/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://app.analystprep.dev/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1184);
	module.exports = __webpack_require__(547);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(115);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(905);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	// lms-qfix BE env (k8s-review.yaml) expects this client id; the CI variable
	// REACT_APP_GOOGLE_OAUTH_CLIENT_ID is not set for that pipeline, so without an
	// env-specific override the FE bundle would ship with the old hardcoded
	// fallback below and every Google login would fail with an audience mismatch.
	// Scoped to qfix only — prod keeps the historical fallback path untouched.
	var DEV_GOOGLE_AUTH_CLIENT_ID = '904037670852-k13pdd6sphomk2gv3917q5vufht9ivcs.apps.googleusercontent.com';
	var DEFAULT_GOOGLE_AUTH_CLIENT_ID = '104176560344-vjgtqbi1ga22rf4646q2pvrj73okfagb.apps.googleusercontent.com';
	
	var App_data = function (_React$Component) {
	  _inherits(App_data, _React$Component);
	
	  function App_data(props) {
	    _classCallCheck(this, App_data);
	
	    var _this = _possibleConstructorReturn(this, (App_data.__proto__ || Object.getPrototypeOf(App_data)).call(this, props));
	
	    _this.backend_api = ("https://api.app.analystprep.dev/api");
	    _this.frontend_url = ("https://app.analystprep.dev");
	    _this.baseURL = ("https://api.app.analystprep.dev/avatars/");
	    _this.stripe_key = ("pk_test_GPG6XQjma3eXn5T4F7CFJFAs");
	    _this.googleAuthClientID = ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}).REACT_APP_GOOGLE_OAUTH_CLIENT_ID || (_CommonUtils.isDev ? DEV_GOOGLE_AUTH_CLIENT_ID : DEFAULT_GOOGLE_AUTH_CLIENT_ID);
	    return _this;
	  }
	
	  return App_data;
	}(_react2.default.Component);
	
	exports.default = new App_data();

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _english = __webpack_require__(1053);
	
	var ENGLISH = _interopRequireWildcard(_english);
	
	var _chinese = __webpack_require__(1052);
	
	var CHINESE = _interopRequireWildcard(_chinese);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/* eslint-disable*/
	var LC = function LC(props) {
	  var selectedLanguage = localStorage.getItem('selectedLanguage');
	  // console.log('selectedLanguageselectedLanguage')
	  // console.log(selectedLanguage)
	  // console.log(localStorage.getItem("domainName"))
	  // console.log(localStorage.getItem("domainApp"))
	  if (selectedLanguage === 'null' || selectedLanguage === undefined || selectedLanguage === null || selectedLanguage === '') {
	    // console.log("DONT HAVE ANY LANGUAGE");
	    var domainName = localStorage.getItem('domainName');
	    var domainApp = localStorage.getItem('domainApp');
	    if (domainApp === 'WORLD') {
	      //console.log("WORLD WORKING");
	      return ENGLISH;
	    } else {
	      //console.log("CHINA WORKING");
	      return CHINESE;
	    }
	  } else {
	    // console.log("HAVE SELECTED LANGUAGE");
	    var language_selected = localStorage.getItem('selectedLanguage');
	    // console.log(localStorage.getItem("selectedLanguage"));
	    switch (language_selected) {
	      case 'EN':
	        //console.log("ENGLISH WORKING");
	        return ENGLISH;
	      case 'CH':
	        //console.log("CHINESE WORKING");
	        return CHINESE;
	      default:
	        null;
	        break;
	    }
	  }
	};
	
	exports.LC = LC;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _isomorphicFetch = __webpack_require__(199);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _toast = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// * snip
	//* I have resolved token issue and also performing the testing all component
	//* that's why i am not optimize this component but for now added in todo list
	var apiPostCall = function sendRequest(url, data, done) {
	  var _this = this;
	
	  var headers = { 'Content-Type': 'application/json' };
	  var storageSession = JSON.parse(localStorage.getItem('localstorageval'));
	  //find out who calls
	  // console.trace("apiPostCall::trace ", url);
	  var payload = {};
	  if (storageSession) {
	    var _storageSession$idnam = storageSession.idname,
	        idname = _storageSession$idnam === undefined ? '' : _storageSession$idnam,
	        _storageSession$token = storageSession.token,
	        token = _storageSession$token === undefined ? '' : _storageSession$token;
	
	    payload = {
	      token: token || '',
	      idname: idname || '',
	      id_name: idname || ''
	    };
	  }
	  return (0, _isomorphicFetch2.default)(url, {
	    method: 'POST',
	    //mode: 'CORS',
	    body: JSON.stringify(Object.assign({}, data, payload)),
	    headers: headers
	  }).then(function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	      var data, err;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // Try to parse JSON regardless of HTTP status. The backend's global
	              // errorHandler always returns JSON ({success:false, message:...}) for
	              // structured errors (NotFoundError, BadRequestError, etc.), and we want
	              // callers to receive that body so their existing `if (resp.success)` /
	              // `else` branches can stop loaders and surface the error message —
	              // throwing here leaves callers with unhandled rejections (infinite
	              // spinners, no modal). Only throw when the body is genuinely non-JSON
	              // (nodemon restart, proxy 502 HTML, etc.) so legacy logout-on-throw
	              // behavior is preserved for that case.
	              data = void 0;
	              _context.prev = 1;
	              _context.next = 4;
	              return resp.json();
	
	            case 4:
	              data = _context.sent;
	              _context.next = 12;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](1);
	              err = new Error('HTTP ' + resp.status);
	
	              err.status = resp.status;
	              throw err;
	
	            case 12:
	              if (resp.ok) {
	                _context.next = 15;
	                break;
	              }
	
	              if (resp.status !== 401 && resp.status !== 403 && data && data.message) {
	                (0, _toast.showFailure)(data.message);
	              }
	              return _context.abrupt('return', Object.assign({ success: false }, data || {}, { httpStatus: resp.status }));
	
	            case 15:
	              return _context.abrupt('return', data);
	
	            case 16:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1, 7]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }()).then(function (data) {
	    var msg = (data && data.message ? String(data.message) : '').toLowerCase();
	    if (data && data.success === false && msg.includes('token') && msg.includes('invalid')) {
	      localStorage.removeItem('localstorageval');
	      (0, _toast.showFailure)('Token has been expired');
	      _reactRouter.browserHistory.push('/');
	    }
	    // Only force logout on getProfileInfo when the server explicitly tells us
	    // the token is invalid. Generic success:false responses (or transient
	    // errors) must not kick the user out.
	    if (data && data.success === false && url.search('api/user/getProfileInfo') !== -1 && msg.includes('token')) {
	      localStorage.removeItem('localstorageval');
	      (0, _toast.showFailure)('Token has been expired');
	      _reactRouter.browserHistory.push('/');
	    }
	    return data;
	  });
	};
	
	exports.callAPI = apiPostCall;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var _Mathround=Math.round,_Mathmin=Math.min,_Mathmax=Math.max;(function(d,g){ true?g(exports,__webpack_require__(1),__webpack_require__(88),__webpack_require__(1071),__webpack_require__(1066)):'function'==typeof define&&define.amd?define(['exports','react','react-dom','react-addons-transition-group','react-addons-css-transition-group'],g):g(d.Reactstrap=d.Reactstrap||{},d.React,d.ReactDOM,d.React.addons.TransitionGroup,d.React.addons.CSSTransitionGroup)})(this,function(d,g,m,h,y){'use strict';function v(){throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs')}function N(Qr,ei){return ei={exports:{}},Qr(ei,ei.exports),ei.exports}function C(Qr){var ei={};return ei='top'===Qr||'top center'===Qr?{attachment:'bottom center',targetAttachment:'top center'}:'bottom'===Qr||'bottom center'===Qr?{attachment:'top center',targetAttachment:'bottom center'}:'left'===Qr||'left center'===Qr?{attachment:'middle right',targetAttachment:'middle left'}:'right'===Qr||'right center'===Qr?{attachment:'middle left',targetAttachment:'middle right'}:'top left'===Qr?{attachment:'bottom left',targetAttachment:'top left'}:'top right'===Qr?{attachment:'bottom right',targetAttachment:'top right'}:'bottom left'===Qr?{attachment:'top left',targetAttachment:'bottom left'}:'bottom right'===Qr?{attachment:'top right',targetAttachment:'bottom right'}:'right top'===Qr?{attachment:'top left',targetAttachment:'top right'}:'right bottom'===Qr?{attachment:'bottom left',targetAttachment:'bottom right'}:'left top'===Qr?{attachment:'top right',targetAttachment:'top left'}:'left bottom'===Qr?{attachment:'bottom right',targetAttachment:'bottom left'}:{attachment:'top center',targetAttachment:'bottom center'},ei}function M(){var Qr=document.createElement('div');Qr.style.position='absolute',Qr.style.top='-9999px',Qr.style.width='50px',Qr.style.height='50px',Qr.style.overflow='scroll',document.body.appendChild(Qr);var ei=Qr.offsetWidth-Qr.clientWidth;return document.body.removeChild(Qr),ei}function _(Qr){document.body.style.paddingRight=0<Qr?Qr+'px':null}function O(){return document.body.clientWidth<window.innerWidth}function E(){return parseInt(window.getComputedStyle(document.body,null).getPropertyValue('padding-right')||0,10)}function P(){var Qr=M(),ei=document.querySelectorAll('.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed')[0],ti=ei?parseInt(ei.style.paddingRight||0,10):0;O()&&_(ti+Qr)}function w(Qr,ei){return ei?Qr.split(' ').map(function(ti){return ei[ti]||ti}).join(' '):Qr}function D(Qr,ei,ti){switch(ti.length){case 0:return Qr.call(ei);case 1:return Qr.call(ei,ti[0]);case 2:return Qr.call(ei,ti[0],ti[1]);case 3:return Qr.call(ei,ti[0],ti[1],ti[2]);}return Qr.apply(ei,ti)}function A(Qr,ei){var ti=Qr?Qr.length:0;return!!ti&&-1<R(Qr,ei,0)}function L(Qr,ei,ti){for(var oi=-1,si=Qr?Qr.length:0;++oi<si;)if(ti(ei,Qr[oi]))return!0;return!1}function S(Qr,ei){for(var ti=-1,oi=Qr?Qr.length:0,si=Array(oi);++ti<oi;)si[ti]=ei(Qr[ti],ti,Qr);return si}function z(Qr,ei){for(var ti=-1,oi=ei.length,si=Qr.length;++ti<oi;)Qr[si+ti]=ei[ti];return Qr}function I(Qr,ei,ti,oi){for(var si=Qr.length,ai=ti+(oi?1:-1);oi?ai--:++ai<si;)if(ei(Qr[ai],ai,Qr))return ai;return-1}function R(Qr,ei,ti){if(ei!==ei)return I(Qr,B,ti);for(var oi=ti-1,si=Qr.length;++oi<si;)if(Qr[oi]===ei)return oi;return-1}function B(Qr){return Qr!==Qr}function W(Qr,ei){for(var ti=-1,oi=Array(Qr);++ti<Qr;)oi[ti]=ei(ti);return oi}function U(Qr){return function(ei){return Qr(ei)}}function H(Qr,ei){return Qr.has(ei)}function q(Qr,ei){return null==Qr?void 0:Qr[ei]}function G(Qr){var ei=!1;if(null!=Qr&&'function'!=typeof Qr.toString)try{ei=!!(Qr+'')}catch(ti){}return ei}function F(Qr,ei){return function(ti){return Qr(ei(ti))}}function V(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.clear();++ei<ti;){var oi=Qr[ei];this.set(oi[0],oi[1])}}function J(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.clear();++ei<ti;){var oi=Qr[ei];this.set(oi[0],oi[1])}}function ae(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.clear();++ei<ti;){var oi=Qr[ei];this.set(oi[0],oi[1])}}function pe(Qr){var ei=-1,ti=Qr?Qr.length:0;for(this.__data__=new ae;++ei<ti;)this.add(Qr[ei])}function ge(Qr,ei){var ti=jo(Qr)||ze(Qr)?W(Qr.length,String):[],oi=ti.length;for(var ai in Qr)(ei||bo.call(Qr,ai))&&!(!!oi&&('length'==ai||Pe(ai,oi)))&&ti.push(ai);return ti}function fe(Qr,ei){for(var ti=Qr.length;ti--;)if(Se(Qr[ti][0],ei))return ti;return-1}function me(Qr,ei,ti,oi){var si=-1,ai=A,ni=!0,li=Qr.length,ri=[],ii=ei.length;if(!li)return ri;ti&&(ei=S(ei,U(ti))),oi?(ai=L,ni=!1):ei.length>=Xt&&(ai=H,ni=!1,ei=new pe(ei));outer:for(;++si<li;){var di=Qr[si],pi=ti?ti(di):di;if(di=oi||0!==di?di:0,ni&&pi===pi){for(var ci=ii;ci--;)if(ei[ci]===pi)continue outer;ri.push(di)}else ai(ei,pi,oi)||ri.push(di)}return ri}function he(Qr,ei,ti,oi,si){var ai=-1,ni=Qr.length;for(ti||(ti=Ee),si||(si=[]);++ai<ni;){var li=Qr[ai];0<ei&&ti(li)?1<ei?he(li,ei-1,ti,oi,si):z(si,li):!oi&&(si[si.length]=li)}return si}function be(Qr,ei,ti){var oi=ei(Qr);return jo(Qr)?oi:z(oi,ti(Qr))}function ye(Qr){if(!Ue(Qr)||xe(Qr))return!1;var ei=Be(Qr)||G(Qr)?vo:no;return ei.test(Le(Qr))}function ve(Qr){if(!Ue(Qr))return De(Qr);var ei=je(Qr),ti=[];for(var oi in Qr)('constructor'!=oi||!ei&&bo.call(Qr,oi))&&ti.push(oi);return ti}function Te(Qr,ei){return Qr=Object(Qr),Ne(Qr,ei,function(ti,oi){return oi in Qr})}function Ne(Qr,ei,ti){for(var oi=-1,si=ei.length,ai={};++oi<si;){var ni=ei[oi],li=Qr[ni];ti(li,ni)&&(ai[ni]=li)}return ai}function Ce(Qr){return be(Qr,Ge,xo)}function Me(Qr,ei){var ti=Qr.__data__;return we(ei)?ti['string'==typeof ei?'string':'hash']:ti.map}function Oe(Qr,ei){var ti=q(Qr,ei);return ye(ti)?ti:void 0}function Ee(Qr){return jo(Qr)||ze(Qr)||!!(Mo&&Qr&&Qr[Mo])}function Pe(Qr,ei){return ei=null==ei?Jt:ei,!!ei&&('number'==typeof Qr||lo.test(Qr))&&-1<Qr&&0==Qr%1&&Qr<ei}function we(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return'string'==ei||'number'==ei||'symbol'==ei||'boolean'==ei?'__proto__'!==Qr:null===Qr}function xe(Qr){return!!mo&&mo in Qr}function je(Qr){var ei=Qr&&Qr.constructor,ti='function'==typeof ei&&ei.prototype||go;return Qr===ti}function De(Qr){var ei=[];if(null!=Qr)for(var ti in Object(Qr))ei.push(ti);return ei}function Ae(Qr){if('string'==typeof Qr||qe(Qr))return Qr;var ei=Qr+'';return'0'==ei&&1/Qr==-Zt?'-0':ei}function Le(Qr){if(null!=Qr){try{return ho.call(Qr)}catch(ei){}try{return Qr+''}catch(ei){}}return''}function Se(Qr,ei){return Qr===ei||Qr!==Qr&&ei!==ei}function ze(Qr){return Re(Qr)&&bo.call(Qr,'callee')&&(!ko.call(Qr,'callee')||yo.call(Qr)==Qt)}function Ie(Qr){return null!=Qr&&We(Qr.length)&&!Be(Qr)}function Re(Qr){return He(Qr)&&Ie(Qr)}function Be(Qr){var ei=Ue(Qr)?yo.call(Qr):'';return ei==eo||ei==oo}function We(Qr){return'number'==typeof Qr&&-1<Qr&&0==Qr%1&&Qr<=Jt}function Ue(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)}function He(Qr){return!!Qr&&'object'==('undefined'==typeof Qr?'undefined':et(Qr))}function qe(Qr){return'symbol'==('undefined'==typeof Qr?'undefined':et(Qr))||He(Qr)&&yo.call(Qr)==so}function Ge(Qr){return Ie(Qr)?ge(Qr,!0):ve(Qr)}function Fe(){return[]}function Ye(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)}function $e(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)}function Xe(Qr){return!!Qr&&'object'==('undefined'==typeof Qr?'undefined':et(Qr))}function Ke(Qr){return'symbol'==('undefined'==typeof Qr?'undefined':et(Qr))||Xe(Qr)&&Tn.call(Qr)==un}function Je(Qr,ei){var ti=Qr.className,oi=Qr.cssModule,si=Qr.tabId,ai=Qr.tag,ni=lt(Qr,['className','cssModule','tabId','tag']),li=w(it('tab-pane',ti,{active:si===ei.activeTabId}),oi);return g.createElement(ai,at({},ni,{className:li}))}g='default'in g?g['default']:g,m='default'in m?m['default']:m,h='default'in h?h['default']:h,y='default'in y?y['default']:y;var Qe='undefined'==typeof window?'undefined'==typeof global?'undefined'==typeof self?{}:self:global:window,et='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(Qr){return typeof Qr}:function(Qr){return Qr&&'function'==typeof Symbol&&Qr.constructor===Symbol&&Qr!==Symbol.prototype?'symbol':typeof Qr},tt=function(Qr,ei){if(!(Qr instanceof ei))throw new TypeError('Cannot call a class as a function')},ot=function(){function Qr(ei,ti){for(var si,oi=0;oi<ti.length;oi++)si=ti[oi],si.enumerable=si.enumerable||!1,si.configurable=!0,'value'in si&&(si.writable=!0),Object.defineProperty(ei,si.key,si)}return function(ei,ti,oi){return ti&&Qr(ei.prototype,ti),oi&&Qr(ei,oi),ei}}(),st=function(Qr,ei,ti){return ei in Qr?Object.defineProperty(Qr,ei,{value:ti,enumerable:!0,configurable:!0,writable:!0}):Qr[ei]=ti,Qr},at=Object.assign||function(Qr){for(var ti,ei=1;ei<arguments.length;ei++)for(var oi in ti=arguments[ei],ti)Object.prototype.hasOwnProperty.call(ti,oi)&&(Qr[oi]=ti[oi]);return Qr},nt=function(Qr,ei){if('function'!=typeof ei&&null!==ei)throw new TypeError('Super expression must either be null or a function, not '+typeof ei);Qr.prototype=Object.create(ei&&ei.prototype,{constructor:{value:Qr,enumerable:!1,writable:!0,configurable:!0}}),ei&&(Object.setPrototypeOf?Object.setPrototypeOf(Qr,ei):Qr.__proto__=ei)},lt=function(Qr,ei){var ti={};for(var oi in Qr)0<=ei.indexOf(oi)||Object.prototype.hasOwnProperty.call(Qr,oi)&&(ti[oi]=Qr[oi]);return ti},rt=function(Qr,ei){if(!Qr)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return ei&&('object'==typeof ei||'function'==typeof ei)?ei:Qr},it=N(function(Qr){(function(){'use strict';function ei(){for(var ai,oi=[],si=0;si<arguments.length;si++)if(ai=arguments[si],ai){var ni='undefined'==typeof ai?'undefined':et(ai);if('string'===ni||'number'===ni)oi.push(ai);else if(Array.isArray(ai))oi.push(ei.apply(null,ai));else if('object'===ni)for(var li in ai)ti.call(ai,li)&&ai[li]&&oi.push(li)}return oi.join(' ')}var ti={}.hasOwnProperty;Qr.exports?Qr.exports=ei:window.classNames=ei})()}),dt=['top','bottom','left','right','top left','top center','top right','right top','right middle','right bottom','bottom right','bottom center','bottom left','left top','left middle','left bottom'],pt=g.PropTypes,ct={tag:pt.oneOfType([pt.func,pt.string]),fluid:pt.bool,className:pt.string,cssModule:pt.object},gt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.fluid,ai=ei.tag,ni=lt(ei,['className','cssModule','fluid','tag']),li=w(it(ti,si?'container-fluid':'container'),oi);return g.createElement(ai,at({},ni,{className:li}))};gt.propTypes=ct,gt.defaultProps={tag:'div'};var ft=g.PropTypes,mt={tag:ft.oneOfType([ft.func,ft.string]),noGutters:ft.bool,className:ft.string,cssModule:ft.object},bt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.noGutters,ai=ei.tag,ni=lt(ei,['className','cssModule','noGutters','tag']),li=w(it(ti,si?'no-gutters':null,'row'),oi);return g.createElement(ai,at({},ni,{className:li}))};bt.propTypes=mt,bt.defaultProps={tag:'div'};var yt=function(Qr){var ei='undefined'==typeof Qr?'undefined':et(Qr);return!!Qr&&('object'==ei||'function'==ei)},vt=g.PropTypes,Nt=vt.oneOfType([vt.number,vt.string]),kt=vt.oneOfType([vt.bool,vt.number,vt.string,vt.shape({size:vt.oneOfType([vt.bool,vt.number,vt.string]),push:Nt,pull:Nt,offset:Nt})]),Ct={tag:vt.oneOfType([vt.func,vt.string]),xs:kt,sm:kt,md:kt,lg:kt,xl:kt,className:vt.string,cssModule:vt.object,widths:vt.array},_t=function(ei,ti,oi){if(!0===oi||''===oi)return ei?'col':'col-'+ti;return'auto'===oi?ei?'col-auto':'col-'+ti+'-auto':ei?'col-'+oi:'col-'+ti+'-'+oi},Ot=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.widths,ai=ei.tag,ni=lt(ei,['className','cssModule','widths','tag']),li=[];si.forEach(function(ii,di){var pi=ei[ii];if(di||void 0!==pi||(pi=!0),delete ni[ii],!!pi){var ui,ci=!di;if(yt(pi)){var gi,fi=ci?'-':'-'+ii+'-';ui=_t(ci,ii,pi.size),li.push(w(it((gi={},st(gi,ui,pi.size||''===pi.size),st(gi,'push'+fi+pi.push,pi.push||0===pi.push),st(gi,'pull'+fi+pi.pull,pi.pull||0===pi.pull),st(gi,'offset'+fi+pi.offset,pi.offset||0===pi.offset),gi))),oi)}else ui=_t(ci,ii,pi),li.push(ui)}});var ri=w(it(ti,li),oi);return g.createElement(ai,at({},ni,{className:ri}))};Ot.propTypes=Ct,Ot.defaultProps={tag:'div',widths:['xs','sm','md','lg','xl']};var Et=g.PropTypes,Pt={light:Et.bool,inverse:Et.bool,full:Et.bool,fixed:Et.string,sticky:Et.string,color:Et.string,role:Et.string,tag:Et.oneOfType([Et.func,Et.string]),className:Et.string,cssModule:Et.object,toggleable:Et.oneOfType([Et.bool,Et.string])},xt=function(ei){if(!1===ei)return!1;return!0===ei||'xs'===ei?'navbar-toggleable':'navbar-toggleable-'+ei},jt=function(ei){var ti,oi=ei.toggleable,si=ei.className,ai=ei.cssModule,ni=ei.light,li=ei.inverse,ri=ei.full,ii=ei.fixed,di=ei.sticky,pi=ei.color,ci=ei.tag,ui=lt(ei,['toggleable','className','cssModule','light','inverse','full','fixed','sticky','color','tag']),gi=w(it(si,'navbar',xt(oi),(ti={'navbar-light':ni,'navbar-inverse':li},st(ti,'bg-'+pi,pi),st(ti,'navbar-full',ri),st(ti,'fixed-'+ii,ii),st(ti,'sticky-'+di,di),ti)),ai);return g.createElement(ci,at({},ui,{className:gi}))};jt.propTypes=Pt,jt.defaultProps={tag:'nav',role:'navigation',toggleable:!1};var Dt=g.PropTypes,At={tag:Dt.oneOfType([Dt.func,Dt.string]),className:Dt.string,cssModule:Dt.object},St=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'navbar-brand'),oi);return g.createElement(si,at({},ai,{className:ni}))};St.propTypes=At,St.defaultProps={tag:'a'};var zt=g.PropTypes,It={tag:zt.oneOfType([zt.func,zt.string]),type:zt.string,className:zt.string,cssModule:zt.object,children:zt.node,right:zt.bool,left:zt.bool},Bt=g.createElement('span',{className:'navbar-toggler-icon'}),Wt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.children,ai=ei.right,ni=ei.left,li=ei.tag,ri=lt(ei,['className','cssModule','children','right','left','tag']),ii=w(it(ti,'navbar-toggler',ai&&'navbar-toggler-right',ni&&'navbar-toggler-left'),oi);return g.createElement(li,at({},ri,{className:ii}),si||Bt)};Wt.propTypes=It,Wt.defaultProps={tag:'button',type:'button'};var Ut=g.PropTypes,Ht={tabs:Ut.bool,pills:Ut.bool,vertical:Ut.bool,navbar:Ut.bool,tag:Ut.oneOfType([Ut.func,Ut.string]),className:Ut.string,cssModule:Ut.object},Gt=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tabs,ai=ei.pills,ni=ei.vertical,li=ei.navbar,ri=ei.tag,ii=lt(ei,['className','cssModule','tabs','pills','vertical','navbar','tag']),di=w(it(ti,li?'navbar-nav':'nav',{'nav-tabs':si,'nav-pills':ai,'flex-column':ni}),oi);return g.createElement(ri,at({},ii,{className:di}))};Gt.propTypes=Ht,Gt.defaultProps={tag:'ul'};var Ft=g.PropTypes,Vt={tag:Ft.oneOfType([Ft.func,Ft.string]),className:Ft.string,cssModule:Ft.object},$t=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'nav-item'),oi);return g.createElement(si,at({},ai,{className:ni}))};$t.propTypes=Vt,$t.defaultProps={tag:'li'};var Xt=200,Kt='__lodash_hash_undefined__',Zt=1/0,Jt=9007199254740991,Qt='[object Arguments]',eo='[object Function]',oo='[object GeneratorFunction]',so='[object Symbol]',ao=/[\\^$.*+?()[\]{}|]/g,no=/^\[object .+?Constructor\]$/,lo=/^(?:0|[1-9]\d*)$/,ro='object'==et(Qe)&&Qe&&Qe.Object===Object&&Qe,io='object'==('undefined'==typeof self?'undefined':et(self))&&self&&self.Object===Object&&self,po=ro||io||Function('return this')(),co=Array.prototype,uo=Function.prototype,go=Object.prototype,fo=po['__core-js_shared__'],mo=function(){var Qr=/[^.]+$/.exec(fo&&fo.keys&&fo.keys.IE_PROTO||'');return Qr?'Symbol(src)_1.'+Qr:''}(),ho=uo.toString,bo=go.hasOwnProperty,yo=go.toString,vo=RegExp('^'+ho.call(bo).replace(ao,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$'),To=po.Symbol,No=F(Object.getPrototypeOf,Object),ko=go.propertyIsEnumerable,Co=co.splice,Mo=To?To.isConcatSpreadable:void 0,_o=Object.getOwnPropertySymbols,Oo=_Mathmax,Eo=Oe(po,'Map'),Po=Oe(Object,'create');V.prototype.clear=function(){this.__data__=Po?Po(null):{}},V.prototype['delete']=function(Qr){return this.has(Qr)&&delete this.__data__[Qr]},V.prototype.get=function(Qr){var ei=this.__data__;if(Po){var ti=ei[Qr];return ti===Kt?void 0:ti}return bo.call(ei,Qr)?ei[Qr]:void 0},V.prototype.has=function(Qr){var ei=this.__data__;return Po?ei[Qr]!==void 0:bo.call(ei,Qr)},V.prototype.set=function(Qr,ei){var ti=this.__data__;return ti[Qr]=Po&&void 0===ei?Kt:ei,this},J.prototype.clear=function(){this.__data__=[]},J.prototype['delete']=function(Qr){var ei=this.__data__,ti=fe(ei,Qr);if(0>ti)return!1;var oi=ei.length-1;return ti==oi?ei.pop():Co.call(ei,ti,1),!0},J.prototype.get=function(Qr){var ei=this.__data__,ti=fe(ei,Qr);return 0>ti?void 0:ei[ti][1]},J.prototype.has=function(Qr){return-1<fe(this.__data__,Qr)},J.prototype.set=function(Qr,ei){var ti=this.__data__,oi=fe(ti,Qr);return 0>oi?ti.push([Qr,ei]):ti[oi][1]=ei,this},ae.prototype.clear=function(){this.__data__={hash:new V,map:new(Eo||J),string:new V}},ae.prototype['delete']=function(Qr){return Me(this,Qr)['delete'](Qr)},ae.prototype.get=function(Qr){return Me(this,Qr).get(Qr)},ae.prototype.has=function(Qr){return Me(this,Qr).has(Qr)},ae.prototype.set=function(Qr,ei){return Me(this,Qr).set(Qr,ei),this},pe.prototype.add=pe.prototype.push=function(Qr){return this.__data__.set(Qr,Kt),this},pe.prototype.has=function(Qr){return this.__data__.has(Qr)};var wo=_o?F(_o,Object):Fe,xo=_o?function(Qr){for(var ei=[];Qr;)z(ei,wo(Qr)),Qr=No(Qr);return ei}:Fe,jo=Array.isArray,Do=function(Qr,ei){return ei=Oo(void 0===ei?Qr.length-1:ei,0),function(){for(var ti=arguments,oi=-1,si=Oo(ti.length-ei,0),ai=Array(si);++oi<si;)ai[oi]=ti[ei+oi];oi=-1;for(var ni=Array(ei+1);++oi<ei;)ni[oi]=ti[oi];return ni[ei]=ai,D(Qr,this,ni)}}(function(Qr,ei){return null==Qr?{}:(ei=S(he(ei,1),Ae),Te(Qr,me(Ce(Qr),ei)))}),Ao=Do,zo=Object.prototype,Io=zo.toString,Ro=function(Qr){var ei=Ye(Qr)?Io.call(Qr):'';return ei=='[object Function]'||ei=='[object GeneratorFunction]'},Bo=N(function(Qr){(function(ti){Qr.exports=ti()})(function(){return function ai(ni,li,ri){function ii(ci,ui){if(!li[ci]){if(!ni[ci]){var gi='function'==typeof v&&v;if(!ui&&gi)return gi(ci,!0);if(di)return di(ci,!0);var fi=new Error('Cannot find module \''+ci+'\'');throw fi.code='MODULE_NOT_FOUND',fi}var mi=li[ci]={exports:{}};ni[ci][0].call(mi.exports,function(hi){var bi=ni[ci][1][hi];return ii(bi?bi:hi)},mi,mi.exports,ai,ni,li,ri)}return li[ci].exports}for(var di='function'==typeof v&&v,pi=0;pi<ri.length;pi++)ii(ri[pi]);return ii}({1:[function(ai){'use strict';var ii=ai('./utils'),di=function(fi){return fi&&fi.__esModule?fi:{'default':fi}}(ii),pi=di['default'].Utils,ci=pi.getBounds,ui=pi.updateClasses,gi=pi.defer;di['default'].modules.push({position:function(mi){var hi=this,bi=mi.top,yi=mi.left,vi=this.cache('element-bounds',function(){return ci(hi.element)}),Ti=vi.height,Ni=vi.width,ki=this.getTargetBounds(),Ci=bi+Ti,Mi=yi+Ni,Oi=[];bi<=ki.bottom&&Ci>=ki.top&&['left','right'].forEach(function(xi){var ji=ki[xi];(ji===yi||ji===Mi)&&Oi.push(xi)}),yi<=ki.right&&Mi>=ki.left&&['top','bottom'].forEach(function(xi){var ji=ki[xi];(ji===bi||ji===Ci)&&Oi.push(xi)});var Ei=[],Pi=[];return Ei.push(this.getClass('abutted')),['left','top','right','bottom'].forEach(function(xi){Ei.push(hi.getClass('abutted')+'-'+xi)}),Oi.length&&Pi.push(this.getClass('abutted')),Oi.forEach(function(xi){Pi.push(hi.getClass('abutted')+'-'+xi)}),gi(function(){!1===hi.options.addTargetClasses||ui(hi.target,Pi,Ei),ui(hi.element,Pi,Ei)}),!0}})},{'./utils':5}],2:[function(ai){'use strict';function ii(yi,vi){return'scrollParent'===vi?vi=yi.scrollParents[0]:'window'===vi&&(vi=[pageXOffset,pageYOffset,innerWidth+pageXOffset,innerHeight+pageYOffset]),vi===document&&(vi=vi.documentElement),'undefined'!=typeof vi.nodeType&&function(){var Ti=vi,Ni=gi(vi),ki=Ni,Ci=getComputedStyle(vi);if(vi=[ki.left,ki.top,Ni.width+ki.left,Ni.height+ki.top],Ti.ownerDocument!==document){var Mi=Ti.ownerDocument.defaultView;vi[0]+=Mi.pageXOffset,vi[1]+=Mi.pageYOffset,vi[2]+=Mi.pageXOffset,vi[3]+=Mi.pageYOffset}bi.forEach(function(Oi,Ei){Oi=Oi[0].toUpperCase()+Oi.substr(1),'Top'===Oi||'Left'===Oi?vi[Ei]+=parseFloat(Ci['border'+Oi+'Width']):vi[Ei]-=parseFloat(Ci['border'+Oi+'Width'])})}(),vi}var di=function(){function yi(vi,Ti){var Ni=[],ki=!0,Ci=!1,Mi;try{for(var Ei,Oi=vi[Symbol.iterator]();!(ki=(Ei=Oi.next()).done)&&(Ni.push(Ei.value),!(Ti&&Ni.length===Ti));ki=!0);}catch(Pi){Ci=!0,Mi=Pi}finally{try{!ki&&Oi['return']&&Oi['return']()}finally{if(Ci)throw Mi}}return Ni}return function(vi,Ti){if(Array.isArray(vi))return vi;if(Symbol.iterator in Object(vi))return yi(vi,Ti);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),pi=ai('./utils'),ci=function(yi){return yi&&yi.__esModule?yi:{'default':yi}}(pi),ui=ci['default'].Utils,gi=ui.getBounds,fi=ui.extend,mi=ui.updateClasses,hi=ui.defer,bi=['left','top','right','bottom'];ci['default'].modules.push({position:function(vi){var Ti=this,Ni=vi.top,ki=vi.left,Ci=vi.targetAttachment;if(!this.options.constraints)return!0;var Mi=this.cache('element-bounds',function(){return gi(Ti.element)}),Oi=Mi.height,Ei=Mi.width;if(0===Ei&&0===Oi&&'undefined'!=typeof this.lastSize){var Pi=this.lastSize;Ei=Pi.width,Oi=Pi.height}var wi=this.cache('target-bounds',function(){return Ti.getTargetBounds()}),xi=wi.height,ji=wi.width,Di=[this.getClass('pinned'),this.getClass('out-of-bounds')];this.options.constraints.forEach(function(zi){var Ii=zi.outOfBoundsClass,Ri=zi.pinnedClass;Ii&&Di.push(Ii),Ri&&Di.push(Ri)}),Di.forEach(function(zi){['left','top','right','bottom'].forEach(function(Ii){Di.push(zi+'-'+Ii)})});var Ai=[],Li=fi({},Ci),Si=fi({},this.attachment);return this.options.constraints.forEach(function(zi){var Ii=zi.to,Ri=zi.attachment,Bi=zi.pin;'undefined'==typeof Ri&&(Ri='');var Wi,Ui;if(0<=Ri.indexOf(' ')){var Hi=Ri.split(' '),qi=di(Hi,2);Ui=qi[0],Wi=qi[1]}else Wi=Ui=Ri;var Gi=ii(Ti,Ii);('target'===Ui||'both'===Ui)&&(Ni<Gi[1]&&'top'===Li.top&&(Ni+=xi,Li.top='bottom'),Ni+Oi>Gi[3]&&'bottom'===Li.top&&(Ni-=xi,Li.top='top')),'together'===Ui&&('top'===Li.top&&('bottom'===Si.top&&Ni<Gi[1]?(Ni+=xi,Li.top='bottom',Ni+=Oi,Si.top='top'):'top'===Si.top&&Ni+Oi>Gi[3]&&Ni-(Oi-xi)>=Gi[1]&&(Ni-=Oi-xi,Li.top='bottom',Si.top='bottom')),'bottom'===Li.top&&('top'===Si.top&&Ni+Oi>Gi[3]?(Ni-=xi,Li.top='top',Ni-=Oi,Si.top='bottom'):'bottom'===Si.top&&Ni<Gi[1]&&Ni+(2*Oi-xi)<=Gi[3]&&(Ni+=Oi-xi,Li.top='top',Si.top='top')),'middle'===Li.top&&(Ni+Oi>Gi[3]&&'top'===Si.top?(Ni-=Oi,Si.top='bottom'):Ni<Gi[1]&&'bottom'===Si.top&&(Ni+=Oi,Si.top='top'))),('target'===Wi||'both'===Wi)&&(ki<Gi[0]&&'left'===Li.left&&(ki+=ji,Li.left='right'),ki+Ei>Gi[2]&&'right'===Li.left&&(ki-=ji,Li.left='left')),'together'===Wi&&(ki<Gi[0]&&'left'===Li.left?'right'===Si.left?(ki+=ji,Li.left='right',ki+=Ei,Si.left='left'):'left'===Si.left&&(ki+=ji,Li.left='right',ki-=Ei,Si.left='right'):ki+Ei>Gi[2]&&'right'===Li.left?'left'===Si.left?(ki-=ji,Li.left='left',ki-=Ei,Si.left='right'):'right'===Si.left&&(ki-=ji,Li.left='left',ki+=Ei,Si.left='left'):'center'===Li.left&&(ki+Ei>Gi[2]&&'left'===Si.left?(ki-=Ei,Si.left='right'):ki<Gi[0]&&'right'===Si.left&&(ki+=Ei,Si.left='left'))),('element'===Ui||'both'===Ui)&&(Ni<Gi[1]&&'bottom'===Si.top&&(Ni+=Oi,Si.top='top'),Ni+Oi>Gi[3]&&'top'===Si.top&&(Ni-=Oi,Si.top='bottom')),('element'===Wi||'both'===Wi)&&(ki<Gi[0]&&('right'===Si.left?(ki+=Ei,Si.left='left'):'center'===Si.left&&(ki+=Ei/2,Si.left='left')),ki+Ei>Gi[2]&&('left'===Si.left?(ki-=Ei,Si.left='right'):'center'===Si.left&&(ki-=Ei/2,Si.left='right'))),'string'==typeof Bi?Bi=Bi.split(',').map(function(Yi){return Yi.trim()}):!0===Bi&&(Bi=['top','left','right','bottom']),Bi=Bi||[];var Fi=[],Vi=[];Ni<Gi[1]&&(0<=Bi.indexOf('top')?(Ni=Gi[1],Fi.push('top')):Vi.push('top')),Ni+Oi>Gi[3]&&(0<=Bi.indexOf('bottom')?(Ni=Gi[3]-Oi,Fi.push('bottom')):Vi.push('bottom')),ki<Gi[0]&&(0<=Bi.indexOf('left')?(ki=Gi[0],Fi.push('left')):Vi.push('left')),ki+Ei>Gi[2]&&(0<=Bi.indexOf('right')?(ki=Gi[2]-Ei,Fi.push('right')):Vi.push('right')),Fi.length&&function(){var Yi;Yi='undefined'==typeof Ti.options.pinnedClass?Ti.getClass('pinned'):Ti.options.pinnedClass,Ai.push(Yi),Fi.forEach(function($i){Ai.push(Yi+'-'+$i)})}(),Vi.length&&function(){var Yi;Yi='undefined'==typeof Ti.options.outOfBoundsClass?Ti.getClass('out-of-bounds'):Ti.options.outOfBoundsClass,Ai.push(Yi),Vi.forEach(function($i){Ai.push(Yi+'-'+$i)})}(),(0<=Fi.indexOf('left')||0<=Fi.indexOf('right'))&&(Si.left=Li.left=!1),(0<=Fi.indexOf('top')||0<=Fi.indexOf('bottom'))&&(Si.top=Li.top=!1),(Li.top!==Ci.top||Li.left!==Ci.left||Si.top!==Ti.attachment.top||Si.left!==Ti.attachment.left)&&(Ti.updateAttachClasses(Si,Li),Ti.trigger('update',{attachment:Si,targetAttachment:Li}))}),hi(function(){!1===Ti.options.addTargetClasses||mi(Ti.target,Ai,Di),mi(Ti.element,Ai,Di)}),{top:Ni,left:ki}}})},{'./utils':5}],3:[function(ai){'use strict';var ii=function(){function ci(ui,gi){var fi=[],mi=!0,hi=!1,bi;try{for(var vi,yi=ui[Symbol.iterator]();!(mi=(vi=yi.next()).done)&&(fi.push(vi.value),!(gi&&fi.length===gi));mi=!0);}catch(Ti){hi=!0,bi=Ti}finally{try{!mi&&yi['return']&&yi['return']()}finally{if(hi)throw bi}}return fi}return function(ui,gi){if(Array.isArray(ui))return ui;if(Symbol.iterator in Object(ui))return ci(ui,gi);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),di=ai('./utils'),pi=function(ci){return ci&&ci.__esModule?ci:{'default':ci}}(di);pi['default'].modules.push({position:function(ui){var gi=ui.top,fi=ui.left;if(this.options.shift){var mi=this.options.shift;'function'==typeof this.options.shift&&(mi=this.options.shift.call(this,{top:gi,left:fi}));var hi,bi;if('string'==typeof mi){mi=mi.split(' '),mi[1]=mi[1]||mi[0];var yi=mi,vi=ii(yi,2);hi=vi[0],bi=vi[1],hi=parseFloat(hi,10),bi=parseFloat(bi,10)}else hi=mi.top,bi=mi.left;return gi+=hi,fi+=bi,{top:gi,left:fi}}}})},{'./utils':5}],4:[function(ai,ni,li){'use strict';function ii(Fi,Vi){if(!(Fi instanceof Vi))throw new TypeError('Cannot call a class as a function')}function di(Fi,Vi){if('function'!=typeof Vi&&null!==Vi)throw new TypeError('Super expression must either be null or a function, not '+('undefined'==typeof Vi?'undefined':et(Vi)));Fi.prototype=Object.create(Vi&&Vi.prototype,{constructor:{value:Fi,enumerable:!1,writable:!0,configurable:!0}}),Vi&&(Object.setPrototypeOf?Object.setPrototypeOf(Fi,Vi):Fi.__proto__=Vi)}function pi(Fi,Vi){var Yi=2>=arguments.length||arguments[2]===void 0?1:arguments[2];return Fi+Yi>=Vi&&Vi>=Fi-Yi}function ci(){return'undefined'!=typeof performance&&'undefined'!=typeof performance.now?performance.now():+new Date}function ui(){for(var Fi={top:0,left:0},Vi=arguments.length,Yi=Array(Vi),$i=0;$i<Vi;$i++)Yi[$i]=arguments[$i];return Yi.forEach(function(Xi){var Ki=Xi.top,Zi=Xi.left;'string'==typeof Ki&&(Ki=parseFloat(Ki,10)),'string'==typeof Zi&&(Zi=parseFloat(Zi,10)),Fi.top+=Ki,Fi.left+=Zi}),Fi}function gi(Fi,Vi){return'string'==typeof Fi.left&&-1!==Fi.left.indexOf('%')&&(Fi.left=parseFloat(Fi.left,10)/100*Vi.width),'string'==typeof Fi.top&&-1!==Fi.top.indexOf('%')&&(Fi.top=parseFloat(Fi.top,10)/100*Vi.height),Fi}Object.defineProperty(li,'__esModule',{value:!0});var fi=function(){function Fi(Vi,Yi){var $i=[],Xi=!0,Ki=!1,Zi;try{for(var Qi,Ji=Vi[Symbol.iterator]();!(Xi=(Qi=Ji.next()).done)&&($i.push(Qi.value),!(Yi&&$i.length===Yi));Xi=!0);}catch(ed){Ki=!0,Zi=ed}finally{try{!Xi&&Ji['return']&&Ji['return']()}finally{if(Ki)throw Zi}}return $i}return function(Vi,Yi){if(Array.isArray(Vi))return Vi;if(Symbol.iterator in Object(Vi))return Fi(Vi,Yi);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),mi=function(){function Fi(Vi,Yi){for(var Xi,$i=0;$i<Yi.length;$i++)Xi=Yi[$i],Xi.enumerable=Xi.enumerable||!1,Xi.configurable=!0,'value'in Xi&&(Xi.writable=!0),Object.defineProperty(Vi,Xi.key,Xi)}return function(Vi,Yi,$i){return Yi&&Fi(Vi.prototype,Yi),$i&&Fi(Vi,$i),Vi}}(),hi=function(Vi,Yi,$i){var Xi=!0;_function:for(;Xi;){var Ki=Vi,Zi=Yi,Ji=$i;Xi=!1,null===Ki&&(Ki=Function.prototype);var Qi=Object.getOwnPropertyDescriptor(Ki,Zi);if(Qi===void 0){var ed=Object.getPrototypeOf(Ki);if(null===ed)return;Vi=ed,Yi=Zi,$i=Ji,Xi=!0,Qi=ed=void 0;continue _function}else{if('value'in Qi)return Qi.value;var td=Qi.get;return void 0===td?void 0:td.call(Ji)}}},bi=ai('./utils'),yi=function(Fi){return Fi&&Fi.__esModule?Fi:{'default':Fi}}(bi);ai('./constraint'),ai('./abutment'),ai('./shift');var vi=yi['default'].Utils,Ti=vi.getScrollParents,Ni=vi.getBounds,ki=vi.getOffsetParent,Ci=vi.extend,Mi=vi.addClass,Oi=vi.removeClass,Ei=vi.updateClasses,Pi=vi.defer,wi=vi.flush,xi=vi.getScrollBarSize,ji=vi.removeUtilElements,Di=vi.Evented,Ai=function(){if('undefined'==typeof document)return'';for(var $i,Fi=document.createElement('div'),Vi=['transform','WebkitTransform','OTransform','MozTransform','msTransform'],Yi=0;Yi<Vi.length;++Yi)if($i=Vi[Yi],void 0!==Fi.style[$i])return $i}(),Li=[],Si=function(){Li.forEach(function(Vi){Vi.position(!1)}),wi()};(function(){var Fi=null,Vi=null,Yi=null,$i=function Xi(){return'undefined'!=typeof Vi&&16<Vi?(Vi=_Mathmin(Vi-16,250),void(Yi=setTimeout(Xi,250))):void('undefined'!=typeof Fi&&10>ci()-Fi||(null!=Yi&&(clearTimeout(Yi),Yi=null),Fi=ci(),Si(),Vi=ci()-Fi))};'undefined'!=typeof window&&'undefined'!=typeof window.addEventListener&&['resize','scroll','touchmove'].forEach(function(Xi){window.addEventListener(Xi,$i)})})();var zi={center:'center',left:'right',right:'left'},Ii={middle:'middle',top:'bottom',bottom:'top'},Ri={top:0,left:0,middle:'50%',center:'50%',bottom:'100%',right:'100%'},Bi=function(Vi,Yi){var $i=Vi.left,Xi=Vi.top;return'auto'===$i&&($i=zi[Yi.left]),'auto'===Xi&&(Xi=Ii[Yi.top]),{left:$i,top:Xi}},Wi=function(Vi){var Yi=Vi.left,$i=Vi.top;return'undefined'!=typeof Ri[Vi.left]&&(Yi=Ri[Vi.left]),'undefined'!=typeof Ri[Vi.top]&&($i=Ri[Vi.top]),{left:Yi,top:$i}},Ui=function(Vi){var Yi=Vi.split(' '),$i=fi(Yi,2),Xi=$i[0],Ki=$i[1];return{top:Xi,left:Ki}},Hi=Ui,qi=function(Fi){function Vi(Yi){var $i=this;ii(this,Vi),hi(Object.getPrototypeOf(Vi.prototype),'constructor',this).call(this),this.position=this.position.bind(this),Li.push(this),this.history=[],this.setOptions(Yi,!1),yi['default'].modules.forEach(function(Xi){'undefined'!=typeof Xi.initialize&&Xi.initialize.call($i)}),this.position()}return di(Vi,Fi),mi(Vi,[{key:'getClass',value:function(){var $i=0>=arguments.length||void 0===arguments[0]?'':arguments[0],Xi=this.options.classes;return'undefined'!=typeof Xi&&Xi[$i]?this.options.classes[$i]:this.options.classPrefix?this.options.classPrefix+'-'+$i:$i}},{key:'setOptions',value:function($i){var Xi=this,Ki=1>=arguments.length||void 0===arguments[1]||arguments[1];this.options=Ci({offset:'0 0',targetOffset:'0 0',targetAttachment:'auto auto',classPrefix:'tether'},$i);var Ji=this.options,Qi=Ji.element,ed=Ji.target,td=Ji.targetModifier;if(this.element=Qi,this.target=ed,this.targetModifier=td,'viewport'===this.target?(this.target=document.body,this.targetModifier='visible'):'scroll-handle'===this.target&&(this.target=document.body,this.targetModifier='scroll-handle'),['element','target'].forEach(function(od){if('undefined'==typeof Xi[od])throw new Error('Tether Error: Both element and target must be defined');'undefined'==typeof Xi[od].jquery?'string'==typeof Xi[od]&&(Xi[od]=document.querySelector(Xi[od])):Xi[od]=Xi[od][0]}),Mi(this.element,this.getClass('element')),!1===this.options.addTargetClasses||Mi(this.target,this.getClass('target')),!this.options.attachment)throw new Error('Tether Error: You must provide an attachment');this.targetAttachment=Hi(this.options.targetAttachment),this.attachment=Hi(this.options.attachment),this.offset=Ui(this.options.offset),this.targetOffset=Ui(this.options.targetOffset),'undefined'!=typeof this.scrollParents&&this.disable(),this.scrollParents='scroll-handle'===this.targetModifier?[this.target]:Ti(this.target),!1===this.options.enabled||this.enable(Ki)}},{key:'getTargetBounds',value:function(){if('undefined'!=typeof this.targetModifier){if('visible'===this.targetModifier){if(this.target===document.body)return{top:pageYOffset,left:pageXOffset,height:innerHeight,width:innerWidth};var $i=Ni(this.target),Xi={height:$i.height,width:$i.width,top:$i.top,left:$i.left};return Xi.height=_Mathmin(Xi.height,$i.height-(pageYOffset-$i.top)),Xi.height=_Mathmin(Xi.height,$i.height-($i.top+$i.height-(pageYOffset+innerHeight))),Xi.height=_Mathmin(innerHeight,Xi.height),Xi.height-=2,Xi.width=_Mathmin(Xi.width,$i.width-(pageXOffset-$i.left)),Xi.width=_Mathmin(Xi.width,$i.width-($i.left+$i.width-(pageXOffset+innerWidth))),Xi.width=_Mathmin(innerWidth,Xi.width),Xi.width-=2,Xi.top<pageYOffset&&(Xi.top=pageYOffset),Xi.left<pageXOffset&&(Xi.left=pageXOffset),Xi}if('scroll-handle'===this.targetModifier){var $i=void 0,Ki=this.target;Ki===document.body?(Ki=document.documentElement,$i={left:pageXOffset,top:pageYOffset,height:innerHeight,width:innerWidth}):$i=Ni(Ki);var Zi=getComputedStyle(Ki),Ji=Ki.scrollWidth>Ki.clientWidth||0<=[Zi.overflow,Zi.overflowX].indexOf('scroll')||this.target!==document.body,Qi=0;Ji&&(Qi=15);var ed=$i.height-parseFloat(Zi.borderTopWidth)-parseFloat(Zi.borderBottomWidth)-Qi,Xi={width:15,height:0.975*ed*(ed/Ki.scrollHeight),left:$i.left+$i.width-parseFloat(Zi.borderLeftWidth)-15},td=0;408>ed&&this.target===document.body&&(td=-1.1e-4*Math.pow(ed,2)-0.00727*ed+22.58),this.target!==document.body&&(Xi.height=_Mathmax(Xi.height,24));var od=this.target.scrollTop/(Ki.scrollHeight-ed);return Xi.top=od*(ed-Xi.height-td)+$i.top+parseFloat(Zi.borderTopWidth),this.target===document.body&&(Xi.height=_Mathmax(Xi.height,24)),Xi}}else return Ni(this.target)}},{key:'clearCache',value:function(){this._cache={}}},{key:'cache',value:function($i,Xi){return'undefined'==typeof this._cache&&(this._cache={}),'undefined'==typeof this._cache[$i]&&(this._cache[$i]=Xi.call(this)),this._cache[$i]}},{key:'enable',value:function(){var $i=this,Xi=0>=arguments.length||void 0===arguments[0]||arguments[0];!1===this.options.addTargetClasses||Mi(this.target,this.getClass('enabled')),Mi(this.element,this.getClass('enabled')),this.enabled=!0,this.scrollParents.forEach(function(Ki){Ki!==$i.target.ownerDocument&&Ki.addEventListener('scroll',$i.position)}),Xi&&this.position()}},{key:'disable',value:function(){var $i=this;Oi(this.target,this.getClass('enabled')),Oi(this.element,this.getClass('enabled')),this.enabled=!1,'undefined'!=typeof this.scrollParents&&this.scrollParents.forEach(function(Xi){Xi.removeEventListener('scroll',$i.position)})}},{key:'destroy',value:function(){var $i=this;this.disable(),Li.forEach(function(Xi,Ki){Xi===$i&&Li.splice(Ki,1)}),0===Li.length&&ji()}},{key:'updateAttachClasses',value:function($i,Xi){var Ki=this;$i=$i||this.attachment,Xi=Xi||this.targetAttachment;'undefined'!=typeof this._addAttachClasses&&this._addAttachClasses.length&&this._addAttachClasses.splice(0,this._addAttachClasses.length),'undefined'==typeof this._addAttachClasses&&(this._addAttachClasses=[]);var Ji=this._addAttachClasses;$i.top&&Ji.push(this.getClass('element-attached')+'-'+$i.top),$i.left&&Ji.push(this.getClass('element-attached')+'-'+$i.left),Xi.top&&Ji.push(this.getClass('target-attached')+'-'+Xi.top),Xi.left&&Ji.push(this.getClass('target-attached')+'-'+Xi.left);var Qi=[];['left','top','bottom','right','middle','center'].forEach(function(ed){Qi.push(Ki.getClass('element-attached')+'-'+ed),Qi.push(Ki.getClass('target-attached')+'-'+ed)}),Pi(function(){'undefined'==typeof Ki._addAttachClasses||(Ei(Ki.element,Ki._addAttachClasses,Qi),!1!==Ki.options.addTargetClasses&&Ei(Ki.target,Ki._addAttachClasses,Qi),delete Ki._addAttachClasses)})}},{key:'position',value:function(){var $i=this,Xi=0>=arguments.length||void 0===arguments[0]||arguments[0];if(this.enabled){this.clearCache();var Ki=Bi(this.targetAttachment,this.attachment);this.updateAttachClasses(this.attachment,Ki);var Zi=this.cache('element-bounds',function(){return Ni($i.element)}),Ji=Zi.width,Qi=Zi.height;if(0===Ji&&0===Qi&&'undefined'!=typeof this.lastSize){var ed=this.lastSize;Ji=ed.width,Qi=ed.height}else this.lastSize={width:Ji,height:Qi};var td=this.cache('target-bounds',function(){return $i.getTargetBounds()}),od=td,sd=gi(Wi(this.attachment),{width:Ji,height:Qi}),ad=gi(Wi(Ki),od),nd=gi(this.offset,{width:Ji,height:Qi}),ld=gi(this.targetOffset,od);sd=ui(sd,nd),ad=ui(ad,ld);for(var rd=td.left+ad.left-sd.left,dd=td.top+ad.top-sd.top,pd=0;pd<yi['default'].modules.length;++pd){var cd=yi['default'].modules[pd],ud=cd.position.call(this,{left:rd,top:dd,targetAttachment:Ki,targetPos:td,elementPos:Zi,offset:sd,targetOffset:ad,manualOffset:nd,manualTargetOffset:ld,scrollbarSize:hd,attachment:this.attachment});if(!1===ud)return!1;if('undefined'==typeof ud||'object'!==('undefined'==typeof ud?'undefined':et(ud)))continue;else dd=ud.top,rd=ud.left}var hd,gd={page:{top:dd,left:rd},viewport:{top:dd-pageYOffset,bottom:pageYOffset-dd-Qi+innerHeight,left:rd-pageXOffset,right:pageXOffset-rd-Ji+innerWidth}},fd=this.target.ownerDocument,md=fd.defaultView;return fd.body.scrollWidth>md.innerWidth&&(hd=this.cache('scrollbar-size',xi),gd.viewport.bottom-=hd.height),fd.body.scrollHeight>md.innerHeight&&(hd=this.cache('scrollbar-size',xi),gd.viewport.right-=hd.width),(-1===['','static'].indexOf(fd.body.style.position)||-1===['','static'].indexOf(fd.body.parentElement.style.position))&&(gd.page.bottom=fd.body.scrollHeight-dd-Qi,gd.page.right=fd.body.scrollWidth-rd-Ji),'undefined'==typeof this.options.optimizations||!1===this.options.optimizations.moveElement||'undefined'!=typeof this.targetModifier||function(){var bd=$i.cache('target-offsetparent',function(){return ki($i.target)}),yd=$i.cache('target-offsetparent-bounds',function(){return Ni(bd)}),vd=getComputedStyle(bd),Td=yd,Nd={};if(['Top','Left','Bottom','Right'].forEach(function(Md){Nd[Md.toLowerCase()]=parseFloat(vd['border'+Md+'Width'])}),yd.right=fd.body.scrollWidth-yd.left-Td.width+Nd.right,yd.bottom=fd.body.scrollHeight-yd.top-Td.height+Nd.bottom,gd.page.top>=yd.top+Nd.top&&gd.page.bottom>=yd.bottom&&gd.page.left>=yd.left+Nd.left&&gd.page.right>=yd.right){var kd=bd.scrollTop,Cd=bd.scrollLeft;gd.offset={top:gd.page.top-yd.top+kd-Nd.top,left:gd.page.left-yd.left+Cd-Nd.left}}}(),this.move(gd),this.history.unshift(gd),3<this.history.length&&this.history.pop(),Xi&&wi(),!0}}},{key:'move',value:function($i){var Xi=this;if('undefined'!=typeof this.element.parentNode){var Ki={};for(var Zi in $i)for(var Ji in Ki[Zi]={},$i[Zi]){for(var td,Qi=!1,ed=0;ed<this.history.length;++ed)if(td=this.history[ed],'undefined'!=typeof td[Zi]&&!pi(td[Zi][Ji],$i[Zi][Ji])){Qi=!0;break}Qi||(Ki[Zi][Ji]=!0)}var od={top:'',left:'',right:'',bottom:''},sd=function(gd,fd){var md='undefined'!=typeof Xi.options.optimizations,hd=md?Xi.options.optimizations.gpu:null;if(!1!==hd){var bd,yd;gd.top?(od.top=0,bd=fd.top):(od.bottom=0,bd=-fd.bottom),gd.left?(od.left=0,yd=fd.left):(od.right=0,yd=-fd.right),od[Ai]='translateX('+_Mathround(yd)+'px) translateY('+_Mathround(bd)+'px)','msTransform'!==Ai&&(od[Ai]+=' translateZ(0)')}else gd.top?od.top=fd.top+'px':od.bottom=fd.bottom+'px',gd.left?od.left=fd.left+'px':od.right=fd.right+'px'},ad=!1;if((Ki.page.top||Ki.page.bottom)&&(Ki.page.left||Ki.page.right)?(od.position='absolute',sd(Ki.page,$i.page)):(Ki.viewport.top||Ki.viewport.bottom)&&(Ki.viewport.left||Ki.viewport.right)?(od.position='fixed',sd(Ki.viewport,$i.viewport)):'undefined'!=typeof Ki.offset&&Ki.offset.top&&Ki.offset.left?function(){od.position='absolute';var ud=Xi.cache('target-offsetparent',function(){return ki(Xi.target)});ki(Xi.element)!==ud&&Pi(function(){Xi.element.parentNode.removeChild(Xi.element),ud.appendChild(Xi.element)}),sd(Ki.offset,$i.offset),ad=!0}():(od.position='absolute',sd({top:!0,left:!0},$i.page)),!ad){for(var nd=!0,ld=this.element.parentNode;ld&&1===ld.nodeType&&'BODY'!==ld.tagName;){if('static'!==getComputedStyle(ld).position){nd=!1;break}ld=ld.parentNode}nd||(this.element.parentNode.removeChild(this.element),this.element.ownerDocument.body.appendChild(this.element))}var rd={},dd=!1;for(var Ji in od){var pd=od[Ji],cd=this.element.style[Ji];cd!==pd&&(dd=!0,rd[Ji]=pd)}dd&&Pi(function(){Ci(Xi.element.style,rd),Xi.trigger('repositioned')})}}}]),Vi}(Di);qi.modules=[],yi['default'].position=Si;var Gi=Ci(qi,yi['default']);li['default']=Gi,ni.exports=li['default']},{'./abutment':1,'./constraint':2,'./shift':3,'./utils':5}],5:[function(ai,ni,li){'use strict';function ri(Di,Ai){if(!(Di instanceof Ai))throw new TypeError('Cannot call a class as a function')}function ii(Di){var Ai=Di.getBoundingClientRect(),Li={};for(var Si in Ai)Li[Si]=Ai[Si];if(Di.ownerDocument!==document){var zi=Di.ownerDocument.defaultView.frameElement;if(zi){var Ii=ii(zi);Li.top+=Ii.top,Li.bottom+=Ii.top,Li.left+=Ii.left,Li.right+=Ii.left}}return Li}function fi(){var Di=0>=arguments.length||void 0===arguments[0]?{}:arguments[0],Ai=[];return Array.prototype.push.apply(Ai,arguments),Ai.slice(1).forEach(function(Li){if(Li)for(var Si in Li)({}).hasOwnProperty.call(Li,Si)&&(Di[Si]=Li[Si])}),Di}function mi(Di,Ai){if('undefined'!=typeof Di.classList)Ai.split(' ').forEach(function(zi){zi.trim()&&Di.classList.remove(zi)});else{var Li=new RegExp('(^| )'+Ai.split(' ').join('|')+'( |$)','gi'),Si=yi(Di).replace(Li,' ');vi(Di,Si)}}function hi(Di,Ai){if('undefined'!=typeof Di.classList)Ai.split(' ').forEach(function(Si){Si.trim()&&Di.classList.add(Si)});else{mi(Di,Ai);var Li=yi(Di)+(' '+Ai);vi(Di,Li)}}function bi(Di,Ai){if('undefined'!=typeof Di.classList)return Di.classList.contains(Ai);var Li=yi(Di);return new RegExp('(^| )'+Ai+'( |$)','gi').test(Li)}function yi(Di){return Di.className instanceof Di.ownerDocument.defaultView.SVGAnimatedString?Di.className.baseVal:Di.className}function vi(Di,Ai){Di.setAttribute('class',Ai)}Object.defineProperty(li,'__esModule',{value:!0});var Ni=function(){function Di(Ai,Li){for(var zi,Si=0;Si<Li.length;Si++)zi=Li[Si],zi.enumerable=zi.enumerable||!1,zi.configurable=!0,'value'in zi&&(zi.writable=!0),Object.defineProperty(Ai,zi.key,zi)}return function(Ai,Li,Si){return Li&&Di(Ai.prototype,Li),Si&&Di(Ai,Si),Ai}}(),ki={modules:[]},Ci=null,Mi=function(){var Di=0;return function(){return++Di}}(),Oi={},Ei=function(){var Ai=Ci;Ai||(Ai=document.createElement('div'),Ai.setAttribute('data-tether-id',Mi()),fi(Ai.style,{top:0,left:0,position:'absolute'}),document.body.appendChild(Ai),Ci=Ai);var Li=Ai.getAttribute('data-tether-id');return'undefined'==typeof Oi[Li]&&(Oi[Li]=ii(Ai),wi(function(){delete Oi[Li]})),Oi[Li]},Pi=[],wi=function(Ai){Pi.push(Ai)},ji=function(){function Di(){ri(this,Di)}return Ni(Di,[{key:'on',value:function(Li,Si,zi){var Ii=3>=arguments.length||void 0===arguments[3]?!1:arguments[3];'undefined'==typeof this.bindings&&(this.bindings={}),'undefined'==typeof this.bindings[Li]&&(this.bindings[Li]=[]),this.bindings[Li].push({handler:Si,ctx:zi,once:Ii})}},{key:'once',value:function(Li,Si,zi){this.on(Li,Si,zi,!0)}},{key:'off',value:function(Li,Si){if('undefined'!=typeof this.bindings&&'undefined'!=typeof this.bindings[Li])if('undefined'==typeof Si)delete this.bindings[Li];else for(var zi=0;zi<this.bindings[Li].length;)this.bindings[Li][zi].handler===Si?this.bindings[Li].splice(zi,1):++zi}},{key:'trigger',value:function(Li){if('undefined'!=typeof this.bindings&&this.bindings[Li]){for(var Si=0,zi=arguments.length,Ii=Array(1<zi?zi-1:0),Ri=1;Ri<zi;Ri++)Ii[Ri-1]=arguments[Ri];for(;Si<this.bindings[Li].length;){var Bi=this.bindings[Li][Si],Wi=Bi.handler,Ui=Bi.ctx,Hi=Bi.once,qi=Ui;'undefined'==typeof qi&&(qi=this),Wi.apply(qi,Ii),Hi?this.bindings[Li].splice(Si,1):++Si}}}}]),Di}();ki.Utils={getActualBoundingClientRect:ii,getScrollParents:function(Di){var Ai=getComputedStyle(Di)||{},Li=Ai.position,Si=[];if('fixed'===Li)return[Di];for(var Ii,zi=Di;(zi=zi.parentNode)&&zi&&1===zi.nodeType;){Ii=void 0;try{Ii=getComputedStyle(zi)}catch(Hi){}if('undefined'==typeof Ii||null===Ii)return Si.push(zi),Si;var Ri=Ii,Bi=Ri.overflow,Wi=Ri.overflowX,Ui=Ri.overflowY;/(auto|scroll)/.test(Bi+Ui+Wi)&&('absolute'!==Li||0<=['relative','absolute','fixed'].indexOf(Ii.position))&&Si.push(zi)}return Si.push(Di.ownerDocument.body),Di.ownerDocument!==document&&Si.push(Di.ownerDocument.defaultView),Si},getBounds:function(Di){var Ai;Di===document?(Ai=document,Di=document.documentElement):Ai=Di.ownerDocument;var Li=Ai.documentElement,Si=ii(Di),zi=Ei();return Si.top-=zi.top,Si.left-=zi.left,'undefined'==typeof Si.width&&(Si.width=document.body.scrollWidth-Si.left-Si.right),'undefined'==typeof Si.height&&(Si.height=document.body.scrollHeight-Si.top-Si.bottom),Si.top-=Li.clientTop,Si.left-=Li.clientLeft,Si.right=Ai.body.clientWidth-Si.width-Si.left,Si.bottom=Ai.body.clientHeight-Si.height-Si.top,Si},getOffsetParent:function(Di){return Di.offsetParent||document.documentElement},extend:fi,addClass:hi,removeClass:mi,hasClass:bi,updateClasses:function(Di,Ai,Li){Li.forEach(function(Si){-1===Ai.indexOf(Si)&&bi(Di,Si)&&mi(Di,Si)}),Ai.forEach(function(Si){bi(Di,Si)||hi(Di,Si)})},defer:wi,flush:function(){for(var Ai;Ai=Pi.pop();)Ai()},uniqueId:Mi,Evented:ji,getScrollBarSize:function(){var Di=document.createElement('div');Di.style.width='100%',Di.style.height='200px';var Ai=document.createElement('div');fi(Ai.style,{position:'absolute',top:0,left:0,pointerEvents:'none',visibility:'hidden',width:'200px',height:'150px',overflow:'hidden'}),Ai.appendChild(Di),document.body.appendChild(Ai);var Li=Di.offsetWidth;Ai.style.overflow='scroll';var Si=Di.offsetWidth;Li===Si&&(Si=Ai.clientWidth),document.body.removeChild(Ai);var zi=Li-Si;return{width:zi,height:zi}},removeUtilElements:function(){Ci&&document.body.removeChild(Ci),Ci=null}},li['default']=ki,ni.exports=li['default']},{}]},{},[4])(4)})}),Wo=function(Qr){return Qr&&Qr.__esModule?Qr['default']:Qr}(Bo),Uo=g.PropTypes,Ho={children:Uo.node.isRequired,className:Uo.string,arrow:Uo.string,disabled:Uo.bool,isOpen:Uo.bool.isRequired,toggle:Uo.func.isRequired,tether:Uo.object.isRequired,tetherRef:Uo.func,style:Uo.node,cssModule:Uo.object},Go=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.handleDocumentClick=oi.handleDocumentClick.bind(oi),oi.toggle=oi.toggle.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'componentDidMount',value:function(){this.handleProps()}},{key:'componentDidUpdate',value:function(oi){this.props.isOpen===oi.isOpen?this._element&&this.renderIntoSubtree():this.handleProps()}},{key:'componentWillUnmount',value:function(){this.hide()}},{key:'getTarget',value:function(){var oi=this.props.tether.target;return Ro(oi)?oi():oi}},{key:'getTetherConfig',value:function(){var oi=at({},this.props.tether);return oi.element=this._element,oi.target=this.getTarget(),oi}},{key:'handleDocumentClick',value:function(oi){var si=this._element;oi.target!==si&&si.contains(oi.target)||this.toggle()}},{key:'handleProps',value:function(){this.props.isOpen?this.show():this.hide()}},{key:'hide',value:function(){document.removeEventListener('click',this.handleDocumentClick,!0),this._element&&(document.body.removeChild(this._element),m.unmountComponentAtNode(this._element),this._element=null),this._tether&&(this._tether.destroy(),this._tether=null,this.props.tetherRef(this._tether))}},{key:'show',value:function(){document.addEventListener('click',this.handleDocumentClick,!0),this._element=document.createElement('div'),this._element.className=this.props.className,document.body.appendChild(this._element),this.renderIntoSubtree(),this._tether=new Wo(this.getTetherConfig()),this.props.tetherRef(this._tether),this._tether.position(),this._element.childNodes[0].focus()}},{key:'toggle',value:function(oi){return this.props.disabled?oi&&oi.preventDefault():this.props.toggle()}},{key:'renderIntoSubtree',value:function(){m.unstable_renderSubtreeIntoContainer(this,this.renderChildren(),this._element)}},{key:'renderChildren',value:function(){var oi=this.props,si=oi.children,ai=oi.style;return g.cloneElement(si,{style:ai})}},{key:'render',value:function(){return null}}]),ei}(g.Component);Go.propTypes=Ho,Go.defaultProps={isOpen:!1,tetherRef:function(){}};var Fo=g.PropTypes,Vo={tag:Fo.oneOfType([Fo.func,Fo.string]),children:Fo.node.isRequired,right:Fo.bool,className:Fo.string,cssModule:Fo.object},$o={isOpen:Fo.bool.isRequired},Xo=function(ei,ti){var oi=ei.className,si=ei.cssModule,ai=ei.right,ni=ei.tag,li=lt(ei,['className','cssModule','right','tag']),ri=w(it(oi,'dropdown-menu',{'dropdown-menu-right':ai}),si);return g.createElement(ni,at({},li,{tabIndex:'-1','aria-hidden':!ti.isOpen,role:'menu',className:ri}))};Xo.propTypes=Vo,Xo.defaultProps={tag:'div'},Xo.contextTypes=$o;var Ko=g.PropTypes,Zo={disabled:Ko.bool,dropup:Ko.bool,group:Ko.bool,isOpen:Ko.bool,size:Ko.string,tag:Ko.string,tether:Ko.oneOfType([Ko.object,Ko.bool]),toggle:Ko.func,children:Ko.node,className:Ko.string,cssModule:Ko.object},Qo={toggle:Ko.func.isRequired,isOpen:Ko.bool.isRequired},es={classPrefix:'bs-tether',classes:{element:'dropdown',enabled:'show'},constraints:[{to:'scrollParent',attachment:'together none'},{to:'window',attachment:'together none'}]},ts=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.addEvents=oi.addEvents.bind(oi),oi.getTetherConfig=oi.getTetherConfig.bind(oi),oi.handleDocumentClick=oi.handleDocumentClick.bind(oi),oi.removeEvents=oi.removeEvents.bind(oi),oi.toggle=oi.toggle.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'getChildContext',value:function(){return{toggle:this.props.toggle,isOpen:this.props.isOpen}}},{key:'componentDidMount',value:function(){this.handleProps()}},{key:'componentDidUpdate',value:function(oi){this.props.isOpen!==oi.isOpen&&this.handleProps()}},{key:'componentWillUnmount',value:function(){this.removeEvents()}},{key:'getTetherTarget',value:function(){var oi=m.findDOMNode(this);return oi.querySelector('[data-toggle="dropdown"]')}},{key:'getTetherConfig',value:function(oi){var si=this,ni='top',li='left',ri='bottom',ii='left';return oi.right&&(li='right',ii='right'),this.props.dropup&&(ni='bottom',ri='top'),at({},es,{attachment:ni+' '+li,targetAttachment:ri+' '+ii,target:function(){return si.getTetherTarget()}},this.props.tether)}},{key:'addEvents',value:function(){document.addEventListener('click',this.handleDocumentClick,!0)}},{key:'removeEvents',value:function(){document.removeEventListener('click',this.handleDocumentClick,!0)}},{key:'handleDocumentClick',value:function(oi){var si=m.findDOMNode(this);si.contains(oi.target)&&si!==oi.target||this.toggle()}},{key:'handleProps',value:function(){this.props.tether||(this.props.isOpen?this.addEvents():this.removeEvents())}},{key:'toggle',value:function(oi){return this.props.disabled?oi&&oi.preventDefault():this.props.toggle()}},{key:'renderChildren',value:function(){var oi=this,si=this.props,ai=si.tether,ni=si.children,li=lt(si,['tether','children']);return li.toggle=this.toggle,g.Children.map(g.Children.toArray(ni),function(ri){if(ai&&ri.type===Xo){var ii=oi.getTetherConfig(ri.props);return g.createElement(Go,at({},li,{tether:ii}),ri)}return ri})}},{key:'render',value:function(){var oi,si=Ao(this.props,['toggle','tether']),ai=si.className,ni=si.cssModule,li=si.dropup,ri=si.group,ii=si.size,di=si.tag,pi=si.isOpen,ci=lt(si,['className','cssModule','dropup','group','size','tag','isOpen']),ui=w(it(ai,(oi={'btn-group':ri},st(oi,'btn-group-'+ii,!!ii),st(oi,'dropdown',!ri),st(oi,'show',pi),st(oi,'dropup',li),oi)),ni);return g.createElement(di,at({},ci,{className:ui}),this.renderChildren())}}]),ei}(g.Component);ts.propTypes=Zo,ts.defaultProps={isOpen:!1,tag:'div'},ts.childContextTypes=Qo;var os=g.PropTypes,ss={children:os.node,tag:os.oneOfType([os.func,os.string]),className:os.string,cssModule:os.object},ns=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'nav-item'),oi);return g.createElement(ts,at({},ai,{tag:si,className:ni}))};ns.propTypes=ss,ns.defaultProps={tag:'li'};var ls=g.PropTypes,rs={tag:ls.oneOfType([ls.func,ls.string]),getRef:ls.oneOfType([ls.func,ls.string]),disabled:ls.bool,active:ls.bool,className:ls.string,cssModule:ls.object,onClick:ls.func,href:ls.any},ds=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled?void oi.preventDefault():void('#'===this.props.href&&oi.preventDefault(),this.props.onClick&&this.props.onClick(oi))}},{key:'render',value:function(){var oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.active,li=oi.tag,ri=oi.getRef,ii=lt(oi,['className','cssModule','active','tag','getRef']),di=w(it(si,'nav-link',{disabled:ii.disabled,active:ni}),ai);return g.createElement(li,at({},ii,{ref:ri,onClick:this.onClick,className:di}))}}]),ei}(g.Component);ds.propTypes=rs,ds.defaultProps={tag:'a'};var ps=g.PropTypes,cs={tag:ps.string,className:ps.string,cssModule:ps.object},gs=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'breadcrumb'),oi);return g.createElement(si,at({},ai,{className:ni}))};gs.propTypes=cs,gs.defaultProps={tag:'ol'};var fs=g.PropTypes,ms={tag:fs.oneOfType([fs.func,fs.string]),active:fs.bool,className:fs.string,cssModule:fs.object},bs=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.active,ai=ei.tag,ni=lt(ei,['className','cssModule','active','tag']),li=w(it(ti,!!si&&'active','breadcrumb-item'),oi);return g.createElement(ai,at({},ni,{className:li}))};bs.propTypes=ms,bs.defaultProps={tag:'li'};var ys=g.PropTypes,vs={active:ys.bool,block:ys.bool,color:ys.string,disabled:ys.bool,outline:ys.bool,tag:ys.oneOfType([ys.func,ys.string]),getRef:ys.oneOfType([ys.func,ys.string]),onClick:ys.func,size:ys.string,children:ys.node,className:ys.string,cssModule:ys.object},Ns=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled?void oi.preventDefault():void(this.props.onClick&&this.props.onClick(oi))}},{key:'render',value:function(){var oi=this.props,si=oi.active,ai=oi.block,ni=oi.className,li=oi.cssModule,ri=oi.color,ii=oi.outline,di=oi.size,pi=oi.tag,ci=oi.getRef,ui=lt(oi,['active','block','className','cssModule','color','outline','size','tag','getRef']),gi=w(it(ni,'btn','btn'+(ii?'-outline':'')+'-'+ri,!!di&&'btn-'+di,!!ai&&'btn-block',{active:si,disabled:this.props.disabled}),li);return ui.href&&'button'===pi&&(pi='a'),g.createElement(pi,at({type:'button'===pi&&ui.onClick?'button':void 0},ui,{className:gi,ref:ci,onClick:this.onClick}))}}]),ei}(g.Component);Ns.propTypes=vs,Ns.defaultProps={color:'secondary',tag:'button'};var ks=g.PropTypes,Cs={children:ks.node},Ms=function(ei){return g.createElement(ts,at({},ei,{group:!0}))};Ms.propTypes=Cs;var Os=g.PropTypes,Es={tag:Os.oneOfType([Os.func,Os.string]),'aria-label':Os.string,className:Os.string,cssModule:Os.object,role:Os.string,size:Os.string,vertical:Os.bool},ws=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.size,ai=ei.vertical,ni=ei.tag,li=lt(ei,['className','cssModule','size','vertical','tag']),ri=w(it(ti,!!si&&'btn-group-'+si,ai?'btn-group-vertical':'btn-group'),oi);return g.createElement(ni,at({},li,{className:ri}))};ws.propTypes=Es,ws.defaultProps={tag:'div',role:'group'};var xs=g.PropTypes,js={tag:xs.oneOfType([xs.func,xs.string]),'aria-label':xs.string,className:xs.string,cssModule:xs.object,role:xs.string},As=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'btn-toolbar'),oi);return g.createElement(si,at({},ai,{className:ni}))};As.propTypes=js,As.defaultProps={tag:'div',role:'toolbar'};var Ls=g.PropTypes,Ss={children:Ls.node,disabled:Ls.bool,divider:Ls.bool,tag:Ls.oneOfType([Ls.func,Ls.string]),header:Ls.bool,onClick:Ls.func,className:Ls.string,cssModule:Ls.object,toggle:Ls.bool},zs={toggle:Ls.func},Rs=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi.getTabIndex=oi.getTabIndex.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled||this.props.header||this.props.divider?void oi.preventDefault():void(this.props.onClick&&this.props.onClick(oi),this.props.toggle&&this.context.toggle())}},{key:'getTabIndex',value:function(){return this.props.disabled||this.props.header||this.props.divider?'-1':'0'}},{key:'render',value:function(){var oi=this.getTabIndex(),si=Ao(this.props,['toggle']),ai=si.className,ni=si.cssModule,li=si.divider,ri=si.tag,ii=si.header,di=lt(si,['className','cssModule','divider','tag','header']),pi=w(it(ai,{disabled:di.disabled,'dropdown-item':!li&&!ii,'dropdown-header':ii,'dropdown-divider':li}),ni);return'button'===ri&&(ii?ri='h6':li?ri='div':di.href&&(ri='a')),g.createElement(ri,at({type:'button'===ri&&(di.onClick||this.props.toggle)?'button':void 0},di,{tabIndex:oi,className:pi,onClick:this.onClick}))}}]),ei}(g.Component);Rs.propTypes=Ss,Rs.defaultProps={tag:'button',toggle:!0},Rs.contextTypes=zs;var Bs=g.PropTypes,Ws={caret:Bs.bool,children:Bs.node,className:Bs.string,cssModule:Bs.object,disabled:Bs.bool,onClick:Bs.func,'data-toggle':Bs.string,'aria-haspopup':Bs.bool,split:Bs.bool,tag:Bs.oneOfType([Bs.func,Bs.string]),nav:Bs.bool},Hs={isOpen:Bs.bool.isRequired,toggle:Bs.func.isRequired},qs=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.onClick=oi.onClick.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'onClick',value:function(oi){return this.props.disabled?void oi.preventDefault():void(this.props.nav&&!this.props.tag&&oi.preventDefault(),this.props.onClick&&this.props.onClick(oi),this.context.toggle())}},{key:'render',value:function(){var gi,oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.caret,li=oi.split,ri=oi.nav,ii=oi.tag,di=lt(oi,['className','cssModule','caret','split','nav','tag']),pi=di['aria-label']||'Toggle Dropdown',ci=w(it(si,{'dropdown-toggle':ni||li,'dropdown-toggle-split':li,active:this.context.isOpen,'nav-link':ri}),ai),ui=di.children||g.createElement('span',{className:'sr-only'},pi);return ri&&!ii?(gi='a',di.href='#'):ii?gi=ii:gi=Ns,g.createElement(gi,at({},di,{className:ci,onClick:this.onClick,'aria-haspopup':'true','aria-expanded':this.context.isOpen,children:ui}))}}]),ei}(g.Component);qs.propTypes=Ws,qs.defaultProps={'data-toggle':'dropdown','aria-haspopup':!0,color:'secondary'},qs.contextTypes=Hs;var Gs=g.PropTypes,Fs={baseClass:Gs.string,baseClassIn:Gs.string,tag:Gs.oneOfType([Gs.func,Gs.string]),className:Gs.string,cssModule:Gs.object,transitionAppearTimeout:Gs.number,transitionEnterTimeout:Gs.number,transitionLeaveTimeout:Gs.number,transitionAppear:Gs.bool,transitionEnter:Gs.bool,transitionLeave:Gs.bool,onLeave:Gs.func,onEnter:Gs.func},Ys=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.state={mounted:!ti.transitionAppear},oi.onLeave=oi.onLeave.bind(oi),oi.onEnter=oi.onEnter.bind(oi),oi.timers=[],oi}return nt(ei,Qr),ot(ei,[{key:'componentWillUnmount',value:function(){this.timers.forEach(function(oi){return clearTimeout(oi)})}},{key:'onEnter',value:function(oi){var si=this;return function(){oi(),si.props.onEnter&&si.props.onEnter()}}},{key:'onLeave',value:function(oi){var si=this;return function(){oi(),si.props.onLeave&&si.props.onLeave()}}},{key:'componentWillAppear',value:function(oi){this.props.transitionAppear||this.onEnter(oi)(),this.timers.push(setTimeout(this.onEnter(oi),this.props.transitionAppearTimeout))}},{key:'componentDidAppear',value:function(){this.setState({mounted:!0})}},{key:'componentWillEnter',value:function(oi){this.props.transitionEnter||this.onEnter(oi)(),this.timers.push(setTimeout(this.onEnter(oi),this.props.transitionEnterTimeout))}},{key:'componentDidEnter',value:function(){this.setState({mounted:!0})}},{key:'componentWillLeave',value:function(oi){this.setState({mounted:!1}),this.props.transitionLeave||this.onLeave(oi)(),this.timers.push(setTimeout(this.onLeave(oi),this.props.transitionLeaveTimeout))}},{key:'render',value:function(){var oi=this.props,si=oi.baseClass,ai=oi.baseClassIn,ni=oi.className,li=oi.cssModule,ri=oi.tag,ii=Ao(this.props,Object.keys(Fs)),di=w(it(ni,si,!!this.state.mounted&&ai),li);return g.createElement(ri,at({},ii,{className:di}))}}]),ei}(g.Component);Ys.propTypes=Fs,Ys.defaultProps={tag:'div',baseClass:'fade',baseClassIn:'show',transitionAppearTimeout:0,transitionEnterTimeout:0,transitionLeaveTimeout:0,transitionAppear:!0,transitionEnter:!0,transitionLeave:!0};var $s=g.PropTypes,Xs={color:$s.string,pill:$s.bool,tag:$s.oneOfType([$s.func,$s.string]),children:$s.node,className:$s.string,cssModule:$s.object},Zs=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.color,ai=ei.pill,ni=ei.tag,li=lt(ei,['className','cssModule','color','pill','tag']),ri=w(it(ti,'badge','badge-'+si,!!ai&&'badge-pill'),oi);return g.createElement(ni,at({},li,{className:ri}))};Zs.propTypes=Xs,Zs.defaultProps={color:'default',pill:!1,tag:'span'};var Js=g.PropTypes,Qs={tag:Js.oneOfType([Js.func,Js.string]),inverse:Js.bool,color:Js.string,block:Js.bool,outline:Js.bool,className:Js.string,cssModule:Js.object},ta=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.color,ai=ei.block,ni=ei.inverse,li=ei.outline,ri=ei.tag,ii=lt(ei,['className','cssModule','color','block','inverse','outline','tag']),di=w(it(ti,'card',!!ni&&'card-inverse',!!ai&&'card-block',!!si&&'card'+(li?'-outline':'')+'-'+si),oi);return g.createElement(ri,at({},ii,{className:di}))};ta.propTypes=Qs,ta.defaultProps={tag:'div'};var oa=g.PropTypes,sa={tag:oa.oneOfType([oa.func,oa.string]),className:oa.string,cssModule:oa.object},na=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-group'),oi);return g.createElement(si,at({},ai,{className:ni}))};na.propTypes=sa,na.defaultProps={tag:'div'};var la=g.PropTypes,ra={tag:la.oneOfType([la.func,la.string]),className:la.string,cssModule:la.object},da=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-deck'),oi);return g.createElement(si,at({},ai,{className:ni}))};da.propTypes=ra,da.defaultProps={tag:'div'};var pa=g.PropTypes,ca={tag:pa.oneOfType([pa.func,pa.string]),className:pa.string,cssModule:pa.object},ga=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-columns'),oi);return g.createElement(si,at({},ai,{className:ni}))};ga.propTypes=ca,ga.defaultProps={tag:'div'};var fa=g.PropTypes,ma={tag:fa.oneOfType([fa.func,fa.string]),className:fa.string,cssModule:fa.object},ba=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-block'),oi);return g.createElement(si,at({},ai,{className:ni}))};ba.propTypes=ma,ba.defaultProps={tag:'div'};var ya=g.PropTypes,va={tag:ya.oneOfType([ya.func,ya.string]),getRef:ya.oneOfType([ya.func,ya.string]),className:ya.string,cssModule:ya.object},Na=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.getRef,ni=lt(ei,['className','cssModule','tag','getRef']),li=w(it(ti,'card-link'),oi);return g.createElement(si,at({},ni,{ref:ai,className:li}))};Na.propTypes=va,Na.defaultProps={tag:'a'};var ka=g.PropTypes,Ca={tag:ka.oneOfType([ka.func,ka.string]),className:ka.string,cssModule:ka.object},_a=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-footer'),oi);return g.createElement(si,at({},ai,{className:ni}))};_a.propTypes=Ca,_a.defaultProps={tag:'div'};var Oa=g.PropTypes,Ea={tag:Oa.oneOfType([Oa.func,Oa.string]),className:Oa.string,cssModule:Oa.object},wa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-header'),oi);return g.createElement(si,at({},ai,{className:ni}))};wa.propTypes=Ea,wa.defaultProps={tag:'div'};var xa=g.PropTypes,ja={tag:xa.oneOfType([xa.func,xa.string]),top:xa.bool,bottom:xa.bool,className:xa.string,cssModule:xa.object},Aa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.top,ai=ei.bottom,ni=ei.tag,li=lt(ei,['className','cssModule','top','bottom','tag']),ri='card-img';si&&(ri='card-img-top'),ai&&(ri='card-img-bottom');var ii=w(it(ti,ri),oi);return g.createElement(ni,at({},li,{className:ii}))};Aa.propTypes=ja,Aa.defaultProps={tag:'img'};var La=g.PropTypes,Sa={tag:La.oneOfType([La.func,La.string]),className:La.string,cssModule:La.object},Ia=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-img-overlay'),oi);return g.createElement(si,at({},ai,{className:ni}))};Ia.propTypes=Sa,Ia.defaultProps={tag:'div'};var Ra=g.PropTypes,Ba={tag:Ra.oneOfType([Ra.func,Ra.string]),className:Ra.string,cssModule:Ra.object},Ua=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-subtitle'),oi);return g.createElement(si,at({},ai,{className:ni}))};Ua.propTypes=Ba,Ua.defaultProps={tag:'h6'};var Ha=g.PropTypes,qa={tag:Ha.oneOfType([Ha.func,Ha.string]),className:Ha.string,cssModule:Ha.object},Fa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-text'),oi);return g.createElement(si,at({},ai,{className:ni}))};Fa.propTypes=qa,Fa.defaultProps={tag:'p'};var Va=g.PropTypes,Ya={tag:Va.oneOfType([Va.func,Va.string]),className:Va.string,cssModule:Va.object},Xa=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'card-title'),oi);return g.createElement(si,at({},ai,{className:ni}))};Xa.propTypes=Ya,Xa.defaultProps={tag:'h4'};var Ka=g.PropTypes,Za={placement:g.PropTypes.oneOf(dt),target:Ka.string.isRequired,isOpen:Ka.bool,tether:Ka.object,tetherRef:Ka.func,className:Ka.string,cssModule:Ka.object,toggle:Ka.func},Qa={classPrefix:'bs-tether',classes:{element:!1,enabled:'show'},constraints:[{to:'scrollParent',attachment:'together none'},{to:'window',attachment:'together none'}]},en=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.getTetherConfig=oi.getTetherConfig.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'getTetherConfig',value:function(){var oi=C(this.props.placement);return at({},Qa,oi,{target:'#'+this.props.target},this.props.tether)}},{key:'render',value:function(){if(!this.props.isOpen)return null;var oi=this.getTetherConfig(),si=w(it('popover-inner',this.props.className),this.props.cssModule),ai=Ao(this.props,Object.keys(Za));return g.createElement(Go,{className:w('popover',this.props.cssModule),tether:oi,tetherRef:this.props.tetherRef,isOpen:this.props.isOpen,toggle:this.props.toggle},g.createElement('div',at({},ai,{className:si})))}}]),ei}(g.Component);en.propTypes=Za,en.defaultProps={isOpen:!1,placement:'bottom',toggle:function(){}};var tn=g.PropTypes,sn={tag:tn.oneOfType([tn.func,tn.string]),className:tn.string,cssModule:tn.object},nn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'popover-title'),oi);return g.createElement(si,at({},ai,{className:ni}))};nn.propTypes=sn,nn.defaultProps={tag:'h3'};var ln=g.PropTypes,rn={tag:ln.oneOfType([ln.func,ln.string]),className:ln.string,cssModule:ln.object},pn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'popover-content'),oi);return g.createElement(si,at({},ai,{className:ni}))};pn.propTypes=rn,pn.defaultProps={tag:'div'};var cn=0/0,un='[object Symbol]',gn=/^\s+|\s+$/g,mn=/^[-+]0x[0-9a-f]+$/i,hn=/^0b[01]+$/i,bn=/^0o[0-7]+$/i,yn=parseInt,vn=Object.prototype,Tn=vn.toString,Nn=function(Qr){if('number'==typeof Qr)return Qr;if(Ke(Qr))return cn;if($e(Qr)){var ei='function'==typeof Qr.valueOf?Qr.valueOf():Qr;Qr=$e(ei)?ei+'':ei}if('string'!=typeof Qr)return 0===Qr?Qr:+Qr;Qr=Qr.replace(gn,'');var ti=hn.test(Qr);return ti||bn.test(Qr)?yn(Qr.slice(2),ti?2:8):mn.test(Qr)?cn:+Qr},kn=g.PropTypes,Cn={children:kn.node,bar:kn.bool,multi:kn.bool,tag:kn.string,value:kn.oneOfType([kn.string,kn.number]),max:kn.oneOfType([kn.string,kn.number]),animated:kn.bool,striped:kn.bool,color:kn.string,className:kn.string,barClassName:kn.string,cssModule:kn.object},On=function(ei){var ti=ei.children,oi=ei.className,si=ei.barClassName,ai=ei.cssModule,ni=ei.value,li=ei.max,ri=ei.animated,ii=ei.striped,di=ei.color,pi=ei.bar,ci=ei.multi,ui=ei.tag,gi=lt(ei,['children','className','barClassName','cssModule','value','max','animated','striped','color','bar','multi','tag']),fi=100*(Nn(ni)/Nn(li)),mi=w(it(oi,'progress'),ai),hi=w(it('progress-bar',pi?oi||si:si,ri?'progress-bar-animated':null,di?'bg-'+di:null,ii||ri?'progress-bar-striped':null),ai),bi=ci?ti:g.createElement('div',{className:hi,style:{width:fi+'%'},role:'progressbar','aria-valuenow':ni,'aria-valuemin':'0','aria-valuemax':li,children:ti});return pi?bi:g.createElement(ui,at({},gi,{className:mi,children:bi}))};On.propTypes=Cn,On.defaultProps={tag:'div',value:0,max:100};var En=g.PropTypes,Pn={isOpen:En.bool,size:En.string,toggle:En.func,keyboard:En.bool,backdrop:En.oneOfType([En.bool,En.oneOf(['static'])]),onEnter:En.func,onExit:En.func,children:En.node,className:En.string,wrapClassName:En.string,modalClassName:En.string,backdropClassName:En.string,contentClassName:En.string,cssModule:En.object,zIndex:En.oneOfType([En.number,En.string])},xn=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.originalBodyPadding=null,oi.isBodyOverflowing=!1,oi.togglePortal=oi.togglePortal.bind(oi),oi.handleBackdropClick=oi.handleBackdropClick.bind(oi),oi.handleEscape=oi.handleEscape.bind(oi),oi.destroy=oi.destroy.bind(oi),oi.onEnter=oi.onEnter.bind(oi),oi.onExit=oi.onExit.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'componentDidMount',value:function(){this.props.isOpen&&this.togglePortal()}},{key:'componentDidUpdate',value:function(oi){this.props.isOpen===oi.isOpen?this._element&&this.renderIntoSubtree():this.togglePortal()}},{key:'componentWillUnmount',value:function(){this.onExit()}},{key:'onEnter',value:function(){this.props.onEnter&&this.props.onEnter()}},{key:'onExit',value:function(){this.destroy(),this.props.onExit&&this.props.onExit()}},{key:'handleEscape',value:function(oi){this.props.keyboard&&27===oi.keyCode&&this.props.toggle&&this.props.toggle()}},{key:'handleBackdropClick',value:function(oi){if(!0===this.props.backdrop){var si=this._dialog;oi.target&&!si.contains(oi.target)&&this.props.toggle&&this.props.toggle()}}},{key:'togglePortal',value:function(){this.props.isOpen?(this._focus=!0,this.show()):this.hide()}},{key:'destroy',value:function(){this._element&&(m.unmountComponentAtNode(this._element),document.body.removeChild(this._element),this._element=null);var oi=document.body.className.replace('modal-open','');document.body.className=w(it(oi).trim(),this.props.cssModule),_(this.originalBodyPadding)}},{key:'hide',value:function(){this.renderIntoSubtree()}},{key:'show',value:function(){var oi=document.body.className;this._element=document.createElement('div'),this._element.setAttribute('tabindex','-1'),this._element.style.position='relative',this._element.style.zIndex=this.props.zIndex,this.originalBodyPadding=E(),P(),document.body.appendChild(this._element),document.body.className=w(it(oi,'modal-open'),this.props.cssModule),this.renderIntoSubtree()}},{key:'renderIntoSubtree',value:function(){m.unstable_renderSubtreeIntoContainer(this,this.renderChildren(),this._element),this._focus&&(this._dialog.parentNode.focus(),this._focus=!1)}},{key:'renderChildren',value:function(){var oi=this,si=Ao(this.props,['toggle','keyboard','onEnter','onExit','zIndex']),ai=si.className,ni=si.wrapClassName,li=si.modalClassName,ri=si.backdropClassName,ii=si.contentClassName,di=si.cssModule,pi=si.isOpen,ci=si.size,ui=si.backdrop,gi=si.children,fi=lt(si,['className','wrapClassName','modalClassName','backdropClassName','contentClassName','cssModule','isOpen','size','backdrop','children']);return g.createElement(h,{component:'div',className:w(ni)},pi&&g.createElement(Ys,{key:'modal-dialog',onEnter:this.onEnter,onLeave:this.onExit,transitionAppearTimeout:300,transitionEnterTimeout:300,transitionLeaveTimeout:300,onClickCapture:this.handleBackdropClick,onKeyUp:this.handleEscape,cssModule:di,className:w(it('modal',li),di),style:{display:'block'},tabIndex:'-1'},g.createElement('div',at({className:w(it('modal-dialog',ai,st({},'modal-'+ci,ci)),di),role:'document',ref:function(hi){return oi._dialog=hi}},fi),g.createElement('div',{className:w(it('modal-content',ii),di)},gi))),pi&&ui&&g.createElement(Ys,{key:'modal-backdrop',transitionAppearTimeout:150,transitionEnterTimeout:150,transitionLeaveTimeout:150,cssModule:di,className:w(it('modal-backdrop',ri),di)}))}},{key:'render',value:function(){return null}}]),ei}(g.Component);xn.propTypes=Pn,xn.defaultProps={isOpen:!1,backdrop:!0,keyboard:!0,zIndex:1050};var jn=g.PropTypes,Dn={tag:jn.oneOfType([jn.func,jn.string]),wrapTag:jn.oneOfType([jn.func,jn.string]),toggle:jn.func,className:jn.string,cssModule:jn.object,children:jn.node},Ln=function(ei){var ti,oi=ei.className,si=ei.cssModule,ai=ei.children,ni=ei.toggle,li=ei.tag,ri=ei.wrapTag,ii=lt(ei,['className','cssModule','children','toggle','tag','wrapTag']),di=w(it(oi,'modal-header'),si);return ni&&(ti=g.createElement('button',{type:'button',onClick:ni,className:'close','aria-label':'Close'},g.createElement('span',{'aria-hidden':'true'},'\xD7'))),g.createElement(ri,at({},ii,{className:di}),g.createElement(li,{className:w('modal-title',si)},ai),ti)};Ln.propTypes=Dn,Ln.defaultProps={tag:'h4',wrapTag:'div'};var Sn=g.PropTypes,zn={tag:Sn.oneOfType([Sn.func,Sn.string]),className:Sn.string,cssModule:Sn.object},Rn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'modal-body'),oi);return g.createElement(si,at({},ai,{className:ni}))};Rn.propTypes=zn,Rn.defaultProps={tag:'div'};var Bn=g.PropTypes,Wn={tag:Bn.oneOfType([Bn.func,Bn.string]),className:Bn.string,cssModule:Bn.object},Hn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'modal-footer'),oi);return g.createElement(si,at({},ai,{className:ni}))};Hn.propTypes=Wn,Hn.defaultProps={tag:'div'};var qn=g.PropTypes,Gn={placement:g.PropTypes.oneOf(dt),target:qn.oneOfType([qn.string,qn.object]).isRequired,isOpen:qn.bool,disabled:qn.bool,tether:qn.object,tetherRef:qn.func,className:qn.string,cssModule:qn.object,toggle:qn.func,autohide:qn.bool,delay:qn.oneOfType([qn.shape({show:qn.number,hide:qn.number}),qn.number])},Fn={show:0,hide:250},Yn={classPrefix:'bs-tether',classes:{element:!1,enabled:'show'},constraints:[{to:'scrollParent',attachment:'together none'},{to:'window',attachment:'together none'}]},$n=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.addTargetEvents=oi.addTargetEvents.bind(oi),oi.getTarget=oi.getTarget.bind(oi),oi.getTetherConfig=oi.getTetherConfig.bind(oi),oi.handleDocumentClick=oi.handleDocumentClick.bind(oi),oi.removeTargetEvents=oi.removeTargetEvents.bind(oi),oi.toggle=oi.toggle.bind(oi),oi.onMouseOverTooltip=oi.onMouseOverTooltip.bind(oi),oi.onMouseLeaveTooltip=oi.onMouseLeaveTooltip.bind(oi),oi.onMouseOverTooltipContent=oi.onMouseOverTooltipContent.bind(oi),oi.onMouseLeaveTooltipContent=oi.onMouseLeaveTooltipContent.bind(oi),oi.show=oi.show.bind(oi),oi.hide=oi.hide.bind(oi),oi}return nt(ei,Qr),ot(ei,[{key:'componentDidMount',value:function(){this._target=this.getTarget(),this.addTargetEvents()}},{key:'componentWillUnmount',value:function(){this.removeTargetEvents()}},{key:'onMouseOverTooltip',value:function(){this._hideTimeout&&this.clearHideTimeout(),this._showTimeout=setTimeout(this.show,this.getDelay('show'))}},{key:'onMouseLeaveTooltip',value:function(){this._showTimeout&&this.clearShowTimeout(),this._hideTimeout=setTimeout(this.hide,this.getDelay('hide'))}},{key:'onMouseOverTooltipContent',value:function(){this.props.autohide||this._hideTimeout&&this.clearHideTimeout()}},{key:'onMouseLeaveTooltipContent',value:function(){this.props.autohide||(this._showTimeout&&this.clearShowTimeout(),this._hideTimeout=setTimeout(this.hide,this.getDelay('hide')))}},{key:'getDelay',value:function(oi){var si=this.props.delay;return'object'===('undefined'==typeof si?'undefined':et(si))?isNaN(si[oi])?Fn[oi]:si[oi]:si}},{key:'getTarget',value:function(){var oi=this.props.target;return'object'===('undefined'==typeof oi?'undefined':et(oi))?oi:document.getElementById(oi)}},{key:'getTetherConfig',value:function(){var oi=C(this.props.placement);return at({},Yn,oi,{target:this.getTarget},this.props.tether)}},{key:'show',value:function(){this.props.isOpen||(this.clearShowTimeout(),this.toggle())}},{key:'hide',value:function(){this.props.isOpen&&(this.clearHideTimeout(),this.toggle())}},{key:'clearShowTimeout',value:function(){clearTimeout(this._showTimeout),this._showTimeout=void 0}},{key:'clearHideTimeout',value:function(){clearTimeout(this._hideTimeout),this._hideTimeout=void 0}},{key:'handleDocumentClick',value:function(oi){(oi.target===this._target||this._target.contains(oi.target))&&(this._hideTimeout&&this.clearHideTimeout(),!this.props.isOpen&&this.toggle())}},{key:'addTargetEvents',value:function(){this._target.addEventListener('mouseover',this.onMouseOverTooltip,!0),this._target.addEventListener('mouseout',this.onMouseLeaveTooltip,!0),document.addEventListener('click',this.handleDocumentClick,!0)}},{key:'removeTargetEvents',value:function(){this._target.removeEventListener('mouseover',this.onMouseOverTooltip,!0),this._target.removeEventListener('mouseout',this.onMouseLeaveTooltip,!0),document.removeEventListener('click',this.handleDocumentClick,!0)}},{key:'toggle',value:function(oi){return this.props.disabled?oi&&oi.preventDefault():this.props.toggle()}},{key:'render',value:function(){if(!this.props.isOpen)return null;var oi=Ao(this.props,Object.keys(Gn)),si=w(it('tooltip-inner',this.props.className),this.props.cssModule),ai=this.getTetherConfig();return g.createElement(Go,{className:'tooltip',tether:ai,tetherRef:this.props.tetherRef,isOpen:this.props.isOpen,toggle:this.toggle},g.createElement('div',at({},oi,{className:si,onMouseOver:this.onMouseOverTooltipContent,onMouseLeave:this.onMouseLeaveTooltipContent})))}}]),ei}(g.Component);$n.propTypes=Gn,$n.defaultProps={isOpen:!1,placement:'bottom',delay:Fn,autohide:!0,toggle:function(){}};var Xn=g.PropTypes,Kn={className:Xn.string,cssModule:Xn.object,size:Xn.string,bordered:Xn.bool,striped:Xn.bool,inverse:Xn.bool,hover:Xn.bool,reflow:Xn.bool,responsive:Xn.bool,tag:Xn.oneOfType([Xn.func,Xn.string]),responsiveTag:Xn.oneOfType([Xn.func,Xn.string])},Jn=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.size,ai=ei.bordered,ni=ei.striped,li=ei.inverse,ri=ei.hover,ii=ei.reflow,di=ei.responsive,pi=ei.tag,ci=ei.responsiveTag,ui=lt(ei,['className','cssModule','size','bordered','striped','inverse','hover','reflow','responsive','tag','responsiveTag']),gi=w(it(ti,'table',!!si&&'table-'+si,!!ai&&'table-bordered',!!ni&&'table-striped',!!li&&'table-inverse',!!ri&&'table-hover',!!ii&&'table-reflow'),oi),fi=g.createElement(pi,at({},ui,{className:gi}));return di?g.createElement(ci,{className:'table-responsive'},fi):fi};Jn.propTypes=Kn,Jn.defaultProps={tag:'table',responsiveTag:'div'};var Qn=g.PropTypes,tl={tag:Qn.oneOfType([Qn.func,Qn.string]),flush:Qn.bool,className:Qn.string,cssModule:Qn.object},sl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.flush,ni=lt(ei,['className','cssModule','tag','flush']),li=w(it(ti,'list-group',!!ai&&'list-group-flush'),oi);return g.createElement(si,at({},ni,{className:li}))};sl.propTypes=tl,sl.defaultProps={tag:'ul'};var al=g.PropTypes,nl={children:al.node,inline:al.bool,tag:al.oneOfType([al.func,al.string]),getRef:al.oneOfType([al.func,al.string]),className:al.string,cssModule:al.object},rl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.inline,ai=ei.tag,ni=ei.getRef,li=lt(ei,['className','cssModule','inline','tag','getRef']),ri=w(it(ti,!!si&&'form-inline'),oi);return g.createElement(ai,at({},li,{ref:ni,className:ri}))};rl.propTypes=nl,rl.defaultProps={tag:'form'};var il=g.PropTypes,dl={children:il.node,tag:il.string,className:il.string,cssModule:il.object},cl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'form-control-feedback'),oi);return g.createElement(si,at({},ai,{className:ni}))};cl.propTypes=dl,cl.defaultProps={tag:'div'};var ul=g.PropTypes,gl={children:ul.node,row:ul.bool,check:ul.bool,disabled:ul.bool,tag:ul.string,color:ul.string,className:ul.string,cssModule:ul.object},ml=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.row,ai=ei.disabled,ni=ei.color,li=ei.check,ri=ei.tag,ii=lt(ei,['className','cssModule','row','disabled','color','check','tag']),di=w(it(ti,!!ni&&'has-'+ni,!!si&&'row',li?'form-check':'form-group',li&&ai&&'disabled'),oi);return g.createElement(ri,at({},ii,{className:di}))};ml.propTypes=gl,ml.defaultProps={tag:'div'};var hl=g.PropTypes,bl={children:hl.node,inline:hl.bool,tag:hl.string,color:hl.string,className:hl.string,cssModule:hl.object},vl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.inline,ai=ei.color,ni=ei.tag,li=lt(ei,['className','cssModule','inline','color','tag']),ri=w(it(ti,!si&&'form-text',!!ai&&'text-'+ai),oi);return g.createElement(ni,at({},li,{className:ri}))};vl.propTypes=bl,vl.defaultProps={tag:'small'};var Tl=g.PropTypes,Nl={children:Tl.node,type:Tl.string,size:Tl.string,state:Tl.string,tag:Tl.oneOfType([Tl.func,Tl.string]),getRef:Tl.oneOfType([Tl.func,Tl.string]),static:Tl.bool,addon:Tl.bool,className:Tl.string,cssModule:Tl.object},Cl=function(Qr){function ei(){return tt(this,ei),rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).apply(this,arguments))}return nt(ei,Qr),ot(ei,[{key:'render',value:function(){var oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.type,li=oi.size,ri=oi.state,ii=oi.tag,di=oi.addon,pi=oi.static,ci=oi.getRef,ui=lt(oi,['className','cssModule','type','size','state','tag','addon','static','getRef']),gi=-1<['radio','checkbox'].indexOf(ni),bi='select'===ni||'textarea'===ni?ni:'input',yi='form-control';pi?(yi+='-static',bi=ii):'file'===ni?yi+='-file':gi&&(di?yi=null:yi='form-check-input');var vi=w(it(si,!!ri&&'form-control-'+ri,!!li&&'form-control-'+li,yi),ai);return'input'===bi&&(ui.type=ni),g.createElement(bi,at({},ui,{ref:ci,className:vi}))}}]),ei}(g.Component);Cl.propTypes=Nl,Cl.defaultProps={tag:'p',type:'text'};var Ml=g.PropTypes,_l={tag:Ml.oneOfType([Ml.func,Ml.string]),size:Ml.string,className:Ml.string,cssModule:Ml.object},El=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.size,ni=lt(ei,['className','cssModule','tag','size']),li=w(it(ti,'input-group',ai?'input-group-'+ai:null),oi);return g.createElement(si,at({},ni,{className:li}))};El.propTypes=_l,El.defaultProps={tag:'div'};var Pl=g.PropTypes,wl={tag:Pl.oneOfType([Pl.func,Pl.string]),className:Pl.string,cssModule:Pl.object},jl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=lt(ei,['className','cssModule','tag']),ni=w(it(ti,'input-group-addon'),oi);return g.createElement(si,at({},ai,{className:ni}))};jl.propTypes=wl,jl.defaultProps={tag:'div'};var Dl=g.PropTypes,Al={tag:Dl.oneOfType([Dl.func,Dl.string]),children:Dl.node,groupClassName:Dl.string,groupAttributes:Dl.object,className:Dl.string,cssModule:Dl.object},Sl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.children,ni=ei.groupClassName,li=ei.groupAttributes,ri=lt(ei,['className','cssModule','tag','children','groupClassName','groupAttributes']);if('string'==typeof ai){var ii=w(it(ni,'input-group-btn'),oi);return g.createElement(si,at({},li,{className:ii}),g.createElement(Ns,at({},ri,{className:ti,children:ai})))}var di=w(it(ti,'input-group-btn'),oi);return g.createElement(si,at({},ri,{className:di,children:ai}))};Sl.propTypes=Al,Sl.defaultProps={tag:'div'};var zl=g.PropTypes,Il=['xs','sm','md','lg','xl'],Rl=zl.oneOfType([zl.number,zl.string]),Bl=zl.oneOfType([zl.string,zl.number,zl.shape({size:Rl,push:Rl,pull:Rl,offset:Rl})]),Wl={children:zl.node,hidden:zl.bool,check:zl.bool,inline:zl.bool,disabled:zl.bool,size:zl.string,for:zl.string,tag:zl.string,className:zl.string,cssModule:zl.object,xs:Bl,sm:Bl,md:Bl,lg:Bl,xl:Bl},Hl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.hidden,ai=ei.tag,ni=ei.check,li=ei.inline,ri=ei.disabled,ii=ei.size,di=ei.for,pi=lt(ei,['className','cssModule','hidden','tag','check','inline','disabled','size','for']),ci=[];Il.forEach(function(gi){var fi=ei[gi];if(delete pi[gi],fi&&fi.size){var mi;ci.push(w(it((mi={},st(mi,'col-'+gi+'-'+fi.size,fi.size),st(mi,'push-'+gi+'-'+fi.push,fi.push),st(mi,'pull-'+gi+'-'+fi.pull,fi.pull),st(mi,'offset-'+gi+'-'+fi.offset,fi.offset),mi))),oi)}else fi&&ci.push('col-'+gi+'-'+fi)});var ui=w(it(ti,!!si&&'sr-only',!!ni&&'form-check-'+(li?'inline':'label'),ni&&li&&ri&&'disabled',!!ii&&'col-form-label-'+ii,ci,!!ci.length&&'col-form-label'),oi);return g.createElement(ai,at({htmlFor:di},pi,{className:ui}))};Hl.propTypes=Wl,Hl.defaultProps={tag:'label'};var ql=g.PropTypes,Gl={body:ql.bool,bottom:ql.bool,children:ql.node,className:ql.string,cssModule:ql.object,heading:ql.bool,left:ql.bool,list:ql.bool,middle:ql.bool,object:ql.bool,right:ql.bool,tag:ql.oneOfType([ql.func,ql.string]),top:ql.bool},Fl=function(ei){var ti=ei.body,oi=ei.bottom,si=ei.className,ai=ei.cssModule,ni=ei.heading,li=ei.left,ri=ei.list,ii=ei.middle,di=ei.object,pi=ei.right,ci=ei.tag,ui=ei.top,gi=lt(ei,['body','bottom','className','cssModule','heading','left','list','middle','object','right','tag','top']),fi;fi=ni?'h4':li||pi?'a':di?'img':ri?'ul':'div';var mi=ci||fi,hi=w(it(si,{'media-body':ti,'media-heading':ni,'media-left':li,'media-right':pi,'media-top':ui,'media-bottom':oi,'media-middle':ii,'media-object':di,'media-list':ri,media:!ti&&!ni&&!li&&!pi&&!ui&&!oi&&!ii&&!di&&!ri}),ai);return g.createElement(mi,at({},gi,{className:hi}))};Fl.propTypes=Gl;var Vl=g.PropTypes,Yl={children:Vl.node,className:Vl.string,cssModule:Vl.object,size:Vl.string,tag:Vl.oneOfType([Vl.func,Vl.string])},Xl=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.size,ai=ei.tag,ni=lt(ei,['className','cssModule','size','tag']),li=w(it(ti,'pagination',st({},'pagination-'+si,!!si)),oi);return g.createElement(ai,at({},ni,{className:li}))};Xl.propTypes=Yl,Xl.defaultProps={tag:'ul'};var Kl=g.PropTypes,Zl={active:Kl.bool,children:Kl.node,className:Kl.string,cssModule:Kl.object,disabled:Kl.bool,tag:Kl.oneOfType([Kl.func,Kl.string])},Ql=function(ei){var ti=ei.active,oi=ei.className,si=ei.cssModule,ai=ei.disabled,ni=ei.tag,li=lt(ei,['active','className','cssModule','disabled','tag']),ri=w(it(oi,'page-item',{active:ti,disabled:ai}),si);return g.createElement(ni,at({},li,{className:ri}))};Ql.propTypes=Zl,Ql.defaultProps={tag:'li'};var er=g.PropTypes,tr={'aria-label':er.string,children:er.node,className:er.string,cssModule:er.object,next:er.bool,previous:er.bool,tag:er.oneOfType([er.func,er.string])},sr=function(ei){var ii,ti=ei.className,oi=ei.cssModule,si=ei.next,ai=ei.previous,ni=ei.tag,li=lt(ei,['className','cssModule','next','previous','tag']),ri=w(it(ti,'page-link'),oi);ai?ii='Previous':si&&(ii='Next');var pi,di=ei['aria-label']||ii;ai?pi='\xAB':si&&(pi='\xBB');var ci=ei.children;return(ai||si)&&(ci=[g.createElement('span',{'aria-hidden':'true',key:'caret'},ci||pi),g.createElement('span',{className:'sr-only',key:'sr'},di)]),g.createElement(ni,at({},li,{className:ri,'aria-label':di}),ci)};sr.propTypes=tr,sr.defaultProps={tag:'a'};var ar=g.PropTypes,nr=g.Component,lr={tag:ar.oneOfType([ar.func,ar.string]),activeTab:ar.any,className:ar.string,cssModule:ar.object},ir={activeTabId:ar.any},dr=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.state={activeTab:oi.props.activeTab},oi}return nt(ei,Qr),ot(ei,[{key:'getChildContext',value:function(){return{activeTabId:this.state.activeTab}}},{key:'componentWillReceiveProps',value:function(oi){this.state.activeTab!==oi.activeTab&&this.setState({activeTab:oi.activeTab})}},{key:'render',value:function(){var oi=this.props,si=oi.className,ai=oi.cssModule,ni=oi.tag,li=Ao(this.props,Object.keys(lr)),ri=w(it('tab-content',si),ai);return g.createElement(ni,at({},li,{className:ri}))}}]),ei}(nr);dr.propTypes=lr,dr.defaultProps={tag:'div'},dr.childContextTypes=ir;var pr=g.PropTypes,cr={tag:pr.oneOfType([pr.func,pr.string]),className:pr.string,cssModule:pr.object,tabId:pr.any},gr={activeTabId:pr.any};Je.propTypes=cr,Je.defaultProps={tag:'div'},Je.contextTypes=gr;var fr=g.PropTypes,mr={tag:fr.oneOfType([fr.func,fr.string]),fluid:fr.bool,className:fr.string,cssModule:fr.object},br=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.fluid,ni=lt(ei,['className','cssModule','tag','fluid']),li=w(it(ti,'jumbotron',!!ai&&'jumbotron-fluid'),oi);return g.createElement(si,at({},ni,{className:li}))};br.propTypes=mr,br.defaultProps={tag:'div'};var yr=g.PropTypes,vr=function(ei){var ti=ei.children;return g.Children.toArray(ti)[0]||null},Tr={children:yr.node,className:yr.string,cssModule:yr.object,color:yr.string,isOpen:yr.bool,toggle:yr.func,tag:yr.oneOfType([yr.func,yr.string]),transitionAppearTimeout:yr.number,transitionEnterTimeout:yr.number,transitionLeaveTimeout:yr.number},kr=function(ei){var ti=ei.className,oi=ei.cssModule,si=ei.tag,ai=ei.color,ni=ei.isOpen,li=ei.toggle,ri=ei.children,ii=ei.transitionAppearTimeout,di=ei.transitionEnterTimeout,pi=ei.transitionLeaveTimeout,ci=lt(ei,['className','cssModule','tag','color','isOpen','toggle','children','transitionAppearTimeout','transitionEnterTimeout','transitionLeaveTimeout']),ui=w(it(ti,'alert','alert-'+ai,{'alert-dismissible':li}),oi),gi=g.createElement(si,at({},ci,{className:ui,role:'alert'}),li?g.createElement('button',{type:'button',className:'close','aria-label':'Close',onClick:li},g.createElement('span',{'aria-hidden':'true'},'\xD7')):null,ri);return g.createElement(y,{component:vr,transitionName:{appear:'fade',appearActive:'show',enter:'fade',enterActive:'show',leave:'fade',leaveActive:'out'},transitionAppear:0<ii,transitionAppearTimeout:ii,transitionEnter:0<di,transitionEnterTimeout:di,transitionLeave:0<pi,transitionLeaveTimeout:pi},ni?gi:null)};kr.propTypes=Tr,kr.defaultProps={color:'success',isOpen:!0,tag:'div',transitionAppearTimeout:150,transitionEnterTimeout:150,transitionLeaveTimeout:150};var Cr=g.PropTypes,Mr=g.Component,_r='SHOW',Or='SHOWN',Er='HIDE',Pr='HIDDEN',wr={isOpen:Cr.bool,className:Cr.node,tag:Cr.oneOfType([Cr.func,Cr.string]),cssModule:Cr.object,navbar:Cr.bool,delay:Cr.oneOfType([Cr.shape({show:Cr.number,hide:Cr.number}),Cr.number]),onOpened:Cr.func,onClosed:Cr.func},xr={show:350,hide:350},Dr=function(Qr){function ei(ti){tt(this,ei);var oi=rt(this,(ei.__proto__||Object.getPrototypeOf(ei)).call(this,ti));return oi.state={collapse:ti.isOpen?Or:Pr,height:null},oi.element=null,oi}return nt(ei,Qr),ot(ei,[{key:'componentWillReceiveProps',value:function(oi){var si=this,ai=oi.isOpen,ni=this.state.collapse;ai&&ni===Pr?this.setState({collapse:_r},function(){si.setState({height:si.getHeight()}),si.transitionTag=setTimeout(function(){si.setState({collapse:Or,height:null})},si.getDelay('show'))}):!ai&&ni===Or&&(this.setState({height:this.getHeight()},function(){si.setState({collapse:Er,height:si.getHeight()},function(){si.setState({height:0})})}),this.transitionTag=setTimeout(function(){si.setState({collapse:Pr,height:null})},this.getDelay('hide')))}},{key:'componentDidUpdate',value:function(oi,si){this.state.collapse===Or&&si&&si.collapse!==Or&&this.props.onOpened(),this.state.collapse===Pr&&si&&si.collapse!==Pr&&this.props.onClosed()}},{key:'componentWillUnmount',value:function(){clearTimeout(this.transitionTag)}},{key:'getDelay',value:function(oi){var si=this.props.delay;return'object'===('undefined'==typeof si?'undefined':et(si))?isNaN(si[oi])?xr[oi]:si[oi]:si}},{key:'getHeight',value:function(){return this.element.scrollHeight}},{key:'render',value:function(){var ui,oi=this,si=Ao(this.props,['isOpen','delay','onOpened','onClosed']),ai=si.navbar,ni=si.className,li=si.cssModule,ri=si.tag,ii=lt(si,['navbar','className','cssModule','tag']),di=this.state,pi=di.collapse,ci=di.height;ui=pi===_r?'collapsing':pi===Or?'collapse show':pi===Er?'collapsing':pi===Pr?'collapse':'collapse';var gi=w(it(ni,ui,ai&&'navbar-collapse'),li),fi=null===ci?null:{height:ci};return g.createElement(ri,at({},ii,{style:at({},ii.style,fi),className:gi,ref:function(hi){oi.element=hi}}))}}]),ei}(Mr);Dr.propTypes=wr,Dr.defaultProps={isOpen:!1,tag:'div',delay:xr,onOpened:function(){},onClosed:function(){}};var Ar=g.PropTypes,Lr={tag:Ar.oneOfType([Ar.func,Ar.string]),active:Ar.bool,disabled:Ar.bool,color:Ar.string,action:Ar.bool,className:Ar.any},zr=function(ei){ei.preventDefault()},Ir=function(ei){var ti=ei.className,oi=ei.tag,si=ei.active,ai=ei.disabled,ni=ei.action,li=ei.color,ri=lt(ei,['className','tag','active','disabled','action','color']),ii=it(ti,!!si&&'active',!!ai&&'disabled',!!ni&&'list-group-item-action',!!li&&'list-group-item-'+li,'list-group-item');return ai&&(ri.onClick=zr),g.createElement(oi,at({},ri,{className:ii}))};Ir.propTypes=Lr,Ir.defaultProps={tag:'li'};var Rr=g.PropTypes,Br={tag:Rr.oneOfType([Rr.func,Rr.string]),className:Rr.any},Ur=function(ei){var ti=ei.className,oi=ei.tag,si=lt(ei,['className','tag']),ai=it(ti,'list-group-item-heading');return g.createElement(oi,at({},si,{className:ai}))};Ur.propTypes=Br,Ur.defaultProps={tag:'h5'};var Hr=g.PropTypes,qr={tag:Hr.oneOfType([Hr.func,Hr.string]),className:Hr.any},Fr=function(ei){var ti=ei.className,oi=ei.tag,si=lt(ei,['className','tag']),ai=it(ti,'list-group-item-text');return g.createElement(oi,at({},si,{className:ai}))};Fr.propTypes=qr,Fr.defaultProps={tag:'p'};var Vr=g.Component,Yr={UncontrolledAlert:kr,UncontrolledButtonDropdown:Ms,UncontrolledDropdown:ts,UncontrolledNavDropdown:ns,UncontrolledTooltip:$n};Object.keys(Yr).forEach(function(Qr){var ei=Yr[Qr],oi=function(si){function ai(ni){tt(this,ai);var li=rt(this,(ai.__proto__||Object.getPrototypeOf(ai)).call(this,ni));return li.state={isOpen:ei===kr},li.toggle=li.toggle.bind(li),li}return nt(ai,si),ot(ai,[{key:'toggle',value:function(){this.setState({isOpen:!this.state.isOpen})}},{key:'render',value:function(){return g.createElement(ei,at({isOpen:this.state.isOpen,toggle:this.toggle},this.props))}}]),ai}(Vr);oi.displayName=Qr,Yr[Qr]=oi});var $r=Yr.UncontrolledAlert,Xr=Yr.UncontrolledButtonDropdown,Kr=Yr.UncontrolledDropdown,Zr=Yr.UncontrolledNavDropdown,Jr=Yr.UncontrolledTooltip;d.Alert=kr,d.Container=gt,d.Row=bt,d.Col=Ot,d.Navbar=jt,d.NavbarBrand=St,d.NavbarToggler=Wt,d.Nav=Gt,d.NavItem=$t,d.NavDropdown=ns,d.NavLink=ds,d.Breadcrumb=gs,d.BreadcrumbItem=bs,d.Button=Ns,d.ButtonDropdown=Ms,d.ButtonGroup=ws,d.ButtonToolbar=As,d.Dropdown=ts,d.DropdownItem=Rs,d.DropdownMenu=Xo,d.DropdownToggle=qs,d.Fade=Ys,d.Badge=Zs,d.Card=ta,d.CardLink=Na,d.CardGroup=na,d.CardDeck=da,d.CardColumns=ga,d.CardBlock=ba,d.CardFooter=_a,d.CardHeader=wa,d.CardImg=Aa,d.CardImgOverlay=Ia,d.CardSubtitle=Ua,d.CardText=Fa,d.CardTitle=Xa,d.Popover=en,d.PopoverContent=pn,d.PopoverTitle=nn,d.Progress=On,d.Modal=xn,d.ModalHeader=Ln,d.ModalBody=Rn,d.ModalFooter=Hn,d.TetherContent=Go,d.Tooltip=$n,d.Table=Jn,d.ListGroup=sl,d.Form=rl,d.FormFeedback=cl,d.FormGroup=ml,d.FormText=vl,d.Input=Cl,d.InputGroup=El,d.InputGroupAddon=jl,d.InputGroupButton=Sl,d.Label=Hl,d.Media=Fl,d.Pagination=Xl,d.PaginationItem=Ql,d.PaginationLink=sr,d.TabContent=dr,d.TabPane=Je,d.Jumbotron=br,d.Collapse=Dr,d.ListGroupItem=Ir,d.ListGroupItemText=Fr,d.ListGroupItemHeading=Ur,d.UncontrolledAlert=$r,d.UncontrolledButtonDropdown=Xr,d.UncontrolledDropdown=Kr,d.UncontrolledNavDropdown=Zr,d.UncontrolledTooltip=Jr,Object.defineProperty(d,'__esModule',{value:!0})});
	//# sourceMappingURL=reactstrap.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(1061)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(497)(module)))

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppRoutes;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint-disable */
	var AppRoutes = (_AppRoutes = {
	  PROFILE_ROUTE: '/profile/profileInfo/:username',
	  CART: '/cart/',
	  THANK_YOU: '/thank-you/:orderId',
	  //? CBT ROUTE START HERE
	  CFA1_2024_CBT: '/cfa1/2026/cbt',
	  CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK: '/cfa1/2026/viewattemptedmock/:id/:timer',
	  CFA1_2024_CBT_INTRODUCTION: '/cfa1/2026/introduction/:id/:questiono/:timer',
	  CFA1_2024_CBT_QUESTIONS: '/cfa1/2026/cbtquestions/:id/:questiono/:timer/:testid/:offset/:isNegative/:timerStart',
	  CFA1_2024_CBT_QUESTION_FINISH: '/cfa1/2026/cbtquestionsfinish/:id/:questiono/:timer/:testid/:offset',
	  CFA1_2024_DETAILED_RESULT_GRAPH: '/cfa1/2026/cbtshowresult/:id/:test_id/:totalQuestions/:timer',
	  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-I (2024) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
	
	  CFA1_2025_NOTES: '/cfa1/2026/notes',
	  CFA1_2025_NOTES_READING_LIST: '/cfa1/2026/notes/chapter/:chapterId/reading-list',
	  CFA1_2025_NOTES_VIEW: '/cfa1/2026/notes/chapter/:chapterId/reading/:readingId/notes/:notesId/view',
	  CFA1_2025_NOTES_LIST: '/cfa1/2026/notes/chapter/:chapterId/reading/:readingId/notes-list',
	
	  //? QUIZ ROUTE START HERE
	  CFA1_2025_QUIZZES: '/cfa1/2026/quizzes',
	  CFA1_2025_QUIZ_BEFORE_START: '/cfa1/2026/beforestart(/:quiz_id)(/:status_send)',
	  CFA1_2025_QUIZ_BEGIN: '/cfa1/2026/beginquiz(/:quiz_id)(/:offset)',
	  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-I (2025) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
	  CFA1_2025_DASHBOARD: '/cfa1/2026/dashboard',
	  CFA1_2025_DASHBOARD_VIEW_QUESTIONS: '/cfa1/2026/viewallquestions',
	
	  CFA1_VIDEOS: '/cfa1/2026/videos',
	  CFA1_VIDEO_LIST: '/cfa1/2026/video/chapterId/:chapterId/list/:id'
	}, _defineProperty(_AppRoutes, 'CFA1_2025_NOTES_READING_LIST', '/cfa1/2026/notes/chapter/:chapterId/reading-list'), _defineProperty(_AppRoutes, 'CFA1_2025_QUESTION_BANK', '/cfa1/2026/question-bank'), _defineProperty(_AppRoutes, 'CFA1_2025_QUESTION_BANK_READING_LIST', '/cfa1/2026/question-bank/chapter/:chapterId/reading-list'), _defineProperty(_AppRoutes, 'CFA1_2025_QUESTIONS_LIST', '/cfa1/2026/question-bank/reading/:readingId/question-list'), _defineProperty(_AppRoutes, 'CFA1_2025_QUESTION_VIEW', '/cfa1/2026/question-bank/reading/:readingId/question/:questionId/view'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_DASHBOARD', '/cfa1/2027/dashboard'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_DASHBOARD_VIEW_QUESTIONS', '/cfa1/2027/viewallquestions'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_NOTES', '/cfa1/2027/notes'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_NOTES_READING_LIST', '/cfa1/2027/notes/chapter/:chapterId/reading-list'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_NOTES_VIEW', '/cfa1/2027/notes/chapter/:chapterId/reading/:readingId/notes/:notesId/view'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_NOTES_LIST', '/cfa1/2027/notes/chapter/:chapterId/reading/:readingId/notes-list'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_VIDEOS', '/cfa1/2027/videos'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_VIDEO_LIST', '/cfa1/2027/video/chapterId/:chapterId/list/:id'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUESTION_BANK', '/cfa1/2027/question-bank'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUESTION_BANK_READING_LIST', '/cfa1/2027/question-bank/chapter/:chapterId/reading-list'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUESTIONS_LIST', '/cfa1/2027/question-bank/reading/:readingId/question-list'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUESTION_VIEW', '/cfa1/2027/question-bank/reading/:readingId/question/:questionId/view'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUIZZES', '/cfa1/2027/quizzes'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUIZ_BEFORE_START', '/cfa1/2027/beforestart(/:quiz_id)(/:status_send)'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_QUIZ_BEGIN', '/cfa1/2027/beginquiz(/:quiz_id)(/:offset)'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_CBT', '/cfa1/2027/cbt'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_CBT_VIEW_ATTEMPTED_MOCK', '/cfa1/2027/viewattemptedmock/:id/:timer'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_CBT_INTRODUCTION', '/cfa1/2027/introduction/:id/:questiono/:timer'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_CBT_QUESTIONS', '/cfa1/2027/cbtquestions/:id/:questiono/:timer/:testid/:offset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_CBT_QUESTION_FINISH', '/cfa1/2027/cbtquestionsfinish/:id/:questiono/:timer/:testid/:offset'), _defineProperty(_AppRoutes, 'CFA1_2027_NEXT_DETAILED_RESULT_GRAPH', '/cfa1/2027/cbtshowresult/:id/:test_id/:totalQuestions/:timer'), _defineProperty(_AppRoutes, 'CFA2_CBT', '/cfa2/2026/cbt'), _defineProperty(_AppRoutes, 'CFA2_CBT_INTRODUCTION', '/cfa2/2026/introduction/:id/:questiono/:timer'), _defineProperty(_AppRoutes, 'CFA2_CBT_VIEW_ATTEMPTED_MOCK', '/cfa2/2026/viewattemptedmock/:id/:timer'), _defineProperty(_AppRoutes, 'CFA2_CBT_QUESTIONS', '/cfa2/2026/cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA2_CBT_QUESTIONS_FINISH', '/cfa2/2026/cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'), _defineProperty(_AppRoutes, 'CFA2_DETAILED_RESULT_GRAPH', '/cfa2/2026/cbtshowresult/:id/:test_id/:totalQuestions/:timer/:isNegative'), _defineProperty(_AppRoutes, 'CFA2_2025_DASHBOARD', '/cfa2/2026/dashboard'), _defineProperty(_AppRoutes, 'CFA2_2025_NOTES', '/cfa2/2026/notes'), _defineProperty(_AppRoutes, 'CFA2_2025_NOTES_READINGS', '/cfa2/2026/notesreadings/:chapter'), _defineProperty(_AppRoutes, 'CFA2_2025_NOTES_QUES_VIEW', '/cfa2/2026/notesviewques/:chapter_no/:id/:reading'), _defineProperty(_AppRoutes, 'CFA2_2025_BEGIN_NOTES', '/cfa2/2026/beginnotes/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'CFA2_2025_VIDEO_DISPLAY', '/cfa2/2026/videodisplay/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'CFA2_2025_VIDEO_LESSONS', '/cfa2/2026/videolessons'), _defineProperty(_AppRoutes, 'CFA2_2026_VIDEOS', '/cfa2/2026/videos'), _defineProperty(_AppRoutes, 'CFA2_2026_VIDEOS_LIST', '/cfa2/2026/video/list/:chapterId/:id'), _defineProperty(_AppRoutes, 'CFA2_2025_QUESTION_BANK', '/cfa2/2026/questionbank'), _defineProperty(_AppRoutes, 'CFA2_2025_QUESTION_BANK_CASES', '/cfa2/2026/cases/:id/:chapter_name/:total_cases'), _defineProperty(_AppRoutes, 'CFA2_2025_QUESTION_BANK_CASES_QUESTION', '/cfa2/2026/chapter/:chapterid/:caseid/:case_offset/:question_number/:offset'), _defineProperty(_AppRoutes, 'CFA2_2025_QUIZZES', '/cfa2/2026/quizzes'), _defineProperty(_AppRoutes, 'CFA2_2025_QUIZZES_BEFORE_START', '/cfa2/2026/beforestart(/:quiz_id)(/:status_send)'), _defineProperty(_AppRoutes, 'CFA2_2025_QUIZZES_BEGIN', '/cfa2/2026/beginquiz(/:quiz_id)(/:offset)'), _defineProperty(_AppRoutes, 'CFA2_2027_DASHBOARD', '/cfa2/2027/dashboard'), _defineProperty(_AppRoutes, 'CFA2_2027_NOTES', '/cfa2/2027/notes'), _defineProperty(_AppRoutes, 'CFA2_2027_NOTES_READINGS', '/cfa2/2027/notesreadings/:chapter'), _defineProperty(_AppRoutes, 'CFA2_2027_NOTES_QUES_VIEW', '/cfa2/2027/notesviewques/:chapter_no/:id/:reading'), _defineProperty(_AppRoutes, 'CFA2_2027_BEGIN_NOTES', '/cfa2/2027/beginnotes/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'CFA2_2027_VIDEO_DISPLAY', '/cfa2/2027/videodisplay/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'CFA2_2027_VIDEO_LESSONS', '/cfa2/2027/videolessons'), _defineProperty(_AppRoutes, 'CFA2_2027_QUESTION_BANK', '/cfa2/2027/questionbank'), _defineProperty(_AppRoutes, 'CFA2_2027_QUESTION_BANK_CASES', '/cfa2/2027/cases/:id/:chapter_name/:total_cases'), _defineProperty(_AppRoutes, 'CFA2_2027_QUESTION_BANK_CASES_QUESTION', '/cfa2/2027/chapter/:chapterid/:caseid/:case_offset/:question_number/:offset'), _defineProperty(_AppRoutes, 'CFA2_2027_QUIZZES', '/cfa2/2027/quizzes'), _defineProperty(_AppRoutes, 'CFA2_2027_QUIZZES_BEFORE_START', '/cfa2/2027/beforestart(/:quiz_id)(/:status_send)'), _defineProperty(_AppRoutes, 'CFA2_2027_QUIZZES_BEGIN', '/cfa2/2027/beginquiz(/:quiz_id)(/:offset)'), _defineProperty(_AppRoutes, 'CFA2_2027_CBT', '/cfa2/2027/cbt'), _defineProperty(_AppRoutes, 'CFA2_2027_CBT_INTRODUCTION', '/cfa2/2027/introduction/:id/:questiono/:timer'), _defineProperty(_AppRoutes, 'CFA2_2027_CBT_VIEW_ATTEMPTED_MOCK', '/cfa2/2027/viewattemptedmock/:id/:timer'), _defineProperty(_AppRoutes, 'CFA2_2027_CBT_QUESTIONS', '/cfa2/2027/cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA2_2027_CBT_QUESTIONS_FINISH', '/cfa2/2027/cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'), _defineProperty(_AppRoutes, 'CFA2_2027_DETAILED_RESULT_GRAPH', '/cfa2/2027/cbtshowresult/:id/:test_id/:totalQuestions/:timer/:isNegative'), _defineProperty(_AppRoutes, 'CFA2_2027_VIDEOS', '/cfa2/2027/videos'), _defineProperty(_AppRoutes, 'CFA2_2027_VIDEOS_LIST', '/cfa2/2027/video/list/:chapterId/:id'), _defineProperty(_AppRoutes, 'CFA3_DASHBOARD', '/cfa3/dashboard'), _defineProperty(_AppRoutes, 'CFA3_NOTES', '/cfa3/notes'), _defineProperty(_AppRoutes, 'CFA3_VIDEO_LESSONS', '/cfa3_videolessons'), _defineProperty(_AppRoutes, 'CFA3_VIDEO_DISPLAY', '/cfa3_video_display/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'CFA3_QUESTION_BANK', '/cfa3/questionBank'), _defineProperty(_AppRoutes, 'CFA3_ESSAY_QUESTION', '/cfa3/essay-question'), _defineProperty(_AppRoutes, 'CFA3_ESSAY_QUESTION_CASES', '/cfa3/essay-question/cases/:chapterID/:chapterName'), _defineProperty(_AppRoutes, 'CFA3_ESSAY_QUESTION_CHAPTERS', '/cfa3/essay-question/chapters'), _defineProperty(_AppRoutes, 'CFA3_ESSAY_QUESTION_CASE_VIEW', '/cfa3/essay-question/case-view/:caseId/:chapterID/:chapterName/:questionIndex/:caseIndex'), _defineProperty(_AppRoutes, 'CFA3_QUIZZES', '/cfa3/quizzes'), _defineProperty(_AppRoutes, 'CFA3_CBT', '/cfa3/cbt'), _defineProperty(_AppRoutes, 'CFA3_CBT_QUESTIONS', '/cfa3/cbt/questions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA3_CBT_QUESTIONS_FINISH', '/cfa3/cbt/questionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'), _defineProperty(_AppRoutes, 'CFA3_CBT_INTRODUCTION', '/cfa3/cbt/introduction/:id/:questiono/:timer'), _defineProperty(_AppRoutes, 'CFA3_CBT_DETAILED_RESULT_GRAPH', '/cfa3/cbt/showresult/:id/:test_id/:totalQuestions/:totalMarks/:timer/:isNegative'), _defineProperty(_AppRoutes, 'CFA3_CBT_VIEW_ATTEMPTED_MOCK', '/cfa3/cbt/viewattemptedmock/:id/:timer'), _defineProperty(_AppRoutes, 'CFA3_CBT_GRADE_QUESTIONS', '/cfa3/cbt/gradeQuestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT', '/pathway'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_SESSION', '/cfa3/pathway/:pathway/session'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK', '/cfa3/pathway/:pathway/session/:session/attempted_mock/:timer'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT_INTRODUCTION', '/cfa3/pathway/:pathway/session/:session/introduction/:questiono/:timer'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT_QUESTIONS', '/cfa3/pathway/:pathway/session/:session/questions/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT_QUESTIONS_FINISH', '/cfa3/pathway/finish/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT_DETAILED_RESULT_GRAPH', '/cfa3/pathway/result/:test_id/:totalQuestions/:totalMarks/:timer/:isNegative'), _defineProperty(_AppRoutes, 'CFA3_PATHWAY_CBT_GRADE_QUESTIONS', '/cfa3/pathway/grade_questions/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart'), _defineProperty(_AppRoutes, 'CFA3_2025_QUESTION_BANK_READING_LIST', 'cfa3/cases/:id/:chapter_name/:total_cases'), _defineProperty(_AppRoutes, 'ESG_DASHBOARD', '/esg/dashboard'), _defineProperty(_AppRoutes, 'ESG_NOTES', '/esg/notes'), _defineProperty(_AppRoutes, 'ESG_VIDEOS', '/esg/videos'), _defineProperty(_AppRoutes, 'ESG_VIDEO_LESSON', '/esg/videos/chapters/:chapter/:index'), _defineProperty(_AppRoutes, 'ESG_QUESTION_BANK', '/esg/question-bank/chapter'), _defineProperty(_AppRoutes, 'ESG_QUESTION_BANK_VIEW_QUE', '/esg/question-bank/chapter/:chapterId/question/:id/index/:index'), _defineProperty(_AppRoutes, 'ESG_QUESTION_BANK_LIST_QUE', '/esg/question-bank/chapter/:listId/questions'), _defineProperty(_AppRoutes, 'ESG_QUIZZES', '/esg/quizzes'), _defineProperty(_AppRoutes, 'ESG_CBT', '/esg/cbt'), _defineProperty(_AppRoutes, 'ESG_CBT_INTRODUCTION', '/esg/cbt/mock/:id/duration/:timer/introduction/index/:offset'), _defineProperty(_AppRoutes, 'ESG_CBT_VIEW_ATTEMPTED_MOCK', '/esg/cbt/mock/:id/duration/:timer/attempted-mock'), _defineProperty(_AppRoutes, 'ESG_CBT_DETAILED_STATS_GRAPH', '/esg/cbt/mock/:id/test/:testId/duration/:timer/showresult/total-questions/:totalQuestions/total-marks/:totalMarks'), _defineProperty(_AppRoutes, 'ESG_CBT_FINISH_PAGE', '/esg/cbt/mock/:mockId/test/:testId/duration/:timer/finish-test/question/:questionId/index/:offset'), _defineProperty(_AppRoutes, 'ESG_CBT_QUESTIONS', '/esg/cbt/mock/:mockId/test/:testId/duration/:timer/question/:questionId/negative-start/:isNegative/index/:offset'), _defineProperty(_AppRoutes, 'FRM_DASHBOARD', '/frm/dashboard'), _defineProperty(_AppRoutes, 'FRM_NOTES', '/frm/notes'), _defineProperty(_AppRoutes, 'FRM_VIDEO_LESSONS', '/frm/videoLessons'), _defineProperty(_AppRoutes, 'FRM_QUESTION_BANK', '/frm/questionbank'), _defineProperty(_AppRoutes, 'FRM_QUIZZES', '/frm/quiz'), _defineProperty(_AppRoutes, 'FRM_CBT', '/frm/cbt'), _defineProperty(_AppRoutes, 'FRM_DETAILED_RESULT_GRAPH', '/frm/cbtshowresult/:id/:test_id/:totalQuestions/:level/:timer'), _defineProperty(_AppRoutes, 'FRM_V2_QUESTION_BANK', '/frm/v2/question-bank'), _defineProperty(_AppRoutes, 'FRM_V2_QUESTION_BANK_READING_LIST', '/frm/v2/question-bank/level/:level/chapter/:chapterId/reading-list'), _defineProperty(_AppRoutes, 'FRM_V2_QUESTION_BANK_QUESTION_LIST', '/frm/v2/question-bank/level/:level/reading/:readingId/question-list'), _defineProperty(_AppRoutes, 'FRM_V2_QUESTION_BANK_QUESTION_VIEW', '/frm/v2/question-bank/level/:level/reading/:readingId/question/:questionId/view'), _defineProperty(_AppRoutes, 'FRM_QUESTION_BANK_VIEW_QUESTION', '/frm/chapter/:notesid/:readingid/:id/:level/:offset'), _defineProperty(_AppRoutes, 'FRM_V2_NOTES', '/frm/v2/notes'), _defineProperty(_AppRoutes, 'FRM_V2_NOTES_READING_LIST', '/frm/v2/notes/level/:level/chapter/:chapterId/reading-list'), _defineProperty(_AppRoutes, 'FRM_V2_NOTES_VIEW', '/frm/v2/notes/level/:level/chapter/:chapterId/reading/:readingId/notes/:notesId/view'), _defineProperty(_AppRoutes, 'FRM_V2_DASHBOARD', '/frm/v2/dashboard'), _defineProperty(_AppRoutes, 'FRM_V2_DETAILS_STATS_LEVEL1', '/frm/viewallquestions'), _defineProperty(_AppRoutes, 'FRM_V2_DETAILS_STATS_LEVEL2', '/frm/2/viewallquestions'), _defineProperty(_AppRoutes, 'FRM_VIDEOS', '/frm/v2/videos'), _defineProperty(_AppRoutes, 'FRM_V2_VIDEOS_PLAYLIST', '/frm/v2/videos/playlist/level/:level/chapter/:chapterId/:id'), _defineProperty(_AppRoutes, 'FRM_V2_VIDEOS_MOCK_PLAYLIST', '/frm/v2/videos/playlist/level/:level/mock/:mockId/:id'), _defineProperty(_AppRoutes, 'FRM_V2_CBT_FINISH_PAGE', '/frm/cbtquestionsfinish/:id/:questiono/:timer/:level/:testid/:offset'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_DASHBOARD', '/soa/probability/dashboard'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_NOTES', '/soa/probability/notes'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_NOTES_READING', '/soa/probability/notesreadings(/:chapter)'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_VIDEO_LESSONS', '/soa/probability/video-lessons'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_VIDEO_DISPLAY', '/soa/probability/video-display/:id/:showFreePremium/:chapterId/:index'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_READING', '/soa/probability/readings(/:chapter)(/:chapterName)'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_QUESTION_BANK', '/soa/probability/questionbank'), _defineProperty(_AppRoutes, 'SOA_PROBABILITY_QUIZZES', '/soa/probability/quizzes'), _defineProperty(_AppRoutes, 'SOA_FINANCIAL_MATHMATICS_DASHBOARD', '/soa/financialmathematics/dashboard'), _defineProperty(_AppRoutes, 'SOA_FINANCIAL_MATHMATICS_NOTES', '/soa/financialmathematics/notes'), _defineProperty(_AppRoutes, 'SOA_FINANCIAL_MATHMATICS_VIDEO_LESSONS', '/soa/financialmathematics/videolessons'), _defineProperty(_AppRoutes, 'SOA_FINANCIAL_MATHMATICS_QUESTION_BANK', '/soa/financialmathematics/questionbank'), _defineProperty(_AppRoutes, 'SOA_FINANCIAL_MATHMATICS_QUIZZES', '/soa/financialmathematics/quizzes'), _defineProperty(_AppRoutes, 'GMAT_DASHBOARD', '/gmat_dashboard'), _defineProperty(_AppRoutes, 'GMAT_VIDEO_DISPLAY', '/gmatvideodisplay/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'GMAT_VIDEO_LESSONS', '/gmatvideolessons'), _defineProperty(_AppRoutes, 'GMAT_QUESTION_BANK', '/gmat_questionbank'), _defineProperty(_AppRoutes, 'GMAT_QUESTION_BANK_READING', '/gmat_readings/:id'), _defineProperty(_AppRoutes, 'GMAT_QUESTION_BANK_LIST_QUE', '/gmat_viewquestions/:chapter_no/:id/:subscriptionstatus/:reading'), _defineProperty(_AppRoutes, 'GMAT_QUESTION_BANK_VIEW_QUE', '/gmat_beginchapter/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'GMAT_BEGINCASE', '/gmat_begincase/:chapterid/:readingid/:caseid/:case_offset/:subscription/:question_number/:offset'), _defineProperty(_AppRoutes, 'GMAT_TAB', '/GMATTab/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'GMAT_GRAPH_MULTI_STATEMENT', '/GMATMultipleStatement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'GMAT_TABLE', '/GMATTable/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'GMAT_TWO_PART_STATEMENT', '/GMAT2Statement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'PRACTICE_EXAM', '/practice_exam'), _defineProperty(_AppRoutes, 'GMAT_QUIZZES', '/gmat_quiz'), _defineProperty(_AppRoutes, 'GMAT_QUIZZES_BEFORE_START', '/gmat_beforestart/:quiz_id/:status_send'), _defineProperty(_AppRoutes, 'GMAT_QUIZZES_BEGIN', '/gmat_beginquiz_tab/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'BEGIN_QUIZ', '/gmat_beginquiz/:quiz_id/:offset/:timer'), _defineProperty(_AppRoutes, 'BEGIN_CASE_QUIZ', '/gmat_beginquiz_case/:quiz_id/:offset/:type/:case/:timer'), _defineProperty(_AppRoutes, 'BEGIN_TABLE_QUIZ', '/gmat_beginquiz_table/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'BEGIN_GRAPH_QUIZ', '/gmat_beginquiz_graph/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'BEGIN_TWOPART_QUIZ', '/gmat_beginquiz_twopart/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'EA_DASHBOARD', '/ea_dashboard'), _defineProperty(_AppRoutes, 'EA_VIDEO_DISPLAY', '/eavideodisplay/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'EA_VIDEO_LESSONS', '/eavideolessons'), _defineProperty(_AppRoutes, 'EA_BEFORE_START', '/ea_beforestart/:quiz_id/:status_send'), _defineProperty(_AppRoutes, 'EA_BEGIN_QUIZ', '/ea_beginquiz/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'EA_BEGIN_CASE_QUIZ', '/ea_beginquiz_case/:quiz_id/:offset/:type/:case/:timer'), _defineProperty(_AppRoutes, 'EA_BEGIN_TAB_QUIZ', '/ea_beginquiz_tab/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'EA_BEGIN_TABLE_QUIZ', '/ea_beginquiz_table/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'EA_BEGIN_GRAPH_QUIZ', '/ea_beginquiz_graph/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'EA_BEGIN_TWOPART_QUIZ', '/ea_beginquiz_twopart/:quiz_id/:offset/:type/:timer'), _defineProperty(_AppRoutes, 'EA_QUESTION_BANK', '/ea_questionbank'), _defineProperty(_AppRoutes, 'VIEW_EA_QUESTION', '/ea_viewquestions/:chapter_no/:id/:subscriptionstatus/:reading'), _defineProperty(_AppRoutes, 'EA_READING', '/ea_readings/:id'), _defineProperty(_AppRoutes, 'EA_BEGINCHAPTER', '/ea_beginchapter/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'EA_BEGINCASE', '/ea_begincase/:chapterid/:readingid/:caseid/:case_offset/:subscription/:question_number/:offset'), _defineProperty(_AppRoutes, 'EA_TAB', '/EATab/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'EA_GRAPH_MULTI_STATEMENT', '/EAMultipleStatement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'EA_TABLE', '/EATable/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'EA_TWO_PART_STATEMENT', '/EA2Statement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading'), _defineProperty(_AppRoutes, 'EA_QUIZZES', '/ea_quiz'), _defineProperty(_AppRoutes, 'DASHBOARD', '/dashboard'), _defineProperty(_AppRoutes, 'CFA_2022_DASHBOARD', '/cfa1/dashboard_2022'), _defineProperty(_AppRoutes, 'CFA2_DASHBOARD', '/cfa2_dashboard'), _defineProperty(_AppRoutes, 'SOAIFM_DASHBOARD', '/soa/investmentmarkets/dashboard'), _defineProperty(_AppRoutes, 'NOTES', '/cfanotes'), _defineProperty(_AppRoutes, 'NOTES_2022', '/cfa1/cfa_2022_notes'), _defineProperty(_AppRoutes, 'NOTES_READINGS_2022', '/cfa1/notesreadings_2022/:chapter'), _defineProperty(_AppRoutes, 'NOTES_VIEW_QUES_2022', '/cfa1/notesviewques_2022/:id/:reading/:chapter_no'), _defineProperty(_AppRoutes, 'NOTES_BEGIN_2022', '/cfa1/beginnotes_2022/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'SOAIFM_NOTES', '/soa/investmentmarkets/notes'), _defineProperty(_AppRoutes, 'CFA3_NOTES_READINGS', '/cfa3_notes_readings/:chapter'), _defineProperty(_AppRoutes, 'CFA3_NOTES_VIEWQUES', '/cfa3_notes_viewques/:chapter_no/:id/:reading'), _defineProperty(_AppRoutes, 'CFA3_BEGIN_NOTES', '/cfa3_beginnotes/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'CFA2_BEGIN_NOTES', '/cfa2_beginnotes/:notesid/:id/:offset'), _defineProperty(_AppRoutes, 'CFA2NOTESVIEWQUES', '/cfa2notesviewques/:chapter_no/:id/:reading'), _defineProperty(_AppRoutes, 'CFA2Notes', '/cfa2_notes'), _defineProperty(_AppRoutes, 'CFA2BEGINNOTES', '/cfa2beginnotes/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'CFA2NOTESREADINGS', '/cfa2notesreadings/:chapter'), _defineProperty(_AppRoutes, 'CFA2VIDEODISPLAY', '/cfa2videodisplay/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'CFA2_VIDEODISPLAY', '/cfa2videodisplay/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'VIDEO_DISPLAY_2022', '/cfavideodisplay_2022/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'VIDEO_LESSONS', '/cfavideolessons'), _defineProperty(_AppRoutes, 'VIDEO_LESSONS_2022', '/cfavideolessons_2022'), _defineProperty(_AppRoutes, 'FLOW_PLAYER_VIDEO_LESSONS_2022', '/cfa1/new_cfavideolessons_2022'), _defineProperty(_AppRoutes, 'FLOW_PLAYER_VIDEO_DISPLAY_2022', '/cfa1/new_cfavideodisplay_2022/:id/:showFreePremium/:type/:chapter_id/:index'), _defineProperty(_AppRoutes, 'CFA2_VIDEO_LESSONS', '/cfa2_videolessons'), _defineProperty(_AppRoutes, 'QUESTION_BANK', '/questionbank'), _defineProperty(_AppRoutes, 'QUESTION_BANK_2022', '/cfa1/questionbank_2022'), _defineProperty(_AppRoutes, 'VIEW_QUESTION_2022', '/cfa1/viewquestions_2022/:chapter_no/:id/:subscriptionstatus/:reading'), _defineProperty(_AppRoutes, 'READING_2022', '/cfa1/readings_2022/:id'), _defineProperty(_AppRoutes, 'BEGINCHAPTER_2022', '/cfa1/beginchapter_2022/:notesid/:readingid/:id/:offset'), _defineProperty(_AppRoutes, 'CFA2_QUESTION_BANK', '/cfa2_questionBank'), _defineProperty(_AppRoutes, 'CFA2_QUESTION_BANK_2022', '/cfa2/questionBank_2022'), _defineProperty(_AppRoutes, 'SOAIFM_QUESTION_BANK', '/soa/investmentmarkets/questionbank'), _defineProperty(_AppRoutes, 'CFA2_CASES', '/cfa2_cases/:id/:chapter_name/:total_cases'), _defineProperty(_AppRoutes, 'QUIZZES', '/cfa1/quizzes'), _defineProperty(_AppRoutes, 'CFA2_QUIZZES', '/cfa2/quizzes'), _defineProperty(_AppRoutes, 'SOAIFM_QUIZZES', '/soa/investmentmarkets/quizzes'), _defineProperty(_AppRoutes, 'CBT', '/cfa1/cfacbt'), _defineProperty(_AppRoutes, 'Tutor', '/tutor'), _defineProperty(_AppRoutes, 'SUBSCRIBE', '/subscribe'), _defineProperty(_AppRoutes, 'CFADETAILEDRESULTGRAPH', '/cfa1/cbtshowresult/:id/:test_id/:totalQuestions/:timer'), _defineProperty(_AppRoutes, 'RECURRING_PLAN_DETAILS', '/recurring-plan-detail(/:selectedMenu)(/:username)'), _defineProperty(_AppRoutes, 'SUBSCRIPTION_DETAILS', '/subscriptiondetail(/:selectedMenu)(/:username)'), _defineProperty(_AppRoutes, 'CFA3_DASHBOARD_2025', '/cfa3/2025/dashboard'), _defineProperty(_AppRoutes, 'VIDEOS', '/videos'), _defineProperty(_AppRoutes, 'VIDEOS_LIST', '/videos/list/:chapterId/:id'), _AppRoutes);
	exports.default = AppRoutes;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXAMS_WITH_IDS = exports.FRM_LEVELS = exports.EXAM_MAPPING = exports.QUESTION_MODE_OPTIONS = exports.EXAM_NAMES = exports.QUESTION_MODE = exports.TABLE_NAME = exports.QUESTION_TYPE = exports.SUBSCRIPTION_STATUS = exports.CHOICE_KEYS = exports.CHOICE_MAPPING = exports.CAPSULE_VIDEO_ID = exports.EXAM_PACKAGE_IDS = exports.getActiveExams = exports.REDIRECTION_ROUTES = exports.SECTION_NAMES = exports.Y_AXIS_SCALES = exports.SUBSCRIPTION_TYPES = exports.mergeTwoSortedArrayDataById = exports.getTokenWithEmail = exports.GMATExamList = exports.ActuarialExamList = exports.FRMExamList = exports.CFAExamList = exports.localStorageKeys = exports.examObject = exports.examNameAccordingToDB = exports.ANALYSTPREP_LOGO = exports.ADMIN_PROFILE_BASE_URL = exports.S3_BASE_URL = exports.routeExamName = exports.ROLES = exports.menuItems = exports.examNames = exports.DIVISOR_FOR_CASES = exports.GTMUserInfo = exports.GA4PaymentFailed = exports.GTMPaymentFailed = exports.GA4AddPaymentInfo = exports.GTMAddPaymentInfo = exports.GA4Purchase = exports.GTMPurchaseCompleted = exports.GA4SignUp = exports.GTMSignUp = exports.GA4BeginCheckout = exports.GTMStartPayment = exports.Currency = exports.GA4AddToCart = exports.GtmAddToCart = exports.GTM_ID = exports.specialChars = exports.OperatorExpression = exports.operationCyphers = exports.buttonCyphers = exports.tabActionButtonStyles = exports.lengthCheck = exports.canvasjsConfig = exports.flowPlayerVideoDisplayUrl = exports.flowPlayerVideoLessonUrl = exports.frmOptionsArr = exports.filterObj = exports.SecondsToMMSS = exports.SecondsToHHMMSS = exports.pad = exports.CFA_UNLIMITED_PLUS_PACKAGE_ID = exports.SHOW_CFA_UNLIMITED_PLUS = exports.optionsArr = exports.defaultDateFormat = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _menuItems, _examObject;
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable */
	
	
	var defaultDateFormat = exports.defaultDateFormat = 'YYYY-MM-DD';
	var optionsArr = exports.optionsArr = ['choice_a', 'choice_b', 'choice_c'];
	
	/**
	 * Feature flag — hide the CFA Unlimited+ package (#216, exam_plans.id = 78) from
	 * the purchase flow and subscription-detail view until the launch. Flipping this
	 * to `true` re-enables the Plus card on `/subscribe/selectPackage/cfa/1` and the
	 * "CFA Unlimited+ Package" label on `/subscriptiondetail`.
	 *
	 * Backend entitlements (webinar access, ownership checks, WooCommerce webhook)
	 * stay active regardless — this flag only controls the marketing surface.
	 */
	var SHOW_CFA_UNLIMITED_PLUS = exports.SHOW_CFA_UNLIMITED_PLUS = true;
	var CFA_UNLIMITED_PLUS_PACKAGE_ID = exports.CFA_UNLIMITED_PLUS_PACKAGE_ID = 78;
	var pad = exports.pad = function pad(num) {
	  return ('0' + num).slice(-2);
	};
	var SecondsToHHMMSS = exports.SecondsToHHMMSS = function SecondsToHHMMSS(sec) {
	  var hours = Math.floor(sec / (60 * 60));
	
	  var divisorForMinutes = sec % (60 * 60);
	  var minutes = Math.floor(divisorForMinutes / 60);
	
	  var divisorForSeconds = divisorForMinutes % 60;
	  var seconds = Math.ceil(divisorForSeconds);
	  return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
	};
	var SecondsToMMSS = exports.SecondsToMMSS = function SecondsToMMSS(sec) {
	  Math.floor(sec / (60 * 60));
	
	  var divisorForMinutes = sec % (60 * 60);
	  var minutes = Math.floor(divisorForMinutes / 60);
	
	  var divisorForSeconds = divisorForMinutes % 60;
	  var seconds = Math.ceil(divisorForSeconds);
	  return pad(minutes) + ':' + pad(seconds);
	};
	var filterObj = exports.filterObj = ['Unattempted', 'Attempted', 'Flagged'];
	var frmOptionsArr = exports.frmOptionsArr = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	var flowPlayerVideoLessonUrl = exports.flowPlayerVideoLessonUrl = function flowPlayerVideoLessonUrl(url_id_qq) {
	  return 'https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + url_id_qq + '.jpg';
	};
	// graph constants
	var flowPlayerVideoDisplayUrl = exports.flowPlayerVideoDisplayUrl = function flowPlayerVideoDisplayUrl(url_id_qq) {
	  return '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + url_id_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef';
	};
	var canvasjsConfig = exports.canvasjsConfig = {
	  axisY: {
	    includeZero: false,
	    valueFormatString: ' ',
	    stripLines: [{
	      color: 'hsl(180deg 1% 83%)',
	      startValue: 70,
	      endValue: 70.5,
	      label: '70%',
	      labelFontColor: 'black',
	      labelFontSize: 15,
	      labelBackgroundColor: '#ffffff'
	    }, {
	      color: 'hsl(180deg 1% 83%)',
	      startValue: 50,
	      endValue: 50.5,
	      label: '50%',
	      labelFontColor: 'black',
	      labelFontSize: 15,
	      labelBackgroundColor: '#ffffff'
	    }],
	    gridThickness: 0,
	
	    tickLength: 0,
	    labelAutoFit: true,
	    interval: 10,
	    labelFontFamily: "'Roboto', sans-serif"
	  },
	
	  toolTip: { enabled: false },
	  axisX: {
	    gridThickness: 0,
	    valueFormatString: ' ',
	    labelFontSize: 15,
	    labelFontColor: '#000000',
	    labelAutoFit: true,
	    labelMaxWidth: 175,
	    labelWrap: true,
	    dataPointWidth: 90,
	    dataPointMaxWidth: 90,
	    dataPointMinWidth: 90,
	    labelAngle: 0,
	    interval: 1,
	    tickLength: 15,
	    tickColor: '#fff',
	    // dataPointWidth: 50,
	    labelFontFamily: "'Roboto', sans-serif"
	  }
	};
	var lengthCheck = exports.lengthCheck = {
	  ZERO: 0,
	  HUNDRED: 100,
	  ONE_HUNDRED_FIFTY: 150
	};
	var tabActionButtonStyles = exports.tabActionButtonStyles = {
	  edit: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	  delete: 'fa fa-trash mark-action-btn-dashboard',
	  viewFeedback: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	  view: 'fa fa-eye mark-action-btn-dashboard',
	  primaryColor: '#1f8ceb',
	  deleteColor: '#f51a00'
	};
	// calculator constants
	var buttonCyphers = exports.buttonCyphers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
	
	var operationCyphers = exports.operationCyphers = ['-', '+', '/', 'x', '.', '√', '%', '+/-'];
	// eslint-disable-next-line
	var OperatorExpression = exports.OperatorExpression = /\+|\*|\-|\/|\%/;
	var specialChars = exports.specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	
	// Google tag Manager and GA4
	var GTM_ID = exports.GTM_ID = 'GTM-KF7B5DD';
	var GtmAddToCart = exports.GtmAddToCart = 'addToCart';
	var GA4AddToCart = exports.GA4AddToCart = 'add_to_cart';
	var Currency = exports.Currency = 'USD';
	var GTMStartPayment = exports.GTMStartPayment = 'startPayment';
	var GA4BeginCheckout = exports.GA4BeginCheckout = 'begin_checkout';
	var GTMSignUp = exports.GTMSignUp = 'signup';
	var GA4SignUp = exports.GA4SignUp = 'sign_up';
	var GTMPurchaseCompleted = exports.GTMPurchaseCompleted = 'purchaseCompleted';
	var GA4Purchase = exports.GA4Purchase = 'purchase';
	var GTMAddPaymentInfo = exports.GTMAddPaymentInfo = 'addPaymentInfo';
	var GA4AddPaymentInfo = exports.GA4AddPaymentInfo = 'add_payment_info';
	var GTMPaymentFailed = exports.GTMPaymentFailed = 'paymentFailed';
	var GA4PaymentFailed = exports.GA4PaymentFailed = 'payment_failed';
	var GTMUserInfo = exports.GTMUserInfo = 'userInfo';
	var DIVISOR_FOR_CASES = exports.DIVISOR_FOR_CASES = 6;
	
	// Show the year-suffixed label only on localhost + the qfix dev env (where the
	// 2027 preview is being staged). Production keeps the plain "CFA Level I" label.
	// const CFA_LEVEL_I = isDevEnv ? 'CFA Level I - 2026' : 'CFA Level I';
	var CFA_LEVEL_I = 'CFA Level I';
	var CFA_LEVEL_II = 'CFA Level II';
	var CFA_LEVEL_III = 'CFA Level III';
	var CFA_LEVEL_I_2026 = 'CFA Level I - 2026';
	var CFA_LEVEL_I_2027 = 'CFA Level I - 2027';
	var CFA_LEVEL_II_2026 = 'CFA Level II - 2026';
	var CFA_LEVEL_II_2027 = 'CFA Level II - 2027';
	// const CFA_LEVEL_III_2026 = 'CFA Level III 2026';
	
	// the logic unifying and combining cfa exams;
	// cfa_2026 --> cfa_2025
	// cfa_2_2026 --> cfa_2_2025
	// cfa_3_2026 --> cfa_3_2025
	
	var examNames = exports.examNames = {
	  // 2027 is open to all users, so the 2026 edition must show the year suffix too — otherwise the
	  // header/dropdown can't tell "CFA Level I - 2026" apart from "CFA Level I - 2027". All three 2026
	  // CFA1 codes (bare cfa, cfa_2025 = the dropdown value for 2026, cfa_2026) get the "- 2026" label.
	  cfa: CFA_LEVEL_I_2026,
	  cfa_2025: CFA_LEVEL_I_2026,
	  cfa_2026: CFA_LEVEL_I_2026,
	  cfa_2027: CFA_LEVEL_I_2027,
	  cfa_2: CFA_LEVEL_II,
	  cfa_2_2025: CFA_LEVEL_II_2026,
	  cfa_2_2026: CFA_LEVEL_II_2026,
	  cfa_2_2027: CFA_LEVEL_II_2027,
	  cfa_3: CFA_LEVEL_III,
	  cfa_3_2025: CFA_LEVEL_III,
	  // cfa_3_2026: CFA_LEVEL_III_2026,
	  cfa_3_2026: CFA_LEVEL_III,
	  frm: 'FRM Part I & II',
	  soa_p: 'Actuarial - P (Probability)',
	  soa_fm: 'Actuarial - FM (Financial Mathematics)',
	  gmat: 'GMAT Focus',
	  gmat_focus: 'GMAT Focus',
	  ea: 'Executive Assessment',
	  esg: 'ESG'
	};
	
	var gmat = examNames.gmat;
	var menuItems = exports.menuItems = (_menuItems = {}, _defineProperty(_menuItems, gmat, {
	  localStorageKey: 'gmat',
	  activeState: 'gmatActive',
	  routePath: _AppRoutes2.default.GMAT_DASHBOARD,
	  selectedMenuKey: 'selectedmenugmat'
	}), _defineProperty(_menuItems, 'Executive Assessment', {
	  localStorageKey: 'ea',
	  activeState: 'EActive',
	  routePath: _AppRoutes2.default.EA_DASHBOARD,
	  selectedMenuKey: 'selectedmenuEA'
	}), _defineProperty(_menuItems, 'CFA Level I', {
	  localStorageKey: 'cfa_2024',
	  activeState: 'cfa1_2024_Active',
	  routePath: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  selectedMenuKey: 'selectedmenucfa2024'
	}), _defineProperty(_menuItems, 'CFA Level II 2025', {
	  localStorageKey: 'cfa_2_2025',
	  activeState: 'cfa22025Active',
	  routePath: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	  selectedMenuKey: 'selectedmenucfa_2'
	}), _defineProperty(_menuItems, 'CFA Level III', {
	  localStorageKey: 'cfa_3',
	  activeState: 'cfa3Active',
	  routePath: _AppRoutes2.default.CFA3_DASHBOARD,
	  selectedMenuKey: 'selectedmenucfa_3'
	}), _defineProperty(_menuItems, 'FRM Part I & II', {
	  localStorageKey: 'frm',
	  activeState: 'frmActive',
	  routePath: _AppRoutes2.default.FRM_DASHBOARD,
	  selectedMenuKey: 'selectedmenufrm'
	}), _defineProperty(_menuItems, 'Actuarial - P (Probability)', {
	  localStorageKey: 'soa_p',
	  activeState: 'soaPActive',
	  routePath: _AppRoutes2.default.SOA_PROBABILITY_DASHBOARD,
	  selectedMenuKey: 'selectedmenufrm'
	}), _defineProperty(_menuItems, 'Actuarial - FM (Financial Mathematics)', {
	  localStorageKey: 'soa_fm',
	  activeState: 'soaFMActive',
	  routePath: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
	  selectedMenuKey: 'selectedmenufrm'
	}), _defineProperty(_menuItems, 'ESG', {
	  localStorageKey: 'esg',
	  activeState: 'esgActive',
	  routePath: _AppRoutes2.default.ESG_DASHBOARD,
	  selectedMenuKey: 'selectedmenuesg'
	}), _menuItems);
	var ROLES = exports.ROLES = {
	  EMPLOYEE: 'employee',
	  USER: 'user',
	  PARTNER: 'partner'
	};
	var routeExamName = exports.routeExamName = {
	  // CFA_LEVEL_1: '/cfa_2023',
	  CFA_LEVEL_1_2024: '/cfa_2024',
	  CFA_LEVEL_2: '/cfa2_2023',
	  CFA_LEVEL_3: '/cfa3',
	  ESG: '/esg',
	  FRM: '/frm',
	  SOA_P: '/soa/probability',
	  SOA_FM: '/soa/financialmathematics',
	  GMAT: '/gmat',
	  GMAT_FOCUS: '/gmat-focus',
	  EA: '/ea'
	};
	// Baked in at image build time -- CRA inlines REACT_APP_* into the bundle, so
	// this varies per environment through the --build-arg in .gitlab/ci/build.yml,
	// not through the runtime lms-ui ConfigMap. Unlike the backend's
	// AWS_S3_BUCKET_NAME this keeps a production default: the frontend only reads
	// public objects, so a missed build arg showing production images is far less
	// bad than every image on the page breaking.
	var DEFAULT_S3_BASE_URL = 'https://s3.amazonaws.com/app.analystprep.com';
	var S3_BASE_URL = exports.S3_BASE_URL = ("https://s3.amazonaws.com/app.analystprep.dev") || DEFAULT_S3_BASE_URL;
	var ADMIN_PROFILE_BASE_URL = exports.ADMIN_PROFILE_BASE_URL = S3_BASE_URL + '/profile/admin';
	var ANALYSTPREP_LOGO = exports.ANALYSTPREP_LOGO = '/img/logo_small.png';
	var examNameAccordingToDB = exports.examNameAccordingToDB = {
	  CFA: 'cfa',
	  CFA_LEVEL_1_2024: 'cfa_2024',
	  CFA_LEVEL_1_2025: 'cfa_2025',
	  CFA_LEVEL_1_2026: 'cfa_2026',
	  CFA_LEVEL_1_2027: 'cfa_2027',
	  CFA_2: 'cfa_2',
	  CFA_LEVEL_2: 'cfa_2_2023',
	  CFA_LEVEL_2_2025: 'cfa_2_2025',
	  CFA_LEVEL_2_2026: 'cfa_2_2026',
	  CFA_LEVEL_2_2027: 'cfa_2_2027',
	  CFA_LEVEL_3: 'cfa_3',
	  CFA_LEVEL_3_2025: 'cfa_3_2025',
	  CFA_LEVEL_3_2026: 'cfa_3_2026',
	  ESG: 'esg',
	  FRM: 'frm',
	  SOA_P: 'soa_p',
	  SOA_FM: 'soa_fm',
	  GMAT: 'gmat_focus',
	  GMAT_FOCUS: 'gmat_focus',
	  EA: 'ea'
	};
	
	var CFA_LEVEL_1_2024 = examNameAccordingToDB.CFA_LEVEL_1_2024,
	    CFA_LEVEL_1_2025 = examNameAccordingToDB.CFA_LEVEL_1_2025,
	    CFA_LEVEL_1_2026 = examNameAccordingToDB.CFA_LEVEL_1_2026,
	    CFA_LEVEL_1_2027 = examNameAccordingToDB.CFA_LEVEL_1_2027,
	    CFA_LEVEL_2 = examNameAccordingToDB.CFA_LEVEL_2,
	    CFA_LEVEL_2_2025 = examNameAccordingToDB.CFA_LEVEL_2_2025,
	    CFA_LEVEL_2_2026 = examNameAccordingToDB.CFA_LEVEL_2_2026,
	    CFA_LEVEL_2_2027 = examNameAccordingToDB.CFA_LEVEL_2_2027,
	    CFA_LEVEL_3 = examNameAccordingToDB.CFA_LEVEL_3,
	    CFA_LEVEL_3_2025 = examNameAccordingToDB.CFA_LEVEL_3_2025,
	    CFA_LEVEL_3_2026 = examNameAccordingToDB.CFA_LEVEL_3_2026,
	    ESG = examNameAccordingToDB.ESG,
	    FRM = examNameAccordingToDB.FRM,
	    SOA_P = examNameAccordingToDB.SOA_P,
	    SOA_FM = examNameAccordingToDB.SOA_FM,
	    GMAT = examNameAccordingToDB.GMAT,
	    GMAT_FOCUS = examNameAccordingToDB.GMAT_FOCUS,
	    EA = examNameAccordingToDB.EA;
	var examObject = exports.examObject = (_examObject = {}, _defineProperty(_examObject, FRM, {
	  dbName: FRM,
	  routeStartWith: routeExamName[FRM],
	  fullName: examNames[FRM],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.FRM_DASHBOARD,
	    notes: _AppRoutes2.default.FRM_NOTES,
	    videos: _AppRoutes2.default.FRM_VIDEOS,
	    questions: _AppRoutes2.default.FRM_QUESTION_BANK,
	    quiz: _AppRoutes2.default.FRM_QUIZZES,
	    cbt: _AppRoutes2.default.FRM_CBT,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_1_2025, {
	  dbName: CFA_LEVEL_1_2025,
	  fullName: examNames[CFA_LEVEL_1_2025],
	  routeStartWith: routeExamName[CFA_LEVEL_1_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	    notes: _AppRoutes2.default.CFA1_2025_NOTES,
	    videos: _AppRoutes2.default.CFA1_VIDEOS,
	    questions: _AppRoutes2.default.CFA1_2025_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA1_2025_QUIZZES,
	    cbt: _AppRoutes2.default.CFA1_2024_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_1_2026, {
	  dbName: CFA_LEVEL_1_2026,
	  fullName: examNames[CFA_LEVEL_1_2025],
	  routeStartWith: routeExamName[CFA_LEVEL_1_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	    notes: _AppRoutes2.default.CFA1_2025_NOTES,
	    videos: _AppRoutes2.default.CFA1_VIDEOS,
	    questions: _AppRoutes2.default.CFA1_2025_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA1_2025_QUIZZES,
	    cbt: _AppRoutes2.default.CFA1_2024_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_1_2027, {
	  dbName: CFA_LEVEL_1_2027,
	  fullName: examNames[CFA_LEVEL_1_2027],
	  routeStartWith: routeExamName[CFA_LEVEL_1_2025],
	  // 2027 navigates its own year-free /cfa1/2027/... tree (unique + deep-linkable). Pointing the
	  // sidebar/dropdown here keeps 2027 users inside /next/, and every /next/ URL forces cfa_2027 via
	  // the #292 guard (common/examUrlResolver.js). 2025/2026 blocks above are untouched.
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA1_2027_NEXT_DASHBOARD,
	    notes: _AppRoutes2.default.CFA1_2027_NEXT_NOTES,
	    videos: _AppRoutes2.default.CFA1_2027_NEXT_VIDEOS,
	    questions: _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA1_2027_NEXT_QUIZZES,
	    cbt: _AppRoutes2.default.CFA1_2027_NEXT_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_2_2025, {
	  dbName: CFA_LEVEL_2_2025,
	  fullName: examNames[CFA_LEVEL_2_2025],
	  routeStartWith: routeExamName[CFA_LEVEL_2_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	    notes: _AppRoutes2.default.CFA2_2025_NOTES,
	    videos: _AppRoutes2.default.CFA2_2026_VIDEOS,
	    questions: _AppRoutes2.default.CFA2_2025_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA2_2025_QUIZZES,
	    cbt: _AppRoutes2.default.CFA2_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_2_2026, {
	  dbName: CFA_LEVEL_2_2026,
	  fullName: examNames[CFA_LEVEL_2_2025],
	  routeStartWith: routeExamName[CFA_LEVEL_2_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	    notes: _AppRoutes2.default.CFA2_2025_NOTES,
	    videos: _AppRoutes2.default.CFA2_2026_VIDEOS,
	    questions: _AppRoutes2.default.CFA2_2025_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA2_2025_QUIZZES,
	    cbt: _AppRoutes2.default.CFA2_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_2_2027, {
	  dbName: CFA_LEVEL_2_2027,
	  fullName: examNames[CFA_LEVEL_2_2027],
	  routeStartWith: routeExamName[CFA_LEVEL_2_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA2_2027_DASHBOARD,
	    notes: _AppRoutes2.default.CFA2_2027_NOTES,
	    videos: _AppRoutes2.default.CFA2_2027_VIDEOS,
	    questions: _AppRoutes2.default.CFA2_2027_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA2_2027_QUIZZES,
	    cbt: _AppRoutes2.default.CFA2_2027_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_3, {
	  dbName: CFA_LEVEL_3,
	  fullName: examNames[CFA_LEVEL_3],
	  routeStartWith: routeExamName[CFA_LEVEL_3],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	    notes: _AppRoutes2.default.CFA3_NOTES,
	    videos: _AppRoutes2.default.CFA3_VIDEO_LESSONS,
	    questions: _AppRoutes2.default.CFA3_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA3_QUIZZES,
	    cbt: _AppRoutes2.default.CFA3_CBT,
	    pathway: _AppRoutes2.default.CFA3_PATHWAY_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE,
	    essay: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CHAPTERS
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_3_2025, {
	  dbName: CFA_LEVEL_3_2025,
	  fullName: examNames[CFA_LEVEL_3_2025],
	  routeStartWith: routeExamName[CFA_LEVEL_3_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	    notes: _AppRoutes2.default.CFA3_NOTES,
	    videos: _AppRoutes2.default.VIDEOS,
	    questions: _AppRoutes2.default.CFA3_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA3_QUIZZES,
	    cbt: _AppRoutes2.default.CFA3_CBT,
	    pathway: _AppRoutes2.default.CFA3_PATHWAY_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE,
	    essay: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CHAPTERS
	  }
	}), _defineProperty(_examObject, CFA_LEVEL_3_2026, {
	  dbName: CFA_LEVEL_3_2026,
	  fullName: examNames[CFA_LEVEL_3_2025],
	  routeStartWith: routeExamName[CFA_LEVEL_3_2025],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	    notes: _AppRoutes2.default.CFA3_NOTES,
	    videos: _AppRoutes2.default.VIDEOS,
	    questions: _AppRoutes2.default.CFA3_QUESTION_BANK,
	    quiz: _AppRoutes2.default.CFA3_QUIZZES,
	    cbt: _AppRoutes2.default.CFA3_CBT,
	    pathway: _AppRoutes2.default.CFA3_PATHWAY_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE,
	    essay: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CHAPTERS
	  }
	}), _defineProperty(_examObject, ESG, {
	  dbName: ESG,
	  fullName: examNames[ESG],
	  routeStartWith: routeExamName[ESG],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.ESG_DASHBOARD,
	    notes: _AppRoutes2.default.ESG_NOTES,
	    videos: _AppRoutes2.default.ESG_VIDEOS,
	    questions: _AppRoutes2.default.ESG_QUESTION_BANK,
	    quiz: _AppRoutes2.default.ESG_QUIZZES,
	    cbt: _AppRoutes2.default.ESG_CBT,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, SOA_P, {
	  dbName: SOA_P,
	  fullName: examNames[SOA_P],
	  routeStartWith: routeExamName[SOA_P],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.SOA_PROBABILITY_DASHBOARD,
	    notes: _AppRoutes2.default.SOA_PROBABILITY_NOTES,
	    videos: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_LESSONS,
	    questions: _AppRoutes2.default.SOA_PROBABILITY_QUESTION_BANK,
	    quiz: _AppRoutes2.default.SOA_PROBABILITY_QUIZZES,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, SOA_FM, {
	  dbName: SOA_FM,
	  fullName: examNames[SOA_FM],
	  routeStartWith: routeExamName[SOA_FM],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
	    notes: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_NOTES,
	    videos: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_VIDEO_LESSONS,
	    questions: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_QUESTION_BANK,
	    quiz: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_QUIZZES,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, GMAT, {
	  dbName: GMAT,
	  fullName: examNames[GMAT],
	  routeStartWith: routeExamName[GMAT],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.GMAT_DASHBOARD,
	    videos: _AppRoutes2.default.GMAT_VIDEO_LESSONS,
	    questions: _AppRoutes2.default.GMAT_QUESTION_BANK,
	    quiz: _AppRoutes2.default.GMAT_QUIZZES,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, GMAT_FOCUS, {
	  dbName: GMAT_FOCUS,
	  fullName: examNames[GMAT_FOCUS],
	  routeStartWith: routeExamName[GMAT_FOCUS],
	  sidebarRoutes: {
	    dashboard: _appRoutes2.default.DASHBOARD,
	    videos: _appRoutes2.default.VIDEO_LESSONS,
	    questions: _appRoutes2.default.QUESTION_BANK,
	    quiz: _appRoutes2.default.QUIZZES,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _defineProperty(_examObject, EA, {
	  dbName: EA,
	  fullName: examNames[EA],
	  routeStartWith: routeExamName[EA],
	  sidebarRoutes: {
	    dashboard: _AppRoutes2.default.EA_DASHBOARD,
	    videos: _AppRoutes2.default.EA_VIDEO_LESSONS,
	    questions: _AppRoutes2.default.EA_QUESTION_BANK,
	    quiz: _AppRoutes2.default.EA_QUIZZES,
	    tutor: _AppRoutes2.default.Tutor,
	    subscription: _AppRoutes2.default.SUBSCRIBE
	  }
	}), _examObject);
	
	var localStorageKeys = exports.localStorageKeys = {
	  loginId: 'loginID',
	  selectedMenu: 'selectedmenu',
	  token: 'token',
	  email: 'idname',
	  role: 'role',
	  organizationDomain: 'organizationDomain',
	  exam: 'exam',
	  questionMode: 'questionMode',
	  userTokenAndEmail: 'localstorageval',
	  previousPath: 'previousPath',
	  previousParams: 'previousParams',
	  selectedLanguage: 'selectedLanguage'
	};
	
	//* Header, SignUp Exam list is shown from here
	var CFAExamList = exports.CFAExamList = function CFAExamList() {
	  var isEmployee = localStorage.getItem('role') === ROLES.EMPLOYEE;
	
	  return [
	  // CFA Level 1: employees see the year-suffixed "CFA Level I - 2026" label — to
	  // distinguish the live 2026 content from the staff-only 2027 preview below.
	  // Everyone else sees the plain "CFA Level I". Same underlying exam value either way.
	  // start comment this logic - TO IMPLEMENT cfa 1 2026, 2027 exam flow
	  // {
	  //   value: CFA_LEVEL_1_2025,
	  //   label: isEmployee ? CFA_LEVEL_I_2026 : CFA_LEVEL_I,
	  // },
	  // // Staff-only 2027 preview.
	  // ...(isEmployee
	  //   ? [{ value: CFA_LEVEL_1_2027, label: CFA_LEVEL_I_2027 }]
	  //   : []),
	  // end
	
	  // start uncomment - TO IMPLEMENT cfa 1 2026, 2027 exam flow
	  { value: CFA_LEVEL_1_2025, label: CFA_LEVEL_I_2026 }, { value: CFA_LEVEL_1_2027, label: CFA_LEVEL_I_2027 },
	  // end
	
	  { value: CFA_LEVEL_2_2025, label: examNames[CFA_LEVEL_2_2025] }].concat(_toConsumableArray(isEmployee ? [{ value: CFA_LEVEL_2_2027, label: examNames[CFA_LEVEL_2_2027] }] : []), [
	  // end
	
	  // start uncomment - TO IMPLEMENT cfa 2 2027 exam flow
	  // { value: CFA_LEVEL_2_2027, label: examNames[CFA_LEVEL_2_2027] },
	  // end
	  { value: CFA_LEVEL_3_2025, label: examNames[CFA_LEVEL_3_2025] }, { value: ESG, label: examNames[ESG] }]);
	};
	
	var FRMExamList = exports.FRMExamList = [{ value: FRM, label: examNames[FRM] }];
	
	var ActuarialExamList = exports.ActuarialExamList = [{ value: SOA_P, label: examNames[SOA_P] }, { value: SOA_FM, label: examNames[SOA_FM] }];
	
	var GMATExamList = exports.GMATExamList = [{ value: GMAT_FOCUS, label: examNames[GMAT_FOCUS] }, { value: EA, label: examNames[EA] }];
	
	var getTokenWithEmail = exports.getTokenWithEmail = function getTokenWithEmail() {
	  var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	  return {
	    token: storage_session['token'],
	    idname: storage_session['idname']
	  };
	};
	
	// aliasName = {esg_chapters : ''}
	var flattenObject = function flattenObject(obj) {
	  var aliasName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var result = {};
	
	  for (var key in obj) {
	    var newKey = parentKey ? parentKey + '.' + key : key;
	
	    if (_typeof(obj[key]) === 'object' && !Array.isArray(obj[key])) {
	      Object.assign(result, flattenObject(obj[key], aliasName, aliasName[key] || ''));
	    } else {
	      result[newKey] = obj[key];
	    }
	  }
	
	  return result;
	};
	
	var mergeTwoSortedArrayDataById = exports.mergeTwoSortedArrayDataById = function mergeTwoSortedArrayDataById(array1, array2, key) {
	  var operations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
	    flatObjectOnArray1: false,
	    aliasName: {},
	    flatObjectOnArray2: false
	  };
	
	  var mergedArray = [];
	  var iterator1 = 0;
	  var iterator2 = 0;
	
	  while (iterator1 < array1.length && iterator2 < array2.length) {
	    if (array1[iterator1][key] < array2[iterator2][key]) {
	      if (operations.flatObjectOnArray1) array1[iterator1] = flattenObject(array1[iterator1], operations.aliasName);
	      mergedArray.push(array1[iterator1]);
	      iterator1++;
	    } else if (array1[iterator1][key] > array2[iterator2][key]) {
	      if (operations.flatObjectOnArray2) array2[iterator2] = flattenObject(array2[iterator2], operations.aliasName);
	      mergedArray.push(array2[iterator2]);
	      iterator2++;
	    } else {
	      // IDs are equal, merge the objects
	      if (operations.flatObjectOnArray1) array1[iterator1] = flattenObject(array1[iterator1], operations.aliasName);
	      if (operations.flatObjectOnArray2) array2[iterator2] = flattenObject(array2[iterator2], operations.aliasName);
	
	      mergedArray.push(Object.assign({}, array1[iterator1], array2[iterator2]));
	      iterator1++;
	      iterator2++;
	    }
	  }
	
	  // Append any remaining elements from array1 and array2
	  while (iterator1 < array1.length) {
	    if (operations.flatObjectOnArray1) array1[iterator1] = flattenObject(array1[iterator1], operations.aliasName);
	    mergedArray.push(array1[iterator1]);
	    iterator1++;
	  }
	
	  while (iterator2 < array2.length) {
	    if (operations.flatObjectOnArray2) array2[iterator2] = flattenObject(array2[iterator2], operations.aliasName);
	    mergedArray.push(array2[iterator2]);
	    iterator2++;
	  }
	
	  return mergedArray;
	};
	
	var SUBSCRIPTION_TYPES = exports.SUBSCRIPTION_TYPES = {
	  EXPENSIVE: 'expensive',
	  UNLIMITED: 'unlimited',
	  SIMPLE: 'simple'
	};
	
	var Y_AXIS_SCALES = exports.Y_AXIS_SCALES = {
	  scales: {
	    yAxes: [{
	      ticks: {
	        min: 0,
	        max: 100
	      }
	    }]
	  }
	};
	
	var SECTION_NAMES = exports.SECTION_NAMES = {
	  NOTES: ['notes'],
	  VIDEOS: ['video', 'cfa3_video_display', 'videodisplay', 'videos', 'eavideodisplay'],
	  QUESTION_BANK: ['question', 'questions', 'readings', 'ea_readings', 'ea_viewquestions', 'beginchapter', 'cases', 'chapter', 'viewquestions', 'EATab', 'EA2Statement', 'EAMultipleStatement', 'EATable', 'ea_beginchapter', 'gmat-tab', 'gmat-two-part', 'gmat-multi-statement', 'gmat-table'],
	  QUIZZES: ['quiz', 'beforestart', 'beginquiz', 'ea_beginquiz', 'before-start', 'ea_beforestart', 'ea_beginquiz_tab', 'ea_beginquiz_graph', 'ea_beginquiz_table', 'ea_beginquiz_twopart', 'ea_beginquiz_case'],
	  DASHBOARD: ['dashboard', 'viewallquestions'],
	  ESSAY_QUESTION: ['essay-question'],
	  CBT: ['cbt', 'viewattemptedmock', 'introduction'],
	  TUTOR: ['tutor'],
	  SUBSCRIBE: ['subscribe'],
	  PATHWAY: ['pathway'],
	  WEBINARS: ['webinars']
	};
	
	var REDIRECTION_ROUTES = exports.REDIRECTION_ROUTES = {
	  cfa_2025: {
	    notes: {
	      pathname: _AppRoutes2.default.CFA1_2025_NOTES_READING_LIST,
	      keys: [{ key: 'chapterId', apiKey: 'chapter_id' }]
	    },
	    question: {
	      pathname: _AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST,
	      keys: [{ key: 'chapterId', apiKey: 'chapter_id' }]
	    }
	  },
	  cfa_2_2025: {
	    notes: {
	      pathname: _AppRoutes2.default.CFA2_2025_NOTES_READINGS,
	      keys: [{ key: 'chapter', apiKey: 'chapter_id_2025' }]
	    },
	    question: {
	      pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES,
	      keys: [{ key: 'id', apiKey: 'chapter_id_2025' }, { key: 'chapter_name', apiKey: 'chapter_name' }]
	    }
	  },
	  cfa_3_2025: {
	    notes: {
	      pathname: _AppRoutes2.default.CFA3_NOTES_READINGS,
	      keys: [{ key: 'chapter', apiKey: 'chapter_id' }]
	    },
	    question: {
	      pathname: _AppRoutes2.default.CFA3_2025_QUESTION_BANK_READING_LIST,
	      keys: [{ key: 'id', apiKey: 'chapter_id' }, { key: 'chapter_name', apiKey: 'chapter_name' }]
	    }
	  }
	};
	
	var EXAM_CATEGORIES = {
	  CFA_LEVEL_1: {
	    examNames: ['cfa', 'cfa_2022', 'cfa_2023', 'cfa_2024', 'cfa_2025', 'cfa_2026', 'cfa_2027'],
	    activeExam: 'cfa_2025'
	  },
	  CFA_LEVEL_2: {
	    examNames: ['cfa_2', 'cfa2', 'cfa_2_2022', 'cfa_2_2023', 'cfa_2_2024', 'cfa_2_2025', 'cfa_2_2025', 'cfa_2_2026', 'cfa_2_2027'],
	    activeExam: 'cfa_2_2025'
	  },
	  CFA_LEVEL_3: {
	    examNames: ['cfa_3', 'cfa3', 'cfa_3_2023', 'cfa_3_2024', 'cfa_3_2025', 'cfa_3_2025', 'cfa_3_2026'],
	    activeExam: 'cfa_3_2025'
	  },
	  ESG: { examNames: ['esg'], activeExam: 'esg' },
	  FRM_PART_1: { examNames: ['frm1', 'frm'], activeExam: 'frm' },
	  FRM_PART_2: { examNames: ['frm2', 'frm_2'], activeExam: 'frm_2' },
	  FRM_COMBINED: { examNames: ['frm_1_2'], activeExam: 'frm' },
	  SOA_P: { examNames: ['soa_p'], activeExam: 'soa_p' },
	  SOA_FM: { examNames: ['soa_fm'], activeExam: 'soa_fm' },
	  SOA_P_FM: { examNames: ['soa_p_fm_ifm'], activeExam: 'soa_p' },
	  GMAT: { examNames: ['gmat', 'gmat_focus'], activeExam: 'gmat_focus' },
	  EXECUTIVE_ASSESSMENT: { examNames: ['ea', 'EA'], activeExam: 'ea' }
	};
	
	var getActiveExams = exports.getActiveExams = function getActiveExams(examName) {
	  var exam = Object.values(EXAM_CATEGORIES).find(function (_ref) {
	    var examNames = _ref.examNames;
	    return examNames.includes(examName);
	  });
	  return exam ? exam.activeExam : null;
	};
	
	var EXAM_PACKAGE_IDS = exports.EXAM_PACKAGE_IDS = {
	  GMAT_FOCUS: {
	    PRACTICE: 57
	  }
	};
	
	var CAPSULE_VIDEO_ID = exports.CAPSULE_VIDEO_ID = 11;
	
	var CHOICE_MAPPING = exports.CHOICE_MAPPING = {
	  choice_a: 'A',
	  choice_b: 'B',
	  choice_c: 'C',
	  choice_d: 'D',
	  choice_e: 'E'
	};
	
	var CHOICE_KEYS = exports.CHOICE_KEYS = ['choice_a', 'choice_b', 'choice_c'];
	
	var SUBSCRIPTION_STATUS = exports.SUBSCRIPTION_STATUS = {
	  FREE: 'free',
	  PAID: 'paid'
	};
	
	var QUESTION_TYPE = exports.QUESTION_TYPE = {
	  CASE_QUESTION: 'case_question',
	  QUESTION: 'question',
	  TABLE_QUESTION: 'table_question',
	  TWO_PART_QUESTION: 'two_part_question',
	  GRAPH_QUESTION: 'graph_question',
	  TAB_QUESTION: 'tab_question'
	};
	
	var TABLE_NAME = exports.TABLE_NAME = {
	  EA_QUESTION_STATS: 'ea_question_stat'
	};
	
	var QUESTION_MODE = exports.QUESTION_MODE = {
	  PRACTICE: 'practice_mode',
	  REVISION: 'revision_mode'
	};
	
	// Define and export exam name constants and a single EXAM_NAMES object
	var EXAM_NAMES = exports.EXAM_NAMES = {
	  CFA_1: 'cfa_1',
	  CFA_2: 'cfa_2',
	  CFA_3: 'cfa_3',
	  ESG: 'esg',
	  FRM: 'frm',
	  SOA_P: 'soa_p',
	  SOA_FM: 'soa_fm',
	  GMAT_FOCUS: 'gmat_focus',
	  EA: 'ea'
	};
	
	var QUESTION_MODE_OPTIONS = exports.QUESTION_MODE_OPTIONS = [{
	  id: QUESTION_MODE.PRACTICE,
	  value: QUESTION_MODE.PRACTICE,
	  label: _messages.messages.PRACTICE_MODE,
	  description: _messages.messages.PRACTICE_MODE_DESC
	}, {
	  id: QUESTION_MODE.REVISION,
	  value: QUESTION_MODE.REVISION,
	  label: _messages.messages.REVISION_MODE,
	  description: _messages.messages.REVISION_MODE_DESC
	}];
	var EXAM_MAPPING = exports.EXAM_MAPPING = {
	  cfa: 'CFA Level I',
	  cfa_2: 'CFA Level II',
	  cfa_3: 'CFA Level III',
	  frm: 'FRM Part I',
	  frm_2: 'FRM Part II',
	  frm_1_2: 'FRM Part I & Part II',
	  soa_p: 'Actuarial - P (Probability)',
	  soa_fm: 'Actuarial - FM (Financial Mathematics)',
	  soa_p_fm_ifm: 'Actuarial - P, FM & IFM',
	  gmat: 'GMAT',
	  ea: 'Executive Assessment',
	  esg: 'ESG',
	  gmat_focus: 'GMAT Focus'
	};
	var FRM_LEVELS = exports.FRM_LEVELS = {
	  ONE: '1',
	  TWO: '2'
	};
	var EXAMS_WITH_IDS = exports.EXAMS_WITH_IDS = [{
	  id: 1,
	  name: 'CFA Level I'
	}, {
	  id: 2,
	  name: 'FRM Part I'
	}, {
	  id: 3,
	  name: 'FRM Part II'
	}, {
	  id: 4,
	  name: 'FRM Part I & Part II'
	}, {
	  id: 5,
	  name: 'CFA Level II'
	}, {
	  id: 6,
	  name: 'CFA Level III'
	}, {
	  id: 7,
	  name: 'Actuarial - P (Probability)'
	}, {
	  id: 8,
	  name: 'Actuarial - FM (Financial Mathematics)'
	}, {
	  id: 9,
	  name: 'Actuarial - IFM (Investment and Financial Markets)'
	}, {
	  id: 10,
	  name: 'Actuarial - P, FM & IFM'
	}, {
	  id: 11,
	  name: 'Actuarial - IFM (Investment and Financial Markets)'
	}, {
	  id: 12,
	  name: 'Actuarial - P, FM & IFM'
	}, {
	  id: 13,
	  name: 'GMAT'
	}, {
	  id: 14,
	  name: 'EA'
	}, {
	  id: 17,
	  name: 'ESG'
	}, {
	  id: 19,
	  name: 'GMAT Focus'
	}];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isRevisionModeActive = exports.setQuestionModeToLocalStorage = exports.getQuestionModeFromLocalStorage = exports.onHandleTableSorting = exports.formatTime = exports.generateRandomInteger = exports.renderSanitizedHTML = exports.renderHTMLContent = exports.retrieveSpecialPrice = exports.generateDynamicRoute = exports.openPDF = exports.downloadPDF = exports.indexOfUsingBinarySearch = exports.postApiCalling = exports.getRequestAPIData = exports._getProfile = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.removeSuffix = removeSuffix;
	exports.slugifyHeader = slugifyHeader;
	exports.countStatements = countStatements;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crypto = __webpack_require__(964);
	
	var _crypto2 = _interopRequireDefault(_crypto);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _reactRouter = __webpack_require__(29);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactHtmlParser = __webpack_require__(1151);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var _getProfile = exports._getProfile = function _getProfile(username) {
	  _reactRouter.browserHistory.push({ pathname: _AppRoutes2.default.PROFILE_ROUTE.replace(':username', username) });
	};
	
	var getRequestAPIData = exports.getRequestAPIData = function getRequestAPIData(dataObj) {
	  var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	  return Object.assign({
	    idname: storage_session['idname'],
	    token: storage_session['token']
	  }, dataObj);
	};
	
	var postApiCalling = exports.postApiCalling = function postApiCalling(route, endpoint, data) {
	  return _fetchData2.default.callAPI('' + _App_data2.default.backend_api + route + endpoint, getRequestAPIData(data));
	};
	var indexOfUsingBinarySearch = exports.indexOfUsingBinarySearch = function indexOfUsingBinarySearch(arr, target) {
	  var left = 0;
	  var right = arr.length - 1;
	
	  while (left <= right) {
	    var mid = Math.floor((left + right) / 2);
	
	    if (arr[mid] === target) {
	      return mid; // Element found, return its index.
	    } else if (arr[mid] < target) {
	      left = mid + 1; // Adjust the left bound.
	    } else {
	      right = mid - 1; // Adjust the right bound.
	    }
	  }
	
	  return -1; // Element not found in the array.
	};
	
	var downloadPDF = exports.downloadPDF = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(bufferData, filename) {
	    var url, link;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            url = window.URL.createObjectURL(new Blob([new Uint8Array(bufferData).buffer]));
	            link = document.createElement('a');
	
	            link.href = url;
	            link.setAttribute('download', filename || 'FileName.pdf');
	
	            // Append to html link element page
	            document.body.appendChild(link);
	
	            // Start download
	            link.click();
	
	            // Clean up and remove the link
	            link.parentNode.removeChild(link);
	
	          case 7:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function downloadPDF(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var openPDF = exports.openPDF = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	    var openPDFWindow, response;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            openPDFWindow = window.open(resp.data.pdf);
	            // openPDFWindow = null; //   // this.downloadFile(resp.data.pdf);
	
	            if (!(openPDFWindow === null || typeof openPDFWindow === 'undefined')) {
	              _context2.next = 6;
	              break;
	            }
	
	            _context2.next = 4;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/s3-pdf-buffer-data', {
	              bucket: resp.data.s3BucketName,
	              key: resp.data.s3Key
	            });
	
	          case 4:
	            response = _context2.sent;
	
	            if (response.success) {
	              downloadPDF(response.Body.data, response.filename);
	            }
	
	          case 6:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function openPDF(_x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var generateDynamicRoute = exports.generateDynamicRoute = function generateDynamicRoute(route, data, chapterName) {
	  var pathname = route.pathname,
	      keys = route.keys;
	
	
	  if (!keys || !Array.isArray(keys)) {
	    return pathname;
	  }
	
	  return keys.reduce(function (updatedPathname, _ref3) {
	    var key = _ref3.key,
	        apiKey = _ref3.apiKey;
	
	    var replacementValue = data[apiKey] || '';
	    return updatedPathname.replace(':' + key, key === 'chapter_name' && chapterName ? chapterName : replacementValue);
	  }, pathname);
	};
	
	var updateExamPackagesWithSpecialPrices = function updateExamPackagesWithSpecialPrices(examPackages, specialPrices) {
	  if (!specialPrices || (typeof specialPrices === 'undefined' ? 'undefined' : _typeof(specialPrices)) !== 'object') {
	    return examPackages;
	  }
	
	  return examPackages.map(function (packageDetail) {
	    var updatedPrice = specialPrices[packageDetail.id];
	    return Object.assign({}, packageDetail, {
	      price: updatedPrice ? parseFloat(updatedPrice) : packageDetail.price
	    });
	  });
	};
	
	var retrieveSpecialPrice = exports.retrieveSpecialPrice = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(partnerId, plans) {
	    var adminDetails, specialPrice;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            if (!(!plans || plans.length === 0)) {
	              _context3.next = 2;
	              break;
	            }
	
	            return _context3.abrupt('return', []);
	
	          case 2:
	            _context3.prev = 2;
	            _context3.next = 5;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/admin', { partnerId: partnerId });
	
	          case 5:
	            adminDetails = _context3.sent;
	
	            if (!(!adminDetails || !adminDetails.partnerDetails)) {
	              _context3.next = 8;
	              break;
	            }
	
	            return _context3.abrupt('return', plans);
	
	          case 8:
	            specialPrice = adminDetails.partnerDetails.special_prices ? JSON.parse(adminDetails.partnerDetails.special_prices) : {};
	            return _context3.abrupt('return', updateExamPackagesWithSpecialPrices(plans, specialPrice));
	
	          case 12:
	            _context3.prev = 12;
	            _context3.t0 = _context3['catch'](2);
	            return _context3.abrupt('return', plans);
	
	          case 15:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined, [[2, 12]]);
	  }));
	
	  return function retrieveSpecialPrice(_x4, _x5) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	/**
	 * Removes '– Volume X' (case-insensitive) from a title string.
	 * Works for the en dash ('–') followed by 'VOLUME' and a number,
	 * and keeps the rest of the title intact.
	 */
	function removeSuffix(title) {
	  var keyword = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '– volume';
	
	  if (!title || !keyword) return title;
	
	  var normalizedTitle = title.toLowerCase();
	  var normalizedKeyword = keyword.toLowerCase();
	
	  var keywordIndex = normalizedTitle.indexOf(normalizedKeyword);
	  if (keywordIndex === -1) return title;
	
	  var baseTitle = title.substring(0, keywordIndex).trim();
	
	  var nextIndex = keywordIndex + normalizedKeyword.length;
	
	  // Skip any spaces and numbers following the keyword
	  while (nextIndex < title.length && (title[nextIndex] === ' ' || /\d/.test(title[nextIndex]))) {
	    nextIndex++;
	  }
	
	  var remainingText = title.slice(nextIndex).trimStart();
	
	  return remainingText ? baseTitle + ' ' + remainingText : baseTitle;
	}
	
	// Turn a section header label (e.g. "Live Sessions") into a DOM-safe
	// anchor id ("recorded-webinars") used for in-page category navigation.
	function slugifyHeader(title) {
	  if (!title) return '';
	  return String(title).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
	}
	
	var renderHTMLContent = exports.renderHTMLContent = function renderHTMLContent(html) {
	  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var extraProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var Tag = tag;
	  return _react2.default.createElement(Tag, Object.assign({ className: className, dangerouslySetInnerHTML: { __html: html } }, extraProps));
	};
	
	var renderSanitizedHTML = exports.renderSanitizedHTML = function renderSanitizedHTML(html) {
	  return (0, _reactHtmlParser2.default)(html);
	};
	
	var generateRandomInteger = exports.generateRandomInteger = function generateRandomInteger(min, max) {
	  var range = max - min;
	  if (range <= 0) throw new Error('Invalid range');
	
	  var randomBytes = _crypto2.default.randomBytes(4);
	  var randomNumber = randomBytes.readUInt32BE(0) / 0xffffffff;
	
	  return Math.floor(randomNumber * range + min);
	};
	
	var formatTime = exports.formatTime = function formatTime(seconds) {
	  if (seconds < 60) {
	    return seconds + 'sec';
	  } else {
	    var getminutes = Math.trunc(seconds / 60);
	    var getSeconds = Math.trunc(seconds % 60);
	    return getminutes + 'min ' + getSeconds + 'sec';
	  }
	};
	
	var onHandleTableSorting = exports.onHandleTableSorting = function onHandleTableSorting(value) {
	  var index = value;
	  var table = document.getElementById('bodyData');
	  if (!table) return;
	
	  var switching = true;
	
	  var sanitizeValue = function sanitizeValue(cell) {
	    var val = parseFloat(cell.innerHTML.replace(/[><]/g, '').replace(/&[gl]t;/g, ''));
	    if (isNaN(val)) {
	      val = cell.innerHTML.toLowerCase().trim();
	      val = _constant.specialChars.test(val) ? '0' : val;
	    }
	    return val;
	  };
	
	  while (switching) {
	    switching = false;
	    var rows = table.rows;
	
	    for (var i = 0; i < rows.length - 1; i++) {
	      var x = rows[i].cells[index];
	      var y = rows[i + 1].cells[index];
	      if (!x || !y) continue;
	
	      var valX = sanitizeValue(x);
	      var valY = sanitizeValue(y);
	
	      // Type consistency fallback
	      if (isNaN(valX) !== isNaN(valY)) {
	        valX = isNaN(valX) ? 0 : valX;
	        valY = isNaN(valY) ? 0 : valY;
	      }
	
	      var shouldSwitch = false;
	
	      if (valX === valY) {
	        var htmlX = x.innerHTML.toLowerCase();
	        var htmlY = y.innerHTML.toLowerCase();
	        if (htmlX.includes('&gt;') && !htmlY.includes('&gt;')) shouldSwitch = true;
	        if (!htmlX.includes('&lt;') && htmlY.includes('&lt;')) shouldSwitch = true;
	      } else if (valX > valY) {
	        shouldSwitch = true;
	      }
	
	      if (shouldSwitch) {
	        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
	        switching = true;
	        break;
	      }
	    }
	  }
	};
	
	var getQuestionModeFromLocalStorage = exports.getQuestionModeFromLocalStorage = function getQuestionModeFromLocalStorage(examNameKey) {
	  if (!examNameKey) return;
	  var localStorageValue = localStorage.getItem(_constant.localStorageKeys.questionMode);
	  if (!localStorageValue) return;
	  var questionMode = JSON.parse(localStorageValue);
	  if (questionMode && (typeof questionMode === 'undefined' ? 'undefined' : _typeof(questionMode)) === 'object') {
	    return questionMode[examNameKey];
	  }
	  return;
	};
	
	// Utility to set question mode for a given exam in localStorage
	var setQuestionModeToLocalStorage = exports.setQuestionModeToLocalStorage = function setQuestionModeToLocalStorage(examNameKey, mode) {
	  if (!examNameKey) return;
	  var questionMode = {};
	  var localStorageValue = localStorage.getItem(_constant.localStorageKeys.questionMode);
	  if (localStorageValue) {
	    var parsed = JSON.parse(localStorageValue);
	    if (parsed && (typeof parsed === 'undefined' ? 'undefined' : _typeof(parsed)) === 'object') {
	      questionMode = parsed;
	    }
	  }
	  questionMode[examNameKey] = mode;
	  localStorage.setItem(_constant.localStorageKeys.questionMode, JSON.stringify(questionMode));
	};
	
	/**
	 * Checks if the current mode is revision_mode for a given exam key.
	 * @param {string} examNameKey - The key for the exam (e.g., "cfa_1", "gmat_focus").
	 * @returns {boolean} - true if revision_mode, false otherwise (defaults to practice_mode).
	 */
	var isRevisionModeActive = exports.isRevisionModeActive = function isRevisionModeActive(examNameKey) {
	  var mode = getQuestionModeFromLocalStorage(examNameKey);
	  return mode === _constant.QUESTION_MODE.REVISION;
	};
	
	function countStatements() {
	  var question = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.keys(question).filter(function (key) {
	    return key.startsWith('statement') && question[key];
	  }).length;
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var AlertMessage = function (_React$Component) {
	  _inherits(AlertMessage, _React$Component);
	
	  function AlertMessage(props) {
	    _classCallCheck(this, AlertMessage);
	
	    // ============CFA- 1 message============
	    var _this = _possibleConstructorReturn(this, (AlertMessage.__proto__ || Object.getPrototypeOf(AlertMessage)).call(this, props));
	
	    _this.messageContent_cfa_1 = '<div class="modal-info-list"><ul> <li> ' + 'Extensive Study Notes' + ' </li> <li> ' + '40+ Hours of Video Lessons' + ' </li> <li> ' + '3,000+ Practice Questions' + ' </li><li> ' + '5 Full-Length Mock Exams' + ' </li> <li> ' + 'Unlimited Customizable Quizzes' + ' </li> <li> ' + 'Tutors Answering your Questions via Live Chat' + '</li></ul></div>';
	    // =============FRM  message=============
	    _this.messageContent_frm = '<div class="modal-info-list"><ul> <li> ' + 'Extensive Study Notes' + ' </li> <li> ' + '30+ Hours of Video Lessons for each Part' + ' </li> <li> ' + '2,000 Practice Questions for each Part' + ' </li> <li> ' + 'Unlimited Customizable Quizzes' + ' </li> <li> ' + 'Tutors Answering your Questions via Live Chat' + '</li></ul></div>';
	
	    // =============CFA-2 message=======
	
	    _this.messageContent_cfa_2 = '<div class="modal-info-list"><ul> <li> ' + '200 Item Sets' + ' </li> <li> ' + '2 Full-Length Mock Exams' + ' </li><li> ' + 'Unlimited Customizable Quizzes' + ' </li> <li> ' + 'Tutors Answering your Questions via Live Chat' + '</li></ul></div>';
	
	    // ===============CFA -3 mesage =========
	    _this.messageContent_cfa_3 = '<div class="modal-info-list"><ul> <li> ' + '100 Item Sets' + ' </li> <li> ' + 'Essay Questions' + ' </li>  <li> ' + 'Unlimited Customizable Quizzes' + ' </li> <li> ' + 'Tutors Answering your Questions via Live Chat' + '</li></ul></div>';
	
	    // =============== ESG mesage =========
	    _this.messageContent_ESG = '<div class=\'modal-info-list\'>\n    <ul>\n      <li> Extensive Study Notes </li>\n      <li> 3500+ Practice Questions </li>\n      <li> 2 Full-Length Mock Exams </li>\n      <li> Tutors Answering your Questions via Live Chat</li>\n    </ul>\n  </div>';
	
	    // ==========SOA _ P message =========
	    _this.messageContent_soa_p = '<div class="modal-info-list"><ul> <li> ' + 'Extensive Study Notes' + ' </li><li> ' + '1,500+ Practice Questions' + ' </li><li> ' + 'Unlimited Customizable Quizzes' + ' </li> <li> ' + 'Tutors Answering your Questions via Live Chat' + '</li></ul></div>';
	
	    // ==========SOA - FM message =========
	    _this.messageContent_soa_fm = '<div class="modal-info-list"><ul> <li> ' + 'Extensive Study Notes' + ' </li>  <li> ' + '40+ Hours of Video Lessons' + ' </li>  <li> ' + '1,500+ Practice Questions' + ' </li><li> ' + 'Unlimited Customizable Quizzes' + ' </li> <li> ' + 'Tutors Answering your Questions via Live Chat' + '</li></ul></div>';
	
	    // ==========GMAT message =========
	    _this.messageContent_gmat = '<div class="modal-info-list"><ul> <li> ' + _language2.default.LC().Hours_of_Video_Lessons_35 + ' </li> <li> ' + _language2.default.LC().Quant_Questions + ' </li><li> ' + _language2.default.LC().Verbal_Questions + ' </li> <li> ' + _language2.default.LC().Integrated_Reasoning_Questions + ' </li> <li> ' + _language2.default.LC().Advanced_Analytics_Dashboard + ' </li><li> ' + _language2.default.LC().AskATutor_Questions + '</li></ul></div>';
	    return _this;
	  }
	
	  return AlertMessage;
	}(_react2.default.Component);
	
	exports.default = new AlertMessage();

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import "./Loader.css";
	
	var Loader = function Loader() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'loader_box' },
	    _react2.default.createElement(
	      'div',
	      { className: 'sk-circle' },
	      _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	      _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	    )
	  );
	};
	
	exports.default = Loader;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _exams = __webpack_require__(180);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalComponent = function (_Component) {
	  _inherits(ModalComponent, _Component);
	
	  function ModalComponent(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ModalComponent);
	
	    var _this = _possibleConstructorReturn(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).call(this, props));
	
	    _this.setContentMessage = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var result, _result$data, _result$data$html_con, html_content, header;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _exams.fetchFreeUseSubscriptionMessage)({
	                exam: _this.props.exam,
	                section: 'modal'
	              });
	
	            case 2:
	              result = _context.sent;
	
	              if (result.success && result.data) {
	                _result$data = result.data, _result$data$html_con = _result$data.html_content, html_content = _result$data$html_con === undefined ? '' : _result$data$html_con, header = _result$data.header;
	
	                _this.setState({
	                  subscriptionMessage: html_content,
	                  contentHeader: header
	                });
	              }
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = { subscriptionMessage: props.MessageContent };
	    return _this;
	  }
	
	  _createClass(ModalComponent, [{
	    key: 'toggleAlert',
	    value: function toggleAlert(event) {
	      event.preventDefault();
	      this.props.toggleAlert(event);
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium(event) {
	      event.preventDefault();
	      this.props.goPremium(event);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var exam = this.props.exam;
	
	      if (exam) {
	        this.setContentMessage();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var alert_status = this.props.alert_status;
	      var subscriptionMessage = this.state.subscriptionMessage;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: alert_status,
	          toggle: this.toggleAlert.bind(this),
	          className: 'modal-primary custom_modalpro info-modal-designing ' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: this.toggleAlert.bind(this), className: 'custom-title' },
	          _language2.default.LC().INFORMATION,
	          ' '
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: '' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _language2.default.LC().Why_should_I_upgrade_my_account
	            ),
	            (0, _function.renderHTMLContent)(subscriptionMessage, "div", "", { contentEditable: "false" }),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary margin_right_20',
	                  onClick: this.toggleAlert.bind(this)
	                },
	                ' ',
	                _language2.default.LC().KEEP_FREE_VERSION,
	                ' '
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: this.goPremium.bind(this) },
	                ' ',
	                _language2.default.LC().GO_PREMIUM,
	                ' '
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalComponent;
	}(_react.Component);
	
	exports.default = ModalComponent;

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var messages = exports.messages = {
	  FROM: 'From',
	  FREE: 'Free',
	  BACK: 'Back',
	  Alert: 'Alert',
	  OK: 'OK',
	  START: 'Start',
	  PATHWAY: 'pathway',
	  SESSION: 'Session',
	  SAVE_ANSWER: 'Save answer',
	  CBT_EXAM: 'CBT Exams',
	  SUBJECT: 'Subject',
	  DELETE_ALERT_MESSAGE: 'Are you sure you want to delete this ?',
	  DATA_NOT_FOUND: 'Data not found',
	  ACTIVE: 'Active',
	  TICKET_ID: 'Ticket ID',
	  EDIT_REPORT: 'Edit report',
	  VIEW_FEEDBACK: 'View feedback',
	  DELETE: 'Delete',
	  RESOLVED: 'resolved',
	  PENDING: 'pending',
	  VIEW: 'View',
	  NOTE: 'Note',
	  PREMIUM: 'Premium',
	  TO: 'To',
	  DASHBOARD: 'Dashboard',
	  VIDEOS: 'Videos',
	  TOPIC: 'Topic',
	  BOOK: 'Book',
	  TOTAL_VIDEOS: 'Total Videos',
	  CHAPTER_READING: 'Chapter Readings',
	  FRM_DASHBOARD_PART_1: 'FRM Dashboard - Part 1',
	  FRM_DASHBOARD_PART_2: 'FRM Dashboard - Part 2',
	  DETAILED_STATS: 'Detailed Stats',
	  READ: 'Read',
	  REQUEST_SENT_SUCCESSFULLY: 'Your request has been submitted successfully.',
	  CHANGE_NOTES: 'Change Notes',
	  UNREAD: 'Unread',
	  CHANGE_PATHWAY: 'Change Pathway',
	  YOU_CAN_SEE: 'A full progress bar means you have completed all available questions in that specific topic.',
	  PERFORMANCE: 'Performance',
	  SEPARATE_YOUR_RESULT: 'Analyze your results by topic and compare them to a user base of over 50,000 candidates.',
	  QUESTION_PROGRESS: 'Questions Progress',
	  NOTES_PROGRESS: 'Notes Progress',
	  MY_SAVED_ITEM_WITH_FLASH_CARD: 'My Saved Items/Flashcards',
	  MY_REPORTS: 'My Reports',
	  SHEET_NOT_AVAILABLE: ':sheet Not Available',
	  GO_TO_MY_LAST_QUESTION_ANSWERED: 'Go to my Last Answered Question ',
	  GO_TO_MY_LAST_READ_NOTE: 'Go to my Last read Note ',
	  GO_TO_MY_LAST_VIEWED_VIDEO: 'Go to my Last Viewed Video',
	  SEND_REQUEST: 'Send Request',
	  QUESTION_BANK: 'Question Bank',
	  PATHWAY_EXAM: 'Computer-Based Testing (CBT) Exams',
	  PATHWAY_NOT_FOUND: 'Pathway not found',
	  ADDITIONAL_RESOURCES: 'Additional Resources',
	  SELECT_MODE: 'Select Mode Type',
	  PRACTICE_MODE: 'Practice Mode',
	  REVISION_MODE: 'Revision Mode',
	  NOTES: 'Notes',
	  RATIO_SHEET: 'Ratio Sheet',
	  READ_NOTES: 'Marked as Read',
	  UNREAD_NOTES: 'Mark as Read',
	  NO_DATA_FOUND: 'No data found',
	  DOWNLOAD_QUESTION: 'Download Q',
	  DOWNLOAD_NOTE: ' Download Notes',
	  FORMULA_SHEET: 'Formula Sheet',
	  NOTES_NOT_AVAILABLE: 'Last read note not available',
	  VIDEO_NOT_AVAILABLE: 'Last viewed video not available',
	  DOWNLOAD_QUESTION_ANSWER: 'Download Q/A',
	  CHANGE_TOPIC: 'Change Topic',
	  CHANGE_READING: 'Change Reading',
	  CHANGE_QUESTION: 'Change Question',
	  BACK_TO_SUMMARY: 'Back to Summary',
	  PDF_DOWNLOAD_CONTENT_MESSAGE: "You successfully initiated your export. You'll receive an email notification when your export is ready to download.",
	  READING: 'Reading',
	  ACTION: 'Action',
	  LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE: 'Last Attempted Question Not Available',
	  VIEW_LIST: 'View List',
	  BEGIN_CHAPTER: 'Begin Chapter',
	  FRM_TOPIC_PART_1: 'FRM Part I - Topics',
	  FRM_TOPIC_PART_2: 'FRM Part II - Topics',
	  SUBSCRIBE_PRACTICE_QUESTION: 'Subscribe for numberOfQuestion practice questions',
	  QUESTION_STATS_SAVED: 'Question stats saved successfully',
	  QUESTION_NOT_AVAILABLE_FOR_READING: 'No questions available for this reading',
	  NOTES_NOT_AVAILABLE_FOR_READING: 'No notes available for this reading',
	  REPORT: 'Report',
	  COMMENT: 'Comment',
	  QUIZ_ID: 'Quiz ID',
	  PLEASE_WAIT: 'Please wait...',
	  CANCEL: 'Cancel',
	  REPORT_SEND_SUCCESS_MESSAGE: 'Report sent successfully',
	  CLOSE: 'Close',
	  SUBJECT_CANT_BE_EMPTY: "Subject can't be empty",
	  COMMENT_CANT_BE_EMPTY: "Comment can't be empty",
	  REPORT_CANT_BE_EMPTY: "Report can't be empty",
	  NO_CHOICE_SELECTED: 'No option selected. Please select option before submitting.',
	  SELECT_OPTION_ERROR: 'Please select all the options',
	  PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER: 'Please subscribe to get access to this chapter',
	  CFA1_PREMIUM_POPUP: '<div class="modal-info-list"><ul> <li> Extensive Study Notes </li> <li> 40+ Hours of Video Lessons </li> <li> 3,000+ Practice Questions </li><li> 5 Full-Length Mock Exams </li> <li> Unlimited Customizable Quizzes </li> <li> Tutors Answering your Questions via Live Chat</li></ul></div>',
	  PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO: 'Please subscribe to get access to this video',
	  FRM_CAPSULES_CHAPTER_NAME: 'Concept Capsules - Concept Capsules for FRM® Exams - Review some important concepts',
	  BACK_TO_VIDEOS: 'Back to Videos',
	  GO_TO_NOTES: 'Go to Notes',
	  FURTHER_HELP: 'I need further help',
	  GO_TO_QUESTION_BANK: 'Go to Question Bank',
	  REPORT_THIS_VIDEO: "Report this video to analystprep's team for review",
	  Download_PDF: 'Download PDF',
	  PDF_NOT_AVAILABLE: 'PDF not available for this video',
	  PDF_DOWNLOAD_NOT_AVAILABLE: 'This PDF is not available for download yet. Please try again later.',
	  CFA1_2025_PREMIUM_POPUP: '<div class="modal-info-list"><ul> <li> Extensive Study Notes </li> <li> 40+ Hours of Video Lessons </li> <li> 3,000+ Practice Questions </li><li> 5 Full-Length Mock Exams </li> <li> Unlimited Customizable Quizzes </li> <li> Tutors Answering your Questions via Live Chat</li></ul></div>',
	  QUIZ_PRIORITY: 'You can priorities quiz on the basis of below options.',
	  NON_ATTEMPTED_QUIZ: 'Insufficient non-attempted cases available.',
	  FILTER_QUIZZES: 'Filter Quizzes',
	  NONE: 'No filter',
	  NON_ATTEMPTED_CASES: 'Non-attempted cases',
	  CASES_NOT_AVAILABLE: 'Insufficient cases available.',
	  STUDY_NOTES: 'Study Notes',
	  VIDEO_LESSONS: 'Video Lessons',
	  QUIZZES: 'Quizzes',
	  ESSAY_QUESTION: 'Essay Question',
	  CBT_MOCK_EXAM: 'CBT Mock Exams',
	  PATHWAY_EXAM_LIST: 'Pathway Exams',
	  PATHWAY_SESSION: 'Pathway Session',
	  TUTORING: 'Tutoring',
	  UPGRADE_ACCOUNT: 'Upgrade Account',
	  PACKAGE: 'Package',
	  PRICE: 'Price',
	  DISCOUNT: 'Discount',
	  TOTAL: 'Total',
	  ORDER_ID: 'Order ID',
	  NAME: 'Name',
	  PAYMENT_METHOD: 'Payment Method',
	  EMAIL: 'Email',
	  CORRECT: 'Correct',
	  INCORRECT: 'Incorrect',
	  START_STUDY: 'Start Studying',
	  GRAPHICAL_INTERPRETATION: 'Graphics Interpretation',
	  OPEN_CALCULATOR: 'Open Calculator',
	  RATING_THIS_QUESTION: 'Rate this Question',
	  TWO_PART_ANALYSIS: 'Two-Part Analysis',
	  SAVE_ITEM_DESCRIPTION: 'Save this item on your dashboard for further review. You will also be able to create a flashcard.',
	  QUESTION_SAVED: 'Question saved',
	  RATED: 'Rated',
	  THANK_YOU_FOR_YOUR_ORDER: 'Thank You for your Order!',
	  REPORT_SUBMISSION_FAILED: 'Report submission failed',
	  PURCHASE_CONFIRMATION: 'You will also receive confirmation of your purchase via email',
	  ORDER_NOT_FOUND: "Oops! We couldn't locate any order. It looks like your order is not available in our database. Please check with correct order details.",
	  USER_SESSION_NOT_FOUND: 'User session is missing or expired.',
	  QUIZ_DATA_FETCH_ERROR: 'Unable to retrieve quiz data. Please try again.',
	  QUESTION_NOT_FOUND: 'The requested question does not exist.',
	  QUESTION_DETAILS_ERROR: 'Unable to load question details.',
	  QUESTION_API_ERROR: 'There was a problem fetching question details.',
	  CHECK_ANSWERED_ERROR: 'Could not verify if the question has been answered.',
	  QUIZ_FINISHED: 'Quiz Finished',
	  ARE_YOU_SURE: 'Are you sure?',
	  YES: 'Yes',
	  LOADING: 'Loading',
	  EMAIL_UNSUBSCRIBED: 'You\'re currently unsubscribed from email. Want back in? ',
	  CLICK_TO_RESUBSCRIBE: 'Click here to resubscribe.',
	  SAVE_QUESTION: 'Save this item on your dashboard for further review. You will also be able to create a flashcard.',
	  SETTINGS_TITLE: 'Question Bank Settings',
	  QUESTION_BANK_MODE_TYPE: 'Question Bank Mode Type',
	  PRACTICE_MODE_DESC: 'Used to reattempt questions.',
	  REVISION_MODE_DESC: 'Used for learning, shows your last selected choice.',
	  MODE_CHANGE_NOTE: 'Note:  You can switch between modes later using the dropdown menu on the question bank page.',
	  SAVE: 'Save',
	  QUESTION_MODE_SAVE_SUCCESS: ':mode is now active. Time to sharpen your skills!',
	  QUESTION_MODE_SAVE_FAILED: 'Failed to save question mode. Please try again.',
	  WEBINARS: 'Live Sessions'
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showInformation = exports.showFailure = exports.showSuccess = undefined;
	
	var _sweetalert = __webpack_require__(1246);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param {*} message
	 */
	var showSuccess = exports.showSuccess = function showSuccess(message) {
	  var Toast = _sweetalert2.default.mixin({
	    toast: true,
	    position: 'top-end',
	    showConfirmButton: false,
	    timer: 5000,
	    timerProgressBar: true
	  });
	
	  Toast.fire({
	    type: 'success',
	    title: message,
	    icon: 'success'
	  });
	};
	var showFailure = exports.showFailure = function showFailure(message) {
	  var Toast = _sweetalert2.default.mixin({
	    toast: true,
	    position: 'top-end',
	    showConfirmButton: false,
	    timer: 5000,
	    timerProgressBar: true
	  });
	
	  Toast.fire({
	    type: 'warning',
	    title: message,
	    icon: 'warning'
	  });
	};
	
	var showInformation = exports.showInformation = function showInformation(message) {
	  var Toast = _sweetalert2.default.mixin({
	    toast: true,
	    position: 'top-end',
	    showConfirmButton: false,
	    timer: 3000,
	    timerProgressBar: true
	  });
	
	  Toast.fire({
	    type: 'info',
	    title: message,
	    icon: 'info'
	  });
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _WebinarRESTService = __webpack_require__(139);
	
	var _WebinarRESTService2 = _interopRequireDefault(_WebinarRESTService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mobx = __webpack_require__(37);
	
	
	var extendObservable = mobx.extendObservable;
	var action = mobx.action;
	var runInAction = mobx.runInAction;
	
	function UserStore() {
	    var self = this;
	
	    extendObservable(this, {
	        token: null,
	        profileInfo: null,
	        subscription_details: null,
	        landingSource: null,
	        landingSourceName: null,
	        loading: false,
	        error: null,
	        apiVersion: null,
	        isUserWebinarsAvailable: false
	    });
	
	    this._profileFetchPromise = null;
	    this._webinarsCountPromise = null;
	    this._apiFetchPromise = null;
	
	    this.setToken = action(function (token) {
	        self.token = token;
	    });
	
	    this.setProfileInfo = action(function (profileInfo) {
	        self.profileInfo = profileInfo;
	    });
	
	    this.clear = action(function () {
	        self.token = null;
	        self.profileInfo = null;
	        self.error = null;
	    });
	
	    //Concurrent safe fetch profile info
	    this.fetchProfile = action(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(idname) {
	            var resp, _resp;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(self._profileFetchPromise != null)) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return self._profileFetchPromise;
	
	                        case 4:
	                            resp = _context.sent;
	                            return _context.abrupt('return', resp && resp.success ? resp.profileInfo : null);
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context['catch'](1);
	                            return _context.abrupt('return', null);
	
	                        case 11:
	
	                            self.loading = true;
	                            self.error = null;
	
	                            self._profileFetchPromise = _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', {
	                                token: self.token,
	                                idname: idname
	                            });
	
	                            _context.prev = 14;
	                            _context.next = 17;
	                            return self._profileFetchPromise;
	
	                        case 17:
	                            _resp = _context.sent;
	
	                            if (!(_resp && _resp.success)) {
	                                _context.next = 23;
	                                break;
	                            }
	
	                            runInAction(function () {
	                                self.profileInfo = _resp.profileInfo;
	                                self.subscription_details = _resp.subscription_details;
	                                self.landingSource = _resp.landingSource;
	                                self.landingSourceName = _resp.landingSourceName;
	                                self.loading = false;
	                            });
	                            return _context.abrupt('return', _resp.profileInfo);
	
	                        case 23:
	                            runInAction(function () {
	                                self.error = new Error('Profile request failed');
	                                self.loading = false;
	                            });
	                            return _context.abrupt('return', null);
	
	                        case 25:
	                            _context.next = 31;
	                            break;
	
	                        case 27:
	                            _context.prev = 27;
	                            _context.t1 = _context['catch'](14);
	
	                            runInAction(function () {
	                                self.error = _context.t1;
	                                self.loading = false;
	                            });
	                            return _context.abrupt('return', null);
	
	                        case 31:
	                            _context.prev = 31;
	
	                            runInAction(function () {
	                                self._profileFetchPromise = null;
	                            });
	                            return _context.finish(31);
	
	                        case 34:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[1, 8], [14, 27, 31, 34]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }());
	
	    this.fetchApiVersion = action(_asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var resp, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.prev = 0;
	                        _context2.next = 3;
	                        return fetch(_App_data2.default.backend_api + '/version', {
	                            method: 'GET',
	                            headers: {
	                                'Content-Type': 'application/json'
	                            }
	                        });
	
	                    case 3:
	                        resp = _context2.sent;
	                        _context2.next = 6;
	                        return resp.json();
	
	                    case 6:
	                        data = _context2.sent;
	
	                        if (!(data != null)) {
	                            _context2.next = 10;
	                            break;
	                        }
	
	                        runInAction(function () {
	                            self.apiVersion = data;
	                        });
	                        return _context2.abrupt('return', data);
	
	                    case 10:
	                        return _context2.abrupt('return', null);
	
	                    case 13:
	                        _context2.prev = 13;
	                        _context2.t0 = _context2['catch'](0);
	
	                        console.warn('Cannot get api version: ' + _context2.t0.message);
	                        return _context2.abrupt('return', null);
	
	                    case 17:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this, [[0, 13]]);
	    })));
	
	    //Concurrent & state exist safe get profile info
	    this.getUserProfile = action(_asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var fullData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        if (!(self.profileInfo == null)) {
	                            _context3.next = 3;
	                            break;
	                        }
	
	                        _context3.next = 3;
	                        return self.fetchProfile();
	
	                    case 3:
	                        if (!fullData) {
	                            _context3.next = 5;
	                            break;
	                        }
	
	                        return _context3.abrupt('return', {
	                            profileInfo: self.profileInfo,
	                            subscription_details: self.subscription_details,
	                            landingSource: self.landingSource,
	                            landingSourceName: self.landingSourceName
	                        });
	
	                    case 5:
	                        return _context3.abrupt('return', self.profileInfo);
	
	                    case 6:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    })));
	
	    this.getSubscriptionDetails = action(_asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        if (!(self.profileInfo == null)) {
	                            _context4.next = 3;
	                            break;
	                        }
	
	                        _context4.next = 3;
	                        return self.fetchProfile();
	
	                    case 3:
	                        return _context4.abrupt('return', self.subscription_details);
	
	                    case 4:
	                    case 'end':
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    })));
	
	    this.getUsersLandingSource = action(_asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        if (!self.profileInfo) {
	                            _context5.next = 3;
	                            break;
	                        }
	
	                        _context5.next = 3;
	                        return self.fetchProfile();
	
	                    case 3:
	                        return _context5.abrupt('return', {
	                            landingSource: self.landingSource,
	                            landingSourceName: self.landingSourceName
	                        });
	
	                    case 4:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, this);
	    })));
	
	    this.getUserWebinarsCount = action(function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(debug) {
	            var resp, data;
	            return _regenerator2.default.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            if (!(self._webinarsCountPromise != null)) {
	                                _context6.next = 11;
	                                break;
	                            }
	
	                            _context6.prev = 1;
	                            _context6.next = 4;
	                            return self._webinarsCountPromise;
	
	                        case 4:
	                            resp = _context6.sent;
	                            return _context6.abrupt('return', resp && resp.count != null ? resp.count : 0);
	
	                        case 8:
	                            _context6.prev = 8;
	                            _context6.t0 = _context6['catch'](1);
	                            return _context6.abrupt('return', 0);
	
	                        case 11:
	                            self._webinarsCountPromise = new _WebinarRESTService2.default().setAuthHeader(self.token).getWebinarsCountByExam();
	                            _context6.prev = 12;
	                            _context6.next = 15;
	                            return self._webinarsCountPromise;
	
	                        case 15:
	                            data = _context6.sent;
	
	                            if (data && data.count != null) {
	                                runInAction(function () {
	                                    self.isUserWebinarsAvailable = data.count > 0;
	                                });
	                            }
	                            return _context6.abrupt('return', data && data.count != null ? data.count : 0);
	
	                        case 20:
	                            _context6.prev = 20;
	                            _context6.t1 = _context6['catch'](12);
	
	                            runInAction(function () {
	                                self.isUserWebinarsAvailable = false;
	                            });
	                            console.log("Error in getWebinarsCountByExam", _context6.t1);
	
	                        case 24:
	                            _context6.prev = 24;
	
	                            runInAction(function () {
	                                self._webinarsCountPromise = null;
	                            });
	                            return _context6.finish(24);
	
	                        case 27:
	                        case 'end':
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, this, [[1, 8], [12, 20, 24, 27]]);
	        }));
	
	        return function (_x3) {
	            return _ref6.apply(this, arguments);
	        };
	    }());
	}
	
	//Debug Store
	// mobx.spy(function (event) {
	//     // event.type can be 'action', 'reaction', 'update' и т.д.
	//     if (event.type === 'action') {
	//         console.log(
	//             '[MobX ACTION]',
	//             event.name,
	//             'args:',
	//             event.arguments
	//         );
	//     }
	//     if (event.type === 'reaction') {
	//         console.log(
	//             '[MobX REACTION]',
	//             event.name
	//         );
	//     }
	//     if (event.type === 'update') {
	//         // will fire when a specific observable field has changed
	//         console.log(
	//             '[MobX UPDATE]',
	//             event.object && event.object.constructor && event.object.constructor.name,
	//             event.key,
	//             '=>',
	//             event.newValue
	//         );
	//     }
	// });
	
	exports.default = new UserStore();

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIpAddress = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// import GD from "../views/RestAPI/getData";
	var getIpAddress = exports.getIpAddress = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var data;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.prev = 0;
	            data = {};
	            // await GD.GetCallAPI('https://geolocation-db.com/json/').then((resp) => {
	            //   data = {
	            //     city: "",
	            //     country: '',
	            //     query: "",
	            //     region: "",
	            //     continent: '',
	            //   };
	            // });
	
	            data = {
	              city: '',
	              country: '',
	              query: '',
	              region: '',
	              continent: ''
	            };
	            return _context.abrupt('return', data);
	
	          case 6:
	            _context.prev = 6;
	            _context.t0 = _context['catch'](0);
	
	          case 8:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[0, 6]]);
	  }));
	
	  return function getIpAddress() {
	    return _ref.apply(this, arguments);
	  };
	}();

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValidateSaveReportIcon = function (_Component) {
	  _inherits(ValidateSaveReportIcon, _Component);
	
	  function ValidateSaveReportIcon(props) {
	    _classCallCheck(this, ValidateSaveReportIcon);
	
	    var _this = _possibleConstructorReturn(this, (ValidateSaveReportIcon.__proto__ || Object.getPrototypeOf(ValidateSaveReportIcon)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ValidateSaveReportIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          all_questions = _props.all_questions,
	          _getResult = _props._getResult,
	          _saveQuestion = _props._saveQuestion,
	          _displayReportForm = _props._displayReportForm,
	          bookmarkCSS = _props.bookmarkCSS,
	          bookmarkColor = _props.bookmarkColor,
	          save_text = _props.save_text,
	          isQue = _props.isQue,
	          _saveNotesstats = _props._saveNotesstats,
	          saveNotes_text = _props.saveNotes_text,
	          markColor = _props.markColor,
	          isSpecialQuestion = _props.isSpecialQuestion,
	          showResult = _props.showResult,
	          clicked = _props.clicked;
	      // console.log('props', this.props);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: isQue ? 'col-lg-6 col-md-12 d-flex align-items-center' : 'col-sm-12 col-md-12 d-flex'
	        },
	        clicked || isQue ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'btn btn-primary pointer_class margin_right_10 ' + (showResult && 'cursor_not_Allowed'),
	            onClick: _getResult.bind(this, all_questions),
	            style: { height: '38px' },
	            disabled: this.props.disabled || showResult
	          },
	          ' ',
	          _language2.default.LC().VALIDATE
	        ) : _react2.default.createElement(
	          'span',
	          { className: 'up tooltip-hover-questions ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            ' ',
	            save_text,
	            ' '
	          ),
	          _react2.default.createElement('i', {
	            onClick: _saveNotesstats.bind(this, all_questions),
	            className: 'fa fa-check mark-action-btn',
	            'aria-hidden': 'true',
	            style: { backgroundColor: '' + markColor }
	          })
	        ),
	        isSpecialQuestion !== true ? _react2.default.createElement(
	          'span',
	          { className: 'up tooltip-hover-questions', style: { marginRight: '10px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            ' ',
	            isQue ? save_text : saveNotes_text,
	            ' '
	          ),
	          _react2.default.createElement(
	            'i',
	            {
	              onClick: _saveQuestion.bind(this, all_questions),
	              className: bookmarkCSS,
	              style: { color: bookmarkColor }
	            },
	            ' '
	          )
	        ) : null,
	        isSpecialQuestion !== true ? _react2.default.createElement(
	          'span',
	          { className: 'up tooltip-hover-questions vertical-align-middle' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            ' ',
	            _language2.default.LC().REPORT_THIS_QUESTION,
	            ' '
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'report-icon-wrapper',
	              onClick: _displayReportForm.bind(this, all_questions)
	            },
	            _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/report4.png', alt: 'report' })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return ValidateSaveReportIcon;
	}(_react.Component);
	
	exports.default = ValidateSaveReportIcon;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Tooltip = __webpack_require__(188);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactstrap = __webpack_require__(6);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var FlashCard = function (_Component) {
	  _inherits(FlashCard, _Component);
	
	  function FlashCard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FlashCard);
	
	    var _this = _possibleConstructorReturn(this, (FlashCard.__proto__ || Object.getPrototypeOf(FlashCard)).call(this, props));
	
	    _this.toggleFlash = function () {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this.onHandleChange = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.getFlashcard = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, id_name, token, _this$props, _this$props$type, type, _this$props$question_, question_type, _this$props$exam, exam, _this$props$level, level, _this$props$item, item, _item$id, id, payload, getFlashCard;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, id_name = _this$state.id_name, token = _this$state.token;
	              _this$props = _this.props, _this$props$type = _this$props.type, type = _this$props$type === undefined ? '' : _this$props$type, _this$props$question_ = _this$props.question_type, question_type = _this$props$question_ === undefined ? '' : _this$props$question_, _this$props$exam = _this$props.exam, exam = _this$props$exam === undefined ? '' : _this$props$exam, _this$props$level = _this$props.level, level = _this$props$level === undefined ? '' : _this$props$level, _this$props$item = _this$props.item, item = _this$props$item === undefined ? {} : _this$props$item;
	              _item$id = item.id, id = _item$id === undefined ? '' : _item$id;
	              payload = {
	                id_name: id_name,
	                token: token,
	                type: type,
	                question_type: question_type,
	                exam: exam,
	                level: level,
	                item_id: id
	              };
	              _context.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/getFlashcards', payload);
	
	            case 6:
	              getFlashCard = _context.sent;
	
	              if (getFlashCard.success) {
	                _this.setState({ flashData: getFlashCard.flash_cards, comment: '', isFlashEditMode: false });
	              } else {
	                _this.setState({ flashData: {}, comment: '', isFlashEditMode: false });
	              }
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.saveFlashCard = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state2, comment, id_name, token, _this$props2, _this$props2$type, type, _this$props2$question, question_type, _this$props2$exam, exam, _this$props2$level, level, _this$props2$item, item, _item$id2, id, payload, saveFlashCard;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	
	              _this.setState({ isLoading: true });
	              _this$state2 = _this.state, comment = _this$state2.comment, id_name = _this$state2.id_name, token = _this$state2.token;
	              _this$props2 = _this.props, _this$props2$type = _this$props2.type, type = _this$props2$type === undefined ? '' : _this$props2$type, _this$props2$question = _this$props2.question_type, question_type = _this$props2$question === undefined ? '' : _this$props2$question, _this$props2$exam = _this$props2.exam, exam = _this$props2$exam === undefined ? '' : _this$props2$exam, _this$props2$level = _this$props2.level, level = _this$props2$level === undefined ? '' : _this$props2$level, _this$props2$item = _this$props2.item, item = _this$props2$item === undefined ? {} : _this$props2$item;
	              _item$id2 = item.id, id = _item$id2 === undefined ? '' : _item$id2;
	              payload = {
	                id_name: id_name,
	                token: token,
	                type: type,
	                question_type: question_type,
	                exam: exam,
	                level: level,
	                flash_card: comment,
	                item_id: id
	              };
	              //* API CALLED HERE FOR SAVE FLASHCARD COMMENT
	
	              _context2.next = 8;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/saveFlashCard', payload);
	
	            case 8:
	              saveFlashCard = _context2.sent;
	
	              if (saveFlashCard.success) {
	                _this.setState({ flash_data: '', isLoading: false }, function () {
	                  (0, _toast.showSuccess)(saveFlashCard.message);
	                  _this.getFlashcard();
	                });
	              } else {
	                _this.setState({ isLoading: false });
	              }
	              _context2.next = 16;
	              break;
	
	            case 12:
	              _context2.prev = 12;
	              _context2.t0 = _context2['catch'](0);
	
	              (0, _toast.showFailure)(_context2.t0.message);
	              _this.setState({ isLoading: false });
	
	            case 16:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[0, 12]]);
	    }));
	    _this.editFlash = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var flashData;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              flashData = _this.state.flashData;
	
	              if (flashData.item_id) {
	                _this.setState({ comment: flashData.flash_card, isFlashEditMode: true }, function () {
	                  _this.setState({ flashData: '' });
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.deleteFlash = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state3, id_name, token, _this$props3, _this$props3$type, type, _this$props3$question, question_type, _this$props3$exam, exam, _this$props3$level, level, _this$props3$item, item, _item$id3, id, payload, response;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	
	              _this.setState({ isLoading: true });
	              _this$state3 = _this.state, id_name = _this$state3.id_name, token = _this$state3.token;
	              _this$props3 = _this.props, _this$props3$type = _this$props3.type, type = _this$props3$type === undefined ? '' : _this$props3$type, _this$props3$question = _this$props3.question_type, question_type = _this$props3$question === undefined ? '' : _this$props3$question, _this$props3$exam = _this$props3.exam, exam = _this$props3$exam === undefined ? '' : _this$props3$exam, _this$props3$level = _this$props3.level, level = _this$props3$level === undefined ? '' : _this$props3$level, _this$props3$item = _this$props3.item, item = _this$props3$item === undefined ? {} : _this$props3$item;
	              _item$id3 = item.id, id = _item$id3 === undefined ? '' : _item$id3;
	              payload = {
	                id_name: id_name,
	                token: token,
	                type: type,
	                question_type: question_type,
	                exam: exam,
	                level: level,
	                item_id: id
	              };
	              _context4.next = 8;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	            case 8:
	              response = _context4.sent;
	
	              if (response.success) {
	                (0, _toast.showSuccess)(response.message);
	              }
	              _this.setState({
	                flashData: {},
	                comment: '',
	                isFlashEditMode: false,
	                isDeleteModal: false,
	                isLoading: false
	              });
	              _context4.next = 17;
	              break;
	
	            case 13:
	              _context4.prev = 13;
	              _context4.t0 = _context4['catch'](0);
	
	              _this.setState({
	                flashData: {},
	                comment: '',
	                isFlashEditMode: false,
	                isDeleteModal: false,
	                isLoading: false
	              });
	              (0, _toast.showFailure)(_context4.t0.message);
	
	            case 17:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2, [[0, 13]]);
	    }));
	
	    _this.state = {
	      comment: '',
	      id_name: '',
	      token: '',
	      flashData: {},
	      isFlashCardHidden: props.isFlashCardHidden,
	      isFlashEditMode: false,
	      isLoading: false,
	      isDeleteModal: false
	    };
	    return _this;
	  }
	
	  _createClass(FlashCard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      if (storage_session) {
	        var _storage_session$toke = storage_session.token,
	            token = _storage_session$toke === undefined ? '' : _storage_session$toke,
	            id_name = storage_session.idname;
	
	        this.setState({
	          id_name: id_name,
	          token: token
	        }, function () {
	          _this3.getFlashcard();
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(prevProps) {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!(prevProps.item.id !== this.props.item.id)) {
	                  _context5.next = 4;
	                  break;
	                }
	
	                this.setState({ isFlashEditMode: false });
	                _context5.next = 4;
	                return this.getFlashcard();
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidUpdate(_x) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	    //* {{ GET }}   FLASHCARD FUNCTIONALITY STARTED HERE
	
	    //* {{ SAVE }}  FLASHCARD FUNCTIONALITY STARTED HERE
	
	    //* {{ EDIT }}  FLASHCARD FUNCTIONALITY STARTED HERE
	
	    //* {{ DELETE}} FLASHCARD FUNCTIONALITY STARTED HERE
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          comment = _state.comment,
	          flashData = _state.flashData,
	          isFlashEditMode = _state.isFlashEditMode,
	          isLoading = _state.isLoading,
	          isDeleteModal = _state.isDeleteModal;
	      var isFlashCardHidden = this.props.isFlashCardHidden;
	
	
	      return !isFlashCardHidden && _react2.default.createElement(
	        'div',
	        { className: 'col-md-12' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header pointer_class', onClick: this.toggleFlash },
	            _language2.default.LC().FLASHCARD,
	            ' ',
	            '  ',
	            _react2.default.createElement(_Tooltip2.default, {
	              placement: 'top',
	              content: _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	              place_tip: 'top',
	              tooltipId: '1'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/arrow_down_ico.png', className: '', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { ref: 'flash_toggle_div' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col-xs-12 col-sm-12 col-md-12' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12' },
	                  flashData.item_id ? _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'comment_content col-md-10' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        flashData.flash_card
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list col-md-2' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: function onClick() {
	                              return _this4.editFlash(flashData);
	                            }
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: function onClick() {
	                              return _this4.setState({ isDeleteModal: true });
	                            }
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement('textarea', {
	                      id: 'flash_card',
	                      name: 'comment',
	                      value: comment,
	                      rows: '6',
	                      className: 'form-control margin_bottom_10 card',
	                      placeholder: 'Your flash card here',
	                      onChange: this.onHandleChange
	                    }),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-primary active pointer_class',
	                        style: { float: 'right' },
	                        disabled: isLoading,
	                        onClick: this.saveFlashCard
	                      },
	                      isFlashEditMode ? isLoading ? 'Updating...' : 'Update' : isLoading ? 'Creating...' : _language2.default.LC().CREATE
	                    ),
	                    isFlashEditMode && _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-primary active pointer_class',
	                        style: { float: 'right' },
	                        onClick: function onClick() {
	                          return _this4.getFlashcard();
	                        }
	                      },
	                      'Cancel'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: { color: '#6d6d6dde', fontSize: '12px' } },
	                      _language2.default.LC().FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: isDeleteModal
	            // toggle={this.toggleAlertReport}
	            , className: 'modal-primary '
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'Alert',
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'close',
	                'aria-label': 'Close',
	                onClick: function onClick() {
	                  return _this4.setState({ isDeleteModal: !_this4.state.isDeleteModal });
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { 'aria-hidden': 'true' },
	                '\xD7'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Are you sure you want to delete this?'
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-sm btn-primary',
	                  color: 'primary',
	                  disabled: isLoading,
	                  onClick: function onClick() {
	                    return _this4.deleteFlash(flashData);
	                  }
	                },
	                isLoading ? 'Deleting...' : 'Ok'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FlashCard;
	}(_react.Component);
	
	exports.default = FlashCard;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1064)();
	}


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComponentHeader(props) {
	  var title = props.title,
	      children = props.children,
	      className = props.className;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className + ' margin_bottom_20 d-flex justify-content-between flex-wrap align-items-center',
	      style: { gap: '8px' }
	    },
	    _react2.default.createElement(
	      'h1',
	      { className: 'section_head' },
	      title
	    ),
	    children
	  );
	}
	
	exports.default = ComponentHeader;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _isomorphicFetch = __webpack_require__(199);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _toast = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getDataHelper = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(apiEndPoint) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var _ref2, _ref2$token, token, headers, queryString, urlWithParams, response, responseData;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            // Retrieve token from localStorage
	            _ref2 = JSON.parse(localStorage.getItem('localstorageval')) || {}, _ref2$token = _ref2.token, token = _ref2$token === undefined ? '' : _ref2$token;
	
	            // Construct headers
	
	            headers = token ? { Authorization: token } : {};
	            // Create query string manually
	
	            queryString = Object.entries(data).filter(function (_ref3) {
	              var _ref4 = _slicedToArray(_ref3, 2),
	                  value = _ref4[1];
	
	              return value;
	            }) // Keep only non-empty values
	            //encodeURIComponent ensures that special characters are properly formatted so they do not disrupt the structure of the URL or cause errors.
	            .map(function (_ref5) {
	              var _ref6 = _slicedToArray(_ref5, 2),
	                  key = _ref6[0],
	                  value = _ref6[1];
	
	              return encodeURIComponent(key) + '=' + encodeURIComponent(value);
	            }).join('&');
	
	            // Construct URL with parameters
	
	            urlWithParams = queryString ? apiEndPoint + '?' + queryString : apiEndPoint;
	
	            // Make the fetch request and return the JSON response
	
	            response = {};
	            _context.next = 7;
	            return (0, _isomorphicFetch2.default)(urlWithParams, { method: 'GET', headers: headers });
	
	          case 7:
	            response = _context.sent;
	            _context.next = 10;
	            return response.json();
	
	          case 10:
	            responseData = _context.sent;
	            // Parse the response once
	
	            if (responseData && !responseData.success && responseData.message === 'token is invalid') {
	              localStorage.removeItem('localstorageval');
	              (0, _toast.showFailure)('Token has been expired');
	              _reactRouter.browserHistory.push('/');
	            }
	
	            // Return the parsed response data instead of calling `response.json()` again
	            return _context.abrupt('return', responseData);
	
	          case 13:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getDataHelper(_x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	exports.callAPI = getDataHelper;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoaderWrapper(_ref) {
	  var _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === undefined ? true : _ref$isLoading,
	      children = _ref.children;
	
	  return isLoading ? _react2.default.createElement(_loader2.default, null) : children;
	}
	
	exports.default = LoaderWrapper;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(57);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 28 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(90);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(222);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(112);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1163);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(466);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1159);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1174);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1160);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1161);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(468);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1162);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(223);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1172);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(473);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1165);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1166);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1170);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(470);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var PDFModelComponent = function (_Component) {
	  _inherits(PDFModelComponent, _Component);
	
	  function PDFModelComponent(props) {
	    _classCallCheck(this, PDFModelComponent);
	
	    var _this = _possibleConstructorReturn(this, (PDFModelComponent.__proto__ || Object.getPrototypeOf(PDFModelComponent)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PDFModelComponent, [{
	    key: "pdfAlertModel",
	    value: function pdfAlertModel(e) {
	      e.preventDefault();
	      this.props.pdfAlertModel(e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          pdfAlert = _props.pdfAlert,
	          PDFContentMessage = _props.PDFContentMessage,
	          type = _props.type;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: pdfAlert,
	          toggle: this.pdfAlertModel.bind(this),
	          className: "modal-primary custom_modalpro info-modal-designing" + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          {
	            toggle: this.pdfAlertModel.bind(this),
	            className: "custom-title"
	          },
	          _react2.default.createElement("i", { className: "fa fa-download", "aria-hidden": "true" }),
	          " ",
	          type,
	          " ",
	          _language2.default.LC().PDFDOWNLOAD,
	          " "
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: "text-center payment-section-wrap" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-info-view-for-plan " },
	            _react2.default.createElement("img", {
	              src: _App_data2.default.frontend_url + "/img/" + "cloud-computing.png",
	              className: "mb-2",
	              width: "90px",
	              height: "90px",
	              alt: ""
	            }),
	            _react2.default.createElement(
	              "div",
	              {
	                contentEditable: "false"
	              },
	              (0, _function.renderHTMLContent)(PDFContentMessage, "div", "", { contentEditable: "false" })
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "btn btn-primary pointer_class",
	                onClick: this.pdfAlertModel.bind(this)
	              },
	              _language2.default.LC().GO_TO_ANSWER
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PDFModelComponent;
	}(_react.Component);
	
	exports.default = PDFModelComponent;

/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	var checkCfa2Subscription = function checkCfa2Subscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  //console.log(selectedLevel);
	  //console.log(exam_data);
	  //console.log(cfaUnlimitedPackage);
	  //console.log(cfaUnlimitedActiveExam);
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	var checkCfa2NotesSubscription = function checkCfa2NotesSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	------------------------
	  Check for videos
	-----------------------
	*/
	var checkCfa2VideosSubscription = function checkCfa2VideosSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	-----------------------
	  Check for PDF's
	----------------------
	*/
	var checkCfa2PDFSubscription = function checkCfa2PDFSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, type) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                flag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                flag = true;
	              }
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	exports.checkCfa2Subscription = checkCfa2Subscription;
	exports.checkCfa2NotesSubscription = checkCfa2NotesSubscription;
	exports.checkCfa2VideosSubscription = checkCfa2VideosSubscription;
	exports.checkCfa2PDFSubscription = checkCfa2PDFSubscription;

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	/*
	  Mock packages grant ONLY mock exams — never quizzes, questions, notes, videos
	  or PDFs (subscription-dataflow.md § "Mock packages").
	
	  Callers that pass `examPlanData` (resp_exam.examPlan[0]) are the pages that must
	  not open on a mock. That argument used to short-circuit every check to false
	  whenever examPlan[0] was a mock — an ARBITRARY row (no ORDER BY, so effectively
	  the lowest owned plan id). Monthly plans have higher ids than the mock plans, so
	  a partner owning a mock and a monthly subscription was always denied, and so was
	  a CFA Unlimited holder whose examPlan[0] happened to be a mock. For those callers
	  mock levels are now skipped per level, which does not depend on order. Callers
	  that do not pass examPlanData keep their previous behaviour. Same approach as
	  Cfa1Subscription.js (D32).
	*/
	var checkCfa2Subscription = function checkCfa2Subscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              // here  inside if check for partner user  partner package suscription
	              if (exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              // here inside else check for  partner user normal app package subscription
	              if (exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	/*
	---------------------------
	   Check for Notes 
	---------------------------
	*/
	var checkCfa2NotesSubscription = function checkCfa2NotesSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -----------------------
	                 for partner users
	              -----------------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — mirror non-partner: pkg 21 is L2's matching-exam unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              ------------------
	                 for app users
	              ------------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L2.
	              // Was pkg 16 (legacy copy-paste from Cfa1) which never matches.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	------------------------
	  Check for videos
	-----------------------
	*/
	var checkCfa2VideosSubscription = function checkCfa2VideosSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -----------------
	                For Partner
	              -----------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — mirror non-partner: pkg 21 is L2's matching-exam unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              -------------
	                For App
	              -------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L2.
	              // Was pkg 16 (legacy copy-paste from Cfa1) which never matches
	              // any active plan, so the original code was dead.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	-----------------------
	  Check for PDF's
	----------------------
	*/
	var checkCfa2PDFSubscription = function checkCfa2PDFSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, type, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -------------
	                For Partner
	              -------------
	              */
	
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                  flag = true;
	                }
	              } else if (
	              // #261 — mirror non-partner: pkg 21 is L2's matching-exam unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              -------------
	                For App
	              -------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                  flag = true;
	                }
	              } else if (
	              // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L2.
	              // Was pkg 16 (legacy copy-paste from Cfa1) which never matches
	              // any active plan, so the original code was dead.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	exports.checkCfa2NotesSubscription = checkCfa2NotesSubscription;
	exports.checkCfa2VideosSubscription = checkCfa2VideosSubscription;
	exports.checkCfa2PDFSubscription = checkCfa2PDFSubscription;
	
	exports.checkCfa2Subscription = checkCfa2Subscription;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(909)
	var ieee754 = __webpack_require__(1049)
	var isArray = __webpack_require__(914)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(1194);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _starRatings = __webpack_require__(1196);
	
	var _starRatings2 = _interopRequireDefault(_starRatings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// polyfill for ie
	Number.isInteger = Number.isInteger || function (value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	};
	
	exports.default = _starRatings2.default;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _HighlightText = __webpack_require__(520);
	
	var _HighlightText2 = _interopRequireDefault(_HighlightText);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ViewQuestion(props) {
	  var question = props.question,
	      id = props.id,
	      children = props.children,
	      correctChoice = props.correctChoice,
	      showAnswer = props.showAnswer,
	      selectedChoice = props.selectedChoice,
	      setAnswer = props.setAnswer,
	      _props$selectedChoice = props.selectedChoiceClassName,
	      selectedChoiceClassName = _props$selectedChoice === undefined ? 'clicked_box' : _props$selectedChoice,
	      _props$correctChoiceC = props.correctChoiceClassName,
	      correctChoiceClassName = _props$correctChoiceC === undefined ? 'success' : _props$correctChoiceC,
	      _props$incorrectChoic = props.incorrectChoiceClassName,
	      incorrectChoiceClassName = _props$incorrectChoic === undefined ? 'failure' : _props$incorrectChoic,
	      strikeText = props.strikeText,
	      _props$strikeThroughA = props.strikeThroughArr,
	      strikeThroughArr = _props$strikeThroughA === undefined ? [] : _props$strikeThroughA,
	      _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params,
	      _props$shouldHighLigh = props.shouldHighLight,
	      shouldHighLight = _props$shouldHighLigh === undefined ? false : _props$shouldHighLigh;
	
	  var choices = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _ref = _step.value;
	
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var key = _ref2[0];
	      var value = _ref2[1];
	
	      if (key.startsWith('choice')) {
	        choices.push(_defineProperty({}, key, value));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      null,
	      shouldHighLight ? _react2.default.createElement(_HighlightText2.default, { params: params, content: question }) : (0, _function.renderHTMLContent)(question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: false })
	    ),
	    choices.map(function (element, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'col-sm-12',
	          id: Object.keys(element),
	          key: Object.keys(element) + '/' + id,
	          onClick: function onClick() {
	            return !showAnswer && setAnswer(Object.keys(element));
	          },
	          onContextMenu: function onContextMenu(event) {
	            return strikeText(event, Object.keys(element));
	          },
	          disabled: showAnswer
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'answer_box ' + (strikeThroughArr.includes(Object.keys(element)[0]) ? 'strikethrough' : '') + ' ' + (!showAnswer && selectedChoice === Object.keys(element)[0] ? selectedChoiceClassName : '') + ' ' + (showAnswer && Object.keys(element)[0] === correctChoice ? correctChoiceClassName : '') + '\n                ' + (showAnswer && selectedChoice === Object.keys(element)[0] && selectedChoice !== correctChoice ? incorrectChoiceClassName : '') + '\n                '
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'answer_count' },
	            String.fromCharCode(index + 65)
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ans_box_text' },
	            (0, _function.renderHTMLContent)(element[Object.keys(element)], "span", "", { contentEditable: false })
	          )
	        )
	      );
	    }),
	    children
	  );
	}
	
	exports.default = ViewQuestion;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	if (typeof process !== 'undefined' && ("production") === 'production') {
	    module.exports = __webpack_require__(1059);
	} else {
	    module.exports = __webpack_require__(1058);
	}
	        
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomButton(_ref) {
	  var onClick = _ref.onClick,
	      children = _ref.children,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      btnColor = _ref.btnColor,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      className: 'btn active pointer_class ' + (className || '') + ' ' + (btnColor ? 'btn-' + btnColor : 'btn-primary'),
	      disabled: disabled,
	      onClick: onClick,
	      style: style
	    },
	    children
	  );
	}
	
	exports.default = CustomButton;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nextAwareRoute = exports.isNextPath = exports.getCurrentPath = undefined;
	
	var _SHARED_TO_NEXT;
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// #cfa1-2027 — keep a 2027 user inside the year-free /cfa1/2027/... tree when the reused
	// CFA1-2025 view components navigate internally. Each shared CFA1 route constant maps to its
	// /next/ (2027) equivalent; nextAwareRoute() swaps to it only while the current route is under
	// /next/, so 2025/2026 navigation is completely unaffected.
	var SHARED_TO_NEXT = (_SHARED_TO_NEXT = {}, _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_DASHBOARD, _AppRoutes2.default.CFA1_2027_NEXT_DASHBOARD), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_DASHBOARD_VIEW_QUESTIONS, _AppRoutes2.default.CFA1_2027_NEXT_DASHBOARD_VIEW_QUESTIONS), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_NOTES, _AppRoutes2.default.CFA1_2027_NEXT_NOTES), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_NOTES_READING_LIST, _AppRoutes2.default.CFA1_2027_NEXT_NOTES_READING_LIST), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_NOTES_VIEW, _AppRoutes2.default.CFA1_2027_NEXT_NOTES_VIEW), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_NOTES_LIST, _AppRoutes2.default.CFA1_2027_NEXT_NOTES_LIST), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_VIDEOS, _AppRoutes2.default.CFA1_2027_NEXT_VIDEOS), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_VIDEO_LIST, _AppRoutes2.default.CFA1_2027_NEXT_VIDEO_LIST), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUESTION_BANK, _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_BANK), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST, _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_BANK_READING_LIST), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUESTIONS_LIST, _AppRoutes2.default.CFA1_2027_NEXT_QUESTIONS_LIST), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUESTION_VIEW, _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_VIEW), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUIZZES, _AppRoutes2.default.CFA1_2027_NEXT_QUIZZES), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START, _AppRoutes2.default.CFA1_2027_NEXT_QUIZ_BEFORE_START), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2025_QUIZ_BEGIN, _AppRoutes2.default.CFA1_2027_NEXT_QUIZ_BEGIN), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2024_CBT, _AppRoutes2.default.CFA1_2027_NEXT_CBT), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK, _AppRoutes2.default.CFA1_2027_NEXT_CBT_VIEW_ATTEMPTED_MOCK), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION, _AppRoutes2.default.CFA1_2027_NEXT_CBT_INTRODUCTION), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2024_CBT_QUESTIONS, _AppRoutes2.default.CFA1_2027_NEXT_CBT_QUESTIONS), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH, _AppRoutes2.default.CFA1_2027_NEXT_CBT_QUESTION_FINISH), _defineProperty(_SHARED_TO_NEXT, _AppRoutes2.default.CFA1_2024_DETAILED_RESULT_GRAPH, _AppRoutes2.default.CFA1_2027_NEXT_DETAILED_RESULT_GRAPH), _SHARED_TO_NEXT);
	
	var NEXT_PREFIX = '/cfa1/2027';
	
	// Current route path, read straight from the browser URL so it works regardless of the react-router
	// history in use: browserHistory keeps the route in window.location.pathname; hashHistory keeps it
	// in the hash (#/path). Prefer the hash when present, else the pathname.
	var getCurrentPath = exports.getCurrentPath = function getCurrentPath() {
	  var hash = window.location && window.location.hash || '';
	  if (hash.length > 1) {
	    return hash.replace(/^#/, '').split('?')[0];
	  }
	  return window.location && window.location.pathname || '';
	};
	
	// True when the current route is inside the 2027 /next/ tree.
	var isNextPath = exports.isNextPath = function isNextPath() {
	  var p = getCurrentPath();
	  return !!p && p.indexOf(NEXT_PREFIX) === 0;
	};
	
	// Given a shared CFA1 route constant (a route template, e.g. '/cfa1/2026/question-bank/.../view'),
	// return the /next/ variant when the user is currently inside the /next/ tree; otherwise return the
	// original constant unchanged. Param substitution stays the caller's job — this only swaps the
	// template. The current route is read from the browser URL (see getCurrentPath).
	var nextAwareRoute = exports.nextAwareRoute = function nextAwareRoute(routeConstant) {
	  if (isNextPath() && SHARED_TO_NEXT[routeConstant]) {
	    return SHARED_TO_NEXT[routeConstant];
	  }
	  return routeConstant;
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var appRoutes = {
	  DASHBOARD: '/gmat-focus/dashboard',
	
	  //? VIDEOS ROUTE START HERE
	  VIDEO_DISPLAY: '/gmat-focus/video-display/:id/:showFreePremium/:type/:chapter_id/:index',
	  VIDEO_LESSONS: '/gmat-focus/video-lessons',
	
	  //? QUESTION BANK ROUTE START HERE
	  QUESTION_BANK: '/gmat-focus/question-bank',
	  QUESTION_BANK_READING: '/gmat-focus/readings/:id',
	  QUESTION_BANK_LIST_QUE: '/gmat-focus/view-questions/:chapter_no/:id/:subscriptionstatus/:reading',
	  QUESTION_BANK_VIEW_QUE: '/gmat-focus/begin-chapter/:notesid/:readingid/:id/:offset',
	  BEGIN_CASE: '/gmat-focus/begin-case/:chapterid/:readingid/:caseid/:case_offset/:subscription/:question_number/:offset',
	  TAB: '/gmat-focus/gmat-tab/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
	  GRAPH_MULTI_STATEMENT: '/gmat-focus/gmat-multi-statement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
	  TABLE: '/gmat-focus/gmat-table/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
	  TWO_PART_STATEMENT: '/gmat-focus/gmat-two-part/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
	  PRACTICE_EXAM: '/gmat-focus/practice_exam',
	
	  //?  QUIZ ROUTE START HERE
	  QUIZZES: '/gmat-focus/quiz',
	  QUIZZES_BEFORE_START: '/gmat-focus/before-start/:quiz_id/:status_send',
	  QUIZZES_BEGIN: '/gmat-focus/begin-quiz-tab/:quiz_id/:offset/:type/:timer',
	  BEGIN_QUIZ: '/gmat-focus/begin-quiz/:quiz_id/:offset/:timer',
	  BEGIN_CASE_QUIZ: '/gmat-focus/begin-quiz-case/:quiz_id/:offset/:type/:case/:timer',
	  BEGIN_TABLE_QUIZ: '/gmat-focus/begin-quiz-table/:quiz_id/:offset/:type/:timer',
	  BEGIN_GRAPH_QUIZ: '/gmat-focus/begin-quiz-graph/:quiz_id/:offset/:type/:timer',
	  BEGIN_TWO_PART_QUIZ: '/gmat-focus/begin-quiz-two-part/:quiz_id/:offset/:type/:timer'
	};
	
	exports.default = appRoutes;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.hasMockAccessFromBackend = exports.hasSubscriptionRegularMix = exports.isSubscriptionItem = exports.tagToChipColors = exports.getContrast = exports.getLuminance = exports.rgbToHex = exports.hslToRgb = exports.hashString = exports.stringToColor = exports.capitalizeFirstLetter = exports.formatMinutesToHHMMSS = exports.formatPrettyDate = exports.formatMoney = exports.testEmptyString = exports.isStringEmpty = exports.isDevEnv = exports.isDev = exports.isLocalhost = exports.hostname = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hostname = exports.hostname = typeof window !== 'undefined' ? window.location.hostname : '';
	
	var isLocalhost = exports.isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
	
	var isDev = exports.isDev = hostname === 'app.analystprep.dev';
	
	var isDevEnv = exports.isDevEnv = isLocalhost || isDev;
	
	var isStringEmpty = exports.isStringEmpty = function isStringEmpty(str) {
	    try {
	        var testEmpty = function testEmpty(value) {
	            var invisible = /[\u200B-\u200D\u2060\uFEFF]/g; // ZWSP, ZWNJ, ZWJ, WORD JOINER, BOM
	            var cleaned = value.replace(invisible, '').trim();
	            return cleaned.length === 0;
	        };
	        if (str == null) return true;
	        if (typeof str === 'string' && ['undefined', 'null'].includes(str.trim())) return true;
	        if (typeof str === 'number') return Number.isNaN(str); //if is number simple check isNaN
	        if (str instanceof String) return testEmpty(str.valueOf());
	        if (typeof str === 'string') return testEmpty(str);
	        return false;
	    } catch (e) {
	        return true;
	    }
	};
	
	//Fast test isStringEmpty test function
	var testEmptyString = exports.testEmptyString = function testEmptyString() {
	    var cases = [[undefined, true, 0], [null, true, 1], ['', true, 2], ['   ', true, 3], ['\t\n', true, 4], ['\xA0', true, 5], // NBSP
	    ['\u200B', true, 6], // ZWSP
	    [new String(''), true, 7], ['0', false, 8], [0, false, 9], ['text', false, 10], ['null', true, 11], ['null ', true, 12], ['undefined', true, 13], ['undefined ', true, 14], ['this is some long test \n with space \t\n ', false, 14], ['this is some \n            long test template & with space \t\n\n              what can go wrong here?  \n        ', false, 15], [String.fromCharCode(0x200B), true, 16], [String("0x00000EB"), false, 17], [0x00000EB, false, 18]];
	
	    try {
	        for (var i = 0; i < cases.length; i++) {
	            var _cases$i = _slicedToArray(cases[i], 3),
	                v = _cases$i[0],
	                expected = _cases$i[1],
	                num = _cases$i[2];
	
	            var ise = isStringEmpty(v);
	            console.log("test:: #[", num, "] >[", JSON.stringify(v), "] ise: [", ise, "] expected: [", expected, "] assert: ", expected === ise);
	        }
	    } catch (e) {
	        console.log("Err::00", e);
	    }
	};
	
	var formatMoney = exports.formatMoney = function formatMoney(n) {
	    var num = Number(n || 0);
	    var v = isNaN(num) ? 0 : num;
	    return "$" + v.toFixed(2);
	};
	
	var formatPrettyDate = exports.formatPrettyDate = function formatPrettyDate(value) {
	    if (!value) return null;
	    var m = (0, _moment2.default)(value);
	    return m.isValid() ? m.format("MMMM D, YYYY") : null;
	};
	
	var formatMinutesToHHMMSS = exports.formatMinutesToHHMMSS = function formatMinutesToHHMMSS(totalMinutes) {
	    var twoDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    // Calculate total seconds first (handle potential decimal minutes)
	    var totalSeconds = Math.floor(totalMinutes * 60);
	
	    // Calculate hours, minutes, and remaining seconds
	    var hours = Math.floor(totalSeconds / 3600);
	    var minutes = Math.floor(totalSeconds % 3600 / 60);
	    var seconds = totalSeconds % 60;
	
	    // Function to add leading zeros to single-digit numbers
	    function padToTwoDigits(num) {
	        if (twoDigits) {
	            return num.toString().padStart(2, '0');
	        }
	        return num;
	    }
	    return {
	        hours: padToTwoDigits(hours),
	        minutes: padToTwoDigits(minutes),
	        seconds: padToTwoDigits(seconds)
	    };
	};
	
	var capitalizeFirstLetter = exports.capitalizeFirstLetter = function capitalizeFirstLetter(string) {
	    if (!string) return "";
	    return string.charAt(0).toUpperCase() + string.slice(1);
	};
	
	var stringToColor = exports.stringToColor = function stringToColor(str) {
	    var hash = 0;
	
	    for (var i = 0; i < str.length; i++) {
	        hash = str.charCodeAt(i) + ((hash << 5) - hash);
	        hash |= 0; // 32-bit int
	    }
	
	    var hue = Math.abs(hash) % 360;
	    var saturation = 65;
	    var lightness = 55;
	
	    return 'hsl(' + hue + ', ' + saturation + '%, ' + lightness + '%)';
	};
	
	var hashString = exports.hashString = function hashString(str) {
	    var hash = 0;
	
	    for (var i = 0; i < str.length; i++) {
	        hash = str.charCodeAt(i) + ((hash << 5) - hash);
	        hash |= 0;
	    }
	
	    return Math.abs(hash);
	};
	
	var hslToRgb = exports.hslToRgb = function hslToRgb(h, s, l) {
	    s /= 100;
	    l /= 100;
	
	    var c = (1 - Math.abs(2 * l - 1)) * s;
	    var x = c * (1 - Math.abs(h / 60 % 2 - 1));
	    var m = l - c / 2;
	
	    var r = 0,
	        g = 0,
	        b = 0;
	
	    if (h >= 0 && h < 60) {
	        r = c;g = x;b = 0;
	    } else if (h < 120) {
	        r = x;g = c;b = 0;
	    } else if (h < 180) {
	        r = 0;g = c;b = x;
	    } else if (h < 240) {
	        r = 0;g = x;b = c;
	    } else if (h < 300) {
	        r = x;g = 0;b = c;
	    } else {
	        r = c;g = 0;b = x;
	    }
	
	    return {
	        r: Math.round((r + m) * 255),
	        g: Math.round((g + m) * 255),
	        b: Math.round((b + m) * 255)
	    };
	};
	
	var rgbToHex = exports.rgbToHex = function rgbToHex(_ref) {
	    var r = _ref.r,
	        g = _ref.g,
	        b = _ref.b;
	
	    return "#" + [r, g, b].map(function (v) {
	        return v.toString(16).padStart(2, "0");
	    }).join("");
	};
	
	var getLuminance = exports.getLuminance = function getLuminance(_ref2) {
	    var r = _ref2.r,
	        g = _ref2.g,
	        b = _ref2.b;
	
	    var toLinear = function toLinear(v) {
	        v /= 255;
	        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
	    };
	
	    var R = toLinear(r);
	    var G = toLinear(g);
	    var B = toLinear(b);
	
	    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
	};
	
	var getContrast = exports.getContrast = function getContrast(rgb1, rgb2) {
	    var l1 = getLuminance(rgb1);
	    var l2 = getLuminance(rgb2);
	
	    var lighter = Math.max(l1, l2);
	    var darker = Math.min(l1, l2);
	
	    return (lighter + 0.05) / (darker + 0.05);
	};
	
	var tagToChipColors = exports.tagToChipColors = function tagToChipColors(tag) {
	    var hash = hashString(tag);
	
	    var hue = hash % 360;
	
	    // Мягкий фон
	    var bg = hslToRgb(hue, 55, 88);
	
	    // Базовый тёмный текст
	    var text = hslToRgb(hue, 45, 28);
	
	    // Если вдруг контраст недостаточный — затемняем текст
	    if (getContrast(bg, text) < 4.5) {
	        text = hslToRgb(hue, 55, 20);
	    }
	
	    // Можно добавить бордер чуть темнее фона
	    var border = hslToRgb(hue, 35, 75);
	
	    return {
	        background: rgbToHex(bg),
	        color: rgbToHex(text),
	        border: rgbToHex(border)
	    };
	};
	
	var isSubscriptionItem = exports.isSubscriptionItem = function isSubscriptionItem(item) {
	    if (!item) return false;
	    var pi = item.payment_interval;
	    // Recurring subscriptions only (month, year, day). "lifetime" is a one-time purchase.
	    return pi !== null && pi !== undefined && pi !== "" && pi !== "lifetime";
	};
	
	var hasSubscriptionRegularMix = exports.hasSubscriptionRegularMix = function hasSubscriptionRegularMix() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    if (items.length < 2) return false;
	    var hasSub = false;
	    var hasRegular = false;
	    for (var i = 0; i < items.length; i++) {
	        if (isSubscriptionItem(items[i])) hasSub = true;else hasRegular = true;
	        if (hasSub && hasRegular) return true;
	    }
	    return false;
	};
	
	/**
	 * Returns true when the backend cbtMockSubscriptionMiddleware has already
	 * granted mock access — used as a fallback alongside legacy frontend
	 * checkCfa*Subscription / checkFrm helpers whose hardcoded allowlists miss
	 * newer mock-unlimited plan ids (e.g. 66, 74, 77).
	 *
	 * @param {*} hasMockSubscription  Response field from /checkout_v1/getExamsbyUser.
	 *   Shapes:
	 *     - undefined / null / false → no access
	 *     - true                     → access (non-FRM boolean shape)
	 *     - { frm, frm_2, frm_1_2 }  → FRM per-exam map (object shape)
	 * @param {string|number} [mockLevel]  FRM-only: '1' checks frm, '2' checks frm_2.
	 *   Always grants if frm_1_2 is true. If omitted, any truthy key grants access
	 *   (CFA semantics — backend never returns the object shape for CFA users).
	 */
	var hasMockAccessFromBackend = exports.hasMockAccessFromBackend = function hasMockAccessFromBackend(hasMockSubscription, mockLevel) {
	    if (!hasMockSubscription) return false;
	    if (typeof hasMockSubscription === 'boolean') return hasMockSubscription;
	
	    // Object shape (FRM).
	    if (mockLevel !== undefined && mockLevel !== null) {
	        var level = String(mockLevel);
	        return level === '1' && !!hasMockSubscription['frm'] || level === '2' && !!hasMockSubscription['frm_2'] || !!hasMockSubscription['frm_1_2'];
	    }
	    return Object.values(hasMockSubscription).some(Boolean);
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var DOMProperty = __webpack_require__(110);
	var ReactDOMComponentFlags = __webpack_require__(444);
	
	var invariant = __webpack_require__(20);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// const requestHandler = response => {
	//   if (response.status) {
	//     return response;
	//   } else {
	//     return { errorMessage: response.errorMessage };
	//   }
	// };
	
	var route = {
	  QUESTION: '/esg/question',
	  CBT: '/esg/cbt',
	  DASHBOARD: '/esg/dashboard',
	  VIDEOS: '/esg/videos'
	};
	
	// ----------------> DASHBOARD API SERVICES START HERE <----------------
	var fetchTotalUsersBarGraph = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/total-user-bar-graph', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchTotalUsersBarGraph(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchUsersBarGraph = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/user-bar-graph', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchUsersBarGraph(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var deleteFlashCard = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function deleteFlashCard(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var fetchQuestionProgressBar = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/question-progress-bar', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function fetchQuestionProgressBar(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var fetchSavedQuestion = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/saved-question', data);
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/delete-saved-question', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var fetchReportedQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/reported-question', data);
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function fetchReportedQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	var deleteReportedQuestion = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/delete-reported-question', data);
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function deleteReportedQuestion(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	var fetchCBTReportedQuestion = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/cbt-reported-question', data);
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function fetchCBTReportedQuestion(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	var deleteCBTReportedQuestion = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            _context10.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/cbt-delete-reported-question', data);
	
	          case 2:
	            return _context10.abrupt('return', _context10.sent);
	
	          case 3:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  return function deleteCBTReportedQuestion(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var redirectToQuestion = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(data) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/redirect-to-question', data);
	
	          case 2:
	            return _context11.abrupt('return', _context11.sent);
	
	          case 3:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, undefined);
	  }));
	
	  return function redirectToQuestion(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	var redirectToCBTQuestion = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/cbt-redirect-to-question', data);
	
	          case 2:
	            return _context12.abrupt('return', _context12.sent);
	
	          case 3:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, undefined);
	  }));
	
	  return function redirectToCBTQuestion(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	var updateReportedQuestion = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(data) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/update-reported-question', data);
	
	          case 2:
	            return _context13.abrupt('return', _context13.sent);
	
	          case 3:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, undefined);
	  }));
	
	  return function updateReportedQuestion(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	var updateReportedCBTQuestion = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(data) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            _context14.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/dashboard/cbt-update-reported-question', data);
	
	          case 2:
	            return _context14.abrupt('return', _context14.sent);
	
	          case 3:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, undefined);
	  }));
	
	  return function updateReportedCBTQuestion(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	// ----------------> DASHBOARD API SERVICES ENDED HERE <----------------
	
	var fetchQuestionsChapterWise = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(data) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            _context15.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question', data);
	
	          case 2:
	            return _context15.abrupt('return', _context15.sent);
	
	          case 3:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, undefined);
	  }));
	
	  return function fetchQuestionsChapterWise(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var fetchChapterNameById = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(data) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            _context16.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/chapter-by-id', data);
	
	          case 2:
	            return _context16.abrupt('return', _context16.sent);
	
	          case 3:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, undefined);
	  }));
	
	  return function fetchChapterNameById(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var reportQuestion = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(data) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            _context17.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/report', data);
	
	          case 2:
	            return _context17.abrupt('return', _context17.sent);
	
	          case 3:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, undefined);
	  }));
	
	  return function reportQuestion(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var saveQuestion = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(data) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            _context18.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/save', data);
	
	          case 2:
	            return _context18.abrupt('return', _context18.sent);
	
	          case 3:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, undefined);
	  }));
	
	  return function saveQuestion(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	var deleteSaveQuestion = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(data) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            _context19.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/delete-save', data);
	
	          case 2:
	            return _context19.abrupt('return', _context19.sent);
	
	          case 3:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, undefined);
	  }));
	
	  return function deleteSaveQuestion(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	var getFavQuestion = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(data) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            _context20.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/get-fav', data);
	
	          case 2:
	            return _context20.abrupt('return', _context20.sent);
	
	          case 3:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, undefined);
	  }));
	
	  return function getFavQuestion(_x20) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var fetchNotePDFById = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(data) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            _context21.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/notes/pdf-by-id', data);
	
	          case 2:
	            return _context21.abrupt('return', _context21.sent);
	
	          case 3:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, undefined);
	  }));
	
	  return function fetchNotePDFById(_x21) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	var getTokenAndEmail = function getTokenAndEmail() {
	  var storageSession = JSON.parse(localStorage.getItem('localstorageval'));
	  return {
	    idname: storageSession['idname'],
	    token: storageSession['token']
	  };
	};
	
	var getImagePath = function getImagePath(imgSrc) {
	  return '' + _App_data2.default.frontend_url + imgSrc;
	};
	
	// const getQuestionsListByReadingId = async data => {
	//   return await FD.callAPI(`${App_data.backend_api}/esg/question`, data);
	// };
	
	var generateTestId = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(data) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            _context22.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/generate-test-id', data);
	
	          case 2:
	            return _context22.abrupt('return', _context22.sent);
	
	          case 3:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, undefined);
	  }));
	
	  return function generateTestId(_x22) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var getUserStatsByMockId = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(data) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            _context23.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/mock-user-stats', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context23.abrupt('return', _context23.sent);
	
	          case 3:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, undefined);
	  }));
	
	  return function getUserStatsByMockId(_x23) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	var deleteUserAttemptedMockExamAPICall = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(data) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            _context24.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/delete-user-attempted-mock-exam', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context24.abrupt('return', _context24.sent);
	
	          case 3:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, undefined);
	  }));
	
	  return function deleteUserAttemptedMockExamAPICall(_x24) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var getMockDetailsById = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(data) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            _context25.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/get-mock-details-by-id', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context25.abrupt('return', _context25.sent);
	
	          case 3:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, undefined);
	  }));
	
	  return function getMockDetailsById(_x25) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	
	var saveMockUserChoice = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(data) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            return _context26.abrupt('return', _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/validate-users-answer-choice', Object.assign({}, data, getTokenAndEmail())));
	
	          case 1:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, undefined);
	  }));
	
	  return function saveMockUserChoice(_x26) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var mockQuestions = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(data) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            _context27.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/mock-questions', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context27.abrupt('return', _context27.sent);
	
	          case 3:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, undefined);
	  }));
	
	  return function mockQuestions(_x27) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	var getUserStatsByTestId = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(data) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            _context28.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/get-user-stats-by-test-id', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context28.abrupt('return', _context28.sent);
	
	          case 3:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, undefined);
	  }));
	
	  return function getUserStatsByTestId(_x28) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var flagUnFlagSelectedQuestion = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(data) {
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            _context29.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/flag-unFlag-selected-question', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context29.abrupt('return', _context29.sent);
	
	          case 3:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, undefined);
	  }));
	
	  return function flagUnFlagSelectedQuestion(_x29) {
	    return _ref29.apply(this, arguments);
	  };
	}();
	
	var reportCBTQuestion = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(data) {
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            _context30.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/report', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context30.abrupt('return', _context30.sent);
	
	          case 3:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, undefined);
	  }));
	
	  return function reportCBTQuestion(_x30) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	var getUserTimeByTestId = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(data) {
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            _context31.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/get-user-time-by-test-id', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context31.abrupt('return', _context31.sent);
	
	          case 3:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, undefined);
	  }));
	
	  return function getUserTimeByTestId(_x31) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	var updateUserTimer = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(data) {
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            _context32.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/update-user-timer', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context32.abrupt('return', _context32.sent);
	
	          case 3:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, undefined);
	  }));
	
	  return function updateUserTimer(_x32) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	var setTestStatusByTestId = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(data) {
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            _context33.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/mark-mock-status-as-completed', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context33.abrupt('return', _context33.sent);
	
	          case 3:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, undefined);
	  }));
	
	  return function setTestStatusByTestId(_x33) {
	    return _ref33.apply(this, arguments);
	  };
	}();
	
	var setCBTScore = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(data) {
	    return _regenerator2.default.wrap(function _callee34$(_context34) {
	      while (1) {
	        switch (_context34.prev = _context34.next) {
	          case 0:
	            _context34.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/update-score-by-test-id', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context34.abrupt('return', _context34.sent);
	
	          case 3:
	          case 'end':
	            return _context34.stop();
	        }
	      }
	    }, _callee34, undefined);
	  }));
	
	  return function setCBTScore(_x34) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var getCBTScore = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(data) {
	    return _regenerator2.default.wrap(function _callee35$(_context35) {
	      while (1) {
	        switch (_context35.prev = _context35.next) {
	          case 0:
	            _context35.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/get-score-by-test-id', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context35.abrupt('return', _context35.sent);
	
	          case 3:
	          case 'end':
	            return _context35.stop();
	        }
	      }
	    }, _callee35, undefined);
	  }));
	
	  return function getCBTScore(_x35) {
	    return _ref35.apply(this, arguments);
	  };
	}();
	
	var fetchChapterWiseCount = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(data) {
	    return _regenerator2.default.wrap(function _callee36$(_context36) {
	      while (1) {
	        switch (_context36.prev = _context36.next) {
	          case 0:
	            _context36.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/chapter-wise-count', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context36.abrupt('return', _context36.sent);
	
	          case 3:
	          case 'end':
	            return _context36.stop();
	        }
	      }
	    }, _callee36, undefined);
	  }));
	
	  return function fetchChapterWiseCount(_x36) {
	    return _ref36.apply(this, arguments);
	  };
	}();
	
	var fetchChapterWiseAnswerCount = function () {
	  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(data) {
	    return _regenerator2.default.wrap(function _callee37$(_context37) {
	      while (1) {
	        switch (_context37.prev = _context37.next) {
	          case 0:
	            _context37.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/chapter-wise-answer-count', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context37.abrupt('return', _context37.sent);
	
	          case 3:
	          case 'end':
	            return _context37.stop();
	        }
	      }
	    }, _callee37, undefined);
	  }));
	
	  return function fetchChapterWiseAnswerCount(_x37) {
	    return _ref37.apply(this, arguments);
	  };
	}();
	
	var setUserChoice = function () {
	  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(data) {
	    return _regenerator2.default.wrap(function _callee38$(_context38) {
	      while (1) {
	        switch (_context38.prev = _context38.next) {
	          case 0:
	            _context38.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/set-user-choice', Object.assign({}, data, getTokenAndEmail()));
	
	          case 2:
	            return _context38.abrupt('return', _context38.sent);
	
	          case 3:
	          case 'end':
	            return _context38.stop();
	        }
	      }
	    }, _callee38, undefined);
	  }));
	
	  return function setUserChoice(_x38) {
	    return _ref38.apply(this, arguments);
	  };
	}();
	
	var saveQuestionStats = function () {
	  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(data) {
	    return _regenerator2.default.wrap(function _callee39$(_context39) {
	      while (1) {
	        switch (_context39.prev = _context39.next) {
	          case 0:
	            _context39.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/save-stats', Object.assign({}, getTokenAndEmail(), data));
	
	          case 2:
	            return _context39.abrupt('return', _context39.sent);
	
	          case 3:
	          case 'end':
	            return _context39.stop();
	        }
	      }
	    }, _callee39, undefined);
	  }));
	
	  return function saveQuestionStats(_x39) {
	    return _ref39.apply(this, arguments);
	  };
	}();
	
	var pdfDownloadViaEmail = function () {
	  var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(data) {
	    return _regenerator2.default.wrap(function _callee40$(_context40) {
	      while (1) {
	        switch (_context40.prev = _context40.next) {
	          case 0:
	            _context40.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/pdf-download-via-email', Object.assign({}, getTokenAndEmail(), data));
	
	          case 2:
	            return _context40.abrupt('return', _context40.sent);
	
	          case 3:
	          case 'end':
	            return _context40.stop();
	        }
	      }
	    }, _callee40, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x40) {
	    return _ref40.apply(this, arguments);
	  };
	}();
	
	var viewPDF = function () {
	  var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(data) {
	    return _regenerator2.default.wrap(function _callee41$(_context41) {
	      while (1) {
	        switch (_context41.prev = _context41.next) {
	          case 0:
	            _context41.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/view-pdf', Object.assign({}, getTokenAndEmail(), data));
	
	          case 2:
	            return _context41.abrupt('return', _context41.sent);
	
	          case 3:
	          case 'end':
	            return _context41.stop();
	        }
	      }
	    }, _callee41, undefined);
	  }));
	
	  return function viewPDF(_x41) {
	    return _ref41.apply(this, arguments);
	  };
	}();
	
	var fetchCBTOverallUserGraph = function () {
	  var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(data) {
	    return _regenerator2.default.wrap(function _callee42$(_context42) {
	      while (1) {
	        switch (_context42.prev = _context42.next) {
	          case 0:
	            _context42.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/get-mock-user-graph', Object.assign({}, getTokenAndEmail(), data));
	
	          case 2:
	            return _context42.abrupt('return', _context42.sent);
	
	          case 3:
	          case 'end':
	            return _context42.stop();
	        }
	      }
	    }, _callee42, undefined);
	  }));
	
	  return function fetchCBTOverallUserGraph(_x42) {
	    return _ref42.apply(this, arguments);
	  };
	}();
	
	var fetchCBTChapterWiseGraph = function () {
	  var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(data) {
	    return _regenerator2.default.wrap(function _callee43$(_context43) {
	      while (1) {
	        switch (_context43.prev = _context43.next) {
	          case 0:
	            _context43.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/get-mock-user-graph-chapter-wise', Object.assign({}, getTokenAndEmail(), data));
	
	          case 2:
	            return _context43.abrupt('return', _context43.sent);
	
	          case 3:
	          case 'end':
	            return _context43.stop();
	        }
	      }
	    }, _callee43, undefined);
	  }));
	
	  return function fetchCBTChapterWiseGraph(_x43) {
	    return _ref43.apply(this, arguments);
	  };
	}();
	
	var postApiCalling = function postApiCalling(route, endpoint, data) {
	  return _fetchData2.default.callAPI('' + _App_data2.default.backend_api + route + endpoint, Object.assign({}, getTokenAndEmail(), data));
	};
	var getHighlightedTextService = function () {
	  var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(data) {
	    return _regenerator2.default.wrap(function _callee44$(_context44) {
	      while (1) {
	        switch (_context44.prev = _context44.next) {
	          case 0:
	            _context44.next = 2;
	            return postApiCalling(route.CBT, '/get-high-lighted-text', data);
	
	          case 2:
	            return _context44.abrupt('return', _context44.sent);
	
	          case 3:
	          case 'end':
	            return _context44.stop();
	        }
	      }
	    }, _callee44, undefined);
	  }));
	
	  return function getHighlightedTextService(_x44) {
	    return _ref44.apply(this, arguments);
	  };
	}();
	
	var deleteHighlightService = function () {
	  var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(data) {
	    return _regenerator2.default.wrap(function _callee45$(_context45) {
	      while (1) {
	        switch (_context45.prev = _context45.next) {
	          case 0:
	            _context45.next = 2;
	            return postApiCalling(route.CBT, '/delete-high-lighted-text', data);
	
	          case 2:
	            return _context45.abrupt('return', _context45.sent);
	
	          case 3:
	          case 'end':
	            return _context45.stop();
	        }
	      }
	    }, _callee45, undefined);
	  }));
	
	  return function deleteHighlightService(_x45) {
	    return _ref45.apply(this, arguments);
	  };
	}();
	
	var addHighlightedTextService = function () {
	  var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(data) {
	    return _regenerator2.default.wrap(function _callee46$(_context46) {
	      while (1) {
	        switch (_context46.prev = _context46.next) {
	          case 0:
	            _context46.next = 2;
	            return postApiCalling(route.CBT, '/add-high-lighted-text', data);
	
	          case 2:
	            return _context46.abrupt('return', _context46.sent);
	
	          case 3:
	          case 'end':
	            return _context46.stop();
	        }
	      }
	    }, _callee46, undefined);
	  }));
	
	  return function addHighlightedTextService(_x46) {
	    return _ref46.apply(this, arguments);
	  };
	}();
	
	var addStrikeThrough = function () {
	  var _ref47 = _asyncToGenerator(_regenerator2.default.mark(function _callee47(data) {
	    return _regenerator2.default.wrap(function _callee47$(_context47) {
	      while (1) {
	        switch (_context47.prev = _context47.next) {
	          case 0:
	            _context47.next = 2;
	            return postApiCalling(route.CBT, '/addStrikeThrough', data);
	
	          case 2:
	            return _context47.abrupt('return', _context47.sent);
	
	          case 3:
	          case 'end':
	            return _context47.stop();
	        }
	      }
	    }, _callee47, undefined);
	  }));
	
	  return function addStrikeThrough(_x47) {
	    return _ref47.apply(this, arguments);
	  };
	}();
	
	var getStrikedText = function () {
	  var _ref48 = _asyncToGenerator(_regenerator2.default.mark(function _callee48(data) {
	    return _regenerator2.default.wrap(function _callee48$(_context48) {
	      while (1) {
	        switch (_context48.prev = _context48.next) {
	          case 0:
	            _context48.next = 2;
	            return postApiCalling(route.CBT, '/getStrikedText', data);
	
	          case 2:
	            return _context48.abrupt('return', _context48.sent);
	
	          case 3:
	          case 'end':
	            return _context48.stop();
	        }
	      }
	    }, _callee48, undefined);
	  }));
	
	  return function getStrikedText(_x48) {
	    return _ref48.apply(this, arguments);
	  };
	}();
	
	var fetchLastAnsweredQuestion = function () {
	  var _ref49 = _asyncToGenerator(_regenerator2.default.mark(function _callee49() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee49$(_context49) {
	      while (1) {
	        switch (_context49.prev = _context49.next) {
	          case 0:
	            _context49.next = 2;
	            return postApiCalling(route.QUESTION, '/getLastAnsweredQuestion', data);
	
	          case 2:
	            return _context49.abrupt('return', _context49.sent);
	
	          case 3:
	          case 'end':
	            return _context49.stop();
	        }
	      }
	    }, _callee49, undefined);
	  }));
	
	  return function fetchLastAnsweredQuestion() {
	    return _ref49.apply(this, arguments);
	  };
	}();
	
	var getQuestionChapterwise = function () {
	  var _ref50 = _asyncToGenerator(_regenerator2.default.mark(function _callee50() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee50$(_context50) {
	      while (1) {
	        switch (_context50.prev = _context50.next) {
	          case 0:
	            _context50.next = 2;
	            return postApiCalling(route.QUESTION, '/getQuestionChapterwise', data);
	
	          case 2:
	            return _context50.abrupt('return', _context50.sent);
	
	          case 3:
	          case 'end':
	            return _context50.stop();
	        }
	      }
	    }, _callee50, undefined);
	  }));
	
	  return function getQuestionChapterwise() {
	    return _ref50.apply(this, arguments);
	  };
	}();
	
	var getAllVideos = function () {
	  var _ref51 = _asyncToGenerator(_regenerator2.default.mark(function _callee51() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee51$(_context51) {
	      while (1) {
	        switch (_context51.prev = _context51.next) {
	          case 0:
	            _context51.next = 2;
	            return postApiCalling(route.VIDEOS, '/getAllVideos', data);
	
	          case 2:
	            return _context51.abrupt('return', _context51.sent);
	
	          case 3:
	          case 'end':
	            return _context51.stop();
	        }
	      }
	    }, _callee51, undefined);
	  }));
	
	  return function getAllVideos() {
	    return _ref51.apply(this, arguments);
	  };
	}();
	
	var getVideosByChapter = function () {
	  var _ref52 = _asyncToGenerator(_regenerator2.default.mark(function _callee52() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee52$(_context52) {
	      while (1) {
	        switch (_context52.prev = _context52.next) {
	          case 0:
	            _context52.next = 2;
	            return postApiCalling(route.VIDEOS, '/getVideoByChapterId', data);
	
	          case 2:
	            return _context52.abrupt('return', _context52.sent);
	
	          case 3:
	          case 'end':
	            return _context52.stop();
	        }
	      }
	    }, _callee52, undefined);
	  }));
	
	  return function getVideosByChapter() {
	    return _ref52.apply(this, arguments);
	  };
	}();
	
	var getLastVideo = function () {
	  var _ref53 = _asyncToGenerator(_regenerator2.default.mark(function _callee53() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee53$(_context53) {
	      while (1) {
	        switch (_context53.prev = _context53.next) {
	          case 0:
	            _context53.next = 2;
	            return postApiCalling(route.VIDEOS, '/getLastViewedVideo', data);
	
	          case 2:
	            return _context53.abrupt('return', _context53.sent);
	
	          case 3:
	          case 'end':
	            return _context53.stop();
	        }
	      }
	    }, _callee53, undefined);
	  }));
	
	  return function getLastVideo() {
	    return _ref53.apply(this, arguments);
	  };
	}();
	
	var fetchSavedVideos = function () {
	  var _ref54 = _asyncToGenerator(_regenerator2.default.mark(function _callee54(data) {
	    return _regenerator2.default.wrap(function _callee54$(_context54) {
	      while (1) {
	        switch (_context54.prev = _context54.next) {
	          case 0:
	            _context54.next = 2;
	            return postApiCalling(route.VIDEOS, '/saved-videos', data);
	
	          case 2:
	            return _context54.abrupt('return', _context54.sent);
	
	          case 3:
	          case 'end':
	            return _context54.stop();
	        }
	      }
	    }, _callee54, undefined);
	  }));
	
	  return function fetchSavedVideos(_x54) {
	    return _ref54.apply(this, arguments);
	  };
	}();
	var deleteSavedVideo = function () {
	  var _ref55 = _asyncToGenerator(_regenerator2.default.mark(function _callee55(data) {
	    return _regenerator2.default.wrap(function _callee55$(_context55) {
	      while (1) {
	        switch (_context55.prev = _context55.next) {
	          case 0:
	            _context55.next = 2;
	            return postApiCalling(route.VIDEOS, '/delete-saved-video', data);
	
	          case 2:
	            return _context55.abrupt('return', _context55.sent);
	
	          case 3:
	          case 'end':
	            return _context55.stop();
	        }
	      }
	    }, _callee55, undefined);
	  }));
	
	  return function deleteSavedVideo(_x55) {
	    return _ref55.apply(this, arguments);
	  };
	}();
	var fetchReportedVideos = function () {
	  var _ref56 = _asyncToGenerator(_regenerator2.default.mark(function _callee56(data) {
	    return _regenerator2.default.wrap(function _callee56$(_context56) {
	      while (1) {
	        switch (_context56.prev = _context56.next) {
	          case 0:
	            _context56.next = 2;
	            return postApiCalling(route.VIDEOS, '/reported-videos', data);
	
	          case 2:
	            return _context56.abrupt('return', _context56.sent);
	
	          case 3:
	          case 'end':
	            return _context56.stop();
	        }
	      }
	    }, _callee56, undefined);
	  }));
	
	  return function fetchReportedVideos(_x56) {
	    return _ref56.apply(this, arguments);
	  };
	}();
	var deleteReportedVideo = function () {
	  var _ref57 = _asyncToGenerator(_regenerator2.default.mark(function _callee57(data) {
	    return _regenerator2.default.wrap(function _callee57$(_context57) {
	      while (1) {
	        switch (_context57.prev = _context57.next) {
	          case 0:
	            _context57.next = 2;
	            return postApiCalling(route.VIDEOS, '/delete-reported-video', data);
	
	          case 2:
	            return _context57.abrupt('return', _context57.sent);
	
	          case 3:
	          case 'end':
	            return _context57.stop();
	        }
	      }
	    }, _callee57, undefined);
	  }));
	
	  return function deleteReportedVideo(_x57) {
	    return _ref57.apply(this, arguments);
	  };
	}();
	
	var mutateSaveVideo = function () {
	  var _ref58 = _asyncToGenerator(_regenerator2.default.mark(function _callee58(data) {
	    return _regenerator2.default.wrap(function _callee58$(_context58) {
	      while (1) {
	        switch (_context58.prev = _context58.next) {
	          case 0:
	            _context58.next = 2;
	            return postApiCalling(route.VIDEOS, '/save-video', data);
	
	          case 2:
	            return _context58.abrupt('return', _context58.sent);
	
	          case 3:
	          case 'end':
	            return _context58.stop();
	        }
	      }
	    }, _callee58, undefined);
	  }));
	
	  return function mutateSaveVideo(_x58) {
	    return _ref58.apply(this, arguments);
	  };
	}();
	
	var mutateReportVideo = function () {
	  var _ref59 = _asyncToGenerator(_regenerator2.default.mark(function _callee59(data) {
	    return _regenerator2.default.wrap(function _callee59$(_context59) {
	      while (1) {
	        switch (_context59.prev = _context59.next) {
	          case 0:
	            _context59.next = 2;
	            return postApiCalling(route.VIDEOS, '/report-video', data);
	
	          case 2:
	            return _context59.abrupt('return', _context59.sent);
	
	          case 3:
	          case 'end':
	            return _context59.stop();
	        }
	      }
	    }, _callee59, undefined);
	  }));
	
	  return function mutateReportVideo(_x59) {
	    return _ref59.apply(this, arguments);
	  };
	}();
	
	var getFavVideoById = function () {
	  var _ref60 = _asyncToGenerator(_regenerator2.default.mark(function _callee60(data) {
	    return _regenerator2.default.wrap(function _callee60$(_context60) {
	      while (1) {
	        switch (_context60.prev = _context60.next) {
	          case 0:
	            _context60.next = 2;
	            return postApiCalling(route.VIDEOS, '/saved-video-by-id', data);
	
	          case 2:
	            return _context60.abrupt('return', _context60.sent);
	
	          case 3:
	          case 'end':
	            return _context60.stop();
	        }
	      }
	    }, _callee60, undefined);
	  }));
	
	  return function getFavVideoById(_x60) {
	    return _ref60.apply(this, arguments);
	  };
	}();
	var deleteFavVideo = function () {
	  var _ref61 = _asyncToGenerator(_regenerator2.default.mark(function _callee61(data) {
	    return _regenerator2.default.wrap(function _callee61$(_context61) {
	      while (1) {
	        switch (_context61.prev = _context61.next) {
	          case 0:
	            _context61.next = 2;
	            return postApiCalling(route.VIDEOS, '/delete-fav-video', data);
	
	          case 2:
	            return _context61.abrupt('return', _context61.sent);
	
	          case 3:
	          case 'end':
	            return _context61.stop();
	        }
	      }
	    }, _callee61, undefined);
	  }));
	
	  return function deleteFavVideo(_x61) {
	    return _ref61.apply(this, arguments);
	  };
	}();
	var updateReportedVideo = function () {
	  var _ref62 = _asyncToGenerator(_regenerator2.default.mark(function _callee62(data) {
	    return _regenerator2.default.wrap(function _callee62$(_context62) {
	      while (1) {
	        switch (_context62.prev = _context62.next) {
	          case 0:
	            _context62.next = 2;
	            return postApiCalling(route.VIDEOS, '/update-reported-video', data);
	
	          case 2:
	            return _context62.abrupt('return', _context62.sent);
	
	          case 3:
	          case 'end':
	            return _context62.stop();
	        }
	      }
	    }, _callee62, undefined);
	  }));
	
	  return function updateReportedVideo(_x62) {
	    return _ref62.apply(this, arguments);
	  };
	}();
	
	var redirectToVideo = function () {
	  var _ref63 = _asyncToGenerator(_regenerator2.default.mark(function _callee63(data) {
	    return _regenerator2.default.wrap(function _callee63$(_context63) {
	      while (1) {
	        switch (_context63.prev = _context63.next) {
	          case 0:
	            _context63.next = 2;
	            return postApiCalling(route.DASHBOARD, '/redirect-to-video', data);
	
	          case 2:
	            return _context63.abrupt('return', _context63.sent);
	
	          case 3:
	          case 'end':
	            return _context63.stop();
	        }
	      }
	    }, _callee63, undefined);
	  }));
	
	  return function redirectToVideo(_x63) {
	    return _ref63.apply(this, arguments);
	  };
	}();
	
	module.exports = {
	  deleteHighlightService: deleteHighlightService,
	  getHighlightedTextService: getHighlightedTextService,
	  addHighlightedTextService: addHighlightedTextService,
	  // ESG DASHBOARD
	  fetchTotalUsersBarGraph: fetchTotalUsersBarGraph,
	  fetchUsersBarGraph: fetchUsersBarGraph,
	  fetchSavedQuestion: fetchSavedQuestion,
	  fetchReportedQuestion: fetchReportedQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  deleteReportedQuestion: deleteReportedQuestion,
	  fetchCBTReportedQuestion: fetchCBTReportedQuestion,
	  deleteCBTReportedQuestion: deleteCBTReportedQuestion,
	  redirectToQuestion: redirectToQuestion,
	  redirectToCBTQuestion: redirectToCBTQuestion,
	  fetchQuestionProgressBar: fetchQuestionProgressBar,
	  updateReportedQuestion: updateReportedQuestion,
	  updateReportedCBTQuestion: updateReportedCBTQuestion,
	
	  fetchQuestionsChapterWise: fetchQuestionsChapterWise,
	  fetchChapterNameById: fetchChapterNameById,
	  getTokenAndEmail: getTokenAndEmail,
	  reportQuestion: reportQuestion,
	  saveQuestion: saveQuestion,
	  getFavQuestion: getFavQuestion,
	  saveQuestionStats: saveQuestionStats,
	  fetchNotePDFById: fetchNotePDFById,
	  getImagePath: getImagePath,
	  // updateUsersChoice,
	  // updateUserAnswer,
	  generateTestId: generateTestId,
	  getUserStatsByMockId: getUserStatsByMockId,
	  deleteUserAttemptedMockExamAPICall: deleteUserAttemptedMockExamAPICall,
	  getMockDetailsById: getMockDetailsById,
	  saveMockUserChoice: saveMockUserChoice,
	  mockQuestions: mockQuestions,
	  getUserStatsByTestId: getUserStatsByTestId,
	  flagUnFlagSelectedQuestion: flagUnFlagSelectedQuestion,
	  //   getQuestionsListByReadingId,
	  reportCBTQuestion: reportCBTQuestion,
	  getUserTimeByTestId: getUserTimeByTestId,
	  updateUserTimer: updateUserTimer,
	  setTestStatusByTestId: setTestStatusByTestId,
	  setCBTScore: setCBTScore,
	  setUserChoice: setUserChoice,
	  pdfDownloadViaEmail: pdfDownloadViaEmail,
	  viewPDF: viewPDF,
	  getCBTScore: getCBTScore,
	  fetchChapterWiseAnswerCount: fetchChapterWiseAnswerCount,
	  fetchChapterWiseCount: fetchChapterWiseCount,
	  fetchCBTOverallUserGraph: fetchCBTOverallUserGraph,
	  fetchCBTChapterWiseGraph: fetchCBTChapterWiseGraph,
	  addStrikeThrough: addStrikeThrough,
	  getStrikedText: getStrikedText,
	  fetchLastAnsweredQuestion: fetchLastAnsweredQuestion,
	  getQuestionChapterwise: getQuestionChapterwise,
	  getAllVideos: getAllVideos,
	  getVideosByChapter: getVideosByChapter,
	  getLastVideo: getLastVideo,
	  fetchSavedVideos: fetchSavedVideos,
	  deleteSavedVideo: deleteSavedVideo,
	  fetchReportedVideos: fetchReportedVideos,
	  deleteReportedVideo: deleteReportedVideo,
	  mutateSaveVideo: mutateSaveVideo,
	  mutateReportVideo: mutateReportVideo,
	  deleteSaveQuestion: deleteSaveQuestion,
	  getFavVideoById: getFavVideoById,
	  deleteFavVideo: deleteFavVideo,
	  updateReportedVideo: updateReportedVideo,
	  redirectToVideo: redirectToVideo,
	  deleteFlashCard: deleteFlashCard
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	var checkCfa3Subscription = function checkCfa3Subscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  // console.log(selectedLevel);
	  // console.log(exam_data);
	  // console.log(cfaUnlimitedPackage);
	  // console.log(cfaUnlimitedActiveExam);
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].isActive) {
	              // console.log("uppercase");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        // console.log("work");
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              // console.log("lowecase");
	
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	    //return final_exam.indexOf(selectedmen) > -1;
	  }
	};
	
	var checkCfa3NotesSubscription = function checkCfa3NotesSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	------------------------
	  Check for videos
	-----------------------
	*/
	var checkCfa3VideosSubscription = function checkCfa3VideosSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	-----------------------
	  Check for PDF's
	----------------------
	*/
	var checkCfa3PDFSubscription = function checkCfa3PDFSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, type) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                flag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                flag = true;
	              }
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	exports.checkCfa3NotesSubscription = checkCfa3NotesSubscription;
	exports.checkCfa3VideosSubscription = checkCfa3VideosSubscription;
	exports.checkCfa3PDFSubscription = checkCfa3PDFSubscription;
	exports.checkCfa3Subscription = checkCfa3Subscription;

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	/*
	  Mock packages grant ONLY mock exams — never quizzes, questions, notes, videos
	  or PDFs (subscription-dataflow.md § "Mock packages").
	
	  Callers that pass `examPlanData` (resp_exam.examPlan[0]) are the pages that must
	  not open on a mock. That argument used to short-circuit every check to false
	  whenever examPlan[0] was a mock — an ARBITRARY row (no ORDER BY, so effectively
	  the lowest owned plan id). Monthly plans have higher ids than the mock plans, so
	  a partner owning a mock and a monthly subscription was always denied, and so was
	  a CFA Unlimited holder whose examPlan[0] happened to be a mock. For those callers
	  mock levels are now skipped per level, which does not depend on order. Callers
	  that do not pass examPlanData keep their previous behaviour. Same approach as
	  Cfa1Subscription.js (D32).
	*/
	var checkCfa3Subscription = function checkCfa3Subscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              // here  inside if check for partner user  partner package suscription
	              if (exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              // here inside else check for  partner user normal app package subscription
	              if (exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        // console.log("work");
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              // console.log("lowecase");
	
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	---------------------------
	   Check for Notes 
	---------------------------
	*/
	var checkCfa3NotesSubscription = function checkCfa3NotesSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -----------------------
	                 for partner users
	              -----------------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — mirror non-partner: pkg 21 covers L2+L3 unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              ------------------
	                 for app users
	              ------------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L3.
	              // Was pkg 16 (legacy copy-paste from Cfa1) which never matches.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	------------------------
	  Check for videos
	-----------------------
	*/
	var checkCfa3VideosSubscription = function checkCfa3VideosSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -----------------
	                For Partner
	              -----------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — mirror non-partner: pkg 21 covers L2+L3 unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              -------------
	                For App
	              -------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L3.
	              // Was pkg 16 (legacy copy-paste from Cfa1) which never matches.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	-----------------------
	  Check for PDF's
	----------------------
	*/
	var checkCfa3PDFSubscription = function checkCfa3PDFSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, type, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam) {
	    if ('cfa' === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -------------
	                For Partner
	              -------------
	              */
	
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                  flag = true;
	                }
	              } else if (
	              // #261 — mirror non-partner: pkg 21 covers L2+L3 unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              -------------
	                For App
	              -------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                  flag = true;
	                }
	              } else if (
	              // #261 — pkg 21 (CFA Unlimited Levels 2 and 3) covers L3.
	              // Was pkg 16 (legacy copy-paste from Cfa1) which never matches.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 21) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 21 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 41 || exam_data[i].levels[j].package_id === 49 || exam_data[i].levels[j].package_id === 50 || exam_data[i].levels[j].package_id === 22)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	exports.checkCfa3NotesSubscription = checkCfa3NotesSubscription;
	exports.checkCfa3VideosSubscription = checkCfa3VideosSubscription;
	exports.checkCfa3PDFSubscription = checkCfa3PDFSubscription;
	exports.checkCfa3Subscription = checkCfa3Subscription;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	__webpack_require__(999);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMATCalculator = function (_Component) {
	  _inherits(GMATCalculator, _Component);
	
	  function GMATCalculator(props) {
	    _classCallCheck(this, GMATCalculator);
	
	    var _this = _possibleConstructorReturn(this, (GMATCalculator.__proto__ || Object.getPrototypeOf(GMATCalculator)).call(this, props));
	
	    _this.handleAC = function () {
	      _this.setState({
	        calcInput: '',
	        calcMemory: '',
	        answer: ''
	      });
	    };
	
	    _this.handleCE = function () {
	      _this.setState({
	        calcInput: ''
	      });
	    };
	
	    _this.handleNumberClick = function (event, value) {
	      switch (true) {
	        case _this.state.answer !== '':
	          _this.setState({
	            answer: '',
	            calcInput: value,
	            calcMemory: value
	          });
	          break;
	
	        case _constant.operationCyphers.includes(_this.state.calcInput):
	          _this.setState({
	            calcInput: value,
	            calcMemory: _this.state.calcMemory + value
	          });
	          break;
	        case _constant.buttonCyphers.includes(value):
	          if (_this.state.isExpressionValidated) {
	            _this.setState({
	              calcInput: '' + value,
	              calcMemory: '' + value,
	              isExpressionValidated: false
	            });
	            return;
	          }
	          _this.setState({
	            calcInput: '' + _this.state.calcInput + value,
	            calcMemory: '' + _this.state.calcMemory + value
	          });
	          break;
	        default:
	      }
	    };
	
	    _this.handleOperator = function (operator) {
	      var calcm = _this.state.calcInput[_this.state.calcInput.length - 1];
	      if (_this.state.calcMemory.length === 0 && (operator === '+' || operator === 'x' || operator === '/' || operator === '-' || operator === '.' || operator === '%' || operator === '√' || operator === '+/-')) {
	        return;
	      }
	      if (calcm === '+' || calcm === '-' || calcm === 'x' || calcm === '/' || calcm === '.' || calcm === '%' || calcm === '+/-') {
	        return;
	      }
	      switch (true) {
	        case _constant.operationCyphers.includes(operator):
	          if (operator === '+/-') {
	            var numberArray = _this.state.calcMemory.toString().split(_constant.OperatorExpression);
	            var lastNumber = numberArray.pop();
	            var lastSecondNumber = numberArray.pop();
	            if (lastSecondNumber === '(') {
	              var _lastIndex = _this.state.calcMemory.toString().lastIndexOf(lastSecondNumber);
	              _this.setState({
	                calcMemory: '' + _this.state.calcMemory.toString().substring(0, _lastIndex) + lastNumber.replace(/.$/, '')
	              });
	              return;
	            }
	            var lastIndex = _this.state.calcMemory.toString().lastIndexOf(lastNumber);
	            _this.setState({
	              calcMemory: _this.state.calcMemory.toString().substring(0, lastIndex) + '(' + lastNumber * -1 + ')'
	            });
	          } else {
	            if (operator === '√') _this.setState({
	              calcInput: operator,
	              calcMemory: operator + '(' + _this.state.calcMemory + ')'
	            });else _this.setState({
	              calcInput: operator,
	              calcMemory: _this.state.calcMemory + operator
	            });
	          }
	          _this.setState({
	            isExpressionValidated: false
	          });
	          break;
	
	        default:
	      }
	    };
	
	    _this.safeEval = function (expression) {
	      var func = new Function('return ' + expression);
	      return func();
	    };
	
	    _this.handleEqual = function (equal) {
	      var _this$state = _this.state,
	          calcInput = _this$state.calcInput,
	          calcMemory = _this$state.calcMemory;
	
	      if (calcInput === '√') {
	        var result = calcMemory.match(/\d+/g);
	        var answer = Math.sqrt(result[0]).toFixed(5);
	        if (calcMemory.includes('-')) {
	          answer += 'i';
	        }
	        _this.setState({
	          calcMemory: answer,
	          calcInput: answer
	        });
	      } else {
	        if (calcMemory.includes('i')) {
	          _this.setState({
	            calcMemory: 'Invalid Input',
	            calcInput: ''
	          });
	          return;
	        }
	        var finalExpression = calcMemory.replace('√', 'Math.sqrt').replace('x', '*');
	        var _answer = _this.safeEval(finalExpression);
	        if (isNaN(_answer)) {
	          _answer = 'Invalid Input';
	        }
	        _this.setState({
	          calcMemory: _answer,
	          calcInput: _answer === 'Invalid Input' || _answer === Infinity ? '' : _answer
	        });
	      }
	      _this.setState({
	        isExpressionValidated: true
	      });
	    };
	
	    _this.clearCloseModal = function () {
	      var closeModal = _this.props.closeModal;
	
	      _this.setState({
	        calcInput: '',
	        calcMemory: ''
	      });
	      closeModal();
	    };
	
	    _this.state = {
	      calcMemory: '',
	      calcInput: '',
	      answer: '',
	      error: '',
	      op: '',
	      isExpressionValidated: false
	    };
	    return _this;
	  }
	
	  _createClass(GMATCalculator, [{
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this2 = this;
	
	      return _constant.buttonCyphers.map(function (item, index) {
	        return _react2.default.createElement(
	          'button',
	          {
	            className: 'map-btn',
	            key: index,
	            onClick: function onClick(event) {
	              return _this2.handleNumberClick(event, item);
	            }
	          },
	          item
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var show = this.props.show;
	
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: show, toggle: this.clearCloseModal, className: 'modal_calc' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Calculator' },
	          _react2.default.createElement(
	            'div',
	            { className: 'calc-wrapper' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              { className: 'modal_calc_header' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'CALCULATOR'
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'close', onClick: this.clearCloseModal },
	                'x'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              { className: 'modal_calc_body' },
	              _react2.default.createElement(
	                'div',
	                { className: 'calculator' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'calcpanel' },
	                  _react2.default.createElement('span', { className: 'line' }),
	                  _react2.default.createElement('span', { className: 'camera' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '_head' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.calcMemory
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.calcInput
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { className: '_buttons' },
	                  _react2.default.createElement('div', { className: '_operators' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: '_numbers' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'num-wrapper' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'op-btn', onClick: function onClick() {
	                            return _this3.handleOperator('+/-');
	                          } },
	                        '+/-'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'op-btn', onClick: function onClick() {
	                            return _this3.handleOperator('%');
	                          } },
	                        '%'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'op-btn', onClick: function onClick() {
	                            return _this3.handleOperator('√');
	                          } },
	                        '\u221A'
	                      ),
	                      this.renderButtons(),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'map-btn', onClick: function onClick() {
	                            return _this3.handleOperator('.');
	                          } },
	                        '.'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'map-btn', onClick: function onClick() {
	                            return _this3.handleEqual('=');
	                          } },
	                        '='
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'opp-btn-wrapper' },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this3.handleAC();
	                          } },
	                        'Clear'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this3.handleOperator('+');
	                          } },
	                        '+'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this3.handleOperator('-');
	                          } },
	                        '-'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this3.handleOperator('x');
	                          } },
	                        '\xD7'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this3.handleOperator('/');
	                          } },
	                        '/'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'Equal' },
	                    _react2.default.createElement('div', null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATCalculator;
	}(_react.Component);
	
	exports.default = GMATCalculator;

/***/ },
/* 47 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 48 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	
	/* eslint-disable*/
	var arr = { "1": "frm", "2": "frm_2" };
	var checkFrmFun = function checkFrmSubscription(selectedLevel, exam_data) {
	  // console.log(selectedLevel);
	  // console.log("selectedLevel");
	  // console.log(exam_data);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log('for working')
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      // console.log('if working')
	      if (exam_data[i].levels.length) {
	        // console.log("in if");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log(exam_data[i].levels);
	          if (exam_data[i].levels[j].isActive) {
	            //  console.log("in if")
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        // console.log("in else");
	        flag = true; //for old user
	      }
	      // break;
	    } else {
	      // console.log("checkFrmSubscription ELSE");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkFrmNotesSubscription = function checkFrmNotesSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  // console.log("notes");
	  // console.log(selectedLevel);
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("check notes");
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      //console.log("check subscription");
	      if (exam_data[i].levels.length) {
	        //console.log("check");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	            // console.log("uppperwork");
	
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	      // break;
	    } else {
	      // console.log("else");
	
	      if (exam_data[i].levels.length) {
	        // console.log("else length");
	
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log("else for");
	
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            // console.log("lowewerrwork");
	
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkFrmVideosSubscription = function checkFrmVideosSubscription(selectedLevel, exam_data) {
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].videoStatus !== false && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkFrmPDFSubscription = function checkFrmPDFSubscription(selectedLevel, exam_data, type) {
	  var flag = false;
	  // mock entries always carry pdfstatus=false / noteStatus=false (DEFAULT_PACKAGE_DETAILS),
	  // so gating expensive/unlimited on the matching flag filters them out.
	  var requiredFlag = type === "notes" ? "noteStatus" : "pdfstatus";
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive && exam_data[i].levels[j][requiredFlag] !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive) {
	            if (exam_data[i].levels[j].pdfstatus && type === "question") {
	              flag = true;
	            } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	              flag = true;
	            }
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive && exam_data[i].levels[j][requiredFlag] !== false) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j][requiredFlag] !== false && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkFormulaSheetSubscription = function checkFormulaSheetSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === 'frm_1_2') {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if ((exam_data[i].levels[j].package_val === 'expensive' || exam_data[i].levels[j].package_val === 'simple' || exam_data[i].levels[j].package_val === 'unlimited') && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	      // break;
	    } else {
	      // console.log("else");
	
	      if (exam_data[i].levels.length) {
	        // console.log("else length");
	
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log("else for");
	
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            // console.log("lowewerrwork");
	
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	exports.checkFrm = checkFrmFun;
	exports.checkFrmNotesSubscription = checkFrmNotesSubscription;
	exports.checkFrmVideosSubscription = checkFrmVideosSubscription;
	exports.checkFrmPDFSubscription = checkFrmPDFSubscription;
	exports.checkFormulaSheetSubscription = checkFormulaSheetSubscription;

/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	/* eslint-disable*/
	/*
	  Mock packages grant ONLY mock exams — never quizzes, questions, notes, videos,
	  PDFs or the formula sheet (subscription-dataflow.md § "Mock packages").
	
	  Callers that pass `examPlanData` (resp_exam.examPlan[0]) are the pages that must
	  not open on a mock. That argument used to short-circuit every check to false
	  whenever examPlan[0] was a mock — an ARBITRARY row (no ORDER BY, so effectively
	  the lowest owned plan id). Monthly plans have higher ids than the mock plans, so
	  a partner owning an FRM mock and a monthly subscription was always denied. For
	  those callers mock levels (including the FRM Mock Unlimited on frm_1_2) are now
	  skipped per level, which does not depend on order. Callers that do not pass
	  examPlanData keep their previous behaviour. Same approach as Cfa1Subscription.js
	  (D32).
	*/
	var arr = { "1": "frm", "2": "frm_2" };
	
	/*
	--------------------------------------------------------------------------
	  FUNCTION TO CHECK SUBSCRIPTION FOR QUIZZES, QUESTIONS AND MOCK EXAMS
	--------------------------------------------------------------------------
	*/
	var checkFRMSubscription = function checkFrmSubscription(selectedLevel, exam_data, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	          if (exam_data[i].levels[j].partner) {
	            // inside if block to check the subscription for partner user plans
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	            }
	          } else {
	            // inside else block to check the subscription for partner user app plans
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	            }
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	/*
	---------------------------------------------
	  FUNCTION TO CHECK SUBSCRIPTION FOR NOTES
	---------------------------------------------
	*/
	
	var checkFrmNotesSubscription = function checkFrmNotesSubscription(selectedLevel, exam_data, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	          if (exam_data[i].levels[j].partner) {
	            /*
	            -----------------
	             Partner User's
	            ----------------
	            */
	            // inside if block check for the partner subscription plans
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              // simple with extras add-ons
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            ----------------
	              App User's
	            ---------------
	            */
	            // inside else block check for the partner user app subcription plans
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive // expensive plans
	            ) {
	                flag = true;
	              } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false
	            // simple with notes add-ons check
	            ) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	              flag = true;
	            }
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	    } else {
	      // inside else check for the partner user app subscription other plans
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	/*
	---------------------------------------------
	  FUNCTION TO CHECK SUBSCRIPTION FOR VIDEOS
	---------------------------------------------
	*/
	
	var checkFrmVideosSubscription = function checkFrmVideosSubscription(selectedLevel, exam_data, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	          if (exam_data[i].levels[j].partner) {
	            /*
	            -------------------
	              Partner  user's
	            -------------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;
	            }
	          } else {
	            /*
	            ---------------------
	              Partner User's
	            ---------------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;/
	            }
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      // inside else block check the partner user app subscription plans
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].videoStatus !== false && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	/*
	--------------------------------------------
	  FUNCTION TO CHECK SUBSCRIPTION FOR PDF'S
	--------------------------------------------
	*/
	
	var checkFrmPDFSubscription = function checkFrmPDFSubscription(selectedLevel, exam_data, type, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  // mock entries always carry pdfstatus=false / noteStatus=false (DEFAULT_PACKAGE_DETAILS),
	  // so gating expensive/unlimited on the matching flag filters them out.
	  var requiredFlag = type === "notes" ? "noteStatus" : "pdfstatus";
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === "frm_1_2") {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive && exam_data[i].levels[j][requiredFlag] !== false) {
	              flag = true;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive // simple active plans
	            ) {
	                if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                  flag = true;
	                }
	              }
	          } else {
	            /*
	            ---------------
	              App User's
	            ---------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive && exam_data[i].levels[j][requiredFlag] !== false) {
	              flag = true;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                flag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                flag = true;
	              }
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive && exam_data[i].levels[j][requiredFlag] !== false) {
	              flag = true;
	              // break;
	            }
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	      // break;
	    } else {
	      // Inside else block check for partner user app subscription plans
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j][requiredFlag] !== false && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkFormulaSheetSubscription = function checkFormulaSheetSubscription(selectedLevel, exam_data, examPlanData) {
	  var flag = false;
	  var skipMock = Boolean(examPlanData);
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === arr[selectedLevel] || exam_data[i].exam_name === 'frm_1_2') {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
	          /* -----------------
	             Partner User's
	            ----------------
	            */
	          if (exam_data[i].levels[j].partner) {
	            if ((exam_data[i].levels[j].package_val === 'expensive' || exam_data[i].levels[j].package_val === 'simple' || exam_data[i].levels[j].package_val === 'unlimited') && exam_data[i].levels[j].isActive) {
	              flag = true;
	              // break;
	            }
	          } else {
	            /*
	            ----------------
	              App User's
	            ---------------
	            */
	            if ((exam_data[i].levels[j].package_val === 'expensive' || exam_data[i].levels[j].package_val === 'simple' || exam_data[i].levels[j].package_val === 'unlimited') && exam_data[i].levels[j].isActive) {
	              flag = true;
	              // break;
	            }
	          }
	        }
	      } else {
	        flag = true; //for old user
	      }
	      // break;
	    } else {
	      // console.log("else");
	
	      if (exam_data[i].levels.length) {
	        // console.log("else length");
	
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log("else for");
	
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 16 || exam_data[i].levels[j].package_id === 17 || exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 20 || exam_data[i].levels[j].package_id === 22 || exam_data[i].levels[j].package_id === 23 || exam_data[i].levels[j].package_id === 24 || exam_data[i].levels[j].package_id === 25)) {
	            // console.log("lowewerrwork");
	
	            flag = true;
	            // break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	exports.checkFrm = checkFRMSubscription;
	exports.checkFrmNotesSubscription = checkFrmNotesSubscription;
	exports.checkFrmVideosSubscription = checkFrmVideosSubscription;
	exports.checkFrmPDFSubscription = checkFrmPDFSubscription;
	exports.checkFormulaSheetSubscription = checkFormulaSheetSubscription;

/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(239);
	var isBuffer = __webpack_require__(517);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Function equal to merge with the difference being that no reference
	 * to original objects is kept.
	 *
	 * @see merge
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function deepMerge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = deepMerge(result[key], val);
	    } else if (typeof val === 'object') {
	      result[key] = deepMerge({}, val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  deepMerge: deepMerge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomCardHeader(props) {
	  var headingText = props.headingText,
	      headerImage = props.headerImage,
	      _props$imageWidth = props.imageWidth,
	      imageWidth = _props$imageWidth === undefined ? '30' : _props$imageWidth,
	      navigateButtonClassName = props.navigateButtonClassName,
	      showPreviousButton = props.showPreviousButton,
	      showNextButton = props.showNextButton,
	      getPreviousQuestion = props.getPreviousQuestion,
	      getNextQuestion = props.getNextQuestion,
	      disabledNextButton = props.disabledNextButton,
	      disabledPreviousButton = props.disabledPreviousButton,
	      className = props.className,
	      headerClassName = props.headerClassName,
	      children = props.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-header ' + (headerClassName || '') },
	    headerImage && _react2.default.createElement('img', { src: headerImage, className: 'margin_right_20', width: imageWidth, alt: 'header-image' }),
	    (0, _function.renderHTMLContent)(headingText, "span", className || "", { contentEditable: 'false' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'float-right text-right ' + (navigateButtonClassName || '') },
	      showPreviousButton && _react2.default.createElement('button', {
	        type: 'button',
	        'aria-label': 'Previous question',
	        className: 'fa fa-angle-left ques_arrow pointer_class ' + (disabledPreviousButton && 'text-secondary'),
	        onClick: getPreviousQuestion,
	        disabled: disabledPreviousButton
	      }),
	      showNextButton && _react2.default.createElement('button', {
	        type: 'button',
	        'aria-label': 'Next question',
	        className: 'fa fa-angle-right ques_arrow pointer_class ' + (disabledNextButton && 'text-secondary'),
	        onClick: getNextQuestion,
	        disabled: disabledNextButton
	      }),
	      children
	    )
	  );
	}
	
	exports.default = CustomCardHeader;

/***/ },
/* 55 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var questionsettings = exports.questionsettings = function questionsettings(offset) {
	  var data = {
	    dots: false,
	    infinite: false,
	    speed: 250,
	    arrows: true,
	    vertical: true,
	    slidesToShow: 10,
	    slidesToScroll: 10,
	    initialSlide: offset
	  };
	  return data;
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * removes the line breaks with a space
	 */
	var removeAllLineBreaks = exports.removeAllLineBreaks = function removeAllLineBreaks(str) {
	  return str.replace(/(?:\r\n|\r|\n)/g, ' ');
	};
	/**
	 * highlight a part of string
	 */
	var highlightString = exports.highlightString = function highlightString(str, find) {
	  // console.log('stringggggg', str);
	  // console.log('find *************', find);
	  if (!str) {
	    return null;
	  }
	  if (!find) {
	    return str;
	  }
	  return str.replace(find, '<b style="background-color: yellow" title="highlighted">' + find + '</b>');
	};
	// \require{color}{\colorbox{yellow}{$+2+h$}}
	
	var strikeThroughString = exports.strikeThroughString = function strikeThroughString(str, find) {
	  if (!str) {
	    return null;
	  }
	  if (!find) {
	    return str;
	  }
	  return removeAllLineBreaks(str).replace(find, '<b style="text-decoration: line-through" title="striked" class="highlighted-text">' + find + '</b>');
	};
	var clearSelection = exports.clearSelection = function clearSelection() {
	  // console.log('selection sleareddd');
	  if (window.getSelection) {
	    if (window.getSelection().empty) {
	      window.getSelection().empty();
	    } else if (window.getSelection().removeAllRanges) {
	      window.getSelection().removeAllRanges();
	    }
	  } else if (document.selection) {
	    document.selection.empty();
	  }
	};

/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chart = exports.defaults = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(88);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _chart = __webpack_require__(915);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _lodash = __webpack_require__(1057);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartComponent = function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  function ChartComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChartComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChartComponent.__proto__ || Object.getPrototypeOf(ChartComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (event) {
	      var instance = _this.chart_instance;
	
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	
	
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChartComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.chart_instance = undefined;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderChart();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.redraw) {
	        this.chart_instance.destroy();
	        this.renderChart();
	        return;
	      }
	
	      this.updateChart();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          redraw = _props.redraw,
	          type = _props.type,
	          options = _props.options,
	          legend = _props.legend,
	          height = _props.height,
	          width = _props.width;
	
	
	      if (nextProps.redraw === true) {
	        return true;
	      }
	
	      if (height !== nextProps.height || width !== nextProps.width) {
	        return true;
	      }
	
	      if (type !== nextProps.type) {
	        return true;
	      }
	
	      if (!(0, _lodash2.default)(legend, nextProps.legend)) {
	        return true;
	      }
	
	      if (!(0, _lodash2.default)(options, nextProps.options)) {
	        return true;
	      }
	
	      var nextData = this.transformDataProp(nextProps);
	      return !(0, _lodash2.default)(this.shadowDataProp, nextData);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.chart_instance.destroy();
	    }
	  }, {
	    key: 'transformDataProp',
	    value: function transformDataProp(props) {
	      var data = props.data;
	
	      if (typeof data == "function") {
	        var node = _reactDom2.default.findDOMNode(this);
	        return data(node);
	      } else {
	        return data;
	      }
	    }
	
	    // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	    // this makes impossible to compare the current and next data changes
	    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	  }, {
	    key: 'memoizeDataProps',
	    value: function memoizeDataProps() {
	      if (!this.props.data) {
	        return;
	      }
	
	      var data = this.transformDataProp(this.props);
	
	      this.shadowDataProp = _extends({}, data, {
	        datasets: data.datasets && data.datasets.map(function (set) {
	          return _extends({}, set);
	        })
	      });
	
	      return data;
	    }
	  }, {
	    key: 'updateChart',
	    value: function updateChart() {
	      var options = this.props.options;
	
	
	      var data = this.memoizeDataProps(this.props);
	
	      if (!this.chart_instance) return;
	
	      if (options) {
	        this.chart_instance.options = _chart2.default.helpers.configMerge(this.chart_instance.options, options);
	      }
	
	      // Pipe datasets to chart instance datasets enabling
	      // seamless transitions
	      var currentDatasets = this.chart_instance.config.data && this.chart_instance.config.data.datasets || [];
	      var nextDatasets = data.datasets || [];
	
	      // Prevent charting of legend items that no longer exist
	      while (currentDatasets.length > nextDatasets.length) {
	        currentDatasets.pop();
	      }
	
	      nextDatasets.forEach(function (dataset, sid) {
	        if (currentDatasets[sid] && currentDatasets[sid].data) {
	          currentDatasets[sid].data.splice(nextDatasets[sid].data.length);
	
	          dataset.data.forEach(function (point, pid) {
	            currentDatasets[sid].data[pid] = nextDatasets[sid].data[pid];
	          });
	
	          var _data = dataset.data,
	              otherProps = _objectWithoutProperties(dataset, ['data']);
	
	          currentDatasets[sid] = _extends({
	            data: currentDatasets[sid].data
	          }, currentDatasets[sid], otherProps);
	        } else {
	          currentDatasets[sid] = nextDatasets[sid];
	        }
	      });
	
	      var datasets = data.datasets,
	          rest = _objectWithoutProperties(data, ['datasets']);
	
	      this.chart_instance.config.data = _extends({}, this.chart_instance.config.data, rest);
	
	      this.chart_instance.update();
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _props2 = this.props,
	          options = _props2.options,
	          legend = _props2.legend,
	          type = _props2.type,
	          redraw = _props2.redraw;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var data = this.memoizeDataProps();
	
	      this.chart_instance = new _chart2.default(node, {
	        type: type,
	        data: data,
	        options: options
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          height = _props3.height,
	          width = _props3.width,
	          onElementsClick = _props3.onElementsClick;
	
	
	      return _react2.default.createElement('canvas', {
	        height: height,
	        width: width,
	        onClick: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ChartComponent;
	}(_react2.default.Component);
	
	ChartComponent.propTypes = {
	  data: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]).isRequired,
	  getDatasetAtEvent: _react.PropTypes.func,
	  getElementAtEvent: _react.PropTypes.func,
	  getElementsAtEvent: _react.PropTypes.func,
	  height: _react.PropTypes.number,
	  legend: _react.PropTypes.object,
	  onElementsClick: _react.PropTypes.func,
	  options: _react.PropTypes.object,
	  redraw: _react.PropTypes.bool,
	  type: _react.PropTypes.oneOf(['doughnut', 'pie', 'line', 'bar', 'horizontalBar', 'radar', 'polarArea', 'bubble']),
	  width: _react.PropTypes.number
	};
	ChartComponent.defaultProps = {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {}
	};
	exports.default = ChartComponent;
	
	var Doughnut = exports.Doughnut = function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _possibleConstructorReturn(this, (Doughnut.__proto__ || Object.getPrototypeOf(Doughnut)).apply(this, arguments));
	  }
	
	  _createClass(Doughnut, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref2) {
	          return _this3.chart_instance = _ref2 && _ref2.chart_instance;
	        },
	        type: 'doughnut'
	      }));
	    }
	  }]);
	
	  return Doughnut;
	}(_react2.default.Component);
	
	var Pie = exports.Pie = function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _possibleConstructorReturn(this, (Pie.__proto__ || Object.getPrototypeOf(Pie)).apply(this, arguments));
	  }
	
	  _createClass(Pie, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref3) {
	          return _this5.chart_instance = _ref3 && _ref3.chart_instance;
	        },
	        type: 'pie'
	      }));
	    }
	  }]);
	
	  return Pie;
	}(_react2.default.Component);
	
	var Line = exports.Line = function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).apply(this, arguments));
	  }
	
	  _createClass(Line, [{
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref4) {
	          return _this7.chart_instance = _ref4 && _ref4.chart_instance;
	        },
	        type: 'line'
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react2.default.Component);
	
	var Bar = exports.Bar = function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
	  }
	
	  _createClass(Bar, [{
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref5) {
	          return _this9.chart_instance = _ref5 && _ref5.chart_instance;
	        },
	        type: 'bar'
	      }));
	    }
	  }]);
	
	  return Bar;
	}(_react2.default.Component);
	
	var HorizontalBar = exports.HorizontalBar = function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _possibleConstructorReturn(this, (HorizontalBar.__proto__ || Object.getPrototypeOf(HorizontalBar)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBar, [{
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref6) {
	          return _this11.chart_instance = _ref6 && _ref6.chart_instance;
	        },
	        type: 'horizontalBar'
	      }));
	    }
	  }]);
	
	  return HorizontalBar;
	}(_react2.default.Component);
	
	var Radar = exports.Radar = function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _possibleConstructorReturn(this, (Radar.__proto__ || Object.getPrototypeOf(Radar)).apply(this, arguments));
	  }
	
	  _createClass(Radar, [{
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref7) {
	          return _this13.chart_instance = _ref7 && _ref7.chart_instance;
	        },
	        type: 'radar'
	      }));
	    }
	  }]);
	
	  return Radar;
	}(_react2.default.Component);
	
	var Polar = exports.Polar = function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _possibleConstructorReturn(this, (Polar.__proto__ || Object.getPrototypeOf(Polar)).apply(this, arguments));
	  }
	
	  _createClass(Polar, [{
	    key: 'render',
	    value: function render() {
	      var _this15 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref8) {
	          return _this15.chart_instance = _ref8 && _ref8.chart_instance;
	        },
	        type: 'polarArea'
	      }));
	    }
	  }]);
	
	  return Polar;
	}(_react2.default.Component);
	
	var Bubble = exports.Bubble = function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _possibleConstructorReturn(this, (Bubble.__proto__ || Object.getPrototypeOf(Bubble)).apply(this, arguments));
	  }
	
	  _createClass(Bubble, [{
	    key: 'render',
	    value: function render() {
	      var _this17 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref9) {
	          return _this17.chart_instance = _ref9 && _ref9.chart_instance;
	        },
	        type: 'bubble'
	      }));
	    }
	  }]);
	
	  return Bubble;
	}(_react2.default.Component);
	
	var defaults = exports.defaults = _chart2.default.defaults;
	exports.Chart = _chart2.default;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(7),__webpack_require__(1),__webpack_require__(1158)):"function"==typeof define&&define.amd?define(["moment","react","react-onclickoutside"],t):"object"==typeof exports?exports.DatePicker=t(require("moment"),require("react"),require("react-onclickoutside")):e.DatePicker=t(e.moment,e.React,e.onClickOutside)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),u=r(c),l=n(4),f=r(l),d=n(5),h=(r(d),n(20)),m=r(h),y=n(11),v=r(y),b=n(18),g=n(2),w=r(g),_=n(12),D=r(_),O="react-datepicker-ignore-onclickoutside",k=(0,D.default)(u.default),E=function(e){function t(e){a(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.calcInitialState=function(){var e=n.props.openToDate?(0,w.default)(n.props.openToDate):n.props.selectsEnd&&n.props.startDate?(0,w.default)(n.props.startDate):n.props.selectsStart&&n.props.endDate?(0,w.default)(n.props.endDate):"undefined"!=typeof n.props.utcOffset?w.default.utc().utcOffset(n.props.utcOffset):(0,w.default)(),t=(0,b.getEffectiveMinDate)(n.props),r=(0,b.getEffectiveMaxDate)(n.props),o=t&&e.isBefore(t)?t:r&&e.isAfter(r)?r:e;return{open:!1,preventFocus:!1,preSelection:n.props.selected?(0,w.default)(n.props.selected):o}},n.clearPreventFocusTimeout=function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)},n.setFocus=function(){n.input.focus()},n.setOpen=function(e){n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.calcInitialState().preSelection})},n.handleFocus=function(e){n.state.preventFocus||(n.props.onFocus(e),n.setOpen(!0))},n.cancelFocusInput=function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null},n.deferFocusInput=function(){n.cancelFocusInput(),n.inputFocusTimeout=setTimeout(function(){return n.setFocus()},1)},n.handleDropdownFocus=function(){n.cancelFocusInput()},n.handleBlur=function(e){n.state.open?n.deferFocusInput():n.props.onBlur(e)},n.handleCalendarClickOutside=function(e){n.props.inline||n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()},n.handleChange=function(e){if(!n.props.onChangeRaw||(n.props.onChangeRaw(e),!e.isDefaultPrevented())){n.setState({inputValue:e.target.value});var t=(0,b.parseDate)(e.target.value,n.props);!t&&e.target.value||n.setSelected(t,e,!0)}},n.handleSelect=function(e,t){n.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),n.setSelected(e,t),n.props.shouldCloseOnSelect?n.props.inline||n.setOpen(!1):n.setPreSelection(e)},n.setSelected=function(e,t,r){var o=e;null!==o&&(0,b.isDayDisabled)(o,n.props)||((0,b.isSameDay)(n.props.selected,o)&&!n.props.allowSameDay||(null!==o&&(n.props.selected&&(o=(0,w.default)(o).set({hour:n.props.selected.hour(),minute:n.props.selected.minute(),second:n.props.selected.second()})),n.setState({preSelection:o})),n.props.onChange(o,t)),n.props.onSelect(o,t),r||n.setState({inputValue:null}))},n.setPreSelection=function(e){var t="undefined"!=typeof n.props.minDate&&"undefined"!=typeof n.props.maxDate,r=!t||!e||(0,b.isDayInRange)(e,n.props.minDate,n.props.maxDate);r&&n.setState({preSelection:e})},n.onInputClick=function(){n.props.disabled||n.setOpen(!0)},n.onInputKeyDown=function(e){n.props.onKeyDown(e);var t=e.key;if(!n.state.open&&!n.props.inline)return void("Enter"!==t&&"Escape"!==t&&"Tab"!==t&&n.onInputClick());var r=(0,w.default)(n.state.preSelection);if("Enter"===t)e.preventDefault(),w.default.isMoment(n.state.preSelection)||w.default.isDate(n.state.preSelection)?(n.handleSelect(r,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(r)):n.setOpen(!1);else if("Escape"===t)e.preventDefault(),n.setOpen(!1);else if("Tab"===t)n.setOpen(!1);else if(!n.props.disabledKeyboardNavigation){var o=void 0;switch(t){case"ArrowLeft":e.preventDefault(),o=r.subtract(1,"days");break;case"ArrowRight":e.preventDefault(),o=r.add(1,"days");break;case"ArrowUp":e.preventDefault(),o=r.subtract(1,"weeks");break;case"ArrowDown":e.preventDefault(),o=r.add(1,"weeks");break;case"PageUp":e.preventDefault(),o=r.subtract(1,"months");break;case"PageDown":e.preventDefault(),o=r.add(1,"months");break;case"Home":e.preventDefault(),o=r.subtract(1,"years");break;case"End":e.preventDefault(),o=r.add(1,"years")}n.setPreSelection(o)}},n.onClearClick=function(e){e.preventDefault(),n.props.onChange(null,e)},n.renderCalendar=function(){return n.props.inline||n.state.open&&!n.props.disabled?f.default.createElement(k,{ref:function(e){n.calendar=e},locale:n.props.locale,dateFormat:n.props.dateFormatCalendar,useWeekdaysShort:n.props.useWeekdaysShort,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,onWeekSelect:n.props.onWeekSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,formatWeekNumber:n.props.formatWeekNumber,highlightDates:n.props.highlightDates,includeDates:n.props.includeDates,inline:n.props.inline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,forceShowMonthNavigation:n.props.forceShowMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,todayButton:n.props.todayButton,weekLabel:n.props.weekLabel,utcOffset:n.props.utcOffset,outsideClickIgnoreClass:O,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,dayClassName:n.props.dayClassName,className:n.props.calendarClassName,yearDropdownItemNumber:n.props.yearDropdownItemNumber},n.props.children):null},n.renderDateInput=function(){var e=(0,v.default)(n.props.className,o({},O,n.state.open)),t=n.props.customInput||f.default.createElement("input",{type:"text"}),r="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:(0,b.safeDateFormat)(n.props.selected,n.props);return f.default.cloneElement(t,{ref:function(e){n.input=e},value:r,onBlur:n.handleBlur,onChange:n.handleChange,onClick:n.onInputClick,onFocus:n.handleFocus,onKeyDown:n.onInputKeyDown,id:n.props.id,name:n.props.name,autoFocus:n.props.autoFocus,placeholder:n.props.placeholderText,disabled:n.props.disabled,autoComplete:n.props.autoComplete,className:e,title:n.props.title,readOnly:n.props.readOnly,required:n.props.required,tabIndex:n.props.tabIndex})},n.renderClearButton=function(){return n.props.isClearable&&null!=n.props.selected?f.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:n.onClearClick}):null},n.state=n.calcInitialState(),n}return s(t,e),p(t,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"L",dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},utcOffset:(0,w.default)().utcOffset(),monthsShown:1,withPortal:!1,shouldCloseOnSelect:!0}}}]),p(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.props.selected&&this.props.selected.month(),n=e.selected&&e.selected.month();this.props.inline&&t!==n&&this.setPreSelection(e.selected)}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?f.default.createElement("div",null,this.props.inline?null:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?f.default.createElement("div",{className:"react-datepicker__portal"},e):null):f.default.createElement(m.default,{className:this.props.popperClassName,hidePopper:!this.state.open||this.props.disabled,popperModifiers:this.props.popperModifiers,targetComponent:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperComponent:e,popperPlacement:this.props.popperPlacement})}}]),t}(f.default.Component);t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(2),c=r(p),u=n(3),l=r(u),f=n(13),d=r(f),h=n(15),m=r(h),y=n(4),v=r(y),b=n(5),g=(r(b),n(11)),w=r(g),_=n(18),D=["react-datepicker__year-select","react-datepicker__month-select"],O=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return D.some(function(e){return t.indexOf(e)>=0})},k=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleClickOutside=function(e){n.props.onClickOutside(e)},n.handleDropdownFocus=function(e){O(e.target)&&n.props.onDropdownFocus()},n.getDateInView=function(){var e=n.props,t=e.preSelection,r=e.selected,o=e.openToDate,a=e.utcOffset,i=(0,_.getEffectiveMinDate)(n.props),s=(0,_.getEffectiveMaxDate)(n.props),p=c.default.utc().utcOffset(a),u=o||r||t;return u?u:i&&p.isBefore(i)?i:s&&p.isAfter(s)?s:p},n.localizeMoment=function(e){return e.clone().locale(n.props.locale||c.default.locale())},n.increaseMonth=function(){n.setState({date:n.state.date.clone().add(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.decreaseMonth=function(){n.setState({date:n.state.date.clone().subtract(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.handleDayClick=function(e,t){return n.props.onSelect(e,t)},n.handleDayMouseEnter=function(e){return n.setState({selectingDate:e})},n.handleMonthMouseLeave=function(){return n.setState({selectingDate:null})},n.handleMonthChange=function(e){n.props.onMonthChange&&n.props.onMonthChange(e)},n.changeYear=function(e){n.setState({date:n.state.date.clone().set("year",e)})},n.changeMonth=function(e){n.setState({date:n.state.date.clone().set("month",e)},function(){return n.handleMonthChange(n.state.date)})},n.header=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=e.clone().startOf("week"),r=[];return n.props.showWeekNumbers&&r.push(v.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map(function(e){var r=t.clone().add(e,"days"),o=n.props.useWeekdaysShort?r.localeData().weekdaysShort(r):r.localeData().weekdaysMin(r);return v.default.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))},n.renderPreviousMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledBefore)(n.state.date,"month",n.props))return v.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:n.decreaseMonth})},n.renderNextMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledAfter)(n.state.date,"month",n.props))return v.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--next",onClick:n.increaseMonth})},n.renderCurrentMonth=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),v.default.createElement("div",{className:t.join(" ")},e.format(n.props.dateFormat))},n.renderYearDropdown=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return v.default.createElement(l.default,{dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:n.state.date.year(),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})},n.renderMonthDropdown=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown)return v.default.createElement(d.default,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonth,month:n.state.date.month()})},n.renderTodayButton=function(){if(n.props.todayButton)return v.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(c.default.utc().utcOffset(n.props.utcOffset).startOf("date"),e)}},n.props.todayButton)},n.renderMonths=function(){for(var e=[],t=0;t<n.props.monthsShown;++t){var r=n.state.date.clone().add(t,"M"),o="month-"+t;e.push(v.default.createElement("div",{key:o,className:"react-datepicker__month-container"},v.default.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),v.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+n.props.dropdownMode,onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==t),n.renderYearDropdown(0!==t)),v.default.createElement("div",{className:"react-datepicker__day-names"},n.header(r))),v.default.createElement(m.default,{day:r,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,formatWeekNumber:n.props.formatWeekNumber,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,utcOffset:n.props.utcOffset})))}return e},n.state={date:n.localizeMoment(n.getDateInView()),selectingDate:null},n}return i(t,e),s(t,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},utcOffset:c.default.utc().utcOffset(),monthsShown:1,forceShowMonthNavigation:!1}}}]),s(t,[{key:"componentWillReceiveProps",value:function(e){e.preSelection&&!(0,_.isSameDay)(e.preSelection,this.props.preSelection)?this.setState({date:this.localizeMoment(e.preSelection)}):e.openToDate&&!(0,_.isSameDay)(e.openToDate,this.props.openToDate)&&this.setState({date:this.localizeMoment(e.openToDate)})}},{key:"render",value:function(){return v.default.createElement("div",{className:(0,w.default)("react-datepicker",this.props.className)},v.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.props.children)}}]),t}(v.default.Component);t.default=k},function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(10)),f=r(l),d=n(12),h=r(d),m=(0,h.default)(f.default),y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(){for(var e=r.props.minDate?r.props.minDate.year():1900,t=r.props.maxDate?r.props.maxDate.year():2100,n=[],o=e;o<=t;o++)n.push(c.default.createElement("option",{key:o,value:o},o));return n},r.onSelectChange=function(e){r.onChange(e.target.value)},r.renderSelectMode=function(){return c.default.createElement("select",{value:r.props.year,className:"react-datepicker__year-select",onChange:r.onSelectChange},r.renderSelectOptions())},r.renderReadView=function(e){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),c.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},r.props.year))},r.renderDropdown=function(){return c.default.createElement(m,{key:"dropdown",ref:"options",year:r.props.year,onChange:r.onChange,onCancel:r.toggleDropdown,scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})},r.renderScrollMode=function(){var e=r.state.dropdownVisible,t=[r.renderReadView(!e)];return e&&t.unshift(r.renderDropdown()),t},r.onChange=function(e){r.toggleDropdown(),e!==r.props.year&&r.props.onChange(e)},r.toggleDropdown=function(){r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=void 0;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return c.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},e)}}]),t}(c.default.Component);t.default=y},function(e,n){e.exports=t},function(e,t,n){e.exports=n(6)()},function(e,t,n){"use strict";var r=n(7),o=n(8),a=n(9);e.exports=function(){function e(e,t,n,r,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,a,i,s,p){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,r,a,i,s,p],l=0;c=new Error(t.replace(/%s/g,function(){return u[l++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e,t){for(var n=[],r=0;r<2*t+1;r++)n.push(e+t-r);return n}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=r(c),l=n(5),f=(r(l),n(11)),d=r(f),h=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map(function(t){return u.default.createElement("div",{className:"react-datepicker__year-option",key:t,ref:t,onClick:n.onChange.bind(n,t)},e===t?u.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)});return t.unshift(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),t.push(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)};var r=e.yearDropdownItemNumber,i=e.scrollableYearDropdown,p=r||(i?10:5);return n.state={yearsList:s(n.props.year,p)},n}return i(t,e),p(t,[{key:"render",value:function(){var e=(0,d.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return u.default.createElement("div",{className:e},this.renderOptions())}}]),t}(u.default.Component);t.default=h},function(e,t,n){var r,o;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var o=typeof r;if("string"===o||"number"===o)e.push(r);else if(Array.isArray(r))e.push(n.apply(null,r));else if("object"===o)for(var i in r)a.call(r,i)&&r[i]&&e.push(i)}}return e.join(" ")}var a={}.hasOwnProperty;"undefined"!=typeof e&&e.exports?e.exports=n:(r=[],o=function(){return n}.apply(t,r),!(void 0!==o&&(e.exports=o)))}()},function(e,t){e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(14)),f=r(l),d=n(12),h=r(d),m=n(2),y=r(m),v=(0,h.default)(f.default),b=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(e){return e.map(function(e,t){return c.default.createElement("option",{key:t,value:t},e)})},r.renderSelectMode=function(e){return c.default.createElement("select",{value:r.props.month,className:"react-datepicker__month-select",onChange:function(e){return r.onChange(e.target.value)}},r.renderSelectOptions(e))},r.renderReadView=function(e,t){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},t[r.props.month]),c.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},r.renderDropdown=function(e){return c.default.createElement(v,{key:"dropdown",ref:"options",month:r.props.month,monthNames:e,onChange:r.onChange,onCancel:r.toggleDropdown})},r.renderScrollMode=function(e){var t=r.state.dropdownVisible,n=[r.renderReadView(!t,e)];return t&&n.unshift(r.renderDropdown(e)),n},r.onChange=function(e){r.toggleDropdown(),e!==r.props.month&&r.props.onChange(e)},r.toggleDropdown=function(){return r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=this,t=y.default.localeData(this.props.locale),n=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(n){return t.months((0,y.default)({M:n}),e.props.dateFormat)}),r=void 0;switch(this.props.dropdownMode){case"scroll":r=this.renderScrollMode(n);break;case"select":r=this.renderSelectMode(n)}return c.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},r)}}]),t}(c.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.renderOptions=function(){return r.props.monthNames.map(function(e,t){return c.default.createElement("div",{className:"react-datepicker__month-option",key:e,ref:e,onClick:r.onChange.bind(r,t)},r.props.month===t?c.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})},r.onChange=function(e){return r.props.onChange(e)},r.handleClickOutside=function(){return r.props.onCancel()},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(c.default.Component));t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=n(16),h=r(d),m=6,y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleMouseLeave=function(){r.props.onMouseLeave&&r.props.onMouseLeave()},r.isWeekInMonth=function(e){var t=r.props.day,n=e.clone().add(6,"days");return e.isSame(t,"month")||n.isSame(t,"month")},r.renderWeeks=function(){for(var e=[],t=r.props.fixedHeight,n=r.props.day.clone().startOf("month").startOf("week"),o=0,a=!1;;){if(e.push(c.default.createElement(h.default,{key:o,day:n,month:r.props.day.month(),onDayClick:r.handleDayClick,onDayMouseEnter:r.handleDayMouseEnter,onWeekSelect:r.props.onWeekSelect,formatWeekNumber:r.props.formatWeekNumber,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,showWeekNumber:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})),a)break;o++,n=n.clone().add(1,"weeks");var i=t&&o>=m,s=!t&&!r.isWeekInMonth(n);if(i||s){if(!r.props.peekNextMonth)break;a=!0}}return e},r.getClassNames=function(){var e=r.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd;return(0,f.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(n||o)})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(17)),f=r(l),d=n(19),h=r(d),m=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleWeekClick=function(e,t,n){"function"==typeof r.props.onWeekSelect&&r.props.onWeekSelect(e,t,n)},r.formatWeekNumber=function(e){return r.props.formatWeekNumber?r.props.formatWeekNumber(e):parseInt(e.format("w"),10)},r.renderDays=function(){var e=r.props.day.clone().startOf("week"),t=[],n=r.formatWeekNumber(e);if(r.props.showWeekNumber){var o=r.props.onWeekSelect?r.handleWeekClick.bind(r,e,n):void 0;t.push(c.default.createElement(h.default,{key:"W",weekNumber:n,onClick:o}))}return t.concat([0,1,2,3,4,5,6].map(function(t){var n=e.clone().add(t,"days");return c.default.createElement(f.default,{key:t,day:n,month:r.props.month,onClick:r.handleDayClick.bind(r,n),onMouseEnter:r.handleDayMouseEnter.bind(r,n),minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})}))},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}]),t}(c.default.Component);t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(2),l=r(u),f=n(4),d=r(f),h=n(5),m=(r(h),n(11)),y=r(m),v=n(18),b=function(e){function t(){var e,n,r,s;a(this,t);for(var c=arguments.length,u=Array(c),f=0;f<c;f++)u[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),r.handleClick=function(e){!r.isDisabled()&&r.props.onClick&&r.props.onClick(e)},r.handleMouseEnter=function(e){!r.isDisabled()&&r.props.onMouseEnter&&r.props.onMouseEnter(e)},r.isSameDay=function(e){return(0,v.isSameDay)(r.props.day,e)},r.isKeyboardSelected=function(){return!r.props.inline&&!r.isSameDay(r.props.selected)&&r.isSameDay(r.props.preSelection)},r.isDisabled=function(){return(0,v.isDayDisabled)(r.props.day,r.props)},r.getHighLightedClass=function(e){var t=r.props,n=t.day,a=t.highlightDates;if(!a)return o({},e,!1);for(var i={},s=0,c=a.length;s<c;s++){var u=a[s];if(u instanceof l.default)(0,v.isSameDay)(n,u)&&(i[e]=!0);else if("object"===("undefined"==typeof u?"undefined":p(u))){var f=Object.keys(u),d=u[f[0]];if("string"==typeof f[0]&&d.constructor===Array)for(var h=0,m=d.length;h<m;h++)(0,v.isSameDay)(n,d[h])&&(i[f[0]]=!0)}}return i},r.isInRange=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isDayInRange)(t,n,o)},r.isInSelectingRange=function(){var e=r.props,t=e.day,n=e.selectsStart,o=e.selectsEnd,a=e.selectingDate,i=e.startDate,s=e.endDate;return!(!n&&!o||!a||r.isDisabled())&&(n&&s&&a.isSameOrBefore(s)?(0,v.isDayInRange)(t,a,s):!!(o&&i&&a.isSameOrAfter(i))&&(0,v.isDayInRange)(t,i,a))},r.isSelectingRangeStart=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.startDate,a=e.selectsStart;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isSelectingRangeEnd=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.endDate,a=e.selectsEnd;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isRangeStart=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(n,t)},r.isRangeEnd=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(o,t)},r.isWeekend=function(){var e=r.props.day.day();return 0===e||6===e},r.isOutsideMonth=function(){return void 0!==r.props.month&&r.props.month!==r.props.day.month()},r.getClassNames=function(e){var t=r.props.dayClassName?r.props.dayClassName(e):void 0;return(0,y.default)("react-datepicker__day",t,"react-datepicker__day--"+(0,v.getDayOfWeekCode)(r.props.day),{"react-datepicker__day--disabled":r.isDisabled(),"react-datepicker__day--selected":r.isSameDay(r.props.selected),"react-datepicker__day--keyboard-selected":r.isKeyboardSelected(),"react-datepicker__day--range-start":r.isRangeStart(),"react-datepicker__day--range-end":r.isRangeEnd(),"react-datepicker__day--in-range":r.isInRange(),"react-datepicker__day--in-selecting-range":r.isInSelectingRange(),"react-datepicker__day--selecting-range-start":r.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":r.isSelectingRangeEnd(),"react-datepicker__day--today":r.isSameDay(l.default.utc().utcOffset(r.props.utcOffset)),"react-datepicker__day--weekend":r.isWeekend(),"react-datepicker__day--outside-month":r.isOutsideMonth()},r.getHighLightedClass("react-datepicker__day--highlighted"))},s=n,i(r,s)}return s(t,e),c(t,[{key:"render",value:function(){return d.default.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+this.props.day.date(),role:"option"},this.props.day.date())}}]),t}(d.default.Component);b.defaultProps={utcOffset:l.default.utc().utcOffset()},t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e&&t?e.isSame(t,"day"):!e&&!t}function a(e,t){return e&&t?e.utcOffset()===t.utcOffset():!e&&!t}function i(e,t,n){var r=t.clone().startOf("day").subtract(1,"seconds"),o=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(r,o)}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,a=t.excludeDates,i=t.includeDates,s=t.filterDate;return n&&e.isBefore(n,"day")||r&&e.isAfter(r,"day")||a&&a.some(function(t){return o(e,t)})||i&&!i.some(function(t){return o(e,t)})||s&&!s(e.clone())||!1}function p(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.minDate,o=n.includeDates,a=e.clone().subtract(1,t);return r&&a.isBefore(r,t)||o&&o.every(function(e){return a.isBefore(e,t)})||!1}function c(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.maxDate,o=n.includeDates,a=e.clone().add(1,t);return r&&a.isAfter(r,t)||o&&o.every(function(e){return a.isAfter(e,t)})||!1}function u(e){var t=e.minDate,n=e.includeDates;return n&&t?y.default.min(n.filter(function(e){return t.isSameOrBefore(e,"day")})):n?y.default.min(n):t}function l(e){var t=e.maxDate,n=e.includeDates;return n&&t?y.default.max(n.filter(function(e){return t.isSameOrAfter(e,"day")})):n?y.default.max(n):t}function f(e,t){var n=t.dateFormat,r=t.locale,o=(0,y.default)(e,n,r||y.default.locale(),!0);return o.isValid()?o:null}function d(e,t){var n=t.dateFormat,r=t.locale;return e&&e.clone().locale(r||y.default.locale()).format(Array.isArray(n)?n[0]:n)||""}function h(e){return v[e.isoWeekday()]}Object.defineProperty(t,"__esModule",{value:!0}),t.isSameDay=o,t.isSameUtcOffset=a,t.isDayInRange=i,t.isDayDisabled=s,t.allDaysDisabledBefore=p,t.allDaysDisabledAfter=c,t.getEffectiveMinDate=u,t.getEffectiveMaxDate=l,t.parseDate=f,t.safeDateFormat=d,t.getDayOfWeekCode=h;var m=n(2),y=r(m),v={1:"mon",2:"tue",3:"wed",4:"thu",5:"fri",6:"sat",7:"sun"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){r.props.onClick&&r.props.onClick(e)},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return c.default.createElement("div",{className:(0,f.default)(e),"aria-label":"week-"+this.props.weekNumber,onClick:this.handleClick},this.props.weekNumber)}}]),t}(c.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.popperPlacementPositions=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(21)),f=(t.popperPlacementPositions=["auto","auto-left","auto-right","bottom","bottom-end","bottom-start","left","left-end","left-start","right","right-end","right-start","top","top-end","top-start"],function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){var e=this.props,t=e.hidePopper,n=e.popperComponent,r=e.popperModifiers,o=e.popperPlacement,a=e.targetComponent;return c.default.createElement(l.Manager,null,c.default.createElement(l.Target,{className:"react-datepicker-wrapper"},a),!t&&c.default.createElement(l.Popper,{className:"react-datepicker-popper",modifiers:r,placement:o},n))}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperPlacement:"bottom-start"}}}]),t}(c.default.Component));t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Arrow=t.Popper=t.Target=t.Manager=void 0;var o=n(22),a=r(o),i=n(23),s=r(i),p=n(24),c=r(p),u=n(28),l=r(u);t.Manager=a.default,t.Target=s.default,t.Popper=c.default,t.Arrow=l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=(r(c),n(5)),l=r(u),f=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r._setTargetNode=function(e){r._targetNode=e},r._getTargetNode=function(){return r._targetNode},o=n,i(r,o)}return s(t,e),p(t,[{key:"getChildContext",value:function(){return{popperManager:{setTargetNode:this._setTargetNode,getTargetNode:this._getTargetNode}}}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.children,r=o(e,["tag","children"]);return t!==!1?(0,c.createElement)(t,r,n):n}}]),t}(c.Component);f.childContextTypes={popperManager:l.default.object.isRequired},f.propTypes={tag:l.default.oneOfType([l.default.string,l.default.bool])},f.defaultProps={tag:"div"},t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"div":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popperManager,l=function(e){u.setTargetNode(e),"function"==typeof s&&s(e)};if("function"==typeof p){var f={ref:l};return p({targetProps:f,restProps:c})}var d=a({},c);return"string"==typeof r?d.ref=l:d.innerRef=l,(0,i.createElement)(r,d,p)};c.contextTypes={popperManager:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(4),f=(r(l),n(5)),d=r(f),h=n(25),m=r(h),y=n(26),v=r(y),b=function(e){function t(){var e,n,r,o;i(this,t);for(var a=arguments.length,p=Array(a),u=0;u<a;u++)p[u]=arguments[u];return n=r=s(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={},r._setArrowNode=function(e){r._arrowNode=e},r._getTargetNode=function(){return r.context.popperManager.getTargetNode()},r._updateStateModifier={enabled:!0,order:900,fn:function(e){return(r.state.data&&!(0,v.default)(e.offsets,r.state.data.offsets)||!r.state.data)&&r.setState({data:e}),e}},r._getPopperStyle=function(){var e=r.state.data;if(!r._popper||!e)return{position:"absolute",pointerEvents:"none",opacity:0};var t=e.offsets.popper,n=(t.top,t.left,t.position);return c({position:n},e.styles)},r._getPopperPlacement=function(){return r.state.data?r.state.data.placement:void 0},r._getArrowStyle=function(){if(r.state.data&&r.state.data.offsets.arrow){var e=r.state.data.offsets.arrow,t=e.top,n=e.left;return{top:t,left:n}}return{}},o=n,s(r,o)}return p(t,e),u(t,[{key:"getChildContext",value:function(){return{popper:{setArrowNode:this._setArrowNode,getArrowStyle:this._getArrowStyle}}}},{key:"componentDidMount",value:function(){this._updatePopper()}},{key:"componentDidUpdate",value:function(e){e.placement===this.props.placement&&e.eventsEnabled===this.props.eventsEnabled||this._updatePopper(),this._popper&&e.children!==this.props.children&&this._popper.scheduleUpdate()}},{key:"componentWillUnmount",value:function(){this._destroyPopper()}},{key:"_updatePopper",value:function(){this._destroyPopper(),this._node&&this._createPopper()}},{key:"_createPopper",value:function(){var e=this.props,t=e.placement,n=e.eventsEnabled,r=c({},this.props.modifiers,{applyStyle:{enabled:!1},updateState:this._updateStateModifier});this._arrowNode&&(r.arrow={element:this._arrowNode}),this._popper=new m.default(this._getTargetNode(),this._node,{placement:t,eventsEnabled:n,modifiers:r}),this._popper.scheduleUpdate()}},{key:"_destroyPopper",value:function(){this._popper&&this._popper.destroy()}},{key:"render",value:function(){var e=this,t=this.props,n=t.component,r=t.innerRef,i=(t.placement,t.eventsEnabled,t.modifiers,t.children),s=a(t,["component","innerRef","placement","eventsEnabled","modifiers","children"]),p=function(t){e._node=t,"function"==typeof r&&r(t)},u=this._getPopperStyle(),f=this._getPopperPlacement();if("function"==typeof i){var d=o({ref:p,style:u},"data-placement",f);return i({popperProps:d,restProps:s,scheduleUpdate:this._popper&&this._popper.scheduleUpdate})}var h=c({},s,{style:c({},s.style,u),"data-placement":f});return"string"==typeof n?h.ref=p:h.innerRef=p,(0,l.createElement)(n,h,i)}}]),t}(l.Component);b.contextTypes={popperManager:d.default.object.isRequired},b.childContextTypes={popper:d.default.object.isRequired},b.propTypes={component:d.default.oneOfType([d.default.node,d.default.func]),innerRef:d.default.func,placement:d.default.oneOf(m.default.placements),eventsEnabled:d.default.bool,modifiers:d.default.object,children:d.default.oneOfType([d.default.node,d.default.func])},b.defaultProps={component:"div",placement:"bottom",eventsEnabled:!0,modifiers:{}},t.default=b},function(e,t,n){(function(t){/**!
		 * @fileOverview Kickass library to create and place poppers near their reference elements.
		 * @version 1.12.3
		 * @license
		 * Copyright (c) 2016 Federico Zivolo and contributors
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in all
		 * copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		 * SOFTWARE.
		 */
	!function(t,n){e.exports=n()}(this,function(){"use strict";function e(e){var t=!1,n=0,r=document.createElement("span"),o=new MutationObserver(function(){e(),t=!1});return o.observe(r,{attributes:!0}),function(){t||(t=!0,r.setAttribute("x-index",n),n+=1)}}function n(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},ce))}}function r(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function o(e,t){if(1!==e.nodeType)return[];var n=window.getComputedStyle(e,null);return t?n[t]:n}function a(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function i(e){if(!e||["HTML","BODY","#document"].indexOf(e.nodeName)!==-1)return window.document.body;var t=o(e),n=t.overflow,r=t.overflowX,s=t.overflowY;return/(auto|scroll)/.test(n+s+r)?e:i(a(e))}function s(e){var t=e&&e.offsetParent,n=t&&t.nodeName;return n&&"BODY"!==n&&"HTML"!==n?["TD","TABLE"].indexOf(t.nodeName)!==-1&&"static"===o(t,"position")?s(t):t:window.document.documentElement}function p(e){var t=e.nodeName;return"BODY"!==t&&("HTML"===t||s(e.firstElementChild)===e)}function c(e){return null!==e.parentNode?c(e.parentNode):e}function u(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return window.document.documentElement;var n=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=n?e:t,o=n?t:e,a=document.createRange();a.setStart(r,0),a.setEnd(o,0);var i=a.commonAncestorContainer;if(e!==i&&t!==i||r.contains(o))return p(i)?i:s(i);var l=c(e);return l.host?u(l.host,t):u(e,c(t).host)}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var o=window.document.documentElement,a=window.document.scrollingElement||o;return a[n]}return e[n]}function f(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=l(t,"top"),o=l(t,"left"),a=n?-1:1;return e.top+=r*a,e.bottom+=r*a,e.left+=o*a,e.right+=o*a,e}function d(e,t){var n="x"===t?"Left":"Top",r="Left"===n?"Right":"Bottom";return+e["border"+n+"Width"].split("px")[0]+ +e["border"+r+"Width"].split("px")[0]}function h(e,t,n,r){return Math.max(t["offset"+e],t["scroll"+e],n["client"+e],n["offset"+e],n["scroll"+e],he()?n["offset"+e]+r["margin"+("Height"===e?"Top":"Left")]+r["margin"+("Height"===e?"Bottom":"Right")]:0)}function m(){var e=window.document.body,t=window.document.documentElement,n=he()&&window.getComputedStyle(t);return{height:h("Height",e,t,n),width:h("Width",e,t,n)}}function y(e){return be({},e,{right:e.left+e.width,bottom:e.top+e.height})}function v(e){var t={};if(he())try{t=e.getBoundingClientRect();var n=l(e,"top"),r=l(e,"left");t.top+=n,t.left+=r,t.bottom+=n,t.right+=r}catch(e){}else t=e.getBoundingClientRect();var a={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},i="HTML"===e.nodeName?m():{},s=i.width||e.clientWidth||a.right-a.left,p=i.height||e.clientHeight||a.bottom-a.top,c=e.offsetWidth-s,u=e.offsetHeight-p;if(c||u){var f=o(e);c-=d(f,"x"),u-=d(f,"y"),a.width-=c,a.height-=u}return y(a)}function b(e,t){var n=he(),r="HTML"===t.nodeName,a=v(e),s=v(t),p=i(e),c=o(t),u=+c.borderTopWidth.split("px")[0],l=+c.borderLeftWidth.split("px")[0],d=y({top:a.top-s.top-u,left:a.left-s.left-l,width:a.width,height:a.height});if(d.marginTop=0,d.marginLeft=0,!n&&r){var h=+c.marginTop.split("px")[0],m=+c.marginLeft.split("px")[0];d.top-=u-h,d.bottom-=u-h,d.left-=l-m,d.right-=l-m,d.marginTop=h,d.marginLeft=m}return(n?t.contains(p):t===p&&"BODY"!==p.nodeName)&&(d=f(d,t)),d}function g(e){var t=window.document.documentElement,n=b(e,t),r=Math.max(t.clientWidth,window.innerWidth||0),o=Math.max(t.clientHeight,window.innerHeight||0),a=l(t),i=l(t,"left"),s={top:a-n.top+n.marginTop,left:i-n.left+n.marginLeft,width:r,height:o};return y(s)}function w(e){var t=e.nodeName;return"BODY"!==t&&"HTML"!==t&&("fixed"===o(e,"position")||w(a(e)))}function _(e,t,n,r){var o={top:0,left:0},s=u(e,t);if("viewport"===r)o=g(s);else{var p=void 0;"scrollParent"===r?(p=i(a(e)),"BODY"===p.nodeName&&(p=window.document.documentElement)):p="window"===r?window.document.documentElement:r;var c=b(p,s);if("HTML"!==p.nodeName||w(s))o=c;else{var l=m(),f=l.height,d=l.width;o.top+=c.top-c.marginTop,o.bottom=f+c.top,o.left+=c.left-c.marginLeft,o.right=d+c.left}}return o.left+=n,o.top+=n,o.right-=n,o.bottom-=n,o}function D(e){var t=e.width,n=e.height;return t*n}function O(e,t,n,r,o){var a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(e.indexOf("auto")===-1)return e;var i=_(n,r,a,o),s={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},p=Object.keys(s).map(function(e){return be({key:e},s[e],{area:D(s[e])})}).sort(function(e,t){return t.area-e.area}),c=p.filter(function(e){var t=e.width,r=e.height;return t>=n.clientWidth&&r>=n.clientHeight}),u=c.length>0?c[0].key:p[0].key,l=e.split("-")[1];return u+(l?"-"+l:"")}function k(e,t,n){var r=u(t,n);return b(n,r)}function E(e){var t=window.getComputedStyle(e),n=parseFloat(t.marginTop)+parseFloat(t.marginBottom),r=parseFloat(t.marginLeft)+parseFloat(t.marginRight),o={width:e.offsetWidth+r,height:e.offsetHeight+n};return o}function S(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function C(e,t,n){n=n.split("-")[0];var r=E(e),o={width:r.width,height:r.height},a=["right","left"].indexOf(n)!==-1,i=a?"top":"left",s=a?"left":"top",p=a?"height":"width",c=a?"width":"height";return o[i]=t[i]+t[p]/2-r[p]/2,n===s?o[s]=t[s]-r[c]:o[s]=t[S(s)],o}function M(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function P(e,t,n){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===n});var r=M(e,function(e){return e[t]===n});return e.indexOf(r)}function N(e,t,n){var o=void 0===n?e:e.slice(0,P(e,"name",n));return o.forEach(function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=e.function||e.fn;e.enabled&&r(n)&&(t.offsets.popper=y(t.offsets.popper),t.offsets.reference=y(t.offsets.reference),t=n(t,e))}),t}function x(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=k(this.state,this.popper,this.reference),e.placement=O(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.offsets.popper=C(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position="absolute",e=N(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function j(e,t){return e.some(function(e){var n=e.name,r=e.enabled;return r&&n===t})}function T(e){for(var t=[!1,"ms","Webkit","Moz","O"],n=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length-1;r++){var o=t[r],a=o?""+o+n:e;if("undefined"!=typeof window.document.body.style[a])return a}return null}function R(){return this.state.isDestroyed=!0,j(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.left="",this.popper.style.position="",this.popper.style.top="",this.popper.style[T("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function W(e,t,n,r){var o="BODY"===e.nodeName,a=o?window:e;a.addEventListener(t,n,{passive:!0}),o||W(i(a.parentNode),t,n,r),r.push(a)}function L(e,t,n,r){n.updateBound=r,window.addEventListener("resize",n.updateBound,{passive:!0});var o=i(e);return W(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function F(){this.state.eventsEnabled||(this.state=L(this.reference,this.options,this.state,this.scheduleUpdate))}function I(e,t){return window.removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function A(){this.state.eventsEnabled&&(window.cancelAnimationFrame(this.scheduleUpdate),this.state=I(this.reference,this.state))}function B(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function Y(e,t){Object.keys(t).forEach(function(n){var r="";["width","height","top","right","bottom","left"].indexOf(n)!==-1&&B(t[n])&&(r="px"),e.style[n]=t[n]+r})}function H(e,t){Object.keys(t).forEach(function(n){var r=t[n];r!==!1?e.setAttribute(n,t[n]):e.removeAttribute(n)})}function U(e){return Y(e.instance.popper,e.styles),H(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&Y(e.arrowElement,e.arrowStyles),e}function V(e,t,n,r,o){var a=k(o,t,e),i=O(n.placement,a,t,e,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return t.setAttribute("x-placement",i),Y(t,{position:"absolute"}),n}function q(e,t){var n=t.x,r=t.y,o=e.offsets.popper,a=M(e.instance.modifiers,function(e){return"applyStyle"===e.name}).gpuAcceleration;void 0!==a&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var i=void 0!==a?a:t.gpuAcceleration,p=s(e.instance.popper),c=v(p),u={position:o.position},l={left:Math.floor(o.left),top:Math.floor(o.top),bottom:Math.floor(o.bottom),right:Math.floor(o.right)},f="bottom"===n?"top":"bottom",d="right"===r?"left":"right",h=T("transform"),m=void 0,y=void 0;if(y="bottom"===f?-c.height+l.bottom:l.top,m="right"===d?-c.width+l.right:l.left,i&&h)u[h]="translate3d("+m+"px, "+y+"px, 0)",u[f]=0,u[d]=0,u.willChange="transform";else{var b="bottom"===f?-1:1,g="right"===d?-1:1;u[f]=y*b,u[d]=m*g,u.willChange=f+", "+d}var w={"x-placement":e.placement};return e.attributes=be({},w,e.attributes),e.styles=be({},u,e.styles),e.arrowStyles=be({},e.offsets.arrow,e.arrowStyles),e}function K(e,t,n){var r=M(e,function(e){var n=e.name;return n===t}),o=!!r&&e.some(function(e){return e.name===n&&e.enabled&&e.order<r.order});if(!o){var a="`"+t+"`",i="`"+n+"`";console.warn(i+" modifier is required by "+a+" modifier in order to work, be sure to include it before "+a+"!")}return o}function z(e,t){if(!K(e.instance.modifiers,"arrow","keepTogether"))return e;var n=t.element;if("string"==typeof n){if(n=e.instance.popper.querySelector(n),!n)return e}else if(!e.instance.popper.contains(n))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var r=e.placement.split("-")[0],a=e.offsets,i=a.popper,s=a.reference,p=["left","right"].indexOf(r)!==-1,c=p?"height":"width",u=p?"Top":"Left",l=u.toLowerCase(),f=p?"left":"top",d=p?"bottom":"right",h=E(n)[c];s[d]-h<i[l]&&(e.offsets.popper[l]-=i[l]-(s[d]-h)),s[l]+h>i[d]&&(e.offsets.popper[l]+=s[l]+h-i[d]);var m=s[l]+s[c]/2-h/2,v=o(e.instance.popper,"margin"+u).replace("px",""),b=m-y(e.offsets.popper)[l]-v;return b=Math.max(Math.min(i[c]-h,b),0),e.arrowElement=n,e.offsets.arrow={},e.offsets.arrow[l]=Math.round(b),e.offsets.arrow[f]="",e}function G(e){return"end"===e?"start":"start"===e?"end":e}function X(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=we.indexOf(e),r=we.slice(n+1).concat(we.slice(0,n));return t?r.reverse():r}function J(e,t){if(j(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var n=_(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement),r=e.placement.split("-")[0],o=S(r),a=e.placement.split("-")[1]||"",i=[];switch(t.behavior){case _e.FLIP:i=[r,o];break;case _e.CLOCKWISE:i=X(r);break;case _e.COUNTERCLOCKWISE:i=X(r,!0);break;default:i=t.behavior}return i.forEach(function(s,p){if(r!==s||i.length===p+1)return e;r=e.placement.split("-")[0],o=S(r);var c=e.offsets.popper,u=e.offsets.reference,l=Math.floor,f="left"===r&&l(c.right)>l(u.left)||"right"===r&&l(c.left)<l(u.right)||"top"===r&&l(c.bottom)>l(u.top)||"bottom"===r&&l(c.top)<l(u.bottom),d=l(c.left)<l(n.left),h=l(c.right)>l(n.right),m=l(c.top)<l(n.top),y=l(c.bottom)>l(n.bottom),v="left"===r&&d||"right"===r&&h||"top"===r&&m||"bottom"===r&&y,b=["top","bottom"].indexOf(r)!==-1,g=!!t.flipVariations&&(b&&"start"===a&&d||b&&"end"===a&&h||!b&&"start"===a&&m||!b&&"end"===a&&y);(f||v||g)&&(e.flipped=!0,(f||v)&&(r=i[p+1]),g&&(a=G(a)),e.placement=r+(a?"-"+a:""),e.offsets.popper=be({},e.offsets.popper,C(e.instance.popper,e.offsets.reference,e.placement)),e=N(e.instance.modifiers,e,"flip"))}),e}function Q(e){var t=e.offsets,n=t.popper,r=t.reference,o=e.placement.split("-")[0],a=Math.floor,i=["top","bottom"].indexOf(o)!==-1,s=i?"right":"bottom",p=i?"left":"top",c=i?"width":"height";return n[s]<a(r[p])&&(e.offsets.popper[p]=a(r[p])-n[c]),n[p]>a(r[s])&&(e.offsets.popper[p]=a(r[s])),e}function Z(e,t,n,r){var o=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),a=+o[1],i=o[2];if(!a)return e;if(0===i.indexOf("%")){var s=void 0;switch(i){case"%p":s=n;break;case"%":case"%r":default:s=r}var p=y(s);return p[t]/100*a}if("vh"===i||"vw"===i){var c=void 0;return c="vh"===i?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0),c/100*a}return a}function $(e,t,n,r){var o=[0,0],a=["right","left"].indexOf(r)!==-1,i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=i.indexOf(M(i,function(e){return e.search(/,|\s/)!==-1}));i[s]&&i[s].indexOf(",")===-1&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var p=/\s*,\s*|\s+/,c=s!==-1?[i.slice(0,s).concat([i[s].split(p)[0]]),[i[s].split(p)[1]].concat(i.slice(s+1))]:[i];return c=c.map(function(e,r){var o=(1===r?!a:a)?"height":"width",i=!1;return e.reduce(function(e,t){return""===e[e.length-1]&&["+","-"].indexOf(t)!==-1?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return Z(e,o,t,n)})}),c.forEach(function(e,t){e.forEach(function(n,r){B(n)&&(o[t]+=n*("-"===e[r-1]?-1:1))})}),o}function ee(e,t){var n=t.offset,r=e.placement,o=e.offsets,a=o.popper,i=o.reference,s=r.split("-")[0],p=void 0;return p=B(+n)?[+n,0]:$(n,a,i,s),"left"===s?(a.top+=p[0],a.left-=p[1]):"right"===s?(a.top+=p[0],a.left+=p[1]):"top"===s?(a.left+=p[0],a.top-=p[1]):"bottom"===s&&(a.left+=p[0],a.top+=p[1]),e.popper=a,e}function te(e,t){var n=t.boundariesElement||s(e.instance.popper);e.instance.reference===n&&(n=s(n));var r=_(e.instance.popper,e.instance.reference,t.padding,n);t.boundaries=r;var o=t.priority,a=e.offsets.popper,i={primary:function(e){var n=a[e];return a[e]<r[e]&&!t.escapeWithReference&&(n=Math.max(a[e],r[e])),ve({},e,n)},secondary:function(e){var n="right"===e?"left":"top",o=a[n];return a[e]>r[e]&&!t.escapeWithReference&&(o=Math.min(a[n],r[e]-("right"===e?a.width:a.height))),ve({},n,o)}};return o.forEach(function(e){var t=["left","top"].indexOf(e)!==-1?"primary":"secondary";a=be({},a,i[t](e))}),e.offsets.popper=a,e}function ne(e){var t=e.placement,n=t.split("-")[0],r=t.split("-")[1];if(r){var o=e.offsets,a=o.reference,i=o.popper,s=["bottom","top"].indexOf(n)!==-1,p=s?"left":"top",c=s?"width":"height",u={start:ve({},p,a[p]),end:ve({},p,a[p]+a[c]-i[c])};e.offsets.popper=be({},i,u[r])}return e}function re(e){if(!K(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,n=M(e.instance.modifiers,function(e){return"preventOverflow"===e.name}).boundaries;if(t.bottom<n.top||t.left>n.right||t.top>n.bottom||t.right<n.left){if(e.hide===!0)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(e.hide===!1)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}function oe(e){var t=e.placement,n=t.split("-")[0],r=e.offsets,o=r.popper,a=r.reference,i=["left","right"].indexOf(n)!==-1,s=["top","left"].indexOf(n)===-1;return o[i?"left":"top"]=a[n]-(s?o[i?"width":"height"]:0),e.placement=S(t),e.offsets.popper=y(o),e}for(var ae=["native code","[object MutationObserverConstructor]"],ie=function(e){return ae.some(function(t){return(e||"").toString().indexOf(t)>-1})},se="undefined"!=typeof window,pe=["Edge","Trident","Firefox"],ce=0,ue=0;ue<pe.length;ue+=1)if(se&&navigator.userAgent.indexOf(pe[ue])>=0){ce=1;break}var le=se&&ie(window.MutationObserver),fe=le?e:n,de=void 0,he=function(){return void 0===de&&(de=navigator.appVersion.indexOf("MSIE 10")!==-1),de},me=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},ye=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),ve=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},be=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ge=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],we=ge.slice(3),_e={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},De={shift:{order:100,enabled:!0,fn:ne},offset:{order:200,enabled:!0,fn:ee,offset:0},preventOverflow:{order:300,enabled:!0,fn:te,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:Q},arrow:{order:500,enabled:!0,fn:z,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:J,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:oe},hide:{order:800,enabled:!0,fn:re},computeStyle:{order:850,enabled:!0,fn:q,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:U,onLoad:V,gpuAcceleration:void 0}},Oe={placement:"bottom",eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:De},ke=function(){function e(t,n){var o=this,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};me(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(o.update)},this.update=fe(this.update.bind(this)),this.options=be({},e.Defaults,a),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t.jquery?t[0]:t,this.popper=n.jquery?n[0]:n,this.options.modifiers={},Object.keys(be({},e.Defaults.modifiers,a.modifiers)).forEach(function(t){o.options.modifiers[t]=be({},e.Defaults.modifiers[t]||{},a.modifiers?a.modifiers[t]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return be({name:e},o.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&r(e.onLoad)&&e.onLoad(o.reference,o.popper,o.options,e,o.state)}),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return ye(e,[{key:"update",value:function(){return x.call(this)}},{key:"destroy",value:function(){return R.call(this)}},{key:"enableEventListeners",value:function(){return F.call(this)}},{key:"disableEventListeners",value:function(){return A.call(this)}}]),e}();return ke.Utils=("undefined"!=typeof window?window:t).PopperUtils,ke.placements=ge,ke.Defaults=Oe,ke})}).call(t,function(){return this}())},function(e,t,n){/*!
		 * is-equal-shallow <https://github.com/jonschlinkert/is-equal-shallow>
		 *
		 * Copyright (c) 2015, Jon Schlinkert.
		 * Licensed under the MIT License.
		 */
	"use strict";var r=n(27);e.exports=function(e,t){if(!e&&!t)return!0;if(!e&&t||e&&!t)return!1;var n,o=0,a=0;for(n in t)if(a++,!r(t[n])||!e.hasOwnProperty(n)||e[n]!==t[n])return!1;for(n in e)o++;return o===a}},function(e,t){/*!
		 * is-primitive <https://github.com/jonschlinkert/is-primitive>
		 *
		 * Copyright (c) 2014-2015, Jon Schlinkert.
		 * Licensed under the MIT License.
		 */
	"use strict";e.exports=function(e){return null==e||"function"!=typeof e&&"object"!=typeof e}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"span":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popper,l=function(e){u.setArrowNode(e),"function"==typeof s&&s(e)},f=u.getArrowStyle();if("function"==typeof p){var d={ref:l,style:f};return p({arrowProps:d,restProps:c})}var h=a({},c,{style:a({},f,c.style)});return"string"==typeof r?h.ref=l:h.innerRef=l,(0,i.createElement)(r,h,p)};c.contextTypes={popper:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c}])});

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomCard(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card margin_bottom_40 ' + (className || '') },
	    children
	  );
	}
	
	exports.default = CustomCard;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomCardBody(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-block ' + (className || '') + ' ' },
	    children
	  );
	}
	
	exports.default = CustomCardBody;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _toast = __webpack_require__(15);
	
	var _function = __webpack_require__(10);
	
	var _Tooltip = __webpack_require__(136);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionModeSetting = function (_Component) {
	  _inherits(QuestionModeSetting, _Component);
	
	  function QuestionModeSetting(props) {
	    _classCallCheck(this, QuestionModeSetting);
	
	    var _this = _possibleConstructorReturn(this, (QuestionModeSetting.__proto__ || Object.getPrototypeOf(QuestionModeSetting)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var examNameKey = props.examNameKey;
	
	    var selectedMode = (0, _function.getQuestionModeFromLocalStorage)(examNameKey) || '';
	    _this.state = {
	      isDropdownOpen: false,
	      selectedMode: selectedMode || _constant.QUESTION_MODE.PRACTICE,
	      isModalOpen: false, // default to closed
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(QuestionModeSetting, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var examNameKey = this.props.examNameKey;
	
	      var selectedMode = (0, _function.getQuestionModeFromLocalStorage)(examNameKey) || '';
	      this.setState({
	        selectedMode: selectedMode || _constant.QUESTION_MODE.PRACTICE,
	        isModalOpen: !selectedMode // open modal only if no mode selected
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isDropdownOpen = _state.isDropdownOpen,
	          selectedMode = _state.selectedMode,
	          isModalOpen = _state.isModalOpen,
	          isLoading = _state.isLoading;
	
	      var userSelectedModeTitle = selectedMode === _constant.QUESTION_MODE.PRACTICE ? _messages.messages.PRACTICE_MODE : selectedMode === _constant.QUESTION_MODE.REVISION ? _messages.messages.REVISION_MODE : _messages.messages.SELECT_MODE;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ml-auto' },
	        _react2.default.createElement(
	          _reactstrap.ButtonDropdown,
	          { isOpen: isDropdownOpen, toggle: this.handleDropdownToggle },
	          _react2.default.createElement(
	            _reactstrap.DropdownToggle,
	            {
	              className: 'btn btn-primary overflow-hidden pointer_class tooltip_wrap',
	              caret: true,
	              disabled: isLoading
	            },
	            isLoading && !isModalOpen && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	            ' ',
	            userSelectedModeTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.DropdownMenu,
	            { end: true, className: 'border-0' },
	            _react2.default.createElement(
	              _reactstrap.DropdownItem,
	              {
	                onClick: function onClick() {
	                  return _this2.updateQuestionMode(_constant.QUESTION_MODE.PRACTICE);
	                },
	                active: selectedMode === _constant.QUESTION_MODE.PRACTICE,
	                className: 'pointer_class'
	              },
	              _messages.messages.PRACTICE_MODE,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_padding' },
	                _react2.default.createElement(_Tooltip2.default, {
	                  tooltipId: _constant.QUESTION_MODE.PRACTICE,
	                  content: _messages.messages.PRACTICE_MODE_DESC,
	                  width: '11'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.DropdownItem,
	              {
	                onClick: function onClick() {
	                  return _this2.updateQuestionMode(_constant.QUESTION_MODE.REVISION);
	                },
	                active: selectedMode === _constant.QUESTION_MODE.REVISION,
	                className: 'pointer_class'
	              },
	              _messages.messages.REVISION_MODE,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_padding' },
	                _react2.default.createElement(_Tooltip2.default, {
	                  tooltipId: _constant.QUESTION_MODE.REVISION,
	                  content: _messages.messages.REVISION_MODE_DESC,
	                  width: '11'
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: isModalOpen,
	            className: 'modal-primary custom-centered-modal',
	            centered: true,
	            backdrop: 'static'
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'pl-0' },
	              _messages.messages.SETTINGS_TITLE
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Row,
	              { className: 'mb-1' },
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: 12, className: 'font-weight-bold question-mode-title' },
	                _messages.messages.QUESTION_BANK_MODE_TYPE
	              )
	            ),
	            _constant.QUESTION_MODE_OPTIONS.map(function (mode) {
	              return _react2.default.createElement(
	                _reactstrap.Row,
	                { key: mode.id, className: 'mb-1 justify-content-center' },
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { sm: 10, md: 10 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'd-flex ' },
	                    _react2.default.createElement(
	                      'div',
	                      { onChange: _this2.handleRadioChange },
	                      _react2.default.createElement('input', {
	                        className: 'form-check-input mr-2 pointer_class',
	                        type: 'radio',
	                        id: mode.id,
	                        name: 'mode',
	                        value: mode.value,
	                        checked: selectedMode === mode.value
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: mode.id, className: 'font-weight-medium mb-0 pointer_class' },
	                        mode.label,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'small pointer_class' },
	                          mode.description
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(
	              _reactstrap.Row,
	              { className: 'mb-2' },
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { className: 'small' },
	                _messages.messages.MODE_CHANGE_NOTE
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    color: 'primary',
	                    onClick: function onClick() {
	                      return _this2.updateQuestionMode(selectedMode);
	                    },
	                    disabled: isLoading
	                  },
	                  isLoading ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                    ' ',
	                    _messages.messages.SAVE
	                  ) : _messages.messages.SAVE
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return QuestionModeSetting;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.updateQuestionMode = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(userSelectedMode) {
	      var selectedMode, examNameKey;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              selectedMode = _this3.state.selectedMode;
	
	              _this3.setState({ isLoading: true });
	              examNameKey = _this3.props.examNameKey;
	              _context.prev = 3;
	              _context.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/update/question-mode', {
	                userSelectedMode: userSelectedMode,
	                examNameKey: examNameKey
	              });
	
	            case 6:
	              // Update localStorage using utility
	              (0, _function.setQuestionModeToLocalStorage)(examNameKey, userSelectedMode || selectedMode);
	
	              _this3.setState({
	                isModalOpen: false,
	                selectedMode: userSelectedMode || selectedMode,
	                isLoading: false
	              });
	              (0, _toast.showSuccess)(_messages.messages.QUESTION_MODE_SAVE_SUCCESS.replace(':mode', userSelectedMode === _constant.QUESTION_MODE.REVISION ? _messages.messages.REVISION_MODE : _messages.messages.PRACTICE_MODE));
	              _context.next = 15;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](3);
	
	              _this3.setState({ isLoading: false, isModalOpen: false });
	              (0, _toast.showFailure)(_messages.messages.QUESTION_MODE_SAVE_FAILED);
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3, [[3, 11]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  this.handleDropdownToggle = function () {
	    _this3.setState(function (prevState) {
	      return {
	        isDropdownOpen: !prevState.isDropdownOpen
	      };
	    });
	  };
	
	  this.handleRadioChange = function (e) {
	    _this3.setState({ selectedMode: e.target.value });
	  };
	};
	
	exports.default = QuestionModeSetting;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _toast = __webpack_require__(15);
	
	var _messages = __webpack_require__(14);
	
	var _apiEndPoints = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailResubscribe = function (_Component) {
	  _inherits(EmailResubscribe, _Component);
	
	  function EmailResubscribe() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailResubscribe);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailResubscribe.__proto__ || Object.getPrototypeOf(EmailResubscribe)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isUserSubscribed: true
	    }, _this.handleResubscribe = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _ref3, isUserSubscribed, message;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _fetchData2.default.callAPI(_apiEndPoints.API_ENDPOINT.RESUBSCRIBE_SENDGRID);
	
	            case 2:
	              _ref3 = _context.sent;
	              isUserSubscribed = _ref3.isUserSubscribed;
	              message = _ref3.message;
	
	              _this.setState({ isUserSubscribed: isUserSubscribed }, function () {
	                isUserSubscribed ? (0, _toast.showSuccess)(message) : (0, _toast.showFailure)(message);
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailResubscribe, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _ref5, isUserSubscribed;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _getDataService2.default.callAPI(_apiEndPoints.API_ENDPOINT.GET_SENDGRID_STATUS);
	
	              case 2:
	                _ref5 = _context2.sent;
	                isUserSubscribed = _ref5.isUserSubscribed;
	
	                this.setState({ isUserSubscribed: isUserSubscribed });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var isUserSubscribed = this.state.isUserSubscribed;
	
	
	      return !isUserSubscribed && _react2.default.createElement(
	        'div',
	        { className: 'email-resubscribe-link text-right' },
	        _react2.default.createElement(
	          'span',
	          { className: 'font-xs font-lusitana' },
	          '\uD83D\uDCE2 ',
	          _messages.messages.EMAIL_UNSUBSCRIBED,
	          _react2.default.createElement(
	            'b',
	            {
	              className: 'text-primary cursor-pointer',
	              onClick: this.handleResubscribe
	            },
	            _messages.messages.CLICK_TO_RESUBSCRIBE
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailResubscribe;
	}(_react.Component);
	
	exports.default = EmailResubscribe;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTFinishTest = function (_Component) {
	  _inherits(CBTFinishTest, _Component);
	
	  function CBTFinishTest(props) {
	    _classCallCheck(this, CBTFinishTest);
	
	    var _this = _possibleConstructorReturn(this, (CBTFinishTest.__proto__ || Object.getPrototypeOf(CBTFinishTest)).call(this, props));
	
	    _this.pdfAlertModel = function (e) {
	      e.preventDefault();
	      _this.props.pdfAlertModel(e);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CBTFinishTest, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleClose = _props.handleClose,
	          showFinishTestPopup = _props.showFinishTestPopup,
	          submitTest = _props.submitTest;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: showFinishTestPopup,
	          toggle: handleClose,
	          className: 'modal-primary custom_modalpro info-modal-designing' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: handleClose, className: 'custom-title' },
	          _react2.default.createElement('i', { className: 'fa fa-info-circle', 'aria-hidden': 'true' }),
	          ' ',
	          _language2.default.LC().Finish_Test
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            _react2.default.createElement('img', {
	              className: 'mb-2',
	              width: '70',
	              src: _App_data2.default.frontend_url + '/img/questions/icon_question.png',
	              alt: 'Question'
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'model-big-text' },
	              _language2.default.LC().ARE_YOU_SURE_FINISH
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary m-lr-10', onClick: submitTest },
	                _language2.default.LC().SUBMIT
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary  m-lr-10',
	                  onClick: handleClose
	                },
	                _language2.default.LC().CANCEL
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CBTFinishTest;
	}(_react.Component);
	
	exports.default = CBTFinishTest;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTFlagged = function (_Component) {
	  _inherits(CBTFlagged, _Component);
	
	  function CBTFlagged(props) {
	    _classCallCheck(this, CBTFlagged);
	
	    var _this = _possibleConstructorReturn(this, (CBTFlagged.__proto__ || Object.getPrototypeOf(CBTFlagged)).call(this, props));
	
	    _this.pdfAlertModel = function (e) {
	      e.preventDefault();
	      _this.props.pdfAlertModel(e);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CBTFlagged, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleClose = _props.handleClose,
	          showFinishTestPopup = _props.showFinishTestPopup,
	          submitTest = _props.submitTest;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: showFinishTestPopup,
	          toggle: handleClose,
	          className: 'modal-primary custom_modalpro info-modal-designing' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: handleClose, className: 'custom-title' },
	          _react2.default.createElement('i', { className: 'fa fa-info-circle', 'aria-hidden': 'true' }),
	          ' ',
	          _language2.default.LC().Finish_Test
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            _react2.default.createElement('img', {
	              className: 'mb-2',
	              width: '70',
	              src: _App_data2.default.frontend_url + '/img/questions/icon_flag.png',
	              alt: 'Question'
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'model-big-text' },
	              _language2.default.LC().FLAG_POPUP_TEXT
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary m-lr-10', onClick: submitTest },
	                _language2.default.LC().SUBMIT
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary  m-lr-10',
	                  onClick: handleClose
	                },
	                _language2.default.LC().CANCEL
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CBTFlagged;
	}(_react.Component);
	
	exports.default = CBTFlagged;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTNonAttempted = function (_Component) {
	  _inherits(CBTNonAttempted, _Component);
	
	  function CBTNonAttempted(props) {
	    _classCallCheck(this, CBTNonAttempted);
	
	    var _this = _possibleConstructorReturn(this, (CBTNonAttempted.__proto__ || Object.getPrototypeOf(CBTNonAttempted)).call(this, props));
	
	    _this.pdfAlertModel = function (e) {
	      e.preventDefault();
	      _this.props.pdfAlertModel(e);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CBTNonAttempted, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleClose = _props.handleClose,
	          showFinishTestPopup = _props.showFinishTestPopup,
	          submitTest = _props.submitTest;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: showFinishTestPopup,
	          toggle: handleClose,
	          className: 'modal-primary custom_modalpro info-modal-designing' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: handleClose, className: 'custom-title' },
	          _react2.default.createElement('i', { className: 'fa fa-info-circle', 'aria-hidden': 'true' }),
	          ' ',
	          _language2.default.LC().Finish_Test
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            _react2.default.createElement('img', {
	              className: 'mb-2',
	              width: '70',
	              src: _App_data2.default.frontend_url + '/img/questions/icon_triangle.png',
	              alt: 'Question'
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'model-big-text' },
	              _language2.default.LC().NOT_ATTEMPTED_POPUP
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'model-big-text' },
	              _language2.default.LC().ARE_YOU_SURE_FINISH
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary m-lr-10', onClick: submitTest },
	                _language2.default.LC().SUBMIT
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary  m-lr-10',
	                  onClick: handleClose
	                },
	                'Cancel'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CBTNonAttempted;
	}(_react.Component);
	
	exports.default = CBTNonAttempted;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(285);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/question_icon_blue.81d3e251.svg";

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var CallbackQueue = __webpack_require__(442);
	var PooledClass = __webpack_require__(99);
	var ReactFeatureFlags = __webpack_require__(447);
	var ReactReconciler = __webpack_require__(111);
	var Transaction = __webpack_require__(156);
	
	var invariant = __webpack_require__(20);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoValidateReportIcons = function (_Component) {
	  _inherits(VideoValidateReportIcons, _Component);
	
	  function VideoValidateReportIcons(props) {
	    _classCallCheck(this, VideoValidateReportIcons);
	
	    var _this = _possibleConstructorReturn(this, (VideoValidateReportIcons.__proto__ || Object.getPrototypeOf(VideoValidateReportIcons)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(VideoValidateReportIcons, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          moveToNotes = _props.moveToNotes,
	          notesCSS = _props.notesCSS,
	          moveToPracticeQuestions = _props.moveToPracticeQuestions,
	          _saveFavVideo = _props._saveFavVideo,
	          _displayReportForm = _props._displayReportForm,
	          viewPdf = _props.viewPdf,
	          showFreePremium = _props.showFreePremium,
	          bookmarkCSS = _props.bookmarkCSS,
	          bookmarkColor = _props.bookmarkColor,
	          type = _props.type,
	          questionsCSS = _props.questionsCSS,
	          saveVideo_text = _props.saveVideo_text,
	          currentReading = _props.currentReading,
	          chapters = _props.chapters,
	          video = _props.video,
	          noPDFInExam = _props.noPDFInExam,
	          _props$reportVideoToo = _props.reportVideoTooltip,
	          reportVideoTooltip = _props$reportVideoToo === undefined ? '' : _props$reportVideoToo,
	          _props$pdfFile = _props.pdfFile,
	          pdfFile = _props$pdfFile === undefined ? '' : _props$pdfFile;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'd-inline-flex align-items-center' },
	            type === 'intro' || chapters && chapters[0].chapter_id === 11 || chapters && chapters[0].chapter_id === 12 || !notesCSS ? null : _react2.default.createElement(
	              'span',
	              {
	                className: 'up tooltip-hover-questions',
	                style: { padding: '10px' }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tootip_box' },
	                ' ',
	                _language2.default.LC().GO_TO_NOTES,
	                ' '
	              ),
	              _react2.default.createElement(
	                'i',
	                {
	                  onClick: moveToNotes ? moveToNotes.bind('123') : null,
	                  className: notesCSS,
	                  style: { color: '#1f8ceb' }
	                },
	                ' '
	              )
	            ),
	            ' ',
	            type === 'intro' || chapters && chapters[0].chapter_id === 11 || chapters && chapters[0].chapter_id === 12 ? null : _react2.default.createElement(
	              'span',
	              {
	                className: 'up tooltip-hover-questions',
	                style: { padding: '10px' }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tootip_box' },
	                ' ',
	                _language2.default.LC().GO_TO_QUESTION_BANK,
	                ' '
	              ),
	              _react2.default.createElement(
	                'i',
	                {
	                  onClick: moveToPracticeQuestions.bind('123'),
	                  className: questionsCSS,
	                  style: { color: '#1d364b' }
	                },
	                ' '
	              )
	            ),
	            type === 'intro' ? null : _react2.default.createElement(
	              'span',
	              {
	                className: 'up tooltip-hover-questions',
	                style: { padding: '10px' }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tootip_box' },
	                ' ',
	                saveVideo_text,
	                ' '
	              ),
	              _react2.default.createElement(
	                'i',
	                {
	                  onClick: _saveFavVideo.bind(this, currentReading),
	                  className: bookmarkCSS,
	                  style: { color: bookmarkColor }
	                },
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'up tooltip-hover-questions vertical-align-middle',
	                style: { padding: '10px' }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tootip_box' },
	                ' ',
	                console.log('checking the tooltip text', reportVideoTooltip
	
	                // ,'===>',
	                // language.LC().REPORT_THIS_QUESTION
	                ),
	                reportVideoTooltip ? reportVideoTooltip : _language2.default.LC().REPORT_THIS_QUESTION,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'report-icon-wrapper',
	                  onClick: _displayReportForm.bind()
	                },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/report4.png',
	                  alt: 'report'
	                })
	              )
	            )
	          ),
	          noPDFInExam ? null : _react2.default.createElement(
	            'div',
	            { onClick: function onClick() {
	                return viewPdf(pdfFile || video.pdf_file);
	              }, className: 'status-download-btn' },
	            _react2.default.createElement(
	              'a',
	              { className: 'btn btn-primary  pointer_class pull-right' },
	              _react2.default.createElement('i', { className: 'fa fa-download  ', 'aria-hidden': 'true' }),
	              showFreePremium ? _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                _language2.default.LC().PREMIUM
	              ) : null,
	              _language2.default.LC().Download_PDF
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VideoValidateReportIcons;
	}(_react.Component);
	
	exports.default = VideoValidateReportIcons;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(props) {
	  var title = props.title,
	      children = props.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'margin_bottom_20 d-flex justify-content-between' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'section_head' },
	      title
	    ),
	    children
	  );
	}
	
	exports.default = Header;

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	
	var checkEASubscription = function checkEASubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log('2');
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          if (exam_data[i].levels[j].isActive) {
	            // console.log('5');
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	            break;
	          }
	          //  else if (
	          //   exam_data[i].levels[j].isActive &&
	          //   exam_data[i].levels[j].package_id === 35
	          // ) {
	          //   flag = true;
	          //   break;
	          // }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkEAVideosSubscription = function checkEAVideosSubscription(selectedLevel, exam_data) {
	  console.log('I am here --------__> ', selectedLevel);
	  console.log(exam_data, '<_-------------------------message 55');
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkEAQuestionSubscription = function checkEAQuestionSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	var checkEAQuizSubscription = function checkEAQuizSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_id === 51) {
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 52) {
	            flag = true;
	          }
	          if (exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	          }
	        }
	      }
	      // break;
	    }
	  }
	
	  return flag;
	};
	exports.checkEAQuizSubscription = checkEAQuizSubscription;
	exports.checkEASubscription = checkEASubscription;
	exports.checkEAQuestionSubscription = checkEAQuestionSubscription;
	exports.checkEAVideosSubscription = checkEAVideosSubscription;

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	
	var checkGMATSubscription = function checkGMATSubscription(selectedLevel, exam_data) {
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      // console.log('2');
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          if (exam_data[i].levels[j].isActive) {
	            // console.log('5');
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	          //  else if (
	          //   exam_data[i].levels[j].isActive &&
	          //   exam_data[i].levels[j].package_id === 35
	          // ) {
	          //   flag = true;
	          //   break;
	          // }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkGMATVideosSubscription = function checkGMATVideosSubscription(selectedLevel, exam_data) {
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkGMATQuestionSubscription = function checkGMATQuestionSubscription(selectedLevel, exam_data) {
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	// this function check subscription only for quize
	var checkGMATQuizSubscription = function checkGMATQuizSubscription(selectedLevel, exam_data) {
	  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // check subscription for partner users
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	          // inside if block subscription check for partner users.
	          if (exam_data[i].levels[j].package_id === 43) {
	            // SIMPLE package
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 44 || exam_data[i].levels[j].package_id === 57) {
	            // EXPENSIVE package
	            flag = true;
	          }
	
	          if (exam_data[i].levels[j].package_id === 45) {
	            // LIFE-TIME package
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      break;
	      // }
	    }
	  }
	  return flag;
	};
	
	exports.checkGMATSubscription = checkGMATSubscription;
	exports.checkGMATQuestionSubscription = checkGMATQuestionSubscription;
	exports.checkGMATVideosSubscription = checkGMATVideosSubscription;
	exports.checkGMATQuizSubscription = checkGMATQuizSubscription;

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	
	var checkGMATSubscription = function checkGMATSubscription(selectedLevel, exam_data) {
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log('2');
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          if (exam_data[i].levels[j].isActive) {
	            // console.log('5');
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	          //  else if (
	          //   exam_data[i].levels[j].isActive &&
	          //   exam_data[i].levels[j].package_id === 35
	          // ) {
	          //   flag = true;
	          //   break;
	          // }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkGMATVideosSubscription = function checkGMATVideosSubscription(selectedLevel, exam_data) {
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkGMATQuestionSubscription = function checkGMATQuestionSubscription(selectedLevel, exam_data) {
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	// this function check subscription only for quize
	var checkGMATQuizSubscription = function checkGMATQuizSubscription(selectedLevel, exam_data) {
	  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
	  console.log({ selectedLevel: selectedLevel, exam_data: exam_data });
	
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // check subscription for partner users
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	          // inside if block subscription check for partner users.
	          if (exam_data[i].levels[j].package_id === 43) {
	            // SIMPLE package
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 44 || exam_data[i].levels[j].package_id === 57) {
	            // EXPENSIVE package
	            flag = true;
	          }
	
	          if (exam_data[i].levels[j].package_id === 45) {
	            // LIFE-TIME package
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      break;
	      // }
	    }
	  }
	  return flag;
	};
	
	exports.checkGMATSubscription = checkGMATSubscription;
	exports.checkGMATQuestionSubscription = checkGMATQuestionSubscription;
	exports.checkGMATVideosSubscription = checkGMATVideosSubscription;
	exports.checkGMATQuizSubscription = checkGMATQuizSubscription;

/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	
	var checkGMATSubscription = function checkGMATSubscription(selectedLevel, exam_data) {
	  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	    //   // console.log('2');
	    //   if (exam_data[i].levels.length) {
	    //     // console.log('3');
	    //     for (var j = 0; j < exam_data[i].levels.length; j++) {
	    //       // console.log('4');
	    //       if (exam_data[i].levels[j].partner) {
	    //         /*
	    //         ------------------
	    //           Partner User's
	    //         ------------------
	    //         */
	    //         // inside if block subscription check for partner users.
	    //         if (exam_data[i].levels[j].isActive) {
	    //           flag = true;
	    //           break;
	    //         }
	    //       } else {
	    //         /*
	    //         ---------------
	    //           App User's
	    //         ---------------
	    //         */
	    //         // inside else block check for partner user app subsciption plans
	    //         if (exam_data[i].levels[j].isActive) {
	    //           flag = true;
	    //           break;
	    //         }
	    //       }
	    //     }
	    //   } else {
	    //     // console.log("6");
	    //     flag = true;
	    //   }
	    //   break;
	    // }
	    // check subscription for partner users
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	          // inside if block subscription check for partner users.
	          if (exam_data[i].levels[j].package_id === 43) {
	            // SIMPLE package
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 44 || exam_data[i].levels[j].package_id === 57) {
	            // EXPENSIVE package
	            flag = true;
	          }
	
	          if (exam_data[i].levels[j].package_id === 45) {
	            // LIFE-TIME package
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      break;
	      // }
	    }
	  }
	  return flag;
	};
	
	var checkGMATVideosSubscription = function checkGMATVideosSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkGMATQuestionSubscription = function checkGMATQuestionSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	// this function check subscription only for quize
	var checkGMATQuizSubscription = function checkGMATQuizSubscription(selectedLevel, exam_data) {
	  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // check subscription for partner users
	    if (selectedLevel.startsWith(exam_data[i].exam_name)) {
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	          // inside if block subscription check for partner users.
	          if (exam_data[i].levels[j].package_id === 43) {
	            // SIMPLE package
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 44) {
	            // EXPENSIVE package
	            flag = true;
	          }
	
	          if (exam_data[i].levels[j].package_id === 45) {
	            // LIFE-TIME package
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      break;
	      // }
	    }
	  }
	  return flag;
	};
	
	exports.checkGMATSubscription = checkGMATSubscription;
	exports.checkGMATQuestionSubscription = checkGMATQuestionSubscription;
	exports.checkGMATVideosSubscription = checkGMATVideosSubscription;
	exports.checkGMATQuizSubscription = checkGMATQuizSubscription;

/***/ },
/* 78 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	
	var checkGMATSubscription = function checkGMATSubscription(selectedLevel, exam_data) {
	  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // if (exam_data[i].exam_name === selectedLevel) {
	    //   // console.log('2');
	    //   if (exam_data[i].levels.length) {
	    //     // console.log('3');
	    //     for (var j = 0; j < exam_data[i].levels.length; j++) {
	    //       // console.log('4');
	    //       if (exam_data[i].levels[j].partner) {
	    //         /*
	    //         ------------------
	    //           Partner User's
	    //         ------------------
	    //         */
	    //         // inside if block subscription check for partner users.
	    //         if (exam_data[i].levels[j].isActive) {
	    //           flag = true;
	    //           break;
	    //         }
	    //       } else {
	    //         /*
	    //         ---------------
	    //           App User's
	    //         ---------------
	    //         */
	    //         // inside else block check for partner user app subsciption plans
	    //         if (exam_data[i].levels[j].isActive) {
	    //           flag = true;
	    //           break;
	    //         }
	    //       }
	    //     }
	    //   } else {
	    //     // console.log("6");
	    //     flag = true;
	    //   }
	    //   break;
	    // }
	    // check subscription for partner users
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	          // inside if block subscription check for partner users.
	          if (exam_data[i].levels[j].package_id === 43) {
	            // SIMPLE package
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 44 || exam_data[i].levels[j].package_id === 57) {
	            // EXPENSIVE package
	            flag = true;
	          }
	
	          if (exam_data[i].levels[j].package_id === 45) {
	            // LIFE-TIME package
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      break;
	      // }
	    }
	  }
	  return flag;
	};
	
	var checkGMATVideosSubscription = function checkGMATVideosSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkGMATQuestionSubscription = function checkGMATQuestionSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 45) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	// this function check subscription only for quize
	var checkGMATQuizSubscription = function checkGMATQuizSubscription(selectedLevel, exam_data) {
	  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // check subscription for partner users
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	          // inside if block subscription check for partner users.
	          if (exam_data[i].levels[j].package_id === 43) {
	            // SIMPLE package
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 44) {
	            // EXPENSIVE package
	            flag = true;
	          }
	
	          if (exam_data[i].levels[j].package_id === 45) {
	            // LIFE-TIME package
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      break;
	      // }
	    }
	  }
	  return flag;
	};
	
	exports.checkGMATSubscription = checkGMATSubscription;
	exports.checkGMATQuestionSubscription = checkGMATQuestionSubscription;
	exports.checkGMATVideosSubscription = checkGMATVideosSubscription;
	exports.checkGMATQuizSubscription = checkGMATQuizSubscription;

/***/ },
/* 79 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 80 */
79,
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var PooledClass = __webpack_require__(99);
	
	var emptyFunction = __webpack_require__(57);
	var warning = __webpack_require__(27);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportComponent = function (_React$Component) {
	  _inherits(ReportComponent, _React$Component);
	
	  function ReportComponent() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReportComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportComponent.__proto__ || Object.getPrototypeOf(ReportComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      reportLoading: false,
	      successAlert: false,
	      comment: '',
	      internalVisible: _this.props.visible || false // manage visibility internally
	    }, _this.reportQuestionAPI = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(payload) {
	        var apiServices, response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                apiServices = _this.props.apiServices;
	                _context.next = 3;
	                return apiServices.saveReport(payload);
	
	              case 3:
	                response = _context.sent;
	
	                if (!(response && response.success)) {
	                  _context.next = 8;
	                  break;
	                }
	
	                return _context.abrupt('return', { success: true });
	
	              case 8:
	                throw new Error(_messages.messages.REPORT_SUBMISSION_FAILED);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }(), _this.handleCancel = function () {
	      _this.setState({
	        successAlert: false,
	        comment: '',
	        internalVisible: false
	      });
	    }, _this.handleCommentChange = function (e) {
	      _this.setState({ comment: e.target.value });
	    }, _this.handleReportSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var payload, comment, fullPayload, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              payload = _this.props.payload;
	              comment = _this.state.comment;
	
	              if (comment.trim()) {
	                _context2.next = 4;
	                break;
	              }
	
	              return _context2.abrupt('return');
	
	            case 4:
	              if (!(!payload || !payload.question_id)) {
	                _context2.next = 7;
	                break;
	              }
	
	              console.warn('[ReportComponent] aborting submit — payload missing question_id', payload);
	              return _context2.abrupt('return');
	
	            case 7:
	
	              _this.setState({ reportLoading: true });
	
	              fullPayload = Object.assign({}, payload, { comment: comment });
	              _context2.prev = 9;
	              _context2.next = 12;
	              return _this.reportQuestionAPI(fullPayload);
	
	            case 12:
	              response = _context2.sent;
	
	              if (response.success) {
	                _this.setState({ successAlert: true });
	              }
	              _context2.next = 19;
	              break;
	
	            case 16:
	              _context2.prev = 16;
	              _context2.t0 = _context2['catch'](9);
	
	              console.error('Submission failed:', _context2.t0);
	
	            case 19:
	              _context2.prev = 19;
	
	              _this.setState({ reportLoading: false });
	              return _context2.finish(19);
	
	            case 22:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[9, 16, 19, 22]]);
	    })), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // Simulated API call
	
	
	  _createClass(ReportComponent, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.visible !== this.props.visible) {
	        this.setState({ internalVisible: this.props.visible });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          internalVisible = _state.internalVisible,
	          successAlert = _state.successAlert,
	          comment = _state.comment,
	          reportLoading = _state.reportLoading;
	
	
	      if (!internalVisible) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card show_block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header' },
	          'Report'
	        ),
	        !successAlert ? _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Comment'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 margin_bottom_10' },
	              _react2.default.createElement('textarea', {
	                rows: '6',
	                className: 'form-control',
	                placeholder: 'Write comment...',
	                value: comment,
	                onChange: this.handleCommentChange
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary active pointer_class report-btn',
	                  disabled: reportLoading,
	                  onClick: this.handleReportSubmit
	                },
	                reportLoading ? 'Please wait...' : 'Report'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-danger active pointer_class margin_left_1',
	                  onClick: this.handleCancel
	                },
	                'Cancel'
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 text-center' },
	              _react2.default.createElement('img', { src: '/img/success-ic.svg', alt: 'success' }),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _messages.messages.REPORT_SEND_SUCCESS_MESSAGE
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary', onClick: this.handleCancel },
	                'Close'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportComponent;
	}(_react2.default.Component);
	
	exports.default = ReportComponent;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTMockExamsInsructions = function (_Component) {
	  _inherits(CBTMockExamsInsructions, _Component);
	
	  function CBTMockExamsInsructions(props) {
	    _classCallCheck(this, CBTMockExamsInsructions);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExamsInsructions.__proto__ || Object.getPrototypeOf(CBTMockExamsInsructions)).call(this, props));
	
	    _this.pdfAlertModel = function (e) {
	      e.preventDefault();
	      _this.props.pdfAlertModel(e);
	    };
	
	    _this.start = function () {
	      var instruct = _this.state.instruct;
	
	      if (instruct) {
	        _this.setState({
	          content: ''
	        });
	        _this.setState({
	          instruct: false
	        });
	        _this.props.getQuestions();
	      } else {
	        _this.setState({
	          content: 'You have not accepted the terms. You must accept the terms before you can take the test.'
	        });
	      }
	    };
	
	    _this.changeValue = function (e) {
	      var target = e.target;
	      var checked = target.checked;
	
	      if (checked) {
	        _this.setState({
	          instruct: true
	        });
	      } else {
	        _this.setState({
	          instruct: false
	        });
	      }
	    };
	
	    _this.close = function () {
	      _this.setState({
	        instruct: false
	      });
	      _this.props.handleClose();
	    };
	
	    _this.state = {
	      instruct: false,
	      content: ''
	    };
	    return _this;
	  }
	
	  _createClass(CBTMockExamsInsructions, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selectedMenu = localStorage.getItem('selectedmenu');
	      var showInstructionModal = this.props.showInstructionModal;
	      var _state = this.state,
	          instruct = _state.instruct,
	          content = _state.content;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: showInstructionModal,
	          toggle: function toggle() {
	            return _this2.close();
	          },
	          className: 'modal-primary custom_modalpro info-modal-designing' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: function toggle() {
	              return _this2.close();
	            }, className: 'custom-title' },
	          _react2.default.createElement('i', { className: 'fa fa-info-circle', 'aria-hidden': 'true' }),
	          ' ',
	          _language2.default.LC().INSTRUCTIONS
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            selectedMenu === 'cfa' ? (0, _function.renderHTMLContent)(_language2.default.LC().CBT_MOCK_INSTRUCTIONS, "div") : (0, _function.renderHTMLContent)(_language2.default.LC().CBT_MOCK_INSTRUCTIONS_FRM, "div"),
	            _react2.default.createElement(
	              'div',
	              { className: 'plan_wrapper remove-plan mt-1' },
	              _react2.default.createElement(
	                'label',
	                { className: 'check_container' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  value: 'on',
	                  checked: instruct ? true : false,
	                  onChange: function onChange(e) {
	                    return _this2.changeValue(e);
	                  }
	                }),
	                _react2.default.createElement('span', { className: 'checkmark' }),
	                _language2.default.LC().I_ACCEPT_THE_TERMS
	              ),
	              content ? _react2.default.createElement(
	                'div',
	                { className: 'error-sms' },
	                content
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary margin_right_20',
	                  onClick: function onClick() {
	                    return _this2.close();
	                  }
	                },
	                ' ',
	                _language2.default.LC().GO_TO_ANSWER,
	                ' '
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: function onClick() {
	                    return _this2.start();
	                  } },
	                ' ',
	                _language2.default.LC().START,
	                ' '
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CBTMockExamsInsructions;
	}(_react.Component);
	
	exports.default = CBTMockExamsInsructions;

/***/ },
/* 85 */
25,
/* 86 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	
	var checkEASubscription = function checkEASubscription(selectedLevel, exam_data) {
	  // console.log('Inside checkEASubscription partnerrrrr');
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log('2');
	      if (exam_data[i].levels.length) {
	        // console.log('3');
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log('4');
	          if (exam_data[i].levels[j].partner) {
	            /*
	              ------------------
	                Partner User's
	              ------------------
	              */
	            // inside if block subscription check for partner users.
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	              ---------------
	                App User's
	              ---------------
	              */
	            // inside else block check for partner user app subsciption plans
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      break;
	    }
	  }
	  return flag;
	};
	
	var checkEAVideosSubscription = function checkEAVideosSubscription(selectedLevel, exam_data) {
	  console.log('I am here --------__> ', selectedLevel);
	  console.log(exam_data, '<_-------------------------message 55');
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkEAQuestionSubscription = function checkEAQuestionSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	var checkEAQuizSubscription = function checkEAQuizSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_id === 51) {
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 52) {
	            flag = true;
	          }
	          if (exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      // break;
	    } else {
	      flag = false;
	    }
	  }
	
	  return flag;
	};
	
	exports.checkEAQuizSubscription = checkEAQuizSubscription;
	exports.checkEASubscription = checkEASubscription;
	exports.checkEAQuestionSubscription = checkEAQuestionSubscription;
	exports.checkEAVideosSubscription = checkEAVideosSubscription;

/***/ },
/* 87 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	var checkSoaPSubscription = function checkSoaPSubscription(selectedLevel, exam_data) {
	  var flag = false;
	
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log("4");
	          if (exam_data[i].levels[j].isActive) {
	            // console.log("5");
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	var checkSoaPNotesSubscription = function checkSoaPNotesSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35 && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	var checkSoaP_PDFSubscription = function checkSoaP_PDFSubscription(selectedLevel, exam_data, type) {
	  //console.log("selectedLevel", selectedLevel);
	  //console.log("exam_data", exam_data);
	  //console.log("type", type);
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            pdfFlag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	            if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	              pdfFlag = true;
	            } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	              pdfFlag = true;
	            }
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	            pdfFlag = true;
	            // break;
	          }
	        }
	      } else {
	        // console.log("6");
	        pdfFlag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            pdfFlag = true;
	            // break;
	          } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	            if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	              pdfFlag = true;
	            } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	              pdfFlag = true;
	            }
	
	            // break;
	          }
	        }
	      }
	    }
	  }
	
	  return pdfFlag;
	};
	
	var checkSoaPVideosSubscription = function checkSoaPVideosSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	          //  else if (
	          //   exam_data[i].levels[j].package_val === 'simple' &&
	          //   exam_data[i].levels[j].isActive &&
	          //   exam_data[i].levels[j].videoStatus !== false
	          // ) {
	          //   flag = true;
	          //   // break;/
	          // }
	          else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              // break;
	            }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	exports.checkSoaPSubscription = checkSoaPSubscription;
	exports.checkSoaPNotesSubscription = checkSoaPNotesSubscription;
	exports.checkSoaP_PDFSubscription = checkSoaP_PDFSubscription;
	exports.checkSoaPVideosSubscription = checkSoaPVideosSubscription;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1087);


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _TagManager = __webpack_require__(1140);
	
	var _TagManager2 = _interopRequireDefault(_TagManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _TagManager2.default;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReportCard = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportCard = exports.ReportCard = function (_Component) {
	  _inherits(ReportCard, _Component);
	
	  function ReportCard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ReportCard);
	
	    var _this = _possibleConstructorReturn(this, (ReportCard.__proto__ || Object.getPrototypeOf(ReportCard)).call(this, props));
	
	    _this.report = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _data;
	
	      var comment, _this$props, itemId, _this$props$keyId, keyId, _this$props$section, section, mockData, apiServiceProvider, _this$props$level, level, data, apiService, response;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              comment = _this.state.comment;
	              _this$props = _this.props, itemId = _this$props.itemId, _this$props$keyId = _this$props.keyId, keyId = _this$props$keyId === undefined ? '' : _this$props$keyId, _this$props$section = _this$props.section, section = _this$props$section === undefined ? '' : _this$props$section, mockData = _this$props.mockData, apiServiceProvider = _this$props.apiServiceProvider, _this$props$level = _this$props.level, level = _this$props$level === undefined ? '' : _this$props$level;
	
	              _this.setState({ reportLoading: true });
	              data = (_data = {}, _defineProperty(_data, keyId, itemId), _defineProperty(_data, 'comment', comment), _defineProperty(_data, 'mockData', mockData), _defineProperty(_data, 'level', level), _data);
	              apiService = apiServiceProvider['reportQuestion'];
	              _context.t0 = section.toLowerCase();
	              _context.next = _context.t0 === 'cbt' ? 8 : _context.t0 === 'video' ? 10 : 12;
	              break;
	
	            case 8:
	              apiService = apiServiceProvider['reportCBTQuestion'];
	              return _context.abrupt('break', 14);
	
	            case 10:
	              apiService = apiServiceProvider['mutateReportVideo'];
	              return _context.abrupt('break', 14);
	
	            case 12:
	              apiService = apiServiceProvider['reportQuestion'];
	              return _context.abrupt('break', 14);
	
	            case 14:
	              _context.next = 16;
	              return apiService(data);
	
	            case 16:
	              response = _context.sent;
	
	              if (response.success) {
	                _this.setState({ successAlert: true, comment: '' });
	              }
	              _this.setState({ reportLoading: false });
	
	            case 19:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      reportLoading: false,
	      successAlert: false,
	      comment: ''
	    };
	    return _this;
	  }
	
	  _createClass(ReportCard, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          comment = _state.comment;
	      var hideReportSection = this.props.hideReportSection;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _messages.messages.REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _messages.messages.COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    onChange: function onChange(event) {
	                      return _this3.setState(_defineProperty({}, event.target.name, event.target.value));
	                    },
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    value: comment,
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this.report
	                    },
	                    reportLoading ? _messages.messages.PLEASE_WAIT : _messages.messages.REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: hideReportSection
	                    },
	                    _messages.messages.CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _messages.messages.REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: hideReportSection
	                    },
	                    ' ',
	                    _messages.messages.CLOSE
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportCard;
	}(_react.Component);
	
	exports.default = ReportCard;

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAiTutorAvailable = isAiTutorAvailable;
	exports.isAiTutorKillSwitchedOff = isAiTutorKillSwitchedOff;
	exports.setAiTutorOffState = setAiTutorOffState;
	exports.refreshAiTutorAvailability = refreshAiTutorAvailability;
	exports.refreshAiTutorAvailabilityPublic = refreshAiTutorAvailabilityPublic;
	exports.aiTutorGlobalContext = aiTutorGlobalContext;
	exports.clearAiTutorContext = clearAiTutorContext;
	exports.aiTutorExamYear = aiTutorExamYear;
	exports.aiTutorPageUrl = aiTutorPageUrl;
	exports.dispatchAiTutorContext = dispatchAiTutorContext;
	exports.dispatchAiTutorExplain = dispatchAiTutorExplain;
	exports.aiTutorStem = aiTutorStem;
	// Shared helpers for AI Tutor page-context (question / note / video views).
	// The tutor widget (components/AITutorChat) consumes:
	//   window.__aiTutorContext + 'aitutor:context'  — which page the student is viewing
	//   'aitutor:explain'                            — open the chat and submit a prompt
	// Context shape (snake_case — the tutor backend accepts these keys):
	//   { exam, exam_year, page_type, content_id, title, stem, page_url }
	
	// Shared style for the per-page ✦ AI trigger buttons ("Explain my answer",
	// "Ask AI about this note/lecture") — violet gradient treatment "B" (design 2026-07-08),
	// matching the header + sidebar launchers. Applied via CustomButton's `style` prop with a
	// neutral `btnColor` so the LMS blue `.btn-primary` never paints over it.
	var AI_TRIGGER_BTN_STYLE = exports.AI_TRIGGER_BTN_STYLE = {
	  display: 'inline-flex',
	  alignItems: 'center',
	  gap: 7,
	  padding: '11.5px 17px',
	  border: 'none',
	  borderRadius: 10,
	  color: '#fff',
	  font: "700 13.5px 'Plus Jakarta Sans', system-ui, sans-serif",
	  fontWeight: 900,
	  background: 'linear-gradient(135deg,#6d4bff,#4a2fe0)',
	  boxShadow: '0 4px 14px rgba(74,47,224,.4)',
	  whiteSpace: 'nowrap'
	};
	
	// V1 scope gate: the tutor is CFA LEVEL 1 only (KB + entitlement are CFA-scoped).
	// L1 family exam names: 'cfa', 'cfa_2022' … 'cfa_2027' (L2/L3 are 'cfa_2_*' / 'cfa_3*').
	function isAiTutorAvailable() {
	  try {
	    if (aiTutorCachedOff()) return false; // admin kill-switch — hide launchers on mount
	    var sel = localStorage.getItem('selectedmenu') || '';
	    return (/^cfa(_\d{4})?$/.test(sel)
	    );
	  } catch (e) {
	    return false;
	  }
	}
	
	// ── Admin kill-switch visibility (task A.2, design 2026-07-15) ────────────────────────
	// The tutor can be disabled globally/per-course from the admin panel. The server enforces
	// immediately (chat rejects ≤30s after a flip); this cache only removes dangling UI:
	//   • isAiTutorAvailable() → false ⇒ route-mounted page buttons don't render;
	//   • body class + the CSS below ⇒ once-mounted Header/Sidebar (and already-rendered page
	//     buttons) hide live without a re-render.
	// Key is per-exam (V2-ready). Synchronous localStorage read at module load = no flicker on
	// repeat loads. Everything fails open: on any error the buttons stay visible.
	var AI_TUTOR_OFF_KEY = 'apAiTutorOff:cfa1'; // V1 is CFA1-only, same as the launcher gate
	var AI_TUTOR_OFF_CLASS = 'ap-ai-tutor-off';
	var AI_TUTOR_PROBE_TS_KEY = 'apAiTutorProbeTs:cfa1'; // last /tutor/health probe (epoch ms)
	var AI_TUTOR_PROBE_TTL = 60000; // re-probe at most once/min across page navigations
	
	function aiTutorCachedOff() {
	  try {
	    return localStorage.getItem(AI_TUTOR_OFF_KEY) === '1';
	  } catch (e) {
	    return false;
	  }
	}
	
	// True if the last kill-switch probe is still fresh — lets the widget reuse the cached state
	// instead of hitting /tutor/health on every page load (the complaint: fires per video page).
	function aiTutorProbeFresh() {
	  try {
	    var ts = parseInt(localStorage.getItem(AI_TUTOR_PROBE_TS_KEY) || '0', 10);
	    return ts > 0 && Date.now() - ts < AI_TUTOR_PROBE_TTL;
	  } catch (e) {
	    return false;
	  }
	}
	
	/** Cached kill-switch state — lets the widget itself render nothing when the tutor is off. */
	function isAiTutorKillSwitchedOff() {
	  return aiTutorCachedOff();
	}
	
	// Apply + remember the disabled state (also exported for the widget's own usage fetch).
	function setAiTutorOffState(off) {
	  try {
	    if (off) {
	      localStorage.setItem(AI_TUTOR_OFF_KEY, '1');
	      if (document.body) document.body.classList.add(AI_TUTOR_OFF_CLASS);
	    } else {
	      localStorage.removeItem(AI_TUTOR_OFF_KEY);
	      if (document.body) document.body.classList.remove(AI_TUTOR_OFF_CLASS);
	    }
	  } catch (e) {/* noop */}
	}
	
	// @deprecated 2026-07-24 — NO CALLERS. Used /tutor/usage just to read `enabled`, so it fired a
	// usage request even when disabled. Superseded by refreshAiTutorAvailabilityPublic (/tutor/health).
	function refreshAiTutorAvailability(base, token, examKey) {
	  try {
	    if (!base || !token) return;
	    var exam = String(examKey || 'cfa1').toLowerCase();
	    var url = base + '/tutor/usage?exam=' + encodeURIComponent(exam) + '&_=' + Date.now();
	    fetch(url, { headers: { Authorization: token }, cache: 'no-store' }).then(function (r) {
	      // Only a SUCCESSFUL response carries the kill-switch. On 401/5xx the error body has no
	      // `enabled`, so parsing it would evaluate `undefined === false` → false and CLEAR a real
	      // admin disable on every page load. Bail out and keep whatever state is cached.
	      if (!r.ok) return null;
	      return r.json().then(function (d) {
	        if (d) setAiTutorOffState(d.enabled === false);
	      }, function () {/* fail-open */});
	    }, function () {/* fail-open */});
	  } catch (e) {/* noop */}
	}
	
	// PRIMARY kill-switch probe — needs NO token. `/tutor/health` is public, so this keeps working
	// even when the session/JWT is broken (a 401 on the guarded /tutor/usage must never be mistaken
	// for "enabled"). `cb(off)` lets the widget drop its panel in the same tick.
	// Older backends have no `enabled` field: we only act on a real boolean, so they stay visible.
	function refreshAiTutorAvailabilityPublic(base, examKey, cb) {
	  try {
	    if (!base) return;
	    // Fresh cache (probed < TTL ago) → skip the network, just replay the cached state so the
	    // widget still updates its `killed` flag. Cuts the per-navigation probe on video/note pages.
	    if (aiTutorProbeFresh()) {
	      if (cb) cb(aiTutorCachedOff());return;
	    }
	    var exam = String(examKey || 'cfa1').toLowerCase();
	    var url = base + '/tutor/health?exam=' + encodeURIComponent(exam) + '&_=' + Date.now();
	    fetch(url, { cache: 'no-store' }).then(function (r) {
	      if (!r.ok) return null; // unreachable/5xx → fail-open, keep the cached state
	      return r.json().then(function (d) {
	        if (!d || typeof d.enabled !== 'boolean') return;
	        var off = d.enabled === false;
	        setAiTutorOffState(off);
	        try {
	          localStorage.setItem(AI_TUTOR_PROBE_TS_KEY, String(Date.now()));
	        } catch (e) {/* noop */}
	        if (cb) cb(off);
	      }, function () {/* fail-open */});
	    }, function () {/* fail-open */});
	  } catch (e) {/* noop */}
	}
	
	// Module load: apply the cached state before first paint + inject the launcher-hiding CSS
	// from HERE (not the widget — the rule must exist even when the widget renders null).
	(function initAiTutorOffState() {
	  try {
	    if (aiTutorCachedOff() && document.body) document.body.classList.add(AI_TUTOR_OFF_CLASS);
	    var s = document.createElement('style');
	    s.textContent = '.' + AI_TUTOR_OFF_CLASS + ' .ap-ai-launcher{display:none !important;}';
	    document.head.appendChild(s);
	  } catch (e) {/* noop */}
	})();
	
	// Fallback context for chats opened outside a content page (dashboard, forum, …).
	// `exam` is hardcoded on purpose: isAiTutorAvailable() gates the launcher to the CFA L1
	// family, so by construction the selected exam here IS CFA1. When the tutor expands to
	// other exams (V2+), extend BOTH together: the gate above + a selectedmenu→exam-slug map
	// here (e.g. 'frm' → 'FRM1'), and the backend's exam-family entitlement scoping.
	function aiTutorGlobalContext() {
	  return {
	    exam: 'CFA1',
	    exam_year: aiTutorExamYear(),
	    page_url: aiTutorPageUrl(),
	    page_type: 'global',
	    title: 'CFA Level I'
	  };
	}
	
	// Content pages call this on unmount so a later sidebar-opened chat doesn't
	// inherit a stale page context (e.g. an old question on the dashboard).
	function clearAiTutorContext() {
	  try {
	    window.__aiTutorContext = null;
	  } catch (e) {
	    /* noop */
	  }
	}
	
	// Year of the selected exam from the header switcher ('selectedmenu' in localStorage,
	// e.g. 'cfa_2026' / 'cfa_2027'). Bare names without a year suffix ('cfa') → null.
	function aiTutorExamYear() {
	  try {
	    var sel = localStorage.getItem('selectedmenu') || '';
	    // CFA1 editions: the 2026 exam is historically coded 'cfa_2025' (and bare 'cfa'); 2027 is
	    // 'cfa_2027'. Normalise so exam_year matches the URL year (/cfa1/2026 vs /cfa1/2027) — the tutor
	    // KB is keyed by this value, so it MUST agree with the URL the learner is on.
	    if (sel === 'cfa_2027') return 2027;
	    if (sel === 'cfa' || sel === 'cfa_2025' || sel === 'cfa_2026') return 2026;
	    // Fallback for any other year-suffixed code (future L2/L3): its literal year.
	    var m = sel.match(/_(\d{4})$/);
	    return m ? parseInt(m[1], 10) : null;
	  } catch (e) {
	    return null;
	  }
	}
	
	function aiTutorPageUrl() {
	  try {
	    return window.location.href;
	  } catch (e) {
	    return null;
	  }
	}
	
	// Publish the current page context: global (read when the tutor opens — timing-proof)
	// + event (live-updates the context bar while the tutor is already open).
	function dispatchAiTutorContext(context) {
	  try {
	    window.__aiTutorContext = context;
	    window.dispatchEvent(new CustomEvent('aitutor:context', { detail: { context: context } }));
	  } catch (e) {
	    /* noop */
	  }
	}
	
	// Open the tutor and submit a prompt scoped to the given context (and optional item).
	function dispatchAiTutorExplain(detail) {
	  try {
	    window.dispatchEvent(new CustomEvent('aitutor:explain', { detail: detail }));
	  } catch (e) {
	    /* noop */
	  }
	}
	
	// HTML → plain text, capped — the grounding snippet for KB retrieval.
	function aiTutorStem(html, max) {
	  var cap = max || 400;
	  try {
	    return String(html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, cap);
	  } catch (e) {
	    return '';
	  }
	}

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var caseCV = exports.caseCV = function caseCV(offset) {
	  var caseCV = {
	    dots: false,
	    infinite: false,
	    speed: 250,
	    arrows: true,
	    vertical: false,
	    slidesToShow: 15,
	    slidesToScroll: 15,
	    initialSlide: offset,
	    /* eslint-disable*/
	    responsive: [{
	      breakpoint: 1234,
	      settings: {
	        slidesToShow: 10,
	        slidesToScroll: 10,
	        infinite: false,
	        dots: false
	      }
	    }, {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 8,
	        slidesToScroll: 8,
	        infinite: false,
	        dots: false
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 5,
	        slidesToScroll: 5,
	        initialSlide: offset
	      }
	    }, {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        initialSlide: offset
	      }
	    }]
	  };
	  return caseCV;
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomButton(_ref) {
	  var onClick = _ref.onClick,
	      children = _ref.children,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      btnColor = _ref.btnColor;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      className: 'btn active pointer_class ' + (className || '') + ' ' + (btnColor ? 'btn-' + btnColor : 'btn-primary'),
	      disabled: disabled,
	      onClick: onClick
	    },
	    children
	  );
	}
	
	exports.default = CustomButton;

/***/ },
/* 96 */
61,
/* 97 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	-------------------------------------------------
	  FUNCTION TO CHECK FOR QUESTIONS AND QUIZZES.
	-------------------------------------------------
	*/
	/* eslint-disable*/
	
	var checkSoaFMSubscription = function checkSoaFMSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            // inside if block subscription check for partner users.
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            ---------------
	              App User's
	            ---------------
	            */
	            // inside else block check for partner user app subsciption plans
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      } else {
	        flag = true;
	      }
	      break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            // inside if block subscription check for partner users plans
	            if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            --------------
	              App User's
	            --------------
	            */
	            // inside else check for block partner user subscription plans
	            if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	/*
	-------------------------------
	  FUNCTION TO CHECK FOR NOTES
	-------------------------------
	*/
	var checkSoaFMNotesSubscription = function checkSoaFMNotesSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            ------------------
	              App User's
	            ------------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	            if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35 && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            --------------
	            App User's
	            --------------
	            */
	            if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35 && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	/*
	-----------------------------------------------------
	  FUNCTION TO CHECK FOR PDF'S DOWNLOAD
	-----------------------------------------------------
	*/
	var checkSoaFM_PDFSubscription = function checkSoaFM_PDFSubscription(selectedLevel, exam_data, type) {
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            // inside if block subscription check for partner user
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              pdfFlag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive // simple check
	            ) {
	                if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                  pdfFlag = true; // for questions
	                } else if (exam_data[i].levels[j].noteStatus && type === "notes" // for notes
	                ) {
	                    pdfFlag = true;
	                  }
	                // break;/
	              }
	          } else {
	            /*
	            ------------------
	              App User's
	            ------------------
	            */
	            // inside else block subscriptin check for partner user app plans
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              pdfFlag = true;
	              // break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;/
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	              pdfFlag = true;
	              // break;
	            }
	          }
	        }
	      } else {
	        pdfFlag = true;
	      }
	    } else {
	      // inside else block check for other exams app and partner subscription plans
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            -------------------
	            */
	
	            if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;
	            }
	          } else {
	            /*
	            ----------------
	              App User's
	            ----------------
	            */
	
	            // inside else block subscription check for partner user app plans
	            if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	              pdfFlag = true;
	            } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;
	            }
	          }
	        }
	      }
	    }
	  }
	
	  return pdfFlag;
	};
	
	/*
	-----------------------------------------------------
	  FUNCTION TO CHECK FOR VIDEOS
	-----------------------------------------------------
	*/
	
	var checkSoaFMVideosSubscription = function checkSoaFMVideosSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            // inside if block subscription check for partner user
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;/
	            }
	          } else {
	            /*
	            ------------------
	              App User's
	            ------------------
	            */
	
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              // break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              // break;/
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              // break;
	            }
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	exports.checkSoaFMSubscription = checkSoaFMSubscription;
	exports.checkSoaFMNotesSubscription = checkSoaFMNotesSubscription;
	exports.checkSoaFM_PDFSubscription = checkSoaFM_PDFSubscription;
	exports.checkSoaFMVideosSubscription = checkSoaFMVideosSubscription;

/***/ },
/* 98 */
/***/ function(module, exports) {

	"use strict";
	
	/* eslint-disable*/
	
	var checkSoaFMSubscription = function checkSoaFMSubscription(selectedLevel, exam_data) {
	  // console.log(" FM selectedLevel", selectedLevel);
	  // console.log(" Fm exam_data", exam_data);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          // console.log("4");
	          if (exam_data[i].levels[j].isActive) {
	            // console.log("5");
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	
	var checkSoaFMNotesSubscription = function checkSoaFMNotesSubscription(selectedLevel, exam_data) {
	  var flag = false;
	
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	            flag = true;
	            break;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35 && exam_data[i].levels[j].noteStatus !== false) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	var checkSoaFM_PDFSubscription = function checkSoaFM_PDFSubscription(selectedLevel, exam_data, type) {
	  // console.log("selectedLevel FM PDF", selectedLevel);/
	  // console.log("exam_data FM PDF", exam_data);/*  */
	
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	    //
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	            pdfFlag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive) {
	            if (exam_data[i].levels[j].pdfstatus && type === "question") {
	              pdfFlag = true;
	            } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	              pdfFlag = true;
	            }
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	            pdfFlag = true;
	            // break;
	          }
	        }
	      } else {
	        // console.log("6");
	        pdfFlag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            pdfFlag = true;
	            // break;
	          } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	            if (exam_data[i].levels[j].pdfstatus && type === "question") {
	              pdfFlag = true;
	            } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	              pdfFlag = true;
	            }
	            // break;
	          }
	        }
	      }
	    }
	  }
	
	  return pdfFlag;
	};
	
	var checkSoaFMVideosSubscription = function checkSoaFMVideosSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	            flag = true;
	            // break;/
	          } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	            flag = true;
	            // break;
	          }
	        }
	      } else {
	        flag = true;
	      }
	      // break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 28 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	  }
	  return flag;
	};
	exports.checkSoaFMSubscription = checkSoaFMSubscription;
	exports.checkSoaFMNotesSubscription = checkSoaFMNotesSubscription;
	exports.checkSoaFM_PDFSubscription = checkSoaFM_PDFSubscription;
	exports.checkSoaFMVideosSubscription = checkSoaFMVideosSubscription;

/***/ },
/* 99 */
[1265, 26],
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickoutside = __webpack_require__(1188);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectionExists() {
	  var selection = window.getSelection();
	  return selection && selection.rangeCount > 0 && selection.getRangeAt(0) && !selection.getRangeAt(0).collapsed && selection.getRangeAt(0).getBoundingClientRect().width > 0 && selection.getRangeAt(0).getBoundingClientRect().height > 0;
	}
	
	function clearSelection() {
	  if (window.getSelection) {
	    window.getSelection().removeAllRanges();
	  } else if (document.selection) {
	    document.selection.empty();
	  }
	}
	
	var SelectionPopover = function (_Component) {
	  _inherits(SelectionPopover, _Component);
	
	  function SelectionPopover(props) {
	    _classCallCheck(this, SelectionPopover);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SelectionPopover).call(this, props));
	
	    _this._handleMouseUp = function () {
	      if (selectionExists()) {
	        _this.props.onSelect();
	        return _this.computePopoverBox();
	      }
	      _this.props.onDeselect();
	    };
	
	    _this.computePopoverBox = function () {
	      var selection = window.getSelection();
	      if (!selectionExists()) {
	        return;
	      }
	      var selectionBox = selection.getRangeAt(0).getBoundingClientRect();
	      var popoverBox = _this.refs.selectionPopover.getBoundingClientRect();
	      var targetBox = document.querySelector('[data-selectable]').getBoundingClientRect();
	      _this.setState({
	        popoverBox: {
	          top: selectionBox.top - targetBox.top - _this.props.topOffset,
	          left: selectionBox.width / 2 - popoverBox.width / 2 + (selectionBox.left - targetBox.left)
	        }
	      });
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onDeselect();
	    };
	
	    _this.state = {
	      popoverBox: {
	        top: 0,
	        left: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(SelectionPopover, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.showPopover === true && nextProps.showPopover === false) {
	        clearSelection();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var target = document.querySelector('[data-selectable]');
	      target.addEventListener('mouseup', this._handleMouseUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var target = document.querySelector('[data-selectable]');
	      target.removeEventListener('mouseup', this._handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onDeselect = _props.onDeselect;
	      var onSelect = _props.onSelect;
	      var showPopover = _props.showPopover;
	      var children = _props.children;
	      var style = _props.style;
	      var topOffset = _props.topOffset;
	
	      var otherProps = _objectWithoutProperties(_props, ['onDeselect', 'onSelect', 'showPopover', 'children', 'style', 'topOffset']); // eslint-disable-line no-unused-vars
	
	
	      var _state$popoverBox = this.state.popoverBox;
	      var top = _state$popoverBox.top;
	      var left = _state$popoverBox.left;
	
	
	      var visibility = showPopover ? 'visible' : 'hidden';
	      var display = showPopover ? 'inline-block' : 'none';
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'selectionPopover',
	          style: _extends({
	            visibility: visibility,
	            display: display,
	            position: 'absolute',
	            top: top,
	            left: left
	          }, style)
	        }, otherProps),
	        children
	      );
	    }
	  }]);
	
	  return SelectionPopover;
	}(_react.Component);
	
	SelectionPopover.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  style: _react.PropTypes.object,
	  topOffset: _react.PropTypes.number,
	  onDeselect: _react.PropTypes.func.isRequired,
	  onSelect: _react.PropTypes.func.isRequired,
	  showPopover: _react.PropTypes.bool.isRequired
	};
	
	SelectionPopover.defaultProps = {
	  topOffset: 30
	};
	
	exports.default = (0, _reactOnclickoutside2.default)(SelectionPopover);

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(153);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(120);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	var Readable = __webpack_require__(491);
	var Writable = __webpack_require__(230);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(502);

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.examRedirectRoute = undefined;
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var examRedirectRoute = exports.examRedirectRoute = {
	  cfa: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2022: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2023: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2024: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2025: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2026: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2027: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	  cfa_2_2025: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	  cfa_2_2026: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	  // CFA2 2027 has its own separate view tree (not shared like CFA1 2027) → land on the 2027 dashboard.
	  cfa_2_2027: _AppRoutes2.default.CFA2_2027_DASHBOARD,
	  cfa_3: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	  cfa_3_2025: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	  cfa_3_2026: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	  frm: _AppRoutes2.default.FRM_DASHBOARD,
	  soa_p: _AppRoutes2.default.SOA_PROBABILITY_DASHBOARD,
	  soa_fm: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
	  gmat: _appRoutes2.default.DASHBOARD,
	  gmat_focus: _appRoutes2.default.DASHBOARD,
	  ea: _AppRoutes2.default.EA_DASHBOARD,
	  esg: _AppRoutes2.default.ESG_DASHBOARD
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionNotFoundModal = function (_React$Component) {
	  _inherits(QuestionNotFoundModal, _React$Component);
	
	  function QuestionNotFoundModal() {
	    _classCallCheck(this, QuestionNotFoundModal);
	
	    return _possibleConstructorReturn(this, (QuestionNotFoundModal.__proto__ || Object.getPrototypeOf(QuestionNotFoundModal)).apply(this, arguments));
	  }
	
	  _createClass(QuestionNotFoundModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          alert_status = _props.alert_status,
	          toggleAlert = _props.toggleAlert,
	          MessageTitle = _props.MessageTitle,
	          MessageContent = _props.MessageContent;
	
	      console.log('MessageTitle--->', MessageTitle);
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: alert_status,
	          toggle: toggleAlert,
	          className: 'modal-primary ' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: toggleAlert },
	          MessageTitle
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex flex-column' },
	            _react2.default.createElement(
	              'div',
	              null,
	              ' ',
	              MessageContent
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-right' },
	              ' ',
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { color: 'primary', onClick: toggleAlert },
	                ' ',
	                _language2.default.LC().OK,
	                ' '
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return QuestionNotFoundModal;
	}(_react2.default.Component);
	
	exports.default = QuestionNotFoundModal;

/***/ },
/* 105 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	----------------------------------------------------
	  FUNCTION TO CHECK FOR QUESTIONS AND QUIZZES
	----------------------------------------------------
	*/
	/* eslint-disable*/
	
	var checkSoaPSubscription = function checkSoaPSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            --------------
	              App User's
	            --------------
	            */
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      } else {
	        flag = true;
	      }
	      break;
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            --------------
	             App User's
	            --------------
	            */
	            if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	/*
	-------------------------------------------
	  Function to check for notes subscription
	-------------------------------------------
	*/
	
	var checkSoaPNotesSubscription = function checkSoaPNotesSubscription(selectedLevel, exam_data) {
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        // console.log("3");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            ---------------
	              App User's
	            ---------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = true;
	      }
	      // break;
	    } else {
	      // console.log("7");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            ------------------
	            */
	
	            if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35 && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            }
	          } else {
	            /*
	            --------------
	            App User's
	            --------------
	            */
	            if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35 && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	  }
	
	  return flag;
	};
	
	/*
	----------------------------------------------
	  FUNCTION TO CHECK FOR PDF'S SUBSCRIPTION
	----------------------------------------------
	*/
	var checkSoaP_PDFSubscription = function checkSoaP_PDFSubscription(selectedLevel, exam_data, type) {
	  var pdfFlag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    if (exam_data[i].exam_name === selectedLevel) {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            -------------------
	            */
	            // inside if block check  for the partner user subscription
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              pdfFlag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;/
	            }
	          } else {
	            /*
	            --------------
	              App user's
	            --------------
	            */
	            if (exam_data[i].levels[j].package_val === "expensive" && exam_data[i].levels[j].isActive) {
	              pdfFlag = true;
	              // break;
	            } else if (exam_data[i].levels[j].package_val === "simple" && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;/
	            } else if (exam_data[i].levels[j].package_val === "unlimited" && exam_data[i].levels[j].isActive) {
	              pdfFlag = true;
	              // break;
	            }
	          }
	        }
	      } else {
	        pdfFlag = true;
	      }
	    } else {
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].partner) {
	            /*
	            ------------------
	              Partner User's
	            -------------------
	            */
	
	            if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;
	            }
	          } else {
	            /*
	            ----------------
	              App User's
	            ----------------
	            */
	            if (exam_data[i].levels[j].package_val === "unlimited" && (exam_data[i].levels[j].package_id === 31 || exam_data[i].levels[j].package_id === 34 || exam_data[i].levels[j].package_id === 36)) {
	              pdfFlag = true;
	            } else if (exam_data[i].levels[j].isActive && exam_data[i].levels[j].package_id === 35) {
	              if (exam_data[i].levels[j].pdfstatus && type === "question") {
	                pdfFlag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
	                pdfFlag = true;
	              }
	              // break;
	            }
	          }
	        }
	      }
	    }
	  }
	
	  return pdfFlag;
	};
	
	exports.checkSoaPSubscription = checkSoaPSubscription;
	exports.checkSoaPNotesSubscription = checkSoaPNotesSubscription;
	exports.checkSoaP_PDFSubscription = checkSoaP_PDFSubscription;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(989);
	var hasBinary = __webpack_require__(304);
	var sliceBuffer = __webpack_require__(500);
	var after = __webpack_require__(499);
	var utf8 = __webpack_require__(990);
	
	var base64encoder;
	if (typeof ArrayBuffer !== 'undefined') {
	  base64encoder = __webpack_require__(908);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(910);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if (typeof utf8encode === 'function') {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data === 'string') {
	    if (data.charAt(0) === 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data, { strict: false });
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data !== 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data === '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = '', n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (chr !== ':') {
	      length += chr;
	      continue;
	    }
	
	    if (length === '' || (length != (n = Number(length)))) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    msg = data.substr(i + 1, n);
	
	    if (length != msg.length) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    if (msg.length) {
	      packet = exports.decodePacket(msg, binaryType, false);
	
	      if (err.type === packet.type && err.data === packet.data) {
	        // parser error in individual packet - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      var ret = callback(packet, i + n, l);
	      if (false === ret) return;
	    }
	
	    // advance cursor
	    i += n;
	    length = '';
	  }
	
	  if (length !== '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] === 255) break;
	
	      // 310 = char length of Number.MAX_VALUE
	      if (msgLength.length > 310) {
	        return callback(err, 0, 1);
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(305);
	var DomHandler = __webpack_require__(288);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(306),
	    ElementType: __webpack_require__(121),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(1046));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(1048));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(307));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(1047));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(290));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(1045)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(204);
	var setInnerHTML = __webpack_require__(158);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(212);
	var setTextContent = __webpack_require__(460);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1110);
	var ReactInstrumentation = __webpack_require__(60);
	
	var warning = __webpack_require__(27);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(91);
	
	var _Actions = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactBaseClasses = __webpack_require__(480);
	var ReactChildren = __webpack_require__(1208);
	var ReactDOMFactories = __webpack_require__(1209);
	var ReactElement = __webpack_require__(116);
	var ReactPropTypes = __webpack_require__(1210);
	var ReactVersion = __webpack_require__(1211);
	
	var createReactClass = __webpack_require__(1212);
	var onlyChild = __webpack_require__(1216);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactCurrentOwner = __webpack_require__(82);
	
	var warning = __webpack_require__(27);
	var canDefineProperty = __webpack_require__(484);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(482);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trackPaymentFailed = exports.trackAddPaymentInfo = exports.trackBeginCheckout = exports.trackAddToCart = undefined;
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Fire add-to-cart conversion events for marketing/analytics platforms.
	 *
	 * Mirrors the legacy /views/Subscribe/SelectPackage.js dataLayer payload
	 * shape so existing GTM tags continue to work without reconfiguration.
	 * Failures are caught and logged so an analytics outage never breaks the
	 * user-visible cart flow.
	 *
	 * Tags fired:
	 *   - GTM custom `addToCart` event (workspace-defined trigger)
	 *   - GTM `add_to_cart` GA4 standard ecommerce event
	 *   - Facebook Pixel `AddToCart` standard event (NOT `Purchase` — the legacy
	 *     code wrongly used `Purchase` on add-to-cart, inflating FB conversion
	 *     counts)
	 *
	 * @param {object} params
	 * @param {string} [params.exam='']            - Display exam name (e.g. "CFA Level I")
	 * @param {string} [params.packageType='']     - Package label (e.g. "CFA Unlimited+ Package (All 3 Levels)")
	 * @param {number} [params.value=0]            - Item value in USD
	 * @param {string} [params.userName='']
	 * @param {string} [params.userEmail='']
	 * @param {string} [params.source='organic']
	 * @param {string|null} [params.affiliateName=null]
	 */
	var trackAddToCart = exports.trackAddToCart = function trackAddToCart() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$exam = _ref.exam,
	      exam = _ref$exam === undefined ? '' : _ref$exam,
	      _ref$packageType = _ref.packageType,
	      packageType = _ref$packageType === undefined ? '' : _ref$packageType,
	      _ref$value = _ref.value,
	      value = _ref$value === undefined ? 0 : _ref$value,
	      _ref$userName = _ref.userName,
	      userName = _ref$userName === undefined ? '' : _ref$userName,
	      _ref$userEmail = _ref.userEmail,
	      userEmail = _ref$userEmail === undefined ? '' : _ref$userEmail,
	      _ref$source = _ref.source,
	      source = _ref$source === undefined ? 'organic' : _ref$source,
	      _ref$affiliateName = _ref.affiliateName,
	      affiliateName = _ref$affiliateName === undefined ? null : _ref$affiliateName;
	
	  try {
	    var numericValue = Number(value) || 0;
	
	    // GTM custom event — workspace tags (Bing UET, custom audiences, etc.)
	    // listen for `addToCart`. Payload shape preserved from legacy code so
	    // existing GTM triggers / variables keep matching.
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GtmAddToCart,
	        eventOptions: {
	          addedPackage: {
	            exam: exam,
	            packageType: packageType,
	            price: numericValue
	          }
	        },
	        userName: userName,
	        userEmail: userEmail,
	        userExam: exam,
	        source: source,
	        affiliateName: affiliateName,
	        price: numericValue,
	        value: numericValue,
	        currency: _constant.Currency
	      }
	    });
	
	    // GA4 standard ecommerce `add_to_cart` event
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GA4AddToCart,
	        eventOptions: {
	          addedPackage: {
	            exam: exam,
	            packageType: packageType,
	            value: numericValue
	          }
	        },
	        currency: _constant.Currency,
	        value: numericValue,
	        items: [{ item_id: userEmail || exam, item_name: exam, price: numericValue }],
	        userName: userName,
	        userEmail: userEmail,
	        userExam: exam,
	        source: source,
	        affiliateName: affiliateName,
	        price: numericValue
	      }
	    });
	
	    // Facebook Pixel — correct standard `AddToCart` event.
	    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
	      window.fbq('track', 'AddToCart', {
	        currency: _constant.Currency,
	        value: numericValue,
	        content_type: 'product',
	        content_name: packageType || exam
	      });
	    }
	  } catch (err) {
	    // eslint-disable-next-line no-console
	    console.warn('trackAddToCart failed:', err && err.message);
	  }
	};
	
	/**
	 * Build the cart array shape used by the GTM/GA4 begin_checkout payloads.
	 * Mirrors the legacy Cart.js array shape so existing GTM tags pick it up.
	 *
	 * @param {Array} cartItems - rows from /checkout_v1/getUserCart
	 * @returns {Array<{ exam: string, packageType: string, price: number }>}
	 */
	var buildCartArray = function buildCartArray() {
	  var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (!Array.isArray(cartItems)) return [];
	  return cartItems.map(function (item) {
	    var extras = Array.isArray(item && item.extraData) ? item.extraData : [];
	    var extrasTotal = extras.reduce(function (sum, ex) {
	      return sum + (Number(ex.price) || 0);
	    }, 0);
	    return {
	      exam: item && item.exam_name || '',
	      packageType: item && item.package_type || '',
	      price: (Number(item && item.price) || 0) + extrasTotal
	    };
	  });
	};
	
	/**
	 * Fire begin-checkout conversion events.
	 *
	 * Trigger: user clicks "Proceed to Checkout" on the cart page (i.e., is
	 * leaving Cart.js for Checkout.js). Mirrors the legacy Cart.js dataLayer
	 * payload shape so existing GTM tags continue to match.
	 *
	 * Tags fired:
	 *   - GTM custom `startPayment` event (workspace-defined trigger)
	 *   - GTM `begin_checkout` GA4 standard ecommerce event
	 *   - Facebook Pixel `InitiateCheckout` standard event
	 *
	 * @param {object} params
	 * @param {Array}  [params.cartItems=[]]    - rows from /checkout_v1/getUserCart
	 * @param {number} [params.total=0]         - cart total in USD (post-discount)
	 * @param {string} [params.paymentType='']  - 'stripe' | 'paypal' | '' if not yet selected
	 * @param {string} [params.userName='']
	 * @param {string} [params.userEmail='']
	 * @param {string} [params.source='organic']
	 * @param {string|null} [params.affiliateName=null]
	 */
	var trackBeginCheckout = exports.trackBeginCheckout = function trackBeginCheckout() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$cartItems = _ref2.cartItems,
	      cartItems = _ref2$cartItems === undefined ? [] : _ref2$cartItems,
	      _ref2$total = _ref2.total,
	      total = _ref2$total === undefined ? 0 : _ref2$total,
	      _ref2$paymentType = _ref2.paymentType,
	      paymentType = _ref2$paymentType === undefined ? '' : _ref2$paymentType,
	      _ref2$userName = _ref2.userName,
	      userName = _ref2$userName === undefined ? '' : _ref2$userName,
	      _ref2$userEmail = _ref2.userEmail,
	      userEmail = _ref2$userEmail === undefined ? '' : _ref2$userEmail,
	      _ref2$source = _ref2.source,
	      source = _ref2$source === undefined ? 'organic' : _ref2$source,
	      _ref2$affiliateName = _ref2.affiliateName,
	      affiliateName = _ref2$affiliateName === undefined ? null : _ref2$affiliateName;
	
	  try {
	    var cart = buildCartArray(cartItems);
	    var value = Number(total) || 0;
	
	    // GTM custom event
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GTMStartPayment,
	        eventOptions: {
	          paymentOption: paymentType,
	          cart: cart,
	          cartTotal: value
	        },
	        userName: userName,
	        userEmail: userEmail,
	        source: source,
	        affiliateName: affiliateName,
	        currency: _constant.Currency,
	        value: value,
	        price: value
	      }
	    });
	
	    // GA4 standard ecommerce begin_checkout
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GA4BeginCheckout,
	        currency: _constant.Currency,
	        value: value,
	        items: cart,
	        userName: userName,
	        userEmail: userEmail,
	        source: source
	      }
	    });
	
	    // Facebook Pixel — standard `InitiateCheckout` event
	    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
	      window.fbq('track', 'InitiateCheckout', {
	        currency: _constant.Currency,
	        value: value,
	        num_items: cart.length
	      });
	    }
	  } catch (err) {
	    // eslint-disable-next-line no-console
	    console.warn('trackBeginCheckout failed:', err && err.message);
	  }
	};
	
	/**
	 * Fire add-payment-info conversion events.
	 *
	 * Trigger: user has provided valid payment information on /checkout (Stripe
	 * has returned a valid token). Fires BEFORE the /createOrder backend call,
	 * so it captures intent regardless of whether the backend transaction
	 * succeeds or is rejected.
	 *
	 * Tags fired:
	 *   - GTM custom `addPaymentInfo` event
	 *   - GTM `add_payment_info` GA4 standard ecommerce event
	 *   - Facebook Pixel `AddPaymentInfo` standard event
	 *
	 * @param {object} params
	 * @param {Array}  [params.cartItems=[]]
	 * @param {number} [params.total=0]
	 * @param {string} [params.paymentType='stripe']
	 * @param {string} [params.userName='']
	 * @param {string} [params.userEmail='']
	 * @param {string} [params.source='organic']
	 * @param {string|null} [params.affiliateName=null]
	 */
	var trackAddPaymentInfo = exports.trackAddPaymentInfo = function trackAddPaymentInfo() {
	  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref3$cartItems = _ref3.cartItems,
	      cartItems = _ref3$cartItems === undefined ? [] : _ref3$cartItems,
	      _ref3$total = _ref3.total,
	      total = _ref3$total === undefined ? 0 : _ref3$total,
	      _ref3$paymentType = _ref3.paymentType,
	      paymentType = _ref3$paymentType === undefined ? 'stripe' : _ref3$paymentType,
	      _ref3$userName = _ref3.userName,
	      userName = _ref3$userName === undefined ? '' : _ref3$userName,
	      _ref3$userEmail = _ref3.userEmail,
	      userEmail = _ref3$userEmail === undefined ? '' : _ref3$userEmail,
	      _ref3$source = _ref3.source,
	      source = _ref3$source === undefined ? 'organic' : _ref3$source,
	      _ref3$affiliateName = _ref3.affiliateName,
	      affiliateName = _ref3$affiliateName === undefined ? null : _ref3$affiliateName;
	
	  try {
	    var cart = buildCartArray(cartItems);
	    var value = Number(total) || 0;
	
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GTMAddPaymentInfo,
	        eventOptions: {
	          paymentOption: paymentType,
	          cart: cart,
	          cartTotal: value
	        },
	        userName: userName,
	        userEmail: userEmail,
	        source: source,
	        affiliateName: affiliateName,
	        currency: _constant.Currency,
	        value: value,
	        price: value
	      }
	    });
	
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GA4AddPaymentInfo,
	        currency: _constant.Currency,
	        value: value,
	        items: cart,
	        payment_type: paymentType,
	        userName: userName,
	        userEmail: userEmail,
	        source: source
	      }
	    });
	
	    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
	      window.fbq('track', 'AddPaymentInfo', {
	        currency: _constant.Currency,
	        value: value,
	        num_items: cart.length
	      });
	    }
	  } catch (err) {
	    // eslint-disable-next-line no-console
	    console.warn('trackAddPaymentInfo failed:', err && err.message);
	  }
	};
	
	/**
	 * Fire payment-failed diagnostic events.
	 *
	 * Trigger: any failure during /checkout payment submission. Fires once per
	 * failed attempt (no idempotency guard inside the helper — caller controls
	 * cadence).
	 *
	 * Tags fired:
	 *   - GTM custom `paymentFailed` event with `reason` + `errorMessage`
	 *   - GTM `payment_failed` custom GA4 event with same fields
	 *   - Facebook Pixel `trackCustom` `PaymentFailed` (custom — only if your FB
	 *     workspace whitelists it; otherwise silently skipped by FB)
	 *
	 * Use the `reason` field to bucket failure types in GA4:
	 *   - 'card_validation' — Stripe.js token creation failed (declined card,
	 *      bad CVC, expired, etc.)
	 *   - 'backend_rejection' — /createOrder returned success: false
	 *   - 'exception' — uncaught JS exception during the submit handler
	 *
	 * @param {object} params
	 * @param {string} [params.reason='unknown']        - Bucket label
	 * @param {string} [params.errorMessage='']         - Human-readable error
	 * @param {Array}  [params.cartItems=[]]
	 * @param {number} [params.total=0]
	 * @param {string} [params.paymentType='stripe']
	 * @param {string} [params.userName='']
	 * @param {string} [params.userEmail='']
	 * @param {string} [params.source='organic']
	 * @param {string|null} [params.affiliateName=null]
	 */
	var trackPaymentFailed = exports.trackPaymentFailed = function trackPaymentFailed() {
	  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref4$reason = _ref4.reason,
	      reason = _ref4$reason === undefined ? 'unknown' : _ref4$reason,
	      _ref4$errorMessage = _ref4.errorMessage,
	      errorMessage = _ref4$errorMessage === undefined ? '' : _ref4$errorMessage,
	      _ref4$cartItems = _ref4.cartItems,
	      cartItems = _ref4$cartItems === undefined ? [] : _ref4$cartItems,
	      _ref4$total = _ref4.total,
	      total = _ref4$total === undefined ? 0 : _ref4$total,
	      _ref4$paymentType = _ref4.paymentType,
	      paymentType = _ref4$paymentType === undefined ? 'stripe' : _ref4$paymentType,
	      _ref4$userName = _ref4.userName,
	      userName = _ref4$userName === undefined ? '' : _ref4$userName,
	      _ref4$userEmail = _ref4.userEmail,
	      userEmail = _ref4$userEmail === undefined ? '' : _ref4$userEmail,
	      _ref4$source = _ref4.source,
	      source = _ref4$source === undefined ? 'organic' : _ref4$source,
	      _ref4$affiliateName = _ref4.affiliateName,
	      affiliateName = _ref4$affiliateName === undefined ? null : _ref4$affiliateName;
	
	  try {
	    var cart = buildCartArray(cartItems);
	    var value = Number(total) || 0;
	
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GTMPaymentFailed,
	        eventOptions: {
	          reason: reason,
	          errorMessage: errorMessage,
	          paymentOption: paymentType,
	          cart: cart,
	          cartTotal: value
	        },
	        userName: userName,
	        userEmail: userEmail,
	        source: source,
	        affiliateName: affiliateName,
	        currency: _constant.Currency,
	        value: value,
	        reason: reason,
	        errorMessage: errorMessage
	      }
	    });
	
	    _reactGtmModule2.default.initialize({
	      gtmId: _constant.GTM_ID,
	      dataLayer: {
	        event: _constant.GA4PaymentFailed,
	        currency: _constant.Currency,
	        value: value,
	        items: cart,
	        payment_type: paymentType,
	        reason: reason,
	        error_message: errorMessage,
	        userName: userName,
	        userEmail: userEmail,
	        source: source
	      }
	    });
	
	    // FB Pixel custom event — fbq supports `trackCustom` for non-standard events.
	    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
	      window.fbq('trackCustom', 'PaymentFailed', {
	        currency: _constant.Currency,
	        value: value,
	        reason: reason
	      });
	    }
	  } catch (err) {
	    // eslint-disable-next-line no-console
	    console.warn('trackPaymentFailed failed:', err && err.message);
	  }
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardBody(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-block ' + (className || '') + ' ' },
	    children
	  );
	}
	
	exports.default = CardBody;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardHeader(props) {
	  var headingText = props.headingText,
	      headerImage = props.headerImage,
	      _props$imageWidth = props.imageWidth,
	      imageWidth = _props$imageWidth === undefined ? '30' : _props$imageWidth,
	      showPreviousButton = props.showPreviousButton,
	      showNextButton = props.showNextButton,
	      _getPrevious = props._getPrevious,
	      _getNext = props._getNext,
	      disabledNextButton = props.disabledNextButton,
	      disabledPreviousButton = props.disabledPreviousButton,
	      className = props.className,
	      headerClassName = props.headerClassName,
	      children = props.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-header ' + (headerClassName || '') },
	    headerImage && _react2.default.createElement('img', {
	      src: _App_data2.default.frontend_url + headerImage,
	      className: 'margin_right_20',
	      width: imageWidth,
	      alt: ''
	    }),
	    (0, _function.renderHTMLContent)(headingText, 'span', '', { contentEditable: 'false' }),
	    ' ',
	    _react2.default.createElement(
	      'div',
	      { className: 'float-right text-right' },
	      showPreviousButton && _react2.default.createElement('button', {
	        className: 'fa fa-angle-left ques_arrow pointer_class ' + (disabledPreviousButton && 'text-secondary'),
	        onClick: _getPrevious,
	        disabled: disabledPreviousButton
	      }),
	      showNextButton && _react2.default.createElement('button', {
	        className: 'fa fa-angle-right ques_arrow pointer_class ' + (disabledNextButton && 'text-secondary'),
	        onClick: _getNext,
	        disabled: disabledNextButton
	      }),
	      children
	    )
	  );
	}
	
	exports.default = CardHeader;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 121 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 122 */
79,
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.load = load;
	exports.loadAll = loadAll;
	exports.select = select;
	exports.save = save;
	exports.remove = remove;
	exports.setRawCookie = setRawCookie;
	exports.plugToRequest = plugToRequest;
	
	var _cookie = __webpack_require__(284);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(28);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IS_NODE = typeof document === 'undefined' || typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}) && ("production") === 'test';
	var _rawCookie = {};
	var _res = void 0;
	
	function _isResWritable() {
	  return _res && !_res.headersSent;
	}
	
	function load(name, doNotParse) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	  var cookieVal = cookies && cookies[name];
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (err) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function loadAll(doNotParse) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	  var cookieVal = cookies;
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (err) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function select(regex) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	
	  if (!cookies) {
	    return {};
	  }
	
	  if (!regex) {
	    return cookies;
	  }
	
	  return Object.keys(cookies).reduce(function (accumulator, name) {
	    if (!regex.test(name)) {
	      return accumulator;
	    }
	
	    var newCookie = {};
	    newCookie[name] = cookies[name];
	    return (0, _objectAssign2.default)({}, accumulator, newCookie);
	  }, {});
	}
	
	function save(name, val, opt) {
	  _rawCookie[name] = val;
	
	  // Allow you to work with cookies as objects.
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    _rawCookie[name] = JSON.stringify(val);
	  }
	
	  // Cookies only work in the browser
	  if (!IS_NODE) {
	    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
	  }
	
	  if (_isResWritable() && _res.cookie) {
	    _res.cookie(name, val, opt);
	  }
	}
	
	function remove(name, opt) {
	  delete _rawCookie[name];
	
	  if (typeof opt === 'undefined') {
	    opt = {};
	  } else if (typeof opt === 'string') {
	    // Will be deprecated in future versions
	    opt = { path: opt };
	  } else {
	    // Prevent mutation of opt below
	    opt = (0, _objectAssign2.default)({}, opt);
	  }
	
	  if (typeof document !== 'undefined') {
	    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
	    opt.maxAge = 0;
	    document.cookie = _cookie2.default.serialize(name, '', opt);
	  }
	
	  if (_isResWritable() && _res.clearCookie) {
	    _res.clearCookie(name, opt);
	  }
	}
	
	function setRawCookie(rawCookie) {
	  if (rawCookie) {
	    _rawCookie = _cookie2.default.parse(rawCookie);
	  } else {
	    _rawCookie = {};
	  }
	}
	
	function plugToRequest(req, res) {
	  if (req.cookie) {
	    _rawCookie = req.cookie;
	  } else if (req.cookies) {
	    _rawCookie = req.cookies;
	  } else if (req.headers && req.headers.cookie) {
	    setRawCookie(req.headers.cookie);
	  } else {
	    _rawCookie = {};
	  }
	
	  _res = res;
	
	  return function unplug() {
	    _res = null;
	    _rawCookie = {};
	  };
	}
	
	exports.default = {
	  setRawCookie: setRawCookie,
	  load: load,
	  loadAll: loadAll,
	  select: select,
	  save: save,
	  remove: remove,
	  plugToRequest: plugToRequest
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var EventPluginRegistry = __webpack_require__(205);
	var EventPluginUtils = __webpack_require__(206);
	var ReactErrorUtils = __webpack_require__(210);
	
	var accumulateInto = __webpack_require__(453);
	var forEachAccumulated = __webpack_require__(454);
	var invariant = __webpack_require__(20);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(124);
	var EventPluginUtils = __webpack_require__(206);
	
	var accumulateInto = __webpack_require__(453);
	var forEachAccumulated = __webpack_require__(454);
	var warning = __webpack_require__(27);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(81);
	
	var getEventTarget = __webpack_require__(215);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(21);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 129 */
26,
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(33)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Configuration objects for different quiz types
	 */
	
	var graphicalStatementConfig = exports.graphicalStatementConfig = {
	  getCorrectOptions: function getCorrectOptions(question) {
	    return {
	      statement1: question.answer_statement1.replace(/^&/, ''),
	      statement2: question.answer_statement2.replace(/^&/, '')
	    };
	  },
	  getWrongOptions: function getWrongOptions(question) {
	    var getWrongOption = function getWrongOption(options, correctValue) {
	      return options.find(function (opt) {
	        return opt && opt !== correctValue;
	      }) || '';
	    };
	
	    var statement1Options = Array.from({ length: 5 }, function (_, index) {
	      return question['statement1_option' + (index + 1)];
	    });
	    var statement2Options = Array.from({ length: 5 }, function (_, index) {
	      return question['statement2_option' + (index + 1)];
	    });
	
	    return {
	      statement1: getWrongOption(statement1Options, question.answer_statement1).replace(/^&/, ''),
	      statement2: getWrongOption(statement2Options, question.answer_statement2).replace(/^&/, '')
	    };
	  },
	  extractExtraState: function extractExtraState(selectedOptions, received) {
	    return Object.assign({}, selectedOptions, {
	      isUserSelectedChoice: parseInt(received.answer, 10) ? true : false,
	      isLoading: false,
	      validated: Object.keys(received).length > 0
	    });
	  }
	};
	
	var tableAnalysisTwoStatementConfig = exports.tableAnalysisTwoStatementConfig = {
	  getCorrectOptions: function getCorrectOptions(question) {
	    var options = {};
	    Object.keys(question).filter(function (key) {
	      return key.startsWith('answer');
	    }).forEach(function (key) {
	      var value = question[key];
	      if (value && value.trim() !== '') {
	        var optionKey = key.replace('answer', 'option');
	        options[optionKey] = value.trim().toLowerCase();
	      }
	    });
	    return options;
	  },
	  getWrongOptions: function getWrongOptions(question) {
	    var options = {};
	    Object.keys(question).filter(function (key) {
	      return key.startsWith('answer');
	    }).forEach(function (key) {
	      var value = question[key];
	      if (value && value.trim() !== '') {
	        var optionKey = key.replace('answer', 'option');
	        options[optionKey] = value.trim().toLowerCase() === 'yes' ? 'no' : 'yes';
	      }
	    });
	    return options;
	  },
	  extractExtraState: function extractExtraState(selectedOptions, received) {
	    return {
	      isUserSelectedChoice: parseInt(received.answer, 10) ? true : false,
	      isLoading: false,
	      validated: Object.keys(received).length > 0
	    };
	  }
	};
	
	var twoPartAnalysisConfig = exports.twoPartAnalysisConfig = {
	  getCorrectOptions: function getCorrectOptions(question) {
	    var selectedAnswer1 = '';
	    var selectedAnswer2 = '';
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = Object.keys(question)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (question[key] === question.answer1) selectedAnswer1 = key;
	        if (question[key] === question.answer2) selectedAnswer2 = key;
	        if (selectedAnswer1 && selectedAnswer2) break;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      selectedAnswer1: selectedAnswer1,
	      selectedAnswer2: selectedAnswer2
	    };
	  },
	  getWrongOptions: function getWrongOptions(question) {
	    var wrongOptionKeys = Object.keys(question).filter(function (key) {
	      return key.startsWith('option');
	    }).filter(function (key) {
	      return question[key] !== question.answer1 && question[key] !== question.answer2;
	    }).slice(0, 2); // Get the first 2 wrong option KEYS
	
	    return {
	      selectedAnswer1: wrongOptionKeys[0],
	      selectedAnswer2: wrongOptionKeys[1]
	    };
	  },
	  extractExtraState: function extractExtraState(selectedOptions, received) {
	    return {
	      isUserSelectedChoice: parseInt(received.answer, 10) ? true : false,
	      isLoading: false,
	      validated: Object.keys(received).length > 0
	    };
	  }
	};
	
	var multiSourceConfig = exports.multiSourceConfig = {
	  extractExtraState: function extractExtraState(selectedOptions, received) {
	    return {
	      selectedOptions: selectedOptions,
	      isUserSelectedChoice: parseInt(received.answer, 10) ? true : false,
	      isLoading: false,
	      validated: Object.keys(received).length > 0
	    };
	  },
	  getCorrectOptions: function getCorrectOptions(questionDetails) {
	    var isSingleChoice = questionDetails.is_single_choice;
	    if (isSingleChoice) {
	      var yesAnswers = Object.keys(questionDetails).filter(function (key) {
	        return key.startsWith('answer_') && questionDetails[key].trim().toLowerCase() === 'yes';
	      });
	      return yesAnswers.reduce(function (obj, key) {
	        obj[key] = 'yes';
	        return obj;
	      }, {});
	    } else {
	      return Object.keys(questionDetails).reduce(function (obj, key) {
	        if (key.startsWith('answer_')) {
	          obj[key] = questionDetails[key].trim().toLowerCase();
	        }
	        return obj;
	      }, {});
	    }
	  },
	
	  getWrongOptions: function getWrongOptions(questionDetails) {
	    var isSingleChoice = questionDetails.is_single_choice;
	    if (isSingleChoice) {
	      var allAnswerKeys = Object.keys(questionDetails).filter(function (key) {
	        return key.startsWith('answer_');
	      });
	      var randomKey = allAnswerKeys[Math.floor(Math.random() * allAnswerKeys.length)];
	      return _defineProperty({}, randomKey, 'yes');
	    } else {
	      return Object.keys(questionDetails).reduce(function (obj, key) {
	        if (key.startsWith('answer_') && questionDetails[key] && questionDetails[key].trim() !== '') {
	          var value = questionDetails[key].trim().toLowerCase();
	          obj[key] = value === 'yes' ? 'no' : 'yes';
	        }
	        return obj;
	      }, {});
	    }
	  }
	};

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserSelectedChoices = getUserSelectedChoices;
	/**
	 * Get user selected choices for a question, handling correct/incorrect/random logic.
	 * @param {Object} params
	 * @param {Object} params.question - The question object
	 * @param {Object} params.stat - The statistics/state object for the question
	 * @param {Object} params.config - Config object for question type specifics
	 * @returns {Object} { selectedOptions, extraState } - State to set in the component
	 */
	function getUserSelectedChoices(_ref) {
	  var question = _ref.question,
	      stat = _ref.stat,
	      _ref$config = _ref.config,
	      config = _ref$config === undefined ? {} : _ref$config;
	
	  try {
	    // 1. If user has selected choices, parse and return
	    if (stat && stat.selected_choice) {
	      var selected_choice = stat.selected_choice;
	      var extractExtraState = config.extractExtraState;
	
	      var selectedOptions = JSON.parse(selected_choice);
	      return {
	        selectedOptions: selectedOptions,
	        extraState: typeof extractExtraState === 'function' ? extractExtraState(selectedOptions, stat) : {}
	      };
	    }
	
	    // 2. If correct answer to be filled in
	    if (stat && stat.answer === 1) {
	      var getCorrectOptions = config.getCorrectOptions,
	          _extractExtraState = config.extractExtraState;
	
	      if (getCorrectOptions) {
	        var _selectedOptions = getCorrectOptions(question);
	        return {
	          selectedOptions: _selectedOptions,
	          extraState: typeof _extractExtraState === 'function' ? _extractExtraState(_selectedOptions, stat) : {}
	        };
	      }
	    }
	
	    // 3. If incorrect answer to be filled randomly
	    if (stat && stat.answer === 0) {
	      var getWrongOptions = config.getWrongOptions,
	          _extractExtraState2 = config.extractExtraState;
	
	      if (getWrongOptions) {
	        var _selectedOptions2 = getWrongOptions(question);
	        return {
	          selectedOptions: _selectedOptions2,
	          extraState: typeof _extractExtraState2 === 'function' ? _extractExtraState2(_selectedOptions2, stat) : {}
	        };
	      }
	    }
	  } catch (err) {}
	  // Swallow error silently to avoid linter issues
	
	  // Default: return empty
	  return { selectedOptions: {}, extraState: {} };
	}

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _TableSort = __webpack_require__(250);
	
	var _TableSort2 = _interopRequireDefault(_TableSort);
	
	var _constant = __webpack_require__(9);
	
	var _questionUtils = __webpack_require__(168);
	
	var _questionConfigs = __webpack_require__(167);
	
	var _RatingComponent = __webpack_require__(173);
	
	var _RatingComponent2 = _interopRequireDefault(_RatingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TwoStatement = function (_Component) {
	  _inherits(TwoStatement, _Component);
	
	  function TwoStatement(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TwoStatement);
	
	    var _this = _possibleConstructorReturn(this, (TwoStatement.__proto__ || Object.getPrototypeOf(TwoStatement)).call(this, props));
	
	    _this.setUserSelectedChoices = function (index, questions) {
	      var currentQuestion = questions && questions.length > 0 ? questions[index] : _this.state.questionData[index];
	      var _this$props$stateTabl = _this.props.stateTableName,
	          stateTableName = _this$props$stateTabl === undefined ? 'gmat_focus_question_stat' : _this$props$stateTabl;
	
	      var attemptedStateDetails = currentQuestion && currentQuestion[stateTableName] || {};
	      try {
	        var type = _this.props.questionType;
	
	
	        var config = type === _constant.QUESTION_TYPE.TABLE_QUESTION ? _questionConfigs.tableAnalysisTwoPartConfig : _questionConfigs.twoStatementConfig;
	
	        var _getUserSelectedChoic = (0, _questionUtils.getUserSelectedChoices)({
	          question: currentQuestion,
	          stat: attemptedStateDetails,
	          config: config
	        }),
	            selectedOptions = _getUserSelectedChoic.selectedOptions,
	            extraState = _getUserSelectedChoic.extraState;
	
	        if (selectedOptions && Object.keys(selectedOptions).length > 0) {
	          _this.setState(Object.assign({
	            selectedOptions: selectedOptions
	          }, selectedOptions, extraState), function () {
	            _this.handleValidate(false);
	          });
	        } else {
	          _this.setState(Object.assign({}, config.extractExtraState(selectedOptions), {
	            selectedOptions: selectedOptions
	          }, selectedOptions));
	        }
	      } catch (error) {
	        console.error('Invalid JSON in selected_choice:', error);
	      }
	    };
	
	    _this.handleSetCurrentQuestion = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(questions) {
	        var questionId, index, _questions$question$s, _questions$question$s2, questionText, tableContent, questionContent, questionTable, sortingOptions;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	                questionId = _this.props.params.question_id;
	                index = questions.findIndex(function (question) {
	                  return question.id === +questionId;
	                }) || 0;
	                _questions$question$s = questions[index > -1 ? index : 0].question.split('<table'), _questions$question$s2 = _slicedToArray(_questions$question$s, 2), questionText = _questions$question$s2[0], tableContent = _questions$question$s2[1];
	                questionContent = questionText || questions[index > -1 ? index : 0].question;
	                questionTable = tableContent ? '<table id="myTable" border="1" cellpadding="5px" ' + tableContent : '';
	                sortingOptions = questions[index > -1 ? index : 0].sortBy && questions[index > -1 ? index : 0].sortBy.split(',') || [];
	
	                _this.setState({
	                  currentIndex: index > -1 ? index : 0,
	                  currentQuestion: questions[index > -1 ? index : 0],
	                  questionContent: questionContent,
	                  questionTable: questionTable,
	                  sortingOptions: sortingOptions,
	                  isLoading: false
	                });
	                _this.getSavedQuestion(questions[index > -1 ? index : 0].id);
	                _this.getQuestionRating(questions[index > -1 ? index : 0].id);
	
	                if (_this.isRevisionMode) {
	                  _this.setUserSelectedChoices(index, questions);
	                } else {
	                  _this.resetStates();
	                }
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, questionId, reading, bookmarkCSS, _this$props, apiServices, type, _this$props$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, questionId = _this$state.questionId, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props = _this.props, apiServices = _this$props.apiServices, type = _this$props.questionType, _this$props$params = _this$props.params, reading_id = _this$props$params.readingid, question_id = _this$props$params.question_id, topic_name = _this$props$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: question_id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context2.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context2.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(questionId) {
	        var _this$props2, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this$props2 = _this.props, apiServices = _this$props2.apiServices, params = _this$props2.params, type = _this$props2.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context3.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context3.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.getQuestionRating = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(question_id) {
	        var _this$props3, apiServices, type, params, response, success, ratting, questionRating;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType;
	                params = {
	                  question_id: question_id,
	                  type: type
	                };
	                _context4.prev = 2;
	                _context4.next = 5;
	                return apiServices.fetchRating(params);
	
	              case 5:
	                response = _context4.sent;
	                success = response.success, ratting = response.ratting;
	
	                if (success && ratting && ratting.length > 0) {
	                  //TODO Change the API and fetch rating in object not array
	                  questionRating = response.ratting[0].ratting;
	
	
	                  _this.setState({
	                    questionRating: questionRating,
	                    questionRatingTitle: _messages.messages.RATED
	                  });
	                }
	                _context4.next = 13;
	                break;
	
	              case 10:
	                _context4.prev = 10;
	                _context4.t0 = _context4['catch'](2);
	
	                console.error('error handling....', _context4.t0);
	
	              case 13:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2, [[2, 10]]);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.handleQuestionRating = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(item, nextValue, prevValue, name) {
	        var questionId, question_id, _this$props4, apiServices, type, updatePayload, updateRatingResponse, fetchPayload, response, success, ratting, latestRating, savePayload, saveRatingResponse;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                questionId = _this.state.questionId;
	                question_id = item.id;
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, type = _this$props4.questionType;
	                _context5.prev = 3;
	
	                if (!(prevValue !== nextValue)) {
	                  _context5.next = 10;
	                  break;
	                }
	
	                updatePayload = { question_id: question_id, ratting: nextValue, type: type };
	                _context5.next = 8;
	                return apiServices.updateQuestionRating(updatePayload);
	
	              case 8:
	                updateRatingResponse = _context5.sent;
	
	
	                if (updateRatingResponse.success) {
	                  _this.setState({ questionRatingTitle: _messages.messages.RATED });
	                }
	
	              case 10:
	
	                _this.setState({ rating: nextValue });
	
	                // Check if a rating already exists
	                fetchPayload = { question_id: question_id, type: type };
	                _context5.next = 14;
	                return apiServices.fetchRating(fetchPayload);
	
	              case 14:
	                response = _context5.sent;
	                success = response.success, ratting = response.ratting;
	
	                if (!(success && ratting && ratting.length > 0)) {
	                  _context5.next = 21;
	                  break;
	                }
	
	                //TODO Change the API and fetch rating in object not array
	                latestRating = response.ratting[0].ratting;
	
	                _this.setState({
	                  questionRating: latestRating,
	                  questionRatingTitle: '' + _messages.messages.RATED
	                });
	                _context5.next = 26;
	                break;
	
	              case 21:
	                // Save a new rating
	                savePayload = {
	                  question_id: question_id,
	                  ratting: nextValue,
	                  type: type
	                };
	                _context5.next = 24;
	                return apiServices.saveRating(savePayload);
	
	              case 24:
	                saveRatingResponse = _context5.sent;
	
	
	                if (saveRatingResponse.success) {
	                  _this.setState({
	                    questionRatingTitle: _messages.messages.RATED,
	                    questionRating: nextValue
	                  });
	                }
	
	              case 26:
	                _context5.next = 31;
	                break;
	
	              case 28:
	                _context5.prev = 28;
	                _context5.t0 = _context5['catch'](3);
	
	                console.error('Error in handleQuestionRating:', _context5.t0);
	
	              case 31:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2, [[3, 28]]);
	      }));
	
	      return function (_x4, _x5, _x6, _x7) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        selectedAnswer1: '',
	        selectedAnswer2: '',
	        questionRating: 0,
	        selectedOptions: {},
	        isError: false,
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.redirectToNextPreviousQuestion = function (index) {
	      var _this$state2 = _this.state,
	          questionData = _this$state2.questionData,
	          isUserSubscribed = _this$state2.isUserSubscribed;
	      var _this$props5 = _this.props,
	          handleChangeParams = _this$props5.handleChangeParams,
	          params = _this$props5.params;
	      var readingid = params.readingid,
	          chapterid = params.chapterid;
	
	      var currentQuestion = questionData[index];
	      if (!currentQuestion) return;
	
	      var id = currentQuestion.id,
	          question = currentQuestion.question,
	          sortBy = currentQuestion.sortBy;
	
	
	      handleChangeParams({ index: index, question_id: id });
	      /**
	       * Navigates to a specific question by index, updates component state with the selected question's
	       * content and table (if present), and fetches saved question data and rating.
	       *
	       * Working:
	       * - Splits the question text and table HTML to allow rendering a dropdown between them.
	       * - Updates state with question content, table, and sorting options.
	       * - Triggers fetch for saved question and rating.
	       *
	       * Unable to change:
	       * - The split and state update logic must remain as is to support inserting a dropdown between the question and table.
	       *
	       * @param {number} index - The index of the question to navigate to.
	       */
	
	      var _question$split = question.split('<table'),
	          _question$split2 = _slicedToArray(_question$split, 2),
	          questionText = _question$split2[0],
	          tableContent = _question$split2[1];
	
	      var questionContent = questionText || question;
	      var questionTable = tableContent ? '<table id="myTable" border="1" cellpadding="5px" ' + tableContent : '';
	      _this.setState({
	        currentIndex: index,
	        currentQuestion: currentQuestion,
	        questionContent: questionContent,
	        questionTable: questionTable,
	        sortingOptions: sortBy && sortBy.split(',') || []
	      });
	
	      _this.getSavedQuestion(id);
	      _this.getQuestionRating(id);
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	
	              if (currentIndex > 0) {
	                _this.redirectToNextPreviousQuestion(currentIndex - 1);
	                _this.resetStates();
	                if (_this.isRevisionMode) _this.setUserSelectedChoices(currentIndex - 1);
	              }
	
	            case 2:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var _this$state3, currentIndex, questionData, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state3 = _this.state, currentIndex = _this$state3.currentIndex, questionData = _this$state3.questionData;
	              nextIndex = currentIndex + 1;
	
	              if (nextIndex < questionData.length) {
	                _this.redirectToNextPreviousQuestion(nextIndex);
	                _this.resetStates();
	                if (_this.isRevisionMode) _this.setUserSelectedChoices(nextIndex);
	              }
	
	            case 3:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.handleSelect = function (type, value) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, type, value), _defineProperty(_this$setState, 'isError', false), _this$setState));
	    };
	
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state4, selectedAnswer1, selectedAnswer2, selectedOptions, currentQuestion, _this$props6, apiServices, type, answerValue1, answerValue2, isCorrect, selectedChoice, answersKeys, isValidated, payload, _this$props$stateTabl2, stateTableName;
	
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _this$state4 = _this.state, selectedAnswer1 = _this$state4.selectedAnswer1, selectedAnswer2 = _this$state4.selectedAnswer2, selectedOptions = _this$state4.selectedOptions, currentQuestion = _this$state4.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType;
	              answerValue1 = currentQuestion[selectedAnswer1];
	              answerValue2 = currentQuestion[selectedAnswer2];
	              isCorrect = false;
	              selectedChoice = void 0;
	
	              if (!(type === _constant.QUESTION_TYPE.TABLE_QUESTION)) {
	                _context8.next = 15;
	                break;
	              }
	
	              answersKeys = {};
	
	              isCorrect = Object.keys(currentQuestion).filter(function (key) {
	                return key.startsWith('answer');
	              }).every(function (key) {
	                var optionKey = key.replace('answer', 'option');
	                return currentQuestion[key] === selectedOptions[optionKey];
	              });
	              selectedChoice = JSON.stringify(selectedOptions);
	
	              if (!(Object.keys(selectedOptions).length !== 3)) {
	                _context8.next = 13;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context8.abrupt('return');
	
	            case 13:
	              _context8.next = 21;
	              break;
	
	            case 15:
	              isCorrect = answerValue1 === currentQuestion.answer1 && answerValue2 === currentQuestion.answer2;
	              selectedChoice = JSON.stringify({ selectedAnswer1: selectedAnswer1, selectedAnswer2: selectedAnswer2 });
	              isValidated = selectedAnswer1 && selectedAnswer2;
	
	              if (isValidated) {
	                _context8.next = 21;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context8.abrupt('return');
	
	            case 21:
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context8.next = 28;
	                break;
	              }
	
	              _context8.next = 26;
	              return apiServices.saveAttemptStats(payload);
	
	            case 26:
	              _this$props$stateTabl2 = _this.props.stateTableName, stateTableName = _this$props$stateTabl2 === undefined ? 'gmat_focus_question_stat' : _this$props$stateTabl2;
	
	              _this.setState({
	                questionData: _this.state.questionData.map(function (questionDetails) {
	                  return questionDetails.id === currentQuestion.id ? Object.assign({}, questionDetails, _defineProperty({}, stateTableName, {
	                    selected_choice: selectedChoice,
	                    isSelectedChoice: isCorrect
	                  })) : questionDetails;
	                })
	              });
	
	            case 28:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this2);
	    }));
	
	    _this.renderOptionRows = function () {
	      var _this$state5 = _this.state,
	          validated = _this$state5.validated,
	          currentQuestion = _this$state5.currentQuestion;
	
	      // Dynamically get all answer keys (e.g., answer1, answer2, etc.)
	
	      var answerKeys = Object.keys(currentQuestion).filter(function (key) {
	        if (key.startsWith('answer') && Boolean(currentQuestion[key])) return true;
	      });
	
	      // Dynamically get selected answer values from state
	      var selectedAnswers = answerKeys.reduce(function (acc, answerKey) {
	        var index = answerKey.replace('answer', '');
	        acc[answerKey] = _this.state['selectedAnswer' + index];
	        return acc;
	      }, {});
	      // Get all option entries
	      var optionEntries = Object.entries(currentQuestion).filter(function (_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 1),
	            key = _ref10[0];
	
	        return key.startsWith('option');
	      });
	      return optionEntries.map(function (_ref11) {
	        var _ref12 = _slicedToArray(_ref11, 2),
	            optionKey = _ref12[0],
	            optionValue = _ref12[1];
	
	        return _react2.default.createElement(
	          'tr',
	          { key: optionKey },
	          answerKeys.map(function (answerKey, idx) {
	            var selectedKey = 'selectedAnswer' + answerKey.replace('answer', '');
	            var isCorrect = currentQuestion[answerKey] === optionValue;
	            var isSelected = selectedAnswers[answerKey] === optionKey;
	            var inputClass = validated && isSelected ? isCorrect ? 'accent-success' : 'accent-faliure' : '';
	
	            var isShowCorrectChoices = validated && isCorrect && !isSelected;
	
	            return _react2.default.createElement(
	              'td',
	              { className: 'border-solid-1 p-10px', key: optionKey + '-' + answerKey },
	              isShowCorrectChoices ? _react2.default.createElement('input', {
	                type: 'radio',
	                name: 'correct' + (idx + 1),
	                className: 'accent-success',
	                checked: true,
	                readOnly: true
	              }) : _react2.default.createElement('input', {
	                type: 'radio',
	                name: 'answer' + (idx + 1),
	                className: inputClass,
	                checked: isSelected,
	                disabled: !inputClass && validated,
	                onChange: function onChange() {
	                  return _this.handleSelect(selectedKey, optionKey);
	                }
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'td',
	            { className: 'border-solid-1 p-10px' },
	            optionValue
	          )
	        );
	      });
	    };
	
	    _this.handleChoicesSelect = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(function (prevState) {
	        return {
	          selectedOptions: Object.assign({}, prevState.selectedOptions, _defineProperty({}, name, value)),
	          isError: false
	        };
	      });
	    };
	
	    _this.renderOptionColumns = function () {
	      var _this$state6 = _this.state,
	          validated = _this$state6.validated,
	          currentQuestion = _this$state6.currentQuestion,
	          _this$state6$selected = _this$state6.selectedOptions,
	          selectedOptions = _this$state6$selected === undefined ? {} : _this$state6$selected;
	
	      // Create entries like { key: "option1", value: "yes" }
	
	      var optionEntries = Object.entries(currentQuestion).filter(function (_ref13) {
	        var _ref14 = _slicedToArray(_ref13, 1),
	            key = _ref14[0];
	
	        return key.startsWith('option');
	      }).map(function (_ref15) {
	        var _ref16 = _slicedToArray(_ref15, 2),
	            key = _ref16[0],
	            value = _ref16[1];
	
	        return { key: key, value: value };
	      });
	
	      return optionEntries.map(function (optionValue, index) {
	        var optionKey = optionValue.key; // e.g., "option1"
	        var answerKey = optionKey.replace('option', 'answer'); // maps to "answer1"
	        var correctAnswer = currentQuestion[answerKey]; // e.g., "yes"
	
	        return _react2.default.createElement(
	          'tr',
	          { key: optionKey },
	          ['yes', 'no'].map(function (choiceValue) {
	            var isSelectedChoice = selectedOptions[optionKey] === choiceValue;
	
	            // Determine class if validated
	            var validationClass = '';
	            if (validated && isSelectedChoice) {
	              validationClass = choiceValue === correctAnswer ? 'accent-success' : 'accent-faliure';
	            }
	
	            return _react2.default.createElement(
	              'td',
	              {
	                className: 'border-solid-1 p-10px ' + validationClass,
	                key: optionKey + '-' + choiceValue
	              },
	              _react2.default.createElement('input', {
	                type: 'radio',
	                name: optionKey,
	                className: 'border-solid',
	                checked: isSelectedChoice,
	                value: choiceValue,
	                disabled: !validationClass && validated,
	                onChange: _this.handleChoicesSelect
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'td',
	            { className: 'border-solid-1 p-10px' },
	            optionValue.value
	          )
	        );
	      });
	    };
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.resetTableContent = function () {
	      var currentQuestion = _this.state.currentQuestion;
	
	      _this.setState({
	        questionTable: ''
	      }, function () {
	        _this.setState({
	          questionTable: '<table id="myTable" border="1" cellpadding="5px" ' + (currentQuestion.question.split('<table') ? currentQuestion.question.split('<table')[1] : currentQuestion.question)
	        });
	        document.getElementById('table_data_select').selectedIndex = 0;
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    var _this$props$questionM = _this.props.questionMode,
	        questionMode = _this$props$questionM === undefined ? _constant.EXAM_NAMES.GMAT_FOCUS : _this$props$questionM;
	
	    _this.isRevisionMode = (0, _function.isRevisionModeActive)(questionMode);
	    return _this;
	  }
	
	  _createClass(TwoStatement, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var _props, apiServices, params, question_type, readingid, subscription, payload, response, questions, isSubscribed;
	
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _props = this.props, apiServices = _props.apiServices, params = _props.params, question_type = _props.questionType;
	                readingid = params.readingid, subscription = params.subscription;
	                payload = {
	                  reading_id: readingid,
	                  question_type: question_type,
	                  subscriptionstatus: +subscription ? _constant.SUBSCRIPTION_STATUS.PAID : _constant.SUBSCRIPTION_STATUS.FREE
	                };
	                _context9.next = 5;
	                return apiServices.fetchQuestionsReadingWise(payload);
	
	              case 5:
	                response = _context9.sent;
	
	                if (response.success) {
	                  _context9.next = 8;
	                  break;
	                }
	
	                return _context9.abrupt('return');
	
	              case 8:
	                questions = response.result || [];
	                isSubscribed = !!+subscription;
	
	                if (!isSubscribed) {
	                  questions = questions.filter(function (question) {
	                    return +question.free === 1;
	                  });
	                }
	
	                _context9.next = 13;
	                return this.handleSetCurrentQuestion(questions);
	
	              case 13:
	                this.setState({
	                  questionData: questions,
	                  isUserSubscribed: isSubscribed,
	                  isLoading: false
	                });
	
	              case 14:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidMount() {
	        return _ref17.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          questionRating = _state.questionRating,
	          questionRatingTitle = _state.questionRatingTitle,
	          showCalculator = _state.showCalculator,
	          questionContent = _state.questionContent,
	          questionTable = _state.questionTable,
	          sortingOptions = _state.sortingOptions,
	          isError = _state.isError;
	      var _props2 = this.props,
	          apiServices = _props2.apiServices,
	          params = _props2.params,
	          redirectTo = _props2.redirectTo,
	          questionType = _props2.questionType,
	          examName = _props2.examName;
	
	      // URL params expose `:readingid` (lowercase) and `:reading`; rename to the
	      // snake_case keys that the BE /reportQuestion writer expects.
	
	      var reading_id = params.readingid,
	          question_id = params.question_id,
	          type = params.type,
	          topic_name = params.reading;
	      var router = this.context.router;
	      var id = currentQuestion.id,
	          question = currentQuestion.question,
	          choice_a = currentQuestion.choice_a,
	          choice_b = currentQuestion.choice_b,
	          explanation = currentQuestion.explanation;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this3.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectTo('question');
	                } },
	              _messages.messages.CHANGE_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return redirectTo('reading');
	                } },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: topic_name + ' (Q. ' + id + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: questionData.length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= questionData.length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 12 },
	                  questionType === _constant.QUESTION_TYPE.TABLE_QUESTION ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block font-16px statement-question-div' },
	                    (0, _function.renderHTMLContent)(questionContent || question, 'div', 'text-justify'),
	                    _react2.default.createElement(_TableSort2.default, {
	                      sortOptions: sortingOptions,
	                      onSortChange: function onSortChange(value) {
	                        return (0, _function.onHandleTableSorting)(value);
	                      },
	                      onReset: this.resetTableContent
	                    }),
	                    (0, _function.renderHTMLContent)(questionTable, 'div', 'overflow-x-auto table-w-100')
	                  ) : (0, _function.renderHTMLContent)(question, 'p', 'font-16px'),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'text-center border-solid-1 margin_bottom_30' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'border-solid-1 p-10px' },
	                          choice_a
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'border-solid-1 p-10px' },
	                          choice_b
	                        ),
	                        _react2.default.createElement('th', { className: 'border-solid-1 p-10px' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      questionType === _constant.QUESTION_TYPE.TABLE_QUESTION ? this.renderOptionColumns() : this.renderOptionRows()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                isError && _react2.default.createElement(
	                  _reactstrap.Col,
	                  { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                  _messages.messages.SELECT_OPTION_ERROR
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 6, lg: 6, sm: 6, className: 'text-center mt-3 d-flex' },
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                    isQue: true,
	                    showResult: validated,
	                    _getResult: this.handleValidate,
	                    _saveQuestion: this.handleSaveQuestion,
	                    _displayReportForm: this.reportCardToggle,
	                    all_questions: questionData,
	                    save_text: saveTooltipTitle,
	                    bookmarkCSS: bookmarkCSS,
	                    bookmarkColor: bookmarkColor
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  {
	                    xs: 6,
	                    lg: 6,
	                    sm: 6,
	                    className: 'text-center mt-3 d-flex align-items-center justify-content-end'
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_bottom_0 margin_right_10' },
	                    questionRatingTitle,
	                    ':'
	                  ),
	                  _react2.default.createElement(_RatingComponent2.default, {
	                    rating: questionRating,
	                    onChange: function onChange(nextValue, prevValue, name) {
	                      return _this3.handleQuestionRating(currentQuestion, nextValue, prevValue, name);
	                    }
	                  })
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this3.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return TwoStatement;
	}(_react.Component);
	
	TwoStatement.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = TwoStatement;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _notes_icon = __webpack_require__(1039);
	
	var _notes_icon2 = _interopRequireDefault(_notes_icon);
	
	var _notes_icon3 = __webpack_require__(1040);
	
	var _notes_icon4 = _interopRequireDefault(_notes_icon3);
	
	var _free_question_icon = __webpack_require__(1041);
	
	var _free_question_icon2 = _interopRequireDefault(_free_question_icon);
	
	var _premium_question_icon = __webpack_require__(1042);
	
	var _premium_question_icon2 = _interopRequireDefault(_premium_question_icon);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _CardImageAndCount = __webpack_require__(519);
	
	var _CardImageAndCount2 = _interopRequireDefault(_CardImageAndCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChapterCard(props) {
	  var headerImage = props.headerImage,
	      chapterOrder = props.chapterOrder,
	      chapterNumber = props.chapterNumber,
	      chapterName = props.chapterName,
	      totalReadings = props.totalReadings,
	      headerImageWidth = props.headerImageWidth,
	      totalNotes = props.totalNotes,
	      premiumQuestionsCount = props.premiumQuestionsCount,
	      freeQuestionsCount = props.freeQuestionsCount,
	      callingComponent = props.callingComponent,
	      children = props.children,
	      onClick = props.onClick,
	      _props$userSubscripti = props.userSubscriptionDetails,
	      userSubscriptionDetails = _props$userSubscripti === undefined ? false : _props$userSubscripti,
	      free = props.free;
	
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    {
	      xs: '12',
	      sm: 6,
	      lg: 6,
	      xl: 4,
	      className: 'question_box free-premium-section',
	      key: chapterNumber
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'question_bank_wrap pointer_class', key: chapterNumber, onClick: onClick },
	      !userSubscriptionDetails && callingComponent === 'notes' ? free ? _react2.default.createElement(
	        'div',
	        { className: 'tag-tile free' },
	        ' ',
	        _language2.default.LC().FREE,
	        ' '
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'tag-tile premium' },
	        ' ',
	        _language2.default.LC().PREMIUM,
	        ' '
	      ) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'margin_bottom_30' },
	        _react2.default.createElement('img', {
	          src: headerImage,
	          className: '',
	          width: headerImageWidth || 40,
	          alt: ''
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'question_title', key: chapterNumber, value: chapterNumber },
	        _react2.default.createElement(
	          'a',
	          null,
	          chapterOrder || chapterNumber,
	          '. ',
	          chapterName
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { key: chapterName },
	        totalReadings && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: _notes_icon2.default,
	          count: totalReadings,
	          text: _language2.default.LC().TOTAL_READINGS,
	          width: '24'
	        }),
	        totalNotes && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: _notes_icon4.default,
	          count: totalNotes,
	          text: _language2.default.LC().TOTAL_NOTES,
	          width: '20'
	        }),
	        freeQuestionsCount !== 'undefined' && callingComponent !== 'notes' && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: _free_question_icon2.default,
	          count: freeQuestionsCount,
	          text: _language2.default.LC().FREE_QUESTIONS,
	          width: '26'
	        }),
	        premiumQuestionsCount && callingComponent !== 'notes' && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: _premium_question_icon2.default,
	          count: premiumQuestionsCount,
	          text: _language2.default.LC().PREMIUM_QUESTIONS,
	          width: '23'
	        }),
	        children
	      )
	    )
	  );
	}
	
	exports.default = ChapterCard;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReadingList = function ReadingList(_ref) {
	  var _ref$readingData = _ref.readingData,
	      readingData = _ref$readingData === undefined ? [] : _ref$readingData,
	      onViewList = _ref.onViewList,
	      onBeginChapter = _ref.onBeginChapter,
	      _ref$isViewListIcon = _ref.isViewListIcon,
	      isViewListIcon = _ref$isViewListIcon === undefined ? true : _ref$isViewListIcon,
	      _ref$tableName = _ref.tableName,
	      tableName = _ref$tableName === undefined ? '' : _ref$tableName;
	
	  return readingData.length > 0 ? _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-12' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card height_70vh' },
	        tableName && _react2.default.createElement(
	          'div',
	          { className: 'card-header' },
	          tableName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'table_responsive_wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	              'table',
	              { className: 'table_white_bg table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  { className: 'border_top_0' },
	                  _react2.default.createElement(
	                    'th',
	                    { width: '90' },
	                    '#'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    _messages.messages.READING
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    _messages.messages.ACTION
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                readingData.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: index },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      index + 1,
	                      '.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      item.reading
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      isViewListIcon && _react2.default.createElement(
	                        'span',
	                        { className: 'tooltip_wrap margin_right_20' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                          className: 'pointer_class',
	                          alt: 'View List',
	                          width: '23',
	                          onClick: function onClick() {
	                            return onViewList(item);
	                          }
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'tootip_box' },
	                          _messages.messages.VIEW_LIST
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'tooltip_wrap' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                          className: 'pointer_class',
	                          alt: '',
	                          width: '21',
	                          id: item.id,
	                          onClick: function onClick() {
	                            return onBeginChapter(item);
	                          },
	                          title: ''
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'tootip_box' },
	                          _messages.messages.BEGIN_CHAPTER
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  ) : _react2.default.createElement(
	    'h1',
	    null,
	    'No data Found'
	  );
	};
	
	exports.default = ReadingList;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TooltipItem = function (_Component) {
	  _inherits(TooltipItem, _Component);
	
	  function TooltipItem(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TooltipItem);
	
	    var _this = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this.onTooltipToggle = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.setState({ tooltipOpen: !_this.state.tooltipOpen });
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = { tooltipOpen: false };
	    return _this;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'render',
	    value: function render() {
	      var tooltipOpen = this.state.tooltipOpen;
	      var _props = this.props,
	          content = _props.content,
	          place_tip = _props.place_tip,
	          tooltipId = _props.tooltipId,
	          _props$isTooltipIcon = _props.isTooltipIcon,
	          isTooltipIcon = _props$isTooltipIcon === undefined ? true : _props$isTooltipIcon,
	          _props$width = _props.width,
	          width = _props$width === undefined ? '18' : _props$width;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        isTooltipIcon && _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + tooltipId,
	          alt: 'tooltipIcon',
	          width: width
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: place_tip,
	            isOpen: tooltipOpen,
	            target: 'Tooltip-' + tooltipId,
	            toggle: this.onTooltipToggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react.Component);
	
	exports.default = TooltipItem;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserAnsweredNotAnsweredStatus = function (_Component) {
	  _inherits(UserAnsweredNotAnsweredStatus, _Component);
	
	  function UserAnsweredNotAnsweredStatus(props) {
	    _classCallCheck(this, UserAnsweredNotAnsweredStatus);
	
	    var _this = _possibleConstructorReturn(this, (UserAnsweredNotAnsweredStatus.__proto__ || Object.getPrototypeOf(UserAnsweredNotAnsweredStatus)).call(this, props));
	
	    _this.state = { questionStatus: '' };
	    return _this;
	  }
	
	  _createClass(UserAnsweredNotAnsweredStatus, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchQuestionStatus();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          itemid = _props.itemid,
	          chapter_id = _props.chapter_id,
	          reading_id = _props.reading_id,
	          idname = _props.idname,
	          token = _props.token,
	          answered_state = _props.answered_state;
	      var prevItemid = prevProps.itemid,
	          prevChapterId = prevProps.chapter_id,
	          prevReadingId = prevProps.reading_id,
	          prevIdname = prevProps.idname,
	          prevToken = prevProps.token,
	          prevAnsweredState = prevProps.answered_state;
	
	
	      if (prevItemid !== itemid || prevChapterId !== chapter_id || prevReadingId !== reading_id || prevIdname !== idname || prevToken !== token || prevAnsweredState !== answered_state) {
	        this.fetchQuestionStatus();
	      }
	    }
	  }, {
	    key: 'fetchQuestionStatus',
	    value: function fetchQuestionStatus() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          itemid = _props2.itemid,
	          chapter_id = _props2.chapter_id,
	          reading_id = _props2.reading_id,
	          idname = _props2.idname,
	          token = _props2.token,
	          readingDetails = _props2.readingDetails,
	          examRoute = _props2.examRoute;
	
	      var data = {
	        itemid: itemid,
	        chapter_id: chapter_id,
	        reading_id: reading_id,
	        idname: idname,
	        token: token,
	        type: readingDetails && readingDetails.type
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + examRoute + '/getQuestionsByuser', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.success === 'success') {
	            _this2.setState({ questionStatus: 'Answered' });
	          } else {
	            _this2.setState({ questionStatus: 'Not Answered' });
	          }
	        } else {
	          _this2.setState({ questionStatus: resp.success });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var questionStatus = this.state.questionStatus;
	
	      var statusId = questionStatus === 'Answered' ? 'answered_status' : 'Not Answered';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: statusId },
	          questionStatus
	        )
	      );
	    }
	  }]);
	
	  return UserAnsweredNotAnsweredStatus;
	}(_react.Component);
	
	exports.default = UserAnsweredNotAnsweredStatus;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.connectSocket = connectSocket;
	exports.getSocket = getSocket;
	exports.disconnectSocket = disconnectSocket;
	
	var _socket = __webpack_require__(1227);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socket = null;
	
	function connectSocket(token) {
	    if (socket) {
	        return socket;
	    }
	
	    console.log('===>> Connecting socket...');
	
	    var apiEndpoint = _App_data2.default.backend_api;
	    var mainApiEndpointHost = apiEndpoint.replace(/\/api$/, '');
	
	    socket = (0, _socket2.default)(mainApiEndpointHost, {
	        path: '/socket.io',
	        transports: ['websocket'],
	        query: {
	            token: token
	        },
	        reconnection: true,
	        forceNew: false
	    });
	
	    socket.on('connect', function () {
	        console.log('Socket connected:', socket.id);
	    });
	
	    socket.on('disconnect', function (reason) {
	        console.log('Socket disconnected:', reason);
	    });
	
	    socket.on('connect_error', function (err) {
	        console.error('------ Socket connect error:', err && err.message ? err.message : err);
	    });
	
	    return socket;
	}
	
	function getSocket() {
	    return socket;
	}
	
	function disconnectSocket() {
	    if (socket) {
	        socket.disconnect();
	        socket = null;
	    }
	}

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ApiService2 = __webpack_require__(550);
	
	var _ApiService3 = _interopRequireDefault(_ApiService2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebinarRESTService = function (_ApiService) {
	    _inherits(WebinarRESTService, _ApiService);
	
	    function WebinarRESTService() {
	        _classCallCheck(this, WebinarRESTService);
	
	        var _this = _possibleConstructorReturn(this, (WebinarRESTService.__proto__ || Object.getPrototypeOf(WebinarRESTService)).call(this));
	
	        _this.endpoint = 'v1/wbi';
	        return _this;
	    }
	
	    _createClass(WebinarRESTService, [{
	        key: 'getWebinarsList',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                var query;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                query = {};
	
	                                if (dto.page != null) query.page = dto.page;
	                                if (dto.perPage != null) query.perPage = dto.perPage;
	                                if (dto.type != null) query.type = dto.type;
	                                if (dto.eligibilityLevel != null) query.eligibilityLevel = dto.eligibilityLevel;
	                                if (dto.exam != null) query.exam = dto.exam;
	                                if (dto.tags != null && dto.tags.length > 0) query.tags = dto.tags.join(',');
	                                if (dto.region != null) query.region = dto.region;
	                                _context.next = 10;
	                                return this.get(this.endpoint + '/webinars', query);
	
	                            case 10:
	                                return _context.abrupt('return', _context.sent);
	
	                            case 11:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getWebinarsList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getWebinarsList;
	        }()
	    }, {
	        key: 'getWebinarItem',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.get(this.endpoint + '/webinars/' + id);
	
	                            case 2:
	                                return _context2.abrupt('return', _context2.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function getWebinarItem(_x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return getWebinarItem;
	        }()
	    }, {
	        key: 'createRegistration',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(payload) {
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.post(this.endpoint + '/register', payload);
	
	                            case 2:
	                                return _context3.abrupt('return', _context3.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function createRegistration(_x3) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return createRegistration;
	        }()
	    }, {
	        key: 'cancelRegistration',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(payload) {
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return this.post(this.endpoint + '/register/cancel', payload);
	
	                            case 2:
	                                return _context4.abrupt('return', _context4.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function cancelRegistration(_x4) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return cancelRegistration;
	        }()
	    }, {
	        key: 'getFIlters',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return this.get(this.endpoint + '/filters');
	
	                            case 2:
	                                return _context5.abrupt('return', _context5.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function getFIlters() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return getFIlters;
	        }()
	    }, {
	        key: 'getWebinarsCountByExam',
	        value: function () {
	            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _context6.next = 2;
	                                return this.get(this.endpoint + '/webinars/count-by-exam');
	
	                            case 2:
	                                return _context6.abrupt('return', _context6.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function getWebinarsCountByExam() {
	                return _ref6.apply(this, arguments);
	            }
	
	            return getWebinarsCountByExam;
	        }()
	
	        // async test(data){
	        //     return await this.post(`${this.endpoint}/test/post` , data);
	        // }
	
	    }]);
	
	    return WebinarRESTService;
	}(_ApiService3.default);
	
	exports.default = WebinarRESTService;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.apiServices = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var session = JSON.parse(localStorage.getItem('localstorageval')) || {};
	var token = session.token,
	    idname = session.idname;
	
	var payload = {
	  token: token,
	  idname: idname
	};
	var fetchQuestionsReadingWise = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getSpecialQuestionByReadingId', Object.assign({}, payload, data));
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchQuestionsReadingWise(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var saveAttemptStats = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveStats', Object.assign({}, payload, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function saveAttemptStats(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var fetchSavedQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavQuestions', Object.assign({}, payload, data));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function saveQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/unsaveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var saveReport = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/reportQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveReport(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var saveRating = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveEARatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function saveRating(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var fetchRating = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function fetchRating(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var updateQuestionRating = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/UpdateEARatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function updateQuestionRating(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var apiServices = exports.apiServices = {
	  saveAttemptStats: saveAttemptStats,
	  fetchQuestionsReadingWise: fetchQuestionsReadingWise,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  saveReport: saveReport,
	  saveRating: saveRating,
	  fetchRating: fetchRating,
	  updateQuestionRating: updateQuestionRating
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.apiServices = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable */
	
	
	var session = JSON.parse(localStorage.getItem('localstorageval')) || {};
	var token = session.token,
	    idname = session.idname;
	
	var payload = {
	  token: token,
	  idname: idname
	};
	var fetchQuestionsReadingWise = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getSpecialQuestionByReadingId', Object.assign({}, payload, data));
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchQuestionsReadingWise(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var saveAttemptStats = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveStats', Object.assign({}, payload, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function saveAttemptStats(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var fetchSavedQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavQuestions', Object.assign({}, payload, data));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function saveQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/unsaveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var saveReport = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/reportQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveReport(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var saveRating = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveGMATRatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function saveRating(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var fetchRating = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function fetchRating(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var updateQuestionRating = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/UpdateGMATRatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function updateQuestionRating(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var apiServices = exports.apiServices = {
	  saveAttemptStats: saveAttemptStats,
	  fetchQuestionsReadingWise: fetchQuestionsReadingWise,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  saveReport: saveReport,
	  saveRating: saveRating,
	  fetchRating: fetchRating,
	  updateQuestionRating: updateQuestionRating
	};

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	var checkCfa1Subscription = function checkCfa1Subscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  // console.log("selectedLevel", selectedLevel);
	  // console.log("exam_data", exam_data);
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            // Mock packages grant ONLY mock exams. This variant had no mock
	            // guard at all, so a non-partner user holding just pkg 65/66 was
	            // granted quiz access — the mirror of the partner-side bug.
	            if (exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	var checkCfa1NotesSubscription = function checkCfa1NotesSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  // console.log("selectedLevel", selectedLevel);
	  // console.log("exam_data", exam_data);
	
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        // console.log("worjjjjjjj");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	            // console.log("work");
	
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	var checkCfa1VideosSubscription = function checkCfa1VideosSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  // console.log("selectedLevel", selectedLevel);
	  // console.log("exam_data", exam_data);
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          // console.log('for-ELSE working');
	          flag = true;
	        }
	        break;
	      } else {
	        // console.log("worjjjjjjj");
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	var checkCfa1PDFSubscription = function checkCfa1PDFSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, type) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	              if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                flag = true;
	              } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                flag = true;
	              }
	              // break;/
	            } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	              // console.log("work");
	
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        // console.log("worjjjjjjj");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	            // console.log("work");
	
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	exports.checkCfa1Subscription = checkCfa1Subscription;
	exports.checkCfa1NotesSubscription = checkCfa1NotesSubscription;
	exports.checkCfa1VideosSubscription = checkCfa1VideosSubscription;
	exports.checkCfa1PDFSubscription = checkCfa1PDFSubscription;

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable*/
	/*
	------------------------------------------------
	  Check for Quizzes, Mock exams and Questions
	------------------------------------------------
	*/
	var checkCfa1Subscription = function checkCfa1Subscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, examPlanData) {
	  var flag = false;
	  // `examPlanData` is no longer consulted. It was `resp_exam.examPlan[0]` — an
	  // ARBITRARY plan, since that query has no ORDER BY, so it is effectively the
	  // user's lowest owned plan id. A user owning a mock package (65/66) plus a
	  // real one was denied whenever the mock sorted first. Mock entitlements are
	  // now excluded per level below, which is both correct and order-independent.
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            // Mock packages grant ONLY mock exams — never quizzes, questions,
	            // notes or videos. See subscription-dataflow.md § "Mock packages".
	            if (exam_data[i].levels[j].package_category === 'mock') continue;
	            if (exam_data[i].levels[j].isActive) {
	              flag = true;
	              break;
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        // console.log("worjjjjjjj");
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	            // console.log("work");
	
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	/*
	---------------------------
	   Check for Notes 
	---------------------------
	*/
	var checkCfa1NotesSubscription = function checkCfa1NotesSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -----------------------
	                 for partner users
	              -----------------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — mirror non-partner: pkg 16 is L1's matching-exam unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              ------------------
	                 for app users
	              ------------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].noteStatus !== false) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true; //for old user
	        }
	        break;
	      } else {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	------------------------
	  Check for videos
	-----------------------
	*/
	var checkCfa1VideosSubscription = function checkCfa1VideosSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -----------------
	                For Partner
	              -----------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — mirror non-partner: pkg 16 is L1's matching-exam unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              -------------
	                For App
	              -------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive && exam_data[i].levels[j].videoStatus !== false) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	              flag = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	/*
	-----------------------
	  Check for PDF's
	----------------------
	*/
	var checkCfa1PDFSubscription = function checkCfa1PDFSubscription(selectedLevel, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam, type) {
	  var flag = false;
	  if (cfaUnlimitedPackage === true || cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam) {
	    if (selectedLevel === cfaUnlimitedActiveExam) {
	      return flag = true;
	    }
	  } else {
	    for (var i = 0; i < exam_data.length; i++) {
	      if (exam_data[i].exam_name === selectedLevel) {
	        if (exam_data[i].levels.length) {
	          for (var j = 0; j < exam_data[i].levels.length; j++) {
	            if (exam_data[i].levels[j].partner) {
	              /*
	              -------------
	                For Partner
	              -------------
	              */
	
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                  flag = true;
	                }
	              } else if (
	              // #261 — mirror non-partner: pkg 16 is L1's matching-exam unlimited.
	              exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            } else {
	              /*
	              -------------
	                For App
	              -------------
	              */
	              if (exam_data[i].levels[j].package_val === 'expensive' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              } else if (exam_data[i].levels[j].package_val === 'simple' && exam_data[i].levels[j].isActive) {
	                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
	                  flag = true;
	                } else if (exam_data[i].levels[j].noteStatus && type === 'notes') {
	                  flag = true;
	                }
	              } else if (exam_data[i].levels[j].package_val === 'unlimited' && exam_data[i].levels[j].package_id === 16) {
	                flag = true;
	                break;
	              } else if (
	              // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
	              exam_data[i].levels[j].package_val === 'plus' && exam_data[i].levels[j].isActive) {
	                flag = true;
	                break;
	              }
	            }
	          }
	        } else {
	          flag = true;
	        }
	        break;
	      } else {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_val === 'unlimited' && (exam_data[i].levels[j].package_id === 18 || exam_data[i].levels[j].package_id === 19 || exam_data[i].levels[j].package_id === 39 || exam_data[i].levels[j].package_id === 20)) {
	            flag = true;
	            break;
	          }
	        }
	      }
	    }
	    return flag;
	  }
	};
	
	exports.checkCfa1Subscription = checkCfa1Subscription;
	exports.checkCfa1NotesSubscription = checkCfa1NotesSubscription;
	exports.checkCfa1VideosSubscription = checkCfa1VideosSubscription;
	exports.checkCfa1PDFSubscription = checkCfa1PDFSubscription;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _isomorphicFetch = __webpack_require__(199);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// * snip 
	
	var getApiPostCall = function sendRequest(url, data, done) {
	    // console.log(data);
	    return (0, _isomorphicFetch2.default)(url, {
	        method: 'GET'
	        // mode: 'CORS',
	    }).then(function (resp) {
	        // console.log(resp);
	        return resp.json();
	    });
	};
	
	exports.GetCallAPI = getApiPostCall;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 146 */
/***/ function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ },
/* 147 */
[1262, 987],
/* 148 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 149 */
79,
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}});f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});
	
	//# sourceMappingURL=FileSaver.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var EventPluginRegistry = __webpack_require__(205);
	var ReactEventEmitterMixin = __webpack_require__(1102);
	var ViewportMetrics = __webpack_require__(452);
	
	var getVendorPrefixedEventName = __webpack_require__(1134);
	var isEventSupported = __webpack_require__(216);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(127);
	var ViewportMetrics = __webpack_require__(452);
	
	var getEventModifierState = __webpack_require__(214);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var DOMNamespaces = __webpack_require__(204);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(212);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(88);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementContextTypes = exports.injectContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(163);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectContextTypes = exports.injectContextTypes = {
	  getRegisteredElements: _propTypes2.default.func.isRequired,
	  elements: _propTypes2.default.object
	};
	
	var elementContextTypes = exports.elementContextTypes = {
	  addElementsLoadListener: _propTypes2.default.func.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this._elements = null;
	
	    _this.handleRegisterElement = function (element, impliedTokenType, impliedSourceType, impliedPaymentMethodType) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [_extends({
	            element: element
	          }, impliedTokenType ? { impliedTokenType: impliedTokenType } : {}, impliedSourceType ? { impliedSourceType: impliedSourceType } : {}, impliedPaymentMethodType ? { impliedPaymentMethodType: impliedPaymentMethodType } : {})])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    var _this$props = _this.props,
	        children = _this$props.children,
	        options = _objectWithoutProperties(_this$props, ['children']);
	
	    if (_this.context.tag === 'sync') {
	      _this._elements = _this.context.stripe.elements(options);
	    }
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  Elements.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      addElementsLoadListener: function addElementsLoadListener(fn) {
	        // Return the existing elements instance if we already have one.
	        if (_this2.context.tag === 'sync') {
	          // This is impossible, but we need to make flow happy.
	          if (!_this2._elements) {
	            throw new Error('Expected elements to be instantiated but it was not.');
	          }
	
	          fn(_this2._elements);
	        } else {
	          _this2.context.addStripeLoadListener(function (stripe) {
	            if (_this2._elements) {
	              fn(_this2._elements);
	            } else {
	              var _props = _this2.props,
	                  _children = _props.children,
	                  options = _objectWithoutProperties(_props, ['children']);
	
	              _this2._elements = stripe.elements(options);
	              fn(_this2._elements);
	            }
	          });
	        }
	      },
	      registerElement: this.handleRegisterElement,
	      unregisterElement: this.handleUnregisterElement,
	      getRegisteredElements: function getRegisteredElements() {
	        return _this2.state.registeredElements;
	      },
	      elements: this._elements
	    };
	  };
	
	  Elements.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
	Elements.contextTypes = _Provider.providerContextTypes;
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1204)();
	}


/***/ },
/* 164 */
[1262, 1229],
/* 165 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXoAAABICAMAAADPu86wAAAAk1BMVEVMaXEOGScOGScApOAVodwApOAVodwVodwOGScOGScOGScVodwVodwOGScOGScOGScOGScOGScOGScVodwApOAVodwVodwVodwVodwVodwOGScVodwOGScVodwOGScOGScVodwVodwApOAApOAApOAApOAApOAApOAApOAApOAApOAApOAApOAApOAOGScVodwApODEcDpDAAAALnRSTlMAvxC/gIBAv4BA7+8wMJ9g388gr0DfEGDPj4+fcCBQr3BQ7xDfMCDPj2CfcK9Qh2ha1QAACGJJREFUeNrtm4mWoroWQA8URZgEBEEUxxp7uhz//+teBmM0Aaqr+1rlrZe9VpcYQpa9E08OCYLFYrFYLBaLxWKxWCwWi8VisVjepAjDcAKWTyBMnY4y3QYbFywfTZGlEfe/tOP/EwiF/XxZgOWjcbO8Yzgh3CCzGXxpskjIv8G4c38PXxt32XGWNzflfnn1AKEY+PkEBnFDijt61mz2ArfnIkVx8+rnng//BsUmcPIuOFmYdpwMesm2UceJtqte/fzyQDffSeTFl80H3QXOyr2q+gQxgb+AoAcMHwU+/AGbZU5FpBuQjLvnM7Eidc0GhVpXV2+Qh6Z6RbS6pvoWsf1c9ROeUE41x8Pui6lhqAANp+OsDPUmWY96RXo99WuMY1yzwEEWXhy3NQAhc4LNnhfNY1qlrbD0wSctQE1IDX6D8aIGqNs4XpypB07CquyIB75HiLfmzSzi2EsIVnswCJ2hVNKNOs5G66moM5jovSnHtKneJOxRr1heTb2HXoseP0AkiAQAEasK0adFMSKsY6waxH3NumiOBBLEpsISgPArlHqfQlUvsFxjXEOLFPrqISdm//rFRxkoDFOR22t+mgbBNtcNC1IpbmM2mAdH0lzrH6HeCTjLqezWa6mnPqknoT4RgR+Z1hJLVlT60GLJdMb0YEeL5/xUHWPCKydKPUW8abDCPUCSwLrBOevBmtYn4OvhyN1qsbrfYAoKNz+WFTJa9cQkV82Ul+q1ok106h+lPtACW3ol9XOsPC/GOVNPjpEb0ecmuTOAmPtCprqpMWaHpedVuDteodQTylzM3CUraUnJzrJ6opqmfhNpQ16n6AQFnBAZf7SBE5OpNpvK0avGrKFeFTCWmnpttrmS+gY5Ta96UYRSPVToYcv6ouKSDfVAkb3AOiBeeJWh3rA4gWG2erwteoKAa7QQ8TqpPmZN9bCVJYZ6lSeFI+q/3Ume4Vkc/Lh/Acr3u7sZcF7u7r6BgY+VR4nR7w84BNgRmzaxAvonxgREBEpqMAKOz6ihrrDBHXjsxGJYfWqYN8k6zlS7aAWjZMKnGNLuqPpgVD28qf7uIJnB7CD5zmoeDk+nOndg0ApvC2z7plmhXk6zADViIwoago0xzQp8KNGjVZI9xl6Lg+rTnvE7ex7IVC7Hcw7jTEXOKF6DK6t/kKOeqX+lB0+sH7j6A6/889CnviZkDZQ1ITUVtBDJJeKukcklP9vGccmdeWQvChBJIpJLb0HmMqfkJAkpxaVejCU9K5rh1Qi7SrAyEu/HH/QzPmj/NS3L2AzdZZl5jBz9kaHeyP+3Q+rdt9Urq0z9jIeaw+EXU095Bnh50NTryFgPMrhfmYmRgDy+Hjh3fepD5YbiwijpSWAkO2p8ml1p6rU8v3ineniihUL9Kw83Dzel3pFKT9yrQDk86rcq8nM2gWSizcTuSd30zeSyGFA/keHtfeofD0f13w6Hn//QF1bpZgjNrPtBqr/rSdAveszRLHO2l4lTagQM85Zqmcv8qVe9G0RaTBybZu9P6mev1DhX//h0eHg4PD3elPqtuTxzOKGtglGmA+pTpd65XH6YnFXYji8kTN1L9bnDmXaC3P199ZLXR65elMzgptR3ArdP/QMoltpk7OiWTfWZfKemlGJMveOOLp9FExhX/3TPmSn1D/ePINTDNxpu4KbUy8UZOONVqv8Fiki7m00vgu+m61Gf8xgSHhHvhtXnGcCY+pyaf0es/zmbPbFxLtU/Pj098kpX3y1Ze96fhnr4R92bgJaBLgdTDnPy3HQmkTukPgUYUx8F7Mr3TbPPBxrdpXp4foYB9T5S4nYNoyCj9EeX7GVzf6wevukJjgwouasngyPqna6H1XnNacg4rh8Vw+qdNHMB3qleOP8l1VOG1XOqely9IBkf9e9Xn8MFsx90AeTZnIwnegTK3UH1RddH3lNzoyZwPcNRvF+9CJ3ff0s9QBLjPCEkqfzTJsiC7FqsvLNEv26wpcXzBaGqCT3HtkN2AD7hxQD7Bpsda65exNj4AMcmJaPrAwpzDGbmMvKyT706b7LRaqqqwb+tnt+/Prz8jnoRMOhBjP75JkjcIHpKPb/lIhgjgQUioXbBx4qvAvGA44uFHwQoMSaICYgmoZdIGhkhU+YVhVaoCXVFzwRnTPlZvaZa+Q/fq/7vUcuNO/YHsdnXchMECItBO4yl+p2/j7lj9JI187qOcQcVPYhxzdWXYrkTxXqmR9+JJt/YA9HRp9gohEvMJ3RCIVe5y3uCW6GpV2dy97PUc1reB2oThMtUKwrIaWogSAB27A+Xu8PFHktzf8XzWoxFkwOEWmJv4IrOcQoY2CzPV/xUkTnnU3aufyVkWaqrVxFt+2nqCWnnQpraBDHUN6Tc1SCKvZP6NVYtzjX1O0TCGJ9zHS1t1JhMzUcxzF1xx9GSmEymkubXx+1RD6Ibs89Srw7UJogRcPyzLDJB3ENd4ZyH9RjgMuDweAQ+jKsvjgInI8/9Ld2hbjFZKZXL3gcbAqVe/xTR5PPVq00QNc2a6k/TLMAecQGgTbMLjEmF+3H1kJkrJBfLVtGyGAlGGk7Rt2yg3QIr9fqnmLqfoD4hRB2cbYIQXJSn5FLtcBy3ReYNNl4NlJJvtcjkksx5K/MKY080OcJKLV6Zz0NtMxdGCLfdGWl46jTKpv8bFp2C1dZIJ6Pi/DOtPkT96P3ptQlM95PVlIowvZu4WepMWbRfbvTK//EnjT9CPWS6+3zqBNkNPlR/q08a/wWTXOTuN/n7ka+tHtyg46Q39xOGIV5e4KtQpMfV2f+M/C+Elf+JuCyv4Rmltf/xFCuRqTtBaPV/PJMs4IsykWN/rmyxWCwWi8VisVgsFovFYrH8X/I/AGn6b8r7h8wAAAAASUVORK5CYII="

/***/ },
/* 166 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Configurations for different question types
	
	var graphicalStatementConfig = exports.graphicalStatementConfig = {
	  extractExtraState: function extractExtraState(selectedOptions) {
	    var statement1 = selectedOptions.statement1,
	        statement2 = selectedOptions.statement2;
	
	    return { statement1: statement1, statement2: statement2 };
	  },
	  getCorrectOptions: function getCorrectOptions(question) {
	    return {
	      statement1: question.answer_statement1.replace(/^&/, ''),
	      statement2: question.answer_statement2.replace(/^&/, '')
	    };
	  },
	  getWrongOptions: function getWrongOptions(question) {
	    var getWrongOption = function getWrongOption(options, correctValue) {
	      return options.find(function (opt) {
	        return opt && opt !== correctValue;
	      }) || '';
	    };
	    var statement1Options = Array.from({ length: 5 }, function (_, index) {
	      return question['statement1_option' + (index + 1)];
	    });
	    var statement2Options = Array.from({ length: 5 }, function (_, index) {
	      return question['statement2_option' + (index + 1)];
	    });
	    return {
	      statement1: getWrongOption(statement1Options, question.answer_statement1).replace(/^&/, ''),
	      statement2: getWrongOption(statement2Options, question.answer_statement2).replace(/^&/, '')
	    };
	  }
	};
	
	var multiSourceConfig = exports.multiSourceConfig = {
	  extractExtraState: function extractExtraState(selectedOptions) {
	    return { selectedOptions: selectedOptions };
	  },
	  getCorrectOptions: function getCorrectOptions(questionDetails) {
	    var isSingleChoice = questionDetails.is_single_choice;
	    if (isSingleChoice) {
	      var yesAnswers = Object.keys(questionDetails).filter(function (key) {
	        return key.startsWith('answer_') && questionDetails[key].trim().toLowerCase() === 'yes';
	      });
	      return yesAnswers.reduce(function (obj, key) {
	        obj[key] = 'yes';
	        return obj;
	      }, {});
	    } else {
	      return Object.keys(questionDetails).reduce(function (obj, key) {
	        if (key.startsWith('answer_')) {
	          obj[key] = questionDetails[key].trim().toLowerCase();
	        }
	        return obj;
	      }, {});
	    }
	  },
	  getWrongOptions: function getWrongOptions(questionDetails) {
	    var isSingleChoice = questionDetails.is_single_choice;
	    if (isSingleChoice) {
	      var allAnswerKeys = Object.keys(questionDetails).filter(function (key) {
	        return key.startsWith('answer_');
	      });
	      var randomKey = allAnswerKeys[Math.floor(Math.random() * allAnswerKeys.length)];
	      return _defineProperty({}, randomKey, 'yes');
	    } else {
	      return Object.keys(questionDetails).reduce(function (obj, key) {
	        if (key.startsWith('answer_') && questionDetails[key] && questionDetails[key].trim() !== '') {
	          var value = questionDetails[key].trim().toLowerCase();
	          obj[key] = value === 'yes' ? 'no' : 'yes';
	        }
	        return obj;
	      }, {});
	    }
	  }
	};
	
	var twoStatementConfig = exports.twoStatementConfig = {
	  extractExtraState: function extractExtraState(selectedOptions) {
	    return { selectedOptions: selectedOptions };
	  },
	  getCorrectOptions: function getCorrectOptions(question) {
	    var selectedAnswer1 = '';
	    var selectedAnswer2 = '';
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = Object.keys(question)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (question[key] === question.answer1) selectedAnswer1 = key;
	        if (question[key] === question.answer2) selectedAnswer2 = key;
	        if (selectedAnswer1 && selectedAnswer2) break;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      selectedAnswer1: selectedAnswer1,
	      selectedAnswer2: selectedAnswer2
	    };
	  },
	  getWrongOptions: function getWrongOptions(question) {
	    var wrongOptionKeys = Object.keys(question).filter(function (key) {
	      return key.startsWith('option');
	    }).filter(function (key) {
	      return question[key] !== question.answer1 && question[key] !== question.answer2;
	    }).slice(0, 2); // Get the first 2 wrong option KEYS
	
	    return {
	      selectedAnswer1: wrongOptionKeys[0],
	      selectedAnswer2: wrongOptionKeys[1]
	    };
	  }
	};
	
	var tableAnalysisTwoPartConfig = exports.tableAnalysisTwoPartConfig = {
	  extractExtraState: function extractExtraState(selectedOptions) {
	    return { selectedOptions: selectedOptions };
	  },
	  getCorrectOptions: function getCorrectOptions(question) {
	    var options = {};
	    Object.keys(question).filter(function (key) {
	      return key.startsWith('answer');
	    }).forEach(function (key) {
	      var value = question[key];
	      if (value && value.trim() !== '') {
	        var optionKey = key.replace('answer', 'option');
	        options[optionKey] = value.trim().toLowerCase();
	      }
	    });
	    return options;
	  },
	  getWrongOptions: function getWrongOptions(question) {
	    var options = {};
	    Object.keys(question).filter(function (key) {
	      return key.startsWith('answer');
	    }).forEach(function (key) {
	      var value = question[key];
	      if (value && value.trim() !== '') {
	        var optionKey = key.replace('answer', 'option');
	        options[optionKey] = value.trim().toLowerCase() === 'yes' ? 'no' : 'yes';
	      }
	    });
	    return options;
	  }
	};

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserSelectedChoices = getUserSelectedChoices;
	// Utility for handling user selected choices logic across different question types
	
	/**
	 * Get user selected choices for a question, handling correct/incorrect/random logic.
	 * @param {Object} params
	 * @param {Object} params.question - The question object
	 * @param {Object} params.stat - The statistics/state object for the question
	 * @param {Object} params.config - Config object for question type specifics
	 * @returns {Object} { selectedOptions, extraState } - State to set in the component
	 */
	function getUserSelectedChoices(_ref) {
	  var question = _ref.question,
	      stat = _ref.stat,
	      _ref$config = _ref.config,
	      config = _ref$config === undefined ? {} : _ref$config;
	
	  try {
	    // 1. If user has selected choices, parse and return
	    if (stat && stat.selected_choice) {
	      var selected_choice = stat.selected_choice;
	
	      var selectedOptions = JSON.parse(selected_choice);
	      var extractExtraState = config.extractExtraState;
	
	      return {
	        selectedOptions: selectedOptions,
	        extraState: typeof extractExtraState === 'function' ? extractExtraState(selectedOptions) : {}
	      };
	    }
	
	    // 2. If correct answer to be filled in
	    if (stat && stat.isSelectedChoice === 1) {
	      var getCorrectOptions = config.getCorrectOptions,
	          _extractExtraState = config.extractExtraState;
	
	      if (getCorrectOptions) {
	        var _selectedOptions = getCorrectOptions(question);
	        return {
	          selectedOptions: _selectedOptions,
	          extraState: typeof _extractExtraState === 'function' ? _extractExtraState(_selectedOptions) : {}
	        };
	      }
	    }
	
	    // 3. If incorrect answer to be filled randomly
	    if (stat && stat.isSelectedChoice === 0) {
	      var getWrongOptions = config.getWrongOptions,
	          _extractExtraState2 = config.extractExtraState;
	
	      if (getWrongOptions) {
	        var _selectedOptions2 = getWrongOptions(question);
	        return {
	          selectedOptions: _selectedOptions2,
	          extraState: typeof _extractExtraState2 === 'function' ? _extractExtraState2(_selectedOptions2) : {}
	        };
	      }
	    }
	  } catch (err) {}
	  // Swallow error silently to avoid linter issues
	
	  // Default: return empty
	  return { selectedOptions: {}, extraState: {} };
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReportQuestion(_ref) {
	  var onClick = _ref.onClick,
	      className = _ref.className,
	      _ref$reportTooltipTex = _ref.reportTooltipText,
	      reportTooltipText = _ref$reportTooltipTex === undefined ? _language2.default.LC().REPORT_THIS_QUESTION : _ref$reportTooltipTex;
	
	  return _react2.default.createElement(
	    'span',
	    { className: (className || '') + ' up tooltip-hover-questions' },
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      ' ',
	      reportTooltipText,
	      ' '
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'report-icon-wrapper', onClick: onClick },
	      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/report4.png', alt: 'report' })
	    )
	  );
	}
	
	exports.default = ReportQuestion;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaveQuestion = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveQuestion = exports.SaveQuestion = function (_Component) {
	  _inherits(SaveQuestion, _Component);
	
	  function SaveQuestion(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SaveQuestion);
	
	    var _this = _possibleConstructorReturn(this, (SaveQuestion.__proto__ || Object.getPrototypeOf(SaveQuestion)).call(this, props));
	
	    _this.setIconColor = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(func, isContentSaved) {
	        var _this$props, favItemId, onSaveItemChange, _this$props$savePayLo, savePayLoad, data, response, setChildRef;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, favItemId = _this$props.favItemId, onSaveItemChange = _this$props.onSaveItemChange, _this$props$savePayLo = _this$props.savePayLoad, savePayLoad = _this$props$savePayLo === undefined ? {} : _this$props$savePayLo;
	                data = {};
	
	                if (!Object.keys(savePayLoad).length) {
	                  data = { favItemId: favItemId };
	                } else {
	                  data = savePayLoad;
	                }
	                _context.next = 5;
	                return func(data);
	
	              case 5:
	                response = _context.sent;
	
	                if (response.success) {
	                  onSaveItemChange(!isContentSaved);
	                  if (!isContentSaved) {
	                    setChildRef = _this.props.setChildRef;
	
	                    if (setChildRef) {
	                      setChildRef.deleteFlash();
	                    }
	                  }
	                  _this.setState({ isContentSaved: isContentSaved });
	                } else {
	                  onSaveItemChange(true);
	                }
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.setIconOnUnSave = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(func) {
	        var _this$props2, favItemId, onSaveItemChange, data, response;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, favItemId = _this$props2.favItemId, onSaveItemChange = _this$props2.onSaveItemChange;
	                data = {
	                  favItemId: favItemId
	                };
	                _context2.next = 4;
	                return func(data);
	
	              case 4:
	                response = _context2.sent;
	
	                if (response.success) {
	                  onSaveItemChange(false);
	                  _this.setState({ isContentSaved: true });
	                } else {
	                  onSaveItemChange(true);
	                }
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$props3, apiServiceProvider, favItemId, onSaveItemChange, _this$props3$savePayL, savePayLoad, data, result;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$props3 = _this.props, apiServiceProvider = _this$props3.apiServiceProvider, favItemId = _this$props3.favItemId, onSaveItemChange = _this$props3.onSaveItemChange, _this$props3$savePayL = _this$props3.savePayLoad, savePayLoad = _this$props3$savePayL === undefined ? {} : _this$props3$savePayL;
	              data = {};
	
	              if (!Object.keys(savePayLoad).length) {
	                data = { favItemId: favItemId };
	              } else {
	                data = savePayLoad;
	              }
	              _context3.next = 5;
	              return apiServiceProvider['fetchSavedQuestion'](data);
	
	            case 5:
	              result = _context3.sent;
	
	              if (result.success) {
	                onSaveItemChange(false);
	                _this.setState({ isContentSaved: true });
	              } else {
	                onSaveItemChange(true);
	              }
	
	            case 7:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.componentDidUpdate = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(previousProps) {
	        var _this$props4, apiServiceProvider, favItemId, onSaveItemChange, savePayLoad, data, result;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(previousProps.favItemId !== _this.props.favItemId)) {
	                  _context4.next = 9;
	                  break;
	                }
	
	                _this$props4 = _this.props, apiServiceProvider = _this$props4.apiServiceProvider, favItemId = _this$props4.favItemId, onSaveItemChange = _this$props4.onSaveItemChange, savePayLoad = _this$props4.savePayLoad;
	                data = {};
	
	                if (!Object.keys(savePayLoad).length) {
	                  data = { favItemId: favItemId };
	                } else {
	                  data = Object.assign({}, savePayLoad);
	                }
	                _this.setState({ isContentSaved: false });
	                _context4.next = 7;
	                return apiServiceProvider['fetchSavedQuestion'](data);
	
	              case 7:
	                result = _context4.sent;
	
	                if (result.success) {
	                  onSaveItemChange(false);
	                  _this.setState({ isContentSaved: true });
	                } else {
	                  onSaveItemChange(true);
	                }
	
	              case 9:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      isContentSaved: false
	    };
	    return _this;
	  }
	
	  _createClass(SaveQuestion, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var isContentSaved = this.state.isContentSaved;
	      var apiServiceProvider = this.props.apiServiceProvider;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'up tooltip-hover-questions', style: { marginRight: '10px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'tootip_box' },
	          ' ',
	          _language2.default.LC().SAVE_QUESTION,
	          ' '
	        ),
	        _react2.default.createElement('i', {
	          className: '' + (isContentSaved ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark'),
	          onClick: function onClick() {
	            return isContentSaved ? _this3.setIconColor(apiServiceProvider['deleteSavedQuestion'], false) : _this3.setIconColor(apiServiceProvider['saveQuestion'], true);
	          },
	          style: { color: isContentSaved ? 'rgb(54, 141, 84)' : '' }
	        })
	      );
	    }
	  }]);
	
	  return SaveQuestion;
	}(_react.Component);
	
	exports.default = SaveQuestion;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Timer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timer = exports.Timer = function (_Component) {
	  _inherits(Timer, _Component);
	
	  function Timer(props) {
	    _classCallCheck(this, Timer);
	
	    var _this = _possibleConstructorReturn(this, (Timer.__proto__ || Object.getPrototypeOf(Timer)).call(this, props));
	
	    _this.timerToggle = function () {
	      var stopTimerOnBtnClick = _this.state.stopTimerOnBtnClick;
	
	      clearInterval(_this.timer);
	      if (!stopTimerOnBtnClick) {
	        _this.timer = setInterval(_this.tick, 1000);
	      }
	    };
	
	    _this.tick = function () {
	      var timerCount = _this.state.count + 1;
	      _this.setState({ count: timerCount }, function () {
	        _this.props.getTimerValue(timerCount);
	      });
	    };
	
	    _this.state = {
	      count: props.initialTime || 0,
	      stopTimerOnBtnClick: props.stopTimer || false,
	      disabled: props.stopTimer || false
	    };
	    return _this;
	  }
	
	  _createClass(Timer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          stopTimer = _props.stopTimer,
	          initialTime = _props.initialTime;
	
	      if (initialTime) {
	        this.setState({ count: initialTime });
	      }
	      if (!stopTimer) {
	        this.timer = setInterval(this.tick, 1000);
	      } else {
	        this.setState({
	          stopTimerOnBtnClick: true,
	          disabled: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          stopTimer = _props2.stopTimer,
	          initialTime = _props2.initialTime;
	
	      // Handle initialTime changes
	
	      if (initialTime !== prevProps.initialTime) {
	        this.setState({ count: initialTime || 0 });
	      }
	
	      // Handle stopTimer changes
	      if (stopTimer !== prevProps.stopTimer) {
	        clearInterval(this.timer);
	        if (stopTimer) {
	          this.setState({
	            stopTimerOnBtnClick: true,
	            disabled: true
	          });
	        } else {
	          this.setState({
	            stopTimerOnBtnClick: false,
	            disabled: false
	          }, function () {
	            _this2.timer = setInterval(_this2.tick, 1000);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          count = _state.count,
	          stopTimerOnBtnClick = _state.stopTimerOnBtnClick,
	          disabled = _state.disabled;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'timer_outer' },
	          _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'timer_box' },
	            (0, _constant.SecondsToMMSS)(count)
	          )
	        ),
	        _react2.default.createElement('button', {
	          type: 'button',
	          'aria-label': stopTimerOnBtnClick ? 'Resume timer' : 'Pause timer',
	          className: 'pause_btn ' + (stopTimerOnBtnClick ? 'icon-control-play' : 'icon-control-pause'),
	          onClick: function onClick() {
	            return _this3.setState({
	              stopTimerOnBtnClick: !stopTimerOnBtnClick
	            }, function () {
	              _this3.timerToggle();
	            });
	          },
	          disabled: disabled
	        })
	      );
	    }
	  }]);
	
	  return Timer;
	}(_react.Component);
	
	exports.default = Timer;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripHtml = function stripHtml(html) {
	  return new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
	};
	
	var ViewCard = function ViewCard(_ref) {
	  var headerIcon = _ref.headerIcon,
	      headerContent = _ref.headerContent,
	      bodyContent = _ref.bodyContent,
	      children = _ref.children,
	      onClick = _ref.onClick,
	      _ref$paddingBox = _ref.paddingBox,
	      paddingBox = _ref$paddingBox === undefined ? 'padding_box' : _ref$paddingBox;
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    { xs: 12, sm: 6, md: 6, lg: 4 },
	    _react2.default.createElement(
	      'div',
	      { className: 'border_box', onClick: onClick },
	      _react2.default.createElement(
	        'div',
	        { className: 'border_box_title font-weight-bold d-flex align-items-center' },
	        headerIcon && _react2.default.createElement('img', { src: headerIcon, alt: 'Header Icon', width: '30' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'ml-1' },
	          stripHtml(headerContent)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: paddingBox },
	        _react2.default.createElement(
	          'div',
	          { className: 'view_question_height view_questionhtml margin_bottom_40 cfa_notes_view' },
	          stripHtml(bodyContent)
	        ),
	        children
	      )
	    )
	  );
	};
	
	ViewCard.propTypes = {
	  headerIcon: _propTypes2.default.string,
	  headerContent: _propTypes2.default.string.isRequired,
	  bodyContent: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node,
	  onClick: _propTypes2.default.func,
	  paddingBox: _propTypes2.default.string
	};
	
	exports.default = ViewCard;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RatingComponent = function RatingComponent(_ref) {
	  var rating = _ref.rating,
	      onChange = _ref.onChange,
	      _ref$numberOfStars = _ref.numberOfStars,
	      numberOfStars = _ref$numberOfStars === undefined ? 5 : _ref$numberOfStars,
	      _ref$name = _ref.name,
	      name = _ref$name === undefined ? 'rate1' : _ref$name,
	      _ref$starRatedColor = _ref.starRatedColor,
	      starRatedColor = _ref$starRatedColor === undefined ? 'rgb(255, 180, 0)' : _ref$starRatedColor,
	      _ref$starEmptyColor = _ref.starEmptyColor,
	      starEmptyColor = _ref$starEmptyColor === undefined ? 'rgb(51, 51, 51)' : _ref$starEmptyColor,
	      _ref$starHoverColor = _ref.starHoverColor,
	      starHoverColor = _ref$starHoverColor === undefined ? 'rgb(255, 180, 0)' : _ref$starHoverColor,
	      _ref$starDimension = _ref.starDimension,
	      starDimension = _ref$starDimension === undefined ? '20px' : _ref$starDimension,
	      _ref$starSpacing = _ref.starSpacing,
	      starSpacing = _ref$starSpacing === undefined ? '2px' : _ref$starSpacing;
	
	  return _react2.default.createElement(_reactStarRatings2.default, {
	    rating: rating,
	    starRatedColor: starRatedColor,
	    starEmptyColor: starEmptyColor,
	    starHoverColor: starHoverColor,
	    starDimension: starDimension,
	    starSpacing: starSpacing,
	    changeRating: onChange,
	    numberOfStars: numberOfStars,
	    name: name
	  });
	};
	
	exports.default = RatingComponent;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	var _reactstrap = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoPlayListView = function VideoPlayListView(_ref) {
	  var _ref$videoTitle = _ref.videoTitle,
	      videoTitle = _ref$videoTitle === undefined ? '' : _ref$videoTitle,
	      _ref$currentIndex = _ref.currentIndex,
	      currentIndex = _ref$currentIndex === undefined ? 0 : _ref$currentIndex,
	      _ref$videosData = _ref.videosData,
	      videosData = _ref$videosData === undefined ? [] : _ref$videosData,
	      _ref$youtubeID = _ref.youtubeID,
	      youtubeID = _ref$youtubeID === undefined ? '' : _ref$youtubeID,
	      navigateToVideoByID = _ref.navigateToVideoByID,
	      isUserSubscribed = _ref.isUserSubscribed,
	      toggleAlert = _ref.toggleAlert;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'video_outer' },
	      _react2.default.createElement(
	        _reactstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { xs: 12, sm: 8, md: 8 },
	          _react2.default.createElement(
	            'h5',
	            { className: 'mb-0' },
	            videoTitle
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { xs: 12, sm: 4, md: 4, className: 'mb-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'float-right text-right' },
	            parseInt(currentIndex, 10) === 0 ? null : _react2.default.createElement('i', {
	              className: 'fa fa-angle-left ques_arrow pointer_class',
	              onClick: function onClick() {
	                return navigateToVideoByID(parseInt(currentIndex, 10) - 1);
	              }
	            }),
	            parseInt(currentIndex, 10) === videosData.length - 1 ? null : _react2.default.createElement('i', {
	              className: 'fa fa-angle-right ques_arrow pointer_class',
	              onClick: function onClick() {
	                return navigateToVideoByID(parseInt(currentIndex, 10) + 1);
	              }
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Row,
	        { className: 'videos-main-wraper p-0' },
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { xs: 12, sm: 9, md: 9, className: 'video-show-section' },
	          _react2.default.createElement(
	            'div',
	            { id: 'video-height' },
	            _react2.default.createElement(
	              'div',
	              { className: 'embed-responsive embed-responsive-16by9' },
	              videosData[currentIndex].url_id_qq ? _react2.default.createElement('iframe', {
	                width: '100%',
	                allowFullScreen: '1',
	                height: '100%',
	                src: '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + videosData[currentIndex].url_id_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef',
	                sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                frameBorder: '0',
	                title: '0'
	              }) : _react2.default.createElement('iframe', {
	                className: 'embed-responsive-item',
	                width: '100%',
	                height: '100%',
	                title: 'video',
	                frameBorder: '0',
	                src: 'https://www.youtube.com/embed/' + youtubeID + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                allowFullScreen: true,
	                sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { xs: 12, sm: 3, md: 3, className: 'video-tag-heading', id: 'video-tag-list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'link_list_wrap height-571' },
	            videosData.map(function (item, index) {
	              return _react2.default.createElement(
	                'div',
	                { key: item.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'full-width', key: item.id },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'videotitle', key: item.id, value: item.id },
	                    !isUserSubscribed && (item.free ? _react2.default.createElement(
	                      'div',
	                      { className: 'video-type-free' },
	                      _messages.messages.FREE
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'video-type-primum' },
	                      _messages.messages.PREMIUM
	                    )),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        name: 'videourl',
	                        id: item.id,
	                        className: item.url_id === youtubeID ? 'active' : '',
	                        onClick: function onClick() {
	                          if (!isUserSubscribed && !item.free) return toggleAlert();
	                          navigateToVideoByID(index);
	                        },
	                        value: item.url
	                      },
	                      _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'text-overflow' },
	                        item.title
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	}; /* eslint-disable */
	exports.default = VideoPlayListView;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	var _SaveQuestion = __webpack_require__(170);
	
	var _SaveQuestion2 = _interopRequireDefault(_SaveQuestion);
	
	var _ReportQuestion = __webpack_require__(169);
	
	var _ReportQuestion2 = _interopRequireDefault(_ReportQuestion);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var VideoValidateReportsIcons = function (_Component) {
	  _inherits(VideoValidateReportsIcons, _Component);
	
	  function VideoValidateReportsIcons(props) {
	    _classCallCheck(this, VideoValidateReportsIcons);
	
	    var _this = _possibleConstructorReturn(this, (VideoValidateReportsIcons.__proto__ || Object.getPrototypeOf(VideoValidateReportsIcons)).call(this, props));
	
	    _this.onHandleDownloadPDF = function () {
	      var _this$props = _this.props,
	          currentVideo = _this$props.currentVideo,
	          isUserSubscribed = _this$props.isUserSubscribed,
	          toggleAlert = _this$props.toggleAlert;
	
	      if (isUserSubscribed) {
	        if (currentVideo.pdf_file) {
	          var myWindow = window.open(currentVideo.pdf_file);
	          myWindow.focus();
	        } else {
	          (0, _toast.showInformation)(_messages.messages.PDF_NOT_AVAILABLE);
	        }
	      } else {
	        toggleAlert();
	      }
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(VideoValidateReportsIcons, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var router = this.context.router;
	      var _props = this.props,
	          _props$isMoveToNotesI = _props.isMoveToNotesIcon,
	          isMoveToNotesIcon = _props$isMoveToNotesI === undefined ? true : _props$isMoveToNotesI,
	          _props$isMoveToQuesti = _props.isMoveToQuestionIcon,
	          isMoveToQuestionIcon = _props$isMoveToQuesti === undefined ? true : _props$isMoveToQuesti,
	          _props$notesRedirectR = _props.notesRedirectRoute,
	          notesRedirectRoute = _props$notesRedirectR === undefined ? '' : _props$notesRedirectR,
	          _props$questionRedire = _props.questionRedirectRoute,
	          questionRedirectRoute = _props$questionRedire === undefined ? '' : _props$questionRedire,
	          savePayLoad = _props.savePayLoad,
	          favItemId = _props.favItemId,
	          onSaveItemChange = _props.onSaveItemChange,
	          setChildRef = _props.setChildRef,
	          apiServiceProvider = _props.apiServiceProvider,
	          toggleReportSection = _props.toggleReportSection,
	          _props$isUserSubscrib = _props.isUserSubscribed,
	          isUserSubscribed = _props$isUserSubscrib === undefined ? false : _props$isUserSubscrib;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 d-flex mb-2' },
	          _react2.default.createElement(
	            'span',
	            { className: 'd-inline-flex align-items-center' },
	            isMoveToNotesIcon && _react2.default.createElement(
	              'span',
	              { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'tootip_box' },
	                ' ',
	                _messages.messages.GO_TO_NOTES,
	                ' '
	              ),
	              _react2.default.createElement('i', {
	                onClick: function onClick() {
	                  return router.push({ pathname: notesRedirectRoute });
	                },
	                className: 'fa fa-book mark-action-btn',
	                style: { color: '#1f8ceb' }
	              })
	            ),
	            isMoveToQuestionIcon && _react2.default.createElement(
	              'span',
	              { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'tootip_box' },
	                ' ',
	                _messages.messages.GO_TO_QUESTION_BANK,
	                ' '
	              ),
	              _react2.default.createElement('i', {
	                onClick: function onClick() {
	                  return router.push({ pathname: questionRedirectRoute });
	                },
	                className: 'fa fa-question-circle-o mark-action-btn',
	                style: { color: '#1d364b' }
	              })
	            ),
	            _react2.default.createElement(_SaveQuestion2.default, {
	              savePayLoad: savePayLoad,
	              favItemId: favItemId,
	              onSaveItemChange: onSaveItemChange,
	              setChildRef: setChildRef,
	              apiServiceProvider: apiServiceProvider
	            }),
	            _react2.default.createElement(_ReportQuestion2.default, {
	              onClick: toggleReportSection,
	              reportTooltipText: _messages.messages.REPORT_THIS_VIDEO
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { onClick: function onClick() {
	                return _this2.onHandleDownloadPDF();
	              }, className: 'status-download-btn ml-auto' },
	            _react2.default.createElement(
	              'a',
	              { className: 'btn btn-primary  pointer_class pull-right' },
	              _react2.default.createElement('i', { className: 'fa fa-download  ', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                _messages.messages.PREMIUM
	              ),
	              _messages.messages.Download_PDF
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VideoValidateReportsIcons;
	}(_react.Component);
	
	VideoValidateReportsIcons.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = VideoValidateReportsIcons;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	var _VideoListSlider = __webpack_require__(522);
	
	var _VideoListSlider2 = _interopRequireDefault(_VideoListSlider);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Per-item subscribed flag — matches VideoListSlider. Non-webinar items
	// resolve to the caller's `isUserSubscribed` (byte-identical historical
	// behavior). Webinars require Unlimited+ (`hasPlusAccess`).
	var itemSubscribed = function itemSubscribed(item, isUserSubscribed, hasPlusAccess) {
	  return item && item.media_type === 'webinar' ? !!hasPlusAccess : !!isUserSubscribed;
	};
	
	var VideoCard = function VideoCard(_ref) {
	  var index = _ref.index,
	      currentItem = _ref.currentItem,
	      _ref$chapterIdKey = _ref.chapterIdKey,
	      chapterIdKey = _ref$chapterIdKey === undefined ? 'id' : _ref$chapterIdKey,
	      _ref$chapterNameKey = _ref.chapterNameKey,
	      chapterNameKey = _ref$chapterNameKey === undefined ? 'name' : _ref$chapterNameKey,
	      videoTableNameKey = _ref.videoTableNameKey,
	      _ref$isUserSubscribed = _ref.isUserSubscribed,
	      isUserSubscribed = _ref$isUserSubscribed === undefined ? false : _ref$isUserSubscribed,
	      _ref$hasPlusAccess = _ref.hasPlusAccess,
	      hasPlusAccess = _ref$hasPlusAccess === undefined ? false : _ref$hasPlusAccess,
	      redirectToPlaylist = _ref.redirectToPlaylist,
	      premiumModalToggle = _ref.premiumModalToggle;
	
	  var isFRMChapter = currentItem.chapter_id === _constant.CAPSULE_VIDEO_ID || currentItem.id === _constant.CAPSULE_VIDEO_ID;
	
	  var hasCFAVideosAndMock = currentItem['cfa1_2025_videos'] && currentItem.mock_id;
	
	  var hasFRMVideos = !!currentItem['frm_videos'];
	
	  var chapterName = currentItem[chapterNameKey];
	  var chapterNameNoSuffix = (0, _function.removeSuffix)(chapterName, '– volume');
	
	  var displayName = void 0;
	  if (hasCFAVideosAndMock) {
	    displayName = chapterName;
	  } else if (!currentItem.case_id) {
	    displayName = isFRMChapter ? chapterName : (hasFRMVideos ? _messages.messages.BOOK : _messages.messages.TOPIC) + ' ' + index + ' - ' + chapterName;
	  } else {
	    displayName = isFRMChapter ? chapterNameNoSuffix : (hasFRMVideos ? _messages.messages.BOOK : _messages.messages.TOPIC) + ' ' + index + ' - ' + chapterNameNoSuffix;
	  }
	  return currentItem.headerTitle ? _react2.default.createElement(
	    _reactstrap.Col,
	    { sm: 12, md: 12, key: index },
	    _react2.default.createElement(
	      'div',
	      { className: 'video-header-title', id: (0, _function.slugifyHeader)(currentItem.headerTitle) },
	      _react2.default.createElement('i', { className: 'fa fa-caret-square-o-right' }),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        null,
	        currentItem.headerTitle
	      )
	    )
	  ) : _react2.default.createElement(
	    _reactstrap.Col,
	    { sm: 12, md: 12, key: index },
	    _react2.default.createElement(
	      'div',
	      { className: 'card' },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'card-header card_header_bg',
	          value: currentItem[chapterIdKey]
	          // onClick={() => redirectToPlaylist(currentItem[videoTableNameKey][0])}
	          , onClick: function onClick() {
	            // Same shape as the historical header handler — a single ternary,
	            // no restructured JSX. Just extends the "can play the first
	            // video" test to respect the Plus tier for webinars, so a non-
	            // Plus user clicking a paid-webinar chapter header opens the
	            // upgrade modal instead of navigating and being bounced back.
	            var firstVideo = currentItem[videoTableNameKey] && currentItem[videoTableNameKey][0];
	            var isSubscribedForFirst = itemSubscribed(firstVideo, isUserSubscribed, hasPlusAccess);
	            return firstVideo && (isSubscribedForFirst || firstVideo.free) ? redirectToPlaylist(firstVideo) : premiumModalToggle && premiumModalToggle();
	          }
	        },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'pointer_class',
	            id: currentItem[chapterNameKey],
	            value: currentItem[chapterIdKey]
	          },
	          displayName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card-block list_icon_outer', key: currentItem[chapterNameKey] },
	        currentItem[videoTableNameKey].length > 0 ? _react2.default.createElement(
	          'p',
	          null,
	          _messages.messages.TOTAL_VIDEOS,
	          ': ',
	          currentItem[videoTableNameKey].length
	        ) : _react2.default.createElement('p', null),
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { xs: 12, sm: 12, md: 12, key: index },
	          _react2.default.createElement(_VideoListSlider2.default, {
	            key: currentItem[chapterIdKey],
	            videos: currentItem[videoTableNameKey],
	            isUserSubscribed: isUserSubscribed,
	            hasPlusAccess: hasPlusAccess,
	            premiumModalToggle: premiumModalToggle,
	            redirectToPlaylist: redirectToPlaylist
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = VideoCard;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nextAwareRoute = exports.redirectSharedVideosToCfa2Tree = exports.isNextPath = exports.getCurrentPath = undefined;
	
	var _map, _map2;
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// #cfa2-2027 — mirror of cfa1NextRoutes.js. Keep a 2027 user inside the /cfa2/2027/... tree when
	// SHARED components navigate internally. Unlike CFA1 (which reuses its 2025 components wholesale),
	// the CFA2 2027 learn/QB/notes/quiz/CBT views are CLONED and already carry their own CFA2_2027_*
	// route constants, so they don't need this. The only genuinely shared CFA2 components are the video
	// list/player (views/Videos/*, edition-neutral /exams/cfa/videos/* endpoints) — nextAwareRoute()
	// swaps their shared /videos route constants to the /cfa2/2027 variants while under that tree, so
	// 2025/2026 navigation is completely unaffected.
	// Both dated CFA2 trees reuse the shared video components, so each prefix maps the shared route
	// constants to its own dated variants. Checked most-specific first.
	var DATED_TREES = [{
	  prefix: '/cfa2/2027',
	  map: (_map = {}, _defineProperty(_map, _AppRoutes2.default.VIDEOS, _AppRoutes2.default.CFA2_2027_VIDEOS), _defineProperty(_map, _AppRoutes2.default.VIDEOS_LIST, _AppRoutes2.default.CFA2_2027_VIDEOS_LIST), _map)
	}, {
	  prefix: '/cfa2/2026',
	  map: (_map2 = {}, _defineProperty(_map2, _AppRoutes2.default.VIDEOS, _AppRoutes2.default.CFA2_2026_VIDEOS), _defineProperty(_map2, _AppRoutes2.default.VIDEOS_LIST, _AppRoutes2.default.CFA2_2026_VIDEOS_LIST), _map2)
	}];
	
	// Current route path, read straight from the browser URL so it works regardless of the react-router
	// history in use: browserHistory keeps the route in window.location.pathname; hashHistory keeps it
	// in the hash (#/path). Prefer the hash when present, else the pathname.
	var getCurrentPath = exports.getCurrentPath = function getCurrentPath() {
	  var hash = window.location && window.location.hash || '';
	  if (hash.length > 1) {
	    return hash.replace(/^#/, '').split('?')[0];
	  }
	  return window.location && window.location.pathname || '';
	};
	
	// The dated-tree entry whose prefix the current route is under, or null (plain /videos etc.).
	var currentDatedTree = function currentDatedTree() {
	  var p = getCurrentPath();
	  if (!p) return null;
	  for (var i = 0; i < DATED_TREES.length; i++) {
	    if (p.indexOf(DATED_TREES[i].prefix) === 0) return DATED_TREES[i];
	  }
	  return null;
	};
	
	// True when the current route is inside either dated CFA2 tree.
	var isNextPath = exports.isNextPath = function isNextPath() {
	  return !!currentDatedTree();
	};
	
	// Legacy shared /videos URLs are shared with CFA3, so a plain route redirect is impossible. Redirect
	// only CFA2 users (by the selected exam code) into their dated tree; CFA3/others stay on /videos.
	// Used as onEnter on the shared AppRoutes.VIDEOS / VIDEOS_LIST routes.
	var CFA2_VIDEO_PREFIX_BY_EXAM = {
	  cfa_2: '/cfa2/2026',
	  cfa_2_2025: '/cfa2/2026',
	  cfa_2_2026: '/cfa2/2026',
	  cfa_2_2027: '/cfa2/2027'
	};
	var redirectSharedVideosToCfa2Tree = exports.redirectSharedVideosToCfa2Tree = function redirectSharedVideosToCfa2Tree(nextState, replace) {
	  var exam = '';
	  try {
	    exam = localStorage.getItem('selectedmenu') || '';
	  } catch (e) {
	    exam = '';
	  }
	  var prefix = CFA2_VIDEO_PREFIX_BY_EXAM[exam];
	  if (!prefix) return;
	  var loc = nextState.location;
	  // /videos → <prefix>/videos ; /videos/list/:chapterId/:id → <prefix>/video/list/:chapterId/:id
	  var rest = loc.pathname.replace(/^\/videos/, '');
	  var target = rest.indexOf('/list/') === 0 ? prefix + '/video' + rest : prefix + '/videos';
	  replace(target + (loc.search || ''));
	};
	
	// Given a shared CFA2 route constant (a route template), return the dated variant for the tree the
	// user is currently inside (/cfa2/2026 or /cfa2/2027); otherwise return the original unchanged. Param
	// substitution stays the caller's job — this only swaps the template.
	var nextAwareRoute = exports.nextAwareRoute = function nextAwareRoute(routeConstant) {
	  var tree = currentDatedTree();
	  if (tree && tree.map[routeConstant]) {
	    return tree.map[routeConstant];
	  }
	  return routeConstant;
	};

/***/ },
/* 178 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * One vocabulary for subscription state across every purchase surface.
	 *
	 * Driven by the status from the backend resolver
	 * (analystprep-lms/backend/services/subscriptions/resolveSubscriptionStatus.js),
	 * so /subscribe, /subscribe/selectPackage and the admin panel cannot disagree —
	 * they did: the same cancelled plan read "Cancelled" on one page and
	 * "Purchased" on the other.
	 *
	 * Change the wording here and it changes everywhere.
	 */
	
	var SUBSCRIPTION_BADGE = exports.SUBSCRIPTION_BADGE = {
	  active: { label: 'Subscribed', tone: 'ok' },
	  past_due: { label: 'Payment failed', tone: 'danger' },
	  cancelling: { label: 'Cancelled', tone: 'warn' },
	  expired: { label: 'Expired', tone: 'danger' }
	};
	
	// One-time purchases keep the existing wording.
	var PURCHASED_BADGE = exports.PURCHASED_BADGE = { label: 'Purchased', tone: 'ok' };
	
	/**
	 * @param {object|null} subscription the `subscription` object from the API
	 *        (null for one-time plans)
	 * @returns {{label: string, tone: 'ok'|'warn'|'danger'}}
	 */
	var getSubscriptionBadge = exports.getSubscriptionBadge = function getSubscriptionBadge(subscription) {
	  if (!subscription || !subscription.status) return PURCHASED_BADGE;
	  return SUBSCRIPTION_BADGE[subscription.status] || PURCHASED_BADGE;
	};
	
	/** Suffix for the date row: a live subscription renews, a cancelled one runs out. */
	var getSubscriptionDateLabel = exports.getSubscriptionDateLabel = function getSubscriptionDateLabel(subscription) {
	  if (!subscription || !subscription.status) return 'Expires: ';
	  if (subscription.status === 'cancelling') return 'Access until: ';
	  if (subscription.status === 'expired') return 'Ended: ';
	  return 'Renews: ';
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSelectedExam = exports.fetchCartItem = undefined;
	
	var _constant = __webpack_require__(9);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchCartItem = exports.fetchCartItem = function fetchCartItem() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getCart', Object.assign({}, data, (0, _constant.getTokenWithEmail)()));
	};
	
	var updateSelectedExam = exports.updateSelectedExam = function updateSelectedExam() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/updateExamSelected', Object.assign({}, data, (0, _constant.getTokenWithEmail)()));
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var _require = __webpack_require__(10),
	    postApiCalling = _require.postApiCalling;
	
	var fetchFreeUseSubscriptionMessage = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return postApiCalling('/exams', '/get-model-content', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchFreeUseSubscriptionMessage() {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	module.exports = { fetchFreeUseSubscriptionMessage: fetchFreeUseSubscriptionMessage };

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Heading(_ref) {
	  var headerText = _ref.headerText,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'section_head' },
	      headerText
	    ),
	    children
	  );
	}
	
	exports.default = Heading;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ViewAnswer(props) {
	  var multiple_answer = props.multiple_answer,
	      grading_details = props.grading_details,
	      is_multiple = props.is_multiple,
	      development_justification = props.development_justification,
	      handleChange = props.handleChange,
	      userGrading = props.userGrading,
	      max_grading = props.max_grading,
	      selectedChoice = props.selectedChoice,
	      disabled = props.disabled;
	
	  var choices = [];
	  var justification = [];
	  for (var objKey in props) {
	    if (objKey.includes('choice')) if (props[objKey]) choices.push(props[objKey]);
	    if (objKey.includes('development_justification')) if (props[objKey]) justification.push(props[objKey]);
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'note-section note-section-new view_questionhtml' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card' },
	      _react2.default.createElement(
	        'div',
	        { className: 'font-lusitana' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header' },
	          is_multiple ? selectedChoice === multiple_answer ? _react2.default.createElement(
	            'div',
	            { className: 'text_success' },
	            'Correct'
	          ) : selectedChoice ? _react2.default.createElement(
	            'div',
	            { className: 'text_failure' },
	            'Incorrect'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'text_unAttempted' },
	            'Not Attempted'
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            development_justification.includes('&;') ? _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 border-gray rounded p-1' },
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  development_justification.split('&;')[0].split(':')[0],
	                  ' :'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  development_justification.split('&;')[0].split(':')[1],
	                  ' '
	                )
	              )
	            ) : null,
	            is_multiple ? _react2.default.createElement(
	              _reactstrap.Col,
	              {
	                className: 'mb-md-0 mb-sm-1',
	                sm: '12',
	                md: development_justification.includes('&;') ? '12' : '4'
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: (development_justification.includes('&;') ? 'p-2' : '') + ' border-gray rounded d-flex justify-content-center align-items-center h-100 p-2'
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'border-solid-1 p-2 rounded-circle text-center' },
	                  multiple_answer
	                )
	              )
	            ) : null,
	            !is_multiple && choices.length ? choices.map(function (element, index) {
	              return _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { sm: '12', md: '6' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'p-2\n                    border-gray rounded d-flex justify-content-center align-items-center'
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'p-2' },
	                      element
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { sm: '12', md: '6' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'p-2\n                    border-gray rounded d-flex justify-content-center align-items-center'
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'p-2' },
	                      justification[index]
	                    )
	                  )
	                )
	              );
	            }) : null,
	            !(!is_multiple && choices.length) && development_justification ? _react2.default.createElement(
	              _reactstrap.Col,
	              {
	                className: 'col-12',
	                sm: '12',
	                md: development_justification.includes('&;') || !is_multiple ? '12' : '8'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: (development_justification.includes('&;') || !is_multiple ? 'p-2' : '') + ' border-gray rounded p-2'
	                  },
	                  development_justification.includes('&;') ? _react2.default.createElement(
	                    'b',
	                    null,
	                    'Justification:'
	                  ) : is_multiple ? selectedChoice === multiple_answer ? _react2.default.createElement(
	                    'p',
	                    { className: 'text-success  d-block font-weight-bold' },
	                    'You Selected the Correct Answer: ',
	                    multiple_answer
	                  ) : selectedChoice ? _react2.default.createElement(
	                    'p',
	                    { className: 'text-danger d-block font-weight-bold' },
	                    'You Selected the Incorrect Answer. The Correct Answer is: ',
	                    multiple_answer
	                  ) : _react2.default.createElement(
	                    'p',
	                    { className: 'd-block font-weight-bold' },
	                    'The Correct Answer is: ',
	                    multiple_answer
	                  ) : null,
	                  (0, _function.renderHTMLContent)(development_justification.includes('&;') ? development_justification.split('&;')[1] : development_justification, "span")
	                )
	              )
	            ) : null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mt-2' },
	                grading_details ? _react2.default.createElement(
	                  'div',
	                  { className: 'bg-secondary w-100 rounded p-1' },
	                  _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'col-12', sm: '12', md: '9' },
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Candidate grading:'
	                      ),
	                      ' ',
	                      (0, _function.renderHTMLContent)(grading_details, "span")
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'col-12 mt-1 mt-md-0', sm: '12', md: '3' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'select',
	                          name: 'userGrading',
	                          className: 'form-control input-sm',
	                          onChange: function onChange(e) {
	                            return handleChange(e);
	                          },
	                          disabled: disabled,
	                          value: userGrading,
	                          size: '1'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'Select grading' },
	                          'Select Grading',
	                          ' '
	                        ),
	                        Array(max_grading + 1).fill(0).map(function (element, index) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: '' + index, key: index },
	                            index
	                          );
	                        })
	                      )
	                    )
	                  )
	                ) : null
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = ViewAnswer;

/***/ },
/* 183 */
84,
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LEFT_PAGE = 'LEFT';
	var RIGHT_PAGE = 'RIGHT';
	/**
	 * Helper method for creating a range of numbers
	 * range(1, 5) => [1, 2, 3, 4, 5]
	 */
	var range = function range(from, to) {
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var iterator = from;
	  var range = [];
	
	  while (iterator <= to) {
	    range.push(iterator);
	    iterator += step;
	  }
	
	  return range;
	};
	/* eslint-disable*/
	
	var CommonDetailStatus = function (_Component) {
	  _inherits(CommonDetailStatus, _Component);
	
	  function CommonDetailStatus(props) {
	    _classCallCheck(this, CommonDetailStatus);
	
	    var _this = _possibleConstructorReturn(this, (CommonDetailStatus.__proto__ || Object.getPrototypeOf(CommonDetailStatus)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    // var messageContent_cfa = `<div class="modal-info-list"><ul> <li> ${
	    //   language.LC().Extensive_Study_Notes
	    // } </li> <li> ${language.LC().Hours_of_Video_Lessons_40} </li> <li> ${
	    //   language.LC().Practice_Questions_3000
	    // } </li> <li> ${language.LC().Unlimited_Customizable_Quizzes} </li> <li> ${
	    //   language.LC().Amazing_Chat_Email_Support
	    // }</li></ul></div>`;
	    _this.state = {
	      currentPage: currentPage ? currentPage : 1,
	      subscriptionstatus: _this.props.subscriptionstatus,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      alert_status: false,
	      selectedmenu: _this.props.selectedmenu,
	      level: _this.props.level,
	      offset: 0
	    };
	    var _props$totalQuestions = props.totalQuestions,
	        totalQuestions = _props$totalQuestions === undefined ? '' : _props$totalQuestions,
	        _props$currentPage = props.currentPage,
	        currentPage = _props$currentPage === undefined ? '' : _props$currentPage,
	        _props$pageLimit = props.pageLimit,
	        pageLimit = _props$pageLimit === undefined ? 20 : _props$pageLimit,
	        _props$pageNeighbours = props.pageNeighbours,
	        pageNeighbours = _props$pageNeighbours === undefined ? 1 : _props$pageNeighbours,
	        _props$questionLowerL = props.questionLowerLimit,
	        questionLowerLimit = _props$questionLowerL === undefined ? 0 : _props$questionLowerL,
	        _props$questionUpperL = props.questionUpperLimit,
	        questionUpperLimit = _props$questionUpperL === undefined ? 20 : _props$questionUpperL;
	
	    // console.log(typeof pageLimit)
	    // console.log(pageLimit)
	    // console.log(typeof totalQuestions)
	    // console.log(totalQuestions)
	    // PAGE LIMIT AND RECORDS
	
	    _this.pageLimit = typeof pageLimit === 'number' ? pageLimit : 20;
	    _this.totalQuestions = typeof totalQuestions === 'number' ? totalQuestions : 0;
	
	    // PAGE NEIGHBOURS CAN BE 0, 1 OR 2
	    _this.pageNeighbours = typeof pageNeighbours === 'number' ? Math.max(0, Math.min(pageNeighbours, 2)) : 0;
	    _this.totalPages = Math.ceil(_this.totalQuestions / _this.pageLimit);
	    // console.log(Math.ceil(this.totalQuestions / this.pageLimit))
	    return _this;
	  }
	
	  _createClass(CommonDetailStatus, [{
	    key: 'executeOnClick',
	    value: function executeOnClick(isExpanded) {
	      // console.log(isExpanded);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // console.log(this.props.level)
	      // console.log("componentdidupdate");
	      // console.log(prevProps);
	      // console.log(this.props);
	      if (this.state.currentPage !== this.props.currentPage && prevProps.currentPage !== this.props.currentPage) {
	        this.setState({ currentPage: this.props.currentPage });
	      }
	      if (prevProps.totalQuestions !== this.props.totalQuestions) {
	        // console.log("componentdidupdate");
	        // console.log(this);
	        var _props = this.props,
	            totalQuestions = _props.totalQuestions,
	            pageLimit = _props.pageLimit;
	        // console.log(totalQuestions);
	        // console.log(pageLimit)
	        // console.log(Math.ceil(totalQuestions / pageLimit))
	
	        var totPages = Math.ceil(totalQuestions / pageLimit);
	        this.setState({
	          totalQuestions: totalQuestions,
	          totalPages: totPages
	        });
	      }
	    }
	  }, {
	    key: 'allQuestionDataFun',
	    value: function allQuestionDataFun(data) {
	      var _this2 = this;
	
	      // console.log("data");
	      // console.log(data);
	      var dataRetun = '';
	      if (data.length) {
	        dataRetun = data.map(function (question, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              question.id
	            ),
	            (0, _function.renderHTMLContent)(question.question, 'td', '', { contentEditable: 'false' }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _this2.getChapterId(question)
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _this2.getReadingId(question)
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              ' ',
	              question.name,
	              ' '
	            ),
	            question.totalAttempt === null || question.totalAttempt === null ? _react2.default.createElement(
	              'td',
	              null,
	              ' ',
	              _language2.default.LC().NO,
	              ' '
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              ' ',
	              _language2.default.LC().YES,
	              ' '
	            ),
	            question.totalAttempt === null || question.totalAttempt === null ? _react2.default.createElement(
	              'td',
	              null,
	              ' 0 '
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              question.totalAttempt
	            ),
	            question.avgScoreA === null && question.totalAttempt === null ? _react2.default.createElement(
	              'td',
	              null,
	              ' - '
	            ) : question.avgScoreA === null && question.totalAttempt !== null ? _react2.default.createElement(
	              'td',
	              null,
	              ' 0% '
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              parseInt(question.avgScoreA),
	              '%'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap left-tool-tip margin_right_20' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-eye font-xl ' + (_this2.hasValidChapterAndReading(question) ? 'text_blue cursor-pointer' : 'text-muted'),
	                  onClick: _this2.hasValidChapterAndReading(question) ? function () {
	                    return _this2._beginChapter(question);
	                  } : null
	                }),
	                _this2.hasValidChapterAndReading(question) ? _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_QUESTION
	                ) : null
	              )
	            )
	          );
	        });
	      } else {
	        dataRetun = _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: '10' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              'No Data Found'
	            )
	          )
	        );
	      }
	      return dataRetun;
	    }
	
	    /**
	     * Retrieves the chapter ID from a question object based on the selected menu state.
	     *
	     * @param {Object} question - The question object containing various chapter IDs.
	     * @returns {string|null} - The chapter ID corresponding to the current selected menu, or null if not available.
	     */
	
	
	    /**
	     * Retrieves the reading ID from a question object based on the selected menu state.
	     *
	     * @param {Object} question - The question object containing various reading IDs.
	     * @returns {string|null} - The reading ID corresponding to the current selected menu, or null if not available.
	     */
	
	
	    /**
	     * Determines if a question can be viewed by checking if it has valid chapter and reading IDs.
	     *
	     * @param {Object} question - The question object to be evaluated.
	     * @returns {boolean} - Returns true if both chapter and reading IDs are present; otherwise, false.
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.gotoPage(this.state.currentPage);
	    }
	
	    // gotoPage only fires a setState + a fire-and-forget parent fetch (onChangePagination); it returns
	    // nothing awaitable, so this stays a plain sync handler. (The parent owns the loading state.)
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // console.log('detail page')
	      // console.log(this.props)
	      var _props2 = this.props,
	          allQuestionData = _props2.allQuestionData,
	          loader = _props2.loader;
	      // console.log(this.totalPages)
	      // if (!this.totalQuestions || this.totalPages === 1) return null;
	
	      var currentPage = this.state.currentPage;
	
	      var pages = this.fetchPageNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'filter-table-wrap' },
	            _react2.default.createElement(
	              'table',
	              { className: 'table-bordered responsive table table-striped table-hover' },
	              _react2.default.createElement(
	                'thead',
	                { className: 'thead_color' },
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    ' ',
	                    _language2.default.LC().Question_ID,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    _language2.default.LC().QUESTION,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    _language2.default.LC().Chapter_No,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    _language2.default.LC().READING_No,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    ' ',
	                    _language2.default.LC().Reading_Name,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    ' ',
	                    _language2.default.LC().ANSWERED,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    ' ',
	                    _language2.default.LC().No_of_attempts,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    ' ',
	                    _language2.default.LC().AVERAGE_SCORE,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    ' ',
	                    _language2.default.LC().ACTION,
	                    ' '
	                  )
	                )
	              ),
	              loader ? _react2.default.createElement(
	                'div',
	                null,
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loader_box' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sk-circle' },
	                    _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	                    _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	                  )
	                ),
	                ' '
	              ) : _react2.default.createElement(
	                'tbody',
	                null,
	                this.allQuestionDataFun(allQuestionData)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pagination-wrapper' },
	            _react2.default.createElement(
	              'nav',
	              { 'aria-label': 'Table Pagination' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'pagination justify-content-end' },
	                pages.map(function (page, index) {
	                  if (page === LEFT_PAGE) return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'p',
	                      {
	                        className: 'page-link',
	                        'aria-label': 'Previous',
	                        onClick: _this3.handleMoveLeft
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { 'aria-hidden': 'true' },
	                        '\xAB'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        'Previous'
	                      )
	                    )
	                  );
	
	                  if (page === RIGHT_PAGE) return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'p',
	                      {
	                        className: 'page-link',
	                        'aria-label': 'Next',
	                        onClick: _this3.handleMoveRight
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { 'aria-hidden': 'true' },
	                        '\xBB'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        'Next'
	                      )
	                    )
	                  );
	
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index, className: '' + (currentPage === page ? ' active' : '') },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'page-link', onClick: _this3.handleClick(page) },
	                      page
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return CommonDetailStatus;
	}(_react.Component);
	
	CommonDetailStatus.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	CommonDetailStatus.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.goPremium = function () {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    _this4.context.router.push({
	      pathname: '/Subscribe/',
	      state: {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        selectedMenu: _this4.state.selectedmenu
	      }
	    });
	  };
	
	  this.toggleAlert = function () {
	    _this4.setState({
	      alert_status: !_this4.state.alert_status
	    });
	  };
	
	  this._beginChapter = function (question, e) {
	    console.log(question);
	    if (_this4.props.subscriptionstatus === 'free') {
	      _this4.toggleAlert();
	    } else {
	      if (_this4.state.selectedmenu === 'frm') {
	        var chapter_id = question.chapter_id,
	            reading_id = question.reading_id,
	            id = question.id;
	        var level = _this4.state.level;
	
	        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	        _this4.context.router.push({
	          pathname: _AppRoutes2.default.FRM_QUESTION_BANK_VIEW_QUESTION.replace(':notesid', chapter_id).replace(':readingid', reading_id).replace(':level', level).replace(':id', id),
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname'],
	            reading: reading_id,
	            chapter: chapter_id,
	            offset: 0,
	            selectedMenu: 'frm'
	          }
	        });
	      } else if (_this4.state.selectedmenu === 'cfa') {
	        // console.log(question);
	        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	        _this4.context.router.push({
	          pathname: '/cfa1/beginchapter_2022/' + question.chapter_id_2022 + '/' + question.reading_id_2022 + '/' + question.id + '/' + _this4.state.offset,
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname'],
	            reading: question.reading_id_2022,
	            chapter: question.chapter_id_2022
	          }
	        });
	      } else if (_this4.state.selectedmenu === 'cfa_2023') {
	        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	        // '/cfa1_2023/beginchapter/:notesid/:readingid/:id/:offset'
	        _this4.context.router.push({
	          pathname: _AppRoutes2.default.CFA1_2023_QUESTION_BANK_VIEW_QUE.replace(':notesId', question.chapter_id_2023).replace(':readingId', question.reading_id_2023).replace(':id', question.id).replace(':offset', _this4.state.offset),
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname'],
	            reading: question.reading_id_2023,
	            chapter: question.chapter_id_2023
	          }
	        });
	      } else if (_this4.state.selectedmenu === 'cfa_2024') {
	        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	        // '/cfa1_2023/beginchapter/:notesid/:readingid/:id/:offset'
	        _this4.context.router.push({
	          pathname: _AppRoutes2.default.CFA1_2024_QUESTION_BANK_VIEW_QUE.replace(':notesid', question.chapter_id_2024).replace(':readingid', question.reading_id_2024).replace(':id', question.id).replace(':offset', _this4.state.offset),
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname'],
	            reading: question.reading_id_2024,
	            chapter: question.chapter_id_2024
	          }
	        });
	      } else if (_this4.state.selectedmenu === 'cfa_2025') {
	        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	        // '/cfa1_2023/beginchapter/:notesid/:readingid/:id/:offset'
	        // selectedmenu is hardcoded 'cfa_2025' by the caller, so nextAwareRoute (which reads the
	        // current URL) is what keeps a 2027 user on /cfa1/2027/... instead of the shared route.
	        _this4.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_VIEW).replace(':readingId', question.reading_id_2025).replace(':questionId', question.id),
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname'],
	            reading: question.reading_id_2025,
	            chapter: question.chapter_id_2025
	          }
	        });
	      }
	    }
	  };
	
	  this.getChapterId = function (question) {
	    var chapterIdMap = {
	      cfa: 'chapter_id_2022',
	      cfa_2023: 'chapter_id_2023',
	      cfa_2024: 'chapter_id_2024',
	      cfa_2025: 'chapter_id_2025',
	      frm: 'chapter_id'
	    };
	    var key = chapterIdMap[_this4.state.selectedmenu];
	    return question[key] !== undefined && question[key] !== null ? question[key] : null;
	  };
	
	  this.getReadingId = function (question) {
	    var readingIdMap = {
	      cfa: 'reading_id_2022',
	      cfa_2023: 'reading_id_2023',
	      cfa_2024: 'reading_id_2024',
	      cfa_2025: 'reading_id_2025',
	      frm: 'reading_id'
	    };
	    var key = readingIdMap[_this4.state.selectedmenu];
	    return question[key] !== undefined && question[key] !== null ? question[key] : null;
	  };
	
	  this.hasValidChapterAndReading = function (question) {
	    return !!(_this4.getChapterId(question) && _this4.getReadingId(question));
	  };
	
	  this.gotoPage = function (page) {
	    var _props$onChangePagina = _this4.props.onChangePagination,
	        onChangePagination = _props$onChangePagina === undefined ? function (f) {
	      return f;
	    } : _props$onChangePagina;
	
	    var currentPage = Math.max(0, Math.min(page, _this4.totalPages));
	    var paginationData = {
	      currentPage: currentPage,
	      totalPages: _this4.totalPages,
	      pageLimit: _this4.pageLimit,
	      totalQuestions: _this4.totalQuestions
	    };
	    return _this4.setState({ currentPage: page }, function () {
	      return onChangePagination(page, paginationData);
	    });
	  };
	
	  this.handleClick = function (page) {
	    return function () {
	      _this4.gotoPage(page);
	    };
	  };
	
	  this.handleMoveLeft = function () {
	    // console.log(this.state.currentPage - this.pageNeighbours * 2 - 1)
	    _this4.gotoPage(_this4.state.currentPage - _this4.pageNeighbours * 2 - 1);
	  };
	
	  this.handleMoveRight = function () {
	    // console.log(this.state.currentPage)
	    // console.log(this.pageNeighbours)
	    // console.log(this.state.currentPage - this.pageNeighbours * 2 + 1)
	    _this4.gotoPage(_this4.state.currentPage + _this4.pageNeighbours * 2 + 1);
	  };
	
	  this.fetchPageNumbers = function () {
	    var totalPages = _this4.state.totalPages;
	    var currentPage = _this4.state.currentPage;
	    var pageNeighbours = _this4.pageNeighbours;
	    /**
	     * totalNumbers: the total page numbers to show on the control
	     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
	     */
	    var totalNumbers = _this4.pageNeighbours * 2 + 3;
	    var totalBlocks = totalNumbers + 2;
	    if (totalPages > totalBlocks) {
	      var startPage = Math.max(2, currentPage - pageNeighbours);
	      var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
	      var pages = range(startPage, endPage);
	      /**
	       * hasLeftSpill: has hidden pages to the left
	       * hasRightSpill: has hidden pages to the right
	       * spillOffset: number of hidden pages either to the left or to the right
	       */
	      var hasLeftSpill = startPage > 2;
	      var hasRightSpill = totalPages - endPage > 1;
	      var spillOffset = totalNumbers - (pages.length + 1);
	      switch (true) {
	        // handle: (1) < {5 6} [7] {8 9} (10)
	        case hasLeftSpill && !hasRightSpill:
	          {
	            var extraPages = range(startPage - spillOffset, startPage - 1);
	            pages = [LEFT_PAGE].concat(_toConsumableArray(extraPages), _toConsumableArray(pages));
	            break;
	          }
	        // handle: (1) {2 3} [4] {5 6} > (10)
	        case !hasLeftSpill && hasRightSpill:
	          {
	            var _extraPages = range(endPage + 1, endPage + spillOffset);
	            pages = [].concat(_toConsumableArray(pages), _toConsumableArray(_extraPages), [RIGHT_PAGE]);
	            break;
	          }
	
	        // handle: (1) < {4 5} [6] {7 8} > (10)
	        case hasLeftSpill && hasRightSpill:
	        default:
	          {
	            pages = [LEFT_PAGE].concat(_toConsumableArray(pages), [RIGHT_PAGE]);
	            break;
	          }
	      }
	      return [1].concat(_toConsumableArray(pages), [totalPages]);
	    }
	    return range(1, totalPages);
	  };
	};
	
	exports.default = CommonDetailStatus;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pStyle = {
	  fontSize: '15px',
	  color: 'red'
	};
	
	var CommonFilter = function (_Component) {
	  _inherits(CommonFilter, _Component);
	
	  function CommonFilter(props) {
	    _classCallCheck(this, CommonFilter);
	
	    var _this = _possibleConstructorReturn(this, (CommonFilter.__proto__ || Object.getPrototypeOf(CommonFilter)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({ alert_status: !_this.state.alert_status });
	    };
	
	    _this.goPremium = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.state = {
	      searchBy: _this.props.searchBy === 'questionID' ? 'questionID' : 'chapterID',
	      answered: 'false',
	      filterBy: '',
	      selectedChapter: _this.props.selectedChapter,
	      showError: false,
	      showErrorNumber: false,
	      subscriptionstatus: _this.props.subscriptionstatus,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      alert_status: false,
	      selectedmenu: 'cfa'
	    };
	    return _this;
	  }
	
	  _createClass(CommonFilter, [{
	    key: 'searchByQuestionID',
	    value: function searchByQuestionID() {
	      if (this.props.subscriptionstatus === 'free') {
	        this.toggleAlert();
	      } else {
	        this.setState({
	          filterBy: '',
	          answered: 'false',
	          searchBy: 'questionID',
	          showError: false
	        });
	        this.props.resetAllQuestion();
	      }
	    }
	  }, {
	    key: 'searchByChapterID',
	    value: function searchByChapterID() {
	      this.setState({
	        answered: 'false',
	        searchBy: 'chapterID',
	        showError: false,
	        filterBy: ''
	      });
	      this.props.resetAllChapter();
	    }
	  }, {
	    key: 'onChangeQuestion',
	    value: function onChangeQuestion(e) {
	      var ageValue = e.target.value;
	      if (isNaN(ageValue) || ageValue < 0) {
	        return;
	      } else {
	        this.setState({ selectedChapter: e.target.value, showError: false });
	        this.props.onChangeQuestion(e);
	      }
	    }
	  }, {
	    key: 'onChangeChapter',
	    value: function onChangeChapter(e) {
	      console.log('e.target', e.target);
	      this.setState({ selectedChapter: e.target.value, showError: false });
	      this.props.onChangeChapter(e);
	    }
	  }, {
	    key: 'onChangeReading',
	    value: function onChangeReading(e) {
	      this.props.onChangeReading(e);
	    }
	  }, {
	    key: 'onChangeAnswered',
	    value: function onChangeAnswered(e) {
	      // console.log(e.target.value)
	      if (e.target.value === this.state.answered) {
	        this.props.onChangeAnswered(e);
	      } else {
	        this.setState({ answered: e.target.value });
	        this.props.onChangeAnswered(e);
	      }
	    }
	  }, {
	    key: 'onChangeNoOfAttempts',
	    value: function onChangeNoOfAttempts(e) {
	      this.props.onChangeNoOfAttempts(e);
	    }
	  }, {
	    key: 'onChangeAvgScore',
	    value: function onChangeAvgScore(e) {
	      // console.log(e);
	      this.props.onChangeAvgScore(e);
	    }
	  }, {
	    key: 'onChangePass',
	    value: function onChangePass(e) {
	      if (e.target.value === 'FAIL') {
	        this.setState({ filterBy: 'FAIL' });
	        this.props.onChangePass(e);
	      } else if (e.target.value === 'PASS') {
	        this.setState({ filterBy: 'PASS' });
	        this.props.onChangePass(e);
	      } else {
	        this.setState({ filterBy: '' });
	        this.props.onChangePass(e);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // console.log(this.props.selectedChapter)
	      this.setState({
	        selectedChapter: this.props.selectedChapter,
	        subscriptionstatus: this.props.subscriptionstatus
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prepProps, prevState) {
	      if (prepProps.selectedChapter !== this.state.selectedChapter) {
	        // console.log(this.props.selectedChapter)
	        this.setState({
	          selectedChapter: this.props.selectedChapter,
	          subscriptionstatus: this.props.subscriptionstatus
	        });
	      }
	    }
	  }, {
	    key: 'filerSubmitFun',
	    value: function filerSubmitFun(e) {
	      e.preventDefault();
	      // console.log(this.state.selectedChapter)
	      // console.log(this.props.selectedChapter)
	      if (this.props.subscriptionstatus === 'free') {
	        this.toggleAlert();
	      } else {
	        if (this.state.selectedChapter === '' && this.state.searchBy === 'chapterID') {
	          this.setState({ showError: true });
	        } else {
	          this.setState({ showError: false });
	          this.props.filerSubmit(e);
	        }
	      }
	    }
	  }, {
	    key: 'resetAll',
	    value: function resetAll(e) {
	      e.preventDefault();
	      this.setState({ showError: false, answered: 'false' });
	      if (this.state.searchBy === 'questionID') {
	        this.props.resetAllQuestion(e);
	      } else if (this.state.searchBy === 'chapterID') {
	        this.props.resetAllChapter(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(this.props.searchBy)
	      // console.log(this.state.searchBy)
	      // console.log(this.props.selectedChapter)
	      // console.log(this.state.selectedChapter)
	      // console.log(this.state.subscriptionstatus);
	      var readingData = this.props.readingData;
	      var chapterData = this.props.chapterData;
	      // const { subscriptionstatus }=this.props
	
	      var searchBy = this.state.searchBy;
	      // console.log("chapterData");
	      // console.log(chapterData);
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-toggle-btn' },
	          _react2.default.createElement(
	            'p',
	            null,
	            ' ',
	            _language2.default.LC().Filter_By,
	            ' -'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'filter-subnav' },
	            _react2.default.createElement(
	              'li',
	              {
	                onClick: this.searchByQuestionID.bind(this),
	                className: searchBy === 'questionID' ? 'active' : ''
	              },
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                _language2.default.LC().QUESTION_ID,
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              {
	                onClick: this.searchByChapterID.bind(this),
	                className: searchBy === 'chapterID' ? 'active' : ''
	              },
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                _language2.default.LC().CHAPTER,
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          ' ',
	          this.state.showErrorNumber ? _react2.default.createElement(
	            'label',
	            { style: pStyle },
	            ' *',
	            _language2.default.LC().Please_Enter_Number_Only,
	            ' '
	          ) : null,
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          ' ',
	          this.state.showError ? _react2.default.createElement(
	            'label',
	            { style: pStyle },
	            ' *',
	            _language2.default.LC().Please_select_Chapter_ID,
	            ' '
	          ) : null,
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-head-wrapper question-list-filter-search' },
	          this.state.searchBy === 'questionID' ? _react2.default.createElement(
	            'div',
	            { className: 'question-filter-search-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                ' ',
	                _language2.default.LC().Question_ID,
	                ' '
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                min: '1',
	                onChange: this.onChangeQuestion.bind(this),
	                className: 'form-control form-control',
	                value: this.props.selectedQuestion
	              })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'chapter-filter-search-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'chapter-fitler-search-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' ',
	                  _language2.default.LC().Chapter_Name,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    name: 'category_id',
	                    onChange: this.onChangeChapter.bind(this),
	                    className: 'form-control form-control',
	                    value: this.props.selectedChapter
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' ',
	                    _language2.default.LC().SELECT,
	                    ' '
	                  ),
	                  chapterData && chapterData.length ? chapterData.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.chapterId },
	                      ' ',
	                      item.chapterName,
	                      ' '
	                    );
	                  }) : _react2.default.createElement(
	                    'option',
	                    null,
	                    '--'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' ',
	                  _language2.default.LC().Reading_Name,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    name: 'category_id',
	                    onChange: this.onChangeReading.bind(this),
	                    className: 'form-control form-control',
	                    value: this.props.selectedReading
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' ',
	                    _language2.default.LC().SELECT,
	                    ' '
	                  ),
	                  readingData && readingData.length ? readingData.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.id },
	                      ' ',
	                      item.reading,
	                      ' '
	                    );
	                  }) : _react2.default.createElement(
	                    'option',
	                    null,
	                    '--'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  _language2.default.LC().ANSWERED
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    name: 'category_id',
	                    onChange: this.onChangeAnswered.bind(this),
	                    className: 'form-control form-control',
	                    value: this.props.Answered
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    _language2.default.LC().SELECT,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'true' },
	                    _language2.default.LC().ANSWERED
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'false' },
	                    ' ',
	                    _language2.default.LC().Non_ANSWERED,
	                    ' '
	                  )
	                )
	              )
	            ),
	            this.state.answered === 'true' ? _react2.default.createElement(
	              'div',
	              { className: 'chapter-fitler-search-block select-search' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' ',
	                  _language2.default.LC().No_of_attempts,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    name: 'category_id',
	                    onChange: this.onChangeNoOfAttempts.bind(this),
	                    className: 'form-control form-control',
	                    value: this.props.selectedAttempt
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' ',
	                    _language2.default.LC().SELECT,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    '1'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    '2'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '3' },
	                    '3'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '4' },
	                    '4'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '5' },
	                    '5'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '6' },
	                    '6'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '7' },
	                    '7'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '8' },
	                    '8'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '9' },
	                    '9+'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' ',
	                  _language2.default.LC().AVERAGE_SCORE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    name: 'category_id',
	                    onChange: this.onChangeAvgScore.bind(this),
	                    className: 'form-control form-control',
	                    value: this.props.selectedAvgScore
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' ',
	                    _language2.default.LC().SELECT,
	                    ' '
	                  ),
	                  this.state.filterBy === '' ? _react2.default.createElement(
	                    'option',
	                    { value: '0' },
	                    ' 0 - 25'
	                  ) : this.state.filterBy === 'FAIL' ? _react2.default.createElement(
	                    'option',
	                    { value: '0' },
	                    ' 0 - 25'
	                  ) : null,
	                  this.state.filterBy === '' ? _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    ' 25 - 50'
	                  ) : this.state.filterBy === 'FAIL' ? _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    ' 25 - 50'
	                  ) : null,
	                  this.state.filterBy === '' ? _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    ' 50 - 75'
	                  ) : this.state.filterBy === 'FAIL' ? _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    ' 50 - 70'
	                  ) : null,
	                  this.state.filterBy === '' ? _react2.default.createElement(
	                    'option',
	                    { value: '3' },
	                    ' 75 - 100'
	                  ) : this.state.filterBy === 'PASS' ? _react2.default.createElement(
	                    'option',
	                    { value: '3' },
	                    ' 70 - 100'
	                  ) : null
	                )
	              )
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group apply-filter-btn' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary',
	                value: this.state.selectedQuestion,
	                onClick: this.filerSubmitFun.bind(this)
	              },
	              _react2.default.createElement('i', { className: 'fa fa-search' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-danger', onClick: this.resetAll.bind(this) },
	              _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true' })
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return CommonFilter;
	}(_react.Component);
	
	CommonFilter.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = CommonFilter;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var SignUpApproval = function (_Component) {
	  _inherits(SignUpApproval, _Component);
	
	  function SignUpApproval(props) {
	    _classCallCheck(this, SignUpApproval);
	
	    var _this = _possibleConstructorReturn(this, (SignUpApproval.__proto__ || Object.getPrototypeOf(SignUpApproval)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(SignUpApproval, [{
	    key: "signUpAlertModel",
	    value: function signUpAlertModel(e) {
	      e.preventDefault();
	      this.props.signUpAlertModel(e);
	    }
	  }, {
	    key: "signUpAlertModelClose",
	    value: function signUpAlertModelClose(e) {
	      e.preventDefault();
	      this.props.signUpAlertModelClose(e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          signupAlert = _props.signupAlert,
	          signUpAlertModelClose = _props.signUpAlertModelClose;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: signupAlert,
	          toggle: this.signUpAlertModel.bind(this),
	          className: "modal-primary custom_modalpro info-modal-designing" + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          {
	            toggle: this.signUpAlertModel.bind(this),
	            className: "custom-title"
	          },
	          _language2.default.LC().SIGNUP_Approval_HEADING
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: "text-center payment-section-wrap" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-info-view-for-plan " },
	            _react2.default.createElement("img", {
	              src: _App_data2.default.frontend_url + "/img/" + "cloud-computing.png",
	              className: "mb-2",
	              width: "90px",
	              height: "90px",
	              alt: ""
	            }),
	            _react2.default.createElement(
	              "p",
	              null,
	              _language2.default.LC().SIGNUP_Approval_BODY_1
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "p",
	              null,
	              _language2.default.LC().SIGNUP_Approval_BODY_2,
	              " "
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "btn btn-primary pointer_class",
	                onClick: this.signUpAlertModelClose.bind(this)
	              },
	              _language2.default.LC().GO_TO_ANSWER
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignUpApproval;
	}(_react.Component);
	
	exports.default = SignUpApproval;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SidebarIndex = function (_Component) {
	  _inherits(SidebarIndex, _Component);
	
	  function SidebarIndex(props) {
	    _classCallCheck(this, SidebarIndex);
	
	    var _this = _possibleConstructorReturn(this, (SidebarIndex.__proto__ || Object.getPrototypeOf(SidebarIndex)).call(this, props));
	
	    _this.slider = '';
	    return _this;
	  }
	
	  _createClass(SidebarIndex, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          itemArray = _props.itemArray,
	          currentIndex = _props.currentIndex,
	          _props$flaggedQuesObj = _props.flaggedQuesObject,
	          flaggedQuesObject = _props$flaggedQuesObj === undefined ? {} : _props$flaggedQuesObj,
	          _props$attemptedQuesO = _props.attemptedQuesObject,
	          attemptedQuesObject = _props$attemptedQuesO === undefined ? {} : _props$attemptedQuesO,
	          slidesToShow = _props.slidesToShow,
	          _props$initialSlide = _props.initialSlide,
	          initialSlide = _props$initialSlide === undefined ? 0 : _props$initialSlide,
	          _onClick = _props.onClick,
	          _props$finishPage = _props.finishPage,
	          finishPage = _props$finishPage === undefined ? false : _props$finishPage,
	          parentCallback = _props.parentCallback,
	          _props$sliderSetting = _props.sliderSetting,
	          sliderSetting = _props$sliderSetting === undefined ? {} : _props$sliderSetting;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'qus-tab-wrapper mr-0' },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          Object.assign({}, Object.assign({
	            dots: false,
	            infinite: false,
	            speed: 250,
	            arrows: true,
	            vertical: true,
	            slidesToShow: slidesToShow,
	            slidesToScroll: 2,
	            initialSlide: initialSlide
	          }, sliderSetting), {
	            ref: function ref(slider) {
	              _this2.slider = slider;
	              parentCallback && parentCallback({ slider: slider });
	            }
	          }),
	          itemArray.map(function (item, index) {
	            return _react2.default.createElement(
	              _reactstrap.Button,
	              {
	                key: index,
	                onClick: function onClick() {
	                  _onClick(index);
	                },
	                className: 'w-auto ' + (index === parseInt(currentIndex, 10) ? 'active' : '') + ' ' + (attemptedQuesObject[item.id] ? 'completed-qus' : '') + ' ' + (finishPage && (attemptedQuesObject[item.id] ? item.correct_choice === attemptedQuesObject[item.id] ? 'right-ans' : 'wrong-ans' : 'not-ans'))
	              },
	              index + 1,
	              flaggedQuesObject[item.id] ? _react2.default.createElement('img', {
	                width: '70',
	                src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                alt: 'Question'
	              }) : null
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return SidebarIndex;
	}(_react.Component);
	
	exports.default = SidebarIndex;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TooltipItem = function (_Component) {
	  _inherits(TooltipItem, _Component);
	
	  function TooltipItem(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TooltipItem);
	
	    var _this = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this.isTooltipToggle = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.setState({ tooltipOpen: !_this.state.tooltipOpen });
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      tooltipOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'render',
	    value: function render() {
	      var tooltipOpen = this.state.tooltipOpen;
	      var _props = this.props,
	          content = _props.content,
	          place_tip = _props.place_tip,
	          tooltipId = _props.tooltipId;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + tooltipId,
	          alt: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: place_tip,
	            isOpen: tooltipOpen,
	            target: 'Tooltip-' + tooltipId,
	            toggle: this.isTooltipToggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react.Component);
	
	exports.default = TooltipItem;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Report = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _services = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Report = exports.Report = function (_Component) {
	  _inherits(Report, _Component);
	
	  function Report(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Report);
	
	    var _this = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this, props));
	
	    _this.report = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var comment, _this$props, commentOnWhichId, _this$props$section, section, mockData, data, apiService, response;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              comment = _this.state.comment;
	              _this$props = _this.props, commentOnWhichId = _this$props.commentOnWhichId, _this$props$section = _this$props.section, section = _this$props$section === undefined ? '' : _this$props$section, mockData = _this$props.mockData;
	
	              _this.setState({ reportLoading: true });
	              data = Object.assign({}, (0, _services.getTokenAndEmail)(), {
	                commentOnWhichId: commentOnWhichId,
	                comment: comment,
	                mockData: mockData
	              });
	              apiService = _services.reportQuestion;
	              _context.t0 = section.toLowerCase();
	              _context.next = _context.t0 === 'cbt' ? 8 : _context.t0 === 'video' ? 10 : 12;
	              break;
	
	            case 8:
	              apiService = _services.reportCBTQuestion;
	              return _context.abrupt('break', 14);
	
	            case 10:
	              apiService = _services.mutateReportVideo;
	              return _context.abrupt('break', 14);
	
	            case 12:
	              apiService = _services.reportQuestion;
	              return _context.abrupt('break', 14);
	
	            case 14:
	              _context.next = 16;
	              return apiService(data);
	
	            case 16:
	              response = _context.sent;
	
	              if (response.success) {
	                _this.setState({ successAlert: true, comment: '' });
	              }
	              _this.setState({ reportLoading: false });
	
	            case 19:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      reportLoading: false,
	      successAlert: false,
	      comment: ''
	    };
	    return _this;
	  }
	
	  _createClass(Report, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          comment = _state.comment;
	      var hideReportSection = this.props.hideReportSection;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    onChange: function onChange(event) {
	                      return _this3.setState(_defineProperty({}, event.target.name, event.target.value));
	                    },
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    value: comment,
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this.report
	                    },
	                    reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: hideReportSection
	                    },
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: hideReportSection
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Report;
	}(_react.Component);
	
	exports.default = Report;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(1236).Transform;
	var inherits = __webpack_require__(47);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 192 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 193 */
/***/ function(module, exports) {

	module.exports = (function () {
	  if (typeof self !== 'undefined') {
	    return self;
	  } else if (typeof window !== 'undefined') {
	    return window;
	  } else {
	    return Function('return this')(); // eslint-disable-line no-new-func
	  }
	})();


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(107);
	var Emitter = __webpack_require__(196);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // results of ReactNative environment detection
	  this.isReactNative = opts.isReactNative;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(1044);
	var globalThis = __webpack_require__(193);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new globalThis[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notes_icon4.1bf0fcdb.svg";

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1254);
	module.exports = self.fetch.bind(self);


/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1060);
	moment.tz.load(__webpack_require__(1051));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(109);
	var Danger = __webpack_require__(1079);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(60);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(212);
	var setInnerHTML = __webpack_require__(158);
	var setTextContent = __webpack_require__(460);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactErrorUtils = __webpack_require__(210);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 207 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactPropTypesSecret = __webpack_require__(1108);
	var propTypesFactory = __webpack_require__(438);
	
	var React = __webpack_require__(115);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(82);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(70);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 214 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var emptyFunction = __webpack_require__(57);
	var warning = __webpack_require__(27);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(1154);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(463);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ },
/* 220 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(21);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _getRouteParams = __webpack_require__(1169);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(221);
	
	var _RouteUtils = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(114);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _DOMStateStorage = __webpack_require__(474);
	
	var _PathUtils = __webpack_require__(91);
	
	var _ExecutionEnvironment = __webpack_require__(225);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 225 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1175);
	
	var _PathUtils = __webpack_require__(91);
	
	var _runTransitionHook = __webpack_require__(227);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(159);
	
	var _LocationUtils = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.providerContextTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(163);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO(jez) 'sync' and 'async' are bad tag names.
	// TODO(jez) What if redux also uses this.context.tag?
	var providerContextTypes = exports.providerContextTypes = {
	  tag: _propTypes2.default.string.isRequired,
	  stripe: _propTypes2.default.object,
	  addStripeLoadListener: _propTypes2.default.func
	};
	
	var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
	  /**
	   * Note that this is not meant to be a generic memoization solution.
	   * This is specifically a solution for `StripeProvider`s being initialized
	   * and destroyed regularly (with the same set of props) when users only
	   * use `StripeProvider` for the subtree that contains their checkout form.
	   */
	  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	
	  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	  window.Stripe.__cachedInstances[cacheKey] = stripe;
	
	  return stripe;
	};
	
	var ensureStripeShape = function ensureStripeShape(stripe) {
	  if (stripe && stripe.elements && stripe.createSource && stripe.createToken && stripe.createPaymentMethod && stripe.handleCardPayment) {
	    return stripe;
	  } else {
	    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
	  }
	};
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  // on the other hand: childContextTypes is *required* to use context.
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (_this.props.apiKey && _this.props.stripe) {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
	    } else if (_this.props.apiKey) {
	      if (!window.Stripe) {
	        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
	      } else {
	        var _this$props = _this.props,
	            _apiKey = _this$props.apiKey,
	            _children = _this$props.children,
	            _stripe = _this$props.stripe,
	            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);
	
	        _this._meta = {
	          tag: 'sync',
	          stripe: getOrCreateStripe(_apiKey, options)
	        };
	      }
	    } else if (_this.props.stripe) {
	      // If we already have a stripe instance (in the constructor), we can behave synchronously.
	      _this._meta = {
	        tag: 'sync',
	        stripe: ensureStripeShape(_this.props.stripe)
	      };
	    } else if (_this.props.stripe === null) {
	      _this._meta = {
	        tag: 'async',
	        stripe: null
	      };
	    } else {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
	    }
	
	    _this._didWarn = false;
	    _this._didWakeUpListeners = false;
	    _this._listeners = [];
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    // getChildContext is run after the constructor, so we WILL have access to
	    // the initial state.
	    //
	    // However, context doesn't update in respnse to state changes like you
	    // might expect: context is pulled by the child, not pushed by the parent.
	    if (this._meta.tag === 'sync') {
	      return {
	        tag: 'sync',
	        stripe: this._meta.stripe
	      };
	    } else {
	      return {
	        tag: 'async',
	        addStripeLoadListener: function addStripeLoadListener(fn) {
	          if (_this2._meta.stripe) {
	            fn(_this2._meta.stripe);
	          } else {
	            _this2._listeners.push(fn);
	          }
	        }
	      };
	    }
	  };
	
	  Provider.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var apiKeyChanged = this.props.apiKey && prevProps.apiKey && this.props.apiKey !== prevProps.apiKey;
	
	    var stripeInstanceChanged = this.props.stripe && prevProps.stripe && this.props.stripe !== prevProps.stripe;
	    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
	      this._didWarn = true;
	      // eslint-disable-next-line no-console
	      console.error('StripeProvider does not support changing the apiKey parameter.');
	      return;
	    }
	
	    if (!this._didWakeUpListeners && this.props.stripe) {
	      // Wake up the listeners if we've finally been given a StripeShape
	      this._didWakeUpListeners = true;
	      var _stripe2 = ensureStripeShape(this.props.stripe);
	      this._meta.stripe = _stripe2;
	      this._listeners.forEach(function (fn) {
	        fn(_stripe2);
	      });
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string,
	  // PropTypes.object is the only way we can accept a Stripe instance
	  // eslint-disable-next-line react/forbid-prop-types
	  stripe: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = providerContextTypes;
	Provider.defaultProps = {
	  apiKey: undefined,
	  stripe: undefined,
	  children: null
	};
	exports.default = Provider;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(1233)('socket.io-parser');
	var Emitter = __webpack_require__(1232);
	var binary = __webpack_require__(1231);
	var isArray = __webpack_require__(490);
	var isBuf = __webpack_require__(489);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	var ERROR_PACKET = exports.ERROR + '"encode error"';
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    encodeAsBinary(obj, callback);
	  } else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	
	  // first is type
	  var str = '' + obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    str += obj.attachments + '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' !== obj.nsp) {
	    str += obj.nsp + ',';
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    var payload = tryStringify(obj.data);
	    if (payload !== false) {
	      str += payload;
	    } else {
	      return ERROR_PACKET;
	    }
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	function tryStringify(str) {
	  try {
	    return JSON.stringify(str);
	  } catch(e){
	    return false;
	  }
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder(opts) {
	  this.reconstructor = null;
	  opts = opts || {};
	  this.opts = {
	    maxAttachments: opts.maxAttachments || 10,
	  };
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an encoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if (typeof obj === 'string') {
	    if (this.reconstructor) {
	      throw new Error("got plaintext data when reconstructing a packet");
	    }
	    packet = decodeString(obj, this.opts.maxAttachments);
	    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  } else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  } else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	function isPayloadValid(type, payload) {
	  switch (type) {
	    case 0: // CONNECT
	      return typeof payload === "object";
	    case 1: // DISCONNECT
	      return payload === undefined;
	    case 4: // ERROR
	      return typeof payload === "string" || typeof payload === "object";
	    case 2: // EVENT
	    case 5: // BINARY_EVENT
	      return (
	        isArray(payload) &&
	        (typeof payload[0] === "string" || typeof payload[0] === "number")
	      );
	    case 3: // ACK
	    case 6: // BINARY_ACK
	      return isArray(payload);
	  }
	}
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @param {Number} maxAttachments - the maximum number of binary attachments
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str, maxAttachments) {
	  var i = 0;
	  // look up type
	  var p = {
	    type: Number(str.charAt(0))
	  };
	
	  if (null == exports.types[p.type]) {
	    return error('unknown packet type ' + p.type);
	  }
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
	    var start = i + 1;
	    while (str.charAt(++i) !== '-' && i != str.length) {}
	    var buf = str.substring(start, i);
	    if (buf != Number(buf) || str.charAt(i) !== '-') {
	      throw new Error('Illegal attachments');
	    }
	    var n = Number(buf);
	    if (!isInteger(n) || n < 1) {
	      throw new Error("Illegal attachments");
	    } else if (n > maxAttachments) {
	      throw new Error("too many attachments");
	    }
	    p.attachments = n;
	  }
	
	  // look up namespace (if any)
	  if ('/' === str.charAt(i + 1)) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' === c) break;
	      if (i === str.length) break;
	    }
	    p.nsp = str.substring(start, i);
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      if (i === str.length) break;
	    }
	    p.id = Number(str.substring(start, i + 1));
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    var payload = tryParse(str.substr(i));
	    if (isPayloadValid(p.type, payload)) {
	      p.data = payload;
	    } else {
	      throw new Error("invalid payload");
	    }
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(str) {
	  try {
	    return JSON.parse(str);
	  } catch(e){
	    return false;
	  }
	}
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(msg) {
	  return {
	    type: exports.ERROR,
	    data: 'parser error: ' + msg
	  };
	}
	
	var isInteger =
	  Number.isInteger ||
	  function (value) {
	    return (
	      typeof value === "number" &&
	      isFinite(value) &&
	      Math.floor(value) === value
	    );
	  };


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(153);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(120);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1252)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(494);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(130).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(493);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(101);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(101);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48), __webpack_require__(1247).setImmediate, (function() { return this; }())))

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(491);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(230);
	exports.Duplex = __webpack_require__(101);
	exports.Transform = __webpack_require__(492);
	exports.PassThrough = __webpack_require__(1239);


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1253);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(47);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var settle = __webpack_require__(508);
	var buildURL = __webpack_require__(240);
	var parseHeaders = __webpack_require__(515);
	var isURLSameOrigin = __webpack_require__(513);
	var createError = __webpack_require__(236);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(511);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 234 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(507);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    }
	  });
	
	  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
	    if (utils.isObject(config2[prop])) {
	      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
	    } else if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (utils.isObject(config1[prop])) {
	      config[prop] = utils.deepMerge(config1[prop]);
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  utils.forEach([
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
	    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
	    'socketPath'
	  ], function defaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  return config;
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(53);
	var normalizeHeaderName = __webpack_require__(514);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  // Only Node.JS has a process variable that is of [[Class]] process
	  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(233);
	  } else if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(233);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForwardTimer = function (_Component) {
	  _inherits(ForwardTimer, _Component);
	
	  function ForwardTimer(props) {
	    _classCallCheck(this, ForwardTimer);
	
	    var _this = _possibleConstructorReturn(this, (ForwardTimer.__proto__ || Object.getPrototypeOf(ForwardTimer)).call(this, props));
	
	    _this.startTimer = function () {
	      if (!_this.timer) {
	        _this.timer = setInterval(function () {
	          _this.setState(function (prevState) {
	            return { seconds: prevState.seconds + 1 };
	          }, function () {
	            if (typeof _this.props.onTick === 'function') {
	              _this.props.onTick(_this.state.seconds);
	            }
	          });
	        }, 1000);
	      }
	    };
	
	    _this.stopTimer = function () {
	      if (_this.timer) {
	        clearInterval(_this.timer);
	        _this.timer = null;
	      }
	    };
	
	    _this.state = {
	      seconds: props.startTimeInSeconds || 0
	    };
	    _this.timer = null;
	    return _this;
	  }
	
	  _createClass(ForwardTimer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof this.props.onTick === 'function') {
	        this.props.onTick(this.state.seconds);
	      }
	
	      if (this.props.isRunning) {
	        this.startTimer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      // Update time if start time changed
	      if (prevProps.startTimeInSeconds !== this.props.startTimeInSeconds) {
	        this.setState({ seconds: this.props.startTimeInSeconds || 0 }, function () {
	          if (typeof _this2.props.onTick === 'function') {
	            _this2.props.onTick(_this2.state.seconds);
	          }
	        });
	      }
	
	      // Handle isRunning change
	      if (prevProps.isRunning !== this.props.isRunning) {
	        if (this.props.isRunning) {
	          this.startTimer();
	        } else {
	          this.stopTimer();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopTimer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var seconds = this.state.seconds;
	      var _props = this.props,
	          isRunning = _props.isRunning,
	          validated = _props.validated;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'timer_outer' },
	          _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'timer_box' },
	            (0, _function.formatTime)(seconds)
	          )
	        ),
	        _react2.default.createElement('button', {
	          type: 'button',
	          'aria-label': isRunning ? 'Pause timer' : 'Resume timer',
	          className: 'pause_btn icon-control-' + (isRunning ? 'pause' : 'play'),
	          onClick: this.props.toggleTimer,
	          disabled: validated
	        })
	      );
	    }
	  }]);
	
	  return ForwardTimer;
	}(_react.Component);
	
	exports.default = ForwardTimer;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _constant = __webpack_require__(9);
	
	var _questionUtils = __webpack_require__(168);
	
	var _questionConfigs = __webpack_require__(167);
	
	var _RatingComponent = __webpack_require__(173);
	
	var _RatingComponent2 = _interopRequireDefault(_RatingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GraphicalStatement = function (_Component) {
	  _inherits(GraphicalStatement, _Component);
	
	  function GraphicalStatement(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GraphicalStatement);
	
	    var _this = _possibleConstructorReturn(this, (GraphicalStatement.__proto__ || Object.getPrototypeOf(GraphicalStatement)).call(this, props));
	
	    _this.setDropdown1Ref = function (element) {
	      _this.dropdown1Ref = element;
	    };
	
	    _this.setDropdown2Ref = function (element) {
	      _this.dropdown2Ref = element;
	    };
	
	    _this.setUserSelectedChoices = function (index, questions) {
	      var questionData = questions || _this.state.questionData;
	      var currentQuestion = questionData[index];
	      var _this$props$stateTabl = _this.props.stateTableName,
	          stateTableName = _this$props$stateTabl === undefined ? 'gmat_focus_question_stat' : _this$props$stateTabl;
	
	      var stat = currentQuestion[stateTableName];
	
	      var _getUserSelectedChoic = (0, _questionUtils.getUserSelectedChoices)({
	        question: currentQuestion,
	        stat: stat,
	        config: _questionConfigs.graphicalStatementConfig
	      }),
	          selectedOptions = _getUserSelectedChoic.selectedOptions,
	          extraState = _getUserSelectedChoic.extraState;
	
	      if (selectedOptions && extraState.statement1 && extraState.statement2) {
	        _this.setState(Object.assign({}, extraState, { selectedOptions: selectedOptions }), function () {
	          _this.handleValidate(false);
	        });
	      }
	    };
	
	    _this.handleSetCurrentQuestion = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(questions) {
	        var questionId, index, selectedIndex, currentQuestion;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	                questionId = _this.props.params.question_id;
	                index = questions.findIndex(function (question) {
	                  return question.id === +questionId;
	                }) || 0;
	                selectedIndex = index > -1 ? index : 0;
	                currentQuestion = questions[selectedIndex];
	
	
	                _this.setState({
	                  currentIndex: selectedIndex,
	                  currentQuestion: currentQuestion,
	                  isLoading: false
	                });
	
	                if (currentQuestion) {
	                  _this.getSavedQuestion(currentQuestion.id);
	                  _this.getQuestionRating(currentQuestion.id);
	                  if (_this.isRevisionMode) {
	                    _this.setUserSelectedChoices(selectedIndex, questions);
	                  } else {
	                    _this.resetStates();
	                  }
	                }
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, questionId, reading, bookmarkCSS, _this$props, apiServices, type, _this$props$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, questionId = _this$state.questionId, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props = _this.props, apiServices = _this$props.apiServices, type = _this$props.questionType, _this$props$params = _this$props.params, reading_id = _this$props$params.readingid, question_id = _this$props$params.question_id, topic_name = _this$props$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: question_id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context2.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context2.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(questionId) {
	        var _this$props2, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this$props2 = _this.props, apiServices = _this$props2.apiServices, params = _this$props2.params, type = _this$props2.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context3.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context3.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.getQuestionRating = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(question_id) {
	        var _this$props3, apiServices, type, params, response, success, ratting, questionRating;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType;
	                params = {
	                  question_id: question_id,
	                  type: type
	                };
	                _context4.prev = 2;
	                _context4.next = 5;
	                return apiServices.fetchRating(params);
	
	              case 5:
	                response = _context4.sent;
	                success = response.success, ratting = response.ratting;
	
	                if (success && ratting && ratting.length > 0) {
	                  //TODO Change the API and fetch rating in object not array
	                  questionRating = response.ratting[0].ratting;
	
	
	                  _this.setState({
	                    questionRating: questionRating,
	                    questionRatingTitle: _messages.messages.RATED
	                  });
	                }
	                _context4.next = 13;
	                break;
	
	              case 10:
	                _context4.prev = 10;
	                _context4.t0 = _context4['catch'](2);
	
	                console.error('Error handling....', _context4.t0);
	
	              case 13:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2, [[2, 10]]);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.handleQuestionRating = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(item, nextValue, prevValue, name) {
	        var question_id, _this$props4, apiServices, type, updatePayload, updateRatingResponse, fetchPayload, response, success, ratting, latestRating, savePayload, saveRatingResponse;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                question_id = item.id;
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, type = _this$props4.questionType;
	                _context5.prev = 2;
	
	                if (!(prevValue !== nextValue)) {
	                  _context5.next = 9;
	                  break;
	                }
	
	                updatePayload = { question_id: question_id, ratting: nextValue, type: type };
	                _context5.next = 7;
	                return apiServices.updateQuestionRating(updatePayload);
	
	              case 7:
	                updateRatingResponse = _context5.sent;
	
	
	                if (updateRatingResponse.success) {
	                  _this.setState({ questionRatingTitle: _messages.messages.RATED });
	                }
	
	              case 9:
	
	                _this.setState({ rating: nextValue });
	
	                // Check if a rating already exists
	                fetchPayload = { question_id: question_id, type: type };
	                _context5.next = 13;
	                return apiServices.fetchRating(fetchPayload);
	
	              case 13:
	                response = _context5.sent;
	                success = response.success, ratting = response.ratting;
	
	                if (!(success && ratting && ratting.length > 0)) {
	                  _context5.next = 20;
	                  break;
	                }
	
	                //TODO Change the API and fetch rating in object not array
	                latestRating = response.ratting[0].ratting;
	
	                _this.setState({
	                  questionRating: latestRating,
	                  questionRatingTitle: '' + _messages.messages.RATED
	                });
	                _context5.next = 25;
	                break;
	
	              case 20:
	                // Save a new rating
	                savePayload = {
	                  question_id: question_id,
	                  ratting: nextValue,
	                  type: type
	                };
	                _context5.next = 23;
	                return apiServices.saveRating(savePayload);
	
	              case 23:
	                saveRatingResponse = _context5.sent;
	
	
	                if (saveRatingResponse.success) {
	                  _this.setState({
	                    questionRatingTitle: _messages.messages.RATED,
	                    questionRating: nextValue
	                  });
	                }
	
	              case 25:
	                _context5.next = 30;
	                break;
	
	              case 27:
	                _context5.prev = 27;
	                _context5.t0 = _context5['catch'](2);
	
	                console.error('Error handling....', _context5.t0);
	
	              case 30:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2, [[2, 27]]);
	      }));
	
	      return function (_x4, _x5, _x6, _x7) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        statement1: '',
	        questionRating: 0,
	        statement2: '',
	        isError: false,
	        selectedOptions: {},
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.redirectToNextPreviousQuestion = function (index) {
	      var _this$state2 = _this.state,
	          questionData = _this$state2.questionData,
	          isUserSubscribed = _this$state2.isUserSubscribed;
	      var _this$props5 = _this.props,
	          handleChangeParams = _this$props5.handleChangeParams,
	          params = _this$props5.params;
	
	      var currentQuestion = questionData[index];
	
	      if (!currentQuestion) return;
	
	      handleChangeParams({ index: index, question_id: currentQuestion.id });
	
	      _this.setState({
	        currentIndex: index,
	        currentQuestion: currentQuestion
	      });
	
	      _this.getSavedQuestion(currentQuestion.id);
	      _this.getQuestionRating(currentQuestion.id);
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	
	              if (currentIndex > 0) {
	                _this.redirectToNextPreviousQuestion(currentIndex - 1);
	                _this.resetStates();
	                if (_this.isRevisionMode) _this.setUserSelectedChoices(currentIndex - 1);
	              }
	
	            case 2:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var _this$state3, currentIndex, questionData, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state3 = _this.state, currentIndex = _this$state3.currentIndex, questionData = _this$state3.questionData;
	              nextIndex = currentIndex + 1;
	
	              if (nextIndex < questionData.length) {
	                _this.redirectToNextPreviousQuestion(nextIndex);
	                _this.resetStates();
	                if (_this.isRevisionMode) _this.setUserSelectedChoices(nextIndex);
	              }
	
	            case 3:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state4, statement1, statement2, selectedOptions, currentQuestion, _this$props6, apiServices, type, isValidated, isCorrect, selectedChoice, payload, _this$props$stateTabl2, stateTableName;
	
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _this$state4 = _this.state, statement1 = _this$state4.statement1, statement2 = _this$state4.statement2, selectedOptions = _this$state4.selectedOptions, currentQuestion = _this$state4.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType;
	              isValidated = statement1 && statement2;
	
	              if (isValidated) {
	                _context8.next = 6;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context8.abrupt('return');
	
	            case 6:
	              isCorrect = statement1 === currentQuestion.answer_statement1.replace(/^&/, '') && statement2 === currentQuestion.answer_statement2.replace(/^&/, '');
	              selectedChoice = JSON.stringify({ statement1: statement1, statement2: statement2 });
	
	
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context8.next = 15;
	                break;
	              }
	
	              _context8.next = 13;
	              return apiServices.saveAttemptStats(payload);
	
	            case 13:
	              _this$props$stateTabl2 = _this.props.stateTableName, stateTableName = _this$props$stateTabl2 === undefined ? 'gmat_focus_question_stat' : _this$props$stateTabl2;
	
	
	              _this.setState({
	                questionData: _this.state.questionData.map(function (questionDetails) {
	                  return questionDetails.id === currentQuestion.id ? Object.assign({}, questionDetails, _defineProperty({}, stateTableName, {
	                    selected_choice: selectedChoice,
	                    isSelectedChoice: isCorrect
	                  })) : questionDetails;
	                })
	              });
	
	            case 15:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this2);
	    }));
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      isError: false,
	      showCalculator: false
	    };
	
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    var _this$props$questionM = _this.props.questionMode,
	        questionMode = _this$props$questionM === undefined ? _constant.EXAM_NAMES.GMAT_FOCUS : _this$props$questionM;
	
	    _this.isRevisionMode = (0, _function.isRevisionModeActive)(questionMode);
	    return _this;
	  }
	
	  _createClass(GraphicalStatement, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var _props, apiServices, params, question_type, _props$questionMode, questionMode, readingid, subscription, payload, response, questions, isSubscribed;
	
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                this.setupDropdownListeners();
	                _props = this.props, apiServices = _props.apiServices, params = _props.params, question_type = _props.questionType, _props$questionMode = _props.questionMode, questionMode = _props$questionMode === undefined ? _constant.EXAM_NAMES.GMAT_FOCUS : _props$questionMode;
	                readingid = params.readingid, subscription = params.subscription;
	                payload = {
	                  reading_id: readingid,
	                  question_type: question_type,
	                  subscriptionstatus: +subscription ? _constant.SUBSCRIPTION_STATUS.PAID : _constant.SUBSCRIPTION_STATUS.FREE
	                };
	                _context9.next = 6;
	                return apiServices.fetchQuestionsReadingWise(payload);
	
	              case 6:
	                response = _context9.sent;
	
	                if (response.success) {
	                  _context9.next = 9;
	                  break;
	                }
	
	                return _context9.abrupt('return');
	
	              case 9:
	                questions = response.result || [];
	                isSubscribed = !!+subscription;
	
	                if (!isSubscribed) {
	                  questions = questions.filter(function (question) {
	                    return +question.free === 1;
	                  });
	                }
	
	                _context9.next = 14;
	                return this.handleSetCurrentQuestion(questions);
	
	              case 14:
	                this.setState({
	                  questionData: questions,
	                  isUserSubscribed: isSubscribed,
	                  isLoading: false
	                });
	
	              case 15:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidMount() {
	        return _ref9.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setupDropdownListeners();
	    }
	  }, {
	    key: 'setupDropdownListeners',
	    value: function setupDropdownListeners() {
	      var _this3 = this;
	
	      var select1 = this.dropdown1Ref && this.dropdown1Ref.querySelector('select');
	      var select2 = this.dropdown2Ref && this.dropdown2Ref.querySelector('select');
	
	      if (select1) {
	        select1.value = this.state.statement1 || 'none';
	        select1.onchange = function (e) {
	          _this3.setState({ statement1: e.target.value, isError: false });
	        };
	      }
	
	      if (select2) {
	        select2.value = this.state.statement2 || 'none';
	        select2.onchange = function (e) {
	          _this3.setState({ statement2: e.target.value, isError: false });
	        };
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          questionRating = _state.questionRating,
	          questionRatingTitle = _state.questionRatingTitle,
	          showCalculator = _state.showCalculator,
	          isError = _state.isError;
	      var _props2 = this.props,
	          apiServices = _props2.apiServices,
	          params = _props2.params,
	          redirectTo = _props2.redirectTo,
	          questionType = _props2.questionType,
	          examName = _props2.examName;
	
	      // URL params expose `:readingid` (lowercase) and `:reading`; rename to the
	      // snake_case keys that the BE /reportQuestion writer expects.
	
	      var reading_id = params.readingid,
	          question_id = params.question_id,
	          type = params.type,
	          topic_name = params.reading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this4.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectTo('question');
	                } },
	              _messages.messages.CHANGE_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return redirectTo('reading');
	                } },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: topic_name + ' (Q. ' + currentQuestion.id + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: questionData.length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= questionData.length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 12 },
	                  (0, _function.renderHTMLContent)(currentQuestion.question, 'p'),
	                  _react2.default.createElement('div', {
	                    ref: this.setDropdown1Ref,
	                    dangerouslySetInnerHTML: { __html: currentQuestion.statement1 },
	                    className: 'statement-question-div select'
	                  }),
	                  _react2.default.createElement('div', {
	                    ref: this.setDropdown2Ref,
	                    dangerouslySetInnerHTML: { __html: currentQuestion.statement2 },
	                    className: 'statement-question-div select'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                isError && _react2.default.createElement(
	                  _reactstrap.Col,
	                  { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                  _messages.messages.SELECT_OPTION_ERROR
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 6, lg: 6, sm: 6, className: 'text-center mt-3 d-flex' },
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                    isQue: true,
	                    showResult: validated,
	                    _getResult: this.handleValidate,
	                    _saveQuestion: this.handleSaveQuestion,
	                    _displayReportForm: this.reportCardToggle,
	                    all_questions: questionData,
	                    save_text: saveTooltipTitle,
	                    bookmarkCSS: bookmarkCSS,
	                    bookmarkColor: bookmarkColor
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  {
	                    xs: 6,
	                    lg: 6,
	                    sm: 6,
	                    className: 'text-center mt-3 d-flex align-items-center justify-content-end'
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_bottom_0 margin_right_10' },
	                    questionRatingTitle,
	                    ':'
	                  ),
	                  _react2.default.createElement(_RatingComponent2.default, {
	                    rating: questionRating,
	                    onChange: function onChange(nextValue, prevValue, name) {
	                      return _this4.handleQuestionRating(currentQuestion, nextValue, prevValue, name);
	                    }
	                  })
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion.explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && currentQuestion.id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this4.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return GraphicalStatement;
	}(_react.Component);
	
	GraphicalStatement.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GraphicalStatement;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _constant = __webpack_require__(9);
	
	var _questionUtils = __webpack_require__(168);
	
	var _questionConfigs = __webpack_require__(167);
	
	var _RatingComponent = __webpack_require__(173);
	
	var _RatingComponent2 = _interopRequireDefault(_RatingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiSourceTab = function (_Component) {
	  _inherits(MultiSourceTab, _Component);
	
	  function MultiSourceTab(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MultiSourceTab);
	
	    var _this = _possibleConstructorReturn(this, (MultiSourceTab.__proto__ || Object.getPrototypeOf(MultiSourceTab)).call(this, props));
	
	    _this.setUserSelectedChoices = function (index, questions) {
	      var questionData = questions || _this.state.questionData;
	      var currentQuestion = questionData[index];
	      var _this$props$stateTabl = _this.props.stateTableName,
	          stateTableName = _this$props$stateTabl === undefined ? 'gmat_focus_question_stat' : _this$props$stateTabl;
	
	      var attemptedStateDetails = currentQuestion && currentQuestion[stateTableName] || {};
	
	      var _getUserSelectedChoic = (0, _questionUtils.getUserSelectedChoices)({
	        question: currentQuestion,
	        stat: attemptedStateDetails,
	        config: _questionConfigs.multiSourceConfig
	      }),
	          selectedOptions = _getUserSelectedChoic.selectedOptions,
	          extraState = _getUserSelectedChoic.extraState;
	
	      if (selectedOptions && Object.keys(selectedOptions).length > 0) {
	        _this.setState(Object.assign({}, extraState, { selectedOptions: selectedOptions }), function () {
	          _this.handleValidate(false);
	        });
	      } else {
	        _this.setState(Object.assign({}, extraState, { selectedOptions: selectedOptions }));
	      }
	    };
	
	    _this.handleSetCurrentQuestion = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(questions) {
	        var questionId, index;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	                questionId = _this.props.params.question_id;
	                index = questions.findIndex(function (question) {
	                  return question.id === +questionId;
	                }) || 0;
	
	
	                _this.setState({
	                  currentIndex: index > -1 ? index : 0,
	                  currentQuestion: questions[index > -1 ? index : 0],
	                  isLoading: false
	                });
	                _this.getSavedQuestion(questions[index > -1 ? index : 0].id);
	                _this.getQuestionRating(questions[index > -1 ? index : 0].id);
	                if (_this.isRevisionMode) {
	                  _this.setUserSelectedChoices(index, questions);
	                } else {
	                  _this.resetStates();
	                }
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, questionId, reading, bookmarkCSS, _this$props, apiServices, type, _this$props$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, questionId = _this$state.questionId, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props = _this.props, apiServices = _this$props.apiServices, type = _this$props.questionType, _this$props$params = _this$props.params, reading_id = _this$props$params.readingid, question_id = _this$props$params.question_id, topic_name = _this$props$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: question_id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context2.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context2.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(questionId) {
	        var _this$props2, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this$props2 = _this.props, apiServices = _this$props2.apiServices, params = _this$props2.params, type = _this$props2.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context3.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context3.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.getQuestionRating = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(question_id) {
	        var _this$props3, apiServices, type, params, response, success, ratting, questionRating;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType;
	                params = {
	                  question_id: question_id,
	                  type: type
	                };
	                _context4.prev = 2;
	                _context4.next = 5;
	                return apiServices.fetchRating(params);
	
	              case 5:
	                response = _context4.sent;
	                success = response.success, ratting = response.ratting;
	
	                if (success && ratting && ratting.length > 0) {
	                  //TODO Change the API and fetch rating in object not array
	                  questionRating = response.ratting[0].ratting;
	
	
	                  _this.setState({
	                    questionRating: questionRating,
	                    questionRatingTitle: _messages.messages.RATED
	                  });
	                }
	                _context4.next = 12;
	                break;
	
	              case 10:
	                _context4.prev = 10;
	                _context4.t0 = _context4['catch'](2);
	
	              case 12:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2, [[2, 10]]);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.handleQuestionRating = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(item, nextValue, prevValue, name) {
	        var questionId, question_id, _this$props4, apiServices, type, updatePayload, updateRatingResponse, fetchPayload, response, success, ratting, latestRating, savePayload, saveResponseRating;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                questionId = _this.state.questionId;
	                question_id = item.id;
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, type = _this$props4.questionType;
	                _context5.prev = 3;
	
	                if (!(prevValue !== nextValue)) {
	                  _context5.next = 10;
	                  break;
	                }
	
	                updatePayload = { question_id: question_id, ratting: nextValue, type: type };
	                _context5.next = 8;
	                return apiServices.updateQuestionRating(updatePayload);
	
	              case 8:
	                updateRatingResponse = _context5.sent;
	
	
	                if (updateRatingResponse.success) {
	                  _this.setState({ questionRatingTitle: _messages.messages.RATED });
	                }
	
	              case 10:
	
	                _this.setState({ rating: nextValue });
	
	                // Check if a rating already exists
	                fetchPayload = { question_id: question_id, type: type };
	                _context5.next = 14;
	                return apiServices.fetchRating(fetchPayload);
	
	              case 14:
	                response = _context5.sent;
	                success = response.success, ratting = response.ratting;
	
	                if (!(success && ratting && ratting.length > 0)) {
	                  _context5.next = 21;
	                  break;
	                }
	
	                //TODO Change the API and fetch rating in object not array
	                latestRating = response.ratting[0].ratting;
	
	                _this.setState({
	                  questionRating: latestRating,
	                  questionRatingTitle: '' + _messages.messages.RATED
	                });
	                _context5.next = 26;
	                break;
	
	              case 21:
	                // Save a new rating
	                savePayload = {
	                  question_id: question_id,
	                  ratting: nextValue,
	                  type: type
	                };
	                _context5.next = 24;
	                return apiServices.saveRating(savePayload);
	
	              case 24:
	                saveResponseRating = _context5.sent;
	
	
	                if (saveResponseRating.success) {
	                  _this.setState({
	                    questionRatingTitle: _messages.messages.RATED,
	                    questionRating: nextValue
	                  });
	                }
	
	              case 26:
	                _context5.next = 30;
	                break;
	
	              case 28:
	                _context5.prev = 28;
	                _context5.t0 = _context5['catch'](3);
	
	              case 30:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2, [[3, 28]]);
	      }));
	
	      return function (_x4, _x5, _x6, _x7) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        selectedAnswer1: '',
	        isError: false,
	        questionRating: 0,
	        selectedAnswer2: '',
	        selectedOptions: {},
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.redirectToNextPreviousQuestion = function (index) {
	      var _this$state2 = _this.state,
	          questionData = _this$state2.questionData,
	          isUserSubscribed = _this$state2.isUserSubscribed;
	      var _this$props5 = _this.props,
	          handleChangeParams = _this$props5.handleChangeParams,
	          params = _this$props5.params;
	      var readingid = params.readingid,
	          chapterid = params.chapterid;
	
	      var currentQuestion = questionData[index];
	
	      if (!currentQuestion) return;
	
	      var id = currentQuestion.id;
	
	      handleChangeParams({ index: index, question_id: id });
	      _this.setState({
	        currentIndex: index,
	        currentQuestion: currentQuestion
	      });
	
	      _this.getSavedQuestion(id);
	      _this.getQuestionRating(id);
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	
	              if (currentIndex > 0) {
	                _this.redirectToNextPreviousQuestion(currentIndex - 1);
	                _this.resetStates();
	                if (_this.isRevisionMode) _this.setUserSelectedChoices(currentIndex - 1);
	              }
	
	            case 2:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var _this$state3, currentIndex, questionData, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state3 = _this.state, currentIndex = _this$state3.currentIndex, questionData = _this$state3.questionData;
	              nextIndex = currentIndex + 1;
	
	              if (nextIndex < questionData.length) {
	                _this.redirectToNextPreviousQuestion(nextIndex);
	                _this.resetStates();
	                if (_this.isRevisionMode) _this.setUserSelectedChoices(nextIndex);
	              }
	
	            case 3:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.handleSelect = function (type, value) {
	      _this.setState(_defineProperty({}, type, value));
	    };
	
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state4, _this$state4$selected, selectedOptions, currentQuestion, _this$props6, apiServices, type, totalStatements, selectedCount, isValidated, isCorrect, selectedChoice, payload, _this$props$stateTabl2, stateTableName;
	
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _this$state4 = _this.state, _this$state4$selected = _this$state4.selectedOptions, selectedOptions = _this$state4$selected === undefined ? {} : _this$state4$selected, currentQuestion = _this$state4.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType;
	              // Count how many statements exist in this question
	
	              totalStatements = (0, _function.countStatements)(currentQuestion);
	              selectedCount = Object.values(selectedOptions).filter(Boolean).length;
	              // We cannot remove the `is_single_choice` condition because validation rules differ:
	              // - For single choice questions → the user must select exactly ONE option.
	              // - For multi-statement questions → the user must provide an answer for EACH available statement.
	              // Without this condition, both question types would be validated the same way, which would break correctness.
	
	              isValidated = currentQuestion.is_single_choice ? selectedCount === 1 : selectedCount === totalStatements;
	
	              if (isValidated) {
	                _context8.next = 8;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context8.abrupt('return');
	
	            case 8:
	
	              // Reverse: check every selectedOption key exists in currentQuestion and matches the correct answer
	              isCorrect = Object.keys(selectedOptions).every(function (key) {
	                if (currentQuestion[key] !== undefined && currentQuestion[key] !== null) {
	                  return String(currentQuestion[key]).trim() === String(selectedOptions[key] || '').trim();
	                }
	                return false;
	              });
	              selectedChoice = JSON.stringify(selectedOptions);
	
	
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context8.next = 17;
	                break;
	              }
	
	              _context8.next = 15;
	              return apiServices.saveAttemptStats(payload);
	
	            case 15:
	              _this$props$stateTabl2 = _this.props.stateTableName, stateTableName = _this$props$stateTabl2 === undefined ? 'gmat_focus_question_stat' : _this$props$stateTabl2;
	
	
	              _this.setState({
	                questionData: _this.state.questionData.map(function (questionDetails) {
	                  return questionDetails.id === currentQuestion.id ? Object.assign({}, questionDetails, _defineProperty({}, stateTableName, {
	                    selected_choice: selectedChoice,
	                    isSelectedChoice: isCorrect
	                  })) : questionDetails;
	                })
	              });
	
	            case 17:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this2);
	    }));
	
	    _this.handleChoicesSelect = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	      var currentQuestion = _this.state.currentQuestion;
	
	
	      _this.setState(function (prevState) {
	        var selectedOptions = void 0;
	        if (currentQuestion.is_single_choice) {
	          // Only keep the current selection for single choice
	          selectedOptions = _defineProperty({}, name, value);
	        } else {
	          // Keep previous selections for multi choice
	          selectedOptions = Object.assign({}, prevState.selectedOptions, _defineProperty({}, name, value));
	        }
	        return {
	          selectedOptions: selectedOptions,
	          isError: false
	        };
	      });
	    };
	
	    _this.renderOptions = function () {
	      var _this$state5 = _this.state,
	          validated = _this$state5.validated,
	          currentQuestion = _this$state5.currentQuestion,
	          _this$state5$selected = _this$state5.selectedOptions,
	          selectedOptions = _this$state5$selected === undefined ? {} : _this$state5$selected;
	
	      // Get entries like { key: "statement1", value: "Some statement" }
	
	      var optionEntries = Object.entries(currentQuestion).filter(function (_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 1),
	            key = _ref10[0];
	
	        return key.startsWith('statement');
	      }).map(function (_ref11) {
	        var _ref12 = _slicedToArray(_ref11, 2),
	            key = _ref12[0],
	            value = _ref12[1];
	
	        return { key: key, value: value };
	      });
	
	      return optionEntries.map(function (optionValue, index) {
	        var optionKey = optionValue.key; // e.g., "statement1"
	        var answerKey = optionKey.replace('statement', 'answer'); // e.g., "answer1"
	        var correctAnswer = currentQuestion[answerKey]; // e.g., "yes" or "no"
	        var choicesStatement = currentQuestion.is_single_choice ? ['yes'] : ['yes', 'no'];
	        return optionValue.value && _react2.default.createElement(
	          'tr',
	          { key: optionKey },
	          choicesStatement.map(function (choiceValue) {
	            var isSelectedChoice = selectedOptions[answerKey] === choiceValue;
	
	            // Apply validation class if validated is true and choice is selected
	            var validationClass = '';
	            var isCorrect = String(choiceValue).trim() === String(correctAnswer).trim();
	            if (validated && isSelectedChoice) {
	              validationClass = isCorrect ? 'accent-success' : 'accent-faliure';
	            }
	            var isShowCorrectChoices = validated && !isSelectedChoice && isCorrect;
	            var ariaLabel = choiceValue + ' \u2014 ' + optionValue.value;
	            return _react2.default.createElement(
	              'td',
	              { className: 'p-10px ' + validationClass, key: answerKey + '-' + choiceValue },
	              isShowCorrectChoices ? _react2.default.createElement('input', {
	                type: 'radio',
	                name: 'correct' + index,
	                'aria-label': 'Correct answer: ' + ariaLabel,
	                className: 'accent-success',
	                checked: true,
	                readOnly: true
	              }) : _react2.default.createElement('input', {
	                type: 'radio',
	                name: answerKey,
	                'aria-label': ariaLabel,
	                className: 'border-solid',
	                checked: isSelectedChoice,
	                value: choiceValue,
	                disabled: !validationClass && validated,
	                onChange: _this.handleChoicesSelect
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'td',
	            { className: 'p-10px text-left' },
	            optionValue.value
	          )
	        );
	      });
	    };
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.onHandleTabChange = function (event, tabName) {
	      var tabContent = document.getElementsByClassName('tabcontent');
	      var tabLinks = document.getElementsByClassName('tablinks');
	      var value = event.target.value;
	      for (var i = 0; i < tabContent.length; i++) {
	        tabContent[i].style.display = 'none';
	      }
	      for (var _i = 0; _i < tabLinks.length; _i++) {
	        if (tabLinks[_i].value === tabName) {
	          tabLinks[_i].className += ' active';
	        } else {
	          tabLinks[_i].classList.remove('active');
	        }
	      }
	      document.getElementById(tabName).style.display = 'block';
	    };
	
	    _this.clickHandler = function (event) {
	      _this.onHandleTabChange(event, event.target.value.trim());
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    var _this$props$questionM = _this.props.questionMode,
	        questionMode = _this$props$questionM === undefined ? _constant.EXAM_NAMES.GMAT_FOCUS : _this$props$questionM;
	
	    _this.isRevisionMode = (0, _function.isRevisionModeActive)(questionMode);
	    return _this;
	  }
	
	  _createClass(MultiSourceTab, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var _props, apiServices, params, question_type, readingid, subscription, payload, response, questions, isSubscribed;
	
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _props = this.props, apiServices = _props.apiServices, params = _props.params, question_type = _props.questionType;
	                readingid = params.readingid, subscription = params.subscription;
	                payload = {
	                  reading_id: readingid,
	                  question_type: question_type,
	                  subscriptionstatus: +subscription ? _constant.SUBSCRIPTION_STATUS.PAID : _constant.SUBSCRIPTION_STATUS.FREE
	                };
	                _context9.next = 5;
	                return apiServices.fetchQuestionsReadingWise(payload);
	
	              case 5:
	                response = _context9.sent;
	
	                if (response.success) {
	                  _context9.next = 8;
	                  break;
	                }
	
	                return _context9.abrupt('return');
	
	              case 8:
	                questions = response.result || [];
	                isSubscribed = !!+subscription;
	
	                if (!isSubscribed) {
	                  questions = questions.filter(function (question) {
	                    return +question.free === 1;
	                  });
	                }
	
	                _context9.next = 13;
	                return this.handleSetCurrentQuestion(questions);
	
	              case 13:
	                this.setState({
	                  questionData: questions,
	                  isUserSubscribed: isSubscribed,
	                  isLoading: false
	                });
	
	              case 14:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidMount() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /**
	     * Handles tab change events by updating the display of tab content and the active state of tab links.
	     * This function is used as-is from older code and has not been modified.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          questionRating = _state.questionRating,
	          questionRatingTitle = _state.questionRatingTitle,
	          showCalculator = _state.showCalculator,
	          isError = _state.isError;
	      var _props2 = this.props,
	          apiServices = _props2.apiServices,
	          params = _props2.params,
	          redirectTo = _props2.redirectTo,
	          questionType = _props2.questionType,
	          examName = _props2.examName;
	
	      // URL params expose `:readingid` (lowercase) and `:reading`; rename to the
	      // snake_case keys that the BE /reportQuestion writer expects. Sending
	      // `readingId` causes req.body.reading_id to be undefined → NULL in
	      // ea_ques_reports / gmat_focus_ques_reports → admin /reports URLs land
	      // on /update/null/null/null/null/question and 400 out.
	
	      var reading_id = params.readingid,
	          question_id = params.question_id,
	          type = params.type,
	          topic_name = params.reading;
	      var id = currentQuestion.id,
	          question_tab = currentQuestion.question_tab,
	          question = currentQuestion.question,
	          is_single_choice = currentQuestion.is_single_choice,
	          choice_a = currentQuestion.choice_a,
	          choice_b = currentQuestion.choice_b,
	          explanation = currentQuestion.explanation;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this3.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectTo('question');
	                } },
	              _messages.messages.CHANGE_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return redirectTo('reading');
	                } },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: topic_name + ' (Q. ' + id + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: questionData.length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= questionData.length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-6 mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view' },
	                  (0, _function.renderHTMLContent)(question_tab, 'div', '', {
	                    onClick: this.clickHandler
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 6, sm: 12, lg: 6, className: 'text-center font-16px' },
	                  (0, _function.renderHTMLContent)(question, 'div', 'text-left'),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'text-center  margin_bottom_30 mt-3' },
	                    !is_single_choice && _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          choice_a
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          choice_b
	                        ),
	                        _react2.default.createElement('th', { className: 'p-10px' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.renderOptions()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    isError && _react2.default.createElement(
	                      _reactstrap.Col,
	                      { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                      _messages.messages.SELECT_OPTION_ERROR
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { xs: 6, lg: 6, sm: 6, className: 'text-center mt-3 d-flex' },
	                      _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                        isQue: true,
	                        showResult: validated,
	                        _getResult: this.handleValidate,
	                        _saveQuestion: this.handleSaveQuestion,
	                        _displayReportForm: this.reportCardToggle,
	                        all_questions: questionData,
	                        save_text: saveTooltipTitle,
	                        bookmarkCSS: bookmarkCSS,
	                        bookmarkColor: bookmarkColor
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      {
	                        xs: 6,
	                        lg: 6,
	                        sm: 6,
	                        className: 'text-center mt-3 d-flex align-items-center justify-content-end'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'margin_bottom_0 margin_right_10' },
	                        questionRatingTitle,
	                        ':'
	                      ),
	                      _react2.default.createElement(_RatingComponent2.default, {
	                        rating: questionRating,
	                        onChange: function onChange(nextValue, prevValue, name) {
	                          return _this3.handleQuestionRating(currentQuestion, nextValue, prevValue, name);
	                        }
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this3.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return MultiSourceTab;
	}(_react.Component);
	
	MultiSourceTab.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = MultiSourceTab;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _quizUtils = __webpack_require__(132);
	
	var _quizConfigs = __webpack_require__(131);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GraphicalStatement = function (_Component) {
	  _inherits(GraphicalStatement, _Component);
	
	  function GraphicalStatement(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GraphicalStatement);
	
	    var _this = _possibleConstructorReturn(this, (GraphicalStatement.__proto__ || Object.getPrototypeOf(GraphicalStatement)).call(this, props));
	
	    _this.setDropdown1Ref = function (element) {
	      _this.dropdown1Ref = element;
	    };
	
	    _this.setDropdown2Ref = function (element) {
	      _this.dropdown2Ref = element;
	    };
	
	    _this.setUserSelectedChoices = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, params, questionIds, questionTypes, apiServices, onHandleSetTimer, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response, currentQuestion, received, _getUserSelectedChoic, selectedOptions, extraState;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, params = _this$props.params, questionIds = _this$props.questionIds, questionTypes = _this$props.questionTypes, apiServices = _this$props.apiServices, onHandleSetTimer = _this$props.onHandleSetTimer;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context.next = 7;
	              return apiServices.checkUserSelectedAnswer(payload);
	
	            case 7:
	              response = _context.sent;
	              currentQuestion = _this.state.currentQuestion;
	              received = response.question_recived || {};
	              _getUserSelectedChoic = (0, _quizUtils.getUserSelectedChoices)({
	                question: currentQuestion,
	                stat: received,
	                config: _quizConfigs.graphicalStatementConfig
	              }), selectedOptions = _getUserSelectedChoic.selectedOptions, extraState = _getUserSelectedChoic.extraState;
	
	              if (selectedOptions && Object.keys(selectedOptions).length > 0) {
	                _this.setState(Object.assign({
	                  selectedOptions: selectedOptions
	                }, selectedOptions, extraState));
	              } else {
	                _this.setState(Object.assign({}, _quizConfigs.graphicalStatementConfig.extractExtraState(selectedOptions, received), selectedOptions, {
	                  selectedOptions: selectedOptions
	                }));
	              }
	
	              onHandleSetTimer(!response.question_recived, !!response.question_recived);
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.handleSetCurrentQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props2, params, questionIds, questionTypes, apiServices, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props2 = _this.props, params = _this$props2.params, questionIds = _this$props2.questionIds, questionTypes = _this$props2.questionTypes, apiServices = _this$props2.apiServices;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context2.next = 7;
	              return apiServices.getQuestionById(payload);
	
	            case 7:
	              response = _context2.sent;
	
	              _this.setState({
	                currentIndex: parseInt(offset, 10) || 0,
	                currentQuestion: response.questionsbyid || {}
	              }, function () {
	                _this.getSavedQuestion(currentQuestionId);
	                _this.setUserSelectedChoices();
	              });
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, currentQuestion, reading, bookmarkCSS, _this$props3, apiServices, type, _this$props3$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, currentQuestion = _this$state.currentQuestion, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType, _this$props3$params = _this$props3.params, reading_id = _this$props3$params.readingid, question_id = _this$props3$params.question_id, topic_name = _this$props3$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: currentQuestion.id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context3.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context3.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(questionId) {
	        var _this$props4, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, params = _this$props4.params, type = _this$props4.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context4.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context4.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        isLoading: true,
	        statement1: '',
	        statement2: '',
	        isError: false,
	        selectedOptions: {},
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var currentIndex, handleChangeParams;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              handleChangeParams = _this.props.handleChangeParams;
	
	              if (!(currentIndex > 0)) {
	                _context5.next = 8;
	                break;
	              }
	
	              handleChangeParams(currentIndex - 1);
	              _context5.next = 6;
	              return _this.resetStates();
	
	            case 6:
	              _context5.next = 8;
	              return _this.handleSetCurrentQuestion();
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex, _this$props5, questionIds, handleChangeParams, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              _this$props5 = _this.props, questionIds = _this$props5.questionIds, handleChangeParams = _this$props5.handleChangeParams;
	              nextIndex = currentIndex + 1;
	
	              if (!(nextIndex < Object.keys(questionIds).length)) {
	                _context6.next = 9;
	                break;
	              }
	
	              handleChangeParams(currentIndex + 1);
	              _context6.next = 7;
	              return _this.resetStates();
	
	            case 7:
	              _context6.next = 9;
	              return _this.handleSetCurrentQuestion();
	
	            case 9:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state2, statement1, statement2, selectedOptions, currentQuestion, _this$props6, apiServices, type, quiz_id, onHandleSetTimer, isValidated, isCorrect, selectedChoice, payload;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state2 = _this.state, statement1 = _this$state2.statement1, statement2 = _this$state2.statement2, selectedOptions = _this$state2.selectedOptions, currentQuestion = _this$state2.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType, quiz_id = _this$props6.params.quiz_id, onHandleSetTimer = _this$props6.onHandleSetTimer;
	              isValidated = statement1 && statement2;
	
	              if (isValidated) {
	                _context7.next = 6;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context7.abrupt('return');
	
	            case 6:
	              isCorrect = statement1 === currentQuestion.answer_statement1.replace(/^&/, '') && statement2 === currentQuestion.answer_statement2.replace(/^&/, '');
	              selectedChoice = JSON.stringify({ statement1: statement1, statement2: statement2 });
	
	              onHandleSetTimer(false, true);
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect ? 1 : 0,
	                answer: isCorrect ? 1 : 0,
	                quiz_id: quiz_id,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context7.next = 16;
	                break;
	              }
	
	              _context7.next = 14;
	              return apiServices.saveAttemptStats(payload);
	
	            case 14:
	              _context7.next = 16;
	              return apiServices.saveQuizAnswer(payload);
	
	            case 16:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.handleChoicesSelect = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(function (prevState) {
	        return {
	          selectedOptions: Object.assign({}, prevState.selectedOptions, _defineProperty({}, name, value))
	        };
	      });
	    };
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(GraphicalStatement, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                this.setupDropdownListeners();
	                _context8.next = 3;
	                return this.handleSetCurrentQuestion();
	
	              case 3:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps) {
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                params = this.props.params;
	
	                if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
	                  this.handleSetCurrentQuestion();
	                }
	                this.setupDropdownListeners();
	
	              case 3:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x3) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'setupDropdownListeners',
	    value: function setupDropdownListeners() {
	      var _this3 = this;
	
	      var select1 = this.dropdown1Ref && this.dropdown1Ref.querySelector('select');
	      var select2 = this.dropdown2Ref && this.dropdown2Ref.querySelector('select');
	
	      if (select1) {
	        select1.value = this.state.statement1 || 'none';
	        select1.onchange = function (e) {
	          _this3.setState({ statement1: e.target.value, isError: false });
	        };
	      }
	
	      if (select2) {
	        select2.value = this.state.statement2 || 'none';
	        select2.onchange = function (e) {
	          _this3.setState({ statement2: e.target.value, isError: false });
	        };
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          showCalculator = _state.showCalculator,
	          isError = _state.isError;
	      var _props = this.props,
	          apiServices = _props.apiServices,
	          params = _props.params,
	          redirectToResults = _props.redirectToResults,
	          questionType = _props.questionType,
	          questionIds = _props.questionIds,
	          examName = _props.examName;
	      // Quiz routes don't expose question_id / readingid / reading in URL params;
	      // pull report fields from currentQuestion + questionType so /reportQuestion
	      // gets real values instead of undefined → NULL rows in *_ques_reports.
	
	      var offset = params.offset,
	          quizId = params.quiz_id;
	
	      var question_id = currentQuestion && currentQuestion.id;
	      var reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
	      var topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
	      var type = questionType;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUIZ_ID + ': ' + quizId },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this4.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectToResults();
	                } },
	              _messages.messages.BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: '(Q. ' + (parseInt(offset, 10) + 1) + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: Object.keys(questionIds).length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= Object.keys(questionIds).length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 10, sm: 12, lg: 10, className: 'text-center' },
	                  (0, _function.renderHTMLContent)(currentQuestion.question, 'div', 'text-left'),
	                  _react2.default.createElement('div', {
	                    ref: this.setDropdown1Ref,
	                    dangerouslySetInnerHTML: { __html: currentQuestion.statement1 },
	                    className: 'text-left statement-question-div select'
	                  }),
	                  _react2.default.createElement('div', {
	                    ref: this.setDropdown2Ref,
	                    dangerouslySetInnerHTML: { __html: currentQuestion.statement2 },
	                    className: 'text-left statement-question-div select'
	                  }),
	                  isError && _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                    _messages.messages.SELECT_OPTION_ERROR
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-center mt-3 d-flex' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      isQue: true,
	                      showResult: validated,
	                      _getResult: this.handleValidate,
	                      _saveQuestion: this.handleSaveQuestion,
	                      _displayReportForm: this.reportCardToggle,
	                      all_questions: questionData,
	                      save_text: saveTooltipTitle,
	                      bookmarkCSS: bookmarkCSS,
	                      bookmarkColor: bookmarkColor
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 2, sm: 12, lg: 2, className: 'text-center' },
	                  this.props.children
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion.explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && currentQuestion.id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this4.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return GraphicalStatement;
	}(_react.Component);
	
	GraphicalStatement.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GraphicalStatement;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _constant = __webpack_require__(9);
	
	var _quizUtils = __webpack_require__(132);
	
	var _quizConfigs = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiSourceTab = function (_Component) {
	  _inherits(MultiSourceTab, _Component);
	
	  function MultiSourceTab(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MultiSourceTab);
	
	    var _this = _possibleConstructorReturn(this, (MultiSourceTab.__proto__ || Object.getPrototypeOf(MultiSourceTab)).call(this, props));
	
	    _this.setUserSelectedChoices = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, params, questionIds, questionTypes, apiServices, onHandleSetTimer, quiz_id, offset, currentQuestionId, currentQuestionType, currentQuestion, payload, response, received, _getUserSelectedChoic, selectedOptions, extraState;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, params = _this$props.params, questionIds = _this$props.questionIds, questionTypes = _this$props.questionTypes, apiServices = _this$props.apiServices, onHandleSetTimer = _this$props.onHandleSetTimer;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              currentQuestion = _this.state.currentQuestion;
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context.next = 8;
	              return apiServices.checkUserSelectedAnswer(payload);
	
	            case 8:
	              response = _context.sent;
	              received = response.question_recived || {};
	              _getUserSelectedChoic = (0, _quizUtils.getUserSelectedChoices)({
	                question: currentQuestion,
	                stat: received,
	                config: _quizConfigs.multiSourceConfig
	              }), selectedOptions = _getUserSelectedChoic.selectedOptions, extraState = _getUserSelectedChoic.extraState;
	
	              if (selectedOptions && Object.keys(selectedOptions).length > 0) {
	                _this.setState(Object.assign({
	                  selectedOptions: selectedOptions
	                }, selectedOptions, extraState));
	              } else {
	                _this.setState(Object.assign({}, _quizConfigs.multiSourceConfig.extractExtraState(selectedOptions, received), selectedOptions, {
	                  selectedOptions: selectedOptions
	                }));
	              }
	
	              onHandleSetTimer(!response.question_recived, !!response.question_recived);
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.handleSetCurrentQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props2, params, questionIds, questionTypes, apiServices, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props2 = _this.props, params = _this$props2.params, questionIds = _this$props2.questionIds, questionTypes = _this$props2.questionTypes, apiServices = _this$props2.apiServices;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context2.next = 7;
	              return apiServices.getQuestionById(payload);
	
	            case 7:
	              response = _context2.sent;
	
	              _this.setState({
	                // isLoading: false,
	                currentIndex: parseInt(offset, 10) || 0,
	                currentQuestion: response.questionsbyid || {}
	              }, function () {
	                _this.getSavedQuestion(currentQuestionId);
	                _this.setUserSelectedChoices();
	              });
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, currentQuestion, bookmarkCSS, _this$props3, apiServices, type, _this$props3$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, currentQuestion = _this$state.currentQuestion, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType, _this$props3$params = _this$props3.params, reading_id = _this$props3$params.readingid, question_id = _this$props3$params.question_id, topic_name = _this$props3$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: currentQuestion.id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context3.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context3.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(questionId) {
	        var _this$props4, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, params = _this$props4.params, type = _this$props4.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context4.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context4.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        isLoading: true,
	        selectedAnswer1: '',
	        isError: false,
	        selectedAnswer2: '',
	        selectedOptions: {},
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var currentIndex, handleChangeParams;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              handleChangeParams = _this.props.handleChangeParams;
	
	              if (!(currentIndex > 0)) {
	                _context5.next = 8;
	                break;
	              }
	
	              handleChangeParams(currentIndex - 1);
	              _context5.next = 6;
	              return _this.resetStates();
	
	            case 6:
	              _context5.next = 8;
	              return _this.handleSetCurrentQuestion();
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex, _this$props5, questionIds, handleChangeParams, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              _this$props5 = _this.props, questionIds = _this$props5.questionIds, handleChangeParams = _this$props5.handleChangeParams;
	              nextIndex = currentIndex + 1;
	
	              if (!(nextIndex < Object.keys(questionIds).length)) {
	                _context6.next = 9;
	                break;
	              }
	
	              handleChangeParams(currentIndex + 1);
	              _context6.next = 7;
	              return _this.resetStates();
	
	            case 7:
	              _context6.next = 9;
	              return _this.handleSetCurrentQuestion();
	
	            case 9:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.handleSelect = function (type, value) {
	      _this.setState(_defineProperty({}, type, value));
	    };
	
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state2, selectedOptions, currentQuestion, _this$props6, apiServices, type, quiz_id, onHandleSetTimer, totalStatements, selectedCount, isValidated, isCorrect, selectedChoice, payload;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state2 = _this.state, selectedOptions = _this$state2.selectedOptions, currentQuestion = _this$state2.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType, quiz_id = _this$props6.params.quiz_id, onHandleSetTimer = _this$props6.onHandleSetTimer;
	
	              // Count total statements dynamically (e.g. statement1, statement2…)
	
	              totalStatements = (0, _function.countStatements)(currentQuestion);
	              selectedCount = Object.values(selectedOptions).filter(Boolean).length;
	              // We cannot remove the `is_single_choice` condition because validation rules differ:
	              // - For single choice questions → the user must select exactly ONE option.
	              // - For multi-statement questions → the user must provide an answer for EACH available statement.
	              // Without this condition, both question types would be validated the same way, which would break correctness.
	
	              isValidated = currentQuestion.is_single_choice ? selectedCount === 1 : selectedCount === totalStatements;
	
	              if (isValidated) {
	                _context7.next = 8;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context7.abrupt('return');
	
	            case 8:
	              isCorrect = Object.keys(selectedOptions).every(function (key) {
	                if (currentQuestion[key] !== undefined && currentQuestion[key] !== null) {
	                  return String(currentQuestion[key]).trim() === String(selectedOptions[key] || '').trim();
	                }
	                return false;
	              });
	              selectedChoice = JSON.stringify(selectedOptions);
	
	
	              onHandleSetTimer(false, true);
	
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect ? 1 : 0,
	                answer: isCorrect ? 1 : 0,
	                quiz_id: quiz_id,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context7.next = 18;
	                break;
	              }
	
	              _context7.next = 16;
	              return apiServices.saveAttemptStats(payload);
	
	            case 16:
	              _context7.next = 18;
	              return apiServices.saveQuizAnswer(payload);
	
	            case 18:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.handleChoicesSelect = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	      var currentQuestion = _this.state.currentQuestion;
	
	
	      _this.setState(function (prevState) {
	        var selectedOptions = void 0;
	        if (currentQuestion.is_single_choice) {
	          // Only keep the current selection for single choice
	          selectedOptions = _defineProperty({}, name, value);
	        } else {
	          // Keep previous selections for multi choice
	          selectedOptions = Object.assign({}, prevState.selectedOptions, _defineProperty({}, name, value));
	        }
	        return {
	          selectedOptions: selectedOptions,
	          isError: false
	        };
	      });
	    };
	
	    _this.renderOptions = function () {
	      var _this$state3 = _this.state,
	          validated = _this$state3.validated,
	          currentQuestion = _this$state3.currentQuestion,
	          _this$state3$selected = _this$state3.selectedOptions,
	          selectedOptions = _this$state3$selected === undefined ? {} : _this$state3$selected;
	
	      // Get entries like { key: "statement1", value: "Some statement" }
	
	      var optionEntries = Object.entries(currentQuestion).filter(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 1),
	            key = _ref9[0];
	
	        return key.startsWith('statement');
	      }).map(function (_ref10) {
	        var _ref11 = _slicedToArray(_ref10, 2),
	            key = _ref11[0],
	            value = _ref11[1];
	
	        return { key: key, value: value };
	      });
	
	      return optionEntries.map(function (optionValue, index) {
	        var optionKey = optionValue.key;
	        var answerKey = optionKey.replace('statement', 'answer');
	        var correctAnswer = currentQuestion[answerKey];
	        var choicesStatement = currentQuestion.is_single_choice ? ['yes'] : ['yes', 'no'];
	        return optionValue.value && _react2.default.createElement(
	          'tr',
	          { key: optionKey },
	          choicesStatement.map(function (choiceValue) {
	            var isSelectedChoice = selectedOptions[answerKey] === choiceValue;
	
	            // Apply validation class if validated is true and choice is selected
	            var validationClass = '';
	            var isCorrect = String(choiceValue).trim() === String(correctAnswer).trim();
	            if (validated && isSelectedChoice) {
	              validationClass = isCorrect ? 'accent-success' : 'accent-faliure';
	            }
	            var isShowCorrectChoices = validated && !isSelectedChoice && isCorrect;
	            var ariaLabel = choiceValue + ' \u2014 ' + optionValue.value;
	            return _react2.default.createElement(
	              'td',
	              { className: 'p-10px ' + validationClass, key: answerKey + '-' + choiceValue },
	              isShowCorrectChoices ? _react2.default.createElement('input', {
	                type: 'radio',
	                name: 'correct' + index,
	                'aria-label': 'Correct answer: ' + ariaLabel,
	                className: 'accent-success',
	                checked: true,
	                readOnly: true
	              }) : _react2.default.createElement('input', {
	                type: 'radio',
	                name: answerKey,
	                'aria-label': ariaLabel,
	                className: 'border-solid',
	                checked: isSelectedChoice,
	                disabled: !validationClass && validated,
	                value: choiceValue,
	                onChange: _this.handleChoicesSelect
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'td',
	            { className: 'p-10px text-left' },
	            optionValue.value
	          )
	        );
	      });
	    };
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.onHandleTabChange = function (event, tabName) {
	      var tabContent = document.getElementsByClassName('tabcontent');
	      var tabLinks = document.getElementsByClassName('tablinks');
	      var value = event.target.value;
	      for (var i = 0; i < tabContent.length; i++) {
	        tabContent[i].style.display = 'none';
	      }
	      for (var _i = 0; _i < tabLinks.length; _i++) {
	        if (tabLinks[_i].value === tabName) {
	          tabLinks[_i].className += ' active';
	        } else {
	          tabLinks[_i].classList.remove('active');
	        }
	      }
	      document.getElementById(tabName).style.display = 'block';
	    };
	
	    _this.clickHandler = function (event) {
	      _this.onHandleTabChange(event, event.target.value.trim());
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(MultiSourceTab, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return this.handleSetCurrentQuestion();
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref12.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps) {
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                params = this.props.params;
	
	                if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
	                  this.handleSetCurrentQuestion();
	                }
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x3) {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	
	    /**
	     * Handles tab change events by updating the display of tab content and the active state of tab links.
	     * This function is used as-is from older code and has not been modified.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          showCalculator = _state.showCalculator,
	          isError = _state.isError;
	      var _props = this.props,
	          apiServices = _props.apiServices,
	          params = _props.params,
	          redirectToResults = _props.redirectToResults,
	          questionType = _props.questionType,
	          questionIds = _props.questionIds,
	          examName = _props.examName;
	      // Quiz routes don't expose question_id / readingid / reading in URL params;
	      // pull report fields from currentQuestion + questionType so /reportQuestion
	      // gets real values instead of undefined → NULL rows in *_ques_reports.
	
	      var offset = params.offset,
	          quizId = params.quiz_id;
	
	      var question_id = currentQuestion && currentQuestion.id;
	      var reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
	      var topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
	      var type = questionType;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUIZ_ID + ': ' + quizId },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this3.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectToResults();
	                } },
	              _messages.messages.BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: '(Q. ' + (parseInt(offset, 10) + 1) + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: Object.keys(questionIds).length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= Object.keys(questionIds).length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  {
	                    xs: 5,
	                    sm: 12,
	                    lg: 5,
	                    className: 'mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'
	                  },
	                  (0, _function.renderHTMLContent)(currentQuestion.question_tab, 'div', '', {
	                    onClick: this.clickHandler
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 5, sm: 12, lg: 5, className: 'text-center font-16px' },
	                  (0, _function.renderHTMLContent)(currentQuestion.question, 'div', 'text-left'),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'text-center  margin_bottom_30 mt-3' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      !currentQuestion.is_single_choice && _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          currentQuestion.choice_a
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          currentQuestion.choice_b
	                        ),
	                        _react2.default.createElement('th', { className: 'p-10px' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.renderOptions()
	                    )
	                  ),
	                  isError && _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                    _messages.messages.SELECT_OPTION_ERROR
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-center mt-3 d-flex' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      isQue: true,
	                      showResult: validated,
	                      _getResult: this.handleValidate,
	                      _saveQuestion: this.handleSaveQuestion,
	                      _displayReportForm: this.reportCardToggle,
	                      all_questions: questionData,
	                      save_text: saveTooltipTitle,
	                      bookmarkCSS: bookmarkCSS,
	                      bookmarkColor: bookmarkColor
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 2, sm: 12, lg: 2, className: 'text-center' },
	                  this.props.children
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion.explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && currentQuestion.id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this3.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return MultiSourceTab;
	}(_react.Component);
	
	MultiSourceTab.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = MultiSourceTab;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _constant = __webpack_require__(9);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NormalQuestion = function (_Component) {
	  _inherits(NormalQuestion, _Component);
	
	  function NormalQuestion(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NormalQuestion);
	
	    var _this = _possibleConstructorReturn(this, (NormalQuestion.__proto__ || Object.getPrototypeOf(NormalQuestion)).call(this, props));
	
	    _this.setDefaultChoice = function (currentQuestionDetails, answerDetails) {
	      if (answerDetails.answer === 1) {
	        return currentQuestionDetails.right_choice;
	      }
	
	      var selectedChoice = answerDetails.selected_choice;
	      if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
	        return selectedChoice;
	      }
	
	      var wrongChoices = _constant.CHOICE_KEYS.filter(function (choice) {
	        return choice !== currentQuestionDetails.right_choice;
	      });
	      var chooseRandomChoice = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];
	
	      return chooseRandomChoice;
	    };
	
	    _this.setUserSelectedChoices = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, params, questionIds, questionTypes, apiServices, onHandleSetTimer, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response, currentQuestion, received, selectedChoice, answer;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, params = _this$props.params, questionIds = _this$props.questionIds, questionTypes = _this$props.questionTypes, apiServices = _this$props.apiServices, onHandleSetTimer = _this$props.onHandleSetTimer;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context.next = 7;
	              return apiServices.checkUserSelectedAnswer(payload);
	
	            case 7:
	              response = _context.sent;
	              currentQuestion = _this.state.currentQuestion;
	              received = response.question_recived || {};
	              selectedChoice = received.selected_choice || '';
	              answer = received.answer;
	
	              if (response.success) {
	                _this.setState({
	                  isUserSelectedChoice: parseInt(answer, 10) ? true : false,
	                  selectedChoice: _this.setDefaultChoice(currentQuestion, received),
	                  isLoading: false,
	                  validated: !!response.question_recived
	                });
	              } else {
	                _this.setState({
	                  isUserSelectedChoice: parseInt(answer, 10) ? true : false,
	                  selectedChoice: selectedChoice,
	                  isLoading: false,
	                  validated: !!response.question_recived
	                });
	              }
	              onHandleSetTimer(!response.question_recived, !!response.question_recived);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.handleSetCurrentQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props2, params, questionIds, questionTypes, apiServices, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props2 = _this.props, params = _this$props2.params, questionIds = _this$props2.questionIds, questionTypes = _this$props2.questionTypes, apiServices = _this$props2.apiServices;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context2.next = 7;
	              return apiServices.getQuestionById(payload);
	
	            case 7:
	              response = _context2.sent;
	
	              _this.setState({
	                // isLoading: false,
	                currentIndex: parseInt(offset, 10) || 0,
	                currentQuestion: response.questionsbyid || {}
	              }, function () {
	                _this.getSavedQuestion(currentQuestionId);
	                _this.setUserSelectedChoices();
	              });
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, currentQuestion, reading, bookmarkCSS, _this$props3, apiServices, type, _this$props3$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, currentQuestion = _this$state.currentQuestion, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType, _this$props3$params = _this$props3.params, reading_id = _this$props3$params.readingid, question_id = _this$props3$params.question_id, topic_name = _this$props3$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: currentQuestion.id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context3.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context3.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(questionId) {
	        var _this$props4, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, params = _this$props4.params, type = _this$props4.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context4.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context4.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        isLoading: true,
	        selectedAnswer1: '',
	        selectedOptions: {},
	        isError: false,
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var currentIndex, handleChangeParams;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              handleChangeParams = _this.props.handleChangeParams;
	
	              if (!(currentIndex > 0)) {
	                _context5.next = 8;
	                break;
	              }
	
	              handleChangeParams(currentIndex - 1);
	              _context5.next = 6;
	              return _this.resetStates();
	
	            case 6:
	              _context5.next = 8;
	              return _this.handleSetCurrentQuestion();
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex, _this$props5, questionIds, handleChangeParams, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              _this$props5 = _this.props, questionIds = _this$props5.questionIds, handleChangeParams = _this$props5.handleChangeParams;
	              nextIndex = currentIndex + 1;
	
	              if (!(nextIndex < Object.keys(questionIds).length)) {
	                _context6.next = 9;
	                break;
	              }
	
	              handleChangeParams(currentIndex + 1);
	              _context6.next = 7;
	              return _this.resetStates();
	
	            case 7:
	              _context6.next = 9;
	              return _this.handleSetCurrentQuestion();
	
	            case 9:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.setAnswer = function (answer) {
	      _this.setState({ selectedChoice: answer[0], isError: false });
	    };
	
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state2, selectedChoice, currentQuestion, _this$props6, apiServices, type, quiz_id, onHandleSetTimer, isCorrect, payload;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state2 = _this.state, selectedChoice = _this$state2.selectedChoice, currentQuestion = _this$state2.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType, quiz_id = _this$props6.params.quiz_id, onHandleSetTimer = _this$props6.onHandleSetTimer;
	
	              if (selectedChoice) {
	                _context7.next = 5;
	                break;
	              }
	
	              _this.setState({
	                isError: true
	              });
	              return _context7.abrupt('return');
	
	            case 5:
	              isCorrect = selectedChoice.trim().toLowerCase() === currentQuestion.right_choice.trim().toLowerCase();
	
	
	              onHandleSetTimer(false, true);
	
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: Number(isCorrect),
	                answer: Number(isCorrect),
	                reading_id: currentQuestion['gmat_focus_reading.id'],
	                quiz_id: quiz_id,
	                selected_choice: selectedChoice,
	                type: type === _constant.QUESTION_TYPE.CASE_QUESTION ? _constant.QUESTION_TYPE.QUESTION : type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context7.next = 14;
	                break;
	              }
	
	              _context7.next = 12;
	              return apiServices.saveAttemptStats(payload);
	
	            case 12:
	              _context7.next = 14;
	              return apiServices.saveQuizAnswer(payload);
	
	            case 14:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(NormalQuestion, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return this.handleSetCurrentQuestion();
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps) {
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                params = this.props.params;
	
	                if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
	                  this.handleSetCurrentQuestion();
	                }
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x3) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          showCalculator = _state.showCalculator,
	          selectedChoice = _state.selectedChoice,
	          isError = _state.isError;
	      var _props = this.props,
	          apiServices = _props.apiServices,
	          params = _props.params,
	          redirectToResults = _props.redirectToResults,
	          questionType = _props.questionType,
	          questionIds = _props.questionIds,
	          examName = _props.examName;
	      // Quiz routes like /begin-quiz/:quiz_id/:offset/:timer don't expose
	      // question_id / readingid / reading in URL params (unlike non-quiz IR
	      // routes). Pull the report fields from the loaded currentQuestion +
	      // questionType prop so /reportQuestion gets real values instead of NULLs
	      // — same pattern used for saveAttemptStats above.
	
	      var offset = params.offset,
	          quizId = params.quiz_id;
	
	      var question_id = currentQuestion && currentQuestion.id;
	      var reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
	      var topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
	      var type = questionType;
	
	      // Helper to render ValidateSaveReportIcon inside ViewQuestion
	      var renderViewQuestion = function renderViewQuestion() {
	        return _react2.default.createElement(
	          _ViewQuestion2.default,
	          Object.assign({}, currentQuestion, _this3.props, {
	            setAnswer: _this3.setAnswer,
	            showAnswer: validated,
	            correctChoice: currentQuestion && currentQuestion.right_choice,
	            selectedChoice: selectedChoice
	          }),
	          isError && _react2.default.createElement(
	            'div',
	            { className: 'text-danger col-12' },
	            _messages.messages.NO_CHOICE_SELECTED
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center mt-2 d-flex' },
	            _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	              isQue: true,
	              showResult: validated,
	              _getResult: _this3.handleValidate,
	              _saveQuestion: _this3.handleSaveQuestion,
	              _displayReportForm: _this3.reportCardToggle,
	              all_questions: questionData,
	              save_text: saveTooltipTitle,
	              bookmarkCSS: bookmarkCSS,
	              bookmarkColor: bookmarkColor
	            })
	          )
	        );
	      };
	
	      // Helper to render the answer feedback card
	      var renderAnswerFeedback = function renderAnswerFeedback() {
	        return validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion.answer, 'span')
	              )
	            )
	          )
	        );
	      };
	
	      // Helper to render the question content
	      var renderQuestionContent = function renderQuestionContent() {
	        if (!currentQuestion || !Object.keys(currentQuestion).length) {
	          return _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          );
	        }
	
	        if (questionType === _constant.QUESTION_TYPE.CASE_QUESTION) {
	          return _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: '(Q. ' + (parseInt(offset, 10) + 1) + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: Object.keys(questionIds).length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= Object.keys(questionIds).length - 1,
	              getPreviousQuestion: _this3.getPreviousQuestion,
	              getNextQuestion: _this3.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  {
	                    xs: 5,
	                    sm: 12,
	                    lg: 5,
	                    className: 'mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'
	                  },
	                  (0, _function.renderHTMLContent)(examName === _constant.examNameAccordingToDB.EA ? currentQuestion['ea_case.passage'] : currentQuestion['gmat_case.passage'], 'div', 'text-left')
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  {
	                    xs: 5,
	                    sm: 12,
	                    lg: 5,
	                    className: 'mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'
	                  },
	                  renderViewQuestion()
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 2, sm: 12, lg: 2, className: 'text-center' },
	                  _this3.props.children
	                )
	              )
	            )
	          );
	        }
	
	        // Default (non-case) question
	        return _react2.default.createElement(
	          _CustomCard2.default,
	          null,
	          _react2.default.createElement(_CustomCardHeader2.default, {
	            headingText: '(Q. ' + (parseInt(offset, 10) + 1) + ')',
	            headerImage: _question_icon_blue2.default,
	            arrayLength: Object.keys(questionIds).length,
	            showPreviousButton: true,
	            showNextButton: true,
	            disabledPreviousButton: currentIndex < 1,
	            disabledNextButton: currentIndex >= Object.keys(questionIds).length - 1,
	            getPreviousQuestion: _this3.getPreviousQuestion,
	            getNextQuestion: _this3.getNextQuestion
	          }),
	          _react2.default.createElement(
	            _CustomCardBody2.default,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: 10, sm: 12, lg: 10, className: 'mb-0 mb-sm-1 question-view' },
	                renderViewQuestion()
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: 2, sm: 12, lg: 2, className: 'text-center' },
	                _this3.props.children
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUIZ_ID + ': ' + quizId },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this3.setState({ showCalculator: true });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectToResults();
	                } },
	              _messages.messages.BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          renderQuestionContent()
	        ),
	        renderAnswerFeedback(),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && currentQuestion.id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this3.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return NormalQuestion;
	}(_react.Component);
	
	NormalQuestion.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = NormalQuestion;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReverseTimer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReverseTimer = exports.ReverseTimer = function (_Component) {
	  _inherits(ReverseTimer, _Component);
	
	  function ReverseTimer(props) {
	    _classCallCheck(this, ReverseTimer);
	
	    var _this = _possibleConstructorReturn(this, (ReverseTimer.__proto__ || Object.getPrototypeOf(ReverseTimer)).call(this, props));
	
	    _this.startTimer = function () {
	      clearInterval(_this.timer);
	      _this.props.onStartTimer && _this.props.onStartTimer();
	      _this.timer = setInterval(_this.onHandleTimerChange, 1000);
	    };
	
	    _this.stopTimer = function () {
	      clearInterval(_this.timer);
	      _this.props.onStopTimer && _this.props.onStopTimer();
	    };
	
	    _this.onHandleTimerChange = function () {
	      var count = _this.state.count - 1;
	      _this.setState({ count: count });
	
	      _this.props.apiCall && _this.props.apiCall({
	        count: count,
	        timer: count
	      });
	    };
	
	    _this.state = {
	      count: props.initialTimerValue || 0
	    };
	    _this.timer = null;
	    return _this;
	  }
	
	  _createClass(ReverseTimer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.isTimerRunning) {
	        this.startTimer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.isTimerRunning !== this.props.isTimerRunning) {
	        if (this.props.isTimerRunning) {
	          this.startTimer();
	        } else {
	          this.stopTimer();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var count = this.state.count;
	      var _props = this.props,
	          isTimerRunning = _props.isTimerRunning,
	          disabled = _props.disabled;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'timer_outer' },
	          _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'timer_box' },
	            (0, _function.formatTime)(count)
	          )
	        ),
	        _react2.default.createElement('button', {
	          type: 'button',
	          'aria-label': isTimerRunning ? 'Pause timer' : 'Resume timer',
	          className: 'pause_btn ' + (isTimerRunning ? 'icon-control-pause' : 'icon-control-play'),
	          onClick: this.props.onToggleTimer // controlled by parent
	          , disabled: disabled
	        })
	      );
	    }
	  }]);
	
	  return ReverseTimer;
	}(_react.Component);
	
	exports.default = ReverseTimer;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _quizUtils = __webpack_require__(132);
	
	var _quizConfigs = __webpack_require__(131);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _constant = __webpack_require__(9);
	
	var _TableSort = __webpack_require__(250);
	
	var _TableSort2 = _interopRequireDefault(_TableSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableAnalysisTwoStatement = function (_Component) {
	  _inherits(TableAnalysisTwoStatement, _Component);
	
	  function TableAnalysisTwoStatement(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TableAnalysisTwoStatement);
	
	    var _this = _possibleConstructorReturn(this, (TableAnalysisTwoStatement.__proto__ || Object.getPrototypeOf(TableAnalysisTwoStatement)).call(this, props));
	
	    _this.setUserSelectedChoices = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, params, questionIds, questionTypes, apiServices, onHandleSetTimer, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response, currentQuestion, received, _getUserSelectedChoic, selectedOptions, extraState;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, params = _this$props.params, questionIds = _this$props.questionIds, questionTypes = _this$props.questionTypes, apiServices = _this$props.apiServices, onHandleSetTimer = _this$props.onHandleSetTimer;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context.next = 7;
	              return apiServices.checkUserSelectedAnswer(payload);
	
	            case 7:
	              response = _context.sent;
	              currentQuestion = _this.state.currentQuestion;
	              received = response.question_recived || {};
	              _getUserSelectedChoic = (0, _quizUtils.getUserSelectedChoices)({
	                question: currentQuestion,
	                stat: received,
	                config: _quizConfigs.tableAnalysisTwoStatementConfig
	              }), selectedOptions = _getUserSelectedChoic.selectedOptions, extraState = _getUserSelectedChoic.extraState;
	
	
	              if (selectedOptions && Object.keys(selectedOptions).length > 0) {
	                _this.setState(Object.assign({
	                  selectedOptions: selectedOptions
	                }, selectedOptions, extraState));
	              } else {
	                _this.setState(Object.assign({}, _quizConfigs.tableAnalysisTwoStatementConfig.extractExtraState(selectedOptions, received), selectedOptions, {
	                  selectedOptions: selectedOptions
	                }));
	              }
	
	              onHandleSetTimer(!response.question_recived, !!response.question_recived);
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.handleSetCurrentQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props2, params, questionIds, questionTypes, apiServices, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response, currentQuestion, question, sortBy, _question$split, _question$split2, questionText, tableContent, questionContent, questionTable, sortingOptions;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props2 = _this.props, params = _this$props2.params, questionIds = _this$props2.questionIds, questionTypes = _this$props2.questionTypes, apiServices = _this$props2.apiServices;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context2.next = 7;
	              return apiServices.getQuestionById(payload);
	
	            case 7:
	              response = _context2.sent;
	              currentQuestion = response.questionsbyid;
	              question = currentQuestion.question, sortBy = currentQuestion.sortBy;
	              /**
	               * Navigates to a specific question by index, updates component state with the selected question's
	               * content and table (if present), and fetches saved question data and rating.
	               *
	               * Working:
	               * - Splits the question text and table HTML to allow rendering a dropdown between them.
	               * - Updates state with question content, table, and sorting options.
	               * - Triggers fetch for saved question and rating.
	               *
	               * Unable to change:
	               * - The split and state update logic must remain as is to support inserting a dropdown between the question and table.
	               *
	               * @param {number} index - The index of the question to navigate to.
	               */
	
	              _question$split = question.split('<table'), _question$split2 = _slicedToArray(_question$split, 2), questionText = _question$split2[0], tableContent = _question$split2[1];
	              questionContent = questionText || question;
	              questionTable = tableContent ? '<table id="myTable" border="1" cellpadding="5px" ' + tableContent : '';
	              sortingOptions = sortBy && sortBy.split(',') || [];
	
	              _this.setState({
	                questionContent: questionContent,
	                questionTable: questionTable,
	                sortingOptions: sortingOptions,
	                currentIndex: parseInt(offset, 10) || 0,
	                currentQuestion: currentQuestion || {}
	              }, function () {
	                _this.getSavedQuestion(currentQuestionId);
	                _this.setUserSelectedChoices();
	              });
	
	            case 15:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, currentQuestion, reading, bookmarkCSS, _this$props3, apiServices, type, _this$props3$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, currentQuestion = _this$state.currentQuestion, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType, _this$props3$params = _this$props3.params, reading_id = _this$props3$params.readingid, question_id = _this$props3$params.question_id, topic_name = _this$props3$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: currentQuestion.id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context3.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context3.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(questionId) {
	        var _this$props4, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, params = _this$props4.params, type = _this$props4.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context4.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context4.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        isLoading: true,
	        selectedAnswer1: '',
	        selectedAnswer2: '',
	        isError: false,
	        selectedOptions: {},
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var currentIndex, handleChangeParams;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              handleChangeParams = _this.props.handleChangeParams;
	
	              if (!(currentIndex > 0)) {
	                _context5.next = 8;
	                break;
	              }
	
	              handleChangeParams(currentIndex - 1);
	              _context5.next = 6;
	              return _this.resetStates();
	
	            case 6:
	              _context5.next = 8;
	              return _this.handleSetCurrentQuestion();
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex, _this$props5, questionIds, handleChangeParams, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              _this$props5 = _this.props, questionIds = _this$props5.questionIds, handleChangeParams = _this$props5.handleChangeParams;
	              nextIndex = currentIndex + 1;
	
	              if (!(nextIndex < Object.keys(questionIds).length)) {
	                _context6.next = 9;
	                break;
	              }
	
	              handleChangeParams(currentIndex + 1);
	              _context6.next = 7;
	              return _this.resetStates();
	
	            case 7:
	              _context6.next = 9;
	              return _this.handleSetCurrentQuestion();
	
	            case 9:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.handleSelect = function (type, value) {
	      _this.setState(_defineProperty({}, type, value));
	    };
	
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state2, selectedOptions, currentQuestion, _this$props6, apiServices, type, quiz_id, onHandleSetTimer, isCorrect, selectedChoice, payload;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state2 = _this.state, selectedOptions = _this$state2.selectedOptions, currentQuestion = _this$state2.currentQuestion;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType, quiz_id = _this$props6.params.quiz_id, onHandleSetTimer = _this$props6.onHandleSetTimer;
	
	              if (!(Object.keys(selectedOptions).length !== 3)) {
	                _context7.next = 5;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context7.abrupt('return');
	
	            case 5:
	              isCorrect = true;
	
	              isCorrect = Object.keys(currentQuestion).filter(function (key) {
	                return key.startsWith('answer');
	              }).every(function (key) {
	                var optionKey = key.replace('answer', 'option');
	                return String(currentQuestion[key]).trim() === String(selectedOptions[optionKey]).trim();
	              });
	
	              selectedChoice = JSON.stringify(selectedOptions);
	
	
	              onHandleSetTimer(false, true);
	
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect ? 1 : 0,
	                answer: isCorrect ? 1 : 0,
	                quiz_id: quiz_id,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context7.next = 16;
	                break;
	              }
	
	              _context7.next = 14;
	              return apiServices.saveAttemptStats(payload);
	
	            case 14:
	              _context7.next = 16;
	              return apiServices.saveQuizAnswer(payload);
	
	            case 16:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.handleChoicesSelect = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(function (prevState) {
	        return {
	          selectedOptions: Object.assign({}, prevState.selectedOptions, _defineProperty({}, name, value)),
	          isError: false
	        };
	      });
	    };
	
	    _this.renderOptions = function () {
	      var _this$state3 = _this.state,
	          validated = _this$state3.validated,
	          currentQuestion = _this$state3.currentQuestion,
	          _this$state3$selected = _this$state3.selectedOptions,
	          selectedOptions = _this$state3$selected === undefined ? {} : _this$state3$selected;
	
	      // Create entries like { key: "option1", value: "yes" }
	
	      var optionEntries = Object.entries(currentQuestion).filter(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 1),
	            key = _ref9[0];
	
	        return key.startsWith('option');
	      }).map(function (_ref10) {
	        var _ref11 = _slicedToArray(_ref10, 2),
	            key = _ref11[0],
	            value = _ref11[1];
	
	        return { key: key, value: value };
	      });
	
	      return optionEntries.map(function (optionValue, index) {
	        var optionKey = optionValue.key; // e.g., "option1"
	        var answerKey = optionKey.replace('option', 'answer'); // maps to "answer1"
	        var correctAnswer = currentQuestion[answerKey]; // e.g., "yes"
	
	        return _react2.default.createElement(
	          'tr',
	          { key: optionKey },
	          ['yes', 'no'].map(function (choiceValue) {
	            var isSelectedChoice = selectedOptions[optionKey] === choiceValue;
	
	            // Determine class if validated
	            var validationClass = '';
	            if (validated && isSelectedChoice) {
	              validationClass = String(choiceValue).trim() === String(correctAnswer).trim() ? 'accent-success' : 'accent-faliure';
	            }
	
	            return _react2.default.createElement(
	              'td',
	              {
	                className: 'border-solid-1 p-10px ' + validationClass,
	                key: optionKey + '-' + choiceValue
	              },
	              _react2.default.createElement('input', {
	                type: 'radio',
	                name: optionKey,
	                className: 'border-solid',
	                checked: isSelectedChoice,
	                value: choiceValue,
	                disabled: !validationClass && validated,
	                onChange: _this.handleChoicesSelect
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'td',
	            { className: 'border-solid-1 p-10px' },
	            optionValue.value
	          )
	        );
	      });
	    };
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.resetTableContent = function () {
	      var currentQuestion = _this.state.currentQuestion;
	
	      _this.setState({
	        questionTable: ''
	      }, function () {
	        _this.setState({
	          questionTable: '<table id="myTable" border="1" cellpadding="5px" ' + (currentQuestion.question.split('<table') ? currentQuestion.question.split('<table')[1] : currentQuestion.question)
	        });
	        document.getElementById('table_data_select').selectedIndex = 0;
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(TableAnalysisTwoStatement, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return this.handleSetCurrentQuestion();
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref12.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps) {
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                params = this.props.params;
	
	                if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
	                  this.handleSetCurrentQuestion();
	                }
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x3) {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          isError = _state.isError,
	          showCalculator = _state.showCalculator,
	          questionContent = _state.questionContent,
	          questionTable = _state.questionTable,
	          sortingOptions = _state.sortingOptions;
	      var _props = this.props,
	          apiServices = _props.apiServices,
	          params = _props.params,
	          redirectToResults = _props.redirectToResults,
	          questionType = _props.questionType,
	          questionIds = _props.questionIds,
	          examName = _props.examName;
	      // Quiz routes don't expose question_id / readingid / reading in URL params;
	      // pull report fields from currentQuestion + questionType so /reportQuestion
	      // gets real values instead of undefined → NULL rows in *_ques_reports.
	
	      var offset = params.offset,
	          quizId = params.quiz_id;
	
	      var question_id = currentQuestion && currentQuestion.id;
	      var reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
	      var topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
	      var type = questionType;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUIZ_ID + ': ' + quizId },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this3.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectToResults();
	                } },
	              _messages.messages.BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: '(Q. ' + (parseInt(offset, 10) + 1) + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: Object.keys(questionIds).length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= Object.keys(questionIds).length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 10, sm: 12, lg: 10, className: 'mb-0 font-16px mb-sm-1 question-view' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block  statement-question-div' },
	                    (0, _function.renderHTMLContent)(questionContent || currentQuestion.question, 'div', 'text-justify'),
	                    _react2.default.createElement(_TableSort2.default, {
	                      sortOptions: sortingOptions,
	                      onSortChange: function onSortChange(value) {
	                        return (0, _function.onHandleTableSorting)(value);
	                      },
	                      onReset: this.resetTableContent
	                    }),
	                    (0, _function.renderHTMLContent)(questionTable, 'div', 'overflow-x-auto table-w-100')
	                  ),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'text-center  margin_bottom_30' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          currentQuestion.choice_a
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          currentQuestion.choice_b
	                        ),
	                        _react2.default.createElement('th', { className: 'p-10px' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.renderOptions()
	                    )
	                  ),
	                  isError && _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                    _messages.messages.SELECT_OPTION_ERROR
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-center mt-3 d-flex' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      isQue: true,
	                      showResult: validated,
	                      _getResult: this.handleValidate,
	                      _saveQuestion: this.handleSaveQuestion,
	                      _displayReportForm: this.reportCardToggle,
	                      all_questions: questionData,
	                      save_text: saveTooltipTitle,
	                      bookmarkCSS: bookmarkCSS,
	                      bookmarkColor: bookmarkColor
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 2, sm: 12, lg: 2, className: 'text-center' },
	                  this.props.children
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion.explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && currentQuestion.id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this3.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return TableAnalysisTwoStatement;
	}(_react.Component);
	
	TableAnalysisTwoStatement.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = TableAnalysisTwoStatement;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _quizUtils = __webpack_require__(132);
	
	var _quizConfigs = __webpack_require__(131);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportComponent = __webpack_require__(83);
	
	var _ReportComponent2 = _interopRequireDefault(_ReportComponent);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TwoPartAnalysis = function (_Component) {
	  _inherits(TwoPartAnalysis, _Component);
	
	  function TwoPartAnalysis(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TwoPartAnalysis);
	
	    var _this = _possibleConstructorReturn(this, (TwoPartAnalysis.__proto__ || Object.getPrototypeOf(TwoPartAnalysis)).call(this, props));
	
	    _this.setUserSelectedChoices = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, params, questionIds, questionTypes, apiServices, onHandleSetTimer, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response, currentQuestion, received, _getUserSelectedChoic, selectedOptions, extraState;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, params = _this$props.params, questionIds = _this$props.questionIds, questionTypes = _this$props.questionTypes, apiServices = _this$props.apiServices, onHandleSetTimer = _this$props.onHandleSetTimer;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context.next = 7;
	              return apiServices.checkUserSelectedAnswer(payload);
	
	            case 7:
	              response = _context.sent;
	              currentQuestion = _this.state.currentQuestion;
	              received = response.question_recived || {};
	              _getUserSelectedChoic = (0, _quizUtils.getUserSelectedChoices)({
	                question: currentQuestion,
	                stat: received,
	                config: _quizConfigs.twoPartAnalysisConfig
	              }), selectedOptions = _getUserSelectedChoic.selectedOptions, extraState = _getUserSelectedChoic.extraState;
	
	
	              if (selectedOptions && Object.keys(selectedOptions).length > 0) {
	                _this.setState(Object.assign({
	                  selectedOptions: selectedOptions
	                }, selectedOptions, extraState));
	              } else {
	                _this.setState(Object.assign({}, _quizConfigs.twoPartAnalysisConfig.extractExtraState(selectedOptions, received), selectedOptions, {
	                  selectedOptions: selectedOptions
	                }));
	              }
	
	              onHandleSetTimer(!response.question_recived, !!response.question_recived);
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.handleSetCurrentQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props2, params, questionIds, questionTypes, apiServices, quiz_id, offset, currentQuestionId, currentQuestionType, payload, response;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props2 = _this.props, params = _this$props2.params, questionIds = _this$props2.questionIds, questionTypes = _this$props2.questionTypes, apiServices = _this$props2.apiServices;
	              quiz_id = params.quiz_id, offset = params.offset;
	              currentQuestionId = questionIds[offset];
	              currentQuestionType = questionTypes[offset];
	              payload = {
	                quiz_id: quiz_id,
	                question_id: currentQuestionId,
	                type: currentQuestionType
	              };
	              _context2.next = 7;
	              return apiServices.getQuestionById(payload);
	
	            case 7:
	              response = _context2.sent;
	
	              _this.setState({
	                // isLoading: false,
	                currentIndex: parseInt(offset, 10) || 0,
	                currentQuestion: response.questionsbyid || {}
	              }, function () {
	                _this.getSavedQuestion(currentQuestionId);
	                _this.setUserSelectedChoices();
	              });
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.handleSaveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, currentQuestion, reading, bookmarkCSS, _this$props3, apiServices, type, _this$props3$params, reading_id, question_id, topic_name, isSaved, payload, endpoint, response;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, currentQuestion = _this$state.currentQuestion, reading = _this$state.reading, bookmarkCSS = _this$state.bookmarkCSS;
	              _this$props3 = _this.props, apiServices = _this$props3.apiServices, type = _this$props3.questionType, _this$props3$params = _this$props3.params, reading_id = _this$props3$params.readingid, question_id = _this$props3$params.question_id, topic_name = _this$props3$params.reading;
	              isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	              payload = {
	                question_id: currentQuestion.id,
	                type: type,
	                topic_name: topic_name,
	                reading_id: reading_id
	              };
	              endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
	              _context3.next = 7;
	              return endpoint(payload);
	
	            case 7:
	              response = _context3.sent;
	
	
	              if (isSaved && _this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	
	              _this.setState({
	                bookmarkCSS: isSaved ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
	                saveTooltipTitle: isSaved ? _messages.messages.SAVE_ITEM_DESCRIPTION : _messages.messages.QUESTION_SAVED,
	                isFlashCardHidden: isSaved
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getSavedQuestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(questionId) {
	        var _this$props4, apiServices, params, type, chapter_id, payload, response;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props4 = _this.props, apiServices = _this$props4.apiServices, params = _this$props4.params, type = _this$props4.questionType;
	                chapter_id = params.chapterid;
	                payload = {
	                  question_id: questionId,
	                  chapter_id: chapter_id,
	                  type: type
	                };
	                _context4.next = 5;
	                return apiServices.fetchSavedQuestion(payload);
	
	              case 5:
	                response = _context4.sent;
	
	                _this.setState(Object.assign({
	                  isFlashCardHidden: !response.success
	                }, response.success && {
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveTooltipTitle: '' + _messages.messages.QUESTION_SAVED,
	                  isFlashCardHidden: false
	                }));
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        validated: false,
	        isLoading: true,
	        selectedAnswer1: '',
	        selectedAnswer2: '',
	        selectedOptions: {},
	        isError: false,
	        isUserSelectedChoice: false,
	        isReportCardHidden: true,
	        isFlashCardHidden: true,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION
	      });
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var currentIndex, handleChangeParams;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              handleChangeParams = _this.props.handleChangeParams;
	
	              if (!(currentIndex > 0)) {
	                _context5.next = 8;
	                break;
	              }
	
	              handleChangeParams(currentIndex - 1);
	              _context5.next = 6;
	              return _this.resetStates();
	
	            case 6:
	              _context5.next = 8;
	              return _this.handleSetCurrentQuestion();
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var currentIndex, _this$props5, questionIds, handleChangeParams, nextIndex;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              _this$props5 = _this.props, questionIds = _this$props5.questionIds, handleChangeParams = _this$props5.handleChangeParams;
	              nextIndex = currentIndex + 1;
	
	              if (!(nextIndex < Object.keys(questionIds).length)) {
	                _context6.next = 9;
	                break;
	              }
	
	              handleChangeParams(currentIndex + 1);
	              _context6.next = 7;
	              return _this.resetStates();
	
	            case 7:
	              _context6.next = 9;
	              return _this.handleSetCurrentQuestion();
	
	            case 9:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.handleSelect = function (type, value) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, type, value), _defineProperty(_this$setState, 'isError', false), _this$setState));
	    };
	
	    _this.handleValidate = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var isSaveAttemptStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var _this$state2, selectedOptions, currentQuestion, selectedAnswer1, selectedAnswer2, _this$props6, apiServices, type, quiz_id, onHandleSetTimer, isValidated, answerValue1, answerValue2, isCorrect, selectedChoice, payload;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state2 = _this.state, selectedOptions = _this$state2.selectedOptions, currentQuestion = _this$state2.currentQuestion, selectedAnswer1 = _this$state2.selectedAnswer1, selectedAnswer2 = _this$state2.selectedAnswer2;
	              _this$props6 = _this.props, apiServices = _this$props6.apiServices, type = _this$props6.questionType, quiz_id = _this$props6.params.quiz_id, onHandleSetTimer = _this$props6.onHandleSetTimer;
	              isValidated = selectedAnswer1 && selectedAnswer2;
	
	              if (isValidated) {
	                _context7.next = 6;
	                break;
	              }
	
	              _this.setState({ isError: true });
	              return _context7.abrupt('return');
	
	            case 6:
	              answerValue1 = currentQuestion[selectedAnswer1];
	              answerValue2 = currentQuestion[selectedAnswer2];
	              isCorrect = answerValue1 === currentQuestion.answer1 && answerValue2 === currentQuestion.answer2;
	              selectedChoice = JSON.stringify({ selectedAnswer1: selectedAnswer1, selectedAnswer2: selectedAnswer2 });
	
	
	              onHandleSetTimer(false, true);
	
	              _this.setState(function (prevState) {
	                return {
	                  validated: true,
	                  isUserSelectedChoice: isCorrect
	                };
	              });
	              payload = {
	                question_id: currentQuestion.id,
	                right_answer: isCorrect ? 1 : 0,
	                answer: isCorrect ? 1 : 0,
	                quiz_id: quiz_id,
	                selected_choice: selectedChoice,
	                type: type
	              };
	
	              if (!isSaveAttemptStats) {
	                _context7.next = 18;
	                break;
	              }
	
	              _context7.next = 16;
	              return apiServices.saveAttemptStats(payload);
	
	            case 16:
	              _context7.next = 18;
	              return apiServices.saveQuizAnswer(payload);
	
	            case 18:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.handleChoicesSelect = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(function (prevState) {
	        return {
	          selectedOptions: Object.assign({}, prevState.selectedOptions, _defineProperty({}, name, value))
	        };
	      });
	    };
	
	    _this.renderOptions = function () {
	      var _this$state3 = _this.state,
	          validated = _this$state3.validated,
	          currentQuestion = _this$state3.currentQuestion;
	
	      // Dynamically get all answer keys (e.g., answer1, answer2, etc.)
	
	      var answerKeys = Object.keys(currentQuestion).filter(function (key) {
	        if (key.startsWith('answer') && Boolean(currentQuestion[key])) return true;
	      });
	
	      // Dynamically get selected answer values from state
	      var selectedAnswers = answerKeys.reduce(function (acc, answerKey) {
	        var index = answerKey.replace('answer', '');
	        acc[answerKey] = _this.state['selectedAnswer' + index];
	        return acc;
	      }, {});
	
	      // Get all option entries
	      var optionEntries = Object.entries(currentQuestion).filter(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 1),
	            key = _ref9[0];
	
	        return key.startsWith('option');
	      });
	      return optionEntries.map(function (_ref10) {
	        var _ref11 = _slicedToArray(_ref10, 2),
	            optionKey = _ref11[0],
	            optionValue = _ref11[1];
	
	        return _react2.default.createElement(
	          'tr',
	          { key: optionKey },
	          answerKeys.map(function (answerKey, idx) {
	            var selectedKey = 'selectedAnswer' + answerKey.replace('answer', '');
	            var isCorrect = currentQuestion[answerKey].trim() === optionValue.trim();
	            var isSelected = selectedAnswers[answerKey] === optionKey;
	
	            var inputClass = validated && isSelected ? isCorrect ? 'accent-success' : 'accent-faliure' : '';
	
	            var isShowCorrectChoices = validated && isCorrect && !isSelected;
	
	            return _react2.default.createElement(
	              'td',
	              { className: 'border-solid-1 p-10px', key: optionKey + '-' + answerKey },
	              isShowCorrectChoices ? _react2.default.createElement('input', {
	                type: 'radio',
	                name: 'correct' + (idx + 1),
	                className: 'accent-success',
	                checked: true,
	                readOnly: true
	              }) : _react2.default.createElement('input', {
	                type: 'radio',
	                name: 'answer' + (idx + 1),
	                className: inputClass,
	                disabled: !inputClass && validated,
	                checked: isSelected,
	                onChange: function onChange() {
	                  return _this.handleSelect(selectedKey, optionKey);
	                }
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'td',
	            { className: 'border-solid-1 p-10px' },
	            optionValue
	          )
	        );
	      });
	    };
	
	    _this.reportCardToggle = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReportCardHidden: !prevState.isReportCardHidden
	        };
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      questionData: [],
	      selectedAnswer1: '',
	      selectedAnswer2: '',
	      validated: false,
	      isUserSelectedChoice: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      saveTooltipTitle: '' + _messages.messages.SAVE_ITEM_DESCRIPTION,
	      questionRatingTitle: _messages.messages.RATING_THIS_QUESTION,
	      isFlashCardHidden: true,
	      isReportCardHidden: true,
	      showCalculator: false,
	      isError: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(TwoPartAnalysis, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return this.handleSetCurrentQuestion();
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref12.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps) {
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                params = this.props.params;
	
	                if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
	                  this.handleSetCurrentQuestion();
	                }
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x3) {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          isUserSelectedChoice = _state.isUserSelectedChoice,
	          validated = _state.validated,
	          saveTooltipTitle = _state.saveTooltipTitle,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          isReportCardHidden = _state.isReportCardHidden,
	          questionRating = _state.questionRating,
	          questionRatingTitle = _state.questionRatingTitle,
	          showCalculator = _state.showCalculator,
	          questionContent = _state.questionContent,
	          questionTable = _state.questionTable,
	          sortingOptions = _state.sortingOptions,
	          isError = _state.isError;
	      var _props = this.props,
	          apiServices = _props.apiServices,
	          params = _props.params,
	          redirectToResults = _props.redirectToResults,
	          questionType = _props.questionType,
	          questionIds = _props.questionIds,
	          examName = _props.examName;
	      // Quiz routes don't expose question_id / readingid / reading in URL params;
	      // pull report fields from currentQuestion + questionType so /reportQuestion
	      // gets real values. Mirrors saveAttemptStats logic.
	
	      var offset = params.offset,
	          quizId = params.quiz_id;
	
	      var question_id = currentQuestion && currentQuestion.id;
	      var reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
	      var topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
	      var type = questionType;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUIZ_ID + ': ' + quizId },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1 calc-btn',
	                onClick: function onClick() {
	                  return _this3.setState({
	                    showCalculator: true
	                  });
	                }
	              },
	              _messages.messages.OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { className: 'mr-1', onClick: function onClick() {
	                  return redirectToResults();
	                } },
	              _messages.messages.BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          currentQuestion && Object.keys(currentQuestion).length ? _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(_CustomCardHeader2.default, {
	              headingText: '(Q. ' + (parseInt(offset, 10) + 1) + ')',
	              headerImage: _question_icon_blue2.default,
	              arrayLength: Object.keys(questionIds).length,
	              showPreviousButton: true,
	              showNextButton: true,
	              disabledPreviousButton: currentIndex < 1,
	              disabledNextButton: currentIndex >= Object.keys(questionIds).length - 1,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion
	            }),
	            _react2.default.createElement(
	              _CustomCardBody2.default,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 10, sm: 12, lg: 10, className: 'mb-0 font-16px mb-sm-1 question-view' },
	                  (0, _function.renderHTMLContent)(currentQuestion.question, 'div', 'text-left'),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'text-center  margin_bottom_30' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          currentQuestion.choice_a
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'p-10px' },
	                          currentQuestion.choice_b
	                        ),
	                        _react2.default.createElement('th', { className: 'p-10px' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.renderOptions()
	                    )
	                  ),
	                  isError && _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 12, md: 12, lg: 12, className: 'text-danger text-left  mb-0 pb-0' },
	                    _messages.messages.SELECT_OPTION_ERROR
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-center mt-3 d-flex' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      isQue: true,
	                      showResult: validated,
	                      _getResult: this.handleValidate,
	                      _saveQuestion: this.handleSaveQuestion,
	                      _displayReportForm: this.reportCardToggle,
	                      all_questions: questionData,
	                      save_text: saveTooltipTitle,
	                      bookmarkCSS: bookmarkCSS,
	                      bookmarkColor: bookmarkColor
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: 2, sm: 12, lg: 2, className: 'text-center' },
	                  this.props.children
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'h1',
	            { className: 'text-center pt-3 pb-3' },
	            _messages.messages.NO_DATA_FOUND
	          )
	        ),
	        validated && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: isUserSelectedChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                className: 'text-uppercase ' + (isUserSelectedChoice ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion.explanation, 'span')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentQuestion && currentQuestion.id },
	          type: _constant.QUESTION_TYPE.QUESTION,
	          question_type: questionType,
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: examName
	        }),
	        _react2.default.createElement(_ReportComponent2.default, {
	          visible: !isReportCardHidden,
	          apiServices: apiServices,
	          payload: {
	            question_id: question_id,
	            type: type,
	            topic_name: topic_name,
	            reading_id: reading_id
	          }
	        }),
	        _react2.default.createElement(_GMATCalculator2.default, {
	          show: showCalculator,
	          closeModal: function closeModal() {
	            return _this3.setState({ showCalculator: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return TwoPartAnalysis;
	}(_react.Component);
	
	TwoPartAnalysis.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = TwoPartAnalysis;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableSort = function (_Component) {
	  _inherits(TableSort, _Component);
	
	  function TableSort() {
	    _classCallCheck(this, TableSort);
	
	    return _possibleConstructorReturn(this, (TableSort.__proto__ || Object.getPrototypeOf(TableSort)).apply(this, arguments));
	  }
	
	  _createClass(TableSort, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          sortOptions = _props.sortOptions,
	          onSortChange = _props.onSortChange,
	          onReset = _props.onReset;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'd-flex mt-1 align-items-center mb-1' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'm-0 font-weight-bold' },
	          'Sort By :'
	        ),
	        _react2.default.createElement(
	          'select',
	          {
	            name: 'table_data_select',
	            id: 'table_data_select',
	            onChange: function onChange(e) {
	              return onSortChange(e.target.value);
	            },
	            className: 'h-min-content ml-35px w-lg-30 w-sm-50'
	          },
	          _react2.default.createElement(
	            'option',
	            { selected: 'selected', disabled: 'disabled', value: 'DEFAULT' },
	            'Select...'
	          ),
	          sortOptions && sortOptions.length ? sortOptions.map(function (value, index) {
	            return _react2.default.createElement(
	              'option',
	              { key: index, value: index },
	              (0, _function.renderHTMLContent)(value, 'span')
	            );
	          }) : null
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'up tooltip-hover-questions ml-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            ' Reset '
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'submit',
	              'aria-label': 'Reset',
	              className: 'btn btn-circle btn-refresh pointer_class',
	              id: 'Tooltip-2',
	              onClick: onReset
	            },
	            _react2.default.createElement('i', { className: 'fa fa-refresh p-0', 'aria-hidden': 'true' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableSort;
	}(_react.Component);
	
	exports.default = TableSort;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ReportQuestion = __webpack_require__(169);
	
	var _ReportQuestion2 = _interopRequireDefault(_ReportQuestion);
	
	var _SaveQuestion = __webpack_require__(170);
	
	var _SaveQuestion2 = _interopRequireDefault(_SaveQuestion);
	
	var _NotesStats = __webpack_require__(518);
	
	var _NotesStats2 = _interopRequireDefault(_NotesStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NotesCardFooter(_ref) {
	  var toggleReportSection = _ref.toggleReportSection,
	      favItemId = _ref.favItemId,
	      onSaveItemChange = _ref.onSaveItemChange,
	      setChildRef = _ref.setChildRef,
	      apiServiceProvider = _ref.apiServiceProvider,
	      savePayLoad = _ref.savePayLoad,
	      _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === undefined ? true : _ref$isLoading,
	      level = _ref.level;
	
	  return !isLoading && _react2.default.createElement(
	    _reactstrap.Col,
	    { sm: 9, xs: 12 },
	    _react2.default.createElement(
	      'div',
	      { className: 'd-flex align-items-center mt-2 mb-1' },
	      _react2.default.createElement(_NotesStats2.default, { apiServiceProvider: apiServiceProvider, id: favItemId, level: level }),
	      _react2.default.createElement(_SaveQuestion2.default, {
	        savePayLoad: savePayLoad,
	        favItemId: favItemId,
	        onSaveItemChange: onSaveItemChange,
	        setChildRef: setChildRef,
	        apiServiceProvider: apiServiceProvider
	      }),
	      _react2.default.createElement(_ReportQuestion2.default, { onClick: toggleReportSection })
	    )
	  );
	}
	exports.default = NotesCardFooter;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomCard(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-sm-12 col-md-12 note-section ' + (className || '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'card note-section-header', style: Object.assign({}, style || {}) },
	      children
	    )
	  );
	}
	
	exports.default = CustomCard;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ValidateButton = __webpack_require__(521);
	
	var _ValidateButton2 = _interopRequireDefault(_ValidateButton);
	
	var _SaveQuestion = __webpack_require__(170);
	
	var _SaveQuestion2 = _interopRequireDefault(_SaveQuestion);
	
	var _ReportQuestion = __webpack_require__(169);
	
	var _ReportQuestion2 = _interopRequireDefault(_ReportQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function QuestionBankFooter(_ref) {
	  var validateQuestion = _ref.validateQuestion,
	      toggleReportSection = _ref.toggleReportSection,
	      favItemId = _ref.favItemId,
	      onSaveItemChange = _ref.onSaveItemChange,
	      setChildRef = _ref.setChildRef,
	      apiServiceProvider = _ref.apiServiceProvider,
	      savePayLoad = _ref.savePayLoad,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    { sm: 9, xs: 12 },
	    _react2.default.createElement(
	      'div',
	      { className: 'd-flex align-items-center mt-2 mb-1' },
	      _react2.default.createElement(_ValidateButton2.default, { onValidate: validateQuestion, disabled: disabled }),
	      _react2.default.createElement(_SaveQuestion2.default, {
	        savePayLoad: savePayLoad,
	        favItemId: favItemId,
	        onSaveItemChange: onSaveItemChange,
	        setChildRef: setChildRef,
	        apiServiceProvider: apiServiceProvider
	      }),
	      _react2.default.createElement(_ReportQuestion2.default, { onClick: toggleReportSection })
	    )
	  );
	}
	exports.default = QuestionBankFooter;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Tooltip = __webpack_require__(136);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateFilter = function (_Component) {
	  _inherits(DateFilter, _Component);
	
	  function DateFilter(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, DateFilter);
	
	    var _this = _possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));
	
	    _this.onHandleDateChange = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(date, name) {
	        var startDate;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                startDate = _this.state.startDate;
	
	                if (name === 'startDate') {
	                  _this.setState({
	                    startDate: date,
	                    endDate: '',
	                    formattedEndDate: '',
	                    formattedStartDate: (0, _moment2.default)(date).format(_constant.defaultDateFormat)
	                  });
	                } else {
	                  if (startDate !== '') _this.setState({
	                    endDate: date,
	                    formattedEndDate: (0, _moment2.default)(date).format(_constant.defaultDateFormat)
	                  });
	                }
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onResetDate = function () {
	      var _this$state = _this.state,
	          startDate = _this$state.startDate,
	          endDate = _this$state.endDate;
	      var _this$props = _this.props,
	          getUserBarGraph = _this$props.getUserBarGraph,
	          getTotalUsersBarGraph = _this$props.getTotalUsersBarGraph,
	          _this$props$level = _this$props.level,
	          level = _this$props$level === undefined ? '' : _this$props$level;
	
	      if (startDate && endDate) {
	        _this.setState({
	          startDate: '',
	          endDate: '',
	          formattedStartDate: '',
	          formattedEndDate: ''
	        }, function () {
	          var _this$state2 = _this.state,
	              formattedStartDate = _this$state2.formattedStartDate,
	              formattedEndDate = _this$state2.formattedEndDate;
	
	          getUserBarGraph(formattedStartDate, formattedEndDate, level);
	          getTotalUsersBarGraph(formattedStartDate, formattedEndDate, level);
	          // this.getQuestionProgressBar(data);
	        });
	      }
	    };
	
	    _this.state = {
	      startDate: '',
	      endDate: '',
	      tooltipOpen: false,
	      formattedEndDate: '',
	      formattedStartDate: ''
	    };
	    return _this;
	  }
	
	  _createClass(DateFilter, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(prevProps, prevState) {
	        var _state, formattedStartDate, formattedEndDate, _props, getUserBarGraph, getTotalUsersBarGraph, _props$level, level;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _state = this.state, formattedStartDate = _state.formattedStartDate, formattedEndDate = _state.formattedEndDate;
	                _props = this.props, getUserBarGraph = _props.getUserBarGraph, getTotalUsersBarGraph = _props.getTotalUsersBarGraph, _props$level = _props.level, level = _props$level === undefined ? '' : _props$level;
	
	
	                if (formattedStartDate && formattedEndDate && formattedEndDate !== prevState.formattedEndDate) {
	                  getUserBarGraph(formattedStartDate, formattedEndDate, level);
	                  getTotalUsersBarGraph(formattedStartDate, formattedEndDate, level);
	                }
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidUpdate(_x3, _x4) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          startDate = _state2.startDate,
	          endDate = _state2.endDate,
	          tooltipOpen = _state2.tooltipOpen;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card margin_bottom_20' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row dashboard-filter' },
	            _react2.default.createElement(
	              'div',
	              { className: 'date-field align-self-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mr-1 min-width-35px text-md-right align-self-center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'mb-0' },
	                    _messages.messages.FROM
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'align-self-center w-100 pr-1' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'datepicker_wrap' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'ico_box' },
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                        alt: 'startDateCalendar',
	                        width: '14'
	                      })
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      selected: startDate,
	                      onChange: function onChange(event) {
	                        return _this3.onHandleDateChange(event, 'startDate');
	                      },
	                      placeholderText: 'Select date',
	                      width: '100%'
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'date-field align-self-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mr-1 min-width-35px text-md-center align-self-center' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'mb-0' },
	                    ' ',
	                    _messages.messages.TO
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'align-self-center w-100 pr-1' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'datepicker_wrap' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'ico_box' },
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                        alt: 'EndDateCalendar',
	                        width: '14'
	                      })
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      placeholderText: 'Select date',
	                      width: '100%',
	                      selected: endDate,
	                      minDate: startDate,
	                      onChange: function onChange(event) {
	                        return _this3.onHandleDateChange(event, 'endDate');
	                      }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mx-auto text-md-center align-self-center' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  'aria-label': 'Reset date filter',
	                  className: 'btn btn-circle btn-refresh cursor-pointer ' + (!startDate || !endDate ? 'disabled' : ''),
	                  onClick: function onClick() {
	                    return _this3.onResetDate();
	                  }
	                },
	                _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true', id: 'Tooltip-1' }),
	                _react2.default.createElement(_Tooltip2.default, {
	                  key: '1',
	                  tooltipId: '1',
	                  content: 'Reset Date',
	                  tooltipPlace: 'top',
	                  tooltipOpen: tooltipOpen,
	                  isTooltipIcon: false
	                }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'reset' },
	                  'Reset'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateFilter;
	}(_react.Component);
	
	exports.default = DateFilter;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Tooltip = __webpack_require__(136);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PerformanceGraph = function PerformanceGraph(_ref) {
	  var _ref$headText = _ref.headText,
	      headText = _ref$headText === undefined ? '' : _ref$headText,
	      _ref$tooltipContent = _ref.tooltipContent,
	      tooltipContent = _ref$tooltipContent === undefined ? '' : _ref$tooltipContent,
	      _ref$tooltipPlace = _ref.tooltipPlace,
	      tooltipPlace = _ref$tooltipPlace === undefined ? 'left' : _ref$tooltipPlace,
	      performanceGraphLoader = _ref.performanceGraphLoader,
	      tooltipOpen = _ref.tooltipOpen,
	      _ref$barLabel = _ref.barLabel,
	      barLabel = _ref$barLabel === undefined ? [] : _ref$barLabel,
	      _ref$usersBarGraphDat = _ref.usersBarGraphData,
	      usersBarGraphData = _ref$usersBarGraphDat === undefined ? [] : _ref$usersBarGraphDat,
	      _ref$totalUsersBarGra = _ref.totalUsersBarGraphData,
	      totalUsersBarGraphData = _ref$totalUsersBarGra === undefined ? [] : _ref$totalUsersBarGra;
	
	  var barGraphData = {
	    labels: barLabel,
	    datasets: [{
	      label: 'You',
	      backgroundColor: 'rgb(31,140,235)',
	      borderWidth: 1,
	      hoverBackgroundColor: 'rgb(31,140,235)',
	      data: usersBarGraphData
	    }, {
	      label: 'AnalystPrep Users Average',
	      backgroundColor: 'rgb(42,63,84)',
	      borderWidth: 1,
	      hoverBackgroundColor: 'rgb(42,63,84)',
	      data: totalUsersBarGraphData
	    }]
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card-header' },
	      headText,
	      _react2.default.createElement(
	        'div',
	        { className: 'card-actions card_action_tooltip float-right' },
	        _react2.default.createElement(_Tooltip2.default, {
	          key: '0',
	          tooltipId: '0',
	          content: tooltipContent,
	          tooltipPlace: tooltipPlace,
	          tooltipOpen: tooltipOpen
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-block' },
	      _react2.default.createElement(
	        'div',
	        { className: 'main_loader  ' + (performanceGraphLoader ? 'show_block' : 'hide_block') },
	        _react2.default.createElement(
	          'div',
	          { className: 'loader-mid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block-loader' },
	            _react2.default.createElement(_loader2.default, null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'chart-wrapper performance-chart-wrapper' },
	        barGraphData.labels && _react2.default.createElement(_reactChartjs.Bar, {
	          data: barGraphData,
	          options: Object.assign({
	            maintainAspectRatio: false
	          }, _constant.Y_AXIS_SCALES, {
	            tooltips: {
	              callbacks: {
	                label: function label(tooltipItem, data) {
	                  return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                }
	              }
	            }
	          })
	        })
	      )
	    )
	  );
	};
	
	exports.default = PerformanceGraph;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(136);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function ProgressBar(_ref) {
	  var _ref$headerName = _ref.headerName,
	      headerName = _ref$headerName === undefined ? '' : _ref$headerName,
	      _ref$tooltipContent = _ref.tooltipContent,
	      tooltipContent = _ref$tooltipContent === undefined ? _messages.messages.YOU_CAN_SEE : _ref$tooltipContent,
	      _ref$tooltipPlace = _ref.tooltipPlace,
	      tooltipPlace = _ref$tooltipPlace === undefined ? 'left' : _ref$tooltipPlace,
	      _ref$ProgressBarData = _ref.ProgressBarData,
	      ProgressBarData = _ref$ProgressBarData === undefined ? [] : _ref$ProgressBarData,
	      _ref$progressBarLoade = _ref.progressBarLoader,
	      progressBarLoader = _ref$progressBarLoade === undefined ? true : _ref$progressBarLoade,
	      _ref$ProgressBarTable = _ref.ProgressBarTables,
	      ProgressBarTables = _ref$ProgressBarTable === undefined ? '' : _ref$ProgressBarTable,
	      _ref$countKey = _ref.countKey,
	      countKey = _ref$countKey === undefined ? 'questionsCount' : _ref$countKey;
	
	  var progressBarItem = void 0;
	  var questionModel = ProgressBarTables.questionModel,
	      questionStatsModel = ProgressBarTables.questionStatsModel;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card-header' },
	      headerName,
	      _react2.default.createElement(
	        'div',
	        { className: 'card-actions card_action_tooltip float-right' },
	        _react2.default.createElement(_Tooltip2.default, {
	          key: headerName,
	          tooltipId: headerName,
	          content: tooltipContent,
	          tooltipPlace: tooltipPlace
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: '' },
	      _react2.default.createElement(
	        'table',
	        { className: 'table table-hover mb-0 compress_table' },
	        progressBarLoader ? _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        ) : _react2.default.createElement(
	          'tbody',
	          null,
	          ProgressBarData.map(function (item, index) {
	            progressBarItem = Math.round(item[questionModel + '.' + questionStatsModel + '.attemptCount'] / item[questionModel + '.' + countKey] * 100);
	            if (progressBarItem < 1) {
	              progressBarItem = 1;
	            }
	            return _react2.default.createElement(
	              'tr',
	              { key: index },
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'question_count' },
	                    '' + (headerName === 'Questions Progress' ? 'Q.' : 'N.') + (index + 1)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'question_bar' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      item.chapterName
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'bar_wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: 'progress progress-xs',
	                            style: { width: progressBarItem + '%' }
	                          },
	                          _react2.default.createElement('div', {
	                            className: 'progress-bar bg-info',
	                            role: 'progressbar',
	                            'aria-label': item.chapterName + ' progress',
	                            'aria-valuenow': progressBarItem,
	                            'aria-valuemin': 0,
	                            'aria-valuemax': 100,
	                            style: { width: '100%' }
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	exports.default = ProgressBar;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _ModalComponent = __webpack_require__(263);
	
	var _ModalComponent2 = _interopRequireDefault(_ModalComponent);
	
	var _notFound = __webpack_require__(1251);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _TabActionButton = __webpack_require__(524);
	
	var _TabActionButton2 = _interopRequireDefault(_TabActionButton);
	
	var _EditReportModalBody = __webpack_require__(523);
	
	var _EditReportModalBody2 = _interopRequireDefault(_EditReportModalBody);
	
	var _messages = __webpack_require__(14);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var TabList = function (_Component) {
	  _inherits(TabList, _Component);
	
	  function TabList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TabList);
	
	    var _this = _possibleConstructorReturn(this, (TabList.__proto__ || Object.getPrototypeOf(TabList)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var currentIndex, tabList;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              currentIndex = _this.state.currentIndex;
	              tabList = _this.props.tabList;
	
	              tabList.length && _this.getData(currentIndex);
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(index) {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	
	                _this.setState({
	                  currentIndex: index,
	                  tabsData: []
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                  var currentIndex, _this$props, section, _this$props$level, level, _this$props2, tabList, apiServiceProvider, tabsData;
	
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          currentIndex = _this.state.currentIndex, _this$props = _this.props, section = _this$props.section, _this$props$level = _this$props.level, level = _this$props$level === undefined ? '' : _this$props$level;
	                          _this$props2 = _this.props, tabList = _this$props2.tabList, apiServiceProvider = _this$props2.apiServiceProvider;
	                          _context2.next = 4;
	                          return apiServiceProvider[tabList[currentIndex][section]]({ level: level });
	
	                        case 4:
	                          tabsData = _context2.sent;
	
	                          _this.setState({
	                            tabsData: tabsData.success ? tabsData.data : [],
	                            isLoading: false
	                          });
	
	                        case 6:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                })));
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onView = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(apiService, items) {
	        var currentIndex, _this$props3, tabList, apiServiceProvider, level, selectedTabWiseServices, saveItemTableName, getParameterList, mapping;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                currentIndex = _this.state.currentIndex;
	                _this$props3 = _this.props, tabList = _this$props3.tabList, apiServiceProvider = _this$props3.apiServiceProvider, level = _this$props3.level;
	                selectedTabWiseServices = tabList[currentIndex];
	                saveItemTableName = selectedTabWiseServices.saveItemTableName;
	
	                if (!apiService) {
	                  _context4.next = 17;
	                  break;
	                }
	
	                _context4.next = 7;
	                return apiServiceProvider[apiService](Object.assign({}, items));
	
	              case 7:
	                getParameterList = _context4.sent;
	                _context4.t0 = _this.context.router;
	                _context4.next = 11;
	                return _this.onNavigateTo((0, _cfa1NextRoutes.nextAwareRoute)(selectedTabWiseServices.redirectionPath), getParameterList.data);
	
	              case 11:
	                _context4.t1 = _context4.sent;
	                _context4.t2 = Object.assign({}, items[saveItemTableName + '.mock_id'] && {
	                  mockId: items[saveItemTableName + '.mock_id']
	                }, getParameterList.data && getParameterList.data.media_type === 'webinar' && {
	                  mediaType: 'webinar'
	                });
	                _context4.t3 = {
	                  pathname: _context4.t1,
	                  query: _context4.t2
	                };
	
	                _context4.t0.push.call(_context4.t0, _context4.t3);
	
	                _context4.next = 24;
	                break;
	
	              case 17:
	                mapping = {
	                  readingId: saveItemTableName + '.readingId',
	                  chapterId: saveItemTableName + '.chapterId',
	                  id: 'video_id'
	                };
	                _context4.t4 = _this.context.router;
	                _context4.next = 21;
	                return _this.replaceValues((0, _cfa1NextRoutes.nextAwareRoute)(selectedTabWiseServices.redirectionPath), items, mapping).replace(':level', level);
	
	              case 21:
	                _context4.t5 = _context4.sent;
	                _context4.t6 = {
	                  pathname: _context4.t5
	                };
	
	                _context4.t4.push.call(_context4.t4, _context4.t6);
	
	              case 24:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.replaceValues = function (template, data, mapping) {
	      // eslint-disable-next-line id-length
	      return template.replace(/:(\w+)/g, function (_, key) {
	        var actualKey = mapping[key] || key;
	        var value = actualKey.split('.').reduce(function (obj, prop) {
	          return obj && obj[prop] ? obj[prop] : data[actualKey];
	        }, data);
	        return value !== undefined ? value : ':' + key;
	      });
	    };
	
	    _this.onNavigateTo = function (path, parameterList) {
	      var navigateURL = path;
	      for (var key in parameterList) {
	        navigateURL = navigateURL.replace(':' + key, parameterList[key]);
	      }
	      return navigateURL;
	    };
	
	    _this.onDelete = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(apiService, items) {
	        var currentIndex, id, item_id, flash_card, _this$props$exam, exam, apiServiceProvider, payload, payLoad, tabsData;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                currentIndex = _this.state.currentIndex;
	                id = items.id, item_id = items.item_id, flash_card = items.flash_card;
	                _this$props$exam = _this.props.exam, exam = _this$props$exam === undefined ? 'esg' : _this$props$exam;
	                apiServiceProvider = _this.props.apiServiceProvider;
	
	                if (!flash_card) {
	                  _context5.next = 8;
	                  break;
	                }
	
	                payload = {
	                  type: apiService === 'deleteSavedQuestion' ? 'question' : apiService === 'deleteSavedNotes' ? 'notes' : 'video',
	                  question_type: '',
	                  exam: exam,
	                  level: '',
	                  item_id: item_id
	                };
	                _context5.next = 8;
	                return apiServiceProvider['deleteFlashCard'](payload);
	
	              case 8:
	                payLoad = exam !== 'frm' ? { id: id } : items;
	                _context5.next = 11;
	                return apiServiceProvider[apiService](payLoad);
	
	              case 11:
	                tabsData = _context5.sent;
	
	                if (tabsData.success) {
	                  _this.getData(currentIndex);
	                  _this.setState({
	                    apiService: '',
	                    reportedItem: '',
	                    isReportModelOpen: false
	                  });
	                } else {
	                  _this.setState({
	                    apiService: '',
	                    reportedItem: '',
	                    isReportModelOpen: false
	                  });
	                }
	
	              case 13:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlertReport = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(apiService, items) {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this.setState({
	                  isReportModelOpen: !_this.state.isReportModelOpen,
	                  apiService: apiService,
	                  reportedItem: items
	                });
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.checkEmptyField = function (fieldValue, fieldText) {
	      if (fieldValue === '') {
	        _this.setState(_defineProperty({}, fieldText, true));
	        return true;
	      }
	      return false;
	    };
	
	    _this.onViewFeedbackModalToggle = function (apiService, items) {
	      var willOpen = !_this.state.isViewFeedbackModalOpen;
	      _this.setState({
	        isViewFeedbackModalOpen: willOpen,
	        selectedFeedbackItemId: willOpen && items ? items.id : null,
	        isFurtherHelpFormOpen: false
	      }, function () {
	        !_this.state.isViewFeedbackModalOpen && _this.setState({
	          contactSubject: '',
	          contactComment: '',
	          isFurtherHelpSubmitForm: false
	        });
	      });
	    };
	
	    _this.onToggleFurtherHelpButton = function () {
	      _this.setState({
	        isFurtherHelpFormOpen: !_this.state.isFurtherHelpFormOpen,
	        isFurtherHelpSubmitForm: false,
	        contactSubject: '',
	        contactComment: '',
	        isSubjectError: false,
	        isCommentError: false
	      });
	    };
	
	    _this.onHandleFurtherHelpChange = function (event) {
	      var _this$setState2;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, value), _defineProperty(_this$setState2, 'isSubjectError', false), _defineProperty(_this$setState2, 'isCommentError', false), _this$setState2));
	    };
	
	    _this.onHandleFurtherHelpSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var apiServiceProvider, _this$state, contactSubject, contactComment;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              apiServiceProvider = _this.props.apiServiceProvider;
	              _this$state = _this.state, contactSubject = _this$state.contactSubject, contactComment = _this$state.contactComment;
	
	              if (!_this.checkEmptyField(contactSubject, 'isSubjectError')) {
	                _context7.next = 4;
	                break;
	              }
	
	              return _context7.abrupt('return');
	
	            case 4:
	              if (!_this.checkEmptyField(contactComment, 'isCommentError')) {
	                _context7.next = 6;
	                break;
	              }
	
	              return _context7.abrupt('return');
	
	            case 6:
	              _this.setState({ isFurtherHelpFormOpen: true, isSendFurtherLoading: true });
	              _context7.next = 9;
	              return apiServiceProvider['sendFurtherHelpRequest']({
	                contactSubject: contactSubject,
	                contactComment: contactComment
	              });
	
	            case 9:
	              _this.setState({
	                isFurtherHelpSubmitForm: true,
	                isSendFurtherLoading: false
	              });
	
	            case 10:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.onReportCommentChange = function (event) {
	      _this.setState({
	        reportComment: event.target.value,
	        isReportError: false
	      });
	    };
	
	    _this.onReportEditModalToggle = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(apiService, items) {
	        var _this$state2, isReportEditModalOpen, currentIndex, _items$comment, comment, _items$tableKey, tableKey, _items$tableName, tableName, tabList, _tabList$currentIndex, saveItemTableName, savedItemTableKey, dottedTitle, nestedTitle, reportTitle, reportModalHeader;
	
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this$state2 = _this.state, isReportEditModalOpen = _this$state2.isReportEditModalOpen, currentIndex = _this$state2.currentIndex;
	
	                if (!isReportEditModalOpen) {
	                  _items$comment = items.comment, comment = _items$comment === undefined ? '' : _items$comment, _items$tableKey = items.tableKey, tableKey = _items$tableKey === undefined ? '' : _items$tableKey, _items$tableName = items.tableName, tableName = _items$tableName === undefined ? '' : _items$tableName;
	                  tabList = _this.props.tabList;
	                  _tabList$currentIndex = tabList[currentIndex], saveItemTableName = _tabList$currentIndex.saveItemTableName, savedItemTableKey = _tabList$currentIndex.savedItemTableKey;
	                  // Report rows key the included question by the edition-specific association alias
	                  // (e.g. 2027 -> cfa1_2027_question / cfa1_2027_cbt_question). Resolve defensively: a missing
	                  // or differently-aliased nested object must never crash the edit click.
	
	                  dottedTitle = items[saveItemTableName + '.' + savedItemTableKey];
	                  nestedTitle = tableName && items[tableName] ? items[tableName][tableKey] : '';
	                  reportTitle = dottedTitle || nestedTitle || '';
	                  reportModalHeader = reportTitle.length > 150 ? ' ' + reportTitle.substr(0, 100) + '...' : ' ' + reportTitle;
	
	
	                  _this.setState({
	                    reportComment: comment,
	                    reportEditItem: Object.assign({}, items, { apiService: apiService }),
	                    reportEditHeader: reportModalHeader,
	                    isReportError: false
	                  }, function () {
	                    _this.setState({
	                      isReportEditModalOpen: !_this.state.isReportEditModalOpen,
	                      isReportError: false
	                    });
	                  });
	                } else {
	                  _this.setState({
	                    isReportEditModalOpen: !_this.state.isReportEditModalOpen,
	                    reportEditItem: {},
	                    reportComment: '',
	                    reportEditHeader: '',
	                    isReportError: true
	                  });
	                }
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x8, _x9) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.onReportEditSubmit = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(event) {
	        var _this$state3, reportComment, reportEditItem, currentIndex, apiService, id, _this$props4, apiServiceProvider, _this$props4$level, level, editReport;
	
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                event.preventDefault();
	                _this$state3 = _this.state, reportComment = _this$state3.reportComment, reportEditItem = _this$state3.reportEditItem, currentIndex = _this$state3.currentIndex;
	                apiService = reportEditItem.apiService, id = reportEditItem.id;
	
	                if (!reportComment.trim().length) {
	                  _context9.next = 11;
	                  break;
	                }
	
	                _this$props4 = _this.props, apiServiceProvider = _this$props4.apiServiceProvider, _this$props4$level = _this$props4.level, level = _this$props4$level === undefined ? '' : _this$props4$level;
	                _context9.next = 7;
	                return apiServiceProvider[apiService]({
	                  id: id,
	                  comment: reportComment,
	                  level: level
	                });
	
	              case 7:
	                editReport = _context9.sent;
	
	                if (editReport.success) {
	                  _this.setState({
	                    isReportEditModalOpen: !_this.state.isReportEditModalOpen,
	                    isReportError: false,
	                    reportEditItem: {},
	                    reportComment: '',
	                    reportEditHeader: ''
	                  }, function () {
	                    _this.getData(currentIndex);
	                  });
	                }
	                _context9.next = 12;
	                break;
	
	              case 11:
	                _this.setState({
	                  isReportError: true,
	                  reportEditItem: {}
	                });
	
	              case 12:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x10) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      TabHeader: '',
	      currentIndex: 0,
	      tabsData: [],
	      isLoading: false,
	      apiService: '',
	      reportedItem: '',
	      reportComment: '',
	      isSubjectError: false,
	      isCommentError: false,
	      reportEditHeader: '',
	      contactSubject: '',
	      contactComment: '',
	      reportEditItem: {},
	      isReportModelOpen: false,
	      isReportEditModalOpen: false,
	      isViewFeedbackModalOpen: false,
	      selectedFeedbackItemId: null,
	      isSendFurtherLoading: false,
	      isFurtherHelpFormOpen: false,
	      isFurtherHelpSubmitForm: false,
	      isReportError: false
	    };
	    return _this;
	  }
	
	  _createClass(TabList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          TabHeader = _props.TabHeader,
	          section = _props.section,
	          tabList = _props.tabList;
	      var _state = this.state,
	          currentIndex = _state.currentIndex,
	          tabsData = _state.tabsData,
	          isLoading = _state.isLoading,
	          isReportModelOpen = _state.isReportModelOpen,
	          reportedItem = _state.reportedItem,
	          apiService = _state.apiService,
	          contactSubject = _state.contactSubject,
	          contactComment = _state.contactComment,
	          isReportEditModalOpen = _state.isReportEditModalOpen,
	          isReportError = _state.isReportError,
	          isFurtherHelpSubmitForm = _state.isFurtherHelpSubmitForm,
	          isViewFeedbackModalOpen = _state.isViewFeedbackModalOpen,
	          selectedFeedbackItemId = _state.selectedFeedbackItemId,
	          isFurtherHelpFormOpen = _state.isFurtherHelpFormOpen,
	          isSendFurtherLoading = _state.isSendFurtherLoading,
	          reportComment = _state.reportComment,
	          isSubjectError = _state.isSubjectError,
	          isCommentError = _state.isCommentError,
	          reportEditHeader = _state.reportEditHeader;
	
	      var showTabsData = tabList[currentIndex];
	      var savedItemTitle = showTabsData.savedItemTitle,
	          saveItemTableName = showTabsData.saveItemTableName,
	          savedItemTableKey = showTabsData.savedItemTableKey,
	          reportedItemTableKey = showTabsData.reportedItemTableKey,
	          idFieldName = showTabsData.idFieldName;
	      var ZERO = _constant.lengthCheck.ZERO,
	          HUNDRED = _constant.lengthCheck.HUNDRED,
	          ONE_HUNDRED_FIFTY = _constant.lengthCheck.ONE_HUNDRED_FIFTY;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'padding_bottom_30' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head padding_bottom_30' },
	            TabHeader
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex header-card-dashboard tab-header-wrap' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'dashboard-card-header-tab' },
	              tabList.map(function (tab, index) {
	                if (!tabList[index][section]) {
	                  return null;
	                }
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: tab.label,
	                    onClick: function onClick() {
	                      _this3.getData(index);
	                    },
	                    className: currentIndex === index && _messages.messages.ACTIVE
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    tab.label
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card tab-body-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block dashboard-cards-scroll my-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'chart-wrapper' },
	                isLoading ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block-loader' },
	                  _react2.default.createElement(_loader2.default, null)
	                ) : tabsData && tabsData.length ? tabsData.map(function (items, index) {
	                  var topic = items[saveItemTableName + '.' + savedItemTableKey] ? items[saveItemTableName + '.' + savedItemTableKey] : items['' + savedItemTableKey] ? items['' + savedItemTableKey] : '';
	
	                  return _react2.default.createElement(
	                    'div',
	                    { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	                    section === 'reportAPIService' && _react2.default.createElement(
	                      'div',
	                      { className: 'mb-1' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _messages.messages.TICKET_ID,
	                          ': '
	                        ),
	                        ' ',
	                        items.id
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'float-right status-' + items.status },
	                        _react2.default.createElement(
	                          'strong',
	                          { className: 'text-capitalize' },
	                          items.status
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          savedItemTitle,
	                          ': '
	                        ),
	                        items[idFieldName || 'id']
	                      ),
	                      _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: _messages.messages.DELETE,
	                        buttonCss: _constant.tabActionButtonStyles.delete,
	                        buttonColor: _constant.tabActionButtonStyles.deleteColor,
	                        apiService: section === 'reportAPIService' ? showTabsData['reportDeleteAPIService'] : showTabsData['saveItemDeleteAPIService'],
	                        onActionButtonClick: _this3.toggleAlertReport,
	                        items: items
	                      }),
	                      items.isSend && (items.answer || items.reply) && _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: _messages.messages.VIEW_FEEDBACK,
	                        buttonCss: _constant.tabActionButtonStyles.viewFeedback,
	                        buttonColor: _constant.tabActionButtonStyles.primaryColor,
	                        apiService: showTabsData['editAPIService'],
	                        onActionButtonClick: _this3.onViewFeedbackModalToggle,
	                        items: Object.assign({}, items, {
	                          tableName: saveItemTableName,
	                          tableKey: savedItemTableKey
	                        })
	                      }),
	                      _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: _messages.messages.VIEW,
	                        buttonCss: _constant.tabActionButtonStyles.view,
	                        buttonColor: _constant.tabActionButtonStyles.primaryColor,
	                        apiService: showTabsData['viewItemAPIService'],
	                        onActionButtonClick: !(savedItemTitle === 'Video ID' || savedItemTitle === 'CBT Question Id') && _this3.onView,
	                        items: items
	                      }),
	                      !items.isSend && !items.answer && items.status !== _messages.messages.RESOLVED && section === 'reportAPIService' ? _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: _messages.messages.EDIT_REPORT,
	                        buttonCss: _constant.tabActionButtonStyles.edit,
	                        buttonColor: _constant.tabActionButtonStyles.primaryColor,
	                        apiService: showTabsData['editAPIService'],
	                        onActionButtonClick: _this3.onReportEditModalToggle,
	                        items: Object.assign({}, items, {
	                          tableName: saveItemTableName,
	                          tableKey: savedItemTableKey
	                        })
	                      }) : null
	                    ),
	                    topic && _react2.default.createElement(
	                      'p',
	                      { className: 'mt-1' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        _messages.messages.TOPIC,
	                        ': '
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        topic && topic.length > 150 ? ' ' + topic.substr(0, 100) + '...' : ' ' + topic
	                      )
	                    ),
	                    items.flash_card && _react2.default.createElement(
	                      'p',
	                      { className: 'mt-1' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        _messages.messages.NOTE,
	                        ': '
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.flash_card && items.flash_card.length > ONE_HUNDRED_FIFTY ? ' ' + items.flash_card.substr(ZERO, HUNDRED) + '...' : ' ' + items.flash_card)
	                      )
	                    ),
	                    section === 'reportAPIService' && _react2.default.createElement(
	                      'p',
	                      { className: 'mt-1' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        _messages.messages.REPORT,
	                        ': '
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items[reportedItemTableKey].length > ONE_HUNDRED_FIFTY ? ' ' + items[reportedItemTableKey].substr(ZERO, HUNDRED) + '...' : ' ' + items[reportedItemTableKey])
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _ModalComponent2.default,
	                      {
	                        isModalOpen: isReportEditModalOpen,
	                        modalHeaderText: reportEditHeader,
	                        onModalToggle: _this3.onReportEditModalToggle
	                      },
	                      _react2.default.createElement(_EditReportModalBody2.default, {
	                        onReportEditSubmit: _this3.onReportEditSubmit,
	                        onReportEditModalToggle: _this3.onReportEditModalToggle,
	                        reportComment: reportComment,
	                        onReportCommentChange: _this3.onReportCommentChange,
	                        isReportErrorMessageDisplay: isReportError,
	                        reportErrorMessage: _messages.messages.REPORT_CANT_BE_EMPTY
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Modal,
	                      {
	                        isOpen: isViewFeedbackModalOpen && selectedFeedbackItemId === items.id,
	                        toggle: _this3.onViewFeedbackModalToggle,
	                        className: 'modal-primary '
	                      },
	                      _react2.default.createElement(
	                        _reactstrap.ModalHeader,
	                        null,
	                        'Q. ' + items.id,
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'pl-1' },
	                          topic
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'contact-us-btn float-right' },
	                          !isFurtherHelpFormOpen ? _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              className: 'btn btn-primary',
	                              onClick: _this3.onToggleFurtherHelpButton
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-question-circle pr-1', 'aria-hidden': 'true' }),
	                            _messages.messages.FURTHER_HELP
	                          ) : _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              className: 'btn btn-primary',
	                              onClick: _this3.onToggleFurtherHelpButton
	                            },
	                            _messages.messages.BACK
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'close',
	                              'aria-label': 'Close',
	                              onClick: _this3.onViewFeedbackModalToggle
	                            },
	                            _react2.default.createElement(
	                              'span',
	                              { 'aria-hidden': 'true' },
	                              '\xD7'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.ModalBody,
	                        null,
	                        isFurtherHelpFormOpen && !isFurtherHelpSubmitForm ? _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 margin_bottom_10' },
	                            _react2.default.createElement(
	                              'h6',
	                              { className: 'mb-1 d-flex' },
	                              _messages.messages.SUBJECT,
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'text-danger' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('textarea', {
	                              id: 'contactSubject',
	                              name: 'contactSubject',
	                              rows: '2',
	                              className: 'form-control',
	                              placeholder: 'Subject..',
	                              onChange: function onChange(event) {
	                                return _this3.onHandleFurtherHelpChange(event);
	                              },
	                              value: contactSubject
	                            }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'text-danger' },
	                              isSubjectError && _messages.messages.SUBJECT_CANT_BE_EMPTY
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 margin_bottom_10' },
	                            _react2.default.createElement(
	                              'h6',
	                              { className: 'mb-1 d-flex' },
	                              _messages.messages.COMMENT,
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'text-danger' },
	                                '*'
	                              )
	                            ),
	                            _react2.default.createElement('textarea', {
	                              id: 'contactComment',
	                              name: 'contactComment',
	                              rows: '6',
	                              className: 'form-control',
	                              placeholder: 'Comment..',
	                              onChange: function onChange(event) {
	                                return _this3.onHandleFurtherHelpChange(event);
	                              },
	                              value: contactComment
	                            }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'text-danger' },
	                              isCommentError && _messages.messages.COMMENT_CANT_BE_EMPTY
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                type: 'submit',
	                                className: 'btn btn-primary active pointer_class',
	                                onClick: _this3.onHandleFurtherHelpSubmit
	                              },
	                              isSendFurtherLoading ? _messages.messages.PLEASE_WAIT : _messages.messages.SEND_REQUEST
	                            )
	                          )
	                        ) : isFurtherHelpSubmitForm ? _react2.default.createElement(
	                          'div',
	                          { className: 'card-block' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-12 report-Success-card' },
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/success-ic.svg',
	                                alt: 'Success Icon'
	                              }),
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'form-control-label', htmlFor: 'textarea-input' },
	                                _react2.default.createElement(
	                                  'strong',
	                                  null,
	                                  _messages.messages.REQUEST_SENT_SUCCESSFULLY
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'button',
	                                {
	                                  type: 'button',
	                                  className: 'btn btn-primary active pointer_class  min-vw-120',
	                                  onClick: _this3.onViewFeedbackModalToggle
	                                },
	                                _messages.messages.CLOSE
	                              )
	                            )
	                          )
	                        ) : _react2.default.createElement(
	                          'div',
	                          { className: 'text-center' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'margin_bottom_20' },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              (0, _function.renderSanitizedHTML)(items.reply || items.answer)
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'text-center',
	                    style: {
	                      fontSize: '14px',
	                      color: 'grey',
	                      fontWeight: '500'
	                    }
	                  },
	                  _react2.default.createElement('img', {
	                    src: _notFound2.default,
	                    alt: 'notFoundImage',
	                    style: {
	                      width: '130px',
	                      height: '130px'
	                    }
	                  }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'mb-0' },
	                    _messages.messages.DATA_NOT_FOUND
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: isReportModelOpen,
	            toggle: this.toggleAlertReport,
	            className: 'modal-primary '
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _messages.messages.Alert,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'close',
	                'aria-label': 'Close',
	                onClick: this.toggleAlertReport
	              },
	              _react2.default.createElement(
	                'span',
	                { 'aria-hidden': 'true' },
	                '\xD7'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _messages.messages.DELETE_ALERT_MESSAGE
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-sm btn-primary',
	                  color: 'primary',
	                  onClick: function onClick() {
	                    return _this3.onDelete(apiService, reportedItem);
	                  }
	                },
	                _messages.messages.OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TabList;
	}(_react.Component);
	
	TabList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = TabList;

/***/ },
/* 258 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// CFA2 question-bank numbering helpers, shared by the 2026 (views/CFA2-2025) and
	// 2027 (views/CFA2-2027) Cfa2chapter.js pages.
	//
	// question_number can have gaps: inactive / admin-deleted questions keep their number
	// but are not in the case's active list (the LMS reads questions by case_id + isActive2025).
	
	// The requested number if the case has it, otherwise the case's first active question's number.
	var resolveQuestionNumber = exports.resolveQuestionNumber = function resolveQuestionNumber(questions, wanted) {
	  for (var i = 0; i < questions.length; i++) {
	    // eslint-disable-next-line eqeqeq
	    if (questions[i].question_number == wanted) return wanted;
	  }
	  return questions.length ? questions[0].question_number : wanted;
	};
	
	// Number shown to the user: position among the case's active questions (offset + 1), so gaps
	// don't show (the first active question is always 1). Falls back to the stored number while
	// no question is selected yet.
	var questionDisplayNumber = exports.questionDisplayNumber = function questionDisplayNumber(question, offset) {
	  return offset === '' || offset === null || offset === undefined ? question.question_number : Number(offset) + 1;
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var graphDataCalculator = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(response, userAttemptCount, userAnswerCount) {
	    var calculatedGraphData, iterator, rightAnswered, totalQuestion, userGraphValues;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            calculatedGraphData = [];
	            iterator = 0;
	
	          case 2:
	            if (!(iterator < response.length)) {
	              _context.next = 11;
	              break;
	            }
	
	            rightAnswered = response[iterator][userAnswerCount];
	            totalQuestion = response[iterator][userAttemptCount];
	            userGraphValues = parseInt(rightAnswered / totalQuestion * 100, 10) || 0;
	            _context.next = 8;
	            return calculatedGraphData.push(userGraphValues);
	
	          case 8:
	            iterator++;
	            _context.next = 2;
	            break;
	
	          case 11:
	            return _context.abrupt("return", calculatedGraphData);
	
	          case 12:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function graphDataCalculator(_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}();
	exports.default = graphDataCalculator;

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseIdToken = parseIdToken;
	/**
	 * Parse google OAuth token
	 * @param idToken
	 * @returns {{}|any}
	 */
	function parseIdToken(idToken) {
	    try {
	        var base64Url = idToken.split('.')[1];
	        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
	            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	        }).join(''));
	        return JSON.parse(jsonPayload); // { email, name, given_name, family_name, picture, ... }
	    } catch (e) {
	        console.error('Failed to parse ID token', e);
	        return {};
	    }
	}

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardBlockLoaderWrapper(_ref) {
	  var _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === undefined ? true : _ref$isLoading;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'main_loader  ' + (isLoading ? 'show_block' : 'hide_block') },
	    _react2.default.createElement(
	      'div',
	      { className: 'loader-mid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-block-loader' },
	        _react2.default.createElement(_loader2.default, null)
	      )
	    )
	  );
	}
	
	exports.default = CardBlockLoaderWrapper;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.loadGis = loadGis;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var gisPromise = null;
	
	function loadGis() {
	    if (window.google && window.google.accounts && window.google.accounts.id) {
	        return Promise.resolve();
	    }
	    if (gisPromise) return gisPromise;
	
	    gisPromise = new Promise(function (resolve, reject) {
	        var s = document.createElement('script');
	        s.src = 'https://accounts.google.com/gsi/client';
	        s.async = true;
	        s.defer = true;
	        s.onload = function () {
	            return resolve();
	        };
	        s.onerror = function (e) {
	            return reject(e);
	        };
	        document.head.appendChild(s);
	    });
	
	    return gisPromise;
	}
	
	var GoogleBtn = function (_Component) {
	    _inherits(GoogleBtn, _Component);
	
	    function GoogleBtn() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, GoogleBtn);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleBtn.__proto__ || Object.getPrototypeOf(GoogleBtn)).call.apply(_ref, [this].concat(args))), _this), _this._unmounted = false, _this.initAndRender = function () {
	            if (!_this.btnRef) return;
	            _this.btnRef.innerHTML = '';
	
	            window.google.accounts.id.initialize({
	                client_id: _App_data2.default.googleAuthClientID,
	                callback: function callback(resp) {
	                    if (resp && resp.credential) {
	                        _this.props.onSuccess && _this.props.onSuccess(resp);
	                    } else {
	                        _this.props.onError && _this.props.onError(resp);
	                    }
	                }
	            });
	
	            window.google.accounts.id.renderButton(_this.btnRef, {
	                theme: 'outline',
	                size: 'large',
	                width: 320
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(GoogleBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            loadGis().then(function () {
	                if (_this2._unmounted) return;
	                _this2.initAndRender();
	            }).catch(function (e) {
	                console.error('GIS load failed', e);
	                _this2.props.onError && _this2.props.onError(e);
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this._unmounted = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement('div', { ref: function ref(el) {
	                    return _this3.btnRef = el;
	                } });
	        }
	    }]);
	
	    return GoogleBtn;
	}(_react.Component);
	
	exports.default = GoogleBtn;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ModelFooter = __webpack_require__(538);
	
	var _ModelFooter2 = _interopRequireDefault(_ModelFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalComponent = function ModalComponent(_ref) {
	  var onModalToggle = _ref.onModalToggle,
	      _ref$isModalOpen = _ref.isModalOpen,
	      isModalOpen = _ref$isModalOpen === undefined ? false : _ref$isModalOpen,
	      modalHeaderText = _ref.modalHeaderText,
	      children = _ref.children,
	      _ref$isFooterOpen = _ref.isFooterOpen,
	      isFooterOpen = _ref$isFooterOpen === undefined ? false : _ref$isFooterOpen,
	      _ref$footerLoader = _ref.footerLoader,
	      footerLoader = _ref$footerLoader === undefined ? false : _ref$footerLoader,
	      _ref$footerLoadingTex = _ref.footerLoadingText,
	      footerLoadingText = _ref$footerLoadingTex === undefined ? '' : _ref$footerLoadingTex,
	      _ref$footerButtonText = _ref.footerButtonText,
	      footerButtonText = _ref$footerButtonText === undefined ? '' : _ref$footerButtonText,
	      _ref$footerButtonCanc = _ref.footerButtonCancelText,
	      footerButtonCancelText = _ref$footerButtonCanc === undefined ? '' : _ref$footerButtonCanc,
	      onSubmitButton = _ref.onSubmitButton;
	
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    { size: 'xs', isOpen: isModalOpen, toggle: onModalToggle, className: 'modal-primary ' },
	    _react2.default.createElement(
	      _reactstrap.ModalHeader,
	      null,
	      modalHeaderText,
	      ' ',
	      _react2.default.createElement(
	        _reactstrap.Button,
	        { className: 'close', color: 'secondary', onClick: onModalToggle },
	        '\xD7'
	      )
	    ),
	    _react2.default.createElement(
	      _reactstrap.ModalBody,
	      null,
	      children
	    ),
	    isFooterOpen && _react2.default.createElement(_ModelFooter2.default, {
	      footerLoader: footerLoader,
	      onModalToggle: onModalToggle,
	      footerLoadingText: footerLoadingText,
	      footerButtonText: footerButtonText,
	      onSubmitButton: onSubmitButton,
	      footerButtonCancelText: footerButtonCancelText
	    })
	  );
	};
	exports.default = ModalComponent;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mobx = __webpack_require__(37);
	var autorun = mobx.autorun;
	
	
	var defaultAvatar = _App_data2.default.frontend_url + '/img/avatars/defaultProfileImage.jpg';
	
	var imagesCache = {};
	
	var UserAvatar = function (_Component) {
	    _inherits(UserAvatar, _Component);
	
	    function UserAvatar(props) {
	        _classCallCheck(this, UserAvatar);
	
	        var _this = _possibleConstructorReturn(this, (UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).call(this, props));
	
	        _this.state = {
	            avatar: defaultAvatar,
	            userName: "AnalystPrep"
	        };
	        return _this;
	    }
	
	    _createClass(UserAvatar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.dispose = autorun(function () {
	                var avatar = _userStore2.default.profileInfo != null && _userStore2.default.profileInfo.imageUrl != null ? _userStore2.default.profileInfo.imageUrl : _this2.state.avatar;
	                var name = _userStore2.default.profileInfo != null && _userStore2.default.profileInfo.username != null ? _userStore2.default.profileInfo.username : _this2.state.userName;
	                var img = new Image();
	                img.src = avatar;
	                img.onload = function () {
	                    imagesCache[avatar] = img;
	                };
	                img.onerror = function (e) {
	                    console.warn('Error loading avatar image: ' + e.target.src);
	                    avatar = defaultAvatar;
	                    _this2.setState({ avatar: avatar });
	                    img.remove();
	                };
	                _this2.setState({
	                    avatar: String(avatar),
	                    userName: name
	                });
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.dispose) this.dispose();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.classNames.join(' ') },
	                _react2.default.createElement('div', { className: 'profile-img', style: { backgroundImage: 'url(' + this.state.avatar + ')' } })
	            );
	        }
	    }]);
	
	    return UserAvatar;
	}(_react.Component);
	
	UserAvatar.defaultProps = {
	    classNames: ['sidebar-profile-circle']
	};
	exports.default = UserAvatar;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewEssayQuestions = function ViewEssayQuestions(props) {
	  var _props$development_ju = props.development_justification,
	      development_justification = _props$development_ju === undefined ? '' : _props$development_ju,
	      setJustification = props.setJustification,
	      question = props.question,
	      is_multiple = props.is_multiple,
	      is_development = props.is_development,
	      _props$justification = props.justification1,
	      justification1 = _props$justification === undefined ? '' : _props$justification,
	      displayError = props.displayError,
	      setUserChoice = props.setUserChoice,
	      selectedIndex = props.selectedIndex,
	      userChoice = props.userChoice,
	      justification = props.justification,
	      disabledTextArea = props.disabledTextArea,
	      selectedCaseQuestionData = props.selectedCaseQuestionData;
	
	  var choices = [];
	  for (var objKey in props) {
	    if (objKey.includes('choice')) if (props[objKey]) choices.push(props[objKey]);
	  }return _react2.default.createElement(
	    _reactstrap.Col,
	    { xs: '12', sm: '12', lg: '12', className: 'pb-2' },
	    (0, _function.renderHTMLContent)(question, "div", "text-justify view_questionhtml margin_bottom_20"),
	    _react2.default.createElement(
	      _reactstrap.Row,
	      null,
	      development_justification.includes('&;') ? _react2.default.createElement(
	        _reactstrap.Col,
	        { className: 'border-gray rounded p-1', md: '12', xs: '12', sm: '12' },
	        _react2.default.createElement(
	          'b',
	          null,
	          development_justification.split('&;')[0].split(':')[0],
	          ' :'
	        ),
	        _react2.default.createElement('input', {
	          type: 'text',
	          className: 'w-50 view_questionhtml',
	          placeholder: 'Please write your answer'
	        })
	      ) : null,
	      choices.length || development_justification.includes('&;') ? _react2.default.createElement(
	        _reactstrap.Col,
	        { xs: '12', md: development_justification.includes('&;') ? '12' : '3' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'flex-column  d-flex border border-gray rounded mb-sm-1 mb-md-0 ' + (development_justification.includes('&;') ? 'justify-content-around' : 'flex-column') + '  d-flex border ' + (is_multiple ? 'border-gray rounded mb-sm-1 mb-md-0 question_sidebar' : '') + ' '
	          },
	          choices.map(function (choice, index) {
	            return _react2.default.createElement(
	              'div',
	              {
	                // className={`${
	                //   userChoice[selectedCaseQuestionData.id] ===
	                //   `choice_${String.fromCharCode(index + 97)}`
	                //     ? `border-yellow`
	                //     : 'border-black'
	                // }`}
	                key: index,
	                className: 'd-flex align-items-center pointer_class sidebar_item ' + (is_multiple ? '' : 'h-100p ') + ' ' + (selectedIndex === index || selectedIndex === -1 && userChoice[selectedCaseQuestionData.id] === 'choice_' + String.fromCharCode(index + 97) ? 'clicked_box_bg_yellow' : ''),
	                name: 'selectedChoice',
	                onClick: function onClick() {
	                  return setUserChoice(choice, index);
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                null,
	                choice
	              )
	            );
	          })
	        )
	      ) : null,
	      _react2.default.createElement(
	        _reactstrap.Col,
	        {
	          xs: '12',
	          md: development_justification.includes('&;') || is_development && !choices.length ? '12' : '9 pl-md-0',
	          className: (development_justification.includes('&;') || is_development && !choices.length ? '' : '') + ' '
	        },
	        is_development ? is_multiple ? _react2.default.createElement('textarea', {
	          className: 'w-100 h-100 view_questionhtml',
	          placeholder: 'Write your justification here',
	          onChange: function onChange(e) {
	            setJustification(e);
	          },
	          disabled: disabledTextArea,
	          value: justification1 || justification[selectedCaseQuestionData.id] && justification[selectedCaseQuestionData.id]['justification1'] || '',
	          name: 'justification1'
	        }) : choices.length ? choices.map(function (choice, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'h-100p' },
	            _react2.default.createElement('textarea', {
	              placeholder: 'Write your justification here',
	              className: 'w-100 h-100 view_questionhtml',
	              onChange: function onChange(e) {
	                setJustification(e);
	              },
	              disabled: disabledTextArea,
	              value: props['justification' + (index + 1)] || justification[selectedCaseQuestionData.id] && justification[selectedCaseQuestionData.id]['justification' + (index + 1)] || '',
	              name: ['justification' + (index + 1)]
	            })
	          );
	        }) : _react2.default.createElement('textarea', {
	          className: 'w-100 h-100 min-height-150 view_questionhtml',
	          placeholder: 'Write your justification here',
	          onChange: function onChange(e) {
	            setJustification(e);
	          },
	          disabled: disabledTextArea,
	          value: justification1 || justification[selectedCaseQuestionData.id] && justification[selectedCaseQuestionData.id]['justification1'] || '',
	          name: 'justification1'
	        }) : null
	      )
	    ),
	    displayError ? _react2.default.createElement(
	      'h6',
	      { className: 'text-danger mt-1 mb-0' },
	      'Please make sure to enter your answer in the answer box before validating.'
	    ) : null
	  );
	};
	
	exports.default = ViewEssayQuestions;

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getTokenData = exports.getTokenData = function getTokenData() {
	  var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	  return {
	    token: storage_session['token'],
	    idname: storage_session['idname']
	  };
	};
	
	// Reference line for 70%
	var referenceLine = exports.referenceLine = {
	  type: 'line',
	  color: '#fff',
	  dataPoints: [{
	    x: -15,
	
	    y: 100
	  }, {
	    x: 20,
	
	    y: 100
	  }, {
	    x: 20,
	
	    y: 100
	  }],
	  markerType: 'none'
	};
	// 20% line
	var twentyPercentLine = exports.twentyPercentLine = {
	  showInLegend: false,
	  name: '20%',
	  type: 'line',
	  lineDashType: 'dash',
	  color: '#39c089',
	  markerType: 'none'
	};
	//80% line
	var eightyPercentLine = exports.eightyPercentLine = {
	  showInLegend: false,
	  name: '80%',
	  type: 'line',
	  lineDashType: 'dot',
	  color: '#1d364b',
	  markerType: 'none'
	};
	
	var getLabelAngleWithFontSize = exports.getLabelAngleWithFontSize = function getLabelAngleWithFontSize(w) {
	  var labelAngle = 0;
	  var labelFontSize = 0;
	  if (w > 1200) {
	    labelAngle = 0;
	    labelFontSize = 15;
	  } else if (w > 991 && w < 1200) {
	    labelAngle = -20;
	    labelFontSize = 12;
	  } else if (w > 767 && w < 991) {
	    labelAngle = 90;
	    labelFontSize = 15;
	  } else {
	    labelAngle = -90;
	    labelFontSize = 12;
	  }
	  return {
	    labelAngle: labelAngle,
	    labelFontSize: labelFontSize
	  };
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusChangeModel = function StatusChangeModel(_ref) {
	  var change_status = _ref.change_status,
	      className = _ref.className,
	      changeModelStatus = _ref.changeModelStatus,
	      changeStatusTitle = _ref.changeStatusTitle,
	      markAsCompleted = _ref.markAsCompleted,
	      markNotCompleted = _ref.markNotCompleted,
	      markAsNotCompleted = _ref.markAsNotCompleted,
	      markCompleted = _ref.markCompleted,
	      markCompletedFun = _ref.markCompletedFun,
	      changeCompletionStatus = _ref.changeCompletionStatus,
	      summaryDetails = _ref.summaryDetails,
	      showComponent = _ref.showComponent,
	      showLoaderOnModel = _ref.showLoaderOnModel;
	
	  var attemptedMarks = 0;
	  var totalMarks = 0;
	  return _react2.default.createElement(
	    _reactstrap.Modal,
	    {
	      isOpen: change_status,
	      toggle: function toggle() {
	        return changeModelStatus();
	      },
	      className: 'modal-primary complete-or-not-model ' + className
	    },
	    _react2.default.createElement(
	      _reactstrap.ModalHeader,
	      { toggle: function toggle() {
	          return changeModelStatus();
	        } },
	      changeStatusTitle
	    ),
	    _react2.default.createElement(
	      _reactstrap.ModalBody,
	      { className: showLoaderOnModel ? 'min-height-150' : '' },
	      showLoaderOnModel ? _react2.default.createElement(
	        'div',
	        { className: 'main_loader show_block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'loader-mid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block-loader' },
	            _react2.default.createElement(_loader2.default, null)
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'card-block card-padding' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 text-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              showComponent.includes(2) ? _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'quation-img' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                    className: 'margin_bottom_10',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    contentEditable: 'false',
	                    suppressContentEditableWarning: true,
	                    className: 'margin_bottom_10 view_questionhtml bg_blue_status'
	                  },
	                  ' ',
	                  _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'complete-or-not-wrap mx-2 ' + (showLoaderOnModel ? 'min-height-150' : '')
	                },
	                showComponent.includes(2) ? _react2.default.createElement(
	                  'div',
	                  { className: 'check-button-wrap mb-2' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions float-right' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().COMPLETED,
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'mark_completed',
	                        name: 'mark_completed',
	                        value: 'select',
	                        onClick: function onClick() {
	                          return markCompletedFun();
	                        },
	                        checked: markAsCompleted
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions float-right' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container margin_bottom_0' },
	                      _language2.default.LC().NOT_COMPLETED,
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'mark_not_completed',
	                        name: 'mark_not_completed',
	                        value: 'select',
	                        onClick: function onClick() {
	                          return markNotCompleted();
	                        },
	                        checked: markAsNotCompleted
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' })
	                    )
	                  )
	                ) : null,
	                showComponent.includes(1) ? _react2.default.createElement(
	                  'div',
	                  null,
	                  summaryDetails.length ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Row,
	                      { className: 'tbl_row tbl_head' },
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        '#'
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: '8', sm: '8' },
	                        'Question'
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        null,
	                        'Grading'
	                      )
	                    ),
	                    summaryDetails.length && summaryDetails.map(function (element, index) {
	                      return _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'tbl_row', key: element.id },
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          null,
	                          element.id
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { md: '8', sm: '8', className: 'text-left' },
	                          (0, _function.renderHTMLContent)(element.question && element.question.substring(0, 70).includes('$$') ? element.question : element.question.substring(0, 70) + ' ...', "span", "summary-text-wrapper"),
	                          ' '
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'd-none' },
	                          attemptedMarks += element.cfa3_essay_case_questions_user_stat.user_grading_details,
	                          totalMarks += element.max_grading
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          null,
	                          element.cfa3_essay_case_questions_user_stat.user_grading_details,
	                          '/',
	                          element.max_grading
	                        )
	                      );
	                    }),
	                    _react2.default.createElement(
	                      _reactstrap.Row,
	                      { className: 'tbl_row tbl_footer' },
	                      _react2.default.createElement(_reactstrap.Col, null),
	                      _react2.default.createElement(_reactstrap.Col, { md: '8' }),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { className: 'pl-3' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Total : '
	                        ),
	                        attemptedMarks,
	                        '/',
	                        totalMarks
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h5',
	                      { className: 'mb-1' },
	                      'You haven\'t recorded any marks for this yet.',
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Please try answering the questions by clicking on the green icon and grading yourself.'
	                    )
	                  )
	                ) : null,
	                showComponent.includes(2) ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-block text-center complete-quation-submit' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      disabled: markCompleted,
	                      onClick: function onClick() {
	                        return changeCompletionStatus();
	                      },
	                      className: 'btn btn-primary pointer_class'
	                    },
	                    ' ',
	                    _language2.default.LC().SUBMIT,
	                    ' '
	                  )
	                ) : null
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = StatusChangeModel;

/***/ },
/* 268 */
266,
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chapter = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ChapterCard = __webpack_require__(728);
	
	var _ChapterCard2 = _interopRequireDefault(_ChapterCard);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chapter = exports.Chapter = function (_Component) {
	  _inherits(Chapter, _Component);
	
	  function Chapter(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Chapter);
	
	    var _this = _possibleConstructorReturn(this, (Chapter.__proto__ || Object.getPrototypeOf(Chapter)).call(this, props));
	
	    _this.fetchChapters = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var apiEndpoint;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                apiEndpoint = _this.props.apiEndpoint;
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + apiEndpoint, data);
	
	              case 3:
	                return _context.abrupt('return', _context.sent);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onClickFunc = function (item, redirectRoute) {
	      var userSubscriptionDetails = _this.state.userSubscriptionDetails;
	      var callingComponent = _this.props.callingComponent;
	
	      if ((Object.keys(userSubscriptionDetails).length || redirectRoute) && callingComponent !== 'notes') {
	        return _this.redirectToContent(item, redirectRoute);
	      }
	      if (Object.keys(userSubscriptionDetails).length || item.isFree === true && callingComponent === 'notes') {
	        _this.props.fetchNotesPDFById(item);
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this.redirectToContent = function (item, redirectRoute) {
	      return _this.context.router.push({
	        pathname: redirectRoute.replace(':index', 0).replace(':chapterId', item.id).replace(':listId', item.id)
	      });
	    };
	
	    _this.state = {
	      chapters: [],
	      idname: '',
	      token: '',
	      isLoading: true,
	      userSubscriptionDetails: {},
	      openPremiumPopup: false
	    };
	    return _this;
	  }
	
	  _createClass(Chapter, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                this.fetchChapters(data).then(function (resp) {
	                  _this3.setState({
	                    chapters: resp.chapters || resp.data,
	                    userSubscriptionDetails: resp.userSubscriptionDetails,
	                    isLoading: false
	                  });
	                }).catch(function (error) {
	                  // eslint-disable-next-line no-console
	                  console.error(error);
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          chapters = _state.chapters,
	          showFreePremiumTag = _state.showFreePremiumTag,
	          isLoading = _state.isLoading,
	          userSubscriptionDetails = _state.userSubscriptionDetails,
	          openPremiumPopup = _state.openPremiumPopup,
	          _props = this.props,
	          headerImage = _props.headerImage,
	          imageWidth = _props.imageWidth,
	          _props$redirectRoute = _props.redirectRoute,
	          redirectRoute = _props$redirectRoute === undefined ? '' : _props$redirectRoute,
	          _props$callingCompone = _props.callingComponent,
	          callingComponent = _props$callingCompone === undefined ? '' : _props$callingCompone,
	          _props$replacementFie = _props.replacementFields,
	          replacementFields = _props$replacementFie === undefined ? {} : _props$replacementFie;
	
	      return _react2.default.createElement(
	        _LoaderWrapper2.default,
	        { isLoading: isLoading },
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  chapters.map(function (item) {
	                    var premiumQuestionsCount = item['esg_questions.premiumQuestionsCount'],
	                        freeQuestionsCount = item['esg_questions.freeQuestionsCount'];
	
	                    return _react2.default.createElement(_ChapterCard2.default, Object.assign({
	                      onClick: function onClick() {
	                        return _this4.onClickFunc(item, redirectRoute);
	                      },
	                      key: item.id,
	                      callingComponent: callingComponent,
	                      headerImage: headerImage,
	                      headerImageWidth: imageWidth,
	                      chapterNumber: item.id,
	                      chapterName: item.name || item[replacementFields.name],
	                      totalReadings: item.totalReadings,
	                      totalNotes: item.totalNotes,
	                      freeQuestionsCount: freeQuestionsCount,
	                      premiumQuestionsCount: premiumQuestionsCount,
	                      showFreePremiumTag: showFreePremiumTag,
	                      userSubscriptionDetails: userSubscriptionDetails,
	                      free: item.isFree
	                    }, _this4.props));
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(_Modal2.default, {
	              goPremium: this.goPremium.bind(this),
	              toggleAlert: this.toggleAlert.bind(this),
	              alert_status: openPremiumPopup,
	              MessageContent: _alertMessage2.default.messageContent_ESG,
	              exam: _constant.examNameAccordingToDB.ESG
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Chapter;
	}(_react.Component);
	
	Chapter.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = Chapter;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _HighlightText = __webpack_require__(741);
	
	var _HighlightText2 = _interopRequireDefault(_HighlightText);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Question(props) {
	  var question = props.question,
	      id = props.id,
	      children = props.children,
	      correctChoice = props.correctChoice,
	      showAnswer = props.showAnswer,
	      selectedChoice = props.selectedChoice,
	      setAnswer = props.setAnswer,
	      _props$selectedChoice = props.selectedChoiceClassName,
	      selectedChoiceClassName = _props$selectedChoice === undefined ? 'clicked_box' : _props$selectedChoice,
	      _props$correctChoiceC = props.correctChoiceClassName,
	      correctChoiceClassName = _props$correctChoiceC === undefined ? 'success' : _props$correctChoiceC,
	      _props$incorrectChoic = props.incorrectChoiceClassName,
	      incorrectChoiceClassName = _props$incorrectChoic === undefined ? 'failure' : _props$incorrectChoic,
	      strikeText = props.strikeText,
	      _props$strikeThroughA = props.strikeThroughArr,
	      strikeThroughArr = _props$strikeThroughA === undefined ? [] : _props$strikeThroughA,
	      _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params,
	      _props$shouldHighLigh = props.shouldHighLight,
	      shouldHighLight = _props$shouldHighLigh === undefined ? false : _props$shouldHighLigh;
	
	  var choices = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _ref = _step.value;
	
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var key = _ref2[0];
	      var value = _ref2[1];
	
	      if (key.startsWith('choice')) {
	        choices.push(_defineProperty({}, key, value));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      null,
	      shouldHighLight ? _react2.default.createElement(_HighlightText2.default, { params: params, content: question }) : (0, _function.renderHTMLContent)(question, 'div', 'margin_bottom_40 view_questionhtml bg_blue', { contentEditable: false })
	    ),
	    choices.map(function (element, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'col-sm-12',
	          id: Object.keys(element),
	          key: Object.keys(element) + '/' + id,
	          onClick: function onClick() {
	            return !showAnswer && setAnswer(Object.keys(element));
	          },
	          onContextMenu: function onContextMenu(event) {
	            return strikeText(event, Object.keys(element));
	          },
	          disabled: showAnswer
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'answer_box ' + (strikeThroughArr.includes(Object.keys(element)[0]) ? 'strikethrough' : '') + ' ' + (!showAnswer && selectedChoice === Object.keys(element)[0] ? selectedChoiceClassName : '') + ' ' + (showAnswer && Object.keys(element)[0] === correctChoice ? correctChoiceClassName : '') + '\n                ' + (showAnswer && selectedChoice === Object.keys(element)[0] && selectedChoice !== correctChoice ? incorrectChoiceClassName : '') + '\n                '
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'answer_count' },
	            String.fromCharCode(index + 65)
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ans_box_text' },
	            ' ',
	            (0, _function.renderHTMLContent)(element[Object.keys(element)[0]], 'span', '', { contentEditable: false })
	          )
	        )
	      );
	    }),
	    children
	  );
	}
	
	exports.default = Question;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReportQuestion(_ref) {
	  var onClick = _ref.onClick,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'span',
	    { className: (className || '') + ' up tooltip-hover-questions' },
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      ' ',
	      _language2.default.LC().REPORT_THIS_QUESTION,
	      ' '
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'report-icon-wrapper', onClick: onClick },
	      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/report4.png', alt: 'report' })
	    )
	  );
	}
	
	exports.default = ReportQuestion;

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Key Represent Uniquely identify field
	 * label are Header of table
	 * referencedField is backend response key by which value will be show to it.
	 * representation means what will be show in table UI
	 *
	 */
	
	var testListColumns = [{ key: 'id', label: '#', width: '9%' }, {
	  key: 'totalScore',
	  label: 'Total Score',
	  referredField: 'score',
	  representation: function representation(value) {
	    return value + '%';
	  },
	  className: 'score-qnt'
	}, {
	  key: 'date',
	  label: 'Test Attempted Date',
	  referredField: 'createdAt',
	  representation: function representation(value, additionalParameterForOperation) {
	    return additionalParameterForOperation.moment(value).format('lll');
	  }
	}, {
	  key: 'time',
	  label: 'Test Completed In',
	  referredField: 'user_time_value',
	  operation: {
	    field: 'isNegative',
	    true: function _true(item, additionalParameterForOperation) {
	      return additionalParameterForOperation.timer - item.user_time_value;
	    },
	    false: function _false(item, additionalParameterForOperation) {
	      return parseInt(additionalParameterForOperation.timer) + item.user_time_value;
	    }
	  },
	  representation: function representation(value, additionalParameterForOperation) {
	    return additionalParameterForOperation.SecondsToHHMMSS(value);
	  }
	}, {
	  key: 'status',
	  label: 'Status',
	  condition: {
	    pending: {
	      label: 'Incomplete',
	      className: 'mock-status not-attempted'
	    },
	    completed: {
	      label: 'Completed',
	      className: 'mock-status'
	    }
	  }
	}];
	var cbtColor = {
	  attempted: {
	    color: '#d0d03d',
	    className: 'border-yellow'
	  },
	  notAttempted: {
	    color: '#444d58',
	    className: 'not-ans'
	  },
	  incorrect: {
	    color: '#db4040',
	    className: 'border-red'
	  },
	  correct: {
	    color: '#39c089',
	    className: 'border-green'
	  }
	};
	// const cbtTestPageSliderColor = {
	//   attemptedQuestion,
	//   notAttemptedQuestion,
	// };
	
	// const cbtFinishPageSliderColor = {
	//   attemptedQuestion,
	//   notAttemptedQuestion,
	//   wrongAnswerQuestion,
	//   rightAnswerQuestion,
	// };
	
	module.exports = {
	  testListColumns: testListColumns,
	  cbtColor: cbtColor
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	__webpack_require__(149);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotModal = function (_Component) {
	  _inherits(ForgotModal, _Component);
	
	  function ForgotModal(props) {
	    _classCallCheck(this, ForgotModal);
	
	    var _this = _possibleConstructorReturn(this, (ForgotModal.__proto__ || Object.getPrototypeOf(ForgotModal)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.props.onToggle(_this.props.forgotOpen);
	    };
	
	    _this.state = {
	      email: '',
	      message: '',
	      message_background: 'bg-danger',
	      displaytext: 'hide_block',
	      status: ''
	    };
	    _this.updateEmail = _this.updateEmail.bind(_this);
	    _this.forgetPassword = _this.forgetPassword.bind(_this);
	    _this.handleResend = _this.handleResend.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForgotModal, [{
	    key: 'updateEmail',
	    value: function updateEmail(e) {
	      this.setState({
	        email: e.target.value,
	        message: ''
	      });
	    }
	  }, {
	    key: 'forgetPassword',
	    value: function forgetPassword(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      if (this.state.email === '') {
	        this.setState({
	          message: '' + _language2.default.LC().Email_is_Required,
	          displaytext: 'show_block'
	        });
	        return;
	      }
	
	      var emailValid = this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	      if (emailValid) {
	        // alert(this.state.email);
	        var data = { idname: this.state.email };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/forgetPassword', data).then(function (resp) {
	          if (resp.success) {
	            _this2.setState({ status: 'success', message: '', email: '' });
	          } else {
	            _this2.setState({ displaytext: 'show_block' });
	            _this2.setState({ message: '' + _language2.default.LC().Email_Id_Not_Exist });
	            _this2.setState({ message_background: 'bg-danger' });
	          }
	        });
	      } else {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ message: '' + _language2.default.LC().Email_Id_Invalid });
	        this.setState({ message_background: 'bg-danger' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({
	        message: ''
	      });
	    }
	  }, {
	    key: 'handleResend',
	    value: function handleResend() {
	      this.setState({ status: '' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: this.props.forgotOpen,
	          toggle: this.toggleAlert,
	          className: 'forgot-modal'
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          null,
	          this.state.status !== 'success' ? _react2.default.createElement(
	            'div',
	            { className: 'forgot-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center foget-password-img' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/forget-password.png',
	                alt: ''
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center heading foget-password-heading' },
	              _language2.default.LC().FORGOT_PASSWORD
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'forgot-text foget-password-text' },
	              _language2.default.LC().ENTER_YOUR_EMAIL_ADDRESS
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.forgetPassword },
	              _react2.default.createElement(
	                'p',
	                { className: this.state.displaytext + ' text-danger' },
	                this.state.message
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group forget-password-value' },
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  className: 'form-control ',
	                  placeholder: 'Email',
	                  value: this.state.email,
	                  onChange: this.updateEmail
	                }),
	                _react2.default.createElement(
	                  'p',
	                  { className: this.state.displaytext + ' text-danger' },
	                  this.state.emailErrorMessage
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn forgot-button btn-block pointer_class' },
	                _language2.default.LC().SUBMIT
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'success-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center foget-password-img' },
	              _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/check.png', alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center heading foget-password-heading' },
	              _language2.default.LC().CHECK_YOUR_EMAIL
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'success-text foget-password-text forget-password-value' },
	              _language2.default.LC().RESTE_PASSWORD_LINK,
	              ' '
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn resend-button btn-block pointer_class',
	                onClick: this.handleResend
	              },
	              _language2.default.LC().RESEND_EMAIL,
	              ' '
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ForgotModal;
	}(_react.Component);
	
	exports.default = ForgotModal;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LEFT_PAGE = "LEFT";
	var RIGHT_PAGE = "RIGHT";
	var FIRST_PAGE = "FIRST_PAGE";
	var LAST_PAGE = "LAST_PAGE";
	
	// HELPER TO CREATE PAGE RANGE
	var range = function range(from, to) {
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var i = from;
	  var range = [];
	  while (i <= to) {
	    range.push(i);
	    i += step;
	  }
	  return range;
	};
	/* eslint-disable*/
	
	var PaginationHelper = function (_Component) {
	  _inherits(PaginationHelper, _Component);
	
	  function PaginationHelper(props) {
	    _classCallCheck(this, PaginationHelper);
	
	    var _this = _possibleConstructorReturn(this, (PaginationHelper.__proto__ || Object.getPrototypeOf(PaginationHelper)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _props$totalRecords = props.totalRecords,
	        totalRecords = _props$totalRecords === undefined ? null : _props$totalRecords,
	        _props$currentPage = props.currentPage,
	        currentPage = _props$currentPage === undefined ? null : _props$currentPage,
	        pageLimit = props.pageLimit,
	        _props$pageNeighbours = props.pageNeighbours,
	        pageNeighbours = _props$pageNeighbours === undefined ? 1 : _props$pageNeighbours;
	    // PAGE LIMIT AND RECORDS
	
	    _this.pageLimit = typeof pageLimit === "number" ? pageLimit : 5;
	    _this.totalRecords = typeof totalRecords === "number" ? totalRecords : 0;
	
	    // PAGE NEIGHBOURS CAN BE 0, 1 OR 2
	    _this.pageNeighbours = typeof pageNeighbours === "number" ? Math.max(0, Math.min(parseInt(pageNeighbours), 2)) : 0;
	    _this.totalPages = Math.ceil(parseInt(_this.totalRecords) / parseInt(_this.pageLimit));
	
	    // STATE
	    _this.state = { currentPage: parseInt(currentPage) ? currentPage : 1 };
	    return _this;
	  }
	
	  _createClass(PaginationHelper, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.gotoPage(this.state.currentPage);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // console.log("prevProps", prevProps.totalRecords);
	      // console.log("bfrf", this.props.totalRecords);
	
	      if (prevProps.totalRecords !== this.props.totalRecords) {
	        var pageLimit = this.props.pageLimit;
	
	        // console.log("type pageLimit",typeof pageLimit );
	        // console.log("type totalRecords",typeof totalRecords );
	
	        var totalRecords = this.props.totalRecords;
	
	        // console.log("type pageLimit", typeof pageLimit);
	        var totalPages = Math.ceil(this.props.totalRecords / pageLimit);
	        this.setState({
	          totalRecords: totalRecords,
	          totalPages: totalPages
	        });
	      } else if (prevProps.currentPage !== this.props.currentPage) {
	        var _props = this.props,
	            _totalRecords = _props.totalRecords,
	            _pageLimit = _props.pageLimit;
	
	        // console.log("type pageLimit", typeof pageLimit);
	        // console.log("type totalRecords", typeof totalRecords);
	
	        var currentPage = this.props.currentPage;
	        // console.log("type pageLimit", typeof pageLimit);
	        var totPages = Math.ceil(_totalRecords / _pageLimit);
	        this.setState({
	          currentPage: currentPage,
	          totalRecords: _totalRecords,
	          totalPages: totPages
	        });
	      }
	    }
	
	    /**
	     * Let's say we have 10 pages and we set pageNeighbours to 2
	     * Given that the current page is 6
	     * The pagination control will look like the following:
	     *
	     * (1) < {4 5} [6] {7 8} > (10)
	     *
	     * (x) => terminal pages: first and last page(always visible)
	     * [x] => represents current page
	     * {...x} => represents page neighbours
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var currentPage = this.state.currentPage;
	      // console.log(currentPage);
	
	      var pages = this.fetchPageNumbers();
	
	      return _react2.default.createElement(
	        "div",
	        { className: "d-flex justify-content-start align-items-end w-100 pagination_list" },
	        _react2.default.createElement(
	          _reactstrap.Pagination,
	          null,
	          pages.map(function (page, index) {
	            return page === LEFT_PAGE ? _react2.default.createElement(
	              _reactstrap.PaginationItem,
	              { key: index, onClick: _this2.handleMoveLeft },
	              _react2.default.createElement(
	                _reactstrap.PaginationLink,
	                { previous: true, tag: "button" },
	                _react2.default.createElement(
	                  "span",
	                  { "aria-hidden": "true" },
	                  "\xAB"
	                ),
	                " Prev"
	              )
	            ) : page === RIGHT_PAGE ? _react2.default.createElement(
	              _reactstrap.PaginationItem,
	              { key: index, onClick: _this2.handleMoveRight },
	              _react2.default.createElement(
	                _reactstrap.PaginationLink,
	                { next: true, tag: "button" },
	                "Next ",
	                _react2.default.createElement(
	                  "span",
	                  { "aria-hidden": "true" },
	                  "\xBB"
	                )
	              )
	            ) : page === FIRST_PAGE ? _react2.default.createElement(
	              _reactstrap.PaginationItem,
	              { key: index, onClick: _this2.handleClick(1) },
	              _react2.default.createElement(
	                _reactstrap.PaginationLink,
	                { next: true, tag: "button" },
	                "First ",
	                _react2.default.createElement(
	                  "span",
	                  { "aria-hidden": "true" },
	                  "\xAB"
	                )
	              )
	            ) : page === LAST_PAGE ? _react2.default.createElement(
	              _reactstrap.PaginationItem,
	              {
	                key: index,
	                onClick: _this2.handleClick(_this2.totalPages)
	              },
	              _react2.default.createElement(
	                _reactstrap.PaginationLink,
	                { next: true, tag: "button" },
	                "Last ",
	                _react2.default.createElement(
	                  "span",
	                  { "aria-hidden": "true" },
	                  "\xBB"
	                )
	              )
	            ) : _react2.default.createElement(
	              _reactstrap.PaginationItem,
	              {
	                key: index,
	                onClick: _this2.handleClick(page),
	                active: currentPage === page
	              },
	              _react2.default.createElement(
	                _reactstrap.PaginationLink,
	                { tag: "button" },
	                page
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return PaginationHelper;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.gotoPage = function (page) {
	    // console.log("WORKING");
	    var _props$onPageChanged = _this3.props.onPageChanged,
	        onPageChanged = _props$onPageChanged === undefined ? function (f) {
	      return f;
	    } : _props$onPageChanged;
	    // console.log("props", this.props);
	
	    var currentPage = Math.max(0, Math.min(parseInt(page), parseInt(_this3.totalPages)));
	    // console.log("type currentPage", typeof currentPage);
	    // console.log("value currentPage", currentPage);
	    // console.log("type totalPages", typeof this.state.totalPages);
	    // console.log("value totalPages", this.state.totalPages);
	    // console.log("type pageLimit", typeof this.pageLimit);
	    // console.log("value pageLimit", this.pageLimit);
	    // console.log("type totalRecords", typeof this.state.totalRecords);
	    // console.log("value totalRecords", this.state.totalRecords);
	
	    var paginationData = {
	      currentPage: currentPage,
	      totalPages: _this3.totalPages,
	      pageLimit: parseInt(_this3.pageLimit),
	      totalRecords: _this3.totalRecords
	    };
	    // console.log("pagination data", paginationData);
	
	    _this3.setState({ currentPage: currentPage }, function () {
	      return onPageChanged(paginationData);
	    });
	  };
	
	  this.handleClick = function (page) {
	    return function (evt) {
	      evt.preventDefault();
	      if (_this3.state.currentPage !== page) {
	        _this3.gotoPage(page);
	      }
	    };
	  };
	
	  this.handleMoveLeft = function (evt) {
	    evt.preventDefault();
	    _this3.gotoPage(_this3.state.currentPage - _this3.pageNeighbours);
	  };
	
	  this.handleMoveRight = function (evt) {
	    evt.preventDefault();
	    _this3.gotoPage(_this3.state.currentPage + _this3.pageNeighbours);
	  };
	
	  this.fetchPageNumbers = function () {
	    var totalPages = _this3.totalPages;
	    var currentPage = _this3.state.currentPage;
	    var pageNeighbours = _this3.pageNeighbours;
	
	    /**
	     * totalNumbers: the total page numbers to show on the control
	     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
	     */
	    var totalNumbers = _this3.pageNeighbours * 2 + 3;
	    var totalBlocks = totalNumbers + 2;
	
	    if (totalPages > totalBlocks) {
	      var startPage = Math.max(2, currentPage - pageNeighbours);
	      var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
	
	      var pages = range(startPage, endPage);
	
	      /**
	       * hasLeftSpill: has hidden pages to the left
	       * hasRightSpill: has hidden pages to the right
	       * spillOffset: number of hidden pages either to the left or to the right
	       */
	      var hasLeftSpill = startPage > 2;
	      var hasRightSpill = totalPages - endPage > 1;
	      var spillOffset = totalNumbers - (pages.length + 1);
	
	      switch (true) {
	        // handle: (1) < {5 6} [7] {8 9} (10)
	        case hasLeftSpill && !hasRightSpill:
	          {
	            var extraPages = range(startPage - spillOffset, startPage - 1);
	            pages = [FIRST_PAGE, LEFT_PAGE].concat(_toConsumableArray(extraPages), _toConsumableArray(pages), [totalPages]);
	            break;
	          }
	
	        // handle: (1) {2 3} [4] {5 6} > (10)
	        case !hasLeftSpill && hasRightSpill:
	          {
	            var _extraPages = range(endPage + 1, endPage + spillOffset);
	            pages = [1].concat(_toConsumableArray(pages), _toConsumableArray(_extraPages), [RIGHT_PAGE, LAST_PAGE]);
	            break;
	          }
	
	        // handle: (1) < {4 5} [6] {7 8} > (10)
	        case hasLeftSpill && hasRightSpill:
	        default:
	          {
	            pages = [FIRST_PAGE, LEFT_PAGE].concat(_toConsumableArray(pages), [RIGHT_PAGE, LAST_PAGE]);
	            break;
	          }
	      }
	      return pages;
	    }
	    return range(1, totalPages);
	  };
	};
	
	exports.default = PaginationHelper;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(145);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(145);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(145);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 279 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(145);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(190);
	var Transform = __webpack_require__(191);
	var inherits = __webpack_require__(47);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 282 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 283 */
/***/ function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ },
/* 284 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var emptyObject = __webpack_require__(150);
	var _invariant = __webpack_require__(20);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1223)
	
	var md5 = toConstructor(__webpack_require__(965))
	var rmd160 = toConstructor(__webpack_require__(1219))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 287 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(121);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(289);
	var ElementPrototype = __webpack_require__(975);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 289 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(980),
		__webpack_require__(981),
		__webpack_require__(978),
		__webpack_require__(979),
		__webpack_require__(977),
		__webpack_require__(976)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(195);
	var XHR = __webpack_require__(985);
	var JSONP = __webpack_require__(984);
	var websocket = __webpack_require__(986);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(194);
	var parseqs = __webpack_require__(152);
	var parser = __webpack_require__(107);
	var inherit = __webpack_require__(146);
	var yeast = __webpack_require__(498);
	var debug = __webpack_require__(147)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(195);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ },
/* 293 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(1050);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ },
/* 295 */
79,
/* 296 */
79,
/* 297 */
79,
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(57);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 299 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notes_icon1.dfffb449.svg";

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon2.06fa3dfd.svg";

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/question_icon-blu.eb3b144b.svg";

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */
	
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(1043);
	
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' ||
	                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof File === 'function' ||
	                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Supports Buffer, ArrayBuffer, Blob and File.
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary (obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  if (isArray(obj)) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      if (hasBinary(obj[i])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
	    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
	    (withNativeBlob && obj instanceof Blob) ||
	    (withNativeFile && obj instanceof File)
	  ) {
	    return true;
	  }
	
	  // see: https://github.com/Automattic/has-binary/pull/4
	  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
	    return hasBinary(obj.toJSON(), true);
	  }
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(306);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(47)(Parser, __webpack_require__(148).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(294);
	var entityMap = __webpack_require__(200);
	var legacyMap = __webpack_require__(309);
	var xmlMap = __webpack_require__(201);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(305);
	var WritableStream = __webpack_require__(1259).Writable;
	var StringDecoder = __webpack_require__(1245).StringDecoder;
	var Buffer = __webpack_require__(33).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(47)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ },
/* 308 */
/***/ function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 309 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    uri.pathNames = pathNames(uri, uri['path']);
	    uri.queryKey = queryKey(uri, uri['query']);
	
	    return uri;
	};
	
	function pathNames(obj, path) {
	    var regx = /\/{2,9}/g,
	        names = path.replace(regx, "/").split("/");
	
	    if (path.substr(0, 1) == '/' || path.length === 0) {
	        names.splice(0, 1);
	    }
	    if (path.substr(path.length - 1, 1) == '/') {
	        names.splice(names.length - 1, 1);
	    }
	
	    return names;
	}
	
	function queryKey(uri, query) {
	    var data = {};
	
	    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
	        if ($1) {
	            data[$1] = $2;
	        }
	    });
	
	    return data;
	}


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1065);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 439 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 441 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(99);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(60);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1135);
	var warning = __webpack_require__(27);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 444 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var LinkedValueUtils = __webpack_require__(208);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactUpdates = __webpack_require__(70);
	
	var warning = __webpack_require__(27);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 446 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 447 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1095);
	
	var containsNode = __webpack_require__(1017);
	var focusNode = __webpack_require__(299);
	var getActiveElement = __webpack_require__(300);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var DOMLazyTree = __webpack_require__(109);
	var DOMProperty = __webpack_require__(110);
	var React = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactCurrentOwner = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactDOMContainerInfo = __webpack_require__(1089);
	var ReactDOMFeatureFlags = __webpack_require__(1091);
	var ReactFeatureFlags = __webpack_require__(447);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(60);
	var ReactMarkupChecksum = __webpack_require__(1105);
	var ReactReconciler = __webpack_require__(111);
	var ReactUpdateQueue = __webpack_require__(211);
	var ReactUpdates = __webpack_require__(70);
	
	var emptyObject = __webpack_require__(150);
	var instantiateReactComponent = __webpack_require__(458);
	var invariant = __webpack_require__(20);
	var setInnerHTML = __webpack_require__(158);
	var shouldUpdateReactComponent = __webpack_require__(217);
	var warning = __webpack_require__(27);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var React = __webpack_require__(115);
	
	var invariant = __webpack_require__(20);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 454 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(451);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(42);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var ReactCompositeComponent = __webpack_require__(1086);
	var ReactEmptyComponent = __webpack_require__(446);
	var ReactHostComponent = __webpack_require__(448);
	
	var getNextDebugID = __webpack_require__(1214);
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 459 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var escapeTextContentForBrowser = __webpack_require__(157);
	var setInnerHTML = __webpack_require__(158);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(82);
	var REACT_ELEMENT_TYPE = __webpack_require__(1101);
	
	var getIteratorFn = __webpack_require__(1132);
	var invariant = __webpack_require__(20);
	var KeyEscapeUtils = __webpack_require__(207);
	var warning = __webpack_require__(27);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.GoogleLogin=t(require("react")):e.GoogleLogin=t(e.react)}(this,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=n(2),a=n.n(s),c=n(3),u=(n.n(c),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),l=function(e){function t(e){o(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.signIn=n.signIn.bind(n),n.state={disabled:!0},n}return i(t,e),u(t,[{key:"componentDidMount",value:function(){var e=this,t=this.props,n=t.clientId,o=t.cookiePolicy,r=t.loginHint,i=t.hostedDomain,s=t.autoLoad,a=t.isSignedIn,c=t.fetchBasicProfile,u=t.redirectUri,l=t.discoveryDocs,f=t.onFailure,p=t.uxMode,d=t.scope;!function(e,t,n,o){var r=e.getElementsByTagName(t)[0],i=r,s=r;s=e.createElement(t),s.id="google-login",s.src="//apis.google.com/js/client:platform.js",i.parentNode.insertBefore(s,i),s.onload=o}(document,"script",0,function(){var t={client_id:n,cookie_policy:o,login_hint:r,hosted_domain:i,fetch_basic_profile:c,discoveryDocs:l,ux_mode:p,redirect_uri:u,scope:d};window.gapi.load("auth2",function(){e.setState({disabled:!1}),window.gapi.auth2.getAuthInstance()||window.gapi.auth2.init(t).then(function(t){a&&t.isSignedIn.get()&&e._handleSigninSuccess(t.currentUser.get())},function(e){return f(e)}),s&&e.signIn()})})}},{key:"signIn",value:function(e){var t=this;if(e&&e.preventDefault(),!this.state.disabled){var n=window.gapi.auth2.getAuthInstance(),o=this.props,r=o.onSuccess,i=o.onRequest,s=o.onFailure,a=o.prompt,c=o.responseType,u={prompt:a};i(),"code"===c?n.grantOfflineAccess(u).then(function(e){return r(e)},function(e){return s(e)}):n.signIn(u).then(function(e){return t._handleSigninSuccess(e)},function(e){return s(e)})}}},{key:"_handleSigninSuccess",value:function(e){var t=e.getBasicProfile(),n=e.getAuthResponse();e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},this.props.onSuccess(e)}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.type,o=e.style,r=e.className,i=e.disabledStyle,s=e.buttonText,c=e.children,u=this.state.disabled||this.props.disabled,l={display:"inline-block",background:"#d14836",color:"#fff",width:190,paddingTop:10,paddingBottom:10,borderRadius:2,border:"1px solid transparent",fontSize:16,fontWeight:"bold",fontFamily:"Roboto"},f=function(){return o||(r&&!o?{}:l)}(),p=function(){return u?Object.assign({},f,i):f}();return a.a.createElement(t,{onClick:this.signIn,style:p,type:n,disabled:u,className:r},c||s)}}]),t}(s.Component);l.defaultProps={type:"button",tag:"button",buttonText:"Login with Google",scope:"profile email",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},onRequest:function(){}},t.default=l},function(t,n){t.exports=e},function(e,t,n){"function"==typeof Symbol&&Symbol.iterator,e.exports=n(4)()},function(e,t,n){"use strict";var o=n(5),r=n(6),i=n(7);e.exports=function(){function e(e,t,n,o,s,a){a!==i&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=o,n.PropTypes=n,n}},function(e,t,n){"use strict";function o(e){return function(){return e}}var r=function(){};r.thatReturns=o,r.thatReturnsFalse=o(!1),r.thatReturnsTrue=o(!0),r.thatReturnsNull=o(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function o(e,t,n,o,i,s,a,c){if(r(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,o,i,s,a,c],f=0;u=new Error(t.replace(/%s/g,function(){return l[f++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var r=function(e){};e.exports=o},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}])});

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(1150);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(1152);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(1153);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ },
/* 465 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(222);
	
	var _ContextUtils = __webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 467 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(90);
	
	var _PatternUtils = __webpack_require__(112);
	
	var _InternalPropTypes = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(476);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(475);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1180);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(473);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(113);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1167);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1164);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1171);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1168);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1173);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(476);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(475);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(227);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1181);
	
	var _runTransitionHook = __webpack_require__(227);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(114);
	
	var _PathUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(501);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1198);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IdealBankElement = exports.IbanElement = exports.PaymentRequestButtonElement = exports.CardCVCElement = exports.CardCvcElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(228);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(1201);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(162);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(1199);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(1200);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Define Elements, and register their implied token / source types for
	// automatic token / source creation.
	
	// Card
	var CardElement = (0, _Element2.default)('card', {
	  impliedTokenType: 'card',
	  impliedSourceType: 'card',
	  impliedPaymentMethodType: 'card'
	});
	
	// Split Fields
	// Note: we only register the CardNumberElement for split fields so that we have
	// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', {
	  impliedTokenType: 'card',
	  impliedSourceType: 'card',
	  impliedPaymentMethodType: 'card'
	});
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCvcElement = (0, _Element2.default)('cardCvc');
	var CardCVCElement = CardCvcElement; // deprecated in favor of CardCvcElement which better matches Elements API
	
	// IBAN
	var IbanElement = (0, _Element2.default)('iban', {
	  impliedTokenType: 'bank_account',
	  impliedSourceType: 'sepa_debit'
	});
	
	// iDEAL Bank
	var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCvcElement = CardCvcElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
	exports.IbanElement = IbanElement;
	exports.IdealBankElement = IdealBankElement;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(129),
	    _assign = __webpack_require__(28);
	
	var ReactNoopUpdateQueue = __webpack_require__(483);
	
	var canDefineProperty = __webpack_require__(484);
	var emptyObject = __webpack_require__(150);
	var invariant = __webpack_require__(20);
	var lowPriorityWarning = __webpack_require__(1215);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(129);
	
	var ReactCurrentOwner = __webpack_require__(82);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 482 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(27);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(982);
	var Socket = __webpack_require__(487);
	var Emitter = __webpack_require__(488);
	var parser = __webpack_require__(229);
	var on = __webpack_require__(486);
	var bind = __webpack_require__(283);
	var debug = __webpack_require__(164)('socket.io-client:manager');
	var indexOf = __webpack_require__(308);
	var Backoff = __webpack_require__(907);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  var _parser = opts.parser || parser;
	  this.encoder = new _parser.Encoder();
	  this.decoder = new _parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.generateId(nsp);
	    }
	  }
	};
	
	/**
	 * generate `socket.id` for the given `nsp`
	 *
	 * @param {String} nsp
	 * @return {String}
	 * @api private
	 */
	
	Manager.prototype.generateId = function (nsp) {
	  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    if (timeout === 0) {
	      openSub.destroy(); // prevents a race condition with the 'open' event
	    }
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.generateId(nsp);
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting event is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ },
/* 486 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(229);
	var Emitter = __webpack_require__(488);
	var toArray = __webpack_require__(1248);
	var on = __webpack_require__(486);
	var bind = __webpack_require__(283);
	var debug = __webpack_require__(164)('socket.io-client:socket');
	var parseqs = __webpack_require__(152);
	var hasBin = __webpack_require__(304);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  this.flags = {};
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  if (!this.io.reconnecting) this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var packet = {
	    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
	    data: args
	  };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  this.flags = {};
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
	      debug('sending connect packet with query %s', query);
	      this.packet({type: parser.CONNECT, query: query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  var sameNamespace = packet.nsp === this.nsp;
	  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';
	
	  if (!sameNamespace && !rootNamespaceError) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    self.packet({
	      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags.compress = compress;
	  return this;
	};
	
	/**
	 * Sets the binary flag
	 *
	 * @param {Boolean} whether the emitted data contains binary
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.binary = function (binary) {
	  this.flags.binary = binary;
	  return this;
	};


/***/ },
/* 488 */
196,
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = isBuf;
	
	var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
	var withNativeArrayBuffer = typeof ArrayBuffer === 'function';
	
	var isView = function (obj) {
	  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
	};
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
	          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 490 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(153);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(1237);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(148).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(494);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(130).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(120);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1260);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1240);
	var destroyImpl = __webpack_require__(493);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(101);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(495).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(101);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(495).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(101);
	
	/*<replacement>*/
	var util = __webpack_require__(120);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(153);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(148).EventEmitter;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(130).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(1249);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cookies2.default;
	module.exports = exports['default'];

/***/ },
/* 497 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 498 */
/***/ function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ },
/* 500 */
/***/ function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ },
/* 501 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var bind = __webpack_require__(239);
	var Axios = __webpack_require__(504);
	var mergeConfig = __webpack_require__(237);
	var defaults = __webpack_require__(238);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(234);
	axios.CancelToken = __webpack_require__(503);
	axios.isCancel = __webpack_require__(235);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(516);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(234);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var buildURL = __webpack_require__(240);
	var InterceptorManager = __webpack_require__(505);
	var dispatchRequest = __webpack_require__(506);
	var mergeConfig = __webpack_require__(237);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	  config.method = config.method ? config.method.toLowerCase() : 'get';
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	var transformData = __webpack_require__(509);
	var isCancel = __webpack_require__(235);
	var defaults = __webpack_require__(238);
	var isAbsoluteURL = __webpack_require__(512);
	var combineURLs = __webpack_require__(510);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(236);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 510 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 512 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(53);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 516 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 517 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotesStats = function (_React$Component) {
	  _inherits(NotesStats, _React$Component);
	
	  function NotesStats(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NotesStats);
	
	    var _this = _possibleConstructorReturn(this, (NotesStats.__proto__ || Object.getPrototypeOf(NotesStats)).call(this, props));
	
	    _this.onHandleStats = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var isNotesRead, _this$props, apiServiceProvider, id, level, result;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              isNotesRead = _this.state.isNotesRead;
	
	              if (isNotesRead) {
	                _context.next = 7;
	                break;
	              }
	
	              _this$props = _this.props, apiServiceProvider = _this$props.apiServiceProvider, id = _this$props.id, level = _this$props.level;
	              _context.next = 5;
	              return apiServiceProvider['saveNotesStats']({ id: id, level: level });
	
	            case 5:
	              result = _context.sent;
	
	              if (result.success) {
	                _this.setState({ isNotesRead: true });
	              }
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      isNotesRead: false
	    };
	    return _this;
	  }
	
	  _createClass(NotesStats, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var _props, apiServiceProvider, id, level, result;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props = this.props, apiServiceProvider = _props.apiServiceProvider, id = _props.id, level = _props.level;
	                _context2.next = 3;
	                return apiServiceProvider['fetchNotesStats']({ id: id, level: level });
	
	              case 3:
	                result = _context2.sent;
	
	                if (result.success) {
	                  this.setState({ isNotesRead: true });
	                } else {
	                  setTimeout(function () {
	                    _this3.onHandleStats();
	                  }, 3000);
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(prevProps) {
	        var _this4 = this;
	
	        var _props2, apiServiceProvider, id, level, result;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!(prevProps.id !== this.props.id)) {
	                  _context3.next = 7;
	                  break;
	                }
	
	                this.setState({ isNotesRead: false });
	                _props2 = this.props, apiServiceProvider = _props2.apiServiceProvider, id = _props2.id, level = _props2.level;
	                _context3.next = 5;
	                return apiServiceProvider['fetchNotesStats']({ id: id, level: level });
	
	              case 5:
	                result = _context3.sent;
	
	                if (result.success) {
	                  this.setState({ isNotesRead: true });
	                } else {
	                  setTimeout(function () {
	                    _this4.onHandleStats();
	                  }, 3000);
	                }
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidUpdate(_x) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var isNotesRead = this.state.isNotesRead;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'up tooltip-hover-questions ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tootip_box' },
	          isNotesRead ? _messages.messages.UNREAD_NOTES : _messages.messages.READ_NOTES,
	          ' '
	        ),
	        _react2.default.createElement('i', {
	          onClick: function onClick() {
	            return _this5.onHandleStats;
	          },
	          className: 'fa fa-check mark-action-btn',
	          'aria-hidden': 'true',
	          style: { backgroundColor: isNotesRead ? 'green' : 'rgb(221, 221, 221)' }
	        })
	      );
	    }
	  }]);
	
	  return NotesStats;
	}(_react2.default.Component);
	
	exports.default = NotesStats;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardImageAndCount(_ref) {
	  var imageURL = _ref.imageURL,
	      count = _ref.count,
	      text = _ref.text,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? '23' : _ref$width;
	
	  return _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement('img', {
	        src: imageURL,
	        className: '',
	        width: width,
	        alt: 'ImageChange'
	      })
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      count
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      text
	    )
	  );
	}
	
	exports.default = CardImageAndCount;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _highlightText = __webpack_require__(56);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HighlightText = function (_Component) {
	  _inherits(HighlightText, _Component);
	
	  function HighlightText(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, HighlightText);
	
	    var _this = _possibleConstructorReturn(this, (HighlightText.__proto__ || Object.getPrototypeOf(HighlightText)).call(this, props));
	
	    _this.setShowPopover = function (value) {
	      return _this.setState({ showPopover: value });
	    };
	
	    _this.addHighlightToText = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var text, _this$props$params, mock_id, question_id, test_id, ApiServiceProvider, res;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              text = _this.getSelectionHtml();
	              _this$props$params = _this.props.params, mock_id = _this$props$params.mockId, question_id = _this$props$params.questionId, test_id = _this$props$params.testId;
	              ApiServiceProvider = _this.props.ApiServiceProvider;
	              _context.next = 5;
	              return ApiServiceProvider['addHighlightedTextService']({
	                mock_id: mock_id,
	                question_id: question_id,
	                test_id: test_id,
	                text: text
	              });
	
	            case 5:
	              res = _context.sent;
	
	              if (!res) {
	                _context.next = 11;
	                break;
	              }
	
	              _this.setState({ showPopover: false });
	              _context.next = 10;
	              return _this.getHighlightedText();
	
	            case 10:
	              (0, _highlightText.clearSelection)();
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection !== 'undefined') {
	        var sel = window.getSelection();
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var count = 0, len = sel.rangeCount; count < len; ++count) {
	            container.appendChild(sel.getRangeAt(count).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection !== 'undefined') {
	        if (document.selection.type === 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.deleteHighlight = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	        var mock_id, ApiServiceProvider, result;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                mock_id = _this.props.params.mock_id;
	                ApiServiceProvider = _this.props.ApiServiceProvider;
	
	                if (!id) {
	                  _context2.next = 13;
	                  break;
	                }
	
	                _context2.next = 5;
	                return ApiServiceProvider['deleteHighlightService']({
	                  mock_id: mock_id,
	                  id: id
	                });
	
	              case 5:
	                result = _context2.sent;
	
	                if (!result) {
	                  _context2.next = 11;
	                  break;
	                }
	
	                _this.setState({ showPopover: false });
	                _context2.next = 10;
	                return _this.getHighlightedText();
	
	              case 10:
	                (0, _highlightText.clearSelection)();
	
	              case 11:
	                _context2.next = 14;
	                break;
	
	              case 13:
	                return _context2.abrupt('return');
	
	              case 14:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.setQuestion = function (question) {
	      _this.setState({ question: question });
	    };
	
	    _this.getHighlightedText = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$props$params2, mock_id, question_id, test_id, ApiServiceProvider, resp, setQuestion, content;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$props$params2 = _this.props.params, mock_id = _this$props$params2.mockId, question_id = _this$props$params2.questionId, test_id = _this$props$params2.testId;
	              ApiServiceProvider = _this.props.ApiServiceProvider;
	              _context3.next = 4;
	              return ApiServiceProvider['getHighlightedTextService']({
	                mock_id: mock_id,
	                question_id: question_id,
	                test_id: test_id
	              });
	
	            case 4:
	              resp = _context3.sent;
	              setQuestion = _this.setQuestion, content = _this.props.content;
	
	
	              _this.highLightedQuestion = content;
	              if (resp.success) {
	                if (resp.data.length) {
	                  _this.highlights = resp.data;
	                  resp.data.forEach(function (element) {
	                    _this.highLightedQuestion = (0, _highlightText.highlightString)(_this.highLightedQuestion, element.text);
	                  });
	                }
	
	                setQuestion(_this.highLightedQuestion);
	              }
	
	            case 8:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.getHighlightedText();
	
	            case 1:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.componentDidUpdate = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(prevProps) {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (prevProps.content !== _this.props.content) _this.getHighlightedText();
	
	              case 1:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      showPopover: false,
	      highlights: [],
	      question: props.content
	    };
	    _this.highLightedQuestion = _this.props.content;
	    return _this;
	  }
	
	  _createClass(HighlightText, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state,
	          setShowPopover = this.setShowPopover;
	      var showPopover = state.showPopover,
	          question = state.question;
	
	
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = this.highLightedQuestion.indexOf(highlighted);
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-selectable': true },
	        (0, _function.renderHTMLContent)(question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: 'false' }),
	        _react2.default.createElement(
	          _reactSelectionPopover2.default,
	          {
	            showPopover: showPopover,
	            onSelect: function onSelect() {
	              return setShowPopover(true);
	            },
	            onDeselect: function onDeselect() {
	              return setShowPopover(false);
	            }
	          },
	          getHighlightedText === -1 ? _react2.default.createElement(
	            'div',
	            { className: 'highlight-popover tooltip_wrap' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	              alt: '523',
	              width: '30',
	              onClick: function onClick() {
	                return _this3.addHighlightToText();
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tootip_box' },
	              _language2.default.LC().Click_me_to_highlight
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'highlight-popover tooltip_wrap' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	              alt: '523',
	              width: '30',
	              onClick: function onClick() {
	                return _this3.deleteHighlightFromText();
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tootip_box' },
	              _language2.default.LC().Click_me_to_unhighlight
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HighlightText;
	}(_react.Component);
	
	exports.default = HighlightText;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ValidateButton(_ref) {
	  var onValidate = _ref.onValidate,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      className: 'btn btn-primary validate-button',
	      onClick: onValidate,
	      disabled: disabled
	    },
	    _language2.default.LC().VALIDATE
	  );
	}
	
	exports.default = ValidateButton;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settings = {
	  dots: true,
	  infinite: false,
	  speed: 500,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  responsive: [{
	    breakpoint: 1024,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3,
	      infinite: false,
	      dots: true
	    }
	  }, {
	    breakpoint: 600,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2,
	      dots: false
	    }
	  }, {
	    breakpoint: 480,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      dots: false
	    }
	  }],
	  nextArrow: _react2.default.createElement(SampleNextArrow, null),
	  prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	}; /* eslint-disable */
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: 'arrow image' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: 'arrow left image' })
	  );
	}
	
	function VideoListSlider(_ref) {
	  var videos = _ref.videos,
	      isUserSubscribed = _ref.isUserSubscribed,
	      _ref$hasPlusAccess = _ref.hasPlusAccess,
	      hasPlusAccess = _ref$hasPlusAccess === undefined ? false : _ref$hasPlusAccess,
	      premiumModalToggle = _ref.premiumModalToggle,
	      redirectToPlaylist = _ref.redirectToPlaylist;
	
	  var count = 0;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactSlick2.default,
	      settings,
	      videos.map(function (item, index) {
	        // Per-item substitution for `isUserSubscribed`. Non-webinar items:
	        // identical value. Webinars: gated on Plus tier.
	        var isSubscribedForItem = item && item.media_type === 'webinar' ? !!hasPlusAccess : !!isUserSubscribed;
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          !isSubscribedForItem ? item.free ? _react2.default.createElement(
	            'div',
	            { className: 'video-type-free' },
	            _messages.messages.FREE
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'video-type-primum' },
	            _messages.messages.PREMIUM
	          ) : _react2.default.createElement('div', null),
	          !item.url_id_qq || item.url_id_qq === 'null' ? _react2.default.createElement('img', {
	            alt: 'youtube thumbnail image',
	            width: '100%',
	            src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	            value: index,
	            onClick: function onClick() {
	              return isSubscribedForItem || item.free ? redirectToPlaylist(item) : premiumModalToggle();
	            },
	            className: 'pointer_class slider_row'
	          }) : _react2.default.createElement('img', {
	            alt: 'flowplayer thumbnail image',
	            width: '100%',
	            src: item.posterImage && item.posterImage !== 'null' ? item.posterImage : 'https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1.jpg',
	            onError: function onError(_ref2) {
	              var currentTarget = _ref2.currentTarget;
	
	              if (!count++) {
	                // Added condition because of infinite loop, this will once only
	                currentTarget.onerror = null; // prevents looping
	                currentTarget.src = '\n                      https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1_2.jpg';
	              }
	            },
	            value: index,
	            onClick: function onClick() {
	              return isSubscribedForItem || item.free ? redirectToPlaylist(item) : premiumModalToggle();
	            },
	            className: 'pointer_class slider_row'
	          }),
	          _react2.default.createElement(
	            'strong',
	            { style: { padding: '10px' } },
	            ' ',
	            item.title
	          )
	        );
	      })
	    )
	  );
	}
	
	exports.default = VideoListSlider;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditReportModalBody = function EditReportModalBody(_ref) {
	  var onReportEditSubmit = _ref.onReportEditSubmit,
	      onReportEditModalToggle = _ref.onReportEditModalToggle,
	      reportComment = _ref.reportComment,
	      onReportCommentChange = _ref.onReportCommentChange,
	      _ref$isReportErrorMes = _ref.isReportErrorMessageDisplay,
	      isReportErrorMessageDisplay = _ref$isReportErrorMes === undefined ? false : _ref$isReportErrorMes,
	      _ref$reportErrorMessa = _ref.reportErrorMessage,
	      reportErrorMessage = _ref$reportErrorMessa === undefined ? '' : _ref$reportErrorMessa;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-block' },
	    _react2.default.createElement(
	      'form',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 margin_bottom_10' },
	          _react2.default.createElement('textarea', {
	            id: 'comment',
	            name: 'reportComment',
	            rows: '6',
	            className: 'form-control',
	            placeholder: 'Content..',
	            onChange: function onChange(event) {
	              return onReportCommentChange(event);
	            },
	            value: reportComment
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: (!isReportErrorMessageDisplay ? 'd-none' : 'd-block') + ' text-danger' },
	            reportErrorMessage
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 d-flex' },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick(event) {
	                return onReportEditSubmit(event);
	              },
	              className: 'btn btn-primary active pointer_class'
	            },
	            'Update'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-danger active pointer_class margin_left_10',
	              onClick: function onClick() {
	                return onReportEditModalToggle();
	              }
	            },
	            'Cancel'
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = EditReportModalBody;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabActionButton = function TabActionButton(_ref) {
	  var _ref$tooltipText = _ref.tooltipText,
	      tooltipText = _ref$tooltipText === undefined ? '' : _ref$tooltipText,
	      _ref$buttonCss = _ref.buttonCss,
	      buttonCss = _ref$buttonCss === undefined ? '' : _ref$buttonCss,
	      _ref$buttonColor = _ref.buttonColor,
	      buttonColor = _ref$buttonColor === undefined ? '' : _ref$buttonColor,
	      _ref$onActionButtonCl = _ref.onActionButtonClick,
	      onActionButtonClick = _ref$onActionButtonCl === undefined ? function () {} : _ref$onActionButtonCl,
	      _ref$items = _ref.items,
	      items = _ref$items === undefined ? '' : _ref$items,
	      _ref$apiService = _ref.apiService,
	      apiService = _ref$apiService === undefined ? '' : _ref$apiService;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      ' ',
	      tooltipText,
	      ' '
	    ),
	    _react2.default.createElement('i', {
	      onClick: function onClick() {
	        return onActionButtonClick(apiService, items);
	      },
	      className: buttonCss,
	      style: { color: buttonColor }
	    })
	  );
	};
	exports.default = TabActionButton;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.API_ENDPOINT = undefined;
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_BASE = _App_data2.default.backend_api;
	
	var API_ENDPOINT = exports.API_ENDPOINT = {
	  GET_SENDGRID_STATUS: API_BASE + '/email/subscription-status',
	  RESUBSCRIBE_SENDGRID: API_BASE + '/email/resubscribe'
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getExamCodeForFamily = exports.getFamilyFromExamCode = exports.resolveExamCodeForPath = exports.isNextPathCfa2 = exports.isNextPath = exports.resolveExamFamilyForPath = exports.getExamFamilyFromPath = exports.EXAM_FAMILY = undefined;
	
	var _CODE_TO_FAMILY;
	
	var _constant = __webpack_require__(9);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // #292 — URL→exam reconciliation helpers.
	//
	// The app keeps three mirrors of "selected exam" (users.exam on the server,
	// localStorage.selectedmenu on the client, and the header dropdown). Page data is
	// resolved from the persisted selection, NOT from the URL, so opening/reloading a URL
	// for a different exam loads the wrong exam's data (or crashes in examWiseModelProvider).
	//
	// This module derives the exam *family* from the URL so the layout guard (containers/Full)
	// can reconcile the selection to match the opening URL. See
	// docs/superpowers/specs/2026-06-24-292-url-exam-reconciliation-design.md.
	
	// Stable, exam-agnostic family identifiers used internally by the guard.
	var EXAM_FAMILY = exports.EXAM_FAMILY = {
	  CFA1: 'cfa1',
	  CFA2: 'cfa2',
	  CFA3: 'cfa3',
	  FRM: 'frm',
	  ESG: 'esg',
	  SOA_P: 'soa_p',
	  SOA_FM: 'soa_fm',
	  GMAT_FOCUS: 'gmat_focus',
	  EA: 'ea'
	};
	
	// Every concrete exam code (the value stored in localStorage.selectedmenu / users.exam)
	// mapped to its family. Covers legacy and year-suffixed CFA codes.
	var CODE_TO_FAMILY = (_CODE_TO_FAMILY = {}, _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA, EXAM_FAMILY.CFA1), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_1_2024, EXAM_FAMILY.CFA1), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_1_2025, EXAM_FAMILY.CFA1), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_1_2026, EXAM_FAMILY.CFA1), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_1_2027, EXAM_FAMILY.CFA1), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_2, EXAM_FAMILY.CFA2), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_2, EXAM_FAMILY.CFA2), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_2_2025, EXAM_FAMILY.CFA2), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_2_2026, EXAM_FAMILY.CFA2), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_2_2027, EXAM_FAMILY.CFA2), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_3, EXAM_FAMILY.CFA3), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_3_2025, EXAM_FAMILY.CFA3), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.CFA_LEVEL_3_2026, EXAM_FAMILY.CFA3), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.ESG, EXAM_FAMILY.ESG), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.FRM, EXAM_FAMILY.FRM), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.SOA_P, EXAM_FAMILY.SOA_P), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.SOA_FM, EXAM_FAMILY.SOA_FM), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.GMAT, EXAM_FAMILY.GMAT_FOCUS), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.GMAT_FOCUS, EXAM_FAMILY.GMAT_FOCUS), _defineProperty(_CODE_TO_FAMILY, _constant.examNameAccordingToDB.EA, EXAM_FAMILY.EA), _CODE_TO_FAMILY);
	
	// Ordered URL-prefix → family table. Positive matches only: any path that matches none of
	// these returns null = "no switch" (covers account/payment routes and the genuinely
	// ambiguous shared `/videos` route, which both cfa2 and cfa3 use).
	var URL_PREFIX_RULES = [{ family: EXAM_FAMILY.CFA1, prefixes: ['/cfa1'] }, { family: EXAM_FAMILY.CFA2, prefixes: ['/cfa2'] }, { family: EXAM_FAMILY.CFA3, prefixes: ['/cfa3', '/pathway'] }, { family: EXAM_FAMILY.SOA_P, prefixes: ['/soa/probability'] }, { family: EXAM_FAMILY.SOA_FM, prefixes: ['/soa/financialmathematics'] }, { family: EXAM_FAMILY.FRM, prefixes: ['/frm'] }, { family: EXAM_FAMILY.ESG, prefixes: ['/esg'] }, { family: EXAM_FAMILY.GMAT_FOCUS, prefixes: ['/gmat'] }, { family: EXAM_FAMILY.EA, prefixes: ['/ea', '/EATab'] }];
	
	// Shared content routes that legitimately belong to more than one exam family. The URL
	// alone can't identify the exam, so: if the current selection is already one of the
	// allowed families, keep it (the page renders that exam's content); otherwise switch to
	// `defaultFamily`. `/videos` (and `/videos/list/...`) is shared by cfa2 and cfa3 — a user
	// on any other exam (e.g. esg) would otherwise get an empty page, so default to cfa2.
	var SHARED_ROUTE_RULES = [{
	  prefixes: ['/videos'],
	  allowedFamilies: [EXAM_FAMILY.CFA2, EXAM_FAMILY.CFA3],
	  defaultFamily: EXAM_FAMILY.CFA2
	}];
	
	var startsWith = function startsWith(path, prefix) {
	  return path.indexOf(prefix) === 0;
	};
	
	// Derive the exam family from a router pathname, or null when the URL carries no single
	// exam (shared/account/payment routes). Note `/soa/...` is checked before `/frm`/`/esg`
	// etc. only matters within its own family; order here is specific-first for safety.
	var getExamFamilyFromPath = exports.getExamFamilyFromPath = function getExamFamilyFromPath(pathname) {
	  if (!pathname) {
	    return null;
	  }
	  var i = 0;
	  for (i = 0; i < URL_PREFIX_RULES.length; i++) {
	    var rule = URL_PREFIX_RULES[i];
	    var j = 0;
	    for (j = 0; j < rule.prefixes.length; j++) {
	      if (startsWith(pathname, rule.prefixes[j])) {
	        return rule.family;
	      }
	    }
	  }
	  return null;
	};
	
	// Resolve the exam family a path should be viewed under, given the current selection.
	// Returns a single-exam family directly; for shared routes (e.g. /videos) it keeps the
	// current family when it's allowed, else falls back to the route's default; null otherwise.
	var resolveExamFamilyForPath = exports.resolveExamFamilyForPath = function resolveExamFamilyForPath(pathname, currentFamily) {
	  var direct = getExamFamilyFromPath(pathname);
	  if (direct) {
	    return direct;
	  }
	  if (!pathname) {
	    return null;
	  }
	  var i = 0;
	  for (i = 0; i < SHARED_ROUTE_RULES.length; i++) {
	    var rule = SHARED_ROUTE_RULES[i];
	    var j = 0;
	    for (j = 0; j < rule.prefixes.length; j++) {
	      if (startsWith(pathname, rule.prefixes[j])) {
	        if (currentFamily && rule.allowedFamilies.indexOf(currentFamily) !== -1) {
	          return currentFamily;
	        }
	        return rule.defaultFamily;
	      }
	    }
	  }
	  return null;
	};
	
	// CFA1 2027 lives at the year-free `/cfa1/2027/...` tree. It shares the CFA1 family prefix, so
	// the family-level reconciliation above can't tell it apart from 2025/2026 — a `/next/` deep-link
	// (e.g. from Bedrock) opened by a 2025/2026 user would resolve to the CFA1 default code and render
	// the wrong year. So `/next/` needs a CODE-level override that forces `cfa_2027` specifically.
	var NEXT_PREFIX = '/cfa1/2027';
	
	var isNextPath = exports.isNextPath = function isNextPath(pathname) {
	  return !!pathname && startsWith(pathname, NEXT_PREFIX);
	};
	
	// CFA2 2027 mirrors CFA1 2027: it lives at /cfa2/2027/... inside the shared CFA2 family prefix, so it
	// needs a CODE-level override to force cfa_2_2027 (family reconciliation alone can't tell it from the
	// 2026 tree at /cfa2/v2/... or the bare /cfa2/... CBT routes).
	var NEXT_PREFIX_CFA2 = '/cfa2/2027';
	
	var isNextPathCfa2 = exports.isNextPathCfa2 = function isNextPathCfa2(pathname) {
	  return !!pathname && startsWith(pathname, NEXT_PREFIX_CFA2);
	};
	
	// Resolve the concrete exam CODE a path should be reconciled to, given the current code, or null
	// for "no switch". `/cfa1/2027/...` forces `cfa_2027`. Every other path defers to the existing
	// family-level rules AND preserves their "don't switch within the same family" behaviour (so a
	// 2026 user opening a shared `/cfa1/...` URL is NOT bumped to the CFA1 default). This is the single
	// entry point the layout guard uses.
	var resolveExamCodeForPath = exports.resolveExamCodeForPath = function resolveExamCodeForPath(pathname, currentCode) {
	  // /cfa1/2027/... always forces cfa_2027 (up-switch if the session isn't already 2027).
	  if (isNextPath(pathname)) {
	    return _constant.examNameAccordingToDB.CFA_LEVEL_1_2027;
	  }
	  // /cfa2/2027/... always forces cfa_2_2027.
	  if (isNextPathCfa2(pathname)) {
	    return _constant.examNameAccordingToDB.CFA_LEVEL_2_2027;
	  }
	  var currentFamily = getFamilyFromExamCode(currentCode);
	  var targetFamily = resolveExamFamilyForPath(pathname, currentFamily);
	  if (!targetFamily) {
	    return null;
	  }
	  // Force-down: a non-2027 CFA1 URL (e.g. /cfa1/2026/...) must NOT keep rendering 2027. Reconcile
	  // the 2027 session down to the shared CFA1 default (cfa_2025 = live 2026 content), so 2027 is
	  // reachable ONLY under /cfa1/2027/.... Other CFA1 years on shared URLs fall through to the
	  // same-family "no switch" below.
	  if (targetFamily === EXAM_FAMILY.CFA1 && currentCode === _constant.examNameAccordingToDB.CFA_LEVEL_1_2027) {
	    return getExamCodeForFamily(EXAM_FAMILY.CFA1);
	  }
	  // Force-down: a non-2027 CFA2 *URL under /cfa2* (/cfa2/v2/..., bare /cfa2/... CBT) must NOT keep
	  // rendering 2027 — reconcile the cfa_2_2027 session down to the CFA2 default (cfa_2_2025 = live 2026),
	  // so 2027 is reachable ONLY under /cfa2/2027/.... The `startsWith('/cfa2')` guard is essential: the
	  // CFA2 videos live on the SHARED /videos page (family resolves to CFA2 there too), and without the
	  // guard a 2027 user opening /videos would be wrongly bumped to 2025. /videos keeps the 2027 token.
	  if (targetFamily === EXAM_FAMILY.CFA2 && currentCode === _constant.examNameAccordingToDB.CFA_LEVEL_2_2027 && startsWith(pathname, '/cfa2')) {
	    return getExamCodeForFamily(EXAM_FAMILY.CFA2);
	  }
	  if (targetFamily === currentFamily) {
	    return null;
	  }
	  return getExamCodeForFamily(targetFamily);
	};
	
	// Family of a stored exam code (localStorage.selectedmenu / users.exam), or null.
	var getFamilyFromExamCode = exports.getFamilyFromExamCode = function getFamilyFromExamCode(examCode) {
	  if (!examCode) {
	    return null;
	  }
	  return CODE_TO_FAMILY[examCode] || null;
	};
	
	// Reuse the header-dropdown lists as the single source of truth for which concrete
	// year-code a family resolves to. Taking the first list entry per family yields exactly
	// the value a manual dropdown click would assign (e.g. cfa1 -> cfa_2025), and adapts
	// automatically when the lists change (e.g. the future 2026/2027 -> single CFA1 collapse).
	var getExamCodeForFamily = exports.getExamCodeForFamily = function getExamCodeForFamily(family) {
	  if (!family) {
	    return null;
	  }
	  var allSelectable = [].concat((0, _constant.CFAExamList)()).concat(_constant.FRMExamList).concat(_constant.ActuarialExamList).concat(_constant.GMATExamList);
	  var i = 0;
	  for (i = 0; i < allSelectable.length; i++) {
	    var option = allSelectable[i];
	    if (option && getFamilyFromExamCode(option.value) === family) {
	      return option.value;
	    }
	  }
	  return null;
	};

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _constant = __webpack_require__(9);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _aiTutorContext = __webpack_require__(93);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _analytics = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	// deep-chat is loaded at RUNTIME from public/vendor → webpack never sees it.
	// Do NOT `import 'deep-chat'` anywhere webpack compiles (CRA 0.9.5 / webpack 1
	// cannot transpile its modern ESM). The browser executes the prebuilt bundle.
	var DEEPCHAT_SRC = (("https://app.analystprep.dev") || '') + '/vendor/deepChat-2.4.2.bundle.js';
	// Resolve the AI Tutor service base URL.
	// Prefer REACT_APP_TUTOR_URL (base origin), keep compatibility with legacy
	// values ending in /tutor/chat, fall back to localhost during local
	// development, then App_data.backend_api (same-origin reverse proxy).
	var normalizeTutorBase = function normalizeTutorBase(value) {
	  return value ? String(value).trim().replace(/\/tutor\/chat\/?$/i, '').replace(/\/+$/, '') : null;
	};
	
	var getTutorBase = function getTutorBase() {
	  var envBase = normalizeTutorBase(("https://ai-tutor.analystprep.dev"));
	
	  if (envBase) return envBase;
	
	  if (_CommonUtils.isLocalhost) return 'http://localhost:8880';
	
	  // NB: no optional chaining — react-scripts 0.9.5 / Babel does not transpile `?.`
	  // and it breaks the whole bundle at build time.
	  return typeof _App_data2.default !== 'undefined' && _App_data2.default ? normalizeTutorBase(_App_data2.default.backend_api) : null;
	};
	
	var TUTOR_BASE = getTutorBase();
	var TUTOR_URL = TUTOR_BASE ? TUTOR_BASE + '/tutor/chat' : null;
	var TUTOR_CONFIGURED = Boolean(TUTOR_BASE);
	
	// ---- V6 "Indigo pro" theme tokens (from the approved MVP mockup) ----
	// Violet "AI Tutor" identity (design 2026-07-08 — AnalystPrep AI Tutor Widget_02):
	// one visual language, violet + ✦, distinct from LMS blue and Intercom grey.
	var T = {
	  accent: '#4a2fe0',
	  accentSoft: '#ece9fd',
	  subText: '#8a86a8',
	  panelBg: '#ffffff',
	  bodyBg: '#f6f6fc',
	  aiBubbleBg: '#f2f0fd',
	  aiBubbleText: '#241f45',
	  aiBubbleBorder: '#e6e1fb',
	  userBubbleBg: 'linear-gradient(135deg,#6d4bff,#4a2fe0)',
	  chipBg: '#f6f4fe',
	  chipText: '#4a2fe0',
	  chipBorder: '#e2ddf8',
	  inputBg: '#ffffff',
	  inputBorder: '#e2e6f5',
	  footText: '#9a97ad',
	  headerBg: 'linear-gradient(135deg,#6d4bff 0%,#4a2fe0 100%)',
	  headerBadge: '#4a2fe0',
	  subBarBg: '#f7f6fe',
	  subBarBorder: '#eceafb',
	  ctxText: '#4a2fe0',
	  meterTrack: '#e6e1fb',
	  font: "'Plus Jakarta Sans', system-ui, sans-serif"
	};
	
	var _loaderPromise = null;
	var loadDeepChat = function loadDeepChat() {
	  if (window.customElements && customElements.get('deep-chat')) {
	    return Promise.resolve();
	  }
	  if (_loaderPromise) return _loaderPromise;
	  _loaderPromise = new Promise(function (resolve, reject) {
	    var s = document.createElement('script');
	    s.type = 'module';
	    s.src = DEEPCHAT_SRC;
	    s.onload = resolve;
	    s.onerror = function () {
	      reject(new Error('deep-chat bundle failed to load'));
	    };
	    document.head.appendChild(s);
	  }).then(function () {
	    return customElements.whenDefined('deep-chat');
	  });
	  return _loaderPromise;
	};
	
	// deep-chat's KaTeX integration needs window.katex present before math renders.
	// Loaded once, lazily. (Prod: self-host katex + fonts; CDN is fine for dev.)
	var _katexPromise = null;
	var loadKatex = function loadKatex() {
	  if (window.katex) return Promise.resolve();
	  if (_katexPromise) return _katexPromise;
	  _katexPromise = new Promise(function (resolve) {
	    try {
	      var link = document.createElement('link');
	      link.rel = 'stylesheet';
	      link.href = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css';
	      document.head.appendChild(link);
	      var s = document.createElement('script');
	      s.src = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.js';
	      s.onload = function () {
	        return resolve();
	      };
	      s.onerror = function () {
	        return resolve();
	      }; // never block the chat if katex fails to load
	      document.head.appendChild(s);
	    } catch (e) {
	      resolve();
	    }
	  });
	  return _katexPromise;
	};
	
	var getAuthToken = function getAuthToken() {
	  try {
	    return (0, _constant.getTokenWithEmail)().token;
	  } catch (e) {
	    return null;
	  }
	};
	
	// Forward-looking entitlement check. NOTE: the backend does not expose
	// `tutorStatus` yet (it's the P7 server-side entitlement work), so this returns
	// false today for everyone. `subscription_details` can also arrive as a JSON
	// string — parse it defensively.
	var hasTutorEntitlement = function hasTutorEntitlement(subs) {
	  if (typeof subs === 'string') {
	    try {
	      subs = JSON.parse(subs);
	    } catch (e) {
	      return false;
	    }
	  }
	  if (!subs || !subs.length) return false;
	  return subs.some(function (s) {
	    return s && s.pacakge && s.pacakge.tutorStatus;
	  });
	};
	
	// intro card (greeting + starter chips) as light-DOM child markup deep-chat slots in.
	// .deep-chat-suggestion-button is auto-wired to submit the chip text on click.
	// Chips depend on where the chat was opened (page_type at first mount): the label IS the
	// submitted prompt, grounded by the page `stem` the requestInterceptor attaches.
	var introChips = function introChips(pageType) {
	  if (pageType === 'question') {
	    return ['Explain my answer', 'Why is this answer correct?', 'Explain simply', 'Give me an example'];
	  }
	  if (pageType === 'note') {
	    return ['Summarize this note', 'Explain simply', 'Give me an example', 'Test me on this'];
	  }
	  if (pageType === 'video') {
	    return ['Summarize the key ideas of this lecture', 'Explain simply', 'Give me an example'];
	  }
	  // global / unknown page: generic CFA L1 prompts
	  return ['Explain this concept', 'Explain simply', 'Give me an example'];
	};
	var introSubject = function introSubject(pageType) {
	  if (pageType === 'question') return 'this question';
	  if (pageType === 'note') return 'this note';
	  if (pageType === 'video') return 'this lecture';
	  return 'the CFA L1 curriculum';
	};
	var introHTML = function introHTML(ctx) {
	  var pageType = ctx && ctx.page_type || 'global';
	  var chip = 'padding:9px 13px;border:1px solid ' + T.chipBorder + ';border-radius:11px;background:' + T.chipBg + ';color:' + T.chipText + ";font:700 13px " + T.font + ';cursor:pointer;text-align:left;';
	  var chips = introChips(pageType).map(function (label) {
	    return '<button class="deep-chat-suggestion-button" style="' + chip + '">' + label + '</button>';
	  }).join('');
	  return '<div style="padding:14px">' + '<div style="background:' + T.aiBubbleBg + ';border:1px solid ' + T.aiBubbleBorder + ';color:' + T.aiBubbleText + ';border-radius:4px 15px 15px 15px;padding:12px 14px;font:500 13.5px ' + T.font + ';line-height:1.5;">Hi \uD83D\uDC4B Ask me about ' + introSubject(pageType) + ' \u2014 I answer from the CFA L1 curriculum and cite the source.</div>' + '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:12px">' + chips + '</div>' + '</div>';
	};
	
	var escHtml = function escHtml(s) {
	  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	};
	// climb from the clicked node to the element carrying `attr` (deep-chat click
	// target may be an inner text node / span).
	var climbAttr = function climbAttr(node, attr) {
	  while (node) {
	    if (node.getAttribute) {
	      var v = node.getAttribute(attr);if (v != null) return v;
	    }
	    node = node.parentNode;
	  }
	  return null;
	};
	
	// V6 "Indigo" icons (shadow-DOM-safe inline SVG) — from the approved spike design
	var V6_ICON = {
	  doc: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h3"/></svg>',
	  book: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 6c-1.5-1.2-4-2-7-2v13c3 0 5.5.8 7 2 1.5-1.2 4-2 7-2V4c-3 0-5.5.8-7 2zM12 6v13"/></svg>',
	  play: '<svg width="15" height="15" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" fill="#fff"/></svg>'
	};
	
	// Composer placeholder copy (design Widget_03). Period-aware like the pill/upsell card — the
	// allowance can be day/month/total, so a monthly cap must not read "Daily".
	var INPUT_PLACEHOLDER = 'Ask a follow-up…';
	var cappedPlaceholder = function cappedPlaceholder(period) {
	  if (period === 'month') return 'Monthly limit reached — upgrade for more';
	  if (period === 'total') return 'Limit reached — upgrade for more'; // lifetime — no reset to promise
	  return 'Daily limit reached — upgrade for more';
	};
	
	// KB `content_type` → the icon/wording used by BOTH "Based on" and READ NEXT, so a source
	// looks the same wherever it appears. `type` comes from the backend citation/readmore entry
	// (note | video | question | …); anything unknown falls back to a document.
	var sourceKind = function sourceKind(rawType) {
	  var t = String(rawType || '').toLowerCase();
	  if (t === 'video' || t === 'lecture') return { icon: 'play', cta: 'Play', sub: 'Lecture · watch' };
	  if (t === 'question' || t === 'quiz') return { icon: 'doc', cta: 'Start', sub: 'Practice · start' };
	  if (t === 'note' || t === 'reading') return { icon: 'book', cta: 'Read', sub: 'Reading · jump to source' };
	  return { icon: 'doc', cta: 'Open', sub: 'Source · open' };
	};
	
	// 1) "Based on" — grounding proof, MINIMISED to one "Based on N sources" line so it never
	// competes with the answer; hover (or keyboard focus — tabindex + :focus-within) reveals the
	// source list in a popover. Design 2026-07-20 (Widget_03) BLOCK 1.
	var BO_DB_ICON = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" style="opacity:.7;flex:none"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5"/><path d="M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3"/></svg>';
	var BO_CHEV_ICON = '<svg class="dc-basedon-chev" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" style="flex:none"><path d="M6 9l6 6 6-6"/></svg>';
	
	var basedOnHtml = function basedOnHtml(cits) {
	  if (!cits.length) return '';
	  var rows = cits.map(function (c) {
	    var label = escHtml(c && (c.label || c.uri) || '');
	    // per-source icon + action word, shared with READ NEXT (Read / Play / Start / Open)
	    var kind = sourceKind(c && c.type);
	    var icCls = kind.icon === 'play' ? 'dc-bo-ic dc-bo-ic-play' : 'dc-bo-ic';
	    var inner = '<span class="' + icCls + '">' + (V6_ICON[kind.icon] || V6_ICON.doc) + '</span>' + '<span class="dc-bo-lbl">' + label + '</span>' + (c && c.url ? '<span class="dc-bo-go">' + kind.cta + ' \u2197</span>' : '');
	    return c && c.url ? '<a class="dc-bo-item" href="' + escHtml(c.url) + '" target="_blank" rel="noopener">' + inner + '</a>' : '<span class="dc-bo-item">' + inner + '</span>';
	  }).join('');
	  var noun = cits.length === 1 ? 'source' : 'sources';
	  return '<div class="dc-basedon" tabindex="0">' + '<div class="dc-basedon-sum">' + BO_DB_ICON + '<span>Based on <strong>' + cits.length + '</strong> ' + noun + '</span>' + BO_CHEV_ICON + '</div>' + '<div class="dc-basedon-pop"><div class="dc-bo-hd">GROUNDED IN</div>' + rows + '</div>' + '</div>';
	};
	
	// 2) "READ NEXT" — study-next cards (spike: dc-srccard). Only render items the backend
	// resolved to a real source link ({label,url,type} → Open/Play). Unresolved model titles
	// (plain strings, no URL) are dropped — no "Ask" fallback; if nothing resolves, no block.
	var readNextHtml = function readNextHtml(items) {
	  // Keep only url-bearing items, deduped by url (defensive — the backend dedups too, but an
	  // older backend or a repeated recommendation must never render the same card twice).
	  var seenUrls = {};
	  var resolved = (items || []).filter(function (r) {
	    if (!(r && (typeof r === 'undefined' ? 'undefined' : _typeof(r)) === 'object' && r.url) || seenUrls[r.url]) return false;
	    seenUrls[r.url] = 1;
	    return true;
	  });
	  if (!resolved.length) return '';
	  var rows = resolved.map(function (r) {
	    var title = escHtml(r.label || r.url || '');
	    var kind = sourceKind(r.type); // same icon/action map as "Based on"
	    var iconCls = kind.icon === 'play' ? 'dc-srcicon dc-srcicon-play' : 'dc-srcicon';
	    var inner = '<span class="' + iconCls + '">' + (V6_ICON[kind.icon] || V6_ICON.doc) + '</span>' + '<span class="dc-srctext"><span class="dc-srctitle">' + title + '</span><span class="dc-srcsub">' + kind.sub + '</span></span>' + '<span class="dc-srccta">' + kind.cta + ' →</span>';
	    return '<a class="dc-srccard" href="' + escHtml(r.url) + '" target="_blank" rel="noopener">' + inner + '</a>';
	  }).join('');
	  return '<div class="dc-readnext-lbl">READ NEXT</div><div class="dc-srccards">' + rows + '</div>';
	};
	
	// 3) "SUGGESTED FOLLOW-UPS" — native deep-chat suggestion buttons (click auto-submits the
	// label as the next question); full-width V6 styling scoped via .dc-followups in auxiliaryStyle.
	var followupsHtml = function followupsHtml(fups) {
	  if (!fups.length) return '';
	  var btns = fups.map(function (f) {
	    return '<button class="deep-chat-suggestion-button">' + escHtml(String(f)) + ' \u2192</button>';
	  }).join('');
	  return '<div class="dc-followups"><div class="dc-followups-lbl">SUGGESTED FOLLOW-UPS</div>' + btns + '</div>';
	};
	
	// 4) "Was this helpful?" — 👍/👎 targeting the exact tutor_message row (data-mid = the
	// SSE messageId). Rendered only when the backend confirmed the row was persisted.
	var feedbackRowHtml = function feedbackRowHtml(messageId) {
	  var up = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 11v9M2 12h5v8H2zM7 11l4-8a2 2 0 0 1 2.7 1.5l-1 5.5h6a2 2 0 0 1 2 2.4l-1.5 6A2 2 0 0 1 17 20H7"/></svg>';
	  var down = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 13V4M22 12h-5V4h5zM17 13l-4 8a2 2 0 0 1-2.7-1.5l1-5.5H5.3a2 2 0 0 1-2-2.4l1.5-6A2 2 0 0 1 7 4h10"/></svg>';
	  return '<div class="dc-fbrow" data-mid="' + escHtml(messageId) + '">' + '<span class="dc-fb-label">Was this helpful?</span>' + '<button type="button" class="dc-fb dc-fb-up" aria-label="Helpful">' + up + '</button>' + '<button type="button" class="dc-fb dc-fb-down" aria-label="Not helpful">' + down + '</button>' + '</div>';
	};
	
	// Per the 2026-07-20 design (Widget_03) the answer bubble CONTAINS its grounding + actions:
	//   [ answer text · Based on N sources · READ NEXT · Was this helpful? ]   ← one violet bubble
	//   SUGGESTED FOLLOW-UPS                                                   ← outside, frameless
	// deep-chat can't append into an already-streamed message, so the extras ride in a second
	// message with role 'extras' whose bubble is styled as a seamless continuation of the answer
	// (same fill, no top border, square top, negative margin) — see el.messageStyles.
	var answerExtrasHTML = function answerExtrasHTML(x) {
	  var citations = x.citations || [];
	  var readmore = x.readmore || [];
	  var out = '<div style="font-family:' + T.font + '">';
	  out += basedOnHtml(citations);
	  out += readNextHtml(readmore);
	  if (x.messageId) out += feedbackRowHtml(x.messageId);
	  return out + '</div>';
	};
	
	// Separate, frameless message: the SUGGESTED FOLLOW-UPS label sits on the panel background
	// (not inside the answer bubble) because clicking one starts the NEXT turn.
	var extrasHTML = function extrasHTML(x) {
	  var followups = x.followups || [];
	  var out = '<div style="font-family:' + T.font + '">';
	  out += followupsHtml(followups);
	  return out + '</div>';
	};
	
	// Time left until the usage window resets. The server counters are UTC (Redis windows),
	// so "tomorrow" means the next UTC midnight, not the browser's local midnight. Returns a
	// short label ("7h 12m", "1d 3h", "45m") or null when the window never resets ('total').
	var resetCountdown = function resetCountdown(period) {
	  try {
	    var now = new Date();
	    var end = void 0;
	    if (period === 'total') return null;
	    if (period === 'month') end = Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1);else end = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1); // day
	    var mins = Math.ceil((end - now.getTime()) / 60000);
	    if (!(mins > 0)) return null;
	    var days = Math.floor(mins / 1440);
	    var hours = Math.floor(mins % 1440 / 60);
	    var m = mins % 60;
	    if (days >= 2) return days + 'd';
	    if (days === 1) return '1d ' + hours + 'h';
	    if (hours >= 1) return hours + 'h ' + m + 'm';
	    return m + 'm';
	  } catch (e) {
	    return null;
	  }
	};
	
	// Limit-reached upsell card (design 2026-07-14, Placement Studio "Limit" tab).
	// V1: the CTA is hardcoded to the CFA1 packages page — make it exam-aware together
	// with the launcher gate + selectedmenu→exam map when the tutor expands (V2+).
	var UPGRADE_URL = '/subscribe/selectPackage/cfa1/1';
	var upgradeHTML = function upgradeHTML(limit, period) {
	  var windowWord = period === 'month' ? ' this month' : period === 'total' ? '' : ' today';
	  var title = (limit > 0 ? "You've used all " + limit + ' free questions' : "You've used all your free questions") + windowWord;
	  var resetWord = period === 'month' ? 'monthly' : 'daily';
	  var sub = period === 'total' ? 'Upgrade to <b>Unlimited+</b> for unlimited AI tutoring.' : 'Upgrade to <b>Unlimited+</b> for unlimited AI tutoring, or wait for your ' + resetWord + ' reset.';
	  var left = resetCountdown(period);
	  return '<div class="dc-upgrade">' + '<div class="dc-upgrade-title">✦ ' + title + '</div>' + '<div class="dc-upgrade-sub">' + sub + '</div>' + '<div class="dc-upgrade-row">' + '<a class="dc-upgrade-btn" href="' + UPGRADE_URL + '">Upgrade to Unlimited+</a>' + (left ? '<span class="dc-upgrade-reset">Resets in ' + left + '</span>' : '') + '</div></div>';
	};
	
	// Guardrail Change 3 — recoverable block. When the guardrail stops a question, the refusal bubble
	// is followed by this card so it's not a dead end: one click hands off to a human (Intercom). The
	// (escaped) blocked question rides on data-q to prefill the Intercom conversation.
	var recoveryHTML = function recoveryHTML(question) {
	  var q = escHtml(String(question || ''));
	  return '<div style="background:' + T.chipBg + ';border:1px solid ' + T.chipBorder + ';border-radius:12px;padding:12px 14px;margin-top:4px">' + '<div style="font:600 12.5px ' + T.font + ';color:' + T.aiBubbleText + ';line-height:1.5">' + 'Still need help with this? A person from our team can take over.</div>' + '<button class="tutor-escalate" data-q="' + q + '" ' + 'style="margin-top:9px;border:none;border-radius:9px;background:' + T.accent + ';color:#fff;font:700 12.5px ' + T.font + ';padding:8px 13px;cursor:pointer">' + 'Talk to a human →</button>' + '</div>';
	};
	
	// "Upgrade to Unlimited+" click: put the CFA Unlimited+ package (exam_plans.package_val
	// = 'plus', id 78) into the server-side
	// cart via the same two checkout_v1 endpoints the packages page uses (the backend
	// validates ownership and computes the upgrade credit itself), then land in /cart.
	// ANY failure — no backend base, request error, plan not found, already owned,
	// success:false — falls back to plain navigation to the packages page (UPGRADE_URL),
	// i.e. exactly the pre-JS behavior of the card's anchor.
	var addUnlimitedToCartAndGo = function addUnlimitedToCartAndGo() {
	  var base = _App_data2.default && _App_data2.default.backend_api;
	  if (!base) {
	    window.location.assign(UPGRADE_URL);return;
	  }
	  _fetchData2.default.callAPI(base + '/checkout_v1/getExamPackagesByUserId', { examId: 1, examName: 'cfa1' }).then(function (resp) {
	    var list = resp && resp.success && resp.packages || [];
	    var plan = null;
	    for (var i = 0; i < list.length; i++) {
	      var p = list[i];
	      if (p && String(p.package_val).toLowerCase() === 'plus' && p.package_category !== 'mock') {
	        plan = p;
	        break;
	      }
	    }
	    if (!plan || plan.isOwned) {
	      window.location.assign(UPGRADE_URL);return null;
	    }
	    var payload = { examId: Number(plan.exam_id), planId: Number(plan.planId), addonIds: [], source: 'ai-tutor' };
	    var displayPrice = plan.price;
	    if (plan.upgradeAvailable) {
	      payload.type = plan.upgradeType || 'upgrade_standard';
	      payload.upgradeFromPlanId = plan.upgradeFromPlanId;
	      displayPrice = plan.upgradePrice;
	      payload.displayPrice = displayPrice;
	    } else {
	      payload.type = 'main';
	    }
	    return _fetchData2.default.callAPI(base + '/checkout_v1/addToUserCart', payload).then(function (r) {
	      if (r && r.success) {
	        try {
	          // same GTM/GA4 AddToCart event the packages page fires — keeps widget
	          // upsells inside the conversion funnel (user fields default to '')
	          (0, _analytics.trackAddToCart)({
	            exam: 'CFA Level I',
	            packageType: plan.package_type || 'CFA Unlimited+ Package',
	            value: Number(displayPrice) || 0,
	            source: _userStore2.default && _userStore2.default.landingSource || 'organic',
	            affiliateName: _userStore2.default && _userStore2.default.landingSourceName || null
	          });
	        } catch (e) {/* analytics is best-effort */}
	        window.location.assign('/cart');
	      } else {
	        window.location.assign(UPGRADE_URL);
	      }
	    });
	  }).catch(function () {
	    window.location.assign(UPGRADE_URL);
	  });
	};
	
	// ── Draggable panel (design 2026-07-20, Widget_03) ────────────────────────────────────
	// Plain mouse events on purpose: React 15 has no synthetic POINTER events (added in 16.4),
	// and every modern DnD library (dnd-kit, react-dnd v14+, react-rnd, react-draggable v4)
	// requires React >= 16.8 hooks. Dragging is desktop-only — on mobile the panel is a
	// full-screen sheet — so mouse events cover every case.
	// The offset is PERSISTED: the panel covering page content is the reason it is movable,
	// so where the student parks it must survive navigation.
	var DRAG_KEY = 'apAiTutorPos';
	var DRAG_MARGIN = 8; // keep at least this many px of the panel on screen
	
	var loadDragPos = function loadDragPos() {
	  try {
	    var raw = localStorage.getItem(DRAG_KEY);
	    if (!raw) return { x: 0, y: 0 };
	    var p = JSON.parse(raw);
	    var x = Number(p && p.x);
	    var y = Number(p && p.y);
	    return { x: isFinite(x) ? x : 0, y: isFinite(y) ? y : 0 };
	  } catch (e) {
	    return { x: 0, y: 0 };
	  }
	};
	
	var saveDragPos = function saveDragPos(p) {
	  try {
	    localStorage.setItem(DRAG_KEY, JSON.stringify({ x: Math.round(p.x), y: Math.round(p.y) }));
	  } catch (e) {/* private mode / quota — dragging still works for this page */}
	};
	
	// Pointer coords from either a mouse or a touch event (React 15 has no pointer events).
	var dragPoint = function dragPoint(e) {
	  if (e.touches && e.touches.length) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
	  if (e.changedTouches && e.changedTouches.length) {
	    return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
	  }
	  return { x: e.clientX, y: e.clientY };
	};
	
	// Mobile = the same breakpoint as the full-screen-sheet media query below.
	var isMobileViewport = function isMobileViewport() {
	  try {
	    return !!(window.matchMedia && window.matchMedia('(max-width:574.98px)').matches);
	  } catch (e) {
	    return false;
	  }
	};
	
	var AITutorChat = function (_Component) {
	  _inherits(AITutorChat, _Component);
	
	  function AITutorChat(props) {
	    _classCallCheck(this, AITutorChat);
	
	    // `killed` = admin kill-switch. Seeded synchronously from the cached flag so a disabled
	    // tutor never flashes on repeat loads; refreshed from the public /tutor/health probe.
	    var _this = _possibleConstructorReturn(this, (AITutorChat.__proto__ || Object.getPrototypeOf(AITutorChat)).call(this, props));
	
	    _this.state = { enabled: false, open: false, notice: null, killed: (0, _aiTutorContext.isAiTutorKillSwitchedOff)() };
	    _this._box = null;
	    _this._el = null;
	    _this._ctx = props.context || {};
	    _this._killedProbeExam = null; // last exam sent to /tutor/health (dedupes mount vs 1st context)
	    _this._sid = null;
	    _this._lastMessageId = null; // last persisted answer row — feedback + escalation target
	    _this._mountedFlag = false;
	    _this._pendingItem = null; // attached to the next request body (e.g. "Explain my answer")
	    _this._ctxLabelRef = null;
	    _this._usageRef = null; // "✦ N left today" pill — updated imperatively from SSE
	    _this._upgradeShown = false; // one upsell card per depletion (re-armed on headroom)
	    _this._lastLimit = null; // last known cap size (GET /tutor/usage) — card title
	    _this._lastPeriod = null; // last known window — the limitReached SSE has no period
	    _this._pendingUpgradeCard = false; // capped-on-open card queued until deep-chat mounts
	    _this._capped = false; // 0 turns left → dimmed composer + dead send button
	    _this._composerGuard = null; // capture-phase submit blocker (installed once, on #input)
	    _this._composerTries = 0; // deep-chat renders its shadow DOM async — bounded retry
	    _this._composerTimer = null;
	    _this._setRef = function (el) {
	      _this._box = el;
	    };
	    // drag: callback refs (React 15 has no createRef) + the persisted offset
	    _this._panelEl = null;
	    _this._dragHandleEl = null;
	    _this._dragPos = loadDragPos();
	    _this._setPanelRef = function (el) {
	      _this._panelEl = el;
	    };
	    _this._setDragHandleRef = function (el) {
	      _this._dragHandleEl = el;
	    };
	    _this._onToggle = _this._onToggle.bind(_this);
	    _this._onContext = _this._onContext.bind(_this);
	    _this._onExplain = _this._onExplain.bind(_this);
	    _this._onDragStart = _this._onDragStart.bind(_this);
	    return _this;
	  }
	
	  _createClass(AITutorChat, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var subs, enabled, exam;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this._mountedFlag = true;
	                window.addEventListener('aitutor:toggle', this._onToggle);
	                window.addEventListener('aitutor:context', this._onContext);
	                window.addEventListener('aitutor:explain', this._onExplain);
	                _context.next = 6;
	                return _userStore2.default.getSubscriptionDetails();
	
	              case 6:
	                subs = _context.sent;
	
	                // TODO(P7): gate strictly on hasTutorEntitlement(subs) once the backend
	                // exposes `tutorStatus`. Until then, enable for any authenticated user so
	                // the feature is testable on this branch.
	                enabled = hasTutorEntitlement(subs) || !!getAuthToken();
	
	                if (this._mountedFlag && enabled) this.setState({ enabled: true });
	                exam = this._ctx && this._ctx.exam || 'cfa1';
	                // A.2: kill-switch sync. Public /tutor/health only — the old token /tutor/usage probe fired
	                // a usage request on every load even when the tutor was disabled.
	
	                this._refreshKilled(exam);
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    // Kill-switch pull point — /tutor/health only (public, no token, survives a broken session).
	    // Deduped per exam: mount probes the default exam, then the first `aitutor:context` event
	    // (prevExam still undefined) would re-probe the SAME exam — one probe per exam is enough.
	
	  }, {
	    key: '_refreshKilled',
	    value: function _refreshKilled(exam) {
	      var _this2 = this;
	
	      var key = String(exam || 'cfa1').toLowerCase();
	      if (key === this._killedProbeExam) return;
	      this._killedProbeExam = key;
	      (0, _aiTutorContext.refreshAiTutorAvailabilityPublic)(TUTOR_BASE, key, function (off) {
	        if (_this2._mountedFlag) _this2.setState({ killed: off, open: off ? false : _this2.state.open });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      if (this._el && next.context !== this.props.context) this._ctx = next.context || {};
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mountedFlag = false;
	      window.removeEventListener('aitutor:toggle', this._onToggle);
	      window.removeEventListener('aitutor:context', this._onContext);
	      window.removeEventListener('aitutor:explain', this._onExplain);
	      clearTimeout(this._composerTimer); // bounded retry must not outlive the widget
	      this._composerTimer = null;
	      this._composerGuard = null;
	      if (this._el && this._el.parentNode) this._el.parentNode.removeChild(this._el);
	      this._el = null;
	    }
	
	    // Mount deep-chat only after the panel is laid out (display:none → flex),
	    // otherwise it measures a 0-height host and collapses. rAF defers past layout.
	    // Reachability probe: GET /tutor/health on the service base. Resolves on ANY http
	    // response (even 404 from an older backend without the endpoint — reachable is
	    // enough); rejects only on network error / timeout, i.e. service down or not deployed.
	
	  }, {
	    key: '_probeHealth',
	    value: function _probeHealth() {
	      var url = TUTOR_BASE + '/tutor/health';
	      return new Promise(function (resolve, reject) {
	        var settled = false;
	        var timer = setTimeout(function () {
	          if (!settled) {
	            settled = true;reject(new Error('timeout'));
	          }
	        }, 3000);
	        fetch(url).then(function (r) {
	          if (!settled) {
	            settled = true;clearTimeout(timer);resolve(r);
	          }
	        }, function (e) {
	          if (!settled) {
	            settled = true;clearTimeout(timer);reject(e);
	          }
	        });
	      });
	    }
	  }, {
	    key: '_ensureMounted',
	    value: function _ensureMounted(cb) {
	      var _this3 = this;
	
	      if (this._el) {
	        if (cb) cb();return;
	      }
	      // Guard 1: no tutor endpoint configured for this env → notice, don't mount.
	      if (!TUTOR_CONFIGURED) {
	        this.setState({ notice: 'config' });return;
	      }
	      // Guard 2: endpoint configured but the service is unreachable → notice.
	      // Re-probed on every open, so the chat recovers once the service is back.
	      this._probeHealth().then(function () {
	        return Promise.all([loadDeepChat(), loadKatex()]).then(function () {
	          _this3.setState({ notice: null }, function () {
	            return requestAnimationFrame(function () {
	              _this3._mountDeepChat();if (cb) cb();
	            });
	          });
	        }).catch(function () {
	          _this3.setState({ notice: 'load' });
	        });
	      }) // bundle failed to load
	      .catch(function () {
	        _this3.setState({ notice: 'backend' });
	      }); // service down / keys missing
	    }
	  }, {
	    key: '_onToggle',
	    value: function _onToggle() {
	      var _this4 = this;
	
	      if (!this.state.enabled) return;
	      if (this.state.killed || (0, _aiTutorContext.isAiTutorKillSwitchedOff)()) return; // disabled → don't open/fetch
	      var open = !this.state.open;
	      // pull the current page context on open (robust against event-timing — the
	      // page writes window.__aiTutorContext; the `aitutor:context` event only
	      // live-updates while already open).
	      if (open) this._ctx = window.__aiTutorContext || (0, _aiTutorContext.aiTutorGlobalContext)();
	      this.setState({ open: open }, function () {
	        if (open) {
	          _this4._settleDragPos();_this4._ensureMounted();_this4._fetchUsage();
	        }
	      });
	    }
	
	    // Keep the panel on screen: `base` is its position WITHOUT any transform, so the clamp
	    // works no matter where the CSS anchors it (and after a viewport resize).
	
	  }, {
	    key: '_clampDrag',
	    value: function _clampDrag(x, y, base) {
	      var vw = window.innerWidth;
	      var vh = window.innerHeight;
	      var minX = DRAG_MARGIN - base.left;
	      var maxX = vw - DRAG_MARGIN - base.w - base.left;
	      var minY = DRAG_MARGIN - base.top;
	      var maxY = vh - DRAG_MARGIN - base.h - base.top;
	      return {
	        x: Math.min(Math.max(x, minX), Math.max(minX, maxX)),
	        y: Math.min(Math.max(y, minY), Math.max(minY, maxY))
	      };
	    }
	  }, {
	    key: '_applyDragTransform',
	    value: function _applyDragTransform() {
	      var el = this._panelEl;
	      if (!el) return;
	      var p = this._dragPos;
	      el.style.transform = p.x || p.y ? 'translate(' + p.x + 'px,' + p.y + 'px)' : '';
	    }
	
	    // Re-clamp on open: the saved offset may be off-screen on a smaller window / another page.
	
	  }, {
	    key: '_settleDragPos',
	    value: function _settleDragPos() {
	      var el = this._panelEl;
	      if (!el) return;
	      if (isMobileViewport()) {
	        el.style.transform = '';return;
	      } // sheet: never offset
	      var p = this._dragPos;
	      var r = el.getBoundingClientRect();
	      this._dragPos = this._clampDrag(p.x, p.y, { left: r.left - p.x, top: r.top - p.y, w: r.width, h: r.height });
	      this._applyDragTransform();
	    }
	
	    // Header drag. Moves the element imperatively (no setState per frame — a re-render on every
	    // mousemove would tear down deep-chat's DOM); the final offset is committed on mouseup.
	
	  }, {
	    key: '_onDragStart',
	    value: function _onDragStart(e) {
	      var _this5 = this;
	
	      // Mobile is a full-screen sheet — nothing to drag. The header still carries
	      // touch-action:none, so the gesture dies here instead of scrolling the page.
	      if (isMobileViewport()) return;
	      var isTouch = !!(e.touches && e.touches.length);
	      if (!isTouch && e.button !== 0) return; // left mouse button only
	      if (e.target && e.target.closest && e.target.closest('[data-no-drag]')) return; // ✕ etc.
	      var el = this._panelEl;
	      if (!el) return;
	      if (e.preventDefault) e.preventDefault(); // no text selection / no page pan
	
	      var start = this._dragPos;
	      var r = el.getBoundingClientRect();
	      var base = { left: r.left - start.x, top: r.top - start.y, w: r.width, h: r.height };
	      var p0 = dragPoint(e);
	      var pending = start;
	
	      var move = function move(ev) {
	        // touchmove is registered non-passive so this can cancel the browser's pan
	        if (ev.cancelable) ev.preventDefault();
	        var p = dragPoint(ev);
	        pending = _this5._clampDrag(start.x + (p.x - p0.x), start.y + (p.y - p0.y), base);
	        el.style.transform = 'translate(' + pending.x + 'px,' + pending.y + 'px)';
	      };
	      var up = function up() {
	        window.removeEventListener('mousemove', move);
	        window.removeEventListener('mouseup', up);
	        window.removeEventListener('touchmove', move);
	        window.removeEventListener('touchend', up);
	        window.removeEventListener('touchcancel', up);
	        document.body.style.userSelect = '';
	        if (_this5._dragHandleEl) _this5._dragHandleEl.style.cursor = 'grab';
	        _this5._dragPos = pending;
	        saveDragPos(pending);
	      };
	
	      document.body.style.userSelect = 'none';
	      if (this._dragHandleEl) this._dragHandleEl.style.cursor = 'grabbing';
	      window.addEventListener('mousemove', move);
	      window.addEventListener('mouseup', up);
	      window.addEventListener('touchmove', move, { passive: false });
	      window.addEventListener('touchend', up);
	      window.addEventListener('touchcancel', up);
	    }
	  }, {
	    key: '_ctxText',
	    value: function _ctxText() {
	      return 'Context · ' + (this._ctx && (this._ctx.title || this._ctx.content_id) || 'CFA Level I');
	    }
	    // V6 usage pill (spike design): "✦ N left today" · "✦ Unlimited" · amber "0 left · resets soon".
	    // Imperative DOM update (like the context label) so it never collides with React reconciliation.
	    // `period` ('day' | 'month' | 'total') tunes the wording; missing/day → "today".
	
	  }, {
	    key: '_updateUsage',
	    value: function _updateUsage(remaining, period) {
	      if (period) this._lastPeriod = period;
	      // headroom again (new window / admin raise / unlimited) → allow a future card
	      if (remaining === null || remaining === undefined || Number(remaining) > 0) this._upgradeShown = false;
	      // Same signal as the pill (unlimited = null → never capped). BEFORE the pill's early
	      // return, or a missing pill ref strands the composer. Re-enables on any headroom refresh.
	      this._setComposerCapped(remaining !== null && remaining !== undefined && !(Number(remaining) > 0));
	      var el = this._usageRef;
	      if (!el) return;
	      el.style.display = 'inline-flex';
	      var violet = function violet() {
	        el.style.color = T.accent;el.style.background = T.accentSoft;el.style.border = 'none';
	      };
	      if (remaining === null || remaining === undefined) {
	        el.textContent = '✦ Unlimited';
	        violet();
	        return;
	      }
	      var n = Number(remaining);
	      if (!(n > 0)) {
	        // 'total' is a lifetime cap — there is no reset to promise.
	        var cd = resetCountdown(period);
	        el.textContent = period === 'total' ? '0 left' : '0 left · resets ' + (cd ? 'in ' + cd : 'soon');
	        el.style.color = '#c2410c';el.style.background = '#fff1e6';el.style.border = '1px solid #ffd9bd';
	        return;
	      }
	      var suffix = period === 'month' ? ' left this month' : period === 'total' ? ' left' : ' left today';
	      el.textContent = '✦ ' + n + suffix;
	      violet();
	    }
	
	    // ---- capped composer (design Widget_03): placeholder swap + 0.55 dim + dead send button ----
	    // Verified headlessly against the vendored bundle; don't "simplify" without re-probing:
	    //  1. Placeholder = the `deep-chat-placeholder-text` ATTRIBUTE (`content:attr()` on
	    //     `#text-input:empty::before`). Re-assigning `el.textInput` after mount blanks it.
	    //  2. Opacity goes on `#input` — the only common ancestor of the box and the submit button
	    //     (the button is an absolutely-positioned sibling of `#text-input-container`).
	    //  3. The Enter guard must sit on `#input`, not `#text-input`: deep-chat registers its own
	    //     keydown on that node first, so a same-node stopImmediatePropagation loses.
	
	  }, {
	    key: '_setComposerCapped',
	    value: function _setComposerCapped(capped) {
	      this._capped = !!capped; // before any DOM work — the guard reads it even pre-mount
	      this._applyComposerState();
	    }
	  }, {
	    key: '_installComposerGuard',
	    value: function _installComposerGuard(input) {
	      var _this6 = this;
	
	      if (this._composerGuard) return; // once per deep-chat instance
	      var guard = function guard(e) {
	        if (!_this6._capped) return;
	        if (e.type === 'keydown' && (e.key !== 'Enter' || e.shiftKey)) return; // shift+Enter = newline
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      };
	      this._composerGuard = guard;
	      input.addEventListener('keydown', guard, true);
	      input.addEventListener('click', guard, true);
	    }
	
	    // deep-chat renders its shadow DOM async — retry briefly (same race as _pendingUpgradeCard).
	
	  }, {
	    key: '_applyComposerState',
	    value: function _applyComposerState() {
	      var _this7 = this;
	
	      var sr = this._el && this._el.shadowRoot;
	      var input = sr && sr.getElementById('input');
	      var ti = sr && sr.getElementById('text-input');
	      if (!input || !ti) {
	        if (this._composerTries < 20) {
	          this._composerTries++;
	          clearTimeout(this._composerTimer);
	          this._composerTimer = setTimeout(function () {
	            return _this7._applyComposerState();
	          }, 100);
	        }
	        return;
	      }
	      this._composerTries = 0;
	      this._installComposerGuard(input);
	      if (this._capped) input.classList.add('ap-capped');else input.classList.remove('ap-capped');
	      ti.setAttribute('contenteditable', this._capped ? 'false' : 'true'); // no typing while capped
	      // A typed draft leaves the box non-`:empty`, so the placeholder stays hidden until the
	      // student clears it — their text is deliberately not destroyed.
	      ti.setAttribute('deep-chat-placeholder-text', this._capped ? cappedPlaceholder(this._lastPeriod) : INPUT_PLACEHOLDER);
	    }
	
	    // Read-only usage snapshot (GET /tutor/usage) — how many questions remain / unlimited, WITHOUT
	    // spending a turn. Called on every open and on course/context switch so the pill is always
	    // current, even before the first message. Best-effort: any failure leaves the pill untouched.
	
	  }, {
	    key: '_fetchUsage',
	    value: function _fetchUsage() {
	      var _this8 = this;
	
	      if (!TUTOR_BASE) return;
	      if (this.state.killed || (0, _aiTutorContext.isAiTutorKillSwitchedOff)()) return; // disabled → no usage request
	      var examKey = (this._ctx && this._ctx.exam || 'CFA1').toString().toLowerCase();
	      // cache-buster + no-store: the count must reflect admin changes on the very next reload,
	      // never a browser-cached copy of this GET.
	      var url = TUTOR_BASE + '/tutor/usage?exam=' + encodeURIComponent(examKey) + '&_=' + Date.now();
	      fetch(url, { headers: { Authorization: getAuthToken() }, cache: 'no-store' }).then(function (r) {
	        // An auth/server error (401 "token invalid", 5xx) is NOT a kill-switch signal. Its JSON
	        // body has no `enabled`, so parsing it would evaluate `undefined === false` → false and
	        // CLEAR a real admin disable on every load. Bail out: leave the cached state untouched.
	        if (!r.ok) return null;
	        return r.json().then(function (d) {
	          if (!d) return;
	          (0, _aiTutorContext.setAiTutorOffState)(d.enabled === false); // panel-open pull point (no extra request)
	          if (d.enabled === false) {
	            _this8.setState({ notice: 'disabled' });return;
	          }
	          if (_this8.state.notice === 'disabled') _this8.setState({ notice: null });
	          if (d.limit !== undefined && d.limit !== null) _this8._lastLimit = Number(d.limit);
	          _this8._updateUsage(d.unlimited ? null : d.remaining, d.period);
	          // already capped when the panel opens → show the upsell card under the intro
	          // (dedup via the same _upgradeShown flag as the SSE triggers)
	          if (!d.unlimited && Number(d.remaining) === 0 && !_this8._upgradeShown) {
	            _this8._upgradeShown = true;
	            if (_this8._el && _this8._el.addMessage) {
	              setTimeout(function () {
	                return _this8._injectUpgrade(_this8._lastLimit, _this8._lastPeriod);
	              }, 200);
	            } else {
	              _this8._pendingUpgradeCard = true; // deep-chat not mounted yet — flush in _mountDeepChat
	            }
	          }
	        }, function () {});
	      }, function () {});
	    }
	  }, {
	    key: '_updateCtxLabel',
	    value: function _updateCtxLabel() {
	      if (this._ctxLabelRef) this._ctxLabelRef.textContent = this._ctxText();
	    }
	
	    // Page told us which item the student is looking at — update silently (no open).
	    // A course/exam switch flows through here too, so re-check the remaining count when open.
	
	  }, {
	    key: '_onContext',
	    value: function _onContext(e) {
	      var ctx = e && e.detail && e.detail.context;
	      if (!ctx) return;
	      var prevExam = this._ctx && this._ctx.exam;
	      this._ctx = ctx;
	      this._updateCtxLabel();
	      if (ctx.exam !== prevExam) this._refreshKilled(ctx.exam); // health probe, not usage
	      if (this.state.open && ctx.exam !== prevExam) this._fetchUsage();
	    }
	
	    // "Explain my answer" — set context + item, open, and submit the prompt.
	
	  }, {
	    key: '_onExplain',
	    value: function _onExplain(e) {
	      var _this9 = this;
	
	      if (!this.state.enabled) return;
	      if (this.state.killed || (0, _aiTutorContext.isAiTutorKillSwitchedOff)()) return; // disabled → don't open/fetch
	      var d = e && e.detail || {};
	      if (d.context) {
	        this._ctx = d.context;this._updateCtxLabel();
	      }
	      if (d.item) this._pendingItem = d.item;
	      var text = d.message || 'Explain my answer';
	      this._fetchUsage(); // show the current count immediately (the turn's SSE will refine it)
	      // small defer: deep-chat warns if submitUserMessage is called before its view renders
	      var submit = function submit() {
	        return setTimeout(function () {
	          return _this9.submitUserMessage({ text: text });
	        }, 60);
	      };
	      if (!this.state.open) this.setState({ open: true }, function () {
	        return _this9._ensureMounted(submit);
	      });else this._ensureMounted(submit);
	    }
	  }, {
	    key: '_mountDeepChat',
	    value: function _mountDeepChat() {
	      var _this10 = this;
	
	      if (!this._box || this._el) return;
	      var token = getAuthToken();
	      var el = document.createElement('deep-chat');
	
	      el.connect = {
	        url: TUTOR_URL,
	        method: 'POST',
	        stream: true,
	        headers: { Authorization: token }
	      };
	      el.requestInterceptor = function (req) {
	        // The answered-question context already embeds `context.item`; the "Explain my answer"
	        // event also carries a one-shot top-level item — same payload. Send it ONCE: when a
	        // pending top-level item exists, strip `item` from a CLONE of the context (never mutate
	        // the persistent this._ctx). Backend reads `body.item || body.context.item`, so either
	        // placement works; sidebar/typed asks (no top-level item) still ground via context.item.
	        var context = _this10._ctx;
	        if (_this10._pendingItem && context && context.item) {
	          context = Object.assign({}, context);
	          delete context.item;
	        }
	        req.body = Object.assign({}, req.body, {
	          context: context, sessionId: _this10._sid, tenantId: 'analystprep'
	        });
	        // one-shot item payload (e.g. "Explain my answer" → stem/chosen/correct/topic)
	        if (_this10._pendingItem) {
	          req.body.item = _this10._pendingItem;_this10._pendingItem = null;
	        }
	        return req;
	      };
	      el.responseInterceptor = function (resp) {
	        if (resp && resp.sessionId) _this10._sid = resp.sessionId;
	        // live "N left today" pill (final SSE event carries remaining; null = unlimited)
	        if (resp && resp.remaining !== undefined) _this10._updateUsage(resp.remaining, resp.period);
	        // Cap depleted → violet upsell card. Fires (a) on the final event of the turn that
	        // spent the last question (remaining === 0), (b) on a rejected attempt (limitReached).
	        // _updateUsage above has already cached period / re-armed the flag for this event.
	        if (resp && (resp.limitReached === true || resp.remaining === 0) && !_this10._upgradeShown) {
	          _this10._upgradeShown = true;
	          var upPeriod = resp.period || _this10._lastPeriod;
	          // defer past the answer bubble + the extras message (extras inject at ~80ms)
	          setTimeout(function () {
	            return _this10._injectUpgrade(_this10._lastLimit, upPeriod);
	          }, 160);
	        }
	        // final metadata event → render sources / follow-ups / study-next under the answer.
	        // defer so the AI bubble finishes streaming before we append the extras message.
	        if (resp && (resp.citations || resp.followups || resp.readmore || resp.messageId)) {
	          if (resp.messageId) _this10._lastMessageId = resp.messageId; // for feedback + escalation
	          var extras = {
	            citations: resp.citations || [],
	            followups: resp.followups || [],
	            readmore: resp.readmore || [],
	            messageId: resp.messageId || null
	          };
	          if (extras.citations.length || extras.followups.length || extras.readmore.length || extras.messageId) {
	            setTimeout(function () {
	              return _this10._injectExtras(extras);
	            }, 80);
	          }
	        }
	        // guardrail block → recoverable: offer a human handoff (Intercom) below the refusal bubble
	        if (resp && resp.recoverable) {
	          var q = resp.question || '';
	          setTimeout(function () {
	            return _this10._injectRecovery(q);
	          }, 90);
	        }
	        // metadata-only chunk (no text) → append nothing, avoid a blank bubble
	        if (resp && resp.text == null) return { text: '' };
	        return resp;
	      };
	      // wire clicks inside appended html messages (deep-chat sandboxes inline onclick)
	      // READ-NEXT cards without a real URL ask the tutor about the title on click.
	      // (Follow-ups are native deep-chat-suggestion-buttons; "Based on" links are plain <a>.)
	      el.htmlClassUtilities = {
	        'tutor-readmore': { events: { click: function click(e) {
	              var r = climbAttr(e.target, 'data-r');if (r) _this10.submitUserMessage({ text: r });
	            } } },
	        // recoverable-block card (Change 3): hand off to a human, prefilling Intercom with the blocked question
	        'tutor-escalate': { events: { click: function click(e) {
	              var q = climbAttr(e.currentTarget, 'data-q');_this10.escalateToHuman(q ? 'I asked the AI Tutor: "' + q + '" and it couldn\'t help. Can someone assist?' : 'I need help with a question the AI Tutor couldn\'t answer.');
	            } } },
	        'dc-fb-up': { events: { click: function click(e) {
	              return _this10._sendFeedback('up', e.currentTarget);
	            } } },
	        'dc-fb-down': { events: { click: function click(e) {
	              return _this10._sendFeedback('down', e.currentTarget);
	            } } },
	        'dc-upgrade-btn': {
	          events: {
	            click: function click(e) {
	              try {
	                e.preventDefault();
	              } catch (err) {/* keep going — worst case the href also navigates */}
	              addUnlimitedToCartAndGo();
	            }
	          }
	        }
	      };
	      // KaTeX via remarkable (NOT a `math` attribute); service emits $$…$$ display math.
	      el.remarkable = { html: true, typographer: true, math: true };
	      // themed bubbles / input / send button to match the violet AI-Tutor identity
	      el.messageStyles = {
	        default: {
	          ai: { bubble: { background: T.aiBubbleBg, color: T.aiBubbleText, border: '1px solid ' + T.aiBubbleBorder, borderRadius: '4px 15px 15px 15px', maxWidth: '96%' } },
	          user: { bubble: { background: T.userBubbleBg, color: '#fff', borderRadius: '15px 15px 4px 15px', maxWidth: '86%' } },
	          upgrade: { bubble: { background: 'none', border: 'none', padding: '0', maxWidth: '100%', width: '100%' } },
	          // 'extras' = Based on / READ NEXT / feedback. Same fill as the answer bubble, square
	          // top, no top border and a negative top margin so it overlaps and hides the answer
	          // bubble's rounded bottom — the two read as ONE block (design Widget_03).
	          extras: {
	            bubble: {
	              background: T.aiBubbleBg, color: T.aiBubbleText,
	              border: '1px solid ' + T.aiBubbleBorder, borderTop: 'none',
	              borderRadius: '0 0 15px 15px', width: '100%', maxWidth: '96%',
	              marginTop: '-11px', paddingTop: '2px'
	            }
	          },
	          // follow-ups live OUTSIDE the bubble, on the panel background
	          followups: { bubble: { background: 'none', border: 'none', padding: '0', width: '100%', maxWidth: '100%' } },
	          // recoverable-block card (Change 3) — frameless, full width, like the upgrade card
	          recovery: { bubble: { background: 'none', border: 'none', padding: '0', width: '100%', maxWidth: '100%' } }
	        }
	      };
	      el.textInput = {
	        // initial text only — capped state swaps it via attribute (see _applyComposerState)
	        placeholder: { text: INPUT_PLACEHOLDER, style: { color: T.footText } },
	        // taller composer to match the design (~52px): left inset + vertical padding on the textarea
	        styles: {
	          container: _defineProperty({ width: '100%', maxWidth: '350px', backgroundColor: T.inputBg, border: '1px solid ' + T.inputBorder, borderRadius: '13px', paddingLeft: '8px' }, 'backgroundColor', 'white'),
	          text: { color: T.aiBubbleText, fontSize: '14px', paddingTop: '16px', paddingRight: '53px', paddingBottom: '16px', lineHeight: '1.4' }
	        }
	      };
	      el.submitButtonStyles = {
	        // keep the button in the active "submit" look (violet bg + white icon) even when the
	        // input is empty — otherwise deep-chat renders the greyed "disabled" state (no bg).
	        alwaysEnabled: true,
	        submit: {
	          container: { default: { position: 'absolute', top: '0', bottom: '0', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 'auto', backgroundColor: T.accent, borderRadius: '10px' } },
	          // container: { default: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '7px', marginRight: '4px', padding: '7.5px', backgroundColor: T.accent, borderRadius: '10px' } },
	          // design send icon = white paper-plane (deep-chat's default is a different arrow).
	          // Explicit white stroke + xmlns so deep-chat renders it as-is (no filter needed).
	          svg: {
	            content: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" ' + 'fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + '<path d="M22 2 11 13"></path><path d="M22 2 15 22 11 13 2 9 22 2Z"></path></svg>',
	            styles: { default: { width: '18px', height: '18px' } }
	          }
	        },
	        // while the request is in flight deep-chat swaps to loading (dots) then stop (cancel).
	        // Keep both on the violet button with WHITE glyphs so it never renders as a blank square.
	        loading: {
	          // no width/height override — the dots indicator isn't square; constraining it squishes
	          // it off-centre. Let the flex container centre its natural size; just tint it white.
	          // container: { default: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '7px', marginRight: '4px', padding: '7.5px', backgroundColor: T.accent, borderRadius: '10px' } },
	          container: { default: { position: 'absolute', top: '0', bottom: '0', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 'auto', backgroundColor: T.accent, borderRadius: '10px' } },
	          svg: { styles: { default: { filter: 'brightness(0) invert(1)' } } }
	        },
	        stop: {
	          container: { default: { position: 'absolute', top: '0', bottom: '0', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 'auto', backgroundColor: T.accent, borderRadius: '10px' } },
	          // container: { default: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '7px', marginRight: '4px', padding: '7.5px', backgroundColor: T.accent, borderRadius: '10px' } },
	          svg: {
	            content: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#ffffff">' + '<rect x="6" y="6" width="12" height="12" rx="2"></rect></svg>',
	            styles: { default: { width: '14px', height: '14px' } }
	          }
	        }
	      };
	      // style the markdown rendered inside AI bubbles (headings were cramping together)
	      // + the V6 "Indigo" answer-tail classes from the approved spike design (shadow DOM —
	      // app-global CSS can't reach in; hover states need this, not inline styles)
	      el.auxiliaryStyle = 'h1,h2,h3,h4{line-height:1.3;margin:14px 0 6px;font-weight:800;color:' + T.aiBubbleText + '}' + 'h1{font-size:17px}h2{font-size:15px}h3{font-size:13.5px}h4{font-size:12.5px}' + 'p{margin:7px 0;line-height:1.55}' + 'ul,ol{margin:7px 0;padding-left:20px}li{margin:3px 0;line-height:1.5}' + 'hr{margin:12px 0;border:none;border-top:1px solid ' + T.aiBubbleBorder + '}' +
	      // --- long formulas / images must scroll INSIDE the bubble, never overflow it ---
	      'img{max-width:100%;height:auto;border-radius:8px;margin:6px 0;display:block}' + '.katex{max-width:100%}' +
	      // katex "display" wrapper variant (spike pattern)
	      '.katex-display{overflow-x:auto;overflow-y:hidden;max-width:100%;padding:4px 0;margin:6px 0}' + '.katex-display>.katex{white-space:nowrap}' +
	      // wrapper-less variant: display-math renders as the paragraph’s only child
	      // (<p><span class="katex"><math display="block">) — make that span the scroll container
	      'p>.katex:only-child{display:block;overflow-x:auto;overflow-y:hidden;max-width:100%;padding:4px 0}' +
	      // --- "Based on N sources" (minimised; hover/focus reveals the source popover) ---
	      '.dc-basedon{position:relative;display:inline-flex;margin-top:11px;outline:none}' + '.dc-basedon-sum{display:inline-flex;align-items:center;gap:5px;font-weight:600;font-size:0.66rem;color:#8a86a8;cursor:default}' + '.dc-basedon-sum strong{font-weight:700;color:#6a6684}' + '.dc-basedon-chev{transition:transform .16s ease}' +
	      // popover opens UPWARD: the extras message sits at the bottom of the scroller, so there
	      // is room above; opening downward would be clipped by the messages container.
	      '.dc-basedon-pop{position:absolute;bottom:calc(100% + 7px);left:0;z-index:5;min-width:230px;max-width:290px;background:#fff;border:1px solid #e6e1fb;border-radius:11px;box-shadow:0 10px 30px rgba(40,30,90,.18);padding:9px;opacity:0;visibility:hidden;transform:translateY(4px);transition:opacity .16s ease,transform .16s ease,visibility .16s}' + '.dc-basedon:hover .dc-basedon-pop,.dc-basedon:focus-within .dc-basedon-pop{opacity:1;visibility:visible;transform:translateY(0)}' + '.dc-basedon:hover .dc-basedon-chev,.dc-basedon:focus-within .dc-basedon-chev{transform:rotate(180deg)}' + '.dc-bo-hd{font-weight:800;font-size:0.56rem;letter-spacing:.1em;color:#a8a4c0;padding:2px 6px 7px}' + '.dc-bo-item{display:flex;align-items:center;gap:8px;width:100%;box-sizing:border-box;text-align:left;padding:7px 6px;border-radius:8px;text-decoration:none;color:inherit}' + 'a.dc-bo-item{cursor:pointer}' + 'a.dc-bo-item:hover{background:#f4f2fe}' + '.dc-bo-ic{width:22px;height:22px;flex:none;border-radius:6px;background:#ece9fd;color:#5b46e0;display:flex;align-items:center;justify-content:center}' +
	      // video sources get the same filled violet treatment as the READ NEXT play card
	      '.dc-bo-ic-play{background:linear-gradient(135deg,#6d4bff,#4a2fe0);color:#fff}' + '.dc-bo-ic svg{width:12px;height:12px;flex:none;display:block}' + '.dc-bo-lbl{flex:1;min-width:0;font-weight:600;font-size:0.72rem;line-height:1.35;color:#3a3557}' + '.dc-bo-go{flex:none;color:#8a86a8;font-weight:800;font-size:0.75rem}' +
	      // --- "READ NEXT" label + jump-to-source cards ---
	      '.dc-readnext-lbl{font-weight:800;font-size:0.62rem;letter-spacing:.11em;color:#8a86a8;margin:14px 0 1px}' + '.dc-srccards{display:flex;flex-direction:column;gap:8px;margin-top:6px}' + '.dc-srccard{display:flex;align-items:center;gap:11px;width:100%;box-sizing:border-box;text-align:left;text-decoration:none;color:inherit;padding:10px;border:1px solid #e2ddf8;border-radius:11px;background:#f6f4fe;cursor:pointer;font-family:' + T.font + '}' + '.dc-srccard:hover{border-color:#4a2fe0;background:#ece9fd}' + '.dc-srcicon{width:34px;height:34px;flex:none;border-radius:9px;background:#ece9fd;color:#4a2fe0;display:flex;align-items:center;justify-content:center}' + '.dc-srcicon-play{background:linear-gradient(135deg,#6d4bff,#4a2fe0);color:#fff}' + '.dc-srctext{flex:1;min-width:0}' + '.dc-srctitle{display:block;font-weight:700;font-size:0.78rem;color:#241f45;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' + '.dc-srcsub{display:block;font-weight:500;font-size:0.69rem;color:#7a7690;margin-top:1px}' + '.dc-srccta{flex:none;font-weight:700;font-size:0.72rem;color:#5b46e0}' +
	      // --- "SUGGESTED FOLLOW-UPS" (full-width native suggestion buttons; scoped so the
	      //     intro chips, which share the class, keep their own inline chip styling) ---
	      '.dc-followups{display:flex;flex-direction:column;gap:7px;margin-top:13px}' + '.dc-followups-lbl{font-weight:800;font-size:0.62rem;letter-spacing:.1em;color:#8a86a8;margin-bottom:1px}' + '.dc-followups .deep-chat-suggestion-button{display:block;width:100%;box-sizing:border-box;text-align:left;background:#f6f4fe;border:1px solid #e2ddf8;color:#4a2fe0;border-radius:11px;padding:11px 13px;font-size:0.8rem;font-weight:700;cursor:pointer;margin:0}' + '.dc-followups .deep-chat-suggestion-button:hover{background:#4a2fe0;color:#fff;border-color:#4a2fe0}' +
	      // --- "Was this helpful?" feedback row ---
	      '.dc-fbrow{display:flex;align-items:center;gap:8px;margin-top:13px;padding-top:11px;border-top:1px solid #e6e1fb}' + '.dc-fb-label{font-weight:600;font-size:0.69rem;color:#7a7690}' + '.dc-fb{width:34px;height:34px;flex:none;border-radius:8px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;border:1px solid #e2ddf8;background:transparent;color:#7a7690;-webkit-appearance:none;padding:0}' + '.dc-fb:hover{border-color:#4a2fe0;color:#4a2fe0}' +
	      // iOS Safari does NOT honour an <svg> width/height ATTRIBUTE inside a flex button the
	      // way Chrome/Android does — it shrink-wraps the icon to a few px. Pinning the size in
	      // CSS (plus flex:none) makes the thumbs identical on iPhone and Android.
	      '.dc-fb svg{width:17px;height:17px;flex:none;display:block;pointer-events:none}' +
	      // --- taller input composer to match the design (deep-chat's default is shorter) ---
	      '.text-input-container{min-height:48px;display:flex;align-items:center}' +
	      // composer panel on WHITE (background only — never touch #input's margin/padding/
	      // align-items: `margin-top:auto` pins it to the bottom and the default align-items
	      // stretch keeps deep-chat's button slots full-height)
	      '#input{background-color:' + T.panelBg + ' !important}' +
	      // kill every border deep-chat paints on its own containers/host
	      ':host,#chat-view,#messages,#input{border:none !important}' +
	      // --- capped composer (0 turns left): one dim over box + send button (see _setComposerCapped).
	      //     Button keeps pointer-events so the cursor shows; the capture guard kills the submit. ---
	      '#input.ap-capped{opacity:.55}' + '#input.ap-capped .submit-button{cursor:not-allowed}' +
	      // --- limit-reached upsell card ---
	      '.dc-upgrade{background:linear-gradient(135deg,#6d4bff,#4a2fe0);border-radius:14px;padding:14px 15px;color:#fff;font-family:' + T.font + '}' + '.dc-upgrade-title{font-weight:800;font-size:0.82rem}' + '.dc-upgrade-sub{font-weight:500;font-size:0.72rem;line-height:1.45;color:rgba(255,255,255,.85);margin-top:4px}' + '.dc-upgrade-sub b{color:#fff}' + '.dc-upgrade-row{display:flex;align-items:center;gap:10px;margin-top:11px;flex-wrap:wrap}' + '.dc-upgrade-btn{flex:none;background:#fff;color:#4a2fe0;font-weight:800;font-size:0.74rem;text-decoration:none;padding:8px 13px;border-radius:9px;cursor:pointer}' + '.dc-upgrade-btn:hover{background:#ece9fd}' + '.dc-upgrade-reset{font-weight:600;font-size:0.7rem;color:rgba(255,255,255,.85)}' +
	      // --- centre the "typing" loading dots (deep-chat ships asymmetric L/R padding,
	      //     1.3em vs .75em, which shoves the three dots off to the right) ---
	      '.deep-chat-loading-message-dots-container{padding-inline-start:.85em !important;padding-inline-end:.85em !important;width:.45em !important;box-sizing:content-box}';
	      // deep-chat re-applies its own `border:1px solid #cacaca` to the host on connect, which
	      // beats a plain inline value — `!important` is what actually removes the grey frame.
	      el.style.cssText = 'width:100%;height:100%;background-color:' + T.bodyBg + ';font-family:' + T.font;
	      el.style.setProperty('border', 'none', 'important');
	      el.innerHTML = introHTML(this._ctx);
	
	      this._box.appendChild(el);
	      this._el = el;
	      // flush a capped-on-open card that raced ahead of the mount (see _fetchUsage)
	      if (this._pendingUpgradeCard) {
	        this._pendingUpgradeCard = false;
	        setTimeout(function () {
	          return _this10._injectUpgrade(_this10._lastLimit, _this10._lastPeriod);
	        }, 250);
	      }
	      // fresh shadow DOM = no guard; usage may already have resolved as capped before this mount
	      this._composerGuard = null;
	      this._composerTries = 0;
	      this._applyComposerState();
	    }
	  }, {
	    key: 'submitUserMessage',
	    value: function submitUserMessage(payload) {
	      if (this._el) this._el.submitUserMessage(payload);
	    }
	    // append the sources / follow-ups / study-next card after an answer
	
	  }, {
	    key: '_injectExtras',
	    value: function _injectExtras(extras) {
	      if (!this._el || !this._el.addMessage) return;
	      // 1) grounding + actions — glued to the answer bubble (role 'extras')
	      var hasAnswerExtras = extras.citations && extras.citations.length || extras.readmore && extras.readmore.length || extras.messageId;
	      if (hasAnswerExtras) {
	        try {
	          this._el.addMessage({ html: answerExtrasHTML(extras), role: 'extras' });
	        } catch (e) {}
	      }
	      // 2) follow-ups — separate frameless block below the bubble
	      if (extras.followups && extras.followups.length) {
	        try {
	          this._el.addMessage({ html: extrasHTML(extras), role: 'followups' });
	        } catch (e) {}
	      }
	    }
	    // append the limit-reached upsell card (custom 'upgrade' role = frameless bubble)
	
	  }, {
	    key: '_injectUpgrade',
	    value: function _injectUpgrade(limit, period) {
	      if (this._el && this._el.addMessage) {
	        try {
	          this._el.addMessage({ html: upgradeHTML(limit, period), role: 'upgrade' });
	        } catch (e) {}
	      }
	    }
	    // append the recoverable-block card (Change 3) — human handoff after a guardrail refusal
	
	  }, {
	    key: '_injectRecovery',
	    value: function _injectRecovery(question) {
	      if (this._el && this._el.addMessage) {
	        try {
	          this._el.addMessage({ html: recoveryHTML(question), role: 'recovery' });
	        } catch (e) {}
	      }
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(ctx) {
	      this._ctx = ctx || {};
	    }
	    // POST 👍/👎 to /tutor/feedback for the answer row carried on the clicked row (data-mid).
	    // Visual ack: the chosen thumb fills indigo, the other dims (spike behavior).
	
	  }, {
	    key: '_sendFeedback',
	    value: function _sendFeedback(rating, btn) {
	      var mid = climbAttr(btn, 'data-mid');
	      if (!mid) return;
	      try {
	        fetch(TUTOR_BASE + '/tutor/feedback', {
	          method: 'POST',
	          headers: { 'Content-Type': 'application/json', Authorization: getAuthToken() },
	          body: JSON.stringify({ messageId: mid, rating: rating })
	        }).catch(function () {/* best-effort */});
	      } catch (e) {/* noop */}
	      try {
	        var row = btn.parentNode;
	        if (row) {
	          var thumbs = row.querySelectorAll('.dc-fb');
	          for (var i = 0; i < thumbs.length; i++) {
	            thumbs[i].style.opacity = '0.35';
	          }
	        }
	        btn.style.opacity = '1';
	        btn.style.background = T.accent;
	        btn.style.borderColor = T.accent;
	        btn.style.color = '#fff';
	      } catch (e) {/* noop */}
	    }
	  }, {
	    key: 'escalateToHuman',
	    value: function escalateToHuman(summary) {
	      // mark the last answer as escalated (best-effort analytics), then open Intercom
	      if (this._lastMessageId) {
	        try {
	          fetch(TUTOR_BASE + '/tutor/feedback', {
	            method: 'POST',
	            headers: { 'Content-Type': 'application/json', Authorization: getAuthToken() },
	            body: JSON.stringify({ messageId: this._lastMessageId, escalated: true })
	          }).catch(function () {/* best-effort */});
	        } catch (e) {/* noop */}
	      }
	      if (window.Intercom) window.Intercom('showNewMessage', summary || '');
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_, n) {
	      return n.enabled !== this.state.enabled || n.open !== this.state.open || n.notice !== this.state.notice || n.killed !== this.state.killed;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      if (!this.state.enabled) return null;
	      if (this.state.killed) return null; // admin kill-switch → no panel at all
	      var open = this.state.open;
	
	      // Persisted drag offset, applied inline so a moved panel never flashes at its
	      // default spot before _settleDragPos() runs. Never offset the mobile sheet.
	      var dp = this._dragPos;
	      var dragTransform = !isMobileViewport() && (dp.x || dp.y) ? 'translate(' + dp.x + 'px,' + dp.y + 'px)' : undefined;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ap-tutor-panel', ref: this._setPanelRef, style: {
	            // Desktop: anchored top-right, capped height with a ≥96px bottom gap so the panel never
	            // covers the bottom-right Intercom bubble. Mobile: the media query below makes it a
	            // near-full-screen sheet (Intercom is hidden/dimmed there).
	            position: 'fixed', top: 72, right: 16, width: 384, maxWidth: 'calc(100vw - 32px)',
	            height: 'calc(100vh - 168px)', maxHeight: 760,
	            background: T.panelBg, boxShadow: '0 14px 44px rgba(20,30,80,.20)', zIndex: 1100,
	            borderTopLeftRadius: '16',
	            borderTopRightRadius: '16',
	            overflow: 'hidden',
	            display: open ? 'flex' : 'none', flexDirection: 'column', fontFamily: T.font,
	            transform: dragTransform
	          } },
	        _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html:
	            // touch-action:none — a touch gesture starting on the header must never pan/scroll
	            // the page behind the panel (on mobile the panel isn't draggable, so the header is
	            // simply inert; on touch tablets it lets our own drag handler own the gesture).
	            '.ap-tutor-grab{cursor:grab;user-select:none;-webkit-user-select:none;touch-action:none;}' +
	            // mobile: full-height sheet, NOT draggable — reset any persisted desktop offset
	            '@media (max-width:574.98px){.ap-tutor-panel{top:8px !important;right:8px !important;left:8px !important;width:auto !important;height:auto !important;bottom:8px !important;max-height:none !important;border-radius:14px !important;transform:none !important;}' + '.ap-tutor-grab{cursor:default;}}' } }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: this._setDragHandleRef,
	            className: 'ap-tutor-grab',
	            onMouseDown: this._onDragStart,
	            onTouchStart: this._onDragStart,
	            style: { flex: 'none', background: T.headerBg, padding: '15px 16px 13px', color: '#fff' }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', alignItems: 'center', gap: 9 } },
	            _react2.default.createElement(
	              'span',
	              { style: { width: 26, height: 26, borderRadius: 8, background: 'rgba(255,255,255,.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flex: 'none' } },
	              '\u2726'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { font: '800 15px ' + T.font } },
	              'AnalystPrep AI Tutor'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { font: '800 10px ' + T.font, letterSpacing: '.1em', background: '#fff', color: T.headerBadge, padding: '2px 7px', borderRadius: 20 } },
	              'AI'
	            ),
	            _react2.default.createElement(
	              'button',
	              { 'data-no-drag': '1', onClick: function onClick() {
	                  return _this11.setState({ open: false });
	                }, style: { marginLeft: 'auto', border: 'none', background: 'rgba(255,255,255,.18)', color: '#fff', width: 24, height: 24, borderRadius: 7, cursor: 'pointer', fontSize: 13, fontWeight: 900, lineHeight: '1' } },
	              '\u2715'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: 7, font: '500 11px ' + T.font, color: 'rgba(255,255,255,.85)', lineHeight: 1.4 } },
	            'AI-generated from AnalystPrep\u2019s CFA curriculum \xB7 cites sources \xB7 says when unsure.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { flex: 'none', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: T.subBarBg, borderBottom: '1px solid ' + T.subBarBorder } },
	          _react2.default.createElement(
	            'span',
	            { style: { display: 'inline-flex', alignItems: 'center', gap: 7, minWidth: 0, flex: 1, font: '600 11.5px ' + T.font, color: T.ctxText } },
	            _react2.default.createElement('span', { style: { width: 7, height: 7, borderRadius: '50%', background: T.accent, flex: 'none' } }),
	            _react2.default.createElement('span', { ref: function ref(el) {
	                _this11._ctxLabelRef = el;if (el) el.textContent = _this11._ctxText();
	              }, style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } })
	          ),
	          !this.state.notice && _react2.default.createElement('span', {
	            ref: function ref(el) {
	              _this11._usageRef = el;
	            },
	            title: 'Questions left today',
	            style: { display: 'none', flex: 'none', alignItems: 'center', gap: 4, font: '700 11px ' + T.font, color: T.accent, background: T.accentSoft, padding: '5px 11px', borderRadius: 20, whiteSpace: 'nowrap' }
	          })
	        ),
	        this.state.notice ? _react2.default.createElement(
	          'div',
	          { style: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '24px 22px', background: T.bodyBg } },
	          _react2.default.createElement(
	            'span',
	            { style: { width: 46, height: 46, borderRadius: 12, background: T.accentSoft, color: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, marginBottom: 12 } },
	            '\u2726'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { font: '800 14px ' + T.font, color: T.aiBubbleText, marginBottom: 6 } },
	            'AI Tutor isn\u2019t available yet'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { font: '500 12.5px ' + T.font, color: T.subText, lineHeight: 1.5, maxWidth: 260 } },
	            this.state.notice === 'disabled' ? 'The AI tutor is currently unavailable. Please check back later.' : this.state.notice === 'load' ? 'The tutor couldn’t load. Please refresh the page and try again.' : this.state.notice === 'backend' ? 'The AI Tutor service isn’t reachable right now — it may be down or missing its keys. Please try again in a moment.' : 'The AI Tutor isn’t configured in this environment yet (missing keys/config). Please try again later or contact support.'
	          ),
	          this.state.notice !== 'config' && _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                return _this11.setState({ notice: null }, function () {
	                  _this11._ensureMounted();_this11._fetchUsage();
	                });
	              },
	              style: { marginTop: 14, padding: '8px 16px', border: '1px solid ' + T.chipBorder, borderRadius: 10, background: T.chipBg, color: T.chipText, font: '700 12.5px ' + T.font, cursor: 'pointer' }
	            },
	            'Try again'
	          )
	        ) : null,
	        _react2.default.createElement('div', { ref: this._setRef, style: { flex: 1, minHeight: 0, display: this.state.notice ? 'none' : 'flex', background: T.bodyBg } }),
	        _react2.default.createElement(
	          'div',
	          { style: { flex: 'none', display: 'flex', alignItems: 'center', gap: 4, padding: '0px 12px 12px', background: T.panelBg } },
	          _react2.default.createElement(
	            'span',
	            { style: { font: '500 11px ' + T.font, color: T.footText, lineHeight: 1.3 } },
	            'AI can make mistakes \u2014 verify with the reading.'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this11.escalateToHuman('I’d like to talk to a human about this.');
	              }, style: { marginLeft: 'auto', border: 'none', padding: 0, background: 'none', font: '700 11.5px ' + T.font, color: T.accent, cursor: 'pointer', whiteSpace: 'nowrap' } },
	            'Talk to human \u2192'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AITutorChat;
	}(_react.Component);
	
	exports.default = AITutorChat;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(102);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Mounts Stripe's Express Checkout Element (Apple Pay + Google Pay + Link).
	// React 15 class component — imperative mount because @stripe/react-stripe-js
	// requires React >= 16.8 (we are on 15.6.2). Coexists on the same page as the
	// legacy react-stripe-elements@6 card form (StripeCheckoutForm.js); both share
	// Stripe's global window.Stripe so only one Stripe.js bundle is loaded.
	//
	// Active checkout page: frontend/src/views/Cart/Checkout.js (mounted from
	// routes.js line ~790 at path /checkout).
	//
	// Props:
	//   stripeInstance    object  A ready Stripe instance (window.Stripe(key)),
	//                             passed down from Checkout.js this.state.stripe.
	//                             The wallet reuses the same instance the card form
	//                             already created — no second instance, no loader.
	//   amount            int     amount in cents
	//   currency          string  e.g. 'usd'
	//   userCart          array   same shape sent to /createOrder
	//   paymentInterval   string|null  null for one-time; otherwise subscription
	//   customerEmail     string  used for Link pre-fill
	//   apiBaseUrl        string  e.g. https://api.app.analystprep.com (prefix
	//                             prepended to /api/checkout_v1/...)
	//   authHeader        string  Authorization header value used by other
	//                             checkout calls in the parent component
	//   onSuccess(orderId)
	//   onError(err)
	
	// Single source of truth for the wallet-button visibility kill switch.
	// Flip to false and redeploy frontend to remove all wallet UI without
	// touching backend code. The card form remains the only visible payment option.
	var WALLET_BUTTONS_ENABLED = true;
	
	var ExpressCheckoutWallets = function (_Component) {
	  _inherits(ExpressCheckoutWallets, _Component);
	
	  function ExpressCheckoutWallets(props) {
	    _classCallCheck(this, ExpressCheckoutWallets);
	
	    var _this = _possibleConstructorReturn(this, (ExpressCheckoutWallets.__proto__ || Object.getPrototypeOf(ExpressCheckoutWallets)).call(this, props));
	
	    _this.state = { available: null, error: null };
	    _this._mountRef = null;
	    _this._stripe = null;
	    _this._elements = null;
	    _this._element = null;
	    _this._destroyed = false;
	    _this._handleConfirm = _this._handleConfirm.bind(_this);
	    _this._setMountRef = _this._setMountRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpressCheckoutWallets, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!WALLET_BUTTONS_ENABLED) return;
	      // if (isLocalhost) return; // mock buttons only — skip Stripe init
	      this._init();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // The cart total can change after mount (coupon applied/removed, item
	      // edited). Stripe's deferred Elements need elements.update({ amount })
	      // so the wallet sheet shows the correct total — otherwise it pays the
	      // stale amount. Only update for a positive integer amount.
	      if (!this._elements) return;
	      var amt = this.props.amount;
	      if (amt !== prevProps.amount && typeof amt === 'number' && amt > 0) {
	        try {
	          this._elements.update({ amount: amt });
	        } catch (e) {
	          console.warn('ExpressCheckoutWallets: elements.update(amount) failed', e && e.message);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyed = true;
	      try {
	        if (this._element && typeof this._element.destroy === 'function') {
	          this._element.destroy();
	        }
	      } catch (e) {
	        // ignore — element may already be unmounted
	      }
	    }
	  }, {
	    key: '_init',
	    value: function _init() {
	      var self = this;
	      // Reuse the ready Stripe instance the checkout page already created
	      // (Checkout.js this.state.stripe). The wallet only renders inside the
	      // `stripe ? <StripeProvider stripe={stripe}>` block, so the instance is
	      // guaranteed present here — no async load, no second instance.
	      var stripe = this.props.stripeInstance;
	      if (this._destroyed || !stripe) {
	        if (!stripe) {
	          console.warn('ExpressCheckoutWallets: no stripeInstance prop — skipping mount');
	        }
	        return;
	      }
	      // Stripe's elements({ amount }) throws if amount <= 0. The parent gates
	      // rendering on a positive amount, but guard here too in case this mounts
	      // before the cart total is known.
	      var amount = this.props.amount;
	      if (typeof amount !== 'number' || !(amount > 0)) {
	        console.warn('ExpressCheckoutWallets: amount not positive yet — skipping mount', amount);
	        return;
	      }
	      try {
	        self._stripe = stripe;
	
	        var isSubscription = !!self.props.paymentInterval;
	        var elements = stripe.elements({
	          mode: isSubscription ? 'subscription' : 'payment',
	          amount: self.props.amount,
	          currency: (self.props.currency || 'usd').toLowerCase(),
	          paymentMethodCreation: 'manual'
	        });
	        self._elements = elements;
	
	        // `paymentMethods` is the current option (replaces the deprecated
	        // `wallets`). applePay/googlePay accept 'always' | 'auto' | 'never';
	        // link accepts 'auto' | 'never' (no 'always'). 'auto' lets Link surface
	        // when the account has it enabled and the buyer is eligible.
	        var ece = elements.create('expressCheckout', {
	          buttonType: { applePay: 'buy', googlePay: 'buy' },
	          paymentMethods: {
	            applePay: 'always',
	            googlePay: 'always',
	            link: 'auto'
	          }
	        });
	        self._element = ece;
	
	        ece.on('ready', function (e) {
	          if (self._destroyed) return;
	          var apm = e && e.availablePaymentMethods;
	          var any = apm && (apm.applePay || apm.googlePay || apm.link);
	          self.setState({ available: !!any });
	        });
	
	        ece.on('confirm', self._handleConfirm);
	
	        if (self._mountRef) {
	          ece.mount(self._mountRef);
	        }
	      } catch (err) {
	        console.error('ExpressCheckoutWallets mount failed', err);
	        self.setState({ error: err && err.message || 'Wallet load failed' });
	      }
	    }
	  }, {
	    key: '_handleConfirm',
	    value: function _handleConfirm(event) {
	      var self = this;
	      var p = self.props;
	      var apiBase = p.apiBaseUrl || '';
	
	      (function run() {
	        return self._elements.submit().then(function (submitRes) {
	          if (submitRes && submitRes.error) throw submitRes.error;
	
	          return self._stripe.createPaymentMethod({
	            elements: self._elements,
	            params: { billing_details: { email: p.customerEmail } }
	          });
	        }).then(function (pmRes) {
	          if (pmRes.error || !pmRes.paymentMethod) {
	            throw pmRes.error || new Error('PaymentMethod creation failed');
	          }
	          var pm = pmRes.paymentMethod;
	          var walletType = pm && pm.card && pm.card.wallet && pm.card.wallet.type || event && event.expressPaymentType || null;
	
	          var body = {
	            payment_type: 'stripe',
	            amount: p.amount / 100,
	            userCart: p.userCart,
	            paymentInterval: p.paymentInterval || null,
	            paymentMethodId: pm.id,
	            walletType: walletType
	          };
	          var headers = { Authorization: p.authHeader || '' };
	
	          return _axios2.default.post(apiBase + '/checkout_v1/createOrder', body, { headers: headers }).then(function (resp) {
	            return resp.data;
	          });
	        }).then(function (data) {
	          // Backend (createOrder) success shape: { success: true, order_id, ... }
	          // — matches the existing card/PayPal contract. Synchronous success
	          // (no SCA): fulfilled inline, order_id returned.
	          if (data && data.success && data.order_id) {
	            // Express Checkout Element has no event.complete() — on success we
	            // just navigate away via onSuccess.
	            if (p.onSuccess) p.onSuccess(data.order_id);
	            return null;
	          }
	          // SCA required: backend returns { requiresAction, clientSecret } and
	          // has NOT fulfilled — clear the challenge then call finalizeWalletOrder.
	          if (data && data.requiresAction && data.clientSecret) {
	            return self._stripe.confirmPayment({
	              clientSecret: data.clientSecret,
	              redirect: 'if_required'
	            }).then(function (cp) {
	              if (cp && cp.error) throw cp.error;
	              var pi = cp && cp.paymentIntent;
	              if (!pi || pi.status !== 'succeeded') {
	                throw new Error('Payment authentication did not complete');
	              }
	              var headers = { Authorization: p.authHeader || '' };
	              return _axios2.default.post(apiBase + '/checkout_v1/finalizeWalletOrder', {
	                paymentIntentId: pi.id,
	                userCart: p.userCart,
	                paymentInterval: p.paymentInterval || null
	              }, { headers: headers }).then(function (resp) {
	                return resp.data;
	              });
	            }).then(function (finalizeData) {
	              // finalizeWalletOrder returns the same { success: true, order_id } shape.
	              if (finalizeData && finalizeData.success && finalizeData.order_id) {
	                if (p.onSuccess) p.onSuccess(finalizeData.order_id);
	                return null;
	              }
	              throw new Error('Finalize failed');
	            });
	          }
	          throw new Error(data && data.message || 'Unexpected response from createOrder');
	        }).catch(function (err) {
	          console.error('Wallet confirm flow failed', err);
	          // Express Checkout Element: signal failure so the button resets.
	          try {
	            event.paymentFailed({ reason: 'fail' });
	          } catch (e) {}
	          if (p.onError) p.onError(err);
	        });
	      })();
	    }
	  }, {
	    key: '_setMountRef',
	    value: function _setMountRef(el) {
	      this._mountRef = el;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!WALLET_BUTTONS_ENABLED) return null;
	
	      if (_CommonUtils.isLocalhost) {
	        var btn = function btn(bg, color, label, key) {
	          return _react2.default.createElement(
	            'button',
	            {
	              key: key,
	              type: 'button',
	              style: {
	                display: 'block',
	                width: '100%',
	                height: 44,
	                margin: '0 0 8px 0',
	                border: 'none',
	                borderRadius: 6,
	                background: bg,
	                color: color,
	                fontSize: 16,
	                fontWeight: 600,
	                cursor: 'pointer',
	                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
	              },
	              onClick: function onClick(e) {
	                e.preventDefault();console.info('[isLocalhost] mock button clicked — no real flow:', label);
	              }
	            },
	            label
	          );
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'chk_wallet_row chk_wallet_row__loading', style: { margin: '0 0 16px 0' } },
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: 11, color: '#999', textAlign: 'center', margin: '0 0 8px 0' } },
	            'DEV PREVIEW \u2014 these buttons are visual mocks only'
	          ),
	          btn('#000', '#fff', ' Pay', 'apple'),
	          btn('#1a73e8', '#fff', 'Buy with G Pay', 'google'),
	          btn('#00d66f', '#011e0f', 'Pay with Link', 'link')
	        );
	      }
	
	      if (this.state.available === false) return null;
	
	      var loading = this.state.available === null;
	      return _react2.default.createElement(
	        'div',
	        { className: "chk_wallet_row " + (loading ? "chk_wallet_row__loading" : "") },
	        _react2.default.createElement('div', { ref: this._setMountRef })
	      );
	    }
	  }]);
	
	  return ExpressCheckoutWallets;
	}(_react.Component);
	
	exports.default = ExpressCheckoutWallets;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	/**
	 * PayPal Smart Button (Orders v2) — React 15 compatible.
	 *
	 * Loads PayPal's JS SDK via a <script> tag (the same pattern Checkout.js uses
	 * for Stripe.js v3) and renders paypal.Buttons() imperatively into a div
	 * ref. We avoid @paypal/react-paypal-js because it requires React ≥ 16.8.
	 *
	 * Flow:
	 *   1. Mount → load https://www.paypal.com/sdk/js?client-id=...&currency=USD
	 *   2. SDK ready → call paypal.Buttons({ createOrder, onApprove, ... }).render()
	 *   3. User clicks → createOrder hits our /paypalCreateOrder, returns paypalOrderId
	 *   4. PayPal popup → user approves
	 *   5. onApprove → hits our /paypalCaptureOrder, parent routes to Thank You
	 *
	 * Props:
	 *   paypalClientId  (string)   PayPal Client ID from /getPaymentCred
	 *   paypalEnv       (string)   'sandbox' | 'live' — informational; the SDK
	 *                              picks sandbox/live by Client ID automatically.
	 *   getCart         (function) Returns { userCart, amount, idname } — called
	 *                              at click-time so values reflect current state.
	 *   onSuccess       (function) Called with { order_id } after capture.
	 *   onError         (function) Called with a human-readable message.
	 *   disabled        (boolean)  Skip rendering (e.g. amount = 0).
	 */
	var PayPalButton = function (_Component) {
	  _inherits(PayPalButton, _Component);
	
	  function PayPalButton(props) {
	    _classCallCheck(this, PayPalButton);
	
	    var _this = _possibleConstructorReturn(this, (PayPalButton.__proto__ || Object.getPrototypeOf(PayPalButton)).call(this, props));
	
	    _this.state = {
	      sdkReady: false,
	      sdkError: false,
	      rendering: false
	    };
	    _this.containerRef = null;
	    _this.setContainerRef = function (el) {
	      _this.containerRef = el;
	    };
	    _this.handleScriptLoaded = _this.handleScriptLoaded.bind(_this);
	    _this.handleScriptError = _this.handleScriptError.bind(_this);
	    return _this;
	  }
	
	  _createClass(PayPalButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadSdk();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevState.sdkReady && this.state.sdkReady && !this.state.rendering) {
	        this.renderButtons();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this._sdkScript && this._sdkScript.parentNode) {
	        this._sdkScript.removeEventListener("load", this.handleScriptLoaded);
	        this._sdkScript.removeEventListener("error", this.handleScriptError);
	      }
	      if (this.containerRef) {
	        // The PayPal SDK doesn't expose a teardown — clearing the host div is
	        // the documented escape hatch. Prevents orphan iframes / event handlers
	        // when the user re-mounts (e.g. toggling payment method).
	        this.containerRef.innerHTML = "";
	      }
	    }
	  }, {
	    key: "loadSdk",
	    value: function loadSdk() {
	      if (!this.props.paypalClientId) {
	        this.setState({ sdkError: true });
	        return;
	      }
	      if (window.paypal && window.paypal.Buttons) {
	        this.setState({ sdkReady: true });
	        return;
	      }
	      var existing = document.querySelector('script[data-paypal-sdk="1"]');
	      if (existing) {
	        // Another instance started the load — piggy-back.
	        existing.addEventListener("load", this.handleScriptLoaded);
	        existing.addEventListener("error", this.handleScriptError);
	        this._sdkScript = existing;
	        return;
	      }
	      var script = document.createElement("script");
	      var params = ["client-id=" + encodeURIComponent(this.props.paypalClientId), "currency=USD", "intent=capture", "components=buttons",
	      // Pay Later messaging will surface automatically for eligible buyers.
	      "enable-funding=paylater",
	      // Suppress the secondary "Debit or Credit Card" PayPal button — that
	      // funding source duplicates our own Stripe card form above.
	      "disable-funding=card"].join("&");
	      script.src = "https://www.paypal.com/sdk/js?" + params;
	      script.async = true;
	      script.dataset.paypalSdk = "1";
	      script.addEventListener("load", this.handleScriptLoaded);
	      script.addEventListener("error", this.handleScriptError);
	      document.body.appendChild(script);
	      this._sdkScript = script;
	    }
	  }, {
	    key: "handleScriptLoaded",
	    value: function handleScriptLoaded() {
	      if (window.paypal && window.paypal.Buttons) {
	        this.setState({ sdkReady: true });
	      } else {
	        this.setState({ sdkError: true });
	      }
	    }
	  }, {
	    key: "handleScriptError",
	    value: function handleScriptError() {
	      this.setState({ sdkError: true });
	    }
	  }, {
	    key: "renderButtons",
	    value: function renderButtons() {
	      var _this2 = this;
	
	      if (!window.paypal || !window.paypal.Buttons || !this.containerRef) return;
	      this.setState({ rendering: true });
	
	      var buttons = window.paypal.Buttons({
	        style: {
	          layout: "vertical",
	          color: "gold",
	          shape: "rect",
	          label: "paypal"
	        },
	
	        createOrder: function () {
	          var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var ctx, payload, resp, msg;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    _context.prev = 0;
	                    ctx = typeof _this2.props.getCart === "function" ? _this2.props.getCart() || {} : {};
	                    payload = {
	                      userCart: ctx.userCart || [],
	                      amount: ctx.amount || 0,
	                      idname: ctx.idname || ""
	                    };
	                    _context.next = 5;
	                    return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/paypalCreateOrder", payload);
	
	                  case 5:
	                    resp = _context.sent;
	
	                    if (!(resp && resp.success && resp.paypalOrderId)) {
	                      _context.next = 8;
	                      break;
	                    }
	
	                    return _context.abrupt("return", resp.paypalOrderId);
	
	                  case 8:
	                    msg = resp && resp.message || "Could not start PayPal checkout.";
	
	                    if (_this2.props.onError) _this2.props.onError(msg);
	                    throw new Error(msg);
	
	                  case 13:
	                    _context.prev = 13;
	                    _context.t0 = _context["catch"](0);
	
	                    if (_this2.props.onError) {
	                      _this2.props.onError(_context.t0 && _context.t0.message || "PayPal initialisation failed.");
	                    }
	                    throw _context.t0;
	
	                  case 17:
	                  case "end":
	                    return _context.stop();
	                }
	              }
	            }, _callee, _this2, [[0, 13]]);
	          }));
	
	          function createOrder() {
	            return _ref.apply(this, arguments);
	          }
	
	          return createOrder;
	        }(),
	
	        onApprove: function () {
	          var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	            var ctx, payload, resp, orderId, msg;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    _context2.prev = 0;
	                    ctx = typeof _this2.props.getCart === "function" ? _this2.props.getCart() || {} : {};
	                    payload = {
	                      paypalOrderId: data.orderID,
	                      userCart: ctx.userCart || [],
	                      amount: ctx.amount || 0,
	                      idname: ctx.idname || ""
	                    };
	                    _context2.next = 5;
	                    return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/paypalCaptureOrder", payload);
	
	                  case 5:
	                    resp = _context2.sent;
	
	                    if (resp && resp.success) {
	                      orderId = resp.order_id || resp.orders && resp.orders.id;
	
	                      if (_this2.props.onSuccess) _this2.props.onSuccess({ order_id: orderId });
	                    } else {
	                      msg = resp && resp.message || "PayPal payment could not be finalised.";
	
	                      if (_this2.props.onError) _this2.props.onError(msg);
	                    }
	                    _context2.next = 12;
	                    break;
	
	                  case 9:
	                    _context2.prev = 9;
	                    _context2.t0 = _context2["catch"](0);
	
	                    if (_this2.props.onError) {
	                      _this2.props.onError(_context2.t0 && _context2.t0.message || "PayPal capture failed.");
	                    }
	
	                  case 12:
	                  case "end":
	                    return _context2.stop();
	                }
	              }
	            }, _callee2, _this2, [[0, 9]]);
	          }));
	
	          function onApprove(_x) {
	            return _ref2.apply(this, arguments);
	          }
	
	          return onApprove;
	        }(),
	
	        onError: function onError(err) {
	          // Fires for SDK-level errors before our createOrder/onApprove run.
	          if (_this2.props.onError) {
	            _this2.props.onError(err && err.message || "PayPal error.");
	          }
	        },
	
	        onCancel: function onCancel() {
	          // User closed the PayPal popup. Not an error — just re-enable parent state.
	          if (_this2.props.onCancel) _this2.props.onCancel();
	        }
	      });
	
	      if (buttons.isEligible && !buttons.isEligible()) {
	        this.setState({ sdkError: true });
	        return;
	      }
	      buttons.render(this.containerRef).catch(function () {
	        _this2.setState({ sdkError: true });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.props.disabled) return null;
	
	      if (this.state.sdkError) {
	        return _react2.default.createElement(
	          "div",
	          { className: "chk_paypal_error" },
	          "PayPal isn't available right now. Please refresh or use a credit card."
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "chk_paypal_wrapper" },
	        _react2.default.createElement("div", { ref: this.setContainerRef, className: "chk_paypal_buttons" }),
	        !this.state.sdkReady && _react2.default.createElement(
	          "div",
	          { className: "chk_paypal_loading" },
	          "Loading PayPal\u2026"
	        )
	      );
	    }
	  }]);
	
	  return PayPalButton;
	}(_react.Component);
	
	exports.default = PayPalButton;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(479);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var stripeElementStyle = {
	    base: {
	        fontSize: '16px',
	        color: '#333',
	        lineHeight: '40px',
	        '::placeholder': {
	            color: '#aab7c4'
	        }
	    },
	    invalid: {
	        color: '#e74c3c'
	    }
	};
	
	var StripeCheckoutForm = function (_Component) {
	    _inherits(StripeCheckoutForm, _Component);
	
	    function StripeCheckoutForm(props) {
	        _classCallCheck(this, StripeCheckoutForm);
	
	        var _this = _possibleConstructorReturn(this, (StripeCheckoutForm.__proto__ || Object.getPrototypeOf(StripeCheckoutForm)).call(this, props));
	
	        _this.state = {
	            nameOnCard: _CommonUtils.isLocalhost ? 't' : '',
	            postalCode: _CommonUtils.isLocalhost ? '07400' : '',
	            addressLine1: _CommonUtils.isLocalhost ? 'Hrushevskoho Street, 23, apartment 84' : '',
	            city: ''
	        };
	
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(StripeCheckoutForm, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            if (this.props.onRef) {
	                this.props.onRef(this);
	            }
	            // Stripe injects unlabelled <iframe> elements (Link autofill buttons)
	            // for Card Number / Expiry / CVC. They have no `title`, which fails
	            // WCAG 4.1.2. We can't pass disableLink through react-stripe-elements,
	            // so observe the DOM and label them once they appear.
	            this._titleStripeIframes = function () {
	                var iframes = document.querySelectorAll('div.StripeElement iframe[name^="cardNumberButton"], ' + 'div.StripeElement iframe[name^="cardExpiryButton"], ' + 'div.StripeElement iframe[name^="cardCvcButton"]');
	                iframes.forEach(function (f) {
	                    if (f.getAttribute('title')) return;
	                    if (f.name.indexOf('cardNumberButton') === 0) f.setAttribute('title', 'Stripe Link autofill — card number');else if (f.name.indexOf('cardExpiryButton') === 0) f.setAttribute('title', 'Stripe Link autofill — expiry date');else if (f.name.indexOf('cardCvcButton') === 0) f.setAttribute('title', 'Stripe Link autofill — CVC');
	                });
	            };
	            this._stripeIframeObserver = new MutationObserver(this._titleStripeIframes);
	            this._stripeIframeObserver.observe(document.body, { childList: true, subtree: true });
	            this._titleStripeIframes();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this.props.onRef) {
	                this.props.onRef(null);
	            }
	            if (this._stripeIframeObserver) {
	                this._stripeIframeObserver.disconnect();
	                this._stripeIframeObserver = null;
	            }
	        }
	    }, {
	        key: "handleInputChange",
	        value: function handleInputChange(e) {
	            this.setState(_defineProperty({}, e.target.name, e.target.value));
	        }
	    }, {
	        key: "handleSubmit",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var nameOnCard, postalCode, addressLine1, city, tokenParams, result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                nameOnCard = this.state.nameOnCard.trim();
	                                postalCode = this.state.postalCode.trim();
	                                addressLine1 = this.state.addressLine1.trim();
	                                city = this.state.city.trim();
	
	                                if (nameOnCard) {
	                                    _context.next = 6;
	                                    break;
	                                }
	
	                                return _context.abrupt("return", { error: { message: "Please enter the name on your card." } });
	
	                            case 6:
	                                if (postalCode) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                return _context.abrupt("return", { error: { message: "Please enter your billing postal/ZIP code." } });
	
	                            case 8:
	                                // Billing address fields are forwarded to Stripe to drive AVS checks
	                                // (`address_postal_code_check`, `address_line1_check`) which improve
	                                // issuer approval rates for cross-border CNP. None of these are
	                                // stored in our DB — they live on Stripe's PaymentMethod/Charge only.
	                                tokenParams = {
	                                    name: nameOnCard,
	                                    address_zip: postalCode
	                                };
	
	                                if (addressLine1) tokenParams.address_line1 = addressLine1;
	                                if (city) tokenParams.address_city = city;
	                                _context.next = 13;
	                                return this.props.stripe.createToken(tokenParams);
	
	                            case 13:
	                                result = _context.sent;
	                                return _context.abrupt("return", result);
	
	                            case 15:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function handleSubmit() {
	                return _ref.apply(this, arguments);
	            }
	
	            return handleSubmit;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _state = this.state,
	                nameOnCard = _state.nameOnCard,
	                postalCode = _state.postalCode,
	                addressLine1 = _state.addressLine1,
	                city = _state.city;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "chk_card_fields" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "chk_form_group" },
	                    _react2.default.createElement(
	                        "label",
	                        { className: "chk_label" },
	                        "Card Number"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "chk_input chk_stripe_element" },
	                        _react2.default.createElement(_reactStripeElements.CardNumberElement, { style: stripeElementStyle })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "chk_form_row" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "chk_form_group" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "chk_label" },
	                            "Expiry Date"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "chk_input chk_stripe_element" },
	                            _react2.default.createElement(_reactStripeElements.CardExpiryElement, { style: stripeElementStyle })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "chk_form_group" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "chk_label" },
	                            "CVV"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "chk_input chk_stripe_element" },
	                            _react2.default.createElement(_reactStripeElements.CardCvcElement, { style: stripeElementStyle })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "chk_form_group" },
	                    _react2.default.createElement(
	                        "label",
	                        { className: "chk_label" },
	                        "Name on Card"
	                    ),
	                    _react2.default.createElement("input", {
	                        className: "chk_input",
	                        type: "text",
	                        name: "nameOnCard",
	                        placeholder: "John Doe",
	                        value: nameOnCard,
	                        onChange: this.handleInputChange,
	                        autoComplete: "cc-name"
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "chk_form_group" },
	                    _react2.default.createElement(
	                        "label",
	                        { className: "chk_label" },
	                        "Address Line 1 ",
	                        _react2.default.createElement(
	                            "span",
	                            { className: "chk_label_optional" },
	                            "(optional)"
	                        )
	                    ),
	                    _react2.default.createElement("input", {
	                        className: "chk_input",
	                        type: "text",
	                        name: "addressLine1",
	                        placeholder: "123 Main St",
	                        value: addressLine1,
	                        onChange: this.handleInputChange,
	                        autoComplete: "address-line1",
	                        maxLength: 100
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "chk_form_row" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "chk_form_group" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "chk_label" },
	                            "City ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "chk_label_optional" },
	                                "(optional)"
	                            )
	                        ),
	                        _react2.default.createElement("input", {
	                            className: "chk_input",
	                            type: "text",
	                            name: "city",
	                            placeholder: "New York",
	                            value: city,
	                            onChange: this.handleInputChange,
	                            autoComplete: "address-level2",
	                            maxLength: 50
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "chk_form_group" },
	                        _react2.default.createElement(
	                            "label",
	                            { className: "chk_label" },
	                            "Postal / ZIP Code"
	                        ),
	                        _react2.default.createElement("input", {
	                            className: "chk_input",
	                            type: "text",
	                            name: "postalCode",
	                            placeholder: "10001",
	                            value: postalCode,
	                            onChange: this.handleInputChange,
	                            autoComplete: "postal-code",
	                            maxLength: 12
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StripeCheckoutForm;
	}(_react.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(StripeCheckoutForm);

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FD from '../../views/RestAPI/fetchData';
	
	
	// import App_data from '../../views/config/App_data';
	
	/* eslint-disable*/
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.state = {
	      gitCommitId: ''
	    };
	    return _this;
	  }
	  // async componentDidMount() {
	  //   await FD.callAPI(App_data.backend_api + '/extras/lastCommitId').then(
	  //     async (resp) => {
	  //       if (resp.success)
	  //         this.setState({
	  //           gitCommitId: ` - ${resp.gitCommitId}`,
	  //         });
	  //     }
	  //   );
	  // }
	
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      function menu_active() {
	        (0, _jquery2.default)('.nav .nav-item').css({ 'background-color': 'transparent' });
	        (0, _jquery2.default)('.nav .nav-item').each(function () {
	          if ((0, _jquery2.default)(this).find('a').hasClass('active')) {
	            (0, _jquery2.default)(this).css({ 'background-color': '#132b40' });
	          }
	        });
	      }
	
	      (0, _jquery2.default)('.nav .nav-item a').click(menu_active());
	
	      (0, _jquery2.default)(document).ready(function () {
	        menu_active();
	      });
	      var selectedMenu = localStorage.getItem('selectedmenu');
	      var exam_name = this.props.exam_name;
	
	      var mainArr = {
	        cfa: true,
	        cfa_2: true,
	        cfa_3: true,
	        frm: false,
	        soa_p: false,
	        soa_fm: false
	      };
	      return _react2.default.createElement(
	        'footer',
	        { className: 'app-footer' },
	        exam_name === 'cfa' || exam_name === 'cfa_2' || exam_name === 'cfa_3' ? _react2.default.createElement(
	          'div',
	          null,
	          _language2.default.LC().FOOTER_MESSAGE
	        ) : selectedMenu === 'frm' || selectedMenu === 'soa_p' || selectedMenu === 'soa_fm' ? null : _react2.default.createElement(
	          'div',
	          null,
	          _language2.default.LC().FOOTER_MESSAGE
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'd-flex justify-content-between' },
	          _react2.default.createElement(
	            'span',
	            { className: '' },
	            'AnalystPrep \xA9 ',
	            (0, _moment2.default)().format('YYYY'),
	            this.state.gitCommitId
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://analystprep.com/privacy/', target: '_blank', className: 'privacy-policy' },
	              _language2.default.LC().Privacy_Policy
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:support@analystprep.com', target: '_top' },
	              'support@analystprep.com'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppLogo = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var AppLogo = exports.AppLogo = function (_Component) {
	    _inherits(AppLogo, _Component);
	
	    function AppLogo(props, context) {
	        _classCallCheck(this, AppLogo);
	
	        var _this = _possibleConstructorReturn(this, (AppLogo.__proto__ || Object.getPrototypeOf(AppLogo)).call(this, props, context));
	
	        _this.state = {
	            logoUrl: _constant.ANALYSTPREP_LOGO,
	            logoClassNames: null
	        };
	        return _this;
	    }
	
	    _createClass(AppLogo, [{
	        key: "_checkLogoAvailability",
	        value: function _checkLogoAvailability(logoUrl) {
	            var _this2 = this;
	
	            return new Promise(function (resolve, reject) {
	                if (logoUrl == null || (0, _CommonUtils.isStringEmpty)(logoUrl)) {
	                    reject('Logo url is null or empty');
	                    return;
	                }
	                var img = new Image();
	                img.src = logoUrl;
	                img.onload = function () {
	                    _this2.setState({ logoUrl: logoUrl });
	                    img.remove();
	                    resolve(true);
	                };
	                img.onerror = function (e) {
	                    console.warn("Error loading logo image: " + e.target.src);
	                    img.remove();
	                    resolve(false);
	                };
	            });
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(nextProps, nextContext) {
	                var logoAvailable;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return this._checkLogoAvailability(nextProps.organizationLogo);
	
	                            case 3:
	                                logoAvailable = _context.sent;
	
	                                if (logoAvailable && nextProps.userRole != null && nextProps.userRole === _constant.ROLES.PARTNER) {
	                                    this.setState({ logoClassNames: ['circular-logo'] });
	                                }
	                                _context.next = 9;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                            case 9:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 7]]);
	            }));
	
	            function componentWillReceiveProps(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillReceiveProps;
	        }()
	    }, {
	        key: "getClassNames",
	        value: function getClassNames() {
	            if (this.state.logoClassNames != null && this.state.logoClassNames.constructor === Array && this.state.logoClassNames.length > 0) {
	                return this.state.logoClassNames.join(' ');
	            }
	            return null;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "a",
	                {
	                    className: "navbar-brand header-logo-section",
	                    href: "#",
	                    id: "header-logo-section",
	                    "aria-label": "AnalystPrep home"
	                },
	                _react2.default.createElement("img", {
	                    src: this.state.logoUrl,
	                    className: this.getClassNames(),
	                    alt: "Logo"
	                })
	            );
	        }
	    }]);
	
	    return AppLogo;
	}(_react.Component);
	
	AppLogo.defaultProps = {
	    userRole: null,
	    organizationLogo: null
	};

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	var _service = __webpack_require__(179);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var ExamDropdownMenu = function (_Component) {
	  _inherits(ExamDropdownMenu, _Component);
	
	  function ExamDropdownMenu(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ExamDropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, (ExamDropdownMenu.__proto__ || Object.getPrototypeOf(ExamDropdownMenu)).call(this, props));
	
	    _this.toggleMenu = function () {
	      // Implement the toggle function here
	      _this.setState(function (prevState) {
	        return {
	          menu_class: prevState.menu_class === 'menu_hide' ? 'menu_show exam_menu' : 'menu_hide'
	        };
	      });
	    };
	
	    _this.openExamsMenu = function (menu) {
	      // Implement the menu opening function here
	      _this.setState(function (prevState) {
	        return {
	          selectedExamMenu: prevState.selectedExamMenu === menu ? '' : menu
	        };
	      });
	    };
	
	    _this.selectedMenu = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(value) {
	        var data, targetDashboard;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // Implement the menu selection function here
	                localStorage.setItem('selectedmenu', value);
	                data = {
	                  exam_selected: value,
	                  organizationDomain: localStorage.getItem('organizationDomain'),
	                  role: localStorage.getItem('role')
	                };
	                _context.next = 4;
	                return (0, _service.updateSelectedExam)(data);
	
	              case 4:
	                _context.next = 6;
	                return _userStore2.default.fetchProfile();
	
	              case 6:
	                _this.setState({
	                  examName: _constant.examNames[localStorage.getItem('selectedmenu')] || '',
	                  menu_class: 'menu_hide'
	                });
	                _context.next = 9;
	                return _userStore2.default.getUserWebinarsCount();
	
	              case 9:
	                targetDashboard = value === _constant.examNameAccordingToDB.FRM && localStorage.getItem('role') === _constant.ROLES.EMPLOYEE ? _AppRoutes2.default.FRM_V2_DASHBOARD : _constant.examObject[value].sidebarRoutes.dashboard;
	                // Force a full document reload (not a soft react-router push) so every dashboard widget —
	                // progress bars, "My Reports", "Saved Items / Flashcards" tabs — refetches for the newly
	                // selected exam. Exams that share the same route (e.g. CFA L1 2025/2026/2027 all map to
	                // /cfa1/2026/dashboard) would otherwise NOT remount on a soft push, leaving widgets showing
	                // the previous year's data until a manual hard reload. This mirrors the cross-exam-level
	                // switch behaviour the user already gets a fresh page from.
	
	                window.location.href = targetDashboard;
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      // Initialize your state here
	      examName: _constant.examNames[localStorage.getItem('selectedmenu')] || '',
	      menu_class: 'menu_hide',
	      selectedExamMenu: '',
	      userRole: 'user'
	    };
	    return _this;
	  }
	
	  _createClass(ExamDropdownMenu, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          examName = _state.examName,
	          menu_class = _state.menu_class;
	
	      console.log("examName: ", examName);
	      return _react2.default.createElement(
	        'li',
	        { className: 'nav-item drop_down_parent exam_dropdown_menu' },
	        _react2.default.createElement(
	          'a',
	          {
	            onClick: this.toggleMenu,
	            onKeyDown: function onKeyDown(e) {
	              if (e.key === 'Enter' || e.key === ' ') {
	                e.preventDefault();
	                _this3.toggleMenu();
	              }
	            },
	            className: 'nav-link white-color-text text-overflow-header',
	            role: 'button',
	            tabIndex: 0,
	            'aria-haspopup': 'true',
	            'aria-expanded': menu_class !== 'menu_hide',
	            'aria-label': 'Select exam, current: ' + (examName || 'none selected')
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'white-color-text', id: 'examName' },
	            examName || 'Select Exam'
	          ),
	          _react2.default.createElement('i', { className: 'fa fa-angle-down', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: menu_class, id: 'menu_state' },
	          this.renderExamSubMenu('CFA Exams', (0, _constant.CFAExamList)()),
	          this.renderExamSubMenu('FRM Exams', _constant.FRMExamList),
	          this.renderExamSubMenu('Actuarial Exams', _constant.ActuarialExamList),
	          this.renderExamSubMenu('MBA Admission', _constant.GMATExamList)
	        )
	      );
	    }
	  }, {
	    key: 'renderExamSubMenu',
	    value: function renderExamSubMenu(title, exams) {
	      var _this4 = this;
	
	      var selectedExamMenu = this.state.selectedExamMenu;
	      var userRole = this.props.userRole;
	
	      var handleToggleKey = function handleToggleKey(e) {
	        if (e.key === 'Enter' || e.key === ' ') {
	          e.preventDefault();
	          _this4.openExamsMenu(title);
	        }
	      };
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'exam-submenu-toggle ' + (selectedExamMenu === title && 'open'),
	            id: title,
	            role: 'button',
	            tabIndex: 0,
	            'aria-expanded': selectedExamMenu === title,
	            onClick: function onClick() {
	              return _this4.openExamsMenu(title);
	            },
	            onKeyDown: handleToggleKey
	          },
	          title,
	          ' ',
	          _react2.default.createElement('i', { className: 'fa fa-angle-right', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'exam-submenu-dropdown ' + (selectedExamMenu === title && 'open') },
	          exams.map(function (exam) {
	            return (!exam.role || userRole === exam.role) && _react2.default.createElement(
	              'li',
	              { key: exam.value },
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'pointer_class ' + (localStorage.getItem('selectedmenu') === exam.value && 'active')
	                  // value={exam.value}
	                  , id: exam.label,
	                  role: 'button',
	                  tabIndex: 0,
	                  onClick: function onClick() {
	                    return _this4.selectedMenu(exam.value);
	                  },
	                  onKeyDown: function onKeyDown(e) {
	                    if (e.key === 'Enter' || e.key === ' ') {
	                      e.preventDefault();
	                      _this4.selectedMenu(exam.value);
	                    }
	                  }
	                },
	                exam.label
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ExamDropdownMenu;
	}(_react.Component);
	
	exports.default = ExamDropdownMenu;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable */
	
	
	__webpack_require__(202);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGa = __webpack_require__(1138);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _reactRouter = __webpack_require__(29);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ExamDropdownMenu = __webpack_require__(533);
	
	var _ExamDropdownMenu2 = _interopRequireDefault(_ExamDropdownMenu);
	
	var _HeaderCart = __webpack_require__(535);
	
	var _HeaderCart2 = _interopRequireDefault(_HeaderCart);
	
	var _MobileSidebarToggle = __webpack_require__(536);
	
	var _MobileSidebarToggle2 = _interopRequireDefault(_MobileSidebarToggle);
	
	var _UserAvatar = __webpack_require__(264);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _mobx = __webpack_require__(37);
	
	var _AppLogo = __webpack_require__(532);
	
	var _WebSocketService = __webpack_require__(138);
	
	var _aiTutorContext = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function normalizeAvatar(next, prev) {
	  try {
	    if (typeof next === 'string') {
	      var v = next.trim().replace(/^["']|["']$/g, '');
	      if (/^https?:\/\//i.test(v)) return v;
	    }
	    if (next && (typeof next === 'undefined' ? 'undefined' : _typeof(next)) === 'object') {
	      if (next.url) return String(next.url).trim();
	      if (next.href) return String(next.href).trim();
	      if (next.toString && next.toString !== Object.prototype.toString) {
	        return String(next.toString()).trim();
	      }
	    }
	  } catch (_) {}
	  return prev || '';
	}
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.handleExamSelection = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(examType, text_head, routeMap) {
	        var storage_session, token, idname, userRole, data, resp, key;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 3:
	                token = storage_session.token, idname = storage_session.idname;
	                userRole = _this.state.userRole;
	                data = {
	                  token: token,
	                  idname: idname,
	                  exam_selected: examType,
	                  organizationDomain: null,
	                  role: userRole
	                };
	                _context.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/updateExamSelected', data);
	
	              case 8:
	                resp = _context.sent;
	
	                if (!resp.success) {
	                  _context.next = 23;
	                  break;
	                }
	
	                _context.next = 12;
	                return _userStore2.default.fetchProfile();
	
	              case 12:
	                localStorage.setItem('selectedmenu', examType);
	                _this.setState({ text_head: text_head });
	
	                // Sidebar route handling
	                _context.t0 = _regenerator2.default.keys(routeMap);
	
	              case 15:
	                if ((_context.t1 = _context.t0()).done) {
	                  _context.next = 23;
	                  break;
	                }
	
	                key = _context.t1.value;
	
	                if (!window.location.pathname.includes(key)) {
	                  _context.next = 21;
	                  break;
	                }
	
	                localStorage.setItem('sidebarRoute', routeMap[key]);
	                _reactRouter.browserHistory.push({
	                  pathname: window.location.pathname,
	                  state: { token: token, idname: idname, selectedMenu: examType }
	                });
	                return _context.abrupt('break', 23);
	
	              case 21:
	                _context.next = 15;
	                break;
	
	              case 23:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.customerly = function () {
	      window.customerlySettings = {
	        app_id: '54b14ea0',
	        user_id: _this.state.user_id,
	        name: _this.state.userName,
	        email: _this.state.idname,
	        attributes: {
	          exam: _this.state.exam,
	          exam_package: _this.state.exam_package,
	          exam_selected: _this.state.exam_selected
	        }
	      };
	      !function () {
	        function e() {
	          var e = t.createElement('script');
	          e.type = 'text/javascript', e.async = !0, e.src = 'https://widget.customerly.io/widget/54b14ea0';
	          var r = t.getElementsByTagName('script')[0];
	          r.parentNode.insertBefore(e, r);
	        }
	        var r = window,
	            t = document,
	            n = function n() {
	          n.c(arguments);
	        };
	        r.customerly_queue = [], n.c = function (e) {
	          r.customerly_queue.push(e);
	        }, r.customerly = n, r.attachEvent ? r.attachEvent('onload', e) : r.addEventListener('load', e, !1);
	        setTimeout(e, 1000);
	      }();
	    };
	
	    _this.logout = function () {
	      var userTokenAndEmail = _constant.localStorageKeys.userTokenAndEmail,
	          selectedLanguage = _constant.localStorageKeys.selectedLanguage,
	          selectedMenu = _constant.localStorageKeys.selectedMenu,
	          loginId = _constant.localStorageKeys.loginId,
	          previousPath = _constant.localStorageKeys.previousPath,
	          previousParams = _constant.localStorageKeys.previousParams,
	          questionMode = _constant.localStorageKeys.questionMode;
	
	      var keysToRemove = [userTokenAndEmail, selectedLanguage, selectedMenu, loginId, previousPath, previousParams, questionMode];
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/logout', {
	        token: _this.state.token
	      }).then(function (resp) {
	        keysToRemove.forEach(function (key) {
	          return localStorage.removeItem(key);
	        });
	        _userStore2.default.clear();
	        (0, _WebSocketService.disconnectSocket)();
	        _reactRouter.browserHistory.push('/login');
	      });
	    };
	
	    _this.state = {
	      domain_name: window.location.hostname,
	      avatar: _App_data2.default.frontend_url + '/img/avatars/defaultProfileImage.jpg',
	      token: '',
	      idname: '',
	      AccountdropdownOpen: false,
	      LanguagedropdownOpen: false,
	      text_head: 'CFA Exams',
	      language_selected: '',
	      userName: '',
	      exam_package: '',
	      exam_selected: '',
	      exam: '',
	      subscription_details: '',
	      user_id: '',
	      showCustomerly: false,
	      pageName: '',
	      Expired: false,
	      userRole: '',
	      redirectParamURL: '',
	      organizationLogo: '',
	      loggedIn: false,
	      cart_count: ''
	    };
	
	    _this.goToProfile = _this.goToProfile.bind(_this);
	    _this.toggleAccountMenu = _this.toggleAccountMenu.bind(_this);
	    _this.toggleLanguageMenu = _this.toggleLanguageMenu.bind(_this);
	
	    _reactGa2.default.initialize('UA-75714602-1');
	    _reactGa2.default.pageview(window.location.pathname + window.location.search);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	
	
	    // getUserDetails = async (token, idname) => {
	    //   if (!token || !idname) return;
	    //
	    //   try {
	    //     const resp = await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, {
	    //       token,
	    //       idname,
	    //     });
	    //
	    //     if (!resp.success) {
	    //       this.setState({ loggedIn: false, Expired: true });
	    //       localStorage.clear();
	    //       return;
	    //     }
	    //
	    //     const {
	    //       profileInfo: {
	    //         username,
	    //         selected_language,
	    //         id,
	    //         exam,
	    //         exam_package,
	    //         exam_selected,
	    //         subscription_details,
	    //         question_mode,
	    //         role,
	    //         imageUrl,
	    //       },
	    //     } = resp;
	    //
	    //     localStorage.setItem('questionMode', question_mode);
	    //     localStorage.setItem('role', role);
	    //
	    //     userStore.setProfileInfo(resp.profileInfo);
	    //
	    //     this.setState({
	    //       userRole: role,
	    //       userName: username,
	    //       language_selected: selected_language || 'EN',
	    //       user_id: id,
	    //       exam,
	    //       exam_package,
	    //       exam_selected,
	    //       subscription_details,
	    //       avatar: String(normalizeAvatar(imageUrl != null ? imageUrl : this.state.avatar)),
	    //       tokentimeout: false,
	    //     });
	    //   } catch (err) {
	    //     console.error('Failed to fetch profile info', err);
	    //   }
	    // };
	
	    //TODO: check exam URL & compare with current url if URL didnt math redirect to selected exam URL
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var storageSession, _storageSession$idnam, idname, _storageSession$token, token;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                storageSession = JSON.parse(localStorage.getItem('localstorageval')) || {};
	                // const { pathname } = this.props.location;
	                // const { SOA_P, SOA_FM, FRM, CFA_LEVEL_1_2026, CFA_LEVEL_2_2026, CFA_LEVEL_3_2026, GMAT_FOCUS, EA, ESG } =
	                // examNameAccordingToDB;
	                // ----------- EXAM SELECTION -------------
	                // const examRoutes = {
	                //   [routeExamName.SOA_P]: SOA_P,
	                //   [routeExamName.SOA_FM]: SOA_FM,
	                //   [routeExamName.FRM]: FRM,
	                //   [routeExamName.CFA_LEVEL_1_2024]: CFA_LEVEL_1_2026,
	                //   [routeExamName.CFA_LEVEL_2]: CFA_LEVEL_2_2026,
	                //   [routeExamName.CFA_LEVEL_3]: CFA_LEVEL_3_2026,
	                //   [routeExamName.GMAT_FOCUS]: GMAT_FOCUS,
	                //   [routeExamName.GMAT]: GMAT_FOCUS,
	                //   [routeExamName.EA]: EA,
	                //   [routeExamName.ESG]: ESG,
	                // };
	
	                // for (const route in examRoutes) {
	                //   if (pathname.startsWith(route) || pathname.includes(route)) {
	                //     this.handleExamSelection(
	                //       examRoutes[route],
	                //       examNames[examRoutes[route]],
	                //       examObject[examRoutes[route]].sidebarRoutes,
	                //     );
	                //     break;
	                //   }
	                // }
	
	                // ----------- LOGIN STATUS -------------
	
	                _storageSession$idnam = storageSession.idname, idname = _storageSession$idnam === undefined ? '' : _storageSession$idnam, _storageSession$token = storageSession.token, token = _storageSession$token === undefined ? '' : _storageSession$token;
	
	                this.setState({
	                  idname: idname,
	                  token: token,
	                  loggedIn: !!(idname && token),
	                  pageName: window.location.href.split('/')[3].split('?')[0]
	                });
	
	                // await this.getUserDetails(token, idname);
	
	                //Get profile info from storage observable
	                this.dispose = (0, _mobx.autorun)(function () {
	
	                  if (_userStore2.default.profileInfo == null) return;
	
	                  var _UserStore$profileInf = _userStore2.default.profileInfo,
	                      username = _UserStore$profileInf.username,
	                      selected_language = _UserStore$profileInf.selected_language,
	                      id = _UserStore$profileInf.id,
	                      exam = _UserStore$profileInf.exam,
	                      exam_package = _UserStore$profileInf.exam_package,
	                      exam_selected = _UserStore$profileInf.exam_selected,
	                      subscription_details = _UserStore$profileInf.subscription_details,
	                      question_mode = _UserStore$profileInf.question_mode,
	                      role = _UserStore$profileInf.role,
	                      imageUrl = _UserStore$profileInf.imageUrl,
	                      organizationLogo = _UserStore$profileInf.organizationLogo;
	
	
	                  localStorage.setItem('questionMode', question_mode);
	                  localStorage.setItem('role', role);
	
	                  _this3.setState({
	                    userRole: role,
	                    userName: username,
	                    language_selected: selected_language || 'EN',
	                    user_id: id,
	                    exam: exam,
	                    exam_package: exam_package,
	                    exam_selected: exam_selected,
	                    subscription_details: subscription_details,
	                    avatar: String(normalizeAvatar(imageUrl != null ? imageUrl : _this3.state.avatar)),
	                    tokentimeout: false,
	                    organizationLogo: organizationLogo
	                  });
	                });
	                setTimeout(function () {
	                  return _this3.setState({ showCustomerly: true });
	                }, 6000);
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.intervalId);
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'getUserDetails',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var profileInfo, username, selected_language, id, exam, exam_package, exam_selected, subscription_details, question_mode, role, imageUrl;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _userStore2.default.getUserProfile();
	
	              case 2:
	                profileInfo = _context3.sent;
	
	                if (!(profileInfo == null)) {
	                  _context3.next = 5;
	                  break;
	                }
	
	                return _context3.abrupt('return');
	
	              case 5:
	                username = profileInfo.username, selected_language = profileInfo.selected_language, id = profileInfo.id, exam = profileInfo.exam, exam_package = profileInfo.exam_package, exam_selected = profileInfo.exam_selected, subscription_details = profileInfo.subscription_details, question_mode = profileInfo.question_mode, role = profileInfo.role, imageUrl = profileInfo.imageUrl;
	
	
	                localStorage.setItem('questionMode', question_mode);
	                localStorage.setItem('role', role);
	
	                this.setState({
	                  userRole: role,
	                  userName: username,
	                  language_selected: selected_language || 'EN',
	                  user_id: id,
	                  exam: exam,
	                  exam_package: exam_package,
	                  exam_selected: exam_selected,
	                  subscription_details: subscription_details,
	                  avatar: String(normalizeAvatar(imageUrl != null ? imageUrl : this.state.avatar)),
	                  tokentimeout: false
	                });
	
	              case 9:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getUserDetails() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getUserDetails;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(prevProps) {
	        var _props, setIsChildChangedFalse, location, isChildChanged, _state, loggedIn, pageName, token, idname, storageSession;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _props = this.props, setIsChildChangedFalse = _props.setIsChildChangedFalse, location = _props.location, isChildChanged = _props.isChildChanged;
	                _state = this.state, loggedIn = _state.loggedIn, pageName = _state.pageName, token = _state.token, idname = _state.idname;
	
	                if (!(location.pathname.includes('profile/profileInfo') && (isChildChanged || prevProps.location.pathname !== location.pathname))) {
	                  _context4.next = 6;
	                  break;
	                }
	
	                _context4.next = 5;
	                return this.getUserDetails(token, idname);
	
	              case 5:
	                setIsChildChangedFalse();
	
	              case 6:
	
	                // ✅ Auto logout if localStorage cleared but state still logged in
	                storageSession = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (!storageSession && loggedIn) {
	                  if (pageName === 'forum') {
	                    this.setState({ loggedIn: false, tokentimeout: true });
	                  } else {
	                    this.logout();
	                  }
	                }
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate(_x4) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.location.pathname !== this.props.location.pathname) {
	        _reactGa2.default.initialize('UA-75714602-1');
	        _reactGa2.default.pageview(window.location.pathname + window.location.search);
	      }
	    }
	  }, {
	    key: 'convertToSlug',
	    value: function convertToSlug(Text, post_id) {
	      return Text.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-').concat('-', post_id);
	    }
	  }, {
	    key: 'goToLogin',
	    value: function goToLogin() {
	      localStorage.setItem('urlToRedirect', this.props.location.pathname);
	      _reactRouter.browserHistory.push({
	        pathname: '/',
	        state: { pageToOpen: '1', urlToRedirect: this.props.location.pathname }
	      });
	    }
	  }, {
	    key: 'goToRegister',
	    value: function goToRegister() {
	      localStorage.setItem('urlToRedirect', this.props.location.pathname);
	      _reactRouter.browserHistory.push({
	        pathname: '/',
	        state: { pageToOpen: '2', urlToRedirect: this.props.location.pathname }
	      });
	    }
	  }, {
	    key: 'toggleAccountMenu',
	    value: function toggleAccountMenu() {
	      this.setState(function (prev) {
	        return { AccountdropdownOpen: !prev.AccountdropdownOpen };
	      });
	    }
	  }, {
	    key: 'toggleLanguageMenu',
	    value: function toggleLanguageMenu() {
	      this.setState(function (prev) {
	        return { LanguagedropdownOpen: !prev.LanguagedropdownOpen };
	      });
	    }
	  }, {
	    key: 'goToProfile',
	    value: function goToProfile() {
	      _reactRouter.browserHistory.push({
	        pathname: '/profile',
	        state: { token: this.state.token, idname: this.state.idname }
	      });
	    }
	  }, {
	    key: 'getAvatarStyle',
	    value: function getAvatarStyle() {
	      return {
	        backgroundImage: 'url("' + this.state.avatar + '")',
	        backgroundSize: 'cover'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          loggedIn = _state2.loggedIn,
	          userRole = _state2.userRole,
	          organizationLogo = _state2.organizationLogo,
	          userName = _state2.userName,
	          user_id = _state2.user_id,
	          cart_count = _state2.cart_count;
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'app-header navbar' },
	        _react2.default.createElement(_AppLogo.AppLogo, { userRole: userRole, organizationLogo: organizationLogo }),
	        _react2.default.createElement(_MobileSidebarToggle2.default, null),
	        loggedIn && (0, _aiTutorContext.isAiTutorAvailable)() && _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: '@media (max-width:574.98px){.ap-ai-hdr-btn{display:none !important;}}' } }),
	        loggedIn && (0, _aiTutorContext.isAiTutorAvailable)() && _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'ap-ai-hdr-btn ap-ai-launcher',
	            'aria-label': 'Open AI Tutor',
	            onClick: function onClick() {
	              return window.dispatchEvent(new CustomEvent('aitutor:toggle'));
	            },
	            style: {
	              display: 'inline-flex',
	              maxHeight: 33,
	              alignItems: 'center',
	              alignSelf: 'center',
	              gap: 7,
	              marginLeft: 14,
	              padding: '8px 15px',
	              borderRadius: 10,
	              border: 'none',
	              cursor: 'pointer',
	              color: '#fff',
	              font: "700 14px 'Plus Jakarta Sans', system-ui, sans-serif",
	              background: 'linear-gradient(135deg,#6d4bff,#4a2fe0)',
	              boxShadow: '0 4px 14px rgba(74,47,224,.42)',
	              whiteSpace: 'nowrap'
	            }
	          },
	          '\u2726 AI Tutor'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'nav navbar-nav ml-auto header_right' },
	          loggedIn && _react2.default.createElement(_ExamDropdownMenu2.default, { userRole: userRole }),
	          loggedIn && _react2.default.createElement(_HeaderCart2.default, {
	            pathname: this.props.location.pathname,
	            isChildChanged: this.props.isChildChanged,
	            setIsChildChangedFalse: this.props.setIsChildChangedFalse
	          }),
	          loggedIn ? _react2.default.createElement(
	            'li',
	            { className: 'nav-item nav-item-profile' },
	            _react2.default.createElement(
	              _reactstrap.Dropdown,
	              { isOpen: this.state.AccountdropdownOpen, toggle: this.toggleAccountMenu },
	              _react2.default.createElement(
	                'a',
	                {
	                  role: 'button',
	                  tabIndex: 0,
	                  onClick: this.toggleAccountMenu,
	                  onKeyDown: function onKeyDown(e) {
	                    if (e.key === 'Enter' || e.key === ' ') {
	                      e.preventDefault();
	                      _this4.toggleAccountMenu();
	                    }
	                  },
	                  'aria-haspopup': 'true',
	                  'aria-expanded': this.state.AccountdropdownOpen,
	                  'aria-label': 'Account menu for ' + (userName || 'user'),
	                  className: 'nav-link dropdown-toggle nav-link profile-dropdown-toddle'
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'profile_name hidden-sm-down' },
	                  _language2.default.LC().WELCOME,
	                  ', ',
	                  userName
	                ),
	                _react2.default.createElement(_UserAvatar2.default, { classNames: ['top-header-imageprofile-circle'] }),
	                _react2.default.createElement('i', { className: 'fa fa-angle-down', 'aria-hidden': 'true' })
	              ),
	              _react2.default.createElement(
	                _reactstrap.DropdownMenu,
	                { className: 'dropdown-menu' },
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  {
	                    className: 'pointer_class',
	                    disabled: !user_id,
	                    onClick: function onClick() {
	                      return (0, _function._getProfile)(_this4.convertToSlug(userName, user_id));
	                    }
	                  },
	                  user_id ? _react2.default.createElement('i', { className: 'fa fa-user' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                  _language2.default.LC().PROFILE
	                ),
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  { className: 'pointer_class', onClick: this.logout },
	                  _react2.default.createElement('i', { className: 'fa fa-lock' }),
	                  ' ',
	                  _language2.default.LC().LOGOUT
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'li',
	            { className: 'cart_li_wrap pointer_class' },
	            _react2.default.createElement(
	              'p',
	              {
	                role: 'button',
	                tabIndex: 0,
	                onClick: this.goToLogin.bind(this),
	                onKeyDown: function onKeyDown(e) {
	                  if (e.key === 'Enter' || e.key === ' ') {
	                    e.preventDefault();
	                    _this4.goToLogin();
	                  }
	                }
	              },
	              'Login'
	            ),
	            _react2.default.createElement(
	              'p',
	              { 'aria-hidden': 'true' },
	              ' | '
	            ),
	            _react2.default.createElement(
	              'p',
	              {
	                role: 'button',
	                tabIndex: 0,
	                onClick: this.goToRegister.bind(this),
	                onKeyDown: function onKeyDown(e) {
	                  if (e.key === 'Enter' || e.key === ' ') {
	                    e.preventDefault();
	                    _this4.goToRegister();
	                  }
	                }
	              },
	              'Register'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'cart-section' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'badge badge-pill badge-danger',
	                  'aria-hidden': 'true'
	                },
	                cart_count
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	Header.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Header;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _service = __webpack_require__(179);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderCart = function (_Component) {
	  _inherits(HeaderCart, _Component);
	
	  function HeaderCart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, HeaderCart);
	
	    var _this = _possibleConstructorReturn(this, (HeaderCart.__proto__ || Object.getPrototypeOf(HeaderCart)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.getCartItem();
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.shoppingCart = function () {
	      _reactRouter.browserHistory.push({
	        pathname: _AppRoutes2.default.CART
	      });
	    };
	
	    _this.getCartItem = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var resp;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _service.fetchCartItem)();
	
	              case 2:
	                resp = _context2.sent;
	
	                if (resp.success) {
	                  if (resp.user_cart.length === 0) {
	                    _this.setState({ count: '' });
	                  } else {
	                    _this.setState({ count: resp.user_cart.length });
	                  }
	                }
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      count: ''
	    };
	    return _this;
	  }
	
	  _createClass(HeaderCart, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(prevProps) {
	        var _props, setIsChildChangedFalse, pathname, isChildChanged;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _props = this.props, setIsChildChangedFalse = _props.setIsChildChangedFalse, pathname = _props.pathname, isChildChanged = _props.isChildChanged;
	
	                if ((pathname === _AppRoutes2.default.CART || pathname.includes('thankyou')) && (isChildChanged || prevProps.pathname !== pathname)) {
	                  this.getCartItem();
	                  setIsChildChangedFalse();
	                }
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidUpdate(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var count = this.state.count;
	
	      var itemCount = typeof count === 'number' ? count : 0;
	      var cartLabel = itemCount === 1 ? 'Shopping cart, 1 item' : 'Shopping cart, ' + itemCount + ' items';
	      var handleKeyDown = function handleKeyDown(e) {
	        if (e.key === 'Enter' || e.key === ' ') {
	          e.preventDefault();
	          _this3.shoppingCart();
	        }
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'cart_li_wrap' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'pointer_class cart-link',
	            role: 'button',
	            tabIndex: 0,
	            'aria-label': cartLabel,
	            onClick: this.shoppingCart,
	            onKeyDown: handleKeyDown
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'hidden-sm-down' },
	            _language2.default.LC().CART
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cart-section' },
	            _react2.default.createElement('i', { className: 'fa fa-shopping-cart fa-lg ', 'aria-hidden': 'true' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'badge badge-pill badge-danger', 'aria-hidden': 'true' },
	              count
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderCart;
	}(_react.Component);
	
	exports.default = HeaderCart;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onclick = function onclick(e) {
	  e.preventDefault();
	  document.body.classList.toggle('sidebar-mobile-show');
	};
	
	function MobileSidebarToggle() {
	  return _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      className: 'menu_toggle hidden-md-up btn-reset',
	      'aria-label': 'Open navigation menu',
	      onClick: onclick
	    },
	    _react2.default.createElement('img', {
	      src: _App_data2.default.frontend_url + '/img/sidebar/menu.png',
	      alt: 'burger icon'
	    })
	  );
	}
	
	exports.default = MobileSidebarToggle;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntercom = __webpack_require__(1155);
	
	var _reactIntercom2 = _interopRequireDefault(_reactIntercom);
	
	var _reactRouter = __webpack_require__(29);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _constant = __webpack_require__(9);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	// import ReactAdroll from "react-adroll";
	
	var mobx = __webpack_require__(37);
	var autorun = mobx.autorun;
	
	/* eslint-disable*/
	var IntercomWidget = function (_Component) {
	  _inherits(IntercomWidget, _Component);
	
	  function IntercomWidget(props) {
	    _classCallCheck(this, IntercomWidget);
	
	    var _this = _possibleConstructorReturn(this, (IntercomWidget.__proto__ || Object.getPrototypeOf(IntercomWidget)).call(this, props));
	
	    _this.state = {
	      /* token : this.props.location.state.token,   //Authentication Token
	      idname : this.props.location.state.idname,  //Email Id*/
	      token: '',
	      idname: '',
	      avatar: '',
	      email: '',
	      username: '',
	      exam: '',
	      exam_package: ''
	    };
	    // ReactAdroll.init("WBMVWJ6ZUREQVFVU46D277", "BAW72YICJBBLDPI7366YAG");
	    return _this;
	  }
	
	  _createClass(IntercomWidget, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (!storage_session) {
	        _reactRouter.browserHistory.push('/');
	      } else {
	        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	        this.setState({ idname: storage_session['idname'] });
	        this.setState({ token: storage_session['token'] });
	        //console.log('---------'+storage_session['idname']);
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname']
	        };
	
	        this.dispose = autorun(function () {
	          if (_userStore2.default.profileInfo == null) return;
	          var _UserStore$profileInf = _userStore2.default.profileInfo,
	              email = _UserStore$profileInf.email,
	              username = _UserStore$profileInf.username,
	              exam = _UserStore$profileInf.exam,
	              exam_package = _UserStore$profileInf.exam_package,
	              imageUrl = _UserStore$profileInf.imageUrl;
	
	          _this2.setState({
	            email: email,
	            username: username,
	            exam: (0, _constant.getActiveExams)(exam) || exam,
	            exam_package: exam_package
	          });
	        });
	
	        // FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
	        //   console.log("-----------------------++++++ProfileInfo:: ")
	        //   if (resp.success) {
	        //     const { email, username, exam, exam_package, imageUrl } = resp.profileInfo;
	        //     this.setState({
	        //       email,
	        //       username,
	        //       exam: getActiveExams(exam) || exam,
	        //       exam_package,
	        //     });
	        //
	        //     if (imageUrl === null || imageUrl === '')
	        //       this.setState({
	        //         avatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
	        //       });
	        //     else this.setState({ avatar: imageUrl });
	        //   } else {
	        //     this.setState({
	        //       avatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
	        //     });
	        //   }
	        //   return resp;
	        // });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var appUser = this.state;
	      var user = {
	        email: appUser.email,
	        name: appUser.username,
	        Exam: appUser.exam,
	        Exam_package: appUser.exam_package,
	        Premium: appUser.exam_package ? true : false
	      };
	      if (window.location.href.indexOf('/cart') !== -1) {
	        user.Cart = true;
	      }
	      // if (window.location.href.indexOf("/thankyou") !== -1) {
	      //   user.Premium = true;
	      // }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntercom2.default, Object.assign({ appID: 'k16xdlc8' }, user))
	      );
	    }
	  }]);
	
	  return IntercomWidget;
	}(_react.Component);
	
	exports.default = IntercomWidget;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModelFooter = function ModelFooter(_ref) {
	  var footerLoader = _ref.footerLoader,
	      onModalToggle = _ref.onModalToggle,
	      footerLoadingText = _ref.footerLoadingText,
	      footerButtonText = _ref.footerButtonText,
	      _ref$onSubmitButton = _ref.onSubmitButton,
	      onSubmitButton = _ref$onSubmitButton === undefined ? true : _ref$onSubmitButton,
	      footerButtonCancelText = _ref.footerButtonCancelText;
	
	  return _react2.default.createElement(
	    _reactstrap.ModalFooter,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { sm: '12', className: 'text-center' },
	      _react2.default.createElement(
	        _reactstrap.FormGroup,
	        null,
	        onSubmitButton && _react2.default.createElement(
	          _reactstrap.Button,
	          { color: ' ', type: 'submit', className: 'mr-2 btn-black radius-btn' },
	          footerLoader ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	            ' ',
	            footerLoadingText || 'create'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            footerButtonText || 'Submit'
	          )
	        ),
	        ' ',
	        _react2.default.createElement(
	          _reactstrap.Button,
	          { color: ' ', onClick: onModalToggle, className: 'btn-line-black radius-btn' },
	          footerButtonCancelText
	        )
	      )
	    )
	  );
	};
	exports.default = ModelFooter;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _version = __webpack_require__(1054);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _mobx = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//TODO: add CI commit version to versions
	var AppVersion = function (_Component) {
	    _inherits(AppVersion, _Component);
	
	    function AppVersion() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AppVersion);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppVersion.__proto__ || Object.getPrototypeOf(AppVersion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            version: _version2.default.version,
	            apiVersion: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AppVersion, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var _this2 = this;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _userStore2.default.fetchApiVersion();
	
	                            case 2:
	                                this.dispose = (0, _mobx.autorun)(function () {
	                                    var version = _userStore2.default.apiVersion.version;
	                                    if (version != null) {
	                                        _this2.setState({ apiVersion: version });
	                                    }
	                                });
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this.dispose) this.dispose();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "sidebar-ver" },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    "fv:",
	                    this.state.version
	                ),
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    "av:",
	                    this.state.apiVersion
	                )
	            );
	        }
	    }]);
	
	    return AppVersion;
	}(_react.Component);
	
	exports.default = AppVersion;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _dashboardIcon = __webpack_require__(1028);
	
	var _dashboardIcon2 = _interopRequireDefault(_dashboardIcon);
	
	var _notesIcon = __webpack_require__(1030);
	
	var _notesIcon2 = _interopRequireDefault(_notesIcon);
	
	var _videoIcon = __webpack_require__(1036);
	
	var _videoIcon2 = _interopRequireDefault(_videoIcon);
	
	var _questionBankIcon = __webpack_require__(1032);
	
	var _questionBankIcon2 = _interopRequireDefault(_questionBankIcon);
	
	var _quizIcon = __webpack_require__(1033);
	
	var _quizIcon2 = _interopRequireDefault(_quizIcon);
	
	var _essayQuestionIcon = __webpack_require__(1029);
	
	var _essayQuestionIcon2 = _interopRequireDefault(_essayQuestionIcon);
	
	var _cbtIcon = __webpack_require__(1027);
	
	var _cbtIcon2 = _interopRequireDefault(_cbtIcon);
	
	var _tutorIcon = __webpack_require__(1035);
	
	var _tutorIcon2 = _interopRequireDefault(_tutorIcon);
	
	var _premium = __webpack_require__(1031);
	
	var _premium2 = _interopRequireDefault(_premium);
	
	var _webinars = __webpack_require__(1037);
	
	var _webinars2 = _interopRequireDefault(_webinars);
	
	var _subscription = __webpack_require__(1034);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _UserAvatar = __webpack_require__(264);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _aiTutorContext = __webpack_require__(93);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _AppVersion = __webpack_require__(539);
	
	var _AppVersion2 = _interopRequireDefault(_AppVersion);
	
	var _WebinarRESTService = __webpack_require__(139);
	
	var _WebinarRESTService2 = _interopRequireDefault(_WebinarRESTService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var mobx = __webpack_require__(37);
	var autorun = mobx.autorun;
	
	/* eslint-disable*/
	
	var Sidebar = function (_Component) {
	  _inherits(Sidebar, _Component);
	
	  function Sidebar() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      userToken: '',
	      userIdName: '',
	      userAvatar: '',
	      isEmployee: false,
	      isPremiumUser: true,
	      isVideoEnabled: true,
	      hasWebinars: false
	    }, _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var localStorageData, token, idname, payload;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              localStorageData = JSON.parse(localStorage.getItem('localstorageval'));
	
	              if (localStorageData) {
	                _context2.next = 3;
	                break;
	              }
	
	              return _context2.abrupt('return', _reactRouter.browserHistory.push('/'));
	
	            case 3:
	              token = localStorageData.token, idname = localStorageData.idname;
	
	              _this.setState({ userToken: token, userIdName: idname });
	
	              payload = { token: token, idname: idname };
	
	
	              _this.dispose = autorun(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var profileInfo, webinarsAvailable, role, isVideo, username, imageUrl, id, exam_selected, exam_package;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        profileInfo = _userStore2.default.profileInfo;
	                        webinarsAvailable = _userStore2.default.isUserWebinarsAvailable;
	
	                        if (!profileInfo) {
	                          _context.next = 8;
	                          break;
	                        }
	
	                        role = profileInfo.role, isVideo = profileInfo.isVideo, username = profileInfo.username, imageUrl = profileInfo.imageUrl, id = profileInfo.id, exam_selected = profileInfo.exam_selected, exam_package = profileInfo.exam_package;
	
	                        _this.setState({
	                          isVideoEnabled: isVideo,
	                          isEmployee: role === _constant.ROLES.EMPLOYEE,
	                          userAvatar: String(imageUrl || _App_data2.default.frontend_url + '/img/avatars/defaultProfileImage.jpg'),
	                          greeting: 'Welcome, ' + (username || 'Admin') + '!',
	                          userName: username,
	                          userId: id,
	                          isPremiumUser: exam_selected && exam_package,
	                          hasWebinars: webinarsAvailable
	                        });
	                        _context.next = 7;
	                        return _userStore2.default.getUserWebinarsCount("Sidebar");
	
	                      case 7:
	                        console.log("Webinar Count", _this.state.hasWebinars);
	
	                      case 8:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              })));
	
	              // try {
	              //   const response = await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, payload);
	              //   const profile = response && response.profileInfo;
	              //
	              //   if (response.success && profile) {
	              //     const { role, isVideo, username, imageUrl, id, exam_selected, exam_package } = profile;
	              //
	              //     this.setState({
	              //       isVideoEnabled: isVideo,
	              //       isEmployee: role === ROLES.EMPLOYEE,
	              //       userAvatar: imageUrl || `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
	              //       greeting: `Welcome, ${username || 'Admin'}!`,
	              //       userName: username,
	              //       userId: id,
	              //       isPremiumUser: exam_selected && exam_package,
	              //     });
	              //
	              //     localStorage.setItem('role', role);
	              //   }
	              // } catch (error) {
	              //   this.setState({
	              //     userAvatar: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
	              //   });
	              // }
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    })), _this.getWebinarsCountByExam = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(token) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.prev = 0;
	                _context3.next = 3;
	                return new _WebinarRESTService2.default().setAuthHeader(token).getWebinarsCountByExam();
	
	              case 3:
	                data = _context3.sent;
	
	                if (data && data.count > 0) _this.setState({ hasWebinars: true });
	                _context3.next = 10;
	                break;
	
	              case 7:
	                _context3.prev = 7;
	                _context3.t0 = _context3['catch'](0);
	
	                console.log("Error in getWebinarsCountByExam", _context3.t0);
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2, [[0, 7]]);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }(), _this.isRouteMatch = function (keywords) {
	      var pathname = _this.props.location.pathname;
	
	      var priorityRoutes = ['essay-question', 'notes', 'cbt', 'pathway'];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = priorityRoutes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var route = _step.value;
	
	          if (pathname.includes(route)) return keywords.includes(route);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var lowerCasePath = pathname.toLowerCase();
	      return keywords.some(function (keyword) {
	        return lowerCasePath.split(/\b/).includes(keyword.toLowerCase());
	      });
	    }, _this.renderSidebarItems = function () {
	      var examName = localStorage.getItem('selectedmenu') || _constant.examNameAccordingToDB.CFA_LEVEL_1_2025;
	      // cfa_2027 / cfa_2_2027 each have their own examObject entry whose sidebarRoutes point at the
	      // /cfa1/2027/... resp. /cfa2/2027/... tree. getActiveExams() collapses them → the family's active
	      // exam (cfa_2025 / cfa_2_2025), which would read the shared 2026 routes — so keep both preview
	      // editions uncollapsed here. All other exams behave exactly as before.
	      var selectedExam = examName === _constant.examNameAccordingToDB.CFA_LEVEL_1_2027 || examName === _constant.examNameAccordingToDB.CFA_LEVEL_2_2027 ? examName : (0, _constant.getActiveExams)(examName);
	      var isPremiumUser = _this.state.isPremiumUser;
	
	      var routes = _constant.examObject[selectedExam] ? _constant.examObject[selectedExam].sidebarRoutes : {};
	
	      var isExcludedFor = function isExcludedFor() {
	        for (var _len2 = arguments.length, exams = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          exams[_key2] = arguments[_key2];
	        }
	
	        return !exams.includes(selectedExam);
	      };
	      var isIncludedFor = function isIncludedFor() {
	        for (var _len3 = arguments.length, exams = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          exams[_key3] = arguments[_key3];
	        }
	
	        return exams.includes(selectedExam);
	      };
	      var GMAT_FOCUS = _constant.examNameAccordingToDB.GMAT_FOCUS,
	          EA = _constant.examNameAccordingToDB.EA,
	          ESG = _constant.examNameAccordingToDB.ESG,
	          CFA_LEVEL_3 = _constant.examNameAccordingToDB.CFA_LEVEL_3,
	          CFA_LEVEL_3_2025 = _constant.examNameAccordingToDB.CFA_LEVEL_3_2025,
	          SOA_P = _constant.examNameAccordingToDB.SOA_P,
	          SOA_FM = _constant.examNameAccordingToDB.SOA_FM,
	          FRM = _constant.examNameAccordingToDB.FRM;
	
	      var sidebarItems = [{
	        keyword: _constant.SECTION_NAMES.DASHBOARD,
	        route: routes.dashboard,
	        icon: _dashboardIcon2.default,
	        label: _messages.messages.DASHBOARD,
	        width: '28'
	      }, {
	        keyword: _constant.SECTION_NAMES.WEBINARS,
	        route: '/webinars',
	        icon: _webinars2.default,
	        label: _messages.messages.WEBINARS,
	        width: '31'
	      }, {
	        keyword: _constant.SECTION_NAMES.NOTES,
	        route: routes.notes,
	        icon: _notesIcon2.default,
	        label: _messages.messages.STUDY_NOTES,
	        condition: isExcludedFor(GMAT_FOCUS, EA),
	        width: '26'
	      }, {
	        keyword: _constant.SECTION_NAMES.VIDEOS,
	        route: routes.videos,
	        icon: _videoIcon2.default,
	        label: _messages.messages.VIDEO_LESSONS,
	        width: '33'
	      }, {
	        keyword: _constant.SECTION_NAMES.QUESTION_BANK,
	        route: routes.questions,
	        icon: _questionBankIcon2.default,
	        label: _messages.messages.QUESTION_BANK,
	        width: '34'
	      }, {
	        keyword: _constant.SECTION_NAMES.QUIZZES,
	        route: routes.quiz,
	        icon: _quizIcon2.default,
	        label: _messages.messages.QUIZZES,
	        condition: isExcludedFor(ESG),
	        width: '29'
	      }, {
	        keyword: _constant.SECTION_NAMES.ESSAY_QUESTION,
	        route: routes.essay,
	        icon: _essayQuestionIcon2.default,
	        label: _messages.messages.ESSAY_QUESTION,
	        condition: isIncludedFor(CFA_LEVEL_3, CFA_LEVEL_3_2025),
	        width: '29'
	      }, {
	        keyword: _constant.SECTION_NAMES.CBT,
	        route: routes.cbt,
	        icon: _cbtIcon2.default,
	        label: _messages.messages.CBT_MOCK_EXAM,
	        condition: isExcludedFor(SOA_P, SOA_FM, GMAT_FOCUS, EA, CFA_LEVEL_3_2025),
	        width: '39'
	      }, {
	        keyword: _constant.SECTION_NAMES.PATHWAY,
	        route: routes.pathway,
	        icon: _cbtIcon2.default,
	        label: _messages.messages.CBT_EXAM,
	        condition: isIncludedFor(CFA_LEVEL_3, CFA_LEVEL_3_2025),
	        width: '39'
	      }, {
	        keyword: _constant.SECTION_NAMES.TUTOR,
	        route: routes.tutor,
	        icon: _tutorIcon2.default,
	        label: _messages.messages.TUTORING,
	        condition: isExcludedFor(ESG, FRM, SOA_P, SOA_FM),
	        width: '31'
	      }, {
	        keyword: _constant.SECTION_NAMES.SUBSCRIBE,
	        route: routes.subscription,
	        icon: isPremiumUser ? _premium2.default : _subscription2.default,
	        label: _messages.messages.UPGRADE_ACCOUNT,
	        width: '31'
	      }];
	
	      return sidebarItems.filter(function (_ref5) {
	        var condition = _ref5.condition;
	        return condition !== false;
	      }).map(function (_ref6, idx) {
	        var keyword = _ref6.keyword,
	            route = _ref6.route,
	            icon = _ref6.icon,
	            label = _ref6.label,
	            width = _ref6.width,
	            isNewBadge = _ref6.isNewBadge;
	        return _react2.default.createElement(
	          'li',
	          {
	            key: idx,
	            className: 'nav-item pointer_class ' + (_this.isRouteMatch(keyword) ? 'sidebar-active' : '')
	          },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: route, activeClassName: 'active' },
	            _react2.default.createElement('img', { src: icon, alt: label + ' Icon', width: width }),
	            isNewBadge && _react2.default.createElement(
	              'span',
	              { className: 'badge badge-danger' },
	              'New'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'submenu_hover submenu_in' },
	              _react2.default.createElement(
	                'span',
	                { className: 'sidebar-link' },
	                label
	              )
	            )
	          )
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sidebar, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var pathname = this.props.location.pathname;
	
	      if (pathname !== prevProps.location.pathname) {
	        localStorage.setItem('sidebarRoute', pathname);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var userAvatar = this.state.userAvatar;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sidebar' },
	        _react2.default.createElement(
	          'nav',
	          { className: 'sidebar-nav', id: 'side_bar_nav' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters justify-content-center col-sm-12 profile_outer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'profile_wrapper' },
	              _react2.default.createElement('div', { className: 'online_status' }),
	              _react2.default.createElement(_UserAvatar2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav', id: 'nav_id' },
	            this.renderSidebarItems()
	          )
	        ),
	        (0, _aiTutorContext.isAiTutorAvailable)() && _react2.default.createElement(
	          'div',
	          { className: 'ap-ai-launcher', style: { display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px auto auto' } },
	          _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: '@keyframes apGlow{0%,100%{box-shadow:0 0 0 0 rgba(109,75,255,.28);}50%{box-shadow:0 0 0 5px rgba(109,75,255,.06);}}' } }),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              title: 'AI Tutor',
	              'aria-label': 'Open AI Tutor',
	              onClick: function onClick() {
	                return window.dispatchEvent(new CustomEvent('aitutor:toggle'));
	              },
	              style: {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                width: 48,
	                height: 48,
	                borderRadius: 13,
	                border: 'none',
	                cursor: 'pointer',
	                color: '#fff',
	                fontSize: 20,
	                background: 'linear-gradient(135deg,#6d4bff 0%,#4a2fe0 100%)',
	                boxShadow: '0 5px 16px rgba(74,47,224,.5)',
	                animation: 'apGlow 2.6s ease-in-out infinite'
	              }
	            },
	            '\u2726'
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { font: "800 8px 'Plus Jakarta Sans', system-ui, sans-serif", color: '#8a93c0', letterSpacing: '.06em', marginTop: 8, fontWeight: 900 } },
	            'AI TUTOR'
	          )
	        ),
	        _react2.default.createElement(_AppVersion2.default, null)
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_react.Component);
	
	exports.default = Sidebar;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tier pattern used across the platform:
	 *   free → simple → expensive → unlimited → Unlimited+ (Plus tier, #216)
	 *
	 * The Plus tier accepts three interchangeable description-tag values so admins
	 * can use whichever reads best:
	 *   [LMS:eligibility=lifetime+]   ← legacy key (still stored on 2 prod webinars)
	 *   [LMS:eligibility=plus]        ← matches exam_plans.package_val enum
	 *   [LMS:eligibility=unlimited+]  ← matches the product's display name
	 * All three render the same badge and grant the same access.
	 */
	var PLUS_ENTRY = { text: 'Unlimited+ Package' }; /* eslint-disable */
	
	
	var EL_LEVELS = {
	    'free': {
	        text: 'Free',
	        className: 'free-label'
	    },
	    'simple': {
	        text: 'Practice Package',
	        className: 'practice-label'
	    },
	    'expensive': {
	        text: 'Learn & Practice Package',
	        className: 'learn-label'
	    },
	    'unlimited': {
	        text: 'Unlimited Package'
	    },
	    // Plus-tier aliases — all three point to the same entry so the display
	    // label stays consistent regardless of which tag the admin used.
	    'lifetime+': PLUS_ENTRY,
	    'plus': PLUS_ENTRY,
	    'unlimited+': PLUS_ENTRY,
	    // Legacy single-word `lifetime` — kept for back-compat with any old rows,
	    // folded into the Plus display now that the product has been renamed.
	    'lifetime': PLUS_ENTRY
	};
	
	var AccessLabel = function AccessLabel(_ref) {
	    var eligibilityLevel = _ref.eligibilityLevel,
	        accessibility = _ref.accessibility;
	
	
	    // Guard the lookup: `EL_LEVELS[undefined].text` throws. Normalise to lowercase
	    // so case variants from Graph API (e.g. "Free", "LIFETIME") still resolve.
	    var normalizedLevel = eligibilityLevel != null ? String(eligibilityLevel).toLowerCase() : null;
	    var levelEntry = normalizedLevel ? EL_LEVELS[normalizedLevel] : null;
	    var accessLabel = levelEntry && levelEntry.text || 'Unknown';
	    var classesNames = ['webinar-card__access-badge'];
	
	    if (normalizedLevel === 'free') {
	        classesNames.push('webinar-card__access-badge--free');
	    } else {
	        classesNames.push(accessibility === true ? 'webinar-card__access-badge--prem-av' : 'webinar-card__access-badge--prem-nav');
	    }
	
	    var iconsSvg = {
	        open: _react2.default.createElement(
	            'svg',
	            { className: 'wb-svg-icon-12', viewBox: '0 0 24 24', fill: 'none', stroke: '#16a34a', strokeWidth: '2' },
	            _react2.default.createElement('rect', { x: '3', y: '11', width: '18', height: '11', rx: '2' }),
	            _react2.default.createElement('path', { d: 'M7,11V7a5,5,0,0,1,9.9-1' })
	        ),
	        close: _react2.default.createElement(
	            'svg',
	            { className: 'wb-svg-icon-12', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2' },
	            _react2.default.createElement('rect', { x: '3', y: '11', width: '18', height: '11', rx: '2' }),
	            _react2.default.createElement('path', { d: 'M7,11V7a5,5,0,0,1,10,0v4' })
	        )
	    };
	
	    var IconItem = function IconItem() {
	        if (normalizedLevel === 'free') return null;
	        return accessibility === true ? iconsSvg.open : iconsSvg.close;
	    };
	
	    return _react2.default.createElement(
	        'span',
	        { className: classesNames.join(' ') },
	        _react2.default.createElement(IconItem, null),
	        accessLabel
	    );
	};
	
	exports.default = AccessLabel;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpinnerButton = function SpinnerButton(_ref) {
	    var children = _ref.children,
	        loading = _ref.loading,
	        disabled = _ref.disabled,
	        className = _ref.className,
	        onClick = _ref.onClick,
	        type = _ref.type;
	
	    var isDisabled = disabled || loading;
	    var btnClass = [className || '', loading ? 'webinar-btn--loading' : ''].filter(Boolean).join(' ');
	
	    return _react2.default.createElement(
	        'button',
	        {
	            className: btnClass,
	            onClick: !isDisabled ? onClick : undefined,
	            disabled: isDisabled,
	            type: type || 'button'
	        },
	        _react2.default.createElement(
	            'span',
	            { className: 'webinar-btn__content' },
	            children,
	            loading && _react2.default.createElement('span', { className: 'webinar-btn-spinner' })
	        )
	    );
	}; /* eslint-disable */
	exports.default = SpinnerButton;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var WebinarTags = function WebinarTags(_ref) {
	    var tags = _ref.tags,
	        isModal = _ref.isModal;
	
	    if (!tags || tags.length === 0) return null;
	    var classNames = isModal ? 'webinar-modal__tags' : 'webinar-card__tags';
	    return _react2.default.createElement(
	        'div',
	        { className: classNames },
	        tags.map(function (tag, index) {
	            return _react2.default.createElement(
	                'span',
	                { className: 'webinar-card__tag', key: tag + '-' + index, style: {
	                        color: (0, _CommonUtils.tagToChipColors)(tag).color,
	                        backgroundColor: (0, _CommonUtils.tagToChipColors)(tag).background
	                    } },
	                tag
	            );
	        })
	    );
	};
	
	exports.default = WebinarTags;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(202);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _TimezoneUtils = __webpack_require__(551);
	
	var _WebinarRESTService = __webpack_require__(139);
	
	var _WebinarRESTService2 = _interopRequireDefault(_WebinarRESTService);
	
	var _SpinnerButton = __webpack_require__(542);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _sanitizeHtml = __webpack_require__(1220);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _AccessLabel = __webpack_require__(541);
	
	var _AccessLabel2 = _interopRequireDefault(_AccessLabel);
	
	var _WebinarTags = __webpack_require__(543);
	
	var _WebinarTags2 = _interopRequireDefault(_WebinarTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/**
	 * Mirrors CANONICAL_EXAM_GROUPS from backend/features/webinars/utils/ExamUtils.js
	 * Each entry: { label: display name, keys: all exam_tag values that belong to this group }
	 * Order matters — III before II before I to avoid substring false matches.
	 */
	var CANONICAL_EXAM_DISPLAY = [{ label: 'CFA Level III', keys: ['cfa_3', 'cfa_3_2025', 'cfa_3_2026'] }, { label: 'CFA Level II', keys: ['cfa_2', 'cfa_2_2022', 'cfa_2_2023', 'cfa_2_2025', 'cfa_2_2026'] }, { label: 'CFA Level I', keys: ['cfa_1', 'cfa', 'cfa_2022', 'cfa_2023', 'cfa_2024', 'cfa_2025', 'cfa_2026'] }, { label: 'FRM Part I & Part II', keys: ['frm_1_2'] }, { label: 'FRM Part II', keys: ['frm_2'] }, { label: 'FRM Part I', keys: ['frm'] }, { label: 'SOA P & FM', keys: ['soa_p_fm_ifm'] }, { label: 'SOA IFM', keys: ['soa_ifm'] }, { label: 'SOA FM', keys: ['soa_fm'] }, { label: 'SOA P', keys: ['soa_p'] }, { label: 'SOA', keys: ['soa'] }, { label: 'GMAT Focus', keys: ['gmat_focus'] }, { label: 'GMAT', keys: ['gmat'] }, { label: 'EA', keys: ['ea'] }, { label: 'ESG', keys: ['esg'] }];
	
	function getExamDisplayLabel(exams) {
	    if (!exams || exams.length === 0) return null;
	    var examTags = exams.map(function (e) {
	        return String(e.exam_tag || '').toLowerCase();
	    });
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = CANONICAL_EXAM_DISPLAY[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var group = _step.value;
	
	            if (group.keys.some(function (k) {
	                return examTags.includes(k);
	            })) return group.label;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return null;
	}
	
	function getRegionChipClass(region) {
	    if (!region) return '';
	    var key = region.toLowerCase();
	    return "webinar-card__chip--region-" + key;
	}
	
	var WebinarsListItem = function (_Component) {
	    _inherits(WebinarsListItem, _Component);
	
	    function WebinarsListItem(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, WebinarsListItem);
	
	        var _this = _possibleConstructorReturn(this, (WebinarsListItem.__proto__ || Object.getPrototypeOf(WebinarsListItem)).call(this, props, context));
	
	        _this.getCountdown = function () {
	            var _this$props$item = _this.props.item,
	                datetimeStart = _this$props$item.datetimeStart,
	                datetimeStartTz = _this$props$item.datetimeStartTz,
	                datetimeEnd = _this$props$item.datetimeEnd,
	                datetimeEndTz = _this$props$item.datetimeEndTz;
	
	            if (!datetimeStart) return null;
	            var now = (0, _momentTimezone2.default)();
	            var start = (0, _TimezoneUtils.getWebinarMoment)(datetimeStart, datetimeStartTz);
	            var end = datetimeEnd ? (0, _TimezoneUtils.getWebinarMoment)(datetimeEnd, datetimeEndTz) : null;
	
	            // Session ended
	            if (end && end.diff(now) <= 0) return 'Ended';
	
	            // Session is live — show time remaining with seconds
	            if (start.diff(now) <= 0 && end && end.diff(now) > 0) {
	                var remaining = _momentTimezone2.default.duration(end.diff(now));
	                var _hours = Math.floor(remaining.asHours());
	                var _minutes = remaining.minutes();
	                var seconds = remaining.seconds();
	                var parts = [];
	                if (_hours > 0) parts.push(_hours + "h");
	                parts.push(_minutes + "m");
	                parts.push(seconds + "s");
	                return parts.join(' ') + ' left';
	            }
	
	            // Upcoming — show countdown to start
	            var diff = start.diff(now);
	            if (diff <= 0) return null;
	            var duration = _momentTimezone2.default.duration(diff);
	            var days = Math.floor(duration.asDays());
	            var hours = duration.hours();
	            var minutes = duration.minutes();
	            return days + "d " + hours + "h " + minutes + "m";
	        };
	
	        _this.__setLoadingDeferred = function (state) {
	            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	
	            setTimeout(function () {
	                _this.setState({ actionLoading: state }, function () {});
	            }, time);
	        };
	
	        _this.__setLoadingAsync = function (value) {
	            return new Promise(function (resolve, reject) {
	                _this.setState({ actionLoading: value }, function () {
	                    resolve();
	                });
	            });
	        };
	
	        _this.__testTimeout = function () {
	            return new Promise(function (resolve, reject) {
	                setTimeout(function () {
	                    resolve(true);
	                }, 10000);
	            });
	        };
	
	        _this.handleRegister = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var requestData;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            if (!(_this.props.item == null || _this.props.item.id == null || _this.props.userData == null || _this.props.userData.token == null)) {
	                                _context.next = 3;
	                                break;
	                            }
	
	                            throw new Error("Webinar id is null");
	
	                        case 3:
	                            _context.next = 5;
	                            return _this.__setLoadingAsync(true);
	
	                        case 5:
	                            requestData = {
	                                id: _this.props.item.id,
	                                preferredTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	                                preferredTimezoneOffset: new Date().getTimezoneOffset(),
	                                preferredLanguage: navigator.language
	                            };
	                            _context.next = 8;
	                            return new _WebinarRESTService2.default().setAuthHeader(_this.props.userData.token).createRegistration(requestData);
	
	                        case 8:
	                            if (!_this.props.onWebinarUpdate) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.next = 11;
	                            return _this.props.onWebinarUpdate(_this.props.item.id);
	
	                        case 11:
	                            _context.next = 16;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context["catch"](0);
	
	                            console.log("Error in handleRegister: ", _context.t0);
	
	                        case 16:
	                            _context.prev = 16;
	
	                            _this.__setLoadingDeferred(false);
	                            return _context.finish(16);
	
	                        case 19:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 13, 16, 19]]);
	        }));
	
	        _this.handleCancelClick = function () {
	            if (window.confirm("Are you sure you want to cancel registration on this webinar?")) {
	                _this.handleCancel();
	            }
	        };
	
	        _this.handleCancel = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var registrationId;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	
	                            if (!(_this.props.item == null || _this.props.item.user_registration == null || _this.props.userData == null || _this.props.userData.token == null)) {
	                                _context2.next = 3;
	                                break;
	                            }
	
	                            throw new Error("Cannot cancel: missing registration data");
	
	                        case 3:
	                            _context2.next = 5;
	                            return _this.__setLoadingAsync(true);
	
	                        case 5:
	                            registrationId = _this.props.item.user_registration.id;
	                            _context2.next = 8;
	                            return new _WebinarRESTService2.default().setAuthHeader(_this.props.userData.token).cancelRegistration({ id: registrationId });
	
	                        case 8:
	                            if (!_this.props.onWebinarUpdate) {
	                                _context2.next = 11;
	                                break;
	                            }
	
	                            _context2.next = 11;
	                            return _this.props.onWebinarUpdate(_this.props.item.id);
	
	                        case 11:
	                            _context2.next = 16;
	                            break;
	
	                        case 13:
	                            _context2.prev = 13;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.log("Error in handleCancel: ", _context2.t0);
	
	                        case 16:
	                            _context2.prev = 16;
	
	                            _this.__setLoadingDeferred(false);
	                            return _context2.finish(16);
	
	                        case 19:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this2, [[0, 13, 16, 19]]);
	        }));
	
	        _this.renderActionButton = function () {
	            var _this$props$item2 = _this.props.item,
	                user_registration = _this$props$item2.user_registration,
	                seatsTotal = _this$props$item2.seatsTotal,
	                seatsTaken = _this$props$item2.seatsTaken,
	                accessibility = _this$props$item2.accessibility;
	            var actionLoading = _this.state.actionLoading;
	
	            var isRegistered = user_registration != null;
	            var registeredStatus = isRegistered ? user_registration.registration_status : 'unknown';
	            var isFull = seatsTotal > 0 && seatsTaken >= seatsTotal;
	            var countdown = _this.getCountdown();
	
	            if (accessibility === false) {
	                var url = _this.makeUpgradeUrlFromExams();
	                return _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__actions" },
	                    _react2.default.createElement(
	                        "a",
	                        { href: url,
	                            className: "webinar-card__button webinar-card__button--upgrade",
	                            disabled: true
	                        },
	                        "Upgrade to register"
	                    )
	                );
	            }
	
	            // Session full and not registered
	            if (!isRegistered && isFull) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__actions" },
	                    _react2.default.createElement(
	                        _SpinnerButton2.default,
	                        {
	                            className: "webinar-card__button webinar-card__button--full",
	                            disabled: true
	                        },
	                        "Session Full"
	                    )
	                );
	            }
	
	            // Registered — status box with "Open in Teams" button
	            if (registeredStatus === 'registered') {
	                var joinUrl = user_registration.joinUrl;
	                return _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__status-box webinar-card__status-box--registered" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__status-header" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "webinar-card__status-text webinar-card__status-text--registered" },
	                            _react2.default.createElement(
	                                "svg",
	                                { className: "webinar-card__status-icon", viewBox: "0 0 20 20", fill: "#22c55e", width: "16", height: "16" },
	                                _react2.default.createElement("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" })
	                            ),
	                            "Registered"
	                        ),
	                        countdown && _react2.default.createElement(
	                            "span",
	                            { className: "webinar-card__countdown" },
	                            countdown
	                        )
	                    ),
	                    joinUrl && _react2.default.createElement(
	                        "a",
	                        { href: joinUrl, target: "_blank", rel: "noopener noreferrer", className: "webinar-card__join-btn" },
	                        _react2.default.createElement(
	                            "svg",
	                            { viewBox: "0 0 20 20", fill: "currentColor", width: "16", height: "16" },
	                            _react2.default.createElement("path", { d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" }),
	                            _react2.default.createElement("path", { d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" })
	                        ),
	                        "Open in Teams"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "webinar-card__cancel-link", onClick: !actionLoading ? _this.handleCancelClick : undefined },
	                        actionLoading ? 'Cancelling...' : 'Cancel registration'
	                    )
	                );
	            }
	
	            // Pending Approval — status box with info message
	            if (registeredStatus === 'pendingApproval') {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__status-box webinar-card__status-box--pending" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__status-header" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "webinar-card__status-text webinar-card__status-text--pending" },
	                            "\u23F3 Pending Approval"
	                        ),
	                        countdown && _react2.default.createElement(
	                            "span",
	                            { className: "webinar-card__countdown" },
	                            countdown
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "webinar-card__status-message" },
	                        "Your join link will be available once approved."
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "webinar-card__cancel-link", onClick: !actionLoading ? _this.handleCancelClick : undefined },
	                        actionLoading ? 'Cancelling...' : 'Cancel registration'
	                    )
	                );
	            }
	
	            // Unknown future value
	            if (registeredStatus === 'unknownFutureValue') {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__actions" },
	                    _react2.default.createElement(
	                        _SpinnerButton2.default,
	                        {
	                            className: "webinar-card__button webinar-card__button--future",
	                            disabled: true
	                        },
	                        "Pending"
	                    )
	                );
	            }
	
	            // Default — Register button
	            var registerLoading = actionLoading;
	            return _react2.default.createElement(
	                "div",
	                { className: "webinar-card__actions" },
	                _react2.default.createElement(
	                    _SpinnerButton2.default,
	                    {
	                        className: "webinar-card__button",
	                        onClick: _this.handleRegister,
	                        loading: registerLoading
	                    },
	                    registerLoading ? 'Registering...' : 'Register'
	                )
	            );
	        };
	
	        _this.state = {
	            actionLoading: false,
	            showModal: false
	        };
	        return _this;
	    }
	
	    _createClass(WebinarsListItem, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._startCountdownTimer();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this._countdownInterval) {
	                clearInterval(this._countdownInterval);
	            }
	        }
	    }, {
	        key: "_startCountdownTimer",
	        value: function _startCountdownTimer() {
	            var _this3 = this;
	
	            // Live sessions tick every second for seconds precision;
	            // upcoming sessions tick every minute
	            var sessionState = this.props.item.sessionState;
	
	            var interval = sessionState === 'live' ? 1000 : 60000;
	            this._countdownInterval = setInterval(function () {
	                _this3.forceUpdate();
	            }, interval);
	        }
	
	        /**
	         * Returns a countdown/status string based on session state:
	         *  - Upcoming:  "3d 2h 15m"
	         *  - Live now:  "1h 30m left"
	         *  - Ended:     "Ended"
	         */
	
	    }, {
	        key: "createMarkup",
	        value: function createMarkup(html) {
	            return {
	                __html: (0, _sanitizeHtml2.default)(html || '', {
	                    allowedTags: ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'a', 'span', 'div'],
	                    allowedAttributes: {
	                        a: ['href', 'target', 'rel'],
	                        span: ['class'],
	                        div: ['class']
	                    },
	                    allowedSchemes: ['http', 'https', 'mailto']
	                })
	            };
	        }
	
	        //TODO: Extend on other exams
	
	    }, {
	        key: "makeUpgradeUrlFromExams",
	        value: function makeUpgradeUrlFromExams() {
	            var exams = this.props.item.exams;
	
	            if (exams == null || exams.length === 0) return null;
	            function findPrimaryExam() {
	                var relatedExams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                var exams = relatedExams.filter(function (item) {
	                    return item && item.exam_tag && item.exam_id;
	                }).map(function (item) {
	                    return {
	                        exam_id: item.exam_id,
	                        exam_tag: String(item.exam_tag).trim().toLowerCase()
	                    };
	                });
	
	                return exams.find(function (x) {
	                    return x.exam_tag === 'cfa';
	                }) || exams.find(function (x) {
	                    return x.exam_tag === 'cfa_2';
	                }) || exams.find(function (x) {
	                    return x.exam_tag === 'cfa_3';
	                }) || exams.find(function (x) {
	                    return (/^cfa(?:_\d{4})?$/.test(x.exam_tag)
	                    );
	                }) || exams.find(function (x) {
	                    return (/^cfa_2(?:_\d{4})?$/.test(x.exam_tag)
	                    );
	                }) || exams.find(function (x) {
	                    return (/^cfa_3(?:_\d{4})?$/.test(x.exam_tag)
	                    );
	                }) || exams[0] || null;
	            }
	
	            function normalizeExamTagForSubscribe() {
	                var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	                var examTag = String(tag).trim().toLowerCase();
	
	                // Map DB exam_name variants to the canonical UI keys used by
	                // /subscribe/selectPackage/:uiKey/:examId (see backend
	                // canonicalExamGroupCheck.js UI_TO_DB_MATCH).
	                if (/^cfa_2(?:_\d{4})?$/.test(examTag)) return 'cfa2';
	                if (/^cfa_3(?:_\d{4})?$/.test(examTag)) return 'cfa3';
	                if (/^cfa(?:_\d{4})?$/.test(examTag)) return 'cfa1';
	
	                return examTag;
	            }
	
	            function buildSubscribeUrl() {
	                var relatedExams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	                var exam = findPrimaryExam(relatedExams);
	                if (!exam) return null;
	
	                var normalizedTag = normalizeExamTagForSubscribe(exam.exam_tag);
	                return "/subscribe/selectPackage/" + normalizedTag + "/" + exam.exam_id;
	            }
	            return buildSubscribeUrl(exams);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            if (this.props.item == null) {
	                return null;
	            }
	            var _props$item = this.props.item,
	                accessibility = _props$item.accessibility,
	                title = _props$item.title,
	                description = _props$item.description,
	                datetimeStart = _props$item.datetimeStart,
	                datetimeStartTz = _props$item.datetimeStartTz,
	                datetimeEnd = _props$item.datetimeEnd,
	                datetimeEndTz = _props$item.datetimeEndTz,
	                durationMinutes = _props$item.durationMinutes,
	                instructorName = _props$item.instructorName,
	                _props$item$presenter = _props$item.presenters,
	                presenters = _props$item$presenter === undefined ? [] : _props$item$presenter,
	                tags = _props$item.tags,
	                webinarStatus = _props$item.webinarStatus,
	                user_registration = _props$item.user_registration,
	                capacity = _props$item.capacity,
	                eligibilityLevel = _props$item.eligibilityLevel,
	                raw_description = _props$item.raw_description,
	                region = _props$item.region,
	                exams = _props$item.exams,
	                sessionState = _props$item.sessionState;
	
	
	            var isLiveNow = sessionState === 'live';
	
	            var cardClassName = ['webinar-card', isLiveNow ? 'webinar-card--live-now' : ''].filter(Boolean).join(' ');
	
	            // const accessLabel = eligibilityLevel != null && eligibilityLevel.length > 0 ? capitalizeFirstLetter(eligibilityLevel) : null;
	
	            var filteredPresenters = presenters.length > 0 && presenters.filter(function (i) {
	                return i !== instructorName;
	            });
	
	            var listPresenters = filteredPresenters.length > 0 ? filteredPresenters.join(', ') : null;
	
	            // const isRegistered = user_registration != null;
	            // const registeredStatus = isRegistered ? user_registration.registration_status : 'unknown';
	
	            var countdown = this.getCountdown();
	            var durationTimes = durationMinutes != null && durationMinutes > 0 ? (0, _CommonUtils.formatMinutesToHHMMSS)(durationMinutes) : null;
	            var startConverted = (0, _TimezoneUtils.convertWebinarTime)(datetimeStart, datetimeStartTz, 'ddd DD, MMM - h:mm A');
	            var endConverted = (0, _TimezoneUtils.convertWebinarTime)(datetimeEnd, datetimeEndTz, 'h:mm A');
	            var startDateFormat = startConverted.formatted;
	            var endTimeFormat = endConverted.formatted;
	            var tzAbbr = startConverted.tzAbbr;
	
	            return _react2.default.createElement(
	                "article",
	                { className: cardClassName },
	                _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__header" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__top" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "webinar-card__badges-left" },
	                            isLiveNow ? _react2.default.createElement(
	                                "span",
	                                { className: "webinar-card__badge webinar-card__badge--live" },
	                                _react2.default.createElement("span", { className: "webinar-card__badge-dot webinar-card__badge-dot--live" }),
	                                "LIVE NOW"
	                            ) : _react2.default.createElement(
	                                "span",
	                                { className: "webinar-card__badge" },
	                                _react2.default.createElement("span", { className: "webinar-card__badge-dot" }),
	                                "UPCOMING"
	                            ),
	                            getExamDisplayLabel(exams) && _react2.default.createElement(
	                                "span",
	                                { className: "webinar-card__chip webinar-card__chip--exam" },
	                                getExamDisplayLabel(exams)
	                            ),
	                            region && _react2.default.createElement(
	                                "span",
	                                { className: 'webinar-card__chip webinar-card__chip--region ' + getRegionChipClass(region) },
	                                region || ""
	                            )
	                        ),
	                        _react2.default.createElement(_AccessLabel2.default, { accessibility: accessibility, eligibilityLevel: eligibilityLevel })
	                    ),
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "webinar-card__title" },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__body" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__description" },
	                        description
	                    ),
	                    description && description.length > 0 && _react2.default.createElement(
	                        "span",
	                        { className: "webinar-card__readmore", onClick: function onClick() {
	                                return _this4.setState({ showModal: true });
	                            } },
	                        "Read more"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "webinar-card__footer" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__meta" },
	                        isLiveNow && countdown ? _react2.default.createElement(
	                            "div",
	                            { className: "webinar-card__live-remaining" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "wb-svg-icon-16" },
	                                _react2.default.createElement(
	                                    "svg",
	                                    { viewBox: "0 0 24 24", fill: "none", stroke: "#dc2626", strokeWidth: "2" },
	                                    _react2.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
	                                    _react2.default.createElement("polyline", { points: "12,6 12,12 16,14" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                countdown
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: "webinar-card__meta-item" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "wb-svg-icon-16" },
	                                _react2.default.createElement(
	                                    "svg",
	                                    { viewBox: "0 0 24 24", fill: "none", stroke: "#5a6a7a", strokeWidth: "2" },
	                                    _react2.default.createElement("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }),
	                                    _react2.default.createElement("line", { x1: "16", y1: "2", x2: "16", y2: "6" }),
	                                    _react2.default.createElement("line", { x1: "8", y1: "2", x2: "8", y2: "6" }),
	                                    _react2.default.createElement("line", { x1: "3", y1: "10", x2: "21", y2: "10" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                startDateFormat,
	                                " ",
	                                tzAbbr
	                            )
	                        ),
	                        !isLiveNow && _react2.default.createElement(
	                            "div",
	                            { className: "webinar-card__meta-item" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "wb-svg-icon-16" },
	                                _react2.default.createElement(
	                                    "svg",
	                                    { viewBox: "0 0 24 24", fill: "none", stroke: "#5a6a7a", strokeWidth: "2" },
	                                    _react2.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
	                                    _react2.default.createElement("polyline", { points: "12,6 12,12 16,14" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                durationTimes.hours,
	                                "h ",
	                                durationTimes.minutes,
	                                "m "
	                            )
	                        )
	                    ),
	                    instructorName != null && instructorName.length > 0 && instructorName.trim().length > 0 ? _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__speaker" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "wb-svg-icon-16" },
	                            _react2.default.createElement(
	                                "svg",
	                                { viewBox: "0 0 24 24", fill: "none", stroke: "#5a6a7a", strokeWidth: "2" },
	                                _react2.default.createElement("path", { d: "M20,21v-2a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" }),
	                                _react2.default.createElement("circle", { cx: "12", cy: "7", r: "4" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            instructorName
	                        )
	                    ) : null,
	                    listPresenters != null && listPresenters.length > 0 ?
	                    // listPresenters.map((presenter, index) => (
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-card__speaker" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "wb-svg-icon-16" },
	                            _react2.default.createElement(
	                                "svg",
	                                { viewBox: "0 0 24 24", fill: "none", stroke: "#5a6a7a", strokeWidth: "2" },
	                                _react2.default.createElement("path", { d: "M20,21v-2a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" }),
	                                _react2.default.createElement("circle", { cx: "12", cy: "7", r: "4" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            listPresenters
	                        )
	                    )
	                    // ))
	                    : null,
	                    _react2.default.createElement(_WebinarTags2.default, { tags: tags }),
	                    this.renderActionButton()
	                ),
	                this.state.showModal && _react2.default.createElement(
	                    "div",
	                    { className: "webinar-modal__overlay", onClick: function onClick() {
	                            return _this4.setState({ showModal: false });
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-modal__content", onClick: function onClick(e) {
	                                return e.stopPropagation();
	                            } },
	                        _react2.default.createElement(
	                            "button",
	                            { className: "webinar-modal__close", onClick: function onClick() {
	                                    return _this4.setState({ showModal: false });
	                                }, type: "button" },
	                            _react2.default.createElement(
	                                "svg",
	                                { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", width: "20", height: "20" },
	                                _react2.default.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
	                                _react2.default.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
	                            )
	                        ),
	                        isLiveNow ? _react2.default.createElement(
	                            "span",
	                            { className: "webinar-card__badge webinar-card__badge--live" },
	                            _react2.default.createElement("span", { className: "webinar-card__badge-dot webinar-card__badge-dot--live" }),
	                            "LIVE NOW"
	                        ) : _react2.default.createElement(
	                            "span",
	                            { className: "webinar-card__badge" },
	                            _react2.default.createElement("span", { className: "webinar-card__badge-dot" }),
	                            "UPCOMING"
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "webinar-modal__title" },
	                            title
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "webinar-modal__meta" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "webinar-card__meta-item" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "wb-svg-icon-16" },
	                                    _react2.default.createElement(
	                                        "svg",
	                                        { viewBox: "0 0 24 24", fill: "none", stroke: "#5a6a7a", strokeWidth: "2" },
	                                        _react2.default.createElement("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }),
	                                        _react2.default.createElement("line", { x1: "16", y1: "2", x2: "16", y2: "6" }),
	                                        _react2.default.createElement("line", { x1: "8", y1: "2", x2: "8", y2: "6" }),
	                                        _react2.default.createElement("line", { x1: "3", y1: "10", x2: "21", y2: "10" })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    startDateFormat,
	                                    endTimeFormat ? " - " + endTimeFormat : '',
	                                    " ",
	                                    tzAbbr
	                                )
	                            ),
	                            durationTimes && _react2.default.createElement(
	                                "span",
	                                { className: "webinar-card__meta-item" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "wb-svg-icon-16" },
	                                    _react2.default.createElement(
	                                        "svg",
	                                        { viewBox: "0 0 24 24", fill: "none", stroke: "#5a6a7a", strokeWidth: "2" },
	                                        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
	                                        _react2.default.createElement("polyline", { points: "12,6 12,12 16,14" })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    durationTimes.hours,
	                                    "h ",
	                                    durationTimes.minutes,
	                                    "m"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_WebinarTags2.default, { tags: tags, isModal: true }),
	                        _react2.default.createElement("div", { className: "webinar-modal__description", dangerouslySetInnerHTML: this.createMarkup(raw_description) })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WebinarsListItem;
	}(_react.Component);
	
	exports.default = WebinarsListItem;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(534);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Sidebar = __webpack_require__(540);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Footer = __webpack_require__(531);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _IntercomWidget = __webpack_require__(537);
	
	var _IntercomWidget2 = _interopRequireDefault(_IntercomWidget);
	
	var _AITutorChat = __webpack_require__(527);
	
	var _AITutorChat2 = _interopRequireDefault(_AITutorChat);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _constant = __webpack_require__(9);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _examUrlResolver = __webpack_require__(526);
	
	var _service = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/* eslint-disable*/
	var Full = function (_Component) {
	  _inherits(Full, _Component);
	
	  function Full(props) {
	    _classCallCheck(this, Full);
	
	    var _this = _possibleConstructorReturn(this, (Full.__proto__ || Object.getPrototypeOf(Full)).call(this, props));
	
	    var pathname = props.location && props.location.pathname;
	    console.log("Full pathname: ", pathname);
	    _this.state = {
	      isChildChanged: false,
	      // #292: when the opening URL belongs to a different exam than the stored selection,
	      // gate rendering so child pages don't mount and fetch with the stale exam. The
	      // actual switch + reload happens in componentDidMount.
	      examSwitching: _this.needsExamSwitch(pathname)
	    };
	    return _this;
	  }
	
	  // True when the URL maps to an exam family that differs from the currently selected one
	  // and we can resolve a concrete year-code to switch to. Pure/synchronous.
	
	
	  _createClass(Full, [{
	    key: 'needsExamSwitch',
	    value: function needsExamSwitch(pathname) {
	      // Only reconcile for a logged-in session — updateSelectedExam needs the stored token.
	      if (!localStorage.getItem('localstorageval')) {
	        return false;
	      }
	      var currentCode = localStorage.getItem('selectedmenu');
	      var targetCode = (0, _examUrlResolver.resolveExamCodeForPath)(pathname, currentCode);
	      // targetCode is null for same-family / no-exam paths (no switch); a `/next/` path forces
	      // cfa_2027 even within the CFA1 family.
	      return targetCode != null && targetCode !== currentCode;
	    }
	
	    // Reconcile the stored selection to the URL's exam, then hard-reload the same URL.
	    // Mirrors the header dropdown: /updateExamSelected refreshes the Redis session + profile
	    // cache asynchronously (user.js .finally emit), and the reload's round-trip gives that
	    // refresh time to land before the page refetches. See spec 2026-06-24-292.
	
	  }, {
	    key: 'performExamSwitch',
	    value: function performExamSwitch(pathname) {
	      var currentCode = localStorage.getItem('selectedmenu');
	      var targetCode = (0, _examUrlResolver.resolveExamCodeForPath)(pathname, currentCode);
	      if (!targetCode) {
	        this.setState({ examSwitching: false });
	        return;
	      }
	      localStorage.setItem('selectedmenu', targetCode);
	      var data = {
	        exam_selected: targetCode,
	        organizationDomain: localStorage.getItem('organizationDomain'),
	        role: localStorage.getItem('role')
	      };
	      var reload = function reload() {
	        window.location.reload();
	      };
	      try {
	        (0, _service.updateSelectedExam)(data).then(reload).catch(reload);
	      } catch (e) {
	        // Never strand the loader if the call throws synchronously (e.g. missing session).
	        this.setState({ examSwitching: false });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var pathname;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                pathname = this.props.location && this.props.location.pathname;
	
	                if (!this.state.examSwitching) {
	                  _context.next = 4;
	                  break;
	                }
	
	                // A reload is imminent; skip the profile fetch and switch the exam.
	                this.performExamSwitch(pathname);
	                return _context.abrupt('return');
	
	              case 4:
	                _context.next = 6;
	                return _userStore2.default.getUserProfile();
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    // Catch client-side navigation to a different exam's URL (links that bypass the dropdown).
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextPath = nextProps.location && nextProps.location.pathname;
	      var currentPath = this.props.location && this.props.location.pathname;
	      if (nextPath && nextPath !== currentPath && !this.state.examSwitching && this.needsExamSwitch(nextPath)) {
	        this.setState({ examSwitching: true });
	        this.performExamSwitch(nextPath);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // #292: while reconciling the exam to the opening URL, render a minimal loader so the
	      // child page never mounts/fetches with the stale exam. A hard reload follows.
	      if (this.state.examSwitching) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'app' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      }
	      var value = localStorage.getItem('signup') || 0;
	      var tagManagerArgs = {
	        gtmId: _constant.GTM_ID,
	        events: {
	          sendUserInfo: 'userInfo'
	        },
	        dataLayer: {
	          page: 'Home',
	          signup: value,
	          currency: 'USD'
	        }
	      };
	      _reactGtmModule2.default.initialize(tagManagerArgs);
	      localStorage.removeItem('signup');
	      var isChildChanged = this.state.isChildChanged;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'app' },
	        _react2.default.createElement(
	          'a',
	          { href: '#main-content', className: 'skip-link' },
	          'Skip to main content'
	        ),
	        _react2.default.createElement(_Header2.default, Object.assign({}, this.props, {
	          isChildChanged: isChildChanged,
	          setIsChildChangedFalse: function setIsChildChangedFalse() {
	            return _this2.setState({ isChildChanged: false });
	          }
	        })),
	        _react2.default.createElement(
	          'div',
	          { className: 'app-body' },
	          _react2.default.createElement(_Sidebar2.default, Object.assign({}, this.props, {
	            isChildChanged: isChildChanged,
	            setIsChildChangedFalse: function setIsChildChangedFalse() {
	              return _this2.setState({ isChildChanged: false });
	            },
	            style: outerWidth = 120 + '%'
	          })),
	          _react2.default.createElement(
	            'main',
	            { className: 'main', id: 'main-content', tabIndex: '-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container-fluid' },
	              ' ',
	              _react2.default.cloneElement(this.props.children, {
	                setIsChildChangedTrue: function setIsChildChangedTrue() {
	                  return _this2.setState({ isChildChanged: true });
	                }
	              })
	            ),
	            _react2.default.createElement(_IntercomWidget2.default, null),
	            _react2.default.createElement(_AITutorChat2.default, { ref: function ref(c) {
	                _this2.tutor = c;
	              } })
	          ),
	          _react2.default.createElement(_Footer2.default, Object.assign({ exam_name: this.props.params.exam_name }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return Full;
	}(_react.Component);
	
	exports.default = Full;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Simple = function (_Component) {
	  _inherits(Simple, _Component);
	
	  function Simple() {
	    _classCallCheck(this, Simple);
	
	    return _possibleConstructorReturn(this, (Simple.__proto__ || Object.getPrototypeOf(Simple)).apply(this, arguments));
	  }
	
	  _createClass(Simple, [{
	    key: "render",
	    value: function render() {
	      // console.log(window.location.hostname)
	      var domain_name = window.location.hostname;
	      localStorage.setItem("domainName", domain_name);
	      var domainApp = localStorage.getItem("domainName");
	      if (domainApp === "localhosts") {
	        // console.log('WORLD APP')
	        // localStorage.setItem("domainApp", "WORLD");
	
	        localStorage.setItem("domainApp", "CHINA");
	      } else {
	        // console.log('CHINA APP')
	        // localStorage.setItem("domainApp", "CHINA");
	        localStorage.setItem("domainApp", "WORLD");
	      }
	      var tagManagerArgs = {
	        gtmId: "GTM-KF7B5DD",
	        events: {
	          sendUserInfo: "userInfo"
	        },
	        dataLayer: {
	          page: "Sign up"
	        }
	      };
	      _reactGtmModule2.default.initialize(tagManagerArgs);
	      return _react2.default.createElement(
	        "div",
	        { className: "" },
	        _react2.default.createElement(
	          "a",
	          { href: "#main-content", className: "skip-link" },
	          "Skip to main content"
	        ),
	        _react2.default.createElement(
	          "main",
	          { id: "main-content", tabIndex: "-1" },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Simple;
	}(_react.Component);
	
	exports.default = Simple;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _routes = __webpack_require__(548);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reactDom = __webpack_require__(88);
	
	var _SessionWatcher = __webpack_require__(844);
	
	var _SessionWatcher2 = _interopRequireDefault(_SessionWatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootElement = document.getElementById("root");
	var app = _react2.default.createElement(
	  _SessionWatcher2.default,
	  null,
	  _react2.default.createElement(_reactRouter.Router, { routes: _routes2.default, history: _reactRouter.browserHistory })
	);
	
	if (rootElement.hasChildNodes()) {
	  (0, _reactDom.hydrate)(app, rootElement);
	} else {
	  (0, _reactDom.render)(app, rootElement);
	}

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _Tutor = __webpack_require__(625);
	
	var _Tutor2 = _interopRequireDefault(_Tutor);
	
	var _index = __webpack_require__(587);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(588);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(589);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(590);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(591);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _index11 = __webpack_require__(592);
	
	var _index12 = _interopRequireDefault(_index11);
	
	var _ViewAllQues = __webpack_require__(595);
	
	var _ViewAllQues2 = _interopRequireDefault(_ViewAllQues);
	
	var _index13 = __webpack_require__(596);
	
	var _index14 = _interopRequireDefault(_index13);
	
	var _index15 = __webpack_require__(609);
	
	var _index16 = _interopRequireDefault(_index15);
	
	var _ReadingsList = __webpack_require__(602);
	
	var _ReadingsList2 = _interopRequireDefault(_ReadingsList);
	
	var _ViewNotes = __webpack_require__(605);
	
	var _ViewNotes2 = _interopRequireDefault(_ViewNotes);
	
	var _NotesList = __webpack_require__(608);
	
	var _NotesList2 = _interopRequireDefault(_NotesList);
	
	var _index17 = __webpack_require__(631);
	
	var _index18 = _interopRequireDefault(_index17);
	
	var _VideoPlayList = __webpack_require__(630);
	
	var _VideoPlayList2 = _interopRequireDefault(_VideoPlayList);
	
	var _index19 = __webpack_require__(621);
	
	var _index20 = _interopRequireDefault(_index19);
	
	var _ReadingsList3 = __webpack_require__(614);
	
	var _ReadingsList4 = _interopRequireDefault(_ReadingsList3);
	
	var _QuestionsList = __webpack_require__(620);
	
	var _QuestionsList2 = _interopRequireDefault(_QuestionsList);
	
	var _QuestionView = __webpack_require__(617);
	
	var _QuestionView2 = _interopRequireDefault(_QuestionView);
	
	var _BeforeStart = __webpack_require__(622);
	
	var _BeforeStart2 = _interopRequireDefault(_BeforeStart);
	
	var _BeginQuiz = __webpack_require__(623);
	
	var _BeginQuiz2 = _interopRequireDefault(_BeginQuiz);
	
	var _Quizzes = __webpack_require__(624);
	
	var _Quizzes2 = _interopRequireDefault(_Quizzes);
	
	var _Full = __webpack_require__(545);
	
	var _Full2 = _interopRequireDefault(_Full);
	
	var _Simple = __webpack_require__(546);
	
	var _Simple2 = _interopRequireDefault(_Simple);
	
	var _Cfa3Dashboard = __webpack_require__(660);
	
	var _Cfa3Dashboard2 = _interopRequireDefault(_Cfa3Dashboard);
	
	var _Auth = __webpack_require__(842);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ResetPassword = __webpack_require__(843);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _Filldetails = __webpack_require__(850);
	
	var _Filldetails2 = _interopRequireDefault(_Filldetails);
	
	var _Selectexam = __webpack_require__(852);
	
	var _Selectexam2 = _interopRequireDefault(_Selectexam);
	
	var _Profile = __webpack_require__(855);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _BeforeStart3 = __webpack_require__(811);
	
	var _BeforeStart4 = _interopRequireDefault(_BeforeStart3);
	
	var _BeginCasequiz = __webpack_require__(812);
	
	var _BeginCasequiz2 = _interopRequireDefault(_BeginCasequiz);
	
	var _BeginGraphQuiz = __webpack_require__(813);
	
	var _BeginGraphQuiz2 = _interopRequireDefault(_BeginGraphQuiz);
	
	var _BeginTableQuiz = __webpack_require__(814);
	
	var _BeginTableQuiz2 = _interopRequireDefault(_BeginTableQuiz);
	
	var _BeginTabsQuiz = __webpack_require__(815);
	
	var _BeginTabsQuiz2 = _interopRequireDefault(_BeginTabsQuiz);
	
	var _BeginTwopartQuiz = __webpack_require__(816);
	
	var _BeginTwopartQuiz2 = _interopRequireDefault(_BeginTwopartQuiz);
	
	var _Beginquiz = __webpack_require__(817);
	
	var _Beginquiz2 = _interopRequireDefault(_Beginquiz);
	
	var _Quizzes3 = __webpack_require__(818);
	
	var _Quizzes4 = _interopRequireDefault(_Quizzes3);
	
	var _PremiumCheckout = __webpack_require__(854);
	
	var _PremiumCheckout2 = _interopRequireDefault(_PremiumCheckout);
	
	var _Subscribe = __webpack_require__(895);
	
	var _Subscribe2 = _interopRequireDefault(_Subscribe);
	
	var _SelectPackage = __webpack_require__(894);
	
	var _SelectPackage2 = _interopRequireDefault(_SelectPackage);
	
	var _Addons = __webpack_require__(552);
	
	var _Addons2 = _interopRequireDefault(_Addons);
	
	var _Cfa3flashquestion = __webpack_require__(675);
	
	var _Cfa3flashquestion2 = _interopRequireDefault(_Cfa3flashquestion);
	
	var _Cfa3savedquestion = __webpack_require__(676);
	
	var _Cfa3savedquestion2 = _interopRequireDefault(_Cfa3savedquestion);
	
	var _Cart = __webpack_require__(683);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _Checkout = __webpack_require__(684);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _paymentProcessing = __webpack_require__(685);
	
	var _paymentProcessing2 = _interopRequireDefault(_paymentProcessing);
	
	var _ChangePassword = __webpack_require__(686);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _OrderDiscription = __webpack_require__(839);
	
	var _OrderDiscription2 = _interopRequireDefault(_OrderDiscription);
	
	var _OrderHistory = __webpack_require__(840);
	
	var _OrderHistory2 = _interopRequireDefault(_OrderHistory);
	
	var _AppSumo = __webpack_require__(841);
	
	var _AppSumo2 = _interopRequireDefault(_AppSumo);
	
	var _Cfa3EssayQuesPdf = __webpack_require__(847);
	
	var _Cfa3EssayQuesPdf2 = _interopRequireDefault(_Cfa3EssayQuesPdf);
	
	var _CheckoutVerify = __webpack_require__(848);
	
	var _CheckoutVerify2 = _interopRequireDefault(_CheckoutVerify);
	
	var _FrmPdf = __webpack_require__(851);
	
	var _FrmPdf2 = _interopRequireDefault(_FrmPdf);
	
	var _Unsubscribe = __webpack_require__(853);
	
	var _Unsubscribe2 = _interopRequireDefault(_Unsubscribe);
	
	var _SetPassword = __webpack_require__(893);
	
	var _SetPassword2 = _interopRequireDefault(_SetPassword);
	
	var _SubscriptionDetail = __webpack_require__(897);
	
	var _SubscriptionDetail2 = _interopRequireDefault(_SubscriptionDetail);
	
	var _Thankyou = __webpack_require__(898);
	
	var _Thankyou2 = _interopRequireDefault(_Thankyou);
	
	var _WordPressThankYou = __webpack_require__(899);
	
	var _WordPressThankYou2 = _interopRequireDefault(_WordPressThankYou);
	
	var _Cfa3BeforeStart = __webpack_require__(658);
	
	var _Cfa3BeforeStart2 = _interopRequireDefault(_Cfa3BeforeStart);
	
	var _Cfa3Beginquiz = __webpack_require__(659);
	
	var _Cfa3Beginquiz2 = _interopRequireDefault(_Cfa3Beginquiz);
	
	var _Cfa3EssayQuestions = __webpack_require__(662);
	
	var _Cfa3EssayQuestions2 = _interopRequireDefault(_Cfa3EssayQuestions);
	
	var _Cfa3QuestionBank = __webpack_require__(671);
	
	var _Cfa3QuestionBank2 = _interopRequireDefault(_Cfa3QuestionBank);
	
	var _Cfa3Quizzes = __webpack_require__(672);
	
	var _Cfa3Quizzes2 = _interopRequireDefault(_Cfa3Quizzes);
	
	var _Cfa3cases = __webpack_require__(673);
	
	var _Cfa3cases2 = _interopRequireDefault(_Cfa3cases);
	
	var _Cfa3chapter = __webpack_require__(674);
	
	var _Cfa3chapter2 = _interopRequireDefault(_Cfa3chapter);
	
	var _Notes = __webpack_require__(677);
	
	var _Notes2 = _interopRequireDefault(_Notes);
	
	var _NotesViewques = __webpack_require__(678);
	
	var _NotesViewques2 = _interopRequireDefault(_NotesViewques);
	
	var _Notesbeginchapters = __webpack_require__(679);
	
	var _Notesbeginchapters2 = _interopRequireDefault(_Notesbeginchapters);
	
	var _Notesreadings = __webpack_require__(680);
	
	var _Notesreadings2 = _interopRequireDefault(_Notesreadings);
	
	var _Cfavideodisplay = __webpack_require__(681);
	
	var _Cfavideodisplay2 = _interopRequireDefault(_Cfavideodisplay);
	
	var _VideoLessons = __webpack_require__(682);
	
	var _VideoLessons2 = _interopRequireDefault(_VideoLessons);
	
	var _BeforeStart5 = __webpack_require__(872);
	
	var _BeforeStart6 = _interopRequireDefault(_BeforeStart5);
	
	var _Beginchapters = __webpack_require__(873);
	
	var _Beginchapters2 = _interopRequireDefault(_Beginchapters);
	
	var _Beginquiz3 = __webpack_require__(874);
	
	var _Beginquiz4 = _interopRequireDefault(_Beginquiz3);
	
	var _Dashboard = __webpack_require__(875);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _FlashQuestion = __webpack_require__(876);
	
	var _FlashQuestion2 = _interopRequireDefault(_FlashQuestion);
	
	var _FlashQuestionNotes = __webpack_require__(877);
	
	var _FlashQuestionNotes2 = _interopRequireDefault(_FlashQuestionNotes);
	
	var _Notes3 = __webpack_require__(878);
	
	var _Notes4 = _interopRequireDefault(_Notes3);
	
	var _NotesViewques3 = __webpack_require__(879);
	
	var _NotesViewques4 = _interopRequireDefault(_NotesViewques3);
	
	var _Notesbeginchapters3 = __webpack_require__(880);
	
	var _Notesbeginchapters4 = _interopRequireDefault(_Notesbeginchapters3);
	
	var _Notesreadings3 = __webpack_require__(881);
	
	var _Notesreadings4 = _interopRequireDefault(_Notesreadings3);
	
	var _QuestionBank = __webpack_require__(882);
	
	var _QuestionBank2 = _interopRequireDefault(_QuestionBank);
	
	var _Quizzes5 = __webpack_require__(883);
	
	var _Quizzes6 = _interopRequireDefault(_Quizzes5);
	
	var _Readings = __webpack_require__(884);
	
	var _Readings2 = _interopRequireDefault(_Readings);
	
	var _SavedQuestion = __webpack_require__(885);
	
	var _SavedQuestion2 = _interopRequireDefault(_SavedQuestion);
	
	var _Viewques = __webpack_require__(892);
	
	var _Viewques2 = _interopRequireDefault(_Viewques);
	
	var _index21 = __webpack_require__(890);
	
	var _index22 = _interopRequireDefault(_index21);
	
	var _VideoLessons3 = __webpack_require__(891);
	
	var _VideoLessons4 = _interopRequireDefault(_VideoLessons3);
	
	var _BeforeStart7 = __webpack_require__(858);
	
	var _BeforeStart8 = _interopRequireDefault(_BeforeStart7);
	
	var _Beginchapters3 = __webpack_require__(859);
	
	var _Beginchapters4 = _interopRequireDefault(_Beginchapters3);
	
	var _Beginquiz5 = __webpack_require__(860);
	
	var _Beginquiz6 = _interopRequireDefault(_Beginquiz5);
	
	var _Dashboard3 = __webpack_require__(861);
	
	var _Dashboard4 = _interopRequireDefault(_Dashboard3);
	
	var _FlashQuestion3 = __webpack_require__(862);
	
	var _FlashQuestion4 = _interopRequireDefault(_FlashQuestion3);
	
	var _FlashQuestionNotes3 = __webpack_require__(863);
	
	var _FlashQuestionNotes4 = _interopRequireDefault(_FlashQuestionNotes3);
	
	var _Notes5 = __webpack_require__(864);
	
	var _Notes6 = _interopRequireDefault(_Notes5);
	
	var _Notesbeginchapters5 = __webpack_require__(865);
	
	var _Notesbeginchapters6 = _interopRequireDefault(_Notesbeginchapters5);
	
	var _QuestionBank3 = __webpack_require__(866);
	
	var _QuestionBank4 = _interopRequireDefault(_QuestionBank3);
	
	var _Quizzes7 = __webpack_require__(867);
	
	var _Quizzes8 = _interopRequireDefault(_Quizzes7);
	
	var _Readings3 = __webpack_require__(868);
	
	var _Readings4 = _interopRequireDefault(_Readings3);
	
	var _SavedQuestion3 = __webpack_require__(869);
	
	var _SavedQuestion4 = _interopRequireDefault(_SavedQuestion3);
	
	var _VideoDisplay = __webpack_require__(870);
	
	var _VideoDisplay2 = _interopRequireDefault(_VideoDisplay);
	
	var _VideoLessons5 = __webpack_require__(871);
	
	var _VideoLessons6 = _interopRequireDefault(_VideoLessons5);
	
	var _index23 = __webpack_require__(553);
	
	var _index24 = _interopRequireDefault(_index23);
	
	var _index25 = __webpack_require__(554);
	
	var _index26 = _interopRequireDefault(_index25);
	
	var _index27 = __webpack_require__(555);
	
	var _index28 = _interopRequireDefault(_index27);
	
	var _Pathway = __webpack_require__(585);
	
	var _Pathway2 = _interopRequireDefault(_Pathway);
	
	var _Session = __webpack_require__(586);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _AttemptedTest = __webpack_require__(583);
	
	var _AttemptedTest2 = _interopRequireDefault(_AttemptedTest);
	
	var _Introduction = __webpack_require__(584);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _index29 = __webpack_require__(556);
	
	var _index30 = _interopRequireDefault(_index29);
	
	var _index31 = __webpack_require__(557);
	
	var _index32 = _interopRequireDefault(_index31);
	
	var _index33 = __webpack_require__(558);
	
	var _index34 = _interopRequireDefault(_index33);
	
	var _dashboard = __webpack_require__(801);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _Beginchapters5 = __webpack_require__(802);
	
	var _Beginchapters6 = _interopRequireDefault(_Beginchapters5);
	
	var _QuestionBank5 = __webpack_require__(803);
	
	var _QuestionBank6 = _interopRequireDefault(_QuestionBank5);
	
	var _Readings5 = __webpack_require__(804);
	
	var _Readings6 = _interopRequireDefault(_Readings5);
	
	var _GMAT2Statement = __webpack_require__(805);
	
	var _GMAT2Statement2 = _interopRequireDefault(_GMAT2Statement);
	
	var _GMATCases = __webpack_require__(806);
	
	var _GMATCases2 = _interopRequireDefault(_GMATCases);
	
	var _GMATMultipleStatement = __webpack_require__(807);
	
	var _GMATMultipleStatement2 = _interopRequireDefault(_GMATMultipleStatement);
	
	var _GMATTab = __webpack_require__(808);
	
	var _GMATTab2 = _interopRequireDefault(_GMATTab);
	
	var _GMATTable = __webpack_require__(809);
	
	var _GMATTable2 = _interopRequireDefault(_GMATTable);
	
	var _Viewques3 = __webpack_require__(810);
	
	var _Viewques4 = _interopRequireDefault(_Viewques3);
	
	var _VideoLessons7 = __webpack_require__(820);
	
	var _VideoLessons8 = _interopRequireDefault(_VideoLessons7);
	
	var _videodisplay = __webpack_require__(821);
	
	var _videodisplay2 = _interopRequireDefault(_videodisplay);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _Cfa2Dashboard = __webpack_require__(632);
	
	var _Cfa2Dashboard2 = _interopRequireDefault(_Cfa2Dashboard);
	
	var _Cfa2notesreadings = __webpack_require__(633);
	
	var _Cfa2notesreadings2 = _interopRequireDefault(_Cfa2notesreadings);
	
	var _Cfanotesbeginchapters = __webpack_require__(634);
	
	var _Cfanotesbeginchapters2 = _interopRequireDefault(_Cfanotesbeginchapters);
	
	var _Notes7 = __webpack_require__(635);
	
	var _Notes8 = _interopRequireDefault(_Notes7);
	
	var _cfa2NotesViewques = __webpack_require__(636);
	
	var _cfa2NotesViewques2 = _interopRequireDefault(_cfa2NotesViewques);
	
	var _Cfa2_2023QuestionBank = __webpack_require__(637);
	
	var _Cfa2_2023QuestionBank2 = _interopRequireDefault(_Cfa2_2023QuestionBank);
	
	var _Cfa2cases = __webpack_require__(638);
	
	var _Cfa2cases2 = _interopRequireDefault(_Cfa2cases);
	
	var _Cfa2chapter = __webpack_require__(639);
	
	var _Cfa2chapter2 = _interopRequireDefault(_Cfa2chapter);
	
	var _Cfa2BeforeStart = __webpack_require__(640);
	
	var _Cfa2BeforeStart2 = _interopRequireDefault(_Cfa2BeforeStart);
	
	var _Cfa2Beginquiz = __webpack_require__(641);
	
	var _Cfa2Beginquiz2 = _interopRequireDefault(_Cfa2Beginquiz);
	
	var _Cfa2_2023Quizzes = __webpack_require__(642);
	
	var _Cfa2_2023Quizzes2 = _interopRequireDefault(_Cfa2_2023Quizzes);
	
	var _Cfavideodisplay3 = __webpack_require__(643);
	
	var _Cfavideodisplay4 = _interopRequireDefault(_Cfavideodisplay3);
	
	var _VideoLessons9 = __webpack_require__(644);
	
	var _VideoLessons10 = _interopRequireDefault(_VideoLessons9);
	
	var _Cfa2Dashboard3 = __webpack_require__(645);
	
	var _Cfa2Dashboard4 = _interopRequireDefault(_Cfa2Dashboard3);
	
	var _Cfa2notesreadings3 = __webpack_require__(646);
	
	var _Cfa2notesreadings4 = _interopRequireDefault(_Cfa2notesreadings3);
	
	var _Cfanotesbeginchapters3 = __webpack_require__(647);
	
	var _Cfanotesbeginchapters4 = _interopRequireDefault(_Cfanotesbeginchapters3);
	
	var _Notes9 = __webpack_require__(648);
	
	var _Notes10 = _interopRequireDefault(_Notes9);
	
	var _cfa2NotesViewques3 = __webpack_require__(649);
	
	var _cfa2NotesViewques4 = _interopRequireDefault(_cfa2NotesViewques3);
	
	var _Cfa2_2023QuestionBank3 = __webpack_require__(650);
	
	var _Cfa2_2023QuestionBank4 = _interopRequireDefault(_Cfa2_2023QuestionBank3);
	
	var _Cfa2cases3 = __webpack_require__(651);
	
	var _Cfa2cases4 = _interopRequireDefault(_Cfa2cases3);
	
	var _Cfa2chapter3 = __webpack_require__(652);
	
	var _Cfa2chapter4 = _interopRequireDefault(_Cfa2chapter3);
	
	var _Cfa2BeforeStart3 = __webpack_require__(653);
	
	var _Cfa2BeforeStart4 = _interopRequireDefault(_Cfa2BeforeStart3);
	
	var _Cfa2Beginquiz3 = __webpack_require__(654);
	
	var _Cfa2Beginquiz4 = _interopRequireDefault(_Cfa2Beginquiz3);
	
	var _Cfa2_2023Quizzes3 = __webpack_require__(655);
	
	var _Cfa2_2023Quizzes4 = _interopRequireDefault(_Cfa2_2023Quizzes3);
	
	var _Cfavideodisplay5 = __webpack_require__(656);
	
	var _Cfavideodisplay6 = _interopRequireDefault(_Cfavideodisplay5);
	
	var _VideoLessons11 = __webpack_require__(657);
	
	var _VideoLessons12 = _interopRequireDefault(_VideoLessons11);
	
	var _index35 = __webpack_require__(559);
	
	var _index36 = _interopRequireDefault(_index35);
	
	var _index37 = __webpack_require__(560);
	
	var _index38 = _interopRequireDefault(_index37);
	
	var _index39 = __webpack_require__(561);
	
	var _index40 = _interopRequireDefault(_index39);
	
	var _index41 = __webpack_require__(562);
	
	var _index42 = _interopRequireDefault(_index41);
	
	var _index43 = __webpack_require__(563);
	
	var _index44 = _interopRequireDefault(_index43);
	
	var _index45 = __webpack_require__(564);
	
	var _index46 = _interopRequireDefault(_index45);
	
	var _dashboard3 = __webpack_require__(689);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	var _Beginchapters7 = __webpack_require__(690);
	
	var _Beginchapters8 = _interopRequireDefault(_Beginchapters7);
	
	var _QuestionBank7 = __webpack_require__(691);
	
	var _QuestionBank8 = _interopRequireDefault(_QuestionBank7);
	
	var _Readings7 = __webpack_require__(692);
	
	var _Readings8 = _interopRequireDefault(_Readings7);
	
	var _Cases = __webpack_require__(693);
	
	var _Cases2 = _interopRequireDefault(_Cases);
	
	var _MultipleStatement = __webpack_require__(694);
	
	var _MultipleStatement2 = _interopRequireDefault(_MultipleStatement);
	
	var _Statement = __webpack_require__(695);
	
	var _Statement2 = _interopRequireDefault(_Statement);
	
	var _Tab = __webpack_require__(696);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Table = __webpack_require__(697);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Viewques5 = __webpack_require__(698);
	
	var _Viewques6 = _interopRequireDefault(_Viewques5);
	
	var _BeforeStart9 = __webpack_require__(699);
	
	var _BeforeStart10 = _interopRequireDefault(_BeforeStart9);
	
	var _BeginQuizContainer = __webpack_require__(701);
	
	var _BeginQuizContainer2 = _interopRequireDefault(_BeginQuizContainer);
	
	var _Quizzes9 = __webpack_require__(702);
	
	var _Quizzes10 = _interopRequireDefault(_Quizzes9);
	
	var _VideoLessons13 = __webpack_require__(704);
	
	var _VideoLessons14 = _interopRequireDefault(_VideoLessons13);
	
	var _videodisplay3 = __webpack_require__(705);
	
	var _videodisplay4 = _interopRequireDefault(_videodisplay3);
	
	var _CaseQuestions = __webpack_require__(661);
	
	var _CaseQuestions2 = _interopRequireDefault(_CaseQuestions);
	
	var _Chapters = __webpack_require__(663);
	
	var _Chapters2 = _interopRequireDefault(_Chapters);
	
	var _EssayCases = __webpack_require__(664);
	
	var _EssayCases2 = _interopRequireDefault(_EssayCases);
	
	var _index47 = __webpack_require__(568);
	
	var _index48 = _interopRequireDefault(_index47);
	
	var _index49 = __webpack_require__(569);
	
	var _index50 = _interopRequireDefault(_index49);
	
	var _index51 = __webpack_require__(571);
	
	var _index52 = _interopRequireDefault(_index51);
	
	var _index53 = __webpack_require__(576);
	
	var _index54 = _interopRequireDefault(_index53);
	
	var _gmatFocus = __webpack_require__(549);
	
	var _CBTFinishPage = __webpack_require__(706);
	
	var _CBTFinishPage2 = _interopRequireDefault(_CBTFinishPage);
	
	var _CBTQuestion = __webpack_require__(707);
	
	var _CBTQuestion2 = _interopRequireDefault(_CBTQuestion);
	
	var _Instructions = __webpack_require__(713);
	
	var _Instructions2 = _interopRequireDefault(_Instructions);
	
	var _index55 = __webpack_require__(719);
	
	var _index56 = _interopRequireDefault(_index55);
	
	var _ViewAttemptedMock = __webpack_require__(724);
	
	var _ViewAttemptedMock2 = _interopRequireDefault(_ViewAttemptedMock);
	
	var _index57 = __webpack_require__(725);
	
	var _index58 = _interopRequireDefault(_index57);
	
	var _index59 = __webpack_require__(738);
	
	var _index60 = _interopRequireDefault(_index59);
	
	var _index61 = __webpack_require__(739);
	
	var _index62 = _interopRequireDefault(_index61);
	
	var _BeginQuestion = __webpack_require__(740);
	
	var _BeginQuestion2 = _interopRequireDefault(_BeginQuestion);
	
	var _QuestionList = __webpack_require__(744);
	
	var _QuestionList2 = _interopRequireDefault(_QuestionList);
	
	var _index63 = __webpack_require__(747);
	
	var _index64 = _interopRequireDefault(_index63);
	
	var _ChapterVideos = __webpack_require__(750);
	
	var _ChapterVideos2 = _interopRequireDefault(_ChapterVideos);
	
	var _index65 = __webpack_require__(752);
	
	var _index66 = _interopRequireDefault(_index65);
	
	var _RecurringPlanDetail = __webpack_require__(896);
	
	var _RecurringPlanDetail2 = _interopRequireDefault(_RecurringPlanDetail);
	
	var _FrmvideoLessons = __webpack_require__(784);
	
	var _FrmvideoLessons2 = _interopRequireDefault(_FrmvideoLessons);
	
	var _Frmvideodisplay = __webpack_require__(785);
	
	var _Frmvideodisplay2 = _interopRequireDefault(_Frmvideodisplay);
	
	var _Frm1BeforeStart = __webpack_require__(786);
	
	var _Frm1BeforeStart2 = _interopRequireDefault(_Frm1BeforeStart);
	
	var _Frm1Beginquiz = __webpack_require__(787);
	
	var _Frm1Beginquiz2 = _interopRequireDefault(_Frm1Beginquiz);
	
	var _Frm1Quizzes = __webpack_require__(788);
	
	var _Frm1Quizzes2 = _interopRequireDefault(_Frm1Quizzes);
	
	var _Frm2BeforeStart = __webpack_require__(789);
	
	var _Frm2BeforeStart2 = _interopRequireDefault(_Frm2BeforeStart);
	
	var _Frm2Beginquiz = __webpack_require__(790);
	
	var _Frm2Beginquiz2 = _interopRequireDefault(_Frm2Beginquiz);
	
	var _FrmNotes = __webpack_require__(791);
	
	var _FrmNotes2 = _interopRequireDefault(_FrmNotes);
	
	var _FrmNotesBeginChapters = __webpack_require__(792);
	
	var _FrmNotesBeginChapters2 = _interopRequireDefault(_FrmNotesBeginChapters);
	
	var _Frmnotesreadings = __webpack_require__(793);
	
	var _Frmnotesreadings2 = _interopRequireDefault(_Frmnotesreadings);
	
	var _FrmQueBank = __webpack_require__(794);
	
	var _FrmQueBank2 = _interopRequireDefault(_FrmQueBank);
	
	var _FrmReadings = __webpack_require__(795);
	
	var _FrmReadings2 = _interopRequireDefault(_FrmReadings);
	
	var _Frmchapter = __webpack_require__(796);
	
	var _Frmchapter2 = _interopRequireDefault(_Frmchapter);
	
	var _ViewFrmQues = __webpack_require__(797);
	
	var _ViewFrmQues2 = _interopRequireDefault(_ViewFrmQues);
	
	var _Frmdashboard = __webpack_require__(798);
	
	var _Frmdashboard2 = _interopRequireDefault(_Frmdashboard);
	
	var _ViewFrm2AllQues = __webpack_require__(799);
	
	var _ViewFrm2AllQues2 = _interopRequireDefault(_ViewFrm2AllQues);
	
	var _ViewFrmAllQues = __webpack_require__(800);
	
	var _ViewFrmAllQues2 = _interopRequireDefault(_ViewFrmAllQues);
	
	var _FinishTest = __webpack_require__(577);
	
	var _FinishTest2 = _interopRequireDefault(_FinishTest);
	
	var _IntoductionInstruction = __webpack_require__(578);
	
	var _IntoductionInstruction2 = _interopRequireDefault(_IntoductionInstruction);
	
	var _MockList = __webpack_require__(579);
	
	var _MockList2 = _interopRequireDefault(_MockList);
	
	var _Questions = __webpack_require__(580);
	
	var _Questions2 = _interopRequireDefault(_Questions);
	
	var _index67 = __webpack_require__(581);
	
	var _index68 = _interopRequireDefault(_index67);
	
	var _ViewAttemptedMocks = __webpack_require__(582);
	
	var _ViewAttemptedMocks2 = _interopRequireDefault(_ViewAttemptedMocks);
	
	var _index69 = __webpack_require__(777);
	
	var _index70 = _interopRequireDefault(_index69);
	
	var _ReadingsList5 = __webpack_require__(770);
	
	var _ReadingsList6 = _interopRequireDefault(_ReadingsList5);
	
	var _QuestionsList3 = __webpack_require__(776);
	
	var _QuestionsList4 = _interopRequireDefault(_QuestionsList3);
	
	var _index71 = __webpack_require__(773);
	
	var _index72 = _interopRequireDefault(_index71);
	
	var _index73 = __webpack_require__(765);
	
	var _index74 = _interopRequireDefault(_index73);
	
	var _ReadingsList7 = __webpack_require__(761);
	
	var _ReadingsList8 = _interopRequireDefault(_ReadingsList7);
	
	var _ViewNotes3 = __webpack_require__(764);
	
	var _ViewNotes4 = _interopRequireDefault(_ViewNotes3);
	
	var _index75 = __webpack_require__(755);
	
	var _index76 = _interopRequireDefault(_index75);
	
	var _index77 = __webpack_require__(783);
	
	var _index78 = _interopRequireDefault(_index77);
	
	var _VideoPlayList3 = __webpack_require__(782);
	
	var _VideoPlayList4 = _interopRequireDefault(_VideoPlayList3);
	
	var _index79 = __webpack_require__(903);
	
	var _index80 = _interopRequireDefault(_index79);
	
	var _index81 = __webpack_require__(902);
	
	var _index82 = _interopRequireDefault(_index81);
	
	var _cfa2NextRoutes = __webpack_require__(177);
	
	var _WebinarsList = __webpack_require__(904);
	
	var _WebinarsList2 = _interopRequireDefault(_WebinarsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//* FRM CBT
	
	
	// ====================== ESG ROUTES =====================
	
	//----------------------- ( CFA LEVEL 1 2024 ) IMPORT START HERE -------------------------------------
	// ===================== CFA3 CBT =====================
	
	
	//  ===================== CFA 2 -2025 - EXAMS ENDS =====================
	
	//  ===================== CFA 2 -2027 - EXAMS START (additive, employee-only preview) =====================
	//  Cloned CFA2-2025 view tree, endpoints swapped to /cfa_2_2027* + /cfa2CBTMockExams2027 + /cfa_2_2027quizes.
	//  Route tree lives at /cfa2/2027/*; access gated by examPreviewGuard (backend) + isEmployee (exam selector).
	
	
	/*end FORUM*/
	
	/*end SOA - Probability*/
	
	// SOA _FM  (Financial Mathematics)
	
	//* ~~~~~~~ QUIZ ROUTE ~~~~~~~~
	
	//* ~~~~~~~ QUESTION BANK ROUTE ~~~~~~~~
	
	//* ~~~~~~~ VIDEOS ROUTE ~~~~~~~~
	
	//* ~~~~~~~ NOTES ROUTE ~~~~~~~~
	
	//* ~~~~~~~ DASHBOARD ROUTE ~~~~~~~~
	exports.default = _react2.default.createElement(
	  _reactRouter.Router,
	  { history: _reactRouter.hashHistory },
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa1/v2',
	    onEnter: function onEnter(nextState, replace) {
	      return replace('/cfa1/2026/dashboard');
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa1/v2/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa1/v2', '/cfa1/2026') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa1_2024/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa1_2024', '/cfa1/2026') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa1_2025/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa1_2025', '/cfa1/2026') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/cfa2/v2', onEnter: function onEnter(nextState, replace) {
	      return replace('/cfa2/2026/dashboard');
	    } }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa2/v2/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa2/v2', '/cfa2/2026') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/cfa2/cbt', onEnter: function onEnter(nextState, replace) {
	      return replace('/cfa2/2026/cbt');
	    } }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa2/introduction/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa2/viewattemptedmock/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa2/cbtquestions/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa2/cbtquestionsfinish/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/cfa2/cbtshowresult/*',
	    onEnter: function onEnter(nextState, replace) {
	      var loc = nextState.location;
	      replace(loc.pathname.replace('/cfa2/', '/cfa2/2026/') + (loc.search || ''));
	    }
	  }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', name: 'Login', component: _Simple2.default },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Auth2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: 'resetpassword(/:tokenid)/(:mailid)',
	      name: 'ForgetPassword',
	      component: _ResetPassword2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/cfa3essayquespdf', name: 'Cfa3EssayQuesPdf', components: _Cfa3EssayQuesPdf2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/frmpdf', name: 'FrmPdf', components: _FrmPdf2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/selectexam', name: 'Select Exam', components: _Selectexam2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe', name: 'Unsubscribe', components: _Unsubscribe2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/fill-details', name: 'Select Exam', components: _Filldetails2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/checkoutVerify', name: 'Checkout Verify', components: _CheckoutVerify2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.THANK_YOU, name: 'Thank you', components: _WordPressThankYou2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/appsumo', name: 'AppSumo', components: _AppSumo2.default })
	  ),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', name: 'Home', component: _Full2.default },
	    '//^ =========== CFA I ROUTE COMPONENT =============',
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.Tutor, name: 'Tutor', components: _Tutor2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH,
	      name: 'cfacbtquestionsfinish 2024',
	      components: _index2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION,
	      name: 'introduction 2024',
	      components: _index4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA1_2025_QUIZZES, name: 'Quizzes', components: _Quizzes2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START,
	      name: 'Quizzes Before Starting',
	      components: _BeforeStart2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_QUIZ_BEGIN,
	      name: 'Begin Quiz',
	      components: _BeginQuiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA1_2024_CBT, name: 'cfacbt', components: _index6.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'cfaviewattemptedmock 2024',
	      components: _index12.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2024_CBT_QUESTIONS,
	      name: 'cfacbtquestions',
	      components: _index8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2024_DETAILED_RESULT_GRAPH,
	      name: 'cfacbtshowresult',
	      components: _index10.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA1_2025_NOTES, name: 'CFA Notes', component: _index16.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_NOTES_READING_LIST,
	      name: 'CFA Notes',
	      component: _ReadingsList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_NOTES_VIEW,
	      name: 'CFA Notes View',
	      component: _ViewNotes2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_NOTES_LIST,
	      name: 'CFA Notes List',
	      component: _NotesList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_DASHBOARD,
	      name: 'CFA1_2025_DASHBOARD',
	      component: _index14.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA1_VIDEOS, name: 'CFA1 2025 videos', component: _index18.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_VIDEO_LIST,
	      name: 'CFA1 2025 video list',
	      component: _VideoPlayList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_QUESTION_BANK,
	      name: 'CFA1 2025 Question Bank',
	      component: _index20.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST,
	      name: 'CFA1 2025 Reading List',
	      component: _ReadingsList4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_QUESTION_VIEW,
	      name: 'CFA1 2025 View Question',
	      component: _QuestionView2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_QUESTIONS_LIST,
	      name: 'CFA1 2025 View Question List',
	      component: _QuestionsList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_DASHBOARD_VIEW_QUESTIONS,
	      name: 'CFA1 AllQuestions 2025',
	      components: _ViewAllQues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_DASHBOARD,
	      name: 'CFA1 2027 Dashboard',
	      component: _index14.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_DASHBOARD_VIEW_QUESTIONS,
	      name: 'CFA1 2027 AllQuestions',
	      components: _ViewAllQues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_NOTES,
	      name: 'CFA1 2027 Notes',
	      component: _index16.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_NOTES_READING_LIST,
	      name: 'CFA1 2027 Notes Reading List',
	      component: _ReadingsList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_NOTES_VIEW,
	      name: 'CFA1 2027 Notes View',
	      component: _ViewNotes2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_NOTES_LIST,
	      name: 'CFA1 2027 Notes List',
	      component: _NotesList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_VIDEOS,
	      name: 'CFA1 2027 Videos',
	      component: _index18.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_VIDEO_LIST,
	      name: 'CFA1 2027 Video List',
	      component: _VideoPlayList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_BANK,
	      name: 'CFA1 2027 Question Bank',
	      component: _index20.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_BANK_READING_LIST,
	      name: 'CFA1 2027 Reading List',
	      component: _ReadingsList4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUESTIONS_LIST,
	      name: 'CFA1 2027 Question List',
	      component: _QuestionsList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUESTION_VIEW,
	      name: 'CFA1 2027 View Question',
	      component: _QuestionView2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUIZZES,
	      name: 'CFA1 2027 Quizzes',
	      components: _Quizzes2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUIZ_BEFORE_START,
	      name: 'CFA1 2027 Quiz Before Start',
	      components: _BeforeStart2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_QUIZ_BEGIN,
	      name: 'CFA1 2027 Begin Quiz',
	      components: _BeginQuiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_CBT,
	      name: 'CFA1 2027 CBT',
	      components: _index6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'CFA1 2027 CBT Attempted',
	      components: _index12.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_CBT_INTRODUCTION,
	      name: 'CFA1 2027 CBT Introduction',
	      components: _index4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_CBT_QUESTIONS,
	      name: 'CFA1 2027 CBT Questions',
	      components: _index8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_CBT_QUESTION_FINISH,
	      name: 'CFA1 2027 CBT Finish',
	      components: _index2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2027_NEXT_DETAILED_RESULT_GRAPH,
	      name: 'CFA1 2027 CBT Result',
	      components: _index10.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.VIDEOS,
	      name: 'Videos',
	      component: _index80.default,
	      onEnter: _cfa2NextRoutes.redirectSharedVideosToCfa2Tree
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.VIDEOS_LIST,
	      name: 'Videos-List',
	      component: _index82.default,
	      onEnter: _cfa2NextRoutes.redirectSharedVideosToCfa2Tree
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA2_2026_VIDEOS, name: 'CFA2 2026 Videos', component: _index80.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2026_VIDEOS_LIST,
	      name: 'CFA2 2026 Videos-List',
	      component: _index82.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA2_2027_VIDEOS, name: 'CFA2 2027 Videos', component: _index80.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_VIDEOS_LIST,
	      name: 'CFA2 2027 Videos-List',
	      component: _index82.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_QUESTION_BANK,
	      name: 'Frm Question Bank',
	      component: _index70.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_QUESTION_BANK_READING_LIST,
	      name: 'Frm Reading List',
	      component: _ReadingsList6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_VIEW,
	      name: 'Frm View Question',
	      component: _index72.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_LIST,
	      name: 'Frm View Question List',
	      component: _QuestionsList4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.FRM_V2_NOTES, name: 'Frm Notes', component: _index74.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_NOTES_READING_LIST,
	      name: 'Frm Notes',
	      component: _ReadingsList8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.FRM_V2_NOTES_VIEW, name: 'Frm Notes View', component: _ViewNotes4.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.FRM_V2_DASHBOARD, name: 'Frm dashboad', component: _index76.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.FRM_VIDEOS, name: 'Frm Videos', component: _index78.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_VIDEOS_PLAYLIST,
	      name: 'Frm Video PlayList',
	      component: _VideoPlayList4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_VIDEOS_MOCK_PLAYLIST,
	      name: 'Frm Video PlayList',
	      component: _VideoPlayList4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.FRM_DASHBOARD, name: 'Frm Dashboard', component: _Frmdashboard2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_DETAILS_STATS_LEVEL1,
	      name: 'FrmAllQueBank',
	      components: _ViewFrmAllQues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_V2_DETAILS_STATS_LEVEL2,
	      name: 'Frm2AllQueBank',
	      components: _ViewFrm2AllQues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/frm/notes', name: 'FRM Notes', components: _FrmNotes2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/notesreadings(/:chapter)',
	      name: 'Frm Notes Readings',
	      components: _Frmnotesreadings2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/beginnotes(/:notesid)(/:readingid)(/:id)(/:offset)(/:level)',
	      name: 'FRM Notes Beginchapters',
	      components: _FrmNotesBeginChapters2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/frm/videoLessons', name: 'FRMVideoLessons', components: _FrmvideoLessons2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/videodisplay(/:id)(/:showFreePremium)(/:type)(/:chapter_id)(/:index)',
	      name: 'Frmvideodisplay',
	      components: _Frmvideodisplay2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/frm/questionbank', name: 'FrmQueBank', components: _FrmQueBank2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/readings(/:chapter)(/:selectedMenu)(/:level)(/:chapterName)',
	      name: 'FrmReadings',
	      components: _FrmReadings2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/questions(/:id)(/:chapter_no)(/:reading)(/:subscriptionstatus)(/:chapter)(/:level)(/:selectedMenu)',
	      name: 'ViewFrmQues',
	      components: _ViewFrmQues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/chapter(/:notesid)(/:readingid)(/:id)(/:level)(/:offset)',
	      name: 'Frmchapter',
	      components: _Frmchapter2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/frm/cbt', name: 'frmcbt', components: _MockList2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/introduction/:id/:questiono/:timer/:level',
	      name: 'introduction',
	      components: _IntoductionInstruction2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/cbtquestions/:id/:questiono/:timer/:level/:testid/:offset/:isNegative/:timerStart',
	      name: 'frmcbtquestions',
	      components: _Questions2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/cbtquestionsfinish/:id/:questiono/:timer/:level/:testid/:offset',
	      name: 'frmcbtquestionsfinish',
	      components: _FinishTest2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/viewattemptedmock/:id/:timer/:level',
	      name: 'frmviewattemptedmock',
	      components: _ViewAttemptedMocks2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.FRM_DETAILED_RESULT_GRAPH,
	      name: 'frmcbtshowresult',
	      components: _index68.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA3_PATHWAY_CBT, name: 'PathwayList', components: _Pathway2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA3_PATHWAY_SESSION, name: 'SessionList', components: _Session2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'pathwayAttemptedTest',
	      components: _AttemptedTest2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_PATHWAY_CBT_INTRODUCTION,
	      name: 'introduction',
	      components: _Introduction2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS,
	      name: 'sessionQuestions',
	      components: _index52.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_PATHWAY_CBT_GRADE_QUESTIONS,
	      name: 'questionGrade',
	      components: _index50.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS_FINISH,
	      name: 'pathawyTestFinish',
	      components: _index48.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_PATHWAY_CBT_DETAILED_RESULT_GRAPH,
	      name: 'resultGraph',
	      components: _index54.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_DASHBOARD,
	      name: 'Cfa 3 Dashboard',
	      component: function component(props) {
	        return _react2.default.createElement(_Cfa3Dashboard2.default, Object.assign({ key: 'cfa3' }, props));
	      }
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      key: 'cfa3_2025',
	      path: _AppRoutes2.default.CFA3_DASHBOARD_2025,
	      name: 'Cfa 3 Dashboard',
	      component: function component(props) {
	        return _react2.default.createElement(_Cfa3Dashboard2.default, Object.assign({ key: 'cfa3_2025' }, props));
	      }
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.PROFILE_ROUTE, name: 'Profile', components: _Profile2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/profile/discussions/:username', name: 'Profile', components: _Profile2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/profile/comments/:username', name: 'Profile', components: _Profile2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/premiumcheckout', name: 'PremiumCheckout', components: _PremiumCheckout2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/frm/quiz(/:quiz_id)', name: 'Frm  Begin Quiz', components: _Frm1Quizzes2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/1/beforestart(/:quiz_id)(/:selectedMenu)(/:status_send)',
	      name: 'Frm Quizzes Before Starting',
	      components: _Frm1BeforeStart2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/1/beginquiz(/:quiz_id)(/:offset)',
	      name: 'FrmBegin Quiz',
	      components: _Frm1Beginquiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/2/beforestart(/:quiz_id)(/:selectedMenu)(/:status_send)',
	      name: 'Frm Quizzes Before Starting',
	      components: _Frm2BeforeStart2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/frm/2/beginquiz(/:quiz_id)(/:offset)(/:selectedMenu)',
	      name: 'FrmBegin Quiz',
	      components: _Frm2Beginquiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/cfa3_savedquestion',
	      name: 'Cfa 3 Saved Question',
	      components: _Cfa3savedquestion2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/cfa3_flashquestion', name: 'Cfa Flash Question', components: _Cfa3flashquestion2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/changepassword(/:selectedMenu)(/:username)',
	      name: 'Change Password',
	      components: _ChangePassword2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/setpassword', name: 'Set Password', components: _SetPassword2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/orderhistory(/:selectedMenu)(/:username)',
	      name: 'Order History',
	      components: _OrderHistory2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/orderdiscription(/:orderid)(/:selectedMenu)(/:username)',
	      name: 'Order Discription',
	      components: _OrderDiscription2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.SUBSCRIPTION_DETAILS,
	      name: 'subscription detail',
	      components: _SubscriptionDetail2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.RECURRING_PLAN_DETAILS,
	      name: 'subscription detail',
	      components: _RecurringPlanDetail2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/cfa3/questionBank', name: 'Cfa 2 QuestionBank', components: _Cfa3QuestionBank2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/cfa3/cases(/:id)(/:chapter_name)(/:total_cases)',
	      name: 'Cfa 3 Cases',
	      components: _Cfa3cases2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/cfa3/essayquestionpdf', name: 'Essay Pdf', components: _Cfa3EssayQuestions2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CHAPTERS,
	      name: 'Essay Chapters',
	      components: _Chapters2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASES,
	      name: 'Cfa 3 Essay Cases',
	      components: _EssayCases2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASE_VIEW,
	      name: 'Cfa 3 Essay Cases',
	      components: _CaseQuestions2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/cfa3/chapter(/:chapterid)(/:caseid)(/:case_offset)(/:question_number)(/:offset)',
	      name: 'Cfa 3 Chapter',
	      components: _Cfa3chapter2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/cfa3/quizzes', name: 'Cfa 3 Quizzes', components: _Cfa3Quizzes2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/cfa3/beforestart(/:quiz_id)(/:status_send)',
	      name: 'Cfa 3 Before Start',
	      components: _Cfa3BeforeStart2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/cfa3/beginquiz(/:quiz_id)(/:offset)',
	      name: 'Cfa 3 Begin Quiz',
	      components: _Cfa3Beginquiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/questionbank',
	      name: 'SOA Probability QuestionBank',
	      components: _QuestionBank2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/readings(/:chapter)(/:chapterName)',
	      name: 'SOA Probability Readings',
	      components: _Readings2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/viewquestions(/:id)(/:chapter_no)(/:reading)(/:chapter)(/:subscriptionstatus)',
	      name: 'SOA Probability Viewques',
	      components: _Viewques2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/beginchapter(/:notesid)(/:readingid)(/:id)(/:chapter)(/:offset)',
	      name: 'SOA Probability Being Chapters',
	      components: _Beginchapters2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/soa/probability/notes', name: 'SOA Probability Notes', components: _Notes4.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.SOA_PROBABILITY_NOTES_READING,
	      name: 'SOA Notes Reading',
	      components: _Notesreadings4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/notesviewques',
	      name: 'SOA Probability Notes',
	      components: _NotesViewques4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/beginnotes(/:notesid)(/:readingid)(/:id)(/:offset)',
	      name: 'SOA Probability begin Notes',
	      components: _Notesbeginchapters4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/dashboard',
	      name: 'SOA Probability Dashboard',
	      component: _Dashboard2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/savedquestion',
	      name: 'SOA Probability Saved Question',
	      component: _SavedQuestion2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/flashquestion',
	      name: 'SOA Probability Flash Question',
	      component: _FlashQuestion2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/flashquestionnotes',
	      name: 'SOA Probability Flash Question - Notes',
	      component: _FlashQuestionNotes2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/quizzes',
	      name: 'SOA Probability Quizzes',
	      components: _Quizzes6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/beforeStart(/:quiz_id)(/:status_send)',
	      name: 'SOA Probability Before Start',
	      components: _BeforeStart6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/probability/beginquiz(/:quiz_id)(/:offset)',
	      name: 'SOA Probability Begin Quiz',
	      components: _Beginquiz4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_LESSONS,
	      name: 'SOA Video Lessons',
	      components: _VideoLessons4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY,
	      name: 'SOA Video Display',
	      components: _index22.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/questionbank',
	      name: 'SOA Financial Mathematics QuestionBank',
	      components: _QuestionBank4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/beginchapter(/:page)(/:notesid)(/:id)(/:offset)',
	      name: 'SOA Financial Mathematics Being Chapters',
	      components: _Beginchapters4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/notes',
	      name: 'SOA Financial Mathematics Notes',
	      components: _Notes6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/beginnotes(/:notesid)(/:id)(/:offset)',
	      name: 'SOA Financial Mathematics begin Notes',
	      components: _Notesbeginchapters6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/dashboard',
	      name: 'SOA Financial Mathematics Dashboard',
	      component: _Dashboard4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/savedquestion',
	      name: 'SOA Financial Mathematics Saved Question',
	      component: _SavedQuestion4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/flashquestion',
	      name: 'SOA Financial Mathematics Flash Question',
	      component: _FlashQuestion4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/flashquestionnotes',
	      name: 'SOA Financial Mathematics Flash Question - Notes',
	      component: _FlashQuestionNotes4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/quizzes',
	      name: 'SOA Financial Mathematics Quizzes',
	      components: _Quizzes8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/beforeStart(/:quiz_id)(/:status_send)',
	      name: 'SOA Financial Mathematics Before Start',
	      components: _BeforeStart8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/beginquiz(/:quiz_id)(/:offset)',
	      name: 'SOA Financial Mathematics Begin Quiz',
	      components: _Beginquiz6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/readings(/:id)(/:page)',
	      name: 'SOA Financial Mathematics Readings',
	      components: _Readings4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/videolessons',
	      name: 'SOA Financial Mathematics Videos Lessons',
	      components: _VideoLessons6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/soa/financialmathematics/videodisplay(/:id)(/:showFreePremium)(/:type)(/:chapter_id)(/:index)',
	      name: 'SOA Financial Mathematics Videos Display',
	      components: _VideoDisplay2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/subscribe', name: 'Subscribe', components: _Subscribe2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/subscribe/selectPackage(/:exam_name)(/:exam_id)',
	      name: 'Select Package',
	      components: _SelectPackage2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/payment-processing', name: 'paymentProcessing', components: _paymentProcessing2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/cart', name: 'Cart', components: _Cart2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/checkout', name: 'Checkout', components: _Checkout2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/thankyou(/:order_id)', name: 'Thankyou', components: _Thankyou2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/addons', name: 'Addons', components: _Addons2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA2_CBT, name: 'cfa2cbt', components: _index28.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_CBT_QUESTIONS,
	      name: 'cfa2cbtquestions',
	      components: _index30.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH,
	      name: 'cfa2cbtquestionsfinish',
	      components: _index24.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_CBT_INTRODUCTION,
	      name: 'introduction',
	      components: _index26.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_DETAILED_RESULT_GRAPH,
	      name: 'cfacbtshowresult',
	      components: _index32.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'cfa2viewattemptedmock',
	      components: _index34.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA2_2027_CBT, name: 'cfa2cbt2027', components: _index40.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS,
	      name: 'cfa2cbtquestions2027',
	      components: _index42.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH,
	      name: 'cfa2cbtquestionsfinish2027',
	      components: _index36.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_CBT_INTRODUCTION,
	      name: 'introduction2027',
	      components: _index38.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_DETAILED_RESULT_GRAPH,
	      name: 'cfacbtshowresult2027',
	      components: _index44.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'cfa2viewattemptedmock2027',
	      components: _index46.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA3_CBT, name: 'cfa3cbt', components: _index28.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_CBT_QUESTIONS,
	      name: 'cfa3cbtquestions',
	      components: _index52.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_CBT_GRADE_QUESTIONS,
	      name: 'cfa3cbtgradequestions',
	      components: _index50.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_CBT_QUESTIONS_FINISH,
	      name: 'cfa3cbtquestionsfinish',
	      components: _index48.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_CBT_INTRODUCTION,
	      name: 'introduction',
	      components: _index26.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_CBT_DETAILED_RESULT_GRAPH,
	      name: 'cfacbtshowresult',
	      components: _index54.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'cfa3viewattemptedmock',
	      components: _index34.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.GMAT_DASHBOARD, name: 'introduction', components: _dashboard2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_QUESTION_BANK,
	      name: 'GMAT_QUESTION_BANK',
	      components: _QuestionBank6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_QUESTION_BANK_READING,
	      name: 'GMAT_QUESTION_BANK_READING',
	      components: _Readings6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE,
	      name: 'GMAT_QUESTION_BANK_VIEW_QUE',
	      components: _Beginchapters6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE,
	      name: 'GMAT_QUESTION_BANK_LIST_QUE',
	      components: _Viewques4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_VIDEO_DISPLAY,
	      name: 'GMAT_VIDEO_DISPLAY',
	      components: _videodisplay2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_VIDEO_LESSONS,
	      name: 'GMAT_VIDEO_LESSONS',
	      components: _VideoLessons8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.GMAT_BEGINCASE, name: 'GMAT Case', components: _GMATCases2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_TWO_PART_STATEMENT,
	      name: 'GMAT 2 Statements',
	      components: _GMAT2Statement2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_GRAPH_MULTI_STATEMENT,
	      name: 'GMAT Multiple Statement',
	      components: _GMATMultipleStatement2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.GMAT_TAB, name: 'GMAT Tab', components: _GMATTab2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.GMAT_TABLE, name: 'GMAT Table', components: _GMATTable2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.GMAT_QUIZZES, name: 'Quizzes', components: _Quizzes4.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START,
	      name: 'Before start',
	      components: _BeforeStart4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.BEGIN_QUIZ, name: 'Begin quizzes', components: _Beginquiz2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.BEGIN_CASE_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginCasequiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.GMAT_QUIZZES_BEGIN,
	      name: 'Begin quizzes',
	      components: _BeginTabsQuiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.BEGIN_TABLE_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginTableQuiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.BEGIN_GRAPH_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginGraphQuiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.BEGIN_TWOPART_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginTwopartQuiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.CFA3_NOTES, name: 'CFA Level 3 Notes', components: _Notes2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_NOTES_READINGS,
	      name: 'Cfa 3 Notes Readings',
	      components: _Notesreadings2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_NOTES_VIEWQUES,
	      name: 'Cfa 3 View Notes',
	      components: _NotesViewques2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_BEGIN_NOTES,
	      name: 'Cfa Level 3 Notes Beginchapters',
	      components: _Notesbeginchapters2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_VIDEO_LESSONS,
	      name: 'CFA level 3 Video Lessons',
	      components: _VideoLessons2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA3_VIDEO_DISPLAY,
	      name: 'Cfa 3 video display',
	      components: _Cfavideodisplay2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_DASHBOARD, name: 'introduction', components: _dashboard4.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_QUESTION_BANK,
	      name: 'GMAT_QUESTION_BANK',
	      components: _QuestionBank8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_READING,
	      name: 'GMAT_QUESTION_BANK_READING',
	      components: _Readings8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_BEGINCHAPTER,
	      name: 'GMAT_QUESTION_BANK_VIEW_QUE',
	      components: _Beginchapters8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.VIEW_EA_QUESTION,
	      name: 'GMAT_QUESTION_BANK_LIST_QUE',
	      components: _Viewques6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_VIDEO_DISPLAY,
	      name: 'GMAT_VIDEO_DISPLAY',
	      components: _videodisplay4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_VIDEO_LESSONS,
	      name: 'GMAT_VIDEO_LESSONS',
	      components: _VideoLessons14.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_BEGINCASE, name: 'GMAT Case', components: _Cases2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_TWO_PART_STATEMENT,
	      name: 'GMAT 2 Statements',
	      components: _Statement2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_GRAPH_MULTI_STATEMENT,
	      name: 'GMAT Multiple Statement',
	      components: _MultipleStatement2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_TAB, name: 'GMAT Tab', components: _Tab2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_TABLE, name: 'GMAT Table', components: _Table2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_QUIZZES, name: 'Quizzes', components: _Quizzes10.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_BEFORE_START, name: 'Before start', components: _BeforeStart10.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_BEGIN_QUIZ, name: 'Begin quizzes', components: _BeginQuizContainer2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_BEGIN_CASE_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginQuizContainer2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.EA_BEGIN_TAB_QUIZ, name: 'Begin quizzes', components: _BeginQuizContainer2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_BEGIN_TABLE_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginQuizContainer2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_BEGIN_GRAPH_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginQuizContainer2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.EA_BEGIN_TWOPART_QUIZ,
	      name: 'Begin quizzes',
	      components: _BeginQuizContainer2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA1_2025_DASHBOARD_VIEW_QUESTIONS,
	      name: 'CFA1 AllQuestions 2025',
	      components: _ViewAllQues2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	      name: 'CFA2_2025_DASHBOARD',
	      component: _Cfa2Dashboard2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_QUESTION_BANK,
	      name: 'Cfa 2 QuestionBank',
	      components: _Cfa2_2023QuestionBank2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES,
	      name: 'Cfa 2 Cases',
	      components: _Cfa2cases2.default
	    }),
	    ' ',
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION,
	      name: 'Cfa 2 Chapter',
	      components: _Cfa2chapter2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_QUIZZES,
	      name: 'Cfa 2 Quizzes',
	      components: _Cfa2_2023Quizzes2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_QUIZZES_BEFORE_START,
	      name: 'Cfa 2 Before Start',
	      components: _Cfa2BeforeStart2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_QUIZZES_BEGIN,
	      name: 'Cfa 2 Begin Quiz',
	      components: _Cfa2Beginquiz2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_NOTES_QUES_VIEW,
	      name: 'Cfa 2 View Notes',
	      components: _cfa2NotesViewques2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_NOTES_READINGS,
	      name: 'Cfa 2 Notes Readings',
	      components: _Cfa2notesreadings2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_NOTES,
	      name: 'CFA Level 2 2025 Notes',
	      components: _Notes8.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY,
	      name: 'Cfa2videodisplay',
	      components: _Cfavideodisplay4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_VIDEO_LESSONS,
	      name: 'CFA level 2 2025 Video Lessons',
	      components: _VideoLessons10.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2025_BEGIN_NOTES,
	      name: 'Cfa Level 2 2025 Notes Beginchapters',
	      components: _Cfanotesbeginchapters2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_DASHBOARD,
	      name: 'CFA2_2027_DASHBOARD',
	      component: _Cfa2Dashboard4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_QUESTION_BANK,
	      name: 'Cfa 2 2027 QuestionBank',
	      components: _Cfa2_2023QuestionBank4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES,
	      name: 'Cfa 2 2027 Cases',
	      components: _Cfa2cases4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION,
	      name: 'Cfa 2 2027 Chapter',
	      components: _Cfa2chapter4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_QUIZZES,
	      name: 'Cfa 2 2027 Quizzes',
	      components: _Cfa2_2023Quizzes4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_QUIZZES_BEFORE_START,
	      name: 'Cfa 2 2027 Before Start',
	      components: _Cfa2BeforeStart4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_QUIZZES_BEGIN,
	      name: 'Cfa 2 2027 Begin Quiz',
	      components: _Cfa2Beginquiz4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_NOTES_QUES_VIEW,
	      name: 'Cfa 2 2027 View Notes',
	      components: _cfa2NotesViewques4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_NOTES_READINGS,
	      name: 'Cfa 2 2027 Notes Readings',
	      components: _Cfa2notesreadings4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_NOTES,
	      name: 'CFA Level 2 2027 Notes',
	      components: _Notes10.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY,
	      name: 'Cfa2 2027 videodisplay',
	      components: _Cfavideodisplay6.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_VIDEO_LESSONS,
	      name: 'CFA level 2 2027 Video Lessons',
	      components: _VideoLessons12.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.CFA2_2027_BEGIN_NOTES,
	      name: 'Cfa Level 2 2027 Notes Beginchapters',
	      components: _Cfanotesbeginchapters4.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.ESG_DASHBOARD, name: 'ESG Dashboard', component: _index60.default }),
	    ' ',
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.ESG_NOTES, name: 'ESG Notes', component: _index62.default }),
	    ' ',
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.ESG_VIDEOS, name: 'ESG Notes', component: _index66.default }),
	    ' ',
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.ESG_VIDEO_LESSON, name: 'ESG Notes', component: _ChapterVideos2.default }),
	    ' ',
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_QUESTION_BANK,
	      name: 'ESG Question Bank',
	      component: _index64.default
	    }),
	    ' ',
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.ESG_CBT, name: 'ESG CBT', component: _index58.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_QUESTION_BANK_VIEW_QUE,
	      name: 'ESG Begin Question',
	      component: _BeginQuestion2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_CBT_VIEW_ATTEMPTED_MOCK,
	      name: 'ESG Begin Question',
	      component: _ViewAttemptedMock2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_CBT_INTRODUCTION,
	      name: 'ESG Begin Question',
	      component: _Instructions2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AppRoutes2.default.ESG_CBT_QUESTIONS, name: 'ESG Begin Question', component: _CBTQuestion2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_CBT_FINISH_PAGE,
	      name: 'ESG Begin Question',
	      component: _CBTFinishPage2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_QUESTION_BANK_LIST_QUE,
	      name: 'ESG Questions List',
	      component: _QuestionList2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: _AppRoutes2.default.ESG_CBT_DETAILED_STATS_GRAPH,
	      name: 'ESG CBT Detailed Graph',
	      component: _index56.default
	    }),
	    _gmatFocus.gmatFocusRoutes.map(function (element) {
	      return _react2.default.createElement(_reactRouter.Route, { path: element.path, name: element.name, component: element.component });
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/webinars', name: 'Webinars', components: _WebinarsList2.default })
	  ),
	  ' ',
	  _react2.default.createElement(_reactRouter.Route, { path: '/*', name: 'FRM Notes', components: _Auth2.default })
	);
	
	//Webinars
	
	//  ===================== CFA 2 -2027 - EXAMS ENDS =====================
	
	// ===================== EA - EXAMS =====================
	
	
	//  ===================== CFA 2 -2025 - EXAMS START =====================
	
	/*SOA - Probability*/
	
	
	// CFA 3 Notes and video
	
	// import SelectExtras from './views/Subscribe/SelectExtras.js';
	
	
	//^ *********************************************************
	//^                  CFA I EXAM ROUTES
	//^ *********************************************************
	//* ~~~~~~~ CBT ROUTE ~~~~~~~~

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gmatFocusRoutes = undefined;
	
	var _dashboard = __webpack_require__(822);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _Beginchapters = __webpack_require__(823);
	
	var _Beginchapters2 = _interopRequireDefault(_Beginchapters);
	
	var _QuestionBank = __webpack_require__(824);
	
	var _QuestionBank2 = _interopRequireDefault(_QuestionBank);
	
	var _Readings = __webpack_require__(825);
	
	var _Readings2 = _interopRequireDefault(_Readings);
	
	var _GMAT2Statement = __webpack_require__(826);
	
	var _GMAT2Statement2 = _interopRequireDefault(_GMAT2Statement);
	
	var _GMATCases = __webpack_require__(827);
	
	var _GMATCases2 = _interopRequireDefault(_GMATCases);
	
	var _GMATMultipleStatement = __webpack_require__(828);
	
	var _GMATMultipleStatement2 = _interopRequireDefault(_GMATMultipleStatement);
	
	var _GMATTab = __webpack_require__(829);
	
	var _GMATTab2 = _interopRequireDefault(_GMATTab);
	
	var _GMATTable = __webpack_require__(830);
	
	var _GMATTable2 = _interopRequireDefault(_GMATTable);
	
	var _Viewques = __webpack_require__(831);
	
	var _Viewques2 = _interopRequireDefault(_Viewques);
	
	var _BeforeStart = __webpack_require__(832);
	
	var _BeforeStart2 = _interopRequireDefault(_BeforeStart);
	
	var _BeginQuizContainer = __webpack_require__(834);
	
	var _BeginQuizContainer2 = _interopRequireDefault(_BeginQuizContainer);
	
	var _Quizzes = __webpack_require__(835);
	
	var _Quizzes2 = _interopRequireDefault(_Quizzes);
	
	var _VideoLessons = __webpack_require__(837);
	
	var _VideoLessons2 = _interopRequireDefault(_VideoLessons);
	
	var _videodisplay = __webpack_require__(838);
	
	var _videodisplay2 = _interopRequireDefault(_videodisplay);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gmatFocusRoutes = exports.gmatFocusRoutes = [
	//^ ******* Dashboard ************ //
	{
	  path: _appRoutes2.default.DASHBOARD,
	  name: 'introduction',
	  component: _dashboard2.default
	},
	//^ ******* Videos ************ //
	{
	  path: _appRoutes2.default.VIDEO_DISPLAY,
	  name: 'VIDEO_DISPLAY',
	  component: _videodisplay2.default
	}, {
	  path: _appRoutes2.default.VIDEO_LESSONS,
	  name: 'VIDEO_LESSONS',
	  component: _VideoLessons2.default
	},
	//^ ******* Question Bank ************ //
	{
	  path: _appRoutes2.default.QUESTION_BANK,
	  name: 'QUESTION_BANK',
	  component: _QuestionBank2.default
	}, {
	  path: _appRoutes2.default.QUESTION_BANK_READING,
	  name: 'QUESTION_BANK_READING',
	  component: _Readings2.default
	}, {
	  path: _appRoutes2.default.QUESTION_BANK_VIEW_QUE,
	  name: 'QUESTION_BANK_VIEW_QUE',
	  component: _Beginchapters2.default
	}, {
	  path: _appRoutes2.default.TWO_PART_STATEMENT,
	  name: 'TWO_PART_STATEMENT',
	  component: _GMAT2Statement2.default
	}, {
	  path: _appRoutes2.default.GRAPH_MULTI_STATEMENT,
	  name: 'GRAPH_MULTI_STATEMENT',
	  component: _GMATMultipleStatement2.default
	}, { path: _appRoutes2.default.TAB, name: 'GMAT Tab', component: _GMATTab2.default }, { path: _appRoutes2.default.TABLE, name: ' Table', component: _GMATTable2.default }, {
	  path: _appRoutes2.default.QUESTION_BANK_LIST_QUE,
	  name: 'Question Bank List',
	  component: _Viewques2.default
	},
	//^ ******* Quizzes ************ //
	{
	  path: _appRoutes2.default.BEGIN_CASE,
	  name: 'Begin Case',
	  component: _GMATCases2.default
	}, { path: _appRoutes2.default.QUIZZES, name: 'Quizzes', component: _Quizzes2.default }, { path: _appRoutes2.default.QUIZZES_BEFORE_START, name: 'Before start', component: _BeforeStart2.default }, { path: _appRoutes2.default.BEGIN_QUIZ, name: 'Begin quizzes', component: _BeginQuizContainer2.default }, { path: _appRoutes2.default.BEGIN_CASE_QUIZ, name: 'Begin quizzes', component: _BeginQuizContainer2.default }, { path: _appRoutes2.default.QUIZZES_BEGIN, name: 'Begin quizzes', component: _BeginQuizContainer2.default }, { path: _appRoutes2.default.BEGIN_TABLE_QUIZ, name: 'Begin quizzes', component: _BeginQuizContainer2.default }, { path: _appRoutes2.default.BEGIN_GRAPH_QUIZ, name: 'Begin quizzes', component: _BeginQuizContainer2.default }, { path: _appRoutes2.default.BEGIN_TWO_PART_QUIZ, name: 'Begin quizzes', component: _BeginQuizContainer2.default }];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ApiService = function () {
	    function ApiService() {
	        _classCallCheck(this, ApiService);
	
	        this.apiEndpoint = _App_data2.default.backend_api;
	        this.authHeader = null;
	    }
	
	    _createClass(ApiService, [{
	        key: 'setAuthHeader',
	        value: function setAuthHeader(token) {
	            this.authHeader = {
	                'Authorization': '' + token
	            };
	            return this;
	        }
	    }, {
	        key: 'serializeUrl',
	        value: function serializeUrl(obj) {
	            return Object.entries(obj).map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    key = _ref2[0],
	                    val = _ref2[1];
	
	                return key + '=' + val;
	            }).join('&');
	        }
	    }, {
	        key: 'buildEndpointUrl',
	        value: function buildEndpointUrl(options) {
	            var query = options.query != null ? options.query : null;
	            var path = options.path;
	            var queryParams = query != null ? this.serializeUrl(query) : null;
	            var reqString = ('' + this.apiEndpoint + (path != null ? '/' + path : '') + (queryParams != null && queryParams.length > 0 ? '?' + queryParams : '')).trim();
	            return reqString.replace(/([^:]\/)\/+/g, "$1");
	        }
	    }, {
	        key: '__fetchRequest',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(url, method, data) {
	                var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	                var normalizedMethod, options, beOptions, response, text;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                normalizedMethod = method.toUpperCase();
	                                options = {
	                                    method: normalizedMethod,
	                                    headers: Object.assign({
	                                        'Accept': 'application/json'
	                                    }, headers)
	                                };
	                                beOptions = { path: url };
	
	
	                                if (data != null && normalizedMethod === 'POST') {
	                                    options.body = JSON.stringify(data);
	                                    options.headers['Content-Type'] = 'application/json';
	                                }
	
	                                if (data != null && normalizedMethod === 'GET') {
	                                    beOptions.query = data;
	                                }
	
	                                if (this.authHeader != null) {
	                                    options.headers = Object.assign({}, options.headers, this.authHeader);
	                                }
	
	                                _context.next = 8;
	                                return fetch(this.buildEndpointUrl(beOptions), options);
	
	                            case 8:
	                                response = _context.sent;
	
	                                if (response.ok) {
	                                    _context.next = 14;
	                                    break;
	                                }
	
	                                _context.next = 12;
	                                return response.text();
	
	                            case 12:
	                                text = _context.sent;
	                                throw new Error('HTTP ' + response.status + ': ' + text);
	
	                            case 14:
	                                _context.next = 16;
	                                return response.json();
	
	                            case 16:
	                                return _context.abrupt('return', _context.sent);
	
	                            case 17:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function __fetchRequest(_x2, _x3, _x4) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return __fetchRequest;
	        }()
	    }, {
	        key: 'get',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(url, query, headers) {
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.__fetchRequest(url, 'GET', query, headers);
	
	                            case 2:
	                                return _context2.abrupt('return', _context2.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function get(_x5, _x6, _x7) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return get;
	        }()
	    }, {
	        key: 'post',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(url, data, headers) {
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.__fetchRequest(url, 'POST', data, headers);
	
	                            case 2:
	                                return _context3.abrupt('return', _context3.sent);
	
	                            case 3:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function post(_x8, _x9, _x10) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return post;
	        }()
	    }]);
	
	    return ApiService;
	}();
	
	exports.default = ApiService;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getWebinarMoment = getWebinarMoment;
	exports.convertWebinarTime = convertWebinarTime;
	
	var _momentTimezone = __webpack_require__(202);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _windowsIana = __webpack_require__(1255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Resolve a Windows timezone id (e.g. "US Eastern Standard Time") to an IANA name
	 * (e.g. "America/Indianapolis") using the CLDR map shipped with the windows-iana
	 * package. Covers every Windows tz id MS Graph can emit. Logs a warning when an
	 * id isn't in the map so we notice drift instead of silently misinterpreting it.
	 */
	function resolveIana(windowsTzId) {
	    if (!windowsTzId) return null;
	    var list = (0, _windowsIana.findIana)(windowsTzId);
	    var iana = Array.isArray(list) ? list[0] : null;
	    if (!iana && typeof console !== 'undefined' && console.warn) {
	        console.warn('[TimezoneUtils] Unknown Windows tz id: "' + windowsTzId + '" — falling back to UTC.');
	    }
	    return iana;
	}
	
	/**
	 * Interpret a naive datetime in the given Windows timezone and return a
	 * timezone-aware moment. Unknown/missing tz ids fall back to UTC (deterministic)
	 * rather than browser-local time, so live/past classification never depends on
	 * who is looking at the page.
	 */
	function getWebinarMoment(naiveDatetime, windowsTzId) {
	    if (!naiveDatetime) return null;
	
	    var iana = resolveIana(windowsTzId);
	
	    // Strip trailing Z that Sequelize adds to naive datetime values — without
	    // this, moment.tz would interpret the value as UTC instead of the source tz.
	    var clean = String(naiveDatetime).replace(/Z$/i, '');
	    return _momentTimezone2.default.tz(clean, iana || 'UTC');
	}
	
	/**
	 * Convert a naive webinar datetime to the user's browser timezone.
	 * Returns { formatted, tzAbbr } where tzAbbr is the abbreviation in the user's timezone.
	 */
	function convertWebinarTime(naiveDatetime, windowsTzId, format) {
	    var m = getWebinarMoment(naiveDatetime, windowsTzId);
	    if (!m || !m.isValid()) return { formatted: '', tzAbbr: '' };
	
	    var browserTz = _momentTimezone2.default.tz.guess();
	    var local = m.tz(browserTz);
	
	    return {
	        formatted: local.format(format),
	        tzAbbr: local.format('z')
	    };
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Addons = function (_Component) {
	  _inherits(Addons, _Component);
	
	  function Addons(props) {
	    _classCallCheck(this, Addons);
	
	    var _this = _possibleConstructorReturn(this, (Addons.__proto__ || Object.getPrototypeOf(Addons)).call(this, props));
	
	    _this._buyPackage = function (item, e) {
	      var data = { token: _this.state.token, idname: _this.state.idname, plan_id: item.id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout/addExamsToCart', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.context.router.push({
	            pathname: '/cart/',
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              package_data: item,
	              exam_name: _this.state.exam_name
	            }
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._getExams = function (item, e) {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      exams: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      answered: [],
	      plan_data: '',
	      pack_class: 'hide_block',
	      exam_name: '',
	      exam_class: 'row'
	    };
	    return _this;
	  }
	
	  //Function to Add Addon to cart and push routing to cart page
	
	
	  //Function to redirect page to subscription page
	
	
	  _createClass(Addons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      //Fetch all Addons
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout/getAddons', data).then(function (resp) {
	        if (resp.success) {
	          _this2.setState({ ValidToken: true });
	          if (resp.exam_plans.length) {
	            var plan_data = resp.exam_plans.map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 align-self-center text-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'plan_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'plan_header' },
	                    _language2.default.LC().ALL_EXAMS
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'plan_price' },
	                    '$',
	                    item.price
	                  ),
	                  (0, _function.renderHTMLContent)(item.package_desc, "div", "addon_text"),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary pointer_class margin_bottom_40',
	                      onClick: _this2._buyPackage.bind(_this2, item)
	                    },
	                    _language2.default.LC().BUY
	                  )
	                )
	              );
	            });
	          } else {
	            var plan_data = _react2.default.createElement(
	              'div',
	              null,
	              _language2.default.LC().NO_PACKAGE_FOUND
	            );
	          }
	          _this2.setState({ package_data: plan_data });
	        } else {
	          _this2.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().ADDONS
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getExams.bind(this)
	              },
	              _language2.default.LC().GO_BACK_TO_EXAMS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          this.state.package_data
	        )
	      );
	    }
	  }]);
	
	  return Addons;
	}(_react.Component);
	
	Addons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Addons;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	__webpack_require__(80);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _highlightText = __webpack_require__(56);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var attemptedCaseArray = [];
	/* eslint-disable*/
	var longPressDuration = 450;
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.caseOffset !== _this.props.params.caseOffset || prevProps.params.quesOffset !== _this.props.params.quesOffset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _this.getCases(data);
	        _this.getUserStats();
	        _this.getFlagQuestions();
	      }
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	              };
	
	              _this.getCases(data);
	              _this.getUserStats();
	              _this.getrightanswer();
	              // this.getFlagQuestions();
	              if (_this.props.params.timerStart === 'true') {
	                _this.timer = setInterval(_this.countDown, 1000);
	              } else {
	                clearInterval(_this.timer);
	              }
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getMockNamebyId', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 9:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getDetailedResultGraph = function (totalQuestion) {
	      var _this$props$params = _this.props.params,
	          id = _this$props$params.id,
	          testid = _this$props$params.testid,
	          timer = _this$props$params.timer;
	
	      var path = _AppRoutes2.default.CFA2_DETAILED_RESULT_GRAPH.replace(':id', id).replace(':test_id', testid).replace(':totalQuestions', totalQuestion).replace(':timer', timer).replace(':isNegative', _this.state.isNegative);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getCases = function (data) {
	      _this.setState({
	        display_main_loader: 'show_block z-index-1000 bg-white',
	        vpCaseLoader: true,
	        questionLoader: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getCFAMockCases', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.question && resp.question.length) {
	            _this.setState({
	              casesData: resp.question,
	              isLoading: false,
	              isDataLoading: false,
	              vpCaseLoader: false,
	              questionLoader: false,
	              display_main_loader: 'hide_block',
	              //selected case
	              selectedQuestionData: resp.question[_this.props.params.caseOffset],
	              //all questions of selected case
	              questionsData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_cbt_questions ? resp.question[_this.props.params.caseOffset].cfa2_cbt_questions : [],
	              //1st question of selected case
	              selectedCaseQuestionData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_cbt_questions && resp.question[_this.props.params.caseOffset].cfa2_cbt_questions[_this.props.params.quesOffset] ? resp.question[_this.props.params.caseOffset].cfa2_cbt_questions[_this.props.params.quesOffset] : []
	            });
	          }
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	
	      // getTotalQuestionsCount
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getTotalQuestionsCount', data).then(function (resp) {
	        if (resp.success) {
	          // console.log('Success --------> ', resp);
	          _this.setState({
	            totalQuestionCount: resp.question
	          });
	        } else {
	          // console.log('falure --------> ', resp);
	        }
	      });
	    };
	
	    _this.changeCase = function (questionNumber, index) {
	      var casesData = _this.state.casesData;
	
	      _this.getUserStats();
	      // this.getFlagQuestions();
	      _this.setState({
	        isLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      if (questionNumber) {
	        //  '/cfa2cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'
	        var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset)] && casesData[parseInt(_this.props.params.caseOffset)].cfa2_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset)].cfa2_cbt_questions[0].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', index).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        }, _this.getCases(data));
	      }
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	
	          attemptedCaseArray = resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	      _this.getUserStats();
	      if (questionNumber) {
	        // /cfa2cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset
	
	        var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', questionNumber).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', index).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.getNextCase = function () {
	      var casesData = _this.state.casesData;
	
	      _this.setState({
	        isLoading: true
	      });
	      _this.slider.slickGoTo(3);
	
	      var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) + 1] && casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_cbt_questions[0].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getPreviousCase = function () {
	      var casesData = _this.state.casesData;
	
	      _this.setState({
	        isLoading: true
	      });
	      _this.slider.slickGoTo(3 - 2);
	
	      var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) - 1] && casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_cbt_questions[0].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getPreviousQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	
	      var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) - 1].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) - 1 : 1).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getNextQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	
	      var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) + 1].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) + 1 : 1).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context5.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/addHighlightedText', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context4.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x4) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context7.next = 7;
	                  break;
	                }
	
	                _context7.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/deleteHighlightedText', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(res) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context6.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context7.next = 8;
	                break;
	
	              case 7:
	                return _context7.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getHighlightedText', data).then(function () {
	        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(res) {
	          return _regenerator2.default.wrap(function _callee8$(_context8) {
	            while (1) {
	              switch (_context8.prev = _context8.next) {
	                case 0:
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context8.stop();
	              }
	            }
	          }, _callee8, _this2);
	        }));
	
	        return function (_x7) {
	          return _ref8.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                //console.log('e. type ___________', e.type);
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  // console.log('Print params ---------> ', this.props.params);
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : null,
	                    caseno: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	                    caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : null
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x8, _x9, _x10, _x11) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context11.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/addStrikeThrough', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(res) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            _context10.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this2);
	                  }));
	
	                  return function (_x13) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this2);
	      }));
	
	      return function (_x12) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      // console.log('userData --------------> ', userData);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUsersChoice', userData).then(function () {
	        var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	              switch (_context13.prev = _context13.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserAnswer', ansData).then(function () {
	                      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(res) {
	                        return _regenerator2.default.wrap(function _callee12$(_context12) {
	                          while (1) {
	                            switch (_context12.prev = _context12.next) {
	                              case 0:
	                              case 'end':
	                                return _context12.stop();
	                            }
	                          }
	                        }, _callee12, _this2);
	                      }));
	
	                      return function (_x15) {
	                        return _ref13.apply(this, arguments);
	                      };
	                    }());
	                  }
	
	                case 1:
	                case 'end':
	                  return _context13.stop();
	              }
	            }
	          }, _callee13, _this2);
	        }));
	
	        return function (_x14) {
	          return _ref12.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getrightanswer = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var ansdata = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        // console.log('I am on respnsod of right answer -----> ', resp_count);
	        if (resp_count.success) {
	          _this.setState({
	            rightanswercount: resp_count.allrightanswercount.question_count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    };
	
	    _this.handleScroll = function () {
	      window.scroll({
	        top: document.body.offsetHeight,
	        left: 0,
	        behavior: 'smooth'
	      });
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state = _this.state,
	          flag = _this$state.flag,
	          userStatsData = _this$state.userStatsData,
	          questionsData = _this$state.questionsData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== questionsData.length) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserQuizStatus', data).then(function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	          return _regenerator2.default.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x16) {
	          return _ref14.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getStrikedText', data).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x17) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.backToMock = function () {
	      var path = _AppRoutes2.default.CFA2_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', _this.props.params.id).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getReadingViseScore = function () {
	      // console.log('heeyyyyyyy');
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getrightAnswerReadingVise', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          var temp, arr;
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  // console.log('response of rightanswer ------> ', res);
	                  temp = 0;
	                  arr = res.readingName.map(function (item, i) {
	                    if (res.allrightanswercount.some(function (ele) {
	                      return ele.id === item.id;
	                    })) {
	                      return Object.assign({}, item, res.allrightanswercount[temp++]);
	                    } else return Object.assign({}, item, 0);
	                  });
	
	                  _this.setState({
	                    readingViseScore: arr
	                  });
	
	                case 3:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this._hideReportForm = function () {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block', reportError: '' });
	    };
	
	    _this.reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	
	      _this.setState({
	        reportError: ''
	      });
	      if (comment.length < 2) {
	        _this.setState({
	          reportError: 'Please enter comment'
	        });
	        return;
	      }
	      // BUG FIX: `questiono` is a URL position param (1-based question index
	      // within a case), NOT the cfa2_cbt_questions primary key. Saving it as
	      // `question_id` broke the admin auto-reply join (cfa2_cbt_question came
	      // back null → empty reported_item). Sibling save/answer calls in this
	      // file (~lines 402/510/535) already use selectedQuestionData.id /
	      // selectedCaseQuestionData.id — reuse the same pattern here.
	      var _this$state2 = _this.state,
	          selectedCaseQuestionData = _this$state2.selectedCaseQuestionData,
	          selectedQuestionData = _this$state2.selectedQuestionData;
	
	      var realQuestionId = selectedCaseQuestionData && selectedCaseQuestionData.id || selectedQuestionData && selectedQuestionData.id || (_this.props.params.questiono ? parseInt(_this.props.params.questiono) : null);
	
	      var data = {
	        case_id: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: realQuestionId,
	        comment: comment,
	        offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : 0,
	        timer: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : 0,
	        mockName: _this.state.mockName,
	        quesOffset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : 0,
	        caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : 0
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      readingViseScore: '',
	      report_block: 'card hide_block',
	      totalQuestionCount: 0
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.state.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        // '/cfa2cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart';
	        var path = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id).replace(':caseno', this.props.params.caseno).replace(':questiono', this.props.params.questiono).replace(':timer', this.props.params.timer).replace(':testid', this.props.params.testid).replace(':caseOffset', this.props.params.caseOffset).replace(':quesOffset', this.props.params.quesOffset).replace(':isNegative', false).replace(':timerStart', this.props.params.timerStart);
	        this.context.router.push({
	          pathname: path
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.state.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserTimer', data).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this3);
	        }));
	
	        return function (_x19) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          vpCaseLoader = _state.vpCaseLoader,
	          questionLoader = _state.questionLoader,
	          rightanswercount = _state.rightanswercount,
	          outOfScore = _state.outOfScore,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData,
	          readingViseScore = _state.readingViseScore,
	          reportError = _state.reportError,
	          reportLoading = _state.reportLoading,
	          questionCount = _state.totalQuestionCount;
	      var question_ids = userStatsData.question_ids;
	
	      var totalQuestionCount = question_ids && JSON.parse(question_ids).length || questionCount && questionCount.length || 0;
	      var userTime = 0;
	      if (userStatsData && userStatsData.user_time_value && this.props.params.timer) {
	        if (userStatsData.isNegative === 'true') {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) - userStatsData.user_time_value);
	        } else {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) + userStatsData.user_time_value);
	        }
	      }
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedCaseQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var parseResult = Object.keys(userChoice).map(function (x) {
	        return parseInt(x, 10);
	      });
	      selectedQuestionData.cfa2_cbt_questions;
	      var count = 0;
	      parseResult.forEach(function (element) {
	        var attemptedCount = questionsData.filter(function (item) {
	          if (item.id === element) {
	            count++;
	          }
	          return item.id === element;
	        });
	      });
	
	      var content = selectedQuestionData.question;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            {
	              className: casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'pointer_class btn-primary back-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                _language2.default.LC().BACK
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this4.slider = slider;
	                      }
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeCase(item.id, index);
	                          },
	                          className: (attemptedCaseArray.indexOf(item.id) === -1 ? 'bg-completed-cases ' : '') + '\n                              ' + (index === parseInt(_this4.props.params.caseOffset) ? 'active button-trial' : 'button-trial')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper  col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header d-flex justify-content-between qus-header' },
	                    selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                      'div',
	                      { className: 'ques-wrapper all-ques' },
	                      _react2.default.createElement('h1', {
	                        className: 'text-center mb-2 text-capitalize',
	                        dangerouslySetInnerHTML: {
	                          __html: selectedQuestionData.case_name
	                        }
	                      }),
	                      _react2.default.createElement('div', {
	                        contentEditable: 'false',
	                        className: 'font-weight-normal',
	                        dangerouslySetInnerHTML: {
	                          __html: selectedQuestionData.case
	                        }
	                      })
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text-right que-action-arrow' },
	                      _react2.default.createElement('i', {
	                        className: this.props.params.caseOffset === '0' ? 'fa fa-angle-left ques_arrow pointer_class hide_block' : 'fa fa-angle-left ques_arrow pointer_class',
	                        onClick: this.getPreviousCase
	                      }),
	                      _react2.default.createElement('i', {
	                        className: parseInt(this.props.params.caseOffset) === casesData.length - 1 ? 'fa fa-angle-right ques_arrow pointer_class hide_block' : 'fa fa-angle-right ques_arrow pointer_class',
	                        onClick: this.getNextCase
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper height-0' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this4.slider = slider;
	                    }
	                  }),
	                  ' ',
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag && flag.length ? flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0] : '';
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                        ' + (index === parseInt(_this4.props.params.quesOffset) ? 'active' : '') + '\n                        ' + (userChoice[item.id] === item.answer ? 'right-ans' : userChoice[item.id] ? 'wrong-ans' : 'not-ans') + '\n                        ' + (flaggedQuestions ? 'flag-add' : '') + '\n                        '
	                        },
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : '',
	                        index + 1
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-11' },
	                isDataLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header qus-header finish-question-wrapper' },
	                    selectedCaseQuestionData && selectedCaseQuestionData.question ? _react2.default.createElement(
	                      'div',
	                      { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_right_20',
	                          alt: '',
	                          width: '30'
	                        }),
	                        'Q.',
	                        parseInt(this.props.params.quesOffset) + 1
	                      ),
	                      _react2.default.createElement('div', {
	                        contentEditable: 'false',
	                        dangerouslySetInnerHTML: {
	                          __html: selectedCaseQuestionData.question
	                        },
	                        className: 'qus-title w-100',
	                        style: {
	                          marginTop: '8px'
	                        }
	                      })
	                    ) : null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'btn btn-primary pointer_class mid-btn',
	                          onClick: function onClick() {
	                            _this4.setState({
	                              showSectionReview: true
	                            });
	                            _this4.getReadingViseScore();
	                          }
	                        },
	                        _language2.default.LC().SCORE
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_MYSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap tooltip_wrap_margin' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: (rightanswercount ? rightanswercount : 0) === 0 ? true : false,
	                          className: (rightanswercount ? rightanswercount : 0) === 0 ? 'cursor_not_Allowed btn btn-primary  mid-btn' : 'btn btn-primary mid-btn',
	                          onClick: function onClick() {
	                            return _this4.getDetailedResultGraph(totalQuestionCount);
	                          }
	                        },
	                        _language2.default.LC().GRAPH
	                      ),
	                      rightanswercount ? rightanswercount === 0 ? null : _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_GRAPH
	                      ) : null
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _constant.optionsArr.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-12', id: item, key: index },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box cursor-default ' + (userChoice ? selectedCaseQuestionData && selectedCaseQuestionData.answer === item && userChoice[_this4.props.params.questiono] === item ? 'border-green' : selectedCaseQuestionData.answer === item ? 'border-green' : userChoice[_this4.props.params.questiono] === item ? 'border-red' : '' : '')
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  { className: 'ans_box_text' },
	                                  selectedCaseQuestionData && selectedCaseQuestionData[item] ? _react2.default.createElement('span', {
	                                    contentEditable: 'false',
	                                    dangerouslySetInnerHTML: {
	                                      __html: selectedCaseQuestionData[item]
	                                    }
	                                  }) : null
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'score-wrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'score-inner' },
	                            rightanswercount ? rightanswercount : 0,
	                            '/',
	                            totalQuestionCount
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().You_Scored,
	                            ' ',
	                            Math.ceil((rightanswercount ? rightanswercount * 100 : 0) / totalQuestionCount),
	                            '%'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer finished-time' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              _language2.default.LC().TEST_COMPLETED_IN
	                            ),
	                            _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'timer_box' },
	                              userTime
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            'span',
	                            {
	                              className: 'up tooltip-hover-questions',
	                              style: { padding: '10px' }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              ' ',
	                              _language2.default.LC().REPORT_THIS_QUESTION,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'report-icon-wrapper',
	                                onClick: function onClick() {
	                                  _this4.handleScroll();
	                                  _this4.setState({
	                                    report_block: 'card show_block'
	                                  });
	                                }
	                              },
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/report4.png',
	                                alt: 'report'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getPreviousQuestion(_this4.props.params.quesOffset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.quesOffset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getNextQuestion(_this4.props.params.quesOffset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card show_block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'main_loader ' + this.state.display_main_loader },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loader-mid' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block-loader' },
	                    _react2.default.createElement(_loader2.default, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'card-header highlight_finish_text ' + (userChoice && userChoice[this.props.params.questiono] === selectedCaseQuestionData.answer ? 'text_success-cbt' : !userChoice[this.props.params.questiono] ? 'text_unAttempted-cbt' : 'text_failure-cbt')
	                },
	                userChoice && userChoice[this.props.params.questiono] === selectedCaseQuestionData.answer ? '' + _language2.default.LC().Correct : !userChoice[this.props.params.questiono] ? '' + _language2.default.LC().NOT_ATTEMPTED : '' + _language2.default.LC().Incorrect
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement('p', {
	                  className: 'answer_text',
	                  dangerouslySetInnerHTML: {
	                    __html: selectedCaseQuestionData && selectedCaseQuestionData.answer ? _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + (selectedCaseQuestionData.answer === 'choice_a' ? '<strong>' + _language2.default.LC().A + '.</strong>' : selectedCaseQuestionData.answer === 'choice_b' ? '<strong>' + _language2.default.LC().B + '.</strong>' : selectedCaseQuestionData.answer === 'choice_c' ? '<strong>' + _language2.default.LC().C + '.</strong>' : null) : ''
	                  }
	                }),
	                _react2.default.createElement('p', {
	                  contentEditable: 'false',
	                  className: 'view_questionhtml',
	                  dangerouslySetInnerHTML: {
	                    __html: selectedCaseQuestionData && selectedCaseQuestionData.explanation ? selectedCaseQuestionData.explanation : ''
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'error_text ml-1' },
	                        ' ',
	                        reportError
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: function onClick() {
	                              return _this4.reportQuestion(selectedQuestionData.id);
	                            }
	                          },
	                          reportLoading ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                            ' ',
	                            _language2.default.LC().PLEASE_WAIT
	                          ) : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: function onClick() {
	                              return _this4._hideReportForm();
	                            }
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: function onClick() {
	                              _this4.setState({
	                                report_block: 'card hide_block',
	                                successAlert: false
	                              });
	                            }
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'sidebar-review-wrapper sidebar-score-wrapper ' + (showSectionReview ? 'active' : '')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              ' ',
	              _language2.default.LC().TOPIC_WISE_SCORE
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'cursor-pointer',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'score-list-wrapper' },
	              readingViseScore && readingViseScore.length ? readingViseScore.map(function (item, index) {
	                var readingPercentage = item.question_count * 100 / item.cfa2_cbt_questions.length;
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      index + 1,
	                      '\xA0 ',
	                      item.chapter_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress custom-prog-bar margin_top_5' },
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'progress-bar',
	                          role: 'progressbar',
	                          style: {
	                            width: Math.ceil(readingPercentage) + '%'
	                          },
	                          'aria-valuenow': '' + Math.ceil(readingPercentage),
	                          'aria-valuemin': '0',
	                          'aria-valuemax': '100'
	                        },
	                        Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0,
	                        '%'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'score-inner' },
	                    item.question_count ? item.question_count : 0,
	                    '/',
	                    item.cfa2_cbt_questions ? item.cfa2_cbt_questions.length : 0
	                  )
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-qus-found no-mock-exam mt-5' },
	                _react2.default.createElement('img', {
	                  width: '62px',
	                  src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'mt-1' },
	                  _language2.default.LC().NO_SCORE_FOUND
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var CFA2IntoductionInstruction = function (_Component) {
	  _inherits(CFA2IntoductionInstruction, _Component);
	
	  function CFA2IntoductionInstruction(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA2IntoductionInstruction);
	
	    var _this = _possibleConstructorReturn(this, (CFA2IntoductionInstruction.__proto__ || Object.getPrototypeOf(CFA2IntoductionInstruction)).call(this, props));
	
	    _this.componentDidMount = function () {
	      // console.log(
	      //   'I am here on Frontendsrc\viewsCBTCFA2CBTNewIntoductionInstructionindex.js '
	      // );
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	    };
	
	    _this.changeQuestion = function (questionNumber) {
	      if (questionNumber) {
	        // ('/cfa2introduction/:id/:questiono/:timer');
	        var path = _this.introductionRoute.replace(':id', _this.props.params.id).replace(':questiono', questionNumber).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.getPrevious = function (questionNumber) {
	      if (questionNumber) {
	        var path = _this.introductionRoute.replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) - 1 : 1).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.getNext = function (questionNumber) {
	      if (questionNumber) {
	        var path = _this.introductionRoute.replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) + 1 : 1).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.startTest = function () {
	      _this.setState({
	        startLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        status: 'pending'
	      };
	      var mockExamSource = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + mockExamSource + '/getCFAMockCases'), data).then(function (caseResp) {
	        if (caseResp.success) {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + mockExamSource + '/getCFAMockQuestions'), data).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                startLoading: true
	              });
	              var _response$question = response.question,
	                  question = _response$question === undefined ? [] : _response$question;
	
	              var questionIds = question.map(function (questionDetail) {
	                return questionDetail.id;
	              });
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + mockExamSource + '/addUsersChoice', Object.assign({}, userData, { questionIds: questionIds })).then(function () {
	                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                  var appRoute, path;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (res.success) {
	                            appRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS : _AppRoutes2.default.CFA2_CBT_QUESTIONS;
	                            path = appRoute.replace(':id', _this.props.params.id).replace(':caseno', caseResp.question && caseResp.question.length ? caseResp.question[0].id : 1).replace(':questiono', response.question && response.question.length ? response.question[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', res.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	
	                            _this.context.router.push({
	                              pathname: path
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref.apply(this, arguments);
	                };
	              }());
	            }
	          });
	        }
	      });
	    };
	
	    _this.strikeText = function (e, value) {
	      e.preventDefault();
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      if (e.type === 'contextmenu') {
	        strikeThroughArr.push(value);
	        _this.setState({
	          strikeThroughArr: strikeThroughArr
	        });
	      } else {
	        return;
	      }
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      token: '',
	      idname: '',
	      startLoading: false,
	      strikeThroughArr: []
	    };
	    _this.introductionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_CBT_INTRODUCTION;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFA2IntoductionInstruction, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          startLoading = _state.startLoading,
	          strikeThroughArr = _state.strikeThroughArr;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().Section_Introduction
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                Array.from({ length: 12 }, function (item) {
	                  return item;
	                }).map(function (item, index) {
	                  return _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      key: index,
	                      onClick: function onClick() {
	                        return _this3.changeQuestion(index + 1);
	                      },
	                      className: '' + (index + 1 === parseInt(_this3.props.params.questiono) ? 'active' : '')
	                    },
	                    index + 1
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper intro-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  this.props.params.questiono === '1' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().INTROTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().INTROPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTTOCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '2' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().WELCOMETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().WELCOMEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '3' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().USEMOUSETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_arrow.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().USEMOUSEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '4' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().NAVIGATTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_tab_btn.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-2' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '5' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TIMEREMAINTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARAONE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'time-left-img',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_time.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARATWO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '6' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().FLAGTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag_btn.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGBUTTON, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '7' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ANSWERMULTTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ANSWERMULTPARA, "div", "", { contentEditable: false })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'h6',
	                            null,
	                            _language2.default.LC().QUESMULTTITLE
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().A
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().ESTONIA
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().B
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().UKRAINE
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().C
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().BELGIUM
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '8' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().REVIEWTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              width: '38px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARACLOSE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'section-review',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_sidebar.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '9' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().HIGHLIGHTINGTEXT
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().HIGHLIGHTINGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'mw-100',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_highlight.png',
	                              alt: 'Highlight'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().PLEASENOTE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '10' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().STRIKINGOUTOPTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().STRIKINGOUTOPTIONSPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                _language2.default.LC().QUESMULTTITLE
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().A
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_a') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().ESTONIA
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().B
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_b') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().UKRAINE
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_c') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().BELGIUM
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '11' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ENDINGEXAMTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ENDINGEXAMPARA, "div", "", { contentEditable: false }),
	                          this.props.location.pathname.includes('cfa3') ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/questions/finish_page.png',
	                                alt: 'Mouse Arrow'
	                              })
	                            ),
	                            (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFOONFINISH, "div", "", { contentEditable: false })
	                          ) : null,
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '12' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TUTORIALCONCLUSIONTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TUTORIALCONCLUSIONPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().CLICKSTARTTEST
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getPrevious,
	                              className: 'pointer_class btn-primary',
	                              disabled: this.props.params.questiono === '1'
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getNext,
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.questiono) === 12
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                _this3.startTest();
	                              },
	                              className: 'pointer_class btn-primary'
	                            },
	                            startLoading ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : '',
	                            ' ',
	                            _language2.default.LC().START_TEST,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CFA2IntoductionInstruction;
	}(_react.Component);
	
	CFA2IntoductionInstruction.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFA2IntoductionInstruction;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBT2InstructionsNew = __webpack_require__(183);
	
	var _CBT2InstructionsNew2 = _interopRequireDefault(_CBT2InstructionsNew);
	
	var _reactstrap = __webpack_require__(6);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBT2MockExams = function (_Component) {
	  _inherits(CBT2MockExams, _Component);
	
	  function CBT2MockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBT2MockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBT2MockExams.__proto__ || Object.getPrototypeOf(CBT2MockExams)).call(this, props));
	
	    _this.checkSubscriptionPartner = function () {
	      var pathname = _this.props.location.pathname;
	
	      if (pathname.includes('/cfa3/')) return _Cfa3Subscription4.default.checkCfa3Subscription;
	      return _Cfa2Subscription4.default.checkCfa2Subscription;
	    };
	
	    _this.checkSubscriptionUser = function () {
	      var pathname = _this.props.location.pathname;
	
	      if (pathname.includes('/cfa3/')) return _Cfa3Subscription2.default.checkCfa3Subscription;
	      return _Cfa2Subscription2.default.checkCfa2Subscription;
	    };
	
	    _this.getQuestions = function (mock) {
	      _this.setState({
	        showInstructionModal: false
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context.next = 6;
	                        return _this.checkSubscriptionPartner(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          _this._runCode('paid', mock);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            // console.log('resp.profileInfo.---------------', resp.profileInfo);
	            _this.toggleAlert();
	            _this.setState({ subscriptionstatus: 'free' });
	            _this._runCode('free');
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _this.checkSubscriptionUser(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	                  _this._runCode('paid', mock);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus, mock) {
	      if (subscriptionstatus === 'paid') {
	        var frontendRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_CBT_INTRODUCTION;
	        var pathname = frontendRoute.replace(':id', mock.id).replace(':questiono', 1).replace(':timer', mock.timer);
	        _this.context.router.push({
	          pathname: pathname
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function (mock) {
	      _this.setState({
	        showInstructionModal: true,
	        mockData: mock
	      });
	    };
	
	    _this.viewAttemptedExams = function (mock) {
	      // ('/cfa2viewattemptedmock/:id/:timer');
	      var frontENDURL = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_VIEW_ATTEMPTED_MOCK : _AppRoutes2.default.CFA2_CBT_VIEW_ATTEMPTED_MOCK;
	
	      var path = frontENDURL.replace(':id', mock.id).replace(':timer', mock.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.openQPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	
	      var filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + filePath + '/MockQPdfDownload'), data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQ: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQ: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.openQAPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	      var filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + filePath + '/MockQAPdfDownload'), data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQA: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQA: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.checkSubscription = function (id, type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log('resp.profileInfo.userStatus', resp.profileInfo);
	
	                        _context2.next = 6;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          if (type === 'Q') {
	                            _this.setState({
	                              pdfLoadingQ: true
	                            });
	                            _this.openQPDF(id);
	                          } else {
	                            _this.setState({
	                              pdfLoadingQA: true
	                            });
	                            _this.openQAPDF(id);
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 12;
	                        break;
	
	                      case 11:
	                        console.log('fail');
	
	                      case 12:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _this.checkSubscriptionUser(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	
	                  if (type === 'Q') {
	                    _this.setState({
	                      pdfLoadingQ: true
	                    });
	                    _this.openQPDF(id);
	                  } else {
	                    _this.setState({
	                      pdfLoadingQA: true
	                    });
	                    _this.openQAPDF(id);
	                  }
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.toggle = function (index) {
	      _this.setState({
	        dropdownOpenIndex: index,
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      pdfLoadingQ: false,
	      pdfLoadingQA: false,
	      pdfMessage: '',
	      pdfMessageOpen: false,
	      dropdownOpen: false,
	      dropdownOpenIndex: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.togglePdfMessage = _this.togglePdfMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBT2MockExams, [{
	    key: 'togglePdfMessage',
	    value: function togglePdfMessage() {
	      this.setState({ pdfMessageOpen: !this.state.pdfMessageOpen });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var storage_session, data, filePath;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // console.log('I am on Frontendsrc\viewsCBTCFA2CBTNewMockListindex.js');
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                filePath = this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + filePath + '/getCFAMockExams'), data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.mock,
	                      isLoading: false,
	                      userStatsData: resp.userstats
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockData = _state.mockData,
	          dropdownOpen = _state.dropdownOpen,
	          dropdownOpenIndex = _state.dropdownOpenIndex;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().MOCK_LIST
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _language2.default.LC().MOCKEXAM
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(_loader2.default, null) : mockList.length ? mockList.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                item.mock_exam
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                  onClick: function onClick() {
	                                    return _this4.viewAttemptedExams(item);
	                                  }
	                                },
	                                _language2.default.LC().START
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'privetinfo-dropdown' },
	                                _react2.default.createElement(
	                                  _reactstrap.ButtonDropdown,
	                                  {
	                                    className: index + 1 === mockList.length ? 'dropup' : '',
	                                    isOpen: dropdownOpenIndex === index ? dropdownOpen : false,
	                                    toggle: function toggle() {
	                                      return _this4.toggle(index);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownToggle,
	                                    {
	                                      className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                      caret: true
	                                    },
	                                    _language2.default.LC().PRINT
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownMenu,
	                                    { right: true },
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'public',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item.id, 'Q');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_CASES_Q_MOCK
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'private',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item.id, 'QA');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_CASES_QA_MOCK
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '4', className: 'text-center py-4 px-2' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _language2.default.LC().No_Mock_Exams
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.pdfMessageOpen,
	            toggle: this.togglePdfMessage,
	            className: 'modal-primary custom_modalpro info-modal-designing'
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.togglePdfMessage, className: 'custom-title' },
	            'Information'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-info-view-for-plan' },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.pdfMessage
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btn-plan-view view-plan-wrap' },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { className: 'btn btn-primary', onClick: this.togglePdfMessage },
	                  'OK'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBT2InstructionsNew2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions(mockData);
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBT2MockExams;
	}(_react.Component);
	
	CBT2MockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBT2MockExams;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactstrap = __webpack_require__(6);
	
	__webpack_require__(80);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _constant = __webpack_require__(9);
	
	var _highlightText = __webpack_require__(56);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var longPressDuration = 450;
	var attemptedCaseArray = [];
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.caseOffset !== _this.props.params.caseOffset || prevProps.params.quesOffset !== _this.props.params.quesOffset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _this.getCases(data);
	        _this.getUserStats();
	        _this.getFlagQuestions();
	      }
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	              };
	
	              _this.getCases(data);
	              _this.getUserStats();
	              // this.getFlagQuestions();
	              if (_this.props.params.timerStart === 'true') {
	                _this.timer = setInterval(_this.countDown, 1000);
	              } else {
	                clearInterval(_this.timer);
	              }
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getMockNamebyId', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	              // getTotalQuestionsCount
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getTotalQuestionsCount', data).then(function (resp) {
	                if (resp.success) {
	                  // console.log('Success --------> ', resp);
	                  _this.setState({
	                    totalQuestionCount: resp.question
	                  });
	                } else {
	                  // console.log('falure --------> ', resp);
	                }
	              });
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getCases = function (data) {
	      _this.setState({
	        display_main_loader: 'show_block z-index-1000 bg-white',
	        vpCaseLoader: true,
	        questionLoader: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getCFAMockCases', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.question && resp.question.length) {
	            _this.getHighlightedText();
	            _this.getStrikedText();
	            _this.setState({
	              casesData: resp.question,
	              isLoading: false,
	              isDataLoading: false,
	              vpCaseLoader: false,
	              questionLoader: false,
	              display_main_loader: 'hide_block',
	              //selected case
	              selectedQuestionData: resp.question[_this.props.params.caseOffset],
	              //all questions of selected case
	              questionsData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_cbt_questions ? resp.question[_this.props.params.caseOffset].cfa2_cbt_questions : [],
	              //1st question of selected case
	              selectedCaseQuestionData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_cbt_questions && resp.question[_this.props.params.caseOffset].cfa2_cbt_questions[_this.props.params.quesOffset] ? resp.question[_this.props.params.caseOffset].cfa2_cbt_questions[_this.props.params.quesOffset] : []
	            });
	          }
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeCase = function (questionNumber, index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index + 1);
	      _this.getUserStats();
	      // this.getFlagQuestions();
	      _this.setState({
	        isLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      if (questionNumber) {
	        var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset)] && casesData[parseInt(_this.props.params.caseOffset)].cfa2_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset)].cfa2_cbt_questions[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', index).replace(':timerStart', _this.props.params.timerStart).replace(':isNegative', _this.props.params.isNegative).replace(':quesOffset', 0);
	        _this.context.router.push({
	          pathname: pathname
	        }, _this.getCases(data));
	      }
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	          attemptedCaseArray = resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      if (questionNumber) {
	        var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', questionNumber).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', index).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	      }
	    };
	
	    _this.getNextCase = function (index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index);
	      _this.setState({
	        isLoading: true
	      });
	      var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) + 1] && casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_cbt_questions[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousCase = function (index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index - 2);
	      _this.setState({
	        isLoading: true
	      });
	      var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) - 1] && casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_cbt_questions[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) - 1].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) - 1 : 1).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getNextQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) + 1].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) + 1 : 1).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/addHighlightedText', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context3.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context6.next = 7;
	                  break;
	                }
	
	                _context6.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/deleteHighlightedText', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context5.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context6.next = 8;
	                break;
	
	              case 7:
	                return _context6.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getHighlightedText', data).then(function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	          return _regenerator2.default.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  // console.log('highlights ---------> ', res.questions);
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this2);
	        }));
	
	        return function (_x6) {
	          return _ref7.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                //console.log('e. type ___________', e.type);
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  // console.log('Print params ---------> ', this.props.params);
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : null,
	                    caseno: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	                    caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : null
	                    // attemptedCases: JSON.stringify(attemptedCaseArray),
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7, _x8, _x9, _x10) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context10.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/addStrikeThrough', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            _context9.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x12) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x11) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      // console.log('userData --------------> ', userData);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUsersChoice', userData).then(function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee12$(_context12) {
	            while (1) {
	              switch (_context12.prev = _context12.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    // console.log('ansData -------------> ', ansData);
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserAnswer', ansData).then(function () {
	                      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	                        return _regenerator2.default.wrap(function _callee11$(_context11) {
	                          while (1) {
	                            switch (_context11.prev = _context11.next) {
	                              case 0:
	                              case 'end':
	                                return _context11.stop();
	                            }
	                          }
	                        }, _callee11, _this2);
	                      }));
	
	                      return function (_x14) {
	                        return _ref12.apply(this, arguments);
	                      };
	                    }());
	                  }
	
	                case 1:
	                case 'end':
	                  return _context12.stop();
	              }
	            }
	          }, _callee12, _this2);
	        }));
	
	        return function (_x13) {
	          return _ref11.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.submitTest = function () {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({
	        showFinishTestPopup: false
	      });
	      // console.log('I am here for you ----------->');
	
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserQuizStatus', data).then(function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	          return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	              switch (_context13.prev = _context13.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context13.stop();
	              }
	            }
	          }, _callee13, _this2);
	        }));
	
	        return function (_x15) {
	          return _ref13.apply(this, arguments);
	        };
	      }());
	
	      var ansdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        // console.log('I am here for you ----------->');
	        if (resp_count.success) {
	          var _data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	            score: resp_count.allrightanswercount.question_count,
	            id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserScore', _data);
	        } else {
	          //console.log(resp_count.success + '------------failure');
	        }
	      });
	      // /:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer
	      var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', 0).replace(':questiono', 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.flagQuestion = function (data) {
	      var flag = _this.state.flag;
	
	      var flaggedQuestions = flag.filter(function (flag) {
	        return flag.question_id === data.id;
	      })[0];
	      var flagdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: data.id,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      if (flaggedQuestions) {
	        (0, _toast.showSuccess)('Question Unflagged');
	      } else {
	        (0, _toast.showSuccess)('Question Flagged');
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/flagQuestion', flagdata).then(function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	          return _regenerator2.default.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  if (res) {
	                    _this.getFlagQuestions();
	                  }
	
	                case 1:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x16) {
	          return _ref14.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.updateAttemptedCases = function () {
	      // console.log('661 attempted cases -----------> ', attemptedCaseArray);
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        attemptedCases: JSON.stringify(attemptedCaseArray)
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateAttemptedCases', userData).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res.success) {
	                    attemptedCaseArray = res.attemptedCases != null ? JSON.parse(res.attemptedCases) : [];
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x17) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state = _this.state,
	          flag = _this$state.flag,
	          userStatsData = _this$state.userStatsData,
	          totalQuestionCount = _this$state.totalQuestionCount;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== totalQuestionCount) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	    };
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	
	      if (timerStart === 'true') {
	        _this.setState({
	          timerStart: 'false'
	        });
	        var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', _this.props.params.questiono).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset).replace(':timerStart', false).replace(':isNegative', _this.props.params.isNegative);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: 'true'
	        });
	
	        var _pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', _this.props.params.questiono).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset).replace(':timerStart', true).replace(':isNegative', _this.props.params.isNegative);
	
	        _this.context.router.push({
	          pathname: _pathname
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getStrikedText', data).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this2);
	        }));
	
	        return function (_x19) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      totalQuestionCount: 0
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        var pathname = _AppRoutes2.default.CFA2_CBT_QUESTIONS.replace(':id', this.props.params.id).replace(':caseno', this.props.params.caseno).replace(':questiono', this.props.params.questiono).replace(':timer', this.props.params.timer).replace(':testid', this.props.params.testid).replace(':caseOffset', this.props.params.caseOffset).replace(':quesOffset', this.props.params.quesOffset).replace(':isNegative', false).replace(':timerStart', this.props.params.timerStart);
	        this.context.router.push({
	          pathname: pathname
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.props.params.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateUserTimer', data).then(function () {
	        var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(res) {
	          return _regenerator2.default.wrap(function _callee18$(_context18) {
	            while (1) {
	              switch (_context18.prev = _context18.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context18.stop();
	              }
	            }
	          }, _callee18, _this3);
	        }));
	
	        return function (_x20) {
	          return _ref18.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedCaseQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var content = selectedCaseQuestionData ? selectedCaseQuestionData.question : null;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      var parseResult = Object.keys(userChoice).map(function (x) {
	        return parseInt(x, 10);
	      });
	      var count = 0;
	      parseResult.forEach(function (element) {
	        // console.log('element -----> ', element);
	        var attemptedCount = questionsData.filter(function (item) {
	          // console.log('iteme ----> ', item);
	          if (item.id === element) {
	            count++;
	            if (questionsData.length === count) {
	              if (attemptedCaseArray.indexOf(item.case_id) === -1) {
	                attemptedCaseArray.push(item.case_id);
	
	                _this4.updateAttemptedCases();
	              }
	            }
	          }
	          return item.id === element;
	        });
	      });
	      var caseAttempted = '';
	      if (questionsData.length === count) {
	        caseAttempted = 'bg-completed-cases';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            {
	              className: casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { onClick: function onClick() {
	                    return _this4.finishTest();
	                  }, className: 'pointer_class btn-primary' },
	                _language2.default.LC().Finish_Test
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this4.slider = slider;
	                      }
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeCase(item.id, index);
	                          },
	                          className: (attemptedCaseArray.indexOf(item.id) === -1 ? '' : 'bg-completed-cases ') + '\n                              ' + (index === parseInt(_this4.props.params.caseOffset) ? 'active button-trial' : 'button-trial')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: '' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header d-flex justify-content-between qus-header' },
	                    selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                      'div',
	                      { className: 'ques-wrapper all-ques' },
	                      (0, _function.renderHTMLContent)(selectedQuestionData.case_name, "h1", "text-center mb-2 text-capitalize"),
	                      (0, _function.renderHTMLContent)(selectedQuestionData.case, "div", "font-weight-normal", { contentEditable: false })
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text-right' },
	                      _react2.default.createElement('i', {
	                        className: this.props.params.caseOffset === '0' ? 'fa fa-angle-left ques_arrow pointer_class hide_block' : 'fa fa-angle-left ques_arrow pointer_class',
	                        onClick: function onClick() {
	                          return _this4.getPreviousCase(_this4.props.params.caseOffset);
	                        }
	                      }),
	                      _react2.default.createElement('i', {
	                        className: parseInt(this.props.params.caseOffset) === casesData.length - 1 ? 'fa fa-angle-right ques_arrow pointer_class hide_block' : 'fa fa-angle-right ques_arrow pointer_class',
	                        onClick: function onClick() {
	                          return _this4.getNextCase(_this4.props.params.caseOffset);
	                        }
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'qus-tab-wrapper' },
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0];
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                            ' + (index === parseInt(_this4.props.params.quesOffset) ? 'active' : '') + '\n                            ' + (userChoice[item.id] ? 'completed-qus' : '') + '\n                            ' + (flaggedQuestions ? 'flag-add' : '') + '\n                            '
	                        },
	                        index + 1,
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : ''
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ques-detail-wrapper col-md-12 question-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'main_loader ' + this.state.display_main_loader },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'loader-mid' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'card-block-loader' },
	                              _react2.default.createElement(_loader2.default, null)
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-8 col-lg-9' },
	                          selectedCaseQuestionData && selectedCaseQuestionData.question ? _react2.default.createElement(
	                            'div',
	                            { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                                className: 'margin_right_20',
	                                alt: '',
	                                width: '30'
	                              }),
	                              'Q.',
	                              parseInt(this.props.params.quesOffset) + 1
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                style: {
	                                  position: 'relative',
	                                  marginTop: '8px',
	                                  maxWidth: '100%'
	                                }
	                              },
	                              _react2.default.createElement(
	                                'div',
	                                { 'data-selectable': true },
	                                (0, _function.renderHTMLContent)(content, "div", "qus-title d-inline-block w-100")
	                              ),
	                              _react2.default.createElement(
	                                _reactSelectionPopover2.default,
	                                {
	                                  showPopover: this.state.showPopover,
	                                  onSelect: function onSelect() {
	                                    _this4.setState({
	                                      showPopover: true
	                                    });
	                                  },
	                                  onDeselect: function onDeselect() {
	                                    _this4.setState({
	                                      showPopover: false
	                                    });
	                                  }
	                                },
	                                getHighlightedText === -1 ? _react2.default.createElement(
	                                  'div',
	                                  { className: 'highlight-popover tooltip_wrap' },
	                                  _react2.default.createElement('img', {
	                                    src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	                                    alt: '523',
	                                    width: '30',
	                                    onClick: function onClick() {
	                                      return _this4.addHighlightToText();
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'tootip_box' },
	                                    _language2.default.LC().Click_me_to_highlight
	                                  )
	                                ) : _react2.default.createElement(
	                                  'div',
	                                  { className: 'highlight-popover tooltip_wrap' },
	                                  _react2.default.createElement('img', {
	                                    src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	                                    alt: '523',
	                                    width: '30',
	                                    onClick: function onClick() {
	                                      return _this4.deleteHighlightFromText();
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'tootip_box' },
	                                    _language2.default.LC().Click_me_to_unhighlight
	                                  )
	                                )
	                              )
	                            )
	                          ) : null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _constant.optionsArr.map(function (item, index) {
	                              return _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'col-sm-12',
	                                  id: item,
	                                  key: index,
	                                  onClick: function onClick(e) {
	                                    _this4.clickOption(item, selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    _this4.clickOption(item, selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	                                  },
	                                  onTouchStart: function onTouchStart(e) {
	                                    _this4.onTouchStart(e, item);
	                                  },
	                                  onTouchCancel: function onTouchCancel(e) {
	                                    _this4.onTouchCancel(e);
	                                  },
	                                  onTouchEnd: function onTouchEnd(e) {
	                                    _this4.onTouchEnd(e);
	                                  },
	                                  onTouchMove: function onTouchMove(e) {
	                                    _this4.onTouchMove(e);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'answer_box ' + (userChoice[selectedCaseQuestionData.id] === item ? 'border-yellow' : 'border-black')
	                                  },
	                                  _react2.default.createElement(
	                                    'div',
	                                    {
	                                      className: 'answer_count highlight_choice no-selection ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	                                    },
	                                    item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    {
	                                      className: 'ans_box_text tooltip_wrap ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	                                    },
	                                    selectedCaseQuestionData && selectedCaseQuestionData[item] ? (0, _function.renderHTMLContent)(selectedCaseQuestionData[item], "span", "no-selection", { contentEditable: false }) : null
	                                  )
	                                )
	                              );
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-4 col-lg-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'timer_outer mb-15' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'h2',
	                                { className: 'time-left-heading' },
	                                _language2.default.LC().TIME_LEFT
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'timer_box ' + (this.props.params.isNegative === 'false' ? 'blink' : null)
	                                },
	                                this.props.params.isNegative === 'false' ? '- ' + formatTimeF : formatTimeF
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              'aria-label': timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer',
	                              className: 'tooltip_wrap mb-2 hover-pad-same\n                                ' + (timerStart === 'true' ? 'icon-control-pause pause_btn' : 'pause_btn icon-control-play'),
	                              onClick: function onClick() {
	                                return _this4.stopTimer();
	                              }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box', 'aria-hidden': 'true' },
	                              _language2.default.LC().Save_and_Take_Break
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              'aria-label': _language2.default.LC().SECTION_REVIEW,
	                              className: 'menu-btn tooltip-hover-questions',
	                              onClick: function onClick() {
	                                _this4.setState({
	                                  showSectionReview: true
	                                });
	                              }
	                            },
	                            _react2.default.createElement('img', {
	                              width: '30px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              className: 'my-1',
	                              alt: ''
	                            }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box', 'aria-hidden': 'true' },
	                              _language2.default.LC().SECTION_REVIEW
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-9 mt-1' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'text-center text-sm-right btm-btn-wrapper quiz-submit-block' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'up tooltip-hover-questions quiz-flag' },
	                              flaggedQuestion ? _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box' },
	                                _language2.default.LC().UNFLAG_THIS_QUESTION
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box' },
	                                _language2.default.LC().FLAG_THIS_QUESTION
	                              ),
	                              _react2.default.createElement(
	                                'i',
	                                {
	                                  onClick: function onClick() {
	                                    return _this4.flagQuestion(selectedCaseQuestionData);
	                                  },
	                                  className: flaggedQuestion ? 'fa fa-flag mark-action-btn' : 'fa fa-flag-o mark-action-btn'
	                                },
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getPreviousQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === 0
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                              ' ',
	                              _language2.default.LC().BACK
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getNextQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                              },
	                              _language2.default.LC().NEXT,
	                              ' ',
	                              _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png', alt: '' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _language2.default.LC().SECTION_REVIEW
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                'aria-label': 'Close section review',
	                className: 'section-review-close',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().FILTER_BY,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'filt-list-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: function onClick() {
	                    _this4.setState({
	                      filter: []
	                    });
	                  }
	                },
	                _language2.default.LC().CLEAR
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _constant.filterObj.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'plan_wrapper remove-plan', key: index },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        value: item,
	                        id: item,
	                        checked: filter.indexOf(item) > -1 ? true : false,
	                        onChange: function onChange(e) {
	                          return _this4.changeFilter(e, item);
	                        }
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' }),
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qus-tab-wrapper' },
	              questionsData.map(function (item, index) {
	                var flaggedQuestions = flag.filter(function (flag) {
	                  return flag.question_id === item.id;
	                })[0];
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  filter.includes('Attempted') && filter.includes('Unattempted') && filter.includes('Flagged') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : filter.includes('Attempted') && filter.includes('Unattempted') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'completed-qus' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : filter.includes('Unattempted') && filter.includes('Flagged') ? !userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : ///
	                  filter.includes('Attempted') && filter.includes('Flagged') ? userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : filter.includes('Attempted') ? userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'completed-qus',
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Unattempted') ? !userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Flagged') ? flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    })
	                  ) : '' : _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _constant = __webpack_require__(9);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CFA2CBTResult = function (_Component) {
	  _inherits(CFA2CBTResult, _Component);
	
	  //
	  function CFA2CBTResult(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA2CBTResult);
	
	    var _this = _possibleConstructorReturn(this, (CFA2CBTResult.__proto__ || Object.getPrototypeOf(CFA2CBTResult)).call(this, props));
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.getGraphoverAllGraphData = function (data) {
	      var fileName = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + fileName + '/getCBTMockUserGraph'), data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.graphData) {
	                    _this.setState({
	                      isLoading: false,
	                      totalQuestions: _this.props.params.totalQuestions,
	                      average: res.graphData ? res.graphData.averageScore : _this.state.average
	                    });
	                    _this.formatoverAllGraphData(res);
	                  } else {
	                    _this.setState({
	                      isLoading: false
	                    });
	                    (0, _toast.showFailure)(res.message);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getGraphData = function (data) {
	      var fileName = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + fileName + '/getCBTMockUserGraphChapterWise'), data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (res.graphData.length > 6) {
	                    _this.setState({
	                      labelAngle: -90
	                    });
	                  }
	                  _this.setState({
	                    isLoading: false,
	                    totalQuestionsChapterwise: _this.props.params.totalQuestions,
	                    exam_name: res.graphData,
	                    averageoverAll: res.graphData
	                  });
	                  _this.formatData(res);
	
	                case 3:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatoverAllGraphData = function (res) {
	      var graphData = res.graphData;
	
	
	      _this.setState({
	        dataOfCurrentUser: graphData ? graphData.dataOfCurrentUser.score : _this.state.dataOfCurrentUser,
	        dataOfEightyPercentileUser: graphData ? graphData.dataOfEightyPercentileUser.score : _this.state.dataOfEightyPercentileUser,
	        dataOfTwentyPercentileUser: graphData ? graphData.dataOfTwentyPercentileUser.score : _this.state.dataOfTwentyPercentileUser
	      });
	      var totalQuestions = _this.state.totalQuestions;
	
	      var temp = [graphData];
	      graphData = temp;
	
	      // Reference line for 70%
	      var referenceLine = {
	        type: 'line',
	        color: '#fff',
	        dataPoints: [{
	          x: -15,
	
	          y: 100
	        }, {
	          x: 20,
	
	          y: 100
	        }, {
	          x: 20,
	
	          y: 100
	        }],
	        markerType: 'none'
	      };
	      // 20% line
	      var dataOfTwentyOverAllGraph = {
	        showInLegend: false,
	        name: '20%',
	
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line
	      var dataOfEightyOverAllGraph = {
	        showInLegend: false,
	
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //User score line
	      var UserScoreOverAllGraph = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User score box
	
	      var scorePercentage = graphData[0].dataOfCurrentUser.score == null ? 0 : Math.ceil(graphData[0].dataOfCurrentUser.score / totalQuestions * 100);
	
	      var UserScoreBoxOverAllGraph2 = {
	        type: 'rangeColumn',
	
	        color: 'hsl(200deg 67% 88%)',
	        dataPoints: []
	      };
	
	      UserScoreBoxOverAllGraph2.dataPoints.push({
	        x: 1.39,
	
	        y: [scorePercentage - 5, scorePercentage + 5]
	      });
	
	      var dataOfCurrentUserLineStart = {
	        x: -0.2,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineMid = {
	        x: 2.8,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineEnd = {
	        x: 2.8,
	        y: null
	      };
	
	      UserScoreOverAllGraph.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	
	      var dataOfTwentyPercentileUserlineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfTwentyPercentileUserlineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfTwentyPercentileUserlineEnd = {
	        x: 7,
	        y: null
	      };
	      dataOfTwentyOverAllGraph.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	      var dataOfEightyPercentileUserLineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfEightyPercentileUserLineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	      };
	
	      var dataOfEightyPercentileUserLineEnd = {
	        x: 7,
	        y: null
	      };
	      dataOfEightyOverAllGraph.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	      var overAllGraphData = [];
	      overAllGraphData.push(UserScoreBoxOverAllGraph2, dataOfTwentyOverAllGraph, dataOfEightyOverAllGraph, UserScoreOverAllGraph, referenceLine);
	
	      _this.setState({
	        dataPointsOverAllGraph: overAllGraphData
	      }, function () {
	        _this.showGraphOverAll(); //Show overall graph
	      });
	    };
	
	    _this.showGraphOverAll = function () {
	      var dataPointsOverAllGraph = _this.state.dataPointsOverAllGraph;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: _constant.canvasjsConfig.axisX,
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        dataPointWidth: 90,
	        dataPointMaxWidth: 80,
	        dataPointMinWidth: 80,
	        legend: {
	          fontSize: 18
	        },
	        data: dataPointsOverAllGraph,
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.formatData = function (res) {
	      // console.log('res ------> ', res);
	      var graphData = res.graphData;
	
	
	      var initialValue = 0;
	      // Reference line for 70%
	      var referenceLine = {
	        type: 'line',
	        color: '#fff',
	        dataPoints: [{
	          x: 0,
	
	          y: 110
	        }, {
	          x: 20,
	
	          y: 110
	        }, {
	          x: 20,
	
	          y: 110
	        }],
	        markerType: 'none'
	      };
	      //20% line chaptervise graph
	      var dataOfTwenty = {
	        showInLegend: false,
	
	        name: '20%',
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line chaptervise graph
	      var dataOfEighty = {
	        showInLegend: false,
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //Userscore line chaptervise graph
	      var UserScore = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User Score Box chaptervise graph
	      // let UserScoreBox = {
	      //   type: 'rangeColumn',
	      //   color: '#cce7f5',
	      //   dataPoints: [],
	      // };
	      // initialValue = -10;
	      // for (let k = 0; k < graphData.length; k++) {
	      //   UserScoreBox.dataPoints.push({
	      //     x: initialValue + 15,
	
	      //     y: [
	      //       graphData[k].dataOfCurrentUser.Percentage - 10,
	      //       graphData[k].dataOfCurrentUser.Percentage + 10,
	      //     ],
	      //   });
	      //   initialValue += 15;
	      // }
	      var UserScoreBox2 = {
	        showInLegend: false,
	        // legendMarkerType: 'square',
	        name: '' + _language2.default.LC().GRAPHSCOREBOX,
	        type: 'rangeColumn',
	        color: '#cce7f5',
	        dataPoints: []
	      };
	      initialValue = -10;
	      // console.log('graphData -------------> ', graphData);
	      var graphDataLength = graphData && graphData.length ? graphData.length : 0;
	      for (var k = 0; k < graphDataLength; k++) {
	        var scoreBoxSize = _this.state.scoreBoxSize;
	
	        UserScoreBox2.dataPoints.push({
	          x: initialValue + 15,
	          label: '' + graphData[k].chapterDetails['cfa2_chapter.chapter_name'],
	          y: [graphData[k].dataOfCurrentUser.Percentage - scoreBoxSize, graphData[k].dataOfCurrentUser.Percentage + scoreBoxSize]
	        });
	        var dataOfCurrentUserLineStart = {
	          x: initialValue + 15 - 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineMid = {
	          x: initialValue + 15 + 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineEnd = {
	          x: initialValue + 15 + 1.5,
	          y: null
	        };
	        UserScore.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	        initialValue += 15;
	      }
	      initialValue = 0;
	      for (var i = 0; i < graphDataLength; i++) {
	        var dataOfTwentyPercentileUserlineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineEnd = {
	          x: initialValue + 10,
	
	          y: null
	        };
	        dataOfTwenty.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	        var dataOfEightyPercentileUserLineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineEnd = {
	          x: initialValue + 10,
	          y: null
	        };
	        dataOfEighty.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	
	        initialValue += 15;
	      }
	      var data = [];
	      data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, referenceLine);
	
	      _this.setState({
	        dataPoints: data
	      }, function () {
	        _this.showGraph(); //Show chaptervise graph
	      });
	    };
	
	    _this.showGraph = function () {
	      var dataPoints = _this.state.dataPoints;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainer', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: Object.assign({}, _constant.canvasjsConfig.axisX, {
	          labelAngle: _this.state.labelAngle,
	          labelFontSize: _this.state.labelFontSize
	        }),
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        data: dataPoints,
	
	        dataPointMaxWidth: 60,
	        dataPointWidth: 60,
	        dataPointMinWidth: 60,
	        legend: {
	          fontSize: 18
	        },
	        interactivityEnabled: false
	      });
	
	      chart.render();
	    };
	
	    _this.state = {
	      token: '',
	      idname: '',
	      activeTabFlashcards: 1,
	      dataPointsOverAllGraph: [],
	      dataPoints: [],
	      totalQuestions: 0,
	      isLoading: true,
	      labelAngle: 0,
	      labelFontSize: 15,
	      scoreBoxSize: 5,
	      exam_name: '',
	      totalQuestionsChapterwise: 0,
	      dataOfCurrentUser: '',
	      dataOfEightyPercentileUser: '',
	      dataOfTwentyPercentileUser: '',
	      average: ''
	    };
	    return _this;
	  }
	
	  _createClass(CFA2CBTResult, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var w = window.innerWidth;
	      // const h = window.innerHeight;
	      if (w > 1200) {
	        this.setState({
	          labelAngle: 0,
	          labelFontSize: 15
	        });
	      } else if (w > 991 && w < 1200) {
	        this.setState({
	          labelAngle: -20,
	          labelFontSize: 12
	        });
	      } else if (w > 767 && w < 991) {
	        this.setState({
	          labelAngle: 90,
	          labelFontSize: 15
	        });
	      } else {
	        this.setState({
	          labelAngle: -90,
	          labelFontSize: 12
	        });
	      }
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        // eslint-disable-next-line
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        test_id: this.props.params.test_id // eslint-disable-next-line
	        ? parseInt(this.props.params.test_id) : null,
	        totalQuestion: this.props.params.totalQuestions // eslint-disable-next-line
	        ? parseInt(this.props.params.totalQuestions) : null,
	        // eslint-disable-next-line
	        timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
	        isNegative: this.props.params.isNegative
	      };
	
	      this.getGraphData(data);
	      this.getGraphoverAllGraphData(data);
	    }
	    // get data for overall graph
	    // myResize = () => {
	
	    //   }
	
	    // get data for chaptervise graph
	
	    //format data as requirement for overall graph
	
	    //Show overall graph
	
	    //Format data as requirement
	
	
	    // show graph chaptervise graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          dataOfCurrentUser = _state.dataOfCurrentUser,
	          dataOfEightyPercentileUser = _state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser = _state.dataOfTwentyPercentileUser,
	          totalQuestions = _state.totalQuestions,
	          activeTabFlashcards = _state.activeTabFlashcards,
	          average = _state.average,
	          exam_name = _state.exam_name;
	      var isLoading = this.state.isLoading;
	
	
	      return !isLoading ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'chart-graph-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().OVERALLRESULT
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              ' ',
	              _react2.default.createElement('div', { id: 'chartContainerOverAllGraph', className: 'js-chart-wrap' }),
	              _react2.default.createElement(
	                'ul',
	                { className: 'legend-wrapper' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'square-box' }),
	                  ' ',
	                  _language2.default.LC().SCOREBOX
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dash' }),
	                  ' ',
	                  _language2.default.LC().Percentile_20
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dots' }),
	                  ' ',
	                  _language2.default.LC().Percentile_80
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-normal' }),
	                  ' ',
	                  _language2.default.LC().YOURSCORE
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              _react2.default.createElement(
	                'div',
	                { className: ' graphData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfTwentyPercentileUser ? Math.ceil(dataOfTwentyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_20
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfEightyPercentileUser ? Math.ceil(dataOfEightyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_80
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(dataOfCurrentUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'score-box' }),
	                    ' ',
	                    '' + _language2.default.LC().YOURSCORE
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(average / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'average-box' }),
	                    ' ',
	                    _language2.default.LC().AVERAGE_SCORE
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: ' chart-graph-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().CFACHAPTERWISERESULT
	          ),
	          _react2.default.createElement('div', { id: 'chartContainer', className: 'js-chart-wrap' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'legend-wrapper' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'square-box' }),
	              ' ',
	              _language2.default.LC().SCOREBOX
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dash' }),
	              ' ',
	              _language2.default.LC().Percentile_20
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dots' }),
	              ' ',
	              _language2.default.LC().Percentile_80
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-normal' }),
	              _language2.default.LC().YOURSCORE
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-5' },
	            'Mean Score by Topic Area'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex header-card-dashboard tab-header-wrap mt-2' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'dashboard-card-header-tab' },
	              exam_name ? exam_name.map(function (exam, index) {
	                // console.log('exam --------------> ', exam, index);
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    onClick: function onClick() {
	                      _this3.flashcardTabToggle(index + 1);
	                    },
	                    className: activeTabFlashcards === index + 1 ? 'active' : ''
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    exam.chapterDetails['cfa2_chapter.chapter_name'] && exam.chapterDetails['cfa2_chapter.chapter_name'].length > 8 ? exam.chapterDetails['cfa2_chapter.chapter_name'].substring(0, 8) + '..' : exam.chapterDetails['cfa2_chapter.chapter_name']
	                  )
	                );
	              }) : null
	            )
	          ),
	          exam_name ? exam_name.map(function (exam, index) {
	            var x = void 0;
	
	            x = _this3.state.activeTabFlashcards === index + 1 ? _react2.default.createElement(
	              'div',
	              { className: 'card tab-body-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block dashboard-cards-scroll my-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'chart-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' graphData' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfTwentyPercentileUser ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_20
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfEightyPercentileUser ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_80
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfCurrentUser ? Math.ceil(exam.dataOfCurrentUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'score-box' }),
	                        ' ',
	                        '' + _language2.default.LC().YOURSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam && exam.chapterDetails && exam.chapterDetails.totalQuestions ? Math.ceil(exam.averageScore / exam.chapterDetails.totalQuestions * 100) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'average-box' }),
	                        ' ',
	                        _language2.default.LC().AVERAGE_SCORE
	                      )
	                    )
	                  )
	                )
	              )
	            ) : null;
	
	            return x;
	          }) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-2 text-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().DataDetail
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { id: 'chartContainer' },
	        _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return CFA2CBTResult;
	}(_react.Component);
	
	exports.default = CFA2CBTResult;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _constant = __webpack_require__(9);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBTMockExams = function (_Component) {
	  _inherits(CBTMockExams, _Component);
	
	  function CBTMockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTMockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExams.__proto__ || Object.getPrototypeOf(CBTMockExams)).call(this, props));
	
	    _this.getQuestions = function () {
	      _this.setState({
	        showInstructionModal: false,
	        isLoading: true
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, mockPackageAccess, isInArray_var, partnerSubscriptionCheck;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 13;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        mockPackageAccess = resp_exam.hasMockSubscription;
	                        isInArray_var = false;
	                        partnerSubscriptionCheck = _Cfa2Subscription4.default.checkCfa2Subscription;
	
	                        if (_this.props.location.pathname.includes('/cfa3/')) {
	                          partnerSubscriptionCheck = _Cfa3Subscription4.default.checkCfa3Subscription;
	                          selectedmen = 'cfa_3';
	                        }
	                        _context.next = 9;
	                        return partnerSubscriptionCheck(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 9:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var || mockPackageAccess) {
	                          _this._runCode('paid');
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 14;
	                        break;
	
	                      case 13:
	                        console.log('fail');
	
	                      case 14:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	            _this.setState({ subscriptionstatus: 'free' });
	            _this._runCode('free');
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                var subscriptionCheck = _Cfa2Subscription2.default.checkCfa2Subscription;
	                if (_this.props.location.pathname.includes('/cfa3/')) {
	                  subscriptionCheck = _Cfa3Subscription2.default.checkCfa3Subscription;
	                  selectedmen = 'cfa_3';
	                }
	                console.log('subscriptionCheck', subscriptionCheck);
	                isInArray_var = subscriptionCheck(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus) {
	      var timer = _this.state.timer,
	          id = _this.props.params.id;
	
	      if (subscriptionstatus === 'paid') {
	        var path = _this.introductionRoute.replace(':id', id).replace(':questiono', 1).replace(':timer', timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function () {
	      _this.setState({
	        showInstructionModal: true
	        // mockData: mock,
	      });
	    };
	
	    _this.backToMock = function () {
	      _this.context.router.push({
	        pathname: _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT : _AppRoutes2.default.CFA2_CBT
	      });
	    };
	
	    _this.deleteTest = function (id) {
	      var deletepopup = _this.state.deletepopup;
	
	      if (!deletepopup) {
	        _this.setState({
	          deleteId: id,
	          deletepopup: true
	        });
	      } else {
	        _this.setState({
	          deleteId: '',
	          deletepopup: false
	        });
	      }
	    };
	
	    _this.view = function (item) {
	      var viewRoute = _this.finishRoute;
	      if (item.status === 'non-graded') viewRoute = _AppRoutes2.default.CFA3_CBT_GRADE_QUESTIONS;
	      var timer = _this.state.timer,
	          id = _this.props.params.id;
	
	      var path = viewRoute.replace(':id', id).replace(':caseno', 1).replace(':questiono', 1).replace(':testid', item.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', timer);
	
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.deleteToggleDone = function () {
	      var deleteId = _this.state.deleteId;
	
	      var deleteData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: deleteId
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/deleteMock'), deleteData).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var data;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this.setState({
	                    deleteId: '',
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
	                    deletepopup: false
	                  });
	
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : ''
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getAllUsersStats'), data).then(function (resp) {
	                    if (resp.success) {
	                      _this.setState({
	                        ValidToken: true,
	                        mockList: resp.data,
	                        isLoading: false
	                        // userStatsData: resp.data,
	                      });
	                    } else {
	                      _this.setState({ ValidToken: false, isLoading: false });
	                    }
	                    return resp;
	                  });
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getMockNamebyId'), data).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              _this.setState({
	                                mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                              });
	
	                            case 1:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	
	                case 4:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.startTest = function () {
	      _this.setState({
	        startLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        status: 'pending'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getCFAMockCases'), data).then(function (caseResp) {
	        if (caseResp.success) {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getCFAMockQuestions'), data).then(function (resp) {
	            if (resp.success) {
	              _this.setState({
	                startLoading: true
	              });
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/addUsersChoice'), userData).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                  var timer, id, path;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (res.success) {
	                            timer = _this.state.timer, id = _this.props.params.id;
	                            path = _this.questionRoute.replace(':id', id).replace(':caseno', caseResp.question && caseResp.question.length ? caseResp.question[0].id : 1).replace(':questiono', resp.question && resp.question.length ? resp.question[0].id : 1).replace(':timer', timer).replace(':testid', res.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	
	                            _this.context.router.push({
	                              pathname: path
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	            }
	          });
	        }
	      });
	    };
	
	    _this.resumeTest = function (item) {
	      if (item.questions) {
	        var questionsData = JSON.parse(item.lastAnswered);
	        if (questionsData) {
	          var timer = _this.state.timer;
	
	          var path = _this.questionRoute.replace(':id', item.mock_id).replace(':caseno', questionsData.caseno).replace(':questiono', questionsData.questionId).replace(':timer', timer).replace(':testid', item.id).replace(':caseOffset', questionsData.caseOffset).replace(':quesOffset', questionsData.offset).replace(':isNegative', item.isNegative).replace(':timerStart', true);
	          _this.context.router.push({
	            pathname: path
	          });
	        }
	      } else {
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getCFAMockCases'), data).then(function (resp) {
	          if (resp.success) {
	            var _timer = _this.state.timer;
	
	            var _path = _this.questionRoute.replace(':id', item.mock_id).replace(':caseno', 1).replace(':questiono', 1).replace(':timer', _timer).replace(':testid', item.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	            _this.context.router.push({
	              pathname: _path
	            });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      mockName: '',
	      deletepopup: false,
	      deleteId: '',
	      totalQuestionCount: 1,
	      timer: _this.props.params.timer === 'undefined' ? 8100 : _this.props.params.timer
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.introductionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_CBT_INTRODUCTION;
	    _this.filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	    _this.questionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS : _AppRoutes2.default.CFA2_CBT_QUESTIONS;
	    _this.finishRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS_FINISH : _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH;
	    return _this;
	  }
	
	  _createClass(CBTMockExams, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        isLoading: false,
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	    //check CFA2 subscription
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                // console.log(
	                //   'I am on Frontendsrc\viewsCBTCFA2CBTNewViewAttemptedMocksindex.js'
	                // );
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname']
	                });
	                this.setState({
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: this.props.params.id ? parseInt(this.props.params.id) : ''
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + this.filePath + '/getAllUsersStats'), data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.data,
	                      isLoading: false
	                    });
	                  } else {
	                    _this3.setState({
	                      ValidToken: false,
	                      isLoading: false
	                    });
	                  }
	                  return resp;
	                });
	
	                // getTotalQuestionsCount
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + this.filePath + '/getTotalQuestionsCount'), data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      totalQuestionCount: resp.question
	                    });
	                  } else {
	                    // console.log('falure --------> ', resp);
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + this.filePath + '/getMockNamebyId'), data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this3.setState({
	                              mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                            });
	
	                          case 1:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this3);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockName = _state.mockName,
	          deletepopup = _state.deletepopup,
	          totalQuestionCount = _state.totalQuestionCount,
	          timer = _state.timer;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper rem-left-pad' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'two-btn-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.startExam();
	                  }
	                },
	                _language2.default.LC().START
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                _language2.default.LC().CHANGE_MOCK
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: deletepopup, toggle: this.deleteTest, className: 'modal-primary' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteTest },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table table-remove-space' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '9%' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().DATE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TEST_COMPLETED_IN
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().STATUS
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList.length ? mockList.map(function (item, index) {
	                          var time = 0;
	                          console.log('timer', timer);
	                          if (item.isNegative === 'true') {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(timer) - item.user_time_value);
	                          } else {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(timer) + item.user_time_value);
	                          }
	                          console.log('time', time);
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'score-qnt' },
	                              item.score ? Math.ceil(item.score / totalQuestionCount * 100) + '%' : '0%'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.createdAt ? (0, _moment2.default)(item.createdAt).format('ll') : ''
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'clr-green' },
	                              time
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize mock-status' },
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                _language2.default.LC().Incomplete
	                              ) : item.status === 'non-graded' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                'Non Graded'
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status' },
	                                item.status
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              item.status === 'completed' || item.status === 'non-graded' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: {
	                                    padding: '0 6px 4px'
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().VIEW,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      return _this4.view(item);
	                                    },
	                                    className: 'fa fa-eye mark-action-btn-dashboard',
	                                    style: {
	                                      color: '#1f8ceb'
	                                    }
	                                  },
	                                  ' '
	                                )
	                              ) : null,
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: {
	                                    padding: '0 6px 4px'
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().RESUME
	                                ),
	                                _react2.default.createElement('i', {
	                                  className: 'fa fa-play-circle-o mark-action-btn-dashboard',
	                                  'aria-hidden': 'true',
	                                  style: {
	                                    color: '#000'
	                                  },
	                                  onClick: function onClick() {
	                                    _this4.resumeTest(item);
	                                  }
	                                })
	                              ) : null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: {
	                                    padding: '0 6px 4px'
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().DELETE,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      _this4.deleteTest(item.id);
	                                    },
	                                    className: 'fa fa-trash mark-action-btn-dashboard',
	                                    style: {
	                                      color: '#f51a00'
	                                    }
	                                  },
	                                  ' '
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '6', className: 'no-mocks' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '82px',
	                                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                { className: 'mt-1' },
	                                _language2.default.LC().NO_MOCK_EXAM_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBTMockExams;
	}(_react.Component);
	
	CBTMockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBTMockExams;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	__webpack_require__(80);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _highlightText = __webpack_require__(56);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var attemptedCaseArray = [];
	/* eslint-disable*/
	var longPressDuration = 450;
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.caseOffset !== _this.props.params.caseOffset || prevProps.params.quesOffset !== _this.props.params.quesOffset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _this.getCases(data);
	        _this.getUserStats();
	        _this.getFlagQuestions();
	      }
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getflaggedQuestions', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	              };
	
	              _this.getCases(data);
	              _this.getUserStats();
	              _this.getrightanswer();
	              // this.getFlagQuestions();
	              if (_this.props.params.timerStart === 'true') {
	                _this.timer = setInterval(_this.countDown, 1000);
	              } else {
	                clearInterval(_this.timer);
	              }
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getMockNamebyId', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 9:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getDetailedResultGraph = function (totalQuestion) {
	      var _this$props$params = _this.props.params,
	          id = _this$props$params.id,
	          testid = _this$props$params.testid,
	          timer = _this$props$params.timer;
	
	      var path = _AppRoutes2.default.CFA2_2027_DETAILED_RESULT_GRAPH.replace(':id', id).replace(':test_id', testid).replace(':totalQuestions', totalQuestion).replace(':timer', timer).replace(':isNegative', _this.state.isNegative);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getCases = function (data) {
	      _this.setState({
	        display_main_loader: 'show_block z-index-1000 bg-white',
	        vpCaseLoader: true,
	        questionLoader: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getCFAMockCases', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.question && resp.question.length) {
	            _this.setState({
	              casesData: resp.question,
	              isLoading: false,
	              isDataLoading: false,
	              vpCaseLoader: false,
	              questionLoader: false,
	              display_main_loader: 'hide_block',
	              //selected case
	              selectedQuestionData: resp.question[_this.props.params.caseOffset],
	              //all questions of selected case
	              questionsData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions ? resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions : [],
	              //1st question of selected case
	              selectedCaseQuestionData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions && resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions[_this.props.params.quesOffset] ? resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions[_this.props.params.quesOffset] : []
	            });
	          }
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	
	      // getTotalQuestionsCount
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getTotalQuestionsCount', data).then(function (resp) {
	        if (resp.success) {
	          // console.log('Success --------> ', resp);
	          _this.setState({
	            totalQuestionCount: resp.question
	          });
	        } else {
	          // console.log('falure --------> ', resp);
	        }
	      });
	    };
	
	    _this.changeCase = function (questionNumber, index) {
	      var casesData = _this.state.casesData;
	
	      _this.getUserStats();
	      // this.getFlagQuestions();
	      _this.setState({
	        isLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      if (questionNumber) {
	        //  '/cfa2cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer'
	        var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset)] && casesData[parseInt(_this.props.params.caseOffset)].cfa2_2027_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset)].cfa2_2027_cbt_questions[0].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', index).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        }, _this.getCases(data));
	      }
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	
	          attemptedCaseArray = resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	      _this.getUserStats();
	      if (questionNumber) {
	        // /cfa2cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset
	
	        var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', questionNumber).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', index).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.getNextCase = function () {
	      var casesData = _this.state.casesData;
	
	      _this.setState({
	        isLoading: true
	      });
	      _this.slider.slickGoTo(3);
	
	      var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) + 1] && casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_2027_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_2027_cbt_questions[0].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getPreviousCase = function () {
	      var casesData = _this.state.casesData;
	
	      _this.setState({
	        isLoading: true
	      });
	      _this.slider.slickGoTo(3 - 2);
	
	      var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) - 1] && casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_2027_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_2027_cbt_questions[0].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getPreviousQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	
	      var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) - 1].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) - 1 : 1).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getNextQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	
	      var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) + 1].id : 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) + 1 : 1).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context5.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/addHighlightedText', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context4.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x4) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context7.next = 7;
	                  break;
	                }
	
	                _context7.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/deleteHighlightedText', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(res) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context6.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context7.next = 8;
	                break;
	
	              case 7:
	                return _context7.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getHighlightedText', data).then(function () {
	        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(res) {
	          return _regenerator2.default.wrap(function _callee8$(_context8) {
	            while (1) {
	              switch (_context8.prev = _context8.next) {
	                case 0:
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context8.stop();
	              }
	            }
	          }, _callee8, _this2);
	        }));
	
	        return function (_x7) {
	          return _ref8.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                //console.log('e. type ___________', e.type);
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  // console.log('Print params ---------> ', this.props.params);
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : null,
	                    caseno: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	                    caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : null
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x8, _x9, _x10, _x11) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context11.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/addStrikeThrough', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(res) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            _context10.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this2);
	                  }));
	
	                  return function (_x13) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this2);
	      }));
	
	      return function (_x12) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      // console.log('userData --------------> ', userData);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUsersChoice', userData).then(function () {
	        var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	              switch (_context13.prev = _context13.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserAnswer', ansData).then(function () {
	                      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(res) {
	                        return _regenerator2.default.wrap(function _callee12$(_context12) {
	                          while (1) {
	                            switch (_context12.prev = _context12.next) {
	                              case 0:
	                              case 'end':
	                                return _context12.stop();
	                            }
	                          }
	                        }, _callee12, _this2);
	                      }));
	
	                      return function (_x15) {
	                        return _ref13.apply(this, arguments);
	                      };
	                    }());
	                  }
	
	                case 1:
	                case 'end':
	                  return _context13.stop();
	              }
	            }
	          }, _callee13, _this2);
	        }));
	
	        return function (_x14) {
	          return _ref12.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getrightanswer = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var ansdata = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getrightAnswer', ansdata).then(function (resp_count) {
	        // console.log('I am on respnsod of right answer -----> ', resp_count);
	        if (resp_count.success) {
	          _this.setState({
	            rightanswercount: resp_count.allrightanswercount.question_count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    };
	
	    _this.handleScroll = function () {
	      window.scroll({
	        top: document.body.offsetHeight,
	        left: 0,
	        behavior: 'smooth'
	      });
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state = _this.state,
	          flag = _this$state.flag,
	          userStatsData = _this$state.userStatsData,
	          questionsData = _this$state.questionsData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== questionsData.length) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserQuizStatus', data).then(function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	          return _regenerator2.default.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x16) {
	          return _ref14.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getStrikedText', data).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x17) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.backToMock = function () {
	      var path = _AppRoutes2.default.CFA2_2027_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', _this.props.params.id).replace(':timer', _this.props.params.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getReadingViseScore = function () {
	      // console.log('heeyyyyyyy');
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getrightAnswerReadingVise', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          var temp, arr;
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  // console.log('response of rightanswer ------> ', res);
	                  temp = 0;
	                  arr = res.readingName.map(function (item, i) {
	                    if (res.allrightanswercount.some(function (ele) {
	                      return ele.id === item.id;
	                    })) {
	                      return Object.assign({}, item, res.allrightanswercount[temp++]);
	                    } else return Object.assign({}, item, 0);
	                  });
	
	                  _this.setState({
	                    readingViseScore: arr
	                  });
	
	                case 3:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this._hideReportForm = function () {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block', reportError: '' });
	    };
	
	    _this.reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	
	      _this.setState({
	        reportError: ''
	      });
	      if (comment.length < 2) {
	        _this.setState({
	          reportError: 'Please enter comment'
	        });
	        return;
	      }
	      // BUG FIX: `questiono` is a URL position param (1-based question index
	      // within a case), NOT the cfa2_2027_cbt_questions primary key. Saving it as
	      // `question_id` broke the admin auto-reply join (cfa2_cbt_question came
	      // back null → empty reported_item). Sibling save/answer calls in this
	      // file (~lines 402/510/535) already use selectedQuestionData.id /
	      // selectedCaseQuestionData.id — reuse the same pattern here.
	      var _this$state2 = _this.state,
	          selectedCaseQuestionData = _this$state2.selectedCaseQuestionData,
	          selectedQuestionData = _this$state2.selectedQuestionData;
	
	      var realQuestionId = selectedCaseQuestionData && selectedCaseQuestionData.id || selectedQuestionData && selectedQuestionData.id || (_this.props.params.questiono ? parseInt(_this.props.params.questiono) : null);
	
	      var data = {
	        case_id: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: realQuestionId,
	        comment: comment,
	        offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : 0,
	        timer: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : 0,
	        mockName: _this.state.mockName,
	        quesOffset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : 0,
	        caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : 0
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      readingViseScore: '',
	      report_block: 'card hide_block',
	      totalQuestionCount: 0
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.state.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        // '/cfa2cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart';
	        var path = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', this.props.params.id).replace(':caseno', this.props.params.caseno).replace(':questiono', this.props.params.questiono).replace(':timer', this.props.params.timer).replace(':testid', this.props.params.testid).replace(':caseOffset', this.props.params.caseOffset).replace(':quesOffset', this.props.params.quesOffset).replace(':isNegative', false).replace(':timerStart', this.props.params.timerStart);
	        this.context.router.push({
	          pathname: path
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.state.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserTimer', data).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this3);
	        }));
	
	        return function (_x19) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          vpCaseLoader = _state.vpCaseLoader,
	          questionLoader = _state.questionLoader,
	          rightanswercount = _state.rightanswercount,
	          outOfScore = _state.outOfScore,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData,
	          readingViseScore = _state.readingViseScore,
	          reportError = _state.reportError,
	          reportLoading = _state.reportLoading,
	          questionCount = _state.totalQuestionCount;
	      var question_ids = userStatsData.question_ids;
	
	      var totalQuestionCount = question_ids && JSON.parse(question_ids).length || questionCount && questionCount.length || 0;
	      var userTime = 0;
	      if (userStatsData && userStatsData.user_time_value && this.props.params.timer) {
	        if (userStatsData.isNegative === 'true') {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) - userStatsData.user_time_value);
	        } else {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) + userStatsData.user_time_value);
	        }
	      }
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedCaseQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var parseResult = Object.keys(userChoice).map(function (x) {
	        return parseInt(x, 10);
	      });
	      selectedQuestionData.cfa2_2027_cbt_questions;
	      var count = 0;
	      parseResult.forEach(function (element) {
	        var attemptedCount = questionsData.filter(function (item) {
	          if (item.id === element) {
	            count++;
	          }
	          return item.id === element;
	        });
	      });
	
	      var content = selectedQuestionData.question;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            {
	              className: casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'pointer_class btn-primary back-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                _language2.default.LC().BACK
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this4.slider = slider;
	                      }
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeCase(item.id, index);
	                          },
	                          className: (attemptedCaseArray.indexOf(item.id) === -1 ? 'bg-completed-cases ' : '') + '\n                              ' + (index === parseInt(_this4.props.params.caseOffset) ? 'active button-trial' : 'button-trial')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper  col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header d-flex justify-content-between qus-header' },
	                    selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                      'div',
	                      { className: 'ques-wrapper all-ques' },
	                      _react2.default.createElement('h1', {
	                        className: 'text-center mb-2 text-capitalize',
	                        dangerouslySetInnerHTML: {
	                          __html: selectedQuestionData.case_name
	                        }
	                      }),
	                      _react2.default.createElement('div', {
	                        contentEditable: 'false',
	                        className: 'font-weight-normal',
	                        dangerouslySetInnerHTML: {
	                          __html: selectedQuestionData.case
	                        }
	                      })
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text-right que-action-arrow' },
	                      _react2.default.createElement('i', {
	                        className: this.props.params.caseOffset === '0' ? 'fa fa-angle-left ques_arrow pointer_class hide_block' : 'fa fa-angle-left ques_arrow pointer_class',
	                        onClick: this.getPreviousCase
	                      }),
	                      _react2.default.createElement('i', {
	                        className: parseInt(this.props.params.caseOffset) === casesData.length - 1 ? 'fa fa-angle-right ques_arrow pointer_class hide_block' : 'fa fa-angle-right ques_arrow pointer_class',
	                        onClick: this.getNextCase
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper height-0' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this4.slider = slider;
	                    }
	                  }),
	                  ' ',
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag && flag.length ? flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0] : '';
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                        ' + (index === parseInt(_this4.props.params.quesOffset) ? 'active' : '') + '\n                        ' + (userChoice[item.id] === item.answer ? 'right-ans' : userChoice[item.id] ? 'wrong-ans' : 'not-ans') + '\n                        ' + (flaggedQuestions ? 'flag-add' : '') + '\n                        '
	                        },
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : '',
	                        index + 1
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-11' },
	                isDataLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header qus-header finish-question-wrapper' },
	                    selectedCaseQuestionData && selectedCaseQuestionData.question ? _react2.default.createElement(
	                      'div',
	                      { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_right_20',
	                          alt: '',
	                          width: '30'
	                        }),
	                        'Q.',
	                        parseInt(this.props.params.quesOffset) + 1
	                      ),
	                      _react2.default.createElement('div', {
	                        contentEditable: 'false',
	                        dangerouslySetInnerHTML: {
	                          __html: selectedCaseQuestionData.question
	                        },
	                        className: 'qus-title w-100',
	                        style: {
	                          marginTop: '8px'
	                        }
	                      })
	                    ) : null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'btn btn-primary pointer_class mid-btn',
	                          onClick: function onClick() {
	                            _this4.setState({
	                              showSectionReview: true
	                            });
	                            _this4.getReadingViseScore();
	                          }
	                        },
	                        _language2.default.LC().SCORE
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_MYSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap tooltip_wrap_margin' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: (rightanswercount ? rightanswercount : 0) === 0 ? true : false,
	                          className: (rightanswercount ? rightanswercount : 0) === 0 ? 'cursor_not_Allowed btn btn-primary  mid-btn' : 'btn btn-primary mid-btn',
	                          onClick: function onClick() {
	                            return _this4.getDetailedResultGraph(totalQuestionCount);
	                          }
	                        },
	                        _language2.default.LC().GRAPH
	                      ),
	                      rightanswercount ? rightanswercount === 0 ? null : _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_GRAPH
	                      ) : null
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _constant.optionsArr.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-12', id: item, key: index },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box cursor-default ' + (userChoice ? selectedCaseQuestionData && selectedCaseQuestionData.answer === item && userChoice[_this4.props.params.questiono] === item ? 'border-green' : selectedCaseQuestionData.answer === item ? 'border-green' : userChoice[_this4.props.params.questiono] === item ? 'border-red' : '' : '')
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  { className: 'ans_box_text' },
	                                  selectedCaseQuestionData && selectedCaseQuestionData[item] ? _react2.default.createElement('span', {
	                                    contentEditable: 'false',
	                                    dangerouslySetInnerHTML: {
	                                      __html: selectedCaseQuestionData[item]
	                                    }
	                                  }) : null
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'score-wrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'score-inner' },
	                            rightanswercount ? rightanswercount : 0,
	                            '/',
	                            totalQuestionCount
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().You_Scored,
	                            ' ',
	                            Math.ceil((rightanswercount ? rightanswercount * 100 : 0) / totalQuestionCount),
	                            '%'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer finished-time' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              _language2.default.LC().TEST_COMPLETED_IN
	                            ),
	                            _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'timer_box' },
	                              userTime
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            'span',
	                            {
	                              className: 'up tooltip-hover-questions',
	                              style: { padding: '10px' }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              ' ',
	                              _language2.default.LC().REPORT_THIS_QUESTION,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'report-icon-wrapper',
	                                onClick: function onClick() {
	                                  _this4.handleScroll();
	                                  _this4.setState({
	                                    report_block: 'card show_block'
	                                  });
	                                }
	                              },
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/report4.png',
	                                alt: 'report'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getPreviousQuestion(_this4.props.params.quesOffset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.quesOffset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getNextQuestion(_this4.props.params.quesOffset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card show_block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'main_loader ' + this.state.display_main_loader },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loader-mid' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block-loader' },
	                    _react2.default.createElement(_loader2.default, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'card-header highlight_finish_text ' + (userChoice && userChoice[this.props.params.questiono] === selectedCaseQuestionData.answer ? 'text_success-cbt' : !userChoice[this.props.params.questiono] ? 'text_unAttempted-cbt' : 'text_failure-cbt')
	                },
	                userChoice && userChoice[this.props.params.questiono] === selectedCaseQuestionData.answer ? '' + _language2.default.LC().Correct : !userChoice[this.props.params.questiono] ? '' + _language2.default.LC().NOT_ATTEMPTED : '' + _language2.default.LC().Incorrect
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement('p', {
	                  className: 'answer_text',
	                  dangerouslySetInnerHTML: {
	                    __html: selectedCaseQuestionData && selectedCaseQuestionData.answer ? _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + (selectedCaseQuestionData.answer === 'choice_a' ? '<strong>' + _language2.default.LC().A + '.</strong>' : selectedCaseQuestionData.answer === 'choice_b' ? '<strong>' + _language2.default.LC().B + '.</strong>' : selectedCaseQuestionData.answer === 'choice_c' ? '<strong>' + _language2.default.LC().C + '.</strong>' : null) : ''
	                  }
	                }),
	                _react2.default.createElement('p', {
	                  contentEditable: 'false',
	                  className: 'view_questionhtml',
	                  dangerouslySetInnerHTML: {
	                    __html: selectedCaseQuestionData && selectedCaseQuestionData.explanation ? selectedCaseQuestionData.explanation : ''
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'error_text ml-1' },
	                        ' ',
	                        reportError
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: function onClick() {
	                              return _this4.reportQuestion(selectedQuestionData.id);
	                            }
	                          },
	                          reportLoading ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                            ' ',
	                            _language2.default.LC().PLEASE_WAIT
	                          ) : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: function onClick() {
	                              return _this4._hideReportForm();
	                            }
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: function onClick() {
	                              _this4.setState({
	                                report_block: 'card hide_block',
	                                successAlert: false
	                              });
	                            }
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'sidebar-review-wrapper sidebar-score-wrapper ' + (showSectionReview ? 'active' : '')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              ' ',
	              _language2.default.LC().TOPIC_WISE_SCORE
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'cursor-pointer',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'score-list-wrapper' },
	              readingViseScore && readingViseScore.length ? readingViseScore.map(function (item, index) {
	                var readingPercentage = item.question_count * 100 / item.cfa2_2027_cbt_questions.length;
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      index + 1,
	                      '\xA0 ',
	                      item.chapter_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress custom-prog-bar margin_top_5' },
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'progress-bar',
	                          role: 'progressbar',
	                          style: {
	                            width: Math.ceil(readingPercentage) + '%'
	                          },
	                          'aria-valuenow': '' + Math.ceil(readingPercentage),
	                          'aria-valuemin': '0',
	                          'aria-valuemax': '100'
	                        },
	                        Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0,
	                        '%'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'score-inner' },
	                    item.question_count ? item.question_count : 0,
	                    '/',
	                    item.cfa2_2027_cbt_questions ? item.cfa2_2027_cbt_questions.length : 0
	                  )
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-qus-found no-mock-exam mt-5' },
	                _react2.default.createElement('img', {
	                  width: '62px',
	                  src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'mt-1' },
	                  _language2.default.LC().NO_SCORE_FOUND
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var CFA2IntoductionInstruction = function (_Component) {
	  _inherits(CFA2IntoductionInstruction, _Component);
	
	  function CFA2IntoductionInstruction(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA2IntoductionInstruction);
	
	    var _this = _possibleConstructorReturn(this, (CFA2IntoductionInstruction.__proto__ || Object.getPrototypeOf(CFA2IntoductionInstruction)).call(this, props));
	
	    _this.componentDidMount = function () {
	      // console.log(
	      //   'I am here on Frontendsrc\viewsCBTCFA2CBTNewIntoductionInstructionindex.js '
	      // );
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	    };
	
	    _this.changeQuestion = function (questionNumber) {
	      if (questionNumber) {
	        // ('/cfa2introduction/:id/:questiono/:timer');
	        var path = _this.introductionRoute.replace(':id', _this.props.params.id).replace(':questiono', questionNumber).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.getPrevious = function (questionNumber) {
	      if (questionNumber) {
	        var path = _this.introductionRoute.replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) - 1 : 1).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.getNext = function (questionNumber) {
	      if (questionNumber) {
	        var path = _this.introductionRoute.replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) + 1 : 1).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.startTest = function () {
	      _this.setState({
	        startLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        status: 'pending'
	      };
	      var mockExamSource = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + mockExamSource + '/getCFAMockCases'), data).then(function (caseResp) {
	        if (caseResp.success) {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + mockExamSource + '/getCFAMockQuestions'), data).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                startLoading: true
	              });
	              var _response$question = response.question,
	                  question = _response$question === undefined ? [] : _response$question;
	
	              var questionIds = question.map(function (questionDetail) {
	                return questionDetail.id;
	              });
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + mockExamSource + '/addUsersChoice', Object.assign({}, userData, { questionIds: questionIds })).then(function () {
	                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                  var appRoute, path;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (res.success) {
	                            appRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS : _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS;
	                            path = appRoute.replace(':id', _this.props.params.id).replace(':caseno', caseResp.question && caseResp.question.length ? caseResp.question[0].id : 1).replace(':questiono', response.question && response.question.length ? response.question[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', res.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	
	                            _this.context.router.push({
	                              pathname: path
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref.apply(this, arguments);
	                };
	              }());
	            }
	          });
	        }
	      });
	    };
	
	    _this.strikeText = function (e, value) {
	      e.preventDefault();
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      if (e.type === 'contextmenu') {
	        strikeThroughArr.push(value);
	        _this.setState({
	          strikeThroughArr: strikeThroughArr
	        });
	      } else {
	        return;
	      }
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      token: '',
	      idname: '',
	      startLoading: false,
	      strikeThroughArr: []
	    };
	    _this.introductionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_2027_CBT_INTRODUCTION;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFA2IntoductionInstruction, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          startLoading = _state.startLoading,
	          strikeThroughArr = _state.strikeThroughArr;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().Section_Introduction
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                Array.from({ length: 12 }, function (item) {
	                  return item;
	                }).map(function (item, index) {
	                  return _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      key: index,
	                      onClick: function onClick() {
	                        return _this3.changeQuestion(index + 1);
	                      },
	                      className: '' + (index + 1 === parseInt(_this3.props.params.questiono) ? 'active' : '')
	                    },
	                    index + 1
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper intro-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  this.props.params.questiono === '1' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().INTROTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().INTROPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTTOCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '2' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().WELCOMETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().WELCOMEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '3' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().USEMOUSETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_arrow.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().USEMOUSEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '4' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().NAVIGATTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_tab_btn.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-2' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '5' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TIMEREMAINTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARAONE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'time-left-img',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_time.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARATWO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '6' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().FLAGTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag_btn.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGBUTTON, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '7' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ANSWERMULTTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ANSWERMULTPARA, "div", "", { contentEditable: false })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'h6',
	                            null,
	                            _language2.default.LC().QUESMULTTITLE
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().A
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().ESTONIA
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().B
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().UKRAINE
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().C
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().BELGIUM
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '8' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().REVIEWTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              width: '38px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARACLOSE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'section-review',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_sidebar.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '9' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().HIGHLIGHTINGTEXT
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().HIGHLIGHTINGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'mw-100',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_highlight.png',
	                              alt: 'Highlight'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().PLEASENOTE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '10' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().STRIKINGOUTOPTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().STRIKINGOUTOPTIONSPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                _language2.default.LC().QUESMULTTITLE
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().A
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_a') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().ESTONIA
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().B
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_b') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().UKRAINE
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_c') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().BELGIUM
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '11' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ENDINGEXAMTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ENDINGEXAMPARA, "div", "", { contentEditable: false }),
	                          this.props.location.pathname.includes('cfa3') ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/questions/finish_page.png',
	                                alt: 'Mouse Arrow'
	                              })
	                            ),
	                            (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFOONFINISH, "div", "", { contentEditable: false })
	                          ) : null,
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '12' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TUTORIALCONCLUSIONTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TUTORIALCONCLUSIONPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().CLICKSTARTTEST
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getPrevious,
	                              className: 'pointer_class btn-primary',
	                              disabled: this.props.params.questiono === '1'
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getNext,
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.questiono) === 12
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                _this3.startTest();
	                              },
	                              className: 'pointer_class btn-primary'
	                            },
	                            startLoading ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : '',
	                            ' ',
	                            _language2.default.LC().START_TEST,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CFA2IntoductionInstruction;
	}(_react.Component);
	
	CFA2IntoductionInstruction.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFA2IntoductionInstruction;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBT2InstructionsNew = __webpack_require__(183);
	
	var _CBT2InstructionsNew2 = _interopRequireDefault(_CBT2InstructionsNew);
	
	var _reactstrap = __webpack_require__(6);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBT2MockExams = function (_Component) {
	  _inherits(CBT2MockExams, _Component);
	
	  function CBT2MockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBT2MockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBT2MockExams.__proto__ || Object.getPrototypeOf(CBT2MockExams)).call(this, props));
	
	    _this.checkSubscriptionPartner = function () {
	      var pathname = _this.props.location.pathname;
	
	      if (pathname.includes('/cfa3/')) return _Cfa3Subscription4.default.checkCfa3Subscription;
	      return _Cfa2Subscription4.default.checkCfa2Subscription;
	    };
	
	    _this.checkSubscriptionUser = function () {
	      var pathname = _this.props.location.pathname;
	
	      if (pathname.includes('/cfa3/')) return _Cfa3Subscription2.default.checkCfa3Subscription;
	      return _Cfa2Subscription2.default.checkCfa2Subscription;
	    };
	
	    _this.getQuestions = function (mock) {
	      _this.setState({
	        showInstructionModal: false
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context.next = 6;
	                        return _this.checkSubscriptionPartner(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          _this._runCode('paid', mock);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            // console.log('resp.profileInfo.---------------', resp.profileInfo);
	            _this.toggleAlert();
	            _this.setState({ subscriptionstatus: 'free' });
	            _this._runCode('free');
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _this.checkSubscriptionUser(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	                  _this._runCode('paid', mock);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus, mock) {
	      if (subscriptionstatus === 'paid') {
	        var frontendRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_2027_CBT_INTRODUCTION;
	        var pathname = frontendRoute.replace(':id', mock.id).replace(':questiono', 1).replace(':timer', mock.timer);
	        _this.context.router.push({
	          pathname: pathname
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function (mock) {
	      _this.setState({
	        showInstructionModal: true,
	        mockData: mock
	      });
	    };
	
	    _this.viewAttemptedExams = function (mock) {
	      // ('/cfa2viewattemptedmock/:id/:timer');
	      var frontENDURL = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_VIEW_ATTEMPTED_MOCK : _AppRoutes2.default.CFA2_2027_CBT_VIEW_ATTEMPTED_MOCK;
	
	      var path = frontENDURL.replace(':id', mock.id).replace(':timer', mock.timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.openQPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	
	      var filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + filePath + '/MockQPdfDownload'), data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQ: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQ: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.openQAPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	      var filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + filePath + '/MockQAPdfDownload'), data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQA: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQA: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.checkSubscription = function (id, type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log('resp.profileInfo.userStatus', resp.profileInfo);
	
	                        _context2.next = 6;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          if (type === 'Q') {
	                            _this.setState({
	                              pdfLoadingQ: true
	                            });
	                            _this.openQPDF(id);
	                          } else {
	                            _this.setState({
	                              pdfLoadingQA: true
	                            });
	                            _this.openQAPDF(id);
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 12;
	                        break;
	
	                      case 11:
	                        console.log('fail');
	
	                      case 12:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _this.checkSubscriptionUser(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	
	                  if (type === 'Q') {
	                    _this.setState({
	                      pdfLoadingQ: true
	                    });
	                    _this.openQPDF(id);
	                  } else {
	                    _this.setState({
	                      pdfLoadingQA: true
	                    });
	                    _this.openQAPDF(id);
	                  }
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.toggle = function (index) {
	      _this.setState({
	        dropdownOpenIndex: index,
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      pdfLoadingQ: false,
	      pdfLoadingQA: false,
	      pdfMessage: '',
	      pdfMessageOpen: false,
	      dropdownOpen: false,
	      dropdownOpenIndex: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.togglePdfMessage = _this.togglePdfMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBT2MockExams, [{
	    key: 'togglePdfMessage',
	    value: function togglePdfMessage() {
	      this.setState({ pdfMessageOpen: !this.state.pdfMessageOpen });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var storage_session, data, filePath;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // console.log('I am on Frontendsrc\viewsCBTCFA2CBTNewMockListindex.js');
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                filePath = this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + filePath + '/getCFAMockExams'), data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.mock,
	                      isLoading: false,
	                      userStatsData: resp.userstats
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockData = _state.mockData,
	          dropdownOpen = _state.dropdownOpen,
	          dropdownOpenIndex = _state.dropdownOpenIndex;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().MOCK_LIST
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _language2.default.LC().MOCKEXAM
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(_loader2.default, null) : mockList.length ? mockList.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                item.mock_exam
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                  onClick: function onClick() {
	                                    return _this4.viewAttemptedExams(item);
	                                  }
	                                },
	                                _language2.default.LC().START
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'privetinfo-dropdown' },
	                                _react2.default.createElement(
	                                  _reactstrap.ButtonDropdown,
	                                  {
	                                    className: index + 1 === mockList.length ? 'dropup' : '',
	                                    isOpen: dropdownOpenIndex === index ? dropdownOpen : false,
	                                    toggle: function toggle() {
	                                      return _this4.toggle(index);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownToggle,
	                                    {
	                                      className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                      caret: true
	                                    },
	                                    _language2.default.LC().PRINT
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownMenu,
	                                    { right: true },
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'public',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item.id, 'Q');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_CASES_Q_MOCK
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'private',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item.id, 'QA');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_CASES_QA_MOCK
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '4', className: 'text-center py-4 px-2' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _language2.default.LC().No_Mock_Exams
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.pdfMessageOpen,
	            toggle: this.togglePdfMessage,
	            className: 'modal-primary custom_modalpro info-modal-designing'
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.togglePdfMessage, className: 'custom-title' },
	            'Information'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-info-view-for-plan' },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.pdfMessage
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btn-plan-view view-plan-wrap' },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { className: 'btn btn-primary', onClick: this.togglePdfMessage },
	                  'OK'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBT2InstructionsNew2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions(mockData);
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBT2MockExams;
	}(_react.Component);
	
	CBT2MockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBT2MockExams;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactstrap = __webpack_require__(6);
	
	__webpack_require__(80);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _constant = __webpack_require__(9);
	
	var _highlightText = __webpack_require__(56);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var longPressDuration = 450;
	var attemptedCaseArray = [];
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.caseOffset !== _this.props.params.caseOffset || prevProps.params.quesOffset !== _this.props.params.quesOffset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _this.getCases(data);
	        _this.getUserStats();
	        _this.getFlagQuestions();
	      }
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	              };
	
	              _this.getCases(data);
	              _this.getUserStats();
	              // this.getFlagQuestions();
	              if (_this.props.params.timerStart === 'true') {
	                _this.timer = setInterval(_this.countDown, 1000);
	              } else {
	                clearInterval(_this.timer);
	              }
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getMockNamebyId', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	              // getTotalQuestionsCount
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getTotalQuestionsCount', data).then(function (resp) {
	                if (resp.success) {
	                  // console.log('Success --------> ', resp);
	                  _this.setState({
	                    totalQuestionCount: resp.question
	                  });
	                } else {
	                  // console.log('falure --------> ', resp);
	                }
	              });
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getCases = function (data) {
	      _this.setState({
	        display_main_loader: 'show_block z-index-1000 bg-white',
	        vpCaseLoader: true,
	        questionLoader: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getCFAMockCases', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.question && resp.question.length) {
	            _this.getHighlightedText();
	            _this.getStrikedText();
	            _this.setState({
	              casesData: resp.question,
	              isLoading: false,
	              isDataLoading: false,
	              vpCaseLoader: false,
	              questionLoader: false,
	              display_main_loader: 'hide_block',
	              //selected case
	              selectedQuestionData: resp.question[_this.props.params.caseOffset],
	              //all questions of selected case
	              questionsData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions ? resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions : [],
	              //1st question of selected case
	              selectedCaseQuestionData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions && resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions[_this.props.params.quesOffset] ? resp.question[_this.props.params.caseOffset].cfa2_2027_cbt_questions[_this.props.params.quesOffset] : []
	            });
	          }
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeCase = function (questionNumber, index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index + 1);
	      _this.getUserStats();
	      // this.getFlagQuestions();
	      _this.setState({
	        isLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      if (questionNumber) {
	        var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset)] && casesData[parseInt(_this.props.params.caseOffset)].cfa2_2027_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset)].cfa2_2027_cbt_questions[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', index).replace(':timerStart', _this.props.params.timerStart).replace(':isNegative', _this.props.params.isNegative).replace(':quesOffset', 0);
	        _this.context.router.push({
	          pathname: pathname
	        }, _this.getCases(data));
	      }
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	          attemptedCaseArray = resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      if (questionNumber) {
	        var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', questionNumber).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', index).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	      }
	    };
	
	    _this.getNextCase = function (index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index);
	      _this.setState({
	        isLoading: true
	      });
	      var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) + 1] && casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_2027_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) + 1].cfa2_2027_cbt_questions[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousCase = function (index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index - 2);
	      _this.setState({
	        isLoading: true
	      });
	      var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset ? casesData[parseInt(_this.props.params.caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(_this.props.params.caseOffset) - 1] && casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_2027_cbt_questions[0] ? casesData[parseInt(_this.props.params.caseOffset) - 1].cfa2_2027_cbt_questions[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) - 1].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) - 1 : 1).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getNextQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseOffset).replace(':questiono', _this.props.params.quesOffset ? questionsData[parseInt(_this.props.params.quesOffset) + 1].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) + 1 : 1).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart);
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/addHighlightedText', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context3.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context6.next = 7;
	                  break;
	                }
	
	                _context6.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/deleteHighlightedText', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context5.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context6.next = 8;
	                break;
	
	              case 7:
	                return _context6.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getHighlightedText', data).then(function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	          return _regenerator2.default.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  // console.log('highlights ---------> ', res.questions);
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this2);
	        }));
	
	        return function (_x6) {
	          return _ref7.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                //console.log('e. type ___________', e.type);
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  // console.log('Print params ---------> ', this.props.params);
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : null,
	                    caseno: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	                    caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : null
	                    // attemptedCases: JSON.stringify(attemptedCaseArray),
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7, _x8, _x9, _x10) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context10.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/addStrikeThrough', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            _context9.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x12) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x11) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      // console.log('userData --------------> ', userData);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUsersChoice', userData).then(function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee12$(_context12) {
	            while (1) {
	              switch (_context12.prev = _context12.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    // console.log('ansData -------------> ', ansData);
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserAnswer', ansData).then(function () {
	                      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	                        return _regenerator2.default.wrap(function _callee11$(_context11) {
	                          while (1) {
	                            switch (_context11.prev = _context11.next) {
	                              case 0:
	                              case 'end':
	                                return _context11.stop();
	                            }
	                          }
	                        }, _callee11, _this2);
	                      }));
	
	                      return function (_x14) {
	                        return _ref12.apply(this, arguments);
	                      };
	                    }());
	                  }
	
	                case 1:
	                case 'end':
	                  return _context12.stop();
	              }
	            }
	          }, _callee12, _this2);
	        }));
	
	        return function (_x13) {
	          return _ref11.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.submitTest = function () {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({
	        showFinishTestPopup: false
	      });
	      // console.log('I am here for you ----------->');
	
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserQuizStatus', data).then(function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	          return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	              switch (_context13.prev = _context13.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context13.stop();
	              }
	            }
	          }, _callee13, _this2);
	        }));
	
	        return function (_x15) {
	          return _ref13.apply(this, arguments);
	        };
	      }());
	
	      var ansdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getrightAnswer', ansdata).then(function (resp_count) {
	        // console.log('I am here for you ----------->');
	        if (resp_count.success) {
	          var _data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	            score: resp_count.allrightanswercount.question_count,
	            id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserScore', _data);
	        } else {
	          //console.log(resp_count.success + '------------failure');
	        }
	      });
	      // /:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer
	      var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH.replace(':id', _this.props.params.id).replace(':caseno', 0).replace(':questiono', 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.flagQuestion = function (data) {
	      var flag = _this.state.flag;
	
	      var flaggedQuestions = flag.filter(function (flag) {
	        return flag.question_id === data.id;
	      })[0];
	      var flagdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: data.id,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      if (flaggedQuestions) {
	        (0, _toast.showSuccess)('Question Unflagged');
	      } else {
	        (0, _toast.showSuccess)('Question Flagged');
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/flagQuestion', flagdata).then(function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	          return _regenerator2.default.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  if (res) {
	                    _this.getFlagQuestions();
	                  }
	
	                case 1:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x16) {
	          return _ref14.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.updateAttemptedCases = function () {
	      // console.log('661 attempted cases -----------> ', attemptedCaseArray);
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        attemptedCases: JSON.stringify(attemptedCaseArray)
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateAttemptedCases', userData).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res.success) {
	                    attemptedCaseArray = res.attemptedCases != null ? JSON.parse(res.attemptedCases) : [];
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x17) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getflaggedQuestions', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state = _this.state,
	          flag = _this$state.flag,
	          userStatsData = _this$state.userStatsData,
	          totalQuestionCount = _this$state.totalQuestionCount;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== totalQuestionCount) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	    };
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	
	      if (timerStart === 'true') {
	        _this.setState({
	          timerStart: 'false'
	        });
	        var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', _this.props.params.questiono).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset).replace(':timerStart', false).replace(':isNegative', _this.props.params.isNegative);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: 'true'
	        });
	
	        var _pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', _this.props.params.id).replace(':caseno', _this.props.params.caseno).replace(':questiono', _this.props.params.questiono).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':caseOffset', _this.props.params.caseOffset).replace(':quesOffset', _this.props.params.quesOffset).replace(':timerStart', true).replace(':isNegative', _this.props.params.isNegative);
	
	        _this.context.router.push({
	          pathname: _pathname
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getStrikedText', data).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this2);
	        }));
	
	        return function (_x19) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      totalQuestionCount: 0
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        var pathname = _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS.replace(':id', this.props.params.id).replace(':caseno', this.props.params.caseno).replace(':questiono', this.props.params.questiono).replace(':timer', this.props.params.timer).replace(':testid', this.props.params.testid).replace(':caseOffset', this.props.params.caseOffset).replace(':quesOffset', this.props.params.quesOffset).replace(':isNegative', false).replace(':timerStart', this.props.params.timerStart);
	        this.context.router.push({
	          pathname: pathname
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.props.params.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateUserTimer', data).then(function () {
	        var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(res) {
	          return _regenerator2.default.wrap(function _callee18$(_context18) {
	            while (1) {
	              switch (_context18.prev = _context18.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context18.stop();
	              }
	            }
	          }, _callee18, _this3);
	        }));
	
	        return function (_x20) {
	          return _ref18.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedCaseQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var content = selectedCaseQuestionData ? selectedCaseQuestionData.question : null;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      var parseResult = Object.keys(userChoice).map(function (x) {
	        return parseInt(x, 10);
	      });
	      var count = 0;
	      parseResult.forEach(function (element) {
	        // console.log('element -----> ', element);
	        var attemptedCount = questionsData.filter(function (item) {
	          // console.log('iteme ----> ', item);
	          if (item.id === element) {
	            count++;
	            if (questionsData.length === count) {
	              if (attemptedCaseArray.indexOf(item.case_id) === -1) {
	                attemptedCaseArray.push(item.case_id);
	
	                _this4.updateAttemptedCases();
	              }
	            }
	          }
	          return item.id === element;
	        });
	      });
	      var caseAttempted = '';
	      if (questionsData.length === count) {
	        caseAttempted = 'bg-completed-cases';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            {
	              className: casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { onClick: function onClick() {
	                    return _this4.finishTest();
	                  }, className: 'pointer_class btn-primary' },
	                _language2.default.LC().Finish_Test
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this4.slider = slider;
	                      }
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeCase(item.id, index);
	                          },
	                          className: (attemptedCaseArray.indexOf(item.id) === -1 ? '' : 'bg-completed-cases ') + '\n                              ' + (index === parseInt(_this4.props.params.caseOffset) ? 'active button-trial' : 'button-trial')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: '' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header d-flex justify-content-between qus-header' },
	                    selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                      'div',
	                      { className: 'ques-wrapper all-ques' },
	                      (0, _function.renderHTMLContent)(selectedQuestionData.case_name, "h1", "text-center mb-2 text-capitalize"),
	                      (0, _function.renderHTMLContent)(selectedQuestionData.case, "div", "font-weight-normal", { contentEditable: false })
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text-right' },
	                      _react2.default.createElement('i', {
	                        className: this.props.params.caseOffset === '0' ? 'fa fa-angle-left ques_arrow pointer_class hide_block' : 'fa fa-angle-left ques_arrow pointer_class',
	                        onClick: function onClick() {
	                          return _this4.getPreviousCase(_this4.props.params.caseOffset);
	                        }
	                      }),
	                      _react2.default.createElement('i', {
	                        className: parseInt(this.props.params.caseOffset) === casesData.length - 1 ? 'fa fa-angle-right ques_arrow pointer_class hide_block' : 'fa fa-angle-right ques_arrow pointer_class',
	                        onClick: function onClick() {
	                          return _this4.getNextCase(_this4.props.params.caseOffset);
	                        }
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'qus-tab-wrapper' },
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0];
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                            ' + (index === parseInt(_this4.props.params.quesOffset) ? 'active' : '') + '\n                            ' + (userChoice[item.id] ? 'completed-qus' : '') + '\n                            ' + (flaggedQuestions ? 'flag-add' : '') + '\n                            '
	                        },
	                        index + 1,
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : ''
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ques-detail-wrapper col-md-12 question-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'main_loader ' + this.state.display_main_loader },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'loader-mid' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'card-block-loader' },
	                              _react2.default.createElement(_loader2.default, null)
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-8 col-lg-9' },
	                          selectedCaseQuestionData && selectedCaseQuestionData.question ? _react2.default.createElement(
	                            'div',
	                            { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                                className: 'margin_right_20',
	                                alt: '',
	                                width: '30'
	                              }),
	                              'Q.',
	                              parseInt(this.props.params.quesOffset) + 1
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                style: {
	                                  position: 'relative',
	                                  marginTop: '8px',
	                                  maxWidth: '100%'
	                                }
	                              },
	                              _react2.default.createElement(
	                                'div',
	                                { 'data-selectable': true },
	                                (0, _function.renderHTMLContent)(content, "div", "qus-title d-inline-block w-100")
	                              ),
	                              _react2.default.createElement(
	                                _reactSelectionPopover2.default,
	                                {
	                                  showPopover: this.state.showPopover,
	                                  onSelect: function onSelect() {
	                                    _this4.setState({
	                                      showPopover: true
	                                    });
	                                  },
	                                  onDeselect: function onDeselect() {
	                                    _this4.setState({
	                                      showPopover: false
	                                    });
	                                  }
	                                },
	                                getHighlightedText === -1 ? _react2.default.createElement(
	                                  'div',
	                                  { className: 'highlight-popover tooltip_wrap' },
	                                  _react2.default.createElement('img', {
	                                    src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	                                    alt: '523',
	                                    width: '30',
	                                    onClick: function onClick() {
	                                      return _this4.addHighlightToText();
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'tootip_box' },
	                                    _language2.default.LC().Click_me_to_highlight
	                                  )
	                                ) : _react2.default.createElement(
	                                  'div',
	                                  { className: 'highlight-popover tooltip_wrap' },
	                                  _react2.default.createElement('img', {
	                                    src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	                                    alt: '523',
	                                    width: '30',
	                                    onClick: function onClick() {
	                                      return _this4.deleteHighlightFromText();
	                                    }
	                                  }),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'tootip_box' },
	                                    _language2.default.LC().Click_me_to_unhighlight
	                                  )
	                                )
	                              )
	                            )
	                          ) : null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _constant.optionsArr.map(function (item, index) {
	                              return _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'col-sm-12',
	                                  id: item,
	                                  key: index,
	                                  onClick: function onClick(e) {
	                                    _this4.clickOption(item, selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    _this4.clickOption(item, selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	                                  },
	                                  onTouchStart: function onTouchStart(e) {
	                                    _this4.onTouchStart(e, item);
	                                  },
	                                  onTouchCancel: function onTouchCancel(e) {
	                                    _this4.onTouchCancel(e);
	                                  },
	                                  onTouchEnd: function onTouchEnd(e) {
	                                    _this4.onTouchEnd(e);
	                                  },
	                                  onTouchMove: function onTouchMove(e) {
	                                    _this4.onTouchMove(e);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'answer_box ' + (userChoice[selectedCaseQuestionData.id] === item ? 'border-yellow' : 'border-black')
	                                  },
	                                  _react2.default.createElement(
	                                    'div',
	                                    {
	                                      className: 'answer_count highlight_choice no-selection ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	                                    },
	                                    item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    {
	                                      className: 'ans_box_text tooltip_wrap ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	                                    },
	                                    selectedCaseQuestionData && selectedCaseQuestionData[item] ? (0, _function.renderHTMLContent)(selectedCaseQuestionData[item], "span", "no-selection", { contentEditable: false }) : null
	                                  )
	                                )
	                              );
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-4 col-lg-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'timer_outer mb-15' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'h2',
	                                { className: 'time-left-heading' },
	                                _language2.default.LC().TIME_LEFT
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'timer_box ' + (this.props.params.isNegative === 'false' ? 'blink' : null)
	                                },
	                                this.props.params.isNegative === 'false' ? '- ' + formatTimeF : formatTimeF
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              'aria-label': timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer',
	                              className: 'tooltip_wrap mb-2 hover-pad-same\n                                ' + (timerStart === 'true' ? 'icon-control-pause pause_btn' : 'pause_btn icon-control-play'),
	                              onClick: function onClick() {
	                                return _this4.stopTimer();
	                              }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box', 'aria-hidden': 'true' },
	                              _language2.default.LC().Save_and_Take_Break
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              'aria-label': _language2.default.LC().SECTION_REVIEW,
	                              className: 'menu-btn tooltip-hover-questions',
	                              onClick: function onClick() {
	                                _this4.setState({
	                                  showSectionReview: true
	                                });
	                              }
	                            },
	                            _react2.default.createElement('img', {
	                              width: '30px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              className: 'my-1',
	                              alt: ''
	                            }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box', 'aria-hidden': 'true' },
	                              _language2.default.LC().SECTION_REVIEW
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-9 mt-1' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'text-center text-sm-right btm-btn-wrapper quiz-submit-block' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'up tooltip-hover-questions quiz-flag' },
	                              flaggedQuestion ? _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box' },
	                                _language2.default.LC().UNFLAG_THIS_QUESTION
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box' },
	                                _language2.default.LC().FLAG_THIS_QUESTION
	                              ),
	                              _react2.default.createElement(
	                                'i',
	                                {
	                                  onClick: function onClick() {
	                                    return _this4.flagQuestion(selectedCaseQuestionData);
	                                  },
	                                  className: flaggedQuestion ? 'fa fa-flag mark-action-btn' : 'fa fa-flag-o mark-action-btn'
	                                },
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getPreviousQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === 0
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                              ' ',
	                              _language2.default.LC().BACK
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getNextQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                              },
	                              _language2.default.LC().NEXT,
	                              ' ',
	                              _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png', alt: '' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _language2.default.LC().SECTION_REVIEW
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                'aria-label': 'Close section review',
	                className: 'section-review-close',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().FILTER_BY,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'filt-list-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: function onClick() {
	                    _this4.setState({
	                      filter: []
	                    });
	                  }
	                },
	                _language2.default.LC().CLEAR
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _constant.filterObj.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'plan_wrapper remove-plan', key: index },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        value: item,
	                        id: item,
	                        checked: filter.indexOf(item) > -1 ? true : false,
	                        onChange: function onChange(e) {
	                          return _this4.changeFilter(e, item);
	                        }
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' }),
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qus-tab-wrapper' },
	              questionsData.map(function (item, index) {
	                var flaggedQuestions = flag.filter(function (flag) {
	                  return flag.question_id === item.id;
	                })[0];
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  filter.includes('Attempted') && filter.includes('Unattempted') && filter.includes('Flagged') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : filter.includes('Attempted') && filter.includes('Unattempted') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'completed-qus' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : filter.includes('Unattempted') && filter.includes('Flagged') ? !userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : ///
	                  filter.includes('Attempted') && filter.includes('Flagged') ? userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : filter.includes('Attempted') ? userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'completed-qus',
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Unattempted') ? !userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Flagged') ? flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    })
	                  ) : '' : _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _constant = __webpack_require__(9);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CFA2CBTResult = function (_Component) {
	  _inherits(CFA2CBTResult, _Component);
	
	  //
	  function CFA2CBTResult(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA2CBTResult);
	
	    var _this = _possibleConstructorReturn(this, (CFA2CBTResult.__proto__ || Object.getPrototypeOf(CFA2CBTResult)).call(this, props));
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.getGraphoverAllGraphData = function (data) {
	      var fileName = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + fileName + '/getCBTMockUserGraph'), data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.graphData) {
	                    _this.setState({
	                      isLoading: false,
	                      totalQuestions: _this.props.params.totalQuestions,
	                      average: res.graphData ? res.graphData.averageScore : _this.state.average
	                    });
	                    _this.formatoverAllGraphData(res);
	                  } else {
	                    _this.setState({
	                      isLoading: false
	                    });
	                    (0, _toast.showFailure)(res.message);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getGraphData = function (data) {
	      var fileName = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + fileName + '/getCBTMockUserGraphChapterWise'), data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (res.graphData.length > 6) {
	                    _this.setState({
	                      labelAngle: -90
	                    });
	                  }
	                  _this.setState({
	                    isLoading: false,
	                    totalQuestionsChapterwise: _this.props.params.totalQuestions,
	                    exam_name: res.graphData,
	                    averageoverAll: res.graphData
	                  });
	                  _this.formatData(res);
	
	                case 3:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatoverAllGraphData = function (res) {
	      var graphData = res.graphData;
	
	
	      _this.setState({
	        dataOfCurrentUser: graphData ? graphData.dataOfCurrentUser.score : _this.state.dataOfCurrentUser,
	        dataOfEightyPercentileUser: graphData ? graphData.dataOfEightyPercentileUser.score : _this.state.dataOfEightyPercentileUser,
	        dataOfTwentyPercentileUser: graphData ? graphData.dataOfTwentyPercentileUser.score : _this.state.dataOfTwentyPercentileUser
	      });
	      var totalQuestions = _this.state.totalQuestions;
	
	      var temp = [graphData];
	      graphData = temp;
	
	      // Reference line for 70%
	      var referenceLine = {
	        type: 'line',
	        color: '#fff',
	        dataPoints: [{
	          x: -15,
	
	          y: 100
	        }, {
	          x: 20,
	
	          y: 100
	        }, {
	          x: 20,
	
	          y: 100
	        }],
	        markerType: 'none'
	      };
	      // 20% line
	      var dataOfTwentyOverAllGraph = {
	        showInLegend: false,
	        name: '20%',
	
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line
	      var dataOfEightyOverAllGraph = {
	        showInLegend: false,
	
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //User score line
	      var UserScoreOverAllGraph = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User score box
	
	      var scorePercentage = graphData[0].dataOfCurrentUser.score == null ? 0 : Math.ceil(graphData[0].dataOfCurrentUser.score / totalQuestions * 100);
	
	      var UserScoreBoxOverAllGraph2 = {
	        type: 'rangeColumn',
	
	        color: 'hsl(200deg 67% 88%)',
	        dataPoints: []
	      };
	
	      UserScoreBoxOverAllGraph2.dataPoints.push({
	        x: 1.39,
	
	        y: [scorePercentage - 5, scorePercentage + 5]
	      });
	
	      var dataOfCurrentUserLineStart = {
	        x: -0.2,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineMid = {
	        x: 2.8,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineEnd = {
	        x: 2.8,
	        y: null
	      };
	
	      UserScoreOverAllGraph.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	
	      var dataOfTwentyPercentileUserlineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfTwentyPercentileUserlineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfTwentyPercentileUserlineEnd = {
	        x: 7,
	        y: null
	      };
	      dataOfTwentyOverAllGraph.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	      var dataOfEightyPercentileUserLineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfEightyPercentileUserLineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	      };
	
	      var dataOfEightyPercentileUserLineEnd = {
	        x: 7,
	        y: null
	      };
	      dataOfEightyOverAllGraph.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	      var overAllGraphData = [];
	      overAllGraphData.push(UserScoreBoxOverAllGraph2, dataOfTwentyOverAllGraph, dataOfEightyOverAllGraph, UserScoreOverAllGraph, referenceLine);
	
	      _this.setState({
	        dataPointsOverAllGraph: overAllGraphData
	      }, function () {
	        _this.showGraphOverAll(); //Show overall graph
	      });
	    };
	
	    _this.showGraphOverAll = function () {
	      var dataPointsOverAllGraph = _this.state.dataPointsOverAllGraph;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: _constant.canvasjsConfig.axisX,
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        dataPointWidth: 90,
	        dataPointMaxWidth: 80,
	        dataPointMinWidth: 80,
	        legend: {
	          fontSize: 18
	        },
	        data: dataPointsOverAllGraph,
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.formatData = function (res) {
	      // console.log('res ------> ', res);
	      var graphData = res.graphData;
	
	
	      var initialValue = 0;
	      // Reference line for 70%
	      var referenceLine = {
	        type: 'line',
	        color: '#fff',
	        dataPoints: [{
	          x: 0,
	
	          y: 110
	        }, {
	          x: 20,
	
	          y: 110
	        }, {
	          x: 20,
	
	          y: 110
	        }],
	        markerType: 'none'
	      };
	      //20% line chaptervise graph
	      var dataOfTwenty = {
	        showInLegend: false,
	
	        name: '20%',
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line chaptervise graph
	      var dataOfEighty = {
	        showInLegend: false,
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //Userscore line chaptervise graph
	      var UserScore = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User Score Box chaptervise graph
	      // let UserScoreBox = {
	      //   type: 'rangeColumn',
	      //   color: '#cce7f5',
	      //   dataPoints: [],
	      // };
	      // initialValue = -10;
	      // for (let k = 0; k < graphData.length; k++) {
	      //   UserScoreBox.dataPoints.push({
	      //     x: initialValue + 15,
	
	      //     y: [
	      //       graphData[k].dataOfCurrentUser.Percentage - 10,
	      //       graphData[k].dataOfCurrentUser.Percentage + 10,
	      //     ],
	      //   });
	      //   initialValue += 15;
	      // }
	      var UserScoreBox2 = {
	        showInLegend: false,
	        // legendMarkerType: 'square',
	        name: '' + _language2.default.LC().GRAPHSCOREBOX,
	        type: 'rangeColumn',
	        color: '#cce7f5',
	        dataPoints: []
	      };
	      initialValue = -10;
	      // console.log('graphData -------------> ', graphData);
	      var graphDataLength = graphData && graphData.length ? graphData.length : 0;
	      for (var k = 0; k < graphDataLength; k++) {
	        var scoreBoxSize = _this.state.scoreBoxSize;
	
	        UserScoreBox2.dataPoints.push({
	          x: initialValue + 15,
	          label: '' + graphData[k].chapterDetails['cfa2_chapter.chapter_name'],
	          y: [graphData[k].dataOfCurrentUser.Percentage - scoreBoxSize, graphData[k].dataOfCurrentUser.Percentage + scoreBoxSize]
	        });
	        var dataOfCurrentUserLineStart = {
	          x: initialValue + 15 - 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineMid = {
	          x: initialValue + 15 + 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineEnd = {
	          x: initialValue + 15 + 1.5,
	          y: null
	        };
	        UserScore.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	        initialValue += 15;
	      }
	      initialValue = 0;
	      for (var i = 0; i < graphDataLength; i++) {
	        var dataOfTwentyPercentileUserlineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineEnd = {
	          x: initialValue + 10,
	
	          y: null
	        };
	        dataOfTwenty.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	        var dataOfEightyPercentileUserLineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineEnd = {
	          x: initialValue + 10,
	          y: null
	        };
	        dataOfEighty.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	
	        initialValue += 15;
	      }
	      var data = [];
	      data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, referenceLine);
	
	      _this.setState({
	        dataPoints: data
	      }, function () {
	        _this.showGraph(); //Show chaptervise graph
	      });
	    };
	
	    _this.showGraph = function () {
	      var dataPoints = _this.state.dataPoints;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainer', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: Object.assign({}, _constant.canvasjsConfig.axisX, {
	          labelAngle: _this.state.labelAngle,
	          labelFontSize: _this.state.labelFontSize
	        }),
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        data: dataPoints,
	
	        dataPointMaxWidth: 60,
	        dataPointWidth: 60,
	        dataPointMinWidth: 60,
	        legend: {
	          fontSize: 18
	        },
	        interactivityEnabled: false
	      });
	
	      chart.render();
	    };
	
	    _this.state = {
	      token: '',
	      idname: '',
	      activeTabFlashcards: 1,
	      dataPointsOverAllGraph: [],
	      dataPoints: [],
	      totalQuestions: 0,
	      isLoading: true,
	      labelAngle: 0,
	      labelFontSize: 15,
	      scoreBoxSize: 5,
	      exam_name: '',
	      totalQuestionsChapterwise: 0,
	      dataOfCurrentUser: '',
	      dataOfEightyPercentileUser: '',
	      dataOfTwentyPercentileUser: '',
	      average: ''
	    };
	    return _this;
	  }
	
	  _createClass(CFA2CBTResult, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var w = window.innerWidth;
	      // const h = window.innerHeight;
	      if (w > 1200) {
	        this.setState({
	          labelAngle: 0,
	          labelFontSize: 15
	        });
	      } else if (w > 991 && w < 1200) {
	        this.setState({
	          labelAngle: -20,
	          labelFontSize: 12
	        });
	      } else if (w > 767 && w < 991) {
	        this.setState({
	          labelAngle: 90,
	          labelFontSize: 15
	        });
	      } else {
	        this.setState({
	          labelAngle: -90,
	          labelFontSize: 12
	        });
	      }
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        // eslint-disable-next-line
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        test_id: this.props.params.test_id // eslint-disable-next-line
	        ? parseInt(this.props.params.test_id) : null,
	        totalQuestion: this.props.params.totalQuestions // eslint-disable-next-line
	        ? parseInt(this.props.params.totalQuestions) : null,
	        // eslint-disable-next-line
	        timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
	        isNegative: this.props.params.isNegative
	      };
	
	      this.getGraphData(data);
	      this.getGraphoverAllGraphData(data);
	    }
	    // get data for overall graph
	    // myResize = () => {
	
	    //   }
	
	    // get data for chaptervise graph
	
	    //format data as requirement for overall graph
	
	    //Show overall graph
	
	    //Format data as requirement
	
	
	    // show graph chaptervise graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          dataOfCurrentUser = _state.dataOfCurrentUser,
	          dataOfEightyPercentileUser = _state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser = _state.dataOfTwentyPercentileUser,
	          totalQuestions = _state.totalQuestions,
	          activeTabFlashcards = _state.activeTabFlashcards,
	          average = _state.average,
	          exam_name = _state.exam_name;
	      var isLoading = this.state.isLoading;
	
	
	      return !isLoading ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'chart-graph-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().OVERALLRESULT
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              ' ',
	              _react2.default.createElement('div', { id: 'chartContainerOverAllGraph', className: 'js-chart-wrap' }),
	              _react2.default.createElement(
	                'ul',
	                { className: 'legend-wrapper' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'square-box' }),
	                  ' ',
	                  _language2.default.LC().SCOREBOX
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dash' }),
	                  ' ',
	                  _language2.default.LC().Percentile_20
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dots' }),
	                  ' ',
	                  _language2.default.LC().Percentile_80
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-normal' }),
	                  ' ',
	                  _language2.default.LC().YOURSCORE
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              _react2.default.createElement(
	                'div',
	                { className: ' graphData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfTwentyPercentileUser ? Math.ceil(dataOfTwentyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_20
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfEightyPercentileUser ? Math.ceil(dataOfEightyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_80
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(dataOfCurrentUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'score-box' }),
	                    ' ',
	                    '' + _language2.default.LC().YOURSCORE
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(average / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'average-box' }),
	                    ' ',
	                    _language2.default.LC().AVERAGE_SCORE
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: ' chart-graph-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().CFACHAPTERWISERESULT
	          ),
	          _react2.default.createElement('div', { id: 'chartContainer', className: 'js-chart-wrap' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'legend-wrapper' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'square-box' }),
	              ' ',
	              _language2.default.LC().SCOREBOX
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dash' }),
	              ' ',
	              _language2.default.LC().Percentile_20
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dots' }),
	              ' ',
	              _language2.default.LC().Percentile_80
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-normal' }),
	              _language2.default.LC().YOURSCORE
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-5' },
	            'Mean Score by Topic Area'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex header-card-dashboard tab-header-wrap mt-2' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'dashboard-card-header-tab' },
	              exam_name ? exam_name.map(function (exam, index) {
	                // console.log('exam --------------> ', exam, index);
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    onClick: function onClick() {
	                      _this3.flashcardTabToggle(index + 1);
	                    },
	                    className: activeTabFlashcards === index + 1 ? 'active' : ''
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    exam.chapterDetails['cfa2_chapter.chapter_name'] && exam.chapterDetails['cfa2_chapter.chapter_name'].length > 8 ? exam.chapterDetails['cfa2_chapter.chapter_name'].substring(0, 8) + '..' : exam.chapterDetails['cfa2_chapter.chapter_name']
	                  )
	                );
	              }) : null
	            )
	          ),
	          exam_name ? exam_name.map(function (exam, index) {
	            var x = void 0;
	
	            x = _this3.state.activeTabFlashcards === index + 1 ? _react2.default.createElement(
	              'div',
	              { className: 'card tab-body-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block dashboard-cards-scroll my-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'chart-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' graphData' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfTwentyPercentileUser ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_20
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfEightyPercentileUser ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_80
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfCurrentUser ? Math.ceil(exam.dataOfCurrentUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'score-box' }),
	                        ' ',
	                        '' + _language2.default.LC().YOURSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam && exam.chapterDetails && exam.chapterDetails.totalQuestions ? Math.ceil(exam.averageScore / exam.chapterDetails.totalQuestions * 100) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'average-box' }),
	                        ' ',
	                        _language2.default.LC().AVERAGE_SCORE
	                      )
	                    )
	                  )
	                )
	              )
	            ) : null;
	
	            return x;
	          }) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-2 text-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().DataDetail
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { id: 'chartContainer' },
	        _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return CFA2CBTResult;
	}(_react.Component);
	
	exports.default = CFA2CBTResult;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _constant = __webpack_require__(9);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBTMockExams = function (_Component) {
	  _inherits(CBTMockExams, _Component);
	
	  function CBTMockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTMockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExams.__proto__ || Object.getPrototypeOf(CBTMockExams)).call(this, props));
	
	    _this.getQuestions = function () {
	      _this.setState({
	        showInstructionModal: false,
	        isLoading: true
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, mockPackageAccess, isInArray_var, partnerSubscriptionCheck;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 13;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        mockPackageAccess = resp_exam.hasMockSubscription;
	                        isInArray_var = false;
	                        partnerSubscriptionCheck = _Cfa2Subscription4.default.checkCfa2Subscription;
	
	                        if (_this.props.location.pathname.includes('/cfa3/')) {
	                          partnerSubscriptionCheck = _Cfa3Subscription4.default.checkCfa3Subscription;
	                          selectedmen = 'cfa_3';
	                        }
	                        _context.next = 9;
	                        return partnerSubscriptionCheck(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 9:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var || mockPackageAccess) {
	                          _this._runCode('paid');
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 14;
	                        break;
	
	                      case 13:
	                        console.log('fail');
	
	                      case 14:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	            _this.setState({ subscriptionstatus: 'free' });
	            _this._runCode('free');
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                var subscriptionCheck = _Cfa2Subscription2.default.checkCfa2Subscription;
	                if (_this.props.location.pathname.includes('/cfa3/')) {
	                  subscriptionCheck = _Cfa3Subscription2.default.checkCfa3Subscription;
	                  selectedmen = 'cfa_3';
	                }
	                console.log('subscriptionCheck', subscriptionCheck);
	                isInArray_var = subscriptionCheck(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus) {
	      var timer = _this.state.timer,
	          id = _this.props.params.id;
	
	      if (subscriptionstatus === 'paid') {
	        var path = _this.introductionRoute.replace(':id', id).replace(':questiono', 1).replace(':timer', timer);
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function () {
	      _this.setState({
	        showInstructionModal: true
	        // mockData: mock,
	      });
	    };
	
	    _this.backToMock = function () {
	      _this.context.router.push({
	        pathname: _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT : _AppRoutes2.default.CFA2_2027_CBT
	      });
	    };
	
	    _this.deleteTest = function (id) {
	      var deletepopup = _this.state.deletepopup;
	
	      if (!deletepopup) {
	        _this.setState({
	          deleteId: id,
	          deletepopup: true
	        });
	      } else {
	        _this.setState({
	          deleteId: '',
	          deletepopup: false
	        });
	      }
	    };
	
	    _this.view = function (item) {
	      var viewRoute = _this.finishRoute;
	      if (item.status === 'non-graded') viewRoute = _AppRoutes2.default.CFA3_CBT_GRADE_QUESTIONS;
	      var timer = _this.state.timer,
	          id = _this.props.params.id;
	
	      var path = viewRoute.replace(':id', id).replace(':caseno', 1).replace(':questiono', 1).replace(':testid', item.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', timer);
	
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.deleteToggleDone = function () {
	      var deleteId = _this.state.deleteId;
	
	      var deleteData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: deleteId
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/deleteMock'), deleteData).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var data;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this.setState({
	                    deleteId: '',
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
	                    deletepopup: false
	                  });
	
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : ''
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getAllUsersStats'), data).then(function (resp) {
	                    if (resp.success) {
	                      _this.setState({
	                        ValidToken: true,
	                        mockList: resp.data,
	                        isLoading: false
	                        // userStatsData: resp.data,
	                      });
	                    } else {
	                      _this.setState({ ValidToken: false, isLoading: false });
	                    }
	                    return resp;
	                  });
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getMockNamebyId'), data).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              _this.setState({
	                                mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                              });
	
	                            case 1:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	
	                case 4:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.startTest = function () {
	      _this.setState({
	        startLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        status: 'pending'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getCFAMockCases'), data).then(function (caseResp) {
	        if (caseResp.success) {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getCFAMockQuestions'), data).then(function (resp) {
	            if (resp.success) {
	              _this.setState({
	                startLoading: true
	              });
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/addUsersChoice'), userData).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                  var timer, id, path;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (res.success) {
	                            timer = _this.state.timer, id = _this.props.params.id;
	                            path = _this.questionRoute.replace(':id', id).replace(':caseno', caseResp.question && caseResp.question.length ? caseResp.question[0].id : 1).replace(':questiono', resp.question && resp.question.length ? resp.question[0].id : 1).replace(':timer', timer).replace(':testid', res.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	
	                            _this.context.router.push({
	                              pathname: path
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	            }
	          });
	        }
	      });
	    };
	
	    _this.resumeTest = function (item) {
	      if (item.questions) {
	        var questionsData = JSON.parse(item.lastAnswered);
	        if (questionsData) {
	          var timer = _this.state.timer;
	
	          var path = _this.questionRoute.replace(':id', item.mock_id).replace(':caseno', questionsData.caseno).replace(':questiono', questionsData.questionId).replace(':timer', timer).replace(':testid', item.id).replace(':caseOffset', questionsData.caseOffset).replace(':quesOffset', questionsData.offset).replace(':isNegative', item.isNegative).replace(':timerStart', true);
	          _this.context.router.push({
	            pathname: path
	          });
	        }
	      } else {
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + _this.filePath + '/getCFAMockCases'), data).then(function (resp) {
	          if (resp.success) {
	            var _timer = _this.state.timer;
	
	            var _path = _this.questionRoute.replace(':id', item.mock_id).replace(':caseno', 1).replace(':questiono', 1).replace(':timer', _timer).replace(':testid', item.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	            _this.context.router.push({
	              pathname: _path
	            });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      mockName: '',
	      deletepopup: false,
	      deleteId: '',
	      totalQuestionCount: 1,
	      timer: _this.props.params.timer === 'undefined' ? 8100 : _this.props.params.timer
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.introductionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_2027_CBT_INTRODUCTION;
	    _this.filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams2027';
	    _this.questionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS : _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS;
	    _this.finishRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS_FINISH : _AppRoutes2.default.CFA2_2027_CBT_QUESTIONS_FINISH;
	    return _this;
	  }
	
	  _createClass(CBTMockExams, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        isLoading: false,
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	    //check CFA2 subscription
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                // console.log(
	                //   'I am on Frontendsrc\viewsCBTCFA2CBTNewViewAttemptedMocksindex.js'
	                // );
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname']
	                });
	                this.setState({
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: this.props.params.id ? parseInt(this.props.params.id) : ''
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + this.filePath + '/getAllUsersStats'), data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.data,
	                      isLoading: false
	                    });
	                  } else {
	                    _this3.setState({
	                      ValidToken: false,
	                      isLoading: false
	                    });
	                  }
	                  return resp;
	                });
	
	                // getTotalQuestionsCount
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + this.filePath + '/getTotalQuestionsCount'), data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      totalQuestionCount: resp.question
	                    });
	                  } else {
	                    // console.log('falure --------> ', resp);
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + ('/' + this.filePath + '/getMockNamebyId'), data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this3.setState({
	                              mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                            });
	
	                          case 1:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this3);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockName = _state.mockName,
	          deletepopup = _state.deletepopup,
	          totalQuestionCount = _state.totalQuestionCount,
	          timer = _state.timer;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper rem-left-pad' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'two-btn-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.startExam();
	                  }
	                },
	                _language2.default.LC().START
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                _language2.default.LC().CHANGE_MOCK
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: deletepopup, toggle: this.deleteTest, className: 'modal-primary' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteTest },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table table-remove-space' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '9%' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().DATE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TEST_COMPLETED_IN
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().STATUS
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList.length ? mockList.map(function (item, index) {
	                          var time = 0;
	                          console.log('timer', timer);
	                          if (item.isNegative === 'true') {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(timer) - item.user_time_value);
	                          } else {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(timer) + item.user_time_value);
	                          }
	                          console.log('time', time);
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'score-qnt' },
	                              item.score ? Math.ceil(item.score / totalQuestionCount * 100) + '%' : '0%'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.createdAt ? (0, _moment2.default)(item.createdAt).format('ll') : ''
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'clr-green' },
	                              time
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize mock-status' },
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                _language2.default.LC().Incomplete
	                              ) : item.status === 'non-graded' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                'Non Graded'
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status' },
	                                item.status
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              item.status === 'completed' || item.status === 'non-graded' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: {
	                                    padding: '0 6px 4px'
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().VIEW,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      return _this4.view(item);
	                                    },
	                                    className: 'fa fa-eye mark-action-btn-dashboard',
	                                    style: {
	                                      color: '#1f8ceb'
	                                    }
	                                  },
	                                  ' '
	                                )
	                              ) : null,
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: {
	                                    padding: '0 6px 4px'
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().RESUME
	                                ),
	                                _react2.default.createElement('i', {
	                                  className: 'fa fa-play-circle-o mark-action-btn-dashboard',
	                                  'aria-hidden': 'true',
	                                  style: {
	                                    color: '#000'
	                                  },
	                                  onClick: function onClick() {
	                                    _this4.resumeTest(item);
	                                  }
	                                })
	                              ) : null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: {
	                                    padding: '0 6px 4px'
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().DELETE,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      _this4.deleteTest(item.id);
	                                    },
	                                    className: 'fa fa-trash mark-action-btn-dashboard',
	                                    style: {
	                                      color: '#f51a00'
	                                    }
	                                  },
	                                  ' '
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '6', className: 'no-mocks' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '82px',
	                                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                { className: 'mt-1' },
	                                _language2.default.LC().NO_MOCK_EXAM_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBTMockExams;
	}(_react.Component);
	
	CBTMockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBTMockExams;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var ViewEssayQuestionChoices = function ViewEssayQuestionChoices(props) {
	  var _props$development_ju = props.development_justification,
	      development_justification = _props$development_ju === undefined ? '' : _props$development_ju,
	      setJustification = props.setJustification,
	      is_multiple = props.is_multiple,
	      is_development = props.is_development,
	      _props$justification = props.justification2,
	      justification2 = _props$justification === undefined ? '' : _props$justification,
	      _props$justification2 = props.justification1,
	      justification1 = _props$justification2 === undefined ? '' : _props$justification2,
	      userChoice = props.userChoice,
	      justification = props.justification,
	      disabledTextArea = props.disabledTextArea,
	      clickOption = props.clickOption,
	      selectedCaseQuestionData = props.selectedCaseQuestionData,
	      disabledChoices = props.disabledChoices;
	
	  var choices = [];
	  for (var objKey in props) {
	    if (objKey.includes('choice')) if (props[objKey]) choices.push(props[objKey]);
	  }console.log('userChoice[selectedCaseQuestionData.id]', userChoice[selectedCaseQuestionData.id]);
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    development_justification && development_justification.includes('&;') ? _react2.default.createElement(
	      _reactstrap.Col,
	      { className: ' rounded p-1', md: '12', xs: '12', sm: '12' },
	      _react2.default.createElement(
	        'b',
	        null,
	        development_justification.split('&;')[0].split(':')[0],
	        ' :'
	      ),
	      _react2.default.createElement('input', {
	        type: 'text',
	        className: 'border-0 w-50 view_questionhtml',
	        placeholder: 'Please write your answer'
	      })
	    ) : null,
	    choices.length || development_justification.includes('&;') ? _react2.default.createElement(
	      _reactstrap.Col,
	      { xs: '12', md: development_justification.includes('&;') ? '12' : '3' },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (development_justification.includes('&;') ? 'justify-content-around' : 'flex-column') + '  d-flex border ' + (is_multiple ? 'rounded mb-sm-1 mb-md-0' : '') + ' '
	        },
	        choices.map(function (choice, index) {
	          return _react2.default.createElement(
	            'div',
	            {
	              className: 'answer_box ' + (userChoice[selectedCaseQuestionData.id] === 'choice_' + String.fromCharCode(index + 97) ? 'border-yellow' : 'border-black')
	            },
	            _react2.default.createElement(
	              'p',
	              {
	                className: 'ans_box_text tooltip_wrap ml-0',
	                onClick: function onClick(e) {
	                  !disabledChoices && clickOption('choice_' + String.fromCharCode(index + 97), selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { 'class': 'no-selection', contenteditable: 'false' },
	                choice
	              )
	            )
	          );
	        })
	      )
	    ) : null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      {
	        xs: '12',
	        md: development_justification.includes('&;') || is_development && !choices.length ? '12' : '9 pl-md-0',
	        className: (development_justification.includes('&;') || is_development && !choices.length ? '' : '') + ' '
	      },
	      is_development ? is_multiple ? _react2.default.createElement('textarea', {
	        className: 'w-100 h-100 view_questionhtml',
	        placeholder: 'Write your justification here',
	        onChange: function onChange(e) {
	          setJustification(e);
	        },
	        disabled: disabledTextArea,
	        value: justification1 || justification[selectedCaseQuestionData.id] && justification[selectedCaseQuestionData.id]['justification1'] || '',
	        name: 'justification1'
	      }) : choices.length ? choices.map(function (choice, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'h-100p' },
	          _react2.default.createElement('textarea', {
	            placeholder: 'Write your justification here',
	            className: 'w-100 h-100 min-height-150 view_questionhtml',
	            onChange: function onChange(e) {
	              setJustification(e);
	            },
	            disabled: disabledTextArea,
	            value: props['justification' + (index + 1)] || justification[selectedCaseQuestionData.id] && justification[selectedCaseQuestionData.id]['justification' + (index + 1)] || '',
	            name: ['justification' + (index + 1)]
	          })
	        );
	      }) : _react2.default.createElement('textarea', {
	        className: 'w-100 h-100 min-height-150 view_questionhtml',
	        placeholder: 'Write your justification here',
	        onChange: function onChange(e) {
	          setJustification(e);
	        },
	        disabled: disabledTextArea,
	        value: justification1 || justification[selectedCaseQuestionData.id] && justification[selectedCaseQuestionData.id]['justification1'] || '',
	        name: 'justification1'
	      }) : null
	    )
	  );
	};
	
	exports.default = ViewEssayQuestionChoices;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ViewNormalAnswer(props) {
	  var loaderCSS = props.loaderCSS,
	      userChoice = props.userChoice,
	      selectedCaseQuestionData = props.selectedCaseQuestionData;
	
	  var currentQuestionChoice = userChoice && (userChoice[selectedCaseQuestionData.id] === selectedCaseQuestionData.answer || userChoice[selectedCaseQuestionData.id] === 'choice_' + selectedCaseQuestionData.answer);
	
	  var getFormattedAnswer = function getFormattedAnswer(answer) {
	    var choices = {
	      a: 'A',
	      b: 'B',
	      c: 'C',
	      d: 'D',
	      e: 'E'
	    };
	
	    var formattedAnswer = choices[answer] || ''; // Get the corresponding letter
	
	    return formattedAnswer + '.';
	  };
	  var answerText = selectedCaseQuestionData && selectedCaseQuestionData.answer ? _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + getFormattedAnswer(selectedCaseQuestionData.answer, true) : '';
	  return _react2.default.createElement(
	    'div',
	    { className: 'card show_block' },
	    _react2.default.createElement(
	      'div',
	      { className: 'main_loader ' + loaderCSS },
	      _react2.default.createElement(
	        'div',
	        { className: 'loader-mid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'card-header highlight_finish_text ' + (currentQuestionChoice ? 'text_success-cbt' : !userChoice[selectedCaseQuestionData.id] ? 'text_unAttempted-cbt' : 'text_failure-cbt')
	      },
	      currentQuestionChoice ? '' + _language2.default.LC().Correct : !userChoice[selectedCaseQuestionData.id] ? '' + _language2.default.LC().NOT_ATTEMPTED : '' + _language2.default.LC().Incorrect
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-block' },
	      (0, _function.renderHTMLContent)(selectedCaseQuestionData && selectedCaseQuestionData.answer ? _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + (selectedCaseQuestionData.answer === 'choice_a' || selectedCaseQuestionData.answer === 'a' ? '<strong>' + _language2.default.LC().A + '.</strong>' : selectedCaseQuestionData.answer === 'choice_b' || selectedCaseQuestionData.answer === 'b' ? '<strong>' + _language2.default.LC().B + '.</strong>' : selectedCaseQuestionData.answer === 'choice_c' || selectedCaseQuestionData.answer === 'c' ? '<strong>' + _language2.default.LC().C + '.</strong>' : '') : '', 'p', 'answer_text'),
	      (0, _function.renderHTMLContent)(selectedCaseQuestionData && selectedCaseQuestionData.explanation ? selectedCaseQuestionData.explanation : "", "p", "view_questionhtml", { contentEditable: false })
	    )
	  );
	}
	
	exports.default = ViewNormalAnswer;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ViewNormalQuestionChoices(props) {
	  var optionsArr = props.optionsArr,
	      userChoice = props.userChoice,
	      selectedCaseQuestionData = props.selectedCaseQuestionData;
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    ' ',
	    optionsArr.map(function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12', id: item, key: index },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'answer_box cursor-default ' + (userChoice ? selectedCaseQuestionData && (selectedCaseQuestionData.answer === item || item === 'choice_' + selectedCaseQuestionData.answer) && userChoice[selectedCaseQuestionData.id] === item ? 'border-green' : selectedCaseQuestionData.answer === item || item === 'choice_' + selectedCaseQuestionData.answer ? 'border-green' : userChoice[selectedCaseQuestionData.id] === item ? 'border-red' : '' : '')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'answer_count highlight_choice' },
	            item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'ans_box_text' },
	            selectedCaseQuestionData && selectedCaseQuestionData[item] ? (0, _function.renderHTMLContent)(selectedCaseQuestionData[item], "span", "", { contentEditable: false }) : null
	          )
	        )
	      );
	    })
	  );
	}
	
	exports.default = ViewNormalQuestionChoices;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactstrap = __webpack_require__(6);
	
	__webpack_require__(80);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _highlightText = __webpack_require__(56);
	
	var _ViewAnswer = __webpack_require__(182);
	
	var _ViewAnswer2 = _interopRequireDefault(_ViewAnswer);
	
	var _ViewEssayQuestionChoices = __webpack_require__(565);
	
	var _ViewEssayQuestionChoices2 = _interopRequireDefault(_ViewEssayQuestionChoices);
	
	var _ViewNormalAnswer = __webpack_require__(566);
	
	var _ViewNormalAnswer2 = _interopRequireDefault(_ViewNormalAnswer);
	
	var _ViewNormalQuestionChoices = __webpack_require__(567);
	
	var _ViewNormalQuestionChoices2 = _interopRequireDefault(_ViewNormalQuestionChoices);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var attemptedCaseArray = [];
	var longPressDuration = 450;
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: params.timer === 'undefined' || params.timer == undefined ? 8100 : parseInt(timer),
	
	      timer: params.timer === 'undefined' || params.timer == undefined ? 8100 : parseInt(timer),
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      readingViseScore: '',
	      report_block: 'card hide_block',
	      totalMaxGrading: 0,
	      disabledTextArea: true,
	      totalQuestionCount: 0
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    _this.isPathway = _this.props.location.pathname.includes(_AppRoutes2.default.CFA3_PATHWAY_CBT);
	    _this.finishTestRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS_FINISH : _AppRoutes2.default.CFA3_CBT_QUESTIONS_FINISH;
	    _this.attemptedTestRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK : _AppRoutes2.default.CFA3_CBT_VIEW_ATTEMPTED_MOCK;
	    _this.detailsGraphRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_DETAILED_RESULT_GRAPH : _AppRoutes2.default.CFA3_CBT_DETAILED_RESULT_GRAPH;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this2 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.state.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        // '/cfa2cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart';
	        var _timer = this.state.timer;
	
	        var path = _AppRoutes2.default.CFA3_CBT_QUESTIONS.replace(':id', this.props.params.id).replace(':caseno', this.props.params.caseno).replace(':questiono', this.props.params.questiono).replace(':timer', _timer).replace(':testid', this.props.params.testid).replace(':caseOffset', this.props.params.caseOffset).replace(':quesOffset', this.props.params.quesOffset).replace(':isNegative', false).replace(':timerStart', timerStart);
	        this.context.router.push({
	          pathname: path
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.state.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserTimer', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          disabledTextArea = _state.disabledTextArea,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          vpCaseLoader = _state.vpCaseLoader,
	          questionLoader = _state.questionLoader,
	          rightanswercount = _state.rightanswercount,
	          outOfScore = _state.outOfScore,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData,
	          readingViseScore = _state.readingViseScore,
	          reportError = _state.reportError,
	          reportLoading = _state.reportLoading,
	          totalMaxGrading = _state.totalMaxGrading,
	          totalQuestionCount = _state.totalQuestionCount,
	          timer = _state.timer;
	
	      var userTime = 0;
	      var params = this.props.params;
	
	      if (userStatsData && userStatsData.user_time_value && timer) {
	        if (userStatsData.isNegative === 'true') {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(timer) - userStatsData.user_time_value);
	        } else {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(timer) + userStatsData.user_time_value);
	        }
	      }
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var justification = userStatsData && userStatsData.justification ? JSON.parse(userStatsData.justification) : '';
	      var usergrading = userStatsData && userStatsData.gradings ? JSON.parse(userStatsData.gradings) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var parseResult = Object.keys(userChoice).map(function (x) {
	        return parseInt(x, 10);
	      });
	      selectedQuestionData.cfa3_cbt_questions;
	      var count = 0;
	      parseResult.forEach(function (element) {
	        var attemptedCount = questionsData.filter(function (item) {
	          if (item.id === element) {
	            count++;
	          }
	          return item.id === element;
	        });
	      });
	
	      var content = selectedQuestionData.question;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            {
	              className: casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'pointer_class btn-primary back-btn',
	                  onClick: this.handleGoBackToMock
	                },
	                _language2.default.LC().BACK
	              )
	            )
	          ) : _react2.default.createElement('div', null),
	          casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this3.slider = slider;
	                      }
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this3.changeCase(item.id, index);
	                          },
	                          className: (item.cfa3_cbt_questions.map(function (id) {
	                            return userChoice[id.id] ? true : false;
	                          }).indexOf(false) === -1 ? true : false ? '' : 'bg-completed-cases ') + '\n                              ' + (index === parseInt(_this3.props.params.caseOffset) ? 'active button-trial' : 'button-trial')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              isLoading ? _react2.default.createElement(
	                'div',
	                { className: 'loader-mid full_page' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block-loader' },
	                  _react2.default.createElement(_loader2.default, null)
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header d-flex justify-content-between qus-header' },
	                    selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                      'div',
	                      { className: 'ques-wrapper all-ques w-100' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex align-items-center justify-content-between' },
	                        _react2.default.createElement('div', { className: 'w-70px' }),
	                        (0, _function.renderHTMLContent)(selectedQuestionData.case_name, "h1", "text-center mb-2 text-capitalize"),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right que-action-arrow mb-2' },
	                          _react2.default.createElement('i', {
	                            className: this.props.params.caseOffset === '0' ? 'fa fa-angle-left ques_arrow pointer_class hide_block' : 'fa fa-angle-left ques_arrow pointer_class',
	                            onClick: this.getPreviousCase
	                          }),
	                          _react2.default.createElement('i', {
	                            className: parseInt(this.props.params.caseOffset) === casesData.length - 1 ? 'fa fa-angle-right ques_arrow pointer_class hide_block' : 'fa fa-angle-right ques_arrow pointer_class',
	                            onClick: this.getNextCase
	                          })
	                        )
	                      ),
	                      (0, _function.renderHTMLContent)(selectedQuestionData.case, "div", "font-weight-normal", { contentEditable: false })
	                    ) : null
	                  )
	                )
	              )
	            ),
	            isLoading ? '' :
	            // <div className='loader-mid full_page'>
	            //   <div className='card-block-loader'>
	            //     <Loader />
	            //   </div>
	            // </div>
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin_bottom_20 ml-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper height-0' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this3.slider = slider;
	                    }
	                  }),
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag && flag.length ? flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0] : '';
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this3.changeQuestion(item.id, index);
	                          },
	                          className: '\n                          ' + (index === parseInt(_this3.props.params.quesOffset) ? 'active' : '') + '\n                          ' + (item.question_type === 'essay_question' ? parseInt(item.max_grading) === parseInt(usergrading[item.id]) ? 'right-ans' : parseInt(usergrading[item.id]) === 0 ? 'wrong-ans' : parseInt(item.max_grading) > parseInt(usergrading[item.id]) ? 'intermediate-grading-answer' : 'not-ans' : userChoice[item.id] === item.answer || userChoice[item.id] === 'choice_' + item.answer ? 'right-ans' : userChoice[item.id] && userChoice[item.id] !== 'no_choice' ? 'wrong-ans' : 'not-ans') + '\n                          ' + (flaggedQuestions ? 'flag-add' : '') + '\n                          '
	                        },
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : '',
	                        index + 1
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-11 pr-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid full_page' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header qus-header finish-question-wrapper' },
	                    selectedCaseQuestionData && selectedCaseQuestionData.question ? _react2.default.createElement(
	                      'div',
	                      { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_right_20',
	                          alt: '',
	                          width: '30'
	                        }),
	                        'Q.',
	                        parseInt(this.props.params.quesOffset) + 1
	                      ),
	                      (0, _function.renderHTMLContent)(selectedCaseQuestionData.question, "div", "qus-title w-100", { style: { marginTop: "8px" } })
	                    ) : null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'btn btn-primary pointer_class mid-btn',
	                          onClick: function onClick() {
	                            _this3.setState({
	                              showSectionReview: true
	                            });
	                            _this3.getReadingViseScore();
	                          }
	                        },
	                        _language2.default.LC().SCORE
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_MYSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap tooltip_wrap_margin' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: (rightanswercount ? rightanswercount : 0) === 0 ? true : false,
	                          className: (rightanswercount ? rightanswercount : 0) === 0 ? 'cursor_not_Allowed btn btn-primary  mid-btn' : 'btn btn-primary mid-btn',
	                          onClick: function onClick() {
	                            return _this3.getDetailedResultGraph(totalQuestionCount);
	                          }
	                        },
	                        _language2.default.LC().GRAPH
	                      ),
	                      rightanswercount ? rightanswercount === 0 ? null : _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_GRAPH
	                      ) : null
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        selectedCaseQuestionData && selectedCaseQuestionData.question_type === 'essay_question' ? _react2.default.createElement(_ViewEssayQuestionChoices2.default, Object.assign({}, this.state, selectedCaseQuestionData, {
	                          selectedCaseQuestionData: selectedCaseQuestionData,
	                          userChoice: userChoice,
	                          justification: justification,
	                          disabledTextArea: disabledTextArea
	                        })) : _react2.default.createElement(_ViewNormalQuestionChoices2.default, {
	                          optionsArr: _constant.optionsArr,
	                          userChoice: userChoice,
	                          selectedCaseQuestionData: selectedCaseQuestionData,
	                          questiono: this.props.params.questiono
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'score-wrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'score-inner-cfa3' },
	                            rightanswercount ? rightanswercount : 0,
	                            '/',
	                            totalMaxGrading
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().You_Scored,
	                            ' ',
	                            Math.ceil((1 ? rightanswercount * 100 : 0) / totalMaxGrading),
	                            '%'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer finished-time' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              _language2.default.LC().TEST_COMPLETED_IN
	                            ),
	                            _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'timer_box' },
	                              userTime
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper quiz-submit-block' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'up tooltip-hover-questions quiz-flag' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              ' ',
	                              _language2.default.LC().REPORT_THIS_QUESTION,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'report-icon-wrapper',
	                                onClick: function onClick() {
	                                  _this3.handleScroll();
	                                  _this3.setState({
	                                    report_block: 'card show_block'
	                                  });
	                                }
	                              },
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/report4.png',
	                                alt: 'report'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this3.getPreviousQuestion(_this3.props.params.quesOffset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.quesOffset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this3.getNextQuestion(_this3.props.params.quesOffset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            selectedCaseQuestionData && selectedCaseQuestionData.question_type === 'essay_question' ? _react2.default.createElement(_ViewAnswer2.default, Object.assign({}, selectedCaseQuestionData, {
	              handleChange: this.handleChange,
	              selectedChoice: userChoice[selectedCaseQuestionData.id] && selectedCaseQuestionData[userChoice[selectedCaseQuestionData.id]] || '',
	              userGrading: this.state.userGrading || usergrading[selectedCaseQuestionData.id] || '',
	              disabled: true
	            })) : _react2.default.createElement(_ViewNormalAnswer2.default, {
	              loaderCSS: this.state.display_main_loader,
	              userChoice: userChoice,
	              selectedCaseQuestionData: selectedCaseQuestionData,
	              questiono: this.props.params.questiono
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'error_text ml-1' },
	                        ' ',
	                        reportError
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: function onClick() {
	                              return _this3.reportQuestion(selectedQuestionData.id);
	                            }
	                          },
	                          reportLoading ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                            ' ',
	                            _language2.default.LC().PLEASE_WAIT
	                          ) : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: function onClick() {
	                              return _this3._hideReportForm();
	                            }
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: function onClick() {
	                              _this3.setState({
	                                report_block: 'card hide_block',
	                                successAlert: false
	                              });
	                            }
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'loader-mid full_page' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block-loader' },
	              _react2.default.createElement(_loader2.default, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'sidebar-review-wrapper sidebar-score-wrapper ' + (showSectionReview ? 'active' : '')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              ' ',
	              _language2.default.LC().TOPIC_WISE_SCORE
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'cursor-pointer',
	                onClick: function onClick() {
	                  _this3.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'score-list-wrapper' },
	              readingViseScore && readingViseScore.length ? readingViseScore.map(function (item, index) {
	                var userGradingOfCurrentChapter = item.questionUserGrading || 0;
	                var readingPercentage = userGradingOfCurrentChapter * 100 / (item.cfa3_cbt_questions && item.cfa3_cbt_questions[0].questionMaxGrading) || 0;
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      item.chapter_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress custom-prog-bar margin_top_5' },
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'progress-bar',
	                          role: 'progressbar',
	                          style: {
	                            width: Math.ceil(readingPercentage) + '%'
	                          },
	                          'aria-valuenow': '' + Math.ceil(readingPercentage),
	                          'aria-valuemin': '0',
	                          'aria-valuemax': '100'
	                        },
	                        Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0,
	                        '%'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'score-inner' },
	                    item.questionUserGrading ? item.questionUserGrading : 0,
	                    '/',
	                    item.cfa3_cbt_questions ? item.cfa3_cbt_questions[0].questionMaxGrading : 0
	                  )
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-qus-found no-mock-exam mt-5' },
	                _react2.default.createElement('img', {
	                  width: '62px',
	                  src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'mt-1' },
	                  _language2.default.LC().NO_SCORE_FOUND
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this3.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this3.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this3.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this3.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this3.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this3.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.componentDidUpdate = function (prevProps) {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    if (prevProps.params.caseOffset !== _this4.props.params.caseOffset || prevProps.params.quesOffset !== _this4.props.params.quesOffset) {
	      var _props$params = _this4.props.params,
	          id = _props$params.id,
	          testid = _props$params.testid;
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: id ? parseInt(id) : null,
	        test_id: testid
	      };
	      _this4.getCases(data);
	      _this4.getUserStats();
	      _this4.getFlagQuestions();
	    }
	  };
	
	  this.getFlagQuestions = function () {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var data = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	      test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getflaggedQuestions', data).then(function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (res) {
	                  _this4.setState({ flag: res.data });
	                }
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }());
	  };
	
	  this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	    var storage_session, _props$params2, id, testid, data;
	
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            window.scrollTo(0, 0);
	            storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	            _this4.setState({
	              token: storage_session['token'],
	              idname: storage_session['idname']
	            });
	            _props$params2 = _this4.props.params, id = _props$params2.id, testid = _props$params2.testid;
	            data = {
	              token: storage_session['token'],
	              idname: storage_session['idname'],
	              mock_id: id ? parseInt(id) : null,
	              test_id: testid
	            };
	
	            _this4.getCases(data);
	            _this4.getUserStats();
	            _this4.getFlagQuestions();
	
	            if (params.timerStart === 'true') {
	              _this4.timer = setInterval(_this4.countDown, 1000);
	            } else {
	              clearInterval(_this4.timer);
	            }
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getMockNamebyId', data).then(function () {
	              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        _context3.next = 2;
	                        return _this4.getTotalQuestionsCount(data);
	
	                      case 2:
	                        _context3.next = 4;
	                        return _this4.getrightanswer();
	
	                      case 4:
	                        _this4.setState({
	                          mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                        });
	
	                      case 5:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this4);
	              }));
	
	              return function (_x3) {
	                return _ref4.apply(this, arguments);
	              };
	            }());
	
	          case 10:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, _this4);
	  }));
	
	  this.getDetailedResultGraph = function (totalQuestion) {
	    var _props$params3 = _this4.props.params,
	        id = _props$params3.id,
	        testid = _props$params3.testid,
	        timer = _props$params3.timer,
	        _state2 = _this4.state,
	        isNegative = _state2.isNegative,
	        totalMaxGrading = _state2.totalMaxGrading;
	
	    var path = _this4.detailsGraphRoute.replace(':id', id).replace(':test_id', testid).replace(':totalQuestions', totalQuestion).replace(':totalMarks', totalMaxGrading).replace(':timer', timer).replace(':isNegative', isNegative);
	    _this4.context.router.push({
	      pathname: path
	    });
	  };
	
	  this.getCases = function (data) {
	    _this4.setState({
	      display_main_loader: 'show_block z-index-1000 bg-white',
	      vpCaseLoader: true,
	      questionLoader: true
	    });
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + (_this4.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams') + '/getCFAMockCases', data).then(function (resp) {
	      if (resp.success) {
	        if (resp.question && resp.question.length) {
	          _this4.setState(Object.assign({
	            casesData: resp.question,
	            isLoading: false,
	            isDataLoading: false,
	            vpCaseLoader: false,
	            questionLoader: false
	          }, _this4.isPathway && { totalQuestionCount: resp.data && resp.data.length }, {
	            display_main_loader: 'hide_block',
	            //selected case
	            selectedQuestionData: resp.question[_this4.props.params.caseOffset],
	            //all questions of selected case
	            questionsData: resp.question[_this4.props.params.caseOffset] && resp.question[_this4.props.params.caseOffset].cfa3_cbt_questions ? resp.question[_this4.props.params.caseOffset].cfa3_cbt_questions : [],
	            //1st question of selected case
	            selectedCaseQuestionData: resp.question[_this4.props.params.caseOffset] && resp.question[_this4.props.params.caseOffset].cfa3_cbt_questions && resp.question[_this4.props.params.caseOffset].cfa3_cbt_questions[_this4.props.params.quesOffset] ? resp.question[_this4.props.params.caseOffset].cfa3_cbt_questions[_this4.props.params.quesOffset] : []
	          }));
	        } else {
	          // success:true but no cases returned — still clear the loader so
	          // the user sees an empty state instead of an infinite spinner.
	          _this4.setState({
	            casesData: [],
	            questionsData: [],
	            selectedQuestionData: null,
	            selectedCaseQuestionData: null,
	            isLoading: false,
	            isDataLoading: false,
	            vpCaseLoader: false,
	            questionLoader: false,
	            display_main_loader: 'hide_block'
	          });
	        }
	      } else {
	        _this4.setState({
	          isLoading: false,
	          isDataLoading: false,
	          vpCaseLoader: false,
	          questionLoader: false,
	          display_main_loader: 'hide_block'
	        });
	      }
	    });
	  };
	
	  this.changeCase = function (questionNumber, index) {
	    var casesData = _this4.state.casesData;
	
	    _this4.getUserStats();
	    // this.getFlagQuestions();
	    _this4.setState({
	      isLoading: true
	    });
	    var props = _this4.props,
	        state = _this4.state;
	    var token = state.token,
	        idname = state.idname;
	    var _props$params4 = props.params,
	        _props$params4$id = _props$params4.id,
	        id = _props$params4$id === undefined ? 0 : _props$params4$id,
	        caseOffset = _props$params4.caseOffset,
	        testid = _props$params4.testid,
	        timer = _props$params4.timer;
	
	    var data = {
	      token: token,
	      idname: idname,
	      mock_id: parseInt(id, 10)
	    };
	    if (questionNumber) {
	      var path = _this4.finishTestRoute.replace(':id', id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(caseOffset)] && casesData[parseInt(caseOffset)].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset)].cfa3_cbt_questions[0].id : 1).replace(':testid', testid).replace(':caseOffset', index).replace(':quesOffset', 0).replace(':timer', timer);
	      _this4.context.router.push({
	        pathname: path
	      }
	      // this.getCases(data)
	      );
	    }
	  };
	
	  this.getUserStats = function () {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var _props$params5 = _this4.props.params,
	        id = _props$params5.id,
	        testid = _props$params5.testid;
	
	    var data = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	      mock_id: id ? parseInt(id) : null,
	      id: testid ? parseInt(testid) : null
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then(function (resp) {
	      if (resp.success) {
	        var _timer2 = _this4.state.timer;
	        var _resp$data = resp.data,
	            user_time_value = _resp$data.user_time_value,
	            isNegative = _resp$data.isNegative,
	            pathway_id = _resp$data.pathway_id,
	            session_id = _resp$data.session_id,
	            attemptedCases = _resp$data.attemptedCases;
	
	        _this4.setState({
	          userStatsData: resp.data,
	          seconds: user_time_value ? user_time_value : parseInt(_timer2),
	          isNegative: isNegative,
	          pathwayId: pathway_id,
	          sessionId: session_id
	        });
	
	        attemptedCaseArray = attemptedCases != null ? JSON.parse(attemptedCases) : [];
	      } else {
	        _this4.setState({
	          isLoading: false
	        });
	      }
	    });
	  };
	
	  this.changeQuestion = function (questionNumber, index) {
	    _this4.setState({ report_block: 'card hide_block', successAlert: false });
	    _this4.getUserStats();
	    if (questionNumber) {
	      var _timer3 = _this4.state.timer;
	      var _props$params6 = _this4.props.params,
	          id = _props$params6.id,
	          caseno = _props$params6.caseno,
	          testid = _props$params6.testid,
	          caseOffset = _props$params6.caseOffset;
	
	      var path = _this4.finishTestRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questionNumber).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', index).replace(':timer', _timer3);
	      _this4.context.router.push({
	        pathname: path
	      });
	    }
	  };
	
	  this.getNextCase = function () {
	    var casesData = _this4.state.casesData;
	
	    _this4.setState({
	      isLoading: true
	    });
	    _this4.slider.slickGoTo(3);
	    var timer = _this4.state.timer;
	    var _props$params7 = _this4.props.params,
	        id = _props$params7.id,
	        testid = _props$params7.testid,
	        caseOffset = _props$params7.caseOffset;
	
	    var path = _this4.finishTestRoute.replace(':id', id).replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(caseOffset) + 1] && casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0].id : 1).replace(':testid', testid).replace(':caseOffset', caseOffset ? parseInt(caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':timer', timer);
	
	    _this4.context.router.push({
	      pathname: path
	    });
	  };
	
	  this.getPreviousCase = function () {
	    var _state3 = _this4.state,
	        casesData = _state3.casesData,
	        timer = _state3.timer;
	
	
	    _this4.setState({
	      isLoading: true
	    });
	    _this4.slider.slickGoTo(3 - 2);
	
	    var path = _this4.finishTestRoute.replace(':id', _this4.props.params.id).replace(':caseno', _this4.props.params.caseOffset ? casesData[parseInt(_this4.props.params.caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(_this4.props.params.caseOffset) - 1] && casesData[parseInt(_this4.props.params.caseOffset) - 1].cfa3_cbt_questions[0] ? casesData[parseInt(_this4.props.params.caseOffset) - 1].cfa3_cbt_questions[0].id : 1).replace(':testid', _this4.props.params.testid).replace(':caseOffset', _this4.props.params.caseOffset ? parseInt(_this4.props.params.caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':timer', timer);
	    _this4.context.router.push({
	      pathname: path
	    });
	  };
	
	  this.getPreviousQuestion = function (index) {
	    var questionsData = _this4.state.questionsData;
	    var _props$params8 = _this4.props.params,
	        id = _props$params8.id,
	        caseOffset = _props$params8.caseOffset,
	        quesOffset = _props$params8.quesOffset,
	        testid = _props$params8.testid,
	        timer = _props$params8.timer;
	
	    var path = _this4.finishTestRoute.replace(':id', id).replace(':caseno', caseOffset).replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) - 1].id : 1).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset ? parseInt(quesOffset) - 1 : 1).replace(':timer', timer);
	    _this4.context.router.push({
	      pathname: path
	    });
	  };
	
	  this.getNextQuestion = function (index) {
	    var questionsData = _this4.state.questionsData;
	    var _props$params9 = _this4.props.params,
	        id = _props$params9.id,
	        timer = _props$params9.timer,
	        caseOffset = _props$params9.caseOffset,
	        quesOffset = _props$params9.quesOffset,
	        testid = _props$params9.testid;
	
	    var path = _this4.finishTestRoute.replace(':id', id).replace(':caseno', caseOffset).replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) + 1].id : 1).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset ? parseInt(quesOffset) + 1 : 1).replace(':timer', timer);
	    _this4.context.router.push({
	      pathname: path
	    });
	  };
	
	  this.addHighlight = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(text) {
	      var storage_session, selectedQuestionData, data;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              selectedQuestionData = _this4.state.selectedQuestionData;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	                question_id: selectedQuestionData.id,
	                test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null,
	                type: 'highlight',
	                text: text
	              };
	              _context6.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/addHighlightedText', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          _this4.setState({ showPopover: false });
	                          _context5.next = 3;
	                          return _this4.getHighlightedText();
	
	                        case 3:
	                          (0, _highlightText.clearSelection)();
	
	                        case 4:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this4);
	                }));
	
	                return function (_x5) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this4);
	    }));
	
	    return function (_x4) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  this.deleteHighlight = function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(id) {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	                id: id
	              };
	
	              if (!id) {
	                _context8.next = 7;
	                break;
	              }
	
	              _context8.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/deleteHighlightedText', data).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          _this4.setState({ showPopover: false });
	                          _context7.next = 3;
	                          return _this4.getHighlightedText();
	
	                        case 3:
	                          (0, _highlightText.clearSelection)();
	
	                        case 4:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this4);
	                }));
	
	                return function (_x7) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	              _context8.next = 8;
	              break;
	
	            case 7:
	              return _context8.abrupt('return');
	
	            case 8:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this4);
	    }));
	
	    return function (_x6) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  this.getHighlightedText = function () {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var data = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	      mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	      question_id: _this4.props.params.questiono ? parseInt(_this4.props.params.questiono) : null,
	      test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getHighlightedText', data).then(function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _this4.setState({
	                  highlights: res.questions
	                });
	
	              case 1:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this4);
	      }));
	
	      return function (_x8) {
	        return _ref9.apply(this, arguments);
	      };
	    }());
	  };
	
	  this.getMobileOperatingSystem = function () {
	    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	    //console.log('userAgent', userAgent);
	    // Windows Phone must come first because its UA also contains "Android"
	    if (/windows phone/i.test(userAgent)) {
	      return 'Windows Phone';
	    }
	
	    if (/android/i.test(userAgent)) {
	      return 'Android';
	    }
	
	    // iOS detection from: http://stackoverflow.com/a/9039885/177710
	    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	      return 'iOS';
	    }
	
	    return 'unknown';
	  };
	
	  this.clickOption = function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(choice, questionId, selectedQuestionData, e) {
	      var userData;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              //console.log('e. type ___________', e.type);
	              e.preventDefault();
	              // on left click
	              if (e.type === 'click') {
	                //console.log('Left click');
	                // console.log('Print params ---------> ', this.props.params);
	                userData = {
	                  token: _this4.state.token,
	                  idname: _this4.state.idname,
	                  mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	                  choice: choice,
	                  questionId: questionId,
	                  id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null,
	                  offset: _this4.props.params.quesOffset ? parseInt(_this4.props.params.quesOffset) : null,
	                  caseno: _this4.props.params.caseno ? parseInt(_this4.props.params.caseno) : null,
	                  caseOffset: _this4.props.params.caseOffset ? parseInt(_this4.props.params.caseOffset) : null
	                };
	
	                _this4.updateSelectedChoice(userData, selectedQuestionData, choice);
	              } else if (e.type === 'contextmenu') {
	                //console.log('Right click');
	                //on right click
	                _this4.addStrikeThrough(choice);
	              }
	
	            case 2:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this4);
	    }));
	
	    return function (_x9, _x10, _x11, _x12) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	
	  this.addStrikeThrough = function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(choice) {
	      var selectedQuestionData, data;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              //console.log('inside call apiiiii', choice);
	              selectedQuestionData = _this4.state.selectedQuestionData;
	              data = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	                question_id: selectedQuestionData.id,
	                test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null,
	                choice: choice
	              };
	              _context12.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/addStrikeThrough', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          _context11.next = 2;
	                          return _this4.getStrikedText();
	
	                        case 2:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this4);
	                }));
	
	                return function (_x14) {
	                  return _ref12.apply(this, arguments);
	                };
	              }()
	              // clearSelection();
	              );
	
	            case 4:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this4);
	    }));
	
	    return function (_x13) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	
	  this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	    // console.log('userData --------------> ', userData);
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUsersChoice', userData).then(function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	        var ansData;
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                if (res.success) {
	                  ansData = {
	                    token: _this4.state.token,
	                    idname: _this4.state.idname,
	                    mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	                    question_id: selectedQuestionData.id,
	                    answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                    test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null,
	                    reading_id: selectedQuestionData.chapter_id
	                  };
	
	                  _this4.getUserStats();
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserAnswer', ansData).then(function () {
	                    var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	                      return _regenerator2.default.wrap(function _callee13$(_context13) {
	                        while (1) {
	                          switch (_context13.prev = _context13.next) {
	                            case 0:
	                            case 'end':
	                              return _context13.stop();
	                          }
	                        }
	                      }, _callee13, _this4);
	                    }));
	
	                    return function (_x16) {
	                      return _ref14.apply(this, arguments);
	                    };
	                  }());
	                }
	
	              case 1:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this4);
	      }));
	
	      return function (_x15) {
	        return _ref13.apply(this, arguments);
	      };
	    }());
	  };
	
	  this.updateUserScore = function (score, test_id, mock_id) {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var ansdata = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	      mock_id: mock_id,
	      score: score,
	      id: test_id
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserScore', ansdata).then(function (resp_count) {});
	  };
	
	  this.getTotalQuestionsCount = function (data) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getTotalQuestionsCount', data).then(function (resp) {
	      if (resp.success && resp.totalQuestionsCount > 0) {
	        _this4.setState({
	          totalQuestionCount: resp.totalQuestionsCount
	        });
	      } else {
	        // console.log('falure --------> ', resp);
	      }
	    });
	  };
	
	  this.getrightanswer = function () {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var ansdata = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	      mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	      test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/totalCount', ansdata).then(function (resp_count) {
	      if (resp_count.success) {
	        var totalUserGrading = resp_count.totalUserGrading,
	            totalMaxGrading = resp_count.totalMaxGrading;
	
	        _this4.setState({
	          rightanswercount: totalUserGrading,
	          totalMaxGrading: totalMaxGrading
	        });
	        _this4.updateUserScore(totalUserGrading, _this4.props.params.testid, _this4.props.params.id);
	      } else {
	        // console.log(resp_count.success + '------------failure');
	      }
	    });
	  };
	
	  this.handleScroll = function () {
	    window.scroll({
	      top: document.body.offsetHeight,
	      left: 0,
	      behavior: 'smooth'
	    });
	  };
	
	  this.changeFilter = function (e, type) {
	    var target = e.target;
	    var checked = target.checked;
	    var filter = _this4.state.filter;
	
	    if (checked) {
	      var temp = [].concat(_toConsumableArray(filter));
	      temp.push(type);
	      _this4.setState({
	        filter: temp
	      });
	    } else {
	      // to uncheck elements
	      var prevArray = filter.filter(function (item) {
	        return item !== type;
	      });
	      _this4.setState({
	        filter: prevArray
	      });
	    }
	  };
	
	  this.finishTest = function () {
	    var _state4 = _this4.state,
	        flag = _state4.flag,
	        userStatsData = _state4.userStatsData,
	        questionsData = _state4.questionsData;
	
	    var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	    if (flag && flag.length) {
	      _this4.setState({
	        showFlaggedPopup: true
	      });
	    } else if (Object.keys(userChoice).length !== questionsData.length) {
	      _this4.setState({
	        showNonAttemptedPopup: true
	      });
	    } else {
	      _this4.setState({ showFinishTestPopup: true });
	    }
	
	    //api to update status of quiz
	    var data = {
	      token: _this4.state.token,
	      idname: _this4.state.idname,
	      mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	      id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null,
	      status: 'completed'
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserQuizStatus', data).then(function () {
	      var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                if (res.success) {}
	
	              case 1:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this4);
	      }));
	
	      return function (_x17) {
	        return _ref15.apply(this, arguments);
	      };
	    }());
	  };
	
	  this.addHighlightToText = function () {
	    var text = _this4.getSelectionHtml();
	    _this4.addHighlight(text);
	  };
	
	  this.deleteHighlightFromText = function () {
	    var text = _this4.getSelectionHtml();
	
	    var highlights = _this4.state.highlights;
	
	    var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	      return item.text === text;
	    })[0] : [];
	
	    _this4.deleteHighlight(getHighlightedTextData.id);
	  };
	
	  this.getStrikedText = function () {
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var data = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	      mock_id: _this4.props.params.id ? parseInt(_this4.props.params.id) : null,
	      question_id: _this4.props.params.questiono ? parseInt(_this4.props.params.questiono) : null,
	      test_id: _this4.props.params.testid ? parseInt(_this4.props.params.testid) : null
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getStrikedText', data).then(function () {
	      var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	        return _regenerator2.default.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                if (res && res.questions) {
	                  _this4.setState({
	                    strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                  });
	                } else {
	                  _this4.setState({
	                    strikeThroughArr: []
	                  });
	                }
	
	              case 1:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this4);
	      }));
	
	      return function (_x18) {
	        return _ref16.apply(this, arguments);
	      };
	    }());
	  };
	
	  this.getSelectionHtml = function () {
	    var html = '';
	    if (typeof window.getSelection != 'undefined') {
	      var sel = window.getSelection();
	      //console.log('heyyyyyyyyyyyyyyyy', sel);
	      if (sel.rangeCount) {
	        var container = document.createElement('div');
	        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	          container.appendChild(sel.getRangeAt(i).cloneContents());
	        }
	        html = container.innerHTML;
	      }
	    } else if (typeof document.selection != 'undefined') {
	      if (document.selection.type == 'Text') {
	        html = document.selection.createRange().htmlText;
	      }
	    }
	    return html;
	  };
	
	  this.onTouchStart = function (e, choice) {
	    e.preventDefault();
	    // console.log(' window.navigator', window.navigator);
	    var data = _this4.getMobileOperatingSystem();
	    //console.log('datadata', data);
	    if (data === 'Android') {
	      return;
	    } else {
	      _this4.longPressCountdown = setTimeout(function () {
	        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	        _this4.addStrikeThrough(choice);
	      }, longPressDuration);
	    }
	  };
	
	  this.onTouchMove = function (e) {
	    clearTimeout(_this4.longPressCountdown);
	  };
	
	  this.onTouchCancel = function (e) {
	    clearTimeout(_this4.longPressCountdown);
	  };
	
	  this.onTouchEnd = function (e) {
	    clearTimeout(_this4.longPressCountdown);
	  };
	
	  this.handleGoBackToMock = function () {
	    var _props$params10 = _this4.props.params,
	        timer = _props$params10.timer,
	        id = _props$params10.id;
	    var _state5 = _this4.state,
	        sessionId = _state5.sessionId,
	        pathwayId = _state5.pathwayId;
	
	    var path = _this4.attemptedTestRoute.replace(':id', id).replace(':timer', timer).replace(':session', sessionId).replace(':pathway', pathwayId);
	    _this4.context.router.push({
	      pathname: path
	    });
	  };
	
	  this.getReadingViseScore = function () {
	    var _props$params11 = _this4.props.params,
	        id = _props$params11.id,
	        testid = _props$params11.testid;
	    var _state6 = _this4.state,
	        token = _state6.token,
	        idname = _state6.idname;
	
	    var data = {
	      token: token,
	      idname: idname,
	      mock_id: id ? parseInt(id) : null,
	      test_id: testid ? parseInt(testid) : null
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + (_this4.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams') + '/getrightAnswerReadingVise', data).then(function () {
	      var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	        var arr;
	        return _regenerator2.default.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                arr = res.questionCount.map(function (t1) {
	                  return Object.assign({}, t1, res.attemptedQuestion.find(function (t2) {
	                    return (_this4.isPathway ? t2.cfa3_2025_chapter.id : t2.cfa3_chapter.id) === t1.id;
	                  }));
	                });
	
	                _this4.setState({
	                  readingViseScore: arr
	                });
	
	              case 2:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this4);
	      }));
	
	      return function (_x19) {
	        return _ref17.apply(this, arguments);
	      };
	    }());
	  };
	
	  this._hideReportForm = function () {
	    document.getElementById('comment').value = '';
	    _this4.setState({ report_block: 'card hide_block', reportError: '' });
	  };
	
	  this.reportQuestion = function () {
	    var comment = document.getElementById('comment').value;
	
	    _this4.setState({
	      reportError: ''
	    });
	    if (comment.length < 2) {
	      _this4.setState({
	        reportError: 'Please enter comment'
	      });
	      return;
	    }
	    var _props$params12 = _this4.props.params,
	        timer = _props$params12.timer,
	        caseno = _props$params12.caseno,
	        questiono = _props$params12.questiono,
	        offset = _props$params12.offset,
	        id = _props$params12.id,
	        testid = _props$params12.testid,
	        quesOffset = _props$params12.quesOffset,
	        caseOffset = _props$params12.caseOffset;
	    // BUG FIX: `questiono` is the position param from the URL (1, 2, 3, …
	    // within a case), NOT the cbt_pathway_questions / cfa3_cbt_questions
	    // primary key. Saving it as `question_id` broke the admin-side join
	    // (`item.cbt_pathway_question` came back null, so the auto-reply payload
	    // had an empty `reported_item`). Use the loaded row's actual `.id` —
	    // which is what the sibling save/answer calls in this file already
	    // use (e.g. lines ~415, 523, 548).
	
	    var _state7 = _this4.state,
	        selectedCaseQuestionData = _state7.selectedCaseQuestionData,
	        selectedQuestionData = _state7.selectedQuestionData;
	
	    var realQuestionId = selectedCaseQuestionData && selectedCaseQuestionData.id || selectedQuestionData && selectedQuestionData.id || (questiono ? parseInt(questiono) : null);
	
	    var data = {
	      case_id: caseno ? parseInt(caseno) : null,
	      token: _this4.state.token,
	      idname: _this4.state.idname,
	      question_id: realQuestionId,
	      isEssayQuestion: selectedCaseQuestionData && selectedCaseQuestionData.question_type === 'essay_question' ? 1 : 0,
	      comment: comment,
	      offset: offset ? parseInt(offset) : 0,
	      mock_id: id ? parseInt(id) : 0,
	      type: !id ? 'pathway' : 'mock',
	      timer: timer ? parseInt(timer) : 0,
	      test_id: testid ? parseInt(testid) : 0,
	      mockName: _this4.state.mockName,
	      quesOffset: quesOffset ? parseInt(quesOffset) : 0,
	      caseOffset: caseOffset ? parseInt(caseOffset) : 0
	    };
	
	    _this4.setState({
	      reportLoading: true
	    });
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/reportQuestion', data).then(function (resp) {
	      if (resp.success) {
	        _this4.setState({
	          ValidToken: true,
	          successAlert: true,
	          reportLoading: false
	        });
	        document.getElementById('comment').value = '';
	      } else {
	        _this4.setState({ ValidToken: false });
	      }
	      return resp;
	    });
	  };
	};
	
	exports.default = CFAQuestions;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactstrap = __webpack_require__(6);
	
	__webpack_require__(80);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _constant = __webpack_require__(9);
	
	var _highlightText = __webpack_require__(56);
	
	var _ViewAnswer = __webpack_require__(182);
	
	var _ViewAnswer2 = _interopRequireDefault(_ViewAnswer);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ViewEssayQuestions = __webpack_require__(265);
	
	var _ViewEssayQuestions2 = _interopRequireDefault(_ViewEssayQuestions);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var longPressDuration = 450;
	// var attemptedGrading = [];
	
	var CFA3GradeQuestions = function (_Component) {
	  _inherits(CFA3GradeQuestions, _Component);
	
	  function CFA3GradeQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA3GradeQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFA3GradeQuestions.__proto__ || Object.getPrototypeOf(CFA3GradeQuestions)).call(this, props));
	
	    _this.componentDidUpdate = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(prevProps, prevState) {
	        var storage_session, _this$props$params, id, testid, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // console.log('prevState', prevState.casesData, prevState.userStatsData);
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (!(prevProps.params.caseOffset !== _this.props.params.caseOffset || prevProps.params.quesOffset !== _this.props.params.quesOffset)) {
	                  _context.next = 9;
	                  break;
	                }
	
	                _this$props$params = _this.props.params, id = _this$props$params.id, testid = _this$props$params.testid;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: id ? parseInt(id) : null,
	                  test_id: testid,
	                  type: 'essay_question'
	                };
	                _context.next = 6;
	                return _this.getGradingQuestions(data);
	
	              case 6:
	                _context.next = 8;
	                return _this.getUserStats();
	
	              case 8:
	                _this.getFlagQuestions();
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var storage_session, _this$props$params2, id, testid, data;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              _this$props$params2 = _this.props.params, id = _this$props$params2.id, testid = _this$props$params2.testid;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: id ? parseInt(id) : null,
	                test_id: testid,
	                type: 'essay_question'
	              };
	
	              _this.getGradingQuestions(data);
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getMockNamebyId', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                }));
	
	                return function (_x3) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	              _this.getFlagQuestions();
	
	            case 8:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.customizeCaseData = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getGradingQuestions', data).then(function (resp) {
	                  if (resp.success) {
	                    if (resp.question && resp.question.length) {
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then(function (resp) {
	                        _this.setState({
	                          isLoading: false,
	                          isDataLoading: false,
	                          vpCaseLoader: false,
	                          questionLoader: false,
	                          display_main_loader: 'hide_block'
	                        });
	                        var customizeCaseData = resp.question.map(function (r) {
	                          var tempArr = r.cfa3_cbt_questions.filter(function (c) {
	                            return keys.includes(c.id.toString());
	                          });
	                          if (tempArr.length) return Object.assign({}, r, { cfa3_cbt_questions: tempArr });
	                        }).filter(Boolean);
	
	                        _this.setState({
	                          casesData: customizeCaseData,
	                          selectedQuestionData: customizeCaseData[caseOffset],
	                          questionsData: customizeCaseData[caseOffset] && customizeCaseData[caseOffset].cfa3_cbt_questions ? customizeCaseData[caseOffset].cfa3_cbt_questions : [],
	                          selectedCaseQuestionData: customizeCaseData[caseOffset] && customizeCaseData[caseOffset].cfa3_cbt_questions && customizeCaseData[caseOffset].cfa3_cbt_questions[quesOffset] ? customizeCaseData[caseOffset].cfa3_cbt_questions[quesOffset] : []
	                        });
	                      });
	                    }
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.getGradingQuestions = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this.setState({
	                  display_main_loader: 'show_block z-index-1000 bg-white',
	                  vpCaseLoader: true,
	                  questionLoader: true
	                });
	                _fetchData2.default.callAPI('' + _App_data2.default.backend_api + (_this.isPathway ? '/cfa3PathwayExams/getCFAMockCases' : '/cfa3CBTMockExams/getGradingQuestions'), data).then(function (resp) {
	                  if (resp.success) {
	                    if (resp.question && resp.question.length) {
	                      _this.getHighlightedText();
	                      _this.getStrikedText();
	                      _this.getUserStats(resp.question);
	                    }
	                  } else {
	                    _this.setState({
	                      isLoading: false,
	                      isDataLoading: false
	                    });
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.changeCase = function (questionNumber, index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index + 1);
	      _this.getUserStats();
	      _this.setState({
	        isLoading: true
	      });
	      var _this$state = _this.state,
	          token = _this$state.token,
	          idname = _this$state.idname,
	          params = _this.props.params;
	      var id = params.id,
	          caseOffset = params.caseOffset,
	          timer = params.timer,
	          testid = params.testid,
	          timerStart = params.timerStart,
	          isNegative = params.isNegative;
	
	      var data = {
	        token: token,
	        idname: idname,
	        mock_id: id ? parseInt(id) : null,
	        test_id: testid,
	        type: 'essay_question'
	      };
	      if (questionNumber) {
	        var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(caseOffset)] && casesData[parseInt(caseOffset)].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset)].cfa3_cbt_questions[0].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', index).replace(':timerStart', timerStart).replace(':isNegative', isNegative).replace(':quesOffset', 0);
	        _this.setState({
	          userGrading: ''
	        });
	        _this.context.router.push({
	          pathname: pathname
	        }, _this.getGradingQuestions(data));
	      }
	    };
	
	    _this.getUserStats = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var essayQues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then(function (resp) {
	                if (resp.success) {
	                  var _this$props$params3 = _this.props.params,
	                      _quesOffset = _this$props$params3.quesOffset,
	                      _caseOffset = _this$props$params3.caseOffset;
	
	
	                  var usersJustifications = resp.data.justification ? JSON.parse(resp.data.justification) : {};
	                  var _keys = Object.keys(usersJustifications);
	                  if (essayQues.length) {
	                    var customizeCaseData = essayQues.map(function (r) {
	                      var tempArr = r.cfa3_cbt_questions.filter(function (c) {
	                        return _keys.includes(c.id.toString());
	                      });
	                      if (tempArr.length) return Object.assign({}, r, { cfa3_cbt_questions: tempArr });
	                    }).filter(Boolean);
	
	                    _this.setState({
	                      casesData: customizeCaseData,
	                      selectedQuestionData: customizeCaseData[_caseOffset],
	                      questionsData: customizeCaseData[_caseOffset] && customizeCaseData[_caseOffset].cfa3_cbt_questions ? customizeCaseData[_caseOffset].cfa3_cbt_questions : [],
	                      selectedCaseQuestionData: customizeCaseData[_caseOffset] && customizeCaseData[_caseOffset].cfa3_cbt_questions && customizeCaseData[_caseOffset].cfa3_cbt_questions[_quesOffset] ? customizeCaseData[_caseOffset].cfa3_cbt_questions[_quesOffset] : []
	                    });
	
	                    _this.setState({
	                      isLoading: false,
	                      isDataLoading: false,
	                      vpCaseLoader: false,
	                      questionLoader: false,
	                      display_main_loader: 'hide_block'
	                    });
	                  }
	
	                  _this.setState({
	                    userStatsData: resp.data,
	                    seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	                    isNegative: resp.data.isNegative,
	                    attemptedGrading: resp.data.attemptedGrading != null ? JSON.parse(resp.data.attemptedGrading) : []
	                  });
	                } else {
	                  _this.setState({
	                    isLoading: false
	                  });
	                }
	              });
	
	            case 3:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.changeQuestion = function (questionNumber, index) {
	      if (questionNumber) {
	        var _this$props$params4 = _this.props.params,
	            id = _this$props$params4.id,
	            caseno = _this$props$params4.caseno,
	            timer = _this$props$params4.timer,
	            testid = _this$props$params4.testid,
	            _caseOffset2 = _this$props$params4.caseOffset,
	            isNegative = _this$props$params4.isNegative,
	            timerStart = _this$props$params4.timerStart;
	
	        var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questionNumber).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', _caseOffset2).replace(':quesOffset', index).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	
	        _this.setState({
	          userGrading: ''
	        });
	        _this.context.router.push({
	          pathname: pathname
	        });
	      }
	    };
	
	    _this.getNextCase = function (index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index);
	      _this.setState({
	        isLoading: true
	      });
	      var _this$props$params5 = _this.props.params,
	          id = _this$props$params5.id,
	          timer = _this$props$params5.timer,
	          testid = _this$props$params5.testid,
	          caseOffset = _this$props$params5.caseOffset,
	          isNegative = _this$props$params5.isNegative,
	          timerStart = _this$props$params5.timerStart;
	
	      var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(caseOffset) + 1] && casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset ? parseInt(caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousCase = function (index) {
	      var casesData = _this.state.casesData;
	
	      _this.slider.slickGoTo(index - 2);
	      _this.setState({
	        isLoading: true
	      });
	      var _this$props$params6 = _this.props.params,
	          id = _this$props$params6.id,
	          timer = _this$props$params6.timer,
	          testid = _this$props$params6.testid,
	          caseOffset = _this$props$params6.caseOffset,
	          isNegative = _this$props$params6.isNegative,
	          timerStart = _this$props$params6.timerStart;
	
	      var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(caseOffset) - 1] && casesData[parseInt(caseOffset) - 1].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset) - 1].cfa3_cbt_questions[0].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset ? parseInt(caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({ userGrading: '' });
	      var _this$props$params7 = _this.props.params,
	          id = _this$props$params7.id,
	          quesOffset = _this$props$params7.quesOffset,
	          timer = _this$props$params7.timer,
	          testid = _this$props$params7.testid,
	          caseOffset = _this$props$params7.caseOffset,
	          isNegative = _this$props$params7.isNegative,
	          timerStart = _this$props$params7.timerStart;
	
	      var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseOffset).replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) - 1].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset ? parseInt(quesOffset) - 1 : 1).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getNextQuestion = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({ userGrading: '' });
	      var _this$props$params8 = _this.props.params,
	          id = _this$props$params8.id,
	          quesOffset = _this$props$params8.quesOffset,
	          timer = _this$props$params8.timer,
	          testid = _this$props$params8.testid,
	          caseOffset = _this$props$params8.caseOffset,
	          isNegative = _this$props$params8.isNegative,
	          timerStart = _this$props$params8.timerStart;
	
	      var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseOffset).replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) + 1].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset ? parseInt(quesOffset) + 1 : 1).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context8.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/addHighlightedText', data).then(function () {
	                  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context7.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this2);
	                  }));
	
	                  return function (_x8) {
	                    return _ref8.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context10.next = 7;
	                  break;
	                }
	
	                _context10.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/deleteHighlightedText', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context9.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x10) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context10.next = 8;
	                break;
	
	              case 7:
	                return _context10.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x9) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getHighlightedText', data).then(function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	          return _regenerator2.default.wrap(function _callee11$(_context11) {
	            while (1) {
	              switch (_context11.prev = _context11.next) {
	                case 0:
	                  // console.log('highlights ---------> ', res.questions);
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context11.stop();
	              }
	            }
	          }, _callee11, _this2);
	        }));
	
	        return function (_x11) {
	          return _ref11.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.setJustification = function (e, index) {
	      var _this$setState;
	
	      console.log('e', e.target.name);
	      var _e$target = e.target,
	          value = _e$target.value,
	          name = _e$target.name;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'displayError', false), _this$setState));
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                console.log({ choice: choice, questionId: questionId, selectedQuestionData: selectedQuestionData });
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  // console.log('Print params ---------> ', this.props.params);
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : null,
	                    caseno: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	                    caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : null
	                    // attemptedCases: JSON.stringify(attemptedGrading),
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 3:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this2);
	      }));
	
	      return function (_x12, _x13, _x14, _x15) {
	        return _ref12.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context14.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/addStrikeThrough', data).then(function () {
	                  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	                    return _regenerator2.default.wrap(function _callee13$(_context13) {
	                      while (1) {
	                        switch (_context13.prev = _context13.next) {
	                          case 0:
	                            _context13.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context13.stop();
	                        }
	                      }
	                    }, _callee13, _this2);
	                  }));
	
	                  return function (_x17) {
	                    return _ref14.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this2);
	      }));
	
	      return function (_x16) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    _this.updateJustification = function () {
	      var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(questionId) {
	        var params, _this$state2, token, idname, justification1, justification2, userGrading, id, testid, quesOffset, caseno, caseOffset, userData, result, userStatsData, usergrading;
	
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                params = _this.props.params, _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname, justification1 = _this$state2.justification1, justification2 = _this$state2.justification2, userGrading = _this$state2.userGrading;
	                id = params.id, testid = params.testid, quesOffset = params.quesOffset, caseno = params.caseno, caseOffset = params.caseOffset;
	                userData = {
	                  token: token,
	                  idname: idname,
	                  questionId: questionId,
	                  mock_id: id ? Number.parseInt(id) : null,
	                  id: testid ? Number.parseInt(testid) : null,
	                  offset: quesOffset ? Number.parseInt(quesOffset) : null,
	                  caseno: caseno ? Number.parseInt(caseno) : null,
	                  caseOffset: caseOffset ? Number.parseInt(caseOffset) : null,
	                  justification1: justification1,
	                  justification2: justification2,
	                  userGrading: userGrading
	                };
	                _context15.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUsersChoice', userData);
	
	              case 5:
	                result = _context15.sent;
	
	                console.log({ result: result });
	
	                userStatsData = _this.state.userStatsData;
	                usergrading = userStatsData && userStatsData.gradings ? JSON.parse(userStatsData.gradings) : {};
	
	                usergrading[questionId] = userGrading;
	                _this.setState(function (prevState) {
	                  return {
	                    userStatsData: Object.assign({}, prevState.userStatsData, {
	                      gradings: JSON.stringify(usergrading)
	                    })
	                  };
	                });
	                _this.checkAttemptedGrading(usergrading);
	
	                // if (result.success) {
	                //   this.getUserStats();
	                // }
	
	              case 12:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this2);
	      }));
	
	      return function (_x18) {
	        return _ref15.apply(this, arguments);
	      };
	    }();
	
	    _this.submitTest = function () {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({
	        showFinishTestPopup: false
	      });
	      // console.log('I am here for you ----------->');
	
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserQuizStatus', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x19) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	
	      var ansdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        // console.log('I am here for you ----------->');
	        if (resp_count.success) {
	          var _data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	            score: resp_count.allrightanswercount.question_count,
	            id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserScore', _data);
	        } else {
	          //console.log(resp_count.success + '------------failure');
	        }
	      });
	
	      var _this$props$params9 = _this.props.params,
	          id = _this$props$params9.id,
	          timer = _this$props$params9.timer,
	          testid = _this$props$params9.testid;
	
	      var pathname = _this.finishTestRoute.replace(':id', id).replace(':caseno', 0).replace(':questiono', 1).replace(':testid', testid).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', timer);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.flagQuestion = function (data) {
	      var flag = _this.state.flag;
	
	      var flaggedQuestions = flag.filter(function (flag) {
	        return flag.question_id === data.id;
	      })[0];
	      var flagdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: data.id,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      if (flaggedQuestions) {
	        (0, _toast.showSuccess)('Question Unflagged');
	      } else {
	        (0, _toast.showSuccess)('Question Flagged');
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/flagQuestion', flagdata).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res) {
	                    _this.getFlagQuestions();
	                  }
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this2);
	        }));
	
	        return function (_x20) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.updateAttemptedGrading = function (caseId) {
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        attemptedGrading: JSON.stringify([].concat(_toConsumableArray(_this.state.attemptedGrading), [caseId]))
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateAttemptedCases', userData).then(function () {
	        var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(res) {
	          return _regenerator2.default.wrap(function _callee18$(_context18) {
	            while (1) {
	              switch (_context18.prev = _context18.next) {
	                case 0:
	                  if (res.success) {
	                    _this.setState({
	                      attemptedGrading: [].concat(_toConsumableArray(_this.state.attemptedGrading), [caseId])
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context18.stop();
	              }
	            }
	          }, _callee18, _this2);
	        }));
	
	        return function (_x21) {
	          return _ref18.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(res) {
	          return _regenerator2.default.wrap(function _callee19$(_context19) {
	            while (1) {
	              switch (_context19.prev = _context19.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data, isLoading: false });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context19.stop();
	              }
	            }
	          }, _callee19, _this2);
	        }));
	
	        return function (_x22) {
	          return _ref19.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state3 = _this.state,
	          flag = _this$state3.flag,
	          userStatsData = _this$state3.userStatsData,
	          totalQuestionCount = _this$state3.totalQuestionCount;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	
	      _this.setState({ showFinishTestPopup: true });
	    };
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	
	      if (timerStart === 'true') {
	        _this.setState({
	          timerStart: 'false'
	        });
	        var _this$props$params10 = _this.props.params,
	            id = _this$props$params10.id,
	            questiono = _this$props$params10.questiono,
	            caseno = _this$props$params10.caseno,
	            _quesOffset2 = _this$props$params10.quesOffset,
	            timer = _this$props$params10.timer,
	            testid = _this$props$params10.testid,
	            _caseOffset3 = _this$props$params10.caseOffset,
	            isNegative = _this$props$params10.isNegative,
	            _timerStart = _this$props$params10.timerStart;
	
	        var pathname = _this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questiono).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', _caseOffset3).replace(':quesOffset', _quesOffset2).replace(':timerStart', false).replace(':isNegative', isNegative);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: 'true'
	        });
	        var _this$props$params11 = _this.props.params,
	            _id = _this$props$params11.id,
	            _questiono = _this$props$params11.questiono,
	            _caseno = _this$props$params11.caseno,
	            _quesOffset3 = _this$props$params11.quesOffset,
	            _timer = _this$props$params11.timer,
	            _testid = _this$props$params11.testid,
	            _caseOffset4 = _this$props$params11.caseOffset,
	            _isNegative = _this$props$params11.isNegative,
	            _timerStart2 = _this$props$params11.timerStart;
	
	        var _pathname = _this.gradeQuestionRoute.replace(':id', _id).replace(':caseno', _caseno).replace(':questiono', _questiono).replace(':timer', _timer).replace(':testid', _testid).replace(':caseOffset', _caseOffset4).replace(':quesOffset', _quesOffset3).replace(':timerStart', true).replace(':isNegative', _isNegative);
	
	        _this.context.router.push({
	          pathname: _pathname
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getStrikedText', data).then(function () {
	        var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(res) {
	          return _regenerator2.default.wrap(function _callee20$(_context20) {
	            while (1) {
	              switch (_context20.prev = _context20.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context20.stop();
	              }
	            }
	          }, _callee20, _this2);
	        }));
	
	        return function (_x23) {
	          return _ref20.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.updateUserAnswer = function (answer, questionId, selectedCaseQuestionData) {
	      var params = _this.props.params,
	          _this$state4 = _this.state,
	          token = _this$state4.token,
	          idname = _this$state4.idname;
	      var id = params.id,
	          testid = params.testid;
	
	      var userData = {
	        token: token,
	        idname: idname,
	        question_id: questionId,
	        reading_id: selectedCaseQuestionData.chapter_id,
	        mock_id: id ? Number.parseInt(id) : null,
	        test_id: testid ? Number.parseInt(testid) : null,
	        user_grading: _this.state.userGrading,
	        max_grading: selectedCaseQuestionData.max_grading,
	        answer: answer
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + (_this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams') + '/updateUserAnswer', userData).then(function () {
	        var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(res) {
	          return _regenerator2.default.wrap(function _callee21$(_context21) {
	            while (1) {
	              switch (_context21.prev = _context21.next) {
	                case 0:
	                case 'end':
	                  return _context21.stop();
	              }
	            }
	          }, _callee21, _this2);
	        }));
	
	        return function (_x24) {
	          return _ref21.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.handleChange = function (e) {
	      var _this$setState2;
	
	      var _e$target2 = e.target,
	          name = _e$target2.name,
	          value = _e$target2.value;
	
	      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, value), _defineProperty(_this$setState2, 'disableNavigationButtons', false), _this$setState2), function () {
	        var selectedCaseQuestionData = _this.state.selectedCaseQuestionData;
	
	
	        if (name === 'userGrading') {
	          _this.updateJustification(selectedCaseQuestionData.id);
	          if (value > 0) {
	            _this.updateUserAnswer('correct', selectedCaseQuestionData.id, selectedCaseQuestionData);
	          } else {
	            _this.updateUserAnswer('incorrect', selectedCaseQuestionData.id, selectedCaseQuestionData);
	          }
	        }
	      });
	    };
	
	    _this.checkAttemptedGrading = function (usergrading) {
	      var _this$state5 = _this.state,
	          questionsData = _this$state5.questionsData,
	          attemptedGrading = _this$state5.attemptedGrading;
	
	      var parseResult = Object.keys(usergrading).map(function (x) {
	        return parseInt(x, 10);
	      });
	      var count = 0;
	      parseResult.forEach(function (element) {
	        var attemptedCount = questionsData.filter(function (item) {
	          if (item.id === element) {
	            count++;
	            if (questionsData.length === count) {
	              if (attemptedGrading.indexOf(item.case_id) === -1) {
	                _this.updateAttemptedGrading(item.case_id);
	              }
	            }
	          }
	          return item.id === element;
	        });
	      });
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      totalQuestionCount: 0,
	      justification1: '',
	      justification2: '',
	      userGrading: '',
	      selectedIndex: -1,
	      attemptedGrading: []
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    _this.isPathway = _this.props.location.pathname.includes(_AppRoutes2.default.CFA3_PATHWAY_CBT);
	    _this.gradeQuestionRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_GRADE_QUESTIONS : _AppRoutes2.default.CFA3_CBT_GRADE_QUESTIONS;
	    _this.finishTestRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS_FINISH : _AppRoutes2.default.CFA3_CBT_QUESTIONS_FINISH;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFA3GradeQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        var _props$params = this.props.params,
	            id = _props$params.id,
	            questiono = _props$params.questiono,
	            caseno = _props$params.caseno,
	            _quesOffset4 = _props$params.quesOffset,
	            timer = _props$params.timer,
	            testid = _props$params.testid,
	            _caseOffset5 = _props$params.caseOffset,
	            isNegative = _props$params.isNegative,
	            timerStart = _props$params.timerStart;
	
	        var pathname = this.gradeQuestionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questiono).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', _caseOffset5).replace(':quesOffset', _quesOffset4).replace(':isNegative', false).replace(':timerStart', timerStart);
	        this.context.router.push({
	          pathname: pathname
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.props.params.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserTimer', data).then(function () {
	        var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(res) {
	          return _regenerator2.default.wrap(function _callee22$(_context22) {
	            while (1) {
	              switch (_context22.prev = _context22.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context22.stop();
	              }
	            }
	          }, _callee22, _this3);
	        }));
	
	        return function (_x25) {
	          return _ref22.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          seconds = _state.seconds,
	          selectedIndex = _state.selectedIndex,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          attemptedGrading = _state.attemptedGrading,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var justification = userStatsData && userStatsData.justification ? JSON.parse(userStatsData.justification) : '';
	      var usergrading = userStatsData && userStatsData.gradings ? JSON.parse(userStatsData.gradings) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      // let flaggedQuestion = flag.filter(flag => flag.question_id === selectedCaseQuestionData.id)[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var content = selectedCaseQuestionData ? selectedCaseQuestionData.question : null;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            {
	              className: casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { onClick: function onClick() {
	                    return _this4.finishTest();
	                  }, className: 'pointer_class btn-primary' },
	                'Finish Test'
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this4.slider = slider;
	                      }
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeCase(item.id, index);
	                          },
	                          className: '\n                              ' + (index === parseInt(_this4.props.params.caseOffset) ? 'active button-trial' : 'button-trial') + '\n                              \n                              ' + (attemptedGrading.indexOf(item.id) !== -1 ? 'bg-completed-essay-cases' : 'bg-completed-cases')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: '' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper col-md-12' },
	                selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                  'div',
	                  { className: 'ques-wrapper all-ques' },
	                  (0, _function.renderHTMLContent)(selectedQuestionData.case_name, "h1", "mb-2 text-capitalize")
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'qus-tab-wrapper' },
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0];
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                            ' + (index === parseInt(_this4.props.params.quesOffset) ? 'active' : '') + '\n                            ' + (usergrading[item.id] ? 'selected-grading' : userChoice[item.id] ? 'completed-qus' : '') + '\n                            ' + (flaggedQuestions ? 'flag-add' : '') + '\n                            '
	                        },
	                        index + 1,
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : ''
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ques-detail-wrapper col-md-12 question-wrapper pr-0' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'main_loader ' + this.state.display_main_loader },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'loader-mid' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'card-block-loader' },
	                              _react2.default.createElement(_loader2.default, null)
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { lg: 12, md: 12 },
	                          _react2.default.createElement(
	                            _reactstrap.Col,
	                            { xs: '12', sm: '12', lg: '12' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                                className: 'margin_right_20',
	                                alt: '',
	                                width: '30'
	                              }),
	                              'Q.',
	                              parseInt(this.props.params.quesOffset) + 1
	                            )
	                          ),
	                          _react2.default.createElement(_ViewEssayQuestions2.default, Object.assign({}, this.state, selectedCaseQuestionData, {
	                            clickOption: this.clickOption,
	                            selectedCaseQuestionData: selectedCaseQuestionData,
	                            userChoice: userChoice,
	                            justification: justification,
	                            setJustification: this.setJustification,
	                            justification1: this.state.justification1,
	                            justification2: this.state.justification2,
	                            disabledTextArea: true,
	                            disabledChoices: true,
	                            selectedIndex: selectedIndex
	                          }))
	                        ),
	                        _react2.default.createElement('div', {
	                          className: 'col-sm-6 d-sm-flex align-items-end text-center text-sm-left'
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-6' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'text-center text-sm-right btm-btn-wrapper quiz-submit-block' },
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getPreviousQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === 0
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                              ' ',
	                              _language2.default.LC().BACK
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getNextQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                              },
	                              _language2.default.LC().NEXT,
	                              ' ',
	                              _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(_ViewAnswer2.default, Object.assign({}, selectedCaseQuestionData, {
	                    handleChange: this.handleChange,
	                    selectedChoice: userChoice[selectedCaseQuestionData.id] && selectedCaseQuestionData[userChoice[selectedCaseQuestionData.id]] || '',
	                    userGrading: this.state.userGrading || usergrading[selectedCaseQuestionData.id] || ''
	                  }))
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_GRADING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _language2.default.LC().SECTION_REVIEW
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _language2.default.LC().FILTER_BY,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'filt-list-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: function onClick() {
	                    _this4.setState({
	                      filter: []
	                    });
	                  }
	                },
	                _language2.default.LC().CLEAR
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _constant.filterObj.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'plan_wrapper remove-plan', key: index },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        value: item,
	                        id: item,
	                        checked: filter.indexOf(item) > -1 ? true : false,
	                        onChange: function onChange(e) {
	                          return _this4.changeFilter(e, item);
	                        }
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' }),
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qus-tab-wrapper' },
	              questionsData.map(function (item, index) {
	                var flaggedQuestions = flag.filter(function (flag) {
	                  return flag.question_id === item.id;
	                })[0];
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  filter.includes('Attempted') && filter.includes('Unattempted') && filter.includes('Flagged') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : filter.includes('Attempted') && filter.includes('Unattempted') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'completed-qus' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : filter.includes('Unattempted') && filter.includes('Flagged') ? !userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : ///
	                  filter.includes('Attempted') && filter.includes('Flagged') ? userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : filter.includes('Attempted') ? userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'completed-qus',
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Unattempted') ? !userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Flagged') ? flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    })
	                  ) : '' : _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFA3GradeQuestions;
	}(_react.Component);
	
	CFA3GradeQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFA3GradeQuestions;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewNormalQuestions = function ViewNormalQuestions(_ref) {
	  var selectedCaseQuestionData = _ref.selectedCaseQuestionData,
	      strikeThroughArr = _ref.strikeThroughArr,
	      userChoice = _ref.userChoice,
	      getHighlightedText = _ref.getHighlightedText,
	      content = _ref.content,
	      _ref$optionsArr = _ref.optionsArr,
	      optionsArr = _ref$optionsArr === undefined ? [] : _ref$optionsArr,
	      showPopover = _ref.showPopover,
	      clickOption = _ref.clickOption,
	      deselectPopover = _ref.deselectPopover,
	      selectPopover = _ref.selectPopover,
	      addHighlightToText = _ref.addHighlightToText,
	      deleteHighlightFromText = _ref.deleteHighlightFromText;
	
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    { xs: '12', sm: '12', lg: '12' },
	    selectedCaseQuestionData && selectedCaseQuestionData.question ? _react2.default.createElement(
	      'div',
	      { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            position: 'relative',
	            marginTop: '8px',
	            maxWidth: '100%'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { 'data-selectable': true },
	          (0, _function.renderHTMLContent)(content, "div", "qus-title d-inline-block w-100")
	        ),
	        _react2.default.createElement(
	          _reactSelectionPopover2.default,
	          {
	            showPopover: showPopover,
	            onSelect: function onSelect() {
	              return selectPopover();
	            },
	            onDeselect: function onDeselect() {
	              return deselectPopover();
	            }
	          },
	          getHighlightedText === -1 ? _react2.default.createElement(
	            'div',
	            { className: 'highlight-popover tooltip_wrap' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	              alt: '523',
	              width: '30',
	              onClick: addHighlightToText
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tootip_box' },
	              _language2.default.LC().Click_me_to_highlight
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'highlight-popover tooltip_wrap' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	              alt: '523',
	              width: '30',
	              onClick: deleteHighlightFromText
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tootip_box' },
	              _language2.default.LC().Click_me_to_unhighlight
	            )
	          )
	        )
	      )
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      optionsArr.map(function (item, index) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'col-sm-12',
	            id: item,
	            key: index,
	            onClick: function onClick(e) {
	              clickOption(item, selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	            },
	            onContextMenu: function onContextMenu(e) {
	              clickOption(item, selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null, selectedCaseQuestionData, e);
	            },
	            onTouchStart: function onTouchStart(e) {
	              undefined.onTouchStart(e, item);
	            },
	            onTouchCancel: function onTouchCancel(e) {
	              undefined.onTouchCancel(e);
	            },
	            onTouchEnd: function onTouchEnd(e) {
	              undefined.onTouchEnd(e);
	            },
	            onTouchMove: function onTouchMove(e) {
	              undefined.onTouchMove(e);
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'answer_box ' + (userChoice[selectedCaseQuestionData.id] === item ? 'border-yellow' : 'border-black')
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'answer_count highlight_choice no-selection ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	              },
	              item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	            ),
	            _react2.default.createElement(
	              'p',
	              {
	                className: 'ans_box_text tooltip_wrap ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	              },
	              selectedCaseQuestionData && selectedCaseQuestionData[item] ? (0, _function.renderHTMLContent)(selectedCaseQuestionData[item], "span", "no-selection", { contentEditable: false }) : null
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = ViewNormalQuestions;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	__webpack_require__(80);
	
	var _toast = __webpack_require__(15);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _highlightText = __webpack_require__(56);
	
	var _constant = __webpack_require__(9);
	
	var _cbttopnavigationsettings = __webpack_require__(94);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ViewEssayQuestions = __webpack_require__(265);
	
	var _ViewEssayQuestions2 = _interopRequireDefault(_ViewEssayQuestions);
	
	var _ViewNormalQuestions = __webpack_require__(570);
	
	var _ViewNormalQuestions2 = _interopRequireDefault(_ViewNormalQuestions);
	
	var _NextQuestionModal = __webpack_require__(687);
	
	var _NextQuestionModal2 = _interopRequireDefault(_NextQuestionModal);
	
	var _messages = __webpack_require__(14);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var longPressDuration = 450;
	var attemptedCaseArray = [];
	
	var CFA3CBTQuestions = function (_Component) {
	  _inherits(CFA3CBTQuestions, _Component);
	
	  function CFA3CBTQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA3CBTQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFA3CBTQuestions.__proto__ || Object.getPrototypeOf(CFA3CBTQuestions)).call(this, props));
	
	    _this.setUserChoice = function (value, index) {
	      _this.setState({
	        selectedChoice: value,
	        selectedIndex: index,
	        displayError: false,
	        disableValidate: false
	      });
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.caseOffset !== _this.props.params.caseOffset || prevProps.params.quesOffset !== _this.props.params.quesOffset) {
	        var _this$props$params = _this.props.params,
	            id = _this$props$params.id,
	            session = _this$props$params.session,
	            pathway = _this$props$params.pathway;
	
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: id ? parseInt(id) : null,
	          pathwayId: pathway,
	          sessionId: session
	        };
	        _this.getCases(data);
	        _this.getUserStats();
	        _this.getFlagQuestions();
	      }
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, _this$props$params2, id, pathway, session, testid, data;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              _this$props$params2 = _this.props.params, id = _this$props$params2.id, pathway = _this$props$params2.pathway, session = _this$props$params2.session, testid = _this$props$params2.testid;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: id ? parseInt(id) : null,
	                pathwayId: pathway,
	                sessionId: session,
	                test_id: testid
	              };
	
	              _this.getCases(data);
	              _this.getUserStats();
	              _this.getFlagQuestions();
	              if (_this.props.params.timerStart === 'true') {
	                _this.timer = setInterval(_this.countDown, 1000);
	              } else {
	                clearInterval(_this.timer);
	              }
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getMockNamebyId', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	              // getTotalQuestionsCount
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getTotalQuestionsCount', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({
	                    totalQuestionCount: resp.totalQuestionsCount
	                  });
	                } else {
	                  // console.log('falure --------> ', resp);
	                }
	              });
	
	            case 11:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getCases = function (data) {
	      _this.setState({
	        display_main_loader: 'show_block z-index-1000 bg-white',
	        vpCaseLoader: true,
	        questionLoader: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + _this.apiRoute + '/getCFAMockCases', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.question && resp.question.length) {
	            _this.getHighlightedText();
	            _this.getStrikedText();
	            _this.setState({
	              totalQuestionCount: resp.data && resp.data.length,
	              casesData: resp.question,
	              isLoading: false,
	              isDataLoading: false,
	              vpCaseLoader: false,
	              questionLoader: false,
	              display_main_loader: 'hide_block',
	              //selected case
	              selectedQuestionData: resp.question[_this.props.params.caseOffset],
	              //all questions of selected case
	              questionsData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa3_cbt_questions ? resp.question[_this.props.params.caseOffset].cfa3_cbt_questions : [],
	              //1st question of selected case
	              selectedCaseQuestionData: resp.question[_this.props.params.caseOffset] && resp.question[_this.props.params.caseOffset].cfa3_cbt_questions && resp.question[_this.props.params.caseOffset].cfa3_cbt_questions[_this.props.params.quesOffset] ? resp.question[_this.props.params.caseOffset].cfa3_cbt_questions[_this.props.params.quesOffset] : []
	            });
	          } else if (resp.question.length === 0) {
	            _this.setState({
	              isLoading: false,
	              disabledGrading: true
	            });
	          }
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeCase = function (questionNumber, index) {
	      var _this$state = _this.state,
	          casesData = _this$state.casesData,
	          showModal = _this$state.showModal;
	
	      if (!showModal && _this.showPopUp(function () {
	        return _this.changeCase(questionNumber, index);
	      })) {
	        return;
	      }
	      // this.slider.slickGoTo(index + 1);
	      _this.getUserStats();
	      // this.getFlagQuestions();
	      _this.setState({
	        isLoading: true,
	        justification1: '',
	        justification2: '',
	        disableValidate: false,
	        selectedIndex: -1,
	        selectedChoice: '',
	        displayError: false
	      });
	      var _this$props$params3 = _this.props.params,
	          id = _this$props$params3.id,
	          session = _this$props$params3.session,
	          pathway = _this$props$params3.pathway,
	          caseOffset = _this$props$params3.caseOffset,
	          timer = _this$props$params3.timer,
	          testid = _this$props$params3.testid,
	          timerStart = _this$props$params3.timerStart,
	          isNegative = _this$props$params3.isNegative;
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id ? parseInt(id) : null,
	        pathwayId: pathway,
	        sessionId: session
	      };
	      if (questionNumber) {
	        var pathname = _this.questionRoute.replace(':id', id).replace(':caseno', questionNumber).replace(':questiono', casesData[parseInt(caseOffset)] && casesData[parseInt(caseOffset)].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset)].cfa3_cbt_questions[0].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', index).replace(':timerStart', timerStart).replace(':isNegative', isNegative).replace(':session', session).replace(':pathway', pathway).replace(':quesOffset', 0);
	        _this.context.router.push({
	          pathname: pathname
	        }, _this.getCases(data));
	      }
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	          attemptedCaseArray = resp.data.attemptedCases != null ? JSON.parse(resp.data.attemptedCases) : [];
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.showPopUp = function (functionToCall) {
	      var _this$state2 = _this.state,
	          justification1 = _this$state2.justification1,
	          justification2 = _this$state2.justification2,
	          disableValidate = _this$state2.disableValidate;
	
	
	      if ((justification1 && justification1.length || justification2 && justification2.length) && !disableValidate) {
	        // showFailure(
	        //   'Please make sure to validate the question before moving on to the next step.'
	        // );
	        _this.setState({ showModal: true });
	        _this.functionToCall = functionToCall;
	        return true;
	      }
	      return false;
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      if (questionNumber) {
	        var showModal = _this.state.showModal;
	
	        if (!showModal && _this.showPopUp(function () {
	          return _this.changeQuestion(questionNumber, index);
	        })) {
	          return;
	        }
	        _this.setState({
	          justification1: '',
	          justification2: '',
	          disableValidate: false,
	          selectedIndex: -1,
	          selectedChoice: '',
	          displayError: false
	        });
	        var _this$props$params4 = _this.props.params,
	            id = _this$props$params4.id,
	            caseno = _this$props$params4.caseno,
	            timer = _this$props$params4.timer,
	            testid = _this$props$params4.testid,
	            caseOffset = _this$props$params4.caseOffset,
	            isNegative = _this$props$params4.isNegative,
	            timerStart = _this$props$params4.timerStart,
	            session = _this$props$params4.session,
	            pathway = _this$props$params4.pathway;
	
	        var pathname = _this.questionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questionNumber).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':session', session).replace(':pathway', pathway).replace(':quesOffset', index).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	      }
	    };
	
	    _this.getNextCase = function (index) {
	      var _this$state3 = _this.state,
	          casesData = _this$state3.casesData,
	          showModal = _this$state3.showModal;
	
	      if (!showModal && _this.showPopUp(function () {
	        return _this.getNextCase(index);
	      })) {
	        return;
	      }
	      // this.slider.slickGoTo(index);
	      _this.setState({
	        isLoading: true,
	        justification1: '',
	        justification2: '',
	        disableValidate: false,
	        selectedIndex: -1,
	        selectedChoice: '',
	        displayError: false
	      });
	      var _this$props$params5 = _this.props.params,
	          id = _this$props$params5.id,
	          timer = _this$props$params5.timer,
	          testid = _this$props$params5.testid,
	          caseOffset = _this$props$params5.caseOffset,
	          isNegative = _this$props$params5.isNegative,
	          timerStart = _this$props$params5.timerStart,
	          session = _this$props$params5.session,
	          pathway = _this$props$params5.pathway;
	
	      var pathname = _this.questionRoute.replace(':id', id).replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) + 1].id : 1).replace(':questiono', casesData[parseInt(caseOffset) + 1] && casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset ? parseInt(caseOffset) + 1 : 1).replace(':quesOffset', 0).replace(':isNegative', isNegative).replace(':session', session).replace(':pathway', pathway).replace(':timerStart', timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousCase = function (index) {
	      var _this$state4 = _this.state,
	          casesData = _this$state4.casesData,
	          showModal = _this$state4.showModal;
	
	      if (!showModal && _this.showPopUp(function () {
	        return _this.getPreviousCase(index);
	      })) {
	        return;
	      }
	      console.log('getPreviousCase');
	      // this.slider.slickGoTo(index - 2);
	      _this.setState({
	        isLoading: true,
	        justification1: '',
	        justification2: '',
	        disableValidate: false,
	        selectedIndex: -1,
	        selectedChoice: '',
	        displayError: false
	      });
	      var _this$props$params6 = _this.props.params,
	          id = _this$props$params6.id,
	          timer = _this$props$params6.timer,
	          testid = _this$props$params6.testid,
	          caseOffset = _this$props$params6.caseOffset,
	          isNegative = _this$props$params6.isNegative,
	          timerStart = _this$props$params6.timerStart,
	          session = _this$props$params6.session,
	          pathway = _this$props$params6.pathway;
	
	      var pathname = _this.questionRoute.replace(':id', id).replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) - 1].id : 1).replace(':questiono', casesData[parseInt(caseOffset) - 1] && casesData[parseInt(caseOffset) - 1].cfa3_cbt_questions[0] ? casesData[parseInt(caseOffset) - 1].cfa3_cbt_questions[0].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset ? parseInt(caseOffset) - 1 : 1).replace(':quesOffset', 0).replace(':isNegative', isNegative).replace(':session', session).replace(':pathway', pathway).replace(':timerStart', timerStart);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getPreviousQuestion = function (index) {
	      var _this$state5 = _this.state,
	          questionsData = _this$state5.questionsData,
	          showModal = _this$state5.showModal;
	
	      if (!showModal && _this.showPopUp(function () {
	        return _this.getPreviousQuestion(index);
	      })) {
	        return;
	      }
	      var _this$props$params7 = _this.props.params,
	          id = _this$props$params7.id,
	          quesOffset = _this$props$params7.quesOffset,
	          timer = _this$props$params7.timer,
	          testid = _this$props$params7.testid,
	          caseOffset = _this$props$params7.caseOffset,
	          isNegative = _this$props$params7.isNegative,
	          timerStart = _this$props$params7.timerStart,
	          session = _this$props$params7.session,
	          pathway = _this$props$params7.pathway;
	
	      var pathname = _this.questionRoute.replace(':id', id).replace(':caseno', caseOffset).replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) - 1].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset ? parseInt(quesOffset) - 1 : 1).replace(':isNegative', isNegative).replace(':session', session).replace(':pathway', pathway).replace(':timerStart', timerStart);
	
	      _this.setState({
	        justification1: '',
	        justification2: '',
	        disableValidate: false,
	        selectedIndex: -1,
	        selectedChoice: '',
	        displayError: false
	      });
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.getNextQuestion = function (index) {
	      var _this$state6 = _this.state,
	          questionsData = _this$state6.questionsData,
	          showModal = _this$state6.showModal;
	
	      console.log('getPreviousCase');
	
	      if (!showModal && _this.showPopUp(function () {
	        return _this.getNextQuestion(index);
	      })) {
	        return;
	      }
	      var _this$props$params8 = _this.props.params,
	          id = _this$props$params8.id,
	          quesOffset = _this$props$params8.quesOffset,
	          timer = _this$props$params8.timer,
	          testid = _this$props$params8.testid,
	          caseOffset = _this$props$params8.caseOffset,
	          isNegative = _this$props$params8.isNegative,
	          timerStart = _this$props$params8.timerStart,
	          session = _this$props$params8.session,
	          pathway = _this$props$params8.pathway;
	
	      var pathname = _this.questionRoute.replace(':id', id).replace(':session', session).replace(':pathway', pathway).replace(':caseno', caseOffset).replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) + 1].id : 1).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset ? parseInt(quesOffset) + 1 : 1).replace(':isNegative', isNegative).replace(':timerStart', timerStart);
	
	      _this.setState({
	        justification1: '',
	        justification2: '',
	        disableValidate: false,
	        selectedIndex: -1,
	        selectedChoice: '',
	        displayError: false
	      });
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/addHighlightedText', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context3.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context6.next = 7;
	                  break;
	                }
	
	                _context6.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/deleteHighlightedText', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context5.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context6.next = 8;
	                break;
	
	              case 7:
	                return _context6.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getHighlightedText', data).then(function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	          return _regenerator2.default.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  // console.log('highlights ---------> ', res.questions);
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this2);
	        }));
	
	        return function (_x6) {
	          return _ref7.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.setJustification = function (e, index) {
	      var _this$setState;
	
	      console.log('e', e.target.name);
	      var _e$target = e.target,
	          value = _e$target.value,
	          name = _e$target.name;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'displayError', false), _defineProperty(_this$setState, 'disableValidate', false), _this$setState));
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                console.log({ choice: choice, questionId: questionId, selectedQuestionData: selectedQuestionData });
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  // console.log('Print params ---------> ', this.props.params);
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.quesOffset ? parseInt(_this.props.params.quesOffset) : null,
	                    caseno: _this.props.params.caseno ? parseInt(_this.props.params.caseno) : null,
	                    caseOffset: _this.props.params.caseOffset ? parseInt(_this.props.params.caseOffset) : null
	                    // attemptedCases: JSON.stringify(attemptedCaseArray),
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 3:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7, _x8, _x9, _x10) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context10.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/addStrikeThrough', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            _context9.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x12) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x11) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUsersChoice', userData).then(function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee11$(_context11) {
	            while (1) {
	              switch (_context11.prev = _context11.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && (selectedQuestionData.answer === choice || choice === 'choice_' + selectedQuestionData.answer) ? 'correct' : 'incorrect',
	                      user_grading: selectedQuestionData && (selectedQuestionData.answer === choice || choice === 'choice_' + selectedQuestionData.answer) ? 2 : 0,
	                      max_grading: selectedQuestionData.max_grading || 2,
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    // console.log('ansData -------------> ', ansData);
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + (_this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams') + '/updateUserAnswer', ansData);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context11.stop();
	              }
	            }
	          }, _callee11, _this2);
	        }));
	
	        return function (_x13) {
	          return _ref11.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.updateJustification = function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(questionId) {
	        var params, _this$state7, token, idname, justification1, justification2, selectedCaseQuestionData, selectedChoice, selectedIndex, userStatsData, id, testid, quesOffset, caseno, caseOffset, is_multiple, development_justification, development_justification2, optionTypeCount, answerTypeCount, userChoice, justification, userData, result;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                params = _this.props.params, _this$state7 = _this.state, token = _this$state7.token, idname = _this$state7.idname, justification1 = _this$state7.justification1, justification2 = _this$state7.justification2, selectedCaseQuestionData = _this$state7.selectedCaseQuestionData, selectedChoice = _this$state7.selectedChoice, selectedIndex = _this$state7.selectedIndex, userStatsData = _this$state7.userStatsData;
	                id = params.id, testid = params.testid, quesOffset = params.quesOffset, caseno = params.caseno, caseOffset = params.caseOffset;
	                is_multiple = selectedCaseQuestionData.is_multiple, development_justification = selectedCaseQuestionData.development_justification, development_justification2 = selectedCaseQuestionData.development_justification2;
	                optionTypeCount = 0, answerTypeCount = 0;
	                userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	                justification = userStatsData && userStatsData.justification ? JSON.parse(userStatsData.justification) : '';
	
	                if (!(selectedIndex === -1 && justification1 === '' && (justification[questionId] || userChoice[questionId]))) {
	                  _context12.next = 9;
	                  break;
	                }
	
	                console.log({ selectedIndex: selectedIndex, justification1: justification1, questionId: questionId });
	                return _context12.abrupt('return');
	
	              case 9:
	
	                if (is_multiple === 1) optionTypeCount++;
	
	                if (development_justification.trim()) optionTypeCount++;
	
	                if (development_justification2.trim() && !is_multiple) optionTypeCount++;
	
	                if (justification1 !== '' || justification[questionId] && justification[questionId].justification1 !== '') answerTypeCount++;
	
	                if (justification2 !== '' || justification[questionId] && justification[questionId].justification2 !== '') answerTypeCount++;
	
	                if (is_multiple && selectedChoice && selectedChoice !== 'no_choice' || !is_multiple && selectedChoice === 'no_choice' || userChoice[questionId]) answerTypeCount++;
	
	                if (!(answerTypeCount < optionTypeCount)) {
	                  _context12.next = 17;
	                  break;
	                }
	
	                return _context12.abrupt('return', _this.setState({ displayError: true }));
	
	              case 17:
	                userData = {
	                  token: token,
	                  idname: idname,
	                  questionId: questionId,
	                  mock_id: id ? Number.parseInt(id) : null,
	                  id: testid ? Number.parseInt(testid) : null,
	                  offset: quesOffset ? Number.parseInt(quesOffset) : null,
	                  caseno: caseno ? Number.parseInt(caseno) : null,
	                  caseOffset: caseOffset ? Number.parseInt(caseOffset) : null,
	                  selectedIndex: selectedIndex,
	                  choice: selectedIndex != -1 ? 'choice_' + String.fromCharCode(selectedIndex + 97) : null,
	                  justification1: justification1,
	                  justification2: justification2
	                };
	                _context12.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUsersChoice', userData);
	
	              case 20:
	                result = _context12.sent;
	
	                console.log({ result: result });
	                if (result.success) {
	                  _this.setState({ disableValidate: true });
	                  _this.getUserStats();
	                }
	
	              case 23:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this2);
	      }));
	
	      return function (_x14) {
	        return _ref12.apply(this, arguments);
	      };
	    }();
	
	    _this.checkSetConditionBeforeSubmitTest = function () {
	      var _this$state8 = _this.state,
	          totalQuestionCount = _this$state8.totalQuestionCount,
	          userStatsData = _this$state8.userStatsData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (Object.keys(userChoice).length !== parseInt(totalQuestionCount, 10)) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({
	          showFinishTestPopup: true
	        });
	      }
	      _this.setState({
	        showFlaggedPopup: false
	        // showFinishTestPopup: true,
	      });
	    };
	
	    _this.submitTest = function () {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({
	        showFinishTestPopup: false
	      });
	      // console.log('I am here for you ----------->');
	
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'non-graded'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserQuizStatus', data).then(function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	          return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	              switch (_context13.prev = _context13.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context13.stop();
	              }
	            }
	          }, _callee13, _this2);
	        }));
	
	        return function (_x15) {
	          return _ref13.apply(this, arguments);
	        };
	      }());
	
	      var ansdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        // console.log('I am here for you ----------->');
	        if (resp_count.success) {
	          var _data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	            score: resp_count.allrightanswercount.question_count,
	            id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserScore', _data);
	        } else {
	          //console.log(resp_count.success + '------------failure');
	        }
	      });
	
	      var pathname = _this.gradeQuestionRoute.replace(':id', _this.props.params.id).replace(':caseno', 0).replace(':questiono', 1).replace(':testid', _this.props.params.testid).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', _this.props.params.timer);
	
	      _this.context.router.push({
	        pathname: pathname
	      });
	    };
	
	    _this.flagQuestion = function (data) {
	      var flag = _this.state.flag;
	
	      var flaggedQuestions = flag.filter(function (flag) {
	        return flag.question_id === data.id;
	      })[0];
	      var flagdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: data.id,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      if (flaggedQuestions) {
	        (0, _toast.showSuccess)('Question Unflagged');
	      } else {
	        (0, _toast.showSuccess)('Question Flagged');
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/flagQuestion', flagdata).then(function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	          return _regenerator2.default.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  if (res) {
	                    _this.getFlagQuestions();
	                  }
	
	                case 1:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x16) {
	          return _ref14.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.updateAttemptedCases = function () {
	      // console.log('661 attempted cases -----------> ', attemptedCaseArray);
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        attemptedCases: JSON.stringify(attemptedCaseArray)
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateAttemptedCases', userData).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res.success) {
	                    attemptedCaseArray = res.attemptedCases != null ? JSON.parse(res.attemptedCases) : [];
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x17) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.gradeQuestions = function () {
	      var _this$state9 = _this.state,
	          flag = _this$state9.flag,
	          userStatsData = _this$state9.userStatsData,
	          totalQuestionCount = _this$state9.totalQuestionCount;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== parseInt(totalQuestionCount, 10)) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	    };
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	      var _this$props$params9 = _this.props.params,
	          id = _this$props$params9.id,
	          caseno = _this$props$params9.caseno,
	          questiono = _this$props$params9.questiono,
	          session = _this$props$params9.session,
	          pathway = _this$props$params9.pathway,
	          quesOffset = _this$props$params9.quesOffset,
	          timer = _this$props$params9.timer,
	          testid = _this$props$params9.testid,
	          caseOffset = _this$props$params9.caseOffset,
	          isNegative = _this$props$params9.isNegative;
	
	      if (timerStart === 'true') {
	        _this.setState({
	          timerStart: 'false'
	        });
	        var pathname = _this.questionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questiono).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset).replace(':session', session).replace(':pathway', pathway).replace(':timerStart', false).replace(':isNegative', isNegative);
	
	        _this.context.router.push({
	          pathname: pathname
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: 'true'
	        });
	
	        var _pathname = _this.questionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questiono).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset).replace(':session', session).replace(':pathway', pathway).replace(':timerStart', true).replace(':isNegative', isNegative);
	
	        _this.context.router.push({
	          pathname: _pathname
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getStrikedText', data).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this2);
	        }));
	
	        return function (_x19) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: [],
	      vpCaseLoader: true,
	      questionLoader: true,
	      totalQuestionCount: 0,
	      justification1: '',
	      justification2: '',
	      disableValidate: false,
	      selectedIndex: -1,
	      showModal: false
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    _this.functionToCall = function () {};
	    _this.isPathway = _this.props.location.pathname.includes(_AppRoutes2.default.CFA3_PATHWAY_CBT);
	    _this.questionRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS : _AppRoutes2.default.CFA3_CBT_QUESTIONS;
	    _this.apiRoute = _this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams';
	    _this.gradeQuestionRoute = _this.isPathway ? _AppRoutes2.default.CFA3_PATHWAY_CBT_GRADE_QUESTIONS : _AppRoutes2.default.CFA3_CBT_GRADE_QUESTIONS;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFA3CBTQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      var _props$params = this.props.params,
	          id = _props$params.id,
	          caseno = _props$params.caseno,
	          questiono = _props$params.questiono,
	          session = _props$params.session,
	          pathway = _props$params.pathway,
	          quesOffset = _props$params.quesOffset,
	          timer = _props$params.timer,
	          testid = _props$params.testid,
	          caseOffset = _props$params.caseOffset,
	          isNegative = _props$params.isNegative,
	          timerStart = _props$params.timerStart;
	
	      if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        var pathname = this.questionRoute.replace(':id', id).replace(':caseno', caseno).replace(':questiono', questiono).replace(':timer', timer).replace(':testid', testid).replace(':caseOffset', caseOffset).replace(':quesOffset', quesOffset).replace(':session', session).replace(':pathway', pathway).replace(':isNegative', false).replace(':timerStart', timerStart);
	        this.context.router.push({
	          pathname: pathname
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: id ? parseInt(id) : null,
	        timer: seconds,
	        isNegative: isNegative,
	        id: testid ? parseInt(testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateUserTimer', data).then(function () {
	        var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(res) {
	          return _regenerator2.default.wrap(function _callee18$(_context18) {
	            while (1) {
	              switch (_context18.prev = _context18.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context18.stop();
	              }
	            }
	          }, _callee18, _this3);
	        }));
	
	        return function (_x20) {
	          return _ref18.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr,
	          casesData = _state.casesData,
	          selectedCaseQuestionData = _state.selectedCaseQuestionData,
	          showModal = _state.showModal;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var justification = userStatsData && userStatsData.justification ? JSON.parse(userStatsData.justification) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedCaseQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var topSliderSettings = (0, _cbttopnavigationsettings.caseCV)(this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1);
	      var content = selectedCaseQuestionData ? selectedCaseQuestionData.question : null;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      var parseResult = Object.keys(userChoice).map(function (x) {
	        return parseInt(x, 10);
	      });
	      var count = 0;
	      parseResult.forEach(function (element) {
	        // console.log('element -----> ', element);
	        var attemptedCount = questionsData.filter(function (item) {
	          // console.log('iteme ----> ', item);
	          if (item.id === element) {
	            count++;
	            if (questionsData.length === count) {
	              if (attemptedCaseArray.indexOf(item.case_id) === -1) {
	                attemptedCaseArray.push(item.case_id);
	
	                _this4.updateAttemptedCases();
	              }
	            }
	          }
	          return item.id === element;
	        });
	      });
	      var caseAttempted = '';
	      if (questionsData.length === count) {
	        caseAttempted = 'bg-completed-cases';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            {
	              className: (casesData ? casesData.length < 15 ? 'margin_bottom_20 ques-title-wrapper pl-0' : 'margin_bottom_20 ques-title-wrapper' : null) + ' d-flex justify-content-between'
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  onClick: function onClick() {
	                    return _this4.gradeQuestions();
	                  },
	                  className: 'pointer_class btn-primary',
	                  disabled: this.state.disabledGrading
	                },
	                'Grade Questions'
	              )
	            )
	          ) : _react2.default.createElement('div', null),
	          casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: casesData.length > 15 ? 'case-tab-wrapper px-0' : 'case-tab-wrapper px-0 padding-10'
	                  },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({}, topSliderSettings, {
	                      ref: function ref(slider) {
	                        _this4.slider = slider;
	                      }
	                      // min={8}
	                    }),
	                    casesData.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'button',
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeCase(item.id, index);
	                          },
	                          className: (attemptedCaseArray.indexOf(item.id) === -1 ? '' : 'bg-completed-cases ') + '\n                              ' + (index === parseInt(_this4.props.params.caseOffset) ? 'active button-trial' : 'button-trial')
	                        },
	                        index + 1
	                      );
	                    })
	                  )
	                )
	              ),
	              isLoading ? _react2.default.createElement(
	                'div',
	                { className: 'loader-mid full_page w-100' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block-loader' },
	                  _react2.default.createElement(_loader2.default, null)
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'case-detail-wrapper col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header d-flex justify-content-between qus-header' },
	                    selectedQuestionData && selectedQuestionData.case ? _react2.default.createElement(
	                      'div',
	                      { className: 'ques-wrapper all-ques w-100' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex align-items-center justify-content-between' },
	                        _react2.default.createElement('div', { className: 'w-70px' }),
	                        (0, _function.renderHTMLContent)(selectedQuestionData.case_name, "h1", "text-center mb-2 text-capitalize"),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right mb-2' },
	                          _react2.default.createElement('i', {
	                            className: this.props.params.caseOffset === '0' ? 'fa fa-angle-left ques_arrow pointer_class hide_block' : 'fa fa-angle-left ques_arrow pointer_class',
	                            onClick: function onClick() {
	                              return _this4.getPreviousCase(_this4.props.params.caseOffset);
	                            }
	                          }),
	                          _react2.default.createElement('i', {
	                            className: parseInt(this.props.params.caseOffset) === casesData.length - 1 ? 'fa fa-angle-right ques_arrow pointer_class hide_block' : 'fa fa-angle-right ques_arrow pointer_class',
	                            onClick: function onClick() {
	                              return _this4.getNextCase(_this4.props.params.caseOffset);
	                            }
	                          })
	                        )
	                      ),
	                      (0, _function.renderHTMLContent)(selectedQuestionData.case, "div", "font-weight-normal", { contentEditable: false })
	                    ) : null
	                  )
	                )
	              )
	            ),
	            isLoading ? '' : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'qus-tab-wrapper' },
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0];
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                            ' + (index === parseInt(_this4.props.params.quesOffset) ? 'active' : '') + '\n                            ' + (userChoice[item.id] ? 'completed-qus' : '') + '\n                            ' + (flaggedQuestions ? 'flag-add' : '') + '\n                            '
	                        },
	                        index + 1,
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : ''
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ques-detail-wrapper col-md-12 question-wrapper pr-0' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'main_loader ' + this.state.display_main_loader },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'loader-mid full_page' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'card-block-loader' },
	                              _react2.default.createElement(_loader2.default, null)
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { lg: 9 },
	                          _react2.default.createElement(
	                            _reactstrap.Col,
	                            { xs: '12', sm: '12', lg: '12' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                                className: 'margin_right_20',
	                                alt: '',
	                                width: '30'
	                              }),
	                              'Q.',
	                              parseInt(this.props.params.quesOffset) + 1
	                            )
	                          ),
	                          selectedCaseQuestionData && selectedCaseQuestionData.question_type === 'essay_question' ? _react2.default.createElement(_ViewEssayQuestions2.default, Object.assign({}, this.state, selectedCaseQuestionData, {
	                            clickOption: this.clickOption,
	                            addHighlightToText: this.addHighlightToText,
	                            selectedCaseQuestionData: selectedCaseQuestionData,
	                            setUserChoice: this.setUserChoice,
	                            userChoice: userChoice,
	                            justification: justification,
	                            setJustification: this.setJustification,
	                            justification1: this.state.justification1,
	                            justification2: this.state.justification2
	                          })) : _react2.default.createElement(_ViewNormalQuestions2.default, {
	                            selectedCaseQuestionData: selectedCaseQuestionData,
	                            clickOption: this.clickOption,
	                            addHighlightToText: this.addHighlightToText,
	                            deleteHighlightFromText: this.deleteHighlightFromText,
	                            strikeThroughArr: strikeThroughArr,
	                            userChoice: userChoice,
	                            getHighlightedText: getHighlightedText,
	                            content: content,
	                            optionsArr: _constant.optionsArr,
	                            showPopover: this.state.showPopover,
	                            selectPopover: function selectPopover() {
	                              _this4.setState({
	                                showPopover: true
	                              });
	                            },
	                            deselectPopover: function deselectPopover() {
	                              _this4.setState({
	                                showPopover: false
	                              });
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 col-lg-3 order-xs-4' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'timer_outer mb-15' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                _language2.default.LC().TIME_LEFT
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'timer_box ' + (this.props.params.isNegative === 'false' ? 'blink' : null)
	                                },
	                                this.props.params.isNegative === 'false' ? '- ' + formatTimeF : formatTimeF
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              'aria-label': timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer',
	                              className: 'tooltip_wrap mb-2 hover-pad-same\n                                ' + (timerStart === 'true' ? 'icon-control-pause pause_btn' : 'pause_btn icon-control-play'),
	                              onClick: function onClick() {
	                                return _this4.stopTimer();
	                              }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box', 'aria-hidden': 'true' },
	                              _language2.default.LC().Save_and_Take_Break
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: (selectedCaseQuestionData && selectedCaseQuestionData.question_type === 'essay_question' ? 'col-md-4' : 'col-md-4 order-xs-2 mt-md-2') + ' '
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'd-flex align-items-center mt-1' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                type: 'button',
	                                'aria-label': _language2.default.LC().SECTION_REVIEW,
	                                className: 'menu-btn tooltip-hover-questions mr-2',
	                                onClick: function onClick() {
	                                  _this4.setState({
	                                    showSectionReview: true
	                                  });
	                                }
	                              },
	                              _react2.default.createElement('img', {
	                                width: '30px',
	                                src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                                alt: ''
	                              }),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box', 'aria-hidden': 'true' },
	                                _language2.default.LC().SECTION_REVIEW
	                              )
	                            ),
	                            selectedCaseQuestionData && selectedCaseQuestionData.question_type === 'essay_question' ? _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                className: 'pointer_class btn-primary h-45px mb-0',
	                                disabled: this.state.disableValidate,
	                                onClick: function onClick() {
	                                  return _this4.updateJustification(selectedCaseQuestionData && selectedCaseQuestionData.id ? selectedCaseQuestionData.id : null);
	                                }
	                              },
	                              _messages.messages.SAVE_ANSWER
	                            ) : ''
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-8 order-xs-3' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'text-center text-sm-right btm-btn-wrapper quiz-submit-block mt-1' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'up tooltip-hover-questions quiz-flag' },
	                              flaggedQuestion ? _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box' },
	                                _language2.default.LC().UNFLAG_THIS_QUESTION
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'tootip_box' },
	                                _language2.default.LC().FLAG_THIS_QUESTION
	                              ),
	                              _react2.default.createElement(
	                                'i',
	                                {
	                                  onClick: function onClick() {
	                                    return _this4.flagQuestion(selectedCaseQuestionData);
	                                  },
	                                  className: flaggedQuestion ? 'fa fa-flag mark-action-btn' : 'fa fa-flag-o mark-action-btn'
	                                },
	                                ' '
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getPreviousQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === 0
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                              ' ',
	                              _language2.default.LC().BACK
	                            ),
	                            _react2.default.createElement(
	                              _reactstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.getNextQuestion(_this4.props.params.quesOffset);
	                                },
	                                className: 'pointer_class btn-primary',
	                                disabled: parseInt(this.props.params.quesOffset) === questionsData.length - 1
	                              },
	                              _language2.default.LC().NEXT,
	                              ' ',
	                              _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : casesData && casesData.length ? _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found mt-2' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png', alt: '' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'loader-mid full_page' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block-loader' },
	              _react2.default.createElement(_loader2.default, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _language2.default.LC().SECTION_REVIEW
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                'aria-label': 'Close section review',
	                className: 'section-review-close',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().FILTER_BY,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'filt-list-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: function onClick() {
	                    _this4.setState({
	                      filter: []
	                    });
	                  }
	                },
	                _language2.default.LC().CLEAR
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _constant.filterObj.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'plan_wrapper remove-plan', key: index },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        value: item,
	                        id: item,
	                        checked: filter.indexOf(item) > -1 ? true : false,
	                        onChange: function onChange(e) {
	                          return _this4.changeFilter(e, item);
	                        }
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' }),
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qus-tab-wrapper' },
	              questionsData.map(function (item, index) {
	                var flaggedQuestions = flag.filter(function (flag) {
	                  return flag.question_id === item.id;
	                })[0];
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  filter.includes('Attempted') && filter.includes('Unattempted') && filter.includes('Flagged') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : filter.includes('Attempted') && filter.includes('Unattempted') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'completed-qus' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : filter.includes('Unattempted') && filter.includes('Flagged') ? !userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : ///
	                  filter.includes('Attempted') && filter.includes('Flagged') ? userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : filter.includes('Attempted') ? userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'completed-qus',
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Unattempted') ? !userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Flagged') ? flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    })
	                  ) : '' : _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: this.checkSetConditionBeforeSubmitTest,
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_NextQuestionModal2.default, {
	          showModal: showModal,
	          headerText: 'Validate Your Answer',
	          bodyText: '<h5 class=\'mb-1\'>Do you wish to proceed to another question without validating your answer? </h5><p>Please note that the data you entered in the answer box will be lost.<p>',
	          closeFn: function closeFn() {
	            return _this4.setState({ showModal: false });
	          },
	          moveToNext: function moveToNext() {
	            _this4.functionToCall();
	            _this4.setState({ showModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFA3CBTQuestions;
	}(_react.Component);
	
	CFA3CBTQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFA3CBTQuestions;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChapterWiseGraph(_ref) {
	  var graphData = _ref.graphData,
	      activeTabFlashcards = _ref.activeTabFlashcards,
	      flashcardTabToggle = _ref.flashcardTabToggle;
	
	  return _react2.default.createElement(
	    'div',
	    { className: ' chart-graph-wrapper' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'overAllScore' },
	      '' + _language2.default.LC().CFACHAPTERWISERESULT
	    ),
	    _react2.default.createElement('div', { id: 'chartContainer', className: 'js-chart-wrap' }),
	    _react2.default.createElement(
	      'ul',
	      { className: 'legend-wrapper' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'square-box' }),
	        ' ',
	        _language2.default.LC().SCOREBOX
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'line-dash' }),
	        ' ',
	        _language2.default.LC().Percentile_20
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'line-dots' }),
	        ' ',
	        _language2.default.LC().Percentile_80
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'line-normal' }),
	        _language2.default.LC().YOURSCORE
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      { className: 'mt-5' },
	      'Mean Score by Topic Area'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'd-flex header-card-dashboard tab-header-wrap mt-2' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'dashboard-card-header-tab' },
	        graphData ? graphData.map(function (exam, index) {
	          return _react2.default.createElement(
	            'li',
	            {
	              onClick: function onClick() {
	                flashcardTabToggle(index + 1);
	              },
	              className: activeTabFlashcards === index + 1 ? 'active' : ''
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              exam.chapterDetails['cfa3_chapter.chapter_name'] && exam.chapterDetails['cfa3_chapter.chapter_name'].length > 8 ? exam.chapterDetails['cfa3_chapter.chapter_name'].substring(0, 8) + '..' : exam.chapterDetails['cfa3_chapter.chapter_name']
	            )
	          );
	        }) : null
	      )
	    ),
	    graphData ? graphData.map(function (exam, index) {
	      var x = void 0;
	
	      x = activeTabFlashcards === index + 1 ? _react2.default.createElement(
	        'div',
	        { className: 'card tab-body-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block dashboard-cards-scroll my-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: ' graphData' },
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam.dataOfTwentyPercentileUser ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                  ' ',
	                  _language2.default.LC().Percentile_20
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam.dataOfEightyPercentileUser ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                  ' ',
	                  _language2.default.LC().Percentile_80
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam.dataOfCurrentUser ? Math.ceil(exam.dataOfCurrentUser.Percentage) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'score-box' }),
	                  ' ',
	                  '' + _language2.default.LC().YOURSCORE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam && exam.chapterDetails && exam.chapterDetails.maxMarks ? Math.ceil(exam.averageScore / exam.chapterDetails.maxMarks * 100) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'average-box' }),
	                  ' ',
	                  _language2.default.LC().AVERAGE_SCORE
	                )
	              )
	            )
	          )
	        )
	      ) : null;
	
	      return x;
	    }) : null,
	    _react2.default.createElement(
	      'div',
	      { className: 'pt-2 text-center' },
	      _react2.default.createElement(
	        'p',
	        null,
	        _language2.default.LC().DataDetail
	      )
	    )
	  );
	}
	
	exports.default = ChapterWiseGraph;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphConstants = __webpack_require__(266);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ChapterWiseGraph = __webpack_require__(572);
	
	var _ChapterWiseGraph2 = _interopRequireDefault(_ChapterWiseGraph);
	
	var _constant = __webpack_require__(9);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainGraph = function (_Component) {
	  _inherits(MainGraph, _Component);
	
	  function MainGraph(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MainGraph);
	
	    var _this = _possibleConstructorReturn(this, (MainGraph.__proto__ || Object.getPrototypeOf(MainGraph)).call(this, props));
	
	    _this.getGraphData = function (data) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + (_this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams') + '/getCBTMockUserGraphChapterWise', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          var totalQuestions;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  console.log('res', res);
	                  if (res.graphData.length > 6) {
	                    _this.setState({
	                      labelAngle: -90
	                    });
	                  }
	                  totalQuestions = _this.props.params.totalQuestions;
	
	                  _this.setState({
	                    isLoading: false,
	                    totalQuestionsChapterwise: totalQuestions,
	                    graphData: res.graphData,
	                    averageoverAll: res.graphData
	                  });
	                  _this.formatData(res);
	
	                case 5:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatData = function (res) {
	      // console.log('res ------> ', res);
	      var graphData = res.graphData;
	
	
	      var initialValue = 0;
	      // Reference line for 70%
	
	      //20% line chaptervise graph
	      var dataOfTwenty = {
	        showInLegend: false,
	
	        name: '20%',
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line chaptervise graph
	      var dataOfEighty = {
	        showInLegend: false,
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //Userscore line chaptervise graph
	      var UserScore = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	
	      var UserScoreBox2 = {
	        showInLegend: false,
	        // legendMarkerType: 'square',
	        name: '' + _language2.default.LC().GRAPHSCOREBOX,
	        type: 'rangeColumn',
	        color: '#cce7f5',
	        dataPoints: []
	      };
	      initialValue = -10;
	      // console.log('graphData -------------> ', graphData);
	      var graphDataLength = graphData && graphData.length ? graphData.length : 0;
	      for (var k = 0; k < graphDataLength; k++) {
	        var scoreBoxSize = _this.state.scoreBoxSize;
	
	        console.log('graphData[k].dataOfCurrentUser', graphData[k].dataOfCurrentUser);
	        UserScoreBox2.dataPoints.push({
	          x: initialValue + 15,
	          label: '' + graphData[k].chapterDetails['cfa3_chapter.chapter_name'],
	          y: [graphData[k].dataOfCurrentUser.Percentage - scoreBoxSize, graphData[k].dataOfCurrentUser.Percentage + scoreBoxSize]
	        });
	        var dataOfCurrentUserLineStart = {
	          x: initialValue + 15 - 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineMid = {
	          x: initialValue + 15 + 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineEnd = {
	          x: initialValue + 15 + 1.5,
	          y: null
	        };
	        UserScore.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	        initialValue += 15;
	      }
	      initialValue = 0;
	      for (var i = 0; i < graphDataLength; i++) {
	        var dataOfTwentyPercentileUserlineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineEnd = {
	          x: initialValue + 10,
	
	          y: null
	        };
	        dataOfTwenty.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	        var dataOfEightyPercentileUserLineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineEnd = {
	          x: initialValue + 10,
	          y: null
	        };
	        dataOfEighty.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	
	        initialValue += 15;
	      }
	      var data = [];
	      console.log('UserScoreBox2', UserScoreBox2);
	      data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, _graphConstants.referenceLine);
	
	      _this.setState({
	        dataPoints: data
	      }, function () {
	        _this.showGraph(); //Show chaptervise graph
	      });
	    };
	
	    _this.showGraph = function () {
	      var dataPoints = _this.state.dataPoints;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainer', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: Object.assign({}, _constant.canvasjsConfig.axisX, {
	          labelAngle: _this.state.labelAngle,
	          labelFontSize: _this.state.labelFontSize
	        }),
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        data: dataPoints,
	
	        dataPointMaxWidth: 60,
	        dataPointWidth: 60,
	        dataPointMinWidth: 60,
	        legend: {
	          fontSize: 18
	        },
	        interactivityEnabled: false
	      });
	
	      chart.render();
	    };
	
	    _this.flashcardTabToggle = function (tab) {
	      var activeTabFlashcards = _this.state.activeTabFlashcards;
	
	      if (activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.state = {
	      graphData: [],
	      activeTabFlashcards: 1,
	      scoreBoxSize: 5
	    };
	    _this.isPathway = _this.props.location.pathname.includes(_AppRoutes2.default.CFA3_PATHWAY_CBT);
	
	    return _this;
	  }
	
	  _createClass(MainGraph, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var w = window.innerWidth;
	      this.setState((0, _graphConstants.getLabelAngleWithFontSize)(w));
	
	      var tokenData = (0, _graphConstants.getTokenData)();
	      this.setState(tokenData);
	
	      var _props$params = this.props.params,
	          _props$params$id = _props$params.id,
	          id = _props$params$id === undefined ? 0 : _props$params$id,
	          _props$params$test_id = _props$params.test_id,
	          test_id = _props$params$test_id === undefined ? 0 : _props$params$test_id,
	          totalQuestions = _props$params.totalQuestions,
	          _props$params$timer = _props$params.timer,
	          timer = _props$params$timer === undefined ? 0 : _props$params$timer,
	          isNegative = _props$params.isNegative;
	
	
	      var data = Object.assign({}, tokenData, {
	        mock_id: parseInt(id, 10),
	        test_id: parseInt(test_id, 10),
	        totalQuestion: parseInt(totalQuestions, 10),
	        timer: parseInt(timer, 10),
	        isNegative: isNegative
	      });
	      this.getGraphData(data);
	    }
	    // get data for chaptervise graph
	
	
	    //Format data as requirement
	
	
	    // show graph chaptervise graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          graphData = _state.graphData,
	          activeTabFlashcards = _state.activeTabFlashcards;
	
	      return _react2.default.createElement(_ChapterWiseGraph2.default, {
	        graphData: graphData,
	        flashcardTabToggle: this.flashcardTabToggle,
	        activeTabFlashcards: activeTabFlashcards
	      });
	    }
	  }]);
	
	  return MainGraph;
	}(_react.Component);
	
	exports.default = MainGraph;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OverallGraph(_ref) {
	  var average = _ref.average,
	      totalMarks = _ref.totalMarks,
	      dataOfCurrentUser = _ref.dataOfCurrentUser,
	      dataOfTwentyPercentileUser = _ref.dataOfTwentyPercentileUser,
	      dataOfEightyPercentileUser = _ref.dataOfEightyPercentileUser;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'chart-graph-wrapper' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'overAllScore' },
	      '' + _language2.default.LC().OVERALLRESULT
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6' },
	        ' ',
	        _react2.default.createElement('div', { id: 'chartContainerOverAllGraph', className: 'js-chart-wrap' }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'legend-wrapper' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('span', { className: 'square-box' }),
	            ' ',
	            _language2.default.LC().SCOREBOX
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('span', { className: 'line-dash' }),
	            ' ',
	            _language2.default.LC().Percentile_20
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('span', { className: 'line-dots' }),
	            ' ',
	            _language2.default.LC().Percentile_80
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('span', { className: 'line-normal' }),
	            ' ',
	            _language2.default.LC().YOURSCORE
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6' },
	        _react2.default.createElement(
	          'div',
	          { className: ' graphData' },
	          _react2.default.createElement(
	            'div',
	            { className: 'graphScoreData' },
	            _react2.default.createElement(
	              'div',
	              { className: 'graphScore' },
	              (dataOfTwentyPercentileUser ? Math.ceil(dataOfTwentyPercentileUser / totalMarks * 100) : 0) + '%'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graphLabel' },
	              _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	              ' ',
	              _language2.default.LC().Percentile_20
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'graphScoreData' },
	            _react2.default.createElement(
	              'div',
	              { className: 'graphScore' },
	              (dataOfEightyPercentileUser ? Math.ceil(dataOfEightyPercentileUser / totalMarks * 100) : 0) + '%'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graphLabel' },
	              _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	              ' ',
	              _language2.default.LC().Percentile_80
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'graphScoreData' },
	            _react2.default.createElement(
	              'div',
	              { className: 'graphScore' },
	              (dataOfCurrentUser ? Math.ceil(dataOfCurrentUser / totalMarks * 100) : 0) + '%'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graphLabel' },
	              _react2.default.createElement('span', { className: 'score-box' }),
	              ' ',
	              '' + _language2.default.LC().YOURSCORE
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'graphScoreData' },
	            _react2.default.createElement(
	              'div',
	              { className: 'graphScore' },
	              (dataOfCurrentUser ? Math.ceil(average / totalMarks * 100) : 0) + '%'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'graphLabel' },
	              _react2.default.createElement('span', { className: 'average-box' }),
	              ' ',
	              _language2.default.LC().AVERAGE_SCORE
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = OverallGraph;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphConstants = __webpack_require__(266);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _constant = __webpack_require__(9);
	
	var _toast = __webpack_require__(15);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _OverallGraph = __webpack_require__(574);
	
	var _OverallGraph2 = _interopRequireDefault(_OverallGraph);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverallCanvasGraph = function (_Component) {
	  _inherits(OverallCanvasGraph, _Component);
	
	  function OverallCanvasGraph(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, OverallCanvasGraph);
	
	    var _this = _possibleConstructorReturn(this, (OverallCanvasGraph.__proto__ || Object.getPrototypeOf(OverallCanvasGraph)).call(this, props));
	
	    _this.getGraphoverAllGraphData = function (data) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + (_this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams') + '/getCBTMockUserGraph', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          var totalQuestions, _res$graphData$averag, averageScore;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.graphData) {
	                    totalQuestions = _this.props.params.totalQuestions;
	                    _res$graphData$averag = res.graphData.averageScore, averageScore = _res$graphData$averag === undefined ? 0 : _res$graphData$averag;
	
	                    _this.setState({
	                      //   isLoading: false,
	                      totalQuestions: totalQuestions,
	                      average: averageScore
	                    });
	                    _this.formatoverAllGraphData(res);
	                  } else (0, _toast.showFailure)(res.message);
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatoverAllGraphData = function (res) {
	      var graphData = res.graphData;
	
	
	      _this.setState({
	        dataOfCurrentUser: graphData ? graphData.dataOfCurrentUser.score : _this.state.dataOfCurrentUser,
	        dataOfEightyPercentileUser: graphData ? graphData.dataOfEightyPercentileUser.score : _this.state.dataOfEightyPercentileUser,
	        dataOfTwentyPercentileUser: graphData ? graphData.dataOfTwentyPercentileUser.score : _this.state.dataOfTwentyPercentileUser
	      });
	      var totalMarks = _this.props.params.totalMarks;
	
	      var temp = [graphData];
	      graphData = temp;
	
	      //User score line
	      var UserScoreOverAllGraph = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User score box
	
	      var scorePercentage = graphData[0].dataOfCurrentUser.score == null ? 0 : Math.ceil(graphData[0].dataOfCurrentUser.score / totalMarks * 100);
	
	      var UserScoreBoxOverAllGraph2 = {
	        type: 'rangeColumn',
	
	        color: 'hsl(200deg 67% 88%)',
	        dataPoints: []
	      };
	
	      UserScoreBoxOverAllGraph2.dataPoints.push({
	        x: 1.39,
	
	        y: [scorePercentage - 5, scorePercentage + 5]
	      });
	
	      var dataOfCurrentUserLineStart = {
	        x: -0.2,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineMid = {
	        x: 2.8,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineEnd = {
	        x: 2.8,
	        y: null
	      };
	
	      UserScoreOverAllGraph.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	
	      var dataOfTwentyPercentileUserlineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalMarks * 100)
	      };
	      var dataOfTwentyPercentileUserlineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalMarks * 100)
	      };
	      var dataOfTwentyPercentileUserlineEnd = {
	        x: 7,
	        y: null
	      };
	      var twentyPercentLineObj = Object.assign({}, _graphConstants.twentyPercentLine, { dataPoints: [] });
	
	      twentyPercentLineObj.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	      var dataOfEightyPercentileUserLineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalMarks * 100)
	      };
	      var dataOfEightyPercentileUserLineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalMarks * 100)
	      };
	
	      var dataOfEightyPercentileUserLineEnd = {
	        x: 7,
	        y: null
	      };
	      var eightyPercentLineObj = Object.assign({}, _graphConstants.eightyPercentLine, { dataPoints: [] });
	      eightyPercentLineObj.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	      var overAllGraphData = [];
	      overAllGraphData.push(UserScoreBoxOverAllGraph2, twentyPercentLineObj, eightyPercentLineObj, UserScoreOverAllGraph, _graphConstants.referenceLine);
	
	      console.log('overAllGraphData', overAllGraphData);
	      _this.setState({
	        dataPointsOverAllGraph: overAllGraphData
	      }, function () {
	        _this.showGraphOverAll(); //Show overall graph
	      });
	    };
	
	    _this.showGraphOverAll = function () {
	      var dataPointsOverAllGraph = _this.state.dataPointsOverAllGraph;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: _constant.canvasjsConfig.axisX,
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        dataPointWidth: 90,
	        dataPointMaxWidth: 80,
	        dataPointMinWidth: 80,
	        legend: {
	          fontSize: 18
	        },
	        data: dataPointsOverAllGraph,
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.state = {
	      dataPointsOverAllGraph: []
	    };
	    _this.isPathway = _this.props.location.pathname.includes(_AppRoutes2.default.CFA3_PATHWAY_CBT);
	
	    return _this;
	  }
	
	  _createClass(OverallCanvasGraph, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var tokenData = (0, _graphConstants.getTokenData)();
	      this.setState(tokenData);
	      var _props$params = this.props.params,
	          _props$params$id = _props$params.id,
	          id = _props$params$id === undefined ? 0 : _props$params$id,
	          _props$params$test_id = _props$params.test_id,
	          test_id = _props$params$test_id === undefined ? 0 : _props$params$test_id,
	          totalQuestions = _props$params.totalQuestions,
	          _props$params$timer = _props$params.timer,
	          timer = _props$params$timer === undefined ? 0 : _props$params$timer,
	          isNegative = _props$params.isNegative;
	
	      var data = Object.assign({}, tokenData, {
	        mock_id: parseInt(id, 10),
	        test_id: parseInt(test_id, 10),
	        totalQuestion: parseInt(totalQuestions, 10),
	        timer: parseInt(timer, 10),
	        isNegative: isNegative
	      });
	      this.getGraphoverAllGraphData(data);
	    }
	
	    //format data as requirement for overall graph
	
	
	    //Show overall graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          average = _state.average,
	          dataOfCurrentUser = _state.dataOfCurrentUser,
	          dataOfEightyPercentileUser = _state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser = _state.dataOfTwentyPercentileUser;
	      var _props$params$totalMa = this.props.params.totalMarks,
	          totalMarks = _props$params$totalMa === undefined ? 1 : _props$params$totalMa;
	
	
	      return _react2.default.createElement(_OverallGraph2.default, {
	        average: average,
	        totalMarks: totalMarks,
	        dataOfCurrentUser: dataOfCurrentUser,
	        dataOfTwentyPercentileUser: dataOfTwentyPercentileUser,
	        dataOfEightyPercentileUser: dataOfEightyPercentileUser
	      });
	    }
	  }]);
	
	  return OverallCanvasGraph;
	}(_react.Component);
	
	exports.default = OverallCanvasGraph;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OverallGraph = __webpack_require__(575);
	
	var _OverallGraph2 = _interopRequireDefault(_OverallGraph);
	
	var _ChapterWiseGraph = __webpack_require__(573);
	
	var _ChapterWiseGraph2 = _interopRequireDefault(_ChapterWiseGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CFA3CBTResult(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_OverallGraph2.default, props),
	    _react2.default.createElement(_ChapterWiseGraph2.default, props)
	  );
	}
	
	exports.default = CFA3CBTResult;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _constant = __webpack_require__(9);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.getQuestions = function (data) {
	      _this.setState({
	        isDataLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            questionsData: resp.question,
	            totalCount: resp.question.length,
	            selectedQuestionData: resp.question[_this.props.params.offset],
	            isLoading: false,
	            isDataLoading: false
	          });
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data
	          });
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.componentDidMount = function () {
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _this.getQuestions(data);
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      _this.timer = setInterval(_this.countDown, 1000);
	      var ansdata = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        if (resp_count.success) {
	          _this.setState({
	            rightanswercount: resp_count.allrightanswercount.question_count
	          });
	        } else {
	          console.log(resp_count.success + '------------failure');
	        }
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _this.setState({
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                  });
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	      _this.getUserStats();
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: '/frm/cbtquestionsfinish/' + _this.props.params.id + '/' + questionNumber + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + index
	        });
	      }
	    };
	
	    _this.getPrevious = function (index) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	      _this.slider.slickGoTo(index - 2);
	      var questionsData = _this.state.questionsData;
	
	      _this.context.router.push({
	        pathname: '/frm/cbtquestionsfinish/' + _this.props.params.id + '/' + (_this.props.params.offset ? questionsData[parseInt(_this.props.params.offset) - 1].id : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + (_this.props.params.offset ? parseInt(_this.props.params.offset) - 1 : 1)
	      });
	    };
	
	    _this.getNext = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(index) {
	        var questionsData;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.setState({ report_block: 'card hide_block', successAlert: false });
	                _this.slider.slickGoTo(index);
	                questionsData = _this.state.questionsData;
	
	                _this.context.router.push({
	                  pathname: '/frm/cbtquestionsfinish/' + _this.props.params.id + '/' + (_this.props.params.offset ? questionsData[parseInt(_this.props.params.offset) + 1].id : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + (_this.props.params.offset ? parseInt(_this.props.params.offset) + 1 : 1)
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.backToMock = function () {
	      _this.context.router.push({
	        pathname: '/frm/viewattemptedmock/' + _this.props.params.id + '/' + _this.props.params.timer + '/' + _this.props.params.level
	      });
	    };
	
	    _this.getDetailedResultGraph = function (totalQuestion) {
	      var _this$props$params = _this.props.params,
	          id = _this$props$params.id,
	          testid = _this$props$params.testid,
	          level = _this$props$params.level,
	          timer = _this$props$params.timer;
	
	      var path = _AppRoutes2.default.FRM_DETAILED_RESULT_GRAPH.replace(':id', id).replace(':test_id', testid).replace(':totalQuestions', totalQuestion).replace(':level', level).replace(':timer', timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getReadingViseScore = function () {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getrightAnswerReadingVise', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var temp, arr;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  temp = 0;
	                  arr = res.readingName.map(function (item, i) {
	                    if (res.allrightanswercount.some(function (ele) {
	                      return ele.id === item.id;
	                    })) {
	                      return Object.assign({}, item, res.allrightanswercount[temp++]);
	                    } else return Object.assign({}, item, 0);
	                  });
	
	                  _this.setState({
	                    readingViseScore: arr
	                  });
	
	                case 3:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x3) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this2);
	        }));
	
	        return function (_x4) {
	          return _ref4.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.offset !== _this.props.params.offset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	          level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	        };
	        _this.getQuestions(data);
	      }
	    };
	
	    _this.reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      // console.log("function calling...", comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: id,
	        comment: comment,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	        offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : 0,
	        timer: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : 0,
	        mockName: _this.state.mockName
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this.handleScroll = function () {
	      window.scroll({
	        top: document.body.offsetHeight,
	        left: 0,
	        behavior: 'smooth'
	      });
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      reportLoading: false,
	      time: {},
	      seconds: 100,
	      showFinishTestPopup: false,
	      showAnswer: false,
	      rightanswercount: '',
	      text: '',
	      mockName: '',
	      showSectionReview: false,
	      readingViseScore: [],
	      selectedQuestionData: [],
	      successAlert: false,
	      report_block: 'card hide_block'
	    };
	    _this.timer = 0;
	    // this.countDown = this.countDown.bind(this);
	    return _this;
	  }
	  //it is use to redirect page
	
	
	  //Function to hide Report box
	
	
	  //Function to show Report box
	
	
	  _createClass(CFAQuestions, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          userStatsData = _state.userStatsData,
	          rightanswercount = _state.rightanswercount,
	          mockName = _state.mockName,
	          showSectionReview = _state.showSectionReview,
	          readingViseScore = _state.readingViseScore,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          flag = _state.flag,
	          reportLoading = _state.reportLoading;
	      var question_ids = userStatsData.question_ids;
	
	      var totalAvailableQuestions = question_ids && JSON.parse(question_ids).length || questionsData && questionsData.length || 0;
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var userTime = 0;
	      if (userStatsData && userStatsData.user_time_value && this.props.params.timer) {
	        if (userStatsData.isNegative === 'true') {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) - userStatsData.user_time_value);
	        } else {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) + userStatsData.user_time_value);
	        }
	      }
	      var percentage = rightanswercount * 100 / totalAvailableQuestions;
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'pointer_class btn-primary back-btn',
	                  onClick: function onClick() {
	                    return _this3.backToMock();
	                  }
	                },
	                _language2.default.LC().BACK
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : questionsData && questionsData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this3.slider = slider;
	                    }
	                  }),
	                  ' ',
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag && flag.length ? flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0] : '';
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          onClick: function onClick() {
	                            return _this3.changeQuestion(item.id, index);
	                          },
	                          className: '\n                        ' + (index === parseInt(_this3.props.params.offset) ? 'active' : '') + '\n                        ' + (userChoice[item.id] === item.answer ? 'right-ans' : userChoice[item.id] ? 'wrong-ans' : 'not-ans') + '\n                        ' + (flaggedQuestions ? 'flag-add' : '') + '\n                        '
	                        },
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : '',
	                        index + 1
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12' },
	                isDataLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header qus-header finish-question-wrapper' },
	                    selectedQuestionData && selectedQuestionData.question ? _react2.default.createElement(
	                      'div',
	                      { className: 'qus-wrapper ques-bold-remove d-block' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_right_20',
	                          alt: '',
	                          width: '30'
	                        }),
	                        'Q.',
	                        parseInt(this.props.params.offset) + 1
	                      ),
	                      (0, _function.renderHTMLContent)(selectedQuestionData.question, "div", "qus-title w-100", { contentEditable: false, style: { marginTop: "8px" } })
	                    ) : null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'btn btn-primary pointer_class mid-btn',
	                          onClick: function onClick() {
	                            _this3.setState({
	                              showSectionReview: true
	                            });
	                            _this3.getReadingViseScore();
	                          }
	                        },
	                        _language2.default.LC().SCORE
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_MYSCORE_Book
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap tooltip_wrap_margin' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: rightanswercount ? rightanswercount === 0 ? true : false : true,
	                          className: rightanswercount === 0 ? 'cursor_not_Allowed btn btn-primary  mid-btn' : 'btn btn-primary mid-btn',
	                          onClick: function onClick() {
	                            return _this3.getDetailedResultGraph(totalAvailableQuestions);
	                          }
	                        },
	                        _language2.default.LC().GRAPH
	                      ),
	                      rightanswercount ? rightanswercount === 0 ? null : _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_GRAPH
	                      ) : null
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _constant.frmOptionsArr.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-12', id: item, key: index },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box cursor-default ' + (userChoice ? selectedQuestionData && selectedQuestionData.answer === item && userChoice[_this3.props.params.questiono] === item ? 'border-green' : selectedQuestionData.answer === item ? 'border-green' : userChoice[_this3.props.params.questiono] === item ? 'border-red' : '' : '')
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : item === 'choice_c' ? _language2.default.LC().C : _language2.default.LC().D
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  { className: 'ans_box_text' },
	                                  selectedQuestionData && selectedQuestionData[item] ? (0, _function.renderHTMLContent)(selectedQuestionData[item], "span", "", { contentEditable: false }) : null
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'score-wrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'score-inner' },
	                            rightanswercount ? rightanswercount : 0,
	                            '/',
	                            totalAvailableQuestions
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().You_Scored,
	                            ' ',
	                            Math.ceil(percentage),
	                            '%'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer finished-time' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              _language2.default.LC().TEST_COMPLETED_IN
	                            ),
	                            _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'timer_box' },
	                              userTime
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            'span',
	                            {
	                              className: 'up tooltip-hover-questions',
	                              style: { padding: '10px' }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              ' ',
	                              _language2.default.LC().REPORT_THIS_QUESTION,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'report-icon-wrapper',
	                                onClick: function onClick() {
	                                  _this3.handleScroll();
	                                  _this3.setState({
	                                    report_block: 'card show_block'
	                                  });
	                                }
	                              },
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/report4.png',
	                                alt: 'report'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this3.getPrevious(_this3.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this3.getNext(_this3.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card show_block' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'card-header  ' + (userChoice && userChoice[this.props.params.questiono] === selectedQuestionData.answer ? 'text_success-cbt' : !userChoice[this.props.params.questiono] ? 'text_unAttempted-cbt' : 'text_failure-cbt')
	                },
	                userChoice && userChoice[this.props.params.questiono] === selectedQuestionData.answer ? '' + _language2.default.LC().Correct : !userChoice[this.props.params.questiono] ? '' + _language2.default.LC().NOT_ATTEMPTED : '' + _language2.default.LC().Incorrect
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                selectedQuestionData && selectedQuestionData.explanation ? (0, _function.renderHTMLContent)(selectedQuestionData.explanation, "p", "view_questionhtml", { contentEditable: false }) : ""
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: function onClick() {
	                              return _this3.reportQuestion(selectedQuestionData.id);
	                            }
	                          },
	                          reportLoading ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                            ' ',
	                            _language2.default.LC().PLEASE_WAIT
	                          ) : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'sidebar-review-wrapper sidebar-score-wrapper ' + (showSectionReview ? 'active' : '')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              ' ',
	              _language2.default.LC().BOOK_WISE_SCORE
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'cursor-pointer',
	                onClick: function onClick() {
	                  _this3.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'score-list-wrapper' },
	              readingViseScore && readingViseScore.length ? readingViseScore.map(function (item, index) {
	                var readingPercentage = item.question_count * 100 / item.frm_cbt_questions.length || 0;
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      index + 1,
	                      '\xA0 ',
	                      item.chapter_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress custom-prog-bar margin_top_5' },
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'progress-bar',
	                          role: 'progressbar',
	                          style: {
	                            width: (readingPercentage ? Math.ceil(readingPercentage) : '0') + '%'
	                          },
	                          'aria-valuenow': (readingPercentage ? Math.ceil(readingPercentage) : '0') + '%',
	                          'aria-valuemin': '0%',
	                          'aria-valuemax': '100%'
	                        },
	                        readingPercentage ? Math.ceil(readingPercentage) : '0',
	                        '%'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'score-inner' },
	                    item.question_count ? item.question_count : 0,
	                    '/',
	                    item.frm_cbt_questions ? item.frm_cbt_questions.length : 0
	                  )
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-qus-found no-mock-exam mt-5' },
	                _react2.default.createElement('img', {
	                  width: '62px',
	                  src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'mt-1' },
	                  _language2.default.LC().NO_SCORE_FOUND
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntoductionInstruction = function (_Component) {
	  _inherits(IntoductionInstruction, _Component);
	
	  function IntoductionInstruction(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, IntoductionInstruction);
	
	    var _this = _possibleConstructorReturn(this, (IntoductionInstruction.__proto__ || Object.getPrototypeOf(IntoductionInstruction)).call(this, props));
	
	    _this.componentDidMount = function () {
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	    };
	
	    _this.changeQuestion = function (questionNumber) {
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: '/frm/introduction/' + _this.props.params.id + '/' + questionNumber + '/' + _this.props.params.timer + '/' + _this.props.params.level
	        });
	      }
	    };
	
	    _this.getPrevious = function (index) {
	      _this.context.router.push({
	        pathname: '/frm/introduction/' + _this.props.params.id + '/' + (_this.props.params.questiono ? parseInt(_this.props.params.questiono, 10) - 1 : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level
	      });
	    };
	
	    _this.getNext = function (questionNumber) {
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: '/frm/introduction/' + _this.props.params.id + '/' + (_this.props.params.questiono ? parseInt(_this.props.params.questiono, 10) + 1 : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level
	        });
	      }
	    };
	
	    _this.startTest = function () {
	      _this.setState({
	        startLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id, 10) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level, 10) : null
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id, 10) : null,
	        status: 'pending',
	        level: _this.props.params.level ? parseInt(_this.props.params.level, 10) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            startLoading: true
	          });
	          var _response$question = response.question,
	              question = _response$question === undefined ? [] : _response$question;
	
	          var questionIds = question.map(function (questionDetail) {
	            return questionDetail.id;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/addUsersChoice', Object.assign({}, userData, { questionIds: questionIds })).then(function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	              return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      if (res.success) {
	                        _this.context.router.push({
	                          pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + (response.question && response.question.length ? response.question[0].id : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + res.id + '/0/true/true'
	                        });
	                      }
	
	                    case 1:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, _this2);
	            }));
	
	            return function (_x) {
	              return _ref.apply(this, arguments);
	            };
	          }());
	        }
	      });
	    };
	
	    _this.strikeText = function (e, value) {
	      e.preventDefault();
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      if (e.type === 'contextmenu') {
	        strikeThroughArr.push(value);
	        _this.setState({
	          strikeThroughArr: strikeThroughArr
	        });
	      } else {
	        return;
	      }
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      token: '',
	      idname: '',
	      startLoading: false,
	      strikeThroughArr: []
	    };
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(IntoductionInstruction, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          startLoading = _state.startLoading,
	          strikeThroughArr = _state.strikeThroughArr;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().Section_Introduction
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                Array.from({ length: 12 }, function (item) {
	                  return item;
	                }).map(function (item, index) {
	                  return _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      key: index,
	                      onClick: function onClick() {
	                        return _this3.changeQuestion(index + 1);
	                      },
	                      className: '' + (index + 1 === parseInt(_this3.props.params.questiono, 0) ? 'active' : '')
	                    },
	                    index + 1
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper intro-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  this.props.params.questiono === '1' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().INTROTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().INTROPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTTOCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '2' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().WELCOMETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().WELCOMEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '3' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().USEMOUSETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_arrow.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().USEMOUSEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '4' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().NAVIGATTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_tab_btn.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-2' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '5' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TIMEREMAINTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARAONE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'time-left-img',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_time.png',
	                              alt: ''
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARATWO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '6' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().FLAGTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag.png',
	                              alt: ''
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag_btn.png',
	                              alt: ''
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGBUTTON, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '7' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ANSWERMULTTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ANSWERMULTPARA, "div", "", { contentEditable: false })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'h6',
	                            null,
	                            _language2.default.LC().QUESMULTTITLE
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().A
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().ESTONIA
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().B
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().UKRAINE
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().C
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().BELGIUM
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '8' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().REVIEWTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              width: '38px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARACLOSE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'section-review',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_sidebar.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '9' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().HIGHLIGHTINGTEXT
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().HIGHLIGHTINGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'mw-100',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_highlight.png',
	                              alt: 'Highlight'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().PLEASENOTE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '10' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().STRIKINGOUTOPTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().STRIKINGOUTOPTIONSPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                _language2.default.LC().QUESMULTTITLE
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().A
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_a') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().ESTONIA
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().B
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_b') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().UKRAINE
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_c') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().BELGIUM
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '11' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ENDINGEXAMTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ENDINGEXAMPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '12' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TUTORIALCONCLUSIONTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TUTORIALCONCLUSIONPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().CLICKSTARTTEST
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getPrevious,
	                              className: 'pointer_class btn-primary',
	                              disabled: this.props.params.questiono === '1'
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getNext,
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.questiono, 0) === 12
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                _this3.startTest();
	                              },
	                              className: 'pointer_class btn-primary'
	                            },
	                            startLoading ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : '',
	                            ' ',
	                            _language2.default.LC().START_TEST,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IntoductionInstruction;
	}(_react.Component);
	
	IntoductionInstruction.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = IntoductionInstruction;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _reactstrap = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBTMockExams = function (_Component) {
	  _inherits(CBTMockExams, _Component);
	
	  function CBTMockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTMockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExams.__proto__ || Object.getPrototypeOf(CBTMockExams)).call(this, props));
	
	    _this.getQuestions = function (mock) {
	      _this.setState({
	        showInstructionModal: false
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, subscriptionStatus, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        _context.next = 4;
	                        return _FrmSubscription4.default.checkFrm(mock.level, exam_data);
	
	                      case 4:
	                        subscriptionStatus = _context.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription, mock.level);
	
	                        if (subscriptionStatus || hasMockAccess) {
	                          _this._runCode('paid', mock);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            //console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var _data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var _dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: _data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(mock.level, exam_data);
	                if (subscriptionStatus) {
	                  _this._runCode('paid', mock);
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus, mock) {
	      if (subscriptionstatus === 'paid') {
	        _this.context.router.push({
	          pathname: '/introduction/' + mock.id + '/1/' + mock.timer
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function (mock) {
	      _this.setState({
	        showInstructionModal: true,
	        mockData: mock
	      });
	    };
	
	    _this.viewAttemptedExams = function (mock) {
	      _this.context.router.push({
	        pathname: '/frm/viewattemptedmock/' + mock.id + '/' + mock.timer + '/' + mock.level
	      });
	    };
	
	    _this.openQPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/MockQPdfDownload', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQ: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQ: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.openQAPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/MockQAPdfDownload', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQA: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQA: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.checkSubscription = function (mock, type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, subscriptionStatus, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        _context2.next = 4;
	                        return _FrmSubscription4.default.checkFrm(mock.level, exam_data);
	
	                      case 4:
	                        subscriptionStatus = _context2.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription, mock.level);
	
	                        if (subscriptionStatus || hasMockAccess) {
	                          if (type === 'Q') {
	                            _this.openQPDF(mock.id);
	                          } else {
	                            _this.openQAPDF(mock.id);
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            //console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var _data_arr2 = JSON.parse(resp.profileInfo.exam_selected);
	            var _dataset2 = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: _data_arr2
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset2).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(mock.level, exam_data);
	                if (subscriptionStatus) {
	                  if (type === 'Q') {
	                    _this.openQPDF(mock.id);
	                  } else {
	                    _this.openQAPDF(mock.id);
	                  }
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.toggle = function (index) {
	      _this.setState({
	        dropdownOpenIndex: index,
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    var messageTitle_frm = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: messageTitle_frm,
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'frm',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      pdfLoadingQ: false,
	      pdfLoadingQA: false,
	      pdfMessage: '',
	      pdfMessageOpen: false,
	      dropdownOpen: false,
	      dropdownOpenIndex: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.togglePdfMessage = _this.togglePdfMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBTMockExams, [{
	    key: 'togglePdfMessage',
	    value: function togglePdfMessage() {
	      this.setState({ pdfMessageOpen: !this.state.pdfMessageOpen });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: 'componentDidMount',
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // get level 1 mocks
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRMMockExams', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.mock,
	                      isLoading: false,
	                      userStatsData: resp.userstats
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	                // get level 2 mocks
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRM2MockExams', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList2: resp.mock,
	                      isLoading: false,
	                      userStatsData: resp.userstats
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockData = _state.mockData,
	          mockList2 = _state.mockList2,
	          dropdownOpen = _state.dropdownOpen,
	          dropdownOpenIndex = _state.dropdownOpenIndex;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          ' ',
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().FRM1_MOCK_LIST
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive min-max-510' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _language2.default.LC().MOCKEXAM
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList.length ? mockList.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id,
	                              '.'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.mock_exam,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                  onClick: function onClick() {
	                                    return _this4.viewAttemptedExams(item);
	                                  }
	                                },
	                                _language2.default.LC().START
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'privetinfo-dropdown' },
	                                _react2.default.createElement(
	                                  _reactstrap.ButtonDropdown,
	                                  {
	                                    className: index + 1 === mockList.length ? 'dropup' : '',
	                                    isOpen: dropdownOpenIndex === item.id ? dropdownOpen : false,
	                                    toggle: function toggle() {
	                                      return _this4.toggle(item.id);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownToggle,
	                                    {
	                                      className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                      caret: true
	                                    },
	                                    _language2.default.LC().PRINT
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownMenu,
	                                    { right: true },
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'public',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item, 'Q');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_Q_MOCK
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'private',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item, 'QA');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_QA_MOCK
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            {
	                              colSpan: '4',
	                              className: 'text-center py-4 px-2'
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _language2.default.LC().No_Mock_Exams
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().FRM2_MOCK_LIST
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive min-max-510' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _language2.default.LC().MOCKEXAM
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList2 && mockList2.length ? mockList2.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id,
	                              '.'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.mock_exam,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                  onClick: function onClick() {
	                                    return _this4.viewAttemptedExams(item);
	                                  }
	                                },
	                                _language2.default.LC().START
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'privetinfo-dropdown' },
	                                _react2.default.createElement(
	                                  _reactstrap.ButtonDropdown,
	                                  {
	                                    className: index + 1 === mockList2.length ? 'dropup' : '',
	                                    isOpen: dropdownOpenIndex === item.id ? dropdownOpen : false,
	                                    toggle: function toggle() {
	                                      return _this4.toggle(item.id);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownToggle,
	                                    {
	                                      className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                      caret: true
	                                    },
	                                    _language2.default.LC().PRINT
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownMenu,
	                                    { right: true },
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'public',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item, 'Q');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_Q_MOCK
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'private',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item, 'QA');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_QA_MOCK
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            {
	                              colSpan: '4',
	                              className: 'text-center py-4 px-2'
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _language2.default.LC().No_Mock_Exams
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.pdfMessageOpen,
	            toggle: this.togglePdfMessage,
	            className: 'modal-primary custom_modalpro info-modal-designing'
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.togglePdfMessage, className: 'custom-title' },
	            'Information'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-info-view-for-plan' },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.pdfMessage
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btn-plan-view view-plan-wrap' },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { className: 'btn btn-primary', onClick: this.togglePdfMessage },
	                  'OK'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions(mockData);
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBTMockExams;
	}(_react.Component);
	
	CBTMockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBTMockExams;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	__webpack_require__(80);
	
	var _toast = __webpack_require__(15);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _highlightText = __webpack_require__(56);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.getQuestions = function (data) {
	      _this.setState({
	        isDataLoading: true
	      });
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var highlightdata = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(function (resp) {
	        if (resp.success) {
	          _this.getHighlightedText(highlightdata);
	          _this.getStrikedText(highlightdata);
	
	          _this.setState({
	            questionsData: resp.question,
	            selectedQuestionData: resp.question[_this.props.params.offset],
	            isLoading: false,
	            isDataLoading: false
	          });
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	          var userChoice = resp.data && resp.data.questions && resp.data.questions ? JSON.parse(resp.data.questions) : '';
	          // console.log('resp.data',resp.data);
	          for (var i in userChoice) {
	            if (i === _this.props.params.questiono) {
	              if (userChoice[i] === 'choice_a') {
	                _this.setState({
	                  choice_border_a: 'border-yellow'
	                });
	              } else if (userChoice[i] === 'choice_b') {
	                _this.setState({
	                  choice_border_b: 'border-yellow'
	                });
	              } else if (userChoice[i] === 'choice_c') {
	                _this.setState({
	                  choice_border_c: 'border-yellow'
	                });
	              } else {
	                _this.setState({
	                  choice_border_d: 'border-yellow'
	                });
	              }
	            }
	          }
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.componentDidMount = function () {
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _this.getQuestions(data);
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      if (_this.props.params.timerStart === 'true') {
	        _this.timer = setInterval(_this.countDown, 1000);
	      } else {
	        clearInterval(_this.timer);
	      }
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _this.setState({
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                  });
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      _this.slider.slickGoTo(index - 1);
	      _this.setDefaultBorderColor();
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + questionNumber + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + index + '/' + _this.props.params.isNegative + '/' + _this.props.params.timerStart
	        });
	      }
	    };
	
	    _this.getPrevious = function (index) {
	      _this.slider.slickGoTo(index - 2);
	      var questionsData = _this.state.questionsData;
	
	      _this.setDefaultBorderColor();
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      _this.context.router.push({
	        pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + (_this.props.params.offset ? questionsData[parseInt(_this.props.params.offset) - 1].id : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + (_this.props.params.offset ? parseInt(_this.props.params.offset) - 1 : 1) + '/' + _this.props.params.isNegative + '/' + _this.props.params.timerStart
	      });
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.offset !== _this.props.params.offset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	          level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	        };
	        _this.getQuestions(data);
	      }
	    };
	
	    _this.getNext = function (index) {
	      _this.slider.slickGoTo(index);
	      var questionsData = _this.state.questionsData;
	
	      _this.setDefaultBorderColor();
	      _this.getFlagQuestions();
	      _this.getUserStats();
	      _this.context.router.push({
	        pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + (_this.props.params.offset ? questionsData[parseInt(_this.props.params.offset) + 1].id : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + (_this.props.params.offset ? parseInt(_this.props.params.offset) + 1 : 1) + '/' + _this.props.params.isNegative + '/' + _this.props.params.timerStart
	      });
	    };
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateUsersChoice', userData).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                      level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateUserAnswer', ansData).then(function () {
	                      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                        return _regenerator2.default.wrap(function _callee2$(_context2) {
	                          while (1) {
	                            switch (_context2.prev = _context2.next) {
	                              case 0:
	                              case 'end':
	                                return _context2.stop();
	                            }
	                          }
	                        }, _callee2, _this2);
	                      }));
	
	                      return function (_x3) {
	                        return _ref3.apply(this, arguments);
	                      };
	                    }());
	                  }
	
	                case 1:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.setDefaultBorderColor = function () {
	      _this.setState({
	        choice_border_a: 'border-black',
	        choice_border_b: 'border-black',
	        choice_border_c: 'border-black',
	        choice_border_d: 'border-black'
	      });
	    };
	
	    _this.submitTest = function () {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({
	        showFinishTestPopup: false
	      });
	      var ansdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        if (resp_count.success) {
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	            score: resp_count.allrightanswercount.question_count,
	            level: _this.props.params.level ? parseInt(_this.props.params.level) : null,
	            id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateUserScore', data);
	        } else {
	          //console.log(resp_count.success + '------------failure');
	        }
	      });
	      _this.context.router.push({
	        pathname: '/frm/cbtquestionsfinish/' + _this.props.params.id + '/' + (questionsData.length && questionsData[0] && questionsData[0].id ? questionsData[0].id : 1) + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/0'
	      });
	    };
	
	    _this.flagQuestion = function (data) {
	      var flag = _this.state.flag;
	
	      var flaggedQuestions = flag.filter(function (flag) {
	        return flag.question_id === data.id;
	      })[0];
	      var flagdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: data.id,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      if (flaggedQuestions) {
	        (0, _toast.showSuccess)('Question Unflagged');
	      } else {
	        (0, _toast.showSuccess)('Question Flagged');
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/flagQuestion', flagdata).then(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (res) {
	                    _this.getFlagQuestions();
	                  }
	
	                case 1:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this2);
	        }));
	
	        return function (_x4) {
	          return _ref4.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	          return _regenerator2.default.wrap(function _callee5$(_context5) {
	            while (1) {
	              switch (_context5.prev = _context5.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context5.stop();
	              }
	            }
	          }, _callee5, _this2);
	        }));
	
	        return function (_x5) {
	          return _ref5.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        //console.log('prevArray', prevArray);
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state = _this.state,
	          flag = _this$state.flag,
	          userStatsData = _this$state.userStatsData,
	          questionsData = _this$state.questionsData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== questionsData.length) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed',
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateUserQuizStatus', data).then(function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(res) {
	          return _regenerator2.default.wrap(function _callee6$(_context6) {
	            while (1) {
	              switch (_context6.prev = _context6.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context6.stop();
	              }
	            }
	          }, _callee6, _this2);
	        }));
	
	        return function (_x6) {
	          return _ref6.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pad = function (num) {
	      return ('0' + num).slice(-2);
	    };
	
	    _this.SecondsToHHMMSS = function (sec) {
	      var hours = Math.floor(sec / (60 * 60));
	
	      var divisor_for_minutes = sec % (60 * 60);
	      var minutes = Math.floor(divisor_for_minutes / 60);
	
	      var divisor_for_seconds = divisor_for_minutes % 60;
	      var seconds = Math.ceil(divisor_for_seconds);
	      return _this.pad(hours) + ':' + _this.pad(minutes) + ':' + _this.pad(seconds);
	    };
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	
	      if (timerStart === 'true') {
	        _this.setState({
	          timerStart: 'false'
	        });
	        _this.context.router.push({
	          pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + _this.props.params.questiono + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + _this.props.params.offset + '/' + _this.props.params.isNegative + '/false'
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: 'true'
	        });
	        _this.context.router.push({
	          pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + _this.props.params.questiono + '/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + _this.props.params.testid + '/' + _this.props.params.offset + '/' + _this.props.params.isNegative + '/true'
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.addHighlight = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text,
	                  level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	                };
	                _context8.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/addHighlightedText', data).then(function () {
	                  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context7.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this2);
	                  }));
	
	                  return function (_x8) {
	                    return _ref8.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id,
	                  level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	                };
	
	                if (!id) {
	                  _context10.next = 7;
	                  break;
	                }
	
	                _context10.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/deleteHighlightedText', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context9.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x10) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context10.next = 8;
	                break;
	
	              case 7:
	                return _context10.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x9) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getHighlightedText', data).then(function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	          return _regenerator2.default.wrap(function _callee11$(_context11) {
	            while (1) {
	              switch (_context11.prev = _context11.next) {
	                case 0:
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context11.stop();
	              }
	            }
	          }, _callee11, _this2);
	        }));
	
	        return function (_x11) {
	          return _ref11.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.clickOption = function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                //console.log('e. type ___________', e.type);
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : null,
	                    level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThroughOption(choice);
	                }
	
	              case 2:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this2);
	      }));
	
	      return function (_x12, _x13, _x14, _x15) {
	        return _ref12.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThroughOption = function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(choice) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                //console.log('I am here ');
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice,
	                  level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	                };
	                _context14.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/addStrikeThrough', data).then(function () {
	                  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	                    return _regenerator2.default.wrap(function _callee13$(_context13) {
	                      while (1) {
	                        switch (_context13.prev = _context13.next) {
	                          case 0:
	                            _context13.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context13.stop();
	                        }
	                      }
	                    }, _callee13, _this2);
	                  }));
	
	                  return function (_x17) {
	                    return _ref14.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 5:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this2);
	      }));
	
	      return function (_x16) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        level: _this.props.params.level ? parseInt(_this.props.params.level) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getStrikedText', data).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThroughOption(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      choice_border_a: 'border-black',
	      choice_border_b: 'border-black',
	      choice_border_c: 'border-black',
	      choice_border_d: 'border-black',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: []
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        this.context.router.push({
	          pathname: '/frm/cbtquestions/' + this.props.params.id + '/' + this.props.params.questiono + '/' + this.props.params.timer + '/' + this.props.params.level + '/' + this.props.params.testid + '/' + this.props.params.offset + '/false/' + this.props.params.timerStart
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        level: this.props.params.level ? parseInt(this.props.params.level) : null,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
	        isNegative: this.props.params.isNegative
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateUserTimer', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this3);
	        }));
	
	        return function (_x19) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    ///------------------------------------------------
	    // for IOS
	
	  }, {
	    key: 'render',
	
	
	    ///-------------------------------------------------
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var content = selectedQuestionData.question;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	
	      // console.log('content', content);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { onClick: function onClick() {
	                    return _this4.finishTest();
	                  }, className: 'pointer_class btn-primary' },
	                _language2.default.LC().Finish_Test
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : questionsData && questionsData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this4.slider = slider;
	                    }
	                  }),
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0];
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                        ' + (index === parseInt(_this4.props.params.offset) ? 'active' : '') + '\n                        ' + (userChoice[item.id] ? 'completed-qus' : '') + '\n                        ' + (flaggedQuestions ? 'flag-add' : '') + '\n                        '
	                        },
	                        index + 1,
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : ''
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper' },
	                isDataLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        selectedQuestionData && selectedQuestionData.question ? _react2.default.createElement(
	                          'div',
	                          { className: 'qus-wrapper ques-bold-remove d-block' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                              className: 'margin_right_20',
	                              alt: '',
	                              width: '30'
	                            }),
	                            'Q.',
	                            parseInt(this.props.params.offset) + 1
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            {
	                              style: {
	                                position: 'relative',
	                                marginTop: '8px'
	                                // maxWidth: "100%",
	                              }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { 'data-selectable': true },
	                              (0, _function.renderHTMLContent)(selectedQuestionData.question, "div", "qus-title d-inline-block w-100")
	                            ),
	                            _react2.default.createElement(
	                              _reactSelectionPopover2.default,
	                              {
	                                showPopover: this.state.showPopover,
	                                onSelect: function onSelect() {
	                                  _this4.setState({ showPopover: true });
	                                },
	                                onDeselect: function onDeselect() {
	                                  _this4.setState({ showPopover: false });
	                                }
	                              },
	                              getHighlightedText === -1 ? _react2.default.createElement(
	                                'div',
	                                { className: 'highlight-popover tooltip_wrap' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	                                  alt: '523',
	                                  width: '30',
	                                  onClick: function onClick() {
	                                    return _this4.addHighlightToText();
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  _language2.default.LC().Click_me_to_highlight
	                                )
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'highlight-popover tooltip_wrap' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	                                  alt: '523',
	                                  width: '30',
	                                  onClick: function onClick() {
	                                    return _this4.deleteHighlightFromText();
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  _language2.default.LC().Click_me_to_unhighlight
	                                )
	                              )
	                            )
	                          )
	                        ) : null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _constant.frmOptionsArr.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'col-sm-12',
	                                id: item,
	                                key: index,
	                                onClick: function onClick(e) {
	                                  _this4.clickOption(item, selectedQuestionData && selectedQuestionData.id ? selectedQuestionData.id : null, selectedQuestionData, e);
	                                },
	                                onContextMenu: function onContextMenu(e) {
	                                  _this4.clickOption(item, selectedQuestionData && selectedQuestionData.id ? selectedQuestionData.id : null, selectedQuestionData, e);
	                                },
	                                onTouchStart: function onTouchStart(e) {
	                                  _this4.onTouchStart(e, item);
	                                },
	                                onTouchCancel: function onTouchCancel(e) {
	                                  _this4.onTouchCancel(e);
	                                },
	                                onTouchEnd: function onTouchEnd(e) {
	                                  _this4.onTouchEnd(e);
	                                },
	                                onTouchMove: function onTouchMove(e) {
	                                  _this4.onTouchMove(e);
	                                }
	                              },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box ' + (userChoice[selectedQuestionData.id] === item ? 'border-yellow' : 'border-black')
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'answer_count highlight_choice no-selection ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : item === 'choice_d' ? strikeThroughArr.includes('choice_d') ? 'strikethrough' : '' : '')
	                                  },
	                                  item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : item === 'choice_c' ? _language2.default.LC().C : _language2.default.LC().D
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : item === 'choice_d' ? strikeThroughArr.includes('choice_d') ? 'strikethrough' : '' : '')
	                                  },
	                                  selectedQuestionData && selectedQuestionData[item] ? (0, _function.renderHTMLContent)(selectedQuestionData[item], "span") : null,
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'tootip_box' },
	                                    _language2.default.LC().Correct_Choice
	                                  )
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer mb-15' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h2',
	                              { className: 'time-left-heading' },
	                              _language2.default.LC().TIME_LEFT
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              {
	                                className: 'timer_box ' + (this.props.params.isNegative === 'false' ? 'blink' : null)
	                              },
	                              this.props.params.isNegative === 'false' ? '- ' + formatTimeF : formatTimeF
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            'aria-label': timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer',
	                            className: 'tooltip_wrap mb-2 hover-pad-same\n                                ' + (timerStart === 'true' ? 'icon-control-pause pause_btn' : 'pause_btn icon-control-play'),
	                            onClick: function onClick() {
	                              return _this4.stopTimer();
	                            }
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tootip_box', 'aria-hidden': 'true' },
	                            _language2.default.LC().Save_and_Take_Break
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            'aria-label': _language2.default.LC().SECTION_REVIEW,
	                            className: 'menu-btn tooltip-hover-questions',
	                            onClick: function onClick() {
	                              _this4.setState({
	                                showSectionReview: true
	                              });
	                            }
	                          },
	                          _react2.default.createElement('img', {
	                            width: '30px',
	                            src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                            className: 'my-1',
	                            alt: ''
	                          }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tootip_box', 'aria-hidden': 'true' },
	                            _language2.default.LC().SECTION_REVIEW
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-9 mt-1' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'up tooltip-hover-questions ' },
	                            flaggedQuestion ? _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              _language2.default.LC().UNFLAG_THIS_QUESTION
	                            ) : _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              _language2.default.LC().FLAG_THIS_QUESTION
	                            ),
	                            _react2.default.createElement(
	                              'i',
	                              {
	                                onClick: function onClick() {
	                                  return _this4.flagQuestion(selectedQuestionData);
	                                },
	                                className: flaggedQuestion ? 'fa fa-flag mark-action-btn' : 'fa fa-flag-o mark-action-btn'
	                              },
	                              ' '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getPrevious(_this4.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getNext(_this4.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png', alt: '' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _language2.default.LC().SECTION_REVIEW
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                'aria-label': 'Close section review',
	                className: 'section-review-close',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().FILTER_BY,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'filt-list-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: function onClick() {
	                    _this4.setState({
	                      filter: []
	                    });
	                  }
	                },
	                _language2.default.LC().CLEAR
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _constant.filterObj.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'plan_wrapper remove-plan', key: index },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        value: item,
	                        id: item,
	                        checked: filter.indexOf(item) > -1 ? true : false,
	                        onChange: function onChange(e) {
	                          return _this4.changeFilter(e, item);
	                        }
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' }),
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qus-tab-wrapper' },
	              questionsData.map(function (item, index) {
	                var flaggedQuestions = flag.filter(function (flag) {
	                  return flag.question_id === item.id;
	                })[0];
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  filter.includes('Attempted') && filter.includes('Unattempted') && filter.includes('Flagged') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : filter.includes('Attempted') && filter.includes('Unattempted') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'completed-qus' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : filter.includes('Unattempted') && filter.includes('Flagged') ? !userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : ///
	                  filter.includes('Attempted') && filter.includes('Flagged') ? userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : filter.includes('Attempted') ? userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'completed-qus',
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Unattempted') ? !userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Flagged') ? flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    })
	                  ) : '' : _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _constant = __webpack_require__(9);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var FRMCBTResult = function (_Component) {
	  _inherits(FRMCBTResult, _Component);
	
	  //
	  function FRMCBTResult(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FRMCBTResult);
	
	    var _this = _possibleConstructorReturn(this, (FRMCBTResult.__proto__ || Object.getPrototypeOf(FRMCBTResult)).call(this, props));
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.getGraphoverAllGraphData = function (data) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getCBTMockUserGraph', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.graphData) {
	                    _this.setState({
	                      isLoading: false,
	                      totalQuestions: _this.props.params.totalQuestions,
	                      average: res.graphData.averageScore
	                    });
	                    _this.formatoverAllGraphData(res);
	                  } else {
	                    _this.setState({
	                      isLoading: false
	                    });
	                    (0, _toast.showFailure)(res.message);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getGraphData = function (data) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getCBTMockUserGraphBookWise', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  _this.setState({
	                    isLoading: false,
	                    totalQuestionsChapterwise: _this.props.params.totalQuestions,
	                    exam_name: res.graphData
	                  });
	                  _this.formatData(res);
	
	                case 2:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatoverAllGraphData = function (res) {
	      var graphData = res.graphData;
	
	
	      if (!res.Error) {
	        _this.setState({
	          dataOfCurrentUser: graphData ? graphData.dataOfCurrentUser.score : _this.state.dataOfCurrentUser,
	          dataOfEightyPercentileUser: graphData ? graphData.dataOfEightyPercentileUser.score : _this.state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser: graphData ? graphData.dataOfTwentyPercentileUser.score : _this.state.dataOfTwentyPercentileUser
	        });
	        var totalQuestions = _this.state.totalQuestions;
	
	        var temp = [graphData];
	        graphData = temp;
	
	        // Reference line for 70%
	        var referenceLine = {
	          type: 'line',
	          color: '#fff',
	          dataPoints: [{
	            x: -15,
	
	            y: 100
	          }, {
	            x: 20,
	
	            y: 100
	          }, {
	            x: 20,
	
	            y: 100
	          }],
	          markerType: 'none'
	        };
	        // 20% line
	        var dataOfTwentyOverAllGraph = {
	          showInLegend: false,
	          name: '20%',
	
	          type: 'line',
	          lineDashType: 'dash',
	          color: '#39c089',
	          dataPoints: [],
	          markerType: 'none'
	        };
	        //80% line
	        var dataOfEightyOverAllGraph = {
	          showInLegend: false,
	
	          name: '80%',
	          type: 'line',
	          lineDashType: 'dot',
	          color: '#1d364b',
	          dataPoints: [],
	          markerType: 'none'
	        };
	        //User score line
	        var UserScoreOverAllGraph = {
	          showInLegend: false,
	          name: '' + _language2.default.LC().GRAPHSCORE,
	
	          type: 'line',
	          color: '#1f8ceb',
	          markerType: 'none',
	          dataPoints: [],
	          overlayBars: true
	        };
	        //User score box
	
	        var scorePercentage = graphData[0].dataOfCurrentUser.score == null ? 0 : Math.ceil(graphData[0].dataOfCurrentUser.score / totalQuestions * 100);
	
	        var UserScoreBoxOverAllGraph2 = {
	          type: 'rangeColumn',
	
	          color: 'hsl(200deg 67% 88%)',
	          dataPoints: []
	        };
	
	        UserScoreBoxOverAllGraph2.dataPoints.push({
	          x: 1.39,
	
	          y: [scorePercentage - 5, scorePercentage + 5]
	        });
	
	        var dataOfCurrentUserLineStart = {
	          x: -0.2,
	
	          y: scorePercentage
	        };
	        var dataOfCurrentUserLineMid = {
	          x: 2.8,
	
	          y: scorePercentage
	        };
	        var dataOfCurrentUserLineEnd = {
	          x: 2.8,
	          y: null
	        };
	
	        UserScoreOverAllGraph.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	
	        var dataOfTwentyPercentileUserlineStart = {
	          x: -3,
	
	          y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	        };
	        var dataOfTwentyPercentileUserlineMid = {
	          x: 7,
	
	          y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	        };
	        var dataOfTwentyPercentileUserlineEnd = {
	          x: 7,
	          y: null
	        };
	        dataOfTwentyOverAllGraph.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	        var dataOfEightyPercentileUserLineStart = {
	          x: -3,
	
	          y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	        };
	        var dataOfEightyPercentileUserLineMid = {
	          x: 7,
	
	          y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	        };
	
	        var dataOfEightyPercentileUserLineEnd = {
	          x: 7,
	          y: null
	        };
	        dataOfEightyOverAllGraph.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	        var overAllGraphData = [];
	        overAllGraphData.push(UserScoreBoxOverAllGraph2, dataOfTwentyOverAllGraph, dataOfEightyOverAllGraph, UserScoreOverAllGraph, referenceLine);
	
	        _this.setState({
	          dataPointsOverAllGraph: overAllGraphData
	        }, function () {
	          _this.showGraphOverAll(); //Show overall graph
	        });
	      } else {
	        _this.setState({ isError: true, error: res.Error });
	      }
	    };
	
	    _this.showGraphOverAll = function () {
	      var dataPointsOverAllGraph = _this.state.dataPointsOverAllGraph;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: _constant.canvasjsConfig.axisX,
	        dataPointWidth: 90,
	        dataPointMaxWidth: 80,
	        dataPointMinWidth: 80,
	        toolTip: _constant.canvasjsConfig.toolTip,
	
	        legend: {
	          fontSize: 18
	        },
	        data: dataPointsOverAllGraph,
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.formatData = function (res) {
	      var graphData = res.graphData;
	
	
	      if (!res.Message) {
	        var initialValue = 0;
	        // Reference line for 70%
	        var referenceLine = {
	          type: 'line',
	          color: '#fff',
	          dataPoints: [{
	            x: 0,
	
	            y: 110
	          }, {
	            x: 20,
	
	            y: 110
	          }, {
	            x: 20,
	
	            y: 110
	          }],
	          markerType: 'none'
	        };
	        //20% line chaptervise graph
	        var dataOfTwenty = {
	          showInLegend: false,
	
	          name: '20%',
	          type: 'line',
	          lineDashType: 'dash',
	          color: '#39c089',
	          dataPoints: [],
	          markerType: 'none'
	        };
	        //80% line chaptervise graph
	        var dataOfEighty = {
	          showInLegend: false,
	          name: '80%',
	          type: 'line',
	          lineDashType: 'dot',
	          color: '#1d364b',
	          dataPoints: [],
	          markerType: 'none'
	        };
	        //Userscore line chaptervise graph
	        var UserScore = {
	          showInLegend: false,
	          name: '' + _language2.default.LC().GRAPHSCORE,
	          type: 'line',
	          color: 'hsl(219deg 62% 44%)',
	          markerType: 'none',
	          dataPoints: [],
	          overlayBars: true
	        };
	        //User Score Box chaptervise graph
	        // let UserScoreBox = {
	        //   type: 'rangeColumn',
	        //   color: '#cce7f5',
	        //   dataPoints: [],
	        // };
	        // initialValue = -10;
	        // for (let k = 0; k < graphData.length; k++) {
	        //   UserScoreBox.dataPoints.push({
	        //     x: initialValue + 15,
	
	        //     y: [
	        //       graphData[k].dataOfCurrentUser.Percentage - 10,
	        //       graphData[k].dataOfCurrentUser.Percentage + 10,
	        //     ],
	        //   });
	        //   initialValue += 15;
	        // }
	        var UserScoreBox2 = {
	          showInLegend: false,
	          // legendMarkerType: 'square',
	          name: '' + _language2.default.LC().GRAPHSCOREBOX,
	          type: 'rangeColumn',
	          color: '#cce7f5',
	          dataPoints: []
	        };
	        initialValue = -10;
	        for (var k = 0; k < graphData.length; k++) {
	          UserScoreBox2.dataPoints.push({
	            x: initialValue + 15,
	            label: '' + graphData[k].chapterDetails['chapters_frm.chapter_name'],
	            y: [graphData[k].dataOfCurrentUser.Percentage - 10, graphData[k].dataOfCurrentUser.Percentage + 10]
	          });
	          var dataOfCurrentUserLineStart = {
	            x: initialValue + 15 - 1.5,
	
	            y: graphData[k].dataOfCurrentUser.Percentage
	          };
	          var dataOfCurrentUserLineMid = {
	            x: initialValue + 15 + 1.5,
	
	            y: graphData[k].dataOfCurrentUser.Percentage
	          };
	          var dataOfCurrentUserLineEnd = {
	            x: initialValue + 15 + 1.5,
	            y: null
	          };
	          UserScore.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	          initialValue += 15;
	        }
	        initialValue = 0;
	        for (var i = 0; i < graphData.length; i++) {
	          var dataOfTwentyPercentileUserlineStart = {
	            x: initialValue,
	
	            y: graphData[i].dataOfTwentyPercentileUser.Percentage
	          };
	          var dataOfTwentyPercentileUserlineMid = {
	            x: initialValue + 10,
	
	            y: graphData[i].dataOfTwentyPercentileUser.Percentage
	          };
	          var dataOfTwentyPercentileUserlineEnd = {
	            x: initialValue + 10,
	
	            y: null
	          };
	          dataOfTwenty.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	          var dataOfEightyPercentileUserLineStart = {
	            x: initialValue,
	
	            y: graphData[i].dataOfEightyPercentileUser.Percentage
	          };
	          var dataOfEightyPercentileUserLineMid = {
	            x: initialValue + 10,
	
	            y: graphData[i].dataOfEightyPercentileUser.Percentage
	          };
	          var dataOfEightyPercentileUserLineEnd = {
	            x: initialValue + 10,
	            y: null
	          };
	          dataOfEighty.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	
	          initialValue += 15;
	        }
	        var data = [];
	        data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, referenceLine);
	
	        _this.setState({
	          dataPoints: data
	        }, function () {
	          _this.showGraph(); //Show chaptervise graph
	        });
	      } else {
	        _this.setState({ Message: true, errorGraph: res.Message });
	      }
	    };
	
	    _this.showGraph = function () {
	      var dataPoints = _this.state.dataPoints;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainer', {
	        animationEnabled: true,
	
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: Object.assign({}, _constant.canvasjsConfig.axisX, {
	          labelAngle: _this.state.labelAngle,
	          labelFontSize: _this.state.labelFontSize
	        }),
	        dataPointWidth: 60,
	        dataPointMaxWidth: 60,
	        dataPointMinWidth: 60,
	        toolTip: _constant.canvasjsConfig.toolTip,
	        data: dataPoints,
	
	        legend: {
	          fontSize: 18
	        },
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.state = {
	      token: '',
	      idname: '',
	      dataPointsOverAllGraph: [],
	      dataPoints: [],
	      totalQuestions: 0,
	      isLoading: true,
	      labelAngle: 0,
	      labelFontSize: 15,
	      activeTabFlashcards: 1,
	      Message: false,
	      isError: false,
	      error: '',
	      errorGraph: '',
	      totalQuestionsChapterwise: 0,
	      dataOfCurrentUser: '',
	      dataOfEightyPercentileUser: '',
	      dataOfTwentyPercentileUser: '',
	      exam_name: '',
	      average: ''
	    };
	    return _this;
	  }
	
	  _createClass(FRMCBTResult, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var w = window.innerWidth;
	      // const h = window.innerHeight;
	      if (w > 1200) {
	        this.setState({
	          labelAngle: 0,
	          labelFontSize: 15
	        });
	      } else if (w > 991 && w < 1200) {
	        this.setState({
	          labelAngle: -20,
	          labelFontSize: 12
	        });
	      } else if (w > 767 && w < 991) {
	        this.setState({
	          labelAngle: 50,
	          labelFontSize: 15
	        });
	      } else {
	        this.setState({
	          labelAngle: -90,
	          labelFontSize: 12
	        });
	      }
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        test_id: this.props.params.test_id ? parseInt(this.props.params.test_id) : null,
	        level: this.props.params.level ? parseInt(this.props.params.level) : null,
	        totalQuestion: this.props.params.totalQuestions ? parseInt(this.props.params.totalQuestions) : null,
	        timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0
	      };
	
	      this.getGraphData(data);
	      this.getGraphoverAllGraphData(data);
	    }
	    // get data for overall graph
	    // myResize = () => {
	
	    //   }
	
	    // get data for chaptervise graph
	
	    //format data as requirement for overall graph
	
	    //Show overall graph
	
	    //Format data as requirement
	
	
	    // show graph chaptervise graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          dataOfCurrentUser = _state.dataOfCurrentUser,
	          dataOfEightyPercentileUser = _state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser = _state.dataOfTwentyPercentileUser,
	          totalQuestions = _state.totalQuestions,
	          isError = _state.isError,
	          Message = _state.Message,
	          exam_name = _state.exam_name,
	          errorGraph = _state.errorGraph,
	          activeTabFlashcards = _state.activeTabFlashcards,
	          average = _state.average;
	      var isLoading = this.state.isLoading;
	
	      return !isLoading ? _react2.default.createElement(
	        'div',
	        null,
	        isError ? _react2.default.createElement(
	          'div',
	          { className: 'chart-graph-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'question-not-found' },
	            _react2.default.createElement('img', {
	              width: '62px',
	              src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png',
	              alt: 'img'
	            }),
	            _react2.default.createElement(
	              'div',
	              null,
	              '' + errorGraph
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'chart-graph-wrapper' },
	          ' ',
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().OVERALLRESULT
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              ' ',
	              _react2.default.createElement('div', {
	                id: 'chartContainerOverAllGraph',
	                className: 'js-chart-wrap'
	              }),
	              _react2.default.createElement(
	                'ul',
	                { className: 'legend-wrapper' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'square-box' }),
	                  ' ',
	                  _language2.default.LC().SCOREBOX
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dash' }),
	                  ' ',
	                  _language2.default.LC().Percentile_20
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dots' }),
	                  ' ',
	                  _language2.default.LC().Percentile_80
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-normal' }),
	                  ' ',
	                  _language2.default.LC().YOURSCORE
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              _react2.default.createElement(
	                'div',
	                { className: ' graphData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfTwentyPercentileUser ? Math.ceil(dataOfTwentyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_20
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfEightyPercentileUser ? Math.ceil(dataOfEightyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_80
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(dataOfCurrentUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'score-box' }),
	                    ' ',
	                    '' + _language2.default.LC().YOURSCORE
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfTwentyPercentileUser ? Math.ceil(average / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'average-box' }),
	                    ' ',
	                    _language2.default.LC().AVERAGE_SCORE
	                  )
	                )
	              )
	            )
	          )
	        ),
	        Message ? null : _react2.default.createElement(
	          'div',
	          { className: ' chart-graph-wrapper' },
	          ' ',
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().FRMBookWiseScore
	          ),
	          _react2.default.createElement('div', { id: 'chartContainer', className: 'js-chart-wrap' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'legend-wrapper' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'square-box' }),
	              ' ',
	              _language2.default.LC().SCOREBOX
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dash' }),
	              ' ',
	              _language2.default.LC().Percentile_20
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dots' }),
	              ' ',
	              _language2.default.LC().Percentile_80
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-normal' }),
	              _language2.default.LC().YOURSCORE
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-5' },
	            'Mean Score by Topic Area'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex header-card-dashboard tab-header-wrap mt-2' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'dashboard-card-header-tab' },
	              exam_name ? exam_name.map(function (exam, index) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    onClick: function onClick() {
	                      _this3.flashcardTabToggle(index + 1);
	                    },
	                    className: activeTabFlashcards === index + 1 ? 'active' : ''
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    exam.chapterDetails['chapters_frm.chapter_name'].length > 20 ? exam.chapterDetails['chapters_frm.chapter_name'].substring(0, 20) + '...' : exam.chapterDetails['chapters_frm.chapter_name']
	                  )
	                );
	              }) : null
	            )
	          ),
	          exam_name ? exam_name.map(function (exam, index) {
	            var x = void 0;
	
	            x = _this3.state.activeTabFlashcards === index + 1 ? _react2.default.createElement(
	              'div',
	              { className: 'card tab-body-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block dashboard-cards-scroll my-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'chart-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' graphData' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfTwentyPercentileUser ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_20
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfEightyPercentileUser ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_80
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfCurrentUser ? Math.ceil(exam.dataOfCurrentUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'score-box' }),
	                        ' ',
	                        '' + _language2.default.LC().YOURSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam && exam.chapterDetails && exam.chapterDetails.totalQuestions ? Math.ceil(exam.averageScore / exam.chapterDetails.totalQuestions * 100) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'average-box' }),
	                        ' ',
	                        _language2.default.LC().AVERAGE_SCORE
	                      )
	                    )
	                  )
	                )
	              )
	            ) : null;
	
	            return x;
	          }) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-2 text-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().DataDetail
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { id: 'chartContainer' },
	        _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return FRMCBTResult;
	}(_react.Component);
	
	exports.default = FRMCBTResult;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTMockExams = function (_Component) {
	  _inherits(CBTMockExams, _Component);
	
	  function CBTMockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTMockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExams.__proto__ || Object.getPrototypeOf(CBTMockExams)).call(this, props));
	
	    _this.getQuestions = function () {
	      _this.setState({
	        showInstructionModal: false,
	        isLoading: true
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.setState({
	              isLoading: false
	            });
	            _this.toggleAlert();
	          } else {
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, examPlanData, mockPackageAccess, subscriptionStatus, level, hasAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 12;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        mockPackageAccess = resp_exam.hasMockSubscription;
	                        _context.next = 6;
	                        return _FrmSubscription4.default.checkFrm(_this.props.params.level, exam_data, examPlanData);
	
	                      case 6:
	                        subscriptionStatus = _context.sent;
	                        level = _this.props.params.level;
	                        hasAccess = level === '1' && mockPackageAccess['frm'] || level === '2' && mockPackageAccess['frm_2'] || mockPackageAccess['frm_1_2'];
	
	                        if (subscriptionStatus || hasAccess) {
	                          _this._runCode('paid');
	                        } else {
	                          _this.setState({
	                            isLoading: false
	                          });
	                          _this.toggleAlert();
	                        }
	                        _context.next = 12;
	                        break;
	
	                      case 12:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            //console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.setState({
	              isLoading: false
	            });
	            _this.toggleAlert();
	          } else {
	            // var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset1 = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset1).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(_this.props.params.level, exam_data);
	                if (subscriptionStatus) {
	                  _this._runCode('paid');
	                } else {
	                  _this.setState({
	                    isLoading: false
	                  });
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus) {
	      if (subscriptionstatus === 'paid') {
	        _this.context.router.push({
	          pathname: '/frm/introduction/' + _this.props.params.id + '/1/' + _this.props.params.timer + '/' + _this.props.params.level
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function () {
	      _this.setState({
	        showInstructionModal: true
	        // mockData: mock,
	      });
	    };
	
	    _this.backToMock = function () {
	      _this.context.router.push({
	        pathname: '/frm/cbt'
	      });
	    };
	
	    _this.deleteTest = function (id) {
	      var deletepopup = _this.state.deletepopup;
	
	      if (!deletepopup) {
	        _this.setState({
	          deleteId: id,
	          deletepopup: true
	        });
	      } else {
	        _this.setState({
	          deleteId: '',
	          deletepopup: false
	        });
	      }
	    };
	
	    _this.view = function (item) {
	      _this.context.router.push({
	        pathname: '/frm/cbtquestionsfinish/' + _this.props.params.id + '/1/' + _this.props.params.timer + '/' + _this.props.params.level + '/' + item.id + '/0'
	      });
	    };
	
	    _this.deleteToggleDone = function () {
	      var deleteId = _this.state.deleteId;
	
	      var deleteData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: deleteId
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/deleteMock', deleteData).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var data;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this.setState({
	                    deleteId: '',
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
	                    deletepopup: false
	                  });
	
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id, 10) : '',
	                    level: _this.props.params.level ? parseInt(_this.props.params.level, 10) : ''
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getAllUsersStats', data).then(function (resp) {
	                    if (resp.success) {
	                      _this.setState({
	                        ValidToken: true,
	                        mockList: resp.data,
	                        isLoading: false
	                        // userStatsData: resp.data,
	                      });
	                    } else {
	                      _this.setState({ ValidToken: false, isLoading: false });
	                    }
	                    return resp;
	                  });
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              _this.setState({
	                                mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                              });
	
	                            case 1:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	
	                case 4:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.resumeTest = function (item) {
	      if (item.questions) {
	        var questionsData = JSON.parse(item.lastAnswered);
	        //console.log('item', questionsData);
	        if (questionsData) {
	          _this.context.router.push({
	            pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + questionsData.questionId + '/' + item.user_time_value + '/' + _this.props.params.level + '/' + item.id + '/' + questionsData.offset + '/true/true'
	          });
	        }
	      } else {
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id, 10) : null,
	          test_id: item.id,
	          level: item.level
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(function (resp) {
	          if (resp.success) {
	            _this.context.router.push({
	              pathname: '/frm/cbtquestions/' + _this.props.params.id + '/' + (resp.question && resp.question.length ? resp.question[0].id : 1) + '/' + item.user_time_value + '/' + _this.props.params.level + '/' + item.id + '/0/true/true'
	            });
	          }
	        });
	      }
	    };
	
	    var messageTitle_frm = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: messageTitle_frm,
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'frm',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      mockName: '',
	      deletepopup: false,
	      deleteId: '',
	      questionsLength: 90
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBTMockExams, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: this.props.params.id ? parseInt(this.props.params.id, 10) : '',
	                  level: this.props.params.level ? parseInt(this.props.params.level, 10) : ''
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getAllUsersStats', data).then(function (resp) {
	                  if (resp.success) {
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(function (resp) {
	                      if (resp && resp.question) {
	                        _this3.setState({
	                          questionsLength: resp.question.length
	                        });
	                      }
	                    });
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.data,
	                      isLoading: false
	                      // userStatsData: resp.data,
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            _this3.setState({
	                              mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                            });
	
	                          case 1:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockName = _state.mockName,
	          deletepopup = _state.deletepopup,
	          questionsLength = _state.questionsLength;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper rem-left-pad' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'two-btn-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.startExam();
	                  }
	                },
	                _language2.default.LC().START
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                _language2.default.LC().CHANGE_MOCK
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: deletepopup, toggle: this.deleteTest, className: 'modal-primary' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteTest },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table table-remove-space' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '9%' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().DATE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TEST_COMPLETED_IN
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().STATUS
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList.length ? mockList.map(function (item, index) {
	                          var time = 0;
	                          if (item.isNegative === 'true') {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(_this4.props.params.timer, 10) - item.user_time_value);
	                          } else {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(_this4.props.params.timer, 10) + item.user_time_value);
	                          }
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id,
	                              '.'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'score-qnt' },
	                              item.score && questionsLength ? Math.ceil(item.score / questionsLength * 100) + '%' : '0%'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.createdAt ? (0, _moment2.default)(item.createdAt).format('ll') : ''
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'clr-green' },
	                              time
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize mock-status' },
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                _language2.default.LC().Incomplete
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status' },
	                                item.status
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              item.status === 'completed' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px 4px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().VIEW,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      return _this4.view(item);
	                                    },
	                                    className: 'fa fa-eye mark-action-btn-dashboard',
	                                    style: { color: '#1f8ceb' }
	                                  },
	                                  ' '
	                                )
	                              ) : null,
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px 4px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().RESUME
	                                ),
	                                _react2.default.createElement('i', {
	                                  className: 'fa fa-play-circle-o mark-action-btn-dashboard',
	                                  'aria-hidden': 'true',
	                                  style: { color: '#000' },
	                                  onClick: function onClick() {
	                                    _this4.resumeTest(item);
	                                  }
	                                })
	                              ) : null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px 4px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().DELETE,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      _this4.deleteTest(item.id);
	                                    },
	                                    className: 'fa fa-trash mark-action-btn-dashboard',
	                                    style: { color: '#f51a00' }
	                                  },
	                                  ' '
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '5', className: 'no-mocks' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '82px',
	                                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png',
	                                alt: ''
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                { className: 'mt-1' },
	                                _language2.default.LC().NO_MOCK_EXAM_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBTMockExams;
	}(_react.Component);
	
	CBTMockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBTMockExams;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _constant = __webpack_require__(9);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var AttemptedTest = function (_Component) {
	  _inherits(AttemptedTest, _Component);
	
	  function AttemptedTest(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, AttemptedTest);
	
	    var _this = _possibleConstructorReturn(this, (AttemptedTest.__proto__ || Object.getPrototypeOf(AttemptedTest)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        isLoading: false,
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.getQuestions = function () {
	      _this.setState({
	        showInstructionModal: false,
	        isLoading: true
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, partnerSubscriptionCheck, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        partnerSubscriptionCheck = _Cfa2Subscription4.default.checkCfa2Subscription;
	
	                        if (_this.props.location.pathname.includes('/cfa3/')) {
	                          partnerSubscriptionCheck = _Cfa3Subscription4.default.checkCfa3Subscription;
	                          selectedmen = 'cfa_3';
	                        }
	                        _context.next = 8;
	                        return partnerSubscriptionCheck(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 8:
	                        isInArray_var = _context.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          _this._runCode('paid');
	                        } else {
	                          _this.toggleAlert();
	                        }
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	            _this.setState({ subscriptionstatus: 'free' });
	            _this._runCode('free');
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                var subscriptionCheck = _Cfa2Subscription2.default.checkCfa2Subscription;
	                if (_this.props.location.pathname.includes('/cfa3/')) {
	                  subscriptionCheck = _Cfa3Subscription2.default.checkCfa3Subscription;
	                  selectedmen = 'cfa_3';
	                }
	                isInArray_var = subscriptionCheck(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                if (isInArray_var || hasMockAccess) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {}
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus) {
	      var timer = _this.state.timer,
	          id = _this.props.params.id;
	
	      if (subscriptionstatus === 'paid') {
	        var _this$props$params = _this.props.params,
	            session = _this$props$params.session,
	            pathway = _this$props$params.pathway;
	
	        var path = _AppRoutes2.default.CFA3_PATHWAY_CBT_INTRODUCTION.replace(':pathway', pathway).replace(':session', session).replace(':questiono', 1).replace(':timer', timer);
	        _this.context.router.push({ pathname: path });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function () {
	      _this.setState({
	        showInstructionModal: true
	        // mockData: mock,
	      });
	    };
	
	    _this.backToMock = function () {
	      var pathway = _this.props.params.pathway;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA3_PATHWAY_SESSION.replace(':pathway', pathway)
	      });
	    };
	
	    _this.deleteTest = function (id) {
	      var deletepopup = _this.state.deletepopup;
	
	      if (!deletepopup) {
	        _this.setState({
	          deleteId: id,
	          deletepopup: true
	        });
	      } else {
	        _this.setState({
	          deleteId: '',
	          deletepopup: false
	        });
	      }
	    };
	
	    _this.view = function (item) {
	      var viewRoute = _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS_FINISH;
	      if (item.status === 'non-graded') viewRoute = _AppRoutes2.default.CFA3_PATHWAY_CBT_GRADE_QUESTIONS;
	      var timer = _this.state.timer,
	          id = _this.props.params.id;
	
	      var path = viewRoute.replace(':id', id).replace(':caseno', 1).replace(':questiono', 1).replace(':testid', item.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':timer', timer);
	
	      _this.context.router.push({ pathname: path });
	    };
	
	    _this.deleteToggleDone = function () {
	      var deleteId = _this.state.deleteId;
	
	      var deleteData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: deleteId
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + _this.filePath + '/deleteMock', deleteData).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var data;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this.setState({
	                    deleteId: '',
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
	                    deletepopup: false
	                  });
	
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : '',
	                    pathwayId: _this.props.params.pathway,
	                    sessionId: _this.props.params.session
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getAllAttemptedTest', data).then(function (resp) {
	                    if (resp.success) {
	                      _this.setState({
	                        ValidToken: true,
	                        mockList: resp.data,
	                        isLoading: false
	                        // userStatsData: resp.data,
	                      });
	                    } else {
	                      _this.setState({ ValidToken: false, isLoading: false });
	                    }
	                    return resp;
	                  });
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getMockNameById', data).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              _this.setState({
	                                mockName: res.data && res.data.session_name ? res.data.session_name : '',
	                                pathwayDetails: res.pathwayDetails && res.pathwayDetails.pathway_name || ''
	                              });
	
	                            case 1:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	
	                case 4:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.resumeTest = function (item) {
	      if (item.questions) {
	        var questionsData = JSON.parse(item.lastAnswered);
	        if (questionsData) {
	          var timer = _this.state.timer;
	
	          var path = _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS.replace(':id', item.mock_id).replace(':session', _this.props.params.session).replace(':pathway', _this.props.params.pathway).replace(':caseno', questionsData.caseno).replace(':questiono', questionsData.questionId).replace(':timer', timer).replace(':testid', item.id).replace(':caseOffset', questionsData.caseOffset).replace(':quesOffset', questionsData.offset).replace(':isNegative', item.isNegative).replace(':timerStart', true);
	          _this.context.router.push({ pathname: path });
	        }
	      } else {
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	          sessionId: _this.props.params.session,
	          pathwayId: _this.props.params.pathway
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getCFAMockCases', data).then(function (resp) {
	          if (resp.success) {
	            var _timer = _this.state.timer;
	
	            var _path = _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS.replace(':id', item.mock_id).replace(':session', _this.props.params.session).replace(':pathway', _this.props.params.pathway).replace(':caseno', 1).replace(':questiono', 1).replace(':timer', _timer).replace(':testid', item.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	            _this.context.router.push({ pathname: _path });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      mockName: '',
	      deletepopup: false,
	      deleteId: '',
	      totalQuestionsCount: 1,
	      timer: _this.props.params.timer
	    };
	
	    _this.filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	    _this.questionRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_QUESTIONS : _AppRoutes2.default.CFA2_CBT_QUESTIONS;
	    _this.finishRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS : _AppRoutes2.default.CFA2_CBT_QUESTIONS_FINISH;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  //Function to redirect page to viewquestions page
	  //check CFA2 subscription
	
	
	  _createClass(AttemptedTest, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: this.props.params.id ? parseInt(this.props.params.id) : '',
	                  pathwayId: this.props.params.pathway,
	                  sessionId: this.props.params.session
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getAllAttemptedTest', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.data,
	                      isLoading: false
	                    });
	                  } else {
	                    _this3.setState({
	                      ValidToken: false,
	                      isLoading: false
	                    });
	                  }
	                  return resp;
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getTotalQuestionsCount', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ totalQuestionsCount: resp.question });
	                  } else {}
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getMockNameById', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            _this3.setState({
	                              mockName: res.data && res.data.session_name ? res.data.session_name : '',
	                              pathwayDetails: res.pathwayDetails && res.pathwayDetails.pathway_name || ''
	                            });
	
	                          case 1:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockName = _state.mockName,
	          deletepopup = _state.deletepopup,
	          totalQuestionsCount = _state.totalQuestionsCount,
	          timer = _state.timer,
	          pathwayDetails = _state.pathwayDetails;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper rem-left-pad' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              (pathwayDetails ? pathwayDetails + ' -' : '') + ' ' + mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'two-btn-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.startExam();
	                  }
	                },
	                _language2.default.LC().START
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                'Change Session'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: deletepopup, toggle: this.deleteTest, className: 'modal-primary' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteTest },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table table-remove-space' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '9%' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().DATE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TEST_COMPLETED_IN
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().STATUS
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList.length ? mockList.map(function (item, index) {
	                          var time = 0;
	                          if (item.isNegative === 'true') {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(timer) - item.user_time_value);
	                          } else {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(timer) + item.user_time_value);
	                          }
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'score-qnt' },
	                              item.score && totalQuestionsCount ? (Math.ceil(item.score / totalQuestionsCount * 100) > 100 ? '0' : Math.ceil(item.score / totalQuestionsCount * 100)) + '%' : '0%'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.createdAt ? (0, _moment2.default)(item.createdAt).format('ll') : ''
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'clr-green' },
	                              time
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize mock-status' },
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                _language2.default.LC().Incomplete
	                              ) : item.status === 'non-graded' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                'Non Graded'
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status' },
	                                item.status
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              item.status === 'completed' || item.status === 'non-graded' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px 4px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().VIEW,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      return _this4.view(item);
	                                    },
	                                    className: 'fa fa-eye mark-action-btn-dashboard',
	                                    style: { color: '#1f8ceb' }
	                                  },
	                                  ' '
	                                )
	                              ) : null,
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px 4px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().RESUME
	                                ),
	                                _react2.default.createElement('i', {
	                                  className: 'fa fa-play-circle-o mark-action-btn-dashboard',
	                                  'aria-hidden': 'true',
	                                  style: { color: '#000' },
	                                  onClick: function onClick() {
	                                    _this4.resumeTest(item);
	                                  }
	                                })
	                              ) : null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px 4px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().DELETE,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      _this4.deleteTest(item.id);
	                                    },
	                                    className: 'fa fa-trash mark-action-btn-dashboard',
	                                    style: { color: '#f51a00' }
	                                  },
	                                  ' '
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '6', className: 'no-mocks' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '82px',
	                                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                { className: 'mt-1' },
	                                _language2.default.LC().NO_MOCK_EXAM_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return AttemptedTest;
	}(_react.Component);
	
	AttemptedTest.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = AttemptedTest;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var CFA2IntoductionInstruction = function (_Component) {
	  _inherits(CFA2IntoductionInstruction, _Component);
	
	  function CFA2IntoductionInstruction(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFA2IntoductionInstruction);
	
	    var _this = _possibleConstructorReturn(this, (CFA2IntoductionInstruction.__proto__ || Object.getPrototypeOf(CFA2IntoductionInstruction)).call(this, props));
	
	    _this.componentDidMount = function () {
	      // console.log(
	      //   'I am here on Frontendsrc\viewsCBTCFA2CBTNewIntoductionInstructionindex.js '
	      // );
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	    };
	
	    _this.changeQuestion = function (questionNumber) {
	      if (questionNumber) {
	        var _this$props$params = _this.props.params,
	            session = _this$props$params.session,
	            pathway = _this$props$params.pathway;
	
	        var path = _this.introductionRoute.replace(':questiono', questionNumber).replace(':pathway', pathway).replace(':session', session).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({ pathname: path });
	      }
	    };
	
	    _this.getPrevious = function (questionNumber) {
	      if (questionNumber) {
	        var _this$props$params2 = _this.props.params,
	            session = _this$props$params2.session,
	            pathway = _this$props$params2.pathway;
	
	        var path = _this.introductionRoute.replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) - 1 : 1).replace(':timer', _this.props.params.timer).replace(':pathway', pathway).replace(':session', session);
	        _this.context.router.push({ pathname: path });
	      }
	    };
	
	    _this.getNext = function (questionNumber) {
	      if (questionNumber) {
	        var _this$props$params3 = _this.props.params,
	            session = _this$props$params3.session,
	            pathway = _this$props$params3.pathway;
	
	        var path = _this.introductionRoute.replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) + 1 : 1).replace(':pathway', pathway).replace(':session', session).replace(':timer', _this.props.params.timer);
	        _this.context.router.push({ pathname: path });
	      }
	    };
	
	    _this.startTest = function () {
	      var _this$props$params4 = _this.props.params,
	          session = _this$props$params4.session,
	          pathway = _this$props$params4.pathway;
	
	      _this.setState({ startLoading: true });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        pathwayId: pathway,
	        sessionId: session
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        status: 'pending',
	        pathwayId: pathway,
	        sessionId: session
	      };
	      var fileName = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getCFAMockCases', data).then(function (caseResp) {
	        if (caseResp.success) {
	          _this.setState({ startLoading: true });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/addUsersChoice', Object.assign({}, userData, {
	            maxGardSum: caseResp.maxGardSum
	          })).then(function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	              var appRoute, path;
	              return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      if (res.success) {
	                        appRoute = _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS;
	                        path = appRoute.replace(':session', session).replace(':pathway', pathway).replace(':caseno', caseResp.question && caseResp.question.length ? caseResp.question[0].id : 1).replace(':questiono', caseResp.data && caseResp.data.length ? caseResp.data[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', res.id).replace(':caseOffset', 0).replace(':quesOffset', 0).replace(':isNegative', true).replace(':timerStart', true);
	
	                        _this.context.router.push({ pathname: path });
	                      }
	
	                    case 1:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, _this2);
	            }));
	
	            return function (_x) {
	              return _ref.apply(this, arguments);
	            };
	          }());
	        }
	      });
	    };
	
	    _this.strikeText = function (e, value) {
	      e.preventDefault();
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      if (e.type === 'contextmenu') {
	        strikeThroughArr.push(value);
	        _this.setState({ strikeThroughArr: strikeThroughArr });
	      } else {
	        return;
	      }
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      token: '',
	      idname: '',
	      startLoading: false,
	      strikeThroughArr: []
	    };
	    _this.introductionRoute = _AppRoutes2.default.CFA3_PATHWAY_CBT_INTRODUCTION;
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFA2IntoductionInstruction, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          startLoading = _state.startLoading,
	          strikeThroughArr = _state.strikeThroughArr;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().Section_Introduction
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                Array.from({ length: 12 }, function (item) {
	                  return item;
	                }).map(function (item, index) {
	                  return _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      key: index,
	                      onClick: function onClick() {
	                        return _this3.changeQuestion(index + 1);
	                      },
	                      className: '' + (index + 1 === parseInt(_this3.props.params.questiono) ? 'active' : '')
	                    },
	                    index + 1
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper intro-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  this.props.params.questiono === '1' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().INTROTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().INTROPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTTOCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '2' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().WELCOMETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().WELCOMEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '3' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().USEMOUSETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_arrow.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().USEMOUSEPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '4' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().NAVIGATTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_tab_btn.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-2' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '5' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TIMEREMAINTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARAONE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'time-left-img',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_time.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARATWO, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '6' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().FLAGTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag_btn.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGBUTTON, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '7' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ANSWERMULTTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ANSWERMULTPARA, "div", "", { contentEditable: false })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'h6',
	                            null,
	                            _language2.default.LC().QUESMULTTITLE
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().A
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().ESTONIA
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().B
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().UKRAINE
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().C
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().BELGIUM
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '8' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().REVIEWTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              width: '38px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARACLOSE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'section-review',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_sidebar.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '9' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().HIGHLIGHTINGTEXT
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().HIGHLIGHTINGPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'mw-100',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_highlight.png',
	                              alt: 'Highlight'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().PLEASENOTE, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '10' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().STRIKINGOUTOPTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().STRIKINGOUTOPTIONSPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                _language2.default.LC().QUESMULTTITLE
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().A
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_a') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().ESTONIA
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().B
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_b') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().UKRAINE
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_c') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().BELGIUM
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '11' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ENDINGEXAMTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ENDINGEXAMPARA, "div", "", { contentEditable: false }),
	                          this.props.location.pathname.includes('cfa3') ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/questions/finish_page.png',
	                                alt: 'Mouse Arrow'
	                              })
	                            ),
	                            (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFOONFINISH, "div", "", { contentEditable: false })
	                          ) : null,
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '12' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TUTORIALCONCLUSIONTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TUTORIALCONCLUSIONPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().CLICKSTARTTEST
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getPrevious,
	                              className: 'pointer_class btn-primary',
	                              disabled: this.props.params.questiono === '1'
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getNext,
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.questiono) === 12
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                _this3.startTest();
	                              },
	                              className: 'pointer_class btn-primary'
	                            },
	                            startLoading ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : '',
	                            ' ',
	                            _language2.default.LC().START_TEST,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CFA2IntoductionInstruction;
	}(_react.Component);
	
	CFA2IntoductionInstruction.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = CFA2IntoductionInstruction;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PathwayList = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var PathwayList = exports.PathwayList = function (_Component) {
	  _inherits(PathwayList, _Component);
	
	  function PathwayList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PathwayList);
	
	    var _this = _possibleConstructorReturn(this, (PathwayList.__proto__ || Object.getPrototypeOf(PathwayList)).call(this, props));
	
	    _this.fetchPathwayList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _ref2, _ref2$success, success, _ref2$data, data;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getPathways');
	
	            case 2:
	              _ref2 = _context.sent;
	              _ref2$success = _ref2.success;
	              success = _ref2$success === undefined ? false : _ref2$success;
	              _ref2$data = _ref2.data;
	              data = _ref2$data === undefined ? [] : _ref2$data;
	
	              if (success) {
	                _this.setState({ list: data, isLoading: false });
	              } else {
	                _this.setState({ isLoading: false });
	              }
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      isLoading: true,
	      list: []
	    };
	    return _this;
	  }
	
	  _createClass(PathwayList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchPathwayList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          list = _state.list,
	          isLoading = _state.isLoading;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(_ComponentHeader2.default, { title: _messages.messages.PATHWAY_EXAM }),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: 12 },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _messages.messages.PATHWAY_EXAM_LIST
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _messages.messages.ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        list.length ? list.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                item.cbt_mock_exam_name,
	                                ' - ',
	                                item.pathway_name
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap ',
	                                  onClick: function onClick() {
	                                    return router.push({
	                                      pathname: _AppRoutes2.default.CFA3_PATHWAY_SESSION.replace(':pathway', item.id)
	                                    });
	                                  }
	                                },
	                                _messages.messages.START
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '4', className: 'text-center py-4 px-2' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _messages.messages.PATHWAY_NOT_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PathwayList;
	}(_react.Component);
	
	PathwayList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = PathwayList;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBT2InstructionsNew = __webpack_require__(183);
	
	var _CBT2InstructionsNew2 = _interopRequireDefault(_CBT2InstructionsNew);
	
	var _reactstrap = __webpack_require__(6);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _messages = __webpack_require__(14);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var CBT2MockExams = function (_Component) {
	  _inherits(CBT2MockExams, _Component);
	
	  function CBT2MockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBT2MockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBT2MockExams.__proto__ || Object.getPrototypeOf(CBT2MockExams)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({ alert_status: !_this.state.alert_status });
	    };
	
	    _this.togglePdfMessage = function () {
	      _this.setState({ pdfMessageOpen: !_this.state.pdfMessageOpen });
	    };
	
	    _this.checkSubscriptionPartner = function () {
	      var pathname = _this.props.location.pathname;
	
	      if (pathname.includes('/cfa3/')) return _Cfa3Subscription4.default.checkCfa3Subscription;
	      return _Cfa2Subscription4.default.checkCfa2Subscription;
	    };
	
	    _this.checkSubscriptionUser = function (selectedmen, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam) {
	      var pathname = _this.props.location.pathname;
	
	      if (pathname.includes('/cfa3/')) {
	        return _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam);
	      }
	      return _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam);
	    };
	
	    _this.getQuestions = function (mock) {
	      _this.setState({ showInstructionModal: false });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context.next = 6;
	                        return _this.checkSubscriptionPartner(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          _this._runCode('paid', mock);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            // console.log('resp.profileInfo.---------------', resp.profileInfo);
	            _this.toggleAlert();
	            _this.setState({ subscriptionstatus: 'free' });
	            _this._runCode('free');
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _this.checkSubscriptionUser(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	                  _this._runCode('paid', mock);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus, mock) {
	      if (subscriptionstatus === 'paid') {
	        var frontendRoute = _this.props.location.pathname.includes('/cfa3/') ? _AppRoutes2.default.CFA3_CBT_INTRODUCTION : _AppRoutes2.default.CFA2_CBT_INTRODUCTION;
	        var pathname = frontendRoute.replace(':id', mock.id).replace(':questiono', 1).replace(':timer', mock.timer);
	        _this.context.router.push({ pathname: pathname });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function (mock) {
	      _this.setState({
	        showInstructionModal: true,
	        mockData: mock
	      });
	    };
	
	    _this.viewAttemptedExams = function (sessionId) {
	      var pathway = _this.props.params.pathway;
	
	      var path = _AppRoutes2.default.CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK.replace(':pathway', pathway).replace(':session', sessionId).replace(':timer', 8100);
	      _this.context.router.push({ pathname: path });
	    };
	
	    _this.openQPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname
	      };
	
	      var filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	
	      if (filePath === 'cfa3CBTMockExams') {
	        data.sessionId = id;
	        data.pathwayId = _this.props.params.pathway;
	      } else {
	        data.mock_id = id;
	      }
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + filePath + '/download-question-pdf', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ pdfLoadingQ: false });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQ: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.openQAPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname
	      };
	      var filePath = _this.props.location.pathname.includes('/cfa3/') ? 'cfa3CBTMockExams' : 'cfa2CBTMockExams';
	
	      if (filePath === 'cfa3CBTMockExams') {
	        data.sessionId = id;
	        data.pathwayId = _this.props.params.pathway;
	      } else {
	        data.mock_id = id;
	      }
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/' + filePath + '/MockQAPdfDownload', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ pdfLoadingQA: false });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQA: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.validateSubscriptionAndGeneratePDF = function (id, type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, partnerCheckFn, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 12;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // #261 — route through checkSubscriptionPartner() so /cfa3/*
	                        // pages use Cfa3 check (whose whitelist includes pkg 21 etc).
	                        // Previously hard-coded Cfa2 → partner with CFA Unlimited L2+L3
	                        // (pkg 21) was denied PDF download on /cfa3/pathway/*/session.
	
	                        partnerCheckFn = _this.checkSubscriptionPartner();
	                        _context2.next = 7;
	                        return partnerCheckFn(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 7:
	                        isInArray_var = _context2.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          if (type === 'Q') {
	                            _this.setState({ pdfLoadingQ: true });
	                            _this.openQPDF(id);
	                          } else {
	                            _this.setState({ pdfLoadingQA: true });
	                            _this.openQAPDF(id);
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 13;
	                        break;
	
	                      case 12:
	                        console.log('fail');
	
	                      case 13:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _this.checkSubscriptionUser(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	
	                  if (type === 'Q') {
	                    _this.setState({ pdfLoadingQ: true });
	                    _this.openQPDF(id);
	                  } else {
	                    _this.setState({ pdfLoadingQA: true });
	                    _this.openQAPDF(id);
	                  }
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.backToPathway = function () {
	      _this.context.router.push({ pathname: _AppRoutes2.default.CFA3_PATHWAY_CBT });
	    };
	
	    _this.toggle = function (index) {
	      _this.setState({
	        dropdownOpenIndex: index,
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: _this.props.location.pathname.includes('/cfa3') ? 'cfa_3' : 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      pathwayDetails: {},
	      pdfLoadingQ: false,
	      pdfLoadingQA: false,
	      pdfMessage: '',
	      pdfMessageOpen: false,
	      dropdownOpen: false,
	      dropdownOpenIndex: ''
	    };
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  //Function to redirect page to viewquestions page
	
	
	  _createClass(CBT2MockExams, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // console.log('I am on Frontendsrc\viewsCBTCFA2CBTNewMockListindex.js');
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  pathwayId: this.props.params.pathway
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3PathwayExams/getSessions', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.data,
	                      isLoading: false,
	                      pathwayDetails: resp.pathwayDetails || {},
	                      userStatsData: resp.userstats
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockData = _state.mockData,
	          dropdownOpen = _state.dropdownOpen,
	          dropdownOpenIndex = _state.dropdownOpenIndex,
	          pathwayDetails = _state.pathwayDetails;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                Object.keys(pathwayDetails).length > 0 && pathwayDetails.pathway_name || ''
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: ' col-4 margin_bottom_20 ques-title-wrapper justify-content-end' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.backToPathway();
	                  }
	                },
	                _messages.messages.CHANGE_PATHWAY
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _messages.messages.SESSION
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _messages.messages.ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(_loader2.default, null) : mockList.length ? mockList.map(function (item, index) {
	                          var sessionOrMockId = item && item.cbt_pathway_session ? item.cbt_pathway_session.id : item.id;
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.cbt_pathway_session.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                item.cbt_pathway_session.session_name
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                  onClick: function onClick() {
	                                    return _this4.viewAttemptedExams(item.cbt_pathway_session.id);
	                                  }
	                                },
	                                _messages.messages.START
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                  _reactstrap.ButtonDropdown,
	                                  {
	                                    className: index + 1 === mockList.length ? 'dropup' : '',
	                                    isOpen: dropdownOpenIndex === index ? dropdownOpen : false,
	                                    toggle: function toggle() {
	                                      return _this4.toggle(index);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownToggle,
	                                    {
	                                      className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                      caret: true
	                                    },
	                                    _language2.default.LC().PRINT
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownMenu,
	                                    { right: true },
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'public',
	                                        onClick: function onClick() {
	                                          _this4.validateSubscriptionAndGeneratePDF(sessionOrMockId, 'Q');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_CASES_Q_MOCK
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'private',
	                                        onClick: function onClick() {
	                                          _this4.validateSubscriptionAndGeneratePDF(sessionOrMockId, 'QA');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_CASES_QA_MOCK
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '4', className: 'text-center py-4 px-2' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _messages.messages.NO_DATA_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.pdfMessageOpen,
	            toggle: this.togglePdfMessage,
	            className: 'modal-primary custom_modalpro info-modal-designing'
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.togglePdfMessage, className: 'custom-title' },
	            'Information'
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-info-view-for-plan' },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.pdfMessage
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btn-plan-view view-plan-wrap' },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { className: 'btn btn-primary', onClick: this.togglePdfMessage },
	                  'OK'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBT2InstructionsNew2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions(mockData);
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBT2MockExams;
	}(_react.Component);
	
	CBT2MockExams.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = CBT2MockExams;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _constant = __webpack_require__(9);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _function = __webpack_require__(10);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.getQuestions = function (data) {
	      _this.setState({
	        isDataLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            questionsData: resp.question,
	            totalCount: resp.question.length,
	            selectedQuestionData: resp.question[_this.props.params.offset],
	            isLoading: false,
	            isDataLoading: false
	          });
	          var _this$props$params = _this.props.params,
	              id = _this$props$params.id,
	              testid = _this$props$params.testid,
	              timer = _this$props$params.timer,
	              offset = _this$props$params.offset;
	
	          resp.question[offset] && _this.context.router.replace({
	            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH).replace(':id', id).replace(':testid', testid).replace(':questiono', resp.question[offset].id).replace(':timer', timer).replace(':offset', offset)
	          });
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data
	          });
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.componentDidMount = function () {
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      _this.getQuestions(data);
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      _this.timer = setInterval(_this.countDown, 1000);
	      var ansdata = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        if (resp_count.success) {
	          _this.setState({
	            rightanswercount: resp_count.allrightanswercount.question_count
	          });
	        } else {
	          // console.log(resp_count.success + "------------failure");
	        }
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _this.setState({
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                  });
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	      _this.getUserStats();
	      if (questionNumber) {
	        var _this$props$params2 = _this.props.params,
	            id = _this$props$params2.id,
	            timer = _this$props$params2.timer,
	            testid = _this$props$params2.testid;
	
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH).replace(':id', id).replace(':testid', testid).replace(':questiono', questionNumber).replace(':timer', timer).replace(':offset', index)
	          //  :id/:questiono/:timer/:testid/:offset/:isNegative/:timerStart
	          //   `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/${questionNumber}/${this.props.params.timer
	          //     }/${this.props.params.testid}/${index}`,
	        });
	      }
	    };
	
	    _this.toggle = function () {
	      var dropdownOpen = _this.state.dropdownOpen;
	
	      _this.setState({ dropdownOpen: !dropdownOpen });
	    };
	
	    _this.getPrevious = function (index) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	      _this.slider.slickGoTo(index - 2);
	      var questionsData = _this.state.questionsData;
	      var _this$props$params3 = _this.props.params,
	          id = _this$props$params3.id,
	          offset = _this$props$params3.offset,
	          timer = _this$props$params3.timer,
	          testid = _this$props$params3.testid;
	
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH).replace(':id', id).replace(':testid', testid).replace(':questiono', offset ? questionsData[parseInt(offset) - 1].id : 1).replace(':timer', timer).replace(':offset', offset ? parseInt(offset) - 1 : 1)
	
	        // pathname: `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/${this.props.params.offset ? questionsData[parseInt(this.props.params.offset) - 1].id : 1
	        //   }/${this.props.params.timer}/${this.props.params.testid}/${this.props.params.offset ? parseInt(this.props.params.offset) - 1 : 1
	        //   }`,
	      });
	    };
	
	    _this.getNext = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(index) {
	        var questionsData, _this$props$params4, id, offset, timer, testid;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.setState({ report_block: 'card hide_block', successAlert: false });
	                _this.slider.slickGoTo(index);
	                questionsData = _this.state.questionsData;
	                _this$props$params4 = _this.props.params, id = _this$props$params4.id, offset = _this$props$params4.offset, timer = _this$props$params4.timer, testid = _this$props$params4.testid;
	
	                _this.context.router.push({
	                  pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH).replace(':id', id).replace(':testid', testid).replace(':questiono', offset ? questionsData[parseInt(offset) + 1].id : 1).replace(':timer', timer).replace(':offset', offset ? parseInt(offset) + 1 : 1)
	
	                  // pathname: `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/${this.props.params.offset ? questionsData[parseInt(this.props.params.offset) + 1].id : 1
	                  //   }/${this.props.params.timer}/${this.props.params.testid}/${this.props.params.offset ? parseInt(this.props.params.offset) + 1 : 1
	                  //   }`,
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.backToMock = function () {
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK).replace(':id', _this.props.params.id).replace(':timer', _this.props.params.timer)
	      });
	    };
	
	    _this.getReadingViseScore = function () {
	      // console.log("heeyyyyyyy");
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getrightAnswerReadingVise', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  // let temp = 0;
	                  // let arr = res.allrightanswercount.map((item, i) => {
	                  //   if (res.readingName.some(ele => ele.id === item.id)) {
	                  //     return Object.assign({}, item, res.allrightanswercount[temp++]);
	                  //   } else return Object.assign({}, item, 0);
	                  // });
	
	                  _this.setState({
	                    readingViseScore: res.result
	                  });
	
	                case 1:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x3) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getDetailedResultGraph = function (totalQuestion) {
	      var _this$props$params5 = _this.props.params,
	          id = _this$props$params5.id,
	          testid = _this$props$params5.testid,
	          timer = _this$props$params5.timer;
	
	      var path = (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_DETAILED_RESULT_GRAPH).replace(':id', id).replace(':test_id', testid).replace(':totalQuestions', totalQuestion).replace(':timer', timer);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this2);
	        }));
	
	        return function (_x4) {
	          return _ref4.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.offset !== _this.props.params.offset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _this.getQuestions(data);
	      }
	    };
	
	    _this.reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	
	      _this.setState({
	        reportError: ''
	      });
	      if (comment.length < 2) {
	        _this.setState({
	          reportError: 'Please enter comment'
	        });
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: id,
	        comment: comment,
	        offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : 0,
	        timer: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : 0,
	        mockName: _this.state.mockName
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._hideReportForm = function () {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block', reportError: '' });
	    };
	
	    _this.handleScroll = function () {
	      window.scroll({
	        top: document.body.offsetHeight,
	        left: 0,
	        behavior: 'smooth'
	      });
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      reportLoading: false,
	      time: {},
	      seconds: 100,
	      showFinishTestPopup: false,
	      showAnswer: false,
	      rightanswercount: '',
	      text: '',
	      mockName: '',
	      showSectionReview: false,
	      dropdownOpen: false,
	      readingViseScore: [],
	      selectedQuestionData: [],
	      report_block: 'card hide_block',
	      successAlert: false,
	      reportError: ''
	    };
	    _this.timer = 0;
	    return _this;
	  }
	  //it is use to redirect page
	
	
	  //Function to hide Report box
	
	
	  _createClass(CFAQuestions, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          userStatsData = _state.userStatsData,
	          rightanswercount = _state.rightanswercount,
	          mockName = _state.mockName,
	          showSectionReview = _state.showSectionReview,
	          readingViseScore = _state.readingViseScore,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          flag = _state.flag,
	          reportLoading = _state.reportLoading,
	          reportError = _state.reportError;
	      var question_ids = userStatsData.question_ids;
	
	      var totalQuestions = question_ids && JSON.parse(question_ids).length || questionsData && questionsData.length || 0;
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var userTime = 0;
	      if (userStatsData && userStatsData.user_time_value && this.props.params.timer) {
	        if (userStatsData.isNegative === 'true') {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) - userStatsData.user_time_value);
	        } else {
	          userTime = (0, _constant.SecondsToHHMMSS)(parseInt(this.props.params.timer) + userStatsData.user_time_value);
	        }
	      }
	      var percentage = rightanswercount * 100 / totalQuestions;
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'pointer_class btn-primary back-btn',
	                  onClick: function onClick() {
	                    return _this3.backToMock();
	                  }
	                },
	                _language2.default.LC().BACK
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : questionsData && questionsData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this3.slider = slider;
	                    }
	                  }),
	                  ' ',
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag && flag.length ? flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0] : '';
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return _this3.changeQuestion(item.id, index);
	                          },
	                          className: '\n                        ' + (index === parseInt(_this3.props.params.offset) ? 'active' : '') + '\n                        ' + (userChoice[item.id] === item.answer ? 'right-ans' : userChoice[item.id] ? 'wrong-ans' : 'not-ans') + '\n                        ' + (flaggedQuestions ? 'flag-add' : '') + '\n                        '
	                        },
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : '',
	                        index + 1
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-11' },
	                isDataLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header qus-header finish-question-wrapper' },
	                    selectedQuestionData && selectedQuestionData.question ? _react2.default.createElement(
	                      'div',
	                      { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_right_20',
	                          alt: '',
	                          width: '30'
	                        }),
	                        'Q.',
	                        parseInt(this.props.params.offset) + 1
	                      ),
	                      (0, _function.renderHTMLContent)(selectedQuestionData.question, "div", "qus-title w-100", { contentEditable: false, style: { marginTop: "8px" } })
	                    ) : null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'btn btn-primary pointer_class mid-btn',
	                          onClick: function onClick() {
	                            _this3.setState({
	                              showSectionReview: true
	                            });
	                            _this3.getReadingViseScore();
	                          }
	                        },
	                        _language2.default.LC().SCORE
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_MYSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip_wrap tooltip_wrap_margin' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: (rightanswercount ? rightanswercount : 0) === 0 ? true : false,
	                          className: (rightanswercount ? rightanswercount : 0) === 0 ? 'cursor_not_Allowed btn btn-primary  mid-btn' : 'btn btn-primary mid-btn',
	                          onClick: function onClick() {
	                            return _this3.getDetailedResultGraph(totalQuestions);
	                          }
	                        },
	                        _language2.default.LC().GRAPH
	                      ),
	                      rightanswercount ? rightanswercount === 0 ? null : _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        _language2.default.LC().SHOW_GRAPH
	                      ) : null
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _constant.optionsArr.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'div',
	                              { className: 'col-sm-12', id: item, key: index },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box cursor-default ' + (userChoice ? selectedQuestionData && selectedQuestionData.answer === item && userChoice[_this3.props.params.questiono] === item ? 'border-green' : selectedQuestionData.answer === item ? 'border-green' : userChoice[_this3.props.params.questiono] === item ? 'border-red' : '' : '')
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  { className: 'ans_box_text' },
	                                  selectedQuestionData && selectedQuestionData[item] ? (0, _function.renderHTMLContent)(selectedQuestionData[item], "span", "", { contentEditable: false }) : null
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'score-wrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'score-inner' },
	                            rightanswercount ? rightanswercount : 0,
	                            '/',
	                            totalQuestions
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            null,
	                            _language2.default.LC().You_Scored,
	                            ' ',
	                            Math.ceil(percentage),
	                            '%'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer finished-time' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h4',
	                              null,
	                              _language2.default.LC().TEST_COMPLETED_IN
	                            ),
	                            _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'timer_box' },
	                              userTime
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            'span',
	                            {
	                              className: 'up tooltip-hover-questions',
	                              style: { padding: '10px' }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              ' ',
	                              _language2.default.LC().REPORT_THIS_QUESTION,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'report-icon-wrapper',
	                                onClick: function onClick() {
	                                  _this3.handleScroll();
	                                  _this3.setState({
	                                    report_block: 'card show_block'
	                                  });
	                                }
	                              },
	                              _react2.default.createElement('img', {
	                                src: _App_data2.default.frontend_url + '/img/report4.png',
	                                alt: 'report'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this3.getPrevious(_this3.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this3.getNext(_this3.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card show_block' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'card-header highlight_finish_text ' + (userChoice && userChoice[this.props.params.questiono] === selectedQuestionData.answer ? 'text_success-cbt' : !userChoice[this.props.params.questiono] ? 'text_unAttempted-cbt' : 'text_failure-cbt')
	                },
	                userChoice && userChoice[this.props.params.questiono] === selectedQuestionData.answer ? '' + _language2.default.LC().Correct : !userChoice[this.props.params.questiono] ? '' + _language2.default.LC().NOT_ATTEMPTED : '' + _language2.default.LC().Incorrect
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                (0, _function.renderHTMLContent)(selectedQuestionData && selectedQuestionData.explanation ? selectedQuestionData.explanation : "", "p", "view_questionhtml", { contentEditable: false })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'error_text ml-1' },
	                        ' ',
	                        reportError
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: function onClick() {
	                              return _this3.reportQuestion(selectedQuestionData.id);
	                            }
	                          },
	                          reportLoading ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                            ' ',
	                            _language2.default.LC().PLEASE_WAIT
	                          ) : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: function onClick() {
	                              return _this3._hideReportForm();
	                            }
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: function onClick() {
	                              _this3.setState({
	                                report_block: 'card hide_block',
	                                successAlert: false
	                              });
	                            }
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'sidebar-review-wrapper sidebar-score-wrapper ' + (showSectionReview ? 'active' : '')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              ' ',
	              _language2.default.LC().TOPIC_WISE_SCORE
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'cursor-pointer',
	                onClick: function onClick() {
	                  _this3.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'score-list-wrapper' },
	              readingViseScore && readingViseScore.length ? readingViseScore.map(function (item, index) {
	                var readingPercentage = item.question_count * 100 / item.cfa_cbt_questions.length;
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      index + 1,
	                      '\xA0 ',
	                      item.chapter_name
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'progress custom-prog-bar margin_top_5' },
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'progress-bar',
	                          role: 'progressbar',
	                          style: {
	                            width: Math.ceil(readingPercentage) + '%'
	                          },
	                          'aria-valuenow': '' + Math.ceil(readingPercentage),
	                          'aria-valuemin': '0',
	                          'aria-valuemax': '100'
	                        },
	                        Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0,
	                        '%'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'score-inner' },
	                    item.question_count ? item.question_count : 0,
	                    '/',
	                    item.cfa_cbt_questions ? item.cfa_cbt_questions.length : 0
	                  )
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-qus-found no-mock-exam mt-5' },
	                _react2.default.createElement('img', {
	                  width: '62px',
	                  src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'mt-1' },
	                  _language2.default.LC().NO_SCORE_FOUND
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var IntroductionInstruction = function (_Component) {
	  _inherits(IntroductionInstruction, _Component);
	
	  function IntroductionInstruction(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, IntroductionInstruction);
	
	    var _this = _possibleConstructorReturn(this, (IntroductionInstruction.__proto__ || Object.getPrototypeOf(IntroductionInstruction)).call(this, props));
	
	    _this.componentDidMount = function () {
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	    };
	
	    _this.changeQuestion = function (questionNumber) {
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION).replace(':id', _this.props.params.id).replace(':questiono', questionNumber).replace(':timer', _this.props.params.timer)
	        });
	      }
	    };
	
	    _this.getPrevious = function (questionNumber) {
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION).replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) - 1 : 1).replace(':timer', _this.props.params.timer)
	        });
	      }
	    };
	
	    _this.getNext = function (questionNumber) {
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION).replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono ? parseInt(_this.props.params.questiono) + 1 : 1).replace(':timer', _this.props.params.timer)
	        });
	      }
	    };
	
	    _this.startTest = function () {
	      _this.setState({
	        startLoading: true
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	      };
	      var userData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        status: 'pending'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            startLoading: true
	          });
	          var _response$question = response.question,
	              question = _response$question === undefined ? [] : _response$question;
	
	          var questionIds = question.map(function (questionDetail) {
	            return questionDetail.id;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/addUsersChoice', Object.assign({}, userData, { questionIds: questionIds })).then(function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	              return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      if (res.success) {
	                        _this.context.router.push({
	                          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', response.question && response.question.length ? response.question[0].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', res.id).replace(':offset', 0).replace(':isNegative', 'true').replace(':timerStart', 'true')
	                        });
	                      }
	
	                    case 1:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, _this2);
	            }));
	
	            return function (_x) {
	              return _ref.apply(this, arguments);
	            };
	          }());
	        }
	      });
	    };
	
	    _this.strikeText = function (e, value) {
	      e.preventDefault();
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      if (e.type === 'contextmenu') {
	        strikeThroughArr.push(value);
	        _this.setState({
	          strikeThroughArr: strikeThroughArr
	        });
	      } else {
	        return;
	      }
	    };
	
	    _this.state = {
	      questionsData: [],
	      totalCount: 0,
	      isLoading: true,
	      token: '',
	      idname: '',
	      startLoading: false,
	      strikeThroughArr: []
	    };
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(IntroductionInstruction, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          startLoading = _state.startLoading,
	          strikeThroughArr = _state.strikeThroughArr;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().Section_Introduction
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                Array.from({ length: 12 }, function (item) {
	                  return item;
	                }).map(function (item, index) {
	                  return _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      key: index,
	                      onClick: function onClick() {
	                        return _this3.changeQuestion(index + 1);
	                      },
	                      className: '' + (index + 1 === parseInt(_this3.props.params.questiono) ? 'active' : '')
	                    },
	                    index + 1
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper intro-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  this.props.params.questiono === '1' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().INTROTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().INTROPARA, "div", "", { contentEditable: false }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTTOCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '2' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().WELCOMETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().WELCOMEPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '3' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().USEMOUSETITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_arrow.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().USEMOUSEPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '4' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().NAVIGATTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_tab_btn.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().NAVIGATBUTTONINFO, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-2' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '5' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TIMEREMAINTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARAONE, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'time-left-img',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_time.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TIMEREMAINPARATWO, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '6' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().FLAGTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_flag_tag_btn.png'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().FLAGBUTTON, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '7' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ANSWERMULTTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ANSWERMULTPARA, "div", "", { contentEditable: "false" })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'h6',
	                            null,
	                            _language2.default.LC().QUESMULTTITLE
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().A
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().ESTONIA
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().B
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().UKRAINE
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-8' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'answer_box border-black' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'answer_count highlight_choice' },
	                              _language2.default.LC().C
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'ans_box_text' },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _language2.default.LC().BELGIUM
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '8' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().REVIEWTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              width: '38px',
	                              src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().REVIEWPARACLOSE, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'section-review',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_sidebar.png',
	                              alt: 'Mouse Arrow'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '9' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().HIGHLIGHTINGTEXT
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().HIGHLIGHTINGPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement('img', {
	                              className: 'mw-100',
	                              src: _App_data2.default.frontend_url + '/img/questions/img_highlight.png',
	                              alt: 'Highlight'
	                            })
	                          ),
	                          (0, _function.renderHTMLContent)(_language2.default.LC().PLEASENOTE, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '10' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().STRIKINGOUTOPTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().STRIKINGOUTOPTIONSPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'h6',
	                                null,
	                                _language2.default.LC().QUESMULTTITLE
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_a');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().A
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_a') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().ESTONIA
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_b');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().B
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_b') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().UKRAINE
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-8' },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box border-black',
	                                  onClick: function onClick(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  },
	                                  onContextMenu: function onContextMenu(e) {
	                                    return _this3.strikeText(e, 'choice_c');
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'answer_count highlight_choice' },
	                                  _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text ' + (strikeThroughArr.includes('choice_c') ? 'strikethrough' : '')
	                                  },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _language2.default.LC().BELGIUM
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '11' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().ENDINGEXAMTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().ENDINGEXAMPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().NEXTBUTTONCONTINUE
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  this.props.params.questiono === '12' ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header d-flex justify-content-between qus-header' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'qus-wrapper' },
	                        _language2.default.LC().TUTORIALCONCLUSIONTITLE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-12' },
	                          (0, _function.renderHTMLContent)(_language2.default.LC().TUTORIALCONCLUSIONPARA, "div", "", { contentEditable: "false" }),
	                          _react2.default.createElement(
	                            'h6',
	                            { className: 'mt-3' },
	                            _language2.default.LC().CLICKSTARTTEST
	                          )
	                        )
	                      )
	                    )
	                  ) : '',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper' },
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getPrevious,
	                              className: 'pointer_class btn-primary',
	                              disabled: this.props.params.questiono === '1'
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: this.getNext,
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.questiono) === 12
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                _this3.startTest();
	                              },
	                              className: 'pointer_class btn-primary'
	                            },
	                            startLoading ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : '',
	                            ' ',
	                            _language2.default.LC().START_TEST,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IntroductionInstruction;
	}(_react.Component);
	
	IntroductionInstruction.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = IntroductionInstruction;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa1Subscription = __webpack_require__(142);
	
	var _Cfa1Subscription2 = _interopRequireDefault(_Cfa1Subscription);
	
	var _Cfa1Subscription3 = __webpack_require__(143);
	
	var _Cfa1Subscription4 = _interopRequireDefault(_Cfa1Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _reactstrap = __webpack_require__(6);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBTMockExams = function (_Component) {
	  _inherits(CBTMockExams, _Component);
	
	  function CBTMockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTMockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExams.__proto__ || Object.getPrototypeOf(CBTMockExams)).call(this, props));
	
	    _this.getQuestions = function (mock) {
	      _this.setState({
	        showInstructionModal: false
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            // console.log(
	            //   "resp.profileInfo.subscription_details",
	            //   resp.profileInfo.subscription_details
	            // );
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log("resp.profileInfo.userStatus", resp.profileInfo);
	
	                        _context.next = 6;
	                        return _Cfa1Subscription4.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          _this._runCode('paid', mock);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            // console.log("fail");
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            // console.log("in paid");
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log("resp of get exam by user", resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa1Subscription2.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log("outside isInArray_var heeee", isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log("inside isInArray_var ", isInArray_var);
	                  _this._runCode('paid', mock);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log("fail");
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus, mock) {
	      if (subscriptionstatus === 'paid') {
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION).replace(':id', mock.id).replace(':questiono', 1).replace(':timer', mock.timer)
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        // pathname: `/subscribe/selectPackage/${this.state.selectedmenu}`,
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function (mock) {
	      _this.setState({
	        showInstructionModal: true,
	        mockData: mock
	      });
	    };
	
	    _this.viewAttemptedExams = function (mock) {
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK).replace(':id', mock.id).replace(':timer', mock.timer)
	      });
	    };
	
	    _this.openQPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/MockQPdfDownload', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQ: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQ: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.openQAPDF = function (id) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/MockQAPdfDownload', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            pdfLoadingQA: false
	          });
	          var myWindow = window.open(resp.DownloadLink);
	          myWindow.focus();
	        } else {
	          // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
	          _this.setState({
	            pdfLoadingQA: false,
	            pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
	            pdfMessageOpen: true
	          });
	        }
	        return resp;
	      });
	    };
	
	    _this.checkSubscription = function (id, type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, hasMockAccess;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log("resp.profileInfo.userStatus", resp.profileInfo);
	
	                        _context2.next = 6;
	                        return _Cfa1Subscription4.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	                        hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	
	                        if (isInArray_var || hasMockAccess) {
	                          if (type === 'Q') {
	                            _this.setState({
	                              pdfLoadingQ: true
	                            });
	                            _this.openQPDF(id);
	                          } else {
	                            _this.setState({
	                              pdfLoadingQA: true
	                            });
	                            _this.openQAPDF(id);
	                          }
	                          // this._runCode('paid');
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            // console.log("fail");
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            // console.log("in paid");
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log("resp of get exam by user", resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa1Subscription2.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(resp_exam.hasMockSubscription);
	                // console.log("outside isInArray_var heeee", isInArray_var);
	                if (isInArray_var || hasMockAccess) {
	                  // console.log("inside isInArray_var ", isInArray_var);
	                  if (type === 'Q') {
	                    _this.setState({
	                      pdfLoadingQ: true
	                    });
	                    _this.openQPDF(id);
	                  } else {
	                    _this.setState({
	                      pdfLoadingQA: true
	                    });
	                    _this.openQAPDF(id);
	                  }
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log("fail");
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.toggle = function (index) {
	      _this.setState({
	        dropdownOpenIndex: index,
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      pdfLoadingQ: false,
	      pdfLoadingQA: false,
	      pdfMessage: '',
	      pdfMessageOpen: false,
	      dropdownOpen: false,
	      dropdownOpenIndex: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.togglePdfMessage = _this.togglePdfMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBTMockExams, [{
	    key: 'togglePdfMessage',
	    value: function togglePdfMessage() {
	      this.setState({ pdfMessageOpen: !this.state.pdfMessageOpen });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                if (localStorage.getItem('selectedmenu') === 'frm') {
	                  this.context.router.push({
	                    pathname: '/frm_questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCFAMockExams', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.mock,
	                      isLoading: false,
	                      userStatsData: resp.userstats
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockData = _state.mockData,
	          dropdownOpen = _state.dropdownOpen,
	          dropdownOpenIndex = _state.dropdownOpenIndex;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().MOCK_LIST
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'mw-190' },
	                            _language2.default.LC().MOCKEXAM
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'w-280 text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(_loader2.default, null) : mockList.length ? mockList.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.mock_order
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                item.mock_exam
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                  onClick: function onClick() {
	                                    return _this4.viewAttemptedExams(item);
	                                  }
	                                },
	                                _language2.default.LC().START
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'privetinfo-dropdown' },
	                                _react2.default.createElement(
	                                  _reactstrap.ButtonDropdown,
	                                  {
	                                    className: index + 1 === mockList.length ? 'dropup' : '',
	                                    isOpen: dropdownOpenIndex === index ? dropdownOpen : false,
	                                    toggle: function toggle() {
	                                      return _this4.toggle(index);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownToggle,
	                                    {
	                                      className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	                                      caret: true
	                                    },
	                                    _language2.default.LC().PRINT
	                                  ),
	                                  _react2.default.createElement(
	                                    _reactstrap.DropdownMenu,
	                                    { right: true },
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'public',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item.id, 'Q');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_Q_MOCK
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactstrap.DropdownItem,
	                                      {
	                                        value: 'private',
	                                        onClick: function onClick() {
	                                          _this4.checkSubscription(item.id, 'QA');
	                                        }
	                                      },
	                                      _react2.default.createElement('i', {
	                                        className: 'fa fa-print color-black',
	                                        'aria-hidden': 'true'
	                                      }),
	                                      _language2.default.LC().PRINT_QA_MOCK
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '4', className: 'text-center py-4 px-2' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '80px',
	                                src: _App_data2.default.frontend_url + '/img/questions/problem.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                null,
	                                _language2.default.LC().No_Mock_Exams
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.pdfMessageOpen,
	            toggle: this.togglePdfMessage,
	            className: 'modal-primary custom_modalpro info-modal-designing'
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.togglePdfMessage, className: 'custom-title' },
	            _language2.default.LC().INFORMATION
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-info-view-for-plan' },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.pdfMessage
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btn-plan-view view-plan-wrap' },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { className: 'btn btn-primary', onClick: this.togglePdfMessage },
	                  _language2.default.LC().OK ? _language2.default.LC().OK : 'OK'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions(mockData);
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBTMockExams;
	}(_react.Component);
	
	CBTMockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBTMockExams;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactstrap = __webpack_require__(6);
	
	__webpack_require__(80);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _cbtleftnavigationsettings = __webpack_require__(55);
	
	var _constant = __webpack_require__(9);
	
	var _highlightText = __webpack_require__(56);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _function = __webpack_require__(10);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var longPressDuration = 450;
	
	var CFAQuestions = function (_Component) {
	  _inherits(CFAQuestions, _Component);
	
	  function CFAQuestions(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CFAQuestions.__proto__ || Object.getPrototypeOf(CFAQuestions)).call(this, props));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (prevProps.params.offset !== _this.props.params.offset) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _this.getQuestions(data);
	      }
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	              };
	
	              _this.getQuestions(data);
	              _this.getUserStats();
	              _this.getFlagQuestions();
	              if (_this.props.params.timerStart === 'true') {
	                _this.timer = setInterval(_this.countDown, 1000);
	              } else {
	                clearInterval(_this.timer);
	              }
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _this.setState({
	                            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                          });
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 9:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getQuestions = function (data) {
	      _this.setState({
	        isDataLoading: true,
	        highlights: []
	      });
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var highlightdata = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(function (resp) {
	        if (resp.success) {
	          _this.getHighlightedText(highlightdata);
	          _this.getStrikedText(highlightdata);
	          _this.setState({
	            questionsData: resp.question,
	            selectedQuestionData: resp.question[_this.props.params.offset],
	            isLoading: false,
	            isDataLoading: false,
	            selectedQuestion: resp.question[_this.props.params.offset].question
	          });
	        } else {
	          _this.setState({
	            isLoading: false,
	            isDataLoading: false
	          });
	        }
	      });
	    };
	
	    _this.getUserStats = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getUsersStats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            userStatsData: resp.data,
	            seconds: resp.data.user_time_value ? resp.data.user_time_value : parseInt(_this.props.params.timer),
	            isNegative: resp.data.isNegative
	          });
	        } else {
	          _this.setState({
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.changeQuestion = function (questionNumber, index) {
	      _this.slider.slickGoTo(index - 1);
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      if (questionNumber) {
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', questionNumber).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':offset', index).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart)
	        });
	      }
	    };
	
	    _this.getPrevious = function (index) {
	      _this.slider.slickGoTo(index - 2);
	      var questionsData = _this.state.questionsData;
	
	      _this.getUserStats();
	      _this.getFlagQuestions();
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.offset ? questionsData[parseInt(_this.props.params.offset) - 1].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':offset', _this.props.params.offset ? parseInt(_this.props.params.offset) - 1 : 1).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart)
	      });
	    };
	
	    _this.addHighlight = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(text) {
	        var storage_session, selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  type: 'highlight',
	                  text: text
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/addHighlightedText', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context3.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteHighlight = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  id: id
	                };
	
	                if (!id) {
	                  _context6.next = 7;
	                  break;
	                }
	
	                _context6.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/deleteHighlightedText', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(res) {
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            _this.setState({ showPopover: false });
	                            _context5.next = 3;
	                            return _this.getHighlightedText();
	
	                          case 3:
	                            (0, _highlightText.clearSelection)();
	
	                          case 4:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                _context6.next = 8;
	                break;
	
	              case 7:
	                return _context6.abrupt('return');
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.getHighlightedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getHighlightedText', data).then(function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(res) {
	          return _regenerator2.default.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  _this.setState({
	                    highlights: res.questions
	                  });
	
	                case 1:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this2);
	        }));
	
	        return function (_x6) {
	          return _ref7.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getNext = function (index) {
	      var questionsData = _this.state.questionsData;
	
	      _this.getFlagQuestions();
	      _this.getUserStats();
	      _this.slider.slickGoTo(index);
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.offset ? questionsData[parseInt(_this.props.params.offset) + 1].id : 1).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':offset', _this.props.params.offset ? parseInt(_this.props.params.offset) + 1 : 1).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', _this.props.params.timerStart)
	      });
	    };
	
	    _this.getMobileOperatingSystem = function () {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	      //console.log('userAgent', userAgent);
	      // Windows Phone must come first because its UA also contains "Android"
	      if (/windows phone/i.test(userAgent)) {
	        return 'Windows Phone';
	      }
	
	      if (/android/i.test(userAgent)) {
	        return 'Android';
	      }
	
	      // iOS detection from: http://stackoverflow.com/a/9039885/177710
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        return 'iOS';
	      }
	
	      return 'unknown';
	    };
	
	    _this.clickOption = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(choice, questionId, selectedQuestionData, e) {
	        var userData;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                //console.log('e. type ___________', e.type);
	                e.preventDefault();
	                // on left click
	                if (e.type === 'click') {
	                  //console.log('Left click');
	                  userData = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                    choice: choice,
	                    questionId: questionId,
	                    id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                    offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : null
	                  };
	
	                  _this.updateSelectedChoice(userData, selectedQuestionData, choice);
	                } else if (e.type === 'contextmenu') {
	                  //console.log('Right click');
	                  //on right click
	                  _this.addStrikeThrough(choice);
	                }
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7, _x8, _x9, _x10) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.addStrikeThrough = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(choice) {
	        var selectedQuestionData, data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                //console.log('inside call apiiiii', choice);
	                selectedQuestionData = _this.state.selectedQuestionData;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                  question_id: selectedQuestionData.id,
	                  test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                  choice: choice
	                };
	                _context10.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/addStrikeThrough', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(res) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            _context9.next = 2;
	                            return _this.getStrikedText();
	
	                          case 2:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x12) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }()
	                // clearSelection();
	                );
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x11) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.updateSelectedChoice = function (userData, selectedQuestionData, choice) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/updateUsersChoice', userData).then(function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(res) {
	          var ansData;
	          return _regenerator2.default.wrap(function _callee12$(_context12) {
	            while (1) {
	              switch (_context12.prev = _context12.next) {
	                case 0:
	                  if (res.success) {
	                    ansData = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	                      question_id: selectedQuestionData.id,
	                      answer: selectedQuestionData && selectedQuestionData.answer === choice ? 'correct' : 'incorrect',
	                      test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	                      reading_id: selectedQuestionData.chapter_id
	                    };
	
	                    _this.getUserStats();
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/updateUserAnswer', ansData).then(function () {
	                      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(res) {
	                        return _regenerator2.default.wrap(function _callee11$(_context11) {
	                          while (1) {
	                            switch (_context11.prev = _context11.next) {
	                              case 0:
	                              case 'end':
	                                return _context11.stop();
	                            }
	                          }
	                        }, _callee11, _this2);
	                      }));
	
	                      return function (_x14) {
	                        return _ref12.apply(this, arguments);
	                      };
	                    }());
	                  }
	
	                case 1:
	                case 'end':
	                  return _context12.stop();
	              }
	            }
	          }, _callee12, _this2);
	        }));
	
	        return function (_x13) {
	          return _ref11.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.submitTest = function () {
	      var questionsData = _this.state.questionsData;
	
	      _this.setState({
	        showFinishTestPopup: false
	      });
	      //api to update status of quiz
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null,
	        status: 'completed'
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/updateUserQuizStatus', data).then(function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(res) {
	          return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	              switch (_context13.prev = _context13.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context13.stop();
	              }
	            }
	          }, _callee13, _this2);
	        }));
	
	        return function (_x15) {
	          return _ref13.apply(this, arguments);
	        };
	      }());
	      var ansdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getrightAnswer', ansdata).then(function (resp_count) {
	        if (resp_count.success) {
	          var _data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	            score: resp_count.allrightanswercount.question_count,
	            id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/updateUserScore', _data);
	        } else {
	          //console.log(resp_count.success + '------------failure');
	        }
	      });
	      var _this$props$params = _this.props.params,
	          id = _this$props$params.id,
	          testid = _this$props$params.testid,
	          timer = _this$props$params.timer;
	
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH).replace(':id', id).replace(':testid', testid).replace(':questiono', questionsData.length && questionsData[0] && questionsData[0].id ? questionsData[0].id : 1).replace(':timer', timer).replace(':offset', 0)
	
	        // pathname: `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/${
	        //   questionsData.length && questionsData[0] && questionsData[0].id ? questionsData[0].id : 1
	        // }/${this.props.params.timer}/${this.props.params.testid}/0`,
	      });
	    };
	
	    _this.flagQuestion = function (data) {
	      var flag = _this.state.flag;
	
	      var flaggedQuestions = flag.filter(function (flag) {
	        return flag.question_id === data.id;
	      })[0];
	      var flagdata = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: data.id,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      if (flaggedQuestions) {
	        (0, _toast.showSuccess)('Question Unflagged');
	      } else {
	        (0, _toast.showSuccess)('Question Flagged');
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/flagQuestion', flagdata).then(function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(res) {
	          return _regenerator2.default.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  if (res) {
	                    _this.getFlagQuestions();
	                  }
	
	                case 1:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x16) {
	          return _ref14.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getFlagQuestions = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getflaggedQuestions', data).then(function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(res) {
	          return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	              switch (_context15.prev = _context15.next) {
	                case 0:
	                  if (res) {
	                    _this.setState({ flag: res.data });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context15.stop();
	              }
	            }
	          }, _callee15, _this2);
	        }));
	
	        return function (_x17) {
	          return _ref15.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.changeFilter = function (e, type) {
	      var target = e.target;
	      var checked = target.checked;
	      var filter = _this.state.filter;
	
	      if (checked) {
	        var temp = [].concat(_toConsumableArray(filter));
	        temp.push(type);
	        _this.setState({
	          filter: temp
	        });
	      } else {
	        // to uncheck elements
	        var prevArray = filter.filter(function (item) {
	          return item !== type;
	        });
	        _this.setState({
	          filter: prevArray
	        });
	      }
	    };
	
	    _this.finishTest = function () {
	      var _this$state = _this.state,
	          flag = _this$state.flag,
	          userStatsData = _this$state.userStatsData,
	          questionsData = _this$state.questionsData;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      if (flag && flag.length) {
	        _this.setState({
	          showFlaggedPopup: true
	        });
	      } else if (Object.keys(userChoice).length !== questionsData.length) {
	        _this.setState({
	          showNonAttemptedPopup: true
	        });
	      } else {
	        _this.setState({ showFinishTestPopup: true });
	      }
	    };
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	
	      if (timerStart === 'true') {
	        _this.setState({
	          timerStart: 'false'
	        });
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':offset', _this.props.params.offset).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', 'false')
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: 'true'
	        });
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', _this.props.params.questiono).replace(':timer', _this.props.params.timer).replace(':testid', _this.props.params.testid).replace(':offset', _this.props.params.offset).replace(':isNegative', _this.props.params.isNegative).replace(':timerStart', 'true')
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.addHighlightToText = function () {
	      var text = _this.getSelectionHtml();
	      _this.addHighlight(text);
	    };
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.state.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getStrikedText = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null,
	        question_id: _this.props.params.questiono ? parseInt(_this.props.params.questiono) : null,
	        test_id: _this.props.params.testid ? parseInt(_this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getStrikedText', data).then(function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(res) {
	          return _regenerator2.default.wrap(function _callee16$(_context16) {
	            while (1) {
	              switch (_context16.prev = _context16.next) {
	                case 0:
	                  if (res && res.questions) {
	                    _this.setState({
	                      strikeThroughArr: JSON.parse(res.questions.choiceArray)
	                    });
	                  } else {
	                    _this.setState({
	                      strikeThroughArr: []
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context16.stop();
	              }
	            }
	          }, _callee16, _this2);
	        }));
	
	        return function (_x18) {
	          return _ref16.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection != 'undefined') {
	        var sel = window.getSelection();
	        //console.log('heyyyyyyyyyyyyyyyy', sel);
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	            container.appendChild(sel.getRangeAt(i).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection != 'undefined') {
	        if (document.selection.type == 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.onTouchStart = function (e, choice) {
	      e.preventDefault();
	      // console.log(' window.navigator', window.navigator);
	      var data = _this.getMobileOperatingSystem();
	      //console.log('datadata', data);
	      if (data === 'Android') {
	        return;
	      } else {
	        _this.longPressCountdown = setTimeout(function () {
	          //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
	          _this.addStrikeThrough(choice);
	        }, longPressDuration);
	      }
	    };
	
	    _this.onTouchMove = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchCancel = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.onTouchEnd = function (e) {
	      clearTimeout(_this.longPressCountdown);
	    };
	
	    _this.state = {
	      questionsData: [],
	      isLoading: true,
	      isDataLoading: true,
	      token: '',
	      idname: '',
	      userStatsData: '',
	      time: {},
	      seconds: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      showFinishTestPopup: false,
	      mockName: '',
	      flag: [],
	      showSectionReview: false,
	      showAttempted: false,
	      showUnattempted: false,
	      showFlagged: false,
	      filter: [],
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      selectedQuestionData: [],
	      runDecrement: true,
	      isNegative: false,
	      timerStart: _this.props.params.timerStart,
	      selectedQuestion: '',
	      highlights: [],
	      showPopover: false,
	      strikeThroughArr: []
	    };
	    _this.longPressCountdown = null;
	    _this.timer = 0;
	    _this.countDown = _this.countDown.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(CFAQuestions, [{
	    key: 'countDown',
	    value: function countDown() {
	      var _this3 = this;
	
	      var runDecrement = this.state.runDecrement;
	
	      var seconds = void 0;
	      if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
	        seconds = this.state.seconds - 1;
	      } else {
	        seconds = this.state.seconds + 1;
	        this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', this.props.params.id).replace(':questiono', this.props.params.questiono).replace(':timer', this.props.params.timer).replace(':testid', this.props.params.testid).replace(':offset', this.props.params.offset).replace(':isNegative', 'false').replace(':timerStart', this.props.params.timerStart)
	        });
	        this.setState({
	          runDecrement: false
	        });
	      }
	      this.setState({
	        seconds: seconds
	      });
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        timer: seconds,
	        isNegative: this.props.params.isNegative,
	        id: this.props.params.testid ? parseInt(this.props.params.testid) : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/updateUserTimer', data).then(function () {
	        var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(res) {
	          return _regenerator2.default.wrap(function _callee17$(_context17) {
	            while (1) {
	              switch (_context17.prev = _context17.next) {
	                case 0:
	                  if (res.success) {}
	
	                case 1:
	                case 'end':
	                  return _context17.stop();
	              }
	            }
	          }, _callee17, _this3);
	        }));
	
	        return function (_x19) {
	          return _ref17.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	
	    // for IOS
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionsData = _state.questionsData,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          userStatsData = _state.userStatsData,
	          mockName = _state.mockName,
	          flag = _state.flag,
	          showSectionReview = _state.showSectionReview,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup,
	          filter = _state.filter,
	          selectedQuestionData = _state.selectedQuestionData,
	          isDataLoading = _state.isDataLoading,
	          seconds = _state.seconds,
	          timerStart = _state.timerStart,
	          highlights = _state.highlights,
	          strikeThroughArr = _state.strikeThroughArr;
	
	      var userChoice = userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
	      var formatTimeF = (0, _constant.SecondsToHHMMSS)(seconds);
	      var flaggedQuestion = flag.filter(function (flag) {
	        return flag.question_id === selectedQuestionData.id;
	      })[0];
	      var sliderSettings = (0, _cbtleftnavigationsettings.questionsettings)(this.props.params.offset ? parseInt(this.props.params.offset) : 1);
	      var content = selectedQuestionData.question;
	      if (highlights) {
	        highlights.forEach(function (element) {
	          content = (0, _highlightText.highlightString)(content, element.text);
	        });
	      }
	
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = content ? content.indexOf(highlighted) : null;
	      //console.log('text isss', text);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'finish-btn-wrapper' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { onClick: function onClick() {
	                    return _this4.finishTest();
	                  }, className: 'pointer_class btn-primary' },
	                _language2.default.LC().Finish_Test
	              )
	            )
	          ),
	          isLoading ? _react2.default.createElement(_loader2.default, null) : questionsData && questionsData.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'qus-tab-wrapper' },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  Object.assign({}, sliderSettings, {
	                    ref: function ref(slider) {
	                      _this4.slider = slider;
	                    }
	                  }),
	                  questionsData.map(function (item, index) {
	                    var flaggedQuestions = flag.filter(function (flag) {
	                      return flag.question_id === item.id;
	                    })[0];
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'slide-button', key: index },
	                      _react2.default.createElement(
	                        _reactstrap.Button,
	                        {
	                          onClick: function onClick() {
	                            return _this4.changeQuestion(item.id, index);
	                          },
	                          className: '\n                        ' + (index === parseInt(_this4.props.params.offset) ? 'active' : '') + '\n                        ' + (userChoice[item.id] ? 'completed-qus' : '') + '\n                        ' + (flaggedQuestions ? 'flag-add' : '') + '\n                        '
	                        },
	                        index + 1,
	                        flaggedQuestions ? _react2.default.createElement('img', {
	                          width: '70',
	                          src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                          alt: 'Question'
	                        }) : ''
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper col-md-12 question-wrapper' },
	                isDataLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-8 col-lg-9' },
	                        selectedQuestionData && selectedQuestionData.question ? _react2.default.createElement(
	                          'div',
	                          { className: 'qus-wrapper ques-bold-remove d-block all-ques' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                              className: 'margin_right_20',
	                              alt: '',
	                              width: '30'
	                            }),
	                            'Q.',
	                            parseInt(this.props.params.offset) + 1
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            {
	                              style: {
	                                position: 'relative',
	                                marginTop: '8px',
	                                maxWidth: '100%'
	                              }
	                            },
	                            _react2.default.createElement(
	                              'div',
	                              { 'data-selectable': true },
	                              (0, _function.renderHTMLContent)(content, "div", "qus-title d-inline-block w-100")
	                            ),
	                            _react2.default.createElement(
	                              _reactSelectionPopover2.default,
	                              {
	                                showPopover: this.state.showPopover,
	                                onSelect: function onSelect() {
	                                  _this4.setState({ showPopover: true });
	                                },
	                                onDeselect: function onDeselect() {
	                                  _this4.setState({ showPopover: false });
	                                }
	                              },
	                              getHighlightedText === -1 ? _react2.default.createElement(
	                                'div',
	                                { className: 'highlight-popover tooltip_wrap' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	                                  alt: '523',
	                                  width: '30',
	                                  onClick: function onClick() {
	                                    return _this4.addHighlightToText();
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  _language2.default.LC().Click_me_to_highlight
	                                )
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'highlight-popover tooltip_wrap' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	                                  alt: '523',
	                                  width: '30',
	                                  onClick: function onClick() {
	                                    return _this4.deleteHighlightFromText();
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  _language2.default.LC().Click_me_to_unhighlight
	                                )
	                              )
	                            )
	                          )
	                        ) : null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'row' },
	                          _constant.optionsArr.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'col-sm-12',
	                                id: item,
	                                key: index,
	                                onClick: function onClick(e) {
	                                  _this4.clickOption(item, selectedQuestionData && selectedQuestionData.id ? selectedQuestionData.id : null, selectedQuestionData, e);
	                                },
	                                onContextMenu: function onContextMenu(e) {
	                                  _this4.clickOption(item, selectedQuestionData && selectedQuestionData.id ? selectedQuestionData.id : null, selectedQuestionData, e);
	                                },
	                                onTouchStart: function onTouchStart(e) {
	                                  _this4.onTouchStart(e, item);
	                                },
	                                onTouchCancel: function onTouchCancel(e) {
	                                  _this4.onTouchCancel(e);
	                                },
	                                onTouchEnd: function onTouchEnd(e) {
	                                  _this4.onTouchEnd(e);
	                                },
	                                onTouchMove: function onTouchMove(e) {
	                                  _this4.onTouchMove(e);
	                                }
	                              },
	                              _react2.default.createElement(
	                                'div',
	                                {
	                                  className: 'answer_box ' + (userChoice[selectedQuestionData.id] === item ? 'border-yellow' : 'border-black')
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'answer_count highlight_choice no-selection ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	                                  },
	                                  item === 'choice_a' ? _language2.default.LC().A : item === 'choice_b' ? _language2.default.LC().B : _language2.default.LC().C
	                                ),
	                                _react2.default.createElement(
	                                  'p',
	                                  {
	                                    className: 'ans_box_text tooltip_wrap ' + (item === 'choice_a' ? strikeThroughArr.includes('choice_a') ? 'strikethrough' : '' : item === 'choice_b' ? strikeThroughArr.includes('choice_b') ? 'strikethrough' : '' : item === 'choice_c' ? strikeThroughArr.includes('choice_c') ? 'strikethrough' : '' : '')
	                                  },
	                                  selectedQuestionData && selectedQuestionData[item] ? (0, _function.renderHTMLContent)(selectedQuestionData[item], "span", "no-selection", { contentEditable: "false" }) : null
	                                )
	                              )
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-lg-3' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'timer_outer mb-15' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'h2',
	                              { className: 'time-left-heading' },
	                              _language2.default.LC().TIME_LEFT
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              {
	                                className: 'timer_box ' + (this.props.params.isNegative === 'false' ? 'blink' : null)
	                              },
	                              this.props.params.isNegative === 'false' ? '- ' + formatTimeF : formatTimeF
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            'aria-label': timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer',
	                            className: 'tooltip_wrap mb-2 hover-pad-same\n                                ' + (timerStart === 'true' ? 'icon-control-pause pause_btn' : 'pause_btn icon-control-play'),
	                            onClick: function onClick() {
	                              return _this4.stopTimer();
	                            }
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tootip_box', 'aria-hidden': 'true' },
	                            _language2.default.LC().Save_and_Take_Break
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            'aria-label': _language2.default.LC().SECTION_REVIEW,
	                            className: 'menu-btn tooltip-hover-questions',
	                            onClick: function onClick() {
	                              _this4.setState({
	                                showSectionReview: true
	                              });
	                            }
	                          },
	                          _react2.default.createElement('img', {
	                            width: '30px',
	                            src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	                            className: 'my-1',
	                            alt: ''
	                          }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tootip_box', 'aria-hidden': 'true' },
	                            _language2.default.LC().SECTION_REVIEW
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-9 mt-1' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center text-sm-right btm-btn-wrapper quiz-submit-block' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'up tooltip-hover-questions quiz-flag' },
	                            flaggedQuestion ? _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              _language2.default.LC().UNFLAG_THIS_QUESTION
	                            ) : _react2.default.createElement(
	                              'div',
	                              { className: 'tootip_box' },
	                              _language2.default.LC().FLAG_THIS_QUESTION
	                            ),
	                            _react2.default.createElement(
	                              'i',
	                              {
	                                onClick: function onClick() {
	                                  return _this4.flagQuestion(selectedQuestionData);
	                                },
	                                className: flaggedQuestion ? 'fa fa-flag mark-action-btn' : 'fa fa-flag-o mark-action-btn'
	                              },
	                              ' '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getPrevious(_this4.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _language2.default.LC().BACK
	                          ),
	                          _react2.default.createElement(
	                            _reactstrap.Button,
	                            {
	                              onClick: function onClick() {
	                                return _this4.getNext(_this4.props.params.offset);
	                              },
	                              className: 'pointer_class btn-primary',
	                              disabled: parseInt(this.props.params.offset) === questionsData.length - 1
	                            },
	                            _language2.default.LC().NEXT,
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'no-qus-found' },
	            _react2.default.createElement('img', { width: '105px', src: _App_data2.default.frontend_url + '/img/questions/problem.png', alt: '' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().NO_QUESTION_FOUND
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              _language2.default.LC().NO_QUESTION_FOR_THIS_EXAM
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-review' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _language2.default.LC().SECTION_REVIEW
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                'aria-label': 'Close section review',
	                className: 'section-review-close',
	                onClick: function onClick() {
	                  _this4.setState({
	                    showSectionReview: false
	                  });
	                }
	              },
	              _react2.default.createElement('img', { width: '30px', src: _App_data2.default.frontend_url + '/img/questions/icon_close.png', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-review' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _language2.default.LC().FILTER_BY,
	              ':'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'filt-list-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: function onClick() {
	                    _this4.setState({
	                      filter: []
	                    });
	                  }
	                },
	                _language2.default.LC().CLEAR
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _constant.filterObj.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { className: 'plan_wrapper remove-plan', key: index },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        value: item,
	                        id: item,
	                        checked: filter.indexOf(item) > -1 ? true : false,
	                        onChange: function onChange(e) {
	                          return _this4.changeFilter(e, item);
	                        }
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' }),
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qus-tab-wrapper' },
	              questionsData.map(function (item, index) {
	                var flaggedQuestions = flag.filter(function (flag) {
	                  return flag.question_id === item.id;
	                })[0];
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  filter.includes('Attempted') && filter.includes('Unattempted') && filter.includes('Flagged') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : filter.includes('Attempted') && filter.includes('Unattempted') ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'completed-qus' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : filter.includes('Unattempted') && filter.includes('Flagged') ? !userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : ///
	                  filter.includes('Attempted') && filter.includes('Flagged') ? userChoice[item.id] && flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  ) : '' : filter.includes('Attempted') ? userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'completed-qus',
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Unattempted') ? !userChoice[item.id] ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1
	                  ) : '' : filter.includes('Flagged') ? flaggedQuestions ? _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: '' + (userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    })
	                  ) : '' : _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: (userChoice[item.id] ? 'completed-qus' : '') + ' ' + (flaggedQuestions ? 'flag-add' : ''),
	                      onClick: function onClick() {
	                        _this4.setState({
	                          showSectionReview: false
	                        });
	                        _this4.changeQuestion(item.id, index);
	                      }
	                    },
	                    index + 1,
	                    flaggedQuestions ? _react2.default.createElement('img', {
	                      width: '70',
	                      src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                      alt: 'Question'
	                    }) : ''
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_CBTFinishTest2.default, {
	          showFinishTestPopup: showFinishTestPopup,
	          submitTest: function submitTest() {
	            return _this4.submitTest();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFinishTestPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTNonAttempted2.default, {
	          showFinishTestPopup: showNonAttemptedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFinishTestPopup: true,
	              showNonAttemptedPopup: false
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showNonAttemptedPopup: false });
	          }
	        }),
	        _react2.default.createElement(_CBTFlagged2.default, {
	          showFinishTestPopup: showFlaggedPopup,
	          submitTest: function submitTest() {
	            return _this4.setState({
	              showFlaggedPopup: false,
	              showFinishTestPopup: true
	            });
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showFlaggedPopup: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CFAQuestions;
	}(_react.Component);
	
	CFAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CFAQuestions;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _constant = __webpack_require__(9);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CFACBTResult = function (_Component) {
	  _inherits(CFACBTResult, _Component);
	
	  //
	  function CFACBTResult(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CFACBTResult);
	
	    var _this = _possibleConstructorReturn(this, (CFACBTResult.__proto__ || Object.getPrototypeOf(CFACBTResult)).call(this, props));
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({ activeTabFlashcards: tab });
	      }
	    };
	
	    _this.getGraphoverAllGraphData = function (data) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCBTMockUserGraph', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.graphData) {
	                    _this.setState({
	                      isLoading: false,
	                      totalQuestions: _this.props.params.totalQuestions,
	                      average: res.graphData ? res.graphData.averageScore : _this.state.average
	                    });
	                    _this.formatoverAllGraphData(res);
	                  } else {
	                    _this.setState({ isLoading: false });
	                    (0, _toast.showFailure)(res.message);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.getGraphData = function (data) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCBTMockUserGraphChapterWise', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  _this.setState({
	                    isLoading: false,
	                    totalQuestionsChapterwise: _this.props.params.totalQuestions,
	                    exam_name: res.graphData,
	                    averageoverAll: res.graphData
	                  });
	                  _this.formatData(res);
	
	                case 2:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatoverAllGraphData = function (res) {
	      var graphData = res.graphData;
	
	
	      _this.setState({
	        dataOfCurrentUser: graphData ? graphData.dataOfCurrentUser.score : _this.state.dataOfCurrentUser,
	        dataOfEightyPercentileUser: graphData ? graphData.dataOfEightyPercentileUser.score : _this.state.dataOfEightyPercentileUser,
	        dataOfTwentyPercentileUser: graphData ? graphData.dataOfTwentyPercentileUser.score : _this.state.dataOfTwentyPercentileUser
	      });
	      var totalQuestions = _this.state.totalQuestions;
	
	      var temp = [graphData];
	      graphData = temp;
	
	      // Reference line for 70%
	      var referenceLine = {
	        type: 'line',
	        color: '#fff',
	        dataPoints: [{
	          x: -15,
	
	          y: 100
	        }, {
	          x: 20,
	
	          y: 100
	        }, {
	          x: 20,
	
	          y: 100
	        }],
	        markerType: 'none'
	      };
	      // 20% line
	      var dataOfTwentyOverAllGraph = {
	        showInLegend: false,
	        name: '20%',
	
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line
	      var dataOfEightyOverAllGraph = {
	        showInLegend: false,
	
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //User score line
	      var UserScoreOverAllGraph = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User score box
	
	      var scorePercentage = graphData[0].dataOfCurrentUser.score == null ? 0 : Math.ceil(graphData[0].dataOfCurrentUser.score / totalQuestions * 100);
	
	      var UserScoreBoxOverAllGraph2 = {
	        type: 'rangeColumn',
	
	        color: 'hsl(200deg 67% 88%)',
	        dataPoints: []
	      };
	
	      UserScoreBoxOverAllGraph2.dataPoints.push({
	        x: 1.39,
	
	        y: [scorePercentage - 5, scorePercentage + 5]
	      });
	
	      var dataOfCurrentUserLineStart = {
	        x: -0.2,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineMid = {
	        x: 2.8,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineEnd = {
	        x: 2.8,
	        y: null
	      };
	
	      UserScoreOverAllGraph.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	
	      var dataOfTwentyPercentileUserlineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfTwentyPercentileUserlineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfTwentyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfTwentyPercentileUserlineEnd = {
	        x: 7,
	        y: null
	      };
	      dataOfTwentyOverAllGraph.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	      var dataOfEightyPercentileUserLineStart = {
	        x: -3,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	      };
	      var dataOfEightyPercentileUserLineMid = {
	        x: 7,
	
	        y: graphData[0].dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData[0].dataOfEightyPercentileUser.score / totalQuestions * 100)
	      };
	
	      var dataOfEightyPercentileUserLineEnd = {
	        x: 7,
	        y: null
	      };
	      dataOfEightyOverAllGraph.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	      var overAllGraphData = [];
	      overAllGraphData.push(UserScoreBoxOverAllGraph2, dataOfTwentyOverAllGraph, dataOfEightyOverAllGraph, UserScoreOverAllGraph, referenceLine);
	
	      _this.setState({ dataPointsOverAllGraph: overAllGraphData }, function () {
	        _this.showGraphOverAll(); //Show overall graph
	      });
	    };
	
	    _this.showGraphOverAll = function () {
	      var dataPointsOverAllGraph = _this.state.dataPointsOverAllGraph;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: _constant.canvasjsConfig.axisX,
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        dataPointWidth: 90,
	        dataPointMaxWidth: 80,
	        dataPointMinWidth: 80,
	        legend: { fontSize: 18 },
	        data: dataPointsOverAllGraph,
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.formatData = function (res) {
	      var graphData = res.graphData;
	
	
	      var initialValue = 0;
	      // Reference line for 70%
	      var referenceLine = {
	        type: 'line',
	        color: '#fff',
	        dataPoints: [{
	          x: 0,
	
	          y: 110
	        }, {
	          x: 20,
	
	          y: 110
	        }, {
	          x: 20,
	
	          y: 110
	        }],
	        markerType: 'none'
	      };
	      //20% line chaptervise graph
	      var dataOfTwenty = {
	        showInLegend: false,
	
	        name: '20%',
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line chaptervise graph
	      var dataOfEighty = {
	        showInLegend: false,
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //Userscore line chaptervise graph
	      var UserScore = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User Score Box chaptervise graph
	      // let UserScoreBox = {
	      //   type: 'rangeColumn',
	      //   color: '#cce7f5',
	      //   dataPoints: [],
	      // };
	      // initialValue = -10;
	      // for (let k = 0; k < graphData.length; k++) {
	      //   UserScoreBox.dataPoints.push({
	      //     x: initialValue + 15,
	
	      //     y: [
	      //       graphData[k].dataOfCurrentUser.Percentage - 10,
	      //       graphData[k].dataOfCurrentUser.Percentage + 10,
	      //     ],
	      //   });
	      //   initialValue += 15;
	      // }
	      var UserScoreBox2 = {
	        showInLegend: false,
	        // legendMarkerType: 'square',
	        name: '' + _language2.default.LC().GRAPHSCOREBOX,
	        type: 'rangeColumn',
	        color: '#cce7f5',
	        dataPoints: []
	      };
	      initialValue = -10;
	      for (var k = 0; k < graphData.length; k++) {
	        var scoreBoxSize = _this.state.scoreBoxSize;
	
	        UserScoreBox2.dataPoints.push({
	          x: initialValue + 15,
	          label: '' + graphData[k].chapterDetails['chapter.chapter_name'],
	          y: [graphData[k].dataOfCurrentUser.Percentage - scoreBoxSize, graphData[k].dataOfCurrentUser.Percentage + scoreBoxSize]
	        });
	        var dataOfCurrentUserLineStart = {
	          x: initialValue + 15 - 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineMid = {
	          x: initialValue + 15 + 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineEnd = {
	          x: initialValue + 15 + 1.5,
	          y: null
	        };
	        UserScore.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	        initialValue += 15;
	      }
	      initialValue = 0;
	      for (var i = 0; i < graphData.length; i++) {
	        var dataOfTwentyPercentileUserlineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineEnd = {
	          x: initialValue + 10,
	
	          y: null
	        };
	        dataOfTwenty.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	        var dataOfEightyPercentileUserLineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineEnd = {
	          x: initialValue + 10,
	          y: null
	        };
	        dataOfEighty.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	
	        initialValue += 15;
	      }
	      var data = [];
	      data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, referenceLine);
	
	      _this.setState({ dataPoints: data }, function () {
	        _this.showGraph(); //Show chaptervise graph
	      });
	    };
	
	    _this.showGraph = function () {
	      var dataPoints = _this.state.dataPoints;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainer', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: Object.assign({}, _constant.canvasjsConfig.axisX, {
	          labelAngle: _this.state.labelAngle,
	          labelFontSize: _this.state.labelFontSize
	        }),
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        data: dataPoints,
	
	        dataPointWidth: 60,
	        dataPointMaxWidth: 60,
	        dataPointMinWidth: 60,
	        legend: { fontSize: 18 },
	        interactivityEnabled: false
	      });
	
	      chart.render();
	    };
	
	    _this.state = {
	      token: '',
	      idname: '',
	      activeTabFlashcards: 1,
	      dataPointsOverAllGraph: [],
	      dataPoints: [],
	      totalQuestions: 0,
	      isLoading: true,
	      labelAngle: 0,
	      labelFontSize: 15,
	      scoreBoxSize: 5,
	      exam_name: '',
	      totalQuestionsChapterwise: 0,
	      dataOfCurrentUser: '',
	      dataOfEightyPercentileUser: '',
	      dataOfTwentyPercentileUser: '',
	      average: ''
	    };
	    return _this;
	  }
	
	  _createClass(CFACBTResult, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var w = window.innerWidth;
	      // const h = window.innerHeight;
	      if (w > 1200) {
	        this.setState({
	          labelAngle: 0,
	          labelFontSize: 15
	        });
	      } else if (w > 991 && w < 1200) {
	        this.setState({
	          labelAngle: -20,
	          labelFontSize: 12
	        });
	      } else if (w > 767 && w < 991) {
	        this.setState({
	          labelAngle: 90,
	          labelFontSize: 15
	        });
	      } else {
	        this.setState({
	          labelAngle: -90,
	          labelFontSize: 12
	        });
	      }
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        // eslint-disable-next-line
	        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
	        test_id: this.props.params.test_id // eslint-disable-next-line
	        ? parseInt(this.props.params.test_id) : null,
	        totalQuestion: this.props.params.totalQuestions // eslint-disable-next-line
	        ? parseInt(this.props.params.totalQuestions) : null,
	        // eslint-disable-next-line
	        timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0
	      };
	
	      this.getGraphData(data);
	      this.getGraphoverAllGraphData(data);
	    }
	    // get data for overall graph
	    // myResize = () => {
	
	    //   }
	
	    // get data for chaptervise graph
	
	    //format data as requirement for overall graph
	
	    //Show overall graph
	
	    //Format data as requirement
	
	
	    // show graph chaptervise graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          dataOfCurrentUser = _state.dataOfCurrentUser,
	          dataOfEightyPercentileUser = _state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser = _state.dataOfTwentyPercentileUser,
	          totalQuestions = _state.totalQuestions,
	          activeTabFlashcards = _state.activeTabFlashcards,
	          average = _state.average,
	          exam_name = _state.exam_name;
	      var isLoading = this.state.isLoading;
	
	
	      return !isLoading ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'chart-graph-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().OVERALLRESULT
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              ' ',
	              _react2.default.createElement('div', { id: 'chartContainerOverAllGraph', className: 'js-chart-wrap' }),
	              _react2.default.createElement(
	                'ul',
	                { className: 'legend-wrapper' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'square-box' }),
	                  ' ',
	                  _language2.default.LC().SCOREBOX
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dash' }),
	                  ' ',
	                  _language2.default.LC().Percentile_20
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-dots' }),
	                  ' ',
	                  _language2.default.LC().Percentile_80
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('span', { className: 'line-normal' }),
	                  ' ',
	                  _language2.default.LC().YOURSCORE
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6' },
	              _react2.default.createElement(
	                'div',
	                { className: ' graphData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfTwentyPercentileUser ? Math.ceil(dataOfTwentyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_20
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfEightyPercentileUser ? Math.ceil(dataOfEightyPercentileUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                    ' ',
	                    _language2.default.LC().Percentile_80
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(dataOfCurrentUser / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'score-box' }),
	                    ' ',
	                    '' + _language2.default.LC().YOURSCORE
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScoreData' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphScore' },
	                    (dataOfCurrentUser ? Math.ceil(average / totalQuestions * 100) : 0) + '%'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'graphLabel' },
	                    _react2.default.createElement('span', { className: 'average-box' }),
	                    ' ',
	                    _language2.default.LC().AVERAGE_SCORE
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: ' chart-graph-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'overAllScore' },
	            '' + _language2.default.LC().CFACHAPTERWISERESULT
	          ),
	          _react2.default.createElement('div', { id: 'chartContainer', className: 'js-chart-wrap' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'legend-wrapper' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'square-box' }),
	              ' ',
	              _language2.default.LC().SCOREBOX
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dash' }),
	              ' ',
	              _language2.default.LC().Percentile_20
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-dots' }),
	              ' ',
	              _language2.default.LC().Percentile_80
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('span', { className: 'line-normal' }),
	              _language2.default.LC().YOURSCORE
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-5' },
	            'Mean Score by Topic Area'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex header-card-dashboard tab-header-wrap mt-2' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'dashboard-card-header-tab' },
	              exam_name ? exam_name.map(function (exam, index) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    onClick: function onClick() {
	                      _this3.flashcardTabToggle(index + 1);
	                    },
	                    className: activeTabFlashcards === index + 1 ? 'active' : ''
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    exam.chapterDetails['chapter.chapter_name'].length > 20 ? exam.chapterDetails['chapter.chapter_name'].substring(0, 20) + '...' : exam.chapterDetails['chapter.chapter_name']
	                  )
	                );
	              }) : null
	            )
	          ),
	          exam_name ? exam_name.map(function (exam, index) {
	            var x = void 0;
	
	            x = _this3.state.activeTabFlashcards === index + 1 ? _react2.default.createElement(
	              'div',
	              { className: 'card tab-body-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block dashboard-cards-scroll my-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'chart-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' graphData' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfTwentyPercentileUser ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_20
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfEightyPercentileUser ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                        ' ',
	                        _language2.default.LC().Percentile_80
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam.dataOfCurrentUser ? Math.ceil(exam.dataOfCurrentUser.Percentage) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'score-box' }),
	                        ' ',
	                        '' + _language2.default.LC().YOURSCORE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'graphScoreData' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphScore' },
	                        (exam && exam.chapterDetails && exam.chapterDetails.totalQuestions ? Math.ceil(exam.averageScore / exam.chapterDetails.totalQuestions * 100) : 0) + '%'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'graphLabel' },
	                        _react2.default.createElement('span', { className: 'average-box' }),
	                        ' ',
	                        _language2.default.LC().AVERAGE_SCORE
	                      )
	                    )
	                  )
	                )
	              )
	            ) : null;
	
	            return x;
	          }) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-2 text-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().DataDetail
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { id: 'chartContainer' },
	        _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return CFACBTResult;
	}(_react.Component);
	
	exports.default = CFACBTResult;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa1Subscription = __webpack_require__(142);
	
	var _Cfa1Subscription2 = _interopRequireDefault(_Cfa1Subscription);
	
	var _Cfa1Subscription3 = __webpack_require__(143);
	
	var _Cfa1Subscription4 = _interopRequireDefault(_Cfa1Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var CBTMockExams = function (_Component) {
	  _inherits(CBTMockExams, _Component);
	
	  function CBTMockExams(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTMockExams);
	
	    var _this = _possibleConstructorReturn(this, (CBTMockExams.__proto__ || Object.getPrototypeOf(CBTMockExams)).call(this, props));
	
	    _this.getQuestions = function () {
	      _this.setState({
	        showInstructionModal: false,
	        isLoading: true
	      });
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.setState({
	              isLoading: false
	            });
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            // console.log(
	            //   'resp.profileInfo.subscription_details',
	            //   resp.profileInfo.subscription_details
	            // );
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, mockPackageAccess;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        mockPackageAccess = resp_exam.hasMockSubscription;
	                        _context.next = 7;
	                        return _Cfa1Subscription4.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 7:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var || mockPackageAccess) {
	                          _this._runCode('paid');
	                        } else {
	                          _this.setState({
	                            isLoading: false
	                          });
	                          _this.toggleAlert();
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.setState({
	              isLoading: false
	            });
	            _this.toggleAlert();
	          } else {
	            // console.log('in paid');
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa1Subscription2.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                // console.log('outside isInArray_var heeee', isInArray_var);
	                if (isInArray_var) {
	                  // console.log('inside isInArray_var ', isInArray_var);
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.setState({
	                    isLoading: false
	                  });
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._runCode = function (subscriptionstatus) {
	      _this.setState({
	        isLoading: false
	      });
	      if (subscriptionstatus === 'paid') {
	        _this.context.router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_INTRODUCTION).replace(':id', _this.props.params.id).replace(':questiono', 1).replace(':timer', _this.props.params.timer)
	        });
	      }
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.startExam = function () {
	      _this.setState({
	        showInstructionModal: true
	        // mockData: mock,
	      });
	    };
	
	    _this.backToMock = function () {
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT)
	      });
	    };
	
	    _this.deleteTest = function (id) {
	      var deletepopup = _this.state.deletepopup;
	
	      if (!deletepopup) {
	        _this.setState({
	          deleteId: id,
	          deletepopup: true
	        });
	      } else {
	        _this.setState({
	          deleteId: '',
	          deletepopup: false
	        });
	      }
	    };
	
	    _this.view = function (item) {
	      // '/cfa1_2024/cbtquestionsfinish/:id/:questiono/:timer/:testid/:offset',
	      var _this$props$params = _this.props.params,
	          id = _this$props$params.id,
	          timer = _this$props$params.timer;
	
	      _this.context.router.push({
	        // pathname: `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/1/${
	        //   this.props.params.timer
	        // }/${item.id}/0`,
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH).replace(':id', id).replace(':questiono', 1).replace(':timer', timer).replace(':testid', item.id).replace(':offset', 0)
	      });
	    };
	
	    _this.deleteToggleDone = function () {
	      var deleteId = _this.state.deleteId;
	
	      var deleteData = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: deleteId
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/deleteMock', deleteData).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var data;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _this.setState({
	                    deleteId: '',
	                    mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
	                    deletepopup: false
	                  });
	
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : ''
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getAllUsersStats', data).then(function (resp) {
	                    if (resp.success) {
	                      _this.setState({
	                        ValidToken: true,
	                        mockList: resp.data,
	                        isLoading: false
	                        // userStatsData: resp.data,
	                      });
	                    } else {
	                      _this.setState({ ValidToken: false, isLoading: false });
	                    }
	                    return resp;
	                  });
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              _this.setState({
	                                mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                              });
	
	                            case 1:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	
	                case 4:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.resumeTest = function (item) {
	      // console.log('item', item);
	      if (item.questions) {
	        var questionsData = JSON.parse(item.lastAnswered);
	        if (questionsData) {
	          _this.context.router.push({
	            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', questionsData.questionId).replace(':timer', item.user_time_value).replace(':testid', item.id).replace(':offset', questionsData.offset).replace(':isNegative', 'true').replace(':timerStart', 'true')
	          });
	        }
	      } else {
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          mock_id: _this.props.params.id ? parseInt(_this.props.params.id) : null
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(function (resp) {
	          if (resp.success) {
	            _this.context.router.push({
	              pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2024_CBT_QUESTIONS).replace(':id', _this.props.params.id).replace(':questiono', resp.question && resp.question.length ? resp.question[0].id : 1).replace(':timer', item.user_time_value).replace(':testid', item.id).replace(':offset', 0).replace(':isNegative', 'true').replace(':timerStart', 'true')
	            });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      mockList: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      isLoading: true,
	      mockData: '',
	      userStatsData: '',
	      mockName: '',
	      deletepopup: false,
	      deleteId: '',
	      questionsLength: 90
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBTMockExams, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  mock_id: this.props.params.id ? parseInt(this.props.params.id) : ''
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getAllUsersStats', data).then(function (resp) {
	                  if (resp.success) {
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(function (resp) {
	                      if (resp && resp.question) {
	                        _this3.setState({
	                          questionsLength: resp.question.length
	                        });
	                      }
	                    });
	                    _this3.setState({
	                      ValidToken: true,
	                      mockList: resp.data,
	                      isLoading: false
	                      // userStatsData: resp.data,
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false, isLoading: false });
	                  }
	                  return resp;
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(res) {
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            _this3.setState({
	                              mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : ''
	                            });
	
	                          case 1:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          showInstructionModal = _state.showInstructionModal,
	          mockName = _state.mockName,
	          deletepopup = _state.deletepopup,
	          questionsLength = _state.questionsLength;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 ques-title-wrapper rem-left-pad' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              mockName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'two-btn-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.startExam();
	                  }
	                },
	                _language2.default.LC().START
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class mid-btn',
	                  onClick: function onClick() {
	                    return _this4.backToMock();
	                  }
	                },
	                _language2.default.LC().CHANGE_MOCK
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            { isOpen: deletepopup, toggle: this.deleteTest, className: 'modal-primary' },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteTest },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table table-remove-space' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '9%' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TOTAL_SCORE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().DATE
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().TEST_COMPLETED_IN
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().STATUS
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { className: 'text-center' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        isLoading ? _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(_loader2.default, null)
	                        ) : mockList.length ? mockList.map(function (item, index) {
	                          var time = 0;
	                          if (item.isNegative === 'true') {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(_this4.props.params.timer) - item.user_time_value);
	                          } else {
	                            time = (0, _constant.SecondsToHHMMSS)(parseInt(_this4.props.params.timer) + item.user_time_value);
	                          }
	                          return _react2.default.createElement(
	                            'tr',
	                            { key: index },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.id
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'score-qnt' },
	                              item.score && questionsLength ? Math.ceil(item.score / questionsLength * 100) + '%' : '0%'
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              item.createdAt ? (0, _moment2.default)(item.createdAt).format('ll') : ''
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'clr-green' },
	                              time
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize mock-status' },
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status not-attempted' },
	                                _language2.default.LC().Incomplete
	                              ) : _react2.default.createElement(
	                                'div',
	                                { className: 'mock-status' },
	                                item.status
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center' },
	                              item.status === 'completed' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().VIEW,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      return _this4.view(item);
	                                    },
	                                    className: 'fa fa-eye mark-action-btn-dashboard',
	                                    style: { color: '#1f8ceb' }
	                                  },
	                                  ' '
	                                )
	                              ) : null,
	                              item.status === 'pending' ? _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().RESUME
	                                ),
	                                _react2.default.createElement('i', {
	                                  className: 'fa fa-play-circle-o mark-action-btn-dashboard',
	                                  'aria-hidden': 'true',
	                                  style: { color: '#000' },
	                                  onClick: function onClick() {
	                                    _this4.resumeTest(item);
	                                  }
	                                })
	                              ) : null,
	                              _react2.default.createElement(
	                                'span',
	                                {
	                                  className: 'up tooltip-hover-questions',
	                                  style: { padding: '0 6px' }
	                                },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tootip_box' },
	                                  ' ',
	                                  _language2.default.LC().DELETE,
	                                  ' '
	                                ),
	                                _react2.default.createElement(
	                                  'i',
	                                  {
	                                    onClick: function onClick() {
	                                      _this4.deleteTest(item.id);
	                                    },
	                                    className: 'fa fa-trash mark-action-btn-dashboard',
	                                    style: { color: '#f51a00' }
	                                  },
	                                  ' '
	                                )
	                              )
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { colSpan: '5', className: 'no-mocks' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'no-qus-found no-mock-exam' },
	                              _react2.default.createElement('img', {
	                                width: '82px',
	                                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	                              }),
	                              _react2.default.createElement(
	                                'h3',
	                                { className: 'mt-1' },
	                                _language2.default.LC().NO_MOCK_EXAM_FOUND
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_CBTInstructions2.default, {
	          showInstructionModal: showInstructionModal,
	          getQuestions: function getQuestions() {
	            return _this4.getQuestions();
	          },
	          handleClose: function handleClose() {
	            return _this4.setState({ showInstructionModal: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return CBTMockExams;
	}(_react.Component);
	
	CBTMockExams.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = CBTMockExams;

/***/ },
/* 593 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  // Edition-stable flat keys emitted by the backend for all CFA1 years (see services/CFA/dashboard.js).
	  performanceGraphUserAttemptedCountKey: 'userAttemptCount',
	  performanceGraphUserAnsweredCountKey: 'userAnswerCount',
	  chapterNameKey: 'chapter_name',
	  attemptedCountKey: 'attempted_count',
	  answeredCountKey: 'answered_count',
	  questionTableNameKey: 'questions',
	  questionStatsTableNameKey: 'cfa1_2024_question_stats',
	  notesTableNameKey: 'cfa1_2025_notes',
	  notesStatsTableNameKey: 'cfa1_2024_notes_stats'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getUserPerformanceBarGraph = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/user-bar-graph', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getUserPerformanceBarGraph(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var getTotalUsersPerformanceBarGraph = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/all-user-bar-graph', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function getTotalUsersPerformanceBarGraph() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var sendFurtherHelpRequest = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function sendFurtherHelpRequest() {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var fetchQuestionProgressBar = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/question-progress-bar', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function fetchQuestionProgressBar() {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var fetchNotesProgressBar = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/notes-progress-bar', data);
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function fetchNotesProgressBar() {
	    return _ref5.apply(this, arguments);
	  };
	}();
	//* QUESTION SAVE AND REPORT STARTED HERE
	var fetchSavedQuestion = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/saved-question', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var fetchReportedQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/reported-question', data);
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function fetchReportedQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	var deleteReportedQuestion = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'report',
	              itemType: 'Question'
	            });
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function deleteReportedQuestion(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	var updateReportedQuestion = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/edit-reports', {
	              id: data.id,
	              comment: data.comment,
	              itemType: 'Question'
	            });
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function updateReportedQuestion(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var deleteSavedQuestion = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            _context10.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'save',
	              itemType: 'Question'
	            });
	
	          case 2:
	            return _context10.abrupt('return', _context10.sent);
	
	          case 3:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	//* NOTES SAVE AND REPORT STARTED HERE
	var fetchSavedNotes = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(data) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/saved-notes', data);
	
	          case 2:
	            return _context11.abrupt('return', _context11.sent);
	
	          case 3:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, undefined);
	  }));
	
	  return function fetchSavedNotes(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	var fetchReportedNotes = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/reported-notes', data);
	
	          case 2:
	            return _context12.abrupt('return', _context12.sent);
	
	          case 3:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, undefined);
	  }));
	
	  return function fetchReportedNotes(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	var deleteSavedNotes = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(data) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'save',
	              itemType: 'Notes'
	            });
	
	          case 2:
	            return _context13.abrupt('return', _context13.sent);
	
	          case 3:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, undefined);
	  }));
	
	  return function deleteSavedNotes(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	var deleteReportedNotes = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(data) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            _context14.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'report',
	              itemType: 'Notes'
	            });
	
	          case 2:
	            return _context14.abrupt('return', _context14.sent);
	
	          case 3:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, undefined);
	  }));
	
	  return function deleteReportedNotes(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	var updateReportedNotes = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(data) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            _context15.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/edit-reports', {
	              id: data.id,
	              comment: data.comment,
	              itemType: 'Notes'
	            });
	
	          case 2:
	            return _context15.abrupt('return', _context15.sent);
	
	          case 3:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, undefined);
	  }));
	
	  return function updateReportedNotes(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	//* VIDEOS SAVE AND REPORT STARTED HERE
	var fetchSavedVideos = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(data) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            _context16.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/saved-videos', data);
	
	          case 2:
	            return _context16.abrupt('return', _context16.sent);
	
	          case 3:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, undefined);
	  }));
	
	  return function fetchSavedVideos(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	var fetchReportedVideos = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(data) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            _context17.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/reported-videos', data);
	
	          case 2:
	            return _context17.abrupt('return', _context17.sent);
	
	          case 3:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, undefined);
	  }));
	
	  return function fetchReportedVideos(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	var deleteSavedVideo = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(data) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            _context18.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'save',
	              itemType: 'Video'
	            });
	
	          case 2:
	            return _context18.abrupt('return', _context18.sent);
	
	          case 3:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, undefined);
	  }));
	
	  return function deleteSavedVideo(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	var deleteReportedVideo = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(data) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            _context19.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'report',
	              itemType: 'Video'
	            });
	
	          case 2:
	            return _context19.abrupt('return', _context19.sent);
	
	          case 3:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, undefined);
	  }));
	
	  return function deleteReportedVideo(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	var updateReportedVideo = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(data) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            _context20.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/edit-reports', {
	              id: data.id,
	              comment: data.comment,
	              itemType: 'Video'
	            });
	
	          case 2:
	            return _context20.abrupt('return', _context20.sent);
	
	          case 3:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, undefined);
	  }));
	
	  return function updateReportedVideo(_x20) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	var redirectToQuestion = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(data) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            _context21.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/redirect-question', data);
	
	          case 2:
	            return _context21.abrupt('return', _context21.sent);
	
	          case 3:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, undefined);
	  }));
	
	  return function redirectToQuestion(_x21) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	var redirectToCbtQuestion = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(data) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            _context22.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/redirect-mocks', data);
	
	          case 2:
	            return _context22.abrupt('return', _context22.sent);
	
	          case 3:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, undefined);
	  }));
	
	  return function redirectToCbtQuestion(_x22) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	var redirectToNotes = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(data) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            _context23.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/redirect-notes', data);
	
	          case 2:
	            return _context23.abrupt('return', _context23.sent);
	
	          case 3:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, undefined);
	  }));
	
	  return function redirectToNotes(_x23) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	var redirectToVideos = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(data) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            _context24.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/redirect-videos', data);
	
	          case 2:
	            return _context24.abrupt('return', _context24.sent);
	
	          case 3:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, undefined);
	  }));
	
	  return function redirectToVideos(_x24) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	//* CBT SAVE AND REPORT STARTED HERE
	var fetchCBTReportedQuestion = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(data) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            _context25.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/reported-mocks', data);
	
	          case 2:
	            return _context25.abrupt('return', _context25.sent);
	
	          case 3:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, undefined);
	  }));
	
	  return function fetchCBTReportedQuestion(_x25) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	// redirectToCBTQuestion
	var deleteCBTReportedQuestion = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(data) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            _context26.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/tab-items', {
	              id: data.id,
	              type: 'reportCBT',
	              itemType: 'Question'
	            });
	
	          case 2:
	            return _context26.abrupt('return', _context26.sent);
	
	          case 3:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, undefined);
	  }));
	
	  return function deleteCBTReportedQuestion(_x26) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	var updateReportedCBTQuestion = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(data) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            _context27.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/dashboard/edit-reports', {
	              id: data.id,
	              comment: data.comment,
	              itemType: 'CBTQuestion'
	            });
	
	          case 2:
	            return _context27.abrupt('return', _context27.sent);
	
	          case 3:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, undefined);
	  }));
	
	  return function updateReportedCBTQuestion(_x27) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	var deleteFlashCard = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(data) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            _context28.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', data);
	
	          case 2:
	            return _context28.abrupt('return', _context28.sent);
	
	          case 3:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, undefined);
	  }));
	
	  return function deleteFlashCard(_x28) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	module.exports = {
	  getUserPerformanceBarGraph: getUserPerformanceBarGraph,
	  getTotalUsersPerformanceBarGraph: getTotalUsersPerformanceBarGraph,
	  fetchQuestionProgressBar: fetchQuestionProgressBar,
	  fetchNotesProgressBar: fetchNotesProgressBar,
	  fetchSavedQuestion: fetchSavedQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  deleteFlashCard: deleteFlashCard,
	  fetchReportedQuestion: fetchReportedQuestion,
	  deleteReportedQuestion: deleteReportedQuestion,
	  updateReportedQuestion: updateReportedQuestion,
	  fetchSavedNotes: fetchSavedNotes,
	  fetchReportedNotes: fetchReportedNotes,
	  deleteSavedNotes: deleteSavedNotes,
	  deleteReportedNotes: deleteReportedNotes,
	  updateReportedNotes: updateReportedNotes,
	  fetchSavedVideos: fetchSavedVideos,
	  fetchReportedVideos: fetchReportedVideos,
	  deleteSavedVideo: deleteSavedVideo,
	  deleteReportedVideo: deleteReportedVideo,
	  updateReportedVideo: updateReportedVideo,
	  fetchCBTReportedQuestion: fetchCBTReportedQuestion,
	  deleteCBTReportedQuestion: deleteCBTReportedQuestion,
	  updateReportedCBTQuestion: updateReportedCBTQuestion,
	  sendFurtherHelpRequest: sendFurtherHelpRequest,
	  redirectToQuestion: redirectToQuestion,
	  redirectToNotes: redirectToNotes,
	  redirectToVideos: redirectToVideos,
	  redirectToCbtQuestion: redirectToCbtQuestion
	};

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa1Subscription = __webpack_require__(142);
	
	var _Cfa1Subscription2 = _interopRequireDefault(_Cfa1Subscription);
	
	var _Cfa1Subscription3 = __webpack_require__(143);
	
	var _Cfa1Subscription4 = _interopRequireDefault(_Cfa1Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _CommonFilter = __webpack_require__(185);
	
	var _CommonFilter2 = _interopRequireDefault(_CommonFilter);
	
	var _CommonDetailStatus = __webpack_require__(184);
	
	var _CommonDetailStatus2 = _interopRequireDefault(_CommonDetailStatus);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { browserHistory } from 'react-router';
	
	
	// import AppRoutes from '../../config/AppRoutes';
	// import ScrollUpButton from "react-scroll-up-button";
	
	/* eslint-disable*/
	var ViewAllQues2025 = function (_Component) {
	  _inherits(ViewAllQues2025, _Component);
	
	  function ViewAllQues2025(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewAllQues2025);
	
	    var _this = _possibleConstructorReturn(this, (ViewAllQues2025.__proto__ || Object.getPrototypeOf(ViewAllQues2025)).call(this, props));
	
	    _this.setSelectedChapter = function (e) {
	      console.log('hello i am herer', _this.state);
	      var chapterId = e.target.value;
	      _this.setState({
	        selectedChapter: e.target.value,
	        selectedQuestion: ''
	      });
	      var data = {
	        token: _this.state.token,
	        chapterId: chapterId
	      };
	      _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/reading', data).then(function (resp) {
	        if (resp.success) {
	          // console.log(resp)
	          _this.setState({ ValidToken: true });
	          _this.setState({ readings: resp.readings }, function () {
	            // console.log(this.state.allQuestions)
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	          // console.log(resp)
	        }
	      });
	    };
	
	    _this.setSelectedReading = function (e) {
	      _this.setState({ selectedReading: e.target.value, selectedQuestion: '' });
	    };
	
	    _this.setSelectedQuestion = function (e) {
	      _this.setState({
	        selectedQuestion: e.target.value,
	        selectedChapter: '',
	        selectedReading: '',
	        selectedAnswered: '',
	        selctedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: ''
	      });
	    };
	
	    _this.setSelectedAnswered = function (e) {
	      _this.setState({ selectedAnswered: e.target.value });
	    };
	
	    _this.setSelectedNoOfAttempts = function (e) {
	      _this.setState({ selectedAttempts: e.target.value });
	    };
	
	    _this.setSelectedPagination = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(page, data) {
	        var pageMinusOne, questionLowerLimit, questionUpperLimit;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.setState({
	                  totalPages: data.totalPages,
	                  pageLimit: data.pageLimit,
	                  // totalQuestions: data.totalQuestions,
	                  currentPage: page,
	                  loader: true
	                });
	                pageMinusOne = page - 1;
	                questionLowerLimit = pageMinusOne * 20;
	                questionUpperLimit = pageMinusOne * 20 + 20;
	
	                _this.setState({
	                  questionLowerLimit: questionLowerLimit,
	                  questionUpperLimit: questionUpperLimit
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                  var storage_session, data;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                          _this.setState({ idname: storage_session['idname'] });
	                          _this.setState({ token: storage_session['token'] });
	                          data = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            chapter: _this.state.selectedChapter,
	                            reading: _this.state.selectedReading,
	                            question: _this.state.selectedQuestion,
	                            selectedAnswered: _this.state.selectedAnswered,
	                            selectedAttempts: _this.state.selectedAttempts,
	                            selectedAvgScore: _this.state.selectedAvgScore,
	                            selectedLowerLimit: _this.state.selectedLowerLimit,
	                            selectedUpperLimit: _this.state.selectedUpperLimit,
	                            selectedPassingScore: _this.state.selectedPassingScore,
	                            questionLowerLimit: _this.state.questionLowerLimit,
	                            questionUpperLimit: _this.state.questionUpperLimit,
	                            subscriptionstatus: _this.state.subscriptionstatus
	                          };
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStats', data).then(function (resp) {
	                            if (resp.success) {
	                              window.scroll(0, 0);
	                              // console.log(resp)
	                              _this.setState({ ValidToken: true });
	                              //   console.log(typeof resp.allQuestions)
	                              _this.setState({
	                                allQuestion: resp.allQuestions,
	                                // totalQuestions: resp.totalQuestions,
	                                loader: false
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                              //   console.log(resp)
	                            }
	                          });
	
	                        case 5:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                })));
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.setSelectedChangeAvgScores = function (e) {
	      // console.log(e.target.value)
	      if (e.target.value === '0') {
	        // console.log('0 working')
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '0',
	          selectedUpperLimit: '25'
	        });
	      } else if (e.target.value === '1') {
	        // console.log('1 working')
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '25',
	          selectedUpperLimit: '50'
	        });
	      } else if (e.target.value === '2') {
	        // console.log('2 working')
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '50',
	          selectedUpperLimit: '75'
	        });
	      } else if (e.target.value === '3') {
	        // console.log('3 working')
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '75',
	          selectedUpperLimit: '100'
	        });
	      }
	    };
	
	    _this.setSelectedChangePass = function (e) {
	      _this.setState({ selectedPassingScore: e.target.value });
	    };
	
	    _this.resetAllQuestion = function () {
	      // console.log('reset all working')
	      _this.setState({
	        selectedChapter: '',
	        selectedReading: '',
	        selectedQuestion: '',
	        selectedAnswered: '',
	        selectedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: '',
	        selectedLowerLimit: '',
	        selectedUpperLimit: '',
	        questionLowerLimit: '0',
	        questionUpperLimit: '20',
	        readings: [],
	        loader: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                // console.log(this.state.selectedChapter)
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                _this.setState({ idname: storage_session['idname'] });
	                _this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: _this.state.selectedChapter,
	                  reading: _this.state.selectedReading,
	                  question: _this.state.selectedQuestion,
	                  selectedAnswered: _this.state.selectedAnswered,
	                  selectedAttempts: _this.state.selectedAttempts,
	                  selectedAvgScore: _this.state.selectedAvgScore,
	                  selectedLowerLimit: _this.state.selectedLowerLimit,
	                  selectedUpperLimit: _this.state.selectedUpperLimit,
	                  selectedPassingScore: _this.state.selectedPassingScore,
	                  questionLowerLimit: _this.state.questionLowerLimit,
	                  questionUpperLimit: _this.state.questionUpperLimit,
	                  subscriptionstatus: _this.state.subscriptionstatus
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStats', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    _this.setState({ ValidToken: true });
	                    //   console.log(typeof resp.allQuestions)
	                    _this.setState({
	                      allQuestion: resp.allQuestions,
	                      loader: false
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStatstotalCount', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ ValidToken: true });
	                    _this.setState({
	                      totalQuestions: resp.totalQuestions
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	                _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/chapter-wise-count', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    _this.setState({ chapters: resp.data }, function () {
	                      // console.log(this.state.chapters)
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                    // console.log(resp)
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      })));
	    };
	
	    _this.resetAllChapter = function () {
	      // console.log('reset all working')
	      _this.setState({
	        selectedChapter: '',
	        selectedReading: '',
	        selectedQuestion: '',
	        selectedAnswered: '',
	        selectedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: '',
	        selectedLowerLimit: '',
	        selectedUpperLimit: '',
	        questionLowerLimit: '0',
	        questionUpperLimit: '20',
	        readings: [],
	        loader: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                // console.log(this.state.selectedChapter)
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                _this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: _this.state.selectedChapter,
	                  reading: _this.state.selectedReading,
	                  question: _this.state.selectedQuestion,
	                  selectedAnswered: _this.state.selectedAnswered,
	                  selectedAttempts: _this.state.selectedAttempts,
	                  selectedAvgScore: _this.state.selectedAvgScore,
	                  selectedLowerLimit: _this.state.selectedLowerLimit,
	                  selectedUpperLimit: _this.state.selectedUpperLimit,
	                  selectedPassingScore: _this.state.selectedPassingScore,
	                  questionLowerLimit: _this.state.questionLowerLimit,
	                  questionUpperLimit: _this.state.questionUpperLimit,
	                  subscriptionstatus: _this.state.subscriptionstatus
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStats', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    _this.setState({ ValidToken: true });
	                    //   console.log(typeof resp.allQuestions)
	                    _this.setState({
	                      allQuestion: resp.allQuestions,
	                      loader: false
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                    // console.log(resp)
	                  }
	                });
	
	              case 5:
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStatstotalCount', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ ValidToken: true });
	                    _this.setState({
	                      totalQuestions: resp.totalQuestions
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	                _context4.next = 8;
	                return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/chapter-wise-count', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    _this.setState({ chapters: resp.data }, function () {
	                      // console.log(this.state.chapters)
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                    // console.log(resp)
	                  }
	                });
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      })));
	    };
	
	    _this.state = {
	      allQuestion: [],
	      selectedChapter: '',
	      selectedReading: '',
	      selectedQuestion: '',
	      selectedAnswered: '',
	      selectedAttempts: '',
	      selectedAvgScore: '',
	      selectedPassingScore: '',
	      selectedLowerLimit: '',
	      selectedUpperLimit: '',
	      searchBy: 'chapterID',
	      readings: [],
	      chapters: [],
	      totalQuestions: '',
	      currentPage: 1,
	      pageLimit: 20,
	      pageNeighbours: 1,
	      questionLowerLimit: 0,
	      questionUpperLimit: 20,
	      loader: true,
	      url: new URL(window.location.href),
	      subscriptionstatus: '',
	      selectedmenu: 'cfa',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: ''
	    };
	    return _this;
	  }
	
	  _createClass(ViewAllQues2025, [{
	    key: '_filerQuestionsByChapter',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                this.setState({ loader: true });
	                // console.log(this.state.searchBy)
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  chapter: this.state.selectedChapter,
	                  reading: this.state.selectedReading,
	                  question: this.state.selectedQuestion,
	                  selectedAnswered: this.state.selectedAnswered,
	                  selectedAttempts: this.state.selectedAttempts,
	                  selectedAvgScore: this.state.selectedAvgScore,
	                  selectedLowerLimit: this.state.selectedLowerLimit,
	                  selectedUpperLimit: this.state.selectedUpperLimit,
	                  selectedPassingScore: this.state.selectedPassingScore,
	                  questionLowerLimit: 0,
	                  questionUpperLimit: 20,
	                  subscriptionstatus: this.state.subscriptionstatus
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStats', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({
	                      currentPage: 1,
	                      questionLowerLimit: 0,
	                      questionUpperLimit: 20,
	                      allQuestion: resp.allQuestions,
	                      loader: false
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/detailedStatstotalCount', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({
	                      totalQuestions: resp.totalQuestions
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function _filerQuestionsByChapter() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return _filerQuestionsByChapter;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this4 = this,
	            _data;
	
	        var storage_session, dataChapter, final_exam, user_data, data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                dataChapter = {
	                  token: storage_session['token'],
	                  chapterId: this.state.selectedChapter
	                };
	                final_exam = [];
	                user_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context12.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context8.next = 10;
	                            break;
	
	                          case 5:
	                            _this4.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context6.next = 6;
	                                        return _Cfa1Subscription4.default.checkCfa1Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context6.sent;
	
	                                        if (isInArray_var) {
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4.setState({ subscriptionstatus: 'free' });
	                                        }
	                                        _context6.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this4);
	                              }));
	
	                              return function (_x4) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }());
	
	                          case 10:
	                            _context8.next = 21;
	                            break;
	
	                          case 12:
	                            if (!(resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context8.next = 16;
	                              break;
	                            }
	
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context8.next = 21;
	                            break;
	
	                          case 16:
	                            _this4.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 21;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (resp_exam.success) {
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this4.state.selectedmenu;
	                                          isInArray_var = false;
	
	                                          isInArray_var = _Cfa1Subscription2.default.checkCfa1Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                          // console.log("isInArray_var",isInArray_var);
	
	                                          if (isInArray_var) {
	                                            _this4.setState({ subscriptionstatus: 'paid' });
	                                          } else {
	                                            _this4.setState({ subscriptionstatus: 'free' });
	                                          }
	                                        } else {
	                                          console.log('fail');
	                                        }
	
	                                      case 1:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this4);
	                              }));
	
	                              return function (_x5) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }());
	
	                          case 21:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this4);
	                  }));
	
	                  return function (_x3) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	                data = (_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.selectedChapter,
	                  reading: this.state.selectedReading,
	                  question: this.state.selectedQuestion,
	                  selectedAnswered: this.state.selectedAnswered,
	                  selectedAttempts: this.state.selectedAttempts,
	                  selectedAvgScore: this.state.selectedAvgScore,
	                  selectedLowerLimit: this.state.selectedLowerLimit,
	                  selectedUpperLimit: this.state.selectedUpperLimit
	                }, _defineProperty(_data, 'selectedUpperLimit', this.state.selectedPassingScore), _defineProperty(_data, 'questionLowerLimit', this.state.questionLowerLimit), _defineProperty(_data, 'questionUpperLimit', this.state.questionUpperLimit), _defineProperty(_data, 'subscriptionstatus', this.state.subscriptionstatus), _data);
	                // console.log(data)
	
	                _context12.next = 10;
	                return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/chapter-wise-count', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (resp.success) {
	                              console.log('chapter', resp);
	                              _this4.setState({ chapters: resp.data });
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this4);
	                  }));
	
	                  return function (_x6) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	                _context12.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/getQuestionsCount', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this4.setState({
	                                totalQuestions: resp.totalQuestions
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this4);
	                  }));
	
	                  return function (_x7) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                if (!(this.state.selectedChapter !== '')) {
	                  _context12.next = 17;
	                  break;
	                }
	
	                _context12.next = 15;
	                return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/reading', dataChapter).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp)
	                              _this4.setState({ ValidToken: true });
	                              _this4.setState({ readings: resp.readings }, function () {});
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this4);
	                  }));
	
	                  return function (_x8) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 15:
	                _context12.next = 18;
	                break;
	
	              case 17:
	                null;
	
	              case 18:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          readings = _state.readings,
	          allQuestion = _state.allQuestion,
	          chapters = _state.chapters,
	          selectedChapter = _state.selectedChapter,
	          selectedReading = _state.selectedReading,
	          selectedQuestion = _state.selectedQuestion,
	          selectedAnswered = _state.selectedAnswered,
	          selectedAttempts = _state.selectedAttempts,
	          selectedAvgScore = _state.selectedAvgScore,
	          selectedPassingScore = _state.selectedPassingScore,
	          selectedLowerLimit = _state.selectedLowerLimit,
	          selectedUpperLimit = _state.selectedUpperLimit,
	          questionLowerLimit = _state.questionLowerLimit,
	          questionUpperLimit = _state.questionUpperLimit,
	          totalQuestions = _state.totalQuestions,
	          pageLimit = _state.pageLimit,
	          pageNeighbours = _state.pageNeighbours,
	          currentPage = _state.currentPage,
	          loader = _state.loader,
	          subscriptionstatus = _state.subscriptionstatus,
	          selectedmenu = _state.selectedmenu,
	          searchBy = _state.searchBy;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'top-heading-filter-toggle clrearfix ' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'all-question-heading' },
	            ' ',
	            _language2.default.LC().List_of_All_Questions_For,
	            ' CFA Level 1',
	            ' '
	          ),
	          _react2.default.createElement(_CommonFilter2.default, {
	            onChangeQuestion: this.setSelectedQuestion.bind(this),
	            onChangeChapter: this.setSelectedChapter.bind(this),
	            onChangeReading: this.setSelectedReading.bind(this),
	            onChangeAnswered: this.setSelectedAnswered.bind(this),
	            onChangeNoOfAttempts: this.setSelectedNoOfAttempts.bind(this),
	            onChangeAvgScore: this.setSelectedChangeAvgScores.bind(this),
	            onChangePass: this.setSelectedChangePass.bind(this),
	            onChangePagination: this.setSelectedPagination.bind(this),
	            readingData: readings,
	            chapterData: chapters,
	            filerSubmit: this._filerQuestionsByChapter.bind(this),
	            resetAllQuestion: this.resetAllQuestion.bind(this),
	            resetAllChapter: this.resetAllChapter.bind(this),
	            selectedChapter: selectedChapter,
	            selectedAnswered: selectedAnswered,
	            selectedReading: selectedReading,
	            selectedQuestion: selectedQuestion,
	            selectedAttempts: selectedAttempts,
	            selectedAvgScore: selectedAvgScore,
	            selectedPassingScore: selectedPassingScore,
	            selectedLowerLimit: selectedLowerLimit,
	            selectedUpperLimit: selectedUpperLimit,
	            subscriptionstatus: subscriptionstatus,
	            selectedmenu: selectedmenu,
	            searchBy: searchBy
	          })
	        ),
	        _react2.default.createElement(_CommonDetailStatus2.default, {
	          onChangePagination: this.setSelectedPagination.bind(this),
	          allQuestionData: allQuestion,
	          totalQuestions: totalQuestions,
	          currentPage: currentPage,
	          pageLimit: pageLimit,
	          pageNeighbours: pageNeighbours,
	          questionLowerLimit: questionLowerLimit,
	          questionUpperLimit: questionUpperLimit,
	          loader: loader,
	          subscriptionstatus: subscriptionstatus,
	          selectedmenu: 'cfa_2025'
	        })
	      );
	    }
	  }]);
	
	  return ViewAllQues2025;
	}(_react.Component);
	
	exports.default = ViewAllQues2025;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateFilter = __webpack_require__(254);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _PerformanceGraph = __webpack_require__(255);
	
	var _PerformanceGraph2 = _interopRequireDefault(_PerformanceGraph);
	
	var _ProgressBar = __webpack_require__(256);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _TabList = __webpack_require__(257);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _graphDataCalculator = __webpack_require__(259);
	
	var _graphDataCalculator2 = _interopRequireDefault(_graphDataCalculator);
	
	var _messages = __webpack_require__(14);
	
	var _ApiAttributesKays = __webpack_require__(593);
	
	var _ApiService = __webpack_require__(594);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _tabList = __webpack_require__(597);
	
	var _tabList2 = _interopRequireDefault(_tabList);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var index = function (_Component) {
	  _inherits(index, _Component);
	
	  function index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, index);
	
	    var _this = _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).call(this, props));
	
	    _this.getUserPerformanceBarGraph = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var data, result, usersBarGraphData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.setState({ isPerformanceGraphLoader: true });
	
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate
	              };
	              _context.next = 4;
	              return _ApiService2.default['getUserPerformanceBarGraph'](data);
	
	            case 4:
	              result = _context.sent;
	
	              if (!result.success) {
	                _context.next = 10;
	                break;
	              }
	
	              _context.next = 8;
	              return (0, _graphDataCalculator2.default)(result.userAttemptedAndAnsweredCount, _ApiAttributesKays.performanceGraphUserAttemptedCountKey, _ApiAttributesKays.performanceGraphUserAnsweredCountKey);
	
	            case 8:
	              usersBarGraphData = _context.sent;
	
	
	              _this.setState({ usersBarGraphData: usersBarGraphData });
	
	            case 10:
	              _this.setState({ isPerformanceGraphLoader: false });
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getTotalUsersPerformanceBarGraph = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var data, result, totalUsersBarGraphData, barLabel;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate
	              };
	              _context2.next = 3;
	              return _ApiService2.default['getTotalUsersPerformanceBarGraph'](data);
	
	            case 3:
	              result = _context2.sent;
	
	              if (!result.success) {
	                _context2.next = 19;
	                break;
	              }
	
	              totalUsersBarGraphData = void 0;
	
	              if (!(formattedStartDate && formattedEndDate)) {
	                _context2.next = 12;
	                break;
	              }
	
	              _context2.next = 9;
	              return (0, _graphDataCalculator2.default)(result.attemptedCount, _ApiAttributesKays.performanceGraphUserAttemptedCountKey, _ApiAttributesKays.performanceGraphUserAnsweredCountKey);
	
	            case 9:
	              totalUsersBarGraphData = _context2.sent;
	              _context2.next = 15;
	              break;
	
	            case 12:
	              _context2.next = 14;
	              return (0, _graphDataCalculator2.default)(result.attemptedCount, _ApiAttributesKays.attemptedCountKey, _ApiAttributesKays.answeredCountKey);
	
	            case 14:
	              totalUsersBarGraphData = _context2.sent;
	
	            case 15:
	              _context2.next = 17;
	              return result.attemptedCount.map(function (chapters) {
	                return chapters[_ApiAttributesKays.chapterNameKey].substring(0, 14);
	              });
	
	            case 17:
	              barLabel = _context2.sent;
	
	              _this.setState({
	                totalUsersBarGraphDataPart: totalUsersBarGraphData,
	                barLabelPart: barLabel
	              });
	
	            case 19:
	              _this.setState({ isPerformanceGraphLoader: false });
	
	            case 20:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.getQuestionProgressBar = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var data, result;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this.setState({ isQuestionProgressBarLoader: true });
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate
	              };
	              _context3.next = 4;
	              return _ApiService2.default['fetchQuestionProgressBar'](data);
	
	            case 4:
	              result = _context3.sent;
	
	              if (result.success) {
	                _this.setState({
	                  questionProgressBarData: result.chapters,
	                  questionProgressTables: result.tables,
	                  isQuestionProgressBarLoader: false
	                });
	              }
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.getNotesProgressBar = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var level = arguments[2];
	      var data, result;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.setState({ isNotesProgressBarLoader: true });
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate,
	                level: level
	              };
	              _context4.next = 4;
	              return _ApiService2.default['fetchNotesProgressBar'](data);
	
	            case 4:
	              result = _context4.sent;
	
	              if (result.success) {
	                _this.setState({
	                  notesProgressBarData: result.chapters,
	                  isNotesProgressBarLoader: false
	                });
	              }
	
	            case 6:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.viewAllQuestion = function () {
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_DASHBOARD_VIEW_QUESTIONS)
	      });
	    };
	
	    _this.state = {
	      isPerformanceGraphLoader: true,
	      usersBarGraphData: [],
	      totalUsersBarGraphData: [],
	      barLabelPart1: [],
	      //^ progress bar state stated here
	      questionProgressBarData: [],
	      questionProgressTables: null,
	      isQuestionProgressBarLoader: true,
	      notesProgressBarData: [],
	      isNotesProgressBarLoader: true,
	      startDate: '',
	      endDate: ''
	    };
	    return _this;
	  }
	
	  _createClass(index, [{
	    key: 'componentDidMount',
	
	
	    //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _state, startDate, endDate;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _state = this.state, startDate = _state.startDate, endDate = _state.endDate;
	
	                this.getUserPerformanceBarGraph(startDate, endDate);
	                this.getTotalUsersPerformanceBarGraph(startDate, endDate);
	                this.getQuestionProgressBar(startDate, endDate);
	                this.getNotesProgressBar(startDate, endDate);
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
	
	    //*=========================={{ PERFORMANCE GRAPH FUNCTION START HERE }}======================================
	
	    //*=========================={{ PERFORMANCE GRAPH FUNCTION ENDED HERE }}======================================
	
	    //*================================{{QUESTION AND NOTES PROGRESS BAR FUNCTIONS START HERE }}====================================
	
	  }, {
	    key: 'render',
	
	
	    //*============================={{QUESTION AND NOTES PROGRESS BAR FUNCTIONS ENDED HERE }}======================================
	    value: function render() {
	      var state = this.state;
	      var barLabelPart = state.barLabelPart,
	          isPerformanceGraphLoader = state.isPerformanceGraphLoader,
	          usersBarGraphData = state.usersBarGraphData,
	          totalUsersBarGraphDataPart = state.totalUsersBarGraphDataPart,
	          questionProgressBarData = state.questionProgressBarData,
	          questionProgressTables = state.questionProgressTables,
	          isQuestionProgressBarLoader = state.isQuestionProgressBarLoader,
	          notesProgressBarData = state.notesProgressBarData,
	          isNotesProgressBarLoader = state.isNotesProgressBarLoader;
	      // Notes-progress rows come back keyed by the notes table name, which differs per exam year
	      // (cfa1_2025_notes for 2025/2026, cfa1_2027_notes for 2027). The static notesTableNameKey
	      // only matches the 2025 table, so for a year that uses a different notes table the ProgressBar
	      // would read undefined keys and render an empty bar. Resolve the matching key per selected exam.
	
	      var selectedExam = localStorage.getItem('selectedmenu');
	      var notesModelKey = selectedExam === 'cfa_2027' ? 'cfa1_2027_notes' : _ApiAttributesKays.notesTableNameKey;
	      // Saved/Reported rows come back keyed by the singular per-year association alias. For 2027
	      // the notes AND videos models are cloned (cfa1_2027_notes / cfa1_2027_videos), so their
	      // aliases differ from the 2025 ones hardcoded in tabList (cfa1_2025_note / cfa1_2025_video).
	      // Without remapping, the topic text reads undefined ("Notes ID: N" / "Video Id: N" with no
	      // title). Remap the affected tabs' saveItemTableName for the selected exam.
	      // For 2027 the question and CBT-question models are cloned too (cfa1_2027_questions /
	      // cfa1_2027_cbt_questions), so the report/saved rows key their included topic by the 2027
	      // association alias (cfa1_2027_question / cfa1_2027_cbt_question) instead of the 2025 ones the
	      // tabList hardcodes. Without remapping, the topic reads undefined and the Edit-report click
	      // crashes on the missing nested object.
	      var aliasFor2027 = {
	        cfa1_2025_note: 'cfa1_2027_note',
	        cfa1_2025_video: 'cfa1_2027_video',
	        question: 'cfa1_2027_question',
	        cfa_cbt_question: 'cfa1_2027_cbt_question'
	      };
	      var yearAwareTabList = selectedExam === 'cfa_2027' ? _tabList2.default.map(function (tab) {
	        return aliasFor2027[tab.saveItemTableName] ? Object.assign({}, tab, { saveItemTableName: aliasFor2027[tab.saveItemTableName] }) : tab;
	      }) : _tabList2.default;
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(_EmailResubscribe2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 mt-1' },
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              { title: 'CFA Level I ' + _messages.messages.DASHBOARD },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this.viewAllQuestion },
	                _messages.messages.DETAILED_STATS
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8' },
	            _react2.default.createElement(_DateFilter2.default, {
	              getUserBarGraph: this.getUserPerformanceBarGraph,
	              getTotalUsersBarGraph: this.getTotalUsersPerformanceBarGraph
	            }),
	            _react2.default.createElement(_PerformanceGraph2.default, {
	              barLabel: barLabelPart,
	              headText: _messages.messages.PERFORMANCE,
	              tooltipContent: _messages.messages.SEPARATE_YOUR_RESULT,
	              tooltipPlace: 'left',
	              performanceGraphLoader: isPerformanceGraphLoader,
	              usersBarGraphData: usersBarGraphData,
	              totalUsersBarGraphData: totalUsersBarGraphDataPart
	            }),
	            _react2.default.createElement(_TabList2.default, {
	              section: 'favAPIService',
	              exam: 'cfa1_2025',
	              TabHeader: _messages.messages.MY_SAVED_ITEM_WITH_FLASH_CARD,
	              apiServiceProvider: _ApiService2.default,
	              tabList: yearAwareTabList
	            }),
	            _react2.default.createElement(_TabList2.default, {
	              section: 'reportAPIService',
	              exam: 'cfa1_2025',
	              TabHeader: _messages.messages.MY_REPORTS,
	              apiServiceProvider: _ApiService2.default,
	              tabList: yearAwareTabList
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-4' },
	            _react2.default.createElement(_ProgressBar2.default, {
	              headerName: _messages.messages.QUESTION_PROGRESS,
	              ProgressBarData: questionProgressBarData,
	              progressBarLoader: isQuestionProgressBarLoader,
	              ProgressBarTables: questionProgressTables || {
	                questionModel: _ApiAttributesKays.questionTableNameKey,
	                questionStatsModel: _ApiAttributesKays.questionStatsTableNameKey
	              }
	            }),
	            _react2.default.createElement(_ProgressBar2.default, {
	              headerName: 'Notes Progress',
	              ProgressBarData: notesProgressBarData,
	              progressBarLoader: isNotesProgressBarLoader,
	              countKey: 'notesCount',
	              ProgressBarTables: {
	                questionModel: notesModelKey,
	                questionStatsModel: _ApiAttributesKays.notesStatsTableNameKey
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return index;
	}(_react.Component);
	
	index.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = index;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabList = [{
	  label: 'Question',
	  idFieldName: 'questionId',
	  // SAVED ITEM LIST START HERE
	  favAPIService: 'fetchSavedQuestion',
	  saveItemDeleteAPIService: 'deleteSavedQuestion',
	  savedItemTitle: 'Question ID', // that is tabs title with ID
	  saveItemTableName: 'question', // table name to access object or save item
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	
	  //* REPORTED ITEM LIST START HERE
	  reportAPIService: 'fetchReportedQuestion',
	  reportedItemTableKey: 'comment',
	  reportDeleteAPIService: 'deleteReportedQuestion',
	  // VIEW ITEM LIST START HERE
	  viewItemAPIService: 'redirectToQuestion',
	  redirectionPath: _AppRoutes2.default.CFA1_2025_QUESTION_VIEW,
	  // EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedQuestion'
	}, {
	  label: 'Notes',
	  //* SAVED ITEM LIST START HERE
	  favAPIService: 'fetchSavedNotes',
	  idFieldName: 'notesId',
	  saveItemDeleteAPIService: 'deleteSavedNotes',
	  savedItemTitle: 'Notes ID', // that is tabs title with ID
	  saveItemTableName: 'cfa1_2025_note', // table name to access object or save item
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	  //* REPORTED ITEM LIST START HERE
	  reportAPIService: 'fetchReportedNotes',
	  reportedItemTableKey: 'comment',
	  reportDeleteAPIService: 'deleteReportedNotes',
	  //* VIEW ITEM LIST START HERE
	  viewItemAPIService: 'redirectToNotes',
	  redirectionPath: _AppRoutes2.default.CFA1_2025_NOTES_VIEW,
	  //* EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedNotes'
	}, {
	  label: 'Video',
	  //* SAVED ITEM LIST START HERE
	  idFieldName: 'video_id',
	  favAPIService: 'fetchSavedVideos',
	  saveItemDeleteAPIService: 'deleteSavedVideo',
	  savedItemTitle: 'Video Id', // that is tabs title with ID
	  saveItemTableName: 'cfa1_2025_video', // table name to access object or save item
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	  //* REPORTED ITEM LIST START HERE
	  reportAPIService: 'fetchReportedVideos',
	  reportedItemTableKey: 'comment',
	  reportDeleteAPIService: 'deleteReportedVideo',
	  //* VIEW ITEM LIST START HERE
	  viewItemAPIService: 'redirectToVideos',
	  redirectionPath: _AppRoutes2.default.CFA1_VIDEO_LIST,
	  //* EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedVideo'
	}, {
	  label: 'Mocks',
	  idFieldName: 'questionId',
	  reportAPIService: 'fetchCBTReportedQuestion',
	  savedItemTitle: 'CBT Question ID',
	  saveItemTableName: 'cfa_cbt_question',
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	  reportedItemTableKey: 'comment',
	  viewItemAPIService: 'redirectToCbtQuestion',
	  redirectionPath: _AppRoutes2.default.CFA1_2024_CBT_QUESTION_FINISH,
	  reportDeleteAPIService: 'deleteCBTReportedQuestion',
	  // EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedCBTQuestion'
	}];
	
	exports.default = tabList;

/***/ },
/* 598 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  readingIdKey: 'reading_id',
	  chapterNameKay: 'chapterName',
	  totalReadingKey: 'totalReading',
	  freeQuestionsCountKey: 'totalFreeQuestions',
	  premiumQuestionsCountKey: 'totalQuestions',
	  tableKey: 'cfa1_2025_note',
	  tableChapterKey: 'chapter_id',
	  //* notes key's
	  totalNotesKey: 'totalNotes'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchChaptersWithPremiumAndFreeCount = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/chapter-wise-notes-count', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchChaptersWithPremiumAndFreeCount(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var downloadFormulaSheet = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/api/exams/cfa/notes/pdf-download-via-email', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function downloadFormulaSheet(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var fetchLastNoteRead = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/last-answered-notes', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchLastNoteRead() {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var fetchAdditionalResourcesPdf = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/additional-resources', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function fetchAdditionalResourcesPdf() {
	    return _ref4.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchChaptersWithPremiumAndFreeCount: fetchChaptersWithPremiumAndFreeCount,
	  fetchLastNoteRead: fetchLastNoteRead,
	  downloadFormulaSheet: downloadFormulaSheet,
	  fetchAdditionalResourcesPdf: fetchAdditionalResourcesPdf
	};

/***/ },
/* 600 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  readingNameKey: 'readingName',
	  freeQuestionCountKey: 'totalFreeQuestion',
	  TotalNotesCountKey: 'totalNotes',
	  chapterIdKey: 'chapterId',
	  chapterNameKey: 'chapter_name',
	  chapterOrderKey: 'chapter_order'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchReadingList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/reading', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchReadingList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var pdfDownloadViaEmail = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/pdf-download-via-email', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchReadingList: fetchReadingList,
	  pdfDownloadViaEmail: pdfDownloadViaEmail
	};

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReadingList = __webpack_require__(135);
	
	var _ReadingList2 = _interopRequireDefault(_ReadingList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _ApiAttributesKeys = __webpack_require__(600);
	
	var _ApiService = __webpack_require__(601);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var ReadingsList = function (_Component) {
	  _inherits(ReadingsList, _Component);
	
	  function ReadingsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ReadingsList);
	
	    var _this = _possibleConstructorReturn(this, (ReadingsList.__proto__ || Object.getPrototypeOf(ReadingsList)).call(this, props));
	
	    _this.checkSubscription = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cb, type) {
	        var isUserSubscribed, response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                isUserSubscribed = _this.state.isUserSubscribed;
	
	                if (isUserSubscribed) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt('return', _this.setState({ openPremiumPopup: true }));
	
	              case 3:
	                _context.next = 5;
	                return cb();
	
	              case 5:
	                response = _context.sent;
	
	                if (response && response.success) {
	                  _this.setState({ PDFDownloadType: type });
	                  _this.pdfAlertModel();
	                } else {
	                  (0, _toast.showFailure)(response && response.message || _messages.messages.PDF_DOWNLOAD_NOT_AVAILABLE);
	                }
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.pdfAlertModel = function () {
	      _this.setState({ pdfAlert: !_this.state.pdfAlert });
	    };
	
	    _this.onBeginChapter = function (items) {
	      var isUserSubscribed = _this.state.isUserSubscribed;
	      var chapterId = _this.props.params.chapterId;
	
	      if (!items[_ApiAttributesKeys.TotalNotesCountKey]) {
	        (0, _toast.showInformation)(_messages.messages.NOTES_NOT_AVAILABLE_FOR_READING);
	      } else {
	        if (!isUserSubscribed && parseInt(chapterId, 10) !== 1) {
	          return _this.setState({ openPremiumPopup: true });
	        } else {
	          var router = _this.context.router;
	
	          router.push({
	            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_VIEW).replace(':readingId', items.id).replace(':chapterId', items[_ApiAttributesKeys.chapterIdKey])
	          });
	        }
	      }
	    };
	
	    _this.onViewList = function (items) {
	      var isUserSubscribed = _this.state.isUserSubscribed;
	      var chapterId = _this.props.params.chapterId;
	
	      if (!items[_ApiAttributesKeys.TotalNotesCountKey]) {
	        (0, _toast.showInformation)(_messages.messages.NOTES_NOT_AVAILABLE_FOR_READING);
	      } else {
	        if (!isUserSubscribed && parseInt(chapterId, 10) !== 1) {
	          return _this.setState({ openPremiumPopup: true });
	        } else {
	          var router = _this.context.router;
	
	          router.push({
	            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_LIST).replace(':readingId', items.id).replace(':chapterId', items[_ApiAttributesKeys.chapterIdKey])
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      selectedExamSubscriptionDetails: {},
	      chapterName: '',
	      chapterOrder: 0,
	      pdfAlert: false,
	      openPremiumPopup: false,
	      isUserSubscribed: false,
	      readingListData: [],
	      isLoading: true
	    };
	    return _this;
	  }
	
	  _createClass(ReadingsList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props$params, chapterId, level, fetchReadingListData, readings, selectedExamSubscriptionDetails, chapterName, router;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props$params = this.props.params, chapterId = _props$params.chapterId, level = _props$params.level;
	                _context2.next = 3;
	                return _ApiService2.default['fetchReadingList']({ chapterId: chapterId, level: level });
	
	              case 3:
	                fetchReadingListData = _context2.sent;
	
	                if (fetchReadingListData.success) {
	                  readings = fetchReadingListData.readings, selectedExamSubscriptionDetails = fetchReadingListData.selectedExamSubscriptionDetails, chapterName = fetchReadingListData.chapterName;
	
	                  if (selectedExamSubscriptionDetails.level1SubscriptionDetails && selectedExamSubscriptionDetails.level1SubscriptionDetails.noteStatus || parseInt(chapterId, 10) === 1) {
	                    this.setState({});
	                    this.setState({
	                      readingListData: readings,
	                      isUserSubscribed: !!selectedExamSubscriptionDetails.level1SubscriptionDetails,
	                      selectedExamSubscriptionDetails: selectedExamSubscriptionDetails,
	                      isLoading: false,
	                      chapterName: Object.keys(chapterName).length && chapterName[_ApiAttributesKeys.chapterNameKey],
	                      chapterOrder: Object.keys(chapterName).length && chapterName[_ApiAttributesKeys.chapterOrderKey]
	                    });
	                  } else {
	                    router = this.context.router;
	
	                    router.push({ pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES) });
	                    (0, _toast.showFailure)(_messages.messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER);
	                  }
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var params = this.props.params;
	      var chapterId = params.chapterId;
	      var _state = this.state,
	          chapterName = _state.chapterName,
	          chapterOrder = _state.chapterOrder,
	          pdfAlert = _state.pdfAlert,
	          openPremiumPopup = _state.openPremiumPopup,
	          isUserSubscribed = _state.isUserSubscribed,
	          readingListData = _state.readingListData,
	          _state$isLoading = _state.isLoading,
	          isLoading = _state$isLoading === undefined ? false : _state$isLoading;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: (chapterOrder !== 0 ? chapterOrder + '.' : '') + ' ' + chapterName },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return _ApiService2.default['pdfDownloadViaEmail']({
	                      chapterId: chapterId
	                    });
	                  }, 'Question');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _messages.messages.DOWNLOAD_NOTE
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return router.push({ pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES) });
	                } },
	              _messages.messages.CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(_ReadingList2.default, {
	            tableName: _messages.messages.CHAPTER_READING,
	            readingData: readingListData,
	            onViewList: this.onViewList,
	            isViewListIcon: true,
	            onBeginChapter: this.onBeginChapter
	          })
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: pdfAlert,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return ReadingsList;
	}(_react.Component);
	
	ReadingsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ReadingsList;

/***/ },
/* 603 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  notesIdKey: 'id',
	  notesNameKey: 'name',
	  notesReadingIdKey: 'readingId',
	  descriptionKey: 'description',
	  notesStatsKey: 'cfa1_2024_notes_stats.answer_status'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchNotes = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/all-notes', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchNotes(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchSavedQuestion = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/save-notes', Object.assign({}, data, {
	              notesId: data.question_id
	            }));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/save-notes', Object.assign({}, data, {
	
	              notesId: data.question_id
	            }));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function saveQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/unsave-notes', Object.assign({}, data, {
	              notesId: data.question_id
	            }));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var fetchNotesStats = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/save-stats', { notesId: data.id });
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function fetchNotesStats(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var saveNotesStats = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/save-stats', { notesId: data.id });
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveNotesStats(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var reportQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/report-notes', Object.assign({
	              notesId: data.questionId
	            }, data));
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function reportQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchNotes: fetchNotes,
	  fetchSavedQuestion: fetchSavedQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  saveQuestion: saveQuestion,
	  fetchNotesStats: fetchNotesStats,
	  saveNotesStats: saveNotesStats,
	  reportQuestion: reportQuestion
	};

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardFooter = __webpack_require__(251);
	
	var _CardFooter2 = _interopRequireDefault(_CardFooter);
	
	var _CustomCard = __webpack_require__(252);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	var _notes_icon = __webpack_require__(198);
	
	var _notes_icon2 = _interopRequireDefault(_notes_icon);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _CardBlockLoaderWrapper = __webpack_require__(261);
	
	var _CardBlockLoaderWrapper2 = _interopRequireDefault(_CardBlockLoaderWrapper);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ApiAttributesKays = __webpack_require__(603);
	
	var _ApiService = __webpack_require__(604);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _function = __webpack_require__(10);
	
	var _aiTutorContext = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var ViewNotes = function (_Component) {
	  _inherits(ViewNotes, _Component);
	
	  function ViewNotes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewNotes);
	
	    var _this = _possibleConstructorReturn(this, (ViewNotes.__proto__ || Object.getPrototypeOf(ViewNotes)).call(this, props));
	
	    _this.onSetCurrentNote = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(notesData) {
	        var _this$props$params, notesId, readingId, index;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props$params = _this.props.params, notesId = _this$props$params.notesId, readingId = _this$props$params.readingId;
	                index = void 0;
	
	                if (notesId !== ':notesId') {
	                  index = notesData.findIndex(function (item) {
	                    return item[_ApiAttributesKays.notesIdKey] === parseInt(notesId, 10);
	                  });
	                  _this.setState({ currentIndex: index });
	                } else {
	                  index = notesData.findIndex(function (item) {
	                    return item[_ApiAttributesKays.notesReadingIdKey] === parseInt(readingId, 10);
	                  });
	                  index = index === -1 ? 0 : index;
	                  _this.setState({ currentIndex: index });
	                }
	                // tell the AI Tutor which note the student is viewing (context bar + grounding)
	                _this.dispatchAiContext(notesData[index]);
	                _this.setState({ isLoading: false });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.buildAiContext = function (note) {
	      return {
	        exam: 'CFA1',
	        exam_year: (0, _aiTutorContext.aiTutorExamYear)(), // 2026/2027 from the header's selected exam; null when unknown
	        page_url: (0, _aiTutorContext.aiTutorPageUrl)(),
	        page_type: 'note',
	        content_id: note && note[_ApiAttributesKays.notesIdKey],
	        title: note && note[_ApiAttributesKays.notesNameKey] ? note[_ApiAttributesKays.notesNameKey] + ' (N. ' + note[_ApiAttributesKays.notesIdKey] + ')' : 'CFA Level I',
	        // reading/chapter names (from the all-notes response) — extra KB grounding + analytics
	        reading: _this._readingName || '',
	        chapter: _this._chapterName || '',
	        // the note text itself — the strongest grounding signal; postTitle names the concept
	        stem: note ? (0, _aiTutorContext.aiTutorStem)((note.postTitle ? note.postTitle + '. ' : '') + (note[_ApiAttributesKays.descriptionKey] || '')) : ''
	      };
	    };
	
	    _this.dispatchAiContext = function (note) {
	      if (!note) return;
	      (0, _aiTutorContext.dispatchAiTutorContext)(_this.buildAiContext(note));
	    };
	
	    _this.askAiAboutNote = function () {
	      var _this$state = _this.state,
	          notesList = _this$state.notesList,
	          currentIndex = _this$state.currentIndex;
	
	      var note = notesList[currentIndex];
	      if (!note) return;
	      (0, _aiTutorContext.dispatchAiTutorExplain)({
	        context: _this.buildAiContext(note),
	        message: 'Explain this note in simple terms'
	      });
	    };
	
	    _this.resetStates = function () {
	      _this.setState({
	        showAnswer: false,
	        showReportSection: false,
	        selectedChoice: '',
	        stopTimer: false
	      });
	    };
	
	    _this.replaceRoute = function (index) {
	      var notesList = _this.state.notesList;
	      var _this$props$params2 = _this.props.params,
	          readingId = _this$props$params2.readingId,
	          chapterId = _this$props$params2.chapterId,
	          notesId = _this$props$params2.notesId,
	          level = _this$props$params2.level;
	      var router = _this.context.router;
	
	
	      var id = notesList[index] ? notesList[index].id : notesId;
	
	      router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_VIEW).replace(':level', level).replace(':readingId', readingId).replace(':chapterId', chapterId).replace(':notesId', id)
	      });
	      _this.setState({ currentIndex: index, currentNoteObj: notesList[index] });
	      _this.dispatchAiContext(notesList[index]);
	    };
	
	    _this.getPreviousQuestion = function () {
	      var currentIndex = _this.state.currentIndex;
	
	      if (parseInt(currentIndex, 10) > 0) {
	        _this.replaceRoute(currentIndex - 1);
	        _this.resetStates();
	      }
	    };
	
	    _this.getNextQuestion = function () {
	      var _this$state2 = _this.state,
	          notesList = _this$state2.notesList,
	          currentIndex = _this$state2.currentIndex;
	
	      var index = parseInt(currentIndex, 10) + 1;
	      if (index < notesList.length) {
	        _this.replaceRoute(index);
	        _this.resetStates();
	      }
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.hideReportSection = function () {
	      _this.setState({ showReportSection: false });
	    };
	
	    _this.state = {
	      isLoading: true,
	      notesList: [],
	      currentNoteObj: {},
	      isFlashCardHidden: true
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(ViewNotes, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props$params, level, readingId, chapterId, result, notes;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props$params = this.props.params, level = _props$params.level, readingId = _props$params.readingId, chapterId = _props$params.chapterId;
	                _context2.next = 3;
	                return _ApiService2.default['fetchNotes']({ level: level, readingId: readingId, chapterId: chapterId });
	
	              case 3:
	                result = _context2.sent;
	
	                if (!result.success) {
	                  _context2.next = 11;
	                  break;
	                }
	
	                notes = result.notes;
	                // reading/chapter names ride along in the all-notes response — kept for AI Tutor grounding
	
	                this._readingName = result.reading && result.reading.readingName || '';
	                this._chapterName = result.chapterName && result.chapterName.chapterName || '';
	                this.setState({ isLoading: false, notesList: notes });
	                _context2.next = 11;
	                return this.onSetCurrentNote(notes);
	
	              case 11:
	                this.setState({ isLoading: false });
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // leaving the notes view → drop stale AI Tutor context
	      (0, _aiTutorContext.clearAiTutorContext)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          notesList = _state.notesList,
	          currentIndex = _state.currentIndex,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          showReportSection = _state.showReportSection;
	      var _props$params2 = this.props.params,
	          chapterId = _props$params2.chapterId,
	          readingId = _props$params2.readingId;
	      var router = this.context.router;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row col-sm-12 d-block' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.NOTES, className: 'note-section notes_inner_title_wrap ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex flex-wrap align-items-center', style: { gap: 8, marginLeft: 'auto', justifyContent: 'flex-end' } },
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_LIST).replace(':chapterId', chapterId).replace(':readingId', readingId),
	                    state: notesList.length && { notesList: notesList }
	                  });
	                }
	              },
	              _messages.messages.CHANGE_NOTES
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_READING_LIST).replace(':chapterId', chapterId),
	                    state: notesList.length && { notesList: notesList }
	                  });
	                }
	              },
	              _messages.messages.CHANGE_READING
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: this.askAiAboutNote, btnColor: 'ai', style: _aiTutorContext.AI_TRIGGER_BTN_STYLE, className: 'ap-ai-launcher' },
	              '\u2726 Ask AI about this note'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _CustomCard2.default,
	            { className: 'special_notes_view', style: isLoading && { height: '800px' } },
	            _react2.default.createElement(_CardBlockLoaderWrapper2.default, { isLoading: isLoading }),
	            currentIndex >= 0 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headerClassName: 'sticky-header',
	                navigateButtonClassName: 'sticky-navigate',
	                headingText: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesNameKey] + ' (N. ' + notesList[currentIndex][_ApiAttributesKays.notesIdKey] + ')',
	                showPreviousButton: true,
	                showNextButton: true,
	                headerImage: _notes_icon2.default,
	                arrayLength: notesList.length,
	                disabledPreviousButton: currentIndex < 1,
	                disabledNextButton: !(currentIndex < notesList.length - 1),
	                getPreviousQuestion: this.getPreviousQuestion,
	                getNextQuestion: this.getNextQuestion
	              }),
	              (0, _function.renderHTMLContent)(notesList.length && notesList[currentIndex][_ApiAttributesKays.descriptionKey], "div", "mt-3"),
	              _react2.default.createElement(_CardFooter2.default, {
	                isLoading: isLoading,
	                savePayLoad: {
	                  question_id: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey]
	                },
	                favItemId: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey],
	                setChildRef: this.childRef,
	                apiServiceProvider: _ApiService2.default,
	                onSaveItemChange: this.onSaveItemChange,
	                toggleReportSection: this.toggleReportSection
	              })
	            ) : _react2.default.createElement(
	              'h1',
	              { className: 'text-center pt-3 pb-3' },
	              !isLoading && _messages.messages.NO_DATA_FOUND
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 note-section p-0' },
	          currentIndex >= 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey] },
	              type: 'notes',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa1_2024'
	            }),
	            showReportSection && _react2.default.createElement(_ReportCard2.default, {
	              hideReportSection: this.hideReportSection,
	              apiServiceProvider: _ApiService2.default,
	              itemId: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey],
	              keyId: 'questionId'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ViewNotes;
	}(_react.Component);
	
	ViewNotes.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ViewNotes;

/***/ },
/* 606 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  readingNameKey: 'name',
	  readingIdKay: 'readingId',
	  questionIdKey: 'id',
	  descriptionKey: 'description',
	  isAttemptedKey: 'cfa1_2024_notes_stats.answer_status' //*The key is associated with another table, which is why we cannot modify it.
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchNotes = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/notes/all-notes', Object.assign({}, data));
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchNotes(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	module.exports = { fetchNotes: fetchNotes };

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ViewCard = __webpack_require__(172);
	
	var _ViewCard2 = _interopRequireDefault(_ViewCard);
	
	var _notes_icon = __webpack_require__(198);
	
	var _notes_icon2 = _interopRequireDefault(_notes_icon);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ApiAttributesKeys = __webpack_require__(606);
	
	var _ApiService = __webpack_require__(607);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var NotesList = function (_Component) {
	  _inherits(NotesList, _Component);
	
	  function NotesList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, NotesList);
	
	    var _this = _possibleConstructorReturn(this, (NotesList.__proto__ || Object.getPrototypeOf(NotesList)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var state, listData, _this$props$params, readingId, chapterId, response, notes, _response$selectedExa, selectedExamSubscriptionDetails, reading, _selectedExamSubscrip, level1SubscriptionDetails, isSubscribed, isLevel1Chapter, router;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              state = _this.props.location.state;
	
	              if (!(state && state.listData && state.listData.length)) {
	                _context.next = 7;
	                break;
	              }
	
	              listData = state.listData;
	
	              _this.setState({ listData: listData });
	              _context.next = 12;
	              break;
	
	            case 7:
	              _this$props$params = _this.props.params, readingId = _this$props$params.readingId, chapterId = _this$props$params.chapterId;
	              _context.next = 10;
	              return _ApiService2.default['fetchNotes']({ readingId: readingId, chapterId: chapterId });
	
	            case 10:
	              response = _context.sent;
	
	              if (response.success) {
	                notes = response.notes, _response$selectedExa = response.selectedExamSubscriptionDetails, selectedExamSubscriptionDetails = _response$selectedExa === undefined ? {} : _response$selectedExa, reading = response.reading;
	                _selectedExamSubscrip = selectedExamSubscriptionDetails.level1SubscriptionDetails, level1SubscriptionDetails = _selectedExamSubscrip === undefined ? {} : _selectedExamSubscrip;
	                isSubscribed = level1SubscriptionDetails && level1SubscriptionDetails.noteStatus;
	                isLevel1Chapter = parseInt(chapterId, 10) === 1;
	
	
	                if (isSubscribed || isLevel1Chapter) {
	                  _this.setState({
	                    listData: notes,
	                    readingName: reading && reading.readingName,
	                    isUserSubscribed: Boolean(Object.keys(selectedExamSubscriptionDetails).length > 0 && isSubscribed)
	                  });
	                } else {
	                  router = _this.context.router;
	
	                  router.push({ pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES) });
	                  (0, _toast.showInformation)(_messages.messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER);
	                }
	              }
	
	            case 12:
	              _this.setState({ isLoading: false });
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.redirectToNotes = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var _this$state, listData, isUserSubscribed, router;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state = _this.state, listData = _this$state.listData, isUserSubscribed = _this$state.isUserSubscribed;
	                router = _this.context.router;
	
	                router.push({
	                  pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_VIEW).replace(':readingId', data[_ApiAttributesKeys.readingIdKay]).replace(':notesId', data[_ApiAttributesKeys.questionIdKey]).replace(':chapterId', data[_ApiAttributesKeys.chapterIdKey]),
	                  state: { questionData: listData, isUserSubscribed: isUserSubscribed }
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      listData: [],
	      questionStatsTableName: '',
	      isLoading: true,
	      isUserSubscribed: false,
	      pdfAlert: false
	    };
	    return _this;
	  }
	  //* ===========================> {{ COMPONENT DID MOUNT START HERE }} <=====================================
	
	  //* ===========================> {{ COMPONENT DID MOUNT ENDED HERE }} <=====================================
	
	  _createClass(NotesList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          listData = _state.listData,
	          isLoading = _state.isLoading,
	          isUserSubscribed = _state.isUserSubscribed,
	          openPremiumPopup = _state.openPremiumPopup,
	          pdfAlert = _state.pdfAlert,
	          readingName = _state.readingName;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: readingName },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_READING_LIST).replace(':chapterId', listData.length && listData[0][_ApiAttributesKeys.chapterIdKey])
	                  });
	                }
	              },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            listData.length > 0 ? listData.map(function (item) {
	              return (
	                // the note title is the admin "Name" field as-is (no auto-generated "LOS N" prefix)
	                _react2.default.createElement(
	                  _ViewCard2.default,
	                  {
	                    headerIcon: _notes_icon2.default,
	                    headerContent: (item[_ApiAttributesKeys.readingNameKey].length > 50 ? item[_ApiAttributesKeys.readingNameKey].slice(0, 70) : item[_ApiAttributesKeys.readingNameKey]) + ' (N. ' + item[_ApiAttributesKeys.questionIdKey] + ')',
	                    bodyContent: item[_ApiAttributesKeys.descriptionKey],
	                    key: item.id,
	                    onClick: function onClick() {
	                      return _this3.redirectToNotes(item);
	                    }
	                  },
	                  item[_ApiAttributesKeys.isAttemptedKey] ? _react2.default.createElement(
	                    'div',
	                    { id: 'answered_status' },
	                    _messages.messages.READ
	                  ) : _react2.default.createElement(
	                    'div',
	                    { id: 'notanswered_status' },
	                    _messages.messages.UNREAD
	                  )
	                )
	              );
	            }) : _react2.default.createElement(
	              'h1',
	              null,
	              'No Data Found'
	            ),
	            !isUserSubscribed && _react2.default.createElement(
	              _ViewCard2.default,
	              {
	                headerIcon: _notes_icon2.default,
	                headerContent: _messages.messages.SUBSCRIBE_PRACTICE_QUESTION.replace('numberOfQuestion', '2,000'),
	                bodyContent: _messages.messages.CFA1_2025_PREMIUM_POPUP,
	                paddingBox: 'padding_box_free'
	              },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                {
	                  className: 'text-center d-block mx-auto',
	                  onClick: function onClick() {
	                    return router.push({ pathname: _AppRoutes2.default.SUBSCRIBE });
	                  }
	                },
	                'Subscribe'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP,
	          exam: 'cfa'
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Question',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: pdfAlert,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return NotesList;
	}(_react.Component);
	
	NotesList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = NotesList;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Notes = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _notes_icon = __webpack_require__(301);
	
	var _notes_icon2 = _interopRequireDefault(_notes_icon);
	
	var _ChapterCards = __webpack_require__(134);
	
	var _ChapterCards2 = _interopRequireDefault(_ChapterCards);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ApiAttributesKays = __webpack_require__(598);
	
	var _ApiService = __webpack_require__(599);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Notes = exports.Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var state;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              state = _this.props.location.state;
	
	              if (!(state && state.chapterData)) {
	                _this.getChapterWiseCount();
	              } else {
	                _this.setState(Object.assign({}, state, { isLoading: false }));
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getChapterWiseCount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _ref3, data, selectedExamSubscriptionDetails, success, level1SubscriptionDetails;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return _ApiService2.default['fetchChaptersWithPremiumAndFreeCount']();
	
	            case 3:
	              _ref3 = _context2.sent;
	              data = _ref3.data;
	              selectedExamSubscriptionDetails = _ref3.selectedExamSubscriptionDetails;
	              success = _ref3.success;
	
	              if (success && data && selectedExamSubscriptionDetails) {
	                level1SubscriptionDetails = selectedExamSubscriptionDetails.level1SubscriptionDetails;
	
	                _this.setState({
	                  chapterData: data,
	                  isUserSubscribed: level1SubscriptionDetails && level1SubscriptionDetails.noteStatus,
	                  isAdditionalResourceSheetavailable: level1SubscriptionDetails && Object.keys(level1SubscriptionDetails).length // it makes Ratio and Formula sheet available for all levels of CFA Level I packages
	                });
	              }
	              _context2.next = 13;
	              break;
	
	            case 10:
	              _context2.prev = 10;
	              _context2.t0 = _context2['catch'](0);
	
	              console.error("getChapterWiseCount error", _context2.t0);
	
	            case 13:
	              _context2.prev = 13;
	
	              setTimeout(function () {
	                return _this.setState({ isLoading: false });
	              }, 500);
	              return _context2.finish(13);
	
	            case 16:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[0, 10, 13, 16]]);
	    }));
	    _this.redirectToLastNoteRead = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var result, data, router, selectedExam, noteAlias, lastNote;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this.setState({ isLastReadNoteButtonDisable: true });
	              _context3.next = 3;
	              return _ApiService2.default['fetchLastNoteRead']();
	
	            case 3:
	              result = _context3.sent;
	
	              _this.setState({ isLastReadNoteButtonDisable: false });
	
	              //* FIRST OF ALL CHECK THE REDIRECTION
	              if (result.success) {
	                data = result.data;
	                router = _this.context.router;
	                // The last-read note comes back under the per-year association alias
	                // (cfa1_2025_note for 2025/2026, cfa1_2027_note for 2027). tableKey is hardcoded to
	                // the 2025 alias, so for 2027 data[tableKey] was undefined and the redirect threw,
	                // leaving the button stuck. Resolve the alias for the selected exam.
	
	                selectedExam = localStorage.getItem('selectedmenu');
	                noteAlias = selectedExam === 'cfa_2027' ? 'cfa1_2027_note' : _ApiAttributesKays.tableKey;
	                lastNote = data && data[noteAlias];
	
	                if (lastNote) {
	                  router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_VIEW).replace(':readingId', lastNote[_ApiAttributesKays.readingIdKey]).replace(':notesId', lastNote.id).replace(':chapterId', lastNote[_ApiAttributesKays.tableChapterKey])
	                  });
	                } else {
	                  (0, _toast.showInformation)(_messages.messages.NOTES_NOT_AVAILABLE);
	                }
	              } else {
	                (0, _toast.showInformation)(_messages.messages.NOTES_NOT_AVAILABLE);
	              }
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.onPdfDownloadDropDownToggle = function () {
	      _this.setState({
	        isPdfDownloadDropdownOpen: !_this.state.isPdfDownloadDropdownOpen
	      });
	    };
	
	    _this.onHandleDownloadSheet = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(type) {
	        var exam, result;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                // 2027 (/cfa1/2027/...) has its own Additional Resources set; every other CFA1 edition
	                // shares 'cfa_1'. isNextPath() reads the URL, so the same reused component picks the right one.
	                exam = (0, _cfa1NextRoutes.isNextPath)() ? 'cfa_2027' : 'cfa_1';
	                _context4.next = 3;
	                return _ApiService2.default['fetchAdditionalResourcesPdf']({ exam: exam, type: type });
	
	              case 3:
	                result = _context4.sent;
	
	                if (result.success) {
	                  (0, _function.openPDF)(result);
	                } else {
	                  (0, _toast.showInformation)(_messages.messages.SHEET_NOT_AVAILABLE.replace(':sheet', type));
	                }
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      chapterId: '',
	      questionId: '',
	      isLoading: true,
	      isLastReadNoteButtonDisable: false,
	      isPdfDownloadDropdownOpen: false,
	      isUserSubscribed: false,
	      openPremiumPopup: false,
	      chapterData: [],
	      isAdditionalResourceSheetavailable: false
	    };
	    return _this;
	  }
	  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
	
	  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
	
	  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================
	
	  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
	
	
	  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================
	
	  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
	
	  //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================
	
	  _createClass(Notes, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state,
	          context = this.context;
	      var imageWidth = state.imageWidth,
	          isLoading = state.isLoading,
	          openPremiumPopup = state.openPremiumPopup,
	          chapterData = state.chapterData,
	          isUserSubscribed = state.isUserSubscribed,
	          isLastReadNoteButtonDisable = state.isLastReadNoteButtonDisable,
	          isPdfDownloadDropdownOpen = state.isPdfDownloadDropdownOpen,
	          isAdditionalResourceSheetavailable = state.isAdditionalResourceSheetavailable;
	      var router = context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.NOTES },
	          _react2.default.createElement(
	            'div',
	            { className: 'ml-auto' },
	            _react2.default.createElement(
	              _reactstrap.ButtonDropdown,
	              {
	                isOpen: isPdfDownloadDropdownOpen,
	                toggle: function toggle() {
	                  return isAdditionalResourceSheetavailable ? _this3.onPdfDownloadDropDownToggle() : _this3.toggleAlert();
	                }
	              },
	              _react2.default.createElement(
	                _reactstrap.DropdownToggle,
	                {
	                  className: 'btn btn-primary overflow-hidden pointer_class tooltip_wrap',
	                  caret: true
	                },
	                !isAdditionalResourceSheetavailable && _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  'Premium'
	                ),
	                _messages.messages.ADDITIONAL_RESOURCES
	              ),
	              _react2.default.createElement(
	                _reactstrap.DropdownMenu,
	                { right: true },
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  {
	                    value: 'public',
	                    onClick: function onClick() {
	                      _this3.onHandleDownloadSheet('Ratio sheet');
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	                  _messages.messages.RATIO_SHEET
	                ),
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  {
	                    value: 'private',
	                    onClick: function onClick() {
	                      _this3.onHandleDownloadSheet('Formula sheet');
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	                  _messages.messages.FORMULA_SHEET
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: function onClick() {
	                return _this3.redirectToLastNoteRead();
	              },
	              disabled: isLastReadNoteButtonDisable
	            },
	            isLastReadNoteButtonDisable && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	            _messages.messages.GO_TO_MY_LAST_READ_NOTE
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'seperator-block-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    chapterData.length > 0 && chapterData.map(function (item, index) {
	                      return _react2.default.createElement(_ChapterCards2.default, Object.assign({
	                        onClick: function onClick() {
	                          return isUserSubscribed || index === 0 ? router.push({
	                            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_READING_LIST).replace(':chapterId', item[_ApiAttributesKays.chapterIdKey]),
	                            state: { chapterData: chapterData }
	                          }) : _this3.toggleAlert();
	                        },
	                        key: item[_ApiAttributesKays.chapterIdKey],
	                        chapterOrder: index + 1,
	                        headerImage: _notes_icon2.default,
	                        headerImageWidth: imageWidth,
	                        chapterNumber: item[_ApiAttributesKays.chapterIdKey],
	                        chapterName: item[_ApiAttributesKays.chapterNameKay],
	                        totalNotes: item[_ApiAttributesKays.totalNotesKey],
	                        totalReadings: item[_ApiAttributesKays.totalReadingKey],
	                        userSubscriptionDetails: isUserSubscribed,
	                        callingComponent: 'notes',
	                        free: index === 0
	                      }, _this3.props));
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _messages.messages.CFA1_PREMIUM_POPUP
	        })
	      );
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	Notes.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = Notes;

/***/ },
/* 610 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  chapterNameKay: 'chapterName',
	  totalReadingKey: 'totalReading',
	  freeQuestionsCountKey: 'totalFreeQuestions',
	  premiumQuestionsCountKey: 'totalQuestions',
	  questionTableKey: 'question',
	  readingIdKey: 'reading_id_2025', //*The key is associated with another table, which is why we cannot modify it.
	  chapterOrderKey: 'chapterOrder'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getChaptersWithPremiumAndFreeCount = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/chapter-wise-count', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getChaptersWithPremiumAndFreeCount(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchLastAnsweredQuestion = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/last-answered-question', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchLastAnsweredQuestion() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	module.exports = {
	  getChaptersWithPremiumAndFreeCount: getChaptersWithPremiumAndFreeCount,
	  fetchLastAnsweredQuestion: fetchLastAnsweredQuestion
	};

/***/ },
/* 612 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  readingNameKey: 'readingName',
	  freeQuestionCountKey: 'totalFreeQuestion',
	  TotalQuestionCountKey: 'totalQuestion',
	  chapterIdKey: 'chapterId',
	  chapterNameKey: 'chapter_name', //* The key is associated with another table, which is why we cannot modify it.
	  chapterOrderKey: 'chapter_order'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchReadingList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/reading', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchReadingList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var pdfDownloadViaEmail = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/pdf-download', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchReadingList: fetchReadingList,
	  pdfDownloadViaEmail: pdfDownloadViaEmail
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReadingList = __webpack_require__(135);
	
	var _ReadingList2 = _interopRequireDefault(_ReadingList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _ApiAttributesKeys = __webpack_require__(612);
	
	var _ApiService = __webpack_require__(613);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var ReadingsList = function (_Component) {
	  _inherits(ReadingsList, _Component);
	
	  function ReadingsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ReadingsList);
	
	    var _this = _possibleConstructorReturn(this, (ReadingsList.__proto__ || Object.getPrototypeOf(ReadingsList)).call(this, props));
	
	    _this.checkSubscription = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cb, type) {
	        var isUserSubscribed, response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                isUserSubscribed = _this.state.isUserSubscribed;
	
	                if (isUserSubscribed) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt('return', _this.setState({ isPremiumPopupOpen: true }));
	
	              case 3:
	                _context.next = 5;
	                return cb();
	
	              case 5:
	                response = _context.sent;
	
	                if (response && response.success) {
	                  _this.setState({ PDFDownloadType: type });
	                  _this.pdfAlertModel();
	                } else {
	                  (0, _toast.showInformation)(response && response.message || _messages.messages.PDF_DOWNLOAD_NOT_AVAILABLE);
	                }
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onHandleRedirectTOSubscription = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ isPremiumPopupOpen: !_this.state.isPremiumPopupOpen });
	    };
	
	    _this.pdfAlertModel = function () {
	      _this.setState({ isPopupOpen: !_this.state.isPopupOpen });
	    };
	
	    _this.onViewList = function (items) {
	      var isUserSubscribed = _this.state.isUserSubscribed;
	
	      if (items.totalQuestion) {
	        if (!isUserSubscribed) {
	          if (items[_ApiAttributesKeys.freeQuestionCountKey] === 0) {
	            (0, _toast.showInformation)(_messages.messages.QUESTION_NOT_AVAILABLE_FOR_READING);
	          } else if (items[_ApiAttributesKeys.freeQuestionCountKey] !== 0) {
	            var router = _this.context.router;
	
	            router.push({
	              pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTIONS_LIST).replace(':readingId', items.id)
	            });
	          } else {
	            return _this.setState({ isPremiumPopupOpen: true });
	          }
	        } else {
	          var _router = _this.context.router;
	
	          _router.push({
	            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTIONS_LIST).replace(':readingId', items.id)
	          });
	        }
	      } else {
	        (0, _toast.showInformation)(_messages.messages.QUESTION_NOT_AVAILABLE_FOR_READING);
	      }
	    };
	
	    _this.onBeginChapter = function (items) {
	      var isUserSubscribed = _this.state.isUserSubscribed;
	
	      if (items.totalQuestion) {
	        if (!isUserSubscribed) {
	          if (items[_ApiAttributesKeys.freeQuestionCountKey] === 0) {
	            (0, _toast.showInformation)(_messages.messages.QUESTION_NOT_AVAILABLE_FOR_READING);
	          } else if (items[_ApiAttributesKeys.freeQuestionCountKey] !== 0) {
	            var router = _this.context.router;
	
	            router.push({
	              pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTIONS_LIST).replace(':readingId', items.id)
	            });
	          } else {
	            return _this.setState({ isPremiumPopupOpen: true });
	          }
	        } else {
	          var _router2 = _this.context.router;
	
	          _router2.push({
	            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_VIEW).replace(':readingId', items.id)
	          });
	        }
	      } else {
	        (0, _toast.showInformation)(_messages.messages.QUESTION_NOT_AVAILABLE_FOR_READING);
	      }
	    };
	
	    _this.state = {
	      selectedExamSubscriptionDetails: {},
	      chapterName: '',
	      chapterOrder: 0,
	      isPopupOpen: false,
	      isPremiumPopupOpen: false,
	      isUserSubscribed: false,
	      readingListData: [],
	      isLoading: true
	    };
	    return _this;
	  }
	
	  _createClass(ReadingsList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var chapterId, readingListData, readings, selectedExamSubscriptionDetails;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chapterId = this.props.params.chapterId;
	                _context2.next = 3;
	                return _ApiService2.default['fetchReadingList']({ chapterId: chapterId });
	
	              case 3:
	                readingListData = _context2.sent;
	
	                if (readingListData.success) {
	                  readings = readingListData.readings, selectedExamSubscriptionDetails = readingListData.selectedExamSubscriptionDetails;
	
	                  if (selectedExamSubscriptionDetails.level1SubscriptionDetails) {
	                    this.setState({ isUserSubscribed: true });
	                  }
	                  this.setState({
	                    readingListData: readings,
	                    selectedExamSubscriptionDetails: selectedExamSubscriptionDetails,
	                    isLoading: false,
	                    chapterName: readingListData.chapterName[_ApiAttributesKeys.chapterNameKey],
	                    chapterOrder: readingListData.chapterName[_ApiAttributesKeys.chapterOrderKey]
	                  });
	                }
	                this.setState({ isLoading: false });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var params = this.props.params;
	      var chapterId = params.chapterId;
	      var _state = this.state,
	          chapterName = _state.chapterName,
	          chapterOrder = _state.chapterOrder,
	          isPopupOpen = _state.isPopupOpen,
	          isPremiumPopupOpen = _state.isPremiumPopupOpen,
	          isUserSubscribed = _state.isUserSubscribed,
	          readingListData = _state.readingListData,
	          _state$isLoading = _state.isLoading,
	          isLoading = _state$isLoading === undefined ? false : _state$isLoading;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: (chapterOrder !== 0 ? chapterOrder + '.' : '') + ' ' + chapterName },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return _ApiService2.default['pdfDownloadViaEmail']({
	                      pdfType: 'question',
	                      chapterId: chapterId
	                    });
	                  }, 'Question');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download pr-1', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _messages.messages.DOWNLOAD_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return _ApiService2.default['pdfDownloadViaEmail']({
	                      pdfType: 'questionAnswer',
	                      chapterId: chapterId
	                    });
	                  }, 'Question/Answer');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download pr-1', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _messages.messages.DOWNLOAD_QUESTION_ANSWER
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return router.push({ pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_BANK) });
	                } },
	              _messages.messages.CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(_ReadingList2.default, {
	            readingData: readingListData,
	            tableName: _messages.messages.CHAPTER_READING,
	            onViewList: this.onViewList,
	            onBeginChapter: this.onBeginChapter
	          })
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.onHandleRedirectTOSubscription,
	          toggleAlert: this.toggleAlert,
	          alert_status: isPremiumPopupOpen,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP,
	          exam: 'cfa'
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Question',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: isPopupOpen,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return ReadingsList;
	}(_react.Component);
	
	ReadingsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ReadingsList;

/***/ },
/* 615 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  readingNameKey: 'name',
	  correctChoiceKey: 'right_choice',
	  readingIdKay: 'readingId',
	  readingIdParamsKey: 'readingId',
	  questionIdKey: 'id',
	  questionIdParamsKey: 'questionId',
	  answerKey: 'answer',
	  questionKey: 'question',
	  isAttemptedKey: 'isAttempted'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var saveQuestionAttemptStats = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    var _data$questionId, questionId, _data$rightAnswer, rightAnswer, _data$timeDone, timeDone, _data$selectedChoice, selectedChoice;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _data$questionId = data.questionId, questionId = _data$questionId === undefined ? '' : _data$questionId, _data$rightAnswer = data.rightAnswer, rightAnswer = _data$rightAnswer === undefined ? '' : _data$rightAnswer, _data$timeDone = data.timeDone, timeDone = _data$timeDone === undefined ? '' : _data$timeDone, _data$selectedChoice = data.selectedChoice, selectedChoice = _data$selectedChoice === undefined ? '' : _data$selectedChoice;
	            _context.next = 3;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/save-stats', {
	              questionId: questionId,
	              rightAnswer: rightAnswer,
	              timeDone: timeDone,
	              selectedChoice: selectedChoice
	            });
	
	          case 3:
	            return _context.abrupt('return', _context.sent);
	
	          case 4:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function saveQuestionAttemptStats(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var fetchSavedQuestion = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    var _data$question_id, question_id;
	
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _data$question_id = data.question_id, question_id = _data$question_id === undefined ? '' : _data$question_id;
	            _context2.next = 3;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/save-question', {
	              questionId: question_id
	            });
	
	          case 3:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 4:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    var question_id;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            question_id = data.question_id;
	            _context3.next = 3;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/save-question', {
	              questionId: question_id
	            });
	
	          case 3:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 4:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function saveQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    var _data$question_id2, question_id;
	
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _data$question_id2 = data.question_id, question_id = _data$question_id2 === undefined ? '' : _data$question_id2;
	            _context4.next = 3;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/un-save-question', {
	              questionId: question_id
	            });
	
	          case 3:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 4:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var fetchQuestionsReadingWise = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/all-questions', data);
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function fetchQuestionsReadingWise(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var reportQuestion = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    var _data$question_id3, question_id, _data$comment, comment;
	
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _data$question_id3 = data.question_id, question_id = _data$question_id3 === undefined ? '' : _data$question_id3, _data$comment = data.comment, comment = _data$comment === undefined ? '' : _data$comment;
	            _context6.next = 3;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/report-question', {
	              questionId: question_id,
	              comment: comment
	            });
	
	          case 3:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 4:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function reportQuestion(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	module.exports = {
	  saveQuestionAttemptStats: saveQuestionAttemptStats,
	  fetchQuestionsReadingWise: fetchQuestionsReadingWise,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  reportQuestion: reportQuestion
	};

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _QuestionBankFooter = __webpack_require__(253);
	
	var _QuestionBankFooter2 = _interopRequireDefault(_QuestionBankFooter);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	var _index = __webpack_require__(171);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _ApiAttributesKeys = __webpack_require__(615);
	
	var _ApiService = __webpack_require__(616);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _function = __webpack_require__(10);
	
	var _constant = __webpack_require__(9);
	
	var _aiTutorContext = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var QuestionView = function (_Component) {
	  _inherits(QuestionView, _Component);
	
	  function QuestionView(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionView);
	
	    var _this = _possibleConstructorReturn(this, (QuestionView.__proto__ || Object.getPrototypeOf(QuestionView)).call(this, props));
	
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	
	    _this.updateState = function (updates) {
	      _this.setState(function (prevState) {
	        return Object.assign({}, prevState, updates);
	      });
	    };
	
	    _this.fetchQuestions = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var readingId, response, questions, selectedExamSubscriptionDetails, isSubscribed, questionsToShow;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              readingId = _this.props.params.readingId;
	              _context.prev = 1;
	              _context.next = 4;
	              return _ApiService2.default.fetchQuestionsReadingWise({ readingId: readingId });
	
	            case 4:
	              response = _context.sent;
	
	              if (!(response && response.success)) {
	                _context.next = 13;
	                break;
	              }
	
	              questions = response.questions, selectedExamSubscriptionDetails = response.selectedExamSubscriptionDetails;
	              // chapter name rides along in the all-questions response — kept for AI Tutor grounding
	
	              _this._chapterName = response.chapterName && response.chapterName.chapterName || '';
	              isSubscribed = selectedExamSubscriptionDetails && selectedExamSubscriptionDetails.level1SubscriptionDetails;
	              questionsToShow = isSubscribed ? questions : questions.filter(function (question) {
	                return parseInt(question.free, 10) === 1;
	              });
	              _context.next = 12;
	              return _this.initializeQuestionState(questionsToShow);
	
	            case 12:
	              _this.updateState({
	                questionData: questionsToShow,
	                isLoading: false,
	                isUserSubscribed: isSubscribed
	              });
	
	            case 13:
	              _context.next = 18;
	              break;
	
	            case 15:
	              _context.prev = 15;
	              _context.t0 = _context['catch'](1);
	
	              _this.updateState({ isLoading: false });
	
	            case 18:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 15]]);
	    }));
	
	    _this.initializeQuestionState = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(questionsData) {
	        var questionId, index, currentQuestion, _this$getUserAnswerSt, selectedChoice, showAnswer, stopTimer, timeDone;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.updateState({ isLoading: true });
	                questionId = _this.props.params.questionId;
	                index = questionId ? questionsData.findIndex(function (item) {
	                  return String(item[_ApiAttributesKeys.questionIdKey]) === String(questionId);
	                }) : 0;
	                currentQuestion = questionsData[Math.max(0, index)];
	
	                if (currentQuestion) {
	                  _context2.next = 7;
	                  break;
	                }
	
	                _this.updateState({ isLoading: false });
	                return _context2.abrupt('return');
	
	              case 7:
	                _this$getUserAnswerSt = _this.getUserAnswerState(currentQuestion), selectedChoice = _this$getUserAnswerSt.selectedChoice, showAnswer = _this$getUserAnswerSt.showAnswer, stopTimer = _this$getUserAnswerSt.stopTimer, timeDone = _this$getUserAnswerSt.timeDone;
	
	                _this.timerValue = timeDone;
	
	                _this.updateState({
	                  selectedChoice: selectedChoice,
	                  stopTimer: stopTimer,
	                  showAnswer: showAnswer,
	                  currentIndex: Math.max(0, index),
	                  currentQuestion: currentQuestion,
	                  isLoading: false
	                });
	                // tell the AI Tutor which item the student is viewing (context bar + grounding) —
	                // answer state passed explicitly: this.state isn't committed yet in this batch
	                _this.dispatchAiContext(currentQuestion, { selectedChoice: selectedChoice, showAnswer: showAnswer });
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.buildAiItem = function (q, selectedChoice) {
	      return {
	        questionId: q[_ApiAttributesKeys.questionIdKey],
	        stem: q[_ApiAttributesKeys.questionKey],
	        chosen: selectedChoice,
	        chosen_text: (0, _aiTutorContext.aiTutorStem)(q[selectedChoice], 300),
	        correct: q[_ApiAttributesKeys.correctChoiceKey],
	        correct_text: (0, _aiTutorContext.aiTutorStem)(q[q[_ApiAttributesKeys.correctChoiceKey]], 300),
	        topic: q.name,
	        chapterId: q[_ApiAttributesKeys.chapterIdKey]
	      };
	    };
	
	    _this.buildAiContext = function (q, answer) {
	      // answer state passed explicitly by callers inside setState batches (this.state is
	      // stale there); falls back to current state for direct calls
	      var a = answer || { selectedChoice: _this.state.selectedChoice, showAnswer: _this.state.showAnswer };
	      var context = {
	        exam: 'CFA1',
	        exam_year: (0, _aiTutorContext.aiTutorExamYear)(), // 2026/2027 from the header's selected exam; null when unknown
	        page_url: (0, _aiTutorContext.aiTutorPageUrl)(),
	        page_type: 'question',
	        content_id: q && q[_ApiAttributesKeys.questionIdKey],
	        title: q && q.name ? q.name + ' (Q. ' + q[_ApiAttributesKeys.questionIdKey] + ')' : 'CFA Level I',
	        // `name` on the question row IS the reading name (e.g. "Natural Resources");
	        // chapter name comes from the all-questions response (added server-side for the tutor)
	        reading: q && q.name || '',
	        chapter: _this._chapterName || '',
	        // the actual question text — the strongest grounding signal for KB retrieval
	        // (the title alone, e.g. "Rate and Return", is too generic)
	        stem: q && q[_ApiAttributesKeys.questionKey] ? String(q[_ApiAttributesKeys.questionKey]).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 400) : ''
	      };
	      // Once ANSWERED, the full item rides inside the context — so a sidebar-opened chat or a
	      // typed "explain my answer" knows the question AND the student's choice (not just the
	      // on-card ✦ button). Refreshed on every dispatch → always the current question.
	      if (q && a.showAnswer && a.selectedChoice) {
	        context.item = _this.buildAiItem(q, a.selectedChoice);
	      }
	      return context;
	    };
	
	    _this.dispatchAiContext = function (q, answer) {
	      if (!q) return;
	      var context = _this.buildAiContext(q, answer);
	      try {
	        // global = read by the tutor when opened from the sidebar (timing-proof);
	        // event = live-update the context bar while the tutor is already open.
	        window.__aiTutorContext = context;
	        window.dispatchEvent(new CustomEvent('aitutor:context', { detail: { context: context } }));
	      } catch (e) {/* noop */}
	    };
	
	    _this.explainMyAnswer = function () {
	      var _this$state = _this.state,
	          currentQuestion = _this$state.currentQuestion,
	          selectedChoice = _this$state.selectedChoice;
	
	      if (!currentQuestion) return;
	      try {
	        window.dispatchEvent(new CustomEvent('aitutor:explain', { detail: {
	            context: _this.buildAiContext(currentQuestion),
	            item: _this.buildAiItem(currentQuestion, selectedChoice),
	            message: 'Explain my answer'
	          } }));
	      } catch (e) {/* noop */}
	    };
	
	    _this.getUserAnswerState = function (question) {
	      var selectedChoice = question["question_stats.selected_choice"] || '';
	      var rightAnswer = question["question_stats.right_answer"] || '';
	      var answerStatus = question["question_stats.answer_status"] || '';
	      var timeDone = parseInt(question["question_stats.time_done"] || 0, 10);
	
	      var showAnswer = false;
	      var selected = '';
	      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_1);
	
	      if (selectedChoice && isRevisionMode) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (answerStatus && isRevisionMode) {
	        if (rightAnswer === 1) {
	          selected = question[_ApiAttributesKeys.correctChoiceKey];
	          showAnswer = true;
	        } else if (!rightAnswer) {
	          var correct = question[_ApiAttributesKeys.correctChoiceKey];
	          var choices = Object.keys(question).filter(function (key) {
	            return key.startsWith('choice') && key !== correct;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	
	      return {
	        selectedChoice: selected,
	        showAnswer: showAnswer,
	        stopTimer: !!selected,
	        timeDone: timeDone
	      };
	    };
	
	    _this.navigateToQuestion = function (newIndex) {
	      var questionData = _this.state.questionData;
	      var readingId = _this.props.params.readingId;
	      var router = _this.context.router;
	
	
	      var questionId = questionData[newIndex] && questionData[newIndex].id;
	      if (questionId) {
	        router.push({
	          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_VIEW).replace(':readingId', readingId).replace(':questionId', questionId)
	        });
	      }
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state2, currentIndex, questionData;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state2 = _this.state, currentIndex = _this$state2.currentIndex, questionData = _this$state2.questionData;
	
	              if (!(currentIndex > 0)) {
	                _context3.next = 6;
	                break;
	              }
	
	              _context3.next = 4;
	              return _this.initializeQuestionState(questionData);
	
	            case 4:
	              _this.setState({ showReportSection: false });
	              _this.navigateToQuestion(currentIndex - 1);
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state3, currentIndex, questionData;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state3 = _this.state, currentIndex = _this$state3.currentIndex, questionData = _this$state3.questionData;
	
	              if (!(currentIndex < questionData.length - 1)) {
	                _context4.next = 6;
	                break;
	              }
	
	              _context4.next = 4;
	              return _this.initializeQuestionState(questionData);
	
	            case 4:
	              _this.setState({ showReportSection: false });
	              _this.navigateToQuestion(currentIndex + 1);
	
	            case 6:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	    _this.validateQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var _this$state4, selectedChoice, questionData, currentIndex, currentQuestion, isCorrect, data, result, _Object$assign, updatedQuestionData;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this$state4 = _this.state, selectedChoice = _this$state4.selectedChoice, questionData = _this$state4.questionData, currentIndex = _this$state4.currentIndex;
	
	              if (selectedChoice) {
	                _context5.next = 3;
	                break;
	              }
	
	              return _context5.abrupt('return');
	
	            case 3:
	              currentQuestion = questionData[currentIndex];
	              isCorrect = currentQuestion && currentQuestion[_ApiAttributesKeys.correctChoiceKey] === selectedChoice;
	              _context5.prev = 5;
	              data = {
	                timeDone: _this.timerValue,
	                questionId: currentQuestion && currentQuestion[_ApiAttributesKeys.questionIdKey],
	                rightAnswer: isCorrect ? 1 : 0,
	                selectedChoice: selectedChoice
	              };
	              _context5.next = 9;
	              return _ApiService2.default.saveQuestionAttemptStats(data);
	
	            case 9:
	              result = _context5.sent;
	
	
	              if (result && result.success) {
	                (0, _toast.showSuccess)(_messages.messages.QUESTION_STATS_SAVED);
	                updatedQuestionData = [].concat(_toConsumableArray(questionData));
	
	                updatedQuestionData[currentIndex] = Object.assign({}, currentQuestion, (_Object$assign = {}, _defineProperty(_Object$assign, 'question_stats.selected_choice', selectedChoice), _defineProperty(_Object$assign, 'question_stats.time_done', _this.timerValue), _defineProperty(_Object$assign, 'question_stats.answer_status', result.answer_status || 0), _defineProperty(_Object$assign, 'question_stats.id', result.id || currentQuestion["question_stats.id"]), _defineProperty(_Object$assign, 'question_stats.right_answer', isCorrect ? 1 : 0), _Object$assign));
	
	                _this.updateState({
	                  stopTimer: true,
	                  showAnswer: true,
	                  questionData: updatedQuestionData,
	                  currentQuestion: updatedQuestionData[currentIndex]
	                });
	                // the student just answered → republish the AI Tutor context WITH the item, so a
	                // sidebar-opened chat / typed "explain my answer" knows the question + their choice
	                _this.dispatchAiContext(updatedQuestionData[currentIndex], { selectedChoice: selectedChoice, showAnswer: true });
	              }
	              _context5.next = 15;
	              break;
	
	            case 13:
	              _context5.prev = 13;
	              _context5.t0 = _context5['catch'](5);
	
	            case 15:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2, [[5, 13]]);
	    }));
	
	    _this.setAnswer = function (answer) {
	      _this.updateState({ selectedChoice: answer[0] });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.updateState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      _this.setState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.getTimerValue = function (timerValue) {
	      _this.timerValue = timerValue;
	    };
	
	    _this.hideReportSection = function () {
	      _this.updateState({ showReportSection: false });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isUserSubscribed: false,
	      currentIndex: 0,
	      currentQuestion: {},
	      showAnswer: false,
	      stopTimer: false,
	      selectedChoice: '',
	      isFlashCardHidden: true,
	      questionData: [],
	      showReportSection: false
	    };
	    _this.childRef = null;
	    _this.timerValue = 0;
	    return _this;
	  }
	
	  _createClass(QuestionView, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var state, questionData;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                state = this.props.location.state;
	
	                if (!(state && state.questionData && state.questionData.length)) {
	                  _context6.next = 9;
	                  break;
	                }
	
	                questionData = state.questionData;
	                // fetchQuestions is skipped on this path — take the chapter name from router state
	                // (passed by QuestionsList), else the AI Tutor context would have an empty chapter
	
	                this._chapterName = state.chapterName || '';
	                this.updateState({ questionData: questionData, isLoading: false });
	                _context6.next = 7;
	                return this.initializeQuestionState(questionData);
	
	              case 7:
	                _context6.next = 11;
	                break;
	
	              case 9:
	                _context6.next = 11;
	                return this.fetchQuestions();
	
	              case 11:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // leaving the question view → drop stale AI Tutor context
	      (0, _aiTutorContext.clearAiTutorContext)();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(prevProps) {
	        var questionId, prevQuestionId;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                questionId = this.props.params.questionId;
	                prevQuestionId = prevProps.params.questionId;
	
	                if (!(questionId !== prevQuestionId && this.state.questionData.length > 0)) {
	                  _context7.next = 5;
	                  break;
	                }
	
	                _context7.next = 5;
	                return this.initializeQuestionState(this.state.questionData);
	
	              case 5:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidUpdate(_x2) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	
	    // The full question payload ("explain my answer" grounding). Keys ('choice_b') identify
	    // the option; *_text carries what the student actually saw — without it the model is
	    // told "your answer: choice_b" and explains blind.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          showAnswer = _state.showAnswer,
	          selectedChoice = _state.selectedChoice,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          stopTimer = _state.stopTimer,
	          showReportSection = _state.showReportSection;
	      var readingId = this.props.params.readingId;
	      var router = this.context.router;
	
	
	      var isValidateDisabled = !selectedChoice || !!showAnswer;
	
	      var timeDone = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_1) && currentQuestion && currentQuestion["question_stats.time_done"] ? parseInt(currentQuestion["question_stats.time_done"], 10) : 0;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1',
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTIONS_LIST).replace(':readingId', readingId)
	                  });
	                }
	              },
	              _messages.messages.CHANGE_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST).replace(':chapterId', currentQuestion && currentQuestion[_ApiAttributesKeys.chapterIdKey])
	                  });
	                }
	              },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            currentQuestion && Object.keys(currentQuestion).length > 0 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: currentQuestion.name + ' (Q. ' + currentQuestion.id + ')',
	                showPreviousButton: true,
	                showNextButton: true,
	                headerImage: _question_icon_blue2.default,
	                arrayLength: questionData.length,
	                disabledPreviousButton: currentIndex < 1,
	                disabledNextButton: !(currentIndex < questionData.length - 1),
	                getPreviousQuestion: this.getPreviousQuestion,
	                getNextQuestion: this.getNextQuestion
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 9, xs: 12 },
	                    _react2.default.createElement(
	                      _ViewQuestion2.default,
	                      Object.assign({}, currentQuestion, this.props, {
	                        setAnswer: this.setAnswer,
	                        showAnswer: showAnswer,
	                        correctChoice: currentQuestion && currentQuestion[_ApiAttributesKeys.correctChoiceKey],
	                        selectedChoice: selectedChoice
	                      }),
	                      _react2.default.createElement(_QuestionBankFooter2.default, {
	                        savePayLoad: {
	                          question_id: currentQuestion && currentQuestion[_ApiAttributesKeys.questionIdKey]
	                        },
	                        validateQuestion: this.validateQuestion,
	                        favItemId: currentQuestion && currentQuestion.id,
	                        setChildRef: this.setChildRef,
	                        apiServiceProvider: _ApiService2.default,
	                        onSaveItemChange: this.onSaveItemChange,
	                        toggleReportSection: this.toggleReportSection,
	                        disabled: isValidateDisabled
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 3, xs: 12 },
	                    _react2.default.createElement(_index2.default, {
	                      getTimerValue: this.getTimerValue,
	                      stopTimer: stopTimer,
	                      shouldFetchFromServer: true,
	                      key: currentQuestion && currentQuestion.id,
	                      initialTime: timeDone
	                    })
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'h1',
	              { className: 'text-center pt-3 pb-3' },
	              _messages.messages.NO_DATA_FOUND
	            )
	          )
	        ),
	        showAnswer && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: selectedChoice === (currentQuestion && currentQuestion[_ApiAttributesKeys.correctChoiceKey]) ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                headerImage: '',
	                className: 'text-uppercase ' + (selectedChoice === (currentQuestion && currentQuestion[_ApiAttributesKeys.correctChoiceKey]) ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mb-2' },
	                  _react2.default.createElement(
	                    _CustomButton2.default,
	                    { onClick: this.explainMyAnswer, btnColor: 'ai', style: _aiTutorContext.AI_TRIGGER_BTN_STYLE, className: 'ap-ai-launcher' },
	                    '\u2726 Explain my answer'
	                  )
	                ),
	                (0, _function.renderHTMLContent)(currentQuestion && currentQuestion[_ApiAttributesKeys.answerKey], "span")
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: currentQuestion,
	          type: 'question',
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: 'cfa1_2024'
	        }),
	        showReportSection && _react2.default.createElement(_ReportCard2.default, {
	          hideReportSection: this.hideReportSection,
	          apiServiceProvider: _ApiService2.default,
	          itemId: currentQuestion && currentQuestion[_ApiAttributesKeys.questionIdKey],
	          keyId: 'question_id'
	        })
	      );
	    }
	  }]);
	
	  return QuestionView;
	}(_react.Component);
	
	QuestionView.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionView;

/***/ },
/* 618 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  readingNameKey: 'name',
	  readingIdKay: 'readingId',
	  questionIdKey: 'id',
	  questionKey: 'question',
	  // Edition-stable key emitted by the backend for all CFA1 years (2026 → cfa1_2024_question_stats,
	  // 2027 → cfa1_2027_question_stats are both copied into `question_stats.*`). See services/CFA/question.js.
	  isAttemptedKey: 'question_stats.answer_status'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchQuestionsChapterWise = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/question-bank/all-questions', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchQuestionsChapterWise(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	module.exports = { fetchQuestionsChapterWise: fetchQuestionsChapterWise };

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ViewCard = __webpack_require__(172);
	
	var _ViewCard2 = _interopRequireDefault(_ViewCard);
	
	var _question_iconBlu = __webpack_require__(303);
	
	var _question_iconBlu2 = _interopRequireDefault(_question_iconBlu);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _ApiAttributesKeys = __webpack_require__(618);
	
	var _ApiService = __webpack_require__(619);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/* eslint-disable*/
	
	var QuestionsList = function (_Component) {
	  _inherits(QuestionsList, _Component);
	
	  function QuestionsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionsList);
	
	    var _this = _possibleConstructorReturn(this, (QuestionsList.__proto__ || Object.getPrototypeOf(QuestionsList)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var state, listData, readingId, response, questions, selectedExamSubscriptionDetails, freeQuestionsList;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              state = _this.props.location.state;
	
	              if (!(state && state.listData && state.listData.length)) {
	                _context.next = 8;
	                break;
	              }
	
	              listData = state.listData;
	
	              _this._chapterName = state && state.chapterName || '';
	              _this.setState({ listData: listData });
	              _context.next = 13;
	              break;
	
	            case 8:
	              readingId = _this.props.params.readingId;
	              _context.next = 11;
	              return _ApiService2.default['fetchQuestionsChapterWise']({ readingId: readingId });
	
	            case 11:
	              response = _context.sent;
	
	              if (response.success) {
	                questions = response.questions, selectedExamSubscriptionDetails = response.selectedExamSubscriptionDetails;
	                // chapter name rides along in the all-questions response — passed to QuestionView
	                // via router state (QuestionView skips its own fetch when state is present)
	
	                _this._chapterName = response.chapterName && response.chapterName.chapterName || '';
	                if (selectedExamSubscriptionDetails.level1SubscriptionDetails) {
	                  _this.setState({
	                    listData: questions,
	                    selectedExamSubscriptionDetails: selectedExamSubscriptionDetails,
	                    isUserSubscribed: true
	                  });
	                } else {
	                  freeQuestionsList = questions.filter(function (question) {
	                    if (parseInt(question.free, 10) === 1) {
	                      return question;
	                    };
	                  });
	
	                  _this.setState({
	                    listData: freeQuestionsList,
	                    selectedExamSubscriptionDetails: selectedExamSubscriptionDetails
	                  });
	                }
	              }
	
	            case 13:
	              _this.setState({ isLoading: false });
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.redirectToQuestion = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var _this$state, listData, selectedExamSubscriptionDetails, router;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state = _this.state, listData = _this$state.listData, selectedExamSubscriptionDetails = _this$state.selectedExamSubscriptionDetails;
	                router = _this.context.router;
	
	                router.push({
	                  pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_VIEW).replace(':readingId', data[_ApiAttributesKeys.readingIdKay]).replace(':questionId', data[_ApiAttributesKeys.questionIdKey]),
	                  state: { questionData: listData, selectedExamSubscriptionDetails: selectedExamSubscriptionDetails, chapterName: _this._chapterName || '' }
	                });
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      listData: [],
	      questionStatsTableName: '',
	      isLoading: true,
	      chapterName: '',
	      selectedExamSubscriptionDetails: {},
	      isUserSubscribed: false,
	      pdfAlert: false
	    };
	    return _this;
	  }
	  //* ===========================> {{ COMPONENT DID MOUNT START HERE }} <=====================================
	
	  //* ===========================> {{ COMPONENT DID MOUNT ENDED HERE }} <=====================================
	
	  _createClass(QuestionsList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          listData = _state.listData,
	          isLoading = _state.isLoading,
	          isUserSubscribed = _state.isUserSubscribed,
	          openPremiumPopup = _state.openPremiumPopup,
	          pdfAlert = _state.pdfAlert;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: listData.length > 0 && listData[0][_ApiAttributesKeys.readingNameKey] },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST).replace(':chapterId', listData.length && listData[0][_ApiAttributesKeys.chapterIdKey])
	                  });
	                }
	              },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            listData.length > 0 ? listData.map(function (item) {
	              return _react2.default.createElement(
	                _ViewCard2.default,
	                {
	                  headerIcon: _question_iconBlu2.default,
	                  headerContent: item[_ApiAttributesKeys.readingNameKey] + ' (Q. ' + item[_ApiAttributesKeys.questionIdKey] + ')',
	                  bodyContent: item[_ApiAttributesKeys.questionKey],
	                  key: item.id,
	                  onClick: function onClick() {
	                    return _this3.redirectToQuestion(item);
	                  }
	                },
	                item[_ApiAttributesKeys.isAttemptedKey] ? _react2.default.createElement(
	                  'div',
	                  { id: 'answered_status' },
	                  'Answered'
	                ) : _react2.default.createElement(
	                  'div',
	                  { id: 'notanswered_status' },
	                  'Not Answered '
	                )
	              );
	            }) : _react2.default.createElement(
	              'h1',
	              null,
	              'No Data Found'
	            ),
	            !isUserSubscribed && _react2.default.createElement(
	              _ViewCard2.default,
	              {
	                headerIcon: _question_iconBlu2.default,
	                headerContent: _messages.messages.SUBSCRIBE_PRACTICE_QUESTION.replace('numberOfQuestion', '2,000'),
	                bodyContent: _messages.messages.CFA1_2025_PREMIUM_POPUP,
	                paddingBox: 'padding_box_free'
	              },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                {
	                  className: 'text-center d-block mx-auto',
	                  onClick: function onClick() {
	                    return router.push({ pathname: _AppRoutes2.default.SUBSCRIBE });
	                  }
	                },
	                'Subscribe'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP,
	          exam: 'cfa'
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Question',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: pdfAlert,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return QuestionsList;
	}(_react.Component);
	
	QuestionsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionsList;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuestionBank = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _icon = __webpack_require__(302);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _ChapterCards = __webpack_require__(134);
	
	var _ChapterCards2 = _interopRequireDefault(_ChapterCards);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _ApiAttributesKeys = __webpack_require__(610);
	
	var _ApiService = __webpack_require__(611);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var QuestionBank = exports.QuestionBank = function (_Component) {
	  _inherits(QuestionBank, _Component);
	
	  function QuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (QuestionBank.__proto__ || Object.getPrototypeOf(QuestionBank)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.getChapterWiseCount();
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getChapterWiseCount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var result;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return _ApiService2.default['getChaptersWithPremiumAndFreeCount']();
	
	            case 2:
	              result = _context2.sent;
	
	              if (result.success) {
	                _this.setState({
	                  isLoading: false,
	                  chapterData: result.data ? result.data : [] //* we will uncomment when api is ready
	                });
	              }
	              _this.setState({ isLoading: false });
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.onHandleLastAttemptedQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var result, data, router;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this.setState({ isLastAttemptButtonDisable: true });
	              _context3.next = 3;
	              return _ApiService2.default['fetchLastAnsweredQuestion']();
	
	            case 3:
	              result = _context3.sent;
	
	              _this.setState({ isLastAttemptButtonDisable: false });
	
	              //* FIRST OF ALL CHECK THE REDIRECTION
	              if (result.success) {
	                data = result.data;
	                router = _this.context.router;
	
	                if (data) {
	                  router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_VIEW).replace(':readingId', data[_ApiAttributesKeys.questionTableKey][_ApiAttributesKeys.readingIdKey]).replace(':questionId', data[_ApiAttributesKeys.questionTableKey].id)
	                  });
	                } else {
	                  (0, _toast.showInformation)(_messages.messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
	                }
	              } else {
	                (0, _toast.showInformation)(_messages.messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
	              }
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.state = {
	      chapterId: '',
	      questionId: '',
	      isLoading: true,
	      isLastAttemptButtonDisable: false,
	      chapterData: [],
	      selectedExamSubscriptionDetails: {}
	    };
	    return _this;
	  }
	  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
	
	  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
	
	  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================
	
	  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
	
	
	  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================
	
	  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
	
	
	  _createClass(QuestionBank, [{
	    key: 'render',
	
	    //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state,
	          context = this.context;
	      var isLoading = state.isLoading,
	          chapterData = state.chapterData,
	          isLastAttemptButtonDisable = state.isLastAttemptButtonDisable;
	      var router = context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK },
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.CFA_1 }),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: function onClick() {
	                return _this3.onHandleLastAttemptedQuestion();
	              },
	              disabled: isLastAttemptButtonDisable
	            },
	            isLastAttemptButtonDisable && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'seperator-block-wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    chapterData.length && chapterData.map(function (item) {
	                      return _react2.default.createElement(_ChapterCards2.default, Object.assign({
	                        onClick: function onClick() {
	                          return router.push({
	                            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST).replace(':chapterId', item[_ApiAttributesKeys.chapterIdKey]),
	                            state: { chapterData: chapterData }
	                          });
	                        },
	                        key: item[_ApiAttributesKeys.chapterIdKey],
	                        headerImage: _icon2.default,
	                        headerImageWidth: 55,
	                        chapterNumber: item[_ApiAttributesKeys.chapterOrderKey],
	                        chapterName: item[_ApiAttributesKeys.chapterNameKay],
	                        totalReadings: item[_ApiAttributesKeys.totalReadingKey],
	                        freeQuestionsCount: item[_ApiAttributesKeys.freeQuestionsCountKey],
	                        premiumQuestionsCount: item[_ApiAttributesKeys.premiumQuestionsCountKey]
	                      }, _this3.props));
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return QuestionBank;
	}(_react.Component);
	
	QuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionBank;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa1Subscription = __webpack_require__(142);
	
	var _Cfa1Subscription2 = _interopRequireDefault(_Cfa1Subscription);
	
	var _Cfa1Subscription3 = __webpack_require__(143);
	
	var _Cfa1Subscription4 = _interopRequireDefault(_Cfa1Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/* eslint-disable*/
	var BeforeStart = function (_Component) {
	  _inherits(BeforeStart, _Component);
	
	  function BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (BeforeStart.__proto__ || Object.getPrototypeOf(BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZZES),
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuizpage = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var final_exam, data;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              final_exam = [];
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context4.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context3.next = 12;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context3.next = 5;
	                            break;
	                          }
	
	                          _this.toggleAlert();
	                          _context3.next = 10;
	                          break;
	
	                        case 5:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context3.next = 10;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, examPlanData;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 11;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this.state.selectedmenu;
	                                      isInArray_var = false;
	                                      examPlanData = resp_exam.examPlan[0];
	                                      _context.next = 7;
	                                      return _Cfa1Subscription4.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                    case 7:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        _this.context.router.push({
	                                          pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEGIN).split('(')[0] + '/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                          state: {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            quiz_id: _this.state.quiz_id,
	                                            offset: _this.state.offset_send
	                                          }
	                                        });
	                                      } else {
	                                        _this.toggleAlert();
	                                      }
	                                      _context.next = 11;
	                                      break;
	
	                                    case 11:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this2);
	                            }));
	
	                            return function (_x2) {
	                              return _ref3.apply(this, arguments);
	                            };
	                          }()
	                          // console.log('fail');
	                          );
	
	                        case 10:
	                          _context3.next = 13;
	                          break;
	
	                        case 12:
	                          if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                            _this.toggleAlert();
	                          } else {
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _Cfa1Subscription2.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (isInArray_var) {
	                                          _this.context.router.push({
	                                            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEGIN).split('(')[0] + '/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                            state: {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              quiz_id: _this.state.quiz_id,
	                                              offset: _this.state.offset_send
	                                            }
	                                          });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context2.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	                          }
	
	                        case 13:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this._startQuizquestion = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(item, offset_va, e) {
	        var final_exam, data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                final_exam = [];
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 11;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context5.next = 7;
	                                        return _Cfa1Subscription4.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          _this.context.router.push({
	                                            pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEGIN).split('(')[0] + '/' + _this.state.quiz_id + '/' + offset_va,
	                                            state: {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              quiz_id: _this.state.quiz_id,
	                                              offset: offset_va
	                                            }
	                                          });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context5.next = 11;
	                                        break;
	
	                                      case 11:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context6.next = 13;
	                            break;
	
	                          case 12:
	                            if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this.toggleAlert();
	                            } else {
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _Cfa1Subscription2.default.checkCfa1Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    _this.context.router.push({
	                                      pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEGIN).split('(')[0] + '/' + _this.state.quiz_id + '/' + offset_va,
	                                      state: {
	                                        token: _this.state.token,
	                                        idname: _this.state.idname,
	                                        quiz_id: _this.state.quiz_id,
	                                        offset: offset_va
	                                      }
	                                    });
	                                  } else {
	                                    _this.toggleAlert();
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 13:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x4, _x5, _x6) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'cfa',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //Function to redirect page to Create Quiz page
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    //Function to redirect page to begin Quiz page
	
	
	    /*
	    ------------------------------------------------------
	        Function to redirect page to begin Quiz page
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	
	          var question_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	          }
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var all_question_id = this.state.all_question_id;
	      var question_id_display = '';
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                quiz_id: _this4.state.quiz_id,
	                answered_state: index
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  onClick: _this4._startQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	      var user_time = '';
	      var min,
	          sec = '';
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          ' ',
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          ' ',
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().QUIZ_ID,
	            ': ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().NO_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().CORRECT_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().WRONG_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/checkAnswered', data).then(function (resp) {
	    if (document.getElementById('questionNameId_' + props.answered_state) !== null) document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer === 1) {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_wrong_answered_status';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	      }
	    } else {
	      if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = BeforeStart;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _messages = __webpack_require__(14);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _aiTutorContext = __webpack_require__(93);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var BeginQuiz = function (_Component) {
	  _inherits(BeginQuiz, _Component);
	
	  function BeginQuiz(props) {
	    _classCallCheck(this, BeginQuiz);
	
	    var _this = _possibleConstructorReturn(this, (BeginQuiz.__proto__ || Object.getPrototypeOf(BeginQuiz)).call(this, props));
	
	    _this.hasTimerFeatureEnabled = function () {
	      var _this$state = _this.state,
	          include_timer = _this$state.include_timer,
	          timer_value = _this$state.timer_value;
	
	      return !!include_timer || timer_value && parseInt(timer_value, 10) > 0;
	    };
	
	    _this.reverseTimerHandler = function () {
	      _this.setState(function (prevState) {
	        var countValue = Number(prevState.count);
	
	        if (!Number.isFinite(countValue) || countValue <= 0) {
	          clearInterval(_this.timer);
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	          return { isTimerStopped: true };
	        }
	
	        var remainingTime = countValue - 1;
	
	        // Only make API call if timer is not stopped
	        if (!prevState.isTimerStopped) {
	          var insert_time = {
	            token: prevState.token,
	            idname: prevState.idname,
	            quiz_id: prevState.quiz_id,
	            user_time_value: remainingTime
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/insertTimer', insert_time);
	        }
	
	        return { count: remainingTime };
	      });
	    };
	
	    _this.fetchQuizData = function () {
	      var _this$state2 = _this.state,
	          token = _this$state2.token,
	          idname = _this$state2.idname,
	          quiz_id = _this$state2.quiz_id,
	          offset = _this$state2.offset;
	
	      var data = { idname: idname, token: token, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var quizData = JSON.parse(resp.singlequiz);
	          var questions = Object.values(quizData.all_questions);
	          var currentQuestionId = questions[offset];
	          var timerValue = Number(resp.timer_value) || 0;
	          var hasUserTimeValue = resp.user_time_value !== undefined && resp.user_time_value !== null;
	          var userTimeValue = hasUserTimeValue ? Number(resp.user_time_value) : timerValue;
	          var initialTimerValue = userTimeValue > 0 ? userTimeValue : timerValue;
	
	          _this.setState({
	            user_time_value: userTimeValue,
	            count: initialTimerValue > 0 ? initialTimerValue : 0,
	            timer_value: timerValue,
	            all_question_id: questions,
	            include_timer: resp.include_timer,
	            first_question_id: currentQuestionId
	          }, function () {
	            if (questions.length - 1 === offset) _this.setState({ next_block: 'card hide_block' });
	            if (currentQuestionId) _this.fetchQuestionDetails(currentQuestionId);else _this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.QUESTION_NOT_FOUND });
	          });
	        } else {
	          _this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.QUIZ_DATA_FETCH_ERROR });
	        }
	      }).catch(function (error) {
	        _this.setState({ display_loader: 'hide_block', already_answered_status: error.message || 'Failed to connect to server' });
	      });
	    };
	
	    _this.buildAiItem = function (q, selectedChoice) {
	      return {
	        questionId: q.id,
	        stem: q.question,
	        chosen: selectedChoice,
	        chosen_text: (0, _aiTutorContext.aiTutorStem)(q[selectedChoice], 300),
	        correct: q.right_choice,
	        correct_text: (0, _aiTutorContext.aiTutorStem)(q[q.right_choice], 300),
	        topic: q.name_2025 || q.name
	      };
	    };
	
	    _this.buildAiContext = function (q, answer) {
	      // answer state passed explicitly by callers inside setState batches (this.state is
	      // stale there); falls back to current state for direct calls.
	      var a = answer || { selectedChoice: _this.state.selectedChoice, showAnswer: _this.state.isAnswered };
	      var readingName = q && (q.name_2025 || q.name) || '';
	      var context = {
	        exam: 'CFA1',
	        exam_year: (0, _aiTutorContext.aiTutorExamYear)(),
	        page_url: (0, _aiTutorContext.aiTutorPageUrl)(),
	        page_type: 'quiz',
	        content_id: q && q.id,
	        title: q && readingName ? readingName + ' (Q. ' + q.id + ')' : 'CFA Level I',
	        reading: readingName,
	        chapter: q && q.chapterName || '', // resolved server-side in getQuestionsbyid
	        // the actual question text — the strongest KB grounding signal
	        stem: q && q.question ? String(q.question).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 400) : ''
	      };
	      if (q && a.showAnswer && a.selectedChoice) {
	        context.item = _this.buildAiItem(q, a.selectedChoice);
	      }
	      return context;
	    };
	
	    _this.dispatchAiContext = function (q, answer) {
	      if (!q || !q.id) return;
	      try {
	        var context = _this.buildAiContext(q, answer);
	        window.__aiTutorContext = context; // read by the sidebar-opened tutor (timing-proof)
	        window.dispatchEvent(new CustomEvent('aitutor:context', { detail: { context: context } }));
	      } catch (e) {/* noop */}
	    };
	
	    _this.explainMyAnswer = function () {
	      var q = _this.state.display_question;
	      var selectedChoice = _this.state.selectedChoice;
	
	      if (!q || !q.id) return;
	      try {
	        window.dispatchEvent(new CustomEvent('aitutor:explain', { detail: {
	            context: _this.buildAiContext(q, { selectedChoice: selectedChoice, showAnswer: true }),
	            item: _this.buildAiItem(q, selectedChoice),
	            message: 'Explain my answer'
	          } }));
	      } catch (e) {/* noop */}
	    };
	
	    _this.fetchQuestionDetails = function (question_id) {
	      var _this$state3 = _this.state,
	          token = _this$state3.token,
	          idname = _this$state3.idname,
	          quiz_id = _this$state3.quiz_id;
	
	      var questionDataPayload = { token: token, idname: idname, question_id: question_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/getQuestionsbyid', questionDataPayload).then(function (questionData) {
	        if (questionData.success) {
	          _this.setState({
	            display_question: questionData.questionsbyid,
	            correctChoice: questionData.questionsbyid.right_choice
	          });
	          var checkAnsweredData = { token: token, idname: idname, quiz_id: quiz_id, question_id: question_id };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/checkAnswered', checkAnsweredData).then(function (answeredResp) {
	            var questionResponse = answeredResp.question_recived || {};
	            var correctAnswer = questionData.questionsbyid.right_choice;
	            // Use helper for DRY
	
	            var _this$getUserAnswerSt = _this.getUserAnswerState(questionResponse, correctAnswer, questionData.questionsbyid),
	                selected = _this$getUserAnswerSt.selected,
	                showAnswer = _this$getUserAnswerSt.showAnswer;
	
	            _this.setState({
	              selectedChoice: selected,
	              isAnswered: !!selected,
	              validated: !!selected,
	              result_block: selected ? 'card show_block' : 'card hide_block',
	              textColor: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === correctAnswer ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	              display_loader: 'hide_block'
	            });
	            // Publish AI-tutor context for this question (fresh on every load / prev-next) —
	            // explicit answer state because setState above is async.
	            _this.dispatchAiContext(questionData.questionsbyid, { selectedChoice: selected, showAnswer: !!selected });
	            // Timer logic remains unchanged
	            var timerFeatureActive = _this.hasTimerFeatureEnabled();
	            if (selected) {
	              if (_this.timer) clearInterval(_this.timer);
	              _this.setState({ isTimerStopped: true });
	              localStorage.setItem('timer_stop', JSON.stringify(true));
	            } else {
	              if (timerFeatureActive && _this.state.count > 0) {
	                clearInterval(_this.timer);
	                _this.timer = setInterval(_this.reverseTimerHandler.bind(_this), 1000);
	                _this.setState({ isTimerStopped: false });
	                localStorage.setItem('timer_stop', JSON.stringify(false));
	              } else {
	                if (_this.timer) clearInterval(_this.timer);
	                _this.setState({ isTimerStopped: true });
	                if (!_this.state.count_end_message || timerFeatureActive && _this.state.count <= 0 && !_this.state.count_end_message) {
	                  localStorage.setItem('timer_stop', JSON.stringify(true));
	                }
	              }
	            }
	            // After setting question details, check if the question is bookmarked
	            var favParams = {
	              token: _this.state.token,
	              question_id: question_id,
	              idname: _this.state.idname
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/getFavQuestions', favParams).then(function (response) {
	              var isSaved = response.success;
	
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: isSaved ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: isSaved ? 'rgb(54, 141, 84)' : '',
	                save_text: isSaved ? _language2.default.LC().Question_Saved : _language2.default.LC().SAVE_QUESTION
	              });
	            });
	          }).catch(function (error) {
	            _this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.CHECK_ANSWERED_ERROR });
	          });
	        } else {
	          _this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.QUESTION_DETAILS_ERROR });
	        }
	      }).catch(function (error) {
	        _this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.QUESTION_API_ERROR });
	      });
	    };
	
	    _this.handleAnswerSelect = function (answerArray) {
	      var answer = answerArray[0];
	      if (!_this.state.isAnswered) {
	        if (_this.hasTimerFeatureEnabled() && !_this.state.isTimerStopped) {
	          clearInterval(_this.timer);
	          _this.setState({
	            isTimerStopped: true
	          });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	        }
	        _this.setState({ selectedChoice: answer });
	      }
	    };
	
	    _this.handleResultEvaluation = function (questionItem) {
	      var _this$state4 = _this.state,
	          selectedChoice = _this$state4.selectedChoice,
	          isAnswered = _this$state4.isAnswered,
	          token = _this$state4.token,
	          idname = _this$state4.idname,
	          quiz_id = _this$state4.quiz_id,
	          all_question_id = _this$state4.all_question_id,
	          offset = _this$state4.offset,
	          validated = _this$state4.validated;
	
	      if (selectedChoice && !isAnswered) {
	        if (_this.hasTimerFeatureEnabled() && !_this.state.isTimerStopped) {
	          clearInterval(_this.timer);
	          _this.setState({
	            isTimerStopped: true
	          });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	        }
	        var correctChoice = questionItem.right_choice;
	        var isCorrect = correctChoice === selectedChoice ? 1 : 0;
	        var resultText = isCorrect === 1 ? _messages.messages.CORRECT : _messages.messages.INCORRECT;
	        var textColor = isCorrect === 1 ? 'card-header text_success' : 'card-header text_failure';
	        _this.setState({
	          result_block: 'card show_block', isAnswered: true, result: resultText, textColor: textColor
	        });
	        // Now answered → re-publish context with the item embedded (grounds the sidebar/typed ask).
	        _this.dispatchAiContext(questionItem, { selectedChoice: selectedChoice, showAnswer: true });
	        if (!validated) {
	          var data = { token: token, idname: idname, quiz_id: quiz_id, question_id: all_question_id[offset], answer: isCorrect, selectedChoice: selectedChoice };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/answerQuiz', data).then(function (resp) {
	            if (resp.success) {
	              var questionsData = { token: token, idname: idname, question_id: all_question_id[offset], right_answer: isCorrect, time_done: 0 };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/saveStats', questionsData);
	            }
	            _this.setState({ isValidToken: resp.success, validated: true });
	          });
	        }
	      }
	    };
	
	    _this.navigateQuestion = function (offset) {
	      if (_this.timer) clearInterval(_this.timer);
	      _this.setState({
	        display_loader: 'show_block', validated: false, isAnswered: false, selectedChoice: '',
	        result_block: 'card hide_block', report_block: 'card hide_block',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark', bookmarkColor: '',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION, offset: offset,
	        previ_block: offset === 0 ? 'card hide_block' : '',
	        next_block: offset === _this.state.all_question_id.length - 1 ? 'card hide_block' : '',
	        count_end_message: ''
	      }, function () {
	        if (document.getElementById('comment')) document.getElementById('comment').value = '';
	        if (_this.state.all_question_id[offset]) {
	          _this.fetchQuestionDetails(_this.state.all_question_id[offset]);
	        } else {
	          _this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.QUESTION_NOT_FOUND });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      if (_this.state.offset < _this.state.all_question_id.length - 1) _this.navigateQuestion(_this.state.offset + 1);
	    };
	
	    _this._getPrevious = function () {
	      if (_this.state.offset > 0) _this.navigateQuestion(_this.state.offset - 1);
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      var apiEndpoint = _this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark' ? '/question_bank_2025/unsaveQuestion' : '/question_bank_2025/saveQuestion';
	
	      _fetchData2.default.callAPI('' + _App_data2.default.backend_api + apiEndpoint, data).then(function (resp) {
	        if (resp.success) {
	          var isUnsaveAction = apiEndpoint.includes('unsave');
	          _this.setState({
	            isValidToken: true,
	            bookmarkCSS: isUnsaveAction ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: isUnsaveAction ? '' : 'rgb(54, 141, 84)',
	            save_text: isUnsaveAction ? '' + _language2.default.LC().SAVE_QUESTION : '' + _language2.default.LC().Question_Saved
	          });
	        } else {
	          _this.setState({ isValidToken: false });
	        }
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment') ? document.getElementById('comment').value : '';
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ isValidToken: true, successAlert: true });
	          if (document.getElementById('comment')) document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ isValidToken: false });
	        }
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this.getToggleComment = function () {
	      _this.setState(function (prevState) {
	        return {
	          isCommentVisible: !prevState.isCommentVisible
	        };
	      });
	    };
	
	    _this.getToggleFlash = function () {
	      _this.setState(function (prevState) {
	        return {
	          isFlashCardVisible: !prevState.isFlashCardVisible
	        };
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      var flashCardInput = document.getElementById('flash_card');
	      if (!flashCardInput || flashCardInput.value === '') {
	        return;
	      }
	      var _this$state5 = _this.state,
	          token = _this$state5.token,
	          idname = _this$state5.idname,
	          quiz_id = _this$state5.quiz_id;
	
	      var flash_card = flashCardInput.value;
	      var data = {
	        token: token,
	        idname: idname,
	        question_id: item.id,
	        flash_card: flash_card,
	        quiz_id: quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ isValidToken: true });
	          flashCardInput.value = '';
	          _this.fetchFlashCards(item.id);
	        } else {
	          _this.setState({ isValidToken: false });
	        }
	      });
	    };
	
	    _this.fetchFlashCards = function (questionId) {
	      var params = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: questionId,
	        quiz_id: _this.state.quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/getFlashCards', params).then(function (response) {
	        var flash_cards_jsx = '';
	        if (response.success) {
	          _this.setState({ isValidToken: true });
	          if (response.flash_cards && response.flash_cards.length > 0) {
	            _this.setState({ flash_form: 'col-sm-12 hide_block' });
	            flash_cards_jsx = response.flash_cards.map(function (fc_item) {
	              return _react2.default.createElement(
	                'li',
	                { key: fc_item.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._editFlash.bind(_this, fc_item) },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        {
	                          className: 'pointer_class',
	                          onClick: _this._deleteFlash.bind(_this, fc_item)
	                        },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _this.state.flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      fc_item.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({ flash_form: 'col-sm-12 display_block' });
	            flash_cards_jsx = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	          }
	          _this.setState({ flash_data: flash_cards_jsx });
	        } else {
	          flash_cards_jsx = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ isValidToken: false, flash_data: flash_cards_jsx, flash_form: 'col-sm-12 display_block' });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-sm-12 display_block' });
	      var flashCardInput = document.getElementById('flash_card');
	      if (flashCardInput) {
	        flashCardInput.value = item.flash_card;
	      }
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ isValidToken: true, flash_form: 'col-sm-12 display_block' });
	          var flashCardInput = document.getElementById('flash_card');
	          if (flashCardInput) flashCardInput.value = '';
	          _this.setState({ flash_data: _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            ) });
	        } else {
	          _this.setState({ isValidToken: false });
	        }
	      });
	    };
	
	    _this._timer_funct = function () {
	      if (!_this.hasTimerFeatureEnabled()) return;
	      if (_this.state.isAnswered) return; // If question validated, do nothing.
	      // If time is up (message shown), button should be disabled, but this is a safeguard.
	      if (_this.state.count <= 0 && !!_this.state.count_end_message) return;
	
	      var newTimerStopState = !_this.state.isTimerStopped;
	      localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
	      _this.setState({
	        isTimerStopped: newTimerStopState
	      });
	
	      if (newTimerStopState) {
	        clearInterval(_this.timer);
	      } else {
	        // Only start if time is left AND no answer has been selected yet.
	        if (_this.state.count > 0 && !_this.state.selectedChoice) {
	          clearInterval(_this.timer);
	          _this.timer = setInterval(_this.reverseTimerHandler.bind(_this), 1000);
	        } else {
	          // If trying to "Play" but an answer is already selected, or time is 0, revert to stopped state.
	          _this.setState({
	            isTimerStopped: true
	          });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	          if (_this.timer) clearInterval(_this.timer);
	        }
	      }
	    };
	
	    _this._getSummary = function () {
	      var url = (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START).split('(')[0] + '/' + _this.state.quiz_id + '/abondon';
	      window.location.href = url;
	    };
	
	    var initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset, 10) : 0,
	      all_question_id: [],
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: {},
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      count: 0,
	      isValidToken: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      correctChoice: '',
	      isAnswered: false,
	      selectedChoice: '',
	      result: '',
	      textColor: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count_end_message: '',
	      isTimerStopped: initialTimerStop,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      already_answered_status: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      isFlashCardVisible: false,
	      isCommentVisible: false
	    };
	    _this.timer = null;
	    return _this;
	  }
	
	  _createClass(BeginQuiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	      (0, _aiTutorContext.clearAiTutorContext)(); // leaving the quiz → drop its AI-tutor context
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (parseInt(this.state.offset) === 0) this.setState({ previ_block: 'card hide_block' });
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        }, function () {
	          return _this2.fetchQuizData();
	        });
	      } else {
	        this.setState({ display_loader: 'hide_block', already_answered_status: _messages.messages.USER_SESSION_NOT_FOUND });
	      }
	    }
	  }, {
	    key: 'getUserAnswerState',
	
	
	    // Helper to extract answer/choice from API response for DRY
	    value: function getUserAnswerState(questionResponse, correctAnswer, questionsbyid) {
	      var selectedChoice = questionResponse.selected_choice || '';
	      var isRightChoice = questionResponse.answer || '';
	      var hasAnswerStatus = questionResponse.id || '';
	      var showAnswer = false;
	      var selected = '';
	      if (selectedChoice) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (hasAnswerStatus) {
	        if (isRightChoice === 1) {
	          selected = correctAnswer;
	          showAnswer = true;
	        } else if (!isRightChoice) {
	          // Pick any incorrect choice (not the correct one)
	          var choices = Object.keys(questionsbyid).filter(function (key) {
	            return key.startsWith('choice') && key !== correctAnswer;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	      return { selected: selected, showAnswer: showAnswer };
	    }
	
	    // ── AI Tutor "Explain my answer" (quiz surface) ──────────────────────────────────
	    // Mirrors QuestionBank/QuestionView: the full item (question + chosen/correct choice
	    // TEXTS) rides inside the published context once answered, so the sidebar chat and a
	    // typed "explain my answer" are grounded exactly like the on-card ✦ button.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.display_question || {};
	      var count_temp_var = this.state.count;
	      var display_time = '0 sec';
	      var isTimeUp = count_temp_var <= 0;
	
	      if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
	        if (count_temp_var < 60) {
	          display_time = count_temp_var + ' sec';
	        } else {
	          var minutes = Math.floor(count_temp_var / 60);
	          var seconds = count_temp_var % 60;
	          display_time = minutes + ' min ' + seconds + ' sec';
	        }
	      }
	
	      var isValidateDisabled = this.state.isAnswered || !this.state.selectedChoice;
	      var isTimerButtonDisabled = !this.hasTimerFeatureEnabled() || isTimeUp || this.state.isAnswered;
	
	      var timerButtonClass = this.state.isTimerStopped ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause';
	
	      var dataContent = null;
	      if (this.state.all_question_id.length > 0 && this.state.offset < this.state.all_question_id.length && Object.keys(questions).length > 0) {
	        dataContent = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg', className: 'margin_right_20', width: '30', alt: '' }),
	              _language2.default.LC().Q,
	              ' ',
	              parseInt(this.state.offset) + 1,
	              ' ',
	              (0, _function.renderHTMLContent)(questions.name_2025 || '', "span", "", { contentEditable: "false" }),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block, onClick: this._getPrevious, role: 'button', tabIndex: 0, onKeyPress: this._getPrevious, 'aria-label': 'Previous question' }),
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block, onClick: this._getNext, role: 'button', tabIndex: 0, onKeyPress: this._getNext, 'aria-label': 'Next question' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, questions, {
	                      setAnswer: this.handleAnswerSelect,
	                      showAnswer: this.state.isAnswered,
	                      correctChoice: this.state.correctChoice,
	                      selectedChoice: this.state.selectedChoice }),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          clicked: isValidateDisabled,
	                          _getResult: function _getResult() {
	                            return _this3.handleResultEvaluation(questions);
	                          },
	                          _saveQuestion: function _saveQuestion() {
	                            return _this3._saveQuestion(questions);
	                          },
	                          _displayReportForm: function _displayReportForm() {
	                            return _this3._displayReportForm(questions);
	                          },
	                          all_questions: questions,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor,
	                          showResult: this.state.isAnswered || !this.state.selectedChoice })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  this.hasTimerFeatureEnabled() && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'timer_outer' },
	                      _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                      !isTimeUp && _react2.default.createElement(
	                        'span',
	                        { className: 'timer_box' },
	                        display_time
	                      )
	                    ),
	                    !isTimeUp && _react2.default.createElement(
	                      'span',
	                      { className: 'quiz_timer_btn ' + this.state.timer_display },
	                      _react2.default.createElement('button', { type: 'button', 'aria-label': this.state.isTimerStopped ? 'Resume timer' : 'Pause timer', className: timerButtonClass, onClick: this._timer_funct, disabled: isTimerButtonDisabled })
	                    ),
	                    isTimeUp && _react2.default.createElement(
	                      'p',
	                      { className: 'text-danger' },
	                      (0, _function.renderHTMLContent)(_language2.default.LC().TIME_UP, "div", "", { contentEditable: "false" })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.state.isAnswered && this.state.result_block === 'card show_block' && _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.textColor },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _aiTutorContext.isAiTutorAvailable)() && _react2.default.createElement(
	                'div',
	                { className: 'mb-2' },
	                _react2.default.createElement(
	                  _CustomButton2.default,
	                  { onClick: this.explainMyAnswer, btnColor: 'ai', style: _aiTutorContext.AI_TRIGGER_BTN_STYLE, className: 'ap-ai-launcher' },
	                  '\u2726 Explain my answer'
	                )
	              ),
	              (0, _function.renderHTMLContent)(questions.answer || '', "div", "", { contentEditable: "false" })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _messages.messages.REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _messages.messages.COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: function onClick() {
	                        return _this3._reportQuestion(questions);
	                      }
	                    },
	                    _messages.messages.REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: function onClick() {
	                        return _this3._hideReportForm(questions);
	                      }
	                    },
	                    _messages.messages.CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _messages.messages.REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _messages.messages.CLOSE
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else if (this.state.display_loader === 'hide_block') {
	        dataContent = _react2.default.createElement(
	          'div',
	          null,
	          _messages.messages.QUIZ_FINISHED
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                ' ',
	                _language2.default.LC().QUIZ_ID,
	                ' : ',
	                this.state.quiz_id,
	                ' '
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'text-danger', role: this.state.already_answered_status ? 'status' : undefined },
	                this.state.already_answered_status
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                ' ',
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' ',
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              dataContent
	            ),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            ' ',
	            [].concat(_toConsumableArray(Array(12))).map(function (_, i) {
	              return _react2.default.createElement('div', { key: i, className: 'sk-circle' + (i + 1) + ' sk-child' });
	            }),
	            ' '
	          )
	        )
	      );
	    }
	  }]);
	
	  return BeginQuiz;
	}(_react.Component);
	
	// TooltipItem class remains the same
	
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this4 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this4.toggle = _this4.toggle.bind(_this4);
	    _this4.state = { tooltipOpen: false };
	    return _this4;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({ tooltipOpen: !this.state.tooltipOpen });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg', id: 'Tooltip-' + this.props.id, width: '18', alt: '', style: { marginLeft: '4px' } }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          { placement: this.props.place_tip, isOpen: this.state.tooltipOpen, target: 'Tooltip-' + this.props.id, toggle: this.toggle },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = BeginQuiz;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/* eslint-disable*/
	var Quizzes = function (_Component) {
	  _inherits(Quizzes, _Component);
	
	  function Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Quizzes.__proto__ || Object.getPrototypeOf(Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot == dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i == dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    _this.setState({ display_loader: 'hide_block' });
	                    (0, _toast.showFailure)(resp.message);
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	
	      // console.log(this.state.all_checked_state);
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          //console.log(i+'----------'+checkboxes[i].value);
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 4;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      token: '',
	      idname: '',
	      chapters: '',
	      all_checked_state: true,
	      radio_checked_question: 0,
	      deleteItemId: '',
	      radio_checked_priority: 'none',
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2025/getChapters', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ ValidToken: true });
	          _this3.setState({ chapters: resp.chapters });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	
	      this.abandonedQuizzes(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        // console.log(resp_quiz_length.quiz_length);
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this3.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	  }, {
	    key: '_createQuiz',
	
	
	    /*_changeIncludetimer(){
	      if(this.state.include_timer)
	      {
	        this.setState({ include_timer:!this.state.include_timer });
	      }
	      else{
	        this.setState({ include_timer:!this.state.include_timer });
	      }    	
	    }*/
	
	    /*_changeSaveresult(){
	      if(this.state.save_results)
	      {
	        this.setState({ save_results:!this.state.save_results });
	      }
	      else{
	        this.setState({ save_results:!this.state.save_results });
	      }    
	    }*/
	
	    value: function _createQuiz() {
	      var _this4 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      var question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	      var timer_value,
	          chapterAll = '';
	      timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	      if (this.state.all_checked_state) {
	        // console.log('if	 working')
	        var dataString = JSON.stringify(this.state.chapters);
	        var dataReason = JSON.parse(dataString);
	        var chapterall_id = [];
	        for (var i = 0; i < dataReason.length; i++) {
	          chapterall_id.push(dataReason[i].id);
	        }
	
	        chapterAll = chapterall_id;
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          chapterAll: chapterAll,
	          questionquize: question_length_val,
	          priority: this.state.radio_checked_priority
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getQuizequestion', data).then(function (resp) {
	          if (resp.success) {
	            var retun_all_chapter = JSON.stringify(resp.chapters);
	            var chapterParse = JSON.parse(retun_all_chapter);
	            var question_id = [];
	            var myJson = { question_count: '', all_questions: {} };
	            for (var i = 0; i < chapterParse.length; i++) {
	              var objName = 'q' + i;
	              var objValue = chapterParse[i].id;
	              myJson.all_questions[i] = objValue;
	              question_id.push(chapterParse[i].id);
	            }
	            myJson.question_count = question_id.length;
	            var questions = JSON.stringify(myJson);
	            var data = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              number_questions: myJson.question_count,
	              questions: questions,
	              timer_value: timer_value
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/createQuiz', data).then(function (resp) {
	              if (resp.success) {
	                _this4.setState({ display_loader: 'hide_block' });
	                _this4.context.router.push({
	                  pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START).split('(')[0] + '/' + resp.last_id + '/',
	                  state: {
	                    token: _this4.state.token,
	                    idname: _this4.state.idname,
	                    quiz_id: resp.last_id,
	                    status_send: ''
	                  }
	                });
	              } else {
	                //console.log(resp.success);
	              }
	            });
	          } else {
	            _this4.setState({ display_loader: 'hide_block' });
	            (0, _toast.showFailure)(resp.message);
	          }
	          return resp;
	        });
	      } else {
	        // console.log('else working')
	        var checkboxes = document.getElementsByName('approve[]');
	        var i = 0;
	        var single_clicked_value = [];
	        if (this.state.single_clicked_val == '') {
	          for (i = 0; i < checkboxes.length; i++) {
	            if (checkboxes[i].checked) {
	              // console.log(i+'----------'+checkboxes[i].value);
	              single_clicked_value.push(checkboxes[i].value);
	            }
	          }
	
	          chapterAll = single_clicked_value;
	          // console.log(chapterAll)
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          // console.log(data)
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getQuizequestion', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/createQuiz', data_insert).then(function (resp) {
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START).split('(')[0] + '/' + resp.last_id,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id
	                    }
	                  });
	                } else {
	                  // console.log(resp.success);
	                }
	              });
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        } else {
	          chapterAll = this.state.single_clicked_val;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/getQuizequestion', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value
	              };
	              if (resp.chapters.length !== 0) {
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2025_quizes/createQuiz', data_insert).then(function (resp) {
	                  if (resp.success) {
	                    _this4.context.router.push({
	                      pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START).split('(')[0] + '/' + resp.last_id,
	                      state: {
	                        token: _this4.state.token,
	                        idname: _this4.state.idname,
	                        quiz_id: resp.last_id
	                      }
	                    });
	                  } else {
	                    //console.log(resp.success);
	                  }
	                });
	              } else {
	                _this4.setState({ display_loader: 'hide_block' });
	                (0, _toast.showFailure)(_language2.default.LC().CFA2_2025_QUIZ_ERROR);
	              }
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        }
	      }
	    }
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START).split('(')[0] + '/' + items.id + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon'
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUIZ_BEFORE_START).split('(')[0] + '/' + items.id + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed'
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.id,
	                onClick: _this5._single_Checked.bind(_this5)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkAbondon.bind(_this5, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkCompleted.bind(_this5, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question == index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().CFA_LEVEL_I_QUIZZES
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._createQuiz.bind(this) },
	              ' ',
	              _language2.default.LC().CREATE_QUIZ,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().CONTENT,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions float-right' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().ALL_CHAPTERS,
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'all_Checked',
	                        name: 'all_checked',
	                        value: 'select',
	                        onClick: this._all_Checked.bind(this),
	                        checked: this.state.all_checked_state
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    chapter_data
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().ABANDONED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        abandoned_data
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().Priorities_By,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().NONE,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'none',
	                      name: 'none',
	                      value: 'none',
	                      checked: this.state.radio_checked_priority == 'none',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    _language2.default.LC().UNANSWERED,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unanswered',
	                      name: 'mark_unanswered',
	                      value: 'unanswered',
	                      checked: this.state.radio_checked_priority == 'unanswered',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().Wrong_answers,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unattempted',
	                      name: 'mark_unattempted',
	                      value: 'wrongquestion',
	                      checked: this.state.radio_checked_priority == 'wrongquestion',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().LENGTH,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  quiz_length_state_data
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().COMPLETED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        getallcompleteQuiz_data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Quizzes;
	}(_react.Component);
	
	Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Quizzes;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _constant = __webpack_require__(9);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tutor2023 = function (_Component) {
	  _inherits(Tutor2023, _Component);
	
	  function Tutor2023(props) {
	    _classCallCheck(this, Tutor2023);
	
	    var _this = _possibleConstructorReturn(this, (Tutor2023.__proto__ || Object.getPrototypeOf(Tutor2023)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Tutor2023, [{
	    key: 'render',
	    value: function render() {
	      var Exams = localStorage.getItem('selectedmenu');
	      var settings = {
	        infinite: true,
	        speed: 1000,
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        // autoplay: true,
	        initialSlide: 0,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null),
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1,
	            infinite: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            initialSlide: 2
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'card guru-head-wrapper' },
	        (0, _constant.CFAExamList)().some(function (exam) {
	          return exam.value === Exams;
	        }) ? _react2.default.createElement(
	          'div',
	          { className: 'row all-rows' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-3  guru-logo' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/APmyguru.jpg', alt: 'APmyguru.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-9  logo-head-section' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What My Guru Offers'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-head-section-inner1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'AnalystPrep, in partnership with George Beshara and MyGuru, offers a live, dynamic, interactive, one-on-one online learning experience at nearly half the cost of comparable online instructors by using free, intuitive online white-boarding and live videoconferencing technology. We rely on our expert online tutors to design highly personalized remote learning experiences. We begin every session with an empty whiteboard and end with a comprehensive set of instructor-generated notes illustrating that day\'s lesson. After every online tutoring session students have the option to review their notes anytime in PDF form.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-head-section-inner2' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/tick.jpg', alt: 'tick.jpg' }),
	                  'Every session is recorded for later review and you can pose questions on the online whiteboard at any time. This notifies the instructor, who will respond to you within 24 hours. So your online tutoring experience extends beyond the 90 minutes of live online coaching you receive each week.'
	                )
	              )
	            )
	          )
	        ) : _constant.GMATExamList.some(function (exam) {
	          return exam.value === Exams;
	        }) ? _react2.default.createElement(
	          'div',
	          { className: 'row all-rows' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-3  guru-logo' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/APmyguru.jpg', alt: 'APmyguru.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-9  logo-head-section' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What My Guru Offers'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-head-section-inner1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'MyGuru offers a live, dynamic, interactive, one-on-one online learning experience at nearly half the cost of comparable online instructors by using free, intuitive online white-boarding and live videoconferencing technology. We rely on our expert online tutors to design highly personalized remote learning experiences. We begin every session with an empty whiteboard and end with a comprehensive set of instructor-generated notes illustrating that day\'s lesson. After every online tutoring session students have the option to review their notes anytime in PDF form.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-head-section-inner2' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'We also offer "premium" online tutoring with two key benefits:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/tick.jpg', alt: 'tick.jpg' }),
	                  'a) Every session is recorded for later review and'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/tick.jpg', alt: 'tick.jpg' }),
	                  'b) You can pose questions on the online whiteboard at any time. This notifies the instructor, who will respond to you within 24 hours. So your online tutoring experience extends beyond the 1-2 hours of live online coaching you receive each week.'
	                )
	              )
	            )
	          )
	        ) : '',
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('hr', { className: 'hr-text', 'data-content': 'PLANS' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'plans-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row all-rows' },
	            (0, _constant.CFAExamList)().some(function (exam) {
	              return exam.value === Exams;
	            }) ? _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5 ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card common-mid-wrapper premium-plan' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/premium1.webp', alt: 'premium1.webp' })
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  ' 1-on-1 Online CFA\xAE Program Tutoring'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'curved-round' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Private, 1 on 1 instruction'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Award-winning virtual options'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Highly customized study plans'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Homework assignments & regular practice tests'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Skills-based & critical thinking oriented'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'action-btn-wrapper' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://analystprep.com/shop/1-on-1-online-cfa-program-tutoring-by-george-beshara/',
	                      target: 'blank',
	                      className: 'btn btn-primary pointer_class premium-btn'
	                    },
	                    'More Details'
	                  )
	                )
	              )
	            ) : _constant.GMATExamList.some(function (exam) {
	              return exam.value === Exams;
	            }) ? _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5 ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card common-mid-wrapper premium-plan' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/standard.webp', alt: 'premium1.webp' })
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  '1-on-1 Online GMAT/EA Program Tutoring'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'curved-round' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Private, 1 on 1 instruction'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Award-winning virtual options'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Highly customized study plans'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Homework assignments & regular practice tests'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Skills-based & critical thinking oriented'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'action-btn-wrapper' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://analystprep.com/shop/1-on-1-online-tutoring-by-myguru-and-analystprep/',
	                      target: 'blank',
	                      className: 'btn btn-primary pointer_class premium-btn'
	                    },
	                    'More Details'
	                  )
	                )
	              )
	            ) : ''
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('hr', { className: 'hr-text', 'data-content': 'REVIEWS' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'review-section all-rows' },
	          _react2.default.createElement(
	            _reactSlick2.default,
	            settings,
	            _react2.default.createElement(
	              'div',
	              { className: 'slider-outer-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'review-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row slider-flex-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-3' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dummy.jpg', alt: 'dummy.jpg' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '- Jessie S.'
	                      ),
	                      'w'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star-review' },
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        starDimension: '15px',
	                        starEmptyColor: 'rgb(255, 180, 0)',
	                        starSpacing: '0px',
	                        numberOfStars: 5
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-9' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Stefan was awesome! He brought up my Verbal from the 40th to 76th percentile. I would definitely use him again. Very affordable, very high quality. I went from a 650 to a 690 in a very tight timeframe.'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slider-outer-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'review-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row slider-flex-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-3' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dummy.jpg', alt: 'dummy.jpg' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '- Alex S.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star-review' },
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        starDimension: '15px',
	                        starEmptyColor: 'rgb(255, 180, 0)',
	                        starSpacing: '0px',
	                        numberOfStars: 5
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-9' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'I raised my score by 80 points in 8 weeks. I worked with Stefan for two months and was able to raise my GMAT score 80 points in order to apply to competitive MBA programs.'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slider-outer-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'review-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row slider-flex-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-3' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dummy.jpg', alt: 'dummy.jpg' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '- Alexandra G.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star-review' },
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        starDimension: '15px',
	                        starEmptyColor: 'rgb(255, 180, 0)',
	                        starSpacing: '0px',
	                        numberOfStars: 5
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-9' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Amazing people all around, from the manager, Morgan, to the tutor, Adam!! Prompt, professional communication and top quality tutoring. My son found the ACT prep very valuable and improved his composite score by 6 points. Highly recommend!'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slider-outer-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'review-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row slider-flex-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-3' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dummy.jpg', alt: 'dummy.jpg' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '- Emily L.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star-review' },
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        starDimension: '15px',
	                        starEmptyColor: 'rgb(255, 180, 0)',
	                        starSpacing: '0px',
	                        numberOfStars: 5
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-9' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'I prepared for the GMAT under Stefan. It was super easy to use the online platform and was very convenient to save notes this way. Stefan is extremely knowledgable on the testing material and really cares about his students.'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slider-outer-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'review-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row slider-flex-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-3' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dummy.jpg', alt: 'dummy.jpg' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '- Abigail M.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star-review' },
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        starDimension: '15px',
	                        starEmptyColor: 'rgb(255, 180, 0)',
	                        starSpacing: '0px',
	                        numberOfStars: 5
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-9' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'I worked with Steve Markofsky. He was very professional, amiable, and flexible with my work schedule. I received my desired scores! Thank you, Steve.'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slider-outer-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'review-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row slider-flex-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-3' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/dummy.jpg', alt: 'dummy.jpg' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ' ',
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '- Izzi S.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star-review' },
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        starDimension: '15px',
	                        starEmptyColor: 'rgb(255, 180, 0)',
	                        starSpacing: '0px',
	                        numberOfStars: 5
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-9' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'I studied with Steve Markofsky, he was always so helpful. When I was confused, he took time to explain the topics slowly and simply. 100% recommend this tutoring service!'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tutor2023;
	}(_react.Component);
	
	Tutor2023.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = Tutor2023;
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement('div', {
	    className: className,
	    style: Object.assign({}, style, { display: 'block', background: 'red' }),
	    onClick: onClick
	  });
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement('div', {
	    className: className,
	    style: Object.assign({}, style, { display: 'block', background: 'green' }),
	    onClick: onClick
	  });
	}

/***/ },
/* 626 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'id',
	  chapterNameKey: 'chapter_name',
	  videoTableNameKey: 'cfa1_2025_videos',
	  videoTableChapterIdKey: 'chapter_id'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchVideos = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/all-videos', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchVideos(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchLastViewedVideo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/last-video-viewed', Object.assign({}, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchLastViewedVideo() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchVideos: fetchVideos,
	  fetchLastViewedVideo: fetchLastViewedVideo
	};

/***/ },
/* 628 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapter_id',
	  chapterNameKey: 'chapter_name',
	  videoTableKey: 'cfa1_2025_videos',
	  videoTitleKey: 'title',
	  youtubeIdKey: 'url_id',
	  videoTableNameKey: 'cfa1_2025_videos',
	  videoTableChapterIdKey: 'chapter_id'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* 
	   I am using the 'question' key in the API functions. 
	   Please disregard it,
	   as these API calls originate from the Question Bank common component, 
	   which necessitates its usage
	*/
	
	var fetchVideos = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/all-videos', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchVideos(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var saveLastViewedVideo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/last-video-viewed', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function saveLastViewedVideo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var fetchSavedQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/save', Object.assign({
	              videoId: data.video_id
	            }, data));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/save', Object.assign({
	              videoId: data.video_id
	            }, data));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function saveQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/unsave', Object.assign({
	              videoId: data.video_id
	            }, data));
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var mutateReportVideo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/report', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function mutateReportVideo(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchVideos: fetchVideos,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  mutateReportVideo: mutateReportVideo,
	  saveLastViewedVideo: saveLastViewedVideo
	};

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	var _VideoPlayList = __webpack_require__(174);
	
	var _VideoPlayList2 = _interopRequireDefault(_VideoPlayList);
	
	var _VideoValidateReportsIcons = __webpack_require__(175);
	
	var _VideoValidateReportsIcons2 = _interopRequireDefault(_VideoValidateReportsIcons);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _ApiAttributesKays = __webpack_require__(628);
	
	var _ApiService = __webpack_require__(629);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _aiTutorContext = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var videoTableKey = 'cfa1_2025_videos';
	
	/* eslint-disable*/
	
	var VideoPlayList = function (_Component) {
	  _inherits(VideoPlayList, _Component);
	
	  function VideoPlayList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, VideoPlayList);
	
	    var _this = _possibleConstructorReturn(this, (VideoPlayList.__proto__ || Object.getPrototypeOf(VideoPlayList)).call(this, props));
	
	    _this.getChapterWiseVideos = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(payload) {
	        var result, videosData, id, currentIndex, level1Sub, isUserSubscriptionStatus, currentVideo, hasPlusAccess, isWebinar, canPlayCurrent, router;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _ApiService2.default['fetchVideos'](payload);
	
	              case 2:
	                result = _context.sent;
	
	                if (result.success) {
	                  videoTableKey = result.associatedVideosTable;
	                  videosData = result.data[0][videoTableKey];
	                  id = payload.id;
	                  currentIndex = videosData.findIndex(function (item) {
	                    return item.id === parseInt(id, 10);
	                  });
	                  //* HERE ADDED A CHECK IF USER WANT TO ACCESS PREMIUM VIDEO WITHOUT SUBSCRIPTION */
	
	                  level1Sub = result.selectedExamSubscriptionDetails.level1SubscriptionDetails;
	                  isUserSubscriptionStatus = level1Sub && level1Sub.videoStatus;
	                  // Live Sessions ("webinar" media_type) — Unlimited+ (pkg 78) is the only
	                  // paid tier with full access; other tiers can only play the ones flagged
	                  // free. `hasCfaPlus` comes from cfaSubscriptionCheckMiddleware which
	                  // detects pkg 78 straight from subscription_details, so pkg-15+pkg-78
	                  // co-holders (e.g. user 159915) resolve to true even when the middleware
	                  // short-circuits into the plain Unlimited details.
	
	                  currentVideo = videosData[currentIndex];
	                  hasPlusAccess = !!result.selectedExamSubscriptionDetails.hasCfaPlus;
	                  isWebinar = currentVideo && currentVideo.media_type === 'webinar';
	                  canPlayCurrent = currentVideo && (currentVideo.free || (isWebinar ? hasPlusAccess : isUserSubscriptionStatus));
	
	                  if (canPlayCurrent) {
	                    _this.setState({
	                      isLoading: false,
	                      currentIndex: currentIndex > -1 ? currentIndex : 0,
	                      videoData: result.data.length && result.data[0][videoTableKey],
	                      title: result.data.length && result.data[0][_ApiAttributesKays.chapterNameKey],
	                      isUserSubscriptionStatus: isUserSubscriptionStatus,
	                      // Persist the Plus tier flag so navigateToVideoByID can re-check
	                      // access when jumping between playlist entries without a refetch.
	                      hasPlusAccess: hasPlusAccess
	                    });
	                    // tell the AI Tutor which lecture the student is viewing (chapter passed explicitly —
	                    // this.state.title isn't committed yet inside this setState batch)
	                    _this.dispatchAiContext(videosData[currentIndex > -1 ? currentIndex : 0], result.data.length && result.data[0][_ApiAttributesKays.chapterNameKey]);
	                  } else {
	                    router = _this.context.router;
	
	                    router.push({ pathname: _AppRoutes2.default.FRM_VIDEOS });
	                    (0, _toast.showInformation)(_messages.messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO);
	                  }
	                } else {
	                  _this.setState({ isLoading: false });
	                }
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.buildAiContext = function (video, chapterName) {
	      return {
	        exam: 'CFA1',
	        exam_year: (0, _aiTutorContext.aiTutorExamYear)(), // 2026/2027 from the header's selected exam; null when unknown
	        page_url: (0, _aiTutorContext.aiTutorPageUrl)(),
	        page_type: 'video',
	        content_id: video && video.id,
	        title: video && video[_ApiAttributesKays.videoTitleKey] || 'CFA Level I',
	        // extra retrieval grounding — the KB chunks carry a matching `chapter` metadata field
	        chapter: chapterName || _this.state.title || '',
	        // reading name (resolved server-side from the video's reading_id) — grounding + analytics,
	        // matches what Notes sends; empty when the lecture isn't tied to a reading (reading_id 0)
	        reading: video && video.reading_name || '',
	        // the lecture title is the retrieval key — KB video transcripts are titled by lecture name
	        stem: video && video[_ApiAttributesKays.videoTitleKey] || ''
	      };
	    };
	
	    _this.dispatchAiContext = function (video, chapterName) {
	      if (!video) return;
	      (0, _aiTutorContext.dispatchAiTutorContext)(_this.buildAiContext(video, chapterName));
	    };
	
	    _this.askAiAboutLecture = function () {
	      var _this$state = _this.state,
	          videoData = _this$state.videoData,
	          currentIndex = _this$state.currentIndex;
	
	      var video = videoData[currentIndex];
	      if (!video) return;
	      (0, _aiTutorContext.dispatchAiTutorExplain)({
	        context: _this.buildAiContext(video),
	        message: 'Summarize the key ideas of this lecture'
	      });
	    };
	
	    _this.navigateToVideoByID = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(index) {
	        var state, isUserSubscriptionStatus, videoData, hasPlusAccess, nextVideo, isWebinar, canPlayNext, router;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                state = _this.state;
	                isUserSubscriptionStatus = state.isUserSubscriptionStatus, videoData = state.videoData, hasPlusAccess = state.hasPlusAccess;
	                // Same Live Sessions tier gate as getChapterWiseVideos above.
	                // Webinars require Plus tier OR free flag; topic videos fall back to
	                // the standard videoStatus check.
	
	                nextVideo = videoData[index];
	                isWebinar = nextVideo && nextVideo.media_type === 'webinar';
	                canPlayNext = nextVideo && (nextVideo.free || (isWebinar ? hasPlusAccess : isUserSubscriptionStatus));
	
	                if (!canPlayNext) {
	                  _context2.next = 14;
	                  break;
	                }
	
	                _this.setState({ currentIndex: index });
	                _this.dispatchAiContext(videoData[index]);
	                router = _this.context.router;
	
	                router.push({
	                  pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_VIDEO_LIST).replace(':id', videoData[index].id).replace(':chapterId', videoData[index][_ApiAttributesKays.videoTableChapterIdKey]),
	                  query: Object.assign({}, videoData[index].mock_id && { mockId: videoData[index].mock_id }, videoData[index].media_type === 'webinar' && { mediaType: 'webinar' })
	                });
	                _context2.next = 12;
	                return _ApiService2.default['saveLastViewedVideo']({
	                  videoId: videoData[index].id,
	                  videoIndex: index
	                });
	
	              case 12:
	                _context2.next = 15;
	                break;
	
	              case 14:
	                _this.setState({ isPremiumPopupOpen: true });
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToSubscription = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.onHandleToggleAlert = function () {
	      _this.setState({ isPremiumPopupOpen: !_this.state.isPremiumPopupOpen });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { isReportSectionShow: !prevState.isReportSectionShow };
	      });
	    };
	
	    _this.onHandleHideReportSection = function () {
	      _this.setState({ isReportSectionShow: false });
	    };
	
	    _this.state = {
	      videoData: [],
	      currentIndex: 0,
	      title: '',
	      isLoading: true,
	      isFlashCardHidden: true,
	      isReportSectionShow: false,
	      isPremiumPopupOpen: false,
	      isUserSubscriptionStatus: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(VideoPlayList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _props$params, chapterId, id, _props$location$query, mockId, mediaType;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.setState({ isLoading: true });
	                _props$params = this.props.params, chapterId = _props$params.chapterId, id = _props$params.id;
	                _props$location$query = this.props.location.query, mockId = _props$location$query.mockId, mediaType = _props$location$query.mediaType;
	                _context3.next = 5;
	                return this.getChapterWiseVideos({ chapterId: chapterId, id: id, mockId: mockId, mediaType: mediaType });
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // leaving the video view → drop stale AI Tutor context
	      (0, _aiTutorContext.clearAiTutorContext)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var router = this.context.router;
	      var state = this.state;
	      var videoData = state.videoData,
	          isLoading = state.isLoading,
	          currentIndex = state.currentIndex,
	          isUserSubscriptionStatus = state.isUserSubscriptionStatus,
	          isPremiumPopupOpen = state.isPremiumPopupOpen,
	          isFlashCardHidden = state.isFlashCardHidden,
	          isReportSectionShow = state.isReportSectionShow,
	          title = state.title;
	      var mockId = this.props.location.query.mockId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              { className: '', title: title },
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex flex-wrap align-items-center', style: { gap: 8, marginLeft: 'auto', justifyContent: 'flex-end' } },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-primary pointer_class',
	                    onClick: function onClick() {
	                      return router.push({ pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_VIDEOS) });
	                    }
	                  },
	                  _messages.messages.BACK_TO_VIDEOS
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'pointer_class ap-ai-launcher', style: _aiTutorContext.AI_TRIGGER_BTN_STYLE, onClick: this.askAiAboutLecture },
	                  '\u2726 Ask AI about this lecture'
	                )
	              )
	            ),
	            _react2.default.createElement(_VideoPlayList2.default, {
	              videoTitle: videoData[currentIndex] ? videoData[currentIndex][_ApiAttributesKays.videoTitleKey] : '',
	              currentIndex: currentIndex,
	              videosData: videoData,
	              youtubeID: videoData[currentIndex] ? videoData[currentIndex][_ApiAttributesKays.youtubeIdKey] : '',
	              navigateToVideoByID: this.navigateToVideoByID,
	              toggleAlert: this.onHandleToggleAlert,
	              isUserSubscribed: isUserSubscriptionStatus
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportsIcons2.default, {
	              isMoveToNotesIcon: !mockId,
	              isMoveToQuestionIcon: !mockId,
	              toggleAlert: this.onHandleToggleAlert,
	              savePayLoad: { videoId: videoData[currentIndex] && videoData[currentIndex].id },
	              favItemId: videoData[currentIndex] && videoData[currentIndex].id,
	              notesRedirectRoute: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_NOTES_READING_LIST).replace(':chapterId', videoData[currentIndex] && videoData[currentIndex][_ApiAttributesKays.chapterIdKey]),
	              questionRedirectRoute: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_2025_QUESTION_BANK_READING_LIST).replace(':chapterId', videoData[currentIndex] && videoData[currentIndex][_ApiAttributesKays.chapterIdKey]),
	              setChildRef: this.childRef,
	              currentVideo: videoData[currentIndex] && videoData[currentIndex],
	              apiServiceProvider: _ApiService2.default,
	              onSaveItemChange: this.onSaveItemChange,
	              toggleReportSection: this.toggleReportSection,
	              isUserSubscribed: isUserSubscriptionStatus
	            }),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: videoData[currentIndex] ? videoData[currentIndex].id : '' },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa1_2024'
	            }),
	            isReportSectionShow && _react2.default.createElement(_ReportCard2.default, {
	              section: 'video',
	              hideReportSection: this.onHandleHideReportSection,
	              apiServiceProvider: _ApiService2.default,
	              itemId: videoData[currentIndex] ? videoData[currentIndex].id : '',
	              keyId: 'videoId'
	            })
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.redirectToSubscription,
	          toggleAlert: this.onHandleToggleAlert,
	          alert_status: isPremiumPopupOpen,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP
	        })
	      );
	    }
	  }]);
	
	  return VideoPlayList;
	}(_react.Component);
	
	VideoPlayList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = VideoPlayList;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _videoCard = __webpack_require__(176);
	
	var _videoCard2 = _interopRequireDefault(_videoCard);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa1NextRoutes = __webpack_require__(39);
	
	var _ApiAttributesKays = __webpack_require__(626);
	
	var _ApiService = __webpack_require__(627);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _toast = __webpack_require__(15);
	
	var _function = __webpack_require__(10);
	
	__webpack_require__(1000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var videoTableNameKey = 'cfa1_2025_videos';
	
	/* eslint-disable*/
	
	var index = function (_Component) {
	  _inherits(index, _Component);
	
	  function index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, index);
	
	    var _this = _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).call(this, props));
	
	    _this.retrieveVideos = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var result;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _ApiService2.default['fetchVideos']();
	
	            case 2:
	              result = _context.sent;
	
	              if (result.success) {
	                videoTableNameKey = result.associatedVideosTable;
	                _this.setState({
	                  isLoading: false,
	                  videoData: result.data,
	                  isUserSubscriptionStatus: result.selectedExamSubscriptionDetails.level1SubscriptionDetails && result.selectedExamSubscriptionDetails.level1SubscriptionDetails.videoStatus,
	                  hasPlusAccess: !!result.selectedExamSubscriptionDetails.hasCfaPlus
	                });
	              } else {
	                _this.setState({ isLoading: false });
	              }
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.redirectToSubscription = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.scrollToSection = function (headerTitle) {
	      var element = document.getElementById((0, _function.slugifyHeader)(headerTitle));
	      if (element && element.scrollIntoView) {
	        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
	      }
	    };
	
	    _this.onHandleToggleAlert = function () {
	      _this.setState({ isPremiumPopupOpen: !_this.state.isPremiumPopupOpen });
	    };
	
	    _this.redirectToPlaylist = function (items) {
	      var router = _this.context.router;
	      var id = items.id;
	
	      router.push({
	        pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_VIDEO_LIST).replace(':chapterId', items[_ApiAttributesKays.videoTableChapterIdKey]).replace(':id', id),
	        query: Object.assign({}, items.mock_id && { mockId: items.mock_id }, items.media_type === 'webinar' && { mediaType: 'webinar' })
	      });
	    };
	
	    _this.redirectToLastViewedVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var result, router, data, associatedVideosTable;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.setState({ isLastVideoViewButtonDisable: true });
	              _context2.next = 3;
	              return _ApiService2.default['fetchLastViewedVideo']();
	
	            case 3:
	              result = _context2.sent;
	
	              if (result.success) {
	                router = _this.context.router;
	                data = result.data, associatedVideosTable = result.associatedVideosTable;
	
	                router.push({
	                  pathname: (0, _cfa1NextRoutes.nextAwareRoute)(_AppRoutes2.default.CFA1_VIDEO_LIST).replace(':chapterId', data[associatedVideosTable] ? data[associatedVideosTable][_ApiAttributesKays.videoTableChapterIdKey] : null).replace(':id', data.contentID),
	                  query: Object.assign({}, data[associatedVideosTable].mock_id && {
	                    mockId: data[associatedVideosTable].mock_id
	                  }, data[associatedVideosTable].media_type === 'webinar' && {
	                    mediaType: 'webinar'
	                  })
	                });
	              } else {
	                _this.setState({ isLastVideoViewButtonDisable: false });
	                (0, _toast.showInformation)(_messages.messages.VIDEO_NOT_AVAILABLE);
	              }
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.state = {
	      videoData: [],
	      isLoading: true,
	      isPremiumPopupOpen: false,
	      isLastVideoViewButtonDisable: false,
	      isUserSubscriptionStatus: false,
	      // Unlimited+ marker for the Live Sessions playback gate; comes from
	      // the backend's cfaSubscriptionCheckMiddleware so pkg-15+pkg-78 co-
	      // holders are recognised even when the middleware short-circuits.
	      hasPlusAccess: false
	    };
	    return _this;
	  }
	
	  _createClass(index, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.setState({ isLoading: true });
	                _context3.next = 3;
	                return this.retrieveVideos();
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state;
	      var isLoading = state.isLoading,
	          isPremiumPopupOpen = state.isPremiumPopupOpen,
	          isUserSubscriptionStatus = state.isUserSubscriptionStatus,
	          hasPlusAccess = state.hasPlusAccess,
	          isLastVideoViewButtonDisable = state.isLastVideoViewButtonDisable,
	          videoData = state.videoData;
	
	      var resetIndex = false;
	      var counterIndex = 1;
	      var sectionHeaders = videoData.filter(function (item) {
	        return item.headerTitle;
	      }).map(function (item) {
	        return item.headerTitle;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _ComponentHeader2.default,
	            { title: _messages.messages.VIDEOS, className: 'mb-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex align-items-center flex-wrap video-category-header-actions' },
	              sectionHeaders.length > 1 && _react2.default.createElement(
	                'div',
	                { className: 'video-category-anchors mr-3' },
	                sectionHeaders.map(function (headerTitle) {
	                  return _react2.default.createElement(
	                    'button',
	                    {
	                      key: headerTitle,
	                      type: 'button',
	                      className: 'btn btn-link video-category-anchor',
	                      onClick: function onClick() {
	                        return _this3.scrollToSection(headerTitle);
	                      }
	                    },
	                    headerTitle
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: function onClick() {
	                    return _this3.redirectToLastViewedVideo();
	                  },
	                  disabled: isLastVideoViewButtonDisable
	                },
	                isLastVideoViewButtonDisable && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	                _messages.messages.GO_TO_MY_LAST_VIEWED_VIDEO
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _LoaderWrapper2.default,
	            { isLoading: isLoading },
	            _react2.default.createElement(
	              _reactstrap.Row,
	              { className: 'video_lesson_wrap' },
	              videoData.length > 0 && videoData.map(function (item, index) {
	                if (item.mock_id && !resetIndex) {
	                  resetIndex = true;
	                  counterIndex = 1;
	                }
	                return _react2.default.createElement(_videoCard2.default, {
	                  key: index,
	                  index: counterIndex++,
	                  currentItem: item,
	                  chapterIdKey: _ApiAttributesKays.chapterIdKey,
	                  chapterNameKey: _ApiAttributesKays.chapterNameKey,
	                  videoTableNameKey: videoTableNameKey,
	                  onHandleRedirect: true,
	                  isUserSubscribed: isUserSubscriptionStatus,
	                  hasPlusAccess: hasPlusAccess,
	                  premiumModalToggle: _this3.onHandleToggleAlert,
	                  redirectToPlaylist: _this3.redirectToPlaylist
	                });
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.redirectToSubscription,
	          toggleAlert: this.onHandleToggleAlert,
	          alert_status: isPremiumPopupOpen,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP
	        })
	      );
	    }
	  }]);
	
	  return index;
	}(_react.Component);
	
	index.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = index;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(79);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _toast = __webpack_require__(15);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var i = '';
	
	var Cfa2Dashboard = function (_Component) {
	  _inherits(Cfa2Dashboard, _Component);
	
	  function Cfa2Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2Dashboard.__proto__ || Object.getPrototypeOf(Cfa2Dashboard)).call(this, props));
	
	    _this.deleteFlashCard = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(type, id) {
	        var _this$state, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, id_name = _this$state.idname, token = _this$state.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: '',
	                  exam: 'cfa2_2025',
	                  level: '',
	                  item_id: id
	                };
	                _context.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.view = function (item) {
	      if (item.mockData) {
	        var mock = JSON.parse(item.mockData);
	        _this.context.router.push({
	          pathname: '/cfa2/2026/cbtquestionsfinish/' + mock.mock_id + '/' + mock.caseId + '/' + item.question_id + '/' + mock.test_id + '/' + mock.caseOffset + '/' + mock.quesOffset + '/' + mock.timer
	        });
	      }
	    };
	
	    _this.toggleDone = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var _this$state2, idname, token, items_val, item_status, question_id, item_id, video_id, data;
	
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              _this$state2 = _this.state, idname = _this$state2.idname, token = _this$state2.token, items_val = _this$state2.items_val, item_status = _this$state2.item_status;
	              question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	              if (!(_this.state.item_status == 'flashcard')) {
	                _context12.next = 6;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteFlashCard', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(response) {
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context2.next = 3;
	                            break;
	                          }
	
	                          _context2.next = 3;
	                          return _this.getQuestionFlashcards();
	
	                        case 3:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                }));
	
	                return function (_x3) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 6:
	              if (!(item_status == 'savedquestion')) {
	                _context12.next = 12;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 10;
	              return _this.deleteFlashCard('question', question_id ? question_id : item_id);
	
	            case 10:
	              _context12.next = 12;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteSavequestion', data).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(response) {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.getQuestionSaved();
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	
	            case 12:
	              if (!(_this.state.item_status == 'Reportsquestion')) {
	                _context12.next = 16;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 16;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteDashboardQuestionReports', data).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(response) {
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context4.next = 3;
	                            break;
	                          }
	
	                          _context4.next = 3;
	                          return _this.getQuestionReports();
	
	                        case 3:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x5) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 16:
	              if (!(item_status == 'savednotes')) {
	                _context12.next = 22;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 20;
	              return _this.deleteFlashCard('notes', question_id ? question_id : item_id);
	
	            case 20:
	              _context12.next = 22;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/deleteSaveNotes', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(response) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context5.next = 5;
	                            break;
	                          }
	
	                          _context5.next = 3;
	                          return _this.getNotesSaved();
	
	                        case 3:
	                          _context5.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 22:
	              if (!(item_status == 'savedvideos')) {
	                _context12.next = 28;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 26;
	              return _this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	            case 26:
	              _context12.next = 28;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteSaveVideo', data).then(function () {
	                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(response) {
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context6.next = 5;
	                            break;
	                          }
	
	                          _context6.next = 3;
	                          return _this.getVideosSaved();
	
	                        case 3:
	                          _context6.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref7.apply(this, arguments);
	                };
	              }());
	
	            case 28:
	              if (!(_this.state.item_status == 'Notesflashcard')) {
	                _context12.next = 32;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 32;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/deleteDashboardFlashCard', data).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(response) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context7.next = 3;
	                            break;
	                          }
	
	                          _context7.next = 3;
	                          return _this.getNotesFlashcards();
	
	                        case 3:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	
	            case 32:
	              if (!(_this.state.item_status == 'Videoflashcard')) {
	                _context12.next = 36;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 36;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteDashboardVideoFlashCard', data).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(response) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context8.next = 3;
	                            break;
	                          }
	
	                          _context8.next = 3;
	                          return _this.getVideoFlashcards();
	
	                        case 3:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	
	            case 36:
	
	              if (_this.state.item_status == 'Reportsnotes') {
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reports: _this.state.items_val
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/deleteDashboardNotesReports', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(response) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context9.next = 3;
	                              break;
	                            }
	
	                            _context9.next = 3;
	                            return _this.getNotesReports();
	
	                          case 3:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x10) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	              }
	
	              if (!(_this.state.item_status == 'Reportsvideos')) {
	                _context12.next = 41;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 41;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteDashboardVideoReports', data).then(function () {
	                var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(response) {
	                  return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                      switch (_context10.prev = _context10.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context10.next = 3;
	                            break;
	                          }
	
	                          _context10.next = 3;
	                          return _this.getVideoReports();
	
	                        case 3:
	                        case 'end':
	                          return _context10.stop();
	                      }
	                    }
	                  }, _callee10, _this2);
	                }));
	
	                return function (_x11) {
	                  return _ref11.apply(this, arguments);
	                };
	              }());
	
	            case 41:
	              if (!(_this.state.item_status == 'CBTreportsquestion')) {
	                _context12.next = 45;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 45;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/deleteReport', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(response) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context11.next = 3;
	                            break;
	                          }
	
	                          _context11.next = 3;
	                          return _this.getCBTQestionReports();
	
	                        case 3:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x12) {
	                  return _ref12.apply(this, arguments);
	                };
	              }());
	
	            case 45:
	              _this.setState({
	                alert_status: false
	              });
	
	            case 46:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteSavequestion = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: 'Hide Details' });
	      }
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({ more_detail_button: 'I Want More Details' });
	      }
	    };
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context14.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(response) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ reportquestion: response.questions, reportLoader: false });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x13) {
	                  return _ref14.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	            case 3:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this2);
	    }));
	    _this.getQuestionSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context16.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestionsbyuserid', data).then(function (response) {
	                if (response.success) {
	                  _this.setState({ savedquestion: response.questions, savedLoader: false });
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	
	    _this._beginChapter = function (item, e) {
	      var isActiveQues = false;
	      var isActiveCases = false;
	      var isActive = false;
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getQuestionsbyid', data).then(function (response) {
	        if (response.success) {
	          isActiveQues = response.questionsbyid.isActive2025;
	          var dataparam = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            caseid: response.questionsbyid.case_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesbyId', dataparam).then(function () {
	            var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(resp_case) {
	              var indexcase, caseReadings;
	              return _regenerator2.default.wrap(function _callee17$(_context17) {
	                while (1) {
	                  switch (_context17.prev = _context17.next) {
	                    case 0:
	                      if (!resp_case.success) {
	                        _context17.next = 10;
	                        break;
	                      }
	
	                      isActiveCases = resp_case.casesingleData.isActive2025;
	                      indexcase = -1;
	                      _context17.next = 5;
	                      return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCases', {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter_id: resp_case.casesingleData.chapter_no_2025
	                      });
	
	                    case 5:
	                      caseReadings = _context17.sent;
	
	                      caseReadings.readings.map(function (value, index) {
	                        if (value.id === resp_case.casesingleData.id) {
	                          isActive = value.isActive2025;
	                          indexcase = index;
	                        }
	                      });
	                      if (isActive && isActiveCases && isActiveQues) {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', response.questionsbyid.chapter_id_2025).replace(':caseid', response.questionsbyid.case_id).replace(':case_offset', indexcase).replace(':question_number', response.questionsbyid.question_number)
	                        });
	                      } else {
	                        (0, _toast.showFailure)('Questions unavailable');
	                      }
	                      _context17.next = 11;
	                      break;
	
	                    case 10:
	                      (0, _toast.showFailure)('Questions unavailable');
	
	                    case 11:
	                    case 'end':
	                      return _context17.stop();
	                  }
	                }
	              }, _callee17, _this2);
	            }));
	
	            return function (_x14) {
	              return _ref17.apply(this, arguments);
	            };
	          }());
	        } else {
	          (0, _toast.showFailure)('Questions unavailable');
	        }
	      });
	    };
	
	    _this.onContactSubmit = function () {
	      var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(event) {
	        var _this$state3, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context19.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context19.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context19.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context19.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state3 = _this.state, idname = _this$state3.idname, token = _this$state3.token, contactComment = _this$state3.contactComment, contactSubject = _this$state3.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context19.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(response) {
	                    return _regenerator2.default.wrap(function _callee18$(_context18) {
	                      while (1) {
	                        switch (_context18.prev = _context18.next) {
	                          case 0:
	                            if (response.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context18.abrupt('return', response);
	
	                          case 2:
	                          case 'end':
	                            return _context18.stop();
	                        }
	                      }
	                    }, _callee18, _this2);
	                  }));
	
	                  return function (_x16) {
	                    return _ref19.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this2);
	      }));
	
	      return function (_x15) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.getNotesSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee21() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee21$(_context21) {
	        while (1) {
	          switch (_context21.prev = _context21.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context21.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getFavNotesbyuserid', data).then(function () {
	                var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(response) {
	                  return _regenerator2.default.wrap(function _callee20$(_context20) {
	                    while (1) {
	                      switch (_context20.prev = _context20.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ savednotes: response.cfa_notes });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context20.stop();
	                      }
	                    }
	                  }, _callee20, _this2);
	                }));
	
	                return function (_x17) {
	                  return _ref21.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context21.stop();
	          }
	        }
	      }, _callee21, _this2);
	    }));
	    _this.getNotesFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee22() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee22$(_context22) {
	        while (1) {
	          switch (_context22.prev = _context22.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	            case 3:
	            case 'end':
	              return _context22.stop();
	          }
	        }
	      }, _callee22, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee23() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee23$(_context23) {
	        while (1) {
	          switch (_context23.prev = _context23.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	            case 3:
	            case 'end':
	              return _context23.stop();
	          }
	        }
	      }, _callee23, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee25() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee25$(_context25) {
	        while (1) {
	          switch (_context25.prev = _context25.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context25.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getReportsVideobyuserid', data).then(function () {
	                var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(response) {
	                  return _regenerator2.default.wrap(function _callee24$(_context24) {
	                    while (1) {
	                      switch (_context24.prev = _context24.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ reportsvideo: response.video });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context24.stop();
	                      }
	                    }
	                  }, _callee24, _this2);
	                }));
	
	                return function (_x18) {
	                  return _ref25.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context25.stop();
	          }
	        }
	      }, _callee25, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee27() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee27$(_context27) {
	        while (1) {
	          switch (_context27.prev = _context27.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context27.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavVideosbyuserid', data).then(function () {
	                var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(response) {
	                  return _regenerator2.default.wrap(function _callee26$(_context26) {
	                    while (1) {
	                      switch (_context26.prev = _context26.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ savedvideo: response.cfa_videos });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context26.stop();
	                      }
	                    }
	                  }, _callee26, _this2);
	                }));
	
	                return function (_x19) {
	                  return _ref27.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context27.stop();
	          }
	        }
	      }, _callee27, _this2);
	    }));
	    _this.getNotesReports = _asyncToGenerator(_regenerator2.default.mark(function _callee29() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee29$(_context29) {
	        while (1) {
	          switch (_context29.prev = _context29.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context29.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getReportsNotesbyuserid', data).then(function () {
	                var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(response) {
	                  return _regenerator2.default.wrap(function _callee28$(_context28) {
	                    while (1) {
	                      switch (_context28.prev = _context28.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ reportnotes: response.notes });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context28.stop();
	                      }
	                    }
	                  }, _callee28, _this2);
	                }));
	
	                return function (_x20) {
	                  return _ref29.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context29.stop();
	          }
	        }
	      }, _callee29, _this2);
	    }));
	
	    _this._beginVideos = function () {
	      var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee30$(_context30) {
	          while (1) {
	            switch (_context30.prev = _context30.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading['cfa2_2025_video_reports.video_id'] ? reading['cfa2_2025_video_reports.video_id'] : reading.video_id
	                };
	                _context30.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getVideoByID', data).then(function (response) {
	                  if (response.success) {
	                    var _data = response.allVideo.findIndex(function (item) {
	                      return item.id === response.video[0].id;
	                    });
	                    if (response.video[0].isActive2025) {
	                      // This handles both `true` and `1`
	                      if (response.video[0].mock_id) {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default.CFA2_2026_VIDEOS_LIST.replace(':id', response.video[0].id).replace(':chapterId', response.video[0].chapter_id_2025),
	                          query: { mockId: response.video[0].mock_id }
	                        });
	                      } else {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default.CFA2_2026_VIDEOS_LIST.replace(':id', response.video[0].id).replace(':chapterId', response.video[0].chapter_id_2025)
	                        });
	                      }
	                    } else {
	                      (0, _toast.showFailure)('Videos unavailable');
	                    }
	                  } else {
	                    (0, _toast.showFailure)('Videos unavailable');
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context30.stop();
	            }
	          }
	        }, _callee30, _this2);
	      }));
	
	      return function (_x21, _x22) {
	        return _ref30.apply(this, arguments);
	      };
	    }();
	
	    _this._beginNotes = function () {
	      var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(reading, e) {
	        var isActive2025, reading_id, chapter_id, data, offset;
	        return _regenerator2.default.wrap(function _callee32$(_context32) {
	          while (1) {
	            switch (_context32.prev = _context32.next) {
	              case 0:
	                isActive2025 = false;
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                offset = 0;
	                _context32.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotesByID', data).then(function (response) {
	                  if (response.success) {
	                    isActive2025 = response.notes[0].isActive2025;
	                    var data = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter_id: response.notes[0].chapter_id_2025,
	                      reading_id: response.notes[0].reading_id_2025,
	                      offset: _this.state.offset
	                    };
	                    chapter_id = response.notes[0].chapter_id_2025;
	                    if (isActive2025 || isActive2025 == 1) {
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes_allcr', data).then(function () {
	                        var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(response) {
	                          var i;
	                          return _regenerator2.default.wrap(function _callee31$(_context31) {
	                            while (1) {
	                              switch (_context31.prev = _context31.next) {
	                                case 0:
	                                  if (!response.success) {
	                                    _context31.next = 10;
	                                    break;
	                                  }
	
	                                  i = 0;
	
	                                case 2:
	                                  if (!(i < response.questions.length)) {
	                                    _context31.next = 10;
	                                    break;
	                                  }
	
	                                  if (!(response.questions[i].id === reading.question_id)) {
	                                    _context31.next = 7;
	                                    break;
	                                  }
	
	                                  offset = i;
	                                  _this.context.router.push({
	                                    pathname: ('' + _AppRoutes2.default.CFA2_2025_BEGIN_NOTES).replace(':notesid', chapter_id).replace(':readingid', response.questions[i].reading_id_2025).replace(':id', reading.question_id).replace(':offset', offset)
	                                  });
	                                  return _context31.abrupt('break', 10);
	
	                                case 7:
	                                  i++;
	                                  _context31.next = 2;
	                                  break;
	
	                                case 10:
	                                case 'end':
	                                  return _context31.stop();
	                              }
	                            }
	                          }, _callee31, _this2);
	                        }));
	
	                        return function (_x25) {
	                          return _ref32.apply(this, arguments);
	                        };
	                      }());
	                    } else {
	                      (0, _toast.showFailure)('Notes unavailable');
	                    }
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context32.stop();
	            }
	          }
	        }, _callee32, _this2);
	      }));
	
	      return function (_x23, _x24) {
	        return _ref31.apply(this, arguments);
	      };
	    }();
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSaveNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savednotes');
	    };
	
	    _this._deleteSaveVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsnotes');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._deleteCBTReportsquestino = function (items) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('CBTreportsquestion');
	    };
	
	    _this.getCBTQestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee34() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee34$(_context34) {
	        while (1) {
	          switch (_context34.prev = _context34.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context34.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/getreportedQuestion', data).then(function () {
	                var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(response) {
	                  return _regenerator2.default.wrap(function _callee33$(_context33) {
	                    while (1) {
	                      switch (_context33.prev = _context33.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({
	                              reportquestionCBT: response.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context33.stop();
	                      }
	                    }
	                  }, _callee33, _this2);
	                }));
	
	                return function (_x26) {
	                  return _ref34.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context34.stop();
	          }
	        }
	      }, _callee34, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      token: '',
	      idname: '',
	      flashreport: [], //All Flash question Store
	      savedquestion: [],
	      reportquestion: [],
	      progress_bar_zero: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      bar_chapter: '',
	      activeTabFlashcards: '1',
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      bar_level_main: ['Ethics', 'Quants', 'Econ', 'FRA', 'Corpo', 'Portfolio', 'Equity', 'Fixed Income', 'Derivatives', 'Al'],
	      bar_main_user: [],
	      bar_main_class: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      subreadings_status: false,
	      ErrorMessage: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      display_main_loader: 'show_block',
	      qpLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	
	      notesFlashReport: [],
	      videoFlashReport: [],
	      savednotes: [],
	      savedvideo: [],
	      reportnotes: [],
	      reportsvideo: [],
	      reportquestionCBT: [],
	      isVideo: '',
	      npLoader: true,
	      selectedmenu: 'cfa_2'
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.OpenEditNotesReport = _this.OpenEditNotesReport.bind(_this);
	    _this.OpenEditCBTQuesReport = _this.OpenEditCBTQuesReport.bind(_this);
	    _this.CloseEditNotesReport = _this.CloseEditNotesReport.bind(_this);
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa2Dashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, type) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: type === 'videoReport' ? item['cfa2_2025_video_reports.id'] : item.id,
	        type: type
	      });
	    }
	    // function to view cbt question
	
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'OpenEditCBTQuesReport',
	    value: function OpenEditCBTQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        cbtquesReport: item.comment,
	        type: 'cbtquesReport'
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate != '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this3 = this;
	
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second
	          };
	          // Get Notes Progress By User
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/getNotesProgressByUser', data).then(function (response) {
	            var notesProgress = response.notesProgress,
	                success = response.success;
	
	            if (success) {
	              _this3.setState({ progress_bar: notesProgress });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/getQuestionProgressByUser', data).then(function (response) {
	            var questionProgress = response.questionProgress,
	                success = response.success;
	
	            if (success) {
	              _this3.setState({ bar_chapter: questionProgress });
	              _this3.setState({ progress_bar_zero: questionProgress });
	            }
	          });
	          // Get Main Progress Bar
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/mainProgressbar', data).then(function (response) {
	            if (response.success) {
	              var dataString = JSON.stringify(response.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this3.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block'
	              });
	            } else {
	              _this3.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/mainProgressclassbar', data).then(function (response) {
	            if (response.success) {
	              var dataString = JSON.stringify(response.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this3.setState({ bar_main_class: final_array_main });
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee38() {
	        var _this4 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee38$(_context38) {
	          while (1) {
	            switch (_context38.prev = _context38.next) {
	              case 0:
	                window.scroll(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (response) {
	                  if (response.success) {
	                    _this4.setState({ ValidToken: true });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChapters', data).then(function (response) {
	                  if (response.success) {
	                    _this4.setState({ ValidToken: true });
	                    _this4.setState({ chapters: response.chapters });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                  return response;
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/getQuestionProgressByUser', data).then(function (response) {
	                  var success = response.success,
	                      questionProgress = response.questionProgress;
	
	                  if (success) {
	                    _this4.setState({
	                      progress_bar_zero: questionProgress,
	                      qpLoader: false
	                    });
	                    _this4.setState({ bar_chapter: questionProgress });
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/mainProgressbar', data).then(function (response) {
	                  if (response.success) {
	                    _this4.setState({ display_main_loader: 'hide_block' });
	                    var dataString = JSON.stringify(response.chapters);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	                      final_array_main.push(user_graph_val);
	                    }
	                    _this4.setState({ bar_main_user: final_array_main });
	                  }
	                });
	
	                this.setState({ display_main_loader: 'show_block' });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/mainProgressclassbar', data).then(function (response) {
	                  if (response.success) {
	                    var dataString = JSON.stringify(response.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	                      final_array_main.push(user_graph_val);
	                    }
	                    _this4.setState({ bar_main_class: final_array_main });
	                  }
	                });
	
	                // --------------------------------- START -----------------------------------
	
	                // A workaround for old functionality
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee36() {
	                  var response, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee36$(_context36) {
	                    while (1) {
	                      switch (_context36.prev = _context36.next) {
	                        case 0:
	                          response = _userStore2.default;
	
	                          if (!(response == null || response.profileInfo == null)) {
	                            _context36.next = 3;
	                            break;
	                          }
	
	                          return _context36.abrupt('return');
	
	                        case 3:
	
	                          if (response.profileInfo) {
	                            _this4.setState({
	                              isVideo: response.profileInfo.isVideo
	                            });
	                          }
	
	                          if (!(response.profileInfo ? response.profileInfo.role === 'partner' : 0)) {
	                            _context36.next = 17;
	                            break;
	                          }
	
	                          if (!(response.profileInfo.exam_selected === '' && response.profileInfo.exam_package === '')) {
	                            _context36.next = 9;
	                            break;
	                          }
	
	                          _this4.setState({
	                            showFreePremium: true
	                          });
	                          _context36.next = 15;
	                          break;
	
	                        case 9:
	                          subscription_details = response.profileInfo.subscription_details ? JSON.parse(response.profileInfo.subscription_details) : response.profileInfo.subscription_details;
	
	
	                          _this4.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam
	                          });
	
	                          data_arr = response.profileInfo.exam_selected ? JSON.parse(response.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this4.state.token,
	                            idname: _this4.state.idname,
	                            examid: data_arr
	                          };
	                          _context36.next = 15;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee35$(_context35) {
	                                while (1) {
	                                  switch (_context35.prev = _context35.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context35.next = 11;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this4.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context35.next = 6;
	                                      return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context35.sent;
	
	                                      if (isInArray_var) {
	                                        _this4.setState({ showFreePremium: false });
	                                      } else {
	                                        _this4.setState({ showFreePremium: true });
	                                      }
	                                      if (!isInArray_var) {
	                                        isInArray_var = _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                        if (isInArray_var) {
	                                          _this4.setState({ showFreePremium: false });
	                                        } else {
	                                          _this4.setState({ showFreePremium: true });
	                                        }
	                                      }
	                                      _context35.next = 11;
	                                      break;
	
	                                    case 11:
	                                    case 'end':
	                                      return _context35.stop();
	                                  }
	                                }
	                              }, _callee35, _this4);
	                            }));
	
	                            return function (_x27) {
	                              return _ref37.apply(this, arguments);
	                            };
	                          }());
	
	                        case 15:
	                          _context36.next = 27;
	                          break;
	
	                        case 17:
	                          if (!(response.profileInfo.exam_selected === '' && response.profileInfo.cfaUnlimitedPackage == '' && response.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context36.next = 21;
	                            break;
	                          }
	
	                          _this4.setState({
	                            showFreePremium: true
	                          });
	                          _context36.next = 27;
	                          break;
	
	                        case 21:
	                          subscription_details = response.profileInfo.subscription_details ? JSON.parse(response.profileInfo.subscription_details) : response.profileInfo.subscription_details;
	
	
	                          _this4.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = response.profileInfo.exam_selected ? JSON.parse(response.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this4.state.token,
	                            idname: _this4.state.idname,
	                            examid: data_arr
	                          };
	                          _context36.next = 27;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this4.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                              if (isInArray_var) {
	                                _this4.setState({ showFreePremium: false });
	                              } else {
	                                _this4.setState({ showFreePremium: true });
	                              }
	                              if (!isInArray_var) {
	                                isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                if (isInArray_var) {
	                                  _this4.setState({ showFreePremium: false });
	                                } else {
	                                  _this4.setState({ showFreePremium: true });
	                                }
	                              }
	                            } else {}
	                          });
	
	                        case 27:
	                        case 'end':
	                          return _context36.stop();
	                      }
	                    }
	                  }, _callee36, _this4);
	                })));
	
	                // const getProfileInfoData = {
	                //   token: storage_session['token'],
	                //   idname: storage_session['idname'],
	                // };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfoData).then(
	                //   async (response) => {
	                //     if (response.profileInfo) {
	                //       this.setState({
	                //         isVideo: response.profileInfo.isVideo,
	                //       });
	                //     }
	                //     if (response.profileInfo ? response.profileInfo.role === 'partner' : 0) {
	                //       if (
	                //         response.profileInfo.exam_selected === '' &&
	                //         response.profileInfo.exam_package === ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //         });
	                //       } else {
	                //         var subscription_details = response.profileInfo.subscription_details
	                //           ? JSON.parse(response.profileInfo.subscription_details)
	                //           : response.profileInfo.subscription_details;
	                //
	                //         this.setState({
	                //           subscription_details: subscription_details,
	                //           cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //
	                //         var data_arr = response.profileInfo.exam_selected
	                //           ? JSON.parse(response.profileInfo.exam_selected)
	                //           : null;
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
	                //           async (resp_exam) => {
	                //             if (resp_exam.success) {
	                //               var exam_data = resp_exam.examData;
	                //               var selectedmen = this.state.selectedmenu;
	                //               var isInArray_var = false;
	                //               isInArray_var = await PartnerCfaSubscriptionCheck.checkCfa2Subscription(
	                //                 selectedmen,
	                //                 exam_data,
	                //                 this.state.cfaUnlimitedPackage,
	                //                 this.state.cfaUnlimitedActiveExam,
	                //               );
	                //               if (isInArray_var) {
	                //                 this.setState({ showFreePremium: false });
	                //               } else {
	                //                 this.setState({ showFreePremium: true });
	                //               }
	                //               if (!isInArray_var) {
	                //                 isInArray_var = PartnerCfaSubscriptionCheck.checkCfa2VideosSubscription(
	                //                   selectedmen,
	                //                   exam_data,
	                //                   this.state.cfaUnlimitedPackage,
	                //                   this.state.cfaUnlimitedActiveExam,
	                //                 );
	                //                 if (isInArray_var) {
	                //                   this.setState({ showFreePremium: false });
	                //                 } else {
	                //                   this.setState({ showFreePremium: true });
	                //                 }
	                //               }
	                //             } else {
	                //             }
	                //           },
	                //         );
	                //       }
	                //     } else {
	                //       if (
	                //         response.profileInfo.exam_selected === '' &&
	                //         response.profileInfo.cfaUnlimitedPackage == '' &&
	                //         response.profileInfo.cfaUnlimitedActiveExam == ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //         });
	                //       } else {
	                //         var subscription_details = response.profileInfo.subscription_details
	                //           ? JSON.parse(response.profileInfo.subscription_details)
	                //           : response.profileInfo.subscription_details;
	                //
	                //         this.setState({
	                //           subscription_details: subscription_details,
	                //           cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //         var data_arr = response.profileInfo.exam_selected
	                //           ? JSON.parse(response.profileInfo.exam_selected)
	                //           : null;
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
	                //           (resp_exam) => {
	                //             if (resp_exam.success) {
	                //               var exam_data = resp_exam.examData;
	                //               var selectedmen = this.state.selectedmenu;
	                //               var isInArray_var = false;
	                //               isInArray_var = CfaSubscriptionCheck.checkCfa2Subscription(
	                //                 selectedmen,
	                //                 exam_data,
	                //                 this.state.cfaUnlimitedPackage,
	                //                 this.state.cfaUnlimitedActiveExam,
	                //               );
	                //               if (isInArray_var) {
	                //                 this.setState({ showFreePremium: false });
	                //               } else {
	                //                 this.setState({ showFreePremium: true });
	                //               }
	                //               if (!isInArray_var) {
	                //                 isInArray_var = CfaSubscriptionCheck.checkCfa2VideosSubscription(
	                //                   selectedmen,
	                //                   exam_data,
	                //                   this.state.cfaUnlimitedPackage,
	                //                   this.state.cfaUnlimitedActiveExam,
	                //                 );
	                //                 if (isInArray_var) {
	                //                   this.setState({ showFreePremium: false });
	                //                 } else {
	                //                   this.setState({ showFreePremium: true });
	                //                 }
	                //               }
	                //             } else {
	                //             }
	                //           },
	                //         );
	                //       }
	                //     }
	                //   },
	                // );
	
	                _context38.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025dashboard/getNotesProgressByUser', data).then(function () {
	                  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(response) {
	                    var success, notesProgress;
	                    return _regenerator2.default.wrap(function _callee37$(_context37) {
	                      while (1) {
	                        switch (_context37.prev = _context37.next) {
	                          case 0:
	                            success = response.success, notesProgress = response.notesProgress;
	
	                            if (response.success) {
	                              _this4.setState({
	                                progress_bar: response.notesProgress,
	                                npLoader: false
	                              });
	                            }
	
	                          case 2:
	                          case 'end':
	                            return _context37.stop();
	                        }
	                      }
	                    }, _callee37, _this4);
	                  }));
	
	                  return function (_x28) {
	                    return _ref38.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context38.next = 16;
	                return this.getQuestionFlashcards();
	
	              case 16:
	                _context38.next = 18;
	                return this.getQuestionSaved();
	
	              case 18:
	                this.getQuestionReports();
	
	                _context38.next = 21;
	                return this.getNotesFlashcards();
	
	              case 21:
	                _context38.next = 23;
	                return this.getNotesSaved();
	
	              case 23:
	                _context38.next = 25;
	                return this.getNotesReports();
	
	              case 25:
	                _context38.next = 27;
	                return this.getVideoFlashcards();
	
	              case 27:
	                _context38.next = 29;
	                return this.getVideosSaved();
	
	              case 29:
	                _context38.next = 31;
	                return this.getVideoReports();
	
	              case 31:
	                _context38.next = 33;
	                return this.getCBTQestionReports();
	
	              case 33:
	              case 'end':
	                return _context38.stop();
	            }
	          }
	        }, _callee38, this);
	      }));
	
	      function componentDidMount() {
	        return _ref35.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	
	    // function for get  question report
	
	
	    // function for get  question FlashCard
	
	
	    // function for get  question report
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.totalQuestions / item.attemptedQuestions * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                _language2.default.LC().Q,
	                item.id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        ErrorMessage: ''
	      });
	    }
	
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(event) {
	        var _this5 = this;
	
	        var _state, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee40$(_context40) {
	          while (1) {
	            switch (_context40.prev = _context40.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context40.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context40.abrupt('return');
	
	              case 4:
	                _state = this.state, reportEditId = _state.reportEditId, idname = _state.idname, token = _state.token, quesReport = _state.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context40.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(response) {
	                    return _regenerator2.default.wrap(function _callee39$(_context39) {
	                      while (1) {
	                        switch (_context39.prev = _context39.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context39.next = 6;
	                              break;
	                            }
	
	                            _this5.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this5.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context39.next = 4;
	                            return _this5.getQuestionReports();
	
	                          case 4:
	                            _context39.next = 7;
	                            break;
	
	                          case 6:
	                            _this5.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context39.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context39.stop();
	                        }
	                      }
	                    }, _callee39, _this5);
	                  }));
	
	                  return function (_x30) {
	                    return _ref40.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context40.stop();
	            }
	          }
	        }, _callee40, this);
	      }));
	
	      function handleQuestionReportSubmit(_x29) {
	        return _ref39.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: type === 'videoReport' ? data['cfa2_2025_video_reports.id'] : data.id,
	          contactIndex: index,
	          contactStatus: true,
	          contactType: type
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditNotesReport',
	    value: function CloseEditNotesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        notesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item['cfa2_2025_video_reports.id'],
	        videoReport: item['cfa2_2025_video_reports.comment'],
	        type: 'videoReport'
	      });
	    }
	  }, {
	    key: 'OpenEditNotesReport',
	    value: function OpenEditNotesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        notesReport: item.comment,
	        type: 'notesReport'
	      });
	    }
	    // function for get  notes report
	
	
	    // function for get  notes report
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  video report
	
	
	    /*
	     * get saved all video
	     */
	
	
	    // function for get  notes report
	
	  }, {
	    key: 'notesProgressBarFun',
	    value: function notesProgressBarFun() {
	      return this.state.progress_bar.map(function (item, index) {
	        var progresstotalques = item.totalNotes;
	        var progressnotes = Math.round(item.attemptedNotes / progresstotalques * 100);
	        if (progressnotes < 1) {
	          progressnotes = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                item.chapter_id_2025
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes,
	                      style: { width: progressnotes + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'handleNotesReportSubmit',
	
	    // notes form submit function
	    value: function () {
	      var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(event) {
	        var _this6 = this;
	
	        var _state2, reportEditId, idname, token, notesReport, data;
	
	        return _regenerator2.default.wrap(function _callee42$(_context42) {
	          while (1) {
	            switch (_context42.prev = _context42.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport === '' && this.state.notesReport.length < 1)) {
	                  _context42.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context42.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, notesReport = _state2.notesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport
	                };
	                _context42.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(response) {
	                    return _regenerator2.default.wrap(function _callee41$(_context41) {
	                      while (1) {
	                        switch (_context41.prev = _context41.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context41.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              notesReport: ''
	                            });
	                            _context41.next = 4;
	                            return _this6.getNotesReports();
	
	                          case 4:
	                            _context41.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context41.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context41.stop();
	                        }
	                      }
	                    }, _callee41, _this6);
	                  }));
	
	                  return function (_x32) {
	                    return _ref42.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context42.stop();
	            }
	          }
	        }, _callee42, this);
	      }));
	
	      function handleNotesReportSubmit(_x31) {
	        return _ref41.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit;
	    }()
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee44$(_context44) {
	          while (1) {
	            switch (_context44.prev = _context44.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context44.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context44.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, videoReport = _state3.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context44.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(response) {
	                    return _regenerator2.default.wrap(function _callee43$(_context43) {
	                      while (1) {
	                        switch (_context43.prev = _context43.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context43.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context43.next = 4;
	                            return _this7.getVideoReports();
	
	                          case 4:
	                            _context43.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context43.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context43.stop();
	                        }
	                      }
	                    }, _callee43, _this7);
	                  }));
	
	                  return function (_x34) {
	                    return _ref44.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context44.stop();
	            }
	          }
	        }, _callee44, this);
	      }));
	
	      function handleVideoReportSubmit(_x33) {
	        return _ref43.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	    /*
	     * function for go to specific notes main page
	     */
	
	    // function to get cbt question reports
	
	  }, {
	    key: 'handleCBTQuestionReportSubmit',
	    value: function () {
	      var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(event) {
	        var _this8 = this;
	
	        var _state4, reportEditId, idname, token, cbtquesReport, data;
	
	        return _regenerator2.default.wrap(function _callee46$(_context46) {
	          while (1) {
	            switch (_context46.prev = _context46.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.cbtquesReport === '' && this.state.cbtquesReport.length < 1)) {
	                  _context46.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context46.abrupt('return');
	
	              case 4:
	                _state4 = this.state, reportEditId = _state4.reportEditId, idname = _state4.idname, token = _state4.token, cbtquesReport = _state4.cbtquesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: cbtquesReport
	                };
	                _context46.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams/updateReport', data).then(function () {
	                  var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(response) {
	                    return _regenerator2.default.wrap(function _callee45$(_context45) {
	                      while (1) {
	                        switch (_context45.prev = _context45.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context45.next = 6;
	                              break;
	                            }
	
	                            _this8.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this8.state.reportEditStatus,
	                              reportEditId: '',
	                              cbtquesReport: ''
	                            });
	                            _context45.next = 4;
	                            return _this8.getCBTQestionReports();
	
	                          case 4:
	                            _context45.next = 7;
	                            break;
	
	                          case 6:
	                            _this8.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context45.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context45.stop();
	                        }
	                      }
	                    }, _callee45, _this8);
	                  }));
	
	                  return function (_x36) {
	                    return _ref46.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context46.stop();
	            }
	          }
	        }, _callee46, this);
	      }));
	
	      function handleCBTQuestionReportSubmit(_x35) {
	        return _ref45.apply(this, arguments);
	      }
	
	      return handleCBTQuestionReportSubmit;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state5 = this.state,
	          activeTabFlashcards = _state5.activeTabFlashcards,
	          activeTabSaved = _state5.activeTabSaved,
	          activeTabReports = _state5.activeTabReports,
	          qpLoader = _state5.qpLoader,
	          savedLoader = _state5.savedLoader,
	          flashLoader = _state5.flashLoader,
	          reportLoader = _state5.reportLoader,
	          isVideo = _state5.isVideo,
	          npLoader = _state5.npLoader;
	
	      var flashreport_val = this.state.flashreport;
	      var savedquestion_val = this.state.savedquestion;
	      var reportquestion_val = this.state.reportquestion;
	      var progress_bar_zero_val = this.state.progress_bar_zero;
	
	      var notes_flashreport_val = this.state.notesFlashReport;
	      var video_flashreport_val = this.state.videoFlashReport;
	      var savednotes_val = this.state.savednotes;
	      var savedvideo_val = this.state.savedvideo;
	      var reportnotes_val = this.state.reportnotes;
	      var reportvideo_val = this.state.reportsvideo;
	      var notes_flashcard_data = '';
	      var video_flashcard_data = '';
	      var savednotes_data = '';
	      var savedvideo_data = '';
	      var notes_reportsData = ''; // for notes report
	      var video_reportsData = ''; // for video report
	
	      var flashcard_data = '';
	      var savedquestion_data = '';
	      var question_reportsData = ''; // for question reports
	      var reportquestionCBT_val = this.state.reportquestionCBT;
	      var cbt_reportsData = ''; // for cbt question reports
	      var progress_bar_data = '';
	      /*first main graph*/
	      var main_bar_val = this.state.bar_chapter;
	      var main_bar_percentage = this.state.bar_main_user;
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	
	      Object.keys(main_bar_val).map(function (key) {
	        var dataString = JSON.stringify(main_bar_val[key]);
	        var dataReason = JSON.parse(dataString);
	        main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
	        var chapter_id = dataReason.chapter_id;
	
	        i++;
	      });
	
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	
	      var savQuestionTabs = [{ id: '1', label: _language2.default.LC().QUESTIONS }, { id: '2', label: _language2.default.LC().Notes }, isVideo && { id: '3', label: _language2.default.LC().VIDEOS }].filter(Boolean);
	
	      var tabs = [{ id: '1', label: _language2.default.LC().QUESTIONS }, { id: '2', label: _language2.default.LC().Notes }, isVideo && { id: '3', label: _language2.default.LC().VIDEOS }, { id: '4', label: 'Mocks' }].filter(Boolean);
	
	      var chapters = this.state.chapters;
	      var reading_data = '';
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.notesFlashReport.length) {
	        notes_flashcard_data = notes_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteNotesFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteVideoFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSavequestion.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditQuesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id,
	                  toggle: _this9.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleQuestionReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id,
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index)
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index)
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      (0, _function.renderHTMLContent)(items.answer, 'span')
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsquestino.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.comment, 'span')
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.savednotes.length) {
	        savednotes_data = savednotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSaveNotes.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items['cfa2_note.name_2025'] && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items['cfa2_note.name_2025'], 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_NOTES,
	          ' '
	        );
	      }
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSaveVideo.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items['cfa2_video.title'] && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items['cfa2_video.title'], 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      if (this.state.reportnotes.length) {
	        notes_reportsData = reportnotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditNotesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'notesReport',
	                  toggle: _this9.OpenEditNotesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items['cfa2_note.name_2025'], 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditNotesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleNotesReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'notesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.notesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditNotesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items, 'notesReport'),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'notesReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items['cfa2_note.name_2025'], 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'notesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'notesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'notesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'notesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsNotes.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items['cfa2_note.name_2025'], 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            {
	              id: 'reportsvideos_' + items['cfa2_2025_video_reports.id'],
	              key: index,
	              className: 'flash_card_box'
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items['cfa2_2025_video_reports.id']
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items['cfa2_2025_video_reports.status'] === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items['cfa2_2025_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items['cfa2_2025_video_reports.video_id']
	              ),
	              !items['cfa2_2025_video_reports.isSend'] && !items['cfa2_2025_video_reports.reply'] && items['cfa2_2025_video_reports.status'] !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditVideoReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items['cfa2_2025_video_reports.id'] && _this9.state.type === 'videoReport',
	                  toggle: _this9.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items['cfa2_2025_video_reports.video_id'],
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleVideoReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items['cfa2_2025_video_reports.reply'] ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items, 'videoReport'),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items['cfa2_2025_video_reports.id'] && _this9.state.type === 'videoReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items['cfa2_2025_video_reports.video_id'],
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _function.renderSanitizedHTML)(items.topic_name)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'videoReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'videoReport' && _this9.state.contactID === items['cfa2_2025_video_reports.id'] && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items['cfa2_2025_video_reports.reply'])
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsVideo.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items['cfa2_2025_video_reports.comment'])
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	      if (this.state.reportquestionCBT.length) {
	        cbt_reportsData = reportquestionCBT_val.map(function (items, index) {
	          var parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
	          var mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditCBTQuesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'cbtquesReport',
	                  toggle: _this9.OpenEditCBTQuesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(mockName, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditCBTQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleCBTQuestionReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'cbtquesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.cbtquesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditCBTQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this9.view(items);
	                    },
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply && items.reply.length > 0 ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this9.toggleAlertReport.bind(_this9, items, 'cbtquesReport'),
	                  className: _this9.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'cbtquesReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _function.renderSanitizedHTML)(items.topic_name)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'cbtquesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'cbtquesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'cbtquesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'cbtquesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteCBTReportsquestino.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        cbt_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().CFA_LEVEL_II_2023_DASHBOARD
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().TO
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    savQuestionTabs.map(function (tab) {
	                      return _react2.default.createElement(Tab, {
	                        key: tab.id,
	                        id: tab.id,
	                        label: tab.label,
	                        isActive: activeTabSaved === tab.id,
	                        onClick: _this9.savedTabToggle
	                      });
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : this.state.activeTabSaved === '2' ? savednotes_data : savedvideo_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    tabs.map(function (tab) {
	                      return _react2.default.createElement(Tab, {
	                        key: tab.id,
	                        id: tab.id,
	                        label: tab.label,
	                        isActive: activeTabReports === tab.id,
	                        onClick: _this9.reportsTabToggle
	                      });
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : this.state.activeTabReports === '2' ? notes_reportsData : this.state.activeTabReports === '3' ? video_reportsData : cbt_reportsData
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    npLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.notesProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'close', 'aria-label': 'Close', onClick: this.toggleClose },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2Dashboard;
	}(_react.Component);
	
	Cfa2Dashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this10 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this10.toggle = _this10.toggle.bind(_this10);
	    _this10.state = {
	      tooltipOpen: false
	    };
	    return _this10;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	var Tab = function Tab(_ref47) {
	  var id = _ref47.id,
	      label = _ref47.label,
	      isActive = _ref47.isActive,
	      _onClick = _ref47.onClick;
	  return _react2.default.createElement(
	    'li',
	    { onClick: function onClick() {
	        return _onClick(id);
	      }, className: isActive ? 'active' : '' },
	    _react2.default.createElement(
	      'span',
	      null,
	      label
	    )
	  );
	};
	exports.default = Cfa2Dashboard;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _questionNotFoundModel = __webpack_require__(104);
	
	var _questionNotFoundModel2 = _interopRequireDefault(_questionNotFoundModel);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	// import { getIpAddress } from '../../../common/getIpAddress';
	
	
	/* eslint-disable*/
	var Cfa2notesreadings = function (_Component) {
	  _inherits(Cfa2notesreadings, _Component);
	
	  function Cfa2notesreadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2notesreadings);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2notesreadings.__proto__ || Object.getPrototypeOf(Cfa2notesreadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '' + _AppRoutes2.default.CFA2_2025_NOTES,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      console.log(reading.reading);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: ('' + _AppRoutes2.default.CFA2_2025_NOTES_QUES_VIEW).replace(':chapter_no', reading.chapter_no).replace(':id', reading.id).replace(':reading', reading.reading),
	              state: {
	                reading: reading,
	                chapter: _this.state.chapterid
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            //  : '/cfa2beginnotes/:notesid/:readingid/:id/:chapter/:chapter_no/:offset',
	            _this.context.router.push({
	              pathname: ('' + _AppRoutes2.default.CFA2_2025_BEGIN_NOTES).replace(':notesid', reading.chapter_no).replace(':readingid', reading.id).replace(':id', resp.questions[0].id).replace(':chapter', _this.props.params.chapter).replace(':chapter_no', reading.chapter_no).replace(':offset', 0)
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.checkSubscriptions = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              console.log('getDerivedStateFromProps for check subscription===============>');
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              if (storage_session) {
	                _this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	              }
	              data = {
	                idname: storage_session['idname'],
	                token: storage_session['token'],
	                chapter: _this.state.chapterid
	              };
	
	              // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	              _userStore2.default.getUserProfile(true).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context.next = 12;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context.next = 5;
	                            break;
	                          }
	
	                          _this.setState({
	                            showFreePremium: true,
	                            subscriptionstatus: 'free'
	                          });
	                          _context.next = 10;
	                          break;
	
	                        case 5:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context.next = 10;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this.state.selectedmenu;
	                              var isInArray_var = false;
	                              var examPlanData = resp_exam.examPlan[0];
	                              isInArray_var = _Cfa2Subscription4.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type, examPlanData);
	                              if (isInArray_var) {
	                                _this.setState({ showFreePremium: false });
	                              } else {
	                                _this.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 10:
	                          _context.next = 24;
	                          break;
	
	                        case 12:
	                          console.log('hello in this');
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context.next = 17;
	                            break;
	                          }
	
	                          _this.setState({
	                            showFreePremium: true,
	                            subscriptionstatus: 'free'
	                          });
	                          _context.next = 24;
	                          break;
	
	                        case 17:
	                          console.log('enter');
	
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                          console.log('dsarafaygdu', data_arr);
	
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context.next = 24;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            console.log(resp_exam);
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this.state.selectedmenu;
	                              var isInArray_var = false;
	
	                              isInArray_var = _Cfa2Subscription2.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	                              console.log(isInArray_var);
	                              if (isInArray_var) {
	                                _this.setState({ showFreePremium: false, checkSubscriptionState: true });
	                              } else {
	                                _this.setState({ showFreePremium: true, checkSubscriptionState: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 24:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getpdf = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(_this.state.pdfLoading === false)) {
	                  _context6.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context6.abrupt('return');
	
	              case 3:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context6.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context5.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context5.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context5.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context3.next = 7;
	                                        return _Cfa2Subscription4.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context3.sent;
	
	                                        if (!isInArray_var) {
	                                          _context3.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context3.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context3.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.toggleAlert();
	
	                                      case 16:
	                                        _context3.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context5.next = 21;
	                            break;
	
	                          case 12:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context5.next = 16;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context5.next = 21;
	                            break;
	
	                          case 16:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 21;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context4.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context4.next = 6;
	                                        return _Cfa2Subscription2.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context4.sent;
	
	                                        if (!isInArray_var) {
	                                          _context4.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context4.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context4.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context4.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref6.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 21:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.chapter,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      chapterName: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      checkSubscriptionState: false,
	      type: 'notes',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      pdfLoading: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      alert_status_question_not_found: false,
	      MessageTitleOnQuestionNotFound: '' + _language2.default.LC().NOTES,
	      MessageContentOnQuestionNotFound: '' + _language2.default.LC().NOTE_NOT_FOUND,
	      subscriptionstatus: ''
	    };
	    _this.checkSubscriptions();
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa2notesreadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      console.log('this.state.subscriptionstatus ', this.state.showFreePremium);
	      if (this.state.showFreePremium) {
	        this.setState({
	          alert_status: !this.state.alert_status
	        });
	      } else {
	        this.setState({
	          alert_status_question_not_found: !this.state.alert_status_question_not_found
	        });
	      }
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to cfanotes page
	
	
	    //Function to redirect page to notesviewquestion  page
	
	
	    //Function to redirect page on specifc questions
	
	
	    // getDerivedStateFromProps for check subscription
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                // await this.checkSubscriptions()
	                window.scrollTo(0, 0);
	                // api to get ip address
	                // const result = await getIpAddress();
	                // if (result) {
	                //   this.setState({
	                //     user_city: result.city,
	                //     user_country: result.country,
	                //     user_ip: result.query,
	                //     user_state: result.region,
	                //     user_continent: result.continent,
	                //   });
	                // }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter: this.state.chapterid
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
	                //   async (resp) => {
	                //     // console.log("resp", resp);
	                //     if (resp.profileInfo.role === 'partner') {
	                //       if (
	                //         resp.profileInfo.exam_selected === '' &&
	                //         resp.profileInfo.exam_package === ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //           subscriptionstatus: 'free',
	                //         });
	                //       } else {
	                //         this.setState({
	                //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //         var data_arr = resp.profileInfo.exam_selected
	                //           ? JSON.parse(resp.profileInfo.exam_selected)
	                //           : null;
	
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(
	                //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
	                //           dataset
	                //         ).then((resp_exam) => {
	                //           if (resp_exam.success) {
	                //             var exam_data = resp_exam.examData;
	                //             var selectedmen = this.state.selectedmenu;
	                //             var isInArray_var = false;
	                //             isInArray_var = PartnerCfa2SubscriptionCheck.checkCfa2PDFSubscription(
	                //               selectedmen,
	                //               exam_data,
	                //               this.state.cfaUnlimitedPackage,
	                //               this.state.cfaUnlimitedActiveExam,
	                //               this.state.type
	                //             );
	                //             console.log(isInArray_var);
	                //             if (isInArray_var) {
	                //               this.setState({ showFreePremium: false });
	                //             } else {
	                //               this.setState({ showFreePremium: true });
	                //             }
	                //           } else {
	                //             // console.log('fail');
	                //           }
	                //         });
	                //       }
	                //     } else {
	                //       console.log('hello in this');
	                //       if (
	                //         resp.profileInfo.exam_selected === '' &&
	                //         resp.profileInfo.cfaUnlimitedPackage == '' &&
	                //         resp.profileInfo.cfaUnlimitedActiveExam == ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //           subscriptionstatus: 'free',
	                //         });
	                //       } else {
	                //         console.log('enter');
	
	                //         this.setState({
	                //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //         var data_arr = resp.profileInfo.exam_selected
	                //           ? JSON.parse(resp.profileInfo.exam_selected)
	                //           : null;
	                //         console.log('dsarafaygdu', data_arr);
	
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(
	                //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
	                //           dataset
	                //         ).then((resp_exam) => {
	                //           console.log(resp_exam);
	                //           if (resp_exam.success) {
	                //             var exam_data = resp_exam.examData;
	                //             var selectedmen = this.state.selectedmenu;
	                //             var isInArray_var = false;
	
	                //             isInArray_var = Cfa2SubscriptionCheck.checkCfa2PDFSubscription(
	                //               selectedmen,
	                //               exam_data,
	                //               this.state.cfaUnlimitedPackage,
	                //               this.state.cfaUnlimitedActiveExam,
	                //               this.state.type
	                //             );
	                //             console.log(isInArray_var);
	                //             if (isInArray_var) {
	                //               this.setState({ showFreePremium: false });
	                //             } else {
	                //               this.setState({ showFreePremium: true });
	                //             }
	                //           } else {
	                //             // console.log('fail');
	                //           }
	                //         });
	                //       }
	                //     }
	                //   }
	                // );
	
	                console.log('I am here -----> ');
	                _context7.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this3.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
	                    }
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '' + _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	    --------------------
	    PDF DOWNLOAD VIA EMAIL
	    --------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading_order,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23'
	                  // aria-disabled={this.state.checkSubscriptionState}
	                  , onClick: _this4._getQuestions.bind(_this4, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21'
	                  // aria-disabled={this.state.checkSubscriptionState}
	
	                  , id: item.id,
	                  onClick: _this4._beginChapter.bind(_this4, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_NOTES_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.chapterName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 notes-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Notes : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CHAPTER_READINGS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().READING
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_questionNotFoundModel2.default, {
	          alert_status: this.state.alert_status_question_not_found,
	          toggleAlert: this.toggleAlert,
	          MessageTitle: this.state.MessageTitleOnQuestionNotFound,
	          MessageContent: this.state.MessageContentOnQuestionNotFound
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Cfa2notesreadings;
	}(_react.Component);
	
	Cfa2notesreadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa2notesreadings;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _axios = __webpack_require__(102);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _fileSaver = __webpack_require__(151);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfanotesbeginchapters = function (_Component) {
	  _inherits(Cfanotesbeginchapters, _Component);
	
	  function Cfanotesbeginchapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfanotesbeginchapters);
	
	    var _this = _possibleConstructorReturn(this, (Cfanotesbeginchapters.__proto__ || Object.getPrototypeOf(Cfanotesbeginchapters)).call(this, props));
	
	    _this._getReadings = function () {
	      var path = _AppRoutes2.default.CFA2_2025_NOTES_READINGS.replace(':chapter', _this.props.params.notesid);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid
	        }
	      });
	    };
	
	    _this._getNotes = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2025_NOTES_QUES_VIEW.replace(':chapter_no', _this.state.questions.chapter_id_2025).replace(':id', _this.props.params.readingid).replace(':reading', _this.state.readings)
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      }), document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	
	      _this.setState({ offset: i, questions: _this.state.all_questions_state[i] });
	
	      //alert((parseInt(this.state.question_length)-1)+'--------'+i);
	      if (parseInt(_this.state.question_length) - 1 == i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i !== 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      console.log('I am here -> ', _this.state.all_questions_state[i], _this.state.all_questions_state[i].id);
	      var next_question_id = _this.state.all_questions_state[i].id;
	      // '/cfa2_2025_beginnotes/:notesid/:readingid/:id/:offset',
	      // the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
	      _this.setState({ reading_name_2025: _this.state.all_questions_state[i].name_2025 || '' });
	
	      var path = _AppRoutes2.default.CFA2_2025_BEGIN_NOTES.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      //alert(i);
	      // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({
	          next_block: ''
	        });
	      }
	      if (i === 0) {
	        _this.setState({
	          previ_block: 'card hide_block'
	        });
	      }
	
	      _this.setState({
	        questions: _this.state.all_questions_state[i]
	      });
	
	      // the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
	      _this.setState({ reading_name_2025: _this.state.all_questions_state[i].name_2025 || '' });
	
	      var next_question_id = _this.state.all_questions_state[i].id;
	      // '/cfa2_2025_beginnotes/:notesid/:readingid/:id/:offset',
	      var path = _AppRoutes2.default.CFA2_2025_BEGIN_NOTES.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      // console.log('Working');
	
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveNotesstats = function (item, e) {
	      if (_this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        notes_id: item.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            save_question: 'btn btn-success pointer_class margin_right_10'
	          });
	          _this.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	          _this.setState({ markColor: 'green' });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          // FD.callAPI(
	          //   App_data.backend_api + '/cfa2_2025_notes/getFlashCards',
	          //   params
	          // ).then((response) => {
	          //   if (response.success) {
	          //     this.setState({ ValidToken: true });
	          //     if (response.flash_cards.length > 0) {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	          //       });
	          //       var flash_cards = response.flash_cards.map((items, index) => (
	          //         <li key={index}>
	          //           <div className=''>
	          //             <ul className='icon_list'>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._editFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-pencil' />
	          //                 </a>
	          //               </li>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._deleteFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-close' />
	          //                 </a>
	          //               </li>
	          //             </ul>
	          //             <div className={this.state.flash_class}>
	          //               <h4 />
	          //               <p>{items.flash_card}</p>
	          //             </div>
	          //           </div>
	          //         </li>
	          //       ));
	          //     } else {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //       });
	          //       var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     }
	          //     this.setState({ flash_data: flash_cards });
	          //   } else {
	          //     var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     this.setState({ ValidToken: false });
	          //     this.setState({ flash_data: flash_cards });
	          //     this.setState({
	          //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //     });
	          //   }
	          //   return response;
	          // });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getSavedNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getFavNotes', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(all_questions, e) {
	        var url, response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                url = _App_data2.default.backend_api + '/cfa2_2025_notes/getpdfnotes?id=' + all_questions.id;
	                _context2.next = 3;
	                return (0, _axios2.default)({
	                  url: url,
	                  method: 'GET',
	                  responseType: 'blob'
	                });
	
	              case 3:
	                response = _context2.sent;
	
	                (0, _fileSaver.saveAs)(response.data, all_questions.name_2025 + '.pdf');
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavNotes = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/unsaveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/saveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      chapter_id: _this.props.params.chapter_no,
	      reading_id: _this.props.params.readingid,
	      ValidToken: false,
	      offset: 0,
	      limit: 1,
	      reportLoading: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'btn btn-primary pointer_class margin_right_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: '' + _language2.default.LC().MARK_AS_READ,
	      saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      display_loader: '',
	      markColor: '',
	      showCustomerly: false,
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  //Function to redirect page to readings page
	
	
	  //Function to fetch Next question
	
	
	  //Function to fetch previous question
	
	
	  //Function to show Report box
	
	
	  //Function to hide Report box
	
	
	  //Funcion to save new report question
	
	
	  //Function to toggle Comment box
	
	
	  //Function to toggle Flash box
	
	
	  //Function to save notes and display Marked on button
	
	
	  //Function to Save flash Card And display new stored flash card
	
	
	  //Function to Edit Flash card
	
	
	  //Function to delete flash card
	
	
	  _createClass(Cfanotesbeginchapters, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context4.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                window.scroll(0, 0);
	                if (!this.props.params.id) {
	                  this.setState({ previ_block: 'card hide_block' });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.props.params.notesid
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getReadings', data).then(function (resp) {
	                  var getReading = resp.readings.filter(function (item) {
	                    return item.id === parseInt(_this3.props.params.readingid);
	                  })[0];
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: getReading.reading
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes_allcr', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var ques_res, offset_res, i, params;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context3.next = 22;
	                              break;
	                            }
	
	                            _this3.setState({ ValidToken: true });
	                            _this3.setState({ all_questions_state: resp.questions });
	                            ques_res = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this3.props.params.id) {
	                                ques_res = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i === resp.questions.length - 1) {
	                                _this3.setState({ display_loader: 'hide_block' });
	                              }
	                            }
	                            // the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
	                            _this3.setState({ reading_name_2025: ques_res.name_2025 || '' });
	                            _this3.setState({ questions: ques_res });
	                            //console.log(ques_res);
	                            _this3.setState({ offset: offset_res });
	                            _this3.setState({ question_length: resp.questions.length });
	
	                            if (offset_res === 0) {
	                              _this3.setState({ previ_block: 'card hide_block' });
	                            }
	                            //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this3.setState({ next_block: 'card hide_block' });
	                            }
	
	                            _context3.next = 14;
	                            return _this3.getSavedNotes(ques_res.id);
	
	                          case 14:
	                            params = {
	                              token: _this3.state.token,
	                              question_id: ques_res.id,
	                              idname: _this3.state.idname
	                            };
	                            _context3.next = 17;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getsavestatesNotes', params).then(function (response) {
	                              if (response.success) {
	                                // console.log("enter");
	
	                                _this3.setState({
	                                  save_question: 'btn btn-success pointer_class margin_right_10'
	                                });
	                                _this3.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	                                _this3.setState({ markColor: 'green' });
	                              } else {
	                                // console.log("enter else");
	                                setTimeout(_this3.notes_MARKED_AS_READ.bind(_this3, params), 6000);
	                              }
	                              // console.log("respomse", response);
	                            });
	
	                          case 17:
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	                            // await FD.callAPI(
	                            //   App_data.backend_api + '/cfa2_2025_notes/getFlashCards',
	                            //   params
	                            // ).then((response) => {
	                            //   var flash_cards = '';
	                            //   if (response.success) {
	                            //     this.setState({ ValidToken: true });
	                            //     if (response.flash_cards.length > 0) {
	                            //       this.setState({
	                            //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                            //       });
	                            //       flash_cards = response.flash_cards.map((items, index) => (
	                            //         <li key={index}>
	                            //           <div className=''>
	                            //             <ul className='icon_list'>
	                            //               <li>
	                            //                 <a
	                            //                   className='pointer_class'
	                            //                   onClick={this._editFlash.bind(this, items)}
	                            //                 >
	                            //                   <i className='fa fa-pencil' />
	                            //                 </a>
	                            //               </li>
	                            //               <li>
	                            //                 <a
	                            //                   className='pointer_class'
	                            //                   onClick={this._deleteFlash.bind(this, items)}
	                            //                 >
	                            //                   <i className='fa fa-close' />
	                            //                 </a>
	                            //               </li>
	                            //             </ul>
	                            //             <div className={this.state.flash_class}>
	                            //               <h4 />
	                            //               <p>{items.flash_card}</p>
	                            //             </div>
	                            //           </div>
	                            //         </li>
	                            //       ));
	                            //     } else {
	                            //       this.setState({
	                            //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                            //       });
	                            //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                            //     }
	                            //     this.setState({ flash_data: flash_cards });
	                            //   } else {
	                            //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                            //     this.setState({ ValidToken: false });
	                            //     this.setState({ flash_data: flash_cards });
	                            //     this.setState({
	                            //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                            //     });
	                            //   }
	                            //   return response;
	                            // });
	
	                            _this3.setState({ records: '' });
	                            _context3.next = 24;
	                            break;
	
	                          case 22:
	                            _this3.setState({ ValidToken: false });
	                            _this3.setState({ records: 'Result not found.' });
	
	                          case 24:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 13:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'notes_MARKED_AS_READ',
	    value: function notes_MARKED_AS_READ(params) {
	      var _this4 = this;
	
	      // const result = getDeviceDetails();
	      // console.log("params", params);
	      var data = {
	        token: params.token,
	        idname: params.idname,
	        notes_id: params.question_id,
	        city: this.state.user_city,
	        country: this.state.user_country,
	        state: this.state.user_state,
	        continent: this.state.user_continent,
	        ip: this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/saveNotesstats', data).then(function (resp) {
	        // console.log("re",resp);
	
	        if (resp.success) {
	          _this4.setState({ ValidToken: true });
	          _this4.setState({
	            save_question: 'btn btn-success pointer_class margin_right_10'
	          });
	          _this4.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	          _this4.setState({ markColor: 'green' });
	        } else {
	          _this4.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, this.state.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes_allcr', data).then(function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	          var ques_res, i, params;
	          return _regenerator2.default.wrap(function _callee5$(_context5) {
	            while (1) {
	              switch (_context5.prev = _context5.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context5.next = 14;
	                    break;
	                  }
	
	                  _this5.setState({ ValidToken: true });
	                  ques_res = [];
	
	                  for (i = 0; i < resp.questions.length; i++) {
	                    if (resp.questions[i].id == _this5.props.params.id) {
	                      ques_res = resp.questions[i];
	                    }
	                  }
	                  _this5.setState({ questions: ques_res });
	                  _this5.setState({ display_loader: 'hide_block' });
	                  params = {
	                    token: _this5.state.token,
	                    question_id: ques_res.id,
	                    idname: _this5.state.idname
	                  };
	                  _context5.next = 9;
	                  return _this5.getSavedNotes(ques_res.id);
	
	                case 9:
	                  _context5.next = 11;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getsavestatesNotes', params).then(function (response) {
	                    if (response.success) {
	                      _this5.setState({
	                        save_question: 'btn btn-success pointer_class margin_right_10'
	                      });
	                      _this5.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	                      _this5.setState({ markColor: 'green' });
	                    } else {
	                      _this5.setState({ markColor: '#ddd' });
	                      // console.log("work");
	                      setTimeout(_this5.notes_MARKED_AS_READ.bind(_this5, params), 6000);
	                      //
	                    }
	                  });
	
	                case 11:
	                  // await FD.callAPI(
	                  //   App_data.backend_api + '/cfa2_2025_notes/getFlashCards',
	                  //   params
	                  // ).then((response) => {
	                  //   var flash_cards = '';
	                  //   if (response.success) {
	                  //     this.setState({ ValidToken: true });
	                  //     if (response.flash_cards.length > 0) {
	                  //       this.setState({
	                  //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                  //       });
	                  //       flash_cards = response.flash_cards.map((items, index) => (
	                  //         <li key={index}>
	                  //           <div className=''>
	                  //             <ul className='icon_list'>
	                  //               <li>
	                  //                 <a
	                  //                   className='pointer_class'
	                  //                   onClick={this._editFlash.bind(this, items)}
	                  //                 >
	                  //                   <i className='fa fa-pencil' />
	                  //                 </a>
	                  //               </li>
	                  //               <li>
	                  //                 <a
	                  //                   className='pointer_class'
	                  //                   onClick={this._deleteFlash.bind(this, items)}
	                  //                 >
	                  //                   <i className='fa fa-close' />
	                  //                 </a>
	                  //               </li>
	                  //             </ul>
	                  //             <div className={this.state.flash_class}>
	                  //               <h4 />
	                  //               <p>{items.flash_card}</p>
	                  //             </div>
	                  //           </div>
	                  //         </li>
	                  //       ));
	                  //     } else {
	                  //       this.setState({
	                  //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  //       });
	                  //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                  //     }
	                  //     this.setState({ flash_data: flash_cards });
	                  //   } else {
	                  //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                  //     this.setState({ ValidToken: false });
	                  //     this.setState({ flash_data: flash_cards });
	                  //     this.setState({
	                  //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  //     });
	                  //   }
	                  //   return response;
	                  // });
	                  _this5.setState({ records: '' });
	                  _context5.next = 16;
	                  break;
	
	                case 14:
	                  _this5.setState({ ValidToken: false });
	                  _this5.setState({ records: '' + _language2.default.LC().Result_not_found });
	
	                case 16:
	                case 'end':
	                  return _context5.stop();
	              }
	            }
	          }, _callee5, _this5);
	        }));
	
	        return function (_x5) {
	          return _ref5.apply(this, arguments);
	        };
	      }());
	    }
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var data = '';
	
	      var retun_all_question = JSON.stringify(questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 note-section special_notes_view' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card note-section-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size sticky-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                className: 'margin_right_10',
	                alt: '',
	                width: '21'
	              }),
	              (0, _function.renderHTMLContent)('' + this.state.reading_name_2025, "span", "notes-head-color", { contentEditable: "false" }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'notes-head-color' },
	                '(',
	                _language2.default.LC().N,
	                ' ',
	                all_questions.id,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right sticky-navigate' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'note-text-wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row overflow-x-auto' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_20' },
	                    (0, _function.renderHTMLContent)(all_questions.description, "div", "note_text_wrap", { contentEditable: "false" })
	                  ),
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default
	                  // _getResult={this._getResult}
	                  , { isQue: false,
	                    saveNotes_text: this.state.saveNotes_text,
	                    markColor: this.state.markColor,
	                    _saveQuestion: this._saveFavNotes,
	                    _saveNotesstats: this._saveNotesstats,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: all_questions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'notes',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'cfa2_2025'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, all_questions)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, all_questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        /* data = <div className="col-sm-12 col-md-12">
	               <div className="no_data_bar card">No Records Found</div>
	          </div>;*/
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row note-section notes_inner_title_wrap' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head title-font-size' },
	                _language2.default.LC().NOTES
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getNotes
	                },
	                _language2.default.LC().CHANGE_NOTES
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_READING
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfanotesbeginchapters;
	}(_react.Component);
	
	Cfanotesbeginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfanotesbeginchapters;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Axios from 'axios';
	// import { saveAs } from 'file-saver';
	
	
	/* eslint-disable*/
	var Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(chapter, e) {
	        var path, final_exam, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (chapter.chapter_no === 1) {
	                  path = _AppRoutes2.default.CFA2_2025_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	
	                  _this.context.router.push({
	                    pathname: path,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter: chapter.chapter_no
	                    }
	                  });
	                } else {
	                  final_exam = [];
	                  data = { token: _this.state.token, idname: _this.state.idname };
	
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                      var data_arr, dataset;
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              if (!(resp.profileInfo.role === 'partner')) {
	                                _context2.next = 12;
	                                break;
	                              }
	
	                              if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                                _context2.next = 5;
	                                break;
	                              }
	
	                              _this.toggleAlert();
	                              _context2.next = 10;
	                              break;
	
	                            case 5:
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	                              _context2.next = 10;
	                              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData, _path;
	
	                                  return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                      switch (_context.prev = _context.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context.next = 7;
	                                          return _Cfa2Subscription4.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context.sent;
	
	                                          if (isInArray_var) {
	                                            _path = _AppRoutes2.default.CFA2_2025_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	
	                                            _this.context.router.push({
	                                              pathname: _path,
	                                              state: {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                chapter: chapter.chapter_no
	                                              }
	                                            });
	                                          } else {
	                                            _this.toggleAlert();
	                                          }
	                                          _context.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context.stop();
	                                      }
	                                    }
	                                  }, _callee, _this2);
	                                }));
	
	                                return function (_x4) {
	                                  return _ref3.apply(this, arguments);
	                                };
	                              }());
	
	                            case 10:
	                              _context2.next = 13;
	                              break;
	
	                            case 12:
	                              if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                                _this.toggleAlert();
	                              } else {
	                                _this.setState({
	                                  cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                  cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                                });
	                                data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                                dataset = {
	                                  token: _this.state.token,
	                                  idname: _this.state.idname,
	                                  examid: data_arr
	                                };
	
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                  if (resp_exam.success) {
	                                    var exam_data = resp_exam.examData;
	                                    var selectedmen = _this.state.selectedmenu;
	                                    var isInArray_var = false;
	
	                                    isInArray_var = _Cfa2Subscription2.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    //console.log(isInArray_var);
	                                    if (isInArray_var) {
	                                      var _path2 = _AppRoutes2.default.CFA2_2025_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	                                      _this.context.router.push({
	                                        pathname: _path2,
	                                        state: {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapter: chapter.chapter_no
	                                        }
	                                      });
	                                    } else {
	                                      _this.toggleAlert();
	                                    }
	                                  } else {}
	                                });
	                              }
	
	                            case 13:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }());
	                }
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goToNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, lastRecord, lastAttempt, path;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              console.log('lastRecord -----------> ', lastRecord, '---------> ', lastRecord.cfa2_note);
	              if (lastAttempt) {
	                // '/cfa2_2025_beginnotes/:notesid/:readingid/:id/:chapter/:chapter_no/:offset',
	                path = _AppRoutes2.default.CFA2_2025_BEGIN_NOTES.replace(':notesid', lastRecord.cfa2_note.chapter_id_2025).replace(':readingid', lastRecord.cfa2_note.reading_id_2025).replace(':id', lastRecord.cfa2_note.id).replace(':chapter', 0);
	
	                _this.context.router.push({
	                  pathname: path
	                });
	              }
	
	            case 3:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.toggle = function () {
	      _this.setState({
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.getAdditionalResources = function (type) {
	      console.log('check pdf type', type);
	      var typeName = type === 'FS' ? 'Formula sheet' : type === 'ES' ? 'Essential summary' : 'Ratio sheet';
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        type: typeName,
	        exam: 'cfa_2'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getAdditionalResources', data).then(function (resp) {
	        if (resp.success) {
	          //   this.setState({ ValidToken: true });
	          (0, _function.openPDF)(resp);
	          return resp;
	        }
	      });
	    };
	
	    _this.checkSubscription = function (type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context5.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	
	                        // #261 — pass examPlanData so mock-only partners hit the
	                        // early-return false (was missing — let mock-package owners
	                        // download additional notes resources they shouldn't).
	
	                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                        _context5.next = 7;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context5.sent;
	
	                        if (isInArray_var) {
	                          _this.getAdditionalResources(type);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context5.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, _this2);
	              }));
	
	              return function (_x5) {
	                return _ref5.apply(this, arguments);
	              };
	            }()
	            //console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            //console.log('in paid');
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              //console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                //console.log('outside isInArray_var heeee', resp_exam);
	                if (isInArray_var) {
	                  _this.getAdditionalResources(type);
	
	                  // const getIndex = resp_exam.allexamData.filter(
	                  //   (item) => item.exam_name === 'cfa'
	                  // )[0];
	                  // if (getIndex) {
	                  //   if (type === 'ES') {
	                  //     if (getIndex.essentialSummary) {
	                  //       var myWindow = window.open(getIndex.essentialSummary);
	                  //     }
	                  //     myWindow.focus();
	                  //   } else if (type === 'FS') {
	                  //     if (getIndex.formulaSheet) {
	                  //       var myWindow = window.open(getIndex.formulaSheet);
	                  //     }
	                  //     myWindow.focus();
	                  //   } else {
	                  //     if (getIndex.ratioSheet) {
	                  //       var myWindow = window.open(getIndex.ratioSheet);
	                  //     }
	                  //     myWindow.focus();
	                  //   }
	                  // }
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      showFreePremium: '',
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      isNotesNotFound: false,
	      lastAttempt: false,
	      pdfLoading: true,
	      dropdownOpen: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Notes, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var _this3 = this;
	
	        var storage_session, data, final_exam;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                // console.log('working')
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    if (resp.chapters.length === 0) {
	                      _this3.setState({ isNotesNotFound: true });
	                    }
	                    _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                    var data = { token: _this3.state.token, idname: _this3.state.idname };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getlastReadNotes', data).then(function (response) {
	                      if (response.success) {
	                        _this3.setState({
	                          lastRecord: response.data,
	                          lastAttempt: true
	                        });
	                      }
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                final_exam = [];
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                  var resp, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context7.next = 3;
	                            break;
	                          }
	
	                          return _context7.abrupt('return');
	
	                        case 3:
	
	                          if (resp.profileInfo.role === 'partner') {
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                              _this3.setState({ showFreePremium: true });
	                            } else {
	                              _this3.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this3.state.token,
	                                idname: _this3.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData;
	                                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                    while (1) {
	                                      switch (_context6.prev = _context6.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context6.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this3.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context6.next = 7;
	                                          return _Cfa2Subscription4.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context6.sent;
	
	                                          if (isInArray_var) {
	                                            _this3.setState({ showFreePremium: false });
	                                          } else {
	                                            _this3.setState({ showFreePremium: true });
	                                          }
	                                          _context6.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context6.stop();
	                                      }
	                                    }
	                                  }, _callee6, _this3);
	                                }));
	
	                                return function (_x6) {
	                                  return _ref8.apply(this, arguments);
	                                };
	                              }()
	                              // console.log('fail');
	                              );
	                            }
	                          } else {
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this3.setState({ showFreePremium: true });
	                            } else {
	                              _this3.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this3.state.token,
	                                idname: _this3.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this3.state.selectedmenu;
	                                  var isInArray_var = false;
	
	                                  isInArray_var = _Cfa2Subscription2.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                  //console.log(isInArray_var);
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	                          }
	
	                        case 4:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this3);
	                })));
	                // });
	
	              case 7:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var dropdownOpen = this.state.dropdownOpen;
	
	      var chapters = this.state.chapters;
	      var data = '';
	      var lastAttempt = this.state.lastAttempt;
	
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium ? item.id === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  item.chapter_no,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon2.svg',
	                      className: '',
	                      width: '24',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countreading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_READINGS
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon3.svg',
	                      className: '',
	                      width: '20',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.Countquestion
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_NOTES
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else if (this.state.isNotesNotFound) {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-12 text-center mt-3' },
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/notes/notes_icon1_blue.svg',
	            className: '',
	            width: '54',
	            alt: ''
	          }),
	          _react2.default.createElement(
	            'h5',
	            { className: 'mt-1' },
	            _language2.default.LC().NOTE_NOT_FOUND
	          )
	        );
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().NOTES
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactstrap.ButtonDropdown,
	              { isOpen: dropdownOpen, toggle: function toggle() {
	                  return _this4.toggle();
	                } },
	              _react2.default.createElement(
	                _reactstrap.DropdownToggle,
	                {
	                  className: 'btn btn-primary pointer_class tooltip_wrap margin_right_20',
	                  caret: true
	                },
	                _language2.default.LC().Additional_Resources
	              ),
	              _react2.default.createElement(
	                _reactstrap.DropdownMenu,
	                { right: true },
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  {
	                    value: 'private',
	                    onClick: function onClick() {
	                      _this4.checkSubscription('FS');
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	                  _language2.default.LC().Formula_Sheet
	                )
	              )
	            ),
	            lastAttempt && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToNotes,
	                disabled: !lastAttempt
	              },
	              _messages.messages.GO_TO_MY_LAST_READ_NOTE
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	Notes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Notes;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(32);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(31);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Viewques = function (_Component) {
	  _inherits(Viewques, _Component);
	
	  function Viewques(props) {
	    _classCallCheck(this, Viewques);
	
	    var _this = _possibleConstructorReturn(this, (Viewques.__proto__ || Object.getPrototypeOf(Viewques)).call(this, props));
	
	    _this._getReadings = function () {
	      var path = _AppRoutes2.default.CFA2_2025_NOTES_READINGS.replace(':chapter', _this.props.params.chapter_no);
	      _this.context.router.push({
	        // pathname: `/cfa2notesreadings/${this.props.params.chapter_no}`,
	        pathname: path
	      });
	    };
	
	    _this._goToVideo = function () {
	      _this.setState({
	        chapter_video_redirect: _this.state.chapters[parseInt(_this.props.params.chapter_no) - 1]
	      }, function () {
	        // TODO work
	
	        // CFA2_2025VIDEODISPLAY: '/cfa2_2025videodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
	        var path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', _this.state.chapter_video_redirect.chapter_no).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':chapter_id', _this.state.chapter_video_redirect.chapter_no).replace(':index', 0);
	        _this.context.router.push({
	          pathname: path,
	          search: '?chapter_name=' + _this.state.chapter_video_redirect.chapter_name + '/' + _this.state.chapter_video_redirect.chapter_no,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter: _this.state.chapter_video_redirect,
	            showFreePremium: _this.state.showFreePremium
	          }
	        });
	      });
	    };
	
	    _this._beginNotes = function (item, e) {
	      // CFA2_2025BEGINNOTES: '/cfa2_2025_beginnotes/:notesid/:readingid/:id/:chapter/:chapter_no/:offset',
	      console.log('beginNotes ---> ', item);
	      var path = _AppRoutes2.default.CFA2_2025_BEGIN_NOTES.replace(':notesid', item.chapter_id_2025).replace(':readingid', item.reading_id_2025).replace(':id', item.id);
	      _this.context.router.push({
	        pathname: path,
	        // '/cfa2beginnotes/' +
	        // item.chapter_id +
	        // '/' +
	        // item.reading_id +
	        // '/' +
	        // item.id,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: item.reading_id,
	          chapter: item.chapter_id
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      showFreePremium: true,
	      subscription_details: '',
	      chapters: [],
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'cfa_2',
	      isVideo: true,
	      Loader: false
	    };
	    return _this;
	  }
	
	  _createClass(Viewques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this2 = this;
	
	        var storage_session, getProfileInfo, data_data, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfo).then(
	                // userStore.getUserProfile(true).then(
	                //   async resp => {
	                //     if (resp.profileInfo) {
	                //       this.setState({
	                //         isVideo: resp.profileInfo.isVideo,
	                //       });
	                //     }
	                //   },
	                // );
	
	                data_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	                // console.log(data);
	
	                _context3.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes', data).then(function (resp) {
	                  // console.log(resp);
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true, questions: resp.questions });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	                _userStore2.default.getUserProfile(true).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (resp.profileInfo != null) {
	                              _this2.setState({ isVideo: resp.profileInfo.isVideo });
	                            }
	
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context2.next = 5;
	                              break;
	                            }
	
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '' && resp.profileInfo.exam_package) {
	                              _this2.setState({
	                                showFreePremium: true,
	                                Loader: true
	                              });
	                            } else {
	                              subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                              _this2.setState({
	                                subscription_details: subscription_details,
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this2.state.token,
	                                idname: _this2.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData;
	                                  return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                      switch (_context.prev = _context.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this2.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context.next = 7;
	                                          return _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context.sent;
	
	                                          if (isInArray_var) {
	                                            _this2.setState({ showFreePremium: false, Loader: true });
	                                          } else {
	                                            _this2.setState({
	                                              showFreePremium: true,
	                                              Loader: true
	                                            });
	                                          }
	                                          _context.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context.stop();
	                                      }
	                                    }
	                                  }, _callee, _this2);
	                                }));
	
	                                return function (_x2) {
	                                  return _ref3.apply(this, arguments);
	                                };
	                              }());
	                            }
	                            _context2.next = 15;
	                            break;
	
	                          case 5:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context2.next = 9;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this2.setState({
	                              showFreePremium: true,
	                              Loader: true
	                            });
	                            _context2.next = 15;
	                            break;
	
	                          case 9:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this2.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this2.state.token,
	                              idname: _this2.state.idname,
	                              examid: data_arr
	                            };
	                            _context2.next = 15;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                                //   console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this2.setState({ showFreePremium: false, Loader: true });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this2.setState({ showFreePremium: true, Loader: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 15:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.questions;
	      // console.log("this.state.questions;", this.state.questions);
	      var chapters = this.state.chapters;
	      var chapter_no = this.props.params.chapter_no;
	
	      var countVideo = chapters[chapter_no - 1] ? chapters[this.props.params.chapter_no - 1].Countvideos : null;
	      var data = '';
	      if (this.state.questions.length && this.state.Loader) {
	        data = questions.map(function (item, index) {
	          var _item$reading_order = item.reading_order,
	              reading_order = _item$reading_order === undefined ? '' : _item$reading_order,
	              _item$name_ = item.name_2025,
	              name_2025 = _item$name_ === undefined ? '' : _item$name_;
	
	          var readings_name_2025;
	          if (name_2025.search('<span') !== -1) {
	            readings_name_2025 = name_2025.split('>')[1].split('<')[0];
	          } else {
	            readings_name_2025 = name_2025;
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4', key: index },
	            _react2.default.createElement(
	              'div',
	              { onClick: _this3._beginNotes.bind(_this3, item), className: 'border_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                    className: 'margin_right_10',
	                    alt: '',
	                    width: '21'
	                  }),
	                  readings_name_2025.length < 90 ? readings_name_2025 : readings_name_2025.substr(0, 100) + '...',
	                  ' ',
	                  '(',
	                  _language2.default.LC().N,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                item.description ? (0, _function.renderHTMLContent)(item.description.substring(0, item.description.indexOf('$$') !== -1 ? item.description.indexOf('$$') : 130) + '...', "div", "view_question_height view_questionhtml margin_bottom_40 cfa_notes_view", { contentEditable: "false" }) : null,
	                _react2.default.createElement(UserInfo, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.reading
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.isVideo === true ? 'col-md-4 text-md-right margin_bottom_20' : 'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data
	        )
	      );
	    }
	  }]);
	
	  return Viewques;
	}(_react.Component);
	
	Viewques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	function UserInfo(props) {
	  var data = {
	    itemid: props.itemid,
	    chapter_id: props.chapter_id,
	    reading_id: props.reading_id,
	    idname: props.idname,
	    token: props.token
	  };
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotesByuser', data).then(function (resp) {
	    if (resp.success) {
	      if (resp.success == 'success') {
	        if (document.getElementById('user_question_status' + props.answered_state) != null) {
	          document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Read';
	
	          document.getElementById('user_question_status' + props.answered_state).id = 'answered_status';
	        }
	      } else {
	        if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Unread';
	
	        if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'notanswered_status';
	      }
	    } else {
	      // Render-fired fetch: an earlier response may have renamed this element's id → null guard.
	      if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { id: 'user_question_status' + props.answered_state })
	  );
	}
	exports.default = Viewques;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _messages = __webpack_require__(14);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa2_2023QuestionBank = function (_Component) {
	  _inherits(Cfa2_2023QuestionBank, _Component);
	
	  function Cfa2_2023QuestionBank(props) {
	    _classCallCheck(this, Cfa2_2023QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2_2023QuestionBank.__proto__ || Object.getPrototypeOf(Cfa2_2023QuestionBank)).call(this, props));
	
	    _this._getCases = function (chapter, e) {
	      // console.log('chapter--------------------', chapter);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES.replace(':id', chapter.id).replace(':chapter_name', chapter.chapter_name).replace(':total_cases', chapter.total_cases)
	        // `/cfa2_cases/${chapter.id}/${chapter.chapter_name}/${
	        //   chapter.total_cases
	        // }`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: chapter,
	        // },
	      });
	    };
	
	    _this.goToQuestion = function () {
	      var _this$state = _this.state,
	          lastRecord = _this$state.lastRecord,
	          lastAttempt = _this$state.lastAttempt;
	
	      if (lastAttempt) {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', lastRecord.cfa2_question.chapter_id_2025).replace(':caseid', lastRecord.cfa2_question.case_id).replace(':case_offset', lastRecord.caseIndex).replace(':question_number', lastRecord.cfa2_question.question_number).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      token: '',
	      freeChapterCount: [],
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      lastRecord: '',
	      lastAttempt: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Cfa2_2023QuestionBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChapters', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context.next = 6;
	                    break;
	                  }
	
	                  _this2.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  _context.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this2.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context.next = 7;
	                  break;
	
	                case 6:
	                  _this2.setState({ ValidToken: false });
	
	                case 7:
	                  return _context.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var chapters = this.state.chapters;
	      var countFree = this.state.freeChapterCount;
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      var percent_data = ['5-10%', //Quanititive
	      '5-10%', //Economics
	      '10-15%', //Financial reporting
	      '5-10%', //Corporate
	      '10-15%', //Equity
	      '10-15%', //Fixed income
	      '5-10%', //Derivative
	      '5-10%', //Alternative
	      '10-15%', //Portfolio
	      '10-15%'];
	
	      if (this.state.chapters.length && this.state.freeChapterCount.length) {
	        var count = 0;
	        data = chapters.map(function (item, index) {
	          var itemFree = _this3.state.freeChapterCount.find(function (obj) {
	            return obj.id === item.id ? count = obj.count : count = 0;
	          });
	
	          return _react2.default.createElement(
	            'div',
	            {
	              className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section',
	              key: index,
	              onClick: _this3._getCases.bind(_this3, item)
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'question_bank_wrap pointer_class', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                  width: '54',
	                  className: '',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.chapter_no,
	                    onClick: _this3._getCases.bind(_this3, item)
	                  },
	                  item.id,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                      className: '',
	                      width: '25',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    percent_data[index]
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                      className: '',
	                      width: '26',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    count
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().FREE_CASES,
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                      className: '',
	                      width: '23',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.total_cases
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().PREMIUM_CASES,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().CFA_LEVEL_II_QUESTION_BANK
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.CFA_2 }),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2_2023QuestionBank;
	}(_react.Component);
	
	Cfa2_2023QuestionBank.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa2_2023QuestionBank;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa22023cases = function (_Component) {
	  _inherits(Cfa22023cases, _Component);
	
	  function Cfa22023cases(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa22023cases);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (Cfa22023cases.__proto__ || Object.getPrototypeOf(Cfa22023cases)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK
	      });
	    };
	
	    _this._beginChapter = function (reading, index, e) {
	      //console.log("readog", reading);
	      // console.log(
	      //   'readingreadingreadingreadingreadingreadingreadingreadingreadingreadingreadingreadingreading---------------------------------',
	      //   reading
	      // );
	      // console.log('indexindexindexindexindex', index);
	
	      var subscriptionstatus = _this.state.subscriptionstatus;
	
	      if (subscriptionstatus === 'free' && reading.free == 0) {
	        _this.togglePremiumAlert();
	      } else {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.state.chapterid).replace(':caseid', reading.id).replace(':case_offset', index).replace(':question_number', 1).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context4.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context4.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context4.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context4.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context4.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context.next = 7;
	                                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context3.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context3.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        //console.log("isInArray_var_PDF before", isInArray_var_PDF);
	
	                                        _context2.next = 6;
	                                        return _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 23:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context8.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context8.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context8.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context8.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context8.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context7.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context7.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context7.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context7.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        // #261 — pass examPlanData so the mock-package early-return
	                                        // fires (otherwise partner with mock-only plan got a PDF email).
	
	                                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                                        _context5.next = 7;
	                                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context5.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context5.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context5.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoadingAnswer: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context5.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context5.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x7) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context7.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context7.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context7.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context7.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context6.next = 6;
	                                        return _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context6.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoadingAnswer: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: '' + _language2.default.LC().READING_NOT_FOUND,
	      changeStatusTitle: '' + _language2.default.LC().Mark_this_Question_as_Completed,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.id,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      selectedmenu: 'cfa_2',
	      subscriptionstatus: '',
	      change_status: false,
	      change_case_no: '',
	      change_completion_status: '',
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      premiumAlertStatus: false,
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFDownloadType: 'Question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggleAlertChangeStatus = _this.toggleAlertChangeStatus.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa22023cases, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    //it is use to redirect page
	
	  }, {
	    key: 'toggleAlertChangeStatus',
	    value: function toggleAlertChangeStatus(item, index) {
	      // console.log(item)
	      // console.log(index)
	      {
	        item.completionStatus === 1 ? this.setState({
	          change_status: !this.state.change_status,
	          change_case_no: item.case_number,
	          change_completion_status: item.completionStatus,
	          markAsCompleted: true,
	          markAsNotCompleted: false
	        }) : this.setState({
	          change_status: !this.state.change_status,
	          change_case_no: item.case_number,
	          change_completion_status: item.completionStatus,
	          markAsNotCompleted: true,
	          markAsCompleted: false
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      // console.log('markCompleted')
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      // console.log('markNotCompleted')
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      // console.log('changeCompletionStatus working')
	      if (this.state.markAsCompleted === true) {
	        // console.log('Mark as completed')
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.change_case_no,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.selectedmenu,
	          chapter_id: this.state.chapterid
	        };
	        // console.log(data)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.message)
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              chapter_id: _this3.state.chapterid,
	              subscriptionstatus: _this3.state.subscriptionstatus
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasessubs', data).then(function (resp) {
	              // console.log(resp);
	              if (resp.success) {
	                _this3.setState({
	                  ValidToken: true,
	                  readings: resp.readings,
	                  change_status: false
	                });
	                if (!resp.readings.length) {
	                  _this3.setState({ no_result_display: 'No Saved Questions' });
	                }
	              } else {
	                _this3.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      } else {
	        // console.log('Mark as Un-Completed')
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.change_case_no,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.selectedmenu,
	          chapter_id: this.state.chapterid
	        };
	        // console.log(data)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.message)
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              chapter_id: _this3.state.chapterid,
	              subscriptionstatus: _this3.state.subscriptionstatus
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasessubs', data).then(function (resp) {
	              // console.log(resp);
	              if (resp.success) {
	                _this3.setState({ ValidToken: true });
	                _this3.setState({ readings: resp.readings, change_status: false });
	                if (!resp.readings.length) {
	                  _this3.setState({ no_result_display: 'No Saved Questions' });
	                }
	              } else {
	                _this3.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      }
	    }
	
	    //Function to redirect page to question bank page
	
	  }, {
	    key: 'togglePremiumAlert',
	    value: function togglePremiumAlert() {
	      this.setState({
	        premiumAlertStatus: !this.state.premiumAlertStatus
	      });
	    }
	
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var final_exam = [];
	      var user_data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
	      _userStore2.default.getUserProfile(true).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this4.setState({ subscriptionstatus: 'free' });
	            _this4._runCode('free');
	          } else {
	            _this4.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                  while (1) {
	                    switch (_context9.prev = _context9.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context9.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this4.state.selectedmenu;
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context9.next = 7;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context9.sent;
	
	                        if (isInArray_var) {
	                          _this4.setState({ subscriptionstatus: 'paid' });
	                          _this4._runCode('paid');
	                        } else {
	                          _this4.setState({ subscriptionstatus: 'free' });
	                          _this4._runCode('free');
	                        }
	                        _context9.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context9.stop();
	                    }
	                  }
	                }, _callee9, _this4);
	              }));
	
	              return function (_x9) {
	                return _ref9.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this4.setState({ subscriptionstatus: 'free' });
	            _this4._runCode('free');
	          } else {
	            _this4.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this4.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this4.setState({ subscriptionstatus: 'paid' });
	                  _this4._runCode('paid');
	                } else {
	                  _this4.setState({ subscriptionstatus: 'free' });
	                  _this4._runCode('free');
	                }
	              } else {}
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        chapter_id: this.state.chapterid,
	        subscriptionstatus: subscriptionstatus
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasessubs', data).then(function (resp) {
	        // console.log(resp);
	        if (resp.success) {
	          _this5.setState({ ValidToken: true });
	          _this5.setState({ readings: resp.readings });
	          if (!resp.readings.length) {
	            _this5.setState({ no_result_display: 'No Saved Questions' });
	          }
	        } else {
	          _this5.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	    /*
	    --------------------------------
	    PDF DOWNLOAD Via email Answer
	    --------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      // console.log(this.state.readings)
	      // console.log(this.state.readings[1])
	      var _state = this.state,
	          subscriptionstatus = _state.subscriptionstatus,
	          premiumAlertStatus = _state.premiumAlertStatus;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              /*item.case_number*/index + 1,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.case_name_2025
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              subscriptionstatus === 'free' && item.free == 0 ? _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/subsciption-dark.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, item, index),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().UPGRADE_ACCOUNT
	                )
	              ) : _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, item, index),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CASES
	                )
	              )
	            ),
	            subscriptionstatus === 'free' && item.free == 0 ? null : readings[index].completionStatus === null || readings[index].completionStatus === false || readings[index].completionStatus === 0 ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  ' ',
	                  _language2.default.LC().NOT_COMPLETED
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this6.toggleAlertChangeStatus.bind(_this6, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  _language2.default.LC().COMPLETED,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this6.toggleAlertChangeStatus.bind(_this6, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.chapter_name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Q_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: this.getpdfAnswer.bind(this),
	                className: 'status-download-btn margin_right_10'
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right max-width-200' },
	                this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoadingAnswer ? _language2.default.LC().Download_QA_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              ' ',
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CASE_STUDIES,
	                ' - ',
	                this.props.params.chapter_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0 case-study-heading-wrap' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          ' ',
	                          _language2.default.LC().CASE_NAME,
	                          ' '
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'action-heading' },
	                          _language2.default.LC().ACTION
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'status-heading' },
	                          _language2.default.LC().STATUS
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex flex-column' },
	              _react2.default.createElement(
	                'div',
	                null,
	                ' ',
	                this.state.MessageContent
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-right' },
	                ' ',
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { color: 'primary', onClick: this.toggleAlert },
	                  ' ',
	                  _language2.default.LC().OK,
	                  ' '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.change_status,
	            toggle: this.toggleAlertChangeStatus,
	            className: 'modal-primary complete-or-not-model ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlertChangeStatus },
	            this.state.changeStatusTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block card-padding' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue_status'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.togglePremiumAlert.bind(this),
	          alert_status: premiumAlertStatus,
	          MessageContent: _alertMessage2.default.messageContent_cfa_2,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Cfa22023cases;
	}(_react.Component);
	
	Cfa22023cases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa22023cases;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _cfa2QuestionNumbering = __webpack_require__(258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	// import StarRatings from 'react-star-ratings';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	// import GD from '../../RestAPI/getData';
	
	
	/* eslint-disable*/
	var Cfa22023chapter = function (_Component) {
	  _inherits(Cfa22023chapter, _Component);
	
	  function Cfa22023chapter(props) {
	    var _this$state4;
	
	    _classCallCheck(this, Cfa22023chapter);
	
	    var _this = _possibleConstructorReturn(this, (Cfa22023chapter.__proto__ || Object.getPrototypeOf(Cfa22023chapter)).call(this, props));
	
	    _this.tick = function () {
	      if (!_this.state.timer_stop) {
	        _this.setState(function (prevState) {
	          return {
	            count: prevState.count + 1
	          };
	        });
	      }
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES.replace(':id', _this.props.params.chapterid).replace(':chapter_name', _this.state.chaptername)
	        // `/cfa2_cases/${this.props.params.chapterid}/${
	        //   this.state.chaptername
	        // }`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.state.chapters,
	        // },
	      });
	    };
	
	    _this._getAnswer = function (choice, e) {
	      var currentQuestionId = _this.state.questions.id;
	      var selectedChoice = choice[0];
	
	      var choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d', 'choice_e'];
	      var updatedChoices = {};
	
	      choiceKeys.forEach(function (key) {
	        updatedChoices[key] = selectedChoice === key ? 'answer_box clicked_box' : 'answer_box';
	      });
	
	      _this.setState(Object.assign({
	        selectedChoice: selectedChoice,
	        setAnswer: true,
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false
	      }, updatedChoices), function () {
	        var currentAttempts = _this.state.attemptedQuestions || {};
	        var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	          selectedChoice: selectedChoice,
	          isAnswered: false,
	          setAnswer: true
	        }));
	
	        _this.setState({ attemptedQuestions: updatedAttempts });
	      });
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this.getResult = function (item, e) {
	      var _this$state = _this.state,
	          selectedChoice = _this$state.selectedChoice,
	          timer = _this$state.timer,
	          count = _this$state.count,
	          attemptedQuestions = _this$state.attemptedQuestions,
	          validated = _this$state.validated,
	          token = _this$state.token,
	          idname = _this$state.idname;
	
	      if (selectedChoice) {
	        if (timer) {
	          clearInterval(timer);
	          _this.timer = null;
	        }
	
	        var currentQuestionId = item.id;
	        var correctChoiceKey = item['answer'];
	        var isCorrect = selectedChoice === 'choice_' + correctChoiceKey;
	        var timeDone = item["cfa2_2025_question_stats.time_done"] || count;
	
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play',
	          setAnswer: true,
	          clicked: true,
	          showAnswer: true,
	          stopTimer: true,
	          result_block: 'card show_block',
	          result: isCorrect ? 'CORRECT' : 'INCORRECT',
	          text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
	        }, function () {
	          var currentAttempts = attemptedQuestions || {};
	          var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	            selectedChoice: selectedChoice,
	            isAnswered: true,
	            isCorrect: isCorrect,
	            setAnswer: true,
	            timeSpent: timeDone
	          }));
	
	          _this.setState({ attemptedQuestions: updatedAttempts });
	
	          if (!validated) {
	            var data = {
	              token: token,
	              idname: idname,
	              question_id: currentQuestionId,
	              right_answer: isCorrect ? 1 : 0,
	              time_done: timeDone,
	              selected_choice: selectedChoice
	            };
	
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveStats', data).then(function (resp) {
	              if (resp.success) {
	                _this.setState({ ValidToken: true, validated: true });
	              } else {
	                _this.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      } else {
	        _this.setState({
	          result_block: 'card hide_block'
	        });
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.clicked || _this.state.validated) {
	        return;
	      }
	      if (_this.state.timer_stop) {
	        _this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick, 1000);
	      } else {
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        clearInterval(_this.timer);
	        _this.timer = null;
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid
	      };
	      if (_this.state.bookmarkCSS == 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashcards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getNext = function () {
	      var _this$state2 = _this.state,
	          offset = _this$state2.offset,
	          all_questions_state = _this$state2.all_questions_state;
	
	      if (offset < all_questions_state.length - 1) {
	        var nextOffset = offset + 1;
	        var nextQuestion = all_questions_state[nextOffset];
	
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	
	        _this.setState({
	          offset: nextOffset,
	          display_loader: 'show_block',
	          validated: false,
	          clicked: false,
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          result_block: 'card hide_block'
	        });
	
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          question_id: nextQuestion.id
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getQuestionsbyid', data).then(function (resp) {
	          if (resp.success) {
	            var currentQuestion = resp.questionsbyid;
	            var selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
	            var rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
	            var answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
	            var timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
	            var correctChoiceKey = 'answer';
	
	            var _this$determineSelect = _this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                selected = _this$determineSelect.selected,
	                showAnswer = _this$determineSelect.showAnswer;
	
	            _this.updateTimerState(selected, timeDone);
	
	            var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	            var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	              var isSelected = selected === choice;
	              var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	              acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : 'answer_box';
	              return acc;
	            }, {});
	
	            _this.setState(Object.assign({
	              questions: currentQuestion,
	              selectedChoice: selected,
	              clicked: !!selected
	            }, choiceBoxStates, {
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	              display_loader: 'hide_block'
	            }));
	
	            var favParams = Object.assign({}, data, {
	              chapter_id: _this.props.params.chapterid
	            });
	            var flashParams = Object.assign({}, data);
	
	            Promise.all([_fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', favParams), _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashcards', flashParams)]).then(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  favResp = _ref2[0],
	                  flashResp = _ref2[1];
	
	              var isSavedQuestion = favResp.success;
	              var hasFlash = flashResp.success && flashResp.flash_cards && flashResp.flash_cards.length > 0;
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: isSavedQuestion ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: isSavedQuestion ? 'rgb(54, 141, 84)' : '',
	                save_text: isSavedQuestion ? '' + _language2.default.LC().Question_Saved : '' + _language2.default.LC().SAVE_QUESTION,
	                isFlashCardHidden: !isSavedQuestion
	              });
	              if (hasFlash) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                  flash_data: flashResp.flash_cards.map(function (items, index) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    );
	                  })
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  )
	                });
	              }
	            });
	          }
	        });
	      } else {
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	        _this.setState({
	          showCompletionQuestion: true,
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	      }
	    };
	
	    _this.getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getPrevious = function () {
	      var _this$state3 = _this.state,
	          offset = _this$state3.offset,
	          all_questions_state = _this$state3.all_questions_state;
	
	
	      if (offset > 0) {
	        var prevOffset = offset - 1;
	        var prevQuestion = all_questions_state[prevOffset];
	
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	
	        _this.setState({
	          offset: prevOffset,
	          display_loader: 'show_block',
	          validated: false,
	          clicked: false,
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          result_block: 'card hide_block'
	        });
	
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          question_id: prevQuestion.id
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getQuestionsbyid', data).then(function (resp) {
	          if (resp.success) {
	            var currentQuestion = resp.questionsbyid;
	            var selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
	            var rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
	            var answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
	            var timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
	            var correctChoiceKey = 'answer';
	
	            var _this$determineSelect2 = _this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                selected = _this$determineSelect2.selected,
	                showAnswer = _this$determineSelect2.showAnswer;
	
	            _this.updateTimerState(selected, timeDone);
	
	            var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	            var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	              var isSelected = selected === choice;
	              var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	              acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : 'answer_box';
	              return acc;
	            }, {});
	
	            _this.setState(Object.assign({
	              questions: currentQuestion,
	              selectedChoice: selected,
	              clicked: !!selected
	            }, choiceBoxStates, {
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	              display_loader: 'hide_block'
	            }));
	
	            var favParams = Object.assign({}, data, {
	              chapter_id: _this.props.params.chapterid
	            });
	            var flashParams = Object.assign({}, data);
	            Promise.all([_fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', favParams), _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashcards', flashParams)]).then(function (_ref3) {
	              var _ref4 = _slicedToArray(_ref3, 2),
	                  favResp = _ref4[0],
	                  flashResp = _ref4[1];
	
	              var isSavedQuestion = favResp.success;
	              var hasFlash = flashResp.success && flashResp.flash_cards && flashResp.flash_cards.length > 0;
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: isSavedQuestion ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: isSavedQuestion ? 'rgb(54, 141, 84)' : '',
	                save_text: isSavedQuestion ? '' + _language2.default.LC().Question_Saved : '' + _language2.default.LC().SAVE_QUESTION,
	                isFlashCardHidden: !isSavedQuestion
	              });
	              if (hasFlash) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                  flash_data: flashResp.flash_cards.map(function (items, index) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    );
	                  })
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  )
	                });
	              }
	            });
	          }
	        });
	      }
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block'
	      });
	      _this.setState({ clicked: false });
	      var casesoffset = parseInt(_this.state.cases_offset) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({ cases_offset: casesoffset });
	        caseid = _this.state.all_cases[casesoffset].id;
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':question_number', 1).replace(':offset', 0)
	        });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', 0).replace(':question_number', 1).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block'
	      });
	      _this.setState({ clicked: false });
	      if (_this.state.cases_offset == 0) {
	        var casesoffset = _this.state.cases_length - 1;
	        var caseid = _this.state.all_cases[casesoffset].id;
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':question_number', 1).replace(':offset', 0)
	        });
	      } else {
	        var _casesoffset = _this.state.cases_offset - 1;
	        var caseid = _this.state.all_cases[_casesoffset].id;
	        _this.setState({ cases_offset: _casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', _casesoffset).replace(':question_number', 1).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.state = (_this$state4 = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: 'Stop'
	    }, _defineProperty(_this$state4, 'timerstopbtn', 'pause_btn icon-control-pause'), _defineProperty(_this$state4, 'chaptername', ''), _defineProperty(_this$state4, 'caseid', _this.props.params.caseid), _defineProperty(_this$state4, 'all_cases', []), _defineProperty(_this$state4, 'cases_display', ''), _defineProperty(_this$state4, 'cases_name', ''), _defineProperty(_this$state4, 'isFlashCardHidden', true), _defineProperty(_this$state4, 'cases_length', ''), _defineProperty(_this$state4, 'case_id', ''), _defineProperty(_this$state4, 'cases_offset', ''), _defineProperty(_this$state4, 'casesquestion_length', ''), _defineProperty(_this$state4, 'chapters', ''), _defineProperty(_this$state4, 'display_loader', ''), _defineProperty(_this$state4, 'selectedmenu', 'cfa_2'), _defineProperty(_this$state4, 'subscriptionstatus', ''), _defineProperty(_this$state4, 'display_subcription', 'hide_block'), _defineProperty(_this$state4, 'display_cases', 'show_block'), _defineProperty(_this$state4, 'showCompletionQuestion', false), _defineProperty(_this$state4, 'markAsCompleted', false), _defineProperty(_this$state4, 'markAsNotCompleted', false), _defineProperty(_this$state4, 'markCompleted', true), _defineProperty(_this$state4, 'cases', []), _defineProperty(_this$state4, 'exam_type', 'cfa_2'), _defineProperty(_this$state4, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state4, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state4, 'forumComment', ''), _defineProperty(_this$state4, 'category', 'CFA Level 2 2023'), _defineProperty(_this$state4, 'tags', ['cfa-2-2023', 'cfa', 'question', 'case']), _defineProperty(_this$state4, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state4, 'user_city', ''), _defineProperty(_this$state4, 'user_country', ''), _defineProperty(_this$state4, 'user_ip', ''), _defineProperty(_this$state4, 'user_state', ''), _defineProperty(_this$state4, 'user_continent', ''), _defineProperty(_this$state4, 'selectedChoice', ''), _defineProperty(_this$state4, 'timeDone', 0), _this$state4);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.timerValue = 0;
	    return _this;
	  }
	
	  _createClass(Cfa22023chapter, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var storage_session, result, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                });
	                _context2.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context2.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({
	                  case_id: this.props.params.caseid,
	                  display_cases: 'hide_block'
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  caseid: this.props.params.caseid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesbyId', data).then(function (resp_cases) {
	                  _this2.setState({ cases: resp_cases });
	                  if (resp_cases.success) {
	                    var data = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    };
	                    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	                    _userStore2.default.getUserProfile(true).then(function (resp) {
	                      var free_status = '';
	
	                      if (resp.profileInfo.role === 'partner') {
	                        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                          free_status = 'free';
	                          _this2.setState({ subscriptionstatus: 'free' });
	                          if (resp_cases.casesingleData.free == 0) {
	                            _this2.setState({
	                              display_cases: 'hide_block',
	                              display_subcription: 'show_block'
	                            });
	                            _this2.toggleAlert();
	                          } else {
	                            _this2.setState({
	                              display_cases: 'show_block',
	                              display_subcription: 'hide_block'
	                            });
	                          }
	                        } else {
	                          _this2.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          var dataset = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            examid: data_arr
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, examPlanData;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 9;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this2.state.selectedmenu;
	                                      isInArray_var = false;
	                                      examPlanData = resp_exam.examPlan[0];
	                                      _context.next = 7;
	                                      return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                    case 7:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        _this2.setState({
	                                          subscriptionstatus: 'paid',
	                                          display_cases: 'show_block',
	                                          display_subcription: 'hide_block'
	                                        });
	                                      } else {
	                                        if (resp_cases.casesingleData.free == 0) {
	                                          _this2.setState({
	                                            display_cases: 'hide_block',
	                                            display_subcription: 'show_block'
	                                          });
	                                        } else {
	                                          _this2.setState({
	                                            subscriptionstatus: 'free',
	                                            display_cases: 'show_block',
	                                            display_subcription: 'hide_block'
	                                          });
	                                        }
	                                      }
	
	                                    case 9:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this2);
	                            }));
	
	                            return function (_x) {
	                              return _ref6.apply(this, arguments);
	                            };
	                          }());
	                        }
	                      } else {
	                        if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                          free_status = 'free';
	                          _this2.setState({ subscriptionstatus: 'free' });
	                          if (resp_cases.casesingleData.free == 0) {
	                            _this2.setState({
	                              display_cases: 'hide_block',
	                              display_subcription: 'show_block'
	                            });
	                            _this2.toggleAlert();
	                          } else {
	                            _this2.setState({
	                              display_cases: 'show_block',
	                              display_subcription: 'hide_block'
	                            });
	                          }
	                        } else {
	                          _this2.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          var dataset = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            examid: data_arr
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this2.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                              if (isInArray_var) {
	                                _this2.setState({
	                                  subscriptionstatus: 'paid',
	                                  display_cases: 'show_block',
	                                  display_subcription: 'hide_block'
	                                });
	                              } else {
	                                if (resp_cases.casesingleData.free == 0) {
	                                  _this2.setState({
	                                    display_cases: 'hide_block',
	                                    display_subcription: 'show_block'
	                                  });
	                                } else {
	                                  _this2.setState({
	                                    subscriptionstatus: 'free',
	                                    display_cases: 'show_block',
	                                    display_subcription: 'hide_block'
	                                  });
	                                }
	                              }
	                            }
	                          });
	                        }
	                      }
	                    });
	                  }
	                });
	                // });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter_id: this.props.params.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      chaptername: resp.chapterdata.chapter_name,
	                      chapters: resp.chapterdata
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCases', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      ValidToken: true,
	                      all_cases: resp.readings,
	                      cases_length: resp.readings.length
	                    });
	                    for (var i = 0; i < resp.readings.length; i++) {
	                      if (_this2.props.params.case_offset == i) {
	                        _this2.setState({
	                          cases_offset: _this2.props.params.case_offset,
	                          cases_display: resp.readings[i].case,
	                          cases_name: resp.readings[i].case_name_2025
	                        });
	                      }
	                    }
	                    var param = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname'],
	                      case_id: _this2.state.case_id
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(function (resp_question) {
	                      if (resp_question.success) {
	                        _this2.setState({
	                          casesquestion_length: resp_question.questions_details.length
	                        });
	                        if (resp_question.questions_details.length > 0) {
	                          var wantedNumber = (0, _cfa2QuestionNumbering.resolveQuestionNumber)(resp_question.questions_details, _this2.props.params.question_number);
	                          var offset_res = '';
	                          var questionid = '';
	                          for (var i = 0; i < resp_question.questions_details.length; i++) {
	                            if (resp_question.questions_details[i].question_number == wantedNumber) {
	                              (function () {
	                                offset_res = i;
	                                questionid = resp_question.questions_details[i].id;
	                                var currentQuestion = resp_question.questions_details[i];
	                                var selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
	                                var rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
	                                var answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
	                                var timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
	                                var correctChoiceKey = 'answer';
	
	                                var _determineSelectedAnd = _this2.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                                    selected = _determineSelectedAnd.selected,
	                                    showAnswer = _determineSelectedAnd.showAnswer;
	
	                                _this2.updateTimerState(selected, timeDone);
	
	                                var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	                                var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	                                  var isSelected = selected === choice;
	                                  var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	                                  acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : isCorrect ? 'answer_box success' : 'answer_box';
	                                  return acc;
	                                }, {});
	
	                                _this2.setState(Object.assign({
	                                  questions: currentQuestion,
	                                  selectedChoice: selected,
	                                  clicked: !!selected
	                                }, choiceBoxStates, {
	                                  result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                                  text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	                                  result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	                                  display_loader: 'hide_block'
	                                }));
	                                _this2.handleTimerResponse(selected);
	                              })();
	                            }
	                          }
	                          _this2.setState({
	                            offset: offset_res,
	                            all_questions_state: resp_question.questions_details
	                          });
	
	                          var params_fav = {
	                            token: storage_session['token'],
	                            question_id: questionid,
	                            idname: storage_session['idname'],
	                            chapter_id: _this2.props.params.chapterid
	                          };
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({
	                                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                                bookmarkColor: 'rgb(54, 141, 84)',
	                                save_text: '' + _language2.default.LC().Question_Saved,
	                                isFlashCardHidden: false
	                              });
	                            } else {
	                              _this2.setState({ isFlashCardHidden: true });
	                            }
	                          });
	
	                          var params = {
	                            token: storage_session['token'],
	                            question_id: questionid,
	                            idname: storage_session['idname']
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ rated: true });
	                              response.ratting.map(function (items) {
	                                _this2.setState({
	                                  rating: items.ratting,
	                                  ratting_text: 'Rated '
	                                });
	                              });
	                            }
	                          });
	
	                          var params = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            question_id: questionid
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashcards', params).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ ValidToken: true });
	                              if (response.flash_cards.length > 0) {
	                                _this2.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                });
	                                var flash_cards = response.flash_cards.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: '' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'icon_list' },
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            { className: 'pointer_class', onClick: _this2._editFlash.bind(_this2, items) },
	                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this2._deleteFlash.bind(_this2, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: _this2.state.flash_class },
	                                        _react2.default.createElement('h4', null),
	                                        _react2.default.createElement(
	                                          'p',
	                                          null,
	                                          items.flash_card
	                                        )
	                                      )
	                                    )
	                                  );
	                                });
	                              } else {
	                                _this2.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                              }
	                              _this2.setState({ flash_data: flash_cards });
	                            } else {
	                              var flash_cards = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_FLASHCARD_FOUND
	                              );
	                              _this2.setState({
	                                ValidToken: false,
	                                flash_data: flash_cards,
	                                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                              });
	                            }
	                            return response;
	                          });
	
	                          _this2.setState({ records: '' });
	                        }
	                      }
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false, records: 'Result not found.' });
	                  }
	                  _this2.setState({ display_loader: 'hide_block' });
	                  clearInterval(_this2.timer);
	                  _this2.timer = setInterval(_this2.tick, 1000);
	                  return resp;
	                }).catch(function (err) {
	                  _this2.setState({ display_loader: 'hide_block' });
	                });
	
	                this.timer = setInterval(this.tick, 1000);
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      if (this.state.markAsCompleted == true) {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.cases.casesingleData.case_number,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.exam_type,
	          chapter_id: this.props.params.chapterid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this3._getReadings();
	          }
	        });
	      } else {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.cases.casesingleData.case_number,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.exam_type,
	          chapter_id: this.props.params.chapterid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this3._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to readings page
	    -------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue != nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/UpdateCfaRatting', params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            var params = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveCfaratting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this4.state.token,
	            idname: _this4.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveCfaratting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	      */
	
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to Edit Flash card
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	       Function to delete flash card
	    --------------------------------------
	    */
	
	  }, {
	    key: 'handleTimerResponse',
	    value: function handleTimerResponse(selectedChoice) {
	      if (selectedChoice) {
	        clearInterval(this.timer);
	        this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	      } else {
	        this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        clearInterval(this.timer);
	        this.timer = setInterval(this.tick, 1000);
	      }
	    }
	  }, {
	    key: 'updateTimerState',
	
	
	    // Helper to update timer state based on whether a question is selected
	    value: function updateTimerState(isSelected) {
	      var timeDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (isSelected) {
	        clearInterval(this.timer);
	        this.timer = null;
	        this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play',
	          count: timeDone
	        });
	      } else {
	        if (this.timer) clearInterval(this.timer);
	        this.timer = setInterval(this.tick, 1000);
	        this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause',
	          count: 0
	        });
	      }
	    }
	  }, {
	    key: 'determineSelectedAndShowAnswer',
	    value: function determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey) {
	      var selected = '';
	      var showAnswer = false;
	      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_2);
	      if (selectedChoice && isRevisionMode) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (answerStatus && isRevisionMode) {
	        if (rightAnswer === 1) {
	          selected = 'choice_' + currentQuestion[correctChoiceKey];
	          showAnswer = true;
	        } else if (!rightAnswer) {
	          var correct = currentQuestion[correctChoiceKey];
	          var choices = Object.keys(currentQuestion).filter(function (key) {
	            return key.startsWith('choice') && key !== 'choice_' + correct;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	      return { selected: selected, showAnswer: showAnswer };
	    }
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      this.setState({ case_id: caseid });
	      var data = { token: token_id, idname: idname, chapter_id: chapterid };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            chaptername: resp.chapterdata.chapter_name,
	            chapters: resp.chapterdata
	          });
	        } else {
	          _this5.setState({ ValidToken: false });
	        }
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCases', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            all_cases: resp.readings
	          });
	          for (var i = 0; i < resp.readings.length; i++) {
	            if (_this5.props.params.case_offset == i) {
	              _this5.setState({
	                cases_display: resp.readings[i].case,
	                cases_name: resp.readings[i].case_name_2025
	              });
	            }
	          }
	          _this5.setState({ display_loader: 'hide_block' });
	          var param = { token: token_id, idname: idname, case_id: caseid };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this5.setState({
	                casesquestion_length: resp_question.questions_details.length
	              });
	              if (resp_question.questions_details.length > 0) {
	                //let ques_res=[];
	                var wantedNumber = (0, _cfa2QuestionNumbering.resolveQuestionNumber)(resp_question.questions_details, question_number);
	                var offset_res = '';
	                var questionid = '';
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  if (resp_question.questions_details[i].question_number == wantedNumber) {
	                    offset_res = i;
	                    questionid = resp_question.questions_details[i].id;
	                    _this5.setState({
	                      questions: resp_question.questions_details[i]
	                    });
	                  }
	                }
	                _this5.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details
	                });
	
	                //Api to Fetch saved question stats
	                var params_fav = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid,
	                  chapter_id: chapterid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      save_text: '' + _language2.default.LC().Question_Saved,
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this5.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to get ratting
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({ rated: true });
	                    response.ratting.map(function (items) {
	                      _this5.setState({
	                        rating: items.ratting,
	                        ratting_text: 'Rated '
	                      });
	                    });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to fetch flashcard by question id
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashCards', params).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this5.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      var flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this5._editFlash.bind(_this5, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this5._deleteFlash.bind(_this5, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this5.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this5.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      var flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this5.setState({ flash_data: flash_cards });
	                  } else {
	                    var flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this5.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                  return response;
	                });
	
	                _this5.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this5.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this5.timer);
	        _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax
	
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this6 = this;
	
	      var data = { token: token_id, idname: idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        var data = {
	          token: token_id,
	          idname: idname,
	          caseid: _this6.props.params.caseid
	        };
	        // var final_exam = [];
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesbyId', data).then(function (resp_cases) {
	          if (resp_cases.success) {
	            var data = { token: token_id, idname: idname };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	              var free_status = '';
	              if (resp.profileInfo.role === 'partner') {
	                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                  free_status = 'free';
	                  _this6.setState({ subscriptionstatus: 'free' });
	                  if (resp_cases.casesingleData.free === 0) {
	                    _this6.setState({
	                      display_cases: 'hide_block',
	                      display_subcription: 'show_block'
	                    });
	                    _this6.toggleAlert();
	                  } else {
	                    _this6.setState({
	                      display_cases: 'show_block',
	                      display_subcription: 'hide_block'
	                    });
	                  }
	                } else {
	                  _this6.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  var dataset = {
	                    token: token_id,
	                    idname: idname,
	                    examid: data_arr
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var, examPlanData;
	                      return _regenerator2.default.wrap(function _callee3$(_context3) {
	                        while (1) {
	                          switch (_context3.prev = _context3.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context3.next = 11;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this6.state.selectedmenu;
	                              isInArray_var = false;
	                              // #261 — pass examPlanData so mock-only partners hit
	                              // the early-return false (was missing here).
	
	                              examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                              _context3.next = 7;
	                              return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this6.state.cfaUnlimitedPackage, _this6.state.cfaUnlimitedActiveExam, examPlanData);
	
	                            case 7:
	                              isInArray_var = _context3.sent;
	
	                              if (isInArray_var) {
	                                _this6.setState({
	                                  display_cases: 'show_block',
	                                  display_subcription: 'hide_block'
	                                });
	                              } else {
	                                if (resp_cases.casesingleData.free == 0) {
	                                  _this6.setState({
	                                    display_cases: 'hide_block',
	                                    display_subcription: 'show_block'
	                                  });
	                                } else {
	                                  _this6.setState({
	                                    display_cases: 'show_block',
	                                    display_subcription: 'hide_block'
	                                  });
	                                }
	                              }
	                              _context3.next = 12;
	                              break;
	
	                            case 11:
	                              console.log('fail');
	
	                            case 12:
	                            case 'end':
	                              return _context3.stop();
	                          }
	                        }
	                      }, _callee3, _this6);
	                    }));
	
	                    return function (_x3) {
	                      return _ref7.apply(this, arguments);
	                    };
	                  }());
	                }
	              } else {
	                if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                  free_status = 'free';
	                  //here code for check case id free or not
	                  _this6.setState({ subscriptionstatus: 'free' });
	                  if (resp_cases.casesingleData.free === 0) {
	                    _this6.setState({
	                      display_cases: 'hide_block',
	                      display_subcription: 'show_block'
	                    });
	                    _this6.toggleAlert();
	                  } else {
	                    _this6.setState({
	                      display_cases: 'show_block',
	                      display_subcription: 'hide_block'
	                    });
	                  }
	                } else {
	                  _this6.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  var dataset = {
	                    token: token_id,
	                    idname: idname,
	                    examid: data_arr
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                    if (resp_exam.success) {
	                      var exam_data = resp_exam.examData;
	                      var selectedmen = _this6.state.selectedmenu;
	                      var isInArray_var = false;
	                      isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this6.state.cfaUnlimitedPackage, _this6.state.cfaUnlimitedActiveExam);
	                      if (isInArray_var) {
	                        _this6.setState({
	                          display_cases: 'show_block',
	                          display_subcription: 'hide_block'
	                        });
	                      } else {
	                        if (resp_cases.casesingleData.free == 0) {
	                          _this6.setState({
	                            display_cases: 'hide_block',
	                            display_subcription: 'show_block'
	                          });
	                        } else {
	                          _this6.setState({
	                            display_cases: 'show_block',
	                            display_subcription: 'hide_block'
	                          });
	                        }
	                      }
	                    } else {
	                      console.log('fail');
	                    }
	                  });
	                }
	              }
	            });
	          } else {
	            console.log('Cases not avilable');
	          }
	        });
	      });
	
	      this.setState({ case_id: caseid });
	      var data = { token: token_id, idname: idname, chapter_id: chapterid };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            chaptername: resp.chapterdata.chapter_name,
	            chapters: resp.chapterdata
	          });
	        } else {
	          _this6.setState({ ValidToken: false });
	        }
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCases', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block'
	          });
	          document && document.getElementById('comment') && document.getElementById('comment') && document.getElementById('comment').value ? document.getElementById('comment').value = '' : null;
	
	          _this6.setState({ all_cases: resp.readings });
	          for (var i = 0; i < resp.readings.length; i++) {
	            if (_this6.props.params.case_offset == i) {
	              _this6.setState({
	                cases_display: resp.readings[i].case,
	                cases_name: resp.readings[i].case_name_2025
	              });
	            }
	          }
	          _this6.setState({ display_loader: 'hide_block' });
	          var param = { token: token_id, idname: idname, case_id: caseid };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this6.setState({
	                casesquestion_length: resp_question.questions_details.length
	              });
	              if (resp_question.questions_details.length > 0) {
	                var wantedNumber = (0, _cfa2QuestionNumbering.resolveQuestionNumber)(resp_question.questions_details, question_number);
	                var offset_res = '';
	                var questionid = '';
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  if (resp_question.questions_details[i].question_number == wantedNumber) {
	                    (function () {
	                      offset_res = i;
	                      questionid = resp_question.questions_details[i].id;
	                      // Use determineSelectedAndShowAnswer for answer state
	                      var currentQuestion = resp_question.questions_details[i];
	                      var selectedChoice = currentQuestion["cfa2_2025_question_stats.selected_choice"] || '';
	                      var rightAnswer = currentQuestion["cfa2_2025_question_stats.right_answer"] || '';
	                      var answerStatus = currentQuestion["cfa2_2025_question_stats.id"] || '';
	                      var timeDone = currentQuestion["cfa2_2025_question_stats.time_done"] || 0;
	                      var correctChoiceKey = 'answer';
	
	                      var _determineSelectedAnd2 = _this6.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                          selected = _determineSelectedAnd2.selected,
	                          showAnswer = _determineSelectedAnd2.showAnswer;
	
	                      _this6.updateTimerState(selected, timeDone);
	
	                      var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	                      var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	                        var isSelected = selected === choice;
	                        var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	                        acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : isCorrect ? 'answer_box success' : 'answer_box';
	                        return acc;
	                      }, {});
	
	                      _this6.setState(Object.assign({
	                        questions: currentQuestion,
	                        selectedChoice: selected,
	                        clicked: !!selected
	                      }, choiceBoxStates, {
	                        result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                        text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	                        result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	                        display_loader: 'hide_block'
	                      }));
	                      _this6.handleTimerResponse(selected);
	                    })();
	                  }
	                }
	                _this6.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details
	                });
	                // ... rest of the code ...
	
	                //Api to Fetch saved question stats
	                var params_fav = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid,
	                  chapter_id: chapterid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({
	                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this6.setState({ isFlashCardHidden: true, bookmarkColor: '' });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to get ratting
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({ rated: true });
	                    response.ratting.map(function (items) {
	                      _this6.setState({
	                        rating: items.ratting,
	                        ratting_text: 'Rated '
	                      });
	                    });
	                  }
	                });
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to fetch flashcard by question id
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashCards', params).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      var flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this6._editFlash.bind(_this6, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this6._deleteFlash.bind(_this6, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      var flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    var flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                  return response;
	                });
	                _this6.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this6.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this6.timer);
	        _this6.timer = setInterval(_this6.tick.bind(_this6), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number != this.props.params.question_number && nextProps.params.caseid == this.props.params.caseid) {
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid != this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var questions_data_display = questions;
	
	      var reportLoading = this.state.reportLoading;
	
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	      var forumData = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var data = void 0,
	          question_data = '';
	      forumData = '<div class=\'col-sm-12 no-cursor\'>\n        <div class=\'margin_bottom_40\'>\n          <div>\n            <div class=\'row\'>\n              <div class=\'col-sm-12\'>\n                <div class=\'row no-cursor\'>\n                  <div class=\'col-sm-12 cursor-text\'>\n                    <div\n                      contentEditable=\'false\'\n                      class=\'margin_bottom_40 view_questionhtml bg_blue \'\n                    >                      \n                      ' + questions_data_display.question + '\n                    </div>\n                  </div>\n                  <div class=\'col-sm-12 no-cursor\' id=\'choice_a\'>\n                    <div class=\'answer_box_forum\'>\n                      <div class=\'answer_count\'>' + _language2.default.LC().A + '</div>\n                      <p class=\'ans_box_text\'>\n                        <span contentEditable=\'false\'>                          \n                          ' + questions_data_display.choice_a + '\n                        </span>\n                      </p>\n                    </div>\n                  </div>\n\n                  <div class=\'col-sm-12 no-cursor\' id=\'choice_b\'>\n                    <div class=\'answer_box_forum\'>\n                      <div class=\'answer_count\'>' + _language2.default.LC().B + '</div>\n                      <p class=\'ans_box_text\'>\n                        <span contentEditable=\'false\'>                          \n                          ' + questions_data_display.choice_b + '\n                        </span>\n                      </p>\n                    </div>\n                  </div>\n                  <div\n                    class=\'col-sm-12 margin_bottom_30 no-cursor\'\n                    id=\'choice_c\'\n                  >\n                    <div class=\'answer_box_forum\'>\n                      <div class=\'answer_count\'>' + _language2.default.LC().C + '</div>\n                      <p class=\'ans_box_text\'>\n                        <span contentEditable=\'false\'>\n                          ' + questions_data_display.choice_c + '\n                        </span>\n                      </p>\n                    </div>\n                  </div>\n                  <div class=\'col-sm-12 cursor-text\'>\n                    <p contentEditable=\'false\' class=\'view_questionhtml\'>\n                    The correct answer is  ' + (questions_data_display.answer === 'choice_a' ? '<strong> A.</strong>' : questions_data_display.answer === 'choice_b' ? '<strong> B.</strong>' : questions_data_display.answer === 'choice_c' ? '<strong> C.</strong>' : '<strong> C.</strong>') + ' <br/>\n                    ' + questions_data_display.explanation + '\n                    </p>\n                  </div>\n                  <div class=\'col-sm-12 margin_bottom_30 no-cursor\'>\n                    <div className=\'userQuestionDiv\'>\n                      <span className=\'questionColor cursor-text\'>                        \n                        *User Question:\n                      </span>\n                      <div className=\'forum-data-comment cursor-text\'>\n                        <h4> ' + this.state.forumComment + '</h4>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>';
	      data = _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12 col-md-12 note-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card note-section-header ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header title-font-size' },
	            this.state.cases_name,
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class',
	                onClick: this._getPreviousCase
	              }),
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class',
	                onClick: this._getNextCase
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block note_text_wrap ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 ' },
	                (0, _function.renderHTMLContent)(this.state.cases_display, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })
	              )
	            )
	          )
	        )
	      );
	
	      {
	        this.state.showCompletionQuestion ? question_data = _react2.default.createElement(
	          'div',
	          { className: 'w-100' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + this.state.display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 complete-section-wrap ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header text-center' },
	                _language2.default.LC().Mark_this_Question_as_Completed,
	                _react2.default.createElement(
	                  'div',
	                  { onClick: this.getNextAnyway, className: 'float-right text-right' },
	                  _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 text-center' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 ' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'quation-img' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                            className: 'margin_bottom_10',
	                            alt: ''
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            contentEditable: 'false',
	                            suppressContentEditableWarning: true,
	                            className: 'margin_bottom_10 view_questionhtml bg_blue'
	                          },
	                          ' ',
	                          _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'complete-or-not-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check-button-wrap' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              ' ',
	                              _language2.default.LC().COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_completed',
	                                name: 'mark_completed',
	                                value: 'select',
	                                onClick: this.markCompleted.bind(this),
	                                checked: this.state.markAsCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              _language2.default.LC().NOT_COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_not_completed',
	                                name: 'mark_not_completed',
	                                value: 'select',
	                                onClick: this.markNotCompleted.bind(this),
	                                checked: this.state.markAsNotCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'd-block text-center complete-quation-submit' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              disabled: this.state.markCompleted,
	                              onClick: this.changeCompletionStatus.bind(this),
	                              className: 'btn btn-primary pointer_class'
	                            },
	                            ' ',
	                            _language2.default.LC().SUBMIT,
	                            ' '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : question_data = _react2.default.createElement(
	          'div',
	          { className: 'note-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + this.state.display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card font-lusitana' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                  className: 'margin_right_20',
	                  alt: '',
	                  width: '30'
	                }),
	                _language2.default.LC().QUESTION,
	                ' ',
	                (0, _cfa2QuestionNumbering.questionDisplayNumber)(questions_data_display, this.state.offset) + ' - ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'float-right text-right' },
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-left ques_arrow pointer_class ',
	                    onClick: this.getPrevious
	                  }),
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-right ques_arrow pointer_class ',
	                    onClick: this.getNext
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9' },
	                    _react2.default.createElement(
	                      _ViewQuestion2.default,
	                      Object.assign({}, questions_data_display, this.props, {
	                        setAnswer: this._getAnswer,
	                        showAnswer: this.state.clicked,
	                        correctChoice: 'choice_' + questions_data_display.answer,
	                        selectedChoice: this.state.selectedChoice,
	                        onValidate: function onValidate() {
	                          return _this7.getResult(questions_data_display);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 12, className: 'mt-2' },
	                        _react2.default.createElement(
	                          _reactstrap.Row,
	                          { className: 'align-items-center' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'd-flex align-items-center' },
	                            _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                              isQue: true,
	                              _getResult: this.getResult,
	                              clicked: this.state.clicked,
	                              _saveQuestion: this._saveQuestion,
	                              _displayReportForm: this._displayReportForm,
	                              all_questions: questions_data_display,
	                              save_text: this.state.save_text,
	                              bookmarkCSS: this.state.bookmarkCSS,
	                              bookmarkColor: this.state.bookmarkColor,
	                              disabled: !this.state.selectedChoice || this.state.clicked
	                            })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'timer_outer' },
	                      _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'timer_box' },
	                        display_time
	                      )
	                    ),
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this._timer_funct.bind(this, questions_data_display)
	                    }),
	                    this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	                      'a',
	                      {
	                        onClick: this.getSubscribe,
	                        className: 'box_question_color text-center cursor_pointer'
	                      },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS,
	                        ' '
	                      )
	                    ) : ''
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.result_block + ' font-lusitana font-16px' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.text_color },
	                this.state.result
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                (0, _function.renderHTMLContent)(questions_data_display.explanation, "p", "view_questionhtml", { contentEditable: "false", suppressContentEditableWarning: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class margin_bottom_20 report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, questions_data_display)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10 margin_bottom_20',
	                            onClick: this._hideReportForm.bind(this, questions_data_display)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: questions,
	              type: 'question',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa2_2025'
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row note-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head title-font-size' },
	              _language2.default.LC().CASE_STUDY,
	              ' - ',
	              this.state.chaptername
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_CASES
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          question_data
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        })
	      );
	    }
	  }]);
	
	  return Cfa22023chapter;
	}(_react.Component);
	
	Cfa22023chapter.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa22023chapter;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa2BeforeStart = function (_Component) {
	  _inherits(Cfa2BeforeStart, _Component);
	
	  function Cfa2BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2BeforeStart.__proto__ || Object.getPrototypeOf(Cfa2BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/cfa2/2026/quizzes',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuizpage = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              data = { token: _this.state.token, idname: _this.state.idname };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                if (resp.profileInfo.role === 'partner') {
	                  if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                    _this.toggleAlert();
	                  } else {
	                    _this.setState({
	                      cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                      cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                    });
	                    var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                    var dataset = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      examid: data_arr
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                        var exam_data, selectedmen, isInArray_var, examPlanData;
	                        return _regenerator2.default.wrap(function _callee$(_context) {
	                          while (1) {
	                            switch (_context.prev = _context.next) {
	                              case 0:
	                                if (!resp_exam.success) {
	                                  _context.next = 11;
	                                  break;
	                                }
	
	                                exam_data = resp_exam.examData;
	                                selectedmen = _this.state.selectedmenu;
	                                isInArray_var = false;
	                                examPlanData = resp_exam.examPlan[0];
	                                _context.next = 7;
	                                return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                              case 7:
	                                isInArray_var = _context.sent;
	
	                                if (isInArray_var) {
	                                  _this.context.router.push({
	                                    pathname: '/cfa2/2026/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send
	                                  });
	                                } else {
	                                  _this.toggleAlert();
	                                }
	                                _context.next = 12;
	                                break;
	
	                              case 11:
	                                console.log('fail');
	
	                              case 12:
	                              case 'end':
	                                return _context.stop();
	                            }
	                          }
	                        }, _callee, _this2);
	                      }));
	
	                      return function (_x) {
	                        return _ref2.apply(this, arguments);
	                      };
	                    }());
	                  }
	                } else {
	                  if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                    _this.toggleAlert();
	                  } else {
	                    _this.setState({
	                      cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                      cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                    });
	                    var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                    var dataset = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      examid: data_arr
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                      if (resp_exam.success) {
	                        var exam_data = resp_exam.examData;
	                        var selectedmen = _this.state.selectedmenu;
	                        var isInArray_var = false;
	                        isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                        if (isInArray_var) {
	                          _this.context.router.push({
	                            pathname: '/cfa2/2026/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send
	                          });
	                        } else {
	                          _this.toggleAlert();
	                        }
	                      } else {
	                        console.log('fail');
	                      }
	                    });
	                  }
	                }
	              });
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    var messageTitle_cfa_2 = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa_2,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      all_cases_id: [],
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa2BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    ----------------------------------
	        Go to subscription
	    ----------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	    --------------------------------------------------
	      Function to redirect page to Create Quiz page
	    --------------------------------------------------
	    */
	
	
	    /*
	    --------------------------------------------------
	      Function to redirect page to begin Quiz page
	    --------------------------------------------------
	    */
	
	  }, {
	    key: 'startQuizquestion',
	
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to begin Quiz page
	    -------------------------------------------------
	    */
	    value: function startQuizquestion(item, offset_va, e) {
	      var _this3 = this;
	
	      // var final_exam=[];
	      var data = { token: this.state.token, idname: this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this3.toggleAlert();
	          } else {
	            _this3.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context3.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this3.state.selectedmenu;
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context3.next = 7;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context3.sent;
	
	                        if (isInArray_var) {
	                          _this3.context.router.push({
	                            pathname: '/cfa2/2026/beginquiz/' + _this3.state.quiz_id + '/' + offset_va,
	                            state: {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              quiz_id: _this3.state.quiz_id,
	                              offset: offset_va
	                            }
	                          });
	                        } else {
	                          _this3.toggleAlert();
	                        }
	                        _context3.next = 12;
	                        break;
	
	                      case 11:
	                        console.log('fail');
	
	                      case 12:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this3);
	              }));
	
	              return function (_x2) {
	                return _ref3.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this3.toggleAlert();
	          } else {
	            _this3.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              examid: data_arr
	            };
	
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this3.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this3.context.router.push({
	                    pathname: '/cfa2/2026/beginquiz/' + _this3.state.quiz_id + '/' + offset_va,
	                    state: {
	                      token: _this3.state.token,
	                      idname: _this3.state.idname,
	                      quiz_id: _this3.state.quiz_id,
	                      offset: offset_va
	                    }
	                  });
	                } else {
	                  _this3.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      /*
	      --------------------------------
	        Api to fetch Quiz by quiz id
	      -------------------------------- 
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var all_questions = JSON.parse(resp.singlequiz);
	          var all_cases = JSON.parse(resp.case_id);
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this4.setState({
	            timer_value: minutes,
	            all_question_id: all_questions,
	            all_cases_id: all_cases,
	            question_length: resp.questions_count,
	            user_time_value: resp.user_time_value
	          });
	        }
	      });
	
	      /*
	      ---------------------------------------------------------  
	      Api to fetch all right answered on particular quiz id
	      ---------------------------------------------------------
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this4.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      // console.log('this.props.params.quiz_id', this.props.params.quiz_id);
	      var all_question_id = this.state.all_question_id;
	      var all_cases = this.state.all_cases_id;
	      var case_id_display = '';
	
	      if (all_cases.length) {
	        case_id_display = all_cases.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_head' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20 margin_top_10' },
	                _language2.default.LC().CASE,
	                ': ',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  className: 'float-right btn btn-primary',
	                  onClick: _this5.startQuizquestion.bind(_this5, items, index)
	                },
	                'View'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'table-responsive' },
	              _react2.default.createElement(
	                'table',
	                { className: 'table_white_bg table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    { className: 'border_top_0' },
	                    _react2.default.createElement(
	                      'th',
	                      { width: '90' },
	                      '#'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().QUESTIONS
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { width: '200' },
	                      _language2.default.LC().YOURS_ANSWER
	                    )
	                  )
	                ),
	                _react2.default.createElement(Questionfetch, {
	                  indexval: index,
	                  casesquestion: all_question_id[index],
	                  token: _this5.state.token,
	                  idname: _this5.state.idname,
	                  quiz_id: _this5.state.quiz_id,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      }
	
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.question_length
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        /*status_data = <div className="card">
	          <div className="card-header">Score</div>
	            <div className="card-block">
	              <div className="row">
	                <div className="col-sm-12 text-center">
	                <div className="score_box">{this.state.allrightanswercount}/{this.state.question_length}</div>
	                <h6 className="text-center">Total Time: {user_time}</h6>
	                </div>
	              </div>
	            </div>        
	          </div>;  */
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.question_length
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          'Continue'
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            'Quiz ID: ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            ' ',
	            _language2.default.LC().CREATE_NEW_QUIZ,
	            ' '
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().NO_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().CORRECT_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().WRONG_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              case_id_display
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        })
	      );
	    }
	  }]);
	
	  return Cfa2BeforeStart;
	}(_react.Component);
	
	Cfa2BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var Questionfetch = function (_React$Component) {
	  _inherits(Questionfetch, _React$Component);
	
	  function Questionfetch() {
	    _classCallCheck(this, Questionfetch);
	
	    return _possibleConstructorReturn(this, (Questionfetch.__proto__ || Object.getPrototypeOf(Questionfetch)).apply(this, arguments));
	  }
	
	  _createClass(Questionfetch, [{
	    key: 'render',
	    value: function render() {
	      var casesquestion = this.props.casesquestion;
	      var token = this.props.token;
	      var idname = this.props.idname;
	      var quiz_id = this.props.quiz_id;
	      var answeredstate = this.props.answered_state;
	      var handler = this.props.handler;
	
	      var caseQuestionval = Object.keys(casesquestion).map(function (key) {
	        return (
	          // nosemgrep
	          _react2.default.createElement(
	            'tr',
	            { key: Math.random() },
	            _react2.default.createElement(
	              'td',
	              null,
	              parseInt(key) + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + answeredstate + '_' + key }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionFetchcheck, {
	                answered_state: answeredstate + '_' + key,
	                question_id: casesquestion[key],
	                token: token,
	                idname: idname,
	                quiz_id: quiz_id
	              })
	            )
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        caseQuestionval
	      );
	    }
	  }]);
	
	  return Questionfetch;
	}(_react2.default.Component);
	
	function QuestionFetchcheck(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/checkAnswered', data).then(function (resp) {
	    if (document.getElementById('questionNameId_' + props.answered_state) !== null) document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // This component re-fires checkAnswered on every render; the first response renames the
	      // status span's id, so on a later response the original id is gone (null). Guard like the
	      // else-branch below — the status was already applied by the earlier response.
	      var statusEl = document.getElementById('user_question_status_' + props.answered_state);
	      var flagEl = document.getElementById('answer_flag' + props.answered_state);
	      if (resp.question_recived.answer === 1) {
	        if (statusEl !== null) statusEl.id = 'quiz_answered_status';
	        if (flagEl !== null) flagEl.innerHTML = 'Correct Answer';
	      } else {
	        if (statusEl !== null) statusEl.id = 'quiz_wrong_answered_status';
	        if (flagEl !== null) flagEl.innerHTML = 'Wrong Answer';
	      }
	    } else {
	      if (document.getElementById('user_question_status_' + props.answered_state) !== null) document.getElementById('user_question_status_' + props.answered_state).id = 'quiz_notanswered_status';
	
	      if (document.getElementById('answer_flag' + props.answered_state) !== null) document.getElementById('answer_flag' + props.answered_state).innerHTML = 'No Answer';
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status_' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	exports.default = Cfa2BeforeStart;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	
	
	// import AppRoutes from '../config/AppRoutes';
	/* eslint-disable*/
	var Cfa2Beginquiz = function (_Component) {
	  _inherits(Cfa2Beginquiz, _Component);
	
	  function Cfa2Beginquiz(props) {
	    _classCallCheck(this, Cfa2Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2Beginquiz.__proto__ || Object.getPrototypeOf(Cfa2Beginquiz)).call(this, props));
	
	    _this._getAnswer = function (choice, e) {
	      var selectedChoice = '';
	      if (typeof choice === 'string') {
	        selectedChoice = choice.startsWith('choice_') ? choice : 'choice_' + choice;
	      } else if (Array.isArray(choice) && typeof choice[0] === 'string') {
	        selectedChoice = choice[0].startsWith('choice_') ? choice[0] : 'choice_' + choice[0];
	      }
	      _this.setState({ choice: selectedChoice, selectedChoice: selectedChoice, clicked: false });
	      if (selectedChoice === 'choice_a') {
	        _this.setState({
	          choice_a: 'answer_box clicked_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box'
	        });
	      } else if (selectedChoice === 'choice_b') {
	        _this.setState({
	          choice_b: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_c: 'answer_box'
	        });
	      } else if (selectedChoice === 'choice_c') {
	        _this.setState({
	          choice_c: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box'
	        });
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.state.chapter_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._getResult = function (item, e) {
	      var chosen_answer = _this.state.choice;
	      if (chosen_answer && !_this.state.clicked) {
	        clearInterval(_this.timer);
	        var right_answer = 0;
	        _this.setState({
	          result_block: 'card show_block',
	          clicked: true,
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play',
	          timer_display: 'card-block'
	        });
	        if ('choice_' + item.answer === chosen_answer) {
	          right_answer = 1;
	          if (chosen_answer === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (chosen_answer === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (chosen_answer === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (chosen_answer === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box danger' });
	          } else if (chosen_answer === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box danger' });
	          } else if (chosen_answer === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box danger' });
	          }
	          if (item.answer === 'a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.answer === 'b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (item.answer === 'c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          }
	          _this.setState({
	            result: 'INCORRECT',
	            text_color: 'card-header text_failure',
	            result_block: 'card show_block'
	          });
	        }
	
	        var idx = _this.state.question_offset;
	        var questionsCopy = [].concat(_toConsumableArray(_this.state.questions));
	        if (questionsCopy[idx]) {
	          if (!questionsCopy[idx].cfa2_answer_quizzes) {
	            questionsCopy[idx].cfa2_answer_quizzes = {};
	          }
	          questionsCopy[idx].cfa2_answer_quizzes.selected_choice = chosen_answer;
	          questionsCopy[idx]['cfa2_answer_quizzes.selected_choice'] = chosen_answer;
	          _this.setState({ questions: questionsCopy });
	        }
	
	        if (!_this.state.validated) {
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.questions[_this.state.question_offset].id,
	            answer: right_answer,
	            selectedChoice: chosen_answer
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/answerQuiz', data).then(function (resp) {
	            if (resp.success) {
	              var data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                question_id: _this.state.questions[_this.state.question_offset].id,
	                right_answer: right_answer,
	                time_done: 0,
	                chapter_id: _this.state.chapter_id,
	                selected_choice: _this.state.choice
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveStats', data).then(function (resp) {});
	              _this.setState({ ValidToken: true, validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/cfa2/2026/beforestart/' + _this.state.quiz_id + '/' + 'abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon'
	        }
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // If the question is already attempted, do nothing
	      if (_this.state.clicked || _this.state.validated) {
	        return;
	      }
	      if (_this.state.timer_stop) {
	        _this.setState({
	          timer_stop: false,
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment') ? document.getElementById('comment').value : null;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._editFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-md-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      clearInterval(_this.timer);
	
	      var indexId = _this.state.question_offset + 1;
	      if (indexId === _this.state.questions.length) {
	        _this.setState({
	          showCompletionQuestion: true,
	          next_block: 'card hide_block',
	          markCompleted: false,
	          markAsCompleted: false,
	          markAsNotCompleted: false,
	          display_cases: 'display_block'
	        });
	      } else {
	        _this.setState({ clicked: false });
	        _this.setState({
	          display_loader: 'show_block',
	          already_answered_status: '',
	          validated: false,
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          report_block: 'card hide_block',
	          rating: 0,
	          ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	          bookmarkColor: ''
	        });
	        document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	
	        var insert_time = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          user_time_value: _this.state.count
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/insertTimer', insert_time).then(function (resp) {});
	
	        if (indexId > 0) {
	          _this.setState({ previ_block: '' });
	        }
	
	        var questionData = _this.state.questions[indexId];
	        var selectedChoice = questionData['cfa2_answer_quizzes.selected_choice'] || '';
	        var rightAnswer = questionData['cfa2_answer_quizzes.answer'] || '';
	        var answerStatus = questionData['cfa2_answer_quizzes.id'] || '';
	        var showAnswer = false;
	        var selected = '';
	
	        if (selectedChoice) {
	          selected = selectedChoice;
	          showAnswer = true;
	        } else if (answerStatus) {
	          if (rightAnswer === 1) {
	            selected = 'choice_' + questionData.answer;
	            showAnswer = true;
	          } else if (!rightAnswer) {
	            var correct = 'choice_' + questionData.answer;
	            var choices = Object.keys(questionData).filter(function (key) {
	              return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	            });
	            selected = choices.length > 0 ? choices[0] : '';
	            showAnswer = true;
	          }
	        }
	
	        var boxA = 'answer_box',
	            boxB = 'answer_box',
	            boxC = 'answer_box';
	        var result_block = 'card hide_block',
	            text_color = 'card-header',
	            result = '',
	            clicked = false;
	
	        if (selected) {
	          var _correct = questionData.answer ? 'choice_' + questionData.answer : '';
	          if (selected === 'choice_a') {
	            boxA = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_b') {
	            boxB = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_c') {
	            boxC = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          }
	          if (_correct) {
	            if (selected === _correct) {
	              text_color = 'card-header text_success';
	              result = 'CORRECT';
	            } else {
	              text_color = 'card-header text_failure';
	              result = 'INCORRECT';
	            }
	            result_block = 'card show_block';
	          }
	          clicked = true;
	        }
	
	        _this.setState({
	          question_display: questionData,
	          question_offset: indexId,
	          selectedChoice: selected,
	          choice: selected,
	          clicked: clicked,
	          choice_a: boxA,
	          choice_b: boxB,
	          choice_c: boxC,
	          result_block: result_block,
	          text_color: text_color,
	          result: result,
	          showAnswer: showAnswer,
	          selected: selected,
	          display_loader: 'hide_block'
	        });
	
	        var data_check = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: questionData.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/checkAnswered', data_check).then(function (resp) {
	          _this.setState({ already_answered_status: resp.message });
	        });
	
	        var params_fav = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname,
	          chapter_id: _this.state.chapter_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	          if (responsefav.success) {
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          }
	        });
	
	        if (selectedChoice || selected) {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          _this.setState({
	            timer_stop: false,
	            timerstopbtn: 'pause_btn icon-control-pause'
	          });
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        }
	
	        var params_rating = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params_rating).then(function (response) {
	          if (response.success) {
	            _this.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            _this.setState({
	              rated: false,
	              rating: 0,
	              ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	            });
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ clicked: false });
	      clearInterval(_this.timer);
	      _this.setState({
	        display_loader: 'show_block',
	        already_answered_status: '',
	        validated: false,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        bookmarkColor: ''
	      });
	      document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/insertTimer', insert_time).then(function (resp) {});
	
	      var indexId = _this.state.question_offset - 1;
	      if (indexId < 0) {
	        if (_this.state.offset > 0) {
	          _this._getPreviousCase();
	        } else {
	          _this.setState({ previ_block: 'card hide_block' });
	        }
	      } else {
	        if (indexId === 0) {
	          _this.setState({ previ_block: 'card hide_block' });
	        }
	
	        var questionData = _this.state.questions[indexId];
	        var selectedChoice = questionData['cfa2_answer_quizzes.selected_choice'] || '';
	        var rightAnswer = questionData['cfa2_answer_quizzes.answer'] || '';
	        var answerStatus = questionData['cfa2_answer_quizzes.id'] || '';
	        var showAnswer = false;
	        var selected = '';
	
	        if (selectedChoice) {
	          selected = selectedChoice;
	          showAnswer = true;
	        } else if (answerStatus) {
	          if (rightAnswer === 1) {
	            selected = 'choice_' + questionData.answer;
	            showAnswer = true;
	          } else if (!rightAnswer) {
	            var correct = 'choice_' + questionData.answer;
	            var choices = Object.keys(questionData).filter(function (key) {
	              return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	            });
	            selected = choices.length > 0 ? choices[0] : '';
	            showAnswer = true;
	          }
	        }
	
	        var boxA = 'answer_box',
	            boxB = 'answer_box',
	            boxC = 'answer_box';
	        var result_block = 'card hide_block',
	            text_color = 'card-header',
	            result = '',
	            clicked = false;
	
	        if (selected) {
	          var _correct2 = questionData.answer ? 'choice_' + questionData.answer : '';
	          if (selected === 'choice_a') {
	            boxA = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_b') {
	            boxB = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_c') {
	            boxC = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          }
	          if (_correct2) {
	            if (selected === _correct2) {
	              text_color = 'card-header text_success';
	              result = 'CORRECT';
	            } else {
	              text_color = 'card-header text_failure';
	              result = 'INCORRECT';
	            }
	            result_block = 'card show_block';
	          }
	          clicked = true;
	        }
	
	        _this.setState({
	          question_display: questionData,
	          question_offset: indexId,
	          selectedChoice: selected,
	          choice: selected,
	          clicked: clicked,
	          choice_a: boxA,
	          choice_b: boxB,
	          choice_c: boxC,
	          result_block: result_block,
	          text_color: text_color,
	          result: result,
	          showAnswer: showAnswer,
	          selected: selected,
	          display_loader: 'hide_block'
	        });
	
	        var data_check = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: questionData.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/checkAnswered', data_check).then(function (resp) {
	          _this.setState({ already_answered_status: resp.message });
	        });
	
	        var params_fav = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname,
	          chapter_id: _this.state.chapter_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	          if (responsefav.success) {
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          }
	        });
	
	        if (selectedChoice || selected) {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          _this.setState({
	            timer_stop: false,
	            timerstopbtn: 'pause_btn icon-control-pause'
	          });
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        }
	
	        var params_rating = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params_rating).then(function (response) {
	          if (response.success) {
	            _this.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            _this.setState({
	              rated: false,
	              rating: 0,
	              ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	            });
	          }
	        });
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      clearInterval(_this.timer);
	      var indexId = _this.state.offset - 1;
	
	      var all_cases = _this.state.all_cases;
	
	
	      if (indexId < 0) {
	        return;
	      }
	
	      _this.setState({
	        display_loader: 'show_block',
	        clicked: false,
	        validated: false,
	        already_answered_status: '',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        showCompletionQuestion: false,
	        lastCase: _this.state.cases_display.id,
	        markCompleted: false,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        rating: 0,
	        bookmarkColor: '',
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        result_block: 'card hide_block',
	        previ_block: 'card hide_block',
	        next_block: '',
	        question_offset: 0,
	        offset: indexId,
	        case_id: all_cases[indexId]
	      });
	
	      if (indexId === 0) {
	        _this.setState({ previ_block_cases: 'card hide_block' });
	      }
	      if (indexId < _this.state.cases_length - 1) {
	        _this.setState({ next_block_cases: '' });
	      }
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        casesId: all_cases[indexId]
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getCasesbyId', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/cfa2/2026/beginquiz/' + _this.state.quiz_id + '/' + indexId
	          });
	
	          _this.setState({
	            cases_display: resp.casesdiscription,
	            chapter_id: resp.casesdiscription.chapter_no_2025,
	            case_no: resp.casesdiscription.case_number,
	            chapter_no_2025: resp.casesdiscription.chapter_no_2025
	          });
	
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter_id: resp.casesdiscription.chapter_no_2025
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(function (respchapter) {
	            if (respchapter.success) {
	              _this.setState({
	                chaptername: respchapter.chapterdata.chapter_name,
	                chapters: respchapter.chapterdata
	              });
	
	              var param = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                case_id: resp.casesdiscription.id,
	                isQuiz: true,
	                quiz_id: _this.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(function (resp_question) {
	                if (resp_question.success) {
	                  var questionData = resp_question.questions_details[0];
	                  var selectedChoice = questionData['cfa2_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = questionData['cfa2_answer_quizzes.answer'] || '';
	                  var answerStatus = questionData['cfa2_answer_quizzes.id'] || '';
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = 'choice_' + questionData.answer;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var correct = 'choice_' + questionData.answer;
	                      var choices = Object.keys(questionData).filter(function (key) {
	                        return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  var boxA = 'answer_box',
	                      boxB = 'answer_box',
	                      boxC = 'answer_box';
	                  var result_block = 'card hide_block',
	                      text_color = 'card-header',
	                      result = '',
	                      clicked = false;
	
	                  if (selected) {
	                    var _correct3 = questionData.answer ? 'choice_' + questionData.answer : '';
	                    if (selected === 'choice_a') {
	                      boxA = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_b') {
	                      boxB = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_c') {
	                      boxC = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    }
	                    if (_correct3) {
	                      if (selected === _correct3) {
	                        text_color = 'card-header text_success';
	                        result = 'CORRECT';
	                      } else {
	                        text_color = 'card-header text_failure';
	                        result = 'INCORRECT';
	                      }
	                      result_block = 'card show_block';
	                    }
	                    clicked = true;
	                  }
	
	                  _this.setState({
	                    question_display: questionData,
	                    question_length: resp_question.questions_details.length,
	                    questions: resp_question.questions_details,
	                    selectedChoice: selected,
	                    choice: selected,
	                    clicked: clicked,
	                    choice_a: boxA,
	                    choice_b: boxB,
	                    choice_c: boxC,
	                    result_block: result_block,
	                    text_color: text_color,
	                    result: result,
	                    showAnswer: showAnswer,
	                    selected: selected,
	                    display_loader: 'hide_block'
	                  });
	
	                  if (!selected) {
	                    _this.timer = setInterval(_this.tick.bind(_this), 1000);
	                    _this.setState({
	                      timer_stop: false,
	                      timerstopbtn: 'pause_btn icon-control-pause',
	                      timer_display: 'card-block'
	                    });
	                  } else {
	                    _this.setState({
	                      timer_stop: true,
	                      timerstopbtn: 'pause_btn icon-control-play',
	                      timer_display: 'card-block'
	                    });
	                  }
	                  var data_check = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: questionData.id
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/checkAnswered', data_check).then(function (resp_inner) {
	                    _this.setState({
	                      already_answered_status: resp_inner.message
	                    });
	                  });
	                  var params_fav = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname,
	                    chapter_id: _this.state.chapter_id
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                    if (responsefav.success) {
	                      _this.setState({
	                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	                  // Fetch rating for this question
	                  var params_rating = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params_rating).then(function (response) {
	                    if (response.success) {
	                      _this.setState({ rated: true });
	                      response.ratting.map(function (items) {
	                        _this.setState({
	                          rating: items.ratting,
	                          ratting_text: '' + _language2.default.LC().RATED
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        rated: false,
	                        rating: 0,
	                        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                      });
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this._getNextCase = function () {
	      clearInterval(_this.timer);
	      var indexId = _this.state.offset + 1;
	
	      var all_cases = _this.state.all_cases;
	
	
	      if (indexId >= _this.state.cases_length) {
	        return;
	      }
	
	      _this.setState({
	        display_loader: 'show_block',
	        clicked: false,
	        validated: false,
	        already_answered_status: '',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        showCompletionQuestion: false,
	        lastCase: _this.state.cases_display.id,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        rating: 0,
	        bookmarkColor: '',
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        result_block: 'card hide_block',
	        previ_block: 'card hide_block',
	        next_block: '',
	        question_offset: 0,
	        offset: indexId,
	        case_id: all_cases[indexId]
	      });
	
	      if (indexId > 0) {
	        _this.setState({ previ_block_cases: '' });
	      }
	      if (indexId === _this.state.cases_length - 1) {
	        _this.setState({ next_block_cases: 'card hide_block' });
	      }
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        casesId: all_cases[indexId]
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getCasesbyId', data).then(function (casesData) {
	        if (casesData.success) {
	          _this.context.router.push({
	            pathname: '/cfa2/2026/beginquiz/' + _this.state.quiz_id + '/' + indexId
	          });
	
	          _this.setState({
	            cases_display: casesData.casesdiscription,
	            chapter_id: casesData.casesdiscription.chapter_no_2025,
	            case_no: casesData.casesdiscription.case_number,
	            chapter_no_2025: casesData.casesdiscription.chapter_no_2025
	          });
	
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter_id: casesData.casesdiscription.chapter_no_2025
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(function (respchapter) {
	            if (respchapter.success) {
	              _this.setState({
	                chaptername: respchapter.chapterdata.chapter_name,
	                chapters: respchapter.chapterdata
	              });
	
	              var param = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                case_id: casesData.casesdiscription.id,
	                isQuiz: true,
	                quiz_id: _this.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(function (resp_question) {
	                if (resp_question.success) {
	                  var questionData = resp_question.questions_details[0];
	                  var selectedChoice = questionData['cfa2_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = questionData['cfa2_answer_quizzes.answer'] || '';
	                  var answerStatus = questionData['cfa2_answer_quizzes.id'] || '';
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = 'choice_' + questionData.answer;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var correct = 'choice_' + questionData.answer;
	                      var choices = Object.keys(questionData).filter(function (key) {
	                        return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  var boxA = 'answer_box',
	                      boxB = 'answer_box',
	                      boxC = 'answer_box';
	                  var result_block = 'card hide_block',
	                      text_color = 'card-header',
	                      result = '',
	                      clicked = false;
	
	                  if (selected) {
	                    var _correct4 = questionData.answer ? 'choice_' + questionData.answer : '';
	                    if (selected === 'choice_a') {
	                      boxA = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_b') {
	                      boxB = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_c') {
	                      boxC = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    }
	                    if (_correct4) {
	                      if (selected === _correct4) {
	                        text_color = 'card-header text_success';
	                        result = 'CORRECT';
	                      } else {
	                        text_color = 'card-header text_failure';
	                        result = 'INCORRECT';
	                      }
	                      result_block = 'card show_block';
	                    }
	                    clicked = true;
	                  }
	
	                  _this.setState({
	                    question_display: questionData,
	                    question_length: resp_question.questions_details.length,
	                    questions: resp_question.questions_details,
	                    selectedChoice: selected,
	                    choice: selected,
	                    clicked: clicked,
	                    choice_a: boxA,
	                    choice_b: boxB,
	                    choice_c: boxC,
	                    result_block: result_block,
	                    text_color: text_color,
	                    result: result,
	                    showAnswer: showAnswer,
	                    selected: selected,
	                    display_loader: 'hide_block'
	                  });
	
	                  if (!selected) {
	                    _this.timer = setInterval(_this.tick.bind(_this), 1000);
	                    _this.setState({
	                      timer_stop: false,
	                      timerstopbtn: 'pause_btn icon-control-pause',
	                      timer_display: 'card-block'
	                    });
	                  } else {
	                    _this.setState({
	                      timer_stop: true,
	                      timerstopbtn: 'pause_btn icon-control-play',
	                      timer_display: 'card-block'
	                    });
	                  }
	
	                  var data_check = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: questionData.id
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/checkAnswered', data_check).then(function (resp_inner) {
	                    _this.setState({
	                      already_answered_status: resp_inner.message
	                    });
	                  });
	                  var params_fav = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname,
	                    chapter_id: _this.state.chapter_id
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                    if (responsefav.success) {
	                      _this.setState({
	                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	                  // Fetch rating for this question
	                  var params_rating = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params_rating).then(function (response) {
	                    if (response.success) {
	                      _this.setState({ rated: true });
	                      response.ratting.map(function (items) {
	                        _this.setState({
	                          rating: items.ratting,
	                          ratting_text: '' + _language2.default.LC().RATED
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        rated: false,
	                        rating: 0,
	                        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                      });
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: '',
	      question_length: '',
	      questions: [],
	      question_offset: 0,
	      question_display: '',
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      count: 0,
	      ValidToken: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count_end_message: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      next_block_cases: '',
	      previ_block_cases: '',
	      already_answered_status: '',
	      caseid: '',
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      casesquestion_length: '',
	      chapters: '',
	      chatername: '',
	      chapter_id: '',
	      case_no: '',
	      chapter_no_2025: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      exam_type: 'cfa_2',
	      showCompletionQuestion: false,
	      selectedChoice: '',
	      showAnswer: false,
	      selected: '',
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: false,
	      lastCase: null,
	      display_cases: ''
	    };
	    return _this;
	  }
	
	  _createClass(Cfa2Beginquiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	    /*
	    -----------------------------------------------------------------
	      Function to change time every second and store in database
	    -----------------------------------------------------------------
	    */
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count > 0) {
	        var countValue = this.state.count - 1;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: countValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/insertTimer', insert_time).then(function (resp) {});
	        this.setState({
	          count: countValue,
	          timer_display: 'card-block'
	        });
	      } else {
	        this.setState({
	          timer_display: 'card hide_block',
	          count_end_message: "Time's Up"
	        });
	        clearInterval(this.timer);
	      }
	    }
	
	    /*
	    -------------------------------
	      it is use to redirect page
	    -------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (this.state.offset === 0) {
	        this.setState({ previ_block_cases: 'card hide_block' });
	      }
	      if (this.state.question_offset === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      /*
	      ----------------------------------  
	      Api to fetch Quiz by quiz id
	      ----------------------------------  
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var all_questions = JSON.parse(resp.singlequiz);
	          var all_cases = JSON.parse(resp.case_id);
	          _this2.setState({
	            all_cases: all_cases,
	            timer_value: resp.timer_value,
	            cases_length: all_cases.length,
	            user_time_value: resp.user_time_value
	          });
	
	          if (all_cases.length - 1 === _this2.state.offset) {
	            _this2.setState({ next_block_cases: 'card hide_block' });
	          }
	
	          var initialCount = resp.user_time_value > 0 ? resp.user_time_value : resp.timer_value;
	          _this2.setState({
	            count: initialCount,
	            count_temp: initialCount
	          });
	
	          if (!_this2.state.clicked) {
	            _this2.timer = setInterval(_this2.tick.bind(_this2), 1000);
	            _this2.setState({
	              timer_stop: false,
	              timerstopbtn: 'pause_btn icon-control-pause',
	              timer_display: 'card-block'
	            });
	          } else {
	            _this2.setState({
	              timer_stop: true,
	              timerstopbtn: 'pause_btn icon-control-play',
	              timer_display: 'card-block'
	            });
	          }
	
	          for (var i = 0; i < all_cases.length; i++) {
	            if (parseInt(_this2.props.params.offset) === i) {
	              _this2.setState({ case_id: all_cases[i] });
	              var data = {
	                token: _this2.state.token,
	                idname: _this2.state.idname,
	                casesId: all_cases[i]
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getCasesbyId', data).then(function (resp) {
	                if (resp.success) {
	                  _this2.context.router.push({
	                    pathname: '/cfa2/2026/beginquiz/' + _this2.state.quiz_id + '/' + _this2.state.offset
	                  });
	                  _this2.setState({
	                    cases_display: resp.casesdiscription,
	                    chapter_id: resp.casesdiscription.chapter_no_2025,
	                    case_no: resp.casesdiscription.case_number,
	                    chapter_no_2025: resp.casesdiscription.chapter_no_2025
	                  });
	                  var questionid = '';
	                  var chapter_id = resp.casesdiscription.chapter_no_2025;
	                  var data = {
	                    token: _this2.state.token,
	                    idname: _this2.state.idname,
	                    chapter_id: resp.casesdiscription.chapter_no_2025
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChaptersbyID', data).then(function (respchapter) {
	                    if (respchapter.success) {
	                      _this2.setState({
	                        chaptername: respchapter.chapterdata.chapter_name,
	                        chapters: respchapter.chapterdata
	                      });
	
	                      var param = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        case_id: resp.casesdiscription.id,
	                        isQuiz: true,
	                        quiz_id: _this2.state.quiz_id
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCasesquestion', param).then(function (resp_question) {
	                        if (resp_question.success) {
	                          var questionData = resp_question.questions_details[_this2.state.question_offset];
	                          var selectedChoice = questionData['cfa2_answer_quizzes.selected_choice'] || '';
	                          var rightAnswer = questionData['cfa2_answer_quizzes.answer'] || '';
	                          var answerStatus = questionData['cfa2_answer_quizzes.id'] || '';
	                          var showAnswer = false;
	                          var selected = '';
	
	                          if (selectedChoice) {
	                            selected = selectedChoice;
	                            showAnswer = true;
	                          } else if (answerStatus) {
	                            if (rightAnswer === 1) {
	                              selected = 'choice_' + questionData.answer;
	                              showAnswer = true;
	                            } else if (!rightAnswer) {
	                              var correct = 'choice_' + questionData.answer;
	                              var choices = Object.keys(questionData).filter(function (key) {
	                                return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                              });
	                              selected = choices.length > 0 ? choices[0] : '';
	                              showAnswer = true;
	                            }
	                          }
	                          var boxA = 'answer_box',
	                              boxB = 'answer_box',
	                              boxC = 'answer_box';
	                          var result_block = 'card hide_block',
	                              text_color = 'card-header',
	                              result = '',
	                              clicked = false;
	
	                          if (selected) {
	                            var _correct5 = questionData.answer ? 'choice_' + questionData.answer : '';
	                            if (selected === 'choice_a') {
	                              boxA = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	                            } else if (selected === 'choice_b') {
	                              boxB = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	                            } else if (selected === 'choice_c') {
	                              boxC = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	                            }
	                            if (_correct5) {
	                              if (selected === _correct5) {
	                                text_color = 'card-header text_success';
	                                result = 'CORRECT';
	                              } else {
	                                text_color = 'card-header text_failure';
	                                result = 'INCORRECT';
	                              }
	                              result_block = 'card show_block';
	                            }
	                            clicked = true;
	                          }
	                          _this2.setState({
	                            question_display: questionData,
	                            question_length: resp_question.questions_details.length,
	                            questions: resp_question.questions_details,
	                            question_offset: _this2.state.question_offset,
	                            selectedChoice: selected,
	                            choice: selected,
	                            clicked: clicked,
	                            choice_a: boxA,
	                            choice_b: boxB,
	                            choice_c: boxC,
	                            result_block: result_block,
	                            text_color: text_color,
	                            result: result,
	                            showAnswer: showAnswer,
	                            selected: selected
	                          });
	                          questionid = questionData.id;
	
	                          var data_check = {
	                            token: _this2.state.token,
	                            idname: _this2.state.idname,
	                            quiz_id: _this2.state.quiz_id,
	                            question_id: questionid
	                          };
	                          /*
	                          --------------------------------------------
	                          Api to fetch question and check answered 
	                          --------------------------------------------  
	                          */
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/checkAnswered', data_check).then(function (resp_inner) {
	                            _this2.setState({
	                              already_answered_status: resp_inner.message
	                            });
	                          });
	                          _this2.setState({ display_loader: 'hide_block' });
	                          clearInterval(_this2.timer);
	                          if (selected) {
	                            _this2.setState({
	                              timer_stop: true,
	                              timerstopbtn: 'pause_btn icon-control-play'
	                            });
	                          } else {
	                            _this2.setState({
	                              timer_stop: false,
	                              timerstopbtn: 'pause_btn icon-control-pause'
	                            });
	                            _this2.timer = setInterval(_this2.tick.bind(_this2), 1000);
	                          }
	                          var params_fav = {
	                            token: _this2.state.token,
	                            question_id: questionid,
	                            idname: _this2.state.idname,
	                            chapter_id: chapter_id
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                            if (responsefav.success) {
	                              _this2.setState({
	                                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                                bookmarkColor: 'rgb(54, 141, 84)',
	                                save_text: '' + _language2.default.LC().Question_Saved
	                              });
	                            }
	                          });
	                          var params = {
	                            token: _this2.state.token,
	                            idname: _this2.state.idname,
	                            question_id: questionid
	                          };
	                          /*
	                          ------------------------------------------ 
	                          Api to fetch flashcard by question id
	                          ------------------------------------------
	                          */
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFlashCards', params).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ ValidToken: true });
	                              if (response.flash_cards.length > 0) {
	                                _this2.setState({
	                                  flash_form: 'col-md-12 hide_block'
	                                });
	                                var flash_cards = response.flash_cards.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: '' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'icon_list' },
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this2._editFlash.bind(_this2, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this2._deleteFlash.bind(_this2, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: _this2.state.flash_class },
	                                        _react2.default.createElement('h4', null),
	                                        _react2.default.createElement(
	                                          'p',
	                                          null,
	                                          items.flash_card
	                                        )
	                                      )
	                                    )
	                                  );
	                                });
	                              } else {
	                                _this2.setState({
	                                  flash_form: 'col-md-12 display_block'
	                                });
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                              }
	                              _this2.setState({ flash_data: flash_cards });
	                            } else {
	                              var flash_cards = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_FLASHCARD_FOUND
	                              );
	                              _this2.setState({
	                                ValidToken: false,
	                                flash_data: flash_cards,
	                                flash_form: 'col-md-12 display_block'
	                              });
	                            }
	                            return response;
	                          });
	                          _this2.setState({ records: '' });
	                          // Fetch rating for this question
	                          var params_rating = {
	                            token: _this2.state.token,
	                            question_id: questionid,
	                            idname: _this2.state.idname
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params_rating).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ rated: true });
	                              response.ratting.map(function (items) {
	                                _this2.setState({
	                                  rating: items.ratting,
	                                  ratting_text: '' + _language2.default.LC().RATED
	                                });
	                              });
	                            } else {
	                              _this2.setState({
	                                rated: false,
	                                rating: 0,
	                                ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                              });
	                            }
	                          });
	                        }
	                      });
	                    } else {
	                      _this2.setState({ ValidToken: false });
	                    }
	                  });
	                }
	              });
	            }
	          }
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.showCompletionQuestion && this.state.lastCase && this.state.cases_display.id != this.state.lastCase && !this.state.markCompleted) {
	        document.getElementById('mark_not_completed') && document.getElementById('mark_not_completed').checked ? document.getElementById('mark_not_completed').checked = false : '';
	        document.getElementById('mark_completed') && document.getElementById('mark_completed').checked ? document.getElementById('mark_completed').checked = false : '';
	      }
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/UpdateCfaRatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getCfaratting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveCfaratting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({
	                  rated: 1,
	                  ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	                });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveCfaratting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({
	                rated: 1,
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    -------------------------------------------------------------------------
	      Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to readings beforestart
	    ------------------------------------------------------ 
	    */
	
	
	    /*
	    ------------------------------------
	    Function to start or stop timer
	    ------------------------------------
	    */
	
	    /*
	    ----------------------------------
	      Function to show Report box
	    ---------------------------------
	    */
	
	
	    /*
	    ---------------------------------------------
	      Funcion to save new report question
	    ---------------------------------------------
	    */
	
	    /*
	    --------------------------------
	      Function to hide Report box
	    -------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	        Function to toggle Comment box
	    --------------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Flash box
	    -----------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    -------------------------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------
	      Function to Edit Flash card
	    ------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to delete flash card
	    ------------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to fetch Next question
	    -----------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to fetch Previous question
	    -----------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to fetch Previous case
	    -----------------------------------
	    */
	
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this4 = this;
	
	      e.preventDefault();
	
	      if (!this.state.markAsCompleted && !this.state.markAsNotCompleted) {
	        return;
	      }
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.case_no,
	        completion_status: this.state.markAsCompleted ? 1 : 0,
	        exam_type: this.state.exam_type,
	        chapter_id: this.state.chapter_id
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(function (casesData) {
	        if (casesData.success) {
	          _this4.setState({
	            markCompleted: true,
	            showCompletionQuestion: false
	          });
	
	          var indexId = _this4.state.offset + 1;
	          if (indexId < _this4.state.cases_length) {
	            _this4._getNextCase();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var rating = this.state.rating;
	      var clicked = this.state.clicked;
	
	      var questions_data_display = this.state.question_display;
	
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	
	      var data = void 0,
	          question_data = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      data = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.cases_display.case_name_2025 || this.state.cases_display.case_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block_cases,
	                  onClick: this._getPreviousCase
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block_cases,
	                  onClick: this._getNextCase
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      (0, _function.renderHTMLContent)(this.state.cases_display.case, 'div', 'margin_bottom_40 view_questionhtml bg_blue', { contentEditable: 'false' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'quiz_timer_btn ' + this.state.timer_display },
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this._timer_funct.bind(this, questions_data_display)
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-danger' },
	                    (0, _function.renderHTMLContent)(this.state.count_end_message, 'div', '', {
	                      contentEditable: 'false'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	
	      question_data = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              _language2.default.LC().QUESTION,
	              ' ',
	              questions_data_display.question_number + ' - ',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, questions_data_display, this.props, {
	                      setAnswer: this._getAnswer,
	                      showAnswer: clicked,
	                      correctChoice: 'choice_' + questions_data_display.answer,
	                      selectedChoice: this.state.selectedChoice,
	                      onValidate: function onValidate() {
	                        return _this5._getResult(questions_data_display);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'd-flex align-items-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'validate-save-report-wrap' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          clicked: this.state.clicked,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions_data_display,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor,
	                          disabled: !this.state.selectedChoice || this.state.clicked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right mr-10',
	                          style: { marginRight: '650px' }
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          { className: ' margin_bottom_0 margin_right_10 font-16px' },
	                          this.state.ratting_text
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'star_rating_wrap' },
	                          _react2.default.createElement(_reactStarRatings2.default, {
	                            rating: this.state.rating,
	                            starRatedColor: 'rgb(255, 180, 0)',
	                            starEmptyColor: 'rgb(51, 51, 51)',
	                            starDimension: '20px',
	                            starHoverColor: 'rgb(255, 180, 0)',
	                            starSpacing: '2px',
	                            changeRating: this.onStarClick.bind(this, questions_data_display),
	                            numberOfStars: 5,
	                            name: 'rate1'
	                          })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-sm-3' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions_data_display.explanation, 'div', '', {
	                contentEditable: 'false'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: this._reportQuestion.bind(this, questions_data_display)
	                    },
	                    _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, questions_data_display)
	                    },
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	      if (this.state.showCompletionQuestion) {
	        question_data = _react2.default.createElement(
	          'div',
	          { className: 'complete-section-wrap ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header text-center' },
	              _language2.default.LC().Mark_this_Question_as_Completed,
	              _react2.default.createElement(
	                'div',
	                { onClick: this.changeCompletionStatus, className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          this.state.markCompleted ? 'Submitted' : _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.markCompleted) {
	        document.getElementById('mark_not_completed') && document.getElementById('mark_not_completed').checked ? document.getElementById('mark_not_completed').checked = false : '';
	        document.getElementById('mark_completed') && document.getElementById('mark_completed').checked ? document.getElementById('mark_completed').checked = false : '';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().QUIZ_ID,
	              ': ',
	              this.state.quiz_id
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	              _language2.default.LC().BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	            question_data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2Beginquiz;
	}(_react.Component);
	
	Cfa2Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa fa-info-circle', id: 'Tooltip-' + this.props.id }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          this.props.tooltip
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa2Beginquiz;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _toast = __webpack_require__(15);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Cfa2_2023Quizzes = function (_Component) {
	  _inherits(Cfa2_2023Quizzes, _Component);
	
	  function Cfa2_2023Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2_2023Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2_2023Quizzes.__proto__ || Object.getPrototypeOf(Cfa2_2023Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot === dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i === dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    //console.log("Some Thing Went Wrong");
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this.prioritySelected = function (e) {
	      _this.setState({ quizPriorityLevel: e.target.value });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 4;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: '',
	      all_checked_state: true,
	      radio_checked_question: 0,
	      quizPriorityLevel: 'none',
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      caseId: [],
	      caseQuestion: [],
	      caseQuestionNextval: [],
	      display_loader: 'show_block',
	      deleteItemId: '',
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _messages.messages.QUIZ_PRIORITY,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().UNANSWERED_QUIZ_SELECTED,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Cfa2_2023Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getChapters', data).then(function (resp) {
	        var success = resp.success,
	            chapters = resp.chapters;
	
	        if (success) {
	          _this3.setState({ ValidToken: true, chapters: chapters });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	
	      this.abandonedQuizzes(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        var success = resp_quiz_length.success,
	            quiz_length = resp_quiz_length.quiz_length;
	
	        if (success) {
	          _this3.setState({ quiz_length_state: quiz_length });
	        }
	      });
	    }
	  }, {
	    key: '_createQuiz',
	    value: function _createQuiz() {
	      var _this4 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      this.setState({ caseId: [] });
	      this.setState({ caseQuestion: [] });
	      var question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	      var timer_value,
	          selectedChapter,
	          caselength = '';
	      timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	
	      if (this.state.all_checked_state) {
	        selectedChapter = this.state.chapters.map(function (val) {
	          return val.id;
	        });
	      } else {
	        var checkboxes = document.getElementsByName('approve[]');
	        var i = 0;
	        var single_clicked_value = [];
	        // if (this.state.single_clicked_val === '') {
	        for (i = 0; i < checkboxes.length; i++) {
	          if (checkboxes[i].checked) {
	            single_clicked_value.push(checkboxes[i].value);
	          }
	
	          // }
	          selectedChapter = single_clicked_value;
	        }
	      }
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        priority: this.state.quizPriorityLevel,
	        selectedChapter: selectedChapter
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getRandomCases', data).then(function (resp) {
	        if (resp.success) {
	          var allCasesid_arr;
	          var i;
	          var allCasesid;
	          var j;
	          var dataparam;
	          var k;
	
	          var _ret = function () {
	            var getRandomValues = function getRandomValues(arr, count) {
	              var result = [];
	              var _tmp = arr.slice();
	              for (var i = 0; i < count; i++) {
	                var index = (0, _function.generateRandomInteger)(1, 10) % _tmp.length;
	                result.push(_tmp.splice(index, 1)[0]);
	              }
	              return result;
	            };
	
	            allCasesid_arr = [];
	
	            for (i = 0; i < resp.chaptersWiseCases.length; i++) {
	              allCasesid_arr.push(resp.chaptersWiseCases[i].id);
	            }
	            if (allCasesid_arr.length < caselength) {
	              (0, _toast.showFailure)(_language2.default.LC().CFA2_2025_QUIZ_ERROR);
	              _this4.setState({ display_loader: 'hide_block' });
	              return {
	                v: void 0
	              };
	            }
	            allCasesid = getRandomValues(allCasesid_arr, question_length_val / 6);
	
	            _this4.setState({ caseId: [] });
	            _this4.setState({ caseQuestion: [] });
	            var chaptersWiseCasesQuestionCount = 0;
	
	            for (j = 0; j < allCasesid.length; j++) {
	              dataparam = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                casesId: allCasesid[j]
	              };
	              k = 0;
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/getCasesquearraybyId', dataparam).then(function (respquestion) {
	                var qid = {};
	                var questionCount = respquestion.chapterswisecases && respquestion.chapterswisecases.length > 0 ? respquestion.chapterswisecases.length : 0;
	                chaptersWiseCasesQuestionCount += questionCount;
	
	                for (var l = 0; l < respquestion.chapterswisecases.length; l++) {
	                  qid[l] = respquestion.chapterswisecases[l].id;
	                }
	                var caseIdjoined = _this4.state.caseId.concat(respquestion.caseId);
	                var questionJoined = '';
	                questionJoined = _this4.state.caseQuestion.concat(qid);
	                _this4.setState({ caseQuestion: questionJoined, caseId: caseIdjoined }, function () {
	                  var _this5 = this;
	
	                  //console.log(this.state);
	                  if (k === allCasesid.length - 1) {
	                    var _state = this.state,
	                        caseId = _state.caseId,
	                        caseQuestion = _state.caseQuestion,
	                        idname = _state.idname,
	                        token = _state.token;
	
	                    var casesId = caseId; // This should be an array like [17,49,89]
	                    var questionStats = JSON.stringify(caseQuestion);
	
	                    var allCasesLength = question_length_val / _constant.DIVISOR_FOR_CASES;
	
	                    if (allCasesLength !== casesId.length) {
	                      (0, _toast.showInformation)(_messages.messages.NON_ATTEMPTED_QUIZ);
	                      this.setState({ display_loader: 'hide_block' });
	                      return;
	                    }
	
	                    var data = {
	                      token: token,
	                      idname: idname,
	                      number_questions: chaptersWiseCasesQuestionCount,
	                      // number_questions: question_length_val, // it makes incorrect questions count
	                      case_id: JSON.stringify(casesId),
	                      questions: questionStats,
	                      timer_value: timer_value
	                    };
	                    //console.log(data);
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025quizes/createQuiz', data).then(function (resp) {
	                      if (resp.success) {
	                        _this5.setState({ display_loader: 'hide_block' });
	                        _this5.context.router.push({
	                          pathname: '/cfa2/2026/beforestart/' + resp.last_id + '/',
	                          state: {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            quiz_id: resp.last_id,
	                            status_send: ''
	                          }
	                        });
	                      } else {
	                        //console.log(resp.success);
	                      }
	                    });
	                  }
	                });
	                k++;
	              });
	            }
	          }();
	
	          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        } else {
	          (0, _toast.showInformation)(_messages.messages.CASES_NOT_AVAILABLE);
	          _this4.setState({ display_loader: 'hide_block' });
	        }
	      });
	    }
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: '/cfa2/2026/beforestart/' + items.id + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon'
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: '/cfa2/2026/beforestart/' + items.id + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed'
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          tooltips = _state2.tooltips,
	          quizPriorityLevel = _state2.quizPriorityLevel,
	          chapters = _state2.chapters;
	
	      var chapters_all = chapters;
	      var chapter_data = '';
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.id,
	                onClick: _this6._single_Checked.bind(_this6)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this6._checkAbondon.bind(_this6, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this6.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this6._checkCompleted.bind(_this6, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            _react2.default.createElement(
	              'span',
	              null,
	              items.quiz_length / 6
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _language2.default.LC().CASES
	            ),
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this6.state.radio_checked_question === index,
	              onClick: _this6._length_Checked.bind(_this6, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().CFA_LEVEL_II_QUIZZES,
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary pointer_class', onClick: this._createQuiz.bind(this) },
	            ' ',
	            _language2.default.LC().CREATE_QUIZ,
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-7' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CONTENT,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'check_container margin_bottom_0' },
	                    ' ',
	                    _language2.default.LC().ALL_CHAPTERS,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'all_Checked',
	                      name: 'all_checked',
	                      value: 'select',
	                      onClick: this._all_Checked.bind(this),
	                      checked: this.state.all_checked_state
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block padding_15' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  chapter_data
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().ABANDONED_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '1',
	                    id: '1',
	                    content: this.state.tooltips[1].placement,
	                    place_tip: this.state.tooltips[1].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      abandoned_data
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _messages.messages.FILTER_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '3',
	                    id: '3',
	                    content: tooltips[3].placement,
	                    place_tip: tooltips[3].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'radio_container' },
	                  ' ',
	                  _messages.messages.NONE,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'none',
	                    name: 'none',
	                    value: 'none',
	                    checked: quizPriorityLevel === 'none',
	                    onClick: this.prioritySelected
	                  }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'radio_container' },
	                  _messages.messages.NON_ATTEMPTED_CASES,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'mark_unanswered',
	                    name: 'mark_unanswered',
	                    value: 'unanswered',
	                    checked: quizPriorityLevel === 'unanswered',
	                    onClick: this.prioritySelected
	                  }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '4',
	                    id: '4',
	                    content: tooltips[4].placement,
	                    place_tip: tooltips[4].text_align
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().LENGTH,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '0',
	                    id: '0',
	                    content: this.state.tooltips[0].placement,
	                    place_tip: this.state.tooltips[0].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                quiz_length_state_data
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().COMPLETED_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '2',
	                    id: '2',
	                    content: this.state.tooltips[2].placement,
	                    place_tip: this.state.tooltips[2].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      getallcompleteQuiz_data
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2_2023Quizzes;
	}(_react.Component);
	
	Cfa2_2023Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this7 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this7.toggle = _this7.toggle.bind(_this7);
	    _this7.state = {
	      tooltipOpen: false
	    };
	    return _this7;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	exports.default = Cfa2_2023Quizzes;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1001);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _toast = __webpack_require__(15);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfavideodisplay = function (_Component) {
	  _inherits(Cfavideodisplay, _Component);
	
	  function Cfavideodisplay(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, Cfavideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (Cfavideodisplay.__proto__ || Object.getPrototypeOf(Cfavideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/trackUserVideowatch', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment,
	        videoIndex: _this.state.currentUrl,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          // FD.callAPI(
	          //   App_data.backend_api + '/cfa_2_2025question_bank/videoGetFlashCards',
	          //   params
	          // ).then((response) => {
	          //   if (response.success) {
	          //     this.setState({ ValidToken: true });
	          //     if (response.flash_cards.length > 0) {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	          //       });
	          //       var flash_cards = response.flash_cards.map((items) => (
	          //         <li key={items.id}>
	          //           <div className=''>
	          //             <ul className='icon_list'>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._editFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-pencil' />
	          //                 </a>
	          //               </li>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._deleteFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-close' />
	          //                 </a>
	          //               </li>
	          //             </ul>
	          //             <div className={this.state.flash_class}>
	          //               <h4 />
	          //               <p>{items.flash_card}</p>
	          //             </div>
	          //           </div>
	          //         </li>
	          //       ));
	          //     } else {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //       });
	          //       var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     }
	          //     this.setState({ flash_data: flash_cards });
	          //   } else {
	          //     var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     this.setState({ ValidToken: false });
	          //     this.setState({ flash_data: flash_cards });
	          //     this.setState({
	          //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //     });
	          //   }
	          //   return response;
	          // });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      var path = _AppRoutes2.default.CFA2_2025_VIDEO_LESSONS;
	      _this.context.router.push({
	        // pathname: '/cfa2_videolessons/',
	        pathname: path,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.moveToNotes = function (reading, e) {
	      var final_exam = [];
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, storage_session, _data;
	
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context2.next = 6;
	                        return _Cfa2Subscription4.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	
	                        if (isInArray_var) {
	                          storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                          if (storage_session) {
	                            _data = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              reading_id: _this.state.currentReadingNo,
	                              chapter_id: _this.state.currentChapterNo,
	                              offset: 0,
	                              limit: 10
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes', _data).then(function (resp) {
	                              console.log(resp);
	                              if (resp.success) {
	                                console.log('resp.questions ---------------> ', resp.questions, resp.questions.length);
	                                if (resp.questions.length) {
	                                  var path = _AppRoutes2.default.CFA2_2025_NOTES_QUES_VIEW.replace(':chapter_no', _this.state.currentChapterNo).replace(':id', _this.state.currentReadingNo).replace(':reading', _this.state.currentReadingTitle);
	                                  _this.context.router.push({
	                                    pathname: path,
	                                    state: {
	                                      token: _this.state.token,
	                                      idname: _this.state.idname,
	                                      reading: {
	                                        id: _this.state.currentReadingNo,
	                                        chapter_no: _this.state.currentChapterNo,
	                                        reading: _this.state.currentReadingTitle,
	                                        chapter: _this.state.currentChapterNo
	                                      }
	                                    }
	                                  });
	                                } else {
	                                  (0, _toast.showFailure)('No Notes found');
	                                }
	                              } else {
	                                console.log('resp.fail');
	                              }
	                              return resp;
	                            });
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x3) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp);
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                // console.log(exam_data);
	                // console.log(selectedmen);
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                  if (storage_session) {
	                    var _data2 = {
	                      idname: storage_session['idname'],
	                      token: storage_session['token'],
	                      reading_id: _this.state.currentReadingNo,
	                      chapter_id: _this.state.currentChapterNo,
	                      offset: 0,
	                      limit: 10
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2025_notes/getNotes', _data2).then(function (resp) {
	                      // console.log(resp);
	                      if (resp.success) {
	                        console.log('resp.questions ---------------> ', resp.questions, resp.questions.length);
	                        if (resp.questions.length) {
	                          var path = _AppRoutes2.default.CFA2_2025_NOTES_QUES_VIEW.replace(':chapter_no', _this.state.currentChapterNo).replace(':id', _this.state.currentReadingNo).replace(':reading', _this.state.currentReadingTitle);
	                          _this.context.router.push({
	                            pathname: path,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              reading: {
	                                id: _this.state.currentReadingNo,
	                                chapter_no: _this.state.currentChapterNo,
	                                reading: _this.state.currentReadingTitle,
	                                chapter: _this.state.currentChapterNo
	                              }
	                            }
	                          });
	                        } else {
	                          (0, _toast.showFailure)('No Notes found');
	                        }
	                      } else {
	                        console.log('resp.fail');
	                      }
	                      return resp;
	                    });
	                  }
	                } else {
	                  console.log('work');
	
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context3.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context3.next = 6;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context3.sent;
	
	
	                        if (isInArray_var) {
	                          _this._runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context3.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this2);
	              }));
	
	              return function (_x4) {
	                return _ref3.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp);
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context4.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(index, url_id, title, id, url_id_qq, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context7.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file
	                }, function () {
	                  var path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                  _this.context.router.push({
	                    pathname: path
	                  });
	                });
	
	                _context7.next = 4;
	                return _this.savelastVideo(id, index);
	
	              case 4:
	                _context7.next = 6;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 6:
	                _context7.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context5.next = 6;
	                                  return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context5.sent;
	
	                                  if (!isInArray_var) {
	                                    _context5.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    var path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                                    _this.context.router.push({
	                                      pathname: path
	                                    });
	                                  });
	                                  _context5.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context5.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context5.abrupt('return');
	
	                                case 16:
	                                  return _context5.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context5.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this2);
	                        }));
	
	                        return function (_x13) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                      // console.log("if working");
	
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee6$(_context6) {
	                            while (1) {
	                              switch (_context6.prev = _context6.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context6.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context6.next = 6;
	                                  return _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context6.sent;
	
	                                  if (!isInArray_var) {
	                                    _context6.next = 16;
	                                    break;
	                                  }
	
	                                  // console.log('IF WORKING')
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    var path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                                    _this.context.router.push({
	                                      pathname: path
	                                    });
	                                  });
	                                  _context6.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context6.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context6.abrupt('return');
	
	                                case 16:
	                                  return _context6.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context6.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context6.stop();
	                              }
	                            }
	                          }, _callee6, _this2);
	                        }));
	
	                        return function (_x14) {
	                          return _ref7.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(id, index) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context8.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x15, _x16) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      // console.log('_saveFavVideo', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	
	          return resp;
	        });
	      }
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state3 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state3, 'MessageTitle', messageTitle_cfa), _defineProperty(_this$state3, 'MessageContent', _alertMessage2.default.messageContent_cfa_1), _defineProperty(_this$state3, 'token', ''), _defineProperty(_this$state3, 'idname', ''), _defineProperty(_this$state3, 'ValidToken', false), _defineProperty(_this$state3, 'all_questions', ''), _defineProperty(_this$state3, 'chapters', []), _defineProperty(_this$state3, 'all_questions_state', []), _defineProperty(_this$state3, 'video_display', ''), _defineProperty(_this$state3, 'video_display_qq', ''), _defineProperty(_this$state3, 'url_id', ''), _defineProperty(_this$state3, 'currentUrl', ''), _defineProperty(_this$state3, 'reportLoading', false), _defineProperty(_this$state3, 'free', ''), _defineProperty(_this$state3, 'video_title', ''), _defineProperty(_this$state3, 'video_display_no', ''), _defineProperty(_this$state3, 'allChapters', []), _defineProperty(_this$state3, 'Chapter_Title', ''), _defineProperty(_this$state3, 'chapterName', ''), _defineProperty(_this$state3, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state3, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state3, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state3, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state3, 'currentReading', _this.props.params.id), _defineProperty(_this$state3, 'comment_update_id', ''), _defineProperty(_this$state3, 'currentChapterNo', ''), _defineProperty(_this$state3, 'currentReadingNo', ''), _defineProperty(_this$state3, 'currentReadingTitle', ''), _defineProperty(_this$state3, 'subscriptionstatus', ''), _defineProperty(_this$state3, 'selectedmenu', 'cfa_2'), _defineProperty(_this$state3, 'subscription_details_for_isActive', ''), _defineProperty(_this$state3, 'pdfData', []), _defineProperty(_this$state3, 'pdf_file', ''), _defineProperty(_this$state3, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state3, 'userType', ''), _defineProperty(_this$state3, 'isFlashCardHidden', true), _defineProperty(_this$state3, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state3, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state3, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state3, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state3, 'bookmarkColor', ''), _defineProperty(_this$state3, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _this$state3);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(Cfavideodisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
	      // const result = getDeviceDetails();
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	      var path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium ? 1 : 0).replace(':type', this.props.params.type ? 1 : 0).replace(':chapter_id', this.props.params.chapter_id ? this.props.params.chapter_id : this.props.params.id).replace(':index', this.state.currentUrl + 1);
	      this.context.router.push({
	        pathname: path
	      });
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        // if (this.state.currentUrl || this.state.currentUrl) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("_goToPreviousReading-tooogle");
	              return _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    // console.log('IF WORKING')
	                    // console.log("_goToPreviousReading Premium");
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      console.log('currentUrl', this.state.currentUrl);
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      var path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium ? 1 : 0).replace(':type', this.props.params.type ? 1 : 0).replace(':chapter_id', this.props.params.chapter_id ? this.props.params.chapter_id : this.props.params.id).replace(':index', this.state.currentUrl + 1);
	      this.context.router.push({
	        pathname: path
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context9.next = 16;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this4.state.selectedmenu;
	                          isInArray_var = false;
	                          _context9.next = 6;
	                          return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                        case 6:
	                          isInArray_var = _context9.sent;
	
	                          if (!isInArray_var) {
	                            _context9.next = 13;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({
	                              video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                            });
	                            _this4.setState({
	                              video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                            });
	                            _this4.setState({
	                              video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                            });
	                            _this4.setState({
	                              currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                            });
	                            _this4.setState({
	                              currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                            });
	                            _this4.setState({
	                              currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                            });
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context9.abrupt('return');
	
	                        case 13:
	                          return _context9.abrupt('return', _this4.toggleAlert());
	
	                        case 14:
	                          _context9.next = 17;
	                          break;
	
	                        case 16:
	                          console.log('fail');
	
	                        case 17:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this4);
	                }));
	
	                return function (_x17) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("working");
	              // console.log("_goToNextReading toggleAlert");
	
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    // console.log("_goToNextReading Premium");
	
	                    // console.log('IF WORKING')
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id_2025
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no_2025
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getQuestions', data).then(function (resp) {
	        // console.log("resp");
	        // console.log(resp);
	        // console.log("resp");
	        // console.log(resp.questions.length);
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: '/cfa2/2026/cases/' + _this5.state.currentChapterNo + '/' + _this5.state.currentReadingTitle + '/' + _this5.state.currentReadingTitle.length,
	              state: {
	                token: _this5.state.token,
	                idname: _this5.state.idname,
	                reading: {
	                  id: _this5.state.currentReadingNo,
	                  chapter_no: _this5.state.currentChapterNo,
	                  reading: _this5.state.currentReadingTitle
	                },
	                subscriptionstatus: _this5.state.subscriptionstatus
	              }
	            });
	          } else {
	            _this5.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(prevProps, prevState) {
	        var params;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context10.next = 5;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context10.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/cfa_2_2025question_bank/videoGetFlashCards',
	                //   params
	                // ).then((response) => {
	                //   var flash_cards = '';
	                //   if (response.success) {
	                //     this.setState({ ValidToken: true });
	                //     if (response.flash_cards.length > 0) {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                //       });
	                //       flash_cards = response.flash_cards.map((items, index) => (
	                //         <li key={index}>
	                //           <div className=''>
	                //             <ul className='icon_list'>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._editFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-pencil' />
	                //                 </a>
	                //               </li>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._deleteFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-close' />
	                //                 </a>
	                //               </li>
	                //             </ul>
	                //             <div className={this.state.flash_class}>
	                //               <h4 />
	                //               <p>{items.flash_card}</p>
	                //             </div>
	                //           </div>
	                //         </li>
	                //       ));
	                //     } else {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //       });
	                //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     }
	                //     this.setState({ flash_data: flash_cards });
	                //   } else {
	                //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     this.setState({ ValidToken: false });
	                //     this.setState({ flash_data: flash_cards });
	                //     this.setState({
	                //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //     });
	                //   }
	                // });
	
	              case 5:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function componentDidUpdate(_x18, _x19) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this6 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context12.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                console.log('this.props ----> ', this.props);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  // console.log('IF Working');
	                  this.setState({
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id || this.props.params.id
	                };
	                _context12.next = 15;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getcfa2videosChapterwise', data).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            console.log('/cfa_2_2025question_bank/getcfa2videosChapterwise -----> ', resp.cfavchapter);
	
	                            if (!resp.success) {
	                              _context11.next = 29;
	                              break;
	                            }
	
	                            _context11.next = 4;
	                            return _this6.setState({ ValidToken: true });
	
	                          case 4:
	                            _context11.next = 6;
	                            return _this6.setState({ chapters: resp.cfavchapter });
	
	                          case 6:
	                            _context11.next = 8;
	                            return _this6.setState({
	                              pdf_file: _this6.state.chapters[_this6.state.currentUrl] ? _this6.state.chapters[_this6.state.currentUrl].pdf_file : null
	                            });
	
	                          case 8:
	                            console.log(_this6.state.chapters, '===> ', _this6.state.currentUrl, _this6.state.chapters[_this6.state.currentUrl.id]);
	                            _context11.next = 11;
	                            return _this6.setState({
	                              currentReading: _this6.state.chapters[_this6.state.currentUrl].id
	                            });
	
	                          case 11:
	                            _context11.next = 13;
	                            return _this6.setState({
	                              video_display: _this6.state.chapters[_this6.state.currentUrl].url_id
	                            });
	
	                          case 13:
	                            _context11.next = 15;
	                            return _this6.setState({
	                              video_display_qq: _this6.state.chapters[_this6.state.currentUrl].url_id_qq
	                            });
	
	                          case 15:
	                            _context11.next = 17;
	                            return _this6.setState({
	                              video_display_previous: _this6.state.chapters[_this6.state.currentUrl].url_id
	                            });
	
	                          case 17:
	                            _context11.next = 19;
	                            return _this6.setState({
	                              video_title: _this6.state.chapters[_this6.state.currentUrl].title
	                            });
	
	                          case 19:
	                            _context11.next = 21;
	                            return _this6.setState({
	                              video_display_next: _this6.state.chapters[_this6.state.currentUrl + 1] ? _this6.state.chapters[_this6.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 21:
	                            _context11.next = 23;
	                            return _this6.setState({
	                              currentChapterNo: _this6.state.chapters[_this6.state.currentUrl].chapter_id_2025
	                            });
	
	                          case 23:
	                            _context11.next = 25;
	                            return _this6.setState({
	                              currentReadingNo: _this6.state.chapters[_this6.state.currentUrl].reading_no_2025
	                            });
	
	                          case 25:
	                            _context11.next = 27;
	                            return _this6.setState({
	                              currentReadingTitle: _this6.state.chapters[_this6.state.currentUrl].title
	                            });
	
	                          case 27:
	                            _context11.next = 30;
	                            break;
	
	                          case 29:
	                            _this6.setState({ ValidToken: false });
	
	                          case 30:
	                            return _context11.abrupt('return', resp);
	
	                          case 31:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this6);
	                  }));
	
	                  return function (_x20) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 15:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context12.next = 18;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 18:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/cfa_2_2025question_bank/videoGetFlashCards',
	                //   params
	                // ).then((response) => {
	                //   var flash_cards = '';
	                //   if (response.success) {
	                //     this.setState({ ValidToken: true });
	                //     if (response.flash_cards.length > 0) {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                //       });
	                //       flash_cards = response.flash_cards.map((items, index) => (
	                //         <li key={index}>
	                //           <div className=''>
	                //             <ul className='icon_list'>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._editFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-pencil' />
	                //                 </a>
	                //               </li>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._deleteFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-close' />
	                //                 </a>
	                //               </li>
	                //             </ul>
	                //             <div className={this.state.flash_class}>
	                //               <h4 />
	                //               <p>{items.flash_card}</p>
	                //             </div>
	                //           </div>
	                //         </li>
	                //       ));
	                //     } else {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //       });
	                //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     }
	                //     this.setState({ flash_data: flash_cards });
	                //   } else {
	                //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     this.setState({ ValidToken: false });
	                //     this.setState({ flash_data: flash_cards });
	                //     this.setState({
	                //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //     });
	                //   }
	                // });
	
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context12.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getcfa_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this6.setState({ pdfData: resp });
	                  } else {
	                    _this6.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 22:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          type = _state.type,
	          questionsCSS = _state.questionsCSS,
	          saveVideo_text = _state.saveVideo_text,
	          currentReading = _state.currentReading,
	          chapters = _state.chapters,
	          showFreePremium = _state.showFreePremium,
	          pdf_file = _state.pdf_file;
	
	
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this7.state.showFreePremium ? item.free === 1 || type === 'intro' ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id === _this7.state.video_display ? 'active' : '',
	                    onClick: _this7.getVideourl.bind(_this7, index, item.url_id, item.title, item.id, item.url_id_qq, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8 mb-1' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'mb-0' },
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        width: '100%',
	                        allowFullScreen: '1',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + this.state.video_display_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef',
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        frameBorder: '0',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportIcons2.default, {
	              moveToNotes: this.moveToNotes,
	              notesCSS: this.state.notesCSS,
	              moveToPracticeQuestions: this.moveToPracticeQuestions,
	              _saveFavVideo: this._saveFavVideo,
	              _displayReportForm: this._displayReportForm,
	              viewPdf: this.pdfOpen,
	              pdfFile: pdf_file,
	              bookmarkCSS: bookmarkCSS,
	              bookmarkColor: bookmarkColor,
	              type: type,
	              questionsCSS: questionsCSS,
	              saveVideo_text: saveVideo_text,
	              currentReading: currentReading,
	              chapters: chapters,
	              showFreePremium: showFreePremium,
	              noPDFInExam: pdf_file ? false : true
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: currentReading },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa2_2025'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT,
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfavideodisplay;
	}(_react.Component);
	
	Cfavideodisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.resizeListener = function () {
	      // write code here
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	    };
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13() {
	        var _this9 = this;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context13.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this9.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, this);
	      }));
	
	      function componentDidMount() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfavideodisplay;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1002);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var VideoLessons = function (_Component) {
	  _inherits(VideoLessons, _Component);
	
	  function VideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, VideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (VideoLessons.__proto__ || Object.getPrototypeOf(VideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getcfa2videosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', resp.cfavchapterfirst.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.cfavchapterfirst.chapter_id_2025).replace(':index', 0)
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt, path;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              // console.log('last video caseIndex -----> ', lastRecord);
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', lastRecord.cfa2_video.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', lastRecord.cfa2_video.chapter_id === 0 ? 0 : 1).replace(':chapter_id', lastRecord.cfa2_video.chapter_id).replace(':index', lastRecord.caseIndex);
	
	                _this.context.router.push({
	                  pathname: path,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.cfa2_video,
	                    index: lastRecord.videoIndex,
	                    showFreePremium: _this.state.showFreePremium
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'cfa_2',
	      exams: [],
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      lastAttempt: false,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(VideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this3);
	                              }));
	
	                              return function (_x5) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context6.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context6.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                // console.log('selectedmen ------> ', selectedmen);
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    // console.log(resp.exams[0])
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getlastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 12:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      //console.log(language.LC())
	      //console.log(this.state.showFreePremium);
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      // console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  ' ',
	                  item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement(
	                  'h1',
	                  { className: 'text-danger font-weight-bold text-center' },
	                  _language2.default.LC().COMING_SOON + '....'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement('div', { className: 'card' })
	                  ),
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent,
	            exam: _constant.examNameAccordingToDB.CFA_2
	          })
	        )
	      );
	    }
	  }]);
	
	  return VideoLessons;
	}(_react.Component);
	
	VideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	var ChatperwiseReadingData = function (_Component2) {
	  _inherits(ChatperwiseReadingData, _Component2);
	
	  function ChatperwiseReadingData(props) {
	    var _this6 = this,
	        _this5$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this5 = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this5.toggleAlert = function () {
	      _this5.setState({
	        alert_status: !_this5.state.alert_status
	      });
	    };
	
	    _this5.goPremium = function () {
	      _this5.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this5.state.token,
	          idname: _this5.state.idname,
	          selectedMenu: _this5.state.selectedmenu
	        }
	      });
	    };
	
	    _this5._getReadings = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.next = 2;
	                return _this5.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this5.state.token,
	                    idname: _this5.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this5.state.user_city,
	                    country: _this5.state.user_country,
	                    state: _this5.state.user_state,
	                    continent: _this5.state.user_continent,
	                    ip: _this5.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/trackUserVideowatch', data).then(function () {
	                    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                      var path;
	                      return _regenerator2.default.wrap(function _callee8$(_context8) {
	                        while (1) {
	                          switch (_context8.prev = _context8.next) {
	                            case 0:
	                              if (resp.success) {
	                                // '/cfa2_2025videodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
	                                path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id_2025).replace(':index', index);
	
	                                _this5.context.router.push({
	                                  pathname: path,
	                                  state: {
	                                    token: _this5.state.token,
	                                    idname: _this5.state.idname,
	                                    chapter: chapter,
	                                    index: index,
	                                    showFreePremium: _this5.state.showFreePremium
	                                  }
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context8.stop();
	                          }
	                        }
	                      }, _callee8, _this6);
	                    }));
	
	                    return function (_x8) {
	                      return _ref9.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _data = { token: _this5.state.token, idname: _this5.state.idname };
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      // console.log('I am here -----------> ', resp.profileInfo);
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this5.toggleAlert();
	                      } else {
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data2;
	
	                            return _regenerator2.default.wrap(function _callee10$(_context10) {
	                              while (1) {
	                                switch (_context10.prev = _context10.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context10.next = 10;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this5.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context10.next = 6;
	                                    return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                  case 6:
	                                    isInArray_var = _context10.sent;
	
	
	                                    if (isInArray_var) {
	                                      _data2 = {
	                                        token: _this5.state.token,
	                                        idname: _this5.state.idname,
	                                        id: chapter.id,
	                                        videoIndex: index,
	                                        city: _this5.state.user_city,
	                                        country: _this5.state.user_country,
	                                        state: _this5.state.user_state,
	                                        continent: _this5.state.user_continent,
	                                        ip: _this5.state.user_ip
	                                      };
	
	                                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/trackUserVideowatch', _data2).then(function () {
	                                        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                                          var path;
	                                          return _regenerator2.default.wrap(function _callee9$(_context9) {
	                                            while (1) {
	                                              switch (_context9.prev = _context9.next) {
	                                                case 0:
	                                                  if (resp.success) {
	                                                    path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id_2025).replace(':index', index);
	
	                                                    _this5.context.router.push({
	                                                      pathname: path,
	                                                      state: {
	                                                        token: _this5.state.token,
	                                                        idname: _this5.state.idname,
	                                                        chapter: chapter,
	                                                        index: index,
	                                                        showFreePremium: _this5.state.showFreePremium
	                                                      }
	                                                    });
	                                                  } else {}
	
	                                                case 1:
	                                                case 'end':
	                                                  return _context9.stop();
	                                              }
	                                            }
	                                          }, _callee9, _this6);
	                                        }));
	
	                                        return function (_x10) {
	                                          return _ref11.apply(this, arguments);
	                                        };
	                                      }());
	                                    } else {
	                                      _this5.toggleAlert();
	                                    }
	                                    _context10.next = 10;
	                                    break;
	
	                                  case 10:
	                                  case 'end':
	                                    return _context10.stop();
	                                }
	                              }
	                            }, _callee10, _this6);
	                          }));
	
	                          return function (_x9) {
	                            return _ref10.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      // console.log('I am here -----------> ', resp.profileInfo);
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                        // console.log('I am here 692');
	                        return _this5.toggleAlert();
	                      } else {
	                        // console.log('I am here 695');
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	                        // console.log('else working');
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data3;
	
	                            return _regenerator2.default.wrap(function _callee12$(_context12) {
	                              while (1) {
	                                switch (_context12.prev = _context12.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context12.next = 13;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this5.state.selectedmenu;
	                                    isInArray_var = false;
	
	                                    isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    // console.log(isInArray_var);
	
	                                    if (!isInArray_var) {
	                                      _context12.next = 10;
	                                      break;
	                                    }
	
	                                    // console.log('IF WORKING')
	
	                                    _data3 = {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      id: chapter.id,
	                                      videoIndex: index,
	                                      city: _this5.state.user_city,
	                                      country: _this5.state.user_country,
	                                      state: _this5.state.user_state,
	                                      continent: _this5.state.user_continent,
	                                      ip: _this5.state.user_ip
	                                    };
	
	                                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/trackUserVideowatch', _data3).then(function () {
	                                      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                                        var path;
	                                        return _regenerator2.default.wrap(function _callee11$(_context11) {
	                                          while (1) {
	                                            switch (_context11.prev = _context11.next) {
	                                              case 0:
	                                                if (resp.success) {
	                                                  path = _AppRoutes2.default.CFA2_2025_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id_2025).replace(':index', index);
	
	                                                  _this5.context.router.push({
	                                                    pathname: path,
	                                                    state: {
	                                                      token: _this5.state.token,
	                                                      idname: _this5.state.idname,
	                                                      chapter: chapter,
	                                                      index: index,
	                                                      showFreePremium: _this5.state.showFreePremium
	                                                    }
	                                                  });
	                                                } else {}
	
	                                              case 1:
	                                              case 'end':
	                                                return _context11.stop();
	                                            }
	                                          }
	                                        }, _callee11, _this6);
	                                      }));
	
	                                      return function (_x12) {
	                                        return _ref13.apply(this, arguments);
	                                      };
	                                    }());
	                                    _context12.next = 11;
	                                    break;
	
	                                  case 10:
	                                    return _context12.abrupt('return', _this5.toggleAlert());
	
	                                  case 11:
	                                    _context12.next = 13;
	                                    break;
	
	                                  case 13:
	                                  case 'end':
	                                    return _context12.stop();
	                                }
	                              }
	                            }, _callee12, _this6);
	                          }));
	
	                          return function (_x11) {
	                            return _ref12.apply(this, arguments);
	                          };
	                        }()
	                        // console.log('fail');
	                        );
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this6);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this5.savelastVideo = function () {
	      var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(chapter, index) {
	        var _this5$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _this5$state = _this5.state, token = _this5$state.token, idname = _this5$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  caseIndex: index
	                };
	                _context14.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this6);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref14.apply(this, arguments);
	      };
	    }();
	
	    _this5.iframe = {
	      padding: 10
	    };
	
	    _this5.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	      if (_this5.state.allchapters.length) {
	        data = _this5.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          var count = 0;
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this5.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              width: '100%',
	              src: item.posterImage ? item.posterImage : 'https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1.jpg',
	              onError: function onError(_ref15) {
	                var currentTarget = _ref15.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	
	                  currentTarget.onerror = null; // prevents looping
	
	                  currentTarget.src = '\n                    https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1_2.jpg';
	                }
	              },
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row',
	              alt: 'flow player image'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row',
	              alt: 'youtube image'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this5.state = (_this5$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this5$state2, 'offset', 0), _defineProperty(_this5$state2, 'limit', 10), _defineProperty(_this5$state2, 'Allchapters', []), _defineProperty(_this5$state2, 'itemData', []), _defineProperty(_this5$state2, 'videoUrl', ''), _defineProperty(_this5$state2, 'srcUrl', ''), _defineProperty(_this5$state2, 'srcUrl_final', ''), _defineProperty(_this5$state2, 'selectedmenu', 'cfa_2'), _defineProperty(_this5$state2, 'showFreePremium', true), _defineProperty(_this5$state2, 'user_city', ''), _defineProperty(_this5$state2, 'user_country', ''), _defineProperty(_this5$state2, 'user_ip', ''), _defineProperty(_this5$state2, 'user_state', ''), _defineProperty(_this5$state2, 'user_continent', ''), _this5$state2);
	    return _this5;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	        var _this7 = this;
	
	        var result, storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _context15.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context15.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context15.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getcfa2videosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this7.setState({ allchapters: [] });
	                    _this7.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, this);
	      }));
	
	      function componentDidMount() {
	        return _ref16.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      //console.log(this.state.showFreePremium);
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = VideoLessons;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(79);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _toast = __webpack_require__(15);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var i = '';
	
	var Cfa2Dashboard = function (_Component) {
	  _inherits(Cfa2Dashboard, _Component);
	
	  function Cfa2Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2Dashboard.__proto__ || Object.getPrototypeOf(Cfa2Dashboard)).call(this, props));
	
	    _this.deleteFlashCard = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(type, id) {
	        var _this$state, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, id_name = _this$state.idname, token = _this$state.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: '',
	                  exam: 'cfa_2_2027',
	                  level: '',
	                  item_id: id
	                };
	                _context.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.view = function (item) {
	      if (item.mockData) {
	        var mock = JSON.parse(item.mockData);
	        _this.context.router.push({
	          pathname: '/cfa2/2027/cbtquestionsfinish/' + mock.mock_id + '/' + mock.caseId + '/' + item.question_id + '/' + mock.test_id + '/' + mock.caseOffset + '/' + mock.quesOffset + '/' + mock.timer
	        });
	      }
	    };
	
	    _this.toggleDone = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var _this$state2, idname, token, items_val, item_status, question_id, item_id, video_id, data;
	
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              _this$state2 = _this.state, idname = _this$state2.idname, token = _this$state2.token, items_val = _this$state2.items_val, item_status = _this$state2.item_status;
	              question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	              if (!(_this.state.item_status == 'flashcard')) {
	                _context12.next = 6;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteFlashCard', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(response) {
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context2.next = 3;
	                            break;
	                          }
	
	                          _context2.next = 3;
	                          return _this.getQuestionFlashcards();
	
	                        case 3:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                }));
	
	                return function (_x3) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 6:
	              if (!(item_status == 'savedquestion')) {
	                _context12.next = 12;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 10;
	              return _this.deleteFlashCard('question', question_id ? question_id : item_id);
	
	            case 10:
	              _context12.next = 12;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteSavequestion', data).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(response) {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.getQuestionSaved();
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	
	            case 12:
	              if (!(_this.state.item_status == 'Reportsquestion')) {
	                _context12.next = 16;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 16;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteDashboardQuestionReports', data).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(response) {
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context4.next = 3;
	                            break;
	                          }
	
	                          _context4.next = 3;
	                          return _this.getQuestionReports();
	
	                        case 3:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x5) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 16:
	              if (!(item_status == 'savednotes')) {
	                _context12.next = 22;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 20;
	              return _this.deleteFlashCard('notes', question_id ? question_id : item_id);
	
	            case 20:
	              _context12.next = 22;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/deleteSaveNotes', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(response) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context5.next = 5;
	                            break;
	                          }
	
	                          _context5.next = 3;
	                          return _this.getNotesSaved();
	
	                        case 3:
	                          _context5.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 22:
	              if (!(item_status == 'savedvideos')) {
	                _context12.next = 28;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 26;
	              return _this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	            case 26:
	              _context12.next = 28;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteSaveVideo', data).then(function () {
	                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(response) {
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context6.next = 5;
	                            break;
	                          }
	
	                          _context6.next = 3;
	                          return _this.getVideosSaved();
	
	                        case 3:
	                          _context6.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref7.apply(this, arguments);
	                };
	              }());
	
	            case 28:
	              if (!(_this.state.item_status == 'Notesflashcard')) {
	                _context12.next = 32;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 32;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/deleteDashboardFlashCard', data).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(response) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context7.next = 3;
	                            break;
	                          }
	
	                          _context7.next = 3;
	                          return _this.getNotesFlashcards();
	
	                        case 3:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	
	            case 32:
	              if (!(_this.state.item_status == 'Videoflashcard')) {
	                _context12.next = 36;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 36;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteDashboardVideoFlashCard', data).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(response) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context8.next = 3;
	                            break;
	                          }
	
	                          _context8.next = 3;
	                          return _this.getVideoFlashcards();
	
	                        case 3:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	
	            case 36:
	
	              if (_this.state.item_status == 'Reportsnotes') {
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reports: _this.state.items_val
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/deleteDashboardNotesReports', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(response) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context9.next = 3;
	                              break;
	                            }
	
	                            _context9.next = 3;
	                            return _this.getNotesReports();
	
	                          case 3:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x10) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	              }
	
	              if (!(_this.state.item_status == 'Reportsvideos')) {
	                _context12.next = 41;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 41;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteDashboardVideoReports', data).then(function () {
	                var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(response) {
	                  return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                      switch (_context10.prev = _context10.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context10.next = 3;
	                            break;
	                          }
	
	                          _context10.next = 3;
	                          return _this.getVideoReports();
	
	                        case 3:
	                        case 'end':
	                          return _context10.stop();
	                      }
	                    }
	                  }, _callee10, _this2);
	                }));
	
	                return function (_x11) {
	                  return _ref11.apply(this, arguments);
	                };
	              }());
	
	            case 41:
	              if (!(_this.state.item_status == 'CBTreportsquestion')) {
	                _context12.next = 45;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 45;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/deleteReport', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(response) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (!response.success) {
	                            _context11.next = 3;
	                            break;
	                          }
	
	                          _context11.next = 3;
	                          return _this.getCBTQestionReports();
	
	                        case 3:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x12) {
	                  return _ref12.apply(this, arguments);
	                };
	              }());
	
	            case 45:
	              _this.setState({
	                alert_status: false
	              });
	
	            case 46:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteSavequestion = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: 'Hide Details' });
	      }
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({ more_detail_button: 'I Want More Details' });
	      }
	    };
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context14.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(response) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ reportquestion: response.questions, reportLoader: false });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x13) {
	                  return _ref14.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	            case 3:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this2);
	    }));
	    _this.getQuestionSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context16.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestionsbyuserid', data).then(function (response) {
	                if (response.success) {
	                  _this.setState({ savedquestion: response.questions, savedLoader: false });
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	
	    _this._beginChapter = function (item, e) {
	      var isActiveQues = false;
	      var isActiveCases = false;
	      var isActive = false;
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getQuestionsbyid', data).then(function (response) {
	        if (response.success) {
	          isActiveQues = response.questionsbyid.isActive2025;
	          var dataparam = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            caseid: response.questionsbyid.case_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesbyId', dataparam).then(function () {
	            var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(resp_case) {
	              var indexcase, caseReadings;
	              return _regenerator2.default.wrap(function _callee17$(_context17) {
	                while (1) {
	                  switch (_context17.prev = _context17.next) {
	                    case 0:
	                      if (!resp_case.success) {
	                        _context17.next = 10;
	                        break;
	                      }
	
	                      isActiveCases = resp_case.casesingleData.isActive2025;
	                      indexcase = -1;
	                      _context17.next = 5;
	                      return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCases', {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter_id: resp_case.casesingleData.chapter_no_2025
	                      });
	
	                    case 5:
	                      caseReadings = _context17.sent;
	
	                      caseReadings.readings.map(function (value, index) {
	                        if (value.id === resp_case.casesingleData.id) {
	                          isActive = value.isActive2025;
	                          indexcase = index;
	                        }
	                      });
	                      if (isActive && isActiveCases && isActiveQues) {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', response.questionsbyid.chapter_id_2025).replace(':caseid', response.questionsbyid.case_id).replace(':case_offset', indexcase).replace(':question_number', response.questionsbyid.question_number).replace(':offset', 0)
	                        });
	                      } else {
	                        (0, _toast.showFailure)('Questions unavailable');
	                      }
	                      _context17.next = 11;
	                      break;
	
	                    case 10:
	                      (0, _toast.showFailure)('Questions unavailable');
	
	                    case 11:
	                    case 'end':
	                      return _context17.stop();
	                  }
	                }
	              }, _callee17, _this2);
	            }));
	
	            return function (_x14) {
	              return _ref17.apply(this, arguments);
	            };
	          }());
	        } else {
	          (0, _toast.showFailure)('Questions unavailable');
	        }
	      });
	    };
	
	    _this.onContactSubmit = function () {
	      var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(event) {
	        var _this$state3, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context19.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context19.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context19.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context19.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state3 = _this.state, idname = _this$state3.idname, token = _this$state3.token, contactComment = _this$state3.contactComment, contactSubject = _this$state3.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context19.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(response) {
	                    return _regenerator2.default.wrap(function _callee18$(_context18) {
	                      while (1) {
	                        switch (_context18.prev = _context18.next) {
	                          case 0:
	                            if (response.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context18.abrupt('return', response);
	
	                          case 2:
	                          case 'end':
	                            return _context18.stop();
	                        }
	                      }
	                    }, _callee18, _this2);
	                  }));
	
	                  return function (_x16) {
	                    return _ref19.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this2);
	      }));
	
	      return function (_x15) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.getNotesSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee21() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee21$(_context21) {
	        while (1) {
	          switch (_context21.prev = _context21.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context21.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getFavNotesbyuserid', data).then(function () {
	                var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(response) {
	                  return _regenerator2.default.wrap(function _callee20$(_context20) {
	                    while (1) {
	                      switch (_context20.prev = _context20.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ savednotes: response.cfa_notes });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context20.stop();
	                      }
	                    }
	                  }, _callee20, _this2);
	                }));
	
	                return function (_x17) {
	                  return _ref21.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context21.stop();
	          }
	        }
	      }, _callee21, _this2);
	    }));
	    _this.getNotesFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee22() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee22$(_context22) {
	        while (1) {
	          switch (_context22.prev = _context22.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	            case 3:
	            case 'end':
	              return _context22.stop();
	          }
	        }
	      }, _callee22, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee23() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee23$(_context23) {
	        while (1) {
	          switch (_context23.prev = _context23.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	            case 3:
	            case 'end':
	              return _context23.stop();
	          }
	        }
	      }, _callee23, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee25() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee25$(_context25) {
	        while (1) {
	          switch (_context25.prev = _context25.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context25.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getReportsVideobyuserid', data).then(function () {
	                var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(response) {
	                  return _regenerator2.default.wrap(function _callee24$(_context24) {
	                    while (1) {
	                      switch (_context24.prev = _context24.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ reportsvideo: response.video });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context24.stop();
	                      }
	                    }
	                  }, _callee24, _this2);
	                }));
	
	                return function (_x18) {
	                  return _ref25.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context25.stop();
	          }
	        }
	      }, _callee25, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee27() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee27$(_context27) {
	        while (1) {
	          switch (_context27.prev = _context27.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context27.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavVideosbyuserid', data).then(function () {
	                var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(response) {
	                  return _regenerator2.default.wrap(function _callee26$(_context26) {
	                    while (1) {
	                      switch (_context26.prev = _context26.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ savedvideo: response.cfa_videos });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context26.stop();
	                      }
	                    }
	                  }, _callee26, _this2);
	                }));
	
	                return function (_x19) {
	                  return _ref27.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context27.stop();
	          }
	        }
	      }, _callee27, _this2);
	    }));
	    _this.getNotesReports = _asyncToGenerator(_regenerator2.default.mark(function _callee29() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee29$(_context29) {
	        while (1) {
	          switch (_context29.prev = _context29.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context29.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getReportsNotesbyuserid', data).then(function () {
	                var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(response) {
	                  return _regenerator2.default.wrap(function _callee28$(_context28) {
	                    while (1) {
	                      switch (_context28.prev = _context28.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({ reportnotes: response.notes });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context28.stop();
	                      }
	                    }
	                  }, _callee28, _this2);
	                }));
	
	                return function (_x20) {
	                  return _ref29.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context29.stop();
	          }
	        }
	      }, _callee29, _this2);
	    }));
	
	    _this._beginVideos = function () {
	      var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee30$(_context30) {
	          while (1) {
	            switch (_context30.prev = _context30.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading['cfa2_2027_video_reports.video_id'] ? reading['cfa2_2027_video_reports.video_id'] : reading.video_id
	                };
	                _context30.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getVideoByID', data).then(function (response) {
	                  if (response.success) {
	                    var _data = response.allVideo.findIndex(function (item) {
	                      return item.id === response.video[0].id;
	                    });
	                    if (response.video[0].isActive2025) {
	                      // This handles both `true` and `1`
	                      if (response.video[0].mock_id) {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default.CFA2_2027_VIDEOS_LIST.replace(':id', response.video[0].id).replace(':chapterId', response.video[0].chapter_id_2025),
	                          query: { mockId: response.video[0].mock_id }
	                        });
	                      } else {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default.CFA2_2027_VIDEOS_LIST.replace(':id', response.video[0].id).replace(':chapterId', response.video[0].chapter_id_2025)
	                        });
	                      }
	                    } else {
	                      (0, _toast.showFailure)('Videos unavailable');
	                    }
	                  } else {
	                    (0, _toast.showFailure)('Videos unavailable');
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context30.stop();
	            }
	          }
	        }, _callee30, _this2);
	      }));
	
	      return function (_x21, _x22) {
	        return _ref30.apply(this, arguments);
	      };
	    }();
	
	    _this._beginNotes = function () {
	      var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(reading, e) {
	        var isActive2025, reading_id, chapter_id, data, offset;
	        return _regenerator2.default.wrap(function _callee32$(_context32) {
	          while (1) {
	            switch (_context32.prev = _context32.next) {
	              case 0:
	                isActive2025 = false;
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                offset = 0;
	                _context32.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotesByID', data).then(function (response) {
	                  if (response.success) {
	                    isActive2025 = response.notes[0].isActive2025;
	                    var data = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter_id: response.notes[0].chapter_id_2025,
	                      reading_id: response.notes[0].reading_id_2025,
	                      offset: _this.state.offset
	                    };
	                    chapter_id = response.notes[0].chapter_id_2025;
	                    if (isActive2025 || isActive2025 == 1) {
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes_allcr', data).then(function () {
	                        var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(response) {
	                          var i;
	                          return _regenerator2.default.wrap(function _callee31$(_context31) {
	                            while (1) {
	                              switch (_context31.prev = _context31.next) {
	                                case 0:
	                                  if (!response.success) {
	                                    _context31.next = 10;
	                                    break;
	                                  }
	
	                                  i = 0;
	
	                                case 2:
	                                  if (!(i < response.questions.length)) {
	                                    _context31.next = 10;
	                                    break;
	                                  }
	
	                                  if (!(response.questions[i].id === reading.question_id)) {
	                                    _context31.next = 7;
	                                    break;
	                                  }
	
	                                  offset = i;
	                                  _this.context.router.push({
	                                    pathname: ('' + _AppRoutes2.default.CFA2_2027_BEGIN_NOTES).replace(':notesid', chapter_id).replace(':readingid', response.questions[i].reading_id_2025).replace(':id', reading.question_id).replace(':offset', offset)
	                                  });
	                                  return _context31.abrupt('break', 10);
	
	                                case 7:
	                                  i++;
	                                  _context31.next = 2;
	                                  break;
	
	                                case 10:
	                                case 'end':
	                                  return _context31.stop();
	                              }
	                            }
	                          }, _callee31, _this2);
	                        }));
	
	                        return function (_x25) {
	                          return _ref32.apply(this, arguments);
	                        };
	                      }());
	                    } else {
	                      (0, _toast.showFailure)('Notes unavailable');
	                    }
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context32.stop();
	            }
	          }
	        }, _callee32, _this2);
	      }));
	
	      return function (_x23, _x24) {
	        return _ref31.apply(this, arguments);
	      };
	    }();
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSaveNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savednotes');
	    };
	
	    _this._deleteSaveVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsnotes');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._deleteCBTReportsquestino = function (items) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('CBTreportsquestion');
	    };
	
	    _this.getCBTQestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee34() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee34$(_context34) {
	        while (1) {
	          switch (_context34.prev = _context34.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context34.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/getreportedQuestion', data).then(function () {
	                var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(response) {
	                  return _regenerator2.default.wrap(function _callee33$(_context33) {
	                    while (1) {
	                      switch (_context33.prev = _context33.next) {
	                        case 0:
	                          if (response.success) {
	                            _this.setState({
	                              reportquestionCBT: response.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context33.stop();
	                      }
	                    }
	                  }, _callee33, _this2);
	                }));
	
	                return function (_x26) {
	                  return _ref34.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context34.stop();
	          }
	        }
	      }, _callee34, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      token: '',
	      idname: '',
	      flashreport: [], //All Flash question Store
	      savedquestion: [],
	      reportquestion: [],
	      progress_bar_zero: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      bar_chapter: '',
	      activeTabFlashcards: '1',
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      bar_level_main: ['Ethics', 'Quants', 'Econ', 'FRA', 'Corpo', 'Portfolio', 'Equity', 'Fixed Income', 'Derivatives', 'Al'],
	      bar_main_user: [],
	      bar_main_class: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      subreadings_status: false,
	      ErrorMessage: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      display_main_loader: 'show_block',
	      qpLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	
	      notesFlashReport: [],
	      videoFlashReport: [],
	      savednotes: [],
	      savedvideo: [],
	      reportnotes: [],
	      reportsvideo: [],
	      reportquestionCBT: [],
	      isVideo: '',
	      npLoader: true,
	      selectedmenu: 'cfa_2'
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.OpenEditNotesReport = _this.OpenEditNotesReport.bind(_this);
	    _this.OpenEditCBTQuesReport = _this.OpenEditCBTQuesReport.bind(_this);
	    _this.CloseEditNotesReport = _this.CloseEditNotesReport.bind(_this);
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa2Dashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, type) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: type === 'videoReport' ? item['cfa2_2027_video_reports.id'] : item.id,
	        type: type
	      });
	    }
	    // function to view cbt question
	
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'OpenEditCBTQuesReport',
	    value: function OpenEditCBTQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        cbtquesReport: item.comment,
	        type: 'cbtquesReport'
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate != '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this3 = this;
	
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second
	          };
	          // Get Notes Progress By User
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/getNotesProgressByUser', data).then(function (response) {
	            var notesProgress = response.notesProgress,
	                success = response.success;
	
	            if (success) {
	              _this3.setState({ progress_bar: notesProgress });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/getQuestionProgressByUser', data).then(function (response) {
	            var questionProgress = response.questionProgress,
	                success = response.success;
	
	            if (success) {
	              _this3.setState({ bar_chapter: questionProgress });
	              _this3.setState({ progress_bar_zero: questionProgress });
	            }
	          });
	          // Get Main Progress Bar
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/mainProgressbar', data).then(function (response) {
	            if (response.success) {
	              var dataString = JSON.stringify(response.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this3.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block'
	              });
	            } else {
	              _this3.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/mainProgressclassbar', data).then(function (response) {
	            if (response.success) {
	              var dataString = JSON.stringify(response.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this3.setState({ bar_main_class: final_array_main });
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee38() {
	        var _this4 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee38$(_context38) {
	          while (1) {
	            switch (_context38.prev = _context38.next) {
	              case 0:
	                window.scroll(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (response) {
	                  if (response.success) {
	                    _this4.setState({ ValidToken: true });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChapters', data).then(function (response) {
	                  if (response.success) {
	                    _this4.setState({ ValidToken: true });
	                    _this4.setState({ chapters: response.chapters });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                  return response;
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/getQuestionProgressByUser', data).then(function (response) {
	                  var success = response.success,
	                      questionProgress = response.questionProgress;
	
	                  if (success) {
	                    _this4.setState({
	                      progress_bar_zero: questionProgress,
	                      qpLoader: false
	                    });
	                    _this4.setState({ bar_chapter: questionProgress });
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/mainProgressbar', data).then(function (response) {
	                  if (response.success) {
	                    _this4.setState({ display_main_loader: 'hide_block' });
	                    var dataString = JSON.stringify(response.chapters);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	                      final_array_main.push(user_graph_val);
	                    }
	                    _this4.setState({ bar_main_user: final_array_main });
	                  }
	                });
	
	                this.setState({ display_main_loader: 'show_block' });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/mainProgressclassbar', data).then(function (response) {
	                  if (response.success) {
	                    var dataString = JSON.stringify(response.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	                      final_array_main.push(user_graph_val);
	                    }
	                    _this4.setState({ bar_main_class: final_array_main });
	                  }
	                });
	
	                // --------------------------------- START -----------------------------------
	
	                // A workaround for old functionality
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee36() {
	                  var response, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee36$(_context36) {
	                    while (1) {
	                      switch (_context36.prev = _context36.next) {
	                        case 0:
	                          response = _userStore2.default;
	
	                          if (!(response == null || response.profileInfo == null)) {
	                            _context36.next = 3;
	                            break;
	                          }
	
	                          return _context36.abrupt('return');
	
	                        case 3:
	
	                          if (response.profileInfo) {
	                            _this4.setState({
	                              isVideo: response.profileInfo.isVideo
	                            });
	                          }
	
	                          if (!(response.profileInfo ? response.profileInfo.role === 'partner' : 0)) {
	                            _context36.next = 17;
	                            break;
	                          }
	
	                          if (!(response.profileInfo.exam_selected === '' && response.profileInfo.exam_package === '')) {
	                            _context36.next = 9;
	                            break;
	                          }
	
	                          _this4.setState({
	                            showFreePremium: true
	                          });
	                          _context36.next = 15;
	                          break;
	
	                        case 9:
	                          subscription_details = response.profileInfo.subscription_details ? JSON.parse(response.profileInfo.subscription_details) : response.profileInfo.subscription_details;
	
	
	                          _this4.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam
	                          });
	
	                          data_arr = response.profileInfo.exam_selected ? JSON.parse(response.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this4.state.token,
	                            idname: _this4.state.idname,
	                            examid: data_arr
	                          };
	                          _context36.next = 15;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee35$(_context35) {
	                                while (1) {
	                                  switch (_context35.prev = _context35.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context35.next = 11;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this4.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context35.next = 6;
	                                      return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context35.sent;
	
	                                      if (isInArray_var) {
	                                        _this4.setState({ showFreePremium: false });
	                                      } else {
	                                        _this4.setState({ showFreePremium: true });
	                                      }
	                                      if (!isInArray_var) {
	                                        isInArray_var = _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                        if (isInArray_var) {
	                                          _this4.setState({ showFreePremium: false });
	                                        } else {
	                                          _this4.setState({ showFreePremium: true });
	                                        }
	                                      }
	                                      _context35.next = 11;
	                                      break;
	
	                                    case 11:
	                                    case 'end':
	                                      return _context35.stop();
	                                  }
	                                }
	                              }, _callee35, _this4);
	                            }));
	
	                            return function (_x27) {
	                              return _ref37.apply(this, arguments);
	                            };
	                          }());
	
	                        case 15:
	                          _context36.next = 27;
	                          break;
	
	                        case 17:
	                          if (!(response.profileInfo.exam_selected === '' && response.profileInfo.cfaUnlimitedPackage == '' && response.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context36.next = 21;
	                            break;
	                          }
	
	                          _this4.setState({
	                            showFreePremium: true
	                          });
	                          _context36.next = 27;
	                          break;
	
	                        case 21:
	                          subscription_details = response.profileInfo.subscription_details ? JSON.parse(response.profileInfo.subscription_details) : response.profileInfo.subscription_details;
	
	
	                          _this4.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = response.profileInfo.exam_selected ? JSON.parse(response.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this4.state.token,
	                            idname: _this4.state.idname,
	                            examid: data_arr
	                          };
	                          _context36.next = 27;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this4.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                              if (isInArray_var) {
	                                _this4.setState({ showFreePremium: false });
	                              } else {
	                                _this4.setState({ showFreePremium: true });
	                              }
	                              if (!isInArray_var) {
	                                isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                if (isInArray_var) {
	                                  _this4.setState({ showFreePremium: false });
	                                } else {
	                                  _this4.setState({ showFreePremium: true });
	                                }
	                              }
	                            } else {}
	                          });
	
	                        case 27:
	                        case 'end':
	                          return _context36.stop();
	                      }
	                    }
	                  }, _callee36, _this4);
	                })));
	
	                // const getProfileInfoData = {
	                //   token: storage_session['token'],
	                //   idname: storage_session['idname'],
	                // };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfoData).then(
	                //   async (response) => {
	                //     if (response.profileInfo) {
	                //       this.setState({
	                //         isVideo: response.profileInfo.isVideo,
	                //       });
	                //     }
	                //     if (response.profileInfo ? response.profileInfo.role === 'partner' : 0) {
	                //       if (
	                //         response.profileInfo.exam_selected === '' &&
	                //         response.profileInfo.exam_package === ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //         });
	                //       } else {
	                //         var subscription_details = response.profileInfo.subscription_details
	                //           ? JSON.parse(response.profileInfo.subscription_details)
	                //           : response.profileInfo.subscription_details;
	                //
	                //         this.setState({
	                //           subscription_details: subscription_details,
	                //           cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //
	                //         var data_arr = response.profileInfo.exam_selected
	                //           ? JSON.parse(response.profileInfo.exam_selected)
	                //           : null;
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
	                //           async (resp_exam) => {
	                //             if (resp_exam.success) {
	                //               var exam_data = resp_exam.examData;
	                //               var selectedmen = this.state.selectedmenu;
	                //               var isInArray_var = false;
	                //               isInArray_var = await PartnerCfaSubscriptionCheck.checkCfa2Subscription(
	                //                 selectedmen,
	                //                 exam_data,
	                //                 this.state.cfaUnlimitedPackage,
	                //                 this.state.cfaUnlimitedActiveExam,
	                //               );
	                //               if (isInArray_var) {
	                //                 this.setState({ showFreePremium: false });
	                //               } else {
	                //                 this.setState({ showFreePremium: true });
	                //               }
	                //               if (!isInArray_var) {
	                //                 isInArray_var = PartnerCfaSubscriptionCheck.checkCfa2VideosSubscription(
	                //                   selectedmen,
	                //                   exam_data,
	                //                   this.state.cfaUnlimitedPackage,
	                //                   this.state.cfaUnlimitedActiveExam,
	                //                 );
	                //                 if (isInArray_var) {
	                //                   this.setState({ showFreePremium: false });
	                //                 } else {
	                //                   this.setState({ showFreePremium: true });
	                //                 }
	                //               }
	                //             } else {
	                //             }
	                //           },
	                //         );
	                //       }
	                //     } else {
	                //       if (
	                //         response.profileInfo.exam_selected === '' &&
	                //         response.profileInfo.cfaUnlimitedPackage == '' &&
	                //         response.profileInfo.cfaUnlimitedActiveExam == ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //         });
	                //       } else {
	                //         var subscription_details = response.profileInfo.subscription_details
	                //           ? JSON.parse(response.profileInfo.subscription_details)
	                //           : response.profileInfo.subscription_details;
	                //
	                //         this.setState({
	                //           subscription_details: subscription_details,
	                //           cfaUnlimitedPackage: response.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: response.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //         var data_arr = response.profileInfo.exam_selected
	                //           ? JSON.parse(response.profileInfo.exam_selected)
	                //           : null;
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
	                //           (resp_exam) => {
	                //             if (resp_exam.success) {
	                //               var exam_data = resp_exam.examData;
	                //               var selectedmen = this.state.selectedmenu;
	                //               var isInArray_var = false;
	                //               isInArray_var = CfaSubscriptionCheck.checkCfa2Subscription(
	                //                 selectedmen,
	                //                 exam_data,
	                //                 this.state.cfaUnlimitedPackage,
	                //                 this.state.cfaUnlimitedActiveExam,
	                //               );
	                //               if (isInArray_var) {
	                //                 this.setState({ showFreePremium: false });
	                //               } else {
	                //                 this.setState({ showFreePremium: true });
	                //               }
	                //               if (!isInArray_var) {
	                //                 isInArray_var = CfaSubscriptionCheck.checkCfa2VideosSubscription(
	                //                   selectedmen,
	                //                   exam_data,
	                //                   this.state.cfaUnlimitedPackage,
	                //                   this.state.cfaUnlimitedActiveExam,
	                //                 );
	                //                 if (isInArray_var) {
	                //                   this.setState({ showFreePremium: false });
	                //                 } else {
	                //                   this.setState({ showFreePremium: true });
	                //                 }
	                //               }
	                //             } else {
	                //             }
	                //           },
	                //         );
	                //       }
	                //     }
	                //   },
	                // );
	
	                _context38.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027dashboard/getNotesProgressByUser', data).then(function () {
	                  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(response) {
	                    var success, notesProgress;
	                    return _regenerator2.default.wrap(function _callee37$(_context37) {
	                      while (1) {
	                        switch (_context37.prev = _context37.next) {
	                          case 0:
	                            success = response.success, notesProgress = response.notesProgress;
	
	                            if (response.success) {
	                              _this4.setState({
	                                progress_bar: response.notesProgress,
	                                npLoader: false
	                              });
	                            }
	
	                          case 2:
	                          case 'end':
	                            return _context37.stop();
	                        }
	                      }
	                    }, _callee37, _this4);
	                  }));
	
	                  return function (_x28) {
	                    return _ref38.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context38.next = 16;
	                return this.getQuestionFlashcards();
	
	              case 16:
	                _context38.next = 18;
	                return this.getQuestionSaved();
	
	              case 18:
	                this.getQuestionReports();
	
	                _context38.next = 21;
	                return this.getNotesFlashcards();
	
	              case 21:
	                _context38.next = 23;
	                return this.getNotesSaved();
	
	              case 23:
	                _context38.next = 25;
	                return this.getNotesReports();
	
	              case 25:
	                _context38.next = 27;
	                return this.getVideoFlashcards();
	
	              case 27:
	                _context38.next = 29;
	                return this.getVideosSaved();
	
	              case 29:
	                _context38.next = 31;
	                return this.getVideoReports();
	
	              case 31:
	                _context38.next = 33;
	                return this.getCBTQestionReports();
	
	              case 33:
	              case 'end':
	                return _context38.stop();
	            }
	          }
	        }, _callee38, this);
	      }));
	
	      function componentDidMount() {
	        return _ref35.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	
	    // function for get  question report
	
	
	    // function for get  question FlashCard
	
	
	    // function for get  question report
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.totalQuestions / item.attemptedQuestions * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                _language2.default.LC().Q,
	                item.id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        ErrorMessage: ''
	      });
	    }
	
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(event) {
	        var _this5 = this;
	
	        var _state, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee40$(_context40) {
	          while (1) {
	            switch (_context40.prev = _context40.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context40.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context40.abrupt('return');
	
	              case 4:
	                _state = this.state, reportEditId = _state.reportEditId, idname = _state.idname, token = _state.token, quesReport = _state.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context40.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(response) {
	                    return _regenerator2.default.wrap(function _callee39$(_context39) {
	                      while (1) {
	                        switch (_context39.prev = _context39.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context39.next = 6;
	                              break;
	                            }
	
	                            _this5.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this5.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context39.next = 4;
	                            return _this5.getQuestionReports();
	
	                          case 4:
	                            _context39.next = 7;
	                            break;
	
	                          case 6:
	                            _this5.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context39.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context39.stop();
	                        }
	                      }
	                    }, _callee39, _this5);
	                  }));
	
	                  return function (_x30) {
	                    return _ref40.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context40.stop();
	            }
	          }
	        }, _callee40, this);
	      }));
	
	      function handleQuestionReportSubmit(_x29) {
	        return _ref39.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: type === 'videoReport' ? data['cfa2_2027_video_reports.id'] : data.id,
	          contactIndex: index,
	          contactStatus: true,
	          contactType: type
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditNotesReport',
	    value: function CloseEditNotesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        notesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item['cfa2_2027_video_reports.id'],
	        videoReport: item['cfa2_2027_video_reports.comment'],
	        type: 'videoReport'
	      });
	    }
	  }, {
	    key: 'OpenEditNotesReport',
	    value: function OpenEditNotesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        notesReport: item.comment,
	        type: 'notesReport'
	      });
	    }
	    // function for get  notes report
	
	
	    // function for get  notes report
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  video report
	
	
	    /*
	     * get saved all video
	     */
	
	
	    // function for get  notes report
	
	  }, {
	    key: 'notesProgressBarFun',
	    value: function notesProgressBarFun() {
	      return this.state.progress_bar.map(function (item, index) {
	        var progresstotalques = item.totalNotes;
	        var progressnotes = Math.round(item.attemptedNotes / progresstotalques * 100);
	        if (progressnotes < 1) {
	          progressnotes = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                item.chapter_id_2025
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes,
	                      style: { width: progressnotes + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'handleNotesReportSubmit',
	
	    // notes form submit function
	    value: function () {
	      var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(event) {
	        var _this6 = this;
	
	        var _state2, reportEditId, idname, token, notesReport, data;
	
	        return _regenerator2.default.wrap(function _callee42$(_context42) {
	          while (1) {
	            switch (_context42.prev = _context42.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport === '' && this.state.notesReport.length < 1)) {
	                  _context42.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context42.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, notesReport = _state2.notesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport
	                };
	                _context42.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(response) {
	                    return _regenerator2.default.wrap(function _callee41$(_context41) {
	                      while (1) {
	                        switch (_context41.prev = _context41.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context41.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              notesReport: ''
	                            });
	                            _context41.next = 4;
	                            return _this6.getNotesReports();
	
	                          case 4:
	                            _context41.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context41.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context41.stop();
	                        }
	                      }
	                    }, _callee41, _this6);
	                  }));
	
	                  return function (_x32) {
	                    return _ref42.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context42.stop();
	            }
	          }
	        }, _callee42, this);
	      }));
	
	      function handleNotesReportSubmit(_x31) {
	        return _ref41.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit;
	    }()
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee44$(_context44) {
	          while (1) {
	            switch (_context44.prev = _context44.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context44.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context44.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, videoReport = _state3.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context44.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(response) {
	                    return _regenerator2.default.wrap(function _callee43$(_context43) {
	                      while (1) {
	                        switch (_context43.prev = _context43.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context43.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context43.next = 4;
	                            return _this7.getVideoReports();
	
	                          case 4:
	                            _context43.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context43.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context43.stop();
	                        }
	                      }
	                    }, _callee43, _this7);
	                  }));
	
	                  return function (_x34) {
	                    return _ref44.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context44.stop();
	            }
	          }
	        }, _callee44, this);
	      }));
	
	      function handleVideoReportSubmit(_x33) {
	        return _ref43.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	    /*
	     * function for go to specific notes main page
	     */
	
	    // function to get cbt question reports
	
	  }, {
	    key: 'handleCBTQuestionReportSubmit',
	    value: function () {
	      var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(event) {
	        var _this8 = this;
	
	        var _state4, reportEditId, idname, token, cbtquesReport, data;
	
	        return _regenerator2.default.wrap(function _callee46$(_context46) {
	          while (1) {
	            switch (_context46.prev = _context46.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.cbtquesReport === '' && this.state.cbtquesReport.length < 1)) {
	                  _context46.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context46.abrupt('return');
	
	              case 4:
	                _state4 = this.state, reportEditId = _state4.reportEditId, idname = _state4.idname, token = _state4.token, cbtquesReport = _state4.cbtquesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: cbtquesReport
	                };
	                _context46.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2CBTMockExams2027/updateReport', data).then(function () {
	                  var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(response) {
	                    return _regenerator2.default.wrap(function _callee45$(_context45) {
	                      while (1) {
	                        switch (_context45.prev = _context45.next) {
	                          case 0:
	                            if (!response.success) {
	                              _context45.next = 6;
	                              break;
	                            }
	
	                            _this8.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this8.state.reportEditStatus,
	                              reportEditId: '',
	                              cbtquesReport: ''
	                            });
	                            _context45.next = 4;
	                            return _this8.getCBTQestionReports();
	
	                          case 4:
	                            _context45.next = 7;
	                            break;
	
	                          case 6:
	                            _this8.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context45.abrupt('return', response);
	
	                          case 8:
	                          case 'end':
	                            return _context45.stop();
	                        }
	                      }
	                    }, _callee45, _this8);
	                  }));
	
	                  return function (_x36) {
	                    return _ref46.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context46.stop();
	            }
	          }
	        }, _callee46, this);
	      }));
	
	      function handleCBTQuestionReportSubmit(_x35) {
	        return _ref45.apply(this, arguments);
	      }
	
	      return handleCBTQuestionReportSubmit;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state5 = this.state,
	          activeTabFlashcards = _state5.activeTabFlashcards,
	          activeTabSaved = _state5.activeTabSaved,
	          activeTabReports = _state5.activeTabReports,
	          qpLoader = _state5.qpLoader,
	          savedLoader = _state5.savedLoader,
	          flashLoader = _state5.flashLoader,
	          reportLoader = _state5.reportLoader,
	          isVideo = _state5.isVideo,
	          npLoader = _state5.npLoader;
	
	      var flashreport_val = this.state.flashreport;
	      var savedquestion_val = this.state.savedquestion;
	      var reportquestion_val = this.state.reportquestion;
	      var progress_bar_zero_val = this.state.progress_bar_zero;
	
	      var notes_flashreport_val = this.state.notesFlashReport;
	      var video_flashreport_val = this.state.videoFlashReport;
	      var savednotes_val = this.state.savednotes;
	      var savedvideo_val = this.state.savedvideo;
	      var reportnotes_val = this.state.reportnotes;
	      var reportvideo_val = this.state.reportsvideo;
	      var notes_flashcard_data = '';
	      var video_flashcard_data = '';
	      var savednotes_data = '';
	      var savedvideo_data = '';
	      var notes_reportsData = ''; // for notes report
	      var video_reportsData = ''; // for video report
	
	      var flashcard_data = '';
	      var savedquestion_data = '';
	      var question_reportsData = ''; // for question reports
	      var reportquestionCBT_val = this.state.reportquestionCBT;
	      var cbt_reportsData = ''; // for cbt question reports
	      var progress_bar_data = '';
	      /*first main graph*/
	      var main_bar_val = this.state.bar_chapter;
	      var main_bar_percentage = this.state.bar_main_user;
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	
	      Object.keys(main_bar_val).map(function (key) {
	        var dataString = JSON.stringify(main_bar_val[key]);
	        var dataReason = JSON.parse(dataString);
	        main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
	        var chapter_id = dataReason.chapter_id;
	
	        i++;
	      });
	
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	
	      var savQuestionTabs = [{ id: '1', label: _language2.default.LC().QUESTIONS }, { id: '2', label: _language2.default.LC().Notes }, isVideo && { id: '3', label: _language2.default.LC().VIDEOS }].filter(Boolean);
	
	      var tabs = [{ id: '1', label: _language2.default.LC().QUESTIONS }, { id: '2', label: _language2.default.LC().Notes }, isVideo && { id: '3', label: _language2.default.LC().VIDEOS }, { id: '4', label: 'Mocks' }].filter(Boolean);
	
	      var chapters = this.state.chapters;
	      var reading_data = '';
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.notesFlashReport.length) {
	        notes_flashcard_data = notes_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteNotesFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteVideoFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSavequestion.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditQuesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id,
	                  toggle: _this9.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleQuestionReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id,
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index)
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index)
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      (0, _function.renderHTMLContent)(items.answer, 'span')
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsquestino.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.comment, 'span')
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.savednotes.length) {
	        savednotes_data = savednotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSaveNotes.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items['cfa2_2027_note.name_2025'] && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items['cfa2_2027_note.name_2025'], 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_NOTES,
	          ' '
	        );
	      }
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSaveVideo.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items['cfa2_2027_video.title'] && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items['cfa2_2027_video.title'], 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      if (this.state.reportnotes.length) {
	        notes_reportsData = reportnotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditNotesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'notesReport',
	                  toggle: _this9.OpenEditNotesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items['cfa2_2027_note.name_2025'], 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditNotesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleNotesReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'notesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.notesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditNotesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items, 'notesReport'),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'notesReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items['cfa2_2027_note.name_2025'], 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'notesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'notesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'notesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'notesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsNotes.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items['cfa2_2027_note.name_2025'], 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            {
	              id: 'reportsvideos_' + items['cfa2_2027_video_reports.id'],
	              key: index,
	              className: 'flash_card_box'
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items['cfa2_2027_video_reports.id']
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items['cfa2_2027_video_reports.status'] === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items['cfa2_2027_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items['cfa2_2027_video_reports.video_id']
	              ),
	              !items['cfa2_2027_video_reports.isSend'] && !items['cfa2_2027_video_reports.reply'] && items['cfa2_2027_video_reports.status'] !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditVideoReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items['cfa2_2027_video_reports.id'] && _this9.state.type === 'videoReport',
	                  toggle: _this9.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items['cfa2_2027_video_reports.video_id'],
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleVideoReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items['cfa2_2027_video_reports.reply'] ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items, 'videoReport'),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items['cfa2_2027_video_reports.id'] && _this9.state.type === 'videoReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items['cfa2_2027_video_reports.video_id'],
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _function.renderSanitizedHTML)(items.topic_name)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'videoReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'videoReport' && _this9.state.contactID === items['cfa2_2027_video_reports.id'] && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items['cfa2_2027_video_reports.reply'])
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsVideo.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items['cfa2_2027_video_reports.comment'])
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	      if (this.state.reportquestionCBT.length) {
	        cbt_reportsData = reportquestionCBT_val.map(function (items, index) {
	          var parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
	          var mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditCBTQuesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'cbtquesReport',
	                  toggle: _this9.OpenEditCBTQuesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(mockName, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditCBTQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleCBTQuestionReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'cbtquesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.cbtquesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditCBTQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this9.view(items);
	                    },
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply && items.reply.length > 0 ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this9.toggleAlertReport.bind(_this9, items, 'cbtquesReport'),
	                  className: _this9.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'cbtquesReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _function.renderSanitizedHTML)(items.topic_name)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'cbtquesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'cbtquesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'cbtquesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'cbtquesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteCBTReportsquestino.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        cbt_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().CFA_LEVEL_II_2023_DASHBOARD
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().TO
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    savQuestionTabs.map(function (tab) {
	                      return _react2.default.createElement(Tab, {
	                        key: tab.id,
	                        id: tab.id,
	                        label: tab.label,
	                        isActive: activeTabSaved === tab.id,
	                        onClick: _this9.savedTabToggle
	                      });
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : this.state.activeTabSaved === '2' ? savednotes_data : savedvideo_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    tabs.map(function (tab) {
	                      return _react2.default.createElement(Tab, {
	                        key: tab.id,
	                        id: tab.id,
	                        label: tab.label,
	                        isActive: activeTabReports === tab.id,
	                        onClick: _this9.reportsTabToggle
	                      });
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : this.state.activeTabReports === '2' ? notes_reportsData : this.state.activeTabReports === '3' ? video_reportsData : cbt_reportsData
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    npLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.notesProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'close', 'aria-label': 'Close', onClick: this.toggleClose },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2Dashboard;
	}(_react.Component);
	
	Cfa2Dashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this10 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this10.toggle = _this10.toggle.bind(_this10);
	    _this10.state = {
	      tooltipOpen: false
	    };
	    return _this10;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	var Tab = function Tab(_ref47) {
	  var id = _ref47.id,
	      label = _ref47.label,
	      isActive = _ref47.isActive,
	      _onClick = _ref47.onClick;
	  return _react2.default.createElement(
	    'li',
	    { onClick: function onClick() {
	        return _onClick(id);
	      }, className: isActive ? 'active' : '' },
	    _react2.default.createElement(
	      'span',
	      null,
	      label
	    )
	  );
	};
	exports.default = Cfa2Dashboard;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _questionNotFoundModel = __webpack_require__(104);
	
	var _questionNotFoundModel2 = _interopRequireDefault(_questionNotFoundModel);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	// import { getIpAddress } from '../../../common/getIpAddress';
	
	
	/* eslint-disable*/
	var Cfa2notesreadings = function (_Component) {
	  _inherits(Cfa2notesreadings, _Component);
	
	  function Cfa2notesreadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2notesreadings);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2notesreadings.__proto__ || Object.getPrototypeOf(Cfa2notesreadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '' + _AppRoutes2.default.CFA2_2027_NOTES,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      console.log(reading.reading);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: ('' + _AppRoutes2.default.CFA2_2027_NOTES_QUES_VIEW).replace(':chapter_no', reading.chapter_no).replace(':id', reading.id).replace(':reading', reading.reading),
	              state: {
	                reading: reading,
	                chapter: _this.state.chapterid
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            //  : '/cfa2beginnotes/:notesid/:readingid/:id/:chapter/:chapter_no/:offset',
	            _this.context.router.push({
	              pathname: ('' + _AppRoutes2.default.CFA2_2027_BEGIN_NOTES).replace(':notesid', reading.chapter_no).replace(':readingid', reading.id).replace(':id', resp.questions[0].id).replace(':chapter', _this.props.params.chapter).replace(':chapter_no', reading.chapter_no).replace(':offset', 0)
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.checkSubscriptions = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              console.log('getDerivedStateFromProps for check subscription===============>');
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              if (storage_session) {
	                _this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	              }
	              data = {
	                idname: storage_session['idname'],
	                token: storage_session['token'],
	                chapter: _this.state.chapterid
	              };
	
	              // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	              _userStore2.default.getUserProfile(true).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context.next = 12;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context.next = 5;
	                            break;
	                          }
	
	                          _this.setState({
	                            showFreePremium: true,
	                            subscriptionstatus: 'free'
	                          });
	                          _context.next = 10;
	                          break;
	
	                        case 5:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context.next = 10;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this.state.selectedmenu;
	                              var isInArray_var = false;
	                              var examPlanData = resp_exam.examPlan[0];
	                              isInArray_var = _Cfa2Subscription4.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type, examPlanData);
	                              if (isInArray_var) {
	                                _this.setState({ showFreePremium: false });
	                              } else {
	                                _this.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 10:
	                          _context.next = 24;
	                          break;
	
	                        case 12:
	                          console.log('hello in this');
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context.next = 17;
	                            break;
	                          }
	
	                          _this.setState({
	                            showFreePremium: true,
	                            subscriptionstatus: 'free'
	                          });
	                          _context.next = 24;
	                          break;
	
	                        case 17:
	                          console.log('enter');
	
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                          console.log('dsarafaygdu', data_arr);
	
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context.next = 24;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            console.log(resp_exam);
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this.state.selectedmenu;
	                              var isInArray_var = false;
	
	                              isInArray_var = _Cfa2Subscription2.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	                              console.log(isInArray_var);
	                              if (isInArray_var) {
	                                _this.setState({ showFreePremium: false, checkSubscriptionState: true });
	                              } else {
	                                _this.setState({ showFreePremium: true, checkSubscriptionState: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 24:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getpdf = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(_this.state.pdfLoading === false)) {
	                  _context6.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context6.abrupt('return');
	
	              case 3:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context6.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context5.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context5.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context5.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context3.next = 7;
	                                        return _Cfa2Subscription4.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context3.sent;
	
	                                        if (!isInArray_var) {
	                                          _context3.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context3.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context3.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.toggleAlert();
	
	                                      case 16:
	                                        _context3.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context5.next = 21;
	                            break;
	
	                          case 12:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context5.next = 16;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context5.next = 21;
	                            break;
	
	                          case 16:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 21;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context4.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context4.next = 6;
	                                        return _Cfa2Subscription2.default.checkCfa2PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context4.sent;
	
	                                        if (!isInArray_var) {
	                                          _context4.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context4.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context4.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context4.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref6.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 21:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.chapter,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      chapterName: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_2',
	      checkSubscriptionState: false,
	      type: 'notes',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      pdfLoading: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      alert_status_question_not_found: false,
	      MessageTitleOnQuestionNotFound: '' + _language2.default.LC().NOTES,
	      MessageContentOnQuestionNotFound: '' + _language2.default.LC().NOTE_NOT_FOUND,
	      subscriptionstatus: ''
	    };
	    _this.checkSubscriptions();
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa2notesreadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      console.log('this.state.subscriptionstatus ', this.state.showFreePremium);
	      if (this.state.showFreePremium) {
	        this.setState({
	          alert_status: !this.state.alert_status
	        });
	      } else {
	        this.setState({
	          alert_status_question_not_found: !this.state.alert_status_question_not_found
	        });
	      }
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to cfanotes page
	
	
	    //Function to redirect page to notesviewquestion  page
	
	
	    //Function to redirect page on specifc questions
	
	
	    // getDerivedStateFromProps for check subscription
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                // await this.checkSubscriptions()
	                window.scrollTo(0, 0);
	                // api to get ip address
	                // const result = await getIpAddress();
	                // if (result) {
	                //   this.setState({
	                //     user_city: result.city,
	                //     user_country: result.country,
	                //     user_ip: result.query,
	                //     user_state: result.region,
	                //     user_continent: result.continent,
	                //   });
	                // }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter: this.state.chapterid
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
	                //   async (resp) => {
	                //     // console.log("resp", resp);
	                //     if (resp.profileInfo.role === 'partner') {
	                //       if (
	                //         resp.profileInfo.exam_selected === '' &&
	                //         resp.profileInfo.exam_package === ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //           subscriptionstatus: 'free',
	                //         });
	                //       } else {
	                //         this.setState({
	                //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //         var data_arr = resp.profileInfo.exam_selected
	                //           ? JSON.parse(resp.profileInfo.exam_selected)
	                //           : null;
	
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(
	                //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
	                //           dataset
	                //         ).then((resp_exam) => {
	                //           if (resp_exam.success) {
	                //             var exam_data = resp_exam.examData;
	                //             var selectedmen = this.state.selectedmenu;
	                //             var isInArray_var = false;
	                //             isInArray_var = PartnerCfa2SubscriptionCheck.checkCfa2PDFSubscription(
	                //               selectedmen,
	                //               exam_data,
	                //               this.state.cfaUnlimitedPackage,
	                //               this.state.cfaUnlimitedActiveExam,
	                //               this.state.type
	                //             );
	                //             console.log(isInArray_var);
	                //             if (isInArray_var) {
	                //               this.setState({ showFreePremium: false });
	                //             } else {
	                //               this.setState({ showFreePremium: true });
	                //             }
	                //           } else {
	                //             // console.log('fail');
	                //           }
	                //         });
	                //       }
	                //     } else {
	                //       console.log('hello in this');
	                //       if (
	                //         resp.profileInfo.exam_selected === '' &&
	                //         resp.profileInfo.cfaUnlimitedPackage == '' &&
	                //         resp.profileInfo.cfaUnlimitedActiveExam == ''
	                //       ) {
	                //         this.setState({
	                //           showFreePremium: true,
	                //           subscriptionstatus: 'free',
	                //         });
	                //       } else {
	                //         console.log('enter');
	
	                //         this.setState({
	                //           cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                //           cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
	                //         });
	                //         var data_arr = resp.profileInfo.exam_selected
	                //           ? JSON.parse(resp.profileInfo.exam_selected)
	                //           : null;
	                //         console.log('dsarafaygdu', data_arr);
	
	                //         var dataset = {
	                //           token: this.state.token,
	                //           idname: this.state.idname,
	                //           examid: data_arr,
	                //         };
	                //         await FD.callAPI(
	                //           App_data.backend_api + '/checkout_v1/getExamsbyUser',
	                //           dataset
	                //         ).then((resp_exam) => {
	                //           console.log(resp_exam);
	                //           if (resp_exam.success) {
	                //             var exam_data = resp_exam.examData;
	                //             var selectedmen = this.state.selectedmenu;
	                //             var isInArray_var = false;
	
	                //             isInArray_var = Cfa2SubscriptionCheck.checkCfa2PDFSubscription(
	                //               selectedmen,
	                //               exam_data,
	                //               this.state.cfaUnlimitedPackage,
	                //               this.state.cfaUnlimitedActiveExam,
	                //               this.state.type
	                //             );
	                //             console.log(isInArray_var);
	                //             if (isInArray_var) {
	                //               this.setState({ showFreePremium: false });
	                //             } else {
	                //               this.setState({ showFreePremium: true });
	                //             }
	                //           } else {
	                //             // console.log('fail');
	                //           }
	                //         });
	                //       }
	                //     }
	                //   }
	                // );
	
	                console.log('I am here -----> ');
	                _context7.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this3.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
	                    }
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '' + _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	    --------------------
	    PDF DOWNLOAD VIA EMAIL
	    --------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading_order,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23'
	                  // aria-disabled={this.state.checkSubscriptionState}
	                  , onClick: _this4._getQuestions.bind(_this4, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21'
	                  // aria-disabled={this.state.checkSubscriptionState}
	
	                  , id: item.id,
	                  onClick: _this4._beginChapter.bind(_this4, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_NOTES_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.chapterName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 notes-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Notes : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CHAPTER_READINGS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().READING
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_questionNotFoundModel2.default, {
	          alert_status: this.state.alert_status_question_not_found,
	          toggleAlert: this.toggleAlert,
	          MessageTitle: this.state.MessageTitleOnQuestionNotFound,
	          MessageContent: this.state.MessageContentOnQuestionNotFound
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Cfa2notesreadings;
	}(_react.Component);
	
	Cfa2notesreadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa2notesreadings;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _axios = __webpack_require__(102);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _fileSaver = __webpack_require__(151);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfanotesbeginchapters = function (_Component) {
	  _inherits(Cfanotesbeginchapters, _Component);
	
	  function Cfanotesbeginchapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfanotesbeginchapters);
	
	    var _this = _possibleConstructorReturn(this, (Cfanotesbeginchapters.__proto__ || Object.getPrototypeOf(Cfanotesbeginchapters)).call(this, props));
	
	    _this._getReadings = function () {
	      var path = _AppRoutes2.default.CFA2_2027_NOTES_READINGS.replace(':chapter', _this.props.params.notesid);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid
	        }
	      });
	    };
	
	    _this._getNotes = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2027_NOTES_QUES_VIEW.replace(':chapter_no', _this.state.questions.chapter_id_2025).replace(':id', _this.props.params.readingid).replace(':reading', _this.state.readings)
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      }), document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	
	      _this.setState({ offset: i, questions: _this.state.all_questions_state[i] });
	
	      //alert((parseInt(this.state.question_length)-1)+'--------'+i);
	      if (parseInt(_this.state.question_length) - 1 == i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i !== 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      console.log('I am here -> ', _this.state.all_questions_state[i], _this.state.all_questions_state[i].id);
	      var next_question_id = _this.state.all_questions_state[i].id;
	
	      // 2027: the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
	      _this.setState({ reading_name_2025: _this.state.all_questions_state[i].name_2025 || '' });
	
	      var path = _AppRoutes2.default.CFA2_2027_BEGIN_NOTES.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      //alert(i);
	      // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({
	          next_block: ''
	        });
	      }
	      if (i === 0) {
	        _this.setState({
	          previ_block: 'card hide_block'
	        });
	      }
	
	      _this.setState({
	        questions: _this.state.all_questions_state[i]
	      });
	
	      // 2027: the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
	      _this.setState({ reading_name_2025: _this.state.all_questions_state[i].name_2025 || '' });
	
	      var next_question_id = _this.state.all_questions_state[i].id;
	
	      var path = _AppRoutes2.default.CFA2_2027_BEGIN_NOTES.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      // console.log('Working');
	
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveNotesstats = function (item, e) {
	      if (_this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        notes_id: item.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            save_question: 'btn btn-success pointer_class margin_right_10'
	          });
	          _this.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	          _this.setState({ markColor: 'green' });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          // FD.callAPI(
	          //   App_data.backend_api + '/cfa2_2027_notes/getFlashCards',
	          //   params
	          // ).then((response) => {
	          //   if (response.success) {
	          //     this.setState({ ValidToken: true });
	          //     if (response.flash_cards.length > 0) {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	          //       });
	          //       var flash_cards = response.flash_cards.map((items, index) => (
	          //         <li key={index}>
	          //           <div className=''>
	          //             <ul className='icon_list'>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._editFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-pencil' />
	          //                 </a>
	          //               </li>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._deleteFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-close' />
	          //                 </a>
	          //               </li>
	          //             </ul>
	          //             <div className={this.state.flash_class}>
	          //               <h4 />
	          //               <p>{items.flash_card}</p>
	          //             </div>
	          //           </div>
	          //         </li>
	          //       ));
	          //     } else {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //       });
	          //       var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     }
	          //     this.setState({ flash_data: flash_cards });
	          //   } else {
	          //     var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     this.setState({ ValidToken: false });
	          //     this.setState({ flash_data: flash_cards });
	          //     this.setState({
	          //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //     });
	          //   }
	          //   return response;
	          // });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getSavedNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getFavNotes', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(all_questions, e) {
	        var url, response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                url = _App_data2.default.backend_api + '/cfa2_2027_notes/getpdfnotes?id=' + all_questions.id;
	                _context2.next = 3;
	                return (0, _axios2.default)({
	                  url: url,
	                  method: 'GET',
	                  responseType: 'blob'
	                });
	
	              case 3:
	                response = _context2.sent;
	
	                (0, _fileSaver.saveAs)(response.data, all_questions.name_2025 + '.pdf');
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavNotes = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/unsaveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/saveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      chapter_id: _this.props.params.chapter_no,
	      reading_id: _this.props.params.readingid,
	      ValidToken: false,
	      offset: 0,
	      limit: 1,
	      reportLoading: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'btn btn-primary pointer_class margin_right_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: '' + _language2.default.LC().MARK_AS_READ,
	      saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      display_loader: '',
	      markColor: '',
	      showCustomerly: false,
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  //Function to redirect page to readings page
	
	
	  //Function to fetch Next question
	
	
	  //Function to fetch previous question
	
	
	  //Function to show Report box
	
	
	  //Function to hide Report box
	
	
	  //Funcion to save new report question
	
	
	  //Function to toggle Comment box
	
	
	  //Function to toggle Flash box
	
	
	  //Function to save notes and display Marked on button
	
	
	  //Function to Save flash Card And display new stored flash card
	
	
	  //Function to Edit Flash card
	
	
	  //Function to delete flash card
	
	
	  _createClass(Cfanotesbeginchapters, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context4.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                window.scroll(0, 0);
	                if (!this.props.params.id) {
	                  this.setState({ previ_block: 'card hide_block' });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.props.params.notesid
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getReadings', data).then(function (resp) {
	                  var getReading = resp.readings.filter(function (item) {
	                    return item.id === parseInt(_this3.props.params.readingid);
	                  })[0];
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: getReading.reading
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes_allcr', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var ques_res, offset_res, i, params;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context3.next = 22;
	                              break;
	                            }
	
	                            _this3.setState({ ValidToken: true });
	                            _this3.setState({ all_questions_state: resp.questions });
	                            ques_res = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this3.props.params.id) {
	                                ques_res = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i === resp.questions.length - 1) {
	                                _this3.setState({ display_loader: 'hide_block' });
	                              }
	                            }
	                            // 2027: the title is the admin "Name" field as-is (no "LOS N" stripping or prefixing)
	                            _this3.setState({ reading_name_2025: ques_res.name_2025 || '' });
	                            _this3.setState({ questions: ques_res });
	                            //console.log(ques_res);
	                            _this3.setState({ offset: offset_res });
	                            _this3.setState({ question_length: resp.questions.length });
	
	                            if (offset_res === 0) {
	                              _this3.setState({ previ_block: 'card hide_block' });
	                            }
	                            //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this3.setState({ next_block: 'card hide_block' });
	                            }
	
	                            _context3.next = 14;
	                            return _this3.getSavedNotes(ques_res.id);
	
	                          case 14:
	                            params = {
	                              token: _this3.state.token,
	                              question_id: ques_res.id,
	                              idname: _this3.state.idname
	                            };
	                            _context3.next = 17;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getsavestatesNotes', params).then(function (response) {
	                              if (response.success) {
	                                // console.log("enter");
	
	                                _this3.setState({
	                                  save_question: 'btn btn-success pointer_class margin_right_10'
	                                });
	                                _this3.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	                                _this3.setState({ markColor: 'green' });
	                              } else {
	                                // console.log("enter else");
	                                setTimeout(_this3.notes_MARKED_AS_READ.bind(_this3, params), 6000);
	                              }
	                              // console.log("respomse", response);
	                            });
	
	                          case 17:
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	                            // await FD.callAPI(
	                            //   App_data.backend_api + '/cfa2_2027_notes/getFlashCards',
	                            //   params
	                            // ).then((response) => {
	                            //   var flash_cards = '';
	                            //   if (response.success) {
	                            //     this.setState({ ValidToken: true });
	                            //     if (response.flash_cards.length > 0) {
	                            //       this.setState({
	                            //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                            //       });
	                            //       flash_cards = response.flash_cards.map((items, index) => (
	                            //         <li key={index}>
	                            //           <div className=''>
	                            //             <ul className='icon_list'>
	                            //               <li>
	                            //                 <a
	                            //                   className='pointer_class'
	                            //                   onClick={this._editFlash.bind(this, items)}
	                            //                 >
	                            //                   <i className='fa fa-pencil' />
	                            //                 </a>
	                            //               </li>
	                            //               <li>
	                            //                 <a
	                            //                   className='pointer_class'
	                            //                   onClick={this._deleteFlash.bind(this, items)}
	                            //                 >
	                            //                   <i className='fa fa-close' />
	                            //                 </a>
	                            //               </li>
	                            //             </ul>
	                            //             <div className={this.state.flash_class}>
	                            //               <h4 />
	                            //               <p>{items.flash_card}</p>
	                            //             </div>
	                            //           </div>
	                            //         </li>
	                            //       ));
	                            //     } else {
	                            //       this.setState({
	                            //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                            //       });
	                            //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                            //     }
	                            //     this.setState({ flash_data: flash_cards });
	                            //   } else {
	                            //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                            //     this.setState({ ValidToken: false });
	                            //     this.setState({ flash_data: flash_cards });
	                            //     this.setState({
	                            //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                            //     });
	                            //   }
	                            //   return response;
	                            // });
	
	                            _this3.setState({ records: '' });
	                            _context3.next = 24;
	                            break;
	
	                          case 22:
	                            _this3.setState({ ValidToken: false });
	                            _this3.setState({ records: 'Result not found.' });
	
	                          case 24:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 13:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'notes_MARKED_AS_READ',
	    value: function notes_MARKED_AS_READ(params) {
	      var _this4 = this;
	
	      // const result = getDeviceDetails();
	      // console.log("params", params);
	      var data = {
	        token: params.token,
	        idname: params.idname,
	        notes_id: params.question_id,
	        city: this.state.user_city,
	        country: this.state.user_country,
	        state: this.state.user_state,
	        continent: this.state.user_continent,
	        ip: this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/saveNotesstats', data).then(function (resp) {
	        // console.log("re",resp);
	
	        if (resp.success) {
	          _this4.setState({ ValidToken: true });
	          _this4.setState({
	            save_question: 'btn btn-success pointer_class margin_right_10'
	          });
	          _this4.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	          _this4.setState({ markColor: 'green' });
	        } else {
	          _this4.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, this.state.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes_allcr', data).then(function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	          var ques_res, i, params;
	          return _regenerator2.default.wrap(function _callee5$(_context5) {
	            while (1) {
	              switch (_context5.prev = _context5.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context5.next = 14;
	                    break;
	                  }
	
	                  _this5.setState({ ValidToken: true });
	                  ques_res = [];
	
	                  for (i = 0; i < resp.questions.length; i++) {
	                    if (resp.questions[i].id == _this5.props.params.id) {
	                      ques_res = resp.questions[i];
	                    }
	                  }
	                  _this5.setState({ questions: ques_res });
	                  _this5.setState({ display_loader: 'hide_block' });
	                  params = {
	                    token: _this5.state.token,
	                    question_id: ques_res.id,
	                    idname: _this5.state.idname
	                  };
	                  _context5.next = 9;
	                  return _this5.getSavedNotes(ques_res.id);
	
	                case 9:
	                  _context5.next = 11;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getsavestatesNotes', params).then(function (response) {
	                    if (response.success) {
	                      _this5.setState({
	                        save_question: 'btn btn-success pointer_class margin_right_10'
	                      });
	                      _this5.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	                      _this5.setState({ markColor: 'green' });
	                    } else {
	                      _this5.setState({ markColor: '#ddd' });
	                      // console.log("work");
	                      setTimeout(_this5.notes_MARKED_AS_READ.bind(_this5, params), 6000);
	                      //
	                    }
	                  });
	
	                case 11:
	                  // await FD.callAPI(
	                  //   App_data.backend_api + '/cfa2_2027_notes/getFlashCards',
	                  //   params
	                  // ).then((response) => {
	                  //   var flash_cards = '';
	                  //   if (response.success) {
	                  //     this.setState({ ValidToken: true });
	                  //     if (response.flash_cards.length > 0) {
	                  //       this.setState({
	                  //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                  //       });
	                  //       flash_cards = response.flash_cards.map((items, index) => (
	                  //         <li key={index}>
	                  //           <div className=''>
	                  //             <ul className='icon_list'>
	                  //               <li>
	                  //                 <a
	                  //                   className='pointer_class'
	                  //                   onClick={this._editFlash.bind(this, items)}
	                  //                 >
	                  //                   <i className='fa fa-pencil' />
	                  //                 </a>
	                  //               </li>
	                  //               <li>
	                  //                 <a
	                  //                   className='pointer_class'
	                  //                   onClick={this._deleteFlash.bind(this, items)}
	                  //                 >
	                  //                   <i className='fa fa-close' />
	                  //                 </a>
	                  //               </li>
	                  //             </ul>
	                  //             <div className={this.state.flash_class}>
	                  //               <h4 />
	                  //               <p>{items.flash_card}</p>
	                  //             </div>
	                  //           </div>
	                  //         </li>
	                  //       ));
	                  //     } else {
	                  //       this.setState({
	                  //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  //       });
	                  //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                  //     }
	                  //     this.setState({ flash_data: flash_cards });
	                  //   } else {
	                  //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                  //     this.setState({ ValidToken: false });
	                  //     this.setState({ flash_data: flash_cards });
	                  //     this.setState({
	                  //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  //     });
	                  //   }
	                  //   return response;
	                  // });
	                  _this5.setState({ records: '' });
	                  _context5.next = 16;
	                  break;
	
	                case 14:
	                  _this5.setState({ ValidToken: false });
	                  _this5.setState({ records: '' + _language2.default.LC().Result_not_found });
	
	                case 16:
	                case 'end':
	                  return _context5.stop();
	              }
	            }
	          }, _callee5, _this5);
	        }));
	
	        return function (_x5) {
	          return _ref5.apply(this, arguments);
	        };
	      }());
	    }
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var data = '';
	
	      var retun_all_question = JSON.stringify(questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 note-section special_notes_view' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card note-section-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size sticky-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                className: 'margin_right_10',
	                alt: '',
	                width: '21'
	              }),
	              (0, _function.renderHTMLContent)('' + this.state.reading_name_2025, "span", "notes-head-color", { contentEditable: "false" }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'notes-head-color' },
	                '(',
	                _language2.default.LC().N,
	                ' ',
	                all_questions.id,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right sticky-navigate' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'note-text-wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row overflow-x-auto' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_20' },
	                    (0, _function.renderHTMLContent)(all_questions.description, "div", "note_text_wrap", { contentEditable: "false" })
	                  ),
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default
	                  // _getResult={this._getResult}
	                  , { isQue: false,
	                    saveNotes_text: this.state.saveNotes_text,
	                    markColor: this.state.markColor,
	                    _saveQuestion: this._saveFavNotes,
	                    _saveNotesstats: this._saveNotesstats,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: all_questions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'notes',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'cfa_2_2027'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, all_questions)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, all_questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        /* data = <div className="col-sm-12 col-md-12">
	               <div className="no_data_bar card">No Records Found</div>
	          </div>;*/
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row note-section notes_inner_title_wrap' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head title-font-size' },
	                _language2.default.LC().NOTES
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getNotes
	                },
	                _language2.default.LC().CHANGE_NOTES
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_READING
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfanotesbeginchapters;
	}(_react.Component);
	
	Cfanotesbeginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfanotesbeginchapters;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Axios from 'axios';
	// import { saveAs } from 'file-saver';
	
	
	/* eslint-disable*/
	var Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(chapter, e) {
	        var path, final_exam, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (chapter.chapter_no === 1) {
	                  path = _AppRoutes2.default.CFA2_2027_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	
	                  _this.context.router.push({
	                    pathname: path,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter: chapter.chapter_no
	                    }
	                  });
	                } else {
	                  final_exam = [];
	                  data = { token: _this.state.token, idname: _this.state.idname };
	
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                      var data_arr, dataset;
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              if (!(resp.profileInfo.role === 'partner')) {
	                                _context2.next = 12;
	                                break;
	                              }
	
	                              if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                                _context2.next = 5;
	                                break;
	                              }
	
	                              _this.toggleAlert();
	                              _context2.next = 10;
	                              break;
	
	                            case 5:
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	                              _context2.next = 10;
	                              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData, _path;
	
	                                  return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                      switch (_context.prev = _context.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context.next = 7;
	                                          return _Cfa2Subscription4.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context.sent;
	
	                                          if (isInArray_var) {
	                                            _path = _AppRoutes2.default.CFA2_2027_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	
	                                            _this.context.router.push({
	                                              pathname: _path,
	                                              state: {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                chapter: chapter.chapter_no
	                                              }
	                                            });
	                                          } else {
	                                            _this.toggleAlert();
	                                          }
	                                          _context.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context.stop();
	                                      }
	                                    }
	                                  }, _callee, _this2);
	                                }));
	
	                                return function (_x4) {
	                                  return _ref3.apply(this, arguments);
	                                };
	                              }());
	
	                            case 10:
	                              _context2.next = 13;
	                              break;
	
	                            case 12:
	                              if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                                _this.toggleAlert();
	                              } else {
	                                _this.setState({
	                                  cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                  cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                                });
	                                data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                                dataset = {
	                                  token: _this.state.token,
	                                  idname: _this.state.idname,
	                                  examid: data_arr
	                                };
	
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                  if (resp_exam.success) {
	                                    var exam_data = resp_exam.examData;
	                                    var selectedmen = _this.state.selectedmenu;
	                                    var isInArray_var = false;
	
	                                    isInArray_var = _Cfa2Subscription2.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    //console.log(isInArray_var);
	                                    if (isInArray_var) {
	                                      var _path2 = _AppRoutes2.default.CFA2_2027_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	                                      _this.context.router.push({
	                                        pathname: _path2,
	                                        state: {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapter: chapter.chapter_no
	                                        }
	                                      });
	                                    } else {
	                                      _this.toggleAlert();
	                                    }
	                                  } else {}
	                                });
	                              }
	
	                            case 13:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }());
	                }
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goToNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, lastRecord, lastAttempt, path;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              console.log('lastRecord -----------> ', lastRecord, '---------> ', lastRecord.cfa2_2027_note);
	              if (lastAttempt) {
	                path = _AppRoutes2.default.CFA2_2027_BEGIN_NOTES.replace(':notesid', lastRecord.cfa2_2027_note.chapter_id_2025).replace(':readingid', lastRecord.cfa2_2027_note.reading_id_2025).replace(':id', lastRecord.cfa2_2027_note.id).replace(':offset', 0);
	
	                _this.context.router.push({
	                  pathname: path
	                });
	              }
	
	            case 3:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.toggle = function () {
	      _this.setState({
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.getAdditionalResources = function (type) {
	      console.log('check pdf type', type);
	      var typeName = type === 'FS' ? 'Formula sheet' : type === 'ES' ? 'Essential summary' : 'Ratio sheet';
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        type: typeName,
	        exam: 'cfa_2'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getAdditionalResources', data).then(function (resp) {
	        if (resp.success) {
	          //   this.setState({ ValidToken: true });
	          (0, _function.openPDF)(resp);
	          return resp;
	        }
	      });
	    };
	
	    _this.checkSubscription = function (type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context5.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	
	                        // #261 — pass examPlanData so mock-only partners hit the
	                        // early-return false (was missing — let mock-package owners
	                        // download additional notes resources they shouldn't).
	
	                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                        _context5.next = 7;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context5.sent;
	
	                        if (isInArray_var) {
	                          _this.getAdditionalResources(type);
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context5.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, _this2);
	              }));
	
	              return function (_x5) {
	                return _ref5.apply(this, arguments);
	              };
	            }()
	            //console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            //console.log('in paid');
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              //console.log('resp of get exam by user', resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                //console.log('outside isInArray_var heeee', resp_exam);
	                if (isInArray_var) {
	                  _this.getAdditionalResources(type);
	
	                  // const getIndex = resp_exam.allexamData.filter(
	                  //   (item) => item.exam_name === 'cfa'
	                  // )[0];
	                  // if (getIndex) {
	                  //   if (type === 'ES') {
	                  //     if (getIndex.essentialSummary) {
	                  //       var myWindow = window.open(getIndex.essentialSummary);
	                  //     }
	                  //     myWindow.focus();
	                  //   } else if (type === 'FS') {
	                  //     if (getIndex.formulaSheet) {
	                  //       var myWindow = window.open(getIndex.formulaSheet);
	                  //     }
	                  //     myWindow.focus();
	                  //   } else {
	                  //     if (getIndex.ratioSheet) {
	                  //       var myWindow = window.open(getIndex.ratioSheet);
	                  //     }
	                  //     myWindow.focus();
	                  //   }
	                  // }
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      showFreePremium: '',
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      isNotesNotFound: false,
	      lastAttempt: false,
	      pdfLoading: true,
	      dropdownOpen: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Notes, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var _this3 = this;
	
	        var storage_session, data, final_exam;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                // console.log('working')
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    if (resp.chapters.length === 0) {
	                      _this3.setState({ isNotesNotFound: true });
	                    }
	                    _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                    var data = { token: _this3.state.token, idname: _this3.state.idname };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getlastReadNotes', data).then(function (response) {
	                      if (response.success) {
	                        _this3.setState({
	                          lastRecord: response.data,
	                          lastAttempt: true
	                        });
	                      }
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                final_exam = [];
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                  var resp, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context7.next = 3;
	                            break;
	                          }
	
	                          return _context7.abrupt('return');
	
	                        case 3:
	
	                          if (resp.profileInfo.role === 'partner') {
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                              _this3.setState({ showFreePremium: true });
	                            } else {
	                              _this3.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this3.state.token,
	                                idname: _this3.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData;
	                                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                    while (1) {
	                                      switch (_context6.prev = _context6.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context6.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this3.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context6.next = 7;
	                                          return _Cfa2Subscription4.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context6.sent;
	
	                                          if (isInArray_var) {
	                                            _this3.setState({ showFreePremium: false });
	                                          } else {
	                                            _this3.setState({ showFreePremium: true });
	                                          }
	                                          _context6.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context6.stop();
	                                      }
	                                    }
	                                  }, _callee6, _this3);
	                                }));
	
	                                return function (_x6) {
	                                  return _ref8.apply(this, arguments);
	                                };
	                              }()
	                              // console.log('fail');
	                              );
	                            }
	                          } else {
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this3.setState({ showFreePremium: true });
	                            } else {
	                              _this3.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this3.state.token,
	                                idname: _this3.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this3.state.selectedmenu;
	                                  var isInArray_var = false;
	
	                                  isInArray_var = _Cfa2Subscription2.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                  //console.log(isInArray_var);
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	                          }
	
	                        case 4:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this3);
	                })));
	                // });
	
	              case 7:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var dropdownOpen = this.state.dropdownOpen;
	
	      var chapters = this.state.chapters;
	      var data = '';
	      var lastAttempt = this.state.lastAttempt;
	
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium ? item.id === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  item.chapter_no,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon2.svg',
	                      className: '',
	                      width: '24',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countreading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_READINGS
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon3.svg',
	                      className: '',
	                      width: '20',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.Countquestion
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_NOTES
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else if (this.state.isNotesNotFound) {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-12 text-center mt-3' },
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/notes/notes_icon1_blue.svg',
	            className: '',
	            width: '54',
	            alt: ''
	          }),
	          _react2.default.createElement(
	            'h5',
	            { className: 'mt-1' },
	            _language2.default.LC().NOTE_NOT_FOUND
	          )
	        );
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().NOTES
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactstrap.ButtonDropdown,
	              { isOpen: dropdownOpen, toggle: function toggle() {
	                  return _this4.toggle();
	                } },
	              _react2.default.createElement(
	                _reactstrap.DropdownToggle,
	                {
	                  className: 'btn btn-primary pointer_class tooltip_wrap margin_right_20',
	                  caret: true
	                },
	                _language2.default.LC().Additional_Resources
	              ),
	              _react2.default.createElement(
	                _reactstrap.DropdownMenu,
	                { right: true },
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  {
	                    value: 'private',
	                    onClick: function onClick() {
	                      _this4.checkSubscription('FS');
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	                  _language2.default.LC().Formula_Sheet
	                )
	              )
	            ),
	            lastAttempt && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToNotes,
	                disabled: !lastAttempt
	              },
	              _messages.messages.GO_TO_MY_LAST_READ_NOTE
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	Notes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Notes;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(32);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(31);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Viewques = function (_Component) {
	  _inherits(Viewques, _Component);
	
	  function Viewques(props) {
	    _classCallCheck(this, Viewques);
	
	    var _this = _possibleConstructorReturn(this, (Viewques.__proto__ || Object.getPrototypeOf(Viewques)).call(this, props));
	
	    _this._getReadings = function () {
	      var path = _AppRoutes2.default.CFA2_2027_NOTES_READINGS.replace(':chapter', _this.props.params.chapter_no);
	      _this.context.router.push({
	        // pathname: `/cfa2notesreadings/${this.props.params.chapter_no}`,
	        pathname: path
	      });
	    };
	
	    _this._goToVideo = function () {
	      _this.setState({
	        chapter_video_redirect: _this.state.chapters[parseInt(_this.props.params.chapter_no) - 1]
	      }, function () {
	        // TODO work
	
	        var path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', _this.state.chapter_video_redirect.chapter_no).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':chapter_id', _this.state.chapter_video_redirect.chapter_no).replace(':index', 0);
	        _this.context.router.push({
	          pathname: path,
	          search: '?chapter_name=' + _this.state.chapter_video_redirect.chapter_name + '/' + _this.state.chapter_video_redirect.chapter_no,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter: _this.state.chapter_video_redirect,
	            showFreePremium: _this.state.showFreePremium
	          }
	        });
	      });
	    };
	
	    _this._beginNotes = function (item, e) {
	      console.log('beginNotes ---> ', item);
	      var path = _AppRoutes2.default.CFA2_2027_BEGIN_NOTES.replace(':notesid', item.chapter_id_2025).replace(':readingid', item.reading_id_2025).replace(':id', item.id);
	      _this.context.router.push({
	        pathname: path,
	        // '/cfa2beginnotes/' +
	        // item.chapter_id +
	        // '/' +
	        // item.reading_id +
	        // '/' +
	        // item.id,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: item.reading_id,
	          chapter: item.chapter_id
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      showFreePremium: true,
	      subscription_details: '',
	      chapters: [],
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'cfa_2',
	      isVideo: true,
	      Loader: false
	    };
	    return _this;
	  }
	
	  _createClass(Viewques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this2 = this;
	
	        var storage_session, getProfileInfo, data_data, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfo).then(
	                // userStore.getUserProfile(true).then(
	                //   async resp => {
	                //     if (resp.profileInfo) {
	                //       this.setState({
	                //         isVideo: resp.profileInfo.isVideo,
	                //       });
	                //     }
	                //   },
	                // );
	
	                data_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	                // console.log(data);
	
	                _context3.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes', data).then(function (resp) {
	                  // console.log(resp);
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true, questions: resp.questions });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 7:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	                _userStore2.default.getUserProfile(true).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (resp.profileInfo != null) {
	                              _this2.setState({ isVideo: resp.profileInfo.isVideo });
	                            }
	
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context2.next = 5;
	                              break;
	                            }
	
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '' && resp.profileInfo.exam_package) {
	                              _this2.setState({
	                                showFreePremium: true,
	                                Loader: true
	                              });
	                            } else {
	                              subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                              _this2.setState({
	                                subscription_details: subscription_details,
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this2.state.token,
	                                idname: _this2.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData;
	                                  return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                      switch (_context.prev = _context.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this2.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context.next = 7;
	                                          return _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context.sent;
	
	                                          if (isInArray_var) {
	                                            _this2.setState({ showFreePremium: false, Loader: true });
	                                          } else {
	                                            _this2.setState({
	                                              showFreePremium: true,
	                                              Loader: true
	                                            });
	                                          }
	                                          _context.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context.stop();
	                                      }
	                                    }
	                                  }, _callee, _this2);
	                                }));
	
	                                return function (_x2) {
	                                  return _ref3.apply(this, arguments);
	                                };
	                              }());
	                            }
	                            _context2.next = 15;
	                            break;
	
	                          case 5:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context2.next = 9;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this2.setState({
	                              showFreePremium: true,
	                              Loader: true
	                            });
	                            _context2.next = 15;
	                            break;
	
	                          case 9:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this2.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this2.state.token,
	                              idname: _this2.state.idname,
	                              examid: data_arr
	                            };
	                            _context2.next = 15;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                                //   console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this2.setState({ showFreePremium: false, Loader: true });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this2.setState({ showFreePremium: true, Loader: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 15:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.questions;
	      // console.log("this.state.questions;", this.state.questions);
	      var chapters = this.state.chapters;
	      var chapter_no = this.props.params.chapter_no;
	
	      var countVideo = chapters[chapter_no - 1] ? chapters[this.props.params.chapter_no - 1].Countvideos : null;
	      var data = '';
	      if (this.state.questions.length && this.state.Loader) {
	        data = questions.map(function (item, index) {
	          var _item$reading_order = item.reading_order,
	              reading_order = _item$reading_order === undefined ? '' : _item$reading_order,
	              _item$name_ = item.name_2025,
	              name_2025 = _item$name_ === undefined ? '' : _item$name_;
	
	          var readings_name_2025;
	          if (name_2025.search('<span') !== -1) {
	            readings_name_2025 = name_2025.split('>')[1].split('<')[0];
	          } else {
	            readings_name_2025 = name_2025;
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4', key: index },
	            _react2.default.createElement(
	              'div',
	              { onClick: _this3._beginNotes.bind(_this3, item), className: 'border_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                    className: 'margin_right_10',
	                    alt: '',
	                    width: '21'
	                  }),
	                  readings_name_2025.length < 90 ? readings_name_2025 : readings_name_2025.substr(0, 100) + '...',
	                  ' ',
	                  '(',
	                  _language2.default.LC().N,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                item.description ? (0, _function.renderHTMLContent)(item.description.substring(0, item.description.indexOf('$$') !== -1 ? item.description.indexOf('$$') : 130) + '...', "div", "view_question_height view_questionhtml margin_bottom_40 cfa_notes_view", { contentEditable: "false" }) : null,
	                _react2.default.createElement(UserInfo, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.reading
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.isVideo === true ? 'col-md-4 text-md-right margin_bottom_20' : 'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data
	        )
	      );
	    }
	  }]);
	
	  return Viewques;
	}(_react.Component);
	
	Viewques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	function UserInfo(props) {
	  var data = {
	    itemid: props.itemid,
	    chapter_id: props.chapter_id,
	    reading_id: props.reading_id,
	    idname: props.idname,
	    token: props.token
	  };
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotesByuser', data).then(function (resp) {
	    if (resp.success) {
	      if (resp.success == 'success') {
	        if (document.getElementById('user_question_status' + props.answered_state) != null) {
	          document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Read';
	
	          document.getElementById('user_question_status' + props.answered_state).id = 'answered_status';
	        }
	      } else {
	        if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Unread';
	
	        if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'notanswered_status';
	      }
	    } else {
	      // Render-fired fetch: an earlier response may have renamed this element's id → null guard.
	      if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { id: 'user_question_status' + props.answered_state })
	  );
	}
	exports.default = Viewques;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _messages = __webpack_require__(14);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa2_2023QuestionBank = function (_Component) {
	  _inherits(Cfa2_2023QuestionBank, _Component);
	
	  function Cfa2_2023QuestionBank(props) {
	    _classCallCheck(this, Cfa2_2023QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2_2023QuestionBank.__proto__ || Object.getPrototypeOf(Cfa2_2023QuestionBank)).call(this, props));
	
	    _this._getCases = function (chapter, e) {
	      // console.log('chapter--------------------', chapter);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES.replace(':id', chapter.id).replace(':chapter_name', chapter.chapter_name).replace(':total_cases', chapter.total_cases)
	        // `/cfa2_cases/${chapter.id}/${chapter.chapter_name}/${
	        //   chapter.total_cases
	        // }`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: chapter,
	        // },
	      });
	    };
	
	    _this.goToQuestion = function () {
	      var _this$state = _this.state,
	          lastRecord = _this$state.lastRecord,
	          lastAttempt = _this$state.lastAttempt;
	
	      if (lastAttempt) {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', lastRecord.cfa2_2027_question.chapter_id_2025).replace(':caseid', lastRecord.cfa2_2027_question.case_id).replace(':case_offset', lastRecord.caseIndex).replace(':question_number', lastRecord.cfa2_2027_question.question_number).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      token: '',
	      freeChapterCount: [],
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      lastRecord: '',
	      lastAttempt: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Cfa2_2023QuestionBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChapters', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context.next = 6;
	                    break;
	                  }
	
	                  _this2.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  _context.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this2.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context.next = 7;
	                  break;
	
	                case 6:
	                  _this2.setState({ ValidToken: false });
	
	                case 7:
	                  return _context.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var chapters = this.state.chapters;
	      var countFree = this.state.freeChapterCount;
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      var percent_data = ['5-10%', //Quanititive
	      '5-10%', //Economics
	      '10-15%', //Financial reporting
	      '5-10%', //Corporate
	      '10-15%', //Equity
	      '10-15%', //Fixed income
	      '5-10%', //Derivative
	      '5-10%', //Alternative
	      '10-15%', //Portfolio
	      '10-15%'];
	
	      if (this.state.chapters.length && this.state.freeChapterCount.length) {
	        var count = 0;
	        data = chapters.map(function (item, index) {
	          var itemFree = _this3.state.freeChapterCount.find(function (obj) {
	            return obj.id === item.id ? count = obj.count : count = 0;
	          });
	
	          return _react2.default.createElement(
	            'div',
	            {
	              className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section',
	              key: index,
	              onClick: _this3._getCases.bind(_this3, item)
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'question_bank_wrap pointer_class', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                  width: '54',
	                  className: '',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.chapter_no,
	                    onClick: _this3._getCases.bind(_this3, item)
	                  },
	                  item.id,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                      className: '',
	                      width: '25',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    percent_data[index]
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                      className: '',
	                      width: '26',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    count
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().FREE_CASES,
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                      className: '',
	                      width: '23',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.total_cases
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().PREMIUM_CASES,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().CFA_LEVEL_II_QUESTION_BANK
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.CFA_2 }),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2_2023QuestionBank;
	}(_react.Component);
	
	Cfa2_2023QuestionBank.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa2_2023QuestionBank;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa22023cases = function (_Component) {
	  _inherits(Cfa22023cases, _Component);
	
	  function Cfa22023cases(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa22023cases);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (Cfa22023cases.__proto__ || Object.getPrototypeOf(Cfa22023cases)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK
	      });
	    };
	
	    _this._beginChapter = function (reading, index, e) {
	      //console.log("readog", reading);
	      // console.log(
	      //   'readingreadingreadingreadingreadingreadingreadingreadingreadingreadingreadingreadingreading---------------------------------',
	      //   reading
	      // );
	      // console.log('indexindexindexindexindex', index);
	
	      var subscriptionstatus = _this.state.subscriptionstatus;
	
	      if (subscriptionstatus === 'free' && reading.free == 0) {
	        _this.togglePremiumAlert();
	      } else {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.state.chapterid).replace(':caseid', reading.id).replace(':case_offset', index).replace(':question_number', 1).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context4.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context4.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context4.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context4.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context4.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context.next = 7;
	                                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context3.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context3.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        //console.log("isInArray_var_PDF before", isInArray_var_PDF);
	
	                                        _context2.next = 6;
	                                        return _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoading: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 23:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context8.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context8.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context8.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context8.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context8.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context7.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context7.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context7.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context7.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        // #261 — pass examPlanData so the mock-package early-return
	                                        // fires (otherwise partner with mock-only plan got a PDF email).
	
	                                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                                        _context5.next = 7;
	                                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context5.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context5.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context5.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoadingAnswer: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context5.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context5.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x7) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context7.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context7.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context7.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context7.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context6.next = 6;
	                                        return _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context6.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
	                                            _this.setState({ pdfLoadingAnswer: true });
	                                            (0, _toast.showInformation)(response.message || "The PDF for this topic is not available yet.");
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: '' + _language2.default.LC().READING_NOT_FOUND,
	      changeStatusTitle: '' + _language2.default.LC().Mark_this_Question_as_Completed,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.id,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      selectedmenu: 'cfa_2',
	      subscriptionstatus: '',
	      change_status: false,
	      change_case_no: '',
	      change_completion_status: '',
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      premiumAlertStatus: false,
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFDownloadType: 'Question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggleAlertChangeStatus = _this.toggleAlertChangeStatus.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa22023cases, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    //it is use to redirect page
	
	  }, {
	    key: 'toggleAlertChangeStatus',
	    value: function toggleAlertChangeStatus(item, index) {
	      // console.log(item)
	      // console.log(index)
	      {
	        item.completionStatus === 1 ? this.setState({
	          change_status: !this.state.change_status,
	          change_case_no: item.case_number,
	          change_completion_status: item.completionStatus,
	          markAsCompleted: true,
	          markAsNotCompleted: false
	        }) : this.setState({
	          change_status: !this.state.change_status,
	          change_case_no: item.case_number,
	          change_completion_status: item.completionStatus,
	          markAsNotCompleted: true,
	          markAsCompleted: false
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      // console.log('markCompleted')
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      // console.log('markNotCompleted')
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      // console.log('changeCompletionStatus working')
	      if (this.state.markAsCompleted === true) {
	        // console.log('Mark as completed')
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.change_case_no,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.selectedmenu,
	          chapter_id: this.state.chapterid
	        };
	        // console.log(data)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.message)
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              chapter_id: _this3.state.chapterid,
	              subscriptionstatus: _this3.state.subscriptionstatus
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasessubs', data).then(function (resp) {
	              // console.log(resp);
	              if (resp.success) {
	                _this3.setState({
	                  ValidToken: true,
	                  readings: resp.readings,
	                  change_status: false
	                });
	                if (!resp.readings.length) {
	                  _this3.setState({ no_result_display: 'No Saved Questions' });
	                }
	              } else {
	                _this3.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      } else {
	        // console.log('Mark as Un-Completed')
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.change_case_no,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.selectedmenu,
	          chapter_id: this.state.chapterid
	        };
	        // console.log(data)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.message)
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              chapter_id: _this3.state.chapterid,
	              subscriptionstatus: _this3.state.subscriptionstatus
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasessubs', data).then(function (resp) {
	              // console.log(resp);
	              if (resp.success) {
	                _this3.setState({ ValidToken: true });
	                _this3.setState({ readings: resp.readings, change_status: false });
	                if (!resp.readings.length) {
	                  _this3.setState({ no_result_display: 'No Saved Questions' });
	                }
	              } else {
	                _this3.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      }
	    }
	
	    //Function to redirect page to question bank page
	
	  }, {
	    key: 'togglePremiumAlert',
	    value: function togglePremiumAlert() {
	      this.setState({
	        premiumAlertStatus: !this.state.premiumAlertStatus
	      });
	    }
	
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var final_exam = [];
	      var user_data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
	      _userStore2.default.getUserProfile(true).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this4.setState({ subscriptionstatus: 'free' });
	            _this4._runCode('free');
	          } else {
	            _this4.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                  while (1) {
	                    switch (_context9.prev = _context9.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context9.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this4.state.selectedmenu;
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context9.next = 7;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context9.sent;
	
	                        if (isInArray_var) {
	                          _this4.setState({ subscriptionstatus: 'paid' });
	                          _this4._runCode('paid');
	                        } else {
	                          _this4.setState({ subscriptionstatus: 'free' });
	                          _this4._runCode('free');
	                        }
	                        _context9.next = 11;
	                        break;
	
	                      case 11:
	                      case 'end':
	                        return _context9.stop();
	                    }
	                  }
	                }, _callee9, _this4);
	              }));
	
	              return function (_x9) {
	                return _ref9.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this4.setState({ subscriptionstatus: 'free' });
	            _this4._runCode('free');
	          } else {
	            _this4.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this4.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this4.setState({ subscriptionstatus: 'paid' });
	                  _this4._runCode('paid');
	                } else {
	                  _this4.setState({ subscriptionstatus: 'free' });
	                  _this4._runCode('free');
	                }
	              } else {}
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        chapter_id: this.state.chapterid,
	        subscriptionstatus: subscriptionstatus
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasessubs', data).then(function (resp) {
	        // console.log(resp);
	        if (resp.success) {
	          _this5.setState({ ValidToken: true });
	          _this5.setState({ readings: resp.readings });
	          if (!resp.readings.length) {
	            _this5.setState({ no_result_display: 'No Saved Questions' });
	          }
	        } else {
	          _this5.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	    /*
	    --------------------------------
	    PDF DOWNLOAD Via email Answer
	    --------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      // console.log(this.state.readings)
	      // console.log(this.state.readings[1])
	      var _state = this.state,
	          subscriptionstatus = _state.subscriptionstatus,
	          premiumAlertStatus = _state.premiumAlertStatus;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              /*item.case_number*/index + 1,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.case_name_2025
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              subscriptionstatus === 'free' && item.free == 0 ? _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/subsciption-dark.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, item, index),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().UPGRADE_ACCOUNT
	                )
	              ) : _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, item, index),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CASES
	                )
	              )
	            ),
	            subscriptionstatus === 'free' && item.free == 0 ? null : readings[index].completionStatus === null || readings[index].completionStatus === false || readings[index].completionStatus === 0 ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  ' ',
	                  _language2.default.LC().NOT_COMPLETED
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this6.toggleAlertChangeStatus.bind(_this6, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  _language2.default.LC().COMPLETED,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this6.toggleAlertChangeStatus.bind(_this6, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.chapter_name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Q_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: this.getpdfAnswer.bind(this),
	                className: 'status-download-btn margin_right_10'
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right max-width-200' },
	                this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoadingAnswer ? _language2.default.LC().Download_QA_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              ' ',
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CASE_STUDIES,
	                ' - ',
	                this.props.params.chapter_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0 case-study-heading-wrap' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          ' ',
	                          _language2.default.LC().CASE_NAME,
	                          ' '
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'action-heading' },
	                          _language2.default.LC().ACTION
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'status-heading' },
	                          _language2.default.LC().STATUS
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex flex-column' },
	              _react2.default.createElement(
	                'div',
	                null,
	                ' ',
	                this.state.MessageContent
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-right' },
	                ' ',
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { color: 'primary', onClick: this.toggleAlert },
	                  ' ',
	                  _language2.default.LC().OK,
	                  ' '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.change_status,
	            toggle: this.toggleAlertChangeStatus,
	            className: 'modal-primary complete-or-not-model ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlertChangeStatus },
	            this.state.changeStatusTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block card-padding' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue_status'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.togglePremiumAlert.bind(this),
	          alert_status: premiumAlertStatus,
	          MessageContent: _alertMessage2.default.messageContent_cfa_2,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Cfa22023cases;
	}(_react.Component);
	
	Cfa22023cases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa22023cases;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _cfa2QuestionNumbering = __webpack_require__(258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	// import StarRatings from 'react-star-ratings';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	// import GD from '../../RestAPI/getData';
	
	
	/* eslint-disable*/
	var Cfa22023chapter = function (_Component) {
	  _inherits(Cfa22023chapter, _Component);
	
	  function Cfa22023chapter(props) {
	    var _this$state4;
	
	    _classCallCheck(this, Cfa22023chapter);
	
	    var _this = _possibleConstructorReturn(this, (Cfa22023chapter.__proto__ || Object.getPrototypeOf(Cfa22023chapter)).call(this, props));
	
	    _this.tick = function () {
	      if (!_this.state.timer_stop) {
	        _this.setState(function (prevState) {
	          return {
	            count: prevState.count + 1
	          };
	        });
	      }
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES.replace(':id', _this.props.params.chapterid).replace(':chapter_name', _this.state.chaptername)
	        // `/cfa2_cases/${this.props.params.chapterid}/${
	        //   this.state.chaptername
	        // }`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.state.chapters,
	        // },
	      });
	    };
	
	    _this._getAnswer = function (choice, e) {
	      var currentQuestionId = _this.state.questions.id;
	      var selectedChoice = choice[0];
	
	      var choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d', 'choice_e'];
	      var updatedChoices = {};
	
	      choiceKeys.forEach(function (key) {
	        updatedChoices[key] = selectedChoice === key ? 'answer_box clicked_box' : 'answer_box';
	      });
	
	      _this.setState(Object.assign({
	        selectedChoice: selectedChoice,
	        setAnswer: true,
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false
	      }, updatedChoices), function () {
	        var currentAttempts = _this.state.attemptedQuestions || {};
	        var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	          selectedChoice: selectedChoice,
	          isAnswered: false,
	          setAnswer: true
	        }));
	
	        _this.setState({ attemptedQuestions: updatedAttempts });
	      });
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this.getResult = function (item, e) {
	      var _this$state = _this.state,
	          selectedChoice = _this$state.selectedChoice,
	          timer = _this$state.timer,
	          count = _this$state.count,
	          attemptedQuestions = _this$state.attemptedQuestions,
	          validated = _this$state.validated,
	          token = _this$state.token,
	          idname = _this$state.idname;
	
	      if (selectedChoice) {
	        if (timer) {
	          clearInterval(timer);
	          _this.timer = null;
	        }
	
	        var currentQuestionId = item.id;
	        var correctChoiceKey = item['answer'];
	        var isCorrect = selectedChoice === 'choice_' + correctChoiceKey;
	        var timeDone = item["cfa2_2027_question_stats.time_done"] || count;
	
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play',
	          setAnswer: true,
	          clicked: true,
	          showAnswer: true,
	          stopTimer: true,
	          result_block: 'card show_block',
	          result: isCorrect ? 'CORRECT' : 'INCORRECT',
	          text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
	        }, function () {
	          var currentAttempts = attemptedQuestions || {};
	          var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	            selectedChoice: selectedChoice,
	            isAnswered: true,
	            isCorrect: isCorrect,
	            setAnswer: true,
	            timeSpent: timeDone
	          }));
	
	          _this.setState({ attemptedQuestions: updatedAttempts });
	
	          if (!validated) {
	            var data = {
	              token: token,
	              idname: idname,
	              question_id: currentQuestionId,
	              right_answer: isCorrect ? 1 : 0,
	              time_done: timeDone,
	              selected_choice: selectedChoice,
	              // Backend saveStats stores caseIndex on the last-answered record; it was never sent, so
	              // "Go to my Last Answered Question" built /…/null/… with an empty case name.
	              caseIndex: _this.props.params.case_offset
	            };
	
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveStats', data).then(function (resp) {
	              if (resp.success) {
	                _this.setState({ ValidToken: true, validated: true });
	              } else {
	                _this.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      } else {
	        _this.setState({
	          result_block: 'card hide_block'
	        });
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.clicked || _this.state.validated) {
	        return;
	      }
	      if (_this.state.timer_stop) {
	        _this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick, 1000);
	      } else {
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        clearInterval(_this.timer);
	        _this.timer = null;
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid
	      };
	      if (_this.state.bookmarkCSS == 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashcards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getNext = function () {
	      var _this$state2 = _this.state,
	          offset = _this$state2.offset,
	          all_questions_state = _this$state2.all_questions_state;
	
	      if (offset < all_questions_state.length - 1) {
	        var nextOffset = offset + 1;
	        var nextQuestion = all_questions_state[nextOffset];
	
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	
	        _this.setState({
	          offset: nextOffset,
	          display_loader: 'show_block',
	          validated: false,
	          clicked: false,
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          result_block: 'card hide_block'
	        });
	
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          question_id: nextQuestion.id
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getQuestionsbyid', data).then(function (resp) {
	          if (resp.success) {
	            var currentQuestion = resp.questionsbyid;
	            var selectedChoice = currentQuestion["cfa2_2027_question_stats.selected_choice"] || '';
	            var rightAnswer = currentQuestion["cfa2_2027_question_stats.right_answer"] || '';
	            var answerStatus = currentQuestion["cfa2_2027_question_stats.id"] || '';
	            var timeDone = currentQuestion["cfa2_2027_question_stats.time_done"] || 0;
	            var correctChoiceKey = 'answer';
	
	            var _this$determineSelect = _this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                selected = _this$determineSelect.selected,
	                showAnswer = _this$determineSelect.showAnswer;
	
	            _this.updateTimerState(selected, timeDone);
	
	            var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	            var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	              var isSelected = selected === choice;
	              var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	              acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : 'answer_box';
	              return acc;
	            }, {});
	
	            _this.setState(Object.assign({
	              questions: currentQuestion,
	              selectedChoice: selected,
	              clicked: !!selected
	            }, choiceBoxStates, {
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	              display_loader: 'hide_block'
	            }));
	
	            var favParams = Object.assign({}, data, {
	              chapter_id: _this.props.params.chapterid
	            });
	            var flashParams = Object.assign({}, data);
	
	            Promise.all([_fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', favParams), _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashcards', flashParams)]).then(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  favResp = _ref2[0],
	                  flashResp = _ref2[1];
	
	              var isSavedQuestion = favResp.success;
	              var hasFlash = flashResp.success && flashResp.flash_cards && flashResp.flash_cards.length > 0;
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: isSavedQuestion ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: isSavedQuestion ? 'rgb(54, 141, 84)' : '',
	                save_text: isSavedQuestion ? '' + _language2.default.LC().Question_Saved : '' + _language2.default.LC().SAVE_QUESTION,
	                isFlashCardHidden: !isSavedQuestion
	              });
	              if (hasFlash) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                  flash_data: flashResp.flash_cards.map(function (items, index) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    );
	                  })
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  )
	                });
	              }
	            });
	          }
	        });
	      } else {
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	        _this.setState({
	          showCompletionQuestion: true,
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	      }
	    };
	
	    _this.getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getPrevious = function () {
	      var _this$state3 = _this.state,
	          offset = _this$state3.offset,
	          all_questions_state = _this$state3.all_questions_state;
	
	
	      if (offset > 0) {
	        var prevOffset = offset - 1;
	        var prevQuestion = all_questions_state[prevOffset];
	
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	
	        _this.setState({
	          offset: prevOffset,
	          display_loader: 'show_block',
	          validated: false,
	          clicked: false,
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          result_block: 'card hide_block'
	        });
	
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          question_id: prevQuestion.id
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getQuestionsbyid', data).then(function (resp) {
	          if (resp.success) {
	            var currentQuestion = resp.questionsbyid;
	            var selectedChoice = currentQuestion["cfa2_2027_question_stats.selected_choice"] || '';
	            var rightAnswer = currentQuestion["cfa2_2027_question_stats.right_answer"] || '';
	            var answerStatus = currentQuestion["cfa2_2027_question_stats.id"] || '';
	            var timeDone = currentQuestion["cfa2_2027_question_stats.time_done"] || 0;
	            var correctChoiceKey = 'answer';
	
	            var _this$determineSelect2 = _this.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                selected = _this$determineSelect2.selected,
	                showAnswer = _this$determineSelect2.showAnswer;
	
	            _this.updateTimerState(selected, timeDone);
	
	            var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	            var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	              var isSelected = selected === choice;
	              var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	              acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : 'answer_box';
	              return acc;
	            }, {});
	
	            _this.setState(Object.assign({
	              questions: currentQuestion,
	              selectedChoice: selected,
	              clicked: !!selected
	            }, choiceBoxStates, {
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	              display_loader: 'hide_block'
	            }));
	
	            var favParams = Object.assign({}, data, {
	              chapter_id: _this.props.params.chapterid
	            });
	            var flashParams = Object.assign({}, data);
	            Promise.all([_fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', favParams), _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashcards', flashParams)]).then(function (_ref3) {
	              var _ref4 = _slicedToArray(_ref3, 2),
	                  favResp = _ref4[0],
	                  flashResp = _ref4[1];
	
	              var isSavedQuestion = favResp.success;
	              var hasFlash = flashResp.success && flashResp.flash_cards && flashResp.flash_cards.length > 0;
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: isSavedQuestion ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: isSavedQuestion ? 'rgb(54, 141, 84)' : '',
	                save_text: isSavedQuestion ? '' + _language2.default.LC().Question_Saved : '' + _language2.default.LC().SAVE_QUESTION,
	                isFlashCardHidden: !isSavedQuestion
	              });
	              if (hasFlash) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                  flash_data: flashResp.flash_cards.map(function (items, index) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    );
	                  })
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  )
	                });
	              }
	            });
	          }
	        });
	      }
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block'
	      });
	      _this.setState({ clicked: false });
	      var casesoffset = parseInt(_this.state.cases_offset) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({ cases_offset: casesoffset });
	        caseid = _this.state.all_cases[casesoffset].id;
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':question_number', 1).replace(':offset', 0)
	        });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', 0).replace(':question_number', 1).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block'
	      });
	      _this.setState({ clicked: false });
	      if (_this.state.cases_offset == 0) {
	        var casesoffset = _this.state.cases_length - 1;
	        var caseid = _this.state.all_cases[casesoffset].id;
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':question_number', 1).replace(':offset', 0)
	        });
	      } else {
	        var _casesoffset = _this.state.cases_offset - 1;
	        var caseid = _this.state.all_cases[_casesoffset].id;
	        _this.setState({ cases_offset: _casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA2_2027_QUESTION_BANK_CASES_QUESTION.replace(':chapterid', _this.props.params.chapterid).replace(':caseid', caseid).replace(':case_offset', _casesoffset).replace(':question_number', 1).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.state = (_this$state4 = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: 'Stop'
	    }, _defineProperty(_this$state4, 'timerstopbtn', 'pause_btn icon-control-pause'), _defineProperty(_this$state4, 'chaptername', ''), _defineProperty(_this$state4, 'caseid', _this.props.params.caseid), _defineProperty(_this$state4, 'all_cases', []), _defineProperty(_this$state4, 'cases_display', ''), _defineProperty(_this$state4, 'cases_name', ''), _defineProperty(_this$state4, 'isFlashCardHidden', true), _defineProperty(_this$state4, 'cases_length', ''), _defineProperty(_this$state4, 'case_id', ''), _defineProperty(_this$state4, 'cases_offset', ''), _defineProperty(_this$state4, 'casesquestion_length', ''), _defineProperty(_this$state4, 'chapters', ''), _defineProperty(_this$state4, 'display_loader', ''), _defineProperty(_this$state4, 'selectedmenu', 'cfa_2'), _defineProperty(_this$state4, 'subscriptionstatus', ''), _defineProperty(_this$state4, 'display_subcription', 'hide_block'), _defineProperty(_this$state4, 'display_cases', 'show_block'), _defineProperty(_this$state4, 'showCompletionQuestion', false), _defineProperty(_this$state4, 'markAsCompleted', false), _defineProperty(_this$state4, 'markAsNotCompleted', false), _defineProperty(_this$state4, 'markCompleted', true), _defineProperty(_this$state4, 'cases', []), _defineProperty(_this$state4, 'exam_type', 'cfa_2'), _defineProperty(_this$state4, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state4, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state4, 'forumComment', ''), _defineProperty(_this$state4, 'category', 'CFA Level 2 2023'), _defineProperty(_this$state4, 'tags', ['cfa-2-2023', 'cfa', 'question', 'case']), _defineProperty(_this$state4, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state4, 'user_city', ''), _defineProperty(_this$state4, 'user_country', ''), _defineProperty(_this$state4, 'user_ip', ''), _defineProperty(_this$state4, 'user_state', ''), _defineProperty(_this$state4, 'user_continent', ''), _defineProperty(_this$state4, 'selectedChoice', ''), _defineProperty(_this$state4, 'timeDone', 0), _this$state4);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.timerValue = 0;
	    return _this;
	  }
	
	  _createClass(Cfa22023chapter, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var storage_session, result, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                });
	                _context2.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context2.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({
	                  case_id: this.props.params.caseid,
	                  display_cases: 'hide_block'
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  caseid: this.props.params.caseid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesbyId', data).then(function (resp_cases) {
	                  _this2.setState({ cases: resp_cases });
	                  if (resp_cases.success) {
	                    var data = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    };
	                    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	                    _userStore2.default.getUserProfile(true).then(function (resp) {
	                      var free_status = '';
	
	                      if (resp.profileInfo.role === 'partner') {
	                        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                          free_status = 'free';
	                          _this2.setState({ subscriptionstatus: 'free' });
	                          if (resp_cases.casesingleData.free == 0) {
	                            _this2.setState({
	                              display_cases: 'hide_block',
	                              display_subcription: 'show_block'
	                            });
	                            _this2.toggleAlert();
	                          } else {
	                            _this2.setState({
	                              display_cases: 'show_block',
	                              display_subcription: 'hide_block'
	                            });
	                          }
	                        } else {
	                          _this2.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          var dataset = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            examid: data_arr
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, examPlanData;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 9;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this2.state.selectedmenu;
	                                      isInArray_var = false;
	                                      examPlanData = resp_exam.examPlan[0];
	                                      _context.next = 7;
	                                      return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                    case 7:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        _this2.setState({
	                                          subscriptionstatus: 'paid',
	                                          display_cases: 'show_block',
	                                          display_subcription: 'hide_block'
	                                        });
	                                      } else {
	                                        if (resp_cases.casesingleData.free == 0) {
	                                          _this2.setState({
	                                            display_cases: 'hide_block',
	                                            display_subcription: 'show_block'
	                                          });
	                                        } else {
	                                          _this2.setState({
	                                            subscriptionstatus: 'free',
	                                            display_cases: 'show_block',
	                                            display_subcription: 'hide_block'
	                                          });
	                                        }
	                                      }
	
	                                    case 9:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this2);
	                            }));
	
	                            return function (_x) {
	                              return _ref6.apply(this, arguments);
	                            };
	                          }());
	                        }
	                      } else {
	                        if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                          free_status = 'free';
	                          _this2.setState({ subscriptionstatus: 'free' });
	                          if (resp_cases.casesingleData.free == 0) {
	                            _this2.setState({
	                              display_cases: 'hide_block',
	                              display_subcription: 'show_block'
	                            });
	                            _this2.toggleAlert();
	                          } else {
	                            _this2.setState({
	                              display_cases: 'show_block',
	                              display_subcription: 'hide_block'
	                            });
	                          }
	                        } else {
	                          _this2.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          var dataset = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            examid: data_arr
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this2.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                              if (isInArray_var) {
	                                _this2.setState({
	                                  subscriptionstatus: 'paid',
	                                  display_cases: 'show_block',
	                                  display_subcription: 'hide_block'
	                                });
	                              } else {
	                                if (resp_cases.casesingleData.free == 0) {
	                                  _this2.setState({
	                                    display_cases: 'hide_block',
	                                    display_subcription: 'show_block'
	                                  });
	                                } else {
	                                  _this2.setState({
	                                    subscriptionstatus: 'free',
	                                    display_cases: 'show_block',
	                                    display_subcription: 'hide_block'
	                                  });
	                                }
	                              }
	                            }
	                          });
	                        }
	                      }
	                    });
	                  }
	                });
	                // });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter_id: this.props.params.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChaptersbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      chaptername: resp.chapterdata.chapter_name,
	                      chapters: resp.chapterdata
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCases', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      ValidToken: true,
	                      all_cases: resp.readings,
	                      cases_length: resp.readings.length
	                    });
	                    for (var i = 0; i < resp.readings.length; i++) {
	                      if (_this2.props.params.case_offset == i) {
	                        _this2.setState({
	                          cases_offset: _this2.props.params.case_offset,
	                          cases_display: resp.readings[i].case,
	                          cases_name: resp.readings[i].case_name_2025
	                        });
	                      }
	                    }
	                    var param = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname'],
	                      case_id: _this2.state.case_id
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesquestion', param).then(function (resp_question) {
	                      if (resp_question.success) {
	                        _this2.setState({
	                          casesquestion_length: resp_question.questions_details.length
	                        });
	                        if (resp_question.questions_details.length > 0) {
	                          var wantedNumber = (0, _cfa2QuestionNumbering.resolveQuestionNumber)(resp_question.questions_details, _this2.props.params.question_number);
	                          var offset_res = '';
	                          var questionid = '';
	                          for (var i = 0; i < resp_question.questions_details.length; i++) {
	                            if (resp_question.questions_details[i].question_number == wantedNumber) {
	                              (function () {
	                                offset_res = i;
	                                questionid = resp_question.questions_details[i].id;
	                                var currentQuestion = resp_question.questions_details[i];
	                                var selectedChoice = currentQuestion["cfa2_2027_question_stats.selected_choice"] || '';
	                                var rightAnswer = currentQuestion["cfa2_2027_question_stats.right_answer"] || '';
	                                var answerStatus = currentQuestion["cfa2_2027_question_stats.id"] || '';
	                                var timeDone = currentQuestion["cfa2_2027_question_stats.time_done"] || 0;
	                                var correctChoiceKey = 'answer';
	
	                                var _determineSelectedAnd = _this2.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                                    selected = _determineSelectedAnd.selected,
	                                    showAnswer = _determineSelectedAnd.showAnswer;
	
	                                _this2.updateTimerState(selected, timeDone);
	
	                                var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	                                var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	                                  var isSelected = selected === choice;
	                                  var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	                                  acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : isCorrect ? 'answer_box success' : 'answer_box';
	                                  return acc;
	                                }, {});
	
	                                _this2.setState(Object.assign({
	                                  questions: currentQuestion,
	                                  selectedChoice: selected,
	                                  clicked: !!selected
	                                }, choiceBoxStates, {
	                                  result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                                  text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	                                  result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	                                  display_loader: 'hide_block'
	                                }));
	                                _this2.handleTimerResponse(selected);
	                              })();
	                            }
	                          }
	                          _this2.setState({
	                            offset: offset_res,
	                            all_questions_state: resp_question.questions_details
	                          });
	
	                          var params_fav = {
	                            token: storage_session['token'],
	                            question_id: questionid,
	                            idname: storage_session['idname'],
	                            chapter_id: _this2.props.params.chapterid
	                          };
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({
	                                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                                bookmarkColor: 'rgb(54, 141, 84)',
	                                save_text: '' + _language2.default.LC().Question_Saved,
	                                isFlashCardHidden: false
	                              });
	                            } else {
	                              _this2.setState({ isFlashCardHidden: true });
	                            }
	                          });
	
	                          var params = {
	                            token: storage_session['token'],
	                            question_id: questionid,
	                            idname: storage_session['idname']
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ rated: true });
	                              response.ratting.map(function (items) {
	                                _this2.setState({
	                                  rating: items.ratting,
	                                  ratting_text: 'Rated '
	                                });
	                              });
	                            }
	                          });
	
	                          var params = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            question_id: questionid
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashcards', params).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ ValidToken: true });
	                              if (response.flash_cards.length > 0) {
	                                _this2.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                });
	                                var flash_cards = response.flash_cards.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: '' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'icon_list' },
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            { className: 'pointer_class', onClick: _this2._editFlash.bind(_this2, items) },
	                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this2._deleteFlash.bind(_this2, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: _this2.state.flash_class },
	                                        _react2.default.createElement('h4', null),
	                                        _react2.default.createElement(
	                                          'p',
	                                          null,
	                                          items.flash_card
	                                        )
	                                      )
	                                    )
	                                  );
	                                });
	                              } else {
	                                _this2.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                              }
	                              _this2.setState({ flash_data: flash_cards });
	                            } else {
	                              var flash_cards = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_FLASHCARD_FOUND
	                              );
	                              _this2.setState({
	                                ValidToken: false,
	                                flash_data: flash_cards,
	                                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                              });
	                            }
	                            return response;
	                          });
	
	                          _this2.setState({ records: '' });
	                        }
	                      }
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false, records: 'Result not found.' });
	                  }
	                  _this2.setState({ display_loader: 'hide_block' });
	                  clearInterval(_this2.timer);
	                  _this2.timer = setInterval(_this2.tick, 1000);
	                  return resp;
	                }).catch(function (err) {
	                  _this2.setState({ display_loader: 'hide_block' });
	                });
	
	                this.timer = setInterval(this.tick, 1000);
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      if (this.state.markAsCompleted == true) {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.cases.casesingleData.case_number,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.exam_type,
	          chapter_id: this.props.params.chapterid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this3._getReadings();
	          }
	        });
	      } else {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.cases.casesingleData.case_number,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.exam_type,
	          chapter_id: this.props.params.chapterid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this3._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to readings page
	    -------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue != nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/UpdateCfaRatting', params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            var params = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveCfaratting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this4.state.token,
	            idname: _this4.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveCfaratting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	      */
	
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to Edit Flash card
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	       Function to delete flash card
	    --------------------------------------
	    */
	
	  }, {
	    key: 'handleTimerResponse',
	    value: function handleTimerResponse(selectedChoice) {
	      if (selectedChoice) {
	        clearInterval(this.timer);
	        this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	      } else {
	        this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        clearInterval(this.timer);
	        this.timer = setInterval(this.tick, 1000);
	      }
	    }
	  }, {
	    key: 'updateTimerState',
	
	
	    // Helper to update timer state based on whether a question is selected
	    value: function updateTimerState(isSelected) {
	      var timeDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (isSelected) {
	        clearInterval(this.timer);
	        this.timer = null;
	        this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play',
	          count: timeDone
	        });
	      } else {
	        if (this.timer) clearInterval(this.timer);
	        this.timer = setInterval(this.tick, 1000);
	        this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause',
	          count: 0
	        });
	      }
	    }
	  }, {
	    key: 'determineSelectedAndShowAnswer',
	    value: function determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey) {
	      var selected = '';
	      var showAnswer = false;
	      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_2);
	      if (selectedChoice && isRevisionMode) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (answerStatus && isRevisionMode) {
	        if (rightAnswer === 1) {
	          selected = 'choice_' + currentQuestion[correctChoiceKey];
	          showAnswer = true;
	        } else if (!rightAnswer) {
	          var correct = currentQuestion[correctChoiceKey];
	          var choices = Object.keys(currentQuestion).filter(function (key) {
	            return key.startsWith('choice') && key !== 'choice_' + correct;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	      return { selected: selected, showAnswer: showAnswer };
	    }
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      this.setState({ case_id: caseid });
	      var data = { token: token_id, idname: idname, chapter_id: chapterid };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChaptersbyID', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            chaptername: resp.chapterdata.chapter_name,
	            chapters: resp.chapterdata
	          });
	        } else {
	          _this5.setState({ ValidToken: false });
	        }
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCases', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            all_cases: resp.readings
	          });
	          for (var i = 0; i < resp.readings.length; i++) {
	            if (_this5.props.params.case_offset == i) {
	              _this5.setState({
	                cases_display: resp.readings[i].case,
	                cases_name: resp.readings[i].case_name_2025
	              });
	            }
	          }
	          _this5.setState({ display_loader: 'hide_block' });
	          var param = { token: token_id, idname: idname, case_id: caseid };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this5.setState({
	                casesquestion_length: resp_question.questions_details.length
	              });
	              if (resp_question.questions_details.length > 0) {
	                //let ques_res=[];
	                var wantedNumber = (0, _cfa2QuestionNumbering.resolveQuestionNumber)(resp_question.questions_details, question_number);
	                var offset_res = '';
	                var questionid = '';
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  if (resp_question.questions_details[i].question_number == wantedNumber) {
	                    offset_res = i;
	                    questionid = resp_question.questions_details[i].id;
	                    _this5.setState({
	                      questions: resp_question.questions_details[i]
	                    });
	                  }
	                }
	                _this5.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details
	                });
	
	                //Api to Fetch saved question stats
	                var params_fav = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid,
	                  chapter_id: chapterid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      save_text: '' + _language2.default.LC().Question_Saved,
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this5.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to get ratting
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({ rated: true });
	                    response.ratting.map(function (items) {
	                      _this5.setState({
	                        rating: items.ratting,
	                        ratting_text: 'Rated '
	                      });
	                    });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to fetch flashcard by question id
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashCards', params).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this5.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      var flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this5._editFlash.bind(_this5, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this5._deleteFlash.bind(_this5, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this5.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this5.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      var flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this5.setState({ flash_data: flash_cards });
	                  } else {
	                    var flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this5.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                  return response;
	                });
	
	                _this5.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this5.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this5.timer);
	        _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax
	
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this6 = this;
	
	      var data = { token: token_id, idname: idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        var data = {
	          token: token_id,
	          idname: idname,
	          caseid: _this6.props.params.caseid
	        };
	        // var final_exam = [];
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesbyId', data).then(function (resp_cases) {
	          if (resp_cases.success) {
	            var data = { token: token_id, idname: idname };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	              var free_status = '';
	              if (resp.profileInfo.role === 'partner') {
	                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                  free_status = 'free';
	                  _this6.setState({ subscriptionstatus: 'free' });
	                  if (resp_cases.casesingleData.free === 0) {
	                    _this6.setState({
	                      display_cases: 'hide_block',
	                      display_subcription: 'show_block'
	                    });
	                    _this6.toggleAlert();
	                  } else {
	                    _this6.setState({
	                      display_cases: 'show_block',
	                      display_subcription: 'hide_block'
	                    });
	                  }
	                } else {
	                  _this6.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  var dataset = {
	                    token: token_id,
	                    idname: idname,
	                    examid: data_arr
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var, examPlanData;
	                      return _regenerator2.default.wrap(function _callee3$(_context3) {
	                        while (1) {
	                          switch (_context3.prev = _context3.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context3.next = 11;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this6.state.selectedmenu;
	                              isInArray_var = false;
	                              // #261 — pass examPlanData so mock-only partners hit
	                              // the early-return false (was missing here).
	
	                              examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                              _context3.next = 7;
	                              return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this6.state.cfaUnlimitedPackage, _this6.state.cfaUnlimitedActiveExam, examPlanData);
	
	                            case 7:
	                              isInArray_var = _context3.sent;
	
	                              if (isInArray_var) {
	                                _this6.setState({
	                                  display_cases: 'show_block',
	                                  display_subcription: 'hide_block'
	                                });
	                              } else {
	                                if (resp_cases.casesingleData.free == 0) {
	                                  _this6.setState({
	                                    display_cases: 'hide_block',
	                                    display_subcription: 'show_block'
	                                  });
	                                } else {
	                                  _this6.setState({
	                                    display_cases: 'show_block',
	                                    display_subcription: 'hide_block'
	                                  });
	                                }
	                              }
	                              _context3.next = 12;
	                              break;
	
	                            case 11:
	                              console.log('fail');
	
	                            case 12:
	                            case 'end':
	                              return _context3.stop();
	                          }
	                        }
	                      }, _callee3, _this6);
	                    }));
	
	                    return function (_x3) {
	                      return _ref7.apply(this, arguments);
	                    };
	                  }());
	                }
	              } else {
	                if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                  free_status = 'free';
	                  //here code for check case id free or not
	                  _this6.setState({ subscriptionstatus: 'free' });
	                  if (resp_cases.casesingleData.free === 0) {
	                    _this6.setState({
	                      display_cases: 'hide_block',
	                      display_subcription: 'show_block'
	                    });
	                    _this6.toggleAlert();
	                  } else {
	                    _this6.setState({
	                      display_cases: 'show_block',
	                      display_subcription: 'hide_block'
	                    });
	                  }
	                } else {
	                  _this6.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  var dataset = {
	                    token: token_id,
	                    idname: idname,
	                    examid: data_arr
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                    if (resp_exam.success) {
	                      var exam_data = resp_exam.examData;
	                      var selectedmen = _this6.state.selectedmenu;
	                      var isInArray_var = false;
	                      isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this6.state.cfaUnlimitedPackage, _this6.state.cfaUnlimitedActiveExam);
	                      if (isInArray_var) {
	                        _this6.setState({
	                          display_cases: 'show_block',
	                          display_subcription: 'hide_block'
	                        });
	                      } else {
	                        if (resp_cases.casesingleData.free == 0) {
	                          _this6.setState({
	                            display_cases: 'hide_block',
	                            display_subcription: 'show_block'
	                          });
	                        } else {
	                          _this6.setState({
	                            display_cases: 'show_block',
	                            display_subcription: 'hide_block'
	                          });
	                        }
	                      }
	                    } else {
	                      console.log('fail');
	                    }
	                  });
	                }
	              }
	            });
	          } else {
	            console.log('Cases not avilable');
	          }
	        });
	      });
	
	      this.setState({ case_id: caseid });
	      var data = { token: token_id, idname: idname, chapter_id: chapterid };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChaptersbyID', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            chaptername: resp.chapterdata.chapter_name,
	            chapters: resp.chapterdata
	          });
	        } else {
	          _this6.setState({ ValidToken: false });
	        }
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCases', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block'
	          });
	          document && document.getElementById('comment') && document.getElementById('comment') && document.getElementById('comment').value ? document.getElementById('comment').value = '' : null;
	
	          _this6.setState({ all_cases: resp.readings });
	          for (var i = 0; i < resp.readings.length; i++) {
	            if (_this6.props.params.case_offset == i) {
	              _this6.setState({
	                cases_display: resp.readings[i].case,
	                cases_name: resp.readings[i].case_name_2025
	              });
	            }
	          }
	          _this6.setState({ display_loader: 'hide_block' });
	          var param = { token: token_id, idname: idname, case_id: caseid };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this6.setState({
	                casesquestion_length: resp_question.questions_details.length
	              });
	              if (resp_question.questions_details.length > 0) {
	                var wantedNumber = (0, _cfa2QuestionNumbering.resolveQuestionNumber)(resp_question.questions_details, question_number);
	                var offset_res = '';
	                var questionid = '';
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  if (resp_question.questions_details[i].question_number == wantedNumber) {
	                    (function () {
	                      offset_res = i;
	                      questionid = resp_question.questions_details[i].id;
	                      // Use determineSelectedAndShowAnswer for answer state
	                      var currentQuestion = resp_question.questions_details[i];
	                      var selectedChoice = currentQuestion["cfa2_2027_question_stats.selected_choice"] || '';
	                      var rightAnswer = currentQuestion["cfa2_2027_question_stats.right_answer"] || '';
	                      var answerStatus = currentQuestion["cfa2_2027_question_stats.id"] || '';
	                      var timeDone = currentQuestion["cfa2_2027_question_stats.time_done"] || 0;
	                      var correctChoiceKey = 'answer';
	
	                      var _determineSelectedAnd2 = _this6.determineSelectedAndShowAnswer(currentQuestion, selectedChoice, answerStatus, rightAnswer, correctChoiceKey),
	                          selected = _determineSelectedAnd2.selected,
	                          showAnswer = _determineSelectedAnd2.showAnswer;
	
	                      _this6.updateTimerState(selected, timeDone);
	
	                      var choiceKeys = ['choice_a', 'choice_b', 'choice_c'];
	                      var choiceBoxStates = choiceKeys.reduce(function (acc, choice) {
	                        var isSelected = selected === choice;
	                        var isCorrect = 'choice_' + currentQuestion[correctChoiceKey] === choice;
	                        acc[choice] = isSelected ? isCorrect ? 'answer_box success' : 'answer_box failure' : isCorrect ? 'answer_box success' : 'answer_box';
	                        return acc;
	                      }, {});
	
	                      _this6.setState(Object.assign({
	                        questions: currentQuestion,
	                        selectedChoice: selected,
	                        clicked: !!selected
	                      }, choiceBoxStates, {
	                        result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                        text_color: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'card-header text_success' : 'card-header text_failure',
	                        result: selected === 'choice_' + currentQuestion[correctChoiceKey] ? 'CORRECT' : 'INCORRECT',
	                        display_loader: 'hide_block'
	                      }));
	                      _this6.handleTimerResponse(selected);
	                    })();
	                  }
	                }
	                _this6.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details
	                });
	                // ... rest of the code ...
	
	                //Api to Fetch saved question stats
	                var params_fav = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid,
	                  chapter_id: chapterid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({
	                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this6.setState({ isFlashCardHidden: true, bookmarkColor: '' });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to get ratting
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({ rated: true });
	                    response.ratting.map(function (items) {
	                      _this6.setState({
	                        rating: items.ratting,
	                        ratting_text: 'Rated '
	                      });
	                    });
	                  }
	                });
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                //Api to fetch flashcard by question id
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashCards', params).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      var flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this6._editFlash.bind(_this6, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this6._deleteFlash.bind(_this6, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      var flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    var flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                  return response;
	                });
	                _this6.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this6.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this6.timer);
	        _this6.timer = setInterval(_this6.tick.bind(_this6), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number != this.props.params.question_number && nextProps.params.caseid == this.props.params.caseid) {
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid != this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var questions_data_display = questions;
	
	      var reportLoading = this.state.reportLoading;
	
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	      var forumData = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var data = void 0,
	          question_data = '';
	      forumData = '<div class=\'col-sm-12 no-cursor\'>\n        <div class=\'margin_bottom_40\'>\n          <div>\n            <div class=\'row\'>\n              <div class=\'col-sm-12\'>\n                <div class=\'row no-cursor\'>\n                  <div class=\'col-sm-12 cursor-text\'>\n                    <div\n                      contentEditable=\'false\'\n                      class=\'margin_bottom_40 view_questionhtml bg_blue \'\n                    >                      \n                      ' + questions_data_display.question + '\n                    </div>\n                  </div>\n                  <div class=\'col-sm-12 no-cursor\' id=\'choice_a\'>\n                    <div class=\'answer_box_forum\'>\n                      <div class=\'answer_count\'>' + _language2.default.LC().A + '</div>\n                      <p class=\'ans_box_text\'>\n                        <span contentEditable=\'false\'>                          \n                          ' + questions_data_display.choice_a + '\n                        </span>\n                      </p>\n                    </div>\n                  </div>\n\n                  <div class=\'col-sm-12 no-cursor\' id=\'choice_b\'>\n                    <div class=\'answer_box_forum\'>\n                      <div class=\'answer_count\'>' + _language2.default.LC().B + '</div>\n                      <p class=\'ans_box_text\'>\n                        <span contentEditable=\'false\'>                          \n                          ' + questions_data_display.choice_b + '\n                        </span>\n                      </p>\n                    </div>\n                  </div>\n                  <div\n                    class=\'col-sm-12 margin_bottom_30 no-cursor\'\n                    id=\'choice_c\'\n                  >\n                    <div class=\'answer_box_forum\'>\n                      <div class=\'answer_count\'>' + _language2.default.LC().C + '</div>\n                      <p class=\'ans_box_text\'>\n                        <span contentEditable=\'false\'>\n                          ' + questions_data_display.choice_c + '\n                        </span>\n                      </p>\n                    </div>\n                  </div>\n                  <div class=\'col-sm-12 cursor-text\'>\n                    <p contentEditable=\'false\' class=\'view_questionhtml\'>\n                    The correct answer is  ' + (questions_data_display.answer === 'choice_a' ? '<strong> A.</strong>' : questions_data_display.answer === 'choice_b' ? '<strong> B.</strong>' : questions_data_display.answer === 'choice_c' ? '<strong> C.</strong>' : '<strong> C.</strong>') + ' <br/>\n                    ' + questions_data_display.explanation + '\n                    </p>\n                  </div>\n                  <div class=\'col-sm-12 margin_bottom_30 no-cursor\'>\n                    <div className=\'userQuestionDiv\'>\n                      <span className=\'questionColor cursor-text\'>                        \n                        *User Question:\n                      </span>\n                      <div className=\'forum-data-comment cursor-text\'>\n                        <h4> ' + this.state.forumComment + '</h4>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>';
	      data = _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12 col-md-12 note-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card note-section-header ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header title-font-size' },
	            this.state.cases_name,
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class',
	                onClick: this._getPreviousCase
	              }),
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class',
	                onClick: this._getNextCase
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block note_text_wrap ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 ' },
	                (0, _function.renderHTMLContent)(this.state.cases_display, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })
	              )
	            )
	          )
	        )
	      );
	
	      {
	        this.state.showCompletionQuestion ? question_data = _react2.default.createElement(
	          'div',
	          { className: 'w-100' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + this.state.display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 complete-section-wrap ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header text-center' },
	                _language2.default.LC().Mark_this_Question_as_Completed,
	                _react2.default.createElement(
	                  'div',
	                  { onClick: this.getNextAnyway, className: 'float-right text-right' },
	                  _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 text-center' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 ' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'quation-img' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                            className: 'margin_bottom_10',
	                            alt: ''
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            contentEditable: 'false',
	                            suppressContentEditableWarning: true,
	                            className: 'margin_bottom_10 view_questionhtml bg_blue'
	                          },
	                          ' ',
	                          _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'complete-or-not-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check-button-wrap' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              ' ',
	                              _language2.default.LC().COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_completed',
	                                name: 'mark_completed',
	                                value: 'select',
	                                onClick: this.markCompleted.bind(this),
	                                checked: this.state.markAsCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              _language2.default.LC().NOT_COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_not_completed',
	                                name: 'mark_not_completed',
	                                value: 'select',
	                                onClick: this.markNotCompleted.bind(this),
	                                checked: this.state.markAsNotCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'd-block text-center complete-quation-submit' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              disabled: this.state.markCompleted,
	                              onClick: this.changeCompletionStatus.bind(this),
	                              className: 'btn btn-primary pointer_class'
	                            },
	                            ' ',
	                            _language2.default.LC().SUBMIT,
	                            ' '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : question_data = _react2.default.createElement(
	          'div',
	          { className: 'note-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + this.state.display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card font-lusitana' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                  className: 'margin_right_20',
	                  alt: '',
	                  width: '30'
	                }),
	                _language2.default.LC().QUESTION,
	                ' ',
	                (0, _cfa2QuestionNumbering.questionDisplayNumber)(questions_data_display, this.state.offset) + ' - ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'float-right text-right' },
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-left ques_arrow pointer_class ',
	                    onClick: this.getPrevious
	                  }),
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-right ques_arrow pointer_class ',
	                    onClick: this.getNext
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9' },
	                    _react2.default.createElement(
	                      _ViewQuestion2.default,
	                      Object.assign({}, questions_data_display, this.props, {
	                        setAnswer: this._getAnswer,
	                        showAnswer: this.state.clicked,
	                        correctChoice: 'choice_' + questions_data_display.answer,
	                        selectedChoice: this.state.selectedChoice,
	                        onValidate: function onValidate() {
	                          return _this7.getResult(questions_data_display);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 12, className: 'mt-2' },
	                        _react2.default.createElement(
	                          _reactstrap.Row,
	                          { className: 'align-items-center' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'd-flex align-items-center' },
	                            _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                              isQue: true,
	                              _getResult: this.getResult,
	                              clicked: this.state.clicked,
	                              _saveQuestion: this._saveQuestion,
	                              _displayReportForm: this._displayReportForm,
	                              all_questions: questions_data_display,
	                              save_text: this.state.save_text,
	                              bookmarkCSS: this.state.bookmarkCSS,
	                              bookmarkColor: this.state.bookmarkColor,
	                              disabled: !this.state.selectedChoice || this.state.clicked
	                            })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'timer_outer' },
	                      _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'timer_box' },
	                        display_time
	                      )
	                    ),
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this._timer_funct.bind(this, questions_data_display)
	                    }),
	                    this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	                      'a',
	                      {
	                        onClick: this.getSubscribe,
	                        className: 'box_question_color text-center cursor_pointer'
	                      },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS,
	                        ' '
	                      )
	                    ) : ''
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.result_block + ' font-lusitana font-16px' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.text_color },
	                this.state.result
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                (0, _function.renderHTMLContent)(questions_data_display.explanation, "p", "view_questionhtml", { contentEditable: "false", suppressContentEditableWarning: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class margin_bottom_20 report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, questions_data_display)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10 margin_bottom_20',
	                            onClick: this._hideReportForm.bind(this, questions_data_display)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: questions,
	              type: 'question',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa_2_2027'
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row note-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head title-font-size' },
	              _language2.default.LC().CASE_STUDY,
	              ' - ',
	              this.state.chaptername
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_CASES
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          question_data
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        })
	      );
	    }
	  }]);
	
	  return Cfa22023chapter;
	}(_react.Component);
	
	Cfa22023chapter.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa22023chapter;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa2BeforeStart = function (_Component) {
	  _inherits(Cfa2BeforeStart, _Component);
	
	  function Cfa2BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2BeforeStart.__proto__ || Object.getPrototypeOf(Cfa2BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/cfa2/2027/quizzes',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuizpage = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              data = { token: _this.state.token, idname: _this.state.idname };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                if (resp.profileInfo.role === 'partner') {
	                  if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                    _this.toggleAlert();
	                  } else {
	                    _this.setState({
	                      cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                      cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                    });
	                    var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                    var dataset = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      examid: data_arr
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                        var exam_data, selectedmen, isInArray_var, examPlanData;
	                        return _regenerator2.default.wrap(function _callee$(_context) {
	                          while (1) {
	                            switch (_context.prev = _context.next) {
	                              case 0:
	                                if (!resp_exam.success) {
	                                  _context.next = 11;
	                                  break;
	                                }
	
	                                exam_data = resp_exam.examData;
	                                selectedmen = _this.state.selectedmenu;
	                                isInArray_var = false;
	                                examPlanData = resp_exam.examPlan[0];
	                                _context.next = 7;
	                                return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                              case 7:
	                                isInArray_var = _context.sent;
	
	                                if (isInArray_var) {
	                                  _this.context.router.push({
	                                    pathname: '/cfa2/2027/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send
	                                  });
	                                } else {
	                                  _this.toggleAlert();
	                                }
	                                _context.next = 12;
	                                break;
	
	                              case 11:
	                                console.log('fail');
	
	                              case 12:
	                              case 'end':
	                                return _context.stop();
	                            }
	                          }
	                        }, _callee, _this2);
	                      }));
	
	                      return function (_x) {
	                        return _ref2.apply(this, arguments);
	                      };
	                    }());
	                  }
	                } else {
	                  if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                    _this.toggleAlert();
	                  } else {
	                    _this.setState({
	                      cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                      cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                    });
	                    var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                    var dataset = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      examid: data_arr
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                      if (resp_exam.success) {
	                        var exam_data = resp_exam.examData;
	                        var selectedmen = _this.state.selectedmenu;
	                        var isInArray_var = false;
	                        isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                        if (isInArray_var) {
	                          _this.context.router.push({
	                            pathname: '/cfa2/2027/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send
	                          });
	                        } else {
	                          _this.toggleAlert();
	                        }
	                      } else {
	                        console.log('fail');
	                      }
	                    });
	                  }
	                }
	              });
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    var messageTitle_cfa_2 = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa_2,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      all_cases_id: [],
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa2BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    ----------------------------------
	        Go to subscription
	    ----------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	    --------------------------------------------------
	      Function to redirect page to Create Quiz page
	    --------------------------------------------------
	    */
	
	
	    /*
	    --------------------------------------------------
	      Function to redirect page to begin Quiz page
	    --------------------------------------------------
	    */
	
	  }, {
	    key: 'startQuizquestion',
	
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to begin Quiz page
	    -------------------------------------------------
	    */
	    value: function startQuizquestion(item, offset_va, e) {
	      var _this3 = this;
	
	      // var final_exam=[];
	      var data = { token: this.state.token, idname: this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this3.toggleAlert();
	          } else {
	            _this3.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context3.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this3.state.selectedmenu;
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context3.next = 7;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context3.sent;
	
	                        if (isInArray_var) {
	                          _this3.context.router.push({
	                            pathname: '/cfa2/2027/beginquiz/' + _this3.state.quiz_id + '/' + offset_va,
	                            state: {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              quiz_id: _this3.state.quiz_id,
	                              offset: offset_va
	                            }
	                          });
	                        } else {
	                          _this3.toggleAlert();
	                        }
	                        _context3.next = 12;
	                        break;
	
	                      case 11:
	                        console.log('fail');
	
	                      case 12:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this3);
	              }));
	
	              return function (_x2) {
	                return _ref3.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this3.toggleAlert();
	          } else {
	            _this3.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              examid: data_arr
	            };
	
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this3.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this3.context.router.push({
	                    pathname: '/cfa2/2027/beginquiz/' + _this3.state.quiz_id + '/' + offset_va,
	                    state: {
	                      token: _this3.state.token,
	                      idname: _this3.state.idname,
	                      quiz_id: _this3.state.quiz_id,
	                      offset: offset_va
	                    }
	                  });
	                } else {
	                  _this3.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      /*
	      --------------------------------
	        Api to fetch Quiz by quiz id
	      -------------------------------- 
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var all_questions = JSON.parse(resp.singlequiz);
	          var all_cases = JSON.parse(resp.case_id);
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this4.setState({
	            timer_value: minutes,
	            all_question_id: all_questions,
	            all_cases_id: all_cases,
	            question_length: resp.questions_count,
	            user_time_value: resp.user_time_value
	          });
	        }
	      });
	
	      /*
	      ---------------------------------------------------------  
	      Api to fetch all right answered on particular quiz id
	      ---------------------------------------------------------
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this4.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      // console.log('this.props.params.quiz_id', this.props.params.quiz_id);
	      var all_question_id = this.state.all_question_id;
	      var all_cases = this.state.all_cases_id;
	      var case_id_display = '';
	
	      if (all_cases.length) {
	        case_id_display = all_cases.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_head' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20 margin_top_10' },
	                _language2.default.LC().CASE,
	                ': ',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  className: 'float-right btn btn-primary',
	                  onClick: _this5.startQuizquestion.bind(_this5, items, index)
	                },
	                'View'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'table-responsive' },
	              _react2.default.createElement(
	                'table',
	                { className: 'table_white_bg table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    { className: 'border_top_0' },
	                    _react2.default.createElement(
	                      'th',
	                      { width: '90' },
	                      '#'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().QUESTIONS
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { width: '200' },
	                      _language2.default.LC().YOURS_ANSWER
	                    )
	                  )
	                ),
	                _react2.default.createElement(Questionfetch, {
	                  indexval: index,
	                  casesquestion: all_question_id[index],
	                  token: _this5.state.token,
	                  idname: _this5.state.idname,
	                  quiz_id: _this5.state.quiz_id,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      }
	
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.question_length
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        /*status_data = <div className="card">
	          <div className="card-header">Score</div>
	            <div className="card-block">
	              <div className="row">
	                <div className="col-sm-12 text-center">
	                <div className="score_box">{this.state.allrightanswercount}/{this.state.question_length}</div>
	                <h6 className="text-center">Total Time: {user_time}</h6>
	                </div>
	              </div>
	            </div>        
	          </div>;  */
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.question_length
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          'Continue'
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            'Quiz ID: ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            ' ',
	            _language2.default.LC().CREATE_NEW_QUIZ,
	            ' '
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().NO_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().CORRECT_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().WRONG_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              case_id_display
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        })
	      );
	    }
	  }]);
	
	  return Cfa2BeforeStart;
	}(_react.Component);
	
	Cfa2BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var Questionfetch = function (_React$Component) {
	  _inherits(Questionfetch, _React$Component);
	
	  function Questionfetch() {
	    _classCallCheck(this, Questionfetch);
	
	    return _possibleConstructorReturn(this, (Questionfetch.__proto__ || Object.getPrototypeOf(Questionfetch)).apply(this, arguments));
	  }
	
	  _createClass(Questionfetch, [{
	    key: 'render',
	    value: function render() {
	      var casesquestion = this.props.casesquestion;
	      var token = this.props.token;
	      var idname = this.props.idname;
	      var quiz_id = this.props.quiz_id;
	      var answeredstate = this.props.answered_state;
	      var handler = this.props.handler;
	
	      var caseQuestionval = Object.keys(casesquestion).map(function (key) {
	        return (
	          // nosemgrep
	          _react2.default.createElement(
	            'tr',
	            { key: Math.random() },
	            _react2.default.createElement(
	              'td',
	              null,
	              parseInt(key) + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + answeredstate + '_' + key }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionFetchcheck, {
	                answered_state: answeredstate + '_' + key,
	                question_id: casesquestion[key],
	                token: token,
	                idname: idname,
	                quiz_id: quiz_id
	              })
	            )
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        caseQuestionval
	      );
	    }
	  }]);
	
	  return Questionfetch;
	}(_react2.default.Component);
	
	function QuestionFetchcheck(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/checkAnswered', data).then(function (resp) {
	    if (document.getElementById('questionNameId_' + props.answered_state) !== null) document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // This component re-fires checkAnswered on every render; the first response renames the
	      // status span's id, so on a later response the original id is gone (null). Guard like the
	      // else-branch below — the status was already applied by the earlier response.
	      var statusEl = document.getElementById('user_question_status_' + props.answered_state);
	      var flagEl = document.getElementById('answer_flag' + props.answered_state);
	      if (resp.question_recived.answer === 1) {
	        if (statusEl !== null) statusEl.id = 'quiz_answered_status';
	        if (flagEl !== null) flagEl.innerHTML = 'Correct Answer';
	      } else {
	        if (statusEl !== null) statusEl.id = 'quiz_wrong_answered_status';
	        if (flagEl !== null) flagEl.innerHTML = 'Wrong Answer';
	      }
	    } else {
	      if (document.getElementById('user_question_status_' + props.answered_state) !== null) document.getElementById('user_question_status_' + props.answered_state).id = 'quiz_notanswered_status';
	
	      if (document.getElementById('answer_flag' + props.answered_state) !== null) document.getElementById('answer_flag' + props.answered_state).innerHTML = 'No Answer';
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status_' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	exports.default = Cfa2BeforeStart;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	
	
	// import AppRoutes from '../config/AppRoutes';
	/* eslint-disable*/
	var Cfa2Beginquiz = function (_Component) {
	  _inherits(Cfa2Beginquiz, _Component);
	
	  function Cfa2Beginquiz(props) {
	    _classCallCheck(this, Cfa2Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2Beginquiz.__proto__ || Object.getPrototypeOf(Cfa2Beginquiz)).call(this, props));
	
	    _this._getAnswer = function (choice, e) {
	      var selectedChoice = '';
	      if (typeof choice === 'string') {
	        selectedChoice = choice.startsWith('choice_') ? choice : 'choice_' + choice;
	      } else if (Array.isArray(choice) && typeof choice[0] === 'string') {
	        selectedChoice = choice[0].startsWith('choice_') ? choice[0] : 'choice_' + choice[0];
	      }
	      _this.setState({ choice: selectedChoice, selectedChoice: selectedChoice, clicked: false });
	      if (selectedChoice === 'choice_a') {
	        _this.setState({
	          choice_a: 'answer_box clicked_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box'
	        });
	      } else if (selectedChoice === 'choice_b') {
	        _this.setState({
	          choice_b: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_c: 'answer_box'
	        });
	      } else if (selectedChoice === 'choice_c') {
	        _this.setState({
	          choice_c: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box'
	        });
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.state.chapter_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._getResult = function (item, e) {
	      var chosen_answer = _this.state.choice;
	      if (chosen_answer && !_this.state.clicked) {
	        clearInterval(_this.timer);
	        var right_answer = 0;
	        _this.setState({
	          result_block: 'card show_block',
	          clicked: true,
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play',
	          timer_display: 'card-block'
	        });
	        if ('choice_' + item.answer === chosen_answer) {
	          right_answer = 1;
	          if (chosen_answer === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (chosen_answer === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (chosen_answer === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (chosen_answer === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box danger' });
	          } else if (chosen_answer === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box danger' });
	          } else if (chosen_answer === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box danger' });
	          }
	          if (item.answer === 'a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.answer === 'b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (item.answer === 'c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          }
	          _this.setState({
	            result: 'INCORRECT',
	            text_color: 'card-header text_failure',
	            result_block: 'card show_block'
	          });
	        }
	
	        var idx = _this.state.question_offset;
	        var questionsCopy = [].concat(_toConsumableArray(_this.state.questions));
	        if (questionsCopy[idx]) {
	          if (!questionsCopy[idx].cfa2_2027_answer_quizzes) {
	            questionsCopy[idx].cfa2_2027_answer_quizzes = {};
	          }
	          questionsCopy[idx].cfa2_2027_answer_quizzes.selected_choice = chosen_answer;
	          questionsCopy[idx]['cfa2_2027_answer_quizzes.selected_choice'] = chosen_answer;
	          _this.setState({ questions: questionsCopy });
	        }
	
	        if (!_this.state.validated) {
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.questions[_this.state.question_offset].id,
	            answer: right_answer,
	            selectedChoice: chosen_answer
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/answerQuiz', data).then(function (resp) {
	            if (resp.success) {
	              var data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                question_id: _this.state.questions[_this.state.question_offset].id,
	                right_answer: right_answer,
	                time_done: 0,
	                chapter_id: _this.state.chapter_id,
	                selected_choice: _this.state.choice
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveStats', data).then(function (resp) {});
	              _this.setState({ ValidToken: true, validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/cfa2/2027/beforestart/' + _this.state.quiz_id + '/' + 'abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon'
	        }
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // If the question is already attempted, do nothing
	      if (_this.state.clicked || _this.state.validated) {
	        return;
	      }
	      if (_this.state.timer_stop) {
	        _this.setState({
	          timer_stop: false,
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment') ? document.getElementById('comment').value : null;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._editFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-md-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      clearInterval(_this.timer);
	
	      var indexId = _this.state.question_offset + 1;
	      if (indexId === _this.state.questions.length) {
	        _this.setState({
	          showCompletionQuestion: true,
	          next_block: 'card hide_block',
	          markCompleted: false,
	          markAsCompleted: false,
	          markAsNotCompleted: false,
	          display_cases: 'display_block'
	        });
	      } else {
	        _this.setState({ clicked: false });
	        _this.setState({
	          display_loader: 'show_block',
	          already_answered_status: '',
	          validated: false,
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          report_block: 'card hide_block',
	          rating: 0,
	          ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	          bookmarkColor: ''
	        });
	        document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	
	        var insert_time = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          user_time_value: _this.state.count
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/insertTimer', insert_time).then(function (resp) {});
	
	        if (indexId > 0) {
	          _this.setState({ previ_block: '' });
	        }
	
	        var questionData = _this.state.questions[indexId];
	        var selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
	        var rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
	        var answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
	        var showAnswer = false;
	        var selected = '';
	
	        if (selectedChoice) {
	          selected = selectedChoice;
	          showAnswer = true;
	        } else if (answerStatus) {
	          if (rightAnswer === 1) {
	            selected = 'choice_' + questionData.answer;
	            showAnswer = true;
	          } else if (!rightAnswer) {
	            var correct = 'choice_' + questionData.answer;
	            var choices = Object.keys(questionData).filter(function (key) {
	              return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	            });
	            selected = choices.length > 0 ? choices[0] : '';
	            showAnswer = true;
	          }
	        }
	
	        var boxA = 'answer_box',
	            boxB = 'answer_box',
	            boxC = 'answer_box';
	        var result_block = 'card hide_block',
	            text_color = 'card-header',
	            result = '',
	            clicked = false;
	
	        if (selected) {
	          var _correct = questionData.answer ? 'choice_' + questionData.answer : '';
	          if (selected === 'choice_a') {
	            boxA = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_b') {
	            boxB = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_c') {
	            boxC = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          }
	          if (_correct) {
	            if (selected === _correct) {
	              text_color = 'card-header text_success';
	              result = 'CORRECT';
	            } else {
	              text_color = 'card-header text_failure';
	              result = 'INCORRECT';
	            }
	            result_block = 'card show_block';
	          }
	          clicked = true;
	        }
	
	        _this.setState({
	          question_display: questionData,
	          question_offset: indexId,
	          selectedChoice: selected,
	          choice: selected,
	          clicked: clicked,
	          choice_a: boxA,
	          choice_b: boxB,
	          choice_c: boxC,
	          result_block: result_block,
	          text_color: text_color,
	          result: result,
	          showAnswer: showAnswer,
	          selected: selected,
	          display_loader: 'hide_block'
	        });
	
	        var data_check = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: questionData.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/checkAnswered', data_check).then(function (resp) {
	          _this.setState({ already_answered_status: resp.message });
	        });
	
	        var params_fav = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname,
	          chapter_id: _this.state.chapter_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	          if (responsefav.success) {
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          }
	        });
	
	        if (selectedChoice || selected) {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          _this.setState({
	            timer_stop: false,
	            timerstopbtn: 'pause_btn icon-control-pause'
	          });
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        }
	
	        var params_rating = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params_rating).then(function (response) {
	          if (response.success) {
	            _this.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            _this.setState({
	              rated: false,
	              rating: 0,
	              ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	            });
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ clicked: false });
	      clearInterval(_this.timer);
	      _this.setState({
	        display_loader: 'show_block',
	        already_answered_status: '',
	        validated: false,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        bookmarkColor: ''
	      });
	      document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/insertTimer', insert_time).then(function (resp) {});
	
	      var indexId = _this.state.question_offset - 1;
	      if (indexId < 0) {
	        if (_this.state.offset > 0) {
	          _this._getPreviousCase();
	        } else {
	          _this.setState({ previ_block: 'card hide_block' });
	        }
	      } else {
	        if (indexId === 0) {
	          _this.setState({ previ_block: 'card hide_block' });
	        }
	
	        var questionData = _this.state.questions[indexId];
	        var selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
	        var rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
	        var answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
	        var showAnswer = false;
	        var selected = '';
	
	        if (selectedChoice) {
	          selected = selectedChoice;
	          showAnswer = true;
	        } else if (answerStatus) {
	          if (rightAnswer === 1) {
	            selected = 'choice_' + questionData.answer;
	            showAnswer = true;
	          } else if (!rightAnswer) {
	            var correct = 'choice_' + questionData.answer;
	            var choices = Object.keys(questionData).filter(function (key) {
	              return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	            });
	            selected = choices.length > 0 ? choices[0] : '';
	            showAnswer = true;
	          }
	        }
	
	        var boxA = 'answer_box',
	            boxB = 'answer_box',
	            boxC = 'answer_box';
	        var result_block = 'card hide_block',
	            text_color = 'card-header',
	            result = '',
	            clicked = false;
	
	        if (selected) {
	          var _correct2 = questionData.answer ? 'choice_' + questionData.answer : '';
	          if (selected === 'choice_a') {
	            boxA = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_b') {
	            boxB = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_c') {
	            boxC = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          }
	          if (_correct2) {
	            if (selected === _correct2) {
	              text_color = 'card-header text_success';
	              result = 'CORRECT';
	            } else {
	              text_color = 'card-header text_failure';
	              result = 'INCORRECT';
	            }
	            result_block = 'card show_block';
	          }
	          clicked = true;
	        }
	
	        _this.setState({
	          question_display: questionData,
	          question_offset: indexId,
	          selectedChoice: selected,
	          choice: selected,
	          clicked: clicked,
	          choice_a: boxA,
	          choice_b: boxB,
	          choice_c: boxC,
	          result_block: result_block,
	          text_color: text_color,
	          result: result,
	          showAnswer: showAnswer,
	          selected: selected,
	          display_loader: 'hide_block'
	        });
	
	        var data_check = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: questionData.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/checkAnswered', data_check).then(function (resp) {
	          _this.setState({ already_answered_status: resp.message });
	        });
	
	        var params_fav = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname,
	          chapter_id: _this.state.chapter_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	          if (responsefav.success) {
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          }
	        });
	
	        if (selectedChoice || selected) {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          _this.setState({
	            timer_stop: false,
	            timerstopbtn: 'pause_btn icon-control-pause'
	          });
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        }
	
	        var params_rating = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params_rating).then(function (response) {
	          if (response.success) {
	            _this.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            _this.setState({
	              rated: false,
	              rating: 0,
	              ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	            });
	          }
	        });
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      clearInterval(_this.timer);
	      var indexId = _this.state.offset - 1;
	
	      var all_cases = _this.state.all_cases;
	
	
	      if (indexId < 0) {
	        return;
	      }
	
	      _this.setState({
	        display_loader: 'show_block',
	        clicked: false,
	        validated: false,
	        already_answered_status: '',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        showCompletionQuestion: false,
	        lastCase: _this.state.cases_display.id,
	        markCompleted: false,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        rating: 0,
	        bookmarkColor: '',
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        result_block: 'card hide_block',
	        previ_block: 'card hide_block',
	        next_block: '',
	        question_offset: 0,
	        offset: indexId,
	        case_id: all_cases[indexId]
	      });
	
	      if (indexId === 0) {
	        _this.setState({ previ_block_cases: 'card hide_block' });
	      }
	      if (indexId < _this.state.cases_length - 1) {
	        _this.setState({ next_block_cases: '' });
	      }
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        casesId: all_cases[indexId]
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getCasesbyId', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/cfa2/2027/beginquiz/' + _this.state.quiz_id + '/' + indexId
	          });
	
	          _this.setState({
	            cases_display: resp.casesdiscription,
	            chapter_id: resp.casesdiscription.chapter_no_2025,
	            case_no: resp.casesdiscription.case_number,
	            chapter_no_2025: resp.casesdiscription.chapter_no_2025
	          });
	
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter_id: resp.casesdiscription.chapter_no_2025
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChaptersbyID', data).then(function (respchapter) {
	            if (respchapter.success) {
	              _this.setState({
	                chaptername: respchapter.chapterdata.chapter_name,
	                chapters: respchapter.chapterdata
	              });
	
	              var param = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                case_id: resp.casesdiscription.id,
	                isQuiz: true,
	                quiz_id: _this.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesquestion', param).then(function (resp_question) {
	                if (resp_question.success) {
	                  var questionData = resp_question.questions_details[0];
	                  var selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
	                  var answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = 'choice_' + questionData.answer;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var correct = 'choice_' + questionData.answer;
	                      var choices = Object.keys(questionData).filter(function (key) {
	                        return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  var boxA = 'answer_box',
	                      boxB = 'answer_box',
	                      boxC = 'answer_box';
	                  var result_block = 'card hide_block',
	                      text_color = 'card-header',
	                      result = '',
	                      clicked = false;
	
	                  if (selected) {
	                    var _correct3 = questionData.answer ? 'choice_' + questionData.answer : '';
	                    if (selected === 'choice_a') {
	                      boxA = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_b') {
	                      boxB = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_c') {
	                      boxC = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    }
	                    if (_correct3) {
	                      if (selected === _correct3) {
	                        text_color = 'card-header text_success';
	                        result = 'CORRECT';
	                      } else {
	                        text_color = 'card-header text_failure';
	                        result = 'INCORRECT';
	                      }
	                      result_block = 'card show_block';
	                    }
	                    clicked = true;
	                  }
	
	                  _this.setState({
	                    question_display: questionData,
	                    question_length: resp_question.questions_details.length,
	                    questions: resp_question.questions_details,
	                    selectedChoice: selected,
	                    choice: selected,
	                    clicked: clicked,
	                    choice_a: boxA,
	                    choice_b: boxB,
	                    choice_c: boxC,
	                    result_block: result_block,
	                    text_color: text_color,
	                    result: result,
	                    showAnswer: showAnswer,
	                    selected: selected,
	                    display_loader: 'hide_block'
	                  });
	
	                  if (!selected) {
	                    _this.timer = setInterval(_this.tick.bind(_this), 1000);
	                    _this.setState({
	                      timer_stop: false,
	                      timerstopbtn: 'pause_btn icon-control-pause',
	                      timer_display: 'card-block'
	                    });
	                  } else {
	                    _this.setState({
	                      timer_stop: true,
	                      timerstopbtn: 'pause_btn icon-control-play',
	                      timer_display: 'card-block'
	                    });
	                  }
	                  var data_check = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: questionData.id
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/checkAnswered', data_check).then(function (resp_inner) {
	                    _this.setState({
	                      already_answered_status: resp_inner.message
	                    });
	                  });
	                  var params_fav = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname,
	                    chapter_id: _this.state.chapter_id
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                    if (responsefav.success) {
	                      _this.setState({
	                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	                  // Fetch rating for this question
	                  var params_rating = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params_rating).then(function (response) {
	                    if (response.success) {
	                      _this.setState({ rated: true });
	                      response.ratting.map(function (items) {
	                        _this.setState({
	                          rating: items.ratting,
	                          ratting_text: '' + _language2.default.LC().RATED
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        rated: false,
	                        rating: 0,
	                        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                      });
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this._getNextCase = function () {
	      clearInterval(_this.timer);
	      var indexId = _this.state.offset + 1;
	
	      var all_cases = _this.state.all_cases;
	
	
	      if (indexId >= _this.state.cases_length) {
	        return;
	      }
	
	      _this.setState({
	        display_loader: 'show_block',
	        clicked: false,
	        validated: false,
	        already_answered_status: '',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        showCompletionQuestion: false,
	        lastCase: _this.state.cases_display.id,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        rating: 0,
	        bookmarkColor: '',
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        result_block: 'card hide_block',
	        previ_block: 'card hide_block',
	        next_block: '',
	        question_offset: 0,
	        offset: indexId,
	        case_id: all_cases[indexId]
	      });
	
	      if (indexId > 0) {
	        _this.setState({ previ_block_cases: '' });
	      }
	      if (indexId === _this.state.cases_length - 1) {
	        _this.setState({ next_block_cases: 'card hide_block' });
	      }
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        casesId: all_cases[indexId]
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getCasesbyId', data).then(function (casesData) {
	        if (casesData.success) {
	          _this.context.router.push({
	            pathname: '/cfa2/2027/beginquiz/' + _this.state.quiz_id + '/' + indexId
	          });
	
	          _this.setState({
	            cases_display: casesData.casesdiscription,
	            chapter_id: casesData.casesdiscription.chapter_no_2025,
	            case_no: casesData.casesdiscription.case_number,
	            chapter_no_2025: casesData.casesdiscription.chapter_no_2025
	          });
	
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter_id: casesData.casesdiscription.chapter_no_2025
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChaptersbyID', data).then(function (respchapter) {
	            if (respchapter.success) {
	              _this.setState({
	                chaptername: respchapter.chapterdata.chapter_name,
	                chapters: respchapter.chapterdata
	              });
	
	              var param = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                case_id: casesData.casesdiscription.id,
	                isQuiz: true,
	                quiz_id: _this.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesquestion', param).then(function (resp_question) {
	                if (resp_question.success) {
	                  var questionData = resp_question.questions_details[0];
	                  var selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
	                  var answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = 'choice_' + questionData.answer;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var correct = 'choice_' + questionData.answer;
	                      var choices = Object.keys(questionData).filter(function (key) {
	                        return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  var boxA = 'answer_box',
	                      boxB = 'answer_box',
	                      boxC = 'answer_box';
	                  var result_block = 'card hide_block',
	                      text_color = 'card-header',
	                      result = '',
	                      clicked = false;
	
	                  if (selected) {
	                    var _correct4 = questionData.answer ? 'choice_' + questionData.answer : '';
	                    if (selected === 'choice_a') {
	                      boxA = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_b') {
	                      boxB = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_c') {
	                      boxC = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    }
	                    if (_correct4) {
	                      if (selected === _correct4) {
	                        text_color = 'card-header text_success';
	                        result = 'CORRECT';
	                      } else {
	                        text_color = 'card-header text_failure';
	                        result = 'INCORRECT';
	                      }
	                      result_block = 'card show_block';
	                    }
	                    clicked = true;
	                  }
	
	                  _this.setState({
	                    question_display: questionData,
	                    question_length: resp_question.questions_details.length,
	                    questions: resp_question.questions_details,
	                    selectedChoice: selected,
	                    choice: selected,
	                    clicked: clicked,
	                    choice_a: boxA,
	                    choice_b: boxB,
	                    choice_c: boxC,
	                    result_block: result_block,
	                    text_color: text_color,
	                    result: result,
	                    showAnswer: showAnswer,
	                    selected: selected,
	                    display_loader: 'hide_block'
	                  });
	
	                  if (!selected) {
	                    _this.timer = setInterval(_this.tick.bind(_this), 1000);
	                    _this.setState({
	                      timer_stop: false,
	                      timerstopbtn: 'pause_btn icon-control-pause',
	                      timer_display: 'card-block'
	                    });
	                  } else {
	                    _this.setState({
	                      timer_stop: true,
	                      timerstopbtn: 'pause_btn icon-control-play',
	                      timer_display: 'card-block'
	                    });
	                  }
	
	                  var data_check = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: questionData.id
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/checkAnswered', data_check).then(function (resp_inner) {
	                    _this.setState({
	                      already_answered_status: resp_inner.message
	                    });
	                  });
	                  var params_fav = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname,
	                    chapter_id: _this.state.chapter_id
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                    if (responsefav.success) {
	                      _this.setState({
	                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	                  // Fetch rating for this question
	                  var params_rating = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params_rating).then(function (response) {
	                    if (response.success) {
	                      _this.setState({ rated: true });
	                      response.ratting.map(function (items) {
	                        _this.setState({
	                          rating: items.ratting,
	                          ratting_text: '' + _language2.default.LC().RATED
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        rated: false,
	                        rating: 0,
	                        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                      });
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: '',
	      question_length: '',
	      questions: [],
	      question_offset: 0,
	      question_display: '',
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      count: 0,
	      ValidToken: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count_end_message: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      next_block_cases: '',
	      previ_block_cases: '',
	      already_answered_status: '',
	      caseid: '',
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      casesquestion_length: '',
	      chapters: '',
	      chatername: '',
	      chapter_id: '',
	      case_no: '',
	      chapter_no_2025: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      exam_type: 'cfa_2',
	      showCompletionQuestion: false,
	      selectedChoice: '',
	      showAnswer: false,
	      selected: '',
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: false,
	      lastCase: null,
	      display_cases: ''
	    };
	    return _this;
	  }
	
	  _createClass(Cfa2Beginquiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	    /*
	    -----------------------------------------------------------------
	      Function to change time every second and store in database
	    -----------------------------------------------------------------
	    */
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count > 0) {
	        var countValue = this.state.count - 1;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: countValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/insertTimer', insert_time).then(function (resp) {});
	        this.setState({
	          count: countValue,
	          timer_display: 'card-block'
	        });
	      } else {
	        this.setState({
	          timer_display: 'card hide_block',
	          count_end_message: "Time's Up"
	        });
	        clearInterval(this.timer);
	      }
	    }
	
	    /*
	    -------------------------------
	      it is use to redirect page
	    -------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (this.state.offset === 0) {
	        this.setState({ previ_block_cases: 'card hide_block' });
	      }
	      if (this.state.question_offset === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      /*
	      ----------------------------------  
	      Api to fetch Quiz by quiz id
	      ----------------------------------  
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var all_questions = JSON.parse(resp.singlequiz);
	          var all_cases = JSON.parse(resp.case_id);
	          _this2.setState({
	            all_cases: all_cases,
	            timer_value: resp.timer_value,
	            cases_length: all_cases.length,
	            user_time_value: resp.user_time_value
	          });
	
	          if (all_cases.length - 1 === _this2.state.offset) {
	            _this2.setState({ next_block_cases: 'card hide_block' });
	          }
	
	          var initialCount = resp.user_time_value > 0 ? resp.user_time_value : resp.timer_value;
	          _this2.setState({
	            count: initialCount,
	            count_temp: initialCount
	          });
	
	          if (!_this2.state.clicked) {
	            _this2.timer = setInterval(_this2.tick.bind(_this2), 1000);
	            _this2.setState({
	              timer_stop: false,
	              timerstopbtn: 'pause_btn icon-control-pause',
	              timer_display: 'card-block'
	            });
	          } else {
	            _this2.setState({
	              timer_stop: true,
	              timerstopbtn: 'pause_btn icon-control-play',
	              timer_display: 'card-block'
	            });
	          }
	
	          for (var i = 0; i < all_cases.length; i++) {
	            if (parseInt(_this2.props.params.offset) === i) {
	              _this2.setState({ case_id: all_cases[i] });
	              var data = {
	                token: _this2.state.token,
	                idname: _this2.state.idname,
	                casesId: all_cases[i]
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getCasesbyId', data).then(function (resp) {
	                if (resp.success) {
	                  _this2.context.router.push({
	                    pathname: '/cfa2/2027/beginquiz/' + _this2.state.quiz_id + '/' + _this2.state.offset
	                  });
	                  _this2.setState({
	                    cases_display: resp.casesdiscription,
	                    chapter_id: resp.casesdiscription.chapter_no_2025,
	                    case_no: resp.casesdiscription.case_number,
	                    chapter_no_2025: resp.casesdiscription.chapter_no_2025
	                  });
	                  var questionid = '';
	                  var chapter_id = resp.casesdiscription.chapter_no_2025;
	                  var data = {
	                    token: _this2.state.token,
	                    idname: _this2.state.idname,
	                    chapter_id: resp.casesdiscription.chapter_no_2025
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChaptersbyID', data).then(function (respchapter) {
	                    if (respchapter.success) {
	                      _this2.setState({
	                        chaptername: respchapter.chapterdata.chapter_name,
	                        chapters: respchapter.chapterdata
	                      });
	
	                      var param = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        case_id: resp.casesdiscription.id,
	                        isQuiz: true,
	                        quiz_id: _this2.state.quiz_id
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCasesquestion', param).then(function (resp_question) {
	                        if (resp_question.success) {
	                          var questionData = resp_question.questions_details[_this2.state.question_offset];
	                          var selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
	                          var rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
	                          var answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
	                          var showAnswer = false;
	                          var selected = '';
	
	                          if (selectedChoice) {
	                            selected = selectedChoice;
	                            showAnswer = true;
	                          } else if (answerStatus) {
	                            if (rightAnswer === 1) {
	                              selected = 'choice_' + questionData.answer;
	                              showAnswer = true;
	                            } else if (!rightAnswer) {
	                              var correct = 'choice_' + questionData.answer;
	                              var choices = Object.keys(questionData).filter(function (key) {
	                                return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                              });
	                              selected = choices.length > 0 ? choices[0] : '';
	                              showAnswer = true;
	                            }
	                          }
	                          var boxA = 'answer_box',
	                              boxB = 'answer_box',
	                              boxC = 'answer_box';
	                          var result_block = 'card hide_block',
	                              text_color = 'card-header',
	                              result = '',
	                              clicked = false;
	
	                          if (selected) {
	                            var _correct5 = questionData.answer ? 'choice_' + questionData.answer : '';
	                            if (selected === 'choice_a') {
	                              boxA = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	                            } else if (selected === 'choice_b') {
	                              boxB = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	                            } else if (selected === 'choice_c') {
	                              boxC = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	                            }
	                            if (_correct5) {
	                              if (selected === _correct5) {
	                                text_color = 'card-header text_success';
	                                result = 'CORRECT';
	                              } else {
	                                text_color = 'card-header text_failure';
	                                result = 'INCORRECT';
	                              }
	                              result_block = 'card show_block';
	                            }
	                            clicked = true;
	                          }
	                          _this2.setState({
	                            question_display: questionData,
	                            question_length: resp_question.questions_details.length,
	                            questions: resp_question.questions_details,
	                            question_offset: _this2.state.question_offset,
	                            selectedChoice: selected,
	                            choice: selected,
	                            clicked: clicked,
	                            choice_a: boxA,
	                            choice_b: boxB,
	                            choice_c: boxC,
	                            result_block: result_block,
	                            text_color: text_color,
	                            result: result,
	                            showAnswer: showAnswer,
	                            selected: selected
	                          });
	                          questionid = questionData.id;
	
	                          var data_check = {
	                            token: _this2.state.token,
	                            idname: _this2.state.idname,
	                            quiz_id: _this2.state.quiz_id,
	                            question_id: questionid
	                          };
	                          /*
	                          --------------------------------------------
	                          Api to fetch question and check answered 
	                          --------------------------------------------  
	                          */
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/checkAnswered', data_check).then(function (resp_inner) {
	                            _this2.setState({
	                              already_answered_status: resp_inner.message
	                            });
	                          });
	                          _this2.setState({ display_loader: 'hide_block' });
	                          clearInterval(_this2.timer);
	                          if (selected) {
	                            _this2.setState({
	                              timer_stop: true,
	                              timerstopbtn: 'pause_btn icon-control-play'
	                            });
	                          } else {
	                            _this2.setState({
	                              timer_stop: false,
	                              timerstopbtn: 'pause_btn icon-control-pause'
	                            });
	                            _this2.timer = setInterval(_this2.tick.bind(_this2), 1000);
	                          }
	                          var params_fav = {
	                            token: _this2.state.token,
	                            question_id: questionid,
	                            idname: _this2.state.idname,
	                            chapter_id: chapter_id
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                            if (responsefav.success) {
	                              _this2.setState({
	                                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                                bookmarkColor: 'rgb(54, 141, 84)',
	                                save_text: '' + _language2.default.LC().Question_Saved
	                              });
	                            }
	                          });
	                          var params = {
	                            token: _this2.state.token,
	                            idname: _this2.state.idname,
	                            question_id: questionid
	                          };
	                          /*
	                          ------------------------------------------ 
	                          Api to fetch flashcard by question id
	                          ------------------------------------------
	                          */
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFlashCards', params).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ ValidToken: true });
	                              if (response.flash_cards.length > 0) {
	                                _this2.setState({
	                                  flash_form: 'col-md-12 hide_block'
	                                });
	                                var flash_cards = response.flash_cards.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: '' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'icon_list' },
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this2._editFlash.bind(_this2, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this2._deleteFlash.bind(_this2, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: _this2.state.flash_class },
	                                        _react2.default.createElement('h4', null),
	                                        _react2.default.createElement(
	                                          'p',
	                                          null,
	                                          items.flash_card
	                                        )
	                                      )
	                                    )
	                                  );
	                                });
	                              } else {
	                                _this2.setState({
	                                  flash_form: 'col-md-12 display_block'
	                                });
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                              }
	                              _this2.setState({ flash_data: flash_cards });
	                            } else {
	                              var flash_cards = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_FLASHCARD_FOUND
	                              );
	                              _this2.setState({
	                                ValidToken: false,
	                                flash_data: flash_cards,
	                                flash_form: 'col-md-12 display_block'
	                              });
	                            }
	                            return response;
	                          });
	                          _this2.setState({ records: '' });
	                          // Fetch rating for this question
	                          var params_rating = {
	                            token: _this2.state.token,
	                            question_id: questionid,
	                            idname: _this2.state.idname
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params_rating).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ rated: true });
	                              response.ratting.map(function (items) {
	                                _this2.setState({
	                                  rating: items.ratting,
	                                  ratting_text: '' + _language2.default.LC().RATED
	                                });
	                              });
	                            } else {
	                              _this2.setState({
	                                rated: false,
	                                rating: 0,
	                                ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                              });
	                            }
	                          });
	                        }
	                      });
	                    } else {
	                      _this2.setState({ ValidToken: false });
	                    }
	                  });
	                }
	              });
	            }
	          }
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.showCompletionQuestion && this.state.lastCase && this.state.cases_display.id != this.state.lastCase && !this.state.markCompleted) {
	        document.getElementById('mark_not_completed') && document.getElementById('mark_not_completed').checked ? document.getElementById('mark_not_completed').checked = false : '';
	        document.getElementById('mark_completed') && document.getElementById('mark_completed').checked ? document.getElementById('mark_completed').checked = false : '';
	      }
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/UpdateCfaRatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getCfaratting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveCfaratting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({
	                  rated: 1,
	                  ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	                });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveCfaratting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({
	                rated: 1,
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    -------------------------------------------------------------------------
	      Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to readings beforestart
	    ------------------------------------------------------ 
	    */
	
	
	    /*
	    ------------------------------------
	    Function to start or stop timer
	    ------------------------------------
	    */
	
	    /*
	    ----------------------------------
	      Function to show Report box
	    ---------------------------------
	    */
	
	
	    /*
	    ---------------------------------------------
	      Funcion to save new report question
	    ---------------------------------------------
	    */
	
	    /*
	    --------------------------------
	      Function to hide Report box
	    -------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	        Function to toggle Comment box
	    --------------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Flash box
	    -----------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    -------------------------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------
	      Function to Edit Flash card
	    ------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to delete flash card
	    ------------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to fetch Next question
	    -----------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to fetch Previous question
	    -----------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to fetch Previous case
	    -----------------------------------
	    */
	
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this4 = this;
	
	      e.preventDefault();
	
	      if (!this.state.markAsCompleted && !this.state.markAsNotCompleted) {
	        return;
	      }
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.case_no,
	        completion_status: this.state.markAsCompleted ? 1 : 0,
	        exam_type: this.state.exam_type,
	        chapter_id: this.state.chapter_id
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/updateCases', data).then(function (casesData) {
	        if (casesData.success) {
	          _this4.setState({
	            markCompleted: true,
	            showCompletionQuestion: false
	          });
	
	          var indexId = _this4.state.offset + 1;
	          if (indexId < _this4.state.cases_length) {
	            _this4._getNextCase();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var rating = this.state.rating;
	      var clicked = this.state.clicked;
	
	      var questions_data_display = this.state.question_display;
	
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	
	      var data = void 0,
	          question_data = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      data = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.cases_display.case_name_2025 || this.state.cases_display.case_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block_cases,
	                  onClick: this._getPreviousCase
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block_cases,
	                  onClick: this._getNextCase
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      (0, _function.renderHTMLContent)(this.state.cases_display.case, 'div', 'margin_bottom_40 view_questionhtml bg_blue', { contentEditable: 'false' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'quiz_timer_btn ' + this.state.timer_display },
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this._timer_funct.bind(this, questions_data_display)
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-danger' },
	                    (0, _function.renderHTMLContent)(this.state.count_end_message, 'div', '', {
	                      contentEditable: 'false'
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	
	      question_data = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              _language2.default.LC().QUESTION,
	              ' ',
	              questions_data_display.question_number + ' - ',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, questions_data_display, this.props, {
	                      setAnswer: this._getAnswer,
	                      showAnswer: clicked,
	                      correctChoice: 'choice_' + questions_data_display.answer,
	                      selectedChoice: this.state.selectedChoice,
	                      onValidate: function onValidate() {
	                        return _this5._getResult(questions_data_display);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'd-flex align-items-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'validate-save-report-wrap' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          clicked: this.state.clicked,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions_data_display,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor,
	                          disabled: !this.state.selectedChoice || this.state.clicked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right mr-10',
	                          style: { marginRight: '650px' }
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          { className: ' margin_bottom_0 margin_right_10 font-16px' },
	                          this.state.ratting_text
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'star_rating_wrap' },
	                          _react2.default.createElement(_reactStarRatings2.default, {
	                            rating: this.state.rating,
	                            starRatedColor: 'rgb(255, 180, 0)',
	                            starEmptyColor: 'rgb(51, 51, 51)',
	                            starDimension: '20px',
	                            starHoverColor: 'rgb(255, 180, 0)',
	                            starSpacing: '2px',
	                            changeRating: this.onStarClick.bind(this, questions_data_display),
	                            numberOfStars: 5,
	                            name: 'rate1'
	                          })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-sm-3' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions_data_display.explanation, 'div', '', {
	                contentEditable: 'false'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: this._reportQuestion.bind(this, questions_data_display)
	                    },
	                    _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, questions_data_display)
	                    },
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	      if (this.state.showCompletionQuestion) {
	        question_data = _react2.default.createElement(
	          'div',
	          { className: 'complete-section-wrap ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header text-center' },
	              _language2.default.LC().Mark_this_Question_as_Completed,
	              _react2.default.createElement(
	                'div',
	                { onClick: this.changeCompletionStatus, className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          this.state.markCompleted ? 'Submitted' : _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.markCompleted) {
	        document.getElementById('mark_not_completed') && document.getElementById('mark_not_completed').checked ? document.getElementById('mark_not_completed').checked = false : '';
	        document.getElementById('mark_completed') && document.getElementById('mark_completed').checked ? document.getElementById('mark_completed').checked = false : '';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().QUIZ_ID,
	              ': ',
	              this.state.quiz_id
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	              _language2.default.LC().BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	            question_data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2Beginquiz;
	}(_react.Component);
	
	Cfa2Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa fa-info-circle', id: 'Tooltip-' + this.props.id }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          this.props.tooltip
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa2Beginquiz;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _toast = __webpack_require__(15);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Cfa2_2023Quizzes = function (_Component) {
	  _inherits(Cfa2_2023Quizzes, _Component);
	
	  function Cfa2_2023Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa2_2023Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Cfa2_2023Quizzes.__proto__ || Object.getPrototypeOf(Cfa2_2023Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot === dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i === dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    //console.log("Some Thing Went Wrong");
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this.prioritySelected = function (e) {
	      _this.setState({ quizPriorityLevel: e.target.value });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 4;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: '',
	      all_checked_state: true,
	      radio_checked_question: 0,
	      quizPriorityLevel: 'none',
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      caseId: [],
	      caseQuestion: [],
	      caseQuestionNextval: [],
	      display_loader: 'show_block',
	      deleteItemId: '',
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _messages.messages.QUIZ_PRIORITY,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().UNANSWERED_QUIZ_SELECTED,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Cfa2_2023Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getChapters', data).then(function (resp) {
	        var success = resp.success,
	            chapters = resp.chapters;
	
	        if (success) {
	          _this3.setState({ ValidToken: true, chapters: chapters });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	
	      this.abandonedQuizzes(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        var success = resp_quiz_length.success,
	            quiz_length = resp_quiz_length.quiz_length;
	
	        if (success) {
	          _this3.setState({ quiz_length_state: quiz_length });
	        }
	      });
	    }
	  }, {
	    key: '_createQuiz',
	    value: function _createQuiz() {
	      var _this4 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      this.setState({ caseId: [] });
	      this.setState({ caseQuestion: [] });
	      var question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	      var timer_value,
	          selectedChapter,
	          caselength = '';
	      timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	
	      if (this.state.all_checked_state) {
	        selectedChapter = this.state.chapters.map(function (val) {
	          return val.id;
	        });
	      } else {
	        var checkboxes = document.getElementsByName('approve[]');
	        var i = 0;
	        var single_clicked_value = [];
	        // if (this.state.single_clicked_val === '') {
	        for (i = 0; i < checkboxes.length; i++) {
	          if (checkboxes[i].checked) {
	            single_clicked_value.push(checkboxes[i].value);
	          }
	
	          // }
	          selectedChapter = single_clicked_value;
	        }
	      }
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        priority: this.state.quizPriorityLevel,
	        selectedChapter: selectedChapter
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getRandomCases', data).then(function (resp) {
	        if (resp.success) {
	          var allCasesid_arr;
	          var i;
	          var allCasesid;
	          var j;
	          var dataparam;
	          var k;
	
	          var _ret = function () {
	            var getRandomValues = function getRandomValues(arr, count) {
	              var result = [];
	              var _tmp = arr.slice();
	              for (var i = 0; i < count; i++) {
	                var index = (0, _function.generateRandomInteger)(1, 10) % _tmp.length;
	                result.push(_tmp.splice(index, 1)[0]);
	              }
	              return result;
	            };
	
	            allCasesid_arr = [];
	
	            for (i = 0; i < resp.chaptersWiseCases.length; i++) {
	              allCasesid_arr.push(resp.chaptersWiseCases[i].id);
	            }
	            if (allCasesid_arr.length < caselength) {
	              (0, _toast.showFailure)(_language2.default.LC().CFA2_2025_QUIZ_ERROR);
	              _this4.setState({ display_loader: 'hide_block' });
	              return {
	                v: void 0
	              };
	            }
	            allCasesid = getRandomValues(allCasesid_arr, question_length_val / 6);
	
	            _this4.setState({ caseId: [] });
	            _this4.setState({ caseQuestion: [] });
	            var chaptersWiseCasesQuestionCount = 0;
	
	            for (j = 0; j < allCasesid.length; j++) {
	              dataparam = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                casesId: allCasesid[j]
	              };
	              k = 0;
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/getCasesquearraybyId', dataparam).then(function (respquestion) {
	                var qid = {};
	                var questionCount = respquestion.chapterswisecases && respquestion.chapterswisecases.length > 0 ? respquestion.chapterswisecases.length : 0;
	                chaptersWiseCasesQuestionCount += questionCount;
	
	                for (var l = 0; l < respquestion.chapterswisecases.length; l++) {
	                  qid[l] = respquestion.chapterswisecases[l].id;
	                }
	                var caseIdjoined = _this4.state.caseId.concat(respquestion.caseId);
	                var questionJoined = '';
	                questionJoined = _this4.state.caseQuestion.concat(qid);
	                _this4.setState({ caseQuestion: questionJoined, caseId: caseIdjoined }, function () {
	                  var _this5 = this;
	
	                  //console.log(this.state);
	                  if (k === allCasesid.length - 1) {
	                    var _state = this.state,
	                        caseId = _state.caseId,
	                        caseQuestion = _state.caseQuestion,
	                        idname = _state.idname,
	                        token = _state.token;
	
	                    var casesId = caseId; // This should be an array like [17,49,89]
	                    var questionStats = JSON.stringify(caseQuestion);
	
	                    var allCasesLength = question_length_val / _constant.DIVISOR_FOR_CASES;
	
	                    if (allCasesLength !== casesId.length) {
	                      (0, _toast.showInformation)(_messages.messages.NON_ATTEMPTED_QUIZ);
	                      this.setState({ display_loader: 'hide_block' });
	                      return;
	                    }
	
	                    var data = {
	                      token: token,
	                      idname: idname,
	                      number_questions: chaptersWiseCasesQuestionCount,
	                      // number_questions: question_length_val, // it makes incorrect questions count
	                      case_id: JSON.stringify(casesId),
	                      questions: questionStats,
	                      timer_value: timer_value
	                    };
	                    //console.log(data);
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027quizes/createQuiz', data).then(function (resp) {
	                      if (resp.success) {
	                        _this5.setState({ display_loader: 'hide_block' });
	                        _this5.context.router.push({
	                          pathname: '/cfa2/2027/beforestart/' + resp.last_id + '/',
	                          state: {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            quiz_id: resp.last_id,
	                            status_send: ''
	                          }
	                        });
	                      } else {
	                        //console.log(resp.success);
	                      }
	                    });
	                  }
	                });
	                k++;
	              });
	            }
	          }();
	
	          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        } else {
	          (0, _toast.showInformation)(_messages.messages.CASES_NOT_AVAILABLE);
	          _this4.setState({ display_loader: 'hide_block' });
	        }
	      });
	    }
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: '/cfa2/2027/beforestart/' + items.id + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon'
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: '/cfa2/2027/beforestart/' + items.id + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed'
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          tooltips = _state2.tooltips,
	          quizPriorityLevel = _state2.quizPriorityLevel,
	          chapters = _state2.chapters;
	
	      var chapters_all = chapters;
	      var chapter_data = '';
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.id,
	                onClick: _this6._single_Checked.bind(_this6)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this6._checkAbondon.bind(_this6, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this6.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this6._checkCompleted.bind(_this6, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            _react2.default.createElement(
	              'span',
	              null,
	              items.quiz_length / 6
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _language2.default.LC().CASES
	            ),
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this6.state.radio_checked_question === index,
	              onClick: _this6._length_Checked.bind(_this6, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().CFA_LEVEL_II_QUIZZES,
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary pointer_class', onClick: this._createQuiz.bind(this) },
	            ' ',
	            _language2.default.LC().CREATE_QUIZ,
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-7' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CONTENT,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'check_container margin_bottom_0' },
	                    ' ',
	                    _language2.default.LC().ALL_CHAPTERS,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'all_Checked',
	                      name: 'all_checked',
	                      value: 'select',
	                      onClick: this._all_Checked.bind(this),
	                      checked: this.state.all_checked_state
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block padding_15' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  chapter_data
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().ABANDONED_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '1',
	                    id: '1',
	                    content: this.state.tooltips[1].placement,
	                    place_tip: this.state.tooltips[1].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      abandoned_data
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _messages.messages.FILTER_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '3',
	                    id: '3',
	                    content: tooltips[3].placement,
	                    place_tip: tooltips[3].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'radio_container' },
	                  ' ',
	                  _messages.messages.NONE,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'none',
	                    name: 'none',
	                    value: 'none',
	                    checked: quizPriorityLevel === 'none',
	                    onClick: this.prioritySelected
	                  }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'radio_container' },
	                  _messages.messages.NON_ATTEMPTED_CASES,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'mark_unanswered',
	                    name: 'mark_unanswered',
	                    value: 'unanswered',
	                    checked: quizPriorityLevel === 'unanswered',
	                    onClick: this.prioritySelected
	                  }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '4',
	                    id: '4',
	                    content: tooltips[4].placement,
	                    place_tip: tooltips[4].text_align
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().LENGTH,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '0',
	                    id: '0',
	                    content: this.state.tooltips[0].placement,
	                    place_tip: this.state.tooltips[0].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                quiz_length_state_data
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().COMPLETED_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '2',
	                    id: '2',
	                    content: this.state.tooltips[2].placement,
	                    place_tip: this.state.tooltips[2].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      getallcompleteQuiz_data
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa2_2023Quizzes;
	}(_react.Component);
	
	Cfa2_2023Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this7 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this7.toggle = _this7.toggle.bind(_this7);
	    _this7.state = {
	      tooltipOpen: false
	    };
	    return _this7;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	exports.default = Cfa2_2023Quizzes;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1003);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _toast = __webpack_require__(15);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfavideodisplay = function (_Component) {
	  _inherits(Cfavideodisplay, _Component);
	
	  function Cfavideodisplay(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, Cfavideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (Cfavideodisplay.__proto__ || Object.getPrototypeOf(Cfavideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/trackUserVideowatch', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment,
	        videoIndex: _this.state.currentUrl,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          // FD.callAPI(
	          //   App_data.backend_api + '/cfa_2_2027question_bank/videoGetFlashCards',
	          //   params
	          // ).then((response) => {
	          //   if (response.success) {
	          //     this.setState({ ValidToken: true });
	          //     if (response.flash_cards.length > 0) {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	          //       });
	          //       var flash_cards = response.flash_cards.map((items) => (
	          //         <li key={items.id}>
	          //           <div className=''>
	          //             <ul className='icon_list'>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._editFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-pencil' />
	          //                 </a>
	          //               </li>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._deleteFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-close' />
	          //                 </a>
	          //               </li>
	          //             </ul>
	          //             <div className={this.state.flash_class}>
	          //               <h4 />
	          //               <p>{items.flash_card}</p>
	          //             </div>
	          //           </div>
	          //         </li>
	          //       ));
	          //     } else {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //       });
	          //       var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     }
	          //     this.setState({ flash_data: flash_cards });
	          //   } else {
	          //     var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     this.setState({ ValidToken: false });
	          //     this.setState({ flash_data: flash_cards });
	          //     this.setState({
	          //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //     });
	          //   }
	          //   return response;
	          // });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      var path = _AppRoutes2.default.CFA2_2027_VIDEO_LESSONS;
	      _this.context.router.push({
	        // pathname: '/cfa2_2027_videolessons/',
	        pathname: path,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.moveToNotes = function (reading, e) {
	      var final_exam = [];
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, storage_session, _data;
	
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context2.next = 6;
	                        return _Cfa2Subscription4.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	
	                        if (isInArray_var) {
	                          storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                          if (storage_session) {
	                            _data = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              reading_id: _this.state.currentReadingNo,
	                              chapter_id: _this.state.currentChapterNo,
	                              offset: 0,
	                              limit: 10
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes', _data).then(function (resp) {
	                              console.log(resp);
	                              if (resp.success) {
	                                console.log('resp.questions ---------------> ', resp.questions, resp.questions.length);
	                                if (resp.questions.length) {
	                                  var path = _AppRoutes2.default.CFA2_2027_NOTES_QUES_VIEW.replace(':chapter_no', _this.state.currentChapterNo).replace(':id', _this.state.currentReadingNo).replace(':reading', _this.state.currentReadingTitle);
	                                  _this.context.router.push({
	                                    pathname: path,
	                                    state: {
	                                      token: _this.state.token,
	                                      idname: _this.state.idname,
	                                      reading: {
	                                        id: _this.state.currentReadingNo,
	                                        chapter_no: _this.state.currentChapterNo,
	                                        reading: _this.state.currentReadingTitle,
	                                        chapter: _this.state.currentChapterNo
	                                      }
	                                    }
	                                  });
	                                } else {
	                                  (0, _toast.showFailure)('No Notes found');
	                                }
	                              } else {
	                                console.log('resp.fail');
	                              }
	                              return resp;
	                            });
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x3) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp);
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                // console.log(exam_data);
	                // console.log(selectedmen);
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                  if (storage_session) {
	                    var _data2 = {
	                      idname: storage_session['idname'],
	                      token: storage_session['token'],
	                      reading_id: _this.state.currentReadingNo,
	                      chapter_id: _this.state.currentChapterNo,
	                      offset: 0,
	                      limit: 10
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa2_2027_notes/getNotes', _data2).then(function (resp) {
	                      // console.log(resp);
	                      if (resp.success) {
	                        console.log('resp.questions ---------------> ', resp.questions, resp.questions.length);
	                        if (resp.questions.length) {
	                          var path = _AppRoutes2.default.CFA2_2027_NOTES_QUES_VIEW.replace(':chapter_no', _this.state.currentChapterNo).replace(':id', _this.state.currentReadingNo).replace(':reading', _this.state.currentReadingTitle);
	                          _this.context.router.push({
	                            pathname: path,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              reading: {
	                                id: _this.state.currentReadingNo,
	                                chapter_no: _this.state.currentChapterNo,
	                                reading: _this.state.currentReadingTitle,
	                                chapter: _this.state.currentChapterNo
	                              }
	                            }
	                          });
	                        } else {
	                          (0, _toast.showFailure)('No Notes found');
	                        }
	                      } else {
	                        console.log('resp.fail');
	                      }
	                      return resp;
	                    });
	                  }
	                } else {
	                  console.log('work');
	
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context3.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context3.next = 6;
	                        return _Cfa2Subscription4.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context3.sent;
	
	
	                        if (isInArray_var) {
	                          _this._runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context3.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this2);
	              }));
	
	              return function (_x4) {
	                return _ref3.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp);
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa2Subscription2.default.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context4.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(index, url_id, title, id, url_id_qq, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context7.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file
	                }, function () {
	                  var path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                  _this.context.router.push({
	                    pathname: path
	                  });
	                });
	
	                _context7.next = 4;
	                return _this.savelastVideo(id, index);
	
	              case 4:
	                _context7.next = 6;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 6:
	                _context7.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context5.next = 6;
	                                  return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context5.sent;
	
	                                  if (!isInArray_var) {
	                                    _context5.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    var path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                                    _this.context.router.push({
	                                      pathname: path
	                                    });
	                                  });
	                                  _context5.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context5.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context5.abrupt('return');
	
	                                case 16:
	                                  return _context5.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context5.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this2);
	                        }));
	
	                        return function (_x13) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                      // console.log("if working");
	
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee6$(_context6) {
	                            while (1) {
	                              switch (_context6.prev = _context6.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context6.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context6.next = 6;
	                                  return _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context6.sent;
	
	                                  if (!isInArray_var) {
	                                    _context6.next = 16;
	                                    break;
	                                  }
	
	                                  // console.log('IF WORKING')
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    var path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                                    _this.context.router.push({
	                                      pathname: path
	                                    });
	                                  });
	                                  _context6.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context6.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context6.abrupt('return');
	
	                                case 16:
	                                  return _context6.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context6.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context6.stop();
	                              }
	                            }
	                          }, _callee6, _this2);
	                        }));
	
	                        return function (_x14) {
	                          return _ref7.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(id, index) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context8.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x15, _x16) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      // console.log('_saveFavVideo', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	
	          return resp;
	        });
	      }
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state3 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state3, 'MessageTitle', messageTitle_cfa), _defineProperty(_this$state3, 'MessageContent', _alertMessage2.default.messageContent_cfa_1), _defineProperty(_this$state3, 'token', ''), _defineProperty(_this$state3, 'idname', ''), _defineProperty(_this$state3, 'ValidToken', false), _defineProperty(_this$state3, 'all_questions', ''), _defineProperty(_this$state3, 'chapters', []), _defineProperty(_this$state3, 'all_questions_state', []), _defineProperty(_this$state3, 'video_display', ''), _defineProperty(_this$state3, 'video_display_qq', ''), _defineProperty(_this$state3, 'url_id', ''), _defineProperty(_this$state3, 'currentUrl', ''), _defineProperty(_this$state3, 'reportLoading', false), _defineProperty(_this$state3, 'free', ''), _defineProperty(_this$state3, 'video_title', ''), _defineProperty(_this$state3, 'video_display_no', ''), _defineProperty(_this$state3, 'allChapters', []), _defineProperty(_this$state3, 'Chapter_Title', ''), _defineProperty(_this$state3, 'chapterName', ''), _defineProperty(_this$state3, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state3, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state3, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state3, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state3, 'currentReading', _this.props.params.id), _defineProperty(_this$state3, 'comment_update_id', ''), _defineProperty(_this$state3, 'currentChapterNo', ''), _defineProperty(_this$state3, 'currentReadingNo', ''), _defineProperty(_this$state3, 'currentReadingTitle', ''), _defineProperty(_this$state3, 'subscriptionstatus', ''), _defineProperty(_this$state3, 'selectedmenu', 'cfa_2'), _defineProperty(_this$state3, 'subscription_details_for_isActive', ''), _defineProperty(_this$state3, 'pdfData', []), _defineProperty(_this$state3, 'pdf_file', ''), _defineProperty(_this$state3, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state3, 'userType', ''), _defineProperty(_this$state3, 'isFlashCardHidden', true), _defineProperty(_this$state3, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state3, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state3, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state3, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state3, 'bookmarkColor', ''), _defineProperty(_this$state3, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _this$state3);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(Cfavideodisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
	      // const result = getDeviceDetails();
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	      var path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium ? 1 : 0).replace(':type', this.props.params.type ? 1 : 0).replace(':chapter_id', this.props.params.chapter_id ? this.props.params.chapter_id : this.props.params.id).replace(':index', this.state.currentUrl + 1);
	      this.context.router.push({
	        pathname: path
	      });
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        // if (this.state.currentUrl || this.state.currentUrl) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("_goToPreviousReading-tooogle");
	              return _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    // console.log('IF WORKING')
	                    // console.log("_goToPreviousReading Premium");
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      console.log('currentUrl', this.state.currentUrl);
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      var path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium ? 1 : 0).replace(':type', this.props.params.type ? 1 : 0).replace(':chapter_id', this.props.params.chapter_id ? this.props.params.chapter_id : this.props.params.id).replace(':index', this.state.currentUrl + 1);
	      this.context.router.push({
	        pathname: path
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context9.next = 16;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this4.state.selectedmenu;
	                          isInArray_var = false;
	                          _context9.next = 6;
	                          return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                        case 6:
	                          isInArray_var = _context9.sent;
	
	                          if (!isInArray_var) {
	                            _context9.next = 13;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({
	                              video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                            });
	                            _this4.setState({
	                              video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                            });
	                            _this4.setState({
	                              video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                            });
	                            _this4.setState({
	                              currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                            });
	                            _this4.setState({
	                              currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                            });
	                            _this4.setState({
	                              currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                            });
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context9.abrupt('return');
	
	                        case 13:
	                          return _context9.abrupt('return', _this4.toggleAlert());
	
	                        case 14:
	                          _context9.next = 17;
	                          break;
	
	                        case 16:
	                          console.log('fail');
	
	                        case 17:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this4);
	                }));
	
	                return function (_x17) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("working");
	              // console.log("_goToNextReading toggleAlert");
	
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    // console.log("_goToNextReading Premium");
	
	                    // console.log('IF WORKING')
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id_2025
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no_2025
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getQuestions', data).then(function (resp) {
	        // console.log("resp");
	        // console.log(resp);
	        // console.log("resp");
	        // console.log(resp.questions.length);
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: '/cfa2/2027/cases/' + _this5.state.currentChapterNo + '/' + _this5.state.currentReadingTitle + '/' + _this5.state.currentReadingTitle.length,
	              state: {
	                token: _this5.state.token,
	                idname: _this5.state.idname,
	                reading: {
	                  id: _this5.state.currentReadingNo,
	                  chapter_no: _this5.state.currentChapterNo,
	                  reading: _this5.state.currentReadingTitle
	                },
	                subscriptionstatus: _this5.state.subscriptionstatus
	              }
	            });
	          } else {
	            _this5.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(prevProps, prevState) {
	        var params;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context10.next = 5;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context10.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/cfa_2_2027question_bank/videoGetFlashCards',
	                //   params
	                // ).then((response) => {
	                //   var flash_cards = '';
	                //   if (response.success) {
	                //     this.setState({ ValidToken: true });
	                //     if (response.flash_cards.length > 0) {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                //       });
	                //       flash_cards = response.flash_cards.map((items, index) => (
	                //         <li key={index}>
	                //           <div className=''>
	                //             <ul className='icon_list'>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._editFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-pencil' />
	                //                 </a>
	                //               </li>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._deleteFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-close' />
	                //                 </a>
	                //               </li>
	                //             </ul>
	                //             <div className={this.state.flash_class}>
	                //               <h4 />
	                //               <p>{items.flash_card}</p>
	                //             </div>
	                //           </div>
	                //         </li>
	                //       ));
	                //     } else {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //       });
	                //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     }
	                //     this.setState({ flash_data: flash_cards });
	                //   } else {
	                //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     this.setState({ ValidToken: false });
	                //     this.setState({ flash_data: flash_cards });
	                //     this.setState({
	                //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //     });
	                //   }
	                // });
	
	              case 5:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function componentDidUpdate(_x18, _x19) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this6 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context12.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                console.log('this.props ----> ', this.props);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  // console.log('IF Working');
	                  this.setState({
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id || this.props.params.id
	                };
	                _context12.next = 15;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getcfa2videosChapterwise', data).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            console.log('/cfa_2_2027question_bank/getcfa2videosChapterwise -----> ', resp.cfavchapter);
	
	                            if (!resp.success) {
	                              _context11.next = 29;
	                              break;
	                            }
	
	                            _context11.next = 4;
	                            return _this6.setState({ ValidToken: true });
	
	                          case 4:
	                            _context11.next = 6;
	                            return _this6.setState({ chapters: resp.cfavchapter });
	
	                          case 6:
	                            _context11.next = 8;
	                            return _this6.setState({
	                              pdf_file: _this6.state.chapters[_this6.state.currentUrl] ? _this6.state.chapters[_this6.state.currentUrl].pdf_file : null
	                            });
	
	                          case 8:
	                            console.log(_this6.state.chapters, '===> ', _this6.state.currentUrl, _this6.state.chapters[_this6.state.currentUrl.id]);
	                            _context11.next = 11;
	                            return _this6.setState({
	                              currentReading: _this6.state.chapters[_this6.state.currentUrl].id
	                            });
	
	                          case 11:
	                            _context11.next = 13;
	                            return _this6.setState({
	                              video_display: _this6.state.chapters[_this6.state.currentUrl].url_id
	                            });
	
	                          case 13:
	                            _context11.next = 15;
	                            return _this6.setState({
	                              video_display_qq: _this6.state.chapters[_this6.state.currentUrl].url_id_qq
	                            });
	
	                          case 15:
	                            _context11.next = 17;
	                            return _this6.setState({
	                              video_display_previous: _this6.state.chapters[_this6.state.currentUrl].url_id
	                            });
	
	                          case 17:
	                            _context11.next = 19;
	                            return _this6.setState({
	                              video_title: _this6.state.chapters[_this6.state.currentUrl].title
	                            });
	
	                          case 19:
	                            _context11.next = 21;
	                            return _this6.setState({
	                              video_display_next: _this6.state.chapters[_this6.state.currentUrl + 1] ? _this6.state.chapters[_this6.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 21:
	                            _context11.next = 23;
	                            return _this6.setState({
	                              currentChapterNo: _this6.state.chapters[_this6.state.currentUrl].chapter_id_2025
	                            });
	
	                          case 23:
	                            _context11.next = 25;
	                            return _this6.setState({
	                              currentReadingNo: _this6.state.chapters[_this6.state.currentUrl].reading_no_2025
	                            });
	
	                          case 25:
	                            _context11.next = 27;
	                            return _this6.setState({
	                              currentReadingTitle: _this6.state.chapters[_this6.state.currentUrl].title
	                            });
	
	                          case 27:
	                            _context11.next = 30;
	                            break;
	
	                          case 29:
	                            _this6.setState({ ValidToken: false });
	
	                          case 30:
	                            return _context11.abrupt('return', resp);
	
	                          case 31:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this6);
	                  }));
	
	                  return function (_x20) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 15:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context12.next = 18;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 18:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/cfa_2_2027question_bank/videoGetFlashCards',
	                //   params
	                // ).then((response) => {
	                //   var flash_cards = '';
	                //   if (response.success) {
	                //     this.setState({ ValidToken: true });
	                //     if (response.flash_cards.length > 0) {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                //       });
	                //       flash_cards = response.flash_cards.map((items, index) => (
	                //         <li key={index}>
	                //           <div className=''>
	                //             <ul className='icon_list'>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._editFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-pencil' />
	                //                 </a>
	                //               </li>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._deleteFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-close' />
	                //                 </a>
	                //               </li>
	                //             </ul>
	                //             <div className={this.state.flash_class}>
	                //               <h4 />
	                //               <p>{items.flash_card}</p>
	                //             </div>
	                //           </div>
	                //         </li>
	                //       ));
	                //     } else {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //       });
	                //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     }
	                //     this.setState({ flash_data: flash_cards });
	                //   } else {
	                //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     this.setState({ ValidToken: false });
	                //     this.setState({ flash_data: flash_cards });
	                //     this.setState({
	                //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //     });
	                //   }
	                // });
	
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context12.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getcfa_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this6.setState({ pdfData: resp });
	                  } else {
	                    _this6.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 22:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          type = _state.type,
	          questionsCSS = _state.questionsCSS,
	          saveVideo_text = _state.saveVideo_text,
	          currentReading = _state.currentReading,
	          chapters = _state.chapters,
	          showFreePremium = _state.showFreePremium,
	          pdf_file = _state.pdf_file;
	
	
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this7.state.showFreePremium ? item.free === 1 || type === 'intro' ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id === _this7.state.video_display ? 'active' : '',
	                    onClick: _this7.getVideourl.bind(_this7, index, item.url_id, item.title, item.id, item.url_id_qq, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8 mb-1' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'mb-0' },
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        width: '100%',
	                        allowFullScreen: '1',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + this.state.video_display_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef',
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        frameBorder: '0',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportIcons2.default, {
	              moveToNotes: this.moveToNotes,
	              notesCSS: this.state.notesCSS,
	              moveToPracticeQuestions: this.moveToPracticeQuestions,
	              _saveFavVideo: this._saveFavVideo,
	              _displayReportForm: this._displayReportForm,
	              viewPdf: this.pdfOpen,
	              pdfFile: pdf_file,
	              bookmarkCSS: bookmarkCSS,
	              bookmarkColor: bookmarkColor,
	              type: type,
	              questionsCSS: questionsCSS,
	              saveVideo_text: saveVideo_text,
	              currentReading: currentReading,
	              chapters: chapters,
	              showFreePremium: showFreePremium,
	              noPDFInExam: pdf_file ? false : true
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: currentReading },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa_2_2027'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT,
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfavideodisplay;
	}(_react.Component);
	
	Cfavideodisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.resizeListener = function () {
	      // write code here
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	    };
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13() {
	        var _this9 = this;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context13.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this9.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, this);
	      }));
	
	      function componentDidMount() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfavideodisplay;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa2Subscription = __webpack_require__(31);
	
	var _Cfa2Subscription2 = _interopRequireDefault(_Cfa2Subscription);
	
	var _Cfa2Subscription3 = __webpack_require__(32);
	
	var _Cfa2Subscription4 = _interopRequireDefault(_Cfa2Subscription3);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1004);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var VideoLessons = function (_Component) {
	  _inherits(VideoLessons, _Component);
	
	  function VideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, VideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (VideoLessons.__proto__ || Object.getPrototypeOf(VideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getcfa2videosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', resp.cfavchapterfirst.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.cfavchapterfirst.chapter_id_2025).replace(':index', 0)
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt, path;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              // console.log('last video caseIndex -----> ', lastRecord);
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', lastRecord.cfa2_2027_video.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', lastRecord.cfa2_2027_video.chapter_id === 0 ? 0 : 1).replace(':chapter_id', lastRecord.cfa2_2027_video.chapter_id).replace(':index', lastRecord.caseIndex);
	
	                _this.context.router.push({
	                  pathname: path,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.cfa2_2027_video,
	                    index: lastRecord.videoIndex,
	                    showFreePremium: _this.state.showFreePremium
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'cfa_2',
	      exams: [],
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      lastAttempt: false,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(VideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this3);
	                              }));
	
	                              return function (_x5) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context6.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context6.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                // console.log('selectedmen ------> ', selectedmen);
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    // console.log(resp.exams[0])
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getlastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 12:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      //console.log(language.LC())
	      //console.log(this.state.showFreePremium);
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      // console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  ' ',
	                  item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement(
	                  'h1',
	                  { className: 'text-danger font-weight-bold text-center' },
	                  _language2.default.LC().COMING_SOON + '....'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement('div', { className: 'card' })
	                  ),
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent,
	            exam: _constant.examNameAccordingToDB.CFA_2
	          })
	        )
	      );
	    }
	  }]);
	
	  return VideoLessons;
	}(_react.Component);
	
	VideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	var ChatperwiseReadingData = function (_Component2) {
	  _inherits(ChatperwiseReadingData, _Component2);
	
	  function ChatperwiseReadingData(props) {
	    var _this6 = this,
	        _this5$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this5 = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this5.toggleAlert = function () {
	      _this5.setState({
	        alert_status: !_this5.state.alert_status
	      });
	    };
	
	    _this5.goPremium = function () {
	      _this5.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this5.state.token,
	          idname: _this5.state.idname,
	          selectedMenu: _this5.state.selectedmenu
	        }
	      });
	    };
	
	    _this5._getReadings = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.next = 2;
	                return _this5.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this5.state.token,
	                    idname: _this5.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this5.state.user_city,
	                    country: _this5.state.user_country,
	                    state: _this5.state.user_state,
	                    continent: _this5.state.user_continent,
	                    ip: _this5.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/trackUserVideowatch', data).then(function () {
	                    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                      var path;
	                      return _regenerator2.default.wrap(function _callee8$(_context8) {
	                        while (1) {
	                          switch (_context8.prev = _context8.next) {
	                            case 0:
	                              if (resp.success) {
	                                path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id_2025).replace(':index', index);
	
	                                _this5.context.router.push({
	                                  pathname: path,
	                                  state: {
	                                    token: _this5.state.token,
	                                    idname: _this5.state.idname,
	                                    chapter: chapter,
	                                    index: index,
	                                    showFreePremium: _this5.state.showFreePremium
	                                  }
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context8.stop();
	                          }
	                        }
	                      }, _callee8, _this6);
	                    }));
	
	                    return function (_x8) {
	                      return _ref9.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _data = { token: _this5.state.token, idname: _this5.state.idname };
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      // console.log('I am here -----------> ', resp.profileInfo);
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this5.toggleAlert();
	                      } else {
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data2;
	
	                            return _regenerator2.default.wrap(function _callee10$(_context10) {
	                              while (1) {
	                                switch (_context10.prev = _context10.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context10.next = 10;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this5.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context10.next = 6;
	                                    return _Cfa2Subscription4.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                  case 6:
	                                    isInArray_var = _context10.sent;
	
	
	                                    if (isInArray_var) {
	                                      _data2 = {
	                                        token: _this5.state.token,
	                                        idname: _this5.state.idname,
	                                        id: chapter.id,
	                                        videoIndex: index,
	                                        city: _this5.state.user_city,
	                                        country: _this5.state.user_country,
	                                        state: _this5.state.user_state,
	                                        continent: _this5.state.user_continent,
	                                        ip: _this5.state.user_ip
	                                      };
	
	                                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/trackUserVideowatch', _data2).then(function () {
	                                        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                                          var path;
	                                          return _regenerator2.default.wrap(function _callee9$(_context9) {
	                                            while (1) {
	                                              switch (_context9.prev = _context9.next) {
	                                                case 0:
	                                                  if (resp.success) {
	                                                    path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id_2025).replace(':index', index);
	
	                                                    _this5.context.router.push({
	                                                      pathname: path,
	                                                      state: {
	                                                        token: _this5.state.token,
	                                                        idname: _this5.state.idname,
	                                                        chapter: chapter,
	                                                        index: index,
	                                                        showFreePremium: _this5.state.showFreePremium
	                                                      }
	                                                    });
	                                                  } else {}
	
	                                                case 1:
	                                                case 'end':
	                                                  return _context9.stop();
	                                              }
	                                            }
	                                          }, _callee9, _this6);
	                                        }));
	
	                                        return function (_x10) {
	                                          return _ref11.apply(this, arguments);
	                                        };
	                                      }());
	                                    } else {
	                                      _this5.toggleAlert();
	                                    }
	                                    _context10.next = 10;
	                                    break;
	
	                                  case 10:
	                                  case 'end':
	                                    return _context10.stop();
	                                }
	                              }
	                            }, _callee10, _this6);
	                          }));
	
	                          return function (_x9) {
	                            return _ref10.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      // console.log('I am here -----------> ', resp.profileInfo);
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                        // console.log('I am here 692');
	                        return _this5.toggleAlert();
	                      } else {
	                        // console.log('I am here 695');
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	                        // console.log('else working');
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data3;
	
	                            return _regenerator2.default.wrap(function _callee12$(_context12) {
	                              while (1) {
	                                switch (_context12.prev = _context12.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context12.next = 13;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this5.state.selectedmenu;
	                                    isInArray_var = false;
	
	                                    isInArray_var = _Cfa2Subscription2.default.checkCfa2VideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    // console.log(isInArray_var);
	
	                                    if (!isInArray_var) {
	                                      _context12.next = 10;
	                                      break;
	                                    }
	
	                                    // console.log('IF WORKING')
	
	                                    _data3 = {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      id: chapter.id,
	                                      videoIndex: index,
	                                      city: _this5.state.user_city,
	                                      country: _this5.state.user_country,
	                                      state: _this5.state.user_state,
	                                      continent: _this5.state.user_continent,
	                                      ip: _this5.state.user_ip
	                                    };
	
	                                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/trackUserVideowatch', _data3).then(function () {
	                                      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                                        var path;
	                                        return _regenerator2.default.wrap(function _callee11$(_context11) {
	                                          while (1) {
	                                            switch (_context11.prev = _context11.next) {
	                                              case 0:
	                                                if (resp.success) {
	                                                  path = _AppRoutes2.default.CFA2_2027_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id_2025).replace(':index', index);
	
	                                                  _this5.context.router.push({
	                                                    pathname: path,
	                                                    state: {
	                                                      token: _this5.state.token,
	                                                      idname: _this5.state.idname,
	                                                      chapter: chapter,
	                                                      index: index,
	                                                      showFreePremium: _this5.state.showFreePremium
	                                                    }
	                                                  });
	                                                } else {}
	
	                                              case 1:
	                                              case 'end':
	                                                return _context11.stop();
	                                            }
	                                          }
	                                        }, _callee11, _this6);
	                                      }));
	
	                                      return function (_x12) {
	                                        return _ref13.apply(this, arguments);
	                                      };
	                                    }());
	                                    _context12.next = 11;
	                                    break;
	
	                                  case 10:
	                                    return _context12.abrupt('return', _this5.toggleAlert());
	
	                                  case 11:
	                                    _context12.next = 13;
	                                    break;
	
	                                  case 13:
	                                  case 'end':
	                                    return _context12.stop();
	                                }
	                              }
	                            }, _callee12, _this6);
	                          }));
	
	                          return function (_x11) {
	                            return _ref12.apply(this, arguments);
	                          };
	                        }()
	                        // console.log('fail');
	                        );
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this6);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this5.savelastVideo = function () {
	      var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(chapter, index) {
	        var _this5$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _this5$state = _this5.state, token = _this5$state.token, idname = _this5$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  caseIndex: index
	                };
	                _context14.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this6);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref14.apply(this, arguments);
	      };
	    }();
	
	    _this5.iframe = {
	      padding: 10
	    };
	
	    _this5.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	      if (_this5.state.allchapters.length) {
	        data = _this5.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          var count = 0;
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this5.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              width: '100%',
	              src: item.posterImage ? item.posterImage : 'https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1.jpg',
	              onError: function onError(_ref15) {
	                var currentTarget = _ref15.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	
	                  currentTarget.onerror = null; // prevents looping
	
	                  currentTarget.src = '\n                    https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1_2.jpg';
	                }
	              },
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row',
	              alt: 'flow player image'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row',
	              alt: 'youtube image'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this5.state = (_this5$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_2,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this5$state2, 'offset', 0), _defineProperty(_this5$state2, 'limit', 10), _defineProperty(_this5$state2, 'Allchapters', []), _defineProperty(_this5$state2, 'itemData', []), _defineProperty(_this5$state2, 'videoUrl', ''), _defineProperty(_this5$state2, 'srcUrl', ''), _defineProperty(_this5$state2, 'srcUrl_final', ''), _defineProperty(_this5$state2, 'selectedmenu', 'cfa_2'), _defineProperty(_this5$state2, 'showFreePremium', true), _defineProperty(_this5$state2, 'user_city', ''), _defineProperty(_this5$state2, 'user_country', ''), _defineProperty(_this5$state2, 'user_ip', ''), _defineProperty(_this5$state2, 'user_state', ''), _defineProperty(_this5$state2, 'user_continent', ''), _this5$state2);
	    return _this5;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	        var _this7 = this;
	
	        var result, storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _context15.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context15.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context15.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2027question_bank/getcfa2videosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this7.setState({ allchapters: [] });
	                    _this7.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, this);
	      }));
	
	      function componentDidMount() {
	        return _ref16.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      //console.log(this.state.showFreePremium);
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_2
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = VideoLessons;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa3BeforeStart = function (_Component) {
	  _inherits(Cfa3BeforeStart, _Component);
	
	  function Cfa3BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa3BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3BeforeStart.__proto__ || Object.getPrototypeOf(Cfa3BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/cfa3/quizzes',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuizpage = function () {
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          var data_arr, dataset;
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      _this.setState({
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var, examPlanData;
	                          return _regenerator2.default.wrap(function _callee$(_context) {
	                            while (1) {
	                              switch (_context.prev = _context.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context.next = 11;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  examPlanData = resp_exam.examPlan[0];
	                                  _context.next = 7;
	                                  return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                case 7:
	                                  isInArray_var = _context.sent;
	
	                                  if (isInArray_var) {
	                                    _this.context.router.push({
	                                      pathname: '/cfa3/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                      state: {
	                                        token: _this.state.token,
	                                        idname: _this.state.idname,
	                                        quiz_id: _this.state.quiz_id,
	                                        offset: _this.state.offset_send
	                                      }
	                                    });
	                                  } else {
	                                    _this.toggleAlert();
	                                  }
	                                  _context.next = 12;
	                                  break;
	
	                                case 11:
	                                  console.log('fail');
	
	                                case 12:
	                                case 'end':
	                                  return _context.stop();
	                              }
	                            }
	                          }, _callee, _this2);
	                        }));
	
	                        return function (_x2) {
	                          return _ref2.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                      _this.toggleAlert();
	                    } else {
	                      _this.setState({
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this.state.selectedmenu;
	                          var isInArray_var = false;
	                          isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                          if (isInArray_var) {
	                            _this.context.router.push({
	                              pathname: '/cfa3/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                              state: {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                quiz_id: _this.state.quiz_id,
	                                offset: _this.state.offset_send
	                              }
	                            });
	                          } else {
	                            _this.toggleAlert();
	                          }
	                        } else {
	                          console.log('fail');
	                        }
	                      });
	                    }
	                  }
	
	                case 1:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.startQuizquestion = function (item, offset_va, e) {
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	          var data_arr, dataset;
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (!(resp.profileInfo.role === 'partner')) {
	                    _context4.next = 12;
	                    break;
	                  }
	
	                  if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                    _context4.next = 5;
	                    break;
	                  }
	
	                  _this.toggleAlert();
	                  _context4.next = 10;
	                  break;
	
	                case 5:
	                  _this.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  dataset = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    examid: data_arr
	                  };
	                  _context4.next = 10;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var, examPlanData;
	                      return _regenerator2.default.wrap(function _callee3$(_context3) {
	                        while (1) {
	                          switch (_context3.prev = _context3.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context3.next = 11;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this.state.selectedmenu;
	                              isInArray_var = false;
	                              examPlanData = resp_exam.examPlan[0];
	                              _context3.next = 7;
	                              return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                            case 7:
	                              isInArray_var = _context3.sent;
	
	                              if (isInArray_var) {
	                                _this.context.router.push({
	                                  pathname: '/cfa3/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                                  state: {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    quiz_id: _this.state.quiz_id,
	                                    offset: offset_va
	                                  }
	                                });
	                              } else {
	                                _this.toggleAlert();
	                              }
	                              _context3.next = 12;
	                              break;
	
	                            case 11:
	                              console.log('fail');
	
	                            case 12:
	                            case 'end':
	                              return _context3.stop();
	                          }
	                        }
	                      }, _callee3, _this2);
	                    }));
	
	                    return function (_x4) {
	                      return _ref4.apply(this, arguments);
	                    };
	                  }());
	
	                case 10:
	                  _context4.next = 13;
	                  break;
	
	                case 12:
	                  if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                    _this.toggleAlert();
	                  } else {
	                    _this.setState({
	                      cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                      cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                    });
	                    data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                    dataset = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      examid: data_arr
	                    };
	
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                      if (resp_exam.success) {
	                        var exam_data = resp_exam.examData;
	                        var selectedmen = _this.state.selectedmenu;
	                        var isInArray_var = false;
	                        isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                        if (isInArray_var) {
	                          _this.context.router.push({
	                            pathname: '/cfa3/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              quiz_id: _this.state.quiz_id,
	                              offset: offset_va
	                            }
	                          });
	                        } else {
	                          _this.toggleAlert();
	                        }
	                      } else {
	                        console.log('fail');
	                      }
	                    });
	                  }
	
	                case 13:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this2);
	        }));
	
	        return function (_x3) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    };
	
	    var messageTitle_cfa_3 = '<i class="icon-info icons font-2xl d-block "></i>';
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa_3,
	      MessageContent: _alertMessage2.default.messageContent_cfa_3,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      all_cases_id: [],
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'cfa_3',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa3BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    //Function to redirect page to Create Quiz page
	
	
	    //Function to redirect page to begin Quiz page
	
	
	    //Function to redirect page to begin Quiz page
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var all_questions = JSON.parse(resp.singlequiz);
	          var all_cases = JSON.parse(resp.case_id);
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this3.setState({ timer_value: minutes });
	          _this3.setState({ all_question_id: all_questions });
	          _this3.setState({ all_cases_id: all_cases });
	          _this3.setState({ question_length: resp.questions_count });
	          _this3.setState({ user_time_value: resp.user_time_value });
	        }
	      });
	
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var all_question_id = this.state.all_question_id;
	      var all_cases = this.state.all_cases_id;
	      var case_id_display = '';
	
	      if (all_cases.length) {
	        case_id_display = all_cases.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'case_head' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20 margin_top_10' },
	                _language2.default.LC().CASE,
	                ': ',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  className: 'float-right btn btn-primary',
	                  onClick: _this4.startQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'table-responsive' },
	              _react2.default.createElement(
	                'table',
	                { className: 'table_white_bg table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    { className: 'border_top_0' },
	                    _react2.default.createElement(
	                      'th',
	                      { width: '90' },
	                      '#'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().QUESTIONS
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { width: '200' },
	                      _language2.default.LC().YOURS_ANSWER
	                    )
	                  )
	                ),
	                _react2.default.createElement(Questionfetch, {
	                  indexval: index,
	                  casesquestion: all_question_id[index],
	                  token: _this4.state.token,
	                  idname: _this4.state.idname,
	                  quiz_id: _this4.state.quiz_id,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      }
	
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.question_length
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.question_length
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          'Continue'
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ': ',
	              this.state.quiz_id
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this._createQuizpage.bind(this)
	              },
	              _language2.default.LC().CREATE_NEW_QUIZ
	            )
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().NO_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().CORRECT_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().WRONG_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWER
	              ),
	              case_id_display
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	        })
	      );
	    }
	  }]);
	
	  return Cfa3BeforeStart;
	}(_react.Component);
	
	Cfa3BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var Questionfetch = function (_React$Component) {
	  _inherits(Questionfetch, _React$Component);
	
	  function Questionfetch() {
	    _classCallCheck(this, Questionfetch);
	
	    return _possibleConstructorReturn(this, (Questionfetch.__proto__ || Object.getPrototypeOf(Questionfetch)).apply(this, arguments));
	  }
	
	  _createClass(Questionfetch, [{
	    key: 'render',
	    value: function render() {
	      var casesquestion = this.props.casesquestion;
	      var token = this.props.token;
	      var idname = this.props.idname;
	      var quiz_id = this.props.quiz_id;
	      var answeredstate = this.props.answered_state;
	      // let handler=this.props.handler;
	      var caseQuestionval = Object.keys(casesquestion).map(function (key) {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            parseInt(key) + 1
	          ),
	          _react2.default.createElement('td', { id: 'questionNameId_' + answeredstate + '_' + key }),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(QuestionFetchcheck, {
	              answered_state: answeredstate + '_' + key,
	              question_id: casesquestion[key],
	              token: token,
	              idname: idname,
	              quiz_id: quiz_id
	            })
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        caseQuestionval
	      );
	    }
	  }]);
	
	  return Questionfetch;
	}(_react2.default.Component);
	
	function QuestionFetchcheck(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data).then(function (resp) {
	    document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    //console.log(resp);
	    if (resp.success) {
	      if (resp.question_recived.answer === 1) {
	        document.getElementById('user_question_status_' + props.answered_state).id = 'quiz_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Correct Answer';
	      } else {
	        document.getElementById('user_question_status_' + props.answered_state).id = 'quiz_wrong_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Wrong Answer';
	      }
	    } else {
	      document.getElementById('user_question_status_' + props.answered_state).id = 'quiz_notanswered_status';
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = 'No Answer';
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status_' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	exports.default = Cfa3BeforeStart;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Col, Row } from 'reactstrap';
	
	
	/* eslint-disable*/
	
	var Cfa3Beginquiz = function (_Component) {
	  _inherits(Cfa3Beginquiz, _Component);
	
	  function Cfa3Beginquiz(props) {
	    _classCallCheck(this, Cfa3Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3Beginquiz.__proto__ || Object.getPrototypeOf(Cfa3Beginquiz)).call(this, props));
	
	    _this._getAnswer = function (choice, e) {
	      var selectedChoice = '';
	      if (typeof choice === 'string') {
	        selectedChoice = choice.startsWith('choice_') ? choice : 'choice_' + choice;
	      } else if (Array.isArray(choice) && typeof choice[0] === 'string') {
	        selectedChoice = choice[0].startsWith('choice_') ? choice[0] : 'choice_' + choice[0];
	      }
	      _this.setState({ choice: selectedChoice, selectedChoice: selectedChoice, clicked: false });
	      var choices = ['choice_a', 'choice_b', 'choice_c'];
	      var updatedChoices = choices.reduce(function (acc, choice) {
	        acc[choice] = choice === selectedChoice ? 'answer_box clicked_box' : 'answer_box';
	        return acc;
	      }, {});
	      _this.setState(updatedChoices);
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.state.chapter_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: '' });
	            _this.setState({
	              save_text: '' + _messages.messages.SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._getResult = function (item, e) {
	      var chosen_answer = _this.state.choice;
	      if (chosen_answer && !_this.state.clicked) {
	        clearInterval(_this.timer);
	        var right_answer = 0;
	        _this.setState({ result_block: 'card show_block', clicked: true });
	        if ('choice_' + item.answer === chosen_answer) {
	          right_answer = 1;
	          if (chosen_answer === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (chosen_answer === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (chosen_answer === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (chosen_answer === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box failure' });
	          } else if (chosen_answer === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box failure' });
	          } else if (chosen_answer === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box failure' });
	          }
	          if (item.answer === 'a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.answer === 'b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (item.answer === 'c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          }
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: 'INCORRECT',
	            result_block: 'card show_block'
	          });
	        }
	
	        var idx = _this.state.question_offset;
	        var questionsCopy = [].concat(_toConsumableArray(_this.state.questions));
	        if (questionsCopy[idx]) {
	          if (!questionsCopy[idx].cfa3_2025_answer_quizzes) {
	            questionsCopy[idx].cfa3_2025_answer_quizzes = {};
	          }
	          questionsCopy[idx].cfa3_2025_answer_quizzes.selected_choice = chosen_answer;
	          questionsCopy[idx]['cfa3_2025_answer_quizzes.selected_choice'] = chosen_answer;
	          _this.setState({ questions: questionsCopy });
	        }
	
	        if (!_this.state.validated) {
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.questions[_this.state.question_offset].id,
	            answer: right_answer,
	            selectedChoice: _this.state.choice
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/answerQuiz', data).then(function (resp) {
	            if (resp.success) {
	              var data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                question_id: _this.state.questions[_this.state.question_offset].id,
	                right_answer: right_answer,
	                time_done: 0,
	                chapter_id: _this.state.chapter_id,
	                selected_choice: _this.state.choice
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveStats', data).then(function (resp) {});
	              _this.setState({ ValidToken: true, validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/cfa3/beforestart/' + _this.state.quiz_id + '/' + 'abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon'
	        }
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.clicked || _this.state.validated) {
	        return;
	      }
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(function () {
	          return _this.timerTick();
	        }, 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment') ? document.getElementById('comment').value : null;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(2000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(2000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-md-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({ flash_form: 'col-md-12 display_block' });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      clearInterval(_this.timer);
	
	      var index_id = _this.state.question_offset + 1;
	      if (index_id === _this.state.questions.length) {
	        _this.setState({
	          showCompletionQuestion: true,
	          next_block: 'card hide_block',
	          markCompleted: false,
	          markAsCompleted: false,
	          markAsNotCompleted: false,
	          display_cases: 'display_block'
	        });
	      } else {
	        _this.setState({ clicked: false });
	        _this.setState({
	          display_loader: 'show_block',
	          already_answered_status: '',
	          validated: false,
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _messages.messages.SAVE_QUESTION,
	          report_block: 'card hide_block',
	          showCompletionQuestion: false,
	          lastCase: _this.state.cases_display.id,
	          ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	          rating: 0,
	          bookmarkColor: ''
	        });
	
	        document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	        _this.setState({
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          result_block: 'card hide_block'
	        });
	
	        if (index_id > 0) {
	          _this.setState({ previ_block: '' });
	        }
	
	        if (index_id === _this.state.questions.length - 1) {
	          _this.setState({ next_block: '' });
	        } else {
	          _this.setState({ next_block: '' });
	        }
	
	        var questionData = _this.state.questions[index_id];
	        var selectedChoice = questionData['cfa3_2025_answer_quizzes.selected_choice'] || '';
	        var rightAnswer = questionData['cfa3_2025_answer_quizzes.answer'] || '';
	        var answerStatus = questionData['cfa3_2025_answer_quizzes.id'] || '';
	        var showAnswer = false;
	        var selected = '';
	
	        if (selectedChoice) {
	          selected = selectedChoice;
	          showAnswer = true;
	        } else if (answerStatus) {
	          if (rightAnswer === 1) {
	            selected = 'choice_' + questionData.answer;
	            showAnswer = true;
	          } else if (!rightAnswer) {
	            var correct = 'choice_' + questionData.answer;
	            var choices = Object.keys(questionData).filter(function (key) {
	              return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	            });
	            selected = choices.length > 0 ? choices[0] : '';
	            showAnswer = true;
	          }
	        }
	
	        var boxA = 'answer_box',
	            boxB = 'answer_box',
	            boxC = 'answer_box';
	        var result_block = 'card hide_block',
	            text_color = 'card-header',
	            result = '',
	            clicked = false;
	
	        if (selected) {
	          var _correct = questionData.answer ? 'choice_' + questionData.answer : '';
	          if (selected === 'choice_a') {
	            boxA = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_b') {
	            boxB = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_c') {
	            boxC = selected === _correct ? 'answer_box success' : 'answer_box failure';
	          }
	          if (_correct) {
	            if (selected === _correct) {
	              text_color = 'card-header text_success';
	              result = 'CORRECT';
	            } else {
	              text_color = 'card-header text_failure';
	              result = 'INCORRECT';
	            }
	            result_block = 'card show_block';
	          }
	          clicked = true;
	        }
	
	        _this.setState({
	          question_display: questionData,
	          question_offset: index_id,
	          selectedChoice: selected,
	          choice: selected,
	          clicked: clicked,
	          choice_a: boxA,
	          choice_b: boxB,
	          choice_c: boxC,
	          result_block: result_block,
	          text_color: text_color,
	          result: result,
	          showAnswer: showAnswer,
	          selected: selected,
	          display_loader: 'hide_block'
	        });
	
	        var data_check = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: questionData.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data_check).then(function (resp) {
	          _this.setState({ already_answered_status: resp.message });
	        });
	
	        var params_fav = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname,
	          chapter_id: _this.state.chapter_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	          if (responsefav.success) {
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          }
	        });
	
	        // Fetch rating for this question
	        var params_rating = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params_rating).then(function (response) {
	          if (response.success) {
	            _this.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            _this.setState({
	              rating: 0,
	              ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	            });
	          }
	        });
	
	        if (selected || selectedChoice) {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          _this.setState({
	            timer_stop: false,
	            timerstopbtn: 'pause_btn icon-control-pause'
	          });
	          _this.timer = setInterval(function () {
	            return _this.timerTick();
	          }, 1000);
	        }
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ clicked: false });
	      clearInterval(_this.timer);
	      _this.setState({
	        display_loader: 'show_block',
	        already_answered_status: '',
	        validated: false,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _messages.messages.SAVE_QUESTION,
	        report_block: 'card hide_block',
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        bookmarkColor: ''
	      });
	      document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/insertTimer', insert_time).then(function (resp) {});
	
	      var index_id = _this.state.question_offset - 1;
	      if (index_id < 0) {
	        if (_this.state.offset > 0) {
	          _this._getPreviousCase();
	        } else {
	          _this.setState({ previ_block: 'card hide_block' });
	        }
	      } else {
	        if (index_id === 0) {
	          _this.setState({ previ_block: 'card hide_block' });
	        }
	
	        var questionData = _this.state.questions[index_id];
	        var selectedChoice = questionData['cfa3_2025_answer_quizzes.selected_choice'] || '';
	        var rightAnswer = questionData['cfa3_2025_answer_quizzes.answer'] || '';
	        var answerStatus = questionData['cfa3_2025_answer_quizzes.id'] || '';
	        var showAnswer = false;
	        var selected = '';
	
	        if (selectedChoice) {
	          selected = selectedChoice;
	          showAnswer = true;
	        } else if (answerStatus) {
	          if (rightAnswer === 1) {
	            selected = 'choice_' + questionData.answer;
	            showAnswer = true;
	          } else if (!rightAnswer) {
	            var correct = 'choice_' + questionData.answer;
	            var choices = Object.keys(questionData).filter(function (key) {
	              return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	            });
	            selected = choices.length > 0 ? choices[0] : '';
	            showAnswer = true;
	          }
	        }
	
	        var boxA = 'answer_box',
	            boxB = 'answer_box',
	            boxC = 'answer_box';
	        var result_block = 'card hide_block',
	            text_color = 'card-header',
	            result = '',
	            clicked = false;
	
	        if (selected) {
	          var _correct2 = questionData.answer ? 'choice_' + questionData.answer : '';
	          if (selected === 'choice_a') {
	            boxA = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_b') {
	            boxB = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          } else if (selected === 'choice_c') {
	            boxC = selected === _correct2 ? 'answer_box success' : 'answer_box failure';
	          }
	          if (_correct2) {
	            if (selected === _correct2) {
	              text_color = 'card-header text_success';
	              result = 'CORRECT';
	            } else {
	              text_color = 'card-header text_failure';
	              result = 'INCORRECT';
	            }
	            result_block = 'card show_block';
	          }
	          clicked = true;
	        }
	
	        _this.setState({
	          question_display: questionData,
	          question_offset: index_id,
	          selectedChoice: selected,
	          choice: selected,
	          clicked: clicked,
	          choice_a: boxA,
	          choice_b: boxB,
	          choice_c: boxC,
	          result_block: result_block,
	          text_color: text_color,
	          result: result,
	          showAnswer: showAnswer,
	          selected: selected,
	          display_loader: 'hide_block'
	        });
	
	        var data_check = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: questionData.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data_check).then(function (resp) {
	          _this.setState({ already_answered_status: resp.message });
	        });
	
	        var params_fav = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname,
	          chapter_id: _this.state.chapter_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	          if (responsefav.success) {
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          }
	        });
	
	        // Fetch rating for this question
	        var params_rating = {
	          token: _this.state.token,
	          question_id: questionData.id,
	          idname: _this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params_rating).then(function (response) {
	          if (response.success) {
	            _this.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this.setState({
	                rating: items.ratting,
	                ratting_text: '' + _language2.default.LC().RATED
	              });
	            });
	          } else {
	            _this.setState({
	              rating: 0,
	              ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	            });
	          }
	        });
	
	        if (selected || selectedChoice) {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          _this.setState({
	            timer_stop: false,
	            timerstopbtn: 'pause_btn icon-control-pause'
	          });
	          _this.timer = setInterval(function () {
	            return _this.timerTick();
	          }, 1000);
	        }
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      clearInterval(_this.timer);
	      var index_id = _this.state.offset - 1;
	
	      if (index_id < 0) {
	        return;
	      }
	
	      _this.setState({
	        display_loader: 'show_block',
	        clicked: false,
	        validated: false,
	        already_answered_status: '',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _messages.messages.SAVE_QUESTION,
	        report_block: 'card hide_block',
	        showCompletionQuestion: false,
	        lastCase: _this.state.cases_display.id,
	        markCompleted: false,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        rating: 0,
	        bookmarkColor: '',
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        result_block: 'card hide_block',
	        previ_block: 'card hide_block',
	        next_block: '',
	        question_offset: 0,
	        offset: index_id,
	        case_id: _this.state.all_cases[index_id]
	      });
	
	      if (index_id === 0) {
	        _this.setState({ previ_block_cases: 'card hide_block' });
	      }
	      if (index_id < _this.state.cases_length - 1) {
	        _this.setState({ next_block_cases: '' });
	      }
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        casesId: _this.state.all_cases[index_id]
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getCasesbyId', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/cfa3/beginquiz/' + _this.state.quiz_id + '/' + index_id
	          });
	
	          _this.setState({
	            cases_display: resp.casesdiscription,
	            chapter_id: resp.casesdiscription.chapter_no,
	            case_no: resp.casesdiscription.case_number,
	            chapter_no: resp.casesdiscription.chapter_no
	          });
	
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter_id: resp.casesdiscription.chapter_no
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(function (chaptersData) {
	            if (chaptersData.success) {
	              _this.setState({
	                chaptername: chaptersData.chapterdata.chapter_name,
	                chapters: chaptersData.chapterdata
	              });
	
	              var param = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                case_id: resp.casesdiscription.id,
	                isQuiz: true,
	                quiz_id: _this.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(function (resp_question) {
	                if (resp_question.success) {
	                  var questionData = resp_question.questions_details[0];
	                  var selectedChoice = questionData['cfa3_2025_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = questionData['cfa3_2025_answer_quizzes.answer'] || '';
	                  var answerStatus = questionData['cfa3_2025_answer_quizzes.id'] || '';
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = 'choice_' + questionData.answer;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var correct = 'choice_' + questionData.answer;
	                      var choices = Object.keys(questionData).filter(function (key) {
	                        return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  var boxA = 'answer_box',
	                      boxB = 'answer_box',
	                      boxC = 'answer_box';
	                  var result_block = 'card hide_block',
	                      text_color = 'card-header',
	                      result = '',
	                      clicked = false;
	
	                  if (selected) {
	                    var _correct3 = questionData.answer ? 'choice_' + questionData.answer : '';
	                    if (selected === 'choice_a') {
	                      boxA = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_b') {
	                      boxB = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_c') {
	                      boxC = selected === _correct3 ? 'answer_box success' : 'answer_box failure';
	                    }
	                    if (_correct3) {
	                      if (selected === _correct3) {
	                        text_color = 'card-header text_success';
	                        result = 'CORRECT';
	                      } else {
	                        text_color = 'card-header text_failure';
	                        result = 'INCORRECT';
	                      }
	                      result_block = 'card show_block';
	                    }
	                    clicked = true;
	                  }
	
	                  _this.setState({
	                    question_display: questionData,
	                    question_length: resp_question.questions_details.length,
	                    questions: resp_question.questions_details,
	                    selectedChoice: selected,
	                    choice: selected,
	                    clicked: clicked,
	                    choice_a: boxA,
	                    choice_b: boxB,
	                    choice_c: boxC,
	                    result_block: result_block,
	                    text_color: text_color,
	                    result: result,
	                    showAnswer: showAnswer,
	                    selected: selected,
	                    display_loader: 'hide_block'
	                  });
	
	                  if (selected || selectedChoice) {
	                    _this.setState({
	                      timer_stop: true,
	                      timerstopbtn: 'pause_btn icon-control-play',
	                      timer_display: 'card-block'
	                    });
	                  } else {
	                    _this.setState({
	                      timer_stop: false,
	                      timerstopbtn: 'pause_btn icon-control-pause',
	                      timer_display: 'card-block'
	                    });
	                    _this.timer = setInterval(function () {
	                      return _this.timerTick();
	                    }, 1000);
	                  }
	
	                  var data_check = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: questionData.id
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data_check).then(function (resp_inner) {
	                    _this.setState({
	                      already_answered_status: resp_inner.message
	                    });
	                  });
	                  var params_fav = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname,
	                    chapter_id: _this.state.chapter_id
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                    if (responsefav.success) {
	                      _this.setState({
	                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	                  // Fetch rating for this question
	                  var params_rating = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params_rating).then(function (response) {
	                    if (response.success) {
	                      _this.setState({ rated: true });
	                      response.ratting.map(function (items) {
	                        _this.setState({
	                          rating: items.ratting,
	                          ratting_text: '' + _language2.default.LC().RATED
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        rating: 0,
	                        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                      });
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this._getNextCase = function () {
	      clearInterval(_this.timer);
	      var index_id = _this.state.offset + 1;
	
	      if (index_id >= _this.state.cases_length) {
	        return;
	      }
	
	      _this.setState({
	        display_loader: 'show_block',
	        clicked: false,
	        validated: false,
	        already_answered_status: '',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _messages.messages.SAVE_QUESTION,
	        report_block: 'card hide_block',
	        showCompletionQuestion: false,
	        lastCase: _this.state.cases_display.id,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        rating: 0,
	        bookmarkColor: '',
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        result_block: 'card hide_block',
	        previ_block: 'card hide_block',
	        next_block: '',
	        question_offset: 0,
	        offset: index_id,
	        case_id: _this.state.all_cases[index_id]
	      });
	
	      if (index_id > 0) {
	        _this.setState({ previ_block_cases: '' });
	      }
	      if (index_id === _this.state.cases_length - 1) {
	        _this.setState({ next_block_cases: 'card hide_block' });
	      }
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        casesId: _this.state.all_cases[index_id]
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getCasesbyId', data).then(function (casesData) {
	        if (casesData.success) {
	          _this.context.router.push({
	            pathname: '/cfa3/beginquiz/' + _this.state.quiz_id + '/' + index_id
	          });
	
	          _this.setState({
	            cases_display: casesData.casesdiscription,
	            chapter_id: casesData.casesdiscription.chapter_no,
	            case_no: casesData.casesdiscription.case_number,
	            chapter_no: casesData.casesdiscription.chapter_no
	          });
	
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter_id: casesData.casesdiscription.chapter_no
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(function (chaptersData) {
	            if (chaptersData.success) {
	              _this.setState({
	                chaptername: chaptersData.chapterdata.chapter_name,
	                chapters: chaptersData.chapterdata
	              });
	
	              var param = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                case_id: casesData.casesdiscription.id,
	                isQuiz: true,
	                quiz_id: _this.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(function (resp_question) {
	                if (resp_question.success) {
	                  var questionData = resp_question.questions_details[0];
	                  var selectedChoice = questionData['cfa3_2025_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = questionData['cfa3_2025_answer_quizzes.answer'] || '';
	                  var answerStatus = questionData['cfa3_2025_answer_quizzes.id'] || '';
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = 'choice_' + questionData.answer;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var correct = 'choice_' + questionData.answer;
	                      var choices = Object.keys(questionData).filter(function (key) {
	                        return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  var boxA = 'answer_box',
	                      boxB = 'answer_box',
	                      boxC = 'answer_box';
	                  var result_block = 'card hide_block',
	                      text_color = 'card-header',
	                      result = '',
	                      clicked = false;
	
	                  if (selected) {
	                    var _correct4 = questionData.answer ? 'choice_' + questionData.answer : '';
	                    if (selected === 'choice_a') {
	                      boxA = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_b') {
	                      boxB = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    } else if (selected === 'choice_c') {
	                      boxC = selected === _correct4 ? 'answer_box success' : 'answer_box failure';
	                    }
	                    if (_correct4) {
	                      if (selected === _correct4) {
	                        text_color = 'card-header text_success';
	                        result = 'CORRECT';
	                      } else {
	                        text_color = 'card-header text_failure';
	                        result = 'INCORRECT';
	                      }
	                      result_block = 'card show_block';
	                    }
	                    clicked = true;
	                  }
	
	                  _this.setState({
	                    question_display: questionData,
	                    question_length: resp_question.questions_details.length,
	                    questions: resp_question.questions_details,
	                    selectedChoice: selected,
	                    choice: selected,
	                    clicked: clicked,
	                    choice_a: boxA,
	                    choice_b: boxB,
	                    choice_c: boxC,
	                    result_block: result_block,
	                    text_color: text_color,
	                    result: result,
	                    showAnswer: showAnswer,
	                    selected: selected,
	                    display_loader: 'hide_block'
	                  });
	                  if (selected || selectedChoice) {
	                    _this.setState({
	                      timer_stop: true,
	                      timerstopbtn: 'pause_btn icon-control-play',
	                      timer_display: 'card-block'
	                    });
	                  } else {
	                    _this.setState({
	                      timer_stop: false,
	                      timerstopbtn: 'pause_btn icon-control-pause',
	                      timer_display: 'card-block'
	                    });
	                    _this.timer = setInterval(function () {
	                      return _this.timerTick();
	                    }, 1000);
	                  }
	
	                  var data_check = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: questionData.id
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data_check).then(function (resp_inner) {
	                    _this.setState({
	                      already_answered_status: resp_inner.message
	                    });
	                  });
	                  var params_fav = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname,
	                    chapter_id: _this.state.chapter_id
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	                    if (responsefav.success) {
	                      _this.setState({
	                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	                  // Fetch rating for this question
	                  var params_rating = {
	                    token: _this.state.token,
	                    question_id: questionData.id,
	                    idname: _this.state.idname
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params_rating).then(function (response) {
	                    if (response.success) {
	                      _this.setState({ rated: true });
	                      response.ratting.map(function (items) {
	                        _this.setState({
	                          rating: items.ratting,
	                          ratting_text: '' + _language2.default.LC().RATED
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        rating: 0,
	                        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                      });
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this._getNextAnyway = function () {
	      var index_id = 0;
	      _this.setState({ clicked: false });
	      _this.setState({
	        display_loader: 'show_block',
	        showCompletionQuestion: false,
	        already_answered_status: '',
	        validated: false,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _messages.messages.SAVE_QUESTION,
	        report_block: 'card hide_block',
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        bookmarkColor: '',
	        next_block: '',
	        previ_block: 'card hide_block'
	      }, function () {});
	      document.getElementById('comment') ? document.getElementById('comment').value = '' : null;
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/insertTimer', insert_time).then(function (resp) {});
	
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      var questionData = _this.state.questions[index_id];
	      var selectedChoice = questionData['cfa3_2025_answer_quizzes.selected_choice'] || '';
	      var rightAnswer = questionData['cfa3_2025_answer_quizzes.answer'] || '';
	      var answerStatus = questionData['cfa3_2025_answer_quizzes.id'] || '';
	      var showAnswer = false;
	      var selected = '';
	
	      if (selectedChoice) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (answerStatus) {
	        if (rightAnswer === 1) {
	          selected = 'choice_' + questionData.answer;
	          showAnswer = true;
	        } else if (!rightAnswer) {
	          var correct = 'choice_' + questionData.answer;
	          var choices = Object.keys(questionData).filter(function (key) {
	            return key.startsWith('choice') && key !== 'choice_' + questionData.answer;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	
	      var boxA = 'answer_box',
	          boxB = 'answer_box',
	          boxC = 'answer_box';
	      var result_block = 'card hide_block',
	          text_color = 'card-header',
	          result = '',
	          clicked = false;
	
	      if (selected) {
	        var _correct5 = questionData.answer ? 'choice_' + questionData.answer : '';
	        if (selected === 'choice_a') {
	          boxA = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	        } else if (selected === 'choice_b') {
	          boxB = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	        } else if (selected === 'choice_c') {
	          boxC = selected === _correct5 ? 'answer_box success' : 'answer_box failure';
	        }
	        if (_correct5) {
	          if (selected === _correct5) {
	            text_color = 'card-header text_success';
	            result = 'CORRECT';
	          } else {
	            text_color = 'card-header text_failure';
	            result = 'INCORRECT';
	          }
	          result_block = 'card show_block';
	        }
	        clicked = true;
	      }
	
	      _this.setState({
	        question_display: questionData,
	        question_offset: index_id,
	        selectedChoice: selected,
	        choice: selected,
	        clicked: clicked,
	        choice_a: boxA,
	        choice_b: boxB,
	        choice_c: boxC,
	        result_block: result_block,
	        text_color: text_color,
	        result: result,
	        showAnswer: showAnswer,
	        selected: selected,
	        display_loader: 'hide_block'
	      });
	
	      var data_check = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        question_id: questionData.id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data_check).then(function (resp) {
	        _this.setState({ already_answered_status: resp.message });
	      });
	
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionData.id,
	        idname: _this.state.idname,
	        chapter_id: _this.state.chapter_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (responsefav) {
	        if (responsefav.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	
	      // Fetch rating for this question
	      var params_rating = {
	        token: _this.state.token,
	        question_id: questionData.id,
	        idname: _this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params_rating).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            _this.setState({
	              rating: items.ratting,
	              ratting_text: '' + _language2.default.LC().RATED
	            });
	          });
	        } else {
	          _this.setState({
	            rating: 0,
	            ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	          });
	        }
	      });
	
	      if (selected || selectedChoice) {
	        _this.setState({
	          timer_stop: false,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	      } else {
	        _this.setState({
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-pause'
	        });
	        _this.timer = setInterval(function () {
	          return _this.timerTick();
	        }, 1000);
	      }
	    };
	
	    _this.state = {
	      idname: '',
	      token: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: parseInt(_this.props.params.offset, 10),
	      question_offset: 0,
	      question_display: '',
	      question_length: 0,
	      questions: [],
	      all_cases: [],
	      cases_length: 0,
	      case_id: '',
	      cases_display: '',
	      exam_type: 'cfa3',
	      chapter_id: '',
	      chaptername: '',
	      chapters: '',
	      choice: '',
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result: '',
	      result_block: 'card hide_block',
	      text_color: 'card-header',
	      clicked: false,
	      display_loader: 'show_block',
	      already_answered_status: '',
	      validated: false,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      save_text: '' + _messages.messages.SAVE_QUESTION,
	      report_block: 'card hide_block',
	      rating: 0,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      bookmarkColor: '',
	      previ_block: '',
	      next_block: '',
	      previ_block_cases: '',
	      next_block_cases: '',
	      showCompletionQuestion: false,
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: false,
	      lastCase: null,
	      display_cases: 'card hide_block',
	      count: 0,
	      count_temp: 0,
	      timer_value: 0,
	      user_time_value: 0,
	      timer_display: 'card-block',
	      timer_stop: false,
	      timerstopbtn: 'pause_btn icon-control-pause',
	      count_end_message: '',
	      selectedChoice: '',
	      showAnswer: false,
	      selected: ''
	    };
	    _this.timer = null;
	    return _this;
	  }
	
	  _createClass(Cfa3Beginquiz, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (this.state.offset === 0) {
	        this.setState({ previ_block_cases: 'card hide_block' });
	      }
	      if (this.state.question_offset === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var all_questions = JSON.parse(resp.singlequiz);
	          var all_cases = JSON.parse(resp.case_id);
	          _this2.setState({
	            all_cases: all_cases,
	            next_block: ''
	          });
	          _this2.setState({ timer_value: resp.timer_value });
	          _this2.setState({ cases_length: all_cases.length });
	
	          if (all_cases.length - 1 === _this2.state.offset) {
	            _this2.setState({ next_block_cases: 'card hide_block' });
	          }
	
	          var user_timer = resp.user_time_value;
	          _this2.setState({
	            user_time_value: user_timer,
	            count: user_timer > 0 ? user_timer : resp.timer_value,
	            count_temp: user_timer > 0 ? user_timer : resp.timer_value
	          });
	
	          if (!_this2.state.clicked) {
	            _this2.timer = setInterval(function () {
	              return _this2.timerTick();
	            }, 1000);
	          }
	          _this2.setState({
	            timer_stop: _this2.state.clicked,
	            timerstopbtn: _this2.state.clicked ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause',
	            timer_display: 'card-block'
	          });
	
	          for (var i = 0; i < all_cases.length; i++) {
	            if (parseInt(_this2.props.params.offset) === i) {
	              _this2.setState({ case_id: all_cases[i] });
	              var data = {
	                token: _this2.state.token,
	                idname: _this2.state.idname,
	                casesId: all_cases[i]
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getCasesbyId', data).then(function (resp) {
	                if (resp.success) {
	                  _this2.context.router.push({
	                    pathname: '/cfa3/beginquiz/' + _this2.state.quiz_id + '/' + _this2.state.offset
	                  });
	                  _this2.setState({ cases_display: resp.casesdiscription });
	                  _this2.setState({
	                    chapter_id: resp.casesdiscription.chapter_no
	                  });
	                  var chapter_id = resp.casesdiscription.chapter_no;
	                  var data = {
	                    token: _this2.state.token,
	                    idname: _this2.state.idname,
	                    chapter_id: resp.casesdiscription.chapter_no
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(function (chaptersData) {
	                    if (chaptersData.success) {
	                      _this2.setState({
	                        chaptername: chaptersData.chapterdata.chapter_name
	                      });
	                      _this2.setState({ chapters: chaptersData.chapterdata });
	
	                      var param = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        case_id: resp.casesdiscription.id,
	                        isQuiz: true,
	                        quiz_id: _this2.state.quiz_id
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(function (resp_question) {
	                        if (resp_question.success) {
	                          var questions = resp_question.questions_details;
	                          var currentQuestion = questions[_this2.state.question_offset];
	
	                          if (_this2.state.question_offset === questions.length - 1) {
	                            _this2.setState({ next_block: 'card hide_block' });
	                          } else {
	                            _this2.setState({ next_block: '' });
	                          }
	
	                          var selectedChoice = currentQuestion['cfa3_2025_answer_quizzes.selected_choice'] || '';
	                          var rightAnswer = currentQuestion['cfa3_2025_answer_quizzes.answer'] || '';
	                          var answerStatus = currentQuestion['cfa3_2025_answer_quizzes.id'] || '';
	                          var showAnswer = false;
	                          var selected = '';
	
	                          if (selectedChoice) {
	                            selected = selectedChoice;
	                            showAnswer = true;
	                          } else if (answerStatus) {
	                            if (rightAnswer === 1) {
	                              selected = 'choice_' + currentQuestion.answer;
	                              showAnswer = true;
	                            } else if (!rightAnswer) {
	                              var correct = 'choice_' + currentQuestion.answer;
	                              var choices = Object.keys(currentQuestion).filter(function (key) {
	                                return key.startsWith('choice') && key !== 'choice_' + currentQuestion.answer;
	                              });
	                              selected = choices.length > 0 ? choices[0] : '';
	                              showAnswer = true;
	                            }
	                          }
	
	                          var boxA = 'answer_box',
	                              boxB = 'answer_box',
	                              boxC = 'answer_box';
	                          var result_block = 'card hide_block',
	                              text_color = 'card-header',
	                              result = '',
	                              clicked = false;
	
	                          if (selected) {
	                            var _correct6 = currentQuestion.answer ? 'choice_' + currentQuestion.answer : '';
	                            if (selected === 'choice_a') {
	                              boxA = selected === _correct6 ? 'answer_box success' : 'answer_box failure';
	                            } else if (selected === 'choice_b') {
	                              boxB = selected === _correct6 ? 'answer_box success' : 'answer_box failure';
	                            } else if (selected === 'choice_c') {
	                              boxC = selected === _correct6 ? 'answer_box success' : 'answer_box failure';
	                            }
	                            if (_correct6) {
	                              if (selected === _correct6) {
	                                text_color = 'card-header text_success';
	                                result = 'CORRECT';
	                              } else {
	                                text_color = 'card-header text_failure';
	                                result = 'INCORRECT';
	                              }
	                              result_block = 'card show_block';
	                            }
	                            clicked = true;
	                          }
	
	                          _this2.setState({
	                            question_display: currentQuestion,
	                            question_length: questions.length,
	                            questions: questions,
	                            question_offset: _this2.state.question_offset,
	                            selectedChoice: selected,
	                            choice: selected,
	                            clicked: clicked,
	                            choice_a: boxA,
	                            choice_b: boxB,
	                            choice_c: boxC,
	                            result_block: result_block,
	                            text_color: text_color,
	                            result: result,
	                            showAnswer: showAnswer,
	                            selected: selected,
	                            display_loader: 'hide_block'
	                          });
	
	                          if (clicked) {
	                            _this2.setState({
	                              timer_stop: true,
	                              timerstopbtn: 'pause_btn icon-control-' + (!selected ? 'pause' : 'play'),
	                              timer_display: 'card-block'
	                            });
	                            clearInterval(_this2.timer);
	                          } else {
	                            _this2.setState({
	                              timer_stop: false,
	                              timerstopbtn: 'pause_btn icon-control-' + (!selected ? 'pause' : 'play'),
	                              timer_display: 'card-block'
	                            });
	                            if (!_this2.timer) {
	                              _this2.timer = setInterval(function () {
	                                return _this2.timerTick();
	                              }, 1000);
	                            }
	                          }
	
	                          var questionid = currentQuestion.id;
	
	                          var data_check = {
	                            token: _this2.state.token,
	                            idname: _this2.state.idname,
	                            quiz_id: _this2.state.quiz_id,
	                            question_id: questionid
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/checkAnswered', data_check).then(function (resp_inner) {
	                            _this2.setState({
	                              already_answered_status: resp_inner.message
	                            });
	                          });
	
	                          // Fetch rating for this question
	                          var params_rating = {
	                            token: _this2.state.token,
	                            question_id: questionid,
	                            idname: _this2.state.idname
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params_rating).then(function (response) {
	                            if (response.success) {
	                              _this2.setState({ rated: true });
	                              response.ratting.map(function (items) {
	                                _this2.setState({
	                                  rating: items.ratting,
	                                  ratting_text: '' + _language2.default.LC().RATED
	                                });
	                              });
	                            } else {
	                              _this2.setState({
	                                rating: 0,
	                                ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION
	                              });
	                            }
	                          });
	
	                          _this2.setState({ display_loader: 'hide_block' });
	                        }
	                      });
	                    } else {
	                      _this2.setState({ ValidToken: false });
	                    }
	                  });
	                }
	              });
	            }
	          }
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearInterval(this.timer);
	      }
	    }
	  }, {
	    key: 'timerTick',
	    value: function timerTick() {
	      var _state = this.state,
	          count = _state.count,
	          token = _state.token,
	          quiz_id = _state.quiz_id,
	          timer_display = _state.timer_display,
	          count_end_message = _state.count_end_message;
	
	
	      if (count > 0) {
	        var countValue = count - 1;
	        var insertTime = {
	          token: token,
	          idname: this.state.idname,
	          quiz_id: quiz_id,
	          user_time_value: countValue
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/insertTimer', insertTime).then(function (resp) {});
	
	        this.setState({
	          count: countValue,
	          timer_display: 'card-block'
	        });
	      }
	
	      if (count === 0) {
	        this.setState({
	          timer_display: 'card hide_block',
	          count_end_message: 'Time\'s Up'
	        });
	        clearInterval(this.timer);
	      }
	    }
	
	    //it is use to redirect page
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.showCompletionQuestion && this.state.lastCase && this.state.cases_display.id != this.state.lastCase && !this.state.markCompleted) {
	        document.getElementById('mark_not_completed') && document.getElementById('mark_not_completed').checked ? document.getElementById('mark_not_completed').checked = false : '';
	        document.getElementById('mark_completed') && document.getElementById('mark_completed').checked ? document.getElementById('mark_completed').checked = false : '';
	      }
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/UpdateCfaRatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1 });
	            _this3.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({ rating: items.ratting });
	              _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveCfaratting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1 });
	                _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveCfaratting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({ rated: 1 });
	              _this3.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to redirect page to readings beforestart
	
	
	    /*Function to start or stop timer*/
	
	
	    //Function to show Report box
	
	
	    //Funcion to save new report question
	
	    //Function to hide Report box
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    //Function to fetch Next question
	
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this4 = this;
	
	      e.preventDefault();
	
	      if (!this.state.markAsCompleted && !this.state.markAsNotCompleted) {
	        return;
	      }
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.case_id,
	        completion_status: this.state.markAsCompleted ? 1 : 0,
	        exam_type: this.state.exam_type,
	        chapter_id: this.state.chapter_id
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/updateCases', data).then(function (casesData) {
	        if (casesData.success) {
	          _this4.setState({
	            markCompleted: true,
	            showCompletionQuestion: false
	          });
	
	          var index_id = _this4.state.offset + 1;
	          if (index_id < _this4.state.cases_length) {
	            _this4._getNextCase();
	          } else {
	            _this4._getSummary();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var questions_data_display = this.state.question_display;
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	
	      var data = void 0,
	          question_data = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      data = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.cases_display.case_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block_cases,
	                  onClick: this._getPreviousCase
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block_cases,
	                  onClick: this._getNextCase
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      (0, _function.renderHTMLContent)(this.state.cases_display.case, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: "false" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'quiz_timer_btn ' + this.state.timer_display },
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this._timer_funct.bind(this, questions_data_display),
	                      disabled: this.state.clicked || this.state.validated
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-danger' },
	                    (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: "false" })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	
	      question_data = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              _language2.default.LC().QUESTION,
	              ' ',
	              questions_data_display.question_number + ' - ',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext,
	                  style: { display: this.state.next_block === 'card hide_block' ? 'none' : 'inline-block' }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, questions_data_display, this.props, {
	                      setAnswer: this._getAnswer,
	                      showAnswer: this.state.clicked,
	                      correctChoice: 'choice_' + questions_data_display.answer,
	                      selectedChoice: this.state.selectedChoice,
	                      onValidate: function onValidate() {
	                        return _this5._getResult(questions_data_display);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'd-flex align-items-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { style: { zIndex: 9999, position: 'relative', pointerEvents: 'auto' } },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          clicked: this.state.clicked,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions_data_display,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor,
	                          disabled: !this.state.selectedChoice || this.state.clicked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right', style: { marginRight: '650px' } },
	                        _react2.default.createElement(
	                          'span',
	                          { className: ' margin_bottom_0 margin_right_10 font-16px' },
	                          this.state.ratting_text
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'star_rating_wrap' },
	                          _react2.default.createElement(_reactStarRatings2.default, {
	                            rating: this.state.rating,
	                            starRatedColor: 'rgb(255, 180, 0)',
	                            starEmptyColor: 'rgb(51, 51, 51)',
	                            starDimension: '20px',
	                            starHoverColor: 'rgb(255, 180, 0)',
	                            starSpacing: '2px',
	                            changeRating: this.onStarClick.bind(this, questions_data_display),
	                            numberOfStars: 5,
	                            name: 'rate1'
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions_data_display.explanation, 'div', '', { contentEditable: 'false' })
	            )
	          )
	        )
	      );
	
	      if (this.state.showCompletionQuestion) {
	        question_data = _react2.default.createElement(
	          'div',
	          { className: 'complete-section-wrap ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header text-center' },
	              _language2.default.LC().Mark_this_Question_as_Completed,
	              _react2.default.createElement(
	                'div',
	                { onClick: this.changeCompletionStatus, className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          this.state.markCompleted ? 'Submitted' : _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().QUIZ_ID,
	              ': ',
	              this.state.quiz_id
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	              _language2.default.LC().BACK_TO_SUMMARY
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	            question_data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class',
	                    onClick: this._reportQuestion.bind(this, questions_data_display)
	                  },
	                  _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, questions_data_display)
	                  },
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa3Beginquiz;
	}(_react.Component);
	
	Cfa3Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa3Beginquiz;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(79);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var i = '';
	
	var Cfa3Dashboard = function (_Component) {
	  _inherits(Cfa3Dashboard, _Component);
	
	  function Cfa3Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa3Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3Dashboard.__proto__ || Object.getPrototypeOf(Cfa3Dashboard)).call(this, props));
	
	    _this.deleteFlashCard = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(type, id) {
	        var _this$state, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, id_name = _this$state.idname, token = _this$state.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: '',
	                  exam: 'cfa3',
	                  level: '',
	                  item_id: id
	                };
	                _context.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleDone = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var _this$state2, idname, token, items_val, item_status, question_id, item_id, video_id, data;
	
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              _this$state2 = _this.state, idname = _this$state2.idname, token = _this$state2.token, items_val = _this$state2.items_val, item_status = _this$state2.item_status;
	              question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	              if (_this.state.item_status == 'flashcard') {
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  flash_card: _this.state.items_val
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 5;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.getQuestionFlashcards();
	
	                          case 3:
	                            _context2.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	              }
	
	              if (!(item_status == 'savedquestion')) {
	                _context12.next = 9;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 7;
	              return _this.deleteFlashCard('question', question_id ? question_id : item_id);
	
	            case 7:
	              _context12.next = 9;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteSavequestion', data).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context3.next = 5;
	                            break;
	                          }
	
	                          _context3.next = 3;
	                          return _this.getQuestionSaved();
	
	                        case 3:
	                          _context3.next = 6;
	                          break;
	
	                        case 5:
	                          console.log('error');
	
	                        case 6:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	
	            case 9:
	              if (!(_this.state.item_status == 'Reportsquestion')) {
	                _context12.next = 13;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                reports: items_val
	              };
	              _context12.next = 13;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteDashboardQuestionReports', data).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context4.next = 5;
	                            break;
	                          }
	
	                          _context4.next = 3;
	                          return _this.getQuestionReports();
	
	                        case 3:
	                          _context4.next = 6;
	                          break;
	
	                        case 5:
	                          console.log('error');
	
	                        case 6:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x5) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 13:
	              if (!(item_status == 'savednotes')) {
	                _context12.next = 19;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 17;
	              return _this.deleteFlashCard('notes', question_id ? question_id : item_id);
	
	            case 17:
	              _context12.next = 19;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/deleteSaveNotes', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context5.next = 5;
	                            break;
	                          }
	
	                          _context5.next = 3;
	                          return _this.getNotesSaved();
	
	                        case 3:
	                          _context5.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 19:
	              if (!(item_status == 'savedvideos')) {
	                _context12.next = 25;
	                break;
	              }
	
	              data = {
	                token: token,
	                idname: idname,
	                save_question: items_val
	              };
	              _context12.next = 23;
	              return _this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	            case 23:
	              _context12.next = 25;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/deleteSaveVideo', data).then(function () {
	                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context6.next = 5;
	                            break;
	                          }
	
	                          _context6.next = 3;
	                          return _this.getVideosSaved();
	
	                        case 3:
	                          _context6.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref7.apply(this, arguments);
	                };
	              }());
	
	            case 25:
	              if (!(_this.state.item_status == 'Notesflashcard')) {
	                _context12.next = 29;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 29;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/deleteDashboardFlashCard', data).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context7.next = 5;
	                            break;
	                          }
	
	                          _context7.next = 3;
	                          return _this.getNotesFlashcards();
	
	                        case 3:
	                          _context7.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref8.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 29:
	              if (!(_this.state.item_status == 'Videoflashcard')) {
	                _context12.next = 33;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.items_val
	              };
	              _context12.next = 33;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/deleteDashboardVideoFlashCard', data).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context8.next = 5;
	                            break;
	                          }
	
	                          _context8.next = 3;
	                          return _this.getVideoFlashcards();
	
	                        case 3:
	                          _context8.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref9.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 33:
	
	              if (_this.state.item_status == 'Reportsnotes') {
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reports: _this.state.items_val
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/deleteDashboardNotesReports', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context9.next = 5;
	                              break;
	                            }
	
	                            _context9.next = 3;
	                            return _this.getNotesReports();
	
	                          case 3:
	                            _context9.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x10) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	              }
	
	              if (!(_this.state.item_status == 'Reportsvideos')) {
	                _context12.next = 38;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 38;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/deleteDashboardVideoReports', data).then(function () {
	                var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                  return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                      switch (_context10.prev = _context10.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context10.next = 5;
	                            break;
	                          }
	
	                          _context10.next = 3;
	                          return _this.getVideoReports();
	
	                        case 3:
	                          _context10.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context10.stop();
	                      }
	                    }
	                  }, _callee10, _this2);
	                }));
	
	                return function (_x11) {
	                  return _ref11.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 38:
	              if (!(_this.state.item_status == 'CBTreportsquestion')) {
	                _context12.next = 42;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.items_val
	              };
	              _context12.next = 42;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/deleteReport', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context11.next = 5;
	                            break;
	                          }
	
	                          _context11.next = 3;
	                          return _this.getCBTQestionReports();
	
	                        case 3:
	                          _context11.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x12) {
	                  return _ref12.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 42:
	              // ==================== NOTES AND VIDEOS ;==========================//
	              _this.setState({
	                alert_status: false
	              });
	
	            case 43:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	
	    _this.handleCBTQuestionReportSubmit = function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(event) {
	        var _this$state3, reportEditId, idname, token, cbtquesReport, data;
	
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.cbtquesReport === '' && _this.state.cbtquesReport.length < 1)) {
	                  _context14.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context14.abrupt('return');
	
	              case 4:
	                _this$state3 = _this.state, reportEditId = _this$state3.reportEditId, idname = _this$state3.idname, token = _this$state3.token, cbtquesReport = _this$state3.cbtquesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: cbtquesReport
	                };
	                _context14.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/updateReport', data).then(function () {
	                  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                    return _regenerator2.default.wrap(function _callee13$(_context13) {
	                      while (1) {
	                        switch (_context13.prev = _context13.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context13.next = 6;
	                              break;
	                            }
	
	                            _this.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this.state.reportEditStatus,
	                              reportEditId: '',
	                              cbtquesReport: ''
	                            });
	                            _context13.next = 4;
	                            return _this.getCBTQestionReports();
	
	                          case 4:
	                            _context13.next = 7;
	                            break;
	
	                          case 6:
	                            _this.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context13.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context13.stop();
	                        }
	                      }
	                    }, _callee13, _this2);
	                  }));
	
	                  return function (_x14) {
	                    return _ref14.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this2);
	      }));
	
	      return function (_x13) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteSavequestion = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({
	          show_outer: 'show_block',
	          more_detail_button: '' + _language2.default.LC().Hide_details
	        });
	      }
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({
	          show_outer: 'hide_block',
	          more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS
	        });
	      }
	    };
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context16.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(resp) {
	                  return _regenerator2.default.wrap(function _callee15$(_context15) {
	                    while (1) {
	                      switch (_context15.prev = _context15.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportquestion: resp.questions, reportLoader: false });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context15.stop();
	                      }
	                    }
	                  }, _callee15, _this2);
	                }));
	
	                return function (_x15) {
	                  return _ref16.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	    _this.getCBTQestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee18() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee18$(_context18) {
	        while (1) {
	          switch (_context18.prev = _context18.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context18.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3CBTMockExams/getreportedQuestion', data).then(function () {
	                var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(resp) {
	                  return _regenerator2.default.wrap(function _callee17$(_context17) {
	                    while (1) {
	                      switch (_context17.prev = _context17.next) {
	                        case 0:
	                          //console.log('heeeeeeeeeeeeeeeeeeeeeeeeeeeee', resp);
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestionCBT: resp.questions,
	                              reportLoader: false
	                            });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context17.stop();
	                      }
	                    }
	                  }, _callee17, _this2);
	                }));
	
	                return function (_x16) {
	                  return _ref18.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context18.stop();
	          }
	        }
	      }, _callee18, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee19() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee19$(_context19) {
	        while (1) {
	          switch (_context19.prev = _context19.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context19.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ flashreport: resp.flash_report, flashLoader: false });
	                } else {
	                  console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context19.stop();
	          }
	        }
	      }, _callee19, _this2);
	    }));
	    _this.getQuestionSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee20() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee20$(_context20) {
	        while (1) {
	          switch (_context20.prev = _context20.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context20.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ savedquestion: resp.questions, savedLoader: false });
	                } else {
	                  console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context20.stop();
	          }
	        }
	      }, _callee20, _this2);
	    }));
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      var isEssayQuestion = item.isEssayQuestion,
	          essayQuestionIndex = item.essayQuestionIndex,
	          question_id = item.question_id;
	
	      if (!isEssayQuestion) {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getQuestionsbyid', data).then(function (resp) {
	          if (resp.success) {
	            var dataparam = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              chapter_id: resp.questionsbyid.chapter_id
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCases', dataparam).then(function (resp_case) {
	              if (resp_case.success) {
	                var caseOffset = resp_case.readings.findIndex(function (item) {
	                  return item.id === resp.questionsbyid.case_id;
	                });
	                _this.context.router.push({
	                  pathname: '/cfa3/chapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.case_id + '/' + parseInt(caseOffset) + '/' + resp.questionsbyid.question_number,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    reading: resp.questionsbyid.reading_id,
	                    chapter: resp.questionsbyid.chapter_id
	                  }
	                });
	              } else {
	                console.log('Some Thing Went Wrong');
	              }
	            });
	          } else {
	            console.log('Not Found');
	          }
	        });
	      } else {
	        var _this$state4 = _this.state,
	            token = _this$state4.token,
	            idname = _this$state4.idname;
	
	        var _data = {
	          token: token,
	          idname: idname,
	          isEssayQuestion: 1,
	          essayQuestionIndex: essayQuestionIndex,
	          questionId: question_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getQuestionDetails', _data).then(function (res) {
	          if (res.success) {
	            var questionId = res.questionId,
	                _essayQuestionIndex = res.essayQuestionIndex,
	                caseId = res.caseId,
	                casesIndex = res.casesIndex,
	                chapterId = res.chapterId,
	                chapterName = res.chapterName;
	            //:caseId/:chapterID/:chapterName/:questionIndex/:caseIndex
	
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', caseId).replace(':chapterID', chapterId).replace(':chapterName', chapterName).replace(':questionIndex', _essayQuestionIndex).replace(':caseIndex', casesIndex)
	            });
	          }
	        });
	      }
	    };
	
	    _this.onContactChange = function (data, index) {
	      if (!_this.state.contactStatus) {
	        _this.setState({
	          contactID: data.id,
	
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        _this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    };
	
	    _this.onContactSubmit = function () {
	      var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(event) {
	        var _this$state5, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee22$(_context22) {
	          while (1) {
	            switch (_context22.prev = _context22.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context22.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context22.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context22.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context22.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state5 = _this.state, idname = _this$state5.idname, token = _this$state5.token, contactComment = _this$state5.contactComment, contactSubject = _this$state5.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context22.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(resp) {
	                    return _regenerator2.default.wrap(function _callee21$(_context21) {
	                      while (1) {
	                        switch (_context21.prev = _context21.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context21.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context21.stop();
	                        }
	                      }
	                    }, _callee21, _this2);
	                  }));
	
	                  return function (_x18) {
	                    return _ref22.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context22.stop();
	            }
	          }
	        }, _callee22, _this2);
	      }));
	
	      return function (_x17) {
	        return _ref21.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.OpenEditCBTQuesReport = function (item, e) {
	      _this.setState({
	        reportEditStatus: !_this.state.reportEditStatus,
	        reportEditId: item.id,
	        cbtquesReport: item.comment,
	        type: 'cbtquesReport'
	      });
	    };
	
	    _this.view = function (item) {
	      if (item.mockData) {
	        var mock = JSON.parse(item.mockData, item);
	        var redirectToFinishTest = mock.type === _messages.messages.PATHWAY ? _AppRoutes2.default.CFA3_PATHWAY_CBT_QUESTIONS_FINISH : _AppRoutes2.default.CFA3_CBT_QUESTIONS_FINISH;
	        _this.context.router.push({
	          pathname: redirectToFinishTest.replace(':id', mock.mock_id).replace(':caseno', mock.caseId).replace(':questiono', item.question_id).replace(':testid', mock.test_id).replace(':caseOffset', mock.caseOffset).replace(':quesOffset', mock.quesOffset).replace(':timer', mock.timer)
	        });
	      }
	    };
	
	    _this.CloseEditCBTQuesReport = function () {
	      _this.setState({
	        reportEditStatus: !_this.state.reportEditStatus,
	        reportEditId: '',
	        cbtquesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    };
	
	    _this._deleteCBTReportsquestino = function (items) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('CBTreportsquestion');
	    };
	
	    _this.renderNotesProgressBar = function () {
	      var notesProgressBar = _this.state.notesProgressBar;
	
	      return notesProgressBar.map(function (item, index) {
	        var notesCount = item.notesCount,
	            attemptedNotes = item.attemptedNotes;
	
	        var progressNotesData = Math.max(Math.round(attemptedNotes / notesCount * 100), 1);
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressNotesData,
	                      style: { width: progressNotesData + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    };
	
	    _this.OpenEditVideoReport = function (item, e) {
	      _this.setState({
	        reportEditStatus: !_this.state.reportEditStatus,
	        reportEditId: item['cfa3_video_reports.id'],
	        // reportEditId: item.id,
	        videoReport: item['cfa3_video_reports.comment'],
	        type: 'videoReport'
	      });
	    };
	
	    _this.getNotesSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee24() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee24$(_context24) {
	        while (1) {
	          switch (_context24.prev = _context24.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context24.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getFavNotesbyuserid', data).then(function () {
	                var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(resp) {
	                  return _regenerator2.default.wrap(function _callee23$(_context23) {
	                    while (1) {
	                      switch (_context23.prev = _context23.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savednotes: resp.cfa_notes });
	                          } else {}
	
	                        case 1:
	                        case 'end':
	                          return _context23.stop();
	                      }
	                    }
	                  }, _callee23, _this2);
	                }));
	
	                return function (_x19) {
	                  return _ref24.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context24.stop();
	          }
	        }
	      }, _callee24, _this2);
	    }));
	    _this.getNotesFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee26() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee26$(_context26) {
	        while (1) {
	          switch (_context26.prev = _context26.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context26.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getFlashcardsnotesbyuserid', data).then(function () {
	                var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(resp) {
	                  return _regenerator2.default.wrap(function _callee25$(_context25) {
	                    while (1) {
	                      switch (_context25.prev = _context25.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ notesFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context25.stop();
	                      }
	                    }
	                  }, _callee25, _this2);
	                }));
	
	                return function (_x20) {
	                  return _ref26.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context26.stop();
	          }
	        }
	      }, _callee26, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee28() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee28$(_context28) {
	        while (1) {
	          switch (_context28.prev = _context28.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context28.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(resp) {
	                  return _regenerator2.default.wrap(function _callee27$(_context27) {
	                    while (1) {
	                      switch (_context27.prev = _context27.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context27.stop();
	                      }
	                    }
	                  }, _callee27, _this2);
	                }));
	
	                return function (_x21) {
	                  return _ref28.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context28.stop();
	          }
	        }
	      }, _callee28, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee30() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee30$(_context30) {
	        while (1) {
	          switch (_context30.prev = _context30.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context30.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getReportsVideobyuserid', data).then(function () {
	                var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(resp) {
	                  return _regenerator2.default.wrap(function _callee29$(_context29) {
	                    while (1) {
	                      switch (_context29.prev = _context29.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo: resp.video });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context29.stop();
	                      }
	                    }
	                  }, _callee29, _this2);
	                }));
	
	                return function (_x22) {
	                  return _ref30.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context30.stop();
	          }
	        }
	      }, _callee30, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee32() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee32$(_context32) {
	        while (1) {
	          switch (_context32.prev = _context32.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context32.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getFavVideosbyuserid', data).then(function () {
	                var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(resp) {
	                  return _regenerator2.default.wrap(function _callee31$(_context31) {
	                    while (1) {
	                      switch (_context31.prev = _context31.next) {
	                        case 0:
	                          if (resp.success) {
	                            // console.log('Saved Video -------> ', resp);
	                            _this.setState({ savedvideo: resp.cfa_videos });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context31.stop();
	                      }
	                    }
	                  }, _callee31, _this2);
	                }));
	
	                return function (_x23) {
	                  return _ref32.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context32.stop();
	          }
	        }
	      }, _callee32, _this2);
	    }));
	    _this.getNotesReports = _asyncToGenerator(_regenerator2.default.mark(function _callee34() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee34$(_context34) {
	        while (1) {
	          switch (_context34.prev = _context34.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context34.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getReportsNotesbyuserid', data).then(function () {
	                var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(resp) {
	                  return _regenerator2.default.wrap(function _callee33$(_context33) {
	                    while (1) {
	                      switch (_context33.prev = _context33.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportnotes: resp.notes });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context33.stop();
	                      }
	                    }
	                  }, _callee33, _this2);
	                }));
	
	                return function (_x24) {
	                  return _ref34.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context34.stop();
	          }
	        }
	      }, _callee34, _this2);
	    }));
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSaveNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savednotes');
	    };
	
	    _this._deleteSaveVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsnotes');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._beginNotes = function () {
	      var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(reading, e) {
	        var reading_id, chapter_id, data, offset;
	        return _regenerator2.default.wrap(function _callee36$(_context36) {
	          while (1) {
	            switch (_context36.prev = _context36.next) {
	              case 0:
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                offset = 0;
	                _context36.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    // ---------------------------------------
	                    var data = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter_id: resp.notes[0].chapter_id,
	                      reading_id: resp.notes[0].reading_id,
	                      offset: _this.state.offset
	                      // limit: this.state.limit,
	                    };
	                    chapter_id = resp.notes[0].chapter_id;
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes_allcr', data).then(function () {
	                      var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(resp) {
	                        var i;
	                        return _regenerator2.default.wrap(function _callee35$(_context35) {
	                          while (1) {
	                            switch (_context35.prev = _context35.next) {
	                              case 0:
	                                if (!resp.success) {
	                                  _context35.next = 10;
	                                  break;
	                                }
	
	                                i = 0;
	
	                              case 2:
	                                if (!(i < resp.questions.length)) {
	                                  _context35.next = 10;
	                                  break;
	                                }
	
	                                if (!(resp.questions[i].id === reading.question_id)) {
	                                  _context35.next = 7;
	                                  break;
	                                }
	
	                                offset = i;
	                                // reading_id = resp.notes[0].reading_id;
	                                _this.context.router.push({
	                                  pathname: ('' + _AppRoutes2.default.CFA3_BEGIN_NOTES).replace(':notesid', chapter_id).replace(':readingid', resp.questions[i].reading_id).replace(':id', reading.question_id).replace(':offset', offset)
	                                });
	                                return _context35.abrupt('break', 10);
	
	                              case 7:
	                                i++;
	                                _context35.next = 2;
	                                break;
	
	                              case 10:
	                              case 'end':
	                                return _context35.stop();
	                            }
	                          }
	                        }, _callee35, _this2);
	                      }));
	
	                      return function (_x27) {
	                        return _ref36.apply(this, arguments);
	                      };
	                    }());
	                    // ---------------------------------------
	                  }
	                });
	
	              case 6:
	              case 'end':
	                return _context36.stop();
	            }
	          }
	        }, _callee36, _this2);
	      }));
	
	      return function (_x25, _x26) {
	        return _ref35.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToList = function () {
	      var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(reading, e) {
	        var chapter_id, video_id, case_id, pathway_id, videoId;
	        return _regenerator2.default.wrap(function _callee37$(_context37) {
	          while (1) {
	            switch (_context37.prev = _context37.next) {
	              case 0:
	                chapter_id = reading.chapter_id, video_id = reading.video_id, case_id = reading.case_id, pathway_id = reading.pathway_id;
	                videoId = video_id ? video_id : reading['cfa3_video_reports.video_id'];
	
	
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.VIDEOS_LIST.replace(':id', videoId).replace(':chapterId', chapter_id),
	                  query: Object.assign({}, case_id && { caseId: case_id }, pathway_id && { pathwayId: pathway_id })
	                });
	
	              case 3:
	              case 'end':
	                return _context37.stop();
	            }
	          }
	        }, _callee37, _this2);
	      }));
	
	      return function (_x28, _x29) {
	        return _ref37.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      token: '',
	      idname: '',
	      flashreport: [], //All Flash question Store
	      savedquestion: [],
	      reportquestion: [],
	      progress_bar_zero: [],
	      activeTabFlashcards: '1',
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      notesProgressBar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      bar_chapter: '',
	      bar_level_main: ['Ethics', 'Quants', 'Econ', 'FRA', 'Corpo', 'Portfolio', 'Equity', 'Fixed Income', 'Derivatives', 'Al'],
	      bar_main_user: [],
	      bar_main_class: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      ErrorMessage: '',
	      subreadings_status: false,
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      display_main_loader: 'show_block',
	      qpLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      notesFlashReport: [],
	      videoFlashReport: [],
	      savednotes: [],
	      savedvideo: [],
	      reportnotes: [],
	      reportsvideo: [],
	      reportquestionCBT: [],
	      notesProgressLoader: true
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.OpenEditNotesReport = _this.OpenEditNotesReport.bind(_this);
	    _this.CloseEditNotesReport = _this.CloseEditNotesReport.bind(_this);
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa3Dashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, type, e) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: type
	      });
	    }
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        contactStatus: false,
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate != '') {
	        // document.getElementById('outer_readings_id').innerHTML = '';
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this3 = this;
	
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second
	          };
	          // Get Notes Progress By User
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/getNotesProgressForUser', data).then(function (resp) {
	            if (resp.success) {
	              _this3.setState({ notesProgressBar: resp.notesProgressBarData });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this3.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block'
	              });
	            } else {
	              _this3.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this3.setState({ bar_main_class: final_array_main });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	          // FD.callAPI(App_data.backend_api+'/cfa_3dashboard/getProgressChapter',data).then(resp => {
	          //   if(resp.success)
	          //   {
	          //     this.setState({bar_chapter:resp.chapters});
	          //     this.setState({progress_bar_zero:resp.chapters});
	          //   }
	          //   else
	          //   {
	          //     console.log(resp.success+'------------failure');
	          //   }
	          // });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/getQuestionProgByUser', data).then(function (resp) {
	            // console.log(resp.progressbarzero_data)
	            if (resp.success) {
	              _this3.setState({
	                bar_chapter: resp.progressBarData,
	                progress_bar_zero: resp.progressBarData,
	                qpLoader: false
	              });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee39() {
	        var _this4 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee39$(_context39) {
	          while (1) {
	            switch (_context39.prev = _context39.next) {
	              case 0:
	                window.scroll(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({ ValidToken: true });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({ ValidToken: true, chapters: resp.chapters });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/mainProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({ display_main_loader: 'hide_block' });
	                    var dataString = JSON.stringify(resp.chapters);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	                      final_array_main.push(user_graph_val);
	                    }
	                    _this4.setState({ bar_main_user: final_array_main });
	                  } else {
	                    console.log(resp.success + '------------failure');
	                  }
	                });
	                this.setState({ display_main_loader: 'show_block' });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/mainProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataString = JSON.stringify(resp.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	                      final_array_main.push(user_graph_val);
	                    }
	                    _this4.setState({ bar_main_class: final_array_main });
	                  } else {
	                    console.log(resp.success + '------------failure');
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/getQuestionProgByUser', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({
	                      progress_bar_zero: resp.progressBarData,
	                      bar_chapter: resp.progressBarData,
	                      qpLoader: false
	                    });
	                  } else {
	                    console.log(resp.success + '------------failure');
	                  }
	                });
	
	                _context39.next = 12;
	                return this.getQuestionFlashcards();
	
	              case 12:
	                _context39.next = 14;
	                return this.getQuestionSaved();
	
	              case 14:
	                _context39.next = 16;
	                return this.getQuestionReports();
	
	              case 16:
	                _context39.next = 18;
	                return this.getNotesFlashcards();
	
	              case 18:
	                _context39.next = 20;
	                return this.getNotesSaved();
	
	              case 20:
	                _context39.next = 22;
	                return this.getNotesReports();
	
	              case 22:
	                _context39.next = 24;
	                return this.getVideoFlashcards();
	
	              case 24:
	                _context39.next = 26;
	                return this.getVideosSaved();
	
	              case 26:
	                _context39.next = 28;
	                return this.getVideoReports();
	
	              case 28:
	                this.getCBTQestionReports();
	
	                _context39.next = 31;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3dashboard/getNotesProgressForUser', data).then(function () {
	                  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(resp) {
	                    return _regenerator2.default.wrap(function _callee38$(_context38) {
	                      while (1) {
	                        switch (_context38.prev = _context38.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this4.setState({
	                                notesProgressBar: resp.notesProgressBarData,
	                                notesProgressLoader: false
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context38.stop();
	                        }
	                      }
	                    }, _callee38, _this4);
	                  }));
	
	                  return function (_x30) {
	                    return _ref39.apply(this, arguments);
	                  };
	                }());
	
	              case 31:
	              case 'end':
	                return _context39.stop();
	            }
	          }
	        }, _callee39, this);
	      }));
	
	      function componentDidMount() {
	        return _ref38.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    // function for get  question report
	
	
	    // function for get  question report
	
	
	    // function for get  question report
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: Math.min(progressnotes_zero, 100) + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        ErrorMessage: ''
	      });
	    }
	
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(event) {
	        var _this5 = this;
	
	        var _state, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee41$(_context41) {
	          while (1) {
	            switch (_context41.prev = _context41.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context41.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context41.abrupt('return');
	
	              case 4:
	                _state = this.state, reportEditId = _state.reportEditId, idname = _state.idname, token = _state.token, quesReport = _state.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context41.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(resp) {
	                    return _regenerator2.default.wrap(function _callee40$(_context40) {
	                      while (1) {
	                        switch (_context40.prev = _context40.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context40.next = 6;
	                              break;
	                            }
	
	                            _this5.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this5.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context40.next = 4;
	                            return _this5.getQuestionReports();
	
	                          case 4:
	                            _context40.next = 7;
	                            break;
	
	                          case 6:
	                            _this5.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context40.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context40.stop();
	                        }
	                      }
	                    }, _callee40, _this5);
	                  }));
	
	                  return function (_x32) {
	                    return _ref41.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context41.stop();
	            }
	          }
	        }, _callee41, this);
	      }));
	
	      function handleQuestionReportSubmit(_x31) {
	        return _ref40.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          activeTabFlashcards = _state2.activeTabFlashcards,
	          activeTabSaved = _state2.activeTabSaved,
	          activeTabReports = _state2.activeTabReports,
	          qpLoader = _state2.qpLoader,
	          savedLoader = _state2.savedLoader,
	          flashLoader = _state2.flashLoader,
	          reportLoader = _state2.reportLoader;
	
	      var flashreport_val = this.state.flashreport;
	      var reportquestionCBT_val = this.state.reportquestionCBT;
	      var progress_bar_zero_val = this.state.progress_bar_zero;
	
	      var flashcard_data = '';
	      var savedquestion_data = '';
	      var question_reportsData = ''; // for question reports
	      var progress_bar_data = '';
	
	      var notes_flashcard_data = '';
	      var video_flashcard_data = '';
	
	      var savednotes_data = '';
	      var savedvideo_data = '';
	
	      var notes_reportsData = ''; // for notes report
	      var video_reportsData = ''; // for video report
	      var cbt_reportsData = ''; // for cbt question reports
	
	      var notes_flashreport_val = this.state.notesFlashReport;
	      var video_flashreport_val = this.state.videoFlashReport;
	      var savedvideo_val = this.state.savedvideo;
	
	      var reportnotes_val = this.state.reportnotes;
	      var reportvideo_val = this.state.reportsvideo;
	      /*first main graph*/
	      var main_bar_val = this.state.bar_chapter;
	      var main_bar_percentage = this.state.bar_main_user;
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	
	      Object.keys(main_bar_val).map(function (key) {
	        var dataString = JSON.stringify(main_bar_val[key]);
	        var dataReason = JSON.parse(dataString);
	        main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
	        var chapter_id = dataReason.chapter_id;
	        i++;
	      });
	
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	
	      var role = localStorage.getItem('role');
	      var chapters = this.state.chapters;
	      var reading_data = '';
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._beginChapter.bind(_this6, items),
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteFlashcard.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = this.state.savedquestion.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._beginChapter.bind(_this6, items),
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteSavequestion.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = this.state.reportquestion.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this6.OpenEditQuesReport.bind(_this6, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this6.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportEditStatus && _this6.state.reportEditId === items.id,
	                  toggle: _this6.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this6.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this6.handleQuestionReportSubmit.bind(_this6) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this6.InputChange.bind(_this6),
	                            value: _this6.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            _this6.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().REPORT
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this6.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._beginChapter.bind(_this6, items),
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6.toggleAlertReport.bind(_this6, items),
	                    className: _this6.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportAnswerStatus && _this6.state.reportAnswerId === items.id,
	                  toggle: _this6.toggleAlertReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this6.state.contactStatus && _this6.state.contactID === items.id && _this6.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(items, index);
	                        }
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(items, index);
	                        }
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this6.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this6.state.contactStatus && _this6.state.contactID === items.id && _this6.state.contactIndex === index ? !_this6.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this6.onContactSubmit.bind(_this6) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this6.SubjectInputChange.bind(_this6),
	                          value: _this6.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this6.CommentInputChange.bind(_this6),
	                          value: _this6.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this6.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this6.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteReportsquestino.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.isEssayQuestion ? items.essay_topic_name && items.essay_topic_name.includes('$$') ? items.essay_topic_name : items.essay_topic_name.length > 150 ? items.essay_topic_name.substring(0, 150) + '...' : items.essay_topic_name : items.topic_name, 'span', 'text-inline-dashboard')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      // ================= Notes And Videos : ====================//
	
	      if (this.state.notesFlashReport.length) {
	        // console.log(
	        //   'I am inside notesFlashReport -----> ',
	        //   this.state.notesFlashReport
	        // );
	        notes_flashcard_data = notes_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._beginNotes.bind(_this6, items),
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteNotesFlashcard.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport.length) {
	        // console.log(
	        //   'I am inside videoFlashReport -----> ',
	        //   this.state.videoFlashReport
	        // );
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this6.redirectToList(items);
	                    },
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteVideoFlashcard.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savednotes.length) {
	        savednotes_data = this.state.savednotes.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._beginNotes.bind(_this6, items),
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteSaveNotes.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items['cfa3_note.name'], "span"),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_NOTES,
	          ' '
	        );
	      }
	
	      // console.log('I am outside savedvideo -----> ', this.state.savedvideo);
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this6.redirectToList(items);
	                    },
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteSaveVideo.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span"),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      if (this.state.reportnotes.length) {
	        // console.log('I am inside reportnotes -----> ', this.state.reportnotes);
	
	        notes_reportsData = reportnotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this6.OpenEditNotesReport.bind(_this6, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this6.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportEditStatus && _this6.state.reportEditId === items.id && _this6.state.type === 'notesReport',
	                  toggle: _this6.OpenEditNotesReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items['cfa3_note.name'], 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this6.CloseEditNotesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this6.handleNotesReportSubmit.bind(_this6) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'notesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this6.InputChange.bind(_this6),
	                            value: _this6.state.notesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            _this6.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this6.CloseEditNotesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._beginNotes.bind(_this6, items),
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6.toggleAlertReport.bind(_this6, items, 'notesReport'),
	                    className: _this6.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportAnswerStatus && _this6.state.reportAnswerId === items.id && _this6.state.type === 'notesReport',
	                  toggle: _this6.toggleAlertReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items['cfa3_note.name'], 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this6.state.contactStatus && _this6.state.contactType === 'notesReport' && _this6.state.contactID === items.id && _this6.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(items, index, 'notesReport');
	                        }
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(items, index, 'notesReport');
	                        }
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this6.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this6.state.contactStatus && _this6.state.contactType === 'notesReport' && _this6.state.contactID === items.id && _this6.state.contactIndex === index ? !_this6.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this6.onContactSubmit.bind(_this6) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this6.SubjectInputChange.bind(_this6),
	                          value: _this6.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this6.CommentInputChange.bind(_this6),
	                          value: _this6.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this6.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this6.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteReportsNotes.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items['cfa3_note.name'], 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        // console.log('I am inside reportsvideo -----> ', this.state.reportsvideo);
	
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            {
	              id: 'reportsvideos_' + items['cfa3_video_reports.id'],
	              key: index,
	              className: 'flash_card_box'
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items['cfa3_video_reports.id']
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items['cfa3_video_reports.status'] === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items['cfa3_video_reports.status'] === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items['cfa3_video_reports.video_id']
	              ),
	              !items['cfa3_video_reports.isSend'] && !items['cfa3_video_reports.reply'] && items['cfa3_video_reports.status'] !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: function onClick() {
	                    return items['cfa3_video_reports.isSend'] ? null : _this6.OpenEditVideoReport(Object.assign({}, items, {
	                      id: items['cfa3_video_reports.id']
	                    }));
	                  },
	                  disabled: items['cfa3_video_reports.isSend']
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this6.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportEditStatus && _this6.state.reportEditId === items['cfa3_video_reports.id'] && _this6.state.type === 'videoReport',
	                  toggle: _this6.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items['cfa3_video_reports.video_id'],
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this6.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this6.handleVideoReportSubmit.bind(_this6) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this6.InputChange.bind(_this6),
	                            value: _this6.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            _this6.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this6.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this6.redirectToList(items);
	                    },
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items['cfa3_video_reports.reply'] ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6.toggleAlertReport.bind(_this6, Object.assign({}, items, { id: items['cfa3_video_reports.id'] }), 'videoReport'),
	                    className: _this6.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportAnswerStatus && _this6.state.reportAnswerId === items['cfa3_video_reports.id'] && _this6.state.type === 'videoReport',
	                  toggle: _this6.toggleAlertReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items['cfa3_video_reports.video_id'],
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this6.state.contactStatus && _this6.state.type === 'videoReport' && _this6.state.contactID === items['cfa3_video_reports.id'] && _this6.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(Object.assign({}, items, { id: items['cfa3_video_reports.id'] }), index, 'videoReport');
	                        }
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(Object.assign({}, items, { id: items['cfa3_video_reports.id'] }), index, 'videoReport');
	                        }
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this6.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this6.state.contactStatus && _this6.state.type === 'videoReport' && _this6.state.contactID === items['cfa3_video_reports.id'] && _this6.state.contactIndex === index ? !_this6.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this6.onContactSubmit.bind(_this6) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this6.SubjectInputChange.bind(_this6),
	                          value: _this6.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this6.CommentInputChange.bind(_this6),
	                          value: _this6.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this6.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this6.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items['cfa3_video_reports.reply'])
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteReportsVideo.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items['cfa3_video_reports.comment'])
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestionCBT.length) {
	        cbt_reportsData = reportquestionCBT_val.map(function (items, index) {
	          var parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
	          var mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this6.OpenEditCBTQuesReport.bind(_this6, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this6.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportEditStatus && _this6.state.reportEditId === items.id && _this6.state.type === 'cbtquesReport',
	                  toggle: _this6.OpenEditCBTQuesReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  (0, _function.renderHTMLContent)(mockName, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this6.CloseEditCBTQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this6.handleCBTQuestionReportSubmit.bind(_this6) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'cbtquesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this6.InputChange.bind(_this6),
	                            value: _this6.state.cbtquesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            _this6.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this6.CloseEditCBTQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this6.view(items);
	                    },
	                    className: _this6.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply && items.reply.length > 0 ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this6.toggleAlertReport.bind(_this6, items, 'cbtquesReport'),
	                  className: _this6.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this6.state.reportAnswerStatus && _this6.state.reportAnswerId === items.id && _this6.state.type === 'cbtquesReport',
	                  toggle: _this6.toggleAlertReport,
	                  className: 'modal-primary ' + _this6.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this6.state.contactStatus && _this6.state.contactType === 'cbtquesReport' && _this6.state.contactID === items.id && _this6.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(items, index, 'cbtquesReport');
	                        }
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: function onClick() {
	                          return _this6.onContactChange(items, index, 'cbtquesReport');
	                        }
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this6.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this6.state.contactStatus && _this6.state.contactType === 'cbtquesReport' && _this6.state.contactID === items.id && _this6.state.contactIndex === index ? !_this6.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this6.onContactSubmit.bind(_this6) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this6.SubjectInputChange.bind(_this6),
	                          value: _this6.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this6.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this6.CommentInputChange.bind(_this6),
	                          value: _this6.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this6.state.displaytext + ' text-danger' },
	                          _this6.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this6.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this6.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this6._deleteCBTReportsquestino.bind(_this6, items),
	                    className: _this6.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        cbt_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      // ================= Notes And Videos ; ====================//
	
	      // alert((this.state.tooltips)[0].placement);
	      var notesProgressLoader = this.state.notesProgressLoader;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().CFA_LEVEL_III_MY_DASHBOARD
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.savedTabToggle('2');
	                        },
	                        className: activeTabSaved === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : this.state.activeTabSaved === '2' ? savednotes_data : savedvideo_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.reportsTabToggle('2');
	                        },
	                        className: activeTabReports === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.reportsTabToggle('4');
	                        },
	                        className: activeTabReports === '4' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' Mocks '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this6.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : this.state.activeTabReports === '2' ? notes_reportsData : this.state.activeTabReports === '3' ? video_reportsData : cbt_reportsData
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    notesProgressLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.renderNotesProgressBar()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'close', 'aria-label': 'Close', onClick: this.toggleClose },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    // ========================== NOTES AND VIDEOS Function ======================= //
	
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditNotesReport',
	    value: function CloseEditNotesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        notesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'OpenEditNotesReport',
	    value: function OpenEditNotesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        notesReport: item.comment,
	        type: 'notesReport'
	      });
	    }
	
	    // function for get  notes report
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  video report
	
	
	    /*
	     * get saved all video
	     */
	
	
	    // function for get  notes report
	
	  }, {
	    key: 'handleNotesReportSubmit',
	
	
	    // notes form submit function
	    value: function () {
	      var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, notesReport, data;
	
	        return _regenerator2.default.wrap(function _callee43$(_context43) {
	          while (1) {
	            switch (_context43.prev = _context43.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport === '' && this.state.notesReport.length < 1)) {
	                  _context43.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context43.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, notesReport = _state3.notesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport
	                };
	                _context43.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(resp) {
	                    return _regenerator2.default.wrap(function _callee42$(_context42) {
	                      while (1) {
	                        switch (_context42.prev = _context42.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context42.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              notesReport: ''
	                            });
	                            _context42.next = 4;
	                            return _this7.getNotesReports();
	
	                          case 4:
	                            _context42.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context42.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context42.stop();
	                        }
	                      }
	                    }, _callee42, _this7);
	                  }));
	
	                  return function (_x34) {
	                    return _ref43.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context43.stop();
	            }
	          }
	        }, _callee43, this);
	      }));
	
	      function handleNotesReportSubmit(_x33) {
	        return _ref42.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit;
	    }()
	
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(event) {
	        var _this8 = this;
	
	        var _state4, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee45$(_context45) {
	          while (1) {
	            switch (_context45.prev = _context45.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context45.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context45.abrupt('return');
	
	              case 4:
	                _state4 = this.state, reportEditId = _state4.reportEditId, idname = _state4.idname, token = _state4.token, videoReport = _state4.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context45.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(resp) {
	                    return _regenerator2.default.wrap(function _callee44$(_context44) {
	                      while (1) {
	                        switch (_context44.prev = _context44.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context44.next = 6;
	                              break;
	                            }
	
	                            _this8.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this8.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context44.next = 4;
	                            return _this8.getVideoReports();
	
	                          case 4:
	                            _context44.next = 7;
	                            break;
	
	                          case 6:
	                            _this8.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context44.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context44.stop();
	                        }
	                      }
	                    }, _callee44, _this8);
	                  }));
	
	                  return function (_x36) {
	                    return _ref45.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context45.stop();
	            }
	          }
	        }, _callee45, this);
	      }));
	
	      function handleVideoReportSubmit(_x35) {
	        return _ref44.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	    /*
	     * function for go to specific notes main page
	     */
	
	  }]);
	
	  return Cfa3Dashboard;
	}(_react.Component);
	
	Cfa3Dashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa3Dashboard;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CaseQuestions = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _StatusChangeModel = __webpack_require__(267);
	
	var _StatusChangeModel2 = _interopRequireDefault(_StatusChangeModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _DisplayLoader = __webpack_require__(666);
	
	var _DisplayLoader2 = _interopRequireDefault(_DisplayLoader);
	
	var _Heading = __webpack_require__(181);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _ViewAnswer = __webpack_require__(182);
	
	var _ViewAnswer2 = _interopRequireDefault(_ViewAnswer);
	
	var _ViewCase = __webpack_require__(668);
	
	var _ViewCase2 = _interopRequireDefault(_ViewCase);
	
	var _ViewQuestions = __webpack_require__(669);
	
	var _ViewQuestions2 = _interopRequireDefault(_ViewQuestions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */
	
	// import { showFailure } from '../../common/toast';
	
	
	var CaseQuestions = exports.CaseQuestions = function (_Component) {
	  _inherits(CaseQuestions, _Component);
	
	  function CaseQuestions(props) {
	    _classCallCheck(this, CaseQuestions);
	
	    var _this = _possibleConstructorReturn(this, (CaseQuestions.__proto__ || Object.getPrototypeOf(CaseQuestions)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      showResult: false,
	      caseQuestions: [],
	      cases: [],
	      displayLoader: true,
	      idname: '',
	      token: '',
	      justification1: '',
	      justification2: '',
	      selectedChoice: '',
	      selectedIndex: -1,
	      displayError: false,
	      displayQuestionLoader: false,
	      stopTimer: false,
	      userGrading: 'Select grading',
	      disableNavigationButtons: false,
	      report_block: 'card hide_block',
	      successAlert: false,
	      reportLoading: false,
	
	      showComponent: [1, 2],
	      showLoaderOnModel: true,
	      userStats: [],
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      errorMessageOnValidate: ''
	    };
	    _this.attemptedQuestions = [];
	    return _this;
	  }
	
	  _createClass(CaseQuestions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      if (localStorage.getItem('attemptedQuestions')) this.attemptedQuestions = JSON.parse(localStorage.getItem('attemptedQuestions'));
	
	      var _props$params = this.props.params,
	          _props$params$caseId = _props$params.caseId,
	          caseId = _props$params$caseId === undefined ? 1 : _props$params$caseId,
	          _props$params$chapter = _props$params.chapterID,
	          chapterID = _props$params$chapter === undefined ? 1 : _props$params$chapter;
	
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        caseId: caseId,
	        chapterId: chapterID
	      };
	      this.getCaseQuestions(data);
	      this.getCases(data);
	    }
	    //Function to show Report box
	
	    //Function to hide Report box
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state,
	          props = this.props;
	      var showResult = state.showResult,
	          caseQuestions = state.caseQuestions,
	          cases = state.cases,
	          displayLoader = state.displayLoader,
	          justification1 = state.justification1,
	          justification2 = state.justification2,
	          selectedChoice = state.selectedChoice,
	          selectedIndex = state.selectedIndex,
	          displayError = state.displayError,
	          displayQuestionLoader = state.displayQuestionLoader,
	          stopTimer = state.stopTimer,
	          userGrading = state.userGrading,
	          disableNavigationButtons = state.disableNavigationButtons,
	          userStats = state.userStats,
	          showComponent = state.showComponent,
	          showLoaderOnModel = state.showLoaderOnModel,
	          changeStatusTitle = state.changeStatusTitle,
	          markAsCompleted = state.markAsCompleted,
	          change_status = state.change_status,
	          markAsNotCompleted = state.markAsNotCompleted,
	          markCompleted = state.markCompleted,
	          reportLoading = state.reportLoading,
	          bookmarkCSS = state.bookmarkCSS,
	          bookmarkColor = state.bookmarkColor,
	          errorMessageOnValidate = state.errorMessageOnValidate;
	      var _props$params2 = props.params,
	          _props$params2$questi = _props$params2.questionIndex,
	          questionIndex = _props$params2$questi === undefined ? 0 : _props$params2$questi,
	          _props$params2$caseIn = _props$params2.caseIndex,
	          caseIndex = _props$params2$caseIn === undefined ? 0 : _props$params2$caseIn,
	          chapterName = _props$params2.chapterName;
	
	      var questionData = {};
	      var caseData = {};
	      if (caseQuestions.length) {
	        questionData = caseQuestions[questionIndex];
	      }
	      if (cases.length) {
	        caseData = cases[caseIndex];
	      }
	      var questions_data_display = questionData;
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _Heading2.default,
	          { headerText: chapterName },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: function onClick() {
	                _this2.changeCase();
	              }
	            },
	            'Change Case'
	          )
	        ),
	        _react2.default.createElement(
	          _DisplayLoader2.default,
	          { displayLoader: displayLoader },
	          _react2.default.createElement(_ViewCase2.default, Object.assign({}, caseData, {
	            casesData: cases,
	            caseIndex: caseIndex,
	            getNextCase: this.getNextCase,
	            getPreviousCase: this.getPreviousCase,
	            disableNavigationButtons: disableNavigationButtons
	          })),
	          _react2.default.createElement(
	            _DisplayLoader2.default,
	            { displayLoader: displayQuestionLoader },
	            _react2.default.createElement(_ViewQuestions2.default, Object.assign({}, questionData, {
	              caseQuestions: caseQuestions,
	              attemptedQuestions: this.attemptedQuestions,
	              questionIndex: questionIndex,
	              getPreviousQuestion: this.getPreviousQuestion,
	              getNextQuestion: this.getNextQuestion,
	              setJustification: this.setJustification,
	              setUserChoice: this.setUserChoice,
	              justification1: justification1,
	              justification2: justification2,
	              selectedChoice: selectedChoice,
	              selectedIndex: selectedIndex,
	              displayError: displayError,
	              stopTimer: stopTimer,
	              disableNavigationButtons: disableNavigationButtons,
	              errorMessageOnValidate: errorMessageOnValidate,
	              showResult: showResult,
	              all_questions: questionIndex,
	              isQue: true,
	              _getResult: this._getResult,
	              _saveQuestion: this._saveQuestion,
	              _displayReportForm: this._displayReportForm,
	              save_text: _language2.default.LC().SAVE_QUESTION,
	              bookmarkCSS: bookmarkCSS,
	              bookmarkColor: bookmarkColor,
	              questionData: questionData
	            }))
	          )
	        ),
	        _react2.default.createElement('div', { className: 'mb-2' }),
	        showResult ? _react2.default.createElement(_ViewAnswer2.default, Object.assign({}, questionData, {
	          handleChange: this.handleChange,
	          selectedChoice: selectedChoice,
	          userGrading: userGrading
	        })) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.report_block },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().REPORT
	              ),
	              !this.state.successAlert ? _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'form-control-label', htmlFor: 'textarea-input' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        ' ',
	                        _language2.default.LC().COMMENT
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12 margin_bottom_10' },
	                    _react2.default.createElement('textarea', {
	                      id: 'comment',
	                      name: 'comment',
	                      rows: '6',
	                      className: 'form-control',
	                      placeholder: 'Content..'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-primary active pointer_class report-btn',
	                        disabled: reportLoading,
	                        onClick: function onClick() {
	                          return _this2._reportQuestion(_this2, questions_data_display);
	                        }
	                      },
	                      ' ',
	                      reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-danger active pointer_class margin_left_10',
	                        onClick: function onClick() {
	                          return _this2._hideReportForm.bind(_this2, questions_data_display);
	                        }
	                      },
	                      ' ',
	                      _language2.default.LC().CANCEL
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 report-Success-card' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'form-control-label', htmlFor: 'textarea-input' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        ' ',
	                        _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-primary active pointer_class  min-vw-120',
	                        onClick: this.onClose
	                      },
	                      ' ',
	                      _language2.default.LC().CLOSE
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_StatusChangeModel2.default, {
	          change_status: change_status,
	          className: '',
	          changeModelStatus: this.changeModelStatus,
	          changeStatusTitle: changeStatusTitle,
	          markAsCompleted: markAsCompleted,
	          markNotCompleted: this.markNotCompleted,
	          markAsNotCompleted: markAsNotCompleted,
	          markCompleted: markCompleted,
	          markCompletedFun: this.markCompleted,
	          changeCompletionStatus: this.changeCompletionStatus,
	          summaryDetails: userStats,
	          showComponent: showComponent,
	          showLoaderOnModel: showLoaderOnModel
	        })
	      );
	    }
	  }]);
	
	  return CaseQuestions;
	}(_react.Component);
	
	CaseQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getNextCase = function () {
	    var nextIndex = _this3.changeIndexInParam(1, 'case');
	    if (nextIndex) {
	      _this3.refetchAndSetCaseQuestions(nextIndex);
	      _this3.attemptedQuestions = [];
	    }
	  };
	
	  this.getPreviousCase = function () {
	    var prevIndex = _this3.changeIndexInParam(-1, 'case');
	    if (prevIndex > -1) {
	      _this3.refetchAndSetCaseQuestions(prevIndex);
	      _this3.attemptedQuestions = [];
	    }
	  };
	
	  this.refetchAndSetCaseQuestions = function (index) {
	    var _state = _this3.state,
	        idname = _state.idname,
	        token = _state.token,
	        cases = _state.cases;
	
	    var data = {
	      idname: idname,
	      token: token,
	      caseId: cases[index].id
	    };
	    _this3.getCaseQuestions(data);
	  };
	
	  this.getPreviousQuestion = function () {
	    _this3.changeIndexInParam(-1, 'question');
	  };
	
	  this.getFavQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var questionIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var state, props, idname, token, caseQuestions, chapterID, isEssayQuestion, question_id, data, getQuestionIndex, _attemptedQuestions$g, userGrading, selectedChoice, justification1, justification2, stopTimer, selectedIndex, disableNavigationButtons;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            //Api to Fetch saved question stats
	            state = _this3.state, props = _this3.props;
	            idname = state.idname, token = state.token, caseQuestions = state.caseQuestions;
	            chapterID = props.params.chapterID;
	            // console.log({ questionIndex });
	
	            isEssayQuestion = 1;
	            question_id = caseQuestions[questionIndex];
	            data = {
	              idname: idname,
	              token: token,
	              essayQuestionIndex: questionIndex,
	              isEssayQuestion: isEssayQuestion,
	              question_id: question_id.id,
	              chapter_id: chapterID
	            };
	            getQuestionIndex = _this3.attemptedQuestions.findIndex(function (element) {
	              return element.questionId === question_id.id;
	            });
	
	
	            if (getQuestionIndex !== -1) {
	              _attemptedQuestions$g = _this3.attemptedQuestions[getQuestionIndex], userGrading = _attemptedQuestions$g.userGrading, selectedChoice = _attemptedQuestions$g.selectedChoice, justification1 = _attemptedQuestions$g.justification1, justification2 = _attemptedQuestions$g.justification2, stopTimer = _attemptedQuestions$g.stopTimer, selectedIndex = _attemptedQuestions$g.selectedIndex, disableNavigationButtons = _attemptedQuestions$g.disableNavigationButtons;
	
	              _this3.setState({
	                userGrading: userGrading,
	                selectedChoice: selectedChoice,
	                justification1: justification1,
	                justification2: justification2,
	                stopTimer: stopTimer,
	                selectedIndex: selectedIndex,
	                disableNavigationButtons: disableNavigationButtons,
	                showResult: true
	              }, function () {
	                // console.log('check stop timer in callBack', this.state.stopTimer);
	              });
	            }
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', data).then(function (response) {
	              if (response.success) {
	                // console.log('I am inside getSave Question');
	                _this3.setState({
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  save_text: '' + _language2.default.LC().Question_Saved
	                });
	              } else {
	                _this3.setState({
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  bookmarkColor: ''
	                });
	              }
	            });
	
	          case 9:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this3);
	  }));
	
	  this.unSaveQuestion = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/unsaveQuestion', data).then(function (resp) {
	                if (resp.success) {
	                  _this3.setState({
	                    ValidToken: true,
	                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                    bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                    bookmarkColor: '',
	                    save_text: '' + _language2.default.LC().SAVE_QUESTION
	                  });
	                } else {
	                  _this3.setState({ ValidToken: false });
	                }
	                return resp;
	              });
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this3);
	    }));
	
	    return function (_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  this.getSummary = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var _state2, caseQuestions, token, idname, _props$params$questio, questionIndex, case_id, data, result, userStats;
	
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _state2 = _this3.state, caseQuestions = _state2.caseQuestions, token = _state2.token, idname = _state2.idname;
	            _props$params$questio = _this3.props.params.questionIndex, questionIndex = _props$params$questio === undefined ? 0 : _props$params$questio;
	            case_id = caseQuestions[questionIndex].case_id;
	            data = {
	              token: token,
	              idname: idname,
	              caseId: case_id
	            };
	
	
	            _this3.setState({
	              change_status: true,
	              changeStatusTitle: 'View Summary',
	              showLoaderOnModel: true
	            });
	            _context3.next = 7;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getSummary', data);
	
	          case 7:
	            result = _context3.sent;
	
	            if (result.success) {
	              userStats = result.userStats;
	
	              _this3.setState({
	                userStats: userStats,
	                showLoaderOnModel: false
	              });
	            } else {
	              _this3.setState({
	                change_status: true
	              });
	              (0, _toast.showFailure)('Something went wrong');
	            }
	
	          case 9:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this3);
	  }));
	
	  this.markCompleted = function () {
	    _this3.setState({
	      markAsCompleted: true,
	      markAsNotCompleted: false,
	      markCompleted: false
	    });
	  };
	
	  this.markNotCompleted = function () {
	    _this3.setState({
	      markAsCompleted: false,
	      markAsNotCompleted: true,
	      markCompleted: false
	    });
	  };
	
	  this.changeCompletionStatus = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	    var _state3, markAsCompleted, token, idname, cases, _props$params$caseInd, caseIndex, caseData, chapter_id, id, data;
	
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _state3 = _this3.state, markAsCompleted = _state3.markAsCompleted, token = _state3.token, idname = _state3.idname, cases = _state3.cases, _props$params$caseInd = _this3.props.params.caseIndex, caseIndex = _props$params$caseInd === undefined ? 0 : _props$params$caseInd;
	            caseData = cases[caseIndex];
	            chapter_id = caseData.chapter_id, id = caseData.id;
	            data = {
	              idname: idname,
	              token: token,
	              chapterNo: chapter_id,
	              caseNo: id,
	              status: markAsCompleted ? 1 : 0
	            };
	            _context4.next = 6;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/upsertUserStats', data).then(function () {
	              _this3.setState({ change_status: false });
	              _this3.getNextCase();
	            });
	
	          case 6:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, _this3);
	  }));
	
	  this.getNextQuestion = function () {
	    var result = _this3.changeIndexInParam(1, 'question');
	    var caseQuestions = _this3.state.caseQuestions;
	
	    if (result === -1 && _this3.attemptedQuestions.length === caseQuestions.length) {
	      _this3.getSummary();
	    }
	  };
	
	  this.changeIndexInParam = function (value, section) {
	    var params = _this3.props.params,
	        _state4 = _this3.state,
	        caseQuestions = _state4.caseQuestions,
	        cases = _state4.cases;
	    var caseId = params.caseId,
	        caseIndex = params.caseIndex,
	        chapterID = params.chapterID,
	        chapterName = params.chapterName,
	        questionIndex = params.questionIndex;
	
	
	    var currentArray = cases;
	    var currentIndex = caseIndex;
	
	    if (section === 'question') {
	      currentArray = caseQuestions;
	      currentIndex = questionIndex;
	    }
	    var condition = value === -1 ? parseInt(currentIndex, 10) > 0 : parseInt(currentIndex, 10) < currentArray.length - 1;
	    if (condition) {
	      var newQuestionIndex = section === 'question' ? parseInt(questionIndex, 10) + value : questionIndex;
	      var newCaseIndex = caseIndex;
	      if (section === 'case') {
	        newCaseIndex = section === 'case' ? parseInt(caseIndex, 10) + value : caseIndex;
	        newQuestionIndex = 0;
	      }
	
	      _this3.context.router.push({
	        pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', caseId).replace(':chapterName', chapterName).replace(':chapterID', chapterID).replace(':questionIndex', newQuestionIndex).replace(':caseIndex', newCaseIndex)
	      });
	      _this3.setState({
	        justification1: '',
	        justification2: '',
	        selectedChoice: '',
	        showResult: false,
	        selectedIndex: -1,
	        displayError: false,
	        stopTimer: false,
	        disableNavigationButtons: false,
	        userGrading: 'Select grading'
	      }, function () {
	        if (section === 'question') _this3.getFavQuestion(newQuestionIndex);
	      });
	      return section === 'case' ? newCaseIndex : newQuestionIndex;
	    } else return -1;
	  };
	
	  this.getCaseQuestions = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	      var response, success, caseQuestions, questionIndex;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this3.setState({
	                displayQuestionLoader: true
	              });
	              _context5.next = 3;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getQuestionsByCaseId', data);
	
	            case 3:
	              response = _context5.sent;
	
	              try {
	                success = response.success, caseQuestions = response.caseQuestions;
	
	                if (success) {
	                  questionIndex = _this3.props.params.questionIndex;
	
	                  _this3.setState({ ValidToken: true, caseQuestions: caseQuestions });
	                  _this3.getFavQuestion(questionIndex);
	                } else {
	                  _this3.setState({
	                    ValidToken: false
	                  });
	                }
	              } catch (error) {}
	              _this3.setState({
	                displayLoader: false,
	                displayQuestionLoader: false
	              });
	
	            case 6:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this3);
	    }));
	
	    return function (_x3) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  this.getCases = function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	      var getCases, success;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.next = 2;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getCasesByChaptersId', data);
	
	            case 2:
	              getCases = _context6.sent;
	              success = getCases.success;
	
	              if (success) {
	                _this3.setState({
	                  ValidToken: true,
	                  cases: getCases && getCases.cases
	                });
	              } else {
	                _this3.setState({
	                  ValidToken: false,
	                  errorMessage: getCases && getCases.message
	                });
	              }
	              _this3.setState({
	                displayLoader: false
	              });
	
	            case 6:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this3);
	    }));
	
	    return function (_x4) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  this.setJustification = function (event) {
	    var _this3$setState;
	
	    var _event$target = event.target,
	        value = _event$target.value,
	        name = _event$target.name;
	
	    _this3.setState((_this3$setState = {}, _defineProperty(_this3$setState, name, value), _defineProperty(_this3$setState, 'displayError', false), _this3$setState));
	  };
	
	  this.setUserChoice = function (value, index) {
	    _this3.setState({
	      selectedChoice: value,
	      selectedIndex: index,
	      displayError: false
	    });
	  };
	
	  this.upsertQuestionUserStats = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	    var _state5, idname, token, justification1, justification2, selectedChoice, userGrading, cases, caseQuestions, selectedIndex, stopTimer, disableNavigationButtons, _props$params3, _props$params3$questi, questionIndex, _props$params3$caseIn, caseIndex, _caseQuestions$questi, case_id, id, chapter_id, data, getQuestionIndex, dataset;
	
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _state5 = _this3.state, idname = _state5.idname, token = _state5.token, justification1 = _state5.justification1, justification2 = _state5.justification2, selectedChoice = _state5.selectedChoice, userGrading = _state5.userGrading, cases = _state5.cases, caseQuestions = _state5.caseQuestions, selectedIndex = _state5.selectedIndex, stopTimer = _state5.stopTimer, disableNavigationButtons = _state5.disableNavigationButtons;
	            _props$params3 = _this3.props.params, _props$params3$questi = _props$params3.questionIndex, questionIndex = _props$params3$questi === undefined ? 0 : _props$params3$questi, _props$params3$caseIn = _props$params3.caseIndex, caseIndex = _props$params3$caseIn === undefined ? 0 : _props$params3$caseIn;
	            _caseQuestions$questi = caseQuestions[questionIndex], case_id = _caseQuestions$questi.case_id, id = _caseQuestions$questi.id;
	            chapter_id = cases[caseIndex].chapter_id;
	            data = {
	              idname: idname,
	              token: token,
	              caseId: case_id,
	              questionIndex: questionIndex,
	              questionId: id,
	              chapterId: chapter_id,
	              userGrading: userGrading,
	              multipleAnswer: selectedChoice,
	              userJustification1: justification1,
	              userJustification2: justification2
	            };
	            getQuestionIndex = _this3.attemptedQuestions.findIndex(function (element) {
	              return element.questionId === id;
	            });
	            dataset = {
	              caseId: case_id,
	              questionIndex: questionIndex,
	              questionId: id,
	              chapterId: chapter_id,
	              userGrading: userGrading,
	              selectedChoice: selectedChoice,
	              selectedIndex: selectedIndex,
	              justification1: justification1,
	              justification2: justification2,
	              stopTimer: stopTimer,
	              disableNavigationButtons: disableNavigationButtons
	            };
	
	            if (getQuestionIndex === -1) {
	              _this3.attemptedQuestions.push(dataset);
	            } else _this3.attemptedQuestions[getQuestionIndex] = dataset;
	            localStorage.setItem('attemptedQuestions', JSON.stringify(_this3.attemptedQuestions));
	            // console.log('check the after selected grading', this.attemptedQuestions);
	            _context7.next = 11;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/upsertQuestionsUserStats', data).then(function (res) {
	              if (res.success) {
	                (0, _toast.showSuccess)('Grading updated.');
	              }
	            });
	
	          case 11:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, _this3);
	  }));
	
	  this.handleChange = function (event) {
	    var _this3$setState2;
	
	    var _event$target2 = event.target,
	        name = _event$target2.name,
	        value = _event$target2.value;
	
	    _this3.setState((_this3$setState2 = {}, _defineProperty(_this3$setState2, name, value), _defineProperty(_this3$setState2, 'disableNavigationButtons', false), _this3$setState2), function () {
	      if (name === 'userGrading') _this3.upsertQuestionUserStats();
	    });
	  };
	
	  this._getResult = function () {
	    var state = _this3.state,
	        questionIndex = _this3.props.params.questionIndex;
	    var justification1 = state.justification1,
	        justification2 = state.justification2,
	        selectedChoice = state.selectedChoice,
	        caseQuestions = state.caseQuestions,
	        selectedIndex = state.selectedIndex,
	        stopTimer = state.stopTimer;
	    var _caseQuestions$questi2 = caseQuestions[questionIndex],
	        id = _caseQuestions$questi2.id,
	        case_id = _caseQuestions$questi2.case_id,
	        is_multiple = _caseQuestions$questi2.is_multiple,
	        development_justification = _caseQuestions$questi2.development_justification,
	        development_justification2 = _caseQuestions$questi2.development_justification2;
	
	    var optionTypeCount = 0,
	        answerTypeCount = 0;
	    if (is_multiple === 1) optionTypeCount++;
	
	    if (development_justification.trim()) optionTypeCount++;
	
	    if (development_justification2.trim()) optionTypeCount++;
	
	    if (justification1) answerTypeCount++;
	
	    if (justification2) answerTypeCount++;
	
	    if (selectedChoice) answerTypeCount++;
	
	    if (optionTypeCount === answerTypeCount) {
	      // if (
	      //   (development_justification.trim() &&
	      //     justification1.trim().length < 50) ||
	      //   (development_justification2.trim() && justification2.trim().length < 50)
	      // ) {
	      //   this.setState({
	      //     displayError: true,
	      //     errorMessageOnValidate:
	      //       'Justification should be greater than 50 characters',
	      //   });
	      //   return;
	      // }
	      _this3.setState({
	        showResult: true,
	        stopTimer: true,
	        disableNavigationButtons: true
	      });
	
	      var getQuestionIndex = _this3.attemptedQuestions.findIndex(function (element) {
	        return element.questionId === id;
	      });
	      var dataset = {
	        caseId: case_id,
	        questionIndex: questionIndex,
	        questionId: id,
	        selectedChoice: selectedChoice,
	        selectedIndex: selectedIndex,
	        justification1: justification1,
	        justification2: justification2,
	        stopTimer: stopTimer,
	        disableNavigationButtons: true
	      };
	      if (getQuestionIndex === -1) {
	        _this3.attemptedQuestions.push(dataset);
	      }
	    } else {
	      // showFailure('Please answer all sections of a question.');
	      _this3.setState({
	        displayError: true,
	        errorMessageOnValidate: 'Please answer all fields'
	      });
	    }
	  };
	
	  this._saveQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	    for (var _len = arguments.length, questionIndex = Array(_len), _key = 0; _key < _len; _key++) {
	      questionIndex[_key] = arguments[_key];
	    }
	
	    var essayQuestionIndex, _state6, idname, token, caseQuestions, chapterID, isEssayQuestion, question_id, data, saveQuestion;
	
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            essayQuestionIndex = questionIndex['0'];
	            _state6 = _this3.state, idname = _state6.idname, token = _state6.token, caseQuestions = _state6.caseQuestions;
	            chapterID = _this3.props.params.chapterID;
	            isEssayQuestion = 1;
	            question_id = caseQuestions[essayQuestionIndex];
	            data = {
	              idname: idname,
	              token: token,
	              essayQuestionIndex: essayQuestionIndex,
	              isEssayQuestion: isEssayQuestion,
	              question_id: question_id.id,
	              chapter_id: chapterID
	            };
	
	            if (!(_this3.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark')) {
	              _context8.next = 9;
	              break;
	            }
	
	            _this3.unSaveQuestion(data);
	            return _context8.abrupt('return');
	
	          case 9:
	            _context8.next = 11;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveQuestion', data);
	
	          case 11:
	            saveQuestion = _context8.sent;
	
	            if (saveQuestion.success) {
	              _this3.setState({ ValidToken: true });
	              _this3.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this3.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this3.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	              _this3.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	            } else {
	              _this3.setState({ ValidToken: false });
	            }
	
	          case 13:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, _this3);
	  }));
	
	  this._displayReportForm = function () {
	    _this3.setState({ report_block: 'card show_block' });
	  };
	
	  this._reportQuestion = function () {
	    for (var _len2 = arguments.length, item = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      item[_key2] = arguments[_key2];
	    }
	
	    var question_id = item['1'].id;
	    var _props$params4 = _this3.props.params,
	        questionIndex = _props$params4.questionIndex,
	        caseIndex = _props$params4.caseIndex;
	
	    var comment = document.getElementById('comment').value;
	    if (comment.length < 2) {
	      return;
	    }
	    // const result = getDeviceDetails();
	    var data = {
	      token: _this3.state.token,
	      idname: _this3.state.idname,
	      question_id: question_id,
	      comment: comment,
	      essayQuestionIndex: questionIndex,
	      isEssayQuestion: 1,
	      caseIndex: caseIndex,
	      city: _this3.state.user_city,
	      country: _this3.state.user_country,
	      state: _this3.state.user_state,
	      continent: _this3.state.user_continent,
	      ip: _this3.state.user_ip
	    };
	    _this3.setState({
	      reportLoading: true
	    });
	
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/reportQuestion', data).then(function (resp) {
	      if (resp.success) {
	        _this3.setState({
	          ValidToken: true,
	          successAlert: true,
	          reportLoading: false
	        });
	        // setState({ successAlert: true }) re-renders the report block into the
	        // success view, which unmounts the textarea. By the time this line
	        // ran the element was already gone, throwing
	        //   TypeError: Cannot set properties of null (setting 'value')
	        // and aborting the rest of the .then chain. The reset is purely
	        // cosmetic (the textarea won't be visible again until the user
	        // reopens the report form), so a null-guard is enough to silence the
	        // error and let the promise resolve normally.
	        var commentEl = document.getElementById('comment');
	        if (commentEl) commentEl.value = '';
	      } else {
	        _this3.setState({ ValidToken: false });
	      }
	      return resp;
	    });
	  };
	
	  this.changeModelStatus = function () {
	    _this3.setState({
	      change_status: false
	    });
	  };
	
	  this.changeCase = function () {
	    var _props$params5 = _this3.props.params,
	        chapterID = _props$params5.chapterID,
	        chapterName = _props$params5.chapterName;
	
	    localStorage.removeItem('attemptedQuestions');
	    _this3.context.router.push({
	      pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASES.replace(':chapterID', chapterID).replace(':chapterName', chapterName)
	    });
	  };
	
	  this.onClose = function () {
	    _this3.setState({
	      report_block: 'card hide_block',
	      successAlert: false
	    });
	  };
	
	  this._hideReportForm = function () {
	    _this3.setState({ report_block: 'card hide_block' });
	  };
	};
	
	exports.default = CaseQuestions;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfa3EssayQuestions = function (_Component) {
	  _inherits(Cfa3EssayQuestions, _Component);
	
	  function Cfa3EssayQuestions(props) {
	    _classCallCheck(this, Cfa3EssayQuestions);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3EssayQuestions.__proto__ || Object.getPrototypeOf(Cfa3EssayQuestions)).call(this, props));
	
	    var messageTitle_cfa_3 = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa_3,
	      MessageContent: _alertMessage2.default.messageContent_cfa_3,
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      selectedmenu: 'cfa_3',
	      showFreePremium: '',
	      userType: '',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Cfa3EssayQuestions, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this2 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context4.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	
	                if (localStorage.getItem('selectedmenu') === 'frm') {
	                  this.context.router.push({
	                    pathname: '/frm/questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context4.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getcfa3_essayques', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this2.setState({ ValidToken: true, chapters: resp.cfa3essayques });
	                            } else {
	                              _this2.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	                data = { token: this.state.token, idname: this.state.idname };
	                _context4.next = 13;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this2.setState({ showFreePremium: true, userType: 'free' });
	                            _context3.next = 10;
	                            break;
	
	                          case 5:
	                            _this2.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this2.state.token,
	                              idname: _this2.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 11;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this2.state.selectedmenu;
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context2.next = 7;
	                                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context2.sent;
	
	                                        if (isInArray_var) {
	                                          _this2.setState({ showFreePremium: false, userType: 'paid' });
	                                        } else {
	                                          _this2.setState({ showFreePremium: true, userType: 'free' });
	                                        }
	                                        _context2.next = 11;
	                                        break;
	
	                                      case 11:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 10:
	                            _context3.next = 21;
	                            break;
	
	                          case 12:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context3.next = 16;
	                              break;
	                            }
	
	                            _this2.setState({ showFreePremium: true, userType: 'free' });
	                            _context3.next = 21;
	                            break;
	
	                          case 16:
	                            _this2.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this2.state.token,
	                              idname: _this2.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 21;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	
	                                if (isInArray_var) {
	                                  _this2.setState({ showFreePremium: false, userType: 'paid' });
	                                } else {
	                                  _this2.setState({ showFreePremium: true, userType: 'free' });
	                                }
	                              } else {
	                                'fail';
	                              }
	                            });
	
	                          case 21:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 13:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'pdfOpen',
	    value: function pdfOpen(pdfdata, e) {
	      if (this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          id: pdfdata.id,
	          city: this.state.user_city,
	          country: this.state.user_country,
	          state: this.state.user_state,
	          continent: this.state.user_continent,
	          ip: this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/trackUserMockExamPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(pdfdata.pdf_file
	            // `${window.location.origin +
	            //   "/pdf/cfa3EssayQuesPdf/" +
	            //   pdfdata.pdf_file}`
	            );
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        this.toggleAlert();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var chapters = this.state.chapters;
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                onClick: _this3.pdfOpen.bind(_this3, item),
	                id: item.id,
	                value: item.pdf_file
	              },
	              _this3.state.showFreePremium ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/mockexams/ebook_icon.svg',
	                  className: '',
	                  width: '50',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: '', key: item.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    item.essay_ques_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.pdf_file },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/mockexams/print_icon.svg',
	                        className: '',
	                        width: '20',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _language2.default.LC().PRINT
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().READY_FOR_PRINT
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().CFA_LEVEL_III_PRINTABLE_ESSAY_QUESTIONS
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	        })
	      );
	    }
	  }]);
	
	  return Cfa3EssayQuestions;
	}(_react.Component);
	
	Cfa3EssayQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa3EssayQuestions;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chapters = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _CaseCard = __webpack_require__(665);
	
	var _CaseCard2 = _interopRequireDefault(_CaseCard);
	
	var _Heading = __webpack_require__(181);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chapters = exports.Chapters = function (_Component) {
	  _inherits(Chapters, _Component);
	
	  function Chapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Chapters);
	
	    var _this = _possibleConstructorReturn(this, (Chapters.__proto__ || Object.getPrototypeOf(Chapters)).call(this, props));
	
	    _this.getChapter = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var getChapters, success, chapters;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getChapterWithCount', data);
	
	              case 2:
	                getChapters = _context.sent;
	                success = getChapters.success, chapters = getChapters.chapters;
	
	                if (success) {
	                  _this.setState({ ValidToken: true, chapters: chapters });
	                } else {
	                  _this.setState({
	                    ValidToken: false,
	                    chapters: [{
	                      chapter_no: '',
	                      chapter_name: 'No data found',
	                      cfa3_essay_case: {
	                        free_cases: 0,
	                        premium_cases: 0
	                      }
	                    }]
	                  });
	                }
	                _this.setState({
	                  displayLoader: false
	                });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goToLastAnsweredQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, idname, token, data, getLastAnsweredAnswer, index, casesId, casesIndex, chapterId, chapterName;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, idname = _this$state.idname, token = _this$state.token;
	              data = { idname: idname, token: token };
	              _context2.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getLastAnsweredQuestion', data);
	
	            case 4:
	              getLastAnsweredAnswer = _context2.sent;
	
	              if (getLastAnsweredAnswer.success) {
	                index = getLastAnsweredAnswer.index, casesId = getLastAnsweredAnswer.casesId, casesIndex = getLastAnsweredAnswer.casesIndex, chapterId = getLastAnsweredAnswer.chapterId, chapterName = getLastAnsweredAnswer.chapterName;
	
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', casesId).replace(':chapterName', chapterName).replace(':chapterID', chapterId).replace(':questionIndex', index === -1 ? 0 : index).replace(':caseIndex', casesIndex)
	                });
	              }
	
	            case 6:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: [],
	      displayLoader: true
	    };
	    return _this;
	  }
	
	  _createClass(Chapters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      this.getChapter(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          chapters = _state.chapters,
	          displayLoader = _state.displayLoader;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _Heading2.default,
	          { headerText: 'Essay Question' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: function onClick() {
	                _this3.goToLastAnsweredQuestion();
	              }
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        displayLoader ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { sm: '12', md: '12', className: 'seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  { className: chapters.length === 1 ? 'justify-content-center' : '' },
	                  chapters.map(function (chapter, index) {
	                    return _react2.default.createElement(_CaseCard2.default, Object.assign({
	                      key: index
	                    }, chapter, {
	                      index: index,
	                      router: _this3.context.router
	                    }));
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Chapters;
	}(_react.Component);
	
	Chapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Chapters;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EssayCases = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _StatusChangeModel = __webpack_require__(267);
	
	var _StatusChangeModel2 = _interopRequireDefault(_StatusChangeModel);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Heading = __webpack_require__(181);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Table = __webpack_require__(667);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _function = __webpack_require__(10);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var EssayCases = exports.EssayCases = function (_Component) {
	  _inherits(EssayCases, _Component);
	
	  function EssayCases(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, EssayCases);
	
	    var _this = _possibleConstructorReturn(this, (EssayCases.__proto__ || Object.getPrototypeOf(EssayCases)).call(this, props));
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var _this$state, pdfLoading, pdfLoadingAnswer, user_data;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                console.log('inside functionnn');
	                _this$state = _this.state, pdfLoading = _this$state.pdfLoading, pdfLoadingAnswer = _this$state.pdfLoadingAnswer;
	
	                if (!(pdfLoading === false)) {
	                  _context4.next = 5;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context4.abrupt('return');
	
	              case 5:
	                if (!(pdfLoadingAnswer === false)) {
	                  _context4.next = 8;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context4.abrupt('return');
	
	              case 8:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context.next = 7;
	                                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          questionType: 'essay_question',
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context3.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context3.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        // console.log('isInArray_var_PDF before', isInArray_var_PDF);
	
	                                        _context2.next = 6;
	                                        return _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          questionType: 'essay_question',
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 23:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getUserDetails = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	        var getUserDetails, response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _userStore2.default.getUserProfile(true);
	
	              case 2:
	                getUserDetails = _context5.sent;
	                _context5.next = 5;
	                return _this.setUserDetails(getUserDetails, data);
	
	              case 5:
	                response = _context5.sent;
	
	                if (response) {
	                  _this.getExamByUser(Object.assign({}, data, response));
	                }
	
	              case 7:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.getExamByUser = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	        var getExamByUser, examData, _this$state2, selectedExam, cfaUnlimitedPackage, cfaUnlimitedActiveExam, exam_data, selectedmen, isInArray_var;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', data);
	
	              case 2:
	                getExamByUser = _context6.sent;
	
	                if (getExamByUser.success) {
	                  examData = getExamByUser.examData;
	                  _this$state2 = _this.state, selectedExam = _this$state2.selectedExam, cfaUnlimitedPackage = _this$state2.cfaUnlimitedPackage, cfaUnlimitedActiveExam = _this$state2.cfaUnlimitedActiveExam;
	                  exam_data = examData;
	                  selectedmen = selectedExam;
	                  isInArray_var = false;
	
	
	                  isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, cfaUnlimitedPackage, cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this.setState({
	                      showFreePremium: false,
	                      userType: 'paid'
	                    });
	                  } else {
	                    _this.setState({
	                      showFreePremium: true,
	                      userType: 'free'
	                    });
	                  }
	                } else {}
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x6) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.setUserDetails = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(getUserDetails) {
	        var _getUserDetails$profi, cfaUnlimitedPackage, cfaUnlimitedActiveExam, exam_selected, data_arr;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _getUserDetails$profi = getUserDetails.profileInfo, cfaUnlimitedPackage = _getUserDetails$profi.cfaUnlimitedPackage, cfaUnlimitedActiveExam = _getUserDetails$profi.cfaUnlimitedActiveExam, exam_selected = _getUserDetails$profi.exam_selected;
	
	                if (!(exam_selected === '' && cfaUnlimitedPackage === '' && cfaUnlimitedActiveExam === '')) {
	                  _context7.next = 5;
	                  break;
	                }
	
	                _this.setState({ showFreePremium: true, userType: 'free' });
	                _context7.next = 8;
	                break;
	
	              case 5:
	                _this.setState({
	                  cfaUnlimitedPackage: cfaUnlimitedPackage,
	                  cfaUnlimitedActiveExam: cfaUnlimitedActiveExam
	                });
	                data_arr = exam_selected ? JSON.parse(exam_selected) : null;
	                return _context7.abrupt('return', {
	                  examid: data_arr
	                });
	
	              case 8:
	                return _context7.abrupt('return', null);
	
	              case 9:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.getCases = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	        var getCases, success;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getCasesByChaptersId', data);
	
	              case 2:
	                getCases = _context8.sent;
	                success = getCases.success;
	
	                if (success) {
	                  _this.setState({
	                    ValidToken: true,
	                    cases: getCases && getCases.cases
	                  });
	                } else {
	                  _this.setState({
	                    ValidToken: false,
	                    errorMessage: getCases && getCases.message
	                  });
	                }
	                _this.setState({
	                  displayLoader: false
	                });
	
	              case 6:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x8) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this._beginChapter = function (cases, index) {
	      localStorage.removeItem('attemptedQuestions');
	
	      var _this$state3 = _this.state,
	          subscriptionstatus = _this$state3.subscriptionstatus,
	          showFreePremium = _this$state3.showFreePremium;
	      var _this$props$params = _this.props.params,
	          chapterName = _this$props$params.chapterName,
	          chapterID = _this$props$params.chapterID;
	
	      if (subscriptionstatus === 'free' && showFreePremium === true && cases.free === false) {
	        _this.togglePremiumAlert();
	      } else {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', cases.id).replace(':chapterName', chapterName).replace(':chapterID', chapterID).replace(':questionIndex', 0).replace(':caseIndex', index)
	        });
	      }
	    };
	
	    _this.toggleAlertChangeStatus = function (item, index) {
	      _this.setState({
	        change_status: !_this.state.change_status,
	        change_case_no: item.id,
	        case_chapterId: item.chapter_id,
	        showComponent: [2],
	        showLoaderOnModel: false
	      });
	      item.cfa3_essay_question_cases_statuses.length && item.cfa3_essay_question_cases_statuses[0].status === 1 ? _this.setState({
	        change_completion_status: item.cfa3_essay_question_cases_statuses[0].status,
	        markAsCompleted: true,
	        markAsNotCompleted: false
	      }) : _this.setState({
	        change_completion_status: 0,
	        markAsCompleted: false,
	        markAsNotCompleted: true
	      });
	    };
	
	    _this.markCompleted = function () {
	      _this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    };
	
	    _this.markNotCompleted = function () {
	      _this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    };
	
	    _this.changeCompletionStatus = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e) {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (_this.state.markAsCompleted) {
	                  data = {
	                    chapterNo: _this.state.case_chapterId,
	                    caseNo: _this.state.change_case_no,
	                    status: 1,
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  };
	                } else {
	                  data = {
	                    chapterNo: _this.state.case_chapterId,
	                    caseNo: _this.state.change_case_no,
	                    status: 0,
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  };
	                }
	                _context9.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/upsertUserStats', data).then(function (updateStatus) {
	                  _this.setState({ change_status: false });
	                  var params = _this.props.params;
	
	
	                  var data = {
	                    idname: storage_session['idname'],
	                    token: storage_session['token'],
	                    chapterId: params ? params.chapterID : 1
	                  };
	                  _this.getCases(data);
	                });
	
	              case 4:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x9) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.changeModelStatus = function () {
	      _this.setState({
	        change_status: false
	      });
	    };
	
	    _this.getSummary = function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(item) {
	        var _this$state4, token, idname, data, result, userStats;
	
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this.setState({
	                  showLoaderOnModel: true
	                });
	                _this$state4 = _this.state, token = _this$state4.token, idname = _this$state4.idname;
	                data = {
	                  token: token,
	                  idname: idname,
	                  caseId: item.id
	                };
	
	                _this.setState({
	                  change_status: true,
	                  changeStatusTitle: 'View Summary'
	                });
	                _context10.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3EssayQuestions/getSummary', data);
	
	              case 6:
	                result = _context10.sent;
	
	                if (result.success) {
	                  userStats = result.userStats;
	
	                  _this.setState({
	                    userStats: userStats,
	                    showComponent: [1],
	                    showLoaderOnModel: false
	                  });
	                } else {
	                  _this.setState({
	                    change_status: true
	                  });
	                  (0, _toast.showFailure)('Something went wrong');
	                }
	
	              case 8:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x10) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context14.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context14.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context14.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context14.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context14.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee13$(_context13) {
	                      while (1) {
	                        switch (_context13.prev = _context13.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context13.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context13.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context13.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context13.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee11$(_context11) {
	                                  while (1) {
	                                    switch (_context11.prev = _context11.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context11.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context11.next = 7;
	                                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context11.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context11.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          questionType: 'essay_question',
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context11.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context11.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context11.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context11.stop();
	                                    }
	                                  }
	                                }, _callee11, _this2);
	                              }));
	
	                              return function (_x13) {
	                                return _ref13.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context13.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context13.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context13.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context13.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee12$(_context12) {
	                                  while (1) {
	                                    switch (_context12.prev = _context12.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context12.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context12.next = 6;
	                                        return _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context12.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context12.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          questionType: 'essay_question',
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context12.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context12.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context12.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context12.stop();
	                                    }
	                                  }
	                                }, _callee12, _this2);
	                              }));
	
	                              return function (_x14) {
	                                return _ref14.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context13.stop();
	                        }
	                      }
	                    }, _callee13, _this2);
	                  }));
	
	                  return function (_x12) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this2);
	      }));
	
	      return function (_x11) {
	        return _ref11.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      cases: [],
	      displayLoader: true,
	      subscriptionstatus: 'free',
	      premiumAlertStatus: false,
	      changeStatusTitle: '' + _language2.default.LC().Mark_this_Question_as_Completed,
	      change_status: false,
	      case_number: 0,
	      change_case_no: 0,
	      case_chapterId: 0,
	      chapterid: _this.props.params ? _this.props.params.chapterID : 1,
	      showFreePremium: true,
	      userType: '',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      selectedExam: 'cfa_3',
	      selectedmenu: 'cfa_3',
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      errorMessage: 'No data found!',
	      userStats: [],
	      // 1 -> for View
	      // 2 -> for Status
	      showComponent: [3],
	      showLoaderOnModel: true,
	      pdfLoading: true,
	      pdfLoadingAnswer: true
	    };
	    return _this;
	  }
	
	  _createClass(EssayCases, [{
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	        var storage_session, params, data;
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                params = this.props.params;
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapterId: params ? params.chapterID : 1
	                };
	
	                this.getCases(data);
	
	                this.getUserDetails(data);
	
	              case 6:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, this);
	      }));
	
	      function componentDidMount() {
	        return _ref15.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    //Function to redirect page on specific questions
	
	  }, {
	    key: 'togglePremiumAlert',
	    value: function togglePremiumAlert() {
	      this.setState({
	        premiumAlertStatus: !this.state.premiumAlertStatus
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var params = this.props.params,
	          _state = this.state,
	          displayLoader = _state.displayLoader,
	          cases = _state.cases,
	          subscriptionstatus = _state.subscriptionstatus,
	          premiumAlertStatus = _state.premiumAlertStatus,
	          errorMessage = _state.errorMessage,
	          userStats = _state.userStats,
	          showFreePremium = _state.showFreePremium,
	          showComponent = _state.showComponent,
	          showLoaderOnModel = _state.showLoaderOnModel;
	
	      var data = '';
	      if (cases.length) {
	        data = cases.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1,
	              '.'
	            ),
	            (0, _function.renderHTMLContent)(item.case_name, "td"),
	            _react2.default.createElement(
	              'td',
	              { className: 'd-flex' },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20 ' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: function onClick() {
	                    return _this3.getSummary(item);
	                  },
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  'View Summary'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: '' + _App_data2.default.frontend_url + (subscriptionstatus === 'free' && showFreePremium === true && item.free === false ? '/img/subsciption-dark.svg' : '/img/question_bank/open_book_icon.svg'),
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: function onClick() {
	                    return _this3._beginChapter(item, index);
	                  },
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  subscriptionstatus === 'free' && showFreePremium === true && item.free === false ? _language2.default.LC().UPGRADE_ACCOUNT : _language2.default.LC().BEGIN_CASES
	                )
	              )
	            ),
	            subscriptionstatus === 'free' && showFreePremium === true && item.free === false ? null : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  item.cfa3_essay_question_cases_statuses.length && item.cfa3_essay_question_cases_statuses[0].status === 1 ? _language2.default.LC().COMPLETED : _language2.default.LC().NOT_COMPLETED
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this3.toggleAlertChangeStatus.bind(_this3, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { colSpan: '100%', className: 'font-bold text-center', style: { fontWeight: 'bold' } },
	            errorMessage
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _Heading2.default,
	          { headerText: params ? params.chapterName : 'Essay Question Cases' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Q_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdfAnswer, className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right max-width-200' },
	                this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoadingAnswer ? _language2.default.LC().Download_QA_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: function onClick() {
	                  _this3.context.router.push({
	                    pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CHAPTERS
	                  });
	                }
	              },
	              'Change Topic'
	            )
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                'Case Studies - ',
	                params ? params.chapterName : ''
	              ),
	              displayLoader ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	                _Table2.default,
	                null,
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    { className: 'border_top_0' },
	                    _react2.default.createElement(
	                      'th',
	                      { width: '90' },
	                      '#'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      ' ',
	                      _language2.default.LC().CASE_NAME,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { className: 'action-heading' },
	                      _language2.default.LC().ACTION
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { className: 'status-heading' },
	                      _language2.default.LC().STATUS
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  data
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_StatusChangeModel2.default, {
	          change_status: this.state.change_status,
	          className: '',
	          changeModelStatus: this.changeModelStatus,
	          changeStatusTitle: this.state.changeStatusTitle,
	          markAsCompleted: this.state.markAsCompleted,
	          markNotCompleted: this.markNotCompleted,
	          markAsNotCompleted: this.state.markAsNotCompleted,
	          markCompleted: this.state.markCompleted,
	          markCompletedFun: this.markCompleted,
	          changeCompletionStatus: this.changeCompletionStatus,
	          summaryDetails: userStats,
	          showComponent: showComponent,
	          showLoaderOnModel: showLoaderOnModel
	        }),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: function goPremium() {
	            return _this3.context.router.push({
	              pathname: '/Subscribe/'
	            });
	          },
	          toggleAlert: this.togglePremiumAlert.bind(this),
	          alert_status: premiumAlertStatus,
	          MessageContent: _alertMessage2.default.messageContent_cfa_3,
	          exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: _language2.default.LC().PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return EssayCases;
	}(_react.Component);
	
	EssayCases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = EssayCases;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseCard(props) {
	  var chapterName = props.chapter_name,
	      chapter_no = props.chapter_no,
	      cfa3_essay_case = props.cfa3_essay_case,
	      cfa3_2025_essay_case = props.cfa3_2025_essay_case,
	      router = props.router,
	      chapterOrder = props.chapterOrder,
	      index = props.index;
	
	  var essayCases = cfa3_essay_case || cfa3_2025_essay_case;
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'question_bank_wrap pointer_class',
	        onClick: function onClick() {
	          chapter_no && chapterName && router.push({
	            pathname: _AppRoutes2.default.CFA3_ESSAY_QUESTION_CASES.replace(':chapterID', chapter_no).replace(':chapterName', chapterName)
	          });
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'margin_bottom_30' },
	        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg', width: '54', alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'question_title', value: '2' },
	        _react2.default.createElement(
	          'a',
	          { className: 'pointer_class', id: 'Behavioral Finance - Study Session 1' },
	          index + 1 + '. ' + chapterName
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	              width: '26',
	              alt: ''
	            })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            essayCases && essayCases.free_cases ? essayCases.free_cases : 0
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            'Free cases'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	              width: '23',
	              alt: ''
	            })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            essayCases && essayCases.premium_cases ? essayCases.premium_cases : 0
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            'Premium cases'
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = CaseCard;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DisplayLoader(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.displayLoader ? _react2.default.createElement(_loader2.default, null) : props.children
	  );
	}
	
	exports.default = DisplayLoader;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Table(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'table_responsive_wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'table-responsive' },
	      _react2.default.createElement(
	        'table',
	        { className: 'table_white_bg table case-study-heading-wrap' },
	        props.children
	      )
	    )
	  );
	}
	
	exports.default = Table;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _toast = __webpack_require__(15);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ViewCase(props) {
	  var getPreviousCase = props.getPreviousCase,
	      getNextCase = props.getNextCase,
	      case_name = props.case_name,
	      cases = props.cases,
	      disableNavigationButtons = props.disableNavigationButtons,
	      casesData = props.casesData,
	      caseIndex = props.caseIndex;
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'note-section note-section-new view_questionhtml' },
	        case_name ? _react2.default.createElement(
	          'div',
	          { className: 'card note-section-header px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header title-font-size' },
	            (0, _function.renderHTMLContent)(case_name, "span"),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ' + (parseInt(caseIndex, 10) !== 0 ? 'ques_arrow' : 'ques_arrow_disable') + ' pointer_class',
	                onClick: function onClick() {
	                  return !disableNavigationButtons ? getPreviousCase() : (0, _toast.showFailure)('Please select grading before proceeding to previous case');
	                }
	                // disabled={disableNavigationButtons}
	              }),
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ' + (parseInt(caseIndex, 10) + 1 !== casesData.length ? 'ques_arrow' : 'ques_arrow_disable') + ' pointer_class',
	                onClick: function onClick() {
	                  return !disableNavigationButtons ? getNextCase() : (0, _toast.showFailure)('Please select grading before proceeding to next case');
	                }
	                // disabled={disableNavigationButtons}
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block note_text_wrap mt-1 mb-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'px-2' },
	              (0, _function.renderHTMLContent)(cases, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })
	            )
	          )
	        ) : _react2.default.createElement(
	          'h4',
	          { className: 'card note-section-header text-center' },
	          'No case found'
	        )
	      )
	    )
	  );
	}
	
	exports.default = ViewCase;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ReverseTimer = __webpack_require__(670);
	
	var _ReverseTimer2 = _interopRequireDefault(_ReverseTimer);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ViewQuestions(props) {
	  var id = props.id,
	      _props$question = props.question,
	      question = _props$question === undefined ? '' : _props$question,
	      question_number = props.question_number,
	      is_multiple = props.is_multiple,
	      _props$development_ju = props.development_justification,
	      development_justification = _props$development_ju === undefined ? '' : _props$development_ju,
	      is_development = props.is_development,
	      timing = props.timing,
	      getPreviousQuestion = props.getPreviousQuestion,
	      getNextQuestion = props.getNextQuestion,
	      setJustification = props.setJustification,
	      setUserChoice = props.setUserChoice,
	      justification1 = props.justification1,
	      selectedIndex = props.selectedIndex,
	      displayError = props.displayError,
	      stopTimer = props.stopTimer,
	      disableNavigationButtons = props.disableNavigationButtons,
	      caseQuestions = props.caseQuestions,
	      questionIndex = props.questionIndex,
	      attemptedQuestions = props.attemptedQuestions,
	      errorMessageOnValidate = props.errorMessageOnValidate,
	      multiple_answer = props.multiple_answer,
	      selectedChoice = props.selectedChoice,
	      showResult = props.showResult,
	      _getResult = props._getResult,
	      _saveQuestion = props._saveQuestion,
	      _displayReportForm = props._displayReportForm,
	      bookmarkCSS = props.bookmarkCSS,
	      bookmarkColor = props.bookmarkColor,
	      questionData = props.questionData;
	
	  var choices = [];
	  for (var objKey in props) {
	    if (objKey.includes('choice')) if (props[objKey]) choices.push(props[objKey]);
	  }return _react2.default.createElement(
	    'div',
	    { className: 'note-section note-section-new' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card view_questionhtml' },
	      question ? _react2.default.createElement(
	        'div',
	        { className: 'font-lusitana' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header' },
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	            className: 'margin_right_20',
	            width: '30',
	            alt: ''
	          }),
	          'Question ',
	          question_number,
	          ' -',
	          ' ',
	          _react2.default.createElement(
	            'div',
	            { className: 'float-right text-right' },
	            _react2.default.createElement('i', {
	              // disabled={
	              //   caseQuestions?.length === parseInt(questionIndex) -1 ? true:false
	              // }
	              className: 'fa fa-angle-left ' + (parseInt(questionIndex, 10) !== 0 ? 'ques_arrow' : 'ques_arrow_disable') + ' pointer_class',
	              onClick: function onClick() {
	                return (
	                  // !disableNavigationButtons
	                  // ?
	                  getPreviousQuestion()
	                );
	              }
	              // : showFailure(
	              // 'Please select grading before proceeding to previous question'
	              // )
	
	            }),
	            _react2.default.createElement('i', {
	              className: 'fa fa-angle-right ' + (!attemptedQuestions.length || attemptedQuestions.length !== caseQuestions.length ? caseQuestions.length !== parseInt(questionIndex, 10) + 1 ? 'ques_arrow' : 'ques_arrow_disable' : caseQuestions.length + 1 === attemptedQuestions.length + 1 ? 'ques_arrow' : 'ques_arrow_disable') + ' pointer_class ',
	              onClick: function onClick() {
	                return !disableNavigationButtons ? getNextQuestion() : (0, _toast.showFailure)('Please select grading before proceeding to next question');
	              }
	              // disabled={disableNavigationButtons}
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { xs: '12', sm: '12', lg: '9' },
	              (0, _function.renderHTMLContent)(question, "div", "text-justify view_questionhtml margin_bottom_20"),
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                development_justification.includes('&;') ? _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'border-gray rounded p-1', md: '12', xs: '12', sm: '12' },
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    development_justification.split('&;')[0].split(':')[0],
	                    ' :'
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    className: 'border-0 w-50 view_questionhtml',
	                    placeholder: 'Please write your answer'
	                  })
	                ) : null,
	                choices.length || development_justification.includes('&;') ? _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: '12', md: development_justification.includes('&;') ? '12' : '3' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: (development_justification.includes('&;') ? 'justify-content-around' : 'flex-column') + '  d-flex border ' + (is_multiple ? 'border-gray rounded mb-sm-1 mb-md-0 question_sidebar' : '') + ' '
	                    },
	                    choices.map(function (choice, index) {
	                      return _react2.default.createElement(
	                        'div',
	                        {
	                          key: index,
	                          className: 'd-flex align-items-center pointer_class sidebar_item ' + (is_multiple ? 'border-0' : 'border-gray rounded') + ' ' + (selectedIndex === index ? 'clicked_box' : '') + ' ' + (showResult && selectedChoice === choice && selectedChoice !== multiple_answer ? 'failure text-white' : '') + ' ' + (showResult && choice === multiple_answer ? 'success text-white' : ''),
	                          name: 'selectedChoice',
	                          onClick: function onClick() {
	                            return !showResult && setUserChoice(choice, index);
	                          }
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          choice
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  {
	                    xs: '12',
	                    md: development_justification.includes('&;') || is_development && !choices.length ? '12' : '9 pl-md-0',
	                    className: (development_justification.includes('&;') || is_development && !choices.length ? '' : '') + ' '
	                  },
	                  is_development ? is_multiple ? _react2.default.createElement('textarea', {
	                    className: 'w-100 h-100 view_questionhtml',
	                    placeholder: 'Write your justification here',
	                    onChange: function onChange(event) {
	                      setJustification(event);
	                    },
	                    value: justification1,
	                    name: 'justification1'
	                  }) : choices.length ? choices.map(function (choice, index) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'h-100p' },
	                      _react2.default.createElement('textarea', {
	                        placeholder: 'Write your justification here',
	                        className: 'w-100 h-100 min-height-150 view_questionhtml',
	                        onChange: function onChange(event) {
	                          setJustification(event);
	                        },
	                        value: props['justification' + (index + 1)],
	                        name: ['justification' + (index + 1)]
	                      })
	                    );
	                  }) : _react2.default.createElement('textarea', {
	                    className: 'w-100 h-100 min-height-150 view_questionhtml',
	                    placeholder: 'Write your justification here',
	                    onChange: function onChange(event) {
	                      setJustification(event);
	                    },
	                    value: justification1,
	                    name: 'justification1'
	                  }) : null
	                )
	              ),
	              displayError ? _react2.default.createElement(
	                'h6',
	                { className: 'text-danger mt-1 mb-0' },
	                errorMessageOnValidate
	              ) : null,
	              questionData && questionData.question && _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { md: '12', sm: '12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row note-section-new align-items-center mt-2' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      all_questions: questionIndex,
	                      isQue: true,
	                      _getResult: _getResult,
	                      _saveQuestion: _saveQuestion,
	                      _displayReportForm: _displayReportForm,
	                      save_text: _language2.default.LC().SAVE_QUESTION,
	                      bookmarkCSS: bookmarkCSS,
	                      bookmarkColor: bookmarkColor,
	                      className: 'p-0',
	                      showResult: showResult
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Col,
	              {
	                lg: '3',
	                sm: '12',
	                xs: '12',
	                className: 'd-flex flex-column justify-content-around mt-2'
	              },
	              _react2.default.createElement(_ReverseTimer2.default, { seconds: timing, key: id, stopTimer: stopTimer })
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'h4',
	        { className: 'text-center p-2' },
	        'No Question found'
	      )
	    )
	  );
	}
	
	exports.default = ViewQuestions;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReverseTimer = function (_Component) {
	  _inherits(ReverseTimer, _Component);
	
	  function ReverseTimer(props) {
	    _classCallCheck(this, ReverseTimer);
	
	    var _this = _possibleConstructorReturn(this, (ReverseTimer.__proto__ || Object.getPrototypeOf(ReverseTimer)).call(this, props));
	
	    _this.mounted = false;
	
	    _this.stopTimer = function () {
	      var timerStart = _this.state.timerStart;
	
	      if (_this.mounted) if (timerStart === true) {
	        _this.setState({
	          timerStart: false
	        });
	        clearInterval(_this.timer);
	      } else {
	        _this.setState({
	          timerStart: true
	        });
	        _this.timer = setInterval(_this.countDown, 1000);
	      }
	    };
	
	    _this.countDown = function () {
	      if (_this.mounted) if (_this.state.seconds > 0) _this.setState({
	        seconds: _this.state.seconds - 1
	      });else clearInterval(_this.timer);
	    };
	
	    _this.state = {
	      timerStart: true,
	      seconds: props.seconds ? props.seconds : 150
	    };
	    _this.timer = 0;
	    return _this;
	  }
	
	  _createClass(ReverseTimer, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.timer = setInterval(this.countDown, 1000);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prev) {
	      if (prev.stopTimer !== this.props.stopTimer) {
	        this.stopTimer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          timerStart = _state.timerStart,
	          seconds = _state.seconds;
	
	      var currentTime = (0, _constant.SecondsToMMSS)(seconds);
	      var stopTimer = this.props.stopTimer;
	      // console.log('stopTimer=====>', stopTimer);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'timer_outer h-min-content py-1' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Estimated Time Left'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'timer_box ' + (seconds <= 10 ? 'blink text-danger' : '') },
	              currentTime
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'tooltip_wrap hover-pad-same\n                          ' + (timerStart ? 'icon-control-pause pause_btn' : 'pause_btn icon-control-play'),
	            disabled: stopTimer,
	            onClick: function onClick() {
	              return _this2.stopTimer();
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'tootip_box' },
	            'Save and Take a break'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReverseTimer;
	}(_react.Component);
	
	exports.default = ReverseTimer;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _function = __webpack_require__(10);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	
	var Cfa3QuestionBank = function (_Component) {
	  _inherits(Cfa3QuestionBank, _Component);
	
	  function Cfa3QuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa3QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3QuestionBank.__proto__ || Object.getPrototypeOf(Cfa3QuestionBank)).call(this, props));
	
	    _this.toggle = function () {
	      _this.setState({ dropdownOpen: !_this.state.dropdownOpen });
	    };
	
	    _this._getCases = function (chapter, e) {
	      _this.context.router.push({
	        pathname: '/cfa3/cases/' + chapter.id + '/' + chapter.chapter_name + '/' + chapter.total_cases,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: chapter
	        }
	      });
	    };
	
	    _this.redirectToQuestion = function () {
	      var _this$state = _this.state,
	          lastRecord = _this$state.lastRecord,
	          hasAnyLastAttemptedQuestion = _this$state.hasAnyLastAttemptedQuestion;
	
	      var questionTableKey = 'cfa3_question';
	      if (hasAnyLastAttemptedQuestion) {
	        if (Object.keys(lastRecord.cfa3_2025_question || {}).length !== 0) {
	          questionTableKey = 'cfa3_2025_question';
	        }
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + lastRecord[questionTableKey].chapter_id + '/' + lastRecord[questionTableKey].case_id + '/' + lastRecord.caseIndex + '/' + lastRecord[questionTableKey].question_number + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            reading: lastRecord[questionTableKey],
	            chapter: lastRecord[questionTableKey].chapter_id,
	            offset: 0
	          }
	        });
	      }
	    };
	
	    _this.getAdditionalResources = function (type) {
	      var _this$state2 = _this.state,
	          token = _this$state2.token,
	          idname = _this$state2.idname;
	
	      var typeNames = {
	        FS: 'Formula sheet',
	        ES: 'Essential summary',
	        RS: 'Ratio sheet'
	      };
	      var typeName = typeNames[type];
	      var data = {
	        token: token,
	        idname: idname,
	        type: typeName,
	        exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2023question_bank/getAdditionalResources', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          (0, _function.openPDF)(resp);
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.checkSubscription = function (type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var selectedExams = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: selectedExams
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(exam) {
	                var success, examData, exam_data, selectedmen, isSubscribed, examPlanData;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        success = exam.success, examData = exam.examData;
	
	                        if (!success) {
	                          _context.next = 10;
	                          break;
	                        }
	
	                        exam_data = examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isSubscribed = false;
	                        examPlanData = exam.examPlan[0];
	                        _context.next = 8;
	                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 8:
	                        isSubscribed = _context.sent;
	
	                        if (isSubscribed) {
	                          _this.getAdditionalResources(type);
	                        } else {
	                          _this.toggleAlert();
	                        }
	
	                      case 10:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            var _subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: _subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var _selectedExams = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var _dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: _selectedExams
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isSubscribed = false;
	
	                isSubscribed = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isSubscribed) {
	                  _this.getAdditionalResources(type);
	                } else {
	                  _this.toggleAlert();
	                }
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      lastRecord: '',
	      hasAnyLastAttemptedQuestion: false,
	      dropdownOpen: false,
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      selectedmenu: 'cfa_3'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Cfa3QuestionBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ alert_status: !this.state.alert_status });
	    }
	
	    // eslint-disable-next-line id-length, no-unused-vars
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      if (localStorage.getItem('selectedmenu') === 'frm') {
	        this.context.router.push({
	          pathname: '/frm/questionbank/',
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname']
	          }
	        });
	      }
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChapters', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          var success, chapters;
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  success = resp.success, chapters = resp.chapters;
	
	                  if (!success) {
	                    _context2.next = 7;
	                    break;
	                  }
	
	                  _this3.setState({ chapters: chapters });
	                  _context2.next = 5;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecord: response.data,
	                        hasAnyLastAttemptedQuestion: true
	                      });
	                    }
	                  });
	
	                case 5:
	                  _context2.next = 8;
	                  break;
	
	                case 7:
	                  _this3.setState({ ValidToken: false });
	
	                case 8:
	                  return _context2.abrupt('return', resp);
	
	                case 9:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters = this.state.chapters;
	      var hasAnyLastAttemptedQuestion = this.state.hasAnyLastAttemptedQuestion;
	
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          if (item.total_cases !== 0) {
	            return _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: index
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id
	                  // eslint-disable-next-line no-underscore-dangle
	                  , onClick: _this4._getCases.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    width: '54',
	                    className: '',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'pointer_class', id: item.chapter_name, value: item.chapter_no },
	                    index + 1,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.free_cases
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().FREE_CASES,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.total_cases
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().PREMIUM_CASES,
	                      ' '
	                    )
	                  )
	                )
	              )
	            );
	          }
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().CFA_LEVEL_III_QUESTION_BANK
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.CFA_3 }),
	          _react2.default.createElement(
	            'div',
	            null,
	            hasAnyLastAttemptedQuestion && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.redirectToQuestion,
	                disabled: !hasAnyLastAttemptedQuestion
	              },
	              _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa3QuestionBank;
	}(_react.Component);
	
	Cfa3QuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = Cfa3QuestionBank;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa3Quizzes = function (_Component) {
	  _inherits(Cfa3Quizzes, _Component);
	
	  function Cfa3Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa3Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3Quizzes.__proto__ || Object.getPrototypeOf(Cfa3Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot === dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i === dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    console.log('Some Thing Went Wrong');
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      // console.log('_all_Checked')
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      //console.log(this.state.all_checked_state);
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	      //console.log(single_clicked_value);
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this.prioritySelected = function (e) {
	      _this.setState({ quizPriorityLevel: e.target.value });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      // console.log('deleteQuizzes', items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                // console.log('calllinggg!!!!');
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 4;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: '',
	      all_checked_state: true,
	      radio_checked_question: 0,
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      caseId: [],
	      caseQuestion: [],
	      caseQuestionNextval: [],
	      display_loader: 'show_block',
	      quizPriorityLevel: 'none',
	      deleteItemId: '',
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _messages.messages.QUIZ_PRIORITY,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().UNANSWERED_QUIZ_SELECTED,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Cfa3Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChapters', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ ValidToken: true });
	          _this3.setState({ chapters: resp.chapters });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	      this.abandonedQuizzes(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        //console.log(resp_quiz_length.quiz_length);
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          console.log('Some Thing Went Wrong');
	        }
	      });
	    }
	  }, {
	    key: '_createQuiz',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this4 = this;
	
	        var question_length_val, timer_value, selectedChapter, caselength, checkboxes, i, single_clicked_value, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.setState({ display_loader: 'show_block' });
	                this.setState({ caseId: [] });
	                this.setState({ caseQuestion: [] });
	                question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                caselength = '';
	
	                timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	
	                console.log('===================> chapters', this.state.chapters);
	                if (this.state.all_checked_state) {
	                  selectedChapter = this.state.chapters.map(function (val) {
	                    return val.id;
	                  });
	                } else {
	                  checkboxes = document.getElementsByName('approve[]');
	                  i = 0;
	                  single_clicked_value = [];
	
	                  if (this.state.single_clicked_val !== '') {
	                    for (i = 0; i < checkboxes.length; i++) {
	                      if (checkboxes[i].checked) {
	                        single_clicked_value.push(checkboxes[i].value);
	                      }
	                    }
	                    selectedChapter = single_clicked_value;
	                  }
	
	                  //console.log(checkboxes);
	                }
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  selectedChapter: selectedChapter,
	                  priority: this.state.quizPriorityLevel,
	                  questionquize: caselength
	                };
	                //console.log(selectedChapter);
	
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getRandomCases', data).then(function (resp) {
	                  if (resp.success) {
	                    var allCasesid_arr;
	                    var i;
	                    var allCasesid;
	                    var j;
	                    var dataparam;
	                    var k;
	
	                    var _ret = function () {
	                      var getRandomValues = function getRandomValues(arr, count) {
	                        var result = [];
	                        var _tmp = arr.slice();
	                        for (var i = 0; i < count; i++) {
	                          var index = (0, _function.generateRandomInteger)(1, 10) % _tmp.length;
	                          result.push(_tmp.splice(index, 1)[0]);
	                        }
	                        return result;
	                      };
	
	                      allCasesid_arr = [];
	
	
	                      for (i = 0; i < resp.chaptersWiseCases.length; i++) {
	                        allCasesid_arr.push(resp.chaptersWiseCases[i].id);
	                      }
	                      console.log('allCasesid_arr.length --> ', resp.chaptersWiseCases.length, question_length_val / 6, '=>', resp.chaptersWiseCases.length < question_length_val / 6);
	                      if (resp.chaptersWiseCases.length < question_length_val / 6) {
	                        console.log('allCasesid_arr.length < caselength', allCasesid_arr.length < caselength);
	                        (0, _toast.showFailure)(_language2.default.LC().CFA2_2025_QUIZ_ERROR);
	                        _this4.setState({ display_loader: 'hide_block' });
	                        return {
	                          v: void 0
	                        };
	                      }
	                      console.log(question_length_val / 6);
	                      allCasesid = getRandomValues(allCasesid_arr, question_length_val / 6);
	
	
	                      _this4.setState({ caseId: [] });
	                      _this4.setState({ caseQuestion: [] });
	                      var chaptersWiseCasesQuestionCount = 0;
	                      for (j = 0; j < allCasesid.length; j++) {
	                        dataparam = {
	                          token: _this4.state.token,
	                          idname: _this4.state.idname,
	                          casesId: allCasesid[j]
	                        };
	                        k = 0;
	
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/getCasesquearraybyId', dataparam).then(function (respquestion) {
	                          var qid = {};
	                          var questionCount = respquestion.chapterswisecases && respquestion.chapterswisecases.length > 0 ? respquestion.chapterswisecases.length : 0;
	                          chaptersWiseCasesQuestionCount += questionCount;
	
	                          for (var l = 0; l < respquestion.chapterswisecases.length; l++) {
	                            qid[l] = respquestion.chapterswisecases[l].id;
	                          }
	                          var caseIdjoined = _this4.state.caseId.concat(respquestion.caseId);
	                          var questionJoined = '';
	                          questionJoined = _this4.state.caseQuestion.concat(qid);
	
	                          _this4.setState({ caseQuestion: questionJoined, caseId: caseIdjoined }, function () {
	                            var _this5 = this;
	
	                            if (k === allCasesid.length - 1) {
	                              var _state = this.state,
	                                  caseId = _state.caseId,
	                                  caseQuestion = _state.caseQuestion,
	                                  idname = _state.idname,
	                                  token = _state.token;
	
	                              var casesId = caseId; // This should be an array like [17,49,89]
	                              var questionStats = JSON.stringify(caseQuestion);
	
	                              var allCasesLength = question_length_val / _constant.DIVISOR_FOR_CASES;
	                              if (allCasesLength !== casesId.length) {
	                                (0, _toast.showInformation)(_messages.messages.NON_ATTEMPTED_QUIZ);
	                                this.setState({ display_loader: 'hide_block' });
	                                return;
	                              }
	
	                              var data = {
	                                token: token,
	                                idname: idname,
	                                number_questions: chaptersWiseCasesQuestionCount,
	                                // number_questions: question_length_val, // it makes incorrect questions count
	                                case_id: JSON.stringify(casesId),
	                                questions: questionStats,
	                                timer_value: timer_value
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3quizes/createQuiz', data).then(function (resp) {
	                                if (resp.success) {
	                                  _this5.context.router.push({
	                                    pathname: '/cfa3/beforestart/' + resp.last_id + '/',
	                                    state: {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      quiz_id: resp.last_id,
	                                      status_send: ''
	                                    }
	                                  });
	                                } else {
	                                  console.log(resp.success);
	                                }
	                              });
	                            }
	                          });
	                          k++;
	                        });
	                      }
	                    }();
	
	                    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                  } else {
	                    (0, _toast.showInformation)(_messages.messages.CASES_NOT_AVAILABLE);
	                    _this4.setState({ display_loader: 'hide_block' });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function _createQuiz() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return _createQuiz;
	    }()
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: '/cfa3/beforestart/' + items.id + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon'
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: '/cfa3/beforestart/' + items.id + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed'
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          tooltips = _state2.tooltips,
	          quizPriorityLevel = _state2.quizPriorityLevel,
	          chapters = _state2.chapters;
	
	      var chapters_all = chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.id,
	                onClick: _this6._single_Checked.bind(_this6)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this6._checkAbondon.bind(_this6, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this6.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colspan: '4', align: 'center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this6._checkCompleted.bind(_this6, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = (0, _function.renderHTMLContent)('<td colspan="4" className="" align="center">No Data Found</td>', "tr", "", { contentEditable: "false" });
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            _react2.default.createElement(
	              'span',
	              null,
	              items.quiz_length / 6
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _language2.default.LC().CASES
	            ),
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this6.state.radio_checked_question === index,
	              onClick: _this6._length_Checked.bind(_this6, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().CFA_LEVEL_III_QUIZZES
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary pointer_class', onClick: this._createQuiz.bind(this) },
	            _language2.default.LC().CREATE_QUIZ
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-7' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CONTENT,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'check_container margin_bottom_0' },
	                    _language2.default.LC().ALL_CHAPTERS,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'all_Checked',
	                      name: 'all_checked',
	                      value: 'select',
	                      onClick: this._all_Checked.bind(this),
	                      checked: this.state.all_checked_state
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block padding_15' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  chapter_data
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().ABANDONED_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '1',
	                    id: '1',
	                    content: this.state.tooltips[1].placement,
	                    place_tip: this.state.tooltips[1].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      abandoned_data
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _messages.messages.FILTER_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '3',
	                    id: '3',
	                    content: tooltips[3].placement,
	                    place_tip: tooltips[3].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'radio_container' },
	                  ' ',
	                  _messages.messages.NONE,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'none',
	                    name: 'none',
	                    value: 'none',
	                    checked: quizPriorityLevel === 'none',
	                    onClick: this.prioritySelected
	                  }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'radio_container' },
	                  _messages.messages.NON_ATTEMPTED_CASES,
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'mark_unanswered',
	                    name: 'mark_unanswered',
	                    value: 'unanswered',
	                    checked: quizPriorityLevel === 'unanswered',
	                    onClick: this.prioritySelected
	                  }),
	                  _react2.default.createElement('span', { className: 'checkmark' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '4',
	                    id: '4',
	                    content: tooltips[4].placement,
	                    place_tip: tooltips[4].text_align
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().LENGTH,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '0',
	                    id: '0',
	                    content: this.state.tooltips[0].placement,
	                    place_tip: this.state.tooltips[0].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                quiz_length_state_data
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().COMPLETED_QUIZZES,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions card_action_tooltip float-right' },
	                  _react2.default.createElement(TooltipItem, {
	                    key: '2',
	                    id: '2',
	                    content: this.state.tooltips[2].placement,
	                    place_tip: this.state.tooltips[2].text_align
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      getallcompleteQuiz_data
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa3Quizzes;
	}(_react.Component);
	
	Cfa3Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this7 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this7.toggle = _this7.toggle.bind(_this7);
	    _this7.state = {
	      tooltipOpen: false
	    };
	    return _this7;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	exports.default = Cfa3Quizzes;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Cfa3cases = function (_Component) {
	  _inherits(Cfa3cases, _Component);
	
	  function Cfa3cases(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa3cases);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3cases.__proto__ || Object.getPrototypeOf(Cfa3cases)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/cfa3/questionBank/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.togglePremiumAlert = function () {
	      _this.setState({
	        premiumAlertStatus: !_this.state.premiumAlertStatus
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var subscriptionstatus = _this.state.subscriptionstatus;
	
	      if (subscriptionstatus === 'free' && reading.free == 0) {
	        _this.togglePremiumAlert();
	      } else {
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          case_id: reading.id,
	          chapter_id: _this.state.chapterid,
	          offset: parseInt(reading.case_number) - 1,
	          limit: 1
	        };
	        console.log('data', reading, '===>', e);
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.state.chapterid + '/' + reading.id + '/' + reading.index + '/1' + '/' + 0
	          // state: {
	          //   token: this.state.token,
	          //   idname: this.state.idname,
	          //   reading: reading,
	          //   chapter: this.props.location.state.chapter,
	          //   offset: 0,
	          // },
	        });
	      }
	    };
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                console.log('inside functionnn');
	
	                if (!(_this.state.pdfLoading == false)) {
	                  _context4.next = 4;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context4.abrupt('return');
	
	              case 4:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context4.next = 7;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context4.abrupt('return');
	
	              case 7:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context4.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context.next = 7;
	                                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context3.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context3.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context3.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        // console.log('isInArray_var_PDF before', isInArray_var_PDF);
	
	                                        _context2.next = 6;
	                                        return _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 23:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context8.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context8.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context8.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context8.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context8.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context7.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context7.next = 5;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context7.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context7.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context5.next = 7;
	                                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                      case 7:
	                                        isInArray_var_PDF = _context5.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context5.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context5.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context5.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.togglePremiumAlert();
	
	                                      case 16:
	                                        _context5.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x7) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context7.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context7.next = 17;
	                              break;
	                            }
	
	                            _this.togglePremiumAlert();
	                            _context7.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context7.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context6.next = 6;
	                                        return _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context6.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.togglePremiumAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.id,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      selectedmenu: 'cfa_3',
	      subscriptionstatus: '',
	      change_status: false,
	      change_case_no: '',
	      change_completion_status: '',
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      premiumAlertStatus: false,
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFDownloadType: 'Question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggleAlertChangeStatus = _this.toggleAlertChangeStatus.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa3cases, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    //it is use to redirect page
	
	  }, {
	    key: 'toggleAlertChangeStatus',
	    value: function toggleAlertChangeStatus(item, index) {
	      // console.log(item)
	      // console.log(index)
	      {
	        item.completionStatus === 1 ? this.setState({
	          change_status: !this.state.change_status,
	          change_case_no: item.case_number,
	          change_completion_status: item.completionStatus,
	          markAsCompleted: true,
	          markAsNotCompleted: false
	        }) : this.setState({
	          change_status: !this.state.change_status,
	          change_case_no: item.case_number,
	          change_completion_status: item.completionStatus,
	          markAsNotCompleted: true,
	          markAsCompleted: false
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      // console.log('markCompleted')
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      // console.log('markNotCompleted')
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      if (this.state.markAsCompleted === true) {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.change_case_no,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.selectedmenu,
	          chapter_id: this.state.chapterid
	        };
	        // console.log(data)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.message)
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              chapter_id: _this3.state.chapterid,
	              subscriptionstatus: _this3.state.subscriptionstatus
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasessubs', data).then(function (resp) {
	              if (resp.success) {
	                _this3.setState({ ValidToken: true });
	                _this3.setState({ readings: resp.readings, change_status: false });
	                if (!resp.readings.length) {
	                  _this3.setState({ no_result_display: 'No Saved Questions' });
	                }
	              } else {
	                _this3.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      } else {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.change_case_no,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.selectedmenu,
	          chapter_id: this.state.chapterid
	        };
	        // console.log(data)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.message)
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              chapter_id: _this3.state.chapterid,
	              subscriptionstatus: _this3.state.subscriptionstatus
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasessubs', data).then(function (resp) {
	              // console.log(resp);
	              if (resp.success) {
	                _this3.setState({ ValidToken: true });
	                _this3.setState({ readings: resp.readings, change_status: false });
	                if (!resp.readings.length) {
	                  _this3.setState({ no_result_display: 'No Saved Questions' });
	                }
	              } else {
	                _this3.setState({ ValidToken: false });
	              }
	              return resp;
	            });
	          }
	        });
	      }
	    }
	
	    //Function to redirect page to question bank page
	
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      if (localStorage.getItem('selectedmenu') === 'frm') {
	        this.context.router.push({
	          pathname: '/frm/questionbank/',
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname']
	          }
	        });
	      }
	
	      // var final_exam=[];
	      var user_data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
	      _userStore2.default.getUserProfile(true).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this4._runCode('free');
	            _this4.setState({ subscriptionstatus: 'free' });
	          } else {
	            _this4.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                  while (1) {
	                    switch (_context9.prev = _context9.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context9.next = 11;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this4.state.selectedmenu;
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context9.next = 7;
	                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isInArray_var = _context9.sent;
	
	                        if (isInArray_var) {
	                          _this4._runCode('paid');
	                          _this4.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this4._runCode('free');
	                          _this4.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context9.next = 12;
	                        break;
	
	                      case 11:
	                        console.log('fail');
	
	                      case 12:
	                      case 'end':
	                        return _context9.stop();
	                    }
	                  }
	                }, _callee9, _this4);
	              }));
	
	              return function (_x9) {
	                return _ref9.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this4._runCode('free');
	            _this4.setState({ subscriptionstatus: 'free' });
	          } else {
	            _this4.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this4.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this4._runCode('paid');
	                  _this4.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this4._runCode('free');
	                  _this4.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      // console.log('_runCode')
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        chapter_id: this.state.chapterid,
	        subscriptionstatus: subscriptionstatus
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasessubs', data).then(function (resp) {
	        // console.log(resp)
	        if (resp.success) {
	          _this5.setState({ ValidToken: true });
	          _this5.setState({ readings: resp.readings });
	        } else {
	          _this5.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	    /*
	    --------------------------------
	    PDF DOWNLOAD Via email Answer
	    --------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	      var _state = this.state,
	          subscriptionstatus = _state.subscriptionstatus,
	          premiumAlertStatus = _state.premiumAlertStatus;
	
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              /*item.case_number*/index + 1,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.case_name
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              subscriptionstatus === 'free' && item.free == 0 ? _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/subsciption-dark.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().UPGRADE_ACCOUNT
	                )
	              ) : _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                console.log('checking case index', index),
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, Object.assign({}, item, {
	                    index: index
	                  })),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CASES
	                )
	              )
	            ),
	            subscriptionstatus === 'free' && item.free == 0 ? null : readings[index].completionStatus == null || readings[index].completionStatus === false || readings[index].completionStatus === 0 ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  ' ',
	                  _language2.default.LC().NOT_COMPLETED
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this6.toggleAlertChangeStatus.bind(_this6, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'complete-or-not' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'complete-or-not-text' },
	                  _language2.default.LC().COMPLETED,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip_wrap left-tool-tip' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/edit-icon.svg',
	                    className: 'pointer_class',
	                    alt: '',
	                    width: '15',
	                    id: item.id,
	                    onClick: _this6.toggleAlertChangeStatus.bind(_this6, item, index),
	                    title: ''
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHANGE_STATUS,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.chapter_name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Q_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: this.getpdfAnswer.bind(this),
	                className: 'status-download-btn margin_right_10'
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right max-width-200' },
	                this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoadingAnswer ? _language2.default.LC().Download_QA_Cases : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CASE_STUDIES,
	                ' - ',
	                this.props.params.chapter_name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table case-study-heading-wrap' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          ' ',
	                          _language2.default.LC().CASE_NAME,
	                          ' '
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'action-heading' },
	                          _language2.default.LC().ACTION
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'status-heading' },
	                          _language2.default.LC().STATUS
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex flex-column' },
	              _react2.default.createElement(
	                'div',
	                null,
	                ' ',
	                this.state.MessageContent
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-right' },
	                ' ',
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { color: 'primary', onClick: this.toggleAlert },
	                  ' ',
	                  _language2.default.LC().OK,
	                  ' '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.change_status,
	            toggle: this.toggleAlertChangeStatus,
	            className: 'modal-primary complete-or-not-model ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlertChangeStatus },
	            this.state.changeStatusTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block card-padding' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue_status'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.togglePremiumAlert.bind(this),
	          alert_status: premiumAlertStatus,
	          MessageContent: _alertMessage2.default.messageContent_cfa_3,
	          exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Cfa3cases;
	}(_react.Component);
	
	Cfa3cases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa3cases;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	
	// import GD from '../RestAPI/getData';
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfa3chapter = function (_Component) {
	  _inherits(Cfa3chapter, _Component);
	
	  function Cfa3chapter(props) {
	    _classCallCheck(this, Cfa3chapter);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3chapter.__proto__ || Object.getPrototypeOf(Cfa3chapter)).call(this, props));
	
	    _this.timerFunction = function (item, e) {
	      if (_this.state.timer_stop) {
	        _this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause'
	        }, function () {
	          if (_this.timer) {
	            clearInterval(_this.timer);
	          }
	          _this.timer = setInterval(_this._tick.bind(_this), 1000);
	        });
	      } else {
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	      }
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/cfa3/cases/' + _this.state.chapters.id + '/' + _this.state.chapters.chapter_name + '/' + _this.state.chapters.total_cases,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.state.chapters
	        }
	      });
	    };
	
	    _this._getAnswer = function (choice, e) {
	      var currentQuestionId = _this.state.questions.id;
	      var selectedChoice = choice[0];
	
	      _this.setState({
	        selectedChoice: selectedChoice,
	        setAnswer: true,
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false,
	        choice_a: selectedChoice === 'choice_a' ? 'answer_box clicked_box' : 'answer_box',
	        choice_b: selectedChoice === 'choice_b' ? 'answer_box clicked_box' : 'answer_box',
	        choice_c: selectedChoice === 'choice_c' ? 'answer_box clicked_box' : 'answer_box',
	        choice_d: selectedChoice === 'choice_d' ? 'answer_box clicked_box' : 'answer_box',
	        choice_e: selectedChoice === 'choice_e' ? 'answer_box clicked_box' : 'answer_box'
	      }, function () {
	        var currentAttempts = _this.state.attemptedQuestions || {};
	        var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	          selectedChoice: _this.state.selectedChoice,
	          isAnswered: false,
	          setAnswer: true
	        }));
	
	        _this.setState({ attemptedQuestions: updatedAttempts });
	      });
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._getResult = function (item, e) {
	      if (_this.state.selectedChoice) {
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	
	        var currentQuestionId = item.id;
	
	        var correctChoiceKey = item['answer'];
	        var isCorrect = _this.state.selectedChoice === 'choice_' + correctChoiceKey;
	
	        var timeDone = item["cfa3_question_stats.time_done"] || _this.state.count;
	
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play',
	          setAnswer: true,
	          clicked: true,
	          showAnswer: true,
	          stopTimer: true,
	          result_block: 'card show_block',
	          result: isCorrect ? 'CORRECT' : 'INCORRECT',
	          text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
	        }, function () {
	          var currentAttempts = _this.state.attemptedQuestions || {};
	          var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	            selectedChoice: _this.state.selectedChoice,
	            isAnswered: true,
	            isCorrect: isCorrect,
	            setAnswer: true,
	            timeSpent: timeDone
	          }));
	
	          _this.setState({ attemptedQuestions: updatedAttempts });
	
	          if (isCorrect) {
	            if (_this.state.selectedChoice === 'choice_a') {
	              _this.setState({ choice_a: 'answer_box success' });
	            } else if (_this.state.selectedChoice === 'choice_b') {
	              _this.setState({ choice_b: 'answer_box success' });
	            } else if (_this.state.selectedChoice === 'choice_c') {
	              _this.setState({ choice_c: 'answer_box success' });
	            } else if (_this.state.selectedChoice === 'choice_d') {
	              _this.setState({ choice_d: 'answer_box success' });
	            } else if (_this.state.selectedChoice === 'choice_e') {
	              _this.setState({ choice_e: 'answer_box success' });
	            }
	          } else {
	            if (_this.state.selectedChoice === 'choice_a') {
	              _this.setState({ choice_a: 'answer_box failure' });
	            } else if (_this.state.selectedChoice === 'choice_b') {
	              _this.setState({ choice_b: 'answer_box failure' });
	            } else if (_this.state.selectedChoice === 'choice_c') {
	              _this.setState({ choice_c: 'answer_box failure' });
	            } else if (_this.state.selectedChoice === 'choice_d') {
	              _this.setState({ choice_d: 'answer_box failure' });
	            } else if (_this.state.selectedChoice === 'choice_e') {
	              _this.setState({ choice_e: 'answer_box failure' });
	            }
	
	            if (item.right_choice === 'choice_a') {
	              _this.setState({ choice_a: 'answer_box success' });
	            } else if (item.right_choice === 'choice_b') {
	              _this.setState({ choice_b: 'answer_box success' });
	            } else if (item.right_choice === 'choice_c') {
	              _this.setState({ choice_c: 'answer_box success' });
	            } else if (item.right_choice === 'choice_d') {
	              _this.setState({ choice_d: 'answer_box success' });
	            } else if (item.right_choice === 'choice_e') {
	              _this.setState({ choice_e: 'answer_box success' });
	            }
	          }
	        });
	
	        if (!_this.state.validated) {
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            right_answer: isCorrect ? 1 : 0,
	            time_done: timeDone,
	            selected_choice: _this.state.selectedChoice
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveStats', data).then(function (resp) {
	            if (resp.success) {
	              _this.setState({ ValidToken: true, validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      } else {
	        _this.setState({
	          result_block: 'card hide_block'
	        });
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid
	      };
	      if (_this.state.bookmarkCSS == 'fa fa-bookmark mark-action-btn-bookmark') {
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true, isFlashCardHidden: false });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      if (_this.timer) {
	        clearInterval(_this.timer);
	        _this.timer = null;
	      }
	
	      _this.setState({ clicked: false });
	      if (parseInt(_this.state.questions.question_number) === _this.state.all_questions_state.length) {
	        _this.setState({ showCompletionQuestion: true });
	      } else {
	        _this.setState({ display_loader: 'show_block' });
	        if (_this.props.params.question_number == _this.state.casesquestion_length) {
	          _this.setState({
	            validated: false,
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            offset: 0
	          });
	          document.getElementById('comment').value = '';
	
	          _this.context.router.push({
	            pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[0].question_number + '/' + 0,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              chapterid: _this.props.params.chapterid,
	              caseid: _this.props.params.caseid,
	              case_offset: _this.props.params.case_offset,
	              question_number: 0,
	              offset: 0
	            }
	          });
	        } else {
	          var i = _this.state.offset + 1;
	          _this.setState({
	            validated: false,
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            offset: i
	          });
	          document.getElementById('comment').value = '';
	
	          _this.context.router.push({
	            pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[i].question_number + '/' + i,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              chapterid: _this.props.params.chapterid,
	              caseid: _this.props.params.caseid,
	              case_offset: _this.props.params.case_offset,
	              question_number: i,
	              offset: i
	            }
	          });
	        }
	      }
	    };
	
	    _this._getNextAnyway = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        showCompletionQuestion: false
	      });
	      _this.setState({ clicked: false });
	      if (_this.props.params.question_number == _this.state.casesquestion_length) {
	        _this.setState({ validated: false });
	        _this.setState({ rated: false });
	        _this.setState({ rating: 0 });
	        _this.setState({ ratting_text: 'Rate this Question' });
	        _this.setState({
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	        });
	        _this.setState({
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark'
	        });
	        _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        _this.setState({ report_block: 'card hide_block' });
	        var i = 0;
	        _this.setState({ offset: i });
	
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[i].question_number + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: i,
	            offset: 0
	          }
	        });
	      } else {
	        _this.setState({ validated: false });
	        _this.setState({ rated: false });
	        _this.setState({ rating: 0 });
	        _this.setState({ ratting_text: 'Rate this Question' });
	        _this.setState({
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	        });
	        _this.setState({
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark'
	        });
	        _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        _this.setState({ report_block: 'card hide_block' });
	        var _i = _this.state.offset + 1;
	        _this.setState({ offset: _i });
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[_i].question_number + '/' + _i,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: _i,
	            offset: _i
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      if (_this.timer) {
	        clearInterval(_this.timer);
	        _this.timer = null;
	      }
	
	      var newOffset = _this.state.offset === 0 ? _this.state.casesquestion_length - 1 : _this.state.offset - 1;
	
	      _this.setState({
	        validated: false,
	        rated: false,
	        clicked: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        offset: newOffset
	      });
	      document.getElementById('comment').value = '';
	
	      _this.context.router.push({
	        pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[newOffset].question_number + '/' + newOffset,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapterid: _this.props.params.chapterid,
	          caseid: _this.props.params.caseid,
	          case_offset: _this.props.params.case_offset,
	          question_number: newOffset,
	          offset: newOffset
	        }
	      });
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({ display_cases: 'hide_block' });
	      _this.setState({ display_subcription: 'hide_block' });
	      _this.setState({ clicked: false });
	      var casesoffset = parseInt(_this.state.cases_offset) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({ cases_offset: casesoffset });
	        caseid = _this.state.all_cases[casesoffset].id;
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + caseid + '/' + casesoffset + '/' + '1' + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: caseid,
	            case_offset: casesoffset,
	            question_number: 1,
	            offset: 0
	          }
	        });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + caseid + '/' + '0' + '/' + '1' + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: caseid,
	            case_offset: casesoffset,
	            question_number: 1,
	            offset: 0
	          }
	        });
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({ display_cases: 'hide_block' });
	      _this.setState({ display_subcription: 'hide_block' });
	      _this.setState({ clicked: false });
	      if (_this.state.cases_offset == 0) {
	        var casesoffset = _this.state.cases_length - 1;
	        var caseid = _this.state.all_cases[casesoffset].id;
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + caseid + '/' + casesoffset + '/' + '1' + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: caseid,
	            case_offset: casesoffset,
	            question_number: 1,
	            offset: 0
	          }
	        });
	      } else {
	        var _casesoffset = _this.state.cases_offset - 1;
	        var caseid = _this.state.all_cases[_casesoffset].id;
	        _this.setState({ cases_offset: _casesoffset });
	        _this.context.router.push({
	          pathname: '/cfa3/chapter/' + _this.props.params.chapterid + '/' + caseid + '/' + _casesoffset + '/' + '1' + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: caseid,
	            case_offset: _casesoffset,
	            question_number: 1,
	            offset: 0
	          }
	        });
	      }
	    };
	
	    _this.handleTimerResponse = function (selectedChoice) {
	      if (selectedChoice) {
	        clearInterval(_this.timer);
	        _this.setState({
	          timer_stop: true,
	          timer_tag: 'Start',
	          timerstopbtn: 'pause_btn icon-control-play',
	          count: _this.state.questions["cfa3_question_stats.time_done"] || 0
	        });
	      } else {
	        _this.setState({
	          timer_stop: false,
	          timer_tag: 'Stop',
	          timerstopbtn: 'pause_btn icon-control-pause',
	          count: 0
	        });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this._tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: _alertMessage2.default.messageContent_cfa_3,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      isFlashCardHidden: true,
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-play',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: true,
	      timer_tag: 'Start',
	      chaptername: '',
	      caseid: _this.props.params.caseid,
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      cases_offset: '',
	      casesquestion_length: '',
	      chapters: '',
	      display_loader: '',
	      selectedmenu: 'cfa_3',
	      subscriptionstatus: '',
	      display_subcription: 'hide_block',
	      display_cases: 'show_block',
	
	      showCompletionQuestion: false,
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cases: [],
	      exam_type: 'cfa3',
	
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      forumComment: '',
	      category: 'CFA Level 3',
	      tags: ['cfa-3', 'cfa', 'question', 'case'],
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      selectedChoice: null,
	      timeDone: 0
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(Cfa3chapter, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: '_tick',
	    value: function _tick() {
	      if (!this.state.timer_stop) {
	        this.setState(function (prevState) {
	          return {
	            count: prevState.count + 1
	          };
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      if (this.state.markAsCompleted == true) {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.cases.casesingleData.case_number,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.exam_type,
	          chapter_id: this.props.params.chapterid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      } else {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          case_no: this.state.cases.casesingleData.case_number,
	          completion_status: this.state.markAsCompleted,
	          exam_type: this.state.exam_type,
	          chapter_id: this.props.params.chapterid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/UpdateCfaRatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1 });
	            _this3.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({ rating: items.ratting });
	              _this3.setState({ ratting_text: 'Rated ' });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveCfaratting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1 });
	                _this3.setState({ ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/saveCfaratting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({ rated: 1 });
	              _this3.setState({
	                ratting_text: 'Rated ' + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this4 = this;
	
	        var storage_session, result, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                });
	                window.scrollTo(0, 0);
	                _context2.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context2.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                this.setState({
	                  case_id: this.props.params.caseid,
	                  display_cases: 'hide_block'
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  caseid: this.props.params.caseid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesbyId', data).then(function (resp_cases) {
	                  _this4.setState({ cases: resp_cases });
	                  if (resp_cases.success) {
	                    var data = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    };
	                    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	                    _userStore2.default.getUserProfile(true).then(function (resp) {
	                      var free_status = '';
	                      if (resp.profileInfo.role === 'partner') {
	                        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                          free_status = 'free';
	                          _this4.setState({ subscriptionstatus: 'free' });
	                          if (resp_cases.casesingleData.free === 0) {
	                            _this4.setState({
	                              display_cases: 'hide_block',
	                              display_subcription: 'show_block'
	                            });
	                            _this4.toggleAlert();
	                          } else {
	                            _this4.setState({
	                              display_cases: 'show_block',
	                              display_subcription: 'hide_block'
	                            });
	                          }
	                        } else {
	                          _this4.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          var dataset = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            examid: data_arr
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, examPlanData;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 9;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this4.state.selectedmenu;
	                                      isInArray_var = false;
	                                      examPlanData = resp_exam.examPlan[0];
	                                      _context.next = 7;
	                                      return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                    case 7:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        _this4.setState({
	                                          subscriptionstatus: 'paid',
	                                          display_cases: 'show_block',
	                                          display_subcription: 'hide_block'
	                                        });
	                                      } else {
	                                        if (resp_cases.casesingleData.free == 0) {
	                                          _this4.setState({
	                                            display_cases: 'hide_block',
	                                            display_subcription: 'show_block'
	                                          });
	                                        } else {
	                                          _this4.setState({
	                                            subscriptionstatus: 'free',
	                                            display_cases: 'show_block',
	                                            display_subcription: 'hide_block'
	                                          });
	                                        }
	                                      }
	
	                                    case 9:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this4);
	                            }));
	
	                            return function (_x) {
	                              return _ref2.apply(this, arguments);
	                            };
	                          }());
	                        }
	                      } else {
	                        if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                          free_status = 'free';
	                          _this4.setState({ subscriptionstatus: 'free' });
	                          if (resp_cases.casesingleData.free === 0) {
	                            _this4.setState({
	                              display_cases: 'hide_block',
	                              display_subcription: 'show_block'
	                            });
	                            _this4.toggleAlert();
	                          } else {
	                            _this4.setState({
	                              display_cases: 'show_block',
	                              display_subcription: 'hide_block'
	                            });
	                          }
	                        } else {
	                          _this4.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          var dataset = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            examid: data_arr
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this4.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                              if (isInArray_var) {
	                                _this4.setState({
	                                  subscriptionstatus: 'paid',
	                                  display_cases: 'show_block',
	                                  display_subcription: 'hide_block'
	                                });
	                              } else {
	                                if (resp_cases.casesingleData.free == 0) {
	                                  _this4.setState({
	                                    display_cases: 'hide_block',
	                                    display_subcription: 'show_block'
	                                  });
	                                } else {
	                                  _this4.setState({
	                                    subscriptionstatus: 'free',
	                                    display_cases: 'show_block',
	                                    display_subcription: 'hide_block'
	                                  });
	                                }
	                              }
	                            }
	                          });
	                        }
	                      }
	                    });
	                  }
	                });
	                // });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter_id: this.props.params.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({ chaptername: resp.chapterdata.chapter_name });
	                    _this4.setState({ chapters: resp.chapterdata });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCases', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({ ValidToken: true });
	                    _this4.setState({ all_cases: resp.readings });
	                    _this4.setState({ cases_length: resp.readings.length });
	
	                    for (var i = 0; i < resp.readings.length; i++) {
	                      if (_this4.props.params.case_offset == i) {
	                        _this4.setState({ cases_offset: _this4.props.params.case_offset });
	                        _this4.setState({ cases_display: resp.readings[i].case });
	                        _this4.setState({ cases_name: resp.readings[i].case_name });
	                      }
	                    }
	                    var param = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname'],
	                      case_id: _this4.state.case_id
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(function (resp_question) {
	                      if (resp_question.success) {
	                        _this4.setState({
	                          casesquestion_length: resp_question.questions_details.length
	                        });
	                        // Guard against infinite loader when the BE returns
	                        // `questions_details: []` — happens when every question row
	                        // for this case_id has been deactivated by admins
	                        // (isActive=0) but the parent row in cfa3_2025_cases is
	                        // still active, so the case tile appears in the chapter
	                        // list. Without this branch the for-loop below never runs
	                        // and display_loader stays 'show_block' forever.
	                        // Also covers the "question_number out of range" case where
	                        // the URL asks for question 5 but only 3 questions exist.
	                        if (resp_question.questions_details.length === 0 || resp_question.questions_details.length <= _this4.props.params.question_number - 1) {
	                          _this4.setState({
	                            display_loader: 'hide_block',
	                            all_questions_state: resp_question.questions_details
	                          });
	                          return;
	                        }
	                        if (resp_question.questions_details.length > _this4.props.params.question_number - 1) {
	                          var offset_res = '';
	                          var questionid = '';
	                          for (var i = 0; i < resp_question.questions_details.length; i++) {
	                            if (resp_question.questions_details[i].question_number == _this4.props.params.question_number) {
	                              (function () {
	                                offset_res = i;
	                                questionid = resp_question.questions_details[i].id;
	                                var currentQuestion = resp_question.questions_details[i];
	                                var selectedChoice = currentQuestion["cfa3_question_stats.selected_choice"] || '';
	                                var rightAnswer = currentQuestion["cfa3_question_stats.right_answer"] || 0;
	                                var answerStatus = currentQuestion["cfa3_question_stats.id"] || '';
	                                var correctAnswer = 'choice_' + currentQuestion.answer;
	                                var showAnswer = false;
	                                var selected = '';
	                                var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_3);
	                                if (selectedChoice && isRevisionMode) {
	                                  selected = selectedChoice;
	                                  showAnswer = true;
	                                } else if (answerStatus && isRevisionMode) {
	                                  if (rightAnswer === 1) {
	                                    selected = correctAnswer;
	                                    showAnswer = true;
	                                  } else if (!rightAnswer) {
	                                    var choices = ['choice_a', 'choice_b', 'choice_c'].filter(function (choice) {
	                                      return choice !== correctAnswer;
	                                    });
	                                    selected = choices.length > 0 ? choices[0] : '';
	                                    showAnswer = true;
	                                  }
	                                }
	                                if (showAnswer && isRevisionMode) {
	                                  _this4.setState({
	                                    questions: currentQuestion,
	                                    selectedChoice: selected,
	                                    clicked: true,
	                                    choice_a: selected === 'choice_a' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_a' ? 'answer_box success' : 'answer_box',
	                                    choice_b: selected === 'choice_b' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_b' ? 'answer_box success' : 'answer_box',
	                                    choice_c: selected === 'choice_c' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_c' ? 'answer_box success' : 'answer_box',
	                                    result_block: 'card show_block',
	                                    text_color: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
	                                    result: selected === correctAnswer ? 'CORRECT' : 'INCORRECT'
	                                  });
	                                } else {
	                                  _this4.setState({
	                                    questions: currentQuestion,
	                                    selectedChoice: '',
	                                    clicked: false,
	                                    choice_a: 'answer_box',
	                                    choice_b: 'answer_box',
	                                    choice_c: 'answer_box',
	                                    result_block: 'card hide_block'
	                                  });
	                                }
	                                _this4.handleTimerResponse(selected);
	                              })();
	                            }
	                            if (i == resp_question.questions_details.length - 1) {
	                              _this4.setState({ display_loader: 'hide_block' });
	                            }
	                          }
	                          _this4.setState({ offset: offset_res });
	                          _this4.setState({
	                            all_questions_state: resp_question.questions_details
	                          });
	
	                          var params_fav = {
	                            token: storage_session['token'],
	                            question_id: questionid,
	                            idname: storage_session['idname'],
	                            chapter_id: _this4.props.params.chapterid
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (response) {
	                            if (response.success) {
	                              _this4.setState({
	                                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                              });
	                              _this4.setState({
	                                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                              });
	                              _this4.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	                              _this4.setState({
	                                save_text: '' + _language2.default.LC().Question_Saved,
	                                isFlashCardHidden: false
	                              });
	                            } else {
	                              _this4.setState({ isFlashCardHidden: true });
	                            }
	                          });
	
	                          var params = {
	                            token: storage_session['token'],
	                            question_id: questionid,
	                            idname: storage_session['idname']
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params).then(function (response) {
	                            if (response.success) {
	                              _this4.setState({ rated: true });
	                              response.ratting.map(function (items) {
	                                _this4.setState({ rating: items.ratting });
	                                _this4.setState({ ratting_text: 'Rated ' });
	                              });
	                            }
	                          });
	                          var params = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            question_id: questionid
	                          };
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFlashCards', params).then(function (response) {
	                            var flash_cards = '';
	                            if (response.success) {
	                              _this4.setState({ ValidToken: true });
	                              if (response.flash_cards.length > 0) {
	                                _this4.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                });
	                                flash_cards = response.flash_cards.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: '' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'icon_list' },
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this4._editFlash.bind(_this4, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            {
	                                              className: 'pointer_class',
	                                              onClick: _this4._deleteFlash.bind(_this4, items)
	                                            },
	                                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: _this4.state.flash_class },
	                                        _react2.default.createElement('h4', null),
	                                        _react2.default.createElement(
	                                          'p',
	                                          null,
	                                          items.flash_card
	                                        )
	                                      )
	                                    )
	                                  );
	                                });
	                              } else {
	                                _this4.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                                flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                              }
	                              _this4.setState({ flash_data: flash_cards });
	                            } else {
	                              flash_cards = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_FLASHCARD_FOUND
	                              );
	                              _this4.setState({ ValidToken: false });
	                              _this4.setState({ flash_data: flash_cards });
	                              _this4.setState({
	                                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                              });
	                            }
	                            return response;
	                          });
	
	                          _this4.setState({ records: '' });
	                        }
	                      } else {
	                        // BE returned success:false. Same infinite-loader risk as
	                        // the empty-array case above — kill the loader so the user
	                        // gets an actionable UI state instead of a hung spinner.
	                        _this4.setState({ display_loader: 'hide_block' });
	                      }
	                    });
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                    _this4.setState({ records: 'Result not found.' });
	                  }
	                  clearInterval(_this4.timer);
	                  _this4.timer = setInterval(_this4._tick.bind(_this4), 1000);
	                  return resp;
	                });
	
	              case 14:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number != this.props.params.question_number && nextProps.params.caseid == this.props.params.caseid) {
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid != this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url question offset change run this function*/
	
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      this.setState({ case_id: caseid });
	      var data = { token: token_id, idname: idname, chapter_id: chapterid };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            chaptername: resp.chapterdata.chapter_name,
	            chapters: resp.chapterdata
	          });
	        } else {
	          _this5.setState({ ValidToken: false });
	        }
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCases', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            all_cases: resp.readings
	          });
	
	          for (var i = 0; i < resp.readings.length; i++) {
	            if (_this5.props.params.case_offset == i) {
	              _this5.setState({
	                cases_display: resp.readings[i].case,
	                cases_name: resp.readings[i].case_name
	              });
	            }
	          }
	
	          _this5.setState({ display_loader: 'hide_block' });
	          var param = { token: token_id, idname: idname, case_id: caseid };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this5.setState({
	                casesquestion_length: resp_question.questions_details.length
	              });
	
	              if (resp_question.questions_details.length > question_number - 1) {
	                var offset_res = '';
	                var questionid = '';
	
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  if (resp_question.questions_details[i].question_number == question_number) {
	                    (function () {
	                      offset_res = i;
	                      questionid = resp_question.questions_details[i].id;
	                      var currentQuestion = resp_question.questions_details[i];
	                      var selectedChoice = currentQuestion["cfa3_question_stats.selected_choice"] || '';
	                      var rightAnswer = currentQuestion["cfa3_question_stats.right_answer"] || 0;
	                      var answerStatus = currentQuestion["cfa3_question_stats.id"] || '';
	                      var timeDone = currentQuestion["cfa3_question_stats.time_done"] || 0;
	                      var correctAnswer = 'choice_' + currentQuestion.answer;
	                      var showAnswer = false;
	                      var selected = '';
	                      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_3);
	                      if (selectedChoice && isRevisionMode) {
	                        selected = selectedChoice;
	                        showAnswer = true;
	                      } else if (answerStatus && isRevisionMode) {
	                        if (rightAnswer === 1) {
	                          selected = correctAnswer;
	                          showAnswer = true;
	                        } else if (!rightAnswer) {
	                          var choices = ['choice_a', 'choice_b', 'choice_c'].filter(function (choice) {
	                            return choice !== correctAnswer;
	                          });
	                          selected = choices.length > 0 ? choices[0] : '';
	                          showAnswer = true;
	                        }
	                      }
	                      if (showAnswer && isRevisionMode) {
	                        _this5.setState({
	                          questions: currentQuestion,
	                          selectedChoice: selected,
	                          clicked: true,
	                          choice_a: selected === 'choice_a' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_a' ? 'answer_box success' : 'answer_box',
	                          choice_b: selected === 'choice_b' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_b' ? 'answer_box success' : 'answer_box',
	                          choice_c: selected === 'choice_c' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_c' ? 'answer_box success' : 'answer_box',
	                          result_block: 'card show_block',
	                          text_color: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
	                          result: selected === correctAnswer ? 'CORRECT' : 'INCORRECT'
	                        });
	                      } else {
	                        _this5.setState({
	                          questions: currentQuestion,
	                          selectedChoice: '',
	                          clicked: false,
	                          choice_a: 'answer_box',
	                          choice_b: 'answer_box',
	                          choice_c: 'answer_box',
	                          result_block: 'card hide_block'
	                        });
	                      }
	                      _this5.handleTimerResponse(selected);
	                    })();
	                  }
	                }
	
	                _this5.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details
	                });
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({ rated: true });
	                    response.ratting.map(function (items) {
	                      _this5.setState({
	                        rating: items.ratting,
	                        ratting_text: 'Rated '
	                      });
	                    });
	                  }
	                });
	                var params_fav = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid,
	                  chapter_id: chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      save_text: '' + _language2.default.LC().Question_Saved,
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this5.setState({ isFlashCardHidden: true, bookmarkColor: '' });
	                  }
	                });
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this6 = this;
	
	      var data = { token: token_id, idname: idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        var data = {
	          token: token_id,
	          idname: idname,
	          caseid: _this6.props.params.caseid
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesbyId', data).then(function (resp_cases) {
	          if (resp_cases.success) {
	            var data = { token: token_id, idname: idname };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	              var free_status = '';
	
	              if (resp.profileInfo.role === 'partner') {
	                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                  free_status = 'free';
	                  _this6.setState({ subscriptionstatus: 'free' });
	                  if (resp_cases.casesingleData.free == 0) {
	                    _this6.setState({
	                      display_cases: 'hide_block',
	                      display_subcription: 'show_block'
	                    });
	                    _this6.toggleAlert();
	                  } else {
	                    _this6.setState({
	                      display_cases: 'show_block',
	                      display_subcription: 'hide_block'
	                    });
	                  }
	                } else {
	                  _this6.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                  var dataset = {
	                    token: token_id,
	                    idname: idname,
	                    examid: data_arr
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var, examPlanData;
	                      return _regenerator2.default.wrap(function _callee3$(_context3) {
	                        while (1) {
	                          switch (_context3.prev = _context3.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context3.next = 9;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this6.state.selectedmenu;
	                              isInArray_var = false;
	                              examPlanData = resp_exam.examPlan[0];
	                              _context3.next = 7;
	                              return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this6.state.cfaUnlimitedPackage, _this6.state.cfaUnlimitedActiveExam, examPlanData);
	
	                            case 7:
	                              isInArray_var = _context3.sent;
	
	                              if (isInArray_var) {
	                                _this6.setState({
	                                  display_cases: 'show_block',
	                                  display_subcription: 'hide_block'
	                                });
	                              } else {
	                                if (resp_cases.casesingleData.free == 0) {
	                                  _this6.setState({
	                                    display_cases: 'hide_block',
	                                    display_subcription: 'show_block'
	                                  });
	                                } else {
	                                  _this6.setState({
	                                    display_cases: 'show_block',
	                                    display_subcription: 'hide_block'
	                                  });
	                                }
	                              }
	
	                            case 9:
	                            case 'end':
	                              return _context3.stop();
	                          }
	                        }
	                      }, _callee3, _this6);
	                    }));
	
	                    return function (_x2) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	                }
	              } else {
	                if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                  free_status = 'free';
	                  _this6.setState({ subscriptionstatus: 'free' });
	                  if (resp_cases.casesingleData.free == 0) {
	                    _this6.setState({
	                      display_cases: 'hide_block',
	                      display_subcription: 'show_block'
	                    });
	                    _this6.toggleAlert();
	                  } else {
	                    _this6.setState({
	                      display_cases: 'show_block',
	                      display_subcription: 'hide_block'
	                    });
	                  }
	                } else {
	                  _this6.setState({
	                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                  });
	                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  var dataset = {
	                    token: token_id,
	                    idname: idname,
	                    examid: data_arr
	                  };
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                    if (resp_exam.success) {
	                      var exam_data = resp_exam.examData;
	                      var selectedmen = _this6.state.selectedmenu;
	                      var isInArray_var = false;
	                      isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this6.state.cfaUnlimitedPackage, _this6.state.cfaUnlimitedActiveExam);
	                      if (isInArray_var) {
	                        _this6.setState({
	                          display_cases: 'show_block',
	                          display_subcription: 'hide_block'
	                        });
	                      } else {
	                        if (resp_cases.casesingleData.free == 0) {
	                          _this6.setState({
	                            display_cases: 'hide_block',
	                            display_subcription: 'show_block'
	                          });
	                        } else {
	                          _this6.setState({
	                            display_cases: 'show_block',
	                            display_subcription: 'hide_block'
	                          });
	                        }
	                      }
	                    }
	                  });
	                }
	              }
	            });
	          }
	        });
	      });
	
	      this.setState({ case_id: caseid });
	      var data = { token: token_id, idname: idname, chapter_id: chapterid };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            chaptername: resp.chapterdata.chapter_name,
	            chapters: resp.chapterdata
	          });
	        } else {
	          _this6.setState({ ValidToken: false });
	        }
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCases', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block'
	          });
	          document.getElementById('comment').value = '';
	
	          _this6.setState({ all_cases: resp.readings });
	          for (var i = 0; i < resp.readings.length; i++) {
	            if (_this6.props.params.case_offset == i) {
	              _this6.setState({
	                cases_display: resp.readings[i].case,
	                cases_name: resp.readings[i].case_name
	              });
	            }
	          }
	          _this6.setState({ display_loader: 'hide_block' });
	          var param = { token: token_id, idname: idname, case_id: caseid };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this6.setState({
	                casesquestion_length: resp_question.questions_details.length
	              });
	              if (resp_question.questions_details.length > question_number - 1) {
	                var offset_res = '';
	                var questionid = '';
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  if (resp_question.questions_details[i].question_number == question_number) {
	                    (function () {
	                      offset_res = i;
	                      questionid = resp_question.questions_details[i].id;
	                      var currentQuestion = resp_question.questions_details[i];
	                      var selectedChoice = currentQuestion["cfa3_question_stats.selected_choice"] || '';
	                      var rightAnswer = currentQuestion["cfa3_question_stats.right_answer"] || 0;
	                      var answerStatus = currentQuestion["cfa3_question_stats.id"] || '';
	                      var timeDone = currentQuestion["cfa3_question_stats.time_done"] || 0;
	                      var correctAnswer = 'choice_' + currentQuestion.answer;
	                      var showAnswer = false;
	                      var selected = '';
	                      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.CFA_3);
	                      if (selectedChoice && isRevisionMode) {
	                        selected = selectedChoice;
	                        showAnswer = true;
	                      } else if (answerStatus && isRevisionMode) {
	                        if (rightAnswer === 1) {
	                          selected = correctAnswer;
	                          showAnswer = true;
	                        } else if (!rightAnswer) {
	                          var choices = ['choice_a', 'choice_b', 'choice_c'].filter(function (choice) {
	                            return choice !== correctAnswer;
	                          });
	                          selected = choices.length > 0 ? choices[0] : '';
	                          showAnswer = true;
	                        }
	                      }
	                      if (showAnswer && isRevisionMode) {
	                        _this6.setState({
	                          questions: currentQuestion,
	                          selectedChoice: selected,
	                          clicked: true,
	                          choice_a: selected === 'choice_a' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_a' ? 'answer_box success' : 'answer_box',
	                          choice_b: selected === 'choice_b' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_b' ? 'answer_box success' : 'answer_box',
	                          choice_c: selected === 'choice_c' ? selected === correctAnswer ? 'answer_box success' : 'answer_box failure' : correctAnswer === 'choice_c' ? 'answer_box success' : 'answer_box',
	                          result_block: 'card show_block',
	                          text_color: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
	                          result: selected === correctAnswer ? 'CORRECT' : 'INCORRECT'
	                        });
	                      } else {
	                        _this6.setState({
	                          questions: currentQuestion,
	                          selectedChoice: '',
	                          clicked: false,
	                          choice_a: 'answer_box',
	                          choice_b: 'answer_box',
	                          choice_c: 'answer_box',
	                          result_block: 'card hide_block'
	                        });
	                      }
	                      _this6.handleTimerResponse(selected);
	                    })();
	                  }
	                }
	
	                _this6.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details
	                });
	
	                var params_fav = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid,
	                  chapter_id: chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({
	                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      save_text: '' + _language2.default.LC().Question_Saved,
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this6.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCfaratting', params).then(function (response) {
	                  if (response.success) {
	                    _this6.setState({ rated: true });
	                    response.ratting.map(function (items) {
	                      _this6.setState({
	                        rating: items.ratting,
	                        ratting_text: 'Rated '
	                      });
	                    });
	                  }
	                });
	
	                var params = {
	                  token: token_id,
	                  idname: idname,
	                  question_id: questionid
	                };
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this6._editFlash.bind(_this6, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  {
	                                    className: 'pointer_class',
	                                    onClick: _this6._deleteFlash.bind(_this6, items)
	                                  },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                  return response;
	                });
	
	                _this6.setState({ records: '' });
	              }
	            }
	          });
	        } else {
	          _this6.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this6.timer);
	        _this6.timer = setInterval(_this6._tick.bind(_this6), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: true, timer_tag: 'Start', count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this._tick.bind(this), 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var questions_data_display = questions;
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	      var forumData = '';
	
	      var data = void 0,
	          question_data = '';
	      forumData = '<div class=\'col-sm-12 no-cursor\'>\n    <div class=\'margin_bottom_40\'>\n      <div>\n        <div class=\'row\'>\n          <div class=\'col-sm-12\'>\n            <div class=\'row no-cursor\'>\n              <div class=\'col-sm-12 cursor-text\'>\n                <div\n                  contentEditable=\'false\'\n                  class=\'margin_bottom_40 view_questionhtml bg_blue \'\n                >                      \n                  ' + questions_data_display.question + '\n                </div>\n              </div>\n              <div class=\'col-sm-12 no-cursor\' id=\'choice_a\'>\n                <div class=\'answer_box_forum\'>\n                  <div class=\'answer_count\'>' + _language2.default.LC().A + '</div>\n                  <p class=\'ans_box_text\'>\n                    <span contentEditable=\'false\'>                          \n                      ' + questions_data_display.choice_a + '\n                    </span>\n                  </p>\n                </div>\n              </div>\n\n              <div class=\'col-sm-12 no-cursor\' id=\'choice_b\'>\n                <div class=\'answer_box_forum\'>\n                  <div class=\'answer_count\'>' + _language2.default.LC().B + '</div>\n                  <p class=\'ans_box_text\'>\n                    <span contentEditable=\'false\'>                          \n                      ' + questions_data_display.choice_b + '\n                    </span>\n                  </p>\n                </div>\n              </div>\n              <div\n                class=\'col-sm-12 margin_bottom_30 no-cursor\'\n                id=\'choice_c\'\n              >\n                <div class=\'answer_box_forum\'>\n                  <div class=\'answer_count\'>' + _language2.default.LC().C + '</div>\n                  <p class=\'ans_box_text\'>\n                    <span contentEditable=\'false\'>\n                      ' + questions_data_display.choice_c + '\n                    </span>\n                  </p>\n                </div>\n              </div>\n              <div class=\'col-sm-12 cursor-text\'>\n                <p contentEditable=\'false\' class=\'view_questionhtml\'>\n                The correct answer is  ' + (questions_data_display.answer === 'choice_a' ? '<strong> A.</strong>' : questions_data_display.answer === 'choice_b' ? '<strong> B.</strong>' : questions_data_display.answer === 'choice_c' ? '<strong> C.</strong>' : '<strong> C.</strong>') + ' <br/>\n                ' + questions_data_display.explanation + '\n                </p>\n              </div>\n              <div class=\'col-sm-12 margin_bottom_30 no-cursor\'>\n                <div class=\'userQuestionDiv\'>\n                  <span class=\'questionColor cursor-text\'>                        \n                    *User Question:\n                  </span>\n                  <div class=\'forum-data-comment cursor-text\'>\n                    <h4> ' + this.state.forumComment + '</h4>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>';
	      data = _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12 col-md-12 note-section note-section-new' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card note-section-header Cfa3-note-section-header ffff' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header title-font-size' },
	            this.state.cases_name,
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(this.state.cases_offset) !== 0 && _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class',
	                onClick: this._getPreviousCase
	              }),
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class',
	                onClick: this._getNextCase
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block note_text_wrap  ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'px-2' },
	              (0, _function.renderHTMLContent)(this.state.cases_display, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })
	            )
	          )
	        )
	      );
	
	      {
	        this.state.showCompletionQuestion ? question_data = _react2.default.createElement(
	          'div',
	          { className: 'w-100' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + this.state.display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 complete-section-wrap ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header text-center' },
	                _language2.default.LC().Mark_this_Question_as_Completed,
	                _react2.default.createElement(
	                  'div',
	                  { onClick: this._getNextAnyway, className: 'float-right text-right' },
	                  _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 text-center' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 ' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'quation-img' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                            className: 'margin_bottom_10',
	                            alt: ''
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            contentEditable: 'false',
	                            suppressContentEditableWarning: true,
	                            className: 'margin_bottom_10 view_questionhtml bg_blue'
	                          },
	                          ' ',
	                          _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                          ' '
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'complete-or-not-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check-button-wrap' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              ' ',
	                              _language2.default.LC().COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_completed',
	                                name: 'mark_completed',
	                                value: 'select',
	                                onClick: this.markCompleted.bind(this),
	                                checked: this.state.markAsCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              _language2.default.LC().NOT_COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_not_completed',
	                                name: 'mark_not_completed',
	                                value: 'select',
	                                onClick: this.markNotCompleted.bind(this),
	                                checked: this.state.markAsNotCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'd-block text-center complete-quation-submit' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              disabled: this.state.markCompleted,
	                              onClick: this.changeCompletionStatus.bind(this),
	                              className: 'btn btn-primary pointer_class'
	                            },
	                            ' ',
	                            _language2.default.LC().SUBMIT,
	                            ' '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : question_data = _react2.default.createElement(
	          'div',
	          { className: 'note-section note-section-new' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + this.state.display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card font-lusitana' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 ' + this.state.display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card font-lusitana' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                  className: 'margin_right_20',
	                  alt: '',
	                  width: '30'
	                }),
	                _language2.default.LC().QUESTION,
	                ' ',
	                questions_data_display.question_number + ' - ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'float-right text-right' },
	                  this.state.offset !== 0 && _react2.default.createElement('i', {
	                    className: 'fa fa-angle-left ques_arrow pointer_class ',
	                    onClick: this._getPrevious
	                  }),
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-right ques_arrow pointer_class ',
	                    onClick: this._getNext
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9' },
	                    _react2.default.createElement(
	                      _ViewQuestion2.default,
	                      Object.assign({}, questions_data_display, this.props, {
	                        setAnswer: this._getAnswer,
	                        showAnswer: this.state.clicked,
	                        correctChoice: 'choice_' + questions_data_display.answer,
	                        selectedChoice: this.state.selectedChoice,
	                        onValidate: function onValidate() {
	                          return _this7._getResult(questions_data_display);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 12, className: 'mt-2' },
	                        _react2.default.createElement(
	                          _reactstrap.Row,
	                          { className: 'align-items-center' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'd-flex align-items-center' },
	                            _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                              isQue: true,
	                              _getResult: this._getResult,
	                              clicked: this.state.clicked,
	                              _saveQuestion: this._saveQuestion,
	                              _displayReportForm: this._displayReportForm,
	                              all_questions: questions_data_display,
	                              save_text: this.state.save_text,
	                              bookmarkCSS: this.state.bookmarkCSS,
	                              bookmarkColor: this.state.bookmarkColor,
	                              disabled: !this.state.selectedChoice || this.state.clicked
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'margin_bottom_0 margin_right_10 font-16px' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'star_rating_wrap' },
	                              _react2.default.createElement(_reactStarRatings2.default, {
	                                rating: this.state.rating,
	                                starRatedColor: 'rgb(255, 180, 0)',
	                                starEmptyColor: 'rgb(51, 51, 51)',
	                                starDimension: '20px',
	                                starHoverColor: 'rgb(255, 180, 0)',
	                                starSpacing: '2px',
	                                changeRating: this.onStarClick.bind(this, questions_data_display),
	                                numberOfStars: 5,
	                                name: 'rate1'
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'timer_outer' },
	                      _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'timer_box' },
	                        display_time
	                      )
	                    ),
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this.timerFunction.bind(this, questions_data_display),
	                      disabled: !!this.state.selectedChoice || this.state.clicked
	                    }),
	                    this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	                      'a',
	                      {
	                        onClick: this._getSubscribe,
	                        className: 'box_question_color text-center cursor_pointer'
	                      },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().SUBSCRIBE_FOR_3000_PRACTICE_QUESTIONS
	                      )
	                    ) : ''
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.result_block + ' font-lusitana font-16px' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.text_color },
	                this.state.result
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                (0, _function.renderHTMLContent)(questions_data_display.explanation, "p", "view_questionhtml", { contentEditable: "false" })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, questions_data_display)
	                          },
	                          ' ',
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this, questions_data_display)
	                          },
	                          ' ',
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(_FlashCard2.default, {
	                item: questions,
	                type: 'question',
	                isFlashCardHidden: isFlashCardHidden,
	                ref: this.setChildRef,
	                exam: 'cfa3'
	              })
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row note-section note-section-new' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head title-font-size' },
	              _language2.default.LC().CASE_STUDY,
	              ' - ',
	              this.state.chaptername
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_CASES
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          question_data
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	        })
	      );
	    }
	  }]);
	
	  return Cfa3chapter;
	}(_react.Component);
	
	Cfa3chapter.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfa3chapter;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Cfa3flashquestion = function (_Component) {
	  _inherits(Cfa3flashquestion, _Component);
	
	  function Cfa3flashquestion(props) {
	    _classCallCheck(this, Cfa3flashquestion);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3flashquestion.__proto__ || Object.getPrototypeOf(Cfa3flashquestion)).call(this, props));
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/cfa3_dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var dataparam = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            caseid: resp.questionsbyid.case_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesbyId', dataparam).then(function (resp_case) {
	            if (resp_case.success) {
	              _this.context.router.push({
	                pathname: '/cfa3/chapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.case_id + '/' + (parseInt(resp_case.casesingleData.case_number) - 1, 10) + '/' + resp.questionsbyid.question_number,
	                state: { token: _this.state.token, idname: _this.state.idname }
	              });
	            } else {
	              console.log('Some Thing Went Wrong');
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      flashreport: [], //All Flash question Store
	      token: '',
	      idname: '',
	      ValidToken: false,
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(Cfa3flashquestion, [{
	    key: 'toggle',
	
	
	    //Function to toggle alert box
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	
	    //Function to delete flash card
	
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	
	    //Function to close toggle and set items status blank
	
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	
	    //On Click ok button from alert perform deletion of cfa flash card
	
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this2 = this;
	
	      if (this.state.item_status === 'flashcard') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          flash_card: this.state.items_val
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('flash_' + _this2.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	
	    //On click delete button ,set item value and open toggle alert
	
	
	    //Function to redirect, page to Dashboard page
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ flashreport: resp.flash_report });
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	
	    //Function to redirect page to particular question id
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var flashreport_val = this.state.flashreport;
	      var flashcard_data = '';
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ': ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().Saved_Note,
	                      ': '
	                    ),
	                    ' ',
	                    items.flash_card
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._beginChapter.bind(_this4, items),
	                        className: _this4.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._deleteFlashcard.bind(_this4, items),
	                        className: _this4.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          ' ',
	          _language2.default.LC().NO_SAVED_FLASHCARDS,
	          ' '
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_FLASHCARDS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                ' ',
	                _language2.default.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW,
	                ':',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          flashcard_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: this.toggleDone },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa3flashquestion;
	}(_react.Component);
	
	Cfa3flashquestion.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa3flashquestion;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Cfa3savedquestion = function (_Component) {
	  _inherits(Cfa3savedquestion, _Component);
	
	  function Cfa3savedquestion(props) {
	    _classCallCheck(this, Cfa3savedquestion);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3savedquestion.__proto__ || Object.getPrototypeOf(Cfa3savedquestion)).call(this, props));
	
	    _this._deleteSavequestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/cfa3_dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var dataparam = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            caseid: resp.questionsbyid.case_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getCasesbyId', dataparam).then(function (resp_case) {
	            if (resp_case.success) {
	              _this.context.router.push({
	                pathname: '/cfa3/chapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.case_id + '/' + (parseInt(resp_case.casesingleData.case_number) - 1) + '/' + resp.questionsbyid.question_number,
	                state: { token: _this.state.token, idname: _this.state.idname }
	              });
	            } else {
	              console.log('Some Thing Went Wrong');
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      savedquestion: [],
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa3savedquestion, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this2 = this;
	
	      if (this.state.item_status == 'savedquestion') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          save_question: this.state.items_val
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/deleteSavequestion', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('savedque_' + _this2.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_3question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ savedquestion: resp.questions });
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	
	    //Function to redirect page to particular question id
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var savedquestion_val = this.state.savedquestion;
	      // console.log(savedquestion_val);
	      var savedquestion_data = '';
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ': ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().TOPIC,
	                      ': '
	                    ),
	                    ' ',
	                    (0, _function.renderHTMLContent)(items.topic_name, "span")
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._beginChapter.bind(_this4, items),
	                        className: _this4.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._deleteSavequestino.bind(_this4, items),
	                        className: _this4.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_SAVED_QUESTIONS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                _language2.default.LC().PICK_THE_QUESTION_YOU_WANT_TO_REVIEW,
	                ':',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              '\xA0\xA0',
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          savedquestion_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-sm btn-primary', color: 'primary', onClick: this.toggleDone },
	                ' ',
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa3savedquestion;
	}(_react.Component);
	
	Cfa3savedquestion.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa3savedquestion;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Axios from 'axios';
	// import { saveAs } from 'file-saver';
	
	
	/* eslint-disable*/
	
	var Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(chapter, e) {
	        var path, final_exam, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (chapter.chapter_no === 1) {
	                  path = _AppRoutes2.default.CFA3_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	
	                  _this.context.router.push({
	                    pathname: path,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter: chapter.chapter_no
	                    }
	                  });
	                } else {
	                  final_exam = [];
	                  data = { token: _this.state.token, idname: _this.state.idname };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                      var data_arr, dataset;
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              if (!(resp.profileInfo.role === 'partner')) {
	                                _context2.next = 12;
	                                break;
	                              }
	
	                              if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                                _context2.next = 5;
	                                break;
	                              }
	
	                              _this.toggleAlert();
	                              _context2.next = 10;
	                              break;
	
	                            case 5:
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	                              _context2.next = 10;
	                              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData, _path;
	
	                                  return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                      switch (_context.prev = _context.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context.next = 7;
	                                          return _Cfa3Subscription4.default.checkCfa3NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context.sent;
	
	                                          if (isInArray_var) {
	                                            _path = _AppRoutes2.default.CFA3_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	
	                                            _this.context.router.push({
	                                              pathname: _path,
	                                              state: {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                chapter: chapter.chapter_no
	                                              }
	                                            });
	                                          } else {
	                                            _this.toggleAlert();
	                                          }
	                                          _context.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context.stop();
	                                      }
	                                    }
	                                  }, _callee, _this2);
	                                }));
	
	                                return function (_x4) {
	                                  return _ref3.apply(this, arguments);
	                                };
	                              }());
	
	                            case 10:
	                              _context2.next = 13;
	                              break;
	
	                            case 12:
	                              if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                                _this.toggleAlert();
	                              } else {
	                                _this.setState({
	                                  cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                  cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                                });
	                                data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                                dataset = {
	                                  token: _this.state.token,
	                                  idname: _this.state.idname,
	                                  examid: data_arr
	                                };
	
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                  if (resp_exam.success) {
	                                    var exam_data = resp_exam.examData;
	                                    var selectedmen = _this.state.selectedmenu;
	                                    var isInArray_var = false;
	
	                                    isInArray_var = _Cfa3Subscription2.default.checkCfa3NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    //console.log(isInArray_var);
	                                    if (isInArray_var) {
	                                      var _path2 = _AppRoutes2.default.CFA3_NOTES_READINGS.replace(':chapter', chapter.chapter_no);
	                                      _this.context.router.push({
	                                        pathname: _path2,
	                                        state: {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapter: chapter.chapter_no
	                                        }
	                                      });
	                                    } else {
	                                      _this.toggleAlert();
	                                    }
	                                  } else {}
	                                });
	                              }
	
	                            case 13:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }());
	                }
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goToNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, lastRecord, lastAttempt, path;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	
	              if (lastAttempt) {
	                path = _AppRoutes2.default.CFA3_BEGIN_NOTES.replace(':notesid', lastRecord.cfa3_note.chapter_id).replace(':readingid', lastRecord.cfa3_note.reading_id).replace(':id', lastRecord.cfa3_note.id).replace(':chapter', 0);
	
	                _this.context.router.push({
	                  pathname: path
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.toggle = function () {
	      _this.setState({
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.getAdditionalResources = function (type) {
	      var _this$state2 = _this.state,
	          token = _this$state2.token,
	          idname = _this$state2.idname;
	
	      var typeNames = {
	        FS: 'Formula sheet',
	        ES: 'Essential summary',
	        RS: 'Ratio sheet'
	      };
	      var typeName = typeNames[type];
	      var data = {
	        token: token,
	        idname: idname,
	        type: typeName,
	        exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getAdditionalResources', data).then(function (response) {
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          (0, _function.openPDF)(response);
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return response;
	      });
	    };
	
	    _this.checkSubscription = function (type) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var selectedExams = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: selectedExams
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                var exam_data, selectedmen, isSubscribed, examPlanData;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context5.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isSubscribed = false;
	
	                        // #261 — pass examPlanData so mock-only partners hit the
	                        // early-return false.
	
	                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                        _context5.next = 7;
	                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, examPlanData);
	
	                      case 7:
	                        isSubscribed = _context5.sent;
	
	                        if (isSubscribed) {
	                          _this.getAdditionalResources(type);
	                        } else {
	                          _this.toggleAlert();
	                        }
	
	                      case 9:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, _this2);
	              }));
	
	              return function (_x5) {
	                return _ref5.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this.toggleAlert();
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var _selectedExams = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var _dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: _selectedExams
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isSubscribed = false;
	
	                isSubscribed = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isSubscribed) {
	                  _this.getAdditionalResources(type);
	                } else {
	                  _this.toggleAlert();
	                }
	              }
	            });
	          }
	        }
	      });
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      showFreePremium: '',
	      selectedmenu: 'cfa_3',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      isNotesNotFound: false,
	      lastAttempt: false,
	      pdfLoading: true,
	      dropdownOpen: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(Notes, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var _this3 = this;
	
	        var storage_session, data, final_exam;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                // console.log('working')
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    if (resp.chapters.length === 0) {
	                      _this3.setState({ isNotesNotFound: true });
	                    }
	                    _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                    var data = { token: _this3.state.token, idname: _this3.state.idname };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getlastReadNotes', data).then(function (response) {
	                      if (response.success) {
	                        _this3.setState({
	                          lastRecord: response.data,
	                          lastAttempt: true
	                        });
	                      }
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                final_exam = [];
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                  var resp, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context7.next = 3;
	                            break;
	                          }
	
	                          return _context7.abrupt('return');
	
	                        case 3:
	
	                          if (resp.profileInfo.role === 'partner') {
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                              _this3.setState({ showFreePremium: true });
	                            } else {
	                              _this3.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this3.state.token,
	                                idname: _this3.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData;
	                                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                    while (1) {
	                                      switch (_context6.prev = _context6.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context6.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this3.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context6.next = 7;
	                                          return _Cfa3Subscription4.default.checkCfa3NotesSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context6.sent;
	
	                                          if (isInArray_var) {
	                                            _this3.setState({ showFreePremium: false });
	                                          } else {
	                                            _this3.setState({ showFreePremium: true });
	                                          }
	                                          _context6.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context6.stop();
	                                      }
	                                    }
	                                  }, _callee6, _this3);
	                                }));
	
	                                return function (_x6) {
	                                  return _ref8.apply(this, arguments);
	                                };
	                              }()
	                              // console.log('fail');
	                              );
	                            }
	                          } else {
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this3.setState({ showFreePremium: true });
	                            } else {
	                              _this3.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this3.state.token,
	                                idname: _this3.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this3.state.selectedmenu;
	                                  var isInArray_var = false;
	
	                                  isInArray_var = _Cfa3Subscription2.default.checkCfa3NotesSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                  //console.log(isInArray_var);
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	                          }
	
	                        case 4:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this3);
	                })));
	                // });
	
	              case 7:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var dropdownOpen = this.state.dropdownOpen;
	
	      var chapters = this.state.chapters;
	      var data = '';
	      var lastAttempt = this.state.lastAttempt;
	
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                key: item.id,
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium ? item.id === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  index + 1,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon2.svg',
	                      className: '',
	                      width: '24',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countreading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_READINGS
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon3.svg',
	                      className: '',
	                      width: '20',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.Countquestion
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_NOTES
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else if (this.state.isNotesNotFound) {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-12 text-center mt-3' },
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/notes/notes_icon1_blue.svg',
	            className: '',
	            width: '54',
	            alt: ''
	          }),
	          _react2.default.createElement(
	            'h5',
	            { className: 'mt-1' },
	            _language2.default.LC().NOTE_NOT_FOUND
	          )
	        );
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().NOTES
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactstrap.ButtonDropdown,
	              { isOpen: dropdownOpen, toggle: this.toggle },
	              _react2.default.createElement(
	                _reactstrap.DropdownToggle,
	                {
	                  className: 'btn btn-primary pointer_class tooltip_wrap margin_right_20',
	                  caret: true
	                },
	                _messages.messages.ADDITIONAL_RESOURCES
	              ),
	              _react2.default.createElement(
	                _reactstrap.DropdownMenu,
	                { right: true },
	                _react2.default.createElement(
	                  _reactstrap.DropdownItem,
	                  {
	                    value: 'private',
	                    onClick: function onClick() {
	                      _this4.checkSubscription('FS');
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	                  _messages.messages.FORMULA_SHEET
	                )
	              )
	            ),
	            lastAttempt && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToNotes,
	                disabled: !lastAttempt
	              },
	              _messages.messages.GO_TO_MY_LAST_READ_NOTE
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	Notes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Notes;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Viewques = function (_Component) {
	  _inherits(Viewques, _Component);
	
	  function Viewques(props) {
	    _classCallCheck(this, Viewques);
	
	    var _this = _possibleConstructorReturn(this, (Viewques.__proto__ || Object.getPrototypeOf(Viewques)).call(this, props));
	
	    _this._getReadings = function () {
	      var path = _AppRoutes2.default.CFA3_NOTES_READINGS.replace(':chapter', _this.props.params.chapter_no);
	      _this.context.router.push({
	        pathname: path
	      });
	    };
	
	    _this._goToVideo = function () {
	      _this.setState({
	        chapter_video_redirect: _this.state.chapters[parseInt(_this.props.params.chapter_no) - 1]
	      }, function () {
	        // TODO work
	
	        var path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', _this.state.chapter_video_redirect.chapter_no).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':chapter_id', _this.state.chapter_video_redirect.chapter_no).replace(':index', 0);
	        _this.context.router.push({
	          pathname: path,
	          search: '?chapter_name=' + _this.state.chapter_video_redirect.chapter_name + '/' + _this.state.chapter_video_redirect.chapter_no,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter: _this.state.chapter_video_redirect,
	            showFreePremium: _this.state.showFreePremium
	          }
	        });
	      });
	    };
	
	    _this._beginNotes = function (item, e) {
	      // console.log('beginNotes ---> ', item);
	      var path = _AppRoutes2.default.CFA3_BEGIN_NOTES.replace(':notesid', item.chapter_id).replace(':readingid', item.reading_id).replace(':id', item.id);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: item.reading_id,
	          chapter: item.chapter_id
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      showFreePremium: true,
	      subscription_details: '',
	      chapters: [],
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'cfa_3',
	      isVideo: true,
	      Loader: false
	    };
	    return _this;
	  }
	
	  _createClass(Viewques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this2 = this;
	
	        var storage_session, getProfileInfo, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', getProfileInfo).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.profileInfo) {
	                              _this2.setState({
	                                isVideo: resp.profileInfo.isVideo
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	                // console.log(data);
	
	                _context4.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes', data).then(function (resp) {
	                  // console.log(resp);
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true, questions: resp.questions });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 8:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 4;
	                              break;
	                            }
	
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '' && resp.profileInfo.exam_package) {
	                              _this2.setState({
	                                showFreePremium: true,
	                                Loader: true
	                              });
	                            } else {
	                              subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                              _this2.setState({
	                                subscription_details: subscription_details,
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this2.state.token,
	                                idname: _this2.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                  var exam_data, selectedmen, isInArray_var, examPlanData;
	                                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                    while (1) {
	                                      switch (_context2.prev = _context2.next) {
	                                        case 0:
	                                          if (!resp_exam.success) {
	                                            _context2.next = 11;
	                                            break;
	                                          }
	
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = _this2.state.selectedmenu;
	                                          isInArray_var = false;
	                                          examPlanData = resp_exam.examPlan[0];
	                                          _context2.next = 7;
	                                          return _Cfa3Subscription4.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam, examPlanData);
	
	                                        case 7:
	                                          isInArray_var = _context2.sent;
	
	                                          if (isInArray_var) {
	                                            _this2.setState({ showFreePremium: false, Loader: true });
	                                          } else {
	                                            _this2.setState({
	                                              showFreePremium: true,
	                                              Loader: true
	                                            });
	                                          }
	                                          _context2.next = 11;
	                                          break;
	
	                                        case 11:
	                                        case 'end':
	                                          return _context2.stop();
	                                      }
	                                    }
	                                  }, _callee2, _this2);
	                                }));
	
	                                return function (_x3) {
	                                  return _ref4.apply(this, arguments);
	                                };
	                              }());
	                            }
	                            _context3.next = 14;
	                            break;
	
	                          case 4:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context3.next = 8;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this2.setState({
	                              showFreePremium: true,
	                              Loader: true
	                            });
	                            _context3.next = 14;
	                            break;
	
	                          case 8:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this2.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this2.state.token,
	                              idname: _this2.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 14;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa3Subscription2.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                                //   console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this2.setState({ showFreePremium: false, Loader: true });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this2.setState({ showFreePremium: true, Loader: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 14:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.questions;
	      // console.log("this.state.questions;", this.state.questions);
	      var chapters = this.state.chapters;
	      var chapter_no = this.props.params.chapter_no;
	      // let countVideo = chapters[chapter_no - 1]
	      //   ? chapters[this.props.params.chapter_no - 1].Countvideos
	      //   : null;
	
	      var data = '';
	      if (this.state.questions.length && this.state.Loader) {
	        data = questions.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4', key: index },
	            _react2.default.createElement(
	              'div',
	              { onClick: _this3._beginNotes.bind(_this3, item), className: 'border_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                    className: 'margin_right_10',
	                    alt: '',
	                    width: '21'
	                  }),
	                  item.name.length < 90 ? item.name : item.name.substr(0, 100) + '...',
	                  ' ',
	                  '(',
	                  _language2.default.LC().N,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                item.description ? (0, _function.renderHTMLContent)(item.description.substring(0, item.description.indexOf('$$') !== -1 ? item.description.indexOf('$$') : 130) + '...', "div", "view_question_height view_questionhtml margin_bottom_40 cfa_notes_view", { contentEditable: "false" }) : null,
	                _react2.default.createElement(UserInfo, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.reading
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.isVideo === true ? 'col-md-4 text-md-right margin_bottom_20' : 'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data
	        )
	      );
	    }
	  }]);
	
	  return Viewques;
	}(_react.Component);
	
	Viewques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	function UserInfo(props) {
	  var data = {
	    itemid: props.itemid,
	    chapter_id: props.chapter_id,
	    reading_id: props.reading_id,
	    idname: props.idname,
	    token: props.token
	  };
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotesByuser', data).then(function (resp) {
	    if (resp.success) {
	      if (resp.success == 'success') {
	        if (document.getElementById('user_question_status' + props.answered_state) != null) {
	          document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Read';
	
	          document.getElementById('user_question_status' + props.answered_state).id = 'answered_status';
	        }
	      } else {
	        if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Unread';
	
	        if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'notanswered_status';
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { id: 'user_question_status' + props.answered_state })
	  );
	}
	exports.default = Viewques;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _axios = __webpack_require__(102);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _fileSaver = __webpack_require__(151);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfanotesbeginchapters = function (_Component) {
	  _inherits(Cfanotesbeginchapters, _Component);
	
	  function Cfanotesbeginchapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfanotesbeginchapters);
	
	    var _this = _possibleConstructorReturn(this, (Cfanotesbeginchapters.__proto__ || Object.getPrototypeOf(Cfanotesbeginchapters)).call(this, props));
	
	    _this._getReadings = function () {
	      var path = _AppRoutes2.default.CFA3_NOTES_READINGS.replace(':chapter', _this.props.params.notesid);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid
	        }
	      });
	    };
	
	    _this._getNotes = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.CFA3_NOTES_VIEWQUES.replace(':chapter_no', _this.state.questions.chapter_id).replace(':id', _this.props.params.readingid).replace(':reading', _this.state.readings)
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	        bookmarkColor: ''
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset + 1;
	
	      _this.setState({ offset: i, questions: _this.state.all_questions_state[i] });
	
	      //alert((parseInt(this.state.question_length)-1)+'--------'+i);
	      if (parseInt(_this.state.question_length) - 1 == i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i !== 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      var next_question_id = _this.state.all_questions_state[i].id;
	      var path = _AppRoutes2.default.CFA3_BEGIN_NOTES.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	        bookmarkColor: ''
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      //alert(i);
	      // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({
	          next_block: ''
	        });
	      }
	      if (i === 0) {
	        _this.setState({
	          previ_block: 'card hide_block'
	        });
	      }
	
	      _this.setState({
	        questions: _this.state.all_questions_state[i]
	      });
	      var next_question_id = _this.state.all_questions_state[i].id;
	      var path = _AppRoutes2.default.CFA3_BEGIN_NOTES.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i);
	      _this.context.router.push({
	        pathname: path,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      // console.log('Working');
	
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveNotesstats = function (item, e) {
	      if (_this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        notes_id: item.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            save_question: 'btn btn-success pointer_class margin_right_10'
	          });
	          _this.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	          _this.setState({ markColor: 'green' });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getSavedNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getFavNotes', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(all_questions, e) {
	        var url, response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                url = _App_data2.default.backend_api + '/cfa3_notes/getpdfnotes?id=' + all_questions.id;
	                _context2.next = 3;
	                return (0, _axios2.default)({
	                  url: url,
	                  method: 'GET',
	                  responseType: 'blob'
	                });
	
	              case 3:
	                response = _context2.sent;
	
	                (0, _fileSaver.saveAs)(response.data, all_questions.name + '.pdf');
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavNotes = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/unsaveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/saveFavNotesByUserID', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	            isFlashCardHidden: false
	          });
	        } else {
	          _this.setState({ ValidToken: false, isFlashCardHidden: true });
	        }
	        return resp;
	      });
	    };
	
	    _this.state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      chapter_id: _this.props.params.chapter_no,
	      reading_id: _this.props.params.readingid,
	      ValidToken: false,
	      offset: 0,
	      limit: 1,
	      reportLoading: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      isFlashCardHidden: true,
	      text_color: 'card-header',
	      records: '',
	      save_question: 'btn btn-primary pointer_class margin_right_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: '' + _language2.default.LC().MARK_AS_READ,
	      saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      display_loader: '',
	      markColor: '',
	      showCustomerly: false,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  //Function to redirect page to readings page
	
	
	  //Function to fetch Next question
	
	
	  //Function to fetch previous question
	
	
	  //Function to show Report box
	
	
	  //Function to hide Report box
	
	
	  //Funcion to save new report question
	
	
	  //Function to toggle Comment box
	
	
	  //Function to toggle Flash box
	
	
	  //Function to save notes and display Marked on button
	
	
	  //Function to Save flash Card And display new stored flash card
	
	
	  //Function to Edit Flash card
	
	
	  //Function to delete flash card
	
	
	  _createClass(Cfanotesbeginchapters, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context4.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                window.scroll(0, 0);
	                if (!this.props.params.id) {
	                  this.setState({ previ_block: 'card hide_block' });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.props.params.notesid
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getReadings', data).then(function (resp) {
	                  var getReading = resp.readings.filter(function (item) {
	                    return item.id === parseInt(_this3.props.params.readingid);
	                  })[0];
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: getReading.reading
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes_allcr', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var ques_res, offset_res, i, params;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context3.next = 21;
	                              break;
	                            }
	
	                            _this3.setState({ ValidToken: true });
	                            _this3.setState({ all_questions_state: resp.questions });
	                            ques_res = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this3.props.params.id) {
	                                ques_res = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i === resp.questions.length - 1) {
	                                _this3.setState({ display_loader: 'hide_block' });
	                              }
	                            }
	                            _this3.setState({ questions: ques_res });
	                            //console.log(ques_res);
	                            _this3.setState({ offset: offset_res });
	                            _this3.setState({ question_length: resp.questions.length });
	
	                            if (offset_res === 0) {
	                              _this3.setState({ previ_block: 'card hide_block' });
	                            }
	                            //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this3.setState({ next_block: 'card hide_block' });
	                            }
	
	                            _context3.next = 13;
	                            return _this3.getSavedNotes(ques_res.id);
	
	                          case 13:
	                            params = {
	                              token: _this3.state.token,
	                              question_id: ques_res.id,
	                              idname: _this3.state.idname
	                            };
	                            _context3.next = 16;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getsavestatesNotes', params).then(function (response) {
	                              if (response.success) {
	                                // console.log("enter");
	
	                                _this3.setState({
	                                  save_question: 'btn btn-success pointer_class margin_right_10'
	                                });
	                                _this3.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	                                _this3.setState({ markColor: 'green' });
	                              } else {
	                                // console.log("enter else");
	                                setTimeout(_this3.notes_MARKED_AS_READ.bind(_this3, params), 6000);
	                              }
	                              // console.log("respomse", response);
	                            });
	
	                          case 16:
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	
	                            _this3.setState({ records: '' });
	                            _context3.next = 23;
	                            break;
	
	                          case 21:
	                            _this3.setState({ ValidToken: false });
	                            _this3.setState({ records: 'Result not found.' });
	
	                          case 23:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 13:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'notes_MARKED_AS_READ',
	    value: function notes_MARKED_AS_READ(params) {
	      var _this4 = this;
	
	      // const result = getDeviceDetails();
	      // console.log("params", params);
	      var data = {
	        token: params.token,
	        idname: params.idname,
	        notes_id: params.question_id,
	        city: this.state.user_city,
	        country: this.state.user_country,
	        state: this.state.user_state,
	        continent: this.state.user_continent,
	        ip: this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/saveNotesstats', data).then(function (resp) {
	        // console.log("re",resp);
	
	        if (resp.success) {
	          _this4.setState({ ValidToken: true });
	          _this4.setState({
	            save_question: 'btn btn-success pointer_class margin_right_10'
	          });
	          _this4.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	          _this4.setState({ markColor: 'green' });
	        } else {
	          _this4.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, this.state.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes_allcr', data).then(function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	          var ques_res, i, params;
	          return _regenerator2.default.wrap(function _callee5$(_context5) {
	            while (1) {
	              switch (_context5.prev = _context5.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context5.next = 14;
	                    break;
	                  }
	
	                  _this5.setState({ ValidToken: true });
	                  ques_res = [];
	
	                  for (i = 0; i < resp.questions.length; i++) {
	                    if (resp.questions[i].id == _this5.props.params.id) {
	                      ques_res = resp.questions[i];
	                    }
	                  }
	                  _this5.setState({ questions: ques_res });
	                  _this5.setState({ display_loader: 'hide_block' });
	                  params = {
	                    token: _this5.state.token,
	                    question_id: ques_res.id,
	                    idname: _this5.state.idname
	                  };
	                  _context5.next = 9;
	                  return _this5.getSavedNotes(ques_res.id);
	
	                case 9:
	                  _context5.next = 11;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getsavestatesNotes', params).then(function (response) {
	                    if (response.success) {
	                      _this5.setState({
	                        save_question: 'btn btn-success pointer_class margin_right_10'
	                      });
	                      _this5.setState({ save_text: '' + _language2.default.LC().MARKED_AS_READ });
	                      _this5.setState({ markColor: 'green' });
	                    } else {
	                      _this5.setState({ markColor: '#ddd' });
	                      // console.log("work");
	                      setTimeout(_this5.notes_MARKED_AS_READ.bind(_this5, params), 6000);
	                      //
	                    }
	                  });
	
	                case 11:
	                  _this5.setState({ records: '' });
	                  _context5.next = 16;
	                  break;
	
	                case 14:
	                  _this5.setState({ ValidToken: false });
	                  _this5.setState({ records: '' + _language2.default.LC().Result_not_found });
	
	                case 16:
	                case 'end':
	                  return _context5.stop();
	              }
	            }
	          }, _callee5, _this5);
	        }));
	
	        return function (_x5) {
	          return _ref5.apply(this, arguments);
	        };
	      }());
	    }
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var data = '';
	
	      var retun_all_question = JSON.stringify(questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 note-section special_notes_view' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card note-section-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size sticky-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                className: 'margin_right_10',
	                alt: '',
	                width: '21'
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, "span", "notes-head-color", { contentEditable: "false" }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'notes-head-color' },
	                '(',
	                _language2.default.LC().N,
	                ' ',
	                all_questions.id,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right sticky-navigate' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'note-text-wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row overflow-x-auto' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_20' },
	                    (0, _function.renderHTMLContent)(all_questions.description, "div", "note_text_wrap", { contentEditable: "false" })
	                  ),
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default
	                  // _getResult={this._getResult}
	                  , { isQue: false,
	                    saveNotes_text: this.state.saveNotes_text,
	                    markColor: this.state.markColor,
	                    _saveQuestion: this._saveFavNotes,
	                    _saveNotesstats: this._saveNotesstats,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: all_questions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, all_questions)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, all_questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'notes',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'cfa3'
	          })
	        );
	      } else {
	        /* data = <div className="col-sm-12 col-md-12">
	               <div className="no_data_bar card">No Records Found</div>
	          </div>;*/
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row note-section notes_inner_title_wrap' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head title-font-size' },
	                _language2.default.LC().NOTES
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getNotes
	                },
	                _language2.default.LC().CHANGE_NOTES
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_READING
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfanotesbeginchapters;
	}(_react.Component);
	
	Cfanotesbeginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfanotesbeginchapters;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _questionNotFoundModel = __webpack_require__(104);
	
	var _questionNotFoundModel2 = _interopRequireDefault(_questionNotFoundModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfa3notesreadings = function (_Component) {
	  _inherits(Cfa3notesreadings, _Component);
	
	  function Cfa3notesreadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Cfa3notesreadings);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3notesreadings.__proto__ || Object.getPrototypeOf(Cfa3notesreadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '' + _AppRoutes2.default.CFA3_NOTES,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      // console.log(reading.reading);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: ('' + _AppRoutes2.default.CFA3_NOTES_VIEWQUES).replace(':chapter_no', reading.chapter_no).replace(':id', reading.id).replace(':reading', reading.reading),
	              state: {
	                reading: reading,
	                chapter: _this.state.chapterid
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: ('' + _AppRoutes2.default.CFA3_BEGIN_NOTES).replace(':notesid', reading.chapter_no).replace(':readingid', reading.id).replace(':id', resp.questions[0].id).replace(':chapter', _this.props.params.chapter).replace(':chapter_no', reading.chapter_no).replace(':offset', 0)
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(_this.state.pdfLoading === false)) {
	                  _context4.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context4.abrupt('return');
	
	              case 3:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context4.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context3.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData, dataset;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context.next = 18;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context.next = 7;
	                                        return _Cfa3Subscription4.default.checkCfa3PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context.sent;
	
	                                        if (!isInArray_var) {
	                                          _context.next = 15;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context.next = 13;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 13:
	                                        _context.next = 16;
	                                        break;
	
	                                      case 15:
	                                        _this.toggleAlert();
	
	                                      case 16:
	                                        _context.next = 18;
	                                        break;
	
	                                      case 18:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context3.next = 21;
	                            break;
	
	                          case 12:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context3.next = 16;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context3.next = 21;
	                            break;
	
	                          case 16:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 21;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _Cfa3Subscription2.default.checkCfa3PDFSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (!isInArray_var) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 21:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.chapter,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      chapterName: '',
	      showFreePremium: true,
	      selectedmenu: 'cfa_3',
	      type: 'notes',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      pdfLoading: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      alert_status_question_not_found: false,
	      MessageTitleOnQuestionNotFound: '' + _language2.default.LC().NOTES,
	      MessageContentOnQuestionNotFound: '' + _language2.default.LC().NOTE_NOT_FOUND,
	      subscriptionstatus: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Cfa3notesreadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      // console.log('this.state.subscriptionstatus ', this.state.showFreePremium);
	      if (this.state.showFreePremium) {
	        this.setState({
	          alert_status: !this.state.alert_status
	        });
	      } else {
	        this.setState({
	          alert_status_question_not_found: !this.state.alert_status_question_not_found
	        });
	      }
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to cfanotes page
	
	
	    //Function to redirect page to notesviewquestion  page
	
	
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context6.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context6.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter: this.state.chapterid
	                };
	                // console.log('I am here -----> ');
	
	                _context6.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this3.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
	                    }
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 10:
	                // var data = { token: this.state.token, idname: this.state.idname };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	                _userStore2.default.getUserProfile(true).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context5.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context5.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context5.next = 10;
	                            break;
	
	                          case 5:
	                            _this3.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                var isInArray_var = false;
	                                var examPlanData = resp_exam.examPlan[0];
	                                isInArray_var = _Cfa3Subscription4.default.checkCfa3PDFSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, _this3.state.type, examPlanData);
	                                if (isInArray_var) {
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 10:
	                            _context5.next = 22;
	                            break;
	
	                          case 12:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context5.next = 16;
	                              break;
	                            }
	
	                            // console.log('hello in set state');
	                            _this3.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context5.next = 22;
	                            break;
	
	                          case 16:
	                            console.log('enter');
	
	                            _this3.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            // console.log('dsarafaygdu', data_arr);
	
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 22;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              // console.log(resp_exam);
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa3Subscription2.default.checkCfa3PDFSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam, _this3.state.type);
	                                console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 22:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this3);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '' + _AppRoutes2.default.SUBSCRIBE,
	        state: {
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	    --------------------
	    PDF DOWNLOAD VIA EMAIL
	    --------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading_order,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: _this4._getQuestions.bind(_this4, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this4._beginChapter.bind(_this4, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_NOTES_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.chapterName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 notes-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Notes : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CHAPTER_READINGS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().READING
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_questionNotFoundModel2.default, {
	          alert_status: this.state.alert_status_question_not_found,
	          toggleAlert: this.toggleAlert,
	          MessageTitle: this.state.MessageTitleOnQuestionNotFound,
	          MessageContent: this.state.MessageContentOnQuestionNotFound
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Cfa3notesreadings;
	}(_react.Component);
	
	Cfa3notesreadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Cfa3notesreadings;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1005);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _toast = __webpack_require__(15);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Cfavideodisplay = function (_Component) {
	  _inherits(Cfavideodisplay, _Component);
	
	  function Cfavideodisplay(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, Cfavideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (Cfavideodisplay.__proto__ || Object.getPrototypeOf(Cfavideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/trackUserVideowatch', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      // console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment,
	        videoIndex: _this.state.currentUrl,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          // FD.callAPI(
	          //   App_data.backend_api + '/cfa3_videos/videoGetFlashCards',
	          //   params
	          // ).then((response) => {
	          //   if (response.success) {
	          //     this.setState({ ValidToken: true });
	          //     if (response.flash_cards.length > 0) {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	          //       });
	          //       var flash_cards = response.flash_cards.map((items) => (
	          //         <li key={items.id}>
	          //           <div className=''>
	          //             <ul className='icon_list'>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._editFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-pencil' />
	          //                 </a>
	          //               </li>
	          //               <li>
	          //                 <a
	          //                   className='pointer_class'
	          //                   onClick={this._deleteFlash.bind(this, items)}
	          //                 >
	          //                   <i className='fa fa-close' />
	          //                 </a>
	          //               </li>
	          //             </ul>
	          //             <div className={this.state.flash_class}>
	          //               <h4 />
	          //               <p>{items.flash_card}</p>
	          //             </div>
	          //           </div>
	          //         </li>
	          //       ));
	          //     } else {
	          //       this.setState({
	          //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //       });
	          //       var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     }
	          //     this.setState({ flash_data: flash_cards });
	          //   } else {
	          //     var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	          //     this.setState({ ValidToken: false });
	          //     this.setState({ flash_data: flash_cards });
	          //     this.setState({
	          //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	          //     });
	          //   }
	          //   return response;
	          // });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      var path = _AppRoutes2.default.CFA3_VIDEO_LESSONS;
	      _this.context.router.push({
	        pathname: path,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.moveToNotes = function (reading, e) {
	      var final_exam = [];
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var, storage_session, _data;
	
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context2.next = 6;
	                        return _Cfa3Subscription4.default.checkCfa3NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	
	                        if (isInArray_var) {
	                          storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                          if (storage_session) {
	                            _data = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              reading_id: _this.state.currentReadingNo,
	                              chapter_id: _this.state.currentChapterNo,
	                              offset: 0,
	                              limit: 10
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes', _data).then(function (resp) {
	                              // console.log(resp);
	                              if (resp.success) {
	                                console.log('resp.questions ---------------> ', resp.questions, resp.questions.length);
	                                if (resp.questions.length) {
	                                  var path = _AppRoutes2.default.CFA3_NOTES_VIEWQUES.replace(':chapter_no', _this.state.currentChapterNo).replace(':id', _this.state.currentReadingNo).replace(':reading', _this.state.currentReadingTitle);
	                                  _this.context.router.push({
	                                    pathname: path,
	                                    state: {
	                                      token: _this.state.token,
	                                      idname: _this.state.idname,
	                                      reading: {
	                                        id: _this.state.currentReadingNo,
	                                        chapter_no: _this.state.currentChapterNo,
	                                        reading: _this.state.currentReadingTitle,
	                                        chapter: _this.state.currentChapterNo
	                                      }
	                                    }
	                                  });
	                                } else {
	                                  (0, _toast.showFailure)('No Notes found');
	                                }
	                              } else {
	                                console.log('resp.fail');
	                              }
	                              return resp;
	                            });
	                          }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x3) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp);
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                // console.log(exam_data);
	                // console.log(selectedmen);
	                isInArray_var = _Cfa3Subscription2.default.checkCfa3NotesSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                  if (storage_session) {
	                    var _data2 = {
	                      idname: storage_session['idname'],
	                      token: storage_session['token'],
	                      reading_id: _this.state.currentReadingNo,
	                      chapter_id: _this.state.currentChapterNo,
	                      offset: 0,
	                      limit: 10
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_notes/getNotes', _data2).then(function (resp) {
	                      // console.log(resp);
	                      if (resp.success) {
	                        if (resp.questions.length) {
	                          var path = _AppRoutes2.default.CFA3_NOTES_VIEWQUES.replace(':chapter_no', _this.state.currentChapterNo).replace(':id', _this.state.currentReadingNo).replace(':reading', _this.state.currentReadingTitle);
	                          _this.context.router.push({
	                            pathname: path,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              reading: {
	                                id: _this.state.currentReadingNo,
	                                chapter_no: _this.state.currentChapterNo,
	                                reading: _this.state.currentReadingTitle,
	                                chapter: _this.state.currentChapterNo
	                              }
	                            }
	                          });
	                        } else {
	                          (0, _toast.showFailure)('No Notes found');
	                        }
	                      } else {
	                        console.log('resp.fail');
	                      }
	                      return resp;
	                    });
	                  }
	                } else {
	                  console.log('work');
	
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context3.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context3.next = 6;
	                        return _Cfa3Subscription4.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context3.sent;
	
	
	                        if (isInArray_var) {
	                          _this._runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context3.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this2);
	              }));
	
	              return function (_x4) {
	                return _ref3.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp);
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _Cfa3Subscription2.default.checkCfa3Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context4.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(index, url_id, title, id, url_id_qq, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context7.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file,
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	                  bookmarkColor: ''
	                }, function () {
	                  var path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                  _this.context.router.push({
	                    pathname: path
	                  });
	                });
	
	                _context7.next = 4;
	                return _this.savelastVideo(id, index);
	
	              case 4:
	                _context7.next = 6;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 6:
	                _context7.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context5.next = 6;
	                                  return _Cfa3Subscription4.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context5.sent;
	
	                                  if (!isInArray_var) {
	                                    _context5.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    var path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                                    _this.context.router.push({
	                                      pathname: path
	                                    });
	                                  });
	                                  _context5.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context5.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context5.abrupt('return');
	
	                                case 16:
	                                  return _context5.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context5.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this2);
	                        }));
	
	                        return function (_x13) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                      // console.log("if working");
	
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee6$(_context6) {
	                            while (1) {
	                              switch (_context6.prev = _context6.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context6.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context6.next = 6;
	                                  return _Cfa3Subscription2.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context6.sent;
	
	                                  if (!isInArray_var) {
	                                    _context6.next = 16;
	                                    break;
	                                  }
	
	                                  // console.log('IF WORKING')
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    var path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium ? 1 : 0).replace(':type', _this.props.params.type ? 1 : 0).replace(':chapter_id', _this.props.params.chapter_id ? _this.props.params.chapter_id : _this.props.params.id).replace(':index', _this.state.currentUrl);
	                                    _this.context.router.push({
	                                      pathname: path
	                                    });
	                                  });
	                                  _context6.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context6.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context6.abrupt('return');
	
	                                case 16:
	                                  return _context6.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context6.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context6.stop();
	                              }
	                            }
	                          }, _callee6, _this2);
	                        }));
	
	                        return function (_x14) {
	                          return _ref7.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(id, index) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context8.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x15, _x16) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      // console.log('_saveFavVideo', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/saveFavVideoByUserID', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            saveVideo_text: '' + _language2.default.LC().Video_Saved,
	            isFlashCardHidden: false
	          });
	        } else {
	          _this.setState({ ValidToken: false, isFlashCardHidden: true });
	        }
	        return resp;
	      });
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state3 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state3, 'MessageTitle', messageTitle_cfa), _defineProperty(_this$state3, 'MessageContent', _alertMessage2.default.messageContent_cfa_1), _defineProperty(_this$state3, 'token', ''), _defineProperty(_this$state3, 'idname', ''), _defineProperty(_this$state3, 'ValidToken', false), _defineProperty(_this$state3, 'isFlashCardHidden', true), _defineProperty(_this$state3, 'all_questions', ''), _defineProperty(_this$state3, 'chapters', []), _defineProperty(_this$state3, 'all_questions_state', []), _defineProperty(_this$state3, 'video_display', ''), _defineProperty(_this$state3, 'video_display_qq', ''), _defineProperty(_this$state3, 'url_id', ''), _defineProperty(_this$state3, 'currentUrl', ''), _defineProperty(_this$state3, 'reportLoading', false), _defineProperty(_this$state3, 'free', ''), _defineProperty(_this$state3, 'video_title', ''), _defineProperty(_this$state3, 'video_display_no', ''), _defineProperty(_this$state3, 'allChapters', []), _defineProperty(_this$state3, 'Chapter_Title', ''), _defineProperty(_this$state3, 'chapterName', ''), _defineProperty(_this$state3, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state3, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state3, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state3, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state3, 'currentReading', _this.props.params.id), _defineProperty(_this$state3, 'comment_update_id', ''), _defineProperty(_this$state3, 'currentChapterNo', ''), _defineProperty(_this$state3, 'currentReadingNo', ''), _defineProperty(_this$state3, 'currentReadingTitle', ''), _defineProperty(_this$state3, 'subscriptionstatus', ''), _defineProperty(_this$state3, 'selectedmenu', 'cfa_3'), _defineProperty(_this$state3, 'subscription_details_for_isActive', ''), _defineProperty(_this$state3, 'pdfData', []), _defineProperty(_this$state3, 'pdf_file', ''), _defineProperty(_this$state3, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state3, 'userType', ''), _defineProperty(_this$state3, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state3, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state3, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state3, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state3, 'bookmarkColor', ''), _defineProperty(_this$state3, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_VIDEO_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _this$state3);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(Cfavideodisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
	      // const result = getDeviceDetails();
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	      var path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium ? 1 : 0).replace(':type', this.props.params.type ? 1 : 0).replace(':chapter_id', this.props.params.chapter_id ? this.props.params.chapter_id : this.props.params.id).replace(':index', this.state.currentUrl + 1);
	      this.context.router.push({
	        pathname: path
	      });
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	        bookmarkColor: ''
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        // if (this.state.currentUrl || this.state.currentUrl) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa3Subscription4.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("_goToPreviousReading-tooogle");
	              return _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa3Subscription2.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    // console.log('IF WORKING')
	                    // console.log("_goToPreviousReading Premium");
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      // console.log('currentUrl', this.state.currentUrl);
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	        bookmarkColor: ''
	      });
	      var path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium ? 1 : 0).replace(':type', this.props.params.type ? 1 : 0).replace(':chapter_id', this.props.params.chapter_id ? this.props.params.chapter_id : this.props.params.id).replace(':index', this.state.currentUrl + 1);
	      this.context.router.push({
	        pathname: path
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context9.next = 16;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this4.state.selectedmenu;
	                          isInArray_var = false;
	                          _context9.next = 6;
	                          return _Cfa3Subscription4.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                        case 6:
	                          isInArray_var = _context9.sent;
	
	                          if (!isInArray_var) {
	                            _context9.next = 13;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({
	                              video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                            });
	                            _this4.setState({
	                              video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                            });
	                            _this4.setState({
	                              video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                            });
	                            _this4.setState({
	                              currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                            });
	                            _this4.setState({
	                              currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                            });
	                            _this4.setState({
	                              currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                            });
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context9.abrupt('return');
	
	                        case 13:
	                          return _context9.abrupt('return', _this4.toggleAlert());
	
	                        case 14:
	                          _context9.next = 17;
	                          break;
	
	                        case 16:
	                          console.log('fail');
	
	                        case 17:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this4);
	                }));
	
	                return function (_x17) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("working");
	              // console.log("_goToNextReading toggleAlert");
	
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _Cfa3Subscription2.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    // console.log("_goToNextReading Premium");
	
	                    // console.log('IF WORKING')
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getQuestions', data).then(function (resp) {
	        // console.log("resp");
	        // console.log(resp);
	        // console.log("resp");
	        // console.log(resp.questions.length);
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: '/cfa3/cases/' + _this5.state.currentChapterNo + '/' + _this5.state.currentReadingTitle,
	              state: {
	                token: _this5.state.token,
	                idname: _this5.state.idname,
	                reading: {
	                  id: _this5.state.currentReadingNo,
	                  chapter_no: _this5.state.currentChapterNo,
	                  reading: _this5.state.currentReadingTitle
	                },
	                subscriptionstatus: _this5.state.subscriptionstatus
	              }
	            });
	          } else {
	            _this5.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(prevProps, prevState) {
	        var params;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context10.next = 5;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context10.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/cfa3_videos/videoGetFlashCards',
	                //   params
	                // ).then((response) => {
	                //   var flash_cards = '';
	                //   if (response.success) {
	                //     this.setState({ ValidToken: true });
	                //     if (response.flash_cards.length > 0) {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                //       });
	                //       flash_cards = response.flash_cards.map((items, index) => (
	                //         <li key={index}>
	                //           <div className=''>
	                //             <ul className='icon_list'>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._editFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-pencil' />
	                //                 </a>
	                //               </li>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._deleteFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-close' />
	                //                 </a>
	                //               </li>
	                //             </ul>
	                //             <div className={this.state.flash_class}>
	                //               <h4 />
	                //               <p>{items.flash_card}</p>
	                //             </div>
	                //           </div>
	                //         </li>
	                //       ));
	                //     } else {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //       });
	                //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     }
	                //     this.setState({ flash_data: flash_cards });
	                //   } else {
	                //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     this.setState({ ValidToken: false });
	                //     this.setState({ flash_data: flash_cards });
	                //     this.setState({
	                //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //     });
	                //   }
	                // });
	
	              case 5:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function componentDidUpdate(_x18, _x19) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this6 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context12.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                // console.log('this.props ----> ', this.props);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  // console.log('IF Working');
	                  this.setState({
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id || this.props.params.id
	                };
	                _context12.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getvideosChapterwise', data).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context11.next = 28;
	                              break;
	                            }
	
	                            _context11.next = 3;
	                            return _this6.setState({ ValidToken: true });
	
	                          case 3:
	                            _context11.next = 5;
	                            return _this6.setState({ chapters: resp.cfavchapter });
	
	                          case 5:
	                            _context11.next = 7;
	                            return _this6.setState({
	                              pdf_file: _this6.state.chapters[_this6.state.currentUrl] ? _this6.state.chapters[_this6.state.currentUrl].pdf_file : null
	                            });
	
	                          case 7:
	                            console.log(_this6.state.chapters, '===> ', _this6.state.currentUrl, _this6.state.chapters[_this6.state.currentUrl.id]);
	                            _context11.next = 10;
	                            return _this6.setState({
	                              currentReading: _this6.state.chapters[_this6.state.currentUrl].id
	                            });
	
	                          case 10:
	                            _context11.next = 12;
	                            return _this6.setState({
	                              video_display: _this6.state.chapters[_this6.state.currentUrl].url_id
	                            });
	
	                          case 12:
	                            _context11.next = 14;
	                            return _this6.setState({
	                              video_display_qq: _this6.state.chapters[_this6.state.currentUrl].url_id_qq
	                            });
	
	                          case 14:
	                            _context11.next = 16;
	                            return _this6.setState({
	                              video_display_previous: _this6.state.chapters[_this6.state.currentUrl].url_id
	                            });
	
	                          case 16:
	                            _context11.next = 18;
	                            return _this6.setState({
	                              video_title: _this6.state.chapters[_this6.state.currentUrl].title
	                            });
	
	                          case 18:
	                            _context11.next = 20;
	                            return _this6.setState({
	                              video_display_next: _this6.state.chapters[_this6.state.currentUrl + 1] ? _this6.state.chapters[_this6.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 20:
	                            _context11.next = 22;
	                            return _this6.setState({
	                              currentChapterNo: _this6.state.chapters[_this6.state.currentUrl].chapter_id
	                            });
	
	                          case 22:
	                            _context11.next = 24;
	                            return _this6.setState({
	                              currentReadingNo: _this6.state.chapters[_this6.state.currentUrl].reading_no
	                            });
	
	                          case 24:
	                            _context11.next = 26;
	                            return _this6.setState({
	                              currentReadingTitle: _this6.state.chapters[_this6.state.currentUrl].title
	                            });
	
	                          case 26:
	                            _context11.next = 29;
	                            break;
	
	                          case 28:
	                            _this6.setState({ ValidToken: false });
	
	                          case 29:
	                            return _context11.abrupt('return', resp);
	
	                          case 30:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this6);
	                  }));
	
	                  return function (_x20) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context12.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(first);
	                    _this6.setState({ ValidToken: true });
	                    _this6.setState({ allChapters: resp.videos });
	                    _this6.props.params.chapter_id === undefined ? null : resp.videos.map(function (element) {
	                      if (element.id == _this6.props.params.chapter_id) {
	                        _this6.setState({
	                          Chapter_Title: element.chapter_name
	                        });
	                      }
	                    });
	                  } else {
	                    _this6.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 16:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context12.next = 19;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 19:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/cfa3_videos/videoGetFlashCards',
	                //   params
	                // ).then((response) => {
	                //   var flash_cards = '';
	                //   if (response.success) {
	                //     this.setState({ ValidToken: true });
	                //     if (response.flash_cards.length > 0) {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
	                //       });
	                //       flash_cards = response.flash_cards.map((items, index) => (
	                //         <li key={index}>
	                //           <div className=''>
	                //             <ul className='icon_list'>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._editFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-pencil' />
	                //                 </a>
	                //               </li>
	                //               <li>
	                //                 <a
	                //                   className='pointer_class'
	                //                   onClick={this._deleteFlash.bind(this, items)}
	                //                 >
	                //                   <i className='fa fa-close' />
	                //                 </a>
	                //               </li>
	                //             </ul>
	                //             <div className={this.state.flash_class}>
	                //               <h4 />
	                //               <p>{items.flash_card}</p>
	                //             </div>
	                //           </div>
	                //         </li>
	                //       ));
	                //     } else {
	                //       this.setState({
	                //         flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //       });
	                //       flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     }
	                //     this.setState({ flash_data: flash_cards });
	                //   } else {
	                //     flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
	                //     this.setState({ ValidToken: false });
	                //     this.setState({ flash_data: flash_cards });
	                //     this.setState({
	                //       flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	                //     });
	                //   }
	                // });
	
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context12.next = 23;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getcfa_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this6.setState({ pdfData: resp });
	                  } else {
	                    _this6.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 23:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          type = _state.type,
	          currentReading = _state.currentReading,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	
	      var chapters = this.state.chapters;
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this7.state.showFreePremium ? item.free === 1 || type === 'intro' ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id === _this7.state.video_display ? 'active' : '',
	                    onClick: _this7.getVideourl.bind(_this7, index, item.url_id, item.title, item.id, item.url_id_qq, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8 mb-1' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'mb-0' },
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        width: '100%',
	                        allowFullScreen: '1',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + this.state.video_display_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef',
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        frameBorder: '0',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportIcons2.default, {
	              moveToNotes: this.moveToNotes,
	              notesCSS: '',
	              moveToPracticeQuestions: this.moveToPracticeQuestions,
	              _saveFavVideo: this._saveFavVideo,
	              _displayReportForm: this._displayReportForm,
	              pdfOpen: this.pdfOpen,
	              bookmarkCSS: this.state.bookmarkCSS,
	              bookmarkColor: this.state.bookmarkColor,
	              type: this.state.type,
	              questionsCSS: this.state.questionsCSS,
	              saveVideo_text: this.state.saveVideo_text,
	              currentReading: this.state.currentReading,
	              chapters: this.state.chapters,
	              showFreePremium: this.state.showFreePremium,
	              noPDFInExam: this.state.pdf_file ? false : true,
	              reportVideoTooltip: _language2.default.LC().REPORT_VIDEO_TOOLTIP_MESSAGE
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: currentReading },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'cfa3'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT,
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfavideodisplay;
	}(_react.Component);
	
	Cfavideodisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.resizeListener = function () {
	      // write code here
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	    };
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13() {
	        var _this9 = this;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context13.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this9.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, this);
	      }));
	
	      function componentDidMount() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Cfavideodisplay;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Cfa3Subscription = __webpack_require__(44);
	
	var _Cfa3Subscription2 = _interopRequireDefault(_Cfa3Subscription);
	
	var _Cfa3Subscription3 = __webpack_require__(45);
	
	var _Cfa3Subscription4 = _interopRequireDefault(_Cfa3Subscription3);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1006);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var VideoLessons = function (_Component) {
	  _inherits(VideoLessons, _Component);
	
	  function VideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, VideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (VideoLessons.__proto__ || Object.getPrototypeOf(VideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank/getcfavideosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.VIDEO_DISPLAY.replace(':id', resp.cfavchapterfirst.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.cfavchapterfirst.chapter_id).replace(':index', 0)
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt, path;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              // console.log('last video caseIndex -----> ', lastRecord);
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', lastRecord.cfa3_video.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', lastRecord.cfa3_video.chapter_id === 0 ? 0 : 1).replace(':chapter_id', lastRecord.cfa3_video.chapter_id).replace(':index', lastRecord.caseIndex);
	
	                _this.context.router.push({
	                  pathname: path,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.cfa3_video,
	                    index: lastRecord.videoIndex,
	                    showFreePremium: _this.state.showFreePremium
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_3,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'cfa_3',
	      exams: [],
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      lastAttempt: false,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(VideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _Cfa3Subscription4.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this3);
	                              }));
	
	                              return function (_x5) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context6.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context6.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                // console.log('selectedmen ------> ', selectedmen);
	                                var isInArray_var = false;
	
	                                isInArray_var = _Cfa3Subscription2.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    // console.log(resp.exams[0])
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ chapters: resp.videos });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 11:
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getlastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 14:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      //console.log(language.LC())
	      //console.log(this.state.showFreePremium);
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      // console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  ' ',
	                  index + 1,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement(
	                  'h1',
	                  { className: 'text-danger font-weight-bold text-center' },
	                  _language2.default.LC().COMING_SOON + '....'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement('div', { className: 'card' })
	                  ),
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent,
	            exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	          })
	        )
	      );
	    }
	  }]);
	
	  return VideoLessons;
	}(_react.Component);
	
	VideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	var ChatperwiseReadingData = function (_Component2) {
	  _inherits(ChatperwiseReadingData, _Component2);
	
	  function ChatperwiseReadingData(props) {
	    var _this6 = this,
	        _this5$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this5 = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this5.toggleAlert = function () {
	      _this5.setState({
	        alert_status: !_this5.state.alert_status
	      });
	    };
	
	    _this5.goPremium = function () {
	      _this5.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this5.state.token,
	          idname: _this5.state.idname,
	          selectedMenu: _this5.state.selectedmenu
	        }
	      });
	    };
	
	    _this5._getReadings = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.next = 2;
	                return _this5.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this5.state.token,
	                    idname: _this5.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this5.state.user_city,
	                    country: _this5.state.user_country,
	                    state: _this5.state.user_state,
	                    continent: _this5.state.user_continent,
	                    ip: _this5.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/trackUserVideowatch', data).then(function () {
	                    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                      var path;
	                      return _regenerator2.default.wrap(function _callee8$(_context8) {
	                        while (1) {
	                          switch (_context8.prev = _context8.next) {
	                            case 0:
	                              if (resp.success) {
	                                path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index);
	
	                                _this5.context.router.push({
	                                  pathname: path,
	                                  state: {
	                                    token: _this5.state.token,
	                                    idname: _this5.state.idname,
	                                    chapter: chapter,
	                                    index: index,
	                                    showFreePremium: _this5.state.showFreePremium
	                                  }
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context8.stop();
	                          }
	                        }
	                      }, _callee8, _this6);
	                    }));
	
	                    return function (_x8) {
	                      return _ref9.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _data = { token: _this5.state.token, idname: _this5.state.idname };
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      // console.log('I am here -----------> ', resp.profileInfo);
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this5.toggleAlert();
	                      } else {
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data2;
	
	                            return _regenerator2.default.wrap(function _callee10$(_context10) {
	                              while (1) {
	                                switch (_context10.prev = _context10.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context10.next = 10;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this5.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context10.next = 6;
	                                    return _Cfa3Subscription4.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                  case 6:
	                                    isInArray_var = _context10.sent;
	
	
	                                    if (isInArray_var) {
	                                      _data2 = {
	                                        token: _this5.state.token,
	                                        idname: _this5.state.idname,
	                                        id: chapter.id,
	                                        videoIndex: index,
	                                        city: _this5.state.user_city,
	                                        country: _this5.state.user_country,
	                                        state: _this5.state.user_state,
	                                        continent: _this5.state.user_continent,
	                                        ip: _this5.state.user_ip
	                                      };
	
	                                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/trackUserVideowatch', _data2).then(function () {
	                                        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                                          var path;
	                                          return _regenerator2.default.wrap(function _callee9$(_context9) {
	                                            while (1) {
	                                              switch (_context9.prev = _context9.next) {
	                                                case 0:
	                                                  if (resp.success) {
	                                                    path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index);
	
	                                                    _this5.context.router.push({
	                                                      pathname: path,
	                                                      state: {
	                                                        token: _this5.state.token,
	                                                        idname: _this5.state.idname,
	                                                        chapter: chapter,
	                                                        index: index,
	                                                        showFreePremium: _this5.state.showFreePremium
	                                                      }
	                                                    });
	                                                  } else {}
	
	                                                case 1:
	                                                case 'end':
	                                                  return _context9.stop();
	                                              }
	                                            }
	                                          }, _callee9, _this6);
	                                        }));
	
	                                        return function (_x10) {
	                                          return _ref11.apply(this, arguments);
	                                        };
	                                      }());
	                                    } else {
	                                      _this5.toggleAlert();
	                                    }
	                                    _context10.next = 10;
	                                    break;
	
	                                  case 10:
	                                  case 'end':
	                                    return _context10.stop();
	                                }
	                              }
	                            }, _callee10, _this6);
	                          }));
	
	                          return function (_x9) {
	                            return _ref10.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      // console.log('I am here -----------> ', resp.profileInfo);
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                        // console.log('I am here 692');
	                        return _this5.toggleAlert();
	                      } else {
	                        // console.log('I am here 695');
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	                        // console.log('else working');
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data3;
	
	                            return _regenerator2.default.wrap(function _callee12$(_context12) {
	                              while (1) {
	                                switch (_context12.prev = _context12.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context12.next = 13;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this5.state.selectedmenu;
	                                    isInArray_var = false;
	
	                                    isInArray_var = _Cfa3Subscription2.default.checkCfa3VideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    // console.log(isInArray_var);
	
	                                    if (!isInArray_var) {
	                                      _context12.next = 10;
	                                      break;
	                                    }
	
	                                    // console.log('IF WORKING')
	
	                                    _data3 = {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      id: chapter.id,
	                                      videoIndex: index,
	                                      city: _this5.state.user_city,
	                                      country: _this5.state.user_country,
	                                      state: _this5.state.user_state,
	                                      continent: _this5.state.user_continent,
	                                      ip: _this5.state.user_ip
	                                    };
	
	                                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/trackUserVideowatch', _data3).then(function () {
	                                      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                                        var path;
	                                        return _regenerator2.default.wrap(function _callee11$(_context11) {
	                                          while (1) {
	                                            switch (_context11.prev = _context11.next) {
	                                              case 0:
	                                                if (resp.success) {
	                                                  path = _AppRoutes2.default.CFA3_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this5.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index);
	
	                                                  _this5.context.router.push({
	                                                    pathname: path,
	                                                    state: {
	                                                      token: _this5.state.token,
	                                                      idname: _this5.state.idname,
	                                                      chapter: chapter,
	                                                      index: index,
	                                                      showFreePremium: _this5.state.showFreePremium
	                                                    }
	                                                  });
	                                                } else {}
	
	                                              case 1:
	                                              case 'end':
	                                                return _context11.stop();
	                                            }
	                                          }
	                                        }, _callee11, _this6);
	                                      }));
	
	                                      return function (_x12) {
	                                        return _ref13.apply(this, arguments);
	                                      };
	                                    }());
	                                    _context12.next = 11;
	                                    break;
	
	                                  case 10:
	                                    return _context12.abrupt('return', _this5.toggleAlert());
	
	                                  case 11:
	                                    _context12.next = 13;
	                                    break;
	
	                                  case 13:
	                                  case 'end':
	                                    return _context12.stop();
	                                }
	                              }
	                            }, _callee12, _this6);
	                          }));
	
	                          return function (_x11) {
	                            return _ref12.apply(this, arguments);
	                          };
	                        }()
	                        // console.log('fail');
	                        );
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this6);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this5.savelastVideo = function () {
	      var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(chapter, index) {
	        var _this5$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _this5$state = _this5.state, token = _this5$state.token, idname = _this5$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  caseIndex: index
	                };
	                _context14.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this6);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref14.apply(this, arguments);
	      };
	    }();
	
	    _this5.iframe = {
	      padding: 10
	    };
	
	    _this5.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	      if (_this5.state.allchapters.length) {
	        data = _this5.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          var count = 0;
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this5.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              width: '100%',
	              src: item.posterImage ? item.posterImage : 'https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1.jpg',
	              onError: function onError(_ref15) {
	                var currentTarget = _ref15.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	
	                  currentTarget.onerror = null; // prevents looping
	
	                  currentTarget.src = '\n                    https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1_2.jpg';
	                }
	              },
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row',
	              alt: 'flow player image'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row',
	              alt: 'youtube image'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this5.state = (_this5$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_3,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this5$state2, 'offset', 0), _defineProperty(_this5$state2, 'limit', 10), _defineProperty(_this5$state2, 'Allchapters', []), _defineProperty(_this5$state2, 'itemData', []), _defineProperty(_this5$state2, 'videoUrl', ''), _defineProperty(_this5$state2, 'srcUrl', ''), _defineProperty(_this5$state2, 'srcUrl_final', ''), _defineProperty(_this5$state2, 'selectedmenu', 'cfa_3'), _defineProperty(_this5$state2, 'showFreePremium', true), _defineProperty(_this5$state2, 'user_city', ''), _defineProperty(_this5$state2, 'user_country', ''), _defineProperty(_this5$state2, 'user_ip', ''), _defineProperty(_this5$state2, 'user_state', ''), _defineProperty(_this5$state2, 'user_continent', ''), _this5$state2);
	    return _this5;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	        var _this7 = this;
	
	        var result, storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _context15.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context15.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.id
	                };
	                _context15.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa3_videos/getvideosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this7.setState({ allchapters: [] });
	                    _this7.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, this);
	      }));
	
	      function componentDidMount() {
	        return _ref16.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      //console.log(this.state.showFreePremium);
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.CFA_LEVEL_3
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = VideoLessons;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(122);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _analytics = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { IntercomAPI } from 'react-intercom';
	// import PaypalExpressBtn from 'react-paypal-express-checkout';
	// import StripeCheckout from 'react-stripe-checkout';
	// import { Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
	// import Cookies from 'universal-cookie';
	
	// import language from '../../assets/languages/language';
	
	// import GD from '../RestAPI/getData';
	// import { Elements, StripeProvider } from "react-stripe-elements";
	/* eslint-disable*/
	
	// import CheckoutForm from "./CheckoutForm";
	
	
	/* eslint-disable*/
	
	var Cart = function (_Component) {
	  _inherits(Cart, _Component);
	
	  function Cart(props) {
	    _classCallCheck(this, Cart);
	
	    var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      errorMessage: "",
	      cartItems: [],
	      showPromoCode: true,
	      couponInput: "",
	      isApplyingCoupon: false,
	      removingItemId: null,
	      removingExtraId: null
	    };
	
	    _this.loadUserCart = _this.loadUserCart.bind(_this);
	    _this.renderEmptyCart = _this.renderEmptyCart.bind(_this);
	    _this.applyCoupon = _this.applyCoupon.bind(_this);
	    _this.removeCoupon = _this.removeCoupon.bind(_this);
	    _this.onRemoveItem = _this.onRemoveItem.bind(_this);
	    _this.onRemoveExtra = _this.onRemoveExtra.bind(_this);
	    _this.renderPackageItem = _this.renderPackageItem.bind(_this);
	    _this.proceedToCheckout = _this.proceedToCheckout.bind(_this);
	    _this.getIntervalLabel = _this.getIntervalLabel.bind(_this);
	    // Idempotency guard so React strict-mode double-mount or rapid clicks
	    // can't fire begin_checkout twice for the same cart-state navigation.
	    _this._beginCheckoutFired = false;
	    return _this;
	  }
	
	  /**
	   * Navigate from /cart → /checkout. Fires begin_checkout / startPayment /
	   * InitiateCheckout conversion events along the way (was lost when this
	   * component was rewritten — see docs/integrations/conversion-tracking.md).
	   */
	
	
	  _createClass(Cart, [{
	    key: 'proceedToCheckout',
	    value: function proceedToCheckout() {
	      try {
	        if (!this._beginCheckoutFired) {
	          this._beginCheckoutFired = true;
	          var cartItems = this.state.cartItems;
	
	          var totals = this.getCartTotals();
	          var profile = _userStore2.default && _userStore2.default.profileInfo || {};
	          (0, _analytics.trackBeginCheckout)({
	            cartItems: cartItems,
	            total: totals && totals.total || 0,
	            paymentType: '',
	            userName: profile.username || '',
	            userEmail: profile.email || '',
	            source: _userStore2.default && _userStore2.default.landingSource || 'organic',
	            affiliateName: _userStore2.default && _userStore2.default.landingSourceName || null
	          });
	        }
	      } catch (e) {
	        // eslint-disable-next-line no-console
	        console.warn('Cart proceedToCheckout tracking failed:', e && e.message);
	      }
	      this.props.router.push('/checkout');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadUserCart();
	    }
	  }, {
	    key: 'loadUserCart',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ isLoading: true, errorMessage: "" });
	
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getUserCart").then(function (resp) {
	                  if (resp && resp.success) {
	                    _this2.setState({
	                      isLoading: false,
	                      errorMessage: "",
	                      cartItems: resp.user_cart,
	                      showPromoCode: resp.showPromoCode
	                    });
	                  } else {
	                    var msg = resp && resp.message ? resp.message : "Failed to load user cart";
	                    _this2.setState({ isLoading: false, errorMessage: msg, cartItems: [] });
	                    (0, _toast.showInformation)(msg);
	                  }
	                  return resp;
	                }).catch(function (err) {
	                  _this2.setState({ isLoading: false, errorMessage: "Error loading user cart", cartItems: [] });
	                  (0, _toast.showFailure)("Error loading user cart");
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadUserCart() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadUserCart;
	    }()
	  }, {
	    key: 'isUpgradeItem',
	    value: function isUpgradeItem(item) {
	      return item && item.type && String(item.type).startsWith("upgrade_");
	    }
	  }, {
	    key: 'getItemBasePrice',
	    value: function getItemBasePrice(item) {
	      var extraData = item.extraData || [];
	      var addonsTotal = 0;
	
	      for (var i = 0; i < extraData.length; i++) {
	        addonsTotal += extraData[i].price;
	      }
	
	      if (item.type === "unlessUnlimited") {
	        return addonsTotal;
	      }
	
	      if (this.isUpgradeItem(item)) {
	        var credit = Number(item.upgrade_credit) || 0;
	        return Math.max(0, item.planPrice + addonsTotal - credit);
	      }
	
	      return item.planPrice + addonsTotal;
	    }
	  }, {
	    key: 'getItemDiscountAmount',
	    value: function getItemDiscountAmount(item) {
	      if (!item || item.type !== "main") return 0;
	
	      var pct = item.percent_discount;
	      if (!(pct > 0)) return 0;
	
	      // Coupon applies only to the plan price, not to add-ons
	      var planPrice = Number(item.planPrice) || 0;
	      return planPrice * pct / 100;
	    }
	  }, {
	    key: 'getCartTotals',
	    value: function getCartTotals() {
	      var items = this.state.cartItems || [];
	      var subtotal = 0;
	      var discountTotal = 0;
	
	      for (var i = 0; i < items.length; i++) {
	        subtotal += this.getItemBasePrice(items[i]);
	        discountTotal += this.getItemDiscountAmount(items[i]);
	      }
	
	      var total = subtotal - discountTotal;
	      return { subtotal: subtotal, discountTotal: discountTotal, total: total };
	    }
	  }, {
	    key: 'anyCouponApplied',
	    value: function anyCouponApplied(items) {
	      if (!items || !items.length) return false;
	
	      for (var i = 0; i < items.length; i++) {
	        var code = items[i].coupon_code || "0";
	        var pct = items[i].percent_discount;
	        if (code !== "0" && pct > 0) return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'applyCoupon',
	    value: function applyCoupon() {
	      var _this3 = this;
	
	      var code = (this.state.couponInput || "").trim();
	      if (!code) return;
	
	      this.setState({ isApplyingCoupon: true });
	
	      return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/applyCouponNew", { code: code }).then(function (resp) {
	        if (resp && resp.success) {
	          (0, _toast.showInformation)(resp.message || "Coupon applied");
	          _this3.setState({ couponInput: "" });
	          return _this3.loadUserCart();
	        }
	
	        var msg = resp && resp.message ? resp.message : "Invalid coupon";
	        (0, _toast.showInformation)(msg);
	        return null;
	      }).catch(function () {
	        (0, _toast.showFailure)("Error applying coupon");
	      }).finally(function () {
	        _this3.setState({ isApplyingCoupon: false });
	      });
	    }
	  }, {
	    key: 'removeCoupon',
	    value: function removeCoupon() {
	      var _this4 = this;
	
	      var items = this.state.cartItems || [];
	      var ids = [];
	
	      for (var i = 0; i < items.length; i++) {
	        var id = items[i].id;
	        if (id > 0) ids.push(id);
	      }
	
	      if (!ids.length) return;
	
	      this.setState({ isApplyingCoupon: true });
	
	      return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/removeCoupon", { cartItemIds: ids }).then(function (resp) {
	        if (resp && resp.success) {
	          (0, _toast.showInformation)(resp.message || "Coupon removed");
	          return _this4.loadUserCart();
	        }
	        var msg = resp && resp.message ? resp.message : "Failed to remove coupon";
	        (0, _toast.showInformation)(msg);
	        return null;
	      }).catch(function () {
	        return (0, _toast.showFailure)("Error removing coupon");
	      }).finally(function () {
	        return _this4.setState({ isApplyingCoupon: false });
	      });
	    }
	  }, {
	    key: 'onRemoveItem',
	    value: function onRemoveItem(cartItemId) {
	      var _this5 = this;
	
	      if (!(cartItemId > 0)) return;
	
	      this.setState({ removingItemId: cartItemId });
	
	      return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/deleteItem", { item_id: cartItemId }).then(function (resp) {
	        if (resp && resp.success) return _this5.loadUserCart();
	        (0, _toast.showInformation)(resp && resp.message ? resp.message : "Failed to remove item");
	        return null;
	      }).catch(function () {
	        return (0, _toast.showFailure)("Error removing item");
	      }).finally(function () {
	        return _this5.setState({ removingItemId: null });
	      });
	    }
	  }, {
	    key: 'onRemoveExtra',
	    value: function onRemoveExtra(cartItemId, extraId) {
	      var _this6 = this;
	
	      if (!(cartItemId > 0) || !(extraId > 0)) return;
	
	      this.setState({ removingExtraId: extraId });
	
	      return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/removeExtra", {
	        item_id: cartItemId,
	        extra_id: extraId
	      }).then(function (resp) {
	        if (resp && resp.success) return _this6.loadUserCart();
	        (0, _toast.showInformation)(resp && resp.message ? resp.message : "Failed to remove addon");
	        return null;
	      }).catch(function () {
	        return (0, _toast.showFailure)("Error removing addon");
	      }).finally(function () {
	        return _this6.setState({ removingExtraId: null });
	      });
	    }
	  }, {
	    key: 'getGlobalCoupon',
	    value: function getGlobalCoupon(items) {
	      if (!items || !items.length) return { couponCode: "", discountPct: null };
	
	      for (var i = 0; i < items.length; i++) {
	        var code = items[i].coupon_code;
	        var pct = items[i].percent_discount;
	
	        if (code && code !== "0" && pct > 0) {
	          return {
	            couponCode: code,
	            discountPct: pct
	          };
	        }
	      }
	
	      return { couponCode: "", discountPct: null };
	    }
	  }, {
	    key: 'renderAddonOnlyItem',
	    value: function renderAddonOnlyItem(item) {
	      var _this7 = this;
	
	      var removingItemId = this.state.removingItemId;
	      var base = this.getItemBasePrice(item);
	      var disc = this.getItemDiscountAmount(item);
	      var finalPrice = base - disc;
	      var examName = item.examName || null;
	      var abbr = examName ? examName.substring(0, 3).toUpperCase() : null;
	
	      return _react2.default.createElement(
	        'div',
	        { key: item.id, className: 'ct_item_block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ct_item_row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ct_item_left' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_card_header_icon sb_icon_not_purchased' },
	              _react2.default.createElement(
	                'span',
	                { className: 'sb_header_icon_text sb_icon_text_not_purchased' },
	                abbr
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_item_title_box' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ct_item_title' },
	                  examName,
	                  ' (',
	                  item.package_type,
	                  ')'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_addon_badge' },
	                  'ADD-ON'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_item_subtitle' },
	                abbr,
	                ' Exams'
	              )
	            )
	          )
	        ),
	        item.extraData && item.extraData.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'ct_addons_box' },
	          item.extraData.map(function (ex) {
	            var isInherited = !!ex.inherited;
	            return _react2.default.createElement(
	              'div',
	              { key: ex.id, className: "ct_addon_row" + (isInherited ? " ct_addon_row_inherited" : "") },
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_addon_name' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_addon_tree' },
	                  '\u2514'
	                ),
	                ex.title
	              ),
	              isInherited ? _react2.default.createElement(
	                'span',
	                { className: 'ct_addon_included_label' },
	                'included'
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'ct_addon_right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ct_item_price' },
	                  (0, _CommonUtils.formatMoney)(ex.price)
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: "ct_remove_btn" + (_this7.state.removingExtraId === ex.id ? " is_loading" : ""),
	                    onClick: function onClick() {
	                      return _this7.onRemoveExtra(item.id, ex.id);
	                    },
	                    title: 'Remove addon'
	                  },
	                  _react2.default.createElement('i', { className: 'ct_remove_btn_icon' })
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'getIntervalLabel',
	    value: function getIntervalLabel(item) {
	      // Return early if item is missing OR payment_interval is missing
	      if (!item || !item.payment_interval) return "";
	
	      var labels = {
	        day: "Daily",
	        week: "Weekly",
	        month: "Monthly",
	        year: "Yearly"
	      };
	
	      return labels[item.payment_interval.toLowerCase()] || "";
	    }
	  }, {
	    key: 'renderPackageItem',
	    value: function renderPackageItem(item) {
	      var _this8 = this;
	
	      var cartItems = this.state.cartItems;
	
	      var _getGlobalCoupon = this.getGlobalCoupon(cartItems),
	          couponCode = _getGlobalCoupon.couponCode,
	          discountPct = _getGlobalCoupon.discountPct;
	
	      var removingItemId = this.state.removingItemId;
	      var disc = this.getItemDiscountAmount(item);
	      var hasAddons = item.extraData && item.extraData.length > 0;
	      var examName = item.examName || null;
	      var abbr = examName ? examName.substring(0, 3).toUpperCase() : null;
	      var isUpgrade = this.isUpgradeItem(item);
	      var isUpgradeUnlimited = isUpgrade && item.type === 'upgrade_unlimited';
	      var upgradeBadgeClass = isUpgradeUnlimited ? "ct_addon_badge ct_upgrade_badge_green" : "ct_addon_badge ct_upgrade_badge";
	      // Show plan-only price (with discount if coupon, without addons)
	      var planPrice = Number(item.planPrice) || 0;
	      var originalPrice = item.originalPrice ? Number(item.originalPrice) : null;
	      var displayPrice = void 0;
	      if (isUpgrade) {
	        var credit = Number(item.upgrade_credit) || 0;
	        displayPrice = Math.max(0, planPrice - credit);
	      } else {
	        displayPrice = planPrice - disc;
	      }
	      var hasOriginalPrice = originalPrice !== null && originalPrice !== displayPrice;
	
	      return _react2.default.createElement(
	        'div',
	        { key: item.id, className: 'ct_item_block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ct_item_row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ct_item_left' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_card_header_icon sb_icon_not_purchased' },
	              _react2.default.createElement(
	                'span',
	                { className: 'sb_header_icon_text sb_icon_text_not_purchased' },
	                abbr
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_item_title_box ct_item_package_title' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'ct_item_title' },
	                  isUpgrade ? item.examName + " – Upgrade to " + item.package_type : item.examName
	                ),
	                !isUpgrade && _react2.default.createElement(
	                  'p',
	                  { className: 'ct_item_title' },
	                  '(',
	                  item.package_type,
	                  ')'
	                ),
	                this.getIntervalLabel(item) ? _react2.default.createElement(
	                  'span',
	                  { className: 'ct_item_interval_badge' },
	                  this.getIntervalLabel(item),
	                  ' '
	                ) : "",
	                isUpgrade && _react2.default.createElement(
	                  'span',
	                  { className: upgradeBadgeClass },
	                  'UPGRADE'
	                ),
	                !isUpgrade && discountPct > 0 && couponCode && _react2.default.createElement(
	                  'div',
	                  { className: 'ct_item_coupon_title' },
	                  'Coupon applied (-',
	                  discountPct,
	                  '%)'
	                )
	              ),
	              isUpgrade && item.upgradeFromPackageType ? _react2.default.createElement(
	                'div',
	                { className: 'ct_item_subtitle' },
	                'From: ',
	                item.upgradeFromPackageType
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'ct_item_subtitle' },
	                abbr,
	                ' Exams'
	              ),
	              this.getIntervalLabel(item) ? _react2.default.createElement(
	                'span',
	                { className: 'ct_item_interval_subtitle' },
	                'Renews ',
	                this.getIntervalLabel(item),
	                ' \xB7 cancel anytime'
	              ) : ""
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ct_item_right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ct_item_price' },
	              hasOriginalPrice && _react2.default.createElement(
	                'span',
	                { className: 'ct_item_price_original' },
	                (0, _CommonUtils.formatMoney)(originalPrice)
	              ),
	              (0, _CommonUtils.formatMoney)(displayPrice),
	              item.payment_interval ? _react2.default.createElement(
	                'span',
	                { className: 'ct_item_price_interval' },
	                '/',
	                item.payment_interval,
	                ' '
	              ) : ""
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: "ct_remove_btn" + (removingItemId === item.id ? " is_loading" : ""),
	                onClick: function onClick() {
	                  return _this8.onRemoveItem(item.id);
	                },
	                title: 'Remove'
	              },
	              _react2.default.createElement('i', { className: 'ct_remove_btn_icon' })
	            )
	          )
	        ),
	        hasAddons && _react2.default.createElement(
	          'div',
	          { className: 'ct_addons_box' },
	          item.extraData.map(function (ex) {
	            var isInherited = !!ex.inherited;
	            return _react2.default.createElement(
	              'div',
	              { key: ex.id, className: "ct_addon_row" + (isInherited ? " ct_addon_row_inherited" : "") },
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_addon_name' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_addon_tree' },
	                  '\u2514'
	                ),
	                ex.title,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_addon_badge' },
	                  'ADD-ON'
	                )
	              ),
	              isInherited ? _react2.default.createElement(
	                'span',
	                { className: 'ct_addon_included_label' },
	                'included'
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'ct_addon_right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ct_item_price' },
	                  (0, _CommonUtils.formatMoney)(Number(ex.price || 0))
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: "ct_remove_btn" + (_this8.state.removingExtraId === ex.id ? " is_loading" : ""),
	                    onClick: function onClick() {
	                      return _this8.onRemoveExtra(item.id, ex.id);
	                    },
	                    title: 'Remove addon'
	                  },
	                  _react2.default.createElement('i', { className: 'ct_remove_btn_icon' })
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var router = this.props.router;
	      var location = router.location;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ct_container_header' },
	        _react2.default.createElement(
	          'span',
	          {
	            className: "ct_shopping_btn " + (location.pathname.includes("/cart") ? "ct_is_btn_active" : ""),
	            onClick: function onClick() {
	              return router.push("/cart");
	            }
	          },
	          'Shopping cart'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'ct_header_icon_arrow' },
	          '\u2192'
	        ),
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'ct_checkout_btn ',
	            onClick: this.proceedToCheckout },
	          'Checkout'
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'ct_continue_btn', onClick: function onClick() {
	              return router.push("/subscribe");
	            } },
	          'CONTINUE SHOPPING'
	        )
	      );
	    }
	  }, {
	    key: 'renderEmptyCart',
	    value: function renderEmptyCart() {
	      var router = this.props.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ct_empty_box' },
	        _react2.default.createElement('span', { className: 'ct_empty_icon' }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'ct_empty_title' },
	          'Your cart is empty'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'ct_empty_subtitle' },
	          'Browse courses and add them to your cart.'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'ct_empty_browser_btn', onClick: function onClick() {
	              return router.push("/subscribe");
	            }, type: 'button' },
	          'Browse Courses'
	        )
	      );
	    }
	  }, {
	    key: 'renderCart',
	    value: function renderCart() {
	      var _this9 = this;
	
	      var _state = this.state,
	          cartItems = _state.cartItems,
	          showPromoCode = _state.showPromoCode,
	          couponInput = _state.couponInput,
	          isApplyingCoupon = _state.isApplyingCoupon;
	
	      var _getCartTotals = this.getCartTotals(),
	          subtotal = _getCartTotals.subtotal,
	          discountTotal = _getCartTotals.discountTotal,
	          total = _getCartTotals.total;
	
	      var _getGlobalCoupon2 = this.getGlobalCoupon(cartItems),
	          couponCode = _getGlobalCoupon2.couponCode,
	          discountPct = _getGlobalCoupon2.discountPct;
	
	      if (!cartItems || !cartItems.length) return this.renderEmptyCart();
	
	      var anyCouponApplied = this.anyCouponApplied(cartItems);
	      var isSubscriptionRegularMix = (0, _CommonUtils.hasSubscriptionRegularMix)(cartItems);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ct_cart_container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ct_items_list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ct_items_title' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'PRODUCT'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'UNIT PRICE'
	            )
	          ),
	          cartItems.map(function (item) {
	            if (item.type === "unlessUnlimited") {
	              return _this9.renderAddonOnlyItem(item);
	            }
	            return _this9.renderPackageItem(item);
	          })
	        ),
	        showPromoCode && function () {
	          // A monthly line cannot take a coupon: the subscription is billed
	          // from its Stripe price, so a cart discount would be shown and then
	          // not charged. `payment_interval` comes from exam_plans on the cart
	          // query — the same signal the server rejects on, so the UI and
	          // /applyCoupon cannot disagree.
	          var isRecurringItem = function isRecurringItem(i) {
	            return !!(i && i.payment_interval);
	          };
	          var couponableItems = cartItems.filter(function (i) {
	            return i.type === "main" && !isRecurringItem(i);
	          });
	          var hasMainItem = couponableItems.length > 0;
	          var hasOnlyNonCouponItems = !hasMainItem;
	
	          if (hasOnlyNonCouponItems && !anyCouponApplied) {
	            var hasUpgrade = cartItems.some(function (i) {
	              return _this9.isUpgradeItem(i);
	            });
	            var hasAddonOnly = cartItems.some(function (i) {
	              return i.type === "unlessUnlimited";
	            });
	            var hasRecurring = cartItems.some(function (i) {
	              return i.type === "main" && isRecurringItem(i);
	            });
	            var msg = "Coupon is not applicable";
	            if (hasRecurring) msg = "Discount codes cannot be applied to monthly plans";else if (hasUpgrade && !hasAddonOnly) msg = "Coupon is not applicable on upgrades";else if (!hasUpgrade && hasAddonOnly) msg = "Coupon is not applicable on extras";else if (hasUpgrade && hasAddonOnly) msg = "Coupon is not applicable on upgrades and extras";
	
	            return _react2.default.createElement(
	              'div',
	              { className: 'ct_coupon_box_container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_coupon_input_row' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_coupon_not_applicable' },
	                  msg
	                )
	              )
	            );
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'ct_coupon_box_container' },
	            anyCouponApplied ? _react2.default.createElement(
	              'div',
	              { className: 'ct_remove_coupon_container' },
	              _react2.default.createElement(
	                'p',
	                { className: 'ct_remove_title' },
	                'Remove coupon:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_remove_box' },
	                _react2.default.createElement('span', { className: 'ct_remove_label' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_remove_subtitle' },
	                  couponCode
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ct_remove_discount' },
	                  '(-',
	                  discountPct,
	                  '%)'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    'aria-label': 'Remove coupon ' + couponCode,
	                    className: 'ct_coupon_btn_remove',
	                    disabled: isApplyingCoupon,
	                    onClick: _this9.removeCoupon
	                  },
	                  _react2.default.createElement('span', { className: 'ct_remove_icon', 'aria-hidden': 'true' })
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'ct_coupon_input_row' },
	              _react2.default.createElement(
	                'span',
	                { className: 'ct_coupon_input_label' },
	                'Add coupon:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ct_coupon_input_col_inline' },
	                _react2.default.createElement('input', {
	                  className: 'packages_modal_input ct_coupon_input',
	                  placeholder: 'Type your coupon code',
	                  value: couponInput,
	                  onChange: function onChange(e) {
	                    return _this9.setState({ couponInput: e.target.value });
	                  },
	                  onKeyDown: function onKeyDown(e) {
	                    return e.key === "Enter" && _this9.applyCoupon();
	                  }
	                }),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'ct_coupon_btn_add', disabled: isApplyingCoupon,
	                    onClick: _this9.applyCoupon },
	                  isApplyingCoupon ? "Applying..." : "Apply coupon"
	                )
	              )
	            )
	          );
	        }(),
	        _react2.default.createElement(
	          'div',
	          { className: 'ct_summary_box' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'ct_summary_subtotal' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Subtotal:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _CommonUtils.formatMoney)(subtotal)
	              )
	            ),
	            discountTotal > 0 && _react2.default.createElement(
	              'div',
	              { className: 'ct_summary_discount' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Discount: (-',
	                discountPct,
	                '%)'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '-',
	                (0, _CommonUtils.formatMoney)(discountTotal)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ct_summary_total' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Total:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _CommonUtils.formatMoney)(total)
	              )
	            )
	          ),
	          isSubscriptionRegularMix && _react2.default.createElement(
	            'div',
	            { className: 'ct_summary_warning' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ct_summary_warning_title' },
	              'Subscription and regular products cannot be purchased together'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ct_summary_warning_text' },
	              'Your cart contains a subscription package (e.g. GMAT Focus) together with a regular product. Please check out the subscription separately from other items to proceed.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ct_summary_actions' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: "ct_btn_checkout" + (isSubscriptionRegularMix ? " ct_btn_disabled" : ""),
	                disabled: isSubscriptionRegularMix,
	                onClick: this.proceedToCheckout
	              },
	              'PROCEED TO CHECKOUT'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          isLoading = _state2.isLoading,
	          errorMessage = _state2.errorMessage,
	          cartItems = _state2.cartItems;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sb_page_container' },
	          errorMessage ? _react2.default.createElement(
	            'div',
	            { className: 'sb_error_message' },
	            errorMessage
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            this.renderHeader(),
	            !cartItems || cartItems.length === 0 ? this.renderEmptyCart() : this.renderCart()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cart;
	}(_react.Component);
	
	// IntercomAPI('trackEvent', 'view-cart-page');
	
	// class Cart extends Component { // old flow
	//   constructor(props) {
	//     super(props);
	//     this.state = {
	//       alert_status: false,
	//       MessageTitle: `${language.LC().ALERT}`,
	//       MessageContent: `${language.LC().ERROR}`,
	//       user_cart: [],
	//       token: '',
	//       idname: '',
	//       ValidToken: false,
	//       chapter_id: '',
	//       plan_data: '',
	//       pack_class: 'hide_block',
	//       exam_name: '',
	//       exam_class: 'row',
	//       total: 0,
	//       primary: false,
	//       checked: 'card',
	//       paypal_app_id: '',
	//       stripe_key: App_data.stripe_key,
	//       env: '',
	//       currency: '',
	//       checkout: 'submit_btn_lg pointer_class',
	//       cart_bottom: '',
	//       discount: 0,
	//       discount_exam_id: 0,
	//       discount_package_type: null,
	//       coupon_code: '',
	//       apply_coupon_code: '',
	//       coupon_wrapper_class: 'prmocode_wrap',
	//       coupon_status: '',
	//       coupon_status_css: '',
	//       tooltipOpen: false,
	//       tooltipval: `${language.LC().MAY_ENTER_COUPON}`,
	//       params: window.location.href,
	//       url: new URL(window.location.href),
	//       source: '',
	//       livemode: '',
	//       client_secret: '',
	//       amount: '',
	//       cartIds: [],
	//       user_city: '',
	//       user_country: '',
	//       user_ip: '',
	//       startLoaderModal: false,
	//       startLoaderPage: false,
	//       China_price: 6.55,
	//       canadian_price: 5.22,
	//       usd_canadian_price: 1.26,
	//       voidstate: '',
	//       landingSource: 'organic',
	//       landingSourceName: null,
	//       username: null,
	//       isLoading: true,
	//       showPromoCode: true,
	//     };
	//     this.togglePrimary = this.togglePrimary.bind(this);
	//     this.toggle = this.toggle.bind(this);
	//     // this.PaypalRecurring = this.PaypalRecurring.bind(this);
	//   }
	
	//   static contextTypes = {
	//     router: React.PropTypes.object,
	//   };
	
	//   toggle() {
	//     this.setState({
	//       tooltipOpen: !this.state.tooltipOpen,
	//     });
	//   }
	
	//   _addItem = () => {
	//     this.context.router.push({
	//       pathname: '/subscribe/',
	//       state: { token: this.state.token, idname: this.state.idname },
	//     });
	//   };
	
	//   /*
	//   --------------------------------------------------
	//     Function to redirect page to subscribe page
	//   -------------------------------------------------
	//   */
	//   _editItem = (item, e) => {
	//     this.context.router.push({
	//       pathname: '/subscribe/',
	//       state: {
	//         token: this.state.token,
	//         idname: this.state.idname,
	//         item_id: item.id,
	//       },
	//     });
	//   };
	
	//   /*
	//   -------------------------------
	//     Function to apply coupan
	//   -------------------------------
	//   */
	//   applyCoupon = () => {
	//     var coupon = document.getElementById('coupon').value;
	
	//     if (coupon == '') {
	//       this.setState({
	//         ValidToken: false,
	//         coupon_status_css: 'text-danger',
	//         coupon_status: 'Please enter coupon code.',
	//       });
	//       return;
	//     }
	
	//     if (
	//       this.state.user_cart &&
	//       this.state.user_cart.length === 1 &&
	//       this.state.user_cart[0].type === 'unlessUnlimited'
	//     ) {
	//       this.setState({
	//         ValidToken: false,
	//         coupon_status_css: 'text-danger',
	//         coupon_status: 'Coupon is not applicable on extras.',
	//       });
	//       return;
	//     }
	
	//     let i;
	//     var exam_id = [];
	//     for (i = 0; i < this.state.user_cart.length; i++) {
	//       exam_id.push(this.state.user_cart[i].exam_id);
	//     }
	//     this.setState({ isLoading: true });
	//     var data = {
	//       token: this.state.token,
	//       idname: this.state.idname,
	//       code: coupon,
	//       exam_id: exam_id,
	//     };
	//     FD.callAPI(App_data.backend_api + '/checkout_v1/applyCoupon', data).then((resp) => {
	//       if (resp != undefined && resp.success) {
	//         this.setState({
	//           ValidToken: true,
	//           coupon_status: resp.message,
	//           apply_coupon_code: coupon,
	//           coupon_status_css: 'text-success',
	//         });
	//         FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((cart_res) => {
	//           // console.log("cartcvuib", cart_res);
	//           this.setState({
	//             landingSource: cart_res.landingSource,
	//             landingSourceName: cart_res.landingSourceName,
	//             username: cart_res.username,
	//             showPromoCode: cart_res.showPromoCode,
	//           });
	//           if (cart_res.success) {
	//             this.setState({
	//               ValidToken: true,
	//               user_cart: cart_res.user_cart,
	//               isLoading: false,
	//             });
	//             if (cart_res.user_cart.length) {
	//               this.setState({
	//                 checkout: 'submit_btn_lg pointer_class',
	//                 cart_bottom: '',
	//               });
	//             } else {
	//               this.setState({
	//                 checkout: 'hide_block',
	//                 cart_bottom: 'hide_block',
	//               });
	//             }
	//           } else {
	//             this.setState({ ValidToken: false });
	//           }
	//         });
	//       } else {
	//         // console.log("ELSE IN COUPON");
	//         this.setState({
	//           coupon_status: resp.message,
	//           apply_coupon_code: coupon,
	//           coupon_status_css: 'text-danger',
	//           ValidToken: false,
	//         });
	//       }
	//       return resp;
	//     });
	//   };
	
	//   /*
	//   ------------------------------------
	//     Function for ALIPAY payment
	//   ------------------------------------
	//   */
	//   redirectToAlipay = () => {
	//     // console.log(this.state.amount);
	//     // console.log(
	//     // "this.state.amount",
	//     // this.state.amount * this.state.usd_canadian_price
	//     // );
	//     // console.log("this.state.usd_canadian_price", this.state.usd_canadian_price);
	
	//     // console.log(this.state.cartIds);
	//     this.setState({ startLoaderModal: true });
	//     var a = this.state.amount * this.state.usd_canadian_price;
	//     var data = {
	//       token: this.state.token,
	//       idname: this.state.idname,
	//       payment_type: 'ali-pay',
	//       amount: a.toFixed(2),
	//       userCart: this.state.user_cart,
	//       cartIds: this.state.cartIds,
	//     };
	//     FD.callAPI(App_data.backend_api + '/checkout_v1/addOrderAlipay', data).then(async (resp) => {
	//       if (resp.success) {
	//         // console.log(resp);
	//         this.setState({
	//           source: resp.source,
	//           startLoaderModal: false,
	//           isLoading: false,
	//         });
	//         window.location.replace(resp.source.redirect.url);
	//       } else {
	//         this.setState({ startLoaderModal: false });
	//         // console.log("Error!!");
	//       }
	//     });
	//   };
	
	//   //Funtion for ALIPAY check source payment
	//   //   redirectToAlipayAgain = () => {
	//   //     this.setState({ startLoaderPage: true });
	//   //     // console.log(this.state.amount);
	//   // // console.log("sourceeeeeee",this.state.source);
	//   // // console.log(" livemode: this.state.livemode,", this.state.livemode,);
	//   // // console.log(" client_secret: this.state.client_secret,", this.state.client_secret,);
	
	//   //     // console.log("working");
	//   //     var a = this.state.amount * this.state.usd_canadian_price;
	//   //     var data = {
	//   //       token: this.state.token,
	//   //       idname: this.state.idname,
	//   //       payment_type: "ali-pay",
	//   //       amount: a.toFixed(2),
	//   //       userCart: this.state.user_cart,
	//   //       cartIds: this.state.cartIds,
	//   //       source: this.state.source,
	//   //       livemode: this.state.livemode,
	//   //       client_secret: this.state.client_secret,
	//   //       user_city: this.state.user_city,
	//   //       user_ip: this.state.user_ip,
	//   //       user_country: this.state.user_country
	//   //     };
	
	//   //     FD.callAPI(
	//   //       App_data.backend_api + "/checkout_v1/addOrderAlipayAgain",
	//   //       data
	//   //     ).then(async resp => {
	//   //       // console.log(resp);
	//   //       if (resp.success) {
	//   //         // console.log(resp);
	//   //         if (resp.success) {
	//   //           var amount = resp.orders.amount;
	//   //           this.setState({ ValidToken: true });
	//   //           var order_val = this.state.user_cart;
	//   //           var all_order = [];
	//   //           var i = 0;
	//   //           var exam_selection = [];
	//   //           var exam_plans = [];
	//   //           Object.keys(order_val).map(function(key) {
	//   //             exam_selection.push(order_val[key].exam_id);
	//   //             exam_plans.push(order_val[key].plan_id);
	//   //             all_order[i] = {
	//   //               exam_id: order_val[key].exam_id,
	//   //               exam_name: order_val[key].exam_name,
	//   //               extras: order_val[key].extraData,
	//   //               package_type: order_val[key].package_type,
	//   //               percent_discount: order_val[key].percent_discount,
	//   //               plan_id: order_val[key].plan_id,
	//   //               price: order_val[key].price
	//   //             };
	//   //             i++;
	//   //           });
	//   //           var unique = exam_selection.filter(function(elem, index, self) {
	//   //             return index === self.indexOf(elem);
	//   //           });
	//   //           var storage_valueofExam = JSON.stringify(unique);
	//   //           var storage_valueofPlan = JSON.stringify(exam_plans);
	
	//   //           await FD.callAPI(
	//   //             App_data.backend_api + "/user/getProfileInfo",
	//   //             data
	//   //           ).then(async resp => {
	//   //             // console.log("resp");
	
	//   //             if (resp.success) {
	//   //               var examData = storage_valueofExam;
	//   //               if (resp.profileInfo.exam_selected !== "") {
	//   //                 var array1_new = JSON.parse(storage_valueofExam);
	//   //                 var array2_old = JSON.parse(resp.profileInfo.exam_selected);
	//   //                 var array3_store = array1_new.concat(array2_old);
	//   //                 var unique_exam = array3_store.filter(function(
	//   //                   elem,
	//   //                   index,
	//   //                   self
	//   //                 ) {
	//   //                   return index === self.indexOf(elem);
	//   //                 });
	//   //                 examData = JSON.stringify(unique_exam);
	//   //               }
	
	//   //               var packageData = storage_valueofPlan;
	//   //               if (resp.profileInfo.exam_package !== "") {
	//   //                 var array1_new = JSON.parse(storage_valueofPlan);
	//   //                 var array2_old = JSON.parse(resp.profileInfo.exam_package);
	//   //                 var array3_store = array1_new.concat(array2_old);
	//   //                 var unique_exam = array3_store.filter(function(
	//   //                   elem,
	//   //                   index,
	//   //                   self
	//   //                 ) {
	//   //                   return index === self.indexOf(elem);
	//   //                 });
	//   //                 packageData = JSON.stringify(unique_exam);
	//   //               }
	//   //               var examdata = {
	//   //                 token: this.state.token,
	//   //                 idname: this.state.idname,
	//   //                 storage_valueofExam: examData,
	//   //                 storage_valueofPlan: packageData,
	//   //                 user_cart: this.state.user_cart
	//   //               };
	//   //               await FD.callAPI(
	//   //                 App_data.backend_api + "/checkout_v1/updateOrderData",
	//   //                 examdata
	//   //               ).then(async resp_get => {
	//   //                 //console.log('selected exam inserted');
	//   //               });
	//   //             }
	//   //           });
	
	//   //           var full_order_details = {
	//   //             token: this.state.token,
	//   //             idname: this.state.idname,
	//   //             order_id: resp.orders.id,
	//   //             username: resp.username,
	//   //             userid: resp.userid,
	//   //             payment_type: "alipay",
	//   //             idname: this.state.idname,
	//   //             all_order_details: all_order,
	//   //             amount: amount
	//   //           };
	//   //           await FD.callAPI(
	//   //             App_data.backend_api + "/checkout_v1/updateOrder",
	//   //             full_order_details
	//   //           ).then(async resp => {
	//   //             if (resp.success) {
	//   //               //console.log('Mail Send Successfully');
	//   //             }
	//   //           });
	//   //           /*End Update order and send mail functionality*/
	//   //           var params = {
	//   //             token: this.state.token,
	//   //             idname: this.state.idname,
	//   //             cart_ids: this.state.cartIds,
	//   //             order_id: resp.orders.id
	//   //           };
	
	//   //           await FD.callAPI(
	//   //             App_data.backend_api + "/checkout_v1/updateCart",
	//   //             params
	//   //           ).then(response => {
	//   //             if (response.success) {
	//   //               this.context.router.push({
	//   //                 pathname: "/thankyou/",
	//   //                 state: {
	//   //                   token: this.state.token,
	//   //                   idname: this.state.idname,
	//   //                   order_id: resp.orders.id,
	//   //                   China_price: this.state.China_price,
	//   //                   canadian_price: this.state.canadian_price
	//   //                 }
	//   //               });
	//   //               window.location.reload();
	//   //             }
	//   //             return response;
	//   //           });
	//   //         }
	//   //       } else {
	//   //         this.setState({ startLoaderPage: false });
	//   //         console.log("Error!!");
	//   //         alert(resp.message);
	//   //       }
	//   //       return resp;
	//   //     });
	//   //   };
	
	//   /*
	//   --------------------------------------------
	//     Function for authenticate stripe payment
	//   -------------------------------------------
	//   */
	//   onToken = (amount, cart_ids, token) => {
	//     var data = {
	//       token: this.state.token,
	//       idname: this.state.idname,
	//       result: token,
	//       payment_type: 'stripe',
	//       amount: this.state.amount,
	//       userCart: this.state.user_cart,
	//       cartIds: this.state.cartIds,
	//     };
	
	//     var gtmData = {
	//       payment_type: 'card',
	//       amount: this.state.amount,
	//       userCart: this.state.user_cart,
	//     };
	//     let endpoint = '/checkout_v1/addOrder';
	//     const { user_cart: userCart } = this.state;
	//     const [first] = userCart;
	//     const { payment_interval } = first;
	//     if (userCart.length === 1 && payment_interval !== null && payment_interval !== undefined) {
	//       endpoint = '/checkout_v1/subscriptionBasedRecurringPayment';
	//       data.paymentInterval = payment_interval;
	//     }
	//     FD.callAPI(App_data.backend_api + endpoint, data).then(async (resp) => {
	//       if (resp.success) {
	//         await this.GTM_Trigger(gtmData);
	//         let subscriptionId = '';
	//         let current_period_end;
	//         if (resp.subscriptionId) {
	//           subscriptionId = resp.subscriptionId;
	//           current_period_end = resp.current_period_end;
	//         }
	//         var amount = resp.orders.amount;
	//         this.setState({ ValidToken: true });
	//         var order_val = this.state.user_cart;
	//         var all_order = [];
	//         var i = 0;
	//         var exam_selection = [];
	//         var exam_plans = [];
	//         Object.keys(order_val).map(function (key) {
	//           exam_selection.push(order_val[key].exam_id);
	//           exam_plans.push(order_val[key].plan_id);
	//           all_order[i] = {
	//             exam_id: order_val[key].exam_id,
	//             exam_name: order_val[key].exam_name,
	//             extras: order_val[key].extraData,
	//             package_type: order_val[key].package_type,
	//             percent_discount: order_val[key].percent_discount,
	//             plan_id: order_val[key].plan_id,
	//             price: order_val[key].price,
	//             discounted_price: Math.round(
	//               order_val[key].price - (order_val[key].price * order_val[key].percent_discount) / 100,
	//             ),
	//             type: order_val[key].type,
	//           };
	//           i++;
	//         });
	//         var unique = exam_selection.filter(function (elem, index, self) {
	//           return index === self.indexOf(elem);
	//         });
	//         var storage_valueofExam = JSON.stringify(unique);
	//         var storage_valueofPlan = JSON.stringify(exam_plans);
	//         // if (
	//         //   !(userCart.length === 1 && payment_interval !== null) &&
	//         //   payment_interval !== undefined
	//         // ) {
	//         await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async (resp) => {
	//           if (resp.success) {
	//             var examData = storage_valueofExam;
	//             if (resp.profileInfo.exam_selected !== '') {
	//               var array1_new = JSON.parse(storage_valueofExam);
	//               var array2_old = JSON.parse(resp.profileInfo.exam_selected);
	
	//               var array3_store = array1_new.concat(array2_old);
	//               var unique_exam = array3_store.filter(function (elem, index, self) {
	//                 return index === self.indexOf(elem);
	//               });
	//               examData = JSON.stringify(unique_exam);
	//             }
	
	//             var packageData = storage_valueofPlan;
	//             if (resp.profileInfo.exam_package !== '') {
	//               var array1_new = JSON.parse(storage_valueofPlan);
	//               var array2_old = JSON.parse(resp.profileInfo.exam_package);
	//               var array3_store = array1_new.concat(array2_old);
	//               var unique_exam = array3_store.filter(function (elem, index, self) {
	//                 return index === self.indexOf(elem);
	//               });
	//               packageData = JSON.stringify(unique_exam);
	//             }
	//             var examdata = {
	//               token: this.state.token,
	//               idname: this.state.idname,
	//               storage_valueofExam: examData,
	//               storage_valueofPlan: packageData,
	//               user_cart: this.state.user_cart,
	//               subscriptionId: subscriptionId,
	//               current_period_end: current_period_end,
	//             };
	//             await FD.callAPI(App_data.backend_api + '/checkout_v1/updateOrderData', examdata).then(
	//               async (resp_get) => {},
	//             );
	//           }
	//         });
	//         // }
	//         var full_order_details = {
	//           token: this.state.token,
	//           idname: this.state.idname,
	//           order_id: resp.orders.id,
	//           username: resp.username,
	//           userid: resp.userid,
	//           payment_type: 'stripe',
	//           idname: this.state.idname,
	//           all_order_details: all_order,
	//           amount: this.state.amount,
	//           subscriptionId: subscriptionId,
	//         };
	//         await FD.callAPI(
	//           App_data.backend_api + '/checkout_v1/updateOrder',
	//           full_order_details,
	//         ).then(async (resp) => {
	//           if (resp.success) {
	//           }
	//         });
	//         /*
	//         ------------------------------------------------
	//           End Update order and send mail functionality
	//         ------------------------------------------------
	//           */
	//         var params = {
	//           token: this.state.token,
	//           idname: this.state.idname,
	//           cart_ids: this.state.cartIds,
	//           order_id: resp.orders.id,
	//         };
	
	//         await FD.callAPI(App_data.backend_api + '/checkout_v1/updateCart', params).then(
	//           (response) => {
	//             if (response.success) {
	//               this.context.router.push({
	//                 pathname: `/thankyou/${resp.orders.id}`,
	//                 state: {
	//                   token: this.state.token,
	//                   idname: this.state.idname,
	//                   order_id: resp.orders.id,
	//                   China_price: this.state.China_price,
	//                   canadian_price: this.state.canadian_price,
	//                 },
	//               });
	//               // window.location.reload();
	//             }
	//             return response;
	//           },
	//         );
	//       } else {
	//         alert('Payment Failed.Please Try Again');
	//       }
	//       return resp;
	//     });
	//   };
	
	//   /*
	//   -----------------------------------------------------------------
	//     For GTM trigger it's fired when a package is added to the cart
	//   ------------------------------------------------------------------
	//   */
	//   GTM_Trigger = (data) => {
	//     const { landingSourceName, landingSource, idname, username } = this.state;
	//     var array = [];
	//     for (let i = 0; i < data.userCart.length; i++) {
	//       let extraPrice = data.userCart[i].price;
	//       if (data.userCart[i].extraData && data.userCart[i].extraData.length) {
	//         for (let e = 0; e < data.userCart[i].extraData.length; e++) {
	//           extraPrice += data.userCart[i].extraData[e].price;
	//         }
	//       }
	//       array.push({
	//         exam: data.userCart[i].exam_name,
	//         packageType: data.userCart[i].package_type,
	//         price: extraPrice,
	//       });
	//     }
	//     const tagManagerArgs = {
	//       gtmId: GTM_ID,
	//       dataLayer: {
	//         event: GTMStartPayment,
	//         eventOptions: {
	//           paymentOption: data.payment_type,
	//           cart: array,
	//           cartTotal: data.amount,
	//         },
	//         userName: username,
	//         userEmail: idname,
	//         source: landingSource,
	//         affiliateName: landingSourceName,
	//         currency: Currency,
	//         value: data.amount ? data.amount : 1,
	//         price: data.amount,
	//         currency: Currency,
	//         value: data.amount ? data.amount : 1,
	//       },
	//     };
	//     TagManager.initialize(tagManagerArgs);
	
	//     // *************** For GA4 begin_checkout event ****************** //
	//     const tagManagerArgsGA4 = {
	//       gtmId: GTM_ID,
	//       dataLayer: {
	//         event: GA4BeginCheckout,
	//         currency: Currency,
	//         value: data.amount ? data.amount : 1,
	//         items: array,
	//         userName: username,
	//         userEmail: idname,
	//         source: landingSource,
	//       },
	//     };
	//     TagManager.initialize(tagManagerArgsGA4);
	//   };
	
	//   /*
	// --------------------------------------------------
	//   Toggle to display alert for Pick Your Payment
	// --------------------------------------------------
	// */
	//   togglePrimary() {
	//     this.setState({
	//       primary: !this.state.primary,
	//     });
	//   }
	
	//   /*
	//   -----------------------------------
	//     Function to delete Cart Item
	//   -----------------------------------
	//   */
	//   _deleteItem = (item, e) => {
	//     var data = {
	//       token: this.state.token,
	//       idname: this.state.idname,
	//       item_id: item.id,
	//       user_id: item.user_id,
	//       plan_id: item.plan_id,
	//     };
	//     this.setState({ isLoading: true });
	//     FD.callAPI(App_data.backend_api + '/checkout_v1/deleteItem', data).then((resp) => {
	//       if (resp.success) {
	//         this.setState({ ValidToken: true });
	//         FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((response) => {
	//           this.setState({
	//             landingSource: response.landingSource,
	//             landingSourceName: response.landingSourceName,
	//             username: response.username,
	//             showPromoCode: response.showPromoCode,
	//           });
	//           if (response.success) {
	//             this.setAmount(response.user_cart);
	//             this.setState({
	//               ValidToken: true,
	//               user_cart: response.user_cart,
	//             });
	//             if (response.user_cart.length) {
	//               this.setState({
	//                 coupon_wrapper_class: 'prmocode_wrap',
	//                 checkout: 'submit_btn_lg pointer_class',
	//                 cart_bottom: '',
	//               });
	//               // window.location.reload();
	//             } else {
	//               this.setState({
	//                 coupon_wrapper_class: 'prmocode_wrap hide_block',
	//                 checkout: 'hide_block',
	//                 cart_bottom: 'hide_block',
	//               });
	//               // window.location.reload();
	//             }
	//             this.props.setIsChildChangedTrue();
	//           } else {
	//             this.setState({ ValidToken: false });
	//           }
	//           return response;
	//         });
	//       } else {
	//         this.setState({ ValidToken: false });
	//       }
	//       return resp;
	//     });
	//   };
	
	//   /*
	// ---------------------------------------------
	//   Function to get today USD to Yuan price
	// ---------------------------------------------
	//   */
	//   getChinaPrice = () => {
	//     GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then((resp) => {
	//       this.setState({
	//         China_price: resp.rates.CNY,
	//         usd_canadian_price: resp.rates.CAD,
	//       });
	//     });
	//     GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=CAD').then((resp) => {
	//       this.setState({
	//         canadian_price: resp.rates.CNY,
	//       });
	//     });
	//   };
	//   async componentDidUpdate(prevProps, prevState) {
	//     if (
	//       prevState.coupon_status !== this.state.coupon_status ||
	//       prevState.apply_coupon_code !== this.state.apply_coupon_code
	//     ) {
	//       // this.getChinaPrice();
	
	//       // console.log("componentDidUpdate Working");
	//       var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	//       this.setState({
	//         idname: storage_session['idname'],
	//         token: storage_session['token'],
	//       });
	//       var data = {
	//         token: storage_session['token'],
	//         idname: storage_session['idname'],
	//         coupon_status: this.state.coupon_status,
	//       };
	//       /*
	//     ------------------------------
	//       Api to fetch Cart Details
	//     ------------------------------
	//       */
	
	//       this.setState({ isLoading: true });
	//       await FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((resp) => {
	//         if (resp.success) {
	//           this.setState({
	//             landingSource: resp.landingSource,
	//             landingSourceName: resp.landingSourceName,
	//             username: resp.username,
	//             isLoading: false,
	//             showPromoCode: resp.showPromoCode,
	//           });
	//           // console.log("response" + resp.user_cart);
	//           this.setState({ ValidToken: true });
	//           if (resp.user_cart.length) {
	//             this.setState({
	//               user_cart: resp.user_cart,
	//               checkout: 'submit_btn_lg pointer_class',
	//               cart_bottom: '',
	//               coupon_wrapper_class: 'prmocode_wrap',
	//             });
	//           } else {
	//             this.setState({
	//               user_cart: resp.user_cart,
	//               checkout: 'hide_block',
	//               cart_bottom: 'hide_block',
	//               coupon_wrapper_class: 'prmocode_wrap hide_block',
	//             });
	//           }
	//         } else {
	//           this.setState({ ValidToken: false });
	//         }
	//         return resp;
	//       });
	
	//       {
	//         let plan = this.state.user_cart;
	//         var total_price = 0;
	//         var new_total = 0;
	//         var cart_ids = [];
	//         var i = 0;
	//         const cookies = new Cookies();
	//         var cookie_data = cookies.get('coupon_data');
	//         Object.keys(plan).map(function (key) {
	//           if (plan[key].type !== 'unlessUnlimited') {
	//             total_price = total_price + plan[key].price;
	//           }
	
	//           cart_ids[i] = plan[key].id;
	//           if (plan[key].coupon_code) {
	//             if (plan[key].type !== 'unlessUnlimited') {
	//               new_total += Math.round(
	//                 plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
	//               );
	//             }
	
	//             if (plan[key].extraData) {
	//               var extraData = plan[key].extraData;
	//               Object.keys(extraData).map(function (key) {
	//                 var price = extraData[key].price;
	//                 new_total += price;
	//               });
	//             }
	//           } else {
	//             if (plan[key].type !== 'unlessUnlimited') {
	//               new_total += plan[key].price;
	//             }
	
	//             if (plan[key].extraData) {
	//               Object.keys(plan[key].extraData).map(function (key) {
	//                 var price = plan[key].extraData.price;
	//                 new_total += price;
	//               });
	//             }
	//           }
	//           i++;
	//         });
	//         this.setState({ amount: new_total, cartIds: cart_ids }, () => {
	//           // console.log(this.state.amount);
	//           // console.log(this.state.cartIds);
	//         });
	//       }
	//     }
	//   }
	
	//   async componentDidMount() {
	//     // console.log("didmount", typeof this.state.stripe_key);
	//     GD.GetCallAPI('https://geolocation-db.com/json/').then((resp) => {
	//       // console.log("resp");
	//       this.setState({
	//         user_city: resp.city,
	//         user_country: resp.country_name,
	//         user_ip: resp.IPv4,
	//       });
	//     });
	
	//     const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	//     this.setState({
	//       idname: storage_session['idname'],
	//       token: storage_session['token'],
	//     });
	
	//     var data = {
	//       token: storage_session['token'],
	//       idname: storage_session['idname'],
	//     };
	
	//     /*
	//     ------------------------------
	//       Api to fetch Cart Details
	//     ------------------------------
	//     */
	//     await FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((resp) => {
	//       if (resp.success) {
	//         // console.log("response", resp.user_cart);
	//         this.setState({
	//           landingSource: resp.landingSource,
	//           landingSourceName: resp.landingSourceName,
	//           username: resp.username,
	//           isLoading: false,
	//           showPromoCode: resp.showPromoCode,
	//         });
	//         if (resp.user_cart.length) {
	//           this.setState({
	//             ValidToken: true,
	//             user_cart: resp.user_cart,
	//             checkout: 'submit_btn_lg pointer_class',
	//             cart_bottom: '',
	//             coupon_wrapper_class: 'prmocode_wrap',
	//           });
	//         } else {
	//           this.setState({
	//             ValidToken: true,
	//             user_cart: resp.user_cart,
	//             checkout: 'hide_block',
	//             cart_bottom: 'hide_block',
	//             coupon_wrapper_class: 'prmocode_wrap hide_block',
	//           });
	//         }
	//       } else {
	//         this.setState({ ValidToken: false });
	//       }
	//       return resp;
	//     });
	
	//     {
	//       let plan = this.state.user_cart;
	//       var total_price = 0;
	//       var new_total = 0;
	//       var cart_ids = [];
	//       var i = 0;
	//       const cookies = new Cookies();
	//       var cookie_data = cookies.get('coupon_data');
	//       Object.keys(plan).map(function (key) {
	//         if (plan[key].type !== 'unlessUnlimited') {
	//           total_price = total_price + plan[key].price;
	//         }
	
	//         cart_ids[i] = plan[key].id;
	//         if (plan[key].coupon_code) {
	//           if (plan[key].type !== 'unlessUnlimited') {
	//             new_total += Math.round(
	//               plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
	//             );
	//           }
	
	//           if (plan[key].extraData) {
	//             var extraData = plan[key].extraData;
	//             Object.keys(extraData).map(function (key) {
	//               var price = extraData[key].price;
	//               new_total += price;
	//             });
	//           }
	//         } else {
	//           if (plan[key].type !== 'unlessUnlimited') {
	//             new_total += plan[key].price;
	//           }
	//           if (plan[key].extraData) {
	//             Object.keys(plan[key].extraData).map(function (key) {
	//               var price = plan[key].extraData.price;
	//               new_total += price;
	//             });
	//           }
	//         }
	//         i++;
	//       });
	//       this.setState({ amount: new_total, cartIds: cart_ids }, () => {});
	//     }
	
	//     await FD.callAPI(App_data.backend_api + '/checkout_v1/getPaymentCred', data).then(
	//       (response) => {
	//         if (response.success) {
	//           this.setState({
	//             ValidToken: true,
	//             paypal_app_id: response.paypal_app_id,
	//             stripe_key: response.stripe_key,
	//             currency: response.currency,
	//             env: response.env,
	//           });
	//         } else {
	//           this.setState({ ValidToken: false });
	//         }
	//         return response;
	//       },
	//     );
	
	//     // this.setState(
	//     //   {
	//     //     voidstate: this.state.url.searchParams.get("token")
	//     //   },
	//     //   () => {
	//     //     this.state.voidstate ? this.PaypalRecurringAgain() : null;
	//     //   }
	//     // );
	//   }
	
	//   // PaypalRecurring = async () => {
	//   //   console.log("this.state ", this.state.voidstate);
	//   //   console.log("PaypalRecurring");
	
	//   //   var data = {
	//   //     token: this.state.token,
	//   //     idname: this.state.idname,
	//   //     amount: this.state.amount,
	//   //     currency: this.state.currency
	//   //   };
	
	//   //   /*Api to fetch Cart Details*/
	//   //   await FD.callAPI(
	//   //     App_data.backend_api + "/checkout_v1/payPalRecurring",
	//   //     data
	//   //   ).then(resp => {
	//   //     console.log("paypal recurring", resp);
	//   //     if (resp.success) {
	//   //       const url = resp.url;
	//   //       console.log("response", url);
	//   //       if (url) {
	//   //         <a
	//   //           href={{ url }}
	//   //           target="_blank"
	//   //           rel="noopener noreferrer"
	//   //         />;
	//   //         // var myWindow = window.open(url);
	//   //         // myWindow.focus();
	//   //       }
	//   //       console.log("response");
	//   //       console.log(
	//   //         "this.state.url.searchParams.get",
	//   //         this.state.url.searchParams.get("token")
	//   //       );
	//   //     }
	//   //   });
	//   // };
	
	//   // PaypalRecurringAgain = async () => {
	//   //   const token = this.state.token;
	//   //   const idname = this.state.idname;
	//   //   const payPaltoken = this.state.voidstate;
	
	//   //   GD.GetCallAPI(
	//   //     `${
	//   //       App_data.backend_api
	//   //     }/checkout_v1/payPalRecurringCheck?payPaltoken=${payPaltoken}&idname=${idname}&token=${token}`
	//   //   ).then(resp => {
	//   //     console.log("resunfnvd", resp);
	//   //   });
	//   // };
	
	//   setAmount = (plan) => {
	//     var total_price = 0;
	//     var new_total = 0;
	//     var cart_ids = [];
	//     var i = 0;
	//     const cookies = new Cookies();
	//     var cookie_data = cookies.get('coupon_data');
	//     Object.keys(plan).map(function (key) {
	//       if (plan[key].type !== 'unlessUnlimited') {
	//         total_price = total_price + plan[key].price;
	//       }
	
	//       cart_ids[i] = plan[key].id;
	//       if (plan[key].coupon_code) {
	//         if (plan[key].type !== 'unlessUnlimited') {
	//           new_total += Math.round(
	//             plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
	//           );
	//         }
	
	//         if (plan[key].extraData) {
	//           var extraData = plan[key].extraData;
	//           Object.keys(extraData).map(function (key) {
	//             var price = extraData[key].price;
	//             new_total += price;
	//           });
	//         }
	//       } else {
	//         if (plan[key].type !== 'unlessUnlimited') {
	//           new_total += plan[key].price;
	//         }
	//         if (plan[key].extraData) {
	//           Object.keys(plan[key].extraData).map(function (key) {
	//             var price = plan[key].extraData.price;
	//             new_total += price;
	//           });
	//         }
	//       }
	//       i++;
	//     });
	//     this.setState({ amount: new_total, cartIds: cart_ids, isLoading: false });
	//   };
	
	//   render() {
	//     var domainApp = localStorage.getItem('domainApp');
	//     let plan = this.state.user_cart;
	//     let data = '';
	//     var i = 0;
	//     const cookies = new Cookies();
	//     var total_price = 0;
	//     var cart_ids = [];
	//     var discount = 0;
	//     var cookie_data = cookies.get('coupon_data');
	//     var new_total = 0;
	
	//     Object.keys(plan).map(function (key) {
	//       total_price = total_price + plan[key].price;
	//       cart_ids[i] = plan[key].id;
	//       if (plan[key].coupon_code) {
	//         new_total += Math.round(
	//           plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
	//         );
	//         if (plan[key].extraData) {
	//           var extraData = plan[key].extraData;
	//           Object.keys(extraData).map(function (key) {
	//             var price = extraData[key].price;
	//             new_total += price;
	//           });
	//         }
	//       } else {
	//         new_total += plan[key].price;
	//         if (plan[key].extraData) {
	//           Object.keys(plan[key].extraData).map(function (key) {
	//             var price = plan[key].extraData.price;
	//             new_total += price;
	//           });
	//         }
	//       }
	//       i++;
	//     });
	
	//     // console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", new_total);
	
	//     const styles_css = {
	//       marginBottom: '20px',
	//     };
	
	//     let env = this.state.env; // you can set here to 'production' for production
	//     let currency = this.state.currency; // or you can set this value from your props or state
	
	//     const client = {
	//       // sandbox: this.state.paypal_app_id
	//       production: this.state.paypal_app_id,
	//     };
	
	//     /*
	//     ----------------------------
	//         FOR PAYPAL PAYMENT
	//     ---------------------------
	//     */
	
	//     const handlePaypalPaymentSuccess = (payment) => {
	//       try {
	//         var data = {
	//           token: this.state.token,
	//           idname: this.state.idname,
	//           result: payment,
	//           payment_type: 'paypal',
	//           amount: this.state.amount,
	//           userCart: this.state.user_cart,
	//           user_ip: this.state.user_ip,
	//           user_city: this.state.user_city,
	//           user_country: this.state.user_country,
	//         };
	//         var gtmData = {
	//           payment_type: 'paypal',
	//           amount: this.state.amount,
	//           userCart: this.state.user_cart,
	//         };
	//         FD.callAPI(App_data.backend_api + '/checkout_v1/addOrder', data).then(async (resp) => {
	//           if (resp.success) {
	//             await this.GTM_Trigger(gtmData);
	//             this.setState({ ValidToken: true });
	//             var amount = resp.orders.amount;
	//             var order_val = this.state.user_cart;
	//             var all_order = [];
	//             var i = 0;
	//             var exam_selection = [];
	//             var exam_plans = [];
	//             Object.keys(order_val).map(function (key) {
	//               exam_selection.push(order_val[key].exam_id);
	//               exam_plans.push(order_val[key].plan_id);
	//               all_order[i] = {
	//                 exam_id: order_val[key].exam_id,
	//                 exam_name: order_val[key].exam_name,
	//                 extras: order_val[key].extraData,
	//                 package_type: order_val[key].package_type,
	//                 percent_discount: order_val[key].percent_discount,
	//                 plan_id: order_val[key].plan_id,
	//                 price: order_val[key].price,
	//                 type: order_val[key].type,
	//                 discounted_price: Math.round(
	//                   order_val[key].price -
	//                     (order_val[key].price * order_val[key].percent_discount) / 100,
	//                 ),
	//               };
	//               i++;
	//             });
	//             var unique = exam_selection.filter(function (elem, index, self) {
	//               return index === self.indexOf(elem);
	//             });
	//             var storage_valueofExam = JSON.stringify(unique);
	//             var storage_valueofPlan = JSON.stringify(exam_plans);
	
	//             await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
	//               async (resp) => {
	//                 if (resp.success) {
	//                   var examData = storage_valueofExam;
	//                   if (resp.profileInfo.exam_selected !== '') {
	//                     var array1_new = JSON.parse(storage_valueofExam);
	//                     var array2_old = JSON.parse(resp.profileInfo.exam_selected);
	
	//                     var array3_store = array1_new.concat(array2_old);
	//                     var unique_exam = array3_store.filter(function (elem, index, self) {
	//                       return index === self.indexOf(elem);
	//                     });
	//                     examData = JSON.stringify(unique_exam);
	//                   }
	
	//                   var packageData = storage_valueofPlan;
	//                   if (resp.profileInfo.exam_package !== '') {
	//                     var array1_new = JSON.parse(storage_valueofPlan);
	//                     var array2_old = JSON.parse(resp.profileInfo.exam_package);
	//                     var array3_store = array1_new.concat(array2_old);
	//                     var unique_exam = array3_store.filter(function (elem, index, self) {
	//                       return index === self.indexOf(elem);
	//                     });
	//                     packageData = JSON.stringify(unique_exam);
	//                   }
	//                   var examdata = {
	//                     token: this.state.token,
	//                     idname: this.state.idname,
	//                     storage_valueofExam: examData,
	//                     storage_valueofPlan: packageData,
	//                     user_cart: this.state.user_cart,
	//                   };
	
	//                   await FD.callAPI(
	//                     App_data.backend_api + '/checkout_v1/updateOrderData',
	//                     examdata,
	//                   ).then(async (resp_get) => {
	//                     // console.log("selected exam inserted");
	//                   });
	//                 }
	//               },
	//             );
	
	//             var full_order_details = {
	//               token: this.state.token,
	//               idname: this.state.idname,
	//               order_id: resp.orders.id,
	//               username: resp.username,
	//               userid: resp.userid,
	//               payment_type: 'paypal',
	//               idname: this.state.idname,
	//               all_order_details: all_order,
	//               amount: amount,
	//             };
	//             await FD.callAPI(
	//               App_data.backend_api + '/checkout_v1/updateOrder',
	//               full_order_details,
	//             ).then(async (resp) => {
	//               if (resp.success) {
	//                 // console.log("Mail Send Successfully");
	//               }
	//             });
	//             var params = {
	//               token: this.state.token,
	//               idname: this.state.idname,
	//               cart_ids: this.state.cartIds,
	//               order_id: resp.orders.id,
	//             };
	//             await FD.callAPI(App_data.backend_api + '/checkout_v1/updateCart', params).then(
	//               (response) => {
	//                 if (response.success) {
	//                   showSuccess('Payment successful! Your packages have been upgraded.');
	//                   this.context.router.push({
	//                     pathname: `/thankyou/${resp.orders.id}`,
	//                     state: {
	//                       token: this.state.token,
	//                       idname: this.state.idname,
	//                       order_id: resp.orders.id,
	//                       China_price: this.state.China_price,
	//                       canadian_price: this.state.canadian_price,
	//                     },
	//                   });
	//                   // window.location.reload();
	//                 } else {
	//                   showFailure(
	//                     'Payment failed or there was an issue updating your packages. Please contact support.',
	//                   );
	//                 }
	//                 return response;
	//               },
	//             );
	//           } else {
	//             //this.setState({ValidToken : false});
	//           }
	//           return resp;
	//         });
	//       } catch (error) {
	//         console.error('Payment processing error:', error);
	//         showFailure(
	//           'Payment failed or there was an issue updating your packages. Please contact support.',
	//         );
	//       }
	//     };
	
	//     const onCancel = (data) => {
	//       console.log('Payment cancelled by user', data);
	//       showFailure('Payment was cancelled. No charges were made.');
	//     };
	
	//     const onError = (err) => {
	//       console.error('PayPal payment error:', err);
	//       showFailure('An error occurred during the payment. Please try again.');
	//     };
	
	//     if (this.state.user_cart.length) {
	//       data = Object.keys(plan).map((item, index) => (
	//         <tbody key={index}>
	//           <tr key={index} className='package-detail'>
	//             <td width='50%'>
	//               {plan[item].package_val === 'unlimited' ||
	//               plan[item].plan_id === 27 ||
	//               plan[item].plan_id === 30 ||
	//               plan[item].plan_id === 33 ||
	//               plan[item].plan_id === 35
	//                 ? null
	//                 : plan[item].exam_name}
	//               <span>
	//                 {plan[item].package_val === 'unlimited' ||
	//                 plan[item].plan_id === 27 ||
	//                 plan[item].plan_id === 30 ||
	//                 plan[item].plan_id === 33 ||
	//                 plan[item].plan_id === 35
	//                   ? plan[item].package_type
	//                   : ` (${plan[item].package_type})`}
	
	//                 {/* &nbsp;({plan[item].package_type}){" "} */}
	//                 {plan[item].package_type == 'addon' ? plan[item].package_desc : ''}
	//               </span>
	//             </td>
	
	//             {
	//               plan[item].type === 'unlessUnlimited' ? (
	//                 <td width='8%' className='text-center pl-0'>
	//                   {' '}
	//                 </td>
	//               ) : (
	//                 // domainApp === 'WORLD' ?
	//                 <td width='8%' className='text-center pl-0'>
	//                   ${plan[item].price}
	//                 </td>
	//               )
	//               // : (
	//               //   <td width='8%' className='text-center pl-0'>
	//               //     ¥ {Math.ceil(Math.ceil(plan[item].price * this.state.China_price) / 10) * 10 - 1}
	//               //   </td>
	//               // )
	//             }
	
	//             {
	//               plan[item].type === 'unlessUnlimited' ? (
	//                 <td width='8%' className='text-center pl-0'>
	//                   {' '}
	//                 </td>
	//               ) : (
	//                 // domainApp === 'WORLD' ?
	//                 <td width='8%' className='text-center pl-0'>
	//                   $
	//                   {plan[item].percent_discount != '' && plan[item].coupon_code != ''
	//                     ? (discount =
	//                         Number(plan[item].price * Number(plan[item].percent_discount)) / 100)
	//                     : ''}
	//                 </td>
	//               )
	//               // : (
	//               //   <td width='8%' className='text-center pl-0'>
	//               //     ¥{' '}
	//               //     {plan[item].percent_discount != '' && plan[item].coupon_code != ''
	//               //       ? (discount =
	//               //         (Math.ceil(
	//               //           Math.ceil(
	//               //             Number(plan[item].price * Number(plan[item].percent_discount)) / 100,
	//               //           ) * this.state.China_price,
	//               //         ) /
	//               //           10) *
	//               //         10)
	//               //       : ''}
	//               //   </td>
	//               // )
	//             }
	
	//             <td width='20%' className='text-center pl-0'>
	//               <button
	//                 type='button'
	//                 className='btn-link pointer_class cart_button'
	//                 onClick={this._deleteItem.bind(this, plan[item])}
	//                 title='Delete'
	//               >
	//                 <img
	//                   src={App_data.frontend_url + '/img/subscription/subscription_icon1.svg'}
	//                   className=''
	//                   width='15'
	//                   alt=''
	//                 />
	//               </button>
	//             </td>
	//           </tr>
	//           {plan[item].extraData
	//             ? plan[item].extraData.map((extra, index) => {
	//                 return (
	//                   <tr key={index} className='package-extras'>
	//                     {/* {console.log(extra)} */}
	//                     <td width='50%' className='extras-title'>
	//                       {'- ' + extra.title}
	//                     </td>
	//                     {
	//                       // domainApp === 'WORLD' ?
	//                       <td width='8%' className='pl-0'>
	//                         {' '}
	//                         ${extra.price}
	//                       </td>
	//                       // : (
	//                       //   <td width='8%' className='pl-0'>
	//                       //     ¥
	//                       //     {Math.ceil(
	//                       //       Math.ceil(Number(extra.price) * Number(this.state.China_price)) / 10,
	//                       //     ) *
	//                       //       10 -
	//                       //       1}
	//                       //   </td>
	//                       // )
	//                     }
	//                   </tr>
	//                 );
	//               })
	//             : ''}
	//         </tbody>
	//       ));
	//     } else {
	//       data = (
	//         <tbody>
	//           <tr>
	//             <td colSpan={4} className='text-center'>
	//               <h6> {language.LC().YOUR_CART_IS_EMPTY} </h6>
	//             </td>
	//           </tr>
	//         </tbody>
	//       );
	//     }
	
	//     let loaderData = <Loader />;
	//     const { isLoading, showPromoCode, user_cart = [] } = this.state;
	
	//     const shouldShowPromoAndPaypal =
	//       showPromoCode &&
	//       !user_cart.some((item) => item && item.plan_id === EXAM_PACKAGE_IDS.GMAT_FOCUS.PRACTICE);
	
	//     return (
	//       <div className='animated fadeIn'>
	//         {this.state.startLoaderPage ? <Loader /> : null}
	//         <div className='row'>
	//           <div className='col-sm-12'>
	//             <div className='card margin_bottom_20'>
	//               <div className='card-header'>
	//                 <h4> {language.LC().YOUR_CART} </h4>
	//                 <h6>
	//                   {' '}
	//                   {
	//                     // domainApp === 'WORLD' ?
	//                     language.LC().PLEASE_VERIFY_THE_EXAM_AND_LEVEL_FOR_YOUR_PURCHASE
	//                     // : null
	//                   }{' '}
	//                 </h6>
	//               </div>
	//               <div className='card-block'>
	//                 <div className='row'>
	//                   <div className='col-lg-8 col-xl-9 margin_bottom_30'>
	//                     <div className='table_responsive_wrapper'>
	//                       <div className='table-responsive cart'>
	//                         <table className='cart_package_table table_white_bg table'>
	//                           <thead>
	//                             <tr>
	//                               <th width='30%'>{language.LC().PACKAGE}</th>
	
	//                               <th width='8%'>{language.LC().PRICE}</th>
	
	//                               <th width='8%'>{language.LC().DISCOUNT}</th>
	//                               <th width='20%'>{language.LC().DELETE_FROM_CART}</th>
	//                             </tr>
	//                           </thead>
	//                           {isLoading ? loaderData : data}
	
	//                           <tfoot>
	//                             <tr className={this.state.cart_bottom}>
	//                               <td> {language.LC().PAYABLE_TODAY} </td>
	//                               {/* <td colSpan={1}>${this.state.amount}</td> */}
	//                               {
	//                                 // domainApp === 'WORLD' ?
	//                                 <td colSpan={1} className='text-center pl-0'>
	//                                   $
	//                                   {this.state.amount
	//                                     ? parseInt(this.state.amount).toFixed(2)
	//                                     : this.state.amount}
	//                                 </td>
	//                                 // : (
	//                                 //   <td colSpan={1} className='text-center pl-0'>
	//                                 //     ¥
	//                                 //     {this.state.amount
	//                                 //       ? parseInt(
	//                                 //         Math.ceil(
	//                                 //           Math.ceil(this.state.amount * this.state.China_price) /
	//                                 //           10,
	//                                 //         ) *
	//                                 //         10 -
	//                                 //         1,
	//                                 //       ).toFixed(2)
	//                                 //       : Math.ceil(
	//                                 //         Math.ceil(this.state.amount * this.state.China_price) / 10,
	//                                 //       ) *
	//                                 //       10 -
	//                                 //       1}
	//                                 //   </td>
	//                                 // )
	//                               }
	//                               <td colSpan={2}>
	//                                 <p className={this.state.coupon_status_css}>
	//                                   <b>{this.state.coupon_status}</b>
	//                                 </p>
	//                               </td>
	//                             </tr>
	//                           </tfoot>
	//                         </table>
	//                       </div>
	//                     </div>
	//                   </div>
	//                   {shouldShowPromoAndPaypal && (
	//                     <div className='col-lg-4 col-xl-3'>
	//                       <div className={this.state.coupon_wrapper_class}>
	//                         <h6>
	//                           {language.LC().HAVE_A_PROMOTIONAL_CODE}?{' '}
	//                           <Tooltip
	//                             placement='left'
	//                             isOpen={this.state.tooltipOpen}
	//                             target='TooltipExample'
	//                             toggle={this.toggle}
	//                           >
	//                             {this.state.tooltipval}
	//                           </Tooltip>
	//                           <img
	//                             src={`${App_data.frontend_url}/img/info_icon.svg`}
	//                             className='margin_left_10'
	//                             id='TooltipExample'
	//                             alt='promotion code'
	//                             width='20'
	//                           />
	//                         </h6>
	//                         <div className='promo_form'>
	//                           <input type='text' id='coupon' name='coupon' />
	//                           <button onClick={this.applyCoupon}>{language.LC().APPLY}</button>
	//                         </div>
	//                       </div>
	//                     </div>
	//                   )}
	//                 </div>
	//                 <div className='row'>
	//                   <div className='col-xl-9'>
	//                     <div className='cart_btn_wrp'>
	//                       <div className='row'>
	//                         <div className='col-sm-8'>
	//                           <button
	//                             className='submit_btn_lg margin_right_10 btn btn-primary margin_bottom_10'
	//                             onClick={this._addItem}
	//                           >
	//                             {language.LC().ADD_SUBSCRIPTION}
	//                           </button>
	//                         </div>
	
	//                         {this.state.user_cart.length ? (
	//                           <div className='col-sm-4 text-sm-right'>
	//                             <button
	//                               className={'btn btn-primary ' + this.state.checkout}
	//                               onClick={this.togglePrimary}
	//                             >
	//                               {language.LC().PROCEED_TO_PAY}
	//                             </button>
	//                             <Modal
	//                               isOpen={this.state.primary}
	//                               toggle={this.togglePrimary}
	//                               className={'modal-primary ' + this.props.className}
	//                             >
	//                               <ModalHeader toggle={this.togglePrimary}>
	//                                 {language.LC().PICK_YOUR_PAYMENT} !
	//                               </ModalHeader>
	
	//                               <ModalBody>
	//                                 {this.state.startLoaderModal ? <Loader /> : null}
	//                                 {
	//                                   // domainApp === 'WORLD' ?
	//                                   <div className='row pay-catagry-wrap'>
	//                                     <div className='col-sm-12 col-md-12 pay-catagry-block'>
	//                                       <div className='pay_btn_wrap'>
	//                                         <p className='margin_bottom_30'>
	//                                           {language.LC().PAY_WITH_CARD}
	//                                         </p>
	//                                         <div className='row'>
	//                                           <div className='col-md-8 col-lg-8 align-self-center'>
	//                                             <ul className='card_list'>
	//                                               <li className='list-item'>
	//                                                 <img
	//                                                   src={
	//                                                     App_data.frontend_url +
	//                                                     '/img/subscription/cart_icon1.png'
	//                                                   }
	//                                                   className=''
	//                                                   alt=''
	//                                                 />
	//                                               </li>
	//                                               <li className='list-item'>
	//                                                 <img
	//                                                   src={
	//                                                     App_data.frontend_url +
	//                                                     '/img/subscription/cart_icon2.png'
	//                                                   }
	//                                                   className=''
	//                                                   alt=''
	//                                                 />
	//                                               </li>
	//                                               <li className='list-item'>
	//                                                 <img
	//                                                   src={
	//                                                     App_data.frontend_url +
	//                                                     '/img/subscription/cart_icon3.png'
	//                                                   }
	//                                                   className=''
	//                                                   alt=''
	//                                                 />
	//                                               </li>
	//                                               <li className='list-item'>
	//                                                 <img
	//                                                   src={
	//                                                     App_data.frontend_url +
	//                                                     '/img/subscription/cart_icon4.png'
	//                                                   }
	//                                                   className=''
	//                                                   alt=''
	//                                                 />
	//                                               </li>
	//                                             </ul>
	//                                           </div>
	//                                           <div className='col-md-4 col-lg-4 align-self-center text-right'>
	//                                             {this.state.stripe_key ? (
	//                                               <StripeCheckout
	//                                                 name='AnalystPrep'
	//                                                 email={this.state.idname}
	//                                                 description='Purchase Packages'
	//                                                 panelLabel={language.LC().PAY}
	//                                                 amount={this.state.amount * 100}
	//                                                 currency='USD'
	//                                                 token={this.onToken.bind(
	//                                                   this,
	//                                                   this.state.amount,
	//                                                   this.state.cartIds,
	//                                                 )}
	//                                                 stripeKey={this.state.stripe_key}
	//                                               />
	//                                             ) : null}
	//                                           </div>
	//                                         </div>
	//                                       </div>
	//                                     </div>
	
	//                                     {shouldShowPromoAndPaypal && (
	//                                       <div className='col-sm-12 col-md-12 pay-catagry-block  margin_top_10'>
	//                                         <div className='pay_btn_wrap'>
	//                                           <p className='pay_btn_title margin_bottom_30'>
	//                                             {language.LC().PAY_WITH_PAYPAL_NORMAL}
	//                                           </p>
	//                                           <div className='row'>
	//                                             <div className='col-md-8 col-lg-8 align-self-center pay-pal-tile'>
	//                                               <img
	//                                                 src={`${App_data.frontend_url}/img/subscription/cart_icon5.png`}
	//                                                 className=''
	//                                                 height='25'
	//                                                 alt='paypal icon'
	//                                               />
	//                                             </div>
	//                                             <div className='col-md-4 col-lg-4 align-self-center text-right'>
	//                                               <div className='paypal_btn_wrap'>
	//                                                 <button className='paypal_btn'>
	//                                                   {language.LC().PAY_WITH_PAYPAL_CAPITAL}
	//                                                 </button>
	//                                                 <div
	//                                                   className='paypal_iframe'
	//                                                   id='paypal-button-container'
	//                                                 >
	//                                                   <PaypalExpressBtn
	//                                                     env={this.state.env}
	//                                                     client={client}
	//                                                     currency={this.state.currency}
	//                                                     total={this.state.amount}
	//                                                     onError={onError}
	//                                                     onSuccess={handlePaypalPaymentSuccess}
	//                                                     onCancel={onCancel}
	//                                                     style={{
	//                                                       size: 'responsive',
	//                                                       color: 'blue',
	//                                                       tagline: false,
	//                                                       label: 'pay',
	//                                                       height: 45,
	//                                                     }}
	//                                                   />
	//                                                 </div>
	//                                               </div>
	//                                             </div>
	//                                           </div>
	//                                         </div>
	//                                       </div>
	//                                     )}
	//                                   </div>
	//                                   // : (
	//                                   //   <div className='row pay-catagry-wrap'>
	//                                   //     <div className='ali-pay-wrap margin_bottom_60 margin_top_10 col-sm-12'>
	//                                   //       <p className='pay_btn_title margin_bottom_30'>
	//                                   //         {language.LC().PAY_WITH_ALIPAY_NORMAL}
	//                                   //       </p>
	//                                   //       <div className='pay_btn_wrap ali-pay-btn-block'>
	//                                   //         <div className='pay-catagry-block'>
	//                                   //           <div className='row'>
	//                                   //             <div className='col-md-8 col-lg-8 align-self-center'>
	//                                   //               <ul className='card_list'>
	//                                   //                 <li className='list-item'>
	//                                   //                   <img
	//                                   //                     src={
	//                                   //                       App_data.frontend_url +
	//                                   //                       '/img/subscription/alipay.png'
	//                                   //                     }
	//                                   //                     style={{ height: '40px' }}
	//                                   //                     alt=''
	//                                   //                   />
	//                                   //                 </li>
	//                                   //               </ul>
	//                                   //             </div>
	//                                   //             <div className='col-md-4 col-lg-4 align-self-center text-right'>
	//                                   //               <Button
	//                                   //                 onClick={this.redirectToAlipay.bind(this)}
	//                                   //                 className='submit_btn_lg margin_right_10 margin_bottom_10 btn btn-primary ali-pay-submit'
	//                                   //               >
	//                                   //                 {' '}
	//                                   //                 {language.LC().PAY_WITH_ALIPAY_CAPITAL}
	//                                   //               </Button>
	//                                   //             </div>
	//                                   //           </div>
	//                                   //         </div>
	//                                   //       </div>
	//                                   //     </div>
	//                                   //   </div>
	//                                   // )
	//                                 }
	//                               </ModalBody>
	//                             </Modal>
	//                           </div>
	//                         ) : (
	//                           ''
	//                         )}
	//                       </div>
	//                     </div>
	//                   </div>
	//                 </div>
	//               </div>
	//             </div>
	//           </div>
	//         </div>
	//         <p>
	//           {' '}
	//           *
	//           {
	//             // domainApp === 'WORLD' ?
	//             language.LC().All_prices_are_in_US_dollars_All_sales_are_final
	//             // : language.LC().All_sales_are_final
	//           }
	//         </p>
	//       </div>
	//     );
	//   }
	// }
	
	exports.default = Cart;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(479);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	__webpack_require__(122);
	
	var _toast = __webpack_require__(15);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _StripeCheckoutForm = __webpack_require__(530);
	
	var _StripeCheckoutForm2 = _interopRequireDefault(_StripeCheckoutForm);
	
	var _ExpressCheckoutWallets = __webpack_require__(528);
	
	var _ExpressCheckoutWallets2 = _interopRequireDefault(_ExpressCheckoutWallets);
	
	var _PayPalButton = __webpack_require__(529);
	
	var _PayPalButton2 = _interopRequireDefault(_PayPalButton);
	
	var _analytics = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Checkout = function (_Component) {
	  _inherits(Checkout, _Component);
	
	  function Checkout(props) {
	    _classCallCheck(this, Checkout);
	
	    var _this = _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      errorMessage: "",
	      cartItems: [],
	
	      paymentMethod: "",
	      // paymentMethod: "card",
	      // paymentMethod: "paypal",
	      isUserAuthorized: false,
	      profileInfo: null,
	      isProcessingPayment: false,
	      stripe_key: null,
	      stripe: null,
	      paypal_client_id: null,
	      paypal_env: null
	    };
	
	    _this.stripeFormRef = null;
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.onStripeFormRef = _this.onStripeFormRef.bind(_this);
	    _this.handlePayment = _this.handlePayment.bind(_this);
	    return _this;
	  }
	
	  _createClass(Checkout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.getIsUserAuthorized();
	      this.loadUserCheckout();
	      this.fetchPaymentCredentials();
	      this.loadStripeJs();
	      // Soft timeout — if Stripe.js + key haven't both arrived within 15s,
	      // surface an error instead of leaving the user on an infinite spinner.
	      this._stripeReadyTimeout = setTimeout(function () {
	        if (!_this2.state.stripe && !_this2.state.errorMessage) {
	          _this2.setState({
	            errorMessage: "Payment form is taking too long to load. Please refresh and try again."
	          });
	        }
	      }, 15000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._stripeReadyTimeout) {
	        clearTimeout(this._stripeReadyTimeout);
	        this._stripeReadyTimeout = null;
	      }
	    }
	  }, {
	    key: 'loadStripeJs',
	    value: function loadStripeJs() {
	      var _this3 = this;
	
	      if (window.Stripe) {
	        this.initStripe();
	        return;
	      }
	      var script = document.createElement('script');
	      script.src = 'https://js.stripe.com/v3/';
	      script.onload = function () {
	        _this3.initStripe();
	      };
	      script.onerror = function () {
	        // Stripe.js blocked by ad-blocker, CSP, or network failure.
	        // Without this handler the second <Loader/> would spin forever.
	        _this3.setState({
	          errorMessage: "Couldn't load the payment form. Please disable ad blockers or check your connection, then refresh."
	        });
	      };
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'initStripe',
	    value: function initStripe() {
	      var _this4 = this;
	
	      var key = this.state.stripe_key;
	      if (!key || !window.Stripe) return;
	      // Always create a fresh Stripe instance bound to the current key,
	      // so a later key update (e.g. from getPaymentCred) replaces any
	      // stale instance that may have been created with a build-time key.
	      this.setState({ stripe: window.Stripe(key) }, function () {
	        // Stripe is ready — cancel the soft timeout so it can't fire later
	        // and overwrite a working state with a stale "taking too long" error.
	        if (_this4._stripeReadyTimeout) {
	          clearTimeout(_this4._stripeReadyTimeout);
	          _this4._stripeReadyTimeout = null;
	        }
	      });
	    }
	  }, {
	    key: 'onStripeFormRef',
	    value: function onStripeFormRef(ref) {
	      this.stripeFormRef = ref;
	    }
	  }, {
	    key: 'fetchPaymentCredentials',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this5 = this;
	
	        var resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getPaymentCred');
	
	              case 3:
	                resp = _context.sent;
	
	                if (resp && resp.success) {
	                  // PayPal — fall back to the legacy `paypal_app_id` name while
	                  // any cached backend still serves it.
	                  if (resp.paypal_client_id || resp.paypal_app_id) {
	                    this.setState({
	                      paypal_client_id: resp.paypal_client_id || resp.paypal_app_id,
	                      paypal_env: resp.paypal_env || 'sandbox'
	                    });
	                  }
	                  if (resp.stripe_key) {
	                    this.setState({ stripe_key: resp.stripe_key }, function () {
	                      if (window.Stripe) {
	                        _this5.initStripe();
	                      }
	                    });
	                  } else if (_App_data2.default.stripe_key) {
	                    // Backend responded OK but carried no Stripe key — use the build-time
	                    // key if one is configured (defense in depth).
	                    this.setState({ stripe_key: _App_data2.default.stripe_key }, function () {
	                      if (window.Stripe) _this5.initStripe();
	                    });
	                  } else {
	                    // Backend reachable but returned no Stripe key, AND no build-time key
	                    // is set (REACT_APP_STRIPEKEY is empty in this build). Without this
	                    // guard the page would hang on the second <Loader/> forever, since
	                    // `stripe` never gets created. Surface a clear, actionable error.
	                    this.setState({
	                      errorMessage: "Payment is temporarily unavailable (no payment key configured). Please refresh, and contact support if the problem persists."
	                    });
	                  }
	                }
	                _context.next = 13;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	
	                if (!(!this.state.stripe_key && _App_data2.default.stripe_key)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                this.setState({ stripe_key: _App_data2.default.stripe_key }, function () {
	                  if (window.Stripe) _this5.initStripe();
	                });
	                return _context.abrupt('return');
	
	              case 12:
	                // No fallback available — surface the failure so the user is not
	                // stuck on the second <Loader/> with no signal of what went wrong.
	                this.setState({
	                  errorMessage: "Couldn't reach the payment service. Please refresh and try again."
	                });
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 7]]);
	      }));
	
	      function fetchPaymentCredentials() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchPaymentCredentials;
	    }()
	
	    /**
	     * Build the common analytics payload shared by add_payment_info and
	     * payment_failed events. Reads from this.state + userStore. Wrapped at
	     * call sites with try/catch — never throws.
	     */
	
	  }, {
	    key: 'buildAnalyticsContext',
	    value: function buildAnalyticsContext() {
	      var cartItems = this.state.cartItems;
	
	      var total = 0;
	      try {
	        var totals = this.getCartTotals();
	        total = totals && totals.total || 0;
	      } catch (e) {/* ignore */}
	      var profile = _userStore2.default && _userStore2.default.profileInfo || this.state.profileInfo || {};
	      return {
	        cartItems: Array.isArray(cartItems) ? cartItems : [],
	        total: total,
	        paymentType: 'stripe',
	        userName: profile.username || '',
	        userEmail: profile.email || '',
	        source: _userStore2.default && _userStore2.default.landingSource || 'organic',
	        affiliateName: _userStore2.default && _userStore2.default.landingSourceName || null
	      };
	    }
	
	    /** Safe wrapper — never throws into the payment flow. */
	
	  }, {
	    key: 'fireAddPaymentInfoSafe',
	    value: function fireAddPaymentInfoSafe() {
	      try {
	        (0, _analytics.trackAddPaymentInfo)(this.buildAnalyticsContext());
	      } catch (e) {
	        // eslint-disable-next-line no-console
	        console.warn('Checkout add_payment_info tracking failed:', e && e.message);
	      }
	    }
	
	    /** Safe wrapper — never throws into the payment flow. */
	
	  }, {
	    key: 'firePaymentFailedSafe',
	    value: function firePaymentFailedSafe(reason, errorMessage) {
	      try {
	        (0, _analytics.trackPaymentFailed)(Object.assign({}, this.buildAnalyticsContext(), {
	          reason: reason || 'unknown',
	          errorMessage: errorMessage || ''
	        }));
	      } catch (e) {
	        // eslint-disable-next-line no-console
	        console.warn('Checkout payment_failed tracking failed:', e && e.message);
	      }
	    }
	  }, {
	    key: 'handlePayment',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var cartItems, _ref3, token, error, _getCartTotals, total, cartIds, idname, data, resp, orderId, msg;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!this.state.isProcessingPayment) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                cartItems = this.state.cartItems;
	
	                if (!(!cartItems || cartItems.length === 0)) {
	                  _context2.next = 6;
	                  break;
	                }
	
	                (0, _toast.showFailure)("Your cart is empty.");
	                return _context2.abrupt('return');
	
	              case 6:
	                if (!(0, _CommonUtils.hasSubscriptionRegularMix)(cartItems)) {
	                  _context2.next = 9;
	                  break;
	                }
	
	                (0, _toast.showFailure)("Subscription and regular products cannot be purchased together. Please check out the subscription separately.");
	                return _context2.abrupt('return');
	
	              case 9:
	                if (this.stripeFormRef) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                (0, _toast.showFailure)("Payment form is not ready. Please try again.");
	                return _context2.abrupt('return');
	
	              case 12:
	
	                this.setState({ isProcessingPayment: true });
	
	                _context2.prev = 13;
	                _context2.next = 16;
	                return this.stripeFormRef.handleSubmit();
	
	              case 16:
	                _ref3 = _context2.sent;
	                token = _ref3.token;
	                error = _ref3.error;
	
	                if (!error) {
	                  _context2.next = 24;
	                  break;
	                }
	
	                // Analytics: card validation failure (Stripe.js token creation rejected).
	                this.firePaymentFailedSafe('card_validation', error && error.message || 'Card validation failed.');
	                (0, _toast.showFailure)(error.message || "Card validation failed.");
	                this.setState({ isProcessingPayment: false });
	                return _context2.abrupt('return');
	
	              case 24:
	
	                // Analytics: user has provided valid payment information. Fires BEFORE
	                // the backend call so the funnel step is captured even if /createOrder
	                // is rejected. GA4-standard funnel position: between begin_checkout
	                // and purchase.
	                this.fireAddPaymentInfoSafe();
	
	                _getCartTotals = this.getCartTotals(), total = _getCartTotals.total;
	                cartIds = cartItems.map(function (item) {
	                  return item.id;
	                });
	                idname = this.state.profileInfo ? this.state.profileInfo.email : '';
	                data = {
	                  result: token,
	                  idname: idname,
	                  payment_type: 'stripe',
	                  amount: total,
	                  userCart: cartItems,
	                  cartIds: cartIds
	                };
	
	                // Include payment interval for subscription detection on the backend
	
	                if (cartItems.length === 1 && cartItems[0].payment_interval !== null && cartItems[0].payment_interval !== undefined) {
	                  data.paymentInterval = cartItems[0].payment_interval;
	                }
	
	                _context2.next = 32;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/createOrder', data);
	
	              case 32:
	                resp = _context2.sent;
	
	
	                if (resp && resp.success) {
	                  orderId = resp.order_id || resp.orders && resp.orders.id;
	
	                  this.props.router.push({
	                    pathname: '/thankyou/' + orderId
	                  });
	                } else {
	                  // Analytics: backend rejected the order (insufficient funds, declined,
	                  // server error mapped to success: false, etc.).
	                  msg = resp && resp.message ? resp.message : "Payment failed. Please try again.";
	
	                  this.firePaymentFailedSafe('backend_rejection', msg);
	                  (0, _toast.showFailure)(msg);
	                  this.setState({ isProcessingPayment: false });
	                }
	                _context2.next = 41;
	                break;
	
	              case 36:
	                _context2.prev = 36;
	                _context2.t0 = _context2['catch'](13);
	
	                // Analytics: uncaught exception — code bug or network failure.
	                this.firePaymentFailedSafe('exception', _context2.t0 && _context2.t0.message || 'unknown exception');
	                (0, _toast.showFailure)("An error occurred during payment. Please try again.");
	                this.setState({ isProcessingPayment: false });
	
	              case 41:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[13, 36]]);
	      }));
	
	      function handlePayment() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return handlePayment;
	    }()
	  }, {
	    key: 'getIsUserAuthorized',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var profileInfo;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _userStore2.default.getUserProfile();
	
	              case 2:
	                profileInfo = _context3.sent;
	
	                if (profileInfo != null) {
	                  this.setState({ isUserAuthorized: true, profileInfo: profileInfo });
	                } else {
	                  this.setState({ isUserAuthorized: false, profileInfo: null });
	                }
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getIsUserAuthorized() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getIsUserAuthorized;
	    }()
	  }, {
	    key: 'loadUserCheckout',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this6 = this;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.setState({ isLoading: true, errorMessage: "" });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getUserCart").then(function (resp) {
	                  if (resp && resp.success) {
	                    var cartItems = resp.user_cart || [];
	                    // PayPal is one-time only in #273 — if the cart contains a
	                    // subscription item, force the selection back to card so the
	                    // user doesn't sit on the "click PayPal button" hint with no
	                    // PayPal button rendered.
	                    var nextPaymentMethod = _this6.state.paymentMethod === 'paypal' && cartItems.some(_CommonUtils.isSubscriptionItem) ? 'card' : _this6.state.paymentMethod;
	                    _this6.setState({
	                      isLoading: false,
	                      errorMessage: "",
	                      cartItems: cartItems,
	                      paymentMethod: nextPaymentMethod
	                    });
	                  } else {
	                    var msg = resp && resp.message ? resp.message : "Failed to load user checkout";
	                    _this6.setState({
	                      isLoading: false,
	                      errorMessage: msg
	                    });
	                    (0, _toast.showInformation)(msg);
	                  }
	                  return resp;
	                }).catch(function (err) {
	                  _this6.setState({
	                    isLoading: false,
	                    errorMessage: "Error loading  user checkout"
	                  });
	                  (0, _toast.showFailure)("Error loading  user checkout");
	                });
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function loadUserCheckout() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return loadUserCheckout;
	    }()
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }
	  }, {
	    key: 'selectPaymentMethod',
	    value: function selectPaymentMethod(method) {
	      // Defence in depth: refuse PayPal selection when cart contains a
	      // subscription item (PayPal one-time only in #273). The radio is
	      // hidden in that state anyway, so this should be unreachable from UI.
	      if (method === 'paypal' && this.cartHasSubscription()) return;
	      this.setState({ paymentMethod: method });
	    }
	  }, {
	    key: 'cartHasSubscription',
	    value: function cartHasSubscription() {
	      var items = this.state.cartItems || [];
	      return items.some(_CommonUtils.isSubscriptionItem);
	    }
	  }, {
	    key: 'isUpgradeItem',
	    value: function isUpgradeItem(item) {
	      return item && item.type && String(item.type).startsWith("upgrade_");
	    }
	  }, {
	    key: 'getItemBasePrice',
	    value: function getItemBasePrice(item) {
	      var extraData = item.extraData || [];
	      var addonsTotal = 0;
	      for (var i = 0; i < extraData.length; i++) {
	        addonsTotal += extraData[i].price;
	      }
	      if (item.type === "unlessUnlimited") {
	        return addonsTotal;
	      }
	      if (this.isUpgradeItem(item)) {
	        var credit = Number(item.upgrade_credit) || 0;
	        return Math.max(0, item.planPrice + addonsTotal - credit);
	      }
	      return item.planPrice + addonsTotal;
	    }
	  }, {
	    key: 'getItemDiscountAmount',
	    value: function getItemDiscountAmount(item) {
	      if (!item || item.type !== "main") return 0;
	      var pct = item.percent_discount;
	      if (!(pct > 0)) return 0;
	      // Coupon applies only to the plan price, not to add-ons
	      var planPrice = Number(item.planPrice) || Number(item.price) || 0;
	      return planPrice * pct / 100;
	    }
	  }, {
	    key: 'getCartTotals',
	    value: function getCartTotals() {
	      var items = this.state.cartItems || [];
	      var subtotal = 0;
	      var discountTotal = 0;
	      for (var i = 0; i < items.length; i++) {
	        subtotal += this.getItemBasePrice(items[i]);
	        discountTotal += this.getItemDiscountAmount(items[i]);
	      }
	      var total = subtotal - discountTotal;
	      return { subtotal: subtotal, discountTotal: discountTotal, total: total };
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var router = this.props.router;
	      var location = router.location;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ct_container_header' },
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'ct_shopping_btn ',
	            onClick: function onClick() {
	              return router.push("/cart");
	            }
	          },
	          'Shopping cart'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'ct_header_icon_arrow' },
	          '\u2192'
	        ),
	        _react2.default.createElement(
	          'span',
	          {
	            className: "ct_checkout_btn " + (location.pathname.includes("checkout") ? "ct_is_btn_active" : ""),
	            onClick: function onClick() {
	              return router.push("/checkout");
	            } },
	          'Checkout'
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'ct_continue_btn', onClick: function onClick() {
	              return router.push("/subscribe");
	            } },
	          'CONTINUE SHOPPING'
	        )
	      );
	    }
	  }, {
	    key: 'renderPaymentMethod',
	    value: function renderPaymentMethod() {
	      var _this7 = this;
	
	      var _state = this.state,
	          stripe = _state.stripe,
	          cartItems = _state.cartItems,
	          profileInfo = _state.profileInfo,
	          paymentMethod = _state.paymentMethod,
	          paypal_client_id = _state.paypal_client_id,
	          paypal_env = _state.paypal_env;
	      // Stripe's elements({ amount }) requires amount > 0. The cart total loads
	      // asynchronously and may not be ready when `stripe` first becomes available,
	      // so gate the wallet render on a positive amount to avoid an IntegrationError.
	
	      var walletAmountCents = Math.round((this.getCartTotals().total || 0) * 100);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chk_card' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'chk_card_title' },
	          'Payment Method'
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: "chk_payment_option" + (paymentMethod === "card" ? " chk_payment_option_active" : ""),
	            onClick: function onClick() {
	              return _this7.selectPaymentMethod("card");
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'chk_payment_option_left' },
	            _react2.default.createElement('input', {
	              type: 'radio',
	              name: 'paymentMethod',
	              'aria-label': 'Credit or debit card',
	              checked: paymentMethod === "card",
	              readOnly: true
	            }),
	            _react2.default.createElement('i', { className: 'chk_payment_icon chk_icon_card' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'chk_payment_option_label' },
	              'Credit / Debit Card'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chk_payment_badges' },
	            _react2.default.createElement(
	              'span',
	              { className: 'chk_badge chk_badge_visa' },
	              'VISA'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chk_badge chk_badge_mc' },
	              'MC'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'chk_badge chk_badge_amex' },
	              'AMEX'
	            )
	          )
	        ),
	        paymentMethod === "card" && _react2.default.createElement(_StripeCheckoutForm2.default, { onRef: this.onStripeFormRef }),
	        paypal_client_id && !this.cartHasSubscription() && _react2.default.createElement(
	          'div',
	          {
	            className: "chk_payment_option" + (paymentMethod === "paypal" ? " chk_payment_option_active" : ""),
	            onClick: function onClick() {
	              return _this7.selectPaymentMethod("paypal");
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'chk_payment_option_left' },
	            _react2.default.createElement('input', {
	              type: 'radio',
	              name: 'paymentMethod',
	              'aria-label': 'PayPal',
	              checked: paymentMethod === "paypal",
	              readOnly: true
	            }),
	            _react2.default.createElement('i', { className: 'chk_payment_icon chk_icon_paypal' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'chk_payment_option_label' },
	              'PayPal'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chk_payment_badges' },
	            _react2.default.createElement(
	              'span',
	              { className: 'chk_badge chk_badge_paypal' },
	              'PayPal'
	            )
	          )
	        ),
	        paymentMethod === "paypal" && !this.cartHasSubscription() && _react2.default.createElement(_PayPalButton2.default, {
	          paypalClientId: paypal_client_id,
	          paypalEnv: paypal_env,
	          getCart: function getCart() {
	            var _getCartTotals2 = _this7.getCartTotals(),
	                total = _getCartTotals2.total;
	
	            return {
	              userCart: cartItems || [],
	              amount: total,
	              idname: profileInfo ? profileInfo.email : ''
	            };
	          },
	          onSuccess: function onSuccess(data) {
	            if (data && data.order_id) {
	              _this7.props.router.push({ pathname: '/thankyou/' + data.order_id });
	            }
	          },
	          onError: function onError(msg) {
	            _this7.firePaymentFailedSafe('paypal_error', msg);
	            (0, _toast.showFailure)(msg || 'PayPal payment failed.');
	          },
	          onCancel: function onCancel() {
	            (0, _toast.showInformation)('PayPal payment cancelled.');
	          }
	        }),
	        stripe && walletAmountCents > 0 ? _react2.default.createElement(_ExpressCheckoutWallets2.default, {
	          stripeInstance: stripe,
	          amount: walletAmountCents,
	          currency: 'usd',
	          userCart: cartItems || [],
	          paymentInterval: cartItems && cartItems[0] && cartItems[0].payment_interval || null,
	          customerEmail: profileInfo && profileInfo.email || '',
	          apiBaseUrl: _App_data2.default.backend_api,
	          authHeader: function () {
	            try {
	              var s = JSON.parse(localStorage.getItem('localstorageval'));return s && s.token || '';
	            } catch (e) {
	              return '';
	            }
	          }(),
	          onSuccess: function onSuccess(orderId) {
	            _this7.props.router.push({ pathname: '/thankyou/' + orderId });
	          },
	          onError: function onError(err) {
	            _this7.firePaymentFailedSafe('wallet_error', err && err.message || 'Wallet payment failed');
	          }
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderOrderSummary',
	    value: function renderOrderSummary() {
	      var _this8 = this;
	
	      var _state2 = this.state,
	          cartItems = _state2.cartItems,
	          paymentMethod = _state2.paymentMethod,
	          isProcessingPayment = _state2.isProcessingPayment;
	
	      var _getCartTotals3 = this.getCartTotals(),
	          subtotal = _getCartTotals3.subtotal,
	          discountTotal = _getCartTotals3.discountTotal,
	          total = _getCartTotals3.total;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chk_card' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'chk_card_title' },
	          'Order Summary'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_summary_items' },
	          (cartItems || []).map(function (item) {
	            var isUpgrade = _this8.isUpgradeItem(item);
	            var isUpgradeUnlimited = isUpgrade && item.type === 'upgrade_unlimited';
	
	            return _react2.default.createElement(
	              'div',
	              { key: item.id },
	              item.type !== "unlessUnlimited" && _react2.default.createElement(
	                'div',
	                { className: 'chk_summary_line' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'chk_summary_line_name' },
	                  isUpgrade ? item.examName + " – Upgrade to " + item.package_type : item.examName + " - " + item.package_type,
	                  isUpgrade && _react2.default.createElement(
	                    'span',
	                    { className: "ct_addon_badge " + (isUpgradeUnlimited ? "ct_upgrade_badge_green" : "ct_upgrade_badge"),
	                      style: { fontSize: 10 }
	                    },
	                    'UPGRADE'
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'chk_summary_line_price' },
	                  item.originalPrice && Number(item.originalPrice) !== Number(item.planPrice) && _react2.default.createElement(
	                    'span',
	                    { className: 'chk_summary_line_price_original' },
	                    (0, _CommonUtils.formatMoney)(item.originalPrice)
	                  ),
	                  (0, _CommonUtils.formatMoney)(item.planPrice),
	                  item.payment_interval ? _react2.default.createElement(
	                    'span',
	                    { className: 'ct_item_price_interval' },
	                    '/',
	                    item.payment_interval,
	                    ' '
	                  ) : ""
	                )
	              ),
	              isUpgrade && Number(item.upgrade_credit) > 0 && _react2.default.createElement(
	                'div',
	                { className: "chk_summary_line " + (isUpgradeUnlimited ? "chk_summary_line_credit_green" : "chk_summary_line_credit") },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'chk_summary_line_name' },
	                  'Upgrade credit (',
	                  item.upgradeFromPackageType || "owned package",
	                  ')'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'chk_summary_line_price' },
	                  '-',
	                  (0, _CommonUtils.formatMoney)(Number(item.upgrade_credit) || 0)
	                )
	              ),
	              _this8.getItemDiscountAmount(item) > 0 && _react2.default.createElement(
	                'div',
	                { className: 'chk_summary_line chk_summary_line_coupon' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'chk_summary_line_name' },
	                  'Coupon applied (-',
	                  item.percent_discount,
	                  '%)'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'chk_summary_line_price' },
	                  '-',
	                  (0, _CommonUtils.formatMoney)(_this8.getItemDiscountAmount(item))
	                )
	              ),
	              (item.extraData || []).map(function (addon) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'chk_summary_line', key: addon.id },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'chk_summary_line_name' },
	                    addon.title
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: addon.inherited ? "chk_summary_line_included" : "chk_summary_line_price" },
	                    addon.inherited ? "included" : (0, _CommonUtils.formatMoney)(addon.price)
	                  )
	                );
	              })
	            );
	          })
	        ),
	        _react2.default.createElement('div', { className: 'chk_summary_divider' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_summary_row' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Subtotal'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'chk_summary_row_sum' },
	            (0, _CommonUtils.formatMoney)(subtotal)
	          )
	        ),
	        discountTotal > 0 && _react2.default.createElement(
	          'div',
	          { className: 'chk_summary_row' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Discount'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'chk_summary_row_sum' },
	            '-',
	            (0, _CommonUtils.formatMoney)(discountTotal)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_summary_row' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Tax'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'chk_summary_row_sum' },
	            '$0.00'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_summary_row chk_summary_row_total' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Total'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            (0, _CommonUtils.formatMoney)(total)
	          )
	        ),
	        paymentMethod === "paypal" && !this.cartHasSubscription() ?
	        // PayPal renders its own button inside <PayPalButton/>. We hide the
	        // generic Pay button to avoid double-submit UX. The PayPal button
	        // sits in the Payment Method card to the left.
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_pay_paypal_hint' },
	          'Click the PayPal button in the Payment Method section to continue.'
	        ) : _react2.default.createElement(
	          'button',
	          {
	            className: 'chk_pay_btn',
	            type: 'button',
	            onClick: this.handlePayment,
	            disabled: isProcessingPayment
	          },
	          isProcessingPayment ? "Processing..." : "Pay " + (0, _CommonUtils.formatMoney)(total)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_secure_text' },
	          paymentMethod === "paypal" && !this.cartHasSubscription() ? "Powered by PayPal. Your payment is secure and encrypted." : "Powered by Stripe. Your payment is secure and encrypted."
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state3 = this.state,
	          isLoading = _state3.isLoading,
	          errorMessage = _state3.errorMessage,
	          stripe = _state3.stripe,
	          cartItems = _state3.cartItems,
	          stripe_key = _state3.stripe_key;
	
	
	      var mixBlock = (0, _CommonUtils.hasSubscriptionRegularMix)(cartItems) ? _react2.default.createElement(
	        'div',
	        { className: 'chk_mix_warning' },
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_mix_warning_title' },
	          'Subscription and regular products cannot be purchased together'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chk_mix_warning_text' },
	          'Your cart contains a subscription package (e.g. GMAT Focus) together with a regular product. Please return to the cart and check out the subscription separately.'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'chk_mix_warning_btn',
	            onClick: function onClick() {
	              return _this9.props.router.push("/cart");
	            }
	          },
	          'Back to cart'
	        )
	      ) : null;
	
	      var checkoutContent = _react2.default.createElement(
	        'div',
	        null,
	        this.renderHeader(),
	        mixBlock ? mixBlock : _react2.default.createElement(
	          'div',
	          { className: 'chk_layout' },
	          _react2.default.createElement(
	            'div',
	            { className: 'chk_col_left' },
	            this.renderPaymentMethod()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chk_col_right' },
	            this.renderOrderSummary()
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	          'div',
	          { className: 'sb_page_container' },
	          errorMessage ? _react2.default.createElement(
	            'div',
	            { className: 'sb_error_message' },
	            errorMessage
	          ) : stripe ? _react2.default.createElement(
	            _reactStripeElements.StripeProvider,
	            { key: stripe_key || 'stripe', stripe: stripe },
	            _react2.default.createElement(
	              _reactStripeElements.Elements,
	              null,
	              checkoutContent
	            )
	          ) : _react2.default.createElement(_loader2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Checkout;
	}(_react.Component);
	
	exports.default = Checkout;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getData = __webpack_require__(144);
	
	var _getData2 = _interopRequireDefault(_getData);
	
	var _paymentModel = __webpack_require__(688);
	
	var _paymentModel2 = _interopRequireDefault(_paymentModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var paymentProcessing = function (_Component) {
	  _inherits(paymentProcessing, _Component);
	
	  function paymentProcessing(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, paymentProcessing);
	
	    var _this = _possibleConstructorReturn(this, (paymentProcessing.__proto__ || Object.getPrototypeOf(paymentProcessing)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.getChinaPrice = function () {
	      _getData2.default.GetCallAPI("https://api.exchangeratesapi.io/latest?base=USD").then(function (resp) {
	        _this.setState({
	          China_price: resp.rates.CNY,
	          usd_canadian_price: resp.rates.CAD
	        });
	      });
	      _getData2.default.GetCallAPI("https://api.exchangeratesapi.io/latest?base=CAD").then(function (resp) {
	        _this.setState({
	          canadian_price: resp.rates.CNY
	        });
	      });
	    };
	
	    _this.redirectToAlipayAgain = function () {
	      _this.setState({ startLoaderPage: true });
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        payment_type: "ali-pay",
	        source: _this.state.source,
	        livemode: _this.state.livemode,
	        client_secret: _this.state.client_secret,
	        user_city: _this.state.user_city,
	        user_ip: _this.state.user_ip,
	        user_country: _this.state.user_country
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/AlipaySourceVerify", data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (resp.success) {
	                    if (resp.status === "consumed") {
	                      _this.setState({
	                        MessageContent: "Payment Successful",
	                        imageName: "success-ic.svg",
	                        order_id: resp.order_id.id,
	                        alert_status: true,
	                        classid: "success",
	                        button: "View order details",
	                        message: "Your transaction was successful."
	                      });
	                    } else if (resp.status === "failed") {
	                      _this.setState({
	                        imageName: "fail-ic.svg",
	                        MessageContent: "Payment Failed",
	                        alert_status: true,
	                        classid: "faild",
	                        button: "Go to Cart",
	                        message: "Your transaction has failed. Kindly try and make the payment again."
	                      });
	                    } else {
	                      console.log("other-status", resp.status);
	                    }
	                  } else {
	                    _this.setState({ startLoaderPage: false });
	                    console.log("Error!!");
	                    alert(resp.message);
	                  }
	                  return _context.abrupt("return", resp);
	
	                case 2:
	                case "end":
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: "" + _language2.default.LC().ALERT,
	      MessageContent: "" + _language2.default.LC().ERROR,
	      exams: [],
	      token: "",
	      idname: "",
	      ValidToken: false,
	      chapter_id: "",
	      offset: 0,
	      limit: 10,
	      answered: [],
	      plan_data: "",
	      pack_class: "hide_block",
	      exam_name: "",
	      exam_class: "row",
	      extras_1: false,
	      extras_2: false,
	      checkedStatus: false,
	      disable: false,
	      params: window.location.href,
	      url: new URL(window.location.href),
	      source: "",
	      livemode: "",
	      client_secret: "",
	      user_city: "",
	      user_country: "",
	      user_ip: "",
	      Trans_id: "",
	      order_id: "",
	      classid: "",
	      message: "",
	      button: "",
	      China_price: 6.55,
	      canadian_price: 5.22,
	      usd_canadian_price: 1.26
	    };
	    return _this;
	  }
	
	  /*
	  --------------------------------------  
	  Function to get USD to yuan price
	  -------------------------------------
	  */
	
	  _createClass(paymentProcessing, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var storage_session;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _getData2.default.GetCallAPI("https://geolocation-db.com/json/").then(function (resp) {
	                  // console.log("resp");
	                  _this3.setState({
	                    user_city: resp.city,
	                    user_country: resp.country_name,
	                    user_ip: resp.IPv4
	                  });
	                });
	                // this.getChinaPrice();
	                storage_session = JSON.parse(localStorage.getItem("localstorageval"));
	
	                this.setState({
	                  idname: storage_session["idname"],
	                  token: storage_session["token"]
	                });
	
	                this.setState({
	                  source: this.state.url.searchParams.get("source"),
	                  livemode: this.state.url.searchParams.get("livemode"),
	                  client_secret: this.state.url.searchParams.get("client_secret"),
	                  Trans_id: this.state.url.searchParams.get("source")
	                }, function () {
	                  _this3.state.source ? _this3.redirectToAlipayAgain() : null;
	                });
	
	              case 4:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.state.alert_status ? _react2.default.createElement(_paymentModel2.default, {
	          token: this.state.token,
	          idname: this.state.idname,
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          imageName: this.state.imageName,
	          Trans_id: this.state.Trans_id,
	          China_price: this.state.China_price,
	          canadian_price: this.state.canadian_price,
	          order_id: this.state.order_id,
	          classid: this.state.classid,
	          message: this.state.message,
	          button: this.state.button
	        }) : null
	      );
	    }
	  }]);
	
	  return paymentProcessing;
	}(_react.Component);
	
	paymentProcessing.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = paymentProcessing;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var fileTypes = ['jpg', 'jpeg', 'png', 'what', 'ever', 'you', 'want'];
	
	var ChangePassword = function (_Component) {
	  _inherits(ChangePassword, _Component);
	
	  function ChangePassword(props) {
	    _classCallCheck(this, ChangePassword);
	
	    var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this, props));
	
	    _this.togglepassword = function (val) {
	      if (_this.state.inputValue == val) _this.setState({ inputValue: undefined });else _this.setState({ inputValue: val });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      oldPass: '',
	      newPass: '',
	      repeatPass: '',
	      social: false,
	      ValidToken: false,
	      message: '',
	      message_display_box: 'hide_block',
	
	      token: '',
	      idname: '',
	      selectedMenu: _this.props.params.selectedMenu,
	      username: _this.props.params.username
	    };
	    _this.oldPassChanged = _this.oldPassChanged.bind(_this);
	    _this.newPassChanged = _this.newPassChanged.bind(_this);
	    _this.repeatPassChanged = _this.repeatPassChanged.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'oldPassChanged',
	    value: function oldPassChanged(e) {
	      this.setState({
	        oldPass: e.target.value
	      });
	    }
	  }, {
	    key: 'newPassChanged',
	    value: function newPassChanged(e) {
	      this.setState({
	        newPass: e.target.value
	      });
	    }
	  }, {
	    key: 'repeatPassChanged',
	    value: function repeatPassChanged(e) {
	      this.setState({
	        repeatPass: e.target.value
	      });
	    }
	  }, {
	    key: 'updatePassword',
	    value: function updatePassword() {
	      var _this2 = this;
	
	      if (this.state.oldPass == '') {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({ message: '' + _language2.default.LC().Password_is_Required });
	        return;
	      }
	      if (this.state.newPass == '') {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({ message: '' + _language2.default.LC().New_Password_Is_Required });
	        return;
	      }
	      if (this.state.repeatPass == '') {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({
	          message: '' + _language2.default.LC().Confirm_Password_is_Required
	        });
	        return;
	      }
	      if (this.state.newPass != this.state.repeatPass) {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({
	          message: '' + _language2.default.LC().Password_And_Confirm_Password_Is_Required
	        });
	        return;
	      }
	
	      if (this.state.newPass.length < 5) {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({
	          message: '' + _language2.default.LC().Please_enter_atleast_6_characters_in_the_field
	        });
	        return;
	      } else {
	        this.setState({ message_display_box: 'hide_block' });
	        var data = {
	          idname: this.state.idname,
	          oldpassword: this.state.oldPass,
	          newpassword: this.state.newPass
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/updatePassword', data).then(function (resp) {
	          if (resp.success) {
	            _this2.setState({ message_display_box: 'show_block' });
	            _this2.setState({ message: resp.message });
	            _this2.setState({ oldPass: '', newPass: '', repeatPass: '' });
	          } else {
	            _this2.setState({ message_display_box: 'show_block' });
	            _this2.setState({ message: resp.message });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ ValidToken: true });
	          if (resp.profileInfo.password === null) {
	            _this3.context.router.push({
	              pathname: '/profile/',
	              state: {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                selectedMenu: localStorage.getItem('selectedmenu')
	              }
	            });
	          }
	        } else {
	          _reactRouter.browserHistory.push('/login');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      /*alert(localStorage.getItem('selectedmenu'));*/
	      var validRender = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().CHANGE_PASSWORD,
	              _react2.default.createElement(
	                'div',
	                { className: 'card-actions float-md-right' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'text_light cursor_pointer',
	                    onClick: _function._getProfile.bind(this, this.state.username)
	                  },
	                  _language2.default.LC().GO_TO_PROFILE,
	                  ' \xA0\xA0\xA0',
	                  ' ',
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/arrow_right.png', className: '', alt: '' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_top_60 padding_bottom_60' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form_wrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 ' + this.state.message_display_box },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'error_text' },
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              this.state.message
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form_field' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              ' ',
	                              _language2.default.LC().OLD_PASSWORD,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/profile/lock_icon.svg',
	                                  className: '',
	                                  width: '15',
	                                  alt: ''
	                                })
	                              ),
	                              _react2.default.createElement('input', {
	                                type: this.state.inputValue == 1 ? 'text' : 'password',
	                                id: 'input1-group1',
	                                name: 'input1-group1',
	                                className: 'form-control',
	                                placeholder: 'Old password',
	                                value: this.state.oldPass,
	                                disabled: this.state.social,
	                                onChange: this.oldPassChanged
	                              }),
	                              this.state.inputValue == 1 ? _react2.default.createElement('img', {
	                                onClick: function onClick() {
	                                  return _this4.togglepassword('1');
	                                },
	                                src: _App_data2.default.frontend_url + '/img/show 2.png',
	                                alt: ''
	                              }) : _react2.default.createElement('img', {
	                                onClick: function onClick() {
	                                  return _this4.togglepassword('1');
	                                },
	                                src: _App_data2.default.frontend_url + '/img/hide2.png',
	                                alt: ''
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form_field' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              ' ',
	                              _language2.default.LC().NEW_PASSWORD,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/profile/lock_icon.svg',
	                                  className: '',
	                                  width: '15',
	                                  alt: ''
	                                })
	                              ),
	                              _react2.default.createElement('input', {
	                                type: this.state.inputValue == 2 ? 'text' : 'password',
	                                id: 'input1-group1',
	                                name: 'input1-group1',
	                                className: 'form-control',
	                                placeholder: 'New password',
	                                value: this.state.newPass,
	                                disabled: this.state.social,
	                                onChange: this.newPassChanged
	                              }),
	                              this.state.inputValue == 2 ? _react2.default.createElement('img', {
	                                onClick: function onClick() {
	                                  return _this4.togglepassword('2');
	                                },
	                                src: _App_data2.default.frontend_url + '/img/show 2.png',
	                                alt: ''
	                              }) : _react2.default.createElement('img', {
	                                onClick: function onClick() {
	                                  return _this4.togglepassword('2');
	                                },
	                                src: _App_data2.default.frontend_url + '/img/hide2.png',
	                                alt: ''
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form_field' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              ' ',
	                              _language2.default.LC().CONFIRM_NEW_PASSWORD,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/profile/lock_icon.svg',
	                                  className: '',
	                                  width: '15',
	                                  alt: ''
	                                })
	                              ),
	                              _react2.default.createElement('input', {
	                                type: this.state.inputValue == 3 ? 'text' : 'password',
	                                id: 'input1-group1',
	                                name: 'input1-group1',
	                                className: 'form-control',
	                                placeholder: 'Confirm password',
	                                value: this.state.repeatPass,
	                                disabled: this.state.social,
	                                onChange: this.repeatPassChanged
	                              }),
	                              this.state.inputValue == 3 ? _react2.default.createElement('img', {
	                                onClick: function onClick() {
	                                  return _this4.togglepassword('3');
	                                },
	                                src: _App_data2.default.frontend_url + '/img/show 2.png',
	                                alt: ''
	                              }) : _react2.default.createElement('img', {
	                                onClick: function onClick() {
	                                  return _this4.togglepassword('3');
	                                },
	                                src: _App_data2.default.frontend_url + '/img/hide2.png',
	                                alt: ''
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement('div', { className: 'border_line' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: 'btn btn-primary btn_full_width',
	                              onClick: this.updatePassword.bind(this)
	                            },
	                            ' ',
	                            _language2.default.LC().UPDATE_PASSWORD,
	                            ' '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	      if (this.state.ValidToken) return validRender;else return _react2.default.createElement('p', null);
	    }
	  }]);
	
	  return ChangePassword;
	}(_react.Component);
	
	ChangePassword.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = ChangePassword;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NextQuestionModal = function (_Component) {
	  _inherits(NextQuestionModal, _Component);
	
	  function NextQuestionModal() {
	    _classCallCheck(this, NextQuestionModal);
	
	    return _possibleConstructorReturn(this, (NextQuestionModal.__proto__ || Object.getPrototypeOf(NextQuestionModal)).apply(this, arguments));
	  }
	
	  _createClass(NextQuestionModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showModal = _props.showModal,
	          headerText = _props.headerText,
	          bodyText = _props.bodyText,
	          closeFn = _props.closeFn,
	          moveToNext = _props.moveToNext;
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: showModal,
	          toggle: closeFn,
	          className: 'modal-primary custom_modalpro info-modal-designing' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalHeader,
	          { toggle: closeFn, className: 'custom-title' },
	          headerText
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            (0, _function.renderHTMLContent)(bodyText, "div"),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary mr-1 small-btn',
	                  onClick: closeFn
	                },
	                'No'
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary small-btn',
	                  onClick: moveToNext
	                },
	                'Yes'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NextQuestionModal;
	}(_react.Component);
	
	exports.default = NextQuestionModal;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import language from "../../assets/languages/language";
	
	
	var PaymentModalComponent = function (_Component) {
	  _inherits(PaymentModalComponent, _Component);
	
	  function PaymentModalComponent(props) {
	    _classCallCheck(this, PaymentModalComponent);
	
	    // console.log("******", props);
	
	    var _this = _possibleConstructorReturn(this, (PaymentModalComponent.__proto__ || Object.getPrototypeOf(PaymentModalComponent)).call(this, props));
	
	    _this.handleAction = function (MessageContent, e) {
	      // console.log("work handleAction", MessageContent);
	      if (_this.props.MessageContent === 'Payment Successful') {
	        // console.log("if");
	
	        _this.context.router.push({
	          pathname: '/thankyou/' + _this.props.order_id,
	          state: {
	            token: _this.props.token,
	            idname: _this.props.idname,
	            order_id: _this.props.order_id,
	            China_price: _this.props.China_price,
	            canadian_price: _this.props.canadian_price
	          }
	        });
	      } else {
	        // console.log("else if");
	
	        _this.context.router.push({
	          pathname: '/cart/',
	          state: {
	            token: _this.props.token,
	            idname: _this.props.idname
	          }
	        });
	      }
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(PaymentModalComponent, [{
	    key: 'toggleAlert',
	    value: function toggleAlert(e) {
	      e.preventDefault();
	      this.props.toggleAlert(e);
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium(e) {
	      e.preventDefault();
	      this.props.goPremium(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var alert_status = this.props.alert_status;
	      var MessageContent = this.props.MessageContent;
	      var imageName = this.props.imageName;
	      var Trans_id = this.props.Trans_id;
	      var button = this.props.button;
	      var message = this.props.message;
	      var classid = this.props.classid;
	      // console.log("type", typeof classid);
	
	      return _react2.default.createElement(
	        _reactstrap.Modal,
	        {
	          isOpen: alert_status,
	          toggle: this.toggleAlert.bind(this),
	          className: 'modal-primary custom_modalpro info-modal-designing' + this.props.className
	        },
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'text-center payment-section-wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-info-view-for-plan ' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/' + imageName,
	              className: 'margin_bottom_30',
	              alt: ''
	            }),
	            _react2.default.createElement(
	              'h4',
	              { className: 'margin_bottom_10' },
	              MessageContent
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'margin_bottom_20' },
	              message,
	              'The transaction ID for this payment is',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'transation-id id-' + classid },
	                Trans_id,
	                '.'
	              ),
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-plan-view view-plan-wrap' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn-transation btn-' + classid + ' margin_right_20',
	                  onClick: this.handleAction.bind(this, MessageContent)
	                },
	                ' ',
	                button
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentModalComponent;
	}(_react.Component);
	
	PaymentModalComponent.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = PaymentModalComponent;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(79);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var i = '';
	/* eslint-disable */
	
	var GMATDashboard = function (_Component) {
	  _inherits(GMATDashboard, _Component);
	
	  function GMATDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATDashboard);
	
	    var _this = _possibleConstructorReturn(this, (GMATDashboard.__proto__ || Object.getPrototypeOf(GMATDashboard)).call(this, props));
	
	    _this.deleteFlashCard = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(type, id, question_type) {
	        var _this$state, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, id_name = _this$state.idname, token = _this$state.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: question_type,
	                  exam: 'ea',
	                  level: '',
	                  item_id: id
	                };
	                _context.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onContactSubmit = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(event) {
	        var _this$state2, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context3.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context3.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context3.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state2 = _this.state, idname = _this$state2.idname, token = _this$state2.token, contactComment = _this$state2.contactComment, contactSubject = _this$state2.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context3.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context2.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x5) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.handleToggle = function (event) {
	      var checked = event.target.checked;
	
	      _this.setState({ toggle: checked }, function () {
	        // console.log('type', checked, this.state.toggle);
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          type: checked ? 'content-type' : 'content-format',
	          startDate: _this.state.send_startDate,
	          endDate: _this.state.send_startDate_second
	        };
	        // FD.callAPI(
	        //   App_data.backend_api + '/ea_dashboard/getQuestionType',
	        //   data
	        // ).then(async (resp) => {
	        //   // console.log(resp);
	        //   let content_type = [];
	        //   if (resp.success) {
	        //     resp.question_type.map((question) => {
	        //       content_type.push(question.content_type);
	        //     });
	        //     // content_type.push('Integrated Reasoning');
	
	        //     this.setState({ content_type }, () => {
	        //       this.contentTypeReportTabToggle(0);
	        //       this.contentTypeTabToggle(0);
	        //     });
	        //   }
	        // });
	        // FD.callAPI(
	        //   App_data.backend_api + '/ea_dashboard/mainProgressbar',
	        //   data
	        // ).then((resp) => {
	        //   if (resp.success) {
	        //     var dataString = JSON.stringify(resp.chapters);
	        //     var dataReason = JSON.parse(dataString);
	
	        //     var final_array_main = [];
	
	        //     for (i = 0; i < dataReason.length; i++) {
	        //       var right_answered = dataReason[i].answered_count;
	        //       var total_question = dataReason[i].attempted_count;
	
	        //       var user_graph_val = Math.round(
	        //         (right_answered / total_question) * 100
	        //       ).toFixed(1);
	
	        //       if (user_graph_val === 'NaN') {
	        //         final_array_main.push('0.0');
	        //       } else {
	        //         final_array_main.push(user_graph_val);
	        //       }
	        //     }
	
	        //     this.setState({
	        //       bar_main_user: final_array_main,
	        //       display_main_loader: 'hide_block',
	        //     });
	        //     // console.log('part 22222---------------------', final_array_main);
	        //   } else {
	        //     this.setState({ display_main_loader: 'hide_block' });
	        //   }
	        // });
	        // FD.callAPI(
	        //   App_data.backend_api + '/ea_dashboard/mainProgressclassbar',
	        //   data
	        // ).then((resp) => {
	        //   if (resp.success) {
	        //     var dataString = JSON.stringify(resp.chaptersclass);
	        //     var dataReason = JSON.parse(dataString);
	        //     var final_array_main = [];
	        //     for (i = 0; i < dataReason.length; i++) {
	        //       var right_answered = dataReason[i].answered_count;
	        //       var total_question = dataReason[i].attempted_count;
	        //       var user_graph_val = Math.round(
	        //         (right_answered / total_question) * 100
	        //       ).toFixed(1);
	
	        //       if (user_graph_val === 'NaN') {
	        //         final_array_main.push('0.0');
	        //       } else {
	        //         final_array_main.push(user_graph_val);
	        //       }
	        //     }
	        //     this.setState({ bar_main_class: final_array_main });
	        //   } else {
	        //     //console.log(resp.success + '------------failure');
	        //   }
	        // });
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getQuestionProgByUser', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ progress_bar_zero: resp.progressbarzero_data });
	          } else {
	            //console.log(resp.success + '------------failure');
	          }
	        });
	      });
	    };
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSavequestino = function (items, e) {
	      // console.log('items --------> ', items);
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteSaveVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: 'Hide Details' });
	      }
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({ more_detail_button: 'I Want More Details' });
	      }
	    };
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var storage_session, _this$state3, toggle, content_type, activeTabReportcards, data;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              _this$state3 = _this.state, toggle = _this$state3.toggle, content_type = _this$state3.content_type, activeTabReportcards = _this$state3.activeTabReportcards;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                // type: toggle
	                //   ? `and content_type = '${
	                //       content_type[activeTabReportcards ? activeTabReportcards : 0]
	                //     }'`
	                //   : `and content_format = '${
	                //       content_type[activeTabReportcards ? activeTabReportcards : 0]
	                //     }'`,
	                type: content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Quant' ? 'and content_type != \'Verbal\'' : 'and content_type = \'' + content_type[activeTabReportcards ? activeTabReportcards : 0] + '\''
	              };
	
	              if (!(content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Integrated Reasoning')) {
	                _context6.next = 9;
	                break;
	              }
	
	              _context6.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/get4typesReportsQuestionsbyuserid', data).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestion: resp.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 7:
	              _context6.next = 11;
	              break;
	
	            case 9:
	              _context6.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestion: resp.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 11:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context8.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashcardsbyuserid', data).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              flashreport: resp.flash_report,
	                              flashLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this2);
	    }));
	    _this.getQuestionsSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	      var storage_session, _this$state4, content_type, activeTabSavedcards, toggle, data;
	
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              _this$state4 = _this.state, content_type = _this$state4.content_type, activeTabSavedcards = _this$state4.activeTabSavedcards, toggle = _this$state4.toggle;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                // type: toggle
	                //   ? `and content_type = '${
	                //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
	                //     }'`
	                //   : `and content_format = '${
	                //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
	                //     }'`,
	                type: content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Quant' ? 'and content_type != \'Verbal\'' : 'and content_type = \'' + content_type[activeTabSavedcards ? activeTabSavedcards : 0] + '\''
	              };
	
	              if (!(content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Integrated Reasoning')) {
	                _context11.next = 9;
	                break;
	              }
	
	              _context11.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/get4typesFavQuestionsbyuserid', data).then(function () {
	                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              savedquestion: resp.questions,
	                              savedLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref10.apply(this, arguments);
	                };
	              }());
	
	            case 7:
	              _context11.next = 11;
	              break;
	
	            case 9:
	              _context11.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavQuestionsbyuserid', data).then(function () {
	                var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                  return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                      switch (_context10.prev = _context10.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              savedquestion: resp.questions,
	                              savedLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context10.stop();
	                      }
	                    }
	                  }, _callee10, _this2);
	                }));
	
	                return function (_x10) {
	                  return _ref11.apply(this, arguments);
	                };
	              }());
	
	            case 11:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee13() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context13.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp) {
	                  return _regenerator2.default.wrap(function _callee12$(_context12) {
	                    while (1) {
	                      switch (_context12.prev = _context12.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context12.stop();
	                      }
	                    }
	                  }, _callee12, _this2);
	                }));
	
	                return function (_x11) {
	                  return _ref13.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context15.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getReportsVideobyuserid', data).then(function () {
	                var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(resp) {
	                  return _regenerator2.default.wrap(function _callee14$(_context14) {
	                    while (1) {
	                      switch (_context14.prev = _context14.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo: resp.video });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context14.stop();
	                      }
	                    }
	                  }, _callee14, _this2);
	                }));
	
	                return function (_x12) {
	                  return _ref15.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee17() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee17$(_context17) {
	        while (1) {
	          switch (_context17.prev = _context17.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context17.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavVideosbyuserid', data).then(function () {
	                var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(resp) {
	                  return _regenerator2.default.wrap(function _callee16$(_context16) {
	                    while (1) {
	                      switch (_context16.prev = _context16.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savedvideo: resp.cfa_videos });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context16.stop();
	                      }
	                    }
	                  }, _callee16, _this2);
	                }));
	
	                return function (_x13) {
	                  return _ref17.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context17.stop();
	          }
	        }
	      }, _callee17, _this2);
	    }));
	
	    _this._beginChapter = function () {
	      var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(item, e) {
	        var data, routeName, caseId, caseOffset;
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: item.question_id
	                };
	
	                if (!(item.type !== 'question')) {
	                  _context18.next = 21;
	                  break;
	                }
	
	                routeName = void 0;
	                _context18.t0 = item.type;
	                _context18.next = _context18.t0 === 'tab_question' ? 6 : _context18.t0 === 'graph_question' ? 8 : _context18.t0 === 'table_question' ? 10 : _context18.t0 === 'two_part_question' ? 12 : 14;
	                break;
	
	              case 6:
	                routeName = 'EA_TAB';
	                return _context18.abrupt('break', 16);
	
	              case 8:
	                routeName = 'EA_GRAPH_MULTI_STATEMENT';
	                return _context18.abrupt('break', 16);
	
	              case 10:
	                routeName = 'EA_TABLE';
	                return _context18.abrupt('break', 16);
	
	              case 12:
	                routeName = 'EA_TWO_PART_STATEMENT';
	                return _context18.abrupt('break', 16);
	
	              case 14:
	                console.log('Route Name issue');
	                return _context18.abrupt('break', 16);
	
	              case 16:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reading_id: item.reading_id,
	                  question_type: item.type
	                };
	                _context18.next = 19;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getSpecialQuestionByReadingId', data).then(function (resp) {
	                  if (resp.success) {
	                    console.log('I am inside resp.success');
	                    resp.result.map(function (element, index) {
	                      if (item.question_id === element.id) {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default[routeName].replace(':chapterid', element.ea_chapter_id).replace(':readingid', element.ea_reading_id).replace(':subscription', _this.state.questionShowFreePremium === false ? 1 : 0).replace(':question_id', item.question_id).replace(':offset', index).replace(':reading', item.topic_name)
	                        });
	                      }
	                    });
	                  }
	                });
	
	              case 19:
	                _context18.next = 24;
	                break;
	
	              case 21:
	                caseId = 0;
	                caseOffset = 0;
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestionsbyid', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log('resp ----> ', resp.questionsbyid.case_id);
	                    console.log('callliiinnngggg.................IF.', _this.state.questionShowFreePremium);
	                    if (resp.questionsbyid.case_id) {
	                      data['case_id'] = resp.questionsbyid.ea_case_id;
	                      data['reading_id'] = resp.questionsbyid.ea_reading_id;
	                      data['subscriptionstatus'] = _this.state.questionShowFreePremium ? 'free' : 'paid';
	                      data['limit'] = 1;
	                      data['offset'] = 0;
	                      data['chapter_id'] = resp.questionsbyid.ea_chapter_id;
	                      // console.log(data);
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCaseByReading', data).then(function (response) {
	                        if (response.success) {
	                          if (response.questions && response.questions.length) {
	                            response.questions.map(function (elementCase, indexCase) {
	                              if (parseInt(elementCase.case_id, 10) === parseInt(resp.questionsbyid.case_id, 10)) {
	                                caseId = elementCase.case_id;
	                                caseOffset = indexCase;
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCasesquestion', data).then(function (result) {
	                                  console.log('result ------> ', result);
	                                  if (result.success) {
	                                    if (result.questions_details && result.questions_details.length) {
	                                      result.questions_details.map(function (element, index) {
	                                        if (parseInt(element.id, 10) === parseInt(item.question_id, 10)) {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', element.ea_chapter_id).replace(':readingid', element.ea_reading_id).replace(':caseid', element.ea_case_id).replace(':case_offset', caseOffset).replace(':subscription', _this.state.questionShowFreePremium ? 0 : 1).replace(':question_number',
	                                            // element.question_no
	                                            index + 1).replace(':offset', index)
	                                          });
	                                        }
	                                      });
	                                    }
	                                  }
	                                });
	                              }
	                            });
	                          }
	                        }
	                      });
	                    } else {
	                      console.log('callliiinnngggg.................ELSE.');
	
	                      _this.context.router.push({
	                        pathname: _AppRoutes2.default.EA_BEGINCHAPTER.replace(':notesid', resp.questionsbyid.ea_chapter_id).replace(':readingid', resp.questionsbyid.ea_reading_id).replace(':id', item.question_id)
	                      });
	                    }
	                  } else {
	                    //console.log('Not Found');
	                  }
	                });
	
	              case 24:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this2);
	      }));
	
	      return function (_x14, _x15) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    _this._beginVideos = function () {
	      var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.video_id
	                  // chapter_id: reading.chapter_id
	                };
	                _context19.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getVideoByID', data).then(function (resp) {
	                  console.log('----------->this.state.showFreePremium<-------------', _this.state.showFreePremium);
	                  if (resp.success) {
	                    var _data = resp.allVideo.findIndex(function (item) {
	                      return item.id === resp.video[0].id;
	                    });
	                    _this.context.router.push({
	                      pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', resp.video[0].id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', resp.video[0].chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.video[0].chapter_id).replace(':index', _data)
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this2);
	      }));
	
	      return function (_x16, _x17) {
	        return _ref19.apply(this, arguments);
	      };
	    }();
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabSavedcards !== tab) {
	        _this.setState({
	          activeTabSavedcards: tab
	        });
	      }
	    };
	
	    _this.contentTypeTabToggle = function (tab) {
	      if (_this.state.activeTabSavedcards !== tab) {
	        _this.setState({
	          savedquestion: [],
	          savedLoader: true,
	          activeTabSavedcards: tab
	        }, function () {
	          return _this.getQuestionsSaved();
	        });
	      }
	    };
	
	    _this.contentTypeReportTabToggle = function (tab) {
	      if (_this.state.activeTabReportcards !== tab) {
	        // console.log('I am inside contentTypeTabToggle');
	        _this.setState({
	          reportquestion: [],
	          reportLoader: true,
	          activeTabReportcards: tab
	        }, function () {
	          return _this.getQuestionReports();
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      toggle: true,
	      token: '',
	      idname: '',
	
	      videoFlashReport: [],
	      flashreport: [], //All Flash question Store
	
	      savedquestion: [],
	      savedvideo: [],
	
	      reportquestion: [],
	      reportsvideo: [],
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	      progress_bar_zero: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      // bar_chapter: '',
	      bar_main_user: [],
	      bar_main_class: [],
	      main_ea_bar_main_user: [],
	      main_ea_bar_main_class: [],
	      main_ea_progress_bar_zero: [],
	      main_ea_progress_bar: [],
	      main_ea_progress_bar_slider: [],
	      verbal_bar_main_user: [],
	      verbal_bar_main_class: [],
	      verbal_progress_bar_zero: [],
	      verbal_progress_bar: [],
	      verbal_progress_bar_slider: [],
	      integrated_reasoning_bar_main_user: [],
	      integrated_reasoning_bar_main_class: [],
	      integrated_reasoning_progress_bar_zero: [],
	      integrated_reasoning_progress_bar: [],
	      integrated_reasoning_progress_bar_slider: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      reportAnswerId: '',
	      subreadings_status: false,
	      display_main_loader: 'show_block',
	      display_loader: 'hide_block',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      ErrorMessage: '',
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      activeTabSavedcards: 0,
	      activeTabReportcards: 0,
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      type: '',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      showFreePremium: false,
	      selectedmenu: 'ea',
	      isVideo: true,
	      qpLoader: true,
	      npLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	      content_type: ['Quant', 'Verbal', 'Integrated Reasoning'],
	      questionShowFreePremium: true
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATDashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, data, e) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: data
	      });
	    }
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment,
	        type: 'quesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        videoReport: item.comment,
	        type: 'videoReport'
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: data.id,
	          contactType: type,
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'toggleDone',
	    value: function () {
	      var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee26() {
	        var _this3 = this;
	
	        var _state, idname, token, item_status, type, items_val, question_id, item_id, video_id, data;
	
	        return _regenerator2.default.wrap(function _callee26$(_context26) {
	          while (1) {
	            switch (_context26.prev = _context26.next) {
	              case 0:
	                _state = this.state, idname = _state.idname, token = _state.token, item_status = _state.item_status, type = _state.type, items_val = _state.items_val;
	                question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	                if (!(this.state.item_status == 'flashcard')) {
	                  _context26.next = 6;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context26.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteFlashCard', data).then(function () {
	                  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(resp) {
	                    return _regenerator2.default.wrap(function _callee20$(_context20) {
	                      while (1) {
	                        switch (_context20.prev = _context20.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context20.next = 5;
	                              break;
	                            }
	
	                            _context20.next = 3;
	                            return _this3.getQuestionFlashcards();
	
	                          case 3:
	                            _context20.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context20.stop();
	                        }
	                      }
	                    }, _callee20, _this3);
	                  }));
	
	                  return function (_x18) {
	                    return _ref21.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                if (!(item_status == 'savedquestion')) {
	                  _context26.next = 12;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val,
	                  type: type
	                };
	                _context26.next = 10;
	                return this.deleteFlashCard('question', question_id ? question_id : item_id, type);
	
	              case 10:
	                _context26.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteSavequestion', data).then(function () {
	                  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(resp) {
	                    return _regenerator2.default.wrap(function _callee21$(_context21) {
	                      while (1) {
	                        switch (_context21.prev = _context21.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context21.next = 5;
	                              break;
	                            }
	
	                            _context21.next = 3;
	                            return _this3.getQuestionsSaved();
	
	                          case 3:
	                            _context21.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context21.stop();
	                        }
	                      }
	                    }, _callee21, _this3);
	                  }));
	
	                  return function (_x19) {
	                    return _ref22.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                if (!(item_status == 'savedvideos')) {
	                  _context26.next = 18;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val
	                };
	                _context26.next = 16;
	                return this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	              case 16:
	                _context26.next = 18;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteSaveVideo', data).then(function () {
	                  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(resp) {
	                    return _regenerator2.default.wrap(function _callee22$(_context22) {
	                      while (1) {
	                        switch (_context22.prev = _context22.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context22.next = 5;
	                              break;
	                            }
	
	                            _context22.next = 3;
	                            return _this3.getVideosSaved();
	
	                          case 3:
	                            _context22.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context22.stop();
	                        }
	                      }
	                    }, _callee22, _this3);
	                  }));
	
	                  return function (_x20) {
	                    return _ref23.apply(this, arguments);
	                  };
	                }());
	
	              case 18:
	                if (!(this.state.item_status == 'Videoflashcard')) {
	                  _context26.next = 22;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context26.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteDashboardVideoFlashCard', data).then(function () {
	                  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(resp) {
	                    return _regenerator2.default.wrap(function _callee23$(_context23) {
	                      while (1) {
	                        switch (_context23.prev = _context23.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context23.next = 5;
	                              break;
	                            }
	
	                            _context23.next = 3;
	                            return _this3.getVideoFlashcards();
	
	                          case 3:
	                            _context23.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context23.stop();
	                        }
	                      }
	                    }, _callee23, _this3);
	                  }));
	
	                  return function (_x21) {
	                    return _ref24.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 22:
	                if (!(this.state.item_status == 'Reportsquestion')) {
	                  _context26.next = 26;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val,
	                  type: this.state.items_val.type
	                };
	                _context26.next = 26;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteDashboardQuestionReports', data).then(function () {
	                  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(resp) {
	                    return _regenerator2.default.wrap(function _callee24$(_context24) {
	                      while (1) {
	                        switch (_context24.prev = _context24.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context24.next = 5;
	                              break;
	                            }
	
	                            _context24.next = 3;
	                            return _this3.getQuestionReports();
	
	                          case 3:
	                            _context24.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context24.stop();
	                        }
	                      }
	                    }, _callee24, _this3);
	                  }));
	
	                  return function (_x22) {
	                    return _ref25.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 26:
	                if (!(this.state.item_status == 'Reportsvideos')) {
	                  _context26.next = 30;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context26.next = 30;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteDashboardVideoReports', data).then(function () {
	                  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(resp) {
	                    return _regenerator2.default.wrap(function _callee25$(_context25) {
	                      while (1) {
	                        switch (_context25.prev = _context25.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context25.next = 5;
	                              break;
	                            }
	
	                            _context25.next = 3;
	                            return _this3.getVideoReports();
	
	                          case 3:
	                            _context25.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context25.stop();
	                        }
	                      }
	                    }, _callee25, _this3);
	                  }));
	
	                  return function (_x23) {
	                    return _ref26.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 30:
	
	                this.setState({
	                  alert_status: false
	                });
	
	              case 31:
	              case 'end':
	                return _context26.stop();
	            }
	          }
	        }, _callee26, this);
	      }));
	
	      function toggleDone() {
	        return _ref20.apply(this, arguments);
	      }
	
	      return toggleDone;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate != '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this4 = this;
	
	          // console.log(
	          //   'I am inside handleChange_second -----> ',
	          //   this.state.toggle
	          // );
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second,
	            type: this.state.toggle ? 'content-type' : 'content-format'
	          };
	
	          // -------------- ---- FOR Main Graph No. 1 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getMainGraphProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph1 = JSON.stringify(resp.chapters);
	              var dataReasonGraph1 = JSON.parse(dataStringGraph1);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReasonGraph1.length; i++) {
	                var right_answered = dataReasonGraph1[i].answered_count;
	                var total_question = dataReasonGraph1[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                main_ea_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                main_ea_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getMainGraphProgressClassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ main_ea_bar_main_class: final_array_main });
	            }
	          });
	          // -------------- ---- FOR Main Graph No. 1 End ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this4.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                progress_bar_zero: resp.chapters
	              });
	              // console.log('part 22222---------------------', final_array_main);
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ bar_main_class: final_array_main });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	
	          // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getVerbalProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph3 = JSON.stringify(resp.chapters);
	              var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReasonGraph3.length; i++) {
	                var right_answered = dataReasonGraph3[i].answered_count;
	                var total_question = dataReasonGraph3[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                verbal_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                verbal_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getVerbalProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
	              var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	              var final_array_main = [];
	              for (i = 0; i < dataReasonGraph3.length; i++) {
	                var right_answered = dataReasonGraph3[i].answered_count;
	                var total_question = dataReasonGraph3[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ verbal_bar_main_class: final_array_main });
	            }
	          });
	          // -------------- ---- FOR Verbal Graph No. 3 End ------------- //
	
	          // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getIntegratedReasoningProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph4 = JSON.stringify(resp.chapters);
	              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReasonGraph4.length; i++) {
	                var right_answered = dataReasonGraph4[i].answered_count;
	                var total_question = dataReasonGraph4[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                integrated_reasoning_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                integrated_reasoning_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getIntegratedReasoningProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
	              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	              var final_array_main = [];
	              for (i = 0; i < dataReasonGraph4.length; i++) {
	                var right_answered = dataReasonGraph4[i].answered_count;
	                var total_question = dataReasonGraph4[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                integrated_reasoning_bar_main_class: final_array_main
	              });
	            }
	          });
	          // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
	          // FD.callAPI(
	          //   App_data.backend_api + '/ea_dashboard/getProgressChapter',
	          //   data
	          // ).then((resp) => {
	          //   if (resp.success) {
	          //     this.setState({ progress_bar_zero: resp.chapters });
	          //   } else {
	          //     //console.log(resp.success + '------------failure');
	          //   }
	          // });
	          // FD.callAPI(
	          //   App_data.backend_api + '/ea_dashboard/getNotesChapter',
	          //   data
	          // ).then((resp) => {
	          //   if (resp.success) {
	          //     this.setState({ bar_chapter: resp.chapters });
	          //   } else {
	          //     //console.log(resp.success + '------------failure');
	          //   }
	          // });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              _this4.setState({ progress_bar_zero: resp.progressbarzero_data });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee34() {
	        var _this5 = this;
	
	        var storage_session, data, getProfileInfoData;
	        return _regenerator2.default.wrap(function _callee34$(_context34) {
	          while (1) {
	            switch (_context34.prev = _context34.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second,
	                  type: this.state.toggle ? 'content-type' : 'content-format'
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/ea_dashboard/getQuestionType',
	                //   data
	                // ).then(async (resp) => {
	                //   // console.log(resp);
	                //   let content_type = [];
	                //   if (resp.success) {
	                //     resp.question_type.map((question) => {
	                //       content_type.push(question.content_type);
	                //     });
	                //     // content_type.push('Integrated Reasoning');
	                //     this.setState({ content_type });
	                //   }
	                // });
	
	                _context34.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getChapters', data).then(function () {
	                  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(resp) {
	                    return _regenerator2.default.wrap(function _callee27$(_context27) {
	                      while (1) {
	                        switch (_context27.prev = _context27.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ ValidToken: true });
	                              _this5.setState({ chapters: resp.chapters });
	                            } else {
	                              _this5.setState({ ValidToken: false });
	                            }
	                            return _context27.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context27.stop();
	                        }
	                      }
	                    }, _callee27, _this5);
	                  }));
	
	                  return function (_x24) {
	                    return _ref28.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	
	                // -------------- ---- FOR Main Graph No. 1 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getMainGraphProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph1 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph1 = JSON.parse(dataStringGraph1);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReasonGraph1.length; i++) {
	                      var right_answered = dataReasonGraph1[i].answered_count;
	                      var total_question = dataReasonGraph1[i].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      main_ea_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      main_ea_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getMainGraphProgressClassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataString = JSON.stringify(resp.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({ main_ea_bar_main_class: final_array_main });
	                  }
	                });
	                // -------------- ---- FOR Main Graph No. 1 End ------------- //
	                _context34.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/mainProgressbar', data).then(function () {
	                  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(resp) {
	                    var dataString, dataReason, final_array_main, right_answered, total_question, user_graph_val;
	                    return _regenerator2.default.wrap(function _callee28$(_context28) {
	                      while (1) {
	                        switch (_context28.prev = _context28.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ display_loader: 'hide_block' });
	                              dataString = JSON.stringify(resp.chapters);
	                              dataReason = JSON.parse(dataString);
	                              final_array_main = [];
	
	                              for (i = 0; i < dataReason.length; i++) {
	                                right_answered = dataReason[i].answered_count;
	                                total_question = dataReason[i].attempted_count;
	                                user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	
	                                if (user_graph_val === 'NaN') {
	                                  final_array_main.push('0.0');
	                                } else {
	                                  final_array_main.push(user_graph_val);
	                                }
	                              }
	                              // console.log('hi-------------------------', final_array_main);
	                              _this5.setState({ bar_main_user: final_array_main });
	                            } else {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context28.stop();
	                        }
	                      }
	                    }, _callee28, _this5);
	                  }));
	
	                  return function (_x25) {
	                    return _ref29.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	                this.setState({ display_main_loader: 'show_block' });
	
	                _context34.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/mainProgressclassbar', data).then(function () {
	                  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(resp) {
	                    var dataStringGraph2, dataReasonGraph2, final_array_main, right_answered, total_question, user_graph_val;
	                    return _regenerator2.default.wrap(function _callee29$(_context29) {
	                      while (1) {
	                        switch (_context29.prev = _context29.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ display_main_loader: 'hide_block' });
	                              dataStringGraph2 = JSON.stringify(resp.chaptersclass);
	                              dataReasonGraph2 = JSON.parse(dataStringGraph2);
	                              final_array_main = [];
	
	                              for (i = 0; i < dataReasonGraph2.length; i++) {
	                                right_answered = dataReasonGraph2[i].answered_count;
	                                total_question = dataReasonGraph2[i].attempted_count;
	                                user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	
	                                if (user_graph_val === 'NaN') {
	                                  final_array_main.push('0.0');
	                                } else {
	                                  final_array_main.push(user_graph_val);
	                                }
	                              }
	                              _this5.setState({ bar_main_class: final_array_main });
	                            } else {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context29.stop();
	                        }
	                      }
	                    }, _callee29, _this5);
	                  }));
	
	                  return function (_x26) {
	                    return _ref30.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	
	                // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getVerbalProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph3 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReasonGraph3.length; i++) {
	                      var right_answered = dataReasonGraph3[i].answered_count;
	                      var total_question = dataReasonGraph3[i].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      verbal_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      verbal_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getVerbalProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
	                    var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReasonGraph3.length; i++) {
	                      var right_answered = dataReasonGraph3[i].answered_count;
	                      var total_question = dataReasonGraph3[i].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({ verbal_bar_main_class: final_array_main });
	                  }
	                });
	                // -------------- ---- FOR Verbal Graph No. 3 End ------------- //
	
	                // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getIntegratedReasoningProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph4 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReasonGraph4.length; i++) {
	                      var right_answered = dataReasonGraph4[i].answered_count;
	                      var total_question = dataReasonGraph4[i].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      integrated_reasoning_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      integrated_reasoning_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getIntegratedReasoningProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
	                    var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReasonGraph4.length; i++) {
	                      var right_answered = dataReasonGraph4[i].answered_count;
	                      var total_question = dataReasonGraph4[i].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      integrated_reasoning_bar_main_class: final_array_main
	                    });
	                  }
	                });
	                // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
	                _context34.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/getQuestionProgByUser', data).then(function () {
	                  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(resp) {
	                    return _regenerator2.default.wrap(function _callee30$(_context30) {
	                      while (1) {
	                        switch (_context30.prev = _context30.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({
	                                progress_bar_zero: resp.progressbarzero_data,
	                                qpLoader: false
	                              });
	                            } else {
	                              //console.log(resp.success + '------------failure');
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context30.stop();
	                        }
	                      }
	                    }, _callee30, _this5);
	                  }));
	
	                  return function (_x27) {
	                    return _ref31.apply(this, arguments);
	                  };
	                }());
	
	              case 20:
	                _context34.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function () {
	                  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(resp) {
	                    return _regenerator2.default.wrap(function _callee31$(_context31) {
	                      while (1) {
	                        switch (_context31.prev = _context31.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ ValidToken: true });
	                            } else {
	                              _this5.setState({ ValidToken: false });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context31.stop();
	                        }
	                      }
	                    }, _callee31, _this5);
	                  }));
	
	                  return function (_x28) {
	                    return _ref32.apply(this, arguments);
	                  };
	                }());
	
	              case 22:
	                getProfileInfoData = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfoData).then(async (resp) => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee33() {
	                  var resp, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee33$(_context33) {
	                    while (1) {
	                      switch (_context33.prev = _context33.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context33.next = 3;
	                            break;
	                          }
	
	                          return _context33.abrupt('return');
	
	                        case 3:
	
	                          if (resp.profileInfo) {
	                            _this5.setState({
	                              isVideo: resp.profileInfo.isVideo
	                            });
	                          }
	
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context33.next = 17;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context33.next = 9;
	                            break;
	                          }
	
	                          _this5.setState({
	                            showFreePremium: true
	                          });
	                          _context33.next = 15;
	                          break;
	
	                        case 9:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this5.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            examid: data_arr
	                          };
	                          _context33.next = 15;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, queSubscription;
	                              return _regenerator2.default.wrap(function _callee32$(_context32) {
	                                while (1) {
	                                  switch (_context32.prev = _context32.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context32.next = 14;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this5.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context32.next = 6;
	                                      return _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context32.sent;
	
	                                      if (isInArray_var) {
	                                        _this5.setState({ showFreePremium: false });
	                                      } else {
	                                        _this5.setState({ showFreePremium: true });
	                                      }
	                                      // Question Subscription
	                                      _context32.next = 10;
	                                      return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    case 10:
	                                      queSubscription = _context32.sent;
	
	                                      if (queSubscription) {
	                                        _this5.setState({ questionShowFreePremium: false });
	                                      } else {
	                                        _this5.setState({
	                                          questionShowFreePremium: true
	                                        });
	                                      }
	                                      _context32.next = 14;
	                                      break;
	
	                                    case 14:
	                                    case 'end':
	                                      return _context32.stop();
	                                  }
	                                }
	                              }, _callee32, _this5);
	                            }));
	
	                            return function (_x29) {
	                              return _ref34.apply(this, arguments);
	                            };
	                          }());
	
	                        case 15:
	                          _context33.next = 27;
	                          break;
	
	                        case 17:
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context33.next = 21;
	                            break;
	                          }
	
	                          _this5.setState({
	                            showFreePremium: true
	                          });
	                          _context33.next = 27;
	                          break;
	
	                        case 21:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this5.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            examid: data_arr
	                          };
	                          _context33.next = 27;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this5.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                              // console.log("check video subscription in EA dashboard ", selectedmen,
	                              // exam_data,
	                              // this.state.cfaUnlimitedPackage,
	                              // this.state.cfaUnlimitedActiveExam)
	                              if (isInArray_var) {
	                                _this5.setState({ showFreePremium: false });
	                              } else {
	                                _this5.setState({ showFreePremium: true });
	                              }
	                              var queSubscription = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                              if (queSubscription) {
	                                _this5.setState({
	                                  questionShowFreePremium: false
	                                });
	                              } else {
	                                _this5.setState({
	                                  questionShowFreePremium: true
	                                });
	                              }
	                            } else {}
	                          });
	
	                        case 27:
	                        case 'end':
	                          return _context33.stop();
	                      }
	                    }
	                  }, _callee33, _this5);
	                })));
	
	                _context34.next = 26;
	                return this.getQuestionFlashcards();
	
	              case 26:
	                _context34.next = 28;
	                return this.getVideoFlashcards();
	
	              case 28:
	                _context34.next = 30;
	                return this.getQuestionsSaved();
	
	              case 30:
	                _context34.next = 32;
	                return this.getVideosSaved();
	
	              case 32:
	                _context34.next = 34;
	                return this.getQuestionReports();
	
	              case 34:
	                _context34.next = 36;
	                return this.getVideoReports();
	
	              case 36:
	              case 'end':
	                return _context34.stop();
	            }
	          }
	        }, _callee34, this);
	      }));
	
	      function componentDidMount() {
	        return _ref27.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	
	    // function for get  question report
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  video report
	
	
	    /*
	     * get saved all video
	     */
	
	
	    /*
	     * function for go to specific   question main page
	     */
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      // console.log(
	      //   'this.state.progress_bar_zero-------',
	      //   this.state.progress_bar_zero
	      // );
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(event) {
	        var _this6 = this;
	
	        var _state2, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee36$(_context36) {
	          while (1) {
	            switch (_context36.prev = _context36.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context36.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context36.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, quesReport = _state2.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context36.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(resp) {
	                    return _regenerator2.default.wrap(function _callee35$(_context35) {
	                      while (1) {
	                        switch (_context35.prev = _context35.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context35.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context35.next = 4;
	                            return _this6.getQuestionReports();
	
	                          case 4:
	                            _context35.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context35.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context35.stop();
	                        }
	                      }
	                    }, _callee35, _this6);
	                  }));
	
	                  return function (_x31) {
	                    return _ref36.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context36.stop();
	            }
	          }
	        }, _callee36, this);
	      }));
	
	      function handleQuestionReportSubmit(_x30) {
	        return _ref35.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee38$(_context38) {
	          while (1) {
	            switch (_context38.prev = _context38.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context38.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context38.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, videoReport = _state3.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context38.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(resp) {
	                    return _regenerator2.default.wrap(function _callee37$(_context37) {
	                      while (1) {
	                        switch (_context37.prev = _context37.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context37.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context37.next = 4;
	                            return _this7.getVideoReports();
	
	                          case 4:
	                            _context37.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context37.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context37.stop();
	                        }
	                      }
	                    }, _callee37, _this7);
	                  }));
	
	                  return function (_x33) {
	                    return _ref38.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context38.stop();
	            }
	          }
	        }, _callee38, this);
	      }));
	
	      function handleVideoReportSubmit(_x32) {
	        return _ref37.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          activeTabSavedcards = _state4.activeTabSavedcards,
	          activeTabSaved = _state4.activeTabSaved,
	          activeTabReports = _state4.activeTabReports,
	          isVideo = _state4.isVideo,
	          qpLoader = _state4.qpLoader,
	          npLoader = _state4.npLoader,
	          savedLoader = _state4.savedLoader,
	          flashLoader = _state4.flashLoader,
	          reportLoader = _state4.reportLoader,
	          toggle = _state4.toggle,
	          activeTabReportcards = _state4.activeTabReportcards;
	
	
	      var flashreport_val = this.state.flashreport;
	      var video_flashreport_val = this.state.videoFlashReport;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savedvideo_val = this.state.savedvideo;
	
	      var reportquestion_val = this.state.reportquestion;
	      var reportvideo_val = this.state.reportsvideo;
	
	      var flashcard_data = '';
	      var video_flashcard_data = '';
	
	      var savedquestion_data = '';
	      var savedvideo_data = '';
	
	      var question_reportsData = ''; // for question reports
	      var video_reportsData = ''; // for video report
	
	      // ------------------ FOR Graph 1 Start ----------------//
	      var main_ea_bar_val = this.state.main_ea_progress_bar_zero;
	      var main_ea_bar_percentage = this.state.main_ea_bar_main_user;
	
	      var main_ea_bar_user_percentage = this.state.main_ea_bar_main_class;
	
	      var main_ea_main_bar_data = [];
	      var i = 0;
	      main_ea_bar_val.map(function (data) {
	        main_ea_main_bar_data[i] = data.chapter_name;
	        i++;
	      });
	      var main_ea_bar_data = {
	        labels: main_ea_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_ea_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_ea_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 1 End ----------------//
	      /*first main graph*/
	      var main_bar_val = this.state.progress_bar_zero;
	      var main_bar_percentage = this.state.bar_main_user;
	
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	      Object.keys(main_bar_val).map(function (key) {
	        // var dataStringGraph2 = JSON.stringify(main_bar_val[key]);
	        // var dataReasonGraph2 = JSON.parse(dataStringGraph2);
	        // console.log('dataReasonGraph2 parse------> ', dataReasonGraph2);
	        // console.log('dataStringGraph2 stringify ------> ', dataReasonGraph2);
	
	        if (main_bar_val[key].chapter_name !== 'Integrated Reasoning' && main_bar_val[key].chapter_name !== 'Verbal') {
	          if (main_bar_val[key].chapter_name) {
	            main_bar_data[i] = main_bar_val[key].chapter_name;
	            i++;
	          }
	        }
	      });
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 3 Start ----------------//
	      var verbal_bar_val = this.state.verbal_progress_bar_zero;
	      var verbal_bar_percentage = this.state.verbal_bar_main_user;
	
	      var verbal_bar_user_percentage = this.state.verbal_bar_main_class;
	
	      var verbal_main_bar_data = [];
	      var i = 0;
	      verbal_bar_val.map(function (data) {
	        verbal_main_bar_data[i] = data.chapter_name;
	        i++;
	      });
	      var verbal_bar_data = {
	        labels: verbal_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: verbal_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: verbal_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 3 End ----------------//
	
	      // ------------------ FOR Graph 4 Start ----------------//
	      var integrated_reasoning_bar_val = this.state.integrated_reasoning_progress_bar_zero;
	      var integrated_reasoning_bar_percentage = this.state.integrated_reasoning_bar_main_user;
	
	      var integrated_reasoning_bar_user_percentage = this.state.integrated_reasoning_bar_main_class;
	
	      var integrated_reasoning_main_bar_data = [];
	      var i = 0;
	      integrated_reasoning_bar_val.map(function (data) {
	        integrated_reasoning_main_bar_data[i] = data.chapter_name.substring(0, 20);
	        i++;
	      });
	      var integrated_reasoning_bar_data = {
	        labels: integrated_reasoning_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: integrated_reasoning_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: integrated_reasoning_bar_user_percentage
	        }]
	      };
	
	      // ------------------ FOR Graph 4 End ----------------//
	
	      /*other graph*/
	      // let chapters = this.state.progress_bar_zero;
	      var chapters = this.state.progress_bar_zero;
	
	      var reading_data = '';
	      // alert(this.state.subreadings_status);
	      if (this.state.progress_bar_zero.length && !this.state.subreadings_status) {
	        chapters.reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	          );
	        });
	      }
	      if (this.state.progress_bar_zero.length && this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	            )
	          );
	        });
	      }
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteVideoFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSavequestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_QUESTIONS,
	          ' '
	        );
	      }
	
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSaveVideo.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditQuesReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleQuestionReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this8.toggleAlertReport.bind(_this8, items, 'quesReport'),
	                  className: _this8.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsquestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditVideoReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleVideoReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8.toggleAlertReport.bind(_this8, items, 'videoReport'),
	                    className: _this8.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsVideo.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  'Executive Assessment Dashboard'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE_BY_AREA,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: main_ea_bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUANT_PROBLEM,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().VERBAL_PROBLEM,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: verbal_bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().INTEGRATED_REASONING_QUESTIONS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: integrated_reasoning_bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: 'dashboard-card-header-tab ' + (activeTabSaved === '1' ? 'mb-1' : '')
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: 'auto' } },
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                activeTabSaved === '1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    this.state.content_type.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          onClick: function onClick() {
	                            _this8.contentTypeTabToggle(index);
	                          },
	                          key: index,
	                          className: activeTabSavedcards === index ? 'active' : ''
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          ' ',
	                          item,
	                          ' '
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : // : this.state.activeTabSaved === '2'
	                      // ? savednotes_data
	                      savedvideo_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: 'dashboard-card-header-tab ' + (activeTabReports === '1' ? 'mb-1' : '')
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: 'auto' } },
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                activeTabReports === '1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    this.state.content_type.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          onClick: function onClick() {
	                            _this8.contentTypeReportTabToggle(index);
	                          },
	                          key: index,
	                          className: activeTabReportcards === index ? 'active' : ''
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          ' ',
	                          item,
	                          ' '
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : // : this.state.activeTabReports === '2'
	                      // ? notes_reportsData
	                      this.state.activeTabReports === '3' ? video_reportsData : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.toggleClose },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        this.state.display_loader === 'hide_block' ? null : _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return GMATDashboard;
	}(_react.Component);
	
	GMATDashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var bar_data_sub = [];
	var reading_text = '';
	function Barget(props) {
	  if (props.subreadings_status && props.endDate != '') {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: props.startDate,
	      endDate: props.endDate
	    };
	  } else {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: '',
	      endDate: ''
	    };
	  }
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/subProgressbar', data).then(function (resp) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_dashboard/subProgressbarofclass', data).then(function (resp_class) {
	      /*class variable */
	      var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
	      var dataReason_class = JSON.parse(dataString_class);
	
	      var final_array_main_class = [];
	
	      for (i = 0; i < dataReason_class.length; i++) {
	        var right_answered_class = dataReason_class[i].right_answer;
	        var total_question_class = dataReason_class[i].total_questions;
	        var user_graph_val_class = (right_answered_class / total_question_class * 100).toFixed(2);
	        final_array_main_class.push(user_graph_val_class);
	      }
	      /*user variable*/
	      var dataString = JSON.stringify(resp.readingwisebar_ret);
	      var dataReason = JSON.parse(dataString);
	
	      var final_array_main = [];
	      var reading_text = [];
	
	      for (i = 0; i < dataReason.length; i++) {
	        var right_answered = dataReason[i].right_answer;
	        var total_question = dataReason[i].total_questions;
	
	        var user_graph_val = (right_answered / total_question * 100).toFixed(2);
	
	        final_array_main.push(user_graph_val);
	        reading_text.push(dataReason[i].reading);
	      }
	
	      bar_data_sub[props.answered_state] = {
	        labels: reading_text,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(114,195,250)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(114,195,250)',
	          data: final_array_main
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: final_array_main_class
	        }]
	      };
	    });
	  });
	  return _react2.default.createElement(_reactChartjs.Bar, { data: bar_data_sub[props.answered_state], options: { maintainAspectRatio: false } });
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATDashboard;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(6);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ForwardTimer = __webpack_require__(241);
	
	var _ForwardTimer2 = _interopRequireDefault(_ForwardTimer);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { getDeviceDetails } from '../../common/deviceDetails';
	
	/* eslint-disable*/
	
	
	var EABeginchapters = function (_Component) {
	  _inherits(EABeginchapters, _Component);
	
	  function EABeginchapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, EABeginchapters);
	
	    var _this = _possibleConstructorReturn(this, (EABeginchapters.__proto__ || Object.getPrototypeOf(EABeginchapters)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_READING.replace(':id', _this.props.params.notesid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', _this.props.params.notesid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.questions.name)
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        isError: false,
	        isFlashCardHidden: true,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      _this.setState({ clicked: false, choice: '' });
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (i === 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      }
	      var questions = _this.state.questions;
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      if (questions.right_choice == 'choice_a') {
	        _this.setState({ choice_name: 'A' });
	      } else if (questions.right_choice == 'choice_b') {
	        _this.setState({ choice_name: 'B' });
	      } else if (questions.right_choice == 'choice_c') {
	        _this.setState({ choice_name: 'C' });
	      } else if (questions.right_choice == 'choice_d') {
	        _this.setState({ choice_name: 'D' });
	      } else if (questions.right_choice == 'choice_e') {
	        _this.setState({ choice_name: 'E' });
	      }
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_BEGINCHAPTER.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i)
	
	        // '/beginchapter/' +
	        // this.props.params.notesid +
	        // '/' +
	        // this.props.params.readingid +
	        // '/' +
	        // next_question_id +
	        // '/' +
	        // i,
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        isError: false,
	        isFlashCardHidden: true,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      _this.setState({ clicked: false, choice: '' });
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	      // alert(i);
	      //console.log(this.props.params.readingid);
	      _this.setState({ offset: i });
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	
	      if (parseInt(_this.state.question_length) - 1 === i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i != 0) {
	        _this.setState({ previ_block: '' });
	      }
	      var questions = _this.state.questions;
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      if (questions.right_choice == 'choice_a') {
	        _this.setState({ choice_name: 'A' });
	      } else if (questions.right_choice == 'choice_b') {
	        _this.setState({ choice_name: 'B' });
	      } else if (questions.right_choice == 'choice_c') {
	        _this.setState({ choice_name: 'C' });
	      } else if (questions.right_choice == 'choice_d') {
	        _this.setState({ choice_name: 'D' });
	      } else if (questions.right_choice == 'choice_e') {
	        _this.setState({ choice_name: 'E' });
	      }
	      var next_question_id = _this.state.all_questions_state[i].id;
	      // console.log(this.state.token)
	      // console.log(this.state.idname)
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_BEGINCHAPTER.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i)
	
	        // '/beginchapter/' +
	        // this.props.params.notesid +
	        // '/' +
	        // this.props.params.readingid +
	        // '/' +
	        // next_question_id +
	        // '/' +
	        // i,
	      });
	    };
	
	    _this._getAnswer = function (choice, e) {
	      _this.setState({ clicked: true });
	      _this.setState({ choice: choice });
	      // const result = getDeviceDetails();
	
	      if (choice === 'choice_a') {
	        _this.setState({ choice_a: 'answer_box clicked_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_b') {
	        _this.setState({ choice_b: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_c') {
	        _this.setState({ choice_c: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_d') {
	        _this.setState({ choice_d: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box ' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_e') {
	        _this.setState({ choice_e: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this.handleQuestionValidate = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var chosen_answer, right_answer, _this$state, token, idname, time_done, selected_choice, question_id, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_this.state.clicked) {
	                  _context2.next = 14;
	                  break;
	                }
	
	                clearInterval(_this.timer);
	                chosen_answer = _this.state.choice;
	                right_answer = 0;
	
	                _this.setState({ result_block: 'card show_block', isTimer: false });
	                if (item.right_choice === _this.state.choice) {
	                  right_answer = 1;
	                  if (_this.state.choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
	                  } else if (_this.state.choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
	                  } else if (_this.state.choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
	                  } else if (_this.state.choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
	                  } else if (_this.state.choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
	                  }
	
	                  _this.setState({
	                    result: '' + _language2.default.LC().CORRECT,
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block'
	                  });
	                } else {
	                  right_answer = 0;
	                  if (_this.state.choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box failure' });
	                  }
	                  if (item.right_choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
	                  } else if (item.right_choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
	                  } else if (item.right_choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
	                  } else if (item.right_choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
	                  } else if (item.right_choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
	                  }
	                  _this.setState({
	                    text_color: 'card-header text_failure',
	                    result: '' + _language2.default.LC().INCORRECT,
	                    result_block: 'card show_block'
	                  });
	                }
	
	                if (_this.state.validated) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                _this$state = _this.state, token = _this$state.token, idname = _this$state.idname, time_done = _this$state.count, selected_choice = _this$state.choice;
	                question_id = item.id;
	                data = {
	                  token: token,
	                  idname: idname,
	                  question_id: question_id,
	                  right_answer: right_answer,
	                  time_done: time_done,
	                  selected_choice: selected_choice
	                };
	                _context2.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({ ValidToken: true, validated: true });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                _context2.next = 15;
	                break;
	
	              case 14:
	                _this.setState({
	                  isError: true
	                });
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      console.log('item ----------->', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              isFlashCardHidden: false
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // Guard against reporting before the question has loaded — same shape
	      // of bug as Cases.js (an empty-object fallback at render time gets
	      // passed as `item`, then `question_id: item.id` is undefined → row
	      // lands with question_id=null and admin auto-reply can't surface the
	      // question text).
	      if (!item || !item.id) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-sm-12 col-md-12 display_block',
	        isEditable: true
	      });
	
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-sm-12 col-md-12 display_block',
	            isEditable: false
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.setQuestionState = function (questionDetails) {
	      _this.setState({ questions: questionDetails }, function () {
	        var selectedChoice = questionDetails['ea_question_stat.isSelectedChoice'];
	        var hasSelectedChoice = selectedChoice !== null && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.EA);
	        var right_choice = questionDetails.right_choice;
	
	        _this.setState({
	          choice_name: _constant.CHOICE_MAPPING[right_choice] || '',
	          isSelectedChoice: selectedChoice || null,
	          choice: hasSelectedChoice ? _this.getSelectedChoice(questionDetails, selectedChoice) : null,
	          clicked: hasSelectedChoice,
	          count: questionDetails['ea_question_stat.time_done'] || 0,
	          isTimer: !hasSelectedChoice,
	          validated: hasSelectedChoice,
	          result_block: 'card ' + (hasSelectedChoice ? 'show_block' : 'hide_block')
	        }, function () {
	          if (hasSelectedChoice) {
	            _this.handleQuestionValidate(questionDetails);
	          }
	        });
	      });
	    };
	
	    _this.getSelectedChoice = function (question, selected) {
	      if (selected === 1) {
	        return question.right_choice;
	      }
	
	      var selectedChoice = question['ea_question_stat.selected_choice'];
	      if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
	        return selectedChoice;
	      }
	
	      var wrongChoices = _constant.CHOICE_KEYS.filter(function (choice) {
	        return choice !== question.right_choice;
	      });
	      var randomWrong = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];
	
	      return randomWrong;
	    };
	
	    _this._displayOuterElement = function () {
	      // console.log("working");
	      var d = document.getElementById('d');
	      // console.log("dsacds");
	      // console.log(d.outerHTML);
	    };
	
	    _this.onTick = function (time) {
	      _this.setState({
	        count: time
	      });
	    };
	
	    _this.setAnswer = function (answer) {
	      _this.setState({ choice: answer[0], clicked: true, isError: false });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      reportLoading: false,
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      successAlert: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      isError: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      // flash_form : 'col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      display_loader: 'show_block',
	      selectedmenu: 'ea',
	      subscriptionstatus: '',
	      chapter_name: '',
	      isEditable: false,
	      all_questions: '',
	      category: 'EA',
	      tags: ['ea', 'question'],
	      title: '',
	      description: '',
	      forumComment: '',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      choice_name: '',
	      isTimer: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(EABeginchapters, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	
	    //Function to redirect page to readings page
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	
	    //Function to check Right Or Wrong Answered and displayed clicked box
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to show Correct box and display right answer and store in database
	
	
	    //Function to Display Saved Question on button and save in database
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Funcion to save new report question
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/UpdateEARatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1 });
	            _this3.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({ rating: items.ratting });
	              _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveEARatting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1 });
	                _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveEARatting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({ rated: 1 });
	              _this3.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this4 = this;
	
	        var result, storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context5.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context5.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                user_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 6;
	                              break;
	                            }
	
	                            _this4._runCode('free');
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context4.next = 11;
	                            break;
	
	                          case 6:
	                            _this4.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context3.next = 6;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context3.sent;
	
	                                        if (isInArray_var) {
	                                          _this4._runCode('paid');
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4._runCode('free');
	                                          _this4.setState({ subscriptionstatus: 'free' });
	                                        }
	                                        _context3.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this4);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context4.next = 14;
	                            break;
	
	                          case 13:
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                              _this4._runCode('free');
	                              _this4.setState({ subscriptionstatus: 'free' });
	                            } else {
	                              _this4.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this4.state.token,
	                                idname: _this4.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this4.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    _this4._runCode('paid');
	                                    _this4.setState({ subscriptionstatus: 'paid' });
	                                  } else {
	                                    _this4._runCode('free');
	                                    _this4.setState({ subscriptionstatus: 'free' });
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 14:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this4);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: '_runCode',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(subscriptionstatus) {
	        var _this5 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                // console.log("subscriptionstatus")
	                // console.log(subscriptionstatus)
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  subscriptionstatus: subscriptionstatus
	                };
	                // console.log('data------------------------', data);
	                /*Api to call all question by chapter ,reading wise without limit and offset*/
	
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestions_allcr', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var questionDetails, offset_res, i, retun_all_question, all_questions, params;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            console.log('resp------------------------------>----------------------------------------------------------------------', resp);
	
	                            if (!resp.success) {
	                              _context6.next = 26;
	                              break;
	                            }
	
	                            _this5.setState({ ValidToken: true });
	                            _this5.setState({ all_questions_state: resp.questions });
	                            questionDetails = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this5.props.params.id) {
	                                questionDetails = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i == resp.questions.length - 1) {
	                                _this5.setState({ choice: '', clicked: false, display_loader: 'hide_block' });
	                              }
	                            }
	                            _this5.setQuestionState(questionDetails);
	                            _this5.setState({ questions: questionDetails }, function () {
	                              if (questionDetails.right_choice == 'choice_a') {
	                                _this5.setState({ choice_name: 'A' });
	                              } else if (questionDetails.right_choice == 'choice_b') {
	                                _this5.setState({ choice_name: 'B' });
	                              } else if (questionDetails.right_choice == 'choice_c') {
	                                _this5.setState({ choice_name: 'C' });
	                              } else if (questionDetails.right_choice == 'choice_d') {
	                                _this5.setState({ choice_name: 'D' });
	                              } else if (questionDetails.right_choice == 'choice_e') {
	                                _this5.setState({ choice_name: 'E' });
	                              }
	                            });
	                            _context6.next = 11;
	                            return _this5.setState({
	                              offset: offset_res,
	                              question_length: resp.questions.length
	                            });
	
	                          case 11:
	                            retun_all_question = JSON.stringify(_this5.state.questions);
	                            all_questions = JSON.parse(retun_all_question);
	                            _context6.next = 15;
	                            return _this5.setState({ all_questions: all_questions });
	
	                          case 15:
	
	                            if (offset_res == 0) {
	                              _this5.setState({ previ_block: 'card hide_block' });
	                            }
	
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this5.setState({ next_block: 'card hide_block' });
	                            }
	
	                            params = {
	                              token: _this5.state.token,
	                              question_id: questionDetails.id,
	                              idname: _this5.state.idname
	                            };
	                            //Api to Fetch saved question stats
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavQuestions', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({
	                                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                                  isFlashCardHidden: false
	                                });
	                                _this5.setState({
	                                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                                });
	                                _this5.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	                                _this5.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	                              } else {
	                                _this5.setState({ isFlashCardHidden: true });
	                              }
	                            });
	                            params = {
	                              token: _this5.state.token,
	                              question_id: questionDetails.id,
	                              idname: _this5.state.idname
	                            };
	                            //Api to get ratting
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({ rated: true });
	                                response.ratting.map(function (items) {
	                                  _this5.setState({ rating: items.ratting });
	                                  _this5.setState({ ratting_text: '' + _language2.default.LC().RATED });
	                                });
	                              }
	                            });
	                            params = {
	                              token: _this5.state.token,
	                              idname: _this5.state.idname,
	                              question_id: questionDetails.id
	                            };
	                            //Api to fetch flashcard by question id
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashCards', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({ ValidToken: true });
	                                if (response.flash_cards.length > 0) {
	                                  _this5.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                                  var flash_cards = response.flash_cards.map(function (items, index) {
	                                    return (
	                                      //alert(items.id)
	                                      _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: '' },
	                                          _react2.default.createElement(
	                                            'ul',
	                                            { className: 'icon_list' },
	                                            _react2.default.createElement(
	                                              'li',
	                                              null,
	                                              _react2.default.createElement(
	                                                'a',
	                                                {
	                                                  className: 'pointer_class',
	                                                  onClick: _this5._editFlash.bind(_this5, items)
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                              )
	                                            ),
	                                            _react2.default.createElement(
	                                              'li',
	                                              null,
	                                              _react2.default.createElement(
	                                                'a',
	                                                {
	                                                  className: 'pointer_class',
	                                                  onClick: _this5._deleteFlash.bind(_this5, items)
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-close' })
	                                              )
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: _this5.state.flash_class },
	                                            _react2.default.createElement('h4', null),
	                                            _react2.default.createElement(
	                                              'p',
	                                              null,
	                                              items.flash_card
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  });
	                                } else {
	                                  _this5.setState({
	                                    flash_form: 'col-sm-12 col-md-12 display_block'
	                                  });
	                                  var flash_cards = _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _language2.default.LC().NO_FLASHCARD_FOUND
	                                  );
	                                }
	                                _this5.setState({ flash_data: flash_cards });
	                              } else {
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                                _this5.setState({ ValidToken: false });
	                                _this5.setState({ flash_data: flash_cards });
	                                _this5.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	                              }
	                              return response;
	                            });
	
	                            _this5.setState({ records: '' });
	                            _context6.next = 28;
	                            break;
	
	                          case 26:
	                            _this5.setState({ ValidToken: false });
	                            _this5.setState({ records: '' + _language2.default.LC().Result_not_found });
	
	                          case 28:
	                            return _context6.abrupt('return', resp);
	
	                          case 29:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this5);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getChapterbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this5.setState({ chapter_name: resp.chapters[0].chapter_name });
	                  } else {
	                    // console.log('Chapter Name Not Found');
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function _runCode(_x6) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return _runCode;
	    }()
	
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      //console.log(this.props);
	      // var subscription=this.state.subscriptionstatus;
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	  }, {
	    key: '_changeContent',
	
	    /*on url change run this function*/
	
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val, subscription) {
	      var _this6 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      // console.log("subscriptionstatus")
	      // console.log(this.state.subscriptionstatus)
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block'
	          });
	          var questionDetails = [];
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (resp.questions[i].id == _this6.props.params.id) {
	              questionDetails = resp.questions[i];
	            }
	          }
	          var questions = _this6.state.questions;
	
	
	          _this6.setState({ questions: questionDetails }, function () {
	            if (questions.right_choice == 'choice_a') {
	              _this6.setState({ choice_name: 'A' });
	            } else if (questions.right_choice == 'choice_b') {
	              _this6.setState({ choice_name: 'B' });
	            } else if (questions.right_choice == 'choice_c') {
	              _this6.setState({ choice_name: 'C' });
	            } else if (questions.right_choice == 'choice_d') {
	              _this6.setState({ choice_name: 'D' });
	            } else if (questions.right_choice == 'choice_e') {
	              _this6.setState({ choice_name: 'E' });
	            }
	          });
	
	          _this6.setQuestionState(questionDetails);
	
	          _this6.setState({ display_loader: 'hide_block' });
	          var params = {
	            token: _this6.state.token,
	            question_id: questionDetails.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavQuestions', params).then(function (response) {
	            // console.log(response);
	            // console.log("getFavQuestions");
	            if (response.success) {
	              _this6.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this6.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this6.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this6.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	          var params = {
	            token: _this6.state.token,
	            question_id: questionDetails.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ rated: true });
	              response.ratting.map(function (items) {
	                _this6.setState({ rating: items.ratting });
	                _this6.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              });
	            }
	          });
	          var params = {
	            token: _this6.state.token,
	            idname: _this6.state.idname,
	            question_id: questionDetails.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this6.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this6._deleteFlash.bind(_this6, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this6.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this6.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this6.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this6.setState({ ValidToken: false });
	              _this6.setState({ flash_data: flash_cards });
	              _this6.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	            }
	            return response;
	          });
	          _this6.setState({ records: '' });
	        } else {
	          _this6.setState({ ValidToken: false });
	          _this6.setState({ records: '' + _language2.default.LC().Result_not_found });
	        }
	
	        return resp;
	      });
	      this.setState({ timer_stop: false });
	      this.setState({ timer_tag: '' + _language2.default.LC().STOP });
	      this.setState({ count: 0 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      // console.log(
	      //   'this.state.choice_namethis.state.choice_name',
	      //   this.state.choice_name
	      // );
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          validated = _state.validated,
	          choice = _state.choice,
	          isTimer = _state.isTimer,
	          count = _state.count,
	          isError = _state.isError;
	
	      var forumData = '';
	      var data = '';
	      var choice_a = 'choice_a';
	      var choice_b = 'choice_b';
	      var choice_c = 'choice_c';
	      var choice_d = 'choice_d';
	      var choice_e = 'choice_e';
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      var retun_all_question = JSON.stringify(this.state.questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        forumData = '<div class="col-sm-12 no-cursor" >\n            <div class="margin_bottom_40">\n                <div >\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="row no-cursor">\n                                <div class="col-sm-12 cursor-text">\n                                    <div contentEditable=\'false\' class="margin_bottom_40 view_questionhtml bg_blue "> ' + all_questions.question + ' </div>\n                                </div>\n                                <div class="col-sm-12 no-cursor" id="choice_a" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().A + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_a + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 no-cursor" id="choice_b">\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().B + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>  ' + all_questions.choice_b + ' </span></p>\n                                    </div>\n                                </div>\n                                \n                                <div class="col-sm-12 no-cursor" id="choice_c" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().C + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>\n                                        ' + all_questions.choice_c + '\n                                        </span></p>\n                                    </div>\n                                    </div>\n\n                                    <div class="col-sm-12 no-cursor" id="choice_d" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().D + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_d + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 no-cursor margin_bottom_30" id="choice_e" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().E + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_e + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 cursor-text">\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> \n                                  ' + _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + this.state.choice_name + ').</p>\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> ' + all_questions.answer + '</p>\n                                </div>\n                                <div class="col-sm-12 margin_bottom_30 no-cursor">\n\n                                <div class="userQuestionDiv">\n                                <span class="questionColor cursor-text"> *User Question: </span>\n                                <div class="forum-data-comment cursor-text">\n                                  <h4> ' + this.state.forumComment + ' \n                                  </h4>\n                                </div>\n                                </div>\n                              </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>';
	
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, 'span', '', { contentEditable: false }),
	              ' (',
	              _language2.default.LC().Q,
	              ' ',
	              all_questions.id,
	              ')',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_ViewQuestion2.default, Object.assign({}, questions, this.props, {
	                      setAnswer: this.setAnswer,
	                      showAnswer: validated,
	                      correctChoice: questions && questions.right_choice,
	                      selectedChoice: choice
	                    })),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      isError && _react2.default.createElement(
	                        'p',
	                        { className: 'text-danger' },
	                        messages.NO_CHOICE_SELECTED
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          showResult: validated,
	                          _getResult: this.handleQuestionValidate,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: all_questions,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'star_rating_wrap' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: ' margin_bottom_0 margin_right_10' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(_reactStarRatings2.default, {
	                              rating: this.state.rating,
	                              starRatedColor: 'rgb(255, 180, 0)',
	                              starEmptyColor: 'rgb(51, 51, 51)',
	                              starDimension: '20px',
	                              starHoverColor: 'rgb(255, 180, 0)',
	                              starSpacing: '2px',
	                              changeRating: this.onStarClick.bind(this, all_questions),
	                              numberOfStars: 5,
	                              name: 'rate1'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(_ForwardTimer2.default, {
	                    isRunning: isTimer,
	                    startTimeInSeconds: count,
	                    validated: validated,
	                    onTick: function onTick(time) {
	                      return _this7.onTick(time);
	                    },
	                    toggleTimer: function toggleTimer() {
	                      return _this7.setState({ isTimer: !_this7.state.isTimer });
	                    }
	                  }),
	                  this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	                    'a',
	                    {
	                      onClick: this._getSubscribe,
	                      className: 'box_question_color text-center cursor_pointer'
	                    },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS,
	                      ' '
	                    )
	                  ) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().THE_CORRECT_ANSWER_IS,
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.choice_name,
	                  '.'
	                )
	              ),
	              (0, _function.renderHTMLContent)(all_questions.answer, 'p', 'view_questionhtml', {
	                contentEditable: false
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this._reportQuestion.bind(this, all_questions)
	                    },
	                    ' ',
	                    reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, all_questions)
	                    },
	                    ' ',
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else {
	        /*data = <div className="col-sm-12 col-md-12">
	            <div className="no_data_bar card">No Records Found</div></div>;*/
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_10 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUESTION_BANK
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getQuestions
	                },
	                _language2.default.LC().CHANGE_QUESTIONS
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_CHAPTER
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'question',
	            question_type: 'question',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'ea'
	          })
	        ),
	        this.state.display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null
	      );
	    }
	  }]);
	
	  return EABeginchapters;
	}(_react.Component);
	
	EABeginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = EABeginchapters;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionBank = function (_Component) {
	  _inherits(QuestionBank, _Component);
	
	  function QuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (QuestionBank.__proto__ || Object.getPrototypeOf(QuestionBank)).call(this, props));
	
	    _this.getReadings = function (chapter) {
	      // console.log('chapterchapterchapterchapterchapterchapterchapter', chapter);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_READING.replace(':id', chapter.chapter_no)
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: chapter.chapter_no,
	        //   chapterName: chapter.chapter_name,
	        // },
	      });
	    };
	
	    _this.goToQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.EA_BEGINCHAPTER.replace(':notesid', lastRecord.ea_question.chapter_id).replace(':readingid', lastRecord.ea_question.reading_id).replace(':id', lastRecord.ea_question.id).replace(':offset', 0)
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      readingsCount: [],
	      token: '',
	      lastRecord: '',
	      lastAttempt: false,
	      idname: '',
	      freeChapterCount: [],
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(QuestionBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ alert_status: !this.state.alert_status });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getChapters', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context2.next = 6;
	                    break;
	                  }
	
	                  _this3.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    eaIRCount: resp.eaIRCount,
	                    IRPremiumQuestionCount: resp.IRPremiumQuestionCount,
	                    freeChapterCount: resp.freeChapterCount,
	                    readingsCount: resp.grouped
	                  });
	                  _context2.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context2.next = 7;
	                  break;
	
	                case 6:
	                  _this3.setState({ ValidToken: false });
	
	                case 7:
	                  return _context2.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          chapters = _state.chapters,
	          readingsCount = _state.readingsCount,
	          countFree = _state.freeChapterCount,
	          eaIRCount = _state.eaIRCount,
	          IRPremiumQuestionCount = _state.IRPremiumQuestionCount;
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      if (this.state.chapters.length && this.state.freeChapterCount.length) {
	        var count = 1;
	        data = chapters.map(function (item, index) {
	          return countFree.map(function (itemFree) {
	            var countedReadingData = readingsCount.findIndex(function (chapter) {
	              return chapter.chapter_no === item.chapter_no ? chapter : null;
	            });
	            return item.chapter_no === itemFree.id ? _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: index
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id,
	                  onClick: _this4.getReadings.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    className: '',
	                    width: '54',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'pointer_class',
	                      id: item.chapter_name,
	                      value: item.chapter_no,
	                      onClick: _this4.getReadings.bind(_this4, item)
	                    },
	                    count++,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                        className: '',
	                        width: '25',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      readingsCount[countedReadingData].Countreading
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().TOTAL_READINGS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.chapter_no !== 2 ? item.free_questions : eaIRCount
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().FREE_QUESTIONS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.chapter_no !== 2 ? readingsCount[countedReadingData].Countquestion : IRPremiumQuestionCount
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().PREMIUM_QUESTIONS
	                    )
	                  )
	                )
	              )
	            ) : null;
	          });
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().CFA_LEVEL_I_QUESTION_BANK,
	            ' '
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.EA }),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return QuestionBank;
	}(_react.Component);
	
	QuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionBank;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _questionNotFoundModel = __webpack_require__(104);
	
	var _questionNotFoundModel2 = _interopRequireDefault(_questionNotFoundModel);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import App_data from "../config/App_data";
	
	// import GD from "../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var EAReadings = function (_Component) {
	  _inherits(EAReadings, _Component);
	
	  function EAReadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, EAReadings);
	
	    var _this = _possibleConstructorReturn(this, (EAReadings.__proto__ || Object.getPrototypeOf(EAReadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_QUESTION_BANK
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      // console.log('get00000=m,j,hjjkkjkj', reading);
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log('resp.profileInfo.userStatus', resp.profileInfo);
	
	                        _context.next = 6;
	                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var) {
	                          _this._runCode('paid', reading);
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free', reading);
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 10:
	                        console.log('fail');
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this._runCode('paid', reading);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free', reading);
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      // console.log('reading----------------------------', reading);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: _this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: _this.state.subscriptionstatus
	      };
	      if (reading.type === 'case_question') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCaseByReading', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.questions.length) {
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':caseid', resp.questions[0].case_id).replace(':case_offset', 0).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', resp.questions[0].question_no).replace(':offset', 0)
	              });
	            } else {
	              _this.toggleAlert();
	            }
	          }
	        });
	      } else if (reading.type === 'tab_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_TAB.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'graph_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_GRAPH_MULTI_STATEMENT.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'table_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_TABLE.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'two_part_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_TWO_PART_STATEMENT.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestions', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.questions.length) {
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.EA_BEGINCHAPTER.replace(':notesid', _this.state.chapterid).replace(':readingid', reading.id).replace(':id', resp.questions[0].id).replace(':offset', 0)
	              });
	            } else {
	              _this.toggleAlert();
	            }
	          }
	        });
	      }
	    };
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context5.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context5.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context5.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context5.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context5.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context4.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context2.next = 6;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context4.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context4.next = 17;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context4.next = 23;
	                            break;
	
	                          case 17:
	                            // console.log(
	                            //   'resssssssssssssssss-----------',
	                            //   resp.profileInfo.subscription_details
	                            // );
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context3.next = 6;
	                                        return _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context3.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context3.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context3.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context3.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context3.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context9.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context9.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context9.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context9.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context9.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context8.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context6.next = 6;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context6.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context8.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context8.next = 17;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context8.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context7.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context7.next = 6;
	                                        return _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context7.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context7.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context7.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context7.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context7.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x6) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      alert_status_question_not_found: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	
	      MessageTitleOnQuestionNotFound: '' + _language2.default.LC().MESSAGE,
	      ComingSoon: '' + _language2.default.LC().COMING_SOON,
	
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.id,
	      chapterName: '',
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'ea',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFDownloadType: 'Question',
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(EAReadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      if (this.state.subscriptionstatus === 'free') {
	        this.setState({
	          alert_status: !this.state.alert_status
	        });
	      } else {
	        this.setState({
	          alert_status_question_not_found: !this.state.alert_status_question_not_found
	        });
	      }
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    //it is use to redirect page
	
	
	    //Function to redirect page to question bank page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus, reading) {
	      var _this3 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: reading.id,
	        chapter_id: this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length || reading.type !== 'case_question') {
	            // console.log('reading.type', reading);
	            _this3.context.router.push({
	              pathname: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', reading.chapter_no).replace(':id', reading.id).replace(':subscriptionstatus', subscriptionstatus).replace(':reading', reading.reading)
	            });
	            // }
	          } else {
	            _this3.toggleAlert();
	          }
	        }
	      });
	    }
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this4 = this;
	
	        var result, storage_session, data, user_data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.chapterid
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this4.setState({ no_result_display: 'No Saved Questions' });
	                    }
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                    (0, _toast.showFailure)('No readings found!!');
	                  }
	                  // return resp;
	                });
	
	                user_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context12.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context11.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context11.next = 5;
	                              break;
	                            }
	
	                            _this4.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context11.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this4.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, isInArray_var_PDF;
	                                return _regenerator2.default.wrap(function _callee10$(_context10) {
	                                  while (1) {
	                                    switch (_context10.prev = _context10.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context10.next = 15;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        isInArray_var_PDF = false;
	                                        _context10.next = 7;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 7:
	                                        isInArray_var = _context10.sent;
	
	                                        if (isInArray_var) {
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4.setState({
	                                            subscriptionstatus: 'free',
	                                            showFreePremium: true
	                                          });
	                                        }
	                                        _context10.next = 11;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, _this4.state.type);
	
	                                      case 11:
	                                        isInArray_var_PDF = _context10.sent;
	
	
	                                        // console.log('isInArray_var_PDF', isInArray_var_PDF);
	                                        if (isInArray_var_PDF) {
	                                          _this4.setState({ showFreePremium: false });
	                                        } else {
	                                          _this4.setState({ showFreePremium: true });
	                                        }
	                                        _context10.next = 15;
	                                        break;
	
	                                      case 15:
	                                      case 'end':
	                                        return _context10.stop();
	                                    }
	                                  }
	                                }, _callee10, _this4);
	                              }));
	
	                              return function (_x11) {
	                                return _ref12.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context11.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context11.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this4.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context11.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this4.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              // console.log(resp_exam);
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this4.state.selectedmenu;
	                                var isInArray_var = false;
	                                var isInArray_var_PDF = false;
	                                isInArray_var = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this4.setState({ subscriptionstatus: 'paid' });
	                                } else {
	                                  _this4.setState({
	                                    subscriptionstatus: 'free',
	                                    showFreePremium: true
	                                  });
	                                }
	                                isInArray_var_PDF = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, _this4.state.type);
	                                if (isInArray_var_PDF) {
	                                  _this4.setState({ showFreePremium: false });
	                                } else {
	                                  _this4.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this4);
	                  }));
	
	                  return function (_x10) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    /*
	    ------------------------------
	    PDF DOWNLOAD Via Email
	    -------------------------------
	    */
	
	    /*
	    --------------------------------
	    PDF DOWNLOAD Via email Answer
	    --------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          // console.log('item----------------', item.type);
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading_no,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            item.type === 'no_question' ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20 coming_soon_table' },
	                '-'
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: _this5._getQuestions.bind(_this5, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this5._beginChapter.bind(_this5, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                this.state.chapterName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	              _react2.default.createElement(
	                'div',
	                { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoading ? _language2.default.LC().Download_Question : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  onClick: this.getpdfAnswer.bind(this),
	                  className: 'status-download-btn margin_right_10'
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoadingAnswer ? _language2.default.LC().Download_Question_Answer : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getChapters
	                },
	                ' ',
	                _language2.default.LC().CHANGE_TOPIC,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().READING
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_questionNotFoundModel2.default, {
	          alert_status: this.state.alert_status_question_not_found,
	          toggleAlert: this.toggleAlert,
	          MessageTitle: this.state.MessageTitleOnQuestionNotFound,
	          MessageContent: this.state.ComingSoon
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return EAReadings;
	}(_react.Component);
	
	EAReadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = EAReadings;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Tooltip } from 'reactstrap';
	
	
	/* eslint-disable */
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var EACases = function (_Component) {
	  _inherits(EACases, _Component);
	
	  // =============================== TODO START =======================//
	  function EACases(props) {
	    _classCallCheck(this, EACases);
	
	    var _this = _possibleConstructorReturn(this, (EACases.__proto__ || Object.getPrototypeOf(EACases)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.questions.name)
	      });
	    };
	
	    _this._getAnswer = function (choice, questionId) {
	      _this.setState({ clicked: true, choice: 'choice_' + choice }, function () {
	        // console.log('choice ----> ', this.state.choice);
	      });
	      if (choice === 'a') {
	        _this.setState({
	          choice_a: 'answer_box clicked_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'b') {
	        _this.setState({
	          choice_b: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'c') {
	        _this.setState({
	          choice_c: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'd') {
	        _this.setState({
	          choice_d: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'e') {
	        _this.setState({
	          choice_e: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box'
	        });
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: questionId,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this.handleQuestionValidate = function (item, e) {
	      // console.log(this.props.params.chapterid);
	      // console.log('item', item);
	      // console.log(this.props.params.case_offset);
	      // console.log(this.state.clicked, 'clicked');
	      // console.log(this.state.choice, 'this.state.choice');
	      if (_this.state.clicked && _this.state.choice) {
	        clearInterval(_this.timer);
	        // const chosen_answer = this.state.choice;
	        var right_answer = 0;
	        _this.setState({ result_block: 'card show_block' });
	        //console.log(item);
	        if (item.right_choice === _this.state.choice) {
	          right_answer = 1;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box failure'
	            });
	          }
	          if (item.right_choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.right_choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: 'INCORRECT',
	            result_block: 'card show_block'
	          });
	        }
	        if (!_this.state.validated) {
	          var _this$state = _this.state,
	              token = _this$state.token,
	              idname = _this$state.idname,
	              time_done = _this$state.count,
	              selected_choice = _this$state.choice;
	          var question_id = item.id;
	          var _this$props$params = _this.props.params,
	              chapter_id = _this$props$params.chapterid,
	              caseIndex = _this$props$params.case_offset;
	
	          var data = {
	            token: token,
	            idname: idname,
	            question_id: question_id,
	            right_answer: right_answer,
	            time_done: time_done,
	            chapter_id: chapter_id,
	            caseIndex: caseIndex,
	            selected_choice: selected_choice
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveStats', data).then(function (resp) {
	            if (resp.success) {
	              _this.setState({ ValidToken: true, validated: true, isError: false });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      } else {
	        _this.setState({
	          isError: true
	        });
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false, timer_tag: 'Stop' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({
	          timer_stop: true
	        });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      console.log('save Question ------> ', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // Guard against reporting before the question has loaded. The render
	      // method falls back to `questions_data_display = questions || {}`
	      // (line ~1645) when `this.state.questions` is undefined, which then
	      // gets passed as `item`. Without this guard, `item.id` is undefined,
	      // the FE sends `question_id: undefined` → JSON drops the key →
	      // ea_ques_reports row lands with question_id=null, no FK to anything,
	      // and the admin auto-reply has no question to summarise (the user
	      // just sees an empty reported_item). Bail silently — the comment
	      // wasn't tied to a question anyway.
	      if (!item || !item.id) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          caseid = _this$props$params2.caseid,
	          case_offset = _this$props$params2.case_offset,
	          readingid = _this$props$params2.readingid;
	
	      if (_this.state.questions.question_number === 6) {
	        _this.setState({ showCompletionQuestion: true });
	      } else {
	        _this.setState({
	          validated: false,
	          isError: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = parseInt(_this.props.params.offset, 10) + 1;
	        _this.setState({ offset: i });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':caseid', caseid).replace(':case_offset', case_offset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_questions_state[i].question_no).replace(':offset', i)
	        });
	      }
	    };
	
	    _this._getNextAnyway = function () {
	      // console.log(this.state.questions)
	      _this.setState({
	        display_loader: 'show_block',
	        showCompletionQuestion: false
	      });
	      if (_this.props.params.question_number === _this.state.casesquestion_length) {
	        _this.setState({
	          validated: false,
	          rated: false,
	          isError: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = 0;
	        _this.setState({ offset: i });
	
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[i].question_number + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: i,
	            offset: 0
	          }
	        });
	      } else {
	        //alert(this.state.casesquestion_length);
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var _i = _this.state.offset + 1;
	        _this.setState({ offset: _i });
	        //alert(i);
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[_i].question_number + '/' + _i,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: _i,
	            offset: _i
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        validated: false,
	        rated: false,
	        isError: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      document.getElementById('comment').value = '';
	      var _this$props$params3 = _this.props.params,
	          chapterid = _this$props$params3.chapterid,
	          caseid = _this$props$params3.caseid,
	          case_offset = _this$props$params3.case_offset,
	          readingid = _this$props$params3.readingid;
	
	      var i = parseInt(_this.props.params.offset, 10) - 1;
	      _this.setState({ offset: i });
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':caseid', caseid).replace(':case_offset', case_offset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_questions_state[i].question_no).replace(':offset', i)
	      });
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block',
	        isError: false
	      });
	      var casesoffset = parseInt(_this.props.params.case_offset, 10) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	        caseid = _this.state.all_cases[casesoffset].case_id;
	
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	        //this.setState({all_cases:caseid});
	        // this.context.router.push({
	        //   pathname:
	        //     '/cfa2_chapter/' +
	        //     this.props.params.chapterid +
	        //     '/' +
	        //     caseid +
	        //     '/' +
	        //     casesoffset +
	        //     '/' +
	        //     '1' +
	        //     '/' +
	        //     0,
	        //   state: {
	        //     token: this.state.token,
	        //     idname: this.state.idname,
	        //     chapterid: this.props.params.chapterid,
	        //     caseid: caseid,
	        //     case_offset: casesoffset,
	        //     question_number: 1,
	        //     offset: 0,
	        //   },
	        // });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block',
	        isError: false
	      });
	      // const casesoffset = parseInt(this.state.cases_offset, 10) + 1;
	      var casesoffset = _this.props.params.case_offset - 1;
	      var caseid = _this.state.all_cases[casesoffset].case_id;
	      if (_this.state.cases_offset === 0) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	      } else {
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.getSelectedChoice = function (question, selected) {
	      console.log('getSelectedChoice', question, selected);
	      if (selected === 1) {
	        return question.right_choice;
	      }
	      var selectedChoice = question['ea_question_stat.selected_choice'];
	      if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
	        return selectedChoice;
	      }
	
	      var wrongChoices = _constant.CHOICE_KEYS.filter(function (choice) {
	        return choice !== question.right_choice;
	      });
	      var randomWrong = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];
	
	      return randomWrong;
	    };
	
	    _this.setQuestionState = function (questionDetails) {
	      var selectedChoice = questionDetails['ea_question_stat.isSelectedChoice'];
	      var hasSelectedChoice = selectedChoice !== null && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.EA);
	      var right_choice = questionDetails.right_choice;
	
	      _this.setState({
	        choice_name: _constant.CHOICE_MAPPING[right_choice] || '',
	        isSelectedChoice: selectedChoice || null,
	        choice: hasSelectedChoice ? _this.getSelectedChoice(questionDetails, selectedChoice) : null,
	        clicked: hasSelectedChoice,
	        validated: hasSelectedChoice,
	        result_block: 'card ' + (hasSelectedChoice ? 'show_block' : 'hide_block')
	      }, function () {
	        if (hasSelectedChoice) {
	          _this.handleQuestionValidate(questionDetails);
	        }
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.expandScreen = function () {
	      _this.setState({
	        isExpand: true
	      });
	      var elem = document.getElementById('Progress1');
	      if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	      } else if (elem.webkitRequestFullscreen) {
	        /* Safari */
	        elem.webkitRequestFullscreen();
	      } else if (elem.msRequestFullscreen) {
	        /* IE11 */
	        elem.msRequestFullscreen();
	      }
	    };
	
	    _this.closeFullscreen = function () {
	      _this.setState({
	        isExpand: false
	      });
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        /* Safari */
	        document.webkitExitFullscreen();
	      } else if (document.msExitFullscreen) {
	        /* IE11 */
	        document.msExitFullscreen();
	      }
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname'],
	        chapter_id: _this.props.params.chapterid
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved,
	            isFlashCardHidden: false
	          });
	        } else {
	          _this.setState({ isFlashCardHidden: true, bookmarkColor: '' });
	        }
	      });
	    };
	
	    _this.getEARatting = function (questionid) {
	      // console.log('I am inside getEARatting', questionid);
	      var params = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname']
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.getFlashCards = function (questionid) {
	      var params = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        question_id: questionid
	      };
	      //Api to fetch flashcard by question id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFlashCards', params).then(function (response) {
	        var flash_cards = _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_FLASHCARD_FOUND
	        );
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          if (response.flash_cards.length > 0) {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	            });
	            flash_cards = response.flash_cards.map(function (items, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _this.state.flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	            });
	          }
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({
	            ValidToken: false,
	            flash_data: flash_cards,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	        }
	        return response;
	      });
	    };
	
	    _this.checkSubscription = function (SubscriptionFile, resp, resp_cases) {
	      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	        //here code for check case id free or not
	        _this.setState({
	          subscriptionstatus: 'free'
	        });
	        if (resp_cases.casesingleData.free === 0) {
	          _this.setState({
	            display_cases: 'hide_block',
	            display_subcription: 'show_block'
	          });
	          _this.toggleAlert();
	        } else {
	          _this.setState({
	            display_cases: 'show_block',
	            display_subcription: 'hide_block'
	          });
	        }
	      } else {
	        _this.setState({
	          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	        });
	        //console.log(resp_cases.casesingleData.free+'----------');
	        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	        var dataset = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          examid: data_arr
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	          if (resp_exam.success) {
	            var exam_data = resp_exam.examData;
	            var selectedmen = _this.state.selectedmenu;
	            var isInArray_var = false;
	            isInArray_var = SubscriptionFile.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	            if (isInArray_var) {
	              _this.setState({
	                subscriptionstatus: 'paid',
	                display_cases: 'show_block',
	                display_subcription: 'hide_block'
	              });
	            } else {
	              if (resp_cases.casesingleData.free === 0) {
	                _this.setState({
	                  display_cases: 'hide_block',
	                  display_subcription: 'show_block'
	                });
	              } else {
	                _this.setState({
	                  subscriptionstatus: 'free',
	                  display_cases: 'show_block',
	                  display_subcription: 'hide_block'
	                });
	              }
	            }
	          } else {
	            console.log('fail');
	          }
	        });
	      }
	    };
	
	    _this.setAnswer = function (answer) {
	      _this.setState({ choice: answer[0], clicked: true });
	    };
	
	    _this.state = {
	      isExpand: false,
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      chaptername: '',
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      cases_offset: '',
	      casesquestion_length: '',
	      chapters: '',
	      display_loader: '',
	      selectedmenu: 'cfa_2',
	      subscriptionstatus: '',
	      display_subcription: 'hide_block',
	      display_cases: 'show_block',
	      showCompletionQuestion: false,
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cases: [],
	      exam_type: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      forumComment: '',
	      category: 'CFA Level 2',
	      tags: ['cfa-2', 'cfa', 'question', 'case'],
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      hide_case_left_arrow: '',
	      hide_case_right_arrow: '',
	      hide_question_left_arrow: '',
	      hide_question_right_arrow: '',
	      display_main_loader: 'hide_block',
	      top_50: '',
	      question_no: 1
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(EACases, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.cases.casesingleData.case_number,
	        completion_status: this.state.markAsCompleted,
	        exam_type: this.state.exam_type,
	        chapter_id: this.props.params.chapterid
	      };
	      if (this.state.markAsCompleted === true) {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    ---------------------------------------------
	      Function to change, time every second
	    ---------------------------------------------
	    */
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      this.setState({ count: this.state.count + 1 });
	      //console.log(this.state.count + 1);
	    }
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to readings page
	    -------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------------------------------
	      Function to check Right Or Wrong Answered and displayed clicked box
	    -----------------------------------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	      */
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/UpdateEARatting', _params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', params).then(function (response) {
	        var params = {
	          token: _this3.state.token,
	          idname: _this3.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this3.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveEARatting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveEARatting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	      */
	
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to Edit Flash card
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	       Function to delete flash card
	    --------------------------------------
	    */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number !== this.props.params.question_number && nextProps.params.caseid === this.props.params.caseid) {
	        // console.log('I am here for pffset ----. ', nextProps.params.offset);
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        // this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid !== this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*
	    ------------------------------------------------------
	    on url question offset change run this function
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      // console.log('all_cases ----> ', case_offset);
	      // console.log('all_questions_state -----> ', question_number);
	      this.setState({
	        case_id: caseid,
	        display_main_loader: 'show_block',
	        display_cases: 'hide_block',
	        top_50: 'top-50',
	        isError: false,
	        choice: '',
	        ValidToken: true,
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        choice_d: 'answer_box',
	        choice_e: 'answer_box',
	        result_block: 'card hide_block',
	        rated: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      // var data = {
	      //   token: token_id,
	      //   idname: idname,
	      //   chapter_id: chapterid,
	      //   reading_id: this.props.params.readingid,
	      //   case_id: caseid,
	      // };
	      var all_questions_state = this.state.all_questions_state;
	
	      var offset_res = '';
	      var questionid = '';
	      // console.log(questionid);
	      for (var i = 0; i < all_questions_state.length; i++) {
	        if (i === parseInt(offset_val, 10)) {
	          this.setState({
	            hide_question_left_arrow: '',
	            hide_question_right_arrow: ''
	          });
	          if (i === 0) this.setState({
	            hide_question_left_arrow: 'menu_hide'
	          });else if (i === all_questions_state.length - 1) this.setState({
	            hide_question_right_arrow: 'menu_hide'
	          });
	          offset_res = i;
	          questionid = all_questions_state[i].id;
	          // console.log(all_questions_state[i]);
	          this.setState({
	            questions: all_questions_state[i],
	            offset: offset_res,
	            display_main_loader: 'hide_block',
	            top_50: '',
	            question_no: i + 1
	          });
	          this.setQuestionState(all_questions_state[i]);
	          this.getFavQuestions(all_questions_state[i].id);
	          this.getEARatting(all_questions_state[i].id);
	          this.getFlashCards(all_questions_state[i].id);
	        }
	        if (i === all_questions_state.length - 1) {
	          this.setState({
	            display_loader: 'hide_block',
	            display_cases: 'show_block'
	          });
	        }
	      }
	      // this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax
	
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this4 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        chapter_id: chapterid,
	        case_id: caseid,
	        reading_id: this.props.params.readingid,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      this.setState({
	        cases_display: '',
	        cases_name: ''
	      });
	
	      this.setState({ case_id: caseid });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCaseByReading', data).then(function (resp) {
	        if (resp.success) {
	          _this4.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            display_main_loader: 'show_block',
	            top_50: 'top-50'
	            // hide_question_right_arrow: 'menu_show',
	            // hide_question_left_arrow: 'menu_hide',
	          });
	          document.getElementById('comment').value = '';
	          _this4.setState({ all_cases: resp.questions });
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (parseInt(_this4.props.params.case_offset, 10) === i) {
	              _this4.setState({
	                hide_case_left_arrow: '',
	                hide_case_right_arrow: ''
	              });
	              if (i === 0) _this4.setState({ hide_case_left_arrow: 'true' });else if (i === resp.questions.length - 1) _this4.setState({ hide_case_right_arrow: 'true' });
	
	              _this4.setState({
	                cases_display: resp.questions[i]['ea_case.passage'],
	                cases_name: 'Case no : ' + (parseInt(i, 10) + 1)
	              });
	            }
	          }
	          _this4.setState({ display_loader: 'hide_block' });
	          var param = {
	            token: token_id,
	            idname: idname,
	            case_id: caseid,
	            reading_id: _this4.props.params.readingid,
	            subscriptionstatus: _this4.state.subscriptionstatus
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this4.setState({
	                casesquestion_length: resp_question.questions_details.length,
	                display_main_loader: 'hide_block'
	              });
	              // console.log(
	              //   'I am having a issue here -------->',
	              //   resp_question.questions_details.length,
	              //   question_number,
	              //   offset_val
	              // );
	              if (resp_question.questions_details.length > offset_val) {
	                //let ques_res=[];
	
	                var offset_res = '';
	                var questionid = '';
	                // console.log(questionid);
	
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  // console.log(
	                  //   'resp_question.questions_details[i].length',
	                  //   resp_question.questions_details.length
	                  // );
	                  if (i === 0) {
	                    _this4.setState({
	                      hide_question_left_arrow: '',
	                      hide_question_right_arrow: ''
	                    });
	                    if (i === 0) _this4.setState({
	                      hide_question_left_arrow: 'menu_hide'
	                    });
	                    if (i === resp_question.questions_details.length - 1) _this4.setState({
	                      hide_question_right_arrow: 'menu_hide'
	                    });
	                    offset_res = i;
	                    questionid = resp_question.questions_details[i].id;
	                    _this4.setState({
	                      questions: resp_question.questions_details[i],
	                      question_no: i + 1
	                    });
	                    _this4.setQuestionState(resp_question.questions_details[i]);
	                    _this4.getFavQuestions(resp_question.questions_details[i].id);
	                    _this4.getEARatting(resp_question.questions_details[i].id);
	                    _this4.getFlashCards(resp_question.questions_details[i].id);
	                  }
	                  if (i === resp_question.questions_details.length - 1) {
	                    _this4.setState({ display_loader: 'hide_block' });
	                  }
	                }
	                _this4.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details,
	                  display_cases: 'show_block',
	                  top_50: ''
	                });
	                _this4.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this4.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this4.timer);
	        _this4.timer = setInterval(_this4.tick.bind(_this4), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    // ==================== CHANGES BY ME START ==============================//
	
	  }, {
	    key: 'componentDidMount',
	
	    // ==================== CHANGES BY ME END ==============================//
	    // =============================== TODO END =======================//
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this5 = this;
	
	        var storage_session, subscriptionstatusData, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  display_loader: 'show_block',
	                  display_cases: 'hide_block'
	                });
	                this.setState({
	                  case_id: this.props.params.caseid
	                });
	                subscriptionstatusData = void 0;
	
	                if (parseInt(this.props.params.subscription, 10) === 1) {
	                  this.setState({ subscriptionstatus: 'paid' });
	                  subscriptionstatusData = 'paid';
	                } else {
	                  this.setState({ subscriptionstatus: 'free' });
	                  subscriptionstatusData = 'free';
	                }
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  caseid: this.props.params.caseid,
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.chapterid,
	                  subscriptionstatus: subscriptionstatusData
	                };
	                // -------------------------- CASE AND Question ---------------- //
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCaseByReading', data).then(function (resp) {
	                  if (resp.success) {
	                    _this5.setState({
	                      ValidToken: true,
	                      all_cases: resp.questions,
	                      cases_length: resp.questions.length
	                    });
	                    console.log('this.props.params.case_offset', _this5.props.params.case_offset);
	                    for (var i = 0; i < resp.questions.length; i++) {
	                      if (parseInt(_this5.props.params.case_offset, 10) === i) {
	                        if (i === 0) _this5.setState({
	                          hide_case_left_arrow: 'true'
	                        });
	                        if (i === resp.questions.length - 1) _this5.setState({
	                          hide_case_right_arrow: 'true'
	                        });
	                        _this5.setState({
	                          cases_offset: _this5.props.params.case_offset,
	                          cases_display: resp.questions[i]['ea_case.passage'],
	                          cases_name: 'Case no: ' + (parseInt(i, 10) + 1),
	                          case_id: resp.questions[i].case_id
	                        });
	                      }
	                    }
	                    var param = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname'],
	                      reading_id: _this5.props.params.readingid,
	                      case_id: _this5.state.case_id,
	                      subscriptionstatus: subscriptionstatusData
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getCasesquestion', param).then(function (resp_question) {
	                      // console.log('I am here 1111');
	                      if (resp_question.success) {
	                        _this5.setState({
	                          casesquestion_length: resp_question.questions_details.length,
	                          display_main_loader: 'hide_block'
	                        });
	                        // console.log(
	                        //   'I am having a issue here -------->',
	                        //   this.props.params,
	                        //   resp_question.questions_details.length,
	                        //   this.props.params.question_number - 1
	                        // );
	                        if (resp_question.questions_details.length > _this5.props.params.offset) {
	                          //let ques_res=[];
	
	                          var offset_res = '';
	                          var questionid = '';
	                          // console.log(questionid);
	
	                          for (var i = 0; i < resp_question.questions_details.length; i++) {
	                            // console.log(
	                            //   'resp_question.questions_details[i]',
	                            //   resp_question.questions_details[i]
	                            // );
	                            if (i === parseInt(_this5.props.params.offset, 10)) {
	                              if (i === 0) _this5.setState({
	                                hide_question_left_arrow: 'menu_hide'
	                              });
	                              if (i === resp_question.questions_details.length - 1) _this5.setState({
	                                hide_question_right_arrow: 'menu_hide'
	                              });
	                              offset_res = i;
	                              questionid = resp_question.questions_details[i].id;
	                              _this5.setState({
	                                questions: resp_question.questions_details[i],
	                                question_no: i + 1
	                              });
	                              _this5.setQuestionState(resp_question.questions_details[i]);
	                              _this5.getFavQuestions(resp_question.questions_details[i].id);
	                              _this5.getEARatting(resp_question.questions_details[i].id);
	                              _this5.getFlashCards(resp_question.questions_details[i].id);
	                            }
	                            if (i === resp_question.questions_details.length - 1) {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	                          }
	                          _this5.setState({
	                            offset: offset_res,
	                            all_questions_state: resp_question.questions_details,
	                            display_cases: 'show_block'
	                          });
	                          _this5.setState({ records: '' });
	                        } else {
	                          console.log('Not Valid');
	                        }
	                      }
	                    });
	                  } else {
	                    _this5.setState({ ValidToken: false, records: 'Result not found.' });
	                  }
	                  clearInterval(_this5.timer);
	                  _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	                  return resp;
	                });
	                // -------------------------- CASE AND Question ---------------- //
	                clearInterval(this.timer);
	                this.timer = setInterval(this.tick.bind(this), 1000);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          validated = _state.validated,
	          choice = _state.choice,
	          isError = _state.isError;
	
	      var questions_data_display = questions || {};
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	      var choice_d = 'd';
	      var choice_e = 'e';
	      var question_data = '';
	
	      this.state.showCompletionQuestion ? question_data = _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block ' + this.state.display_subcription },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card 23434' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 complete-section-wrap ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header text-center' },
	              _language2.default.LC().Mark_this_Question_as_Completed,
	              _react2.default.createElement(
	                'div',
	                { onClick: this._getNextAnyway, className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ) : question_data = _react2.default.createElement(
	        'div',
	        { className: 'note-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block ' + this.state.display_subcription },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 p-sm-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 p-sm-0 ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card box-shadow-none' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size' },
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                    className: 'margin_right_20',
	                    alt: '',
	                    width: '30'
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'title-font-size' },
	                    _language2.default.LC().QUESTION,
	                    ' ',
	                    this.state.question_no + ' - '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'float-right text-right' },
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.hide_question_left_arrow,
	                    onClick: this._getPrevious
	                  }),
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.hide_question_right_arrow,
	                    onClick: this._getNext
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row px-md-15px' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_ViewQuestion2.default, Object.assign({}, questions, this.props, {
	                      setAnswer: this.setAnswer,
	                      showAnswer: validated,
	                      correctChoice: questions && questions.right_choice,
	                      selectedChoice: choice
	                    })),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: '12', className: 'mt-2' },
	                      isError && _react2.default.createElement(
	                        'p',
	                        { className: 'text-danger' },
	                        _messages.messages.NO_CHOICE_SELECTED
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          showResult: validated,
	                          _getResult: this.handleQuestionValidate,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions_data_display,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'star_rating_wrap' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: ' margin_bottom_0 margin_right_10' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(_reactStarRatings2.default, {
	                              rating: this.state.rating,
	                              starRatedColor: 'rgb(255, 180, 0)',
	                              starEmptyColor: 'rgb(51, 51, 51)',
	                              starDimension: '20px',
	                              starHoverColor: 'rgb(255, 180, 0)',
	                              starSpacing: '2px',
	                              changeRating: this.onStarClick.bind(this, questions_data_display),
	                              numberOfStars: 5,
	                              name: 'rate1'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' bg-faded' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions_data_display.answer, 'p', 'view_questionhtml', {
	                contentEditable: false,
	                suppressContentEditableWarning: true
	              })
	            )
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'question',
	            question_type: 'question',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'ea'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class margin_bottom_20 report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, questions_data_display)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10 margin_bottom_20',
	                          onClick: this._hideReportForm.bind(this, questions_data_display)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        )
	      );
	
	      // const { timer_stop } = this.state;
	      return _react2.default.createElement(
	        'div',
	        { className: 'd-flex flex-column', id: 'Progress1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_CHAPTER
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'd-flex flex-sm-col' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'p-2 card mr-1 mb-0 calc_height_GMAT overflow-y-auto width-sm-100 width-50 mb-sm-1 font-lusitana bg_blue'
	              // style={{ borderRadius: '0px' }}
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex justify-content-between align-items-center card-header px-0 ' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  disabled: this.state.hide_case_left_arrow,
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getPreviousCase
	                },
	                'Previous Passage'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  disabled: this.state.hide_case_right_arrow,
	                  onClick: this._getNextCase
	                },
	                'Next Passage'
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              (0, _function.renderHTMLContent)(this.state.cases_display, 'span', '', {
	                contentEditable: false,
	                suppressContentEditableWarning: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'width-50 calc_height_GMAT overflow-y-auto width-sm-100 card-border-radius-none bg-white p-2 card font-lusitana bg_blue'
	              // style={{ borderRadius: '0px' }}
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'position-relative ' + this.state.top_50 },
	              _react2.default.createElement(
	                'div',
	                { className: 'main_loader ' + this.state.display_main_loader },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loader-mid' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block-loader' },
	                    _react2.default.createElement(_loader2.default, null)
	                  )
	                )
	              ),
	              question_data
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EACases;
	}(_react.Component);
	
	// class TooltipItem extends React.Component {
	//   constructor(props) {
	//     super(props);
	
	//     this.toggle = this.toggle.bind(this);
	
	//     // document.body.style.backgroundColor = '#1d364b';
	//     this.state = {
	//       tooltipOpen: false,
	//     };
	//   }
	
	//   toggle() {
	//     this.setState({
	//       // tooltipOpen: !tooltipOpen,
	//     });
	//   }
	
	//   render() {
	//     return (
	//       <span>
	//         <img
	//           src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
	//           id={'Tooltip-' + this.props.id}
	//           width='18'
	//           alt=''
	//           style={{ marginLeft: '4px' }}
	//         />
	//         {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}
	
	//         <Tooltip
	//           placement={this.props.place_tip}
	//           // isOpen={tooltipOpen}
	//           target={'Tooltip-' + this.props.id}
	//           toggle={this.toggle}
	//         >
	//           <p className='tooltip_text'>{this.props.content}</p>
	//         </Tooltip>
	//       </span>
	//     );
	//   }
	// }
	
	
	EACases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = EACases;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _messages = __webpack_require__(14);
	
	var _GraphicalStatement = __webpack_require__(242);
	
	var _GraphicalStatement2 = _interopRequireDefault(_GraphicalStatement);
	
	var _apiServerProvider = __webpack_require__(140);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMATGraphical = function (_Component) {
	  _inherits(GMATGraphical, _Component);
	
	  function GMATGraphical(props) {
	    _classCallCheck(this, GMATGraphical);
	
	    var _this = _possibleConstructorReturn(this, (GMATGraphical.__proto__ || Object.getPrototypeOf(GMATGraphical)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _AppRoutes2.default.EA_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_GRAPH_MULTI_STATEMENT.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GMATGraphical, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_GraphicalStatement2.default, Object.assign({}, this.props, {
	          apiServices: _apiServerProvider.apiServices,
	          examName: _constant.examNameAccordingToDB.EA,
	          stateTableName: _constant.TABLE_NAME.EA_QUESTION_STATS,
	          questionMode: _constant.EXAM_NAMES.EA,
	          questionType: _constant.QUESTION_TYPE.GRAPH_QUESTION,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return GMATGraphical;
	}(_react.Component);
	
	GMATGraphical.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GMATGraphical;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TwoStatement = __webpack_require__(133);
	
	var _TwoStatement2 = _interopRequireDefault(_TwoStatement);
	
	var _apiServerProvider = __webpack_require__(140);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _messages = __webpack_require__(14);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMAT2Statement = function (_Component) {
	  _inherits(GMAT2Statement, _Component);
	
	  function GMAT2Statement(props) {
	    _classCallCheck(this, GMAT2Statement);
	
	    var _this = _possibleConstructorReturn(this, (GMAT2Statement.__proto__ || Object.getPrototypeOf(GMAT2Statement)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _AppRoutes2.default.EA_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_TWO_PART_STATEMENT.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GMAT2Statement, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TwoStatement2.default, Object.assign({}, this.props, {
	          questionType: _constant.QUESTION_TYPE.TWO_PART_QUESTION,
	          examName: _constant.examNameAccordingToDB.EA,
	          apiServices: _apiServerProvider.apiServices,
	          redirectTo: this.redirectTo,
	          stateTableName: _constant.TABLE_NAME.EA_QUESTION_STATS,
	          questionMode: _constant.EXAM_NAMES.EA,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return GMAT2Statement;
	}(_react.Component);
	
	GMAT2Statement.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GMAT2Statement;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MultiSourceTab = __webpack_require__(243);
	
	var _MultiSourceTab2 = _interopRequireDefault(_MultiSourceTab);
	
	var _apiServerProvider = __webpack_require__(140);
	
	var _messages = __webpack_require__(14);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMATTab = function (_Component) {
	  _inherits(GMATTab, _Component);
	
	  function GMATTab(props) {
	    _classCallCheck(this, GMATTab);
	
	    var _this = _possibleConstructorReturn(this, (GMATTab.__proto__ || Object.getPrototypeOf(GMATTab)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _AppRoutes2.default.EA_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_TAB.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GMATTab, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_MultiSourceTab2.default, Object.assign({}, this.props, {
	          apiServices: _apiServerProvider.apiServices,
	          examName: _constant.examNameAccordingToDB.EA,
	          questionType: _constant.QUESTION_TYPE.TAB_QUESTION,
	          stateTableName: _constant.TABLE_NAME.EA_QUESTION_STATS,
	          questionMode: _constant.EXAM_NAMES.EA,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return GMATTab;
	}(_react.Component);
	
	GMATTab.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GMATTab;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _messages = __webpack_require__(14);
	
	var _TwoStatement = __webpack_require__(133);
	
	var _TwoStatement2 = _interopRequireDefault(_TwoStatement);
	
	var _apiServerProvider = __webpack_require__(140);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // my datatatatat
	
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _AppRoutes2.default.EA_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_TABLE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TwoStatement2.default, Object.assign({}, this.props, {
	          apiServices: _apiServerProvider.apiServices,
	          questionType: _constant.QUESTION_TYPE.TABLE_QUESTION,
	          examName: _constant.examNameAccordingToDB.EA,
	          stateTableName: _constant.TABLE_NAME.EA_QUESTION_STATS,
	          questionMode: _constant.EXAM_NAMES.EA,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = Table;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _UserAnsweredNotAnsweredStatus = __webpack_require__(137);
	
	var _UserAnsweredNotAnsweredStatus2 = _interopRequireDefault(_UserAnsweredNotAnsweredStatus);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var ViewEAQuestions = function (_Component) {
	  _inherits(ViewEAQuestions, _Component);
	
	  function ViewEAQuestions(props) {
	    _classCallCheck(this, ViewEAQuestions);
	
	    var _this = _possibleConstructorReturn(this, (ViewEAQuestions.__proto__ || Object.getPrototypeOf(ViewEAQuestions)).call(this, props));
	
	    _this._goToVideo = function () {
	      _this.setState({
	        chapter_video_redirect: _this.state.chapters[parseInt(_this.props.params.chapter_no) - 1]
	      }, function () {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', _this.state.chapter_video_redirect.chapter_no).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1),
	          // .replace(':type', '')
	          // .replace(':chapter_id', '')
	          // .replace(':index', '')
	          search: '?chapter_name=' + _this.state.chapter_video_redirect.chapter_name
	        });
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_READING.replace(':id', _this.props.params.chapter_no)
	
	        // `/readings/${this.props.params.chapter_no}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.props.location.state.reading.chapter_no,
	        // },
	      });
	    };
	
	    _this._beginChapter = function (item, index, caseOffset, questionOffset, e) {
	      var reading = _this.state.readingDetails;
	
	      if (reading.type === 'case_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_BEGINCASE.replace(':chapterid', item.ea_chapter_id).replace(':readingid', reading.id).replace(':caseid', item.case_id).replace(':case_offset', caseOffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', item.id).replace(':offset', questionOffset)
	        });
	      } else if (reading.type === 'tab_question' || reading.type === 'graph_question' || reading.type === 'table_question' || reading.type === 'two_part_question') {
	        var routeName = void 0;
	        switch (reading.type) {
	          case 'tab_question':
	            routeName = 'EA_TAB';
	            break;
	          case 'graph_question':
	            routeName = 'EA_GRAPH_MULTI_STATEMENT';
	            break;
	          case 'table_question':
	            routeName = 'EA_TABLE';
	            break;
	          case 'two_part_question':
	            routeName = 'EA_TWO_PART_STATEMENT';
	            break;
	          default:
	            console.log('Route Name issue');
	            break;
	        }
	        _this.context.router.push({
	          pathname: _AppRoutes2.default[routeName].replace(':chapterid', item.ea_chapter_id).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', item.id).replace(':offset', index).replace(':reading', reading.reading)
	        });
	      } else {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.EA_BEGINCHAPTER.replace(':notesid', item.ea_chapter_id).replace(':readingid', item.ea_reading_id).replace(':id', item.id)
	        });
	      }
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      SubsciptionMessage: _alertMessage2.default.messageContent_gmat,
	      token: '',
	      idname: '',
	      readingName: _this.props.params.reading,
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      subscriptionstatus: _this.props.params.subscriptionstatus,
	      chapters: [],
	      subscription_details: '',
	      showFreePremium: true,
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'ea',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      isVideo: true,
	      display_loader: 'show'
	    };
	    return _this;
	  }
	
	  _createClass(ViewEAQuestions, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this2 = this;
	
	        var storage_session, getProfileInfo, data_data, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', getProfileInfo).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.profileInfo) {
	                              _this2.setState({
	                                isVideo: resp.profileInfo.isVideo
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                data_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEAVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true, chapters: resp.cfavideo });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                });
	
	              case 8:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset, subscription_details;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_selected === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this2.setState({
	                              showFreePremium: true
	                            });
	                            _context3.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context3.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this2.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (isInArray_var) {
	                                          _this2.setState({ showFreePremium: false });
	                                        } else {
	                                          _this2.setState({ showFreePremium: true });
	                                        }
	                                        _context2.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 9:
	                            _context3.next = 22;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context3.next = 16;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            (0, _toast.showFailure)('Please upgrade your package to access all questions');
	
	                            _this2.setState({
	                              showFreePremium: true
	                            });
	                            _context3.next = 22;
	                            break;
	
	                          case 16:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this2.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context3.next = 22;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this2.setState({ showFreePremium: false });
	                                } else {
	                                  //   console.log('ELSE WORKING')
	                                  (0, _toast.showFailure)('Please upgrade your package to access all questions');
	
	                                  _this2.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                console.log('fail');
	                              }
	                            });
	
	                          case 22:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit,
	                  subscriptionstatus: this.state.subscriptionstatus
	                };
	                _context4.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestions', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      ValidToken: true,
	                      questions: resp.questions,
	                      readingDetails: resp.readingDetails
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  _this2.setState({ display_loader: 'hide' });
	
	                  return resp;
	                });
	
	              case 14:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.questions;
	      var data = '';
	      var caseOffset = -1;
	      var questionOffset = 0;
	      var previousCaseId = undefined;
	      if (this.state.questions.length) {
	        data = questions.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId === item.case_id ? questionOffset++ : questionOffset = 0
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId === item.case_id ? caseOffset = caseOffset : caseOffset++
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId = item.case_id
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: _this3._beginChapter.bind(_this3, item, index, caseOffset, questionOffset),
	                className: 'border_box'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title d-flex' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'ml-1' },
	                  item.name ? item.name : _this3.state.readingName,
	                  ' (',
	                  _language2.default.LC().Q,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                (0, _function.renderHTMLContent)(item.question.substring(0, item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 500) + '...', "div", "view_question_height view_questionhtml", { contentEditable: false }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _this3.state.answered_state[index]
	                ),
	                _react2.default.createElement(_UserAnsweredNotAnsweredStatus2.default, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index,
	                  readingDetails: _this3.state.readingDetails,
	                  examRoute: 'ea_question_bank'
	                })
	              )
	            )
	          );
	        });
	      } else {
	        // data = <Loader />;
	        data = this.state.display_loader === 'show' ? _react2.default.createElement(_loader2.default, null) : null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.readingName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className:
	              // this.state.isVideo === true
	              //   ? `col-md-2 text-md-right margin_bottom_20`
	              // :
	              'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'border_box', onClick: this._getSubscribe },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  ' ',
	                  _language2.default.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box_free' },
	                (0, _function.renderHTMLContent)(this.state.SubsciptionMessage, "div", "view_question_height view_questionhtml modal-info-view-for-plan", { contentEditable: false })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscibe__btn text-center' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary pointer_class',
	                    onClick: this._getSubscribe
	                  },
	                  _language2.default.LC().SUBSCRIBE
	                )
	              )
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ViewEAQuestions;
	}(_react.Component);
	
	ViewEAQuestions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = ViewEAQuestions;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var BeforeStart = function (_Component) {
	  _inherits(BeforeStart, _Component);
	
	  function BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (BeforeStart.__proto__ || Object.getPrototypeOf(BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_QUIZZES,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.beginQuiz = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, all_reading_type, all_cases_id, final_exam, data;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, all_reading_type = _this$state.all_reading_type, all_cases_id = _this$state.all_cases_id;
	              final_exam = [];
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context4.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context3.next = 12;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context3.next = 5;
	                            break;
	                          }
	
	                          _this.toggleAlert();
	                          _context3.next = 10;
	                          break;
	
	                        case 5:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context3.next = 10;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 10;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context.next = 6;
	                                      return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        if (all_reading_type[0] === 'case_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':case', all_cases_id[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'tab_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGIN_TAB_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'graph_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'table_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'two_part_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.EA_BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        }
	                                      } else {
	                                        _this.toggleAlert();
	                                      }
	                                      _context.next = 10;
	                                      break;
	
	                                    case 10:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this2);
	                            }));
	
	                            return function (_x2) {
	                              return _ref3.apply(this, arguments);
	                            };
	                          }()
	                          // console.log('fail');
	                          );
	
	                        case 10:
	                          _context3.next = 13;
	                          break;
	
	                        case 12:
	                          if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                            _this.toggleAlert();
	                          } else {
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 11;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        console.log("check why call toggle==============>", selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                        if (isInArray_var) {
	                                          if (all_reading_type[0] === 'case_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':case', all_cases_id[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'tab_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_TAB_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'graph_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'table_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'two_part_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          }
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context2.next = 11;
	                                        break;
	
	                                      case 11:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	                          }
	
	                        case 13:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.viewQuizquestion = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(item, offset_va, e) {
	        var _this$state2, all_reading_type, all_cases_id, final_exam, data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this$state2 = _this.state, all_reading_type = _this$state2.all_reading_type, all_cases_id = _this$state2.all_cases_id;
	                final_exam = [];
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _EASubscription4.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          if (all_reading_type[offset_va] === 'case_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':case', all_cases_id[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'tab_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_TAB_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'graph_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'table_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'two_part_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          }
	
	                                          // this.context.router.push({
	                                          //   pathname: AppRoutes.BEGIN_QUIZ.replace(
	                                          //     ':quiz_id',
	                                          //     this.state.quiz_id
	                                          //   ).replace(':offset', offset_va),
	
	                                          // });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context6.next = 13;
	                            break;
	
	                          case 12:
	                            if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this.toggleAlert();
	                            } else {
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _EASubscription2.default.checkEAQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    if (all_reading_type[offset_va] === 'case_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.EA_BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':case', all_cases_id[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'tab_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.EA_BEGIN_TAB_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'graph_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.EA_BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', all_reading_type[offset_va]).replace(':offset', offset_va).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'table_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.EA_BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'two_part_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.EA_BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.EA_BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    }
	
	                                    // this.context.router.push({
	                                    //   pathname: AppRoutes.BEGIN_QUIZ.replace(
	                                    //     ':quiz_id',
	                                    //     this.state.quiz_id
	                                    //   ).replace(':offset', offset_va),
	
	                                    // });
	                                  } else {
	                                    _this.toggleAlert();
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 13:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x4, _x5, _x6) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'ea',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      timerInSeconds: 0
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //Function to redirect page to Create Quiz page
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    //Function to redirect page to begin Quiz page
	
	
	    /*
	    ------------------------------------------------------
	        Function to redirect page to begin Quiz page
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var cases = JSON.parse(JSON.parse(retun_all_question)).cases;
	
	          var question_id = [];
	          var reading_id = [];
	          var case_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	            case_id.push(cases[i]);
	          }
	          console.log('resp.timer_value---', resp.timer_value);
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count,
	            all_reading_type: reading_id,
	            all_cases_id: case_id,
	            timerInSeconds: resp.timer_value
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var question_id_display = '';
	      var _state = this.state,
	          all_reading_type = _state.all_reading_type,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id,
	          all_question_id = _state.all_question_id;
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: token,
	                idname: idname,
	                quiz_id: quiz_id,
	                answered_state: index,
	                type: all_reading_type[index]
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  onClick: _this4.viewQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	      var _state2 = this.state,
	          timerInSeconds = _state2.timerInSeconds,
	          user_time_value = _state2.user_time_value,
	          status_send = _state2.status_send;
	
	      var user_time = '';
	      var min,
	          sec = '';
	      var status_data = '';
	      var spentTime = timerInSeconds - user_time_value;
	      if (status_send === 'abondon') {
	        if (spentTime < 60) {
	          user_time = spentTime + 'sec';
	        } else {
	          min = parseInt(spentTime / 60);
	          sec = spentTime % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary pointer_class',
	            onClick: this.beginQuiz.bind(this)
	          },
	          ' ',
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary pointer_class',
	            onClick: this.beginQuiz.bind(this)
	          },
	          ' ',
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().QUIZ_ID,
	            ': ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ',',
	                  ' ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().NO_ANSWER
	                          ),
	                          _react2.default.createElement('span', {
	                            id: 'quiz_notanswered_status',
	                            className: 'margin_right_60'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().CORRECT_ANSWER
	                          ),
	                          _react2.default.createElement('span', {
	                            id: 'quiz_answered_status',
	                            className: 'margin_right_60'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().WRONG_ANSWER
	                          ),
	                          _react2.default.createElement('span', {
	                            id: 'quiz_wrong_answered_status',
	                            className: 'margin_right_60'
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id,
	    type: props.type
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/checkAnswered', data).then(function (resp) {
	    if (document.getElementById('questionNameId_' + props.answered_state) !== null) document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer === 1) {
	        var userQuestionStatus = document.getElementById('user_question_status' + props.answered_state);
	        var answerFlag = document.getElementById('answer_flag' + props.answered_state);
	        if (userQuestionStatus) userQuestionStatus.id = 'quiz_answered_status';
	        if (answerFlag) answerFlag.innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        var _userQuestionStatus = document.getElementById('user_question_status' + props.answered_state);
	        var _answerFlag = document.getElementById('answer_flag' + props.answered_state);
	        if (_userQuestionStatus) _userQuestionStatus.id = 'quiz_wrong_answered_status';
	        if (_answerFlag) _answerFlag.innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	        // document.getElementById(
	        //   'user_question_status' + props.answered_state
	        // ).id = 'quiz_wrong_answered_status';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	        // document.getElementById(
	        //   'answer_flag' + props.answered_state
	        // ).innerHTML = `${language.LC().WRONG_ANSWER}`;
	      }
	    } else {
	      if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', {
	      className: 'margin_right_20',
	      id: 'user_question_status' + props.answered_state
	    }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = BeforeStart;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.apiServices = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var session = JSON.parse(localStorage.getItem('localstorageval')) || {};
	var token = session.token,
	    idname = session.idname;
	
	var payload = {
	  token: token,
	  idname: idname
	};
	var getQuizDetails = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuize', Object.assign({}, payload, data));
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getQuizDetails(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var getQuestionById = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuestionsbyid', Object.assign({}, payload, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function getQuestionById(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var checkUserSelectedAnswer = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/checkAnswered', Object.assign({}, payload, data));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function checkUserSelectedAnswer(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var insertUserTimer = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/insertTimer', Object.assign({}, payload, data));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function insertUserTimer(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var saveQuizAnswer = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/answerQuiz', Object.assign({}, payload, data));
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function saveQuizAnswer(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var saveAttemptStats = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveStats', Object.assign({}, payload, data));
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveAttemptStats(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var fetchSavedQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavQuestions', Object.assign({}, payload, data));
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function saveQuestion(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/unsaveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var saveReport = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            _context10.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/reportQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context10.abrupt('return', _context10.sent);
	
	          case 3:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  return function saveReport(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	var saveRating = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(data) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveEARatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context11.abrupt('return', _context11.sent);
	
	          case 3:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, undefined);
	  }));
	
	  return function saveRating(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var fetchRating = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEARatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context12.abrupt('return', _context12.sent);
	
	          case 3:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, undefined);
	  }));
	
	  return function fetchRating(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var updateQuestionRating = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(data) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/UpdateEARatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context13.abrupt('return', _context13.sent);
	
	          case 3:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, undefined);
	  }));
	
	  return function updateQuestionRating(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var apiServices = exports.apiServices = {
	  saveAttemptStats: saveAttemptStats,
	  saveQuizAnswer: saveQuizAnswer,
	  getQuestionById: getQuestionById,
	  getQuizDetails: getQuizDetails,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  saveReport: saveReport,
	  saveRating: saveRating,
	  fetchRating: fetchRating,
	  updateQuestionRating: updateQuestionRating,
	  checkUserSelectedAnswer: checkUserSelectedAnswer,
	  insertUserTimer: insertUserTimer
	};

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ApiServiceProvider = __webpack_require__(700);
	
	var _MultiSourceTab = __webpack_require__(245);
	
	var _MultiSourceTab2 = _interopRequireDefault(_MultiSourceTab);
	
	var _ReverseTimer = __webpack_require__(247);
	
	var _ReverseTimer2 = _interopRequireDefault(_ReverseTimer);
	
	var _GraphicalStatement = __webpack_require__(244);
	
	var _GraphicalStatement2 = _interopRequireDefault(_GraphicalStatement);
	
	var _TableAnalysisTwoStatement = __webpack_require__(248);
	
	var _TableAnalysisTwoStatement2 = _interopRequireDefault(_TableAnalysisTwoStatement);
	
	var _TwoPartAnalysis = __webpack_require__(249);
	
	var _TwoPartAnalysis2 = _interopRequireDefault(_TwoPartAnalysis);
	
	var _NormalQuestion = __webpack_require__(246);
	
	var _NormalQuestion2 = _interopRequireDefault(_NormalQuestion);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeginQuizContainer = function (_Component) {
	  _inherits(BeginQuizContainer, _Component);
	
	  function BeginQuizContainer(props) {
	    _classCallCheck(this, BeginQuizContainer);
	
	    var _this = _possibleConstructorReturn(this, (BeginQuizContainer.__proto__ || Object.getPrototypeOf(BeginQuizContainer)).call(this, props));
	
	    _this.handleChangeParams = function (index) {
	      var _this$state = _this.state,
	          questionTypes = _this$state.questionTypes,
	          questionIds = _this$state.questionIds;
	      var _this$props$params = _this.props.params,
	          quiz_id = _this$props$params.quiz_id,
	          timer = _this$props$params.timer;
	
	      var currentQuestionType = questionTypes[index];
	      var currentQuestionId = questionIds[index];
	
	      _this.setState({ currentQuestionType: currentQuestionType, currentQuestionId: currentQuestionId });
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_BEGIN_QUIZ.replace(':quiz_id', quiz_id).replace(':offset', index).replace(':type', currentQuestionType).replace(':timer', timer)
	      });
	    };
	
	    _this.redirectToResults = function (status) {
	      var router = _this.context.router;
	      var quiz_id = _this.props.params.quiz_id;
	
	
	      router.push({
	        pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', quiz_id).replace(':status_send', status || 'abondon')
	      });
	    };
	
	    _this.onHandleSetTimer = function (isTimer, isValidate) {
	      return _this.setState({ isTimer: isTimer, isValidate: isValidate });
	    };
	
	    _this.updateUserTimer = function (time) {
	      var params = _this.props.params;
	
	
	      var payload = {
	        quiz_id: params.quiz_id,
	        user_time_value: time.timer
	      };
	      _ApiServiceProvider.apiServices.insertUserTimer(payload).then(function (response) {
	        _this.setState({ timer: time.timer });
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      currentQuestion: {},
	      validated: false,
	      timer: props.params.timer || 0
	    };
	    return _this;
	  }
	
	  _createClass(BeginQuizContainer, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var router, _props, params, question_type, quiz_id, type, offset, payload, response, parsedQuiz, questionIds, questionTypes, quizTime, userSpendTime, currentQuestionId, currentQuestionType;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                router = this.context.router;
	                _props = this.props, params = _props.params, question_type = _props.questionType;
	                quiz_id = params.quiz_id, type = params.type, offset = params.offset;
	                payload = {
	                  quiz_id: quiz_id
	                };
	                _context.next = 6;
	                return _ApiServiceProvider.apiServices.getQuizDetails(payload);
	
	              case 6:
	                response = _context.sent;
	
	
	                // Parse nested JSON once
	                parsedQuiz = JSON.parse(JSON.parse(JSON.stringify(response.singlequiz)));
	                questionIds = parsedQuiz.all_questions, questionTypes = parsedQuiz.readings;
	
	                // Timer values
	
	                quizTime = response.timer_value;
	                userSpendTime = response.user_time_value;
	                currentQuestionId = questionIds[offset];
	                currentQuestionType = questionTypes[offset];
	
	                this.setState({
	                  questionIds: questionIds,
	                  questionTypes: questionTypes,
	                  quizTime: quizTime,
	                  userSpendTime: userSpendTime,
	                  currentQuestionId: currentQuestionId,
	                  currentQuestionType: currentQuestionType,
	                  timer: userSpendTime || quizTime,
	                  isValidate: false
	                });
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          currentQuestionType = _state.currentQuestionType,
	          questionIds = _state.questionIds,
	          questionTypes = _state.questionTypes,
	          isTimer = _state.isTimer,
	          timer = _state.timer,
	          isValidate = _state.isValidate;
	
	      if (!currentQuestionType || Object.keys(currentQuestionType).length === 0) {
	        return null;
	      }
	
	      var commonProps = Object.assign({}, this.props, {
	        questionTypes: questionTypes,
	        questionType: currentQuestionType,
	        apiServices: _ApiServiceProvider.apiServices,
	        questionIds: questionIds,
	        handleChangeParams: this.handleChangeParams,
	        redirectToResults: this.redirectToResults,
	        onHandleSetTimer: this.onHandleSetTimer,
	        examName: _constant.examNameAccordingToDB.EA
	      });
	
	      var reverseTimer = _react2.default.createElement(_ReverseTimer2.default, {
	        initialTimerValue: timer,
	        isTimerRunning: isTimer,
	        apiCall: this.updateUserTimer,
	        onStartTimer: function onStartTimer() {
	          return _this2.setState({ isTimer: true });
	        },
	        onStopTimer: function onStopTimer() {
	          return _this2.setState({ isTimer: false });
	        },
	        onToggleTimer: function onToggleTimer() {
	          return _this2.setState(function (prev) {
	            return { isTimer: !prev.isTimer };
	          });
	        },
	        disabled: isValidate
	      });
	
	      var questionTypeMap = {
	        tab_question: _MultiSourceTab2.default,
	        graph_question: _GraphicalStatement2.default,
	        table_question: _TableAnalysisTwoStatement2.default,
	        two_part_question: _TwoPartAnalysis2.default,
	        question: _NormalQuestion2.default,
	        case_question: _NormalQuestion2.default
	      };
	
	      var QuestionComponent = questionTypeMap[currentQuestionType];
	
	      if (!QuestionComponent) return null;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          QuestionComponent,
	          commonProps,
	          reverseTimer
	        )
	      );
	    }
	  }]);
	
	  return BeginQuizContainer;
	}(_react.Component);
	
	BeginQuizContainer.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = BeginQuizContainer;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _EAQuizSubscriptionPartner = __webpack_require__(857);
	
	var _EAQuizSubscriptionPartner2 = _interopRequireDefault(_EAQuizSubscriptionPartner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Quizzes = function (_Component) {
	  _inherits(Quizzes, _Component);
	
	  function Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Quizzes.__proto__ || Object.getPrototypeOf(Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot == dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i == dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    _this.setState({ display_loader: 'hide_block' });
	                    (0, _toast.showFailure)(resp.message);
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._createQuiz = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var data;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this.setState({ display_loader: 'show_block' });
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context5.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context4.next = 13;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context4.next = 6;
	                            break;
	                          }
	
	                          _this.setState({ display_loader: 'hide_block' });
	                          (0, _toast.showFailure)('Please Upgrade Your Account');
	                          _context4.next = 11;
	                          break;
	
	                        case 6:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context4.next = 11;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, question_length_val, timer_value, chapterAll, dataString, dataReason, chapterall_id, i, data, checkboxes, single_clicked_value;
	                              return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                while (1) {
	                                  switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context2.next = 9;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = 'ea';
	                                      isInArray_var = false;
	                                      _context2.next = 6;
	                                      return (0, _EAQuizSubscriptionPartner2.default)(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context2.sent;
	
	
	                                      console.log('====CHECK SUBSCRIPTION AT PARTNER SIDE =======>', isInArray_var, resp_exam);
	                                      if (isInArray_var) {
	                                        question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                                        chapterAll = '';
	
	                                        timer_value = _this.state.quiz_length_state[_this.state.radio_checked_question].timer_value;
	                                        if (_this.state.all_checked_state) {
	                                          // console.log('if	 working')
	                                          dataString = JSON.stringify(_this.state.chapters);
	                                          dataReason = JSON.parse(dataString);
	                                          chapterall_id = [];
	
	                                          for (i = 0; i < dataReason.length; i++) {
	                                            chapterall_id.push(dataReason[i].chapter_no);
	                                          }
	
	                                          chapterAll = chapterall_id;
	                                          data = {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            chapterAll: ['' + (_this.state.radio_checked_reasoning + 1)],
	                                            questionquize: parseInt(question_length_val),
	                                            priority: _this.state.radio_checked_priority,
	                                            reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                          };
	
	                                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuizequestion', data).then(function (resp) {
	                                            if (resp.success) {
	                                              var retun_all_chapter = JSON.stringify(resp.chapters);
	                                              var chapterParse = JSON.parse(retun_all_chapter);
	                                              var question_id = [];
	                                              var myJson = {
	                                                question_count: '',
	                                                all_questions: {},
	                                                readings: {},
	                                                cases: {}
	                                              };
	                                              for (var i = 0; i < chapterParse.length; i++) {
	                                                var objName = 'q' + i;
	                                                var objValue = chapterParse[i].id;
	                                                myJson.all_questions[i] = objValue;
	                                                myJson.readings[i] = chapterParse[i]['ea_reading.type'];
	                                                myJson.cases[i] = chapterParse[i].case_id;
	                                                question_id.push(chapterParse[i].id);
	                                              }
	                                              myJson.question_count = question_id.length;
	                                              var questions = JSON.stringify(myJson);
	                                              var data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                number_questions: myJson.question_count,
	                                                questions: questions,
	                                                timer_value: timer_value
	                                              };
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/createQuiz', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  _this.context.router.push({
	                                                    pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                    //   `/ea_beforestart/${resp.last_id}/${''}`,
	                                                    // state: {
	                                                    //   token: this.state.token,
	                                                    //   idname: this.state.idname,
	                                                    //   quiz_id: resp.last_id,
	                                                    //   status_send: '',
	                                                    // },
	                                                  });
	                                                } else {
	                                                  //console.log(resp.success);
	                                                }
	                                              });
	                                            } else {
	                                              _this.setState({ display_loader: 'hide_block' });
	                                              (0, _toast.showFailure)(resp.message);
	                                            }
	                                            return resp;
	                                          });
	                                        } else {
	                                          // console.log('else working')
	                                          checkboxes = document.getElementsByName('approve[]');
	                                          i = 0;
	                                          single_clicked_value = [];
	
	                                          if (_this.state.single_clicked_val == '') {
	                                            for (i = 0; i < checkboxes.length; i++) {
	                                              if (checkboxes[i].checked) {
	                                                // console.log(i+'----------'+checkboxes[i].value);
	                                                single_clicked_value.push(checkboxes[i].value);
	                                              }
	                                            }
	
	                                            chapterAll = single_clicked_value;
	                                            // console.log(chapterAll)
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                            };
	
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['ea_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	
	                                                      //   `/ea_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    // console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          } else {
	                                            chapterAll = _this.state.single_clicked_val;
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning
	                                            };
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['ea_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                      //   `/ea_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    //console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          }
	                                        }
	                                      } else {
	                                        _this.setState({ display_loader: 'hide_block' });
	                                        (0, _toast.showFailure)('Please Upgrade Your Account');
	                                      }
	
	                                    case 9:
	                                    case 'end':
	                                      return _context2.stop();
	                                  }
	                                }
	                              }, _callee2, _this2);
	                            }));
	
	                            return function (_x3) {
	                              return _ref4.apply(this, arguments);
	                            };
	                          }());
	
	                        case 11:
	                          _context4.next = 14;
	                          break;
	
	                        case 13:
	                          if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                            _this.setState({ display_loader: 'hide_block' });
	                            (0, _toast.showFailure)('Please Upgrade Your Account');
	                          } else {
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, question_length_val, timer_value, chapterAll, dataString, dataReason, chapterall_id, i, data, checkboxes, single_clicked_value;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 9;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = 'ea';
	                                        isInArray_var = false;
	                                        _context3.next = 6;
	                                        return _EASubscription2.default.checkEAQuizSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context3.sent;
	
	                                        console.log('check subscription without partner=======>', selectedmen, exam_data, isInArray_var);
	                                        if (isInArray_var) {
	                                          question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                                          chapterAll = '';
	
	                                          timer_value = _this.state.quiz_length_state[_this.state.radio_checked_question].timer_value;
	                                          if (_this.state.all_checked_state) {
	                                            // console.log('if	 working')
	                                            dataString = JSON.stringify(_this.state.chapters);
	                                            dataReason = JSON.parse(dataString);
	                                            chapterall_id = [];
	
	                                            for (i = 0; i < dataReason.length; i++) {
	                                              chapterall_id.push(dataReason[i].chapter_no);
	                                            }
	
	                                            chapterAll = chapterall_id;
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: ['' + (_this.state.radio_checked_reasoning + 1)],
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                            };
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['ea_reading.type'];
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                  question_id.push(chapterParse[i].id);
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/createQuiz', data).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.setState({ display_loader: 'hide_block' });
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                      //   `/ea_beforestart/${resp.last_id}/${''}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      //   status_send: '',
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    //console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          } else {
	                                            // console.log('else working')
	                                            checkboxes = document.getElementsByName('approve[]');
	                                            i = 0;
	                                            single_clicked_value = [];
	
	                                            if (_this.state.single_clicked_val == '') {
	                                              for (i = 0; i < checkboxes.length; i++) {
	                                                if (checkboxes[i].checked) {
	                                                  // console.log(i+'----------'+checkboxes[i].value);
	                                                  single_clicked_value.push(checkboxes[i].value);
	                                                }
	                                              }
	
	                                              chapterAll = single_clicked_value;
	                                              // console.log(chapterAll)
	                                              data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                chapterAll: chapterAll,
	                                                questionquize: parseInt(question_length_val),
	                                                priority: _this.state.radio_checked_priority,
	                                                // reasoning: chapterAll.length
	                                                //   ? chapterAll[0] === '1'
	                                                //     ? 'Integrated Reasoning'
	                                                //     : chapterAll[0] === '2'
	                                                //     ? 'Quantitative Reasoning'
	                                                //     : 'Verbal Reasoning'
	                                                //   : 'Verbal Reasoning',
	                                                reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                              };
	
	
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuizequestion', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                  var chapterParse = JSON.parse(retun_all_chapter);
	                                                  var question_id = [];
	                                                  var myJson = {
	                                                    question_count: '',
	                                                    all_questions: {},
	                                                    readings: {},
	                                                    cases: {}
	                                                  };
	                                                  for (var i = 0; i < chapterParse.length; i++) {
	                                                    var objName = 'q' + i;
	                                                    var objValue = chapterParse[i].id;
	                                                    myJson.all_questions[i] = objValue;
	                                                    myJson.readings[i] = chapterParse[i]['ea_reading.type'];
	                                                    question_id.push(chapterParse[i].id);
	                                                    myJson.cases[i] = chapterParse[i].case_id;
	                                                  }
	                                                  myJson.question_count = question_id.length;
	                                                  var questions = JSON.stringify(myJson);
	                                                  var data_insert = {
	                                                    token: _this.state.token,
	                                                    idname: _this.state.idname,
	                                                    number_questions: myJson.question_count,
	                                                    questions: questions,
	                                                    timer_value: timer_value
	                                                  };
	                                                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/createQuiz', data_insert).then(function (resp) {
	                                                    if (resp.success) {
	                                                      _this.context.router.push({
	                                                        pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	
	                                                        //   `/ea_beforestart/${resp.last_id}`,
	                                                        // state: {
	                                                        //   token: this.state.token,
	                                                        //   idname: this.state.idname,
	                                                        //   quiz_id: resp.last_id,
	                                                        // },
	                                                      });
	                                                    } else {
	                                                      // console.log(resp.success);
	                                                    }
	                                                  });
	                                                } else {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  (0, _toast.showFailure)(resp.message);
	                                                }
	                                                return resp;
	                                              });
	                                            } else {
	                                              chapterAll = _this.state.single_clicked_val;
	                                              data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                chapterAll: chapterAll,
	                                                questionquize: parseInt(question_length_val),
	                                                priority: _this.state.radio_checked_priority,
	                                                // reasoning: chapterAll.length
	                                                //   ? chapterAll[0] === '1'
	                                                //     ? 'Integrated Reasoning'
	                                                //     : chapterAll[0] === '2'
	                                                //     ? 'Quantitative Reasoning'
	                                                //     : 'Verbal Reasoning'
	                                                //   : 'Verbal Reasoning',
	                                                reasoning: _this.state.radio_checked_reasoning
	                                              };
	
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getQuizequestion', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                  var chapterParse = JSON.parse(retun_all_chapter);
	                                                  var question_id = [];
	                                                  var myJson = {
	                                                    question_count: '',
	                                                    all_questions: {},
	                                                    readings: {},
	                                                    cases: {}
	                                                  };
	                                                  for (var i = 0; i < chapterParse.length; i++) {
	                                                    var objName = 'q' + i;
	                                                    var objValue = chapterParse[i].id;
	                                                    myJson.all_questions[i] = objValue;
	                                                    myJson.readings[i] = chapterParse[i]['ea_reading.type'];
	                                                    question_id.push(chapterParse[i].id);
	                                                    myJson.cases[i] = chapterParse[i].case_id;
	                                                  }
	                                                  myJson.question_count = question_id.length;
	                                                  var questions = JSON.stringify(myJson);
	                                                  var data_insert = {
	                                                    token: _this.state.token,
	                                                    idname: _this.state.idname,
	                                                    number_questions: myJson.question_count,
	                                                    questions: questions,
	                                                    timer_value: timer_value
	                                                  };
	                                                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/createQuiz', data_insert).then(function (resp) {
	                                                    if (resp.success) {
	                                                      _this.context.router.push({
	                                                        pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                        //   `/ea_beforestart/${resp.last_id}`,
	                                                        // state: {
	                                                        //   token: this.state.token,
	                                                        //   idname: this.state.idname,
	                                                        //   quiz_id: resp.last_id,
	                                                        // },
	                                                      });
	                                                    } else {
	                                                      //console.log(resp.success);
	                                                    }
	                                                  });
	                                                } else {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  (0, _toast.showFailure)(resp.message);
	                                                }
	                                                return resp;
	                                              });
	                                            }
	                                          }
	                                        } else {
	                                          _this.setState({ display_loader: 'hide_block' });
	                                          (0, _toast.showFailure)('Please Upgrade Your Account');
	                                        }
	
	                                      case 9:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	                          }
	
	                        case 14:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context6.next = 4;
	                              break;
	                            }
	
	                            _context6.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      token: '',
	      idname: '',
	      chapters: [{
	        chapter_no: 1,
	        chapter_name: 'Integrated Reasoning'
	      }, {
	        chapter_no: 2,
	        chapter_name: 'Quantitative Reasoning'
	      }, {
	        chapter_no: 3,
	        chapter_name: 'Verbal Reasoning'
	      }],
	      all_checked_state: true,
	      radio_checked_question: 0,
	      deleteItemId: '',
	      radio_checked_priority: 'none',
	      radio_checked_reasoning: 0,
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reasoning: this.state.radio_checked_reasoning
	      };
	
	      this.abandonedQuizzes(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        // console.log(resp_quiz_length.quiz_length);
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this3.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	  }, {
	    key: '_single_Checked',
	    value: function _single_Checked(items, index_value, e) {
	      var _this4 = this;
	
	      this.setState({ radio_checked_reasoning: index_value });
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reasoning: index_value
	      };
	      console.log('I am inside single checked');
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        if (resp_quiz_length.success) {
	          _this4.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this4.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	
	    /*_changeIncludetimer(){
	      if(this.state.include_timer)
	      {
	        this.setState({ include_timer:!this.state.include_timer });
	      }
	      else{
	        this.setState({ include_timer:!this.state.include_timer });
	      }    	
	    }*/
	
	    /*_changeSaveresult(){
	      if(this.state.save_results)
	      {
	        this.setState({ save_results:!this.state.save_results });
	      }
	      else{
	        this.setState({ save_results:!this.state.save_results });
	      }    
	    }*/
	
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', items.id).replace(':status_send', 'abondon')
	
	        //   `/ea_beforestart/${items.id}/${'abondon'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: items.id,
	        //   status_send: 'abondon',
	        // },
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: _AppRoutes2.default.EA_BEFORE_START.replace(':quiz_id', items.id).replace(':status_send', 'completed')
	
	        //   `/ea_beforestart/${items.id}/${'completed'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: items.id,
	        //   status_send: 'completed',
	        // },
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'radio_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                // type='checkbox'
	                type: 'radio',
	                name: 'approve[]',
	                value: items.chapter_no,
	                checked: _this5.state.radio_checked_reasoning == index,
	                onClick: _this5._single_Checked.bind(_this5, items, index)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'cursor_pointer',
	                  onClick: _this5._checkAbondon.bind(_this5, items)
	                },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'delete-quizzes',
	                  onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  }
	                },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'cursor_pointer',
	                  onClick: _this5._checkCompleted.bind(_this5, items)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question == index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().CFA_LEVEL_I_QUIZZES
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this._createQuiz.bind(this)
	              },
	              ' ',
	              _language2.default.LC().CREATE_QUIZ,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().CONTENT
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    chapter_data
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().ABANDONED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        abandoned_data
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().Priorities_By,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().NONE,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'none',
	                      name: 'none',
	                      value: 'none',
	                      checked: this.state.radio_checked_priority == 'none',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    _language2.default.LC().UNANSWERED,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unanswered',
	                      name: 'mark_unanswered',
	                      value: 'unanswered',
	                      checked: this.state.radio_checked_priority == 'unanswered',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().Wrong_answers,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unattempted',
	                      name: 'mark_unattempted',
	                      value: 'wrongquestion',
	                      checked: this.state.radio_checked_priority == 'wrongquestion',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().LENGTH,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  quiz_length_state_data
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().COMPLETED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        getallcompleteQuiz_data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'close',
	                  color: 'secondary',
	                  onClick: this.deleteQuizzes
	                },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Quizzes;
	}(_react.Component);
	
	Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Quizzes;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(295);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var ChatperwiseReadingData = function (_Component) {
	  _inherits(ChatperwiseReadingData, _Component);
	
	  function ChatperwiseReadingData(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee5(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _this.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this.state.user_city,
	                    country: _this.state.user_country,
	                    state: _this.state.user_state,
	                    continent: _this.state.user_continent,
	                    ip: _this.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserVideowatch', data).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                      return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              if (resp.success) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  _data = { token: _this.state.token, idname: _this.state.idname };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this.toggleAlert();
	                      } else {
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data2;
	
	                            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                              while (1) {
	                                switch (_context3.prev = _context3.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context3.next = 10;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context3.next = 6;
	                                    return _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                  case 6:
	                                    isInArray_var = _context3.sent;
	
	                                    if (isInArray_var) {
	                                      _data2 = {
	                                        token: _this.state.token,
	                                        idname: _this.state.idname,
	                                        id: chapter.id,
	                                        videoIndex: index,
	                                        city: _this.state.user_city,
	                                        country: _this.state.user_country,
	                                        state: _this.state.user_state,
	                                        continent: _this.state.user_continent,
	                                        ip: _this.state.user_ip
	                                      };
	
	                                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserVideowatch', _data2).then(function () {
	                                        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                                          return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                            while (1) {
	                                              switch (_context2.prev = _context2.next) {
	                                                case 0:
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                                    });
	                                                  } else {}
	
	                                                case 1:
	                                                case 'end':
	                                                  return _context2.stop();
	                                              }
	                                            }
	                                          }, _callee2, _this2);
	                                        }));
	
	                                        return function (_x5) {
	                                          return _ref4.apply(this, arguments);
	                                        };
	                                      }());
	                                    } else {
	                                      _this.toggleAlert();
	                                    }
	                                    _context3.next = 10;
	                                    break;
	
	                                  case 10:
	                                  case 'end':
	                                    return _context3.stop();
	                                }
	                              }
	                            }, _callee3, _this2);
	                          }));
	
	                          return function (_x4) {
	                            return _ref3.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                        return _this.toggleAlert();
	                      } else {
	                        var exam_selected = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : resp.profileInfo.exam_selected;
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            var selectedmen = _this.state.selectedmenu;
	                            var isInArray_var = false;
	                            isInArray_var = _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                            if (isInArray_var) {
	                              var _data3 = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                id: chapter.id,
	                                videoIndex: index,
	                                city: _this.state.user_city,
	                                country: _this.state.user_country,
	                                state: _this.state.user_state,
	                                continent: _this.state.user_continent,
	                                ip: _this.state.user_ip
	                              };
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserVideowatch', _data3).then(function () {
	                                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                    while (1) {
	                                      switch (_context4.prev = _context4.next) {
	                                        case 0:
	                                          if (resp.success) {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                            });
	                                          } else {}
	
	                                        case 1:
	                                        case 'end':
	                                          return _context4.stop();
	                                      }
	                                    }
	                                  }, _callee4, _this2);
	                                }));
	
	                                return function (_x6) {
	                                  return _ref5.apply(this, arguments);
	                                };
	                              }());
	                            } else {
	                              return _this.toggleAlert();
	                            }
	                          }
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(chapter, index) {
	        var _this$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this$state = _this.state, token = _this$state.token, idname = _this$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  videoIndex: index
	                };
	                _context6.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x7, _x8) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	
	    _this.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	      var count = 0;
	      if (_this.state.allchapters.length) {
	        data = _this.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              alt: '',
	              width: '100%',
	              src: item.posterImage ? item.posterImage : (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1'),
	              onError: function onError(_ref7) {
	                var currentTarget = _ref7.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	                  currentTarget.onerror = null; // prevents looping
	                  currentTarget.src = (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1_2');
	                }
	              },
	              value: index,
	              onClick: _this._getReadings.bind(_this, item, index),
	              className: 'pointer_class slider_row'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this._getReadings.bind(_this, item, index),
	              className: 'pointer_class slider_row'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { className: 'videoTitles12', style: { padding: '10px' } },
	              item.title.toLowerCase()
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this$state2, 'offset', 0), _defineProperty(_this$state2, 'limit', 10), _defineProperty(_this$state2, 'Allchapters', []), _defineProperty(_this$state2, 'itemData', []), _defineProperty(_this$state2, 'videoUrl', ''), _defineProperty(_this$state2, 'srcUrl', ''), _defineProperty(_this$state2, 'srcUrl_final', ''), _defineProperty(_this$state2, 'selectedmenu', 'ea'), _defineProperty(_this$state2, 'showFreePremium', true), _defineProperty(_this$state2, 'user_city', ''), _defineProperty(_this$state2, 'user_country', ''), _defineProperty(_this$state2, 'user_ip', ''), _defineProperty(_this$state2, 'user_state', ''), _defineProperty(_this$state2, 'user_continent', ''), _this$state2);
	    return _this;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var result, storage_session, payload;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context7.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                payload = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context7.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEAVideosChapterwise', payload).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this3.setState({ allchapters: [] });
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	exports.default = ChatperwiseReadingData;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	__webpack_require__(295);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ChatperwiseReadingData = __webpack_require__(703);
	
	var _ChatperwiseReadingData2 = _interopRequireDefault(_ChatperwiseReadingData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var GMATVideoLessons = function (_Component) {
	  _inherits(GMATVideoLessons, _Component);
	
	  function GMATVideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATVideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (GMATVideoLessons.__proto__ || Object.getPrototypeOf(GMATVideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: "/Subscribe/",
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + "/ea_question_bank/getEAVideosChapterwise", data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(":id", resp.cfavchapterfirst.id).replace(":showFreePremium", _this.state.showFreePremium ? 0 : 1).replace(":type", chapter.chapter_id === 0 ? 0 : 1).replace(":chapter_id", resp.cfavchapterfirst.chapter_id).replace(":index", 0)
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case "end":
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(":id", lastRecord.ea_video.id).replace(":showFreePremium", _this.state.showFreePremium ? 0 : 1).replace(":type", lastRecord.ea_video.chapter_id === 0 ? 0 : 1).replace(":chapter_id", lastRecord.ea_video.chapter_id).replace(":index", lastRecord.videoIndex)
	                });
	              }
	
	            case 2:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_cfa = "<i class=\"icon-info icons font-2xl d-block \"></i>";
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      chapters: [],
	      allChapters: [],
	      token: "",
	      idname: "",
	      ValidToken: false,
	      chapter_id: "",
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: "",
	      subscription_details_for_isActive: "",
	      showFreePremium: "",
	      selectedmenu: "ea",
	      exams: [],
	      cfaUnlimitedPackage: "",
	      cfaUnlimitedActiveExam: "",
	      lastRecord: "",
	      lastAttempt: false,
	      user_city: "",
	      user_country: "",
	      user_ip: "",
	      user_state: "",
	      user_continent: ""
	    };
	    return _this;
	  }
	
	  _createClass(GMATVideoLessons, [{
	    key: "componentDidUpdate",
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "componentDidMount",
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data, chapter;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem("localstorageval"));
	
	                this.setState({ idname: storage_session["idname"] });
	                this.setState({ token: storage_session["token"] });
	                data = {
	                  token: storage_session["token"],
	                  idname: storage_session["idname"]
	                };
	                // await FD.callAPI(App_data.backend_api + "/user/getProfileInfo", data).then(async (resp) => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	                  var resp, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context6.next = 3;
	                            break;
	                          }
	
	                          return _context6.abrupt("return");
	
	                        case 3:
	                          if (!(resp.profileInfo.role === "partner")) {
	                            _context6.next = 16;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === "" && resp.profileInfo.exam_package === "")) {
	                            _context6.next = 8;
	                            break;
	                          }
	
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context6.next = 14;
	                          break;
	
	                        case 8:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this3.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context6.next = 14;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getExamsbyUser", dataset).then(function () {
	                            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                while (1) {
	                                  switch (_context5.prev = _context5.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context5.next = 10;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this3.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context5.next = 6;
	                                      return _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context5.sent;
	
	                                      if (isInArray_var) {
	                                        _this3.setState({ showFreePremium: false });
	                                      } else {
	                                        _this3.setState({ showFreePremium: true });
	                                      }
	                                      _context5.next = 10;
	                                      break;
	
	                                    case 10:
	                                    case "end":
	                                      return _context5.stop();
	                                  }
	                                }
	                              }, _callee5, _this3);
	                            }));
	
	                            return function (_x4) {
	                              return _ref7.apply(this, arguments);
	                            };
	                          }());
	
	                        case 14:
	                          _context6.next = 27;
	                          break;
	
	                        case 16:
	                          if (!(resp.profileInfo.exam_selected === "" && resp.profileInfo.cfaUnlimitedPackage == "" && resp.profileInfo.cfaUnlimitedActiveExam == "")) {
	                            _context6.next = 21;
	                            break;
	                          }
	
	                          console.log("if working", resp.profileInfo.exam_selected === "" && resp.profileInfo.cfaUnlimitedPackage == "" && resp.profileInfo.cfaUnlimitedActiveExam == "");
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context6.next = 27;
	                          break;
	
	                        case 21:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this3.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context6.next = 27;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getExamsbyUser", dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this3.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                              // console.log(isInArray_var);
	                              if (isInArray_var) {
	                                // console.log('IF WORKING')
	                                _this3.setState({ showFreePremium: false });
	                              } else {
	                                // console.log('ELSE WORKING')
	                                _this3.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 27:
	                        case "end":
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this3);
	                })));
	
	                dataExam = {
	                  token: storage_session["token"],
	                  idname: storage_session["idname"]
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getExams", dataExam).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    // console.log(resp.exams[0])
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session["token"],
	                  idname: storage_session["idname"]
	                };
	                _context7.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/ea_question_bank/getEAVideos", data_data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({
	                      chapters: resp.cfavideo
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 10:
	                chapter = this.state.chapters.map(function (val) {
	                  if (val.Countvideos !== 0) {
	                    return val;
	                  }
	                });
	                data_data = {
	                  token: storage_session["token"],
	                  idname: storage_session["idname"]
	                };
	                _context7.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/ea_question_bank/getlastViewedVideo", data_data).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 14:
	              case "end":
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      console.log(this.state.chapters);
	      var data = "";
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          console.log("===========> chapter for video", item);
	          // if (item.Countvideos !== 0) {
	          //   let videoTitle;
	          //   if (item.chapter_no === 1) {
	          //     videoTitle = "Exam & Preparation Overview";
	          //   } else if (item.chapter_no === 2) {
	          //     videoTitle = "Integrated Reasoning";
	          //   } else if (item.chapter_no === 3) {
	          //     videoTitle = "Verbal Reasoning";
	          //   } else if (item.chapter_no === 4) {
	          //     videoTitle = "Quantitative Reasoning";
	          //   }
	          return _react2.default.createElement(
	            "div",
	            { className: "col-sm-12 col-md-12", key: index },
	            _react2.default.createElement(
	              "div",
	              { className: "card" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-header card_header_bg", value: item.id },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "pointer_class",
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  " ",
	                  item.chapter_no,
	                  " - ",
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "card-block list_icon_outer",
	                  key: item.chapter_name
	                },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  "p",
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ": ",
	                  item.Countvideos
	                ) : _react2.default.createElement("p", null),
	                _react2.default.createElement(
	                  "div",
	                  { key: index, className: "col-xs-12 col-sm-12 col-md-12" },
	                  _react2.default.createElement(_ChatperwiseReadingData2.default, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          );
	          // }
	          // else {
	          //   return null;
	          // }
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "video_lesson_wrap" },
	        _react2.default.createElement(
	          "div",
	          { className: "animated fadeIn" },
	          _react2.default.createElement(
	            "div",
	            { className: "margin_bottom_20 d-flex justify-content-between last_question_read" },
	            _react2.default.createElement(
	              "h1",
	              { className: "section_head" },
	              " ",
	              _language2.default.LC().VIDEO_LESSONS,
	              " "
	            ),
	            lastAttempt ? _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-primary pointer_class",
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              " ",
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              " "
	            ) : null
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-xs-12 col-sm-12 col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "bank_wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12 col-md-12" },
	                    _react2.default.createElement("div", { className: "card" })
	                  ),
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent
	          })
	        )
	      );
	    }
	  }]);
	
	  return GMATVideoLessons;
	}(_react.Component);
	
	GMATVideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: className,
	      style: Object.assign({}, style, { display: "block" }),
	      onClick: onClick
	    },
	    _react2.default.createElement("img", { onClick: onClick, src: "../../assets/img/right-arrow.svg", alt: "" })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: "block",
	        fontSize: "60px",
	        right: "80px",
	        zIndex: "15",
	        height: "20px",
	        width: "40px",
	        opacity: "1"
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement("img", { onClick: onClick, src: "../../assets/img/left-arrow.svg", alt: "" })
	  );
	}
	
	exports.default = GMATVideoLessons;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1007);
	
	var _EASubscription = __webpack_require__(74);
	
	var _EASubscription2 = _interopRequireDefault(_EASubscription);
	
	var _EASubscription3 = __webpack_require__(86);
	
	var _EASubscription4 = _interopRequireDefault(_EASubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactstrap = __webpack_require__(6);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _toast = __webpack_require__(15);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var GMATvideodisplay = function (_Component) {
	  _inherits(GMATvideodisplay, _Component);
	
	  function GMATvideodisplay(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, GMATvideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (GMATvideodisplay.__proto__ || Object.getPrototypeOf(GMATvideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserVideowatch', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      // console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment,
	        videoIndex: _this.state.currentUrl,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/videoGetFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.EA_VIDEO_LESSONS
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context2.next = 6;
	                        return _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	
	
	                        if (isInArray_var) {
	                          _this._runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x3) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp, 'sssssssssssssssssssssssss');
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                // console.log('selectedmen--------------------', selectedmen);
	                // console.log('isInArray_var--------------------', isInArray_var);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(index, url_id, title, id, url_id_qq, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file
	                }, function () {
	                  _this.context.router.push({
	                    pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                    // `/cfavideodisplay/${this.props.params.id}/${
	                    //   this.props.params.showFreePremium
	                    // }/${this.props.params.type}/${this.props.params.chapter_id}/${
	                    //   this.state.currentUrl
	                    // }`,
	                  });
	                });
	
	                _context6.next = 4;
	                return _this.savelastVideo(id, index);
	
	              case 4:
	                _context6.next = 6;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 6:
	                _context6.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee4$(_context4) {
	                            while (1) {
	                              switch (_context4.prev = _context4.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context4.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context4.next = 6;
	                                  return _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context4.sent;
	
	                                  if (!isInArray_var) {
	                                    _context4.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                                      // `/cfavideodisplay/${this.props.params.id}/${
	                                      //   this.props.params.showFreePremium
	                                      // }/${this.props.params.type}/${
	                                      //   this.props.params.chapter_id
	                                      // }/${this.state.currentUrl}`,
	                                    });
	                                  });
	                                  _context4.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context4.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context4.abrupt('return');
	
	                                case 16:
	                                  return _context4.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context4.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context4.stop();
	                              }
	                            }
	                          }, _callee4, _this2);
	                        }));
	
	                        return function (_x12) {
	                          return _ref5.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                      // console.log("if working");
	
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context5.next = 6;
	                                  return _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context5.sent;
	
	                                  if (!isInArray_var) {
	                                    _context5.next = 16;
	                                    break;
	                                  }
	
	                                  // console.log('IF WORKING')
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                                      // `/cfavideodisplay/${this.props.params.id}/${
	                                      //   this.props.params.showFreePremium
	                                      // }/${this.props.params.type}/${
	                                      //   this.props.params.chapter_id
	                                      // }/${this.state.currentUrl}`,
	                                    });
	                                  });
	                                  _context5.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context5.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context5.abrupt('return');
	
	                                case 16:
	                                  return _context5.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context5.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this2);
	                        }));
	
	                        return function (_x13) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x5, _x6, _x7, _x8, _x9, _x10, _x11) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(id, index) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context7.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x14, _x15) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      // console.log('_saveFavVideo', item);
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state3 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state3, 'MessageTitle', messageTitle_cfa), _defineProperty(_this$state3, 'MessageContent', _alertMessage2.default.messageContent_gmat), _defineProperty(_this$state3, 'token', ''), _defineProperty(_this$state3, 'idname', ''), _defineProperty(_this$state3, 'ValidToken', false), _defineProperty(_this$state3, 'all_questions', ''), _defineProperty(_this$state3, 'chapters', []), _defineProperty(_this$state3, 'all_questions_state', []), _defineProperty(_this$state3, 'video_display', ''), _defineProperty(_this$state3, 'video_display_qq', ''), _defineProperty(_this$state3, 'url_id', ''), _defineProperty(_this$state3, 'currentUrl', ''), _defineProperty(_this$state3, 'reportLoading', false), _defineProperty(_this$state3, 'free', ''), _defineProperty(_this$state3, 'video_title', ''), _defineProperty(_this$state3, 'video_display_no', ''), _defineProperty(_this$state3, 'allChapters', []), _defineProperty(_this$state3, 'Chapter_Title', ''), _defineProperty(_this$state3, 'chapterName', ''), _defineProperty(_this$state3, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state3, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state3, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state3, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state3, 'currentReading', _this.props.params.id), _defineProperty(_this$state3, 'comment_update_id', ''), _defineProperty(_this$state3, 'currentChapterNo', ''), _defineProperty(_this$state3, 'currentReadingNo', ''), _defineProperty(_this$state3, 'currentReadingTitle', ''), _defineProperty(_this$state3, 'subscriptionstatus', ''), _defineProperty(_this$state3, 'selectedmenu', 'ea'), _defineProperty(_this$state3, 'subscription_details_for_isActive', ''), _defineProperty(_this$state3, 'pdfData', []), _defineProperty(_this$state3, 'pdf_file', ''), _defineProperty(_this$state3, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state3, 'userType', ''), _defineProperty(_this$state3, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state3, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state3, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state3, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state3, 'bookmarkColor', ''), _defineProperty(_this$state3, 'isFlashCardHidden', true), _defineProperty(_this$state3, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _this$state3);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(GMATvideodisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
	      // const result = getDeviceDetails();
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	      this.context.router.push({
	        pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium).replace(':type', this.props.params.type).replace(':chapter_id', this.props.params.chapter_id).replace(':index', this.state.currentUrl + 1)
	
	        // `/cfavideodisplay/${this.props.params.id}/${
	        //   this.props.params.showFreePremium
	        // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
	        //   .currentUrl + 1}`,
	      });
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        // if (this.state.currentUrl || this.state.currentUrl) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("_goToPreviousReading-tooogle");
	              return _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    // console.log('IF WORKING')
	                    // console.log("_goToPreviousReading Premium");
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      // console.log('currentUrl', this.state.currentUrl);
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      this.context.router.push({
	        pathname: _AppRoutes2.default.EA_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium).replace(':type', this.props.params.type).replace(':chapter_id', this.props.params.chapter_id).replace(':index', this.state.currentUrl + 1)
	
	        // `/cfavideodisplay/${this.props.params.id}/${
	        //   this.props.params.showFreePremium
	        // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
	        //   .currentUrl + 1}`,
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context8.next = 16;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this4.state.selectedmenu;
	                          isInArray_var = false;
	                          _context8.next = 6;
	                          return _EASubscription4.default.checkEAVideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                        case 6:
	                          isInArray_var = _context8.sent;
	
	                          if (!isInArray_var) {
	                            _context8.next = 13;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({
	                              video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                            });
	                            _this4.setState({
	                              video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                            });
	                            _this4.setState({
	                              video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                            });
	                            _this4.setState({
	                              currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                            });
	                            _this4.setState({
	                              currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                            });
	                            _this4.setState({
	                              currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                            });
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context8.abrupt('return');
	
	                        case 13:
	                          return _context8.abrupt('return', _this4.toggleAlert());
	
	                        case 14:
	                          _context8.next = 17;
	                          break;
	
	                        case 16:
	                          console.log('fail');
	
	                        case 17:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this4);
	                }));
	
	                return function (_x16) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("working");
	              // console.log("_goToNextReading toggleAlert");
	
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _EASubscription2.default.checkEAVideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    // console.log("_goToNextReading Premium");
	
	                    // console.log('IF WORKING')
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      // console.log('hiyuuuuuuuuu', subscriptionstatus);
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getQuestions', data).then(function (resp) {
	        // console.log('resp');
	        if (resp && resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: _AppRoutes2.default.VIEW_EA_QUESTION.replace(':chapter_no', _this5.state.currentChapterNo).replace(':id', _this5.state.currentReadingNo).replace(':subscriptionstatus', _this5.state.subscriptionstatus).replace(':reading', _this5.state.currentReadingTitle)
	            });
	          } else {
	            (0, _toast.showFailure)('No questions found');
	          }
	        } else {
	          _this5.toggleAlert();
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps, prevState) {
	        var _this6 = this;
	
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                console.log('showFreePremium', this.props.params);
	
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context9.next = 8;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context9.next = 5;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 5:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context9.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._deleteFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({ ValidToken: false });
	                    _this6.setState({ flash_data: flash_cards });
	                    _this6.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 8:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x17, _x18) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	        var _this7 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context11.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context11.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  // console.log('IF Working');
	                  this.setState({
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id !== ':chapter_id' ? this.props.params.chapter_id : this.props.params.id
	                };
	                // console.log('this.propsssssssssssssss', this.props);
	
	                _context11.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEAVideosChapterwise', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context10.next = 28;
	                              break;
	                            }
	
	                            _context10.next = 3;
	                            return _this7.setState({ ValidToken: true });
	
	                          case 3:
	                            _context10.next = 5;
	                            return _this7.setState({ chapters: resp.cfavchapter });
	
	                          case 5:
	                            if (!(_this7.state.chapters && _this7.state.chapters.length && _this7.state.chapters[_this7.state.currentUrl])) {
	                              _context10.next = 26;
	                              break;
	                            }
	
	                            _context10.next = 8;
	                            return _this7.setState({
	                              pdf_file: _this7.state.chapters[_this7.state.currentUrl] && _this7.state.chapters[_this7.state.currentUrl].pdf_file ? _this7.state.chapters[_this7.state.currentUrl].pdf_file : null
	                            });
	
	                          case 8:
	                            _context10.next = 10;
	                            return _this7.setState({
	                              currentReading: _this7.state.chapters[_this7.state.currentUrl].id
	                            });
	
	                          case 10:
	                            _context10.next = 12;
	                            return _this7.setState({
	                              video_display: _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 12:
	                            _context10.next = 14;
	                            return _this7.setState({
	                              video_display_qq: _this7.state.chapters[_this7.state.currentUrl].url_id_qq
	                            });
	
	                          case 14:
	                            _context10.next = 16;
	                            return _this7.setState({
	                              video_display_previous: _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 16:
	                            _context10.next = 18;
	                            return _this7.setState({
	                              video_title: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 18:
	                            _context10.next = 20;
	                            return _this7.setState({
	                              video_display_next: _this7.state.chapters[_this7.state.currentUrl + 1] ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 20:
	                            _context10.next = 22;
	                            return _this7.setState({
	                              currentChapterNo: _this7.state.chapters[_this7.state.currentUrl].chapter_id
	                            });
	
	                          case 22:
	                            _context10.next = 24;
	                            return _this7.setState({
	                              currentReadingNo: _this7.state.chapters[_this7.state.currentUrl].reading_no
	                            });
	
	                          case 24:
	                            _context10.next = 26;
	                            return _this7.setState({
	                              currentReadingTitle: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 26:
	                            _context10.next = 29;
	                            break;
	
	                          case 28:
	                            _this7.setState({ ValidToken: false });
	
	                          case 29:
	                            return _context10.abrupt('return', resp);
	
	                          case 30:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this7);
	                  }));
	
	                  return function (_x19) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context11.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getEAVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ ValidToken: true });
	                    _this7.setState({ allChapters: resp.cfavideo });
	                    _this7.props.params.chapter_id === undefined ? null : _this7.setState({
	                      Chapter_Title: resp.cfavideo && resp.cfavideo[_this7.props.params.chapter_id - 1] && resp.cfavideo[_this7.props.params.chapter_id - 1].chapter_name ? resp.cfavideo[_this7.props.params.chapter_id - 1].chapter_name : ''
	                    });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 16:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context11.next = 19;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 19:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context11.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this7.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._editFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._deleteFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this7.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this7.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this7.setState({ ValidToken: false });
	                    _this7.setState({ flash_data: flash_cards });
	                    _this7.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 22:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context11.next = 25;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/ea_question_bank/getea_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ pdfData: resp });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 25:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          type = _state.type,
	          currentReading = _state.currentReading,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          chapters = _state.chapters,
	          pdf_file = _state.pdf_file,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          questionsCSS = _state.questionsCSS,
	          saveVideo_text = _state.saveVideo_text,
	          showFreePremium = _state.showFreePremium;
	
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this8.state.showFreePremium ? item.free === 1 || type === 'intro' ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id === _this8.state.video_display ? 'active' : '',
	                    onClick: _this8.getVideourl.bind(_this8, index, item.url_id, item.title, item.id, item.url_id_qq, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow videoTitles12' },
	                    item.title.toLowerCase()
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'mb-0 videoTitles12' },
	                    this.state.video_title.toLowerCase()
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        allowFullScreen: true,
	                        width: '100%',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: (0, _constant.flowPlayerVideoDisplayUrl)(this.state.video_display_qq),
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(_VideoValidateReportIcons2.default, {
	                moveToNotes: this.moveToNotes
	                // notesCSS={this.state.notesCSS}
	                , moveToPracticeQuestions: this.moveToPracticeQuestions,
	                _saveFavVideo: this._saveFavVideo,
	                _displayReportForm: this._displayReportForm,
	                viewPdf: this.pdfOpen,
	                pdfFile: pdf_file,
	                noPDFInExam: pdf_file ? false : true,
	                bookmarkCSS: bookmarkCSS,
	                bookmarkColor: bookmarkColor,
	                type: type,
	                questionsCSS: questionsCSS,
	                saveVideo_text: saveVideo_text,
	                currentReading: currentReading,
	                chapters: chapters,
	                showFreePremium: showFreePremium
	              })
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(_FlashCard2.default, {
	                item: { id: currentReading },
	                type: 'video',
	                isFlashCardHidden: isFlashCardHidden,
	                ref: this.setChildRef,
	                exam: 'ea'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 d-none' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'card-header pointer_class',
	                      onClick: this._getToggleFlash.bind()
	                    },
	                    _language2.default.LC().FLASHCARD,
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'float-right text-right' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/arrow_down_ico.png', alt: '' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' }, ref: 'flash_toggle_div' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-12 col-sm-12 col-md-12' },
	                          _react2.default.createElement(
	                            'ul',
	                            { className: 'comment_list_wrapper' },
	                            this.state.flash_data
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: this.state.flash_form },
	                          _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement('textarea', {
	                              id: 'flash_card',
	                              name: 'flash_card',
	                              rows: '6',
	                              className: 'form-control margin_bottom_10',
	                              placeholder: 'Your flash card here'
	                            }),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                type: 'button',
	                                className: 'btn btn-primary active pointer_class',
	                                onClick: this._saveFlashCard.bind(this, this.state.currentReading)
	                              },
	                              _language2.default.LC().CREATE
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              '*',
	                              _language2.default.LC().FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATvideodisplay;
	}(_react.Component);
	
	GMATvideodisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.resizeListener = function () {
	      // write code here
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	    };
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this10 = this;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context12.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this10.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref12.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATvideodisplay;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CardBody = __webpack_require__(118);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _CardHeader = __webpack_require__(119);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _Question = __webpack_require__(270);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _ReportQuestion = __webpack_require__(271);
	
	var _ReportQuestion2 = _interopRequireDefault(_ReportQuestion);
	
	var _Report = __webpack_require__(189);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _common = __webpack_require__(272);
	
	var _services = __webpack_require__(43);
	
	var _FinishPageRightSidebar = __webpack_require__(711);
	
	var _FinishPageRightSidebar2 = _interopRequireDefault(_FinishPageRightSidebar);
	
	var _ShowAnswer = __webpack_require__(722);
	
	var _ShowAnswer2 = _interopRequireDefault(_ShowAnswer);
	
	var _SidebarIndex = __webpack_require__(187);
	
	var _SidebarIndex2 = _interopRequireDefault(_SidebarIndex);
	
	var _Summary = __webpack_require__(723);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTFinishPage = function (_Component) {
	  _inherits(CBTFinishPage, _Component);
	
	  function CBTFinishPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTFinishPage);
	
	    var _this = _possibleConstructorReturn(this, (CBTFinishPage.__proto__ || Object.getPrototypeOf(CBTFinishPage)).call(this, props));
	
	    _this.fetchQuestionByMock = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var response, _this$props, pathname, offset;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _services.mockQuestions)(data);
	
	              case 2:
	                response = _context.sent;
	
	                if (response.success) {
	                  _this.setState({ questionData: response.question, questionIds: response.questionIds });
	                  _this$props = _this.props, pathname = _this$props.location.pathname, offset = _this$props.params.offset;
	
	                  if (pathname.includes(':questionId')) _this.context.router.push({
	                    pathname: pathname.replace(':questionId', response.question[offset].id),
	                    state: {}
	                  });
	                }
	                _this.setState({ isLoading: false });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleCallback = function (childData) {
	      _this.slider = childData.slider;
	    };
	
	    _this.getTitle = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _services.getMockDetailsById)({ mockId: data.mock_id });
	
	              case 2:
	                response = _context2.sent;
	
	                if (response.success) {
	                  _this.setState({ title: response.mockData.mock_exam });
	                }
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchUserRecordByTestId = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var response, _response$userStatsDa, _response$userStatsDa2, questions, _response$userStatsDa3, flagged_questions, questionId, attemptedQuesObjectFromRes;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return (0, _services.getUserStatsByTestId)(data);
	
	              case 2:
	                response = _context3.sent;
	
	                if (response.success) {
	                  _response$userStatsDa = response.userStatsData, _response$userStatsDa2 = _response$userStatsDa.questions, questions = _response$userStatsDa2 === undefined ? {} : _response$userStatsDa2, _response$userStatsDa3 = _response$userStatsDa.flagged_questions, flagged_questions = _response$userStatsDa3 === undefined ? {} : _response$userStatsDa3;
	                  questionId = _this.props.params.questionId;
	                  attemptedQuesObjectFromRes = questions ? JSON.parse(questions) : {};
	
	                  _this.setState({
	                    attemptedQuesObject: attemptedQuesObjectFromRes,
	                    selectedChoice: attemptedQuesObjectFromRes[questionId] || '',
	                    flaggedQuesObject: flagged_questions ? JSON.parse(flagged_questions) : {}
	                  });
	                }
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.getQuestionIDfromOffset = function () {
	      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var questionData = _this.state.questionData;
	
	      var parsedOffset = parseInt(offset, 10);
	      if (isNaN(parsedOffset)) parsedOffset = 0;
	      return questionData[offset].id;
	    };
	
	    _this.setAnswer = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(_ref4) {
	        var _ref6 = _slicedToArray(_ref4, 1),
	            UserAnswer = _ref6[0];
	
	        var attemptedQuesObject, _this$props$params, offset, testId, mockId, questionId;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                attemptedQuesObject = _this.state.attemptedQuesObject;
	                _this$props$params = _this.props.params, offset = _this$props$params.offset, testId = _this$props$params.testId, mockId = _this$props$params.mockId;
	                questionId = _this.getQuestionIDfromOffset(offset);
	
	                attemptedQuesObject[questionId] = UserAnswer;
	                _this.setState({
	                  selectedChoice: UserAnswer,
	                  attemptedQuesObject: attemptedQuesObject
	                });
	                // Calling API to set answer
	                _context4.next = 7;
	                return (0, _services.saveMockUserChoice)({
	                  choice: UserAnswer,
	                  test_id: testId,
	                  mock_id: mockId,
	                  index: offset,
	                  question_id: questionId
	                });
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.strikeText = function (event, _ref7) {
	      var _ref8 = _slicedToArray(_ref7, 1),
	          value = _ref8[0];
	
	      event.preventDefault();
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      _this.setState({ strikeThroughArr: _this.toggleArray(strikeThroughArr, value) });
	    };
	
	    _this.toggleArray = function (array, value) {
	      var choiceIndex = array.findIndex(function (element) {
	        return element === value;
	      });
	      if (choiceIndex === -1) {
	        array.push(value);
	      } else {
	        array.splice(choiceIndex, 1);
	      }
	      return array;
	    };
	
	    _this.onFlagClick = function (offset) {
	      var flaggedQuesObject = _this.state.flaggedQuesObject;
	      var _this$props$params2 = _this.props.params,
	          mockId = _this$props$params2.mockId,
	          testId = _this$props$params2.testId;
	
	      var questionId = _this.getQuestionIDfromOffset(offset);
	      if (flaggedQuesObject[questionId]) {
	        delete flaggedQuesObject[questionId];
	      } else {
	        flaggedQuesObject[questionId] = 'flagged';
	      }
	      (0, _services.flagUnFlagSelectedQuestion)({
	        flaggedQuestions: flaggedQuesObject,
	        testId: testId,
	        mockId: mockId
	      });
	
	      _this.setState({ flaggedQuesObject: flaggedQuesObject });
	    };
	
	    _this.changeQuestionByIndex = function (inputIndex) {
	      var index = inputIndex;
	      if (isNaN(index)) index = 0;
	      var _this$props$params3 = _this.props.params,
	          mockId = _this$props$params3.mockId,
	          testId = _this$props$params3.testId,
	          isNegative = _this$props$params3.isNegative,
	          timerStart = _this$props$params3.timerStart,
	          timer = _this$props$params3.timer;
	      var attemptedQuesObject = _this.state.attemptedQuesObject;
	
	      var questionId = _this.getQuestionIDfromOffset(index);
	
	      _this.slider.slickGoTo(index);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_FINISH_PAGE.replace(':offset', index).replace(':mockId', mockId).replace(':questionId', questionId).replace(':testId', testId).replace(':isNegative', isNegative).replace(':timerStart', timerStart).replace(':timer', timer)
	      });
	
	      _this.setState({ selectedChoice: attemptedQuesObject[questionId] || '' });
	    };
	
	    _this.onClickPreviousButton = function (offset) {
	      _this.changeQuestionByIndex(offset - 1);
	    };
	
	    _this.onClickNextButton = function (offset) {
	      _this.changeQuestionByIndex(offset + 1);
	    };
	
	    _this.navigateToAttemptedMockList = function () {
	      var _this$props$params4 = _this.props.params,
	          mockId = _this$props$params4.mockId,
	          timer = _this$props$params4.timer;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', mockId).replace(':timer', timer),
	        state: {}
	      });
	    };
	
	    _this.getScore = function (score) {
	      _this.setState({ score: score });
	    };
	
	    _this.state = {
	      questionData: [],
	      strikeThroughArr: [],
	      flaggedQuesObject: {},
	      attemptedQuesObject: {},
	      showSectionReview: false,
	      isLoading: true,
	      title: '',
	      showAnswer: true,
	      showReportSection: false,
	      showSummary: false,
	      score: 0
	    };
	    _this.slider = '';
	    return _this;
	  }
	
	  _createClass(CBTFinishPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	      var _props = this.props,
	          chapterId = _props.chapterId,
	          _props$params = _props.params,
	          mockId = _props$params.mockId,
	          testId = _props$params.testId;
	
	      var data = {
	        chapterId: chapterId,
	        mock_id: isNaN(mockId) ? 1 : parseInt(mockId, 10),
	        test_id: isNaN(testId) ? 1 : parseInt(testId, 10)
	      };
	
	      this.fetchQuestionByMock(data);
	      this.fetchUserRecordByTestId(data);
	      this.getTitle(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          questionData = _state.questionData,
	          strikeThroughArr = _state.strikeThroughArr,
	          attemptedQuesObject = _state.attemptedQuesObject,
	          showReportSection = _state.showReportSection,
	          flaggedQuesObject = _state.flaggedQuesObject,
	          isLoading = _state.isLoading,
	          title = _state.title,
	          showAnswer = _state.showAnswer,
	          showSummary = _state.showSummary,
	          score = _state.score,
	          questionIds = _state.questionIds;
	      var _props$params$offset = this.props.params.offset,
	          offset = _props$params$offset === undefined ? 0 : _props$params$offset;
	      var _props$params2 = this.props.params,
	          questionId = _props$params2.questionId,
	          mockId = _props$params2.mockId,
	          testId = _props$params2.testId,
	          timer = _props$params2.timer;
	
	
	      offset = parseInt(offset, 10);
	      if (isNaN(offset)) offset = 0;
	
	      var questionObject = {};
	      try {
	        if (questionData.length) {
	          questionObject = questionData[offset];
	        }
	      } catch (error) {
	        // eslint-disable-next-line no-console
	        console.trace(error);
	      }
	      var totalQuestions = 0;
	
	      if (Array.isArray(questionIds) && questionIds.length > 0) {
	        totalQuestions = questionIds.length;
	      } else if (Array.isArray(questionData) && questionData.length > 0) {
	        totalQuestions = questionData.length;
	      }
	      return _react2.default.createElement(
	        _LoaderWrapper2.default,
	        { isLoading: isLoading },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'animated fadeIn' },
	            _react2.default.createElement(
	              _Header2.default,
	              { title: title },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                { className: 'back-btn', onClick: this.navigateToAttemptedMockList },
	                'Back'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex font-16px' },
	              _react2.default.createElement(_SidebarIndex2.default, {
	                itemArray: questionData,
	                currentIndex: offset,
	                slidesToShow: 10,
	                onClick: this.changeQuestionByIndex,
	                initialSlide: offset,
	                flaggedQuesObject: flaggedQuesObject,
	                attemptedQuesObject: attemptedQuesObject,
	                finishPage: true,
	                parentCallback: this.handleCallback
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper' },
	                _react2.default.createElement(
	                  _CustomCard2.default,
	                  { className: 'w-100' },
	                  _react2.default.createElement(
	                    _CardHeader2.default,
	                    {
	                      headerImage: '/img/question_bank/question_icon_blue.svg',
	                      headingText: 'Q.' + (parseInt(offset, 10) + 1)
	                      // headerClassName='pl-0'
	                    },
	                    _react2.default.createElement(
	                      _CustomButton2.default,
	                      {
	                        onClick: function onClick() {
	                          _this3.setState({ showSummary: true });
	                        }
	                      },
	                      'Summary'
	                    ),
	                    _react2.default.createElement(
	                      _CustomButton2.default,
	                      {
	                        onClick: function onClick() {
	                          _this3.context.router.push({
	                            pathname: _AppRoutes2.default.ESG_CBT_DETAILED_STATS_GRAPH.replace(':id', mockId).replace(':testId', testId).replace(':totalQuestions', questionData.length).replace(':totalMarks', questionData.length).replace(':timer', timer)
	                          });
	                        },
	                        disabled: !Boolean(+score)
	                      },
	                      'Detailed Score'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _CardBody2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 9, xs: 12 },
	                        questionData.length && _react2.default.createElement(_Question2.default, Object.assign({}, questionObject, {
	                          setAnswer: this.setAnswer,
	                          selectedChoiceClassName: 'border-yellow',
	                          correctChoiceClassName: _common.cbtColor.correct.className,
	                          incorrectChoiceClassName: _common.cbtColor.incorrect.className,
	                          strikeText: this.strikeText,
	                          strikeThroughArr: strikeThroughArr,
	                          showAnswer: showAnswer,
	                          selectedChoice: attemptedQuesObject[questionObject.id],
	                          correctChoice: questionObject.correct_choice
	                        }))
	                      ),
	                      _react2.default.createElement(_FinishPageRightSidebar2.default, Object.assign({
	                        className: 'mt-2 col-sm-4 col-lg-3'
	                      }, this.props, {
	                        totalQuestions: totalQuestions,
	                        getScore: this.getScore
	                      })),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 12, xs: 12, className: 'text-right mt-2' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'd-flex justify-content-end' },
	                          _react2.default.createElement(_ReportQuestion2.default, {
	                            className: 'mr-1',
	                            onClick: function onClick() {
	                              return _this3.setState({ showReportSection: true });
	                            }
	                          }),
	                          _react2.default.createElement(
	                            _CustomButton2.default,
	                            {
	                              className: 'mid-btn',
	                              onClick: function onClick() {
	                                return _this3.onClickPreviousButton(parseInt(offset, 10));
	                              },
	                              disabled: parseInt(offset, 10) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Back'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _CustomButton2.default,
	                            {
	                              className: 'mid-btn',
	                              onClick: function onClick() {
	                                return _this3.onClickNextButton(parseInt(offset, 10));
	                              },
	                              disabled: parseInt(offset, 10) === questionData.length - 1
	                            },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Next'
	                            ),
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            showAnswer && _react2.default.createElement(_ShowAnswer2.default, Object.assign({}, questionObject, { attemptedQuesObject: attemptedQuesObject })),
	            showReportSection && _react2.default.createElement(_Report2.default, {
	              hideReportSection: function hideReportSection() {
	                _this3.setState({ showReportSection: false });
	              },
	              section: 'CBT',
	              mockData: { mock_id: mockId, timer: timer, testId: testId },
	              commentOnWhichId: questionId
	            }),
	            showSummary && _react2.default.createElement(_Summary2.default, {
	              onClose: function onClose() {
	                return _this3.setState({ showSummary: false });
	              },
	              mockId: mockId,
	              testId: testId
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CBTFinishPage;
	}(_react.Component);
	
	CBTFinishPage.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = CBTFinishPage;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CardBody = __webpack_require__(118);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _CardHeader = __webpack_require__(119);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _Question = __webpack_require__(270);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _ReverseTimer = __webpack_require__(748);
	
	var _ReverseTimer2 = _interopRequireDefault(_ReverseTimer);
	
	var _services = __webpack_require__(43);
	
	var _Flagged = __webpack_require__(712);
	
	var _Flagged2 = _interopRequireDefault(_Flagged);
	
	var _ReviewSectionButton = __webpack_require__(720);
	
	var _ReviewSectionButton2 = _interopRequireDefault(_ReviewSectionButton);
	
	var _SectionReview = __webpack_require__(721);
	
	var _SectionReview2 = _interopRequireDefault(_SectionReview);
	
	var _SidebarIndex = __webpack_require__(187);
	
	var _SidebarIndex2 = _interopRequireDefault(_SidebarIndex);
	
	var _CBTFinishTest = __webpack_require__(65);
	
	var _CBTFinishTest2 = _interopRequireDefault(_CBTFinishTest);
	
	var _CBTFlagged = __webpack_require__(66);
	
	var _CBTFlagged2 = _interopRequireDefault(_CBTFlagged);
	
	var _CBTNonAttempted = __webpack_require__(67);
	
	var _CBTNonAttempted2 = _interopRequireDefault(_CBTNonAttempted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CBTQuestion = function (_Component) {
	  _inherits(CBTQuestion, _Component);
	
	  function CBTQuestion(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CBTQuestion);
	
	    var _this = _possibleConstructorReturn(this, (CBTQuestion.__proto__ || Object.getPrototypeOf(CBTQuestion)).call(this, props));
	
	    _this.fetchQuestionByMock = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var response, _this$props, pathname, offset;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _services.mockQuestions)(data);
	
	              case 2:
	                response = _context.sent;
	
	                if (response.success) {
	                  _this.setState({ questionData: response.question });
	                  _this$props = _this.props, pathname = _this$props.location.pathname, offset = _this$props.params.offset;
	
	                  if (pathname.includes(':questionId')) _this.context.router.replace({
	                    pathname: pathname.replace(':questionId', response.question[offset].id),
	                    state: {}
	                  });
	
	                  _this.strikeThroughChoices(response.question[offset].id);
	                }
	                _this.setState({ isLoading: false });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.strikeThroughChoices = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(questionId) {
	        var _this$props$params, testId, mockId, result, strikeThroughArr, choiceArray;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props$params = _this.props.params, testId = _this$props$params.testId, mockId = _this$props$params.mockId;
	                _context2.next = 3;
	                return (0, _services.getStrikedText)({
	                  questionId: questionId,
	                  testId: testId,
	                  mockId: mockId
	                });
	
	              case 3:
	                result = _context2.sent;
	                strikeThroughArr = [];
	
	                if (result.success) {
	                  choiceArray = result.data.choiceArray;
	
	                  if (choiceArray) {
	                    strikeThroughArr = JSON.parse(choiceArray);
	                  }
	                }
	                _this.setState({ strikeThroughArr: strikeThroughArr });
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getTitle = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return (0, _services.getMockDetailsById)({ mockId: data.mock_id });
	
	              case 2:
	                response = _context3.sent;
	
	                if (response.success) {
	                  _this.setState({ title: response.mockData.mock_exam });
	                }
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchUserRecordByTestId = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	        var response, _response$userStatsDa, _response$userStatsDa2, questions, _response$userStatsDa3, flagged_questions, userTimeValue, questionId, attemptedQuesObjectFromRes;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.prev = 0;
	                _context4.next = 3;
	                return (0, _services.getUserStatsByTestId)(data);
	
	              case 3:
	                response = _context4.sent;
	
	                if (response.success) {
	                  _response$userStatsDa = response.userStatsData, _response$userStatsDa2 = _response$userStatsDa.questions, questions = _response$userStatsDa2 === undefined ? {} : _response$userStatsDa2, _response$userStatsDa3 = _response$userStatsDa.flagged_questions, flagged_questions = _response$userStatsDa3 === undefined ? {} : _response$userStatsDa3, userTimeValue = _response$userStatsDa.user_time_value;
	                  questionId = _this.props.params.questionId;
	                  attemptedQuesObjectFromRes = questions ? JSON.parse(questions) : {};
	
	                  if (parseInt(userTimeValue, 10) !== 0) {
	                    _this.setState({
	                      userTimeValue: userTimeValue,
	                      attemptedQuesObject: attemptedQuesObjectFromRes,
	                      selectedChoice: attemptedQuesObjectFromRes[questionId] || '',
	                      flaggedQuesObject: flagged_questions ? JSON.parse(flagged_questions) : {}
	                    });
	                  }
	                }
	                _context4.next = 10;
	                break;
	
	              case 7:
	                _context4.prev = 7;
	                _context4.t0 = _context4['catch'](0);
	
	                // eslint-disable-next-line no-console
	                console.trace(_context4.t0);
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2, [[0, 7]]);
	      }));
	
	      return function (_x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.getQuestionIDfromOffset = function () {
	      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var questionData = _this.state.questionData;
	
	      var parsedOffset = parseInt(offset, 10);
	      if (isNaN(parsedOffset)) parsedOffset = 0;
	      return questionData[offset].id;
	    };
	
	    _this.getQuestionDetailsfromOffset = function () {
	      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var questionData = _this.state.questionData;
	
	      var parsedOffset = parseInt(offset, 10);
	      if (isNaN(parsedOffset)) parsedOffset = 0;
	      return questionData[offset];
	    };
	
	    _this.setAnswer = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(answer) {
	        var attemptedQuesObject, _this$props$params2, offset, testId, mockId, questionDetails, _answer, userAnser;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                attemptedQuesObject = _this.state.attemptedQuesObject;
	                _this$props$params2 = _this.props.params, offset = _this$props$params2.offset, testId = _this$props$params2.testId, mockId = _this$props$params2.mockId;
	                questionDetails = _this.getQuestionDetailsfromOffset(offset) || {};
	                _answer = _slicedToArray(answer, 1), userAnser = _answer[0];
	
	                attemptedQuesObject[questionDetails.id] = userAnser;
	
	                _this.setState({
	                  selectedChoice: answer[0],
	                  attemptedQuesObject: attemptedQuesObject
	                });
	                // Calling API to set answer
	                _context5.next = 8;
	                return (0, _services.saveMockUserChoice)({
	                  choice: answer[0],
	                  test_id: testId,
	                  mock_id: mockId,
	                  index: offset,
	                  question_id: questionDetails.id
	                });
	
	              case 8:
	                // Insert data into Database
	                (0, _services.setUserChoice)({
	                  mock_id: mockId,
	                  question_id: questionDetails.id,
	                  test_id: testId,
	                  chapter_id: questionDetails.chapter_id,
	                  answer: questionDetails.correct_choice === answer[0] ? 'correct' : 'incorrect'
	                });
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.strikeText = function (event, value) {
	      event.preventDefault();
	
	      var _value = _slicedToArray(value, 1),
	          choice = _value[0];
	
	      var strikeThroughArr = _this.state.strikeThroughArr;
	
	      _this.setState({ strikeThroughArr: _this.toggleArray(strikeThroughArr, choice) });
	      var _this$props$params3 = _this.props.params,
	          questionId = _this$props$params3.questionId,
	          testId = _this$props$params3.testId,
	          mockId = _this$props$params3.mockId;
	
	
	      (0, _services.addStrikeThrough)({
	        mockId: mockId,
	        questionId: questionId,
	        testId: testId,
	        choice: choice
	      });
	    };
	
	    _this.toggleArray = function (array, value) {
	      var choiceIndex = array.findIndex(function (element) {
	        return element === value;
	      });
	      if (choiceIndex === -1) {
	        array.push(value);
	      } else {
	        array.splice(choiceIndex, 1);
	      }
	      return array;
	    };
	
	    _this.onFlagClick = function (offset) {
	      var flaggedQuesObject = _this.state.flaggedQuesObject;
	      var _this$props$params4 = _this.props.params,
	          mockId = _this$props$params4.mockId,
	          testId = _this$props$params4.testId;
	
	      var questionId = _this.getQuestionIDfromOffset(offset);
	      if (flaggedQuesObject[questionId]) {
	        delete flaggedQuesObject[questionId];
	      } else {
	        flaggedQuesObject[questionId] = 'flagged';
	      }
	      (0, _services.flagUnFlagSelectedQuestion)({
	        flaggedQuestions: flaggedQuesObject,
	        testId: testId,
	        mockId: mockId
	      });
	
	      _this.setState({ flaggedQuesObject: flaggedQuesObject });
	    };
	
	    _this.changeQuestionByIndex = function (inputIndex) {
	      var index = inputIndex;
	      if (isNaN(index)) index = 0;
	      var _this$props$params5 = _this.props.params,
	          mockId = _this$props$params5.mockId,
	          testId = _this$props$params5.testId,
	          isNegative = _this$props$params5.isNegative,
	          timerStart = _this$props$params5.timerStart,
	          timer = _this$props$params5.timer;
	      var attemptedQuesObject = _this.state.attemptedQuesObject;
	
	      var questionId = _this.getQuestionIDfromOffset(index);
	
	      _this.slider.slickGoTo(index);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_QUESTIONS.replace(':offset', index).replace(':mockId', mockId).replace(':questionId', questionId).replace(':testId', testId).replace(':isNegative', isNegative).replace(':timerStart', timerStart).replace(':timer', timer)
	      });
	      _this.strikeThroughChoices(questionId);
	
	      _this.setState({ selectedChoice: attemptedQuesObject[questionId] || '' });
	    };
	
	    _this.onClickPreviousButton = function (offset) {
	      _this.changeQuestionByIndex(offset - 1);
	    };
	
	    _this.onClickNextButton = function (offset) {
	      _this.changeQuestionByIndex(offset + 1);
	    };
	
	    _this.checkFlaggedQuestion = function () {
	      var flaggedQuesObject = _this.state.flaggedQuesObject;
	
	      if (Object.keys(flaggedQuesObject).length) {
	        _this.setState({ showFlaggedPopup: true });
	        return;
	      }
	      _this.checkAllQuestionAttempted();
	    };
	
	    _this.checkAllQuestionAttempted = function () {
	      var _this$state = _this.state,
	          attemptedQuesObject = _this$state.attemptedQuesObject,
	          questionData = _this$state.questionData;
	
	      var attemptedQuesLength = Object.keys(attemptedQuesObject).length;
	
	      if (!attemptedQuesLength || attemptedQuesLength !== questionData.length) {
	        _this.setState({ showNonAttemptedPopup: true });
	        return;
	      }
	      _this.setState({ showFinishTestPopup: true });
	    };
	
	    _this.navigateToFinishPage = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var _this$props$params6, mockId, testId, offset, timer, questionId;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _this$props$params6 = _this.props.params, mockId = _this$props$params6.mockId, testId = _this$props$params6.testId, offset = _this$props$params6.offset, timer = _this$props$params6.timer;
	              questionId = _this.getQuestionIDfromOffset(offset);
	              _context6.prev = 2;
	              _context6.next = 5;
	              return Promise.all([(0, _services.setTestStatusByTestId)({
	                id: testId,
	                mock_id: mockId
	              }), (0, _services.setCBTScore)({
	                testId: testId,
	                mockId: mockId
	              })]);
	
	            case 5:
	              _context6.next = 10;
	              break;
	
	            case 7:
	              _context6.prev = 7;
	              _context6.t0 = _context6['catch'](2);
	
	              // Handle errors for both operations
	              _context6.t0.forEach(function (error) {
	                // eslint-disable-next-line no-console
	                console.trace(error);
	              });
	
	            case 10:
	
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.ESG_CBT_FINISH_PAGE.replace(':offset', offset).replace(':mockId', mockId).replace(':questionId', questionId).replace(':timer', timer).replace(':testId', testId)
	              });
	
	            case 11:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2, [[2, 7]]);
	    }));
	
	    _this.handleCallback = function (childData) {
	      _this.slider = childData.slider;
	    };
	
	    _this.onStopTimer = function () {
	      _this.setTimerParam(false);
	    };
	
	    _this.onStartTimer = function () {
	      _this.setTimerParam(true);
	    };
	
	    _this.setTimerParam = function (timerStart) {
	      var _this$props$params7 = _this.props.params,
	          mockId = _this$props$params7.mockId,
	          testId = _this$props$params7.testId,
	          questionId = _this$props$params7.questionId,
	          isNegative = _this$props$params7.isNegative,
	          timer = _this$props$params7.timer,
	          offset = _this$props$params7.offset;
	
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_QUESTIONS.replace(':offset', offset).replace(':mockId', mockId).replace(':questionId', questionId).replace(':testId', testId).replace(':isNegative', isNegative).replace(':timerStart', timerStart).replace(':timer', timer)
	      });
	    };
	
	    _this.state = {
	      questionData: [],
	      strikeThroughArr: [],
	      flaggedQuesObject: {},
	      attemptedQuesObject: {},
	      showSectionReview: false,
	      isLoading: true,
	      title: '',
	      userTimeValue: props.params.timer,
	      showFinishTestPopup: false,
	      showNonAttemptedPopup: false,
	      showFlaggedPopup: false,
	      showPopover: false
	    };
	    _this.slider = '';
	    return _this;
	  }
	
	  _createClass(CBTQuestion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var _props = this.props,
	          chapterId = _props.chapterId,
	          _props$params = _props.params,
	          mockId = _props$params.mockId,
	          testId = _props$params.testId;
	
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        chapterId: chapterId,
	        mock_id: isNaN(mockId) ? 1 : parseInt(mockId, 10),
	        test_id: isNaN(testId) ? 1 : parseInt(testId, 10)
	      };
	
	      this.fetchQuestionByMock(data);
	      this.fetchUserRecordByTestId(data);
	      this.getTitle(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          questionData = _state.questionData,
	          selectedChoice = _state.selectedChoice,
	          strikeThroughArr = _state.strikeThroughArr,
	          attemptedQuesObject = _state.attemptedQuesObject,
	          showSectionReview = _state.showSectionReview,
	          flaggedQuesObject = _state.flaggedQuesObject,
	          isLoading = _state.isLoading,
	          title = _state.title,
	          userTimeValue = _state.userTimeValue,
	          showFinishTestPopup = _state.showFinishTestPopup,
	          showNonAttemptedPopup = _state.showNonAttemptedPopup,
	          showFlaggedPopup = _state.showFlaggedPopup;
	      var _props$params$offset = this.props.params.offset,
	          offset = _props$params$offset === undefined ? 0 : _props$params$offset;
	      var _props$params2 = this.props.params,
	          mockId = _props$params2.mockId,
	          testId = _props$params2.testId,
	          timer = _props$params2.timer,
	          isNegative = _props$params2.isNegative,
	          timerStart = _props$params2.timerStart;
	
	      offset = parseInt(offset, 10);
	      if (isNaN(offset)) offset = 0;
	
	      var questionObject = {};
	      try {
	        if (questionData.length) {
	          questionObject = questionData[offset];
	        }
	      } catch (error) {
	        // eslint-disable-next-line no-console
	        console.error(error);
	      }
	      return _react2.default.createElement(
	        _LoaderWrapper2.default,
	        { isLoading: isLoading },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'animated fadeIn' },
	            _react2.default.createElement(
	              _Header2.default,
	              { title: title },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                { onClick: this.checkFlaggedQuestion },
	                'Finish Test'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex font-16px' },
	              _react2.default.createElement(_SidebarIndex2.default, {
	                itemArray: questionData,
	                currentIndex: offset,
	                slidesToShow: 10,
	                onClick: this.changeQuestionByIndex,
	                initialSlide: offset,
	                flaggedQuesObject: flaggedQuesObject,
	                attemptedQuesObject: attemptedQuesObject,
	                parentCallback: this.handleCallback
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'ques-detail-wrapper' },
	                _react2.default.createElement(
	                  _CustomCard2.default,
	                  { className: 'w-100' },
	                  _react2.default.createElement(_CardHeader2.default, {
	                    headerImage: '/img/question_bank/question_icon_blue.svg',
	                    headingText: 'Q.' + (parseInt(offset, 10) + 1)
	                    // headerClassName='pl-0'
	                  }),
	                  _react2.default.createElement(
	                    _CardBody2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Row,
	                      null,
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 9, xs: 12 },
	                        questionData.length && _react2.default.createElement(_Question2.default, Object.assign({}, questionObject, {
	                          setAnswer: this.setAnswer,
	                          selectedChoice: selectedChoice,
	                          selectedChoiceClassName: 'border-yellow',
	                          strikeText: this.strikeText,
	                          strikeThroughArr: strikeThroughArr,
	                          params: this.props.params,
	                          shouldHighLight: true
	                        }))
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 3, xs: 12 },
	                        _react2.default.createElement(_ReverseTimer2.default, {
	                          intialTimerValue: userTimeValue,
	                          apiCall: function apiCall(data) {
	                            return (0, _services.updateUserTimer)(Object.assign({
	                              mock_id: mockId,
	                              isNegative: isNegative,
	                              testId: testId,
	                              timer: timer,
	                              id: testId
	                            }, data));
	                          },
	                          stopTimerOnMount: timerStart === 'false',
	                          onStopTimer: function onStopTimer() {
	                            return _this3.setTimerParam(false);
	                          },
	                          onStartTimer: function onStartTimer() {
	                            return _this3.setTimerParam(true);
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 3, xs: 12, className: 'mt-2' },
	                        _react2.default.createElement(_ReviewSectionButton2.default, {
	                          onClick: function onClick() {
	                            _this3.setState({ showSectionReview: true });
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 9, xs: 12, className: 'text-right mt-2' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'd-flex justify-content-end' },
	                          _react2.default.createElement(_Flagged2.default, {
	                            className: 'mr-1',
	                            flaggedQuestion: questionData.length && flaggedQuesObject[questionData[offset].id],
	                            onClick: function onClick() {
	                              return _this3.onFlagClick(offset);
	                            }
	                          }),
	                          _react2.default.createElement(
	                            _CustomButton2.default,
	                            {
	                              className: 'mid-btn',
	                              onClick: function onClick() {
	                                return _this3.onClickPreviousButton(parseInt(offset, 10));
	                              },
	                              disabled: parseInt(offset, 10) === 0
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                            ' ',
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Back'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _CustomButton2.default,
	                            {
	                              className: 'mid-btn',
	                              onClick: function onClick() {
	                                return _this3.onClickNextButton(parseInt(offset, 10));
	                              },
	                              disabled: parseInt(offset, 10) === questionData.length - 1
	                            },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Next'
	                            ),
	                            ' ',
	                            _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_SectionReview2.default, {
	            dataList: questionData,
	            attemptedQuesObject: attemptedQuesObject,
	            showSectionReview: showSectionReview,
	            flaggedQuesObject: flaggedQuesObject,
	            changeQuestion: this.changeQuestionByIndex,
	            onClick: function onClick() {
	              _this3.setState({ showSectionReview: false });
	            }
	          }),
	          _react2.default.createElement(_CBTFinishTest2.default, {
	            showFinishTestPopup: showFinishTestPopup,
	            submitTest: this.navigateToFinishPage,
	            handleClose: function handleClose() {
	              return _this3.setState({ showFinishTestPopup: false });
	            }
	          }),
	          _react2.default.createElement(_CBTNonAttempted2.default, {
	            showFinishTestPopup: showNonAttemptedPopup,
	            submitTest: function submitTest() {
	              return _this3.setState({
	                showFinishTestPopup: true,
	                showNonAttemptedPopup: false
	              });
	            },
	            handleClose: function handleClose() {
	              return _this3.setState({ showNonAttemptedPopup: false });
	            }
	          }),
	          _react2.default.createElement(_CBTFlagged2.default, {
	            showFinishTestPopup: showFlaggedPopup,
	            submitTest: function submitTest() {
	              _this3.setState({ showFlaggedPopup: false });
	              _this3.checkAllQuestionAttempted();
	            },
	            handleClose: function handleClose() {
	              return _this3.setState({ showFlaggedPopup: false });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return CBTQuestion;
	}(_react.Component);
	
	CBTQuestion.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = CBTQuestion;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CBTTestTimeTaken(props) {
	  var userStatsData = props.userStatsData,
	      timer = props.params.timer,
	      userTime = props.userTime;
	
	
	  if (userStatsData && userTime && timer) {
	    userTime = (0, _constant.SecondsToHHMMSS)(userStatsData.isNegative === 'true' ? parseInt(timer, 10) + userTime : timer - userTime);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'timer_outer finished-time' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        _language2.default.LC().TEST_COMPLETED_IN
	      ),
	      _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'timer_box' },
	        userTime
	      )
	    )
	  );
	}
	
	exports.default = CBTTestTimeTaken;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CBTTotalScore(props) {
	  var rightAnswerCount = props.rightAnswerCount,
	      outOfScore = props.totalQuestions;
	
	  var percentage = rightAnswerCount * 100 / outOfScore;
	  return _react2.default.createElement(
	    'div',
	    { className: 'score-wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'score-inner' },
	      rightAnswerCount ? rightAnswerCount : 0,
	      '/',
	      outOfScore
	    ),
	    _react2.default.createElement(
	      'h5',
	      null,
	      _language2.default.LC().TOTAL_SCORE
	    ),
	    _react2.default.createElement(
	      'h5',
	      null,
	      _language2.default.LC().You_Scored,
	      ' ',
	      Math.ceil(percentage),
	      '%'
	    )
	  );
	}
	
	exports.default = CBTTotalScore;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DynamicTable(_ref) {
	  var data = _ref.data,
	      columns = _ref.columns,
	      actionList = _ref.actionList,
	      additionalParameterForOperation = _ref.additionalParameterForOperation;
	
	  var getOperationValue = function getOperationValue(item, column) {
	    var operation = column.operation;
	
	    if (!operation) return item[column.key];
	
	    var condition = item[operation.field];
	    return condition ? operation.true(item, additionalParameterForOperation) : operation.false(item, additionalParameterForOperation);
	  };
	
	  var getRepresentationValue = function getRepresentationValue(item, column) {
	    var result = column.operation ? getOperationValue(item, column) : item[column.referredField || column.key];
	
	    if (typeof column.representation === 'function') {
	      return column.representation(result, additionalParameterForOperation);
	    }
	    return result;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'table-responsive' },
	    _react2.default.createElement(
	      'table',
	      { className: 'table_white_bg table table-remove-space center_table' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'border_top_0' },
	          columns.map(function (column, index) {
	            return _react2.default.createElement(
	              'th',
	              { key: index, width: column.width },
	              column.label
	            );
	          }),
	          actionList && _react2.default.createElement(
	            'th',
	            { className: 'text-center' },
	            'Action'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        data.length ? data.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            columns.map(function (column, columnIndex) {
	              return _react2.default.createElement(
	                'td',
	                { key: columnIndex, className: column['className'] || '' },
	                column['condition'] ? _react2.default.createElement(
	                  'span',
	                  {
	                    className: column['condition'][item[column.referredField || column.key]].className
	                  },
	                  column['condition'][item[column.referredField || column.key]].label
	                ) : column['representation'] ? getRepresentationValue(item, column) : item[column.referredField || column.key]
	              );
	            }),
	            actionList && _react2.default.createElement(
	              'td',
	              { className: 'text-center' },
	              actionList.map(function (action, index) {
	                var label = action.label,
	                    actionFunction = action.action,
	                    icon = action.icon,
	                    _action$className = action.className,
	                    className = _action$className === undefined ? '' : _action$className,
	                    condition = action.condition,
	                    style = action.style;
	
	
	                if (condition && condition[Object.keys(condition)[0]] !== item[Object.keys(condition)[0]]) {
	                  return null; // Skip rendering if condition doesn't match
	                }
	
	                return _react2.default.createElement(
	                  'span',
	                  {
	                    key: index,
	                    onClick: function onClick(event) {
	                      return actionFunction(event, item);
	                    },
	                    className: 'up tooltip-hover-questions'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    label
	                  ),
	                  _react2.default.createElement('i', { className: icon + ' ' + className, style: style })
	                );
	              })
	            )
	          );
	        }) : _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { colSpan: columns.length + (actionList ? 1 : 0), className: 'text-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'no-qus-found no-mock-exam' },
	              _react2.default.createElement('img', {
	                width: '82px',
	                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png'
	              }),
	              _react2.default.createElement(
	                'h3',
	                { className: 'mt-1' },
	                _language2.default.LC().NO_MOCK_EXAM_FOUND
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = DynamicTable;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _services = __webpack_require__(43);
	
	var _CBTTestTimeTaken = __webpack_require__(708);
	
	var _CBTTestTimeTaken2 = _interopRequireDefault(_CBTTestTimeTaken);
	
	var _CBTTotalScore = __webpack_require__(709);
	
	var _CBTTotalScore2 = _interopRequireDefault(_CBTTotalScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinishPageRightSidebar = function (_Component) {
	  _inherits(FinishPageRightSidebar, _Component);
	
	  function FinishPageRightSidebar(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FinishPageRightSidebar);
	
	    var _this = _possibleConstructorReturn(this, (FinishPageRightSidebar.__proto__ || Object.getPrototypeOf(FinishPageRightSidebar)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props$params, testId, mockId, data;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props$params = _this.props.params, testId = _this$props$params.testId, mockId = _this$props$params.mockId;
	              data = {
	                test_id: testId,
	                mock_id: mockId
	              };
	
	
	              _this.getUserStats(data);
	              _this.getCBTAnsweredCount(data);
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getUserStats = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var result, userStatsData;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _services.getUserStatsByTestId)(data);
	
	              case 2:
	                result = _context2.sent;
	
	
	                if (result.success) {
	                  userStatsData = result.userStatsData;
	
	                  _this.setState({
	                    userTime: userStatsData.user_time_value,
	                    userStatsData: userStatsData
	                    // score: userStatsData.score,
	                  });
	                }
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getCBTAnsweredCount = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var result, totalScore;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return (0, _services.getCBTScore)(data);
	
	              case 2:
	                result = _context3.sent;
	
	                if (result.success) {
	                  totalScore = result.totalScore;
	
	                  _this.setState({ score: totalScore });
	                  _this.props.getScore(totalScore || 0);
	                }
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      userTime: 0,
	      userStatsData: {},
	      score: 0
	    };
	    return _this;
	  }
	
	  _createClass(FinishPageRightSidebar, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      var _state = this.state,
	          userTime = _state.userTime,
	          userStatsData = _state.userStatsData,
	          score = _state.score;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(_CBTTotalScore2.default, Object.assign({}, this.props, { userStatsData: userStatsData, rightAnswerCount: score })),
	        _react2.default.createElement(_CBTTestTimeTaken2.default, Object.assign({}, this.props, { userTime: userTime, userStatsData: userStatsData }))
	      );
	    }
	  }]);
	
	  return FinishPageRightSidebar;
	}(_react.Component);
	
	exports.default = FinishPageRightSidebar;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Flagged(_ref) {
	  var flaggedQuestion = _ref.flaggedQuestion,
	      className = _ref.className,
	      onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'span',
	    {
	      className: 'up tooltip-hover-questions quiz-flag ' + (className || ''),
	      onClick: onClick
	    },
	    flaggedQuestion ? _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      _language2.default.LC().UNFLAG_THIS_QUESTION
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      _language2.default.LC().FLAG_THIS_QUESTION
	    ),
	    _react2.default.createElement(
	      'i',
	      {
	        className: flaggedQuestion ? 'fa fa-flag mark-action-btn' : 'fa fa-flag-o mark-action-btn'
	      },
	      ' '
	    )
	  );
	}
	
	exports.default = Flagged;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SidebarIndex = __webpack_require__(187);
	
	var _SidebarIndex2 = _interopRequireDefault(_SidebarIndex);
	
	var _instructions = __webpack_require__(726);
	
	var _instructions2 = _interopRequireDefault(_instructions);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CardHeader = __webpack_require__(119);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardBody = __webpack_require__(118);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _services = __webpack_require__(43);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Instructions = function (_Component) {
	  _inherits(Instructions, _Component);
	
	  function Instructions() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Instructions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Instructions.__proto__ || Object.getPrototypeOf(Instructions)).call.apply(_ref, [this].concat(args))), _this), _this.startTest = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props$params, id, timer, result;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props$params = _this.props.params, id = _this$props$params.id, timer = _this$props$params.timer;
	              _context.next = 3;
	              return (0, _services.generateTestId)(Object.assign({}, (0, _services.getTokenAndEmail)(), {
	                mock_id: id ? parseInt(id, 10) : null,
	                status: 'pending'
	              }));
	
	            case 3:
	              result = _context.sent;
	
	
	              if (result.success) {
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.ESG_CBT_QUESTIONS.replace(':mockId', id).replace(':timer', timer).replace(':timerStart', true).replace(':isNegative', false).replace(':offset', 0).replace(':testId', result.id)
	                });
	              }
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), _this.changePageByIndex = function (index) {
	      if (isNaN(index)) index = 0;
	      var _this$props$params2 = _this.props.params,
	          timer = _this$props$params2.timer,
	          id = _this$props$params2.id;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_INTRODUCTION.replace(':id', id).replace(':timer', timer).replace(':offset', index)
	      });
	    }, _this.onClickPreviousButton = function (offset) {
	      _this.changePageByIndex(offset - 1);
	    }, _this.onClickNextButton = function (offset) {
	      _this.changePageByIndex(parseInt(offset, 10) + 1);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Instructions, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var offset = this.props.params.offset;
	
	      try {
	        var _IntroductionItems$of = _instructions2.default[offset],
	            title = _IntroductionItems$of.title,
	            content = _IntroductionItems$of.content,
	            buttonText = _IntroductionItems$of.buttonText;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_Header2.default, { title: 'Section Introduction' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex font-16px' },
	            _react2.default.createElement(_SidebarIndex2.default, {
	              itemArray: _instructions2.default,
	              currentIndex: offset,
	              onClick: function onClick(index) {
	                return _this3.changePageByIndex(index);
	              },
	              sliderSetting: { arrows: false }
	            }),
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'w-100' },
	              _react2.default.createElement(_CardHeader2.default, { headingText: title }),
	              _react2.default.createElement(
	                _CardBody2.default,
	                null,
	                content.map(function (item) {
	                  return item.image ? _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement('img', { src: item.image, alt: item.image })
	                  ) : (0, _function.renderHTMLContent)(item.html, 'div', 'font-16px');
	                }),
	                buttonText && _react2.default.createElement(
	                  'h6',
	                  { className: 'mt-3' },
	                  buttonText
	                )
	              ),
	              _react2.default.createElement(
	                _CardBody2.default,
	                { className: 'text-right btm-btn-wrapper' },
	                _react2.default.createElement(
	                  _CustomButton2.default,
	                  {
	                    onClick: function onClick() {
	                      return _this3.onClickPreviousButton(offset);
	                    },
	                    disabled: 0 === parseInt(offset, 10)
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Back'
	                  )
	                ),
	                _react2.default.createElement(
	                  _CustomButton2.default,
	                  {
	                    onClick: function onClick() {
	                      return _this3.onClickNextButton(offset);
	                    },
	                    disabled: _instructions2.default.length - 1 === parseInt(offset, 10)
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Next'
	                  ),
	                  ' ',
	                  _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	                ),
	                _react2.default.createElement(
	                  _CustomButton2.default,
	                  { onClick: this.startTest },
	                  'Start Test'
	                )
	              )
	            )
	          )
	        );
	      } catch (error) {
	        console.trace(error);
	        return _react2.default.createElement(
	          'div',
	          null,
	          error.message,
	          ' '
	        );
	      }
	    }
	  }]);
	
	  return Instructions;
	}(_react.Component);
	
	Instructions.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Instructions;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _services = __webpack_require__(43);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrintButton(_ref) {
	  var mockListLength = _ref.mockListLength,
	      item = _ref.item,
	      index = _ref.index,
	      dropdownOpen = _ref.dropdownOpen,
	      dropdownOpenIndex = _ref.dropdownOpenIndex,
	      _toggle = _ref.toggle;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'privetinfo-dropdown' },
	    _react2.default.createElement(
	      _reactstrap.ButtonDropdown,
	      {
	        className: index + 1 === mockListLength ? 'dropup' : '',
	        isOpen: dropdownOpenIndex === index ? dropdownOpen : false,
	        toggle: function toggle() {
	          return _toggle(index);
	        }
	      },
	      _react2.default.createElement(
	        _reactstrap.DropdownToggle,
	        {
	          className: 'btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20',
	          caret: true
	        },
	        _language2.default.LC().PRINT
	      ),
	      _react2.default.createElement(
	        _reactstrap.DropdownMenu,
	        { right: true },
	        _react2.default.createElement(
	          _reactstrap.DropdownItem,
	          {
	            value: 'public',
	            onClick: function onClick() {
	              (0, _services.viewPDF)({ mock_id: item.id, type: 'question' }).then(function (resp) {
	                var myWindow = window.open(resp.pdf);
	                myWindow.focus();
	              });
	            }
	          },
	          _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	          _language2.default.LC().PRINT_Q_MOCK
	        ),
	        _react2.default.createElement(
	          _reactstrap.DropdownItem,
	          {
	            value: 'private',
	            onClick: function onClick() {
	              (0, _services.viewPDF)({ mock_id: item.id, type: 'questionAnswer' }).then(function (resp) {
	                var myWindow = window.open(resp.pdf);
	                myWindow.focus();
	              });
	            }
	          },
	          _react2.default.createElement('i', { className: 'fa fa-print color-black', 'aria-hidden': 'true' }),
	          _language2.default.LC().PRINT_QA_MOCK
	        )
	      )
	    )
	  );
	}
	
	exports.default = PrintButton;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChapterWiseGraph(_ref) {
	  var graphData = _ref.graphData,
	      activeTabFlashcards = _ref.activeTabFlashcards,
	      flashcardTabToggle = _ref.flashcardTabToggle;
	
	  return _react2.default.createElement(
	    'div',
	    { className: ' chart-graph-wrapper' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'overAllScore' },
	      '' + _language2.default.LC().CFACHAPTERWISERESULT
	    ),
	    _react2.default.createElement('div', { id: 'chartContainer', className: 'js-chart-wrap' }),
	    _react2.default.createElement(
	      'ul',
	      { className: 'legend-wrapper' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'square-box' }),
	        ' ',
	        _language2.default.LC().SCOREBOX
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'line-dash' }),
	        ' ',
	        _language2.default.LC().Percentile_20
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'line-dots' }),
	        ' ',
	        _language2.default.LC().Percentile_80
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('span', { className: 'line-normal' }),
	        _language2.default.LC().YOURSCORE
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      { className: 'mt-5' },
	      'Mean Score by Topic Area'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'd-flex header-card-dashboard tab-header-wrap mt-2' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'dashboard-card-header-tab' },
	        graphData ? graphData.map(function (exam, index) {
	          return _react2.default.createElement(
	            'li',
	            {
	              onClick: function onClick() {
	                flashcardTabToggle(index + 1);
	              },
	              className: activeTabFlashcards === index + 1 ? 'active' : ''
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              exam.chapterDetails['esg_chapter.name'] && exam.chapterDetails['esg_chapter.name'].length > 8 ? exam.chapterDetails['esg_chapter.name'].substring(0, 8) + '..' : exam.chapterDetails['esg_chapter.name']
	            )
	          );
	        }) : null
	      )
	    ),
	    graphData ? graphData.map(function (exam, index) {
	      var x = void 0;
	
	      x = activeTabFlashcards === index + 1 ? _react2.default.createElement(
	        'div',
	        { className: 'card tab-body-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block dashboard-cards-scroll my-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: ' graphData' },
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam.dataOfTwentyPercentileUser ? Math.ceil(exam.dataOfTwentyPercentileUser.Percentage) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'percentileTwentyScore-box' }),
	                  ' ',
	                  _language2.default.LC().Percentile_20
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam.dataOfEightyPercentileUser ? Math.ceil(exam.dataOfEightyPercentileUser.Percentage) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'percentileEightyScore-box' }),
	                  ' ',
	                  _language2.default.LC().Percentile_80
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam.dataOfCurrentUser ? Math.ceil(exam.dataOfCurrentUser.Percentage) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'score-box' }),
	                  ' ',
	                  '' + _language2.default.LC().YOURSCORE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'graphScoreData' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphScore' },
	                  (exam && exam.chapterDetails && exam.chapterDetails.totalQuestions ? Math.ceil(exam.averageScore / exam.chapterDetails.totalQuestions * 100) : 0) + '%'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'graphLabel' },
	                  _react2.default.createElement('span', { className: 'average-box' }),
	                  ' ',
	                  _language2.default.LC().AVERAGE_SCORE
	                )
	              )
	            )
	          )
	        )
	      ) : null;
	
	      return x;
	    }) : null,
	    _react2.default.createElement(
	      'div',
	      { className: 'pt-2 text-center' },
	      _react2.default.createElement(
	        'p',
	        null,
	        _language2.default.LC().DataDetail
	      )
	    )
	  );
	}
	
	exports.default = ChapterWiseGraph;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphConstants = __webpack_require__(268);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ChapterWiseGraph = __webpack_require__(715);
	
	var _ChapterWiseGraph2 = _interopRequireDefault(_ChapterWiseGraph);
	
	var _constant = __webpack_require__(9);
	
	var _services = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainGraph = function (_Component) {
	  _inherits(MainGraph, _Component);
	
	  function MainGraph(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MainGraph);
	
	    var _this = _possibleConstructorReturn(this, (MainGraph.__proto__ || Object.getPrototypeOf(MainGraph)).call(this, props));
	
	    _this.getGraphData = function (data) {
	      (0, _services.fetchCBTChapterWiseGraph)(data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          var totalQuestions;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  console.log('res', res);
	                  if (res.success === 'true' || res.success === true) if (res.graphData.length > 6) {
	                    _this.setState({
	                      labelAngle: -90
	                    });
	                  }
	                  totalQuestions = _this.props.params.totalQuestions;
	
	                  _this.setState({
	                    isLoading: false,
	                    totalQuestionsChapterwise: totalQuestions,
	                    graphData: res.graphData,
	                    averageoverAll: res.graphData
	                  });
	                  _this.formatData(res);
	
	                case 5:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatData = function (res) {
	      // console.log('res ------> ', res);
	      var graphData = res.graphData;
	
	
	      var initialValue = 0;
	      // Reference line for 70%
	
	      //20% line chaptervise graph
	      var dataOfTwenty = {
	        showInLegend: false,
	
	        name: '20%',
	        type: 'line',
	        lineDashType: 'dash',
	        color: '#39c089',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //80% line chaptervise graph
	      var dataOfEighty = {
	        showInLegend: false,
	        name: '80%',
	        type: 'line',
	        lineDashType: 'dot',
	        color: '#1d364b',
	        dataPoints: [],
	        markerType: 'none'
	      };
	      //Userscore line chaptervise graph
	      var UserScore = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	
	      var UserScoreBox2 = {
	        showInLegend: false,
	        // legendMarkerType: 'square',
	        name: '' + _language2.default.LC().GRAPHSCOREBOX,
	        type: 'rangeColumn',
	        color: '#cce7f5',
	        dataPoints: []
	      };
	      initialValue = -10;
	      // console.log('graphData -------------> ', graphData);
	      var graphDataLength = graphData && graphData.length ? graphData.length : 0;
	      for (var k = 0; k < graphDataLength; k++) {
	        var scoreBoxSize = _this.state.scoreBoxSize;
	
	        console.log('graphData[k].dataOfCurrentUser', graphData[k].dataOfCurrentUser);
	        UserScoreBox2.dataPoints.push({
	          x: initialValue + 15,
	          label: '' + graphData[k].chapterDetails['esg_chapter.name'],
	          y: [graphData[k].dataOfCurrentUser.Percentage - scoreBoxSize, graphData[k].dataOfCurrentUser.Percentage + scoreBoxSize]
	        });
	        var dataOfCurrentUserLineStart = {
	          x: initialValue + 15 - 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineMid = {
	          x: initialValue + 15 + 1.5,
	
	          y: graphData[k].dataOfCurrentUser.Percentage
	        };
	        var dataOfCurrentUserLineEnd = {
	          x: initialValue + 15 + 1.5,
	          y: null
	        };
	        UserScore.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	        initialValue += 15;
	      }
	      initialValue = 0;
	      for (var i = 0; i < graphDataLength; i++) {
	        var dataOfTwentyPercentileUserlineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfTwentyPercentileUser.Percentage
	        };
	        var dataOfTwentyPercentileUserlineEnd = {
	          x: initialValue + 10,
	
	          y: null
	        };
	        dataOfTwenty.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	        var dataOfEightyPercentileUserLineStart = {
	          x: initialValue,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineMid = {
	          x: initialValue + 10,
	
	          y: graphData[i].dataOfEightyPercentileUser.Percentage
	        };
	        var dataOfEightyPercentileUserLineEnd = {
	          x: initialValue + 10,
	          y: null
	        };
	        dataOfEighty.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	
	        initialValue += 15;
	      }
	      var data = [];
	      console.log('UserScoreBox2', UserScoreBox2);
	      data.push(UserScoreBox2, dataOfTwenty, dataOfEighty, UserScore, _graphConstants.referenceLine);
	
	      _this.setState({
	        dataPoints: data
	      }, function () {
	        _this.showGraph(); //Show chaptervise graph
	      });
	    };
	
	    _this.showGraph = function () {
	      var dataPoints = _this.state.dataPoints;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainer', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: Object.assign({}, _constant.canvasjsConfig.axisX, {
	          labelAngle: _this.state.labelAngle,
	          labelFontSize: _this.state.labelFontSize
	        }),
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        data: dataPoints,
	
	        dataPointMaxWidth: 60,
	        dataPointWidth: 60,
	        dataPointMinWidth: 60,
	        legend: {
	          fontSize: 18
	        },
	        interactivityEnabled: false
	      });
	
	      chart.render();
	    };
	
	    _this.flashcardTabToggle = function (tab) {
	      var activeTabFlashcards = _this.state.activeTabFlashcards;
	
	      if (activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.state = {
	      graphData: [],
	      activeTabFlashcards: 1,
	      scoreBoxSize: 5
	    };
	    return _this;
	  }
	
	  _createClass(MainGraph, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var w = window.innerWidth;
	      this.setState((0, _graphConstants.getLabelAngleWithFontSize)(w));
	
	      var tokenData = (0, _graphConstants.getTokenData)();
	      this.setState(tokenData);
	
	      var _props$params = this.props.params,
	          _props$params$id = _props$params.id,
	          id = _props$params$id === undefined ? 0 : _props$params$id,
	          _props$params$testId = _props$params.testId,
	          testId = _props$params$testId === undefined ? 0 : _props$params$testId,
	          totalQuestions = _props$params.totalQuestions,
	          _props$params$timer = _props$params.timer,
	          timer = _props$params$timer === undefined ? 0 : _props$params$timer,
	          isNegative = _props$params.isNegative;
	
	
	      var data = Object.assign({}, tokenData, {
	        mock_id: parseInt(id, 10),
	        test_id: parseInt(testId, 10),
	        totalQuestion: parseInt(totalQuestions, 10),
	        timer: parseInt(timer, 10),
	        isNegative: isNegative
	      });
	      this.getGraphData(data);
	    }
	    // get data for chaptervise graph
	
	
	    //Format data as requirement
	
	
	    // show graph chaptervise graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          graphData = _state.graphData,
	          activeTabFlashcards = _state.activeTabFlashcards;
	
	      return _react2.default.createElement(_ChapterWiseGraph2.default, {
	        graphData: graphData,
	        flashcardTabToggle: this.flashcardTabToggle,
	        activeTabFlashcards: activeTabFlashcards
	      });
	    }
	  }]);
	
	  return MainGraph;
	}(_react.Component);
	
	exports.default = MainGraph;

/***/ },
/* 717 */
574,
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _toast = __webpack_require__(15);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _services = __webpack_require__(43);
	
	var _graphConstants = __webpack_require__(268);
	
	var _OverallGraph = __webpack_require__(717);
	
	var _OverallGraph2 = _interopRequireDefault(_OverallGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable id-length */
	
	
	var OverallCanvasGraph = function (_Component) {
	  _inherits(OverallCanvasGraph, _Component);
	
	  function OverallCanvasGraph(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, OverallCanvasGraph);
	
	    var _this = _possibleConstructorReturn(this, (OverallCanvasGraph.__proto__ || Object.getPrototypeOf(OverallCanvasGraph)).call(this, props));
	
	    _this.getGraphoverAllGraphData = function (data) {
	      (0, _services.fetchCBTOverallUserGraph)(data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          var totalQuestions, _res$graphData$averag, averageScore;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (res.graphData) {
	                    totalQuestions = _this.props.params.totalQuestions;
	                    _res$graphData$averag = res.graphData.averageScore, averageScore = _res$graphData$averag === undefined ? 0 : _res$graphData$averag;
	
	                    _this.setState({
	                      totalQuestions: totalQuestions,
	                      average: averageScore
	                    });
	                    _this.setState({ isLoading: false });
	                    _this.formatoverAllGraphData(res);
	                  } else (0, _toast.showFailure)(res.message);
	
	                case 1:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.formatoverAllGraphData = function (res) {
	      var graphData = res.graphData;
	
	
	      _this.setState({
	        dataOfCurrentUser: graphData ? graphData.dataOfCurrentUser.score : _this.state.dataOfCurrentUser,
	        dataOfEightyPercentileUser: graphData ? graphData.dataOfEightyPercentileUser.score : _this.state.dataOfEightyPercentileUser,
	        dataOfTwentyPercentileUser: graphData ? graphData.dataOfTwentyPercentileUser.score : _this.state.dataOfTwentyPercentileUser
	      });
	      var totalMarks = _this.props.params.totalMarks;
	
	      //User score line
	
	      var UserScoreOverAllGraph = {
	        showInLegend: false,
	        name: '' + _language2.default.LC().GRAPHSCORE,
	
	        type: 'line',
	        color: '#1f8ceb',
	        markerType: 'none',
	        dataPoints: [],
	        overlayBars: true
	      };
	      //User score box
	
	      var scorePercentage = graphData.dataOfCurrentUser.score == null ? 0 : Math.ceil(graphData.dataOfCurrentUser.score / totalMarks * 100);
	
	      var UserScoreBoxOverAllGraph2 = {
	        type: 'rangeColumn',
	
	        color: 'hsl(200deg 67% 88%)',
	        dataPoints: []
	      };
	
	      UserScoreBoxOverAllGraph2.dataPoints.push({
	        x: 1.39,
	
	        y: [scorePercentage - 5, scorePercentage + 5]
	      });
	
	      var dataOfCurrentUserLineStart = {
	        x: -0.2,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineMid = {
	        x: 2.8,
	
	        y: scorePercentage
	      };
	      var dataOfCurrentUserLineEnd = {
	        x: 2.8,
	        y: null
	      };
	
	      UserScoreOverAllGraph.dataPoints.push(dataOfCurrentUserLineStart, dataOfCurrentUserLineMid, dataOfCurrentUserLineEnd);
	
	      var dataOfTwentyPercentileUserlineStart = {
	        x: -3,
	
	        y: graphData.dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData.dataOfTwentyPercentileUser.score / totalMarks * 100)
	      };
	      var dataOfTwentyPercentileUserlineMid = {
	        x: 7,
	
	        y: graphData.dataOfTwentyPercentileUser.score == null ? 0 : Math.ceil(graphData.dataOfTwentyPercentileUser.score / totalMarks * 100)
	      };
	      var dataOfTwentyPercentileUserlineEnd = {
	        x: 7,
	        y: null
	      };
	      var twentyPercentLineObj = Object.assign({}, _graphConstants.twentyPercentLine, { dataPoints: [] });
	
	      twentyPercentLineObj.dataPoints.push(dataOfTwentyPercentileUserlineStart, dataOfTwentyPercentileUserlineMid, dataOfTwentyPercentileUserlineEnd);
	      var dataOfEightyPercentileUserLineStart = {
	        x: -3,
	
	        y: graphData.dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData.dataOfEightyPercentileUser.score / totalMarks * 100)
	      };
	      var dataOfEightyPercentileUserLineMid = {
	        x: 7,
	
	        y: graphData.dataOfEightyPercentileUser.score == null ? 0 : Math.ceil(graphData.dataOfEightyPercentileUser.score / totalMarks * 100)
	      };
	
	      var dataOfEightyPercentileUserLineEnd = {
	        x: 7,
	        y: null
	      };
	      var eightyPercentLineObj = Object.assign({}, _graphConstants.eightyPercentLine, { dataPoints: [] });
	      eightyPercentLineObj.dataPoints.push(dataOfEightyPercentileUserLineStart, dataOfEightyPercentileUserLineMid, dataOfEightyPercentileUserLineEnd);
	      var overAllGraphData = [];
	      overAllGraphData.push(UserScoreBoxOverAllGraph2, twentyPercentLineObj, eightyPercentLineObj, UserScoreOverAllGraph, _graphConstants.referenceLine);
	
	      _this.setState({ dataPointsOverAllGraph: overAllGraphData }, function () {
	        _this.showGraphOverAll(); //Show overall graph
	      });
	    };
	
	    _this.showGraphOverAll = function () {
	      var dataPointsOverAllGraph = _this.state.dataPointsOverAllGraph;
	
	
	      var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
	        animationEnabled: true,
	        axisY: _constant.canvasjsConfig.axisY,
	        axisX: _constant.canvasjsConfig.axisX,
	
	        toolTip: _constant.canvasjsConfig.toolTip,
	        dataPointWidth: 90,
	        dataPointMaxWidth: 80,
	        dataPointMinWidth: 80,
	        legend: { fontSize: 18 },
	        data: dataPointsOverAllGraph,
	        interactivityEnabled: false
	      });
	      chart.render();
	    };
	
	    _this.state = {
	      dataPointsOverAllGraph: [],
	      isLoading: true
	    };
	    return _this;
	  }
	
	  _createClass(OverallCanvasGraph, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var tokenData = (0, _graphConstants.getTokenData)();
	      this.setState(tokenData);
	      var _props$params = this.props.params,
	          _props$params$id = _props$params.id,
	          id = _props$params$id === undefined ? 0 : _props$params$id,
	          _props$params$testId = _props$params.testId,
	          testId = _props$params$testId === undefined ? 0 : _props$params$testId,
	          totalQuestions = _props$params.totalQuestions,
	          _props$params$timer = _props$params.timer,
	          timer = _props$params$timer === undefined ? 0 : _props$params$timer,
	          isNegative = _props$params.isNegative;
	
	      var data = Object.assign({}, tokenData, {
	        mock_id: parseInt(id, 10),
	        test_id: parseInt(testId, 10),
	        totalQuestion: parseInt(totalQuestions, 10),
	        timer: parseInt(timer, 10),
	        isNegative: isNegative
	      });
	      this.getGraphoverAllGraphData(data);
	    }
	
	    //format data as requirement for overall graph
	
	
	    //Show overall graph
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          average = _state.average,
	          dataOfCurrentUser = _state.dataOfCurrentUser,
	          dataOfEightyPercentileUser = _state.dataOfEightyPercentileUser,
	          dataOfTwentyPercentileUser = _state.dataOfTwentyPercentileUser,
	          isLoading = _state.isLoading;
	      var _props$params$totalMa = this.props.params.totalMarks,
	          totalMarks = _props$params$totalMa === undefined ? 1 : _props$params$totalMa;
	
	
	      return _react2.default.createElement(
	        _LoaderWrapper2.default,
	        { isLoading: isLoading },
	        _react2.default.createElement(_OverallGraph2.default, {
	          average: average,
	          totalMarks: totalMarks,
	          dataOfCurrentUser: dataOfCurrentUser,
	          dataOfTwentyPercentileUser: dataOfTwentyPercentileUser,
	          dataOfEightyPercentileUser: dataOfEightyPercentileUser
	        })
	      );
	    }
	  }]);
	
	  return OverallCanvasGraph;
	}(_react.Component);
	
	exports.default = OverallCanvasGraph;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OverallGraph = __webpack_require__(718);
	
	var _OverallGraph2 = _interopRequireDefault(_OverallGraph);
	
	var _ChapterWiseGraph = __webpack_require__(716);
	
	var _ChapterWiseGraph2 = _interopRequireDefault(_ChapterWiseGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ESGResult(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_OverallGraph2.default, props),
	    _react2.default.createElement(_ChapterWiseGraph2.default, props)
	  );
	}
	
	exports.default = ESGResult;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReviewSectionButton(_ref) {
	  var onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'button',
	    { className: 'menu-btn tooltip-hover-questions', onClick: onClick },
	    _react2.default.createElement('img', {
	      width: '30px',
	      src: _App_data2.default.frontend_url + '/img/questions/icon_menu.png',
	      className: 'my-1',
	      alt: 'questions'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      _language2.default.LC().SECTION_REVIEW
	    )
	  );
	}
	
	exports.default = ReviewSectionButton;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var filterByList = ['Unattempted', 'Attempted', 'Flagged'];
	
	var SectionReview = function (_Component) {
	  _inherits(SectionReview, _Component);
	
	  function SectionReview(props) {
	    _classCallCheck(this, SectionReview);
	
	    var _this = _possibleConstructorReturn(this, (SectionReview.__proto__ || Object.getPrototypeOf(SectionReview)).call(this, props));
	
	    _this.toggleFilter = function (item) {
	      var filter = _this.state.filter;
	
	      var indexPos = filter.indexOf(item);
	      if (indexPos > -1) {
	        _this.setState({
	          filter: filter.filter(function (i) {
	            return i !== item;
	          })
	        });
	      } else {
	        _this.setState({
	          filter: [].concat(_toConsumableArray(filter), [item])
	        });
	      }
	    };
	
	    _this.state = {
	      filter: []
	    };
	    return _this;
	  }
	
	  _createClass(SectionReview, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var filter = this.state.filter;
	      var _props = this.props,
	          dataList = _props.dataList,
	          onClick = _props.onClick,
	          showSectionReview = _props.showSectionReview,
	          flaggedQuesObject = _props.flaggedQuesObject,
	          attemptedQuesObject = _props.attemptedQuesObject;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sidebar-review-wrapper ' + (showSectionReview ? 'active' : '') },
	        console.log('showSectionReview', showSectionReview),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-review' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _language2.default.LC().SECTION_REVIEW
	          ),
	          _react2.default.createElement(
	            'span',
	            { onClick: onClick },
	            _react2.default.createElement('img', {
	              width: '30px',
	              src: _App_data2.default.frontend_url + '/img/questions/icon_close.png',
	              alt: '/img/questions/icon_close.png'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'body-review' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _language2.default.LC().FILTER_BY,
	            ':'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'filt-list-wrapper' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary small-btn',
	                onClick: function onClick() {
	                  _this2.setState({
	                    filter: []
	                  });
	                }
	              },
	              _language2.default.LC().CLEAR
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              filterByList.map(function (item, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'plan_wrapper remove-plan', key: index },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'check_container' },
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      value: item,
	                      id: item,
	                      checked: filter.indexOf(item) > -1 ? true : false,
	                      onChange: function onChange(e) {
	                        return _this2.toggleFilter(item);
	                      }
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' }),
	                    ' ',
	                    item
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'qus-tab-wrapper' },
	            dataList.map(function (item, index) {
	              return _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: (attemptedQuesObject[item.id] ? 'completed-qus' : '') + '\n                ' + (filter.length === filterByList.length || filter.includes('Unattempted') && filter.includes('Attempted') ? '' : filter.includes('Unattempted') && filter.includes('Flagged') ? !attemptedQuesObject[item.id] && flaggedQuesObject[item.id] ? '' : 'd-none' : filter.includes('Attempted') && filter.includes('Flagged') ? attemptedQuesObject[item.id] && flaggedQuesObject[item.id] ? '' : 'd-none' : filter.includes('Unattempted') ? attemptedQuesObject[item.id] ? 'd-none' : '' : filter.includes('Attempted') ? attemptedQuesObject[item.id] ? '' : 'd-none' : filter.includes('Flagged') ? flaggedQuesObject[item.id] ? '' : 'd-none' : '') + '\n                ',
	                  onClick: function onClick() {
	                    _this2.setState({
	                      showSectionReview: false
	                    });
	                    _this2.props.changeQuestion(index);
	                  }
	                },
	                index + 1,
	                flaggedQuesObject[item.id] ? _react2.default.createElement('img', {
	                  width: '70',
	                  src: _App_data2.default.frontend_url + '/img/questions/icon_flag_white.png',
	                  alt: 'Question'
	                }) : ''
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SectionReview;
	}(_react.Component);
	
	exports.default = SectionReview;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CardHeader = __webpack_require__(119);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardBody = __webpack_require__(118);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShowAnswer(props) {
	  var correctChoice = props.correct_choice,
	      explanation = props.explanation,
	      attemptedQuesObject = props.attemptedQuesObject,
	      id = props.id;
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      null,
	      _react2.default.createElement(
	        _CustomCard2.default,
	        { className: 'font-lusitana font-16px' },
	        _react2.default.createElement(_CardHeader2.default, {
	          headingText: attemptedQuesObject[id] === correctChoice ? 'Correct' : attemptedQuesObject[id] !== undefined ? 'Incorrect' : 'Not Attempted',
	          headerImage: '',
	          className: 'text-uppercase ' + (attemptedQuesObject[id] === correctChoice ? 'text_success' : attemptedQuesObject[id] !== undefined ? 'text_failure' : '') + '\n            }'
	        }),
	        _react2.default.createElement(
	          _CardBody2.default,
	          null,
	          (0, _function.renderHTMLContent)(explanation, "span")
	        )
	      )
	    )
	  );
	}
	
	exports.default = ShowAnswer;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _services = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Summary = function (_Component) {
	  _inherits(Summary, _Component);
	
	  function Summary(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Summary);
	
	    var _this = _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, mockId, testId, data, results, result;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, mockId = _this$props.mockId, testId = _this$props.testId;
	              data = {
	                mockId: mockId,
	                testId: testId
	              };
	              _context.next = 4;
	              return Promise.all([(0, _services.fetchChapterWiseCount)(data), (0, _services.fetchChapterWiseAnswerCount)(data)]);
	
	            case 4:
	              results = _context.sent;
	              result = (0, _constant.mergeTwoSortedArrayDataById)(results[0].chapterwiseData, results[1].totalScore, 'chapter_id', {
	                flatObjectOnArray1: true
	                // aliasName: { esg_chapter: 'Chapter' },
	              });
	
	              _this.setState({
	                readingViseScore: result,
	                loading: false
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      readingViseScore: [],
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(Summary, [{
	    key: 'render',
	    value: function render() {
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          readingViseScore = _state.readingViseScore,
	          loading = _state.loading;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sidebar-review-wrapper sidebar-score-wrapper active' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-review' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            ' ',
	            _language2.default.LC().TOPIC_WISE_SCORE
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'cursor-pointer', onClick: onClose },
	            _react2.default.createElement('img', {
	              alt: 'icon_close',
	              width: '30px',
	              src: _App_data2.default.frontend_url + '/img/questions/icon_close.png'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'body-review' },
	          loading && _react2.default.createElement(
	            'div',
	            { className: 'card-block-loader' },
	            _react2.default.createElement(_loader2.default, null)
	          ) || _react2.default.createElement(
	            'ul',
	            { className: 'score-list-wrapper' },
	            readingViseScore && readingViseScore.length ? readingViseScore.map(function (item, index) {
	              var readingPercentage = item.correctCount * 100 / item.totalCount;
	              return item.name && _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    index + 1,
	                    '.\xA0 ',
	                    item.name
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'progress custom-prog-bar margin_top_5' },
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'progress-bar',
	                        role: 'progressbar',
	                        style: {
	                          width: Math.ceil(readingPercentage) + '%'
	                        },
	                        'aria-valuenow': '' + Math.ceil(readingPercentage),
	                        'aria-valuemin': '0',
	                        'aria-valuemax': '100'
	                      },
	                      Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0,
	                      '%'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'score-inner' },
	                  item.correctCount || 0,
	                  '/',
	                  item.totalCount || 1
	                )
	              );
	            }) : _react2.default.createElement(
	              'div',
	              { className: 'no-qus-found no-mock-exam mt-5' },
	              _react2.default.createElement('img', {
	                width: '62px',
	                src: _App_data2.default.frontend_url + '/img/questions/icon_nomock.png',
	                alt: 'No mock'
	              }),
	              _react2.default.createElement(
	                'h3',
	                { className: 'mt-1' },
	                _language2.default.LC().NO_SCORE_FOUND
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Summary;
	}(_react.Component);
	
	exports.default = Summary;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constant = __webpack_require__(9);
	
	var _CBTInstructions = __webpack_require__(84);
	
	var _CBTInstructions2 = _interopRequireDefault(_CBTInstructions);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _common = __webpack_require__(272);
	
	var _services = __webpack_require__(43);
	
	var _DynamicTable = __webpack_require__(710);
	
	var _DynamicTable2 = _interopRequireDefault(_DynamicTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewAttemptedMock = function (_Component) {
	  _inherits(ViewAttemptedMock, _Component);
	
	  function ViewAttemptedMock(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewAttemptedMock);
	
	    var _this = _possibleConstructorReturn(this, (ViewAttemptedMock.__proto__ || Object.getPrototypeOf(ViewAttemptedMock)).call(this, props));
	
	    _this.viewTest = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(___, item) {
	        var _this$props$params, id, timer, testId;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props$params = _this.props.params, id = _this$props$params.id, timer = _this$props$params.timer;
	                testId = item.id;
	
	
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.ESG_CBT_FINISH_PAGE.replace(':mockId', id).replace(':timer', timer).replace(':offset', 0).replace(':testId', testId)
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.resumeTest = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event, item) {
	        var _this$props$params2, id, timer, isNegative, testId, lastAnswered;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props$params2 = _this.props.params, id = _this$props$params2.id, timer = _this$props$params2.timer;
	                isNegative = item.isNegative, testId = item.id;
	                lastAnswered = item.lastAnswered ? JSON.parse(item.lastAnswered) : {};
	
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.ESG_CBT_QUESTIONS.replace(':mockId', id).replace(':timer', timer).replace(':timerStart', true).replace(':isNegative', isNegative).replace(':offset', lastAnswered.offset || 0).replace(':testId', testId).replace(':questionId', lastAnswered.question_id || ':questionId')
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteUserAttemptedMockExam = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(event, item) {
	        var result, id;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return (0, _services.deleteUserAttemptedMockExamAPICall)({ id: item.id });
	
	              case 2:
	                result = _context3.sent;
	
	                if (result.success) {
	                  id = _this.props.params.id;
	
	                  _this.getList(id);
	                }
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x5, _x6) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToInstructionsPage = function () {
	      var _this$props$params3 = _this.props.params,
	          id = _this$props$params3.id,
	          timer = _this$props$params3.timer;
	
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_INTRODUCTION.replace(':id', id).replace(':timer', timer).replace(':offset', 0)
	      });
	    };
	
	    _this.redirectedToMockList = function () {
	      _this.context.router.push({ pathname: _AppRoutes2.default.ESG_CBT });
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var id, response;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              id = _this.props.params.id;
	
	              _this.getList(id);
	              _context4.next = 4;
	              return (0, _services.getMockDetailsById)({ mockId: id });
	
	            case 4:
	              response = _context4.sent;
	
	              if (response.success) {
	                _this.setState({ title: response.mockData.mock_exam });
	              }
	              _this.setState({ isLoading: false });
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.getList = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	        var result, hasValidSubscription;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return (0, _services.getUserStatsByMockId)({ mockId: id });
	
	              case 2:
	                result = _context5.sent;
	
	                if (result.success) {
	                  hasValidSubscription = result.userSubscriptionDetails && Object.keys(result.userSubscriptionDetails).length > 0;
	
	
	                  _this.setState({
	                    userMockList: result.userStatsData,
	                    userSubscriptionDetails: hasValidSubscription ? result.userSubscriptionDetails : result.hasMockSubscription || null
	                  });
	                }
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _this.context.router.push({
	                pathname: '/Subscribe/',
	                state: {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  selectedMenu: _this.state.selectedmenu
	                }
	              });
	
	            case 1:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.checkSubscription = function (cb) {
	      var userSubscriptionDetails = _this.state.userSubscriptionDetails;
	
	      var isEmptyObject = !userSubscriptionDetails || (typeof userSubscriptionDetails === 'undefined' ? 'undefined' : _typeof(userSubscriptionDetails)) === 'object' && Object.keys(userSubscriptionDetails).length === 0;
	      if (isEmptyObject) {
	        return _this.setState({ openPremiumPopup: true });
	      }
	      cb();
	    };
	
	    _this.state = {
	      userMockList: [],
	      actionList: [{
	        label: 'View',
	        action: _this.viewTest,
	        icon: 'fa fa-eye mark-action-btn-dashboard',
	        className: 'mr-md-1',
	        style: { color: 'rgb(31, 140, 235)' },
	        condition: { status: 'completed' }
	      }, {
	        label: 'Resume',
	        action: _this.resumeTest,
	        icon: 'fa fa-play-circle-o mark-action-btn-dashboard',
	        condition: { status: 'pending' },
	        className: 'mr-md-1',
	        style: { color: 'rgb(0, 0, 0)' }
	      }, {
	        label: 'delete',
	        action: _this.deleteUserAttemptedMockExam,
	        icon: 'fa fa-trash mark-action-btn-dashboard'
	      }],
	      additionalParameterForOperation: {
	        timer: _this.props.params.timer,
	        SecondsToHHMMSS: _constant.SecondsToHHMMSS,
	        moment: _moment2.default
	      },
	
	      userSubscriptionDetails: {},
	      openPremiumPopup: false,
	      isLoading: true,
	      showInstructionModal: false
	    };
	    return _this;
	  }
	
	  _createClass(ViewAttemptedMock, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          title = _state.title,
	          userMockList = _state.userMockList,
	          actionList = _state.actionList,
	          additionalParameterForOperation = _state.additionalParameterForOperation,
	          isLoading = _state.isLoading,
	          openPremiumPopup = _state.openPremiumPopup,
	          showInstructionModal = _state.showInstructionModal;
	
	      return _react2.default.createElement(
	        _LoaderWrapper2.default,
	        { isLoading: isLoading },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn font-16px' },
	          _react2.default.createElement(
	            _Header2.default,
	            { title: title },
	            _react2.default.createElement(
	              'div',
	              { className: 'two-btn-wrapper' },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                {
	                  className: 'mid-btn',
	                  onClick: function onClick() {
	                    return _this3.checkSubscription(function () {
	                      return _this3.setState({ showInstructionModal: true });
	                    });
	                  }
	                },
	                'Start'
	              ),
	              _react2.default.createElement(
	                _CustomButton2.default,
	                { className: 'mid-btn', onClick: this.redirectedToMockList },
	                'Change Mock'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _CustomCard2.default,
	            { className: 'height_70vh esg_custom_card' },
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                null,
	                _react2.default.createElement(_DynamicTable2.default, {
	                  data: userMockList,
	                  columns: _common.testListColumns,
	                  actionList: actionList,
	                  additionalParameterForOperation: additionalParameterForOperation
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium,
	            toggleAlert: this.toggleAlert,
	            alert_status: openPremiumPopup,
	            MessageContent: _alertMessage2.default.messageContent_ESG,
	            exam: _constant.examNameAccordingToDB.ESG
	          }),
	          _react2.default.createElement(_CBTInstructions2.default, {
	            showInstructionModal: showInstructionModal,
	            getQuestions: this.redirectToInstructionsPage,
	            handleClose: function handleClose() {
	              return _this3.setState({ showInstructionModal: false });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ViewAttemptedMock;
	}(_react.Component);
	
	ViewAttemptedMock.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ViewAttemptedMock;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESGCBT = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _PrintButton = __webpack_require__(714);
	
	var _PrintButton2 = _interopRequireDefault(_PrintButton);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _constant = __webpack_require__(9);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESGCBT = exports.ESGCBT = function (_Component) {
	  _inherits(ESGCBT, _Component);
	
	  function ESGCBT(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ESGCBT);
	
	    var _this = _possibleConstructorReturn(this, (ESGCBT.__proto__ || Object.getPrototypeOf(ESGCBT)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var storage_session, data, result, mockList, userSubscriptionDetails, hasMockSubscription;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              data = {
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              };
	              _context.next = 5;
	              return _this.fetchMockList(data);
	
	            case 5:
	              result = _context.sent;
	
	              if (result.success) {
	                mockList = result.mockList, userSubscriptionDetails = result.userSubscriptionDetails, hasMockSubscription = result.hasMockSubscription;
	
	                _this.setState({
	                  mockList: mockList,
	                  userSubscriptionDetails: userSubscriptionDetails,
	                  hasMockSubscription: hasMockSubscription || null
	                });
	              }
	              _this.setState({
	                isLoading: false
	              });
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.fetchMockList = function (data) {
	      return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/cbt/mocks', data);
	    };
	
	    _this.checkSubscription = function (cb) {
	      for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        params[_key - 1] = arguments[_key];
	      }
	
	      var _this$state = _this.state,
	          userSubscriptionDetails = _this$state.userSubscriptionDetails,
	          hasMockSubscription = _this$state.hasMockSubscription;
	
	      var hasStandardSubscription = userSubscriptionDetails && Object.keys(userSubscriptionDetails).length > 0;
	      // Users with a mock-only package (e.g. ESG Mock Learn + Practice) get an
	      // empty userSubscriptionDetails from subscriptionCheckMiddleware — fall
	      // back to hasMockSubscription computed by cbtMockSubscriptionMiddleware.
	      var hasMockAccess = (0, _CommonUtils.hasMockAccessFromBackend)(hasMockSubscription);
	      if (!hasStandardSubscription && !hasMockAccess) {
	        return _this.setState({ openPremiumPopup: true });
	      }
	      cb.apply(undefined, params);
	    };
	
	    _this.goPremium = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.context.router.push({
	                pathname: '/Subscribe/'
	              });
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        openPremiumPopup: !_this.state.openPremiumPopup
	      });
	    };
	
	    _this.toggle = function (index) {
	      _this.setState({
	        dropdownOpenIndex: index,
	        dropdownOpen: !_this.state.dropdownOpen
	      });
	    };
	
	    _this.viewAttemptedExams = function (item) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', item.id).replace(':timer', item.timer)
	      });
	    };
	
	    _this.state = {
	      dropdownOpen: false,
	      dropdownOpenIndex: '',
	      mockList: [],
	      isLoading: true,
	      openPremiumPopup: false,
	      userSubscriptionDetails: {},
	      hasMockSubscription: null
	    };
	    return _this;
	  }
	
	  // Subscription Modal Pop-up
	
	  // Subscription Modal Pop-up
	
	  _createClass(ESGCBT, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          dropdownOpen = _state.dropdownOpen,
	          dropdownOpenIndex = _state.dropdownOpenIndex,
	          mockList = _state.mockList,
	          isLoading = _state.isLoading,
	          openPremiumPopup = _state.openPremiumPopup;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn font-lusitana font-16px' },
	        _react2.default.createElement(_Header2.default, { title: _language2.default.LC().MOCK_LIST }),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                null,
	                _react2.default.createElement(
	                  'table',
	                  { className: 'table_white_bg table' },
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      { className: 'border_top_0' },
	                      _react2.default.createElement(
	                        'th',
	                        { width: '90' },
	                        '#'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'mw-190' },
	                        _language2.default.LC().MOCKEXAM
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'w-280 text-center' },
	                        _language2.default.LC().ACTION
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    mockList.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: index },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          item.mock_order
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            item.mock_exam
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            _CustomButton2.default,
	                            {
	                              className: 'small-btn',
	                              onClick: function onClick() {
	                                return _this3.viewAttemptedExams(item);
	                              }
	                            },
	                            _language2.default.LC().START
	                          ),
	                          _react2.default.createElement(_PrintButton2.default, {
	                            mockListLength: mockList.length,
	                            index: index,
	                            item: item,
	                            dropdownOpen: dropdownOpen,
	                            dropdownOpenIndex: dropdownOpenIndex,
	                            toggle: function toggle() {
	                              return _this3.checkSubscription(_this3.toggle, index);
	                            }
	                          })
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_ESG,
	          exam: _constant.examNameAccordingToDB.ESG
	        })
	      );
	    }
	  }]);
	
	  return ESGCBT;
	}(_react.Component);
	
	ESGCBT.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = ESGCBT;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getImagePath = function getImagePath(imgSrc) {
	  return '' + _App_data2.default.frontend_url + imgSrc;
	};
	
	var IntroductionItems = [{
	  id: '1',
	  title: _language2.default.LC().INTROTITLE,
	  content: [{ html: _language2.default.LC().INTROPARA }],
	  buttonText: _language2.default.LC().NEXTTOCONTINUE
	}, {
	  id: '2',
	  title: _language2.default.LC().WELCOMETITLE,
	  content: [{ html: _language2.default.LC().WELCOMEPARA }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '3',
	  title: _language2.default.LC().USEMOUSETITLE,
	  content: [{ image: getImagePath('/img/questions/icon_arrow.png') }, { html: _language2.default.LC().USEMOUSEPARA }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '4',
	  title: _language2.default.LC().NAVIGATTITLE,
	  content: [{ html: _language2.default.LC().NAVIGATPARA }, { image: getImagePath('/img/questions/icon_tab_btn.png') }, { html: _language2.default.LC().NAVIGATBUTTONINFO }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '5',
	  title: _language2.default.LC().TIMEREMAINTITLE,
	  content: [{ html: _language2.default.LC().TIMEREMAINPARAONE }, { image: getImagePath('/img/questions/img_time.png') }, { html: _language2.default.LC().TIMEREMAINPARATWO }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '6',
	  title: _language2.default.LC().FLAGTITLE,
	  content: [{ image: getImagePath('/img/questions/icon_flag_tag.png') }, { html: _language2.default.LC().FLAGPARA }, { image: getImagePath('/img/questions/icon_flag_tag_btn.png') }, { html: _language2.default.LC().FLAGBUTTON }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '7',
	  title: _language2.default.LC().ANSWERMULTTITLE,
	  content: [{ html: _language2.default.LC().ANSWERMULTPARA }],
	  imageSrc: '',
	  buttonText: '',
	  choices: [{
	    letter: _language2.default.LC().A,
	    answer: _language2.default.LC().ESTONIA
	  }, {
	    letter: _language2.default.LC().B,
	    answer: _language2.default.LC().UKRAINE
	  }, {
	    letter: _language2.default.LC().C,
	    answer: _language2.default.LC().BELGIUM
	  }]
	}, {
	  id: '8',
	  title: _language2.default.LC().REVIEWTITLE,
	  content: [{ html: _language2.default.LC().REVIEWPARA }, { image: getImagePath('/img/questions/icon_menu.png') }, { html: _language2.default.LC().REVIEWPARACLOSE }, { image: getImagePath('/img/questions/img_sidebar.png') }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '9',
	  title: _language2.default.LC().HIGHLIGHTINGTEXT,
	  content: [{ html: _language2.default.LC().HIGHLIGHTINGPARA }, { image: getImagePath('/img/questions/img_highlight.png') }, { html: _language2.default.LC().PLEASENOTE }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '10',
	  title: _language2.default.LC().STRIKINGOUTOPTIONS,
	  content: [{ html: _language2.default.LC().STRIKINGOUTOPTIONSPARA }],
	  imageSrc: '',
	  buttonText: '',
	  choices: [{
	    letter: _language2.default.LC().A,
	    answer: _language2.default.LC().ESTONIA
	  }, {
	    letter: _language2.default.LC().B,
	    answer: _language2.default.LC().UKRAINE
	  }, {
	    letter: _language2.default.LC().C,
	    answer: _language2.default.LC().BELGIUM
	  }]
	}, {
	  id: '11',
	  title: _language2.default.LC().ENDINGEXAMTITLE,
	  content: [{ html: _language2.default.LC().ENDINGEXAMPARA }],
	  buttonText: _language2.default.LC().NEXTBUTTONCONTINUE
	}, {
	  id: '12',
	  title: _language2.default.LC().TUTORIALCONCLUSIONTITLE,
	  content: [{ html: _language2.default.LC().TUTORIALCONCLUSIONPARA }],
	  buttonText: _language2.default.LC().CLICKSTARTTEST
	}];
	exports.default = IntroductionItems;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardImageAndCount(props) {
	  var imageURL = props.imageURL,
	      count = props.count,
	      text = props.text,
	      _props$width = props.width,
	      width = _props$width === undefined ? '23' : _props$width;
	
	  return _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement('img', {
	        src: '' + _App_data2.default.frontend_url + imageURL,
	        className: '',
	        width: width,
	        alt: 'ImageChange'
	      })
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      count
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      text
	    )
	  );
	}
	
	exports.default = CardImageAndCount;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _CardImageAndCount = __webpack_require__(727);
	
	var _CardImageAndCount2 = _interopRequireDefault(_CardImageAndCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChapterCard(props) {
	  var headerImage = props.headerImage,
	      chapterOrder = props.chapterOrder,
	      chapterNumber = props.chapterNumber,
	      chapterName = props.chapterName,
	      totalReadings = props.totalReadings,
	      headerImageWidth = props.headerImageWidth,
	      totalNotes = props.totalNotes,
	      premiumQuestionsCount = props.premiumQuestionsCount,
	      freeQuestionsCount = props.freeQuestionsCount,
	      callingComponent = props.callingComponent,
	      children = props.children,
	      onClick = props.onClick,
	      userSubscriptionDetails = props.userSubscriptionDetails,
	      free = props.free;
	
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    {
	      xs: '12',
	      sm: 6,
	      lg: 6,
	      xl: 4,
	      className: 'question_box free-premium-section',
	      key: chapterNumber
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'question_bank_wrap pointer_class', key: chapterNumber, onClick: onClick },
	      !Object.keys(userSubscriptionDetails).length && callingComponent === 'notes' ? free ? _react2.default.createElement(
	        'div',
	        { className: 'tag-tile free' },
	        ' ',
	        _language2.default.LC().FREE,
	        ' '
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'tag-tile premium' },
	        ' ',
	        _language2.default.LC().PREMIUM,
	        ' '
	      ) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'margin_bottom_30' },
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + headerImage,
	          className: '',
	          width: headerImageWidth || 40,
	          alt: ''
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'question_title', key: chapterNumber, value: chapterNumber },
	        _react2.default.createElement(
	          'a',
	          null,
	          chapterOrder || chapterNumber,
	          '. ',
	          chapterName
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { key: chapterName },
	        totalReadings && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: '/img/notes/notes_icon2.svg',
	          count: totalReadings,
	          text: _language2.default.LC().TOTAL_READINGS,
	          width: '24'
	        }),
	        totalNotes && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: '/img/notes/notes_icon3.svg',
	          count: totalNotes,
	          text: _language2.default.LC().TOTAL_NOTES,
	          width: '20'
	        }),
	        freeQuestionsCount !== 'undefined' && callingComponent !== 'notes' && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: '/img/question_bank/free_question_icon.svg',
	          count: freeQuestionsCount,
	          text: _language2.default.LC().FREE_QUESTIONS,
	          width: '26'
	        }),
	        premiumQuestionsCount && callingComponent !== 'notes' && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: '/img/question_bank/premium_question_icon.svg',
	          count: premiumQuestionsCount,
	          text: _language2.default.LC().PREMIUM_QUESTIONS,
	          width: '23'
	        }),
	        callingComponent === 'notes' && _react2.default.createElement(_CardImageAndCount2.default, {
	          imageURL: '/img/mockexams/print_icon.svg',
	          count: _language2.default.LC().VIEW,
	          text: _language2.default.LC().VIEW_PDF,
	          width: '23'
	        }),
	        children
	      )
	    )
	  );
	}
	
	exports.default = ChapterCard;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var GraphDataCalculation = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(response) {
	    var calculatedGraphData, iterator, right_answered, total_question, user_graph_val;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            calculatedGraphData = [];
	            iterator = 0;
	
	          case 2:
	            if (!(iterator < response.length)) {
	              _context.next = 11;
	              break;
	            }
	
	            right_answered = response[iterator]['esg_questions.esg_question_stats.userAnswerCount'];
	            total_question = response[iterator]['esg_questions.esg_question_stats.userAttemptCount'];
	            user_graph_val = parseInt(right_answered / total_question * 100, 10);
	            _context.next = 8;
	            return calculatedGraphData.push(user_graph_val);
	
	          case 8:
	            iterator++;
	            _context.next = 2;
	            break;
	
	          case 11:
	            return _context.abrupt('return', calculatedGraphData);
	
	          case 12:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function GraphDataCalculation(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	exports.default = GraphDataCalculation;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabList = {
	  esg: [{
	    label: 'Question',
	    idFieldName: 'questionId',
	    // SAVED ITEM LIST START HERE
	    favAPIService: 'fetchSavedQuestion',
	    saveItemDeleteAPIService: 'deleteSavedQuestion',
	    savedItemTitle: 'Question ID', // that is tabs title with ID
	    saveItemTableName: 'esg_question', // table name to access object or save item
	    savedItemTableKey: 'name', // key name to represent topic which is show in tab
	    // REPORTED ITEM LIST START HERE
	    reportAPIService: 'fetchReportedQuestion',
	    reportedItemTableKey: 'comment',
	    reportDeleteAPIService: 'deleteReportedQuestion',
	    // VIEW ITEM LIST START HERE
	    viewItemAPIService: 'redirectToQuestion',
	    redirectionPath: _AppRoutes2.default.ESG_QUESTION_BANK_VIEW_QUE,
	    // EDIT REPORT LIST START HERE
	    editAPIService: 'updateReportedQuestion'
	  }, {
	    label: 'Video',
	    //* SAVED ITEM LIST START HERE
	    favAPIService: 'fetchSavedVideos',
	    saveItemDeleteAPIService: 'deleteSavedVideo',
	    savedItemTitle: 'Video ID', // that is tabs title with ID
	    saveItemTableName: 'esg_video', // table name to access object or save item
	    savedItemTableKey: 'title', // key name to represent topic which is show in tab
	    //* REPORTED ITEM LIST START HERE
	    reportAPIService: 'fetchReportedVideos',
	    reportedItemTableKey: 'comment',
	    reportDeleteAPIService: 'deleteReportedVideo',
	    //* VIEW ITEM LIST START HERE
	    viewItemAPIService: 'redirectToVideo',
	    redirectionPath: _AppRoutes2.default.ESG_VIDEO_LESSON,
	    //* EDIT REPORT LIST START HERE
	    editAPIService: 'updateReportedVideo'
	  }, {
	    label: 'Mocks',
	    reportAPIService: 'fetchCBTReportedQuestion',
	    savedItemTitle: 'CBT Question ID',
	    saveItemTableName: 'esg_cbt_question',
	    savedItemTableKey: 'name', // key name to represent topic which is show in tab
	    reportedItemTableKey: 'comment',
	    viewItemAPIService: 'redirectToCBTQuestion',
	    redirectionPath: _AppRoutes2.default.ESG_CBT_FINISH_PAGE,
	    reportDeleteAPIService: 'deleteCBTReportedQuestion',
	    // EDIT REPORT LIST START HERE
	    editAPIService: 'updateReportedCBTQuestion'
	  }]
	};
	
	exports.default = tabList;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardDateFilter = function DashboardDateFilter(_ref) {
	  var _ref$startDate = _ref.startDate,
	      startDate = _ref$startDate === undefined ? '' : _ref$startDate,
	      _ref$endDate = _ref.endDate,
	      endDate = _ref$endDate === undefined ? '' : _ref$endDate,
	      isDateHandleChange = _ref.isDateHandleChange,
	      resetDate = _ref.resetDate,
	      isTooltipToggle = _ref.isTooltipToggle,
	      _ref$tooltipOpen = _ref.tooltipOpen,
	      tooltipOpen = _ref$tooltipOpen === undefined ? false : _ref$tooltipOpen,
	      _ref$content = _ref.content,
	      content = _ref$content === undefined ? '' : _ref$content;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card margin_bottom_20' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card-block' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row dashboard-filter' },
	        _react2.default.createElement(
	          'div',
	          { className: 'date-field align-self-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mr-1 min-width-35px text-md-right align-self-center' },
	              _react2.default.createElement(
	                'label',
	                { className: 'margin_bottom_0' },
	                _language2.default.LC().FROM
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'align-self-center w-100 pr-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'datepicker_wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ico_box' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                    alt: '',
	                    width: '14'
	                  })
	                ),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  selected: startDate,
	                  onChange: function onChange(e) {
	                    return isDateHandleChange(e, 'startDate');
	                  },
	                  placeholderText: 'Select date',
	                  width: '100%'
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-field align-self-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mr-1 min-width-35px text-md-center align-self-center' },
	              _react2.default.createElement(
	                'label',
	                { className: 'margin_bottom_0' },
	                ' ',
	                _language2.default.LC().TO
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'align-self-center w-100 pr-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'datepicker_wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ico_box' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                    alt: '',
	                    width: '14'
	                  })
	                ),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  placeholderText: 'Select date',
	                  width: '100%',
	                  selected: endDate,
	                  minDate: startDate,
	                  onChange: function onChange(e) {
	                    return isDateHandleChange(e, 'endDate');
	                  }
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mx-auto text-md-center align-self-center', id: 'Tooltip-' + 3 },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-circle btn-refresh cursor-pointer ' + (!startDate || !endDate ? 'disabled' : ''),
	              onClick: function onClick() {
	                return resetDate();
	              }
	            },
	            _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true' }),
	            _react2.default.createElement(
	              _reactstrap.Tooltip,
	              {
	                placement: 'top',
	                isOpen: tooltipOpen,
	                target: 'Tooltip-' + 3,
	                toggle: function toggle() {
	                  return isTooltipToggle();
	                }
	              },
	              _react2.default.createElement(
	                'p',
	                { className: 'tooltip_text' },
	                content
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'reset' },
	              'Reset'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = DashboardDateFilter;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardHeader = function DashboardHeader(_ref) {
	  var title = _ref.title;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'section_head' },
	      title
	    )
	  );
	};
	
	exports.default = DashboardHeader;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditReportModalBody = function EditReportModalBody(_ref) {
	  var onReportEditSubmit = _ref.onReportEditSubmit,
	      onReportEditModalToggle = _ref.onReportEditModalToggle,
	      reportComment = _ref.reportComment,
	      onReportCommentChange = _ref.onReportCommentChange,
	      _ref$isReportErrorMes = _ref.isReportErrorMessageDisplay,
	      isReportErrorMessageDisplay = _ref$isReportErrorMes === undefined ? 'd-none' : _ref$isReportErrorMes,
	      _ref$reportErrorMessa = _ref.reportErrorMessage,
	      reportErrorMessage = _ref$reportErrorMessa === undefined ? '' : _ref$reportErrorMessa;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-block' },
	    _react2.default.createElement(
	      'form',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 margin_bottom_10' },
	          _react2.default.createElement('textarea', {
	            id: 'comment',
	            name: 'reportComment',
	            rows: '6',
	            className: 'form-control',
	            placeholder: 'Content..',
	            onChange: function onChange(e) {
	              return onReportCommentChange(e);
	            },
	            value: reportComment
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: isReportErrorMessageDisplay + ' text-danger' },
	            reportErrorMessage
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 d-flex' },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick(e) {
	                return onReportEditSubmit(e);
	              },
	              className: 'btn btn-primary active pointer_class'
	            },
	            ' ',
	            'Update'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-danger active pointer_class margin_left_10',
	              onClick: function onClick() {
	                return onReportEditModalToggle();
	              }
	            },
	            ' ',
	            'Cancel'
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = EditReportModalBody;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Tooltip = __webpack_require__(188);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PerformanceGraph = function PerformanceGraph(_ref) {
	  var _ref$headText = _ref.headText,
	      headText = _ref$headText === undefined ? '' : _ref$headText,
	      _ref$tooltipContent = _ref.tooltipContent,
	      tooltipContent = _ref$tooltipContent === undefined ? '' : _ref$tooltipContent,
	      _ref$tooltipPlace = _ref.tooltipPlace,
	      tooltipPlace = _ref$tooltipPlace === undefined ? 'left' : _ref$tooltipPlace,
	      _ref$PerformanceGraph = _ref.PerformanceGraphLoader,
	      PerformanceGraphLoader = _ref$PerformanceGraph === undefined ? 'show_block' : _ref$PerformanceGraph,
	      barGraphData = _ref.barGraphData,
	      tooltipOpen = _ref.tooltipOpen;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card-header' },
	      headText,
	      _react2.default.createElement(
	        'div',
	        { className: 'card-actions card_action_tooltip float-right' },
	        _react2.default.createElement(_Tooltip2.default, {
	          key: '0',
	          tooltipId: '0',
	          content: tooltipContent,
	          place_tip: tooltipPlace,
	          tooltipOpen: tooltipOpen
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-block' },
	      _react2.default.createElement(
	        'div',
	        { className: 'main_loader  ' + PerformanceGraphLoader },
	        _react2.default.createElement(
	          'div',
	          { className: 'loader-mid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block-loader' },
	            _react2.default.createElement(_loader2.default, null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'chart-wrapper performance-chart-wrapper' },
	        barGraphData.labels && _react2.default.createElement(_reactChartjs.Bar, {
	          data: barGraphData,
	          options: Object.assign({
	            maintainAspectRatio: false
	          }, _constant.Y_AXIS_SCALES, {
	            tooltips: {
	              callbacks: {
	                label: function label(tooltipItem, data) {
	                  return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                }
	              }
	            }
	          })
	        })
	      )
	    )
	  );
	};
	
	exports.default = PerformanceGraph;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Tooltip = __webpack_require__(188);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function ProgressBar(_ref) {
	  var _ref$headerName = _ref.headerName,
	      headerName = _ref$headerName === undefined ? '' : _ref$headerName,
	      _ref$tooltipContent = _ref.tooltipContent,
	      tooltipContent = _ref$tooltipContent === undefined ? '' : _ref$tooltipContent,
	      _ref$tooltipPlace = _ref.tooltipPlace,
	      tooltipPlace = _ref$tooltipPlace === undefined ? '' : _ref$tooltipPlace,
	      _ref$tooltipOpen = _ref.tooltipOpen,
	      tooltipOpen = _ref$tooltipOpen === undefined ? '' : _ref$tooltipOpen,
	      _ref$ProgressBarData = _ref.ProgressBarData,
	      ProgressBarData = _ref$ProgressBarData === undefined ? [] : _ref$ProgressBarData,
	      _ref$progressBarLoade = _ref.progressBarLoader,
	      progressBarLoader = _ref$progressBarLoade === undefined ? true : _ref$progressBarLoade,
	      _ref$ProgressBarTable = _ref.ProgressBarTables,
	      ProgressBarTables = _ref$ProgressBarTable === undefined ? '' : _ref$ProgressBarTable;
	
	  var progressBarItem = void 0;
	  var questionModel = ProgressBarTables.questionModel,
	      questionStatsModel = ProgressBarTables.questionStatsModel;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card-header' },
	      headerName,
	      _react2.default.createElement(
	        'div',
	        { className: 'card-actions card_action_tooltip float-right' },
	        _react2.default.createElement(_Tooltip2.default, {
	          key: '1',
	          tooltipId: '1',
	          content: tooltipContent,
	          place_tip: tooltipPlace,
	          tooltipOpen: tooltipOpen
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: '' },
	      _react2.default.createElement(
	        'table',
	        { className: 'table table-hover mb-0 compress_table' },
	        progressBarLoader ? _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        ) : _react2.default.createElement(
	          'tbody',
	          null,
	          ProgressBarData.map(function (item, index) {
	            progressBarItem = Math.round(item[questionModel + '.' + questionStatsModel + '.attemptCount'] / item[questionModel + '.questionsCount'] * 100);
	            if (progressBarItem < 1) {
	              progressBarItem = 1;
	            }
	            return _react2.default.createElement(
	              'tr',
	              { key: index },
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'question_count' },
	                    'Q.',
	                    index + 1
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'question_bar' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      item.chapterName
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'bar_wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactstrap.Progress, {
	                          className: 'progress-xs',
	                          color: 'info',
	                          value: progressBarItem,
	                          style: { width: progressBarItem + '%' }
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	exports.default = ProgressBar;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabActionButton = function TabActionButton(_ref) {
	  var _ref$tooltipText = _ref.tooltipText,
	      tooltipText = _ref$tooltipText === undefined ? '' : _ref$tooltipText,
	      _ref$buttonCss = _ref.buttonCss,
	      buttonCss = _ref$buttonCss === undefined ? '' : _ref$buttonCss,
	      _ref$buttonColor = _ref.buttonColor,
	      buttonColor = _ref$buttonColor === undefined ? '' : _ref$buttonColor,
	      _ref$OnActionButtonCl = _ref.OnActionButtonClick,
	      OnActionButtonClick = _ref$OnActionButtonCl === undefined ? '' : _ref$OnActionButtonCl,
	      _ref$items = _ref.items,
	      items = _ref$items === undefined ? '' : _ref$items,
	      _ref$apiService = _ref.apiService,
	      apiService = _ref$apiService === undefined ? '' : _ref$apiService;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      ' ',
	      tooltipText,
	      ' '
	    ),
	    _react2.default.createElement(
	      'i',
	      {
	        onClick: function onClick() {
	          return OnActionButtonClick(apiService, items);
	        },
	        className: buttonCss,
	        style: { color: buttonColor }
	      },
	      ' '
	    )
	  );
	};
	exports.default = TabActionButton;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _ModalComponent = __webpack_require__(263);
	
	var _ModalComponent2 = _interopRequireDefault(_ModalComponent);
	
	var _services = __webpack_require__(43);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _tabList = __webpack_require__(730);
	
	var _tabList2 = _interopRequireDefault(_tabList);
	
	var _EditReportModalBody = __webpack_require__(733);
	
	var _EditReportModalBody2 = _interopRequireDefault(_EditReportModalBody);
	
	var _TabActionButton = __webpack_require__(736);
	
	var _TabActionButton2 = _interopRequireDefault(_TabActionButton);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabList = function (_Component) {
	  _inherits(TabList, _Component);
	
	  function TabList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TabList);
	
	    var _this = _possibleConstructorReturn(this, (TabList.__proto__ || Object.getPrototypeOf(TabList)).call(this, props));
	
	    _this.onViewFeedbackModalToggle = function (_apiService, items) {
	      var willOpen = !_this.state.isViewFeedbackModalOpen;
	      _this.setState({
	        isViewFeedbackModalOpen: willOpen,
	        selectedFeedbackItemId: willOpen && items ? items.id : null
	      });
	    };
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, selectedExam, currentIndex;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, selectedExam = _this$state.selectedExam, currentIndex = _this$state.currentIndex;
	
	              _tabList2.default[selectedExam].length && _this.getData(currentIndex);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(index) {
	        var selectedExam, storageSession, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                selectedExam = _this.state.selectedExam;
	
	                _this.setState({ isLoading: true });
	                storageSession = _this.state.storageSession;
	                data = {
	                  token: storageSession.token,
	                  idname: storageSession.idname
	                };
	
	                _this.setState({
	                  currentIndex: index,
	                  tabsData: []
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                  var currentIndex, section, tabsData;
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          currentIndex = _this.state.currentIndex, section = _this.props.section;
	                          _context2.next = 3;
	                          return _services2.default[_tabList2.default[selectedExam][currentIndex][section]](data);
	
	                        case 3:
	                          tabsData = _context2.sent;
	
	                          _this.setState({
	                            tabsData: tabsData.success ? tabsData.data : [],
	                            isLoading: false
	                          });
	
	                        case 5:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2);
	                })));
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onView = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(apiService, items) {
	        var _this$state2, currentIndex, selectedExam, storageSession, getTabsData, data, getParameterList;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$state2 = _this.state, currentIndex = _this$state2.currentIndex, selectedExam = _this$state2.selectedExam, storageSession = _this$state2.storageSession;
	                getTabsData = _tabList2.default[selectedExam][currentIndex];
	                data = {
	                  token: storageSession.token,
	                  idname: storageSession.idname
	                };
	                _context4.next = 5;
	                return _services2.default[apiService](Object.assign({}, items, data));
	
	              case 5:
	                getParameterList = _context4.sent;
	                _context4.t0 = _this.context.router;
	                _context4.next = 9;
	                return _this.onNavigateTo(getTabsData.redirectionPath, getParameterList.data);
	
	              case 9:
	                _context4.t1 = _context4.sent;
	                _context4.t2 = {
	                  pathname: _context4.t1
	                };
	
	                _context4.t0.push.call(_context4.t0, _context4.t2);
	
	              case 12:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onNavigateTo = function (path, parameterList) {
	      // console.log('path', path, parameterList);
	      var navigateURL = path;
	      for (var key in parameterList) {
	        navigateURL = navigateURL.replace(':' + key, parameterList[key]);
	      }
	      return navigateURL;
	    };
	
	    _this.onDelete = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(apiService, items) {
	        var _this$state3, storageSession, currentIndex, id, item_id, flash_card, data, payload, tabsData;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this$state3 = _this.state, storageSession = _this$state3.storageSession, currentIndex = _this$state3.currentIndex;
	                id = items.id, item_id = items.item_id, flash_card = items.flash_card;
	                data = {
	                  token: storageSession.token,
	                  idname: storageSession.idname
	                };
	
	                if (!flash_card) {
	                  _context5.next = 7;
	                  break;
	                }
	
	                payload = {
	                  id_name: storageSession.idname,
	                  token: storageSession.token,
	                  type: apiService === 'deleteSavedQuestion' ? 'question' : 'video',
	                  question_type: '',
	                  exam: 'esg',
	                  level: '',
	                  item_id: item_id
	                };
	                _context5.next = 7;
	                return _services2.default['deleteFlashCard'](payload);
	
	              case 7:
	                _context5.next = 9;
	                return _services2.default[apiService](Object.assign({}, data, { id: id }));
	
	              case 9:
	                tabsData = _context5.sent;
	
	                if (tabsData.success) {
	                  _this.getData(currentIndex);
	                  _this.setState({
	                    apiService: '',
	                    reportedItem: '',
	                    reportModelOpen: false
	                  });
	                } else {
	                  _this.setState({
	                    apiService: '',
	                    reportedItem: '',
	                    reportModelOpen: false
	                  });
	                }
	
	              case 11:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlertReport = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(apiService, items) {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this.setState({
	                  reportModelOpen: !_this.state.reportModelOpen,
	                  apiService: apiService,
	                  reportedItem: items
	                });
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.onReportCommentChange = function (event) {
	      _this.setState({ reportComment: event.target.value, isReportErrorMessageDisplay: 'd-none' });
	    };
	
	    _this.onReportEditModalToggle = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(apiService, items) {
	        var isReportEditModalOpen, comment, tableKey, tableName, getReportHeaderText, reportModalHeader;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                isReportEditModalOpen = _this.state.isReportEditModalOpen;
	
	                if (!isReportEditModalOpen) {
	                  comment = items.comment, tableKey = items.tableKey, tableName = items.tableName;
	                  getReportHeaderText = items[tableName][tableKey];
	                  reportModalHeader = getReportHeaderText.length > 150 ? ' ' + getReportHeaderText.substr(0, 100) + '...' : ' ' + getReportHeaderText;
	
	
	                  _this.setState({
	                    reportComment: comment,
	                    reportEditItem: Object.assign({}, items, { apiService: apiService }),
	                    reportEditHeader: reportModalHeader,
	                    isReportErrorMessageDisplay: 'd-none'
	                  }, function () {
	                    _this.setState({
	                      isReportEditModalOpen: !_this.state.isReportEditModalOpen,
	                      isReportErrorMessageDisplay: 'd-none'
	                    });
	                  });
	                } else {
	                  _this.setState({
	                    isReportEditModalOpen: !_this.state.isReportEditModalOpen,
	                    reportEditItem: {},
	                    reportComment: '',
	                    reportEditHeader: '',
	                    isReportErrorMessageDisplay: 'd-block'
	                  });
	                }
	
	              case 2:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x8, _x9) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.onReportEditSubmit = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(event) {
	        var _this$state4, reportComment, reportEditItem, storageSession, currentIndex, apiService, id, data, editReport;
	
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                event.preventDefault();
	                _this$state4 = _this.state, reportComment = _this$state4.reportComment, reportEditItem = _this$state4.reportEditItem, storageSession = _this$state4.storageSession, currentIndex = _this$state4.currentIndex;
	                apiService = reportEditItem.apiService, id = reportEditItem.id;
	
	                if (!reportComment.trim().length) {
	                  _context8.next = 11;
	                  break;
	                }
	
	                data = {
	                  token: storageSession.token,
	                  idname: storageSession.idname
	                };
	                _context8.next = 7;
	                return _services2.default[apiService](Object.assign({}, data, { id: id, comment: reportComment }));
	
	              case 7:
	                editReport = _context8.sent;
	
	                if (editReport.success) {
	                  _this.setState({
	                    isReportEditModalOpen: !_this.state.isReportEditModalOpen,
	                    isReportErrorMessageDisplay: 'd-none',
	                    reportEditItem: {},
	                    reportComment: '',
	                    reportEditHeader: ''
	                  }, function () {
	                    _this.getData(currentIndex);
	                  });
	                }
	                _context8.next = 12;
	                break;
	
	              case 11:
	                _this.setState({
	                  isReportErrorMessageDisplay: 'd-block',
	                  reportEditItem: {}
	                });
	
	              case 12:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x10) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      TabHeader: '',
	      currentIndex: 0,
	      storageSession: JSON.parse(localStorage.getItem('localstorageval')),
	      tabsData: [],
	      isLoading: false,
	      selectedExam: localStorage.getItem('selectedmenu'),
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      editCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewFeedbackCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      apiService: '',
	      reportedItem: '',
	      reportComment: '',
	      reportEditHeader: '',
	      reportEditItem: {},
	      reportModelOpen: false,
	      isReportEditModalOpen: false,
	      isReportErrorMessageDisplay: 'd-none',
	      isViewFeedbackModalOpen: false,
	      selectedFeedbackItemId: null
	    };
	    return _this;
	  }
	
	  _createClass(TabList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          TabHeader = _props.TabHeader,
	          section = _props.section;
	      var _state = this.state,
	          currentIndex = _state.currentIndex,
	          tabsData = _state.tabsData,
	          isLoading = _state.isLoading,
	          selectedExam = _state.selectedExam,
	          deleteCSS = _state.deleteCSS,
	          viewCSS = _state.viewCSS,
	          editCSS = _state.editCSS,
	          viewFeedbackCSS = _state.viewFeedbackCSS,
	          reportModelOpen = _state.reportModelOpen,
	          apiService = _state.apiService,
	          reportedItem = _state.reportedItem,
	          isReportEditModalOpen = _state.isReportEditModalOpen,
	          isReportErrorMessageDisplay = _state.isReportErrorMessageDisplay,
	          reportComment = _state.reportComment,
	          reportEditHeader = _state.reportEditHeader,
	          isViewFeedbackModalOpen = _state.isViewFeedbackModalOpen,
	          selectedFeedbackItemId = _state.selectedFeedbackItemId;
	
	      var showTabsData = _tabList2.default[selectedExam][currentIndex];
	      var savedItemTitle = showTabsData.savedItemTitle,
	          saveItemTableName = showTabsData.saveItemTableName,
	          savedItemTableKey = showTabsData.savedItemTableKey,
	          reportedItemTableKey = showTabsData.reportedItemTableKey,
	          idFieldName = showTabsData.idFieldName;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'padding_bottom_30' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head padding_bottom_30' },
	            TabHeader
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex header-card-dashboard tab-header-wrap' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'dashboard-card-header-tab' },
	              _tabList2.default[selectedExam].map(function (tab, index) {
	                if (!_tabList2.default[selectedExam][index][section]) {
	                  return null;
	                }
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: tab.label,
	                    onClick: function onClick() {
	                      _this3.getData(index);
	                    },
	                    className: currentIndex === index ? 'active' : ''
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    tab.label
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card tab-body-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block dashboard-cards-scroll my-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'chart-wrapper' },
	                isLoading ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block-loader' },
	                  _react2.default.createElement(_loader2.default, null)
	                ) : tabsData.length ? tabsData.map(function (items, index) {
	                  var topic = items[saveItemTableName + '.' + savedItemTableKey] ? items[saveItemTableName + '.' + savedItemTableKey] : items['' + savedItemTableKey] ? items['' + savedItemTableKey] : '';
	
	                  return _react2.default.createElement(
	                    'div',
	                    { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	                    section === 'reportAPIService' && _react2.default.createElement(
	                      'div',
	                      { className: 'mb-1' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          'Ticket ID',
	                          ': '
	                        ),
	                        ' ',
	                        items.id
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        {
	                          className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                        },
	                        _react2.default.createElement(
	                          'strong',
	                          { className: 'text-capitalize' },
	                          items.status === 'resolved' ? 'resolved' : 'pending'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          savedItemTitle,
	                          ': '
	                        ),
	                        items[idFieldName || 'id']
	                      ),
	                      _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: 'Delete',
	                        buttonCss: deleteCSS,
	                        buttonColor: '#f51a00',
	                        apiService: section === 'reportAPIService' ? showTabsData['reportDeleteAPIService'] : showTabsData['saveItemDeleteAPIService'],
	                        OnActionButtonClick: _this3.toggleAlertReport,
	                        items: items
	                      }),
	                      items.isSend && (items.answer || items.reply) && _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: 'View feedback',
	                        buttonCss: viewFeedbackCSS,
	                        buttonColor: '#1f8ceb',
	                        apiService: showTabsData['editAPIService'],
	                        OnActionButtonClick: _this3.onViewFeedbackModalToggle,
	                        items: Object.assign({}, items, {
	                          tableName: saveItemTableName,
	                          tableKey: savedItemTableKey
	                        })
	                      }),
	                      _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: 'View',
	                        buttonCss: viewCSS,
	                        buttonColor: '#1f8ceb',
	                        apiService: showTabsData['viewItemAPIService'],
	                        OnActionButtonClick: _this3.onView,
	                        items: items
	                      }),
	                      !items.isSend && !items.answer && items.status !== 'resolved' && section === 'reportAPIService' ? _react2.default.createElement(_TabActionButton2.default, {
	                        tooltipText: 'Edit report',
	                        buttonCss: editCSS,
	                        buttonColor: '#1f8ceb',
	                        apiService: showTabsData['editAPIService'],
	                        OnActionButtonClick: _this3.onReportEditModalToggle,
	                        items: Object.assign({}, items, {
	                          tableName: saveItemTableName,
	                          tableKey: savedItemTableKey
	                        })
	                      }) : null
	                    ),
	                    topic && _react2.default.createElement(
	                      'p',
	                      { className: 'mt-1' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Topic',
	                        ': '
	                      ),
	                      (0, _function.renderHTMLContent)(topic && topic.length > 150 ? topic.substr(0, 100) + '...' : topic, 'span')
	                    ),
	                    items.flash_card && _react2.default.createElement(
	                      'p',
	                      { className: 'mt-1' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Note',
	                        ': '
	                      ),
	                      (0, _function.renderHTMLContent)(items.flash_card && items.flash_card.length > 150 ? items.flash_card.substr(0, 100) + '...' : items.flash_card, 'span')
	                    ),
	                    section === 'reportAPIService' && _react2.default.createElement(
	                      'p',
	                      { className: 'mt-1' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Report',
	                        ': '
	                      ),
	                      (0, _function.renderHTMLContent)(items[reportedItemTableKey].length > 150 ? items[reportedItemTableKey].substr(0, 100) + '...' : items[reportedItemTableKey], 'span')
	                    ),
	                    _react2.default.createElement(
	                      _ModalComponent2.default,
	                      {
	                        isModalOpen: isReportEditModalOpen,
	                        modalHeaderText: reportEditHeader,
	                        onModalToggle: _this3.onReportEditModalToggle
	                      },
	                      _react2.default.createElement(_EditReportModalBody2.default, {
	                        onReportEditSubmit: _this3.onReportEditSubmit,
	                        onReportEditModalToggle: _this3.onReportEditModalToggle,
	                        reportComment: reportComment,
	                        onReportCommentChange: _this3.onReportCommentChange,
	                        isReportErrorMessageDisplay: isReportErrorMessageDisplay,
	                        reportErrorMessage: 'Report can\'t be empty'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Modal,
	                      {
	                        isOpen: isViewFeedbackModalOpen && selectedFeedbackItemId === items.id,
	                        toggle: _this3.onViewFeedbackModalToggle,
	                        className: 'modal-primary '
	                      },
	                      _react2.default.createElement(
	                        _reactstrap.ModalHeader,
	                        null,
	                        'Q. ' + items.id,
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'close',
	                            'aria-label': 'Close',
	                            onClick: _this3.onViewFeedbackModalToggle
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '\xD7'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.ModalBody,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-center' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'margin_bottom_20' },
	                            (0, _function.renderHTMLContent)(items.reply || items.answer || '', 'span')
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : _react2.default.createElement(
	                  'div',
	                  { className: 'text-center' },
	                  'No data found'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: reportModelOpen,
	            toggle: this.toggleAlertReport,
	            className: 'modal-primary '
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'Alert',
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'close',
	                'aria-label': 'Close',
	                onClick: this.toggleAlertReport
	              },
	              _react2.default.createElement(
	                'span',
	                { 'aria-hidden': 'true' },
	                '\xD7'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Are you sure you want to delete this?'
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-sm btn-primary',
	                  color: 'primary',
	                  onClick: function onClick() {
	                    return _this3.onDelete(apiService, reportedItem);
	                  }
	                },
	                'OK'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TabList;
	}(_react.Component);
	
	TabList.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = TabList;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESGDashboard = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _services = __webpack_require__(43);
	
	var _GraphDataCalculation = __webpack_require__(729);
	
	var _GraphDataCalculation2 = _interopRequireDefault(_GraphDataCalculation);
	
	var _DashboardDateFilter = __webpack_require__(731);
	
	var _DashboardDateFilter2 = _interopRequireDefault(_DashboardDateFilter);
	
	var _DashboardHeader = __webpack_require__(732);
	
	var _DashboardHeader2 = _interopRequireDefault(_DashboardHeader);
	
	var _PerformanceGraph = __webpack_require__(734);
	
	var _PerformanceGraph2 = _interopRequireDefault(_PerformanceGraph);
	
	var _ProgressBar = __webpack_require__(735);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _TabList = __webpack_require__(737);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESGDashboard = exports.ESGDashboard = function (_Component) {
	  _inherits(ESGDashboard, _Component);
	
	  function ESGDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ESGDashboard);
	
	    var _this = _possibleConstructorReturn(this, (ESGDashboard.__proto__ || Object.getPrototypeOf(ESGDashboard)).call(this, props));
	
	    _this.getQuestionProgressBar = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var result;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ progressBarLoader: true });
	                _context.next = 3;
	                return (0, _services.fetchQuestionProgressBar)(data);
	
	              case 3:
	                result = _context.sent;
	
	                if (result.success) {
	                  _this.setState({
	                    ProgressBarData: result.questionProgressBarData,
	                    ProgressBarTables: result.tables,
	                    progressBarLoader: false
	                  });
	                }
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getBarGraph = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var result, usersBarGraphData;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _services.fetchUsersBarGraph)(data);
	
	              case 2:
	                result = _context2.sent;
	
	                if (!result.success) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                _context2.next = 6;
	                return (0, _GraphDataCalculation2.default)(result.userAttemptedAndAnsweredCount);
	
	              case 6:
	                usersBarGraphData = _context2.sent;
	
	                _this.setState({ usersBarGraphData: usersBarGraphData });
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getTotalUsersBarGraph = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var result, totalUsers, barGraphLabel;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return (0, _services.fetchTotalUsersBarGraph)(data);
	
	              case 2:
	                result = _context3.sent;
	
	                if (!result.success) {
	                  _context3.next = 11;
	                  break;
	                }
	
	                _context3.next = 6;
	                return (0, _GraphDataCalculation2.default)(result.attemptedCount);
	
	              case 6:
	                totalUsers = _context3.sent;
	                _context3.next = 9;
	                return result.attemptedCount.map(function (chapters) {
	                  return chapters.chapterName.substring(0, 14);
	                });
	
	              case 9:
	                barGraphLabel = _context3.sent;
	
	                _this.setState({
	                  totalUsersBarGraphData: totalUsers,
	                  barGraphLabel: barGraphLabel,
	                  PerformanceGraphLoader: 'hide_block'
	                });
	
	              case 11:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.isDateHandleChange = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(date, name) {
	        var startDate;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                startDate = _this.state.startDate;
	
	                if (name === 'startDate') {
	                  _this.setState({
	                    startDate: date,
	                    endDate: '',
	                    formattedEndDate: '',
	                    formattedStartDate: (0, _moment2.default)(date).format('YYYY-MM-DD')
	                  });
	                } else {
	                  if (startDate !== '') _this.setState({
	                    endDate: date,
	                    formattedEndDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	                    PerformanceGraphLoader: 'show_block'
	                  });
	                }
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onResetDate = function () {
	      var _this$state = _this.state,
	          startDate = _this$state.startDate,
	          endDate = _this$state.endDate;
	
	      if (startDate && endDate) {
	        _this.setState({
	          startDate: '',
	          endDate: '',
	          formattedStartDate: '',
	          formattedEndDate: ''
	        }, function () {
	          var _this$state2 = _this.state,
	              storageSession = _this$state2.storageSession,
	              formattedStartDate = _this$state2.formattedStartDate,
	              formattedEndDate = _this$state2.formattedEndDate;
	
	          var data = {
	            token: storageSession['token'],
	            idname: storageSession['idname'],
	            startDate: formattedStartDate,
	            endDate: formattedEndDate
	          };
	          _this.getBarGraph(data);
	          _this.getTotalUsersBarGraph(data);
	          _this.getQuestionProgressBar(data);
	        });
	      }
	    };
	
	    _this.isTooltipToggle = function () {
	      _this.setState({ tooltipOpen: !_this.state.tooltipOpen });
	    };
	
	    _this.state = {
	      storageSession: JSON.parse(localStorage.getItem('localstorageval')),
	      startDate: '',
	      endDate: '',
	      formattedEndDate: '',
	      formattedStartDate: '',
	      tooltipOpen: false,
	      ProgressBarData: [],
	      progressBarLoader: false
	    };
	    return _this;
	  }
	
	  _createClass(ESGDashboard, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _state, storageSession, formattedStartDate, formattedEndDate, data;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _state = this.state, storageSession = _state.storageSession, formattedStartDate = _state.formattedStartDate, formattedEndDate = _state.formattedEndDate;
	                data = {
	                  token: storageSession['token'],
	                  idname: storageSession['idname'],
	                  startDate: formattedStartDate,
	                  endDate: formattedEndDate
	                };
	
	                this.setState({ PerformanceGraphLoader: 'show_block' });
	                this.getBarGraph(data);
	                this.getTotalUsersBarGraph(data);
	                this.getQuestionProgressBar(data);
	
	              case 6:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(prevProps, prevState) {
	        var _state2, storageSession, formattedStartDate, formattedEndDate, data;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _state2 = this.state, storageSession = _state2.storageSession, formattedStartDate = _state2.formattedStartDate, formattedEndDate = _state2.formattedEndDate;
	
	                if (formattedStartDate && formattedEndDate && formattedEndDate !== prevState.formattedEndDate) {
	                  data = {
	                    token: storageSession['token'],
	                    idname: storageSession['idname'],
	                    startDate: formattedStartDate,
	                    endDate: formattedEndDate
	                  };
	
	                  this.getBarGraph(data);
	                  this.getTotalUsersBarGraph(data);
	                  this.getQuestionProgressBar(data);
	                }
	
	              case 2:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidUpdate(_x6, _x7) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state3 = this.state,
	          startDate = _state3.startDate,
	          endDate = _state3.endDate,
	          tooltipOpen = _state3.tooltipOpen,
	          totalUsersBarGraphData = _state3.totalUsersBarGraphData,
	          barGraphLabel = _state3.barGraphLabel,
	          performanceGraphLoader = _state3.PerformanceGraphLoader,
	          usersBarGraphData = _state3.usersBarGraphData,
	          ProgressBarData = _state3.ProgressBarData,
	          progressBarLoader = _state3.progressBarLoader,
	          ProgressBarTables = _state3.ProgressBarTables;
	
	      var barGraphData = {
	        labels: barGraphLabel,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: usersBarGraphData
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: totalUsersBarGraphData
	        }]
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(_EmailResubscribe2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(_DashboardHeader2.default, { title: 'ESG Dashboard' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-8' },
	            _react2.default.createElement(_DashboardDateFilter2.default, {
	              startDate: startDate,
	              endDate: endDate,
	              isDateHandleChange: this.isDateHandleChange,
	              resetDate: this.onResetDate,
	              isTooltipToggle: this.isTooltipToggle,
	              tooltipOpen: tooltipOpen,
	              content: 'Reset date'
	            }),
	            _react2.default.createElement(_PerformanceGraph2.default, {
	              headText: _language2.default.LC().PERFORMANCE,
	              tooltipContent: _language2.default.LC().SEPARATE_YOUR_RESULT,
	              tooltipPlace: 'left',
	              PerformanceGraphLoader: performanceGraphLoader,
	              barGraphData: barGraphData
	            }),
	            _react2.default.createElement(_TabList2.default, {
	              section: 'favAPIService',
	              TabHeader: _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	            }),
	            _react2.default.createElement(_TabList2.default, { section: 'reportAPIService', TabHeader: _language2.default.LC().MY_REPORTS })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-4' },
	            _react2.default.createElement(_ProgressBar2.default, {
	              headerName: _language2.default.LC().QUESTION_PROGRESS,
	              tooltipContent: _language2.default.LC().YOU_CAN_SEE,
	              tooltipPlace: 'left',
	              ProgressBarData: ProgressBarData,
	              progressBarLoader: progressBarLoader,
	              ProgressBarTables: ProgressBarTables
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ESGDashboard;
	}(_react.Component);
	
	exports.default = ESGDashboard;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESGNotes = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Chapter = __webpack_require__(269);
	
	var _Chapter2 = _interopRequireDefault(_Chapter);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESGNotes = exports.ESGNotes = function (_Component) {
	  _inherits(ESGNotes, _Component);
	
	  function ESGNotes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ESGNotes);
	
	    var _this = _possibleConstructorReturn(this, (ESGNotes.__proto__ || Object.getPrototypeOf(ESGNotes)).call(this, props));
	
	    _this.fetchNotesPDFById = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item) {
	        var myWindow;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                myWindow = window.open(item.pdf_file);
	
	                myWindow.focus();
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ESGNotes, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(_Header2.default, { title: _language2.default.LC().NOTES }),
	        _react2.default.createElement(_Chapter2.default, Object.assign({
	          headerImage: '/img/notes/notes_icon1.svg',
	          apiEndpoint: '/esg/notes/allPdf',
	          imageWidth: 40,
	          callingComponent: 'notes',
	          fetchNotesPDFById: this.fetchNotesPDFById,
	          replacementFields: { name: 'essay_ques_name' }
	        }, this.props))
	      );
	    }
	  }]);
	
	  return ESGNotes;
	}(_react.Component);
	
	exports.default = ESGNotes;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BeginQuestion = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _CustomCard = __webpack_require__(96);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CardBody = __webpack_require__(118);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _CardHeader = __webpack_require__(119);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _Report = __webpack_require__(189);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _Timer = __webpack_require__(749);
	
	var _Timer2 = _interopRequireDefault(_Timer);
	
	var _services = __webpack_require__(43);
	
	var _QuestionBankFooter = __webpack_require__(743);
	
	var _QuestionBankFooter2 = _interopRequireDefault(_QuestionBankFooter);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeginQuestion = exports.BeginQuestion = function (_Component) {
	  _inherits(BeginQuestion, _Component);
	
	  function BeginQuestion(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, BeginQuestion);
	
	    var _this = _possibleConstructorReturn(this, (BeginQuestion.__proto__ || Object.getPrototypeOf(BeginQuestion)).call(this, props));
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, currentIndex, questionData, newIndex;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, currentIndex = _this$state.currentIndex, questionData = _this$state.questionData;
	
	              if (!(currentIndex > 0)) {
	                _context.next = 7;
	                break;
	              }
	
	              newIndex = currentIndex - 1;
	              // Update URL for navigation
	
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.ESG_QUESTION_BANK_VIEW_QUE.replace(':chapterId', _this.props.params.chapterId).replace(':id', questionData[newIndex].id).replace(':index', newIndex)
	              });
	              _context.next = 6;
	              return _this.onSetCurrentQuestion(questionData, newIndex);
	
	            case 6:
	              _this.setState({
	                showReportSection: false
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state2, currentIndex, questionData, newIndex;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state2 = _this.state, currentIndex = _this$state2.currentIndex, questionData = _this$state2.questionData;
	
	              if (!(currentIndex < questionData.length - 1)) {
	                _context2.next = 7;
	                break;
	              }
	
	              newIndex = currentIndex + 1;
	              // Update URL for navigation
	
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.ESG_QUESTION_BANK_VIEW_QUE.replace(':chapterId', _this.props.params.chapterId).replace(':id', questionData[newIndex].id).replace(':index', newIndex)
	              });
	              _context2.next = 6;
	              return _this.onSetCurrentQuestion(questionData, newIndex);
	
	            case 6:
	              _this.setState({
	                showReportSection: false
	              });
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getTimerValue = function (timerValue) {
	      _this.timerValue = timerValue;
	    };
	
	    _this.validateQuestion = function () {
	      var _this$state3 = _this.state,
	          selectedChoice = _this$state3.selectedChoice,
	          currentQuestion = _this$state3.currentQuestion,
	          questionData = _this$state3.questionData,
	          currentIndex = _this$state3.currentIndex;
	
	
	      if (selectedChoice) {
	        var right_answer = 0;
	        if (currentQuestion.correctChoice === selectedChoice) {
	          right_answer = 1;
	          _this.setState({ textColor: 'text_success', result: 'Correct' });
	        } else {
	          _this.setState({ textColor: 'text_failure', result: 'Incorrect' });
	        }
	
	        var data = {
	          time_done: _this.timerValue,
	          question_id: currentQuestion.id,
	          right_answer: right_answer,
	          selected_choice: selectedChoice
	        };
	
	        (0, _services.saveQuestionStats)(data).then(function (response) {
	          if (response.success) {
	            var existingStats = currentQuestion.esg_question_stats && currentQuestion.esg_question_stats[0] || {};
	            var updatedQuestion = Object.assign({}, currentQuestion, {
	              selectedChoice: selectedChoice,
	              esg_question_stats: [Object.assign({}, existingStats, {
	                time_done: _this.timerValue,
	                selected_choice: selectedChoice,
	                right_answer: right_answer,
	                id: response.id || existingStats && existingStats.id,
	                question_id: currentQuestion.id,
	                user_id: existingStats.user_id
	              })]
	            });
	            var updatedQuestionData = [].concat(_toConsumableArray(questionData));
	            updatedQuestionData[currentIndex] = updatedQuestion;
	
	            _this.setState({
	              currentQuestion: updatedQuestion,
	              questionData: updatedQuestionData,
	              showAnswer: true,
	              stopTimer: true,
	              timeDone: _this.timerValue
	            });
	          }
	        });
	      }
	    };
	
	    _this.setAnswer = function (answer) {
	      _this.setState({
	        selectedChoice: answer[0]
	      });
	    };
	
	    _this.hideReportSection = function () {
	      _this.setState({ showReportSection: false });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.state = {
	      stopTimer: false,
	      questionData: [],
	      currentQuestion: null,
	      currentIndex: 0,
	      showReportSection: false,
	      isFlashCardHidden: true,
	      isLoading: true,
	      showAnswer: false,
	      selectedChoice: '',
	      chapterName: '',
	      textColor: '',
	      result: '',
	      correctChoice: '',
	      timeDone: 0
	    };
	    _this.timerValue = 0;
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(BeginQuestion, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var state, initialIndex, questionData, data, response, userId, questions, chapterResponse;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                state = this.props.location.state;
	                initialIndex = 0;
	
	                if (this.props.params && this.props.params.index) {
	                  initialIndex = parseInt(this.props.params.index, 10) || 0;
	                }
	
	                if (!(state && state.questionData && state.questionData.length)) {
	                  _context3.next = 11;
	                  break;
	                }
	
	                questionData = state.questionData;
	                _context3.next = 8;
	                return this.onSetCurrentQuestion(questionData, initialIndex);
	
	              case 8:
	                this.setState({ questionData: questionData, isLoading: false });
	                _context3.next = 28;
	                break;
	
	              case 11:
	                data = Object.assign({}, (0, _services.getTokenAndEmail)(), {
	                  chapterId: this.props.params.chapterId
	                });
	                _context3.next = 14;
	                return (0, _services.fetchQuestionsChapterWise)(data);
	
	              case 14:
	                response = _context3.sent;
	
	                if (!response.success) {
	                  _context3.next = 23;
	                  break;
	                }
	
	                userId = (0, _services.getTokenAndEmail)().user_id;
	                questions = response.question.map(function (q) {
	                  var userStats = q.esg_question_stats && q.esg_question_stats.find(function (stat) {
	                    return stat.user_id === userId;
	                  });
	                  var selectedChoice = userStats && userStats.selected_choice ? userStats.selected_choice : '';
	                  return Object.assign({}, q, { selectedChoice: selectedChoice });
	                });
	                _context3.next = 20;
	                return this.onSetCurrentQuestion(questions, initialIndex);
	
	              case 20:
	                this.setState({ questionData: questions, isLoading: false });
	                _context3.next = 24;
	                break;
	
	              case 23:
	                this.setState({ isLoading: false });
	
	              case 24:
	                _context3.next = 26;
	                return (0, _services.fetchChapterNameById)(data);
	
	              case 26:
	                chapterResponse = _context3.sent;
	
	                if (chapterResponse.success) {
	                  this.setState({ chapterName: chapterResponse.chapter.name });
	                }
	
	              case 28:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(prevProps) {
	        var newIndex;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(this.props.params.index !== prevProps.params.index && this.state.questionData.length > 0)) {
	                  _context4.next = 4;
	                  break;
	                }
	
	                newIndex = parseInt(this.props.params.index, 10) || 0;
	                _context4.next = 4;
	                return this.onSetCurrentQuestion(this.state.questionData, newIndex);
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate(_x) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	
	    // Helper to extract stats from esg_question_stats
	
	  }, {
	    key: 'getStatsFromQuestionStats',
	    value: function getStatsFromQuestionStats(stats, correctChoice) {
	      var selectedChoice = '';
	      var rightAnswer = '';
	      var answerStatus = '';
	      var timeDone = 0;
	      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.ESG);
	      if (stats && stats.length > 0 && isRevisionMode) {
	        selectedChoice = stats[0].selected_choice || '';
	        rightAnswer = stats[0].right_answer || '';
	        answerStatus = stats[0].id || '';
	        timeDone = stats[0].time_done || 0;
	      }
	      return { selectedChoice: selectedChoice, rightAnswer: rightAnswer, answerStatus: answerStatus, timeDone: timeDone };
	    }
	  }, {
	    key: 'onSetCurrentQuestion',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(questionsData, index) {
	        var currentIndex, currentQuestion, selectedChoice, rightAnswer, answerStatus, timeDone, stats, correctChoice, showAnswer, selected, isRevisionMode, choices, isChoiceCorrect;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                currentIndex = typeof index === 'number' ? index : 0;
	
	                if (typeof currentIndex !== 'number' || isNaN(currentIndex) || currentIndex < 0 || currentIndex >= questionsData.length) {
	                  currentIndex = 0;
	                }
	                currentQuestion = questionsData[currentIndex];
	                selectedChoice = currentQuestion.selectedChoice || '';
	                rightAnswer = '';
	                answerStatus = '';
	                timeDone = 0;
	
	
	                if (currentQuestion.esg_question_stats && currentQuestion.esg_question_stats.length > 0) {
	                  stats = this.getStatsFromQuestionStats(currentQuestion.esg_question_stats, currentQuestion.correctChoice);
	
	                  if (!selectedChoice) {
	                    selectedChoice = stats.selectedChoice;
	                  }
	                  rightAnswer = stats.rightAnswer;
	                  answerStatus = stats.answerStatus;
	                  timeDone = stats.timeDone;
	                }
	
	                correctChoice = currentQuestion.correctChoice || '';
	                showAnswer = false;
	                selected = '';
	                isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.ESG);
	
	
	                if (selectedChoice && isRevisionMode) {
	                  selected = selectedChoice;
	                  showAnswer = true;
	                } else if (answerStatus && isRevisionMode) {
	                  if (rightAnswer === 1) {
	                    selected = correctChoice;
	                    showAnswer = true;
	                  } else if (!rightAnswer) {
	                    choices = Object.keys(currentQuestion).filter(function (key) {
	                      return key.startsWith('choice') && key !== correctChoice;
	                    });
	
	                    selected = choices.length > 0 ? choices[0] : '';
	                    showAnswer = true;
	                  }
	                }
	
	                isChoiceCorrect = selected === correctChoice;
	
	                // Set timer value when initializing question
	
	                this.timerValue = timeDone;
	
	                this.setState({
	                  selectedChoice: selected,
	                  stopTimer: !!selected,
	                  showAnswer: showAnswer,
	                  currentIndex: currentIndex,
	                  currentQuestion: currentQuestion,
	                  correctChoice: correctChoice,
	                  textColor: isChoiceCorrect ? 'text_success' : 'text_failure',
	                  result: isChoiceCorrect ? 'Correct' : 'Incorrect',
	                  timeDone: timeDone
	                });
	
	              case 16:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function onSetCurrentQuestion(_x2, _x3) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return onSetCurrentQuestion;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          stopTimer = _state.stopTimer,
	          questionData = _state.questionData,
	          currentQuestion = _state.currentQuestion,
	          currentIndex = _state.currentIndex,
	          showReportSection = _state.showReportSection,
	          isLoading = _state.isLoading,
	          showAnswer = _state.showAnswer,
	          selectedChoice = _state.selectedChoice,
	          chapterName = _state.chapterName,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          textColor = _state.textColor,
	          result = _state.result,
	          timeDone = _state.timeDone;
	
	      // Disable Validate if no choice is selected or answer is already shown
	
	      var disableValidate = !selectedChoice || !!showAnswer;
	
	      return _react2.default.createElement(
	        _LoaderWrapper2.default,
	        { isLoading: isLoading },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn font-lusitana font-16px' },
	          _react2.default.createElement(
	            _Header2.default,
	            { title: _language2.default.LC().QUESTION_BANK },
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return _this3.context.router.push({ pathname: _AppRoutes2.default.ESG_QUESTION_BANK });
	                }
	              },
	              _language2.default.LC().CHANGE_CHAPTER,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              _react2.default.createElement(
	                _CustomCard2.default,
	                null,
	                _react2.default.createElement(_CardHeader2.default, {
	                  headingText: chapterName + ' (Q. ' + (currentQuestion && currentQuestion.id) + ')',
	                  headerImage: '/img/question_bank/question_icon_blue.svg',
	                  showPreviousButton: true,
	                  showNextButton: true,
	                  currentIndex: currentIndex,
	                  arrayLength: questionData.length,
	                  disabledPreviousButton: currentIndex < 1,
	                  disabledNextButton: !(currentIndex < questionData.length - 1),
	                  _getPrevious: this.getPreviousQuestion,
	                  _getNext: this.getNextQuestion
	                }),
	                _react2.default.createElement(
	                  _CardBody2.default,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { sm: 9, xs: 12 },
	                      _react2.default.createElement(
	                        _ViewQuestion2.default,
	                        Object.assign({}, currentQuestion, this.props, {
	                          setAnswer: this.setAnswer,
	                          showAnswer: showAnswer,
	                          selectedChoice: selectedChoice
	                        }),
	                        _react2.default.createElement(_QuestionBankFooter2.default, {
	                          key: currentQuestion && currentQuestion.id,
	                          validateQuestion: this.validateQuestion,
	                          favItemId: currentQuestion && currentQuestion.id,
	                          setChildRef: this.childRef,
	                          onSaveItemChange: this.onSaveItemChange,
	                          toggleReportSection: this.toggleReportSection,
	                          disabled: disableValidate
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { sm: 3, xs: 12 },
	                      _react2.default.createElement(_Timer2.default, {
	                        getTimerValue: this.getTimerValue,
	                        stopTimer: stopTimer,
	                        shouldFetchFromServer: true,
	                        key: currentQuestion && currentQuestion.id,
	                        initialTime: timeDone
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          showAnswer && _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              _react2.default.createElement(
	                _CustomCard2.default,
	                { className: 'font-lusitana font-16px' },
	                _react2.default.createElement(_CustomCardHeader2.default, {
	                  headingText: result,
	                  headerImage: '',
	                  className: 'text-uppercase ' + textColor
	                }),
	                _react2.default.createElement(
	                  _CardBody2.default,
	                  null,
	                  (0, _function.renderHTMLContent)(currentQuestion && currentQuestion.explanation, 'span')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: currentQuestion,
	            type: 'question',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'esg'
	          }),
	          showReportSection && _react2.default.createElement(_Report2.default, {
	            hideReportSection: this.hideReportSection,
	            commentOnWhichId: currentQuestion && currentQuestion.id
	          })
	        )
	      );
	    }
	  }]);
	
	  return BeginQuestion;
	}(_react.Component);
	
	BeginQuestion.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = BeginQuestion;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelectionPopover = __webpack_require__(100);
	
	var _reactSelectionPopover2 = _interopRequireDefault(_reactSelectionPopover);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _highlightText = __webpack_require__(56);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _services = __webpack_require__(43);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HighlightText = function (_Component) {
	  _inherits(HighlightText, _Component);
	
	  function HighlightText(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, HighlightText);
	
	    var _this = _possibleConstructorReturn(this, (HighlightText.__proto__ || Object.getPrototypeOf(HighlightText)).call(this, props));
	
	    _this.setShowPopover = function (value) {
	      return _this.setState({ showPopover: value });
	    };
	
	    _this.addHighlightToText = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var text, _this$props$params, mock_id, question_id, test_id, res;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              text = _this.getSelectionHtml();
	              _this$props$params = _this.props.params, mock_id = _this$props$params.mockId, question_id = _this$props$params.questionId, test_id = _this$props$params.testId;
	              _context.next = 4;
	              return (0, _services.addHighlightedTextService)({
	                mock_id: mock_id,
	                question_id: question_id,
	                test_id: test_id,
	                text: text
	              });
	
	            case 4:
	              res = _context.sent;
	
	              if (!res) {
	                _context.next = 10;
	                break;
	              }
	
	              _this.setState({ showPopover: false });
	              _context.next = 9;
	              return _this.getHighlightedText();
	
	            case 9:
	              (0, _highlightText.clearSelection)();
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.deleteHighlightFromText = function () {
	      var text = _this.getSelectionHtml();
	
	      var highlights = _this.highlights;
	
	      var getHighlightedTextData = highlights ? highlights.filter(function (item) {
	        return item.text === text;
	      })[0] : [];
	
	      _this.deleteHighlight(getHighlightedTextData.id);
	    };
	
	    _this.getSelectionHtml = function () {
	      var html = '';
	      if (typeof window.getSelection !== 'undefined') {
	        var sel = window.getSelection();
	        if (sel.rangeCount) {
	          var container = document.createElement('div');
	          for (var count = 0, len = sel.rangeCount; count < len; ++count) {
	            container.appendChild(sel.getRangeAt(count).cloneContents());
	          }
	          html = container.innerHTML;
	        }
	      } else if (typeof document.selection !== 'undefined') {
	        if (document.selection.type === 'Text') {
	          html = document.selection.createRange().htmlText;
	        }
	      }
	      return html;
	    };
	
	    _this.deleteHighlight = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(id) {
	        var mock_id, result;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                mock_id = _this.props.params.mock_id;
	
	                if (!id) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                _context2.next = 4;
	                return (0, _services.deleteHighlightService)({
	                  mock_id: mock_id,
	                  id: id
	                });
	
	              case 4:
	                result = _context2.sent;
	
	                if (!result) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                _this.setState({ showPopover: false });
	                _context2.next = 9;
	                return _this.getHighlightedText();
	
	              case 9:
	                (0, _highlightText.clearSelection)();
	
	              case 10:
	                _context2.next = 13;
	                break;
	
	              case 12:
	                return _context2.abrupt('return');
	
	              case 13:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.setQuestion = function (question) {
	      _this.setState({ question: question });
	    };
	
	    _this.getHighlightedText = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$props$params2, mock_id, question_id, test_id, resp, setQuestion, content;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$props$params2 = _this.props.params, mock_id = _this$props$params2.mockId, question_id = _this$props$params2.questionId, test_id = _this$props$params2.testId;
	              _context3.next = 3;
	              return (0, _services.getHighlightedTextService)({
	                mock_id: mock_id,
	                question_id: question_id,
	                test_id: test_id
	              });
	
	            case 3:
	              resp = _context3.sent;
	              setQuestion = _this.setQuestion, content = _this.props.content;
	
	
	              _this.highLightedQuestion = content;
	              if (resp.success) {
	                if (resp.data.length) {
	                  _this.highlights = resp.data;
	                  resp.data.forEach(function (element) {
	                    _this.highLightedQuestion = (0, _highlightText.highlightString)(_this.highLightedQuestion, element.text);
	                  });
	                }
	
	                setQuestion(_this.highLightedQuestion);
	              }
	
	            case 7:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.getHighlightedText();
	
	            case 1:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.componentDidUpdate = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(prevProps) {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (prevProps.content !== _this.props.content) _this.getHighlightedText();
	
	              case 1:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      showPopover: false,
	      highlights: [],
	      question: props.content
	    };
	    _this.highLightedQuestion = _this.props.content;
	    return _this;
	  }
	
	  _createClass(HighlightText, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state,
	          setShowPopover = this.setShowPopover;
	      var showPopover = state.showPopover,
	          question = state.question;
	
	
	      var text = this.getSelectionHtml();
	      var highlighted = '<b style="background-color: yellow" title="highlighted">' + text + '</b>';
	      var getHighlightedText = this.highLightedQuestion.indexOf(highlighted);
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-selectable': true },
	        (0, _function.renderHTMLContent)(question, 'div', 'margin_bottom_40 view_questionhtml bg_blue', { contentEditable: 'false' }),
	        _react2.default.createElement(
	          _reactSelectionPopover2.default,
	          {
	            showPopover: showPopover,
	            onSelect: function onSelect() {
	              return setShowPopover(true);
	            },
	            onDeselect: function onDeselect() {
	              return setShowPopover(false);
	            }
	          },
	          getHighlightedText === -1 ? _react2.default.createElement(
	            'div',
	            { className: 'highlight-popover tooltip_wrap' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/high-edit-ico.svg',
	              alt: '523',
	              width: '30',
	              onClick: function onClick() {
	                return _this3.addHighlightToText();
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tootip_box' },
	              _language2.default.LC().Click_me_to_highlight
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'highlight-popover tooltip_wrap' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/icon_select_text.png',
	              alt: '523',
	              width: '30',
	              onClick: function onClick() {
	                return _this3.deleteHighlightFromText();
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'tootip_box' },
	              _language2.default.LC().Click_me_to_unhighlight
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HighlightText;
	}(_react.Component);
	
	exports.default = HighlightText;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function List(props) {
	  var headerIcon = props.headerIcon,
	      headerContent = props.headerContent,
	      bodyContent = props.bodyContent,
	      children = props.children,
	      onClick = props.onClick,
	      paddingBox = props.paddingBox;
	
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    { xs: 12, sm: '6', md: '6', lg: '4' },
	    _react2.default.createElement(
	      'div',
	      { className: 'border_box', onClick: onClick },
	      _react2.default.createElement(
	        'p',
	        { className: 'border_box_title font-weight-bold' },
	        headerIcon ? _react2.default.createElement('img', { src: headerIcon, alt: 'header Icon', width: '30' }) : null,
	        (0, _function.renderHTMLContent)(headerContent, 'span', 'ml-1')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: paddingBox || 'padding_box ' },
	        (0, _function.renderHTMLContent)(bodyContent, 'div', 'view_question_height view_questionhtml margin_bottom_40 cfa_notes_view'),
	        children
	      )
	    )
	  );
	}
	
	exports.default = List;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ValidateButton = __webpack_require__(746);
	
	var _ValidateButton2 = _interopRequireDefault(_ValidateButton);
	
	var _SaveQuestion = __webpack_require__(745);
	
	var _SaveQuestion2 = _interopRequireDefault(_SaveQuestion);
	
	var _ReportQuestion = __webpack_require__(271);
	
	var _ReportQuestion2 = _interopRequireDefault(_ReportQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function QuestionBankFooter(_ref) {
	  var validateQuestion = _ref.validateQuestion,
	      toggleReportSection = _ref.toggleReportSection,
	      favItemId = _ref.favItemId,
	      onSaveItemChange = _ref.onSaveItemChange,
	      setChildRef = _ref.setChildRef,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	  return _react2.default.createElement(
	    _reactstrap.Col,
	    { sm: 9, xs: 12 },
	    _react2.default.createElement(
	      'div',
	      { className: 'd-flex align-items-center mt-2 mb-1' },
	      _react2.default.createElement(_ValidateButton2.default, { onValidate: validateQuestion, disabled: disabled }),
	      _react2.default.createElement(_SaveQuestion2.default, { favItemId: favItemId, onSaveItemChange: onSaveItemChange, setChildRef: setChildRef }),
	      _react2.default.createElement(_ReportQuestion2.default, { onClick: toggleReportSection })
	    )
	  );
	}
	exports.default = QuestionBankFooter;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _LoaderWrapper = __webpack_require__(85);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _List = __webpack_require__(742);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _services = __webpack_require__(43);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _CustomButton = __webpack_require__(95);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _constant = __webpack_require__(9);
	
	var _exams = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionsList = function (_Component) {
	  _inherits(QuestionsList, _Component);
	
	  function QuestionsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionsList);
	
	    var _this = _possibleConstructorReturn(this, (QuestionsList.__proto__ || Object.getPrototypeOf(QuestionsList)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var chapterId, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              chapterId = _this.props.params.listId;
	              data = Object.assign({}, (0, _services.getTokenAndEmail)(), {
	                chapterId: chapterId
	              });
	
	
	              _this.setContentMessage();
	
	              (0, _services.fetchQuestionsChapterWise)(data).then(function (response) {
	                if (response.success) {
	                  var questionStatsTableName = response.questionStatsTableName,
	                      listData = response.question,
	                      userSubscriptionDetails = response.userSubscriptionDetails;
	
	                  _this.setState({
	                    listData: listData,
	                    questionStatsTableName: questionStatsTableName || 'esg_question_stats',
	                    userSubscriptionDetails: userSubscriptionDetails
	                  });
	                }
	                _this.setState({ isLoading: false });
	              });
	
	              (0, _services.fetchChapterNameById)(data).then(function (response) {
	                if (response.success) {
	                  var name = response.chapter.name;
	
	                  _this.setState({ chapterName: name });
	                }
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.setContentMessage = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var result, _result$data, html_content, header;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return (0, _exams.fetchFreeUseSubscriptionMessage)({
	                exam: 'esg',
	                section: 'question'
	              });
	
	            case 2:
	              result = _context2.sent;
	
	              if (result.success) {
	                _result$data = result.data, html_content = _result$data.html_content, header = _result$data.header;
	
	                _this.setState({
	                  subscriptionMessage: html_content,
	                  contentHeader: header
	                });
	              }
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.redirectToQuestion = function (data) {
	      var listId = data.listId,
	          id = data.id,
	          offset = data.offset;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_QUESTION_BANK_VIEW_QUE.replace(':chapterId', listId).replace(':index', offset).replace(':id', id)
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({ pathname: '/Subscribe/' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.checkSubscription = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(cb, type) {
	        var userSubscriptionDetails;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                userSubscriptionDetails = _this.state.userSubscriptionDetails;
	
	                if (Object.keys(userSubscriptionDetails).length) {
	                  _context3.next = 3;
	                  break;
	                }
	
	                return _context3.abrupt('return', _this.setState({ openPremiumPopup: true }));
	
	              case 3:
	                cb();
	                _this.setState({ PDFDownloadType: type });
	                _this.pdfAlertModel();
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.pdfAlertModel = function () {
	      _this.setState({ pdfAlert: !_this.state.pdfAlert });
	    };
	
	    _this.state = {
	      listData: [],
	      questionStatsTableName: '',
	      isLoading: true,
	      chapterName: '',
	      userSubscriptionDetails: {},
	      subscriptionMessage: _alertMessage2.default.messageContent_ESG,
	      contentHeader: 'Subscribe for 3,000 practice questions',
	      pdfAlert: false,
	      PDFDownloadType: 'Question'
	    };
	    return _this;
	  }
	
	  _createClass(QuestionsList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          listData = _state.listData,
	          questionStatsTableName = _state.questionStatsTableName,
	          chapterName = _state.chapterName,
	          isLoading = _state.isLoading,
	          userSubscriptionDetails = _state.userSubscriptionDetails,
	          openPremiumPopup = _state.openPremiumPopup,
	          subscriptionMessage = _state.subscriptionMessage,
	          contentHeader = _state.contentHeader;
	      var listId = this.props.params.listId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _Header2.default,
	          { title: _language2.default.LC().QUESTION_BANK },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return (0, _services.pdfDownloadViaEmail)({ type: 'question', chapterNo: listId });
	                  }, 'Question');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }),
	              ' ',
	              !Object.keys(userSubscriptionDetails).length && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _language2.default.LC().Download_Question
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return (0, _services.pdfDownloadViaEmail)({ type: 'questionAnswer', chapterNo: listId });
	                  }, 'Question/Answer');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download ', 'aria-hidden': 'true' }),
	              ' ',
	              !Object.keys(userSubscriptionDetails).length && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _language2.default.LC().Download_Question_Answer,
	              ' '
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return _this3.context.router.push({ pathname: _AppRoutes2.default.ESG_QUESTION_BANK });
	                }
	              },
	              ' ',
	              _language2.default.LC().CHANGE_TOPIC,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            listData.map(function (item, index) {
	              return _react2.default.createElement(
	                _List2.default,
	                {
	                  headerIcon: '/img/question_bank/question_icon-blu.svg',
	                  headerContent: chapterName + ' (Q. ' + item.id + ')',
	                  bodyContent: item.question,
	                  key: item.id,
	                  onClick: function onClick() {
	                    return _this3.redirectToQuestion({
	                      offset: index,
	                      listId: listId,
	                      id: item.id
	                    });
	                  }
	                },
	                item[questionStatsTableName].length ? _react2.default.createElement(
	                  'div',
	                  { id: 'answered_status' },
	                  'Answered'
	                ) : _react2.default.createElement(
	                  'div',
	                  { id: 'notanswered_status' },
	                  'Not Answered '
	                )
	              );
	            }),
	            !Object.keys(userSubscriptionDetails).length && _react2.default.createElement(
	              _List2.default,
	              {
	                headerIcon: '/img/question_bank/question_icon-blu.svg',
	                headerContent: contentHeader,
	                bodyContent: subscriptionMessage,
	                paddingBox: 'padding_box_free'
	              },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                {
	                  className: 'text-center d-block mx-auto',
	                  onClick: function onClick() {
	                    return _this3.context.router.push({ pathname: _AppRoutes2.default.SUBSCRIBE });
	                  }
	                },
	                'Subscribe'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_ESG,
	          exam: _constant.examNameAccordingToDB.ESG
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: _language2.default.LC().PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return QuestionsList;
	}(_react.Component);
	
	QuestionsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionsList;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaveQuestion = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _services = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveQuestion = exports.SaveQuestion = function (_Component) {
	  _inherits(SaveQuestion, _Component);
	
	  function SaveQuestion(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SaveQuestion);
	
	    var _this = _possibleConstructorReturn(this, (SaveQuestion.__proto__ || Object.getPrototypeOf(SaveQuestion)).call(this, props));
	
	    _this.setIconColor = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(func, isContentSaved) {
	        var _this$props, favItemId, onSaveItemChange, data, response, isSaved, setChildRef;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, favItemId = _this$props.favItemId, onSaveItemChange = _this$props.onSaveItemChange;
	                data = Object.assign({}, (0, _services.getTokenAndEmail)(), {
	                  favItemId: favItemId
	                });
	                _context.next = 4;
	                return func(data);
	
	              case 4:
	                response = _context.sent;
	
	                if (!(func === _services.getFavQuestion)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                isSaved = response.success && response.data && response.data.id;
	
	                _this.setState({ isContentSaved: !!isSaved });
	                onSaveItemChange(!isSaved);
	                return _context.abrupt('return');
	
	              case 10:
	
	                if (response.success) {
	                  onSaveItemChange(!isContentSaved);
	                  if (!isContentSaved) {
	                    setChildRef = _this.props.setChildRef;
	
	                    if (setChildRef) {
	                      setChildRef.deleteFlash();
	                    }
	                  }
	                  _this.setState({ isContentSaved: isContentSaved });
	                } else {
	                  onSaveItemChange(true);
	                }
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.setIconOnUnSave = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(func) {
	        var _this$props2, favItemId, onSaveItemChange, data, response;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, favItemId = _this$props2.favItemId, onSaveItemChange = _this$props2.onSaveItemChange;
	                data = Object.assign({}, (0, _services.getTokenAndEmail)(), {
	                  favItemId: favItemId
	                });
	                _context2.next = 4;
	                return func(data);
	
	              case 4:
	                response = _context2.sent;
	
	                if (response.success) {
	                  onSaveItemChange(false);
	                  _this.setState({ isContentSaved: true });
	                } else {
	                  onSaveItemChange(true);
	                }
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      isContentSaved: false
	    };
	
	    return _this;
	  }
	
	  _createClass(SaveQuestion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.favItemId) {
	        this.setIconColor(_services.getFavQuestion);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.favItemId !== this.props.favItemId && this.props.favItemId) {
	        this.setState({ isContentSaved: false });
	        this.setIconColor(_services.getFavQuestion);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var isContentSaved = this.state.isContentSaved;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'up tooltip-hover-questions', style: { marginRight: '10px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'tootip_box' },
	          ' ',
	          _language2.default.LC().SAVE_QUESTION,
	          ' '
	        ),
	        console.log('checking the save state', isContentSaved),
	        _react2.default.createElement('i', {
	          className: '' + (isContentSaved ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark'),
	          onClick: function onClick() {
	            return isContentSaved ? _this3.setIconColor(_services.deleteSaveQuestion, false) : _this3.setIconColor(_services.saveQuestion, true);
	          },
	          style: { color: isContentSaved ? 'rgb(54, 141, 84)' : '' }
	        })
	      );
	    }
	  }]);
	
	  return SaveQuestion;
	}(_react.Component);
	
	exports.default = SaveQuestion;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ValidateButton(_ref) {
	  var onValidate = _ref.onValidate,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      className: 'btn btn-primary pointer_class margin_right_10 mb-0',
	      onClick: onValidate,
	      style: { height: '38px' },
	      disabled: disabled
	    },
	    _language2.default.LC().VALIDATE
	  );
	}
	
	exports.default = ValidateButton;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESGQuestionBank = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _Chapter = __webpack_require__(269);
	
	var _Chapter2 = _interopRequireDefault(_Chapter);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _services = __webpack_require__(43);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESGQuestionBank = exports.ESGQuestionBank = function (_Component) {
	  _inherits(ESGQuestionBank, _Component);
	
	  function ESGQuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ESGQuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (ESGQuestionBank.__proto__ || Object.getPrototypeOf(ESGQuestionBank)).call(this, props));
	
	    _this.getLastAnsweredQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var result;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _services.fetchLastAnsweredQuestion)();
	
	            case 2:
	              result = _context.sent;
	
	              if (!result.success) {
	                _context.next = 5;
	                break;
	              }
	
	              return _context.abrupt('return', result.getLastAnsweredQuestion);
	
	            case 5:
	              return _context.abrupt('return', {});
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var result, chapter_id, question_id;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return _this.getLastAnsweredQuestion();
	
	            case 2:
	              result = _context2.sent;
	              chapter_id = result.chapter_id, question_id = result.question_id;
	
	              _this.setState({ chapterId: chapter_id, questionId: question_id });
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.redirectToQuestionBank = function (_ref3) {
	      var questionId = _ref3.questionId,
	          chapterId = _ref3.chapterId;
	
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.ESG_QUESTION_BANK_VIEW_QUE.replace(':chapterId', chapterId).replace(':id', questionId)
	      });
	    };
	
	    _this.state = {
	      chapterId: '',
	      questionId: ''
	    };
	    return _this;
	  }
	
	  _createClass(ESGQuestionBank, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          questionId = _state.questionId,
	          chapterId = _state.chapterId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _Header2.default,
	          { title: _language2.default.LC().QUESTION_BANK },
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.ESG }),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: function onClick() {
	                return _this3.redirectToQuestionBank({ questionId: questionId, chapterId: chapterId });
	              },
	              disabled: !questionId
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(_Chapter2.default, {
	          headerImage: '/img/question_bank/icon2.svg',
	          apiEndpoint: '/esg/chapter',
	          imageWidth: 54
	          // redirectRoute={AppRoutes.ESG_QUESTION_BANK_VIEW_QUE}
	          , redirectRoute: _AppRoutes2.default.ESG_QUESTION_BANK_LIST_QUE
	        })
	      );
	    }
	  }]);
	
	  return ESGQuestionBank;
	}(_react.Component);
	
	ESGQuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ESGQuestionBank;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReverseTimer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReverseTimer = exports.ReverseTimer = function (_Component) {
	  _inherits(ReverseTimer, _Component);
	
	  function ReverseTimer(props) {
	    _classCallCheck(this, ReverseTimer);
	
	    var _this = _possibleConstructorReturn(this, (ReverseTimer.__proto__ || Object.getPrototypeOf(ReverseTimer)).call(this, props));
	
	    _this.timerFunc = function () {
	      var stopTimerOnBtnClick = _this.state.stopTimerOnBtnClick;
	      var _this$props = _this.props,
	          _this$props$onStopTim = _this$props.onStopTimer,
	          onStopTimer = _this$props$onStopTim === undefined ? function () {} : _this$props$onStopTim,
	          _this$props$onStartTi = _this$props.onStartTimer,
	          onStartTimer = _this$props$onStartTi === undefined ? function () {} : _this$props$onStartTi;
	
	      if (stopTimerOnBtnClick) {
	        clearInterval(_this.timer);
	        onStopTimer();
	      } else {
	        clearInterval(_this.timer);
	        onStartTimer();
	        _this.timer = setInterval(_this.tick, 1000);
	      }
	    };
	
	    _this.tick = function () {
	      var apiCall = _this.props.apiCall;
	
	      _this.setState({ count: _this.state.count - 1 });
	      apiCall && apiCall({
	        count: _this.state.count - 1,
	        timer: _this.state.count - 1
	      });
	    };
	
	    _this.state = {
	      count: props.intialTimerValue || 0,
	      stopTimerOnBtnClick: props.stopTimerOnMount || false,
	      disabled: false
	    };
	    return _this;
	  }
	
	  _createClass(ReverseTimer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.stopTimerOnMount) this.timer = setInterval(this.tick, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      var stopTimer = this.props.stopTimer;
	
	      if (stopTimer && prevProps.stopTimer !== stopTimer) {
	        this.setState({ stopTimerOnBtnClick: true, disabled: true }, function () {
	          _this2.timerFunc();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          count = _state.count,
	          stopTimerOnBtnClick = _state.stopTimerOnBtnClick,
	          disabled = _state.disabled;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'timer_outer' },
	          _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'timer_box' },
	            (0, _constant.SecondsToHHMMSS)(count)
	          )
	        ),
	        _react2.default.createElement('button', {
	          type: 'button',
	          className: 'pause_btn ' + (stopTimerOnBtnClick ? 'icon-control-play' : 'icon-control-pause'),
	          onClick: function onClick() {
	            return _this3.setState({ stopTimerOnBtnClick: !stopTimerOnBtnClick }, function () {
	              _this3.timerFunc();
	            });
	          },
	          disabled: disabled
	        })
	      );
	    }
	  }]);
	
	  return ReverseTimer;
	}(_react.Component);
	
	exports.default = ReverseTimer;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Timer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timer = exports.Timer = function (_Component) {
	  _inherits(Timer, _Component);
	
	  function Timer(props) {
	    _classCallCheck(this, Timer);
	
	    var _this = _possibleConstructorReturn(this, (Timer.__proto__ || Object.getPrototypeOf(Timer)).call(this, props));
	
	    _this.timerToggle = function () {
	      var stopTimerOnBtnClick = _this.state.stopTimerOnBtnClick;
	
	      if (stopTimerOnBtnClick) {
	        clearInterval(_this.timer);
	      } else {
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick, 1000);
	      }
	    };
	
	    _this.tick = function () {
	      _this.setState(function (prevState) {
	        return { count: prevState.count + 1 };
	      }, function () {
	        if (_this.props.getTimerValue) {
	          _this.props.getTimerValue(_this.state.count);
	        }
	      });
	    };
	
	    _this.state = {
	      count: parseInt(props.initialTime || 0, 10),
	      stopTimerOnBtnClick: false,
	      disabled: false
	    };
	    return _this;
	  }
	
	  _createClass(Timer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.stopTimer) {
	        this.timer = setInterval(this.tick, 1000);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (prevProps.stopTimer !== this.props.stopTimer) {
	        if (this.props.stopTimer) {
	          this.setState({ stopTimerOnBtnClick: true, disabled: true }, function () {
	            _this2.timerToggle();
	          });
	        } else {
	          this.setState({ stopTimerOnBtnClick: false, disabled: false }, function () {
	            _this2.timerToggle();
	          });
	        }
	      }
	      if (prevProps.initialTime !== this.props.initialTime) {
	        this.setState({ count: parseInt(this.props.initialTime || 0, 10) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          count = _state.count,
	          stopTimerOnBtnClick = _state.stopTimerOnBtnClick,
	          disabled = _state.disabled;
	      var stopTimer = this.props.stopTimer;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'timer_outer' },
	          _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'timer_box' },
	            (0, _constant.SecondsToMMSS)(count)
	          )
	        ),
	        _react2.default.createElement('button', {
	          type: 'button',
	          className: 'pause_btn ' + (stopTimerOnBtnClick || stopTimer ? 'icon-control-play' : 'icon-control-pause'),
	          onClick: function onClick() {
	            return _this3.setState({
	              stopTimerOnBtnClick: !stopTimerOnBtnClick
	            }, function () {
	              _this3.timerToggle();
	            });
	          },
	          disabled: disabled || stopTimer
	        })
	      );
	    }
	  }]);
	
	  return Timer;
	}(_react.Component);
	
	exports.default = Timer;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _Report = __webpack_require__(189);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _services = __webpack_require__(43);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _toast = __webpack_require__(15);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var styles_css = { marginBottom: '20px' };
	
	var ChapterVideos = function (_Component) {
	  _inherits(ChapterVideos, _Component);
	
	  function ChapterVideos(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ChapterVideos);
	
	    var _this = _possibleConstructorReturn(this, (ChapterVideos.__proto__ || Object.getPrototypeOf(ChapterVideos)).call(this, props));
	
	    _this.getVideoById = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props$params, chapter, index, response;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _this$props$params = _this.props.params, chapter = _this$props$params.chapter, index = _this$props$params.index;
	              _context.next = 4;
	              return (0, _services.getVideosByChapter)({ chapterID: chapter });
	
	            case 4:
	              response = _context.sent;
	
	              if (response.success) {
	                _this.getFavVideo(response.data);
	                _this.setState({
	                  videos: response.data,
	                  showFreePremium: !Object.keys(response.userSubscriptionDetails).length,
	                  isLoading: false,
	                  currentVideoId: response.data[index].id
	                });
	              }
	              _context.next = 10;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context['catch'](0);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 8]]);
	    }));
	    _this.moveToPracticeQuestions = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var chapter;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              chapter = _this.props.params.chapter;
	
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.ESG_QUESTION_BANK_LIST_QUE.replace(':listId', chapter)
	              });
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.moveToNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this.context.router.push({ pathname: _AppRoutes2.default.ESG_NOTES });
	
	            case 1:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.setBookmarkColor = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var response;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.next = 2;
	              return api({ video_id: id });
	
	            case 2:
	              response = _context4.sent;
	
	              if (response.success) {
	                _this.setState({
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                  isFlashCardHidden: false
	                });
	              } else {
	                _this.setState({
	                  bookmarkColor: '',
	                  saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  isFlashCardHidden: true
	                });
	              }
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.getFavVideo = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(videos) {
	        var index;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                index = _this.props.params.index;
	
	                _this.setBookmarkColor(_services.getFavVideoById, videos[index].id);
	                _this.setState({
	                  currentVideoId: videos[index].id
	                });
	
	              case 3:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.saveFavVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var videos, index, response;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              videos = _this.state.videos;
	              index = _this.props.params.index;
	
	              if (!(_this.state.bookmarkCSS !== 'fa fa-bookmark mark-action-btn-bookmark')) {
	                _context6.next = 6;
	                break;
	              }
	
	              _this.setBookmarkColor(_services.mutateSaveVideo, videos[index].id);
	              _context6.next = 11;
	              break;
	
	            case 6:
	              if (_this.childRef) {
	                _this.childRef.deleteFlash();
	              }
	              _context6.next = 9;
	              return (0, _services.deleteFavVideo)({ video_id: videos[index].id });
	
	            case 9:
	              response = _context6.sent;
	
	              if (response.success) {
	                _this.setState({
	                  bookmarkColor: '',
	                  saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  isFlashCardHidden: true
	                });
	              }
	
	            case 11:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.displayReportForm = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this.setState({ showReportSection: true });
	
	            case 1:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.viewPdf = function (pdf) {
	      var showFreePremium = _this.state.showFreePremium;
	
	      if (showFreePremium) {
	        _this.toggleAlert();
	        return;
	      }
	      if (pdf) {
	        var myWindow = window.open(pdf);
	        myWindow.focus();
	      } else {
	        (0, _toast.showInformation)(_messages.messages.PDF_NOT_AVAILABLE);
	      }
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.SUBSCRIBE
	      });
	    };
	
	    _this.navigateToVideoByID = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(index) {
	        var chapter, videos;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                chapter = _this.props.params.chapter;
	                videos = _this.state.videos;
	                _context8.next = 4;
	                return _this.context.router.push({
	                  pathname: _AppRoutes2.default.ESG_VIDEO_LESSON.replace(':chapter', chapter).replace(':index', index)
	                });
	
	              case 4:
	                _this.getFavVideo(videos);
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      videos: [],
	      showFreePremium: true,
	      isLoading: true,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      notesCSS: 'fa fa-book mark-action-btn',
	      questionsCSS: 'fa fa-question-circle-o mark-action-btn',
	      saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	      showReportSection: false,
	      isFlashCardHidden: true
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(ChapterVideos, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	      this.getVideoById();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          videos = _state.videos,
	          showFreePremium = _state.showFreePremium,
	          isLoading = _state.isLoading,
	          notesCSS = _state.notesCSS,
	          bookmarkColor = _state.bookmarkColor,
	          bookmarkCSS = _state.bookmarkCSS,
	          questionsCSS = _state.questionsCSS,
	          saveVideo_text = _state.saveVideo_text,
	          showReportSection = _state.showReportSection,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          currentVideoId = _state.currentVideoId;
	      var index = this.props.params.index;
	      var _ref9 = {},
	          _ref9$title = _ref9.title,
	          title = _ref9$title === undefined ? 'Title' : _ref9$title,
	          _ref9$youtubeID = _ref9.youtubeID,
	          youtubeID = _ref9$youtubeID === undefined ? '' : _ref9$youtubeID,
	          url_id_qq = _ref9.url_id_qq;
	
	      if (videos[index]) {
	        ;
	        var _videos$index = videos[index];
	        var _videos$index$title = _videos$index.title;
	        title = _videos$index$title === undefined ? 'Title' : _videos$index$title;
	        youtubeID = _videos$index.url_id;
	        url_id_qq = _videos$index.url_id_qq;
	      }return _react2.default.createElement(
	        'div',
	        null,
	        isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	          'div',
	          { className: 'video_outer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-8 col-md-8' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'mb-0' },
	                title
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                parseInt(index, 10) === 0 ? null : _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class',
	                  onClick: function onClick() {
	                    return _this3.navigateToVideoByID(parseInt(index, 10) - 1);
	                  }
	                }),
	                parseInt(index, 10) === videos.length - 1 ? null : _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class',
	                  onClick: function onClick() {
	                    return _this3.navigateToVideoByID(parseInt(index, 10) + 1);
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row videos-main-wraper p-0' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	              _react2.default.createElement(
	                'div',
	                { className: '', id: 'video-height' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'embed-responsive embed-responsive-16by9' },
	                  url_id_qq ? _react2.default.createElement('iframe', {
	                    width: '100%',
	                    allowFullScreen: '1',
	                    height: '100%',
	                    position: 'absolute',
	                    top: '10',
	                    left: '0',
	                    src: '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + url_id_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef',
	                    sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                    frameBorder: '0',
	                    title: '0',
	                    byline: '0',
	                    portrait: '0',
	                    frameborder: '10'
	                  }) : _react2.default.createElement('iframe', {
	                    className: 'embed-responsive-item',
	                    width: '100%',
	                    height: '100%',
	                    title: 'video',
	                    frameBorder: '0',
	                    src: 'https://www.youtube.com/embed/' + youtubeID + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                    allowFullScreen: true,
	                    sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading', id: 'video-tag-list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'link_list_wrap' },
	                videos.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'full-width', key: item.id },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'videotitle', key: item.id, value: item.id },
	                        showFreePremium ? item.free ? _react2.default.createElement(
	                          'div',
	                          { className: 'video-type-free' },
	                          _language2.default.LC().FREE
	                        ) : _react2.default.createElement(
	                          'div',
	                          { className: 'video-type-primum' },
	                          _language2.default.LC().PREMIUM
	                        ) : _react2.default.createElement('div', null),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            name: 'videourl',
	                            id: item.id,
	                            className: item.url_id === youtubeID ? 'active' : '',
	                            onClick: function onClick() {
	                              if (showFreePremium && !item.free) return _this3.toggleAlert();
	                              _this3.navigateToVideoByID(index);
	                            },
	                            value: item.url
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'text-overflow' },
	                            item.title
	                          )
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_VideoValidateReportIcons2.default, {
	          moveToNotes: this.moveToNotes,
	          notesCSS: notesCSS,
	          moveToPracticeQuestions: this.moveToPracticeQuestions,
	          _saveFavVideo: this.saveFavVideo,
	          _displayReportForm: this.displayReportForm,
	          viewPdf: this.viewPdf,
	          bookmarkCSS: bookmarkCSS,
	          bookmarkColor: bookmarkColor,
	          questionsCSS: questionsCSS,
	          saveVideo_text: saveVideo_text,
	          video: videos[0],
	          showFreePremium: showFreePremium
	        }),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: { id: currentVideoId },
	          type: 'video',
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: 'esg'
	        }),
	        showReportSection && _react2.default.createElement(_Report2.default, {
	          hideReportSection: function hideReportSection() {
	            _this3.setState({ showReportSection: false });
	          },
	          section: 'video',
	          commentOnWhichId: videos.length && videos[index].id
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: _alertMessage2.default.messageContent_ESG
	          })
	        )
	      );
	    }
	  }]);
	
	  return ChapterVideos;
	}(_react.Component);
	
	ChapterVideos.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ChapterVideos;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var settings = {
	  dots: true,
	  infinite: false,
	  speed: 500,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  responsive: [{
	    breakpoint: 1024,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3,
	      infinite: false,
	      dots: true
	    }
	  }, {
	    breakpoint: 600,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2,
	      dots: false
	    }
	  }, {
	    breakpoint: 480,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      dots: false
	    }
	  }],
	  nextArrow: _react2.default.createElement(SampleNextArrow, null),
	  prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	};
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	function VideoList(_ref) {
	  var videos = _ref.videos,
	      showFreePremium = _ref.showFreePremium,
	      gotoVideo = _ref.gotoVideo;
	
	  var count = 0;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactSlick2.default,
	      settings,
	      videos.map(function (item, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          showFreePremium ? item.free ? _react2.default.createElement(
	            'div',
	            { className: 'video-type-free' },
	            _language2.default.LC().FREE
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'video-type-primum' },
	            _language2.default.LC().PREMIUM
	          ) : _react2.default.createElement('div', null),
	          item.url_id_qq ? _react2.default.createElement('img', {
	            width: '100%',
	            src: item.posterImage ? item.posterImage : (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1'),
	            onError: function onError(_ref2) {
	              var currentTarget = _ref2.currentTarget;
	
	              if (!count++) {
	                // Added condition because of infinite loop, this will once only
	
	                currentTarget.onerror = null; // prevents looping
	
	                currentTarget.src = (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1_2');
	              }
	            },
	            value: index,
	            onClick: function onClick() {
	              return gotoVideo(index, item);
	            },
	            className: 'pointer_class slider_row',
	            alt: 'flow player image'
	          }) : _react2.default.createElement('img', {
	            alt: 'youtube',
	            width: '100%',
	            src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	            value: index,
	            onClick: function onClick() {
	              return gotoVideo(index, item);
	            },
	            className: 'pointer_class slider_row'
	          }),
	          _react2.default.createElement(
	            'strong',
	            { style: { padding: '10px' } },
	            ' ',
	            item.title
	          )
	        );
	      })
	    )
	  );
	}
	
	exports.default = VideoList;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _services = __webpack_require__(43);
	
	var _VideoList = __webpack_require__(751);
	
	var _VideoList2 = _interopRequireDefault(_VideoList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var ESGVideos = function (_Component) {
	    _inherits(ESGVideos, _Component);
	
	    function ESGVideos(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, ESGVideos);
	
	        var _this = _possibleConstructorReturn(this, (ESGVideos.__proto__ || Object.getPrototypeOf(ESGVideos)).call(this, props));
	
	        _this.toggleAlert = function () {
	            _this.setState({
	                alert_status: !_this.state.alert_status
	            });
	        };
	
	        _this.goPremium = function () {
	            _this.context.router.push({
	                pathname: _AppRoutes2.default.SUBSCRIBE
	            });
	        };
	
	        _this.getVideos = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var response;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _services.getAllVideos)();
	
	                        case 3:
	                            response = _context.sent;
	
	                            if (response.success) {
	                                _this.setState({
	                                    chapters: response.data,
	                                    videoTable: response.videoTable,
	                                    showFreePremium: !Object.keys(response.userSubscriptionDetails).length,
	                                    isLoading: false
	
	                                });
	                            }
	                            _context.next = 9;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	
	                        case 9:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        }));
	
	        _this.state = {
	            lastAttempt: false,
	            chapters: [],
	            showFreePremium: true,
	            videoTable: '',
	            alert_status: false,
	            isLoading: true
	
	        };
	        return _this;
	    }
	
	    _createClass(ESGVideos, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.scrollTo(0, 0);
	            this.getVideos();
	            this.getLastVideo();
	        }
	    }, {
	        key: 'getLastVideo',
	        value: function getLastVideo() {
	            try {} catch (error) {}
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                chapters = _state.chapters,
	                lastAttempt = _state.lastAttempt,
	                showFreePremium = _state.showFreePremium,
	                videoTable = _state.videoTable,
	                alert_status = _state.alert_status,
	                isLoading = _state.isLoading;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'video_lesson_wrap' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'animated fadeIn' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'section_head' },
	                            ' Video Lessons '
	                        ),
	                        lastAttempt ? _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'btn btn-primary pointer_class'
	                                // onClick={this.goToVideo.bind(this)}
	                            },
	                            ' ',
	                            'Go to my Last Viewed Video',
	                            ' '
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-12 col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bank_wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-12 col-md-12' },
	                                        _react2.default.createElement('div', { className: 'card' })
	                                    ),
	                                    isLoading ? _react2.default.createElement(_loader2.default, null) : chapters.map(function (item, index) {
	
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-12 col-md-12', key: index },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'card' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'card-header card_header_bg', value: item.id },
	                                                    _react2.default.createElement(
	                                                        'a',
	                                                        {
	                                                            className: 'pointer_class',
	                                                            id: item.name,
	                                                            value: item.id
	                                                            // onClick={this._getReadings.bind(this, item, index)}
	                                                        },
	                                                        _language2.default.LC().TOPIC,
	                                                        ' ',
	                                                        index + 1,
	                                                        ' - ',
	                                                        item.name
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'card-block list_icon_outer', key: item.name },
	                                                    item[videoTable].length > 0 ? _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _language2.default.LC().TOTAL_VIDEOS,
	                                                        ': ',
	                                                        item[videoTable].length
	                                                    ) : _react2.default.createElement('p', null),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                                                        _react2.default.createElement(_VideoList2.default, {
	                                                            key: item.id,
	                                                            videos: item[videoTable],
	                                                            showFreePremium: showFreePremium,
	                                                            gotoVideo: function gotoVideo(index, video) {
	                                                                if (showFreePremium && !video.free) return _this3.toggleAlert();
	                                                                _this3.context.router.push({
	                                                                    pathname: _AppRoutes2.default.ESG_VIDEO_LESSON.replace(':chapter', item.id).replace(':index', index)
	                                                                });
	                                                            }
	                                                        })
	                                                    )
	                                                )
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_Modal2.default, {
	                        goPremium: this.goPremium,
	                        toggleAlert: this.toggleAlert,
	                        alert_status: alert_status,
	                        MessageContent: _alertMessage2.default.messageContent_ESG
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ESGVideos;
	}(_react.Component);
	
	ESGVideos.contextTypes = {
	    router: _react2.default.PropTypes.object
	};
	exports.default = ESGVideos;

/***/ },
/* 753 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  performanceGraphUserAttemptedCountKey: 'questions_frms.frm_question_stat.userAttemptCount',
	  performanceGraphUserAnsweredCountKey: 'questions_frms.frm_question_stat.userAnswerCount',
	  chapterNameKey: 'chapter_name',
	  attemptedCountKey: 'attempted_count',
	  answeredCountKey: 'answered_count',
	  questionTableNameKey: 'questions_frms',
	  questionStatsTableNameKey: 'frm_question_stat',
	  notesTableNameKey: 'frm_notes',
	  notesStatsTableNameKey: 'frm_notes_stat'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getUserPerformanceBarGraph = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/user-bar-graph', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getUserPerformanceBarGraph(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var getTotalUsersPerformanceBarGraph = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/all-user-bar-graph', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function getTotalUsersPerformanceBarGraph() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var sendFurtherHelpRequest = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function sendFurtherHelpRequest() {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var fetchQuestionProgressBar = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/question-progress-bar', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function fetchQuestionProgressBar() {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var fetchNotesProgressBar = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/notes-progress-bar', data);
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function fetchNotesProgressBar() {
	    return _ref5.apply(this, arguments);
	  };
	}();
	//* QUESTION SAVE AND REPORT STARTED HERE
	var fetchSavedQuestion = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/saved-question', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var fetchReportedQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/reported-question', data);
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function fetchReportedQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	var deleteReportedQuestion = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardQuestionReports', { reports: data });
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function deleteReportedQuestion(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	var updateReportedQuestion = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateReportsQuestionsbyuserid', {
	              quesReport: data.comment,
	              id: data.id
	            });
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function updateReportedQuestion(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var deleteSavedQuestion = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            _context10.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteSavequestion', {
	              save_question: data
	            });
	
	          case 2:
	            return _context10.abrupt('return', _context10.sent);
	
	          case 3:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	//* NOTES SAVE AND REPORT STARTED HERE
	var fetchSavedNotes = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(data) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/saved-notes', data);
	
	          case 2:
	            return _context11.abrupt('return', _context11.sent);
	
	          case 3:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, undefined);
	  }));
	
	  return function fetchSavedNotes(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	var fetchReportedNotes = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/reported-notes', data);
	
	          case 2:
	            return _context12.abrupt('return', _context12.sent);
	
	          case 3:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, undefined);
	  }));
	
	  return function fetchReportedNotes(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	var deleteSavedNotes = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(data) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteSaveNotes', {
	              save_question: data
	            });
	
	          case 2:
	            return _context13.abrupt('return', _context13.sent);
	
	          case 3:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, undefined);
	  }));
	
	  return function deleteSavedNotes(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	var deleteReportedNotes = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(data) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            _context14.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteDashboardNotesReports', {
	              reports: data
	            });
	
	          case 2:
	            return _context14.abrupt('return', _context14.sent);
	
	          case 3:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, undefined);
	  }));
	
	  return function deleteReportedNotes(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	var updateReportedNotes = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(data) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            _context15.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/UpdateReportsNotesbyuserid', {
	              notesReport: data.comment,
	              id: data.id
	            });
	
	          case 2:
	            return _context15.abrupt('return', _context15.sent);
	
	          case 3:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, undefined);
	  }));
	
	  return function updateReportedNotes(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	//* VIDEOS SAVE AND REPORT STARTED HERE
	var fetchSavedVideos = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(data) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            _context16.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/saved-videos', data);
	
	          case 2:
	            return _context16.abrupt('return', _context16.sent);
	
	          case 3:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, undefined);
	  }));
	
	  return function fetchSavedVideos(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	var fetchReportedVideos = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(data) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            _context17.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/reported-videos', data);
	
	          case 2:
	            return _context17.abrupt('return', _context17.sent);
	
	          case 3:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, undefined);
	  }));
	
	  return function fetchReportedVideos(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	var deleteSavedVideo = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(data) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            _context18.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteSaveVideo', {
	              save_question: data
	            });
	
	          case 2:
	            return _context18.abrupt('return', _context18.sent);
	
	          case 3:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, undefined);
	  }));
	
	  return function deleteSavedVideo(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	var deleteReportedVideo = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(data) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            _context19.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardVideoReports', { reports: data });
	
	          case 2:
	            return _context19.abrupt('return', _context19.sent);
	
	          case 3:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, undefined);
	  }));
	
	  return function deleteReportedVideo(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	var updateReportedVideo = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(data) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            _context20.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateReportsVideobyuserid', {
	              videoReport: data.comment,
	              id: data.id,
	              level: data.level
	            });
	
	          case 2:
	            return _context20.abrupt('return', _context20.sent);
	
	          case 3:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, undefined);
	  }));
	
	  return function updateReportedVideo(_x20) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	//* CBT SAVE AND REPORT STARTED HERE
	var fetchCBTReportedQuestion = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(data) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            _context21.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/reported-mocks', data);
	
	          case 2:
	            return _context21.abrupt('return', _context21.sent);
	
	          case 3:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, undefined);
	  }));
	
	  return function fetchCBTReportedQuestion(_x21) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	// redirectToCBTQuestion
	var deleteCBTReportedQuestion = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(data) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            _context22.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/deleteReport', {
	              reports: data
	            });
	
	          case 2:
	            return _context22.abrupt('return', _context22.sent);
	
	          case 3:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, undefined);
	  }));
	
	  return function deleteCBTReportedQuestion(_x22) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	var updateReportedCBTQuestion = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(data) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            _context23.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateReport', {
	              quesReport: data.comment,
	              id: data.id,
	              level: data.level
	            });
	
	          case 2:
	            return _context23.abrupt('return', _context23.sent);
	
	          case 3:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, undefined);
	  }));
	
	  return function updateReportedCBTQuestion(_x23) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	var deleteFlashCard = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            _context24.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', data);
	
	          case 2:
	            return _context24.abrupt('return', _context24.sent);
	
	          case 3:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, undefined);
	  }));
	
	  return function deleteFlashCard() {
	    return _ref24.apply(this, arguments);
	  };
	}();
	var redirectToCBTQuestion = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(data) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            _context25.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/dashboard/redirect-mocks', data);
	
	          case 2:
	            return _context25.abrupt('return', _context25.sent);
	
	          case 3:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, undefined);
	  }));
	
	  return function redirectToCBTQuestion(_x25) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	module.exports = {
	  getUserPerformanceBarGraph: getUserPerformanceBarGraph,
	  getTotalUsersPerformanceBarGraph: getTotalUsersPerformanceBarGraph,
	  fetchQuestionProgressBar: fetchQuestionProgressBar,
	  fetchNotesProgressBar: fetchNotesProgressBar,
	  fetchSavedQuestion: fetchSavedQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  deleteFlashCard: deleteFlashCard,
	  fetchReportedQuestion: fetchReportedQuestion,
	  deleteReportedQuestion: deleteReportedQuestion,
	  updateReportedQuestion: updateReportedQuestion,
	  fetchSavedNotes: fetchSavedNotes,
	  fetchReportedNotes: fetchReportedNotes,
	  deleteSavedNotes: deleteSavedNotes,
	  sendFurtherHelpRequest: sendFurtherHelpRequest,
	  deleteReportedNotes: deleteReportedNotes,
	  updateReportedNotes: updateReportedNotes,
	  fetchSavedVideos: fetchSavedVideos,
	  fetchReportedVideos: fetchReportedVideos,
	  deleteSavedVideo: deleteSavedVideo,
	  deleteReportedVideo: deleteReportedVideo,
	  updateReportedVideo: updateReportedVideo,
	  fetchCBTReportedQuestion: fetchCBTReportedQuestion,
	  deleteCBTReportedQuestion: deleteCBTReportedQuestion,
	  updateReportedCBTQuestion: updateReportedCBTQuestion,
	  redirectToCBTQuestion: redirectToCBTQuestion
	};

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GARP_logo = __webpack_require__(165);
	
	var _GARP_logo2 = _interopRequireDefault(_GARP_logo);
	
	var _DateFilter = __webpack_require__(254);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _PerformanceGraph = __webpack_require__(255);
	
	var _PerformanceGraph2 = _interopRequireDefault(_PerformanceGraph);
	
	var _ProgressBar = __webpack_require__(256);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _TabList = __webpack_require__(257);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _graphDataCalculator = __webpack_require__(259);
	
	var _graphDataCalculator2 = _interopRequireDefault(_graphDataCalculator);
	
	var _messages = __webpack_require__(14);
	
	var _ApiAttributesKays = __webpack_require__(753);
	
	var _ApiService = __webpack_require__(754);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _tabList = __webpack_require__(756);
	
	var _tabList2 = _interopRequireDefault(_tabList);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var index = function (_Component) {
	  _inherits(index, _Component);
	
	  function index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, index);
	
	    var _this = _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).call(this, props));
	
	    _this.getUserPerformanceBarGraph = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var level = arguments[2];
	      var data, result, usersBarGraphData;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.setState(_defineProperty({}, 'performanceGraphLoaderPart' + level, true));
	
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate,
	                level: level
	              };
	              _context.next = 4;
	              return _ApiService2.default['getUserPerformanceBarGraph'](data);
	
	            case 4:
	              result = _context.sent;
	
	              if (!result.success) {
	                _context.next = 10;
	                break;
	              }
	
	              _context.next = 8;
	              return (0, _graphDataCalculator2.default)(result.userAttemptedAndAnsweredCount, _ApiAttributesKays.performanceGraphUserAttemptedCountKey, _ApiAttributesKays.performanceGraphUserAnsweredCountKey);
	
	            case 8:
	              usersBarGraphData = _context.sent;
	
	              _this.setState(_defineProperty({}, 'usersBarGraphDataPart' + level, usersBarGraphData));
	
	            case 10:
	              _this.setState(_defineProperty({}, 'performanceGraphLoaderPart' + level, false));
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getTotalUsersPerformanceBarGraph = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var level = arguments[2];
	
	      var data, result, _this$setState4, totalUsersBarGraphData, barLabel;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate,
	                level: level
	              };
	              _context2.next = 3;
	              return _ApiService2.default['getTotalUsersPerformanceBarGraph'](data);
	
	            case 3:
	              result = _context2.sent;
	
	              if (!result.success) {
	                _context2.next = 19;
	                break;
	              }
	
	              totalUsersBarGraphData = void 0;
	
	              if (!(formattedStartDate && formattedEndDate)) {
	                _context2.next = 12;
	                break;
	              }
	
	              _context2.next = 9;
	              return (0, _graphDataCalculator2.default)(result.attemptedCount, _ApiAttributesKays.performanceGraphUserAttemptedCountKey, _ApiAttributesKays.performanceGraphUserAnsweredCountKey);
	
	            case 9:
	              totalUsersBarGraphData = _context2.sent;
	              _context2.next = 15;
	              break;
	
	            case 12:
	              _context2.next = 14;
	              return (0, _graphDataCalculator2.default)(result.attemptedCount, _ApiAttributesKays.attemptedCountKey, _ApiAttributesKays.answeredCountKey);
	
	            case 14:
	              totalUsersBarGraphData = _context2.sent;
	
	            case 15:
	              _context2.next = 17;
	              return result.attemptedCount.map(function (chapters) {
	                return chapters[_ApiAttributesKays.chapterNameKey].substring(0, 14);
	              });
	
	            case 17:
	              barLabel = _context2.sent;
	
	              _this.setState((_this$setState4 = {}, _defineProperty(_this$setState4, 'totalUsersBarGraphDataPart' + level, totalUsersBarGraphData), _defineProperty(_this$setState4, 'barLabelPart' + level, barLabel), _this$setState4));
	
	            case 19:
	              _this.setState(_defineProperty({}, 'performanceGraphLoaderPart' + level, false));
	
	            case 20:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.getQuestionProgressBar = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var level = arguments[2];
	
	      var data, result, _this$setState7;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this.setState(_defineProperty({}, 'questionProgressBarLoaderPart' + level, true));
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate,
	                level: level
	              };
	              _context3.next = 4;
	              return _ApiService2.default['fetchQuestionProgressBar'](data);
	
	            case 4:
	              result = _context3.sent;
	
	              if (result.success) {
	                _this.setState((_this$setState7 = {}, _defineProperty(_this$setState7, 'questionProgressBarDataPart' + level, result.chapters), _defineProperty(_this$setState7, 'questionProgressBarLoaderPart' + level, false), _this$setState7));
	              }
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.getNotesProgressBar = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var formattedStartDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var formattedEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var level = arguments[2];
	
	      var data, result, _this$setState9;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.setState(_defineProperty({}, 'notesProgressBarLoaderPart' + level, true));
	              data = {
	                startDate: formattedStartDate,
	                endDate: formattedEndDate,
	                level: level
	              };
	              _context4.next = 4;
	              return _ApiService2.default['fetchNotesProgressBar'](data);
	
	            case 4:
	              result = _context4.sent;
	
	              if (result.success) {
	                _this.setState((_this$setState9 = {}, _defineProperty(_this$setState9, 'notesProgressBarDataPart' + level, result.chapters), _defineProperty(_this$setState9, 'notesProgressBarLoaderPart' + level, false), _this$setState9));
	              }
	
	            case 6:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.state = {
	      performanceGraphLoaderPart1: true,
	      performanceGraphLoaderPart2: true,
	      usersBarGraphDataPart1: [],
	      usersBarGraphDataPart2: [],
	      totalUsersBarGraphDataPart1: [],
	      totalUsersBarGraphDataPart2: [],
	      barLabelPart1: [],
	      barLabelPart2: [],
	      //^ progress bar state stated here
	      questionProgressBarDataPart1: [],
	      questionProgressBarDataPart2: [],
	      questionProgressBarLoaderPart1: true,
	      questionProgressBarLoaderPart2: true,
	      notesProgressBarDataPart1: [],
	      notesProgressBarDataPart2: [],
	      notesProgressBarLoaderPart1: true,
	      notesProgressBarLoaderPart2: true,
	      startDate: '',
	      endDate: ''
	    };
	    return _this;
	  }
	  //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
	
	
	  _createClass(index, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _state, startDate, endDate;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _state = this.state, startDate = _state.startDate, endDate = _state.endDate;
	
	                this.getUserPerformanceBarGraph(startDate, endDate, 1);
	                this.getUserPerformanceBarGraph(startDate, endDate, 2);
	                this.getTotalUsersPerformanceBarGraph(startDate, endDate, 1);
	                this.getTotalUsersPerformanceBarGraph(startDate, endDate, 2);
	                this.getQuestionProgressBar(startDate, endDate, 1);
	                this.getQuestionProgressBar(startDate, endDate, 2);
	                this.getNotesProgressBar(startDate, endDate, 1);
	                this.getNotesProgressBar(startDate, endDate, 2);
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
	
	    //*=========================={{ PERFORMANCE GRAPH FUNCTION START HERE }}======================================
	
	    //*=========================={{ PERFORMANCE GRAPH FUNCTION ENDED HERE }}======================================
	
	    //*================================{{QUESTION AND NOTES PROGRESS BAR FUNCTIONS START HERE }}====================================
	
	  }, {
	    key: 'render',
	
	
	    //*============================={{QUESTION AND NOTES PROGRESS BAR FUNCTIONS ENDED HERE }}======================================
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.DASHBOARD, className: 'frm_title_logo_wrap' },
	          _react2.default.createElement('img', { src: _GARP_logo2.default, className: 'garpLogo', alt: 'full logo' })
	        ),
	        ['1', '2'].map(function (level) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 mt-3' },
	              _react2.default.createElement(
	                _ComponentHeader2.default,
	                { title: _messages.messages['FRM_DASHBOARD_PART_' + level] },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-primary pointer_class',
	                    onClick: function onClick() {
	                      return _this3.context.router.push({
	                        pathname: _AppRoutes2.default['FRM_V2_DETAILS_STATS_LEVEL' + level]
	                      });
	                    }
	                    // disabled={state[`isButtonDisablePart${level}`]}
	                  },
	                  _messages.messages.DETAILED_STATS
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8' },
	              _react2.default.createElement(_DateFilter2.default, {
	                getUserBarGraph: _this3.getUserPerformanceBarGraph,
	                getTotalUsersBarGraph: _this3.getTotalUsersPerformanceBarGraph,
	                level: level
	              }),
	              _react2.default.createElement(_PerformanceGraph2.default, {
	                barLabel: state['barLabelPart' + level],
	                headText: _messages.messages.PERFORMANCE,
	                tooltipContent: _messages.messages.SEPARATE_YOUR_RESULT,
	                tooltipPlace: 'left',
	                performanceGraphLoader: state['performanceGraphLoaderPart' + level],
	                usersBarGraphData: state['usersBarGraphDataPart' + level],
	                totalUsersBarGraphData: state['totalUsersBarGraphDataPart' + level]
	              }),
	              _react2.default.createElement(_TabList2.default, {
	                section: 'favAPIService',
	                level: level,
	                exam: 'frm',
	                TabHeader: _messages.messages.MY_SAVED_ITEM_WITH_FLASH_CARD,
	                apiServiceProvider: _ApiService2.default,
	                tabList: _tabList2.default
	              }),
	              _react2.default.createElement(_TabList2.default, {
	                section: 'reportAPIService',
	                level: level,
	                exam: 'frm',
	                TabHeader: _messages.messages.MY_REPORTS,
	                apiServiceProvider: _ApiService2.default,
	                tabList: _tabList2.default
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(_ProgressBar2.default, {
	                headerName: _messages.messages.QUESTION_PROGRESS,
	                ProgressBarData: state['questionProgressBarDataPart' + level],
	                progressBarLoader: state['questionProgressBarLoaderPart' + level],
	                ProgressBarTables: {
	                  questionModel: _ApiAttributesKays.questionTableNameKey,
	                  questionStatsModel: _ApiAttributesKays.questionStatsTableNameKey
	                }
	              }),
	              _react2.default.createElement(_ProgressBar2.default, {
	                headerName: 'Notes Progress',
	                ProgressBarData: state['notesProgressBarDataPart' + level],
	                progressBarLoader: state['notesProgressBarLoaderPart' + level],
	                countKey: 'notesCount',
	                ProgressBarTables: {
	                  questionModel: _ApiAttributesKays.notesTableNameKey,
	                  questionStatsModel: _ApiAttributesKays.notesStatsTableNameKey
	                }
	              })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return index;
	}(_react.Component);
	
	index.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = index;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabList = [{
	  label: 'Question',
	  idFieldName: 'questionId',
	  // SAVED ITEM LIST START HERE
	  favAPIService: 'fetchSavedQuestion',
	  saveItemDeleteAPIService: 'deleteSavedQuestion',
	  savedItemTitle: 'Question ID', // that is tabs title with ID
	  saveItemTableName: 'questions_frm', // table name to access object or save item
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	
	  //* REPORTED ITEM LIST START HERE
	  reportAPIService: 'fetchReportedQuestion',
	  reportedItemTableKey: 'comment',
	  reportDeleteAPIService: 'deleteReportedQuestion',
	  // VIEW ITEM LIST START HERE
	  viewItemAPIService: '',
	  redirectionPath: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_VIEW,
	  // EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedQuestion'
	}, {
	  label: 'Notes',
	  //* SAVED ITEM LIST START HERE
	  favAPIService: 'fetchSavedNotes',
	  idFieldName: 'notesId',
	  saveItemDeleteAPIService: 'deleteSavedNotes',
	  savedItemTitle: 'Notes ID', // that is tabs title with ID
	  saveItemTableName: 'frm_note', // table name to access object or save item
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	  //* REPORTED ITEM LIST START HERE
	  reportAPIService: 'fetchReportedNotes',
	  reportedItemTableKey: 'comment',
	  reportDeleteAPIService: 'deleteReportedNotes',
	  //* VIEW ITEM LIST START HERE
	  viewItemAPIService: '',
	  redirectionPath: _AppRoutes2.default.FRM_V2_NOTES_VIEW,
	  //* EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedNotes'
	}, {
	  label: 'Video',
	  //* SAVED ITEM LIST START HERE
	  idFieldName: 'video_id',
	  favAPIService: 'fetchSavedVideos',
	  saveItemDeleteAPIService: 'deleteSavedVideo',
	  savedItemTitle: 'Video Id', // that is tabs title with ID
	  saveItemTableName: 'frm_video', // table name to access object or save item
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	  //* REPORTED ITEM LIST START HERE
	  reportAPIService: 'fetchReportedVideos',
	  reportedItemTableKey: 'comment',
	  reportDeleteAPIService: 'deleteReportedVideo',
	  //* VIEW ITEM LIST START HERE
	  viewItemAPIService: '',
	  redirectionPath: _AppRoutes2.default.FRM_V2_VIDEOS_PLAYLIST,
	  //* EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedVideo'
	}, {
	  label: 'Mocks',
	  idFieldName: 'questionId',
	
	  reportAPIService: 'fetchCBTReportedQuestion',
	  savedItemTitle: 'CBT Question ID',
	  saveItemTableName: 'frm_cbt_question',
	  savedItemTableKey: 'name', // key name to represent topic which is show in tab
	  reportedItemTableKey: 'comment',
	  viewItemAPIService: 'redirectToCBTQuestion',
	  redirectionPath: _AppRoutes2.default.FRM_V2_CBT_FINISH_PAGE,
	  reportDeleteAPIService: 'deleteCBTReportedQuestion',
	  // EDIT REPORT LIST START HERE
	  editAPIService: 'updateReportedCBTQuestion'
	}];
	
	exports.default = tabList;

/***/ },
/* 757 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  readingIdKey: 'reading_id',
	  chapterNameKay: 'chapterName',
	  totalReadingKey: 'TotalReading',
	  freeQuestionsCountKey: 'TotalFreeQuestions',
	  premiumQuestionsCountKey: 'TotalQuestions',
	  tableKey: 'frm_note',
	  tableChapterKey: 'chapter_id',
	  //* notes key's
	  totalNotesKey: 'TotalNotes'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchChaptersWithPremiumAndFreeCount = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/notes/notes-wise-count', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchChaptersWithPremiumAndFreeCount(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var downloadFormulaSheet = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/notes/additional-resources', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function downloadFormulaSheet(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var fetchLastNoteRead = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/notes/last-notes-answered', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchLastNoteRead() {
	    return _ref3.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchChaptersWithPremiumAndFreeCount: fetchChaptersWithPremiumAndFreeCount,
	  fetchLastNoteRead: fetchLastNoteRead,
	  downloadFormulaSheet: downloadFormulaSheet
	};

/***/ },
/* 759 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  readingNameKey: 'readingName',
	  freeQuestionCountKey: 'TotalFreeQuestion',
	  TotalNotesCountKey: 'TotalNotes',
	  chapterIdKey: 'chapter_no',
	  chapterNameKey: 'chapter_name'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchReadingList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/notes/reading', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchReadingList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchChapterNameById = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/chapter-by-id', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchChapterNameById(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var pdfDownloadViaEmail = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/PdfDownloadViaEmail', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchReadingList: fetchReadingList,
	  fetchChapterNameById: fetchChapterNameById,
	  pdfDownloadViaEmail: pdfDownloadViaEmail
	};

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReadingList = __webpack_require__(135);
	
	var _ReadingList2 = _interopRequireDefault(_ReadingList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _ApiAttributesKays = __webpack_require__(759);
	
	var _ApiService = __webpack_require__(760);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReadingsList = function (_Component) {
	  _inherits(ReadingsList, _Component);
	
	  function ReadingsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ReadingsList);
	
	    var _this = _possibleConstructorReturn(this, (ReadingsList.__proto__ || Object.getPrototypeOf(ReadingsList)).call(this, props));
	
	    _this.checkSubscription = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cb, type) {
	        var isUserSubscribed;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                isUserSubscribed = _this.state.isUserSubscribed;
	
	                if (isUserSubscribed) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt('return', _this.setState({ openPremiumPopup: true }));
	
	              case 3:
	                cb();
	                _this.setState({ PDFDownloadType: type });
	                _this.pdfAlertModel();
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.pdfAlertModel = function () {
	      _this.setState({ pdfAlert: !_this.state.pdfAlert });
	    };
	
	    _this.onBeginChapter = function (items) {
	      var isUserSubscribed = _this.state.isUserSubscribed;
	
	      if (!items[_ApiAttributesKays.TotalNotesCountKey]) {
	        (0, _toast.showInformation)(_messages.messages.NOTES_NOT_AVAILABLE_FOR_READING);
	      } else {
	        if (!isUserSubscribed) {
	          return _this.setState({ openPremiumPopup: true });
	        } else {
	          var router = _this.context.router;
	
	          router.push({
	            pathname: _AppRoutes2.default.FRM_V2_NOTES_VIEW.replace(':level', items.level).replace(':readingId', items.id).replace(':chapterId', items[_ApiAttributesKays.chapterIdKey])
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      selectedExamSubscriptionDetails: {},
	      chapterName: '',
	      pdfAlert: false,
	      openPremiumPopup: false,
	      isUserSubscribed: false,
	      readingListData: [],
	      isLoading: true
	    };
	    return _this;
	  }
	
	  _createClass(ReadingsList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props$params, chapterId, level, fetchReadingListData, readings, selectedExamSubscriptionDetails, chapterName, router;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props$params = this.props.params, chapterId = _props$params.chapterId, level = _props$params.level;
	                _context2.next = 3;
	                return _ApiService2.default['fetchReadingList']({ chapterId: chapterId, level: level });
	
	              case 3:
	                fetchReadingListData = _context2.sent;
	
	                if (fetchReadingListData.success) {
	                  readings = fetchReadingListData.readings, selectedExamSubscriptionDetails = fetchReadingListData.selectedExamSubscriptionDetails, chapterName = fetchReadingListData.chapterName;
	
	                  if (selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 || selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + level] || chapterId === '1' || chapterId === '5') {
	                    this.setState({ isUserSubscribed: true });
	                  }
	
	                  this.setState({
	                    readingListData: readings,
	                    selectedExamSubscriptionDetails: selectedExamSubscriptionDetails,
	                    isLoading: false,
	                    chapterName: Object.keys(chapterName).length && chapterName[_ApiAttributesKays.chapterNameKey]
	                  });
	                } else {
	                  router = this.context.router;
	
	                  router.push({ pathname: _AppRoutes2.default.FRM_V2_NOTES });
	                  (0, _toast.showFailure)(_messages.messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER);
	                }
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var params = this.props.params;
	      var chapterId = params.chapterId,
	          level = params.level;
	      var _state = this.state,
	          chapterName = _state.chapterName,
	          pdfAlert = _state.pdfAlert,
	          openPremiumPopup = _state.openPremiumPopup,
	          isUserSubscribed = _state.isUserSubscribed,
	          readingListData = _state.readingListData,
	          _state$isLoading = _state.isLoading,
	          isLoading = _state$isLoading === undefined ? false : _state$isLoading;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: chapterId + '. ' + chapterName },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return _ApiService2.default['pdfDownloadViaEmail']({
	                      chapterId: chapterId,
	                      frmLevel: level
	                    });
	                  }, 'Question');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _messages.messages.DOWNLOAD_NOTE
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return router.push({ pathname: _AppRoutes2.default.FRM_V2_NOTES });
	                } },
	              _messages.messages.CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(_ReadingList2.default, {
	            tableName: _messages.messages.CHAPTER_READING,
	            readingData: readingListData,
	            onViewList: this.onViewList,
	            isViewListIcon: false,
	            onBeginChapter: this.onBeginChapter
	          })
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: pdfAlert,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return ReadingsList;
	}(_react.Component);
	
	ReadingsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ReadingsList;

/***/ },
/* 762 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  notesIdKey: 'id',
	  notesNameKey: 'name',
	  notesReadingIdKey: 'reading_id',
	  descriptionKey: 'discription',
	  notesStatsKey: 'frm_notes_stat.answer_status'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchNotes = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/notes/all-notes', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchNotes(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchSavedQuestion = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFavNotes', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/unsaveFavNotesByUserID', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/saveFavNotesByUserID', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function saveQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var fetchNotesStats = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getsavestatesNotes', {
	              question_id: data.id,
	              level: data.level
	            });
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function fetchNotesStats(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var saveNotesStats = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/saveNotesstats', {
	              notes_id: data.id,
	              level: data.level,
	              frmLevel: data.level
	            });
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveNotesStats(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	var reportQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/reportQuestion', data);
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function reportQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchNotes: fetchNotes,
	  fetchSavedQuestion: fetchSavedQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  saveQuestion: saveQuestion,
	  fetchNotesStats: fetchNotesStats,
	  saveNotesStats: saveNotesStats,
	  reportQuestion: reportQuestion
	};

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardFooter = __webpack_require__(251);
	
	var _CardFooter2 = _interopRequireDefault(_CardFooter);
	
	var _CustomCard = __webpack_require__(252);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	var _notes_icon = __webpack_require__(198);
	
	var _notes_icon2 = _interopRequireDefault(_notes_icon);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _CardBlockLoaderWrapper = __webpack_require__(261);
	
	var _CardBlockLoaderWrapper2 = _interopRequireDefault(_CardBlockLoaderWrapper);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ApiAttributesKays = __webpack_require__(762);
	
	var _ApiService = __webpack_require__(763);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewNotes = function (_Component) {
	  _inherits(ViewNotes, _Component);
	
	  function ViewNotes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewNotes);
	
	    var _this = _possibleConstructorReturn(this, (ViewNotes.__proto__ || Object.getPrototypeOf(ViewNotes)).call(this, props));
	
	    _this.onSetCurrentNote = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(notesData) {
	        var _this$props$params, notesId, readingId, index, _index;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props$params = _this.props.params, notesId = _this$props$params.notesId, readingId = _this$props$params.readingId;
	
	                if (notesId !== ':notesId') {
	                  index = notesData.findIndex(function (item) {
	                    return item[_ApiAttributesKays.notesIdKey] === parseInt(notesId, 10);
	                  });
	
	                  _this.setState({ currentIndex: index });
	                } else {
	                  _index = notesData.findIndex(function (item) {
	                    return item[_ApiAttributesKays.notesReadingIdKey] === parseInt(readingId, 10);
	                  });
	
	                  _this.setState({ currentIndex: _index });
	                }
	                _this.setState({ isLoading: false });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.resetStates = function () {
	      _this.setState({
	        showAnswer: false,
	        showReportSection: false,
	        selectedChoice: '',
	        stopTimer: false
	      });
	    };
	
	    _this.replaceRoute = function (index) {
	      var notesList = _this.state.notesList;
	      var _this$props$params2 = _this.props.params,
	          readingId = _this$props$params2.readingId,
	          chapterId = _this$props$params2.chapterId,
	          notesId = _this$props$params2.notesId,
	          level = _this$props$params2.level;
	      var router = _this.context.router;
	
	
	      var id = notesList[index] ? notesList[index].id : notesId;
	
	      router.push({
	        pathname: _AppRoutes2.default.FRM_V2_NOTES_VIEW.replace(':level', level).replace(':readingId', readingId).replace(':chapterId', chapterId).replace(':notesId', id)
	      });
	      _this.setState({ currentIndex: index, currentNoteObj: notesList[index] });
	    };
	
	    _this.getPreviousQuestion = function () {
	      var currentIndex = _this.state.currentIndex;
	
	      if (parseInt(currentIndex, 10) > 0) {
	        _this.replaceRoute(currentIndex - 1);
	        _this.resetStates();
	      }
	    };
	
	    _this.getNextQuestion = function () {
	      var _this$state = _this.state,
	          notesList = _this$state.notesList,
	          currentIndex = _this$state.currentIndex;
	
	      var index = parseInt(currentIndex, 10) + 1;
	      if (index < notesList.length) {
	        _this.replaceRoute(index);
	        _this.resetStates();
	      }
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.hideReportSection = function () {
	      _this.setState({ showReportSection: false });
	    };
	
	    _this.state = {
	      isLoading: true,
	      notesList: [],
	      currentNoteObj: {},
	      isFlashCardHidden: true
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(ViewNotes, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props$params, level, readingId, chapterId, result, questions;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props$params = this.props.params, level = _props$params.level, readingId = _props$params.readingId, chapterId = _props$params.chapterId;
	                _context2.next = 3;
	                return _ApiService2.default['fetchNotes']({ level: level, readingId: readingId, chapterId: chapterId });
	
	              case 3:
	                result = _context2.sent;
	
	                if (!result.success) {
	                  _context2.next = 9;
	                  break;
	                }
	
	                questions = result.questions;
	
	                this.setState({ isLoading: false, notesList: questions });
	                _context2.next = 9;
	                return this.onSetCurrentNote(questions);
	
	              case 9:
	                this.setState({ isLoading: false });
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          notesList = _state.notesList,
	          currentIndex = _state.currentIndex,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          showReportSection = _state.showReportSection;
	      var _props$params2 = this.props.params,
	          level = _props$params2.level,
	          chapterId = _props$params2.chapterId;
	      var router = this.context.router;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row col-sm-12 d-block' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.NOTES, className: 'note-section notes_inner_title_wrap ' },
	          _react2.default.createElement(
	            _CustomButton2.default,
	            {
	              onClick: function onClick() {
	                return router.push({
	                  pathname: _AppRoutes2.default.FRM_V2_NOTES_READING_LIST.replace(':level', level).replace(':chapterId', chapterId),
	                  state: notesList.length && { notesList: notesList }
	                });
	              }
	            },
	            _messages.messages.CHANGE_READING
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _CustomCard2.default,
	            { style: isLoading && { height: '800px' } },
	            _react2.default.createElement(_CardBlockLoaderWrapper2.default, { isLoading: isLoading }),
	            currentIndex >= 0 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesNameKey] + ' (N. ' + notesList[currentIndex][_ApiAttributesKays.notesIdKey] + ')',
	                showPreviousButton: true,
	                showNextButton: true,
	                headerImage: _notes_icon2.default,
	                arrayLength: notesList.length,
	                disabledPreviousButton: currentIndex < 1,
	                disabledNextButton: !(currentIndex < notesList.length - 1),
	                getPreviousQuestion: this.getPreviousQuestion,
	                getNextQuestion: this.getNextQuestion
	              }),
	              (0, _function.renderHTMLContent)(notesList.length && notesList[currentIndex][_ApiAttributesKays.descriptionKey], "div", "mt-3 note_text_wrap"),
	              _react2.default.createElement(_CardFooter2.default, {
	                isLoading: isLoading,
	                savePayLoad: {
	                  question_id: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey],
	                  level: level
	                },
	                level: level,
	                favItemId: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey],
	                setChildRef: this.childRef,
	                apiServiceProvider: _ApiService2.default,
	                onSaveItemChange: this.onSaveItemChange,
	                toggleReportSection: this.toggleReportSection
	              })
	            ) : _react2.default.createElement(
	              'h1',
	              { className: 'text-center pt-3 pb-3' },
	              !isLoading && _messages.messages.NO_DATA_FOUND
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 note-section p-0' },
	          currentIndex >= 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey] },
	              type: 'notes',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'frm',
	              level: level
	            }),
	            showReportSection && _react2.default.createElement(_ReportCard2.default, {
	              hideReportSection: this.hideReportSection,
	              apiServiceProvider: _ApiService2.default,
	              itemId: notesList.length && notesList[currentIndex][_ApiAttributesKays.notesIdKey],
	              keyId: 'question_id'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ViewNotes;
	}(_react.Component);
	
	ViewNotes.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ViewNotes;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Notes = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _GARP_logo = __webpack_require__(165);
	
	var _GARP_logo2 = _interopRequireDefault(_GARP_logo);
	
	var _notes_icon = __webpack_require__(301);
	
	var _notes_icon2 = _interopRequireDefault(_notes_icon);
	
	var _ChapterCards = __webpack_require__(134);
	
	var _ChapterCards2 = _interopRequireDefault(_ChapterCards);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _ApiAttributesKays = __webpack_require__(757);
	
	var _ApiService = __webpack_require__(758);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notes = exports.Notes = function (_Component) {
	  _inherits(Notes, _Component);
	
	  function Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Notes);
	
	    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var state;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              state = _this.props.location.state;
	
	              if (!(state && state.chapterDataPart1 && state.chapterDataPart2)) {
	                _this.getChapterWiseCount({ level: 1 });
	                _this.getChapterWiseCount({ level: 2 });
	              } else {
	                _this.setState(Object.assign({}, state, { isLoading: false }));
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getChapterWiseCount = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(level) {
	        var result, _this$setState;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _ApiService2.default['fetchChaptersWithPremiumAndFreeCount'](level);
	
	              case 2:
	                result = _context2.sent;
	
	                if (result.success) {
	                  _this.setState((_this$setState = {
	                    isLoading: false
	                  }, _defineProperty(_this$setState, 'chapterDataPart' + level.level, result.data), _defineProperty(_this$setState, 'isUserSubscribedPart' + level.level, result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + level.level] && result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + level.level].noteStatus), _defineProperty(_this$setState, 'isUserSubscribedBoth', result.selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 && result.selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2.noteStatus), _this$setState));
	                }
	                _this.setState({ isLoading: false });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToLastNoteRead = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(level) {
	        var result, data, router;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this.setState(_defineProperty({}, 'isButtonDisablePart' + level.level, true));
	                _context3.next = 3;
	                return _ApiService2.default['fetchLastNoteRead'](level);
	
	              case 3:
	                result = _context3.sent;
	
	                _this.setState(_defineProperty({}, 'isButtonDisablePart' + level.level, false));
	
	                //* FIRST OF ALL CHECK THE REDIRECTION
	                if (result.success) {
	                  data = result.data;
	                  router = _this.context.router;
	
	                  router.push({
	                    pathname: _AppRoutes2.default.FRM_V2_NOTES_VIEW.replace(':level', level.level).replace(':readingId', data[_ApiAttributesKays.tableKey][_ApiAttributesKays.readingIdKey]).replace(':questionId', data[_ApiAttributesKays.tableKey].id).replace(':chapterId', data[_ApiAttributesKays.tableKey][_ApiAttributesKays.tableChapterKey])
	                  });
	                } else {
	                  (0, _toast.showInformation)(_messages.messages.NOTES_NOT_AVAILABLE);
	                }
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.state = {
	      chapterId: '',
	      questionId: '',
	      isLoading: true,
	      isButtonDisablePart1: false,
	      isButtonDisablePart2: false,
	      isUserSubscribedBoth: false,
	      isUserSubscribedPart1: false,
	      isUserSubscribedPart2: false,
	      openPremiumPopup: false,
	      chapterDataPart1: [],
	      chapterDataPart2: [],
	      selectedExamSubscriptionDetails: {}
	    };
	    return _this;
	  }
	  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
	
	  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
	
	  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================
	
	  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
	
	
	  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================
	
	  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
	
	  //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================
	
	  _createClass(Notes, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state,
	          context = this.context;
	      var imageWidth = state.imageWidth,
	          isLoading = state.isLoading,
	          isUserSubscribedBoth = state.isUserSubscribedBoth,
	          openPremiumPopup = state.openPremiumPopup,
	          chapterDataPart1 = state.chapterDataPart1,
	          chapterDataPart2 = state.chapterDataPart2;
	      var router = context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.NOTES, className: 'frm_title_logo_wrap' },
	          _react2.default.createElement('img', {
	            src: _GARP_logo2.default,
	            className: 'garpLogo',
	            alt: 'full logo'
	          })
	        ),
	        ['1', '2'].map(function (level) {
	          return _react2.default.createElement(
	            'div',
	            { key: level },
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              { title: _messages.messages['FRM_TOPIC_PART_' + level] },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                {
	                  className: 'bg-completed-cases overflow-hidden max-width-min-content ml-auto',
	                  onClick: function onClick() {
	                    isUserSubscribedBoth || state['isUserSubscribedPart' + level] ? _ApiService2.default['downloadFormulaSheet']({
	                      type: 'Formula sheet',
	                      level: level
	                    }).then(function (res) {
	                      return (0, _function.openPDF)(res);
	                    }) : _this3.toggleAlert();
	                  }
	                },
	                _react2.default.createElement('i', { className: 'fa fa-download pr-1', 'aria-hidden': 'true' }),
	                !(isUserSubscribedBoth || state['isUserSubscribedPart' + level]) && _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  'Premium'
	                ),
	                _messages.messages.FORMULA_SHEET
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: function onClick() {
	                    return _this3.redirectToLastNoteRead({ level: level });
	                  },
	                  disabled: state['isButtonDisablePart' + level]
	                },
	                state['isButtonDisablePart' + level] && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	                _messages.messages.GO_TO_MY_LAST_READ_NOTE
	              )
	            ),
	            _react2.default.createElement(
	              _LoaderWrapper2.default,
	              { isLoading: isLoading },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'seperator-block-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        state['chapterDataPart' + level].length && state['chapterDataPart' + level].map(function (item, index) {
	                          return _react2.default.createElement(_ChapterCards2.default, Object.assign({
	                            onClick: function onClick() {
	                              return isUserSubscribedBoth || state['isUserSubscribedPart' + level] || index === 0 ? router.push({
	                                pathname: _AppRoutes2.default.FRM_V2_NOTES_READING_LIST.replace(':level', level).replace(':chapterId', item[_ApiAttributesKays.chapterIdKey]),
	                                state: { chapterDataPart1: chapterDataPart1, chapterDataPart2: chapterDataPart2 }
	                              }) : _this3.toggleAlert();
	                            },
	                            key: item[_ApiAttributesKays.chapterIdKey],
	                            headerImage: _notes_icon2.default,
	                            headerImageWidth: imageWidth,
	                            chapterNumber: item[_ApiAttributesKays.chapterIdKey],
	                            chapterName: item[_ApiAttributesKays.chapterNameKay],
	                            totalNotes: item[_ApiAttributesKays.totalNotesKey],
	                            userSubscriptionDetails: isUserSubscribedBoth || state['isUserSubscribedPart' + level],
	                            callingComponent: 'notes',
	                            free: index === 0
	                          }, _this3.props));
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm
	        })
	      );
	    }
	  }]);
	
	  return Notes;
	}(_react.Component);
	
	Notes.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = Notes;

/***/ },
/* 766 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapterId',
	  readingIdKey: 'reading_id',
	  chapterNameKay: 'chapterName',
	  totalReadingKey: 'TotalReading',
	  freeQuestionsCountKey: 'TotalFreeQuestions',
	  premiumQuestionsCountKey: 'TotalQuestions',
	  questionTableKey: 'questions_frm'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchChaptersWithPremiumAndFreeCount = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/question-bank/chapter-wise-count', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchChaptersWithPremiumAndFreeCount(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchLastAnsweredQuestion = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/question-bank/last-question-answered', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchLastAnsweredQuestion() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchChaptersWithPremiumAndFreeCount: fetchChaptersWithPremiumAndFreeCount,
	  fetchLastAnsweredQuestion: fetchLastAnsweredQuestion
	};

/***/ },
/* 768 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  readingNameKey: 'readingName',
	  freeQuestionCountKey: 'TotalFreeQuestion',
	  TotalQuestionCountKey: 'TotalQuestion',
	  chapterIdKey: 'chapterId',
	  chapterNameKey: 'chapter_name'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchReadingList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/question-bank/reading', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchReadingList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchChapterNameById = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/chapter-by-id', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchChapterNameById(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var pdfDownloadViaEmail = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/question-bank/pdf-download', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchReadingList: fetchReadingList,
	  fetchChapterNameById: fetchChapterNameById,
	  pdfDownloadViaEmail: pdfDownloadViaEmail
	};

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReadingList = __webpack_require__(135);
	
	var _ReadingList2 = _interopRequireDefault(_ReadingList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _ApiService = __webpack_require__(769);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ApiAttributesKays = __webpack_require__(768);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReadingsList = function (_Component) {
	  _inherits(ReadingsList, _Component);
	
	  function ReadingsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ReadingsList);
	
	    var _this = _possibleConstructorReturn(this, (ReadingsList.__proto__ || Object.getPrototypeOf(ReadingsList)).call(this, props));
	
	    _this.checkSubscription = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cb, type) {
	        var isUserSubscribed;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                isUserSubscribed = _this.state.isUserSubscribed;
	
	                if (isUserSubscribed) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt('return', _this.setState({ openPremiumPopup: true }));
	
	              case 3:
	                cb();
	                _this.setState({ PDFDownloadType: type });
	                _this.pdfAlertModel();
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.pdfAlertModel = function () {
	      _this.setState({ pdfAlert: !_this.state.pdfAlert });
	    };
	
	    _this.onViewList = function (items) {
	      var level = _this.props.params.level;
	      var isUserSubscribed = _this.state.isUserSubscribed;
	
	      if (!isUserSubscribed && items[_ApiAttributesKays.freeQuestionCountKey] === 0) {
	        return _this.setState({ openPremiumPopup: true });
	      } else {
	        if (!items[_ApiAttributesKays.TotalQuestionCountKey]) {
	          (0, _toast.showInformation)(_messages.messages.QUESTION_NOT_AVAILABLE_FOR_READING);
	        } else {
	          var router = _this.context.router;
	
	
	          router.push({
	            pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_LIST.replace(':level', level).replace(':readingId', items.id)
	          });
	        }
	      }
	    };
	
	    _this.onBeginChapter = function (items) {
	      var isUserSubscribed = _this.state.isUserSubscribed;
	
	      if (!isUserSubscribed && items[_ApiAttributesKays.freeQuestionCountKey] === 0) {
	        return _this.setState({ openPremiumPopup: true });
	      } else {
	        if (!items[_ApiAttributesKays.TotalQuestionCountKey]) {
	          (0, _toast.showInformation)(_messages.messages.QUESTION_NOT_AVAILABLE_FOR_READING);
	        } else {
	          var router = _this.context.router;
	
	
	          router.push({
	            pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(':level', items.level).replace(':readingId', items.id)
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      selectedExamSubscriptionDetails: {},
	      chapterName: '',
	      pdfAlert: false,
	      openPremiumPopup: false,
	      isUserSubscribed: false,
	      readingListData: [],
	      isLoading: true
	    };
	    return _this;
	  }
	
	  _createClass(ReadingsList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props$params, chapterId, level, fetchReadingListData, readings, selectedExamSubscriptionDetails;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props$params = this.props.params, chapterId = _props$params.chapterId, level = _props$params.level;
	                _context2.next = 3;
	                return _ApiService2.default['fetchReadingList']({ chapterId: chapterId });
	
	              case 3:
	                fetchReadingListData = _context2.sent;
	
	                if (fetchReadingListData.success) {
	                  readings = fetchReadingListData.readings, selectedExamSubscriptionDetails = fetchReadingListData.selectedExamSubscriptionDetails;
	
	                  if (Object.keys(selectedExamSubscriptionDetails).length) {
	                    if (selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 || selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + level]) this.setState({ isUserSubscribed: true });
	                  }
	                  this.setState({
	                    readingListData: readings,
	                    selectedExamSubscriptionDetails: selectedExamSubscriptionDetails,
	                    isLoading: false,
	                    chapterName: fetchReadingListData.chapterName[_ApiAttributesKays.chapterNameKey]
	                  });
	                }
	                this.setState({ isLoading: false });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var params = this.props.params;
	      var chapterId = params.chapterId,
	          level = params.level;
	      var _state = this.state,
	          chapterName = _state.chapterName,
	          pdfAlert = _state.pdfAlert,
	          openPremiumPopup = _state.openPremiumPopup,
	          isUserSubscribed = _state.isUserSubscribed,
	          readingListData = _state.readingListData,
	          _state$isLoading = _state.isLoading,
	          isLoading = _state$isLoading === undefined ? false : _state$isLoading;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: chapterId + '. ' + chapterName },
	          _react2.default.createElement(
	            'div',
	            { className: 'download-pdf-button' },
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return _ApiService2.default['pdfDownloadViaEmail']({
	                      pdfType: 'question',
	                      chapterId: chapterId,
	                      level: level
	                    });
	                  }, 'Question');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download pr-1', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _messages.messages.DOWNLOAD_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'bg-completed-cases overflow-hidden max-width-min-content',
	                onClick: function onClick() {
	                  _this3.checkSubscription(function () {
	                    return _ApiService2.default['pdfDownloadViaEmail']({
	                      pdfType: 'questionAnswer',
	                      chapterId: chapterId,
	                      level: level
	                    });
	                  }, 'Question/Answer');
	                }
	              },
	              _react2.default.createElement('i', { className: 'fa fa-download pr-1', 'aria-hidden': 'true' }),
	              !isUserSubscribed && _react2.default.createElement(
	                'div',
	                { className: 'premium-download' },
	                'Premium'
	              ),
	              _messages.messages.DOWNLOAD_QUESTION_ANSWER
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              { onClick: function onClick() {
	                  return router.push({ pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK });
	                } },
	              _messages.messages.CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(_ReadingList2.default, {
	            readingData: readingListData,
	            tableName: _messages.messages.CHAPTER_READING,
	            onViewList: this.onViewList,
	            onBeginChapter: this.onBeginChapter
	          })
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm,
	          exam: 'FRM'
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Question',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: pdfAlert,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return ReadingsList;
	}(_react.Component);
	
	ReadingsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = ReadingsList;

/***/ },
/* 771 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapter_id',
	  readingNameKey: 'name',
	  correctChoiceKey: 'right_choice',
	  readingIdKay: 'reading_id',
	  readingIdParamsKey: 'readingId',
	  questionIdKey: 'id',
	  questionIdParamsKey: 'questionId',
	  answerKey: 'answer',
	  questionKey: 'question',
	  isAttemptedKey: 'isAttempted'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var saveQuestionAttemptStats = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveStats', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function saveQuestionAttemptStats(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchChapterNameById = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/chapter-by-id', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchChapterNameById(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var pdfDownloadViaEmail = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/pdf-download-via-email', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var fetchSavedQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestions', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveQuestion', data);
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function saveQuestion(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/unsaveQuestion', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var fetchQuestionsReadingWise = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/question-bank/all-questions', data);
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function fetchQuestionsReadingWise(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	var reportQuestion = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/reportQuestion', data);
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function reportQuestion(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	module.exports = {
	  saveQuestionAttemptStats: saveQuestionAttemptStats,
	  fetchQuestionsReadingWise: fetchQuestionsReadingWise,
	  fetchChapterNameById: fetchChapterNameById,
	  pdfDownloadViaEmail: pdfDownloadViaEmail,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  reportQuestion: reportQuestion
	};

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(772);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _CustomCard = __webpack_require__(61);
	
	var _CustomCard2 = _interopRequireDefault(_CustomCard);
	
	var _CustomCardHeader = __webpack_require__(54);
	
	var _CustomCardHeader2 = _interopRequireDefault(_CustomCardHeader);
	
	var _CustomCardBody = __webpack_require__(62);
	
	var _CustomCardBody2 = _interopRequireDefault(_CustomCardBody);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _QuestionBankFooter = __webpack_require__(253);
	
	var _QuestionBankFooter2 = _interopRequireDefault(_QuestionBankFooter);
	
	var _index = __webpack_require__(171);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ApiAttributesKays = __webpack_require__(771);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _toast = __webpack_require__(15);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	var _question_icon_blue = __webpack_require__(69);
	
	var _question_icon_blue2 = _interopRequireDefault(_question_icon_blue);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionView = function (_Component) {
	  _inherits(QuestionView, _Component);
	
	  function QuestionView(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionView);
	
	    var _this = _possibleConstructorReturn(this, (QuestionView.__proto__ || Object.getPrototypeOf(QuestionView)).call(this, props));
	
	    _this.onSetCurrentQuestion = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(questionsData) {
	        var questionId, index;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	                questionId = _this.props.params.questionId;
	
	                if (questionId !== ':questionId') {
	                  index = questionsData.findIndex(function (item) {
	                    return item[_ApiAttributesKays.questionIdKey] === parseInt(questionId, 10);
	                  });
	
	                  _this.setState({
	                    currentIndex: index > -1 ? index : 0,
	                    currentQuestion: questionsData[index > -1 ? index : 0]
	                  });
	                } else {
	                  _this.setState({ currentQuestion: questionsData[0] });
	                }
	                _this.setState({ isLoading: false });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getPreviousQuestion = function () {
	      var currentIndex = _this.state.currentIndex;
	
	      if (parseInt(currentIndex, 10) > 0) {
	        _this.replaceRoute(currentIndex - 1);
	        _this.resetStates();
	      }
	    };
	
	    _this.getNextQuestion = function () {
	      var _this$state = _this.state,
	          questionData = _this$state.questionData,
	          currentIndex = _this$state.currentIndex;
	
	      var index = parseInt(currentIndex, 10) + 1;
	      if (index < questionData.length) {
	        _this.replaceRoute(index);
	        _this.resetStates();
	      }
	    };
	
	    _this.resetStates = function () {
	      _this.setState({
	        showAnswer: false,
	        showReportSection: false,
	        selectedChoice: '',
	        stopTimer: false
	      });
	    };
	
	    _this.replaceRoute = function (index) {
	      var questionData = _this.state.questionData;
	      var _this$props$params = _this.props.params,
	          readingId = _this$props$params.readingId,
	          questionId = _this$props$params.questionId,
	          level = _this$props$params.level;
	      var router = _this.context.router;
	
	
	      var id = questionData[index] ? questionData[index].id : questionId;
	      router.push({
	        pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(':level', level).replace(':readingId', readingId).replace(':questionId', id)
	      });
	      _this.setState({ currentIndex: index, currentQuestion: questionData[index] });
	    };
	
	    _this.validateQuestion = function () {
	      var _this$state2 = _this.state,
	          selectedChoice = _this$state2.selectedChoice,
	          questionData = _this$state2.questionData,
	          currentIndex = _this$state2.currentIndex;
	      var level = _this.props.params.level;
	
	      if (selectedChoice) {
	        _this.setState({ stopTimer: true });
	        var right_answer = 0;
	        if (questionData[currentIndex] && questionData[currentIndex][_ApiAttributesKays.correctChoiceKey] === selectedChoice) right_answer = 1;
	        var data = {
	          time_done: _this.timerValue,
	          question_id: questionData[currentIndex][_ApiAttributesKays.questionIdKey],
	          right_answer: right_answer,
	          level: level
	        };
	        var result = _ApiService2.default['saveQuestionAttemptStats'](data);
	        if (result.success) {
	          (0, _toast.showSuccess)(_messages.messages.QUESTION_STATS_SAVED);
	        }
	        _this.setState({ showAnswer: true });
	      }
	    };
	
	    _this.setAnswer = function (answer) {
	      _this.setState({ selectedChoice: answer[0] });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.getTimerValue = function (timerValue) {
	      _this.timerValue = timerValue;
	    };
	
	    _this.hideReportSection = function () {
	      _this.setState({ showReportSection: false });
	    };
	
	    _this.state = {
	      isLoading: true,
	      selectedExamSubscriptionDetails: {},
	      currentIndex: 0,
	      currentQuestion: {},
	      showAnswer: false,
	      stopTimer: false,
	      selectedChoice: '',
	      isFlashCardHidden: true,
	      questionData: []
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	  //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
	
	
	  _createClass(QuestionView, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var state, questionData, _props$params, readingId, level, response, questions;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                state = this.props.location.state;
	                //^ IF WE HAVE A QUESTIONS STATE FROM PREVIOUS COMPONENT THEN DIRECTLY SET IT OTHERWISE FETCH DATA FROM API
	
	                if (!(state && state.questionData && state.questionData.length)) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                questionData = state.questionData;
	
	                this.setState({ questionData: questionData, isLoading: false });
	                _context2.next = 6;
	                return this.onSetCurrentQuestion(questionData);
	
	              case 6:
	                _context2.next = 17;
	                break;
	
	              case 8:
	                _props$params = this.props.params, readingId = _props$params.readingId, level = _props$params.level;
	                _context2.next = 11;
	                return _ApiService2.default['fetchQuestionsReadingWise']({ readingId: readingId, level: level });
	
	              case 11:
	                response = _context2.sent;
	
	                if (!response.success) {
	                  _context2.next = 17;
	                  break;
	                }
	
	                questions = response.questions;
	                _context2.next = 16;
	                return this.onSetCurrentQuestion(questions);
	
	              case 16:
	                this.setState({
	                  questionData: questions,
	                  isLoading: false
	                });
	
	              case 17:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
	
	    //* ============================{{ QUESTION MOVE FORWARD AND PREVIOUS START HERE }}==========================================
	
	    //* ============================{{ QUESTION MOVE FORWARD AND PREVIOUS ENDED HERE }}==========================================
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          questionData = _state.questionData,
	          currentIndex = _state.currentIndex,
	          currentQuestion = _state.currentQuestion,
	          showAnswer = _state.showAnswer,
	          selectedChoice = _state.selectedChoice,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          stopTimer = _state.stopTimer,
	          showReportSection = _state.showReportSection;
	      var _props$params2 = this.props.params,
	          level = _props$params2.level,
	          readingId = _props$params2.readingId;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                className: 'mr-1',
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_LIST.replace(':level', level).replace(':readingId', readingId)
	                  });
	                }
	              },
	              _messages.messages.CHANGE_QUESTION
	            ),
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_READING_LIST.replace(':level', level).replace(':chapterId', currentQuestion && currentQuestion[_ApiAttributesKays.chapterIdKey])
	                  });
	                }
	              },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _CustomCard2.default,
	            null,
	            currentQuestion && Object.keys(currentQuestion).length > 0 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: currentQuestion.name + ' (Q. ' + currentQuestion.id + ')',
	                showPreviousButton: true,
	                showNextButton: true,
	                headerImage: _question_icon_blue2.default,
	                arrayLength: questionData.length,
	                disabledPreviousButton: currentIndex < 1,
	                disabledNextButton: !(currentIndex < questionData.length - 1),
	                getPreviousQuestion: this.getPreviousQuestion,
	                getNextQuestion: this.getNextQuestion
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 9, xs: 12 },
	                    _react2.default.createElement(
	                      _ViewQuestion2.default,
	                      Object.assign({}, currentQuestion, this.props, {
	                        setAnswer: this.setAnswer,
	                        showAnswer: showAnswer,
	                        correctChoice: currentQuestion && currentQuestion[_ApiAttributesKays.correctChoiceKey],
	                        selectedChoice: selectedChoice
	                      }),
	                      _react2.default.createElement(_QuestionBankFooter2.default, {
	                        savePayLoad: {
	                          question_id: currentQuestion && currentQuestion[_ApiAttributesKays.questionIdKey],
	                          level: level
	                        },
	                        validateQuestion: this.validateQuestion,
	                        favItemId: currentQuestion && currentQuestion.id,
	                        setChildRef: this.childRef,
	                        apiServiceProvider: _ApiService2.default,
	                        onSaveItemChange: this.onSaveItemChange,
	                        toggleReportSection: this.toggleReportSection
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { sm: 3, xs: 12 },
	                    _react2.default.createElement(_index2.default, {
	                      getTimerValue: this.getTimerValue,
	                      stopTimer: stopTimer,
	                      shouldFetchFromServer: true,
	                      key: currentQuestion && currentQuestion.id
	                    })
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'h1',
	              { className: 'text-center pt-3 pb-3' },
	              _messages.messages.NO_DATA_FOUND
	            )
	          )
	        ),
	        showAnswer && _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _CustomCard2.default,
	              { className: 'font-lusitana font-16px' },
	              _react2.default.createElement(_CustomCardHeader2.default, {
	                headingText: selectedChoice === currentQuestion[_ApiAttributesKays.correctChoiceKey] ? 'Correct' : 'Incorrect',
	                headerImage: '',
	                className: 'text-uppercase ' + (selectedChoice === currentQuestion[_ApiAttributesKays.correctChoiceKey] ? 'text_success' : 'text_failure')
	              }),
	              _react2.default.createElement(
	                _CustomCardBody2.default,
	                null,
	                (0, _function.renderHTMLContent)(currentQuestion && currentQuestion[_ApiAttributesKays.answerKey], "span")
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FlashCard2.default, {
	          item: currentQuestion,
	          type: 'question',
	          isFlashCardHidden: isFlashCardHidden,
	          ref: this.setChildRef,
	          exam: 'frm',
	          level: level
	        }),
	        showReportSection && _react2.default.createElement(_ReportCard2.default, {
	          hideReportSection: this.hideReportSection,
	          apiServiceProvider: _ApiService2.default,
	          itemId: currentQuestion && currentQuestion[_ApiAttributesKays.questionIdKey],
	          keyId: 'question_id'
	        })
	      );
	    }
	  }]);
	
	  return QuestionView;
	}(_react.Component);
	
	QuestionView.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionView;

/***/ },
/* 774 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapter_id',
	  readingNameKey: 'name',
	  readingIdKay: 'reading_id',
	  questionIdKey: 'id',
	  questionKey: 'question',
	  isAttemptedKey: 'frm_question_stat.answer_status'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchQuestionsChapterWise = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/question-bank/all-questions', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchQuestionsChapterWise(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchChapterNameById = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/chapter-by-id', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchChapterNameById(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var pdfDownloadViaEmail = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/esg/question/pdf-download-via-email', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function pdfDownloadViaEmail(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchQuestionsChapterWise: fetchQuestionsChapterWise,
	  fetchChapterNameById: fetchChapterNameById,
	  pdfDownloadViaEmail: pdfDownloadViaEmail
	};

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ViewCard = __webpack_require__(172);
	
	var _ViewCard2 = _interopRequireDefault(_ViewCard);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _CustomButton = __webpack_require__(38);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _messages = __webpack_require__(14);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _question_iconBlu = __webpack_require__(303);
	
	var _question_iconBlu2 = _interopRequireDefault(_question_iconBlu);
	
	var _ApiAttributesKays = __webpack_require__(774);
	
	var _ApiService = __webpack_require__(775);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionsList = function (_Component) {
	  _inherits(QuestionsList, _Component);
	
	  function QuestionsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionsList);
	
	    var _this = _possibleConstructorReturn(this, (QuestionsList.__proto__ || Object.getPrototypeOf(QuestionsList)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var state, listData, _this$props$params, readingId, level, response, questions, selectedExamSubscriptionDetails;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              state = _this.props.location.state;
	
	              if (!(state && state.listData && state.listData.length)) {
	                _context.next = 7;
	                break;
	              }
	
	              listData = state.listData;
	
	              _this.setState({ listData: listData });
	              _context.next = 12;
	              break;
	
	            case 7:
	              _this$props$params = _this.props.params, readingId = _this$props$params.readingId, level = _this$props$params.level;
	              _context.next = 10;
	              return _ApiService2.default['fetchQuestionsChapterWise']({ readingId: readingId, level: level });
	
	            case 10:
	              response = _context.sent;
	
	              if (response.success) {
	                questions = response.questions, selectedExamSubscriptionDetails = response.selectedExamSubscriptionDetails;
	
	                if (selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 || selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + level]) {
	                  _this.setState({ isUserSubscribed: true });
	                }
	                _this.setState({
	                  listData: questions,
	                  selectedExamSubscriptionDetails: selectedExamSubscriptionDetails
	                });
	              }
	
	            case 12:
	              _this.setState({ isLoading: false });
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.redirectToQuestion = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var _this$state, listData, selectedExamSubscriptionDetails, level, router;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state = _this.state, listData = _this$state.listData, selectedExamSubscriptionDetails = _this$state.selectedExamSubscriptionDetails;
	                level = _this.props.params.level;
	                router = _this.context.router;
	
	                router.push({
	                  pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(':readingId', data[_ApiAttributesKays.readingIdKay]).replace(':level', level).replace(':questionId', data[_ApiAttributesKays.questionIdKey]),
	                  state: { questionData: listData, selectedExamSubscriptionDetails: selectedExamSubscriptionDetails }
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      listData: [],
	      questionStatsTableName: '',
	      isLoading: true,
	      chapterName: '',
	      selectedExamSubscriptionDetails: {},
	      isUserSubscribed: false,
	      pdfAlert: false
	    };
	    return _this;
	  }
	  //* ===========================> {{ COMPONENT DID MOUNT START HERE }} <=====================================
	
	  //* ===========================> {{ COMPONENT DID MOUNT ENDED HERE }} <=====================================
	
	  _createClass(QuestionsList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          listData = _state.listData,
	          isLoading = _state.isLoading,
	          isUserSubscribed = _state.isUserSubscribed,
	          openPremiumPopup = _state.openPremiumPopup,
	          pdfAlert = _state.pdfAlert;
	      var level = this.props.params.level;
	      var router = this.context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: listData.length > 0 && listData[0][_ApiAttributesKays.readingNameKey] },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _CustomButton2.default,
	              {
	                onClick: function onClick() {
	                  return router.push({
	                    pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_READING_LIST.replace(':chapterId', listData.length && listData[0][_ApiAttributesKays.chapterIdKey]).replace(':level', level)
	                  });
	                }
	              },
	              _messages.messages.CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            listData.length ? listData.map(function (item) {
	              return _react2.default.createElement(
	                _ViewCard2.default,
	                {
	                  headerIcon: _question_iconBlu2.default,
	                  headerContent: item[_ApiAttributesKays.readingNameKey] + ' (Q. ' + item[_ApiAttributesKays.questionIdKey] + ')',
	                  bodyContent: item[_ApiAttributesKays.questionKey],
	                  key: item.id,
	                  onClick: function onClick() {
	                    return _this3.redirectToQuestion(item);
	                  }
	                },
	                item[_ApiAttributesKays.isAttemptedKey] ? _react2.default.createElement(
	                  'div',
	                  { id: 'answered_status' },
	                  'Answered'
	                ) : _react2.default.createElement(
	                  'div',
	                  { id: 'notanswered_status' },
	                  'Not Answered '
	                )
	              );
	            }) : _react2.default.createElement(
	              'h1',
	              null,
	              'No Data Found'
	            ),
	            !isUserSubscribed && _react2.default.createElement(
	              _ViewCard2.default,
	              {
	                headerIcon: _question_iconBlu2.default,
	                headerContent: _messages.messages.SUBSCRIBE_PRACTICE_QUESTION.replace('numberOfQuestion', '2,000'),
	                bodyContent: _alertMessage2.default.messageContent_frm,
	                paddingBox: 'padding_box_free'
	              },
	              _react2.default.createElement(
	                _CustomButton2.default,
	                {
	                  className: 'text-center d-block mx-auto',
	                  onClick: function onClick() {
	                    return router.push({ pathname: _AppRoutes2.default.SUBSCRIBE });
	                  }
	                },
	                'Subscribe'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm,
	          exam: 'frm'
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Question',
	          pdfAlertModel: this.pdfAlertModel,
	          pdfAlert: pdfAlert,
	          PDFContentMessage: _messages.messages.PDF_DOWNLOAD_CONTENT_MESSAGE
	        })
	      );
	    }
	  }]);
	
	  return QuestionsList;
	}(_react.Component);
	
	QuestionsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionsList;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuestionBank = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _GARP_logo = __webpack_require__(165);
	
	var _GARP_logo2 = _interopRequireDefault(_GARP_logo);
	
	var _ChapterCards = __webpack_require__(134);
	
	var _ChapterCards2 = _interopRequireDefault(_ChapterCards);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _icon = __webpack_require__(302);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _ApiAttributesKays = __webpack_require__(766);
	
	var _ApiService = __webpack_require__(767);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionBank = exports.QuestionBank = function (_Component) {
	  _inherits(QuestionBank, _Component);
	
	  function QuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (QuestionBank.__proto__ || Object.getPrototypeOf(QuestionBank)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.getChapterWiseCount({ level: 1 });
	              _this.getChapterWiseCount({ level: 2 });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getChapterWiseCount = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(level) {
	        var result;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _ApiService2.default['fetchChaptersWithPremiumAndFreeCount'](level);
	
	              case 2:
	                result = _context2.sent;
	
	                if (result.success) {
	                  _this.setState(_defineProperty({
	                    isLoading: false
	                  }, 'chapterDataPart' + level.level, result.data));
	                }
	                _this.setState({ isLoading: false });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToQuestionBank = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(level) {
	        var result, data, router;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this.setState(_defineProperty({}, 'isButtonDisablePart' + level.level, true));
	                _context3.next = 3;
	                return _ApiService2.default['fetchLastAnsweredQuestion'](level);
	
	              case 3:
	                result = _context3.sent;
	
	                _this.setState(_defineProperty({}, 'isButtonDisablePart' + level.level, false));
	
	                //* FIRST OF ALL CHECK THE REDIRECTION
	                if (result.success) {
	                  data = result.data;
	                  router = _this.context.router;
	
	                  if (data) {
	                    router.push({
	                      pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(':level', level.level).replace(':readingId', data[_ApiAttributesKays.questionTableKey][_ApiAttributesKays.readingIdKey]).replace(':questionId', data[_ApiAttributesKays.questionTableKey].id)
	                    });
	                  } else {
	                    (0, _toast.showInformation)(_messages.messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
	                  }
	                } else {
	                  (0, _toast.showInformation)(_messages.messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
	                }
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      chapterId: '',
	      questionId: '',
	      isLoading: true,
	      isButtonDisablePart1: false,
	      isButtonDisablePart2: false,
	      chapterDataPart1: [],
	      chapterDataPart2: [],
	      selectedExamSubscriptionDetails: {}
	    };
	    return _this;
	  }
	  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
	
	  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
	
	
	  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================
	
	  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
	
	
	  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================
	
	  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
	
	
	  _createClass(QuestionBank, [{
	    key: 'render',
	
	    //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state,
	          context = this.context;
	      var isLoading = state.isLoading,
	          chapterDataPart1 = state.chapterDataPart1,
	          chapterDataPart2 = state.chapterDataPart2;
	      var router = context.router;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.QUESTION_BANK, className: 'frm_title_logo_wrap' },
	          _react2.default.createElement('img', {
	            src: _GARP_logo2.default,
	            className: 'garpLogo',
	            alt: 'full logo'
	          })
	        ),
	        ['1', '2'].map(function (level) {
	          return _react2.default.createElement(
	            'div',
	            { key: level },
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              { title: _messages.messages['FRM_TOPIC_PART_' + level] },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: function onClick() {
	                    return _this3.redirectToQuestionBank({ level: level });
	                  },
	                  disabled: state['isButtonDisablePart' + level]
	                },
	                state['isButtonDisablePart' + level] && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	                _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	              )
	            ),
	            _react2.default.createElement(
	              _LoaderWrapper2.default,
	              { isLoading: isLoading },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'seperator-block-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        state['chapterDataPart' + level].length && state['chapterDataPart' + level].map(function (item) {
	                          return _react2.default.createElement(_ChapterCards2.default, Object.assign({
	                            onClick: function onClick() {
	                              return router.push({
	                                pathname: _AppRoutes2.default.FRM_V2_QUESTION_BANK_READING_LIST.replace(':level', level).replace(':chapterId', item[_ApiAttributesKays.chapterIdKey]),
	                                state: { chapterDataPart1: chapterDataPart1, chapterDataPart2: chapterDataPart2 }
	                              });
	                            },
	                            key: item[_ApiAttributesKays.chapterIdKey],
	                            headerImage: _icon2.default,
	                            headerImageWidth: 55,
	                            chapterNumber: item[_ApiAttributesKays.chapterIdKey],
	                            chapterName: item[_ApiAttributesKays.chapterNameKay],
	                            totalReadings: item[_ApiAttributesKays.totalReadingKey],
	                            freeQuestionsCount: item[_ApiAttributesKays.freeQuestionsCountKey],
	                            premiumQuestionsCount: item[_ApiAttributesKays.premiumQuestionsCountKey]
	                          }, _this3.props));
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return QuestionBank;
	}(_react.Component);
	
	QuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = QuestionBank;

/***/ },
/* 778 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'id',
	  chapterNameKey: 'chapter_name',
	  videoTableNameKey: 'frm_videos',
	  lastVideoViewTableNameKey: 'frm_video'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchVideos = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/videos/all-videos', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchVideos(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var fetchLastViewedVideo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/videos/last-video-viewed', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchLastViewedVideo() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var saveLastViewedVideo = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveLastViewedVideo', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function saveLastViewedVideo() {
	    return _ref3.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchVideos: fetchVideos,
	  fetchLastViewedVideo: fetchLastViewedVideo,
	  saveLastViewedVideo: saveLastViewedVideo
	};

/***/ },
/* 780 */
/***/ function(module, exports) {

	'use strict';
	
	var ApiAttributesKeys = {
	  chapterIdKey: 'chapter_id',
	  chapterNameKey: 'chapter_name',
	  videoTableKey: 'frm_videos',
	  videoTitleKey: 'title',
	  youtubeIdKey: 'url_id',
	  videoTableNameKey: 'frm_videos',
	  mockIdKey: 'mock_id'
	};
	module.exports = ApiAttributesKeys;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchVideos = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/frm/videos/all-videos', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchVideos(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var fetchSavedQuestion = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavVideo', Object.assign({
	              question_id: data.video_id
	            }, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFavVideoByUserID', data);
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function saveQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var deleteSaveQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/unsaveFavVideoByUserID', data);
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function deleteSaveQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var mutateReportVideo = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoReportQuestion', data);
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function mutateReportVideo(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var saveLastViewedVideo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveLastViewedVideo', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveLastViewedVideo() {
	    return _ref6.apply(this, arguments);
	  };
	}();
	module.exports = {
	  fetchVideos: fetchVideos,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSaveQuestion: deleteSaveQuestion,
	  mutateReportVideo: mutateReportVideo,
	  saveLastViewedVideo: saveLastViewedVideo
	};

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _VideoPlayList = __webpack_require__(174);
	
	var _VideoPlayList2 = _interopRequireDefault(_VideoPlayList);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ApiService = __webpack_require__(781);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _ApiAttributesKays = __webpack_require__(780);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _toast = __webpack_require__(15);
	
	var _VideoValidateReportsIcons = __webpack_require__(175);
	
	var _VideoValidateReportsIcons2 = _interopRequireDefault(_VideoValidateReportsIcons);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoPlayList = function (_Component) {
	  _inherits(VideoPlayList, _Component);
	
	  function VideoPlayList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, VideoPlayList);
	
	    var _this = _possibleConstructorReturn(this, (VideoPlayList.__proto__ || Object.getPrototypeOf(VideoPlayList)).call(this, props));
	
	    _this.getChapterWiseVideos = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(payload) {
	        var result, videosData, id, currentIndex, isCurrentVideoFree, isUserSubscribedPartWisePackage, isUserSubscribedForPart1AndPart2, _this$setState, router;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _ApiService2.default['fetchVideos'](payload);
	
	              case 2:
	                result = _context.sent;
	
	                if (result.success) {
	                  videosData = result.data[0][_ApiAttributesKays.videoTableKey] ? result.data[0][_ApiAttributesKays.videoTableKey] : result.data;
	                  id = payload.id;
	                  currentIndex = videosData.findIndex(function (item) {
	                    return item.id === parseInt(id, 10);
	                  });
	                  isCurrentVideoFree = videosData.length ? videosData[currentIndex > -1 ? currentIndex : 0].free : false;
	                  isUserSubscribedPartWisePackage = result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + payload.level] && result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + payload.level].videoStatus;
	                  isUserSubscribedForPart1AndPart2 = result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm1And2'] && result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm1And2'].videoStatus;
	
	
	                  if (isUserSubscribedForPart1AndPart2 || isUserSubscribedPartWisePackage || isCurrentVideoFree) {
	                    _this.setState((_this$setState = {
	                      isLoading: false,
	                      currentIndex: currentIndex > -1 ? currentIndex : 0,
	                      videoData: videosData.length ? videosData : result.data[_ApiAttributesKays.videoTableKey]
	                    }, _defineProperty(_this$setState, 'isUserSubscribedPart' + payload.level, isUserSubscribedPartWisePackage), _defineProperty(_this$setState, 'isUserSubscribedForPart1AndPart2', isUserSubscribedForPart1AndPart2), _defineProperty(_this$setState, 'mockId', payload.mockId), _this$setState));
	                  } else {
	                    router = _this.context.router;
	
	                    router.push({ pathname: _AppRoutes2.default.FRM_VIDEOS });
	                    (0, _toast.showInformation)(_messages.messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO);
	                  }
	                } else {
	                  _this.setState({ isLoading: false });
	                }
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.navigateToVideoByID = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(index) {
	        var level, state, isUserSubscribedForPart1AndPart2, videoData, video, mockId, router, videoPathName, payLoad;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                level = _this.props.params.level;
	                state = _this.state;
	                isUserSubscribedForPart1AndPart2 = state.isUserSubscribedForPart1AndPart2, videoData = state.videoData;
	                video = videoData[index];
	
	                if (!(isUserSubscribedForPart1AndPart2 || state['isUserSubscribedPart' + level] || video.free)) {
	                  _context2.next = 15;
	                  break;
	                }
	
	                // Get the mockId for the selected video
	                mockId = video[_ApiAttributesKays.mockIdKey] ? video[_ApiAttributesKays.mockIdKey] : null;
	
	
	                _this.setState({ currentIndex: index, mockId: mockId });
	
	                router = _this.context.router;
	                videoPathName = video.mock_id ? _AppRoutes2.default.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':mockId', video.mock_id) : _AppRoutes2.default.FRM_V2_VIDEOS_PLAYLIST.replace(':chapterId', video.chapter_id);
	
	
	                router.push({
	                  pathname: videoPathName.replace(':level', level).replace(':id', video.id)
	                });
	                payLoad = {
	                  video_id: videoData[index].id,
	                  level: level
	                };
	                _context2.next = 13;
	                return _ApiService2.default['saveLastViewedVideo'](payLoad);
	
	              case 13:
	                _context2.next = 16;
	                break;
	
	              case 15:
	                _this.setState({ openPremiumPopup: true });
	
	              case 16:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.hideReportSection = function () {
	      _this.setState({ showReportSection: false });
	    };
	
	    _this.state = {
	      videoData: [],
	      currentIndex: 0,
	      isLoading: true,
	      isFlashCardHidden: true,
	      showReportSection: false,
	      openPremiumPopup: false,
	      isUserSubscribedPart1: false,
	      isUserSubscribedPart2: false,
	      isUserSubscribedForPart1AndPart2: false,
	      mockId: null
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(VideoPlayList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _props$params, level, chapterId, id, mockId;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.setState({ isLoading: true });
	
	                _props$params = this.props.params, level = _props$params.level, chapterId = _props$params.chapterId, id = _props$params.id, mockId = _props$params.mockId;
	                _context3.next = 4;
	                return this.getChapterWiseVideos({
	                  level: level,
	                  chapterId: chapterId,
	                  id: id,
	                  mockId: mockId
	                });
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var router = this.context.router;
	      var level = this.props.params.level;
	      var state = this.state;
	      var videoData = state.videoData,
	          isLoading = state.isLoading,
	          currentIndex = state.currentIndex,
	          isUserSubscribedForPart1AndPart2 = state.isUserSubscribedForPart1AndPart2,
	          openPremiumPopup = state.openPremiumPopup,
	          isFlashCardHidden = state.isFlashCardHidden,
	          showReportSection = state.showReportSection,
	          mockId = state.mockId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: function onClick() {
	                    return router.push({ pathname: _AppRoutes2.default.FRM_VIDEOS });
	                  }
	                },
	                _messages.messages.BACK_TO_VIDEOS
	              )
	            ),
	            _react2.default.createElement(_VideoPlayList2.default, {
	              videoTitle: videoData[currentIndex] ? videoData[currentIndex][_ApiAttributesKays.videoTitleKey] : '',
	              currentIndex: currentIndex,
	              videosData: videoData,
	              youtubeID: videoData[currentIndex] ? videoData[currentIndex][_ApiAttributesKays.youtubeIdKey] : '',
	              navigateToVideoByID: this.navigateToVideoByID,
	              toggleAlert: this.toggleAlert,
	              isUserSubscribed: isUserSubscribedForPart1AndPart2 || state['isUserSubscribedPart' + level]
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportsIcons2.default, {
	              isMoveToNotesIcon: !mockId,
	              isMoveToQuestionIcon: !mockId,
	              toggleAlert: this.toggleAlert,
	              savePayLoad: {
	                videoId: videoData[currentIndex] ? videoData[currentIndex].id : '',
	                level: level
	              },
	              favItemId: videoData[currentIndex] ? videoData[currentIndex].id : '',
	              notesRedirectRoute: _AppRoutes2.default.FRM_V2_NOTES_READING_LIST.replace(':level', level).replace(':chapterId', videoData[currentIndex] ? videoData[currentIndex][_ApiAttributesKays.chapterIdKey] : ''),
	              questionRedirectRoute: _AppRoutes2.default.FRM_V2_QUESTION_BANK_READING_LIST.replace(':level', level).replace(':chapterId', videoData[currentIndex] ? videoData[currentIndex][_ApiAttributesKays.chapterIdKey] : ''),
	              setChildRef: this.childRef,
	              currentVideo: videoData[currentIndex] && videoData[currentIndex],
	              apiServiceProvider: _ApiService2.default,
	              onSaveItemChange: this.onSaveItemChange,
	              toggleReportSection: this.toggleReportSection,
	              isUserSubscribed: isUserSubscribedForPart1AndPart2 || state['isUserSubscribedPart' + level]
	            }),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: videoData[currentIndex] ? videoData[currentIndex].id : '' },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'frm',
	              level: level
	            }),
	            showReportSection && _react2.default.createElement(_ReportCard2.default, {
	              section: 'video',
	              hideReportSection: this.hideReportSection,
	              apiServiceProvider: _ApiService2.default,
	              itemId: videoData[currentIndex] ? videoData[currentIndex].id : '',
	              keyId: 'video_id',
	              level: level
	            })
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm
	        })
	      );
	    }
	  }]);
	
	  return VideoPlayList;
	}(_react.Component);
	
	VideoPlayList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = VideoPlayList;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _GARP_logo = __webpack_require__(165);
	
	var _GARP_logo2 = _interopRequireDefault(_GARP_logo);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _videoCard = __webpack_require__(176);
	
	var _videoCard2 = _interopRequireDefault(_videoCard);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _messages = __webpack_require__(14);
	
	var _ApiAttributesKays = __webpack_require__(778);
	
	var _ApiService = __webpack_require__(779);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _toast = __webpack_require__(15);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var index = function (_Component) {
	  _inherits(index, _Component);
	
	  function index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, index);
	
	    var _this = _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).call(this, props));
	
	    _this.getChapterWiseVideos = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(payload) {
	        var result, _this$setState, videosData, videoDataPart1;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _ApiService2.default['fetchVideos'](payload);
	
	              case 2:
	                result = _context.sent;
	
	                if (result.success) {
	                  videosData = result.data;
	
	
	                  if (payload.chapterId === 11) {
	                    videoDataPart1 = _this.state.videoDataPart1;
	
	                    videosData = [].concat(_toConsumableArray(videoDataPart1), [{
	                      chapter_name: _messages.messages.FRM_CAPSULES_CHAPTER_NAME,
	                      chapter_no: 11,
	                      id: 11,
	                      frm_videos: result.data
	                    }]);
	                  }
	                  _this.setState((_this$setState = {
	                    isLoading: false
	                  }, _defineProperty(_this$setState, 'videoDataPart' + payload.level, videosData.length ? videosData : result.data), _defineProperty(_this$setState, 'isUserSubscribedPart' + payload.level, result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + payload.level] && result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm' + payload.level].videoStatus), _defineProperty(_this$setState, 'isUserSubscribedBoth', result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm1And2'] && result.selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2.videoStatus), _this$setState));
	                } else {
	                  _this.setState({ isLoading: false });
	                }
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.goPremium = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.toggleAlert = function () {
	      _this.setState({ openPremiumPopup: !_this.state.openPremiumPopup });
	    };
	
	    _this.redirectToPlaylist = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(items) {
	        var router, level, chapter_id, id, mock_id, payLoad;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                router = _this.context.router;
	                level = items.level, chapter_id = items.chapter_id, id = items.id, mock_id = items.mock_id;
	                payLoad = {
	                  video_id: id,
	                  level: level
	                };
	                _context2.next = 5;
	                return _ApiService2.default['saveLastViewedVideo'](payLoad);
	
	              case 5:
	                router.push({
	                  pathname: mock_id ? _AppRoutes2.default.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':mockId', mock_id).replace(':level', level).replace(':id', id) : _AppRoutes2.default.FRM_V2_VIDEOS_PLAYLIST.replace(':chapterId', chapter_id).replace(':level', level).replace(':id', id)
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToLastViewedVideo = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(level) {
	        var result, data, router, lastVideo, videoPathName;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this.setState(_defineProperty({}, 'isButtonDisablePart' + level.level, true));
	                _context3.next = 3;
	                return _ApiService2.default['fetchLastViewedVideo'](level);
	
	              case 3:
	                result = _context3.sent;
	
	                _this.setState(_defineProperty({}, 'isButtonDisablePart' + level.level, false));
	
	                if (result.success) {
	                  data = result.data;
	                  router = _this.context.router;
	                  lastVideo = data[_ApiAttributesKays.lastVideoViewTableNameKey];
	                  videoPathName = lastVideo.mock_id ? _AppRoutes2.default.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':mockId', lastVideo.mock_id) : _AppRoutes2.default.FRM_V2_VIDEOS_PLAYLIST.replace(':chapterId', lastVideo.chapter_id);
	
	
	                  router.push({
	                    pathname: videoPathName.replace(':level', lastVideo.level).replace(':id', lastVideo.id)
	                  });
	                } else {
	                  (0, _toast.showInformation)(_messages.messages.VIDEO_NOT_AVAILABLE);
	                }
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.createVideoCard = function (_ref4) {
	      var item = _ref4.item,
	          idx = _ref4.idx,
	          _ref4$type = _ref4.type,
	          type = _ref4$type === undefined ? "" : _ref4$type,
	          level = _ref4.level,
	          isUserSubscribedBoth = _ref4.isUserSubscribedBoth,
	          isUserSubscribedPart1 = _ref4.isUserSubscribedPart1,
	          isUserSubscribedPart2 = _ref4.isUserSubscribedPart2,
	          toggleAlert = _ref4.toggleAlert,
	          redirectToPlaylist = _ref4.redirectToPlaylist;
	
	      var isUserSubscribed = level === _constant.FRM_LEVELS.ONE ? Boolean(isUserSubscribedBoth || isUserSubscribedPart1) : Boolean(isUserSubscribedBoth || isUserSubscribedPart2);
	
	      return _react2.default.createElement(_videoCard2.default, {
	        key: type + '-' + (item.id || item.chapter_id || Math.random()),
	        index: idx + 1,
	        currentItem: item,
	        chapterIdKey: _ApiAttributesKays.chapterIdKey,
	        chapterNameKey: _ApiAttributesKays.chapterNameKey,
	        videoTableNameKey: _ApiAttributesKays.videoTableNameKey,
	        isUserSubscribed: isUserSubscribed,
	        premiumModalToggle: toggleAlert,
	        redirectToPlaylist: redirectToPlaylist
	      });
	    };
	
	    _this.renderVideoCards = function (_ref5) {
	      var state = _ref5.state,
	          level = _ref5.level,
	          toggleAlert = _ref5.toggleAlert,
	          redirectToPlaylist = _ref5.redirectToPlaylist;
	
	      var chapters = state['videoDataPart' + level] || [];
	      var capsuleChapter = null;
	
	      var normalChapters = chapters.filter(function (item) {
	        if (level === _constant.FRM_LEVELS.ONE && (item.chapter_id === _constant.CAPSULE_VIDEO_ID || item.id === _constant.CAPSULE_VIDEO_ID)) {
	          capsuleChapter = item;
	          return false;
	        }
	        return !item.mock_id;
	      });
	
	      var mockChapters = chapters.filter(function (item) {
	        return item.mock_id;
	      });
	
	      var normalCards = normalChapters.map(function (item, idx) {
	        return _this.createVideoCard(Object.assign({
	          item: item,
	          idx: idx,
	          type: "normal",
	          level: level
	        }, state, {
	          toggleAlert: toggleAlert,
	          redirectToPlaylist: redirectToPlaylist
	        }));
	      });
	
	      var mockCards = mockChapters.map(function (item, idx) {
	        return _this.createVideoCard(Object.assign({
	          item: item,
	          idx: idx,
	          type: "mock",
	          level: level
	        }, state, {
	          toggleAlert: toggleAlert,
	          redirectToPlaylist: redirectToPlaylist
	        }));
	      });
	
	      var capsuleCard = capsuleChapter ? _this.createVideoCard(Object.assign({
	        item: capsuleChapter,
	        idx: normalCards.length + mockCards.length,
	        type: "capsule",
	        level: level
	      }, state, {
	        toggleAlert: toggleAlert,
	        redirectToPlaylist: redirectToPlaylist
	      })) : null;
	
	      var cards = [].concat(_toConsumableArray(normalCards), _toConsumableArray(mockCards));
	      if (level === _constant.FRM_LEVELS.ONE) cards.push(capsuleCard);
	      return cards.filter(Boolean);
	    };
	
	    _this.state = {
	      videoDataPart1: [],
	      videoDataPart2: [],
	      isLoading: true,
	      openPremiumPopup: false,
	      isUserSubscribedPart1: false,
	      isUserSubscribedPart2: false,
	      isUserSubscribedBoth: false
	    };
	    return _this;
	  }
	
	  _createClass(index, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.setState({ isLoading: true });
	                _context4.next = 3;
	                return this.getChapterWiseVideos({ level: 1 });
	
	              case 3:
	                _context4.next = 5;
	                return this.getChapterWiseVideos({ level: 1, chapterId: 11 });
	
	              case 5:
	                this.getChapterWiseVideos({ level: 2 });
	
	              case 6:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state;
	      var isLoading = state.isLoading,
	          openPremiumPopup = state.openPremiumPopup;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _ComponentHeader2.default,
	          { title: _messages.messages.VIDEOS, className: 'frm_title_logo_wrap' },
	          _react2.default.createElement('img', { src: _GARP_logo2.default, className: 'garpLogo', alt: 'full logo' })
	        ),
	        ['1', '2'].map(function (level) {
	          return _react2.default.createElement(
	            'div',
	            { key: level },
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              { title: _messages.messages['FRM_TOPIC_PART_' + level], className: 'mt-3' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: function onClick() {
	                    return _this3.redirectToLastViewedVideo({ level: level });
	                  },
	                  disabled: state['isButtonDisablePart' + level]
	                },
	                state['isButtonDisablePart' + level] && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	                _messages.messages.GO_TO_MY_LAST_VIEWED_VIDEO
	              )
	            ),
	            _react2.default.createElement(
	              _LoaderWrapper2.default,
	              { isLoading: isLoading },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                { className: 'video_lesson_wrap' },
	                _this3.renderVideoCards({
	                  state: state,
	                  level: level,
	                  toggleAlert: _this3.toggleAlert,
	                  redirectToPlaylist: _this3.redirectToPlaylist
	                })
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium,
	          toggleAlert: this.toggleAlert,
	          alert_status: openPremiumPopup,
	          MessageContent: _alertMessage2.default.messageContent_frm
	        })
	      );
	    }
	  }]);
	
	  return index;
	}(_react.Component);
	
	index.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = index;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1008);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrmvideoLessons = function (_Component) {
	  _inherits(FrmvideoLessons, _Component);
	
	  function FrmvideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FrmvideoLessons);
	
	    var _this = _possibleConstructorReturn(this, (FrmvideoLessons.__proto__ || Object.getPrototypeOf(FrmvideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({ alert_status: !_this.state.alert_status });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this.getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, event, level) {
	        var chapterNumber, premium, capsulePremium, txt, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chapterNumber = chapter.chapter_no;
	                premium = level === 1 ? _this.state.showFreePremium : _this.state.showFreePremium1;
	                capsulePremium = void 0;
	
	                if (chapterNumber === 11 && level === 1 && _this.state.showFreePremium1 === false) {
	                  capsulePremium = false;
	                } else {
	                  capsulePremium = true;
	                }
	                txt = chapterNumber.toString();
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: txt
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getcfavideosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (premium === true) {
	                                if (capsulePremium === false) {
	                                  _this.context.router.push({
	                                    pathname: '/frm/videodisplay/' + resp.cfavchapterfirst.id + '/' + (premium ? 0 : 1) + '/' + resp.cfavchapterfirst.chapter_id + '/' + chapter.chapter_no,
	                                    search: '?showCapsules=' + _this.state.showCapsules + '&level=' + level,
	                                    state: {
	                                      token: _this.state.token,
	                                      idname: _this.state.idname,
	                                      chapter: { chapter_id: chapter.chapter_no },
	                                      level: level,
	                                      showCapsules: _this.state.showCapsules
	                                    }
	                                  });
	                                } else {
	                                  _this.toggleAlert();
	                                }
	                              } else if (premium === false) {
	                                _this.context.router.push({
	                                  pathname: '/frm/videodisplay/' + resp.cfavchapterfirst.id + '/' + (premium ? 0 : 1) + '/' + resp.cfavchapterfirst.chapter_id + '/' + chapter.chapter_no,
	                                  search: '?showCapsules=' + _this.state.showCapsules + '&level=' + level,
	                                  state: {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    chapter: { chapter_id: chapter.chapter_no },
	                                    level: level,
	                                    showCapsules: _this.state.showCapsules
	                                  }
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x4) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = { padding: 10 };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: '/frm/videodisplay/' + lastRecord.frm_video.id + '/' + (_this.state.showFreePremium ? 0 : 1) + '/' + (lastRecord.frm_video.chapter_id === 0 ? 0 : 1) + '/' + lastRecord.frm_video.chapter_id + '/' + lastRecord.videoIndex,
	                  search: '?showCapsules=' + _this.state.showCapsules + '&level=' + 1,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.frm_video,
	                    index: lastRecord.videoIndex,
	                    showFreePremium: _this.state.showFreePremium,
	                    showCapsules: _this.state.showCapsules,
	                    level: 1
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.goToLastVideoFrm2 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state2, lastRecord1, lastAttempt1;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state2 = _this.state, lastRecord1 = _this$state2.lastRecord1, lastAttempt1 = _this$state2.lastAttempt1;
	
	              if (lastAttempt1) {
	                _this.context.router.push({
	                  pathname: '/frm/videodisplay/' + lastRecord1.frm_video.id + '/' + (_this.state.showFreePremium1 ? 0 : 1) + '/' + (lastRecord1.frm_video.chapter_id === 0 ? 0 : 1) + '/' + lastRecord1.frm_video.chapter_id + '/' + lastRecord1.videoIndex,
	                  search: '?showCapsules=' + _this.state.showCapsules + '&level=' + 2,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord1.frm_video,
	                    index: lastRecord1.videoIndex,
	                    showFreePremium: _this.state.showFreePremium1,
	                    showCapsules: _this.state.showCapsules,
	                    level: 2
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    window.scrollTo(0, 0);
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '<i class="icon-info icons font-2xl d-block "></i>',
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      chapters: [],
	      frm2chapters: [],
	      allChapters: [],
	      idname: '',
	      token: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: true,
	      selectedmenu: 'frm',
	      exams: [],
	      lastRecord: '',
	      lastAttempt: true,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      lastRecord1: '',
	      lastAttempt1: true,
	      showFreePremium1: true,
	      showCapsules: true
	    };
	    return _this;
	  }
	
	  _createClass(FrmvideoLessons, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var result, storage_session, data, dataExam;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context7.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var examIds, dataset, subscription_details, _examIds, _dataset;
	
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true,
	                              showFreePremium1: true
	                            });
	                            _context6.next = 9;
	                            break;
	
	                          case 5:
	                            examIds = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: examIds
	                            };
	                            _context6.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, isSubscribed, examPlanData, isSubscribed1;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 16;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        isSubscribed = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context5.next = 6;
	                                        return _FrmSubscription4.default.checkFrmVideosSubscription(1, exam_data, examPlanData);
	
	                                      case 6:
	                                        isSubscribed = _context5.sent;
	
	                                        if (isSubscribed) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        // var exam_data = resp_exam.examData;
	                                        isSubscribed1 = false;
	                                        _context5.next = 11;
	                                        return _FrmSubscription4.default.checkFrmVideosSubscription(2, exam_data, examPlanData);
	
	                                      case 11:
	                                        isSubscribed1 = _context5.sent;
	
	                                        if (isSubscribed1) {
	                                          _this3.setState({ showFreePremium1: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium1: true });
	                                        }
	                                        if (isSubscribed || isSubscribed1) {
	                                          _this3.setState({ showCapsules: false });
	                                        } else {
	                                          _this3.setState({ showCapsules: true });
	                                        }
	                                        _context5.next = 16;
	                                        break;
	
	                                      case 16:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this3);
	                              }));
	
	                              return function (_x6) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }());
	
	                          case 9:
	                            _context6.next = 21;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context6.next = 15;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true,
	                              showFreePremium1: true
	                            });
	                            _context6.next = 21;
	                            break;
	
	                          case 15:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({ subscription_details: subscription_details });
	                            _examIds = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            _dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: _examIds
	                            };
	                            _context6.next = 21;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var isSubscribed = false;
	                                isSubscribed = _FrmSubscription2.default.checkFrmVideosSubscription(1, exam_data);
	
	                                if (isSubscribed) {
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                                // var exam_data = resp_exam.examData;
	                                var isSubscribed1 = false;
	                                isSubscribed1 = _FrmSubscription2.default.checkFrmVideosSubscription(2, exam_data);
	                                if (isSubscribed1) {
	                                  _this3.setState({ showFreePremium1: false });
	                                } else {
	                                  _this3.setState({ showFreePremium1: true });
	                                }
	                                if (isSubscribed || isSubscribed1) {
	                                  _this3.setState({ showCapsules: false });
	                                } else {
	                                  _this3.setState({ showCapsules: true });
	                                }
	                              } else {}
	                            });
	
	                          case 21:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this3);
	                  }));
	
	                  return function (_x5) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, exams: resp.exams[1] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                // let data_data = {
	                //   token: storage_session['token'],
	                //   idname: storage_session['idname'],
	                // };
	                _context7.next = 13;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getcfaVideos', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, chapters: resp.cfavideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 13:
	                _context7.next = 15;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getfrm2Videos', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, frm2chapters: resp.cfavideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 15:
	                _context7.next = 17;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getlastViewedVideo', dataExam).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 17:
	                _context7.next = 19;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getlastViewedVideofrm2', dataExam).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord1: response.data,
	                      lastAttempt1: true
	                    });
	                  }
	                });
	
	              case 19:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          chapters = _state.chapters,
	          frm2chapters = _state.frm2chapters;
	
	      var data = '';
	      var _state2 = this.state,
	          lastAttempt = _state2.lastAttempt,
	          lastAttempt1 = _state2.lastAttempt1;
	      // frm 1 video lessons
	
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4.getReadings.bind(_this4, item, item.chapter_name, 1)
	                  },
	                  item.chapter_no === 11 ? 'Concept Capsules' : _language2.default.LC().BOOK,
	                  ' ',
	                  item.chapter_no === 11 ? '' : item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium,
	                    showCapsules: _this4.state.showCapsules
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      // frm 2 video lessons
	      var data1 = '';
	      if (this.state.frm2chapters.length) {
	        data1 = frm2chapters /* .slice(4,11) */
	        .map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4.getReadings.bind(_this4, item, item.chapter_name, 2)
	                  },
	                  _language2.default.LC().BOOK,
	                  ' ',
	                  /* item.chapter_no === 11 ? chapters.length :  */index + 1,
	                  ' ',
	                  '- ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium1: _this4.state.showFreePremium1,
	                    showCapsules: _this4.state.showCapsules
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data1 = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: ' frm_title_logo_wrap_Videos' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                ' ',
	                _language2.default.LC().FRM_LEVEL_I_LESSONS,
	                ' '
	              ),
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	                className: 'garpLogo',
	                alt: 'full logo'
	              }),
	              lastAttempt ? _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this.goToVideo.bind(this),
	                  disabled: !lastAttempt
	                },
	                ' ',
	                _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	                ' '
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: ' frm_title_logo_wrap_Videos' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                ' ',
	                _language2.default.LC().FRM_LEVEL_II_LESSONS,
	                ' '
	              ),
	              lastAttempt1 ? _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this.goToLastVideoFrm2.bind(this),
	                  disabled: !lastAttempt1
	                },
	                ' ',
	                _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	                ' '
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  data1
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent
	          })
	        )
	      );
	    }
	  }]);
	
	  return FrmvideoLessons;
	}(_react.Component);
	
	FrmvideoLessons.contextTypes = { router: _react2.default.PropTypes.object };
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	var ChatperwiseReadingData = function (_Component2) {
	  _inherits(ChatperwiseReadingData, _Component2);
	
	  function ChatperwiseReadingData(props) {
	    var _this6 = this;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this5 = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this5.toggleAlert = function () {
	      _this5.setState({ alert_status: !_this5.state.alert_status });
	    };
	
	    _this5.goPremium = function () {
	      _this5.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this5.state.token,
	          idname: _this5.state.idname,
	          selectedMenu: _this5.state.selectedmenu
	        }
	      });
	    };
	
	    _this5.getReadings = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return _this5.savelastVideo(chapter, index, chapter.level);
	
	              case 2:
	                // const result = getDeviceDetails();
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this5.state.token,
	                    idname: _this5.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this5.state.user_city,
	                    country: _this5.state.user_country,
	                    state: _this5.state.user_state,
	                    continent: _this5.state.user_continent,
	                    ip: _this5.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/trackUserVideowatch', data).then(function () {
	                    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                      return _regenerator2.default.wrap(function _callee8$(_context8) {
	                        while (1) {
	                          switch (_context8.prev = _context8.next) {
	                            case 0:
	                              if (resp.success) {
	                                if (chapter.level === 1) {
	                                  _this5.context.router.push({
	                                    pathname: '/frm/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                    search: '?showCapsules=' + _this5.state.showCapsules + '&level=' + chapter.level,
	                                    state: {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      chapter: chapter,
	                                      index: index,
	                                      showFreePremium: _this5.state.showFreePremium,
	                                      level: chapter.level,
	                                      showCapsules: _this5.state.showCapsules
	                                    }
	                                  });
	                                } else {
	                                  _this5.context.router.push({
	                                    pathname: '/frm/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium1 ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                    search: '?showCapsules=' + _this5.state.showCapsules + '&level=' + chapter.level,
	                                    state: {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      chapter: chapter,
	                                      index: index,
	                                      showFreePremium: _this5.state.showFreePremium1,
	                                      level: chapter.level,
	                                      showCapsules: _this5.state.showCapsules
	                                    }
	                                  });
	                                }
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context8.stop();
	                          }
	                        }
	                      }, _callee8, _this6);
	                    }));
	
	                    return function (_x9) {
	                      return _ref9.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  _data = { token: _this5.state.token, idname: _this5.state.idname };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this5.toggleAlert();
	                      } else {
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                            var exam_data, isInArray_var, examPlanData, _data2;
	
	                            return _regenerator2.default.wrap(function _callee10$(_context10) {
	                              while (1) {
	                                switch (_context10.prev = _context10.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context10.next = 25;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    // const selectedmen = this.state.selectedmenu;
	
	                                    isInArray_var = false;
	                                    examPlanData = resp_exam.examPlan[0];
	
	                                    if (!(chapter.chapter_id === 11)) {
	                                      _context10.next = 14;
	                                      break;
	                                    }
	
	                                    _context10.next = 7;
	                                    return _FrmSubscription4.default.checkFrmVideosSubscription(1, exam_data, examPlanData);
	
	                                  case 7:
	                                    isInArray_var = _context10.sent;
	
	                                    if (isInArray_var) {
	                                      _context10.next = 12;
	                                      break;
	                                    }
	
	                                    _context10.next = 11;
	                                    return _FrmSubscription4.default.checkFrmVideosSubscription(2, exam_data, examPlanData);
	
	                                  case 11:
	                                    isInArray_var = _context10.sent;
	
	                                  case 12:
	                                    _context10.next = 17;
	                                    break;
	
	                                  case 14:
	                                    _context10.next = 16;
	                                    return _FrmSubscription4.default.checkFrmVideosSubscription(chapter.level, exam_data, examPlanData);
	
	                                  case 16:
	                                    isInArray_var = _context10.sent;
	
	                                  case 17:
	                                    if (!isInArray_var) {
	                                      _context10.next = 22;
	                                      break;
	                                    }
	
	                                    _data2 = {
	                                      token: _this5.state.token,
	                                      idname: _this5.state.idname,
	                                      id: chapter.id,
	                                      videoIndex: index,
	                                      city: _this5.state.user_city,
	                                      country: _this5.state.user_country,
	                                      state: _this5.state.user_state,
	                                      continent: _this5.state.user_continent,
	                                      ip: _this5.state.user_ip
	                                    };
	
	                                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/trackUserVideowatch', _data2).then(function () {
	                                      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                                        return _regenerator2.default.wrap(function _callee9$(_context9) {
	                                          while (1) {
	                                            switch (_context9.prev = _context9.next) {
	                                              case 0:
	                                                if (resp.success) {
	                                                  if (chapter.level === 1) {
	                                                    _this5.context.router.push({
	                                                      pathname: '/frm/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                                      search: '?showCapsules=' + _this5.state.showCapsules + '&level=' + chapter.level,
	                                                      state: {
	                                                        token: _this5.state.token,
	                                                        idname: _this5.state.idname,
	                                                        chapter: chapter,
	                                                        index: index,
	                                                        showFreePremium: _this5.state.showFreePremium,
	                                                        level: chapter.level,
	                                                        showCapsules: _this5.state.showCapsules
	                                                      }
	                                                    });
	                                                  } else {
	                                                    _this5.context.router.push({
	                                                      pathname: '/frm/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium1 ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                                      search: '?showCapsules=' + _this5.state.showCapsules + '&level=' + chapter.level,
	                                                      state: {
	                                                        token: _this5.state.token,
	                                                        idname: _this5.state.idname,
	                                                        chapter: chapter,
	                                                        index: index,
	                                                        showFreePremium: _this5.state.showFreePremium1,
	                                                        level: chapter.level,
	                                                        showCapsules: _this5.state.showCapsules
	                                                      }
	                                                    });
	                                                  }
	                                                } else {}
	
	                                              case 1:
	                                              case 'end':
	                                                return _context9.stop();
	                                            }
	                                          }
	                                        }, _callee9, _this6);
	                                      }));
	
	                                      return function (_x11) {
	                                        return _ref11.apply(this, arguments);
	                                      };
	                                    }());
	                                    _context10.next = 23;
	                                    break;
	
	                                  case 22:
	                                    return _context10.abrupt('return', _this5.toggleAlert());
	
	                                  case 23:
	                                    _context10.next = 25;
	                                    break;
	
	                                  case 25:
	                                  case 'end':
	                                    return _context10.stop();
	                                }
	                              }
	                            }, _callee10, _this6);
	                          }));
	
	                          return function (_x10) {
	                            return _ref10.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      if (resp.profileInfo.exam_selected === '') {
	                        return _this5.toggleAlert();
	                      } else {
	                        // const exam_selected = resp.profileInfo.exam_selected
	                        //   ? JSON.parse(resp.profileInfo.exam_selected)
	                        //   : resp.profileInfo.exam_selected;
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this5.setState({ subscription_details: subscription_details });
	
	                        var _data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var _dataset2 = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: _data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset2).then(function (resp_exam) {
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            // var selectedmen = this.state.selectedmenu;
	                            var isInArray_var = false;
	                            if (chapter.chapter_id === 11) {
	                              isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(1, exam_data);
	                              if (!isInArray_var) {
	                                isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(2, exam_data);
	                              }
	                            } else {
	                              isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(chapter.level, exam_data);
	                            }
	                            if (isInArray_var) {
	                              var _data3 = {
	                                token: _this5.state.token,
	                                idname: _this5.state.idname,
	                                id: chapter.id,
	                                videoIndex: index,
	                                city: _this5.state.user_city,
	                                country: _this5.state.user_country,
	                                state: _this5.state.user_state,
	                                continent: _this5.state.user_continent,
	                                ip: _this5.state.user_ip
	                              };
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/trackUserVideowatch', _data3).then(function () {
	                                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                                    while (1) {
	                                      switch (_context11.prev = _context11.next) {
	                                        case 0:
	                                          if (resp.success) {
	                                            if (chapter.level === 1) {
	                                              _this5.context.router.push({
	                                                pathname: '/frm/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                                search: '?showCapsules=' + _this5.state.showCapsules + '&level=' + chapter.level,
	                                                state: {
	                                                  token: _this5.state.token,
	                                                  idname: _this5.state.idname,
	                                                  chapter: chapter,
	                                                  index: index,
	                                                  showFreePremium: _this5.state.showFreePremium,
	                                                  level: chapter.level,
	                                                  showCapsules: _this5.state.showCapsules
	                                                }
	                                              });
	                                            } else {
	                                              _this5.context.router.push({
	                                                pathname: '/frm/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium1 ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                                search: '?showCapsules=' + _this5.state.showCapsules + '&level=' + chapter.level,
	                                                state: {
	                                                  token: _this5.state.token,
	                                                  idname: _this5.state.idname,
	                                                  chapter: chapter,
	                                                  index: index,
	                                                  showFreePremium: _this5.state.showFreePremium1,
	                                                  level: chapter.level,
	                                                  showCapsules: _this5.state.showCapsules
	                                                }
	                                              });
	                                            }
	                                          } else {}
	
	                                        case 1:
	                                        case 'end':
	                                          return _context11.stop();
	                                      }
	                                    }
	                                  }, _callee11, _this6);
	                                }));
	
	                                return function (_x12) {
	                                  return _ref12.apply(this, arguments);
	                                };
	                              }());
	                            } else {
	                              return _this5.toggleAlert();
	                            }
	                          } else {}
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this6);
	      }));
	
	      return function (_x7, _x8) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this5.savelastVideo = function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(chapter, index, level) {
	        var _this5$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _this5$state = _this5.state, token = _this5$state.token, idname = _this5$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  videoIndex: index,
	                  level: level
	                };
	                _context13.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({ ValidToken: true });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this6);
	      }));
	
	      return function (_x13, _x14, _x15) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    _this5.iframe = { padding: 10 };
	
	    _this5.videoSection = function () {
	      var data = '';
	      var count = 0;
	      if (_this5.state.allchapters.length) {
	        data = _this5.state.allchapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            item && item.level === 1 ? _react2.default.createElement(
	              'div',
	              null,
	              item.chapter_id === 11 ? _this5.state.showCapsules ? item.free === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'video-type-free' },
	                _language2.default.LC().FREE
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'video-type-primum' },
	                _language2.default.LC().PREMIUM
	              ) : _react2.default.createElement('div', null) : _this5.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'video-type-free' },
	                _language2.default.LC().FREE
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'video-type-primum' },
	                _language2.default.LC().PREMIUM
	              ) : _react2.default.createElement('div', null),
	              !item.url_id_qq ? _react2.default.createElement('img', {
	                alt: '',
	                width: '100%',
	                src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	                value: index,
	                onClick: _this5.getReadings.bind(_this5, item, index),
	                className: 'pointer_class slider_row'
	              }) : _react2.default.createElement('img', {
	                alt: '',
	                width: '100%',
	                src: item.posterImage ? item.posterImage : 'https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1.jpg',
	                onError: function onError(_ref14) {
	                  var currentTarget = _ref14.currentTarget;
	
	                  if (!count++) {
	                    // Added condition because of infinite loop, this will once only
	                    currentTarget.onerror = null; // prevents looping
	                    currentTarget.src = '\n                      https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1_2.jpg';
	                  }
	                },
	                value: index,
	                onClick: _this5.getReadings.bind(_this5, item, index),
	                className: 'pointer_class slider_row'
	              }),
	              _react2.default.createElement(
	                'strong',
	                { style: { padding: '10px' } },
	                ' ',
	                item.title
	              )
	            ) :
	            /* item.level === 2 ? */_react2.default.createElement(
	              'div',
	              { key: index },
	              _this5.state.showFreePremium1 ? item.free === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'video-type-free' },
	                _language2.default.LC().FREE
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'video-type-primum' },
	                _language2.default.LC().PREMIUM
	              ) : _react2.default.createElement('div', null),
	              !item.url_id_qq ? _react2.default.createElement('img', {
	                alt: '',
	                width: '100%',
	                src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	                value: index,
	                onClick: _this5.getReadings.bind(_this5, item, index),
	                className: 'pointer_class slider_row'
	              }) : _react2.default.createElement('img', {
	                alt: '',
	                width: '100%',
	                src: item.posterImage ? item.posterImage : (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1'),
	                onError: function onError(_ref15) {
	                  var currentTarget = _ref15.currentTarget;
	
	                  if (!count++) {
	                    // Added condition because of infinite loop, this will once only
	                    currentTarget.onerror = null; // prevents looping
	                    currentTarget.src = (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1_2');
	                  }
	                },
	                value: index,
	                onClick: _this5.getReadings.bind(_this5, item, index),
	                className: 'pointer_class slider_row'
	              }),
	              _react2.default.createElement(
	                'strong',
	                { style: { padding: '10px' } },
	                ' ',
	                item.title
	              )
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    _this5.state = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: '<i class="icon-info icons font-2xl d-block "></i>',
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      Allchapters: [],
	      itemData: [],
	      videoUrl: '',
	      srcUrl: '',
	      srcUrl_final: '',
	      selectedmenu: 'frm',
	      showFreePremium: true,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      showFreePremium1: true,
	      showCapsules: _this5.props.showCapsules
	    };
	    return _this5;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	        var _this7 = this;
	
	        var result, storage_session, payload;
	        return _regenerator2.default.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _context14.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context14.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({
	                  showFreePremium: this.props.showFreePremium,
	                  showFreePremium1: this.props.showFreePremium1
	                });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                payload = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context14.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getcfavideosChapterwise', payload).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this7.setState({ allchapters: [], ValidToken: false });
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, this);
	      }));
	
	      function componentDidMount() {
	        return _ref16.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = FrmvideoLessons;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1009);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	
	
	var Frmvideodisplay = function (_Component) {
	  _inherits(Frmvideodisplay, _Component);
	
	  function Frmvideodisplay(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Frmvideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (Frmvideodisplay.__proto__ || Object.getPrototypeOf(Frmvideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/trackUserVideowatch', data);
	    };
	
	    _this.pdfOpen = function () {
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this.displayReportForm = function () {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this.hideReportForm = function () {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this.reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        videoIndex: _this.state.currentUrl,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        level: _this.state.videoPartLevel
	      };
	      _this.setState({ reportLoading: true });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function () {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function () {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this.getToggleFlash = function () {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this.saveFlashCard = function (id) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card,
	        level: _this.state.videoPartLevel
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoGetFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block' });
	                response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this.editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this.deleteFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
	              }
	              _this.setState({ flash_data: _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                ) });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.editFlash = function (item) {
	      _this.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this.deleteFlash = function (item) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getChapters = function () {
	      _this.context.router.push({
	        pathname: '/frm/videoLessons',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.moveToNotes = function () {
	      // const final_exam = [];
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        // const selectedmen = this.state.selectedmenu;
	
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context.next = 6;
	                        return _FrmSubscription4.default.checkFrmVideosSubscription(_this.state.videoPartLevel, exam_data, examPlanData);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var) {
	                          _this.context.router.push({
	                            pathname: '/frm/notesview/' + _this.state.currentReadingNo + '/' + _this.state.currentChapterNo + '/' + _this.state.currentReadingTitle + '/' + _this.state.currentChapterNo,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              reading: {
	                                id: _this.state.currentReadingNo,
	                                chapter_no: _this.state.currentChapterNo,
	                                reading: _this.state.currentReadingTitle,
	                                chapter: _this.state.currentChapterNo,
	                                level: _this.state.videoPartLevel
	                              }
	                            }
	                          });
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            // console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            return _this.toggleAlert();
	          } else {
	            var _data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var _dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: _data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                // const selectedmen = this.state.selectedmenu;
	                var isInArray_var = false;
	
	                isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(_this.state.videoPartLevel, exam_data);
	
	                if (isInArray_var) {
	                  _this.context.router.push({
	                    pathname: '/frm/notesview/' + _this.state.currentReadingNo + '/' + _this.state.currentChapterNo + '/' + _this.state.currentReadingTitle + '/' + _this.state.currentChapterNo,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      reading: {
	                        id: _this.state.currentReadingNo,
	                        chapter_no: _this.state.currentChapterNo,
	                        reading: _this.state.currentReadingTitle,
	                        chapter: _this.state.currentChapterNo,
	                        level: _this.state.videoPartLevel
	                      }
	                    }
	                  });
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      // const final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, isInArray_var, examPlanData;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        // const selectedmen = this.state.selectedmenu;
	
	                        isInArray_var = false;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context2.next = 6;
	                        return _FrmSubscription4.default.checkFrmVideosSubscription(_this.state.videoPartLevel, exam_data, examPlanData);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	
	                        if (isInArray_var) {
	                          _this.runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this.runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            return _this.toggleAlert();
	          } else {
	            var _data_arr2 = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var _dataset2 = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: _data_arr2
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset2).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                // const selectedmen = this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(_this.state.videoPartLevel, exam_data);
	                if (isInArray_var) {
	                  _this.runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this.runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {}
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({ alert_status: !_this.state.alert_status });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(index, url_id, title, id, url_id_qq, posterImage, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  posterImage: posterImage,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file
	                }, function () {
	                  _this.context.router.push({
	                    pathname: '/frm/videodisplay/' + _this.props.params.id + '/' + _this.props.params.showFreePremium + '/' + (_this.props.params.type ? _this.props.params.type : 1) + '/' + (_this.props.params.chapter_id ? _this.props.params.chapter_id : item.chapter_id) + '/' + _this.state.currentUrl,
	                    search: '?showCapsules=' + (_this.state.showCapsules ? _this.state.showCapsules : false) + '&level=' + (_this.state.videoPartLevel ? _this.state.videoPartLevel : item.level)
	                  });
	                });
	                _context6.next = 4;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 4:
	                _context6.next = 6;
	                return _this.savelastVideo(id, index, item.level);
	
	              case 6:
	                _context6.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                          var exam_data, isInArray_var, examPlanData;
	                          return _regenerator2.default.wrap(function _callee4$(_context4) {
	                            while (1) {
	                              switch (_context4.prev = _context4.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context4.next = 27;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  // const selectedmen = this.state.selectedmenu;
	
	                                  isInArray_var = false;
	                                  examPlanData = resp_exam.examPlan[0];
	
	                                  if (!(item.chapter_id === 11)) {
	                                    _context4.next = 14;
	                                    break;
	                                  }
	
	                                  _context4.next = 7;
	                                  return _FrmSubscription4.default.checkFrmVideosSubscription(1, exam_data, examPlanData);
	
	                                case 7:
	                                  isInArray_var = _context4.sent;
	
	                                  if (isInArray_var) {
	                                    _context4.next = 12;
	                                    break;
	                                  }
	
	                                  _context4.next = 11;
	                                  return _FrmSubscription4.default.checkFrmVideosSubscription(2, exam_data, examPlanData);
	
	                                case 11:
	                                  isInArray_var = _context4.sent;
	
	                                case 12:
	                                  _context4.next = 17;
	                                  break;
	
	                                case 14:
	                                  _context4.next = 16;
	                                  return _FrmSubscription4.default.checkFrmVideosSubscription(_this.state.videoPartLevel, exam_data, examPlanData);
	
	                                case 16:
	                                  isInArray_var = _context4.sent;
	
	                                case 17:
	                                  if (!isInArray_var) {
	                                    _context4.next = 26;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    posterImage: posterImage,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: '/frm/videodisplay/' + _this.props.params.id + '/' + _this.props.params.showFreePremium + '/' + (_this.props.params.type ? _this.props.params.type : 1) + '/' + (_this.props.params.chapter_id ? _this.props.params.chapter_id : item.chapter_id) + '/' + _this.state.currentUrl,
	                                      search: '?showCapsules=' + (_this.state.showCapsules ? _this.state.showCapsules : false) + '&level=' + (_this.state.videoPartLevel ? _this.state.videoPartLevel : item.level)
	                                    });
	                                  });
	
	                                  _context4.next = 21;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 21:
	                                  _context4.next = 23;
	                                  return _this.savelastVideo(id, index, item.level);
	
	                                case 23:
	                                  return _context4.abrupt('return');
	
	                                case 26:
	                                  return _context4.abrupt('return', _this.toggleAlert());
	
	                                case 27:
	                                case 'end':
	                                  return _context4.stop();
	                              }
	                            }
	                          }, _callee4, _this2);
	                        }));
	
	                        return function (_x12) {
	                          return _ref5.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({ subscription_details: subscription_details });
	
	                      var _data_arr3 = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var _dataset3 = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: _data_arr3
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset3).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 16;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  // const selectedmen = this.state.selectedmenu;
	
	                                  isInArray_var = false;
	
	                                  if (item.chapter_id === 11) {
	                                    isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(1, exam_data);
	                                    if (isInArray_var) {
	                                      _this.setState({ showFreePremiumFRM_1: false });
	                                    } else {
	                                      _this.setState({ showFreePremiumFRM_1: true });
	                                    }
	                                    if (!isInArray_var) {
	                                      isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(2, exam_data);
	
	                                      if (isInArray_var) {
	                                        _this.setState({ showFreePremiumFRM_2: false });
	                                      } else {
	                                        _this.setState({ showFreePremiumFRM_2: true });
	                                      }
	                                    }
	                                  } else {
	                                    isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(_this.state.videoPartLevel, exam_data);
	                                  }
	                                  // isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
	                                  //   this.state.videoPartLevel,
	                                  //   exam_data
	                                  // );
	
	                                  if (!isInArray_var) {
	                                    _context5.next = 13;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    posterImage: posterImage,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: '/frm/videodisplay/' + _this.props.params.id + '/' + _this.props.params.showFreePremium + '/' + _this.props.params.type + '/' + _this.props.params.chapter_id + '/' + _this.state.currentUrl,
	                                      search: '?showCapsules=' + (_this.state.showCapsules ? _this.state.showCapsules : false) + '&level=' + (_this.state.videoPartLevel ? _this.state.videoPartLevel : item.level)
	                                    });
	                                  });
	
	                                  _context5.next = 8;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 8:
	                                  _context5.next = 10;
	                                  return _this.savelastVideo(id, index, item.level);
	
	                                case 10:
	                                  return _context5.abrupt('return');
	
	                                case 13:
	                                  return _context5.abrupt('return', _this.toggleAlert());
	
	                                case 14:
	                                  _context5.next = 16;
	                                  break;
	
	                                case 16:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this2);
	                        }));
	
	                        return function (_x13) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x4, _x5, _x6, _x7, _x8, _x9, _x10, _x11) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(id, index, level) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index,
	                  level: level
	                };
	                _context7.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({ ValidToken: true });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x14, _x15, _x16) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.saveFavVideo = function (item) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item,
	        level: _this.state.videoPartLevel
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved,
	              isFlashCardHidden: false
	            });
	            _this.getToggleFlash();
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.state = {
	      successAlert: false,
	      alert_status: false,
	      showFreePremiumFRM_1: true,
	      showFreePremiumFRM_2: true,
	
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      // MessageTitle: `<i class="icon-info icons font-2xl d-block "></i>`,
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      all_questions: '',
	      chapters: [],
	      all_questions_state: [],
	      video_display: '',
	      video_display_qq: '',
	      posterImage: '',
	      url_id: '',
	      currentUrl: '',
	      video_title: '',
	      video_display_no: '',
	      allChapters: [],
	      Chapter_Title: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      notesCSS: 'fa fa-book mark-action-btn',
	      questionsCSS: 'fa fa-question-circle-o mark-action-btn',
	      showFreePremium: _this.props.params.showFreePremium === '0',
	      currentReading: _this.props.params.id,
	      comment_update_id: '',
	      currentChapterNo: '',
	      currentReadingNo: '',
	      currentReadingTitle: '',
	      subscriptionstatus: '',
	      selectedmenu: 'frm',
	      subscription_details_for_isActive: '',
	      pdfData: [],
	      pdf_file: '',
	      type: _this.props.params.type === '0' ? 'intro' : 'notintro',
	      userType: '',
	      saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      videoPartLevel: '',
	      showCapsules: ''
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(Frmvideodisplay, [{
	    key: 'goToPreviousReading',
	    value: function goToPreviousReading() {
	      var _this3 = this;
	
	      if (this.state.currentUrl === 0 || this.state.currentUrl < 0 || this.state.currentUrl > this.state.chapters.length - 1) {
	        return;
	      }
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      this.context.router.push({
	        pathname: '/frm/videodisplay/' + this.props.params.id + '/' + this.props.params.showFreePremium + '/' + (this.props.params.type ? this.props.params.type : 1) + '/' + (this.props.params.chapter_id ? this.props.params.chapter_id : this.state.chapters[this.state.currentUrl].chapter_id) + '/' + this.state.currentUrl,
	        search: '?showCapsules=' + (this.state.showCapsules ? this.state.showCapsules : false) + '&level=' + (this.state.videoPartLevel ? this.state.videoPartLevel : this.state.chapters[this.state.currentUrl].level)
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({ video_display: _this3.state.chapters[_this3.state.currentUrl].url_id });
	          _this3.setState({ video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq });
	          _this3.setState({ posterImage: _this3.state.chapters[_this3.state.currentUrl].posterImage });
	          _this3.setState({ video_title: _this3.state.chapters[_this3.state.currentUrl].title });
	          _this3.setState({ currentReading: _this3.state.chapters[_this3.state.currentUrl].id });
	          _this3.setState({ currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id });
	          _this3.setState({ currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no });
	          _this3.setState({ currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title });
	          _this3.setState({ pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file });
	        });
	        this.context.router.push({
	          pathname: '/frm/videodisplay/' + this.props.params.id + '/' + this.props.params.showFreePremium + '/' + (this.props.params.type ? this.props.params.type : 1) + '/' + (this.props.params.chapter_id ? this.props.params.chapter_id : this.state.chapters[this.state.currentUrl].chapter_id) + '/' + this.state.currentUrl,
	          search: '?showCapsules=' + (this.state.showCapsules ? this.state.showCapsules : false) + '&level=' + (this.state.videoPartLevel ? this.state.videoPartLevel : this.state.chapters[this.state.currentUrl].level)
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({ subscription_details: subscription_details });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp_exam) {
	                  var exam_data, isInArray_var, examPlanData;
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context8.next = 17;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          // const selectedmen = this.state.selectedmenu;
	
	                          isInArray_var = false;
	                          examPlanData = resp_exam.examPlan[0];
	                          _context8.next = 6;
	                          return _FrmSubscription4.default.checkFrmVideosSubscription(_this3.state.videoPartLevel, exam_data, examPlanData);
	
	                        case 6:
	                          isInArray_var = _context8.sent;
	
	                          if (!isInArray_var) {
	                            _context8.next = 14;
	                            break;
	                          }
	
	                          _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                            _this3.setState({ video_display: _this3.state.chapters[_this3.state.currentUrl].url_id });
	                            _this3.setState({ video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq });
	                            _this3.setState({ posterImage: _this3.state.chapters[_this3.state.currentUrl].posterImage });
	                            _this3.setState({ video_title: _this3.state.chapters[_this3.state.currentUrl].title });
	                            _this3.setState({ currentReading: _this3.state.chapters[_this3.state.currentUrl].id });
	                            _this3.setState({ currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id });
	                            _this3.setState({ currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no });
	                            _this3.setState({ currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title });
	                            _this3.setState({ pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file });
	                          });
	                          _this3.context.router.push({
	                            pathname: '/frm/videodisplay/' + _this3.props.params.id + '/' + _this3.props.params.showFreePremium + '/' + (_this3.props.params.type ? _this3.props.params.type : 1) + '/' + (_this3.props.params.chapter_id ? _this3.props.params.chapter_id : _this3.state.chapters[_this3.state.currentUrl].chapter_id) + '/' + _this3.state.currentUrl,
	                            search: '?showCapsules=' + (_this3.state.showCapsules ? _this3.state.showCapsules : false) + '&level=' + (_this3.state.videoPartLevel ? _this3.state.videoPartLevel : _this3.state.chapters[_this3.state.currentUrl].level)
	                          });
	
	                          _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                          return _context8.abrupt('return');
	
	                        case 14:
	                          return _context8.abrupt('return', _this3.toggleAlert());
	
	                        case 15:
	                          _context8.next = 17;
	                          break;
	
	                        case 17:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this3);
	                }));
	
	                return function (_x17) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '') {
	              return _this3.toggleAlert();
	            } else {
	              var _subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({ subscription_details: _subscription_details });
	
	              var _data_arr4 = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var _dataset4 = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: _data_arr4
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset4).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  // const selectedmen = this.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(_this3.state.videoPartLevel, exam_data);
	
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({ video_display: _this3.state.chapters[_this3.state.currentUrl].url_id });
	                      _this3.setState({ video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq });
	                      _this3.setState({ posterImage: _this3.state.chapters[_this3.state.currentUrl].posterImage });
	                      _this3.setState({ video_title: _this3.state.chapters[_this3.state.currentUrl].title });
	                      _this3.setState({ currentReading: _this3.state.chapters[_this3.state.currentUrl].id });
	                      _this3.setState({ currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id });
	                      _this3.setState({ currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no });
	                      _this3.setState({ currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title });
	                      _this3.setState({ pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file });
	                    });
	                    _this3.context.router.push({
	                      pathname: '/frm/videodisplay/' + _this3.props.params.id + '/' + _this3.props.params.showFreePremium + '/' + (_this3.props.params.type ? _this3.props.params.type : 1) + '/' + (_this3.props.params.chapter_id ? _this3.props.params.chapter_id : _this3.state.chapters[_this3.state.currentUrl].chapter_id) + '/' + _this3.state.currentUrl,
	                      search: '?showCapsules=' + (_this3.state.showCapsules ? _this3.state.showCapsules : false) + '&level=' + (_this3.state.videoPartLevel ? _this3.state.videoPartLevel : _this3.state.chapters[_this3.state.currentUrl].level)
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    return _this3.toggleAlert();
	                  }
	                } else {}
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'goToNextReading',
	    value: function goToNextReading() {
	      var _this4 = this;
	
	      if (this.state.currentUrl === this.state.chapters.length - 1 || this.state.currentUrl >= this.state.chapters.length - 1) {
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      }
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({ video_display: _this4.state.chapters[_this4.state.currentUrl].url_id });
	          _this4.setState({ video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq });
	          _this4.setState({ posterImage: _this4.state.chapters[_this4.state.currentUrl].posterImage });
	          _this4.setState({ video_title: _this4.state.chapters[_this4.state.currentUrl].title });
	          _this4.setState({ currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title });
	          _this4.setState({ currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id });
	          _this4.setState({ currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no });
	          _this4.setState({ currentReading: _this4.state.chapters[_this4.state.currentUrl].id });
	          _this4.setState({ pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file });
	        });
	        this.context.router.push({
	          pathname: '/frm/videodisplay/' + this.props.params.id + '/' + this.props.params.showFreePremium + '/' + (this.props.params.type ? this.props.params.type : 1) + '/' + (this.props.params.chapter_id ? this.props.params.chapter_id : this.state.chapters[this.state.currentUrl].chapter_id) + '/' + this.state.currentUrl,
	          search: '?showCapsules=' + (this.state.showCapsules ? this.state.showCapsules : false) + '&level=' + (this.state.videoPartLevel ? this.state.videoPartLevel : this.state.chapters[this.state.currentUrl].level)
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                  var exam_data, isInArray_var, examPlanData;
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context9.next = 17;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          // const selectedmen = this.state.selectedmenu;
	
	                          isInArray_var = false;
	                          examPlanData = resp_exam.examPlan[0];
	                          _context9.next = 6;
	                          return _FrmSubscription4.default.checkFrmVideosSubscription(_this4.state.videoPartLevel, exam_data, examPlanData);
	
	                        case 6:
	                          isInArray_var = _context9.sent;
	
	                          if (!isInArray_var) {
	                            _context9.next = 14;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({ video_display: _this4.state.chapters[_this4.state.currentUrl].url_id });
	                            _this4.setState({ video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq });
	                            _this4.setState({ posterImage: _this4.state.chapters[_this4.state.currentUrl].posterImage });
	                            _this4.setState({ video_title: _this4.state.chapters[_this4.state.currentUrl].title });
	                            _this4.setState({ currentReading: _this4.state.chapters[_this4.state.currentUrl].id });
	                            _this4.setState({ currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id });
	                            _this4.setState({ currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no });
	                            _this4.setState({ currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title });
	                            _this4.setState({ pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file });
	                          });
	                          _this4.context.router.push({
	                            pathname: '/frm/videodisplay/' + _this4.props.params.id + '/' + _this4.props.params.showFreePremium + '/' + (_this4.props.params.type ? _this4.props.params.type : 1) + '/' + (_this4.props.params.chapter_id ? _this4.props.params.chapter_id : _this4.state.chapters[_this4.state.currentUrl].chapter_id) + '/' + (_this4.state.currentUrl + 1),
	                            search: '?showCapsules=' + (_this4.state.showCapsules ? _this4.state.showCapsules : false) + '&level=' + (_this4.state.videoPartLevel ? _this4.state.videoPartLevel : _this4.state.chapters[_this4.state.currentUrl].level)
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context9.abrupt('return');
	
	                        case 14:
	                          return _context9.abrupt('return', _this4.toggleAlert());
	
	                        case 15:
	                          _context9.next = 17;
	                          break;
	
	                        case 17:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this4);
	                }));
	
	                return function (_x18) {
	                  return _ref9.apply(this, arguments);
	                };
	              }()
	              //console.log('fail');
	              );
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '') {
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({ subscription_details: subscription_details });
	              var _data_arr5 = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var _dataset5 = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: _data_arr5
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', _dataset5).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  // const selectedmen = this.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(_this4.state.videoPartLevel, exam_data);
	                  if (isInArray_var) {
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({ video_display: _this4.state.chapters[_this4.state.currentUrl].url_id });
	                      _this4.setState({ video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq });
	                      _this4.setState({ posterImage: _this4.state.chapters[_this4.state.currentUrl].posterImage });
	                      _this4.setState({ video_title: _this4.state.chapters[_this4.state.currentUrl].title });
	                      _this4.setState({ currentReading: _this4.state.chapters[_this4.state.currentUrl].id });
	                      _this4.setState({ currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id });
	                      _this4.setState({ currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no });
	                      _this4.setState({ currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title });
	                      _this4.setState({ pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file });
	                    });
	                    _this4.context.router.push({
	                      pathname: '/frm/videodisplay/' + _this4.props.params.id + '/' + _this4.props.params.showFreePremium + '/' + (_this4.props.params.type ? _this4.props.params.type : 1) + '/' + (_this4.props.params.chapter_id ? _this4.props.params.chapter_id : _this4.state.chapters[_this4.state.currentUrl].chapter_id) + '/' + _this4.state.currentUrl,
	                      search: '?showCapsules=' + (_this4.state.showCapsules ? _this4.state.showCapsules : false) + '&level=' + (_this4.state.videoPartLevel ? _this4.state.videoPartLevel : _this4.state.chapters[_this4.state.currentUrl].level)
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                    return;
	                  } else {
	                    return _this4.toggleAlert();
	                  }
	                } else {}
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    /*
	    ----------------------------------
	      Function to show Report box
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------
	      Function to hide Report box
	    -------------------------------
	    */
	
	
	    /*
	    ------------------------------------------
	      Function to save new report question
	    -----------------------------------------
	    */
	
	    /*
	    ---------------------------------
	     Function to toggle Comment box
	    ---------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	     Function to toggle Flash box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------------------
	     Function to Save flash Card And display new stored flash card
	    -----------------------------------------------------------------
	    */
	
	
	    /*
	    ----------------------------------
	     Function to Edit Flash card
	    ----------------------------------
	    */
	
	
	    /*
	    ----------------------------------
	     Function to delete flash card
	    ----------------------------------
	    */
	
	
	    /*
	    --------------------------------------------------
	    Function to redirect page to viewquestions page
	    --------------------------------------------------
	    */
	
	  }, {
	    key: 'runCode',
	    value: function runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: '/frm/questions/' + _this5.state.currentReadingNo + '/' + _this5.state.currentChapterNo + '/' + _this5.state.currentReadingTitle + '/' + _this5.state.subscriptionstatus + '/' + _this5.props.params.chapter + '/' + _this5.state.videoPartLevel,
	              state: {
	                token: _this5.state.token,
	                idname: _this5.state.idname,
	                reading: {
	                  id: _this5.state.currentReadingNo,
	                  chapter_no: _this5.state.currentChapterNo,
	                  reading: _this5.state.currentReadingTitle
	                },
	                subscriptionstatus: _this5.state.subscriptionstatus,
	                level: _this5.state.videoPartLevel
	              }
	            });
	          } else {
	            _this5.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(prevProps, prevState) {
	        var _this6 = this;
	
	        var params;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context10.next = 6;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context10.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                _context10.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block' });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6.editFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6.deleteFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 6:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function componentDidUpdate(_x19, _x20) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee13() {
	        var _this7 = this;
	
	        var location, _location$query, level, showCapsules, chapter_name, result, storage_session, datas, data, params;
	
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                // console.log(
	                //   '--------------this.props---------------------->',
	                //   this.props.params.showFreePremium,
	                // );
	
	                location = this.props.location;
	                _location$query = location.query, level = _location$query.level, showCapsules = _location$query.showCapsules, chapter_name = _location$query.chapter_name;
	
	                this.setState({
	                  showCapsules: showCapsules,
	                  videoPartLevel: level,
	                  chapterName: chapter_name
	                });
	                // api to get ip address
	                _context13.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context13.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  this.setState({
	                    // eslint-disable-next-line radix
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  this.setState({ currentUrl: 0 });
	                }
	                datas = { token: this.state.token, idname: this.state.idname };
	                _context13.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', datas).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context11.next = 3;
	                              break;
	                            }
	
	                            _context11.next = 7;
	                            break;
	
	                          case 3:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this7.state.token,
	                              idname: _this7.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 7;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var isInArray_var = false;
	                                isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(1, exam_data);
	                                if (isInArray_var) {
	                                  _this7.setState({ showFreePremiumFRM_1: false });
	                                } else {
	                                  _this7.setState({ showFreePremiumFRM_1: true });
	                                }
	                                // var exam_data = resp_exam.examData;
	                                var isInArray_var1 = false;
	                                isInArray_var1 = _FrmSubscription2.default.checkFrmVideosSubscription(2, exam_data);
	                                if (isInArray_var1) {
	                                  _this7.setState({ showFreePremiumFRM_2: false });
	                                } else {
	                                  _this7.setState({ showFreePremiumFRM_2: true });
	                                }
	                              } else {}
	                            });
	
	                          case 7:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this7);
	                  }));
	
	                  return function (_x21) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id || this.props.params.id
	                };
	                _context13.next = 17;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getcfavideosChapterwise', data).then(function () {
	                  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp) {
	                    return _regenerator2.default.wrap(function _callee12$(_context12) {
	                      while (1) {
	                        switch (_context12.prev = _context12.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context12.next = 29;
	                              break;
	                            }
	
	                            _context12.next = 3;
	                            return _this7.setState({ ValidToken: true });
	
	                          case 3:
	                            _context12.next = 5;
	                            return _this7.setState({ chapters: resp.cfavchapter });
	
	                          case 5:
	                            _context12.next = 7;
	                            return _this7.setState({ pdf_file: _this7.state.chapters[_this7.state.currentUrl].pdf_file });
	
	                          case 7:
	                            _context12.next = 9;
	                            return _this7.setState({ currentReading: _this7.state.chapters[_this7.state.currentUrl].id });
	
	                          case 9:
	                            _context12.next = 11;
	                            return _this7.setState({ video_display: _this7.state.chapters[_this7.state.currentUrl].url_id });
	
	                          case 11:
	                            _context12.next = 13;
	                            return _this7.setState({ video_display_qq: _this7.state.chapters[_this7.state.currentUrl].url_id_qq });
	
	                          case 13:
	                            _context12.next = 15;
	                            return _this7.setState({ posterImage: _this7.state.chapters[_this7.state.currentUrl].posterImage });
	
	                          case 15:
	                            _context12.next = 17;
	                            return _this7.setState({
	                              video_display_previous: _this7.state.chapters[_this7.state.currentUrl].url_id_qq ? _this7.state.chapters[_this7.state.currentUrl].url_id_qq : _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 17:
	                            _context12.next = 19;
	                            return _this7.setState({ video_title: _this7.state.chapters[_this7.state.currentUrl].title });
	
	                          case 19:
	                            _context12.next = 21;
	                            return _this7.setState({
	                              video_display_next: _this7.state.chapters[_this7.state.currentUrl + 1] ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id_qq ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id_qq : _this7.state.chapters[_this7.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 21:
	                            _context12.next = 23;
	                            return _this7.setState({ currentChapterNo: _this7.state.chapters[_this7.state.currentUrl].chapter_id });
	
	                          case 23:
	                            _context12.next = 25;
	                            return _this7.setState({ currentReadingNo: _this7.state.chapters[_this7.state.currentUrl].reading_no });
	
	                          case 25:
	                            _context12.next = 27;
	                            return _this7.setState({ currentReadingTitle: _this7.state.chapters[_this7.state.currentUrl].title });
	
	                          case 27:
	                            _context12.next = 30;
	                            break;
	
	                          case 29:
	                            _this7.setState({ ValidToken: false });
	
	                          case 30:
	                            return _context12.abrupt('return', resp);
	
	                          case 31:
	                          case 'end':
	                            return _context12.stop();
	                        }
	                      }
	                    }, _callee12, _this7);
	                  }));
	
	                  return function (_x22) {
	                    return _ref13.apply(this, arguments);
	                  };
	                }());
	
	              case 17:
	                _context13.next = 19;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getfrmVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ ValidToken: true, allChapters: resp.cfavideo });
	                    if (_this7.props.params.chapter_id === undefined || _this7.props.params.chapter_id === null) {
	                      _this7.setState({ Chapter_Title: resp.frmvideo[_this7.props.params.chapter_id - 1].chapter_name });
	                    }
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 19:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context13.next = 22;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 22:
	                _context13.next = 24;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this7.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this7.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block' });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7.editFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7.deleteFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this7.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this7.setState({ flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block' });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this7.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this7.setState({
	                      ValidToken: false,
	                      flash_data: flash_cards,
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 24:
	                _context13.next = 26;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getcfa_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ pdfData: resp });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 26:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, this);
	      }));
	
	      function componentDidMount() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    -----------------------
	      saved viewed video
	    -----------------------
	    */
	
	    /*
	    --------------------------------------------------------------------
	     Function to Display Saved Question on button and save in database
	    --------------------------------------------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          chapters = _state.chapters,
	          currentReading = _state.currentReading,
	          videoPartLevel = _state.videoPartLevel,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          pdf_file = _state.pdf_file,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          type = _state.type,
	          questionsCSS = _state.questionsCSS,
	          saveVideo_text = _state.saveVideo_text,
	          showFreePremium = _state.showFreePremium;
	      // const chapters = this.state.chapters;
	
	      var styles_css = { marginBottom: '20px' };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                item.chapter_id === 11 ? _this8.state.showFreePremiumFRM_1 === true && _this8.state.showFreePremiumFRM_2 === true ? item.free === 1 ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null) : _this8.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id_qq ? item.url_id_qq === _this8.state.video_display_qq ? 'active' : '' : item.url_id === _this8.state.video_display ? 'active' : '',
	                    onClick: _this8.getVideourl.bind(_this8, index, item.url_id, item.title, item.id, item.url_id_qq, item.posterImage, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  ' ',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            this.state.type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this.getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8' },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 || this.state.currentUrl < 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this.goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 || this.state.currentUrl >= this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this.goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        allowFullScreen: true,
	                        width: '100%',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: (0, _constant.flowPlayerVideoDisplayUrl)(this.state.video_display_qq),
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportIcons2.default, {
	              moveToNotes: this.moveToNotes,
	              notesCSS: this.state.notesCSS,
	              moveToPracticeQuestions: this.moveToPracticeQuestions,
	              _saveFavVideo: this.saveFavVideo,
	              _displayReportForm: this.displayReportForm,
	              viewPdf: this.pdfOpen,
	              pdfFile: pdf_file,
	              bookmarkCSS: bookmarkCSS,
	              bookmarkColor: bookmarkColor,
	              type: type,
	              questionsCSS: questionsCSS,
	              saveVideo_text: saveVideo_text,
	              currentReading: currentReading,
	              chapters: chapters,
	              showFreePremium: showFreePremium
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: currentReading },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'frm',
	              level: videoPartLevel
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this.reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this.hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ),
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'row' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Frmvideodisplay;
	}(_react.Component);
	
	Frmvideodisplay.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = Frmvideodisplay;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Frm1BeforeStart = function (_Component) {
	  _inherits(Frm1BeforeStart, _Component);
	
	  function Frm1BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Frm1BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (Frm1BeforeStart.__proto__ || Object.getPrototypeOf(Frm1BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/frm/quiz',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenufrm
	        }
	      });
	    };
	
	    _this._startQuizpage = function () {
	      var final_exam = [];
	      var package_name_1 = _this.state.selectedmenu;
	      var package_all = _this.state.selectedmenu_1_2;
	
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context.next = 5;
	                        return _FrmSubscription4.default.checkFrm(_this.state.level, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context.sent;
	
	                        if (subscriptionStatus) {
	                          _this.setState({ subscriptionstatus: 'paid' });
	                          _this.context.router.push({
	                            pathname: '/frm/1/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              quiz_id: _this.state.quiz_id,
	                              offset: _this.state.offset_send,
	                              selectedMenu: _this.state.selectedmenufrm
	                            }
	                          });
	                        } else {
	                          _this.setState({ subscriptionstatus: 'free' });
	                          _this.toggleAlert();
	                        }
	                        _context.next = 10;
	                        break;
	
	                      case 9:
	                        console.log('fail');
	
	                      case 10:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(_this.state.level, exam_data);
	                if (subscriptionStatus) {
	                  _this.setState({ subscriptionstatus: 'paid' });
	                  _this.context.router.push({
	                    pathname: '/frm/1/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      quiz_id: _this.state.quiz_id,
	                      offset: _this.state.offset_send,
	                      selectedMenu: _this.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  _this.setState({ subscriptionstatus: 'free' });
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._startQuizquestion = function (item, offset_va, e) {
	      var final_exam = [];
	      var package_name_1 = _this.state.selectedmenu;
	      var package_all = _this.state.selectedmenu_1_2;
	
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context2.next = 5;
	                        return _FrmSubscription4.default.checkFrm(_this.state.level, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context2.sent;
	
	                        if (subscriptionStatus) {
	                          _this.setState({ subscriptionstatus: 'paid' });
	                          _this.context.router.push({
	                            pathname: '/frm/1/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              quiz_id: _this.state.quiz_id,
	                              offset: offset_va,
	                              selectedMenu: _this.state.selectedmenufrm
	                            }
	                          });
	                        } else {
	                          _this.setState({ subscriptionstatus: 'free' });
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 9:
	                        console.log('fail');
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(_this.state.level, exam_data);
	                if (subscriptionStatus) {
	                  _this.setState({ subscriptionstatus: 'paid' });
	                  _this.context.router.push({
	                    pathname: '/frm/1/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      quiz_id: _this.state.quiz_id,
	                      offset: offset_va,
	                      selectedMenu: _this.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  _this.setState({ subscriptionstatus: 'free' });
	                  _this.toggleAlert();
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    var messageTitle_frm = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_frm,
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenufrm: 'frm',
	      selectedmenu: 'frm',
	      selectedmenu_1_2: 'frm_1_2',
	      subscriptionstatus: '',
	      level: 1
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(Frm1BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Subscription plans
	      ------------------------------------------------------
	      */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Frm Create Quiz page
	      ------------------------------------------------------
	      */
	
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Frm begin Quiz page
	      ------------------------------------------------------
	      */
	
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Frm begin Quiz page
	      ------------------------------------------------------
	      */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var question_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	          }
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count
	          });
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var all_question_id = this.state.all_question_id;
	      var question_id_display = '';
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, id: 'quiz_status_border_' + index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                quiz_id: _this4.state.quiz_id,
	                answered_state: index
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  onClick: _this4._startQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send == 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            'Quiz ID: ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            ' ',
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ' ',
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().NO_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().CORRECT_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().WRONG_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOURS_ANSWER
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTIONS
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return Frm1BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	Frm1BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/checkAnswered', data).then(function (resp) {
	    if (resp.questionName === '' || resp.questionName == null) {
	      document.getElementById('questionNameId_' + props.answered_state).innerHTML = 'Frm Exam I';
	    } else {
	      document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    }
	
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer == 1) {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Correct Answer';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_wrong_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Wrong Answer';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = 'No Answer';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = Frm1BeforeStart;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Frm1Beginquiz = function (_Component) {
	  _inherits(Frm1Beginquiz, _Component);
	
	  function Frm1Beginquiz(props) {
	    _classCallCheck(this, Frm1Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (Frm1Beginquiz.__proto__ || Object.getPrototypeOf(Frm1Beginquiz)).call(this, props));
	
	    _this.isTimerFeatureEnabled = function () {
	      var _this$state = _this.state,
	          include_timer = _this$state.include_timer,
	          timer_value = _this$state.timer_value;
	
	      return !!include_timer || timer_value && parseInt(timer_value, 10) > 0;
	    };
	
	    _this.manageTimerForQuestion = function (isQuestionAnswered) {
	      if (_this.timer) clearInterval(_this.timer);
	
	      var timerShouldRun = _this.isTimerFeatureEnabled() && _this.state.count > 0 && !isQuestionAnswered;
	
	      if (timerShouldRun) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        _this.setState({ timer_stop: false, timerstopbtn: 'pause_btn icon-control-pause' });
	        localStorage.setItem('timer_stop', JSON.stringify(false));
	      } else {
	        _this.setState({ timer_stop: true, timerstopbtn: 'pause_btn icon-control-play' });
	        localStorage.setItem('timer_stop', JSON.stringify(true));
	      }
	    };
	
	    _this.fetchFlashCardsInternal = function (params) {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashCards', params).then(function (response) {
	        var flash_cards_jsx = void 0;
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          if (response.flash_cards && response.flash_cards.length > 0) {
	            _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	            flash_cards_jsx = response.flash_cards.map(function (items) {
	              return _react2.default.createElement(
	                'li',
	                { key: items.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: function onClick() {
	                            return _this._editFlash(items);
	                          } },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: function onClick() {
	                            return _this._deleteFlash(items);
	                          } },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _this.state.flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	            flash_cards_jsx = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	          }
	        } else {
	          _this.setState({ ValidToken: false, flash_form: 'col-sm-12 col-md-12 display_block' });
	          flash_cards_jsx = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	        }
	        _this.setState({ flash_data: flash_cards_jsx });
	      });
	    };
	
	    _this.getAnswer = function (choiceArray) {
	      var _this$state2 = _this.state,
	          clicked = _this$state2.clicked,
	          timer_stop = _this$state2.timer_stop;
	
	      if (clicked) return;
	      var selectedChoice = choiceArray[0];
	      _this.setState({ choice: selectedChoice });
	      if (_this.isTimerFeatureEnabled() && !timer_stop) {
	        clearInterval(_this.timer);
	        _this.setState({
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        localStorage.setItem('timer_stop', JSON.stringify(true));
	      }
	      var choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	      var updatedChoices = {};
	
	      choices.forEach(function (choice) {
	        updatedChoices[choice] = selectedChoice === choice ? 'answer_box clicked_box' : 'answer_box';
	      });
	
	      _this.setState(updatedChoices);
	    };
	
	    _this.validateAnswer = function () {
	      var _this$state3 = _this.state,
	          choice = _this$state3.choice,
	          display_question = _this$state3.display_question,
	          validated = _this$state3.validated,
	          token = _this$state3.token,
	          idname = _this$state3.idname,
	          quiz_id = _this$state3.quiz_id,
	          all_question_id = _this$state3.all_question_id,
	          offset = _this$state3.offset,
	          level = _this$state3.level,
	          clicked = _this$state3.clicked,
	          timer_stop = _this$state3.timer_stop;
	
	      if (choice && !clicked) {
	        _this.setState({ clicked: true });
	        if (_this.isTimerFeatureEnabled() && !timer_stop) {
	          clearInterval(_this.timer);
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	        }
	        var isCorrect = choice === display_question.right_choice;
	        _this.setState({
	          text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	          result: isCorrect ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	          result_block: 'card show_block'
	        });
	        if (!validated) {
	          var right_answer = isCorrect ? 1 : 0;
	          var answerQuizData = {
	            token: token,
	            idname: idname,
	            quiz_id: quiz_id,
	            question_id: all_question_id[offset],
	            answer: right_answer,
	            selectedChoice: choice
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/answerQuiz', answerQuizData).then(function (resp) {
	            if (resp.success) {
	              var saveStatsData = {
	                token: token,
	                idname: idname,
	                question_id: all_question_id[offset],
	                right_answer: right_answer,
	                time_done: _this.state.count,
	                level: level
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveStats', saveStatsData).then(function (statResp) {
	                if (statResp.success) {
	                  _this.setState({ validated: true });
	                }
	              });
	            }
	          });
	        }
	      }
	    };
	
	    _this.loadQuestionData = function (questionIndex) {
	      var _this$state4 = _this.state,
	          all_question_id = _this$state4.all_question_id,
	          quiz_id = _this$state4.quiz_id,
	          token = _this$state4.token,
	          idname = _this$state4.idname,
	          question_length = _this$state4.question_length;
	
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        clicked: false,
	        choice: '',
	        result_block: 'card hide_block',
	        report_block: 'card hide_block',
	        offset: questionIndex,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        count_end_message: ''
	      });
	      if (questionIndex === 0) _this.setState({ previ_block: 'card hide_block' });else _this.setState({ previ_block: '' });
	      if (questionIndex === question_length - 1) _this.setState({ next_block: 'card hide_block' });else _this.setState({ next_block: '' });
	      var questionIdToLoad = all_question_id[questionIndex];
	      if (!questionIdToLoad) {
	        _this.setState({
	          display_loader: 'hide_block',
	          already_answered_status: 'Error: Question not found.'
	        });
	        return;
	      }
	      var data = { token: token, idname: idname, question_id: questionIdToLoad, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var currentQuestion = resp.questionsbyid;
	          var dataCheck = { token: token, idname: idname, quiz_id: quiz_id, question_id: questionIdToLoad };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/checkAnswered', dataCheck).then(function (respInner) {
	            var selectedChoice = respInner.question_recived && respInner.question_recived.selected_choice ? respInner.question_recived.selected_choice : currentQuestion['frm_answer_quizzes.selected_choice'] || '';
	            var rightAnswer = respInner.question_recived && respInner.question_recived.answer !== undefined ? respInner.question_recived.answer : currentQuestion['frm_answer_quizzes.answer'] || '';
	            var answerStatus = respInner.question_recived && respInner.question_recived.id ? respInner.question_recived.id : currentQuestion['frm_answer_quizzes.id'] || '';
	            var correctChoice = currentQuestion.right_choice || '';
	            var showAnswer = false;
	            var selected = '';
	            if (selectedChoice) {
	              selected = selectedChoice;
	              showAnswer = true;
	            } else if (answerStatus) {
	              if (rightAnswer === 1) {
	                selected = correctChoice;
	                showAnswer = true;
	              } else if (!rightAnswer) {
	                var choices = Object.keys(currentQuestion).filter(function (key) {
	                  return key.startsWith('choice') && key !== correctChoice;
	                });
	                selected = choices.length > 0 ? choices[0] : '';
	                showAnswer = true;
	              }
	            }
	            var choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	            var updatedChoices = {};
	
	            choiceKeys.forEach(function (choiceKey) {
	              updatedChoices[choiceKey] = selected === choiceKey ? 'answer_box clicked_box' : 'answer_box';
	            });
	
	            _this.setState(Object.assign({
	              display_question: currentQuestion,
	              choice: selected,
	              clicked: !!selected,
	              validated: !!selected,
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === correctChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	              display_loader: 'hide_block'
	            }, updatedChoices));
	            _this.manageTimerForQuestion(!!selected);
	            var paramsFav = { token: token, quiz_id: quiz_id, question_id: questionIdToLoad, idname: idname };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestions', paramsFav).then(function (favResp) {
	              if (favResp.success) {
	                _this.setState({
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  save_text: '' + _language2.default.LC().Question_Saved
	                });
	              } else {
	                _this.setState({
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  bookmarkColor: '',
	                  save_text: '' + _language2.default.LC().SAVE_QUESTION
	                });
	              }
	            });
	            var paramsFlash = { token: token, idname: idname, question_id: questionIdToLoad, quiz_id: quiz_id };
	            _this.fetchFlashCardsInternal(paramsFlash);
	          });
	        } else {
	          _this.setState({
	            display_loader: 'hide_block',
	            already_answered_status: 'Failed to load question.'
	          });
	        }
	      });
	    };
	
	    _this.getNext = function () {
	      var _this$state5 = _this.state,
	          offset = _this$state5.offset,
	          question_length = _this$state5.question_length;
	
	      if (offset < question_length - 1) {
	        _this.loadQuestionData(offset + 1);
	      }
	    };
	
	    _this.getPrevious = function () {
	      var offset = _this.state.offset;
	
	      if (offset > 0) {
	        _this.loadQuestionData(offset - 1);
	      }
	    };
	
	    _this.saveQuestion = function (item, e) {
	      var _this$state6 = _this.state,
	          token = _this$state6.token,
	          idname = _this$state6.idname,
	          quiz_id = _this$state6.quiz_id,
	          level = _this$state6.level,
	          bookmarkCSS = _this$state6.bookmarkCSS;
	
	      var apiEndpoint = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark' ? '/frm_question_bank/unsaveQuestion' : '/frm_question_bank/saveQuestion';
	      var data = { token: token, idname: idname, question_id: item.id, quiz_id: quiz_id, level: level };
	      _fetchData2.default.callAPI('' + _App_data2.default.backend_api + apiEndpoint, data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            bookmarkCSS: apiEndpoint.includes('unsave') ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: apiEndpoint.includes('unsave') ? '' : 'rgb(54, 141, 84)',
	            save_text: apiEndpoint.includes('unsave') ? '' + _language2.default.LC().SAVE_QUESTION : '' + _language2.default.LC().Question_Saved
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var _this$state7 = _this.state,
	          token = _this$state7.token,
	          idname = _this$state7.idname,
	          quiz_id = _this$state7.quiz_id;
	
	      var commentInput = document.getElementById('comment');
	      var comment = commentInput ? commentInput.value : '';
	      var data = { token: token, idname: idname, question_id: item.id, comment: comment, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          if (commentInput) commentInput.value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      if (_this.refs['comment_toggle_div']) (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      if (_this.refs['flash_toggle_div']) (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      var flashCardInput = document.getElementById('flash_card');
	      if (!flashCardInput || flashCardInput.value === '') return;
	      var flash_card = flashCardInput.value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card,
	        quiz_id: _this.state.quiz_id,
	        level: _this.state.level
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          flashCardInput.value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _this.fetchFlashCardsInternal(params);
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-md-12 display_block' });
	      var flashCardInput = document.getElementById('flash_card');
	      if (flashCardInput) flashCardInput.value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = { token: _this.state.token, idname: _this.state.idname, flash_card_id: item.id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, flash_form: 'col-md-12 display_block' });
	          var flashCardInput = document.getElementById('flash_card');
	          if (flashCardInput) flashCardInput.value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: _this.state.display_question.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _this.fetchFlashCardsInternal(params);
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._timer_funct = function () {
	      var _this$state8 = _this.state,
	          timer_stop = _this$state8.timer_stop,
	          clicked = _this$state8.clicked,
	          count = _this$state8.count,
	          count_end_message = _this$state8.count_end_message,
	          choice = _this$state8.choice;
	
	      if (!_this.isTimerFeatureEnabled() || clicked || count <= 0 && !!count_end_message) return;
	      var newTimerStopState = !timer_stop;
	      localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
	      _this.setState({
	        timer_stop: newTimerStopState,
	        timerstopbtn: newTimerStopState ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	      });
	      if (newTimerStopState) {
	        clearInterval(_this.timer);
	      } else {
	        if (count > 0 && !choice && !clicked) {
	          if (_this.timer) clearInterval(_this.timer);
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        } else {
	          _this.setState({ timer_stop: true, timerstopbtn: 'pause_btn icon-control-play' });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	          if (_this.timer) clearInterval(_this.timer);
	        }
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/frm/1/beforestart/' + _this.state.quiz_id + '/' + _this.state.selectedmenufrm + '/' + 'abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon',
	          selectedMenu: _this.state.selectedmenufrm
	        }
	      });
	    };
	
	    var initialTimerStopFromStorage = localStorage.getItem('timer_stop');
	    var initialTimerStop = initialTimerStopFromStorage !== null ? JSON.parse(initialTimerStopFromStorage) : false;
	
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: [],
	      question_length: 0,
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: {},
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: initialTimerStop ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause',
	      count: 0,
	      ValidToken: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count_end_message: '',
	      timer_stop: initialTimerStop,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      already_answered_status: '',
	      selectedmenufrm: 'frm',
	      display_loader: 'show_block',
	      level: '1',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }]
	    };
	    _this.timer = null;
	    return _this;
	  }
	
	  _createClass(Frm1Beginquiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'tick',
	    value: function tick() {
	      var _state = this.state,
	          timer_stop = _state.timer_stop,
	          count = _state.count,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id,
	          count_end_message = _state.count_end_message;
	
	      if (timer_stop && this.timer) {
	        clearInterval(this.timer);
	        return;
	      }
	
	      if (count > 0) {
	        var count_value = count - 1;
	        this.setState({ count: count_value });
	
	        if (!timer_stop) {
	          var insert_time = {
	            token: token,
	            idname: idname,
	            quiz_id: quiz_id,
	            user_time_value: count_value
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/insertTimer', insert_time);
	        }
	      } else {
	        clearInterval(this.timer);
	        if (!count_end_message) {
	          this.setState({
	            count_end_message: _language2.default.LC().TIME_UP || _messages.messages.TIME_UP,
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	
	      if (parseInt(this.state.offset) === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        }, function () {
	          var data = {
	            idname: _this2.state.idname,
	            token: _this2.state.token,
	            quiz_id: _this2.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuize', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_question = JSON.stringify(resp.singlequiz);
	              var all_questions_from_api = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	              var question_id_array = [];
	              for (var i = 0; i < resp.questions_count; i++) {
	                question_id_array.push(all_questions_from_api[i]);
	              }
	
	              var api_timer_value = resp.timer_value;
	              var user_timer_remaining = resp.user_time_value;
	
	              var count_start_value = user_timer_remaining !== undefined && user_timer_remaining !== null && parseInt(user_timer_remaining, 10) > 0 ? parseInt(user_timer_remaining, 10) : api_timer_value ? parseInt(api_timer_value, 10) : 0;
	
	              _this2.setState({
	                level: resp.level,
	                user_time_value: user_timer_remaining,
	                count: count_start_value,
	                all_question_id: question_id_array,
	                question_length: question_id_array.length,
	                timer_value: api_timer_value,
	                include_timer: resp.include_timer,
	                first_question_id: question_id_array[_this2.state.offset]
	              });
	
	              if (question_id_array.length - 1 === _this2.state.offset) {
	                _this2.setState({ next_block: 'card hide_block' });
	              }
	
	              var first_question_id_for_fetch = question_id_array[_this2.state.offset];
	              if (!first_question_id_for_fetch) {
	                _this2.setState({
	                  display_loader: 'hide_block',
	                  already_answered_status: _messages.messages.QUESTION_NOT_FOUND
	                });
	                return;
	              }
	
	              var question_data_payload = {
	                token: _this2.state.token,
	                idname: _this2.state.idname,
	                question_id: first_question_id_for_fetch,
	                quiz_id: _this2.state.quiz_id
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', question_data_payload).then(function (qResp) {
	                if (!qResp.success) {
	                  _this2.setState({
	                    display_loader: 'hide_block',
	                    already_answered_status: _messages.messages.QUESTION_DETAILS_ERROR
	                  });
	                  return;
	                }
	
	                // Redirect to quiz path
	                _this2.context.router.push({
	                  pathname: '/frm/1/beginquiz/' + _this2.state.quiz_id + '/' + _this2.state.offset
	                });
	
	                var data_check = {
	                  token: _this2.state.token,
	                  idname: _this2.state.idname,
	                  quiz_id: _this2.state.quiz_id,
	                  question_id: first_question_id_for_fetch
	                };
	
	                // Check if already answered
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                  _this2.setState({ already_answered_status: resp_inner.message });
	
	                  var currentQuestion = qResp.questionsbyid;
	                  var selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
	                  var rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
	                  var answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
	                  var correctChoice = currentQuestion.right_choice || '';
	
	                  var showAnswer = false;
	                  var selected = '';
	
	                  if (selectedChoice) {
	                    selected = selectedChoice;
	                    showAnswer = true;
	                  } else if (answerStatus) {
	                    if (rightAnswer === 1) {
	                      selected = correctChoice;
	                      showAnswer = true;
	                    } else if (!rightAnswer) {
	                      var choices = Object.keys(currentQuestion).filter(function (key) {
	                        return key.startsWith('choice') && key !== correctChoice;
	                      });
	                      selected = choices.length > 0 ? choices[0] : '';
	                      showAnswer = true;
	                    }
	                  }
	
	                  // Build choices styling
	                  var choiceBoxes = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	                  var updatedChoices = {};
	                  choiceBoxes.forEach(function (choiceKey) {
	                    updatedChoices[choiceKey] = selected === choiceKey ? 'answer_box clicked_box' : 'answer_box';
	                  });
	
	                  _this2.setState(Object.assign({
	                    display_question: currentQuestion,
	                    choice: selected,
	                    clicked: !!selected,
	                    validated: !!selected,
	                    result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                    text_color: selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
	                    result: selected === correctChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                    display_loader: 'hide_block'
	                  }, updatedChoices), function () {
	                    _this2.manageTimerForQuestion(!!selected);
	                  });
	
	                  // Get bookmarked state
	                  var paramsFav = {
	                    token: _this2.state.token,
	                    quiz_id: _this2.state.quiz_id,
	                    question_id: first_question_id_for_fetch,
	                    idname: _this2.state.idname
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestions', paramsFav).then(function (response) {
	                    if (response.success) {
	                      _this2.setState({
	                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                        bookmarkColor: 'rgb(54, 141, 84)',
	                        save_text: '' + _language2.default.LC().Question_Saved
	                      });
	                    }
	                  });
	
	                  // Fetch flashcards
	                  var paramsFlash = {
	                    token: _this2.state.token,
	                    idname: _this2.state.idname,
	                    question_id: first_question_id_for_fetch,
	                    quiz_id: _this2.state.quiz_id
	                  };
	                  _this2.fetchFlashCardsInternal(paramsFlash);
	                });
	              });
	            } else {
	              _this2.setState({
	                display_loader: 'hide_block',
	                already_answered_status: _messages.messages.QUIZ_DATA_FETCH_ERROR
	              });
	            }
	          });
	        });
	      } else {
	        this.setState({
	          display_loader: 'hide_block',
	          already_answered_status: _messages.messages.USER_SESSION_NOT_FOUND
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          display_question = _state2.display_question,
	          count = _state2.count,
	          clicked = _state2.clicked,
	          choice = _state2.choice,
	          timer_stop = _state2.timer_stop,
	          timerstopbtn = _state2.timerstopbtn,
	          count_end_message = _state2.count_end_message,
	          question_length = _state2.question_length,
	          offset = _state2.offset,
	          previ_block = _state2.previ_block,
	          next_block = _state2.next_block,
	          result_block = _state2.result_block,
	          text_color = _state2.text_color,
	          result = _state2.result,
	          display_loader = _state2.display_loader,
	          already_answered_status = _state2.already_answered_status,
	          save_text = _state2.save_text,
	          bookmarkCSS = _state2.bookmarkCSS,
	          bookmarkColor = _state2.bookmarkColor,
	          flash_data = _state2.flash_data,
	          flash_form = _state2.flash_form,
	          report_block = _state2.report_block,
	          successAlert = _state2.successAlert,
	          ValidToken = _state2.ValidToken,
	          quiz_id = _state2.quiz_id,
	          selectedmenufrm = _state2.selectedmenufrm;
	
	      var questions = display_question || {};
	
	      var count_temp_var = count;
	      var display_time = '0 sec';
	      if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
	        if (count_temp_var < 60) display_time = count_temp_var + ' sec';else display_time = Math.floor(count_temp_var / 60) + ' min ' + count_temp_var % 60 + ' sec';
	      }
	
	      var isValidateDisabled = clicked || !choice;
	      var isTimerButtonDisabled = !this.isTimerFeatureEnabled() || count <= 0 && !!count_end_message || clicked;
	
	      var dataContent = '';
	      if (question_length > 0 && offset < question_length && Object.keys(questions).length > 0) {
	        dataContent = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'card font-lusitana' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              _language2.default.LC().Q,
	              ' ',
	              parseInt(offset) + 1,
	              ' ',
	              (0, _function.renderHTMLContent)(questions.name, 'span', '', { contentEditable: false }),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + previ_block,
	                  onClick: this.getPrevious,
	                  role: 'button',
	                  tabIndex: 0,
	                  onKeyPress: this.getPrevious,
	                  'aria-label': 'Previous question'
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + next_block,
	                  onClick: this.getNext,
	                  role: 'button',
	                  tabIndex: 0,
	                  onKeyPress: this.getNext,
	                  'aria-label': 'Next question'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, questions, this.props, {
	                      setAnswer: this.getAnswer,
	                      showAnswer: clicked,
	                      correctChoice: questions.right_choice,
	                      selectedChoice: choice
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 mt-2' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          clicked: isValidateDisabled,
	                          _getResult: this.validateAnswer,
	                          _saveQuestion: function _saveQuestion() {
	                            return _this3.saveQuestion(questions);
	                          },
	                          _displayReportForm: function _displayReportForm() {
	                            return _this3._displayReportForm(questions);
	                          },
	                          all_questions: questions,
	                          save_text: save_text,
	                          bookmarkCSS: bookmarkCSS,
	                          bookmarkColor: bookmarkColor,
	                          showResult: clicked || !choice
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  this.isTimerFeatureEnabled() && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'timer_outer' },
	                      _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                      !count_end_message && _react2.default.createElement(
	                        'span',
	                        { className: 'timer_box' },
	                        display_time
	                      )
	                    ),
	                    !(count <= 0 && !!count_end_message) && _react2.default.createElement(
	                      'span',
	                      { className: 'quiz_timer_btn ' + this.state.timer_display },
	                      _react2.default.createElement('button', {
	                        type: 'button',
	                        'aria-label': this.state.timer_stop ? 'Resume timer' : 'Pause timer',
	                        className: timerstopbtn,
	                        onClick: this._timer_funct,
	                        disabled: isTimerButtonDisabled
	                      })
	                    ),
	                    count_end_message && _react2.default.createElement(
	                      'p',
	                      { className: 'text-danger' },
	                      (0, _function.renderHTMLContent)(count_end_message, 'div', '', {
	                        contentEditable: 'false'
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          clicked && result_block === 'card show_block' && _react2.default.createElement(
	            'div',
	            { className: result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: text_color },
	              result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions.answer, 'div', '', { contentEditable: false })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: function onClick() {
	                        return _this3._reportQuestion(questions);
	                      }
	                    },
	                    ' ',
	                    _language2.default.LC().REPORT,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: function onClick() {
	                        return _this3._hideReportForm(questions);
	                      }
	                    },
	                    ' ',
	                    _language2.default.LC().CANCEL,
	                    ' '
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE,
	                    ' '
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else if (display_loader === 'hide_block') {
	        dataContent = _react2.default.createElement(
	          'div',
	          null,
	          already_answered_status || _messages.messages.QUIZ_FINISHED
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                'Quiz ID : ',
	                quiz_id
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                _language2.default.LC().BACK_TO_SUMMARY
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 margin_bottom_20' },
	              dataContent
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            [].concat(_toConsumableArray(Array(12))).map(function (_, i) {
	              return _react2.default.createElement('div', { key: i, className: 'sk-circle' + (i + 1) + ' sk-child' });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Frm1Beginquiz;
	}(_react.Component);
	
	Frm1Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this4 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this4.toggle = _this4.toggle.bind(_this4);
	    _this4.state = { tooltipOpen: false };
	    return _this4;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({ tooltipOpen: !this.state.tooltipOpen });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Frm1Beginquiz;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Frm1Quizzes = function (_Component) {
	  _inherits(Frm1Quizzes, _Component);
	
	  function Frm1Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Frm1Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Frm1Quizzes.__proto__ || Object.getPrototypeOf(Frm1Quizzes)).call(this, props));
	
	    _this.FRM1 = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        exam_choose: 'frm1'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapters', data).then(function (resp) {
	        if (resp.success) {
	          var chapters_1_arr = [];
	          var first_incr = 0;
	          for (var i = 0; i < resp.chapters.length; i++) {
	            if (resp.chapters[i].level == 1) {
	              chapters_1_arr[first_incr] = resp.chapters[i];
	              first_incr++;
	            }
	          }
	          _this.setState({ ValidToken: true, chapters: chapters_1_arr });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getallQuizbyPlan', data).then(function (resp) {
	        if (resp.success) {
	          var getallabondQuiz = [];
	          var completed_quiz = [];
	          var dataString = JSON.stringify(resp.getallQuiz);
	          var dataReason = JSON.parse(dataString);
	          // console.log(dataReason.length+'-----sdf-----');
	          if (!dataReason.length) {
	            _this.setState({ display_loader: 'hide_block' });
	          }
	          for (var i = 0; i < dataReason.length; i++) {
	            if (dataReason[i].count_tot == dataReason[i].number_questions) {
	              completed_quiz.push(dataReason[i]);
	            } else {
	              getallabondQuiz.push(dataReason[i]);
	            }
	            if (i == dataReason.length - 1) {
	              _this.setState({ display_loader: 'hide_block' });
	            }
	            //console.log(dataReason.length+'----------');
	          }
	          _this.setState({
	            getallabondQuiz: getallabondQuiz,
	            getallcompleteQuiz: completed_quiz
	          });
	        } else {
	          _this.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	        return resp;
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        if (resp_quiz_length.success) {
	          _this.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    };
	
	    _this.FRM2 = function () {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      _this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        exam_choose: 'frm2'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapters', data).then(function (resp) {
	        if (resp.success) {
	          var chapters_1_arr = [];
	          var first_incr = 0;
	          for (var i = 0; i < resp.chapters.length; i++) {
	            if (resp.chapters[i].level == 2) {
	              chapters_1_arr[first_incr] = resp.chapters[i];
	              first_incr++;
	            }
	          }
	          _this.setState({ ValidToken: true, chapters1: chapters_1_arr });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getallQuizbyPlan', data).then(function (resp) {
	        if (resp.success) {
	          var getallabondQuiz = [];
	          var completed_quiz = [];
	          var dataString = JSON.stringify(resp.getallQuiz);
	          var dataReason = JSON.parse(dataString);
	          if (!dataReason.length) {
	            _this.setState({ display_loader: 'hide_block' });
	          }
	          for (var i = 0; i < dataReason.length; i++) {
	            if (dataReason[i].count_tot == dataReason[i].number_questions) {
	              completed_quiz.push(dataReason[i]);
	            } else {
	              getallabondQuiz.push(dataReason[i]);
	            }
	            if (i == dataReason.length - 1) {
	              _this.setState({ display_loader: 'hide_block' });
	            }
	            //console.log(dataReason.length+'----------');
	          }
	          _this.setState({
	            getallabondQuiz1: getallabondQuiz,
	            getallcompleteQuiz1: completed_quiz
	          });
	        } else {
	          _this.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	        return resp;
	      });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getallQuiz_lengthfrm2', data).then(function (resp_quiz_length) {
	        if (resp_quiz_length.success) {
	          _this.setState({ quiz_length_state1: resp_quiz_length.quiz_length });
	        } else {
	          _this.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    };
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._all_Checked1 = function () {
	      var checkboxes = document.getElementsByName('approve1[]');
	      var all_Checked = document.getElementById('all_Checked1');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state1: true }, function all_checked_state1() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state1: false }, function all_checked_state1() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          //console.log(i+'----------'+checkboxes[i].value);
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this._single_Checked1 = function () {
	      var checkboxes = document.getElementsByName('approve1[]');
	
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          //console.log(i+'----------'+checkboxes[i].value);
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	
	      _this.setState({
	        all_checked_state1: false,
	        single_clicked_val1: single_clicked_value
	      });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context2.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context.next = 6;
	                              break;
	                            }
	
	                            _context.next = 3;
	                            return _this.FRM1();
	
	                          case 3:
	                            _context.next = 5;
	                            return _this.FRM2();
	
	                          case 5:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 6:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: '',
	      chapters1: '',
	      all_checked_state: true,
	      all_checked_state1: true,
	
	      radio_checked_question: 0,
	      radio_checked_question1: 0,
	
	      radio_checked_priority: 'none',
	      radio_checked_priority1: 'none1',
	
	      single_clicked_val: '',
	      single_clicked_val1: '',
	
	      getallabondQuiz: '',
	      getallabondQuiz1: '',
	
	      getallcompleteQuiz: '',
	      getallcompleteQuiz1: '',
	
	      quiz_length_state: '',
	      quiz_length_state1: '',
	
	      selectedmenufrm: 'frm',
	      display_loader: 'show_block',
	      level: 1,
	      level1: 2,
	
	      deleteItemId: '',
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Frm1Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      if (localStorage.getItem('selectedmenu') == 'cfa') {
	        this.context.router.push({
	          pathname: '/dashboard/',
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname']
	          }
	        });
	      }
	
	      this.FRM1();
	      this.FRM2();
	    }
	  }, {
	    key: '_createQuiz',
	    value: function _createQuiz() {
	      var _this3 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      var question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	      var timer_value,
	          chapterAll = '';
	      timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	      if (this.state.all_checked_state) {
	        var dataString = JSON.stringify(this.state.chapters);
	        var dataReason = JSON.parse(dataString);
	        var chapterall_id = [];
	        for (var i = 0; i < dataReason.length; i++) {
	          chapterall_id.push(dataReason[i].chapter_no);
	        }
	        chapterAll = chapterall_id;
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          chapterAll: chapterAll,
	          questionquize: question_length_val,
	          priority: this.state.radio_checked_priority
	        };
	        //console.log(data);
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuizequestion', data).then(function (resp) {
	          if (resp.success) {
	            var retun_all_chapter = JSON.stringify(resp.chapters);
	            var chapterParse = JSON.parse(retun_all_chapter);
	            var question_id = [];
	            var myJson = { question_count: '', all_questions: {} };
	            for (var i = 0; i < chapterParse.length; i++) {
	              var objName = 'q' + i;
	              var objValue = chapterParse[i].id;
	              myJson.all_questions[i] = objValue;
	              question_id.push(chapterParse[i].id);
	            }
	            myJson.question_count = question_id.length;
	            var questions = JSON.stringify(myJson);
	            var data = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              number_questions: myJson.question_count,
	              questions: questions,
	              timer_value: timer_value,
	              exam_choose: 'frm1',
	              level: _this3.state.level
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/createQuiz', data).then(function (resp) {
	              if (resp.success) {
	                _this3.setState({ display_loader: 'hide_block' });
	                _this3.context.router.push({
	                  pathname: '/frm/1/beforestart/' + resp.last_id + '/' + _this3.state.selectedmenufrm + '/',
	                  state: {
	                    token: _this3.state.token,
	                    idname: _this3.state.idname,
	                    quiz_id: resp.last_id,
	                    status_send: '',
	                    selectedMenu: _this3.state.selectedmenufrm
	                  }
	                });
	              } else {
	                //console.log(resp.success);
	              }
	            });
	          } else {
	            _this3.setState({ display_loader: 'hide_block' });
	            (0, _toast.showFailure)(resp.message);
	          }
	          return resp;
	        });
	      } else {
	        var checkboxes = document.getElementsByName('approve[]');
	        var i = 0;
	        var single_clicked_value = [];
	        if (this.state.single_clicked_val == '') {
	          for (i = 0; i < checkboxes.length; i++) {
	            if (checkboxes[i].checked) {
	              single_clicked_value.push(checkboxes[i].value);
	            }
	          }
	          chapterAll = single_clicked_value;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuizequestion', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value,
	                exam_choose: 'frm1',
	                level: _this3.state.level
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/createQuiz', data_insert).then(function (resp) {
	                if (resp.success) {
	                  _this3.context.router.push({
	                    pathname: '/frm/1/beforestart/' + resp.last_id + '/' + _this3.state.selectedmenufrm + '/',
	                    state: {
	                      token: _this3.state.token,
	                      idname: _this3.state.idname,
	                      quiz_id: resp.last_id,
	                      selectedMenu: _this3.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  //console.log(resp.success);
	                }
	              });
	            } else {
	              _this3.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        } else {
	          chapterAll = this.state.single_clicked_val;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuizequestion', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value,
	                exam_choose: 'frm1',
	                level: _this3.state.level
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/createQuiz', data_insert).then(function (resp) {
	                if (resp.success) {
	                  _this3.context.router.push({
	                    pathname: '/frm/1/beforestart/' + resp.last_id + '/' + _this3.state.selectedmenufrm + '/',
	                    state: {
	                      token: _this3.state.token,
	                      idname: _this3.state.idname,
	                      quiz_id: resp.last_id,
	                      selectedMenu: _this3.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  //console.log(resp.success);
	                }
	              });
	            } else {
	              _this3.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        }
	      }
	    }
	  }, {
	    key: '_createQuiz1',
	    value: function _createQuiz1() {
	      var _this4 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      var question_length_val = document.querySelector('input[name="number_questions1"]:checked').value;
	      var timer_value,
	          chapterAll = '';
	      timer_value = this.state.quiz_length_state1[this.state.radio_checked_question1].timer_value;
	      if (this.state.all_checked_state1) {
	        var dataString = JSON.stringify(this.state.chapters1);
	        var dataReason = JSON.parse(dataString);
	        var chapterall_id = [];
	        for (var i = 0; i < dataReason.length; i++) {
	          chapterall_id.push(dataReason[i].chapter_no);
	        }
	        chapterAll = chapterall_id;
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          chapterAll: chapterAll,
	          questionquize: question_length_val,
	          priority: this.state.radio_checked_priority1
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuizequestion', data).then(function (resp) {
	          if (resp.success) {
	            var retun_all_chapter = JSON.stringify(resp.chapters);
	            var chapterParse = JSON.parse(retun_all_chapter);
	            var question_id = [];
	            var myJson = { question_count: '', all_questions: {} };
	            for (var i = 0; i < chapterParse.length; i++) {
	              var objName = 'q' + i;
	              var objValue = chapterParse[i].id;
	              myJson.all_questions[i] = objValue;
	              question_id.push(chapterParse[i].id);
	            }
	            myJson.question_count = question_id.length;
	            var questions = JSON.stringify(myJson);
	            var data = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              number_questions: myJson.question_count,
	              questions: questions,
	              timer_value: timer_value,
	              exam_choose: 'frm2',
	              level: _this4.state.level1
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/createQuiz', data).then(function (resp) {
	              if (resp.success) {
	                _this4.setState({ display_loader: 'hide_block' });
	                _this4.context.router.push({
	                  pathname: '/frm/2/beforestart/' + resp.last_id + '/' + _this4.state.selectedmenufrm,
	                  state: {
	                    token: _this4.state.token,
	                    idname: _this4.state.idname,
	                    quiz_id: resp.last_id,
	                    status_send: '',
	                    selectedMenu: _this4.state.selectedmenufrm
	                  }
	                });
	              } else {
	                //console.log(resp.success);
	              }
	            });
	          } else {
	            _this4.setState({ display_loader: 'hide_block' });
	            (0, _toast.showFailure)(resp.message);
	          }
	          return resp;
	        });
	      } else {
	        var checkboxes = document.getElementsByName('approve1[]');
	        var i = 0;
	        var single_clicked_value = [];
	        if (this.state.single_clicked_val == '') {
	          for (i = 0; i < checkboxes.length; i++) {
	            if (checkboxes[i].checked) {
	              single_clicked_value.push(checkboxes[i].value);
	            }
	          }
	          chapterAll = single_clicked_value;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority1
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuizequestion', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value,
	                exam_choose: 'frm2',
	                level: _this4.state.level1
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/createQuiz', data_insert).then(function (resp) {
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: '/frm/2/beforestart/' + resp.last_id + '/' + _this4.state.selectedmenufrm,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id,
	                      selectedMenu: _this4.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  //console.log(resp.success);
	                }
	              });
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        } else {
	          chapterAll = this.state.single_clicked_val1;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority1
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuizequestion', data).then(function (resp) {
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value,
	                exam_choose: 'frm2',
	                level: _this4.state.level1
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/createQuiz', data_insert).then(function (resp) {
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: '/frm/2/beforestart/' + resp.last_id + '/' + _this4.state.selectedmenufrm,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id,
	                      selectedMenu: _this4.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  //console.log(resp.success);
	                }
	              });
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        }
	      }
	    }
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: '/frm/1/beforestart/' + items.id + '/' + this.state.selectedmenufrm + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon',
	          selectedMenu: this.state.selectedmenufrm
	        }
	      });
	    }
	  }, {
	    key: '_checkAbondon1',
	    value: function _checkAbondon1(items, e) {
	      this.context.router.push({
	        pathname: '/frm/2/beforestart/' + items.id + '/' + this.state.selectedmenufrm + '/abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon',
	          selectedMenu: this.state.selectedmenufrm
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: '/frm/1/beforestart/' + items.id + '/' + this.state.selectedmenufrm + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed',
	          selectedMenu: this.state.selectedmenufrm
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted1',
	    value: function _checkCompleted1(items, e) {
	      this.context.router.push({
	        pathname: '/frm/2/beforestart/' + items.id + '/' + this.state.selectedmenufrm + '/completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed',
	          selectedMenu: this.state.selectedmenufrm
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_length_Checked1',
	    value: function _length_Checked1(items, index_value, e) {
	      this.setState({ radio_checked_question1: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log("_priority_selected")
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: '_priority_selected1',
	    value: function _priority_selected1(e) {
	      // console.log("_priority_selected1", e.target.value)
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority1: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapters_all1 = this.state.chapters1;
	
	      var chapter_data = '';
	      var chapter_data1 = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.chapter_no,
	                onClick: _this5._single_Checked.bind(_this5)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	      if (this.state.chapters1.length) {
	        chapter_data1 = chapters_all1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve1[]',
	                value: items.chapter_no,
	                onClick: _this5._single_Checked1.bind(_this5)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkAbondon.bind(_this5, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	      var abandoned_all1 = this.state.getallabondQuiz1;
	
	      var abandoned_data1 = '';
	
	      if (this.state.getallabondQuiz1.length) {
	        abandoned_data1 = abandoned_all1.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkAbondon1.bind(_this5, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data1 = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ' : ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkCompleted.bind(_this5, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all1 = this.state.getallcompleteQuiz1;
	      var getallcompleteQuiz_data1 = '';
	      if (this.state.getallcompleteQuiz1.length) {
	        getallcompleteQuiz_data1 = getallcompleteQuiz_all1.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ' : ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkCompleted1.bind(_this5, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data1 = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question == index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      var quiz_length_state_all1 = this.state.quiz_length_state1;
	      var quiz_length_state_data1 = '';
	      if (this.state.quiz_length_state1.length) {
	        quiz_length_state_data1 = quiz_length_state_all1.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id1',
	              name: 'number_questions1',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question1 == index,
	              onClick: _this5._length_Checked1.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'frm_title_logo_wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  _language2.default.LC().QUIZZES
	                ),
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	                  className: 'garpLogo',
	                  alt: 'full logo'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row frm_quizzes_sub_heading' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h1',
	                    { className: 'section_head' },
	                    _language2.default.LC().FRM_LEVEL_I_QUIZZES
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: ' text-md-right ' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn btn-primary pointer_class',
	                      onClick: this._createQuiz.bind(this)
	                    },
	                    _language2.default.LC().CREATE_QUIZ
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-7' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().CONTENT,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions float-right' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'check_container margin_bottom_0' },
	                          ' ',
	                          _language2.default.LC().ALL_CHAPTERS,
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: 'all_Checked',
	                            name: 'all_checked',
	                            value: 'select',
	                            onClick: this._all_Checked.bind(this),
	                            checked: this.state.all_checked_state
	                          }),
	                          _react2.default.createElement('span', { className: 'checkmark' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block padding_15' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        chapter_data
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().ABANDONED_QUIZZES,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '1',
	                          id: '1',
	                          content: this.state.tooltips[1].placement,
	                          place_tip: this.state.tooltips[1].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-responsive' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table_white_bg table' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            abandoned_data
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-5' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().Priorities_By,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '6',
	                          id: '6',
	                          content: this.state.tooltips[6].placement,
	                          place_tip: this.state.tooltips[6].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'radio_container' },
	                        ' ',
	                        _language2.default.LC().NONE,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'none',
	                          name: 'none',
	                          value: 'none',
	                          checked: this.state.radio_checked_priority == 'none',
	                          onClick: this._priority_selected.bind(this)
	                        }),
	                        _react2.default.createElement('span', { className: 'checkmark' })
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'radio_container' },
	                        _language2.default.LC().UNANSWERED,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'mark_unanswered',
	                          name: 'mark_unanswered',
	                          value: 'unanswered',
	                          checked: this.state.radio_checked_priority == 'unanswered',
	                          onClick: this._priority_selected.bind(this)
	                        }),
	                        _react2.default.createElement('span', { className: 'checkmark' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '7',
	                          id: '7',
	                          content: this.state.tooltips[7].placement,
	                          place_tip: this.state.tooltips[7].text_align
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'radio_container' },
	                        ' ',
	                        _language2.default.LC().Wrong_answers,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'mark_unattempted',
	                          name: 'mark_unattempted',
	                          value: 'wrongquestion',
	                          checked: this.state.radio_checked_priority == 'wrongquestion',
	                          onClick: this._priority_selected.bind(this)
	                        }),
	                        _react2.default.createElement('span', { className: 'checkmark' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '8',
	                          id: '8',
	                          content: this.state.tooltips[8].placement,
	                          place_tip: this.state.tooltips[8].text_align
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().LENGTH,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '0',
	                          id: '0',
	                          content: this.state.tooltips[0].placement,
	                          place_tip: this.state.tooltips[0].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      quiz_length_state_data
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().COMPLETED_QUIZZES,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '2',
	                          id: '2',
	                          content: this.state.tooltips[2].placement,
	                          place_tip: this.state.tooltips[2].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table_responsive_wrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-responsive' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table_white_bg table' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            getallcompleteQuiz_data
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row frm_quizzes_sub_heading', id: 'frm_2', name: 'frm_2' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  ' ',
	                  _language2.default.LC().FRM_LEVEL_II_QUIZZES,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-md-right' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn btn-primary pointer_class',
	                      onClick: this._createQuiz1.bind(this)
	                    },
	                    ' ',
	                    _language2.default.LC().CREATE_QUIZ,
	                    ' '
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-7' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().CONTENT,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions float-right' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'check_container margin_bottom_0' },
	                          _language2.default.LC().ALL_CHAPTERS,
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: 'all_Checked1',
	                            name: 'all_Checked1',
	                            value: 'select',
	                            onClick: this._all_Checked1.bind(this),
	                            checked: this.state.all_checked_state1
	                          }),
	                          _react2.default.createElement('span', { className: 'checkmark' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block padding_15' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        chapter_data1
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().ABANDONED_QUIZZES,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '4',
	                          id: '4',
	                          content: this.state.tooltips[4].placement,
	                          place_tip: this.state.tooltips[4].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-responsive' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table_white_bg table' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            abandoned_data1
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-5' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().Priorities_By,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '9',
	                          id: '9',
	                          content: this.state.tooltips[9].placement,
	                          place_tip: this.state.tooltips[9].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'radio_container' },
	                        ' ',
	                        _language2.default.LC().NONE,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'none1',
	                          name: 'none1',
	                          value: 'none1',
	                          checked: this.state.radio_checked_priority1 == 'none1',
	                          onClick: this._priority_selected1.bind(this)
	                        }),
	                        _react2.default.createElement('span', { className: 'checkmark' })
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'radio_container' },
	                        _language2.default.LC().UNANSWERED,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'mark_unanswered',
	                          name: 'mark_unanswered',
	                          value: 'unanswered',
	                          checked: this.state.radio_checked_priority1 == 'unanswered',
	                          onClick: this._priority_selected1.bind(this)
	                        }),
	                        _react2.default.createElement('span', { className: 'checkmark' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '10',
	                          id: '10',
	                          content: this.state.tooltips[10].placement,
	                          place_tip: this.state.tooltips[10].text_align
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'radio_container' },
	                        ' ',
	                        _language2.default.LC().Wrong_answers,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'mark_unattempted',
	                          name: 'mark_unattempted',
	                          value: 'wrongquestion',
	                          checked: this.state.radio_checked_priority1 == 'wrongquestion',
	                          onClick: this._priority_selected1.bind(this)
	                        }),
	                        _react2.default.createElement('span', { className: 'checkmark' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '11',
	                          id: '11',
	                          content: this.state.tooltips[11].placement,
	                          place_tip: this.state.tooltips[11].text_align
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().LENGTH,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '3',
	                          id: '3',
	                          content: this.state.tooltips[3].placement,
	                          place_tip: this.state.tooltips[3].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      quiz_length_state_data1
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-header' },
	                      _language2.default.LC().COMPLETED_QUIZZES,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-actions card_action_tooltip float-right' },
	                        _react2.default.createElement(TooltipItem, {
	                          key: '5',
	                          id: '5',
	                          content: this.state.tooltips[5].placement,
	                          place_tip: this.state.tooltips[5].text_align
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table_responsive_wrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-responsive' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table_white_bg table' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            getallcompleteQuiz_data1
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Frm1Quizzes;
	}(_react.Component);
	
	Frm1Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    // console.log("TooltipItem",props);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	exports.default = Frm1Quizzes;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Frm2BeforeStart = function (_Component) {
	  _inherits(Frm2BeforeStart, _Component);
	
	  function Frm2BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Frm2BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (Frm2BeforeStart.__proto__ || Object.getPrototypeOf(Frm2BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/frm/quiz',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenufrm
	        }
	      });
	    };
	
	    _this._startQuizpage = function () {
	      var final_exam = [];
	      var package_name_1 = _this.state.selectedmenu;
	      var package_all = _this.state.selectedmenu_1_2;
	
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context.next = 5;
	                        return _FrmSubscription4.default.checkFrm(_this.state.level, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context.sent;
	
	                        if (subscriptionStatus) {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().PAID
	                          });
	                          _this.context.router.push({
	                            pathname: '/frm/2/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send + '/' + _this.state.selectedmenufrm,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              quiz_id: _this.state.quiz_id,
	                              offset: _this.state.offset_send,
	                              selectedMenu: _this.state.selectedmenufrm
	                            }
	                          });
	                        } else {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().FREE
	                          });
	                          _this.toggleAlert();
	                        }
	                        _context.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            ////console.log("fail");
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(_this.state.level, exam_data);
	                if (subscriptionStatus) {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().PAID
	                  });
	                  _this.context.router.push({
	                    pathname: '/frm/2/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send + '/' + _this.state.selectedmenufrm,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      quiz_id: _this.state.quiz_id,
	                      offset: _this.state.offset_send,
	                      selectedMenu: _this.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().FREE
	                  });
	                  _this.toggleAlert();
	                }
	              } else {
	                ////console.log("fail");
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._startQuizquestion = function (item, offset_va, e) {
	      var final_exam = [];
	      var package_name_1 = _this.state.selectedmenu;
	      var package_all = _this.state.selectedmenu_1_2;
	
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        // #261 — pass examPlanData so the partner check's mock-package
	                        // early-return fires (was missing — partner with mock-only plan
	                        // could begin Part 2 quiz which they shouldn't access).
	
	                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                        _context2.next = 5;
	                        return _FrmSubscription4.default.checkFrm(_this.state.level, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context2.sent;
	
	                        if (subscriptionStatus) {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().PAID
	                          });
	                          _this.context.router.push({
	                            pathname: '/frm/2/beginquiz/' + _this.state.quiz_id + '/' + offset_va + '/' + _this.state.selectedmenufrm,
	                            state: {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              quiz_id: _this.state.quiz_id,
	                              offset: offset_va,
	                              selectedMenu: _this.state.selectedmenufrm
	                            }
	                          });
	                        } else {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().FREE
	                          });
	                          _this.toggleAlert();
	                        }
	                        _context2.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            ////console.log("fail");
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(_this.state.level, exam_data);
	                if (subscriptionStatus) {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().PAID
	                  });
	                  _this.context.router.push({
	                    pathname: '/frm/2/beginquiz/' + _this.state.quiz_id + '/' + offset_va + '/' + _this.state.selectedmenufrm,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      quiz_id: _this.state.quiz_id,
	                      offset: offset_va,
	                      selectedMenu: _this.state.selectedmenufrm
	                    }
	                  });
	                } else {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().FREE
	                  });
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log("fail");
	              }
	            });
	          }
	        }
	      });
	    };
	
	    var messageTitle_frm = '<i class="icon-info icons font-2xl d-block "></i>';
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_frm,
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenufrm: 'frm',
	      selectedmenu: 'frm_2',
	      selectedmenu_1_2: 'frm_1_2',
	      subscriptionstatus: '',
	      level: 2
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(Frm2BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Subscription plans
	      ------------------------------------------------------
	      */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Frm Create Quiz page
	      ------------------------------------------------------
	      */
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Frm begin Quiz page
	      ------------------------------------------------------
	      */
	
	    /*
	      -------------------------------------------------------
	        Function to redirect page to Frm begin Quiz page
	      ------------------------------------------------------
	      */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var question_id = [];
	          ////console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	          }
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count
	          });
	        } else {
	          //console.log(resp.success + "------------failure");
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          //console.log(resp_count.success + "------------failure");
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var all_question_id = this.state.all_question_id;
	      var question_id_display = '';
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                quiz_id: _this4.state.quiz_id,
	                answered_state: index
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  onClick: _this4._startQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	
	      var status_data = '';
	      if (this.state.status_send == 'abondon') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().TOTAL_TIME,
	                  ' :'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        var user_time = '';
	        var min,
	            sec = '';
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ' : ',
	              this.state.quiz_id
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                id: 'frm_2',
	                onClick: this._createQuizpage.bind(this)
	              },
	              ' ',
	              _language2.default.LC().CREATE_NEW_QUIZ,
	              ' '
	            )
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ' ',
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().EXAMPLE,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().NO_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().CORRECT_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            ' ',
	                            _language2.default.LC().WRONG_ANSWER,
	                            ' '
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOURS_ANSWER
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          ' ',
	                          _language2.default.LC().YOURS_ANSWER,
	                          ' '
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          ' ',
	                          _language2.default.LC().ACTIONS,
	                          ' '
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return Frm2BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	Frm2BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/checkAnswered', data).then(function (resp) {
	    if (resp.questionName === '' || resp.questionName == null) {
	      document.getElementById('questionNameId_' + props.answered_state).innerHTML = 'Frm Exam I';
	    } else {
	      document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    }
	    if (resp.success) {
	      // //console.log(resp.question_recived);
	      if (resp.question_recived.answer == 1) {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Correct Answer';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_wrong_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Wrong Answer';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = 'No Answer';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = Frm2BeforeStart;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Frm2Beginquiz = function (_Component) {
	  _inherits(Frm2Beginquiz, _Component);
	
	  function Frm2Beginquiz(props) {
	    var _this$state8;
	
	    _classCallCheck(this, Frm2Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (Frm2Beginquiz.__proto__ || Object.getPrototypeOf(Frm2Beginquiz)).call(this, props));
	
	    _this.getAnswer = function (choice, e) {
	      var clicked = _this.state.clicked;
	
	      _this.setState({ choice: choice[0] });
	      _this.setState({ clicked: false });
	    };
	
	    _this.validateAnswer = function () {
	      var _this$state = _this.state,
	          choice = _this$state.choice,
	          display_question = _this$state.display_question,
	          validated = _this$state.validated,
	          token = _this$state.token,
	          idname = _this$state.idname,
	          quiz_id = _this$state.quiz_id,
	          all_question_id = _this$state.all_question_id,
	          offset = _this$state.offset,
	          level = _this$state.level;
	
	      if (choice) {
	        _this.setState({ clicked: true });
	        var isCorrect = choice === display_question.right_choice;
	        _this.setState({
	          text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	          result: isCorrect ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	          result_block: 'card show_block'
	        });
	        _this.setState({ timer_stop: true });
	        clearInterval(_this.timer);
	        if (!validated) {
	          var right_answer = isCorrect ? 1 : 0;
	          var answerQuizData = {
	            token: token,
	            idname: idname,
	            quiz_id: quiz_id,
	            question_id: all_question_id[offset],
	            answer: right_answer,
	            selectedChoice: choice
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/answerQuiz', answerQuizData).then(function (resp) {
	            if (resp.success) {
	              var saveStatsData = {
	                token: token,
	                idname: idname,
	                question_id: all_question_id[offset],
	                right_answer: right_answer,
	                time_done: _this.state.count,
	                level: level
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveStats', saveStatsData).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ validated: true });
	                }
	              });
	            }
	          });
	        }
	      }
	    };
	
	    _this.getNext = function () {
	      var _this$state2 = _this.state,
	          offset = _this$state2.offset,
	          all_question_id = _this$state2.all_question_id,
	          quiz_id = _this$state2.quiz_id,
	          question_length = _this$state2.question_length,
	          token = _this$state2.token,
	          idname = _this$state2.idname;
	
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        clicked: false,
	        choice: '',
	        result_block: 'card hide_block',
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION
	      });
	      var nextIndex = offset + 1;
	      _this.setState({ offset: nextIndex });
	      if (nextIndex === question_length - 1) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      if (nextIndex !== 0) {
	        _this.setState({ previ_block: '' });
	      }
	      var data = { token: token, idname: idname, question_id: all_question_id[nextIndex], quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var currentQuestion = resp.questionsbyid;
	          var selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
	          var rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
	          var answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
	          var correctChoice = currentQuestion.right_choice || '';
	          var showAnswer = false;
	          var selected = '';
	          if (selectedChoice) {
	            selected = selectedChoice;
	            showAnswer = true;
	          } else if (answerStatus) {
	            if (rightAnswer === 1) {
	              selected = correctChoice;
	              showAnswer = true;
	            } else if (!rightAnswer) {
	              var choices = Object.keys(currentQuestion).filter(function (key) {
	                return key.startsWith('choice') && key !== correctChoice;
	              });
	              selected = choices.length > 0 ? choices[0] : '';
	              showAnswer = true;
	            }
	          }
	          var choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	          var updatedChoices = {};
	
	          choiceKeys.forEach(function (choice) {
	            updatedChoices[choice] = selected === choice ? 'answer_box clicked_box' : 'answer_box';
	          });
	
	          _this.setState(Object.assign({
	            display_question: currentQuestion,
	            choice: selected,
	            clicked: !!selected,
	            result_block: showAnswer ? 'card show_block' : 'card hide_block',
	            text_color: selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
	            result: selected === correctChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	            display_loader: 'hide_block',
	            timer_stop: !!selected
	          }, updatedChoices));
	          clearInterval(_this.timer);
	          if (!selected) {
	            _this.timer = setInterval(_this.tick.bind(_this), 1000);
	          }
	          _this.checkBookmarkState(all_question_id[nextIndex]);
	        }
	      });
	    };
	
	    _this.getPrevious = function () {
	      var _this$state3 = _this.state,
	          offset = _this$state3.offset,
	          all_question_id = _this$state3.all_question_id,
	          question_length = _this$state3.question_length,
	          token = _this$state3.token,
	          idname = _this$state3.idname,
	          quiz_id = _this$state3.quiz_id;
	
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        clicked: false,
	        choice: '',
	        result_block: 'card hide_block',
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION
	      });
	      var prevIndex = offset - 1;
	      _this.setState({ offset: prevIndex });
	      if (prevIndex < question_length - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (prevIndex === 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      } else {
	        _this.setState({ previ_block: '' });
	      }
	      var data = { token: token, idname: idname, question_id: all_question_id[prevIndex], quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var currentQuestion = resp.questionsbyid;
	          var selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
	          var rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
	          var answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
	          var correctChoice = currentQuestion.right_choice || '';
	          var showAnswer = false;
	          var selected = '';
	          if (selectedChoice) {
	            selected = selectedChoice;
	            showAnswer = true;
	          } else if (answerStatus) {
	            if (rightAnswer === 1) {
	              selected = correctChoice;
	              showAnswer = true;
	            } else if (!rightAnswer) {
	              var choices = Object.keys(currentQuestion).filter(function (key) {
	                return key.startsWith('choice') && key !== correctChoice;
	              });
	              selected = choices.length > 0 ? choices[0] : '';
	              showAnswer = true;
	            }
	          }
	          var choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	          var updatedChoices = {};
	
	          choiceKeys.forEach(function (key) {
	            updatedChoices[key] = selected === key ? 'answer_box clicked_box' : 'answer_box';
	          });
	
	          _this.setState(Object.assign({
	            display_question: currentQuestion,
	            choice: selected,
	            clicked: !!selected,
	            result_block: showAnswer ? 'card show_block' : 'card hide_block',
	            text_color: selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
	            result: selected === correctChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	            display_loader: 'hide_block',
	            timer_stop: !!selected
	          }, updatedChoices));
	          clearInterval(_this.timer);
	          if (!selected) {
	            _this.timer = setInterval(_this.tick.bind(_this), 1000);
	          }
	          _this.checkBookmarkState(all_question_id[prevIndex]);
	        }
	      });
	    };
	
	    _this.saveQuestion = function (item, e) {
	      var _this$state4 = _this.state,
	          bookmarkCSS = _this$state4.bookmarkCSS,
	          token = _this$state4.token,
	          idname = _this$state4.idname,
	          quiz_id = _this$state4.quiz_id,
	          level = _this$state4.level;
	
	      var isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
	      var apiEndpoint = isSaved ? '/frm_question_bank/unsaveQuestion' : '/frm_question_bank/saveQuestion';
	      var data = { token: token, idname: idname, question_id: item.id, quiz_id: quiz_id, level: level };
	      _fetchData2.default.callAPI('' + _App_data2.default.backend_api + apiEndpoint, data).then(function (resp) {
	        if (resp.success) {
	          _this.checkBookmarkState(item.id);
	        }
	      });
	    };
	
	    _this._reportQuestion = function () {
	      var _this$state5 = _this.state,
	          token = _this$state5.token,
	          idname = _this$state5.idname,
	          quiz_id = _this$state5.quiz_id,
	          display_question = _this$state5.display_question;
	
	      var commentInput = document.getElementById('comment');
	      var comment = commentInput ? commentInput.value : '';
	      if (!comment || comment.trim().length < 2) {
	        return;
	      }
	      var data = { token: token, idname: idname, question_id: display_question.id, comment: comment, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ successAlert: true, report_block: 'card show_block' });
	          if (commentInput) commentInput.value = '';
	        } else {
	          _this.setState({ successAlert: false });
	        }
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._displayReportForm = function () {
	      _this.setState({ report_block: 'card show_block', successAlert: false });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card,
	        quiz_id: _this.state.quiz_id,
	        level: _this.state.level
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-md-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({ flash_form: 'col-md-12 display_block' });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.timerHandler = function () {
	      var _this$state6 = _this.state,
	          timer_stop = _this$state6.timer_stop,
	          clicked = _this$state6.clicked,
	          choice = _this$state6.choice;
	
	      if (clicked || choice) {
	        return;
	      }
	      var newTimerStopState = !timer_stop;
	      _this.setState({
	        timer_stop: newTimerStopState,
	        timerstopbtn: newTimerStopState ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	      });
	      localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
	      if (newTimerStopState) {
	        clearInterval(_this.timer);
	      } else {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/frm/2/beforestart/' + _this.state.quiz_id + '/' + _this.state.selectedmenufrm + '/abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon',
	          selectedMenu: _this.state.selectedmenufrm
	        }
	      });
	    };
	
	    _this.checkBookmarkState = function (question_id) {
	      var _this$state7 = _this.state,
	          token = _this$state7.token,
	          quiz_id = _this$state7.quiz_id,
	          idname = _this$state7.idname;
	
	      var paramsFav = { token: token, quiz_id: quiz_id, question_id: question_id, idname: idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestions', paramsFav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        } else {
	          _this.setState({
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            bookmarkColor: '',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION
	          });
	        }
	      });
	    };
	
	    _this.state = (_this$state8 = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      count: 0,
	      ValidToken: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding'
	    }, _defineProperty(_this$state8, 'count', 0), _defineProperty(_this$state8, 'count_end_message', ''), _defineProperty(_this$state8, 'timer_stop', false), _defineProperty(_this$state8, 'timer_tag', '' + _language2.default.LC().STOP), _defineProperty(_this$state8, 'timer_display', 'card-block'), _defineProperty(_this$state8, 'rating', 0), _defineProperty(_this$state8, 'rated', false), _defineProperty(_this$state8, 'ratting_text', '' + _language2.default.LC().RATE_THIS_QUESTION), _defineProperty(_this$state8, 'validated', false), _defineProperty(_this$state8, 'comment_update', 'hide_block'), _defineProperty(_this$state8, 'comment_save', 'btn btn-primary active pointer_class'), _defineProperty(_this$state8, 'comment_update_id', ''), _defineProperty(_this$state8, 'next_block', ''), _defineProperty(_this$state8, 'previ_block', ''), _defineProperty(_this$state8, 'already_answered_status', ''), _defineProperty(_this$state8, 'selectedmenufrm', 'frm'), _defineProperty(_this$state8, 'display_loader', 'show_block'), _defineProperty(_this$state8, 'level', '2'), _defineProperty(_this$state8, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _this$state8);
	    return _this;
	  }
	
	  _createClass(Frm2Beginquiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'tick',
	    value: function tick() {
	      var _state = this.state,
	          count = _state.count,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id;
	
	      if (count > 0) {
	        var newCount = count - 1;
	        var insertTime = { token: token, idname: idname, quiz_id: quiz_id, user_time_value: newCount };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/insertTimer', insertTime).then(function () {});
	        this.setState({ count: newCount });
	      } else {
	        clearInterval(this.timer);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      var timerStopState = localStorage.getItem('timer_stop');
	      if (timerStopState !== null) {
	        this.setState({ timer_stop: JSON.parse(timerStopState) });
	        if (JSON.parse(timerStopState)) {
	          this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        } else {
	          this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	          this.timer = setInterval(this.tick.bind(this), 1000);
	        }
	      }
	      if (parseInt(this.state.offset) === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_quizes/getQuize', data).then(function (resp) {
	        if (resp.success && resp.singlequiz) {
	          var all_questions = JSON.parse(JSON.parse(JSON.stringify(resp.singlequiz))).all_questions;
	          var question_id = all_questions[_this2.state.offset];
	          var question_length = all_questions.length;
	
	          var timer_value = resp.timer_value || 1800;
	          var user_time_value = resp.user_time_value || timer_value;
	
	          _this2.setState({
	            timer_value: timer_value,
	            count: user_time_value,
	            all_question_id: all_questions,
	            question_length: question_length,
	            first_question_id: question_id
	          });
	
	          if (_this2.state.offset === question_length - 1) {
	            _this2.setState({ next_block: 'card hide_block' });
	          }
	
	          var questionData = {
	            token: _this2.state.token,
	            idname: _this2.state.idname,
	            question_id: question_id,
	            quiz_id: _this2.state.quiz_id
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', questionData).then(function (resp) {
	            if (resp.success && resp.questionsbyid) {
	              var currentQuestion = resp.questionsbyid;
	              var selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
	              var rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
	              var answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
	              var correctChoice = currentQuestion.right_choice || '';
	              var showAnswer = false;
	              var selected = '';
	
	              if (selectedChoice) {
	                selected = selectedChoice;
	                showAnswer = true;
	              } else if (answerStatus) {
	                if (rightAnswer === 1) {
	                  selected = correctChoice;
	                  showAnswer = true;
	                } else if (!rightAnswer) {
	                  var choices = Object.keys(currentQuestion).filter(function (key) {
	                    return key.startsWith('choice') && key !== correctChoice;
	                  });
	                  selected = choices.length > 0 ? choices[0] : '';
	                  showAnswer = true;
	                }
	              }
	
	              var choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	              var updatedChoices = {};
	
	              choiceKeys.forEach(function (key) {
	                updatedChoices[key] = selected === key ? 'answer_box clicked_box' : 'answer_box';
	              });
	
	              _this2.setState(Object.assign({
	                display_question: currentQuestion,
	                choice: selected,
	                clicked: !!selected,
	                result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                text_color: selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
	                result: selected === correctChoice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                display_loader: 'hide_block',
	                timer_stop: !!selected
	              }, updatedChoices));
	
	              clearInterval(_this2.timer);
	              if (!selected) {
	                _this2.timer = setInterval(_this2.tick.bind(_this2), 1000);
	              }
	
	              // Always check bookmark state for the current question
	              _this2.checkBookmarkState(question_id);
	            } else {
	              _this2.setState({ display_question: null });
	            }
	          });
	        } else {
	          _this2.setState({ display_question: null });
	        }
	      });
	
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    // Helper to check and set bookmark state for the current question
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var questions = this.state.display_question;
	      var _state2 = this.state,
	          clicked = _state2.clicked,
	          choice = _state2.choice;
	
	
	      var data = '';
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      if (questions) {
	        data = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              _language2.default.LC().Q,
	              parseInt(this.state.offset) + 1,
	              ' ',
	              (0, _function.renderHTMLContent)(questions.name, 'span', '', { contentEditable: false }),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + (this.state.offset === 0 ? 'card hide_block' : ''),
	                  onClick: this.getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + (this.state.offset === this.state.question_length - 1 ? 'card hide_block' : ''),
	                  onClick: this.getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, questions, this.props, {
	                      setAnswer: this.getAnswer,
	                      showAnswer: clicked,
	                      correctChoice: questions.right_choice,
	                      selectedChoice: choice
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12 mt-2' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row align-items-center' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary pointer_class margin_bottom_10 margin_right_10',
	                            onClick: this.validateAnswer,
	                            disabled: this.state.clicked || !this.state.choice
	                          },
	                          _language2.default.LC().VALIDATE
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'up tooltip-hover-questions', style: { padding: '10px' } },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tootip_box' },
	                            ' ',
	                            this.state.save_text,
	                            ' '
	                          ),
	                          _react2.default.createElement(
	                            'i',
	                            {
	                              onClick: this.saveQuestion.bind(this, questions),
	                              className: this.state.bookmarkCSS,
	                              style: { color: this.state.bookmarkColor }
	                            },
	                            ' '
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'up tooltip-hover-questions vertical-align-middle' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tootip_box' },
	                            ' ',
	                            _language2.default.LC().REPORT_THIS_QUESTION,
	                            ' '
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            {
	                              className: 'report-icon-wrapper',
	                              onClick: this._displayReportForm.bind(this, questions)
	                            },
	                            _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/report4.png', alt: 'report' })
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'quiz_timer_btn ' + this.state.timer_display },
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timer_stop ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause',
	                      onClick: this.timerHandler
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-danger' },
	                    (0, _function.renderHTMLContent)(this.state.count_end_message, 'div', '', {
	                      contentEditable: false
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions.answer, 'div', '', { contentEditable: false })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: this._reportQuestion.bind(this, questions)
	                    },
	                    _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, questions)
	                    },
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUIZ_ID,
	                ' : ',
	                this.state.quiz_id
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'text-danger' },
	                this.state.already_answered_status
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                _language2.default.LC().BACK_TO_SUMMARY
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 margin_bottom_20' },
	              data
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Frm2Beginquiz;
	}(_react.Component);
	
	Frm2Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this3 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this3.toggle = _this3.toggle.bind(_this3);
	    _this3.state = {
	      tooltipOpen: false
	    };
	    return _this3;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Frm2Beginquiz;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(102);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _fileSaver = __webpack_require__(151);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _function = __webpack_require__(10);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var FrmNotes = function (_Component) {
	  _inherits(FrmNotes, _Component);
	
	  function FrmNotes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FrmNotes);
	
	    var _this = _possibleConstructorReturn(this, (FrmNotes.__proto__ || Object.getPrototypeOf(FrmNotes)).call(this, props));
	
	    _this._getReadings = function (chapter, e) {
	      'chapter', chapter;
	
	      if (chapter.chapter_no === 1 || chapter.chapter_no === 5) {
	        _this.context.router.push({
	          pathname: '/frm/notesreadings/' + chapter.chapter_no,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter: chapter.chapter_no
	          }
	        });
	      } else {
	        var data = { token: _this.state.token, idname: _this.state.idname };
	        // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	        _userStore2.default.getUserProfile(true).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	              var dataset = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                  var exam_data, examPlanData, subscriptionStatus;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context.next = 9;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          examPlanData = resp_exam.examPlan[0];
	                          _context.next = 5;
	                          return _FrmSubscription4.default.checkFrmNotesSubscription(chapter.level, exam_data, examPlanData);
	
	                        case 5:
	                          subscriptionStatus = _context.sent;
	
	                          if (subscriptionStatus) {
	                            _this.context.router.push({
	                              pathname: '/frm/notesreadings/' + chapter.chapter_no,
	                              state: {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                chapter: chapter.chapter_no
	                              }
	                            });
	                          } else {
	                            _this.toggleAlert();
	                          }
	                          _context.next = 9;
	                          break;
	
	                        case 9:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref.apply(this, arguments);
	                };
	              }()
	              //console.log('fail');
	              );
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '') {
	              _this.toggleAlert();
	            } else {
	              var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	              var dataset = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var subscriptionStatus = _FrmSubscription2.default.checkFrmNotesSubscription(chapter.level, exam_data);
	                  if (subscriptionStatus) {
	                    _this.context.router.push({
	                      pathname: '/frm/notesreadings/' + chapter.chapter_no,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter: chapter.chapter_no
	                      }
	                    });
	                  } else {
	                    _this.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    };
	
	    _this.goToNotesLevel1 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, lastRecordLevel1, lastAttemptLevel1;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, lastRecordLevel1 = _this$state.lastRecordLevel1, lastAttemptLevel1 = _this$state.lastAttemptLevel1;
	
	              if (lastAttemptLevel1) {
	                _this.context.router.push({
	                  pathname: '/frm/beginnotes/' + lastRecordLevel1.frm_note.chapter_id + '/' + lastRecordLevel1.frm_note.reading_id + '/' + lastRecordLevel1.contentID + '/' + 0 + lastRecordLevel1.frmLevel,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecordLevel1.frm_note.chapter_id,
	                    reading: {
	                      level: lastRecordLevel1.frmLevel,
	                      chapter_no: lastRecordLevel1.frm_note.chapter_id,
	                      id: lastRecordLevel1.frm_note.reading_id
	                    },
	                    offset: 0
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.goToNotesLevel2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state2, lastRecordLevel2, lastAttemptLevel2;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state2 = _this.state, lastRecordLevel2 = _this$state2.lastRecordLevel2, lastAttemptLevel2 = _this$state2.lastAttemptLevel2;
	
	              if (lastAttemptLevel2) {
	                _this.context.router.push({
	                  pathname: '/frm/beginnotes/' + lastRecordLevel2.frm_note.chapter_id + '/' + lastRecordLevel2.frm_note.reading_id + '/' + lastRecordLevel2.contentID + '/' + 0 + '/' + lastRecordLevel2.frmLevel,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecordLevel2.frm_note.chapter_id,
	                    reading: {
	                      level: lastRecordLevel2.frmLevel,
	                      chapter_no: lastRecordLevel2.frm_note.chapter_id,
	                      id: lastRecordLevel2.frm_note.reading_id
	                    },
	                    offset: 0
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.getAdditionalResources = function (level) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        type: 'Formula sheet',
	        exam: level === 1 ? 'frm_1' : 'frm_2'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/cfa_2_2025question_bank/getAdditionalResources', data).then(function (resp) {
	        console.log('resp--------------------', resp);
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          (0, _function.openPDF)(resp);
	          // var myWindow = window.open(resp.data.pdf);
	          // myWindow.focus();
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.checkSubscription = function (level) {
	      var data = { token: _this.state.token, idname: _this.state.idname };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                  while (1) {
	                    switch (_context4.prev = _context4.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context4.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context4.next = 5;
	                        return _FrmSubscription4.default.checkFormulaSheetSubscription(level, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context4.sent;
	
	                        if (subscriptionStatus) {
	                          _this.getAdditionalResources(1);
	                          // const getIndex = resp_exam.examdetails.filter(
	                          //   (item) => item.exam_name === 'frm'
	                          // )[0];
	                          // if (getIndex) {
	                          //   if (getIndex.formulaSheet) {
	                          //     var myWindow = window.open(getIndex.formulaSheet);
	                          //   }
	                          //   myWindow.focus();
	                          // }
	                        } else {
	                          _this.toggleAlert();
	                        }
	                        _context4.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context4.stop();
	                    }
	                  }
	                }, _callee4, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref4.apply(this, arguments);
	              };
	            }()
	            //console.log('fail');
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              //console.log('resp_exam', resp_exam);
	
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFormulaSheetSubscription(level, exam_data);
	                if (subscriptionStatus) {
	                  //console.log('resp_exam.examdetails', resp_exam);
	                  var getIndex = void 0;
	                  if (level === 1) {
	                    // getIndex = resp_exam.allexamData.filter(
	                    //   (item) => item.exam_name === 'frm'
	                    // )[0];
	                    _this.getAdditionalResources(1);
	                  } else {
	                    // getIndex = resp_exam.allexamData.filter(
	                    //   (item) => item.exam_name === 'frm_2'
	                    // )[0];
	
	                    _this.getAdditionalResources(2);
	                  }
	                  //console.log('getIndex', getIndex);
	                  // if (getIndex) {
	                  //   if (getIndex.formulaSheet) {
	                  //     var myWindow = window.open(getIndex.formulaSheet);
	                  //   }
	                  //   myWindow.focus();
	                  // }
	                } else {
	                  _this.toggleAlert();
	                }
	              } else {
	                //console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    var messageTitle_frm = '<i class="icon-info icons font-2xl d-block "></i>';
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_frm,
	      MessageContent: _alertMessage2.default.messageContent_frm,
	      chapters: [],
	      chapters_1: [],
	      chapters_2: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      showFreePremium1: '',
	      showFreePremium2: '',
	      selectedmenu: 'frm',
	      pdfLoading1: true,
	      pdfLoading2: true,
	      lastRecordLevel1: '',
	      lastAttemptLevel1: false,
	      lastRecordLevel2: '',
	      lastAttemptLevel2: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(FrmNotes, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                if (localStorage.getItem('selectedmenu') === 'cfa') {
	                  this.context.router.push({
	                    pathname: '/dashboard/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context8.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapters', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                    var chapters_1_arr, chapters_2_arr, first_incr, second_incr, i;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context5.next = 14;
	                              break;
	                            }
	
	                            _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                            chapters_1_arr = [];
	                            chapters_2_arr = [];
	                            first_incr = 0;
	                            second_incr = 0;
	
	                            for (i = 0; i < resp.chapters.length; i++) {
	                              if (resp.chapters[i].level === 1) {
	                                chapters_1_arr[first_incr] = resp.chapters[i];
	                                first_incr++;
	                              }
	                              if (resp.chapters[i].level === 2) {
	                                chapters_2_arr[second_incr] = resp.chapters[i];
	                                second_incr++;
	                              }
	                            }
	                            _this3.setState({
	                              chapters_1: chapters_1_arr,
	                              chapters_2: chapters_2_arr
	                            });
	                            _context5.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getlastReadNotesLevel1', data).then(function (response) {
	                              if (response.success) {
	                                _this3.setState({
	                                  lastRecordLevel1: response.dataLevel1,
	                                  lastAttemptLevel1: true
	                                });
	                              }
	                            });
	
	                          case 10:
	                            _context5.next = 12;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getlastReadNotesLevel2', data).then(function (response) {
	                              if (response.success) {
	                                _this3.setState({
	                                  lastRecordLevel2: response.dataLevel2,
	                                  lastAttemptLevel2: true
	                                });
	                              }
	                            });
	
	                          case 12:
	                            _context5.next = 15;
	                            break;
	
	                          case 14:
	                            _this3.setState({ ValidToken: false });
	
	                          case 15:
	                            return _context5.abrupt('return', resp);
	
	                          case 16:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this3);
	                  }));
	
	                  return function (_x3) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	                data = { token: this.state.token, idname: this.state.idname };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                  var resp, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context7.next = 3;
	                            break;
	                          }
	
	                          return _context7.abrupt('return');
	
	                        case 3:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context7.next = 14;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context7.next = 8;
	                            break;
	                          }
	
	                          _this3.setState({ showFreePremium1: true, showFreePremium2: true });
	                          _context7.next = 12;
	                          break;
	
	                        case 8:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context7.next = 12;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                              var exam_data, examPlanData, subscriptionStatus;
	                              return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                while (1) {
	                                  switch (_context6.prev = _context6.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context6.next = 14;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      examPlanData = resp_exam.examPlan[0];
	                                      _context6.next = 5;
	                                      return _FrmSubscription4.default.checkFrmNotesSubscription(1, exam_data, examPlanData);
	
	                                    case 5:
	                                      subscriptionStatus = _context6.sent;
	
	                                      if (subscriptionStatus) {
	                                        _this3.setState({ showFreePremium1: false });
	                                      } else {
	                                        _this3.setState({ showFreePremium1: true });
	                                      }
	                                      exam_data = resp_exam.examData;
	                                      _context6.next = 10;
	                                      return _FrmSubscription4.default.checkFrmNotesSubscription(2, exam_data, examPlanData);
	
	                                    case 10:
	                                      subscriptionStatus = _context6.sent;
	
	
	                                      if (subscriptionStatus) {
	                                        _this3.setState({ showFreePremium2: false });
	                                      } else {
	                                        _this3.setState({ showFreePremium2: true });
	                                      }
	                                      _context6.next = 14;
	                                      break;
	
	                                    case 14:
	                                    case 'end':
	                                      return _context6.stop();
	                                  }
	                                }
	                              }, _callee6, _this3);
	                            }));
	
	                            return function (_x4) {
	                              return _ref8.apply(this, arguments);
	                            };
	                          }()
	                          //console.log('fail');
	                          );
	
	                        case 12:
	                          _context7.next = 22;
	                          break;
	
	                        case 14:
	                          if (!(resp.profileInfo.exam_selected === '')) {
	                            _context7.next = 18;
	                            break;
	                          }
	
	                          _this3.setState({ showFreePremium1: true, showFreePremium2: true });
	                          _context7.next = 22;
	                          break;
	
	                        case 18:
	                          data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context7.next = 22;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var subscriptionStatus = _FrmSubscription2.default.checkFrmNotesSubscription(1, exam_data);
	                              if (subscriptionStatus) {
	                                _this3.setState({ showFreePremium1: false });
	                              } else {
	                                _this3.setState({ showFreePremium1: true });
	                              }
	
	                              var exam_data = resp_exam.examData;
	                              var subscriptionStatus = _FrmSubscription2.default.checkFrmNotesSubscription(2, exam_data);
	
	                              if (subscriptionStatus) {
	                                _this3.setState({ showFreePremium2: false });
	                              } else {
	                                _this3.setState({ showFreePremium2: true });
	                              }
	                            } else {
	                              //console.log('fail');
	                            }
	                          });
	
	                        case 22:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this3);
	                })));
	
	              case 9:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters_1 = this.state.chapters_1;
	      var data = '';
	      var _state = this.state,
	          lastAttemptLevel1 = _state.lastAttemptLevel1,
	          lastAttemptLevel2 = _state.lastAttemptLevel2;
	
	      if (this.state.chapters_1.length) {
	        data = chapters_1.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                key: item.id,
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium1 ? item.id === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  index + 1,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon2.svg',
	                      className: '',
	                      width: '24',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countreading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHAPTERS,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      var chapters_2 = this.state.chapters_2;
	      var data_2 = '';
	      if (this.state.chapters_2.length) {
	        data_2 = chapters_2.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                key: item.id,
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium2 ? item.id === 5 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  index + 1,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon2.svg',
	                      className: '',
	                      width: '24',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countreading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    ' ',
	                    _language2.default.LC().CHAPTERS,
	                    ' '
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data_2 = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20 frm_title_logo_wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().FRM_NOTES
	            ),
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	              className: 'garpLogo',
	              alt: 'full logo'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().FRM_PART_I_CHAPTERS,
	            ' '
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class mr-2',
	                onClick: function onClick() {
	                  _this4.checkSubscription(1);
	                }
	              },
	              ' ',
	              _language2.default.LC().Formula_Sheet,
	              ' '
	            ),
	            lastAttemptLevel1 ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToNotesLevel1.bind(this),
	                disabled: !lastAttemptLevel1
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_NOTES_READ,
	              ' '
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().FRM_PART_II_CHAPTERS,
	            ' '
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class mr-2',
	                onClick: function onClick() {
	                  _this4.checkSubscription(2);
	                }
	              },
	              ' ',
	              _language2.default.LC().Formula_Sheet,
	              ' '
	            ),
	            lastAttemptLevel2 ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToNotesLevel2.bind(this),
	                disabled: !lastAttemptLevel2
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_NOTES_READ,
	              ' '
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data_2
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return FrmNotes;
	}(_react.Component);
	
	FrmNotes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = FrmNotes;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../RestAPI/getData';
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var FrmNotesBeginChapters = function (_Component) {
	  _inherits(FrmNotesBeginChapters, _Component);
	
	  function FrmNotesBeginChapters(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, FrmNotesBeginChapters);
	
	    var _this = _possibleConstructorReturn(this, (FrmNotesBeginChapters.__proto__ || Object.getPrototypeOf(FrmNotesBeginChapters)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/frm/notesreadings/' + _this.props.params.notesid,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid
	        }
	      });
	    };
	
	    _this._getNotes = function () {
	      _this.context.router.push({
	        pathname: '/frm/notesview/' + _this.props.params.readingid + '/' + _this.props.params.notesid + '/' + _this.state.questions.name + '/' + _this.props.params.notesid
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	
	      _this.setState({ offset: i, questions: _this.state.all_questions_state[i] });
	
	      // alert(parseInt(this.state.question_length) - 1 + "--------" + i);
	
	      if (parseInt(_this.state.question_length) - 1 == i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i != 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      var next_question_id = _this.state.all_questions_state[i].id;
	      var readingId = _this.state.all_questions_state[i].reading_id;
	      _this.context.router.push({
	        pathname: '/frm/beginnotes/' + _this.props.params.notesid + '/' + readingId + '/' + next_question_id + '/' + i + '/' + _this.props.params.level
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      //alert(i);
	      // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
	      if (i < parseInt(_this.state.question_length, 10) - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (i == 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      }
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      var next_question_id = _this.state.all_questions_state[i].id;
	      var readingId = _this.state.all_questions_state[i].reading_id;
	      _this.context.router.push({
	        pathname: '/frm/beginnotes/' + _this.props.params.notesid + '/' + readingId + '/' + next_question_id + '/' + i + '/' + _this.props.params.level
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        frmLevel: _this.props.params.level ? _this.props.params.level : null
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveNotesstats = function (item, e) {
	      if (_this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        notes_id: item.id,
	        level: _this.props.params.level ? _this.props.params.level : null,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        frmLevel: _this.props.params.level ? _this.props.params.level : null
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            save_question: 'btn btn-success pointer_class margin_right_10',
	            save_text: '' + _language2.default.LC().MARKED_AS_READ,
	            markColor: 'green'
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.getSavedNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFavNotes', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavNotes = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        level: item.chapter_id <= 4 ? 1 : 2
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/unsaveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/saveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	              isFlashCardHidden: false
	            });
	            _this._getToggleFlash();
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.state = (_this$state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      chapter_id: _this.props.params.notesid ? _this.props.params.notesid : '',
	      reading_id: _this.props.params.readingid ? _this.props.params.readingid : '',
	      ValidToken: false,
	      reportLoading: false,
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      isFlashCardHidden: true,
	      result: '',
	      readingName: _this.props.params.reading,
	      text_color: 'card-header',
	      records: '',
	      save_question: 'btn btn-primary pointer_class margin_right_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: '' + _language2.default.LC().MARK_AS_READ,
	      saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	    }, _defineProperty(_this$state, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state, 'bookmarkColor', ''), _defineProperty(_this$state, 'savedQuestion', false), _defineProperty(_this$state, 'comment', 'card-block'), _defineProperty(_this$state, 'flashcard', 'card-block'), _defineProperty(_this$state, 'comment_data', ''), _defineProperty(_this$state, 'flash_data', []), _defineProperty(_this$state, 'flash_form', 'col-xs-12 col-sm-12 col-md-12 display_block'), _defineProperty(_this$state, 'comment_arrow', ''), _defineProperty(_this$state, 'flash_card_arrow', ''), _defineProperty(_this$state, 'flash_class', 'edit_right_padding'), _defineProperty(_this$state, 'count', 0), _defineProperty(_this$state, 'rating', 0), _defineProperty(_this$state, 'rated', false), _defineProperty(_this$state, 'ratting_text', '' + _language2.default.LC().RATE_THIS_QUESTION), _defineProperty(_this$state, 'validated', false), _defineProperty(_this$state, 'comment_update', 'hide_block'), _defineProperty(_this$state, 'comment_save', 'btn btn-primary active pointer_class'), _defineProperty(_this$state, 'comment_update_id', ''), _defineProperty(_this$state, 'next_block', ''), _defineProperty(_this$state, 'previ_block', ''), _defineProperty(_this$state, 'display_loader', ''), _defineProperty(_this$state, 'markColor', ''), _defineProperty(_this$state, 'pdfLoading', true), _defineProperty(_this$state, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state, 'user_city', ''), _defineProperty(_this$state, 'user_country', ''), _defineProperty(_this$state, 'user_ip', ''), _defineProperty(_this$state, 'user_state', ''), _defineProperty(_this$state, 'user_continent', ''), _this$state);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  /*
	  ----------------------------------------------- 
	    Function to redirect page to readings page
	  ----------------------------------------------
	  */
	
	
	  /*
	  --------------------------------------- 
	      Function to fetch Next question
	  --------------------------------------
	  */
	
	  /*
	  -----------------------------------------
	    Function to fetch previous question
	  ------------------------------------------
	  */
	
	
	  /*
	  ------------------------------------------------  
	        Function to show Report box
	  ------------------------------------------------
	  */
	
	  /*
	  ----------------------------------------
	        Function to hide Report box
	  --------------------------------------
	  */
	
	  /*
	  ----------------------------------------  
	    Funcion to save new report question
	  ----------------------------------------
	    */
	
	
	  /*
	  ------------------------------------
	    /Function to toggle Comment box
	  ------------------------------------
	    */
	
	
	  /*
	  ------------------------------------
	    /Function to toggle Flash box
	  ------------------------------------
	    */
	
	
	  /*
	  -------------------------------------------------------
	    Funcion to save notes and display Marked on button
	  -------------------------------------------------------
	    */
	
	  _createClass(FrmNotesBeginChapters, [{
	    key: 'notes_MARKED_AS_READ',
	    value: function notes_MARKED_AS_READ(params) {
	      var _this3 = this;
	
	      // const result = getDeviceDetails();
	      var data = {
	        token: params.token,
	        idname: params.idname,
	        notes_id: params.question_id,
	        level: this.props.params.level ? this.props.params.level : null,
	        city: this.state.user_city,
	        country: this.state.user_country,
	        state: this.state.user_state,
	        continent: this.state.user_continent,
	        ip: this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({
	            ValidToken: true,
	            save_question: 'btn btn-success pointer_class margin_right_10',
	            save_text: '' + _language2.default.LC().MARKED_AS_READ,
	            markColor: 'green'
	          });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	
	    /*
	    ------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    -----------------------------------------------------------------
	      */
	
	
	    /*
	    -----------------------------------
	      Function to Edit Flash card
	    -----------------------------------
	      */
	
	    /*
	    -----------------------------------
	      Function to delete flash card
	    -----------------------------------
	      */
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this4 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scroll(0, 0);
	                // api to get ip address
	                _context3.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context3.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (!this.props.params.id) {
	                  this.setState({ previ_block: 'card hide_block' });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getNotes_allcr', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    var ques_res, offset_res, i, params;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 18;
	                              break;
	                            }
	
	                            _this4.setState({
	                              ValidToken: true,
	                              all_questions_state: resp.questions
	                            });
	                            ques_res = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this4.props.params.id) {
	                                ques_res = resp.questions[i];
	                                offset_res = i;
	                              }
	
	                              if (i == resp.questions.length - 1) {
	                                _this4.setState({ display_loader: 'hide_block' });
	                              }
	                            }
	                            _this4.setState({
	                              questions: ques_res,
	                              offset: offset_res,
	                              question_length: resp.questions.length
	                            });
	
	                            if (offset_res == 0) {
	                              _this4.setState({ previ_block: 'card hide_block' });
	                            }
	                            //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
	                            if (offset_res == parseInt(resp.questions.length, 10) - 1) {
	                              _this4.setState({ next_block: 'card hide_block' });
	                            }
	
	                            params = {
	                              token: _this4.state.token,
	                              question_id: ques_res.id,
	                              idname: _this4.state.idname
	                            };
	                            _context2.next = 11;
	                            return _this4.getSavedNotes(ques_res.id);
	
	                          case 11:
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getsavestatesNotes', params).then(function (response) {
	                              if (response.success) {
	                                _this4.setState({
	                                  save_question: 'btn btn-success pointer_class margin_right_10',
	                                  save_text: '' + _language2.default.LC().MARKED_AS_READ,
	                                  markColor: 'green'
	                                });
	                              } else {
	                                setTimeout(_this4.notes_MARKED_AS_READ.bind(_this4, params), 120000);
	                              }
	                            });
	                            params = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              question_id: ques_res.id
	                            };
	                            _context2.next = 15;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFlashCards', params).then(function (response) {
	                              var flash_cards = '';
	                              if (response.success) {
	                                _this4.setState({ ValidToken: true });
	                                if (response.flash_cards.length > 0) {
	                                  _this4.setState({
	                                    flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                  });
	                                  flash_cards = response.flash_cards.map(function (items, index) {
	                                    return _react2.default.createElement(
	                                      'li',
	                                      { key: index },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: '' },
	                                        _react2.default.createElement(
	                                          'ul',
	                                          { className: 'icon_list' },
	                                          _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                              'a',
	                                              { className: 'pointer_class', onClick: _this4._editFlash.bind(_this4, items) },
	                                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                              'a',
	                                              {
	                                                className: 'pointer_class',
	                                                onClick: _this4._deleteFlash.bind(_this4, items)
	                                              },
	                                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                                            )
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: _this4.state.flash_class },
	                                          _react2.default.createElement('h4', null),
	                                          _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            items.flash_card
	                                          )
	                                        )
	                                      )
	                                    );
	                                  });
	                                } else {
	                                  _this4.setState({
	                                    flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                  });
	                                  flash_cards = _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _language2.default.LC().NO_FLASHCARDS
	                                  );
	                                }
	                                _this4.setState({ flash_data: flash_cards });
	                              } else {
	                                flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARDS
	                                );
	                                _this4.setState({
	                                  ValidToken: false,
	                                  flash_data: flash_cards,
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                              }
	                              return response;
	                            });
	
	                          case 15:
	                            _this4.setState({ records: '' });
	                            _context2.next = 19;
	                            break;
	
	                          case 18:
	                            _this4.setState({
	                              ValidToken: false,
	                              records: '' + _language2.default.LC().Result_not_found
	                            });
	
	                          case 19:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this4);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	
	
	    /*on url change run this function*/
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*
	    -----------------------------------
	     on url change run this function
	    -----------------------------------
	      */
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getNotes_allcr', data).then(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	          var ques_res, i, params;
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context4.next = 15;
	                    break;
	                  }
	
	                  _this5.setState({ ValidToken: true });
	                  ques_res = [];
	
	                  for (i = 0; i < resp.questions.length; i++) {
	                    if (resp.questions[i].id == _this5.props.params.id) {
	                      ques_res = resp.questions[i];
	                    }
	                  }
	
	                  _this5.setState({ questions: ques_res, display_loader: 'hide_block' });
	                  params = {
	                    token: _this5.state.token,
	                    question_id: ques_res.id,
	                    idname: _this5.state.idname
	                  };
	                  _context4.next = 8;
	                  return _this5.getSavedNotes(ques_res.id);
	
	                case 8:
	                  _context4.next = 10;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getsavestatesNotes', params).then(function (response) {
	                    if (response.success) {
	                      _this5.setState({
	                        save_question: 'btn btn-success pointer_class margin_right_10',
	                        save_text: 'Marked as read',
	                        markColor: 'green'
	                      });
	                    } else {
	                      _this5.setState({ markColor: '#ddd' });
	                      setTimeout(_this5.notes_MARKED_AS_READ.bind(_this5, params), 120000);
	                    }
	                  });
	
	                case 10:
	                  _context4.next = 12;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFlashCards', params).then(function (response) {
	                    var flash_cards = '';
	                    if (response.success) {
	                      _this5.setState({ ValidToken: true });
	                      if (response.flash_cards.length > 0) {
	                        _this5.setState({
	                          flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                        });
	                        flash_cards = response.flash_cards.map(function (items, index) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                              'div',
	                              { className: '' },
	                              _react2.default.createElement(
	                                'ul',
	                                { className: 'icon_list' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  _react2.default.createElement(
	                                    'a',
	                                    { className: 'pointer_class', onClick: _this5._editFlash.bind(_this5, items) },
	                                    _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  _react2.default.createElement(
	                                    'a',
	                                    {
	                                      className: 'pointer_class',
	                                      onClick: _this5._deleteFlash.bind(_this5, items)
	                                    },
	                                    _react2.default.createElement('i', { className: 'fa fa-close' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: _this5.state.flash_class },
	                                _react2.default.createElement('h4', null),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  items.flash_card
	                                )
	                              )
	                            )
	                          );
	                        });
	                      } else {
	                        _this5.setState({
	                          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                        });
	                        flash_cards = _react2.default.createElement(
	                          'p',
	                          null,
	                          _language2.default.LC().NO_FLASHCARDS
	                        );
	                      }
	                      _this5.setState({ flash_data: flash_cards });
	                    } else {
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARDS
	                      );
	                      _this5.setState({
	                        ValidToken: false,
	                        flash_data: flash_cards,
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                    }
	                    return response;
	                  });
	
	                case 12:
	                  _this5.setState({ records: '' });
	                  _context4.next = 16;
	                  break;
	
	                case 15:
	                  _this5.setState({
	                    ValidToken: false,
	                    records: '' + _language2.default.LC().Result_not_found
	                  });
	
	                case 16:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this5);
	        }));
	
	        return function (_x3) {
	          return _ref4.apply(this, arguments);
	        };
	      }());
	    }
	
	    /*
	    ---------------------------------------------------------------------
	     Function to Display Saved Question on button and save in database
	    ----------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = '';
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var retun_all_question = JSON.stringify(questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 note-section special_notes_view' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card note-section-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size sticky-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                className: 'margin_right_20',
	                alt: '',
	                width: '21'
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, 'span', 'notes-head-color'),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'notes-head-color' },
	                '(',
	                _language2.default.LC().N,
	                ' ',
	                all_questions.id,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right sticky-navigate' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'note-text-wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_20' },
	                    (0, _function.renderHTMLContent)(all_questions.discription, 'div', 'note_text_wrap')
	                  ),
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default
	                  // _getResult={this._getResult}
	                  , { isQue: false,
	                    saveNotes_text: this.state.saveNotes_text,
	                    markColor: this.state.markColor,
	                    _saveQuestion: this._saveFavNotes,
	                    _saveNotesstats: this._saveNotesstats,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: all_questions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, all_questions)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, all_questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                ),
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_FlashCard2.default, {
	              item: questions,
	              type: 'notes',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'frm',
	              level: questions.level
	            })
	          )
	        );
	      } else {
	        /* data = <div className="col-sm-12 col-md-12">
	               <div className="no_data_bar card">No Records Found</div>
	          </div>;*/
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row note-section notes_inner_title_wrap' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head title-font-size' },
	                _language2.default.LC().NOTES
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_CHAPTER
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FrmNotesBeginChapters;
	}(_react.Component);
	
	FrmNotesBeginChapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = FrmNotesBeginChapters;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var Frmnotesreadings = function (_Component) {
	  _inherits(Frmnotesreadings, _Component);
	
	  function Frmnotesreadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Frmnotesreadings);
	
	    var _this = _possibleConstructorReturn(this, (Frmnotesreadings.__proto__ || Object.getPrototypeOf(Frmnotesreadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/frm/notes/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      //console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: '/frm/notesview/' + reading.id + '/' + reading.chapter_no + '/' + reading.reading + '/' + _this.state.chapterid,
	              state: {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reading: reading,
	                chapter: _this.state.chapterid
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: '/frm/beginnotes/' + reading.chapter_no + '/' + reading.id + '/' + resp.questions[0].id + '/' + 0 + '/' + reading.level
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(_this.state.pdfLoading === false)) {
	                  _context4.next = 3;
	                  break;
	                }
	
	                alert('Download is in process....');
	                return _context4.abrupt('return');
	
	              case 3:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapterLevel: _this.state.chapterLevel
	                };
	                _context4.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (resp.profileInfo.role === 'partner') {
	                              if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                                _this.PDFToggleAlert();
	                              } else {
	                                data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                                dataset = {
	                                  token: _this.state.token,
	                                  idname: _this.state.idname,
	                                  examid: data_arr
	                                };
	
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                    var exam_data, examPlanData, subscriptionStatus, dataset;
	                                    return _regenerator2.default.wrap(function _callee$(_context) {
	                                      while (1) {
	                                        switch (_context.prev = _context.next) {
	                                          case 0:
	                                            if (!resp_exam.success) {
	                                              _context.next = 16;
	                                              break;
	                                            }
	
	                                            exam_data = resp_exam.examData;
	                                            examPlanData = resp_exam.examPlan[0];
	                                            _context.next = 5;
	                                            return _FrmSubscription4.default.checkFrmPDFSubscription(_this.state.chapterLevel, exam_data, _this.state.type, examPlanData);
	
	                                          case 5:
	                                            subscriptionStatus = _context.sent;
	
	                                            if (!subscriptionStatus) {
	                                              _context.next = 13;
	                                              break;
	                                            }
	
	                                            _this.setState({
	                                              pdfLoading: false
	                                            });
	                                            // const result = getDeviceDetails();
	                                            dataset = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterId: _this.state.chapterid,
	                                              city: _this.state.user_city,
	                                              country: _this.state.user_country,
	                                              state: _this.state.user_state,
	                                              continent: _this.state.user_continent,
	                                              ip: _this.state.user_ip,
	
	                                              frmLevel: _this.state.chapterLevel
	                                            };
	                                            _context.next = 11;
	                                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                              if (response.success) {
	                                                _this.setState({
	                                                  pdfLoading: true
	                                                });
	                                                _this.PDFDownloadAlertModel();
	                                              } else if (!response.pdf) {
	                                                _this.setState({
	                                                  pdfLoading: true
	                                                });
	                                                _this.PDFDownloadAlertModel();
	                                              }
	                                            });
	
	                                          case 11:
	                                            _context.next = 14;
	                                            break;
	
	                                          case 13:
	                                            _this.PDFToggleAlert();
	
	                                          case 14:
	                                            _context.next = 16;
	                                            break;
	
	                                          case 16:
	                                          case 'end':
	                                            return _context.stop();
	                                        }
	                                      }
	                                    }, _callee, _this2);
	                                  }));
	
	                                  return function (_x3) {
	                                    return _ref3.apply(this, arguments);
	                                  };
	                                }()
	                                //console.log("fail");
	                                );
	                              }
	                            } else {
	                              if (resp.profileInfo.exam_selected == '') {
	                                _this.PDFToggleAlert();
	                              } else {
	                                data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                                dataset = {
	                                  token: _this.state.token,
	                                  idname: _this.state.idname,
	                                  examid: data_arr
	                                };
	
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                    var exam_data, subscriptionStatus, dataset;
	                                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                      while (1) {
	                                        switch (_context2.prev = _context2.next) {
	                                          case 0:
	                                            if (!resp_exam.success) {
	                                              _context2.next = 15;
	                                              break;
	                                            }
	
	                                            exam_data = resp_exam.examData;
	                                            _context2.next = 4;
	                                            return _FrmSubscription2.default.checkFrmPDFSubscription(_this.state.chapterLevel, exam_data, _this.state.type);
	
	                                          case 4:
	                                            subscriptionStatus = _context2.sent;
	
	                                            if (!subscriptionStatus) {
	                                              _context2.next = 12;
	                                              break;
	                                            }
	
	                                            _this.setState({
	                                              pdfLoading: false
	                                            });
	                                            // const result = getDeviceDetails();
	                                            dataset = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterId: _this.state.chapterid,
	                                              city: _this.state.user_city,
	                                              country: _this.state.user_country,
	                                              state: _this.state.user_state,
	                                              continent: _this.state.user_continent,
	                                              ip: _this.state.user_ip,
	
	                                              frmLevel: _this.state.chapterLevel
	                                            };
	                                            _context2.next = 10;
	                                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                              if (response.success) {
	                                                _this.setState({
	                                                  pdfLoading: true
	                                                });
	                                                _this.PDFDownloadAlertModel();
	                                              } else if (!response.pdf) {
	                                                _this.setState({
	                                                  pdfLoading: true
	                                                });
	                                                _this.PDFDownloadAlertModel();
	                                              }
	                                            });
	
	                                          case 10:
	                                            _context2.next = 13;
	                                            break;
	
	                                          case 12:
	                                            _this.PDFToggleAlert();
	
	                                          case 13:
	                                            _context2.next = 15;
	                                            break;
	
	                                          case 15:
	                                          case 'end':
	                                            return _context2.stop();
	                                        }
	                                      }
	                                    }, _callee2, _this2);
	                                  }));
	
	                                  return function (_x4) {
	                                    return _ref4.apply(this, arguments);
	                                  };
	                                }()
	                                //console.log("fail");
	                                );
	                              }
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      PDF_Alert_status: false,
	      PDFDownloadAlertStatus: false,
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: '' + _language2.default.LC().NOTE_NOT_FOUND,
	      PDFMessageTitle: _App_data2.default.messageTitle_frm,
	      PDFMessageContent: _alertMessage2.default.messageContent_frm,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params ? _this.props.params.chapter : '',
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      chapterName: '',
	      pdfLoading: true,
	      chapterLevel: '',
	      showFreePremium: true,
	      type: 'notes',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.PDFToggleAlert = _this.PDFToggleAlert.bind(_this);
	    _this.PDFDownloadAlertModel = _this.PDFDownloadAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(Frmnotesreadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'PDFToggleAlert',
	    value: function PDFToggleAlert() {
	      this.setState({
	        PDF_Alert_status: !this.state.PDF_Alert_status
	      });
	    }
	  }, {
	    key: 'PDFDownloadAlertModel',
	    value: function PDFDownloadAlertModel() {
	      this.setState({
	        PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus
	      });
	    }
	    //it is use to redirect page
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to cfanotes page
	    ------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to notes viewquestion  page
	    ------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page on specifc questions
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context6.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context6.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter: this.state.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name,
	                      chapterLevel: resp.chaptername.level
	                    });
	                    if (!resp.readings.length) {
	                      _this3.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
	                    }
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	                _userStore2.default.getUserProfile(true).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this3.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, examPlanData, subscriptionStatus;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 9;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  examPlanData = resp_exam.examPlan[0];
	                                  _context5.next = 5;
	                                  return _FrmSubscription4.default.checkFrmPDFSubscription(_this3.state.chapterLevel, exam_data, _this3.state.type, examPlanData);
	
	                                case 5:
	                                  subscriptionStatus = _context5.sent;
	
	                                  if (subscriptionStatus) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                  _context5.next = 9;
	                                  break;
	
	                                case 9:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this3);
	                        }));
	
	                        return function (_x5) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }()
	                      //console.log("fail");
	                      );
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected == '') {
	                      _this3.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var subscriptionStatus = _FrmSubscription2.default.checkFrmPDFSubscription(_this3.state.chapterLevel, exam_data, _this3.state.type);
	                          if (subscriptionStatus) {
	                            _this3.setState({ showFreePremium: false });
	                          } else {
	                            _this3.setState({ showFreePremium: true });
	                          }
	                        } else {
	                          //console.log("fail");
	                        }
	                      });
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    ----------------------------------
	    Notes PDF DOWNLOAD Via Email
	    ---------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  style: { textAlign: 'center' },
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this4._beginChapter.bind(_this4, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().READ_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.chapterName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 notes-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Notes : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              ' ',
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CHAPTER,
	                ' ',
	                _language2.default.LC().READINGS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().READING
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            this.state.MessageContent
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.PDFToggleAlert.bind(this),
	          alert_status: this.state.PDF_Alert_status,
	          MessageContent: this.state.PDFMessageContent
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.PDFDownloadAlertModel.bind(this),
	          pdfAlert: this.state.PDFDownloadAlertStatus,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return Frmnotesreadings;
	}(_react.Component);
	
	Frmnotesreadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Frmnotesreadings;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var FrmQueBank = function (_Component) {
	  _inherits(FrmQueBank, _Component);
	
	  function FrmQueBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FrmQueBank);
	
	    var _this = _possibleConstructorReturn(this, (FrmQueBank.__proto__ || Object.getPrototypeOf(FrmQueBank)).call(this, props));
	
	    _this._getReadings = function (chapter, e) {
	      _this.context.router.push({
	        pathname: '/frm/readings/' + chapter.chapter_no + '/' + _this.state.selectedmenufrm + '/' + chapter.level + '/' + chapter.chapter_name,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: chapter.chapter_no,
	          selectedMenu: _this.state.selectedmenufrm,
	          level: chapter.level,
	          chapterName: chapter.chapter_name
	        }
	      });
	    };
	
	    _this.goToQuestionLevel1 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, lastRecordLevel1, lastAttemptLevel1;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, lastRecordLevel1 = _this$state.lastRecordLevel1, lastAttemptLevel1 = _this$state.lastAttemptLevel1;
	
	              if (lastAttemptLevel1) {
	                _this.context.router.push({
	                  pathname: '/frm/chapter/' + lastRecordLevel1.questions_frm.chapter_id + '/' + lastRecordLevel1.questions_frm.reading_id + '/' + lastRecordLevel1.contentID + '/' + lastRecordLevel1.frmLevel + '/' + 0,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecordLevel1.chapter_id,
	                    offset: 0,
	                    selectedMenu: 'frm'
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.goToQuestionLevel2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state2, lastRecordLevel2, lastAttemptLevel2;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state2 = _this.state, lastRecordLevel2 = _this$state2.lastRecordLevel2, lastAttemptLevel2 = _this$state2.lastAttemptLevel2;
	
	              if (lastAttemptLevel2) {
	                _this.context.router.push({
	                  pathname: '/frm/chapter/' + lastRecordLevel2.questions_frm.chapter_id + '/' + lastRecordLevel2.questions_frm.reading_id + '/' + lastRecordLevel2.contentID + '/' + lastRecordLevel2.frmLevel + '/' + 0,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecordLevel2.chapter_id,
	                    offset: 0,
	                    selectedMenu: 'frm'
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      freeChapterCount: [],
	      chapters_1: [],
	      chapters_2: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      selectedmenufrm: 'frm',
	      lastRecordLevel1: '',
	      lastAttemptLevel1: false,
	      lastRecordLevel2: '',
	      lastAttemptLevel2: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(FrmQueBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      if (localStorage.getItem('selectedmenu') == 'cfa') {
	        this.context.router.push({
	          pathname: '/dashboard/',
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname']
	          }
	        });
	      }
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapters', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	          var chapters_1_arr, chapters_2_arr, first_incr, second_incr, i;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context3.next = 14;
	                    break;
	                  }
	
	                  _this3.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  //console.log(resp.chapters);
	                  chapters_1_arr = [];
	                  chapters_2_arr = [];
	                  first_incr = 0;
	                  second_incr = 0;
	
	                  for (i = 0; i < resp.chapters.length; i++) {
	                    //console.log(resp.chapters[i]);
	                    if (resp.chapters[i].level == 1) {
	                      chapters_1_arr[first_incr] = resp.chapters[i];
	                      first_incr++;
	                    }
	                    if (resp.chapters[i].level == 2) {
	                      chapters_2_arr[second_incr] = resp.chapters[i];
	                      second_incr++;
	                    }
	                  }
	                  _this3.setState({
	                    chapters_1: chapters_1_arr,
	                    chapters_2: chapters_2_arr
	                  });
	
	                  _context3.next = 10;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getlastAnsweredQuestionLevel1', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecordLevel1: response.dataLevel1,
	                        lastAttemptLevel1: true
	                      });
	                    }
	                  });
	
	                case 10:
	                  _context3.next = 12;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getlastAnsweredQuestionLevel2', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecordLevel2: response.dataLevel2,
	                        lastAttemptLevel2: true
	                      });
	                    }
	                  });
	
	                case 12:
	                  _context3.next = 15;
	                  break;
	
	                case 14:
	                  _this3.setState({ ValidToken: false });
	
	                case 15:
	                  return _context3.abrupt('return', resp);
	
	                case 16:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this3);
	        }));
	
	        return function (_x) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters_1 = this.state.chapters_1;
	      var countFree = this.state.freeChapterCount;
	      var _state = this.state,
	          lastAttemptLevel1 = _state.lastAttemptLevel1,
	          lastAttemptLevel2 = _state.lastAttemptLevel2;
	
	      var data = '';
	      if (this.state.chapters_1.length && this.state.freeChapterCount.length) {
	        data = chapters_1.map(function (item, index) {
	          return countFree.map(function (itemFree, indexFree) {
	            return item.chapter_no === itemFree.id && itemFree.level === 1 ? _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: item.id
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id,
	                  onClick: _this4._getReadings.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    className: '',
	                    width: '54',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'pointer_class',
	                      id: item.chapter_name,
	                      value: item.id,
	                      onClick: _this4._getReadings.bind(_this4, item)
	                    },
	                    item.chapter_no,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                        className: '',
	                        width: '25',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countreading
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().TOTAL_READINGS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      itemFree.count
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().FREE_QUESTIONS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countquestion
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().PREMIUM_QUESTIONS
	                    )
	                  )
	                )
	              )
	            ) : null;
	          });
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      var chapters_2 = this.state.chapters_2;
	      var data_2 = '';
	      if (this.state.chapters_2.length) {
	        data_2 = chapters_2.map(function (item, index) {
	          return countFree.map(function (itemFree, indexFree) {
	            return item.chapter_no === itemFree.id && itemFree.level === 2 ? _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: item.id
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id,
	                  onClick: _this4._getReadings.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    width: '54',
	                    className: '',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'pointer_class',
	                      id: item.chapter_name,
	                      value: item.id,
	                      onClick: _this4._getReadings.bind(_this4, item)
	                    },
	                    item.id - 4,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                        className: '',
	                        width: '25',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countreading
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().TOTAL_READINGS,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      itemFree.count
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().FREE_QUESTIONS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countquestion
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().PREMIUM_QUESTIONS
	                    )
	                  )
	                )
	              )
	            ) : null;
	          });
	        });
	      } else {
	        data_2 = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 margin_bottom_20 frm_title_logo_wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().QUESTION_BANK,
	              ' '
	            ),
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	              className: 'garpLogo',
	              alt: 'full logo'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'align-self-center' },
	              _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.FRM })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read_FRM' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().FRM_LEVEL_I_TOPICS,
	            ' '
	          ),
	          lastAttemptLevel1 ? _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestionLevel1.bind(this),
	              disabled: !lastAttemptLevel1
	            },
	            ' ',
	            _language2.default.LC().GO_TO_MY_LAST_QUESTION_ANSWERED,
	            ' '
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read_FRM' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().FRM_LEVEL_II_TOPICS,
	            ' '
	          ),
	          lastAttemptLevel2 ? _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestionLevel2.bind(this),
	              disabled: !lastAttemptLevel2
	            },
	            ' ',
	            _language2.default.LC().GO_TO_MY_LAST_QUESTION_ANSWERED,
	            ' '
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data_2
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FrmQueBank;
	}(_react.Component);
	
	FrmQueBank.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = FrmQueBank;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var FrmReadings = function (_Component) {
	  _inherits(FrmReadings, _Component);
	
	  function FrmReadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, FrmReadings);
	
	    var _this = _possibleConstructorReturn(this, (FrmReadings.__proto__ || Object.getPrototypeOf(FrmReadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/frm/questionbank/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      //console.log("rrrrrrrrrr", reading);
	
	      var final_exam = [];
	      var level_store = reading.level;
	      var flag_val = false;
	      var package_name_1,
	          package_name_2 = '';
	      var package_all = _this.state.selectedmenu_1_2;
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this._runQuestions('free', reading);
	            _this.setState({ subscriptionstatus: '' + _language2.default.LC().FREE });
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context.next = 5;
	                        return _FrmSubscription4.default.checkFrm(level_store, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context.sent;
	
	                        if (subscriptionStatus) {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().PAID
	                          });
	                          _this._runQuestions('paid', reading);
	                        } else {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().FREE
	                          });
	                          _this._runQuestions('free', reading);
	                        }
	                        _context.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }()
	            //console.log("fail");
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected == '') {
	            _this._runQuestions('free', reading);
	            _this.setState({ subscriptionstatus: '' + _language2.default.LC().FREE });
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(level_store, exam_data);
	                // console.log("subscriptionStatus",subscriptionStatus);
	
	                if (subscriptionStatus) {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().PAID
	                  });
	                  _this._runQuestions('paid', reading);
	                } else {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().FREE
	                  });
	                  _this._runQuestions('free', reading);
	                }
	              } else {
	                //console.log("fail");
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var level_store = reading.level;
	      // console.log(level_store)
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: '' + _language2.default.LC().FREE });
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, examPlanData, subscriptionStatus;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 9;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        examPlanData = resp_exam.examPlan[0];
	                        _context2.next = 5;
	                        return _FrmSubscription4.default.checkFrm(level_store, exam_data, examPlanData);
	
	                      case 5:
	                        subscriptionStatus = _context2.sent;
	
	                        if (subscriptionStatus) {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().PAID
	                          });
	                          _this._runCode('paid', reading);
	                        } else {
	                          _this.setState({
	                            subscriptionstatus: '' + _language2.default.LC().FREE
	                          });
	                          _this._runCode('free', reading);
	                        }
	                        _context2.next = 9;
	                        break;
	
	                      case 9:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x2) {
	                return _ref2.apply(this, arguments);
	              };
	            }()
	            //console.log("fail");
	            );
	          }
	        } else {
	          if (resp.profileInfo.exam_selected == '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: '' + _language2.default.LC().FREE });
	          } else {
	            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var subscriptionStatus = _FrmSubscription2.default.checkFrm(level_store, exam_data);
	                if (subscriptionStatus) {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().PAID
	                  });
	                  _this._runCode('paid', reading);
	                } else {
	                  _this.setState({
	                    subscriptionstatus: '' + _language2.default.LC().FREE
	                  });
	                  _this._runCode('free', reading);
	                }
	              } else {
	                //console.log("fail");
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getpdf = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context6.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context6.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context6.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context6.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapterLevel: _this.state.chapterLevel
	                };
	                _context6.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context5.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context5.next = 5;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context5.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, examPlanData, subscriptionStatus, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 16;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context3.next = 5;
	                                        return _FrmSubscription4.default.checkFrm(_this.state.chapterLevel, exam_data, examPlanData, _this.state.type);
	
	                                      case 5:
	                                        subscriptionStatus = _context3.sent;
	
	                                        if (!subscriptionStatus) {
	                                          _context3.next = 13;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip,
	                                          frmLevel: _this.state.chapterLevel
	                                        };
	                                        _context3.next = 11;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 11:
	                                        _context3.next = 14;
	                                        break;
	
	                                      case 13:
	                                        _this.PDFToggleAlert();
	
	                                      case 14:
	                                        _context3.next = 16;
	                                        break;
	
	                                      case 16:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            //console.log("fail");
	                            );
	
	                          case 9:
	                            _context5.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected == '')) {
	                              _context5.next = 15;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context5.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                                var exam_data, subscriptionStatus, dataset;
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context4.next = 15;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        _context4.next = 4;
	                                        return _FrmSubscription2.default.checkFrm(_this.state.chapterLevel, exam_data, _this.state.type);
	
	                                      case 4:
	                                        subscriptionStatus = _context4.sent;
	
	                                        if (!subscriptionStatus) {
	                                          _context4.next = 12;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip,
	
	                                          frmLevel: _this.state.chapterLevel
	                                        };
	                                        _context4.next = 10;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 10:
	                                        _context4.next = 13;
	                                        break;
	
	                                      case 12:
	                                        _this.PDFToggleAlert();
	
	                                      case 13:
	                                        _context4.next = 15;
	                                        break;
	
	                                      case 15:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this2);
	                              }));
	
	                              return function (_x6) {
	                                return _ref6.apply(this, arguments);
	                              };
	                            }()
	                            //console.log("fail");
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context10.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context10.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context10.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context10.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapterLevel: _this.state.chapterLevel
	                };
	                _context10.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context9.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context9.next = 5;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context9.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context9.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, examPlanData, subscriptionStatus, dataset;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context7.next = 16;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        // #261 — partner checkFrm signature is (level, exam_data, examPlanData).
	                                        // This site was passing this.state.type as the 3rd arg → mock-package
	                                        // early-return guard didn't fire → partner with mock-only pkg got
	                                        // PDF QA email anyway. Pass the actual examPlanData object now.
	
	                                        examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
	                                        _context7.next = 5;
	                                        return _FrmSubscription4.default.checkFrm(_this.state.chapterLevel, exam_data, examPlanData);
	
	                                      case 5:
	                                        subscriptionStatus = _context7.sent;
	
	                                        if (!subscriptionStatus) {
	                                          _context7.next = 13;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip,
	
	                                          frmLevel: _this.state.chapterLevel
	                                        };
	                                        _context7.next = 11;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 11:
	                                        _context7.next = 14;
	                                        break;
	
	                                      case 13:
	                                        _this.PDFToggleAlert();
	
	                                      case 14:
	                                        _context7.next = 16;
	                                        break;
	
	                                      case 16:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }()
	                            //console.log("fail");
	                            );
	
	                          case 9:
	                            _context9.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected == '')) {
	                              _context9.next = 15;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context9.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context9.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp_exam) {
	                                var exam_data, subscriptionStatus, dataset;
	                                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                                  while (1) {
	                                    switch (_context8.prev = _context8.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context8.next = 15;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        _context8.next = 4;
	                                        return _FrmSubscription2.default.checkFrm(_this.state.chapterLevel, exam_data, _this.state.type);
	
	                                      case 4:
	                                        subscriptionStatus = _context8.sent;
	
	                                        if (!subscriptionStatus) {
	                                          _context8.next = 12;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip,
	
	                                          frmLevel: _this.state.chapterLevel
	                                        };
	                                        _context8.next = 10;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 10:
	                                        _context8.next = 13;
	                                        break;
	
	                                      case 12:
	                                        _this.PDFToggleAlert();
	
	                                      case 13:
	                                        _context8.next = 15;
	                                        break;
	
	                                      case 15:
	                                      case 'end':
	                                        return _context8.stop();
	                                    }
	                                  }
	                                }, _callee8, _this2);
	                              }));
	
	                              return function (_x10) {
	                                return _ref10.apply(this, arguments);
	                              };
	                            }()
	                            //console.log("fail");
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this2);
	                  }));
	
	                  return function (_x8) {
	                    return _ref8.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      PDF_Alert_status: false,
	      PDFDownloadAlertStatus: false,
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: '' + _language2.default.LC().QUESTION_NOT_FOUND,
	      PDFMessageTitle: _App_data2.default.messageTitle_frm,
	      PDFMessageContent: _alertMessage2.default.messageContent_frm,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.chapter,
	      chapterName: '',
	      ValidToken: false,
	      chapter_id: '',
	      selectedmenufrm: 'frm',
	      no_result_display: '',
	      selectedmenu: 'frm',
	      selectedmenu_2: 'frm_2',
	      selectedmenu_1_2: 'frm_1_2',
	      subscriptionstatus: '',
	      pdfLoading: true,
	      chapterLevel: '',
	      pdfLoadingAnswer: true,
	      level: _this.props.params.level,
	      showFreePremium: true,
	      type: 'question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      PDFDownloadType: 'Question',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.PDFToggleAlert = _this.PDFToggleAlert.bind(_this);
	
	    _this.PDFDownloadAlertModel = _this.PDFDownloadAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(FrmReadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'PDFToggleAlert',
	    value: function PDFToggleAlert() {
	      this.setState({
	        PDF_Alert_status: !this.state.PDF_Alert_status
	      });
	    }
	  }, {
	    key: 'PDFDownloadAlertModel',
	    value: function PDFDownloadAlertModel() {
	      this.setState({
	        PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus
	      });
	    }
	  }, {
	    key: '_runQuestions',
	    value: function _runQuestions(subscriptionstatus, reading) {
	      var _this3 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: reading.id,
	        chapter_id: this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this3.context.router.push({
	              pathname: '/frm/questions/' + reading.id + '/' + reading.chapter_no + '/' + reading.reading + '/' + subscriptionstatus + '/' + _this3.props.params.chapter + '/' + reading.level + '/' + _this3.state.selectedmenufrm
	              // state: {
	              //   token: this.state.token,
	              //   idname: this.state.idname,
	              //   reading: reading,
	              //   chapter: this.props.location.state.chapter,
	              //   selectedMenu: this.state.selectedmenufrm,
	              //   subscriptionstatus: subscriptionstatus,
	              //   level: reading.level,
	              // },
	            });
	          } else {
	            _this3.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus, reading) {
	      var _this4 = this;
	
	      // console.log('_runCode')
	      // console.log(subscriptionstatus)
	      // console.log(reading)
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: reading.id,
	        chapter_id: this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          // console.log(resp.questions)
	          if (resp.questions.length) {
	            _this4.context.router.push({
	              pathname: '/frm/chapter/' + _this4.state.chapterid + '/' + reading.id + '/' + resp.questions[0].id + '/' + reading.level + '/' + 0
	              // state: {
	              //   token: this.state.token,
	              //   idname: this.state.idname,
	              //   reading: reading,
	              //   chapter: this.props.location.state.chapter,
	              //   offset: 0,
	              //   selectedMenu: this.state.selectedmenufrm,
	              // },
	            });
	          } else {
	            _this4.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this5 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context12.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReadings', data).then(function (resp) {
	                  //console.log(resp);
	                  if (resp.success) {
	                    _this5.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name,
	                      chapterLevel: resp.chaptername.level
	                    });
	
	                    if (!resp.readings.length) {
	                      _this5.setState({
	                        no_result_display: '' + _language2.default.LC().NO_SAVED_QUESTIONS
	                      });
	                    }
	                  } else {
	                    _this5.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                // ----------PDF check---------------
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this5.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this5.state.token,
	                        idname: _this5.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp_exam) {
	                          var exam_data, examPlanData, subscriptionStatus;
	                          return _regenerator2.default.wrap(function _callee11$(_context11) {
	                            while (1) {
	                              switch (_context11.prev = _context11.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context11.next = 9;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  examPlanData = resp_exam.examPlan[0];
	                                  _context11.next = 5;
	                                  return _FrmSubscription4.default.checkFrm(_this5.state.chapterLevel, exam_data, examPlanData, _this5.state.type);
	
	                                case 5:
	                                  subscriptionStatus = _context11.sent;
	
	                                  if (subscriptionStatus) {
	                                    _this5.setState({ showFreePremium: false });
	                                  } else {
	                                    _this5.setState({ showFreePremium: true });
	                                  }
	                                  _context11.next = 9;
	                                  break;
	
	                                case 9:
	                                case 'end':
	                                  return _context11.stop();
	                              }
	                            }
	                          }, _callee11, _this5);
	                        }));
	
	                        return function (_x11) {
	                          return _ref12.apply(this, arguments);
	                        };
	                      }()
	                      //console.log("fail");
	                      );
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected == '') {
	                      _this5.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                      var dataset = {
	                        token: _this5.state.token,
	                        idname: _this5.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var subscriptionStatus = _FrmSubscription2.default.checkFrm(_this5.state.chapterLevel, exam_data, _this5.state.type);
	                          if (subscriptionStatus) {
	                            _this5.setState({ showFreePremium: false });
	                          } else {
	                            _this5.setState({ showFreePremium: true });
	                          }
	                        } else {
	                          //console.log("fail");
	                        }
	                      });
	                    }
	                  }
	                });
	
	                // ------------------
	
	              case 10:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    ------------------------------
	    PDF Question DOWNLOAD Via Email
	    -------------------------------
	    */
	
	    /*
	    --------------------------------------------
	    PDF Question & Answer DOWNLOAD Via Email
	    --------------------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: _this6._getQuestions.bind(_this6, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_LIST,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this6._beginChapter.bind(_this6, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().BEGIN_CHAPTER,
	                  ' '
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.chapterName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                ' ',
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Question : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: this.getpdfAnswer.bind(this),
	                className: 'status-download-btn margin_right_10'
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                ' ',
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoadingAnswer ? _language2.default.LC().Download_Question_Answer : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().CHAPTER,
	                ' ',
	                this.props.params.chapter.id,
	                ' ',
	                this.props.params.chapter.chapter_name,
	                ' ',
	                _language2.default.LC().READINGS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().READING
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex flex-column' },
	              _react2.default.createElement(
	                'div',
	                null,
	                ' ',
	                this.state.MessageContent
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-right' },
	                ' ',
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { color: 'primary', onClick: this.toggleAlert },
	                  ' ',
	                  _language2.default.LC().OK,
	                  ' '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.PDFToggleAlert.bind(this),
	          alert_status: this.state.PDF_Alert_status,
	          MessageContent: this.state.PDFMessageContent
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.PDFDownloadAlertModel.bind(this),
	          pdfAlert: this.state.PDFDownloadAlertStatus,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return FrmReadings;
	}(_react.Component);
	
	FrmReadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = FrmReadings;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _Timer = __webpack_require__(171);
	
	var _Timer2 = _interopRequireDefault(_Timer);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Frmchapter = function (_Component) {
	  _inherits(Frmchapter, _Component);
	
	  function Frmchapter(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Frmchapter);
	
	    var _this = _possibleConstructorReturn(this, (Frmchapter.__proto__ || Object.getPrototypeOf(Frmchapter)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/frm/readings/' + _this.props.params.notesid + '/' + _this.state.selectedmenufrm,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid,
	          selectedMenu: _this.state.selectedmenufrm
	        }
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: '/frm/questions/' + _this.props.params.readingid + '/' + _this.props.params.notesid + '/' + _this.state.chapter_name + '/' + _this.state.subscriptionstatus + '/' + _this.props.params.notesid + '/' + _this.props.params.level + '/' + _this.state.selectedmenufrm
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this.getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this.getPrevious = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, offset, all_questions_state, token, idname, selectedmenufrm, _this$props$params, notesid, readingid, level, prevIndex, prevQuestion, _this$getSelectedAndS, selected, showAnswer, timeDone, isRevisionMode;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.setState({ successAlert: false, report_block: 'card hide_block' });
	              _this$state = _this.state, offset = _this$state.offset, all_questions_state = _this$state.all_questions_state, token = _this$state.token, idname = _this$state.idname, selectedmenufrm = _this$state.selectedmenufrm;
	              _this$props$params = _this.props.params, notesid = _this$props$params.notesid, readingid = _this$props$params.readingid, level = _this$props$params.level;
	              prevIndex = offset - 1;
	
	              if (!(prevIndex < 0)) {
	                _context.next = 6;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 6:
	              prevQuestion = all_questions_state[prevIndex];
	              _this$getSelectedAndS = _this.getSelectedAndShowAnswer(prevQuestion, 'right_choice'), selected = _this$getSelectedAndS.selected, showAnswer = _this$getSelectedAndS.showAnswer, timeDone = _this$getSelectedAndS.timeDone, isRevisionMode = _this$getSelectedAndS.isRevisionMode;
	
	              _this.setState({
	                offset: prevIndex,
	                questions: prevQuestion,
	                choice: selected,
	                clicked: showAnswer,
	                result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                text_color: selected === prevQuestion.right_choice ? 'card-header text_success' : 'card-header text_failure',
	                result: selected === prevQuestion.right_choice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                display_loader: 'hide_block',
	                stopTimer: !!selected,
	                timerValue: isRevisionMode ? timeDone : 0,
	                previ_block: prevIndex === 0 ? 'card hide_block' : '',
	                next_block: ''
	              });
	              _this.context.router.push({
	                pathname: '/frm/chapter/' + notesid + '/' + readingid + '/' + prevQuestion.id + '/' + level + '/' + prevIndex,
	                state: {
	                  token: token,
	                  idname: idname,
	                  reading: readingid,
	                  chapter: notesid,
	                  offset: prevIndex,
	                  selectedMenu: selectedmenufrm
	                }
	              });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getNext = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state2, offset, all_questions_state, question_length, token, idname, selectedmenufrm, _this$props$params2, notesid, readingid, level, nextIndex, nextQuestion, _this$getSelectedAndS2, selected, showAnswer, timeDone, isRevisionMode;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.setState({ successAlert: false, report_block: 'card hide_block' });
	              _this$state2 = _this.state, offset = _this$state2.offset, all_questions_state = _this$state2.all_questions_state, question_length = _this$state2.question_length, token = _this$state2.token, idname = _this$state2.idname, selectedmenufrm = _this$state2.selectedmenufrm;
	              _this$props$params2 = _this.props.params, notesid = _this$props$params2.notesid, readingid = _this$props$params2.readingid, level = _this$props$params2.level;
	              nextIndex = offset + 1;
	
	              if (!(nextIndex >= question_length)) {
	                _context2.next = 6;
	                break;
	              }
	
	              return _context2.abrupt('return');
	
	            case 6:
	              nextQuestion = all_questions_state[nextIndex];
	              _this$getSelectedAndS2 = _this.getSelectedAndShowAnswer(nextQuestion, 'right_choice'), selected = _this$getSelectedAndS2.selected, showAnswer = _this$getSelectedAndS2.showAnswer, timeDone = _this$getSelectedAndS2.timeDone, isRevisionMode = _this$getSelectedAndS2.isRevisionMode;
	
	              _this.setState({
	                offset: nextIndex,
	                questions: nextQuestion,
	                choice: selected,
	                clicked: showAnswer,
	                result_block: showAnswer ? 'card show_block' : 'card hide_block',
	                text_color: selected === nextQuestion.right_choice ? 'card-header text_success' : 'card-header text_failure',
	                result: selected === nextQuestion.right_choice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	                display_loader: 'hide_block',
	                stopTimer: !!selected,
	                timerValue: isRevisionMode ? timeDone : 0,
	                next_block: nextIndex === question_length - 1 ? 'card hide_block' : '',
	                previ_block: ''
	              });
	              _this.context.router.push({
	                pathname: '/frm/chapter/' + notesid + '/' + readingid + '/' + nextQuestion.id + '/' + level + '/' + nextIndex,
	                state: {
	                  token: token,
	                  idname: idname,
	                  reading: readingid,
	                  chapter: notesid,
	                  offset: nextIndex,
	                  selectedMenu: selectedmenufrm
	                }
	              });
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getAnswer = function (choice) {
	      var clicked = _this.state.clicked;
	
	      if (clicked) return;
	
	      var selectedChoice = choice[0];
	      var choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
	      var updatedState = {
	        choice: selectedChoice,
	        selectedChoice: selectedChoice,
	        stopTimer: false
	      };
	
	      choices.forEach(function (key) {
	        updatedState[key] = key === selectedChoice ? 'answer_box selected' : 'answer_box';
	      });
	
	      _this.setState(updatedState);
	    };
	
	    _this._displayReportForm = function () {
	      _this.setState({ report_block: 'card show_block', successAlert: false });
	    };
	
	    _this._hideReportForm = function () {
	      _this.setState({ report_block: 'card hide_block', successAlert: false });
	    };
	
	    _this._getResult = function () {
	      var _this$state3 = _this.state,
	          choice = _this$state3.choice,
	          questions = _this$state3.questions,
	          all_questions_state = _this$state3.all_questions_state,
	          offset = _this$state3.offset,
	          timerValue = _this$state3.timerValue,
	          level = _this$state3.level,
	          token = _this$state3.token,
	          idname = _this$state3.idname;
	
	      if (!choice) return;
	      var isCorrect = choice === questions.right_choice;
	      var updatedQuestion = Object.assign({}, questions, { selectedChoice: choice });
	      var updatedQuestionsState = [].concat(_toConsumableArray(all_questions_state));
	      updatedQuestionsState[offset] = updatedQuestion;
	      _this.setState({
	        clicked: true,
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	        result: isCorrect ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	        result_block: 'card show_block',
	        questions: updatedQuestion,
	        all_questions_state: updatedQuestionsState,
	        stopTimer: true,
	        showAnswer: true
	      });
	      var statsData = {
	        token: token,
	        idname: idname,
	        question_id: questions.id,
	        right_answer: isCorrect ? 1 : 0,
	        time_done: timerValue,
	        level: level,
	        selectedChoice: choice
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveStats', statsData).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, validated: true });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      }).catch(function () {
	        _this.setState({ ValidToken: false });
	      });
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        level: _this.state.level
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: _language2.default.LC().SAVE_QUESTION + ' ',
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              isFlashCardHidden: false
	            });
	            _this.getToggleFlash();
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card,
	        level: _this.state.level
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: ques_res.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	                _this.setState({ flash_data: flash_cards });
	              } else {
	                _this.setState({
	                  flash_form: 'col-sm-12 display_block',
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  )
	                });
	              }
	            } else {
	              _this.setState({
	                flash_form: 'col-sm-12 display_block',
	                flash_data: _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                )
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this._reportQuestion = function () {
	      var _this$state4 = _this.state,
	          questions = _this$state4.questions,
	          token = _this$state4.token,
	          idname = _this$state4.idname,
	          user_city = _this$state4.user_city,
	          user_country = _this$state4.user_country,
	          user_state = _this$state4.user_state,
	          user_continent = _this$state4.user_continent,
	          user_ip = _this$state4.user_ip;
	
	      var comment = document.getElementById('comment').value;
	
	      if (comment.length < 2) {
	        return;
	      }
	
	      var data = {
	        token: token,
	        idname: idname,
	        question_id: questions.id,
	        comment: comment,
	        city: user_city,
	        country: user_country,
	        state: user_state,
	        continent: user_continent,
	        ip: user_ip,
	        frmLevel: _this.props.params.level
	      };
	
	      _this.setState({ reportLoading: true });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            successAlert: true,
	            reportLoading: false,
	            report_block: 'card show_block'
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ reportLoading: false });
	        }
	      }).catch(function (error) {
	        _this.setState({ reportLoading: false });
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getTimerValue = function (value) {
	      _this.setState({ timerValue: value });
	    };
	
	    _this.updateState = function (updates) {
	      _this.setState(function (prevState) {
	        return Object.assign({}, prevState, updates);
	      });
	    };
	
	    _this.fetchQuestions = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var readingid, _this$state5, token, idname, level, response, questions;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              readingid = _this.props.params.readingid;
	              _this$state5 = _this.state, token = _this$state5.token, idname = _this$state5.idname, level = _this$state5.level;
	              _context3.prev = 2;
	              _context3.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions_allcr', {
	                token: token,
	                idname: idname,
	                readingid: readingid,
	                level: level
	              });
	
	            case 5:
	              response = _context3.sent;
	
	              if (!(response && response.success)) {
	                _context3.next = 11;
	                break;
	              }
	
	              questions = response.questions;
	              _context3.next = 10;
	              return _this.initializeQuestionState(questions);
	
	            case 10:
	              _this.updateState({
	                questionData: questions,
	                isLoading: false
	              });
	
	            case 11:
	              _context3.next = 16;
	              break;
	
	            case 13:
	              _context3.prev = 13;
	              _context3.t0 = _context3['catch'](2);
	
	              _this.updateState({ isLoading: false });
	
	            case 16:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[2, 13]]);
	    }));
	
	    _this.initializeQuestionState = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(questionsData) {
	        var id, index, currentQuestion, _this$determineAnswer, selectedChoice, showAnswer, stopTimer, timeDone;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	                id = _this.props.params.id;
	                index = id && id !== ':id' ? questionsData.findIndex(function (item) {
	                  return String(item.id) === String(id);
	                }) : 0;
	                currentQuestion = questionsData[Math.max(0, index)];
	
	                if (currentQuestion) {
	                  _context4.next = 7;
	                  break;
	                }
	
	                _this.setState({ isLoading: false });
	                return _context4.abrupt('return');
	
	              case 7:
	                _this$determineAnswer = _this.determineAnswerState(currentQuestion), selectedChoice = _this$determineAnswer.selectedChoice, showAnswer = _this$determineAnswer.showAnswer, stopTimer = _this$determineAnswer.stopTimer, timeDone = _this$determineAnswer.timeDone;
	
	
	                _this.setState({
	                  selectedChoice: selectedChoice,
	                  stopTimer: stopTimer,
	                  showAnswer: showAnswer,
	                  currentIndex: Math.max(0, index),
	                  currentQuestion: currentQuestion,
	                  timerValue: timeDone,
	                  isLoading: false
	                });
	
	              case 9:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.determineAnswerState = function (question) {
	      var selectedChoice = question.frm_question_stats && question.frm_question_stats[0] ? question.frm_question_stats[0].selected_choice || '' : '';
	      var rightAnswer = question.frm_question_stats && question.frm_question_stats[0] ? question.frm_question_stats[0].right_answer || '' : '';
	      var answerStatus = question.frm_question_stats && question.frm_question_stats[0] ? question.frm_question_stats[0].id || '' : '';
	      var timeDone = question.frm_question_stats && question.frm_question_stats[0] ? parseInt(question.frm_question_stats[0].time_done || 0, 10) : 0;
	
	      var showAnswer = false;
	      var selected = '';
	
	      if (selectedChoice) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (answerStatus) {
	        if (rightAnswer === 1) {
	          selected = question.right_choice;
	          showAnswer = true;
	        } else if (!rightAnswer) {
	          var correct = question.right_choice;
	          var choices = Object.keys(question).filter(function (key) {
	            return key.startsWith('choice') && key !== correct;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	
	      return {
	        selectedChoice: selected,
	        showAnswer: showAnswer,
	        stopTimer: !!selected,
	        timeDone: timeDone
	      };
	    };
	
	    _this.navigateToQuestion = function (newIndex) {
	      var questionData = _this.state.questionData;
	      var readingid = _this.props.params.readingid;
	      var router = _this.context.router;
	
	
	      var questionId = questionData[newIndex] && questionData[newIndex].id;
	      if (questionId) {
	        router.push({
	          pathname: '/frm/questions/' + readingid + '/' + questionId + '/' + _this.state.level
	        });
	      }
	    };
	
	    _this.getPreviousQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var _this$state6, currentIndex, questionData;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this$state6 = _this.state, currentIndex = _this$state6.currentIndex, questionData = _this$state6.questionData;
	
	              if (!(currentIndex > 0)) {
	                _context5.next = 5;
	                break;
	              }
	
	              _context5.next = 4;
	              return _this.initializeQuestionState(questionData);
	
	            case 4:
	              _this.navigateToQuestion(currentIndex - 1);
	
	            case 5:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getNextQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var _this$state7, currentIndex, questionData;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _this$state7 = _this.state, currentIndex = _this$state7.currentIndex, questionData = _this$state7.questionData;
	
	              if (!(currentIndex < questionData.length - 1)) {
	                _context6.next = 5;
	                break;
	              }
	
	              _context6.next = 4;
	              return _this.initializeQuestionState(questionData);
	
	            case 4:
	              _this.navigateToQuestion(currentIndex + 1);
	
	            case 5:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.validateQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var _this$state8, selectedChoice, questionData, currentIndex, timerValue, token, idname, level, currentQuestion, isCorrect, data, result, updatedQuestionData, statsId;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state8 = _this.state, selectedChoice = _this$state8.selectedChoice, questionData = _this$state8.questionData, currentIndex = _this$state8.currentIndex, timerValue = _this$state8.timerValue, token = _this$state8.token, idname = _this$state8.idname, level = _this$state8.level;
	
	              if (selectedChoice) {
	                _context7.next = 3;
	                break;
	              }
	
	              return _context7.abrupt('return');
	
	            case 3:
	              currentQuestion = questionData[currentIndex];
	              isCorrect = currentQuestion && currentQuestion.right_choice === selectedChoice;
	              _context7.prev = 5;
	              data = {
	                token: token,
	                idname: idname,
	                question_id: currentQuestion && currentQuestion.id,
	                right_answer: isCorrect ? 1 : 0,
	                time_done: timerValue,
	                level: level,
	                selectedChoice: selectedChoice
	              };
	              _context7.next = 9;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveStats', data);
	
	            case 9:
	              result = _context7.sent;
	
	
	              if (result && result.success) {
	                updatedQuestionData = [].concat(_toConsumableArray(questionData));
	                statsId = '';
	
	                if (currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0]) {
	                  statsId = currentQuestion.frm_question_stats[0].id;
	                }
	
	                updatedQuestionData[currentIndex] = Object.assign({}, currentQuestion, {
	                  frm_question_stats: [{
	                    selected_choice: selectedChoice,
	                    time_done: timerValue,
	                    answer_status: result.answer_status || 0,
	                    id: result.id || statsId,
	                    right_answer: isCorrect ? 1 : 0
	                  }]
	                });
	
	                _this.setState({
	                  stopTimer: true,
	                  showAnswer: true,
	                  questionData: updatedQuestionData,
	                  currentQuestion: updatedQuestionData[currentIndex]
	                });
	              }
	              _context7.next = 15;
	              break;
	
	            case 13:
	              _context7.prev = 13;
	              _context7.t0 = _context7['catch'](5);
	
	            case 15:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2, [[5, 13]]);
	    }));
	
	    _this.setAnswer = function (answer) {
	      _this.updateState({ selectedChoice: answer[0] });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.updateState({ isFlashCardHidden: status });
	    };
	
	    _this.toggleReportSection = function () {
	      _this.updateState(function (prevState) {
	        return { showReportSection: !prevState.showReportSection };
	      });
	    };
	
	    _this.hideReportSection = function () {
	      _this.updateState({ showReportSection: false });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this.fetchRatingForCurrentQuestion = function (questionId) {
	      var _this$state9 = _this.state,
	          token = _this$state9.token,
	          idname = _this$state9.idname;
	
	      var params = {
	        token: token,
	        question_id: questionId,
	        idname: idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFrmratting', params).then(function (response) {
	        if (response.success && response.ratting.length > 0) {
	          var ratingValue = response.ratting[0].ratting;
	          _this.setState({
	            rating: ratingValue,
	            rated: true,
	            ratting_text: 'Rated ' + ratingValue + ' stars'
	          });
	        } else {
	          _this.setState({
	            rating: 0,
	            rated: false,
	            ratting_text: _language2.default.LC().RATE_THIS_QUESTION
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: _language2.default.LC().SAVE_QUESTION + ' ',
	      savedQuestion: false,
	      timerstopbtn: 'pause_btn icon-control-pause',
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      choice_name: '',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      selectedmenufrm: 'frm',
	      display_loader: '',
	      selectedmenu: 'frm',
	      selectedmenu_2: 'frm_2',
	      selectedmenu_1_2: 'frm_1_2',
	      subscriptionstatus: '',
	      level: '',
	      chapter_name: '',
	
	      all_questions: '',
	      category: _this.props.params.level === '1' ? 'FRM Part 1' : 'FRM Part 2',
	      tags: ['frm-2', 'frm-1', 'frm', 'question'],
	      title: '',
	      description: '',
	      forumComment: '',
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      timerValue: 0,
	      isLoading: true,
	      currentIndex: 0,
	      showAnswer: false,
	      stopTimer: false,
	      selectedChoice: '',
	      isUserSubscribed: false,
	      currentQuestion: {},
	      showReportSection: false,
	      questionData: []
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	
	    _this.getAnswer = _this.getAnswer.bind(_this);
	    _this.tick = _this.tick.bind(_this);
	    _this.timerFunct = _this.timerFunct.bind(_this);
	    return _this;
	  }
	
	  _createClass(Frmchapter, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (!this.state.timer_stop) {
	        this.setState(function (prevState) {
	          return { count: prevState.count + 1 };
	        });
	      }
	    }
	  }, {
	    key: 'initializeTimer',
	    value: function initializeTimer() {
	      if (this.timer) {
	        clearInterval(this.timer);
	      }
	      this.timer = setInterval(this.tick, 1000);
	      this.setState({ timer_stop: false, timerstopbtn: 'pause_btn icon-control-pause' });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var _this3 = this;
	
	        var result, storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                window.scrollTo(0, 0);
	
	                _context9.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context9.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	
	                this.setState({ level: this.props.params.level });
	
	                user_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var level_store, afterRunCode, data_arr, _result, examPlanData, subscriptionStatus, _data_arr, _result2, _subscriptionStatus;
	
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            level_store = _this3.props.params.level;
	
	                            afterRunCode = function afterRunCode() {
	                              var questions = _this3.state.questions;
	
	                              if (questions && questions.right_choice) {
	                                var choiceMap = {
	                                  choice_a: 'A',
	                                  choice_b: 'B',
	                                  choice_c: 'C',
	                                  choice_d: 'D'
	                                };
	
	                                var choice_name = choiceMap[questions.right_choice] || '';
	                                _this3.setState({ choice_name: choice_name });
	                              }
	                            };
	
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 20;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 8;
	                              break;
	                            }
	
	                            _this3._runCode('free');
	                            _this3.setState({ subscriptionstatus: 'free' }, afterRunCode);
	                            _context8.next = 18;
	                            break;
	
	                          case 8:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            _context8.next = 11;
	                            return _this3._getExamsByUser(data_arr);
	
	                          case 11:
	                            _result = _context8.sent;
	
	                            if (!(_result && _result.examData)) {
	                              _context8.next = 18;
	                              break;
	                            }
	
	                            // #261 — pass examPlanData so the partner check's mock-package
	                            // early-return fires (was missing — partner with mock-only plan
	                            // saw the QB chapter as "paid" with full access).
	                            examPlanData = _result.examPlan && _result.examPlan[0];
	                            _context8.next = 16;
	                            return _FrmSubscription4.default.checkFrm(level_store, _result.examData, examPlanData);
	
	                          case 16:
	                            subscriptionStatus = _context8.sent;
	
	                            if (subscriptionStatus) {
	                              _this3._runCode('paid');
	                              _this3.setState({ subscriptionstatus: 'paid' }, afterRunCode);
	                            } else {
	                              _this3._runCode('free');
	                              _this3.setState({ subscriptionstatus: 'free' }, afterRunCode);
	                            }
	
	                          case 18:
	                            _context8.next = 30;
	                            break;
	
	                          case 20:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context8.next = 25;
	                              break;
	                            }
	
	                            _this3._runCode('free');
	                            _this3.setState({ subscriptionstatus: 'free' }, afterRunCode);
	                            _context8.next = 30;
	                            break;
	
	                          case 25:
	                            _data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                            _context8.next = 28;
	                            return _this3._getExamsByUser(_data_arr);
	
	                          case 28:
	                            _result2 = _context8.sent;
	
	                            if (_result2 && _result2.examData) {
	                              _subscriptionStatus = _FrmSubscription2.default.checkFrm(level_store, _result2.examData);
	
	                              if (_subscriptionStatus) {
	                                _this3._runCode('paid');
	                                _this3.setState({ subscriptionstatus: 'paid' }, afterRunCode);
	                              } else {
	                                _this3._runCode('free');
	                                _this3.setState({ subscriptionstatus: 'free' }, afterRunCode);
	                              }
	                            }
	
	                          case 30:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this3);
	                  }));
	
	                  return function (_x2) {
	                    return _ref9.apply(this, arguments);
	                  };
	                }());
	
	                this.initializeTimer();
	
	              case 11:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: '_getExamsByUser',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(examIds) {
	        var dataset, response;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (examIds) {
	                  _context10.next = 2;
	                  break;
	                }
	
	                return _context10.abrupt('return', null);
	
	              case 2:
	                _context10.prev = 2;
	                dataset = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  examid: examIds
	                };
	                _context10.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset);
	
	              case 6:
	                response = _context10.sent;
	
	                if (!response.success) {
	                  _context10.next = 9;
	                  break;
	                }
	
	                return _context10.abrupt('return', { examData: response.examData, examPlan: response.examPlan });
	
	              case 9:
	                return _context10.abrupt('return', null);
	
	              case 12:
	                _context10.prev = 12;
	                _context10.t0 = _context10['catch'](2);
	
	                console.error('Error fetching exam data:', _context10.t0);
	                return _context10.abrupt('return', null);
	
	              case 16:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this, [[2, 12]]);
	      }));
	
	      function _getExamsByUser(_x3) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return _getExamsByUser;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearInterval(this.timer);
	      }
	    }
	  }, {
	    key: 'getSelectedAndShowAnswer',
	    value: function getSelectedAndShowAnswer(currentQuestion) {
	      var correctChoiceKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right_choice';
	
	      var selectedChoice = currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0] ? currentQuestion.frm_question_stats[0].selected_choice || '' : currentQuestion.selectedChoice || '';
	      var rightAnswer = currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0] ? currentQuestion.frm_question_stats[0].right_answer || '' : '';
	      var answerStatus = currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0] ? currentQuestion.frm_question_stats[0].id || '' : '';
	      var timeDone = currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0] ? parseInt(currentQuestion.frm_question_stats[0].time_done || 0, 10) : 0;
	      var showAnswer = false;
	      var selected = '';
	      var isRevisionMode = (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.FRM);
	
	      if (selectedChoice && isRevisionMode) {
	        selected = selectedChoice;
	        showAnswer = true;
	      } else if (answerStatus && isRevisionMode) {
	        if (rightAnswer === 1) {
	          selected = currentQuestion[correctChoiceKey];
	          showAnswer = true;
	        } else if (!rightAnswer) {
	          var correct = currentQuestion[correctChoiceKey];
	          var choices = Object.keys(currentQuestion).filter(function (key) {
	            return key.startsWith('choice') && key !== correct;
	          });
	          selected = choices.length > 0 ? choices[0] : '';
	          showAnswer = true;
	        }
	      }
	      return { selected: selected, showAnswer: showAnswer, timeDone: timeDone, isRevisionMode: isRevisionMode };
	    }
	
	    /*
	    ---------------------------------------
	      Function to fetch Next question
	    --------------------------------------
	    */
	
	
	    /*
	    --------------------------------------------------------------------------
	      Function to check Right Or Wrong Answered and displayed clicked box
	    --------------------------------------------------------------------------
	    */
	
	
	    /*
	    --------------------------------
	      Function to show Report box
	    --------------------------------
	    */
	
	
	    /*
	    -------------------------------
	      Function to hide Report box
	    -------------------------------
	    */
	
	
	    /*
	    ---------------------------------------------------------------------------------
	        Function to show Correct box and display right answer and store in database
	    ---------------------------------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------------------- 
	    Function to Display Saved Question on button and save in database
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------------------
	       Function to Save flash Card And display new stored flash card
	    -------------------------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------
	      Funcion to save new report question
	    -----------------------------------------
	    */
	
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      var _state = this.state,
	          token = _state.token,
	          idname = _state.idname;
	
	      if (prevValue !== nextValue) {
	        var updateParams = {
	          token: token,
	          idname: idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateFrmratting', updateParams).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var getParams = {
	        token: token,
	        question_id: item.id,
	        idname: idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFrmratting', getParams).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.forEach(function (ratingItem) {
	              _this4.setState({ rating: ratingItem.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            var saveParams = {
	              token: token,
	              idname: idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFrmratting', saveParams).then(function (saveResp) {
	              if (saveResp.success) {
	                _this4.setState({
	                  rated: 1,
	                  ratting_text: 'Rated ' + nextValue + ' stars'
	                });
	              }
	            });
	          }
	        } else {
	          var _saveParams = {
	            token: token,
	            idname: idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/saveFrmratting', _saveParams).then(function (saveResp) {
	            if (saveResp.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.props.params.readingid,
	        chapter_id: this.props.params.notesid,
	        offset: this.state.offset,
	        subscriptionstatus: subscriptionstatus,
	        level: this.state.level
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success) {
	          var allQuestions = resp.questions.map(function (question) {
	            var selectedChoice = question.frm_question_stats && question.frm_question_stats.length > 0 ? question.frm_question_stats[0].selected_choice : '';
	            return Object.assign({}, question, { selectedChoice: selectedChoice });
	          });
	
	          _this5.setState({
	            ValidToken: true,
	            all_questions_state: allQuestions,
	            question_length: allQuestions.length
	          });
	
	          var offset = 0;
	          if (_this5.props.params.offset !== undefined) {
	            offset = parseInt(_this5.props.params.offset, 10);
	            if (isNaN(offset) || offset < 0 || offset >= allQuestions.length) {
	              offset = 0;
	            }
	          }
	          var currentQuestion = allQuestions[offset || allQuestions.findIndex(function (item) {
	            return item.id == _this5.props.params.id;
	          })];
	
	          var _getSelectedAndShowAn = _this5.getSelectedAndShowAnswer(currentQuestion, 'right_choice'),
	              selected = _getSelectedAndShowAn.selected,
	              showAnswer = _getSelectedAndShowAn.showAnswer,
	              timeDone = _getSelectedAndShowAn.timeDone,
	              isRevisionMode = _getSelectedAndShowAn.isRevisionMode;
	
	          _this5.setState({
	            questions: currentQuestion,
	            offset: offset,
	            choice: selected,
	            clicked: showAnswer,
	            result_block: showAnswer ? 'card show_block' : 'card hide_block',
	            text_color: selected === currentQuestion.right_choice ? 'card-header text_success' : 'card-header text_failure',
	            result: selected === currentQuestion.right_choice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	            display_loader: 'hide_block',
	            stopTimer: !!selected,
	            timerValue: isRevisionMode ? timeDone : 0
	          }, function () {
	            var rightChoice = _this5.state.questions.right_choice;
	            var choiceMap = {
	              choice_a: 'A',
	              choice_b: 'B',
	              choice_c: 'C',
	              choice_d: 'D'
	            };
	
	            if (choiceMap[rightChoice]) {
	              _this5.setState({ choice_name: choiceMap[rightChoice] });
	            }
	          });
	
	          if (offset === 0) {
	            _this5.setState({ previ_block: 'card hide_block' });
	          }
	          if (offset === allQuestions.length - 1) {
	            _this5.setState({ next_block: 'card hide_block' });
	          }
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapterbyID', {
	            token: _this5.state.token,
	            chapter_id: _this5.props.params.notesid
	          }).then(function (resp_chap) {
	            if (resp_chap.success && resp_chap.chapters && resp_chap.chapters.length > 0) {
	              _this5.setState({ chapter_name: resp_chap.chapters[0].chapter_name });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestions', {
	            token: _this5.state.token,
	            question_id: currentQuestion.id,
	            idname: _this5.state.idname
	          }).then(function (response) {
	            if (response.success) {
	              _this5.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: 'rgb(54, 141, 84)',
	                save_text: '' + _language2.default.LC().Question_Saved,
	                isFlashCardHidden: false
	              });
	            } else {
	              _this5.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: '',
	                save_text: _language2.default.LC().SAVE_QUESTION + ' ',
	                isFlashCardHidden: true
	              });
	            }
	          });
	
	          _this5.fetchRatingForCurrentQuestion(currentQuestion.id);
	        } else {
	          _this5.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	      });
	    }
	
	    /*
	    ----------------------------------------
	      on url change run this function
	    ---------------------------------------
	    */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          subscriptionstatus = _state2.subscriptionstatus,
	          level = _state2.level,
	          token = _state2.token,
	          stateIdname = _state2.idname;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val,
	        subscriptionstatus: subscriptionstatus,
	        level: level
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            result_block: 'card hide_block'
	          });
	
	          var foundIndex = parseInt(offset_val, 10);
	          if (isNaN(foundIndex) || foundIndex < 0 || foundIndex >= resp.questions.length) {
	            foundIndex = 0;
	          }
	          var _ques_res = resp.questions[foundIndex];
	
	          _this6.setState({ questions: _ques_res, offset: foundIndex }, function () {
	            var choiceMap = {
	              choice_a: 'A',
	              choice_b: 'B',
	              choice_c: 'C',
	              choice_d: 'D'
	            };
	
	            var rightChoice = _this6.state.questions.right_choice;
	            var choiceName = choiceMap[rightChoice] || '';
	
	            _this6.setState({ choice_name: choiceName });
	
	            var _getSelectedAndShowAn2 = _this6.getSelectedAndShowAnswer(_this6.state.questions, 'right_choice'),
	                selected = _getSelectedAndShowAn2.selected,
	                showAnswer = _getSelectedAndShowAn2.showAnswer,
	                timeDone = _getSelectedAndShowAn2.timeDone,
	                isRevisionMode = _getSelectedAndShowAn2.isRevisionMode;
	
	            _this6.setState({
	              choice: selected,
	              clicked: showAnswer,
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === _this6.state.questions.right_choice ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === _this6.state.questions.right_choice ? _messages.messages.CORRECT : _messages.messages.INCORRECT,
	              display_loader: 'hide_block',
	              timer_stop: !!selected,
	              timerstopbtn: !!selected ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause',
	              timerValue: isRevisionMode ? timeDone : 0
	            });
	
	            _this6.fetchRatingForCurrentQuestion(_ques_res.id);
	          });
	          var params = {
	            token: _this6.state.token,
	            question_id: _ques_res.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: 'rgb(54, 141, 84)',
	                save_text: '' + _language2.default.LC().Question_Saved,
	                isFlashCardHidden: false
	              });
	            } else {
	              _this6.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: '',
	                save_text: _language2.default.LC().SAVE_QUESTION + ' ',
	                isFlashCardHidden: true
	              });
	            }
	          });
	
	          var params = {
	            token: _this6.state.token,
	            question_id: _ques_res.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFrmratting', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ rated: true });
	              response.ratting.map(function (items) {
	                _this6.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	              });
	            }
	          });
	
	          var params = {
	            token: _this6.state.token,
	            idname: _this6.state.idname,
	            question_id: _ques_res.id
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this6.setState({ flash_form: 'col-sm-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this6._editFlash.bind(_this6, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this6._deleteFlash.bind(_this6, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this6.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this6.setState({ flash_form: 'col-sm-12 display_block' });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this6.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this6.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-sm-12 display_block'
	              });
	            }
	            return response;
	          });
	          _this6.setState({ records: '' });
	
	          _this6.fetchRatingForCurrentQuestion(_ques_res.id);
	        } else {
	          _this6.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this6.timer);
	        _this6.timer = setInterval(_this6.tick.bind(_this6), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    /*
	    ----------------------------------
	      Function to start or stop timer
	    ----------------------------------
	    */
	
	  }, {
	    key: 'timerFunct',
	    value: function timerFunct() {
	      if (this.state.timer_stop) {
	        this.initializeTimer();
	      } else {
	        if (this.timer) {
	          clearInterval(this.timer);
	        }
	        this.setState({
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(prevProps) {
	        var id, questionData, prevId;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                id = this.props.params.id;
	                questionData = this.state.questionData;
	                prevId = prevProps.params.id;
	
	                if (!(id !== prevId && questionData.length > 0)) {
	                  _context11.next = 6;
	                  break;
	                }
	
	                _context11.next = 6;
	                return this.initializeQuestionState(questionData);
	
	              case 6:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function componentDidUpdate(_x5) {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          isLoading = _state3.isLoading,
	          questionData = _state3.questionData,
	          currentIndex = _state3.currentIndex,
	          currentQuestion = _state3.currentQuestion,
	          showAnswer = _state3.showAnswer,
	          selectedChoice = _state3.selectedChoice,
	          isFlashCardHidden = _state3.isFlashCardHidden,
	          stopTimer = _state3.stopTimer,
	          showReportSection = _state3.showReportSection,
	          timerValue = _state3.timerValue,
	          questions = _state3.questions,
	          clicked = _state3.clicked,
	          choice = _state3.choice;
	
	
	      var timeDone = 0;
	      if (questions && questions.frm_question_stats && questions.frm_question_stats[0]) {
	        timeDone = parseInt(questions.frm_question_stats[0].time_done || 0, 10);
	      }
	
	      var data = '';
	      var forumData = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var retun_all_question = JSON.stringify(this.state.questions);
	      var selectedQuestion = JSON.parse(retun_all_question);
	
	      if (questionData !== '') {
	        forumData = '<div class="col-sm-12 no-cursor">\n        <div class="margin_bottom_40">\n          <div>\n            <div class="row">\n              <div class="col-sm-12">\n                <div class="row">\n                  <div class="col-sm-12 cursor-text">\n                    <div contentEditable=\'false\' class="margin_bottom_40 view_questionhtml bg_blue">\n                      ' + selectedQuestion.question + '\n                    </div>\n                  </div>\n                  <div class="col-sm-12" id="choice_a">\n                    <div class="answer_box_forum">\n                      <div class="answer_count">' + _language2.default.LC().A + '</div>\n                      <p class="ans_box_text">\n                        <span contentEditable=\'false\'>' + selectedQuestion.choice_a + '</span>\n                      </p>\n                    </div>\n                  </div>\n                  <div class="col-sm-12" id="choice_b">\n                    <div class="answer_box_forum">\n                      <div class="answer_count">' + _language2.default.LC().B + '</div>\n                      <p class="ans_box_text">\n                        <span contentEditable=\'false\'>' + selectedQuestion.choice_b + '</span>\n                      </p>\n                    </div>\n                  </div>\n                  <div class="col-sm-12" id="choice_c">\n                    <div class="answer_box_forum">\n                      <div class="answer_count">' + _language2.default.LC().C + '</div>\n                      <p class="ans_box_text">\n                        <span contentEditable=\'false\'>' + selectedQuestion.choice_c + '</span>\n                      </p>\n                    </div>\n                  </div>\n                  <div class="col-sm-12 margin_bottom_30" id="choice_d">\n                    <div class="answer_box_forum">\n                      <div class="answer_count">' + _language2.default.LC().D + '</div>\n                      <p class="ans_box_text">\n                        <span contentEditable=\'false\'>' + selectedQuestion.choice_d + '</span>\n                      </p>\n                    </div>\n                  </div>\n                  <div class="col-sm-12 cursor-text">\n                    <p contentEditable=\'false\' class=\'view_questionhtml\'>\n                      ' + _language2.default.LC().THE_CORRECT_ANSWER_IS + ' <b>' + this.state.choice_name + '</b>\n                    </p>\n                    <p contentEditable=\'false\' class=\'view_questionhtml\'>' + selectedQuestion.answer + '</p>\n                  </div>\n                  <div class="col-sm-12 margin_bottom_30">\n                    <div class="userQuestionDiv">\n                      <span class="questionColor cursor-text">*User Question:</span>\n                      <div class="forum-data-comment cursor-text">\n                        <h4>' + this.state.forumComment + '</h4>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>';
	
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                alt: '',
	                width: '30'
	              }),
	              selectedQuestion.name,
	              ' (',
	              _language2.default.LC().Q,
	              ' ',
	              selectedQuestion.id,
	              ')',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this.getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this.getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    _ViewQuestion2.default,
	                    Object.assign({}, selectedQuestion, this.props, {
	                      setAnswer: this.getAnswer,
	                      showAnswer: clicked,
	                      correctChoice: questions.right_choice,
	                      selectedChoice: choice
	                    }),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          clicked: this.state.clicked || !this.state.choice,
	                          _getResult: this._getResult,
	                          _saveQuestion: function _saveQuestion() {
	                            return _this7._saveQuestion(selectedQuestion);
	                          },
	                          _displayReportForm: function _displayReportForm() {
	                            return _this7._displayReportForm(selectedQuestion);
	                          },
	                          all_questions: selectedQuestion,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor,
	                          showResult: this.state.clicked || !this.state.choice
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'star_rating_wrap' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: ' margin_bottom_0 margin_right_10' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(_reactStarRatings2.default, {
	                              rating: this.state.rating,
	                              starRatedColor: 'rgb(255, 180, 0)',
	                              starEmptyColor: 'rgb(51, 51, 51)',
	                              starDimension: '20px',
	                              starHoverColor: 'rgb(255, 180, 0)',
	                              starSpacing: '2px',
	                              changeRating: this.onStarClick.bind(this, selectedQuestion),
	                              numberOfStars: 5,
	                              name: 'rate1'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(_Timer2.default, {
	                    getTimerValue: this.getTimerValue,
	                    stopTimer: this.state.stopTimer,
	                    shouldFetchFromServer: true,
	                    key: questions && questions.id,
	                    initialTime: this.state.timerValue
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().THE_CORRECT_ANSWER_IS,
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.choice_name,
	                  '.'
	                )
	              ),
	              (0, _function.renderHTMLContent)(selectedQuestion.answer, 'div')
	            )
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: selectedQuestion,
	            type: 'question',
	            isFlashCardHidden: this.state.isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'frm',
	            level: this.state.questions.level
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: this._reportQuestion.bind(this, selectedQuestion)
	                    },
	                    _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, selectedQuestion)
	                    },
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'no_data_bar card' },
	            'No Records Found'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUESTION_BANK
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getQuestions
	                },
	                ' ',
	                _language2.default.LC().CHANGE_QUESTIONS
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                ' ',
	                _language2.default.LC().CHANGE_READING
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Frmchapter;
	}(_react.Component);
	
	Frmchapter.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Frmchapter;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _UserAnsweredNotAnsweredStatus = __webpack_require__(137);
	
	var _UserAnsweredNotAnsweredStatus2 = _interopRequireDefault(_UserAnsweredNotAnsweredStatus);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var ViewFrmQues = function (_Component) {
	  _inherits(ViewFrmQues, _Component);
	
	  function ViewFrmQues(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewFrmQues);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (ViewFrmQues.__proto__ || Object.getPrototypeOf(ViewFrmQues)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/frm/readings/' + _this.props.params.chapter_no
	      });
	    };
	
	    _this._goToVideo = function () {
	      _this.context.router.push({
	        pathname: '/frm/videodisplay/' + _this.props.params.chapter_no + '/' + (_this.state.showFreePremium ? 0 : 1),
	        search: '?chapter_name=' + _this.props.params.reading
	      });
	      // }
	      // );
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, e) {
	        var questions, offset;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(item.chapter_id <= 4)) {
	                  _context.next = 5;
	                  break;
	                }
	
	                _context.next = 3;
	                return _this.setState({
	                  level: 1
	                });
	
	              case 3:
	                _context.next = 8;
	                break;
	
	              case 5:
	                if (!(item.chapter_id > 4)) {
	                  _context.next = 8;
	                  break;
	                }
	
	                _context.next = 8;
	                return _this.setState({
	                  level: 2
	                });
	
	              case 8:
	
	                // Find the offset (index) of the clicked question
	                questions = _this.state.questions;
	                offset = 0;
	
	                if (questions && questions.length > 0) {
	                  offset = questions.findIndex(function (q) {
	                    return String(q.id) === String(item.id);
	                  });
	                  if (offset < 0) offset = 0;
	                }
	
	                _this.context.router.push({
	                  pathname: '/frm/chapter/' + item.chapter_id + '/' + item.reading_id + '/' + item.id + '/' + _this.state.level + '/' + offset, // <-- add offset to the URL
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    reading: item.reading_id,
	                    chapter: item.chapter_id,
	                    offset: offset
	                  }
	                });
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      SubsciptionMessage: _alertMessage2.default.messageContent_frm,
	      questions: [],
	      token: '',
	      idname: '',
	      readingName: _this.props.params.reading,
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      chapters: [],
	      answered_state: [],
	      subscriptionstatus: _this.props.params.subscriptionstatus,
	      level: _this.props.params.level,
	      selectedmenu: 'frm',
	      videoPartLevel: _this.props.params.level
	    };
	    //  this.getAnswered = this.getAnswered.bind(this);
	    return _this;
	  }
	
	  _createClass(ViewFrmQues, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var storage_session, data, getProfileInfo;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                // var data = { token: this.state.token, idname: this.state.idname };
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.reading.chapter_no
	                };
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context5.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', getProfileInfo).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (resp.profileInfo) {
	                              _this3.setState({
	                                isVideo: resp.profileInfo.isVideo
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this3);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	                _context5.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getfrmVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, chapters: resp.frmvideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 9:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context5.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var exam_selected, subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            exam_selected = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : resp.profileInfo.exam_selected;
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                            _this3.setState({ subscription_details: subscription_details });
	
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 14;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 8;
	                              break;
	                            }
	
	                            _this3.setState({ showFreePremium: true });
	                            _context4.next = 12;
	                            break;
	
	                          case 8:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context4.next = 12;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 11;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context3.next = 7;
	                                        return _FrmSubscription4.default.checkFrmVideosSubscription(_this3.state.videoPartLevel, exam_data, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context3.sent;
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context3.next = 12;
	                                        break;
	
	                                      case 11:
	                                        console.log('fail');
	
	                                      case 12:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this3);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	
	                          case 12:
	                            _context4.next = 22;
	                            break;
	
	                          case 14:
	                            if (!(resp.profileInfo.exam_selected == '')) {
	                              _context4.next = 18;
	                              break;
	                            }
	
	                            _this3.setState({ showFreePremium: true });
	                            _context4.next = 22;
	                            break;
	
	                          case 18:
	                            data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context4.next = 22;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(_this3.state.videoPartLevel, exam_data);
	                                if (isInArray_var) {
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                console.log('fail');
	                              }
	                            });
	
	                          case 22:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit,
	                  subscriptionstatus: this.state.subscriptionstatus
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestions', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, questions: resp.questions });
	                    //this.setState({answered: resp.answered});
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 14:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters = this.state.chapters;
	
	      var filterVideoByChapter = chapters.filter(function (item) {
	        return item.chapter_no === parseInt(_this4.props.params.chapter);
	      })[0];
	      var videosCount = filterVideoByChapter && filterVideoByChapter.Countvideos ? filterVideoByChapter.Countvideos : 0;
	      var questions = this.state.questions;
	      var data = '';
	
	      // alert(this.state.answered);
	      if (this.state.questions.length) {
	        //alert(this.state.answered[3]);
	        data = questions.map(function (item, index) {
	          return (
	            // alert(this.state.answered[item.id])
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-lg-4', key: index },
	              _react2.default.createElement(
	                'div',
	                { onClick: _this4._beginChapter.bind(_this4, item), className: 'border_box' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'border_box_title d-flex' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                    className: 'margin_bottom_20',
	                    width: '30',
	                    alt: ''
	                  }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'ml-1' },
	                    item.name,
	                    ' (',
	                    _language2.default.LC().Q,
	                    ' ',
	                    item.id,
	                    ')'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'padding_box' },
	                  item.question ? _react2.default.createElement(
	                    'div',
	                    { contentEditable: 'false', className: 'view_question_height view_questionhtml margin_bottom_40 frm_question_height' },
	                    (0, _function.renderHTMLContent)(item.question.substring(0, item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 450) + '...')
	                  ) : null,
	                  _react2.default.createElement(_UserAnsweredNotAnsweredStatus2.default, {
	                    itemid: item.id,
	                    chapter_id: _this4.props.params.chapter_no,
	                    reading_id: _this4.props.params.id,
	                    idname: _this4.state.idname,
	                    token: _this4.state.token,
	                    answered_state: index,
	                    examRoute: 'frm_question_bank'
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        this.props.params.chapter_no <= 4 ? _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.readingName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.isVideo === true && videosCount > 0 ? 'col-md-2 text-md-right margin_bottom_20' : 'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          ),
	          this.state.isVideo === true && videosCount > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-2 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._goToVideo
	              },
	              ' ',
	              _language2.default.LC().GO_TO_VIDEOS
	            )
	          ) : null
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.readingName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.isVideo === true && videosCount > 0 ? 'col-md-2 text-md-right margin_bottom_20' : 'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          ),
	          this.state.isVideo === true && videosCount > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-2 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._goToVideo
	              },
	              ' ',
	              _language2.default.LC().GO_TO_VIDEOS
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'border_box', onClick: this._getSubscribe },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  ' ',
	                  _language2.default.LC().SUBSCRIBE_FOR_4000_PRACTICE_QUESTIONS,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                (0, _function.renderHTMLContent)(this.state.SubsciptionMessage, "div", "view_question_height view_questionhtml modal-info-view-for-plan frm_question_height", { contentEditable: 'false' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscibe__btn text-center' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary pointer_class',
	                    onClick: this._getSubscribe
	                  },
	                  _language2.default.LC().SUBSCRIBE
	                )
	              )
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ViewFrmQues;
	}(_react.Component);
	
	ViewFrmQues.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = ViewFrmQues;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(79);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable */
	var i = '';
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.deleteFlashCard = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(type, id) {
	        var _this$state, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, id_name = _this$state.idname, token = _this$state.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: '',
	                  exam: 'frm',
	                  level: '',
	                  item_id: id
	                };
	                _context.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onContactSubmit = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(event) {
	        var _this$state2, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context3.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context3.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context3.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state2 = _this.state, idname = _this$state2.idname, token = _this$state2.token, contactComment = _this$state2.contactComment, contactSubject = _this$state2.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context3.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context2.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x4) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.onContactSubmit1 = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(event) {
	        var _this$state3, idname, token, contactComment1, contactSubject1, data;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject1 === '' && _this.state.contactSubject1.length < 1)) {
	                  _context5.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage1: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context5.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment1 === '' && _this.state.contactComment1.length < 1)) {
	                  _context5.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage1: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context5.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state3 = _this.state, idname = _this$state3.idname, token = _this$state3.token, contactComment1 = _this$state3.contactComment1, contactSubject1 = _this$state3.contactSubject1;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment1,
	                  contactSubject: contactSubject1
	                };
	                _context5.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert1: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context4.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose1 = function (e) {
	      _this.setState({
	        contactID1: '',
	        contactType1: '',
	        contactIndex1: '',
	        contactSubject1: '',
	        contactComment1: '',
	        contactStatus1: false,
	        successAlert1: false,
	        reportAnswerStatus1: !_this.state.reportAnswerStatus1,
	        reportAnswerId1: '',
	        type1: ''
	      });
	    };
	
	    _this.toggleDone = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var _this$state4, idname, token, frm1_flash_card_data, item_status, question_id, item_id, video_id, data, datas, data1, data2, data3, data4, data5, data6, data7;
	
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              _this$state4 = _this.state, idname = _this$state4.idname, token = _this$state4.token, frm1_flash_card_data = _this$state4.frm1_flash_card_data, item_status = _this$state4.item_status;
	              question_id = frm1_flash_card_data.question_id, item_id = frm1_flash_card_data.item_id, video_id = frm1_flash_card_data.video_id;
	              // eslint-disable-next-line
	
	              if (!(_this.state.item_status === 'Notesflashcard')) {
	                _context16.next = 6;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteFlashCardD', data).then(function () {
	                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context6.next = 5;
	                            break;
	                          }
	
	                          _context6.next = 3;
	                          return _this.getNotesSaved();
	
	                        case 3:
	                          _context6.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref7.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 6:
	              if (!(_this.state.item_status === 'flashcard')) {
	                _context16.next = 10;
	                break;
	              }
	
	              datas = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 10;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteFlashCard', datas).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context7.next = 5;
	                            break;
	                          }
	
	                          _context7.next = 3;
	                          return _this.getQuestionSaved();
	
	                        case 3:
	                          _context7.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref8.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 10:
	              if (!(item_status === 'savedquestion')) {
	                _context16.next = 16;
	                break;
	              }
	
	              data1 = {
	                token: token,
	                idname: idname,
	                save_question: frm1_flash_card_data
	              };
	              _context16.next = 14;
	              return _this.deleteFlashCard('question', question_id ? question_id : item_id);
	
	            case 14:
	              _context16.next = 16;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteSavequestion', data1).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context8.next = 5;
	                            break;
	                          }
	
	                          _context8.next = 3;
	                          return _this.getQuestionSaved();
	
	                        case 3:
	                          _context8.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref9.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 16:
	              if (!(item_status === 'savednotes')) {
	                _context16.next = 22;
	                break;
	              }
	
	              data2 = {
	                token: token,
	                idname: idname,
	                save_question: frm1_flash_card_data
	              };
	              _context16.next = 20;
	              return _this.deleteFlashCard('notes', question_id ? question_id : item_id);
	
	            case 20:
	              _context16.next = 22;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteSaveNotes', data2).then(function () {
	                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context9.next = 5;
	                            break;
	                          }
	
	                          _context9.next = 3;
	                          return _this.getNotesSaved();
	
	                        case 3:
	                          _context9.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                }));
	
	                return function (_x10) {
	                  return _ref10.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 22:
	              if (!(item_status === 'savedvideo')) {
	                _context16.next = 28;
	                break;
	              }
	
	              data3 = {
	                token: token,
	                idname: idname,
	                save_question: frm1_flash_card_data
	              };
	              _context16.next = 26;
	              return _this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	            case 26:
	              _context16.next = 28;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteSaveVideo', data3).then(function () {
	                var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                  return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                      switch (_context10.prev = _context10.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context10.next = 5;
	                            break;
	                          }
	
	                          _context10.next = 3;
	                          return _this.getVideosSaved();
	
	                        case 3:
	                          _context10.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context10.stop();
	                      }
	                    }
	                  }, _callee10, _this2);
	                }));
	
	                return function (_x11) {
	                  return _ref11.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 28:
	              if (!(_this.state.item_status === 'Videoflashcard')) {
	                _context16.next = 32;
	                break;
	              }
	
	              data4 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 32;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardVideoFlashCard', data4).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context11.next = 5;
	                            break;
	                          }
	
	                          _context11.next = 3;
	                          return _this.getVideosSaved();
	
	                        case 3:
	                          _context11.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x12) {
	                  return _ref12.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 32:
	              if (!(_this.state.item_status === 'Reportsquestion')) {
	                _context16.next = 36;
	                break;
	              }
	
	              data5 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 36;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardQuestionReports', data5).then(function () {
	                var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(resp) {
	                  return _regenerator2.default.wrap(function _callee12$(_context12) {
	                    while (1) {
	                      switch (_context12.prev = _context12.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context12.next = 5;
	                            break;
	                          }
	
	                          _context12.next = 3;
	                          return _this.getQuestionReports();
	
	                        case 3:
	                          _context12.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context12.stop();
	                      }
	                    }
	                  }, _callee12, _this2);
	                }));
	
	                return function (_x13) {
	                  return _ref13.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 36:
	              if (!(_this.state.item_status == 'CBTreportsquestion')) {
	                _context16.next = 40;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 40;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/deleteReport', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context13.next = 5;
	                            break;
	                          }
	
	                          _context13.next = 3;
	                          return _this.getCBTQestionReports();
	
	                        case 3:
	                          _context13.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x14) {
	                  return _ref14.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 40:
	              if (!(_this.state.item_status === 'Reportsnotes')) {
	                _context16.next = 44;
	                break;
	              }
	
	              data6 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 44;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteDashboardNotesReports', data6).then(function () {
	                var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(resp) {
	                  return _regenerator2.default.wrap(function _callee14$(_context14) {
	                    while (1) {
	                      switch (_context14.prev = _context14.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context14.next = 5;
	                            break;
	                          }
	
	                          _context14.next = 3;
	                          return _this.getNotesReports();
	
	                        case 3:
	                          _context14.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context14.stop();
	                      }
	                    }
	                  }, _callee14, _this2);
	                }));
	
	                return function (_x15) {
	                  return _ref15.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 44:
	              if (!(_this.state.item_status === 'Reportsvideos')) {
	                _context16.next = 48;
	                break;
	              }
	
	              data7 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm1_flash_card_data
	              };
	              _context16.next = 48;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardVideoReports', data7).then(function () {
	                var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(resp) {
	                  return _regenerator2.default.wrap(function _callee15$(_context15) {
	                    while (1) {
	                      switch (_context15.prev = _context15.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context15.next = 5;
	                            break;
	                          }
	
	                          _context15.next = 3;
	                          return _this.getVideoReports();
	
	                        case 3:
	                          _context15.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context15.stop();
	                      }
	                    }
	                  }, _callee15, _this2);
	                }));
	
	                return function (_x16) {
	                  return _ref16.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 48:
	
	              _this.setState({
	                alert_status: false
	              });
	
	            case 49:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	    _this.toggleDone1 = _asyncToGenerator(_regenerator2.default.mark(function _callee27() {
	      var _this$state5, idname, token, frm2_flash_card_data, item_status1, question_id, item_id, video_id, data, data1, data6, data7, data2, data3, data4, dataa, data5, data8;
	
	      return _regenerator2.default.wrap(function _callee27$(_context27) {
	        while (1) {
	          switch (_context27.prev = _context27.next) {
	            case 0:
	              _this$state5 = _this.state, idname = _this$state5.idname, token = _this$state5.token, frm2_flash_card_data = _this$state5.frm2_flash_card_data, item_status1 = _this$state5.item_status1;
	              question_id = frm2_flash_card_data.question_id, item_id = frm2_flash_card_data.item_id, video_id = frm2_flash_card_data.video_id;
	
	              if (!(_this.state.item_status1 === 'Notesflashcard1')) {
	                _context27.next = 6;
	                break;
	              }
	
	              data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.frm2_flash_card_data
	              };
	              _context27.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteFlashCardD', data).then(function () {
	                var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(resp) {
	                  return _regenerator2.default.wrap(function _callee17$(_context17) {
	                    while (1) {
	                      switch (_context17.prev = _context17.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context17.next = 5;
	                            break;
	                          }
	
	                          _context17.next = 3;
	                          return _this.getNotesSaved1();
	
	                        case 3:
	                          _context17.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context17.stop();
	                      }
	                    }
	                  }, _callee17, _this2);
	                }));
	
	                return function (_x17) {
	                  return _ref18.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 6:
	              if (!(_this.state.item_status1 === 'flashcard1')) {
	                _context27.next = 10;
	                break;
	              }
	
	              data1 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.frm2_flash_card_data
	              };
	              _context27.next = 10;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteFlashCard', data1).then(function () {
	                var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(resp) {
	                  return _regenerator2.default.wrap(function _callee18$(_context18) {
	                    while (1) {
	                      switch (_context18.prev = _context18.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context18.next = 5;
	                            break;
	                          }
	
	                          _context18.next = 3;
	                          return _this.getQuestionSaved1();
	
	                        case 3:
	                          _context18.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context18.stop();
	                      }
	                    }
	                  }, _callee18, _this2);
	                }));
	
	                return function (_x18) {
	                  return _ref19.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 10:
	              if (!(_this.state.item_status1 === 'Videoflashcard1')) {
	                _context27.next = 14;
	                break;
	              }
	
	              data6 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                flash_card: _this.state.frm2_flash_card_data
	              };
	              _context27.next = 14;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardVideoFlashCard', data6).then(function () {
	                var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(resp) {
	                  return _regenerator2.default.wrap(function _callee19$(_context19) {
	                    while (1) {
	                      switch (_context19.prev = _context19.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context19.next = 5;
	                            break;
	                          }
	
	                          _context19.next = 3;
	                          return _this.getVideosSaved1();
	
	                        case 3:
	                          _context19.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context19.stop();
	                      }
	                    }
	                  }, _callee19, _this2);
	                }));
	
	                return function (_x19) {
	                  return _ref20.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 14:
	              if (!(item_status1 === 'savedvideo1')) {
	                _context27.next = 20;
	                break;
	              }
	
	              data7 = {
	                token: token,
	                idname: idname,
	                save_question: frm2_flash_card_data
	              };
	              _context27.next = 18;
	              return _this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	            case 18:
	              _context27.next = 20;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteSaveVideo', data7).then(function () {
	                var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(resp) {
	                  return _regenerator2.default.wrap(function _callee20$(_context20) {
	                    while (1) {
	                      switch (_context20.prev = _context20.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context20.next = 5;
	                            break;
	                          }
	
	                          _context20.next = 3;
	                          return _this.getVideosSaved1();
	
	                        case 3:
	                          _context20.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context20.stop();
	                      }
	                    }
	                  }, _callee20, _this2);
	                }));
	
	                return function (_x20) {
	                  return _ref21.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 20:
	              if (!(item_status1 === 'savedquestion1')) {
	                _context27.next = 26;
	                break;
	              }
	
	              data2 = {
	                token: token,
	                idname: idname,
	                save_question: frm2_flash_card_data
	              };
	              _context27.next = 24;
	              return _this.deleteFlashCard('question', question_id ? question_id : item_id);
	
	            case 24:
	              _context27.next = 26;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteSavequestion', data2).then(function () {
	                var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(resp) {
	                  return _regenerator2.default.wrap(function _callee21$(_context21) {
	                    while (1) {
	                      switch (_context21.prev = _context21.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context21.next = 5;
	                            break;
	                          }
	
	                          _context21.next = 3;
	                          return _this.getQuestionSaved1();
	
	                        case 3:
	                          _context21.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context21.stop();
	                      }
	                    }
	                  }, _callee21, _this2);
	                }));
	
	                return function (_x21) {
	                  return _ref22.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 26:
	              if (!(item_status1 === 'savednotes1')) {
	                _context27.next = 32;
	                break;
	              }
	
	              data3 = {
	                token: token,
	                idname: idname,
	                save_question: frm2_flash_card_data
	              };
	              _context27.next = 30;
	              return _this.deleteFlashCard('notes', question_id ? question_id : item_id);
	
	            case 30:
	              _context27.next = 32;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteSaveNotes', data3).then(function () {
	                var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(resp) {
	                  return _regenerator2.default.wrap(function _callee22$(_context22) {
	                    while (1) {
	                      switch (_context22.prev = _context22.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context22.next = 5;
	                            break;
	                          }
	
	                          _context22.next = 3;
	                          return _this.getNotesSaved1();
	
	                        case 3:
	                          _context22.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context22.stop();
	                      }
	                    }
	                  }, _callee22, _this2);
	                }));
	
	                return function (_x22) {
	                  return _ref23.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 32:
	              if (!(_this.state.item_status1 === 'Reportsquestion1')) {
	                _context27.next = 36;
	                break;
	              }
	
	              data4 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm2_flash_card_data
	              };
	              _context27.next = 36;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardQuestionReports', data4).then(function () {
	                var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(resp) {
	                  return _regenerator2.default.wrap(function _callee23$(_context23) {
	                    while (1) {
	                      switch (_context23.prev = _context23.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context23.next = 5;
	                            break;
	                          }
	
	                          _context23.next = 3;
	                          return _this.getQuestionReports1();
	
	                        case 3:
	                          _context23.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context23.stop();
	                      }
	                    }
	                  }, _callee23, _this2);
	                }));
	
	                return function (_x23) {
	                  return _ref24.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 36:
	              if (!(_this.state.item_status1 == 'CBTreportsquestion1')) {
	                _context27.next = 40;
	                break;
	              }
	
	              dataa = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm2_flash_card_data
	              };
	              _context27.next = 40;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/deleteReport', dataa).then(function () {
	                var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(resp) {
	                  return _regenerator2.default.wrap(function _callee24$(_context24) {
	                    while (1) {
	                      switch (_context24.prev = _context24.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context24.next = 5;
	                            break;
	                          }
	
	                          _context24.next = 3;
	                          return _this.getCBTQestionReports1();
	
	                        case 3:
	                          _context24.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context24.stop();
	                      }
	                    }
	                  }, _callee24, _this2);
	                }));
	
	                return function (_x24) {
	                  return _ref25.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 40:
	              if (_this.state.item_status1 === 'Reportsnotes1') {
	                data5 = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reports: _this.state.frm2_flash_card_data
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/deleteDashboardNotesReports', data5).then(function () {
	                  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(resp) {
	                    return _regenerator2.default.wrap(function _callee25$(_context25) {
	                      while (1) {
	                        switch (_context25.prev = _context25.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context25.next = 5;
	                              break;
	                            }
	
	                            _context25.next = 3;
	                            return _this.getNotesReports1();
	
	                          case 3:
	                            _context25.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context25.stop();
	                        }
	                      }
	                    }, _callee25, _this2);
	                  }));
	
	                  return function (_x25) {
	                    return _ref26.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	              }
	
	              if (!(_this.state.item_status1 === 'Reportsvideos1')) {
	                _context27.next = 45;
	                break;
	              }
	
	              data8 = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reports: _this.state.frm2_flash_card_data
	              };
	              _context27.next = 45;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/deleteDashboardVideoReports', data8).then(function () {
	                var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(resp) {
	                  return _regenerator2.default.wrap(function _callee26$(_context26) {
	                    while (1) {
	                      switch (_context26.prev = _context26.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context26.next = 5;
	                            break;
	                          }
	
	                          _context26.next = 3;
	                          return _this.getVideoReports1();
	
	                        case 3:
	                          _context26.next = 5;
	                          break;
	
	                        case 5:
	                        case 'end':
	                          return _context26.stop();
	                      }
	                    }
	                  }, _callee26, _this2);
	                }));
	
	                return function (_x26) {
	                  return _ref27.apply(this, arguments);
	                };
	              }()
	              //console.log('error');
	              );
	
	            case 45:
	              _this.setState({
	                alert_status1: false
	              });
	
	            case 46:
	            case 'end':
	              return _context27.stop();
	          }
	        }
	      }, _callee27, _this2);
	    }));
	
	    _this._viewAllQuestion = function () {
	      _this.context.router.push({
	        pathname: '/frm/viewallquestions/'
	      });
	    };
	
	    _this._viewAllQuestion1 = function () {
	      // console.log('_viewAllQuestion Working')
	      _this.context.router.push({
	        pathname: '/frm/2/viewallquestions/'
	      });
	    };
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteFlashcard1 = function (items, e) {
	      // console.log("_deleteFlashcard1",items);
	
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('flashcard1');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteVideoFlashcard1 = function (items, e) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('Videoflashcard1');
	    };
	
	    _this._deleteNotesFlashcard1 = function (items, e) {
	      // console.log("_deleteNotesFlashcard1",items);
	
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('Notesflashcard1');
	    };
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      // console.log("_deleteNotesFlashcard",items);
	
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._deleteSavequestion = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('' + (items.topic_name ? 'savedquestion' : 'flashcard'));
	    };
	
	    _this._deleteSavequestion1 = function (items, e) {
	      // console.log("_deleteSavequestion1",items);
	
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1(items.topic_name ? 'savedquestion1' : 'flashcard1');
	    };
	
	    _this._deleteSavedNotes = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert(items.topic_name ? 'savednotes' : 'Notesflashcard');
	    };
	
	    _this._deleteSavedNotes1 = function (items, e) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1(items.topic_name ? 'savednotes1' : 'Notesflashcard1');
	    };
	
	    _this._deletesavedvideo = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert(items.topic_name ? 'savedvideo' : 'Videoflashcard');
	    };
	
	    _this._deletesavedvideo1 = function (items, e) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1(items.topic_name ? 'savedvideo1' : 'Videoflashcard1');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._deleteReportsquestino1 = function (items, e) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('Reportsquestion1');
	    };
	
	    _this._deleteCBTReportsquestino = function (items) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('CBTreportsquestion');
	    };
	
	    _this._deleteCBTReportsquestino1 = function (items) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('CBTreportsquestion1');
	    };
	
	    _this._deleteReportsNotes = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('Reportsnotes');
	    };
	
	    _this._deleteReportsNotes1 = function (items, e) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('Reportsnotes1');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ frm1_flash_card_data: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._deleteReportsVideo1 = function (items, e) {
	      _this.setState({ frm2_flash_card_data: items });
	      _this.toggleAlert1('Reportsvideos1');
	    };
	
	    _this._getall = function () {
	      // eslint-disable-next-line
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: '' + _language2.default.LC().Hide_details });
	      }
	      // eslint-disable-next-line
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({
	          more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS
	        });
	      }
	    };
	
	    _this._beginNotes = function () {
	      var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(reading, e) {
	        var reading_id, chapter_id, data;
	        return _regenerator2.default.wrap(function _callee28$(_context28) {
	          while (1) {
	            switch (_context28.prev = _context28.next) {
	              case 0:
	                // console.log(reading)
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                // console.log(data)
	
	                _context28.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    // console.log(resp.notes)
	                    chapter_id = resp.notes[0].chapter_id;
	                    reading_id = resp.notes[0].reading_id;
	                    // console.log(chapter_id)
	                    // console.log(reading_id)
	                    _this.context.router.push({
	                      pathname: '/frm/beginnotes/' + chapter_id + '/' + reading_id + '/' + reading.question_id + '/' + 0,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        reading: reading_id,
	                        chapter: chapter_id,
	                        offset: 0
	                      }
	                    });
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context28.stop();
	            }
	          }
	        }, _callee28, _this2);
	      }));
	
	      return function (_x27, _x28) {
	        return _ref28.apply(this, arguments);
	      };
	    }();
	
	    _this._beginNotes1 = function () {
	      var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(reading, e) {
	        var reading_id, chapter_id, data;
	        return _regenerator2.default.wrap(function _callee29$(_context29) {
	          while (1) {
	            switch (_context29.prev = _context29.next) {
	              case 0:
	                // console.log(reading)
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                // console.log(data)
	
	                _context29.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    // console.log(resp.notes)
	                    chapter_id = resp.notes[0].chapter_id;
	                    reading_id = resp.notes[0].reading_id;
	                    // console.log(chapter_id)
	                    // console.log(reading_id)
	                    _this.context.router.push({
	                      pathname: '/frm/beginnotes/' + chapter_id + '/' + reading_id + '/' + reading.question_id + '/' + 0,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        reading: reading_id,
	                        chapter: chapter_id,
	                        offset: 0
	                      }
	                    });
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context29.stop();
	            }
	          }
	        }, _callee29, _this2);
	      }));
	
	      return function (_x29, _x30) {
	        return _ref29.apply(this, arguments);
	      };
	    }();
	
	    _this.beginVideos = function () {
	      var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(reading, level) {
	        var _this$state6, token, idname, showCapsules, showFreePremium, payload, response, video, isMock, playlistPath;
	
	        return _regenerator2.default.wrap(function _callee30$(_context30) {
	          while (1) {
	            switch (_context30.prev = _context30.next) {
	              case 0:
	                _this$state6 = _this.state, token = _this$state6.token, idname = _this$state6.idname, showCapsules = _this$state6.showCapsules, showFreePremium = _this$state6.showFreePremium;
	                payload = {
	                  token: token,
	                  idname: idname,
	                  id: reading.video_id
	                };
	                _context30.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getVideoByID', payload);
	
	              case 4:
	                response = _context30.sent;
	
	
	                if (response.success) {
	                  video = response.video;
	                  isMock = !!video.mock_id;
	                  playlistPath = isMock ? _AppRoutes2.default.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':level', level).replace(':mockId', video.mock_id).replace(':id', video.id) : _AppRoutes2.default.FRM_V2_VIDEOS_PLAYLIST.replace(':level', level).replace(':chapterId', video.chapter_id).replace(':id', video.id);
	
	
	                  _this.context.router.push({
	                    pathname: playlistPath,
	                    search: '?showCapsules=' + showCapsules + '&level=' + level
	                  });
	                }
	
	              case 6:
	              case 'end':
	                return _context30.stop();
	            }
	          }
	        }, _callee30, _this2);
	      }));
	
	      return function (_x31, _x32) {
	        return _ref30.apply(this, arguments);
	      };
	    }();
	
	    _this.FRM1 = _asyncToGenerator(_regenerator2.default.mark(function _callee31() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee31$(_context31) {
	        while (1) {
	          switch (_context31.prev = _context31.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({ idname: storage_session['idname'] });
	              _this.setState({ token: storage_session['token'] });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 1
	              };
	              _context31.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ ValidToken: true });
	                } else {
	                  _this.setState({ ValidToken: false });
	                }
	              });
	
	            case 6:
	              _context31.next = 8;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapters', data).then(function (resp) {
	                if (resp.success) {
	                  var chapters_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.chapters.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.chapters[i].level == 1) {
	                      chapters_1_arr[first_incr] = resp.chapters[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({
	                    chapters: chapters_1_arr,
	                    bar_chapter: chapters_1_arr
	                  });
	                  // this.setState({progress_bar_zero:chapters_1_arr});
	                } else {
	                    //console.log(resp.success + '------------failure');
	                  }
	              });
	
	            case 8:
	              _context31.next = 10;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressbar', data).then(function (resp) {
	                if (resp.success) {
	                  var dataString = JSON.stringify(resp.chapters);
	                  var dataReason = JSON.parse(dataString);
	
	                  var final_array_main = [];
	
	                  for (i = 0; i < dataReason.length; i++) {
	                    var right_answered = dataReason[i].answered_count;
	                    //var total_question=dataReason[i].question_stat_count;
	                    var total_question = dataReason[i].attempted_count;
	
	                    var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                    if (user_graph_val === 'NaN') {
	                      final_array_main.push('0.0');
	                    } else {
	                      final_array_main.push(user_graph_val);
	                    }
	
	                    //console.log(final_array_main+'----fdg-------');
	                  }
	                  _this.setState({ bar_main_user: final_array_main });
	                  //console.log('***********'+this.state.bar_main_user+'++++++++++++');
	                } else {
	                    //console.log(resp.success + '------------failure');
	                  }
	              });
	
	            case 10:
	              _this.setState({ display_main_loader: 'show_block' });
	
	              _context31.next = 13;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(function (resp) {
	                if (resp.success) {
	                  var dataString = JSON.stringify(resp.chaptersclass);
	                  var dataReason = JSON.parse(dataString);
	
	                  var final_array_main = [];
	
	                  for (i = 0; i < dataReason.length; i++) {
	                    var right_answered = dataReason[i].answered_count;
	                    var total_question = dataReason[i].attempted_count;
	
	                    var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                    if (user_graph_val === 'NaN') {
	                      final_array_main.push('0.0');
	                    } else {
	                      final_array_main.push(user_graph_val);
	                    }
	                  }
	                  _this.setState({ bar_main_class: final_array_main });
	                  //setTimeout(this.setState({display_loader: 'hide_block'}), 5000);
	                  _this.setState({ display_main_loader: 'hide_block' });
	                  //console.log('***********'+this.state.bar_main_class+'++++++++++++');
	                } else {
	                  console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 13:
	              _context31.next = 15;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(function (resp) {
	                if (resp.success) {
	                  var chapters_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.progressbarzero_data.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.progressbarzero_data[i].level == 1) {
	                      chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({ progress_bar_zero: chapters_1_arr, qpLoader: false });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 15:
	              _context31.next = 17;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(function (resp) {
	                if (resp.success) {
	                  var notes_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.progressbar_data.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.progressbar_data[i].level == 1) {
	                      notes_1_arr[first_incr] = resp.progressbar_data[i];
	                      first_incr++;
	                    }
	                  }
	
	                  _this.setState({ progress_bar: notes_1_arr, npLoader: false });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 17:
	              _context31.next = 19;
	              return _this.getQuestionFlashcards();
	
	            case 19:
	              _context31.next = 21;
	              return _this.getNotesFlashcards();
	
	            case 21:
	              _context31.next = 23;
	              return _this.getVideoFlashcards();
	
	            case 23:
	              _context31.next = 25;
	              return _this.getQuestionSaved();
	
	            case 25:
	              _context31.next = 27;
	              return _this.getNotesSaved();
	
	            case 27:
	              _context31.next = 29;
	              return _this.getVideosSaved();
	
	            case 29:
	              _context31.next = 31;
	              return _this.getCBTQestionReports();
	
	            case 31:
	              _context31.next = 33;
	              return _this.getQuestionReports();
	
	            case 33:
	              _context31.next = 35;
	              return _this.getNotesReports();
	
	            case 35:
	              _context31.next = 37;
	              return _this.getVideoReports();
	
	            case 37:
	            case 'end':
	              return _context31.stop();
	          }
	        }
	      }, _callee31, _this2);
	    }));
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee33() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee33$(_context33) {
	        while (1) {
	          switch (_context33.prev = _context33.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context33.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(resp) {
	                  var reports_arr, first_incr, i;
	                  return _regenerator2.default.wrap(function _callee32$(_context32) {
	                    while (1) {
	                      switch (_context32.prev = _context32.next) {
	                        case 0:
	                          if (resp.success) {
	                            reports_arr = [];
	                            first_incr = 0;
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].chapter_id <= 4) {
	                                reports_arr[first_incr] = resp.questions[i];
	                                first_incr++;
	                              }
	                            }
	                            _this.setState({ reportquestion: reports_arr });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context32.stop();
	                      }
	                    }
	                  }, _callee32, _this2);
	                }));
	
	                return function (_x33) {
	                  return _ref33.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context33.stop();
	          }
	        }
	      }, _callee33, _this2);
	    }));
	    _this.getCBTQestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee35() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee35$(_context35) {
	        while (1) {
	          switch (_context35.prev = _context35.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 1
	              };
	              _context35.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getreportedQuestion', data).then(function () {
	                var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(resp) {
	                  return _regenerator2.default.wrap(function _callee34$(_context34) {
	                    while (1) {
	                      switch (_context34.prev = _context34.next) {
	                        case 0:
	                          //console.log('344444444444', resp);
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestionCBT: resp.questions,
	                              reportLoader: false
	                            });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context34.stop();
	                      }
	                    }
	                  }, _callee34, _this2);
	                }));
	
	                return function (_x34) {
	                  return _ref35.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context35.stop();
	          }
	        }
	      }, _callee35, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee36() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee36$(_context36) {
	        while (1) {
	          switch (_context36.prev = _context36.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context36.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  var flash_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.flash_report.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.flash_report[i].level == 1) {
	                      flash_arr[first_incr] = resp.flash_report[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({ flashreport: flash_arr, flashLoader: false });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context36.stop();
	          }
	        }
	      }, _callee36, _this2);
	    }));
	    _this.getQuestionSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee37() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee37$(_context37) {
	        while (1) {
	          switch (_context37.prev = _context37.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context37.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  var fav_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.questions.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.questions[i].level == 1) {
	                      fav_arr[first_incr] = resp.questions[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({ savedquestion: fav_arr, savedLoader: false });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context37.stop();
	          }
	        }
	      }, _callee37, _this2);
	    }));
	    _this.getNotesFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee39() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee39$(_context39) {
	        while (1) {
	          switch (_context39.prev = _context39.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context39.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFlashcardsnotesbyuseridD1', data).then(function () {
	                var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(resp) {
	                  var fav_arr, first_incr, i;
	                  return _regenerator2.default.wrap(function _callee38$(_context38) {
	                    while (1) {
	                      switch (_context38.prev = _context38.next) {
	                        case 0:
	                          if (resp.success) {
	                            fav_arr = [];
	                            first_incr = 0;
	
	                            for (i = 0; i < resp.flash_cards.length; i++) {
	                              if (resp.flash_cards.length > 0) {
	                                fav_arr[first_incr] = resp.flash_cards[i];
	                                first_incr++;
	                              }
	                            }
	                            _this.setState({ notesFlashReport: fav_arr });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context38.stop();
	                      }
	                    }
	                  }, _callee38, _this2);
	                }));
	
	                return function (_x35) {
	                  return _ref39.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context39.stop();
	          }
	        }
	      }, _callee39, _this2);
	    }));
	    _this.getNotesReports = _asyncToGenerator(_regenerator2.default.mark(function _callee41() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee41$(_context41) {
	        while (1) {
	          switch (_context41.prev = _context41.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context41.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getReportsNotesbyuserid1', data).then(function () {
	                var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(resp) {
	                  var fav_arr, first_incr, i;
	                  return _regenerator2.default.wrap(function _callee40$(_context40) {
	                    while (1) {
	                      switch (_context40.prev = _context40.next) {
	                        case 0:
	                          if (resp.success) {
	                            fav_arr = [];
	                            first_incr = 0;
	
	                            for (i = 0; i < resp.notes.length; i++) {
	                              if (resp.notes.length > 0) {
	                                fav_arr[first_incr] = resp.notes[i];
	                                first_incr++;
	                              }
	                            }
	                            _this.setState({ reportnotes: resp.notes });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context40.stop();
	                      }
	                    }
	                  }, _callee40, _this2);
	                }));
	
	                return function (_x36) {
	                  return _ref41.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context41.stop();
	          }
	        }
	      }, _callee41, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee43() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee43$(_context43) {
	        while (1) {
	          switch (_context43.prev = _context43.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              // frm1
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 1
	              };
	              _context43.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReportsVideobyuserid', data).then(function () {
	                var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(resp) {
	                  return _regenerator2.default.wrap(function _callee42$(_context42) {
	                    while (1) {
	                      switch (_context42.prev = _context42.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo: resp.video });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context42.stop();
	                      }
	                    }
	                  }, _callee42, _this2);
	                }));
	
	                return function (_x37) {
	                  return _ref43.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context43.stop();
	          }
	        }
	      }, _callee43, _this2);
	    }));
	    _this.getVideoReports1 = _asyncToGenerator(_regenerator2.default.mark(function _callee45() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee45$(_context45) {
	        while (1) {
	          switch (_context45.prev = _context45.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 2
	              };
	              _context45.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReportsVideobyuserid', data).then(function () {
	                var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(resp) {
	                  return _regenerator2.default.wrap(function _callee44$(_context44) {
	                    while (1) {
	                      switch (_context44.prev = _context44.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo1: resp.video });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context44.stop();
	                      }
	                    }
	                  }, _callee44, _this2);
	                }));
	
	                return function (_x38) {
	                  return _ref45.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context45.stop();
	          }
	        }
	      }, _callee45, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee47() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee47$(_context47) {
	        while (1) {
	          switch (_context47.prev = _context47.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 1
	              };
	              _context47.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref47 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(resp) {
	                  return _regenerator2.default.wrap(function _callee46$(_context46) {
	                    while (1) {
	                      switch (_context46.prev = _context46.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context46.stop();
	                      }
	                    }
	                  }, _callee46, _this2);
	                }));
	
	                return function (_x39) {
	                  return _ref47.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context47.stop();
	          }
	        }
	      }, _callee47, _this2);
	    }));
	    _this.getVideoFlashcards1 = _asyncToGenerator(_regenerator2.default.mark(function _callee49() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee49$(_context49) {
	        while (1) {
	          switch (_context49.prev = _context49.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 2
	              };
	              _context49.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref49 = _asyncToGenerator(_regenerator2.default.mark(function _callee48(resp) {
	                  return _regenerator2.default.wrap(function _callee48$(_context48) {
	                    while (1) {
	                      switch (_context48.prev = _context48.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport1: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context48.stop();
	                      }
	                    }
	                  }, _callee48, _this2);
	                }));
	
	                return function (_x40) {
	                  return _ref49.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context49.stop();
	          }
	        }
	      }, _callee49, _this2);
	    }));
	    _this.getNotesSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee50() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee50$(_context50) {
	        while (1) {
	          switch (_context50.prev = _context50.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context50.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFavNotesbyuserID1', data).then(function (resp) {
	                if (resp.success) {
	                  var save_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.frm_fav_notes.length; i++) {
	                    if (resp.frm_fav_notes.length > 0) {
	                      save_1_arr[first_incr] = resp.frm_fav_notes[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({
	                    savednotes: save_1_arr
	                  });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context50.stop();
	          }
	        }
	      }, _callee50, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee51() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee51$(_context51) {
	        while (1) {
	          switch (_context51.prev = _context51.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 2
	              };
	              _context51.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavVideosbyuserID1', data).then(function (resp) {
	                if (resp.success) {
	                  var save_1_arr = [];
	                  var first_incr = 0;
	
	                  for (var i = 0; i < resp.frm_fav_videos.length; i++) {
	                    if (resp.frm_fav_videos.length > 0) {
	                      save_1_arr[first_incr] = resp.frm_fav_videos[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({
	                    savedvideo: save_1_arr
	                  });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context51.stop();
	          }
	        }
	      }, _callee51, _this2);
	    }));
	    _this.getVideosSaved1 = _asyncToGenerator(_regenerator2.default.mark(function _callee52() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee52$(_context52) {
	        while (1) {
	          switch (_context52.prev = _context52.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 2
	              };
	              _context52.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavVideosbyuserID2', data).then(function (resp) {
	                if (resp.success) {
	                  var save_1_arr = [];
	                  var first_incr = 0;
	
	                  for (var i = 0; i < resp.frm_fav_videos.length; i++) {
	                    if (resp.frm_fav_videos.length > 0) {
	                      save_1_arr[first_incr] = resp.frm_fav_videos[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({
	                    savedvideo1: save_1_arr
	                  });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context52.stop();
	          }
	        }
	      }, _callee52, _this2);
	    }));
	    _this.FRM2 = _asyncToGenerator(_regenerator2.default.mark(function _callee53() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee53$(_context53) {
	        while (1) {
	          switch (_context53.prev = _context53.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({ idname: storage_session['idname'] });
	              _this.setState({ token: storage_session['token'] });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate1,
	                endDate: _this.state.send_startDate_second1,
	                level: 2
	              };
	              _context53.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ ValidToken: true });
	                } else {
	                  _this.setState({ ValidToken: false });
	                }
	              });
	
	            case 6:
	              _context53.next = 8;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChapters', data).then(function (resp) {
	                if (resp.success) {
	                  var chapters_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.chapters.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.chapters[i].level == 2) {
	                      chapters_1_arr[first_incr] = resp.chapters[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({
	                    chapters1: chapters_1_arr,
	                    bar_chapter1: chapters_1_arr
	                  });
	                  // this.setState({progress_bar_zero:chapters_1_arr});
	                } else {
	                    //console.log(resp.success + '------------failure');
	                  }
	              });
	
	            case 8:
	              _context53.next = 10;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressbar', data).then(function (resp) {
	                if (resp.success) {
	                  var dataString = JSON.stringify(resp.chapters);
	                  var dataReason = JSON.parse(dataString);
	
	                  var final_array_main = [];
	
	                  for (i = 0; i < dataReason.length; i++) {
	                    var right_answered = dataReason[i].answered_count;
	                    //var total_question=dataReason[i].question_stat_count;
	                    var total_question = dataReason[i].attempted_count;
	
	                    var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                    if (user_graph_val === 'NaN') {
	                      final_array_main.push('0.0');
	                    } else {
	                      final_array_main.push(user_graph_val);
	                    }
	
	                    //console.log(final_array_main+'----fdg-------');
	                  }
	                  //console.log(final_array_main);
	                  _this.setState({ bar_main_user1: final_array_main });
	                  //console.log('***********'+this.state.bar_main_user+'++++++++++++');
	                } else {
	                    //console.log(resp.success + '------------failure');
	                  }
	              });
	
	            case 10:
	              _this.setState({ display_main_loader: 'show_block' });
	
	              _context53.next = 13;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ display_main_loader: 'hide_block' });
	                  var dataString = JSON.stringify(resp.chaptersclass);
	                  var dataReason = JSON.parse(dataString);
	
	                  var final_array_main = [];
	
	                  for (i = 0; i < dataReason.length; i++) {
	                    var right_answered = dataReason[i].answered_count;
	                    var total_question = dataReason[i].attempted_count;
	
	                    var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                    if (user_graph_val === 'NaN') {
	                      final_array_main.push('0.0');
	                    } else {
	                      final_array_main.push(user_graph_val);
	                    }
	                  }
	                  _this.setState({ bar_main_class1: final_array_main });
	                  //setTimeout(this.setState({display_loader: 'hide_block'}), 5000);
	                  //console.log('***********'+this.state.bar_main_class+'++++++++++++');
	                } else {
	                    //console.log(resp.success + '------------failure');
	                  }
	              });
	
	            case 13:
	              _context53.next = 15;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(function (resp) {
	                if (resp.success) {
	                  var chapters_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.progressbarzero_data.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.progressbarzero_data[i].level == 2) {
	                      chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({ progress_bar_zero1: chapters_1_arr });
	                  //console.log(chapters_1_arr);
	                } else {
	                  console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 15:
	              _context53.next = 17;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(function (resp) {
	                if (resp.success) {
	                  var notes_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.progressbar_data.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.progressbar_data[i].level == 2) {
	                      notes_1_arr[first_incr] = resp.progressbar_data[i];
	                      first_incr++;
	                    }
	                  }
	
	                  _this.setState({ progress_bar1: notes_1_arr });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 17:
	              _context53.next = 19;
	              return _this.getQuestionFlashcards1();
	
	            case 19:
	              _context53.next = 21;
	              return _this.getQuestionSaved1();
	
	            case 21:
	              _context53.next = 23;
	              return _this.getNotesSaved1();
	
	            case 23:
	              _context53.next = 25;
	              return _this.getVideoFlashcards1();
	
	            case 25:
	              _context53.next = 27;
	              return _this.getVideosSaved1();
	
	            case 27:
	              _context53.next = 29;
	              return _this.getCBTQestionReports1();
	
	            case 29:
	              _context53.next = 31;
	              return _this.getNotesFlashcards1();
	
	            case 31:
	              _context53.next = 33;
	              return _this.getQuestionReports1();
	
	            case 33:
	              _context53.next = 35;
	              return _this.getNotesReports1();
	
	            case 35:
	              _context53.next = 37;
	              return _this.getVideoReports1();
	
	            case 37:
	            case 'end':
	              return _context53.stop();
	          }
	        }
	      }, _callee53, _this2);
	    }));
	    _this.getQuestionReports1 = _asyncToGenerator(_regenerator2.default.mark(function _callee55() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee55$(_context55) {
	        while (1) {
	          switch (_context55.prev = _context55.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context55.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref55 = _asyncToGenerator(_regenerator2.default.mark(function _callee54(resp) {
	                  var reports_arr, first_incr, i;
	                  return _regenerator2.default.wrap(function _callee54$(_context54) {
	                    while (1) {
	                      switch (_context54.prev = _context54.next) {
	                        case 0:
	                          if (resp.success) {
	                            reports_arr = [];
	                            first_incr = 0;
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].chapter_id > 4) {
	                                reports_arr[first_incr] = resp.questions[i];
	                                first_incr++;
	                              }
	                            }
	                            _this.setState({ reportquestion1: reports_arr });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context54.stop();
	                      }
	                    }
	                  }, _callee54, _this2);
	                }));
	
	                return function (_x41) {
	                  return _ref55.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context55.stop();
	          }
	        }
	      }, _callee55, _this2);
	    }));
	    _this.getCBTQestionReports1 = _asyncToGenerator(_regenerator2.default.mark(function _callee57() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee57$(_context57) {
	        while (1) {
	          switch (_context57.prev = _context57.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                level: 2
	              };
	              _context57.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/getreportedQuestion', data).then(function () {
	                var _ref57 = _asyncToGenerator(_regenerator2.default.mark(function _callee56(resp) {
	                  return _regenerator2.default.wrap(function _callee56$(_context56) {
	                    while (1) {
	                      switch (_context56.prev = _context56.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestionCBT1: resp.questions,
	                              reportLoader: false
	                            });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context56.stop();
	                      }
	                    }
	                  }, _callee56, _this2);
	                }));
	
	                return function (_x42) {
	                  return _ref57.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context57.stop();
	          }
	        }
	      }, _callee57, _this2);
	    }));
	    _this.getQuestionFlashcards1 = _asyncToGenerator(_regenerator2.default.mark(function _callee58() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee58$(_context58) {
	        while (1) {
	          switch (_context58.prev = _context58.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context58.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  var flash_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.flash_report.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.flash_report[i].level == 2) {
	                      flash_arr[first_incr] = resp.flash_report[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({ flashreport1: flash_arr, flashLoader: false });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context58.stop();
	          }
	        }
	      }, _callee58, _this2);
	    }));
	    _this.getQuestionSaved1 = _asyncToGenerator(_regenerator2.default.mark(function _callee59() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee59$(_context59) {
	        while (1) {
	          switch (_context59.prev = _context59.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context59.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  var fav_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.questions.length; i++) {
	                    // eslint-disable-next-line
	                    if (resp.questions[i].level == 2) {
	                      fav_arr[first_incr] = resp.questions[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({ savedquestion1: fav_arr, savedLoader: false });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context59.stop();
	          }
	        }
	      }, _callee59, _this2);
	    }));
	    _this.getNotesReports1 = _asyncToGenerator(_regenerator2.default.mark(function _callee61() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee61$(_context61) {
	        while (1) {
	          switch (_context61.prev = _context61.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context61.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getReportsNotesbyuserid2', data).then(function () {
	                var _ref61 = _asyncToGenerator(_regenerator2.default.mark(function _callee60(resp) {
	                  var fav_arr, first_incr, i;
	                  return _regenerator2.default.wrap(function _callee60$(_context60) {
	                    while (1) {
	                      switch (_context60.prev = _context60.next) {
	                        case 0:
	                          if (resp.success) {
	                            fav_arr = [];
	                            first_incr = 0;
	
	                            for (i = 0; i < resp.notes.length; i++) {
	                              if (resp.notes.length > 0) {
	                                fav_arr[first_incr] = resp.notes[i];
	                                first_incr++;
	                              }
	                            }
	                            _this.setState({ reportnotes1: resp.notes });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context60.stop();
	                      }
	                    }
	                  }, _callee60, _this2);
	                }));
	
	                return function (_x43) {
	                  return _ref61.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context61.stop();
	          }
	        }
	      }, _callee61, _this2);
	    }));
	    _this.getNotesFlashcards1 = _asyncToGenerator(_regenerator2.default.mark(function _callee63() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee63$(_context63) {
	        while (1) {
	          switch (_context63.prev = _context63.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context63.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFlashcardsnotesbyuseridD2', data).then(function () {
	                var _ref63 = _asyncToGenerator(_regenerator2.default.mark(function _callee62(resp) {
	                  var fav_arr, first_incr, i;
	                  return _regenerator2.default.wrap(function _callee62$(_context62) {
	                    while (1) {
	                      switch (_context62.prev = _context62.next) {
	                        case 0:
	                          if (resp.success) {
	                            fav_arr = [];
	                            first_incr = 0;
	
	                            for (i = 0; i < resp.flash_cards.length; i++) {
	                              if (resp.flash_cards.length > 0) {
	                                fav_arr[first_incr] = resp.flash_cards[i];
	                                first_incr++;
	                              }
	                            }
	                            _this.setState({ notesFlashReport1: fav_arr });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context62.stop();
	                      }
	                    }
	                  }, _callee62, _this2);
	                }));
	
	                return function (_x44) {
	                  return _ref63.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context63.stop();
	          }
	        }
	      }, _callee63, _this2);
	    }));
	    _this.getNotesSaved1 = _asyncToGenerator(_regenerator2.default.mark(function _callee64() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee64$(_context64) {
	        while (1) {
	          switch (_context64.prev = _context64.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context64.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/getFavNotesbyuserID2', data).then(function (resp) {
	                if (resp.success) {
	                  var save_1_arr = [];
	                  var first_incr = 0;
	                  for (var i = 0; i < resp.frm_fav_notes.length; i++) {
	                    if (resp.frm_fav_notes.length > 0) {
	                      save_1_arr[first_incr] = resp.frm_fav_notes[i];
	                      first_incr++;
	                    }
	                  }
	                  _this.setState({
	                    savednotes1: save_1_arr
	                  });
	                } else {
	                  //console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context64.stop();
	          }
	        }
	      }, _callee64, _this2);
	    }));
	
	    _this._beginChapter = function () {
	      var _ref65 = _asyncToGenerator(_regenerator2.default.mark(function _callee65(item, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee65$(_context65) {
	          while (1) {
	            switch (_context65.prev = _context65.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: item.question_id
	                };
	                _context65.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.context.router.push({
	                      pathname: '/frm/chapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.reading_id + '/' + item.question_id + '/' + 1,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        reading: resp.questionsbyid.reading_id,
	                        chapter: resp.questionsbyid.chapter_id,
	                        selectedMenu: _this.state.selectedmenufrm
	                      }
	                    });
	                  } else {
	                    //console.log('Not Found');
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context65.stop();
	            }
	          }
	        }, _callee65, _this2);
	      }));
	
	      return function (_x45, _x46) {
	        return _ref65.apply(this, arguments);
	      };
	    }();
	
	    _this._beginChapter1 = function () {
	      var _ref66 = _asyncToGenerator(_regenerator2.default.mark(function _callee66(item, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee66$(_context66) {
	          while (1) {
	            switch (_context66.prev = _context66.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: item.question_id
	                };
	                _context66.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.context.router.push({
	                      pathname: '/frm/chapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.reading_id + '/' + item.question_id + '/' + 2,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        reading: resp.questionsbyid.reading_id,
	                        chapter: resp.questionsbyid.chapter_id,
	                        selectedMenu: _this.state.selectedmenufrm
	                      }
	                    });
	                  } else {
	                    //console.log('Not Found');
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context66.stop();
	            }
	          }
	        }, _callee66, _this2);
	      }));
	
	      return function (_x47, _x48) {
	        return _ref66.apply(this, arguments);
	      };
	    }();
	
	    _this.handleVideoReportSubmit = function () {
	      var _ref67 = _asyncToGenerator(_regenerator2.default.mark(function _callee68(event) {
	        var _this$state7, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee68$(_context68) {
	          while (1) {
	            switch (_context68.prev = _context68.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.videoReport === '' && _this.state.videoReport.length < 1)) {
	                  _context68.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context68.abrupt('return');
	
	              case 4:
	                _this$state7 = _this.state, reportEditId = _this$state7.reportEditId, idname = _this$state7.idname, token = _this$state7.token, videoReport = _this$state7.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport,
	                  level: 1
	                };
	                _context68.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref68 = _asyncToGenerator(_regenerator2.default.mark(function _callee67(resp) {
	                    return _regenerator2.default.wrap(function _callee67$(_context67) {
	                      while (1) {
	                        switch (_context67.prev = _context67.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context67.next = 6;
	                              break;
	                            }
	
	                            _this.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context67.next = 4;
	                            return _this.getVideoReports();
	
	                          case 4:
	                            _context67.next = 7;
	                            break;
	
	                          case 6:
	                            _this.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context67.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context67.stop();
	                        }
	                      }
	                    }, _callee67, _this2);
	                  }));
	
	                  return function (_x50) {
	                    return _ref68.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context68.stop();
	            }
	          }
	        }, _callee68, _this2);
	      }));
	
	      return function (_x49) {
	        return _ref67.apply(this, arguments);
	      };
	    }();
	
	    _this.handleVideoReportSubmit1 = function () {
	      var _ref69 = _asyncToGenerator(_regenerator2.default.mark(function _callee70(event) {
	        var _this$state8, reportEditId1, idname, token, videoReport1, data;
	
	        return _regenerator2.default.wrap(function _callee70$(_context70) {
	          while (1) {
	            switch (_context70.prev = _context70.next) {
	              case 0:
	                //console.log('inside submiyyyyyttttttttttttttttttttt', event);
	                //console.log('');
	                event.preventDefault();
	
	                if (!(_this.state.videoReport1 === '' && _this.state.videoReport1.length < 1)) {
	                  _context70.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage1: "Report can't be empty"
	                });
	                return _context70.abrupt('return');
	
	              case 4:
	                _this$state8 = _this.state, reportEditId1 = _this$state8.reportEditId1, idname = _this$state8.idname, token = _this$state8.token, videoReport1 = _this$state8.videoReport1;
	                data = {
	                  id: reportEditId1,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport1,
	                  level: 2
	                };
	                _context70.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref70 = _asyncToGenerator(_regenerator2.default.mark(function _callee69(resp) {
	                    return _regenerator2.default.wrap(function _callee69$(_context69) {
	                      while (1) {
	                        switch (_context69.prev = _context69.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context69.next = 6;
	                              break;
	                            }
	
	                            _this.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus1: !_this.state.reportEditStatus1,
	                              reportEditId: '',
	                              videoReport1: ''
	                            });
	                            _context69.next = 4;
	                            return _this.getVideoReports1();
	
	                          case 4:
	                            _context69.next = 7;
	                            break;
	
	                          case 6:
	                            _this.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context69.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context69.stop();
	                        }
	                      }
	                    }, _callee69, _this2);
	                  }));
	
	                  return function (_x52) {
	                    return _ref70.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context70.stop();
	            }
	          }
	        }, _callee70, _this2);
	      }));
	
	      return function (_x51) {
	        return _ref69.apply(this, arguments);
	      };
	    }();
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.flashcardTabToggle1 = function (tab) {
	      if (_this.state.activeTabFlashcards1 !== tab) {
	        _this.setState({
	          activeTabFlashcards1: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle1 = function (tab) {
	      if (_this.state.activeTabSaved1 !== tab) {
	        _this.setState({
	          activeTabSaved1: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle1 = function (tab) {
	      if (_this.state.activeTabReports1 !== tab) {
	        _this.setState({
	          activeTabReports1: tab
	        });
	      }
	    };
	
	    _this.view = function (item) {
	      if (item.mockData) {
	        var mock = JSON.parse(item.mockData);
	        _this.context.router.push({
	          pathname: '/frm/cbtquestionsfinish/' + mock.mock_id + '/' + item.question_id + '/' + mock.timer + '/1/' + mock.test_id + '/' + mock.offset
	        });
	      }
	    };
	
	    _this.view1 = function (item) {
	      if (item.mockData) {
	        var mock = JSON.parse(item.mockData);
	        _this.context.router.push({
	          pathname: '/frm/cbtquestionsfinish/' + mock.mock_id + '/' + item.question_id + '/' + mock.timer + '/2/' + mock.test_id + '/' + mock.offset
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      alert_status1: false,
	
	      reportAnswerStatus: false,
	      reportAnswerStatus1: false,
	
	      reportEditStatus: false,
	      reportEditStatus1: false,
	
	      reportEditId: '',
	      reportEditId1: '',
	
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      frm1_flash_card_data: '',
	      item_status: '',
	      frm2_flash_card_data: '',
	      item_status1: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      token: '',
	      idname: '',
	      flashreport: [],
	      flashreport1: [],
	
	      notesFlashReport: [],
	      notesFlashReport1: [],
	
	      savedquestion: [],
	      savedquestion1: [],
	
	      savednotes: [],
	      savednotes1: [],
	
	      contactID: '',
	      contactID1: '',
	
	      contactType: '',
	      contactType1: '',
	
	      contactIndex: '',
	      contactIndex1: '',
	
	      contactSubject: '',
	      contactSubject1: '',
	
	      contactComment: '',
	      contactComment1: '',
	
	      contactStatus: false,
	      contactStatus1: false,
	
	      successAlert: false,
	      successAlert1: false,
	
	      SubjectErrorMessage: '',
	      SubjectErrorMessage1: '',
	
	      CommentErrorMessage: '',
	      CommentErrorMessage1: '',
	
	      savedvideo: [],
	      savedvideo1: [],
	
	      progress_bar_zero: [],
	      progress_bar_zero1: [],
	
	      progress_bar: [],
	      progress_bar1: [],
	
	      reportquestion: [],
	      reportquestion1: [],
	
	      reportquestionCBT: [],
	      reportquestionCBT1: [],
	
	      reportnotes: [],
	      reportnotes1: [],
	
	      reportsvideo: [],
	      reportsvideo1: [],
	
	      main_bargraph_data: '',
	      main_bargraph_data1: '',
	
	      bar_chapter: '',
	      bar_chapter1: '',
	
	      videoFlashReport: [],
	      videoFlashReport1: [],
	
	      activeTabFlashcards: '1',
	      activeTabSaved: '1',
	      activeTabReports: '1',
	
	      activeTabFlashcards1: '1',
	      activeTabSaved1: '1',
	      activeTabReports1: '1',
	
	      type: '',
	      type1: '',
	
	      bar_level_main: ['Ethics', 'Quants', 'Econ', 'FRA', 'Corpo', 'Portfolio', 'Equity', 'Fixed Income', 'Derivatives', 'Al'],
	      bar_main_user: [],
	      bar_main_user1: [],
	
	      bar_main_class: [],
	      bar_main_class1: [],
	
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      startDate1: '',
	      startDate_second1: '',
	      send_startDate1: '',
	      send_startDate_second1: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: [],
	      chapters1: [],
	      videoReport1: '',
	      subreadings_status: false,
	      selectedmenufrm: 'frm',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      ErrorMessage: '',
	      ErrorMessage1: '',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      display_main_loader: 'show_block',
	      display_loader: 'hide_block',
	      showFreePremium: '',
	
	      showFreePremium1: '',
	      isVideo: true,
	      showCapsules: true,
	      qpLoader: true,
	      npLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleChange1 = _this.handleChange1.bind(_this);
	
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggleAlert1 = _this.toggleAlert1.bind(_this);
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggle1 = _this.toggle1.bind(_this);
	
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleClose1 = _this.toggleClose1.bind(_this);
	
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.toggleDone1 = _this.toggleDone1.bind(_this);
	
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleCloseReport1 = _this.toggleCloseReport1.bind(_this);
	
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.toggleAlertReport1 = _this.toggleAlertReport1.bind(_this);
	
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.CloseEditQuesReport1 = _this.CloseEditQuesReport1.bind(_this);
	
	    _this.CloseEditCBTQuesReport = _this.CloseEditCBTQuesReport.bind(_this);
	    _this.CloseEditCBTQuesReport1 = _this.CloseEditCBTQuesReport1.bind(_this);
	
	    _this.OpenEditCBTQuesReport = _this.OpenEditCBTQuesReport.bind(_this);
	    _this.OpenEditCBTQuesReport1 = _this.OpenEditCBTQuesReport1.bind(_this);
	
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport1 = _this.OpenEditQuesReport1.bind(_this);
	
	    _this.CloseEditNotesReport = _this.CloseEditNotesReport.bind(_this);
	    _this.CloseEditNotesReport1 = _this.CloseEditNotesReport1.bind(_this);
	
	    _this.OpenEditNotesReport = _this.OpenEditNotesReport.bind(_this);
	    _this.OpenEditNotesReport1 = _this.OpenEditNotesReport1.bind(_this);
	
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.CloseEditVideoReport1 = _this.CloseEditVideoReport1.bind(_this);
	
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    _this.OpenEditVideoReport1 = _this.OpenEditVideoReport1.bind(_this);
	
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    _this.onContactChange1 = _this.onContactChange1.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggle1',
	    value: function toggle1() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleAlert1',
	    value: function toggleAlert1(card) {
	      this.setState({
	        alert_status1: !this.state.alert_status1,
	        item_status1: card
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, data, e) {
	      //console.log('tooogle', data);
	
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: data
	      });
	    }
	  }, {
	    key: 'toggleAlertReport1',
	    value: function toggleAlertReport1(item, data, e) {
	      this.setState({
	        reportAnswerStatus1: !this.state.reportAnswerStatus1,
	        reportAnswerId1: item.id,
	        type1: data
	      });
	    }
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'toggleCloseReport1',
	    value: function toggleCloseReport1() {
	      this.setState({
	        reportAnswerStatus1: !this.state.reportAnswerStatus1,
	        reportAnswerId1: '',
	        type1: '',
	        contactID1: '',
	        contactType1: '',
	        contactIndex1: '',
	        contactSubject1: '',
	        contactComment1: '',
	        SubjectErrorMessage1: '',
	        CommentErrorMessage1: '',
	        contactStatus1: false
	      });
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      //console.log('dfaay', data);
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: data.id,
	          contactType: type,
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'onContactChange1',
	    value: function onContactChange1(data, index, type) {
	      //console.log('dfaay', data);
	      if (!this.state.contactStatus1) {
	        this.setState({
	          contactID1: data.id,
	          contactType1: type,
	          contactIndex1: index,
	          contactStatus1: true
	        });
	      } else {
	        this.setState({
	          contactID1: '',
	          contactType1: '',
	          contactIndex1: '',
	          contactSubject1: '',
	          contactComment1: '',
	          SubjectErrorMessage1: '',
	          CommentErrorMessage1: '',
	          contactStatus1: false
	        });
	      }
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment,
	        type: 'quesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport1',
	    value: function OpenEditQuesReport1(item, e) {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: item.id,
	        quesReport1: item.comment,
	        type1: 'quesReport1'
	      });
	    }
	  }, {
	    key: 'OpenEditCBTQuesReport',
	    value: function OpenEditCBTQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        cbtquesReport: item.comment,
	        type: 'cbtquesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditCBTQuesReport1',
	    value: function OpenEditCBTQuesReport1(item, e) {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: item.id,
	        cbtquesReport1: item.comment,
	        type1: 'cbtquesReport1'
	      });
	    }
	  }, {
	    key: 'OpenEditNotesReport',
	    value: function OpenEditNotesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        notesReport: item.comment,
	        type: 'notesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditNotesReport1',
	    value: function OpenEditNotesReport1(item, e) {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: item.id,
	        notesReport1: item.comment,
	        type1: 'notesReport1'
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        videoReport: item.comment,
	        type: 'videoReport'
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport1',
	    value: function OpenEditVideoReport1(item, e) {
	      //console.log('hiiiiiiiiiiiiiiiiiiiiiii', item, this.state.reportEditStatus1);
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: item.id,
	        videoReport1: item.comment,
	        type1: 'videoReport1'
	      }, function () {
	        //console.log('in callback', this.state.reportEditStatus1);
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport1',
	    value: function CloseEditQuesReport1() {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: '',
	        quesReport1: '',
	        type1: '',
	        ErrorMessage1: ''
	      });
	    }
	  }, {
	    key: 'CloseEditCBTQuesReport',
	    value: function CloseEditCBTQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        cbtquesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditCBTQuesReport1',
	    value: function CloseEditCBTQuesReport1() {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: '',
	        cbtquesReport1: '',
	        type1: '',
	        ErrorMessage1: ''
	      });
	    }
	  }, {
	    key: 'CloseEditNotesReport',
	    value: function CloseEditNotesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        notesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditNotesReport1',
	    value: function CloseEditNotesReport1() {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: '',
	        notesReport1: '',
	        type1: '',
	        ErrorMessage1: ''
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport1',
	    value: function CloseEditVideoReport1() {
	      this.setState({
	        reportEditStatus1: !this.state.reportEditStatus1,
	        reportEditId1: '',
	        videoReport1: '',
	        type1: '',
	        ErrorMessage1: ''
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        frm1_flash_card_data: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleClose1',
	    value: function toggleClose1() {
	      this.setState({
	        alert_status1: !this.state.alert_status1,
	        frm2_flash_card_data: '',
	        item_status1: ''
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange1',
	    value: function handleChange1(date) {
	      this.setState({
	        startDate1: date,
	        startDate_second1: '',
	        send_startDate1: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status1: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate !== '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this3 = this;
	
	          //alert('testing');
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second,
	            level: 1
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this3.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block'
	              });
	            } else {
	              _this3.setState({
	                display_main_loader: 'hide_block'
	              });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this3.setState({ bar_main_class: final_array_main });
	              //console.log('***********'+this.state.bar_main_class+'++++++++++++');
	            } else {
	                //console.log(resp.success + '------------failure');
	              }
	          });
	          // FD.callAPI(App_data.backend_api+'/frm_dashboard/getProgressChapter',data).then(resp => {
	          //   if(resp.success)
	          //   {
	          //     var chapters_1_arr=[];
	          //     var first_incr=0;
	          //     for(var i=0;i<resp.chapters.length;i++)
	          //     {
	          //       if(resp.chapters[i].level==1)
	          //       {
	          //         chapters_1_arr[first_incr]=resp.chapters[i];
	          //         first_incr++;
	          //       }
	          //     }
	          //     this.setState({progress_bar_zero:chapters_1_arr});
	          //   }
	          //   else
	          //   {
	          //     console.log(resp.success+'------------failure');
	          //   }
	          // });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              var chapters_1_arr = [];
	              var first_incr = 0;
	              for (var i = 0; i < resp.progressbarzero_data.length; i++) {
	                // eslint-disable-next-line
	                if (resp.progressbarzero_data[i].level == 1) {
	                  chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
	                  first_incr++;
	                }
	              }
	              _this3.setState({
	                progress_bar_zero: chapters_1_arr,
	                qpLoader: false
	              });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(function (resp) {
	            if (resp.success) {
	              var notes_1_arr = [];
	              var first_incr = 0;
	              for (var i = 0; i < resp.progressbar_data.length; i++) {
	                // eslint-disable-next-line
	                if (resp.progressbar_data[i].level == 1) {
	                  notes_1_arr[first_incr] = resp.progressbar_data[i];
	                  first_incr++;
	                }
	              }
	
	              _this3.setState({ progress_bar: notes_1_arr, npLoader: false });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'handleChange_second1',
	    value: function handleChange_second1(date) {
	      // console.log("woooooooooo",date);
	
	      if (this.state.startDate1 !== '') {
	        // console.log("iffffffffffffffffffffffff");
	
	        this.setState({
	          startDate_second1: date,
	          send_startDate_second1: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status1: true
	        }, function afterdateChange() {
	          var _this4 = this;
	
	          //alert('testing');
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate1,
	            endDate: this.state.send_startDate_second1,
	            level: 2
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressbar', data).then(function (resp) {
	            // console.log(".mainProgressbar",resp);
	
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ bar_main_user1: final_array_main });
	              // console.log('***********'+this.state.bar_main_user+'++++++++++++');
	            } else {
	                //console.log(resp.success + '------------failure');
	              }
	          });
	          this.setState({ display_main_loader: 'show_block' });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(function (resp) {
	            //  console.log("mainProgressclassbar",resp);
	
	            if (resp.success) {
	              _this4.setState({ display_main_loader: 'hide_block' });
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ bar_main_class1: final_array_main });
	              //console.log('***********'+this.state.bar_main_class+'++++++++++++');
	            } else {
	                //console.log(resp.success + '------------failure');
	              }
	          });
	          // FD.callAPI(App_data.backend_api+'/frm_dashboard/getProgressChapter',data).then(resp => {
	          //   if(resp.success)
	          //   {
	          //     var chapters_1_arr=[];
	          //     var first_incr=0;
	          //     for(var i=0;i<resp.chapters.length;i++)
	          //     {
	          //       if(resp.chapters[i].level==2)
	          //       {
	          //         chapters_1_arr[first_incr]=resp.chapters[i];
	          //         first_incr++;
	          //       }
	          //     }
	          //     this.setState({progress_bar_zero:chapters_1_arr});
	          //   }
	          //   else
	          //   {
	          //     console.log(resp.success+'------------failure');
	          //   }
	          // });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              var chapters_1_arr = [];
	              var first_incr = 0;
	              for (var i = 0; i < resp.progressbarzero_data.length; i++) {
	                // eslint-disable-next-line
	                if (resp.progressbarzero_data[i].level == 2) {
	                  chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
	                  first_incr++;
	                }
	              }
	              _this4.setState({
	                progress_bar_zero1: chapters_1_arr,
	                qpLoader: false
	              });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(function (resp) {
	            if (resp.success) {
	              var notes_1_arr = [];
	              var first_incr = 0;
	              for (var i = 0; i < resp.progressbar_data.length; i++) {
	                // eslint-disable-next-line
	                if (resp.progressbar_data[i].level == 2) {
	                  notes_1_arr[first_incr] = resp.progressbar_data[i];
	                  first_incr++;
	                }
	              }
	
	              _this4.setState({ progress_bar1: notes_1_arr, npLoader: false });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	        });
	      }
	    }
	
	    //Function to redirect page on specifc questions
	
	
	    //Function to redirect page on specifc questions
	
	    // function for get  question report
	
	
	    // function to get cbt question reports
	
	    // function for get  question FlashCard
	
	    // function for get  question report
	
	
	    // function for get  notes FlashCard
	
	
	    // function for get  notes report
	
	    // function for get  video report
	
	
	    // function for get  video report of frm2
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  question report
	
	
	    // function for get  question FlashCard
	
	
	    // function for get  question report
	
	
	    // function for get  notes report
	
	
	    // function for get  notes FlashCard
	
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref71 = _asyncToGenerator(_regenerator2.default.mark(function _callee74() {
	        var _this5 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee74$(_context74) {
	          while (1) {
	            switch (_context74.prev = _context74.next) {
	              case 0:
	                console.log('I am inside did mount');
	
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                // eslint-disable-next-line
	                if (localStorage.getItem('selectedmenu') == 'cfa') {
	                  this.context.router.push({
	                    pathname: '/dashboard/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async (resp) => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee73() {
	                  var resp, exam_selected, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee73$(_context73) {
	                    while (1) {
	                      switch (_context73.prev = _context73.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context73.next = 3;
	                            break;
	                          }
	
	                          return _context73.abrupt('return');
	
	                        case 3:
	                          exam_selected = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : resp.profileInfo.exam_selected;
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                          _this5.setState({ subscription_details: subscription_details });
	                          if (resp.profileInfo) {
	                            _this5.setState({
	                              isVideo: resp.profileInfo.isVideo
	                            });
	                          }
	
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context73.next = 18;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context73.next = 12;
	                            break;
	                          }
	
	                          _this5.setState({ showFreePremium: true, showFreePremium1: true });
	                          _context73.next = 16;
	                          break;
	
	                        case 12:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            examid: data_arr
	                          };
	                          _context73.next = 16;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref73 = _asyncToGenerator(_regenerator2.default.mark(function _callee71(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, examPlanData, isInArray_var1;
	                              return _regenerator2.default.wrap(function _callee71$(_context71) {
	                                while (1) {
	                                  switch (_context71.prev = _context71.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context71.next = 17;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this5.state.selectedmenu;
	                                      isInArray_var = false;
	                                      examPlanData = resp_exam.examPlan[0];
	                                      _context71.next = 7;
	                                      return _FrmSubscription4.default.checkFrmVideosSubscription(1, exam_data, examPlanData);
	
	                                    case 7:
	                                      isInArray_var = _context71.sent;
	
	                                      if (isInArray_var) {
	                                        _this5.setState({ showFreePremium: false });
	                                      } else {
	                                        _this5.setState({ showFreePremium: true });
	                                      }
	
	                                      isInArray_var1 = false;
	                                      _context71.next = 12;
	                                      return _FrmSubscription4.default.checkFrmVideosSubscription(2, exam_data, examPlanData);
	
	                                    case 12:
	                                      isInArray_var1 = _context71.sent;
	
	                                      if (isInArray_var1) {
	                                        _this5.setState({ showFreePremium1: false });
	                                      } else {
	                                        _this5.setState({ showFreePremium1: true });
	                                      }
	
	                                      if (isInArray_var || isInArray_var1) {
	                                        _this5.setState({
	                                          showCapsules: false
	                                        });
	                                      } else {
	                                        _this5.setState({
	                                          showCapsules: true
	                                        });
	                                      }
	                                      _context71.next = 17;
	                                      break;
	
	                                    case 17:
	                                    case 'end':
	                                      return _context71.stop();
	                                  }
	                                }
	                              }, _callee71, _this5);
	                            }));
	
	                            return function (_x53) {
	                              return _ref73.apply(this, arguments);
	                            };
	                          }()
	                          //console.log('fail');
	                          );
	
	                        case 16:
	                          _context73.next = 26;
	                          break;
	
	                        case 18:
	                          if (!(resp.profileInfo.exam_selected == '')) {
	                            _context73.next = 22;
	                            break;
	                          }
	
	                          _this5.setState({ showFreePremium: true, showFreePremium1: true });
	                          _context73.next = 26;
	                          break;
	
	                        case 22:
	                          data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                          dataset = {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            examid: data_arr
	                          };
	                          _context73.next = 26;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref74 = _asyncToGenerator(_regenerator2.default.mark(function _callee72(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, isInArray_var1;
	                              return _regenerator2.default.wrap(function _callee72$(_context72) {
	                                while (1) {
	                                  switch (_context72.prev = _context72.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context72.next = 14;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this5.state.selectedmenu;
	                                      isInArray_var = false;
	
	                                      isInArray_var = _FrmSubscription2.default.checkFrmVideosSubscription(1, exam_data);
	                                      if (isInArray_var) {
	                                        _this5.setState({ showFreePremium: false });
	                                      } else {
	                                        _this5.setState({ showFreePremium: true });
	                                      }
	
	                                      isInArray_var1 = false;
	                                      _context72.next = 9;
	                                      return _FrmSubscription4.default.checkFrmVideosSubscription(2, exam_data);
	
	                                    case 9:
	                                      isInArray_var1 = _context72.sent;
	
	                                      if (isInArray_var1) {
	                                        _this5.setState({ showFreePremium1: false });
	                                      } else {
	                                        _this5.setState({ showFreePremium1: true });
	                                      }
	
	                                      if (isInArray_var || isInArray_var1) {
	                                        _this5.setState({
	                                          showCapsules: false
	                                        });
	                                      } else {
	                                        _this5.setState({
	                                          showCapsules: true
	                                        });
	                                      }
	                                      _context72.next = 14;
	                                      break;
	
	                                    case 14:
	                                    case 'end':
	                                      return _context72.stop();
	                                  }
	                                }
	                              }, _callee72, _this5);
	                            }));
	
	                            return function (_x54) {
	                              return _ref74.apply(this, arguments);
	                            };
	                          }()
	                          //console.log('fail');
	                          );
	
	                        case 26:
	                        case 'end':
	                          return _context73.stop();
	                      }
	                    }
	                  }, _callee73, _this5);
	                })));
	
	                this.FRM1();
	                this.FRM2();
	
	              case 10:
	              case 'end':
	                return _context74.stop();
	            }
	          }
	        }, _callee74, this);
	      }));
	
	      function componentDidMount() {
	        return _ref71.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'questionProgressBarFun1',
	    value: function questionProgressBarFun1() {
	      return this.state.progress_bar_zero1.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'notesProgressBarFun',
	    value: function notesProgressBarFun() {
	      return this.state.progress_bar.map(function (item, index) {
	        var progresstotalques = item.chapterallqurestion;
	        var progressnotes = Math.round(item.fav / progresstotalques * 100);
	        if (progressnotes < 1) {
	          progressnotes = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes,
	                      style: { width: progressnotes + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'notesProgressBarFun1',
	    value: function notesProgressBarFun1() {
	      return this.state.progress_bar1.map(function (item, index) {
	        var progresstotalques = item.chapterallqurestion;
	        var progressnotes = Math.round(item.fav / progresstotalques * 100);
	        if (progressnotes < 1) {
	          progressnotes = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes,
	                      style: { width: progressnotes + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref75 = _asyncToGenerator(_regenerator2.default.mark(function _callee76(event) {
	        var _this6 = this;
	
	        var _state, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee76$(_context76) {
	          while (1) {
	            switch (_context76.prev = _context76.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context76.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context76.abrupt('return');
	
	              case 4:
	                _state = this.state, reportEditId = _state.reportEditId, idname = _state.idname, token = _state.token, quesReport = _state.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context76.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref76 = _asyncToGenerator(_regenerator2.default.mark(function _callee75(resp) {
	                    return _regenerator2.default.wrap(function _callee75$(_context75) {
	                      while (1) {
	                        switch (_context75.prev = _context75.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context75.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context75.next = 4;
	                            return _this6.getQuestionReports();
	
	                          case 4:
	                            _context75.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context75.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context75.stop();
	                        }
	                      }
	                    }, _callee75, _this6);
	                  }));
	
	                  return function (_x56) {
	                    return _ref76.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context76.stop();
	            }
	          }
	        }, _callee76, this);
	      }));
	
	      function handleQuestionReportSubmit(_x55) {
	        return _ref75.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit1',
	    value: function () {
	      var _ref77 = _asyncToGenerator(_regenerator2.default.mark(function _callee78(event) {
	        var _this7 = this;
	
	        var _state2, reportEditId1, idname, token, quesReport1, data;
	
	        return _regenerator2.default.wrap(function _callee78$(_context78) {
	          while (1) {
	            switch (_context78.prev = _context78.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport1 === '' && this.state.quesReport1.length < 1)) {
	                  _context78.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage1: "Report can't be empty"
	                });
	                return _context78.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId1 = _state2.reportEditId1, idname = _state2.idname, token = _state2.token, quesReport1 = _state2.quesReport1;
	                data = {
	                  id: reportEditId1,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport1
	                };
	                _context78.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref78 = _asyncToGenerator(_regenerator2.default.mark(function _callee77(resp) {
	                    return _regenerator2.default.wrap(function _callee77$(_context77) {
	                      while (1) {
	                        switch (_context77.prev = _context77.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context77.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus1: !_this7.state.reportEditStatus1,
	                              reportEditId1: '',
	                              quesReport1: ''
	                            });
	                            _context77.next = 4;
	                            return _this7.getQuestionReports1();
	
	                          case 4:
	                            _context77.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context77.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context77.stop();
	                        }
	                      }
	                    }, _callee77, _this7);
	                  }));
	
	                  return function (_x58) {
	                    return _ref78.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context78.stop();
	            }
	          }
	        }, _callee78, this);
	      }));
	
	      function handleQuestionReportSubmit1(_x57) {
	        return _ref77.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit1;
	    }()
	
	    // question form submit function
	
	  }, {
	    key: 'handleCBTQuestionReportSubmit',
	    value: function () {
	      var _ref79 = _asyncToGenerator(_regenerator2.default.mark(function _callee80(event) {
	        var _this8 = this;
	
	        var _state3, reportEditId, idname, token, cbtquesReport, data;
	
	        return _regenerator2.default.wrap(function _callee80$(_context80) {
	          while (1) {
	            switch (_context80.prev = _context80.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.cbtquesReport === '' && this.state.cbtquesReport.length < 1)) {
	                  _context80.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context80.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, cbtquesReport = _state3.cbtquesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: cbtquesReport,
	                  level: 1
	                };
	                _context80.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateReport', data).then(function () {
	                  var _ref80 = _asyncToGenerator(_regenerator2.default.mark(function _callee79(resp) {
	                    return _regenerator2.default.wrap(function _callee79$(_context79) {
	                      while (1) {
	                        switch (_context79.prev = _context79.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context79.next = 6;
	                              break;
	                            }
	
	                            _this8.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this8.state.reportEditStatus,
	                              reportEditId: '',
	                              cbtquesReport: ''
	                            });
	                            _context79.next = 4;
	                            return _this8.getCBTQestionReports();
	
	                          case 4:
	                            _context79.next = 7;
	                            break;
	
	                          case 6:
	                            _this8.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context79.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context79.stop();
	                        }
	                      }
	                    }, _callee79, _this8);
	                  }));
	
	                  return function (_x60) {
	                    return _ref80.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context80.stop();
	            }
	          }
	        }, _callee80, this);
	      }));
	
	      function handleCBTQuestionReportSubmit(_x59) {
	        return _ref79.apply(this, arguments);
	      }
	
	      return handleCBTQuestionReportSubmit;
	    }()
	
	    // question form submit function
	
	  }, {
	    key: 'handleCBTQuestionReportSubmit1',
	    value: function () {
	      var _ref81 = _asyncToGenerator(_regenerator2.default.mark(function _callee82(event) {
	        var _this9 = this;
	
	        var _state4, reportEditId1, idname, token, cbtquesReport1, data;
	
	        return _regenerator2.default.wrap(function _callee82$(_context82) {
	          while (1) {
	            switch (_context82.prev = _context82.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.cbtquesReport1 === '' && this.state.cbtquesReport1.length < 1)) {
	                  _context82.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage1: "Report can't be empty"
	                });
	                return _context82.abrupt('return');
	
	              case 4:
	                _state4 = this.state, reportEditId1 = _state4.reportEditId1, idname = _state4.idname, token = _state4.token, cbtquesReport1 = _state4.cbtquesReport1;
	                data = {
	                  id: reportEditId1,
	                  idname: idname,
	                  token: token,
	                  quesReport: cbtquesReport1,
	                  level: 2
	                };
	                _context82.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frmCBTMockExams/updateReport', data).then(function () {
	                  var _ref82 = _asyncToGenerator(_regenerator2.default.mark(function _callee81(resp) {
	                    return _regenerator2.default.wrap(function _callee81$(_context81) {
	                      while (1) {
	                        switch (_context81.prev = _context81.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context81.next = 6;
	                              break;
	                            }
	
	                            _this9.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this9.state.reportEditStatus,
	                              reportEditId1: '',
	                              cbtquesReport1: ''
	                            });
	                            _context81.next = 4;
	                            return _this9.getCBTQestionReports1();
	
	                          case 4:
	                            _context81.next = 7;
	                            break;
	
	                          case 6:
	                            _this9.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context81.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context81.stop();
	                        }
	                      }
	                    }, _callee81, _this9);
	                  }));
	
	                  return function (_x62) {
	                    return _ref82.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context82.stop();
	            }
	          }
	        }, _callee82, this);
	      }));
	
	      function handleCBTQuestionReportSubmit1(_x61) {
	        return _ref81.apply(this, arguments);
	      }
	
	      return handleCBTQuestionReportSubmit1;
	    }()
	
	    // notes form submit function
	
	  }, {
	    key: 'handleNotesReportSubmit',
	    value: function () {
	      var _ref83 = _asyncToGenerator(_regenerator2.default.mark(function _callee84(event) {
	        var _this10 = this;
	
	        var _state5, reportEditId, idname, token, notesReport, data;
	
	        return _regenerator2.default.wrap(function _callee84$(_context84) {
	          while (1) {
	            switch (_context84.prev = _context84.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport === '' && this.state.notesReport.length < 1)) {
	                  _context84.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context84.abrupt('return');
	
	              case 4:
	                _state5 = this.state, reportEditId = _state5.reportEditId, idname = _state5.idname, token = _state5.token, notesReport = _state5.notesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport
	                };
	                _context84.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref84 = _asyncToGenerator(_regenerator2.default.mark(function _callee83(resp) {
	                    return _regenerator2.default.wrap(function _callee83$(_context83) {
	                      while (1) {
	                        switch (_context83.prev = _context83.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context83.next = 6;
	                              break;
	                            }
	
	                            _this10.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this10.state.reportEditStatus,
	                              reportEditId: '',
	                              notesReport: ''
	                            });
	                            _context83.next = 4;
	                            return _this10.getNotesReports();
	
	                          case 4:
	                            _context83.next = 7;
	                            break;
	
	                          case 6:
	                            _this10.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context83.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context83.stop();
	                        }
	                      }
	                    }, _callee83, _this10);
	                  }));
	
	                  return function (_x64) {
	                    return _ref84.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context84.stop();
	            }
	          }
	        }, _callee84, this);
	      }));
	
	      function handleNotesReportSubmit(_x63) {
	        return _ref83.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit;
	    }()
	
	    // notes form submit function
	
	  }, {
	    key: 'handleNotesReportSubmit1',
	    value: function () {
	      var _ref85 = _asyncToGenerator(_regenerator2.default.mark(function _callee86(event) {
	        var _this11 = this;
	
	        var _state6, reportEditId1, idname, token, notesReport1, data;
	
	        return _regenerator2.default.wrap(function _callee86$(_context86) {
	          while (1) {
	            switch (_context86.prev = _context86.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport1 === '' && this.state.notesReport1.length < 1)) {
	                  _context86.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage1: "Report can't be empty"
	                });
	                return _context86.abrupt('return');
	
	              case 4:
	                _state6 = this.state, reportEditId1 = _state6.reportEditId1, idname = _state6.idname, token = _state6.token, notesReport1 = _state6.notesReport1;
	                data = {
	                  id: reportEditId1,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport1
	                };
	                _context86.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_notes/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref86 = _asyncToGenerator(_regenerator2.default.mark(function _callee85(resp) {
	                    return _regenerator2.default.wrap(function _callee85$(_context85) {
	                      while (1) {
	                        switch (_context85.prev = _context85.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context85.next = 6;
	                              break;
	                            }
	
	                            _this11.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus1: !_this11.state.reportEditStatus1,
	                              reportEditId1: '',
	                              notesReport1: ''
	                            });
	                            _context85.next = 4;
	                            return _this11.getNotesReports1();
	
	                          case 4:
	                            _context85.next = 7;
	                            break;
	
	                          case 6:
	                            _this11.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context85.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context85.stop();
	                        }
	                      }
	                    }, _callee85, _this11);
	                  }));
	
	                  return function (_x66) {
	                    return _ref86.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context86.stop();
	            }
	          }
	        }, _callee86, this);
	      }));
	
	      function handleNotesReportSubmit1(_x65) {
	        return _ref85.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit1;
	    }()
	
	    // video form submit function
	
	
	    // video form submit function
	
	  }, {
	    key: 'InputChange',
	
	
	    // function for state change of edit report form fileds
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange1',
	    value: function InputChange1(e) {
	      var _setState4;
	
	      //console.log('callling-------', e.target.name);
	      //console.log('fffffffffffff', e.target.value);
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState4 = {}, _defineProperty(_setState4, name, value), _defineProperty(_setState4, 'ErrorMessage1', ''), _setState4));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange1',
	    value: function SubjectInputChange1(e) {
	      var _setState5;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState5 = {}, _defineProperty(_setState5, name, value), _defineProperty(_setState5, 'SubjectErrorMessage1', ''), _setState5));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange1',
	    value: function CommentInputChange1(e) {
	      var _setState6;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState6 = {}, _defineProperty(_setState6, name, value), _defineProperty(_setState6, 'CommentErrorMessage1', ''), _setState6));
	    }
	
	    // function to view cbt question
	
	    // function to view cbt question
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var _state7 = this.state,
	          activeTabFlashcards = _state7.activeTabFlashcards,
	          activeTabSaved = _state7.activeTabSaved,
	          activeTabReports = _state7.activeTabReports,
	          activeTabFlashcards1 = _state7.activeTabFlashcards1,
	          activeTabSaved1 = _state7.activeTabSaved1,
	          activeTabReports1 = _state7.activeTabReports1,
	          qpLoader = _state7.qpLoader,
	          npLoader = _state7.npLoader,
	          savedLoader = _state7.savedLoader,
	          flashLoader = _state7.flashLoader,
	          reportLoader = _state7.reportLoader;
	
	      var flashreport_val = this.state.flashreport;
	      var flashreport_val1 = this.state.flashreport1;
	
	      var notes_flashreport_val = this.state.notesFlashReport;
	      var notes_flashreport_val1 = this.state.notesFlashReport1;
	
	      var video_flashreport_val = this.state.videoFlashReport;
	      var video_flashreport_val1 = this.state.videoFlashReport1;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savedquestion_val1 = this.state.savedquestion1;
	
	      var savednotes_val = this.state.savednotes;
	      var savednotes_val1 = this.state.savednotes1;
	
	      var savedvideo_val = this.state.savedvideo;
	      var savedvideo_val1 = this.state.savedvideo1;
	
	      // let progress_bar_zero_val = this.state.progress_bar_zero;
	      // let progress_bar_zero_val1 = this.state.progress_bar_zero1;
	
	      // let progress_barnotes_val = this.state.progress_bar;
	      // let progress_barnotes_val1 = this.state.progress_bar1;
	
	      var reportquestion_val = this.state.reportquestion;
	      var reportquestion_val1 = this.state.reportquestion1;
	
	      var reportquestionCBT_val = this.state.reportquestionCBT;
	      var reportquestionCBT_val1 = this.state.reportquestionCBT1;
	
	      var reportnotes_val = this.state.reportnotes;
	      var reportnotes_val1 = this.state.reportnotes1;
	
	      var reportvideo_val = this.state.reportsvideo;
	      var reportvideo_val1 = this.state.reportsvideo1;
	
	      var question_reportsData = ''; // for question reports
	      var question_reportsData1 = ''; // for question reports
	
	      var cbt_reportsData = ''; // for cbt question reports
	      var cbt_reportsData1 = ''; // for cbt question reports
	
	      var notes_reportsData = ''; // for notes report
	      var notes_reportsData1 = ''; // for notes1 report
	
	      var video_reportsData = ''; // for video report
	      var video_reportsData1 = ''; // for video report
	
	      var flashcard_data = '';
	      var flashcard_data1 = '';
	
	      var notes_flashcard_data = '';
	      var notes_flashcard_data1 = '';
	
	      var video_flashcard_data = '';
	      var video_flashcard_data1 = '';
	
	      var savedquestion_data = '';
	      var savednotes_data = '';
	      var savedvideos_data = '';
	      var savedvideos_data1 = '';
	
	      // let progress_bar_data = "";
	      // let progress_bar_data1 = "";
	
	      var savedquestion_data1 = '';
	      var savednotes_data1 = '';
	
	      /*first main graph*/
	      var main_bar_val = this.state.bar_chapter;
	      var main_bar_val1 = this.state.bar_chapter1;
	
	      var main_bar_percentage = this.state.bar_main_user;
	      var main_bar_percentage1 = this.state.bar_main_user1;
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_user_percentage1 = this.state.bar_main_class1;
	
	      //console.log(main_bar_user_percentage+'sdfdsfdsf');
	      var main_bar_data = [];
	      var main_bar_data1 = [];
	
	      var i = 0;
	
	      // eslint-disable-next-line
	      Object.keys(main_bar_val).map(function (key) {
	        var dataString = JSON.stringify(main_bar_val[key]);
	        var dataReason = JSON.parse(dataString);
	        main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
	        // var chapter_id = dataReason.chapter_id;
	
	        i++;
	      });
	      var i1 = 0;
	
	      // eslint-disable-next-line
	      Object.keys(main_bar_val1).map(function (key) {
	        var dataString1 = JSON.stringify(main_bar_val1[key]);
	        var dataReason1 = JSON.parse(dataString1);
	        main_bar_data1[i1] = dataReason1.chapter_name.substring(0, 14);
	        // var chapter_id1 = dataReason1.chapter_id;
	
	        i1++;
	      });
	
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	
	      var bar_data1 = {
	        labels: main_bar_data1,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage1
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage1
	        }]
	      };
	
	      /*other graph*/
	      var chapters = this.state.chapters;
	      var chapters1 = this.state.chapters1;
	
	      // eslint-disable-next-line
	      var reading_data = '';
	      // eslint-disable-next-line
	      var reading_data1 = '';
	
	      // alert(this.state.subreadings_status);
	      if (this.state.chapters.length && !this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	          );
	        });
	      }
	      if (this.state.chapters1.length && !this.state.subreadings_status1) {
	        reading_data1 = chapters1.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item1' + index },
	              _react2.default.createElement(Barget, {
	                chapter_id: item.chapter_no,
	                idname: _this12.state.idname,
	                token: _this12.state.token,
	                answered_state: index
	              })
	            )
	          );
	        });
	      }
	
	      if (this.state.chapters.length && this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	            )
	          );
	        });
	      }
	      if (this.state.chapters1.length && this.state.subreadings_status1) {
	        reading_data1 = chapters1.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item1' + index },
	                _react2.default.createElement(Barget, {
	                  chapter_id: item.chapter_no,
	                  idname: _this12.state.idname,
	                  token: _this12.state.token,
	                  answered_state: index,
	                  startDate: _this12.state.send_startDate1,
	                  endDate: _this12.state.send_startDate_second1,
	                  subreadings_status: _this12.state.subreadings_status1
	                })
	              )
	            )
	          );
	        });
	      }
	
	      if (this.state.notesFlashReport.length) {
	        notes_flashcard_data = notes_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginNotes.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteNotesFlashcard.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.notesFlashReport1.length) {
	        notes_flashcard_data1 = notes_flashreport_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash__' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginNotes1.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteNotesFlashcard1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ':'
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginChapter.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteFlashcard.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.flashreport1.length) {
	        flashcard_data1 = flashreport_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash__' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ':'
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginChapter1.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteFlashcard1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data1 = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this12.beginVideos(items, 1);
	                    },
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteVideoFlashcard.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport1.length) {
	        video_flashcard_data1 = video_flashreport_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.beginVideos.bind(_this12, items, 2),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteVideoFlashcard1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        video_flashcard_data1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginChapter.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteSavequestion.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      if (this.state.savednotes.length) {
	        savednotes_data = savednotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginNotes.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteSavedNotes.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_NOTES
	        );
	      }
	
	      if (this.state.savedvideo.length) {
	        savedvideos_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this12.beginVideos(items, 1);
	                    },
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deletesavedvideo.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savedvideos_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_VIDEO
	        );
	      }
	
	      if (this.state.savedvideo1.length) {
	        savedvideos_data1 = savedvideo_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.beginVideos.bind(_this12, items, 2),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deletesavedvideo1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savedvideos_data1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_VIDEO
	        );
	      }
	
	      if (this.state.savedquestion1.length) {
	        savedquestion_data1 = savedquestion_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque__' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginChapter1.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteSavequestion1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data1 = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      if (this.state.savednotes1.length) {
	        savednotes_data1 = savednotes_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes1_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginNotes1.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteSavedNotes1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_SAVED_NOTES
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditQuesReport.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus && _this12.state.reportEditId === items.id && _this12.state.type === 'quesReport',
	                  toggle: _this12.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this12.handleQuestionReportSubmit.bind(_this12) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'quesReportcomment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange.bind(_this12),
	                            value: _this12.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginChapter.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport.bind(_this12, items, 'quesReport'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus && _this12.state.reportAnswerId === items.id && _this12.state.type === 'quesReport',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus && _this12.state.contactType === 'quesReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'quesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'quesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus && _this12.state.contactType === 'quesReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? !_this12.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange.bind(_this12),
	                          value: _this12.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange.bind(_this12),
	                          value: _this12.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteReportsquestino.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestion1.length) {
	        question_reportsData1 = reportquestion_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque1_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditQuesReport1.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus1 && _this12.state.reportEditId1 === items.id && _this12.state.type1 === 'quesReport1',
	                  toggle: _this12.OpenEditQuesReport1,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditQuesReport1 },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this12.handleQuestionReportSubmit1.bind(_this12) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'quesReportcomment1',
	                            name: 'quesReport1',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange1.bind(_this12),
	                            value: _this12.state.quesReport1
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage1
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditQuesReport1
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginChapter1.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport1.bind(_this12, items, 'quesReport1'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus1 && _this12.state.reportAnswerId1 === items.id && _this12.state.type1 === 'quesReport1',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus1 && _this12.state.contactType1 === 'quesReport1' && _this12.state.contactID1 === items.id && _this12.state.contactIndex1 === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange1.bind(_this12, items, index, 'quesReport1')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange1.bind(_this12, items, index, 'quesReport1')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport1
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus1 && _this12.state.contactType1 === 'quesReport1' && _this12.state.contactID1 === items.id && _this12.state.contactIndex1 === index ? !_this12.state.successAlert1 ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit1.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject1',
	                          name: 'contactSubject1',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange1.bind(_this12),
	                          value: _this12.state.contactSubject1
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment1',
	                          name: 'contactComment1',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange1.bind(_this12),
	                          value: _this12.state.contactComment1
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose1
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteReportsquestino1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData1 = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestionCBT.length) {
	        cbt_reportsData = reportquestionCBT_val.map(function (items, index) {
	          var parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
	          var mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditCBTQuesReport.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus && _this12.state.reportEditId === items.id && _this12.state.type === 'cbtquesReport',
	                  toggle: _this12.OpenEditCBTQuesReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(mockName, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditCBTQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this12.handleCBTQuestionReportSubmit.bind(_this12) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'cbtquesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange.bind(_this12),
	                            value: _this12.state.cbtquesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditCBTQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this12.view(items);
	                    },
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply && items.reply.length > 0 ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this12.toggleAlertReport.bind(_this12, items, 'cbtquesReport'),
	                  className: _this12.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus && _this12.state.reportAnswerId === items.id && _this12.state.type === 'cbtquesReport',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus && _this12.state.contactType === 'cbtquesReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'cbtquesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'cbtquesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus && _this12.state.contactType === 'cbtquesReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? !_this12.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange.bind(_this12),
	                          value: _this12.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange.bind(_this12),
	                          value: _this12.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteCBTReportsquestino.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        cbt_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestionCBT1.length) {
	        cbt_reportsData1 = reportquestionCBT_val1.map(function (items, index) {
	          var parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
	          var mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque1_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditCBTQuesReport1.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus1 && _this12.state.reportEditId1 === items.id && _this12.state.type1 === 'cbtquesReport1',
	                  toggle: _this12.OpenEditCBTQuesReport1,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderSanitizedHTML)(mockName, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    {
	                      className: 'close',
	                      color: 'secondary',
	                      onClick: _this12.CloseEditCBTQuesReport1
	                    },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this12.handleCBTQuestionReportSubmit1.bind(_this12) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'cbtquesReport1',
	                            name: 'cbtquesReport1',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange1.bind(_this12),
	                            value: _this12.state.cbtquesReport1
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage1
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditCBTQuesReport1
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this12.view1(items);
	                    },
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.reply && items.reply.length > 0 ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport1.bind(_this12, items, 'cbtquesReport1'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus1 && _this12.state.reportAnswerId1 === items.id && _this12.state.type1 === 'cbtquesReport1',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus1 && _this12.state.contactType1 === 'cbtquesReport1' && _this12.state.contactID1 === items.id && _this12.state.contactIndex1 === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange1.bind(_this12, items, index, 'cbtquesReport1')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange1.bind(_this12, items, index, 'cbtquesReport1')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport1
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus1 && _this12.state.contactType1 === 'cbtquesReport1' && _this12.state.contactID1 === items.id && _this12.state.contactIndex1 === index ? !_this12.state.successAlert1 ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit1.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject1',
	                          name: 'contactSubject1',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange1.bind(_this12),
	                          value: _this12.state.contactSubject1
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment1',
	                          name: 'contactComment1',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange1.bind(_this12),
	                          value: _this12.state.contactComment1
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose1
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.reply)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteCBTReportsquestino1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        cbt_reportsData1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportnotes.length) {
	        notes_reportsData = reportnotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditNotesReport.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus && _this12.state.reportEditId === items.id && _this12.state.type === 'notesReport',
	                  toggle: _this12.OpenEditNotesReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditNotesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this12.handleNotesReportSubmit.bind(_this12) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'notesReportComment',
	                            name: 'notesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange.bind(_this12),
	                            value: _this12.state.notesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditNotesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginNotes.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport.bind(_this12, items, 'notesReport'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus && _this12.state.reportAnswerId === items.id && _this12.state.type === 'notesReport',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus && _this12.state.contactType === 'notesReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'notesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'notesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus && _this12.state.contactType === 'notesReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? !_this12.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange.bind(_this12),
	                          value: _this12.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange.bind(_this12),
	                          value: _this12.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteReportsNotes.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportnotes1.length) {
	        notes_reportsData1 = reportnotes_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes1_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditNotesReport1.bind(_this12, items, 'notesReport1'),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus1 && _this12.state.reportEditId1 === items.id && _this12.state.type1 === 'notesReport1',
	                  toggle: _this12.OpenEditNotesReport1,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditNotesReport1 },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this12.handleNotesReportSubmit1.bind(_this12) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'notesReportcomment1',
	                            name: 'notesReport1',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange1.bind(_this12),
	                            value: _this12.state.notesReport1
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage1
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditNotesReport1
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._beginNotes1.bind(_this12, items),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport1.bind(_this12, items, 'notesReport1'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus1 && _this12.state.reportAnswerId1 === items.id && _this12.state.type1 === 'notesReport1',
	                  toggle: _this12.toggleAlertReport1,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus1 && _this12.state.contactType1 === 'notesReport1' && _this12.state.contactID1 === items.id && _this12.state.contactIndex1 === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange1.bind(_this12, items, index, 'notesReport1')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange1.bind(_this12, items, index, 'notesReport1')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport1
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus1 && _this12.state.contactType1 === 'notesReport1' && _this12.state.contactID1 === items.id && _this12.state.contactIndex1 === index ? !_this12.state.successAlert1 ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit1.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject1',
	                          name: 'contactSubject1',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange1.bind(_this12),
	                          value: _this12.state.contactSubject1
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment1',
	                          name: 'contactComment1',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange1.bind(_this12),
	                          value: _this12.state.contactComment1
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose1
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteReportsNotes1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditVideoReport.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus && _this12.state.reportEditId === items.id && _this12.state.type === 'videoReport',
	                  toggle: _this12.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: function onSubmit(e) {
	                          return _this12.handleVideoReportSubmit(e);
	                        } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'videoReportcomment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange.bind(_this12),
	                            value: _this12.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this12.beginVideos(items, 1);
	                    },
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport.bind(_this12, items, 'videoReport'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus && _this12.state.reportAnswerId === items.id && _this12.state.type === 'videoReport',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus && _this12.state.contactType === 'videoReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus && _this12.state.contactType === 'videoReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? !_this12.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange.bind(_this12),
	                          value: _this12.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange.bind(_this12),
	                          value: _this12.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteReportsVideo.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo1.length) {
	        video_reportsData1 = reportvideo_val1.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this12.OpenEditVideoReport1.bind(_this12, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this12.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportEditStatus1 && _this12.state.reportEditId1 === items.id && _this12.state.type1 === 'videoReport1',
	                  toggle: _this12.OpenEditVideoReport1,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this12.CloseEditVideoReport1 },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: function onSubmit(e) {
	                          return _this12.handleVideoReportSubmit1(e);
	                        } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'videoReportcomment',
	                            name: 'videoReport1',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this12.InputChange1.bind(_this12),
	                            value: _this12.state.videoReport1
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            _this12.state.ErrorMessage1
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this12.CloseEditVideoReport1
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.beginVideos.bind(_this12, items, 2),
	                    className: _this12.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12.toggleAlertReport.bind(_this12, items, 'videoReport'),
	                    className: _this12.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this12.state.reportAnswerStatus && _this12.state.reportAnswerId === items.id && _this12.state.type === 'videoReport',
	                  toggle: _this12.toggleAlertReport,
	                  className: 'modal-primary ' + _this12.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this12.state.contactStatus && _this12.state.contactType === 'videoReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this12.onContactChange.bind(_this12, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this12.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this12.state.contactStatus && _this12.state.contactType === 'videoReport' && _this12.state.contactID === items.id && _this12.state.contactIndex === index ? !_this12.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this12.onContactSubmit.bind(_this12) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this12.SubjectInputChange.bind(_this12),
	                          value: _this12.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this12.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this12.CommentInputChange.bind(_this12),
	                          value: _this12.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this12.state.displaytext + ' text-danger' },
	                          _this12.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this12.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this12.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this12._deleteReportsVideo1.bind(_this12, items),
	                    className: _this12.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData1 = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      // if(this.state.progress_bar_zero.length)
	      // {
	      //   progress_bar_data=progress_bar_zero_val.map((item,index)=>
	      //     <tr key={index}>
	
	      //         <td>
	      //             <div className="question_row">
	      //                 <div className="question_count">
	      //                    Q{item.chapter_no}
	      //                 </div>
	      //                 <div className="question_bar">
	      //                     <p>{item.chapter_name}</p>
	      //                     <div className="bar_wrap">
	      //                         <CountProgressinfo_zero chapter_id={item.chapter_id}  idname={this.state.idname} token={this.state.token} answered_state={index} tot_count={item.question_stat_count} startDate={this.state.send_startDate} endDate={this.state.send_startDate_second}/>
	      //                     </div>
	      //                 </div>
	      //             </div>
	      //         </td>
	      //     </tr>
	
	      //   );
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 margin_bottom_20 frm_title_logo_wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().DASHBOARD
	              ),
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	                className: 'garpLogo',
	                alt: 'full logo'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  ' ',
	                  _language2.default.LC().MY_FRM_EXAM_I_DASHBOARD,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dashboard-right-side-btn' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary', onClick: this._viewAllQuestion.bind() },
	                    ' ',
	                    _language2.default.LC().Detailed_Stats,
	                    ' '
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().FROM,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'col-sm-12 text-center' }),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.savedTabToggle('2');
	                        },
	                        className: activeTabSaved === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : this.state.activeTabSaved === '2' ? savednotes_data : savedvideos_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle('2');
	                        },
	                        className: activeTabReports === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null,
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle('4');
	                        },
	                        className: activeTabReports === '4' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' Mocks'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : this.state.activeTabReports === '2' ? notes_reportsData : this.state.activeTabReports === '3' ? video_reportsData : cbt_reportsData
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    npLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.notesProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'close', 'aria-label': 'Close', onClick: this.toggleClose },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  ' ',
	                  _language2.default.LC().OK,
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  ' ',
	                  _language2.default.LC().MY_FRM_EXAM_II_DASHBOARD,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dashboard-right-side-btn' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary', onClick: this._viewAllQuestion1.bind() },
	                    ' ',
	                    _language2.default.LC().Detailed_Stats,
	                    ' '
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate1,
	                          onChange: this.handleChange1,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second1,
	                          minDate: this.state.startDate1,
	                          onChange: this.handleChange_second1.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data1,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'col-sm-12 text-center' }),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.savedTabToggle1('1');
	                        },
	                        className: activeTabSaved1 === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.savedTabToggle1('2');
	                        },
	                        className: activeTabSaved1 === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.savedTabToggle1('3');
	                        },
	                        className: activeTabSaved1 === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved1 === '1' ? savedquestion_data1 : this.state.activeTabSaved1 === '2' ? savednotes_data1 : this.state.activeTabSaved1 === '3' ? savedvideos_data1 : null
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle1('1');
	                        },
	                        className: activeTabReports1 === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle1('2');
	                        },
	                        className: activeTabReports1 === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle1('3');
	                        },
	                        className: activeTabReports1 === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null,
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this12.reportsTabToggle1('4');
	                        },
	                        className: activeTabReports1 === '4' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' Mocks'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports1 === '1' ? question_reportsData1 : this.state.activeTabReports1 === '2' ? notes_reportsData1 : this.state.activeTabReports1 === '3' ? video_reportsData1 : this.state.activeTabReports1 === '4' ? cbt_reportsData1 : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun1()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    npLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.notesProgressBarFun1()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status1,
	              toggle: this.toggleAlert1,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'close',
	                  'aria-label': 'Close',
	                  onClick: this.toggleClose1
	                },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone1
	                  },
	                  ' ',
	                  _language2.default.LC().OK,
	                  ' '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	// function CountProgressinfo_zero(props) {
	//     var data={'idname':props.idname,'chapter_id':props.chapter_id,'token':props.token,'tot_count':props.tot_count,startDate:props.startDate,endDate:props.endDate};
	//     FD.callAPI(App_data.backend_api+'/frm_dashboard/getCountquesprogByuser',data).then(resp => {
	//       var dataString = JSON.stringify(resp);
	//       var dataReason = JSON.parse(dataString);
	//       var progresstotalques_zero=props.tot_count;
	//       var progressnotes_zero=Math.round(((dataReason.progressbarzero_data[0].counttotquestion)/progresstotalques_zero)*100);
	//       if(progressnotes_zero<1)
	//       {
	//         document.getElementById('user_question_status'+props.answered_state).innerHTML = '<Progress className="progress-xs" color="info" value="1" style="width:1%;" />';
	//       }
	//       else{
	//         document.getElementById('user_question_status'+props.answered_state).innerHTML = '<Progress className="progress-xs" color="info" value="'+progressnotes_zero+'" style="width:'+progressnotes_zero+'%;" />';
	//       }
	//     })
	//    return (<div id={'user_question_status'+props.answered_state}></div>);
	// }
	
	Dashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	var bar_data_sub = [];
	// var reading_text = "";
	function Barget(props) {
	  var data = {};
	  if (props.subreadings_status && props.endDate !== '') {
	    data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: props.startDate,
	      endDate: props.endDate,
	      level: 2
	    };
	  } else {
	    data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: '',
	      endDate: '',
	      level: 2
	    };
	  }
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/subProgressbar', data).then(function (resp) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_dashboard/subProgressbarofclass', data).then(function (resp_class) {
	      /*class variable */
	      var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
	      var dataReason_class = JSON.parse(dataString_class);
	
	      var final_array_main_class = [];
	
	      for (i = 0; i < dataReason_class.length; i++) {
	        var right_answered_class = dataReason_class[i].right_answer;
	        var total_question_class = dataReason_class[i].total_questions_frms;
	        var user_graph_val_class = Math.round(right_answered_class / total_question_class * 100);
	        final_array_main_class.push(user_graph_val_class);
	      }
	      //  console.log('abc------------------'+final_array_main_class+'-------ssss--------');
	      /*user variable*/
	      var dataString = JSON.stringify(resp.readingwisebar_ret);
	      var dataReason = JSON.parse(dataString);
	
	      var final_array_main = [];
	      var reading_text = [];
	
	      for (i = 0; i < dataReason.length; i++) {
	        var right_answered = dataReason[i].right_answer;
	        var total_question = dataReason[i].total_questions_frms;
	
	        var user_graph_val = (right_answered / total_question * 100).toFixed(2);
	        final_array_main.push(user_graph_val);
	        reading_text.push(dataReason[i].reading.substring(0, 10));
	      }
	      /*graph details*/
	      bar_data_sub[props.answered_state] = {
	        labels: reading_text,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(114,195,250)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(114,195,250)',
	          data: final_array_main
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: final_array_main_class
	        }]
	      };
	    });
	  });
	  return _react2.default.createElement(_reactChartjs.Bar, {
	    data: bar_data_sub[props.answered_state],
	    options: {
	      maintainAspectRatio: false
	      // animation: {
	      //   duration: 1000,
	      //   delay: 1000,
	      //   from: 1,
	      //   to: 0,
	      //   easing: 'linear',
	      // },
	    }
	  });
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this13 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this13.toggle = _this13.toggle.bind(_this13);
	    _this13.state = {
	      tooltipOpen: false
	    };
	    return _this13;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Dashboard;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _CommonDetailStatus = __webpack_require__(184);
	
	var _CommonDetailStatus2 = _interopRequireDefault(_CommonDetailStatus);
	
	var _CommonFilter = __webpack_require__(185);
	
	var _CommonFilter2 = _interopRequireDefault(_CommonFilter);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ScrollUpButton from "react-scroll-up-button";
	
	/* eslint-disable*/
	var ViewFrm2AllQues = function (_Component) {
	  _inherits(ViewFrm2AllQues, _Component);
	
	  function ViewFrm2AllQues(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewFrm2AllQues);
	
	    var _this = _possibleConstructorReturn(this, (ViewFrm2AllQues.__proto__ || Object.getPrototypeOf(ViewFrm2AllQues)).call(this, props));
	
	    _this.setSelectedChapter = function (e) {
	      var chapterId = e.target.value;
	      _this.setState({
	        selectedChapter: e.target.value,
	        selectedQuestion: ''
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        chapter: chapterId,
	        reading: _this.state.selectedReading
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReadings', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({ readings: resp.readings }, function () {});
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.setSelectedReading = function (e) {
	      _this.setState({ selectedReading: e.target.value, selectedQuestion: '' });
	    };
	
	    _this.setSelectedQuestion = function (e) {
	      _this.setState({
	        selectedQuestion: e.target.value,
	        selectedChapter: '',
	        selectedReading: '',
	        selectedAnswered: '',
	        selctedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: ''
	      });
	    };
	
	    _this.setSelectedAnswered = function (e) {
	      _this.setState({ selectedAnswered: e.target.value });
	    };
	
	    _this.setSelectedNoOfAttempts = function (e) {
	      _this.setState({ selectedAttempts: e.target.value });
	    };
	
	    _this.setSelectedPagination = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(page, data) {
	        var pageMinusOne, questionLowerLimit, questionUpperLimit;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.setState({
	                  totalPages: data.totalPages,
	                  pageLimit: data.pageLimit,
	                  totalQuestions: data.totalQuestions,
	                  currentPage: page,
	                  loader: true
	                });
	                pageMinusOne = page - 1;
	                questionLowerLimit = pageMinusOne * 20;
	                questionUpperLimit = pageMinusOne * 20 + 20;
	
	                _this.setState({
	                  questionLowerLimit: questionLowerLimit,
	                  questionUpperLimit: questionUpperLimit
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                  var storage_session, data;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                          _this.setState({
	                            idname: storage_session['idname'],
	                            token: storage_session['token']
	                          });
	                          data = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            chapter: _this.state.selectedChapter,
	                            reading: _this.state.selectedReading,
	                            question: _this.state.selectedQuestion,
	                            selectedAnswered: _this.state.selectedAnswered,
	                            selectedAttempts: _this.state.selectedAttempts,
	                            selectedAvgScore: _this.state.selectedAvgScore,
	                            selectedLowerLimit: _this.state.selectedLowerLimit,
	                            selectedUpperLimit: _this.state.selectedUpperLimit,
	                            selectedPassingScore: _this.state.selectedPassingScore,
	                            questionLowerLimit: _this.state.questionLowerLimit,
	                            questionUpperLimit: _this.state.questionUpperLimit,
	                            subscriptionstatus: _this.state.subscriptionstatus,
	                            level: _this.state.level
	                          };
	                          _context.next = 5;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                            if (resp.success) {
	                              window.scroll(0, 0);
	
	                              _this.setState({ ValidToken: true });
	
	                              _this.setState({
	                                allQuestion: resp.allQuestions,
	                                totalQuestions: resp.totalQuestions,
	                                loader: false,
	                                selectedLevel: _this.state.selectedLevel
	                              }, function () {
	                                _reactRouter.browserHistory.push('/frm/2/viewallquestions/?sQ=' + _this.state.selectedQuestion + '&c=' + _this.state.selectedChapter + '&s=' + _this.state.selectedReading + '&sAns=' + _this.state.selectedAnswered + '&sAtt=' + _this.state.selectedAttempts + '&sAvgS=' + _this.state.selectedAvgScore + '&sLl=' + _this.state.selectedLowerLimit + '&sUl=' + _this.state.selectedUpperLimit + '&sPs=' + _this.state.selectedUpperLimit + '&sQll=' + _this.state.questionLowerLimit + '&sQul=' + _this.state.questionUpperLimit);
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                          });
	
	                        case 5:
	                          _context.next = 7;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm2', data).then(function (resp) {
	                            if (resp.success) {
	                              _this.setState({ chapters: resp.chapters }, function () {});
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                          });
	
	                        case 7:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                })));
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.setSelectedChangeAvgScores = function (e) {
	      if (e.target.value === '0') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '0',
	          selectedUpperLimit: '25'
	        });
	      }
	
	      if (e.target.value === '1') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '25',
	          selectedUpperLimit: '50'
	        });
	      } else if (e.target.value === '2') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '50',
	          selectedUpperLimit: '70'
	        });
	      } else if (e.target.value === '3') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '70',
	          selectedUpperLimit: '100'
	        });
	      }
	    };
	
	    _this.setSelectedChangePass = function (e) {
	      _this.setState({ selectedPassingScore: e.target.value });
	    };
	
	    _this.resetAllQuestion = function () {
	      _this.setState({
	        selectedChapter: '',
	        selectedReading: '',
	        selectedQuestion: '',
	        selectedAnswered: '',
	        selectedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: '',
	        selectedLowerLimit: '',
	        selectedUpperLimit: '',
	        questionLowerLimit: '0',
	        questionUpperLimit: '20',
	        readings: [],
	        loader: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                _this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: _this.state.selectedChapter,
	                  reading: _this.state.selectedReading,
	                  question: _this.state.selectedQuestion,
	                  selectedAnswered: _this.state.selectedAnswered,
	                  selectedAttempts: _this.state.selectedAttempts,
	                  selectedAvgScore: _this.state.selectedAvgScore,
	                  selectedLowerLimit: _this.state.selectedLowerLimit,
	                  selectedUpperLimit: _this.state.selectedUpperLimit,
	                  selectedPassingScore: _this.state.selectedPassingScore,
	                  questionLowerLimit: _this.state.questionLowerLimit,
	                  questionUpperLimit: _this.state.questionUpperLimit,
	                  subscriptionstatus: _this.state.subscriptionstatus,
	                  level: _this.state.level
	                };
	                _context3.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ ValidToken: true });
	
	                    _this.setState({
	                      allQuestion: resp.allQuestions,
	                      totalQuestions: resp.totalQuestions,
	                      loader: false,
	                      selectedLevel: _this.state.selectedLevel
	                    }, function () {
	                      _reactRouter.browserHistory.push('/frm/2/viewallquestions/?sQ=' + _this.state.selectedQuestion + '&c=' + _this.state.selectedChapter + '&s=' + _this.state.selectedReading + '&sAns=' + _this.state.selectedAnswered + '&sAtt=' + _this.state.selectedAttempts + '&sAvgS=' + _this.state.selectedAvgScore + '&sLl=' + _this.state.selectedLowerLimit + '&sUl=' + _this.state.selectedUpperLimit + '&sPs=' + _this.state.selectedUpperLimit + '&sQll=' + _this.state.questionLowerLimit + '&sQul=' + _this.state.questionUpperLimit + '&searchBy=questionID');
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 5:
	                _context3.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm2', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ chapters: resp.chapters }, function () {});
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      })));
	    };
	
	    _this.resetAllChapter = function () {
	      _this.setState({
	        selectedChapter: '',
	        selectedReading: '',
	        selectedQuestion: '',
	        selectedAnswered: '',
	        selectedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: '',
	        selectedLowerLimit: '',
	        selectedUpperLimit: '',
	        questionLowerLimit: '0',
	        questionUpperLimit: '20',
	        readings: [],
	        loader: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                _this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: _this.state.selectedChapter,
	                  reading: _this.state.selectedReading,
	                  question: _this.state.selectedQuestion,
	                  selectedAnswered: _this.state.selectedAnswered,
	                  selectedAttempts: _this.state.selectedAttempts,
	                  selectedAvgScore: _this.state.selectedAvgScore,
	                  selectedLowerLimit: _this.state.selectedLowerLimit,
	                  selectedUpperLimit: _this.state.selectedUpperLimit,
	                  selectedPassingScore: _this.state.selectedPassingScore,
	                  questionLowerLimit: _this.state.questionLowerLimit,
	                  questionUpperLimit: _this.state.questionUpperLimit,
	                  subscriptionstatus: _this.state.subscriptionstatus,
	                  level: _this.state.level
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ ValidToken: true });
	
	                    _this.setState({
	                      allQuestion: resp.allQuestions,
	                      totalQuestions: resp.totalQuestions,
	                      loader: false,
	                      selectedLevel: _this.state.selectedLevel
	                    }, function () {
	                      _reactRouter.browserHistory.push('/frm/2/viewallquestions/?sQ=' + _this.state.selectedQuestion + '&c=' + _this.state.selectedChapter + '&s=' + _this.state.selectedReading + '&sAns=' + _this.state.selectedAnswered + '&sAtt=' + _this.state.selectedAttempts + '&sAvgS=' + _this.state.selectedAvgScore + '&sLl=' + _this.state.selectedLowerLimit + '&sUl=' + _this.state.selectedUpperLimit + '&sPs=' + _this.state.selectedUpperLimit + '&sQll=' + _this.state.questionLowerLimit + '&sQul=' + _this.state.questionUpperLimit + '&searchBy=chapterID');
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 5:
	                _context4.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm2', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ chapters: resp.chapters }, function () {});
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      })));
	    };
	
	    _this.state = {
	      allQuestion: [],
	      selectedChapter: '',
	      selectedReading: '',
	      selectedQuestion: '',
	      selectedAnswered: '',
	      selectedAttempts: '',
	      selectedAvgScore: '',
	      selectedPassingScore: '',
	      selectedLowerLimit: '',
	      selectedUpperLimit: '',
	      readings: [],
	      chapters: [],
	      totalQuestions: '',
	      currentPage: 1,
	      pageLimit: 20,
	      pageNeighbours: 1,
	      questionLowerLimit: 0,
	      questionUpperLimit: 20,
	      loader: true,
	      url: new URL(window.location.href),
	      subscriptionstatus: '',
	      selectedmenu: 'frm',
	      selectedmen: '',
	      selectedLevel: 'frm2',
	      level: '2'
	    };
	    return _this;
	  }
	
	  _createClass(ViewFrm2AllQues, [{
	    key: '_filerQuestionsByChapter',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                this.setState({ loader: true });
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  chapter: this.state.selectedChapter,
	                  reading: this.state.selectedReading,
	                  question: this.state.selectedQuestion,
	                  selectedAnswered: this.state.selectedAnswered,
	                  selectedAttempts: this.state.selectedAttempts,
	                  selectedAvgScore: this.state.selectedAvgScore,
	                  selectedLowerLimit: this.state.selectedLowerLimit,
	                  selectedUpperLimit: this.state.selectedUpperLimit,
	                  selectedPassingScore: this.state.selectedPassingScore,
	                  questionLowerLimit: this.state.questionLowerLimit,
	                  questionUpperLimit: this.state.questionUpperLimit,
	                  subscriptionstatus: this.state.subscriptionstatu,
	                  level: this.state.level
	                };
	                _context5.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      allQuestion: resp.allQuestions,
	                      totalQuestions: resp.totalQuestions,
	                      loader: false,
	                      selectedLevel: _this3.state.selectedLevel
	                    }, function () {
	                      _reactRouter.browserHistory.push('/frm/2/viewallquestions/?sQ=' + _this3.state.selectedQuestion + '&c=' + _this3.state.selectedChapter + '&s=' + _this3.state.selectedReading + '&sAns=' + _this3.state.selectedAnswered + '&sAtt=' + _this3.state.selectedAttempts + '&sAvgS=' + _this3.state.selectedAvgScore + '&sLl=' + _this3.state.selectedLowerLimit + '&sUl=' + _this3.state.selectedUpperLimit + '&sPs=' + _this3.state.selectedUpperLimit + '&sQll=' + _this3.state.questionLowerLimit + '&sQul=' + _this3.state.questionUpperLimit);
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function _filerQuestionsByChapter() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return _filerQuestionsByChapter;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this4 = this,
	            _data;
	
	        var storage_session, dataChapter, user_data, data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                if (!(this.state.url.searchParams.get('c') !== null || this.state.url.searchParams.get('sQ') !== null)) {
	                  _context12.next = 5;
	                  break;
	                }
	
	                _context12.next = 3;
	                return this.setState({
	                  selectedQuestion: this.state.url.searchParams.get('sQ'),
	                  selectedChapter: this.state.url.searchParams.get('c'),
	                  selectedReading: this.state.url.searchParams.get('s'),
	                  selectedAnswered: this.state.url.searchParams.get('sAns'),
	                  selectedAttempts: this.state.url.searchParams.get('sAtt'),
	                  selectedAvgScore: this.state.url.searchParams.get('sAvgS'),
	                  selectedLowerLimit: this.state.url.searchParams.get('sLl'),
	                  selectedUpperLimit: this.state.url.searchParams.get('sUl'),
	                  selectedPassingScore: this.state.url.searchParams.get('sPs'),
	                  questionLowerLimit: this.state.url.searchParams.get('sQll'),
	                  questionUpperLimit: this.state.url.searchParams.get('sQul')
	                });
	
	              case 3:
	                _context12.next = 6;
	                break;
	
	              case 5:
	                null;
	
	              case 6:
	                // console.log('after setState')
	                // console.log(this.state)
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                dataChapter = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.selectedChapter
	                };
	                user_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context12.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context8.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 11;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = '2';
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context6.next = 7;
	                                        return _FrmSubscription4.default.checkFrm(selectedmen, exam_data, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context6.sent;
	
	                                        if (isInArray_var) {
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4.setState({ subscriptionstatus: 'free' });
	                                        }
	                                        _context6.next = 12;
	                                        break;
	
	                                      case 11:
	                                        console.log('fail');
	
	                                      case 12:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this4);
	                              }));
	
	                              return function (_x4) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }());
	
	                          case 9:
	                            _context8.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context8.next = 15;
	                              break;
	                            }
	
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context8.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (resp_exam.success) {
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = '2';
	                                          isInArray_var = false;
	
	                                          isInArray_var = _FrmSubscription2.default.checkFrm(selectedmen, exam_data);
	                                          // console.log(isInArray_var)
	                                          if (isInArray_var) {
	                                            // console.log('paid')
	                                            _this4.setState({ subscriptionstatus: 'paid' });
	                                          } else {
	                                            // console.log('free')
	                                            _this4.setState({ subscriptionstatus: 'free' });
	                                          }
	                                        } else {
	                                          console.log('fail');
	                                        }
	
	                                      case 1:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this4);
	                              }));
	
	                              return function (_x5) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }());
	
	                          case 19:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this4);
	                  }));
	
	                  return function (_x3) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                data = (_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.selectedChapter,
	                  reading: this.state.selectedReading,
	                  question: this.state.selectedQuestion,
	                  selectedAnswered: this.state.selectedAnswered,
	                  selectedAttempts: this.state.selectedAttempts,
	                  selectedAvgScore: this.state.selectedAvgScore,
	                  selectedLowerLimit: this.state.selectedLowerLimit,
	                  selectedUpperLimit: this.state.selectedUpperLimit
	                }, _defineProperty(_data, 'selectedUpperLimit', this.state.selectedPassingScore), _defineProperty(_data, 'questionLowerLimit', this.state.questionLowerLimit), _defineProperty(_data, 'questionUpperLimit', this.state.questionUpperLimit), _defineProperty(_data, 'subscriptionstatus', this.state.subscriptionstatus), _defineProperty(_data, 'level', this.state.level), _data);
	                // console.log(data)
	
	                _context12.next = 15;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm2', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp.chapters)
	                              _this4.setState({ chapters: resp.chapters }, function () {
	                                _reactRouter.browserHistory.push('/frm/2/viewallquestions/?sQ=' + _this4.state.selectedQuestion + '&c=' + _this4.state.selectedChapter + '&s=' + _this4.state.selectedReading + '&sAns=' + _this4.state.selectedAnswered + '&sAtt=' + _this4.state.selectedAttempts + '&sAvgS=' + _this4.state.selectedAvgScore + '&sLl=' + _this4.state.selectedLowerLimit + '&sUl=' + _this4.state.selectedUpperLimit + '&sPs=' + _this4.state.selectedUpperLimit + '&sQll=' + _this4.state.questionLowerLimit + '&sQul=' + _this4.state.questionUpperLimit);
	                              });
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                              // console.log(resp)
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this4);
	                  }));
	
	                  return function (_x6) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	
	              case 15:
	                _context12.next = 17;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp)
	                              _this4.setState({
	                                ValidToken: true,
	                                allQuestion: resp.allQuestions,
	                                totalQuestions: resp.totalQuestions,
	                                loader: false
	                              }, function () {});
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                              //   console.log(resp)
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this4);
	                  }));
	
	                  return function (_x7) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 17:
	                if (!(this.state.chapter !== '')) {
	                  _context12.next = 22;
	                  break;
	                }
	
	                _context12.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReadings', dataChapter).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp)
	                              _this4.setState({ ValidToken: true, readings: resp.readings }, function () {
	                                // console.log(this.state.allQuestions)
	                              });
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                              // console.log(resp)
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this4);
	                  }));
	
	                  return function (_x8) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 20:
	                _context12.next = 23;
	                break;
	
	              case 22:
	                null;
	
	              case 23:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(this.state.subscriptionstatus)
	      var _state = this.state,
	          readings = _state.readings,
	          allQuestion = _state.allQuestion,
	          chapters = _state.chapters,
	          selectedChapter = _state.selectedChapter,
	          selectedReading = _state.selectedReading,
	          selectedQuestion = _state.selectedQuestion,
	          selectedAnswered = _state.selectedAnswered,
	          selectedAttempts = _state.selectedAttempts,
	          selectedAvgScore = _state.selectedAvgScore,
	          selectedPassingScore = _state.selectedPassingScore,
	          selectedLowerLimit = _state.selectedLowerLimit,
	          selectedUpperLimit = _state.selectedUpperLimit,
	          questionLowerLimit = _state.questionLowerLimit,
	          questionUpperLimit = _state.questionUpperLimit,
	          totalQuestions = _state.totalQuestions,
	          pageLimit = _state.pageLimit,
	          pageNeighbours = _state.pageNeighbours,
	          currentPage = _state.currentPage,
	          loader = _state.loader,
	          subscriptionstatus = _state.subscriptionstatus,
	          selectedmenu = _state.selectedmenu,
	          level = _state.level;
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 d-flex' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	              className: 'garpLogo',
	              alt: 'full logo'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 top-heading-filter-toggle clrearfix' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().List_of_All_Questions_For,
	              ' FRM Part - II',
	              ' '
	            ),
	            _react2.default.createElement(_CommonFilter2.default, {
	              onChangeQuestion: this.setSelectedQuestion.bind(this),
	              onChangeChapter: this.setSelectedChapter.bind(this),
	              onChangeReading: this.setSelectedReading.bind(this),
	              onChangeAnswered: this.setSelectedAnswered.bind(this),
	              onChangeNoOfAttempts: this.setSelectedNoOfAttempts.bind(this),
	              onChangeAvgScore: this.setSelectedChangeAvgScores.bind(this),
	              onChangePass: this.setSelectedChangePass.bind(this),
	              onChangePagination: this.setSelectedPagination.bind(this),
	              readingData: readings,
	              chapterData: chapters,
	              filerSubmit: this._filerQuestionsByChapter.bind(this),
	              resetAllQuestion: this.resetAllQuestion.bind(this),
	              resetAllChapter: this.resetAllChapter.bind(this),
	              selectedChapter: selectedChapter,
	              selectedAnswered: selectedAnswered,
	              selectedReading: selectedReading,
	              selectedQuestion: selectedQuestion,
	              selectedAttempts: selectedAttempts,
	              selectedAvgScore: selectedAvgScore,
	              selectedPassingScore: selectedPassingScore,
	              selectedLowerLimit: selectedLowerLimit,
	              selectedUpperLimit: selectedUpperLimit,
	              subscriptionstatus: subscriptionstatus,
	              selectedmenu: selectedmenu
	            })
	          )
	        ),
	        _react2.default.createElement(_CommonDetailStatus2.default, {
	          onChangePagination: this.setSelectedPagination.bind(this),
	          allQuestionData: allQuestion,
	          totalQuestions: totalQuestions,
	          currentPage: currentPage,
	          pageLimit: pageLimit,
	          pageNeighbours: pageNeighbours,
	          questionLowerLimit: questionLowerLimit,
	          questionUpperLimit: questionUpperLimit,
	          loader: loader,
	          subscriptionstatus: subscriptionstatus,
	          selectedmenu: selectedmenu,
	          level: level
	        })
	      );
	    }
	  }]);
	
	  return ViewFrm2AllQues;
	}(_react.Component);
	
	exports.default = ViewFrm2AllQues;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _CommonDetailStatus = __webpack_require__(184);
	
	var _CommonDetailStatus2 = _interopRequireDefault(_CommonDetailStatus);
	
	var _CommonFilter = __webpack_require__(185);
	
	var _CommonFilter2 = _interopRequireDefault(_CommonFilter);
	
	var _FrmSubscription = __webpack_require__(49);
	
	var _FrmSubscription2 = _interopRequireDefault(_FrmSubscription);
	
	var _FrmSubscription3 = __webpack_require__(50);
	
	var _FrmSubscription4 = _interopRequireDefault(_FrmSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ScrollUpButton from "react-scroll-up-button";
	
	/* eslint-disable*/
	var ViewFrmAllQues = function (_Component) {
	  _inherits(ViewFrmAllQues, _Component);
	
	  function ViewFrmAllQues(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewFrmAllQues);
	
	    var _this = _possibleConstructorReturn(this, (ViewFrmAllQues.__proto__ || Object.getPrototypeOf(ViewFrmAllQues)).call(this, props));
	
	    _this.setSelectedChapter = function (e) {
	      var chapterId = e.target.value;
	      _this.setState({
	        selectedChapter: e.target.value,
	        selectedQuestion: ''
	      });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        chapter: chapterId,
	        reading: _this.state.selectedReading
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReadings', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({ readings: resp.readings }, function () {});
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.setSelectedReading = function (e) {
	      _this.setState({ selectedReading: e.target.value, selectedQuestion: '' });
	    };
	
	    _this.setSelectedQuestion = function (e) {
	      _this.setState({
	        selectedQuestion: e.target.value,
	        selectedChapter: '',
	        selectedReading: '',
	        selectedAnswered: '',
	        selctedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: ''
	      });
	    };
	
	    _this.setSelectedAnswered = function (e) {
	      _this.setState({ selectedAnswered: e.target.value });
	    };
	
	    _this.setSelectedNoOfAttempts = function (e) {
	      _this.setState({ selectedAttempts: e.target.value });
	    };
	
	    _this.setSelectedPagination = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(page, data) {
	        var pageMinusOne, questionLowerLimit, questionUpperLimit;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.setState({
	                  totalPages: data.totalPages,
	                  pageLimit: data.pageLimit,
	                  totalQuestions: data.totalQuestions,
	                  currentPage: page,
	                  loader: true
	                });
	                pageMinusOne = page - 1;
	                questionLowerLimit = pageMinusOne * 20;
	                questionUpperLimit = pageMinusOne * 20 + 20;
	
	                _this.setState({
	                  questionLowerLimit: questionLowerLimit,
	                  questionUpperLimit: questionUpperLimit
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                  var storage_session, data;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                          _this.setState({
	                            idname: storage_session['idname'],
	                            token: storage_session['token']
	                          });
	                          data = {
	                            token: storage_session['token'],
	                            idname: storage_session['idname'],
	                            chapter: _this.state.selectedChapter,
	                            reading: _this.state.selectedReading,
	                            question: _this.state.selectedQuestion,
	                            selectedAnswered: _this.state.selectedAnswered,
	                            selectedAttempts: _this.state.selectedAttempts,
	                            selectedAvgScore: _this.state.selectedAvgScore,
	                            selectedLowerLimit: _this.state.selectedLowerLimit,
	                            selectedUpperLimit: _this.state.selectedUpperLimit,
	                            selectedPassingScore: _this.state.selectedPassingScore,
	                            questionLowerLimit: _this.state.questionLowerLimit,
	                            questionUpperLimit: _this.state.questionUpperLimit,
	                            subscriptionstatus: _this.state.subscriptionstatus,
	                            level: _this.state.level
	                          };
	                          _context.next = 5;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                            if (resp.success) {
	                              window.scroll(0, 0);
	
	                              _this.setState({ ValidToken: true });
	
	                              _this.setState({
	                                allQuestion: resp.allQuestions,
	                                totalQuestions: resp.totalQuestions,
	                                loader: false,
	                                selectedLevel: _this.state.selectedLevel
	                              }, function () {
	                                _reactRouter.browserHistory.push('/frm/viewallquestions/?sQ=' + _this.state.selectedQuestion + '&c=' + _this.state.selectedChapter + '&s=' + _this.state.selectedReading + '&sAns=' + _this.state.selectedAnswered + '&sAtt=' + _this.state.selectedAttempts + '&sAvgS=' + _this.state.selectedAvgScore + '&sLl=' + _this.state.selectedLowerLimit + '&sUl=' + _this.state.selectedUpperLimit + '&sPs=' + _this.state.selectedUpperLimit + '&sQll=' + _this.state.questionLowerLimit + '&sQul=' + _this.state.questionUpperLimit);
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                          });
	
	                        case 5:
	                          _context.next = 7;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(function (resp) {
	                            if (resp.success) {
	                              _this.setState({ chapters: resp.chapters }, function () {});
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                          });
	
	                        case 7:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                })));
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.setSelectedChangeAvgScores = function (e) {
	      if (e.target.value === '0') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '0',
	          selectedUpperLimit: '25'
	        });
	      }
	
	      if (e.target.value === '1') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '25',
	          selectedUpperLimit: '50'
	        });
	      } else if (e.target.value === '2') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '50',
	          selectedUpperLimit: '70'
	        });
	      } else if (e.target.value === '3') {
	        _this.setState({
	          selectedAvgScore: e.target.value,
	          selectedLowerLimit: '70',
	          selectedUpperLimit: '100'
	        });
	      }
	    };
	
	    _this.setSelectedChangePass = function (e) {
	      _this.setState({ selectedPassingScore: e.target.value });
	    };
	
	    _this.resetAllQuestion = function () {
	      _this.setState({
	        selectedChapter: '',
	        selectedReading: '',
	        selectedQuestion: '',
	        selectedAnswered: '',
	        selectedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: '',
	        selectedLowerLimit: '',
	        selectedUpperLimit: '',
	        questionLowerLimit: '0',
	        questionUpperLimit: '20',
	        readings: [],
	        loader: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                _this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: _this.state.selectedChapter,
	                  reading: _this.state.selectedReading,
	                  question: _this.state.selectedQuestion,
	                  selectedAnswered: _this.state.selectedAnswered,
	                  selectedAttempts: _this.state.selectedAttempts,
	                  selectedAvgScore: _this.state.selectedAvgScore,
	                  selectedLowerLimit: _this.state.selectedLowerLimit,
	                  selectedUpperLimit: _this.state.selectedUpperLimit,
	                  selectedPassingScore: _this.state.selectedPassingScore,
	                  questionLowerLimit: _this.state.questionLowerLimit,
	                  questionUpperLimit: _this.state.questionUpperLimit,
	                  subscriptionstatus: _this.state.subscriptionstatus,
	                  level: _this.state.level
	                };
	                _context3.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp)
	                    _this.setState({ ValidToken: true });
	                    //   console.log(typeof resp.allQuestions)
	                    _this.setState({
	                      allQuestion: resp.allQuestions,
	                      totalQuestions: resp.totalQuestions,
	                      loader: false,
	                      selectedLevel: _this.state.selectedLevel
	                    }, function () {
	                      _reactRouter.browserHistory.push('/frm/viewallquestions/?sQ=' + _this.state.selectedQuestion + '&c=' + _this.state.selectedChapter + '&s=' + _this.state.selectedReading + '&sAns=' + _this.state.selectedAnswered + '&sAtt=' + _this.state.selectedAttempts + '&sAvgS=' + _this.state.selectedAvgScore + '&sLl=' + _this.state.selectedLowerLimit + '&sUl=' + _this.state.selectedUpperLimit + '&sPs=' + _this.state.selectedUpperLimit + '&sQll=' + _this.state.questionLowerLimit + '&sQul=' + _this.state.questionUpperLimit + '&searchBy=questionID');
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 5:
	                _context3.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ chapters: resp.chapters }, function () {});
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      })));
	    };
	
	    _this.resetAllChapter = function () {
	      _this.setState({
	        selectedChapter: '',
	        selectedReading: '',
	        selectedQuestion: '',
	        selectedAnswered: '',
	        selectedAttempts: '',
	        selectedAvgScore: '',
	        selectedPassingScore: '',
	        selectedLowerLimit: '',
	        selectedUpperLimit: '',
	        questionLowerLimit: '0',
	        questionUpperLimit: '20',
	        readings: [],
	        loader: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                _this.setState({ idname: storage_session['idname'] });
	                _this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: _this.state.selectedChapter,
	                  reading: _this.state.selectedReading,
	                  question: _this.state.selectedQuestion,
	                  selectedAnswered: _this.state.selectedAnswered,
	                  selectedAttempts: _this.state.selectedAttempts,
	                  selectedAvgScore: _this.state.selectedAvgScore,
	                  selectedLowerLimit: _this.state.selectedLowerLimit,
	                  selectedUpperLimit: _this.state.selectedUpperLimit,
	                  selectedPassingScore: _this.state.selectedPassingScore,
	                  questionLowerLimit: _this.state.questionLowerLimit,
	                  questionUpperLimit: _this.state.questionUpperLimit,
	                  subscriptionstatus: _this.state.subscriptionstatus,
	                  level: _this.state.level
	                };
	                _context4.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ ValidToken: true });
	                    _this.setState({
	                      allQuestion: resp.allQuestions,
	                      totalQuestions: resp.totalQuestions,
	                      loader: false,
	                      selectedLevel: _this.state.selectedLevel
	                    }, function () {
	                      _reactRouter.browserHistory.push('/frm/viewallquestions/?sQ=' + _this.state.selectedQuestion + '&c=' + _this.state.selectedChapter + '&s=' + _this.state.selectedReading + '&sAns=' + _this.state.selectedAnswered + '&sAtt=' + _this.state.selectedAttempts + '&sAvgS=' + _this.state.selectedAvgScore + '&sLl=' + _this.state.selectedLowerLimit + '&sUl=' + _this.state.selectedUpperLimit + '&sPs=' + _this.state.selectedUpperLimit + '&sQll=' + _this.state.questionLowerLimit + '&sQul=' + _this.state.questionUpperLimit + '&searchBy=chapterID');
	                    });
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 6:
	                _context4.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ chapters: resp.chapters }, function () {});
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      })));
	    };
	
	    _this.state = {
	      allQuestion: [],
	      selectedChapter: '',
	      selectedReading: '',
	      selectedQuestion: '',
	      selectedAnswered: '',
	      selectedAttempts: '',
	      selectedAvgScore: '',
	      selectedPassingScore: '',
	      selectedLowerLimit: '',
	      selectedUpperLimit: '',
	      readings: [],
	      chapters: [],
	      totalQuestions: '',
	      currentPage: 1,
	      pageLimit: 20,
	      pageNeighbours: 1,
	      questionLowerLimit: 0,
	      questionUpperLimit: 20,
	      loader: true,
	      url: new URL(window.location.href),
	      subscriptionstatus: '',
	      selectedmenu: 'frm',
	      selectedmen: '',
	      selectedLevel: 'frm1',
	      level: '1'
	    };
	    return _this;
	  }
	
	  _createClass(ViewFrmAllQues, [{
	    key: '_filerQuestionsByChapter',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                this.setState({ loader: true });
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  chapter: this.state.selectedChapter,
	                  reading: this.state.selectedReading,
	                  question: this.state.selectedQuestion,
	                  selectedAnswered: this.state.selectedAnswered,
	                  selectedAttempts: this.state.selectedAttempts,
	                  selectedAvgScore: this.state.selectedAvgScore,
	                  selectedLowerLimit: this.state.selectedLowerLimit,
	                  selectedUpperLimit: this.state.selectedUpperLimit,
	                  selectedPassingScore: this.state.selectedPassingScore,
	                  questionLowerLimit: this.state.questionLowerLimit,
	                  questionUpperLimit: this.state.questionUpperLimit,
	                  subscriptionstatus: this.state.subscriptionstatus,
	                  level: this.state.level
	                };
	                _context5.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({
	                      allQuestion: resp.allQuestions,
	                      totalQuestions: resp.totalQuestions,
	                      loader: false,
	                      selectedLevel: _this3.state.selectedLevel
	                    }, function () {
	                      _reactRouter.browserHistory.push('/frm/viewallquestions/?sQ=' + _this3.state.selectedQuestion + '&c=' + _this3.state.selectedChapter + '&s=' + _this3.state.selectedReading + '&sAns=' + _this3.state.selectedAnswered + '&sAtt=' + _this3.state.selectedAttempts + '&sAvgS=' + _this3.state.selectedAvgScore + '&sLl=' + _this3.state.selectedLowerLimit + '&sUl=' + _this3.state.selectedUpperLimit + '&sPs=' + _this3.state.selectedUpperLimit + '&sQll=' + _this3.state.questionLowerLimit + '&sQul=' + _this3.state.questionUpperLimit);
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function _filerQuestionsByChapter() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return _filerQuestionsByChapter;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this4 = this,
	            _data;
	
	        var storage_session, dataChapter, user_data, data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                if (!(this.state.url.searchParams.get('c') !== null || this.state.url.searchParams.get('sQ') !== null)) {
	                  _context12.next = 5;
	                  break;
	                }
	
	                _context12.next = 3;
	                return this.setState({
	                  selectedQuestion: this.state.url.searchParams.get('sQ'),
	                  selectedChapter: this.state.url.searchParams.get('c'),
	                  selectedReading: this.state.url.searchParams.get('s'),
	                  selectedAnswered: this.state.url.searchParams.get('sAns'),
	                  selectedAttempts: this.state.url.searchParams.get('sAtt'),
	                  selectedAvgScore: this.state.url.searchParams.get('sAvgS'),
	                  selectedLowerLimit: this.state.url.searchParams.get('sLl'),
	                  selectedUpperLimit: this.state.url.searchParams.get('sUl'),
	                  selectedPassingScore: this.state.url.searchParams.get('sPs'),
	                  questionLowerLimit: this.state.url.searchParams.get('sQll'),
	                  questionUpperLimit: this.state.url.searchParams.get('sQul')
	                });
	
	              case 3:
	                _context12.next = 6;
	                break;
	
	              case 5:
	                null;
	
	              case 6:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                dataChapter = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.selectedChapter
	                };
	                user_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context12.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context8.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, examPlanData;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 11;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = '1';
	                                        isInArray_var = false;
	                                        examPlanData = resp_exam.examPlan[0];
	                                        _context6.next = 7;
	                                        return _FrmSubscription4.default.checkFrm(selectedmen, exam_data, examPlanData);
	
	                                      case 7:
	                                        isInArray_var = _context6.sent;
	
	                                        if (isInArray_var) {
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4.setState({ subscriptionstatus: 'free' });
	                                        }
	                                        _context6.next = 12;
	                                        break;
	
	                                      case 11:
	                                        console.log('fail');
	
	                                      case 12:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this4);
	                              }));
	
	                              return function (_x4) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }());
	
	                          case 9:
	                            _context8.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context8.next = 15;
	                              break;
	                            }
	
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context8.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (resp_exam.success) {
	                                          exam_data = resp_exam.examData;
	                                          selectedmen = '1';
	                                          isInArray_var = false;
	
	                                          isInArray_var = _FrmSubscription2.default.checkFrm(selectedmen, exam_data);
	                                          // console.log(isInArray_var)
	                                          if (isInArray_var) {
	                                            // console.log('paid')
	                                            _this4.setState({ subscriptionstatus: 'paid' });
	                                          } else {
	                                            // console.log('free')
	                                            _this4.setState({ subscriptionstatus: 'free' });
	                                          }
	                                        } else {
	                                          console.log('fail');
	                                        }
	
	                                      case 1:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this4);
	                              }));
	
	                              return function (_x5) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }());
	
	                          case 19:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this4);
	                  }));
	
	                  return function (_x3) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                data = (_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.selectedChapter,
	                  reading: this.state.selectedReading,
	                  question: this.state.selectedQuestion,
	                  selectedAnswered: this.state.selectedAnswered,
	                  selectedAttempts: this.state.selectedAttempts,
	                  selectedAvgScore: this.state.selectedAvgScore,
	                  selectedLowerLimit: this.state.selectedLowerLimit,
	                  selectedUpperLimit: this.state.selectedUpperLimit
	                }, _defineProperty(_data, 'selectedUpperLimit', this.state.selectedPassingScore), _defineProperty(_data, 'questionLowerLimit', this.state.questionLowerLimit), _defineProperty(_data, 'questionUpperLimit', this.state.questionUpperLimit), _defineProperty(_data, 'subscriptionstatus', this.state.subscriptionstatus), _data);
	                // console.log(data)
	
	                _context12.next = 15;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(function () {
	                  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                    return _regenerator2.default.wrap(function _callee9$(_context9) {
	                      while (1) {
	                        switch (_context9.prev = _context9.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp.chapters)
	                              _this4.setState({ chapters: resp.chapters }, function () {
	                                _reactRouter.browserHistory.push('/frm/viewallquestions/?sQ=' + _this4.state.selectedQuestion + '&c=' + _this4.state.selectedChapter + '&s=' + _this4.state.selectedReading + '&sAns=' + _this4.state.selectedAnswered + '&sAtt=' + _this4.state.selectedAttempts + '&sAvgS=' + _this4.state.selectedAvgScore + '&sLl=' + _this4.state.selectedLowerLimit + '&sUl=' + _this4.state.selectedUpperLimit + '&sPs=' + _this4.state.selectedUpperLimit + '&sQll=' + _this4.state.questionLowerLimit + '&sQul=' + _this4.state.questionUpperLimit);
	                              });
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                              // console.log(resp)
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context9.stop();
	                        }
	                      }
	                    }, _callee9, _this4);
	                  }));
	
	                  return function (_x6) {
	                    return _ref10.apply(this, arguments);
	                  };
	                }());
	
	              case 15:
	                _context12.next = 17;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp)
	                              _this4.setState({ ValidToken: true });
	                              _this4.setState({
	                                allQuestion: resp.allQuestions,
	                                totalQuestions: resp.totalQuestions,
	                                loader: false,
	                                selectedLevel: _this4.state.selectedLevel
	                              }, function () {});
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                              //   console.log(resp)
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this4);
	                  }));
	
	                  return function (_x7) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 17:
	                if (!(this.state.chapter !== '')) {
	                  _context12.next = 22;
	                  break;
	                }
	
	                _context12.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/frm_question_bank/getReadings', dataChapter).then(function () {
	                  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (resp.success) {
	                              // console.log(resp)
	                              _this4.setState({ ValidToken: true });
	                              _this4.setState({ readings: resp.readings }, function () {
	                                // console.log(this.state.allQuestions)
	                              });
	                            } else {
	                              _this4.setState({ ValidToken: false });
	                              // console.log(resp)
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this4);
	                  }));
	
	                  return function (_x8) {
	                    return _ref12.apply(this, arguments);
	                  };
	                }());
	
	              case 20:
	                _context12.next = 23;
	                break;
	
	              case 22:
	                null;
	
	              case 23:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(this.state.subscriptionstatus)
	      var _state = this.state,
	          readings = _state.readings,
	          allQuestion = _state.allQuestion,
	          chapters = _state.chapters,
	          selectedChapter = _state.selectedChapter,
	          selectedReading = _state.selectedReading,
	          selectedQuestion = _state.selectedQuestion,
	          selectedAnswered = _state.selectedAnswered,
	          selectedAttempts = _state.selectedAttempts,
	          selectedAvgScore = _state.selectedAvgScore,
	          selectedPassingScore = _state.selectedPassingScore,
	          selectedLowerLimit = _state.selectedLowerLimit,
	          selectedUpperLimit = _state.selectedUpperLimit,
	          questionLowerLimit = _state.questionLowerLimit,
	          questionUpperLimit = _state.questionUpperLimit,
	          totalQuestions = _state.totalQuestions,
	          pageLimit = _state.pageLimit,
	          pageNeighbours = _state.pageNeighbours,
	          currentPage = _state.currentPage,
	          loader = _state.loader,
	          subscriptionstatus = _state.subscriptionstatus,
	          selectedmenu = _state.selectedmenu,
	          level = _state.level;
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          ' ',
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 d-flex' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/GARP_logo.png',
	              className: 'garpLogo',
	              alt: 'full logo'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 top-heading-filter-toggle clrearfix' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().List_of_All_Questions_For,
	              ' FRM Part -I',
	              ' '
	            ),
	            ' ',
	            _react2.default.createElement(_CommonFilter2.default, {
	              onChangeQuestion: this.setSelectedQuestion.bind(this),
	              onChangeChapter: this.setSelectedChapter.bind(this),
	              onChangeReading: this.setSelectedReading.bind(this),
	              onChangeAnswered: this.setSelectedAnswered.bind(this),
	              onChangeNoOfAttempts: this.setSelectedNoOfAttempts.bind(this),
	              onChangeAvgScore: this.setSelectedChangeAvgScores.bind(this),
	              onChangePass: this.setSelectedChangePass.bind(this),
	              onChangePagination: this.setSelectedPagination.bind(this),
	              readingData: readings,
	              chapterData: chapters,
	              filerSubmit: this._filerQuestionsByChapter.bind(this),
	              resetAllQuestion: this.resetAllQuestion.bind(this),
	              resetAllChapter: this.resetAllChapter.bind(this),
	              selectedChapter: selectedChapter,
	              selectedAnswered: selectedAnswered,
	              selectedReading: selectedReading,
	              selectedQuestion: selectedQuestion,
	              selectedAttempts: selectedAttempts,
	              selectedAvgScore: selectedAvgScore,
	              selectedPassingScore: selectedPassingScore,
	              selectedLowerLimit: selectedLowerLimit,
	              selectedUpperLimit: selectedUpperLimit,
	              subscriptionstatus: subscriptionstatus,
	              selectedmenu: selectedmenu
	            })
	          )
	        ),
	        _react2.default.createElement(_CommonDetailStatus2.default, {
	          onChangePagination: this.setSelectedPagination.bind(this),
	          allQuestionData: allQuestion,
	          totalQuestions: totalQuestions,
	          currentPage: currentPage,
	          pageLimit: pageLimit,
	          pageNeighbours: pageNeighbours,
	          questionLowerLimit: questionLowerLimit,
	          questionUpperLimit: questionUpperLimit,
	          loader: loader,
	          subscriptionstatus: subscriptionstatus,
	          selectedmenu: selectedmenu,
	          level: level
	        })
	      );
	    }
	  }]);
	
	  return ViewFrmAllQues;
	}(_react.Component);
	
	exports.default = ViewFrmAllQues;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(79);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iterator = '';
	/* eslint-disable */
	
	var GMATDashboard = function (_Component) {
	  _inherits(GMATDashboard, _Component);
	
	  function GMATDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATDashboard);
	
	    var _this = _possibleConstructorReturn(this, (GMATDashboard.__proto__ || Object.getPrototypeOf(GMATDashboard)).call(this, props));
	
	    _this.onContactSubmit = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
	        var _this$state, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context2.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context2.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context2.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state = _this.state, idname = _this$state.idname, token = _this$state.token, contactComment = _this$state.contactComment, contactSubject = _this$state.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context2.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.handleToggle = function (event) {
	      var checked = event.target.checked;
	
	      _this.setState({ toggle: checked }, function () {
	        // console.log('type', checked, this.state.toggle);
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          type: checked ? 'content-type' : 'content-format',
	          startDate: _this.state.send_startDate,
	          endDate: _this.state.send_startDate_second
	        };
	        // FD.callAPI(
	        //   App_data.backend_api + '/gmat_dashboard/getQuestionType',
	        //   data
	        // ).then(async (resp) => {
	        //   // console.log(resp);
	        //   let content_type = [];
	        //   if (resp.success) {
	        //     resp.question_type.map((question) => {
	        //       content_type.push(question.content_type);
	        //     });
	        //     // content_type.push('Integrated Reasoning');
	
	        //     this.setState({ content_type }, () => {
	        //       this.contentTypeReportTabToggle(0);
	        //       this.contentTypeTabToggle(0);
	        //     });
	        //   }
	        // });
	        // FD.callAPI(
	        //   App_data.backend_api + '/gmat_dashboard/mainProgressbar',
	        //   data
	        // ).then((resp) => {
	        //   if (resp.success) {
	        //     var dataString = JSON.stringify(resp.chapters);
	        //     var dataReason = JSON.parse(dataString);
	
	        //     var final_array_main = [];
	
	        //     for (i = 0; i < dataReason.length; i++) {
	        //       var right_answered = dataReason[i].answered_count;
	        //       var total_question = dataReason[i].attempted_count;
	
	        //       var user_graph_val = Math.round(
	        //         (right_answered / total_question) * 100
	        //       ).toFixed(1);
	
	        //       if (user_graph_val === 'NaN') {
	        //         final_array_main.push('0.0');
	        //       } else {
	        //         final_array_main.push(user_graph_val);
	        //       }
	        //     }
	
	        //     this.setState({
	        //       bar_main_user: final_array_main,
	        //       display_main_loader: 'hide_block',
	        //     });
	        //     // console.log('part 22222---------------------', final_array_main);
	        //   } else {
	        //     this.setState({ display_main_loader: 'hide_block' });
	        //   }
	        // });
	        // FD.callAPI(
	        //   App_data.backend_api + '/gmat_dashboard/mainProgressclassbar',
	        //   data
	        // ).then((resp) => {
	        //   if (resp.success) {
	        //     var dataString = JSON.stringify(resp.chaptersclass);
	        //     var dataReason = JSON.parse(dataString);
	        //     var final_array_main = [];
	        //     for (i = 0; i < dataReason.length; i++) {
	        //       var right_answered = dataReason[i].answered_count;
	        //       var total_question = dataReason[i].attempted_count;
	        //       var user_graph_val = Math.round(
	        //         (right_answered / total_question) * 100
	        //       ).toFixed(1);
	
	        //       if (user_graph_val === 'NaN') {
	        //         final_array_main.push('0.0');
	        //       } else {
	        //         final_array_main.push(user_graph_val);
	        //       }
	        //     }
	        //     this.setState({ bar_main_class: final_array_main });
	        //   } else {
	        //     //console.log(resp.success + '------------failure');
	        //   }
	        // });
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getQuestionProgByUser', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ progress_bar_zero: resp.progressbarzero_data });
	          } else {
	            //console.log(resp.success + '------------failure');
	          }
	        });
	      });
	    };
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSavequestino = function (items, e) {
	      // console.log('items --------> ', items);
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteSaveVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: 'Hide Details' });
	      }
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({ more_detail_button: 'I Want More Details' });
	      }
	    };
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var storage_session, _this$state2, toggle, content_type, activeTabReportcards, data;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              _this$state2 = _this.state, toggle = _this$state2.toggle, content_type = _this$state2.content_type, activeTabReportcards = _this$state2.activeTabReportcards;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                // type: toggle
	                //   ? `and content_type = '${
	                //       content_type[activeTabReportcards ? activeTabReportcards : 0]
	                //     }'`
	                //   : `and content_format = '${
	                //       content_type[activeTabReportcards ? activeTabReportcards : 0]
	                //     }'`,
	                type: content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Quant' ? 'and content_type != \'Verbal\'' : 'and content_type = \'' + content_type[activeTabReportcards ? activeTabReportcards : 0] + '\''
	              };
	
	              if (!(content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Integrated Reasoning')) {
	                _context5.next = 9;
	                break;
	              }
	
	              _context5.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/get4typesReportsQuestionsbyuserid', data).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestion: resp.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x3) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	
	            case 7:
	              _context5.next = 11;
	              break;
	
	            case 9:
	              _context5.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestion: resp.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 11:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context7.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashcardsbyuserid', data).then(function () {
	                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              flashreport: resp.flash_report,
	                              flashLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this2);
	                }));
	
	                return function (_x5) {
	                  return _ref7.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	    _this.getQuestionsSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	      var storage_session, _this$state3, content_type, activeTabSavedcards, toggle, data;
	
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              _this$state3 = _this.state, content_type = _this$state3.content_type, activeTabSavedcards = _this$state3.activeTabSavedcards, toggle = _this$state3.toggle;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                // type: toggle
	                //   ? `and content_type = '${
	                //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
	                //     }'`
	                //   : `and content_format = '${
	                //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
	                //     }'`,
	                type: content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Quant' ? 'and content_type != \'Verbal\'' : 'and content_type = \'' + content_type[activeTabSavedcards ? activeTabSavedcards : 0] + '\''
	              };
	
	              if (!(content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Integrated Reasoning')) {
	                _context10.next = 9;
	                break;
	              }
	
	              _context10.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/get4typesFavQuestionsbyuserid', data).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              savedquestion: resp.questions,
	                              savedLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	
	            case 7:
	              _context10.next = 11;
	              break;
	
	            case 9:
	              _context10.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestionsbyuserid', data).then(function () {
	                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              savedquestion: resp.questions,
	                              savedLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref10.apply(this, arguments);
	                };
	              }());
	
	            case 11:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context12.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref12.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context14.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getReportsVideobyuserid', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo: resp.video });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref14.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context16.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavVideosbyuserid', data).then(function () {
	                var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(resp) {
	                  return _regenerator2.default.wrap(function _callee15$(_context15) {
	                    while (1) {
	                      switch (_context15.prev = _context15.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savedvideo: resp.cfa_videos });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context15.stop();
	                      }
	                    }
	                  }, _callee15, _this2);
	                }));
	
	                return function (_x10) {
	                  return _ref16.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	
	    _this._beginChapter = function () {
	      var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(item, e) {
	        var data, routeName, caseId, caseOffset;
	        return _regenerator2.default.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: item.question_id
	                };
	
	                if (!(item.type !== 'question')) {
	                  _context17.next = 21;
	                  break;
	                }
	
	                routeName = void 0;
	                _context17.t0 = item.type;
	                _context17.next = _context17.t0 === 'tab_question' ? 6 : _context17.t0 === 'graph_question' ? 8 : _context17.t0 === 'table_question' ? 10 : _context17.t0 === 'two_part_question' ? 12 : 14;
	                break;
	
	              case 6:
	                routeName = 'GMAT_TAB';
	                return _context17.abrupt('break', 16);
	
	              case 8:
	                routeName = 'GMAT_GRAPH_MULTI_STATEMENT';
	                return _context17.abrupt('break', 16);
	
	              case 10:
	                routeName = 'GMAT_TABLE';
	                return _context17.abrupt('break', 16);
	
	              case 12:
	                routeName = 'GMAT_TWO_PART_STATEMENT';
	                return _context17.abrupt('break', 16);
	
	              case 14:
	                console.log('Route Name issue');
	                return _context17.abrupt('break', 16);
	
	              case 16:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reading_id: item.reading_id,
	                  question_type: item.type
	                };
	                _context17.next = 19;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId', data).then(function (resp) {
	                  if (resp.success) {
	                    console.log('I am inside resp.success');
	                    resp.result.map(function (element, index) {
	                      if (item.question_id === element.id) {
	                        _this.context.router.push({
	                          pathname: _AppRoutes2.default[routeName].replace(':chapterid', element.chapter_id).replace(':readingid', element.reading_id).replace(':subscription', _this.state.questionShowFreePremium === false ? 1 : 0).replace(':question_id', item.question_id).replace(':offset', index).replace(':reading', item.topic_name)
	                        });
	                      }
	                    });
	                  }
	                });
	
	              case 19:
	                _context17.next = 24;
	                break;
	
	              case 21:
	                caseId = 0;
	                caseOffset = 0;
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestionsbyid', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log('resp ----> ', resp.questionsbyid.case_id);
	                    if (resp.questionsbyid.case_id) {
	                      data['case_id'] = resp.questionsbyid.case_id;
	                      data['reading_id'] = resp.questionsbyid.reading_id;
	                      data['subscriptionstatus'] = _this.state.questionShowFreePremium ? 'free' : 'paid';
	                      data['limit'] = 1;
	                      data['offset'] = 0;
	                      data['chapter_id'] = resp.questionsbyid.chapter_id;
	                      // console.log(data);
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCaseByReading', data).then(function (response) {
	                        if (response.success) {
	                          if (response.questions && response.questions.length) {
	                            response.questions.map(function (elementCase, indexCase) {
	                              if (parseInt(elementCase.case_id, 10) === parseInt(resp.questionsbyid.case_id, 10)) {
	                                caseId = elementCase.case_id;
	                                caseOffset = indexCase;
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCasesquestion', data).then(function (result) {
	                                  // console.log('result ------> ', result);
	                                  if (result.success) {
	                                    if (result.questions_details && result.questions_details.length) {
	                                      result.questions_details.map(function (element, index) {
	                                        if (parseInt(element.id, 10) === parseInt(item.question_id, 10)) {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', element.chapter_id).replace(':readingid', element.reading_id).replace(':caseid', element.case_id).replace(':case_offset', caseOffset).replace(':subscription', _this.state.questionShowFreePremium ? 0 : 1).replace(':question_number',
	                                            // element.question_no
	                                            index + 1).replace(':offset', index)
	                                          });
	                                        }
	                                      });
	                                    }
	                                  }
	                                });
	                              }
	                            });
	                          }
	                        }
	                      });
	                    } else {
	                      _this.context.router.push({
	                        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', resp.questionsbyid.chapter_id).replace(':readingid', resp.questionsbyid.reading_id).replace(':id', item.question_id)
	                      });
	                    }
	                  } else {
	                    //console.log('Not Found');
	                  }
	                });
	
	              case 24:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this2);
	      }));
	
	      return function (_x11, _x12) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    _this._beginVideos = function () {
	      var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.video_id
	                  // chapter_id: reading.chapter_id
	                };
	                _context18.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getVideoByID', data).then(function (resp) {
	                  if (resp.success) {
	                    var _data = resp.allVideo.findIndex(function (item) {
	                      return item.id === resp.video[0].id;
	                    });
	                    _this.context.router.push({
	                      pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', resp.video[0].id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', resp.video[0].chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.video[0].chapter_id).replace(':index', _data)
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this2);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabSavedcards !== tab) {
	        _this.setState({
	          activeTabSavedcards: tab
	        });
	      }
	    };
	
	    _this.contentTypeTabToggle = function (tab) {
	      if (_this.state.activeTabSavedcards !== tab) {
	        _this.setState({
	          savedquestion: [],
	          savedLoader: true,
	          activeTabSavedcards: tab
	        }, function () {
	          return _this.getQuestionsSaved();
	        });
	      }
	    };
	
	    _this.contentTypeReportTabToggle = function (tab) {
	      if (_this.state.activeTabReportcards !== tab) {
	        // console.log('I am inside contentTypeTabToggle');
	        _this.setState({
	          reportquestion: [],
	          reportLoader: true,
	          activeTabReportcards: tab
	        }, function () {
	          return _this.getQuestionReports();
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      toggle: true,
	      token: '',
	      idname: '',
	
	      videoFlashReport: [],
	      flashreport: [], //All Flash question Store
	
	      savedquestion: [],
	      savedvideo: [],
	
	      reportquestion: [],
	      reportsvideo: [],
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	      progress_bar_zero: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      // bar_chapter: '',
	      bar_main_user: [],
	      bar_main_class: [],
	      main_gmat_bar_main_user: [],
	      main_gmat_bar_main_class: [],
	      main_gmat_progress_bar_zero: [],
	      main_gmat_progress_bar: [],
	      main_gmat_progress_bar_slider: [],
	      verbal_bar_main_user: [],
	      verbal_bar_main_class: [],
	      verbal_progress_bar_zero: [],
	      verbal_progress_bar: [],
	      verbal_progress_bar_slider: [],
	      integrated_reasoning_bar_main_user: [],
	      integrated_reasoning_bar_main_class: [],
	      integrated_reasoning_progress_bar_zero: [],
	      integrated_reasoning_progress_bar: [],
	      integrated_reasoning_progress_bar_slider: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      reportAnswerId: '',
	      subreadings_status: false,
	      display_main_loader: 'show_block',
	      display_loader: 'hide_block',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      ErrorMessage: '',
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      activeTabSavedcards: 0,
	      activeTabReportcards: 0,
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      type: '',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      showFreePremium: false,
	      selectedmenu: 'gmat',
	      isVideo: true,
	      qpLoader: true,
	      npLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	      content_type: ['Quant', 'Verbal', 'Integrated Reasoning'],
	      questionShowFreePremium: true
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATDashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, data, e) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: data
	      });
	    }
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment,
	        type: 'quesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        videoReport: item.comment,
	        type: 'videoReport'
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: data.id,
	          contactType: type,
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'toggleDone',
	    value: function () {
	      var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee25() {
	        var _this3 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee25$(_context25) {
	          while (1) {
	            switch (_context25.prev = _context25.next) {
	              case 0:
	                if (!(this.state.item_status == 'flashcard')) {
	                  _context25.next = 4;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context25.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteFlashCard', data).then(function () {
	                  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(resp) {
	                    return _regenerator2.default.wrap(function _callee19$(_context19) {
	                      while (1) {
	                        switch (_context19.prev = _context19.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context19.next = 5;
	                              break;
	                            }
	
	                            _context19.next = 3;
	                            return _this3.getQuestionFlashcards();
	
	                          case 3:
	                            _context19.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context19.stop();
	                        }
	                      }
	                    }, _callee19, _this3);
	                  }));
	
	                  return function (_x15) {
	                    return _ref20.apply(this, arguments);
	                  };
	                }());
	
	              case 4:
	                if (!(this.state.item_status == 'savedquestion')) {
	                  _context25.next = 8;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  save_question: this.state.items_val,
	                  type: this.state.items_val.type
	                };
	                _context25.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteSavequestion', data).then(function () {
	                  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(resp) {
	                    return _regenerator2.default.wrap(function _callee20$(_context20) {
	                      while (1) {
	                        switch (_context20.prev = _context20.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context20.next = 5;
	                              break;
	                            }
	
	                            _context20.next = 3;
	                            return _this3.getQuestionsSaved();
	
	                          case 3:
	                            _context20.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context20.stop();
	                        }
	                      }
	                    }, _callee20, _this3);
	                  }));
	
	                  return function (_x16) {
	                    return _ref21.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	                if (!(this.state.item_status == 'savedvideos')) {
	                  _context25.next = 12;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  save_question: this.state.items_val
	                };
	                _context25.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteSaveVideo', data).then(function () {
	                  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(resp) {
	                    return _regenerator2.default.wrap(function _callee21$(_context21) {
	                      while (1) {
	                        switch (_context21.prev = _context21.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context21.next = 5;
	                              break;
	                            }
	
	                            _context21.next = 3;
	                            return _this3.getVideosSaved();
	
	                          case 3:
	                            _context21.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context21.stop();
	                        }
	                      }
	                    }, _callee21, _this3);
	                  }));
	
	                  return function (_x17) {
	                    return _ref22.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                if (!(this.state.item_status == 'Videoflashcard')) {
	                  _context25.next = 16;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context25.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteDashboardVideoFlashCard', data).then(function () {
	                  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(resp) {
	                    return _regenerator2.default.wrap(function _callee22$(_context22) {
	                      while (1) {
	                        switch (_context22.prev = _context22.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context22.next = 5;
	                              break;
	                            }
	
	                            _context22.next = 3;
	                            return _this3.getVideoFlashcards();
	
	                          case 3:
	                            _context22.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context22.stop();
	                        }
	                      }
	                    }, _callee22, _this3);
	                  }));
	
	                  return function (_x18) {
	                    return _ref23.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 16:
	                if (!(this.state.item_status == 'Reportsquestion')) {
	                  _context25.next = 20;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val,
	                  type: this.state.items_val.type
	                };
	                _context25.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteDashboardQuestionReports', data).then(function () {
	                  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(resp) {
	                    return _regenerator2.default.wrap(function _callee23$(_context23) {
	                      while (1) {
	                        switch (_context23.prev = _context23.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context23.next = 5;
	                              break;
	                            }
	
	                            _context23.next = 3;
	                            return _this3.getQuestionReports();
	
	                          case 3:
	                            _context23.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context23.stop();
	                        }
	                      }
	                    }, _callee23, _this3);
	                  }));
	
	                  return function (_x19) {
	                    return _ref24.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 20:
	                if (!(this.state.item_status == 'Reportsvideos')) {
	                  _context25.next = 24;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context25.next = 24;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteDashboardVideoReports', data).then(function () {
	                  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(resp) {
	                    return _regenerator2.default.wrap(function _callee24$(_context24) {
	                      while (1) {
	                        switch (_context24.prev = _context24.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context24.next = 5;
	                              break;
	                            }
	
	                            _context24.next = 3;
	                            return _this3.getVideoReports();
	
	                          case 3:
	                            _context24.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context24.stop();
	                        }
	                      }
	                    }, _callee24, _this3);
	                  }));
	
	                  return function (_x20) {
	                    return _ref25.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 24:
	
	                this.setState({
	                  alert_status: false
	                });
	
	              case 25:
	              case 'end':
	                return _context25.stop();
	            }
	          }
	        }, _callee25, this);
	      }));
	
	      function toggleDone() {
	        return _ref19.apply(this, arguments);
	      }
	
	      return toggleDone;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate != '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this4 = this;
	
	          // console.log(
	          //   'I am inside handleChange_second -----> ',
	          //   this.state.toggle
	          // );
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second,
	            type: this.state.toggle ? 'content-type' : 'content-format'
	          };
	
	          // -------------- ---- FOR Main Graph No. 1 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getMainGraphProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph1 = JSON.stringify(resp.chapters);
	              var dataReasonGraph1 = JSON.parse(dataStringGraph1);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReasonGraph1.length; iterator++) {
	                var right_answered = dataReasonGraph1[iterator].answered_count;
	                var total_question = dataReasonGraph1[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                main_gmat_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                main_gmat_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getMainGraphProgressClassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ main_gmat_bar_main_class: final_array_main });
	            }
	          });
	          // -------------- ---- FOR Main Graph No. 1 End ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this4.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                progress_bar_zero: resp.chapters
	              });
	              // console.log('part 22222---------------------', final_array_main);
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ bar_main_class: final_array_main });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	
	          // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getVerbalProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph3 = JSON.stringify(resp.chapters);
	              var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                var right_answered = dataReasonGraph3[iterator].answered_count;
	                var total_question = dataReasonGraph3[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                verbal_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                verbal_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getVerbalProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
	              var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                var right_answered = dataReasonGraph3[iterator].answered_count;
	                var total_question = dataReasonGraph3[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ verbal_bar_main_class: final_array_main });
	            }
	          });
	          // -------------- ---- FOR Verbal Graph No. 3 End ------------- //
	
	          // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getIntegratedReasoningProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph4 = JSON.stringify(resp.chapters);
	              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                var right_answered = dataReasonGraph4[iterator].answered_count;
	                var total_question = dataReasonGraph4[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                integrated_reasoning_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                integrated_reasoning_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getIntegratedReasoningProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
	              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                var right_answered = dataReasonGraph4[iterator].answered_count;
	                var total_question = dataReasonGraph4[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                integrated_reasoning_bar_main_class: final_array_main
	              });
	            }
	          });
	          // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
	          // FD.callAPI(
	          //   App_data.backend_api + '/gmat_dashboard/getProgressChapter',
	          //   data
	          // ).then((resp) => {
	          //   if (resp.success) {
	          //     this.setState({ progress_bar_zero: resp.chapters });
	          //   } else {
	          //     //console.log(resp.success + '------------failure');
	          //   }
	          // });
	          // FD.callAPI(
	          //   App_data.backend_api + '/gmat_dashboard/getNotesChapter',
	          //   data
	          // ).then((resp) => {
	          //   if (resp.success) {
	          //     this.setState({ bar_chapter: resp.chapters });
	          //   } else {
	          //     //console.log(resp.success + '------------failure');
	          //   }
	          // });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              _this4.setState({ progress_bar_zero: resp.progressbarzero_data });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee33() {
	        var _this5 = this;
	
	        var storage_session, data, getProfileInfoData;
	        return _regenerator2.default.wrap(function _callee33$(_context33) {
	          while (1) {
	            switch (_context33.prev = _context33.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second,
	                  type: this.state.toggle ? 'content-type' : 'content-format'
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/gmat_dashboard/getQuestionType',
	                //   data
	                // ).then(async (resp) => {
	                //   // console.log(resp);
	                //   let content_type = [];
	                //   if (resp.success) {
	                //     resp.question_type.map((question) => {
	                //       content_type.push(question.content_type);
	                //     });
	                //     // content_type.push('Integrated Reasoning');
	                //     this.setState({ content_type });
	                //   }
	                // });
	
	                _context33.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getChapters', data).then(function () {
	                  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(resp) {
	                    return _regenerator2.default.wrap(function _callee26$(_context26) {
	                      while (1) {
	                        switch (_context26.prev = _context26.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ ValidToken: true });
	                              _this5.setState({ chapters: resp.chapters });
	                            } else {
	                              _this5.setState({ ValidToken: false });
	                            }
	                            return _context26.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context26.stop();
	                        }
	                      }
	                    }, _callee26, _this5);
	                  }));
	
	                  return function (_x21) {
	                    return _ref27.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	
	                // -------------- ---- FOR Main Graph No. 1 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getMainGraphProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph1 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph1 = JSON.parse(dataStringGraph1);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReasonGraph1.length; iterator++) {
	                      var right_answered = dataReasonGraph1[iterator].answered_count;
	                      var total_question = dataReasonGraph1[iterator].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      main_gmat_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      main_gmat_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getMainGraphProgressClassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataString = JSON.stringify(resp.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReason.length; iterator++) {
	                      var right_answered = dataReason[iterator].answered_count;
	                      var total_question = dataReason[iterator].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({ main_gmat_bar_main_class: final_array_main });
	                  }
	                });
	                // -------------- ---- FOR Main Graph No. 1 End ------------- //
	                _context33.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/mainProgressbar', data).then(function () {
	                  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(resp) {
	                    var dataString, dataReason, final_array_main, right_answered, total_question, user_graph_val;
	                    return _regenerator2.default.wrap(function _callee27$(_context27) {
	                      while (1) {
	                        switch (_context27.prev = _context27.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ display_loader: 'hide_block' });
	                              dataString = JSON.stringify(resp.chapters);
	                              dataReason = JSON.parse(dataString);
	                              final_array_main = [];
	
	                              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                                right_answered = dataReason[iterator].answered_count;
	                                total_question = dataReason[iterator].attempted_count;
	                                user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	
	                                if (user_graph_val === 'NaN') {
	                                  final_array_main.push('0.0');
	                                } else {
	                                  final_array_main.push(user_graph_val);
	                                }
	                              }
	                              // console.log('hi-------------------------', final_array_main);
	                              _this5.setState({ bar_main_user: final_array_main });
	                            } else {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context27.stop();
	                        }
	                      }
	                    }, _callee27, _this5);
	                  }));
	
	                  return function (_x22) {
	                    return _ref28.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	                this.setState({ display_main_loader: 'show_block' });
	
	                _context33.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/mainProgressclassbar', data).then(function () {
	                  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(resp) {
	                    var dataStringGraph2, dataReasonGraph2, final_array_main, right_answered, total_question, user_graph_val;
	                    return _regenerator2.default.wrap(function _callee28$(_context28) {
	                      while (1) {
	                        switch (_context28.prev = _context28.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ display_main_loader: 'hide_block' });
	                              dataStringGraph2 = JSON.stringify(resp.chaptersclass);
	                              dataReasonGraph2 = JSON.parse(dataStringGraph2);
	                              final_array_main = [];
	
	                              for (iterator = 0; iterator < dataReasonGraph2.length; iterator++) {
	                                right_answered = dataReasonGraph2[iterator].answered_count;
	                                total_question = dataReasonGraph2[iterator].attempted_count;
	                                user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	
	                                if (user_graph_val === 'NaN') {
	                                  final_array_main.push('0.0');
	                                } else {
	                                  final_array_main.push(user_graph_val);
	                                }
	                              }
	                              _this5.setState({ bar_main_class: final_array_main });
	                            } else {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context28.stop();
	                        }
	                      }
	                    }, _callee28, _this5);
	                  }));
	
	                  return function (_x23) {
	                    return _ref29.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	
	                // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getVerbalProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph3 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                      var right_answered = dataReasonGraph3[iterator].answered_count;
	                      var total_question = dataReasonGraph3[iterator].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      verbal_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      verbal_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getVerbalProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
	                    var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                      var right_answered = dataReasonGraph3[iterator].answered_count;
	                      var total_question = dataReasonGraph3[iterator].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({ verbal_bar_main_class: final_array_main });
	                  }
	                });
	                // -------------- ---- FOR Verbal Graph No. 3 End ------------- //
	
	                // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getIntegratedReasoningProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph4 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                      var right_answered = dataReasonGraph4[iterator].answered_count;
	                      var total_question = dataReasonGraph4[iterator].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      integrated_reasoning_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      integrated_reasoning_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getIntegratedReasoningProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
	                    var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                      var right_answered = dataReasonGraph4[iterator].answered_count;
	                      var total_question = dataReasonGraph4[iterator].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      integrated_reasoning_bar_main_class: final_array_main
	                    });
	                  }
	                });
	                // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
	                _context33.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/getQuestionProgByUser', data).then(function () {
	                  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(resp) {
	                    return _regenerator2.default.wrap(function _callee29$(_context29) {
	                      while (1) {
	                        switch (_context29.prev = _context29.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({
	                                progress_bar_zero: resp.progressbarzero_data,
	                                qpLoader: false
	                              });
	                            } else {
	                              //console.log(resp.success + '------------failure');
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context29.stop();
	                        }
	                      }
	                    }, _callee29, _this5);
	                  }));
	
	                  return function (_x24) {
	                    return _ref30.apply(this, arguments);
	                  };
	                }());
	
	              case 20:
	                _context33.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function () {
	                  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(resp) {
	                    return _regenerator2.default.wrap(function _callee30$(_context30) {
	                      while (1) {
	                        switch (_context30.prev = _context30.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ ValidToken: true });
	                            } else {
	                              _this5.setState({ ValidToken: false });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context30.stop();
	                        }
	                      }
	                    }, _callee30, _this5);
	                  }));
	
	                  return function (_x25) {
	                    return _ref31.apply(this, arguments);
	                  };
	                }());
	
	              case 22:
	                getProfileInfoData = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context33.next = 25;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', getProfileInfoData).then(function () {
	                  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee32$(_context32) {
	                      while (1) {
	                        switch (_context32.prev = _context32.next) {
	                          case 0:
	                            if (resp.profileInfo) {
	                              _this5.setState({
	                                isVideo: resp.profileInfo.isVideo
	                              });
	                            }
	
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context32.next = 14;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context32.next = 6;
	                              break;
	                            }
	
	                            _this5.setState({
	                              showFreePremium: true
	                            });
	                            _context32.next = 12;
	                            break;
	
	                          case 6:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this5.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this5.state.token,
	                              idname: _this5.state.idname,
	                              examid: data_arr
	                            };
	                            _context32.next = 12;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, queSubscription;
	                                return _regenerator2.default.wrap(function _callee31$(_context31) {
	                                  while (1) {
	                                    switch (_context31.prev = _context31.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context31.next = 14;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this5.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context31.next = 6;
	                                        return _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context31.sent;
	
	                                        if (isInArray_var) {
	                                          _this5.setState({ showFreePremium: false });
	                                        } else {
	                                          _this5.setState({ showFreePremium: true });
	                                        }
	                                        // Question Subscription
	                                        _context31.next = 10;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                      case 10:
	                                        queSubscription = _context31.sent;
	
	                                        if (queSubscription) {
	                                          _this5.setState({ questionShowFreePremium: false });
	                                        } else {
	                                          _this5.setState({
	                                            questionShowFreePremium: true
	                                          });
	                                        }
	                                        _context31.next = 14;
	                                        break;
	
	                                      case 14:
	                                      case 'end':
	                                        return _context31.stop();
	                                    }
	                                  }
	                                }, _callee31, _this5);
	                              }));
	
	                              return function (_x27) {
	                                return _ref33.apply(this, arguments);
	                              };
	                            }());
	
	                          case 12:
	                            _context32.next = 24;
	                            break;
	
	                          case 14:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context32.next = 18;
	                              break;
	                            }
	
	                            _this5.setState({
	                              showFreePremium: true
	                            });
	                            _context32.next = 24;
	                            break;
	
	                          case 18:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this5.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this5.state.token,
	                              idname: _this5.state.idname,
	                              examid: data_arr
	                            };
	                            _context32.next = 24;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this5.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                                console.log(' in GMAT dashboard ', selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                                if (isInArray_var) {
	                                  _this5.setState({ showFreePremium: false });
	                                } else {
	                                  _this5.setState({ showFreePremium: true });
	                                }
	                                var queSubscription = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                                if (queSubscription) {
	                                  _this5.setState({
	                                    questionShowFreePremium: false
	                                  });
	                                } else {
	                                  _this5.setState({
	                                    questionShowFreePremium: true
	                                  });
	                                }
	                              } else {}
	                            });
	
	                          case 24:
	                          case 'end':
	                            return _context32.stop();
	                        }
	                      }
	                    }, _callee32, _this5);
	                  }));
	
	                  return function (_x26) {
	                    return _ref32.apply(this, arguments);
	                  };
	                }());
	
	              case 25:
	                _context33.next = 27;
	                return this.getQuestionFlashcards();
	
	              case 27:
	                _context33.next = 29;
	                return this.getVideoFlashcards();
	
	              case 29:
	                _context33.next = 31;
	                return this.getQuestionsSaved();
	
	              case 31:
	                _context33.next = 33;
	                return this.getVideosSaved();
	
	              case 33:
	                _context33.next = 35;
	                return this.getQuestionReports();
	
	              case 35:
	                _context33.next = 37;
	                return this.getVideoReports();
	
	              case 37:
	              case 'end':
	                return _context33.stop();
	            }
	          }
	        }, _callee33, this);
	      }));
	
	      function componentDidMount() {
	        return _ref26.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    // function for get  question report
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  video report
	
	
	    /*
	     * get saved all video
	     */
	
	
	    /*
	     * function for go to specific   question main page
	     */
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      // console.log(
	      //   'this.state.progress_bar_zero-------',
	      //   this.state.progress_bar_zero
	      // );
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(event) {
	        var _this6 = this;
	
	        var _state, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee35$(_context35) {
	          while (1) {
	            switch (_context35.prev = _context35.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context35.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context35.abrupt('return');
	
	              case 4:
	                _state = this.state, reportEditId = _state.reportEditId, idname = _state.idname, token = _state.token, quesReport = _state.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context35.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(resp) {
	                    return _regenerator2.default.wrap(function _callee34$(_context34) {
	                      while (1) {
	                        switch (_context34.prev = _context34.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context34.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context34.next = 4;
	                            return _this6.getQuestionReports();
	
	                          case 4:
	                            _context34.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context34.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context34.stop();
	                        }
	                      }
	                    }, _callee34, _this6);
	                  }));
	
	                  return function (_x29) {
	                    return _ref35.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context35.stop();
	            }
	          }
	        }, _callee35, this);
	      }));
	
	      function handleQuestionReportSubmit(_x28) {
	        return _ref34.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(event) {
	        var _this7 = this;
	
	        var _state2, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee37$(_context37) {
	          while (1) {
	            switch (_context37.prev = _context37.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context37.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context37.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, videoReport = _state2.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context37.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(resp) {
	                    return _regenerator2.default.wrap(function _callee36$(_context36) {
	                      while (1) {
	                        switch (_context36.prev = _context36.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context36.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context36.next = 4;
	                            return _this7.getVideoReports();
	
	                          case 4:
	                            _context36.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context36.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context36.stop();
	                        }
	                      }
	                    }, _callee36, _this7);
	                  }));
	
	                  return function (_x31) {
	                    return _ref37.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context37.stop();
	            }
	          }
	        }, _callee37, this);
	      }));
	
	      function handleVideoReportSubmit(_x30) {
	        return _ref36.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          activeTabSavedcards = _state3.activeTabSavedcards,
	          activeTabSaved = _state3.activeTabSaved,
	          activeTabReports = _state3.activeTabReports,
	          isVideo = _state3.isVideo,
	          qpLoader = _state3.qpLoader,
	          npLoader = _state3.npLoader,
	          savedLoader = _state3.savedLoader,
	          flashLoader = _state3.flashLoader,
	          reportLoader = _state3.reportLoader,
	          toggle = _state3.toggle,
	          activeTabReportcards = _state3.activeTabReportcards;
	
	
	      var flashreport_val = this.state.flashreport;
	      var video_flashreport_val = this.state.videoFlashReport;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savedvideo_val = this.state.savedvideo;
	
	      var reportquestion_val = this.state.reportquestion;
	      var reportvideo_val = this.state.reportsvideo;
	
	      var flashcard_data = '';
	      var video_flashcard_data = '';
	
	      var savedquestion_data = '';
	      var savedvideo_data = '';
	
	      var question_reportsData = ''; // for question reports
	      var video_reportsData = ''; // for video report
	
	      // ------------------ FOR Graph 1 Start ----------------//
	      var main_gmat_bar_val = this.state.main_gmat_progress_bar_zero;
	      var main_gmat_bar_percentage = this.state.main_gmat_bar_main_user;
	
	      var main_gmat_bar_user_percentage = this.state.main_gmat_bar_main_class;
	
	      var main_gmat_main_bar_data = [];
	      var i = 0;
	      main_gmat_bar_val.map(function (data) {
	        main_gmat_main_bar_data[i] = data.chapter_name;
	        i++;
	      });
	      var main_gmat_bar_data = {
	        labels: main_gmat_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_gmat_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_gmat_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 1 End ----------------//
	      /*first main graph*/
	      var main_bar_val = this.state.progress_bar_zero;
	      var main_bar_percentage = this.state.bar_main_user;
	
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	      Object.keys(main_bar_val).map(function (key) {
	        // var dataStringGraph2 = JSON.stringify(main_bar_val[key]);
	        // var dataReasonGraph2 = JSON.parse(dataStringGraph2);
	        // console.log('dataReasonGraph2 parse------> ', dataReasonGraph2);
	        // console.log('dataStringGraph2 stringify ------> ', dataReasonGraph2);
	
	        if (main_bar_val[key].chapter_name !== 'Integrated Reasoning' && main_bar_val[key].chapter_name !== 'Verbal') {
	          if (main_bar_val[key].chapter_name) {
	            main_bar_data[i] = main_bar_val[key].chapter_name;
	            i++;
	          }
	        }
	      });
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 3 Start ----------------//
	      var verbal_bar_val = this.state.verbal_progress_bar_zero;
	      var verbal_bar_percentage = this.state.verbal_bar_main_user;
	
	      var verbal_bar_user_percentage = this.state.verbal_bar_main_class;
	
	      var verbal_main_bar_data = [];
	      var i = 0;
	      verbal_bar_val.map(function (data) {
	        verbal_main_bar_data[i] = data.chapter_name;
	        i++;
	      });
	      var verbal_bar_data = {
	        labels: verbal_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: verbal_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: verbal_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 3 End ----------------//
	
	      // ------------------ FOR Graph 4 Start ----------------//
	      var integrated_reasoning_bar_val = this.state.integrated_reasoning_progress_bar_zero;
	      var integrated_reasoning_bar_percentage = this.state.integrated_reasoning_bar_main_user;
	
	      var integrated_reasoning_bar_user_percentage = this.state.integrated_reasoning_bar_main_class;
	
	      var integrated_reasoning_main_bar_data = [];
	      var i = 0;
	      integrated_reasoning_bar_val.map(function (data) {
	        integrated_reasoning_main_bar_data[i] = data.chapter_name.substring(0, 20);
	        i++;
	      });
	      var integrated_reasoning_bar_data = {
	        labels: integrated_reasoning_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: integrated_reasoning_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: integrated_reasoning_bar_user_percentage
	        }]
	      };
	
	      // ------------------ FOR Graph 4 End ----------------//
	
	      /*other graph*/
	      // let chapters = this.state.progress_bar_zero;
	      var chapters = this.state.progress_bar_zero;
	
	      var reading_data = '';
	      // alert(this.state.subreadings_status);
	      if (this.state.progress_bar_zero.length && !this.state.subreadings_status) {
	        chapters.reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	          );
	        });
	      }
	      if (this.state.progress_bar_zero.length && this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	            )
	          );
	        });
	      }
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteVideoFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSavequestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_QUESTIONS,
	          ' '
	        );
	      }
	
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSaveVideo.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditQuesReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleQuestionReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this8.toggleAlertReport.bind(_this8, items, 'quesReport'),
	                  className: _this8.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsquestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditVideoReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleVideoReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8.toggleAlertReport.bind(_this8, items, 'videoReport'),
	                    className: _this8.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsVideo.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  'GMAT Dashboard'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE_BY_AREA,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: main_gmat_bar_data,
	                      options: {
	                        maintainAspectRatio: false,
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUANT_PROBLEM,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: {
	                        maintainAspectRatio: false,
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().VERBAL_PROBLEM,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: verbal_bar_data,
	                      options: {
	                        maintainAspectRatio: false,
	                        // animation: {
	                        //   duration: 1000,
	
	                        //   from: 1,
	                        //   to: 0,
	                        //   easing: 'linear',
	                        // },
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().INTEGRATED_REASONING_QUESTIONS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: integrated_reasoning_bar_data,
	                      options: {
	                        maintainAspectRatio: false,
	                        // animation: {
	                        //   duration: 1000,
	
	                        //   from: 1,
	                        //   to: 0,
	                        //   easing: 'linear',
	                        // },
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: 'dashboard-card-header-tab ' + (activeTabSaved === '1' ? 'mb-1' : '')
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: 'auto' } },
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                activeTabSaved === '1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    this.state.content_type.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          onClick: function onClick() {
	                            _this8.contentTypeTabToggle(index);
	                          },
	                          key: index,
	                          className: activeTabSavedcards === index ? 'active' : ''
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          ' ',
	                          item,
	                          ' '
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : // : this.state.activeTabSaved === '2'
	                      // ? savednotes_data
	                      savedvideo_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: 'dashboard-card-header-tab ' + (activeTabReports === '1' ? 'mb-1' : '')
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: 'auto' } },
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                activeTabReports === '1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    this.state.content_type.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          onClick: function onClick() {
	                            _this8.contentTypeReportTabToggle(index);
	                          },
	                          key: index,
	                          className: activeTabReportcards === index ? 'active' : ''
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          ' ',
	                          item,
	                          ' '
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : // : this.state.activeTabReports === '2'
	                      // ? notes_reportsData
	                      this.state.activeTabReports === '3' ? video_reportsData : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.toggleClose },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        this.state.display_loader === 'hide_block' ? null : _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return GMATDashboard;
	}(_react.Component);
	
	GMATDashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var bar_data_sub = [];
	var reading_text = '';
	function Barget(props) {
	  if (props.subreadings_status && props.endDate != '') {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: props.startDate,
	      endDate: props.endDate
	    };
	  } else {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: '',
	      endDate: ''
	    };
	  }
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/subProgressbar', data).then(function (resp) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_dashboard/subProgressbarofclass', data).then(function (resp_class) {
	      /*class variable */
	      var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
	      var dataReason_class = JSON.parse(dataString_class);
	
	      var final_array_main_class = [];
	
	      for (iterator = 0; iterator < dataReason_class.length; iterator++) {
	        var right_answered_class = dataReason_class[iterator].right_answer;
	        var total_question_class = dataReason_class[iterator].total_questions;
	        var user_graph_val_class = (right_answered_class / total_question_class * 100).toFixed(2);
	        final_array_main_class.push(user_graph_val_class);
	      }
	      /*user variable*/
	      var dataString = JSON.stringify(resp.readingwisebar_ret);
	      var dataReason = JSON.parse(dataString);
	
	      var final_array_main = [];
	      var reading_text = [];
	
	      for (iterator = 0; iterator < dataReason.length; iterator++) {
	        var right_answered = dataReason[iterator].right_answer;
	        var total_question = dataReason[iterator].total_questions;
	
	        var user_graph_val = (right_answered / total_question * 100).toFixed(2);
	
	        final_array_main.push(user_graph_val);
	        reading_text.push(dataReason[iterator].reading);
	      }
	
	      bar_data_sub[props.answered_state] = {
	        labels: reading_text,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(114,195,250)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(114,195,250)',
	          data: final_array_main
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: final_array_main_class
	        }]
	      };
	    });
	  });
	  return _react2.default.createElement(_reactChartjs.Bar, { data: bar_data_sub[props.answered_state], options: { maintainAspectRatio: false } });
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATDashboard;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(6);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { getDeviceDetails } from '../../common/deviceDetails';
	
	
	/* eslint-disable*/
	var GMATBeginchapters = function (_Component) {
	  _inherits(GMATBeginchapters, _Component);
	
	  function GMATBeginchapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATBeginchapters);
	
	    var _this = _possibleConstructorReturn(this, (GMATBeginchapters.__proto__ || Object.getPrototypeOf(GMATBeginchapters)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.notesid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.notesid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.questions.name)
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      _this.setState({ clicked: false });
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (i === 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      }
	      var questions = _this.state.questions;
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      if (questions.right_choice == 'choice_a') {
	        _this.setState({ choice_name: 'A' });
	      } else if (questions.right_choice == 'choice_b') {
	        _this.setState({ choice_name: 'B' });
	      } else if (questions.right_choice == 'choice_c') {
	        _this.setState({ choice_name: 'C' });
	      } else if (questions.right_choice == 'choice_d') {
	        _this.setState({ choice_name: 'D' });
	      } else if (questions.right_choice == 'choice_e') {
	        _this.setState({ choice_name: 'E' });
	      }
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i)
	
	        // '/beginchapter/' +
	        // this.props.params.notesid +
	        // '/' +
	        // this.props.params.readingid +
	        // '/' +
	        // next_question_id +
	        // '/' +
	        // i,
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      _this.setState({ clicked: false });
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	      // alert(i);
	      //console.log(this.props.params.readingid);
	      _this.setState({ offset: i });
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	
	      if (parseInt(_this.state.question_length) - 1 === i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i != 0) {
	        _this.setState({ previ_block: '' });
	      }
	      var questions = _this.state.questions;
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      if (questions.right_choice == 'choice_a') {
	        _this.setState({ choice_name: 'A' });
	      } else if (questions.right_choice == 'choice_b') {
	        _this.setState({ choice_name: 'B' });
	      } else if (questions.right_choice == 'choice_c') {
	        _this.setState({ choice_name: 'C' });
	      } else if (questions.right_choice == 'choice_d') {
	        _this.setState({ choice_name: 'D' });
	      } else if (questions.right_choice == 'choice_e') {
	        _this.setState({ choice_name: 'E' });
	      }
	      var next_question_id = _this.state.all_questions_state[i].id;
	      // console.log(this.state.token)
	      // console.log(this.state.idname)
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i)
	
	        // '/beginchapter/' +
	        // this.props.params.notesid +
	        // '/' +
	        // this.props.params.readingid +
	        // '/' +
	        // next_question_id +
	        // '/' +
	        // i,
	      });
	    };
	
	    _this._getAnswer = function (choice, e) {
	      _this.setState({ clicked: true });
	      _this.setState({ choice: choice });
	      // const result = getDeviceDetails();
	
	      if (choice === 'choice_a') {
	        _this.setState({ choice_a: 'answer_box clicked_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_b') {
	        _this.setState({ choice_b: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_c') {
	        _this.setState({ choice_c: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_d') {
	        _this.setState({ choice_d: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box ' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_e') {
	        _this.setState({ choice_e: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var chosen_answer, right_answer, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_this.state.clicked) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                clearInterval(_this.timer);
	                chosen_answer = _this.state.choice;
	                right_answer = 0;
	
	                _this.setState({ result_block: 'card show_block' });
	                if (item.right_choice === _this.state.choice) {
	                  right_answer = 1;
	                  if (_this.state.choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
	                  } else if (_this.state.choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
	                  } else if (_this.state.choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
	                  } else if (_this.state.choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
	                  } else if (_this.state.choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
	                  }
	
	                  _this.setState({
	                    result: '' + _language2.default.LC().CORRECT,
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block'
	                  });
	                } else {
	                  right_answer = 0;
	                  if (_this.state.choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box failure' });
	                  }
	                  if (item.right_choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
	                  } else if (item.right_choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
	                  } else if (item.right_choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
	                  } else if (item.right_choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
	                  } else if (item.right_choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
	                  }
	                  _this.setState({
	                    text_color: 'card-header text_failure',
	                    result: '' + _language2.default.LC().INCORRECT,
	                    result_block: 'card show_block'
	                  });
	                }
	
	                if (_this.state.validated) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: item.id,
	                  right_answer: right_answer,
	                  time_done: _this.state.count
	                };
	                _context2.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({ ValidToken: true, validated: true });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      console.log('item ----------->', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      console.log('item ------------> ', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-sm-12 col-md-12 display_block',
	        isEditable: true
	      });
	
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-sm-12 col-md-12 display_block',
	            isEditable: false
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        _this.setState({ timer_tag: '' + _language2.default.LC().STOP });
	        clearInterval(_this.timer);
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timer_tag: '' + _language2.default.LC().START });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._displayOuterElement = function () {
	      // console.log("working");
	      var d = document.getElementById('d');
	      // console.log("dsacds");
	      // console.log(d.outerHTML);
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      reportLoading: false,
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      successAlert: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      // flash_form : 'col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      display_loader: 'show_block',
	      selectedmenu: 'gmat',
	      subscriptionstatus: '',
	      chapter_name: '',
	      isEditable: false,
	      all_questions: '',
	      category: 'GMAT',
	      tags: ['gmat', 'question'],
	      title: '',
	      description: '',
	      forumComment: '',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      choice_name: ''
	    };
	    return _this;
	  }
	
	  _createClass(GMATBeginchapters, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	
	    //Function to change, time every second
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      this.setState({ count: this.state.count + 1 });
	    }
	
	    //Function to redirect page to readings page
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	
	    //Function to check Right Or Wrong Answered and displayed clicked box
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to show Correct box and display right answer and store in database
	
	
	    //Function to Display Saved Question on button and save in database
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Funcion to save new report question
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1 });
	            _this3.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({ rating: items.ratting });
	              _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1 });
	                _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({ rated: 1 });
	              _this3.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this4 = this;
	
	        var result, storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context5.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context5.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                user_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 6;
	                              break;
	                            }
	
	                            _this4._runCode('free');
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context4.next = 11;
	                            break;
	
	                          case 6:
	                            _this4.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context3.next = 6;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context3.sent;
	
	                                        if (isInArray_var) {
	                                          _this4._runCode('paid');
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4._runCode('free');
	                                          _this4.setState({ subscriptionstatus: 'free' });
	                                        }
	                                        _context3.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this4);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context4.next = 14;
	                            break;
	
	                          case 13:
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                              _this4._runCode('free');
	                              _this4.setState({ subscriptionstatus: 'free' });
	                            } else {
	                              _this4.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this4.state.token,
	                                idname: _this4.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this4.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    _this4._runCode('paid');
	                                    _this4.setState({ subscriptionstatus: 'paid' });
	                                  } else {
	                                    _this4._runCode('free');
	                                    _this4.setState({ subscriptionstatus: 'free' });
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 14:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this4);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: '_runCode',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(subscriptionstatus) {
	        var _this5 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                // console.log("subscriptionstatus")
	                // console.log(subscriptionstatus)
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  subscriptionstatus: subscriptionstatus
	                };
	                // console.log('data------------------------', data);
	                /*Api to call all question by chapter ,reading wise without limit and offset*/
	
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestions_allcr', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var ques_res, offset_res, i, retun_all_question, all_questions, params;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context6.next = 24;
	                              break;
	                            }
	
	                            _this5.setState({ ValidToken: true });
	                            _this5.setState({ all_questions_state: resp.questions });
	                            ques_res = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this5.props.params.id) {
	                                ques_res = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i == resp.questions.length - 1) {
	                                _this5.setState({ display_loader: 'hide_block' });
	                              }
	                            }
	                            _this5.setState({ questions: ques_res }, function () {
	                              if (ques_res.right_choice == 'choice_a') {
	                                _this5.setState({ choice_name: 'A' });
	                              } else if (ques_res.right_choice == 'choice_b') {
	                                _this5.setState({ choice_name: 'B' });
	                              } else if (ques_res.right_choice == 'choice_c') {
	                                _this5.setState({ choice_name: 'C' });
	                              } else if (ques_res.right_choice == 'choice_d') {
	                                _this5.setState({ choice_name: 'D' });
	                              } else if (ques_res.right_choice == 'choice_e') {
	                                _this5.setState({ choice_name: 'E' });
	                              }
	                            });
	
	                            _context6.next = 9;
	                            return _this5.setState({
	                              offset: offset_res,
	                              question_length: resp.questions.length
	                            });
	
	                          case 9:
	                            retun_all_question = JSON.stringify(_this5.state.questions);
	                            all_questions = JSON.parse(retun_all_question);
	                            _context6.next = 13;
	                            return _this5.setState({ all_questions: all_questions });
	
	                          case 13:
	
	                            if (offset_res == 0) {
	                              _this5.setState({ previ_block: 'card hide_block' });
	                            }
	
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this5.setState({ next_block: 'card hide_block' });
	                            }
	
	                            params = {
	                              token: _this5.state.token,
	                              question_id: ques_res.id,
	                              idname: _this5.state.idname
	                            };
	                            //Api to Fetch saved question stats
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({
	                                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                                });
	                                _this5.setState({
	                                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                                });
	                                _this5.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	                                _this5.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	                              }
	                            });
	                            params = {
	                              token: _this5.state.token,
	                              question_id: ques_res.id,
	                              idname: _this5.state.idname
	                            };
	                            //Api to get ratting
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({ rated: true });
	                                response.ratting.map(function (items) {
	                                  _this5.setState({ rating: items.ratting });
	                                  _this5.setState({ ratting_text: '' + _language2.default.LC().RATED });
	                                });
	                              }
	                            });
	                            params = {
	                              token: _this5.state.token,
	                              idname: _this5.state.idname,
	                              question_id: ques_res.id
	                            };
	                            //Api to fetch flashcard by question id
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({ ValidToken: true });
	                                if (response.flash_cards.length > 0) {
	                                  _this5.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                                  var flash_cards = response.flash_cards.map(function (items, index) {
	                                    return (
	                                      //alert(items.id)
	                                      _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: '' },
	                                          _react2.default.createElement(
	                                            'ul',
	                                            { className: 'icon_list' },
	                                            _react2.default.createElement(
	                                              'li',
	                                              null,
	                                              _react2.default.createElement(
	                                                'a',
	                                                {
	                                                  className: 'pointer_class',
	                                                  onClick: _this5._editFlash.bind(_this5, items)
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                              )
	                                            ),
	                                            _react2.default.createElement(
	                                              'li',
	                                              null,
	                                              _react2.default.createElement(
	                                                'a',
	                                                {
	                                                  className: 'pointer_class',
	                                                  onClick: _this5._deleteFlash.bind(_this5, items)
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-close' })
	                                              )
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: _this5.state.flash_class },
	                                            _react2.default.createElement('h4', null),
	                                            _react2.default.createElement(
	                                              'p',
	                                              null,
	                                              items.flash_card
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  });
	                                } else {
	                                  _this5.setState({
	                                    flash_form: 'col-sm-12 col-md-12 display_block'
	                                  });
	                                  var flash_cards = _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _language2.default.LC().NO_FLASHCARD_FOUND
	                                  );
	                                }
	                                _this5.setState({ flash_data: flash_cards });
	                              } else {
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                                _this5.setState({ ValidToken: false });
	                                _this5.setState({ flash_data: flash_cards });
	                                _this5.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	                              }
	                              return response;
	                            });
	
	                            _this5.setState({ records: '' });
	                            _context6.next = 26;
	                            break;
	
	                          case 24:
	                            _this5.setState({ ValidToken: false });
	                            _this5.setState({ records: '' + _language2.default.LC().Result_not_found });
	
	                          case 26:
	                            clearInterval(_this5.timer);
	                            _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	                            return _context6.abrupt('return', resp);
	
	                          case 29:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this5);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getChapterbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this5.setState({ chapter_name: resp.chapters[0].chapter_name });
	                  } else {
	                    // console.log('Chapter Name Not Found');
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function _runCode(_x6) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return _runCode;
	    }()
	
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      //console.log(this.props);
	      // var subscription=this.state.subscriptionstatus;
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val, subscription) {
	      var _this6 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      // console.log("subscriptionstatus")
	      // console.log(this.state.subscriptionstatus)
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block'
	          });
	          var ques_res = [];
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (resp.questions[i].id == _this6.props.params.id) {
	              ques_res = resp.questions[i];
	            }
	          }
	          var questions = _this6.state.questions;
	
	
	          _this6.setState({ questions: ques_res }, function () {
	            if (questions.right_choice == 'choice_a') {
	              _this6.setState({ choice_name: 'A' });
	            } else if (questions.right_choice == 'choice_b') {
	              _this6.setState({ choice_name: 'B' });
	            } else if (questions.right_choice == 'choice_c') {
	              _this6.setState({ choice_name: 'C' });
	            } else if (questions.right_choice == 'choice_d') {
	              _this6.setState({ choice_name: 'D' });
	            } else if (questions.right_choice == 'choice_e') {
	              _this6.setState({ choice_name: 'E' });
	            }
	          });
	          _this6.setState({ display_loader: 'hide_block' });
	          var params = {
	            token: _this6.state.token,
	            question_id: ques_res.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            // console.log(response);
	            // console.log("getFavQuestions");
	            if (response.success) {
	              _this6.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this6.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this6.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this6.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	          var params = {
	            token: _this6.state.token,
	            question_id: ques_res.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ rated: true });
	              response.ratting.map(function (items) {
	                _this6.setState({ rating: items.ratting });
	                _this6.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              });
	            }
	          });
	          var params = {
	            token: _this6.state.token,
	            idname: _this6.state.idname,
	            question_id: ques_res.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this6.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this6._deleteFlash.bind(_this6, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this6.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this6.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this6.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this6.setState({ ValidToken: false });
	              _this6.setState({ flash_data: flash_cards });
	              _this6.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	            }
	            return response;
	          });
	          _this6.setState({ records: '' });
	        } else {
	          _this6.setState({ ValidToken: false });
	          _this6.setState({ records: '' + _language2.default.LC().Result_not_found });
	        }
	        clearInterval(_this6.timer);
	        _this6.timer = setInterval(_this6.tick.bind(_this6), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false });
	      this.setState({ timer_tag: '' + _language2.default.LC().STOP });
	      this.setState({ count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    /*Function to start or stop timer*/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(
	      //   'this.state.choice_namethis.state.choice_name',
	      //   this.state.choice_name
	      // );
	      var questions = this.state.questions;
	      var _state = this.state,
	          rating = _state.rating,
	          reportLoading = _state.reportLoading;
	
	      var forumData = '';
	      var data = '';
	      var choice_a = 'choice_a';
	      var choice_b = 'choice_b';
	      var choice_c = 'choice_c';
	      var choice_d = 'choice_d';
	      var choice_e = 'choice_e';
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      var retun_all_question = JSON.stringify(this.state.questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        forumData = '<div class="col-sm-12 no-cursor" >\n            <div class="margin_bottom_40">\n                <div >\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="row no-cursor">\n                                <div class="col-sm-12 cursor-text">\n                                    <div contentEditable=\'false\' class="margin_bottom_40 view_questionhtml bg_blue "> ' + all_questions.question + ' </div>\n                                </div>\n                                <div class="col-sm-12 no-cursor" id="choice_a" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().A + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_a + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 no-cursor" id="choice_b">\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().B + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>  ' + all_questions.choice_b + ' </span></p>\n                                    </div>\n                                </div>\n                                \n                                <div class="col-sm-12 no-cursor" id="choice_c" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().C + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>\n                                        ' + all_questions.choice_c + '\n                                        </span></p>\n                                    </div>\n                                    </div>\n\n                                    <div class="col-sm-12 no-cursor" id="choice_d" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().D + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_d + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 no-cursor margin_bottom_30" id="choice_e" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().E + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_e + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 cursor-text">\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> \n                                  ' + _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + this.state.choice_name + ').</p>\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> ' + all_questions.answer + '</p>\n                                </div>\n                                <div class="col-sm-12 margin_bottom_30 no-cursor">\n\n                                <div class="userQuestionDiv">\n                                <span class="questionColor cursor-text"> *User Question: </span>\n                                <div class="forum-data-comment cursor-text">\n                                  <h4> ' + this.state.forumComment + ' \n                                  </h4>\n                                </div>\n                                </div>\n                              </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>';
	
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, "span", "", { contentEditable: 'false' }),
	              ' ',
	              '(',
	              _language2.default.LC().Q,
	              ' ',
	              all_questions.id,
	              ')',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      (0, _function.renderHTMLContent)(all_questions.question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: 'false' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_a',
	                        onClick: this._getAnswer.bind(this, choice_a)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_a },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().A
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          ' ',
	                          (0, _function.renderHTMLContent)(all_questions.choice_a, "span", "", { contentEditable: 'false' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_b',
	                        onClick: this._getAnswer.bind(this, choice_b)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_b },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().B
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(all_questions.choice_b, "span", "", { contentEditable: 'false' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_c',
	                        onClick: this._getAnswer.bind(this, choice_c)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_c },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().C
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(all_questions.choice_c, "span", "", { contentEditable: 'false' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_d',
	                        onClick: this._getAnswer.bind(this, choice_d)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_d },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().D
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(all_questions.choice_d, "span", "", { contentEditable: 'false' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_e',
	                        onClick: this._getAnswer.bind(this, choice_e)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_e },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().E
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(all_questions.choice_e, "span", "", { contentEditable: 'false' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: all_questions,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'star_rating_wrap' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: ' margin_bottom_0 margin_right_10' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(_reactStarRatings2.default, {
	                              rating: this.state.rating,
	                              starRatedColor: 'rgb(255, 180, 0)',
	                              starEmptyColor: 'rgb(51, 51, 51)',
	                              starDimension: '20px',
	                              starHoverColor: 'rgb(255, 180, 0)',
	                              starSpacing: '2px',
	                              changeRating: this.onStarClick.bind(this, all_questions),
	                              numberOfStars: 5,
	                              name: 'rate1'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement('button', {
	                    type: 'button',
	                    className: this.state.timerstopbtn,
	                    onClick: this._timer_funct.bind(this, questions)
	                  }),
	                  this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	                    'a',
	                    {
	                      onClick: this._getSubscribe,
	                      className: 'box_question_color text-center cursor_pointer'
	                    },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS,
	                      ' '
	                    )
	                  ) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().THE_CORRECT_ANSWER_IS,
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.choice_name,
	                  '.'
	                )
	              ),
	              (0, _function.renderHTMLContent)(all_questions.answer, "p", "view_questionhtml", { contentEditable: 'false' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this._reportQuestion.bind(this, all_questions)
	                    },
	                    ' ',
	                    reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, all_questions)
	                    },
	                    ' ',
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else {
	        /*data = <div className="col-sm-12 col-md-12">
	            <div className="no_data_bar card">No Records Found</div></div>;*/
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_10 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUESTION_BANK
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getQuestions
	                },
	                _language2.default.LC().CHANGE_QUESTIONS
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_CHAPTER
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        this.state.display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null
	      );
	    }
	  }]);
	
	  return GMATBeginchapters;
	}(_react.Component);
	
	GMATBeginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this7 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this7.toggle = _this7.toggle.bind(_this7);
	    _this7.state = {
	      tooltipOpen: false
	    };
	    return _this7;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATBeginchapters;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMAT_QUESTION_BANK = function (_Component) {
	  _inherits(GMAT_QUESTION_BANK, _Component);
	
	  function GMAT_QUESTION_BANK(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMAT_QUESTION_BANK);
	
	    var _this = _possibleConstructorReturn(this, (GMAT_QUESTION_BANK.__proto__ || Object.getPrototypeOf(GMAT_QUESTION_BANK)).call(this, props));
	
	    _this._getReadings = function (chapter) {
	      // console.log('chapterchapterchapterchapterchapterchapterchapter', chapter);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', chapter.chapter_no)
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: chapter.chapter_no,
	        //   chapterName: chapter.chapter_name,
	        // },
	      });
	    };
	
	    _this.goToQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', lastRecord.gmat_question.chapter_id).replace(':readingid', lastRecord.gmat_question.reading_id).replace(':id', lastRecord.gmat_question.id).replace(':offset', 0)
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      token: '',
	      lastRecord: '',
	      lastAttempt: false,
	      idname: '',
	      freeChapterCount: [],
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(GMAT_QUESTION_BANK, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ alert_status: !this.state.alert_status });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getChapters', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context2.next = 6;
	                    break;
	                  }
	
	                  _this3.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    IRCount: resp.GMATIRTable,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  _context2.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context2.next = 7;
	                  break;
	
	                case 6:
	                  _this3.setState({ ValidToken: false });
	
	                case 7:
	                  return _context2.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      // console.log(language.LC())
	      var countFree = this.state.freeChapterCount;
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      if (this.state.chapters.length && this.state.freeChapterCount.length) {
	        data = this.state.chapters.map(function (item, index) {
	          return countFree.map(function (itemFree) {
	            return item.chapter_no === itemFree.id ? _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: index
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id
	                  // eslint-disable-next-line no-underscore-dangle
	                  , onClick: _this4._getReadings.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    className: '',
	                    width: '54',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'pointer_class',
	                      id: item.chapter_name,
	                      value: item.chapter_no
	                      // eslint-disable-next-line no-underscore-dangle
	                      , onClick: _this4._getReadings.bind(_this4, item)
	                    },
	                    item.chapter_no,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                        className: '',
	                        width: '25',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countreading
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().TOTAL_READINGS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      itemFree.id !== 9 ? itemFree.count : _this4.state.IRCount
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().FREE_QUESTIONS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countquestion
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().PREMIUM_QUESTIONS
	                    )
	                  )
	                )
	              )
	            ) : null;
	          });
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().CFA_LEVEL_I_QUESTION_BANK,
	            ' '
	          ),
	          lastAttempt ? _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion.bind(this),
	              disabled: !lastAttempt
	            },
	            ' ',
	            _language2.default.LC().GO_TO_MY_LAST_QUESTION_ANSWERED,
	            ' '
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMAT_QUESTION_BANK;
	}(_react.Component);
	
	GMAT_QUESTION_BANK.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = GMAT_QUESTION_BANK;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _questionNotFoundModel = __webpack_require__(104);
	
	var _questionNotFoundModel2 = _interopRequireDefault(_questionNotFoundModel);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import App_data from "../config/App_data";
	
	// import GD from "../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var GMATReadings = function (_Component) {
	  _inherits(GMATReadings, _Component);
	
	  function GMATReadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATReadings);
	
	    var _this = _possibleConstructorReturn(this, (GMATReadings.__proto__ || Object.getPrototypeOf(GMATReadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      // console.log('get00000=m,j,hjjkkjkj', reading);
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log('resp.profileInfo.userStatus', resp.profileInfo);
	
	                        _context.next = 6;
	                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var) {
	                          _this._runCode('paid', reading);
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free', reading);
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 10:
	                        console.log('fail');
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this._runCode('paid', reading);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free', reading);
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      // console.log('reading----------------------------', reading);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: _this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: _this.state.subscriptionstatus
	      };
	      if (reading.type === 'case_question') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCaseByReading', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.questions.length) {
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':caseid', resp.questions[0].case_id).replace(':case_offset', 0).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', resp.questions[0].question_no).replace(':offset', 0)
	              });
	            } else {
	              _this.toggleAlert();
	            }
	          }
	        });
	      } else if (reading.type === 'tab_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_TAB.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'graph_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_GRAPH_MULTI_STATEMENT.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'table_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_TABLE.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'two_part_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_TWO_PART_STATEMENT.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestions', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.questions.length) {
	              _this.context.router.push({
	                pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', _this.state.chapterid).replace(':readingid', reading.id).replace(':id', resp.questions[0].id).replace(':offset', 0)
	              });
	            } else {
	              _this.toggleAlert();
	            }
	          }
	        });
	      }
	    };
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context5.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context5.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context5.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context5.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context5.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context4.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context2.next = 6;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context4.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context4.next = 17;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context4.next = 23;
	                            break;
	
	                          case 17:
	                            // console.log(
	                            //   'resssssssssssssssss-----------',
	                            //   resp.profileInfo.subscription_details
	                            // );
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context3.next = 6;
	                                        return _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context3.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context3.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context3.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context3.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context3.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context9.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context9.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context9.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context9.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context9.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context8.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context6.next = 6;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context6.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context8.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context8.next = 17;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context8.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context7.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context7.next = 6;
	                                        return _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context7.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context7.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context7.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context7.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context7.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x6) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      alert_status_question_not_found: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	
	      MessageTitleOnQuestionNotFound: '' + _language2.default.LC().MESSAGE,
	      ComingSoon: '' + _language2.default.LC().COMING_SOON,
	
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.id,
	      chapterName: '',
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'gmat',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFDownloadType: 'Question',
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATReadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      if (this.state.subscriptionstatus === 'free') {
	        this.setState({
	          alert_status: !this.state.alert_status
	        });
	      } else {
	        this.setState({
	          alert_status_question_not_found: !this.state.alert_status_question_not_found
	        });
	      }
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    //it is use to redirect page
	
	
	    //Function to redirect page to question bank page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus, reading) {
	      var _this3 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: reading.id,
	        chapter_id: this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length || reading.type !== 'case_question') {
	            // console.log('reading.type', reading);
	            _this3.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', reading.chapter_no).replace(':id', reading.id).replace(':subscriptionstatus', subscriptionstatus).replace(':reading', reading.reading)
	            });
	            // }
	          } else {
	            _this3.toggleAlert();
	          }
	        }
	      });
	    }
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this4 = this;
	
	        var result, storage_session, data, user_data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.chapterid
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this4.setState({ no_result_display: 'No Saved Questions' });
	                    }
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                    (0, _toast.showFailure)('No readings found!!');
	                  }
	                  // return resp;
	                });
	
	                user_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context12.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context11.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context11.next = 5;
	                              break;
	                            }
	
	                            _this4.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context11.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this4.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, isInArray_var_PDF;
	                                return _regenerator2.default.wrap(function _callee10$(_context10) {
	                                  while (1) {
	                                    switch (_context10.prev = _context10.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context10.next = 15;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        isInArray_var_PDF = false;
	                                        _context10.next = 7;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 7:
	                                        isInArray_var = _context10.sent;
	
	                                        if (isInArray_var) {
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4.setState({
	                                            subscriptionstatus: 'free',
	                                            showFreePremium: true
	                                          });
	                                        }
	                                        _context10.next = 11;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, _this4.state.type);
	
	                                      case 11:
	                                        isInArray_var_PDF = _context10.sent;
	
	
	                                        // console.log('isInArray_var_PDF', isInArray_var_PDF);
	                                        if (isInArray_var_PDF) {
	                                          _this4.setState({ showFreePremium: false });
	                                        } else {
	                                          _this4.setState({ showFreePremium: true });
	                                        }
	                                        _context10.next = 15;
	                                        break;
	
	                                      case 15:
	                                      case 'end':
	                                        return _context10.stop();
	                                    }
	                                  }
	                                }, _callee10, _this4);
	                              }));
	
	                              return function (_x11) {
	                                return _ref12.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context11.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context11.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this4.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context11.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this4.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              // console.log(resp_exam);
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this4.state.selectedmenu;
	                                var isInArray_var = false;
	                                var isInArray_var_PDF = false;
	                                isInArray_var = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this4.setState({ subscriptionstatus: 'paid' });
	                                } else {
	                                  _this4.setState({
	                                    subscriptionstatus: 'free',
	                                    showFreePremium: true
	                                  });
	                                }
	                                isInArray_var_PDF = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, _this4.state.type);
	                                if (isInArray_var_PDF) {
	                                  _this4.setState({ showFreePremium: false });
	                                } else {
	                                  _this4.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this4);
	                  }));
	
	                  return function (_x10) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    /*
	    ------------------------------
	    PDF DOWNLOAD Via Email
	    -------------------------------
	    */
	
	    /*
	    --------------------------------
	    PDF DOWNLOAD Via email Answer
	    --------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          // console.log('item----------------', item.type);
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading_no,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            item.type === 'no_question' ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20 coming_soon_table' },
	                '-'
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: _this5._getQuestions.bind(_this5, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this5._beginChapter.bind(_this5, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                this.state.chapterName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	              _react2.default.createElement(
	                'div',
	                { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoading ? _language2.default.LC().Download_Question : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  onClick: this.getpdfAnswer.bind(this),
	                  className: 'status-download-btn margin_right_10'
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoadingAnswer ? _language2.default.LC().Download_Question_Answer : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getChapters
	                },
	                ' ',
	                _language2.default.LC().CHANGE_TOPIC,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().READING
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_questionNotFoundModel2.default, {
	          alert_status: this.state.alert_status_question_not_found,
	          toggleAlert: this.toggleAlert,
	          MessageTitle: this.state.MessageTitleOnQuestionNotFound,
	          MessageContent: this.state.ComingSoon
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return GMATReadings;
	}(_react.Component);
	
	GMATReadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATReadings;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable */
	
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var GMAT2Statement = function (_Component) {
	  _inherits(GMAT2Statement, _Component);
	
	  function GMAT2Statement(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMAT2Statement);
	
	    var _this = _possibleConstructorReturn(this, (GMAT2Statement.__proto__ || Object.getPrototypeOf(GMAT2Statement)).call(this, props));
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var _this$state, answer1, answer2, userValue1, userValue2, selectedChoiceNo, selectedChoiceYes, option1, option2, option3, option4, option5, option6, expectedCount, count, optionArray, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                // const { option1, option2, option3, option4, option5, option6 } = item;
	                _this$state = _this.state, answer1 = _this$state.answer1, answer2 = _this$state.answer2, userValue1 = _this$state.userValue1, userValue2 = _this$state.userValue2, selectedChoiceNo = _this$state.selectedChoiceNo, selectedChoiceYes = _this$state.selectedChoiceYes, option1 = _this$state.option1, option2 = _this$state.option2, option3 = _this$state.option3, option4 = _this$state.option4, option5 = _this$state.option5, option6 = _this$state.option6;
	                expectedCount = 2;
	                count = 0;
	                optionArray = [];
	
	                optionArray.push(option1);
	                optionArray.push(option2);
	                optionArray.push(option3);
	                optionArray.push(option4);
	                optionArray.push(option5);
	
	                if (userValue1 && userValue2) {
	                  _this.setState({
	                    error: ''
	                  });
	                  console.log('if');
	                } else {
	                  // this.setRadioButtonBlank();
	                  _this.setState({
	                    error: 'Please select all options '
	                  });
	                  console.log('else');
	                }
	
	                if (option6) optionArray.push(option6);
	                userValue2 = userValue2 ? userValue2.toLowerCase().trim() : null;
	                answer2 = answer2 ? answer2.toLowerCase().trim() : null;
	
	                if (!(userValue1 && userValue2)) {
	                  _context2.next = 23;
	                  break;
	                }
	
	                if (userValue2 === answer2) {
	                  count++;
	                  _this.setState(_defineProperty({}, selectedChoiceNo, 'accent-success'));
	                } else {
	                  optionArray.filter(function (item, index) {
	                    if (item.toLowerCase().trim() === answer2) {
	                      var value = 'choice' + (index + 1) + '_no';
	                      _this.setState(_defineProperty({}, value, 'accent-success'), function () {
	                        _this.setRadioButtonSuccess(true);
	                      });
	                      return;
	                    }
	                  });
	                  _this.setState(_defineProperty({}, selectedChoiceNo, 'accent-faliure'));
	                }
	
	                userValue1 = userValue1 ? userValue1.toLowerCase().trim() : null;
	                answer1 = answer1 ? answer1.toLowerCase().trim() : null;
	                if (userValue1 === answer1) {
	                  count++;
	                  _this.setState(_defineProperty({}, selectedChoiceYes, 'accent-success'));
	                } else {
	                  optionArray.filter(function (item, index) {
	                    if (item.toLowerCase().trim() === answer1) {
	                      var value = 'choice' + (index + 1) + '_yes';
	                      _this.setState(_defineProperty({}, value, 'accent-success'), function () {
	                        _this.setRadioButtonSuccess(true);
	                      });
	                      return;
	                    }
	                  });
	                  _this.setState(_defineProperty({}, selectedChoiceYes, 'accent-faliure'));
	                }
	
	                // ========================================
	                right_answer = 0;
	
	                if (expectedCount === count) {
	                  right_answer = 1;
	                  _this.setState({
	                    result: 'CORRECT',
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block',
	                    isQuestionValidated: true
	                  });
	                } else {
	                  _this.setState({
	                    result_block: 'card show_block',
	                    result: 'INCORRECT',
	                    text_color: 'card-header text_failure',
	                    isQuestionValidated: true
	                  });
	                }
	                // --------------- Save Stat API call Start -----------//
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: _this.state.questionId,
	                  right_answer: right_answer,
	                  type: 'two_part_question'
	                  // time_done: this.state.count,
	                };
	                _context2.next = 23;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true
	                              });
	                            } else {
	                              _this.setState({
	                                ValidToken: false
	                              });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 23:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'two_part_question'
	      };
	      console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'two_part_question'
	      };
	      //Api to get ratting
	      console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.setQuestionData = function (questionsArray, offset) {
	      var questionObj = questionsArray[offset || 0];
	      if (questionObj) {
	        _this.setState({
	          allQuestions: questionObj,
	          question: questionObj.question,
	          questionId: questionObj.id,
	          choice_a: questionObj.choice_a,
	          choice_b: questionObj.choice_b,
	          explanation: questionObj.explanation,
	          answer1: questionObj.answer1,
	          answer2: questionObj.answer2,
	          option1: questionObj.option1,
	          option2: questionObj.option2,
	          option3: questionObj.option3,
	          option4: questionObj.option4,
	          option5: questionObj.option5,
	          option6: questionObj.option6,
	          offset: offset,
	          questionHide: '',
	          display_loader: 'hide_block',
	          result_block: 'card hide_block',
	          report_block: 'card hide_block',
	          choice1_yes: '',
	          choice1_no: '',
	          choice2_yes: '',
	          choice2_no: '',
	          choice3_yes: '',
	          choice3_no: '',
	          choice4_yes: '',
	          choice4_no: '',
	          choice5_yes: '',
	          choice5_no: '',
	          choice6_yes: '',
	          choice6_no: ''
	        }, function () {
	          _this.setRadioButtonBlank();
	          _this.getFavQuestions(questionObj.id);
	          _this.getGMATRatting(questionObj.id);
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      var error = void 0;
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: '',
	        isQuestionValidated: false
	      });
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else', error);
	      }
	      if (_this.state.userValue1) {
	        _this.setState({
	          userValue1: ''
	        });
	      } else if (_this.state.userValue2) {
	        _this.setState({
	          userValue2: ''
	        });
	      } else {
	        console.log('error');
	      }
	
	      document.getElementById('comment').value = '';
	      var offset = parseFloat(_this.state.offset) - 1;
	      var _this$state2 = _this.state,
	          questionsArray = _this$state2.questionsArray,
	          reading = _this$state2.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_TWO_PART_STATEMENT.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	    };
	
	    _this._getNext = function () {
	      var error = void 0;
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: '',
	        isQuestionValidated: false
	      });
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      if (_this.state.userValue1) {
	        _this.setState({
	          userValue1: ''
	        });
	      } else if (_this.state.userValue2) {
	        _this.setState({
	          userValue2: ''
	        });
	      } else {
	        console.log('error');
	      }
	
	      document.getElementById('comment').value = '';
	      var offset = parseFloat(_this.state.offset) + 1;
	      var _this$state3 = _this.state,
	          questionsArray = _this$state3.questionsArray,
	          reading = _this$state3.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_TWO_PART_STATEMENT.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	    };
	
	    _this.setRadioButtonBlank = function () {
	      for (var counter = 0; counter < 2; counter++) {
	        var resetRadioButton = document.getElementsByName('userValue' + (counter + 1));
	        for (var i = 0; i < resetRadioButton.length; i++) {
	          resetRadioButton[i].checked = false;
	        }
	      }
	    };
	
	    _this.setRadioButtonSuccess = function (value) {
	      var radioButtonElement = document.getElementsByName('accent-success_yes');
	      for (var y = 0; y < 2; y++) {
	        for (var i = 0; i < radioButtonElement.length; i++) {
	          radioButtonElement[i].checked = value;
	        }radioButtonElement = document.getElementsByName('accent-success_no');
	      }
	    };
	
	    _this.setRadioButtonAfterValidate = function (event, choice1) {
	      _this.setRadioButtonBlank();
	      _this.setRadioButtonSuccess(false);
	      // let resetRadioButton = document.getElementsByName(name);
	      // for (var i = 0; i < resetRadioButton.length; i++)
	      //   resetRadioButton[i].checked = true;
	    };
	
	    _this._saveQuestion = function (item, e) {
	      // console.log("_saveQuestion");
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        type: 'two_part_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'two_part_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.reading)
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.state = {
	      show: false,
	      question: '',
	      explanation: '',
	      choice_a: '',
	      choice_b: '',
	      answer1: '',
	      answer2: '',
	      user_answer1: '',
	      user_answer2: '',
	      offset: _this.props.params.offset,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      rating: 0,
	      reportLoading: false,
	      questionsArray: [],
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      subscriptionstatus: parseInt(_this.props.params.subscription, 10) ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      option1: '',
	      option2: '',
	      option3: '',
	      option4: '',
	      option5: '',
	      option6: '',
	      error: '',
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      isQuestionValidated: false,
	      save_text: '' + _language2.default.LC().SAVE_QUESTION
	    };
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMAT2Statement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reading_id: this.props.params.readingid,
	        question_type: 'two_part_question',
	        subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free'
	      };
	      var offset = this.state.offset;
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (resp.success) {
	                    _this3.setState({
	                      questionsArray: resp.result
	                    });
	                    _this3.setQuestionData(resp.result, offset);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this3);
	        }));
	
	        return function (_x4) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    }
	
	    //Function to show Correct box and display right answer and store in database
	
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1 });
	            _this4.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this4.setState({ rating: items.ratting });
	              _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              question_id: _this4.state.questionId,
	              ratting: nextValue,
	              type: 'two_part_question'
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1 });
	                _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var _params2 = {
	            token: _this4.state.token,
	            idname: _this4.state.idname,
	            question_id: _this4.state.questionId,
	            ratting: nextValue,
	            type: 'two_part_question'
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', _params2).then(function (response) {
	            if (response.success) {
	              _this4.setState({ rated: 1 });
	              _this4.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Funcion to save new report question
	
	
	    //Function to redirect page to readings page
	
	
	    //Function to show calculator
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(event, choice1) {
	      var _this5 = this,
	          _setState3;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	      var isQuestionValidated = this.state.isQuestionValidated;
	
	      if (isQuestionValidated) {
	        for (var i = 1; i <= 5; i++) {
	          var _setState;
	
	          this.setState((_setState = {}, _defineProperty(_setState, 'choice' + i + '_yes', ''), _defineProperty(_setState, 'choice' + i + '_no', ''), _setState));
	        }this.setState({
	          choice6_yes: '',
	          choice6_no: '',
	          userValue1: '',
	          userValue2: ''
	        }, function () {
	          _this5.setRadioButtonAfterValidate(event, choice1);
	          var setRadioButton = void 0;
	          // console.log(choice1);
	          if (choice1.includes('_yes')) {
	            setRadioButton = document.getElementsByName('userValue1');
	          } else {
	            setRadioButton = document.getElementsByName('userValue2');
	          }
	          setRadioButton[parseInt(choice1.match(/[0-9]/)[0]) - 1].checked = true;
	        });
	      }
	      if (choice1.includes('_yes')) this.setState({
	        selectedChoiceYes: choice1
	      });else this.setState({ selectedChoiceNo: choice1 });
	      for (var _i = 1; _i <= 6; _i++) {
	        var _setState2;
	
	        this.setState((_setState2 = {}, _defineProperty(_setState2, 'choice' + _i + '_yes', ''), _defineProperty(_setState2, 'choice' + _i + '_no', ''), _setState2));
	      }this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'isQuestionValidated', false), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state = this.state,
	          choice_a = _state.choice_a,
	          choice_b = _state.choice_b,
	          question = _state.question,
	          reportLoading = _state.reportLoading,
	          explanation = _state.explanation,
	          questionsArray = _state.questionsArray,
	          offset = _state.offset,
	          reading = _state.reading,
	          questionHide = _state.questionHide,
	          display_loader = _state.display_loader,
	          option1 = _state.option1,
	          option2 = _state.option2,
	          option3 = _state.option3,
	          option4 = _state.option4,
	          option5 = _state.option5,
	          option6 = _state.option6,
	          choice1_yes = _state.choice1_yes,
	          choice1_no = _state.choice1_no,
	          choice2_yes = _state.choice2_yes,
	          choice2_no = _state.choice2_no,
	          choice3_yes = _state.choice3_yes,
	          choice3_no = _state.choice3_no,
	          choice4_yes = _state.choice4_yes,
	          choice4_no = _state.choice4_no,
	          choice5_yes = _state.choice5_yes,
	          choice5_no = _state.choice5_no,
	          choice6_yes = _state.choice6_yes,
	          choice6_no = _state.choice6_no,
	          allQuestions = _state.allQuestions,
	          questionId = _state.questionId,
	          error = _state.error;
	      // console.log("error.................................",error)
	      // let optionsArray = [];
	      // for (const property in dataObject) {
	      //   if (property.includes('option')) {
	      //     optionsArray.push(dataObject[property]);
	      //   }
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_10 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class calc-btn',
	                onClick: this._handleModal
	              },
	              _language2.default.LC().OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 font-16px ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            (0, _function.renderHTMLContent)(reading, "span", "", { contentEditable: 'false' }),
	            '(',
	            _language2.default.LC().Q,
	            ' ',
	            questionId,
	            ')',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(question, "p"),
	            _react2.default.createElement(
	              'table',
	              {
	                className: 'text-center border-solid-1 margin_bottom_30'
	                // border='1'
	              },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { className: 'border-solid-1 p-10px' },
	                  choice_a
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'border-solid-1 p-10px' },
	                  choice_b
	                ),
	                _react2.default.createElement('th', { className: 'border-solid-1 p-10px' })
	              ),
	              option1 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice1_yes === 'accent-success' ? choice1_yes + '_yes' : 'userValue1',
	                    value: option1,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice1_yes');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice1_yes
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice1_no === 'accent-success' ? choice1_no + '_no' : 'userValue2',
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice1_no');
	                    },
	                    value: option1,
	                    className: 'border-solid-1 cursor-pointer ' + choice1_no
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  (0, _function.renderHTMLContent)(option1, "span")
	                )
	              ) : null,
	              option2 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice2_yes === 'accent-success' ? choice2_yes + '_yes' : 'userValue1',
	                    value: option2,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice2_yes');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice2_yes
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice2_no === 'accent-success' ? choice2_no + '_no' : 'userValue2',
	                    value: option2,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice2_no');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice2_no
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  (0, _function.renderHTMLContent)(option2, "span")
	                )
	              ) : null,
	              option3 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice3_yes === 'accent-success' ? choice3_yes + '_yes' : 'userValue1',
	                    value: option3,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice3_yes');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice3_yes
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice3_no === 'accent-success' ? choice3_no + '_no' : 'userValue2',
	                    value: option3,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice3_no');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice3_no
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  (0, _function.renderHTMLContent)(option3, "span")
	                )
	              ) : null,
	              option4 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice4_yes === 'accent-success' ? choice4_yes + '_yes' : 'userValue1',
	                    value: option4,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice4_yes');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice4_yes
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice4_no === 'accent-success' ? choice4_no + '_no' : 'userValue2',
	                    value: option4,
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice4_no');
	                    },
	                    className: 'border-solid-1 cursor-pointer ' + choice4_no
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  (0, _function.renderHTMLContent)(option4, "span")
	                )
	              ) : null,
	              option5 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice5_yes === 'accent-success' ? choice5_yes + '_yes' : 'userValue1',
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice5_yes');
	                    },
	                    value: option5,
	                    className: 'border-solid-1 cursor-pointer ' + choice5_yes
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice5_no === 'accent-success' ? choice5_no + '_no' : 'userValue2',
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice5_no');
	                    },
	                    value: option5,
	                    className: 'border-solid-1 cursor-pointer ' + choice5_no
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  (0, _function.renderHTMLContent)(option5, "span")
	                )
	              ) : null,
	              option6 ? _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice6_yes === 'accent-success' ? choice6_yes + '_yes' : 'userValue1',
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice6_yes');
	                    },
	                    value: option6,
	                    className: 'border-solid-1 cursor-pointer ' + choice6_yes
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  _react2.default.createElement('input', {
	                    type: 'radio',
	                    id: 'html',
	                    name: choice6_no === 'accent-success' ? choice6_no + '_no' : 'userValue2',
	                    onChange: function onChange(e) {
	                      return _this6.onChangeValue(e, 'choice6_no');
	                    },
	                    value: option6,
	                    className: 'border-solid-1 cursor-pointer ' + choice6_no
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'border-solid-1 p-10px' },
	                  (0, _function.renderHTMLContent)(option6, "span")
	                )
	              ) : null
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'error_msg' },
	              error
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row bottom-tool' },
	              _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                isQue: true,
	                _getResult: this._getResult,
	                _saveQuestion: this._saveQuestion,
	                _displayReportForm: this._displayReportForm,
	                all_questions: allQuestions,
	                save_text: this.state.save_text,
	                bookmarkCSS: this.state.bookmarkCSS,
	                bookmarkColor: this.state.bookmarkColor
	                // isSpecialQuestion={true}
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'star_rating_wrap' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: ' margin_bottom_0 margin_right_10' },
	                    this.state.ratting_text
	                  ),
	                  _react2.default.createElement(_reactStarRatings2.default, {
	                    rating: this.state.rating,
	                    starRatedColor: 'rgb(255, 180, 0)',
	                    starEmptyColor: 'rgb(51, 51, 51)',
	                    starDimension: '20px',
	                    starHoverColor: 'rgb(255, 180, 0)',
	                    starSpacing: '2px',
	                    changeRating: this.onStarClick.bind(this, question),
	                    numberOfStars: 5,
	                    name: 'rate1'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.result_block + ' font-lusitana font-16px' },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.text_color },
	            this.state.result
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, question)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, question)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this6.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return GMAT2Statement;
	}(_react.Component);
	
	GMAT2Statement.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMAT2Statement;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	/* eslint-disable */
	
	var GMATCases = function (_Component) {
	  _inherits(GMATCases, _Component);
	
	  // =============================== TODO START =======================//
	  function GMATCases(props) {
	    _classCallCheck(this, GMATCases);
	
	    var _this = _possibleConstructorReturn(this, (GMATCases.__proto__ || Object.getPrototypeOf(GMATCases)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.questions.name)
	      });
	    };
	
	    _this._getAnswer = function (choice, questionId) {
	      _this.setState({ clicked: true, choice: 'choice_' + choice }, function () {
	        // console.log('choice ----> ', this.state.choice);
	      });
	      if (choice === 'a') {
	        _this.setState({
	          choice_a: 'answer_box clicked_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'b') {
	        _this.setState({
	          choice_b: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'c') {
	        _this.setState({
	          choice_c: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'd') {
	        _this.setState({
	          choice_d: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'e') {
	        _this.setState({
	          choice_e: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box'
	        });
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: questionId,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._getResult = function (item, e) {
	      // console.log(this.props.params.chapterid);
	      // console.log('item', item);
	      // console.log(this.props.params.case_offset);
	      // console.log(this.state.clicked, 'clicked');
	      // console.log(this.state.choice, 'this.state.choice');
	      if (_this.state.clicked) {
	        clearInterval(_this.timer);
	        // const chosen_answer = this.state.choice;
	        var right_answer = 0;
	        _this.setState({ result_block: 'card show_block' });
	        //console.log(item);
	        if (item.right_choice === _this.state.choice) {
	          right_answer = 1;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box failure'
	            });
	          }
	          if (item.right_choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.right_choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: 'INCORRECT',
	            result_block: 'card show_block'
	          });
	        }
	        if (!_this.state.validated) {
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            right_answer: right_answer,
	            time_done: _this.state.count,
	            chapter_id: _this.props.params.chapterid,
	            caseIndex: _this.props.params.case_offset
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	            if (resp.success) {
	              _this.setState({ ValidToken: true, validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false, timer_tag: 'Stop' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({
	          timer_stop: true
	        });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      console.log('save Question ------> ', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      console.log('items ----------> ', item);
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          caseid = _this$props$params.caseid,
	          case_offset = _this$props$params.case_offset,
	          readingid = _this$props$params.readingid;
	
	      if (_this.state.questions.question_number === 6) {
	        _this.setState({ showCompletionQuestion: true });
	      } else {
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = parseInt(_this.props.params.offset, 10) + 1;
	        _this.setState({ offset: i });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':caseid', caseid).replace(':case_offset', case_offset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_questions_state[i].question_no).replace(':offset', i)
	        });
	      }
	    };
	
	    _this._getNextAnyway = function () {
	      // console.log(this.state.questions)
	      _this.setState({
	        display_loader: 'show_block',
	        showCompletionQuestion: false
	      });
	      if (_this.props.params.question_number === _this.state.casesquestion_length) {
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = 0;
	        _this.setState({ offset: i });
	
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[i].question_number + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: i,
	            offset: 0
	          }
	        });
	      } else {
	        //alert(this.state.casesquestion_length);
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var _i = _this.state.offset + 1;
	        _this.setState({ offset: _i });
	        //alert(i);
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[_i].question_number + '/' + _i,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: _i,
	            offset: _i
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      document.getElementById('comment').value = '';
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          caseid = _this$props$params2.caseid,
	          case_offset = _this$props$params2.case_offset,
	          readingid = _this$props$params2.readingid;
	
	      var i = parseInt(_this.props.params.offset, 10) - 1;
	      _this.setState({ offset: i });
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':caseid', caseid).replace(':case_offset', case_offset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_questions_state[i].question_no).replace(':offset', i)
	      });
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block'
	      });
	      var casesoffset = parseInt(_this.props.params.case_offset, 10) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	        caseid = _this.state.all_cases[casesoffset].case_id;
	
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	        //this.setState({all_cases:caseid});
	        // this.context.router.push({
	        //   pathname:
	        //     '/cfa2_chapter/' +
	        //     this.props.params.chapterid +
	        //     '/' +
	        //     caseid +
	        //     '/' +
	        //     casesoffset +
	        //     '/' +
	        //     '1' +
	        //     '/' +
	        //     0,
	        //   state: {
	        //     token: this.state.token,
	        //     idname: this.state.idname,
	        //     chapterid: this.props.params.chapterid,
	        //     caseid: caseid,
	        //     case_offset: casesoffset,
	        //     question_number: 1,
	        //     offset: 0,
	        //   },
	        // });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block'
	      });
	      // const casesoffset = parseInt(this.state.cases_offset, 10) + 1;
	      var casesoffset = _this.props.params.case_offset - 1;
	      var caseid = _this.state.all_cases[casesoffset].case_id;
	      if (_this.state.cases_offset === 0) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	      } else {
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.expandScreen = function () {
	      _this.setState({
	        isExpand: true
	      });
	      var elem = document.getElementById('Progress1');
	      if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	      } else if (elem.webkitRequestFullscreen) {
	        /* Safari */
	        elem.webkitRequestFullscreen();
	      } else if (elem.msRequestFullscreen) {
	        /* IE11 */
	        elem.msRequestFullscreen();
	      }
	    };
	
	    _this.closeFullscreen = function () {
	      _this.setState({
	        isExpand: false
	      });
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        /* Safari */
	        document.webkitExitFullscreen();
	      } else if (document.msExitFullscreen) {
	        /* IE11 */
	        document.msExitFullscreen();
	      }
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname'],
	        chapter_id: _this.props.params.chapterid
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      // console.log('I am inside getGMATRatting', questionid);
	      var params = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname']
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.getFlashCards = function (questionid) {
	      var params = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        question_id: questionid
	      };
	      //Api to fetch flashcard by question id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	        var flash_cards = _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_FLASHCARD_FOUND
	        );
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          if (response.flash_cards.length > 0) {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	            });
	            flash_cards = response.flash_cards.map(function (items, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _this.state.flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	            });
	          }
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({
	            ValidToken: false,
	            flash_data: flash_cards,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	        }
	        return response;
	      });
	    };
	
	    _this.checkSubscription = function (SubscriptionFile, resp, resp_cases) {
	      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	        //here code for check case id free or not
	        _this.setState({
	          subscriptionstatus: 'free'
	        });
	        if (resp_cases.casesingleData.free === 0) {
	          _this.setState({
	            display_cases: 'hide_block',
	            display_subcription: 'show_block'
	          });
	          _this.toggleAlert();
	        } else {
	          _this.setState({
	            display_cases: 'show_block',
	            display_subcription: 'hide_block'
	          });
	        }
	      } else {
	        _this.setState({
	          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	        });
	        //console.log(resp_cases.casesingleData.free+'----------');
	        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	        var dataset = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          examid: data_arr
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	          if (resp_exam.success) {
	            var exam_data = resp_exam.examData;
	            var selectedmen = _this.state.selectedmenu;
	            var isInArray_var = false;
	            isInArray_var = SubscriptionFile.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	            if (isInArray_var) {
	              _this.setState({
	                subscriptionstatus: 'paid',
	                display_cases: 'show_block',
	                display_subcription: 'hide_block'
	              });
	            } else {
	              if (resp_cases.casesingleData.free === 0) {
	                _this.setState({
	                  display_cases: 'hide_block',
	                  display_subcription: 'show_block'
	                });
	              } else {
	                _this.setState({
	                  subscriptionstatus: 'free',
	                  display_cases: 'show_block',
	                  display_subcription: 'hide_block'
	                });
	              }
	            }
	          } else {
	            console.log('fail');
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      isExpand: false,
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      chaptername: '',
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      cases_offset: '',
	      casesquestion_length: '',
	      chapters: '',
	      display_loader: '',
	      selectedmenu: 'cfa_2',
	      subscriptionstatus: '',
	      display_subcription: 'hide_block',
	      display_cases: 'show_block',
	      showCompletionQuestion: false,
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cases: [],
	      exam_type: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      forumComment: '',
	      category: 'CFA Level 2',
	      tags: ['cfa-2', 'cfa', 'question', 'case'],
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      hide_case_left_arrow: '',
	      hide_case_right_arrow: '',
	      hide_question_left_arrow: '',
	      hide_question_right_arrow: '',
	      display_main_loader: 'hide_block',
	      top_50: '',
	      question_no: 1
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATCases, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.cases.casesingleData.case_number,
	        completion_status: this.state.markAsCompleted,
	        exam_type: this.state.exam_type,
	        chapter_id: this.props.params.chapterid
	      };
	      if (this.state.markAsCompleted === true) {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    ---------------------------------------------
	      Function to change, time every second
	    ---------------------------------------------
	    */
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      this.setState({ count: this.state.count + 1 });
	      //console.log(this.state.count + 1);
	    }
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to readings page
	    -------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------------------------------
	      Function to check Right Or Wrong Answered and displayed clicked box
	    -----------------------------------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	      */
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this3.state.token,
	          idname: _this3.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this3.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	      */
	
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to Edit Flash card
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	       Function to delete flash card
	    --------------------------------------
	    */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number !== this.props.params.question_number && nextProps.params.caseid === this.props.params.caseid) {
	        // console.log('I am here for pffset ----. ', nextProps.params.offset);
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        // this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid !== this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*
	    ------------------------------------------------------
	    on url question offset change run this function
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      // console.log('all_cases ----> ', case_offset);
	      // console.log('all_questions_state -----> ', question_number);
	      this.setState({
	        case_id: caseid,
	        display_main_loader: 'show_block',
	        display_cases: 'hide_block',
	        top_50: 'top-50',
	
	        ValidToken: true,
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        choice_d: 'answer_box',
	        choice_e: 'answer_box',
	        result_block: 'card hide_block',
	        rated: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      // var data = {
	      //   token: token_id,
	      //   idname: idname,
	      //   chapter_id: chapterid,
	      //   reading_id: this.props.params.readingid,
	      //   case_id: caseid,
	      // };
	      var all_questions_state = this.state.all_questions_state;
	
	      var offset_res = '';
	      var questionid = '';
	      // console.log(questionid);
	      for (var i = 0; i < all_questions_state.length; i++) {
	        if (i === parseInt(offset_val, 10)) {
	          this.setState({
	            hide_question_left_arrow: '',
	            hide_question_right_arrow: ''
	          });
	          if (i === 0) this.setState({
	            hide_question_left_arrow: 'menu_hide'
	          });else if (i === all_questions_state.length - 1) this.setState({
	            hide_question_right_arrow: 'menu_hide'
	          });
	          offset_res = i;
	          questionid = all_questions_state[i].id;
	          // console.log(all_questions_state[i]);
	          this.setState({
	            questions: all_questions_state[i],
	            offset: offset_res,
	            display_main_loader: 'hide_block',
	            top_50: '',
	            question_no: i + 1
	          });
	          this.getFavQuestions(all_questions_state[i].id);
	          this.getGMATRatting(all_questions_state[i].id);
	          this.getFlashCards(all_questions_state[i].id);
	        }
	        if (i === all_questions_state.length - 1) {
	          this.setState({
	            display_loader: 'hide_block',
	            display_cases: 'show_block'
	          });
	        }
	      }
	      // this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax
	
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this4 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        chapter_id: chapterid,
	        case_id: caseid,
	        reading_id: this.props.params.readingid,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      this.setState({
	        cases_display: '',
	        cases_name: ''
	      });
	
	      this.setState({ case_id: caseid });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCaseByReading', data).then(function (resp) {
	        if (resp.success) {
	          _this4.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            display_main_loader: 'show_block',
	            top_50: 'top-50'
	            // hide_question_right_arrow: 'menu_show',
	            // hide_question_left_arrow: 'menu_hide',
	          });
	          document.getElementById('comment').value = '';
	          _this4.setState({ all_cases: resp.questions });
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (parseInt(_this4.props.params.case_offset, 10) === i) {
	              _this4.setState({
	                hide_case_left_arrow: '',
	                hide_case_right_arrow: ''
	              });
	              if (i === 0) _this4.setState({ hide_case_left_arrow: 'true' });else if (i === resp.questions.length - 1) _this4.setState({ hide_case_right_arrow: 'true' });
	
	              _this4.setState({
	                cases_display: resp.questions[i]['gmat_case.passage'],
	                cases_name: 'Case no : ' + (parseInt(i, 10) + 1)
	              });
	            }
	          }
	          _this4.setState({ display_loader: 'hide_block' });
	          var param = {
	            token: token_id,
	            idname: idname,
	            case_id: caseid,
	            reading_id: _this4.props.params.readingid,
	            subscriptionstatus: _this4.state.subscriptionstatus
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this4.setState({
	                casesquestion_length: resp_question.questions_details.length,
	                display_main_loader: 'hide_block'
	              });
	              // console.log(
	              //   'I am having a issue here -------->',
	              //   resp_question.questions_details.length,
	              //   question_number,
	              //   offset_val
	              // );
	              if (resp_question.questions_details.length > offset_val) {
	                //let ques_res=[];
	
	                var offset_res = '';
	                var questionid = '';
	                // console.log(questionid);
	
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  // console.log(
	                  //   'resp_question.questions_details[i].length',
	                  //   resp_question.questions_details.length
	                  // );
	                  if (i === 0) {
	                    _this4.setState({
	                      hide_question_left_arrow: '',
	                      hide_question_right_arrow: ''
	                    });
	                    if (i === 0) _this4.setState({
	                      hide_question_left_arrow: 'menu_hide'
	                    });
	                    if (i === resp_question.questions_details.length - 1) _this4.setState({
	                      hide_question_right_arrow: 'menu_hide'
	                    });
	                    offset_res = i;
	                    questionid = resp_question.questions_details[i].id;
	                    _this4.setState({
	                      questions: resp_question.questions_details[i],
	                      question_no: i + 1
	                    });
	                    _this4.getFavQuestions(resp_question.questions_details[i].id);
	                    _this4.getGMATRatting(resp_question.questions_details[i].id);
	                    _this4.getFlashCards(resp_question.questions_details[i].id);
	                  }
	                  if (i === resp_question.questions_details.length - 1) {
	                    _this4.setState({ display_loader: 'hide_block' });
	                  }
	                }
	                _this4.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details,
	                  display_cases: 'show_block',
	                  top_50: ''
	                });
	                _this4.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this4.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this4.timer);
	        _this4.timer = setInterval(_this4.tick.bind(_this4), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    // ==================== CHANGES BY ME START ==============================//
	
	  }, {
	    key: 'componentDidMount',
	
	    // ==================== CHANGES BY ME END ==============================//
	    // =============================== TODO END =======================//
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this5 = this;
	
	        var storage_session, subscriptionstatusData, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  display_loader: 'show_block',
	                  display_cases: 'hide_block'
	                });
	                this.setState({
	                  case_id: this.props.params.caseid
	                });
	                subscriptionstatusData = void 0;
	
	                if (parseInt(this.props.params.subscription, 10) === 1) {
	                  this.setState({ subscriptionstatus: 'paid' });
	                  subscriptionstatusData = 'paid';
	                } else {
	                  this.setState({ subscriptionstatus: 'free' });
	                  subscriptionstatusData = 'free';
	                }
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  caseid: this.props.params.caseid,
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.chapterid,
	                  subscriptionstatus: subscriptionstatusData
	                };
	                // -------------------------- CASE AND Question ---------------- //
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCaseByReading', data).then(function (resp) {
	                  if (resp.success) {
	                    _this5.setState({
	                      ValidToken: true,
	                      all_cases: resp.questions,
	                      cases_length: resp.questions.length
	                    });
	                    console.log('this.props.params.case_offset==============>GMAT', _this5.props.params.case_offset);
	                    for (var i = 0; i < resp.questions.length; i++) {
	                      if (parseInt(_this5.props.params.case_offset, 10) === i) {
	                        if (i === 0) _this5.setState({
	                          hide_case_left_arrow: 'true'
	                        });
	                        if (i === resp.questions.length - 1) _this5.setState({
	                          hide_case_right_arrow: 'true'
	                        });
	                        _this5.setState({
	                          cases_offset: _this5.props.params.case_offset,
	                          cases_display: resp.questions[i]['gmat_case.passage'],
	                          cases_name: 'Case no: ' + (parseInt(i, 10) + 1),
	                          case_id: resp.questions[i].case_id
	                        });
	                      }
	                    }
	                    var param = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname'],
	                      reading_id: _this5.props.params.readingid,
	                      case_id: _this5.state.case_id,
	                      subscriptionstatus: subscriptionstatusData
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCasesquestion', param).then(function (resp_question) {
	                      // console.log('I am here 1111');
	                      if (resp_question.success) {
	                        _this5.setState({
	                          casesquestion_length: resp_question.questions_details.length,
	                          display_main_loader: 'hide_block'
	                        });
	                        // console.log(
	                        //   'I am having a issue here -------->',
	                        //   this.props.params,
	                        //   resp_question.questions_details.length,
	                        //   this.props.params.question_number - 1
	                        // );
	                        if (resp_question.questions_details.length > _this5.props.params.offset) {
	                          //let ques_res=[];
	
	                          var offset_res = '';
	                          var questionid = '';
	                          // console.log(questionid);
	
	                          for (var i = 0; i < resp_question.questions_details.length; i++) {
	                            // console.log(
	                            //   'resp_question.questions_details[i]',
	                            //   resp_question.questions_details[i]
	                            // );
	                            if (i === parseInt(_this5.props.params.offset, 10)) {
	                              if (i === 0) _this5.setState({
	                                hide_question_left_arrow: 'menu_hide'
	                              });
	                              if (i === resp_question.questions_details.length - 1) _this5.setState({
	                                hide_question_right_arrow: 'menu_hide'
	                              });
	                              offset_res = i;
	                              questionid = resp_question.questions_details[i].id;
	                              _this5.setState({
	                                questions: resp_question.questions_details[i],
	                                question_no: i + 1
	                              });
	                              _this5.getFavQuestions(resp_question.questions_details[i].id);
	                              _this5.getGMATRatting(resp_question.questions_details[i].id);
	                              _this5.getFlashCards(resp_question.questions_details[i].id);
	                            }
	                            if (i === resp_question.questions_details.length - 1) {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	                          }
	                          _this5.setState({
	                            offset: offset_res,
	                            all_questions_state: resp_question.questions_details,
	                            display_cases: 'show_block'
	                          });
	                          _this5.setState({ records: '' });
	                        } else {
	                          console.log('Not Valid');
	                        }
	                      }
	                    });
	                  } else {
	                    _this5.setState({ ValidToken: false, records: 'Result not found.' });
	                  }
	                  clearInterval(_this5.timer);
	                  _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	                  return resp;
	                });
	                // -------------------------- CASE AND Question ---------------- //
	                clearInterval(this.timer);
	                this.timer = setInterval(this.tick.bind(this), 1000);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var questions_data_display = this.state.questions;
	      // console.log('I am inside render', questions_data_display.question_no);
	      var reportLoading = this.state.reportLoading;
	
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	      var choice_d = 'd';
	      var choice_e = 'e';
	      var question_data = '';
	      console.log('offset ', this.state.offset);
	      this.state.showCompletionQuestion ? question_data = _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block ' + this.state.display_subcription },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card 23434' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 complete-section-wrap ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header text-center' },
	              _language2.default.LC().Mark_this_Question_as_Completed,
	              _react2.default.createElement(
	                'div',
	                { onClick: this._getNextAnyway, className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ) : question_data = _react2.default.createElement(
	        'div',
	        { className: 'note-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block ' + this.state.display_subcription },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 p-sm-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 p-sm-0 ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card box-shadow-none' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size' },
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                    className: 'margin_right_20',
	                    alt: '',
	                    width: '30'
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'title-font-size' },
	                    _language2.default.LC().QUESTION,
	                    ' ',
	                    this.state.question_no + ' - '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'float-right text-right' },
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.hide_question_left_arrow,
	                    onClick: this._getPrevious
	                  }),
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.hide_question_right_arrow,
	                    onClick: this._getNext
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row px-md-15px' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12' },
	                      (0, _function.renderHTMLContent)(questions_data_display.question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: 'false', suppressContentEditableWarning: true })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_a',
	                        onClick: this._getAnswer.bind(this, choice_a, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_a },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().A
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_a, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_b',
	                        onClick: this._getAnswer.bind(this, choice_b, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_b },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().B
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_b, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_c',
	                        onClick: this._getAnswer.bind(this, choice_c, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_c },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().C
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_c, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_d',
	                        onClick: this._getAnswer.bind(this, choice_d, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_d },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().D
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_d, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_e',
	                        onClick: this._getAnswer.bind(this, choice_e, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_e },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().E
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_e, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions_data_display,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'star_rating_wrap' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: ' margin_bottom_0 margin_right_10' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(_reactStarRatings2.default, {
	                              rating: this.state.rating,
	                              starRatedColor: 'rgb(255, 180, 0)',
	                              starEmptyColor: 'rgb(51, 51, 51)',
	                              starDimension: '20px',
	                              starHoverColor: 'rgb(255, 180, 0)',
	                              starSpacing: '2px',
	                              changeRating: this.onStarClick.bind(this, questions_data_display),
	                              numberOfStars: 5,
	                              name: 'rate1'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' bg-faded' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions_data_display.answer, "p", "view_questionhtml", { contentEditable: 'false', suppressContentEditableWarning: true })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class margin_bottom_20 report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, questions_data_display)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10 margin_bottom_20',
	                          onClick: this._hideReportForm.bind(this, questions_data_display)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        )
	      );
	
	      // const { timer_stop } = this.state;
	      return _react2.default.createElement(
	        'div',
	        { className: 'd-flex flex-column', id: 'Progress1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_CHAPTER
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'd-flex flex-sm-col' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'p-2 card mr-1 mb-0 calc_height_GMAT overflow-y-auto width-sm-100 width-50 mb-sm-1 font-lusitana bg_blue'
	              // style={{ borderRadius: '0px' }}
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex justify-content-between align-items-center card-header px-0 ' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  disabled: this.state.hide_case_left_arrow,
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getPreviousCase
	                },
	                'Previous Passage'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  disabled: this.state.hide_case_right_arrow,
	                  onClick: this._getNextCase
	                },
	                'Next Passage'
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              (0, _function.renderHTMLContent)(this.state.cases_display, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'width-50 calc_height_GMAT overflow-y-auto width-sm-100 card-border-radius-none bg-white p-2 card font-lusitana bg_blue'
	              // style={{ borderRadius: '0px' }}
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'position-relative ' + this.state.top_50 },
	              _react2.default.createElement(
	                'div',
	                { className: 'main_loader ' + this.state.display_main_loader },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loader-mid' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block-loader' },
	                    _react2.default.createElement(_loader2.default, null)
	                  )
	                )
	              ),
	              question_data
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATCases;
	}(_react.Component);
	
	// class TooltipItem extends React.Component {
	//   constructor(props) {
	//     super(props);
	
	//     this.toggle = this.toggle.bind(this);
	
	//     // document.body.style.backgroundColor = '#1d364b';
	//     this.state = {
	//       tooltipOpen: false,
	//     };
	//   }
	
	//   toggle() {
	//     this.setState({
	//       // tooltipOpen: !tooltipOpen,
	//     });
	//   }
	
	//   render() {
	//     return (
	//       <span>
	//         <img
	//           src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
	//           id={'Tooltip-' + this.props.id}
	//           width='18'
	//           alt=''
	//           style={{ marginLeft: '4px' }}
	//         />
	//         {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}
	
	//         <Tooltip
	//           placement={this.props.place_tip}
	//           // isOpen={tooltipOpen}
	//           target={'Tooltip-' + this.props.id}
	//           toggle={this.toggle}
	//         >
	//           <p className='tooltip_text'>{this.props.content}</p>
	//         </Tooltip>
	//       </span>
	//     );
	//   }
	// }
	
	
	GMATCases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATCases;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable */
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var GMATGraphical = function (_Component) {
	  _inherits(GMATGraphical, _Component);
	
	  function GMATGraphical(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATGraphical);
	
	    var _this = _possibleConstructorReturn(this, (GMATGraphical.__proto__ || Object.getPrototypeOf(GMATGraphical)).call(this, props));
	
	    _this.clickHandler = function (e, statement) {
	      var value = e.target.value;
	
	      _this.setState(_defineProperty({}, statement, { value: value, index: e.target.options.selectedIndex }));
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      document.getElementById('comment').value = '';
	      var offset = parseFloat(_this.state.offset) - 1;
	      var _this$state = _this.state,
	          questionsArray = _this$state.questionsArray,
	          reading = _this$state.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_GRAPH_MULTI_STATEMENT.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      document.getElementById('comment').value = '';
	      var offset = parseFloat(_this.state.offset) + 1;
	      var _this$state2 = _this.state,
	          questionsArray = _this$state2.questionsArray,
	          reading = _this$state2.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_GRAPH_MULTI_STATEMENT.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	    };
	
	    _this.setQuestionData = function (questionsArray, offset) {
	      var questionObj = questionsArray[offset || 0];
	      if (questionObj) {
	        _this.setState({
	          statement1: questionObj.statement1,
	          statement2: questionObj.statement2,
	          question: questionObj.question,
	          questionId: questionObj.id,
	          explanation: questionObj.explanation,
	          questionObj: questionObj,
	          offset: offset,
	          // display_loader: 'hide_block',
	          questionHide: '',
	          answers1: questionObj.answer_statement1,
	          answers2: questionObj.answer_statement2,
	          result_block: 'card hide_block',
	          report_block: 'card hide_block',
	          statementSelect1: '',
	          statementSelect2: ''
	        }, function () {
	          _this.getFavQuestions(questionObj.id);
	          _this.getGMATRatting(questionObj.id);
	        });
	      }
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'graph_question'
	      };
	      console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'graph_question'
	      };
	      //Api to get ratting
	      console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.reading)
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var _this$state3, statementSelect1, statementSelect2, answers2, answers1, questionObj, boundaryConditionAnswer1, boundaryConditionAnswer2, count, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state3 = _this.state, statementSelect1 = _this$state3.statementSelect1, statementSelect2 = _this$state3.statementSelect2, answers2 = _this$state3.answers2, answers1 = _this$state3.answers1, questionObj = _this$state3.questionObj;
	                boundaryConditionAnswer1 = questionObj['statement1_option' + statementSelect1.index].toLowerCase().trim();
	                boundaryConditionAnswer2 = questionObj['statement2_option' + statementSelect2.index].toLowerCase().trim();
	
	                statementSelect2 = statementSelect2.value.toLowerCase().trim();
	                answers2 = answers2.toLowerCase().trim();
	                statementSelect1 = statementSelect1.value.toLowerCase().trim();
	                answers1 = answers1.toLowerCase().trim();
	                count = 0;
	
	                if (!(statementSelect1 && statementSelect2)) {
	                  _context2.next = 16;
	                  break;
	                }
	
	                if (statementSelect2 === answers2 || '&' + statementSelect2 === answers2 || boundaryConditionAnswer2 === answers2) {
	                  count++;
	                }
	                if (statementSelect1 === answers1 || '&' + statementSelect1 === answers1 || boundaryConditionAnswer1 === answers1) {
	                  count++;
	                }
	                right_answer = 0;
	
	                if (count === 2) {
	                  right_answer = 1;
	                  _this.setState({
	                    result: 'CORRECT',
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block'
	                  });
	                } else {
	                  _this.setState({
	                    result_block: 'card show_block',
	                    result: 'INCORRECT',
	                    text_color: 'card-header text_failure'
	                  });
	                }
	                // --------------- Save Stat API call Start -----------//
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: _this.state.questionId,
	                  right_answer: right_answer,
	                  type: 'graph_question'
	                  // time_done: this.state.count,
	                };
	                _context2.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true
	                              });
	                            } else {
	                              _this.setState({
	                                ValidToken: false
	                              });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 16:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      // console.log("_saveQuestion");
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        type: 'graph_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'graph_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this.state = {
	      show: false,
	      question: '',
	      answers: {},
	      token: '',
	      idname: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      reportLoading: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      all_questions: '',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      text_color: 'card-header',
	      result: '',
	      explanation: '',
	      questionsArray: [],
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      subscriptionstatus: parseInt(_this.props.params.subscription, 10) ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      offset: _this.props.params.offset,
	      display_loader: 'show_block',
	      questionHide: 'hide_block'
	    };
	    return _this;
	  }
	
	  _createClass(GMATGraphical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reading_id: this.props.params.readingid,
	        question_type: 'graph_question',
	        subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	          var offset;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (resp.success) {
	                    offset = _this3.state.offset;
	
	                    _this3.setState({
	                      questionsArray: resp.result
	                    });
	                    _this3.setQuestionData(resp.result, offset);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this3);
	        }));
	
	        return function (_x4) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    }
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	    //Function to redirect page to readings page
	
	
	    //Function to show calculator
	
	
	    //Function to show Correct box and display right answer and store in database
	
	    //Function to Display Saved Question on button and save in database
	
	    //Function to show Report box
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: this.state.questionId,
	          ratting: nextValue,
	          type: 'graph_question'
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1 });
	            _this4.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: this.state.question_id,
	        idname: this.state.idname,
	        type: 'graph_question'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this4.setState({ rating: items.ratting });
	              _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              question_id: _this4.state.questionId,
	              ratting: nextValue,
	              type: 'graph_question'
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1 });
	                _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var _params2 = {
	            token: _this4.state.token,
	            idname: _this4.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', _params2).then(function (response) {
	            if (response.success) {
	              _this4.setState({ rated: 1 });
	              _this4.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to hide Report box
	
	
	    //Funcion to save new report question
	
	  }, {
	    key: 'handleImageLoaded',
	    value: function handleImageLoaded() {
	      console.log('I am inside handleImageLoaded');
	      this.setState({
	        imageStatus: 'loaded',
	        display_loader: 'hide_block'
	      });
	    }
	  }, {
	    key: 'handleImageErrored',
	    value: function handleImageErrored() {
	      console.log('I am inside handleImageErrored');
	      this.setState({ imageStatus: 'failed to load' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          question = _state.question,
	          all_questions = _state.all_questions,
	          reportLoading = _state.reportLoading,
	          explanation = _state.explanation,
	          offset = _state.offset,
	          questionsArray = _state.questionsArray,
	          reading = _state.reading,
	          display_loader = _state.display_loader,
	          questionHide = _state.questionHide,
	          statement1 = _state.statement1,
	          statement2 = _state.statement2,
	          questionId = _state.questionId;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_10 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class calc-btn',
	                onClick: this._handleModal
	              },
	              _language2.default.LC().OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            (0, _function.renderHTMLContent)(reading, "span", "", { contentEditable: 'false' }),
	            '(',
	            _language2.default.LC().Q,
	            ' ',
	            questionId,
	            ')',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: 'margin_bottom_30 statement-question-div' },
	              (0, _function.renderHTMLContent)(question ? question.split('<img src="')[0] : '', "div"),
	              _react2.default.createElement('img', {
	                src: question ? question.split('<img src="')[1].split('"')[0] : '',
	                onLoad: this.handleImageLoaded.bind(this),
	                onError: this.handleImageErrored.bind(this)
	              }),
	              (0, _function.renderHTMLContent)(question ? question.split('<img src="')[1].split('/>')[1] : '', "div"),
	              (0, _function.renderHTMLContent)(statement1, "div", "my-1", { onClick: function onClick(e) {
	                  return _this5.clickHandler(e, 'statementSelect1');
	                } }),
	              (0, _function.renderHTMLContent)(statement2, "div", "", { onClick: function onClick(e) {
	                  return _this5.clickHandler(e, 'statementSelect2');
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row bottom-tool' },
	              _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                isQue: true,
	                _getResult: this._getResult,
	                _saveQuestion: this._saveQuestion,
	                _displayReportForm: this._displayReportForm,
	                all_questions: question,
	                save_text: this.state.save_text,
	                bookmarkCSS: this.state.bookmarkCSS,
	                bookmarkColor: this.state.bookmarkColor
	                // isSpecialQuestion={true}
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'star_rating_wrap' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: ' margin_bottom_0 margin_right_10' },
	                    this.state.ratting_text
	                  ),
	                  _react2.default.createElement(_reactStarRatings2.default, {
	                    rating: this.state.rating,
	                    starRatedColor: 'rgb(255, 180, 0)',
	                    starEmptyColor: 'rgb(51, 51, 51)',
	                    starDimension: '20px',
	                    starHoverColor: 'rgb(255, 180, 0)',
	                    starSpacing: '2px',
	                    changeRating: this.onStarClick.bind(this, question),
	                    numberOfStars: 5,
	                    name: 'rate1'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.result_block + ' font-lusitana font-16px' },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.text_color },
	            this.state.result
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, all_questions)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, all_questions)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this5.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return GMATGraphical;
	}(_react.Component);
	
	GMATGraphical.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATGraphical;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable */
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var GMATTab = function (_Component) {
	  _inherits(GMATTab, _Component);
	
	  function GMATTab(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATTab);
	
	    var _this = _possibleConstructorReturn(this, (GMATTab.__proto__ || Object.getPrototypeOf(GMATTab)).call(this, props));
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'tab_question'
	      };
	      // console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'tab_question'
	      };
	      //Api to get ratting
	      // console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.openCity = function (evt, cityName) {
	      var i = void 0;
	      var tabcontent = void 0;
	      var tablinks = void 0;
	      tabcontent = document.getElementsByClassName('tabcontent');
	      for (i = 0; i < tabcontent.length; i++) {
	        tabcontent[i].style.display = 'none';
	      }
	      tablinks = document.getElementsByClassName('tablinks');
	      for (i = 0; i < tablinks.length; i++) {
	        var value = tablinks[i].value;
	        if (value === cityName) {
	          tablinks[i].className += ' active';
	        } else {
	          tablinks[i].classList.remove('active');
	        }
	        // tablinks[i].className = tablinks[i].className.replace(' active', '');
	      }
	      document.getElementById(cityName).style.display = 'block';
	      // evt.currentTarget.className += ' active';
	    };
	
	    _this.clickHandler = function (e) {
	      _this.openCity(e, e.target.value.trim());
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var _this$state, choice1, choice2, choice3, choice4, choice5, answer1, answer2, answer3, answer4, answer5, expectedCount, count, activateExplanation, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state = _this.state, choice1 = _this$state.choice1, choice2 = _this$state.choice2, choice3 = _this$state.choice3, choice4 = _this$state.choice4, choice5 = _this$state.choice5, answer1 = _this$state.answer1, answer2 = _this$state.answer2, answer3 = _this$state.answer3, answer4 = _this$state.answer4, answer5 = _this$state.answer5;
	                expectedCount = 3;
	
	                if (_this.state.statement3 === '') {
	                  expectedCount = 2;
	                }
	                count = 0;
	                activateExplanation = true;
	
	
	                if (answer4 !== '' && answer5 !== '') {
	                  activateExplanation = false;
	                  if (choice4 !== '', choice5 !== '') {
	                    activateExplanation = true;
	                  }
	                  expectedCount = 5;
	                  if (choice4.toLowerCase().trim() === answer4.toLowerCase().trim()) {
	                    count++;
	                    if (choice4.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice4_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice4_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice4.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice4_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice4_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  if (choice5.toLowerCase().trim() === answer5.toLowerCase().trim()) {
	                    count++;
	                    if (choice5.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice5_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice5_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice5.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice5_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice5_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                }
	
	                if (!(choice1 && choice2 && (choice3 || _this.state.statement3 === ''))) {
	                  _context2.next = 18;
	                  break;
	                }
	
	                if (choice1.toLowerCase().trim() === answer1.toLowerCase().trim()) {
	                  count++;
	                  if (choice1.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice1_yes: 'accent-success'
	                    });
	                  } else {
	                    _this.setState({
	                      choice1_no: 'accent-success'
	                    });
	                  }
	                } else {
	                  if (choice1.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice1_yes: 'accent-faliure'
	                    });
	                  } else {
	                    _this.setState({
	                      choice1_no: 'accent-faliure'
	                    });
	                  }
	                }
	                if (choice2.toLowerCase().trim() === answer2.toLowerCase().trim()) {
	                  count++;
	                  if (choice2.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice2_yes: 'accent-success'
	                    });
	                  } else {
	                    _this.setState({
	                      choice2_no: 'accent-success'
	                    });
	                  }
	                } else {
	                  if (choice2.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice2_yes: 'accent-faliure'
	                    });
	                  } else {
	                    _this.setState({
	                      choice2_no: 'accent-faliure'
	                    });
	                  }
	                }
	                if (choice3.toLowerCase().trim() === answer3.toLowerCase().trim()) {
	                  count++;
	                  if (choice3.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice3_yes: 'accent-success'
	                    });
	                  } else {
	                    _this.setState({
	                      choice3_no: 'accent-success'
	                    });
	                  }
	                } else {
	                  if (choice3.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice3_yes: 'accent-faliure'
	                    });
	                  } else {
	                    _this.setState({
	                      choice3_no: 'accent-faliure'
	                    });
	                  }
	                }
	                right_answer = 0;
	
	                if (expectedCount === count) {
	                  right_answer = 1;
	                  _this.setState({
	                    result: 'CORRECT',
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block'
	                  });
	                } else {
	                  if (activateExplanation) {
	                    _this.setState({
	                      result_block: 'card show_block',
	                      result: 'INCORRECT',
	                      text_color: 'card-header text_failure'
	                    });
	                  }
	                }
	                // --------------- Save Stat API call -----------//
	
	                if (!activateExplanation) {
	                  _context2.next = 16;
	                  break;
	                }
	
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: _this.state.questionId,
	                  right_answer: right_answer,
	                  type: 'tab_question'
	                  // time_done: this.state.count,
	                };
	                _context2.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({ ValidToken: true, validated: true });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 16:
	                _context2.next = 19;
	                break;
	
	              case 18:
	                console.log('I am inside else ');
	
	              case 19:
	                // console.log('excepted', expectedCount);
	                if (expectedCount === 3 || _this.state.statement3 === '') {
	                  if (choice1 && choice2 && (choice3 || _this.state.statement3 === '')) {
	                    _this.setState({
	                      error: ''
	                    });
	                    console.log('if');
	                  } else {
	                    _this.setRadioButtonBlank();
	                    _this.setState({
	                      error: 'Please select all the options'
	                    });
	                  }
	                } else if (expectedCount === 4) {
	                  if (choice1 && choice2 && choice3 && choice4) {
	                    _this.setState({
	                      error: ''
	                    });
	                  } else {
	                    _this.setRadioButtonBlank();
	                    _this.setState({
	                      error: 'Required'
	                    });
	                  }
	                } else if (expectedCount === 5) {
	                  if (choice1 && choice2 && choice3 && choice4 && choice5) {
	                    _this.setState({
	                      error: ''
	                    });
	                    console.log('if5', expectedCount);
	                  } else {
	                    _this.setRadioButtonBlank();
	                    _this.setState({
	                      error: 'Please select all options'
	                    });
	                  }
	                }
	
	              case 20:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._getResultfor5Statements = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(item, e) {
	        var _this$state2, answer1, answer2, answer3, answer4, answer5, userChoice, validateAnswer;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this$state2 = _this.state, answer1 = _this$state2.answer1, answer2 = _this$state2.answer2, answer3 = _this$state2.answer3, answer4 = _this$state2.answer4, answer5 = _this$state2.answer5, userChoice = _this$state2.userChoice;
	
	                validateAnswer = function validateAnswer(value, option) {
	                  if (value) {
	                    _this.setState(_defineProperty({
	                      result: 'CORRECT',
	                      text_color: 'card-header text_success',
	                      result_block: 'card show_block'
	                    }, 'choice' + option + '_yes', 'accent-success'));
	                  } else {
	                    _this.setState(_defineProperty({
	                      result_block: 'card show_block',
	                      result: 'INCORRECT',
	                      text_color: 'card-header text_failure'
	                    }, 'choice' + option + '_yes', 'accent-faliure'));
	                  }
	                };
	
	                if (userChoice) {
	                  if (answer1.toLocaleLowerCase().trim() === 'yes' && userChoice == 1) validateAnswer(true, userChoice);else if (answer2.toLocaleLowerCase().trim() === 'yes' && userChoice == 2) validateAnswer(true, userChoice);else if (answer3.toLocaleLowerCase().trim() === 'yes' && userChoice == 3) validateAnswer(true, userChoice);else if (answer4.toLocaleLowerCase().trim() === 'yes' && userChoice == 4) validateAnswer(true, userChoice);else if (answer5.toLocaleLowerCase().trim() === 'yes' && userChoice == 5) validateAnswer(true, userChoice);else {
	                    if (answer1.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_1: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer2.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_2: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer3.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_3: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer4.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_4: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer5.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_5: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });
	                    validateAnswer(false, userChoice);
	                  }
	                }
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        chapter_id: _this.props.params.chapterid,
	        type: 'tab_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'tab_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getPrevious = function () {
	      var error = void 0;
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: '',
	        choice1_yes: '',
	        choice2_yes: '',
	        choice3_yes: '',
	        choice4_yes: '',
	        choice5_yes: '',
	        choice1_no: '',
	        choice2_no: '',
	        choice3_no: '',
	        choice4_no: '',
	        choice5_no: '',
	        choice1: '',
	        choice2: '',
	        choice3: '',
	        choice4: '',
	        choice5: '',
	        answer1: '',
	        answer2: '',
	        answer3: '',
	        answer4: '',
	        answer5: ''
	      });
	      _this.removeRadioButtonClass();
	      _this.setRadioButtonCorrectChoice(false);
	      document.getElementById('comment').value = '';
	      _this.setRadioButtonBlank();
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      var offset = parseFloat(_this.state.offset) - 1;
	      var _this$state3 = _this.state,
	          questionsArray = _this$state3.questionsArray,
	          reading = _this$state3.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_TAB.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	      // window.location.reload();
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: '',
	        choice1_yes: '',
	        choice2_yes: '',
	        choice3_yes: '',
	        choice4_yes: '',
	        choice5_yes: '',
	        choice1_no: '',
	        choice2_no: '',
	        choice3_no: '',
	        choice4_no: '',
	        choice5_no: '',
	        choice1: '',
	        choice2: '',
	        choice3: '',
	        choice4: '',
	        choice5: '',
	        answer1: '',
	        answer2: '',
	        answer3: '',
	        answer4: '',
	        answer5: ''
	      });
	      _this.removeRadioButtonClass();
	      _this.setRadioButtonCorrectChoice(false);
	      document.getElementById('comment').value = '';
	      _this.setRadioButtonBlank();
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        // console.log('else');
	      }
	      var offset = parseFloat(_this.state.offset) + 1;
	      var _this$state4 = _this.state,
	          questionsArray = _this$state4.questionsArray,
	          reading = _this$state4.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_TAB.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	      // window.location.reload();
	    };
	
	    _this.setRadioButtonBlank = function () {
	      for (var counter = 0; counter < 5; counter++) {
	        var resetRadioButton = document.getElementsByName('choice' + (counter + 1));
	        for (var i = 0; i < resetRadioButton.length; i++) {
	          resetRadioButton[i].checked = false;
	        }
	      }
	    };
	
	    _this.setRadioButtonCorrectChoice = function (value) {
	      var resetRadioButton = document.getElementsByName('correct_choice');
	      for (var i = 0; i < resetRadioButton.length; i++) {
	        resetRadioButton[i].checked = value;
	      }
	    };
	
	    _this.setQuestionData = function (questionsArray, offset) {
	      var quesArr = questionsArray[offset || 0];
	      if (quesArr) {
	        _this.setState({
	          data: quesArr.question_tab,
	          question: quesArr.question,
	          statement1: quesArr.statement_A,
	          statement2: quesArr.statement_B,
	          statement3: quesArr.statement_C,
	          statement4: quesArr.statement_D,
	          statement5: quesArr.statement_E,
	          questionId: quesArr.id,
	          choice_a: quesArr.choice_a === '' ? 'Yes' : quesArr.choice_a,
	          choice_b: quesArr.choice_b === '' ? 'No' : quesArr.choice_b,
	          explanation: quesArr.explanation,
	          offset: offset,
	          questionHide: '',
	          answer1: quesArr.answer_A,
	          answer2: quesArr.answer_B,
	          answer3: quesArr.answer_C,
	          answer4: quesArr.answer_D,
	          answer5: quesArr.answer_E,
	          display_loader: 'hide_block',
	          result_block: 'card hide_block',
	          report_block: 'card hide_block'
	        }, function () {
	          // console.log('I am inside setQuestionData', quesArr.id);
	          _this.getFavQuestions(quesArr.id);
	          _this.getGMATRatting(quesArr.id);
	        });
	      }
	      console.log('answer', _this.state.answer1);
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.reading)
	      });
	    };
	
	    _this.onChangeValueFor5Statement = function (event, value) {
	      var _this$setState3;
	
	      _this.removeRadioButtonClass();
	      _this.setRadioButtonCorrectChoice(false);
	      var name = event.target.name;
	
	      _this.setState((_this$setState3 = {
	        userChoice: value
	      }, _defineProperty(_this$setState3, name + '_yes', ''), _defineProperty(_this$setState3, name + '_no', ''), _this$setState3));
	    };
	
	    _this.removeRadioButtonClass = function () {
	      _this.setState({
	        choice1_yes: '',
	        choice2_yes: '',
	        choice3_yes: '',
	        choice4_yes: '',
	        choice5_yes: '',
	        choice1_no: '',
	        choice2_no: '',
	        choice3_no: '',
	        choice4_no: '',
	        choice5_no: '',
	
	        correct_answer_1: '',
	        correct_answer_2: '',
	        correct_answer_3: '',
	        correct_answer_4: '',
	        correct_answer_5: ''
	      });
	    };
	
	    _this.state = {
	      show: false,
	      data: '',
	      question: '',
	      statement1: '',
	      statement2: '',
	      statement3: '',
	      statement4: '',
	      statement5: '',
	      choice1: '',
	      choice2: '',
	      choice3: '',
	      choice4: '',
	      choice5: '',
	      choice_a: 'Yes',
	      choice_b: 'No',
	      explanation: '',
	      error: '',
	      token: '',
	      idname: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      text_color: 'card-header',
	      result: '',
	      reportLoading: false,
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      subscriptionstatus: parseInt(_this.props.params.subscription, 10) ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      offset: _this.props.params.offset,
	      questionsArray: [],
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      choice1_yes: '',
	      choice2_yes: '',
	      choice3_yes: '',
	      choice4_yes: '',
	      choice5_yes: '',
	      choice1_no: '',
	      choice2_no: '',
	      choice3_no: '',
	      choice4_no: '',
	      choice5_no: '',
	      answer1: '',
	      answer2: '',
	      answer3: '',
	      answer4: '',
	      answer5: '',
	      userChoice: ''
	    };
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reading_id: this.props.params.readingid,
	        question_type: 'tab_question',
	        subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId', data).then(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	          var offset;
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (resp.success) {
	                    offset = _this3.state.offset;
	
	                    _this3.setState({
	                      questionsArray: resp.result
	                    });
	                    _this3.setQuestionData(resp.result, offset);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this3);
	        }));
	
	        return function (_x6) {
	          return _ref4.apply(this, arguments);
	        };
	      }());
	    }
	
	    /*
	    ------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	      */
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this4.state.token,
	          idname: _this4.state.idname,
	          question_id: _this4.state.questionId,
	          ratting: nextValue,
	          type: 'tab_question'
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	    //Function to redirect page to readings page
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(event) {
	      var _setState;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + '_yes', ''), _defineProperty(_setState, name + '_no', ''), _setState));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          statement1 = _state.statement1,
	          statement2 = _state.statement2,
	          statement3 = _state.statement3,
	          statement4 = _state.statement4,
	          statement5 = _state.statement5,
	          choice_a = _state.choice_a,
	          choice_b = _state.choice_b,
	          question = _state.question,
	          explanation = _state.explanation,
	          reportLoading = _state.reportLoading,
	          offset = _state.offset,
	          questionsArray = _state.questionsArray,
	          reading = _state.reading,
	          display_loader = _state.display_loader,
	          questionHide = _state.questionHide,
	          choice1_yes = _state.choice1_yes,
	          choice2_yes = _state.choice2_yes,
	          choice3_yes = _state.choice3_yes,
	          choice4_yes = _state.choice4_yes,
	          choice5_yes = _state.choice5_yes,
	          choice1_no = _state.choice1_no,
	          choice2_no = _state.choice2_no,
	          choice3_no = _state.choice3_no,
	          choice4_no = _state.choice4_no,
	          choice5_no = _state.choice5_no,
	          questionId = _state.questionId,
	          correct_answer_1 = _state.correct_answer_1,
	          correct_answer_2 = _state.correct_answer_2,
	          correct_answer_3 = _state.correct_answer_3,
	          correct_answer_4 = _state.correct_answer_4,
	          correct_answer_5 = _state.correct_answer_5,
	          error = _state.error;
	      // console.log('error---------------', error);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class calc-btn',
	                onClick: this._handleModal
	              },
	              _language2.default.LC().OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            (0, _function.renderHTMLContent)(reading, "span", "", { contentEditable: 'false' }),
	            ' (',
	            _language2.default.LC().Q,
	            ' ',
	            questionId,
	            ')',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'col-lg-6 mb-0 calc_height_GMAT overflow-y-auto mb-sm-1',
	                style: {
	                  borderRadius: '0px',
	                  borderRight: '1px solid #f5f5f5'
	                }
	              },
	              (0, _function.renderHTMLContent)(this.state.data, "div", "", { onClick: this.clickHandler })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'col-lg-6 mb-0 calc_height_GMAT overflow-y-auto  mb-sm-1 font-16px',
	                style: { borderRadius: '0px' }
	              },
	              (0, _function.renderHTMLContent)(this.state.option, "div"),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.submit, className: 'm-15px' },
	                (0, _function.renderHTMLContent)(question, "div"),
	                _react2.default.createElement(
	                  'table',
	                  { className: 'm-15px' },
	                  statement1 && statement2 && statement3 && statement4 && statement5 ? _react2.default.createElement(
	                    'tbody',
	                    { className: 'first-letter-capitilize' },
	                    _react2.default.createElement(
	                      'tr',
	                      { onChange: function onChange(e) {
	                          return _this5.onChangeValueFor5Statement(e, 1);
	                        } },
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'pr-1' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: correct_answer_1 ? 'correct_choice' : 'choice1',
	                          name: correct_answer_1 ? 'correct_choice' : 'choice1'
	                          // checked={correct_answer_1}
	                          , value: 'Yes',
	                          className: correct_answer_1 ? 'accent-success pointer_class' : choice1_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement1
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      { onChange: function onChange(e) {
	                          return _this5.onChangeValueFor5Statement(e, 2);
	                        } },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: correct_answer_2 ? 'correct_choice' : 'choice1',
	                          name: correct_answer_2 ? 'correct_choice' : 'choice1'
	                          // checked={correct_answer_2}
	                          , value: 'Yes',
	                          className: correct_answer_2 ? 'accent-success pointer_class' : choice2_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement2
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      { onChange: function onChange(e) {
	                          return _this5.onChangeValueFor5Statement(e, 3);
	                        } },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: correct_answer_3 ? 'correct_choice' : 'choice1',
	                          name: correct_answer_3 ? 'correct_choice' : 'choice1'
	                          // checked={correct_answer_3}
	                          , value: 'Yes',
	                          className: correct_answer_3 ? 'accent-success pointer_class' : choice3_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement3
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      { onChange: function onChange(e) {
	                          return _this5.onChangeValueFor5Statement(e, 4);
	                        } },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: correct_answer_4 ? 'correct_choice' : 'choice1',
	                          name: correct_answer_4 ? 'correct_choice' : 'choice1'
	                          // checked={correct_answer_4}
	                          , value: 'Yes',
	                          className: correct_answer_4 ? 'accent-success pointer_class' : choice4_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement4
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tr',
	                      { onChange: function onChange(e) {
	                          return _this5.onChangeValueFor5Statement(e, 5);
	                        } },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: correct_answer_5 ? 'correct_choice' : 'choice1',
	                          name: correct_answer_5 ? 'correct_choice' : 'choice1'
	                          // checked={correct_answer_5}
	                          , value: 'Yes',
	                          className: correct_answer_3 ? 'accent-success pointer_class' : choice5_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement5
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'tbody',
	                    { className: 'first-letter-capitilize' },
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        choice_a
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        choice_b
	                      ),
	                      _react2.default.createElement('th', null)
	                    ),
	                    statement1 ? _react2.default.createElement(
	                      'tr',
	                      { onChange: this.onChangeValue },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: 'choice1',
	                          value: 'Yes',
	                          className: choice1_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: 'choice1',
	                          value: 'No',
	                          className: choice1_no + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement1
	                      )
	                    ) : null,
	                    statement2 ? _react2.default.createElement(
	                      'tr',
	                      { onChange: this.onChangeValue },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: 'choice2',
	                          value: 'Yes',
	                          className: choice2_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: 'choice2',
	                          value: 'No',
	                          className: choice2_no + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement2
	                      )
	                    ) : null,
	                    statement3 ? _react2.default.createElement(
	                      'tr',
	                      { onChange: this.onChangeValue },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: 'choice3',
	                          value: 'Yes',
	                          className: choice3_yes + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: 'choice3',
	                          value: 'No',
	                          className: choice3_no + '  pointer_class'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        statement3
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'error_msg' },
	                  error
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex' },
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                    isQue: true,
	                    _getResult: statement1 && statement2 && statement3 && statement4 && statement5 ? this._getResultfor5Statements : this._getResult,
	                    _saveQuestion: this._saveQuestion,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: question,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                    // isSpecialQuestion={true}
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'star_rating_wrap' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: ' margin_bottom_0 margin_right_10' },
	                        this.state.ratting_text
	                      ),
	                      _react2.default.createElement(_reactStarRatings2.default, {
	                        rating: this.state.rating,
	                        starRatedColor: 'rgb(255, 180, 0)',
	                        starEmptyColor: 'rgb(51, 51, 51)',
	                        starDimension: '20px',
	                        starHoverColor: 'rgb(255, 180, 0)',
	                        starSpacing: '2px',
	                        changeRating: this.onStarClick.bind(this, question),
	                        numberOfStars: 5,
	                        name: 'rate1'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' + this.state.result_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.text_color },
	                    this.state.result
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block font-16px' },
	                    (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false', suppressContentEditableWarning: true })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, question)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, question)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this5.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return GMATTab;
	}(_react.Component);
	
	GMATTab.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATTab;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // my datatatatat
	
	/* eslint-disable */
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	// let tableRegex = /(<table[^>]*>(?:.|\n)*(?=<\/table>))/g;
	var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'table_question'
	      };
	      console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'tab_question'
	      };
	      //Api to get ratting
	      console.log('I am inside get Fav question', questionid);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.setQuestionData = function (questionsArray, offset) {
	      var questionObj = questionsArray[offset || 0];
	      if (questionObj) {
	        _this.setState({
	          question: questionObj.question.split('<table') ? questionObj.question.split('<table')[0] : questionObj.question,
	          tableData: '<table id="myTable" border="1" cellpadding="5px" ' + (questionObj.question.split('<table') ? questionObj.question.split('<table')[1] : questionObj.question),
	          sortElement: questionObj.sortBy ? questionObj.sortBy.split(',') : [],
	          explanation: questionObj.explanation ? questionObj.explanation.split(',') : [],
	          statement1: questionObj.option1,
	          statement2: questionObj.option2,
	          statement3: questionObj.option3,
	          answer1: questionObj.answer1,
	          answer2: questionObj.answer2,
	          answer3: questionObj.answer3,
	          questionId: questionObj.id,
	          offset: offset,
	          display_loader: 'hide_block',
	          questionHide: '',
	          choice1: '',
	          choice2: '',
	          choice3: '',
	          choice1_yes: '',
	          choice2_yes: '',
	          choice3_yes: '',
	          choice1_no: '',
	          choice2_no: '',
	          choice3_no: '',
	          correct_heading: questionObj.choice_a,
	          incorrect_heading: questionObj.choice_b,
	          result_block: 'card hide_block',
	          report_block: 'card hide_block'
	        }, function () {
	          _this.getFavQuestions(questionObj.id);
	          _this.getGMATRatting(questionObj.id);
	        });
	      }
	    };
	
	    _this._getAnswer = function (choice, e) {
	      _this.setState({ clicked: true });
	      _this.setState({ choice: choice });
	      // const result = getDeviceDetails();
	
	      if (choice === 'choice_a') {
	        _this.setState({ choice_a: 'answer_box clicked_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_b') {
	        _this.setState({ choice_b: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_c') {
	        _this.setState({ choice_c: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_d') {
	        _this.setState({ choice_d: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box ' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_e') {
	        _this.setState({ choice_e: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var _this$state, choice1, choice2, choice3, answer1, answer2, answer3, expectedCount, count, _count, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state = _this.state, choice1 = _this$state.choice1, choice2 = _this$state.choice2, choice3 = _this$state.choice3, answer1 = _this$state.answer1, answer2 = _this$state.answer2, answer3 = _this$state.answer3;
	                expectedCount = 3;
	                count = 0;
	
	                if (!(choice1 && choice2 && choice3)) {
	                  _context2.next = 15;
	                  break;
	                }
	
	                _count = 0;
	
	                if (choice1.toLowerCase().trim() === answer1.toLowerCase().trim()) {
	                  _count++;
	                  if (choice1.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice1_yes: 'accent-success'
	                    });
	                  } else {
	                    _this.setState({
	                      choice1_no: 'accent-success'
	                    });
	                  }
	                } else {
	                  if (choice1.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice1_yes: 'accent-faliure'
	                    });
	                  } else {
	                    _this.setState({
	                      choice1_no: 'accent-faliure'
	                    });
	                  }
	                }
	                if (choice2.toLowerCase().trim() === answer2.toLowerCase().trim()) {
	                  _count++;
	                  if (choice2.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice2_yes: 'accent-success'
	                    });
	                  } else {
	                    _this.setState({
	                      choice2_no: 'accent-success'
	                    });
	                  }
	                } else {
	                  if (choice2.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice2_yes: 'accent-faliure'
	                    });
	                  } else {
	                    _this.setState({
	                      choice2_no: 'accent-faliure'
	                    });
	                  }
	                }
	                if (choice3.toLowerCase().trim() === answer3.toLowerCase().trim()) {
	                  _count++;
	                  if (choice3.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice3_yes: 'accent-success'
	                    });
	                  } else {
	                    _this.setState({
	                      choice3_no: 'accent-success'
	                    });
	                  }
	                } else {
	                  if (choice3.toLowerCase().trim() === 'yes') {
	                    _this.setState({
	                      choice3_yes: 'accent-faliure'
	                    });
	                  } else {
	                    _this.setState({
	                      choice3_no: 'accent-faliure'
	                    });
	                  }
	                }
	                right_answer = 0;
	
	                if (expectedCount === _count) {
	                  right_answer = 1;
	                  _this.setState({
	                    result: 'CORRECT',
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block'
	                  });
	                } else {
	                  _this.setState({
	                    result_block: 'card show_block',
	                    result: 'INCORRECT',
	                    text_color: 'card-header text_failure'
	                  });
	                }
	                // --------------- Save Stat API call Start -----------//
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: _this.state.questionId,
	                  right_answer: right_answer,
	                  type: 'table_question'
	                  // time_done: this.state.count,
	                };
	                _context2.next = 13;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({ ValidToken: true, validated: true });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 13:
	                _context2.next = 16;
	                break;
	
	              case 15:
	                console.log('I am inside else ');
	
	              case 16:
	                if (expectedCount === 3) {
	                  if (choice1 && choice2 && choice3) {
	                    _this.setState({
	                      error: ''
	                    });
	                  } else {
	                    _this.setState({
	                      error: 'Please select all the options'
	                    });
	                  }
	                }
	
	              case 17:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      document.getElementById('comment').value = '';
	      _this.setRadioButtonBlank();
	      var offset = parseFloat(_this.state.offset) - 1;
	      var _this$state2 = _this.state,
	          questionsArray = _this$state2.questionsArray,
	          reading = _this$state2.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_TABLE.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	      // window.location.reload();
	    };
	
	    _this.setRadioButtonBlank = function () {
	      for (var counter = 0; counter < 5; counter++) {
	        var resetRadioButton = document.getElementsByName('choice' + (counter + 1));
	        for (var i = 0; i < resetRadioButton.length; i++) {
	          resetRadioButton[i].checked = false;
	        }
	      }
	      document.getElementById('table_data_select').selectedIndex = 0;
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        rating: 0,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      _this.setRadioButtonBlank();
	      document.getElementById('comment').value = '';
	      var offset = parseFloat(_this.state.offset) + 1;
	      var _this$state3 = _this.state,
	          questionsArray = _this$state3.questionsArray,
	          reading = _this$state3.reading;
	
	      _this.setQuestionData(questionsArray, offset);
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_TABLE.replace(':chapterid', _this.state.chapter_id).replace(':readingid', _this.state.reading_id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', questionsArray[offset || 0].id).replace(':offset', offset).replace(':reading', reading)
	      });
	      // window.location.reload();
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        chapter_id: _this.props.params.chapterid,
	        type: 'table_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'table_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.reading)
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.resetTableContent = function () {
	      var _this$state4 = _this.state,
	          questionsArray = _this$state4.questionsArray,
	          offset = _this$state4.offset;
	
	      var questionObj = questionsArray[offset || 0];
	      _this.setState({
	        tableData: ''
	      }, function () {
	        _this.setState({
	          tableData: '<table id="myTable" border="1" cellpadding="5px" ' + (questionObj.question.split('<table') ? questionObj.question.split('<table')[1] : questionObj.question)
	        });
	        document.getElementById('table_data_select').selectedIndex = 0;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this.state = {
	      token: '',
	      idname: '',
	      data: [],
	      question: '',
	      statement1: '',
	      statement2: '',
	      statement3: '',
	      choice1: '',
	      choice2: '',
	      choice3: '',
	      error: '',
	      sortElement: [],
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      offset: _this.props.params.offset,
	      explanation: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      report_block: 'card hide_block',
	      text_color: 'card-header',
	      result: '',
	      reportLoading: false,
	      result_block: 'card hide_block',
	      questionsArray: [],
	      subscriptionstatus: parseInt(_this.props.params.subscription, 10) ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      answer1: '',
	      answer2: '',
	      answer3: '',
	      choice1_yes: '',
	      choice2_yes: '',
	      choice3_yes: '',
	      choice1_no: '',
	      choice2_no: '',
	      choice3_no: ''
	    };
	
	    // http://reactkungfu.com/2015/07/why-and-how-to-bind-methods-in-your-react-component-classes/
	    // bind the context for compareBy & sortBy to this component instance
	    _this.compareBy.bind(_this);
	    _this.sortBy.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'compareBy',
	    value: function compareBy(key) {
	      return function (a, b) {
	        if (a[key] < b[key]) return -1;
	        if (a[key] > b[key]) return 1;
	        return 0;
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reading_id: this.props.params.readingid,
	        question_type: 'table_question',
	        subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId', data).then(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	          var offset;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (resp.success) {
	                    offset = _this3.state.offset;
	
	                    _this3.setState({
	                      questionsArray: resp.result
	                    });
	                    _this3.setQuestionData(resp.result, offset);
	                  }
	                  console.log('questioooonn array', _this3.state.questionsArray);
	
	                case 2:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this3);
	        }));
	
	        return function (_x4) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    }
	
	    //Function to check Right Or Wrong Answered and displayed clicked box
	
	
	    //Function to fetch previous question
	
	    //Function to fetch Next question
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	
	    //Function to hide Report box
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: this.state.questionId,
	          ratting: nextValue,
	          type: 'table_question'
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this4.state.token,
	          idname: _this4.state.idname,
	          question_id: _this4.state.questionId,
	          ratting: nextValue,
	          type: 'table_question'
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to redirect page to readings page
	
	
	    //Function to show calculator
	
	  }, {
	    key: 'sortBy',
	    value: function sortBy(key) {
	      var arrayCopy = [].concat(_toConsumableArray(this.state.data));
	      arrayCopy.sort(this.compareBy(key));
	      this.setState({ data: arrayCopy });
	    }
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(event) {
	      var _setState;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + '_yes', ''), _defineProperty(_setState, name + '_no', ''), _setState));
	    }
	  }, {
	    key: 'sortTable',
	    value: function sortTable(value, e) {
	      var index = value;
	      // this.state.sortElement.find((element, i) => {
	      //   if (element === value) index = i;
	      // });
	      var table, rows, switching, i, x, y, shouldSwitch;
	      table = document.getElementById('bodyData');
	      switching = true;
	      /*Make a loop that will continue until
	      no switching has been done:*/
	      var firstValue = void 0,
	          secondValue = void 0;
	      while (switching) {
	        //start by saying: no switching is done:
	        switching = false;
	        rows = table.rows;
	        /*Loop through all table rows (except the
	        first, which contains table headers):*/
	        for (i = 0; i < rows.length - 1; i++) {
	          //start by saying there should be no switching:
	          shouldSwitch = false;
	          /*Get the two elements you want to compare,
	          one from current row and one from the next:*/
	          x = rows[i].getElementsByTagName('TD')[index];
	          y = rows[i + 1].getElementsByTagName('TD')[index];
	          //check if the two rows should switch place:
	          if (x !== undefined && y !== undefined) {
	            firstValue = parseFloat(x.innerHTML.replace(/[>,<]/gm, '').replace(/&[gl]t;/gm, ''));
	            secondValue = parseFloat(y.innerHTML.replace(/[>,<]/gm, '').replace(/&[gl]t;/gm, ''));
	            if (isNaN(firstValue)) {
	              firstValue = x.innerHTML.toLowerCase().trim();
	              firstValue = specialChars.test(firstValue) ? '0' : firstValue;
	            }
	            if (isNaN(secondValue)) {
	              secondValue = y.innerHTML.toLowerCase().trim();
	              secondValue = specialChars.test(secondValue) ? '0' : secondValue;
	            }
	            if (isNaN(firstValue) !== isNaN(secondValue)) {
	              if (isNaN(firstValue)) firstValue = 0;
	              if (isNaN(secondValue)) secondValue = 0;
	            }
	            if (firstValue === secondValue) {
	              var repGtx = x.innerHTML.toLowerCase().replace('&gt;', '>');
	              var repGty = y.innerHTML.toLowerCase().replace('&gt;', '>');
	              var repltx = x.innerHTML.toLowerCase().replace('&lt;', '<');
	              var replty = y.innerHTML.toLowerCase().replace('&lt;', '<');
	              if (repGtx.includes('>') && !repGty.includes('>')) {
	                shouldSwitch = true;
	                break;
	              }
	              if (!repltx.includes('<') && replty.includes('<')) {
	                shouldSwitch = true;
	                break;
	              }
	            }
	            if (firstValue > secondValue) {
	              //if so, mark as a switch and break the loop:
	              shouldSwitch = true;
	              break;
	            }
	          }
	        }
	        if (shouldSwitch) {
	          /*If a switch has been marked, make the switch
	          and mark that a switch has been done:*/
	          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
	          switching = true;
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          statement1 = _state.statement1,
	          statement2 = _state.statement2,
	          statement3 = _state.statement3,
	          correct_heading = _state.correct_heading,
	          incorrect_heading = _state.incorrect_heading,
	          question = _state.question,
	          tableData = _state.tableData,
	          explanation = _state.explanation,
	          reportLoading = _state.reportLoading,
	          questionsArray = _state.questionsArray,
	          offset = _state.offset,
	          reading = _state.reading,
	          display_loader = _state.display_loader,
	          questionHide = _state.questionHide,
	          choice3_yes = _state.choice3_yes,
	          choice3_no = _state.choice3_no,
	          choice1_yes = _state.choice1_yes,
	          choice1_no = _state.choice1_no,
	          choice2_yes = _state.choice2_yes,
	          choice2_no = _state.choice2_no,
	          questionId = _state.questionId,
	          error = _state.error;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class calc-btn',
	                onClick: this._handleModal
	              },
	              _language2.default.LC().OPEN_CALCULATOR
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_READING
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            (0, _function.renderHTMLContent)(reading, "span", "", { contentEditable: 'false' }),
	            ' (',
	            _language2.default.LC().Q,
	            ' ',
	            questionId,
	            ')',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block font-16px statement-question-div' },
	            (0, _function.renderHTMLContent)(question, "div", "text-justify"),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex mt-1 align-items-center mb-1' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'm-0  font-weight-bold' },
	                'Sort By :'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  name: 'table_data_select',
	                  id: 'table_data_select'
	                  // onChange={(e) => this.sortBy(e.target.value)}
	                  , onChange: function onChange(e) {
	                    return _this5.sortTable(e.target.value);
	                  },
	                  className: 'h-min-content ml-35px w-lg-30 w-sm-50'
	                },
	                _react2.default.createElement(
	                  'option',
	                  { selected: 'selected', disabled: 'disabled', value: 'DEFAULT' },
	                  'Select...'
	                ),
	                this.state.sortElement && this.state.sortElement.length ? this.state.sortElement.map(function (value, index) {
	                  return _react2.default.createElement(
	                    'option',
	                    {
	                      key: index,
	                      value: index
	                      // onChange={() => this.sortBy(value)}
	                      , onChange: function onChange() {
	                        return _this5.sortTable(index, value);
	                      }
	                    },
	                    (0, _function.renderHTMLContent)(value, "span")
	                  );
	                }) : null
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions ml-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' Reset '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'submit',
	                    className: 'btn btn-circle btn-refresh pointer_class',
	                    id: 'Tooltip-2',
	                    onClick: this.resetTableContent
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-refresh p-0', 'aria-hidden': 'true' })
	                )
	              )
	            ),
	            (0, _function.renderHTMLContent)(tableData, "div", "overflow-x-auto table-w-100"),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.submit },
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    correct_heading
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    incorrect_heading
	                  ),
	                  _react2.default.createElement('th', null)
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { onChange: this.onChangeValue },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'html',
	                      name: 'choice1',
	                      value: 'Yes',
	                      className: choice1_yes + '  pointer_class'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'html',
	                      name: 'choice1',
	                      value: 'No',
	                      className: choice1_no + '  pointer_class'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    statement1
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { onChange: this.onChangeValue },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'html',
	                      name: 'choice2',
	                      value: 'Yes',
	                      className: choice2_yes + ' pointer_class'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'html',
	                      name: 'choice2',
	                      value: 'No',
	                      className: choice2_no + '  pointer_class'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    statement2
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  { onChange: this.onChangeValue },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'html',
	                      name: 'choice3',
	                      value: 'Yes',
	                      className: choice3_yes + ' pointer_class'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'html',
	                      name: 'choice3',
	                      value: 'No',
	                      className: choice3_no + '  pointer_class'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    statement3
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'error_msg1' },
	              error
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row bottom-tool mt-1' },
	              _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                isQue: true,
	                _getResult: this._getResult,
	                _saveQuestion: this._saveQuestion,
	                _displayReportForm: this._displayReportForm,
	                all_questions: question,
	                save_text: this.state.save_text,
	                bookmarkCSS: this.state.bookmarkCSS,
	                bookmarkColor: this.state.bookmarkColor
	                // isSpecialQuestion={true}
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'star_rating_wrap' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: ' margin_bottom_0 margin_right_10' },
	                    this.state.ratting_text
	                  ),
	                  _react2.default.createElement(_reactStarRatings2.default, {
	                    rating: this.state.rating,
	                    starRatedColor: 'rgb(255, 180, 0)',
	                    starEmptyColor: 'rgb(51, 51, 51)',
	                    starDimension: '20px',
	                    starHoverColor: 'rgb(255, 180, 0)',
	                    starSpacing: '2px',
	                    changeRating: this.onStarClick.bind(this, question),
	                    numberOfStars: 5,
	                    name: 'rate1'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.result_block + ' font-lusitana font-16px' },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.text_color },
	            this.state.result
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, question)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, question)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this5.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Table;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var ViewGMATques = function (_Component) {
	  _inherits(ViewGMATques, _Component);
	
	  function ViewGMATques(props) {
	    _classCallCheck(this, ViewGMATques);
	
	    var _this = _possibleConstructorReturn(this, (ViewGMATques.__proto__ || Object.getPrototypeOf(ViewGMATques)).call(this, props));
	
	    _this._goToVideo = function () {
	      _this.setState({
	        chapter_video_redirect: _this.state.chapters[parseInt(_this.props.params.chapter_no) - 1]
	      }, function () {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', _this.state.chapter_video_redirect.chapter_no).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1),
	          // .replace(':type', '')
	          // .replace(':chapter_id', '')
	          // .replace(':index', '')
	          search: '?chapter_name=' + _this.state.chapter_video_redirect.chapter_name
	        });
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapter_no)
	
	        // `/readings/${this.props.params.chapter_no}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.props.location.state.reading.chapter_no,
	        // },
	      });
	    };
	
	    _this._beginChapter = function (item, index, caseOffset, questionOffset, e) {
	      var reading = _this.state.readingDetails;
	
	      if (reading.type === 'case_question') {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', item.chapter_id).replace(':readingid', reading.id).replace(':caseid', item.case_id).replace(':case_offset', caseOffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', item.id).replace(':offset', questionOffset)
	        });
	      } else if (reading.type === 'tab_question' || reading.type === 'graph_question' || reading.type === 'table_question' || reading.type === 'two_part_question') {
	        var routeName = void 0;
	        switch (reading.type) {
	          case 'tab_question':
	            routeName = 'GMAT_TAB';
	            break;
	          case 'graph_question':
	            routeName = 'GMAT_GRAPH_MULTI_STATEMENT';
	            break;
	          case 'table_question':
	            routeName = 'GMAT_TABLE';
	            break;
	          case 'two_part_question':
	            routeName = 'GMAT_TWO_PART_STATEMENT';
	            break;
	          default:
	            console.log('Route Name issue');
	            break;
	        }
	        _this.context.router.push({
	          pathname: _AppRoutes2.default[routeName].replace(':chapterid', item.chapter_id).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', item.id).replace(':offset', index).replace(':reading', reading.reading)
	        });
	      } else {
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', item.chapter_id).replace(':readingid', item.reading_id).replace(':id', item.id)
	        });
	      }
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      SubsciptionMessage: _alertMessage2.default.messageContent_gmat,
	      token: '',
	      idname: '',
	      readingName: _this.props.params.reading,
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      subscriptionstatus: _this.props.params.subscriptionstatus,
	      chapters: [],
	      subscription_details: '',
	      showFreePremium: true,
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'gmat',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      isVideo: true,
	      display_loader: 'show'
	    };
	    return _this;
	  }
	
	  _createClass(ViewGMATques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this2 = this;
	
	        var storage_session, getProfileInfo, data_data, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', getProfileInfo).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.profileInfo) {
	                              _this2.setState({
	                                isVideo: resp.profileInfo.isVideo
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                data_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true, chapters: resp.cfavideo });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                });
	
	              case 8:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset, subscription_details;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_selected === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this2.setState({
	                              showFreePremium: true
	                            });
	                            _context3.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context3.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this2.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (isInArray_var) {
	                                          _this2.setState({ showFreePremium: false });
	                                        } else {
	                                          _this2.setState({ showFreePremium: true });
	                                        }
	                                        _context2.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 9:
	                            _context3.next = 22;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context3.next = 16;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            (0, _toast.showFailure)('Please upgrade your package to access all questions');
	
	                            _this2.setState({
	                              showFreePremium: true
	                            });
	                            _context3.next = 22;
	                            break;
	
	                          case 16:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this2.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context3.next = 22;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this2.setState({ showFreePremium: false });
	                                } else {
	                                  (0, _toast.showFailure)('Please upgrade your package to access all questions');
	                                  //   console.log('ELSE WORKING')
	                                  _this2.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                console.log('fail');
	                              }
	                            });
	
	                          case 22:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit,
	                  subscriptionstatus: this.state.subscriptionstatus
	                };
	                _context4.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestions', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      ValidToken: true,
	                      questions: resp.questions,
	                      readingDetails: resp.readingDetails
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  _this2.setState({ display_loader: 'hide' });
	                  return resp;
	                });
	
	              case 14:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.questions;
	      var data = '';
	      var caseOffset = -1;
	      var questionOffset = 0;
	      var previousCaseId = undefined;
	      if (this.state.questions.length) {
	        data = questions.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId === item.case_id ? questionOffset++ : questionOffset = 0
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId === item.case_id ? caseOffset = caseOffset : caseOffset++
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId = item.case_id
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: _this3._beginChapter.bind(_this3, item, index, caseOffset, questionOffset),
	                className: 'border_box'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title d-flex' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'ml-1' },
	                  item.name ? item.name : _this3.state.readingName,
	                  ' (',
	                  _language2.default.LC().Q,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                _react2.default.createElement(
	                  'div',
	                  { contentEditable: 'false', className: 'view_question_height view_questionhtml' },
	                  (0, _function.renderHTMLContent)(item.question.substring(0, item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 500) + '...')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _this3.state.answered_state[index]
	                ),
	                _react2.default.createElement(UserInfo, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index,
	                  readingDetails: _this3.state.readingDetails
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = this.state.display_loader === 'show' ? _react2.default.createElement(_loader2.default, null) : null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.readingName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className:
	              // this.state.isVideo === true
	              //   ? `col-md-2 text-md-right margin_bottom_20`
	              // :
	              'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'border_box', onClick: this._getSubscribe },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  ' ',
	                  _language2.default.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box_free' },
	                (0, _function.renderHTMLContent)(this.state.SubsciptionMessage, "div", "view_question_height view_questionhtml modal-info-view-for-plan", { contentEditable: 'false' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscibe__btn text-center' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary pointer_class',
	                    onClick: this._getSubscribe
	                  },
	                  _language2.default.LC().SUBSCRIBE
	                )
	              )
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ViewGMATques;
	}(_react.Component);
	
	ViewGMATques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function UserInfo(props) {
	  var data = {
	    itemid: props.itemid,
	    chapter_id: props.chapter_id,
	    reading_id: props.reading_id,
	    idname: props.idname,
	    token: props.token,
	    type: props.readingDetails.type
	  };
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestionsByuser', data).then(function (resp) {
	    // console.log('abc'+props.answered_state+'------'+resp.success);
	    if (resp.success) {
	      if (resp.success == 'success') {
	        document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Answered';
	        document.getElementById('user_question_status' + props.answered_state).id = 'answered_status';
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Not Answered';
	        document.getElementById('user_question_status' + props.answered_state).id = 'notanswered_status';
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { id: 'user_question_status' + props.answered_state })
	  );
	}
	exports.default = ViewGMATques;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var BeforeStart = function (_Component) {
	  _inherits(BeforeStart, _Component);
	
	  function BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (BeforeStart.__proto__ || Object.getPrototypeOf(BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.beginQuiz = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, all_reading_type, all_cases_id, final_exam, data;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, all_reading_type = _this$state.all_reading_type, all_cases_id = _this$state.all_cases_id;
	              final_exam = [];
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context4.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context3.next = 12;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context3.next = 5;
	                            break;
	                          }
	
	                          _this.toggleAlert();
	                          _context3.next = 10;
	                          break;
	
	                        case 5:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context3.next = 10;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 10;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context.next = 6;
	                                      return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        if (all_reading_type[0] === 'case_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':case', all_cases_id[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'tab_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'graph_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'table_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'two_part_question') {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else {
	                                          _this.context.router.push({
	                                            pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        }
	                                      } else {
	                                        _this.toggleAlert();
	                                      }
	                                      _context.next = 10;
	                                      break;
	
	                                    case 10:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this2);
	                            }));
	
	                            return function (_x2) {
	                              return _ref3.apply(this, arguments);
	                            };
	                          }()
	                          // console.log('fail');
	                          );
	
	                        case 10:
	                          _context3.next = 13;
	                          break;
	
	                        case 12:
	                          if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                            _this.toggleAlert();
	                          } else {
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	
	                                        if (isInArray_var) {
	                                          if (all_reading_type[0] === 'case_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':case', all_cases_id[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'tab_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'graph_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'table_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'two_part_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          }
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context2.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	                          }
	
	                        case 13:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.viewQuizquestion = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(item, offset_va, e) {
	        var _this$state2, all_reading_type, all_cases_id, final_exam, data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this$state2 = _this.state, all_reading_type = _this$state2.all_reading_type, all_cases_id = _this$state2.all_cases_id;
	                final_exam = [];
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _GMATSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          if (all_reading_type[offset_va] === 'case_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':case', all_cases_id[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'tab_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'graph_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'table_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'two_part_question') {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          }
	
	                                          // this.context.router.push({
	                                          //   pathname: AppRoutes.BEGIN_QUIZ.replace(
	                                          //     ':quiz_id',
	                                          //     this.state.quiz_id
	                                          //   ).replace(':offset', offset_va),
	
	                                          // });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context6.next = 13;
	                            break;
	
	                          case 12:
	                            if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this.toggleAlert();
	                            } else {
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _GMATSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    if (all_reading_type[offset_va] === 'case_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':case', all_cases_id[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'tab_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'graph_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', all_reading_type[offset_va]).replace(':offset', offset_va).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'table_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'two_part_question') {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else {
	                                      _this.context.router.push({
	                                        pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    }
	
	                                    // this.context.router.push({
	                                    //   pathname: AppRoutes.BEGIN_QUIZ.replace(
	                                    //     ':quiz_id',
	                                    //     this.state.quiz_id
	                                    //   ).replace(':offset', offset_va),
	
	                                    // });
	                                  } else {
	                                    _this.toggleAlert();
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 13:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x4, _x5, _x6) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'gmat',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      timerInSeconds: 0
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //Function to redirect page to Create Quiz page
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    //Function to redirect page to begin Quiz page
	
	
	    /*
	    ------------------------------------------------------
	        Function to redirect page to begin Quiz page
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var cases = JSON.parse(JSON.parse(retun_all_question)).cases;
	
	          var question_id = [];
	          var reading_id = [];
	          var case_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	            case_id.push(cases[i]);
	          }
	          console.log('resp.timer_value---', resp.timer_value);
	          var minutes = Math.floor(resp.timer_value / 60);
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count,
	            all_reading_type: reading_id,
	            all_cases_id: case_id,
	            timerInSeconds: resp.timer_value
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var question_id_display = '';
	      var _state = this.state,
	          all_reading_type = _state.all_reading_type,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id,
	          all_question_id = _state.all_question_id;
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: token,
	                idname: idname,
	                quiz_id: quiz_id,
	                answered_state: index,
	                type: all_reading_type[index]
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'javascript: void(0)', onClick: _this4.viewQuizquestion.bind(_this4, items, index) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	      var _state2 = this.state,
	          timerInSeconds = _state2.timerInSeconds,
	          user_time_value = _state2.user_time_value,
	          status_send = _state2.status_send;
	
	      var user_time = '';
	      var min,
	          sec = '';
	      var status_data = '';
	      var spentTime = timerInSeconds - user_time_value;
	      if (status_send === 'abondon') {
	        if (spentTime < 60) {
	          user_time = spentTime + 'sec';
	        } else {
	          min = parseInt(spentTime / 60);
	          sec = spentTime % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this.beginQuiz.bind(this) },
	          ' ',
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this.beginQuiz.bind(this) },
	          ' ',
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().QUIZ_ID,
	            ': ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().NO_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().CORRECT_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().WRONG_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id,
	    type: props.type
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data).then(function (resp) {
	    if (document.getElementById('questionNameId_' + props.answered_state) !== null) document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer === 1) {
	        var userQuestionStatus = document.getElementById('user_question_status' + props.answered_state);
	        var answerFlag = document.getElementById('answer_flag' + props.answered_state);
	        if (userQuestionStatus) userQuestionStatus.id = 'quiz_answered_status';
	        if (answerFlag) answerFlag.innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        var _userQuestionStatus = document.getElementById('user_question_status' + props.answered_state);
	        var _answerFlag = document.getElementById('answer_flag' + props.answered_state);
	        if (_userQuestionStatus) _userQuestionStatus.id = 'quiz_wrong_answered_status';
	        if (_answerFlag) _answerFlag.innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	        // document.getElementById(
	        //   'user_question_status' + props.answered_state
	        // ).id = 'quiz_wrong_answered_status';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	        // document.getElementById(
	        //   'answer_flag' + props.answered_state
	        // ).innerHTML = `${language.LC().WRONG_ANSWER}`;
	      }
	    } else {
	      if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = BeforeStart;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _reactstrap = __webpack_require__(6);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatings from 'react-star-ratings';
	// import { Tooltip } from 'reactstrap';
	
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	/* eslint-disable */
	
	var GMATCases = function (_Component) {
	  _inherits(GMATCases, _Component);
	
	  // =============================== TODO START =======================//
	  function GMATCases(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, GMATCases);
	
	    var _this = _possibleConstructorReturn(this, (GMATCases.__proto__ || Object.getPrototypeOf(GMATCases)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getAnswer = function (choice, questionId) {
	      _this.setState({ clicked: true, choice: 'choice_' + choice }, function () {
	        // console.log('choice ----> ', this.state.choice);
	      });
	      if (choice === 'a') {
	        _this.setState({
	          choice_a: 'answer_box clicked_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'b') {
	        _this.setState({
	          choice_b: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'c') {
	        _this.setState({
	          choice_c: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'd') {
	        _this.setState({
	          choice_d: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'e') {
	        _this.setState({
	          choice_e: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box'
	        });
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: questionId,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      if (!_this.state.validated) {
	        //  console.log('quiz id  '+this.state.quiz_id+'---question_id---'+this.state.all_question_id[this.state.offset]+'-----right answer-----'+right_answer);
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          question_id: _this.state.all_question_id[_this.state.offset],
	          answer: right_answer,
	          reading_id: item.reading_id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	          if (resp.success) {
	            var data = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              question_id: _this.state.all_question_id[_this.state.offset],
	              right_answer: right_answer,
	              time_done: 0
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	              if (resp.success) {} else {}
	            });
	            _this.setState({ ValidToken: true });
	            _this.setState({ validated: true });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._getResult = function (item, e) {
	      if (_this.state.clicked) {
	        clearInterval(_this.timer);
	        // const chosen_answer = this.state.choice;
	        var right_answer = 0;
	        _this.setState({ result_block: 'card show_block' });
	        //console.log(item);
	        if (item.right_choice === _this.state.choice) {
	          right_answer = 1;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box failure'
	            });
	          }
	          if (item.right_choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.right_choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: 'INCORRECT',
	            result_block: 'card show_block'
	          });
	        }
	
	        if (!_this.state.validated) {
	          //  console.log('quiz id  '+this.state.quiz_id+'---question_id---'+this.state.all_question_id[this.state.offset]+'-----right answer-----'+right_answer);
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            answer: right_answer,
	            reading_id: item.reading_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	            if (resp.success) {
	              var data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                question_id: _this.state.all_question_id[_this.state.offset],
	                right_answer: right_answer,
	                time_done: 0
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                if (resp.success) {} else {}
	              });
	              _this.setState({ ValidToken: true });
	              _this.setState({ validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveComment = function (item, forumData) {
	      if (document.getElementById('ques_comment').value === '') {
	        return;
	      }
	      var comment = document.getElementById('ques_comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      /*Api to save comment*/
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          _this.setState({ forumComment: '' });
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          var location = _this.props.location;
	          var pathname = location.pathname;
	
	          var titleUpdated = '' + _language2.default.LC().Q + item.question_number + ' ' + _language2.default.LC().CASE_STUDY + ' ' + item.case_id + ' - ' + _this.state.cases_name;
	          var data = {
	            idname: _this.state.idname,
	            token: _this.state.token,
	            title: titleUpdated,
	            description: forumData,
	            tags: _this.state.tags,
	            category: _this.state.category,
	            postFrom: 'app',
	            appQuestion: true,
	            quesID: item.id,
	            comment: comment,
	            caseId: item.case_id,
	            caseRedirectURL: '' + _App_data2.default.frontend_url + pathname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/forum/savePost', data).then(function (resp) {
	            if (resp.success) {
	              _this.setState({ title: '', description: '' });
	              /*Api to get comment*/
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                var comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                if (response.success) {
	                  _this.setState({ ValidToken: true });
	                  //this.setState({getComments : resp.comments});
	                  if (response.comments.length > 0) {
	                    comments = response.comments.map(function (items, index) {
	                      return (
	                        //alert(items.id)
	                        _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          response.user_id === items.uid ? _react2.default.createElement(
	                            'ul',
	                            { className: 'icon_list' },
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                {
	                                  className: 'pointer_class',
	                                  onClick: _this._editComment.bind(_this, items)
	                                },
	                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                {
	                                  className: 'pointer_class',
	                                  onClick: _this._deleteComment.bind(_this, items)
	                                },
	                                _react2.default.createElement('i', { className: 'fa fa-close' })
	                              )
	                            )
	                          ) : _react2.default.createElement('ul', null),
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            'By ',
	                            items.username,
	                            ', ',
	                            new Date(items.createdAt).toDateString()
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.comment
	                          )
	                        )
	                      );
	                    });
	
	                    _this.setState({ comment_data: comments });
	                  } else {
	                    _this.setState({ comment_data: comments });
	                  }
	                } else {
	                  _this.setState({ comment_data: comments, ValidToken: false });
	                }
	                return response;
	              });
	            }
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        /// return resp;
	      });
	    };
	
	    _this._editComment = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, e) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                document.getElementById('ques_comment').value = item.comment;
	                _context.next = 3;
	                return _this.setState({
	                  forumComment: item.comment,
	                  comment_update: 'btn btn-primary active pointer_class margin_bottom_20',
	                  comment_save: 'hide_block',
	                  comment_update_id: item.id
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._updateComment = function (item, e) {
	      if (document.getElementById('ques_comment').value === '') {
	        return;
	      }
	      var comment = document.getElementById('ques_comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        comment_id: _this.state.comment_update_id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/updateComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          _this.setState({ forumComment: '' });
	          _this.setState({
	            comment_update: 'hide_block',
	            comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	            comment_update_id: ''
	          });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_COMMENTS_FOUND
	            );
	
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              //this.setState({getComments : resp.comments});
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      response.user_id === items.uid ? _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._editComment.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteComment.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ) : _react2.default.createElement('ul', null),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'By ',
	                        items.username,
	                        ', ',
	                        new Date(items.createdAt).toDateString()
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        items.comment
	                      )
	                    )
	                  );
	                });
	
	                _this.setState({ comment_data: comments });
	              } else {
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              _this.setState({ comment_data: comments, ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._deleteComment = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        comment: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.question_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_COMMENTS_FOUND
	            );
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              //this.setState({getComments : resp.comments});
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    response.user_id === items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	
	                _this.setState({ comment_data: comments });
	              } else {
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              _this.setState({ comment_data: comments, ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              //this.setState({getComments : resp.comments});
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false, clicked: false });
	
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      _this.setState({
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        choice_d: 'answer_box',
	        choice_e: 'answer_box'
	      });
	      document.getElementById('comment').value = '';
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          //console.log('Timer Update Successfull');
	        } else {
	            //console.log('Fail Timer Update');
	          }
	      });
	      var index_id = _this.state.offset + 1;
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (_this.state.question_length - 1 == index_id) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        var questionsbyid = resp.questionsbyid;
	
	        if (resp.success) {
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          _this.setState({
	            cases_display: questionsbyid['gmat_case.passage']
	          });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _this.setState({ display_loader: 'hide_block' });
	          //console.log(data_check);
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          _this.setState({ choice_a: 'answer_box' });
	          _this.setState({ choice_b: 'answer_box' });
	          _this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getNextAnyway = function () {
	      // console.log(this.state.questions)
	      _this.setState({
	        display_loader: 'show_block',
	        showCompletionQuestion: false
	      });
	      if (_this.props.params.question_number === _this.state.casesquestion_length) {
	        _this.setState({
	          validated: false,
	          clicked: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = 0;
	        _this.setState({ offset: i });
	
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[i].question_number + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: i,
	            offset: 0
	          }
	        });
	      } else {
	        //alert(this.state.casesquestion_length);
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var _i = _this.state.offset + 1;
	        _this.setState({ offset: _i });
	        //alert(i);
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[_i].question_number + '/' + _i,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: _i,
	            offset: _i
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false, clicked: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      _this.setState({
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        choice_d: 'answer_box',
	        choice_e: 'answer_box'
	      });
	      document.getElementById('comment').value = '';
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          console.log('Timer Update Successfull');
	        } else {
	          console.log('Fail Timer Update');
	        }
	      });
	
	      var index_id = _this.state.offset - 1;
	      if (_this.state.question_length - 1 != index_id) {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var questionsbyid = resp.questionsbyid;
	
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', questionsbyid['gmat_reading.type']).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          // this.context.router.push({
	          //   pathname: AppRoutes.BEGIN_QUIZ.replace(
	          //     ':quiz_id',
	          //     this.state.quiz_id
	          //   ).replace(':offset', parseInt(this.props.params.offset) - 1),
	
	          //   //   `/gmat_beginquiz/${this.state.quiz_id}/${parseInt(
	          //   //   this.props.params.offset
	          //   // ) - 1}`,
	          // });
	
	          _this.setState({
	            cases_display: questionsbyid['gmat_case.passage'],
	            display_loader: 'hide_block'
	          });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          _this.setState({ choice_a: 'answer_box' });
	          _this.setState({ choice_b: 'answer_box' });
	          _this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block',
	        clicked: false
	      });
	      var casesoffset = parseInt(_this.props.params.case_offset, 10) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	        caseid = _this.state.all_cases[casesoffset].case_id;
	
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	        //this.setState({all_cases:caseid});
	        // this.context.router.push({
	        //   pathname:
	        //     '/cfa2_chapter/' +
	        //     this.props.params.chapterid +
	        //     '/' +
	        //     caseid +
	        //     '/' +
	        //     casesoffset +
	        //     '/' +
	        //     '1' +
	        //     '/' +
	        //     0,
	        //   state: {
	        //     token: this.state.token,
	        //     idname: this.state.idname,
	        //     chapterid: this.props.params.chapterid,
	        //     caseid: caseid,
	        //     case_offset: casesoffset,
	        //     question_number: 1,
	        //     offset: 0,
	        //   },
	        // });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block',
	        clicked: false
	      });
	      // const casesoffset = parseInt(this.state.cases_offset, 10) + 1;
	      var casesoffset = _this.props.params.case_offset - 1;
	      var caseid = _this.state.all_cases[casesoffset].case_id;
	      if (_this.state.cases_offset === 0) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	      } else {
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_BEGINCASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.expandScreen = function () {
	      _this.setState({
	        isExpand: true
	      });
	      var elem = document.getElementById('Progress1');
	      if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	      } else if (elem.webkitRequestFullscreen) {
	        /* Safari */
	        elem.webkitRequestFullscreen();
	      } else if (elem.msRequestFullscreen) {
	        /* IE11 */
	        elem.msRequestFullscreen();
	      }
	    };
	
	    _this.closeFullscreen = function () {
	      _this.setState({
	        isExpand: false
	      });
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        /* Safari */
	        document.webkitExitFullscreen();
	      } else if (document.msExitFullscreen) {
	        /* IE11 */
	        document.msExitFullscreen();
	      }
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname'],
	        chapter_id: _this.props.params.chapterid
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      // console.log('I am inside getGMATRatting', questionid);
	      var params = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname']
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.getComments = function (questionid) {
	      var params = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        question_id: questionid
	      };
	      //Api to fetch Comment
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	        //console.log(response);
	        var comments = _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_COMMENTS_FOUND
	        );
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          //console.log(response)           ;
	          if (response.comments.length > 0) {
	            comments = response.comments.map(function (items, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                response.user_id === items.uid ? _react2.default.createElement(
	                  'ul',
	                  { className: 'icon_list' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'pointer_class', onClick: _this._editComment.bind(_this, items) },
	                      _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'pointer_class', onClick: _this._deleteComment.bind(_this, items) },
	                      _react2.default.createElement('i', { className: 'fa fa-close' })
	                    )
	                  )
	                ) : _react2.default.createElement('ul', null),
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _language2.default.LC().BY,
	                  ' ',
	                  items.username,
	                  ', ',
	                  new Date(items.createdAt).toDateString()
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  items.comment
	                )
	              );
	            });
	
	            _this.setState({ comment_data: comments });
	          } else {
	            _this.setState({ comment_data: comments });
	          }
	        } else {
	          _this.setState({
	            comment_data: comments,
	            ValidToken: false
	          });
	        }
	        return response;
	      });
	    };
	
	    _this.getFlashCards = function (questionid) {
	      var params = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        question_id: questionid
	      };
	      //Api to fetch flashcard by question id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	        var flash_cards = _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_FLASHCARD_FOUND
	        );
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          if (response.flash_cards.length > 0) {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	            });
	            flash_cards = response.flash_cards.map(function (items, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _this.state.flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	            });
	          }
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({
	            ValidToken: false,
	            flash_data: flash_cards,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	        }
	        return response;
	      });
	    };
	
	    _this.checkSubscription = function (SubscriptionFile, resp, resp_cases) {
	      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	        //here code for check case id free or not
	        _this.setState({
	          subscriptionstatus: 'free'
	        });
	        if (resp_cases.casesingleData.free === 0) {
	          _this.setState({
	            display_cases: 'hide_block',
	            display_subcription: 'show_block'
	          });
	          _this.toggleAlert();
	        } else {
	          _this.setState({
	            display_cases: 'show_block',
	            display_subcription: 'hide_block'
	          });
	        }
	      } else {
	        _this.setState({
	          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	        });
	        //console.log(resp_cases.casesingleData.free+'----------');
	        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	        var dataset = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          examid: data_arr
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	          if (resp_exam.success) {
	            var exam_data = resp_exam.examData;
	            var selectedmen = _this.state.selectedmenu;
	            var isInArray_var = false;
	            isInArray_var = SubscriptionFile.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	            if (isInArray_var) {
	              _this.setState({
	                subscriptionstatus: 'paid',
	                display_cases: 'show_block',
	                display_subcription: 'hide_block'
	              });
	            } else {
	              if (resp_cases.casesingleData.free === 0) {
	                _this.setState({
	                  display_cases: 'hide_block',
	                  display_subcription: 'show_block'
	                });
	              } else {
	                _this.setState({
	                  subscriptionstatus: 'free',
	                  display_cases: 'show_block',
	                  display_subcription: 'hide_block'
	                });
	              }
	            }
	          } else {
	            console.log('fail');
	          }
	        });
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', _this.state.quiz_id).replace(':status_send', 'abondon')
	      });
	    };
	
	    _this.state = (_this$state = {
	      isExpand: false,
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      getComments: [],
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: _this.props.params.timer ? _this.props.params.timer : 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      chaptername: '',
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      cases_offset: '',
	      casesquestion_length: '',
	      chapters: '',
	      display_loader: '',
	      selectedmenu: 'cfa_2',
	      subscriptionstatus: '',
	      display_subcription: 'hide_block',
	      display_cases: 'show_block',
	      showCompletionQuestion: false,
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cases: [],
	      exam_type: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      forumComment: '',
	      category: 'CFA Level 2',
	      tags: ['cfa-2', 'cfa', 'question', 'case'],
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      hide_case_left_arrow: '',
	      hide_case_right_arrow: '',
	      hide_question_left_arrow: '',
	      hide_question_right_arrow: '',
	      display_main_loader: 'hide_block',
	      top_50: '',
	      question_no: 1,
	      quiz_id: _this.props.params.quiz_id
	    }, _defineProperty(_this$state, 'offset', _this.props.params.offset ? parseInt(_this.props.params.offset) : 0), _defineProperty(_this$state, 'display_question', ''), _this$state);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATCases, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.cases.casesingleData.case_number,
	        completion_status: this.state.markAsCompleted,
	        exam_type: this.state.exam_type,
	        chapter_id: this.props.params.chapterid
	      };
	      if (this.state.markAsCompleted === true) {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this3._getReadings();
	          }
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this3._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    ---------------------------------------------
	      Function to change, time every second
	    ---------------------------------------------
	    */
	    //Function to change time every second and store in database
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count != 0) {
	        var count_value = this.state.count - 1;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: count_value
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	          if (resp.success) {
	            // console.log('Timer Update Successfull');
	          } else {
	              // console.log('Fail Timer Update');
	            }
	        });
	        this.setState({ count: this.state.count - 1 });
	        this.setState({ timer_display: 'card-block' });
	      } else {
	        this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(':status_send', 'completed')
	        });
	      }
	      // if (this.state.timer_value == this.state.count) {
	      //   // this.setState({count_end_message:'Time&#8242;s Up'});
	      //   this.setState({ timer_display: 'card hide_block' });
	      // }
	    }
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to readings page
	    -------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------------------------------
	      Function to check Right Or Wrong Answered and displayed clicked box
	    -----------------------------------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	      */
	
	
	    /*Function to start or stop timer*/
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this4.state.token,
	          idname: _this4.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------------
	      Function to save comment And display new comment
	    -----------------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------
	     Function to Edit particular comment
	    -----------------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	        Function to Update Comment
	    -----------------------------------
	    */
	
	
	    /*
	    --------------------------------------------
	      Function to delete particular comment
	    --------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	      */
	
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to Edit Flash card
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	       Function to delete flash card
	    --------------------------------------
	    */
	
	
	    //Function to fetch Next question
	
	    //Function to fetch previous question
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number !== this.props.params.question_number && nextProps.params.caseid === this.props.params.caseid) {
	        // console.log('I am here for pffset ----. ', nextProps.params.offset);
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        // this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid !== this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*
	    ------------------------------------------------------
	    on url question offset change run this function
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      // console.log('all_cases ----> ', case_offset);
	      // console.log('all_questions_state -----> ', question_number);
	      this.setState({
	        case_id: caseid,
	        display_main_loader: 'show_block',
	        display_cases: 'hide_block',
	        top_50: 'top-50',
	
	        ValidToken: true,
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        choice_d: 'answer_box',
	        choice_e: 'answer_box',
	        result_block: 'card hide_block',
	        rated: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      // var data = {
	      //   token: token_id,
	      //   idname: idname,
	      //   chapter_id: chapterid,
	      //   reading_id: this.props.params.readingid,
	      //   case_id: caseid,
	      // };
	      var all_questions_state = this.state.all_questions_state;
	
	      var offset_res = '';
	      var questionid = '';
	      // console.log(questionid);
	      for (var i = 0; i < all_questions_state.length; i++) {
	        if (i === parseInt(offset_val, 10)) {
	          this.setState({
	            hide_question_left_arrow: '',
	            hide_question_right_arrow: ''
	          });
	          if (i === 0) this.setState({
	            hide_question_left_arrow: 'menu_hide'
	          });else if (i === all_questions_state.length - 1) this.setState({
	            hide_question_right_arrow: 'menu_hide'
	          });
	          offset_res = i;
	          questionid = all_questions_state[i].id;
	          // console.log(all_questions_state[i]);
	          this.setState({
	            questions: all_questions_state[i],
	            offset: offset_res,
	            display_main_loader: 'hide_block',
	            top_50: '',
	            question_no: i + 1
	          });
	          this.getFavQuestions(all_questions_state[i].id);
	          this.getGMATRatting(all_questions_state[i].id);
	          this.getComments(all_questions_state[i].id);
	          this.getFlashCards(all_questions_state[i].id);
	        }
	        if (i === all_questions_state.length - 1) {
	          this.setState({
	            display_loader: 'hide_block',
	            display_cases: 'show_block'
	          });
	        }
	      }
	      // this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax
	
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        chapter_id: chapterid,
	        case_id: caseid,
	        reading_id: this.props.params.readingid,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      this.setState({
	        cases_display: '',
	        cases_name: ''
	      });
	
	      this.setState({ case_id: caseid });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCaseByReading', data).then(function (resp) {
	        if (resp.success) {
	          _this5.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            display_main_loader: 'show_block',
	            top_50: 'top-50'
	            // hide_question_right_arrow: 'menu_show',
	            // hide_question_left_arrow: 'menu_hide',
	          });
	          document.getElementById('comment').value = '';
	          _this5.setState({ all_cases: resp.questions });
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (parseInt(_this5.props.params.case_offset, 10) === i) {
	              _this5.setState({
	                hide_case_left_arrow: '',
	                hide_case_right_arrow: ''
	              });
	              if (i === 0) _this5.setState({ hide_case_left_arrow: 'menu_hide' });else if (i === resp.questions.length - 1) _this5.setState({ hide_case_right_arrow: 'menu_hide' });
	
	              _this5.setState({
	                cases_display: resp.questions[i]['gmat_case.passage'],
	                cases_name: 'Case no : ' + (parseInt(i, 10) + 1)
	              });
	            }
	          }
	          _this5.setState({ display_loader: 'hide_block' });
	          var param = {
	            token: token_id,
	            idname: idname,
	            case_id: caseid,
	            reading_id: _this5.props.params.readingid,
	            subscriptionstatus: _this5.state.subscriptionstatus
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this5.setState({
	                casesquestion_length: resp_question.questions_details.length,
	                display_main_loader: 'hide_block'
	              });
	              // console.log(
	              //   'I am having a issue here -------->',
	              //   resp_question.questions_details.length,
	              //   question_number,
	              //   offset_val
	              // );
	              if (resp_question.questions_details.length > offset_val) {
	                //let ques_res=[];
	
	                var offset_res = '';
	                var questionid = '';
	                // console.log(questionid);
	
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  // console.log(
	                  //   'resp_question.questions_details[i].length',
	                  //   resp_question.questions_details.length
	                  // );
	                  if (i === 0) {
	                    _this5.setState({
	                      hide_question_left_arrow: '',
	                      hide_question_right_arrow: ''
	                    });
	                    if (i === 0) _this5.setState({
	                      hide_question_left_arrow: 'menu_hide'
	                    });
	                    if (i === resp_question.questions_details.length - 1) _this5.setState({
	                      hide_question_right_arrow: 'menu_hide'
	                    });
	                    offset_res = i;
	                    questionid = resp_question.questions_details[i].id;
	                    _this5.setState({
	                      questions: resp_question.questions_details[i],
	                      question_no: i + 1
	                    });
	                    _this5.getFavQuestions(resp_question.questions_details[i].id);
	                    _this5.getGMATRatting(resp_question.questions_details[i].id);
	                    _this5.getComments(resp_question.questions_details[i].id);
	                    _this5.getFlashCards(resp_question.questions_details[i].id);
	                  }
	                  if (i === resp_question.questions_details.length - 1) {
	                    _this5.setState({ display_loader: 'hide_block' });
	                  }
	                }
	                _this5.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details,
	                  display_cases: 'show_block',
	                  top_50: ''
	                });
	                _this5.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this5.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this5.timer);
	        _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    // ==================== CHANGES BY ME START ==============================//
	
	  }, {
	    key: 'componentDidMount',
	
	    // ==================== CHANGES BY ME END ==============================//
	    // =============================== TODO END =======================//
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this6 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  display_loader: 'show_block',
	                  // display_cases: 'hide_block',
	                  quiz_id: this.state.quiz_id
	                });
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  quiz_id: this.state.quiz_id
	                };
	                //Api to fetch Quiz by quiz id
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	                  if (resp.success) {
	                    var retun_all_question = JSON.stringify(resp.singlequiz);
	                    var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	                    var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	                    var question_id = [];
	                    var reading_id = [];
	                    for (var i = 0; i < resp.questions_count; i++) {
	                      question_id.push(all_questions[i]);
	                      reading_id.push(readings[i]);
	                    }
	                    var timer_value = resp.timer_value;
	
	                    var first_question_id = question_id[_this6.state.offset];
	                    var first_reading_type = reading_id[_this6.state.offset];
	                    var user_timer = resp.user_time_value;
	                    _this6.setState({
	                      user_time_value: user_timer,
	                      count: resp.user_time_value ? resp.user_time_value : parseInt(_this6.props.params.timer),
	                      count_temp: user_timer
	                    });
	                    _this6.setState({
	                      all_question_id: question_id,
	                      question_length: question_id.length,
	                      timer_value: timer_value,
	                      include_timer: resp.include_timer,
	                      first_question_id: first_question_id,
	                      first_reading_type: first_reading_type,
	                      all_reading_type: reading_id
	                    });
	
	                    if (question_id.length - 1 == _this6.state.offset) {
	                      _this6.setState({ next_block: 'card hide_block' });
	                    }
	
	                    var data = {
	                      token: _this6.state.token,
	                      idname: _this6.state.idname,
	                      question_id: first_question_id,
	                      type: first_reading_type
	                    };
	                    //Api to fetch question by question id
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	                      if (resp.success) {
	                        var data_check = {
	                          token: _this6.state.token,
	                          idname: _this6.state.idname,
	                          quiz_id: _this6.state.quiz_id,
	                          question_id: first_question_id,
	                          type: first_reading_type
	                        };
	                        /*Api to fetch question and check answered */
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                          _this6.setState({ already_answered_status: resp_inner.message });
	                        });
	                        // console.log('esp.questionsbyid-----', resp.questionsbyid);
	                        _this6.setState({ ValidToken: true });
	                        _this6.setState({
	                          display_question: resp.questionsbyid,
	                          cases_display: resp.questionsbyid['gmat_case.passage']
	                        });
	                        _this6.setState({ display_loader: 'hide_block' });
	                        var params = {
	                          token: _this6.state.token,
	                          question_id: first_question_id,
	                          idname: _this6.state.idname,
	                          type: first_reading_type
	                        };
	                        /*Api to fetch Saved question */
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                          if (response.success) {
	                            _this6.setState({
	                              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                            });
	                            _this6.setState({
	                              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                            });
	                            _this6.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	                            _this6.setState({
	                              save_text: '' + _language2.default.LC().Question_Saved
	                            });
	                          }
	                        });
	                        var params = {
	                          token: _this6.state.token,
	                          idname: _this6.state.idname,
	                          quiz_id: _this6.state.quiz_id,
	                          question_id: first_question_id
	                        };
	                        /*Api to fetch commented on question*/
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                          if (response.success) {
	                            var comments = '';
	                            _this6.setState({ ValidToken: true });
	                            if (response.comments.length > 0) {
	                              comments = response.comments.map(function (items, index) {
	                                return _react2.default.createElement(
	                                  'li',
	                                  { key: index },
	                                  response.user_id == items.uid ? _react2.default.createElement(
	                                    'ul',
	                                    { className: 'icon_list' },
	                                    _react2.default.createElement(
	                                      'li',
	                                      null,
	                                      _react2.default.createElement(
	                                        'a',
	                                        {
	                                          className: 'pointer_class',
	                                          onClick: _this6._editComment.bind(_this6, items)
	                                        },
	                                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'li',
	                                      null,
	                                      _react2.default.createElement(
	                                        'a',
	                                        {
	                                          className: 'pointer_class',
	                                          onClick: _this6._deleteComment.bind(_this6, items)
	                                        },
	                                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                                      )
	                                    )
	                                  ) : _react2.default.createElement('ul', null),
	                                  _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _language2.default.LC().BY,
	                                    ' ',
	                                    items.username,
	                                    ',',
	                                    ' ',
	                                    new Date(items.createdAt).toDateString()
	                                  ),
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    items.comment
	                                  )
	                                );
	                              });
	
	                              _this6.setState({ comment_data: comments });
	                            } else {
	                              comments = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_COMMENTS_FOUND
	                              );
	                              _this6.setState({ comment_data: comments });
	                            }
	                          } else {
	                            comments = _react2.default.createElement(
	                              'p',
	                              null,
	                              _language2.default.LC().NO_COMMENTS_FOUND
	                            );
	                            _this6.setState({ comment_data: comments });
	                            _this6.setState({ ValidToken: false });
	                          }
	                          return response;
	                        });
	                      } else {
	                        // console.log(resp.success + '------------failure');
	                      }
	                    });
	
	                    var params = {
	                      token: _this6.state.token,
	                      idname: _this6.state.idname,
	                      question_id: first_question_id,
	                      quiz_id: _this6.state.quiz_id
	                    };
	                    /*Api to fetch flash card*/
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	                      var flash_cards = '';
	                      if (response.success) {
	                        _this6.setState({ ValidToken: true });
	                        if (response.flash_cards.length > 0) {
	                          _this6.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                          flash_cards = response.flash_cards.map(function (items) {
	                            return (
	                              //alert(items.id)
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: '' },
	                                  _react2.default.createElement(
	                                    'ul',
	                                    { className: 'icon_list' },
	                                    _react2.default.createElement(
	                                      'li',
	                                      null,
	                                      _react2.default.createElement(
	                                        'a',
	                                        { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'li',
	                                      null,
	                                      _react2.default.createElement(
	                                        'a',
	                                        {
	                                          className: 'pointer_class',
	                                          onClick: _this6._deleteFlash.bind(_this6, items)
	                                        },
	                                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: _this6.state.flash_class },
	                                    _react2.default.createElement('h4', null),
	                                    _react2.default.createElement(
	                                      'p',
	                                      null,
	                                      items.flash_card
	                                    )
	                                  )
	                                )
	                              )
	                            );
	                          });
	                        } else {
	                          _this6.setState({ flash_form: 'col-md-12 display_block' });
	                          flash_cards = _react2.default.createElement(
	                            'p',
	                            null,
	                            _language2.default.LC().NO_FLASHCARD_FOUND
	                          );
	                        }
	                        _this6.setState({ flash_data: flash_cards });
	                      } else {
	                        flash_cards = _react2.default.createElement(
	                          'p',
	                          null,
	                          _language2.default.LC().NO_FLASHCARD_FOUND
	                        );
	                        _this6.setState({ ValidToken: false });
	                        _this6.setState({ flash_data: flash_cards });
	                        _this6.setState({ flash_form: 'col-md-12 display_block' });
	                      }
	                      return response;
	                    });
	                  } else {
	                    // console.log(resp.success + '------------failure');
	                  }
	                  return resp;
	                });
	                // -------------------------- CASE AND Question ---------------- //
	                clearInterval(this.timer);
	                this.timer = setInterval(this.tick.bind(this), 1000);
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    //Function to redirect page to readings beforestart
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var questions_data_display = this.state.display_question;
	      var questions = this.state.display_question;
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var reportLoading = this.state.reportLoading;
	
	      var choice_a = 'a';
	      var choice_b = 'b';
	      var choice_c = 'c';
	      var choice_d = 'd';
	      var choice_e = 'e';
	      var question_data = '';
	      this.state.showCompletionQuestion ? question_data = _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block ' + this.state.display_subcription },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card 23434' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 complete-section-wrap ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header text-center' },
	              _language2.default.LC().Mark_this_Question_as_Completed,
	              _react2.default.createElement(
	                'div',
	                { onClick: this._getNextAnyway, className: 'float-right text-right' },
	                _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'quation-img' },
	                        _react2.default.createElement('img', {
	                          src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                          className: 'margin_bottom_10',
	                          alt: ''
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        {
	                          contentEditable: 'false',
	                          suppressContentEditableWarning: true,
	                          className: 'margin_bottom_10 view_questionhtml bg_blue'
	                        },
	                        ' ',
	                        _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'complete-or-not-wrap' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'check-button-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            ' ',
	                            _language2.default.LC().COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_completed',
	                              name: 'mark_completed',
	                              value: 'select',
	                              onClick: this.markCompleted.bind(this),
	                              checked: this.state.markAsCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'card-actions float-right' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'check_container margin_bottom_0' },
	                            _language2.default.LC().NOT_COMPLETED,
	                            _react2.default.createElement('input', {
	                              type: 'checkbox',
	                              id: 'mark_not_completed',
	                              name: 'mark_not_completed',
	                              value: 'select',
	                              onClick: this.markNotCompleted.bind(this),
	                              checked: this.state.markAsNotCompleted
	                            }),
	                            _react2.default.createElement('span', { className: 'checkmark' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-block text-center complete-quation-submit' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            disabled: this.state.markCompleted,
	                            onClick: this.changeCompletionStatus.bind(this),
	                            className: 'btn btn-primary pointer_class'
	                          },
	                          ' ',
	                          _language2.default.LC().SUBMIT,
	                          ' '
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ) : question_data = _react2.default.createElement(
	        'div',
	        { className: 'note-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block ' + this.state.display_subcription },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 p-sm-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 p-sm-0 ' + this.state.display_cases },
	          _react2.default.createElement(
	            'div',
	            { className: 'card box-shadow-none' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'row px-md-15px' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12' },
	                      (0, _function.renderHTMLContent)(questions_data_display.question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: 'false', suppressContentEditableWarning: true })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_a',
	                        onClick: this._getAnswer.bind(this, choice_a, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_a },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().A
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_a, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_b',
	                        onClick: this._getAnswer.bind(this, choice_b, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_b },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().B
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_b, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_c',
	                        onClick: this._getAnswer.bind(this, choice_c, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_c },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().C
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_c, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_d',
	                        onClick: this._getAnswer.bind(this, choice_d, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_d },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().D
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_d, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12 col-md-12',
	                        id: 'choice_e',
	                        onClick: this._getAnswer.bind(this, choice_e, questions_data_display.id)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_e },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().E
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions_data_display.choice_e, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          clicked: this.state.clicked,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions_data_display,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' bg-faded' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions_data_display.answer, "p", "view_questionhtml", { contentEditable: 'false', suppressContentEditableWarning: true })
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        )
	      );
	
	      // console.log('question_data----------', question_data);
	      // const { timer_stop } = this.state;
	      return _react2.default.createElement(
	        'div',
	        { className: 'd-flex flex-column', id: 'Progress1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ' : ',
	              this.state.quiz_id
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'text-danger' },
	              this.state.already_answered_status
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	              ' ',
	              _language2.default.LC().BACK_TO_SUMMARY,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card py-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            _language2.default.LC().Q,
	            ' ',
	            parseInt(this.state.offset) + 1,
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }),
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex flex-sm-col' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'col-lg-5 mb-0 overflow-y-auto mb-sm-1 font-lusitana bg_blue calc_height_GMAT'
	                // style={{ borderRadius: '0px' }}
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'mt-1' },
	                (0, _function.renderHTMLContent)(this.state.cases_display, "span", "", { contentEditable: 'false', suppressContentEditableWarning: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'col-lg-5 mb-0 overflow-y-auto  mb-sm-1  card-border-radius-none bg-white p-2 font-lusitana bg_blue overflow-x-hide calc_height_GMAT'
	                // style={{ borderRadius: '0px' }}
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'position-relative ' + this.state.top_50 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'main_loader ' + this.state.display_main_loader },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'loader-mid' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    )
	                  )
	                ),
	                question_data
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-2 mt-lg-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'timer_outer' },
	                _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'timer_box' },
	                  display_time
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'quiz_timer_btn ' + this.state.timer_display },
	                _react2.default.createElement('button', {
	                  type: 'button',
	                  className: this.state.timerstopbtn,
	                  onClick: this._timer_funct.bind(this, questions)
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'text-danger' },
	                (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: 'false' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.report_block },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().REPORT
	              ),
	              !this.state.successAlert ? _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'form-control-label', htmlFor: 'textarea-input' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        _language2.default.LC().COMMENT
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 margin_bottom_10' },
	                    _react2.default.createElement('textarea', {
	                      id: 'comment',
	                      name: 'comment',
	                      rows: '6',
	                      className: 'form-control',
	                      placeholder: 'Content..'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-primary active pointer_class margin_bottom_20 report-btn',
	                        disabled: reportLoading,
	                        onClick: this._reportQuestion.bind(this, questions_data_display)
	                      },
	                      reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-danger active pointer_class margin_left_10 margin_bottom_20',
	                        onClick: this._hideReportForm.bind(this, questions_data_display)
	                      },
	                      _language2.default.LC().CANCEL
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 report-Success-card' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'form-control-label', htmlFor: 'textarea-input' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        ' ',
	                        _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'button',
	                        className: 'btn btn-primary active pointer_class  min-vw-120',
	                        onClick: this.onClose
	                      },
	                      ' ',
	                      _language2.default.LC().CLOSE
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATCases;
	}(_react.Component);
	
	// class TooltipItem extends React.Component {
	//   constructor(props) {
	//     super(props);
	
	//     this.toggle = this.toggle.bind(this);
	
	//     // document.body.style.backgroundColor = '#1d364b';
	//     this.state = {
	//       tooltipOpen: false,
	//     };
	//   }
	
	//   toggle() {
	//     this.setState({
	//       // tooltipOpen: !tooltipOpen,
	//     });
	//   }
	
	//   render() {
	//     return (
	//       <span>
	//         <img
	//           src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
	//           id={'Tooltip-' + this.props.id}
	//           width='18'
	//           alt=''
	//           style={{ marginLeft: '4px' }}
	//         />
	//         {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}
	
	//         <Tooltip
	//           placement={this.props.place_tip}
	//           // isOpen={tooltipOpen}
	//           target={'Tooltip-' + this.props.id}
	//           toggle={this.toggle}
	//         >
	//           <p className='tooltip_text'>{this.props.content}</p>
	//         </Tooltip>
	//       </span>
	//     );
	//   }
	// }
	
	
	GMATCases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATCases;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable */
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var TestDropDown = function (_Component) {
	  _inherits(TestDropDown, _Component);
	
	  function TestDropDown(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, TestDropDown);
	
	    var _this = _possibleConstructorReturn(this, (TestDropDown.__proto__ || Object.getPrototypeOf(TestDropDown)).call(this, props));
	
	    _this.clickHandler = function (e, statement) {
	      var value = e.target.value;
	
	      _this.setState(_defineProperty({}, statement, value));
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false, clicked: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      document.getElementById('comment').value = '';
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          console.log('Timer Update Successfull');
	        } else {
	          console.log('Fail Timer Update');
	        }
	      });
	
	      var index_id = _this.state.offset - 1;
	      if (_this.state.question_length - 1 != index_id) {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type && _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var questionsbyid = resp.questionsbyid;
	
	          _this.setQuestionData(resp.questionsbyid);
	
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          }
	          _this.setState({ display_loader: 'hide_block' });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getNext = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false, clicked: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      document.getElementById('comment').value = '';
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          //console.log('Timer Update Successfull');
	        } else {
	            //console.log('Fail Timer Update');
	          }
	      });
	      var index_id = _this.state.offset + 1;
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (_this.state.question_length - 1 == index_id) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        var questionsbyid = resp.questionsbyid;
	
	        _this.setQuestionData(resp.questionsbyid);
	
	        if (resp.success) {
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', questionsbyid['gmat_reading.type']).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _this.setState({ display_loader: 'hide_block' });
	          //console.log(data_check);
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this.setQuestionData = function (questionObj) {
	      if (questionObj) {
	        _this.setState({
	          statement1: questionObj.statement1,
	          statement2: questionObj.statement2,
	          question: questionObj.question,
	          questionId: questionObj.id,
	          explanation: questionObj.explanation,
	          questionHide: '',
	          answers1: questionObj.answer_statement1,
	          answers2: questionObj.answer_statement2,
	          result_block: 'card hide_block',
	          report_block: 'card hide_block',
	          statementSelect1: '',
	          statementSelect2: '',
	          reading: questionObj['gmat_reading.reading'],
	          reading_id: questionObj.reading_id
	        }, function () {
	          _this.getFavQuestions(questionObj.id);
	          _this.getGMATRatting(questionObj.id);
	        });
	      }
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'graph_question'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'graph_question'
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, e) {
	        var _this$state, statementSelect1, statementSelect2, answers2, answers1, count, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, statementSelect1 = _this$state.statementSelect1, statementSelect2 = _this$state.statementSelect2, answers2 = _this$state.answers2, answers1 = _this$state.answers1;
	
	                statementSelect2 = statementSelect2.toLowerCase().trim();
	                answers2 = answers2.toLowerCase().trim();
	                statementSelect1 = statementSelect1.toLowerCase().trim();
	                answers1 = answers1.toLowerCase().trim();
	                count = 0;
	
	                if (statementSelect1 && statementSelect2) {
	                  if (statementSelect2 === answers2 || '&' + statementSelect2 === answers2) {
	                    count++;
	                  }
	                  if (statementSelect1 === answers1 || '&' + statementSelect1 === answers1) {
	                    count++;
	                  }
	                  right_answer = 0;
	
	                  if (count === 2) {
	                    right_answer = 1;
	                    _this.setState({
	                      result: 'CORRECT',
	                      text_color: 'card-header text_success',
	                      result_block: 'card show_block'
	                    });
	                  } else {
	                    _this.setState({
	                      result_block: 'card show_block',
	                      result: 'INCORRECT',
	                      text_color: 'card-header text_failure'
	                    });
	                  }
	                  // --------------- Save Stat API call Start -----------//
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: _this.state.all_question_id[_this.state.offset],
	                    answer: right_answer,
	                    reading_id: item.reading_id,
	                    type: 'graph_question'
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	                    if (resp.success) {
	                      var data = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        question_id: _this.state.questionId,
	                        right_answer: right_answer,
	                        type: 'graph_question'
	                        // time_done: this.state.count,
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                        if (resp.success) {} else {}
	                      });
	                      _this.setState({ ValidToken: true });
	                      _this.setState({ validated: true });
	                    } else {
	                      _this.setState({ ValidToken: false });
	                    }
	                    return resp;
	                  });
	
	                  // --------------- Save Stat API call End-----------//
	                }
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      console.log('item -------> ', _this.state.reading, _this.state.reading_id);
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        type: 'graph_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid ? _this.props.params.readingid : _this.state.reading_id ? _this.state.reading_id : 0
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'graph_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.state.reading_id
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', _this.state.quiz_id).replace(':status_send', 'abondon')
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this.state = (_this$state2 = {
	      show: false,
	      question: '',
	      answers: {},
	      token: '',
	      idname: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      reportLoading: false,
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      all_questions: '',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      text_color: 'card-header',
	      result: '',
	      explanation: '',
	      questionsArray: [],
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      subscriptionstatus: _this.props.params.subscription ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      offset: _this.props.params.offset,
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      quiz_id: _this.props.params.quiz_id
	    }, _defineProperty(_this$state2, 'offset', _this.props.params.offset ? parseInt(_this.props.params.offset) : 0), _defineProperty(_this$state2, 'count', _this.props.params.timer ? _this.props.params.timer : 0), _defineProperty(_this$state2, 'display_question', ''), _defineProperty(_this$state2, 'timerstopbtn', 'icon-control-pause pause_btn'), _this$state2);
	    return _this;
	  }
	
	  _createClass(TestDropDown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      console.log('mounted ---------> ', this.mounted);
	
	      this.mounted = true;
	      console.log('mounted ---------> ', this.mounted);
	      if (this.mounted) {
	        this.setState({ idname: storage_session['idname'] });
	        this.setState({ token: storage_session['token'] });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var question_id = [];
	          var reading_id = [];
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	          }
	          var timer_value = resp.timer_value;
	
	          var first_question_id = question_id[_this3.state.offset];
	          var first_reading_type = reading_id[_this3.state.offset];
	          var user_timer = resp.user_time_value;
	          _this3.setState({
	            user_time_value: user_timer,
	            count: resp.user_time_value ? resp.user_time_value : parseInt(_this3.props.params.timer),
	            count_temp: user_timer
	          });
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: timer_value,
	            include_timer: resp.include_timer,
	            first_question_id: first_question_id,
	            first_reading_type: first_reading_type,
	            all_reading_type: reading_id
	          });
	
	          if (question_id.length - 1 == _this3.state.offset) {
	            _this3.setState({
	              next_block: 'card hide_block'
	            });
	          }
	
	          var data = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            type: first_reading_type
	          };
	          //Api to fetch question by question id
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	            if (resp.success) {
	              var data_check = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id,
	                type: first_reading_type
	              };
	              _this3.setQuestionData(resp.questionsbyid);
	              /*Api to fetch question and check answered */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                _this3.setState({
	                  already_answered_status: resp_inner.message
	                });
	              });
	              _this3.setState({
	                ValidToken: true
	              });
	              _this3.setState({
	                display_question: resp.questionsbyid
	              });
	              _this3.setState({
	                display_loader: 'hide_block'
	              });
	              var params = {
	                token: _this3.state.token,
	                question_id: first_question_id,
	                idname: _this3.state.idname,
	                type: first_reading_type
	              };
	              /*Api to fetch Saved question */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                if (response.success) {
	                  _this3.setState({
	                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                  });
	                  _this3.setState({
	                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                  });
	                  _this3.setState({
	                    bookmarkColor: 'rgb(54, 141, 84)'
	                  });
	                  _this3.setState({
	                    save_text: '' + _language2.default.LC().Question_Saved
	                  });
	                }
	              });
	              var params = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id
	              };
	              /*Api to fetch commented on question*/
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                if (response.success) {
	                  var comments = '';
	                  _this3.setState({
	                    ValidToken: true
	                  });
	                  if (response.comments.length > 0) {
	                    comments = response.comments.map(function (items, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: index },
	                        response.user_id == items.uid ? _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._editComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ) : _react2.default.createElement('ul', null),
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          _language2.default.LC().BY,
	                          ' ',
	                          items.username,
	                          ',',
	                          ' ',
	                          new Date(items.createdAt).toDateString()
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.comment
	                        )
	                      );
	                    });
	
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  } else {
	                    comments = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_COMMENTS_FOUND
	                    );
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  }
	                } else {
	                  comments = _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_COMMENTS_FOUND
	                  );
	                  _this3.setState({
	                    comment_data: comments
	                  });
	                  _this3.setState({
	                    ValidToken: false
	                  });
	                }
	                return response;
	              });
	            } else {
	              // console.log(resp.success + '------------failure');
	            }
	          });
	
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            quiz_id: _this3.state.quiz_id
	          };
	          /*Api to fetch flash card*/
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this3.setState({
	                ValidToken: true
	              });
	              if (response.flash_cards.length > 0) {
	                _this3.setState({
	                  flash_form: 'col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this3._editFlash.bind(_this3, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteFlash.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this3.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this3.setState({
	                  flash_form: 'col-md-12 display_block'
	                });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this3.setState({
	                flash_data: flash_cards
	              });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this3.setState({
	                ValidToken: false
	              });
	              _this3.setState({
	                flash_data: flash_cards
	              });
	              _this3.setState({
	                flash_form: 'col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	    //Function to change time every second and store in database
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count != 0) {
	        var count_value = this.state.count - 1;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: count_value
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	          if (resp.success) {
	            // console.log('Timer Update Successfull');
	          } else {
	              // console.log('Fail Timer Update');
	            }
	        });
	        this.setState({ count: this.state.count - 1 });
	        this.setState({ timer_display: 'card-block' });
	      } else {
	        this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(':status_send', 'completed')
	        });
	      }
	      // if (this.state.timer_value == this.state.count) {
	      //   // this.setState({count_end_message:'Time&#8242;s Up'});
	      //   this.setState({ timer_display: 'card hide_block' });
	      // }
	    }
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	      this.mounted = false;
	    }
	    //Function to redirect page to readings page
	
	
	    //Function to show Correct box and display right answer and store in database
	
	    //Function to Display Saved Question on button and save in database
	
	    //Function to show Report box
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: this.state.questionId,
	          ratting: nextValue,
	          type: 'graph_question'
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1 });
	            _this4.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: this.state.question_id,
	        idname: this.state.idname,
	        type: 'graph_question'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this4.setState({ rating: items.ratting });
	              _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              question_id: _this4.state.questionId,
	              ratting: nextValue,
	              type: 'graph_question'
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1 });
	                _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var _params2 = {
	            token: _this4.state.token,
	            idname: _this4.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', _params2).then(function (response) {
	            if (response.success) {
	              _this4.setState({ rated: 1 });
	              _this4.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to hide Report box
	
	
	    //Funcion to save new report question
	
	  }, {
	    key: 'handleImageLoaded',
	    value: function handleImageLoaded() {
	      this.setState({
	        imageStatus: 'loaded',
	        display_loader: 'hide_block'
	      });
	    }
	  }, {
	    key: 'handleImageErrored',
	    value: function handleImageErrored() {
	      this.setState({ imageStatus: 'failed to load' });
	    }
	    //Function to redirect page to readings beforestart
	
	
	    //function to show calculator
	
	
	    /*Function to start or stop timer*/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          question = _state.question,
	          all_questions = _state.all_questions,
	          reportLoading = _state.reportLoading,
	          explanation = _state.explanation,
	          offset = _state.offset,
	          questionsArray = _state.questionsArray,
	          reading = _state.reading,
	          display_loader = _state.display_loader,
	          questionHide = _state.questionHide,
	          statement1 = _state.statement1,
	          statement2 = _state.statement2,
	          questionId = _state.questionId;
	
	      var questions = this.state.display_question;
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ' : ',
	              this.state.quiz_id
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'text-danger' },
	              this.state.already_answered_status
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class calc-btn',
	                  onClick: this._handleModal
	                },
	                ' ',
	                _language2.default.LC().OPEN_CALCULATOR
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            _language2.default.LC().Q,
	            ' ',
	            parseInt(this.state.offset) + 1,
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'font-16px' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'margin_bottom_30 statement-question-div' },
	                    (0, _function.renderHTMLContent)(question ? question.split('<img src="')[0] : '', "div"),
	                    _react2.default.createElement('img', {
	                      className: 'img-fluid',
	                      src: question ? question.split('<img src="')[1] ? question.split('<img src="')[1].split('"')[0] : question.split('<img src="')[1] : '',
	                      onLoad: this.handleImageLoaded.bind(this),
	                      onError: this.handleImageErrored.bind(this)
	                    }),
	                    (0, _function.renderHTMLContent)(question ? question.split('<img src="')[1] ? question.split('<img src="')[1].split('/>')[1] : question.split('<img src="')[1] : '', "div"),
	                    (0, _function.renderHTMLContent)(statement1, "div", "my-1", { onClick: function onClick(e) {
	                        return _this5.clickHandler(e, 'statementSelect1');
	                      } }),
	                    (0, _function.renderHTMLContent)(statement2, "div", "", { onClick: function onClick(e) {
	                        return _this5.clickHandler(e, 'statementSelect2');
	                      } })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row bottom-tool' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      isQue: true,
	                      _getResult: this._getResult,
	                      clicked: this.state.clicked,
	                      _saveQuestion: this._saveQuestion,
	                      _displayReportForm: this._displayReportForm,
	                      all_questions: question,
	                      save_text: this.state.save_text,
	                      bookmarkCSS: this.state.bookmarkCSS,
	                      bookmarkColor: this.state.bookmarkColor
	                      // isSpecialQuestion={true}
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'timer_outer' },
	                  _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'timer_box' },
	                    display_time
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'quiz_timer_btn ' + this.state.timer_display },
	                  _react2.default.createElement('button', {
	                    type: 'button',
	                    className: this.state.timerstopbtn,
	                    onClick: this._timer_funct.bind(this, questions)
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'text-danger' },
	                  (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: 'false' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.result_block + ' font-lusitana font-16px' },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.text_color },
	            this.state.result
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, all_questions)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, all_questions)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this5.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return TestDropDown;
	}(_react.Component);
	
	TestDropDown.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = TestDropDown;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // my datatatatat
	
	/* eslint-disable */
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	// let tableRegex = /(<table[^>]*>(?:.|\n)*(?=<\/table>))/g;
	var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', _this.state.quiz_id).replace(':status_send', 'abondon')
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'table_question'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'tab_question'
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.setQuestionData = function (questionObj) {
	      if (questionObj) {
	        _this.setState({
	          question: questionObj.question.split('<table') ? questionObj.question.split('<table')[0] : questionObj.question,
	          tableData: '<table id="myTable" border="1" cellpadding="5px" ' + (questionObj.question.split('<table') ? questionObj.question.split('<table')[1] : questionObj.question),
	          sortElement: questionObj.sortBy ? questionObj.sortBy.split(',') : [],
	          explanation: questionObj.explanation ? questionObj.explanation.split(',') : [],
	          statement1: questionObj.option1,
	          statement2: questionObj.option2,
	          statement3: questionObj.option3,
	          answer1: questionObj.answer1,
	          answer2: questionObj.answer2,
	          answer3: questionObj.answer3,
	          questionId: questionObj.id,
	          display_loader: 'hide_block',
	          questionHide: '',
	          choice1: '',
	          choice2: '',
	          choice3: '',
	          choice1_yes: '',
	          choice2_yes: '',
	          choice3_yes: '',
	          choice1_no: '',
	          choice2_no: '',
	          choice3_no: '',
	          result_block: 'card hide_block',
	          report_block: 'card hide_block',
	          reading: questionObj['gmat_reading.reading'],
	          reading_id: questionObj.reading_id
	        }, function () {
	          _this.getFavQuestions(questionObj.id);
	          _this.getGMATRatting(questionObj.id);
	        });
	      }
	    };
	
	    _this._getAnswer = function (choice, e) {
	      _this.setState({ clicked: true });
	      _this.setState({ choice: choice });
	      // const result = getDeviceDetails();
	
	      if (choice === 'choice_a') {
	        _this.setState({ choice_a: 'answer_box clicked_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_b') {
	        _this.setState({ choice_b: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_c') {
	        _this.setState({ choice_c: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_d') {
	        _this.setState({ choice_d: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box ' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_e') {
	        _this.setState({ choice_e: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, e) {
	        var _this$state, choice1, choice2, choice3, answer1, answer2, answer3, expectedCount, count, _count, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, choice1 = _this$state.choice1, choice2 = _this$state.choice2, choice3 = _this$state.choice3, answer1 = _this$state.answer1, answer2 = _this$state.answer2, answer3 = _this$state.answer3;
	                expectedCount = 3;
	                count = 0;
	
	                if (choice1 && choice2 && choice3) {
	                  _count = 0;
	
	                  if (choice1.toLowerCase().trim() === answer1.toLowerCase().trim()) {
	                    _count++;
	                    if (choice1.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice1_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice1_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice1.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice1_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice1_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  if (choice2.toLowerCase().trim() === answer2.toLowerCase().trim()) {
	                    _count++;
	                    if (choice2.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice2_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice2_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice2.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice2_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice2_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  if (choice3.toLowerCase().trim() === answer3.toLowerCase().trim()) {
	                    _count++;
	                    if (choice3.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice3_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice3_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice3.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice3_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice3_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  right_answer = 0;
	
	                  if (expectedCount === _count) {
	                    right_answer = 1;
	                    _this.setState({
	                      result: 'CORRECT',
	                      text_color: 'card-header text_success',
	                      result_block: 'card show_block'
	                    });
	                  } else {
	                    _this.setState({
	                      result_block: 'card show_block',
	                      result: 'INCORRECT',
	                      text_color: 'card-header text_failure'
	                    });
	                  }
	                  // --------------- Save Stat API call Start -----------//
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: _this.state.all_question_id[_this.state.offset],
	                    answer: right_answer,
	                    reading_id: item.reading_id,
	                    type: 'table_question'
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	                    if (resp.success) {
	                      var data = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        question_id: _this.state.questionId,
	                        right_answer: right_answer,
	                        type: 'table_question'
	                        // time_done: this.state.count,
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                        if (resp.success) {} else {}
	                      });
	                      _this.setState({ ValidToken: true });
	                      _this.setState({ validated: true });
	                    } else {
	                      _this.setState({ ValidToken: false });
	                    }
	                    return resp;
	                  });
	                  // --------------- Save Stat API call End-----------//
	                } else {
	                    // console.log('I am inside else ');
	                  }
	                if (expectedCount === 3) {
	                  if (choice1 && choice2 && choice3) {
	                    _this.setState({
	                      error: ''
	                    });
	                  } else {
	                    _this.setState({
	                      error: 'Please select all the options'
	                    });
	                  }
	                }
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._getPrevious = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      document.getElementById('comment').value = '';
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          console.log('Timer Update Successfull');
	        } else {
	          console.log('Fail Timer Update');
	        }
	      });
	
	      var index_id = _this.state.offset - 1;
	      if (_this.state.question_length - 1 != index_id) {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type && _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var questionsbyid = resp.questionsbyid;
	
	          _this.setQuestionData(resp.questionsbyid);
	          _this.setRadioButtonBlank();
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          }
	          _this.setState({ display_loader: 'hide_block' });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this.setRadioButtonBlank = function () {
	      for (var counter = 0; counter < 5; counter++) {
	        var resetRadioButton = document.getElementsByName('choice' + (counter + 1));
	        for (var i = 0; i < resetRadioButton.length; i++) {
	          resetRadioButton[i].checked = false;
	        }
	      }
	      document.getElementById('table_data_select').selectedIndex = 0;
	    };
	
	    _this._getNext = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      document.getElementById('comment').value = '';
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          //console.log('Timer Update Successfull');
	        } else {
	            //console.log('Fail Timer Update');
	          }
	      });
	      var index_id = _this.state.offset + 1;
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (_this.state.question_length - 1 == index_id) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        var questionsbyid = resp.questionsbyid;
	
	        _this.setQuestionData(resp.questionsbyid);
	        _this.setRadioButtonBlank();
	        if (resp.success) {
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', questionsbyid['gmat_reading.type']).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _this.setState({ display_loader: 'hide_block' });
	          //console.log(data_check);
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      console.log('item -------> ', _this.state.reading, _this.state.reading_id);
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        chapter_id: _this.props.params.chapterid,
	        type: 'table_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid ? _this.props.params.readingid : _this.state.reading_id ? _this.state.reading_id : 0
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'table_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.state.reading_id
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment') ? document.getElementById('comment').value = '' : '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this.resetTableContent = function () {
	      var tableData = _this.state.tableData;
	
	      var tableDataReset = tableData;
	      _this.setState({
	        tableData: ''
	      }, function () {
	        _this.setState({
	          tableData: tableDataReset
	        });
	        document.getElementById('table_data_select').selectedIndex = 0;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this.state = (_this$state2 = {
	      show: false,
	      token: '',
	      idname: '',
	      data: [],
	      question: '',
	      statement1: '',
	      statement2: '',
	      statement3: '',
	      choice1: '',
	      choice2: '',
	      choice3: '',
	      sortElement: [],
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      offset: _this.props.params.offset,
	      explanation: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      report_block: 'card hide_block',
	      text_color: 'card-header',
	      result: '',
	      reportLoading: false,
	      result_block: 'card hide_block',
	      questionsArray: [],
	      subscriptionstatus: _this.props.params.subscription ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      answer1: '',
	      answer2: '',
	      answer3: '',
	      choice1_yes: '',
	      choice2_yes: '',
	      choice3_yes: '',
	      choice1_no: '',
	      choice2_no: '',
	      choice3_no: '',
	      error: '',
	      quiz_id: _this.props.params.quiz_id
	    }, _defineProperty(_this$state2, 'offset', _this.props.params.offset ? parseInt(_this.props.params.offset) : 0), _defineProperty(_this$state2, 'count', _this.props.params.timer ? _this.props.params.timer : 0), _defineProperty(_this$state2, 'display_question', ''), _defineProperty(_this$state2, 'timerstopbtn', 'icon-control-pause pause_btn'), _this$state2);
	
	    // http://reactkungfu.com/2015/07/why-and-how-to-bind-methods-in-your-react-component-classes/
	    // bind the context for compareBy & sortBy to this component instance
	    _this.compareBy.bind(_this);
	    _this.sortBy.bind(_this);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'compareBy',
	    value: function compareBy(key) {
	      return function (a, b) {
	        if (a[key] < b[key]) return -1;
	        if (a[key] > b[key]) return 1;
	        return 0;
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.mounted = true;
	      if (this.mounted) {
	        this.setState({ idname: storage_session['idname'] });
	        this.setState({ token: storage_session['token'] });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var question_id = [];
	          var reading_id = [];
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	          }
	          var timer_value = resp.timer_value;
	
	          var first_question_id = question_id[_this3.state.offset];
	          var first_reading_type = reading_id[_this3.state.offset];
	          var user_timer = resp.user_time_value;
	          _this3.setState({
	            user_time_value: user_timer,
	            count: resp.user_time_value ? resp.user_time_value : parseInt(_this3.props.params.timer),
	            count_temp: user_timer
	          });
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: timer_value,
	            include_timer: resp.include_timer,
	            first_question_id: first_question_id,
	            first_reading_type: first_reading_type,
	            all_reading_type: reading_id
	          });
	
	          if (question_id.length - 1 == _this3.state.offset) {
	            _this3.setState({
	              next_block: 'card hide_block'
	            });
	          }
	
	          var data = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            type: first_reading_type
	          };
	          //Api to fetch question by question id
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	            if (resp.success) {
	              var data_check = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id,
	                type: first_reading_type
	              };
	              _this3.setQuestionData(resp.questionsbyid);
	              /*Api to fetch question and check answered */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                _this3.setState({
	                  already_answered_status: resp_inner.message
	                });
	              });
	              _this3.setState({
	                ValidToken: true
	              });
	              _this3.setState({
	                display_question: resp.questionsbyid
	              });
	              _this3.setState({
	                display_loader: 'hide_block'
	              });
	              var params = {
	                token: _this3.state.token,
	                question_id: first_question_id,
	                idname: _this3.state.idname,
	                type: first_reading_type
	              };
	              /*Api to fetch Saved question */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                if (response.success) {
	                  _this3.setState({
	                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                  });
	                  _this3.setState({
	                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                  });
	                  _this3.setState({
	                    bookmarkColor: 'rgb(54, 141, 84)'
	                  });
	                  _this3.setState({
	                    save_text: '' + _language2.default.LC().Question_Saved
	                  });
	                }
	              });
	              var params = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id
	              };
	              /*Api to fetch commented on question*/
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                if (response.success) {
	                  var comments = '';
	                  _this3.setState({
	                    ValidToken: true
	                  });
	                  if (response.comments.length > 0) {
	                    comments = response.comments.map(function (items, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: index },
	                        response.user_id == items.uid ? _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._editComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ) : _react2.default.createElement('ul', null),
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          _language2.default.LC().BY,
	                          ' ',
	                          items.username,
	                          ',',
	                          ' ',
	                          new Date(items.createdAt).toDateString()
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.comment
	                        )
	                      );
	                    });
	
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  } else {
	                    comments = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_COMMENTS_FOUND
	                    );
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  }
	                } else {
	                  comments = _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_COMMENTS_FOUND
	                  );
	                  _this3.setState({
	                    comment_data: comments
	                  });
	                  _this3.setState({
	                    ValidToken: false
	                  });
	                }
	                return response;
	              });
	            } else {
	              // console.log(resp.success + '------------failure');
	            }
	          });
	
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            quiz_id: _this3.state.quiz_id
	          };
	          /*Api to fetch flash card*/
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this3.setState({
	                ValidToken: true
	              });
	              if (response.flash_cards.length > 0) {
	                _this3.setState({
	                  flash_form: 'col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this3._editFlash.bind(_this3, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteFlash.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this3.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this3.setState({
	                  flash_form: 'col-md-12 display_block'
	                });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this3.setState({
	                flash_data: flash_cards
	              });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this3.setState({
	                ValidToken: false
	              });
	              _this3.setState({
	                flash_data: flash_cards
	              });
	              _this3.setState({
	                flash_form: 'col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	    //Function to change time every second and store in database
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count != 0) {
	        var count_value = this.state.count - 1;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: count_value
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	          if (resp.success) {
	            // console.log('Timer Update Successfull');
	          } else {
	              // console.log('Fail Timer Update');
	            }
	        });
	        this.setState({ count: this.state.count - 1 });
	        this.setState({ timer_display: 'card-block' });
	      } else {
	        this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(':status_send', 'completed')
	        });
	      }
	      // if (this.state.timer_value == this.state.count) {
	      //   // this.setState({count_end_message:'Time&#8242;s Up'});
	      //   this.setState({ timer_display: 'card hide_block' });
	      // }
	    }
	    //Function to redirect page to readings beforestart
	
	
	    //function to show calculator
	
	
	    //Function to check Right Or Wrong Answered and displayed clicked box
	
	
	    //Function to fetch previous question
	
	    //Function to fetch Next question
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	      this.mounted = false;
	    }
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	
	    //Function to hide Report box
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: this.state.questionId,
	          ratting: nextValue,
	          type: 'table_question'
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this4.state.token,
	          idname: _this4.state.idname,
	          question_id: _this4.state.questionId,
	          ratting: nextValue,
	          type: 'table_question'
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to redirect page to readings page
	
	  }, {
	    key: 'sortBy',
	    value: function sortBy(key) {
	      var arrayCopy = [].concat(_toConsumableArray(this.state.data));
	      arrayCopy.sort(this.compareBy(key));
	      this.setState({ data: arrayCopy });
	    }
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(event) {
	      var _setState;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + '_yes', ''), _defineProperty(_setState, name + '_no', ''), _setState));
	    }
	  }, {
	    key: 'sortTable',
	    value: function sortTable(value) {
	      var index = value;
	      // this.state.sortElement.find((element, i) => {
	      //   if (element === value) index = i;
	      // });
	      var table, rows, switching, i, x, y, shouldSwitch;
	      table = document.getElementById('bodyData');
	      switching = true;
	      /*Make a loop that will continue until
	      no switching has been done:*/
	      var firstValue = void 0,
	          secondValue = void 0;
	      while (switching) {
	        //start by saying: no switching is done:
	        switching = false;
	        rows = table.rows;
	        /*Loop through all table rows (except the
	        first, which contains table headers):*/
	        for (i = 0; i < rows.length - 1; i++) {
	          //start by saying there should be no switching:
	          shouldSwitch = false;
	          /*Get the two elements you want to compare,
	          one from current row and one from the next:*/
	          x = rows[i].getElementsByTagName('TD')[index];
	          y = rows[i + 1].getElementsByTagName('TD')[index];
	          //check if the two rows should switch place:
	          if (x !== undefined && y !== undefined) {
	            firstValue = parseFloat(x.innerHTML.replace(/[>,<]/gm, '').replace(/&[gl]t;/gm, ''));
	            secondValue = parseFloat(y.innerHTML.replace(/[>,<]/gm, '').replace(/&[gl]t;/gm, ''));
	            if (isNaN(firstValue)) {
	              firstValue = x.innerHTML.toLowerCase().trim();
	              firstValue = specialChars.test(firstValue) ? '0' : firstValue;
	            }
	            if (isNaN(secondValue)) {
	              secondValue = y.innerHTML.toLowerCase().trim();
	              secondValue = specialChars.test(secondValue) ? '0' : secondValue;
	            }
	            if (isNaN(firstValue) !== isNaN(secondValue)) {
	              if (isNaN(firstValue)) firstValue = 0;
	              if (isNaN(secondValue)) secondValue = 0;
	            }
	            if (firstValue === secondValue) {
	              var repGtx = x.innerHTML.toLowerCase().replace('&gt;', '>');
	              var repGty = y.innerHTML.toLowerCase().replace('&gt;', '>');
	              var repltx = x.innerHTML.toLowerCase().replace('&lt;', '<');
	              var replty = y.innerHTML.toLowerCase().replace('&lt;', '<');
	              if (repGtx.includes('>') && !repGty.includes('>')) {
	                shouldSwitch = true;
	                break;
	              }
	              if (!repltx.includes('<') && replty.includes('<')) {
	                shouldSwitch = true;
	                break;
	              }
	            }
	            if (firstValue > secondValue) {
	              //if so, mark as a switch and break the loop:
	              shouldSwitch = true;
	              break;
	            }
	          }
	        }
	        if (shouldSwitch) {
	          /*If a switch has been marked, make the switch
	          and mark that a switch has been done:*/
	          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
	          switching = true;
	        }
	      }
	    }
	
	    /*Function to start or stop timer*/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          statement1 = _state.statement1,
	          statement2 = _state.statement2,
	          statement3 = _state.statement3,
	          question = _state.question,
	          tableData = _state.tableData,
	          explanation = _state.explanation,
	          reportLoading = _state.reportLoading,
	          questionsArray = _state.questionsArray,
	          offset = _state.offset,
	          reading = _state.reading,
	          display_loader = _state.display_loader,
	          questionHide = _state.questionHide,
	          choice3_yes = _state.choice3_yes,
	          choice3_no = _state.choice3_no,
	          choice1_yes = _state.choice1_yes,
	          choice1_no = _state.choice1_no,
	          choice2_yes = _state.choice2_yes,
	          choice2_no = _state.choice2_no,
	          questionId = _state.questionId,
	          error = _state.error;
	
	      console.log('error......', error);
	      var questions = this.state.display_question;
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ' : ',
	              this.state.quiz_id
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'text-danger' },
	              this.state.already_answered_status
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class calc-btn',
	                  onClick: this._handleModal
	                },
	                ' ',
	                _language2.default.LC().OPEN_CALCULATOR
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            _language2.default.LC().Q,
	            ' ',
	            parseInt(this.state.offset) + 1,
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'font-16px statement-question-div' },
	                  (0, _function.renderHTMLContent)(question, "div", "text-justify"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'd-flex mt-1 align-items-center mb-1' },
	                    _react2.default.createElement(
	                      'h5',
	                      { className: 'm-0  font-weight-bold' },
	                      'Sort By :'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        name: 'table_data_select',
	                        id: 'table_data_select'
	                        // onChange={(e) => this.sortBy(e.target.value)}
	                        , onChange: function onChange(e) {
	                          return _this5.sortTable(e.target.value);
	                        },
	                        className: 'h-min-content ml-35px w-lg-30 w-sm-50'
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        {
	                          // selected='selected'
	                          disabled: 'disabled',
	                          value: 'DEFAULT'
	                        },
	                        'Select...'
	                      ),
	                      this.state.sortElement && this.state.sortElement.length ? this.state.sortElement.map(function (value, index) {
	                        return _react2.default.createElement(
	                          'option',
	                          {
	                            key: index,
	                            value: index
	                            // onChange={() => this.sortBy(value)}
	                            , onChange: function onChange() {
	                              return _this5.sortTable(index);
	                            }
	                          },
	                          (0, _function.renderHTMLContent)(value, "span")
	                        );
	                      }) : null
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'up tooltip-hover-questions ml-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tootip_box' },
	                        ' Reset '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'submit',
	                          className: 'btn btn-circle btn-refresh pointer_class',
	                          id: 'Tooltip-2',
	                          onClick: this.resetTableContent
	                        },
	                        _react2.default.createElement('i', { className: 'fa fa-refresh p-0', 'aria-hidden': 'true' })
	                      )
	                    )
	                  ),
	                  (0, _function.renderHTMLContent)(tableData, "div", "overflow-x-auto table-w-100"),
	                  _react2.default.createElement(
	                    'form',
	                    { onSubmit: this.submit },
	                    _react2.default.createElement(
	                      'table',
	                      null,
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'True'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'False'
	                          ),
	                          _react2.default.createElement('th', null)
	                        ),
	                        _react2.default.createElement(
	                          'tr',
	                          { onChange: this.onChangeValue },
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                              type: 'radio',
	                              id: 'html',
	                              name: 'choice1',
	                              value: 'Yes',
	                              className: choice1_yes + '  pointer_class'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                              type: 'radio',
	                              id: 'html',
	                              name: 'choice1',
	                              value: 'No',
	                              className: choice1_no + '  pointer_class'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            statement1
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tr',
	                          { onChange: this.onChangeValue },
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                              type: 'radio',
	                              id: 'html',
	                              name: 'choice2',
	                              value: 'Yes',
	                              className: choice2_yes + ' pointer_class'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                              type: 'radio',
	                              id: 'html',
	                              name: 'choice2',
	                              value: 'No',
	                              className: choice2_no + '  pointer_class'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            statement2
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tr',
	                          { onChange: this.onChangeValue },
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                              type: 'radio',
	                              id: 'html',
	                              name: 'choice3',
	                              value: 'Yes',
	                              className: choice3_yes + ' pointer_class'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                              type: 'radio',
	                              id: 'html',
	                              name: 'choice3',
	                              value: 'No',
	                              className: choice3_no + '  pointer_class'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            statement3
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'error_msg' },
	                    error
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row bottom-tool mt-1' },
	                    _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                      isQue: true,
	                      _getResult: this._getResult,
	                      _saveQuestion: this._saveQuestion,
	                      _displayReportForm: this._displayReportForm,
	                      all_questions: question,
	                      save_text: this.state.save_text,
	                      bookmarkCSS: this.state.bookmarkCSS,
	                      bookmarkColor: this.state.bookmarkColor
	                      // isSpecialQuestion={true}
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'timer_outer' },
	                  _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'timer_box' },
	                    display_time
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'quiz_timer_btn ' + this.state.timer_display },
	                  _react2.default.createElement('button', {
	                    type: 'button',
	                    className: this.state.timerstopbtn,
	                    onClick: this._timer_funct.bind(this, questions)
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'text-danger' },
	                  (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: 'false' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.result_block + ' font-lusitana font-16px' },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.text_color },
	            this.state.result
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, question)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, question)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this5.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Table;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable */
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var GMATTab = function (_Component) {
	  _inherits(GMATTab, _Component);
	
	  function GMATTab(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, GMATTab);
	
	    var _this = _possibleConstructorReturn(this, (GMATTab.__proto__ || Object.getPrototypeOf(GMATTab)).call(this, props));
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'tab_question'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'tab_question'
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.openCity = function (evt, cityName) {
	      var i = void 0;
	      var tabcontent = void 0;
	      var tablinks = void 0;
	      tabcontent = document.getElementsByClassName('tabcontent');
	      for (i = 0; i < tabcontent.length; i++) {
	        tabcontent[i].style.display = 'none';
	      }
	      tablinks = document.getElementsByClassName('tablinks');
	      for (i = 0; i < tablinks.length; i++) {
	        var value = tablinks[i].value;
	        if (value === cityName) {
	          tablinks[i].className += ' active';
	        } else {
	          tablinks[i].classList.remove('active');
	        }
	        // tablinks[i].className = tablinks[i].className.replace(' active', '');
	      }
	      document.getElementById(cityName).style.display = 'block';
	      // evt.currentTarget.className += ' active';
	    };
	
	    _this.clickHandler = function (e) {
	      _this.openCity(e, e.target.value.trim());
	    };
	
	    _this.setRadioButtonCorrectChoice = function (value) {
	      var resetRadioButton = document.getElementsByName('correct_choice');
	      for (var i = 0; i < resetRadioButton.length; i++) {
	        resetRadioButton[i].checked = value;
	      }
	    };
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, e) {
	        var _this$state, choice1, choice2, choice3, choice4, choice5, answer1, answer2, answer3, answer4, answer5, expectedCount, count, activateExplanation, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, choice1 = _this$state.choice1, choice2 = _this$state.choice2, choice3 = _this$state.choice3, choice4 = _this$state.choice4, choice5 = _this$state.choice5, answer1 = _this$state.answer1, answer2 = _this$state.answer2, answer3 = _this$state.answer3, answer4 = _this$state.answer4, answer5 = _this$state.answer5;
	                expectedCount = 3;
	
	                if (_this.state.statement3 === '') {
	                  expectedCount = 2;
	                }
	                count = 0;
	                activateExplanation = true;
	
	                if (answer4 !== '' && answer5 !== '') {
	                  activateExplanation = false;
	                  if (choice4 !== '', choice5 !== '') {
	                    activateExplanation = true;
	                  }
	                  expectedCount = 5;
	                  if (choice4.toLowerCase().trim() === answer4.toLowerCase().trim()) {
	                    count++;
	                    if (choice4.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice4_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice4_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice4.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice4_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice4_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  if (choice5.toLowerCase().trim() === answer5.toLowerCase().trim()) {
	                    count++;
	                    if (choice5.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice5_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice5_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice5.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice5_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice5_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                }
	                if (choice1 && choice2 && (choice3 || _this.state.statement3 === '')) {
	                  if (choice1.toLowerCase().trim() === answer1.toLowerCase().trim()) {
	                    count++;
	                    if (choice1.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice1_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice1_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice1.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice1_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice1_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  if (choice2.toLowerCase().trim() === answer2.toLowerCase().trim()) {
	                    count++;
	                    if (choice2.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice2_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice2_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice2.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice2_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice2_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  if (choice3.toLowerCase().trim() === answer3.toLowerCase().trim()) {
	                    count++;
	                    if (choice3.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice3_yes: 'accent-success'
	                      });
	                    } else {
	                      _this.setState({
	                        choice3_no: 'accent-success'
	                      });
	                    }
	                  } else {
	                    if (choice3.toLowerCase().trim() === 'yes') {
	                      _this.setState({
	                        choice3_yes: 'accent-faliure'
	                      });
	                    } else {
	                      _this.setState({
	                        choice3_no: 'accent-faliure'
	                      });
	                    }
	                  }
	                  right_answer = 0;
	
	                  if (expectedCount === count) {
	                    right_answer = 1;
	                    _this.setState({
	                      result: 'CORRECT',
	                      text_color: 'card-header text_success',
	                      result_block: 'card show_block'
	                    });
	                  } else {
	                    if (activateExplanation) {
	                      _this.setState({
	                        result_block: 'card show_block',
	                        result: 'INCORRECT',
	                        text_color: 'card-header text_failure'
	                      });
	                    }
	                  }
	                  // --------------- Save Stat API call -----------//
	                  if (activateExplanation) {
	                    data = {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      quiz_id: _this.state.quiz_id,
	                      question_id: _this.state.all_question_id[_this.state.offset],
	                      answer: right_answer,
	                      reading_id: item.reading_id,
	                      type: 'tab_question'
	                    };
	
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	                      if (resp.success) {
	                        var data = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          question_id: _this.state.questionId,
	                          right_answer: right_answer,
	                          type: 'tab_question'
	                          // time_done: this.state.count,
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                          if (resp.success) {} else {}
	                        });
	                        _this.setState({ ValidToken: true });
	                        _this.setState({ validated: true });
	                      } else {
	                        _this.setState({ ValidToken: false });
	                      }
	                      return resp;
	                    });
	                  }
	                } else {
	                  // console.log('I am inside else ');
	                }
	
	                if (expectedCount === 3 || _this.state.statement3 === '') {
	                  if (choice1 && choice2 && (choice3 || _this.state.statement3 === '')) {
	                    _this.setState({
	                      error: ''
	                    });
	                  } else {
	                    _this.setRadioButtonBlank();
	                    _this.setState({
	                      error: 'Please select all the options'
	                    });
	                  }
	                } else if (expectedCount === 4) {
	                  if (choice1 && choice2 && choice3 && choice4) {
	                    _this.setState({
	                      error: ''
	                    });
	                  } else {
	                    _this.setRadioButtonBlank();
	                    _this.setState({
	                      error: 'Required'
	                    });
	                  }
	                } else if (expectedCount === 5) {
	                  if (choice1 && choice2 && choice3 && choice4 && choice5) {
	                    _this.setState({
	                      error: ''
	                    });
	                    console.log('if5', expectedCount);
	                  } else {
	                    _this.setRadioButtonBlank();
	                    _this.setState({
	                      error: 'Please select all options'
	                    });
	                  }
	                }
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._getResultfor5Statements = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var _this$state2, answer1, answer2, answer3, answer4, answer5, userChoice, validateAnswer, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$state2 = _this.state, answer1 = _this$state2.answer1, answer2 = _this$state2.answer2, answer3 = _this$state2.answer3, answer4 = _this$state2.answer4, answer5 = _this$state2.answer5, userChoice = _this$state2.userChoice;
	
	                validateAnswer = function validateAnswer(value, option) {
	                  if (value) {
	                    _this.setState(_defineProperty({
	                      result: 'CORRECT',
	                      text_color: 'card-header text_success',
	                      result_block: 'card show_block'
	                    }, 'choice' + option + '_yes', 'accent-success'));
	                  } else {
	                    _this.setState(_defineProperty({
	                      result_block: 'card show_block',
	                      result: 'INCORRECT',
	                      text_color: 'card-header text_failure'
	                    }, 'choice' + option + '_yes', 'accent-faliure'));
	                  }
	                };
	
	                if (userChoice) {
	                  right_answer = 0;
	
	                  if (answer1.toLocaleLowerCase().trim() === 'yes' && userChoice == 1) {
	                    right_answer = 1;
	                    validateAnswer(true, userChoice);
	                  } else if (answer2.toLocaleLowerCase().trim() === 'yes' && userChoice == 2) {
	                    right_answer = 1;
	                    validateAnswer(true, userChoice);
	                  } else if (answer3.toLocaleLowerCase().trim() === 'yes' && userChoice == 3) {
	                    right_answer = 1;
	                    validateAnswer(true, userChoice);
	                  } else if (answer4.toLocaleLowerCase().trim() === 'yes' && userChoice == 4) {
	                    right_answer = 1;
	                    validateAnswer(true, userChoice);
	                  } else if (answer5.toLocaleLowerCase().trim() === 'yes' && userChoice == 5) {
	                    right_answer = 1;
	                    validateAnswer(true, userChoice);
	                  } else {
	                    if (answer1.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_1: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer2.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_2: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer3.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_3: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer4.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_4: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });else if (answer5.toLocaleLowerCase().trim() === 'yes') _this.setState({ correct_answer_5: true }, function () {
	                      return _this.setRadioButtonCorrectChoice(true);
	                    });
	                    validateAnswer(false, userChoice);
	                  }
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: _this.state.all_question_id[_this.state.offset],
	                    answer: right_answer,
	                    reading_id: item.reading_id,
	                    type: 'tab_question'
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	                    if (resp.success) {
	                      var data = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        question_id: _this.state.questionId,
	                        right_answer: right_answer,
	                        type: 'tab_question'
	                        // time_done: this.state.count,
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                        if (resp.success) {} else {}
	                      });
	                      _this.setState({ ValidToken: true });
	                      _this.setState({ validated: true });
	                    } else {
	                      _this.setState({ ValidToken: false });
	                    }
	                    return resp;
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      console.log('item -------> ', _this.state.reading, _this.state.reading_id);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        chapter_id: _this.props.params.chapterid,
	        type: 'tab_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid ? _this.props.params.readingid : _this.state.reading_id ? _this.state.reading_id : 0
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      console.log('itemit ---> ', e);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'tab_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.state.reading_id
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this.removeRadioButtonClass = function () {
	      _this.setState({
	        choice1_yes: '',
	        choice2_yes: '',
	        choice3_yes: '',
	        choice4_yes: '',
	        choice5_yes: '',
	        choice1_no: '',
	        choice2_no: '',
	        choice3_no: '',
	        choice4_no: '',
	        choice5_no: '',
	        correct_answer_1: '',
	        correct_answer_2: '',
	        correct_answer_3: '',
	        correct_answer_4: '',
	        correct_answer_5: ''
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        choice1: '',
	        choice2: '',
	        choice3: '',
	        choice4: '',
	        choice5: '',
	        answer1: '',
	        answer2: '',
	        answer3: '',
	        answer4: '',
	        answer5: ''
	      });
	      _this.setRadioButtonCorrectChoice(false);
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      _this.removeRadioButtonClass();
	      document.getElementById('comment').value = '';
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      }
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          console.log('Timer Update Successfull');
	        } else {
	          console.log('Fail Timer Update');
	        }
	      });
	
	      var index_id = _this.state.offset - 1;
	      if (_this.state.question_length - 1 != index_id) {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type && _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var questionsbyid = resp.questionsbyid;
	
	          _this.setQuestionData(resp.questionsbyid);
	          _this.setRadioButtonBlank();
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          }
	          _this.setState({ display_loader: 'hide_block' });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getNext = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        choice1: '',
	        choice2: '',
	        choice3: '',
	        choice4: '',
	        choice5: '',
	        answer1: '',
	        answer2: '',
	        answer3: '',
	        answer4: '',
	        answer5: ''
	      });
	      _this.setRadioButtonCorrectChoice(false);
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      _this.removeRadioButtonClass();
	      document.getElementById('comment').value = '';
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          //console.log('Timer Update Successfull');
	        } else {
	            //console.log('Fail Timer Update');
	          }
	      });
	      var index_id = _this.state.offset + 1;
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (_this.state.question_length - 1 == index_id) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      console.log('typeeee senddd', _this.state.all_reading_type[index_id]);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        var questionsbyid = resp.questionsbyid;
	
	        _this.setQuestionData(resp.questionsbyid);
	        _this.setRadioButtonBlank();
	
	        if (resp.success) {
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', questionsbyid['gmat_reading.type']).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _this.setState({ display_loader: 'hide_block' });
	          //console.log(data_check);
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this.setRadioButtonBlank = function () {
	      for (var counter = 0; counter < 5; counter++) {
	        var resetRadioButton = document.getElementsByName('choice' + (counter + 1));
	        for (var i = 0; i < resetRadioButton.length; i++) {
	          resetRadioButton[i].checked = false;
	        }
	      }
	    };
	
	    _this.setQuestionData = function (quesArr) {
	      if (quesArr) {
	        _this.setState({
	          data: quesArr.question_tab,
	          question: quesArr.question,
	          statement1: quesArr.statement_A,
	          statement2: quesArr.statement_B,
	          statement3: quesArr.statement_C,
	          statement4: quesArr.statement_D,
	          statement5: quesArr.statement_E,
	          questionId: quesArr.id,
	          choice_a: quesArr.choice_a === '' ? 'Yes' : quesArr.choice_a,
	          choice_b: quesArr.choice_b === '' ? 'No' : quesArr.choice_b,
	          explanation: quesArr.explanation,
	          questionHide: '',
	          answer1: quesArr.answer_A,
	          answer2: quesArr.answer_B,
	          answer3: quesArr.answer_C,
	          answer4: quesArr.answer_D,
	          answer5: quesArr.answer_E,
	          display_loader: 'hide_block',
	          result_block: 'card hide_block',
	          report_block: 'card hide_block',
	          reading: quesArr['gmat_reading.reading'],
	          reading_id: quesArr.reading_id
	        }, function () {
	          _this.getFavQuestions(quesArr.id);
	          _this.getGMATRatting(quesArr.id);
	        });
	      }
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this.onChangeValueFor5Statement = function (event, value) {
	      var _this$setState3;
	
	      var name = event.target.name;
	
	      _this.removeRadioButtonClass();
	      _this.setRadioButtonCorrectChoice(false);
	      _this.setState((_this$setState3 = {
	        userChoice: value
	      }, _defineProperty(_this$setState3, name + '_yes', ''), _defineProperty(_this$setState3, name + '_no', ''), _this$setState3));
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', _this.state.quiz_id).replace(':status_send', 'abondon')
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.state = (_this$state3 = {
	      show: false,
	      data: '',
	      question: '',
	      statement1: '',
	      statement2: '',
	      statement3: '',
	      statement4: '',
	      statement5: '',
	      choice1: '',
	      choice2: '',
	      choice3: '',
	      choice4: '',
	      choice5: '',
	      choice_a: 'Yes',
	      choice_b: 'No',
	      explanation: '',
	      token: '',
	      idname: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      text_color: 'card-header',
	      result: '',
	      reportLoading: false,
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      subscriptionstatus: _this.props.params.subscription ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      offset: _this.props.params.offset,
	      questionsArray: [],
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      choice1_yes: '',
	      choice2_yes: '',
	      choice3_yes: '',
	      choice4_yes: '',
	      choice5_yes: '',
	      choice1_no: '',
	      choice2_no: '',
	      choice3_no: '',
	      choice4_no: '',
	      choice5_no: '',
	      answer1: '',
	      answer2: '',
	      answer3: '',
	      answer4: '',
	      answer5: '',
	      error: '',
	      quiz_id: _this.props.params.quiz_id
	    }, _defineProperty(_this$state3, 'offset', _this.props.params.offset ? parseInt(_this.props.params.offset) : 0), _defineProperty(_this$state3, 'all_reading_type', ''), _defineProperty(_this$state3, 'count', _this.props.params.timer ? _this.props.params.timer : 0), _defineProperty(_this$state3, 'display_question', ''), _defineProperty(_this$state3, 'timerstopbtn', 'icon-control-pause pause_btn'), _this$state3);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.mounted = true;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (this.mounted) {
	        this.setState({
	          idname: storage_session['idname']
	        });
	        this.setState({
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var question_id = [];
	          var reading_id = [];
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	          }
	          var timer_value = resp.timer_value;
	
	          var first_question_id = question_id[_this3.state.offset];
	          var first_reading_type = reading_id[_this3.state.offset];
	          var user_timer = resp.user_time_value;
	          _this3.setState({
	            user_time_value: user_timer,
	            count: resp.user_time_value ? resp.user_time_value : parseInt(_this3.props.params.timer),
	            count_temp: user_timer
	          });
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: timer_value,
	            include_timer: resp.include_timer,
	            first_question_id: first_question_id,
	            first_reading_type: first_reading_type,
	            all_reading_type: reading_id
	          });
	
	          if (question_id.length - 1 == _this3.state.offset) {
	            _this3.setState({
	              next_block: 'card hide_block'
	            });
	          }
	
	          var data = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            type: first_reading_type
	          };
	          //Api to fetch question by question id
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	            if (resp.success) {
	              var data_check = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id,
	                type: first_reading_type
	              };
	              _this3.setQuestionData(resp.questionsbyid);
	              /*Api to fetch question and check answered */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                _this3.setState({
	                  already_answered_status: resp_inner.message
	                });
	              });
	              _this3.setState({
	                ValidToken: true
	              });
	              _this3.setState({
	                display_question: resp.questionsbyid
	              });
	              _this3.setState({
	                display_loader: 'hide_block'
	              });
	              var params = {
	                token: _this3.state.token,
	                question_id: first_question_id,
	                idname: _this3.state.idname,
	                type: first_reading_type
	              };
	              /*Api to fetch Saved question */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                if (response.success) {
	                  _this3.setState({
	                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                  });
	                  _this3.setState({
	                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                  });
	                  _this3.setState({
	                    bookmarkColor: 'rgb(54, 141, 84)'
	                  });
	                  _this3.setState({
	                    save_text: '' + _language2.default.LC().Question_Saved
	                  });
	                }
	              });
	              var params = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id
	              };
	              /*Api to fetch commented on question*/
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                if (response.success) {
	                  var comments = '';
	                  _this3.setState({
	                    ValidToken: true
	                  });
	                  if (response.comments.length > 0) {
	                    comments = response.comments.map(function (items, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: index },
	                        response.user_id == items.uid ? _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._editComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ) : _react2.default.createElement('ul', null),
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          _language2.default.LC().BY,
	                          ' ',
	                          items.username,
	                          ',',
	                          ' ',
	                          new Date(items.createdAt).toDateString()
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.comment
	                        )
	                      );
	                    });
	
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  } else {
	                    comments = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_COMMENTS_FOUND
	                    );
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  }
	                } else {
	                  comments = _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_COMMENTS_FOUND
	                  );
	                  _this3.setState({
	                    comment_data: comments
	                  });
	                  _this3.setState({
	                    ValidToken: false
	                  });
	                }
	                return response;
	              });
	            } else {
	              // console.log(resp.success + '------------failure');
	            }
	          });
	
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            quiz_id: _this3.state.quiz_id
	          };
	          /*Api to fetch flash card*/
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this3.setState({
	                ValidToken: true
	              });
	              if (response.flash_cards.length > 0) {
	                _this3.setState({
	                  flash_form: 'col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this3._editFlash.bind(_this3, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteFlash.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this3.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this3.setState({
	                  flash_form: 'col-md-12 display_block'
	                });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this3.setState({
	                flash_data: flash_cards
	              });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this3.setState({
	                ValidToken: false
	              });
	              _this3.setState({
	                flash_data: flash_cards
	              });
	              _this3.setState({
	                flash_form: 'col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	    //Function to change time every second and store in database
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count != 0) {
	        var count_value = this.state.count;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: count_value
	        };
	        // console.log("user time",this.state.user_time_value)
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	          if (resp.success) {
	            // console.log('Timer Update Successfull');
	          } else {
	              // console.log('Fail Timer Update');
	            }
	        });
	        this.setState({ count: this.state.count - 1 });
	        this.setState({ timer_display: 'card-block' });
	      } else {
	        this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(':status_send', 'completed')
	        });
	      }
	      // if (this.state.timer_value === this.state.count) {
	      //   // this.setState({count_end_message:'Time&#8242;s Up'});
	      //   this.setState({ timer_display: 'card hide_block' });
	      // }
	    }
	    /*
	    ------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	      */
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this4.state.token,
	          idname: _this4.state.idname,
	          question_id: _this4.state.questionId,
	          ratting: nextValue,
	          type: 'tab_question'
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this4.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this4.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	    //Function to fetch previous question
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	      this.mounted = false;
	    }
	    //Function to fetch Next question
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	    //Function to redirect page to readings page
	
	    /*Function to start or stop timer*/
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(event) {
	      var _setState;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + '_yes', ''), _defineProperty(_setState, name + '_no', ''), _setState));
	    }
	    //Function to redirect page to readings beforestart
	
	    //function to show calculator
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          statement1 = _state.statement1,
	          statement2 = _state.statement2,
	          statement3 = _state.statement3,
	          statement4 = _state.statement4,
	          statement5 = _state.statement5,
	          choice_a = _state.choice_a,
	          choice_b = _state.choice_b,
	          question = _state.question,
	          explanation = _state.explanation,
	          reportLoading = _state.reportLoading,
	          offset = _state.offset,
	          questionsArray = _state.questionsArray,
	          reading = _state.reading,
	          display_loader = _state.display_loader,
	          questionHide = _state.questionHide,
	          choice1_yes = _state.choice1_yes,
	          choice2_yes = _state.choice2_yes,
	          choice3_yes = _state.choice3_yes,
	          choice4_yes = _state.choice4_yes,
	          choice5_yes = _state.choice5_yes,
	          choice1_no = _state.choice1_no,
	          choice2_no = _state.choice2_no,
	          choice3_no = _state.choice3_no,
	          choice4_no = _state.choice4_no,
	          choice5_no = _state.choice5_no,
	          questionId = _state.questionId,
	          error = _state.error,
	          correct_answer_1 = _state.correct_answer_1,
	          correct_answer_2 = _state.correct_answer_2,
	          correct_answer_3 = _state.correct_answer_3,
	          correct_answer_4 = _state.correct_answer_4,
	          correct_answer_5 = _state.correct_answer_5;
	
	      var questions = this.state.display_question;
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ' : ',
	              this.state.quiz_id
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'text-danger' },
	              this.state.already_answered_status
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class calc-btn',
	                  onClick: this._handleModal
	                },
	                ' ',
	                _language2.default.LC().OPEN_CALCULATOR
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            _language2.default.LC().Q,
	            ' ',
	            parseInt(this.state.offset) + 1,
	            ' ',
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row card-block' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'col-lg-5 mb-0 overflow-y-auto mb-sm-1 calc_height_GMAT',
	                style: {
	                  borderRadius: '0px',
	                  borderRight: '1px solid #f5f5f5'
	                }
	              },
	              (0, _function.renderHTMLContent)(this.state.data, "div", "", { onClick: this.clickHandler })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'col-lg-5 mb-0 overflow-y-auto  mb-sm-1 font-16px calc_height_GMAT',
	                style: { borderRadius: '0px' }
	              },
	              (0, _function.renderHTMLContent)(this.state.option, "div"),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.submit, className: 'm-15px' },
	                (0, _function.renderHTMLContent)(question, "div"),
	                _react2.default.createElement(
	                  'table',
	                  { className: 'm-15px' },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    statement1 && statement2 && statement3 && statement4 && statement5 ? _react2.default.createElement(
	                      'tbody',
	                      { className: 'first-letter-capitilize' },
	                      _react2.default.createElement(
	                        'tr',
	                        { onChange: function onChange(e) {
	                            return _this5.onChangeValueFor5Statement(e, 1);
	                          } },
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'pr-1' },
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: correct_answer_1 ? 'correct_choice' : 'choice1',
	                            name: correct_answer_1 ? 'correct_choice' : 'choice1'
	                            // checked={correct_answer_1}
	                            , value: 'Yes',
	                            className: correct_answer_1 ? 'accent-success pointer_class' : choice1_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement1
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { onChange: function onChange(e) {
	                            return _this5.onChangeValueFor5Statement(e, 2);
	                          } },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: correct_answer_2 ? 'correct_choice' : 'choice1',
	                            name: correct_answer_2 ? 'correct_choice' : 'choice1'
	                            // checked={correct_answer_2}
	                            , value: 'Yes',
	                            className: correct_answer_2 ? 'accent-success pointer_class' : choice2_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement2
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { onChange: function onChange(e) {
	                            return _this5.onChangeValueFor5Statement(e, 3);
	                          } },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: correct_answer_3 ? 'correct_choice' : 'choice1',
	                            name: correct_answer_3 ? 'correct_choice' : 'choice1'
	                            // checked={correct_answer_3}
	                            , value: 'Yes',
	                            className: correct_answer_3 ? 'accent-success pointer_class' : choice3_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement3
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { onChange: function onChange(e) {
	                            return _this5.onChangeValueFor5Statement(e, 4);
	                          } },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: correct_answer_4 ? 'correct_choice' : 'choice1',
	                            name: correct_answer_4 ? 'correct_choice' : 'choice1'
	                            // checked={correct_answer_4}
	                            , value: 'Yes',
	                            className: correct_answer_4 ? 'accent-success pointer_class' : choice4_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement4
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { onChange: function onChange(e) {
	                            return _this5.onChangeValueFor5Statement(e, 5);
	                          } },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: correct_answer_5 ? 'correct_choice' : 'choice1',
	                            name: correct_answer_5 ? 'correct_choice' : 'choice1'
	                            // checked={correct_answer_5}
	                            , value: 'Yes',
	                            className: correct_answer_3 ? 'accent-success pointer_class' : choice5_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement5
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      { className: 'first-letter-capitilize' },
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          choice_a
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          choice_b
	                        ),
	                        _react2.default.createElement('th', null)
	                      ),
	                      statement1 ? _react2.default.createElement(
	                        'tr',
	                        { onChange: this.onChangeValue },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: 'html',
	                            name: 'choice1',
	                            value: 'Yes',
	                            className: choice1_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: 'html',
	                            name: 'choice1',
	                            value: 'No',
	                            className: choice1_no + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement1
	                        )
	                      ) : null,
	                      statement2 ? _react2.default.createElement(
	                        'tr',
	                        { onChange: this.onChangeValue },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: 'html',
	                            name: 'choice2',
	                            value: 'Yes',
	                            className: choice2_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: 'html',
	                            name: 'choice2',
	                            value: 'No',
	                            className: choice2_no + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement2
	                        )
	                      ) : null,
	                      statement3 ? _react2.default.createElement(
	                        'tr',
	                        { onChange: this.onChangeValue },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: 'html',
	                            name: 'choice3',
	                            value: 'Yes',
	                            className: choice3_yes + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement('input', {
	                            type: 'radio',
	                            id: 'html',
	                            name: 'choice3',
	                            value: 'No',
	                            className: choice3_no + '  pointer_class'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          statement3
	                        )
	                      ) : null
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'error_msg' },
	                  error
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex' },
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                    isQue: true
	                    // activateExplanation={activateExplanation}
	                    , _getResult: statement1 && statement2 && statement3 && statement4 && statement5 ? this._getResultfor5Statements : this._getResult,
	                    _saveQuestion: this._saveQuestion,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: question,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                    // isSpecialQuestion={true}
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' + this.state.result_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.text_color },
	                    this.state.result
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block font-16px' },
	                    (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false', suppressContentEditableWarning: true })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'timer_outer' },
	                _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'timer_box' },
	                  display_time
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'quiz_timer_btn ' + this.state.timer_display },
	                _react2.default.createElement('button', {
	                  type: 'button',
	                  className: this.state.timerstopbtn,
	                  onClick: this._timer_funct.bind(this, questions)
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'text-danger' },
	                (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: 'false' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, question)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, question)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this5.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return GMATTab;
	}(_react.Component);
	
	GMATTab.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATTab;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _GMATCalculator = __webpack_require__(46);
	
	var _GMATCalculator2 = _interopRequireDefault(_GMATCalculator);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable */
	
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	var TwoPartQuiz = function (_Component) {
	  _inherits(TwoPartQuiz, _Component);
	
	  function TwoPartQuiz(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, TwoPartQuiz);
	
	    var _this = _possibleConstructorReturn(this, (TwoPartQuiz.__proto__ || Object.getPrototypeOf(TwoPartQuiz)).call(this, props));
	
	    _this._getResult = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(item, e) {
	        var _this$state, answer1, answer2, userValue1, userValue2, selectedChoiceNo, selectedChoiceYes, option1, option2, option3, option4, option5, option6, expectedCount, count, optionArray, right_answer, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // const { option1, option2, option3, option4, option5, option6 } = item;
	                _this$state = _this.state, answer1 = _this$state.answer1, answer2 = _this$state.answer2, userValue1 = _this$state.userValue1, userValue2 = _this$state.userValue2, selectedChoiceNo = _this$state.selectedChoiceNo, selectedChoiceYes = _this$state.selectedChoiceYes, option1 = _this$state.option1, option2 = _this$state.option2, option3 = _this$state.option3, option4 = _this$state.option4, option5 = _this$state.option5, option6 = _this$state.option6;
	                expectedCount = 2;
	                count = 0;
	                optionArray = [];
	
	                optionArray.push(option1);
	                optionArray.push(option2);
	                optionArray.push(option3);
	                optionArray.push(option4);
	                optionArray.push(option5);
	                if (userValue1 && userValue2) {
	                  _this.setState({
	                    error: ''
	                  });
	                  console.log('if');
	                } else {
	                  // this.setRadioButtonBlank();
	                  _this.setState({
	                    error: 'Please select all options '
	                  });
	                  console.log('else');
	                }
	                if (option6) optionArray.push(option6);
	                userValue2 = userValue2 ? userValue2.toLowerCase().trim() : null;
	                answer2 = answer2 ? answer2.toLowerCase().trim() : null;
	                if (userValue1 && userValue2) {
	                  if (userValue2 === answer2) {
	                    count++;
	                    _this.setState(_defineProperty({}, selectedChoiceNo, 'accent-success'));
	                  } else {
	                    optionArray.filter(function (item, index) {
	                      if (item.toLowerCase().trim() === answer2) {
	                        var value = 'choice' + (index + 1) + '_no';
	                        _this.setState(_defineProperty({}, value, 'accent-success'), function () {
	                          _this.setRadioButtonSuccess(true);
	                        });
	                        return;
	                      }
	                    });
	                    _this.setState(_defineProperty({}, selectedChoiceNo, 'accent-faliure'));
	                  }
	
	                  userValue1 = userValue1 ? userValue1.toLowerCase().trim() : null;
	                  answer1 = answer1 ? answer1.toLowerCase().trim() : null;
	                  if (userValue1 === answer1) {
	                    count++;
	                    _this.setState(_defineProperty({}, selectedChoiceYes, 'accent-success'));
	                  } else {
	                    optionArray.filter(function (item, index) {
	                      if (item.toLowerCase().trim() === answer1) {
	                        var value = 'choice' + (index + 1) + '_yes';
	                        _this.setState(_defineProperty({}, value, 'accent-success'), function () {
	                          _this.setRadioButtonSuccess(true);
	                        });
	                        return;
	                      }
	                    });
	                    _this.setState(_defineProperty({}, selectedChoiceYes, 'accent-faliure'));
	                  }
	
	                  // ========================================
	                  right_answer = 0;
	
	                  if (expectedCount === count) {
	                    right_answer = 1;
	                    _this.setState({
	                      result: 'CORRECT',
	                      text_color: 'card-header text_success',
	                      result_block: 'card show_block',
	                      isQuestionValidated: true
	                    });
	                  } else {
	                    _this.setState({
	                      result_block: 'card show_block',
	                      result: 'INCORRECT',
	                      text_color: 'card-header text_failure',
	                      isQuestionValidated: true
	                    });
	                  }
	                  // --------------- Save Stat API call Start -----------//
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    quiz_id: _this.state.quiz_id,
	                    question_id: _this.state.all_question_id[_this.state.offset],
	                    answer: right_answer,
	                    reading_id: item.reading_id,
	                    type: 'two_part_question'
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	                    if (resp.success) {
	                      var data = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        question_id: _this.state.questionId,
	                        right_answer: right_answer,
	                        type: 'two_part_question'
	                        // time_done: this.state.count,
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                        if (resp.success) {} else {}
	                      });
	                      _this.setState({ ValidToken: true });
	                      _this.setState({ validated: true });
	                    } else {
	                      _this.setState({ ValidToken: false });
	                    }
	                    return resp;
	                  });
	
	                  // --------------- Save Stat API call End-----------//
	                }
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        chapter_id: _this.props.params.chapterid,
	        type: 'two_part_question'
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      var params = {
	        token: _this.state.token,
	        question_id: questionid,
	        idname: _this.state.idname,
	        type: 'two_part_question'
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.setQuestionData = function (questionObj) {
	      if (questionObj) {
	        _this.setState({
	          allQuestions: questionObj,
	          question: questionObj.question,
	          questionId: questionObj.id,
	          choice_a: questionObj.choice_a,
	          choice_b: questionObj.choice_b,
	          explanation: questionObj.explanation,
	          answer1: questionObj.answer1,
	          answer2: questionObj.answer2,
	          option1: questionObj.option1,
	          option2: questionObj.option2,
	          option3: questionObj.option3,
	          option4: questionObj.option4,
	          option5: questionObj.option5,
	          option6: questionObj.option6,
	          questionHide: '',
	          display_loader: 'hide_block',
	          result_block: 'card hide_block',
	          report_block: 'card hide_block',
	          choice1_yes: '',
	          choice1_no: '',
	          choice2_yes: '',
	          choice2_no: '',
	          choice3_yes: '',
	          choice3_no: '',
	          choice4_yes: '',
	          choice4_no: '',
	          choice5_yes: '',
	          choice5_no: '',
	          choice6_yes: '',
	          choice6_no: '',
	          reading_id: questionObj.reading_id,
	          reading: questionObj['gmat_reading.reading']
	        }, function () {
	          _this.setRadioButtonBlank();
	          _this.getFavQuestions(questionObj.id);
	          _this.getGMATRatting(questionObj.id);
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({
	        report_block: 'card hide_block',
	        isQuestionValidated: false
	      });
	      document.getElementById('comment').value = '';
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      if (_this.state.userValue1) {
	        _this.setState({
	          userValue1: ''
	        });
	      } else if (_this.state.userValue2) {
	        _this.setState({
	          userValue2: ''
	        });
	      }
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          console.log('Timer Update Successfull');
	        } else {
	          console.log('Fail Timer Update');
	        }
	      });
	
	      var index_id = _this.state.offset - 1;
	      if (_this.state.question_length - 1 != index_id) {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type && _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var questionsbyid = resp.questionsbyid;
	
	          _this.setQuestionData(resp.questionsbyid);
	          _this.setRadioButtonBlank();
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', questionsbyid['gmat_reading.type']).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          }
	          _this.setState({ display_loader: 'hide_block' });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getNext = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({
	        report_block: 'card hide_block',
	        isQuestionValidated: false
	      });
	      document.getElementById('comment').value = '';
	      if (_this.state.error) {
	        _this.setState({
	          error: ''
	        });
	      } else {
	        console.log('else');
	      }
	      if (_this.state.userValue1) {
	        _this.setState({
	          userValue1: ''
	        });
	      } else if (_this.state.userValue2) {
	        _this.setState({
	          userValue2: ''
	        });
	      } else {
	        console.log('error');
	      }
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          //console.log('Timer Update Successfull');
	        } else {
	            //console.log('Fail Timer Update');
	          }
	      });
	      var index_id = _this.state.offset + 1;
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (_this.state.question_length - 1 == index_id) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        var questionsbyid = resp.questionsbyid;
	
	        _this.setQuestionData(resp.questionsbyid);
	        _this.setRadioButtonBlank();
	        if (resp.success) {
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', questionsbyid['gmat_reading.type']).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _this.setState({ display_loader: 'hide_block' });
	          //console.log(data_check);
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          // this.setState({ choice_a: 'answer_box' });
	          // this.setState({ choice_b: 'answer_box' });
	          // this.setState({ choice_c: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this.setRadioButtonBlank = function () {
	      for (var counter = 0; counter < 2; counter++) {
	        var resetRadioButton = document.getElementsByName('userValue' + (counter + 1));
	        for (var i = 0; i < resetRadioButton.length; i++) {
	          resetRadioButton[i].checked = false;
	        }
	      }
	    };
	
	    _this.setRadioButtonSuccess = function (value) {
	      var radioButtonElement = document.getElementsByName('accent-success_yes');
	      for (var y = 0; y < 2; y++) {
	        for (var i = 0; i < radioButtonElement.length; i++) {
	          radioButtonElement[i].checked = value;
	        }radioButtonElement = document.getElementsByName('accent-success_no');
	      }
	    };
	
	    _this.setRadioButtonAfterValidate = function (name) {
	      _this.setRadioButtonBlank();
	      _this.setRadioButtonSuccess(false);
	      // let resetRadioButton = document.getElementsByName(name);
	      // for (var i = 0; i < resetRadioButton.length; i++)
	      //   resetRadioButton[i].checked = true;
	    };
	
	    _this._saveQuestion = function (item, e) {
	      // console.log("_saveQuestion");
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        type: 'two_part_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.props.params.readingid ? _this.props.params.readingid : _this.state.reading_id ? _this.state.reading_id : 0
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.questionId,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        type: 'two_part_question',
	        topic_name: _this.state.reading,
	        reading_id: _this.state.reading_id
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', _this.state.quiz_id).replace(':status_send', 'abondon')
	      });
	    };
	
	    _this._handleModal = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this.state = (_this$state2 = {
	      show: false,
	      question: '',
	      explanation: '',
	      choice_a: '',
	      choice_b: '',
	      answer1: '',
	      answer2: '',
	      user_answer1: '',
	      user_answer2: '',
	      offset: _this.props.params.offset,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      rating: 0,
	      reportLoading: false,
	      questionsArray: [],
	      chapter_id: _this.props.params.chapterid,
	      reading_id: _this.props.params.readingid,
	      subscriptionstatus: _this.props.params.subscription ? 'paid' : 'free',
	      reading: _this.props.params.reading,
	      display_loader: 'show_block',
	      questionHide: 'hide_block',
	      option1: '',
	      option2: '',
	      option3: '',
	      option4: '',
	      option5: '',
	      option6: '',
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      isQuestionValidated: false,
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      quiz_id: _this.props.params.quiz_id
	    }, _defineProperty(_this$state2, 'offset', _this.props.params.offset ? parseInt(_this.props.params.offset) : 0), _defineProperty(_this$state2, 'count', _this.props.params.timer ? _this.props.params.timer : 0), _defineProperty(_this$state2, 'error', ''), _defineProperty(_this$state2, 'display_question', ''), _defineProperty(_this$state2, 'timerstopbtn', 'icon-control-pause pause_btn'), _this$state2);
	    _this.onChangeValue = _this.onChangeValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(TwoPartQuiz, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.mounted = true;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (this.mounted) {
	        this.setState({ idname: storage_session['idname'] });
	        this.setState({ token: storage_session['token'] });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var question_id = [];
	          var reading_id = [];
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	          }
	          var timer_value = resp.timer_value;
	
	          var first_question_id = question_id[_this3.state.offset];
	          var first_reading_type = reading_id[_this3.state.offset];
	          var user_timer = resp.user_time_value;
	          _this3.setState({
	            user_time_value: user_timer,
	            count: resp.user_time_value ? resp.user_time_value : parseInt(_this3.props.params.timer),
	            count_temp: user_timer
	          });
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: timer_value,
	            include_timer: resp.include_timer,
	            first_question_id: first_question_id,
	            first_reading_type: first_reading_type,
	            all_reading_type: reading_id
	          });
	
	          if (question_id.length - 1 == _this3.state.offset) {
	            _this3.setState({
	              next_block: 'card hide_block'
	            });
	          }
	
	          var data = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            type: first_reading_type
	          };
	          //Api to fetch question by question id
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	            if (resp.success) {
	              var data_check = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id,
	                type: first_reading_type
	              };
	              _this3.setQuestionData(resp.questionsbyid);
	              /*Api to fetch question and check answered */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                _this3.setState({
	                  already_answered_status: resp_inner.message
	                });
	              });
	              _this3.setState({
	                ValidToken: true
	              });
	              _this3.setState({
	                display_question: resp.questionsbyid
	              });
	              _this3.setState({
	                display_loader: 'hide_block'
	              });
	              var params = {
	                token: _this3.state.token,
	                question_id: first_question_id,
	                idname: _this3.state.idname,
	                type: first_reading_type
	              };
	              /*Api to fetch Saved question */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                if (response.success) {
	                  _this3.setState({
	                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                  });
	                  _this3.setState({
	                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                  });
	                  _this3.setState({
	                    bookmarkColor: 'rgb(54, 141, 84)'
	                  });
	                  _this3.setState({
	                    save_text: '' + _language2.default.LC().Question_Saved
	                  });
	                }
	              });
	              var params = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                quiz_id: _this3.state.quiz_id,
	                question_id: first_question_id
	              };
	              /*Api to fetch commented on question*/
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                if (response.success) {
	                  var comments = '';
	                  _this3.setState({
	                    ValidToken: true
	                  });
	                  if (response.comments.length > 0) {
	                    comments = response.comments.map(function (items, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: index },
	                        response.user_id == items.uid ? _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._editComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteComment.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ) : _react2.default.createElement('ul', null),
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          _language2.default.LC().BY,
	                          ' ',
	                          items.username,
	                          ',',
	                          ' ',
	                          new Date(items.createdAt).toDateString()
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.comment
	                        )
	                      );
	                    });
	
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  } else {
	                    comments = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_COMMENTS_FOUND
	                    );
	                    _this3.setState({
	                      comment_data: comments
	                    });
	                  }
	                } else {
	                  comments = _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_COMMENTS_FOUND
	                  );
	                  _this3.setState({
	                    comment_data: comments
	                  });
	                  _this3.setState({
	                    ValidToken: false
	                  });
	                }
	                return response;
	              });
	            } else {
	              // console.log(resp.success + '------------failure');
	            }
	          });
	
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: first_question_id,
	            quiz_id: _this3.state.quiz_id
	          };
	          /*Api to fetch flash card*/
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this3.setState({
	                ValidToken: true
	              });
	              if (response.flash_cards.length > 0) {
	                _this3.setState({
	                  flash_form: 'col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this3._editFlash.bind(_this3, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this3._deleteFlash.bind(_this3, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this3.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this3.setState({
	                  flash_form: 'col-md-12 display_block'
	                });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this3.setState({
	                flash_data: flash_cards
	              });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this3.setState({
	                ValidToken: false
	              });
	              _this3.setState({
	                flash_data: flash_cards
	              });
	              _this3.setState({
	                flash_form: 'col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    //Function to show Correct box and display right answer and store in database
	
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	      this.mounted = false;
	    }
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this4 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this4.setState({ rated: 1 });
	            _this4.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this4.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this4.setState({ rating: items.ratting });
	              _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              question_id: _this4.state.questionId,
	              ratting: nextValue,
	              type: 'two_part_question'
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({ rated: 1 });
	                _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var _params2 = {
	            token: _this4.state.token,
	            idname: _this4.state.idname,
	            question_id: _this4.state.questionId,
	            ratting: nextValue,
	            type: 'two_part_question'
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveGMATRatting', _params2).then(function (response) {
	            if (response.success) {
	              _this4.setState({ rated: 1 });
	              _this4.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Funcion to save new report question
	
	
	    //Function to redirect page to readings page
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(event, choice1) {
	      var _this5 = this,
	          _setState3;
	
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	      var isQuestionValidated = this.state.isQuestionValidated;
	
	      if (isQuestionValidated) {
	        for (var i = 1; i <= 5; i++) {
	          var _setState;
	
	          this.setState((_setState = {}, _defineProperty(_setState, 'choice' + i + '_yes', ''), _defineProperty(_setState, 'choice' + i + '_no', ''), _setState));
	        }this.setState({
	          choice6_yes: '',
	          choice6_no: '',
	          userValue1: '',
	          userValue2: ''
	        }, function () {
	          _this5.setRadioButtonAfterValidate(event, choice1);
	          var setRadioButton = void 0;
	          // console.log(choice1);
	          if (choice1.includes('_yes')) {
	            setRadioButton = document.getElementsByName('userValue1');
	          } else {
	            setRadioButton = document.getElementsByName('userValue2');
	          }
	          setRadioButton[parseInt(choice1.match(/[0-9]/)[0]) - 1].checked = true;
	        });
	      }
	      if (choice1.includes('_yes')) this.setState({
	        selectedChoiceYes: choice1
	      });else this.setState({ selectedChoiceNo: choice1 });
	      for (var _i = 1; _i <= 6; _i++) {
	        var _setState2;
	
	        this.setState((_setState2 = {}, _defineProperty(_setState2, 'choice' + _i + '_yes', ''), _defineProperty(_setState2, 'choice' + _i + '_no', ''), _setState2));
	      }this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'isQuestionValidated', false), _setState3));
	    }
	
	    //Function to redirect page to readings beforestart
	
	
	    //function to show calculator
	
	
	    /*Function to start or stop timer*/
	
	    /*Function to start or stop timer*/
	
	  }, {
	    key: 'tick',
	
	
	    //Function to change time every second and store in database
	    value: function tick() {
	      if (this.state.count != 0) {
	        var count_value = this.state.count - 1;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: count_value
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	          if (resp.success) {
	            // console.log('Timer Update Successfull');
	          } else {
	              // console.log('Fail Timer Update');
	            }
	        });
	        this.setState({ count: this.state.count - 1 });
	        this.setState({ timer_display: 'card-block' });
	      } else {
	        this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(':status_send', 'completed')
	        });
	      }
	      // if (this.state.timer_value == this.state.count) {
	      //   // this.setState({count_end_message:'Time&#8242;s Up'});
	      //   this.setState({ timer_display: 'card hide_block' });
	      // }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state = this.state,
	          choice_a = _state.choice_a,
	          choice_b = _state.choice_b,
	          question = _state.question,
	          reportLoading = _state.reportLoading,
	          explanation = _state.explanation,
	          questionsArray = _state.questionsArray,
	          offset = _state.offset,
	          reading = _state.reading,
	          questionHide = _state.questionHide,
	          display_loader = _state.display_loader,
	          option1 = _state.option1,
	          option2 = _state.option2,
	          option3 = _state.option3,
	          option4 = _state.option4,
	          option5 = _state.option5,
	          option6 = _state.option6,
	          choice1_yes = _state.choice1_yes,
	          choice1_no = _state.choice1_no,
	          choice2_yes = _state.choice2_yes,
	          choice2_no = _state.choice2_no,
	          choice3_yes = _state.choice3_yes,
	          choice3_no = _state.choice3_no,
	          choice4_yes = _state.choice4_yes,
	          choice4_no = _state.choice4_no,
	          choice5_yes = _state.choice5_yes,
	          choice5_no = _state.choice5_no,
	          choice6_yes = _state.choice6_yes,
	          choice6_no = _state.choice6_no,
	          allQuestions = _state.allQuestions,
	          questionId = _state.questionId,
	          error = _state.error;
	
	      var questions = this.state.display_question;
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUIZ_ID,
	              ' : ',
	              this.state.quiz_id
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'text-danger' },
	              this.state.already_answered_status
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class calc-btn',
	                  onClick: this._handleModal
	                },
	                ' ',
	                _language2.default.LC().OPEN_CALCULATOR
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card margin_bottom_40 font-16px ' + questionHide },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement('img', {
	              src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	              className: 'margin_right_20',
	              width: '30',
	              alt: ''
	            }),
	            _language2.default.LC().Q,
	            ' ',
	            parseInt(this.state.offset) + 1,
	            ' ',
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              parseInt(offset) !== 0 ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                onClick: this._getPrevious
	              }) : null,
	              questionsArray.length - 1 !== parseInt(offset) ? _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                onClick: this._getNext
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9' },
	                (0, _function.renderHTMLContent)(question, "p"),
	                _react2.default.createElement(
	                  'table',
	                  {
	                    className: 'text-center border-solid-1 margin_bottom_30'
	                    // border='1'
	                  },
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'border-solid-1 p-10px' },
	                        choice_a
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'border-solid-1 p-10px' },
	                        choice_b
	                      ),
	                      _react2.default.createElement('th', { className: 'border-solid-1 p-10px' })
	                    ),
	                    option1 ? _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice1_yes === 'accent-success' ? choice1_yes + '_yes' : 'userValue1',
	                          value: option1,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice1_yes');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice1_yes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice1_no === 'accent-success' ? choice1_no + '_no' : 'userValue2',
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice1_no');
	                          },
	                          value: option1,
	                          className: 'border-solid-1 cursor-pointer ' + choice1_no
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        (0, _function.renderHTMLContent)(option1, "span")
	                      )
	                    ) : null,
	                    option2 ? _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice2_yes === 'accent-success' ? choice2_yes + '_yes' : 'userValue1',
	                          value: option2,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice2_yes');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice2_yes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice2_no === 'accent-success' ? choice2_no + '_no' : 'userValue2',
	                          value: option2,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice2_no');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice2_no
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        (0, _function.renderHTMLContent)(option2, "span")
	                      )
	                    ) : null,
	                    option3 ? _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice3_yes === 'accent-success' ? choice3_yes + '_yes' : 'userValue1',
	                          value: option3,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice3_yes');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice3_yes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice3_no === 'accent-success' ? choice3_no + '_no' : 'userValue2',
	                          value: option3,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice3_no');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice3_no
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        (0, _function.renderHTMLContent)(option3, "span")
	                      )
	                    ) : null,
	                    option4 ? _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice4_yes === 'accent-success' ? choice4_yes + '_yes' : 'userValue1',
	                          value: option4,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice4_yes');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice4_yes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice4_no === 'accent-success' ? choice4_no + '_no' : 'userValue2',
	                          value: option4,
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice4_no');
	                          },
	                          className: 'border-solid-1 cursor-pointer ' + choice4_no
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        (0, _function.renderHTMLContent)(option4, "span")
	                      )
	                    ) : null,
	                    option5 ? _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice5_yes === 'accent-success' ? choice5_yes + '_yes' : 'userValue1',
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice5_yes');
	                          },
	                          value: option5,
	                          className: 'border-solid-1 cursor-pointer ' + choice5_yes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice5_no === 'accent-success' ? choice5_no + '_no' : 'userValue2',
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice5_no');
	                          },
	                          value: option5,
	                          className: 'border-solid-1 cursor-pointer ' + choice5_no
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        (0, _function.renderHTMLContent)(option5, "span")
	                      )
	                    ) : null,
	                    option6 ? _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice6_yes === 'accent-success' ? choice6_yes + '_yes' : 'userValue1',
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice6_yes');
	                          },
	                          value: option6,
	                          className: 'border-solid-1 cursor-pointer ' + choice6_yes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          id: 'html',
	                          name: choice6_no === 'accent-success' ? choice6_no + '_no' : 'userValue2',
	                          onChange: function onChange(e) {
	                            return _this6.onChangeValue(e, 'choice6_no');
	                          },
	                          value: option6,
	                          className: 'border-solid-1 cursor-pointer ' + choice6_no
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'border-solid-1 p-10px' },
	                        (0, _function.renderHTMLContent)(option6, "span")
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'error_msg' },
	                  error
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row bottom-tool' },
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                    isQue: true,
	                    _getResult: this._getResult,
	                    _saveQuestion: this._saveQuestion,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: allQuestions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                    // isSpecialQuestion={true}
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'timer_outer' },
	                  _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'timer_box' },
	                    display_time
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'quiz_timer_btn ' + this.state.timer_display },
	                  _react2.default.createElement('button', {
	                    type: 'button',
	                    className: this.state.timerstopbtn,
	                    onClick: this._timer_funct.bind(this, questions)
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'text-danger' },
	                  (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: 'false' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.result_block + ' font-lusitana font-16px' },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.text_color },
	            this.state.result
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            (0, _function.renderHTMLContent)(explanation, "p", "view_questionhtml", { contentEditable: 'false' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.report_block },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _language2.default.LC().REPORT
	          ),
	          !this.state.successAlert ? _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().COMMENT
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 margin_bottom_10' },
	                _react2.default.createElement('textarea', {
	                  id: 'comment',
	                  name: 'comment',
	                  rows: '6',
	                  className: 'form-control',
	                  placeholder: 'Content..'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class report-btn',
	                    disabled: reportLoading,
	                    onClick: this._reportQuestion.bind(this, question)
	                  },
	                  ' ',
	                  reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-danger active pointer_class margin_left_10',
	                    onClick: this._hideReportForm.bind(this, question)
	                  },
	                  ' ',
	                  _language2.default.LC().CANCEL
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 report-Success-card' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-control-label', htmlFor: 'textarea-input' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' ',
	                    _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary active pointer_class  min-vw-120',
	                    onClick: this.onClose
	                  },
	                  ' ',
	                  _language2.default.LC().CLOSE
	                )
	              )
	            )
	          )
	        ),
	        display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null,
	        _react2.default.createElement(_GMATCalculator2.default, {
	          addToInput: this.addToInput,
	          show: this.state.show,
	          addDecimal: this.addDecimal,
	          addZeroToInput: this.addZeroToInput,
	          clearInput: this.clearInput,
	          add: this.add,
	          subtract: this.subtract,
	          multiply: this.multiply,
	          divide: this.divide,
	          evaluate: this.evaluate,
	          closeModal: function closeModal() {
	            return _this6.setState({ show: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return TwoPartQuiz;
	}(_react.Component);
	
	TwoPartQuiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = TwoPartQuiz;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Beginquiz = function (_Component) {
	  _inherits(Beginquiz, _Component);
	
	  function Beginquiz(props) {
	    _classCallCheck(this, Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (Beginquiz.__proto__ || Object.getPrototypeOf(Beginquiz)).call(this, props));
	
	    _this._getAnswer = function (choice, e) {
	      _this.setState({ clicked: true });
	      _this.setState({ choice: choice });
	      if (choice === 'choice_a') {
	        _this.setState({ choice_a: 'answer_box clicked_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_b') {
	        _this.setState({ choice_b: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_c') {
	        _this.setState({ choice_c: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_d') {
	        _this.setState({ choice_d: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box ' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_e') {
	        _this.setState({ choice_e: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	      }
	    };
	
	    _this._getResult = function (item, e) {
	      if (_this.state.clicked) {
	        clearInterval(_this.timer);
	        var chosen_answer = _this.state.choice;
	        var right_answer = 0;
	        _this.setState({ result_block: 'card show_block' });
	        if (item.right_choice == _this.state.choice) {
	          right_answer = 1;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({ choice_d: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({ choice_e: 'answer_box success' });
	          }
	          _this.setState({ result: '' + _language2.default.LC().CORRECT });
	          _this.setState({ text_color: 'card-header text_success' });
	          _this.setState({ result_block: 'card show_block' });
	        } else {
	          right_answer = 0;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({ choice_d: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({ choice_e: 'answer_box failure' });
	          }
	          if (item.right_choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.right_choice === 'choice_b') {
	            _this.setState({ choice_b: 'answer_box success' });
	          } else if (item.right_choice === 'choice_c') {
	            _this.setState({ choice_c: 'answer_box success' });
	          } else if (item.right_choice === 'choice_d') {
	            _this.setState({ choice_d: 'answer_box success' });
	          } else if (item.right_choice === 'choice_e') {
	            _this.setState({ choice_e: 'answer_box success' });
	          }
	          _this.setState({ text_color: 'card-header text_failure' });
	          _this.setState({ result: '' + _language2.default.LC().INCORRECT });
	          _this.setState({ result_block: 'card show_block' });
	        }
	
	        if (!_this.state.validated) {
	          //  console.log('quiz id  '+this.state.quiz_id+'---question_id---'+this.state.all_question_id[this.state.offset]+'-----right answer-----'+right_answer);
	          var data = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            answer: right_answer,
	            reading_id: item.reading_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/answerQuiz', data).then(function (resp) {
	            if (resp.success) {
	              var data = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                question_id: _this.state.all_question_id[_this.state.offset],
	                right_answer: right_answer,
	                time_done: 0
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveStats', data).then(function (resp) {
	                if (resp.success) {} else {}
	              });
	              _this.setState({ ValidToken: true });
	              _this.setState({ validated: true });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      }
	    };
	
	    _this._getNext = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({ clicked: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      document.getElementById('comment').value = '';
	      // document.getElementById('ques_comment').value = '';
	
	      var data = {
	        idname: _this.state.idname,
	        token: _this.state.token,
	        quiz_id: _this.state.quiz_id
	      };
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          //console.log('Timer Update Successfull');
	        } else {
	            //console.log('Fail Timer Update');
	          }
	      });
	
	      var index_id = _this.state.offset + 1;
	      if (index_id > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (_this.state.question_length - 1 == index_id) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        var questionsbyid = resp.questionsbyid;
	
	        if (resp.success) {
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) + 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _this.setState({ display_loader: 'hide_block' });
	          //console.log(data_check);
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          _this.setState({ choice_a: 'answer_box' });
	          _this.setState({ choice_b: 'answer_box' });
	          _this.setState({ choice_c: 'answer_box' });
	          _this.setState({ choice_d: 'answer_box' });
	          _this.setState({ choice_e: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({ display_loader: 'show_block' });
	      _this.setState({ validated: false });
	      _this.setState({ clicked: false });
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	      });
	      _this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
	      _this.setState({ bookmarkColor: '' });
	      _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	      _this.setState({ report_block: 'card hide_block' });
	      document.getElementById('comment').value = '';
	      // document.getElementById('ques_comment').value = '';
	
	      var insert_time = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        quiz_id: _this.state.quiz_id,
	        user_time_value: _this.state.count
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	        if (resp.success) {
	          console.log('Timer Update Successfull');
	        } else {
	          console.log('Fail Timer Update');
	        }
	      });
	
	      var index_id = _this.state.offset - 1;
	      if (_this.state.question_length - 1 != index_id) {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: index_id });
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: _this.state.all_question_id[index_id],
	        type: _this.state.all_reading_type[index_id]
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          var questionsbyid = resp.questionsbyid;
	
	          if (questionsbyid['gmat_reading.type'] === 'case_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':case', questionsbyid.case_id).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_TWOPART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':type', questionsbyid['gmat_reading.type']).replace(':timer', _this.state.count)
	            });
	          } else {
	            _this.context.router.push({
	              pathname: _AppRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', parseInt(_this.props.params.offset) - 1).replace(':timer', _this.state.count)
	            });
	          }
	
	          // this.context.router.push({
	          //   pathname: AppRoutes.BEGIN_QUIZ.replace(
	          //     ':quiz_id',
	          //     this.state.quiz_id
	          //   ).replace(':offset', parseInt(this.props.params.offset) - 1),
	
	          //   //   `/gmat_beginquiz/${this.state.quiz_id}/${parseInt(
	          //   //   this.props.params.offset
	          //   // ) - 1}`,
	          // });
	          _this.setState({ display_loader: 'hide_block' });
	          var data_check = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            quiz_id: _this.state.quiz_id,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            type: _this.state.all_reading_type[_this.state.offset]
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp) {
	            _this.setState({ already_answered_status: resp.message });
	          });
	          _this.setState({ choice_a: 'answer_box' });
	          _this.setState({ choice_b: 'answer_box' });
	          _this.setState({ choice_c: 'answer_box' });
	          _this.setState({ choice_d: 'answer_box' });
	          _this.setState({ choice_e: 'answer_box' });
	          _this.setState({ result_block: 'card hide_block' });
	          _this.setState({ display_question: resp.questionsbyid });
	
	          var params = {
	            token: _this.state.token,
	            question_id: _this.state.all_question_id[_this.state.offset],
	            idname: _this.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	      });
	      clearInterval(_this.timer);
	      if (!_this.state.timer_stop) {
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({ save_text: '' + _language2.default.LC().SAVE_QUESTION });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: '' });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card,
	        quiz_id: _this.state.quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({ flash_form: 'col-sm-12 display_block' });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-sm-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({ flash_form: 'col-sm-12 display_block' });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._saveComment = function (item, e) {
	      if (document.getElementById('ques_comment').value == '') {
	        return;
	      }
	      var comment = document.getElementById('ques_comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        quiz_id: _this.state.quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/saveComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        /// return resp;
	      });
	    };
	
	    _this._editComment = function (item, e) {
	      document.getElementById('ques_comment').value = item.comment;
	      _this.setState({ comment_update: 'btn btn-primary active pointer_class' });
	      _this.setState({ comment_save: 'hide_block' });
	      _this.setState({ comment_update_id: item.id });
	    };
	
	    _this._deleteComment = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        comment: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/deleteComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.question_id,
	            quiz_id: _this.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ',',
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._updateComment = function (item, e) {
	      if (document.getElementById('ques_comment').value == '') {
	        return;
	      }
	      var comment = document.getElementById('ques_comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        comment_id: _this.state.comment_update_id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/updateComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          _this.setState({ comment_update: 'hide_block' });
	          _this.setState({
	            comment_save: 'btn btn-primary active pointer_class'
	          });
	          _this.setState({ comment_update_id: '' });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	            var comments = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              //this.setState({getComments : resp.comments});
	              if (response.comments.length > 0) {
	                comments = response.comments.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      response.user_id == items.uid ? _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._editComment.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteComment.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ) : _react2.default.createElement('ul', null),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        _language2.default.LC().BY,
	                        ' ',
	                        items.username,
	                        ',',
	                        ' ',
	                        new Date(items.createdAt).toDateString()
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        items.comment
	                      )
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._timer_funct = function (item, e) {
	      // this.setState({timer_stop:!this.state.timer_stop});
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false });
	        /*this.setState({timer_tag:'Stop'});   */
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({ timer_stop: true });
	        _this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
	        /*    this.setState({timer_tag:'Start'}); */
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', _this.state.quiz_id).replace(':status_send', 'abondon')
	
	        //   `/gmat_beforestart/${this.state.quiz_id}/${'abondon'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: this.state.quiz_id,
	        //   status_send: 'abondon',
	        // },
	      });
	    };
	
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: '',
	      all_reading_type: '',
	      question_length: '',
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      ValidToken: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      getComments: [],
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: _this.props.params.timer ? parseInt(_this.props.params.timer) : 0,
	      count_end_message: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      already_answered_status: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }]
	    };
	    return _this;
	  }
	  // componentWillUnmount() {
	  //   clearInterval(this.timer);
	  // }
	  //Function to change time every second and store in database
	
	
	  _createClass(Beginquiz, [{
	    key: 'tick',
	    value: function tick() {
	      if (this.state.count != 0) {
	        var count_value = this.state.count;
	        var insert_time = {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: this.state.quiz_id,
	          user_time_value: count_value
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/insertTimer', insert_time).then(function (resp) {
	          if (resp.success) {
	            // console.log('Timer Update Successfull');
	          } else {
	              // console.log('Fail Timer Update');
	            }
	        });
	        this.setState({ count: this.state.count - 1 });
	        this.setState({ timer_display: 'card-block' });
	      } else {
	        this.context.router.push({
	          pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(':status_send', 'completed')
	        });
	      }
	      // if (this.state.timer_value == this.state.count) {
	      //   console.log('another if');
	      //   this.setState({ timer_display: 'card hide_block' });
	      // }
	      console.log('exit0-------');
	    }
	
	    //it is use to redirect page
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (parseInt(this.state.offset) == 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var question_id = [];
	          var reading_id = [];
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	          }
	          var timer_value = resp.timer_value;
	
	          var first_question_id = question_id[_this2.state.offset];
	          var first_reading_type = reading_id[_this2.state.offset];
	          var user_timer = resp.user_time_value;
	          console.log('user_timer', resp.user_time_value);
	          _this2.setState({
	            user_time_value: user_timer,
	            count: resp.user_time_value ? resp.user_time_value : parseInt(_this2.props.params.timer)
	          });
	          _this2.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: timer_value,
	            include_timer: resp.include_timer,
	            first_question_id: first_question_id,
	            first_reading_type: first_reading_type,
	            all_reading_type: reading_id
	          });
	
	          if (question_id.length - 1 == _this2.state.offset) {
	            _this2.setState({ next_block: 'card hide_block' });
	          }
	
	          var data = {
	            token: _this2.state.token,
	            idname: _this2.state.idname,
	            question_id: first_question_id,
	            type: first_reading_type
	          };
	          //Api to fetch question by question id
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(function (resp) {
	            if (resp.success) {
	              var data_check = {
	                token: _this2.state.token,
	                idname: _this2.state.idname,
	                quiz_id: _this2.state.quiz_id,
	                question_id: first_question_id,
	                type: first_reading_type
	              };
	              /*Api to fetch question and check answered */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/checkAnswered', data_check).then(function (resp_inner) {
	                _this2.setState({ already_answered_status: resp_inner.message });
	              });
	              _this2.setState({ ValidToken: true });
	              _this2.setState({ display_question: resp.questionsbyid });
	              _this2.setState({ display_loader: 'hide_block' });
	              var params = {
	                token: _this2.state.token,
	                question_id: first_question_id,
	                idname: _this2.state.idname,
	                type: first_reading_type
	              };
	              /*Api to fetch Saved question */
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavQuestions', params).then(function (response) {
	                if (response.success) {
	                  _this2.setState({
	                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	                  });
	                  _this2.setState({
	                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                  });
	                  _this2.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	                  _this2.setState({
	                    save_text: '' + _language2.default.LC().Question_Saved
	                  });
	                }
	              });
	              var params = {
	                token: _this2.state.token,
	                idname: _this2.state.idname,
	                quiz_id: _this2.state.quiz_id,
	                question_id: first_question_id
	              };
	              /*Api to fetch commented on question*/
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getComments', params).then(function (response) {
	                if (response.success) {
	                  var comments = '';
	                  _this2.setState({ ValidToken: true });
	                  if (response.comments.length > 0) {
	                    comments = response.comments.map(function (items, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: index },
	                        response.user_id == items.uid ? _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this2._editComment.bind(_this2, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this2._deleteComment.bind(_this2, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ) : _react2.default.createElement('ul', null),
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          _language2.default.LC().BY,
	                          ' ',
	                          items.username,
	                          ',',
	                          ' ',
	                          new Date(items.createdAt).toDateString()
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.comment
	                        )
	                      );
	                    });
	
	                    _this2.setState({ comment_data: comments });
	                  } else {
	                    comments = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_COMMENTS_FOUND
	                    );
	                    _this2.setState({ comment_data: comments });
	                  }
	                } else {
	                  comments = _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_COMMENTS_FOUND
	                  );
	                  _this2.setState({ comment_data: comments });
	                  _this2.setState({ ValidToken: false });
	                }
	                return response;
	              });
	            } else {
	              // console.log(resp.success + '------------failure');
	            }
	          });
	
	          var params = {
	            token: _this2.state.token,
	            idname: _this2.state.idname,
	            question_id: first_question_id,
	            quiz_id: _this2.state.quiz_id
	          };
	          /*Api to fetch flash card*/
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this2.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this2.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this2._editFlash.bind(_this2, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this2._deleteFlash.bind(_this2, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this2.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this2.setState({ flash_form: 'col-md-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this2.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this2.setState({ ValidToken: false });
	              _this2.setState({ flash_data: flash_cards });
	              _this2.setState({ flash_form: 'col-md-12 display_block' });
	            }
	            return response;
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      clearInterval(this.timer);
	      this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    //Function to check Right Or Wrong Answered and displayed clicked box
	
	
	    //Function to show Correct box and display right answer and store in database
	
	
	    //Function to fetch Next question
	
	    //Function to fetch previous question
	
	
	    //Function to Display Question saved on button
	
	
	    //Funcion to save new report question
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    //Function to save comment And display new comment
	
	
	    //Function to Edit particular comment
	
	
	    //Function to delete particular comment
	
	
	    //Function to Update Comment
	
	
	    /*Function to start or stop timer*/
	
	
	    //Function to redirect page to readings beforestart
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var questions = this.state.display_question;
	      var choice_a = 'choice_a';
	      var choice_b = 'choice_b';
	      var choice_c = 'choice_c';
	      var choice_d = 'choice_d';
	      var choice_e = 'choice_e';
	      var data = '';
	      console.log('this.state.count', this.state.count);
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	
	      if (this.state.question_length >= parseInt(this.state.offset) - 1) {
	        data = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              _language2.default.LC().Q,
	              ' ',
	              parseInt(this.state.offset) + 1,
	              ' ',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      (0, _function.renderHTMLContent)(questions.question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: 'false' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_a',
	                        onClick: this._getAnswer.bind(this, choice_a)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_a },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().A
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions.choice_a, "span", "", { contentEditable: "false" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_b',
	                        onClick: this._getAnswer.bind(this, choice_b)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_b },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().B
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions.choice_b, "span", "", { contentEditable: "false" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_c',
	                        onClick: this._getAnswer.bind(this, choice_c)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_c },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().C
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions.choice_c, "span", "", { contentEditable: "false" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_d',
	                        onClick: this._getAnswer.bind(this, choice_d)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_d },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().D
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions.choice_d, "span", "", { contentEditable: "false" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'col-sm-12',
	                        id: 'choice_e',
	                        onClick: this._getAnswer.bind(this, choice_e)
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: this.state.choice_e },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'answer_count' },
	                          _language2.default.LC().E
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'ans_box_text' },
	                          (0, _function.renderHTMLContent)(questions.choice_e, "span", "", { contentEditable: "false" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          _getResult: this._getResult,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: questions,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'quiz_timer_btn ' + this.state.timer_display },
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: this.state.timerstopbtn,
	                      onClick: this._timer_funct.bind(this, questions)
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-danger' },
	                    (0, _function.renderHTMLContent)(this.state.count_end_message, "div", "", { contentEditable: 'false' })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(questions.answer, "div", "", { contentEditable: 'false' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class',
	                      onClick: this._reportQuestion.bind(this, questions)
	                    },
	                    _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, questions)
	                    },
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        data = '<div>Data Not Found</div>';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUIZ_ID,
	                ' : ',
	                this.state.quiz_id
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'text-danger' },
	                this.state.already_answered_status
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              data
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Beginquiz;
	}(_react.Component);
	
	Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this3 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this3.toggle = _this3.toggle.bind(_this3);
	    _this3.state = {
	      tooltipOpen: false
	    };
	    return _this3;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Beginquiz;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Quizzes = function (_Component) {
	  _inherits(Quizzes, _Component);
	
	  function Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Quizzes.__proto__ || Object.getPrototypeOf(Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot == dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i == dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    _this.setState({ display_loader: 'hide_block' });
	                    (0, _toast.showFailure)(resp.message);
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._createQuiz = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var data;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this.setState({ display_loader: 'show_block' });
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context5.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context4.next = 13;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context4.next = 6;
	                            break;
	                          }
	
	                          _this.setState({ display_loader: 'hide_block' });
	                          (0, _toast.showFailure)('Please Upgrade Your Account');
	                          _context4.next = 11;
	                          break;
	
	                        case 6:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context4.next = 11;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, question_length_val, timer_value, chapterAll, dataString, dataReason, chapterall_id, i, data, checkboxes, single_clicked_value;
	                              return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                while (1) {
	                                  switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context2.next = 11;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = 'gmat';
	                                      isInArray_var = false;
	                                      _context2.next = 6;
	                                      return _GMATSubscription4.default.checkGMATSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context2.sent;
	
	                                      console.log(isInArray_var, '<========partner==========');
	                                      if (isInArray_var) {
	                                        question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                                        chapterAll = '';
	
	                                        timer_value = _this.state.quiz_length_state[_this.state.radio_checked_question].timer_value;
	                                        if (_this.state.all_checked_state) {
	                                          // console.log('if	 working')
	                                          dataString = JSON.stringify(_this.state.chapters);
	                                          dataReason = JSON.parse(dataString);
	                                          chapterall_id = [];
	
	                                          for (i = 0; i < dataReason.length; i++) {
	                                            chapterall_id.push(dataReason[i].chapter_no);
	                                          }
	
	                                          chapterAll = chapterall_id;
	                                          data = {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            chapterAll: ['' + (_this.state.radio_checked_reasoning + 1)],
	                                            questionquize: parseInt(question_length_val),
	                                            priority: _this.state.radio_checked_priority,
	                                            // reasoning: chapterAll.length
	                                            //   ? chapterAll[0] === '1'
	                                            //     ? 'Integrated Reasoning'
	                                            //     : chapterAll[0] === '2'
	                                            //     ? 'Quantitative Reasoning'
	                                            //     : 'Verbal Reasoning'
	                                            //   : 'Verbal Reasoning',
	                                            reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                          };
	
	                                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuizequestion', data).then(function (resp) {
	                                            if (resp.success) {
	                                              var retun_all_chapter = JSON.stringify(resp.chapters);
	                                              var chapterParse = JSON.parse(retun_all_chapter);
	                                              var question_id = [];
	                                              var myJson = {
	                                                question_count: '',
	                                                all_questions: {},
	                                                readings: {},
	                                                cases: {}
	                                              };
	                                              for (var i = 0; i < chapterParse.length; i++) {
	                                                var objName = 'q' + i;
	                                                var objValue = chapterParse[i].id;
	                                                myJson.all_questions[i] = objValue;
	                                                myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
	                                                myJson.cases[i] = chapterParse[i].case_id;
	                                                question_id.push(chapterParse[i].id);
	                                              }
	                                              myJson.question_count = question_id.length;
	                                              var questions = JSON.stringify(myJson);
	                                              var data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                number_questions: myJson.question_count,
	                                                questions: questions,
	                                                timer_value: timer_value
	                                              };
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/createQuiz', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  _this.context.router.push({
	                                                    pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                    //   `/gmat_beforestart/${resp.last_id}/${''}`,
	                                                    // state: {
	                                                    //   token: this.state.token,
	                                                    //   idname: this.state.idname,
	                                                    //   quiz_id: resp.last_id,
	                                                    //   status_send: '',
	                                                    // },
	                                                  });
	                                                } else {
	                                                  //console.log(resp.success);
	                                                }
	                                              });
	                                            } else {
	                                              _this.setState({ display_loader: 'hide_block' });
	                                              (0, _toast.showFailure)(resp.message);
	                                            }
	                                            return resp;
	                                          });
	                                        } else {
	                                          // console.log('else working')
	                                          checkboxes = document.getElementsByName('approve[]');
	                                          i = 0;
	                                          single_clicked_value = [];
	
	                                          if (_this.state.single_clicked_val == '') {
	                                            for (i = 0; i < checkboxes.length; i++) {
	                                              if (checkboxes[i].checked) {
	                                                // console.log(i+'----------'+checkboxes[i].value);
	                                                single_clicked_value.push(checkboxes[i].value);
	                                              }
	                                            }
	
	                                            chapterAll = single_clicked_value;
	                                            // console.log(chapterAll)
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                            };
	
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    // console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          } else {
	                                            chapterAll = _this.state.single_clicked_val;
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning
	                                            };
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    //console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          }
	                                        }
	                                      } else {
	                                        _this.setState({ display_loader: 'hide_block' });
	                                        (0, _toast.showFailure)('Please Upgrade Your Account');
	                                      }
	                                      _context2.next = 13;
	                                      break;
	
	                                    case 11:
	                                      _this.setState({ display_loader: 'hide_block' });
	                                      (0, _toast.showFailure)('Please Upgrade Your Account');
	
	                                    case 13:
	                                    case 'end':
	                                      return _context2.stop();
	                                  }
	                                }
	                              }, _callee2, _this2);
	                            }));
	
	                            return function (_x3) {
	                              return _ref4.apply(this, arguments);
	                            };
	                          }());
	
	                        case 11:
	                          _context4.next = 17;
	                          break;
	
	                        case 13:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, question_length_val, timer_value, chapterAll, dataString, dataReason, chapterall_id, i, data, checkboxes, single_clicked_value;
	                              return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                while (1) {
	                                  switch (_context3.prev = _context3.next) {
	                                    case 0:
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = 'gmat';
	                                      isInArray_var = false;
	                                      _context3.next = 5;
	                                      return _GMATSubscription2.default.checkGMATQuizSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 5:
	                                      isInArray_var = _context3.sent;
	
	                                      console.log('check subscription in gamt sections===>', isInArray_var);
	                                      if (isInArray_var) {
	                                        question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                                        chapterAll = '';
	
	                                        timer_value = _this.state.quiz_length_state[_this.state.radio_checked_question].timer_value;
	                                        if (_this.state.all_checked_state) {
	                                          // console.log('if	 working')
	                                          dataString = JSON.stringify(_this.state.chapters);
	                                          dataReason = JSON.parse(dataString);
	                                          chapterall_id = [];
	
	                                          for (i = 0; i < dataReason.length; i++) {
	                                            chapterall_id.push(dataReason[i].chapter_no);
	                                          }
	
	                                          chapterAll = chapterall_id;
	                                          data = {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            chapterAll: ['' + (_this.state.radio_checked_reasoning + 1)],
	                                            questionquize: parseInt(question_length_val),
	                                            priority: _this.state.radio_checked_priority,
	                                            // reasoning: chapterAll.length
	                                            //   ? chapterAll[0] === '1'
	                                            //     ? 'Integrated Reasoning'
	                                            //     : chapterAll[0] === '2'
	                                            //     ? 'Quantitative Reasoning'
	                                            //     : 'Verbal Reasoning'
	                                            //   : 'Verbal Reasoning',
	                                            reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                          };
	
	                                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuizequestion', data).then(function (resp) {
	                                            if (resp.success) {
	                                              var retun_all_chapter = JSON.stringify(resp.chapters);
	                                              var chapterParse = JSON.parse(retun_all_chapter);
	                                              var question_id = [];
	                                              var myJson = {
	                                                question_count: '',
	                                                all_questions: {},
	                                                readings: {},
	                                                cases: {}
	                                              };
	                                              for (var i = 0; i < chapterParse.length; i++) {
	                                                var objName = 'q' + i;
	                                                var objValue = chapterParse[i].id;
	                                                myJson.all_questions[i] = objValue;
	                                                myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
	                                                myJson.cases[i] = chapterParse[i].case_id;
	                                                question_id.push(chapterParse[i].id);
	                                              }
	                                              myJson.question_count = question_id.length;
	                                              var questions = JSON.stringify(myJson);
	                                              var data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                number_questions: myJson.question_count,
	                                                questions: questions,
	                                                timer_value: timer_value
	                                              };
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/createQuiz', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  _this.context.router.push({
	                                                    pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                    //   `/gmat_beforestart/${resp.last_id}/${''}`,
	                                                    // state: {
	                                                    //   token: this.state.token,
	                                                    //   idname: this.state.idname,
	                                                    //   quiz_id: resp.last_id,
	                                                    //   status_send: '',
	                                                    // },
	                                                  });
	                                                } else {
	                                                  //console.log(resp.success);
	                                                }
	                                              });
	                                            } else {
	                                              _this.setState({ display_loader: 'hide_block' });
	                                              (0, _toast.showFailure)(resp.message);
	                                            }
	                                            return resp;
	                                          });
	                                        } else {
	                                          // console.log('else working')
	                                          checkboxes = document.getElementsByName('approve[]');
	                                          i = 0;
	                                          single_clicked_value = [];
	
	                                          if (_this.state.single_clicked_val == '') {
	                                            for (i = 0; i < checkboxes.length; i++) {
	                                              if (checkboxes[i].checked) {
	                                                // console.log(i+'----------'+checkboxes[i].value);
	                                                single_clicked_value.push(checkboxes[i].value);
	                                              }
	                                            }
	
	                                            chapterAll = single_clicked_value;
	                                            // console.log(chapterAll)
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                            };
	
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    // console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          } else {
	                                            chapterAll = _this.state.single_clicked_val;
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning
	                                            };
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    //console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          }
	                                        }
	                                      } else {
	                                        _this.setState({ display_loader: 'hide_block' });
	                                        (0, _toast.showFailure)('Please Upgrade Your Account');
	                                      }
	
	                                    case 8:
	                                    case 'end':
	                                      return _context3.stop();
	                                  }
	                                }
	                              }, _callee3, _this2);
	                            }));
	
	                            return function (_x4) {
	                              return _ref5.apply(this, arguments);
	                            };
	                          }());
	
	                        case 17:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context6.next = 4;
	                              break;
	                            }
	
	                            _context6.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      token: '',
	      idname: '',
	      chapters: [{
	        chapter_no: 1,
	        chapter_name: 'Integrated Reasoning'
	      }, {
	        chapter_no: 2,
	        chapter_name: 'Quantitative Reasoning'
	      }, {
	        chapter_no: 3,
	        chapter_name: 'Verbal Reasoning'
	      }],
	      all_checked_state: true,
	      radio_checked_question: 0,
	      deleteItemId: '',
	      radio_checked_priority: 'none',
	      radio_checked_reasoning: 0,
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reasoning: this.state.radio_checked_reasoning
	      };
	
	      this.abandonedQuizzes(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        // console.log(resp_quiz_length.quiz_length);
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this3.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	  }, {
	    key: '_single_Checked',
	    value: function _single_Checked(items, index_value, e) {
	      var _this4 = this;
	
	      this.setState({ radio_checked_reasoning: index_value });
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reasoning: index_value
	      };
	      console.log('I am inside single checked');
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_quizes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        if (resp_quiz_length.success) {
	          _this4.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this4.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	
	    /*_changeIncludetimer(){
	      if(this.state.include_timer)
	      {
	        this.setState({ include_timer:!this.state.include_timer });
	      }
	      else{
	        this.setState({ include_timer:!this.state.include_timer });
	      }    	
	    }*/
	
	    /*_changeSaveresult(){
	      if(this.state.save_results)
	      {
	        this.setState({ save_results:!this.state.save_results });
	      }
	      else{
	        this.setState({ save_results:!this.state.save_results });
	      }    
	    }*/
	
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', items.id).replace(':status_send', 'abondon')
	
	        //   `/gmat_beforestart/${items.id}/${'abondon'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: items.id,
	        //   status_send: 'abondon',
	        // },
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', items.id).replace(':status_send', 'completed')
	
	        //   `/gmat_beforestart/${items.id}/${'completed'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: items.id,
	        //   status_send: 'completed',
	        // },
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'radio_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                // type='checkbox'
	                type: 'radio',
	                name: 'approve[]',
	                value: items.chapter_no,
	                checked: _this5.state.radio_checked_reasoning == index,
	                onClick: _this5._single_Checked.bind(_this5, items, index)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkAbondon.bind(_this5, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkCompleted.bind(_this5, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question == index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().CFA_LEVEL_I_QUIZZES
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._createQuiz.bind(this) },
	              ' ',
	              _language2.default.LC().CREATE_QUIZ,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().CONTENT
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    chapter_data
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().ABANDONED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        abandoned_data
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().Priorities_By,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().NONE,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'none',
	                      name: 'none',
	                      value: 'none',
	                      checked: this.state.radio_checked_priority == 'none',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    _language2.default.LC().UNANSWERED,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unanswered',
	                      name: 'mark_unanswered',
	                      value: 'unanswered',
	                      checked: this.state.radio_checked_priority == 'unanswered',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().Wrong_answers,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unattempted',
	                      name: 'mark_unattempted',
	                      value: 'wrongquestion',
	                      checked: this.state.radio_checked_priority == 'wrongquestion',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().LENGTH,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  quiz_length_state_data
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().COMPLETED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        getallcompleteQuiz_data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Quizzes;
	}(_react.Component);
	
	Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Quizzes;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(296);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var ChatperwiseReadingData = function (_Component) {
	  _inherits(ChatperwiseReadingData, _Component);
	
	  function ChatperwiseReadingData(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee5(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _this.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this.state.user_city,
	                    country: _this.state.user_country,
	                    state: _this.state.user_state,
	                    continent: _this.state.user_continent,
	                    ip: _this.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserVideowatch', data).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                      return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              if (resp.success) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _data = { token: _this.state.token, idname: _this.state.idname };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this.toggleAlert();
	                      } else {
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data2;
	
	                            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                              while (1) {
	                                switch (_context3.prev = _context3.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context3.next = 10;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context3.next = 6;
	                                    return _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                  case 6:
	                                    isInArray_var = _context3.sent;
	
	                                    if (isInArray_var) {
	                                      _data2 = {
	                                        token: _this.state.token,
	                                        idname: _this.state.idname,
	                                        id: chapter.id,
	                                        videoIndex: index,
	                                        city: _this.state.user_city,
	                                        country: _this.state.user_country,
	                                        state: _this.state.user_state,
	                                        continent: _this.state.user_continent,
	                                        ip: _this.state.user_ip
	                                      };
	
	                                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserVideowatch', _data2).then(function () {
	                                        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                                          return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                            while (1) {
	                                              switch (_context2.prev = _context2.next) {
	                                                case 0:
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                                    });
	                                                  } else {}
	
	                                                case 1:
	                                                case 'end':
	                                                  return _context2.stop();
	                                              }
	                                            }
	                                          }, _callee2, _this2);
	                                        }));
	
	                                        return function (_x5) {
	                                          return _ref4.apply(this, arguments);
	                                        };
	                                      }());
	                                    } else {
	                                      _this.toggleAlert();
	                                    }
	                                    _context3.next = 10;
	                                    break;
	
	                                  case 10:
	                                  case 'end':
	                                    return _context3.stop();
	                                }
	                              }
	                            }, _callee3, _this2);
	                          }));
	
	                          return function (_x4) {
	                            return _ref3.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      // console.log('heyyyyyyyyyyyyyy===============');
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                        // console.log('aaaaaaaaaaaaaaaa');
	                        return _this.toggleAlert();
	                      } else {
	                        // console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbbbb');
	                        var exam_selected = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : resp.profileInfo.exam_selected;
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	                        // console.log('else working');
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          // console.log(
	                          //   resp_exam,
	                          //   '00000000000000000000000000000000000000000'
	                          // );
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            var selectedmen = _this.state.selectedmenu;
	                            var isInArray_var = false;
	                            isInArray_var = _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                            // console.log(isInArray_var, selectedmen, exam_data);
	                            if (isInArray_var) {
	                              // console.log('IF WORKING');
	
	                              var _data3 = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                id: chapter.id,
	                                videoIndex: index,
	                                city: _this.state.user_city,
	                                country: _this.state.user_country,
	                                state: _this.state.user_state,
	                                continent: _this.state.user_continent,
	                                ip: _this.state.user_ip
	                              };
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserVideowatch', _data3).then(function () {
	                                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                    while (1) {
	                                      switch (_context4.prev = _context4.next) {
	                                        case 0:
	                                          if (resp.success) {
	                                            _this.context.router.push({
	                                              pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                            });
	                                          } else {}
	
	                                        case 1:
	                                        case 'end':
	                                          return _context4.stop();
	                                      }
	                                    }
	                                  }, _callee4, _this2);
	                                }));
	
	                                return function (_x6) {
	                                  return _ref5.apply(this, arguments);
	                                };
	                              }());
	                            } else {
	                              // console.log('ELSE WORKING')
	                              return _this.toggleAlert();
	                            }
	                          } else {
	                            // console.log('fail');
	                          }
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(chapter, index) {
	        var _this$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this$state = _this.state, token = _this$state.token, idname = _this$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  videoIndex: index
	                };
	                _context6.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x7, _x8) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	
	    _this.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	
	      if (_this.state.allchapters.length) {
	        data = _this.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq === '' ? _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this._getReadings.bind(_this, item, index),
	              className: 'pointer_class slider_row'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: '\n        https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-' + item.url_id_qq + '-1.jpg',
	              value: index,
	              onClick: _this._getReadings.bind(_this, item, index),
	              className: 'pointer_class slider_row'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this$state2, 'offset', 0), _defineProperty(_this$state2, 'limit', 10), _defineProperty(_this$state2, 'Allchapters', []), _defineProperty(_this$state2, 'itemData', []), _defineProperty(_this$state2, 'videoUrl', ''), _defineProperty(_this$state2, 'srcUrl', ''), _defineProperty(_this$state2, 'srcUrl_final', ''), _defineProperty(_this$state2, 'selectedmenu', 'gmat'), _defineProperty(_this$state2, 'showFreePremium', true), _defineProperty(_this$state2, 'user_city', ''), _defineProperty(_this$state2, 'user_country', ''), _defineProperty(_this$state2, 'user_ip', ''), _defineProperty(_this$state2, 'user_state', ''), _defineProperty(_this$state2, 'user_continent', ''), _this$state2);
	    return _this;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var result, storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context7.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context7.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATVideosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this3.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this3.setState({ allchapters: [] });
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	exports.default = ChatperwiseReadingData;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	__webpack_require__(296);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _ChatperwiseReadingData = __webpack_require__(819);
	
	var _ChatperwiseReadingData2 = _interopRequireDefault(_ChatperwiseReadingData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var GMATVideoLessons = function (_Component) {
	  _inherits(GMATVideoLessons, _Component);
	
	  function GMATVideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATVideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (GMATVideoLessons.__proto__ || Object.getPrototypeOf(GMATVideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATVideosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', resp.cfavchapterfirst.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.cfavchapterfirst.chapter_id).replace(':index', 0)
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', lastRecord.gmat_video.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', lastRecord.gmat_video.chapter_id === 0 ? 0 : 1).replace(':chapter_id', lastRecord.gmat_video.chapter_id).replace(':index', lastRecord.videoIndex)
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'gmat',
	      exams: [],
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      lastAttempt: false,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(GMATVideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this3);
	                              }));
	
	                              return function (_x5) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context6.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context6.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context6.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  // console.log('ELSE WORKING')
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this3);
	                  }));
	
	                  return function (_x4) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    // console.log(resp.exams[0])
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ chapters: resp.cfavideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 11:
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getlastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 14:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      // console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  ' ',
	                  item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement(
	                  'p',
	                  { className: 'text-danger font-weight-bold font-16px text-center' },
	                  'Coming Soon ...'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(_ChatperwiseReadingData2.default, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement('div', { className: 'card' })
	                  ),
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent
	          })
	        )
	      );
	    }
	  }]);
	
	  return GMATVideoLessons;
	}(_react.Component);
	
	GMATVideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	exports.default = GMATVideoLessons;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1010);
	
	var _GMATSubscription = __webpack_require__(76);
	
	var _GMATSubscription2 = _interopRequireDefault(_GMATSubscription);
	
	var _GMATSubscription3 = __webpack_require__(78);
	
	var _GMATSubscription4 = _interopRequireDefault(_GMATSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactstrap = __webpack_require__(6);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _toast = __webpack_require__(15);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var GMATvideodisplay = function (_Component) {
	  _inherits(GMATvideodisplay, _Component);
	
	  function GMATvideodisplay(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, GMATvideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (GMATvideodisplay.__proto__ || Object.getPrototypeOf(GMATvideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserVideowatch', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      // console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment,
	        videoIndex: _this.state.currentUrl,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveComment = function (id) {
	      // console.log('_saveComment');
	      if (document.getElementById('ques_comment').value === '') {
	        return;
	      }
	      var comment = document.getElementById('ques_comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoSaveComment', data).then(function (resp) {
	        // console.log(resp);
	
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          // console.log(params);
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetComments', params).then(function (response) {
	            // console.log(response);
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                var comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().BY,
	                      ' ',
	                      items.username,
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                var comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              var comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editComment = function (item, e) {
	      document.getElementById('ques_comment').value = item.comment;
	      _this.setState({ comment_update: 'btn btn-primary active pointer_class' });
	      _this.setState({ comment_save: 'hide_block' });
	      _this.setState({ comment_update_id: item.id });
	    };
	
	    _this._updateComment = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(id) {
	        var comment, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(document.getElementById('ques_comment').value == '')) {
	                  _context4.next = 2;
	                  break;
	                }
	
	                return _context4.abrupt('return');
	
	              case 2:
	                comment = document.getElementById('ques_comment').value;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  comment_id: _this.state.comment_update_id,
	                  comment: comment
	                };
	                _context4.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoUpdateComment', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var params;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context3.next = 12;
	                              break;
	                            }
	
	                            // console.log('if working');
	                            _this.setState({ ValidToken: true });
	                            document.getElementById('ques_comment').value = '';
	                            _this.setState({ comment_update: 'hide_block' });
	                            _this.setState({ comment_save: 'btn btn-primary active pointer_class' });
	                            _this.setState({ comment_update_id: '' });
	                            document.getElementById('ques_comment').value = '';
	                            params = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              video_id: id
	                            };
	                            // console.log(params);
	
	                            _context3.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetComments', params).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(response) {
	                                var comments;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        // console.log('getComments');
	                                        // console.log(response);
	                                        if (response.success) {
	                                          _this.setState({ ValidToken: true });
	
	                                          if (response.comments.length > 0) {
	                                            // console.log('IF working');
	                                            comments = response.comments.map(function (items, index) {
	                                              return _react2.default.createElement(
	                                                'li',
	                                                { key: index },
	                                                response.user_id == items.uid ? _react2.default.createElement(
	                                                  'ul',
	                                                  { className: 'icon_list' },
	                                                  _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                      'a',
	                                                      {
	                                                        className: 'pointer_class',
	                                                        onClick: _this._editComment.bind(_this, items)
	                                                      },
	                                                      _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                                    )
	                                                  ),
	                                                  _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                      'a',
	                                                      {
	                                                        className: 'pointer_class',
	                                                        onClick: _this._deleteComment.bind(_this, items)
	                                                      },
	                                                      _react2.default.createElement('i', { className: 'fa fa-close' })
	                                                    )
	                                                  )
	                                                ) : _react2.default.createElement('ul', null),
	                                                _react2.default.createElement(
	                                                  'h4',
	                                                  null,
	                                                  'By ',
	                                                  items.username,
	                                                  ' ',
	                                                  new Date(items.createdAt).toDateString()
	                                                ),
	                                                _react2.default.createElement(
	                                                  'p',
	                                                  null,
	                                                  items.comment
	                                                )
	                                              );
	                                            });
	
	                                            _this.setState({ comment_data: comments });
	                                          } else {
	                                            // console.log('ELSE working');
	                                            comments = _react2.default.createElement(
	                                              'p',
	                                              null,
	                                              _language2.default.LC().NO_COMMENTS_FOUND
	                                            );
	
	                                            _this.setState({ comment_data: comments });
	                                          }
	                                        } else {
	                                          comments = _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            _language2.default.LC().NO_COMMENTS_FOUND
	                                          );
	
	                                          _this.setState({ comment_data: comments });
	                                          _this.setState({ ValidToken: false });
	                                        }
	                                        return _context2.abrupt('return', response);
	
	                                      case 2:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 10:
	                            _context3.next = 13;
	                            break;
	
	                          case 12:
	                            _this.setState({ ValidToken: false });
	
	                          case 13:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x4) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }()
	                /// return resp;
	                );
	
	              case 6:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this._deleteComment = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        comment: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoDeleteComment', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('ques_comment').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: item.video_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetComments', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.comments.length > 0) {
	                var comments = response.comments.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    response.user_id == items.uid ? _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._editComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this._deleteComment.bind(_this, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ) : _react2.default.createElement('ul', null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'By ',
	                      items.username,
	                      ' ',
	                      new Date(items.createdAt).toDateString()
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.comment
	                    )
	                  );
	                });
	                _this.setState({ comment_data: comments });
	              } else {
	                var comments = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_COMMENTS_FOUND
	                );
	                _this.setState({ comment_data: comments });
	              }
	            } else {
	              var comments = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_COMMENTS_FOUND
	              );
	              _this.setState({ comment_data: comments });
	              _this.setState({ ValidToken: false });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._editFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_VIDEO_LESSONS
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context5.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context5.next = 6;
	                        return _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context5.sent;
	
	
	                        if (isInArray_var) {
	                          _this._runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context5.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, _this2);
	              }));
	
	              return function (_x6) {
	                return _ref5.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp, 'sssssssssssssssssssssssss');
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                // console.log('selectedmen--------------------', selectedmen);
	                // console.log('isInArray_var--------------------', isInArray_var);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context6.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)'
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(index, url_id, title, id, url_id_qq, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context9.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file
	                }, function () {
	                  _this.context.router.push({
	                    pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                    // `/cfavideodisplay/${this.props.params.id}/${
	                    //   this.props.params.showFreePremium
	                    // }/${this.props.params.type}/${this.props.params.chapter_id}/${
	                    //   this.state.currentUrl
	                    // }`,
	                  });
	                });
	
	                _context9.next = 4;
	                return _this.savelastVideo(id, index);
	
	              case 4:
	                _context9.next = 6;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 6:
	                _context9.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee7$(_context7) {
	                            while (1) {
	                              switch (_context7.prev = _context7.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context7.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context7.next = 6;
	                                  return _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context7.sent;
	
	                                  if (!isInArray_var) {
	                                    _context7.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                                      // `/cfavideodisplay/${this.props.params.id}/${
	                                      //   this.props.params.showFreePremium
	                                      // }/${this.props.params.type}/${
	                                      //   this.props.params.chapter_id
	                                      // }/${this.state.currentUrl}`,
	                                    });
	                                  });
	                                  _context7.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context7.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context7.abrupt('return');
	
	                                case 16:
	                                  return _context7.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context7.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context7.stop();
	                              }
	                            }
	                          }, _callee7, _this2);
	                        }));
	
	                        return function (_x15) {
	                          return _ref8.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                      // console.log("if working");
	
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee8$(_context8) {
	                            while (1) {
	                              switch (_context8.prev = _context8.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context8.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context8.next = 6;
	                                  return _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context8.sent;
	
	                                  if (!isInArray_var) {
	                                    _context8.next = 16;
	                                    break;
	                                  }
	
	                                  // console.log('IF WORKING')
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                                      // `/cfavideodisplay/${this.props.params.id}/${
	                                      //   this.props.params.showFreePremium
	                                      // }/${this.props.params.type}/${
	                                      //   this.props.params.chapter_id
	                                      // }/${this.state.currentUrl}`,
	                                    });
	                                  });
	                                  _context8.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context8.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context8.abrupt('return');
	
	                                case 16:
	                                  return _context8.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context8.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context8.stop();
	                              }
	                            }
	                          }, _callee8, _this2);
	                        }));
	
	                        return function (_x16) {
	                          return _ref9.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x8, _x9, _x10, _x11, _x12, _x13, _x14) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(id, index) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context10.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x17, _x18) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      // console.log('_saveFavVideo', item);
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state3 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state3, 'MessageTitle', messageTitle_cfa), _defineProperty(_this$state3, 'MessageContent', _alertMessage2.default.messageContent_gmat), _defineProperty(_this$state3, 'token', ''), _defineProperty(_this$state3, 'idname', ''), _defineProperty(_this$state3, 'ValidToken', false), _defineProperty(_this$state3, 'all_questions', ''), _defineProperty(_this$state3, 'chapters', []), _defineProperty(_this$state3, 'all_questions_state', []), _defineProperty(_this$state3, 'video_display', ''), _defineProperty(_this$state3, 'video_display_qq', ''), _defineProperty(_this$state3, 'url_id', ''), _defineProperty(_this$state3, 'currentUrl', ''), _defineProperty(_this$state3, 'reportLoading', false), _defineProperty(_this$state3, 'free', ''), _defineProperty(_this$state3, 'video_title', ''), _defineProperty(_this$state3, 'video_display_no', ''), _defineProperty(_this$state3, 'allChapters', []), _defineProperty(_this$state3, 'Chapter_Title', ''), _defineProperty(_this$state3, 'chapterName', ''), _defineProperty(_this$state3, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state3, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state3, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state3, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state3, 'currentReading', _this.props.params.id), _defineProperty(_this$state3, 'comment_update_id', ''), _defineProperty(_this$state3, 'currentChapterNo', ''), _defineProperty(_this$state3, 'currentReadingNo', ''), _defineProperty(_this$state3, 'currentReadingTitle', ''), _defineProperty(_this$state3, 'subscriptionstatus', ''), _defineProperty(_this$state3, 'selectedmenu', 'gmat'), _defineProperty(_this$state3, 'subscription_details_for_isActive', ''), _defineProperty(_this$state3, 'pdfData', []), _defineProperty(_this$state3, 'pdf_file', ''), _defineProperty(_this$state3, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state3, 'userType', ''), _defineProperty(_this$state3, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state3, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state3, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state3, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state3, 'bookmarkColor', ''), _defineProperty(_this$state3, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _this$state3);
	    return _this;
	  }
	
	  _createClass(GMATvideodisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
	      // const result = getDeviceDetails();
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	      this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium).replace(':type', this.props.params.type).replace(':chapter_id', this.props.params.chapter_id).replace(':index', this.state.currentUrl + 1)
	
	        // `/cfavideodisplay/${this.props.params.id}/${
	        //   this.props.params.showFreePremium
	        // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
	        //   .currentUrl + 1}`,
	      });
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        // if (this.state.currentUrl || this.state.currentUrl) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("_goToPreviousReading-tooogle");
	              return _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    // console.log('IF WORKING')
	                    // console.log("_goToPreviousReading Premium");
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      // console.log('currentUrl', this.state.currentUrl);
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      this.context.router.push({
	        pathname: _AppRoutes2.default.GMAT_VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium).replace(':type', this.props.params.type).replace(':chapter_id', this.props.params.chapter_id).replace(':index', this.state.currentUrl + 1)
	
	        // `/cfavideodisplay/${this.props.params.id}/${
	        //   this.props.params.showFreePremium
	        // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
	        //   .currentUrl + 1}`,
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context11.next = 16;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this4.state.selectedmenu;
	                          isInArray_var = false;
	                          _context11.next = 6;
	                          return _GMATSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                        case 6:
	                          isInArray_var = _context11.sent;
	
	                          if (!isInArray_var) {
	                            _context11.next = 13;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({
	                              video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                            });
	                            _this4.setState({
	                              video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                            });
	                            _this4.setState({
	                              video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                            });
	                            _this4.setState({
	                              currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                            });
	                            _this4.setState({
	                              currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                            });
	                            _this4.setState({
	                              currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                            });
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context11.abrupt('return');
	
	                        case 13:
	                          return _context11.abrupt('return', _this4.toggleAlert());
	
	                        case 14:
	                          _context11.next = 17;
	                          break;
	
	                        case 16:
	                          console.log('fail');
	
	                        case 17:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this4);
	                }));
	
	                return function (_x19) {
	                  return _ref11.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("working");
	              // console.log("_goToNextReading toggleAlert");
	
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _GMATSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    // console.log("_goToNextReading Premium");
	
	                    // console.log('IF WORKING')
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to save comment And display new comment
	
	
	    //Function to Edit particular comment
	
	
	    //Function to Update Comment
	
	
	    //Function to delete particular comment
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      // console.log('hiyuuuuuuuuu', subscriptionstatus);
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getQuestions', data).then(function (resp) {
	        // console.log('resp');
	        if (resp && resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: _AppRoutes2.default.GMAT_QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this5.state.currentChapterNo).replace(':id', _this5.state.currentReadingNo).replace(':subscriptionstatus', _this5.state.subscriptionstatus).replace(':reading', _this5.state.currentReadingTitle)
	            });
	          } else {
	            (0, _toast.showFailure)('No questions found');
	          }
	        } else {
	          _this5.toggleAlert();
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(prevProps, prevState) {
	        var _this6 = this;
	
	        var params;
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context13.next = 9;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context13.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                _context13.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetComments', params).then(function () {
	                  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(response) {
	                    var comments;
	                    return _regenerator2.default.wrap(function _callee12$(_context12) {
	                      while (1) {
	                        switch (_context12.prev = _context12.next) {
	                          case 0:
	                            comments = '';
	
	                            if (response.success) {
	                              _this6.setState({ ValidToken: true });
	                              if (response.comments.length > 0) {
	                                comments = response.comments.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    response.user_id == items.uid ? _react2.default.createElement(
	                                      'ul',
	                                      { className: 'icon_list' },
	                                      _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                          'a',
	                                          { className: 'pointer_class', onClick: _this6._editComment.bind(_this6, items) },
	                                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                          'a',
	                                          {
	                                            className: 'pointer_class',
	                                            onClick: _this6._deleteComment.bind(_this6, items)
	                                          },
	                                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                                        )
	                                      )
	                                    ) : _react2.default.createElement('ul', null),
	                                    _react2.default.createElement(
	                                      'h4',
	                                      null,
	                                      _language2.default.LC().BY,
	                                      ' ',
	                                      items.username,
	                                      ' ',
	                                      new Date(items.createdAt).toDateString()
	                                    ),
	                                    _react2.default.createElement(
	                                      'p',
	                                      null,
	                                      items.comment
	                                    )
	                                  );
	                                });
	
	                                _this6.setState({ comment_data: comments });
	                              } else {
	                                comments = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_COMMENTS_FOUND
	                                );
	                                _this6.setState({ comment_data: comments });
	                              }
	                            } else {
	                              comments = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_COMMENTS_FOUND
	                              );
	                              _this6.setState({ comment_data: comments });
	                              _this6.setState({ ValidToken: false });
	                            }
	                            return _context12.abrupt('return', response);
	
	                          case 3:
	                          case 'end':
	                            return _context12.stop();
	                        }
	                      }
	                    }, _callee12, _this6);
	                  }));
	
	                  return function (_x22) {
	                    return _ref13.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context13.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._deleteFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({ ValidToken: false });
	                    _this6.setState({ flash_data: flash_cards });
	                    _this6.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 9:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, this);
	      }));
	
	      function componentDidUpdate(_x20, _x21) {
	        return _ref12.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	        var _this7 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context15.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context15.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  // console.log('IF Working');
	                  this.setState({
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id !== ':chapter_id' ? this.props.params.chapter_id : this.props.params.id
	                };
	                // console.log('this.propsssssssssssssss', this.props);
	
	                _context15.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATVideosChapterwise', data).then(function () {
	                  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(resp) {
	                    return _regenerator2.default.wrap(function _callee14$(_context14) {
	                      while (1) {
	                        switch (_context14.prev = _context14.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context14.next = 28;
	                              break;
	                            }
	
	                            _context14.next = 3;
	                            return _this7.setState({ ValidToken: true });
	
	                          case 3:
	                            _context14.next = 5;
	                            return _this7.setState({ chapters: resp.cfavchapter });
	
	                          case 5:
	                            if (!(_this7.state.chapters && _this7.state.chapters.length && _this7.state.chapters[_this7.state.currentUrl])) {
	                              _context14.next = 26;
	                              break;
	                            }
	
	                            _context14.next = 8;
	                            return _this7.setState({
	                              pdf_file: _this7.state.chapters[_this7.state.currentUrl] && _this7.state.chapters[_this7.state.currentUrl].pdf_file ? _this7.state.chapters[_this7.state.currentUrl].pdf_file : null
	                            });
	
	                          case 8:
	                            _context14.next = 10;
	                            return _this7.setState({
	                              currentReading: _this7.state.chapters[_this7.state.currentUrl].id
	                            });
	
	                          case 10:
	                            _context14.next = 12;
	                            return _this7.setState({
	                              video_display: _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 12:
	                            _context14.next = 14;
	                            return _this7.setState({
	                              video_display_qq: _this7.state.chapters[_this7.state.currentUrl].url_id_qq
	                            });
	
	                          case 14:
	                            _context14.next = 16;
	                            return _this7.setState({
	                              video_display_previous: _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 16:
	                            _context14.next = 18;
	                            return _this7.setState({
	                              video_title: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 18:
	                            _context14.next = 20;
	                            return _this7.setState({
	                              video_display_next: _this7.state.chapters[_this7.state.currentUrl + 1] ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 20:
	                            _context14.next = 22;
	                            return _this7.setState({
	                              currentChapterNo: _this7.state.chapters[_this7.state.currentUrl].chapter_id
	                            });
	
	                          case 22:
	                            _context14.next = 24;
	                            return _this7.setState({
	                              currentReadingNo: _this7.state.chapters[_this7.state.currentUrl].reading_no
	                            });
	
	                          case 24:
	                            _context14.next = 26;
	                            return _this7.setState({
	                              currentReadingTitle: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 26:
	                            _context14.next = 29;
	                            break;
	
	                          case 28:
	                            _this7.setState({ ValidToken: false });
	
	                          case 29:
	                            return _context14.abrupt('return', resp);
	
	                          case 30:
	                          case 'end':
	                            return _context14.stop();
	                        }
	                      }
	                    }, _callee14, _this7);
	                  }));
	
	                  return function (_x23) {
	                    return _ref15.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context15.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getGMATVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ ValidToken: true });
	                    _this7.setState({ allChapters: resp.cfavideo });
	                    _this7.props.params.chapter_id === undefined ? null : _this7.setState({
	                      Chapter_Title: resp.cfavideo && resp.cfavideo[_this7.props.params.chapter_id - 1] && resp.cfavideo[_this7.props.params.chapter_id - 1].chapter_name ? resp.cfavideo[_this7.props.params.chapter_id - 1].chapter_name : ''
	                    });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 16:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context15.next = 19;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 19:
	                _context15.next = 21;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetComments', params).then(function (response) {
	                  var comments = '';
	                  if (response.success) {
	                    _this7.setState({ ValidToken: true });
	                    if (response.comments.length > 0) {
	                      comments = response.comments.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          response.user_id == items.uid ? _react2.default.createElement(
	                            'ul',
	                            { className: 'icon_list' },
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { className: 'pointer_class', onClick: _this7._editComment.bind(_this7, items) },
	                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'li',
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                { className: 'pointer_class', onClick: _this7._deleteComment.bind(_this7, items) },
	                                _react2.default.createElement('i', { className: 'fa fa-close' })
	                              )
	                            )
	                          ) : _react2.default.createElement('ul', null),
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            _language2.default.LC().BY,
	                            ' ',
	                            items.username,
	                            ' ',
	                            new Date(items.createdAt).toDateString()
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.comment
	                          )
	                        );
	                      });
	
	                      _this7.setState({ comment_data: comments });
	                    } else {
	                      comments = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_COMMENTS_FOUND
	                      );
	                      _this7.setState({ comment_data: comments });
	                    }
	                  } else {
	                    comments = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_COMMENTS_FOUND
	                    );
	                    _this7.setState({ comment_data: comments });
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return response;
	                });
	
	              case 21:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context15.next = 24;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this7.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._editFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._deleteFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this7.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this7.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this7.setState({ ValidToken: false });
	                    _this7.setState({ flash_data: flash_cards });
	                    _this7.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 24:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context15.next = 27;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat_question_bank/getgmat_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ pdfData: resp });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 27:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, this);
	      }));
	
	      function componentDidMount() {
	        return _ref14.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          type = _state.type;
	
	
	      var chapters = this.state.chapters;
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this8.state.showFreePremium ? item.free === 1 || type === 'intro' ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id === _this8.state.video_display ? 'active' : '',
	                    onClick: _this8.getVideourl.bind(_this8, index, item.url_id, item.title, item.id, item.url_id_qq, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'mb-0' },
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq === '' ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	
	                        //controls={false}
	                        // showinfo={0}
	                        // autohide={1}
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        width: '100%',
	                        allowFullScreen: '1',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: '//ljsp.lwcdn.com/api/video/embed.jsp?id=' + this.state.video_display_qq + '&pi=080de783-b4bf-4b42-ac09-e782c8a907ef',
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        frameBorder: '0',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(_VideoValidateReportIcons2.default, {
	                moveToNotes: this.moveToNotes
	                // notesCSS={this.state.notesCSS}
	                , moveToPracticeQuestions: this.moveToPracticeQuestions,
	                _saveFavVideo: this._saveFavVideo,
	                _displayReportForm: this._displayReportForm,
	                pdfOpen: this.pdfOpen,
	                noPDFInExam: this.state.pdf_file ? false : true,
	                bookmarkCSS: this.state.bookmarkCSS,
	                bookmarkColor: this.state.bookmarkColor,
	                type: this.state.type,
	                questionsCSS: this.state.questionsCSS,
	                saveVideo_text: this.state.saveVideo_text,
	                currentReading: this.state.currentReading,
	                chapters: this.state.chapters,
	                showFreePremium: this.state.showFreePremium
	              })
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 d-none' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'card-header pointer_class',
	                      onClick: this._getToggleFlash.bind()
	                    },
	                    _language2.default.LC().FLASHCARD,
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'float-right text-right' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/arrow_down_ico.png', alt: '' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' }, ref: 'flash_toggle_div' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-12 col-sm-12 col-md-12' },
	                          _react2.default.createElement(
	                            'ul',
	                            { className: 'comment_list_wrapper' },
	                            this.state.flash_data
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: this.state.flash_form },
	                          _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement('textarea', {
	                              id: 'flash_card',
	                              name: 'flash_card',
	                              rows: '6',
	                              className: 'form-control margin_bottom_10',
	                              placeholder: 'Your flash card here'
	                            }),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                type: 'button',
	                                className: 'btn btn-primary active pointer_class',
	                                onClick: this._saveFlashCard.bind(this, this.state.currentReading)
	                              },
	                              _language2.default.LC().CREATE
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              '*',
	                              _language2.default.LC().FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATvideodisplay;
	}(_react.Component);
	
	GMATvideodisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.resizeListener = function () {
	      // write code here
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	    };
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	        var _this10 = this;
	
	        return _regenerator2.default.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context16.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this10.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, this);
	      }));
	
	      function componentDidMount() {
	        return _ref16.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATvideodisplay;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(79);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iterator = '';
	/* eslint-disable */
	
	var GMATDashboard = function (_Component) {
	  _inherits(GMATDashboard, _Component);
	
	  function GMATDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATDashboard);
	
	    var _this = _possibleConstructorReturn(this, (GMATDashboard.__proto__ || Object.getPrototypeOf(GMATDashboard)).call(this, props));
	
	    _this.deleteFlashCard = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(type, id, question_type) {
	        var _this$state, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, id_name = _this$state.idname, token = _this$state.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: question_type,
	                  exam: 'gmat_focus',
	                  level: '',
	                  item_id: id
	                };
	                _context.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onContactSubmit = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(event) {
	        var _this$state2, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context3.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context3.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context3.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state2 = _this.state, idname = _this$state2.idname, token = _this$state2.token, contactComment = _this$state2.contactComment, contactSubject = _this$state2.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context3.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context2.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x5) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.handleToggle = function (event) {
	      var checked = event.target.checked;
	
	      _this.setState({ toggle: checked }, function () {
	        // console.log('type', checked, this.state.toggle);
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          type: checked ? 'content-type' : 'content-format',
	          startDate: _this.state.send_startDate,
	          endDate: _this.state.send_startDate_second
	        };
	        // FD.callAPI(
	        //   App_data.backend_api + '/gmat-focus/dashboard/getQuestionType',
	        //   data
	        // ).then(async (resp) => {
	        //   // console.log(resp);
	        //   let content_type = [];
	        //   if (resp.success) {
	        //     resp.question_type.map((question) => {
	        //       content_type.push(question.content_type);
	        //     });
	        //     // content_type.push('Integrated Reasoning');
	
	        //     this.setState({ content_type }, () => {
	        //       this.contentTypeReportTabToggle(0);
	        //       this.contentTypeTabToggle(0);
	        //     });
	        //   }
	        // });
	        // FD.callAPI(
	        //   App_data.backend_api + '/gmat-focus/dashboard/mainProgressbar',
	        //   data
	        // ).then((resp) => {
	        //   if (resp.success) {
	        //     var dataString = JSON.stringify(resp.chapters);
	        //     var dataReason = JSON.parse(dataString);
	
	        //     var final_array_main = [];
	
	        //     for (i = 0; i < dataReason.length; i++) {
	        //       var right_answered = dataReason[i].answered_count;
	        //       var total_question = dataReason[i].attempted_count;
	
	        //       var user_graph_val = Math.round(
	        //         (right_answered / total_question) * 100
	        //       ).toFixed(1);
	
	        //       if (user_graph_val === 'NaN') {
	        //         final_array_main.push('0.0');
	        //       } else {
	        //         final_array_main.push(user_graph_val);
	        //       }
	        //     }
	
	        //     this.setState({
	        //       bar_main_user: final_array_main,
	        //       display_main_loader: 'hide_block',
	        //     });
	        //     // console.log('part 22222---------------------', final_array_main);
	        //   } else {
	        //     this.setState({ display_main_loader: 'hide_block' });
	        //   }
	        // });
	        // FD.callAPI(
	        //   App_data.backend_api + '/gmat-focus/dashboard/mainProgressclassbar',
	        //   data
	        // ).then((resp) => {
	        //   if (resp.success) {
	        //     var dataString = JSON.stringify(resp.chaptersclass);
	        //     var dataReason = JSON.parse(dataString);
	        //     var final_array_main = [];
	        //     for (i = 0; i < dataReason.length; i++) {
	        //       var right_answered = dataReason[i].answered_count;
	        //       var total_question = dataReason[i].attempted_count;
	        //       var user_graph_val = Math.round(
	        //         (right_answered / total_question) * 100
	        //       ).toFixed(1);
	
	        //       if (user_graph_val === 'NaN') {
	        //         final_array_main.push('0.0');
	        //       } else {
	        //         final_array_main.push(user_graph_val);
	        //       }
	        //     }
	        //     this.setState({ bar_main_class: final_array_main });
	        //   } else {
	        //     //console.log(resp.success + '------------failure');
	        //   }
	        // });
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getQuestionProgByUser', data).then(function (resp) {
	          if (resp.success) {
	            // this.setState({ progress_bar_zero: resp.progressbarzero_data });
	          } else {
	              //console.log(resp.success + '------------failure');
	            }
	        });
	      });
	    };
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSavequestino = function (items, e) {
	      // console.log('items --------> ', items);
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteSaveVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer == 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: 'Hide Details' });
	      }
	      if (_this.state.show_outer == 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({ more_detail_button: 'I Want More Details' });
	      }
	    };
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var storage_session, _this$state3, toggle, content_type, activeTabReportcards, data;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              _this$state3 = _this.state, toggle = _this$state3.toggle, content_type = _this$state3.content_type, activeTabReportcards = _this$state3.activeTabReportcards;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                // type: toggle
	                //   ? `and content_type = '${
	                //       content_type[activeTabReportcards ? activeTabReportcards : 0]
	                //     }'`
	                //   : `and content_format = '${
	                //       content_type[activeTabReportcards ? activeTabReportcards : 0]
	                //     }'`,
	                type: content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Quant' ? 'and content_type != \'Verbal\'' : 'and content_type = \'' + content_type[activeTabReportcards ? activeTabReportcards : 0] + '\''
	              };
	
	              if (!(content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Integrated Reasoning')) {
	                _context6.next = 9;
	                break;
	              }
	
	              _context6.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/get4typesReportsQuestionsbyuserid', data).then(function () {
	                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestion: resp.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	
	            case 7:
	              _context6.next = 11;
	              break;
	
	            case 9:
	              _context6.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              reportquestion: resp.questions,
	                              reportLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 11:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getQuestionFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var storageRaw, storage_session, idname, token, data, response;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              storageRaw = localStorage.getItem('localstorageval');
	
	              if (storageRaw) {
	                _context7.next = 4;
	                break;
	              }
	
	              _this.setState({ flashLoader: false });
	              return _context7.abrupt('return');
	
	            case 4:
	              storage_session = void 0;
	              _context7.prev = 5;
	
	              storage_session = JSON.parse(storageRaw);
	              _context7.next = 14;
	              break;
	
	            case 9:
	              _context7.prev = 9;
	              _context7.t0 = _context7['catch'](5);
	
	              console.warn('Invalid localstorageval JSON', _context7.t0);
	              _this.setState({ flashLoader: false });
	              return _context7.abrupt('return');
	
	            case 14:
	              idname = storage_session.idname;
	              token = storage_session.token;
	
	              if (!(!idname || !token)) {
	                _context7.next = 19;
	                break;
	              }
	
	              _this.setState({ flashLoader: false });
	              return _context7.abrupt('return');
	
	            case 19:
	
	              _this.setState({
	                idname: idname,
	                token: token
	              });
	
	              data = {
	                token: token,
	                idname: idname,
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context7.prev = 21;
	              _context7.next = 24;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashcardsbyuserid', data);
	
	            case 24:
	              response = _context7.sent;
	
	
	              if (response && response.success) {
	                _this.setState({
	                  flashreport: response.flash_report,
	                  flashLoader: false
	                });
	              } else {
	                _this.setState({ flashLoader: false });
	              }
	              _context7.next = 32;
	              break;
	
	            case 28:
	              _context7.prev = 28;
	              _context7.t1 = _context7['catch'](21);
	
	              console.warn('getQuestionFlashcards error', _context7.t1);
	              _this.setState({ flashLoader: false });
	
	            case 32:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2, [[5, 9], [21, 28]]);
	    }));
	    _this.getQuestionsSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	      var storage_session, _this$state4, content_type, activeTabSavedcards, toggle, data;
	
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              _this$state4 = _this.state, content_type = _this$state4.content_type, activeTabSavedcards = _this$state4.activeTabSavedcards, toggle = _this$state4.toggle;
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second,
	                // type: toggle
	                //   ? `and content_type = '${
	                //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
	                //     }'`
	                //   : `and content_format = '${
	                //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
	                //     }'`,
	                type: content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Quant' ? 'and content_type != \'Verbal\'' : 'and content_type = \'' + content_type[activeTabSavedcards ? activeTabSavedcards : 0] + '\''
	              };
	
	              if (!(content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Integrated Reasoning')) {
	                _context10.next = 9;
	                break;
	              }
	
	              _context10.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/get4typesFavQuestionsbyuserid', data).then(function () {
	                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              savedquestion: resp.questions,
	                              savedLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this2);
	                }));
	
	                return function (_x8) {
	                  return _ref9.apply(this, arguments);
	                };
	              }());
	
	            case 7:
	              _context10.next = 11;
	              break;
	
	            case 9:
	              _context10.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavQuestionsbyuserid', data).then(function () {
	                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({
	                              savedquestion: resp.questions,
	                              savedLoader: false
	                            });
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                }));
	
	                return function (_x9) {
	                  return _ref10.apply(this, arguments);
	                };
	              }());
	
	            case 11:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context12.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x10) {
	                  return _ref12.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context14.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getReportsVideobyuserid', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo: resp.video });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x11) {
	                  return _ref14.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context16.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavVideosbyuserid', data).then(function () {
	                var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(resp) {
	                  return _regenerator2.default.wrap(function _callee15$(_context15) {
	                    while (1) {
	                      switch (_context15.prev = _context15.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savedvideo: resp.cfa_videos });
	                          } else {
	                            //console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context15.stop();
	                      }
	                    }
	                  }, _callee15, _this2);
	                }));
	
	                return function (_x12) {
	                  return _ref16.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	
	    _this._beginChapter = function () {
	      var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(item, e) {
	        var data, routeName, caseId, caseOffset;
	        return _regenerator2.default.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  question_id: item.question_id
	                };
	
	                if (!(item.type !== 'question')) {
	                  _context17.next = 21;
	                  break;
	                }
	
	                routeName = void 0;
	                _context17.t0 = item.type;
	                _context17.next = _context17.t0 === 'tab_question' ? 6 : _context17.t0 === 'graph_question' ? 8 : _context17.t0 === 'table_question' ? 10 : _context17.t0 === 'two_part_question' ? 12 : 14;
	                break;
	
	              case 6:
	                routeName = 'TAB';
	                return _context17.abrupt('break', 16);
	
	              case 8:
	                routeName = 'GRAPH_MULTI_STATEMENT';
	                return _context17.abrupt('break', 16);
	
	              case 10:
	                routeName = 'TABLE';
	                return _context17.abrupt('break', 16);
	
	              case 12:
	                routeName = 'TWO_PART_STATEMENT';
	                return _context17.abrupt('break', 16);
	
	              case 14:
	                console.log('Route Name issue');
	                return _context17.abrupt('break', 16);
	
	              case 16:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  reading_id: item.reading_id,
	                  question_type: item.type
	                };
	                _context17.next = 19;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getSpecialQuestionByReadingId', data).then(function (resp) {
	                  if (resp.success) {
	                    console.log('I am inside resp.success');
	                    resp.result.map(function (element, index) {
	                      if (item.question_id === element.id) {
	                        _this.context.router.push({
	                          pathname: _appRoutes2.default[routeName].replace(':chapterid', element.chapter_id).replace(':readingid', element.reading_id).replace(':subscription', _this.state.questionShowFreePremium === false ? 1 : 0).replace(':question_id', item.question_id).replace(':offset', index).replace(':reading', item.topic_name)
	                        });
	                      }
	                    });
	                  }
	                });
	
	              case 19:
	                _context17.next = 24;
	                break;
	
	              case 21:
	                caseId = 0;
	                caseOffset = 0;
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestionsbyid', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log('resp ----> ', resp.questionsbyid.case_id);
	                    if (resp.questionsbyid.case_id) {
	                      data['case_id'] = resp.questionsbyid.case_id;
	                      data['reading_id'] = resp.questionsbyid.reading_id;
	                      data['subscriptionstatus'] = _this.state.questionShowFreePremium ? 'free' : 'paid';
	                      data['limit'] = 1;
	                      data['offset'] = 0;
	                      data['chapter_id'] = resp.questionsbyid.chapter_id;
	                      // console.log(data);
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCaseByReading', data).then(function (response) {
	                        if (response.success) {
	                          if (response.questions && response.questions.length) {
	                            response.questions.map(function (elementCase, indexCase) {
	                              if (parseInt(elementCase.case_id, 10) === parseInt(resp.questionsbyid.case_id, 10)) {
	                                caseId = elementCase.case_id;
	                                caseOffset = indexCase;
	                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCasesquestion', data).then(function (result) {
	                                  // console.log('result ------> ', result);
	                                  if (result.success) {
	                                    if (result.questions_details && result.questions_details.length) {
	                                      result.questions_details.map(function (element, index) {
	                                        if (parseInt(element.id, 10) === parseInt(item.question_id, 10)) {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', element.chapter_id).replace(':readingid', element.reading_id).replace(':caseid', element.case_id).replace(':case_offset', caseOffset).replace(':subscription', _this.state.questionShowFreePremium ? 0 : 1).replace(':question_number',
	                                            // element.question_no
	                                            index + 1).replace(':offset', index)
	                                          });
	                                        }
	                                      });
	                                    }
	                                  }
	                                });
	                              }
	                            });
	                          }
	                        }
	                      });
	                    } else {
	                      _this.context.router.push({
	                        pathname: _appRoutes2.default.QUESTION_BANK_VIEW_QUE.replace(':notesid', resp.questionsbyid.chapter_id).replace(':readingid', resp.questionsbyid.reading_id).replace(':id', item.question_id)
	                      });
	                    }
	                  } else {
	                    //console.log('Not Found');
	                  }
	                });
	
	              case 24:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this2);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    _this._beginVideos = function () {
	      var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.video_id
	                  // chapter_id: reading.chapter_id
	                };
	                _context18.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getVideoByID', data).then(function (resp) {
	                  if (resp.success) {
	                    var _data = resp.allVideo.findIndex(function (item) {
	                      return item.id === resp.video[0].id;
	                    });
	                    _this.context.router.push({
	                      pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', resp.video[0].id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', resp.video[0].chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.video[0].chapter_id).replace(':index', _data)
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this2);
	      }));
	
	      return function (_x15, _x16) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabSavedcards !== tab) {
	        _this.setState({
	          activeTabSavedcards: tab
	        });
	      }
	    };
	
	    _this.contentTypeTabToggle = function (tab) {
	      if (_this.state.activeTabSavedcards !== tab) {
	        _this.setState({
	          savedquestion: [],
	          savedLoader: true,
	          activeTabSavedcards: tab
	        }, function () {
	          return _this.getQuestionsSaved();
	        });
	      }
	    };
	
	    _this.contentTypeReportTabToggle = function (tab) {
	      if (_this.state.activeTabReportcards !== tab) {
	        // console.log('I am inside contentTypeTabToggle');
	        _this.setState({
	          reportquestion: [],
	          reportLoader: true,
	          activeTabReportcards: tab
	        }, function () {
	          return _this.getQuestionReports();
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      toggle: true,
	      token: '',
	      idname: '',
	
	      videoFlashReport: [],
	      flashreport: [], //All Flash question Store
	
	      savedquestion: [],
	      savedvideo: [],
	
	      reportquestion: [],
	      reportsvideo: [],
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	      progress_bar_zero: [],
	      question_progress_bar: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      // bar_chapter: '',
	      bar_main_user: [],
	      bar_main_class: [],
	      main_gmat_bar_main_user: [],
	      main_gmat_bar_main_class: [],
	      main_gmat_progress_bar_zero: [],
	      main_gmat_progress_bar: [],
	      main_gmat_progress_bar_slider: [],
	      verbal_bar_main_user: [],
	      verbal_bar_main_class: [],
	      verbal_progress_bar_zero: [],
	      verbal_progress_bar: [],
	      verbal_progress_bar_slider: [],
	      integrated_reasoning_bar_main_user: [],
	      integrated_reasoning_bar_main_class: [],
	      integrated_reasoning_progress_bar_zero: [],
	      integrated_reasoning_progress_bar: [],
	      integrated_reasoning_progress_bar_slider: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      reportAnswerId: '',
	      subreadings_status: false,
	      display_main_loader: 'show_block',
	      display_loader: 'hide_block',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      ErrorMessage: '',
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      activeTabSavedcards: 0,
	      activeTabReportcards: 0,
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      type: '',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      showFreePremium: false,
	      selectedmenu: 'gmat_focus',
	      isVideo: true,
	      qpLoader: true,
	      npLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	      content_type: ['Quant', 'Verbal', 'Integrated Reasoning'],
	      questionShowFreePremium: true
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATDashboard, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, data, e) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: data
	      });
	    }
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment,
	        type: 'quesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        videoReport: item.comment,
	        type: 'videoReport'
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: data.id,
	          contactType: type,
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'toggleDone',
	    value: function () {
	      var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee25() {
	        var _this3 = this;
	
	        var _state, idname, token, item_status, type, items_val, question_id, item_id, video_id, data;
	
	        return _regenerator2.default.wrap(function _callee25$(_context25) {
	          while (1) {
	            switch (_context25.prev = _context25.next) {
	              case 0:
	                _state = this.state, idname = _state.idname, token = _state.token, item_status = _state.item_status, type = _state.type, items_val = _state.items_val;
	                question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	                if (!(this.state.item_status == 'flashcard')) {
	                  _context25.next = 6;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context25.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteFlashCard', data).then(function () {
	                  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(resp) {
	                    return _regenerator2.default.wrap(function _callee19$(_context19) {
	                      while (1) {
	                        switch (_context19.prev = _context19.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context19.next = 5;
	                              break;
	                            }
	
	                            _context19.next = 3;
	                            return _this3.getQuestionFlashcards();
	
	                          case 3:
	                            _context19.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context19.stop();
	                        }
	                      }
	                    }, _callee19, _this3);
	                  }));
	
	                  return function (_x17) {
	                    return _ref20.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                if (!(item_status == 'savedquestion')) {
	                  _context25.next = 12;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val,
	                  type: type
	                };
	                _context25.next = 10;
	                return this.deleteFlashCard('question', question_id ? question_id : item_id, type);
	
	              case 10:
	                _context25.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteSavequestion', data).then(function () {
	                  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(resp) {
	                    return _regenerator2.default.wrap(function _callee20$(_context20) {
	                      while (1) {
	                        switch (_context20.prev = _context20.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context20.next = 5;
	                              break;
	                            }
	
	                            _context20.next = 3;
	                            return _this3.getQuestionsSaved();
	
	                          case 3:
	                            _context20.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context20.stop();
	                        }
	                      }
	                    }, _callee20, _this3);
	                  }));
	
	                  return function (_x18) {
	                    return _ref21.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                if (!(item_status == 'savedvideos')) {
	                  _context25.next = 18;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val
	                };
	                _context25.next = 16;
	                return this.deleteFlashCard('video', video_id ? video_id : item_id);
	
	              case 16:
	                _context25.next = 18;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteSaveVideo', data).then(function () {
	                  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(resp) {
	                    return _regenerator2.default.wrap(function _callee21$(_context21) {
	                      while (1) {
	                        switch (_context21.prev = _context21.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context21.next = 5;
	                              break;
	                            }
	
	                            _context21.next = 3;
	                            return _this3.getVideosSaved();
	
	                          case 3:
	                            _context21.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context21.stop();
	                        }
	                      }
	                    }, _callee21, _this3);
	                  }));
	
	                  return function (_x19) {
	                    return _ref22.apply(this, arguments);
	                  };
	                }());
	
	              case 18:
	                if (!(this.state.item_status == 'Videoflashcard')) {
	                  _context25.next = 22;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context25.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteDashboardVideoFlashCard', data).then(function () {
	                  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(resp) {
	                    return _regenerator2.default.wrap(function _callee22$(_context22) {
	                      while (1) {
	                        switch (_context22.prev = _context22.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context22.next = 5;
	                              break;
	                            }
	
	                            _context22.next = 3;
	                            return _this3.getVideoFlashcards();
	
	                          case 3:
	                            _context22.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context22.stop();
	                        }
	                      }
	                    }, _callee22, _this3);
	                  }));
	
	                  return function (_x20) {
	                    return _ref23.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 22:
	                if (!(this.state.item_status == 'Reportsquestion')) {
	                  _context25.next = 26;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val,
	                  type: this.state.items_val.type
	                };
	                _context25.next = 26;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteDashboardQuestionReports', data).then(function () {
	                  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(resp) {
	                    return _regenerator2.default.wrap(function _callee23$(_context23) {
	                      while (1) {
	                        switch (_context23.prev = _context23.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context23.next = 5;
	                              break;
	                            }
	
	                            _context23.next = 3;
	                            return _this3.getQuestionReports();
	
	                          case 3:
	                            _context23.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context23.stop();
	                        }
	                      }
	                    }, _callee23, _this3);
	                  }));
	
	                  return function (_x21) {
	                    return _ref24.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 26:
	                if (!(this.state.item_status == 'Reportsvideos')) {
	                  _context25.next = 30;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context25.next = 30;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteDashboardVideoReports', data).then(function () {
	                  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(resp) {
	                    return _regenerator2.default.wrap(function _callee24$(_context24) {
	                      while (1) {
	                        switch (_context24.prev = _context24.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context24.next = 5;
	                              break;
	                            }
	
	                            _context24.next = 3;
	                            return _this3.getVideoReports();
	
	                          case 3:
	                            _context24.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context24.stop();
	                        }
	                      }
	                    }, _callee24, _this3);
	                  }));
	
	                  return function (_x22) {
	                    return _ref25.apply(this, arguments);
	                  };
	                }()
	                //console.log('error');
	                );
	
	              case 30:
	
	                this.setState({
	                  alert_status: false
	                });
	
	              case 31:
	              case 'end':
	                return _context25.stop();
	            }
	          }
	        }, _callee25, this);
	      }));
	
	      function toggleDone() {
	        return _ref19.apply(this, arguments);
	      }
	
	      return toggleDone;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate != '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this4 = this;
	
	          // console.log(
	          //   'I am inside handleChange_second -----> ',
	          //   this.state.toggle
	          // );
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second,
	            type: this.state.toggle ? 'content-type' : 'content-format'
	          };
	
	          // -------------- ---- FOR Main Graph No. 1 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getMainGraphProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph1 = JSON.stringify(resp.chapters);
	              var dataReasonGraph1 = JSON.parse(dataStringGraph1);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReasonGraph1.length; iterator++) {
	                var right_answered = dataReasonGraph1[iterator].answered_count;
	                var total_question = dataReasonGraph1[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                main_gmat_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                main_gmat_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getMainGraphProgressClassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ main_gmat_bar_main_class: final_array_main });
	            }
	          });
	          // -------------- ---- FOR Main Graph No. 1 End ------------- //
	          // -------------- ---- FOR Main Graph No. 2 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this4.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                progress_bar_zero: resp.chapters
	              });
	              // console.log('part 22222---------------------', final_array_main);
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ bar_main_class: final_array_main });
	            } else {
	              //console.log(resp.success + '------------failure');
	            }
	          });
	          // -------------- ---- FOR Main Graph No. 2 END ------------- //
	
	          // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getVerbalProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph3 = JSON.stringify(resp.chapters);
	              var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                var right_answered = dataReasonGraph3[iterator].answered_count;
	                var total_question = dataReasonGraph3[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                verbal_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                verbal_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getVerbalProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
	              var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                var right_answered = dataReasonGraph3[iterator].answered_count;
	                var total_question = dataReasonGraph3[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({ verbal_bar_main_class: final_array_main });
	            }
	          });
	          // -------------- ---- FOR Verbal Graph No. 3 End ------------- //
	
	          // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getIntegratedReasoningProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph4 = JSON.stringify(resp.chapters);
	              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                var right_answered = dataReasonGraph4[iterator].answered_count;
	                var total_question = dataReasonGraph4[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                integrated_reasoning_bar_main_user: final_array_main,
	                display_main_loader: 'hide_block',
	                integrated_reasoning_progress_bar_zero: resp.chapters
	              });
	            } else {
	              _this4.setState({ display_main_loader: 'hide_block' });
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getIntegratedReasoningProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
	              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                var right_answered = dataReasonGraph4[iterator].answered_count;
	                var total_question = dataReasonGraph4[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this4.setState({
	                integrated_reasoning_bar_main_class: final_array_main
	              });
	            }
	          });
	          // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
	          // FD.callAPI(
	          //   App_data.backend_api + '/gmat-focus/dashboard/getProgressChapter',
	          //   data
	          // ).then((resp) => {
	          //   if (resp.success) {
	          //     this.setState({ progress_bar_zero: resp.chapters });
	          //   } else {
	          //     //console.log(resp.success + '------------failure');
	          //   }
	          // });
	          // FD.callAPI(
	          //   App_data.backend_api + '/gmat-focus/dashboard/getNotesChapter',
	          //   data
	          // ).then((resp) => {
	          //   if (resp.success) {
	          //     this.setState({ bar_chapter: resp.chapters });
	          //   } else {
	          //     //console.log(resp.success + '------------failure');
	          //   }
	          // });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              // this.setState({ progress_bar_zero: resp.progressbarzero_data });
	            } else {
	                //console.log(resp.success + '------------failure');
	              }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee33() {
	        var _this5 = this;
	
	        var storage_session, data, getProfileInfoData;
	        return _regenerator2.default.wrap(function _callee33$(_context33) {
	          while (1) {
	            switch (_context33.prev = _context33.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second,
	                  type: this.state.toggle ? 'content-type' : 'content-format'
	                };
	                // await FD.callAPI(
	                //   App_data.backend_api + '/gmat-focus/dashboard/getQuestionType',
	                //   data
	                // ).then(async (resp) => {
	                //   // console.log(resp);
	                //   let content_type = [];
	                //   if (resp.success) {
	                //     resp.question_type.map((question) => {
	                //       content_type.push(question.content_type);
	                //     });
	                //     // content_type.push('Integrated Reasoning');
	                //     this.setState({ content_type });
	                //   }
	                // });
	
	                _context33.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getChapters', data).then(function () {
	                  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(resp) {
	                    return _regenerator2.default.wrap(function _callee26$(_context26) {
	                      while (1) {
	                        switch (_context26.prev = _context26.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ ValidToken: true });
	                              _this5.setState({ chapters: resp.chapters });
	                            } else {
	                              _this5.setState({ ValidToken: false });
	                            }
	                            return _context26.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context26.stop();
	                        }
	                      }
	                    }, _callee26, _this5);
	                  }));
	
	                  return function (_x23) {
	                    return _ref27.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	
	                // -------------- ---- FOR Main Graph No. 1 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getMainGraphProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph1 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph1 = JSON.parse(dataStringGraph1);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReasonGraph1.length; iterator++) {
	                      var right_answered = dataReasonGraph1[iterator].answered_count;
	                      var total_question = dataReasonGraph1[iterator].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      main_gmat_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      main_gmat_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getMainGraphProgressClassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataString = JSON.stringify(resp.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReason.length; iterator++) {
	                      var right_answered = dataReason[iterator].answered_count;
	                      var total_question = dataReason[iterator].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({ main_gmat_bar_main_class: final_array_main });
	                  }
	                });
	                // -------------- ---- FOR Main Graph No. 1 End ------------- //
	                // -------------- ---- FOR Main Graph No. 2 Start ------------- //
	                _context33.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/mainProgressbar', data).then(function () {
	                  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(resp) {
	                    var dataString, dataReason, final_array_main, right_answered, total_question, user_graph_val;
	                    return _regenerator2.default.wrap(function _callee27$(_context27) {
	                      while (1) {
	                        switch (_context27.prev = _context27.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ display_loader: 'hide_block' });
	                              dataString = JSON.stringify(resp.chapters);
	                              dataReason = JSON.parse(dataString);
	                              final_array_main = [];
	
	                              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                                right_answered = dataReason[iterator].answered_count;
	                                total_question = dataReason[iterator].attempted_count;
	                                user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	
	                                if (user_graph_val === 'NaN') {
	                                  final_array_main.push('0.0');
	                                } else {
	                                  final_array_main.push(user_graph_val);
	                                }
	                              }
	                              // console.log('hi-------------------------', final_array_main);
	                              _this5.setState({
	                                bar_main_user: final_array_main,
	                                display_main_loader: 'hide_block',
	                                progress_bar_zero: resp.chapters
	                              });
	                            } else {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context27.stop();
	                        }
	                      }
	                    }, _callee27, _this5);
	                  }));
	
	                  return function (_x24) {
	                    return _ref28.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	                this.setState({ display_main_loader: 'show_block' });
	
	                _context33.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/mainProgressclassbar', data).then(function () {
	                  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(resp) {
	                    var dataStringGraph2, dataReasonGraph2, final_array_main, right_answered, total_question, user_graph_val;
	                    return _regenerator2.default.wrap(function _callee28$(_context28) {
	                      while (1) {
	                        switch (_context28.prev = _context28.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ display_main_loader: 'hide_block' });
	                              dataStringGraph2 = JSON.stringify(resp.chaptersclass);
	                              dataReasonGraph2 = JSON.parse(dataStringGraph2);
	                              final_array_main = [];
	
	                              for (iterator = 0; iterator < dataReasonGraph2.length; iterator++) {
	                                right_answered = dataReasonGraph2[iterator].answered_count;
	                                total_question = dataReasonGraph2[iterator].attempted_count;
	                                user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	
	                                if (user_graph_val === 'NaN') {
	                                  final_array_main.push('0.0');
	                                } else {
	                                  final_array_main.push(user_graph_val);
	                                }
	                              }
	                              _this5.setState({ bar_main_class: final_array_main });
	                            } else {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context28.stop();
	                        }
	                      }
	                    }, _callee28, _this5);
	                  }));
	
	                  return function (_x25) {
	                    return _ref29.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	
	                // -------------- ---- FOR Main Graph No. 2 End ------------- //
	                // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getVerbalProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph3 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                      var right_answered = dataReasonGraph3[iterator].answered_count;
	                      var total_question = dataReasonGraph3[iterator].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    console.log('Verbal ---->', final_array_main, resp.chapters);
	                    _this5.setState({
	                      verbal_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      verbal_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getVerbalProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
	                    var dataReasonGraph3 = JSON.parse(dataStringGraph3);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReasonGraph3.length; iterator++) {
	                      var right_answered = dataReasonGraph3[iterator].answered_count;
	                      var total_question = dataReasonGraph3[iterator].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({ verbal_bar_main_class: final_array_main });
	                  }
	                });
	                // -------------- ---- FOR Verbal Graph No. 3 End ------------- //
	
	                // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getIntegratedReasoningProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph4 = JSON.stringify(resp.chapters);
	                    var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                      var right_answered = dataReasonGraph4[iterator].answered_count;
	                      var total_question = dataReasonGraph4[iterator].attempted_count;
	
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      integrated_reasoning_bar_main_user: final_array_main,
	                      display_main_loader: 'hide_block',
	                      integrated_reasoning_progress_bar_zero: resp.chapters
	                    });
	                  } else {
	                    _this5.setState({ display_main_loader: 'hide_block' });
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getIntegratedReasoningProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
	                    var dataReasonGraph4 = JSON.parse(dataStringGraph4);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReasonGraph4.length; iterator++) {
	                      var right_answered = dataReasonGraph4[iterator].answered_count;
	                      var total_question = dataReasonGraph4[iterator].attempted_count;
	                      var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this5.setState({
	                      integrated_reasoning_bar_main_class: final_array_main
	                    });
	                  }
	                });
	                // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
	                _context33.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/getQuestionProgByUser', data).then(function () {
	                  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(resp) {
	                    return _regenerator2.default.wrap(function _callee29$(_context29) {
	                      while (1) {
	                        switch (_context29.prev = _context29.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({
	                                question_progress_bar: resp.progressbarzero_data,
	                                qpLoader: false
	                              });
	                            } else {
	                              //console.log(resp.success + '------------failure');
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context29.stop();
	                        }
	                      }
	                    }, _callee29, _this5);
	                  }));
	
	                  return function (_x26) {
	                    return _ref30.apply(this, arguments);
	                  };
	                }());
	
	              case 20:
	                _context33.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function () {
	                  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(resp) {
	                    return _regenerator2.default.wrap(function _callee30$(_context30) {
	                      while (1) {
	                        switch (_context30.prev = _context30.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this5.setState({ ValidToken: true });
	                            } else {
	                              _this5.setState({ ValidToken: false });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context30.stop();
	                        }
	                      }
	                    }, _callee30, _this5);
	                  }));
	
	                  return function (_x27) {
	                    return _ref31.apply(this, arguments);
	                  };
	                }());
	
	              case 22:
	                getProfileInfoData = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfoData).then(async (resp) => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee32() {
	                  var resp, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee32$(_context32) {
	                    while (1) {
	                      switch (_context32.prev = _context32.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context32.next = 3;
	                            break;
	                          }
	
	                          return _context32.abrupt('return');
	
	                        case 3:
	
	                          if (resp.profileInfo) {
	                            _this5.setState({
	                              isVideo: resp.profileInfo.isVideo
	                            });
	                          }
	
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context32.next = 17;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context32.next = 9;
	                            break;
	                          }
	
	                          _this5.setState({
	                            showFreePremium: true
	                          });
	                          _context32.next = 15;
	                          break;
	
	                        case 9:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this5.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            examid: data_arr
	                          };
	                          _context32.next = 15;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, queSubscription;
	                              return _regenerator2.default.wrap(function _callee31$(_context31) {
	                                while (1) {
	                                  switch (_context31.prev = _context31.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context31.next = 14;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this5.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context31.next = 6;
	                                      return _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context31.sent;
	
	                                      if (isInArray_var) {
	                                        _this5.setState({ showFreePremium: false });
	                                      } else {
	                                        _this5.setState({ showFreePremium: true });
	                                      }
	                                      // Question Subscription
	                                      _context31.next = 10;
	                                      return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	
	                                    case 10:
	                                      queSubscription = _context31.sent;
	
	                                      if (queSubscription) {
	                                        _this5.setState({ questionShowFreePremium: false });
	                                      } else {
	                                        _this5.setState({
	                                          questionShowFreePremium: true
	                                        });
	                                      }
	                                      _context31.next = 14;
	                                      break;
	
	                                    case 14:
	                                    case 'end':
	                                      return _context31.stop();
	                                  }
	                                }
	                              }, _callee31, _this5);
	                            }));
	
	                            return function (_x28) {
	                              return _ref33.apply(this, arguments);
	                            };
	                          }());
	
	                        case 15:
	                          _context32.next = 27;
	                          break;
	
	                        case 17:
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context32.next = 21;
	                            break;
	                          }
	
	                          _this5.setState({
	                            showFreePremium: true
	                          });
	                          _context32.next = 27;
	                          break;
	
	                        case 21:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this5.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this5.state.token,
	                            idname: _this5.state.idname,
	                            examid: data_arr
	                          };
	                          _context32.next = 27;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this5.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                              console.log(' in GMAT dashboard ', selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                              if (isInArray_var) {
	                                _this5.setState({ showFreePremium: false });
	                              } else {
	                                _this5.setState({ showFreePremium: true });
	                              }
	                              var queSubscription = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this5.state.cfaUnlimitedPackage, _this5.state.cfaUnlimitedActiveExam);
	                              if (queSubscription) {
	                                _this5.setState({
	                                  questionShowFreePremium: false
	                                });
	                              } else {
	                                _this5.setState({
	                                  questionShowFreePremium: true
	                                });
	                              }
	                            } else {}
	                          });
	
	                        case 27:
	                        case 'end':
	                          return _context32.stop();
	                      }
	                    }
	                  }, _callee32, _this5);
	                })));
	
	                _context33.next = 26;
	                return this.getQuestionFlashcards();
	
	              case 26:
	                _context33.next = 28;
	                return this.getVideoFlashcards();
	
	              case 28:
	                _context33.next = 30;
	                return this.getQuestionsSaved();
	
	              case 30:
	                _context33.next = 32;
	                return this.getVideosSaved();
	
	              case 32:
	                _context33.next = 34;
	                return this.getQuestionReports();
	
	              case 34:
	                _context33.next = 36;
	                return this.getVideoReports();
	
	              case 36:
	              case 'end':
	                return _context33.stop();
	            }
	          }
	        }, _callee33, this);
	      }));
	
	      function componentDidMount() {
	        return _ref26.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	
	    // function for get  question report
	
	
	    // function for get  Video falshCard
	
	
	    // function for get  video report
	
	
	    /*
	     * get saved all video
	     */
	
	
	    /*
	     * function for go to specific   question main page
	     */
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      // console.log(
	      //   'this.state.progress_bar_zero-------',
	      //   this.state.progress_bar_zero
	      // );
	      return this.state.question_progress_bar.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        var progressPercentage = progressnotes_zero > 100 ? 100 : progressnotes_zero;
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                index + 1
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressPercentage,
	                      style: { width: progressPercentage + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	    // question form submit function
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(event) {
	        var _this6 = this;
	
	        var _state2, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee35$(_context35) {
	          while (1) {
	            switch (_context35.prev = _context35.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context35.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context35.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, quesReport = _state2.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context35.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(resp) {
	                    return _regenerator2.default.wrap(function _callee34$(_context34) {
	                      while (1) {
	                        switch (_context34.prev = _context34.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context34.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context34.next = 4;
	                            return _this6.getQuestionReports();
	
	                          case 4:
	                            _context34.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context34.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context34.stop();
	                        }
	                      }
	                    }, _callee34, _this6);
	                  }));
	
	                  return function (_x30) {
	                    return _ref35.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context35.stop();
	            }
	          }
	        }, _callee35, this);
	      }));
	
	      function handleQuestionReportSubmit(_x29) {
	        return _ref34.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee37$(_context37) {
	          while (1) {
	            switch (_context37.prev = _context37.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context37.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context37.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, videoReport = _state3.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context37.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(resp) {
	                    return _regenerator2.default.wrap(function _callee36$(_context36) {
	                      while (1) {
	                        switch (_context36.prev = _context36.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context36.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context36.next = 4;
	                            return _this7.getVideoReports();
	
	                          case 4:
	                            _context36.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context36.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context36.stop();
	                        }
	                      }
	                    }, _callee36, _this7);
	                  }));
	
	                  return function (_x32) {
	                    return _ref37.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context37.stop();
	            }
	          }
	        }, _callee37, this);
	      }));
	
	      function handleVideoReportSubmit(_x31) {
	        return _ref36.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    // function for state change of edit report form fileds
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          activeTabSavedcards = _state4.activeTabSavedcards,
	          activeTabSaved = _state4.activeTabSaved,
	          activeTabReports = _state4.activeTabReports,
	          isVideo = _state4.isVideo,
	          qpLoader = _state4.qpLoader,
	          npLoader = _state4.npLoader,
	          savedLoader = _state4.savedLoader,
	          flashLoader = _state4.flashLoader,
	          reportLoader = _state4.reportLoader,
	          toggle = _state4.toggle,
	          activeTabReportcards = _state4.activeTabReportcards;
	
	
	      var flashreport_val = this.state.flashreport;
	      var video_flashreport_val = this.state.videoFlashReport;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savedvideo_val = this.state.savedvideo;
	
	      var reportquestion_val = this.state.reportquestion;
	      var reportvideo_val = this.state.reportsvideo;
	
	      var flashcard_data = '';
	      var video_flashcard_data = '';
	
	      var savedquestion_data = '';
	      var savedvideo_data = '';
	
	      var question_reportsData = ''; // for question reports
	      var video_reportsData = ''; // for video report
	
	      // ------------------ FOR Graph 1 Start ----------------//
	      var main_gmat_bar_val = this.state.main_gmat_progress_bar_zero;
	      var main_gmat_bar_percentage = this.state.main_gmat_bar_main_user;
	
	      var main_gmat_bar_user_percentage = this.state.main_gmat_bar_main_class;
	
	      var main_gmat_main_bar_data = [];
	      var i = 0;
	      main_gmat_bar_val.map(function (data) {
	        main_gmat_main_bar_data[i] = data.chapter_name;
	        i++;
	      });
	      var main_gmat_bar_data = {
	        labels: main_gmat_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_gmat_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_gmat_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 1 End ----------------//
	      /*first main graph*/
	      var main_bar_val = this.state.progress_bar_zero;
	      var main_bar_percentage = this.state.bar_main_user;
	
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	      Object.keys(main_bar_val).map(function (key) {
	        // var dataStringGraph2 = JSON.stringify(main_bar_val[key]);
	        // var dataReasonGraph2 = JSON.parse(dataStringGraph2);
	        // console.log('dataReasonGraph2 parse------> ', dataReasonGraph2);
	        // console.log('dataStringGraph2 stringify ------> ', dataReasonGraph2);
	
	        if (main_bar_val[key].chapter_name !== 'Integrated Reasoning' && main_bar_val[key].chapter_name !== 'Verbal') {
	          if (main_bar_val[key].chapter_name) {
	            main_bar_data[i] = main_bar_val[key].chapter_name;
	            i++;
	          }
	        }
	      });
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 3 Start ----------------//
	      var verbal_bar_val = this.state.verbal_progress_bar_zero;
	      var verbal_bar_percentage = this.state.verbal_bar_main_user;
	
	      var verbal_bar_user_percentage = this.state.verbal_bar_main_class;
	
	      var verbal_main_bar_data = [];
	      var i = 0;
	      verbal_bar_val.map(function (data) {
	        verbal_main_bar_data[i] = data.chapter_name;
	        i++;
	      });
	      var verbal_bar_data = {
	        labels: verbal_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: verbal_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: verbal_bar_user_percentage
	        }]
	      };
	      // ------------------ FOR Graph 3 End ----------------//
	
	      // ------------------ FOR Graph 4 Start ----------------//
	      var integrated_reasoning_bar_val = this.state.integrated_reasoning_progress_bar_zero;
	      var integrated_reasoning_bar_percentage = this.state.integrated_reasoning_bar_main_user;
	
	      var integrated_reasoning_bar_user_percentage = this.state.integrated_reasoning_bar_main_class;
	
	      var integrated_reasoning_main_bar_data = [];
	      var i = 0;
	      integrated_reasoning_bar_val.map(function (data) {
	        integrated_reasoning_main_bar_data[i] = data.chapter_name.substring(0, 20);
	        i++;
	      });
	      var integrated_reasoning_bar_data = {
	        labels: integrated_reasoning_main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31,140,235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31,140,235)',
	          data: integrated_reasoning_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: integrated_reasoning_bar_user_percentage
	        }]
	      };
	
	      // ------------------ FOR Graph 4 End ----------------//
	
	      /*other graph*/
	      // let chapters = this.state.progress_bar_zero;
	      var chapters = this.state.progress_bar_zero;
	
	      var reading_data = '';
	      // alert(this.state.subreadings_status);
	      if (this.state.progress_bar_zero.length && !this.state.subreadings_status) {
	        chapters.reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	          );
	        });
	      }
	      if (this.state.progress_bar_zero.length && this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	            )
	          );
	        });
	      }
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteVideoFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, 'span')
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSavequestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_QUESTIONS,
	          ' '
	        );
	      }
	
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSaveVideo.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)(items.topic_name, 'span')
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, 'span')
	              )
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditQuesReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleQuestionReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this8.toggleAlertReport.bind(_this8, items, 'quesReport'),
	                  className: _this8.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsquestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditVideoReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleVideoReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8.toggleAlertReport.bind(_this8, items, 'videoReport'),
	                    className: _this8.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, 'span'),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsVideo.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, 'span')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  'GMAT Focus Dashboard'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE_BY_AREA,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: main_gmat_bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUANT_PROBLEM,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().VERBAL_PROBLEM,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: verbal_bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().INTEGRATED_REASONING_QUESTIONS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: integrated_reasoning_bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: 'dashboard-card-header-tab ' + (activeTabSaved === '1' ? 'mb-1' : '')
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: 'auto' } },
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                activeTabSaved === '1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    this.state.content_type.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          onClick: function onClick() {
	                            _this8.contentTypeTabToggle(index);
	                          },
	                          key: index,
	                          className: activeTabSavedcards === index ? 'active' : ''
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          ' ',
	                          item,
	                          ' '
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : // : this.state.activeTabSaved === '2'
	                      // ? savednotes_data
	                      savedvideo_data
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: 'dashboard-card-header-tab ' + (activeTabReports === '1' ? 'mb-1' : '')
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: 'auto' } },
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                activeTabReports === '1' ? _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    this.state.content_type.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          onClick: function onClick() {
	                            _this8.contentTypeReportTabToggle(index);
	                          },
	                          key: index,
	                          className: activeTabReportcards === index ? 'active' : ''
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          ' ',
	                          item,
	                          ' '
	                        )
	                      );
	                    })
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : // : this.state.activeTabReports === '2'
	                      // ? notes_reportsData
	                      this.state.activeTabReports === '3' ? video_reportsData : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.toggleClose },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        this.state.display_loader === 'hide_block' ? null : _react2.default.createElement(_loader2.default, null)
	      );
	    }
	  }]);
	
	  return GMATDashboard;
	}(_react.Component);
	
	GMATDashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var bar_data_sub = [];
	var reading_text = '';
	function Barget(props) {
	  if (props.subreadings_status && props.endDate != '') {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: props.startDate,
	      endDate: props.endDate
	    };
	  } else {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: '',
	      endDate: ''
	    };
	  }
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/subProgressbar', data).then(function (resp) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/dashboard/subProgressbarofclass', data).then(function (resp_class) {
	      /*class variable */
	      var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
	      var dataReason_class = JSON.parse(dataString_class);
	
	      var final_array_main_class = [];
	
	      for (iterator = 0; iterator < dataReason_class.length; iterator++) {
	        var right_answered_class = dataReason_class[iterator].right_answer;
	        var total_question_class = dataReason_class[iterator].total_questions;
	        var user_graph_val_class = (right_answered_class / total_question_class * 100).toFixed(2);
	        final_array_main_class.push(user_graph_val_class);
	      }
	      /*user variable*/
	      var dataString = JSON.stringify(resp.readingwisebar_ret);
	      var dataReason = JSON.parse(dataString);
	
	      var final_array_main = [];
	      var reading_text = [];
	
	      for (iterator = 0; iterator < dataReason.length; iterator++) {
	        var right_answered = dataReason[iterator].right_answer;
	        var total_question = dataReason[iterator].total_questions;
	
	        var user_graph_val = (right_answered / total_question * 100).toFixed(2);
	
	        final_array_main.push(user_graph_val);
	        reading_text.push(dataReason[iterator].reading);
	      }
	
	      bar_data_sub[props.answered_state] = {
	        labels: reading_text,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(114,195,250)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(114,195,250)',
	          data: final_array_main
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: final_array_main_class
	        }]
	      };
	    });
	  });
	  return _react2.default.createElement(_reactChartjs.Bar, { data: bar_data_sub[props.answered_state], options: { maintainAspectRatio: false } });
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATDashboard;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _constant = __webpack_require__(9);
	
	var _ForwardTimer = __webpack_require__(241);
	
	var _ForwardTimer2 = _interopRequireDefault(_ForwardTimer);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { getDeviceDetails } from '../../common/deviceDetails';
	
	
	/* eslint-disable*/
	var GMATBeginchapters = function (_Component) {
	  _inherits(GMATBeginchapters, _Component);
	
	  function GMATBeginchapters(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATBeginchapters);
	
	    var _this = _possibleConstructorReturn(this, (GMATBeginchapters.__proto__ || Object.getPrototypeOf(GMATBeginchapters)).call(this, props));
	
	    _this.onTick = function (time) {
	      _this.setState({
	        count: time
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', _this.props.params.notesid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.notesid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.questions.name)
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        isFlashCardHidden: true,
	        rated: false,
	        rating: 0,
	        isError: false,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      _this.setState({ clicked: false, choice: '' });
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (i === 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      }
	      var questions = _this.state.questions;
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      if (questions.right_choice == 'choice_a') {
	        _this.setState({ choice_name: 'A' });
	      } else if (questions.right_choice == 'choice_b') {
	        _this.setState({ choice_name: 'B' });
	      } else if (questions.right_choice == 'choice_c') {
	        _this.setState({ choice_name: 'C' });
	      } else if (questions.right_choice == 'choice_d') {
	        _this.setState({ choice_name: 'D' });
	      } else if (questions.right_choice == 'choice_e') {
	        _this.setState({ choice_name: 'E' });
	      }
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_VIEW_QUE.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i)
	
	        // '/beginchapter/' +
	        // this.props.params.notesid +
	        // '/' +
	        // this.props.params.readingid +
	        // '/' +
	        // next_question_id +
	        // '/' +
	        // i,
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        rated: false,
	        isFlashCardHidden: true,
	        rating: 0,
	        isError: false,
	        ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block',
	        choice_name: '',
	        bookmarkColor: ''
	      });
	      _this.setState({ clicked: false, choice: '' });
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	      // alert(i);
	      //console.log(this.props.params.readingid);
	      _this.setState({ offset: i });
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	
	      if (parseInt(_this.state.question_length) - 1 === i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i != 0) {
	        _this.setState({ previ_block: '' });
	      }
	      var questions = _this.state.questions;
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      if (questions.right_choice == 'choice_a') {
	        _this.setState({ choice_name: 'A' });
	      } else if (questions.right_choice == 'choice_b') {
	        _this.setState({ choice_name: 'B' });
	      } else if (questions.right_choice == 'choice_c') {
	        _this.setState({ choice_name: 'C' });
	      } else if (questions.right_choice == 'choice_d') {
	        _this.setState({ choice_name: 'D' });
	      } else if (questions.right_choice == 'choice_e') {
	        _this.setState({ choice_name: 'E' });
	      }
	      var next_question_id = _this.state.all_questions_state[i].id;
	      // console.log(this.state.token)
	      // console.log(this.state.idname)
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_VIEW_QUE.replace(':notesid', _this.props.params.notesid).replace(':readingid', _this.props.params.readingid).replace(':id', next_question_id).replace(':offset', i)
	
	        // '/beginchapter/' +
	        // this.props.params.notesid +
	        // '/' +
	        // this.props.params.readingid +
	        // '/' +
	        // next_question_id +
	        // '/' +
	        // i,
	      });
	    };
	
	    _this._getAnswer = function (choice, e) {
	      _this.setState({ clicked: true });
	      _this.setState({ choice: choice });
	      // const result = getDeviceDetails();
	
	      if (choice === 'choice_a') {
	        _this.setState({ choice_a: 'answer_box clicked_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_b') {
	        _this.setState({ choice_b: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_c') {
	        _this.setState({ choice_c: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_d') {
	        _this.setState({ choice_d: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box ' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_e: 'answer_box' });
	      } else if (choice === 'choice_e') {
	        _this.setState({ choice_e: 'answer_box clicked_box' });
	        _this.setState({ choice_a: 'answer_box' });
	        _this.setState({ choice_b: 'answer_box' });
	        _this.setState({ choice_c: 'answer_box' });
	        _this.setState({ choice_d: 'answer_box' });
	      }
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: _this.props.params.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this.handleQuestionValidate = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(item, e) {
	        var chosen_answer, right_answer, _this$state, token, idname, time_done, selected_choice, question_id, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_this.state.clicked) {
	                  _context2.next = 14;
	                  break;
	                }
	
	                clearInterval(_this.timer);
	                chosen_answer = _this.state.choice;
	                right_answer = 0;
	
	                _this.setState({ result_block: 'card show_block', isTimer: false });
	                if (item.right_choice === _this.state.choice) {
	                  right_answer = 1;
	                  if (_this.state.choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
	                  } else if (_this.state.choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
	                  } else if (_this.state.choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
	                  } else if (_this.state.choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
	                  } else if (_this.state.choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
	                  }
	
	                  _this.setState({
	                    result: '' + _language2.default.LC().CORRECT,
	                    text_color: 'card-header text_success',
	                    result_block: 'card show_block'
	                  });
	                } else {
	                  right_answer = 0;
	                  if (_this.state.choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box failure' });
	                  } else if (_this.state.choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box failure' });
	                  }
	                  if (item.right_choice === 'choice_a') {
	                    _this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
	                  } else if (item.right_choice === 'choice_b') {
	                    _this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
	                  } else if (item.right_choice === 'choice_c') {
	                    _this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
	                  } else if (item.right_choice === 'choice_d') {
	                    _this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
	                  } else if (item.right_choice === 'choice_e') {
	                    _this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
	                  }
	                  _this.setState({
	                    text_color: 'card-header text_failure',
	                    result: '' + _language2.default.LC().INCORRECT,
	                    result_block: 'card show_block'
	                  });
	                }
	
	                if (_this.state.validated) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                _this$state = _this.state, token = _this$state.token, idname = _this$state.idname, time_done = _this$state.count, selected_choice = _this$state.choice;
	                question_id = item.id;
	                data = {
	                  token: token,
	                  idname: idname,
	                  question_id: question_id,
	                  right_answer: right_answer,
	                  time_done: time_done,
	                  selected_choice: selected_choice
	                };
	                _context2.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveStats', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({ ValidToken: true, validated: true });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	                _context2.next = 15;
	                break;
	
	              case 14:
	                _this.setState({
	                  isError: true
	                });
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._saveQuestion = function (item, e) {
	      console.log('item ----------->', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({ ValidToken: true });
	            _this.setState({
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	            });
	            _this.setState({
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              isFlashCardHidden: false
	            });
	            _this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
	            _this.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true, isFlashCardHidden: false });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._editFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                isFlashCardHidden: true,
	                flash_data: flash_cards,
	                flash_form: 'col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      console.log('item ------------> ', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      // console.log(data);
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-sm-12 col-md-12 display_block',
	        isEditable: true
	      });
	
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-sm-12 col-md-12 display_block',
	            isEditable: false
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.setQuestionState = function (questionDetails) {
	      _this.setState({ questions: questionDetails }, function () {
	        var selectedChoice = questionDetails['gmat_focus_question_stat.isSelectedChoice'];
	        var hasSelectedChoice = selectedChoice !== null && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.GMAT_FOCUS);
	        var right_choice = questionDetails.right_choice;
	
	        _this.setState({
	          choice_name: _constant.CHOICE_MAPPING[right_choice] || '',
	          isSelectedChoice: selectedChoice || null,
	          choice: hasSelectedChoice ? _this.getSelectedChoice(questionDetails, selectedChoice) : null,
	          clicked: hasSelectedChoice,
	          count: questionDetails['gmat_focus_question_stat.time_done'] || 0,
	          isTimer: !hasSelectedChoice,
	          validated: hasSelectedChoice,
	          result_block: 'card ' + (hasSelectedChoice ? 'show_block' : 'hide_block')
	        }, function () {
	          if (hasSelectedChoice) {
	            _this.handleQuestionValidate(questionDetails);
	          }
	        });
	      });
	    };
	
	    _this.getSelectedChoice = function (question, selected) {
	      if (selected === 1) {
	        return question.right_choice;
	      }
	
	      var selectedChoice = question['gmat_focus_question_stat.selected_choice'];
	
	      if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
	        return selectedChoice;
	      }
	
	      var wrongChoices = _constant.CHOICE_KEYS.filter(function (choice) {
	        return choice !== question.right_choice;
	      });
	      var randomWrong = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];
	
	      return randomWrong;
	    };
	
	    _this._displayOuterElement = function () {
	      // console.log("working");
	      var d = document.getElementById('d');
	      // console.log("dsacds");
	      // console.log(d.outerHTML);
	    };
	
	    _this.setAnswer = function (answer) {
	      _this.setState({ choice: answer[0], clicked: true, isError: false });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      reportLoading: false,
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      successAlert: false,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      isError: false,
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      display_loader: 'show_block',
	      selectedmenu: 'gmat_focus',
	      subscriptionstatus: '',
	      chapter_name: '',
	      isEditable: false,
	      all_questions: '',
	      category: 'GMAT',
	      tags: ['gmat', 'question'],
	      title: '',
	      description: '',
	      forumComment: '',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      choice_name: '',
	      isTimer: false
	    };
	    _this.timer = null;
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(GMATBeginchapters, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	
	    //Function to change, time every second
	
	
	    //Function to redirect page to readings page
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to fetch previous question
	
	
	    //Function to fetch Next question
	
	
	    //Function to check Right Or Wrong Answered and displayed clicked box
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to show Correct box and display right answer and store in database
	
	
	    //Function to Display Saved Question on button and save in database
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Funcion to save new report question
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	  }, {
	    key: 'onStarClick',
	
	
	    //Function to give star rattings
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) ;
	      {
	        var params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/UpdateGMATRatting', params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1 });
	            _this3.setState({ ratting_text: 'Rated ' });
	          }
	        });
	      }
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              _this3.setState({ rating: items.ratting });
	              _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	            });
	          } else {
	            var params = {
	              token: _this3.state.token,
	              idname: _this3.state.idname,
	              question_id: item.id,
	              ratting: nextValue
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1 });
	                _this3.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              }
	            });
	          }
	        } else {
	          var params = {
	            token: _this3.state.token,
	            idname: _this3.state.idname,
	            question_id: item.id,
	            ratting: nextValue
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({ rated: 1 });
	              _this3.setState({
	                ratting_text: '' + _language2.default.LC().RATED + nextValue + ' ' + 'stars'
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this4 = this;
	
	        var result, storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context5.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context5.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                user_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 6;
	                              break;
	                            }
	
	                            _this4._runCode('free');
	                            _this4.setState({ subscriptionstatus: 'free' });
	                            _context4.next = 11;
	                            break;
	
	                          case 6:
	                            _this4.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context3.next = 6;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context3.sent;
	
	                                        if (isInArray_var) {
	                                          _this4._runCode('paid');
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4._runCode('free');
	                                          _this4.setState({ subscriptionstatus: 'free' });
	                                        }
	                                        _context3.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this4);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context4.next = 14;
	                            break;
	
	                          case 13:
	                            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	                              _this4._runCode('free');
	                              _this4.setState({ subscriptionstatus: 'free' });
	                            } else {
	                              _this4.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this4.state.token,
	                                idname: _this4.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this4.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    _this4._runCode('paid');
	                                    _this4.setState({ subscriptionstatus: 'paid' });
	                                  } else {
	                                    _this4._runCode('free');
	                                    _this4.setState({ subscriptionstatus: 'free' });
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 14:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this4);
	                  }));
	
	                  return function (_x4) {
	                    return _ref4.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: '_runCode',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(subscriptionstatus) {
	        var _this5 = this;
	
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                // console.log("subscriptionstatus")
	                // console.log(subscriptionstatus)
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  subscriptionstatus: subscriptionstatus
	                };
	                // console.log('data------------------------', data);
	                /*Api to call all question by chapter ,reading wise without limit and offset*/
	
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestions_allcr', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var questionDetails, offset_res, i, retun_all_question, all_questions, params;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context6.next = 24;
	                              break;
	                            }
	
	                            _this5.setState({ ValidToken: true });
	                            _this5.setState({ all_questions_state: resp.questions });
	                            questionDetails = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this5.props.params.id) {
	                                questionDetails = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i == resp.questions.length - 1) {
	                                _this5.setState({ choice: '', clicked: false, display_loader: 'hide_block' });
	                              }
	                            }
	                            _this5.setQuestionState(questionDetails);
	
	                            _context6.next = 9;
	                            return _this5.setState({
	                              offset: offset_res,
	                              question_length: resp.questions.length
	                            });
	
	                          case 9:
	                            retun_all_question = JSON.stringify(_this5.state.questions);
	                            all_questions = JSON.parse(retun_all_question);
	                            _context6.next = 13;
	                            return _this5.setState({ all_questions: all_questions });
	
	                          case 13:
	
	                            if (offset_res == 0) {
	                              _this5.setState({ previ_block: 'card hide_block' });
	                            }
	
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this5.setState({ next_block: 'card hide_block' });
	                            }
	
	                            params = {
	                              token: _this5.state.token,
	                              question_id: questionDetails.id,
	                              idname: _this5.state.idname
	                            };
	                            //Api to Fetch saved question stats
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavQuestions', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({
	                                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                                  isFlashCardHidden: false
	                                });
	                                _this5.setState({
	                                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	                                });
	                                _this5.setState({ bookmarkColor: 'rgb(54, 141, 84)', isFlashCardHidden: false });
	                                _this5.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	                              } else {
	                                _this5.setState({ isFlashCardHidden: true });
	                              }
	                            });
	                            params = {
	                              token: _this5.state.token,
	                              question_id: questionDetails.id,
	                              idname: _this5.state.idname
	                            };
	                            //Api to get ratting
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({ rated: true });
	                                response.ratting.map(function (items) {
	                                  _this5.setState({ rating: items.ratting });
	                                  _this5.setState({ ratting_text: '' + _language2.default.LC().RATED });
	                                });
	                              }
	                            });
	                            params = {
	                              token: _this5.state.token,
	                              idname: _this5.state.idname,
	                              question_id: questionDetails.id
	                            };
	                            //Api to fetch flashcard by question id
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(function (response) {
	                              if (response.success) {
	                                _this5.setState({ ValidToken: true });
	                                if (response.flash_cards.length > 0) {
	                                  _this5.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                                  var flash_cards = response.flash_cards.map(function (items, index) {
	                                    return (
	                                      //alert(items.id)
	                                      _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: '' },
	                                          _react2.default.createElement(
	                                            'ul',
	                                            { className: 'icon_list' },
	                                            _react2.default.createElement(
	                                              'li',
	                                              null,
	                                              _react2.default.createElement(
	                                                'a',
	                                                { className: 'pointer_class', onClick: _this5._editFlash.bind(_this5, items) },
	                                                _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                              )
	                                            ),
	                                            _react2.default.createElement(
	                                              'li',
	                                              null,
	                                              _react2.default.createElement(
	                                                'a',
	                                                {
	                                                  className: 'pointer_class',
	                                                  onClick: _this5._deleteFlash.bind(_this5, items)
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-close' })
	                                              )
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'div',
	                                            { className: _this5.state.flash_class },
	                                            _react2.default.createElement('h4', null),
	                                            _react2.default.createElement(
	                                              'p',
	                                              null,
	                                              items.flash_card
	                                            )
	                                          )
	                                        )
	                                      )
	                                    );
	                                  });
	                                } else {
	                                  _this5.setState({
	                                    flash_form: 'col-sm-12 col-md-12 display_block'
	                                  });
	                                  var flash_cards = _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _language2.default.LC().NO_FLASHCARD_FOUND
	                                  );
	                                }
	                                _this5.setState({ flash_data: flash_cards });
	                              } else {
	                                var flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                                _this5.setState({ ValidToken: false });
	                                _this5.setState({ flash_data: flash_cards });
	                                _this5.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	                              }
	                              return response;
	                            });
	
	                            _this5.setState({ records: '' });
	                            _context6.next = 26;
	                            break;
	
	                          case 24:
	                            _this5.setState({ ValidToken: false });
	                            _this5.setState({ records: '' + _language2.default.LC().Result_not_found });
	
	                          case 26:
	                            return _context6.abrupt('return', resp);
	
	                          case 27:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this5);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getChapterbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this5.setState({ chapter_name: resp.chapters[0].chapter_name });
	                  } else {
	                    // console.log('Chapter Name Not Found');
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function _runCode(_x6) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return _runCode;
	    }()
	
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      //console.log(this.props);
	      // var subscription=this.state.subscriptionstatus;
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	  }, {
	    key: '_changeContent',
	
	
	    /*on url change run this function*/
	
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val, subscription) {
	      var _this6 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      // console.log("subscriptionstatus")
	      // console.log(this.state.subscriptionstatus)
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success) {
	          _this6.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block'
	          });
	          var questionDetails = [];
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (resp.questions[i].id == _this6.props.params.id) {
	              questionDetails = resp.questions[i];
	            }
	          }
	          var questions = _this6.state.questions;
	
	
	          _this6.setQuestionState(questionDetails);
	
	          _this6.setState({ display_loader: 'hide_block' });
	          var params = {
	            token: _this6.state.token,
	            question_id: questionDetails.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavQuestions', params).then(function (response) {
	            // console.log(response);
	            // console.log("getFavQuestions");
	            if (response.success) {
	              _this6.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10'
	              });
	              _this6.setState({
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark'
	              });
	              _this6.setState({ save_text: '' + _language2.default.LC().Question_Saved });
	              _this6.setState({ bookmarkColor: 'rgb(54, 141, 84)', isFlashCardHidden: false });
	            }
	          });
	          var params = {
	            token: _this6.state.token,
	            question_id: questionDetails.id,
	            idname: _this6.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ rated: true });
	              response.ratting.map(function (items) {
	                _this6.setState({ rating: items.ratting });
	                _this6.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              });
	            }
	          });
	          var params = {
	            token: _this6.state.token,
	            idname: _this6.state.idname,
	            question_id: questionDetails.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this6.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this6.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this6._editFlash.bind(_this6, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this6._deleteFlash.bind(_this6, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this6.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this6.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this6.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this6.setState({ ValidToken: false });
	              _this6.setState({ flash_data: flash_cards });
	              _this6.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
	            }
	            return response;
	          });
	          _this6.setState({ records: '' });
	        } else {
	          _this6.setState({ ValidToken: false });
	          _this6.setState({ records: '' + _language2.default.LC().Result_not_found });
	        }
	
	        return resp;
	      });
	      this.setState({ timer_stop: false });
	      this.setState({ timer_tag: '' + _language2.default.LC().STOP });
	      this.setState({ count: 0 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          validated = _state.validated,
	          choice = _state.choice,
	          count = _state.count,
	          isTimer = _state.isTimer,
	          isError = _state.isError;
	
	      var forumData = '';
	      var data = '';
	      var retun_all_question = JSON.stringify(this.state.questions);
	      var all_questions = JSON.parse(retun_all_question);
	
	      if (all_questions != '') {
	        forumData = '<div class="col-sm-12 no-cursor" >\n            <div class="margin_bottom_40">\n                <div >\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="row no-cursor">\n                                <div class="col-sm-12 cursor-text">\n                                    <div contentEditable=\'false\' class="margin_bottom_40 view_questionhtml bg_blue "> ' + all_questions.question + ' </div>\n                                </div>\n                                <div class="col-sm-12 no-cursor" id="choice_a" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().A + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_a + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 no-cursor" id="choice_b">\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().B + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>  ' + all_questions.choice_b + ' </span></p>\n                                    </div>\n                                </div>\n                                \n                                <div class="col-sm-12 no-cursor" id="choice_c" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().C + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>\n                                        ' + all_questions.choice_c + '\n                                        </span></p>\n                                    </div>\n                                    </div>\n\n                                    <div class="col-sm-12 no-cursor" id="choice_d" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().D + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_d + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 no-cursor margin_bottom_30" id="choice_e" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().E + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_e + ' </span></p>\n                                    </div>\n                                </div>\n\n                                <div class="col-sm-12 cursor-text">\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> \n                                  ' + _language2.default.LC().THE_CORRECT_ANSWER_IS + ' ' + this.state.choice_name + ').</p>\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> ' + all_questions.answer + '</p>\n                                </div>\n                                <div class="col-sm-12 margin_bottom_30 no-cursor">\n\n                                <div class="userQuestionDiv">\n                                <span class="questionColor cursor-text"> *User Question: </span>\n                                <div class="forum-data-comment cursor-text">\n                                  <h4> ' + this.state.forumComment + ' \n                                  </h4>\n                                </div>\n                                </div>\n                              </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>';
	
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, 'span', '', { contentEditable: 'false' }),
	              ' (',
	              _language2.default.LC().Q,
	              ' ',
	              all_questions.id,
	              ')',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(_ViewQuestion2.default, Object.assign({}, questions, this.props, {
	                      setAnswer: this.setAnswer,
	                      showAnswer: validated,
	                      correctChoice: questions && questions.right_choice,
	                      selectedChoice: choice
	                    })),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { md: 12, className: 'mt-2' },
	                      isError && _react2.default.createElement(
	                        'p',
	                        { className: 'text-danger' },
	                        _messages.messages.NO_CHOICE_SELECTED
	                      ),
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        { className: 'align-items-center' },
	                        _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                          isQue: true,
	                          showResult: validated,
	                          _getResult: this.handleQuestionValidate,
	                          _saveQuestion: this._saveQuestion,
	                          _displayReportForm: this._displayReportForm,
	                          all_questions: all_questions,
	                          save_text: this.state.save_text,
	                          bookmarkCSS: this.state.bookmarkCSS,
	                          bookmarkColor: this.state.bookmarkColor
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'star_rating_wrap' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: ' margin_bottom_0 margin_right_10' },
	                              this.state.ratting_text
	                            ),
	                            _react2.default.createElement(_reactStarRatings2.default, {
	                              rating: this.state.rating,
	                              starRatedColor: 'rgb(255, 180, 0)',
	                              starEmptyColor: 'rgb(51, 51, 51)',
	                              starDimension: '20px',
	                              starHoverColor: 'rgb(255, 180, 0)',
	                              starSpacing: '2px',
	                              changeRating: this.onStarClick.bind(this, all_questions),
	                              numberOfStars: 5,
	                              name: 'rate1'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(_ForwardTimer2.default, {
	                    isRunning: isTimer,
	                    startTimeInSeconds: count,
	                    validated: validated,
	                    onTick: function onTick(time) {
	                      return _this7.onTick(time);
	                    },
	                    toggleTimer: function toggleTimer() {
	                      return _this7.setState({ isTimer: !_this7.state.isTimer });
	                    }
	                  }),
	                  this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	                    'a',
	                    {
	                      onClick: this._getSubscribe,
	                      className: 'box_question_color text-center cursor_pointer'
	                    },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS,
	                      ' '
	                    )
	                  ) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().THE_CORRECT_ANSWER_IS,
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.choice_name,
	                  '.'
	                )
	              ),
	              (0, _function.renderHTMLContent)(all_questions.answer, 'p', 'view_questionhtml', {
	                contentEditable: 'false'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this._reportQuestion.bind(this, all_questions)
	                    },
	                    ' ',
	                    reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, all_questions)
	                    },
	                    ' ',
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else {
	        /*data = <div className="col-sm-12 col-md-12">
	            <div className="no_data_bar card">No Records Found</div></div>;*/
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_10 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUESTION_BANK
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getQuestions
	                },
	                _language2.default.LC().CHANGE_QUESTIONS
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_CHAPTER
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'question',
	            question_type: 'question',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'gmat_focus'
	          })
	        ),
	        this.state.display_loader === 'show_block' ? _react2.default.createElement(_loader2.default, null) : null
	      );
	    }
	  }]);
	
	  return GMATBeginchapters;
	}(_react.Component);
	
	GMATBeginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this8 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this8.toggle = _this8.toggle.bind(_this8);
	    _this8.state = {
	      tooltipOpen: false
	    };
	    return _this8;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATBeginchapters;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMAT_QUESTION_BANK = function (_Component) {
	  _inherits(GMAT_QUESTION_BANK, _Component);
	
	  function GMAT_QUESTION_BANK(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMAT_QUESTION_BANK);
	
	    var _this = _possibleConstructorReturn(this, (GMAT_QUESTION_BANK.__proto__ || Object.getPrototypeOf(GMAT_QUESTION_BANK)).call(this, props));
	
	    _this._getReadings = function (chapter) {
	      // console.log('chapterchapterchapterchapterchapterchapterchapter', chapter);
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', chapter.chapter_no)
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: chapter.chapter_no,
	        //   chapterName: chapter.chapter_name,
	        // },
	      });
	    };
	
	    _this.goToQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: _appRoutes2.default.QUESTION_BANK_VIEW_QUE.replace(':notesid', lastRecord.gmat_focus_question.chapter_id).replace(':readingid', lastRecord.gmat_focus_question.reading_id).replace(':id', lastRecord.gmat_focus_question.id).replace(':offset', 0)
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      token: '',
	      lastRecord: '',
	      lastAttempt: false,
	      idname: '',
	      freeChapterCount: [],
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(GMAT_QUESTION_BANK, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ alert_status: !this.state.alert_status });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getChapters', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context2.next = 6;
	                    break;
	                  }
	
	                  _this3.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    IRCount: resp.GMATIRTable,
	                    IRPremiumQuestionCount: resp.IRPremiumQuestionCount,
	                    question: resp.question,
	                    reading: resp.reading,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  _context2.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context2.next = 7;
	                  break;
	
	                case 6:
	                  _this3.setState({ ValidToken: false });
	
	                case 7:
	                  return _context2.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      if (this.state.chapters.length) {
	        data = this.state.chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box', key: index },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                key: item.id
	                // eslint-disable-next-line no-underscore-dangle
	                , onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                  className: '',
	                  width: '54',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.chapter_no
	                    // eslint-disable-next-line no-underscore-dangle
	                    , onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  item.chapter_no,
	                  '. ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                      className: '',
	                      width: '25',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item[_this4.state.reading + '.readingCount']
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_READINGS
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                      className: '',
	                      width: '26',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    !item.chapter_name.includes('Integrated Reasoning') ? item[_this4.state.question + '.freeQuestionsCount'] : _this4.state.IRCount
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().FREE_QUESTIONS
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                      className: '',
	                      width: '23',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    !item.chapter_name.includes('Integrated Reasoning') ? item[_this4.state.question + '.premiumQuestionsCount'] : _this4.state.IRPremiumQuestionCount
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().PREMIUM_QUESTIONS
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().CFA_LEVEL_I_QUESTION_BANK,
	            ' '
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.GMAT_FOCUS }),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMAT_QUESTION_BANK;
	}(_react.Component);
	
	GMAT_QUESTION_BANK.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = GMAT_QUESTION_BANK;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _questionNotFoundModel = __webpack_require__(104);
	
	var _questionNotFoundModel2 = _interopRequireDefault(_questionNotFoundModel);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import App_data from "../config/App_data";
	
	// import GD from "../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var GMATReadings = function (_Component) {
	  _inherits(GMATReadings, _Component);
	
	  function GMATReadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATReadings);
	
	    var _this = _possibleConstructorReturn(this, (GMATReadings.__proto__ || Object.getPrototypeOf(GMATReadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      // console.log('get00000=m,j,hjjkkjkj', reading);
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        // console.log('resp.profileInfo.userStatus', resp.profileInfo);
	
	                        _context.next = 6;
	                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var) {
	                          _this._runCode('paid', reading);
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free', reading);
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 10:
	                        console.log('fail');
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details,
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                if (isInArray_var) {
	                  _this._runCode('paid', reading);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free', reading);
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      // console.log('reading----------------------------', reading);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: _this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: _this.state.subscriptionstatus
	      };
	      if (reading.type === 'case_question') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCaseByReading', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.questions.length) {
	              _this.context.router.push({
	                pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':caseid', resp.questions[0].case_id).replace(':case_offset', 0).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', resp.questions[0].question_no).replace(':offset', 0)
	              });
	            } else {
	              _this.toggleAlert();
	            }
	          }
	        });
	      } else if (reading.type === 'tab_question') {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.TAB.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'graph_question') {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.GRAPH_MULTI_STATEMENT.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'table_question') {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.TABLE.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else if (reading.type === 'two_part_question') {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.TWO_PART_STATEMENT.replace(':chapterid', _this.state.chapterid).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', 1).replace(':offset', 0).replace(':reading', reading.reading)
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestions', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.questions.length) {
	              _this.context.router.push({
	                pathname: _appRoutes2.default.QUESTION_BANK_VIEW_QUE.replace(':notesid', _this.state.chapterid).replace(':readingid', reading.id).replace(':id', resp.questions[0].id).replace(':offset', 0)
	              });
	            } else {
	              _this.toggleAlert();
	            }
	          }
	        });
	      }
	    };
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context5.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context5.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context5.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context5.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context5.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context4.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context2.next = 6;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context2.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context4.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context4.next = 17;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context4.next = 23;
	                            break;
	
	                          case 17:
	                            // console.log(
	                            //   'resssssssssssssssss-----------',
	                            //   resp.profileInfo.subscription_details
	                            // );
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context3.next = 6;
	                                        return _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context3.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context3.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context3.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context3.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context3.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e) {
	        var user_data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context9.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context9.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context9.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context9.abrupt('return');
	
	              case 6:
	                user_data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname
	                };
	                _context9.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context8.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context6.next = 6;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context6.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context8.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context8.next = 17;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context8.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var_PDF, dataset;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context7.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var_PDF = false;
	                                        _context7.next = 6;
	                                        return _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var_PDF = _context7.sent;
	
	                                        if (!isInArray_var_PDF) {
	                                          _context7.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context7.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context7.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context7.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 23:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x6) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      alert_status_question_not_found: false,
	      pdfAlert: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	
	      MessageTitleOnQuestionNotFound: '' + _language2.default.LC().MESSAGE,
	      ComingSoon: '' + _language2.default.LC().COMING_SOON,
	
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.id,
	      chapterName: '',
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'gmat_focus',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      type: 'question',
	      PDFDownloadType: 'Question',
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATReadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      if (this.state.subscriptionstatus === 'free') {
	        this.setState({
	          alert_status: !this.state.alert_status
	        });
	      } else {
	        this.setState({
	          alert_status_question_not_found: !this.state.alert_status_question_not_found
	        });
	      }
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    //it is use to redirect page
	
	
	    //Function to redirect page to question bank page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus, reading) {
	      var _this3 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: reading.id,
	        chapter_id: this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          // if (resp.questions.length || reading.type !== 'case_question') {
	          if (resp.questions.length) {
	            // console.log('reading.type', reading);
	            _this3.context.router.push({
	              pathname: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', reading.chapter_no).replace(':id', reading.id).replace(':subscriptionstatus', subscriptionstatus).replace(':reading', reading.reading)
	            });
	            // }
	          } else {
	            _this3.toggleAlert();
	          }
	        }
	      });
	    }
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this4 = this;
	
	        var result, storage_session, data, user_data;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.chapterid
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this4.setState({ no_result_display: 'No Saved Questions' });
	                    }
	                  } else {
	                    _this4.setState({ ValidToken: false });
	                    (0, _toast.showFailure)('No readings found!!');
	                  }
	                  // return resp;
	                });
	
	                user_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context12.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context11.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context11.next = 5;
	                              break;
	                            }
	
	                            _this4.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context11.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this4.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, isInArray_var_PDF;
	                                return _regenerator2.default.wrap(function _callee10$(_context10) {
	                                  while (1) {
	                                    switch (_context10.prev = _context10.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context10.next = 15;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this4.state.selectedmenu;
	                                        isInArray_var = false;
	                                        isInArray_var_PDF = false;
	                                        _context10.next = 7;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                                      case 7:
	                                        isInArray_var = _context10.sent;
	
	                                        if (isInArray_var) {
	                                          _this4.setState({ subscriptionstatus: 'paid' });
	                                        } else {
	                                          _this4.setState({
	                                            subscriptionstatus: 'free',
	                                            showFreePremium: true
	                                          });
	                                        }
	                                        _context10.next = 11;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, _this4.state.type);
	
	                                      case 11:
	                                        isInArray_var_PDF = _context10.sent;
	
	
	                                        // console.log('isInArray_var_PDF', isInArray_var_PDF);
	                                        if (isInArray_var_PDF) {
	                                          _this4.setState({ showFreePremium: false });
	                                        } else {
	                                          _this4.setState({ showFreePremium: true });
	                                        }
	                                        _context10.next = 15;
	                                        break;
	
	                                      case 15:
	                                      case 'end':
	                                        return _context10.stop();
	                                    }
	                                  }
	                                }, _callee10, _this4);
	                              }));
	
	                              return function (_x11) {
	                                return _ref12.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 11:
	                            _context11.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '')) {
	                              _context11.next = 17;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            _this4.setState({
	                              showFreePremium: true,
	                              subscriptionstatus: 'free'
	                            });
	                            _context11.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this4.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this4.state.token,
	                              idname: _this4.state.idname,
	                              examid: data_arr
	                            };
	                            _context11.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              // console.log(resp_exam);
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this4.state.selectedmenu;
	                                var isInArray_var = false;
	                                var isInArray_var_PDF = false;
	                                isInArray_var = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this4.setState({ subscriptionstatus: 'paid' });
	                                } else {
	                                  _this4.setState({
	                                    subscriptionstatus: 'free',
	                                    showFreePremium: true
	                                  });
	                                }
	                                isInArray_var_PDF = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam, _this4.state.type);
	                                if (isInArray_var_PDF) {
	                                  _this4.setState({ showFreePremium: false });
	                                } else {
	                                  _this4.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 23:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this4);
	                  }));
	
	                  return function (_x10) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    /*
	    ------------------------------
	    PDF DOWNLOAD Via Email
	    -------------------------------
	    */
	
	    /*
	    --------------------------------
	    PDF DOWNLOAD Via email Answer
	    --------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          // console.log('item----------------', item.type);
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading_no,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            item.type === 'no_question' ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20 coming_soon_table' },
	                '-'
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: _this5._getQuestions.bind(_this5, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this5._beginChapter.bind(_this5, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                this.state.chapterName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getChapters
	                },
	                ' ',
	                _language2.default.LC().CHANGE_TOPIC,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().READING
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_questionNotFoundModel2.default, {
	          alert_status: this.state.alert_status_question_not_found,
	          toggleAlert: this.toggleAlert,
	          MessageTitle: this.state.MessageTitleOnQuestionNotFound,
	          MessageContent: this.state.ComingSoon
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return GMATReadings;
	}(_react.Component);
	
	GMATReadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATReadings;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TwoStatement = __webpack_require__(133);
	
	var _TwoStatement2 = _interopRequireDefault(_TwoStatement);
	
	var _twoStatementServices = __webpack_require__(141);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMAT2Statement = function (_Component) {
	  _inherits(GMAT2Statement, _Component);
	
	  function GMAT2Statement(props) {
	    _classCallCheck(this, GMAT2Statement);
	
	    var _this = _possibleConstructorReturn(this, (GMAT2Statement.__proto__ || Object.getPrototypeOf(GMAT2Statement)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _appRoutes2.default.TWO_PART_STATEMENT.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GMAT2Statement, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TwoStatement2.default, Object.assign({}, this.props, {
	          questionType: _constant.QUESTION_TYPE.TWO_PART_QUESTION,
	          examName: _constant.examNameAccordingToDB.GMAT_FOCUS,
	          apiServices: _twoStatementServices.apiServices,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return GMAT2Statement;
	}(_react.Component);
	
	GMAT2Statement.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GMAT2Statement;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	/* eslint-disable */
	
	var GMATCases = function (_Component) {
	  _inherits(GMATCases, _Component);
	
	  // =============================== TODO START =======================//
	  function GMATCases(props) {
	    _classCallCheck(this, GMATCases);
	
	    var _this = _possibleConstructorReturn(this, (GMATCases.__proto__ || Object.getPrototypeOf(GMATCases)).call(this, props));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', _this.props.params.chapterid)
	      });
	    };
	
	    _this._getQuestions = function () {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this.props.params.chapterid).replace(':id', _this.props.params.readingid).replace(':subscriptionstatus', _this.state.subscriptionstatus).replace(':reading', _this.state.questions.name)
	      });
	    };
	
	    _this._getAnswer = function (choice, questionId) {
	      _this.setState({ clicked: true, choice: 'choice_' + choice }, function () {
	        // console.log('choice ----> ', this.state.choice);
	      });
	      if (choice === 'a') {
	        _this.setState({
	          choice_a: 'answer_box clicked_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'b') {
	        _this.setState({
	          choice_b: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'c') {
	        _this.setState({
	          choice_c: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_d: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'd') {
	        _this.setState({
	          choice_d: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_e: 'answer_box'
	        });
	      } else if (choice === 'e') {
	        _this.setState({
	          choice_e: 'answer_box clicked_box',
	          choice_a: 'answer_box',
	          choice_b: 'answer_box',
	          choice_c: 'answer_box',
	          choice_d: 'answer_box'
	        });
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: questionId,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserRecord', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	        }
	      });
	    };
	
	    _this.handleQuestionValidate = function (item, e) {
	      // console.log(this.props.params.chapterid);
	      // console.log('item', item);
	      // console.log(this.props.params.case_offset);
	      // console.log(this.state.clicked, 'clicked');
	      // console.log(this.state.choice, 'this.state.choice');
	      if (_this.state.clicked) {
	        clearInterval(_this.timer);
	        // const chosen_answer = this.state.choice;
	        var right_answer = 0;
	        _this.setState({ result_block: 'card show_block' });
	        //console.log(item);
	        if (item.right_choice === _this.state.choice) {
	          right_answer = 1;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            result: 'CORRECT',
	            text_color: 'card-header text_success',
	            result_block: 'card show_block'
	          });
	        } else {
	          right_answer = 0;
	          if (_this.state.choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box failure' });
	          } else if (_this.state.choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box failure'
	            });
	          } else if (_this.state.choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box failure'
	            });
	          }
	          if (item.right_choice === 'choice_a') {
	            _this.setState({ choice_a: 'answer_box success' });
	          } else if (item.right_choice === 'choice_b') {
	            _this.setState({
	              choice_b: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_c') {
	            _this.setState({
	              choice_c: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_d') {
	            _this.setState({
	              choice_d: 'answer_box success'
	            });
	          } else if (item.right_choice === 'choice_e') {
	            _this.setState({
	              choice_e: 'answer_box success'
	            });
	          }
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: 'INCORRECT',
	            result_block: 'card show_block'
	          });
	        }
	        if (!_this.state.validated) {
	          var _this$state = _this.state,
	              token = _this$state.token,
	              idname = _this$state.idname,
	              time_done = _this$state.count,
	              selected_choice = _this$state.choice;
	          var question_id = item.id;
	          var _this$props$params = _this.props.params,
	              chapter_id = _this$props$params.chapterid,
	              caseIndex = _this$props$params.case_offset;
	
	          var data = {
	            token: token,
	            idname: idname,
	            question_id: question_id,
	            right_answer: right_answer,
	            time_done: time_done,
	            chapter_id: chapter_id,
	            caseIndex: caseIndex,
	            selected_choice: selected_choice
	          };
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveStats', data).then(function (resp) {
	            if (resp.success) {
	              _this.setState(function (prevState) {
	                return {
	                  ValidToken: true,
	                  validated: true,
	                  all_questions_state: prevState.all_questions_state.map(function (question) {
	                    return question.id === question_id ? Object.assign({}, question, {
	                      'gmat_focus_question_stat.isSelectedChoice': right_answer,
	                      'gmat_focus_question_stat.selected_choice': selected_choice
	                    }) : question;
	                  })
	                };
	              });
	            } else {
	              _this.setState({ ValidToken: false });
	            }
	            return resp;
	          });
	        }
	      } else {
	        _this.setState({
	          isError: true
	        });
	      }
	    };
	
	    _this._timer_funct = function (item, e) {
	      if (_this.state.timer_stop) {
	        _this.setState({ timer_stop: false, timer_tag: 'Stop' });
	        clearInterval(_this.timer);
	        _this.timer = setInterval(_this.tick.bind(_this), 1000);
	      } else {
	        _this.setState({
	          timer_stop: true
	        });
	        clearInterval(_this.timer);
	      }
	    };
	
	    _this._saveQuestion = function (item, e) {
	      console.log('save Question ------> ', item);
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        chapter_id: _this.props.params.chapterid,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      console.log('items ----------> ', item);
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        caseIndex: _this.props.params.case_offset,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip,
	        topic_name: item.name,
	        reading_id: item.reading_id
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(function (response) {
	            var flash_cards = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._editFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this._deleteFlash.bind(_this, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            'No Flash Card Found'
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          caseid = _this$props$params2.caseid,
	          case_offset = _this$props$params2.case_offset,
	          readingid = _this$props$params2.readingid;
	
	      if (_this.state.questions.question_number === 6) {
	        _this.setState({ showCompletionQuestion: true });
	      } else {
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          isError: false,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = parseInt(_this.props.params.offset, 10) + 1;
	        _this.setState({ offset: i });
	        _this.context.router.push({
	          pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':caseid', caseid).replace(':case_offset', case_offset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_questions_state[i].question_no).replace(':offset', i)
	        });
	      }
	    };
	
	    _this._getNextAnyway = function () {
	      // console.log(this.state.questions)
	      _this.setState({
	        display_loader: 'show_block',
	        showCompletionQuestion: false
	      });
	      if (_this.props.params.question_number === _this.state.casesquestion_length) {
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          isError: false,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var i = 0;
	        _this.setState({ offset: i });
	
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[i].question_number + '/' + 0,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: i,
	            offset: 0
	          }
	        });
	      } else {
	        //alert(this.state.casesquestion_length);
	        _this.setState({
	          validated: false,
	          rated: false,
	          rating: 0,
	          ratting_text: 'Rate this Question',
	          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	          save_text: '' + _language2.default.LC().SAVE_QUESTION,
	          timerstopbtn: 'pause_btn icon-control-pause',
	          report_block: 'card hide_block'
	        });
	        var _i = _this.state.offset + 1;
	        _this.setState({ offset: _i });
	        //alert(i);
	        _this.context.router.push({
	          pathname: '/cfa2_chapter/' + _this.props.params.chapterid + '/' + _this.props.params.caseid + '/' + _this.props.params.case_offset + '/' + _this.state.all_questions_state[_i].question_number + '/' + _i,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapterid: _this.props.params.chapterid,
	            caseid: _this.props.params.caseid,
	            case_offset: _this.props.params.case_offset,
	            question_number: _i,
	            offset: _i
	          }
	        });
	      }
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        validated: false,
	        rated: false,
	        isError: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      document.getElementById('comment').value = '';
	      var _this$props$params3 = _this.props.params,
	          chapterid = _this$props$params3.chapterid,
	          caseid = _this$props$params3.caseid,
	          case_offset = _this$props$params3.case_offset,
	          readingid = _this$props$params3.readingid;
	
	      var i = parseInt(_this.props.params.offset, 10) - 1;
	      _this.setState({ offset: i });
	      _this.context.router.push({
	        pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':caseid', caseid).replace(':case_offset', case_offset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_questions_state[i].question_no).replace(':offset', i)
	      });
	    };
	
	    _this._getNextCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block',
	        isError: false
	      });
	      var casesoffset = parseInt(_this.props.params.case_offset, 10) + 1;
	      var caseid = '';
	      if (_this.state.cases_length > casesoffset) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	        caseid = _this.state.all_cases[casesoffset].case_id;
	
	        _this.context.router.push({
	          pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	        //this.setState({all_cases:caseid});
	        // this.context.router.push({
	        //   pathname:
	        //     '/cfa2_chapter/' +
	        //     this.props.params.chapterid +
	        //     '/' +
	        //     caseid +
	        //     '/' +
	        //     casesoffset +
	        //     '/' +
	        //     '1' +
	        //     '/' +
	        //     0,
	        //   state: {
	        //     token: this.state.token,
	        //     idname: this.state.idname,
	        //     chapterid: this.props.params.chapterid,
	        //     caseid: caseid,
	        //     case_offset: casesoffset,
	        //     question_number: 1,
	        //     offset: 0,
	        //   },
	        // });
	      } else {
	        _this.setState({ cases_offset: 0 });
	        caseid = _this.state.all_cases[0].id;
	      }
	    };
	
	    _this._getPreviousCase = function () {
	      _this.setState({
	        display_cases: 'hide_block',
	        display_subcription: 'hide_block',
	        isError: false
	      });
	      // const casesoffset = parseInt(this.state.cases_offset, 10) + 1;
	      var casesoffset = _this.props.params.case_offset - 1;
	      var caseid = _this.state.all_cases[casesoffset].case_id;
	      if (_this.state.cases_offset === 0) {
	        _this.setState({
	          cases_offset: casesoffset
	        });
	      } else {
	        _this.setState({ cases_offset: casesoffset });
	        _this.context.router.push({
	          pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', _this.props.params.chapterid).replace(':readingid', _this.props.params.readingid).replace(':caseid', caseid).replace(':case_offset', casesoffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', _this.state.all_cases[casesoffset].question_no).replace(':offset', 0)
	        });
	      }
	    };
	
	    _this.getSelectedChoice = function (question, selected) {
	      console.log('getSelectedChoice', question, selected);
	
	      if (selected === 1) {
	        return question.right_choice;
	      }
	
	      var selectedChoice = question['gmat_focus_question_stat.selected_choice'];
	      if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
	        return selectedChoice;
	      }
	
	      var wrongChoices = _constant.CHOICE_KEYS.filter(function (choice) {
	        return choice !== question.right_choice;
	      });
	      var randomWrong = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];
	
	      return randomWrong;
	    };
	
	    _this.setQuestionState = function (questionDetails) {
	      var selectedChoice = questionDetails['gmat_focus_question_stat.isSelectedChoice'];
	      var hasSelectedChoice = selectedChoice !== null && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.GMAT_FOCUS);
	      var right_choice = questionDetails.right_choice;
	
	
	      _this.setState({
	        choice_name: _constant.CHOICE_MAPPING[right_choice] || '',
	        isSelectedChoice: selectedChoice || null,
	        choice: hasSelectedChoice ? _this.getSelectedChoice(questionDetails, selectedChoice) : null,
	        clicked: hasSelectedChoice,
	        validated: hasSelectedChoice,
	        result_block: 'card ' + (hasSelectedChoice ? 'show_block' : 'hide_block')
	      }, function () {
	        if (hasSelectedChoice) {
	          _this.handleQuestionValidate(questionDetails);
	        }
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.expandScreen = function () {
	      _this.setState({
	        isExpand: true
	      });
	      var elem = document.getElementById('Progress1');
	      if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	      } else if (elem.webkitRequestFullscreen) {
	        /* Safari */
	        elem.webkitRequestFullscreen();
	      } else if (elem.msRequestFullscreen) {
	        /* IE11 */
	        elem.msRequestFullscreen();
	      }
	    };
	
	    _this.closeFullscreen = function () {
	      _this.setState({
	        isExpand: false
	      });
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        /* Safari */
	        document.webkitExitFullscreen();
	      } else if (document.msExitFullscreen) {
	        /* IE11 */
	        document.msExitFullscreen();
	      }
	    };
	
	    _this.getFavQuestions = function (questionid) {
	      var params_fav = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname'],
	        chapter_id: _this.props.params.chapterid
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavQuestions', params_fav).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved,
	            isFlashCardHidden: false
	          });
	        } else {
	          _this.setState({ isFlashCardHidden: true, bookmarkColor: '' });
	        }
	      });
	    };
	
	    _this.getGMATRatting = function (questionid) {
	      // console.log('I am inside getGMATRatting', questionid);
	      var params = {
	        token: storage_session['token'],
	        question_id: questionid,
	        idname: storage_session['idname']
	      };
	      //Api to get ratting
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(function (response) {
	        if (response.success) {
	          _this.setState({ rated: true });
	          response.ratting.map(function (items) {
	            return _this.setState({
	              rating: items.ratting,
	              ratting_text: 'Rated '
	            });
	          });
	        }
	      });
	    };
	
	    _this.getFlashCards = function (questionid) {
	      var params = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        question_id: questionid
	      };
	      //Api to fetch flashcard by question id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(function (response) {
	        var flash_cards = _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_FLASHCARD_FOUND
	        );
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          if (response.flash_cards.length > 0) {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	            });
	            flash_cards = response.flash_cards.map(function (items, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _this.state.flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      items.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({
	              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	            });
	          }
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({
	            ValidToken: false,
	            flash_data: flash_cards,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	        }
	        return response;
	      });
	    };
	
	    _this.checkSubscription = function (SubscriptionFile, resp, resp_cases) {
	      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage === '' && resp.profileInfo.cfaUnlimitedActiveExam === '') {
	        //here code for check case id free or not
	        _this.setState({
	          subscriptionstatus: 'free'
	        });
	        if (resp_cases.casesingleData.free === 0) {
	          _this.setState({
	            display_cases: 'hide_block',
	            display_subcription: 'show_block'
	          });
	          _this.toggleAlert();
	        } else {
	          _this.setState({
	            display_cases: 'show_block',
	            display_subcription: 'hide_block'
	          });
	        }
	      } else {
	        _this.setState({
	          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	        });
	        //console.log(resp_cases.casesingleData.free+'----------');
	        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	        var dataset = {
	          token: storage_session['token'],
	          idname: storage_session['idname'],
	          examid: data_arr
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	          if (resp_exam.success) {
	            var exam_data = resp_exam.examData;
	            var selectedmen = _this.state.selectedmenu;
	            var isInArray_var = false;
	            isInArray_var = SubscriptionFile.checkCfa2Subscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	            if (isInArray_var) {
	              _this.setState({
	                subscriptionstatus: 'paid',
	                display_cases: 'show_block',
	                display_subcription: 'hide_block'
	              });
	            } else {
	              if (resp_cases.casesingleData.free === 0) {
	                _this.setState({
	                  display_cases: 'hide_block',
	                  display_subcription: 'show_block'
	                });
	              } else {
	                _this.setState({
	                  subscriptionstatus: 'free',
	                  display_cases: 'show_block',
	                  display_subcription: 'hide_block'
	                });
	              }
	            }
	          } else {
	            console.log('fail');
	          }
	        });
	      }
	    };
	
	    _this.setAnswer = function (answer) {
	      _this.setState({ choice: answer[0], clicked: true });
	    };
	
	    _this.state = {
	      isExpand: false,
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      isError: false,
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'pause_btn icon-control-pause',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      chaptername: '',
	      all_cases: [],
	      cases_display: '',
	      cases_name: '',
	      cases_length: '',
	      case_id: '',
	      cases_offset: '',
	      casesquestion_length: '',
	      chapters: '',
	      display_loader: '',
	      selectedmenu: 'cfa_2',
	      subscriptionstatus: '',
	      display_subcription: 'hide_block',
	      display_cases: 'show_block',
	      showCompletionQuestion: false,
	      markAsCompleted: false,
	      markAsNotCompleted: false,
	      markCompleted: true,
	      cases: [],
	      exam_type: 'cfa_2',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      forumComment: '',
	      category: 'CFA Level 2',
	      tags: ['cfa-2', 'cfa', 'question', 'case'],
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      hide_case_left_arrow: '',
	      hide_case_right_arrow: '',
	      hide_question_left_arrow: '',
	      hide_question_right_arrow: '',
	      display_main_loader: 'hide_block',
	      top_50: '',
	      question_no: 1
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(GMATCases, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: 'changeCompletionStatus',
	    value: function changeCompletionStatus(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        case_no: this.state.cases.casesingleData.case_number,
	        completion_status: this.state.markAsCompleted,
	        exam_type: this.state.exam_type,
	        chapter_id: this.props.params.chapterid
	      };
	      if (this.state.markAsCompleted === true) {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/updateCases', data).then(function (resp) {
	          if (resp.success) {
	            _this2._getReadings();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'markCompleted',
	    value: function markCompleted() {
	      this.setState({
	        markAsCompleted: true,
	        markAsNotCompleted: false,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'markNotCompleted',
	    value: function markNotCompleted() {
	      this.setState({
	        markAsCompleted: false,
	        markAsNotCompleted: true,
	        markCompleted: false
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    ---------------------------------------------
	      Function to change, time every second
	    ---------------------------------------------
	    */
	
	  }, {
	    key: 'tick',
	    value: function tick() {
	      this.setState({ count: this.state.count + 1 });
	      //console.log(this.state.count + 1);
	    }
	
	    /*
	    -------------------------------------------------
	      Function to redirect page to readings page
	    -------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------------------------------
	      Function to check Right Or Wrong Answered and displayed clicked box
	    -----------------------------------------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	      */
	
	
	    /*
	    ------------------------------------------------------------------------
	       Function to Display Saved Question on button and save in database
	    -------------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'onStarClick',
	
	
	    /*
	    -------------------------------------
	      Function to give star rattings
	    -------------------------------------
	      */
	    value: function onStarClick(item, nextValue, prevValue, name) {
	      var _this3 = this;
	
	      if (prevValue !== nextValue) {
	        var _params = {
	          token: this.state.token,
	          idname: this.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/UpdateGMATRatting', _params).then(function (response) {
	          if (response.success) {
	            _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	          }
	        });
	      }
	
	      this.setState({ rating: nextValue });
	      var params = {
	        token: this.state.token,
	        question_id: item.id,
	        idname: this.state.idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(function (response) {
	        var params = {
	          token: _this3.state.token,
	          idname: _this3.state.idname,
	          question_id: item.id,
	          ratting: nextValue
	        };
	        if (response.success) {
	          if (response.ratting.length > 0) {
	            _this3.setState({ rated: true });
	            response.ratting.map(function (items) {
	              return _this3.setState({ rating: items.ratting, ratting_text: 'Rated ' });
	            });
	          } else {
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveGMATRatting', params).then(function (response) {
	              if (response.success) {
	                _this3.setState({ rated: 1, ratting_text: 'Rated ' });
	              }
	            });
	          }
	        } else {
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveGMATRatting', params).then(function (response) {
	            if (response.success) {
	              _this3.setState({
	                rated: 1,
	                ratting_text: 'Rated ' + nextValue + ' stars'
	              });
	            }
	          });
	        }
	      });
	    }
	
	    /*
	    --------------------------------------
	      Function to show Report box
	    -------------------------------------
	      */
	
	
	    /*
	    -------------------------------------------
	      Funcion to save new report question
	    -------------------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to hide Report box
	    ---------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	      */
	
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ---------------------------------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to Edit Flash card
	    ---------------------------------
	    */
	
	
	    /*
	    --------------------------------------
	       Function to delete flash card
	    --------------------------------------
	    */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.question_number !== this.props.params.question_number && nextProps.params.caseid === this.props.params.caseid) {
	        // console.log('I am here for pffset ----. ', nextProps.params.offset);
	        this._changeQuestion(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        // this.setState({ display_loader: 'show_block' });
	      }
	
	      if (nextProps.params.caseid !== this.props.params.caseid) {
	        this._changeCase(nextProps.params.chapterid, nextProps.params.caseid, nextProps.params.case_offset, nextProps.params.question_number, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*
	    ------------------------------------------------------
	    on url question offset change run this function
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: '_changeQuestion',
	    value: function _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      // console.log('all_cases ----> ', case_offset);
	      // console.log('all_questions_state -----> ', question_number);
	      this.setState({
	        case_id: caseid,
	        display_main_loader: 'show_block',
	        display_cases: 'hide_block',
	        top_50: 'top-50',
	        choice: '',
	        validated: false,
	        ValidToken: true,
	        choice_a: 'answer_box',
	        choice_b: 'answer_box',
	        choice_c: 'answer_box',
	        choice_d: 'answer_box',
	        choice_e: 'answer_box',
	        result_block: 'card hide_block',
	        rated: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        timerstopbtn: 'pause_btn icon-control-pause',
	        report_block: 'card hide_block'
	      });
	      // var data = {
	      //   token: token_id,
	      //   idname: idname,
	      //   chapter_id: chapterid,
	      //   reading_id: this.props.params.readingid,
	      //   case_id: caseid,
	      // };
	      var all_questions_state = this.state.all_questions_state;
	
	      var offset_res = '';
	      var questionid = '';
	      // console.log(questionid);
	      for (var i = 0; i < all_questions_state.length; i++) {
	        if (i === parseInt(offset_val, 10)) {
	          this.setState({
	            hide_question_left_arrow: '',
	            hide_question_right_arrow: ''
	          });
	          if (i === 0) this.setState({
	            hide_question_left_arrow: 'menu_hide'
	          });else if (i === all_questions_state.length - 1) this.setState({
	            hide_question_right_arrow: 'menu_hide'
	          });
	          offset_res = i;
	          questionid = all_questions_state[i].id;
	          // console.log(all_questions_state[i]);
	          this.setState({
	            questions: all_questions_state[i],
	            offset: offset_res,
	            display_main_loader: 'hide_block',
	            top_50: '',
	            question_no: i + 1
	          });
	          this.setQuestionState(all_questions_state[i]);
	          this.getFavQuestions(all_questions_state[i].id);
	          this.getGMATRatting(all_questions_state[i].id);
	          this.getFlashCards(all_questions_state[i].id);
	        }
	        if (i === all_questions_state.length - 1) {
	          this.setState({
	            display_loader: 'hide_block',
	            display_cases: 'show_block'
	          });
	        }
	      }
	      // this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax
	
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	  }, {
	    key: '_changeCase',
	    value: function _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
	      var _this4 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        chapter_id: chapterid,
	        case_id: caseid,
	        reading_id: this.props.params.readingid,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      this.setState({
	        cases_display: '',
	        cases_name: ''
	      });
	
	      this.setState({ case_id: caseid });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCaseByReading', data).then(function (resp) {
	        if (resp.success) {
	          _this4.setState({
	            ValidToken: true,
	            choice_a: 'answer_box',
	            choice_b: 'answer_box',
	            choice_c: 'answer_box',
	            choice_d: 'answer_box',
	            choice_e: 'answer_box',
	            result_block: 'card hide_block',
	            rated: false,
	            rating: 0,
	            ratting_text: 'Rate this Question',
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            timerstopbtn: 'pause_btn icon-control-pause',
	            report_block: 'card hide_block',
	            display_main_loader: 'show_block',
	            top_50: 'top-50'
	            // hide_question_right_arrow: 'menu_show',
	            // hide_question_left_arrow: 'menu_hide',
	          });
	          document.getElementById('comment').value = '';
	          _this4.setState({ all_cases: resp.questions });
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (parseInt(_this4.props.params.case_offset, 10) === i) {
	              _this4.setState({
	                hide_case_left_arrow: '',
	                hide_case_right_arrow: ''
	              });
	              if (i === 0) _this4.setState({ hide_case_left_arrow: 'true' });else if (i === resp.questions.length - 1) _this4.setState({ hide_case_right_arrow: 'true' });
	
	              _this4.setState({
	                cases_display: resp.questions[i]['gmat_focus_case.passage'],
	                cases_name: 'Case no : ' + (parseInt(i, 10) + 1)
	              });
	            }
	          }
	          _this4.setState({ display_loader: 'hide_block' });
	          var param = {
	            token: token_id,
	            idname: idname,
	            case_id: caseid,
	            reading_id: _this4.props.params.readingid,
	            subscriptionstatus: _this4.state.subscriptionstatus
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCasesquestion', param).then(function (resp_question) {
	            if (resp_question.success) {
	              _this4.setState({
	                casesquestion_length: resp_question.questions_details.length,
	                display_main_loader: 'hide_block'
	              });
	
	              // console.log(
	              //   'I am having a issue here -------->',
	              //   resp_question.questions_details.length,
	              //   question_number,
	              //   offset_val
	              // );
	              if (resp_question.questions_details.length > offset_val) {
	                //let ques_res=[];
	
	                var offset_res = '';
	                var questionid = '';
	                // console.log(questionid);
	
	                for (var i = 0; i < resp_question.questions_details.length; i++) {
	                  // console.log(
	                  //   'resp_question.questions_details[i].length',
	                  //   resp_question.questions_details.length
	                  // );
	                  if (i === 0) {
	                    _this4.setState({
	                      hide_question_left_arrow: '',
	                      hide_question_right_arrow: ''
	                    });
	                    if (i === 0) _this4.setState({
	                      hide_question_left_arrow: 'menu_hide'
	                    });
	                    if (i === resp_question.questions_details.length - 1) _this4.setState({
	                      hide_question_right_arrow: 'menu_hide'
	                    });
	                    offset_res = i;
	                    questionid = resp_question.questions_details[i].id;
	                    _this4.setState({
	                      questions: resp_question.questions_details[i],
	                      question_no: i + 1
	                    });
	                    _this4.setQuestionState(resp_question.questions_details[i]);
	                    _this4.getFavQuestions(resp_question.questions_details[i].id);
	                    _this4.getGMATRatting(resp_question.questions_details[i].id);
	                    _this4.getFlashCards(resp_question.questions_details[i].id);
	                  }
	                  if (i === resp_question.questions_details.length - 1) {
	                    _this4.setState({ display_loader: 'hide_block' });
	                  }
	                }
	                _this4.setState({
	                  offset: offset_res,
	                  all_questions_state: resp_question.questions_details,
	                  display_cases: 'show_block',
	                  top_50: ''
	                });
	                _this4.setState({ records: '' });
	              } else {
	                console.log('Not Valid');
	              }
	            }
	          });
	        } else {
	          _this4.setState({ ValidToken: false, records: 'Result not found.' });
	        }
	        clearInterval(_this4.timer);
	        _this4.timer = setInterval(_this4.tick.bind(_this4), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
	      // clearInterval(this.timer);
	      // this.timer = setInterval(this.tick.bind(this), 1000);
	    }
	
	    // ==================== CHANGES BY ME START ==============================//
	
	  }, {
	    key: 'componentDidMount',
	
	    // ==================== CHANGES BY ME END ==============================//
	    // =============================== TODO END =======================//
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this5 = this;
	
	        var storage_session, subscriptionstatusData, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  display_loader: 'show_block',
	                  display_cases: 'hide_block'
	                });
	                this.setState({
	                  case_id: this.props.params.caseid
	                });
	                subscriptionstatusData = void 0;
	
	                if (parseInt(this.props.params.subscription, 10) === 1) {
	                  this.setState({ subscriptionstatus: 'paid' });
	                  subscriptionstatusData = 'paid';
	                } else {
	                  this.setState({ subscriptionstatus: 'free' });
	                  subscriptionstatusData = 'free';
	                }
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  caseid: this.props.params.caseid,
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.chapterid,
	                  subscriptionstatus: subscriptionstatusData
	                };
	                // -------------------------- CASE AND Question ---------------- //
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCaseByReading', data).then(function (resp) {
	                  if (resp.success) {
	                    _this5.setState({
	                      ValidToken: true,
	                      all_cases: resp.questions,
	                      cases_length: resp.questions.length
	                    });
	                    console.log('this.props.params.case_offset==============>GMAT', _this5.props.params.case_offset);
	                    for (var i = 0; i < resp.questions.length; i++) {
	                      if (parseInt(_this5.props.params.case_offset, 10) === i) {
	                        if (i === 0) _this5.setState({
	                          hide_case_left_arrow: 'true'
	                        });
	                        if (i === resp.questions.length - 1) _this5.setState({
	                          hide_case_right_arrow: 'true'
	                        });
	                        _this5.setState({
	                          cases_offset: _this5.props.params.case_offset,
	                          cases_display: resp.questions[i]['gmat_focus_case.passage'],
	                          cases_name: 'Case no: ' + (parseInt(i, 10) + 1),
	                          case_id: resp.questions[i].case_id
	                        });
	                      }
	                    }
	                    var param = {
	                      token: storage_session['token'],
	                      idname: storage_session['idname'],
	                      reading_id: _this5.props.params.readingid,
	                      case_id: _this5.state.case_id,
	                      subscriptionstatus: subscriptionstatusData
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getCasesquestion', param).then(function (resp_question) {
	                      // console.log('I am here 1111');
	                      if (resp_question.success) {
	                        _this5.setState({
	                          casesquestion_length: resp_question.questions_details.length,
	                          display_main_loader: 'hide_block'
	                        });
	                        // console.log(
	                        //   'I am having a issue here -------->',
	                        //   this.props.params,
	                        //   resp_question.questions_details.length,
	                        //   this.props.params.question_number - 1
	                        // );
	                        if (resp_question.questions_details.length > _this5.props.params.offset) {
	                          //let ques_res=[];
	
	                          var offset_res = '';
	                          var questionid = '';
	                          // console.log(questionid);
	
	                          for (var i = 0; i < resp_question.questions_details.length; i++) {
	                            // console.log(
	                            //   'resp_question.questions_details[i]',
	                            //   resp_question.questions_details[i]
	                            // );
	                            if (i === parseInt(_this5.props.params.offset, 10)) {
	                              if (i === 0) _this5.setState({
	                                hide_question_left_arrow: 'menu_hide'
	                              });
	                              if (i === resp_question.questions_details.length - 1) _this5.setState({
	                                hide_question_right_arrow: 'menu_hide'
	                              });
	                              offset_res = i;
	                              questionid = resp_question.questions_details[i].id;
	                              _this5.setState({
	                                questions: resp_question.questions_details[i],
	                                question_no: i + 1
	                              });
	                              _this5.setQuestionState(resp_question.questions_details[i]);
	                              _this5.getFavQuestions(resp_question.questions_details[i].id);
	                              _this5.getGMATRatting(resp_question.questions_details[i].id);
	                              _this5.getFlashCards(resp_question.questions_details[i].id);
	                            }
	                            if (i === resp_question.questions_details.length - 1) {
	                              _this5.setState({ display_loader: 'hide_block' });
	                            }
	                          }
	                          _this5.setState({
	                            offset: offset_res,
	                            all_questions_state: resp_question.questions_details,
	                            display_cases: 'show_block'
	                          });
	
	                          _this5.setState({ records: '' });
	                        } else {
	                          console.log('Not Valid');
	                        }
	                      }
	                    });
	                  } else {
	                    _this5.setState({ ValidToken: false, records: 'Result not found.' });
	                  }
	                  clearInterval(_this5.timer);
	                  _this5.timer = setInterval(_this5.tick.bind(_this5), 1000);
	                  return resp;
	                });
	                // -------------------------- CASE AND Question ---------------- //
	                clearInterval(this.timer);
	                this.timer = setInterval(this.tick.bind(this), 1000);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          showCompletionQuestion = _state.showCompletionQuestion,
	          display_subcription = _state.display_subcription,
	          display_cases = _state.display_cases,
	          markAsCompleted = _state.markAsCompleted,
	          markAsNotCompleted = _state.markAsNotCompleted,
	          markCompleted = _state.markCompleted,
	          save_text = _state.save_text,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          ratting_text = _state.ratting_text,
	          rating = _state.rating,
	          result_block = _state.result_block,
	          text_color = _state.text_color,
	          result = _state.result,
	          choice_a = _state.choice_a,
	          choice_b = _state.choice_b,
	          choice_c = _state.choice_c,
	          choice_d = _state.choice_d,
	          choice_e = _state.choice_e,
	          hide_question_left_arrow = _state.hide_question_left_arrow,
	          hide_question_right_arrow = _state.hide_question_right_arrow,
	          questionsState = _state.questions,
	          choice = _state.choice,
	          question_no = _state.question_no,
	          validated = _state.validated,
	          report_block = _state.report_block,
	          successAlert = _state.successAlert,
	          tooltips = _state.tooltips,
	          isError = _state.isError;
	
	      var questions_data_display = questions || {};
	      var question_data = void 0;
	      if (showCompletionQuestion) {
	        question_data = _react2.default.createElement(
	          'div',
	          { className: 'w-100' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card 23434' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 complete-section-wrap ' + display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header text-center' },
	                _language2.default.LC().Mark_this_Question_as_Completed,
	                _react2.default.createElement(
	                  'div',
	                  { onClick: this._getNextAnyway, className: 'float-right text-right' },
	                  _react2.default.createElement('i', { className: 'fa fa-angle-right ques_arrow pointer_class' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 text-center' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 ' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'quation-img' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                            className: 'margin_bottom_10',
	                            alt: ''
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            contentEditable: false,
	                            suppressContentEditableWarning: true,
	                            className: 'margin_bottom_10 view_questionhtml bg_blue'
	                          },
	                          _language2.default.LC().MARK_THIS_QUESTION_AS_COMPLETED
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'complete-or-not-wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check-button-wrap' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              _language2.default.LC().COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_completed',
	                                name: 'mark_completed',
	                                value: 'select',
	                                onClick: this.markCompleted.bind(this),
	                                checked: markAsCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'card-actions float-right' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'check_container margin_bottom_0' },
	                              _language2.default.LC().NOT_COMPLETED,
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'mark_not_completed',
	                                name: 'mark_not_completed',
	                                value: 'select',
	                                onClick: this.markNotCompleted.bind(this),
	                                checked: markAsNotCompleted
	                              }),
	                              _react2.default.createElement('span', { className: 'checkmark' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'd-block text-center complete-quation-submit' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              disabled: markCompleted,
	                              onClick: this.changeCompletionStatus.bind(this),
	                              className: 'btn btn-primary pointer_class'
	                            },
	                            _language2.default.LC().SUBMIT
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        question_data = _react2.default.createElement(
	          'div',
	          { className: 'note-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block ' + display_subcription },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 p-sm-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      _language2.default.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 p-sm-0 ' + display_cases },
	            _react2.default.createElement(
	              'div',
	              { className: 'card box-shadow-none' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header title-font-size' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex justify-content-between' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'd-flex' },
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                      className: 'margin_right_20',
	                      alt: '',
	                      width: '30'
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'title-font-size' },
	                      _language2.default.LC().QUESTION,
	                      ' ',
	                      question_no + ' - '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class ' + hide_question_left_arrow,
	                      onClick: this._getPrevious
	                    }),
	                    _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class ' + hide_question_right_arrow,
	                      onClick: this._getNext
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row px-md-15px' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(_ViewQuestion2.default, Object.assign({}, questions, this.props, {
	                        setAnswer: this.setAnswer,
	                        showAnswer: validated,
	                        correctChoice: questions && questions.right_choice,
	                        selectedChoice: choice
	                      })),
	                      _react2.default.createElement(
	                        _reactstrap.Col,
	                        { md: 12, className: 'mt-2' },
	                        isError && _react2.default.createElement(
	                          'p',
	                          { className: 'text-danger' },
	                          _messages.messages.NO_CHOICE_SELECTED
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Row,
	                          { className: 'align-items-center' },
	                          _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                            showResult: validated,
	                            isQue: true,
	                            _getResult: this.handleQuestionValidate,
	                            _saveQuestion: this._saveQuestion,
	                            _displayReportForm: this._displayReportForm,
	                            all_questions: questions_data_display,
	                            save_text: save_text,
	                            bookmarkCSS: bookmarkCSS,
	                            bookmarkColor: bookmarkColor
	                          }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'star_rating_wrap' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'margin_bottom_0 margin_right_10' },
	                                ratting_text
	                              ),
	                              _react2.default.createElement(_reactStarRatings2.default, {
	                                rating: rating,
	                                starRatedColor: 'rgb(255, 180, 0)',
	                                starEmptyColor: 'rgb(51, 51, 51)',
	                                starDimension: '20px',
	                                starHoverColor: 'rgb(255, 180, 0)',
	                                starSpacing: '2px',
	                                changeRating: this.onStarClick.bind(this, questions_data_display),
	                                numberOfStars: 5,
	                                name: 'rate1'
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: result_block + ' bg-faded' },
	              _react2.default.createElement(
	                'div',
	                { className: text_color },
	                result
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                (0, _function.renderHTMLContent)(questions_data_display.answer, 'p', 'view_questionhtml', {
	                  contentEditable: false,
	                  suppressContentEditableWarning: true
	                })
	              ),
	              console.log(questionsState)
	            ),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: questions,
	              type: 'question',
	              question_type: 'question',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'gmat_focus'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class margin_bottom_20 report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, questions_data_display)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10 margin_bottom_20',
	                            onClick: this._hideReportForm.bind(this, questions_data_display)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      // const { timer_stop } = this.state;
	      return _react2.default.createElement(
	        'div',
	        { className: 'd-flex flex-column', id: 'Progress1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getQuestions
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_CHAPTER
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'd-flex flex-sm-col' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'p-2 card mr-1 mb-0 calc_height_GMAT overflow-y-auto width-sm-100 width-50 mb-sm-1 font-lusitana bg_blue'
	              // style={{ borderRadius: '0px' }}
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-flex justify-content-between align-items-center card-header px-0 ' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  disabled: this.state.hide_case_left_arrow,
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getPreviousCase
	                },
	                'Previous Passage'
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  disabled: this.state.hide_case_right_arrow,
	                  onClick: this._getNextCase
	                },
	                'Next Passage'
	              )
	            ),
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              console.log('check case data', this.state.cases_display),
	              (0, _function.renderHTMLContent)(this.state.cases_display, 'span', '', {
	                contentEditable: 'false',
	                suppressContentEditableWarning: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'width-50 calc_height_GMAT overflow-y-auto width-sm-100 card-border-radius-none bg-white p-2 card font-lusitana bg_blue'
	              // style={{ borderRadius: '0px' }}
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'position-relative ' + this.state.top_50 },
	              _react2.default.createElement(
	                'div',
	                { className: 'main_loader ' + this.state.display_main_loader },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'loader-mid' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block-loader' },
	                    _react2.default.createElement(_loader2.default, null)
	                  )
	                )
	              ),
	              question_data
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATCases;
	}(_react.Component);
	
	// class TooltipItem extends React.Component {
	//   constructor(props) {
	//     super(props);
	
	//     this.toggle = this.toggle.bind(this);
	
	//     // document.body.style.backgroundColor = '#1d364b';
	//     this.state = {
	//       tooltipOpen: false,
	//     };
	//   }
	
	//   toggle() {
	//     this.setState({
	//       // tooltipOpen: !tooltipOpen,
	//     });
	//   }
	
	//   render() {
	//     return (
	//       <span>
	//         <img
	//           src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
	//           id={'Tooltip-' + this.props.id}
	//           width='18'
	//           alt=''
	//           style={{ marginLeft: '4px' }}
	//         />
	//         {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}
	
	//         <Tooltip
	//           placement={this.props.place_tip}
	//           // isOpen={tooltipOpen}
	//           target={'Tooltip-' + this.props.id}
	//           toggle={this.toggle}
	//         >
	//           <p className='tooltip_text'>{this.props.content}</p>
	//         </Tooltip>
	//       </span>
	//     );
	//   }
	// }
	
	
	GMATCases.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = GMATCases;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _messages = __webpack_require__(14);
	
	var _GraphicalStatement = __webpack_require__(242);
	
	var _GraphicalStatement2 = _interopRequireDefault(_GraphicalStatement);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _twoStatementServices = __webpack_require__(141);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMATGraphical = function (_Component) {
	  _inherits(GMATGraphical, _Component);
	
	  function GMATGraphical(props) {
	    _classCallCheck(this, GMATGraphical);
	
	    var _this = _possibleConstructorReturn(this, (GMATGraphical.__proto__ || Object.getPrototypeOf(GMATGraphical)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _appRoutes2.default.GRAPH_MULTI_STATEMENT.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GMATGraphical, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_GraphicalStatement2.default, Object.assign({}, this.props, {
	          apiServices: _twoStatementServices.apiServices,
	          examName: _constant.examNameAccordingToDB.GMAT_FOCUS,
	          questionType: _constant.QUESTION_TYPE.GRAPH_QUESTION,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return GMATGraphical;
	}(_react.Component);
	
	GMATGraphical.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GMATGraphical;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MultiSourceTab = __webpack_require__(243);
	
	var _MultiSourceTab2 = _interopRequireDefault(_MultiSourceTab);
	
	var _twoStatementServices = __webpack_require__(141);
	
	var _messages = __webpack_require__(14);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GMATTab = function (_Component) {
	  _inherits(GMATTab, _Component);
	
	  function GMATTab(props) {
	    _classCallCheck(this, GMATTab);
	
	    var _this = _possibleConstructorReturn(this, (GMATTab.__proto__ || Object.getPrototypeOf(GMATTab)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _appRoutes2.default.TAB.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(GMATTab, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_MultiSourceTab2.default, Object.assign({}, this.props, {
	          examName: _constant.examNameAccordingToDB.GMAT_FOCUS,
	          apiServices: _twoStatementServices.apiServices,
	          questionType: _constant.QUESTION_TYPE.TAB_QUESTION,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return GMATTab;
	}(_react.Component);
	
	GMATTab.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = GMATTab;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _messages = __webpack_require__(14);
	
	var _TwoStatement = __webpack_require__(133);
	
	var _TwoStatement2 = _interopRequireDefault(_TwoStatement);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _twoStatementServices = __webpack_require__(141);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // my datatatatat
	
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.redirectTo = function (path) {
	      var router = _this.context.router;
	      var _this$props$params = _this.props.params,
	          chapterid = _this$props$params.chapterid,
	          readingid = _this$props$params.readingid,
	          subscription = _this$props$params.subscription,
	          reading = _this$props$params.reading;
	
	
	      var routes = {
	        question: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', chapterid).replace(':id', readingid).replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free').replace(':reading', reading),
	
	        reading: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', chapterid)
	      };
	
	      if (routes[path]) {
	        router.push({ pathname: routes[path] });
	      }
	    };
	
	    _this.handleChangeParams = function (value) {
	      var index = value.index,
	          question_id = value.question_id;
	      var _this$props$params2 = _this.props.params,
	          chapterid = _this$props$params2.chapterid,
	          readingid = _this$props$params2.readingid,
	          subscription = _this$props$params2.subscription,
	          reading = _this$props$params2.reading;
	
	      _this.context.router.push({
	        pathname: _appRoutes2.default.TABLE.replace(':chapterid', chapterid).replace(':readingid', readingid).replace(':subscription', subscription).replace(':question_id', question_id).replace(':offset', index).replace(':reading', reading)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TwoStatement2.default, Object.assign({}, this.props, {
	          examName: _constant.examNameAccordingToDB.GMAT_FOCUS,
	          apiServices: _twoStatementServices.apiServices,
	          questionType: _constant.QUESTION_TYPE.TABLE_QUESTION,
	          redirectTo: this.redirectTo,
	          handleChangeParams: this.handleChangeParams
	        }))
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = Table;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _UserAnsweredNotAnsweredStatus = __webpack_require__(137);
	
	var _UserAnsweredNotAnsweredStatus2 = _interopRequireDefault(_UserAnsweredNotAnsweredStatus);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var ViewGMATques = function (_Component) {
	  _inherits(ViewGMATques, _Component);
	
	  function ViewGMATques(props) {
	    _classCallCheck(this, ViewGMATques);
	
	    var _this = _possibleConstructorReturn(this, (ViewGMATques.__proto__ || Object.getPrototypeOf(ViewGMATques)).call(this, props));
	
	    _this._goToVideo = function () {
	      _this.setState({
	        chapter_video_redirect: _this.state.chapters[parseInt(_this.props.params.chapter_no) - 1]
	      }, function () {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', _this.state.chapter_video_redirect.chapter_no).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1),
	          // .replace(':type', '')
	          // .replace(':chapter_id', '')
	          // .replace(':index', '')
	          search: '?chapter_name=' + _this.state.chapter_video_redirect.chapter_name
	        });
	      });
	    };
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUESTION_BANK_READING.replace(':id', _this.props.params.chapter_no)
	
	        // `/readings/${this.props.params.chapter_no}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.props.location.state.reading.chapter_no,
	        // },
	      });
	    };
	
	    _this._beginChapter = function (item, index, caseOffset, questionOffset, e) {
	      var reading = _this.state.readingDetails;
	
	      if (reading.type === 'case_question') {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.BEGIN_CASE.replace(':chapterid', item.chapter_id).replace(':readingid', reading.id).replace(':caseid', item.case_id).replace(':case_offset', caseOffset).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_number', item.id).replace(':offset', questionOffset)
	        });
	      } else if (reading.type === 'tab_question' || reading.type === 'graph_question' || reading.type === 'table_question' || reading.type === 'two_part_question') {
	        var routeName = void 0;
	        switch (reading.type) {
	          case 'tab_question':
	            routeName = 'TAB';
	            break;
	          case 'graph_question':
	            routeName = 'GRAPH_MULTI_STATEMENT';
	            break;
	          case 'table_question':
	            routeName = 'TABLE';
	            break;
	          case 'two_part_question':
	            routeName = 'TWO_PART_STATEMENT';
	            break;
	          default:
	            console.log('Route Name issue');
	            break;
	        }
	        _this.context.router.push({
	          pathname: _appRoutes2.default[routeName].replace(':chapterid', item.chapter_id).replace(':readingid', reading.id).replace(':subscription', _this.state.subscriptionstatus === 'paid' ? 1 : 0).replace(':question_id', item.id).replace(':offset', index).replace(':reading', reading.reading)
	        });
	      } else {
	        _this.context.router.push({
	          pathname: _appRoutes2.default.QUESTION_BANK_VIEW_QUE.replace(':notesid', item.chapter_id).replace(':readingid', item.reading_id).replace(':id', item.id)
	        });
	      }
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      SubsciptionMessage: _alertMessage2.default.messageContent_gmat,
	      token: '',
	      idname: '',
	      readingName: _this.props.params.reading,
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      subscriptionstatus: _this.props.params.subscriptionstatus,
	      chapters: [],
	      subscription_details: '',
	      showFreePremium: true,
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'gmat_focus',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      isVideo: true,
	      display_loader: 'show'
	    };
	    return _this;
	  }
	
	  _createClass(ViewGMATques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this2 = this;
	
	        var storage_session, getProfileInfo, data_data, data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                getProfileInfo = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', getProfileInfo).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.profileInfo) {
	                              _this2.setState({
	                                isVideo: resp.profileInfo.isVideo
	                              });
	                            }
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	                data_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true, chapters: resp.cfavideo });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                });
	
	              case 8:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context4.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset, subscription_details;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_selected === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this2.setState({
	                              showFreePremium: true
	                            });
	                            _context3.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context3.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this2.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (isInArray_var) {
	                                          _this2.setState({ showFreePremium: false });
	                                        } else {
	                                          _this2.setState({ showFreePremium: true });
	                                        }
	                                        _context2.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 9:
	                            _context3.next = 22;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                              _context3.next = 16;
	                              break;
	                            }
	
	                            // console.log('if working')
	                            (0, _toast.showFailure)('Please upgrade your package to access all questions');
	
	                            _this2.setState({
	                              showFreePremium: true
	                            });
	                            _context3.next = 22;
	                            break;
	
	                          case 16:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this2.setState({
	                              subscription_details: subscription_details,
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context3.next = 22;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this2.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this2.state.cfaUnlimitedPackage, _this2.state.cfaUnlimitedActiveExam);
	                                // console.log(isInArray_var);
	                                if (isInArray_var) {
	                                  // console.log('IF WORKING')
	                                  _this2.setState({ showFreePremium: false });
	                                } else {
	                                  (0, _toast.showFailure)('Please upgrade your package to access all questions');
	                                  //   console.log('ELSE WORKING')
	                                  _this2.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                console.log('fail');
	                              }
	                            });
	
	                          case 22:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 11:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit,
	                  subscriptionstatus: this.state.subscriptionstatus
	                };
	                _context4.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestions', data).then(function (resp) {
	                  if (resp.success) {
	                    _this2.setState({
	                      ValidToken: true,
	                      questions: resp.questions,
	                      readingDetails: resp.readingDetails
	                    });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  _this2.setState({ display_loader: 'hide' });
	                  return resp;
	                });
	
	              case 14:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var questions = this.state.questions;
	      var data = '';
	      var caseOffset = -1;
	      var questionOffset = 0;
	      var previousCaseId = undefined;
	      if (this.state.questions.length) {
	        data = questions.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId === item.case_id ? questionOffset++ : questionOffset = 0
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId === item.case_id ? caseOffset = caseOffset : caseOffset++
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-none' },
	              previousCaseId = item.case_id
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: _this3._beginChapter.bind(_this3, item, index, caseOffset, questionOffset),
	                className: 'border_box'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title d-flex' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'ml-1' },
	                  item.name ? item.name : _this3.state.readingName,
	                  ' (',
	                  _language2.default.LC().Q,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                _react2.default.createElement(
	                  'div',
	                  { contentEditable: 'false', className: 'view_question_height view_questionhtml' },
	                  (0, _function.renderHTMLContent)(item.question.substring(0, item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 500) + '...')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _this3.state.answered_state[index]
	                ),
	                _react2.default.createElement(_UserAnsweredNotAnsweredStatus2.default, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index,
	                  readingDetails: _this3.state.readingDetails,
	                  examRoute: 'gmat-focus/question-bank'
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = this.state.display_loader === 'show' ? _react2.default.createElement(_loader2.default, null) : null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.readingName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className:
	              // this.state.isVideo === true
	              //   ? `col-md-2 text-md-right margin_bottom_20`
	              // :
	              'col-md-4 text-md-right margin_bottom_20'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          this.state.subscriptionstatus == 'free' ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'border_box', onClick: this._getSubscribe },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  ' ',
	                  _language2.default.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box_free' },
	                (0, _function.renderHTMLContent)(this.state.SubsciptionMessage, "div", "view_question_height view_questionhtml modal-info-view-for-plan", { contentEditable: 'false' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscibe__btn text-center' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary pointer_class',
	                    onClick: this._getSubscribe
	                  },
	                  _language2.default.LC().SUBSCRIBE
	                )
	              )
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ViewGMATques;
	}(_react.Component);
	
	ViewGMATques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = ViewGMATques;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var BeforeStart = function (_Component) {
	  _inherits(BeforeStart, _Component);
	
	  function BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (BeforeStart.__proto__ || Object.getPrototypeOf(BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUIZZES,
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.beginQuiz = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, all_reading_type, all_cases_id, final_exam, data;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, all_reading_type = _this$state.all_reading_type, all_cases_id = _this$state.all_cases_id;
	              final_exam = [];
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context4.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context3.next = 12;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context3.next = 5;
	                            break;
	                          }
	
	                          _this.toggleAlert();
	                          _context3.next = 10;
	                          break;
	
	                        case 5:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context3.next = 10;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context.next = 10;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context.next = 6;
	                                      return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context.sent;
	
	                                      if (isInArray_var) {
	                                        if (all_reading_type[0] === 'case_question') {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':case', all_cases_id[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'tab_question') {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'graph_question') {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'table_question') {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else if (all_reading_type[0] === 'two_part_question') {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.BEGIN_TWO_PART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        } else {
	                                          _this.context.router.push({
	                                            pathname: _appRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                          });
	                                        }
	                                      } else {
	                                        _this.toggleAlert();
	                                      }
	                                      _context.next = 10;
	                                      break;
	
	                                    case 10:
	                                    case 'end':
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this2);
	                            }));
	
	                            return function (_x2) {
	                              return _ref3.apply(this, arguments);
	                            };
	                          }()
	                          // console.log('fail');
	                          );
	
	                        case 10:
	                          _context3.next = 13;
	                          break;
	
	                        case 12:
	                          if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                            _this.toggleAlert();
	                          } else {
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	
	                                        if (isInArray_var) {
	                                          if (all_reading_type[0] === 'case_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':case', all_cases_id[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'tab_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'graph_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'table_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[0] === 'two_part_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_TWO_PART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', _this.state.offset_send).replace(':type', all_reading_type[0]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          }
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context2.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	                          }
	
	                        case 13:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.viewQuizquestion = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(item, offset_va, e) {
	        var _this$state2, all_reading_type, all_cases_id, final_exam, data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this$state2 = _this.state, all_reading_type = _this$state2.all_reading_type, all_cases_id = _this$state2.all_cases_id;
	                final_exam = [];
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 12;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 10;
	                            break;
	
	                          case 5:
	                            _this.setState({
	                              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _GMATFocusSubscription4.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          if (all_reading_type[offset_va] === 'case_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':case', all_cases_id[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'tab_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'graph_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'table_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else if (all_reading_type[offset_va] === 'two_part_question') {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_TWO_PART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          } else {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                            });
	                                          }
	
	                                          // this.context.router.push({
	                                          //   pathname: appRoutes.BEGIN_QUIZ.replace(
	                                          //     ':quiz_id',
	                                          //     this.state.quiz_id
	                                          //   ).replace(':offset', offset_va),
	
	                                          // });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 10:
	                            _context6.next = 13;
	                            break;
	
	                          case 12:
	                            if (resp.profileInfo.exam_selected == '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                              _this.toggleAlert();
	                            } else {
	                              _this.setState({
	                                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                              });
	                              data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                              dataset = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                examid: data_arr
	                              };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                if (resp_exam.success) {
	                                  var exam_data = resp_exam.examData;
	                                  var selectedmen = _this.state.selectedmenu;
	                                  var isInArray_var = false;
	                                  isInArray_var = _GMATFocusSubscription2.default.checkGMATQuestionSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                                  if (isInArray_var) {
	                                    if (all_reading_type[offset_va] === 'case_question') {
	                                      _this.context.router.push({
	                                        pathname: _appRoutes2.default.BEGIN_CASE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':case', all_cases_id[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'tab_question') {
	                                      _this.context.router.push({
	                                        pathname: _appRoutes2.default.QUIZZES_BEGIN.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'graph_question') {
	                                      _this.context.router.push({
	                                        pathname: _appRoutes2.default.BEGIN_GRAPH_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':type', all_reading_type[offset_va]).replace(':offset', offset_va).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'table_question') {
	                                      _this.context.router.push({
	                                        pathname: _appRoutes2.default.BEGIN_TABLE_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else if (all_reading_type[offset_va] === 'two_part_question') {
	                                      _this.context.router.push({
	                                        pathname: _appRoutes2.default.BEGIN_TWO_PART_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    } else {
	                                      _this.context.router.push({
	                                        pathname: _appRoutes2.default.BEGIN_QUIZ.replace(':quiz_id', _this.state.quiz_id).replace(':offset', offset_va).replace(':type', all_reading_type[offset_va]).replace(':timer', _this.state.timerInSeconds)
	                                      });
	                                    }
	
	                                    // this.context.router.push({
	                                    //   pathname: appRoutes.BEGIN_QUIZ.replace(
	                                    //     ':quiz_id',
	                                    //     this.state.quiz_id
	                                    //   ).replace(':offset', offset_va),
	
	                                    // });
	                                  } else {
	                                    _this.toggleAlert();
	                                  }
	                                } else {
	                                  // console.log('fail');
	                                }
	                              });
	                            }
	
	                          case 13:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }());
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x4, _x5, _x6) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_cfa_1,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'gmat_focus',
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      timerInSeconds: 0
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //Function to redirect page to Create Quiz page
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    //Function to redirect page to begin Quiz page
	
	
	    /*
	    ------------------------------------------------------
	        Function to redirect page to begin Quiz page
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	          var readings = JSON.parse(JSON.parse(retun_all_question)).readings;
	          var cases = JSON.parse(JSON.parse(retun_all_question)).cases;
	
	          var question_id = [];
	          var reading_id = [];
	          var case_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	            reading_id.push(readings[i]);
	            case_id.push(cases[i]);
	          }
	          console.log('resp.timer_value---', resp.timer_value);
	          // var minutes = Math.floor(resp.timer_value / 60);
	          var minutes = resp.timer_value / 60;
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count,
	            all_reading_type: reading_id,
	            all_cases_id: case_id,
	            timerInSeconds: resp.timer_value
	          });
	        } else {
	          // console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          // console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var question_id_display = '';
	      var _state = this.state,
	          all_reading_type = _state.all_reading_type,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id,
	          all_question_id = _state.all_question_id;
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: token,
	                idname: idname,
	                quiz_id: quiz_id,
	                answered_state: index,
	                type: all_reading_type[index]
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'javascript: void(0)', onClick: _this4.viewQuizquestion.bind(_this4, items, index) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	      var _state2 = this.state,
	          timerInSeconds = _state2.timerInSeconds,
	          user_time_value = _state2.user_time_value,
	          status_send = _state2.status_send;
	
	      var user_time = '';
	      var min,
	          sec = '';
	      var status_data = '';
	      var spentTime = timerInSeconds - user_time_value;
	      if (status_send === 'abondon') {
	        if (spentTime < 60) {
	          user_time = spentTime + 'sec';
	        } else {
	          min = parseInt(spentTime / 60);
	          sec = spentTime % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this.beginQuiz.bind(this) },
	          ' ',
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this.beginQuiz.bind(this) },
	          ' ',
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().QUIZ_ID,
	            ': ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().NO_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().CORRECT_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().WRONG_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id,
	    type: props.type
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/checkAnswered', data).then(function (resp) {
	    if (document.getElementById('questionNameId_' + props.answered_state) !== null) document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer === 1) {
	        var userQuestionStatus = document.getElementById('user_question_status' + props.answered_state);
	        var answerFlag = document.getElementById('answer_flag' + props.answered_state);
	        if (userQuestionStatus) userQuestionStatus.id = 'quiz_answered_status';
	        if (answerFlag) answerFlag.innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        var _userQuestionStatus = document.getElementById('user_question_status' + props.answered_state);
	        var _answerFlag = document.getElementById('answer_flag' + props.answered_state);
	        if (_userQuestionStatus) _userQuestionStatus.id = 'quiz_wrong_answered_status';
	        if (_answerFlag) _answerFlag.innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	        // document.getElementById(
	        //   'user_question_status' + props.answered_state
	        // ).id = 'quiz_wrong_answered_status';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	        // document.getElementById(
	        //   'answer_flag' + props.answered_state
	        // ).innerHTML = `${language.LC().WRONG_ANSWER}`;
	      }
	    } else {
	      if (document.getElementById('user_question_status' + props.answered_state) !== null) document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = BeforeStart;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.apiServices = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable */
	
	
	var session = JSON.parse(localStorage.getItem('localstorageval')) || {};
	var token = session.token,
	    idname = session.idname;
	
	var payload = {
	  token: token,
	  idname: idname
	};
	var getQuizDetails = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuize', Object.assign({}, payload, data));
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getQuizDetails(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var getQuestionById = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuestionsbyid', Object.assign({}, payload, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function getQuestionById(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var checkUserSelectedAnswer = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/checkAnswered', Object.assign({}, payload, data));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function checkUserSelectedAnswer(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var insertUserTimer = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/insertTimer', Object.assign({}, payload, data));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function insertUserTimer(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var saveQuizAnswer = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/answerQuiz', Object.assign({}, payload, data));
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function saveQuizAnswer(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var saveAttemptStats = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveStats', Object.assign({}, payload, data));
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function saveAttemptStats(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var fetchSavedQuestion = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(data) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavQuestions', Object.assign({}, payload, data));
	
	          case 2:
	            return _context7.abrupt('return', _context7.sent);
	
	          case 3:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(data) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _context8.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context8.abrupt('return', _context8.sent);
	
	          case 3:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function saveQuestion(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(data) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/unsaveQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context9.abrupt('return', _context9.sent);
	
	          case 3:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var saveReport = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            _context10.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/reportQuestion', Object.assign({}, payload, data));
	
	          case 2:
	            return _context10.abrupt('return', _context10.sent);
	
	          case 3:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  return function saveReport(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	var saveRating = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(data) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveGMATRatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context11.abrupt('return', _context11.sent);
	
	          case 3:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, undefined);
	  }));
	
	  return function saveRating(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var fetchRating = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATRatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context12.abrupt('return', _context12.sent);
	
	          case 3:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, undefined);
	  }));
	
	  return function fetchRating(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var updateQuestionRating = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(data) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/UpdateGMATRatting', Object.assign({}, payload, data));
	
	          case 2:
	            return _context13.abrupt('return', _context13.sent);
	
	          case 3:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, undefined);
	  }));
	
	  return function updateQuestionRating(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var apiServices = exports.apiServices = {
	  saveAttemptStats: saveAttemptStats,
	  saveQuizAnswer: saveQuizAnswer,
	  getQuestionById: getQuestionById,
	  getQuizDetails: getQuizDetails,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  saveReport: saveReport,
	  saveRating: saveRating,
	  fetchRating: fetchRating,
	  updateQuestionRating: updateQuestionRating,
	  checkUserSelectedAnswer: checkUserSelectedAnswer,
	  insertUserTimer: insertUserTimer
	};

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ApiServiceProvider = __webpack_require__(833);
	
	var _MultiSourceTab = __webpack_require__(245);
	
	var _MultiSourceTab2 = _interopRequireDefault(_MultiSourceTab);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _ReverseTimer = __webpack_require__(247);
	
	var _ReverseTimer2 = _interopRequireDefault(_ReverseTimer);
	
	var _GraphicalStatement = __webpack_require__(244);
	
	var _GraphicalStatement2 = _interopRequireDefault(_GraphicalStatement);
	
	var _TableAnalysisTwoStatement = __webpack_require__(248);
	
	var _TableAnalysisTwoStatement2 = _interopRequireDefault(_TableAnalysisTwoStatement);
	
	var _TwoPartAnalysis = __webpack_require__(249);
	
	var _TwoPartAnalysis2 = _interopRequireDefault(_TwoPartAnalysis);
	
	var _NormalQuestion = __webpack_require__(246);
	
	var _NormalQuestion2 = _interopRequireDefault(_NormalQuestion);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeginQuizContainer = function (_Component) {
	  _inherits(BeginQuizContainer, _Component);
	
	  function BeginQuizContainer(props) {
	    _classCallCheck(this, BeginQuizContainer);
	
	    var _this = _possibleConstructorReturn(this, (BeginQuizContainer.__proto__ || Object.getPrototypeOf(BeginQuizContainer)).call(this, props));
	
	    _this.handleChangeParams = function (index) {
	      var _this$state = _this.state,
	          questionTypes = _this$state.questionTypes,
	          questionIds = _this$state.questionIds;
	      var _this$props$params = _this.props.params,
	          quiz_id = _this$props$params.quiz_id,
	          timer = _this$props$params.timer;
	
	      var currentQuestionType = questionTypes[index];
	      var currentQuestionId = questionIds[index];
	
	      _this.setState({ currentQuestionType: currentQuestionType, currentQuestionId: currentQuestionId });
	      _this.context.router.push({
	        pathname: _appRoutes2.default.QUIZZES_BEGIN.replace(':quiz_id', quiz_id).replace(':offset', index).replace(':type', currentQuestionType).replace(':timer', timer)
	      });
	    };
	
	    _this.redirectToResults = function (status) {
	      var router = _this.context.router;
	      var quiz_id = _this.props.params.quiz_id;
	
	
	      router.push({
	        pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', quiz_id).replace(':status_send', status || 'abondon')
	      });
	    };
	
	    _this.onHandleSetTimer = function (isTimer, isValidate) {
	      return _this.setState({ isTimer: isTimer, isValidate: isValidate });
	    };
	
	    _this.updateUserTimer = function (time) {
	      var params = _this.props.params;
	
	
	      var payload = {
	        quiz_id: params.quiz_id,
	        user_time_value: time.timer
	      };
	      _ApiServiceProvider.apiServices.insertUserTimer(payload).then(function (response) {
	        _this.setState({ timer: time.timer });
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      currentQuestion: {},
	      validated: false,
	      timer: props.params.timer || 0
	    };
	    return _this;
	  }
	
	  _createClass(BeginQuizContainer, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var router, _props, params, question_type, quiz_id, type, offset, payload, response, parsedQuiz, questionIds, questionTypes, quizTime, userSpendTime, currentQuestionId, currentQuestionType;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                router = this.context.router;
	                _props = this.props, params = _props.params, question_type = _props.questionType;
	                quiz_id = params.quiz_id, type = params.type, offset = params.offset;
	                payload = {
	                  quiz_id: quiz_id
	                };
	                _context.next = 6;
	                return _ApiServiceProvider.apiServices.getQuizDetails(payload);
	
	              case 6:
	                response = _context.sent;
	
	
	                // Parse nested JSON once
	                parsedQuiz = JSON.parse(JSON.parse(JSON.stringify(response.singlequiz)));
	                questionIds = parsedQuiz.all_questions, questionTypes = parsedQuiz.readings;
	
	                // Timer values
	
	                quizTime = response.timer_value;
	                userSpendTime = response.user_time_value;
	                currentQuestionId = questionIds[offset];
	                currentQuestionType = questionTypes[offset];
	
	                this.setState({
	                  questionIds: questionIds,
	                  questionTypes: questionTypes,
	                  quizTime: quizTime,
	                  userSpendTime: userSpendTime,
	                  currentQuestionId: currentQuestionId,
	                  currentQuestionType: currentQuestionType,
	                  timer: userSpendTime || quizTime,
	                  isValidate: false
	                });
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          currentQuestionType = _state.currentQuestionType,
	          questionIds = _state.questionIds,
	          questionTypes = _state.questionTypes,
	          isTimer = _state.isTimer,
	          timer = _state.timer,
	          isValidate = _state.isValidate;
	
	      if (!currentQuestionType || Object.keys(currentQuestionType).length === 0) {
	        return null;
	      }
	
	      var commonProps = Object.assign({}, this.props, {
	        questionTypes: questionTypes,
	        questionType: currentQuestionType,
	        apiServices: _ApiServiceProvider.apiServices,
	        questionIds: questionIds,
	        handleChangeParams: this.handleChangeParams,
	        redirectToResults: this.redirectToResults,
	        onHandleSetTimer: this.onHandleSetTimer,
	        examName: _constant.examNameAccordingToDB.GMAT_FOCUS
	      });
	
	      var reverseTimer = _react2.default.createElement(_ReverseTimer2.default, {
	        initialTimerValue: timer,
	        isTimerRunning: isTimer,
	        apiCall: this.updateUserTimer,
	        onStartTimer: function onStartTimer() {
	          return _this2.setState({ isTimer: true });
	        },
	        onStopTimer: function onStopTimer() {
	          return _this2.setState({ isTimer: false });
	        },
	        onToggleTimer: function onToggleTimer() {
	          return _this2.setState(function (prev) {
	            return { isTimer: !prev.isTimer };
	          });
	        },
	        disabled: isValidate
	      });
	
	      var questionTypeMap = {
	        tab_question: _MultiSourceTab2.default,
	        graph_question: _GraphicalStatement2.default,
	        table_question: _TableAnalysisTwoStatement2.default,
	        two_part_question: _TwoPartAnalysis2.default,
	        question: _NormalQuestion2.default,
	        case_question: _NormalQuestion2.default
	      };
	
	      var QuestionComponent = questionTypeMap[currentQuestionType];
	
	      if (!QuestionComponent) return null;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          QuestionComponent,
	          commonProps,
	          reverseTimer
	        )
	      );
	    }
	  }]);
	
	  return BeginQuizContainer;
	}(_react.Component);
	
	BeginQuizContainer.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = BeginQuizContainer;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/* eslint-disable*/
	var Quizzes = function (_Component) {
	  _inherits(Quizzes, _Component);
	
	  function Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (Quizzes.__proto__ || Object.getPrototypeOf(Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot == dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i == dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    _this.setState({ display_loader: 'hide_block' });
	                    (0, _toast.showFailure)(resp.message);
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._createQuiz = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var data;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this.setState({ display_loader: 'show_block' });
	              data = { token: _this.state.token, idname: _this.state.idname };
	              _context5.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context4.next = 13;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context4.next = 6;
	                            break;
	                          }
	
	                          _this.setState({ display_loader: 'hide_block' });
	                          (0, _toast.showFailure)('Please Upgrade Your Account');
	                          _context4.next = 11;
	                          break;
	
	                        case 6:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context4.next = 11;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, question_length_val, timer_value, chapterAll, dataString, dataReason, chapterall_id, i, data, checkboxes, single_clicked_value;
	                              return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                while (1) {
	                                  switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context2.next = 11;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = 'gmat_focus';
	                                      isInArray_var = false;
	                                      _context2.next = 6;
	                                      return _GMATFocusSubscription4.default.checkGMATSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context2.sent;
	
	                                      console.log(isInArray_var, '<========partner==========');
	                                      if (isInArray_var) {
	                                        question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                                        chapterAll = '';
	
	                                        timer_value = _this.state.quiz_length_state[_this.state.radio_checked_question].timer_value;
	                                        if (_this.state.all_checked_state) {
	                                          // console.log('if	 working')
	                                          dataString = JSON.stringify(_this.state.chapters);
	                                          dataReason = JSON.parse(dataString);
	                                          chapterall_id = [];
	
	                                          for (i = 0; i < dataReason.length; i++) {
	                                            chapterall_id.push(dataReason[i].chapter_no);
	                                          }
	
	                                          chapterAll = chapterall_id;
	                                          data = {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            chapterAll: ['' + (_this.state.radio_checked_reasoning + 1)],
	                                            questionquize: parseInt(question_length_val),
	                                            priority: _this.state.radio_checked_priority,
	                                            // reasoning: chapterAll.length
	                                            //   ? chapterAll[0] === '1'
	                                            //     ? 'Integrated Reasoning'
	                                            //     : chapterAll[0] === '2'
	                                            //     ? 'Quantitative Reasoning'
	                                            //     : 'Verbal Reasoning'
	                                            //   : 'Verbal Reasoning',
	                                            reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                          };
	
	                                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuizequestion', data).then(function (resp) {
	                                            if (resp.success) {
	                                              var retun_all_chapter = JSON.stringify(resp.chapters);
	                                              var chapterParse = JSON.parse(retun_all_chapter);
	                                              var question_id = [];
	                                              var myJson = {
	                                                question_count: '',
	                                                all_questions: {},
	                                                readings: {},
	                                                cases: {}
	                                              };
	                                              for (var i = 0; i < chapterParse.length; i++) {
	                                                var objName = 'q' + i;
	                                                var objValue = chapterParse[i].id;
	                                                myJson.all_questions[i] = objValue;
	                                                myJson.readings[i] = chapterParse[i]['gmat_focus_reading.type'];
	                                                myJson.cases[i] = chapterParse[i].case_id;
	                                                question_id.push(chapterParse[i].id);
	                                              }
	                                              myJson.question_count = question_id.length;
	                                              var questions = JSON.stringify(myJson);
	                                              var data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                number_questions: myJson.question_count,
	                                                questions: questions,
	                                                timer_value: timer_value
	                                              };
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/createQuiz', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  _this.context.router.push({
	                                                    pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                    //   `/gmat_beforestart/${resp.last_id}/${''}`,
	                                                    // state: {
	                                                    //   token: this.state.token,
	                                                    //   idname: this.state.idname,
	                                                    //   quiz_id: resp.last_id,
	                                                    //   status_send: '',
	                                                    // },
	                                                  });
	                                                } else {
	                                                  //console.log(resp.success);
	                                                }
	                                              });
	                                            } else {
	                                              _this.setState({ display_loader: 'hide_block' });
	                                              (0, _toast.showFailure)(resp.message);
	                                            }
	                                            return resp;
	                                          });
	                                        } else {
	                                          // console.log('else working')
	                                          checkboxes = document.getElementsByName('approve[]');
	                                          i = 0;
	                                          single_clicked_value = [];
	
	                                          if (_this.state.single_clicked_val == '') {
	                                            for (i = 0; i < checkboxes.length; i++) {
	                                              if (checkboxes[i].checked) {
	                                                // console.log(i+'----------'+checkboxes[i].value);
	                                                single_clicked_value.push(checkboxes[i].value);
	                                              }
	                                            }
	
	                                            chapterAll = single_clicked_value;
	                                            // console.log(chapterAll)
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                            };
	
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_focus_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    // console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          } else {
	                                            chapterAll = _this.state.single_clicked_val;
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning
	                                            };
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_focus_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    //console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          }
	                                        }
	                                      } else {
	                                        _this.setState({ display_loader: 'hide_block' });
	                                        (0, _toast.showFailure)('Please Upgrade Your Account');
	                                      }
	                                      _context2.next = 13;
	                                      break;
	
	                                    case 11:
	                                      _this.setState({ display_loader: 'hide_block' });
	                                      (0, _toast.showFailure)('Please Upgrade Your Account');
	
	                                    case 13:
	                                    case 'end':
	                                      return _context2.stop();
	                                  }
	                                }
	                              }, _callee2, _this2);
	                            }));
	
	                            return function (_x3) {
	                              return _ref4.apply(this, arguments);
	                            };
	                          }());
	
	                        case 11:
	                          _context4.next = 17;
	                          break;
	
	                        case 13:
	                          _this.setState({
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, question_length_val, timer_value, chapterAll, dataString, dataReason, chapterall_id, i, data, checkboxes, single_clicked_value;
	                              return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                while (1) {
	                                  switch (_context3.prev = _context3.next) {
	                                    case 0:
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = 'gmat_focus';
	                                      isInArray_var = false;
	                                      _context3.next = 5;
	                                      return _GMATFocusSubscription2.default.checkGMATQuizSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                    case 5:
	                                      isInArray_var = _context3.sent;
	
	                                      console.log('check subscription in gamt sections===>', isInArray_var);
	                                      if (isInArray_var) {
	                                        question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	                                        chapterAll = '';
	
	                                        timer_value = _this.state.quiz_length_state[_this.state.radio_checked_question].timer_value;
	                                        if (_this.state.all_checked_state) {
	                                          // console.log('if	 working')
	                                          dataString = JSON.stringify(_this.state.chapters);
	                                          dataReason = JSON.parse(dataString);
	                                          chapterall_id = [];
	
	                                          for (i = 0; i < dataReason.length; i++) {
	                                            chapterall_id.push(dataReason[i].chapter_no);
	                                          }
	
	                                          chapterAll = chapterall_id;
	                                          data = {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            chapterAll: ['' + (_this.state.radio_checked_reasoning + 1)],
	                                            questionquize: parseInt(question_length_val),
	                                            priority: _this.state.radio_checked_priority,
	                                            // reasoning: chapterAll.length
	                                            //   ? chapterAll[0] === '1'
	                                            //     ? 'Integrated Reasoning'
	                                            //     : chapterAll[0] === '2'
	                                            //     ? 'Quantitative Reasoning'
	                                            //     : 'Verbal Reasoning'
	                                            //   : 'Verbal Reasoning',
	                                            reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                          };
	
	                                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuizequestion', data).then(function (resp) {
	                                            if (resp.success) {
	                                              var retun_all_chapter = JSON.stringify(resp.chapters);
	                                              var chapterParse = JSON.parse(retun_all_chapter);
	                                              var question_id = [];
	                                              var myJson = {
	                                                question_count: '',
	                                                all_questions: {},
	                                                readings: {},
	                                                cases: {}
	                                              };
	                                              for (var i = 0; i < chapterParse.length; i++) {
	                                                var objName = 'q' + i;
	                                                var objValue = chapterParse[i].id;
	                                                myJson.all_questions[i] = objValue;
	                                                myJson.readings[i] = chapterParse[i]['gmat_focus_reading.type'];
	                                                myJson.cases[i] = chapterParse[i].case_id;
	                                                question_id.push(chapterParse[i].id);
	                                              }
	                                              myJson.question_count = question_id.length;
	                                              var questions = JSON.stringify(myJson);
	                                              var data = {
	                                                token: _this.state.token,
	                                                idname: _this.state.idname,
	                                                number_questions: myJson.question_count,
	                                                questions: questions,
	                                                timer_value: timer_value
	                                              };
	                                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/createQuiz', data).then(function (resp) {
	                                                if (resp.success) {
	                                                  _this.setState({ display_loader: 'hide_block' });
	                                                  _this.context.router.push({
	                                                    pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                    //   `/gmat_beforestart/${resp.last_id}/${''}`,
	                                                    // state: {
	                                                    //   token: this.state.token,
	                                                    //   idname: this.state.idname,
	                                                    //   quiz_id: resp.last_id,
	                                                    //   status_send: '',
	                                                    // },
	                                                  });
	                                                } else {
	                                                  //console.log(resp.success);
	                                                }
	                                              });
	                                            } else {
	                                              _this.setState({ display_loader: 'hide_block' });
	                                              (0, _toast.showFailure)(resp.message);
	                                            }
	                                            return resp;
	                                          });
	                                        } else {
	                                          // console.log('else working')
	                                          checkboxes = document.getElementsByName('approve[]');
	                                          i = 0;
	                                          single_clicked_value = [];
	
	                                          if (_this.state.single_clicked_val == '') {
	                                            for (i = 0; i < checkboxes.length; i++) {
	                                              if (checkboxes[i].checked) {
	                                                // console.log(i+'----------'+checkboxes[i].value);
	                                                single_clicked_value.push(checkboxes[i].value);
	                                              }
	                                            }
	
	                                            chapterAll = single_clicked_value;
	                                            // console.log(chapterAll)
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning == 0 ? 'Integrated Reasoning' : _this.state.radio_checked_reasoning == 1 ? 'Quantitative Reasoning' : 'Verbal Reasoning'
	                                            };
	
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_focus_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    // console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          } else {
	                                            chapterAll = _this.state.single_clicked_val;
	                                            data = {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              chapterAll: chapterAll,
	                                              questionquize: parseInt(question_length_val),
	                                              priority: _this.state.radio_checked_priority,
	                                              // reasoning: chapterAll.length
	                                              //   ? chapterAll[0] === '1'
	                                              //     ? 'Integrated Reasoning'
	                                              //     : chapterAll[0] === '2'
	                                              //     ? 'Quantitative Reasoning'
	                                              //     : 'Verbal Reasoning'
	                                              //   : 'Verbal Reasoning',
	                                              reasoning: _this.state.radio_checked_reasoning
	                                            };
	
	                                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getQuizequestion', data).then(function (resp) {
	                                              if (resp.success) {
	                                                var retun_all_chapter = JSON.stringify(resp.chapters);
	                                                var chapterParse = JSON.parse(retun_all_chapter);
	                                                var question_id = [];
	                                                var myJson = {
	                                                  question_count: '',
	                                                  all_questions: {},
	                                                  readings: {},
	                                                  cases: {}
	                                                };
	                                                for (var i = 0; i < chapterParse.length; i++) {
	                                                  var objName = 'q' + i;
	                                                  var objValue = chapterParse[i].id;
	                                                  myJson.all_questions[i] = objValue;
	                                                  myJson.readings[i] = chapterParse[i]['gmat_focus_reading.type'];
	                                                  question_id.push(chapterParse[i].id);
	                                                  myJson.cases[i] = chapterParse[i].case_id;
	                                                }
	                                                myJson.question_count = question_id.length;
	                                                var questions = JSON.stringify(myJson);
	                                                var data_insert = {
	                                                  token: _this.state.token,
	                                                  idname: _this.state.idname,
	                                                  number_questions: myJson.question_count,
	                                                  questions: questions,
	                                                  timer_value: timer_value
	                                                };
	                                                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/createQuiz', data_insert).then(function (resp) {
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', resp.last_id).replace(':status_send', 'no')
	                                                      //   `/gmat_beforestart/${resp.last_id}`,
	                                                      // state: {
	                                                      //   token: this.state.token,
	                                                      //   idname: this.state.idname,
	                                                      //   quiz_id: resp.last_id,
	                                                      // },
	                                                    });
	                                                  } else {
	                                                    //console.log(resp.success);
	                                                  }
	                                                });
	                                              } else {
	                                                _this.setState({ display_loader: 'hide_block' });
	                                                (0, _toast.showFailure)(resp.message);
	                                              }
	                                              return resp;
	                                            });
	                                          }
	                                        }
	                                      } else {
	                                        _this.setState({ display_loader: 'hide_block' });
	                                        (0, _toast.showFailure)('Please Upgrade Your Account');
	                                      }
	
	                                    case 8:
	                                    case 'end':
	                                      return _context3.stop();
	                                  }
	                                }
	                              }, _callee3, _this2);
	                            }));
	
	                            return function (_x4) {
	                              return _ref5.apply(this, arguments);
	                            };
	                          }());
	
	                        case 17:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context6.next = 4;
	                              break;
	                            }
	
	                            _context6.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      token: '',
	      idname: '',
	      chapters: [{
	        chapter_no: 1,
	        chapter_name: 'Data Insights'
	      }, {
	        chapter_no: 2,
	        chapter_name: 'Quantitative Reasoning'
	      }, {
	        chapter_no: 3,
	        chapter_name: 'Verbal Reasoning'
	      }],
	      all_checked_state: true,
	      radio_checked_question: 0,
	      deleteItemId: '',
	      radio_checked_priority: 'none',
	      radio_checked_reasoning: 0,
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname'],
	        reasoning: this.state.radio_checked_reasoning
	      };
	
	      this.abandonedQuizzes(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        // console.log(resp_quiz_length.quiz_length);
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this3.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	  }, {
	    key: '_single_Checked',
	    value: function _single_Checked(items, index_value, e) {
	      var _this4 = this;
	
	      this.setState({ radio_checked_reasoning: index_value });
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reasoning: index_value
	      };
	      console.log('I am inside single checked');
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/quizzes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        if (resp_quiz_length.success) {
	          _this4.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this4.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	
	    /*_changeIncludetimer(){
	      if(this.state.include_timer)
	      {
	        this.setState({ include_timer:!this.state.include_timer });
	      }
	      else{
	        this.setState({ include_timer:!this.state.include_timer });
	      }    	
	    }*/
	
	    /*_changeSaveresult(){
	      if(this.state.save_results)
	      {
	        this.setState({ save_results:!this.state.save_results });
	      }
	      else{
	        this.setState({ save_results:!this.state.save_results });
	      }    
	    }*/
	
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', items.id).replace(':status_send', 'abondon')
	
	        //   `/gmat_beforestart/${items.id}/${'abondon'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: items.id,
	        //   status_send: 'abondon',
	        // },
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: _appRoutes2.default.QUIZZES_BEFORE_START.replace(':quiz_id', items.id).replace(':status_send', 'completed')
	
	        //   `/gmat_beforestart/${items.id}/${'completed'}`,
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   quiz_id: items.id,
	        //   status_send: 'completed',
	        // },
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'radio_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                // type='checkbox'
	                type: 'radio',
	                name: 'approve[]',
	                value: items.chapter_no,
	                checked: _this5.state.radio_checked_reasoning == index,
	                onClick: _this5._single_Checked.bind(_this5, items, index)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkAbondon.bind(_this5, items) },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                { className: 'delete-quizzes', onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  } },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cursor_pointer', onClick: _this5._checkCompleted.bind(_this5, items) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question == index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().CFA_LEVEL_I_QUIZZES
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary pointer_class', onClick: this._createQuiz.bind(this) },
	              ' ',
	              _language2.default.LC().CREATE_QUIZ,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().CONTENT
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    chapter_data
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().ABANDONED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        abandoned_data
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().Priorities_By,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().NONE,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'none',
	                      name: 'none',
	                      value: 'none',
	                      checked: this.state.radio_checked_priority == 'none',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    _language2.default.LC().UNANSWERED,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unanswered',
	                      name: 'mark_unanswered',
	                      value: 'unanswered',
	                      checked: this.state.radio_checked_priority == 'unanswered',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().Wrong_answers,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unattempted',
	                      name: 'mark_unattempted',
	                      value: 'wrongquestion',
	                      checked: this.state.radio_checked_priority == 'wrongquestion',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().LENGTH,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  quiz_length_state_data
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().COMPLETED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        getallcompleteQuiz_data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.deleteQuizzes },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Quizzes;
	}(_react.Component);
	
	Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = Quizzes;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(297);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var ChatperwiseReadingData = function (_Component) {
	  _inherits(ChatperwiseReadingData, _Component);
	
	  function ChatperwiseReadingData(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee5(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return _this.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this.state.user_city,
	                    country: _this.state.user_country,
	                    state: _this.state.user_state,
	                    continent: _this.state.user_continent,
	                    ip: _this.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserVideowatch', data).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                      return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              if (resp.success) {
	                                _this.context.router.push({
	                                  pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');
	
	                  _data = { token: _this.state.token, idname: _this.state.idname };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this.toggleAlert();
	                      } else {
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var, _data2;
	
	                            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                              while (1) {
	                                switch (_context3.prev = _context3.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context3.next = 10;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context3.next = 6;
	                                    return _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                  case 6:
	                                    isInArray_var = _context3.sent;
	
	                                    if (isInArray_var) {
	                                      _data2 = {
	                                        token: _this.state.token,
	                                        idname: _this.state.idname,
	                                        id: chapter.id,
	                                        videoIndex: index,
	                                        city: _this.state.user_city,
	                                        country: _this.state.user_country,
	                                        state: _this.state.user_state,
	                                        continent: _this.state.user_continent,
	                                        ip: _this.state.user_ip
	                                      };
	
	                                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserVideowatch', _data2).then(function () {
	                                        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                                          return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                            while (1) {
	                                              switch (_context2.prev = _context2.next) {
	                                                case 0:
	                                                  if (resp.success) {
	                                                    _this.context.router.push({
	                                                      pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                                    });
	                                                  } else {}
	
	                                                case 1:
	                                                case 'end':
	                                                  return _context2.stop();
	                                              }
	                                            }
	                                          }, _callee2, _this2);
	                                        }));
	
	                                        return function (_x5) {
	                                          return _ref4.apply(this, arguments);
	                                        };
	                                      }());
	                                    } else {
	                                      _this.toggleAlert();
	                                    }
	                                    _context3.next = 10;
	                                    break;
	
	                                  case 10:
	                                  case 'end':
	                                    return _context3.stop();
	                                }
	                              }
	                            }, _callee3, _this2);
	                          }));
	
	                          return function (_x4) {
	                            return _ref3.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      // console.log('heyyyyyyyyyyyyyy===============');
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                        // console.log('aaaaaaaaaaaaaaaa');
	                        return _this.toggleAlert();
	                      } else {
	                        // console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbbbb');
	                        var exam_selected = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : resp.profileInfo.exam_selected;
	                        var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                        _this.setState({
	                          subscription_details: subscription_details,
	                          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                        });
	                        // console.log('else working');
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          // console.log(
	                          //   resp_exam,
	                          //   '00000000000000000000000000000000000000000'
	                          // );
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            var selectedmen = _this.state.selectedmenu;
	                            var isInArray_var = false;
	                            isInArray_var = _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                            // console.log(isInArray_var, selectedmen, exam_data);
	                            if (isInArray_var) {
	                              // console.log('IF WORKING');
	
	                              var _data3 = {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                id: chapter.id,
	                                videoIndex: index,
	                                city: _this.state.user_city,
	                                country: _this.state.user_country,
	                                state: _this.state.user_state,
	                                continent: _this.state.user_continent,
	                                ip: _this.state.user_ip
	                              };
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserVideowatch', _data3).then(function () {
	                                var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                    while (1) {
	                                      switch (_context4.prev = _context4.next) {
	                                        case 0:
	                                          if (resp.success) {
	                                            _this.context.router.push({
	                                              pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', chapter.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', chapter.chapter_id).replace(':index', index)
	                                            });
	                                          } else {}
	
	                                        case 1:
	                                        case 'end':
	                                          return _context4.stop();
	                                      }
	                                    }
	                                  }, _callee4, _this2);
	                                }));
	
	                                return function (_x6) {
	                                  return _ref5.apply(this, arguments);
	                                };
	                              }());
	                            } else {
	                              // console.log('ELSE WORKING')
	                              return _this.toggleAlert();
	                            }
	                          } else {
	                            // console.log('fail');
	                          }
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(chapter, index) {
	        var _this$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this$state = _this.state, token = _this$state.token, idname = _this$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  videoIndex: index
	                };
	                _context6.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x7, _x8) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	
	    _this.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	
	      if (_this.state.allchapters.length) {
	        var count = 0;
	        data = _this.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              alt: '',
	              width: '100%',
	              src: item.posterImage ? item.posterImage : (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1'),
	              onError: function onError(_ref7) {
	                var currentTarget = _ref7.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	                  currentTarget.onerror = null; // prevents looping
	                  currentTarget.src = (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1_2');
	                }
	              },
	              value: index,
	              onClick: _this._getReadings.bind(_this, item, index),
	              className: 'pointer_class slider_row'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this._getReadings.bind(_this, item, index),
	              className: 'pointer_class slider_row'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this$state2, 'offset', 0), _defineProperty(_this$state2, 'limit', 10), _defineProperty(_this$state2, 'Allchapters', []), _defineProperty(_this$state2, 'itemData', []), _defineProperty(_this$state2, 'videoUrl', ''), _defineProperty(_this$state2, 'srcUrl', ''), _defineProperty(_this$state2, 'srcUrl_final', ''), _defineProperty(_this$state2, 'selectedmenu', 'gmat_focus'), _defineProperty(_this$state2, 'showFreePremium', true), _defineProperty(_this$state2, 'user_city', ''), _defineProperty(_this$state2, 'user_country', ''), _defineProperty(_this$state2, 'user_ip', ''), _defineProperty(_this$state2, 'user_state', ''), _defineProperty(_this$state2, 'user_continent', ''), _this$state2);
	    return _this;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var result, storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context7.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context7.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATVideosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this3.setState({ allchapters: resp.cfavchapter });
	                  } else {
	                    _this3.setState({ allchapters: [] });
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	exports.default = ChatperwiseReadingData;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _ChatperwiseReadingData = __webpack_require__(836);
	
	var _ChatperwiseReadingData2 = _interopRequireDefault(_ChatperwiseReadingData);
	
	__webpack_require__(297);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var GMATVideoLessons = function (_Component) {
	  _inherits(GMATVideoLessons, _Component);
	
	  function GMATVideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GMATVideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (GMATVideoLessons.__proto__ || Object.getPrototypeOf(GMATVideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATVideosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', resp.cfavchapterfirst.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', chapter.chapter_id === 0 ? 0 : 1).replace(':chapter_id', resp.cfavchapterfirst.chapter_id).replace(':index', 0)
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', lastRecord.gmat_focus_video.id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':type', lastRecord.gmat_focus_video.chapter_id === 0 ? 0 : 1).replace(':chapter_id', lastRecord.gmat_focus_video.chapter_id).replace(':index', lastRecord.videoIndex)
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_gmat,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'gmat_focus',
	      exams: [],
	      cfaUnlimitedPackage: '',
	      cfaUnlimitedActiveExam: '',
	      lastRecord: '',
	      lastAttempt: false,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(GMATVideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	                  var resp, subscription_details, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                      switch (_context6.prev = _context6.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context6.next = 3;
	                            break;
	                          }
	
	                          return _context6.abrupt('return');
	
	                        case 3:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context6.next = 16;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context6.next = 8;
	                            break;
	                          }
	
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context6.next = 14;
	                          break;
	
	                        case 8:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this3.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context6.next = 14;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var;
	                              return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                while (1) {
	                                  switch (_context5.prev = _context5.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context5.next = 10;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this3.state.selectedmenu;
	                                      isInArray_var = false;
	                                      _context5.next = 6;
	                                      return _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	
	                                    case 6:
	                                      isInArray_var = _context5.sent;
	
	                                      if (isInArray_var) {
	                                        _this3.setState({ showFreePremium: false });
	                                      } else {
	                                        _this3.setState({ showFreePremium: true });
	                                      }
	                                      _context5.next = 10;
	                                      break;
	
	                                    case 10:
	                                    case 'end':
	                                      return _context5.stop();
	                                  }
	                                }
	                              }, _callee5, _this3);
	                            }));
	
	                            return function (_x4) {
	                              return _ref7.apply(this, arguments);
	                            };
	                          }());
	
	                        case 14:
	                          _context6.next = 26;
	                          break;
	
	                        case 16:
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '')) {
	                            _context6.next = 20;
	                            break;
	                          }
	
	                          // console.log('if working')
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context6.next = 26;
	                          break;
	
	                        case 20:
	                          subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                          _this3.setState({
	                            subscription_details: subscription_details,
	                            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                          });
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context6.next = 26;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this3.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                              // console.log(isInArray_var);
	                              if (isInArray_var) {
	                                // console.log('IF WORKING')
	                                _this3.setState({ showFreePremium: false });
	                              } else {
	                                // console.log('ELSE WORKING')
	                                _this3.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 26:
	                        case 'end':
	                          return _context6.stop();
	                      }
	                    }
	                  }, _callee6, _this3);
	                })));
	
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    // console.log(resp.exams[0])
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ chapters: resp.cfavideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 10:
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context7.next = 13;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getlastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 13:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      // console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  ' ',
	                  item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement(
	                  'p',
	                  { className: 'text-danger font-weight-bold font-16px text-center' },
	                  'Coming Soon ...'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(_ChatperwiseReadingData2.default, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(_loader2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12' },
	                    _react2.default.createElement('div', { className: 'card' })
	                  ),
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent
	          })
	        )
	      );
	    }
	  }]);
	
	  return GMATVideoLessons;
	}(_react.Component);
	
	GMATVideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	exports.default = GMATVideoLessons;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _GMATFocusSubscription = __webpack_require__(75);
	
	var _GMATFocusSubscription2 = _interopRequireDefault(_GMATFocusSubscription);
	
	var _GMATFocusSubscription3 = __webpack_require__(77);
	
	var _GMATFocusSubscription4 = _interopRequireDefault(_GMATFocusSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	__webpack_require__(1011);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _toast = __webpack_require__(15);
	
	var _appRoutes = __webpack_require__(40);
	
	var _appRoutes2 = _interopRequireDefault(_appRoutes);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var GMATvideodisplay = function (_Component) {
	  _inherits(GMATvideodisplay, _Component);
	
	  function GMATvideodisplay(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, GMATvideodisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (GMATvideodisplay.__proto__ || Object.getPrototypeOf(GMATvideodisplay)).call(this, props));
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserVideowatch', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          currentUrl = _this$state.currentUrl;
	
	      if (_this.state.userType === 'paid') {
	        // const result = getDeviceDetails();
	        var data = {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          id: chapters[currentUrl].id,
	          videoIndex: currentUrl,
	          city: _this.state.user_city,
	          country: _this.state.user_country,
	          state: _this.state.user_state,
	          continent: _this.state.user_continent,
	          ip: _this.state.user_ip
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/trackUserVideoPPTDownload', data).then(function (resp) {
	          if (resp.success) {
	            var myWindow = window.open(_this.state.pdf_file);
	            myWindow.focus();
	          }
	          return resp;
	        });
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      // console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        comment: comment,
	        videoIndex: _this.state.currentUrl,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/videoGetFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: _appRoutes2.default.VIDEO_LESSONS
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context2.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context2.next = 6;
	                        return _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                      case 6:
	                        isInArray_var = _context2.sent;
	
	
	                        if (isInArray_var) {
	                          _this._runCode('paid');
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free');
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context2.next = 10;
	                        break;
	
	                      case 10:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              }));
	
	              return function (_x3) {
	                return _ref2.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	            return _this.toggleAlert();
	          } else {
	            // console.log(resp, 'sssssssssssssssssssssssss');
	            _this.setState({
	              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	                // console.log('selectedmen--------------------', selectedmen);
	                // console.log('isInArray_var--------------------', isInArray_var);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(index, url_id, title, id, url_id_qq, free, item) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: item.id,
	                  currentChapterNo: item.chapter_id,
	                  currentReadingNo: item.reading_no,
	                  currentReadingTitle: item.title,
	                  pdf_file: item.pdf_file
	                }, function () {
	                  _this.context.router.push({
	                    pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                    // `/cfavideodisplay/${this.props.params.id}/${
	                    //   this.props.params.showFreePremium
	                    // }/${this.props.params.type}/${this.props.params.chapter_id}/${
	                    //   this.state.currentUrl
	                    // }`,
	                  });
	                });
	
	                _context6.next = 4;
	                return _this.savelastVideo(id, index);
	
	              case 4:
	                _context6.next = 6;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 6:
	                _context6.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee4$(_context4) {
	                            while (1) {
	                              switch (_context4.prev = _context4.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context4.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context4.next = 6;
	                                  return _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context4.sent;
	
	                                  if (!isInArray_var) {
	                                    _context4.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                                      // `/cfavideodisplay/${this.props.params.id}/${
	                                      //   this.props.params.showFreePremium
	                                      // }/${this.props.params.type}/${
	                                      //   this.props.params.chapter_id
	                                      // }/${this.state.currentUrl}`,
	                                    });
	                                  });
	                                  _context4.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context4.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context4.abrupt('return');
	
	                                case 16:
	                                  return _context4.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context4.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context4.stop();
	                              }
	                            }
	                          }, _callee4, _this2);
	                        }));
	
	                        return function (_x12) {
	                          return _ref5.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	                      // console.log("if working");
	
	                      return _this.toggleAlert();
	                    } else {
	                      var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                      _this.setState({
	                        subscription_details: subscription_details,
	                        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	                      });
	
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context5.next = 6;
	                                  return _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this.state.cfaUnlimitedPackage, _this.state.cfaUnlimitedActiveExam);
	
	                                case 6:
	                                  isInArray_var = _context5.sent;
	
	                                  if (!isInArray_var) {
	                                    _context5.next = 16;
	                                    break;
	                                  }
	
	                                  // console.log('IF WORKING')
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    currentUrl: index,
	                                    video_title: title,
	                                    currentReading: item.id,
	                                    currentChapterNo: item.chapter_id,
	                                    currentReadingNo: item.reading_no,
	                                    currentReadingTitle: item.title,
	                                    pdf_file: item.pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', _this.props.params.id).replace(':showFreePremium', _this.props.params.showFreePremium).replace(':type', _this.props.params.type).replace(':chapter_id', _this.props.params.chapter_id).replace(':index', _this.state.currentUrl)
	
	                                      // `/cfavideodisplay/${this.props.params.id}/${
	                                      //   this.props.params.showFreePremium
	                                      // }/${this.props.params.type}/${
	                                      //   this.props.params.chapter_id
	                                      // }/${this.state.currentUrl}`,
	                                    });
	                                  });
	                                  _context5.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context5.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context5.abrupt('return');
	
	                                case 16:
	                                  return _context5.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context5.next = 20;
	                                  break;
	
	                                case 19:
	                                  console.log('fail');
	
	                                case 20:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this2);
	                        }));
	
	                        return function (_x13) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x5, _x6, _x7, _x8, _x9, _x10, _x11) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(id, index) {
	        var _this$state2, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this$state2 = _this.state, token = _this$state2.token, idname = _this$state2.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context7.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x14, _x15) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      // console.log('_saveFavVideo', item);
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = (_this$state3 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state3, 'MessageTitle', messageTitle_cfa), _defineProperty(_this$state3, 'MessageContent', _alertMessage2.default.messageContent_gmat), _defineProperty(_this$state3, 'token', ''), _defineProperty(_this$state3, 'idname', ''), _defineProperty(_this$state3, 'ValidToken', false), _defineProperty(_this$state3, 'all_questions', ''), _defineProperty(_this$state3, 'chapters', []), _defineProperty(_this$state3, 'all_questions_state', []), _defineProperty(_this$state3, 'video_display', ''), _defineProperty(_this$state3, 'video_display_qq', ''), _defineProperty(_this$state3, 'url_id', ''), _defineProperty(_this$state3, 'currentUrl', ''), _defineProperty(_this$state3, 'reportLoading', false), _defineProperty(_this$state3, 'free', ''), _defineProperty(_this$state3, 'video_title', ''), _defineProperty(_this$state3, 'video_display_no', ''), _defineProperty(_this$state3, 'allChapters', []), _defineProperty(_this$state3, 'Chapter_Title', ''), _defineProperty(_this$state3, 'chapterName', ''), _defineProperty(_this$state3, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state3, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state3, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state3, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state3, 'currentReading', _this.props.params.id), _defineProperty(_this$state3, 'comment_update_id', ''), _defineProperty(_this$state3, 'currentChapterNo', ''), _defineProperty(_this$state3, 'currentReadingNo', ''), _defineProperty(_this$state3, 'currentReadingTitle', ''), _defineProperty(_this$state3, 'subscriptionstatus', ''), _defineProperty(_this$state3, 'selectedmenu', 'gmat_focus'), _defineProperty(_this$state3, 'subscription_details_for_isActive', ''), _defineProperty(_this$state3, 'pdfData', []), _defineProperty(_this$state3, 'pdf_file', ''), _defineProperty(_this$state3, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state3, 'userType', ''), _defineProperty(_this$state3, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state3, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state3, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state3, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state3, 'bookmarkColor', ''), _defineProperty(_this$state3, 'isFlashCardHidden', true), _defineProperty(_this$state3, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _this$state3);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(GMATvideodisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
	      // const result = getDeviceDetails();
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	      this.context.router.push({
	        pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium).replace(':type', this.props.params.type).replace(':chapter_id', this.props.params.chapter_id).replace(':index', this.state.currentUrl + 1)
	
	        // `/cfavideodisplay/${this.props.params.id}/${
	        //   this.props.params.showFreePremium
	        // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
	        //   .currentUrl + 1}`,
	      });
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        // if (this.state.currentUrl || this.state.currentUrl) {
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("_goToPreviousReading-tooogle");
	              return _this3.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this3.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this3.state.cfaUnlimitedPackage, _this3.state.cfaUnlimitedActiveExam);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    // console.log('IF WORKING')
	                    // console.log("_goToPreviousReading Premium");
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      // console.log('currentUrl', this.state.currentUrl);
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      this.context.router.push({
	        pathname: _appRoutes2.default.VIDEO_DISPLAY.replace(':id', this.props.params.id).replace(':showFreePremium', this.props.params.showFreePremium).replace(':type', this.props.params.type).replace(':chapter_id', this.props.params.chapter_id).replace(':index', this.state.currentUrl + 1)
	
	        // `/cfavideodisplay/${this.props.params.id}/${
	        //   this.props.params.showFreePremium
	        // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
	        //   .currentUrl + 1}`,
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                      switch (_context8.prev = _context8.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context8.next = 16;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this4.state.selectedmenu;
	                          isInArray_var = false;
	                          _context8.next = 6;
	                          return _GMATFocusSubscription4.default.checkGMATVideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	
	                        case 6:
	                          isInArray_var = _context8.sent;
	
	                          if (!isInArray_var) {
	                            _context8.next = 13;
	                            break;
	                          }
	
	                          _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                            _this4.setState({
	                              video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                            });
	                            _this4.setState({
	                              video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                            });
	                            _this4.setState({
	                              video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                            });
	                            _this4.setState({
	                              currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                            });
	                            _this4.setState({
	                              currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                            });
	                            _this4.setState({
	                              currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                            });
	                            _this4.setState({
	                              pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                            });
	                          });
	                          _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                          return _context8.abrupt('return');
	
	                        case 13:
	                          return _context8.abrupt('return', _this4.toggleAlert());
	
	                        case 14:
	                          _context8.next = 17;
	                          break;
	
	                        case 16:
	                          console.log('fail');
	
	                        case 17:
	                        case 'end':
	                          return _context8.stop();
	                      }
	                    }
	                  }, _callee8, _this4);
	                }));
	
	                return function (_x16) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.cfaUnlimitedPackage == '' && resp.profileInfo.cfaUnlimitedActiveExam == '') {
	              // console.log("working");
	              // console.log("_goToNextReading toggleAlert");
	
	              return _this4.toggleAlert();
	            } else {
	              var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	              _this4.setState({
	                subscription_details: subscription_details,
	                cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
	                cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam
	              });
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _GMATFocusSubscription2.default.checkGMATVideosSubscription(selectedmen, exam_data, _this4.state.cfaUnlimitedPackage, _this4.state.cfaUnlimitedActiveExam);
	                  if (isInArray_var) {
	                    // console.log("_goToNextReading Premium");
	
	                    // console.log('IF WORKING')
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    // function to track user watched video
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      // console.log('hiyuuuuuuuuu', subscriptionstatus);
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: this.state.currentReadingNo,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getQuestions', data).then(function (resp) {
	        // console.log('resp');
	        if (resp && resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: _appRoutes2.default.QUESTION_BANK_LIST_QUE.replace(':chapter_no', _this5.state.currentChapterNo).replace(':id', _this5.state.currentReadingNo).replace(':subscriptionstatus', _this5.state.subscriptionstatus).replace(':reading', _this5.state.currentReadingTitle)
	            });
	          } else {
	            (0, _toast.showFailure)('No questions found');
	          }
	        } else {
	          _this5.toggleAlert();
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(prevProps, prevState) {
	        var _this6 = this;
	
	        var params;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context9.next = 7;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context9.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context9.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._deleteFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({ ValidToken: false });
	                    _this6.setState({ flash_data: flash_cards });
	                    _this6.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidUpdate(_x17, _x18) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	        var _this7 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context11.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context11.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	                if (this.props.params.index) {
	                  // console.log('IF Working');
	                  this.setState({
	                    currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0
	                  });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id !== ':chapter_id' ? this.props.params.chapter_id : this.props.params.id
	                };
	                // console.log('this.propsssssssssssssss', this.props);
	
	                _context11.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATVideosChapterwise', data).then(function () {
	                  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp) {
	                    return _regenerator2.default.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context10.next = 28;
	                              break;
	                            }
	
	                            _context10.next = 3;
	                            return _this7.setState({ ValidToken: true });
	
	                          case 3:
	                            _context10.next = 5;
	                            return _this7.setState({ chapters: resp.cfavchapter });
	
	                          case 5:
	                            if (!(_this7.state.chapters && _this7.state.chapters.length && _this7.state.chapters[_this7.state.currentUrl])) {
	                              _context10.next = 26;
	                              break;
	                            }
	
	                            _context10.next = 8;
	                            return _this7.setState({
	                              pdf_file: _this7.state.chapters[_this7.state.currentUrl] && _this7.state.chapters[_this7.state.currentUrl].pdf_file ? _this7.state.chapters[_this7.state.currentUrl].pdf_file : null
	                            });
	
	                          case 8:
	                            _context10.next = 10;
	                            return _this7.setState({
	                              currentReading: _this7.state.chapters[_this7.state.currentUrl].id
	                            });
	
	                          case 10:
	                            _context10.next = 12;
	                            return _this7.setState({
	                              video_display: _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 12:
	                            _context10.next = 14;
	                            return _this7.setState({
	                              video_display_qq: _this7.state.chapters[_this7.state.currentUrl].url_id_qq
	                            });
	
	                          case 14:
	                            _context10.next = 16;
	                            return _this7.setState({
	                              video_display_previous: _this7.state.chapters[_this7.state.currentUrl].url_id
	                            });
	
	                          case 16:
	                            _context10.next = 18;
	                            return _this7.setState({
	                              video_title: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 18:
	                            _context10.next = 20;
	                            return _this7.setState({
	                              video_display_next: _this7.state.chapters[_this7.state.currentUrl + 1] ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id : null
	                            });
	
	                          case 20:
	                            _context10.next = 22;
	                            return _this7.setState({
	                              currentChapterNo: _this7.state.chapters[_this7.state.currentUrl].chapter_id
	                            });
	
	                          case 22:
	                            _context10.next = 24;
	                            return _this7.setState({
	                              currentReadingNo: _this7.state.chapters[_this7.state.currentUrl].reading_no
	                            });
	
	                          case 24:
	                            _context10.next = 26;
	                            return _this7.setState({
	                              currentReadingTitle: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 26:
	                            _context10.next = 29;
	                            break;
	
	                          case 28:
	                            _this7.setState({ ValidToken: false });
	
	                          case 29:
	                            return _context10.abrupt('return', resp);
	
	                          case 30:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this7);
	                  }));
	
	                  return function (_x19) {
	                    return _ref11.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context11.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getGMATVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ ValidToken: true });
	                    _this7.setState({ allChapters: resp.cfavideo });
	                    _this7.props.params.chapter_id === undefined ? null : _this7.setState({
	                      Chapter_Title: resp.cfavideo && resp.cfavideo[_this7.props.params.chapter_id - 1] && resp.cfavideo[_this7.props.params.chapter_id - 1].chapter_name ? resp.cfavideo[_this7.props.params.chapter_id - 1].chapter_name : ''
	                    });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 16:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context11.next = 19;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 19:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context11.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this7.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._editFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._deleteFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this7.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this7.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this7.setState({ ValidToken: false });
	                    _this7.setState({ flash_data: flash_cards });
	                    _this7.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 22:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context11.next = 25;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/gmat-focus/question-bank/getgmat_video_pdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ pdfData: resp });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 25:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          type = _state.type,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          pdf_file = _state.pdf_file,
	          bookmarkCSS = _state.bookmarkCSS,
	          bookmarkColor = _state.bookmarkColor,
	          questionsCSS = _state.questionsCSS,
	          saveVideo_text = _state.saveVideo_text,
	          currentReading = _state.currentReading,
	          chapters = _state.chapters,
	          showFreePremium = _state.showFreePremium;
	
	
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this8.state.showFreePremium ? item.free === 1 || type === 'intro' ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id === _this8.state.video_display ? 'active' : '',
	                    onClick: _this8.getVideourl.bind(_this8, index, item.url_id, item.title, item.id, item.url_id_qq, item.free, item),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'mb-0' },
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        allowFullScreen: true,
	                        width: '100%',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: (0, _constant.flowPlayerVideoDisplayUrl)(this.state.video_display_qq),
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(_VideoValidateReportIcons2.default, {
	                moveToNotes: this.moveToNotes
	                // notesCSS={this.state.notesCSS}
	                , moveToPracticeQuestions: this.moveToPracticeQuestions,
	                _saveFavVideo: this._saveFavVideo,
	                _displayReportForm: this._displayReportForm,
	                viewPdf: this.pdfOpen,
	                pdfFile: pdf_file,
	                noPDFInExam: pdf_file ? false : true,
	                bookmarkCSS: bookmarkCSS,
	                bookmarkColor: bookmarkColor,
	                type: type,
	                questionsCSS: questionsCSS,
	                saveVideo_text: saveVideo_text,
	                currentReading: currentReading,
	                chapters: chapters,
	                showFreePremium: showFreePremium
	              })
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(_FlashCard2.default, {
	                item: { id: currentReading },
	                type: 'video',
	                isFlashCardHidden: isFlashCardHidden,
	                ref: this.setChildRef,
	                exam: 'gmat_focus'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 d-none' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'card-header pointer_class',
	                      onClick: this._getToggleFlash.bind()
	                    },
	                    _language2.default.LC().FLASHCARD,
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'float-right text-right' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/arrow_down_ico.png', alt: '' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' }, ref: 'flash_toggle_div' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-block' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-xs-12 col-sm-12 col-md-12' },
	                          _react2.default.createElement(
	                            'ul',
	                            { className: 'comment_list_wrapper' },
	                            this.state.flash_data
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: this.state.flash_form },
	                          _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement('textarea', {
	                              id: 'flash_card',
	                              name: 'flash_card',
	                              rows: '6',
	                              className: 'form-control margin_bottom_10',
	                              placeholder: 'Your flash card here'
	                            }),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                type: 'button',
	                                className: 'btn btn-primary active pointer_class',
	                                onClick: this._saveFlashCard.bind(this, this.state.currentReading)
	                              },
	                              _language2.default.LC().CREATE
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              '*',
	                              _language2.default.LC().FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GMATvideodisplay;
	}(_react.Component);
	
	GMATvideodisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.resizeListener = function () {
	      // write code here
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	    };
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this10 = this;
	
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context12.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this10.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref12.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var windowwidth = window.innerWidth;
	      var videoHeight = document.getElementById('video-height').offsetHeight;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoHeight + 'px';
	      if (windowwidth > 992) {
	        listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	      } else {
	        listHeight.setAttribute('style', 'height: auto !important');
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = GMATvideodisplay;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getData = __webpack_require__(144);
	
	var _getData2 = _interopRequireDefault(_getData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var OrderDiscription = function (_Component) {
	  _inherits(OrderDiscription, _Component);
	
	  function OrderDiscription(props) {
	    _classCallCheck(this, OrderDiscription);
	
	    var _this = _possibleConstructorReturn(this, (OrderDiscription.__proto__ || Object.getPrototypeOf(OrderDiscription)).call(this, props));
	
	    _this.getChinaPrice = function () {
	      _getData2.default.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then(function (resp) {
	        // console.log("resunfnvd", resp);
	        // console.log("dollar", resp.rates.CNY);
	        _this.setState({
	          China_price: resp.rates.CNY
	        });
	      });
	      _getData2.default.GetCallAPI('https://api.exchangeratesapi.io/latest?base=CAD').then(function (resp) {
	        // console.log("resunfnvd", resp);
	        // console.log("canada", resp.rates.CNY);
	        _this.setState({
	          Canadian_China_price: resp.rates.CNY
	        });
	      });
	    };
	
	    _this.getOrdersById = function (idname, token) {
	      var data = {
	        idname: idname,
	        token: token,
	        order_id: _this.props.params.orderid
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getOrdersbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            orders_details: {
	              order_data: resp.orders_val,
	              amount: resp.amount
	            }
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      readings: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      selectedMenu: _this.props.params.selectedMenu,
	      orders_details: {
	        order_data: {},
	        amount: 0
	      },
	      username: '',
	      China_price: 6.55,
	      Canadian_China_price: 5.22,
	      canadian_price: 5.22,
	      usd_canadian_price: 1.26
	    };
	
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	
	  _createClass(OrderDiscription, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.getChinaPrice();
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      this.getOrdersById(storage_session['idname'], storage_session['token']);
	      this.props.params ? this.setState({ username: this.props.params.username }) : null;
	    }
	  }, {
	    key: '_orderHistory',
	    value: function _orderHistory() {
	      this.context.router.push({
	        pathname: '/orderhistory/' + localStorage.getItem('selectedmenu') + '/' + this.state.username,
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: localStorage.getItem('selectedmenu'),
	          username: this.state.username
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var domainApp = localStorage.getItem('domainApp');
	      var plan_details = this.state.orders_details && Object.keys(this.state.orders_details.order_data).length > 0 ? JSON.parse(this.state.orders_details.order_data).all_order_details : null;
	      var data1 = '';
	      if (plan_details && plan_details.length) {
	        data1 = Object.keys(plan_details).map(function (item, index) {
	          return _react2.default.createElement(
	            'tbody',
	            { key: index },
	            _react2.default.createElement(
	              'tr',
	              { className: 'package-heading' },
	              _react2.default.createElement(
	                'td',
	                { width: '60%' },
	                plan_details[index].exam_name + ' (' + plan_details[index].package_type + ') '
	              ),
	
	              // domainApp === 'WORLD' ?
	              _react2.default.createElement(
	                'td',
	                { width: '20%' },
	                plan_details[index].type !== 'unlessUnlimited' ? '$' + plan_details[index].price : null
	              )
	              //  : (
	              //   <td width='20%'>
	              //     {plan_details[index].type !== 'unlessUnlimited'
	              //       ? `¥${Math.ceil(
	              //           Math.ceil(
	              //             plan_details[index].price * this.state.China_price
	              //           ) / 10
	              //         ) *
	              //           10 -
	              //           1}`
	              //       : null}
	              //   </td>
	              // )
	              ,
	
	              // domainApp === 'WORLD' ?
	              _react2.default.createElement(
	                'td',
	                { width: '20%' },
	                plan_details[index].type !== 'unlessUnlimited' ? '$' + (plan_details[index].percent_discount == 0 ? plan_details[index].percent_discount : Math.ceil(plan_details[index].price * plan_details[index].percent_discount) / 100) : null
	              )
	              //  : (
	              //   <td width='20%'>
	              //     {plan_details[index].type !== 'unlessUnlimited'
	              //       ? `¥${
	              //           plan_details[index].percent_discount == 0
	              //             ? plan_details[index].percent_discount
	              //             : Math.ceil(
	              //                 plan_details[index].price *
	              //                   plan_details[index].percent_discount
	              //               ) / 100
	              //         }`
	              //       : null}
	              //   </td>
	              // )
	
	            ),
	            plan_details[index].extras.map(function (extras, key) {
	              return _react2.default.createElement(
	                'tr',
	                { key: key, className: 'extras-table' },
	                _react2.default.createElement(
	                  'td',
	                  { width: '60%' },
	                  '- ' + extras.title
	                ),
	
	                // domainApp === 'WORLD' ?
	                _react2.default.createElement(
	                  'td',
	                  { width: '20%' },
	                  '$',
	                  extras.price
	                )
	                // : (
	                //   <td width='20%'>
	                //     {Math.ceil(
	                //       Math.ceil(extras.price * this.state.China_price) / 10
	                //     ) *
	                //       10 -
	                //       1}
	                //   </td>
	                // )
	                ,
	                _react2.default.createElement('td', { width: '20%' })
	              );
	            })
	          );
	        });
	      }
	
	      var tot_price = 0;
	      if (plan_details && plan_details.length) {
	        Object.keys(plan_details).map(function (item, index) {
	          if (plan_details[index].percent_discount == '') {
	            tot_price +=
	            // domainApp === 'WORLD'  ?
	            tot_price += plan_details[index].price;
	            // : Math.ceil(
	            //     Math.ceil(
	            //       plan_details[index].price * this.state.China_price
	            //     ) / 10
	            //   ) *
	            //     10 -
	            //   1;
	          } else {
	            tot_price +=
	            // domainApp === 'WORLD'?
	            plan_details[index].price - Number(plan_details[index].price * plan_details[index].percent_discount / 100);
	            // : Math.ceil(
	            //   Math.ceil(
	            //     plan_details[index].price -
	            //     Number(
	            //       (plan_details[index].price *
	            //         plan_details[index].percent_discount) /
	            //       100
	            //     ) *
	            //     this.state.China_price
	            //   ) / 10
	            // ) *
	            // 10 -
	            // 1;
	          }
	        });
	      }
	      var payment_details = this.state.orders_details && Object.keys(this.state.orders_details.order_data).length > 0 ? JSON.parse(this.state.orders_details.order_data) : null;
	      var totalAmount = this.state.orders_details && this.state.orders_details.amount ? this.state.orders_details.amount.toFixed(2) : 0;
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mb-1 d-inline-block' },
	                  _language2.default.LC().Order_Details
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-md-right' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary pointer_class',
	                      onClick: this._orderHistory.bind(this)
	                    },
	                    ' ',
	                    _language2.default.LC().GO_TO_HISTORY,
	                    ' '
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-7 margin_bottom_30' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table_responsive_wrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'table-responsive thankyou_tb' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table cart_table ' },
	                          _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                { width: '60%' },
	                                _language2.default.LC().PACKAGE
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                { width: '20%' },
	                                _language2.default.LC().PRICE
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                { width: '20%' },
	                                _language2.default.LC().DISCOUNT
	                              )
	                            )
	                          ),
	                          data1,
	                          _react2.default.createElement(
	                            'tfoot',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              { className: this.state.cart_bottom },
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                  'strong',
	                                  null,
	                                  _language2.default.LC().TOTAL
	                                )
	                              ),
	
	                              // domainApp === 'WORLD' ?
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                '$',
	                                totalAmount
	                              )
	                              // : (
	                              //   <td>
	                              //     ¥
	                              //     {Math.ceil(
	                              //       Math.ceil(
	                              //         totalAmount *
	                              //         this.state.Canadian_China_price
	                              //       ) / 10
	                              //     ) *
	                              //       10 -
	                              //       1}
	                              //   </td>
	                              // )
	                              ,
	                              _react2.default.createElement('td', null)
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-5' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-responsive thankyou_tb' },
	                      payment_details ? _react2.default.createElement(
	                        'table',
	                        { className: 'table cart_table' },
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                ' ',
	                                _language2.default.LC().ORDER_ID,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              payment_details.order_id
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().NAME,
	                                ':'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize' },
	                              payment_details.username
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().PAYMENT_METHOD,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-capitalize' },
	                              payment_details.payment_type
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().EMAIL,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              payment_details.idname
	                            )
	                          )
	                        )
	                      ) : null
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderDiscription;
	}(_react.Component);
	
	OrderDiscription.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = OrderDiscription;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getData = __webpack_require__(144);
	
	var _getData2 = _interopRequireDefault(_getData);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var OrderHistory = function (_Component) {
	  _inherits(OrderHistory, _Component);
	
	  function OrderHistory(props) {
	    _classCallCheck(this, OrderHistory);
	
	    var _this = _possibleConstructorReturn(this, (OrderHistory.__proto__ || Object.getPrototypeOf(OrderHistory)).call(this, props));
	
	    _this._getOrderdiscription = function (order, e) {
	      _this.context.router.push({
	        pathname: '/orderdiscription/' + order.id + '/' + _this.state.selectedMenu + '/' + _this.state.username
	      });
	    };
	
	    _this.getChinaPrice = function () {
	      _getData2.default.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then(function (resp) {
	        // console.log("resunfnvd", resp);
	        // console.log("dollar", resp.rates.CNY);
	        _this.setState({
	          China_price: resp.rates.CNY
	        });
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      readings: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      selectedMenu: _this.props.params.selectedMenu,
	      orders_list: '',
	      no_restult_display: '',
	      startLoaderPage: false,
	      username: '',
	      China_price: 6.55,
	      canadian_price: 5.22,
	      usd_canadian_price: 1.26
	    };
	    return _this;
	  }
	
	  //it is use to redirect page
	
	  _createClass(OrderHistory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // this.getChinaPrice();
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      this.props.params ? this.setState({ username: this.props.params.username }) : null;
	      this.setState({ startLoaderPage: true });
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getOrders', data).then(function (resp) {
	        if (resp.success) {
	          // console.log(resp.orders);
	          _this2.setState({ ValidToken: true });
	          _this2.setState({ orders_list: resp.orders });
	          _this2.setState({ startLoaderPage: false });
	          if (!resp.orders.length) {
	            _this2.setState({
	              no_restult_display: '<td colspan="6" className="" align="center"> ' + _language2.default.LC().No_Order_History + ' </td>'
	            });
	          }
	        } else {
	          _this2.setState({ ValidToken: false });
	          _this2.setState({ startLoaderPage: false });
	        }
	        return resp;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var orders_list = this.state.orders_list;
	      var data = '';
	      if (this.state.orders_list.length) {
	        data = orders_list.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.id
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text-capitalize' },
	              item.payment_type
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text-capitalize' },
	              item.payment_status
	            ),
	            ' ',
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(Package_fun, { order_data: item.order_data })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              (0, _moment2.default)(item.createdAt).format('llll')
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.payment_type !== 'AppSumo' ? _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn_circle_sm',
	                  onClick: _this3._getOrderdiscription.bind(_this3, item),
	                  id: item.id
	                },
	                _react2.default.createElement('i', { className: 'fa fa-eye' })
	              ) : '-'
	            )
	          );
	        });
	      } else {
	        data = (0, _function.renderHTMLContent)(this.state.no_restult_display, "tr", "", { contentEditable: 'false' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        this.state.startLoaderPage ? _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header order-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().ORDERS_History
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().GO_TO_PROFILE
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'table_responsive_wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-responsive order_his_tb' },
	              _react2.default.createElement(
	                'table',
	                { className: 'cart_table table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    { className: 'border_top_0' },
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().ORDER_ID
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().PAYMENT_TYPE
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().PAYMENT_STATUS
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().PACKAGE
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().ORDER_DATE
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().ACTION
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  data
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderHistory;
	}(_react.Component);
	
	OrderHistory.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var returnpackage_val = '';
	
	function Package_fun(props) {
	  if (props.order_data) {
	    var data = JSON.parse(props.order_data);
	    var package_details = data.all_order_details;
	
	    returnpackage_val = package_details.map(function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        _react2.default.createElement(
	          'li',
	          { className: 'package-heading' },
	          item.exam_name + ' - ' + item.package_type
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'order' },
	          item.extras ? item.extras.map(function (extras, index) {
	            return _react2.default.createElement(
	              'span',
	              { key: index },
	              _react2.default.createElement(
	                'li',
	                { className: 'order-extras' },
	                '- ' + extras.title
	              )
	            );
	          }) : ''
	        )
	      );
	    });
	  }
	  return _react2.default.createElement(
	    'span',
	    null,
	    returnpackage_val
	  );
	}
	
	exports.default = OrderHistory;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _getData = __webpack_require__(144);
	
	var _getData2 = _interopRequireDefault(_getData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { getDeviceDetails } from "../../../common/deviceDetails";
	
	
	/* eslint-disable */
	
	var AppSumo = function (_Component) {
	  _inherits(AppSumo, _Component);
	
	  function AppSumo(props) {
	    _classCallCheck(this, AppSumo);
	
	    var _this = _possibleConstructorReturn(this, (AppSumo.__proto__ || Object.getPrototypeOf(AppSumo)).call(this, props));
	
	    _this.onSubmitNewUser = function (event) {
	      event.preventDefault();
	      var userData = JSON.parse(localStorage.getItem('userData'));
	
	      _this.setState({
	        displaytext: 'hide_block',
	        message: '',
	        loading: true
	      });
	      if (_this.state.username === '') {
	        _this.setState({
	          displaytext: 'show_block',
	          userNameErrorMessage: '' + _language2.default.LC().User_Name_is_Required,
	          loading: false
	        });
	        return;
	      }
	      if (_this.state.email === '') {
	        _this.setState({
	          displaytext: 'show_block',
	          emailErrorMessage: '' + _language2.default.LC().Email_is_Required,
	          loading: false
	        });
	        return;
	      }
	      var emailValid = _this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	      if (emailValid) {
	        if (_this.state.password === '') {
	          _this.setState({
	            displaytext: 'show_block',
	            passwordErrorMessage: '' + _language2.default.LC().Password_is_Required,
	            loading: false
	          });
	          return;
	        }
	        if (_this.state.repeatpassword === '') {
	          _this.setState({
	            displaytext: 'show_block',
	            repPasswordErrorMessage: '' + _language2.default.LC().Confirm_Password_is_Required,
	            loading: false
	          });
	          return;
	        }
	        if (_this.state.password !== _this.state.repeatpassword) {
	          _this.setState({
	            displaytext: 'show_block',
	            repPasswordErrorMessage: '' + _language2.default.LC().Password_didnt_match,
	            loading: false
	          });
	          return;
	        }
	        if (_this.state.password.length < 6) {
	          _this.setState({
	            displaytext: 'show_block',
	            passwordErrorMessage: '' + _language2.default.LC().Please_enter_atleast_6_characters_in_the_field,
	            loading: false
	          });
	          return;
	        }
	
	        if (_this.state.code === '') {
	          _this.setState({
	            displaytext: 'show_block',
	            codeErrorMessage: '' + _language2.default.LC().Code_is_Required,
	            loading: false
	          });
	          return;
	        }
	
	        var data = {
	          email: _this.state.email,
	          password: _this.state.password,
	          code: _this.state.code,
	          landingSource: _this.state.landingSource,
	          landingSourceName: _this.state.landingSourceName,
	          name: _this.state.username,
	          userIP: _this.state.userIP
	
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/appSumo/signup', data).then(function (resp) {
	          if (resp.success) {
	            localStorage.setItem('loginID', resp.loginID);
	            var localStorage_array = {
	              token: resp.token,
	              idname: _this.state.email
	            };
	            localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	            localStorage.setItem('selectedmenu', 'cfa');
	            _reactRouter.browserHistory.push({
	              pathname: _AppRoutes2.default.DASHBOARD,
	              state: { token: resp.token, idname: _this.state.email }
	            });
	          } else {
	            _this.setState({
	              displaytext: 'show_block',
	              message: resp.message,
	              loading: false
	            });
	          }
	        });
	      } else {
	        _this.setState({
	          displaytext: 'show_block',
	          loading: false,
	          emailErrorMessage: '' + _language2.default.LC().Email_Id_Invalid
	        });
	        return;
	      }
	    };
	
	    _this.onSubmitOldUser = function (event) {
	      event.preventDefault();
	      var userData = JSON.parse(localStorage.getItem('userData'));
	      console.log('***');
	      _this.setState({
	        displaytext: 'hide_block',
	        message: '',
	        loading: true
	      });
	      if (_this.state.email === '') {
	        _this.setState({
	          displaytext: 'show_block',
	          emailErrorMessage: '' + _language2.default.LC().Email_is_Required,
	          loading: false
	        });
	        return;
	      }
	      var emailValid = _this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	      if (emailValid) {
	        if (_this.state.password === '') {
	          _this.setState({
	            displaytext: 'show_block',
	            passwordErrorMessage: '' + _language2.default.LC().Password_is_Required,
	            loading: false
	          });
	          return;
	        }
	        _this.setState({
	          displaytext: 'hide_block',
	          message: '',
	          emailErrorMessage: '',
	          passwordErrorMessage: '',
	          loading: false
	        });
	
	        if (_this.state.code === '') {
	          _this.setState({
	            displaytext: 'show_block',
	            codeErrorMessage: '' + _language2.default.LC().Code_is_Required,
	            loading: false
	          });
	          return;
	        }
	
	        var data = {
	          email: _this.state.email,
	          password: _this.state.password,
	          code: _this.state.code,
	          userIP: _this.state.userIP
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/appSumo/login', data).then(function (resp) {
	          if (resp.success) {
	            localStorage.setItem('loginID', resp.loginID);
	            var localStorage_array = {
	              token: resp.token,
	              idname: _this.state.email
	            };
	            localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	            localStorage.setItem('selectedmenu', 'cfa');
	            _reactRouter.browserHistory.push({
	              pathname: _AppRoutes2.default.DASHBOARD,
	              state: { token: resp.token, idname: _this.state.email }
	            });
	          } else {
	            _this.setState({
	              displaytext: 'show_block',
	              message: resp.message,
	              password: '',
	              loading: false
	            });
	          }
	        });
	      } else {
	        _this.setState({
	          displaytext: 'show_block',
	          emailErrorMessage: '' + _language2.default.LC().Email_Id_Invalid,
	          loading: false
	        });
	        return;
	      }
	    };
	
	    _this.updateEmail = function (e) {
	      console.log('');
	      var email_lower = e.target.value.toLowerCase();
	      _this.setState({
	        message: '',
	        email: email_lower,
	        emailErrorMessage: ''
	      });
	    };
	
	    _this.updatePassword = function (e) {
	      _this.setState({
	        message: '',
	        password: e.target.value,
	        passwordErrorMessage: ''
	      });
	    };
	
	    _this.updateRepeatPassword = function (e) {
	      _this.setState({
	        message: '',
	        repeatpassword: e.target.value,
	        repPasswordErrorMessage: ''
	      });
	    };
	
	    _this.updateCode = function (e) {
	      _this.setState({ message: '', code: e.target.value, codeErrorMessage: '' });
	    };
	
	    _this.updateUserName = function (e) {
	      _this.setState({
	        message: '',
	        username: e.target.value,
	        userNameErrorMessage: ''
	      });
	    };
	
	    _this.handleChange = function (e) {
	      console.log(':dfdddd');
	      _this.setState({
	        userType: !_this.state.userType,
	        displaytext: 'hide_block',
	        message: ''
	      });
	    };
	
	    _this.state = {
	      message_background: 'bg-danger',
	      displaytext: 'hide_block',
	      username: '',
	      email: '',
	      password: '',
	      repeatpassword: '',
	      message: '',
	      userNameErrorMessage: '',
	      emailErrorMessage: '',
	      passwordErrorMessage: '',
	      repPasswordErrorMessage: '',
	      code: '',
	      codeErrorMessage: '',
	      landingSource: 'AppSumo',
	      landingSourceName: null,
	      loading: false,
	      userType: true,
	      userIP: '',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(AppSumo, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var result1, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _getData2.default.GetCallAPI('https://geolocation-db.com/json/').then(function (resp) {
	                  _this2.setState({
	                    userIP: resp.IPv4
	                  });
	                });
	                // api to get ip address
	                _context.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result1 = _context.sent;
	
	                if (result1) {
	                  this.setState({
	                    user_city: result1.city,
	                    user_country: result1.country,
	                    user_ip: result1.query,
	                    user_state: result1.region,
	                    user_continent: result1.continent
	                  });
	                }
	                //user tracking code
	
	                // const result = getDeviceDetails();
	                data = {
	                  city: this.state.user_city,
	                  country: this.state.user_country,
	                  state: this.state.user_state,
	                  continent: this.state.user_continent,
	                  ip: this.state.user_ip
	                };
	
	                localStorage.setItem('userData', JSON.stringify(data));
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    ----------------------
	      Login form submit 
	    ----------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      console.log('ddddd', this.state.userType);
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center margin_bottom_20 logo_wrapper appSumo_Logo' },
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/logo1.png',
	            alt: '',
	            width: '121px',
	            className: 'mr-1'
	          }),
	          ' ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'X'
	          ),
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/as-appsumo-logo-footer.svg',
	            alt: '',
	            width: '121px',
	            className: 'ml-1'
	          }),
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-group mb-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card p-2  ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  this.state.userType ? _react2.default.createElement(
	                    'p',
	                    { className: 'text-muted' },
	                    'Fill this information:'
	                  ) : null,
	                  this.state.userType ? _react2.default.createElement(
	                    'form',
	                    {
	                      className: 'sign-up-form-wrap',
	                      onSubmit: this.onSubmitNewUser
	                    },
	                    ' ',
	                    _react2.default.createElement(
	                      'p',
	                      { className: this.state.displaytext + ' text-danger' },
	                      this.state.message
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/profile/user_ico.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().USERNAME,
	                          value: this.state.username,
	                          onChange: this.updateUserName
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.userNameErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/profile/mail_ico.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'email',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().EMAIL,
	                          value: this.state.email,
	                          onChange: this.updateEmail
	                        })
	                      ),
	                      ' ',
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.emailErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/pin-code.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'password',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().PASSWORD,
	                          value: this.state.password,
	                          onChange: this.updatePassword
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.passwordErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/pin-code.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'password',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().CONFIRM_PASSWORD,
	                          value: this.state.repeatpassword,
	                          onChange: this.updateRepeatPassword
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.repPasswordErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/safari-pinned-tab.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().APPSUMO_CODE,
	                          maxLength: '7',
	                          value: this.state.code,
	                          onChange: this.updateCode
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.codeErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'submit',
	                            style: { width: 100 + '%' },
	                            className: 'btn btn-primary'
	                          },
	                          this.state.loading ? 'Please wait...' : _language2.default.LC().SIGN_UP
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: 'AppSumoFooter',
	                            onClick: function onClick() {
	                              return _this3.handleChange();
	                            }
	                          },
	                          ' ',
	                          _language2.default.LC().EXISTING_USER_APP_SUMO
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'form',
	                    {
	                      className: 'sign-up-form-wrap',
	                      onSubmit: this.onSubmitOldUser
	                    },
	                    ' ',
	                    _react2.default.createElement(
	                      'p',
	                      { className: this.state.displaytext + ' text-danger' },
	                      this.state.message
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/profile/mail_ico.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'email',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().EMAIL,
	                          value: this.state.email,
	                          onChange: this.updateEmail
	                        })
	                      ),
	                      ' ',
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.emailErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/pin-code.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'password',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().PASSWORD,
	                          value: this.state.password,
	                          onChange: this.updatePassword
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.passwordErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'input-group-addon-social-registration' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/safari-pinned-tab.svg',
	                            className: '',
	                            alt: '',
	                            width: '15'
	                          })
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          className: 'form-control',
	                          placeholder: _language2.default.LC().APPSUMO_CODE,
	                          maxLength: '7',
	                          value: this.state.code,
	                          onChange: this.updateCode
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + ' text-danger' },
	                        this.state.codeErrorMessage
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'submit',
	                            style: { width: 100 + '%' },
	                            className: 'btn btn-primary'
	                          },
	                          this.state.loading ? 'Please wait...' : _language2.default.LC().SIGN_IN
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: 'AppSumoFooter',
	                            onClick: function onClick() {
	                              return _this3.handleChange();
	                            }
	                          },
	                          ' ',
	                          _language2.default.LC().NEW_USER_APP_SUMO
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppSumo;
	}(_react.Component);
	
	exports.default = AppSumo;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _classnames = __webpack_require__(106);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SignIn = __webpack_require__(845);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _SignUp = __webpack_require__(846);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	var _ForgotModal = __webpack_require__(273);
	
	var _ForgotModal2 = _interopRequireDefault(_ForgotModal);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	var _reactCookies = __webpack_require__(123);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _examRedirectRoute = __webpack_require__(103);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../RestAPI/getData';
	
	// import { getDeviceDetails } from '../../../common/deviceDetails';
	
	
	// import { showFailure } from '../../../common/toast';
	// import Header from '../../../components/Header/Header';
	// const queryString = require("query-string");
	
	/* eslint-disable*/
	
	var Auth = function (_Component) {
	  _inherits(Auth, _Component);
	
	  function Auth(props) {
	    _classCallCheck(this, Auth);
	
	    window.scroll(0, 0);
	    // console.log("window.location.protocol ", window.location.protocol);
	    // console.log("window.location.hostname ", window.location.hostname);
	
	    var _this = _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).call(this, props));
	
	    _this.handleForgot = function () {
	      _this.setState({ forgotOpenStatus: !_this.state.forgotOpenStatus });
	    };
	
	    _this.toggleHandleForgot = function (status) {
	      _this.setState({ forgotOpenStatus: !status });
	    };
	
	    _this.goToForum = function (e) {
	      // console.log("goToForum");
	      _reactRouter.browserHistory.push({
	        pathname: '/forum'
	      });
	    };
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.state = {
	      activeTab: '1',
	      forgotOpenStatus: false,
	      qq_user_code: '',
	      qq_user_nickname: '',
	      qq_user_image_url: '',
	      startLoaderPage: false,
	      urlToRedirect: _this.props.location.state ? _this.props.location.state.urlToRedirect : null,
	      userType: 'user',
	      pageNotFound: false,
	      landingSource: 'organic',
	      landingSourceName: null,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(Auth, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var result1, parsed, landingSourceCookie, landingSource, tapfiliateRef, hostDomain, parsedData, configDomain, proxyOrganizationDomain, resp, subDomain, data, _resp, userData, proxyToken, proxyResponse, token, idname, localStorageArray, selectedExam, _props$location$state, pageToOpen, urlToRedirect, forgotOpenStatus;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 4:
	                result1 = _context.sent;
	
	                if (result1) {
	                  this.setState({
	                    user_city: result1.city || '',
	                    user_country: result1.country || '',
	                    user_ip: result1.query || '',
	                    user_state: result1.region || '',
	                    user_continent: result1.continent || ''
	                  });
	                }
	                _context.next = 11;
	                break;
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context['catch'](1);
	
	                console.error('Error fetching IP address:', _context.t0);
	
	              case 11:
	                parsed = this.props.location.query || {};
	                landingSourceCookie = _reactCookies2.default.load('utm_source', {
	                  path: '/',
	                  domain: '.analystprep.com'
	                });
	                landingSource = landingSourceCookie || 'organic';
	
	                localStorage.setItem('landingSource', landingSource);
	
	                this.setState({ landingSource: landingSource });
	
	                tapfiliateRef = _reactCookies2.default.load('ref', {
	                  path: '/',
	                  domain: '.analystprep.com'
	                });
	
	
	                if (tapfiliateRef) {
	                  this.setState({
	                    landingSource: 'tapfiliate',
	                    landingSourceName: tapfiliateRef
	                  });
	                  localStorage.setItem('landingSource', 'tapfiliate');
	                }
	
	                localStorage.setItem('landingSourceName', tapfiliateRef || '');
	
	                hostDomain = window.location.hostname;
	                parsedData = hostDomain.split('.') || [];
	                configDomain = _App_data2.default.frontend_url != null && _App_data2.default.frontend_url !== '' ? new URL(_App_data2.default.frontend_url) : { host: 'app.analystprep.com' };
	
	                // Partner identity may arrive explicitly via a proxy-login query param
	                // (used where the hostname cannot carry the partner subdomain, e.g. branch/dev
	                // environments). Prefer it; otherwise fall back to hostname-based detection (live).
	
	                proxyOrganizationDomain = parsed.organizationDomain;
	
	                if (!proxyOrganizationDomain) {
	                  _context.next = 36;
	                  break;
	                }
	
	                _context.prev = 24;
	                _context.next = 27;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/auth/getDetailsByDomain', {
	                  partnerDomain: proxyOrganizationDomain
	                });
	
	              case 27:
	                resp = _context.sent;
	
	                if (resp.success && resp.data) {
	                  localStorage.setItem('role', 'partner');
	                  localStorage.setItem('organizationDomain', resp.data.organizationDomain);
	                } else {
	                  localStorage.removeItem('role');
	                  localStorage.removeItem('organizationDomain');
	                }
	                _context.next = 34;
	                break;
	
	              case 31:
	                _context.prev = 31;
	                _context.t1 = _context['catch'](24);
	
	                console.error('Error fetching domain details:', _context.t1);
	
	              case 34:
	                _context.next = 53;
	                break;
	
	              case 36:
	                if (!(parsedData.length && hostDomain !== configDomain.host && parsedData[1] === 'analystprep')) {
	                  _context.next = 51;
	                  break;
	                }
	
	                _context.prev = 37;
	                subDomain = parsedData[0];
	                data = { partnerDomain: subDomain };
	                _context.next = 42;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/auth/getDetailsByDomain', data);
	
	              case 42:
	                _resp = _context.sent;
	
	                if (_resp.success && _resp.data) {
	                  localStorage.setItem('role', 'partner');
	                  localStorage.setItem('organizationDomain', _resp.data.organizationDomain);
	                } else {
	                  this.setState({ pageNotFound: true });
	                  localStorage.removeItem('role');
	                  localStorage.removeItem('organizationDomain');
	                }
	                _context.next = 49;
	                break;
	
	              case 46:
	                _context.prev = 46;
	                _context.t2 = _context['catch'](37);
	
	                console.error('Error fetching domain details:', _context.t2);
	
	              case 49:
	                _context.next = 53;
	                break;
	
	              case 51:
	                // Not a partner context (main app domain, or a single-origin dev/localhost host).
	                // Clear any stale partner flags so a previous partner login (e.g. proxy login on the
	                // same origin) can't leak organizationDomain/role into a subsequent regular
	                // social/password login and trigger the "wrong domain" rejection.
	                localStorage.removeItem('role');
	                localStorage.removeItem('organizationDomain');
	
	              case 53:
	                userData = {
	                  city: this.state.user_city,
	                  country: this.state.user_country,
	                  state: this.state.user_state,
	                  continent: this.state.user_continent,
	                  ip: this.state.user_ip
	                };
	
	                localStorage.setItem('userData', JSON.stringify(userData));
	
	                proxyToken = parsed.proxyToken;
	
	                if (!proxyToken) {
	                  _context.next = 88;
	                  break;
	                }
	
	                proxyResponse = null;
	                _context.prev = 58;
	                _context.next = 61;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/proxyLogin', { proxyToken: proxyToken });
	
	              case 61:
	                proxyResponse = _context.sent;
	                token = proxyResponse.token || proxyResponse.data && proxyResponse.data.token;
	                idname = proxyResponse.idname || proxyResponse.data && proxyResponse.data.idname;
	
	                if (!(!token || !idname)) {
	                  _context.next = 66;
	                  break;
	                }
	
	                throw new Error('Something went wrong. Please try again later.');
	
	              case 66:
	
	                _userStore2.default.clear();
	
	                _userStore2.default.setToken(token);
	
	                _context.prev = 68;
	                _context.next = 71;
	                return _userStore2.default.fetchProfile(idname);
	
	              case 71:
	                _context.next = 76;
	                break;
	
	              case 73:
	                _context.prev = 73;
	                _context.t3 = _context['catch'](68);
	
	                console.warn('Error preloading profile after proxyLogin', _context.t3);
	
	              case 76:
	
	                localStorage.removeItem('localstorageval');
	                localStorageArray = { token: token, idname: idname };
	
	                localStorage.setItem('localstorageval', JSON.stringify(localStorageArray));
	
	                selectedExam = parsed.exam;
	
	
	                if (!selectedExam) {
	                  window.location.href = '/selectexam';
	                  // browserHistory.push({ // does not update user in header
	                  //   pathname: '/selectexam',
	                  //   state: { token, idname },
	                  // });
	                } else if (_examRedirectRoute.examRedirectRoute[selectedExam]) {
	                  localStorage.setItem('selectedmenu', selectedExam);
	                  window.location.href = _examRedirectRoute.examRedirectRoute[selectedExam];
	                  // browserHistory.push({ // does not update user in header
	                  //   pathname: examRedirectRoute[selectedExam],
	                  //   state: { token, idname },
	                  // });
	                }
	
	                _context.next = 88;
	                break;
	
	              case 83:
	                _context.prev = 83;
	                _context.t4 = _context['catch'](58);
	
	                console.error(_context.t4);
	                alert(proxyResponse.message || _context.t4.message || 'Something went wrong. Please try again later.');
	                localStorage.removeItem('localstorageval');
	
	              case 88:
	
	                if (this.props.location.state) {
	                  _props$location$state = this.props.location.state, pageToOpen = _props$location$state.pageToOpen, urlToRedirect = _props$location$state.urlToRedirect, forgotOpenStatus = _props$location$state.forgotOpenStatus;
	
	
	                  this.setState({
	                    activeTab: pageToOpen === '2' ? '2' : '1',
	                    urlToRedirect: urlToRedirect,
	                    forgotOpenStatus: forgotOpenStatus
	                  });
	                }
	                _context.next = 94;
	                break;
	
	              case 91:
	                _context.prev = 91;
	                _context.t5 = _context['catch'](0);
	
	                console.error('Unexpected error in Auth.js componentDidMount:', _context.t5);
	
	              case 94:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 91], [1, 8], [24, 31], [37, 46], [58, 83], [68, 73]]);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'toggle',
	    value: function toggle(tab) {
	      if (this.state.activeTab !== tab) {
	        this.setState({
	          activeTab: tab,
	          forgotOpenStatus: false
	        });
	      }
	    }
	
	    // socialQQLogin = (e) => {
	    //   this.signinRef.socialLoginQQ(e)
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // console.log("************", this.state.landingSource);
	      var _state = this.state,
	          qq_user_code = _state.qq_user_code,
	          qq_user_nickname = _state.qq_user_nickname,
	          qq_user_image_url = _state.qq_user_image_url,
	          pageNotFound = _state.pageNotFound;
	      // console.log('this.props.params', this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'login-full-wraper' },
	        this.state.startLoaderPage ? _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        ) : null,
	        pageNotFound ? _react2.default.createElement(
	          'div',
	          { className: 'd-flex login-img-main-block align-items-center' },
	          _react2.default.createElement(
	            'section',
	            { className: 'error-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-notfound' },
	                  '404!'
	                ),
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'score-text' },
	                  'Sorry, The Page not found'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\u2019re sorry, the domain you have looked for does not registered with our AnalystPrep organisation!'
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'login-main-wraper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex login-img-main-block align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'login-main-block' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'login-heading' },
	                _language2.default.LC().WELCOME_TO_ANALYSTPREP
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'justify-content-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'login-block' },
	                  _react2.default.createElement(
	                    _reactstrap.Nav,
	                    { tabs: true },
	                    _react2.default.createElement(
	                      _reactstrap.NavItem,
	                      null,
	                      _react2.default.createElement(
	                        _reactstrap.NavLink,
	                        {
	                          className: '' + (this.state.activeTab === '1' ? 'active' : ''),
	                          onClick: function onClick() {
	                            _this2.toggle('1');
	                          }
	                        },
	                        _language2.default.LC().SIGN_IN
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.NavItem,
	                      null,
	                      _react2.default.createElement(
	                        _reactstrap.NavLink,
	                        {
	                          className: (0, _classnames2.default)({
	                            active: this.state.activeTab === '2'
	                          }),
	                          onClick: function onClick() {
	                            _this2.toggle('2');
	                          }
	                        },
	                        _language2.default.LC().SIGN_UP
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.TabContent,
	                    { activeTab: this.state.activeTab },
	                    _react2.default.createElement(
	                      _reactstrap.TabPane,
	                      { tabId: '1' },
	                      _react2.default.createElement(_SignIn2.default, Object.assign({
	                        qq_user_code: qq_user_code,
	                        qq_user_nickname: qq_user_nickname,
	                        qq_user_image_url: qq_user_image_url,
	                        urlToRedirect: this.state.urlToRedirect
	                      }, this.props))
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.TabPane,
	                      { tabId: '2' },
	                      _react2.default.createElement(_SignUp2.default, {
	                        urlToRedirect: this.state.urlToRedirect,
	                        landingSource: this.state.landingSource,
	                        landingSourceName: this.state.landingSourceName
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_ForgotModal2.default, {
	                forgotOpen: this.state.forgotOpenStatus,
	                onToggle: this.toggleHandleForgot
	              }),
	              ' ',
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'footer-blockquote-login' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().FOOTER_MESSAGE
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ml-1' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://analystprep.com/privacy/',
	                      target: '_blank',
	                      className: 'privacy-policy'
	                    },
	                    _language2.default.LC().Privacy_Policy
	                  )
	                )
	              ),
	              ' '
	            ),
	            _react2.default.createElement('div', { className: 'login-image' })
	          ),
	          ' '
	        )
	      );
	    }
	  }]);
	
	  return Auth;
	}(_react.Component);
	
	exports.default = Auth;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	__webpack_require__(149);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPassword = function (_Component) {
	  _inherits(ResetPassword, _Component);
	
	  function ResetPassword(props) {
	    _classCallCheck(this, ResetPassword);
	
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props));
	
	    _this.state = {
	      email: _this.props.params.mailid,
	      tokenid: _this.props.params.tokenid,
	      password: '',
	      con_password: '',
	      passwordError: '',
	      con_passwordError: '',
	      message: '',
	      resetbox: 'block',
	      successbox: 'card hide_block',
	      displaytext: 'hide_block'
	    };
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'updatePassword',
	    value: function updatePassword(e) {
	      this.setState({
	        password: e.target.value,
	        passwordError: ''
	      });
	    }
	  }, {
	    key: 'conPassword',
	    value: function conPassword(e) {
	      this.setState({
	        con_password: e.target.value,
	        con_passwordError: ''
	      });
	    }
	  }, {
	    key: 'loginPage',
	    value: function loginPage() {
	      _reactRouter.browserHistory.push('/');
	    }
	  }, {
	    key: 'forgetPassword',
	    value: function forgetPassword() {
	      _reactRouter.browserHistory.push({
	        pathname: '/',
	        state: { forgotOpenStatus: true }
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      if (this.state.password === "") {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ passwordError: '' + _language2.default.LC().Password_is_Required });
	        return;
	      }
	      if (this.state.password.length < 6) {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ passwordError: '' + _language2.default.LC().Password_at_least_6_characters_long });
	        return;
	      }
	      if (this.state.con_password === "") {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ con_passwordError: '' + _language2.default.LC().Confirm_Password_is_Required });
	        return;
	      }
	      if (this.state.password !== this.state.con_password) {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ con_passwordError: '' + _language2.default.LC().Password_didnt_match });
	        return;
	      } else {
	        var data = { idname: this.state.email, password: this.state.password, passwordtoken: this.state.tokenid };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/resetPassword', data).then(function (resp) {
	          if (resp.success) {
	            _this2.setState({ displaytext: 'hide_block' });
	            _this2.setState({ resetbox: 'card hide_block' });
	            _this2.setState({ successbox: 'card-block' });
	          } else {
	            _this2.setState({ displaytext: 'show_block', message: '' + _language2.default.LC().Session_has_been_Expired });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.params.tokenid && this.props.params.mailid) {
	        // console.log('Parameter Exist');
	      } else {
	        _reactRouter.browserHistory.push({
	          pathname: '/',
	          state: { forgotOpenStatus: true }
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'reset-full-wraper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-main-wraper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex login-img-main-block align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: "login-main-block " + this.state.resetbox },
	              _react2.default.createElement(
	                'h1',
	                { className: 'reset-heading' },
	                _language2.default.LC().RESET_PASSWORD
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: "justify-content-center" },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'login-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'reset-input-tile' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: this.resetPassword.bind(this) },
	                      _react2.default.createElement(
	                        'p',
	                        { className: this.state.displaytext + " text-danger" },
	                        this.state.message
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement('input', { type: 'password', className: 'form-control', placeholder: 'Password', value: this.state.password, onChange: this.updatePassword.bind(this) }),
	                        _react2.default.createElement(
	                          'p',
	                          { className: this.state.displaytext + " text-danger" },
	                          this.state.passwordError
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement('input', { type: 'password', className: 'form-control', placeholder: 'Confirm Password', value: this.state.con_password, onChange: this.conPassword.bind(this) }),
	                        _react2.default.createElement(
	                          'p',
	                          { className: this.state.displaytext + " text-danger" },
	                          this.state.con_passwordError
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary reset-button btn-block pointer_class' },
	                        _language2.default.LC().RESET_PASSWORD
	                      ),
	                      _react2.default.createElement('div', { className: 'divider' }),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary resendEmail-button btn-block pointer_class', onClick: this.forgetPassword.bind(this) },
	                        _language2.default.LC().RESEND_MAIL
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: "success-main-block " + this.state.successbox },
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + "/img/check.png", alt: '', className: 'success-img' })
	              ),
	              _react2.default.createElement(
	                'h1',
	                { className: 'success-heading' },
	                _language2.default.LC().PASSWORD_RESET_SUCCESSFULLY
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary login-button btn-block pointer_class', onClick: this.loginPage.bind(this) },
	                _language2.default.LC().LOGIN
	              )
	            ),
	            _react2.default.createElement('div', { className: 'login-image' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react.Component);
	
	exports.default = ResetPassword;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _WebSocketService = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionWatcher = function (_React$Component) {
	    _inherits(SessionWatcher, _React$Component);
	
	    function SessionWatcher() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SessionWatcher);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SessionWatcher.__proto__ || Object.getPrototypeOf(SessionWatcher)).call.apply(_ref, [this].concat(args))), _this), _this.intervalId = null, _this.connectWSs = function () {
	            var ls = _this.getStoredSession();
	            if (ls && ls.token) {
	                (0, _WebSocketService.connectSocket)(ls.token);
	            }
	        }, _this.redirectToLogin = function () {
	            try {
	                _userStore2.default.clear();
	            } catch (e) {}
	
	            try {
	                localStorage.removeItem("localstorageval");
	            } catch (e) {}
	
	            try {
	                _reactRouter.hashHistory.push("/");
	            } catch (e) {
	                window.location.href = "/";
	            }
	        }, _this.getStoredSession = function () {
	            try {
	                var raw = localStorage.getItem("localstorageval");
	                return raw ? JSON.parse(raw) : null;
	            } catch (e) {
	                return null;
	            }
	        }, _this.setStoredToken = function (newToken) {
	            try {
	                var s = _this.getStoredSession() || {};
	                localStorage.setItem("localstorageval", JSON.stringify(Object.assign({}, s, { token: newToken })));
	            } catch (e) {}
	        }, _this.isTransientError = function (e) {
	            if (!e) return false;
	            var message = String(e.message || e).toLowerCase();
	            return e.name === 'TypeError' || // `fetch` throws TypeError on network failure
	            message.includes('failed to fetch') || message.includes('networkerror') || message.includes('network request failed') || message.includes('load failed');
	        }, _this.refreshNow = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var s, storedToken, resp, _ref3, success, token;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            s = _this.getStoredSession();
	                            storedToken = s && s.token ? s.token : null;
	
	                            if (!(!storedToken && !_userStore2.default.token)) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt("return");
	
	                        case 4:
	
	                            if (!_userStore2.default.token && storedToken) {
	                                _userStore2.default.setToken(storedToken);
	                            }
	
	                            _context.prev = 5;
	                            _context.next = 8;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + "/user/refreshToken", {});
	
	                        case 8:
	                            resp = _context.sent;
	                            _ref3 = resp || {}, success = _ref3.success, token = _ref3.token;
	
	                            if (!(success && token)) {
	                                _context.next = 14;
	                                break;
	                            }
	
	                            _userStore2.default.setToken(token);
	                            _this.setStoredToken(token);
	                            return _context.abrupt("return");
	
	                        case 14:
	
	                            // Explicit failure from server (e.g. invalid/expired token) → logout.
	                            // Keep user signed in if the server did not return a clear failure.
	                            if (resp && resp.success === false) {
	                                _this.redirectToLogin();
	                            }
	                            _context.next = 23;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t0 = _context["catch"](5);
	
	                            if (!_this.isTransientError(_context.t0)) {
	                                _context.next = 22;
	                                break;
	                            }
	
	                            console.warn('SessionWatcher: transient error during token refresh — keeping session', _context.t0.message);
	                            return _context.abrupt("return");
	
	                        case 22:
	                            _this.redirectToLogin();
	
	                        case 23:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[5, 17]]);
	        })), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SessionWatcher, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            this.refreshNow();
	
	            this.intervalId = setInterval(function () {
	                _this3.refreshNow();
	            }, 2 * 60 * 60 * 1000); // every 2 hours
	            this.connectWSs();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this.intervalId) clearInterval(this.intervalId);
	        }
	
	        /**
	         * Returns true if the error is a transient network/backend-outage error
	         * (e.g. nodemon restart, DNS blip, offline). Logging out for these would
	         * log the user out every time the dev server restarts — we should keep
	         * the session and let the user retry.
	         */
	
	    }, {
	        key: "render",
	        value: function render() {
	            return this.props.children;
	        }
	    }]);
	
	    return SessionWatcher;
	}(_react2.default.Component);
	
	exports.default = SessionWatcher;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleLogin = __webpack_require__(462);
	
	var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);
	
	var _reactRouter = __webpack_require__(29);
	
	var _universalCookie = __webpack_require__(496);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _examRedirectRoute = __webpack_require__(103);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	__webpack_require__(149);
	
	var _ForgotModal = __webpack_require__(273);
	
	var _ForgotModal2 = _interopRequireDefault(_ForgotModal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _GoogleBtn = __webpack_require__(262);
	
	var _GoogleBtn2 = _interopRequireDefault(_GoogleBtn);
	
	var _helper = __webpack_require__(260);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _WebSocketService = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { FacebookLogin } from 'react-facebook-login-component';
	
	
	var UserStore = __webpack_require__(16);
	
	/* eslint-disable*/
	
	var SignIn = function (_Component) {
	  _inherits(SignIn, _Component);
	
	  function SignIn(props) {
	    _classCallCheck(this, SignIn);
	
	    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this, props));
	
	    _this.handleForgot = function () {
	      _this.setState({
	        forgotOpenStatus: !_this.state.forgotOpenStatus,
	        message: '',
	        emailErrorMessage: '',
	        passwordErrormessage: ''
	      });
	    };
	
	    _this.toggleHandleForgot = function (status) {
	      _this.setState({ forgotOpenStatus: !status });
	    };
	
	    _this.togglepassword = function () {
	      if (_this.state.passwordtype === 'password') {
	        _this.setState({ passwordtype: 'text' });
	        return;
	      }
	      _this.setState({ passwordtype: 'password' });
	      console.log(_this.state.passwordtype);
	    };
	
	    _this.state = {
	      email: '',
	      password: '',
	      displaytext: 'hide_block',
	      message: '',
	      emailErrorMessage: '',
	      passwordErrormessage: '',
	      forgotOpenStatus: false,
	      urlToRedirect: '',
	      passwordtype: 'password'
	      // qq_user_code:this.props.qq_user_code,
	      // qq_user_nickname:this.props.qq_user_nickname,
	      // qq_user_image_url:this.props.qq_user_image_url
	    };
	    _this.loginToDashboard = _this.loginToDashboard.bind(_this);
	    _this.updateEmail = _this.updateEmail.bind(_this);
	    _this.updatePassword = _this.updatePassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignIn, [{
	    key: 'socialQQLogin',
	    value: function socialQQLogin(e) {
	      e.preventDefault();
	      var data = { idname: '1223' };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/socialLoginQQ', data).then(function (resp) {
	        if (resp.success) {
	          window.open(resp.result, '_self');
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      {
	        this.props.urlToRedirect !== null ? this.setState({ urlToRedirect: this.props.urlToRedirect }) : this.setState({ urlToRedirect: null });
	      }
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        var data = {
	          token: storage_session['token'],
	          idname: storage_session['idname']
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.success) {
	            if (resp.profileInfo.exam) {
	              localStorage.setItem('selectedmenu', resp.profileInfo.exam === 'cfa_2023' ? 'cfa_2024' : resp.profileInfo.exam);
	              _reactRouter.browserHistory.push({
	                pathname: resp.profileInfo.role === 'employee' && resp.profileInfo.exam === 'frm' ? _AppRoutes2.default.FRM_V2_DASHBOARD : _examRedirectRoute.examRedirectRoute[resp.profileInfo.exam],
	                state: {
	                  token: data.token,
	                  idname: data.idname
	                }
	              });
	            }
	          } else {
	            localStorage.clear();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({
	        message: '',
	        emailErrorMessage: '',
	        passwordErrormessage: ''
	      });
	    }
	  }, {
	    key: 'updateEmail',
	    value: function updateEmail(e) {
	      var email_lower = e.target.value.toLowerCase();
	      this.setState({
	        message: '',
	        emailErrorMessage: '',
	        email: email_lower
	      });
	    }
	  }, {
	    key: 'updatePassword',
	    value: function updatePassword(e) {
	      this.setState({
	        message: '',
	        passwordErrormessage: '',
	        password: e.target.value
	      });
	    }
	  }, {
	    key: 'loginToDashboard',
	    value: function loginToDashboard(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      this.setState({ isDisabled: true });
	
	      var _state = this.state,
	          email = _state.email,
	          password = _state.password,
	          urlToRedirect = _state.urlToRedirect;
	
	      var landingSource = localStorage.getItem('landingSource');
	      var landingSourceName = localStorage.getItem('landingSourceName');
	
	      if (!email) {
	        this.setState({
	          displaytext: 'show_block',
	          emailErrorMessage: _language2.default.LC().Email_is_Required,
	          isDisabled: false
	        });
	        return;
	      }
	
	      var emailValid = /\S+@\S+\.\S+/.test(email);
	      if (!emailValid) {
	        this.setState({
	          displaytext: 'show_block',
	          emailErrorMessage: _language2.default.LC().Email_Id_Invalid,
	          password: '',
	          isDisabled: false
	        });
	        return;
	      }
	
	      if (!password) {
	        this.setState({
	          displaytext: 'show_block',
	          passwordErrormessage: _language2.default.LC().Password_is_Required,
	          isDisabled: false
	        });
	        return;
	      }
	
	      this.setState({
	        displaytext: 'hide_block',
	        message: '',
	        emailErrorMessage: '',
	        passwordErrormessage: ''
	      });
	
	      var role = localStorage.getItem('role');
	      var organizationDomain = localStorage.getItem('organizationDomain');
	      var loginData = { idname: email, password: password, role: role, organizationDomain: organizationDomain };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/login', loginData).then(function (resp) {
	        if (!resp || !resp.success) {
	          _this2.setState({
	            displaytext: 'show_block',
	            message: resp.message || 'Login failed',
	            isDisabled: false
	          });
	          localStorage.clear();
	          return;
	        }
	        _userStore2.default.setToken(resp.token);
	        (0, _WebSocketService.connectSocket)(resp.token);
	
	        localStorage.setItem('loginID', resp.loginID);
	        localStorage.setItem('localstorageval', JSON.stringify({ token: resp.token, idname: email }));
	        localStorage.setItem('selectedmenu', 'cfa_2025');
	
	        if (!resp.exam_details) {
	          _reactRouter.browserHistory.push({
	            pathname: '/selectexam',
	            state: { token: resp.token, idname: email, landingSource: landingSource, landingSourceName: landingSourceName }
	          });
	          _this2.setState({ isDisabled: false });
	          return;
	        }
	
	        var processProfileInfo = function processProfileInfo(profileInfo) {
	          console.log("Profile Info sign in: ", profileInfo);
	          if (profileInfo != null) {
	            var examMapping = {
	              cfa: 'cfa_2024',
	              cfa_2022: 'cfa_2024',
	              cfa_2023: 'cfa_2024',
	              cfa_3: 'cfa_3_2025',
	              cfa_2_2022: 'cfa_2_2023'
	            };
	            var selectedExam = examMapping[profileInfo.exam] || profileInfo.exam;
	            localStorage.setItem('selectedmenu', selectedExam);
	            _reactRouter.browserHistory.push({
	              pathname: urlToRedirect || _examRedirectRoute.examRedirectRoute[selectedExam],
	              state: { token: resp.token, idname: email }
	            });
	          }
	        };
	
	        _userStore2.default.getUserProfile().then(processProfileInfo).finally(function () {
	          _this2.setState({ isDisabled: false });
	        });
	
	        // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', {
	        //   token: resp.token,
	        //   idname: email,
	        // })
	        //   .then((profileResponse) => {
	        //     if (profileResponse && profileResponse.success && profileResponse.profileInfo) {
	        //       userStore.setProfileInfo(profileResponse);
	        //       const examMapping = {
	        //         cfa: 'cfa_2024',
	        //         cfa_2022: 'cfa_2024',
	        //         cfa_2023: 'cfa_2024',
	        //         cfa_3: 'cfa_3_2025',
	        //         cfa_2_2022: 'cfa_2_2023',
	        //       };
	        //       const selectedExam =
	        //         examMapping[profileResponse.profileInfo.exam] || profileResponse.profileInfo.exam;
	        //       localStorage.setItem('selectedmenu', selectedExam);
	        //       browserHistory.push({
	        //         pathname: urlToRedirect || examRedirectRoute[selectedExam],
	        //         state: { token: resp.token, idname: email },
	        //       });
	        //     }
	        //     this.setState({ isDisabled: false });
	        //   })
	        //   .catch(() => this.setState({ isDisabled: false }));
	      }).catch(function (err) {
	        console.error('Login API failed:', err);
	        _this2.setState({ isDisabled: false, message: 'Something went wrong. Please try again.' });
	      });
	    }
	  }, {
	    key: 'responseGoogleGIS',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(response) {
	        var role, organizationDomain, landingSource, landingSourceName, idPayload, email, name, data, resp, cookies, localStorage_array, prof, ex, normalized, targetPath;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                role = localStorage.getItem('role');
	                organizationDomain = localStorage.getItem('organizationDomain');
	                landingSource = localStorage.getItem('landingSource');
	                landingSourceName = localStorage.getItem('landingSourceName');
	                idPayload = (0, _helper.parseIdToken)(response.credential || '');
	                email = idPayload.email || '';
	                name = idPayload.name || '';
	                data = {
	                  credential: response.credential,
	                  role: role,
	                  organizationDomain: organizationDomain
	                };
	                _context.prev = 8;
	                _context.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/v2/loginWithSocialMedia', data);
	
	              case 11:
	                resp = _context.sent;
	
	                if (resp.success) {
	                  _context.next = 15;
	                  break;
	                }
	
	                if (resp.partner && resp.message) {
	                  alert(resp.message);
	                } else {
	                  alert('Login failed. Please try again.');
	                }
	                return _context.abrupt('return');
	
	              case 15:
	
	                if (resp.loginID) {
	                  localStorage.setItem('loginID', resp.loginID);
	                }
	
	                _userStore2.default.setToken(resp.token);
	
	                (0, _WebSocketService.connectSocket)(resp.token);
	
	                cookies = new _universalCookie2.default();
	
	                cookies.set('token', resp.token, { path: '/', maxAge: 60 * 60 * 24 });
	                if (email) cookies.set('idname', email, { path: '/', maxAge: 60 * 60 * 24 });
	
	                localStorage_array = { token: resp.token, idname: email };
	
	                localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	
	                if (!(resp.user_data == null)) {
	                  _context.next = 27;
	                  break;
	                }
	
	                localStorage.setItem('signup', 1);
	                _reactRouter.browserHistory.push({
	                  pathname: '/selectexam',
	                  state: {
	                    token: resp.token,
	                    idname: email,
	                    name: name || email,
	                    landingSource: landingSource,
	                    landingSourceName: landingSourceName
	                  }
	                });
	                return _context.abrupt('return');
	
	              case 27:
	                _context.next = 29;
	                return _userStore2.default.getUserProfile();
	
	              case 29:
	                prof = _context.sent;
	
	                if (prof.exam) {
	                  _context.next = 35;
	                  break;
	                }
	
	                console.log('getProfileInfo failed or exam missing');
	                // fallback — select exam
	                localStorage.setItem('signup', 1);
	                _reactRouter.browserHistory.push({
	                  pathname: '/selectexam',
	                  state: {
	                    token: resp.token,
	                    idname: email,
	                    name: name || email,
	                    landingSource: landingSource,
	                    landingSourceName: landingSourceName
	                  }
	                });
	                return _context.abrupt('return');
	
	              case 35:
	                ex = prof.exam;
	                normalized = ex === 'cfa_2023' ? 'cfa_2024' : ex === 'cfa_2_2022' || ex === 'cfa_2' ? 'cfa_2_2023' : ex === 'cfa_3' ? 'cfa_3_2025' : ex;
	
	
	                localStorage.setItem('selectedmenu', normalized);
	
	                targetPath = prof.role === 'employee' && prof.exam === 'frm' ? _AppRoutes2.default.FRM_V2_DASHBOARD : _examRedirectRoute.examRedirectRoute[normalized];
	
	
	                _reactRouter.browserHistory.push({
	                  pathname: targetPath,
	                  state: { token: resp.token, idname: email }
	                });
	                _context.next = 46;
	                break;
	
	              case 42:
	                _context.prev = 42;
	                _context.t0 = _context['catch'](8);
	
	                console.error('GIS login error', _context.t0);
	                alert('Login failed. Please try again.');
	
	              case 46:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[8, 42]]);
	      }));
	
	      function responseGoogleGIS(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return responseGoogleGIS;
	    }()
	  }, {
	    key: 'responseGoogle',
	    value: function responseGoogle(response) {
	      var role = localStorage.getItem('role');
	      var organizationDomain = localStorage.getItem('organizationDomain');
	      var landingSource = localStorage.getItem('landingSource');
	      var landingSourceName = localStorage.getItem('landingSourceName');
	      var userData = JSON.parse(localStorage.getItem('userData'));
	
	      var data = {
	        name: response.profileObj.name,
	        email: response.profileObj.email,
	        token: response.accessToken,
	        imageUrl: response.profileObj.imageUrl,
	        organizationDomain: organizationDomain,
	        role: role
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/loginWithSocialMedia', data).then(function (resp) {
	        if (resp.success) {
	          localStorage.setItem('loginID', resp.loginID);
	          var localStorage_array = {
	            token: resp.token,
	            idname: response.profileObj.email
	          };
	          var cookies = new _universalCookie2.default();
	          cookies.set('token', resp.token, {
	            path: '/',
	            maxAge: 60 * 60 * 24
	          });
	          cookies.set('idname', response.profileObj.email, {
	            path: '/',
	            maxAge: 60 * 60 * 24
	          });
	          localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	          if (resp.user_data == null) {
	            localStorage.setItem('signup', 1);
	            _reactRouter.browserHistory.push({
	              pathname: '/selectexam',
	              state: {
	                token: resp.token,
	                idname: response.profileObj.email,
	                name: response.profileObj.name,
	                landingSource: landingSource,
	                landingSourceName: landingSourceName
	              }
	            });
	          } else {
	            var data = { token: resp.token, idname: response.profileObj.email };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	              if (resp.success) {
	                if (resp.profileInfo.exam) {
	                  localStorage.setItem('selectedmenu', resp.profileInfo.exam === 'cfa_2023' ? 'cfa_2024' : resp.profileInfo.exam === 'cfa_2_2022' || resp.profileInfo.exam === 'cfa_2' ? 'cfa_2_2023' : resp.profileInfo.exam === 'cfa_3' ? 'cfa_3_2025' : resp.profileInfo.exam);
	                  _reactRouter.browserHistory.push({
	                    pathname: resp.profileInfo.role === 'employee' && resp.profileInfo.exam === 'frm' ? _AppRoutes2.default.FRM_V2_DASHBOARD : _examRedirectRoute.examRedirectRoute[resp.profileInfo.exam],
	                    state: {
	                      token: resp.token,
	                      idname: response.profileObj.email
	                    }
	                  });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        } else if (!resp.success && resp.partner) {
	          alert(resp.message);
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'failedGoogle',
	    value: function failedGoogle(response) {
	      console.log('Failed googles login::', response);
	      if (response.details === 'Cookies are not enabled in current environment.') {
	        alert("We've detected a problem with your cookie settings in the browser. Make sure that your cookies are enabled.");
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$isDisabled = this.state.isDisabled,
	          isDisabled = _state$isDisabled === undefined ? false : _state$isDisabled;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'signin-block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'social-button-tile ' },
	          _react2.default.createElement(_GoogleBtn2.default, {
	            onSuccess: this.responseGoogleGIS,
	            onError: this.failedGoogle
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sign-in-input-tile' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.loginToDashboard },
	            _react2.default.createElement(
	              'p',
	              { className: this.state.displaytext + ' text-danger' },
	              this.state.message
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'form-control',
	                placeholder: _language2.default.LC().USERNAME_OR_EMAIL,
	                value: this.state.email,
	                onChange: this.updateEmail
	              }),
	              _react2.default.createElement(
	                'p',
	                { className: this.state.displaytext + ' text-danger' },
	                this.state.emailErrorMessage
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'passwordeye_wrapper' },
	                _react2.default.createElement('input', {
	                  type: this.state.passwordtype,
	                  className: 'form-control',
	                  placeholder: _language2.default.LC().PASSWORD,
	                  value: this.state.password,
	                  onChange: this.updatePassword
	                }),
	                this.state.passwordtype === 'password' ? _react2.default.createElement('img', {
	                  onClick: this.togglepassword,
	                  src: _App_data2.default.frontend_url + '/img/hide2.png',
	                  alt: ''
	                }) : _react2.default.createElement('img', {
	                  onClick: this.togglepassword,
	                  src: _App_data2.default.frontend_url + '/img/show 2.png',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: this.state.displaytext + ' text-danger' },
	                this.state.passwordErrormessage
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'forgot-password pointer_class', onClick: this.handleForgot },
	              ' ',
	              _language2.default.LC().FORGOT_PASSWORD
	            ),
	            _react2.default.createElement(_ForgotModal2.default, {
	              forgotOpen: this.state.forgotOpenStatus,
	              onToggle: this.toggleHandleForgot
	            }),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary sign-in-button btn-block',
	                disabled: isDisabled,
	                type: 'submit',
	                id: 'my-btn'
	              },
	              isDisabled && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	              ' ',
	              _language2.default.LC().SIGN_IN
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignIn;
	}(_react.Component);
	
	exports.default = SignIn;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactCookies = __webpack_require__(123);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _reactGoogleLogin = __webpack_require__(462);
	
	var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _signUpApproval = __webpack_require__(186);
	
	var _signUpApproval2 = _interopRequireDefault(_signUpApproval);
	
	__webpack_require__(149);
	
	var _universalCookie = __webpack_require__(496);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _examRedirectRoute = __webpack_require__(103);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _GoogleBtn = __webpack_require__(262);
	
	var _GoogleBtn2 = _interopRequireDefault(_GoogleBtn);
	
	var _helper = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../RestAPI/getData';
	
	//import { FacebookLogin } from 'react-facebook-login-component';
	
	// import { getDeviceDetails } from "../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SignUp = function (_Component) {
	  _inherits(SignUp, _Component);
	
	  function SignUp(props) {
	    _classCallCheck(this, SignUp);
	
	    var _this = _possibleConstructorReturn(this, (SignUp.__proto__ || Object.getPrototypeOf(SignUp)).call(this, props));
	
	    _this.togglepassword = function (val) {
	      if (_this.state.inputValue == val) _this.setState({ inputValue: undefined });else _this.setState({ inputValue: val });
	    };
	
	    _this.state = {
	      username: '',
	      email: '',
	      password: '',
	      repeatpassword: '',
	      message: '',
	      userNameErrorMessage: '',
	      emailErrorMessage: '',
	      passwordErrorMessage: '',
	      repPasswordErrorMessage: '',
	      locErrorMessage: '',
	      examErrorMessage: '',
	      urlToRedirect: '',
	      signupAlert: false,
	
	      landingSource: 'organic',
	      landingSourceName: null,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.updateUserName = _this.updateUserName.bind(_this);
	    _this.updateEmail = _this.updateEmail.bind(_this);
	    _this.updatePassword = _this.updatePassword.bind(_this);
	    _this.updateRepeatPassword = _this.updateRepeatPassword.bind(_this);
	    _this.Registration = _this.Registration.bind(_this);
	    _this.signUpAlertModel = _this.signUpAlertModel.bind(_this);
	    _this.signUpAlertModelClose = _this.signUpAlertModelClose.bind(_this);
	    _this.responseGoogle = _this.responseGoogle.bind(_this);
	    _this.failedGoogle = _this.failedGoogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignUp, [{
	    key: 'signUpAlertModel',
	    value: function signUpAlertModel() {
	      this.setState({
	        signupAlert: !this.state.signupAlert
	      });
	    }
	  }, {
	    key: 'signUpAlertModelClose',
	    value: function signUpAlertModelClose() {
	      this.setState({
	        signupAlert: false
	      });
	      _reactRouter.browserHistory.push('/');
	    }
	  }, {
	    key: 'socialQQLogin',
	    value: function socialQQLogin(e) {
	      e.preventDefault();
	      var data = { idname: '1223' };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/socialLoginQQ', data).then(function (resp) {
	        if (resp.success) {
	          window.open(resp.result, '_self');
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var result1, data1, landingSourceCokkie, checkTapfilliateRefernce, storage_session, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result1 = _context.sent;
	
	                if (result1) {
	                  this.setState({
	                    user_city: result1.city,
	                    user_country: result1.country,
	                    user_ip: result1.query,
	                    user_state: result1.region,
	                    user_continent: result1.continent
	                  });
	                  data1 = {
	                    city: result1.city,
	                    country: result1.country,
	                    state: result1.region,
	                    continent: result1.continent,
	                    ip: result1.query
	                  };
	
	                  localStorage.setItem('userData', JSON.stringify(data1));
	                }
	                // const result = getDeviceDetails();
	                // const data1 = {
	                //   city: this.state.user_city,
	                //   country: this.state.user_country,
	                //   state: this.state.user_state,
	                //   continent: this.state.user_continent,
	                //   ip: this.state.user_ip,
	                // };
	                // localStorage.setItem("userData", JSON.stringify(data1));
	                /*
	                --------------------------------
	                Pixel Integration code start
	                --------------------------------
	                */
	                landingSourceCokkie = _reactCookies2.default.load('utm_source', {
	                  path: '/',
	                  domain: '.analystprep.com'
	                });
	
	                if (landingSourceCokkie) {
	                  this.setState({
	                    landingSource: landingSourceCokkie
	                  });
	                }
	                localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
	                checkTapfilliateRefernce = _reactCookies2.default.load('ref', {
	                  path: '/',
	                  domain: '.analystprep.com'
	                });
	
	                if (checkTapfilliateRefernce) {
	                  this.setState({
	                    landingSource: 'tapfiliate',
	                    landingSourceName: checkTapfilliateRefernce
	                  });
	                  localStorage.setItem('landingSource', 'tapfiliate');
	                }
	
	                localStorage.setItem('landingSourceName', checkTapfilliateRefernce ? checkTapfilliateRefernce : null);
	                /*
	                -------------------------------
	                Pixel Integration code end
	                -------------------------------
	                */
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.props.urlToRedirect !== null ? this.setState({ urlToRedirect: this.props.urlToRedirect }) : this.setState({ urlToRedirect: null });
	
	
	                if (storage_session) {
	                  data = {
	                    token: storage_session['token'],
	                    idname: storage_session['idname']
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                    if (resp.success) {
	                      if (resp.profileInfo.exam) {
	                        localStorage.setItem('selectedmenu', resp.profileInfo.exam);
	                        _reactRouter.browserHistory.push({
	                          pathname: _examRedirectRoute.examRedirectRoute[resp.profileInfo.exam],
	                          state: {
	                            token: storage_session['token'],
	                            idname: storage_session['idname']
	                          }
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({
	        message: '',
	        userNameErrorMessage: '',
	        emailErrorMessage: '',
	        passwordErrorMessage: '',
	        repPasswordErrorMessage: '',
	        locErrorMessage: '',
	        examErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'Registration',
	    value: function Registration(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      if (this.state.username === '') {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({
	          userNameErrorMessage: '' + _language2.default.LC().User_Name_is_Required
	        });
	        return;
	      }
	      if (this.state.email === '') {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({
	          emailErrorMessage: '' + _language2.default.LC().Email_is_Required
	        });
	        return;
	      }
	      var emailValid = this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	      if (emailValid) {
	        if (this.state.password === '') {
	          this.setState({ displaytext: 'show_block' });
	          this.setState({
	            passwordErrorMessage: '' + _language2.default.LC().Password_is_Required
	          });
	          return;
	        }
	        if (this.state.repeatpassword === '') {
	          this.setState({ displaytext: 'show_block' });
	          this.setState({
	            repPasswordErrorMessage: '' + _language2.default.LC().Confirm_Password_is_Required
	          });
	          return;
	        }
	        if (this.state.password !== this.state.repeatpassword) {
	          this.setState({ displaytext: 'show_block' });
	          this.setState({
	            repPasswordErrorMessage: '' + _language2.default.LC().Password_didnt_match
	          });
	          return;
	        }
	        if (this.state.password.length < 6) {
	          this.setState({ displaytext: 'show_block' });
	          this.setState({
	            passwordErrorMessage: '' + _language2.default.LC().Please_enter_atleast_6_characters_in_the_field
	          });
	          return;
	        }
	        // if (document.getElementById("examlocate").value === "") {
	        //   this.setState({ displaytext: "show_block" });
	        //   this.setState({ locErrorMessage: "Exam Location is Required" });
	        //   return;
	        // }
	        if (document.getElementById('exam_field').value === '') {
	          this.setState({ displaytext: 'show_block' });
	          this.setState({
	            examErrorMessage: '' + _language2.default.LC().Exam_Field_is_Required
	          });
	          return;
	        }
	
	        var role = localStorage.getItem('role');
	        var organizationDomain = localStorage.getItem('organizationDomain');
	        var examValue = document.getElementById('exam_field').value;
	
	        var data = {
	          name: this.state.username,
	          email: this.state.email,
	          password: this.state.password,
	          exam: examValue,
	          role: role,
	          organizationDomain: organizationDomain,
	          landingSource: this.state.landingSource,
	          landingSourceName: this.state.landingSourceName
	        };
	        var userData = JSON.parse(localStorage.getItem('userData'));
	        var loginData = {
	          idname: this.state.email,
	          password: this.state.password,
	          role: role,
	          organizationDomain: organizationDomain
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/signup', data).then(function (resp) {
	          console.log('singnup reponseing {}==========>', resp);
	          if (resp.success) {
	            localStorage.setItem('loginID', resp.loginID);
	            localStorage.removeItem('previousPath');
	            // if (this.state.landingSource) {
	            /*
	            -------------------------
	            GTM signup event code
	            -------------------------
	            */
	            var tagManagerArgs = {
	              gtmId: _constant.GTM_ID,
	              dataLayer: {
	                event: _constant.GTMSignUp,
	                eventOptions: {
	                  selectedExam: document.getElementById('exam_field').value
	                },
	                userName: _this2.state.username,
	                userEmail: _this2.state.email,
	                userExam: document.getElementById('exam_field').value,
	                source: _this2.state.landingSource,
	                affiliateName: _this2.state.landingSourceName
	              }
	            };
	            _reactGtmModule2.default.initialize(tagManagerArgs);
	            // ************* Sign Up event for GA4 ****************** //
	            var tagManagerArgsGA4 = {
	              gtmId: _constant.GTM_ID,
	              dataLayer: {
	                event: _constant.GA4SignUp,
	                method: _this2.state.email
	              }
	            };
	            _reactGtmModule2.default.initialize(tagManagerArgsGA4);
	            // }
	            localStorage.setItem('signup', 1);
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/login', loginData).then(function (response) {
	              console.log('first login api', response);
	              if (response.success) {
	                localStorage.setItem('loginID', response.loginID);
	                var localStorage_array = {
	                  token: response.token,
	                  idname: _this2.state.email
	                };
	                localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	                localStorage.setItem('selectedmenu', examValue);
	                console.log(_this2.state.urlToRedirect);
	                var _examField = examValue;
	                if (_this2.state.urlToRedirect !== null && _this2.state.urlToRedirect !== undefined) {
	                  _reactRouter.browserHistory.push({
	                    pathname: _this2.state.urlToRedirect,
	                    state: {
	                      token: response.token,
	                      idname: _this2.state.email
	                    }
	                  });
	                } else if (_constant.examObject[_examField]) {
	                  _reactRouter.browserHistory.push({
	                    pathname: _constant.examObject[_examField].sidebarRoutes.dashboard || _AppRoutes2.default.CFA1_2024_DASHBOARD
	                  });
	                }
	              }
	              // else if (!response.success && response.partner) {
	              //   this.signUpAlertModel();
	              //   this.setState({
	              //     username: "",
	              //     email: "",
	              //     password: "",
	              //     repeatpassword: "",
	              //     message: "",
	              //     userNameErrorMessage: "",
	              //     emailErrorMessage: "",
	              //     passwordErrorMessage: "",
	              //     repPasswordErrorMessage: "",
	              //     locErrorMessage: "",
	              //     examErrorMessage: "",
	              //     urlToRedirect: "",
	              //   });
	              // }
	            });
	          } else {
	            _this2.setState({ displaytext: 'show_block' });
	            _this2.setState({ message: resp.message });
	          }
	        });
	      } else {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ emailErrorMessage: '' + _language2.default.LC().Email_Id_Invalid });
	        return;
	      }
	    }
	  }, {
	    key: 'updateUserName',
	    value: function updateUserName(e) {
	      this.setState({
	        username: e.target.value,
	        userNameErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'updateEmail',
	    value: function updateEmail(e) {
	      var email_lower = e.target.value.toLowerCase();
	      this.setState({
	        email: email_lower,
	        emailErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'updatePassword',
	    value: function updatePassword(e) {
	      this.setState({
	        password: e.target.value,
	        passwordErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'updateRepeatPassword',
	    value: function updateRepeatPassword(e) {
	      this.setState({
	        repeatpassword: e.target.value,
	        repPasswordErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'responseGoogleGIS',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(response) {
	        var role, organizationDomain, landingSource, landingSourceName, credential, idPayload, email, name, data, resp, cookies, prof, hasUrlRedirect, examField;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('============response============', response);
	                role = localStorage.getItem('role');
	                organizationDomain = localStorage.getItem('organizationDomain');
	                landingSource = localStorage.getItem('landingSource');
	                landingSourceName = localStorage.getItem('landingSourceName');
	                credential = response && response.credential ? response.credential : '';
	                idPayload = (0, _helper.parseIdToken)(credential);
	                email = idPayload && idPayload.email ? idPayload.email : '';
	                name = idPayload && idPayload.name ? idPayload.name : email;
	                data = {
	                  credential: credential,
	                  role: role,
	                  organizationDomain: organizationDomain
	                };
	                _context2.prev = 10;
	                _context2.next = 13;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/v2/loginWithSocialMedia', data);
	
	              case 13:
	                resp = _context2.sent;
	
	                if (!(!resp || !resp.success)) {
	                  _context2.next = 17;
	                  break;
	                }
	
	                if (resp && resp.partner && resp.message) {
	                  alert(resp.message);
	                } else {
	                  alert('Login failed. Please try again.');
	                }
	                return _context2.abrupt('return');
	
	              case 17:
	
	                if (resp.loginID) {
	                  localStorage.setItem('loginID', resp.loginID);
	                }
	
	                // cookies + localStorage
	                cookies = new _universalCookie2.default();
	
	                cookies.set('token', resp.token, { path: '/', maxAge: 60 * 60 * 24 });
	                if (email) {
	                  cookies.set('idname', email, { path: '/', maxAge: 60 * 60 * 24 });
	                }
	                localStorage.setItem('localstorageval', JSON.stringify({ token: resp.token, idname: email }));
	
	                if (!(resp.user_data == null)) {
	                  _context2.next = 26;
	                  break;
	                }
	
	                localStorage.setItem('signup', 1);
	                _reactRouter.browserHistory.push({
	                  pathname: '/selectexam',
	                  state: { token: resp.token, idname: email, name: name, landingSource: landingSource, landingSourceName: landingSourceName }
	                });
	                return _context2.abrupt('return');
	
	              case 26:
	                _context2.next = 28;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', { token: resp.token, idname: email });
	
	              case 28:
	                prof = _context2.sent;
	
	                if (!(!prof || !prof.success || !prof.profileInfo || !prof.profileInfo.exam)) {
	                  _context2.next = 33;
	                  break;
	                }
	
	                localStorage.setItem('signup', 1);
	                _reactRouter.browserHistory.push({
	                  pathname: '/selectexam',
	                  state: { token: resp.token, idname: email, name: name, landingSource: landingSource, landingSourceName: landingSourceName }
	                });
	                return _context2.abrupt('return');
	
	              case 33:
	                hasUrlRedirect = this && this.state && this.state.urlToRedirect != null;
	
	                if (!hasUrlRedirect) {
	                  _context2.next = 39;
	                  break;
	                }
	
	                examField = prof.profileInfo.exam;
	
	                if (!(_constant.examObject && _constant.examObject[examField])) {
	                  _context2.next = 39;
	                  break;
	                }
	
	                _reactRouter.browserHistory.push({
	                  pathname: _constant.examObject[examField].sidebarRoutes && _constant.examObject[examField].sidebarRoutes.dashboard || _AppRoutes2.default.CFA1_2024_DASHBOARD
	                });
	                return _context2.abrupt('return');
	
	              case 39:
	
	                localStorage.setItem('selectedmenu', prof.profileInfo.exam);
	                _reactRouter.browserHistory.push({
	                  pathname: _examRedirectRoute.examRedirectRoute[prof.profileInfo.exam],
	                  state: { token: resp.token, idname: email }
	                });
	                _context2.next = 47;
	                break;
	
	              case 43:
	                _context2.prev = 43;
	                _context2.t0 = _context2['catch'](10);
	
	                console.error('GIS login error', _context2.t0);
	                alert('Login failed. Please try again.');
	
	              case 47:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[10, 43]]);
	      }));
	
	      function responseGoogleGIS(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return responseGoogleGIS;
	    }()
	  }, {
	    key: 'responseGoogle',
	    value: function responseGoogle(response) {
	      var _this3 = this;
	
	      console.log('============response============', response);
	      var role = localStorage.getItem('role');
	      var organizationDomain = localStorage.getItem('organizationDomain');
	      var userData = JSON.parse(localStorage.getItem('userData'));
	      var landingSource = localStorage.getItem('landingSource');
	      var landingSourceName = localStorage.getItem('landingSourceName');
	      var data = {
	        name: response.profileObj.name,
	        email: response.profileObj.email,
	        token: response.accessToken,
	        imageUrl: response.profileObj.imageUrl,
	        organizationDomain: organizationDomain,
	        role: role
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/loginWithSocialMedia', data).then(function (resp) {
	        if (resp.success) {
	          localStorage.setItem('loginID', resp.loginID);
	          var localStorage_array = {
	            token: resp.token,
	            idname: response.profileObj.email
	          };
	          var cookies = new _universalCookie2.default();
	          cookies.set('token', resp.token, {
	            path: '/',
	            maxAge: 60 * 60 * 24
	          });
	          cookies.set('idname', response.profileObj.email, {
	            path: '/',
	            maxAge: 60 * 60 * 24
	          });
	          localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	          if (resp.user_data == null) {
	            localStorage.setItem('signup', 1);
	            _reactRouter.browserHistory.push({
	              pathname: '/selectexam',
	              state: {
	                token: resp.token,
	                idname: response.profileObj.email,
	                name: response.profileObj.name,
	                landingSource: landingSource,
	                landingSourceName: landingSourceName
	              }
	            });
	          } else {
	            var data = { token: resp.token, idname: response.profileObj.email };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	              if (resp.success) {
	                if (_this3.state.urlToRedirect !== null) {
	                  if (_constant.examObject[examField]) {
	                    _reactRouter.browserHistory.push({
	                      pathname: _constant.examObject[examField].sidebarRoutes.dashboard || _AppRoutes2.default.CFA1_2024_DASHBOARD
	                    });
	                  }
	                } else if (resp.profileInfo.exam) {
	                  localStorage.setItem('selectedmenu', resp.profileInfo.exam);
	                  _reactRouter.browserHistory.push({
	                    pathname: _examRedirectRoute.examRedirectRoute[resp.profileInfo.exam],
	                    state: {
	                      token: resp.token,
	                      idname: response.profileObj.email
	                    }
	                  });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        } else if (!resp.success && resp.partner) {
	          alert(resp.message);
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'failedGoogle',
	    value: function failedGoogle(response) {
	      console.log('Failed googles login', response);
	      if (response.details === 'Cookies are not enabled in current environment.') {
	        alert("We've detected a problem with your cookie settings in the browser. Make sure that your cookies are enabled.");
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      // console.log(this.props.urlToRedirect)
	      // console.log("th.landingSource", this.state.landingSource);
	      // console.log(localStorage.getItem("domainName"));
	      // console.log(localStorage.getItem("domainApp"));
	      var domainApp = localStorage.getItem('domainApp');
	      return _react2.default.createElement(
	        'div',
	        { className: 'sign-up-input-tile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'social-button-tile' },
	          _react2.default.createElement(_GoogleBtn2.default, {
	            onSuccess: this.responseGoogleGIS,
	            onFailure: this.failedGoogle
	          })
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'sign-up-form-wrap', onSubmit: this.Registration },
	          _react2.default.createElement(
	            'p',
	            { className: this.state.displaytext + ' text-danger' },
	            this.state.message
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('input', {
	              type: 'text',
	              className: 'form-control',
	              placeholder: _language2.default.LC().USERNAME,
	              value: this.state.username,
	              onChange: this.updateUserName
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: this.state.displaytext + ' text-danger' },
	              this.state.userNameErrorMessage
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('input', {
	              type: 'text',
	              className: 'form-control',
	              placeholder: _language2.default.LC().EMAIL,
	              value: this.state.email,
	              onChange: this.updateEmail
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: this.state.displaytext + ' text-danger' },
	              this.state.emailErrorMessage
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'passwordeye_wrapper' },
	              _react2.default.createElement('input', {
	                type: this.state.inputValue == 1 ? 'text' : 'password',
	                className: 'form-control',
	                placeholder: _language2.default.LC().PASSWORD,
	                value: this.state.password,
	                onChange: this.updatePassword
	              }),
	              this.state.inputValue == 1 ? _react2.default.createElement('img', {
	                onClick: function onClick() {
	                  return _this4.togglepassword('1');
	                },
	                src: _App_data2.default.frontend_url + '/img/show 2.png',
	                alt: ''
	              }) : _react2.default.createElement('img', {
	                onClick: function onClick() {
	                  return _this4.togglepassword('1');
	                },
	                src: _App_data2.default.frontend_url + '/img/hide2.png',
	                alt: ''
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: this.state.displaytext + ' text-danger' },
	              this.state.passwordErrorMessage
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'passwordeye_wrapper' },
	              _react2.default.createElement('input', {
	                type: this.state.inputValue == 2 ? 'text' : 'password',
	                className: 'form-control',
	                placeholder: _language2.default.LC().CONFIRM_PASSWORD,
	                value: this.state.repeatpassword,
	                onChange: this.updateRepeatPassword
	              }),
	              this.state.inputValue == 2 ? _react2.default.createElement('img', {
	                onClick: function onClick() {
	                  return _this4.togglepassword('2');
	                },
	                src: _App_data2.default.frontend_url + '/img/show 2.png',
	                alt: ''
	              }) : _react2.default.createElement('img', {
	                onClick: function onClick() {
	                  return _this4.togglepassword('2');
	                },
	                src: _App_data2.default.frontend_url + '/img/hide2.png',
	                alt: ''
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: this.state.displaytext + ' text-danger' },
	              this.state.repPasswordErrorMessage
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'select',
	              { className: 'form-control', id: 'exam_field' },
	              [{ value: '', label: _language2.default.LC().SELECT_EXAM }].concat(_toConsumableArray((0, _constant.CFAExamList)()), _toConsumableArray(_constant.FRMExamList), _toConsumableArray(_constant.ActuarialExamList), _toConsumableArray(_constant.GMATExamList)).map(function (_ref3) {
	                var value = _ref3.value,
	                    label = _ref3.label;
	                return _react2.default.createElement(
	                  'option',
	                  { key: value, value: value },
	                  label
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: this.state.displaytext + ' text-danger' },
	              this.state.examErrorMessage
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary sign-up-button btn-block', type: 'submit' },
	            _language2.default.LC().SIGN_UP
	          )
	        ),
	        _react2.default.createElement(_signUpApproval2.default, {
	          signUpAlertModel: this.signUpAlertModel.bind(this),
	          signUpAlertModelClose: this.signUpAlertModelClose.bind(this),
	          signupAlert: this.state.signupAlert
	        })
	      );
	    }
	  }]);
	
	  return SignUp;
	}(_react.Component);
	
	exports.default = SignUp;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cfa3EssayQuesPdf = function (_Component) {
	  _inherits(Cfa3EssayQuesPdf, _Component);
	
	  function Cfa3EssayQuesPdf(props) {
	    _classCallCheck(this, Cfa3EssayQuesPdf);
	
	    var _this = _possibleConstructorReturn(this, (Cfa3EssayQuesPdf.__proto__ || Object.getPrototypeOf(Cfa3EssayQuesPdf)).call(this, props));
	
	    _this.state = {
	      pdfurl: ''
	    };
	    return _this;
	  }
	
	  _createClass(Cfa3EssayQuesPdf, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // console.log('workingh')
	      // console.log(this.props.location.state.pdffilename)
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        // console.log('oif working')
	        this.setState({ pdfurl: this.props.location.state.pdffilename });
	      } else {
	        localStorage.removeItem('localstorageval');
	        localStorage.removeItem('selectedmenu', '');
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('object', { data: _App_data2.default.frontend_url + "/pdf/cfa3EssayQuesPdf/" + this.state.pdfurl,
	                type: 'application/pdf', style: { height: 100 + 'vh', width: 100 + '%' } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Cfa3EssayQuesPdf;
	}(_react.Component);
	
	exports.default = Cfa3EssayQuesPdf;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactCookies = __webpack_require__(123);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _examRedirectRoute = __webpack_require__(103);
	
	var _OrderLinkInvalid = __webpack_require__(849);
	
	var _OrderLinkInvalid2 = _interopRequireDefault(_OrderLinkInvalid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var CheckoutVerify = function (_Component) {
	  _inherits(CheckoutVerify, _Component);
	
	  function CheckoutVerify(props) {
	    var _this2 = this,
	        _this$state3;
	
	    _classCallCheck(this, CheckoutVerify);
	
	    var _this = _possibleConstructorReturn(this, (CheckoutVerify.__proto__ || Object.getPrototypeOf(CheckoutVerify)).call(this, props));
	
	    _this.getOrderById = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var response, _response$data, order_data, stripe_customerID, stripe_chargeID, amount, payment_type, orderDataInJSONString, orderDataInJson, gtmData;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/getOrdersbyid', data);
	
	              case 2:
	                response = _context.sent;
	
	
	                if (response && response.success) {
	                  _response$data = response.data, order_data = _response$data.order_data, stripe_customerID = _response$data.stripe_customerID, stripe_chargeID = _response$data.stripe_chargeID, amount = _response$data.amount, payment_type = _response$data.payment_type;
	                  orderDataInJSONString = JSON.stringify(order_data);
	                  orderDataInJson = JSON.parse(JSON.parse(orderDataInJSONString));
	
	                  _this.setState({
	                    orders_discription: orderDataInJson,
	                    totalAmount: amount,
	                    order_price: orderDataInJson.all_order_details,
	                    loader: false,
	                    showDetails: true,
	                    tapfilliate: !data.isExist,
	                    stripeCustomerID: stripe_customerID,
	                    stripeChargeID: stripe_chargeID,
	                    paymentType: payment_type
	                  });
	                  window.uet_report_conversion(response.data.amount);
	                  if (!data.isExist) {
	                    gtmData = {
	                      orders_discription: orderDataInJson,
	                      totalAmount: response.data.amount,
	                      order_price: orderDataInJson.all_order_details,
	                      landingSource: response.landingSource,
	                      landingSourceName: response.landingSourceName
	                    };
	
	                    _this.GTM_Trigger(gtmData);
	                  }
	                }
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.updateParsedValue = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(parsed) {
	        var value1, value2, value, IP, rawMethod, paymentType, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (parsed.email) {
	                  _this.setState({
	                    email: parsed.email.replace(/^[^\w]+|[^\w]+$/g, '')
	                  });
	                }
	
	                if (parsed.first_name || parsed.last_name) {
	                  value1 = parsed.first_name.replace(/[^A-Z0-9a-z]/gi, '');
	                  value2 = parsed.last_name.replace(/[^A-Z0-9a-z]/gi, '');
	                  value = value1.concat(' ', value2);
	
	                  _this.setState({
	                    username: value
	                  });
	                }
	                if (parsed.product_id) {
	                  _this.setState({
	                    packageID: parsed.product_id
	                  });
	                }
	                if (parsed.total) {
	                  _this.setState({
	                    amount: parsed.total
	                  });
	                }
	                if (parsed.city) {
	                  _this.setState({
	                    city: parsed.city.replace(/[^A-Z0-9a-z]/gi, '')
	                  });
	                }
	
	                if (parsed.discount_amount) {
	                  _this.setState({
	                    discountAmount: parsed.discount_amount
	                  });
	                }
	
	                if (parsed.transaction_id) {
	                  _this.setState({
	                    stripeChargeID: parsed.transaction_id
	                  });
	                }
	
	                if (parsed.subscription_id) {
	                  _this.setState({
	                    subscriptionScheduleID: parsed.subscription_id
	                  });
	                }
	
	                IP = '';
	                // await GD.GetCallAPI("https://geolocation-db.com/json/").then((resp) => {
	                //   IP = resp.IPv4;
	                //   this.setState({
	                //     userIP: resp.IPv4,
	                //   });
	                // });
	                // ── payment_type (#273) ──────────────────────────────────────────────
	                // WordPress redirects pass `payment_method=PayPal` or `payment_method=Stripe`
	                // (capitalised) in the URL. The legacy LMS code dropped this entirely,
	                // so PayPal orders ended up persisted as `payment_type='stripe'` and the
	                // PayPal Capture ID landed in `stripe_chargeID`. Forward a normalised
	                // `payment_type` so the backend writes the right columns.
	
	                rawMethod = String(parsed.payment_method || '').toLowerCase();
	                paymentType = rawMethod === 'paypal' ? 'paypal' : 'stripe';
	                data = {
	                  username: parsed.first_name.replace(/[^A-Z0-9a-z]/gi, '').concat(' ', parsed.last_name.replace(/[^A-Z0-9a-z]/gi, '')),
	                  email: parsed.email.replace(/^[^\w]+|[^\w]+$/g, ''),
	                  landingSource: _this.state.landingSource,
	                  landingSourceName: _this.state.landingSourceName,
	                  packageID: parsed.product_id,
	                  city: parsed.city.replace(/[^A-Z0-9a-z]/gi, ''),
	                  amount: parsed.total,
	                  userIP: IP,
	                  discountAmount: parsed.discount_amount ? parsed.discount_amount : 0,
	                  // WP is the source of truth for the partner/sale-adjusted discount %.
	                  // LMS just forwards. Falls back to 0 when WP doesn't send the param.
	                  percent_discount: parsed.percent_discount ? Number(parsed.percent_discount) : 0,
	                  stripeChargeID: parsed.transaction_id,
	                  subscriptionScheduleID: parsed.subscription_id,
	                  customerId: parsed.customerId,
	                  payment_type: paymentType,
	                  // Wallet/Link metadata forwarded by the WP-Stripe plugin (see proposal
	                  // in docs/integrations/stripe-wallets.md). Both fields are optional —
	                  // legacy WP builds that don't send them keep working unchanged.
	                  walletType: parsed.wallet_type || null,
	                  paymentIntentId: parsed.payment_intent_id || null
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/signup', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var examIdArray, examData, canProceed, _examIdArray, array1_new, array2_old, array3_store, unique_exam, idArray, packageData, updateorderData, canProceedExisting;
	
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context4.next = 34;
	                              break;
	                            }
	
	                            if (resp.isExist) {
	                              _context4.next = 16;
	                              break;
	                            }
	
	                            _this.setState({
	                              password: resp.password,
	                              exam: resp.exam,
	                              discountAmount: parsed.discount_amount ? parsed.discount_amount : 0
	                            });
	
	                            examIdArray = [];
	
	                            examIdArray = resp.plans.map(function (plan) {
	                              return plan.exam_id;
	                            });
	                            examData = JSON.stringify(examIdArray);
	
	                            data['examData'] = examData;
	                            // Gate (#273): Stripe path requires a customerId; PayPal path
	                            // requires the transaction (capture) ID. WordPress's PayPal flow
	                            // doesn't supply a customerId we can use.
	                            canProceed = data.payment_type === 'paypal' ? !!data.stripeChargeID : !!data.customerId;
	
	                            if (!canProceed) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/updateOrder', data).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(respOrder) {
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (respOrder.success) {
	                                          if (respOrder.isOrderAlreadyExist) {
	                                            _this.setState({
	                                              loader: false,
	                                              isLinkInvalid: true
	                                            });
	                                          } else {
	                                            _this.getOrderById(respOrder.orderData);
	                                          }
	                                        }
	
	                                      case 1:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context4.next = 14;
	                            break;
	
	                          case 13:
	                            _this.setState({
	                              loader: false,
	                              isLinkInvalid: true
	                            });
	
	                          case 14:
	                            _context4.next = 34;
	                            break;
	
	                          case 16:
	                            if (!resp.isExist) {
	                              _context4.next = 34;
	                              break;
	                            }
	
	                            _this.setState({
	                              isExist: true,
	                              plans: resp.plans,
	                              exam: resp.userData.exam
	                            });
	                            _examIdArray = [];
	
	                            _examIdArray = resp.plans.map(function (plan) {
	                              return plan.exam_id;
	                            });
	                            examData = JSON.stringify(_examIdArray);
	
	                            if (resp.userData.exam_selected !== '') {
	                              array1_new = _examIdArray;
	                              array2_old = JSON.parse(resp.userData.exam_selected);
	                              array3_store = array1_new.concat(array2_old);
	                              unique_exam = array3_store.filter(function (elem, index, self) {
	                                return index === self.indexOf(elem);
	                              });
	
	                              examData = JSON.stringify(unique_exam);
	                            }
	
	                            idArray = [];
	
	                            idArray = resp.plans.map(function (plan) {
	                              return plan.id;
	                            });
	                            packageData = JSON.stringify(idArray);
	
	                            if (resp.userData.exam_package !== '') {
	                              array1_new = idArray;
	                              array2_old = JSON.parse(resp.userData.exam_package);
	                              array3_store = array1_new.concat(array2_old);
	                              unique_exam = array3_store.filter(function (elem, index, self) {
	                                return index === self.indexOf(elem);
	                              });
	
	                              packageData = JSON.stringify(unique_exam);
	                            }
	
	                            updateorderData = Object.assign({}, data, {
	                              storage_valueofExam: examData,
	                              storage_valueofPlan: packageData,
	                              orderData: resp.plans
	                            });
	                            // Same gate (#273) as the new-user branch above.
	
	                            canProceedExisting = updateorderData.payment_type === 'paypal' ? !!updateorderData.stripeChargeID : !!updateorderData.customerId;
	
	                            if (!canProceedExisting) {
	                              _context4.next = 33;
	                              break;
	                            }
	
	                            _context4.next = 31;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/updateExistingUserOrder', updateorderData).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(respOrder) {
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (respOrder.success) {
	                                          if (respOrder.isOrderAlreadyExist) {
	                                            _this.setState({
	                                              loader: false,
	                                              isLinkInvalid: true
	                                            });
	                                          } else {
	                                            _this.getOrderById(respOrder.orderData);
	                                          }
	                                        }
	
	                                      case 1:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	
	                          case 31:
	                            _context4.next = 34;
	                            break;
	
	                          case 33:
	                            _this.setState({
	                              loader: false,
	                              isLinkInvalid: true
	                            });
	
	                          case 34:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 13:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.login = function () {
	      var _this$state = _this.state,
	          exam = _this$state.exam,
	          isExist = _this$state.isExist,
	          email = _this$state.email,
	          password = _this$state.password;
	
	
	      if (isExist) {
	        _this.password();
	      }
	      var loginData = { idname: email, password: password };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/login', loginData).then(function (response) {
	        if (!response.success) return;
	
	        var loginID = response.loginID,
	            token = response.token,
	            exam_details = response.exam_details;
	        var CFA = _constant.examNameAccordingToDB.CFA,
	            CFA_LEVEL_1_2025 = _constant.examNameAccordingToDB.CFA_LEVEL_1_2025;
	
	
	        var selectedExam = exam_details || (exam.startsWith(CFA) ? CFA_LEVEL_1_2025 : exam);
	        localStorage.setItem('loginID', loginID);
	        localStorage.setItem('localstorageval', JSON.stringify({ token: token, idname: email }));
	        localStorage.setItem('selectedmenu', selectedExam);
	
	        var examRoute = _examRedirectRoute.examRedirectRoute[(exam_details || exam).toLowerCase()];
	        _reactRouter.browserHistory.push({ pathname: examRoute });
	      });
	    };
	
	    _this.password = function () {
	      if (_this.state.passwordAlert) {
	        _this.setState({
	          forgotOpenStatus: false,
	          passwordAlert: !_this.state.passwordAlert,
	          message: '',
	          passwordErrorMessage: ''
	        });
	      }
	      _this.setState({
	        passwordAlert: !_this.state.passwordAlert,
	        message: '',
	        passwordErrorMessage: ''
	      });
	    };
	
	    _this.updatePassword = function (e) {
	      _this.setState({
	        enterPassword: e.target.value,
	        passwordErrorMessage: ''
	      });
	    };
	
	    _this.onLoginSubmit = function (event) {
	      event.preventDefault();
	      var _this$state2 = _this.state,
	          enterPassword = _this$state2.enterPassword,
	          email = _this$state2.email;
	
	      if (enterPassword == '') {
	        _this.setState({
	          passwordErrorMessage: '' + _language2.default.LC().Password_is_Required,
	          displaytext: 'show_block'
	        });
	        return;
	      }
	      _this.setState({
	        passwordErrorMessage: '',
	        displaytext: 'hide_block'
	      });
	      var data = { idname: email, password: enterPassword };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/credentialsCheck', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            isExist: false,
	            password: enterPassword
	          });
	          _this.login();
	        } else {
	          _this.setState({
	            passwordErrorMessage: resp.message,
	            enterPassword: '',
	            displaytext: 'show_block'
	          });
	        }
	      });
	    };
	
	    _this.handleForgot = function () {
	      var forgotOpenStatus = _this.state.forgotOpenStatus;
	
	      var data = { idname: _this.state.email };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/wooCoomerceCheckout/forgetPassword', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            forgotOpenStatus: true,
	            message: '',
	            passwordErrorMessage: ''
	          });
	        }
	      });
	    };
	
	    _this.GTM_Trigger = function (data) {
	      var _dataLayer;
	
	      var array = [];
	      for (var i = 0; i < data.order_price.length; i++) {
	        array.push({
	          exam: data.order_price[i].exam_name,
	          packageType: data.order_price[i].package_type,
	          price: data.order_price[i].price
	        });
	      }
	      var tagManagerArgs = {
	        gtmId: _constant.GTM_ID,
	        dataLayer: (_dataLayer = {
	          event: _constant.GTMPurchaseCompleted,
	          eventOptions: {
	            orderID: JSON.stringify(data.orders_discription.order_id),
	            paymentOption: 'card',
	            cart: array,
	            cartTotal: data.totalAmount
	          },
	          userName: data.orders_discription.username,
	          userEmail: data.orders_discription.idname,
	          source: data.landingSource,
	          value: data.totalAmount,
	          currency: _constant.Currency,
	          affiliateName: data.landingSourceName,
	          price: data.totalAmount
	        }, _defineProperty(_dataLayer, 'value', data.totalAmount), _defineProperty(_dataLayer, 'currency', _constant.Currency), _dataLayer)
	      };
	      _reactGtmModule2.default.initialize(tagManagerArgs);
	
	      // ******************** For purchase event on GA4 **************** //
	
	      var tagManagerArgsGA4 = {
	        gtmId: _constant.GTM_ID,
	        dataLayer: {
	          event: _constant.GA4Purchase,
	          eventOptions: {
	            orderID: JSON.stringify(data.orders_discription.order_id),
	            paymentOption: 'card',
	            cart: array,
	            cartTotal: data.totalAmount
	          },
	
	          transaction_id: JSON.stringify(data.orders_discription.order_id),
	          value: data.totalAmount,
	          currency: _constant.Currency,
	          affiliation: data.landingSourceName,
	          items: array,
	          revenue_value: data.totalAmount,
	          userName: data.orders_discription.username,
	          userEmail: data.orders_discription.idname,
	          source: data.landingSource
	        }
	      };
	      _reactGtmModule2.default.initialize(tagManagerArgsGA4);
	    };
	
	    _this.state = (_this$state3 = {
	      landingSource: 'organic',
	      landingSourceName: null,
	      username: '',
	      email: '',
	      amount: '',
	      city: '',
	      packageID: '',
	      userIP: '',
	      message_background: 'bg-danger',
	      displaytext: 'hide_block',
	      orders_discription: '',
	      order_price: [],
	      loader: true,
	      password: '',
	      exam: '',
	      isLinkInvalid: false,
	      discountAmount: 0,
	      passwordAlert: false,
	      enterPassword: '',
	      showDetails: false,
	      passwordErrorMessage: '',
	      forgotOpenStatus: false,
	      isExist: false
	    }, _defineProperty(_this$state3, 'landingSource', 'organic'), _defineProperty(_this$state3, 'landingSourceName', null), _defineProperty(_this$state3, 'user_city', ''), _defineProperty(_this$state3, 'user_country', ''), _defineProperty(_this$state3, 'user_ip', ''), _defineProperty(_this$state3, 'user_state', ''), _defineProperty(_this$state3, 'user_continent', ''), _defineProperty(_this$state3, 'tapfilliate', false), _defineProperty(_this$state3, 'stripeCustomerID', ''), _defineProperty(_this$state3, 'stripeChargeID', ''), _defineProperty(_this$state3, 'paymentType', ""), _this$state3);
	    _this.login = _this.login.bind(_this);
	    _this.password = _this.password.bind(_this);
	    _this.onLoginSubmit = _this.onLoginSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckoutVerify, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var landingSourceCokkie, checkTapfilliateRefernce, parsed, result1, data1;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                /*
	                --------------------------------
	                Pixel Integration code start
	                --------------------------------
	                */
	                landingSourceCokkie = _reactCookies2.default.load('utm_source', {
	                  path: '/',
	                  domain: '.analystprep.com'
	                });
	
	                if (landingSourceCokkie) {
	                  this.setState({
	                    landingSource: landingSourceCokkie
	                  });
	                }
	                localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
	                checkTapfilliateRefernce = _reactCookies2.default.load('ref', {
	                  path: '/',
	                  domain: '.analystprep.com'
	                });
	
	                if (checkTapfilliateRefernce) {
	                  this.setState({
	                    landingSource: 'tapfiliate',
	                    landingSourceName: checkTapfilliateRefernce
	                  });
	                  localStorage.setItem('landingSource', 'tapfiliate');
	                }
	
	                localStorage.setItem('landingSourceName', checkTapfilliateRefernce ? checkTapfilliateRefernce : null);
	                /*
	                -------------------------------
	                Pixel Integration code end
	                -------------------------------    
	                */
	
	                // GD.GetCallAPI("https://geolocation-db.com/json/").then((resp) => {
	                //   this.setState({
	                //     userIP: resp.IPv4,
	                //   });
	                // });
	                parsed = this.props.location.query;
	
	
	                this.updateParsedValue(parsed);
	
	                // api to get ip address
	                _context6.next = 10;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 10:
	                result1 = _context6.sent;
	
	                if (result1) {
	                  this.setState({
	                    user_city: result1.city,
	                    user_country: result1.country,
	                    user_ip: result1.query,
	                    userIP: result1.query,
	                    user_state: result1.region,
	                    user_continent: result1.continent
	                  });
	                }
	                // const result = getDeviceDetails();
	                data1 = {
	                  city: this.state.user_city,
	                  country: this.state.user_country,
	                  state: this.state.user_state,
	                  continent: this.state.user_continent,
	                  ip: this.state.user_ip
	                };
	
	                localStorage.setItem('userData', JSON.stringify(data1));
	
	              case 14:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	    /*
	    ------------------------
	      Update parsed value
	    ------------------------
	    */
	
	
	    /*
	    ----------
	      Login 
	    ----------
	    */
	
	
	    /*
	    ------------------
	      Password model
	    ------------------
	    */
	
	
	    /*
	    -------------------------
	      Update password value
	    -------------------------
	    */
	
	
	    /*
	    ----------------------
	      Login form submit 
	    ----------------------
	    */
	
	
	    /*
	    ---------------------
	      Forgot password 
	    ---------------------
	    */
	
	    /*
	    -------------------------------------------------------
	      For GTM trigger it's fired when  package purchased
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          totalAmount = _state.totalAmount,
	          order_price = _state.order_price,
	          orders_discription = _state.orders_discription,
	          loader = _state.loader,
	          discountAmount = _state.discountAmount,
	          passwordAlert = _state.passwordAlert,
	          email = _state.email,
	          enterPassword = _state.enterPassword,
	          passwordErrorMessage = _state.passwordErrorMessage,
	          showDetails = _state.showDetails,
	          forgotOpenStatus = _state.forgotOpenStatus,
	          tapfilliate = _state.tapfilliate,
	          stripeCustomerID = _state.stripeCustomerID,
	          stripeChargeID = _state.stripeChargeID,
	          isLinkInvalid = _state.isLinkInvalid,
	          paymentType = _state.paymentType;
	
	      /*
	      --------------------------
	        Tapfilliate code
	      --------------------------
	      */
	
	      var tapFiliateCount = 0;
	      if (tapfilliate) {
	        _react2.default.createElement(
	          'script',
	          { src: 'https://script.tapfiliate.com/tapfiliate.js', type: 'text/javascript', async: true },
	          _react2.default.createElement(
	            'script',
	            { type: 'text/javascript' },
	            tapFiliateCount++,
	            function (t, a, p) {
	              t.TapfiliateObject = a, t[a] = t[a] || function () {
	                (t[a].q = t[a].q || []).push(arguments);
	              };
	            },
	            ')(',
	            (window, 'tap'),
	            ');',
	            (window.tap('create', '14886-4db9dd', {
	              integration: 'stripe'
	            }), window.tap('conversion', stripeChargeID, totalAmount, {
	              customer_id: stripeCustomerID
	            }))
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper' },
	            _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/logo1.png', alt: '', width: '200' })
	          )
	        ),
	        loader ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'loader_box checkout-message' },
	            'Your payment is being processed. please do not close this page.',
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          )
	        ) : null,
	        isLinkInvalid && _react2.default.createElement(_OrderLinkInvalid2.default, null),
	        showDetails ? _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-group mb-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card p-2  ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    ' ',
	                    _language2.default.LC().THANK_YOU_FOR_YOUR_ORDER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    '*You will also receive confirmation of your purchase via email'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-6 col-md-7 margin_bottom_10' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-responsive thankyou_tb' },
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table cart_table ' },
	                        _react2.default.createElement(
	                          'thead',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'th',
	                              null,
	                              _language2.default.LC().PACKAGE
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              null,
	                              _language2.default.LC().PRICE
	                            ),
	                            discountAmount !== 0 ? _react2.default.createElement(
	                              'th',
	                              null,
	                              _language2.default.LC().DISCOUNT
	                            ) : _react2.default.createElement('th', null)
	                          )
	                        ),
	                        order_price && order_price.length > 0 ? order_price.map(function (packageDetail, index) {
	                          return _react2.default.createElement(
	                            'tbody',
	                            { key: index },
	                            _react2.default.createElement(
	                              'tr',
	                              { className: 'package-heading' },
	                              _react2.default.createElement(
	                                'td',
	                                { width: '60%' },
	                                packageDetail.exam_name + ' (' + packageDetail.package_type + ') '
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { width: '20%' },
	                                '$',
	                                packageDetail.price,
	                                '.00'
	                              ),
	                              discountAmount !== 0 ? _react2.default.createElement(
	                                'td',
	                                { width: '20%' },
	                                '$',
	                                discountAmount
	                              ) : _react2.default.createElement('td', { width: '20%' })
	                            )
	                          );
	                        }) : null,
	                        _react2.default.createElement(
	                          'tfoot',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().TOTAL
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              '$',
	                              totalAmount ? totalAmount.toFixed(2) : null
	                            ),
	                            _react2.default.createElement('td', null)
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-6 col-md-5 margin_bottom_10' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-responsive thankyou_tb' },
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table cart_table' },
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().ORDER_ID,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              orders_discription.order_id
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().NAME,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              orders_discription.username
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().PAYMENT_METHOD,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              paymentType
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _language2.default.LC().EMAIL,
	                                ' :'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              orders_discription.idname
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10 m-0 d-flex justify-content-center' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-primary pointer_class', onClick: this.login },
	                      ' ',
	                      _language2.default.LC().START_STUDY,
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : null,
	        showDetails ? _react2.default.createElement(
	          'blockquote',
	          { className: 'footer-blockquote' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().FOOTER_MESSAGE
	          )
	        ) : null,
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: passwordAlert,
	            toggle: this.password,
	            className: 'forgot-modal'
	            // backdrop="static"
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'forgot-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center foget-password-img' },
	                _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/forget-password.png', alt: '' })
	              ),
	              !forgotOpenStatus ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-center heading foget-password-heading' },
	                  _language2.default.LC().LOGIN
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.onLoginSubmit },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group forget-password-value' },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      className: 'form-control ',
	                      placeholder: 'Email',
	                      value: email,
	                      disabled: true
	                    }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('input', {
	                      type: 'password',
	                      className: 'form-control ',
	                      placeholder: 'Please enter your password',
	                      value: enterPassword,
	                      onChange: this.updatePassword
	                    }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: this.state.displaytext + ' text-danger' },
	                      passwordErrorMessage
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn forgot-button btn-block pointer_class' },
	                    _language2.default.LC().SUBMIT
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'forgot-password pointer_class', onClick: this.handleForgot },
	                    ' ',
	                    _language2.default.LC().FORGOT_PASSWORD
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-center heading foget-password-heading' },
	                  _language2.default.LC().FORGOT_PASSWORD
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'success-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-center foget-password-img' },
	                    _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/check.png', alt: '' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-center heading foget-password-heading' },
	                    _language2.default.LC().CHECK_YOUR_EMAIL
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'success-text foget-password-text forget-password-value' },
	                    _language2.default.LC().RESTE_PASSWORD_LINK,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn resend-button btn-block pointer_class',
	                      onClick: this.handleForgot
	                    },
	                    _language2.default.LC().RESEND_EMAIL,
	                    ' '
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CheckoutVerify;
	}(_react.Component);
	
	exports.default = CheckoutVerify;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderLinkInvalid = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderLinkInvalid = exports.OrderLinkInvalid = function (_Component) {
	  _inherits(OrderLinkInvalid, _Component);
	
	  function OrderLinkInvalid() {
	    _classCallCheck(this, OrderLinkInvalid);
	
	    return _possibleConstructorReturn(this, (OrderLinkInvalid.__proto__ || Object.getPrototypeOf(OrderLinkInvalid)).apply(this, arguments));
	  }
	
	  _createClass(OrderLinkInvalid, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row justify-content-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-group mb-0' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card p-2  ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block text-center' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    'The link has ',
	                    _react2.default.createElement(
	                      'span',
	                      { style: { color: 'red' } },
	                      'expired'
	                    ),
	                    '.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12 pr-3 pl-3 text-center' },
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'To access your order details. Please login and follow the steps.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Navigate to Profile > Order History',
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10 m-0 d-flex justify-content-center' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn btn-primary pointer_class',
	                      onClick: function onClick() {
	                        return _reactRouter.browserHistory.push({ pathname: _App_data2.default.REACT_APP_FRONTEND_ENDPOINT });
	                      }
	                    },
	                    'Login'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderLinkInvalid;
	}(_react.Component);
	
	exports.default = OrderLinkInvalid;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _signUpApproval = __webpack_require__(186);
	
	var _signUpApproval2 = _interopRequireDefault(_signUpApproval);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _reactCookies = __webpack_require__(123);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filldetails = function (_Component) {
	  _inherits(Filldetails, _Component);
	
	  function Filldetails(props) {
	    _classCallCheck(this, Filldetails);
	
	    var _this = _possibleConstructorReturn(this, (Filldetails.__proto__ || Object.getPrototypeOf(Filldetails)).call(this, props));
	
	    _this.state = {
	      exam: '',
	      message: '',
	      message_background: 'bg-danger',
	      displaytext: 'hide_block',
	      token: '',
	      idname: '',
	      fb_id: _this.props.params.fb_id,
	      signupAlert: false,
	      landingSource: 'organic',
	      landingSourceName: null,
	      name: _this.props.params.name
	    };
	    _this.updateEmail = _this.updateEmail.bind(_this);
	    _this.saveExam = _this.saveExam.bind(_this);
	    _this.signUpAlertModel = _this.signUpAlertModel.bind(_this);
	    _this.signUpAlertModelClose = _this.signUpAlertModelClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Filldetails, [{
	    key: 'updateEmail',
	    value: function updateEmail(event) {
	      var email_lower = event.target.value.toLowerCase();
	      this.setState({ idname: email_lower });
	    }
	  }, {
	    key: 'signUpAlertModel',
	    value: function signUpAlertModel() {
	      this.setState({ signupAlert: !this.state.signupAlert });
	    }
	  }, {
	    key: 'signUpAlertModelClose',
	    value: function signUpAlertModelClose() {
	      this.setState({ signupAlert: false });
	      _reactRouter.browserHistory.push('/');
	    }
	  }, {
	    key: 'saveExam',
	    value: function saveExam() {
	      var _this2 = this;
	
	      if (document.getElementById('exam_field').value === '') {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ message: 'Exam Field Is Required' });
	        return;
	      }
	      // if(document.getElementById('examlocate').value==="")
	      // {
	      //   this.setState({displaytext:'show_block'});
	      //   this.setState({message:'Exam Location Is Required'});
	      //   return;
	      // }
	
	      var emailValid = this.state.idname.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	      if (emailValid) {
	        var role = localStorage.getItem('role');
	        var organizationDomain = localStorage.getItem('organizationDomain');
	        var userData = JSON.parse(localStorage.getItem('userData'));
	
	        var data = {
	          idname: this.state.idname,
	          fb_id: this.state.fb_id,
	          examfield: document.getElementById('exam_field').value,
	          organizationDomain: organizationDomain,
	          role: role,
	          landingSource: this.state.landingSource,
	          landingSourceName: this.state.landingSourceName,
	          city: userData.city,
	          country: userData.country,
	          state: userData.state,
	          continent: userData.continent,
	          ip: userData.ip
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/savewithFBcheck', data).then(function (resp) {
	          if (resp.success) {
	            localStorage.setItem('loginID', resp.loginID);
	            // if (resp.partner) {
	            //   this.signUpAlertModel();
	            // }
	            /*
	            -------------------------
	              GTM signup event code
	            -------------------------
	            */
	            // if (this.state.landingSource) {
	            var tagManagerArgs = {
	              gtmId: _constant.GTM_ID,
	              dataLayer: {
	                event: _constant.GTMSignUp,
	                eventOptions: { selectedExam: document.getElementById('exam_field').value },
	                userName: _this2.state.name,
	                userEmail: _this2.state.idname,
	                userExam: document.getElementById('exam_field').value,
	                source: _this2.state.landingSource,
	                affiliateName: _this2.state.landingSourceName
	              }
	            };
	            _reactGtmModule2.default.initialize(tagManagerArgs);
	            // ************** For GA4 sign_up event ****************//
	            var tagManagerArgsGA4 = {
	              gtmId: _constant.GTM_ID,
	              dataLayer: {
	                event: _constant.GA4SignUp,
	                method: _this2.state.idname
	              }
	            };
	            _reactGtmModule2.default.initialize(tagManagerArgsGA4);
	            // }
	
	            var localStorage_array = {
	              token: resp.token,
	              idname: _this2.state.idname
	            };
	            localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
	
	            var exam_status = document.getElementById('exam_field').value;
	            if (exam_status === 'cfa') {
	              localStorage.setItem('selectedmenu', 'cfa');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.DASHBOARD,
	                state: { token: resp.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'cfa_2022') {
	              localStorage.setItem('selectedmenu', 'cfa_2022');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.CFA_2022_DASHBOARD,
	                state: { token: resp.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'cfa_2_2025') {
	              localStorage.setItem('selectedmenu', 'cfa_2_2025');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.CFA2_2025_DASHBOARD,
	                state: { token: resp.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'cfa_3') {
	              localStorage.setItem('selectedmenu', 'cfa_3');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.CFA3_DASHBOARD,
	                state: { token: resp.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'frm') {
	              localStorage.setItem('selectedmenu', 'frm');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.FRM_DASHBOARD,
	                state: { token: resp.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'soa_p') {
	              localStorage.setItem('selectedmenu', 'soa_p');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.SOA_PROBABILITY_DASHBOARD,
	                state: { token: _this2.state.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'soa_fm') {
	              localStorage.setItem('selectedmenu', 'soa_fm');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
	                state: { token: _this2.state.token, idname: _this2.state.idname }
	              });
	            }
	            if (exam_status === 'gmat') {
	              localStorage.setItem('selectedmenu', 'gmat');
	              _reactRouter.browserHistory.push({
	                pathname: _AppRoutes2.default.GMAT_DASHBOARD,
	                state: { token: _this2.state.token, idname: _this2.state.idname }
	              });
	            }
	          } else {
	            _this2.setState({ displaytext: 'show_block' });
	            _this2.setState({ message: resp.message });
	          }
	        });
	      } else {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ message: 'Email Is Not Valid' });
	        return;
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      /*
	      --------------------------------
	      Pixel Integration code start
	      --------------------------------
	      */
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var landingSourceCokkie = _reactCookies2.default.load('utm_source', {
	        path: '/',
	        domain: '.analystprep.com'
	      });
	      if (landingSourceCokkie) {
	        this.setState({ landingSource: landingSourceCokkie });
	      }
	      localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
	      var checkTapfilliateRefernce = _reactCookies2.default.load('ref', {
	        path: '/',
	        domain: '.analystprep.com'
	      });
	      if (checkTapfilliateRefernce) {
	        this.setState({
	          landingSource: 'tapfiliate',
	          landingSourceName: checkTapfilliateRefernce
	        });
	        localStorage.setItem('landingSource', 'tapfiliate');
	      }
	
	      localStorage.setItem('landingSourceName', checkTapfilliateRefernce ? checkTapfilliateRefernce : null);
	
	      /*
	      -------------------------------
	      Pixel Integration code end
	      -------------------------------    
	      */
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper' },
	            _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/logo1.png', alt: '', width: '200' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-group mb-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card p-2  ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Select Exam'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-muted' },
	                    'Fill Your Details'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    {
	                      className: this.state.message_background + ' ' + this.state.displaytext,
	                      style: {
	                        paddingTop: 4 + 'px',
	                        paddingBottom: 4 + 'px',
	                        paddingLeft: 10 + 'px',
	                        fontSize: 14 + 'px'
	                      }
	                    },
	                    this.state.message
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group mb-1' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-addon-social-registration' },
	                      _react2.default.createElement('i', { className: 'fa fa-envelope' })
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      className: 'form-control',
	                      placeholder: 'Email',
	                      value: this.state.idname,
	                      onChange: this.updateEmail
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group mb-1' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-addon-social-registration' },
	                      _react2.default.createElement('i', { className: 'fa fa-book' })
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-control', id: 'exam_field' },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        _language2.default.LC().SELECT_EXAM
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'cfa' },
	                        _language2.default.LC().CFA_1
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'cfa_2' },
	                        _language2.default.LC().CFA_2
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'cfa_3' },
	                        _language2.default.LC().CFA_3
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'frm' },
	                        _language2.default.LC().FRM_PART_1
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'frm' },
	                        _language2.default.LC().FRM_PART_2
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'frm' },
	                        _language2.default.LC().FRM_PART_1,
	                        ' & ',
	                        _language2.default.LC().FRM_PART_2
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'soa_p' },
	                        _language2.default.LC().SOA_PROBABILITY
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'soa_fm' },
	                        _language2.default.LC().SOA_FINANCIAL
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          style: { width: 100 + '%' },
	                          className: 'btn btn-primary',
	                          onClick: this.saveExam
	                        },
	                        'Save'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_signUpApproval2.default, {
	            signUpAlertModel: this.signUpAlertModel.bind(this),
	            signUpAlertModelClose: this.signUpAlertModelClose.bind(this),
	            signupAlert: this.state.signupAlert
	          })
	        ),
	        _react2.default.createElement(
	          'blockquote',
	          { className: 'footer-blockquote' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().FOOTER_MESSAGE
	          )
	        ),
	        ' '
	      );
	    }
	  }]);
	
	  return Filldetails;
	}(_react.Component);
	
	exports.default = Filldetails;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrmPdf = function (_Component) {
	  _inherits(FrmPdf, _Component);
	
	  function FrmPdf(props) {
	    _classCallCheck(this, FrmPdf);
	
	    var _this = _possibleConstructorReturn(this, (FrmPdf.__proto__ || Object.getPrototypeOf(FrmPdf)).call(this, props));
	
	    _this.state = {
	      pdfurl: ''
	    };
	    return _this;
	  }
	
	  _createClass(FrmPdf, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({ pdfurl: this.props.location.state.pdffilename });
	      } else {
	        localStorage.removeItem('localstorageval');
	        localStorage.removeItem('selectedmenu', '');
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('object', { data: _App_data2.default.frontend_url + "/pdf/frm/" + this.state.pdfurl,
	                type: 'application/pdf', style: { height: 100 + 'vh', width: 100 + '%' } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FrmPdf;
	}(_react.Component);
	
	exports.default = FrmPdf;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactRouter = __webpack_require__(29);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _signUpApproval = __webpack_require__(186);
	
	var _signUpApproval2 = _interopRequireDefault(_signUpApproval);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _reactCookies = __webpack_require__(123);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	var _examRedirectRoute = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selectexam = function (_Component) {
	  _inherits(Selectexam, _Component);
	
	  function Selectexam(props) {
	    _classCallCheck(this, Selectexam);
	
	    var _this = _possibleConstructorReturn(this, (Selectexam.__proto__ || Object.getPrototypeOf(Selectexam)).call(this, props));
	
	    _this.state = {
	      exam: '',
	      message: '',
	      message_background: 'bg-danger',
	      displaytext: 'hide_block',
	      token: '',
	      idname: '',
	      signupAlert: false,
	      landingSource: 'organic',
	      landingSourceName: null,
	      name: _this.props.params.name ? _this.props.params.name : null
	    };
	    _this.saveExam = _this.saveExam.bind(_this);
	    _this.signUpAlertModel = _this.signUpAlertModel.bind(_this);
	    _this.signUpAlertModelClose = _this.signUpAlertModelClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Selectexam, [{
	    key: 'signUpAlertModel',
	    value: function signUpAlertModel() {
	      this.setState({ signupAlert: !this.state.signupAlert });
	    }
	  }, {
	    key: 'signUpAlertModelClose',
	    value: function signUpAlertModelClose() {
	      this.setState({ signupAlert: false });
	      _reactRouter.browserHistory.push('/');
	    }
	  }, {
	    key: 'saveExam',
	    value: function saveExam() {
	      var _this2 = this;
	
	      if (document.getElementById('exam_field').value === '') {
	        this.setState({ displaytext: 'show_block' });
	        this.setState({ message: 'Exam Field Is Required' });
	        return;
	      } else {
	        var role = localStorage.getItem('role');
	        var organizationDomain = localStorage.getItem('organizationDomain');
	
	        var data = {
	          idname: this.state.idname,
	          token: this.state.token,
	          examfield: document.getElementById('exam_field').value,
	          organizationDomain: organizationDomain,
	          role: role,
	          landingSource: this.state.landingSource,
	          landingSourceName: this.state.landingSourceName
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/updateUser', data).then(function (resp) {
	          if (resp.success) {
	            /*
	            -------------------------
	              GTM signup event code
	            -------------------------
	            */
	
	            // if (this.state.landingSource) {
	            var tagManagerArgs = {
	              gtmId: _constant.GTM_ID,
	              dataLayer: {
	                event: _constant.GTMSignUp,
	                eventOptions: { selectedExam: document.getElementById('exam_field').value },
	                userName: _this2.state.name,
	                userEmail: _this2.state.idname,
	                userExam: document.getElementById('exam_field').value,
	                source: _this2.state.landingSource,
	                affiliateName: _this2.state.landingSourceName
	              }
	            };
	            _reactGtmModule2.default.initialize(tagManagerArgs);
	
	            // ******************* Event for Sign Up in GA4 ************** //
	            var tagManagerArgsGA4 = {
	              gtmId: _constant.GTM_ID,
	              dataLayer: {
	                event: _constant.GA4SignUp,
	                method: _this2.state.idname
	              }
	            };
	            _reactGtmModule2.default.initialize(tagManagerArgsGA4);
	            // }
	
	            localStorage.setItem('selectedmenu', document.getElementById('exam_field').value);
	            var exam_status = document.getElementById('exam_field').value;
	            if (exam_status) {
	              localStorage.setItem('selectedmenu', exam_status);
	              _reactRouter.browserHistory.push({ pathname: _examRedirectRoute.examRedirectRoute[exam_status] });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      /*
	      --------------------------------
	      Pixel Integration code start
	      --------------------------------
	      */
	      var landingSourceCokkie = _reactCookies2.default.load('utm_source', {
	        path: '/',
	        domain: '.analystprep.com'
	      });
	      if (landingSourceCokkie) {
	        this.setState({ landingSource: landingSourceCokkie });
	      }
	      localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
	      var checkTapfilliateRefernce = _reactCookies2.default.load('ref', {
	        path: '/',
	        domain: '.analystprep.com'
	      });
	      if (checkTapfilliateRefernce) {
	        this.setState({
	          landingSource: 'tapfiliate',
	          landingSourceName: checkTapfilliateRefernce
	        });
	        localStorage.setItem('landingSource', 'tapfiliate');
	      }
	
	      localStorage.setItem('landingSourceName', checkTapfilliateRefernce ? checkTapfilliateRefernce : null);
	      /*
	      -------------------------------
	      Pixel Integration code end
	      -------------------------------    
	      */
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      if (!storage_session) {
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper' },
	            _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/logo1.png', alt: '', width: '200' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-12 col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-group mb-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card p-2  ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Select Exam'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'text-muted' },
	                    'Fill Your Details'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    {
	                      className: this.state.message_background + ' ' + this.state.displaytext,
	                      style: {
	                        paddingTop: 4 + 'px',
	                        paddingBottom: 4 + 'px',
	                        paddingLeft: 10 + 'px',
	                        fontSize: 14 + 'px'
	                      }
	                    },
	                    this.state.message
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group mb-1' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-addon-social-registration' },
	                      _react2.default.createElement('i', { className: 'fa fa-book' })
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-control', id: 'exam_field' },
	                      [{ value: '', label: _language2.default.LC().SELECT_EXAM }].concat(_toConsumableArray((0, _constant.CFAExamList)()), _toConsumableArray(_constant.FRMExamList), _toConsumableArray(_constant.ActuarialExamList), _toConsumableArray(_constant.GMATExamList)).map(function (_ref) {
	                        var value = _ref.value,
	                            label = _ref.label;
	                        return _react2.default.createElement(
	                          'option',
	                          { key: value, value: value },
	                          label
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          style: { width: 100 + '%' },
	                          className: 'btn btn-primary',
	                          onClick: this.saveExam
	                        },
	                        'Save'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_signUpApproval2.default, {
	          signUpAlertModel: this.signUpAlertModel.bind(this),
	          signUpAlertModelClose: this.signUpAlertModelClose.bind(this),
	          signupAlert: this.state.signupAlert
	        }),
	        _react2.default.createElement(
	          'blockquote',
	          { className: 'footer-blockquote' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().FOOTER_MESSAGE
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'ml-1' },
	            _react2.default.createElement(
	              'a',
	              { href: 'https://analystprep.com/privacy/', target: '_blank', className: 'privacy-policy' },
	              _language2.default.LC().Privacy_Policy
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Selectexam;
	}(_react.Component);
	
	exports.default = Selectexam;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unsubscribe = function (_Component) {
	  _inherits(Unsubscribe, _Component);
	
	  function Unsubscribe(props) {
	    _classCallCheck(this, Unsubscribe);
	
	    var _this = _possibleConstructorReturn(this, (Unsubscribe.__proto__ || Object.getPrototypeOf(Unsubscribe)).call(this, props));
	
	    _this.state = {
	      email: "",
	      send_notification: "",
	      message_background: "bg-danger",
	      displaytext: "hide_block",
	      isSend: false
	    };
	    _this.settingChanged = _this.settingChanged.bind(_this);
	    return _this;
	  }
	
	  _createClass(Unsubscribe, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var parsed = this.props.location.query;
	      if (parsed.email) {
	        this.setState({
	          email: parsed.email
	        });
	      }
	    }
	  }, {
	    key: "settingChanged",
	    value: function settingChanged() {
	      var _this2 = this;
	
	      if (document.getElementById("verification").value === "") {
	        this.setState({ displaytext: "show_block" });
	        this.setState({ message: "This field is required" });
	        return;
	      } else {
	        if (document.getElementById("verification").value === "false") {
	          this.context.router.push("/");
	          return;
	        }
	        var data = {
	          email: this.state.email,
	          send_notification: false
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + "/user/updateUnsubscribe", data).then(function (resp) {
	          if (resp.success) {
	            _this2.setState({
	              isSend: true
	            });
	          } else {
	            console.log("fails");
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var isSend = this.state.isSend;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper" },
	            _react2.default.createElement("img", {
	              src: _App_data2.default.frontend_url + "/img/logo1.png",
	              alt: "",
	              width: "200"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row justify-content-center" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12 col-sm-12 col-md-6 col-lg-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-group mb-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "card p-2  " },
	                !isSend ? _react2.default.createElement(
	                  "div",
	                  { className: "card-block" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    "Unsubscribe"
	                  ),
	                  _react2.default.createElement(
	                    "h6",
	                    { className: " text-center" },
	                    "Are you sure?"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "", style: { color: "rgb(42, 59, 78)" } },
	                    "Do you want to unsubscribe from email notifications."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mb-1" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-addon-social-registration" },
	                      _react2.default.createElement("i", { className: "fa fa-cog" })
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", id: "verification" },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "Select setting"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: true },
	                        _language2.default.LC().YES
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: false },
	                        " ",
	                        _language2.default.LC().NO
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    {
	                      className: this.state.displaytext,
	                      style: {
	                        color: "#f86c6b"
	                      }
	                    },
	                    this.state.message,
	                    "*"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: { width: 100 + "%" },
	                          className: "btn btn-primary",
	                          onClick: this.settingChanged
	                        },
	                        "Save"
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "card-block" },
	                  " ",
	                  _react2.default.createElement("img", {
	                    src: _App_data2.default.frontend_url + "/img/success-ic.svg",
	                    className: "margin_bottom_30  unsubscribe-image",
	                    alt: ""
	                  }),
	                  _react2.default.createElement(
	                    "h6",
	                    { className: " text-center" },
	                    " Successfully Unsubscribed"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "", style: { color: "rgb(42, 59, 78)" } },
	                    "You successfully unsubscribed from the email notifications and should not receive future app email notifications."
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "", style: { color: "rgb(42, 59, 78)" } },
	                    "If you interested to receive this in the future then navigate into the profile section and activate the email notifications."
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: { width: 100 + "%" },
	                          className: "btn btn-primary",
	                          onClick: function onClick() {
	                            return _this3.context.router.push("/");
	                          }
	                        },
	                        "Go to App"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Unsubscribe;
	}(_react.Component);
	
	Unsubscribe.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Unsubscribe;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PremiumCheckout = function (_Component) {
	    _inherits(PremiumCheckout, _Component);
	
	    function PremiumCheckout() {
	        _classCallCheck(this, PremiumCheckout);
	
	        return _possibleConstructorReturn(this, (PremiumCheckout.__proto__ || Object.getPrototypeOf(PremiumCheckout)).apply(this, arguments));
	    }
	
	    _createClass(PremiumCheckout, [{
	        key: "render",
	        value: function render() {
	            var validRender = _react2.default.createElement(
	                "div",
	                { className: "row" },
	                " "
	            );
	            return validRender;
	        }
	    }]);
	
	    return PremiumCheckout;
	}(_react.Component);
	
	exports.default = PremiumCheckout;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(1137);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _ProfileInfo = __webpack_require__(856);
	
	var _ProfileInfo2 = _interopRequireDefault(_ProfileInfo);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.onFileChange = function (files) {
	      var file = files[0];
	      if (!file) return;
	      var avatarURL = URL.createObjectURL(file);
	      _this.setState({ avatarURL: avatarURL, avatarData: file });
	    };
	
	    _this._subscriptionDetails = function (event) {
	      var recurringPayment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var username = _this.state.username;
	
	      if (_this.props.params.username && _this.props.params.username !== username) {
	        username = _this.props.params.username;
	        _this.setState({
	          username: username
	        });
	      }
	      var pathname = '/subscriptiondetail/' + localStorage.getItem('selectedmenu') + '/' + username;
	      if (recurringPayment) {
	        pathname = _AppRoutes2.default.RECURRING_PLAN_DETAILS.replace('(/:selectedMenu)', '/' + localStorage.getItem('selectedmenu')).replace('(/:username)', '/' + username);
	      }
	      _this.context.router.push({
	        pathname: pathname,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: localStorage.getItem('selectedmenu'),
	          username: _this.state.username
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      avatarData: '',
	      avatarURL: '',
	      token: '',
	      idname: '',
	      email: '',
	      userName: '',
	      ValidToken: false,
	      pastPassword: '',
	      social: false,
	      examData: '',
	      selected_language: '',
	      dropdownOpen: false,
	      username: '',
	      user_id: '',
	      url: '',
	      noOfComments: '',
	      noOfPosts: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggleAlertvalidation = _this.toggleAlertvalidation.bind(_this);
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(prevProps, prevState) {
	        var u, r, url;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(prevProps.route.path !== this.props.route.path)) {
	                  _context.next = 7;
	                  break;
	                }
	
	                window.scrollTo(0, 0);
	                u = window.location.href;
	                r = u.split('/');
	                url = r[4];
	                _context.next = 7;
	                return this.setState({ url: url });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidUpdate(_x2, _x3) {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var storage_session, u, r, url, username, un, user_id, data, userProfile;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                u = window.location.href;
	                r = u.split('/');
	                url = r[4];
	                _context2.next = 8;
	                return this.setState({ url: url });
	
	              case 8:
	                username = this.props.params.username;
	                un = u.split('-');
	                user_id = un[un.length - 1];
	                _context2.next = 13;
	                return this.setState({ user_id: user_id, username: username });
	
	              case 13:
	                // console.log(username)
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then((resp) => {
	
	                _context2.next = 16;
	                return _userStore2.default.getUserProfile();
	
	              case 16:
	                userProfile = _context2.sent;
	
	                if (userProfile) {
	                  this.setState({ ValidToken: true });
	                  if (userProfile.imageUrl == '' || userProfile.imageUrl == undefined) {
	                    this.setState({
	                      avatarURL: _App_data2.default.frontend_url + '/img/avatars/defaultProfileImage.jpg'
	                    });
	                  } else {
	                    this.setState({ avatarURL: userProfile.imageUrl });
	                  }
	                  this.setState({
	                    userName: userProfile.username,
	                    email: userProfile.email,
	                    examDate: userProfile.exam,
	                    examLocation: userProfile.location,
	                    pastPassword: userProfile.password,
	                    social: userProfile.isSocial,
	                    age: userProfile.age,
	                    occupation: userProfile.occupation,
	                    education: userProfile.education,
	                    profileStatus: userProfile.isProfilePrivate,
	                    selected_language: userProfile.selected_language ? userProfile.selected_language : 'EN'
	                  });
	                  // localStorage.getItem('domainApp') === 'WORLD';
	                } else {
	                  this.setState({ ValidToken: false });
	                }
	                // return resp;
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: '_getAllDiscussions',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.context.router.push({
	                  pathname: '/profile/discussions/' + this.state.username,
	                  state: {
	                    token: this.state.token,
	                    idname: this.state.idname,
	                    user_id: this.state.user_id
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function _getAllDiscussions() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return _getAllDiscussions;
	    }()
	  }, {
	    key: '_getAllComments',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.context.router.push({
	                  pathname: '/profile/comments/' + this.state.username,
	                  state: {
	                    token: this.state.token,
	                    idname: this.state.idname,
	                    user_id: this.state.user_id
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function _getAllComments() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return _getAllComments;
	    }()
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert() {}
	  }, {
	    key: 'toggleAlertvalidation',
	    value: function toggleAlertvalidation() {}
	  }, {
	    key: 'changePassword',
	    value: function changePassword() {
	      var username = this.state.username;
	
	      if (this.props.params.username && this.props.params.username !== username) {
	        username = this.props.params.username;
	        this.setState({
	          username: username
	        });
	      }
	      if (this.state.pastPassword === null || this.state.pastPassword === '') {
	        this.context.router.push({
	          pathname: '/setpassword/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            selectedMenu: localStorage.getItem('selectedmenu')
	          }
	        });
	      } else {
	        this.context.router.push({
	          pathname: '/changepassword/' + localStorage.getItem('selectedmenu') + '/' + username,
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            selectedMenu: localStorage.getItem('selectedmenu'),
	            username: this.state.username
	          }
	        });
	      }
	    }
	  }, {
	    key: '_savedQuestion',
	    value: function _savedQuestion() {
	      if (localStorage.getItem('selectedmenu') === 'frm') {
	        this.context.router.push({
	          pathname: '/frmsavedquestion/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            selectedMenu: 'frm',
	            username: this.state.username
	          }
	        });
	      }
	      if (localStorage.getItem('selectedmenu') === 'cfa') {
	        this.context.router.push({
	          pathname: '/cfasavedquestion/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            username: this.state.username
	          }
	        });
	      }
	      if (localStorage.getItem('selectedmenu') === 'cfa_2') {
	        this.context.router.push({
	          pathname: '/cfa2_savedquestion/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            username: this.state.username
	          }
	        });
	      }
	      if (localStorage.getItem('selectedmenu') === 'cfa_3') {
	        this.context.router.push({
	          pathname: '/cfa3_savedquestion/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            username: this.state.username
	          }
	        });
	      }
	      if (localStorage.getItem('selectedmenu') === 'soa_p') {
	        this.context.router.push({
	          pathname: '/soa/probability/savedquestion/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            username: this.state.username
	          }
	        });
	      }
	      if (localStorage.getItem('selectedmenu') === 'soa_fm') {
	        this.context.router.push({
	          pathname: '/soa/financialmathematics/savedquestion/',
	          state: {
	            token: this.state.token,
	            idname: this.state.idname,
	            username: this.state.username
	          }
	        });
	      }
	    }
	  }, {
	    key: '_orderHistory',
	    value: function _orderHistory() {
	      var username = this.state.username;
	
	      if (this.props.params.username && this.props.params.username !== username) {
	        username = this.props.params.username;
	        this.setState({
	          username: username
	        });
	      }
	      this.context.router.push({
	        pathname: '/orderhistory/' + localStorage.getItem('selectedmenu') + '/' + username,
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: localStorage.getItem('selectedmenu'),
	          username: this.state.username
	        }
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var changepassword_var = '';
	      {
	        if (this.state.pastPassword === null || this.state.pastPassword === '') {
	          changepassword_var = _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'margin_bottom_20 btn_full_width btn btn-primary pointer_class',
	              onClick: this.changePassword.bind(this)
	            },
	            _language2.default.LC().SET_PASSWORD
	          );
	        } else if (this.state.pastPassword !== null) {
	          changepassword_var = _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'margin_bottom_20 btn_full_width btn btn-primary pointer_class',
	              onClick: this.changePassword.bind(this)
	            },
	            _language2.default.LC().CHANGE_PASSWORD
	          );
	        }
	      }
	
	      var validRender = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12' },
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              { toggle: this.toggleAlert },
	              this.state.MessageTitle
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              this.state.MessageContent
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlertvalidation,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              { toggle: this.toggleAlertvalidation },
	              this.state.MessageTitle
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              this.state.MessageContent
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row frm-profile-wraps' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6 col-lg-4 col-xl-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_0' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 align-self-center text-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'profile_img_wrap' },
	                        _react2.default.createElement(
	                          _reactDropzone2.default,
	                          {
	                            style: { cursor: 'pointer', border: 'none' },
	                            multiple: false,
	                            accept: 'image/*',
	                            onDrop: this.onFileChange
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'profile-img-update-wrap' },
	                            _react2.default.createElement('div', {
	                              className: 'profile-img',
	                              style: {
	                                backgroundImage: 'url(' + this.state.avatarURL + ')'
	                              }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'camera_wrapper' },
	                            _react2.default.createElement('img', {
	                              src: _App_data2.default.frontend_url + '/img/profile/plus_sm_ico.png',
	                              className: '',
	                              alt: ''
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'h6',
	                          null,
	                          this.state.userName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'profile_link_wrapper profilebtnHover' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'margin_bottom_20' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'blue_btn',
	                              onClick: this._orderHistory.bind(this)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-shopping-bag me-2' }),
	                            ' ',
	                            _language2.default.LC().ORDER_HISTORY
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'margin_bottom_20' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'blue_btn',
	                              onClick: function onClick(e) {
	                                return _this2._subscriptionDetails(e);
	                              }
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-credit-card me-2' }),
	                            ' ',
	                            _language2.default.LC().SUBSCRIPTION_DETAIL
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'margin_bottom_20' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'blue_btn',
	                              onClick: function onClick(e) {
	                                return _this2._subscriptionDetails(e, true);
	                              }
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-calendar me-2' }),
	                            ' ',
	                            _language2.default.LC().MONTHLY_SUBSCRIPTION_DETAIL
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'change_password_wrapper' },
	                        ' ',
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'margin_bottom_20 btn_full_width btn btn-primary pointer_class',
	                            onClick: this.changePassword.bind(this)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-key me-2' }),
	                          ' ',
	                          _language2.default.LC().CHANGE_PASSWORD
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_ProfileInfo2.default, {
	              props: this.props,
	              user_id: this.state.user_id,
	              avatarData: this.state.avatarData,
	              setIsChildChangedTrue: this.props.setIsChildChangedTrue
	            })
	          )
	        )
	      );
	      if (this.state.ValidToken) return validRender;else return _react2.default.createElement(_loader2.default, null);
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	Profile.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Profile;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _axios = __webpack_require__(102);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _function = __webpack_require__(10);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _constant = __webpack_require__(9);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileInfo = function (_Component) {
	  _inherits(ProfileInfo, _Component);
	
	  function ProfileInfo() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProfileInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileInfo.__proto__ || Object.getPrototypeOf(ProfileInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      alert_status: false,
	      avatarData: '',
	      avatarURL: '',
	      token: '',
	      idname: '',
	      email: '',
	      userName: '',
	      age: '',
	      occupation: '',
	      education: '',
	      ValidToken: false,
	      send_notification: '',
	      user_id: '',
	      username: '',
	      toggleActive: false,
	      storage_session: [],
	      dropdownOpen: false,
	      isLoading: true,
	      isShowDeleteConfirmationModal: false,
	      role: '',
	      subscriptionDetails: [],
	      isLoadingUpdateProfile: false
	    }, _this.handleInputChange = function (field) {
	      return function (e) {
	        var value = e.target.value;
	
	        if (field === 'age' && (isNaN(value) || value < 0)) return;
	        _this.setState(_defineProperty({}, field, value));
	      };
	    }, _this.updateProfile = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, userName, email, age, occupation, education, avatarData, send_notification, idname, token, profilePayload, formData, resp, data, _resp;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, userName = _this$state.userName, email = _this$state.email, age = _this$state.age, occupation = _this$state.occupation, education = _this$state.education, avatarData = _this$state.avatarData, send_notification = _this$state.send_notification, idname = _this$state.idname, token = _this$state.token;
	
	              _this.setState({ isLoadingUpdateProfile: true });
	              profilePayload = {
	                userName: userName,
	                email: email,
	                age: age,
	                occupation: occupation,
	                education: education,
	                file: avatarData,
	                send_notification: send_notification,
	                idname: idname
	              };
	
	              if (!avatarData) {
	                _context.next = 18;
	                break;
	              }
	
	              formData = new FormData();
	
	              Object.entries(profilePayload).forEach(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    k = _ref4[0],
	                    v = _ref4[1];
	
	                return formData.append(k, v);
	              });
	
	              _context.prev = 6;
	              _context.next = 9;
	              return _axios2.default.post(_App_data2.default.backend_api + '/user/updateProfile', formData, {
	                headers: { Authorization: token }
	              });
	
	            case 9:
	              resp = _context.sent;
	
	              if (resp.data.success) {
	                (0, _toast.showSuccess)(_language2.default.LC().PROFILE_SUCCESSFULLY_UPDATED);
	                _this.props.setIsChildChangedTrue(true);
	                _this.setState({ isLoadingUpdateProfile: false }, function () {
	                  _userStore2.default.fetchProfile();
	                });
	              } else {
	                _this.setState({ isLoadingUpdateProfile: false });
	                (0, _toast.showFailure)(_language2.default.LC().UPDATE_FAILED);
	              }
	              _context.next = 16;
	              break;
	
	            case 13:
	              _context.prev = 13;
	              _context.t0 = _context['catch'](6);
	
	              (0, _toast.showFailure)(_language2.default.LC().UPDATE_FAILED);
	
	            case 16:
	              _context.next = 23;
	              break;
	
	            case 18:
	              data = {
	                token: _this.state.token,
	                idname: idname,
	                newProfile: {
	                  userName: userName,
	                  email: email,
	                  age: age,
	                  occupation: occupation,
	                  education: education,
	                  send_notification: send_notification
	                }
	              };
	              _context.next = 21;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/updateProfiledata', data);
	
	            case 21:
	              _resp = _context.sent;
	
	              if (_resp.success) {
	                (0, _toast.showSuccess)(_language2.default.LC().PROFILE_SUCCESSFULLY_UPDATED);
	                _this.setState({ isLoadingUpdateProfile: false });
	                _this.props.setIsChildChangedTrue(true);
	              } else {
	                _this.setState({ isLoadingUpdateProfile: false });
	                (0, _toast.showFailure)(_language2.default.LC().UPDATE_FAILED);
	              }
	
	            case 23:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[6, 13]]);
	    })), _this.deleteAccount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state2, token, user_id, role, idname, subscriptionDetails, data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref6, subscriptionId, subscriptionScheduleId, cancelledSubscription, package_id, cancelPayload, resp;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state2 = _this.state, token = _this$state2.token, user_id = _this$state2.user_id, role = _this$state2.role, idname = _this$state2.idname, subscriptionDetails = _this$state2.subscriptionDetails;
	
	              _this.deleteAccountToggle();
	
	              data = { token: token, idname: idname, id: user_id, role: role };
	
	              // Cancel subscriptions if any
	
	              if (!(subscriptionDetails && subscriptionDetails.length)) {
	                _context2.next = 33;
	                break;
	              }
	
	              _iteratorNormalCompletion = true;
	              _didIteratorError = false;
	              _iteratorError = undefined;
	              _context2.prev = 7;
	              _iterator = subscriptionDetails[Symbol.iterator]();
	
	            case 9:
	              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                _context2.next = 19;
	                break;
	              }
	
	              _ref6 = _step.value;
	              subscriptionId = _ref6.subscriptionId, subscriptionScheduleId = _ref6.subscriptionScheduleId, cancelledSubscription = _ref6.cancelledSubscription, package_id = _ref6.package_id;
	
	              if (!((subscriptionId || subscriptionScheduleId) && !cancelledSubscription)) {
	                _context2.next = 16;
	                break;
	              }
	
	              cancelPayload = {
	                token: token,
	                idname: idname,
	                subscriptionId: subscriptionId,
	                subscriptionScheduleId: subscriptionScheduleId,
	                package_id: package_id
	              };
	              _context2.next = 16;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/cancelSubscription', cancelPayload);
	
	            case 16:
	              _iteratorNormalCompletion = true;
	              _context2.next = 9;
	              break;
	
	            case 19:
	              _context2.next = 25;
	              break;
	
	            case 21:
	              _context2.prev = 21;
	              _context2.t0 = _context2['catch'](7);
	              _didIteratorError = true;
	              _iteratorError = _context2.t0;
	
	            case 25:
	              _context2.prev = 25;
	              _context2.prev = 26;
	
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	
	            case 28:
	              _context2.prev = 28;
	
	              if (!_didIteratorError) {
	                _context2.next = 31;
	                break;
	              }
	
	              throw _iteratorError;
	
	            case 31:
	              return _context2.finish(28);
	
	            case 32:
	              return _context2.finish(25);
	
	            case 33:
	              _context2.next = 35;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/accountDelete', data);
	
	            case 35:
	              resp = _context2.sent;
	
	              if (!resp.success) {
	                _context2.next = 40;
	                break;
	              }
	
	              _context2.next = 39;
	              return (0, _toast.showSuccess)(_language2.default.LC().ACCOUNT_DELETED_SUCCESSFULLY);
	
	            case 39:
	              _this.clearLocalStorage();
	
	            case 40:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[7, 21, 25, 33], [26,, 28, 32]]);
	    })), _this.toggle = function () {
	      return _this.setState(function (s) {
	        return { dropdownOpen: !s.dropdownOpen };
	      });
	    }, _this.deleteAccountToggle = function () {
	      return _this.setState(function (pre) {
	        return { isShowDeleteConfirmationModal: !pre.isShowDeleteConfirmationModal };
	      });
	    }, _this.clearLocalStorage = function () {
	      [_constant.localStorageKeys.userTokenAndEmail, _constant.localStorageKeys.selectedLanguage, _constant.localStorageKeys.selectedMenu, _constant.localStorageKeys.loginId, 'userData', 'landingSource'].forEach(function (key) {
	        return localStorage.removeItem(key);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProfileInfo, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.isProfilePrivate !== this.state.isProfilePrivate) {
	        this.setState({
	          profileStatus: this.state.isProfilePrivate === 'private' ? 'Private' : 'Public'
	        });
	      }
	      if (prevProps.avatarData !== this.props.avatarData) {
	        this.setState({ avatarData: this.props.avatarData });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var storage_session, _storage_session$idna, idname, _storage_session$toke, token, urlParts, user_id, username, resp, subscription_details, imageUrl, userName, email, age, occupation, education, role, send_notification;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval')) || {};
	                _storage_session$idna = storage_session.idname, idname = _storage_session$idna === undefined ? '' : _storage_session$idna, _storage_session$toke = storage_session.token, token = _storage_session$toke === undefined ? '' : _storage_session$toke;
	                urlParts = window.location.href.split('-');
	                user_id = urlParts[urlParts.length - 1];
	                username = this.props.props.params.username;
	
	
	                this.setState({ storage_session: storage_session, idname: idname, token: token, user_id: user_id, username: username });
	
	                _context3.prev = 6;
	                _context3.next = 9;
	                return _userStore2.default.getUserProfile();
	
	              case 9:
	                resp = _context3.sent;
	
	                if (resp != null) {
	                  subscription_details = resp.subscription_details, imageUrl = resp.imageUrl, userName = resp.username, email = resp.email, age = resp.age, occupation = resp.occupation, education = resp.education, role = resp.role, send_notification = resp.send_notification;
	
	
	                  this.setState({
	                    ValidToken: true,
	                    subscriptionDetails: subscription_details ? JSON.parse(subscription_details) : [],
	                    avatarURL: imageUrl || '../img/avatars/defaultProfileImage.jpg',
	                    userName: userName,
	                    email: email,
	                    age: age,
	                    occupation: occupation,
	                    education: education,
	                    isLoading: false,
	                    role: role,
	                    send_notification: send_notification
	                  });
	                } else {
	                  this.setState({ ValidToken: false });
	                }
	                _context3.next = 16;
	                break;
	
	              case 13:
	                _context3.prev = 13;
	                _context3.t0 = _context3['catch'](6);
	
	                this.setState({ ValidToken: false });
	
	              case 16:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[6, 13]]);
	      }));
	
	      function componentDidMount() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          userName = _state.userName,
	          email = _state.email,
	          age = _state.age,
	          occupation = _state.occupation,
	          education = _state.education,
	          send_notification = _state.send_notification,
	          isLoadingUpdateProfile = _state.isLoadingUpdateProfile;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12 col-md-6 col-lg-8 col-xl-9' },
	        isLoading && _react2.default.createElement(_loader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'card minHeight-card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header font-16 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('i', { className: 'fa fa-users me-2' }),
	              ' ',
	              _language2.default.LC().PROFILE_INFO
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form_wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 col-lg-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form_field' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _language2.default.LC().NAME
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement('i', { className: 'fa fa-user' })
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        className: 'form-control',
	                        placeholder: _language2.default.LC().USERNAME,
	                        value: userName,
	                        onChange: this.handleInputChange('userName'),
	                        maxLength: 30
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 col-lg-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form_field' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _language2.default.LC().EMAIL
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement('i', { className: 'fa fa-envelope' })
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'email',
	                        className: 'form-control',
	                        value: email,
	                        disabled: true,
	                        onChange: this.handleInputChange('email')
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 col-lg-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form_field' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _language2.default.LC().AGE
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement('i', { className: 'fa fa-user' })
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        className: 'form-control',
	                        value: age || '',
	                        onChange: this.handleInputChange('age'),
	                        maxLength: 3
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 col-lg-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form_field' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _language2.default.LC().OCCUPATION
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement('i', { className: 'fa fa-briefcase' })
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        className: 'form-control',
	                        value: occupation || '',
	                        onChange: this.handleInputChange('occupation'),
	                        maxLength: 40
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 col-lg-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form_field' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _language2.default.LC().EDUCATION
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement('i', { className: 'fa fa-graduation-cap' })
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        className: 'form-control',
	                        value: education || '',
	                        onChange: this.handleInputChange('education'),
	                        maxLength: 40
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 col-lg-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form_field' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      _language2.default.LC().SEND_NOTIFICATIONS_VIA_EMAIL
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement('i', { className: 'fa fa-cog' })
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          className: 'form-control',
	                          value: send_notification,
	                          onChange: this.handleInputChange('send_notification')
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: true },
	                          _language2.default.LC().YES
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: false },
	                          _language2.default.LC().NO
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-danger account-delete pointer_class pull-right',
	                    onClick: this.deleteAccountToggle
	                  },
	                  _language2.default.LC().ACCOUNT_DELETE
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-primary pointer_class pull-right',
	                    onClick: this.updateProfile,
	                    disabled: isLoadingUpdateProfile
	                  },
	                  isLoadingUpdateProfile ? _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }) : null,
	                  ' ',
	                  _language2.default.LC().UPDATE_PROFILE
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.isShowDeleteConfirmationModal,
	            toggle: this.deleteAccountToggle,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ACCOUNT_DELETE_ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.deleteAccountToggle },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { style: { color: 'red' } },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS_ACCOUNT
	                )
	              ),
	              (0, _function.renderHTMLContent)('<strong>Please Note: </strong> This will <span style=\'color: #f86c6b;font-weight: bold;\'>permanently</span> delete your account including all your data.<br/>\n                <p>Your subscriptions/packages will be <span style=\'color: #f86c6b;font-weight: bold;\'>automatically cancelled</span>.', 'p'),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { color: 'primary', onClick: this.deleteAccount },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileInfo;
	}(_react.Component);
	
	ProfileInfo.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = ProfileInfo;

/***/ },
/* 857 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkEAQuizSubscriptionPartner = function checkEAQuizSubscriptionPartner(selectedLevel, exam_data) {
	  console.log('checking----------------------->', exam_data, selectedLevel);
	  var flag = false;
	  for (var i = 0; i < exam_data.length; i++) {
	    // console.log("1");
	
	    if (exam_data[i].exam_name === selectedLevel) {
	      // console.log("2");
	      if (exam_data[i].levels.length) {
	        for (var j = 0; j < exam_data[i].levels.length; j++) {
	          if (exam_data[i].levels[j].package_id === 51) {
	            flag = false;
	          }
	          if (exam_data[i].levels[j].package_id === 52) {
	            flag = true;
	          }
	          if (exam_data[i].levels[j].package_id === 53) {
	            flag = true;
	          }
	        }
	      } else {
	        // console.log("6");
	        flag = false;
	      }
	      // break;
	    } else {
	      flag = false;
	    }
	  }
	
	  return flag;
	};
	exports.default = checkEAQuizSubscriptionPartner;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var SOA_FM_BeforeStart = function (_Component) {
	  _inherits(SOA_FM_BeforeStart, _Component);
	
	  function SOA_FM_BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_BeforeStart.__proto__ || Object.getPrototypeOf(SOA_FM_BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/quizzes',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuizpage = function () {
	      var final_exam = [];
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	          var data_arr, dataset;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (!(resp.profileInfo.role === 'partner')) {
	                    _context3.next = 11;
	                    break;
	                  }
	
	                  if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                    _context3.next = 5;
	                    break;
	                  }
	
	                  _this.toggleAlert();
	                  _context3.next = 9;
	                  break;
	
	                case 5:
	                  data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  dataset = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    examid: data_arr
	                  };
	                  _context3.next = 9;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var;
	                      return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context.next = 10;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this.state.selectedmenu;
	                              isInArray_var = false;
	                              _context.next = 6;
	                              return _SoaFMSubscription4.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                            case 6:
	                              isInArray_var = _context.sent;
	
	                              if (isInArray_var) {
	                                _this.context.router.push({
	                                  pathname: '/soa/financialmathematics/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                  state: {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    quiz_id: _this.state.quiz_id,
	                                    offset: _this.state.offset_send
	                                  }
	                                });
	                              } else {
	                                _this.toggleAlert();
	                              }
	                              _context.next = 10;
	                              break;
	
	                            case 10:
	                            case 'end':
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x2) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }()
	                  // console.log('fail');
	                  );
	
	                case 9:
	                  _context3.next = 19;
	                  break;
	
	                case 11:
	                  if (!(resp.profileInfo.exam_selected == '')) {
	                    _context3.next = 15;
	                    break;
	                  }
	
	                  _this.toggleAlert();
	                  _context3.next = 19;
	                  break;
	
	                case 15:
	                  data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  dataset = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    examid: data_arr
	                  };
	                  _context3.next = 19;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var;
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context2.next = 10;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this.state.selectedmenu;
	                              isInArray_var = false;
	                              _context2.next = 6;
	                              return _SoaFMSubscription2.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                            case 6:
	                              isInArray_var = _context2.sent;
	
	                              if (isInArray_var) {
	                                _this.context.router.push({
	                                  pathname: '/soa/financialmathematics/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                  state: {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    quiz_id: _this.state.quiz_id,
	                                    offset: _this.state.offset_send
	                                  }
	                                });
	                              } else {
	                                _this.toggleAlert();
	                              }
	                              _context2.next = 10;
	                              break;
	
	                            case 10:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }()
	                  // console.log('fail');
	                  );
	
	                case 19:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this._startQuizquestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(item, offset_va, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context4.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context4.next = 6;
	                                        return _SoaFMSubscription4.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                                      case 6:
	                                        isInArray_var = _context4.sent;
	
	                                        if (isInArray_var) {
	                                          _this.context.router.push({
	                                            pathname: '/soa/financialmathematics/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	
	                                            state: {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              quiz_id: _this.state.quiz_id,
	                                              offset: offset_va
	                                            }
	                                          });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context4.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref6.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 9:
	                            _context6.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected == '')) {
	                              _context6.next = 15;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _SoaFMSubscription2.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          _this.context.router.push({
	                                            pathname: '/soa/financialmathematics/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                                            state: {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              quiz_id: _this.state.quiz_id,
	                                              offset: offset_va
	                                            }
	                                          });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x4, _x5, _x6) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_soa_fm,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'soa_fm'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_FM_BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    //Function to redirect page to Create Quiz page
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    //Function to redirect page to begin Quiz page
	
	
	    //Function to redirect page to begin Quiz page
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	
	          var question_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	          }
	          var minutes = resp.timer_value / 60;
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count
	          });
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	        return resp;
	      });
	      //Api to fetch all right answered on particular quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          console.log(resp_count.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var all_question_id = this.state.all_question_id;
	      var question_id_display = '';
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                quiz_id: _this4.state.quiz_id,
	                answered_state: index
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  onClick: _this4._startQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	      var user_time = '';
	      var min,
	          sec = '';
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary pointer_class',
	            onClick: this._startQuizpage.bind(this)
	          },
	          ' ',
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary pointer_class',
	            onClick: this._startQuizpage.bind(this)
	          },
	          ' ',
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().QUIZ_ID,
	            ': ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ',',
	                  ' ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().NO_ANSWER
	                          ),
	                          _react2.default.createElement('span', {
	                            id: 'quiz_notanswered_status',
	                            className: 'margin_right_60'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().CORRECT_ANSWER
	                          ),
	                          _react2.default.createElement('span', {
	                            id: 'quiz_answered_status',
	                            className: 'margin_right_60'
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().WRONG_ANSWER
	                          ),
	                          _react2.default.createElement('span', {
	                            id: 'quiz_wrong_answered_status',
	                            className: 'margin_right_60'
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return SOA_FM_BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	SOA_FM_BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/checkAnswered', data).then(function (resp) {
	    document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer === 1) {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_wrong_answered_status';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', {
	      className: 'margin_right_20',
	      id: 'user_question_status' + props.answered_state
	    }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = SOA_FM_BeforeStart;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	// import GD from '../../../RestAPI/getData';
	
	
	/* eslint-disable*/
	var SOA_FM_Beginchapters = function (_Component) {
	  _inherits(SOA_FM_Beginchapters, _Component);
	
	  function SOA_FM_Beginchapters(props) {
	    _classCallCheck(this, SOA_FM_Beginchapters);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_Beginchapters.__proto__ || Object.getPrototypeOf(SOA_FM_Beginchapters)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      reportLoading: false,
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      // flash_form : 'col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: false,
	      timer_tag: '' + _language2.default.LC().STOP,
	      display_loader: '',
	      selectedmenu: 'soa_fm',
	      subscriptionstatus: 'free',
	      chapter_name: '',
	      isEditable: false,
	      all_questions: '',
	      category: 'Actuarial - FM(Financial Mathematics)',
	      tags: ['Financial Mathematics', 'acturial', 'exam', 'question'],
	      title: '',
	      description: '',
	      page: _this.props.params.page,
	      forumComment: '',
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      selectedChoice: '',
	      setAnswer: false,
	      showAnswer: false,
	      stopTimer: false,
	      attemptedQuestions: {}
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(SOA_FM_Beginchapters, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	
	    /*
	    -----------------------------------------
	      Function to change, time every second
	    ----------------------------------------
	    */
	
	  }, {
	    key: '_tick',
	    value: function _tick() {
	      var timer_stop = this.state.timer_stop;
	
	      if (!timer_stop) {
	        this.setState(function (prevState) {
	          return {
	            count: prevState.count + 1
	          };
	        });
	      }
	    }
	
	    /*
	    -----------------------------------------------
	      Function to redirect page to readings page
	    -----------------------------------------------
	    */
	
	
	    /*
	    ---------------------------------------
	      Function to toggle Comment box
	    ---------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------  
	    */
	
	
	    /*
	    ------------------------------------------
	      Function to fetch previous question
	    ------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to fetch Next question
	    ------------------------------------
	      */
	
	
	    /*
	    ------------------------------------------------------------------------
	      Function to check Right Or Wrong Answered and displayed clicked box
	    ------------------------------------------------------------------------
	    */
	
	
	    /*
	    --------------------------------
	      Function to hide Report box
	    --------------------------------
	      */
	
	
	    /*
	    -------------------------------------------------------------------------------
	      Function to show Correct box and display right answer and store in database
	    -------------------------------------------------------------------------------
	    */
	
	
	    /*
	    ----------------------------------------------------------------------
	      Function to Display Saved Question on button and save in database
	    ----------------------------------------------------------------------
	      */
	
	    /*
	    ------------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    ------------------------------------------------------------------
	      */
	
	
	    /*
	    -----------------------------------------
	      Funcion to save new report question
	    -----------------------------------------
	    */
	
	    /*
	    -------------------------------
	      Function to Edit Flash card
	    -------------------------------
	      */
	
	
	    /*
	    -----------------------------------
	      Function to delete flash card
	    -----------------------------------
	      */
	
	
	    /*
	    ---------------------------------
	      Function to give star rattings
	    ---------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var result, storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                window.scrollTo(0, 0);
	
	                // Clear any existing timer first
	                if (this.timer) {
	                  clearInterval(this.timer);
	                  this.timer = null;
	                }
	
	                // Initialize timer state
	                this.setState({
	                  count: 0,
	                  timer_stop: true,
	                  timer_tag: 'Start',
	                  timerstopbtn: 'pause_btn icon-control-play'
	                });
	
	                // api to get ip address
	                _context.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	
	                user_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this2._runCode('free');
	                      _this2.setState({ subscriptionstatus: 'free' });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this2.state.selectedmenu;
	                          var isInArray_var = false;
	                          isInArray_var = _SoaFMSubscription4.default.checkSoaFMSubscription(selectedmen, exam_data);
	                          if (isInArray_var) {
	                            _this2._runCode('paid');
	                            _this2.setState({ subscriptionstatus: 'paid' });
	                          } else {
	                            _this2._runCode('free');
	                            _this2.setState({ subscriptionstatus: 'free' });
	                          }
	                        }
	                      });
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      _this2._runCode('free');
	                      _this2.setState({ subscriptionstatus: 'free' });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this2.state.selectedmenu;
	                          var isInArray_var = false;
	                          isInArray_var = _SoaFMSubscription2.default.checkSoaFMSubscription(selectedmen, exam_data);
	                          if (isInArray_var) {
	                            _this2._runCode('paid');
	                            _this2.setState({ subscriptionstatus: 'paid' });
	                          } else {
	                            _this2._runCode('free');
	                            _this2.setState({ subscriptionstatus: 'free' });
	                          }
	                        }
	                      });
	                    }
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(prevProps, prevState) {
	        var _this3 = this;
	
	        var storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (this.props.params.page !== prevProps.params.page) {
	                  storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                  user_data = {
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this3._runCode('free');
	                        _this3.setState({ subscriptionstatus: 'free' });
	                      } else {
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                        var dataset = {
	                          token: _this3.state.token,
	                          idname: _this3.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                          var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                            var exam_data, selectedmen, isInArray_var;
	                            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                              while (1) {
	                                switch (_context2.prev = _context2.next) {
	                                  case 0:
	                                    if (!resp_exam.success) {
	                                      _context2.next = 8;
	                                      break;
	                                    }
	
	                                    exam_data = resp_exam.examData;
	                                    selectedmen = _this3.state.selectedmenu;
	                                    isInArray_var = false;
	                                    _context2.next = 6;
	                                    return _SoaFMSubscription4.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                                  case 6:
	                                    isInArray_var = _context2.sent;
	
	                                    if (isInArray_var) {
	                                      _this3._runCode('paid');
	                                      _this3.setState({ subscriptionstatus: 'paid' });
	                                    } else {
	                                      _this3._runCode('free');
	                                      _this3.setState({ subscriptionstatus: 'free' });
	                                    }
	
	                                  case 8:
	                                  case 'end':
	                                    return _context2.stop();
	                                }
	                              }
	                            }, _callee2, _this3);
	                          }));
	
	                          return function (_x3) {
	                            return _ref3.apply(this, arguments);
	                          };
	                        }());
	                      }
	                    } else {
	                      if (resp.profileInfo.exam_selected === '') {
	                        _this3._runCode('free');
	                        _this3.setState({ subscriptionstatus: 'free' });
	                      } else {
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this3.state.token,
	                          idname: _this3.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            var selectedmen = _this3.state.selectedmenu;
	                            var isInArray_var = false;
	                            isInArray_var = _SoaFMSubscription2.default.checkSoaFMSubscription(selectedmen, exam_data);
	                            if (isInArray_var) {
	                              _this3._runCode('paid');
	                              _this3.setState({ subscriptionstatus: 'paid' });
	                            } else {
	                              _this3._runCode('free');
	                              _this3.setState({ subscriptionstatus: 'free' });
	                            }
	                          }
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidUpdate(_x, _x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: '_runCode',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(subscriptionStatus) {
	        var _this4 = this;
	
	        var storageSession, _state, page, offset, _props$params, notesid, id, data;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                this.setState({ display_loader: 'show_block' });
	                // Clear any existing timer
	                clearInterval(this.timer);
	
	                storageSession = JSON.parse(localStorage.getItem('localstorageval'));
	                _state = this.state, page = _state.page, offset = _state.offset;
	                _props$params = this.props.params, notesid = _props$params.notesid, id = _props$params.id;
	                data = {
	                  idname: storageSession['idname'],
	                  token: storageSession['token'],
	                  reading_id: page,
	                  chapter_id: notesid,
	                  offset: offset,
	                  subscriptionstatus: subscriptionStatus
	                };
	                _context4.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestions_allcr', data).then(function (resp) {
	                  if (resp.success && resp.questions && resp.questions.length > 0) {
	                    _this4.setState({
	                      ValidToken: true,
	                      alert_status: false,
	                      MessageTitle: '',
	                      MessageContent: '',
	                      all_questions_state: resp.questions
	                    });
	                    var quesRes = [];
	                    var offsetRes = '';
	                    for (var i = 0; i < resp.questions.length; i++) {
	                      if (resp.questions[i].id == id) {
	                        (function () {
	                          quesRes = resp.questions[i];
	                          offsetRes = i;
	                          var currentQuestion = resp.questions[i];
	                          var selected = '';
	                          var showAnswer = false;
	                          var selectedChoice = currentQuestion['soa_fm_question_stats.selected_choice'] || '';
	                          var rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
	                          var answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
	                          var timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
	                          var correctChoiceKey = 'right_choice';
	                          if (selectedChoice && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	                            selected = selectedChoice;
	                            showAnswer = true;
	                          } else if (answerStatus && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	                            if (rightAnswer === 1) {
	                              selected = currentQuestion[correctChoiceKey];
	                              showAnswer = true;
	                            } else if (!rightAnswer) {
	                              var choices = Object.keys(currentQuestion).filter(function (key) {
	                                return key.startsWith('choice') && key !== correctChoiceKey;
	                              });
	                              selected = choices.length > 0 ? choices[0] : '';
	                              showAnswer = true;
	                            }
	                          }
	                          var isCorrect = selected === currentQuestion[correctChoiceKey];
	                          if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	                            clearInterval(_this4.timer);
	                            _this4.setState(Object.assign({
	                              timer_stop: true,
	                              timer_tag: 'Start',
	                              timerstopbtn: 'pause_btn icon-control-play',
	                              count: timeDone || _this4.state.count,
	                              selectedChoice: selected,
	                              clicked: true,
	                              showAnswer: showAnswer,
	                              stopTimer: true,
	                              setAnswer: true
	                            }, _this4.getChoices(selected, isCorrect, correctChoiceKey), {
	                              result_block: 'card show_block',
	                              text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	                              result: isCorrect ? 'CORRECT' : 'INCORRECT'
	                            }));
	                          } else {
	                            clearInterval(_this4.timer);
	                            _this4.setState({
	                              timer_stop: false,
	                              timer_tag: 'Stop',
	                              timerstopbtn: 'pause_btn icon-control-pause',
	                              count: 0,
	                              selectedChoice: '',
	                              clicked: false,
	                              showAnswer: false,
	                              stopTimer: false,
	                              setAnswer: false,
	                              result_block: 'card hide_block'
	                            });
	                            _this4.timer = setInterval(_this4._tick.bind(_this4), 1000);
	                          }
	                        })();
	                      }
	                      if (i === resp.questions.length - 1) {
	                        _this4.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this4.setState({ questions: quesRes });
	                    _this4.setState({ offset: offsetRes });
	                    _this4.setState({ question_length: resp.questions.length });
	
	                    // Update navigation states based on initial offset
	                    if (offsetRes === 0) {
	                      _this4.setState({ previ_block: 'hide_block' });
	                    } else {
	                      _this4.setState({ previ_block: '' });
	                    }
	
	                    if (offsetRes === parseInt(resp.questions.length) - 1) {
	                      _this4.setState({ next_block: 'hide_block' });
	                    } else {
	                      _this4.setState({ next_block: '' });
	                    }
	
	                    var favParams = {
	                      token: _this4.state.token,
	                      question_id: quesRes.id,
	                      idname: _this4.state.idname
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestions', favParams).then(function (response) {
	                      if (response.success) {
	                        _this4.setState({
	                          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                          bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                          bookmarkColor: 'rgb(54, 141, 84)',
	                          save_text: '' + _language2.default.LC().Question_Saved,
	                          isFlashCardHidden: false
	                        });
	                      } else {
	                        _this4.setState({ isFlashCardHidden: true });
	                      }
	                    });
	                    var ratingParams = {
	                      idname: storageSession['idname'],
	                      token: storageSession['token'],
	                      question_id: quesRes.id
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getRatting', ratingParams).then(function (response) {
	                      if (response.success) {
	                        _this4.setState({ rated: true });
	                        response.ratting.map(function (items) {
	                          _this4.setState({ rating: items.ratting });
	                          _this4.setState({ ratting_text: '' + _language2.default.LC().RATED });
	                        });
	                      }
	                    });
	                    var flashParams = {
	                      idname: storageSession['idname'],
	                      token: storageSession['token'],
	                      question_id: quesRes.id
	                    };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashCards', flashParams).then(function (response) {
	                      if (response.success) {
	                        _this4.setState({ ValidToken: true });
	                        if (response.flash_cards.length > 0) {
	                          _this4.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                          var flashCards = response.flash_cards.map(function (items, index) {
	                            return _react2.default.createElement(
	                              'li',
	                              { key: index },
	                              _react2.default.createElement(
	                                'div',
	                                { className: '' },
	                                _react2.default.createElement(
	                                  'ul',
	                                  { className: 'icon_list' },
	                                  _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                      'a',
	                                      { className: 'pointer_class', onClick: _this4._editFlash.bind(_this4, items) },
	                                      _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                      'a',
	                                      {
	                                        className: 'pointer_class',
	                                        onClick: _this4._deleteFlash.bind(_this4, items)
	                                      },
	                                      _react2.default.createElement('i', { className: 'fa fa-close' })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: _this4.state.flash_class },
	                                  _react2.default.createElement('h4', null),
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    items.flash_card
	                                  )
	                                )
	                              )
	                            );
	                          });
	                          _this4.setState({ flash_data: flashCards });
	                        } else {
	                          _this4.setState({
	                            flash_form: 'col-sm-12 col-md-12 display_block'
	                          });
	                          var _flashCards = _react2.default.createElement(
	                            'p',
	                            null,
	                            _language2.default.LC().NO_FLASHCARD_FOUND
	                          );
	                          _this4.setState({ flash_data: _flashCards });
	                        }
	                      } else {
	                        _this4.setState({
	                          ValidToken: false,
	                          flash_data: _react2.default.createElement(
	                            'p',
	                            null,
	                            _language2.default.LC().NO_FLASHCARD_FOUND
	                          ),
	                          flash_form: 'col-sm-12 col-md-12 display_block'
	                        });
	                      }
	                    });
	                    _this4.setState({ records: '' });
	                  } else {
	                    _this4.setState({
	                      ValidToken: false,
	                      alert_status: true,
	                      MessageTitle: '' + _language2.default.LC().ALERT,
	                      MessageContent: '' + _language2.default.LC().ERROR,
	                      records: '' + _language2.default.LC().Result_not_found
	                    });
	                  }
	                  return resp;
	                });
	
	              case 8:
	                _context4.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getChapterbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this4.setState({ chapter_name: resp.chapters[0].chapter_name });
	                  }
	                });
	
	              case 10:
	                this.setState({ display_loader: 'hide_block' });
	
	              case 11:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function _runCode(_x4) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return _runCode;
	    }()
	
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, token_id, idname, offset_val, subscription) {
	      var _this5 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: this.state.page,
	        chapter_id: chapter_id,
	        offset: offset_val,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success && resp.questions && resp.questions.length > 0) {
	          _this5.setState({
	            ValidToken: true,
	            alert_status: false,
	            MessageTitle: '',
	            MessageContent: '',
	            all_questions_state: resp.questions
	          });
	          var ques_res = [];
	          var offset_res = '';
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (resp.questions[i].id == _this5.props.params.id) {
	              (function () {
	                ques_res = resp.questions[i];
	                offset_res = i;
	                var currentQuestion = resp.questions[i];
	
	                // Get answer state for navigation (match SOA-P logic exactly)
	                var selected = '';
	                var showAnswer = false;
	                var selectedChoice = currentQuestion['soa_fm_question_stats.selected_choice'] || '';
	                var rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
	                var answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
	                var timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
	                var correctChoiceKey = 'right_choice';
	                if (selectedChoice && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	                  selected = selectedChoice;
	                  showAnswer = true;
	                } else if (answerStatus && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	                  if (rightAnswer === 1) {
	                    selected = currentQuestion[correctChoiceKey];
	                    showAnswer = true;
	                  } else if (!rightAnswer) {
	                    var choices = Object.keys(currentQuestion).filter(function (key) {
	                      return key.startsWith('choice') && key !== correctChoiceKey;
	                    });
	                    selected = choices.length > 0 ? choices[0] : '';
	                    showAnswer = true;
	                  }
	                }
	                var isCorrect = selected === currentQuestion[correctChoiceKey];
	
	                // Handle timer based on selected choice
	                if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	                  // Ensure timer is stopped
	                  clearInterval(_this5.timer);
	                  _this5.setState(Object.assign({
	                    timer_stop: true,
	                    timer_tag: 'Start',
	                    timerstopbtn: 'pause_btn icon-control-play',
	                    count: timeDone || _this5.state.count,
	                    selectedChoice: selected,
	                    clicked: true,
	                    showAnswer: showAnswer,
	                    stopTimer: true,
	                    setAnswer: true
	                  }, _this5.getChoices(selected, isCorrect, correctChoiceKey), {
	                    result_block: 'card show_block',
	                    text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	                    result: isCorrect ? 'CORRECT' : 'INCORRECT'
	                  }));
	                } else {
	                  // Start timer if no choice is selected
	                  clearInterval(_this5.timer);
	                  _this5.setState({
	                    timer_stop: false,
	                    timer_tag: 'Stop',
	                    timerstopbtn: 'pause_btn icon-control-pause',
	                    count: 0,
	                    selectedChoice: '',
	                    clicked: false,
	                    showAnswer: false,
	                    stopTimer: false,
	                    setAnswer: false,
	                    result_block: 'card hide_block'
	                  });
	                  _this5.timer = setInterval(_this5._tick.bind(_this5), 1000);
	                }
	
	                _this5.setState(Object.assign({
	                  questions: currentQuestion,
	                  selectedChoice: selected,
	                  clicked: !!selected,
	                  showAnswer: !!selected,
	                  stopTimer: !!selected,
	                  setAnswer: !!selected
	                }, _this5.getChoices(selected, isCorrect, correctChoiceKey), {
	                  result_block: selected ? 'card show_block' : 'card hide_block',
	                  text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	                  result: isCorrect ? 'CORRECT' : 'INCORRECT'
	                }));
	              })();
	            }
	            if (i == resp.questions.length - 1) {
	              _this5.setState({ display_loader: 'hide_block' });
	            }
	          }
	          _this5.setState({ questions: ques_res });
	          _this5.setState({ offset: offset_res });
	          _this5.setState({ question_length: resp.questions.length });
	
	          // Update navigation states based on initial offset
	          if (offset_res === 0) {
	            _this5.setState({ previ_block: 'hide_block' });
	          } else {
	            _this5.setState({ previ_block: '' });
	          }
	
	          if (offset_res === parseInt(resp.questions.length) - 1) {
	            _this5.setState({ next_block: 'hide_block' });
	          } else {
	            _this5.setState({ next_block: '' });
	          }
	
	          var params = {
	            token: _this5.state.token,
	            question_id: ques_res.id,
	            idname: _this5.state.idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestions', params).then(function (response) {
	            if (response.success) {
	              _this5.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                bookmarkColor: 'rgb(54, 141, 84)',
	                save_text: '' + _language2.default.LC().Question_Saved,
	                isFlashCardHidden: false
	              });
	            } else {
	              _this5.setState({
	                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                bookmarkColor: '',
	                save_text: '' + _language2.default.LC().SAVE_QUESTION,
	                isFlashCardHidden: true
	              });
	            }
	          });
	          var params = {
	            idname: storage_session['idname'],
	            token: storage_session['token'],
	            question_id: ques_res.id
	          };
	          //Api to get ratting
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getRatting', params).then(function (response) {
	            if (response.success) {
	              _this5.setState({ rated: true });
	              response.ratting.map(function (items) {
	                _this5.setState({ rating: items.ratting });
	                _this5.setState({ ratting_text: '' + _language2.default.LC().RATED });
	              });
	            }
	          });
	
	          var params = {
	            idname: storage_session['idname'],
	            token: storage_session['token'],
	            question_id: ques_res.id
	          };
	          //Api to fetch flashcard by question id
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this5.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this5.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return (
	                    //alert(items.id)
	                    _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this5._editFlash.bind(_this5, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              {
	                                className: 'pointer_class',
	                                onClick: _this5._deleteFlash.bind(_this5, items)
	                              },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this5.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this5.setState({
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this5.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this5.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	
	          _this5.setState({ records: '' });
	        } else {
	          _this5.setState({
	            ValidToken: false,
	            alert_status: true,
	            MessageTitle: '' + _language2.default.LC().ALERT,
	            MessageContent: '' + _language2.default.LC().ERROR,
	            records: '' + _language2.default.LC().Result_not_found
	          });
	        }
	        return resp;
	      });
	      this.setState({ display_loader: 'hide_block' });
	    }
	
	    /*Function to start or stop timer*/
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    }
	
	    // Add this helper function inside the class
	
	  }, {
	    key: 'getChoices',
	    value: function getChoices(selected, isCorrect, correct) {
	      var choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d', 'choice_e'];
	      var state = {};
	      choices.forEach(function (choice) {
	        if (selected === choice) {
	          state[choice] = isCorrect ? 'answer_box success' : 'answer_box failure';
	        } else if (correct === choice && selected) {
	          state[choice] = 'answer_box success';
	        } else {
	          state[choice] = 'answer_box';
	        }
	      });
	      return state;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          reportLoading = _state2.reportLoading,
	          questions = _state2.questions,
	          isFlashCardHidden = _state2.isFlashCardHidden;
	
	
	      var data = '';
	      var forumData = '';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var retun_all_question = JSON.stringify(this.state.questions);
	      var all_questions = JSON.parse(retun_all_question);
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, 'span', '', { contentEditable: 'false' }),
	              ' (',
	              _language2.default.LC().Q,
	              ' ',
	              all_questions.id,
	              ')',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this.getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this.getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        _ViewQuestion2.default,
	                        Object.assign({}, all_questions, this.props, {
	                          setAnswer: this.getAnswer,
	                          showAnswer: this.state.clicked,
	                          correctChoice: '' + all_questions.right_choice,
	                          selectedChoice: this.state.selectedChoice,
	                          onValidate: function onValidate() {
	                            return _this6.getResult(all_questions);
	                          },
	                          disabled: !this.state.selectedChoice || this.state.clicked
	                        }),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { md: 12, className: 'mt-2' },
	                          _react2.default.createElement(
	                            _reactstrap.Row,
	                            { className: 'align-items-center' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'd-flex align-items-center' },
	                              _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                                isQue: true,
	                                _getResult: this.getResult,
	                                clicked: this.state.clicked,
	                                _saveQuestion: this._saveQuestion,
	                                _displayReportForm: this._displayReportForm,
	                                all_questions: all_questions,
	                                save_text: this.state.save_text,
	                                bookmarkCSS: this.state.bookmarkCSS,
	                                bookmarkColor: this.state.bookmarkColor,
	                                disabled: !this.state.selectedChoice || this.state.clicked
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'star_rating_wrap' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: ' margin_bottom_0 margin_right_10' },
	                                  this.state.ratting_text
	                                ),
	                                _react2.default.createElement(_reactStarRatings2.default, {
	                                  rating: this.state.rating,
	                                  starRatedColor: 'rgb(255, 180, 0)',
	                                  starEmptyColor: 'rgb(51, 51, 51)',
	                                  starDimension: '20px',
	                                  starHoverColor: 'rgb(255, 180, 0)',
	                                  starSpacing: '2px',
	                                  changeRating: this.onStarClick.bind(this, all_questions),
	                                  numberOfStars: 5,
	                                  name: 'rate1'
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement('button', {
	                    type: 'button',
	                    className: this.state.timerstopbtn,
	                    onClick: this._timer_funct
	                  }),
	                  this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                    'a',
	                    {
	                      onClick: this._getSubscribe,
	                      className: 'box_question_color text-center cursor_pointer'
	                    },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS,
	                      ' '
	                    )
	                  ) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(all_questions.answer, 'p', 'view_questionhtml', {
	                contentEditable: 'false'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this._reportQuestion.bind(this, all_questions)
	                    },
	                    ' ',
	                    reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, all_questions)
	                    },
	                    ' ',
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            ),
	            ' '
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else {
	        /*data = <div className="col-sm-12 col-md-12">
	            <div className="no_data_bar card">No Records Found</div></div>;*/
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().QUESTION_BANK
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_QUESTIONS
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'question',
	            isFlashCardHidden: isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'soa_fm'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_Beginchapters;
	}(_react.Component);
	
	/*
	-----------------------------------
	  Class component for tooltip
	-----------------------------------
	*/
	
	
	SOA_FM_Beginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this8 = this;
	
	  this._getReadings = function () {
	    _this8.context.router.push({
	      pathname: '/soa/financialmathematics/readings/' + _this8.props.params.notesid + '/' + _this8.state.page,
	      state: {
	        token: _this8.state.token,
	        idname: _this8.state.idname,
	        chapter: _this8.props.params.notesid
	      }
	    });
	  };
	
	  this._getToggleComment = function (item, e) {
	    (0, _jquery2.default)(_this8.refs['comment_toggle_div']).slideToggle(1000);
	  };
	
	  this._getToggleFlash = function (item, e) {
	    (0, _jquery2.default)(_this8.refs['flash_toggle_div']).slideToggle(1000);
	  };
	
	  this.getPrevious = function () {
	    _this8.setState({ display_loader: 'show_block' });
	    var _state3 = _this8.state,
	        offset = _state3.offset,
	        question_length = _state3.question_length,
	        all_questions_state = _state3.all_questions_state,
	        attemptedQuestions = _state3.attemptedQuestions,
	        token = _state3.token,
	        idname = _state3.idname;
	
	    var prevIndex = offset - 1;
	    _this8.setState({
	      offset: prevIndex,
	      questions: all_questions_state[prevIndex]
	    });
	    if (prevIndex < parseInt(question_length) - 1) {
	      _this8.setState({ next_block: '' });
	    }
	    if (prevIndex === 0) {
	      _this8.setState({ previ_block: 'card hide_block' });
	    }
	    var params = _this8.props.params;
	
	    var prevQuestionId = all_questions_state[prevIndex].id;
	    // Update the URL when navigating to the previous question
	    _this8.context.router.push({
	      pathname: '/soa/financialmathematics/beginchapter/' + _this8.state.page + '/' + params.notesid + '/' + prevQuestionId + '/' + prevIndex,
	      state: {
	        token: token,
	        idname: idname,
	        chapter: params.notesid,
	        offset: prevIndex
	      }
	    });
	    // Check if the previous question is saved
	    var favParams = {
	      token: token,
	      question_id: prevQuestionId,
	      idname: idname
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestions', favParams).then(function (response) {
	      var isSaved = response.success;
	
	      _this8.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: isSaved ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: isSaved ? 'rgb(54, 141, 84)' : '',
	        save_text: isSaved ? _language2.default.LC().Question_Saved : _language2.default.LC().SAVE_QUESTION,
	        isFlashCardHidden: !isSaved
	      });
	    });
	    _this8.setState({ questions: all_questions_state[prevIndex] }, function () {
	      _this8.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	      var ratingParams = {
	        token: token,
	        question_id: _this8.state.questions.id,
	        idname: idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getRatting', ratingParams).then(function (response) {
	        if (response.success && response.ratting.length > 0) {
	          _this8.setState({
	            rating: response.ratting[0].ratting,
	            ratting_text: '' + _language2.default.LC().RATED,
	            rated: true
	          });
	        } else {
	          _this8.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	        }
	      });
	    });
	    if (_this8.timer) {
	      clearInterval(_this8.timer);
	      _this8.timer = null;
	    }
	    var selected = '';
	    var showAnswer = false;
	    var currentQuestion = all_questions_state[prevIndex];
	    var currentAttempts = attemptedQuestions || {};
	    var previousAttempt = currentAttempts[currentQuestion.id] || {};
	    var selectedChoice = previousAttempt.selectedChoice || currentQuestion['soa_fm_question_stats.selected_choice'] || '';
	    var rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
	    var answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
	    var timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
	    var correctChoiceKey = 'right_choice';
	    if (selectedChoice && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	      selected = selectedChoice;
	      showAnswer = true;
	    } else if (answerStatus && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	      if (rightAnswer === 1) {
	        selected = currentQuestion[correctChoiceKey];
	        showAnswer = true;
	      } else if (!rightAnswer) {
	        var choices = Object.keys(currentQuestion).filter(function (key) {
	          return key.startsWith('choice') && key !== correctChoiceKey;
	        });
	        selected = choices.length > 0 ? choices[0] : '';
	        showAnswer = true;
	      }
	    }
	    var isCorrect = selected === currentQuestion[correctChoiceKey];
	    if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	      clearInterval(_this8.timer);
	      _this8.setState(Object.assign({
	        timer_stop: true,
	        timer_tag: 'Start',
	        timerstopbtn: 'pause_btn icon-control-play',
	        count: timeDone || _this8.state.count,
	        selectedChoice: selected,
	        clicked: true,
	        showAnswer: showAnswer,
	        stopTimer: true,
	        setAnswer: true
	      }, _this8.getChoices(selected, isCorrect, correctChoiceKey), {
	        result_block: 'card show_block',
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	        result: isCorrect ? 'CORRECT' : 'INCORRECT',
	        timerstopbtn: 'pause_btn icon-control-play',
	        report_block: 'card hide_block',
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        rated: false,
	        rating: 0,
	        ratting_text: 'Rate this Question',
	        previ_block: prevIndex === 0 ? 'hide_block' : '',
	        next_block: parseInt(question_length) - 1 === prevIndex ? 'hide_block' : ''
	      }));
	    } else {
	      clearInterval(_this8.timer);
	      _this8.setState(Object.assign({
	        timer_stop: false,
	        timer_tag: 'Stop',
	        timerstopbtn: 'pause_btn icon-control-pause',
	        count: 0,
	        selectedChoice: '',
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false,
	        setAnswer: false,
	        result_block: 'card hide_block'
	      }, _this8.getChoices('', false, ''), {
	        previ_block: prevIndex === 0 ? 'hide_block' : '',
	        next_block: parseInt(question_length) - 1 === prevIndex ? 'hide_block' : ''
	      }));
	      _this8.timer = setInterval(_this8._tick.bind(_this8), 1000);
	    }
	    _this8.setState({ display_loader: 'hide_block' });
	  };
	
	  this.getNext = function () {
	    _this8.setState({ display_loader: 'show_block' });
	    var _state4 = _this8.state,
	        offset = _state4.offset,
	        question_length = _state4.question_length,
	        all_questions_state = _state4.all_questions_state,
	        attemptedQuestions = _state4.attemptedQuestions,
	        token = _state4.token,
	        idname = _state4.idname,
	        page = _state4.page;
	
	    var nextIndex = offset + 1;
	    _this8.setState({
	      offset: nextIndex,
	      questions: all_questions_state[nextIndex]
	    });
	    if (parseInt(question_length) - 1 === nextIndex) {
	      _this8.setState({ next_block: 'card hide_block' });
	    }
	    if (nextIndex !== 0) {
	      _this8.setState({ previ_block: '' });
	    }
	    var nextQuestionId = all_questions_state[nextIndex].id;
	    var params = _this8.props.params;
	
	    _this8.context.router.push({
	      pathname: '/soa/financialmathematics/beginchapter/' + page + '/' + params.notesid + '/' + nextQuestionId + '/' + nextIndex,
	      state: {
	        token: token,
	        idname: idname,
	        chapter: params.notesid,
	        offset: nextIndex
	      }
	    });
	    // Check if the next question is saved
	    var favParams = {
	      token: token,
	      question_id: nextQuestionId,
	      idname: idname
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestions', favParams).then(function (response) {
	      var isSaved = response.success;
	
	      _this8.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: isSaved ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: isSaved ? 'rgb(54, 141, 84)' : '',
	        save_text: isSaved ? _language2.default.LC().Question_Saved : _language2.default.LC().SAVE_QUESTION,
	        isFlashCardHidden: !isSaved
	      });
	    });
	
	    if (_this8.timer) {
	      clearInterval(_this8.timer);
	      _this8.timer = null;
	    }
	    var selected = '';
	    var showAnswer = false;
	    var currentQuestion = all_questions_state[nextIndex];
	    var currentAttempts = attemptedQuestions || {};
	    var previousAttempt = currentAttempts[currentQuestion.id] || {};
	    var selectedChoice = previousAttempt.selectedChoice || currentQuestion['soa_fm_question_stats.selected_choice'] || '';
	    var rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
	    var answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
	    var timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
	    var correctChoiceKey = 'right_choice';
	    if (selectedChoice && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	      selected = selectedChoice;
	      showAnswer = true;
	    } else if (answerStatus && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	      if (rightAnswer === 1) {
	        selected = currentQuestion[correctChoiceKey];
	        showAnswer = true;
	      } else if (!rightAnswer) {
	        var choices = Object.keys(currentQuestion).filter(function (key) {
	          return key.startsWith('choice') && key !== correctChoiceKey;
	        });
	        selected = choices.length > 0 ? choices[0] : '';
	        showAnswer = true;
	      }
	    }
	    var isCorrect = selected === currentQuestion[correctChoiceKey];
	    if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_FM)) {
	      clearInterval(_this8.timer);
	      _this8.setState(Object.assign({
	        timer_stop: true,
	        timer_tag: 'Start',
	        timerstopbtn: 'pause_btn icon-control-play',
	        count: timeDone || _this8.state.count,
	        selectedChoice: selected,
	        clicked: true,
	        showAnswer: showAnswer,
	        stopTimer: true,
	        setAnswer: true
	      }, _this8.getChoices(selected, isCorrect, correctChoiceKey), {
	        result_block: 'card show_block',
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	        result: isCorrect ? 'CORRECT' : 'INCORRECT'
	      }));
	    } else {
	      clearInterval(_this8.timer);
	      _this8.setState(Object.assign({
	        timer_stop: false,
	        timer_tag: 'Stop',
	        timerstopbtn: 'pause_btn icon-control-pause',
	        count: 0,
	        selectedChoice: '',
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false,
	        setAnswer: false,
	        result_block: 'card hide_block'
	      }, _this8.getChoices('', false, ''), {
	        next_block: parseInt(question_length) - 1 === nextIndex ? 'hide_block' : ''
	      }));
	      _this8.timer = setInterval(_this8._tick.bind(_this8), 1000);
	    }
	    _this8.setState({ display_loader: 'hide_block' });
	    _this8.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	    var ratingParams = {
	      token: token,
	      question_id: currentQuestion.id,
	      idname: idname
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getRatting', ratingParams).then(function (response) {
	      if (response.success && response.ratting.length > 0) {
	        _this8.setState({
	          rating: response.ratting[0].ratting,
	          ratting_text: '' + _language2.default.LC().RATED,
	          rated: true
	        });
	      } else {
	        _this8.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	      }
	    });
	  };
	
	  this.getAnswer = function (choice, e) {
	    var _state5 = _this8.state,
	        questions = _state5.questions,
	        user_city = _state5.user_city,
	        user_country = _state5.user_country,
	        user_state = _state5.user_state,
	        user_continent = _state5.user_continent,
	        user_ip = _state5.user_ip,
	        token = _state5.token,
	        idname = _state5.idname,
	        attemptedQuestions = _state5.attemptedQuestions,
	        props = _state5.props;
	
	    var currentQuestionId = questions.id;
	    var selectedChoice = choice[0];
	    _this8.setState(Object.assign({
	      selectedChoice: selectedChoice,
	      setAnswer: true,
	      clicked: false,
	      showAnswer: false,
	      stopTimer: false
	    }, _this8.getChoices(selectedChoice, false, '')), function () {
	      var currentAttempts = attemptedQuestions || {};
	      var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	        selectedChoice: _this8.state.selectedChoice,
	        isAnswered: false,
	        setAnswer: true
	      }));
	      _this8.setState({ attemptedQuestions: updatedAttempts });
	    });
	    var data = {
	      token: token,
	      idname: idname,
	      id: props.params.id,
	      city: user_city,
	      country: user_country,
	      state: user_state,
	      continent: user_continent,
	      ip: user_ip
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/trackUserRecord', data).then(function (resp) {
	      if (resp.success) {
	        _this8.setState({ ValidToken: true });
	      }
	    });
	  };
	
	  this._displayReportForm = function (item, e) {
	    _this8.setState({ report_block: 'card show_block' });
	  };
	
	  this._hideReportForm = function (item, e) {
	    _this8.setState({ report_block: 'card hide_block' });
	  };
	
	  this.getResult = function (item, e) {
	    var _state6 = _this8.state,
	        selectedChoice = _state6.selectedChoice,
	        timer = _state6.timer,
	        count = _state6.count,
	        attemptedQuestions = _state6.attemptedQuestions,
	        ValidToken = _state6.ValidToken,
	        validated = _state6.validated,
	        token = _state6.token,
	        idname = _state6.idname;
	
	    if (selectedChoice) {
	      if (timer) {
	        clearInterval(timer);
	        _this8.timer = null;
	      }
	      var currentQuestionId = item.id;
	      var correctChoiceKey = 'right_choice';
	      var isCorrect = selectedChoice === '' + item[correctChoiceKey];
	      _this8.setState({
	        timer_stop: true,
	        timer_tag: 'Start',
	        timerstopbtn: 'pause_btn icon-control-play',
	        setAnswer: true,
	        clicked: true,
	        showAnswer: true,
	        stopTimer: true,
	        result_block: 'card show_block',
	        result: isCorrect ? 'CORRECT' : 'INCORRECT',
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
	      }, function () {
	        var currentAttempts = attemptedQuestions || {};
	        var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	          selectedChoice: selectedChoice,
	          isAnswered: true,
	          isCorrect: isCorrect,
	          setAnswer: true,
	          timeSpent: count
	        }));
	        _this8.setState({ attemptedQuestions: updatedAttempts });
	        if (isCorrect) {
	          _this8.setState(Object.assign({}, _this8.getChoices(selectedChoice, isCorrect, correctChoiceKey)));
	        } else {
	          _this8.setState(Object.assign({}, _this8.getChoices(item.right_choice, isCorrect, correctChoiceKey)));
	        }
	      });
	      if (!validated) {
	        var data = {
	          token: token,
	          idname: idname,
	          question_id: item.id,
	          right_answer: isCorrect ? 1 : 0,
	          time_done: count,
	          selected_choice: selectedChoice
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveStats', data).then(function (resp) {
	          if (resp.success) {
	            _this8.setState({ ValidToken: true, validated: true });
	          } else {
	            _this8.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    } else {
	      _this8.setState({
	        result_block: 'card hide_block'
	      });
	    }
	  };
	
	  this._saveQuestion = function (item, e) {
	    var _state7 = _this8.state,
	        bookmarkCSS = _state7.bookmarkCSS,
	        bookmarkColor = _state7.bookmarkColor,
	        save_text = _state7.save_text,
	        save_question = _state7.save_question,
	        isFlashCardHidden = _state7.isFlashCardHidden;
	    var _state8 = _this8.state,
	        token = _state8.token,
	        idname = _state8.idname;
	
	    var data = {
	      token: token,
	      idname: idname,
	      question_id: item.id
	    };
	    if (bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/unsaveQuestion', data).then(function (resp) {
	        if (resp.success) {
	          if (_this8.childRef) {
	            _this8.childRef.deleteFlash();
	          }
	          _this8.setState({
	            ValidToken: true,
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	            bookmarkColor: '',
	            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	            isFlashCardHidden: true
	          });
	        } else {
	          _this8.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    } else {
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this8.setState({
	            ValidToken: true,
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved,
	            isFlashCardHidden: false
	          });
	        } else {
	          _this8.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	  };
	
	  this._saveFlashCard = function (item, e) {
	    if (document.getElementById('flash_card').value == '') {
	      return;
	    }
	
	    var flash_card = document.getElementById('flash_card').value;
	    var data = {
	      token: token,
	      idname: idname,
	      question_id: item.id,
	      flash_card: flash_card
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveFlashCard', data).then(function (resp) {
	      if (resp.success) {
	        _this8.setState({ ValidToken: true });
	        document.getElementById('flash_card').value = '';
	        var params = {
	          token: token,
	          idname: idname,
	          question_id: item.id
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashCards', params).then(function (response) {
	          if (response.success) {
	            _this8.setState({ ValidToken: true });
	            if (response.flash_cards.length > 0) {
	              _this8.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	              var flashCards = response.flash_cards.map(function (items, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'icon_list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'pointer_class', onClick: _this8._editFlash.bind(_this8, items) },
	                          _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            className: 'pointer_class',
	                            onClick: _this8._deleteFlash.bind(_this8, items)
	                          },
	                          _react2.default.createElement('i', { className: 'fa fa-close' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _this8.state.flash_class },
	                      _react2.default.createElement('h4', null),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        items.flash_card
	                      )
	                    )
	                  )
	                );
	              });
	              _this8.setState({ flash_data: flashCards });
	            } else {
	              _this8.setState({
	                flash_form: 'col-sm-12 col-md-12 display_block'
	              });
	              var _flashCards2 = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this8.setState({ flash_data: _flashCards2 });
	            }
	          } else {
	            var _flashCards3 = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	            _this8.setState({
	              ValidToken: false,
	              flash_data: _flashCards3,
	              flash_form: 'col-sm-12 col-md-12 display_block'
	            });
	          }
	          return response;
	        });
	      } else {
	        _this8.setState({ ValidToken: false });
	      }
	    });
	  };
	
	  this._reportQuestion = function (item, e) {
	    var reportLoading = _this8.state.reportLoading;
	
	    var comment = document.getElementById('comment').value;
	    if (comment.length < 2) {
	      return;
	    }
	    var data = {
	      token: _this8.state.token,
	      idname: _this8.state.idname,
	      question_id: item.id,
	      comment: comment,
	      city: _this8.state.user_city,
	      country: _this8.state.user_country,
	      state: _this8.state.user_state,
	      continent: _this8.state.user_continent,
	      ip: _this8.state.user_ip
	    };
	    _this8.setState({
	      reportLoading: true
	    });
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/reportQuestion', data).then(function (resp) {
	      if (resp.success) {
	        _this8.setState({
	          ValidToken: true,
	          successAlert: true,
	          reportLoading: false
	        });
	        document.getElementById('comment').value = '';
	      } else {
	        _this8.setState({ ValidToken: false });
	      }
	      return resp;
	    });
	  };
	
	  this.onClose = function (e) {
	    _this8.setState({
	      report_block: 'card hide_block',
	      successAlert: false
	    });
	  };
	
	  this._editFlash = function (item, e) {
	    _this8.setState({
	      flash_form: 'col-sm-12 col-md-12 display_block',
	      isEditable: true
	    });
	
	    document.getElementById('flash_card').value = item.flash_card;
	  };
	
	  this._deleteFlash = function (item, e) {
	    var _state9 = _this8.state,
	        token = _state9.token,
	        idname = _state9.idname;
	
	    var data = {
	      token: token,
	      idname: idname,
	      flash_card: item
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteFlashCard', data).then(function (resp) {
	      if (resp.success) {
	        _this8.setState({
	          ValidToken: true,
	          flash_form: 'col-sm-12 col-md-12 display_block',
	          isEditable: false
	        });
	        document.getElementById('flash_card').value = '';
	        var flashCards = _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_FLASHCARD_FOUND
	        );
	        _this8.setState({ flash_data: flashCards });
	      } else {
	        _this8.setState({ ValidToken: false });
	      }
	    });
	  };
	
	  this.onStarClick = function (item, nextValue, prevValue, name) {
	    var _state10 = _this8.state,
	        token = _state10.token,
	        idname = _state10.idname;
	
	    _this8.setState({ rating: nextValue, ratting_text: '' + _language2.default.LC().RATED, rated: true });
	    var params = {
	      token: token,
	      idname: idname,
	      question_id: item.id,
	      ratting: nextValue
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveRatting', params).then(function (response) {
	      if (response.success) {
	        var getParams = {
	          token: token,
	          question_id: item.id,
	          idname: idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getRatting', getParams).then(function (resp) {
	          if (resp.success && resp.ratting.length > 0) {
	            _this8.setState({
	              rating: resp.ratting[0].ratting,
	              ratting_text: '' + _language2.default.LC().RATED,
	              rated: true
	            });
	          } else {
	            _this8.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	          }
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/UpdateSoaFmRatting', params).then(function () {
	          var getParams = {
	            token: token,
	            question_id: item.id,
	            idname: idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getRatting', getParams).then(function (resp) {
	            if (resp.success && resp.ratting.length > 0) {
	              _this8.setState({
	                rating: resp.ratting[0].ratting,
	                ratting_text: '' + _language2.default.LC().RATED,
	                rated: true
	              });
	            } else {
	              _this8.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	            }
	          });
	        });
	      }
	    });
	  };
	
	  this._getSubscribe = function () {
	    _this8.context.router.push({
	      pathname: '/subscribe/',
	      state: { token: _this8.state.token, idname: _this8.state.idname }
	    });
	  };
	
	  this._timer_funct = function () {
	    // Prevent timer from starting if already answered
	    if (_this8.state.clicked || _this8.state.selectedChoice) {
	      // Optionally, show a message or just do nothing
	      return;
	    }
	    var newTimerStopState = !_this8.state.timer_stop;
	    _this8.setState({
	      timer_stop: newTimerStopState,
	      timerstopbtn: newTimerStopState ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	    });
	    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
	    if (newTimerStopState) {
	      if (_this8.timer) {
	        clearInterval(_this8.timer);
	      }
	    } else {
	      _this8.timer = setInterval(_this8._tick.bind(_this8), 1000);
	    }
	  };
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this7 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this7.toggle = _this7.toggle.bind(_this7);
	    _this7.state = {
	      tooltipOpen: false
	    };
	    return _this7;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_FM_Beginchapters;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var SOA_FM_Beginquiz = function (_Component) {
	  _inherits(SOA_FM_Beginquiz, _Component);
	
	  function SOA_FM_Beginquiz(props) {
	    _classCallCheck(this, SOA_FM_Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_Beginquiz.__proto__ || Object.getPrototypeOf(SOA_FM_Beginquiz)).call(this, props));
	
	    _this.fetchQuizData = function () {
	      var _this$state = _this.state,
	          idname = _this$state.idname,
	          token = _this$state.token,
	          quiz_id = _this$state.quiz_id,
	          offset = _this$state.offset;
	
	      if (!token || !idname) return;
	      var requestData = { idname: idname, token: token, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getQuize', requestData).then(function (resp) {
	        if (!resp || !resp.success) return;
	        var allQuestions = JSON.parse(JSON.parse(JSON.stringify(resp.singlequiz))).all_questions;
	        var questionIds = [];
	        for (var i = 0; i < resp.questions_count; i++) {
	          questionIds.push(allQuestions[i]);
	        }
	        var timerValue = Number(resp.timer_value) || 0;
	        var hasUserTimeValue = resp.user_time_value !== undefined && resp.user_time_value !== null;
	        var userTimeValue = hasUserTimeValue ? Number(resp.user_time_value) : timerValue;
	        var initialTimerValue = userTimeValue > 0 ? userTimeValue : timerValue;
	        var firstQuestionId = questionIds[offset];
	        _this.setState({
	          user_time_value: userTimeValue,
	          count: initialTimerValue,
	          count_temp: initialTimerValue,
	          all_question_id: questionIds,
	          question_length: questionIds.length,
	          timer_value: timerValue,
	          include_timer: resp.include_timer,
	          first_question_id: firstQuestionId
	        }, function () {
	          if (questionIds.length - 1 === offset) {
	            _this.setState({ next_block: 'card hide_block' });
	          }
	          if (_this.isTimerFeatureEnabled() && !_this.state.timer_stop && !_this.state.validated && !_this.state.selectedChoice) {
	            if (_this.timer) {
	              clearInterval(_this.timer);
	              _this.timer = null;
	            }
	            _this.timer = setInterval(_this.tick.bind(_this), 1000);
	          }
	          _this.fetchQuestionDetails(firstQuestionId);
	        });
	      }).catch(function () {});
	    };
	
	    _this.fetchQuestionDetails = function (questionId) {
	      var _this$state2 = _this.state,
	          token = _this$state2.token,
	          idname = _this$state2.idname,
	          quiz_id = _this$state2.quiz_id,
	          offset = _this$state2.offset;
	
	      if (!token || !idname || !questionId) return;
	      var requestData = { token: token, idname: idname, question_id: questionId, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestionsbyid', requestData).then(function (resp) {
	        if (!resp || !resp.success) return;
	        var questionData = resp.questionsbyid;
	        _this.setState({
	          display_question: questionData,
	          correctChoice: questionData.right_choice || '',
	          display_loader: 'hide_block'
	        });
	        var checkData = { token: token, idname: idname, quiz_id: quiz_id, question_id: questionId };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/checkAnswered', checkData).then(function (respInner) {
	          if (!respInner) return;
	          var questionResponse = respInner.question_recived || {};
	          var selected = '';
	          var showAnswer = false;
	          if (questionResponse.selected_choice) {
	            selected = questionResponse.selected_choice;
	            showAnswer = true;
	          } else if (questionResponse.id) {
	            if (questionResponse.answer === 1) {
	              selected = questionData.right_choice;
	              showAnswer = true;
	            } else if (!questionResponse.answer) {
	              var choices = Object.keys(questionData).filter(function (key) {
	                return key.startsWith('choice') && key !== questionData.right_choice;
	              });
	              selected = choices.length > 0 ? choices[0] : '';
	              showAnswer = true;
	            }
	          }
	          _this.setState({
	            already_answered_status: respInner.message,
	            ValidToken: true,
	            selectedChoice: selected,
	            clicked: showAnswer,
	            validated: showAnswer,
	            result_block: showAnswer ? 'card show_block' : 'card hide_block',
	            text_color: selected === questionData.right_choice ? 'card-header text_success' : 'card-header text_failure',
	            result: selected === questionData.right_choice ? '' + _language2.default.LC().CORRECT : '' + _language2.default.LC().INCORRECT,
	            timer_stop: showAnswer || !!selected,
	            timerstopbtn: showAnswer || !!selected ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	          });
	          if (showAnswer || !!selected) {
	            if (_this.timer) {
	              clearInterval(_this.timer);
	              _this.timer = null;
	            }
	          } else if (_this.isTimerFeatureEnabled() && !_this.state.timer_stop) {
	            if (_this.timer) {
	              clearInterval(_this.timer);
	              _this.timer = null;
	            }
	            _this.timer = setInterval(_this.tick.bind(_this), 1000);
	          }
	        }).catch(function () {});
	        _this.fetchSavedQuestionStatus(questionId);
	        _this.fetchFlashCards(questionId);
	      }).catch(function () {});
	    };
	
	    _this.fetchSavedQuestionStatus = function (questionId) {
	      var _this$state3 = _this.state,
	          token = _this$state3.token,
	          idname = _this$state3.idname;
	
	      var params = { token: token, question_id: questionId, idname: idname };
	      _this.setState({
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: ''
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestions', params).then(function (resp) {
	        if (resp && resp.success) {
	          _this.setState({
	            ValidToken: true,
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            save_text: '' + _language2.default.LC().Question_Saved,
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)'
	          });
	        }
	      }).catch(function () {});
	    };
	
	    _this.fetchFlashCards = function (questionId) {
	      var _this$state4 = _this.state,
	          token = _this$state4.token,
	          idname = _this$state4.idname,
	          quiz_id = _this$state4.quiz_id,
	          flash_class = _this$state4.flash_class;
	
	      var params = { token: token, idname: idname, question_id: questionId, quiz_id: quiz_id };
	      _this.setState({
	        flash_form: 'col-sm-12 display_block',
	        flash_data: _react2.default.createElement(
	          'p',
	          null,
	          _language2.default.LC().NO_FLASHCARD_FOUND
	        )
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashCards', params).then(function (response) {
	        try {
	          var responseData = typeof response === 'string' ? JSON.parse(response) : response;
	          _this.setState({ ValidToken: true });
	          var flashCardsContent = '';
	          if (responseData.flash_cards && responseData.flash_cards.length > 0) {
	            _this.setState({ flash_form: 'col-sm-12 hide_block' });
	            flashCardsContent = responseData.flash_cards.map(function (item) {
	              return _react2.default.createElement(
	                'li',
	                { key: item.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: function onClick() {
	                            return _this._editFlash(item);
	                          } },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: function onClick() {
	                            return _this._deleteFlash(item);
	                          } },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      item.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({ flash_form: 'col-sm-12 display_block' });
	            flashCardsContent = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	          }
	          _this.setState({ flash_data: flashCardsContent });
	        } catch (parseError) {
	          // Keep default no flash cards state on error
	        }
	      }).catch(function () {});
	    };
	
	    _this.handleAnswerSelect = function (choice) {
	      if (!_this.state.validated) {
	        _this.setState({
	          selectedChoice: choice[0],
	          clicked: true,
	          result_block: 'card hide_block',
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        if (_this.timer) {
	          clearInterval(_this.timer);
	          _this.timer = null;
	        }
	      }
	    };
	
	    _this.getNext = function () {
	      _this.navigateQuestion(_this.state.offset + 1);
	    };
	
	    _this.getPrevious = function () {
	      _this.navigateQuestion(_this.state.offset - 1);
	    };
	
	    _this.navigateQuestion = function (newOffset) {
	      var _this$state5 = _this.state,
	          token = _this$state5.token,
	          idname = _this$state5.idname,
	          quiz_id = _this$state5.quiz_id,
	          count = _this$state5.count,
	          question_length = _this$state5.question_length,
	          all_question_id = _this$state5.all_question_id;
	
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        clicked: false,
	        selectedChoice: null,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        timer_stop: false,
	        timerstopbtn: 'pause_btn icon-control-pause'
	      });
	      document.getElementById('comment').value = '';
	      var timerData = { token: token, idname: idname, quiz_id: quiz_id, user_time_value: count };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/insertTimer', timerData);
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/beginquiz/' + quiz_id + '/' + newOffset
	      });
	      if (newOffset > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (question_length - 1 === newOffset) {
	        _this.setState({ next_block: 'card hide_block' });
	      } else {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: newOffset });
	      _this.fetchQuestionDetails(all_question_id[newOffset]);
	      if (_this.isTimerFeatureEnabled()) {
	        clearInterval(_this.timer);
	        if (!_this.state.timer_stop) {
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        }
	      }
	    };
	
	    _this.getResult = function (questionItem, e) {
	      var _this$state6 = _this.state,
	          clicked = _this$state6.clicked,
	          validated = _this$state6.validated,
	          token = _this$state6.token,
	          idname = _this$state6.idname,
	          quiz_id = _this$state6.quiz_id,
	          all_question_id = _this$state6.all_question_id,
	          offset = _this$state6.offset,
	          selectedChoice = _this$state6.selectedChoice;
	
	      if (clicked && !validated) {
	        clearInterval(_this.timer);
	        var isRightAnswer = 0;
	        if (questionItem.right_choice === selectedChoice) {
	          isRightAnswer = 1;
	          _this.setState({
	            result: '' + _language2.default.LC().CORRECT,
	            text_color: 'card-header text_success',
	            result_block: 'card show_block',
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          isRightAnswer = 0;
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: '' + _language2.default.LC().INCORRECT,
	            result_block: 'card show_block',
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        }
	        var answerData = {
	          token: token,
	          idname: idname,
	          quiz_id: quiz_id,
	          question_id: all_question_id[offset],
	          answer: isRightAnswer,
	          selected_choice: selectedChoice
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/answerQuiz', answerData).then(function (resp) {
	          if (resp.success) {
	            var statsData = {
	              token: token,
	              idname: idname,
	              question_id: all_question_id[offset],
	              right_answer: isRightAnswer,
	              time_done: 0
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveStats', statsData).then(function (resp) {
	              if (resp.success) {
	                _this.setState({ ValidToken: true, validated: true });
	              }
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	        });
	      }
	    };
	
	    _this.isTimerFeatureEnabled = function () {
	      var _this$state7 = _this.state,
	          include_timer = _this$state7.include_timer,
	          timer_value = _this$state7.timer_value;
	
	      return !!include_timer || timer_value && parseInt(timer_value, 10) > 0;
	    };
	
	    _this.saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: ''
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)'
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card,
	        quiz_id: _this.state.quiz_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id,
	            quiz_id: _this.state.quiz_id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashCards', params).then(function (response) {
	            var flash_cards = '';
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({ flash_form: 'col-sm-12 hide_block' });
	                flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({ flash_form: 'col-sm-12 display_block' });
	                flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-sm-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-sm-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-sm-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/beforeStart/' + _this.state.quiz_id + '/' + 'abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon'
	        }
	      });
	    };
	
	    var initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: initialTimerStop ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause',
	      ValidToken: false,
	      selectedChoice: null,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      count_end_message: '',
	      timer_stop: initialTimerStop,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      already_answered_status: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(SOA_FM_Beginquiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	      this.setState = function () {};
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (this.state.offset === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        }, function () {
	          _this2.fetchQuizData();
	          if (_this2.timer) {
	            clearInterval(_this2.timer);
	            _this2.timer = null;
	          }
	          var initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
	          _this2.setState({
	            timer_stop: initialTimerStop,
	            timerstopbtn: initialTimerStop ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	          });
	        });
	      }
	    }
	  }, {
	    key: 'tick',
	    value: function tick() {
	      var _state = this.state,
	          count = _state.count,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id;
	
	      if (count > 0) {
	        var newCount = count - 1;
	        var timerData = { token: token, idname: idname, quiz_id: quiz_id, user_time_value: newCount };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/insertTimer', timerData);
	        this.setState({
	          count: newCount,
	          timer_display: 'card-block'
	        });
	      } else {
	        this.setState({
	          timer_display: 'card hide_block',
	          count_end_message: "Time's Up"
	        });
	        clearInterval(this.timer);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var questions = this.state.display_question;
	      if (!questions) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      var isTimeUp = count_temp_var <= 0;
	
	      if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
	        if (count_temp_var < 60) {
	          display_time = count_temp_var + ' sec';
	        } else {
	          var minutes = Math.floor(count_temp_var / 60);
	          var seconds = count_temp_var % 60;
	          display_time = minutes + ' min ' + seconds + ' sec';
	        }
	      }
	
	      var isValidateDisabled = this.state.validated || !this.state.selectedChoice;
	      var isTimerButtonDisabled = !this.isTimerFeatureEnabled() || this.state.count <= 0 || this.state.validated || this.state.selectedChoice;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUIZ_ID,
	                ' : ',
	                this.state.quiz_id
	              ),
	              _react2.default.createElement(
	                'h6',
	                { className: 'text-danger' },
	                this.state.already_answered_status
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                _language2.default.LC().BACK_TO_SUMMARY
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_40 font-16px' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                    className: 'margin_right_20',
	                    width: '30',
	                    alt: ''
	                  }),
	                  _language2.default.LC().Q,
	                  ' ',
	                  parseInt(this.state.offset) + 1,
	                  ' ',
	                  (0, _function.renderHTMLContent)(questions.name, 'span', '', { contentEditable: 'false' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    parseInt(this.props.params.offset) === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                      onClick: this.getPrevious
	                    }),
	                    _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                      onClick: this.getNext
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-9' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          (0, _function.renderHTMLContent)(questions.question, 'div', 'margin_bottom_40 view_questionhtml bg_blue', { contentEditable: 'false' })
	                        ),
	                        _react2.default.createElement(_ViewQuestion2.default, {
	                          question: questions.question,
	                          choice_a: questions.choice_a,
	                          choice_b: questions.choice_b,
	                          choice_c: questions.choice_c,
	                          choice_d: questions.choice_d,
	                          choice_e: questions.choice_e,
	                          selectedChoice: this.state.selectedChoice,
	                          onAnswerSelect: this.handleAnswerSelect,
	                          isAnswered: this.state.validated,
	                          correctChoice: this.state.correctChoice,
	                          setAnswer: this.handleAnswerSelect,
	                          showAnswer: this.state.validated
	                        }),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { md: 12, className: 'mt-2' },
	                          _react2.default.createElement(
	                            _reactstrap.Row,
	                            { className: 'align-items-center' },
	                            _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                              isQue: true,
	                              _getResult: this.getResult,
	                              clicked: isValidateDisabled,
	                              _saveQuestion: this.saveQuestion,
	                              _displayReportForm: this._displayReportForm,
	                              all_questions: questions,
	                              save_text: this.state.save_text,
	                              bookmarkCSS: this.state.bookmarkCSS,
	                              bookmarkColor: this.state.bookmarkColor,
	                              showResult: this.state.validated || !this.state.selectedChoice
	                            })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'timer_outer' },
	                        _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'timer_box' },
	                          display_time
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'quiz_timer_btn ' + this.state.timer_display },
	                        _react2.default.createElement('button', {
	                          type: 'button',
	                          className: this.state.timerstopbtn,
	                          onClick: this._timer_funct,
	                          disabled: isTimerButtonDisabled
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'text-danger' },
	                        (0, _function.renderHTMLContent)(this.state.count_end_message, 'div', '', {
	                          contentEditable: 'false'
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.result_block + ' font-lusitana font-16px' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.text_color },
	                  this.state.result
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  (0, _function.renderHTMLContent)(questions.answer, 'div', '', { contentEditable: 'false' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class',
	                          onClick: this._reportQuestion.bind(this, questions)
	                        },
	                        _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_Beginquiz;
	}(_react.Component);
	
	SOA_FM_Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this3 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this3.toggle = _this3.toggle.bind(_this3);
	    _this3.state = {
	      tooltipOpen: false
	    };
	    return _this3;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_FM_Beginquiz;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(79);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var i = '';
	/* eslint-disable*/
	
	var SOA_FM_Dashboard = function (_Component) {
	  _inherits(SOA_FM_Dashboard, _Component);
	
	  function SOA_FM_Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_Dashboard.__proto__ || Object.getPrototypeOf(SOA_FM_Dashboard)).call(this, props));
	
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context2.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportquestion: resp.questions, reportLoader: false });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.getQuestionFlashCards = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context3.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ flashreport: resp.flash_report, flashLoader: false });
	                } else {
	                  console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.getQuestionSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context4.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ savedquestion: resp.questions, savedLoader: false });
	                } else {
	                  console.log(resp.success + '------------failure');
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	    _this.getNotesReports = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context6.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getReportsNotesbyuserid', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportnotes: resp.notes });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getNotesFlashCards = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context8.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFlashcardsnotesbyuserid', data).then(function () {
	                var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                  return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ notesFlashReport: resp.flash_report });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this2);
	                }));
	
	                return function (_x3) {
	                  return _ref8.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this2);
	    }));
	    _this.getNotesSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context10.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFavNotesbyuserID', data).then(function () {
	                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savednotes: resp.soa_fm_fav_notes });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref10.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this2);
	    }));
	    _this.getVideoFlashcards = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context12.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getFlashcardsVideobyuserid', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ videoFlashReport: resp.flash_report });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x5) {
	                  return _ref12.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context14.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getFavVideosbyuserid', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savedvideo: resp.soa_fm_videos });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref14.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee16() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context16.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getReportsVideobyuserid', data).then(function () {
	                var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(resp) {
	                  return _regenerator2.default.wrap(function _callee15$(_context15) {
	                    while (1) {
	                      switch (_context15.prev = _context15.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportsvideo: resp.video });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context15.stop();
	                      }
	                    }
	                  }, _callee15, _this2);
	                }));
	
	                return function (_x7) {
	                  return _ref16.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this2);
	    }));
	
	    _this.onContactSubmit = function () {
	      var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(event) {
	        var _this$state, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context18.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context18.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context18.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context18.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state = _this.state, idname = _this$state.idname, token = _this$state.token, contactComment = _this$state.contactComment, contactSubject = _this$state.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context18.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(resp) {
	                    return _regenerator2.default.wrap(function _callee17$(_context17) {
	                      while (1) {
	                        switch (_context17.prev = _context17.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context17.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context17.stop();
	                        }
	                      }
	                    }, _callee17, _this2);
	                  }));
	
	                  return function (_x9) {
	                    return _ref18.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this2);
	      }));
	
	      return function (_x8) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this.deleteFlashCard = function () {
	      var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(type, id) {
	        var _this$state2, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                _this$state2 = _this.state, id_name = _this$state2.idname, token = _this$state2.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: '',
	                  exam: 'soa_fm',
	                  level: '',
	                  item_id: id
	                };
	                _context19.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this2);
	      }));
	
	      return function (_x10, _x11) {
	        return _ref19.apply(this, arguments);
	      };
	    }();
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._deleteVideoFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Videoflashcard');
	    };
	
	    _this._deleteSavequestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteSavedNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savednotes');
	    };
	
	    _this._deleteSavedVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._deleteReportsNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsnotes');
	    };
	
	    _this._deleteReportsVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer === 'hide_block') {
	        _this.setState({
	          show_outer: 'show_block',
	          more_detail_button: 'Hide Details'
	        });
	      }
	      if (_this.state.show_outer === 'show_block') {
	        _this.setState({
	          show_outer: 'hide_block',
	          more_detail_button: 'I Want More Details'
	        });
	      }
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/soa/financialmathematics/beginchapter/' + 1 + '/' + resp.questionsbyid.chapter_id + '/' + item.question_id,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              chapter: resp.questionsbyid.chapter_id
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this._beginNotes = function () {
	      var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(reading, e) {
	        var reading_id, chapter_id, data;
	        return _regenerator2.default.wrap(function _callee20$(_context20) {
	          while (1) {
	            switch (_context20.prev = _context20.next) {
	              case 0:
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                _context20.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    chapter_id = resp.notes[0].chapter_id;
	
	                    _this.context.router.push({
	                      pathname: '/soa/financialmathematics/beginnotes/' + chapter_id + '/' + reading.question_id + '/' + 0,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter: chapter_id,
	                        offset: 0
	                      }
	                    });
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context20.stop();
	            }
	          }
	        }, _callee20, _this2);
	      }));
	
	      return function (_x12, _x13) {
	        return _ref20.apply(this, arguments);
	      };
	    }();
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this._beginVideos = function () {
	      var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee21$(_context21) {
	          while (1) {
	            switch (_context21.prev = _context21.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.video_id
	                  // chapter_id: reading.chapter_id
	                };
	                _context21.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getVideoByID', data).then(function (resp) {
	                  if (resp.success) {
	                    var _data = resp.allVideo.findIndex(function (item) {
	                      return item.id === resp.video[0].id;
	                    });
	                    _this.context.router.push({
	                      pathname: '/soa/financialmathematics/videodisplay/' + resp.video[0].id + '/' + (_this.state.showFreePremium ? 0 : 1) + '/' + (resp.video[0].chapter_id === 0 ? 0 : 1) + ' /' + resp.video[0].chapter_id + '/' + _data,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter: resp.video[0],
	                        index: _data,
	                        showFreePremium: _this.state.showFreePremium
	                      }
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context21.stop();
	            }
	          }
	        }, _callee21, _this2);
	      }));
	
	      return function (_x14, _x15) {
	        return _ref21.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      token: '',
	      idname: '',
	      notesFlashReport: [],
	      flashreport: [], //All Flash question Store
	      videoFlashReport: [],
	      savedquestion: [],
	      savednotes: [],
	      savedvideo: [],
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	
	      reportquestion: [],
	      reportnotes: [],
	      reportsvideo: [],
	
	      progress_bar_zero: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      bar_chapter: '',
	      bar_main_user: [],
	      bar_main_class: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      subreadings_status: false,
	      display_main_loader: 'show_block',
	      display_loader: 'hide_block',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      ErrorMessage: '',
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      type: '',
	      activeTabFlashcards: '1',
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      showFreePremium: '',
	      isVideo: true,
	      qpLoader: true,
	      npLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	
	    _this.CloseEditNotesReport = _this.CloseEditNotesReport.bind(_this);
	    _this.OpenEditNotesReport = _this.OpenEditNotesReport.bind(_this);
	
	    _this.OpenEditVideoReport = _this.OpenEditVideoReport.bind(_this);
	    _this.CloseEditVideoReport = _this.CloseEditVideoReport.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_FM_Dashboard, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee23() {
	        var _this3 = this;
	
	        var storage_session, data, getProfileInfo;
	        return _regenerator2.default.wrap(function _callee23$(_context23) {
	          while (1) {
	            switch (_context23.prev = _context23.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                //this.setState({display_loader:'show_block'});
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	                getProfileInfo = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfo).then(async resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee22() {
	                  var resp, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee22$(_context22) {
	                    while (1) {
	                      switch (_context22.prev = _context22.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context22.next = 3;
	                            break;
	                          }
	
	                          return _context22.abrupt('return');
	
	                        case 3:
	
	                          if (resp.profileInfo) {
	                            _this3.setState({
	                              isVideo: resp.profileInfo.isVideo
	                            });
	                          }
	
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context22.next = 15;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context22.next = 9;
	                            break;
	                          }
	
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context22.next = 13;
	                          break;
	
	                        case 9:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context22.next = 13;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this3.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                              if (isInArray_var) {
	                                _this3.setState({ showFreePremium: false });
	                              } else {
	                                _this3.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 13:
	                          _context22.next = 23;
	                          break;
	
	                        case 15:
	                          if (!(resp.profileInfo.exam_selected === '')) {
	                            _context22.next = 19;
	                            break;
	                          }
	
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context22.next = 23;
	                          break;
	
	                        case 19:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context22.next = 23;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this3.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                              if (isInArray_var) {
	                                _this3.setState({ showFreePremium: false });
	                              } else {
	                                _this3.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 23:
	                        case 'end':
	                          return _context22.stop();
	                      }
	                    }
	                  }, _callee22, _this3);
	                })));
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/mainProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ display_loader: 'hide_block' });
	                    var dataString = JSON.stringify(resp.chapters);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      /* var total_question=dataReason[i].question_stat_count;*/
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	
	                    _this3.setState({ bar_main_user: final_array_main });
	                  } else {
	                    _this3.setState({ display_loader: 'hide_block' });
	                    // console.log(resp.success+'------------failure');
	                  }
	                });
	                this.setState({ display_main_loader: 'show_block' });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/mainProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ display_main_loader: 'hide_block' });
	                    var dataString = JSON.stringify(resp.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	
	                    var final_array_main = [];
	
	                    for (i = 0; i < dataReason.length; i++) {
	                      var right_answered = dataReason[i].answered_count;
	                      var total_question = dataReason[i].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	
	                    _this3.setState({ bar_main_class: final_array_main });
	                  } else {
	                    _this3.setState({ display_loader: 'hide_block' });
	                    // console.log(resp.success+'------------failure');
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getQuestionProgByUser', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      progress_bar_zero: resp.progressbarzero_data,
	                      qpLoader: false
	                    });
	                  } else {
	                    console.log(resp.success + '------------failure');
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getNotesChapter', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ bar_chapter: resp.chapters });
	                  } else {
	                    console.log(resp.success + '------------failure');
	                  }
	                });
	                _context23.next = 16;
	                return this.getQuestionFlashCards();
	
	              case 16:
	                _context23.next = 18;
	                return this.getNotesFlashCards();
	
	              case 18:
	                _context23.next = 20;
	                return this.getVideoFlashcards();
	
	              case 20:
	                _context23.next = 22;
	                return this.getQuestionSaved();
	
	              case 22:
	                _context23.next = 24;
	                return this.getNotesSaved();
	
	              case 24:
	                _context23.next = 26;
	                return this.getVideosSaved();
	
	              case 26:
	                /*FD.callAPI(App_data.backend_api+'/cfa_dashboard/getProgressChapter',data).then(resp => {
	                if(resp.success)
	                {
	                this.setState({progress_bar_zero:resp.chapters});
	                }
	                else
	                {
	                console.log(resp.success+'------------failure');
	                }
	                })*/
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getnotesprogByuser', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ progress_bar: resp.progressbar_data, npLoader: false });
	                  } else {
	                    console.log(resp.success + '------------failure');
	                  }
	                });
	
	                _context23.next = 29;
	                return this.getQuestionReports();
	
	              case 29:
	                _context23.next = 31;
	                return this.getNotesReports();
	
	              case 31:
	                _context23.next = 33;
	                return this.getVideoReports();
	
	              case 33:
	              case 'end':
	                return _context23.stop();
	            }
	          }
	        }, _callee23, this);
	      }));
	
	      function componentDidMount() {
	        return _ref22.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	
	    /*
	    ----------------------------------------------------
	      function for get all  question report by user id
	    ----------------------------------------------------
	    */
	
	
	    /*
	    ----------------------------------------------------------
	      function for get all  question flash card by user id
	    ----------------------------------------------------------
	     */
	
	
	    /*
	    ----------------------------------------------------
	      function for get all  question saved by user id
	    ----------------------------------------------------
	     */
	
	
	    /*
	    -------------------------------------------------
	     function for get  all  notes report by user id
	    -------------------------------------------------
	     */
	
	
	    /*
	    ----------------------------------------------------
	     function for get  all  notes flas card by user id
	    ----------------------------------------------------
	     */
	
	
	    /*
	    --------------------------------------------------
	      Function for get all saved notes by user id
	    --------------------------------------------------
	      */
	
	
	    // function for get  Video falshCard
	
	
	    /*
	     * get saved all video
	     */
	
	
	    // function for get  video report
	
	  }, {
	    key: 'OpenEditQuesReport',
	
	
	    /*
	    -------------------------------------------------
	      function for open the question report model
	    -------------------------------------------------
	      */
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment,
	        type: 'quesReport'
	      });
	    }
	
	    /*
	    ---------------------------------------------------
	      function for open the edit notes report model
	    --------------------------------------------------
	      */
	
	  }, {
	    key: 'OpenEditNotesReport',
	    value: function OpenEditNotesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        notesReport: item.comment,
	        type: 'notesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditVideoReport',
	    value: function OpenEditVideoReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        videoReport: item.comment,
	        type: 'videoReport'
	      });
	    }
	
	    /*
	    -----------------------------------------------------
	     function for close the edit question report model
	    -----------------------------------------------------
	     */
	
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	
	    /*
	    ----------------------------------------------------
	      function for close the edit notes reports model
	    ----------------------------------------------------
	     */
	
	  }, {
	    key: 'CloseEditNotesReport',
	    value: function CloseEditNotesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        notesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditVideoReport',
	    value: function CloseEditVideoReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        videoReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	
	    /*
	    ---------------------------------------------------
	      function for open the reports answer view model
	    ---------------------------------------------------
	     */
	
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, data, e) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: data
	      });
	    }
	
	    /*
	    ----------------------------------------------------
	      function for close the reports answer view model
	    ----------------------------------------------------
	     */
	
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        ErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      // console.log('dfaay', data);
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: data.id,
	          contactType: type,
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleDone',
	
	
	    /*
	    ----------------------------------
	      function for delete the data
	    ----------------------------------
	     */
	    value: function () {
	      var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee33() {
	        var _this4 = this;
	
	        var _state, idname, token, item_status, items_val, question_id, item_id, video_id, data;
	
	        return _regenerator2.default.wrap(function _callee33$(_context33) {
	          while (1) {
	            switch (_context33.prev = _context33.next) {
	              case 0:
	                /*
	                -------------------------------------------
	                 API for delete the questions  flashcard
	                -------------------------------------------
	                */
	                _state = this.state, idname = _state.idname, token = _state.token, item_status = _state.item_status, items_val = _state.items_val;
	                question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	                if (!(this.state.item_status === 'flashcard')) {
	                  _context33.next = 6;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context33.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteFlashCard', data).then(function () {
	                  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(resp) {
	                    return _regenerator2.default.wrap(function _callee24$(_context24) {
	                      while (1) {
	                        switch (_context24.prev = _context24.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context24.next = 5;
	                              break;
	                            }
	
	                            _context24.next = 3;
	                            return _this4.getQuestionFlashCards();
	
	                          case 3:
	                            _context24.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context24.stop();
	                        }
	                      }
	                    }, _callee24, _this4);
	                  }));
	
	                  return function (_x16) {
	                    return _ref25.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                if (!(this.state.item_status === 'Notesflashcard')) {
	                  _context33.next = 10;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context33.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/deleteDashboardFlashCard', data).then(function () {
	                  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(resp) {
	                    return _regenerator2.default.wrap(function _callee25$(_context25) {
	                      while (1) {
	                        switch (_context25.prev = _context25.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context25.next = 5;
	                              break;
	                            }
	
	                            _context25.next = 3;
	                            return _this4.getNotesFlashCards();
	
	                          case 3:
	                            _context25.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context25.stop();
	                        }
	                      }
	                    }, _callee25, _this4);
	                  }));
	
	                  return function (_x17) {
	                    return _ref26.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	                if (!(this.state.item_status == 'Videoflashcard')) {
	                  _context33.next = 14;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context33.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/deleteDashboardVideoFlashCard', data).then(function () {
	                  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(resp) {
	                    return _regenerator2.default.wrap(function _callee26$(_context26) {
	                      while (1) {
	                        switch (_context26.prev = _context26.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context26.next = 5;
	                              break;
	                            }
	
	                            _context26.next = 3;
	                            return _this4.getVideoFlashcards();
	
	                          case 3:
	                            _context26.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context26.stop();
	                        }
	                      }
	                    }, _callee26, _this4);
	                  }));
	
	                  return function (_x18) {
	                    return _ref27.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	
	                /*
	                ---------------------------------
	                  API to delete saved questions
	                ---------------------------------
	                 */
	                if (item_status === 'savedquestion') {
	                  data = {
	                    token: token,
	                    idname: idname,
	                    save_question: items_val
	                  };
	
	                  this.deleteFlashCard('question', question_id ? question_id : item_id);
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteSavequestion', data).then(function () {
	                    var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(resp) {
	                      return _regenerator2.default.wrap(function _callee27$(_context27) {
	                        while (1) {
	                          switch (_context27.prev = _context27.next) {
	                            case 0:
	                              if (!resp.success) {
	                                _context27.next = 5;
	                                break;
	                              }
	
	                              _context27.next = 3;
	                              return _this4.getQuestionSaved();
	
	                            case 3:
	                              _context27.next = 6;
	                              break;
	
	                            case 5:
	                              console.log('error');
	
	                            case 6:
	                            case 'end':
	                              return _context27.stop();
	                          }
	                        }
	                      }, _callee27, _this4);
	                    }));
	
	                    return function (_x19) {
	                      return _ref28.apply(this, arguments);
	                    };
	                  }());
	                }
	
	                /*
	                ------------------------------------------
	                  API to delete saved notes by user id
	                ------------------------------------------
	                 */
	                if (item_status === 'savednotes') {
	                  data = {
	                    token: token,
	                    idname: idname,
	                    save_question: items_val
	                  };
	
	                  this.deleteFlashCard('notes', question_id ? question_id : item_id);
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/deleteSaveNotes', data).then(function () {
	                    var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(resp) {
	                      return _regenerator2.default.wrap(function _callee28$(_context28) {
	                        while (1) {
	                          switch (_context28.prev = _context28.next) {
	                            case 0:
	                              if (!resp.success) {
	                                _context28.next = 5;
	                                break;
	                              }
	
	                              _context28.next = 3;
	                              return _this4.getNotesSaved();
	
	                            case 3:
	                              _context28.next = 6;
	                              break;
	
	                            case 5:
	                              console.log('error');
	
	                            case 6:
	                            case 'end':
	                              return _context28.stop();
	                          }
	                        }
	                      }, _callee28, _this4);
	                    }));
	
	                    return function (_x20) {
	                      return _ref29.apply(this, arguments);
	                    };
	                  }());
	                }
	
	                if (!(item_status == 'savedvideos')) {
	                  _context33.next = 21;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val
	                };
	
	                this.deleteFlashCard('video', video_id ? video_id : item_id);
	                _context33.next = 21;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/deleteSaveVideo', data).then(function () {
	                  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(resp) {
	                    return _regenerator2.default.wrap(function _callee29$(_context29) {
	                      while (1) {
	                        switch (_context29.prev = _context29.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context29.next = 5;
	                              break;
	                            }
	
	                            _context29.next = 3;
	                            return _this4.getVideosSaved();
	
	                          case 3:
	                            _context29.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context29.stop();
	                        }
	                      }
	                    }, _callee29, _this4);
	                  }));
	
	                  return function (_x21) {
	                    return _ref30.apply(this, arguments);
	                  };
	                }()
	                // console.log("error");
	                );
	
	              case 21:
	                if (!(this.state.item_status == 'Reportsquestion')) {
	                  _context33.next = 25;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context33.next = 25;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteDashboardQuestionReports', data).then(function () {
	                  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(resp) {
	                    return _regenerator2.default.wrap(function _callee30$(_context30) {
	                      while (1) {
	                        switch (_context30.prev = _context30.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context30.next = 5;
	                              break;
	                            }
	
	                            _context30.next = 3;
	                            return _this4.getQuestionReports();
	
	                          case 3:
	                            _context30.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context30.stop();
	                        }
	                      }
	                    }, _callee30, _this4);
	                  }));
	
	                  return function (_x22) {
	                    return _ref31.apply(this, arguments);
	                  };
	                }());
	
	              case 25:
	                if (!(this.state.item_status == 'Reportsnotes')) {
	                  _context33.next = 29;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context33.next = 29;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/deleteDashboardNotesReports', data).then(function () {
	                  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(resp) {
	                    return _regenerator2.default.wrap(function _callee31$(_context31) {
	                      while (1) {
	                        switch (_context31.prev = _context31.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context31.next = 5;
	                              break;
	                            }
	
	                            _context31.next = 3;
	                            return _this4.getNotesReports();
	
	                          case 3:
	                            _context31.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context31.stop();
	                        }
	                      }
	                    }, _callee31, _this4);
	                  }));
	
	                  return function (_x23) {
	                    return _ref32.apply(this, arguments);
	                  };
	                }());
	
	              case 29:
	                if (!(this.state.item_status == 'Reportsvideos')) {
	                  _context33.next = 33;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context33.next = 33;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/deleteDashboardVideoReports', data).then(function () {
	                  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(resp) {
	                    return _regenerator2.default.wrap(function _callee32$(_context32) {
	                      while (1) {
	                        switch (_context32.prev = _context32.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context32.next = 5;
	                              break;
	                            }
	
	                            _context32.next = 3;
	                            return _this4.getVideoReports();
	
	                          case 3:
	                            _context32.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context32.stop();
	                        }
	                      }
	                    }, _callee32, _this4);
	                  }));
	
	                  return function (_x24) {
	                    return _ref33.apply(this, arguments);
	                  };
	                }());
	
	              case 33:
	
	                this.setState({
	                  alert_status: false
	                });
	
	              case 34:
	              case 'end':
	                return _context33.stop();
	            }
	          }
	        }, _callee33, this);
	      }));
	
	      function toggleDone() {
	        return _ref24.apply(this, arguments);
	      }
	
	      return toggleDone;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate !== '') {
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this5 = this;
	
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this5.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block'
	              });
	            } else {
	              _this5.setState({
	                display_main_loader: 'hide_block'
	              });
	              console.log(resp.success + '------------failure');
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (i = 0; i < dataReason.length; i++) {
	                var right_answered = dataReason[i].answered_count;
	                var total_question = dataReason[i].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	
	              _this5.setState({ bar_main_class: final_array_main });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getProgressChapter', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({ progress_bar_zero: resp.chapters });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({
	                progress_bar_zero: resp.progressbarzero_data,
	                qpLoader: false
	              });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getNotesChapter', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({ bar_chapter: resp.chapters });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/getnotesprogByuser', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({
	                progress_bar: resp.progressbar_data,
	                npLoader: false
	              });
	            } else {
	              console.log(resp.success + '------------failure');
	            }
	          });
	        });
	      }
	    }
	
	    /*
	    -----------------------------------------------------
	      function  for delete the falshcards for questions
	    -----------------------------------------------------
	     */
	
	
	    /*
	    ---------------------------------------------
	     function to delete the flashcard for notes
	    ----------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------
	      function to delete the saved questions
	    -------------------------------------------
	     */
	
	
	    /*
	    ---------------------------------------
	      function to delete the saved notes
	    ---------------------------------------
	     */
	
	    /*
	    -----------------------------------------------
	     function to delete the reports for questions
	    -----------------------------------------------
	     */
	
	
	    /*
	    ---------------------------------------------
	      function to delete the reports for notes
	    ---------------------------------------------
	     */
	
	
	    /*
	    ---------------------------------------------------------------
	      function for navigate a specific question to its main page.
	    ---------------------------------------------------------------
	     */
	
	
	    /*
	    -----------------------------------------------------------
	      Function to navigate a specific notes to its main page
	    -----------------------------------------------------------
	     */
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                item.chapter_id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'notesProgressBarFun',
	    value: function notesProgressBarFun() {
	      return this.state.progress_bar.map(function (item, index) {
	        var progresstotalques = item.chapterallqurestion;
	        var progressnotes = Math.round(item.fav / progresstotalques * 100);
	        if (progressnotes < 1) {
	          progressnotes = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                item.chapter_id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes,
	                      style: { width: progressnotes + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	
	    /*
	    ---------------------------------------------------
	     function for submiting the question  form data
	    ---------------------------------------------------
	    */
	
	  }, {
	    key: 'handleQuestionReportSubmit',
	    value: function () {
	      var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(event) {
	        var _this6 = this;
	
	        var _state2, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee35$(_context35) {
	          while (1) {
	            switch (_context35.prev = _context35.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context35.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context35.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, quesReport = _state2.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context35.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(resp) {
	                    return _regenerator2.default.wrap(function _callee34$(_context34) {
	                      while (1) {
	                        switch (_context34.prev = _context34.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context34.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context34.next = 4;
	                            return _this6.getQuestionReports();
	
	                          case 4:
	                            _context34.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context34.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context34.stop();
	                        }
	                      }
	                    }, _callee34, _this6);
	                  }));
	
	                  return function (_x26) {
	                    return _ref35.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context35.stop();
	            }
	          }
	        }, _callee35, this);
	      }));
	
	      function handleQuestionReportSubmit(_x25) {
	        return _ref34.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    /*
	    ----------------------------------------------
	     function for submitting the notes form data
	    ----------------------------------------------
	     */
	
	  }, {
	    key: 'handleNotesReportSubmit',
	    value: function () {
	      var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, notesReport, data;
	
	        return _regenerator2.default.wrap(function _callee37$(_context37) {
	          while (1) {
	            switch (_context37.prev = _context37.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport === '' && this.state.notesReport.length < 1)) {
	                  _context37.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context37.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, notesReport = _state3.notesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport
	                };
	                _context37.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(resp) {
	                    return _regenerator2.default.wrap(function _callee36$(_context36) {
	                      while (1) {
	                        switch (_context36.prev = _context36.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context36.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              notesReport: ''
	                            });
	                            _context36.next = 4;
	                            return _this7.getNotesReports();
	
	                          case 4:
	                            _context36.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context36.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context36.stop();
	                        }
	                      }
	                    }, _callee36, _this7);
	                  }));
	
	                  return function (_x28) {
	                    return _ref37.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context37.stop();
	            }
	          }
	        }, _callee37, this);
	      }));
	
	      function handleNotesReportSubmit(_x27) {
	        return _ref36.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit;
	    }()
	
	    // video form submit function
	
	  }, {
	    key: 'handleVideoReportSubmit',
	    value: function () {
	      var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(event) {
	        var _this8 = this;
	
	        var _state4, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee39$(_context39) {
	          while (1) {
	            switch (_context39.prev = _context39.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.videoReport === '' && this.state.videoReport.length < 1)) {
	                  _context39.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context39.abrupt('return');
	
	              case 4:
	                _state4 = this.state, reportEditId = _state4.reportEditId, idname = _state4.idname, token = _state4.token, videoReport = _state4.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context39.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(resp) {
	                    return _regenerator2.default.wrap(function _callee38$(_context38) {
	                      while (1) {
	                        switch (_context38.prev = _context38.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context38.next = 6;
	                              break;
	                            }
	
	                            _this8.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this8.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context38.next = 4;
	                            return _this8.getVideoReports();
	
	                          case 4:
	                            _context38.next = 7;
	                            break;
	
	                          case 6:
	                            _this8.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context38.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context38.stop();
	                        }
	                      }
	                    }, _callee38, _this8);
	                  }));
	
	                  return function (_x30) {
	                    return _ref39.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context39.stop();
	            }
	          }
	        }, _callee39, this);
	      }));
	
	      function handleVideoReportSubmit(_x29) {
	        return _ref38.apply(this, arguments);
	      }
	
	      return handleVideoReportSubmit;
	    }()
	    /*
	    -----------------------------------------------------------
	     function for state change of edit report form fileds
	    -----------------------------------------------------------
	    */
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    /*
	    ----------------------------------------------------------
	      function for state change of edit report form fileds
	    ----------------------------------------------------------
	    */
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    /*
	    ---------------------------------------------------------
	      function for state change of edit report form fileds
	    ---------------------------------------------------------
	    */
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _state5 = this.state,
	          activeTabFlashcards = _state5.activeTabFlashcards,
	          activeTabSaved = _state5.activeTabSaved,
	          activeTabReports = _state5.activeTabReports,
	          qpLoader = _state5.qpLoader,
	          npLoader = _state5.npLoader,
	          savedLoader = _state5.savedLoader,
	          flashLoader = _state5.flashLoader,
	          reportLoader = _state5.reportLoader;
	
	      var flashreport_val = this.state.flashreport;
	      var notes_flashreport_val = this.state.notesFlashReport;
	      var video_flashreport_val = this.state.videoFlashReport;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savednotes_val = this.state.savednotes;
	      var savedvideo_val = this.state.savedvideo;
	
	      var progress_bar_zero_val = this.state.progress_bar_zero;
	      var progress_barnotes_val = this.state.progress_bar;
	
	      var reportquestion_val = this.state.reportquestion;
	      var reportnotes_val = this.state.reportnotes;
	      var reportvideo_val = this.state.reportsvideo;
	
	      var flashcard_data = '';
	      var notes_flashcard_data = '';
	      var video_flashcard_data = '';
	
	      var savedquestion_data = '';
	      var savednotes_data = '';
	      var savedvideo_data = '';
	
	      var progress_bar_data = '';
	
	      var question_reportsData = ''; // for question reports
	      var notes_reportsData = ''; // for notes report
	      var video_reportsData = '';
	
	      var token_Val = this.state.token;
	      var idname_Val = this.state.idname;
	      /*first main graph*/
	      var main_bar_val = this.state.bar_chapter;
	      var main_bar_percentage = this.state.bar_main_user;
	
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	
	      Object.keys(main_bar_val).map(function (key) {
	        var dataString = JSON.stringify(main_bar_val[key]);
	        var dataReason = JSON.parse(dataString);
	        main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
	        var chapter_id = dataReason.chapter_id;
	
	        i++;
	      });
	
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31, 140, 235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31, 140, 235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	
	      /*other graph*/
	      var chapters = this.state.chapters;
	      var reading_data = '';
	      // alert(this.state.subreadings_status);
	      if (this.state.chapters.length && !this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	          );
	        });
	      }
	      if (this.state.chapters.length && this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	            )
	          );
	        });
	      }
	
	      /*
	      ------------------------------
	      For question flashcard
	      ------------------------------
	       */
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              ' ',
	              items.flash_card
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      /*
	      -------------------------
	        For notes flashcard
	      ------------------------
	       */
	
	      if (this.state.notesFlashReport.length) {
	        notes_flashcard_data = notes_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteNotesFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.videoFlashReport.length) {
	        video_flashcard_data = video_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'videoFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteVideoFlashcard.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else {
	        video_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      /*
	      ------------------------
	        For saved questions
	      ------------------------
	       */
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSavequestino.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)((items.topic_name || '').replace(/LOS \d*/i, ''), "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_QUESTIONS,
	          ' '
	        );
	      }
	
	      /*
	      -------------------
	        For Saved Notes
	      -------------------
	       */
	      if (this.state.savednotes.length) {
	        savednotes_data = savednotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSavedNotes.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)((items.topic_name || '').replace(/LOS \d*/i, ''), "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_NOTES,
	          ' '
	        );
	      }
	
	      /*
	      ------------------------------
	        For Saved Videos
	      ------------------------------
	       */
	
	      if (this.state.savedvideo.length) {
	        savedvideo_data = savedvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteSavedVideo.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)((items.topic_name || '').replace(/LOS \d*/i, ''), "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else {
	        savedvideo_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	
	      /*
	      ------------------------------
	        For report questions
	      ------------------------------
	       */
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditQuesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'quesReport',
	                  toggle: _this9.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleQuestionReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment-' + index,
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginChapter.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this9.toggleAlertReport.bind(_this9, items, 'quesReport'),
	                  className: _this9.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'quesReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'quesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'quesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'quesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'quesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsquestino.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      /*
	      ---------------------
	        For notes report
	      ---------------------
	       */
	      if (this.state.reportnotes.length) {
	        notes_reportsData = reportnotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditNotesReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'notesReport',
	                  toggle: _this9.OpenEditNotesReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditNotesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleNotesReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment-' + index + '_' + items.id,
	                            name: 'notesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.notesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditNotesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginNotes.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items, 'notesReport'),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'notesReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'notesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'notesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'notesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'notesReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsNotes.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportsvideo.length) {
	        video_reportsData = reportvideo_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this9.OpenEditVideoReport.bind(_this9, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this9.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportEditStatus && _this9.state.reportEditId === items.id && _this9.state.type === 'videoReport',
	                  toggle: _this9.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this9.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this9.handleVideoReportSubmit.bind(_this9) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this9.InputChange.bind(_this9),
	                            value: _this9.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            _this9.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this9.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._beginVideos.bind(_this9, items),
	                    className: _this9.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9.toggleAlertReport.bind(_this9, items, 'videoReport'),
	                    className: _this9.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this9.state.reportAnswerStatus && _this9.state.reportAnswerId === items.id && _this9.state.type === 'videoReport',
	                  toggle: _this9.toggleAlertReport,
	                  className: 'modal-primary ' + _this9.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this9.state.contactStatus && _this9.state.contactType === 'videoReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this9.onContactChange.bind(_this9, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this9.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this9.state.contactStatus && _this9.state.contactType === 'videoReport' && _this9.state.contactID === items.id && _this9.state.contactIndex === index ? !_this9.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this9.onContactSubmit.bind(_this9) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this9.SubjectInputChange.bind(_this9),
	                          value: _this9.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this9.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this9.CommentInputChange.bind(_this9),
	                          value: _this9.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this9.state.displaytext + ' text-danger' },
	                          _this9.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this9.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this9.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this9._deleteReportsVideo.bind(_this9, items),
	                    className: _this9.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        video_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  _language2.default.LC().DASHBOARD
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this9.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this9.savedTabToggle('2');
	                        },
	                        className: activeTabSaved === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this9.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : this.state.activeTabSaved === '2' ? savednotes_data : this.state.activeTabSaved === '3' ? savedvideo_data : null
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this9.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this9.reportsTabToggle('2');
	                        },
	                        className: activeTabReports === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    ' ',
	                    this.state.isVideo ? _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this9.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().VIDEOS,
	                        ' '
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : this.state.activeTabReports === '2' ? notes_reportsData : this.state.activeTabReports === '3' ? video_reportsData : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    npLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.notesProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.toggleClose },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_Dashboard;
	}(_react.Component);
	
	SOA_FM_Dashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var bar_data_sub = [];
	var reading_text = '';
	function Barget(props) {
	  if (props.subreadings_status && props.endDate !== '') {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: props.startDate,
	      endDate: props.endDate
	    };
	  } else {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: '',
	      endDate: ''
	    };
	  }
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/subProgressbar', data).then(function (resp) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_dashboard/subProgressbarofclass', data).then(function (resp_class) {
	      var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
	      var dataReason_class = JSON.parse(dataString_class);
	      var final_array_main_class = [];
	
	      for (i = 0; i < dataReason_class.length; i++) {
	        var right_answered_class = dataReason_class[i].right_answer;
	        var total_question_class = dataReason_class[i].total_questions;
	        var user_graph_val_class = (right_answered_class / total_question_class * 100).toFixed(2);
	        final_array_main_class.push(user_graph_val_class);
	      }
	      // console.log('abc------------------'+final_array_main_class+'-------ssss--------');
	      /*user variable*/
	      var dataString = JSON.stringify(resp.readingwisebar_ret);
	      var dataReason = JSON.parse(dataString);
	      var final_array_main = [];
	      var reading_text = [];
	
	      for (i = 0; i < dataReason.length; i++) {
	        var right_answered = dataReason[i].right_answer;
	        var total_question = dataReason[i].total_questions;
	        var user_graph_val = (right_answered / total_question * 100).toFixed(2);
	
	        final_array_main.push(user_graph_val);
	        reading_text.push(dataReason[i].reading.substring(0, 14));
	      }
	
	      bar_data_sub[props.answered_state] = {
	        labels: reading_text,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(114,195,250)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(114,195,250)',
	          data: final_array_main
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: final_array_main_class
	        }]
	      };
	    });
	  });
	  return _react2.default.createElement(_reactChartjs.Bar, { data: bar_data_sub[props.answered_state], options: { maintainAspectRatio: false } });
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this10 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this10.toggle = _this10.toggle.bind(_this10);
	    _this10.state = {
	      tooltipOpen: false
	    };
	    return _this10;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_FM_Dashboard;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Soa_fm_flashquestion = function (_Component) {
	  _inherits(Soa_fm_flashquestion, _Component);
	
	  function Soa_fm_flashquestion(props) {
	    _classCallCheck(this, Soa_fm_flashquestion);
	
	    var _this = _possibleConstructorReturn(this, (Soa_fm_flashquestion.__proto__ || Object.getPrototypeOf(Soa_fm_flashquestion)).call(this, props));
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/soa/financialmathematics/beginchapter/' + 1 + '/' + resp.questionsbyid.chapter_id + '/' + item.question_id,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              chapter: resp.questionsbyid.chapter_id
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      flashreport: [], //All Flash question Store
	      token: '',
	      idname: '',
	      ValidToken: false,
	      no_result_display: '',
	      username: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(Soa_fm_flashquestion, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      window.scrollTo(0, 0);
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this2.setState({ flashreport: resp.flash_report });
	          if (!resp.flash_report.length) {
	            _this2.setState({
	              no_result_display: '' + _language2.default.LC().NO_SAVED_FLASHCARDS
	            });
	          }
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	
	    //Function to toggle alert box
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	
	    //Function to delete flash card
	
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	
	    //Function to close toggle and set items status blank
	
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	
	    //On Click ok button from alert perform deletion of cfa flash card
	
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this3 = this;
	
	      if (this.state.item_status === 'flashcard') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          flash_card: this.state.items_val
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteFlashCard', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('flash_' + _this3.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	
	    //On click delete button ,set item value and open toggle alert
	
	
	    //Function to redirect, page to Dashboard page
	
	
	    //Function to redirect page to particular question id
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var flashreport_val = this.state.flashreport;
	      var flashcard_data = '';
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row  align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ':',
	                    ' ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().Saved_Note,
	                      ': '
	                    ),
	                    ' ',
	                    items.flash_card
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._beginChapter.bind(_this4, items),
	                        className: _this4.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._deleteFlashcard.bind(_this4, items),
	                        className: _this4.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_FLASHCARDS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                ' ',
	                _language2.default.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW,
	                ':',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          flashcard_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: this.toggleDone },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Soa_fm_flashquestion;
	}(_react.Component);
	
	Soa_fm_flashquestion.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Soa_fm_flashquestion;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var Soa_fm_flashquestionnotes = function (_Component) {
	  _inherits(Soa_fm_flashquestionnotes, _Component);
	
	  function Soa_fm_flashquestionnotes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Soa_fm_flashquestionnotes);
	
	    var _this = _possibleConstructorReturn(this, (Soa_fm_flashquestionnotes.__proto__ || Object.getPrototypeOf(Soa_fm_flashquestionnotes)).call(this, props));
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(reading, e) {
	        var reading_id, chapter_id, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                _context.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    chapter_id = resp.notes[0].chapter_id;
	                    reading_id = resp.notes[0].reading_id;
	
	                    _this.context.router.push({
	                      pathname: '/soa/financialmathematics/beginnotes/' + chapter_id + '/' + reading.question_id,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter: chapter_id,
	                        offset: 0
	                      }
	                    });
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      flashreport: [], //All Flash question Store
	      token: '',
	      idname: '',
	      ValidToken: false,
	      no_result_display: '',
	      username: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(Soa_fm_flashquestionnotes, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFlashcardsnotesbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ flashreport: resp.flash_report });
	          if (!resp.flash_report.length) {
	            _this3.setState({
	              no_result_display: '' + _language2.default.LC().NO_SAVED_FLASHCARDS
	            });
	          }
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	
	    //Function to toggle alert box
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	
	    //Function to delete flash card
	
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	
	    //Function to close toggle and set items status blank
	
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	
	    //On Click ok button from alert perform deletion of cfa flash card
	
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this4 = this;
	
	      if (this.state.item_status === 'Notesflashcard') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          flash_card: this.state.items_val
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/deleteDashboardFlashCard', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('notesFlash_' + _this4.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	
	    //On click delete button ,set item value and open toggle alert
	
	
	    //Function to redirect, page to Dashboard page
	
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var flashreport_val = this.state.flashreport;
	      var flashcard_data = '';
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row  align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ':',
	                    ' ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().Saved_Note,
	                      ': '
	                    ),
	                    ' ',
	                    items.flash_card
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this5._beginNotes.bind(_this5, items),
	                        className: _this5.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this5._deleteNotesFlashcard.bind(_this5, items),
	                        className: _this5.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_FLASHCARDS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                ' ',
	                _language2.default.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW,
	                ':',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          flashcard_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: this.toggleDone },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Soa_fm_flashquestionnotes;
	}(_react.Component);
	
	Soa_fm_flashquestionnotes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Soa_fm_flashquestionnotes;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _messages = __webpack_require__(14);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_FM_Notes = function (_Component) {
	  _inherits(SOA_FM_Notes, _Component);
	
	  function SOA_FM_Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_Notes);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_Notes.__proto__ || Object.getPrototypeOf(SOA_FM_Notes)).call(this, props));
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(chapter, e) {
	        var verifyData;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                verifyData = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chapter.chapter_no
	                };
	                //* Please avoid this code, I have added this code in todo list for optimization
	
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getActiveNotes', verifyData).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    var final_exam, data;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 11;
	                              break;
	                            }
	
	                            if (!(chapter.chapter_no === 1)) {
	                              _context2.next = 5;
	                              break;
	                            }
	
	                            _this.context.router.push({
	                              pathname: '/soa/financialmathematics/beginnotes/' + chapter.chapter_no,
	                              state: {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                chapter: chapter.chapter_no
	                              }
	                            });
	                            _context2.next = 9;
	                            break;
	
	                          case 5:
	                            final_exam = [];
	                            data = { token: _this.state.token, idname: _this.state.idname };
	                            _context2.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                              // console.log("resp", resp);
	                              if (resp.profileInfo.role === 'partner') {
	                                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                                  _this.toggleAlert();
	                                } else {
	                                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                                  var dataset = {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    examid: data_arr
	                                  };
	                                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                      var exam_data, selectedmen, isInArray_var;
	                                      return _regenerator2.default.wrap(function _callee$(_context) {
	                                        while (1) {
	                                          switch (_context.prev = _context.next) {
	                                            case 0:
	                                              if (!resp_exam.success) {
	                                                _context.next = 8;
	                                                break;
	                                              }
	
	                                              exam_data = resp_exam.examData;
	                                              selectedmen = _this.state.selectedmenu;
	                                              isInArray_var = false;
	                                              _context.next = 6;
	                                              return _SoaFMSubscription4.default.checkSoaFMNotesSubscription(selectedmen, exam_data);
	
	                                            case 6:
	                                              isInArray_var = _context.sent;
	
	                                              if (isInArray_var) {
	                                                _this.context.router.push({
	                                                  pathname: '/soa/financialmathematics/beginnotes/' + chapter.chapter_no,
	                                                  state: {
	                                                    token: _this.state.token,
	                                                    idname: _this.state.idname,
	                                                    chapter: chapter.chapter_no
	                                                  }
	                                                });
	                                              } else {
	                                                _this.toggleAlert();
	                                              }
	
	                                            case 8:
	                                            case 'end':
	                                              return _context.stop();
	                                          }
	                                        }
	                                      }, _callee, _this2);
	                                    }));
	
	                                    return function (_x4) {
	                                      return _ref3.apply(this, arguments);
	                                    };
	                                  }());
	                                }
	                              } else {
	                                if (resp.profileInfo.exam_selected === '') {
	                                  _this.toggleAlert();
	                                } else {
	                                  var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                                  var dataset = {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    examid: data_arr
	                                  };
	                                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                                    // console.log(resp_exam);
	                                    if (resp_exam.success) {
	                                      var exam_data = resp_exam.examData;
	                                      var selectedmen = _this.state.selectedmenu;
	                                      var isInArray_var = false;
	                                      // console.log(exam_data);
	                                      // console.log(selectedmen);
	                                      isInArray_var = _SoaFMSubscription2.default.checkSoaFMNotesSubscription(selectedmen, exam_data);
	                                      // console.log(isInArray_var);
	                                      if (isInArray_var) {
	                                        _this.context.router.push({
	                                          pathname: '/soa/financialmathematics/beginnotes/' + chapter.chapter_no,
	                                          state: {
	                                            token: _this.state.token,
	                                            idname: _this.state.idname,
	                                            chapter: chapter.chapter_no
	                                          }
	                                        });
	                                      } else {
	                                        _this.toggleAlert();
	                                      }
	                                    } else {
	                                      // console.log('fail');
	                                    }
	                                  });
	                                }
	                              }
	                            });
	
	                          case 9:
	                            _context2.next = 12;
	                            break;
	
	                          case 11:
	                            _this.ActiveToggleAlert();
	
	                          case 12:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdf = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(_this.state.pdfLoading === false)) {
	                  _context6.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context6.abrupt('return');
	
	              case 3:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee5$(_context5) {
	                      while (1) {
	                        switch (_context5.prev = _context5.next) {
	                          case 0:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context5.next = 4;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context5.next = 8;
	                            break;
	
	                          case 4:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context5.next = 8;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                                var exam_data, selectedmen, isInArray_varPDF, dataset;
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context4.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_varPDF = false;
	                                        _context4.next = 6;
	                                        return _SoaFMSubscription2.default.checkSoaFM_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_varPDF = _context4.sent;
	
	                                        if (!isInArray_varPDF) {
	                                          _context4.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context4.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context4.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.toggleAlert();
	
	                                      case 15:
	                                        _context4.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this2);
	                              }));
	
	                              return function (_x7) {
	                                return _ref6.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 8:
	                          case 'end':
	                            return _context5.stop();
	                        }
	                      }
	                    }, _callee5, _this2);
	                  }));
	
	                  return function (_x6) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x5) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.goToNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: '/soa/financialmathematics/beginnotes/' + lastRecord.soa_fm_note.chapter_id,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.soa_fm_note.chapter_id
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      PDF_Alert_status: false,
	      Active_Alert_status: false,
	
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_soa_fm,
	
	      ActiveMessageTitle: '' + _language2.default.LC().MESSAGE,
	      ActiveMessageContent: '' + _language2.default.LC().NOTE_NOT_FOUND,
	
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      pdfLoading: true,
	      showFreePremium: '',
	      showFreePremiumPDF: '',
	      selectedmenu: 'soa_fm',
	      lastRecord: '',
	      lastAttempt: false,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      type: 'notes',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	
	    _this.ActiveToggleAlert = _this.ActiveToggleAlert.bind(_this);
	    _this.PDFDownloadAlertModel = _this.PDFDownloadAlertModel.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(SOA_FM_Notes, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'ActiveToggleAlert',
	    value: function ActiveToggleAlert() {
	      this.setState({
	        Active_Alert_status: !this.state.Active_Alert_status
	      });
	    }
	  }, {
	    key: 'PDFDownloadAlertModel',
	    value: function PDFDownloadAlertModel() {
	      this.setState({
	        PDF_Alert_status: !this.state.PDF_Alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context11.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context11.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                if (localStorage.getItem('selectedmenu') === 'frm') {
	                  this.context.router.push({
	                    pathname: '/frm/questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getChapters', data).then(function () {
	                  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var data;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            // console.log(resp);
	                            if (resp.success) {
	                              _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                              data = { token: _this3.state.token, idname: _this3.state.idname };
	
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getlastReadNotes', data).then(function (response) {
	                                if (response.success) {
	                                  _this3.setState({
	                                    lastRecord: response.data,
	                                    lastAttempt: true
	                                  });
	                                }
	                              });
	                            } else {
	                              _this3.setState({ ValidToken: false });
	                            }
	                            return _context8.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this3);
	                  }));
	
	                  return function (_x8) {
	                    return _ref9.apply(this, arguments);
	                  };
	                }());
	                this.dispose = (0, _mobx.autorun)(function () {
	                  var resp = _userStore2.default;
	
	                  if (resp == null || resp.profileInfo == null) {
	                    return;
	                  }
	                  // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	                  //console.log("resp getProfile info", resp);
	
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this3.setState({ showFreePremium: true, showFreePremiumPDF: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var, isInArray_varPDF;
	                          return _regenerator2.default.wrap(function _callee9$(_context9) {
	                            while (1) {
	                              switch (_context9.prev = _context9.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context9.next = 15;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this3.state.selectedmenu;
	                                  isInArray_var = false;
	                                  isInArray_varPDF = false;
	                                  _context9.next = 7;
	                                  return _SoaFMSubscription4.default.checkSoaFMNotesSubscription(selectedmen, exam_data);
	
	                                case 7:
	                                  isInArray_var = _context9.sent;
	
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                  _context9.next = 11;
	                                  return _SoaFMSubscription4.default.checkSoaFM_PDFSubscription(selectedmen, exam_data, _this3.state.type);
	
	                                case 11:
	                                  isInArray_varPDF = _context9.sent;
	
	                                  if (isInArray_varPDF) {
	                                    _this3.setState({ showFreePremiumPDF: false });
	                                  } else {
	                                    _this3.setState({ showFreePremiumPDF: true });
	                                  }
	                                  _context9.next = 15;
	                                  break;
	
	                                case 15:
	                                case 'end':
	                                  return _context9.stop();
	                              }
	                            }
	                          }, _callee9, _this3);
	                        }));
	
	                        return function (_x9) {
	                          return _ref10.apply(this, arguments);
	                        };
	                      }()
	                      //console.log("fail");
	                      );
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      _this3.setState({ showFreePremium: true, showFreePremiumPDF: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var, isInArray_varPDF;
	                          return _regenerator2.default.wrap(function _callee10$(_context10) {
	                            while (1) {
	                              switch (_context10.prev = _context10.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context10.next = 15;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this3.state.selectedmenu;
	                                  isInArray_var = false;
	                                  isInArray_varPDF = false;
	                                  _context10.next = 7;
	                                  return _SoaFMSubscription2.default.checkSoaFMNotesSubscription(selectedmen, exam_data);
	
	                                case 7:
	                                  isInArray_var = _context10.sent;
	
	                                  //console.log(isInArray_var);
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                  _context10.next = 11;
	                                  return _SoaFMSubscription2.default.checkSoaFM_PDFSubscription(selectedmen, exam_data, _this3.state.type);
	
	                                case 11:
	                                  isInArray_varPDF = _context10.sent;
	
	                                  //console.log(isInArray_varPDF);
	                                  if (isInArray_varPDF) {
	                                    _this3.setState({ showFreePremiumPDF: false });
	                                  } else {
	                                    _this3.setState({ showFreePremiumPDF: true });
	                                  }
	                                  _context10.next = 15;
	                                  break;
	
	                                case 15:
	                                case 'end':
	                                  return _context10.stop();
	                              }
	                            }
	                          }, _callee10, _this3);
	                        }));
	
	                        return function (_x10) {
	                          return _ref11.apply(this, arguments);
	                        };
	                      }()
	                      //console.log("fail");
	                      );
	                    }
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	
	    /*
	    ----------------------------------
	    Notes PDF DOWNLOAD Via email
	    ---------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters = this.state.chapters;
	      var data = '';
	      var lastAttempt = this.state.lastAttempt;
	
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                key: item.id,
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium ? item.id === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  item.chapter_no,
	                  ' ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                item.Countreading,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon3.svg',
	                      className: '',
	                      width: '20',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countquestion
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_NOTES
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-2 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().NOTES
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-10 margin_bottom_20 A_FM_notes_title_wrap' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn mr-1' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.showFreePremiumPDF ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Notes : '  please wait...'
	              )
	            ),
	            lastAttempt && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class ',
	                onClick: this.goToNotes,
	                disabled: !lastAttempt
	              },
	              _messages.messages.GO_TO_MY_LAST_READ_NOTE
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.Active_Alert_status,
	            toggle: this.ActiveToggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.ActiveToggleAlert },
	            this.state.ActiveMessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            this.state.ActiveMessageContent
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.PDFDownloadAlertModel.bind(this),
	          pdfAlert: this.state.PDF_Alert_status,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return SOA_FM_Notes;
	}(_react.Component);
	
	SOA_FM_Notes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_FM_Notes;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_FM_BeingNotes = function (_Component) {
	  _inherits(SOA_FM_BeingNotes, _Component);
	
	  function SOA_FM_BeingNotes(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, SOA_FM_BeingNotes);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_BeingNotes.__proto__ || Object.getPrototypeOf(SOA_FM_BeingNotes)).call(this, props));
	
	    _this.getNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                storage_session: storage_session,
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                chapter_id: _this.props.params.notesid,
	                offset: _this.state.offset,
	                limit: _this.state.limit
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getNotes_allcr', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                  var ques_res, offset_res, i, params;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!resp.success) {
	                            _context.next = 17;
	                            break;
	                          }
	
	                          _this.setState({
	                            ValidToken: true,
	                            all_questions_state: resp.questions
	                          });
	                          ques_res = [];
	                          offset_res = '';
	
	                          for (i = 0; i < resp.questions.length; i++) {
	                            if (resp.questions[i].chapter_id == _this.props.params.notesid) {
	                              ques_res = resp.questions[i];
	                              offset_res = i;
	                            }
	                            if (i == resp.questions.length - 1) {
	                              _this.setState({ display_loader: 'hide_block' });
	                            }
	                          }
	                          _this.setState({
	                            questions: ques_res,
	                            offset: offset_res,
	                            question_length: resp.questions.length
	                          });
	                          if (offset_res == 0) {
	                            _this.setState({ previ_block: 'card hide_block' });
	                          }
	                          //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
	                          if (offset_res == parseInt(resp.questions.length, 10) - 1) {
	                            _this.setState({ next_block: 'card hide_block' });
	                          }
	                          _context.next = 10;
	                          return _this.getSavedNotes(ques_res.id);
	
	                        case 10:
	                          params = {
	                            token: _this.state.token,
	                            question_id: ques_res.id,
	                            idname: _this.state.idname
	                          };
	
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getsavestatesNotes', params).then(function (response) {
	                            if (response.success) {
	                              _this.setState({
	                                save_question: 'btn btn-success pointer_class margin_right_10',
	                                save_text: '' + _language2.default.LC().MARKED_AS_READ,
	                                markColor: 'green'
	                              });
	                            } else {
	                              // console.log("enter else");
	                              setTimeout(_this.notes_MARKED_AS_READ.bind(_this, params), 120000);
	                            }
	                          });
	                          params = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            question_id: ques_res.id
	                          };
	
	                          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFlashCards', params).then(function (response) {
	                            var flash_cards = '';
	                            if (response.success) {
	                              _this.setState({ ValidToken: true });
	                              if (response.flash_cards.length > 0) {
	                                _this.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                });
	                                flash_cards = response.flash_cards.map(function (items, index) {
	                                  return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: '' },
	                                      _react2.default.createElement(
	                                        'ul',
	                                        { className: 'icon_list' },
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'li',
	                                          null,
	                                          _react2.default.createElement(
	                                            'a',
	                                            { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                                          )
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: _this.state.flash_class },
	                                        _react2.default.createElement('h4', null),
	                                        _react2.default.createElement(
	                                          'p',
	                                          null,
	                                          items.flash_card
	                                        )
	                                      )
	                                    )
	                                  );
	                                });
	                              } else {
	                                _this.setState({
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                                flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                              }
	                              _this.setState({ flash_data: flash_cards });
	                            } else {
	                              flash_cards = _react2.default.createElement(
	                                'p',
	                                null,
	                                _language2.default.LC().NO_FLASHCARD_FOUND
	                              );
	                              _this.setState({
	                                ValidToken: false,
	                                flash_data: flash_cards,
	                                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                              });
	                            }
	                            return response;
	                          });
	                          _this.setState({ records: '' });
	                          _context.next = 18;
	                          break;
	
	                        case 17:
	                          _this.setState({ ValidToken: false, records: 'Result not found.' });
	
	                        case 18:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getSavedNotes = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFavNotes', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/notes/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getNext = function () {
	      var _this$setState;
	
	      _this.setState((_this$setState = {
	        display_loader: 'show_block',
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block'
	      }, _defineProperty(_this$setState, 'report_block', 'card hide_block'), _defineProperty(_this$setState, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$setState, 'saveNotes_text', '' + _language2.default.LC().SAVE_NOTES), _this$setState));
	
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	
	      _this.setState({ offset: i, questions: _this.state.all_questions_state[i] });
	
	      //alert((parseInt(this.state.question_length)-1)+'--------'+i);
	      if (parseInt(_this.state.question_length) - 1 == i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i !== 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/beginnotes/' + _this.props.params.notesid + '/' + next_question_id + '/' + i,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      //alert(i);
	      // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (i === 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      }
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/beginnotes/' + _this.props.params.notesid + '/' + next_question_id + '/' + i,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      // console.log('Working');
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveNotesstats = function (item, e) {
	      if (_this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        notes_id: item.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            save_question: 'btn btn-success pointer_class margin_right_10',
	            save_text: '' + _language2.default.LC().MARKED_AS_READ,
	            markColor: 'green'
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._changeContent = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(qui_id, chapter_id, token_id, idname, offset_val) {
	        var data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                data = {
	                  token: token_id,
	                  idname: idname,
	                  chapter_id: chapter_id,
	                  offset: offset_val
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getNotes_allcr', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var ques_res, i, params;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context4.next = 14;
	                              break;
	                            }
	
	                            _this.setState({ ValidToken: true });
	                            ques_res = [];
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].chapter_id == _this.props.params.id) {
	                                ques_res = resp.questions[i];
	                              }
	                            }
	                            _this.setState({ questions: ques_res, display_loader: 'hide_block' });
	
	                            _context4.next = 7;
	                            return _this.getSavedNotes(ques_res.id);
	
	                          case 7:
	                            params = {
	                              token: _this.state.token,
	                              question_id: ques_res.id,
	                              idname: _this.state.idname
	                            };
	                            _context4.next = 10;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getsavestatesNotes', params).then(function (response) {
	                              if (response.success) {
	                                _this.setState({
	                                  save_question: 'btn btn-success pointer_class margin_right_10',
	                                  save_text: '' + _language2.default.LC().MARKED_AS_READ,
	                                  markColor: 'green'
	                                });
	                              }
	                            });
	
	                          case 10:
	
	                            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/getFlashCards', params).then(function (response) {
	                              var flash_cards = '';
	                              if (response.success) {
	                                _this.setState({ ValidToken: true });
	                                if (response.flash_cards.length > 0) {
	                                  _this.setState({
	                                    flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                  });
	                                  flash_cards = response.flash_cards.map(function (items, index) {
	                                    return _react2.default.createElement(
	                                      'li',
	                                      { key: index },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: '' },
	                                        _react2.default.createElement(
	                                          'ul',
	                                          { className: 'icon_list' },
	                                          _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                              'a',
	                                              { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                              'a',
	                                              { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                                            )
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: _this.state.flash_class },
	                                          _react2.default.createElement('h4', null),
	                                          _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            items.flash_card
	                                          )
	                                        )
	                                      )
	                                    );
	                                  });
	                                } else {
	                                  _this.setState({
	                                    flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                  });
	                                  flash_cards = _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _language2.default.LC().NO_FLASHCARD_FOUND
	                                  );
	                                }
	                                _this.setState({ flash_data: flash_cards });
	                              } else {
	                                flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                                _this.setState({
	                                  ValidToken: false,
	                                  flash_data: flash_cards,
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                              }
	                              return response;
	                            });
	                            _this.setState({ records: '' });
	                            _context4.next = 15;
	                            break;
	
	                          case 14:
	                            _this.setState({
	                              ValidToken: false,
	                              records: '' + _language2.default.LC().Result_not_found
	                            });
	
	                          case 15:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x8) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x3, _x4, _x5, _x6, _x7) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavNotes = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/unsaveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/saveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.state = (_this$state = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      chapter_id: parseInt(_this.props.params.notesid),
	      ValidToken: false,
	      reportLoading: false,
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'btn btn-primary pointer_class margin_right_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	
	      bookmarkCSS: 'fa fa-bookmark-o',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: '' + _language2.default.LC().MARK_AS_READ,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      display_loader: '',
	      saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	    }, _defineProperty(_this$state, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state, 'bookmarkColor', ''), _defineProperty(_this$state, 'isFlashCardHidden', true), _defineProperty(_this$state, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state, 'user_city', ''), _defineProperty(_this$state, 'user_country', ''), _defineProperty(_this$state, 'user_ip', ''), _defineProperty(_this$state, 'user_state', ''), _defineProperty(_this$state, 'user_continent', ''), _this$state);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(SOA_FM_BeingNotes, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var result, storage_session;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                window.scroll(0, 0);
	                // api to get ip address
	                _context6.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context6.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                if (!this.props.params.id) {
	                  this.setState({ previ_block: 'card hide_block' });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  storage_session: storage_session,
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                this.getNotes();
	
	              case 9:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(prevProps, prevState) {
	        var storage_session;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(this.props.params.notesid !== prevProps.params.notesid)) {
	                  _context7.next = 7;
	                  break;
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                _context7.next = 4;
	                return this.setState({ loader: true });
	
	              case 4:
	                this.setState({
	                  storage_session: storage_session,
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                _context7.next = 7;
	                return this.getNotes();
	
	              case 7:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidUpdate(_x9, _x10) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	
	    //Function to redirect page to readings page
	
	
	    //Function to fetch Next question
	
	
	    //Function to fetch previous question
	
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Funcion to save new report question
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to save notes and display Marked on button
	
	  }, {
	    key: 'notes_MARKED_AS_READ',
	    value: function notes_MARKED_AS_READ(params) {
	      var _this3 = this;
	
	      // console.log("params", params);
	      // const result = getDeviceDetails();
	      var data = {
	        token: params.token,
	        idname: params.idname,
	        notes_id: params.question_id
	        // city: this.state.user_city,
	        // country: this.state.user_country,
	        // state:this.state.user_state,
	        // continent:this.state.user_continent,
	        // ip: this.state.user_ip,
	        // browser: result.client.name,
	        // browserVersion: result.client.version,
	        // os: result.os.name,
	        // deviceModel: result.device.model,
	        // deviceType: result.device.type,
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_notes/saveNotesstats', data).then(function (resp) {
	        // console.log("re", resp);
	
	        if (resp.success) {
	          _this3.setState({
	            ValidToken: true,
	            save_question: 'btn btn-success pointer_class margin_right_10',
	            save_text: '' + _language2.default.LC().MARKED_AS_READ,
	            markColor: 'green'
	          });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	  }, {
	    key: 'componentWillReceiveProps',
	
	
	    /*on url change run this function*/
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, this.state.state.token, this.state.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	
	    //Function to Display Saved Question on button and save in database
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = '';
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var retun_all_question = JSON.stringify(questions);
	      var all_questions = JSON.parse(retun_all_question);
	      // console.log(all_questions)
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 note-section special_notes_view' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card note-section-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                className: 'margin_right_20',
	                alt: '',
	                width: '21'
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, "span", "notes-head-color", { contentEditable: "false" }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'notes-head-color' },
	                '(',
	                _language2.default.LC().N,
	                ' ',
	                all_questions.id,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'note-text-wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_20' },
	                    (0, _function.renderHTMLContent)(all_questions.description, "div", "note_text_wrap", { contentEditable: "false" })
	                  ),
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default
	                  // _getResult={this._getResult}
	                  , { isQue: false,
	                    saveNotes_text: this.state.saveNotes_text,
	                    markColor: this.state.markColor,
	                    _saveQuestion: this._saveFavNotes,
	                    _saveNotesstats: this._saveNotesstats,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: all_questions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, all_questions)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, all_questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                ),
	                ' '
	              )
	            ),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: questions,
	              type: 'notes',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'soa_fm'
	            })
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else if (all_questions == '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'card card-block',
	              style: {
	                color: '#e28484',
	                fontSize: 'larger',
	                margin: '0 auto',
	                textAlign: 'center'
	              }
	            },
	            'Coming Soon...'
	          )
	        );
	        {}
	        /* <div className="no_data_bar card">No Records Found</div> */
	
	        // </div>;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row note-section notes_inner_title_wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head title-font-size' },
	              _language2.default.LC().NOTES
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_CHAPTER
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        all_questions !== '' ? _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return SOA_FM_BeingNotes;
	}(_react.Component);
	
	SOA_FM_BeingNotes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this4 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this4.toggle = _this4.toggle.bind(_this4);
	    _this4.state = {
	      tooltipOpen: false
	    };
	    return _this4;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_FM_BeingNotes;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SOA_FM_QuestionBank = function (_Component) {
	  _inherits(SOA_FM_QuestionBank, _Component);
	
	  function SOA_FM_QuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_QuestionBank.__proto__ || Object.getPrototypeOf(SOA_FM_QuestionBank)).call(this, props));
	
	    _this._getReadings = function (chapter, e) {
	      var _this$state = _this.state,
	          token = _this$state.token,
	          idname = _this$state.idname;
	      var chapter_no = chapter.chapter_no,
	          chapter_name = chapter.chapter_name;
	
	      var data = {
	        token: token,
	        idname: idname,
	        chapter_id: chapter.chapter_no,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: 'paid'
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          var _resp$questions = resp.questions,
	              questions = _resp$questions === undefined ? [] : _resp$questions;
	
	          if (questions.length) {
	            _this.context.router.push({
	              pathname: '/soa/financialmathematics/readings/' + chapter_no + '/' + 1,
	              state: {
	                token: token,
	                idname: idname,
	                chapter: chapter_no,
	                chapterName: chapter_name
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.goToQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state2, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state2 = _this.state, lastRecord = _this$state2.lastRecord, lastAttempt = _this$state2.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: '/soa/financialmathematics/beginchapter/' + 1 + '/' + lastRecord.soa_fm_question.chapter_id + '/' + lastRecord.soa_fm_question.id,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.soa_fm_question.chapter_id,
	
	                    page: 1,
	                    subscriptionstatus: 'free'
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      freeChapterCount: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      lastRecord: '',
	      lastAttempt: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_FM_QuestionBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ alert_status: !this.state.alert_status });
	    }
	
	    /*
	    ------------------------------------------
	      Function to get readings by chapter no
	    ------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      if (localStorage.getItem('selectedmenu') === 'frm') {
	        this.context.router.push({
	          pathname: '/frm/questionbank/',
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname']
	          }
	        });
	      }
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getChapters', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context2.next = 6;
	                    break;
	                  }
	
	                  _this3.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  _context2.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context2.next = 7;
	                  break;
	
	                case 6:
	                  _this3.setState({ ValidToken: false });
	
	                case 7:
	                  return _context2.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	
	    /*
	    ----------------------------------
	      Function to go to questions
	    ----------------------------------
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters = this.state.chapters;
	      var countFree = this.state.freeChapterCount;
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      if (this.state.chapters.length && this.state.freeChapterCount.length) {
	        data = chapters.map(function (item, index) {
	          return countFree.map(function (itemFree, indexFree) {
	            return item.chapter_no === itemFree.id ? _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: index
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id,
	                  onClick: _this4._getReadings.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    width: '54',
	                    alt: 'book icon'
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'pointer_class',
	                      id: item.chapter_name,
	                      value: item.chapter_no,
	                      onClick: _this4._getReadings.bind(_this4, item)
	                    },
	                    item.chapter_no,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      itemFree.count
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().FREE_QUESTIONS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countquestion
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().PREMIUM_QUESTIONS
	                    )
	                  )
	                )
	              )
	            ) : null;
	          });
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().ACTUARIAL_FM_QUESTION_BANK
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.SOA_FM }),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_QuestionBank;
	}(_react.Component);
	
	SOA_FM_QuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = SOA_FM_QuestionBank;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var SOA_FM_Quizzes = function (_Component) {
	  _inherits(SOA_FM_Quizzes, _Component);
	
	  function SOA_FM_Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_Quizzes.__proto__ || Object.getPrototypeOf(SOA_FM_Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('abandonedQuizzes', data);
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot === dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i === dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    _this.setState({ display_loader: 'hide_block' });
	                    (0, _toast.showFailure)(resp.message);
	                  }
	                  return resp;
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	
	      // console.log(this.state.all_checked_state);
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          //console.log(i+'----------'+checkboxes[i].value);
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      console.log('deleteQuizzes', items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                console.log('calllinggg!!!!');
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context3.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 4;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: '',
	      all_checked_state: true,
	      radio_checked_question: 0,
	      radio_checked_priority: 'none',
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      display_loader: 'show_block',
	      deleteItemId: '',
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    // this.toggle = this.toggle.bind(this);
	    return _this;
	  }
	
	  _createClass(SOA_FM_Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getChapters', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ ValidToken: true, chapters: resp.chapters });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	      this.abandonedQuizzes(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          _this3.setState({ display_loader: 'hide_block' });
	          (0, _toast.showFailure)(resp.message);
	        }
	      });
	    }
	  }, {
	    key: '_createQuiz',
	
	
	    /*_changeIncludetimer(){
	      if(this.state.include_timer)
	      {
	        this.setState({ include_timer:!this.state.include_timer });
	      }
	      else{
	        this.setState({ include_timer:!this.state.include_timer });
	      }    	
	    }*/
	
	    /*_changeSaveresult(){
	      if(this.state.save_results)
	      {
	        this.setState({ save_results:!this.state.save_results });
	      }
	      else{
	        this.setState({ save_results:!this.state.save_results });
	      }    
	    }*/
	
	    value: function _createQuiz() {
	      var _this4 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      var question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	      var timer_value,
	          chapterAll = '';
	      timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	      if (this.state.all_checked_state) {
	        // console.log('if	 working')
	        var dataString = JSON.stringify(this.state.chapters);
	        var dataReason = JSON.parse(dataString);
	        var chapterall_id = [];
	        for (var i = 0; i < dataReason.length; i++) {
	          chapterall_id.push(dataReason[i].chapter_no);
	        }
	
	        chapterAll = chapterall_id;
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          chapterAll: chapterAll,
	          questionquize: question_length_val,
	          priority: this.state.radio_checked_priority
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getQuizequestion', data).then(function (resp) {
	          // console.log(resp)
	          if (resp.success) {
	            var retun_all_chapter = JSON.stringify(resp.chapters);
	            var chapterParse = JSON.parse(retun_all_chapter);
	            var question_id = [];
	            var myJson = { question_count: '', all_questions: {} };
	            for (var i = 0; i < chapterParse.length; i++) {
	              var objName = 'q' + i;
	              var objValue = chapterParse[i].id;
	              myJson.all_questions[i] = objValue;
	              question_id.push(chapterParse[i].id);
	            }
	            myJson.question_count = question_id.length;
	            var questions = JSON.stringify(myJson);
	            var data = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              number_questions: myJson.question_count,
	              questions: questions,
	              timer_value: timer_value
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/createQuiz', data).then(function (resp) {
	              // console.log(resp)
	              if (resp.success) {
	                _this4.setState({ display_loader: 'hide_block' });
	                _this4.context.router.push({
	                  pathname: '/soa/financialmathematics/beforeStart/' + resp.last_id,
	                  state: {
	                    token: _this4.state.token,
	                    idname: _this4.state.idname,
	                    quiz_id: resp.last_id,
	                    status_send: ''
	                  }
	                });
	              } else {
	                //console.log(resp.success);
	              }
	            });
	          } else {
	            console.log('Some Thing Went Wrong');
	          }
	          return resp;
	        });
	      } else {
	        // console.log('else working')
	        var checkboxes = document.getElementsByName('approve[]');
	        var i = 0;
	        var single_clicked_value = [];
	        if (this.state.single_clicked_val === '') {
	          for (i = 0; i < checkboxes.length; i++) {
	            if (checkboxes[i].checked) {
	              // console.log(i+'----------'+checkboxes[i].value);
	              single_clicked_value.push(checkboxes[i].value);
	            }
	          }
	
	          chapterAll = single_clicked_value;
	          // console.log(chapterAll)
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          // console.log(data)
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getQuizequestion', data).then(function (resp) {
	            // console.log(resp)
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/createQuiz', data_insert).then(function (resp) {
	                // console.log('createQuiz')
	                // console.log(resp)
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: '/soa/financialmathematics/beforeStart/' + resp.last_id,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id
	                    }
	                  });
	                } else {
	                  // console.log(resp.success);
	                }
	              });
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        } else {
	          chapterAll = this.state.single_clicked_val;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/getQuizequestion', data).then(function (resp) {
	            // console.log(resp)
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_quizzes/createQuiz', data_insert).then(function (resp) {
	                // console.log(resp)
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: '/soa/financialmathematics/beforeStart/' + resp.last_id,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id
	                    }
	                  });
	                } else {
	                  //console.log(resp.success);
	                }
	              });
	            } else {
	              console.log('Some Thing Went Wrong');
	            }
	            return resp;
	          });
	        }
	      }
	    }
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: '/soa/financialmathematics/beforeStart/' + items.id + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon'
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: '/soa/financialmathematics/beforeStart/' + items.id + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed'
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.chapter_no,
	                onClick: _this5._single_Checked.bind(_this5)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'cursor_pointer',
	                  onClick: _this5._checkAbondon.bind(_this5, items)
	                },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'delete-quizzes',
	                  onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  }
	                },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'cursor_pointer',
	                  onClick: _this5._checkCompleted.bind(_this5, items)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question == index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().SOA_FM_QUIZZES
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this._createQuiz.bind(this)
	              },
	              ' ',
	              _language2.default.LC().CREATE_QUIZ,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().CONTENT,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions float-right' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().ALL_CHAPTERS,
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'all_Checked',
	                        name: 'all_checked',
	                        value: 'select',
	                        onClick: this._all_Checked.bind(this),
	                        checked: this.state.all_checked_state
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    chapter_data
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().ABANDONED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        abandoned_data
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().Priorities_By,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().NONE,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'none',
	                      name: 'none',
	                      value: 'none',
	                      checked: this.state.radio_checked_priority == 'none',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    _language2.default.LC().UNANSWERED,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unanswered',
	                      name: 'mark_unanswered',
	                      value: 'unanswered',
	                      checked: this.state.radio_checked_priority == 'unanswered',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().Wrong_answers,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unattempted',
	                      name: 'mark_unattempted',
	                      value: 'wrongquestion',
	                      checked: this.state.radio_checked_priority == 'wrongquestion',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().LENGTH,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  quiz_length_state_data
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().COMPLETED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        getallcompleteQuiz_data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'close',
	                  color: 'secondary',
	                  onClick: this.deleteQuizzes
	                },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_Quizzes;
	}(_react.Component);
	
	SOA_FM_Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_FM_Quizzes;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _pagination = __webpack_require__(274);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _reactRouter = __webpack_require__(29);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_FM_Readings = function (_Component) {
	  _inherits(SOA_FM_Readings, _Component);
	
	  function SOA_FM_Readings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_Readings);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_Readings.__proto__ || Object.getPrototypeOf(SOA_FM_Readings)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var result, storage_session;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              window.scrollTo(0, 0);
	              // api to get ip address
	              _context.next = 3;
	              return (0, _getIpAddress.getIpAddress)();
	
	            case 3:
	              result = _context.sent;
	
	              if (result) {
	                _this.setState({
	                  user_city: result.city,
	                  user_country: result.country,
	                  user_ip: result.query,
	                  user_state: result.region,
	                  user_continent: result.continent
	                });
	              }
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              _context.next = 8;
	              return storage_session;
	
	            case 8:
	              if (!_context.sent) {
	                _context.next = 12;
	                break;
	              }
	
	              _this.setState({
	                storage_session: storage_session,
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	
	              _context.next = 13;
	              break;
	
	            case 12:
	              null;
	
	            case 13:
	              _context.next = 15;
	              return _this.state.idname;
	
	            case 15:
	              _context.t1 = _context.sent;
	              _context.t0 = _context.t1 === '';
	
	              if (!_context.t0) {
	                _context.next = 19;
	                break;
	              }
	
	              _context.t0 = _this.state.token === '';
	
	            case 19:
	              if (!_context.t0) {
	                _context.next = 23;
	                break;
	              }
	
	              _this.setState({ loggedIn: false });
	
	              _context.next = 24;
	              break;
	
	            case 23:
	              _this.setState({ loggedIn: true });
	
	            case 24:
	
	              if (localStorage.getItem('selectedmenu') === 'frm') {
	                _this.context.router.push({
	                  pathname: '/soa/probability/questionbank/',
	                  state: {
	                    token: storage_session['token'],
	                    idname: storage_session['idname']
	                  }
	                });
	              }
	
	              if (!_this.props.params.page) {
	                _context.next = 28;
	                break;
	              }
	
	              _context.next = 28;
	              return _this.setState({
	                selectedPage: parseInt(_this.props.params.page),
	                skip: _this.state.limit * (parseInt(_this.props.params.page), -1)
	              }, function () {
	                _this.GetSubscription();
	              });
	
	            case 28:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.GetSubscription = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname']
	              };
	              _context5.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                  var data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context4.next = 11;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context4.next = 5;
	                            break;
	                          }
	
	                          _this.setState({ showFreePremium: true, subscriptionstatus: 'free' }, function () {
	                            _this.GETQuestions('free');
	                          });
	                          _context4.next = 9;
	                          break;
	
	                        case 5:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context4.next = 9;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, isInArray_varPDF;
	                              return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                while (1) {
	                                  switch (_context2.prev = _context2.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context2.next = 15;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this.state.selectedmenu;
	                                      isInArray_var = false;
	                                      isInArray_varPDF = false;
	                                      _context2.next = 7;
	                                      return _SoaFMSubscription4.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                                    case 7:
	                                      isInArray_var = _context2.sent;
	
	                                      if (isInArray_var) {
	                                        _this.setState({
	                                          subscriptionstatus: 'paid'
	                                        }, function () {
	                                          _this.GETQuestions('paid');
	                                        });
	                                      } else {
	                                        _this.setState({
	                                          showFreePremium: true,
	                                          subscriptionstatus: 'free'
	                                        }, function () {
	                                          _this.GETQuestions('free');
	                                        });
	                                      }
	
	                                      _context2.next = 11;
	                                      return _SoaFMSubscription4.default.checkSoaFM_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                    case 11:
	                                      isInArray_varPDF = _context2.sent;
	
	                                      if (isInArray_varPDF) {
	                                        _this.setState({
	                                          showFreePremium: false
	                                        });
	                                      } else {
	                                        _this.setState({
	                                          showFreePremium: true
	                                        });
	                                      }
	                                      _context2.next = 16;
	                                      break;
	
	                                    case 15:
	                                      console.log('fail');
	
	                                    case 16:
	                                    case 'end':
	                                      return _context2.stop();
	                                  }
	                                }
	                              }, _callee2, _this2);
	                            }));
	
	                            return function (_x2) {
	                              return _ref4.apply(this, arguments);
	                            };
	                          }());
	
	                        case 9:
	                          _context4.next = 19;
	                          break;
	
	                        case 11:
	                          if (!(resp.profileInfo.exam_selected === '')) {
	                            _context4.next = 15;
	                            break;
	                          }
	
	                          _this.setState({ showFreePremium: true, subscriptionstatus: 'free' }, function () {
	                            _this.GETQuestions('free');
	                          });
	                          _context4.next = 19;
	                          break;
	
	                        case 15:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this.state.token,
	                            idname: _this.state.idname,
	                            examid: data_arr
	                          };
	                          _context4.next = 19;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                              var exam_data, selectedmen, isInArray_var, isInArray_varPDF;
	                              return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                while (1) {
	                                  switch (_context3.prev = _context3.next) {
	                                    case 0:
	                                      if (!resp_exam.success) {
	                                        _context3.next = 15;
	                                        break;
	                                      }
	
	                                      exam_data = resp_exam.examData;
	                                      selectedmen = _this.state.selectedmenu;
	                                      isInArray_var = false;
	                                      isInArray_varPDF = false;
	                                      _context3.next = 7;
	                                      return _SoaFMSubscription2.default.checkSoaFMSubscription(selectedmen, exam_data);
	
	                                    case 7:
	                                      isInArray_var = _context3.sent;
	
	                                      if (isInArray_var) {
	                                        _this.setState({
	                                          subscriptionstatus: 'paid'
	                                        }, function () {
	                                          _this.GETQuestions('paid');
	                                        });
	                                      } else {
	                                        _this.setState({
	                                          showFreePremium: true,
	                                          subscriptionstatus: 'free'
	                                        }, function () {
	                                          _this.GETQuestions('free');
	                                        });
	                                      }
	
	                                      _context3.next = 11;
	                                      return _SoaFMSubscription2.default.checkSoaFM_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                    case 11:
	                                      isInArray_varPDF = _context3.sent;
	
	                                      // console.log("PSVDVDV", isInArray_varPDF);
	                                      if (isInArray_varPDF) {
	                                        _this.setState({
	                                          showFreePremium: false
	                                        });
	                                      } else {
	                                        _this.setState({
	                                          showFreePremium: true
	                                        });
	                                      }
	                                      _context3.next = 16;
	                                      break;
	
	                                    case 15:
	                                      console.log('fail');
	
	                                    case 16:
	                                    case 'end':
	                                      return _context3.stop();
	                                  }
	                                }
	                              }, _callee3, _this2);
	                            }));
	
	                            return function (_x3) {
	                              return _ref5.apply(this, arguments);
	                            };
	                          }());
	
	                        case 19:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref3.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.GETQuestions = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(status) {
	        var data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this.setState({ display_loader: 'show_block' });
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: _this.state.chapterid,
	                  subscriptionstatus: status,
	                  page: parseInt(_this.state.selectedPage)
	                };
	                _context6.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestionsAll_With_Pagination', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({
	                      ValidToken: true,
	                      question: resp.questions,
	                      totalCount: resp.totalCount,
	                      chapterName: resp.chapter.chapter_name
	                    });
	
	                    _this.setState({ display_loader: 'hide_block' });
	                    if (!resp.question.length) {
	                      _this.setState({
	                        no_result_display: 'No Saved Questions',
	                        display_loader: 'hide_block'
	                      });
	                    }
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/questionbank',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuestion = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(chapter, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chapter.chapter_id,
	                  question_no: chapter.id,
	                  offset: 0,
	                  limit: 1,
	                  subscriptionstatus: _this.state.subscriptionstatus
	                };
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getSelectedQuestions', data).then(function (resp) {
	                  if (resp.success) {
	                    if (resp.questions.length) {
	                      _this.context.router.push({
	                        pathname: '/soa/financialmathematics/beginchapter/' + _this.state.selectedPage + '/' + chapter.chapter_id + '/' + resp.questions[0].id,
	                        state: {
	                          token: _this.state.token,
	                          idname: _this.state.idname,
	                          chapter: chapter.id,
	                          chapterName: chapter.name,
	                          page: _this.props.location.query.page,
	                          subscriptionstatus: _this.state.subscriptionstatus
	                        }
	                      });
	                    } else {
	                      _this.toggleAlert();
	                    }
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x5, _x6) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.handleSelected = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(page) {
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return _this.setState({
	                  display_loader: 'show_block',
	                  selectedPage: page.currentPage,
	                  skip: _this.state.limit * (page.currentPage - 1)
	                }, function () {
	                  _reactRouter.browserHistory.push('/soa/financialmathematics/readings/' + _this.state.chapterid + '/' + page.currentPage);
	                });
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdf = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e) {
	        var dataset;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context9.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context9.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context9.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context9.abrupt('return');
	
	              case 6:
	                if (!_this.state.showFreePremium) {
	                  _context9.next = 10;
	                  break;
	                }
	
	                _this.toggleAlert();
	                _context9.next = 14;
	                break;
	
	              case 10:
	                _this.setState({
	                  pdfLoading: false
	                });
	                // const result = getDeviceDetails();
	                dataset = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapterId: _this.state.chapterid,
	                  city: _this.state.user_city,
	                  country: _this.state.user_country,
	                  state: _this.state.user_state,
	                  continent: _this.state.user_continent,
	                  ip: _this.state.user_ip
	                };
	                _context9.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      pdfLoading: true,
	                      PDFDownloadType: 'Question'
	                    });
	                    _this.pdfAlertModel();
	                  } else if (!response.pdf) {
	                    _this.setState({
	                      pdfLoading: true,
	                      PDFDownloadType: 'Question'
	                    });
	                    _this.pdfAlertModel();
	                  }
	                });
	
	              case 14:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x8) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(e) {
	        var dataset;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context10.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context10.abrupt('return');
	
	              case 3:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context10.next = 6;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context10.abrupt('return');
	
	              case 6:
	                if (!_this.state.showFreePremium) {
	                  _context10.next = 10;
	                  break;
	                }
	
	                _this.toggleAlert();
	                _context10.next = 14;
	                break;
	
	              case 10:
	                _this.setState({
	                  pdfLoadingAnswer: false
	                });
	                // const result = getDeviceDetails();
	                dataset = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapterId: _this.state.chapterid,
	                  city: _this.state.user_city,
	                  country: _this.state.user_country,
	                  state: _this.state.user_state,
	                  continent: _this.state.user_continent,
	                  ip: _this.state.user_ip
	                };
	                _context10.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      pdfLoadingAnswer: true,
	                      PDFDownloadType: 'Question/Answer'
	                    });
	                    _this.pdfAlertModel();
	                  } else if (!response.pdf) {
	                    _this.setState({
	                      pdfLoadingAnswer: true,
	                      PDFDownloadType: 'Question/Answer'
	                    });
	                    _this.pdfAlertModel();
	                  }
	                });
	
	              case 14:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x9) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      pdfAlert: false,
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: _alertMessage2.default.messageContent_soa_fm,
	      question: [],
	      token: '',
	      idname: '',
	      chapterid: parseInt(_this.props.params.id),
	      // chapterName: this.props.params.name,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      subscriptionstatus: '',
	      showFreePremium: true,
	      selectedmenu: 'soa_fm',
	      selectedPage: parseInt(_this.props.params.page),
	      totalCount: 0,
	      limit: 10,
	      skip: 0,
	      offset: 0,
	      display_loader: 'show_block',
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFDownloadType: 'Question',
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      type: 'question',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_FM_Readings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        pdfAlert: !this.state.pdfAlert
	      });
	    }
	    /*
	    --------------------------------
	      On Page Load,init this method
	    --------------------------------
	    */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(prevProps, prevState) {
	        var _this3 = this;
	
	        var storage_session;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                if (!(this.props.params.page !== prevProps.params.page)) {
	                  _context11.next = 7;
	                  break;
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	                _context11.next = 4;
	                return this.setState({ loader: true });
	
	              case 4:
	                if (!this.props.params.page) {
	                  _context11.next = 7;
	                  break;
	                }
	
	                _context11.next = 7;
	                return this.setState({
	                  selectedPage: parseInt(this.props.params.page),
	                  skip: this.state.limit * (parseInt(this.props.params.page), -1)
	                }, function () {
	                  _this3.GetSubscription();
	                });
	
	              case 7:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function componentDidUpdate(_x10, _x11) {
	        return _ref11.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	
	    //it is use to redirect page
	
	    /*
	    -------------------------------------------------------
	          Function to go to questions
	    -------------------------------------------------------
	    */
	
	
	    //Function to redirect page to question bank page
	
	
	    /*
	    ------------------------------
	    Question PDF DOWNLOAD  via email
	    -------------------------------
	    */
	
	
	    /*
	    ----------------------------------------------
	    Question PDF DOWNLOAD and Answer via email
	    ----------------------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var question = this.state.question;
	      var data = '';
	      var selectedPage = this.state.selectedPage;
	      var totalCount = this.state.totalCount;
	      var limit = this.state.limit;
	
	      if (this.state.question.length) {
	        data = question.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.id,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              {
	                id: 'questionNameId_' + index,
	                contentEditable: 'false',
	                className: 'view_question_height view_questionhtml hide-question'
	              },
	              (0, _function.renderHTMLContent)(item.question.substring(0, item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 70) + '...')
	            ),
	            _react2.default.createElement(
	              'td',
	              { id: 'questionNameId_' + index.id },
	              _react2.default.createElement(QuestionChecked, {
	                question_id: item,
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                answered_state: item.id
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'javascript: void(0)', onClick: _this4._startQuestion.bind(_this4, item, index) },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        data = (0, _function.renderHTMLContent)(this.state.no_result_display, "div", "horizontal_mid card-block text-center text_light", { contentEditable: "false" });
	      }
	
	      /*This is  child component for checked Question is answered or not*/
	      function QuestionChecked(props) {
	        var data = {
	          token: props.token,
	          idname: props.idname,
	          question_id: props.question_id
	        };
	
	        //Api to check quiz answered of particular question
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/checkAnswered', data).then(function (resp) {
	          if (resp.success) {
	            // console.log(resp.question_recived);
	            if (resp.question_recived.right_answer === 1) {
	              if (document.getElementById('user_question_status' + props.answered_state)) {
	                document.getElementById('user_question_status' + props.answered_state).id = 'quiz_answered_status';
	                document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	
	                //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	              }
	            } else {
	              if (document.getElementById('user_question_status' + props.answered_state)) {
	                document.getElementById('user_question_status' + props.answered_state).id = 'quiz_wrong_answered_status';
	                //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	                document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	              }
	            }
	          } else {
	            if (document.getElementById('user_question_status' + props.answered_state)) {
	              document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	              //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	              document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	            }
	          }
	          // this.setState({ display_loader: "hide_block" });
	        });
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	          _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                'Chapter ',
	                this.state.chapterid,
	                ': ',
	                this.state.chapterName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	              _react2.default.createElement(
	                'div',
	                { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoading ? _language2.default.LC().Download_Question : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  onClick: this.getpdfAnswer.bind(this),
	                  className: 'status-download-btn margin_right_10'
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoadingAnswer ? _language2.default.LC().Download_Question_Answer : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getChapters
	                },
	                ' ',
	                _language2.default.LC().CHANGE_CHAPTER,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement('div', { className: 'card-header' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().QUESTIONS
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().YOURS_ANSWER
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        data
	                      )
	                    )
	                  )
	                )
	              ),
	              totalCount > 0 ? _react2.default.createElement(_pagination2.default, {
	                totalRecords: totalCount,
	                onPageChanged: this.handleSelected,
	                currentPage: parseInt(selectedPage),
	                pageLimit: limit
	              }) : null
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.pdfAlert,
	          PDFContentMessage: this.state.PDFContentMessage
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_Readings;
	}(_react.Component);
	
	//  <script type="text/x-mathjax-config">
	// window.MathJax.Hub.Config({
	//   messageStyle: "none",
	// tex2jax: { preview: "none" }
	// });
	
	
	SOA_FM_Readings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	{
	  /* </script> */
	}
	exports.default = SOA_FM_Readings;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Soa_fm_savedquestion = function (_Component) {
	  _inherits(Soa_fm_savedquestion, _Component);
	
	  function Soa_fm_savedquestion(props) {
	    _classCallCheck(this, Soa_fm_savedquestion);
	
	    var _this = _possibleConstructorReturn(this, (Soa_fm_savedquestion.__proto__ || Object.getPrototypeOf(Soa_fm_savedquestion)).call(this, props));
	
	    _this._deleteSavequestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/soa/financialmathematics/beginchapter/' + 1 + '/' + resp.questionsbyid.chapter_id + '/' + item.question_id,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              chapter: resp.questionsbyid.chapter_id
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      savedquestion: [],
	      no_restult_display: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  _createClass(Soa_fm_savedquestion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this2.setState({ savedquestion: resp.questions });
	          if (!resp.questions.length) {
	            _this2.setState({
	              no_restult_display: '' + _language2.default.LC().NO_SAVED_QUESTIONS
	            });
	          }
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      // console.log(card)
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this3 = this;
	
	      if (this.state.item_status === 'savedquestion') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          save_question: this.state.items_val
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_question_bank/deleteSavequestion', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('savedque_' + _this3.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savedquestion_data = '';
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row  align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ':',
	                    ' ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().TOPIC,
	                      ': '
	                    ),
	                    ' ',
	                    items.topic_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._beginChapter.bind(_this4, items),
	                        className: _this4.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._deleteSavequestino.bind(_this4, items),
	                        className: _this4.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_SAVED_QUESTIONS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                _language2.default.LC().PICK_THE_QUESTION_YOU_WANT_TO_REVIEW,
	                ' :',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              '\xA0\xA0',
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          savedquestion_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary',
	                  color: 'primary',
	                  onClick: this.toggleDone
	                },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Soa_fm_savedquestion;
	}(_react.Component);
	
	Soa_fm_savedquestion.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Soa_fm_savedquestion;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1012);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactstrap = __webpack_require__(6);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _VideoValidateReportIcons = __webpack_require__(72);
	
	var _VideoValidateReportIcons2 = _interopRequireDefault(_VideoValidateReportIcons);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";/*  */
	
	
	/* eslint-disable*/
	var SOA_FM_VideoDisplay = function (_Component) {
	  _inherits(SOA_FM_VideoDisplay, _Component);
	
	  function SOA_FM_VideoDisplay(props) {
	    var _this2 = this,
	        _this$state2;
	
	    _classCallCheck(this, SOA_FM_VideoDisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_VideoDisplay.__proto__ || Object.getPrototypeOf(SOA_FM_VideoDisplay)).call(this, props));
	
	    _this.pdfOpen = function (pdfdata, e) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      if (_this.state.userType === 'paid') {
	        var myWindow = window.open(_this.state.pdf_file);
	        myWindow.focus();
	      } else {
	        _this.toggleAlert();
	      }
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._downloadPDF = function () {
	      // console.log('Download PDF')
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (id) {
	      var comment = document.getElementById('comment').value;
	      //console.log('function calling...', comment.length);
	
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        videoIndex: _this.state.currentUrl,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/videoReportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveFlashCard = function (id, e) {
	      if (document.getElementById('flash_card').value === '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/videoSaveFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            video_id: id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/videoGetFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: items.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              className: 'pointer_class',
	                              onClick: _this._deleteFlash.bind(_this, items)
	                            },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({ ValidToken: false });
	              _this.setState({ flash_data: flash_cards });
	              _this.setState({
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/videoDeleteFlashCards', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          _this.setState({
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/soa/financialmathematics/videolessons/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.moveToNotes = function (reading, e) {
	      // console.log(reading)
	      var final_exam = [];
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	
	                isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                if (isInArray_var) {
	                  _this.context.router.push({
	                    pathname: '/soa/financialmathematics/beginnotes/' + _this.state.currentChapterNo,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter: _this.state.currentChapterNo
	                    }
	                  });
	                } else {
	                  //console.log('work');
	
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            return _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	
	                isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                if (isInArray_var) {
	                  _this.context.router.push({
	                    pathname: '/soa/financialmathematics/beginnotes/' + _this.state.currentChapterNo,
	                    state: {
	                      token: _this.state.token,
	                      idname: _this.state.idname,
	                      chapter: _this.state.currentChapterNo
	                    }
	                  });
	                } else {
	                  //console.log('work');
	
	                  _this.toggleAlert();
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.moveToPracticeQuestions = function () {
	      var final_exam = [];
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            return _this.toggleAlert();
	          } else {
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              // console.log(resp_exam);
	              if (resp_exam.success) {
	                // console.log('If working');
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                if (isInArray_var) {
	                  _this._runCode('paid');
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free');
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                // console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.getSavedVideo = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getFavVideo', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveVideo_text: '' + _language2.default.LC().Video_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.getVideourl = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(index, url_id, title, id, url_id_qq, free) {
	        var data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(free === 1)) {
	                  _context4.next = 8;
	                  break;
	                }
	
	                _this.setState({
	                  video_display: url_id,
	                  video_display_qq: url_id_qq,
	                  currentUrl: index,
	                  video_title: title,
	                  currentReading: _this.state.chapters[index].id,
	                  currentChapterNo: _this.state.chapters[index].chapter_id,
	                  currentReadingTitle: _this.state.chapters[index].title,
	                  currentReadingNo: _this.state.chapters[index].reading_no,
	                  pdf_file: _this.state.chapters[index].pdf_file
	                }, function () {
	                  _this.context.router.push({
	                    pathname: '/soa/financialmathematics/videodisplay/' + _this.props.params.id + '/' + _this.props.params.showFreePremium + '/' + _this.props.params.type + '/' + _this.props.params.chapter_id + '/' + _this.state.currentUrl
	                  });
	                });
	
	                _context4.next = 4;
	                return _this.trackUserWatchedVideo(id, index);
	
	              case 4:
	                _context4.next = 6;
	                return _this.savelastVideo(id, index);
	
	              case 6:
	                _context4.next = 10;
	                break;
	
	              case 8:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this.toggleAlert();
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee2$(_context2) {
	                            while (1) {
	                              switch (_context2.prev = _context2.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context2.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context2.next = 6;
	                                  return _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                                case 6:
	                                  isInArray_var = _context2.sent;
	
	                                  if (!isInArray_var) {
	                                    _context2.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    video_title: title,
	                                    currentReading: _this.state.chapters[index].id,
	                                    currentChapterNo: _this.state.chapters[index].chapter_id,
	                                    currentUrl: index,
	                                    currentReadingTitle: _this.state.chapters[index].title,
	                                    pdf_file: _this.state.chapters[_this.state.currentUrl].pdf_file,
	                                    currentReadingNo: _this.state.chapters[index].reading_no
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: '/soa/financialmathematics/videodisplay/' + _this.props.params.id + '/' + _this.props.params.showFreePremium + '/' + _this.props.params.type + '/' + _this.props.params.chapter_id + '/' + _this.state.currentUrl
	                                    });
	                                  });
	                                  _context2.next = 11;
	                                  return _this.savelastVideo(id, index);
	
	                                case 11:
	                                  _context2.next = 13;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 13:
	                                  return _context2.abrupt('return');
	
	                                case 16:
	                                  return _context2.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context2.next = 19;
	                                  break;
	
	                                case 19:
	                                case 'end':
	                                  return _context2.stop();
	                              }
	                            }
	                          }, _callee2, _this2);
	                        }));
	
	                        return function (_x9) {
	                          return _ref3.apply(this, arguments);
	                        };
	                      }()
	                      // console.log('fail');
	                      );
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      // console.log("if working");
	                      return _this.toggleAlert();
	                    } else {
	                      // console.log('else working');
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee3$(_context3) {
	                            while (1) {
	                              switch (_context3.prev = _context3.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context3.next = 19;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context3.next = 6;
	                                  return _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                                case 6:
	                                  isInArray_var = _context3.sent;
	
	                                  if (!isInArray_var) {
	                                    _context3.next = 16;
	                                    break;
	                                  }
	
	                                  _this.setState({
	                                    currentUrl: index,
	                                    video_display: url_id,
	                                    video_display_qq: url_id_qq,
	                                    video_title: title,
	                                    currentReading: _this.state.chapters[index].id,
	                                    currentChapterNo: _this.state.chapters[index].chapter_id,
	                                    currentReadingNo: _this.state.chapters[index].reading_no,
	                                    currentReadingTitle: _this.state.chapters[index].title,
	                                    pdf_file: _this.state.chapters[_this.state.currentUrl].pdf_file
	                                  }, function () {
	                                    _this.context.router.push({
	                                      pathname: '/soa/financialmathematics/videodisplay/' + _this.props.params.id + '/' + _this.props.params.showFreePremium + '/' + _this.props.params.type + '/' + _this.props.params.chapter_id + '/' + _this.state.currentUrl
	                                    });
	                                  });
	                                  _context3.next = 11;
	                                  return _this.trackUserWatchedVideo(id, index);
	
	                                case 11:
	                                  _context3.next = 13;
	                                  return _this.savelastVideo(id, index);
	
	                                case 13:
	                                  return _context3.abrupt('return');
	
	                                case 16:
	                                  return _context3.abrupt('return', _this.toggleAlert());
	
	                                case 17:
	                                  _context3.next = 19;
	                                  break;
	
	                                case 19:
	                                case 'end':
	                                  return _context3.stop();
	                              }
	                            }
	                          }, _callee3, _this2);
	                        }));
	
	                        return function (_x10) {
	                          return _ref4.apply(this, arguments);
	                        };
	                      }()
	                      // console.log('fail');
	                      );
	                    }
	                  }
	                });
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x3, _x4, _x5, _x6, _x7, _x8) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.savelastVideo = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id, index) {
	        var _this$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _this$state = _this.state, token = _this$state.token, idname = _this$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: id,
	                  videoIndex: index
	                };
	                _context5.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x11, _x12) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this._saveFavVideo = function (item, e) {
	      //console.log('_saveFavVideo', item);
	
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        video_id: item
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/unsaveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/saveFavVideoByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveVideo_text: '' + _language2.default.LC().Video_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.trackUserWatchedVideo = function (id, index) {
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        id: id,
	        videoIndex: index,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/trackUserVideowatch', data).then(function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	          return _regenerator2.default.wrap(function _callee6$(_context6) {
	            while (1) {
	              switch (_context6.prev = _context6.next) {
	                case 0:
	                case 'end':
	                  return _context6.stop();
	              }
	            }
	          }, _callee6, _this2);
	        }));
	
	        return function (_x13) {
	          return _ref6.apply(this, arguments);
	        };
	      }());
	    };
	
	    var messageTitle_soa_fm = '<i class="icon-info icons font-2xl d-block "></i>';
	
	    _this.state = (_this$state2 = {
	      alert_status: false,
	      successAlert: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class'
	    }, _defineProperty(_this$state2, 'MessageTitle', messageTitle_soa_fm), _defineProperty(_this$state2, 'MessageContent', _alertMessage2.default.messageContent_soa_fm), _defineProperty(_this$state2, 'token', ''), _defineProperty(_this$state2, 'idname', ''), _defineProperty(_this$state2, 'ValidToken', false), _defineProperty(_this$state2, 'all_questions', ''), _defineProperty(_this$state2, 'chapters', []), _defineProperty(_this$state2, 'all_questions_state', []), _defineProperty(_this$state2, 'video_display', ''), _defineProperty(_this$state2, 'video_display_qq', ''), _defineProperty(_this$state2, 'url_id', ''), _defineProperty(_this$state2, 'url_id_qq', ''), _defineProperty(_this$state2, 'currentUrl', ''), _defineProperty(_this$state2, 'reportLoading', false), _defineProperty(_this$state2, 'free', ''), _defineProperty(_this$state2, 'video_title', ''), _defineProperty(_this$state2, 'video_display_no', ''), _defineProperty(_this$state2, 'allChapters', []), _defineProperty(_this$state2, 'Chapter_Title', ''), _defineProperty(_this$state2, 'flagCSS', 'fa fa-flag-o mark-action-btn'), _defineProperty(_this$state2, 'notesCSS', 'fa fa-book mark-action-btn'), _defineProperty(_this$state2, 'questionsCSS', 'fa fa-question-circle-o mark-action-btn'), _defineProperty(_this$state2, 'showFreePremium', _this.props.params.showFreePremium === '0' ? true : false), _defineProperty(_this$state2, 'currentReading', _this.props.params.id), _defineProperty(_this$state2, 'comment_update_id', ''), _defineProperty(_this$state2, 'currentChapterNo', ''), _defineProperty(_this$state2, 'currentReadingNo', ''), _defineProperty(_this$state2, 'currentReadingTitle', ''), _defineProperty(_this$state2, 'subscriptionstatus', ''), _defineProperty(_this$state2, 'selectedmenu', 'soa_fm'), _defineProperty(_this$state2, 'subscription_details_for_isActive', ''), _defineProperty(_this$state2, 'pdfData', []), _defineProperty(_this$state2, 'pdf_file', ''), _defineProperty(_this$state2, 'type', _this.props.params.type === '0' ? 'intro' : 'notintro'), _defineProperty(_this$state2, 'userType', ''), _defineProperty(_this$state2, 'cfaUnlimitedPackage', ''), _defineProperty(_this$state2, 'cfaUnlimitedActiveExam', ''), _defineProperty(_this$state2, 'saveVideo_text', '' + _language2.default.LC().SAVE_VIDEO), _defineProperty(_this$state2, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state2, 'bookmarkColor', ''), _defineProperty(_this$state2, 'isFlashCardHidden', true), _defineProperty(_this$state2, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state2, 'user_city', ''), _defineProperty(_this$state2, 'user_country', ''), _defineProperty(_this$state2, 'user_ip', ''), _defineProperty(_this$state2, 'user_state', ''), _defineProperty(_this$state2, 'user_continent', ''), _defineProperty(_this$state2, 'chapterName', ''), _this$state2);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(SOA_FM_VideoDisplay, [{
	    key: '_goToPreviousReading',
	    value: function _goToPreviousReading() {
	      var _this3 = this;
	
	      if (this.state.currentUrl === 0) {
	        return;
	      }
	
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
	        // console.log("_goToPreviousReading");
	
	        this.setState({ currentUrl: this.state.currentUrl - 1 }, function () {
	          _this3.setState({
	            video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	          });
	          _this3.setState({
	            video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	          });
	          _this3.setState({
	            video_title: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	          });
	          _this3.setState({
	            currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	          });
	          _this3.setState({
	            currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	          });
	          _this3.setState({
	            currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	          });
	          _this3.setState({
	            pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	          });
	        });
	        this.context.router.push({
	          pathname: '/soa/financialmathematics/videodisplay/' + this.props.params.id + '/' + this.props.params.showFreePremium + '/' + this.props.params.type + '/' + this.props.params.chapter_id + '/' + this.state.currentUrl
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	      } else {
	        //console.log(' inside else of _goToPreviousReading');
	
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this3.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.context.router.push({
	                      pathname: '/soa/financialmathematics/videodisplay/' + _this3.props.params.id + '/' + _this3.props.params.showFreePremium + '/' + _this3.props.params.type + '/' + _this3.props.params.chapter_id + '/' + _this3.state.currentUrl
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '') {
	              return _this3.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this3.state.token,
	                idname: _this3.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this3.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                  if (isInArray_var) {
	                    _this3.setState({ currentUrl: _this3.state.currentUrl - 1 }, function () {
	                      _this3.setState({
	                        free: _this3.state.chapters[_this3.state.currentUrl].free
	                      });
	                      _this3.setState({
	                        video_display: _this3.state.chapters[_this3.state.currentUrl].url_id
	                      });
	                      _this3.setState({
	                        video_display_qq: _this3.state.chapters[_this3.state.currentUrl].url_id_qq
	                      });
	                      _this3.setState({
	                        video_title: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        currentReading: _this3.state.chapters[_this3.state.currentUrl].id
	                      });
	                      _this3.setState({
	                        currentChapterNo: _this3.state.chapters[_this3.state.currentUrl].chapter_id
	                      });
	                      _this3.setState({
	                        currentReadingNo: _this3.state.chapters[_this3.state.currentUrl].reading_no
	                      });
	                      _this3.setState({
	                        currentReadingTitle: _this3.state.chapters[_this3.state.currentUrl].title
	                      });
	                      _this3.setState({
	                        pdf_file: _this3.state.chapters[_this3.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this3.context.router.push({
	                      pathname: '/soa/financialmathematics/videodisplay/' + _this3.props.params.id + '/' + _this3.props.params.showFreePremium + '/' + _this3.props.params.type + '/' + _this3.props.params.chapter_id + '/' + _this3.state.currentUrl
	                    });
	                    _this3.trackUserWatchedVideo(_this3.state.chapters[_this3.state.currentUrl].id, _this3.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this3.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_goToNextReading',
	    value: function _goToNextReading() {
	      var _this4 = this;
	
	      this.setState({
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveVideo_text: '' + _language2.default.LC().SAVE_VIDEO
	      });
	      if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
	        // console.log("_goToNextReading if");
	
	        this.setState({ currentUrl: this.state.currentUrl + 1 }, function () {
	          _this4.setState({
	            video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	          });
	          _this4.setState({
	            video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	          });
	          _this4.setState({
	            video_title: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	          });
	          _this4.setState({
	            currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	          });
	          _this4.setState({
	            currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	          });
	          _this4.setState({
	            currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	          });
	          _this4.setState({
	            pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	          });
	        });
	        this.context.router.push({
	          pathname: '/soa/financialmathematics/videodisplay/' + this.props.params.id + '/' + this.props.params.showFreePremium + '/' + this.props.params.type + '/' + this.props.params.chapter_id + '/' + this.state.currentUrl
	        });
	        this.trackUserWatchedVideo(this.state.chapters[this.state.currentUrl].id, this.state.currentUrl);
	        return;
	      }
	      if (this.state.currentUrl === this.state.chapters.length - 1) {
	        //  console.log("if");
	
	        // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
	        return;
	      } else {
	        var data = { token: this.state.token, idname: this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this4.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                  if (isInArray_var) {
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.context.router.push({
	                      pathname: '/soa/financialmathematics/videodisplay/' + _this4.props.params.id + '/' + _this4.props.params.showFreePremium + '/' + _this4.props.params.type + '/' + _this4.props.params.chapter_id + '/' + _this4.state.currentUrl
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  //console.log('fail');
	                }
	              });
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '') {
	              return _this4.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this4.state.selectedmenu;
	                  var isInArray_var = false;
	                  isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                  if (isInArray_var) {
	                    _this4.setState({ currentUrl: _this4.state.currentUrl + 1 }, function () {
	                      _this4.setState({
	                        video_display: _this4.state.chapters[_this4.state.currentUrl].url_id
	                      });
	                      _this4.setState({
	                        video_display_qq: _this4.state.chapters[_this4.state.currentUrl].url_id_qq
	                      });
	                      _this4.setState({
	                        video_title: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        currentReading: _this4.state.chapters[_this4.state.currentUrl].id
	                      });
	                      _this4.setState({
	                        currentChapterNo: _this4.state.chapters[_this4.state.currentUrl].chapter_id
	                      });
	                      _this4.setState({
	                        currentReadingNo: _this4.state.chapters[_this4.state.currentUrl].reading_no
	                      });
	                      _this4.setState({
	                        currentReadingTitle: _this4.state.chapters[_this4.state.currentUrl].title
	                      });
	                      _this4.setState({
	                        pdf_file: _this4.state.chapters[_this4.state.currentUrl].pdf_file
	                      });
	                    });
	                    _this4.context.router.push({
	                      pathname: '/soa/financialmathematics/videodisplay/' + _this4.props.params.id + '/' + _this4.props.params.showFreePremium + '/' + _this4.props.params.type + '/' + _this4.props.params.chapter_id + '/' + _this4.state.currentUrl
	                    });
	                    _this4.trackUserWatchedVideo(_this4.state.chapters[_this4.state.currentUrl].id, _this4.state.currentUrl);
	                    return;
	                  } else {
	                    // console.log('ELSE WORKING')
	                    return _this4.toggleAlert();
	                  }
	                } else {
	                  //console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    }
	
	    //Function to show Report box
	
	
	    //Function to hide Report box
	
	
	    //Function to save new report question
	
	
	    //Function to toggle Comment box
	
	
	    //Function to toggle Flash box
	
	
	    //Function to Save flash Card And display new stored flash card
	
	
	    //Function to Edit Flash card
	
	
	    //Function to delete flash card
	
	
	    // Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus) {
	      var _this5 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        chapter_id: this.state.currentChapterNo,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	      // console.log(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this5.context.router.push({
	              pathname: '/soa/financialmathematics/readings/' + _this5.state.currentChapterNo + '/' + 1,
	              state: {
	                token: _this5.state.token,
	                idname: _this5.state.idname,
	                chapter: _this5.state.currentChapterNo,
	                chapterName: _this5.state.Chapter_Title
	              }
	            });
	          } else {
	            _this5.toggleAlert();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(prevProps, prevState) {
	        var _this6 = this;
	
	        var params;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(prevState.currentReading !== this.state.currentReading)) {
	                  _context7.next = 7;
	                  break;
	                }
	
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context7.next = 4;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 4:
	                params = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  video_id: this.state.currentReading
	                };
	                _context7.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this6.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._editFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this6._deleteFlash.bind(_this6, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this6.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this6.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this6.setState({ ValidToken: false });
	                    _this6.setState({ flash_data: flash_cards });
	                    _this6.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidUpdate(_x14, _x15) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	        var _this7 = this;
	
	        var location, _location$query$chapt, chapter_name, result, storage_session, data, params;
	
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                location = this.props.location;
	                _location$query$chapt = location.query.chapter_name, chapter_name = _location$query$chapt === undefined ? '' : _location$query$chapt;
	
	                if (chapter_name) {
	                  this.setState({
	                    chapterName: chapter_name
	                  });
	                }
	                // api to get ip address
	                _context9.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context9.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                if (this.state.showFreePremium) {
	                  this.setState({ userType: 'free' });
	                } else if (!this.state.showFreePremium) {
	                  this.setState({ userType: 'paid' });
	                }
	
	                // console.log('this.props', this.props);
	                if (this.props.params.index) {
	                  this.setState({ currentUrl: parseInt(this.props.params.index) });
	                } else {
	                  // console.log('Else Working');
	                  this.setState({ currentUrl: 0 });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter_id: this.props.params.chapter_id || this.props.params.id
	                };
	                _context9.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getSoaFmVideosChapterwise', data).then(function () {
	                  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context8.next = 10;
	                              break;
	                            }
	
	                            _context8.next = 3;
	                            return _this7.setState({ ValidToken: true });
	
	                          case 3:
	                            _context8.next = 5;
	                            return _this7.setState({ chapters: resp.soafmvchapter });
	
	                          case 5:
	                            if (!(_this7.state.chapters && _this7.state.chapters[_this7.state.currentUrl])) {
	                              _context8.next = 8;
	                              break;
	                            }
	
	                            _context8.next = 8;
	                            return _this7.setState({
	                              pdf_file: _this7.state.chapters[_this7.state.currentUrl].pdf_file,
	                              currentReading: _this7.state.chapters[_this7.state.currentUrl].id,
	                              video_display: _this7.state.chapters[_this7.state.currentUrl].url_id,
	                              video_display_qq: _this7.state.chapters[_this7.state.currentUrl].url_id_qq,
	                              video_display_previous: _this7.state.chapters[_this7.state.currentUrl].url_id,
	                              video_title: _this7.state.chapters[_this7.state.currentUrl].title,
	                              video_display_next: _this7.state.chapters[_this7.state.currentUrl + 1] ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id_qq ? _this7.state.chapters[_this7.state.currentUrl + 1].url_id_qq : _this7.state.chapters[_this7.state.currentUrl + 1].url_id : null,
	                              currentChapterNo: _this7.state.chapters[_this7.state.currentUrl].chapter_id,
	                              currentReadingNo: _this7.state.chapters[_this7.state.currentUrl].reading_no,
	                              currentReadingTitle: _this7.state.chapters[_this7.state.currentUrl].title
	                            });
	
	                          case 8:
	                            _context8.next = 11;
	                            break;
	
	                          case 10:
	                            _this7.setState({ ValidToken: false });
	
	                          case 11:
	                            return _context8.abrupt('return', resp);
	
	                          case 12:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this7);
	                  }));
	
	                  return function (_x16) {
	                    return _ref9.apply(this, arguments);
	                  };
	                }());
	
	              case 14:
	                _context9.next = 16;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getSoaFmVideos', data).then(function (resp) {
	                  if (resp.success) {
	                    _this7.setState({ ValidToken: true });
	                    _this7.setState({ allChapters: resp.soafmvideo });
	                    _this7.props.params.chapter_id === undefined ? null : _this7.setState({
	                      Chapter_Title: resp.soafmvideo[_this7.props.params.chapter_id - 1].chapter_name
	                    });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 16:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context9.next = 19;
	                return this.getSavedVideo(this.state.currentReading);
	
	              case 19:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  video_id: this.state.currentReading
	                };
	                _context9.next = 22;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/videoGetFlashCards', params).then(function (response) {
	                  var flash_cards = '';
	                  if (response.success) {
	                    _this7.setState({ ValidToken: true });
	                    if (response.flash_cards.length > 0) {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                      });
	                      flash_cards = response.flash_cards.map(function (items, index) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: index },
	                          _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'icon_list' },
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._editFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { className: 'pointer_class', onClick: _this7._deleteFlash.bind(_this7, items) },
	                                  _react2.default.createElement('i', { className: 'fa fa-close' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this7.state.flash_class },
	                              _react2.default.createElement('h4', null),
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                items.flash_card
	                              )
	                            )
	                          )
	                        );
	                      });
	                    } else {
	                      _this7.setState({
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                    }
	                    _this7.setState({ flash_data: flash_cards });
	                  } else {
	                    flash_cards = _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    );
	                    _this7.setState({ ValidToken: false });
	                    _this7.setState({ flash_data: flash_cards });
	                    _this7.setState({
	                      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                    });
	                  }
	                });
	
	              case 22:
	                params = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context9.next = 25;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getSoaFmVideoPdf', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this7.setState({ pdfData: resp });
	                  } else {
	                    _this7.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 25:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function componentDidMount() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    saved viewed video
	    */
	
	    //Function to Display Saved Question on button and save in database
	
	
	    // function to track user watched video
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          currentReading = _state.currentReading,
	          isFlashCardHidden = _state.isFlashCardHidden,
	          chapters = _state.chapters;
	
	      var styles_css = {
	        marginBottom: '20px'
	      };
	      var data = '';
	      if (this.state.chapters.length > 0) {
	        data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'full-width', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'videotitle', key: item.id, value: item.id },
	                _this8.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-free' },
	                  _language2.default.LC().FREE
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'video-type-primum' },
	                  _language2.default.LC().PREMIUM
	                ) : _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    name: 'videourl',
	                    id: item.id,
	                    className: item.url_id_qq ? item.url_id_qq === _this8.state.video_display_qq ? 'active' : '' : item.url_id === _this8.state.video_display ? 'active' : '',
	                    onClick: _this8.getVideourl.bind(_this8, index, item.url_id, item.title, item.id, item.url_id_qq, item.free),
	                    value: item.url
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-play-circle' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-overflow' },
	                    item.title
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-inverse card-primary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().NO_RECORD_FOUND
	            ),
	            _react2.default.createElement('div', { className: 'card-block' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn coming_soon_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6' },
	            this.state.type === 'intro' ? _react2.default.createElement(
	              'h4',
	              null,
	              ' Introduction '
	            ) : this.state.Chapter_Title ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.Chapter_Title
	            ) : this.state.chapterName ? _react2.default.createElement(
	              'h4',
	              null,
	              ' ',
	              this.state.chapterName
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6 col-md-6 text-right', style: styles_css },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().BACK_TO_VIDEOS
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.chapters.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'loader_box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-circle' },
	              _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	              _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'video_outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-8 col-md-8' },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    this.state.video_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-4 col-md-4', style: styles_css },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    this.state.currentUrl === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class',
	                      onClick: this._goToPreviousReading.bind(this)
	                    }),
	                    this.state.currentUrl === this.state.chapters.length - 1 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class',
	                      onClick: this._goToNextReading.bind(this)
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row videos-main-wraper p-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '', id: 'video-height' },
	                    this.state.video_display_qq ? _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        allowFullScreen: true,
	                        width: '100%',
	                        height: '100%',
	                        position: 'absolute',
	                        top: '10',
	                        left: '0',
	                        src: (0, _constant.flowPlayerVideoDisplayUrl)(this.state.video_display_qq),
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                        title: '0',
	                        byline: '0',
	                        portrait: '0',
	                        frameborder: '10'
	                      })
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'embed-responsive embed-responsive-16by9' },
	                      _react2.default.createElement('iframe', {
	                        className: 'embed-responsive-item',
	                        width: '100%',
	                        height: '100%',
	                        title: 'video',
	                        frameBorder: '0',
	                        src: 'https://www.youtube.com/embed/' + this.state.video_display + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                        allowFullScreen: true,
	                        sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading',
	                    id: 'video-tag-list'
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link_list_wrap' },
	                    data
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              ' '
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportIcons2.default, {
	              moveToNotes: this.moveToNotes,
	              notesCSS: this.state.notesCSS,
	              moveToPracticeQuestions: this.moveToPracticeQuestions,
	              _saveFavVideo: this._saveFavVideo,
	              _displayReportForm: this._displayReportForm,
	              pdfOpen: this.pdfOpen,
	              bookmarkCSS: this.state.bookmarkCSS,
	              bookmarkColor: this.state.bookmarkColor,
	              type: this.state.type,
	              questionsCSS: this.state.questionsCSS,
	              saveVideo_text: this.state.saveVideo_text,
	              currentReading: this.state.currentReading,
	              chapters: this.state.chapters,
	              showFreePremium: this.state.showFreePremium,
	              noPDFInExam: true
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: currentReading },
	              type: 'video',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'soa_fm'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.report_block },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header' },
	                    _language2.default.LC().REPORT
	                  ),
	                  !this.state.successAlert ? _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            _language2.default.LC().COMMENT
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                        _react2.default.createElement('textarea', {
	                          id: 'comment',
	                          name: 'comment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Content..'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-12 col-md-12' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class report-btn',
	                            disabled: reportLoading,
	                            onClick: this._reportQuestion.bind(this, this.state.currentReading)
	                          },
	                          reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-danger active pointer_class margin_left_10',
	                            onClick: this._hideReportForm.bind(this)
	                          },
	                          _language2.default.LC().CANCEL
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: this.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'row' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Modal2.default, {
	                goPremium: this.goPremium.bind(this),
	                toggleAlert: this.toggleAlert.bind(this),
	                alert_status: this.state.alert_status,
	                MessageContent: this.state.MessageContent
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_VideoDisplay;
	}(_react.Component);
	
	SOA_FM_VideoDisplay.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.resizeListener = function () {
	      var videoHeight = document.getElementById('video-height');
	      var videoOffsetHeight = videoHeight ? videoHeight.offsetHeight : null;
	      var windowwidth = window.innerWidth;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoOffsetHeight + 'px';
	      if (windowwidth > 992) {
	        if (listHeight) {
	          listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	        }
	      } else {
	        if (listHeight) {
	          listHeight.setAttribute('style', 'height: auto !important');
	        }
	      }
	    };
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	        var _this10 = this;
	
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                // set resize listener
	                window.addEventListener('resize', this.resizeListener);
	                // clean up function
	                return _context10.abrupt('return', function () {
	                  // remove resize listener
	                  window.removeEventListener('resize', _this10.resizeListener);
	                });
	
	              case 2:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var videoHeight = document.getElementById('video-height');
	      var videoOffsetHeight = videoHeight ? videoHeight.offsetHeight : null;
	      var windowwidth = window.innerWidth;
	      var listHeight = document.getElementById('video-tag-list');
	      var importantHeight = videoOffsetHeight + 'px';
	      if (windowwidth > 992) {
	        if (listHeight) {
	          listHeight.setAttribute('style', 'height: ' + importantHeight + ' !important');
	        }
	      } else {
	        if (listHeight) {
	          listHeight.setAttribute('style', 'height: auto !important');
	        }
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_FM_VideoDisplay;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(1013);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _SoaFMSubscription = __webpack_require__(98);
	
	var _SoaFMSubscription2 = _interopRequireDefault(_SoaFMSubscription);
	
	var _SoaFMSubscription3 = __webpack_require__(97);
	
	var _SoaFMSubscription4 = _interopRequireDefault(_SoaFMSubscription3);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _constant = __webpack_require__(9);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_FM_VideoLessons = function (_Component) {
	  _inherits(SOA_FM_VideoLessons, _Component);
	
	  function SOA_FM_VideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_FM_VideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (SOA_FM_VideoLessons.__proto__ || Object.getPrototypeOf(SOA_FM_VideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(chapter, e) {
	        var chap, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                chap = chapter.chapter_no;
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  chapter_id: chap
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2022/getcfavideosChapterwise', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (resp.success) {
	                              if (_this.state.showFreePremium === true) {
	                                _this.toggleAlert();
	                              } else if (_this.state.showFreePremium === false) {
	                                _this.context.router.push({
	                                  pathname: '/soa/financialmathematics/videodisplay/' + resp.cfavchapterfirst.id + '/' + (_this.state.showFreePremium ? 0 : 1) + '/' + resp.cfavchapterfirst.chapter_id + '/' + chapter.chapter_no
	                                });
	                              }
	                            } else {}
	
	                          case 1:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: '/soa/financialmathematics/videodisplay/' + lastRecord.soa_fm_video.id + '/' + (_this.state.showFreePremium ? 0 : 1) + '/' + (lastRecord.soa_fm_video.chapter_id === 0 ? 0 : 1) + '/' + lastRecord.soa_fm_video.chapter_id + '/' + lastRecord.videoIndex,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.soa_fm_video,
	                    index: lastRecord.videoIndex,
	                    showFreePremium: _this.state.showFreePremium
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    var messageTitle_soa_fm = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_soa_fm,
	      MessageContent: _alertMessage2.default.messageContent_soa_fm,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'soa_fm',
	      exams: [],
	      lastRecord: '',
	      lastAttempt: false,
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    return _this;
	  }
	
	  _createClass(SOA_FM_VideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var _this3 = this;
	
	        var result, storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context6.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                if (localStorage.getItem('selectedmenu') == 'frm') {
	                  this.context.router.push({
	                    pathname: '/frm/questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	                this.dispose = (0, _mobx.autorun)(_asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                  var resp, data_arr, dataset;
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          resp = _userStore2.default;
	
	                          if (!(resp == null || resp.profileInfo == null)) {
	                            _context5.next = 3;
	                            break;
	                          }
	
	                          return _context5.abrupt('return');
	
	                        case 3:
	                          if (!(resp.profileInfo.role === 'partner')) {
	                            _context5.next = 14;
	                            break;
	                          }
	
	                          if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                            _context5.next = 8;
	                            break;
	                          }
	
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context5.next = 12;
	                          break;
	
	                        case 8:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context5.next = 12;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this3.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                              if (isInArray_var) {
	                                _this3.setState({ showFreePremium: false });
	                              } else {
	                                _this3.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 12:
	                          _context5.next = 22;
	                          break;
	
	                        case 14:
	                          if (!(resp.profileInfo.exam_selected === '')) {
	                            _context5.next = 18;
	                            break;
	                          }
	
	                          _this3.setState({
	                            showFreePremium: true
	                          });
	                          _context5.next = 22;
	                          break;
	
	                        case 18:
	                          data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                          dataset = {
	                            token: _this3.state.token,
	                            idname: _this3.state.idname,
	                            examid: data_arr
	                          };
	                          _context5.next = 22;
	                          return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                            if (resp_exam.success) {
	                              var exam_data = resp_exam.examData;
	                              var selectedmen = _this3.state.selectedmenu;
	                              var isInArray_var = false;
	                              isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                              if (isInArray_var) {
	                                _this3.setState({ showFreePremium: false });
	                              } else {
	                                _this3.setState({ showFreePremium: true });
	                              }
	                            } else {
	                              // console.log('fail');
	                            }
	                          });
	
	                        case 22:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this3);
	                })));
	
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context6.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getSoaFmVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    //console.log(resp);
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ chapters: resp.soafmvideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 14:
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context6.next = 17;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getLastViewedVideo', data_data).then(function (response) {
	                  //console.log("hvedf", response);
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 17:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      //console.log(language.LC())
	      //console.log(this.state.showFreePremium);
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      //console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return item.Countvideos > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().TOPIC,
	                  ' ',
	                  item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          ) : null;
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent
	          })
	        )
	      );
	    }
	  }]);
	
	  return SOA_FM_VideoLessons;
	}(_react.Component);
	
	SOA_FM_VideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	var ChatperwiseReadingData = function (_Component2) {
	  _inherits(ChatperwiseReadingData, _Component2);
	
	  function ChatperwiseReadingData(props) {
	    var _this6 = this,
	        _this5$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this5 = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this5.toggleAlert = function () {
	      _this5.setState({
	        alert_status: !_this5.state.alert_status
	      });
	    };
	
	    _this5.goPremium = function () {
	      _this5.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this5.state.token,
	          idname: _this5.state.idname,
	          selectedMenu: _this5.state.selectedmenu
	        }
	      });
	    };
	
	    _this5._getReadings = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(chapter, index) {
	        var data, _data;
	
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _context10.next = 2;
	                return _this5.savelastVideo(chapter, index);
	
	              case 2:
	                if (chapter.free === 1) {
	                  data = {
	                    token: _this5.state.token,
	                    idname: _this5.state.idname,
	                    id: chapter.id,
	                    videoIndex: index,
	                    city: _this5.state.user_city,
	                    country: _this5.state.user_country,
	                    state: _this5.state.user_state,
	                    continent: _this5.state.user_continent,
	                    ip: _this5.state.user_ip
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/trackUserVideowatch', data).then(function () {
	                    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp) {
	                      return _regenerator2.default.wrap(function _callee7$(_context7) {
	                        while (1) {
	                          switch (_context7.prev = _context7.next) {
	                            case 0:
	                              if (resp.success) {
	                                _this5.context.router.push({
	                                  pathname: '/soa/financialmathematics/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                  state: {
	                                    token: _this5.state.token,
	                                    idname: _this5.state.idname,
	                                    chapter: chapter,
	                                    index: index,
	                                    showFreePremium: _this5.state.showFreePremium
	                                  }
	                                });
	                              } else {}
	
	                            case 1:
	                            case 'end':
	                              return _context7.stop();
	                          }
	                        }
	                      }, _callee7, _this6);
	                    }));
	
	                    return function (_x6) {
	                      return _ref8.apply(this, arguments);
	                    };
	                  }());
	                } else {
	                  _data = { token: _this5.state.token, idname: _this5.state.idname };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', _data).then(function (resp) {
	                    if (resp.profileInfo.role === 'partner') {
	                      if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                        _this5.toggleAlert();
	                      } else {
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          // console.log(resp_exam);
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            var selectedmen = _this5.state.selectedmenu;
	                            var isInArray_var = false;
	                            isInArray_var = _SoaFMSubscription4.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	
	                            if (isInArray_var) {
	                              var _data2 = {
	                                token: _this5.state.token,
	                                idname: _this5.state.idname,
	                                id: chapter.id,
	                                videoIndex: index,
	                                city: _this5.state.user_city,
	                                country: _this5.state.user_country,
	                                state: _this5.state.user_state,
	                                continent: _this5.state.user_continent,
	                                ip: _this5.state.user_ip
	                              };
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/trackUserVideowatch', _data2).then(function () {
	                                var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                                  return _regenerator2.default.wrap(function _callee8$(_context8) {
	                                    while (1) {
	                                      switch (_context8.prev = _context8.next) {
	                                        case 0:
	                                          if (resp.success) {
	                                            _this5.context.router.push({
	                                              pathname: '/soa/financialmathematics/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                              state: {
	                                                token: _this5.state.token,
	                                                idname: _this5.state.idname,
	                                                chapter: chapter,
	                                                index: index,
	                                                showFreePremium: _this5.state.showFreePremium
	                                              }
	                                            });
	                                          } else {}
	
	                                        case 1:
	                                        case 'end':
	                                          return _context8.stop();
	                                      }
	                                    }
	                                  }, _callee8, _this6);
	                                }));
	
	                                return function (_x7) {
	                                  return _ref9.apply(this, arguments);
	                                };
	                              }());
	                            } else {
	                              // console.log('ELSE WORKING')
	                              return _this5.toggleAlert();
	                            }
	                          } else {
	                            // console.log('fail');
	                          }
	                        });
	                      }
	                    } else {
	                      if (resp.profileInfo.exam_selected === '') {
	                        return _this5.toggleAlert();
	                      } else {
	                        var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                        var dataset = {
	                          token: _this5.state.token,
	                          idname: _this5.state.idname,
	                          examid: data_arr
	                        };
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          // console.log(resp_exam);
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            var selectedmen = _this5.state.selectedmenu;
	                            var isInArray_var = false;
	                            isInArray_var = _SoaFMSubscription2.default.checkSoaFMVideosSubscription(selectedmen, exam_data);
	                            if (isInArray_var) {
	                              var _data3 = {
	                                token: _this5.state.token,
	                                idname: _this5.state.idname,
	                                id: chapter.id,
	                                videoIndex: index,
	                                city: _this5.state.user_city,
	                                country: _this5.state.user_country,
	                                state: _this5.state.user_state,
	                                continent: _this5.state.user_continent,
	                                ip: _this5.state.user_ip
	                              };
	                              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/trackUserVideowatch', _data3).then(function () {
	                                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                                    while (1) {
	                                      switch (_context9.prev = _context9.next) {
	                                        case 0:
	                                          if (resp.success) {
	                                            _this5.context.router.push({
	                                              pathname: '/soa/financialmathematics/videodisplay/' + chapter.id + '/' + (_this5.state.showFreePremium ? 0 : 1) + '/' + (chapter.chapter_id === 0 ? 0 : 1) + '/' + chapter.chapter_id + '/' + index,
	                                              state: {
	                                                token: _this5.state.token,
	                                                idname: _this5.state.idname,
	                                                chapter: chapter,
	                                                index: index,
	                                                showFreePremium: _this5.state.showFreePremium
	                                              }
	                                            });
	                                          } else {}
	
	                                        case 1:
	                                        case 'end':
	                                          return _context9.stop();
	                                      }
	                                    }
	                                  }, _callee9, _this6);
	                                }));
	
	                                return function (_x8) {
	                                  return _ref10.apply(this, arguments);
	                                };
	                              }());
	                            } else {
	                              // console.log('ELSE WORKING')
	                              return _this5.toggleAlert();
	                            }
	                          } else {
	                            // console.log('fail');
	                          }
	                        });
	                      }
	                    }
	                  });
	                }
	
	              case 3:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this6);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this5.savelastVideo = function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(chapter, index) {
	        var _this5$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _this5$state = _this5.state, token = _this5$state.token, idname = _this5$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  videoIndex: index
	                };
	                _context11.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this6);
	      }));
	
	      return function (_x9, _x10) {
	        return _ref11.apply(this, arguments);
	      };
	    }();
	
	    _this5.iframe = {
	      padding: 10
	    };
	
	    _this5.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	      //console.log('this.state.allchapters.length', this.state.allchapters.length);
	
	      if (_this5.state.allchapters.length > 0) {
	        var count = 0;
	        data = _this5.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this5.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              alt: '',
	              width: '100%',
	              src: item.posterImage ? item.posterImage : (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1'),
	              onError: function onError(_ref12) {
	                var currentTarget = _ref12.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	                  currentTarget.onerror = null; // prevents looping
	                  currentTarget.src = (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1_2');
	                }
	              },
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_soa_fm = '<i class="icon-info icons font-2xl d-block "></i>';
	
	    _this5.state = (_this5$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_soa_fm,
	      MessageContent: _alertMessage2.default.messageContent_soa_fm,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this5$state2, 'offset', 0), _defineProperty(_this5$state2, 'limit', 10), _defineProperty(_this5$state2, 'Allchapters', []), _defineProperty(_this5$state2, 'itemData', []), _defineProperty(_this5$state2, 'videoUrl', ''), _defineProperty(_this5$state2, 'srcUrl', ''), _defineProperty(_this5$state2, 'srcUrl_final', ''), _defineProperty(_this5$state2, 'selectedmenu', 'soa_fm'), _defineProperty(_this5$state2, 'showFreePremium', true), _defineProperty(_this5$state2, 'user_city', ''), _defineProperty(_this5$state2, 'user_country', ''), _defineProperty(_this5$state2, 'user_ip', ''), _defineProperty(_this5$state2, 'user_state', ''), _defineProperty(_this5$state2, 'user_continent', ''), _this5$state2);
	    return _this5;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	        var _this7 = this;
	
	        var result, storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 2:
	                result = _context12.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context12.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_fm_videos/getSoaFmVideosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    //console.log('getSoaFmVideosChapterwise', resp);
	                    _this7.setState({ allchapters: resp.soafmvchapter });
	                  } else {
	                    _this7.setState({ allchapters: [] });
	                    _this7.setState({ ValidToken: false });
	                  }
	                });
	
	              case 11:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      function componentDidMount() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      //console.log(this.state.showFreePremium);
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_FM_VideoLessons;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _SoaPSubscription3 = __webpack_require__(105);
	
	var _SoaPSubscription4 = _interopRequireDefault(_SoaPSubscription3);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var SOA_P_BeforeStart = function (_Component) {
	  _inherits(SOA_P_BeforeStart, _Component);
	
	  function SOA_P_BeforeStart(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_BeforeStart);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_BeforeStart.__proto__ || Object.getPrototypeOf(SOA_P_BeforeStart)).call(this, props));
	
	    _this._createQuizpage = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/quizzes',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._startQuizpage = function () {
	      var data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	          var data_arr, dataset;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (!(resp.profileInfo.role === 'partner')) {
	                    _context3.next = 11;
	                    break;
	                  }
	
	                  if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                    _context3.next = 5;
	                    break;
	                  }
	
	                  _this.toggleAlert();
	                  _context3.next = 9;
	                  break;
	
	                case 5:
	                  data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  dataset = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    examid: data_arr
	                  };
	                  _context3.next = 9;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var;
	                      return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context.next = 10;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this.state.selectedmenu;
	                              isInArray_var = false;
	                              _context.next = 6;
	                              return _SoaPSubscription4.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                            case 6:
	                              isInArray_var = _context.sent;
	
	                              if (isInArray_var) {
	                                _this.context.router.push({
	                                  pathname: '/soa/probability/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                  state: {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    quiz_id: _this.state.quiz_id,
	                                    offset: _this.state.offset_send
	                                  }
	                                });
	                              } else {
	                                _this.toggleAlert();
	                              }
	                              _context.next = 10;
	                              break;
	
	                            case 10:
	                            case 'end':
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x2) {
	                      return _ref2.apply(this, arguments);
	                    };
	                  }()
	                  // console.log('fail');
	                  );
	
	                case 9:
	                  _context3.next = 19;
	                  break;
	
	                case 11:
	                  if (!(resp.profileInfo.exam_selected == '')) {
	                    _context3.next = 15;
	                    break;
	                  }
	
	                  _this.toggleAlert();
	                  _context3.next = 19;
	                  break;
	
	                case 15:
	                  data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                  dataset = {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    examid: data_arr
	                  };
	                  _context3.next = 19;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                      var exam_data, selectedmen, isInArray_var;
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              if (!resp_exam.success) {
	                                _context2.next = 10;
	                                break;
	                              }
	
	                              exam_data = resp_exam.examData;
	                              selectedmen = _this.state.selectedmenu;
	                              isInArray_var = false;
	                              _context2.next = 6;
	                              return _SoaPSubscription2.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                            case 6:
	                              isInArray_var = _context2.sent;
	
	                              if (isInArray_var) {
	                                _this.context.router.push({
	                                  pathname: '/soa/probability/beginquiz/' + _this.state.quiz_id + '/' + _this.state.offset_send,
	                                  state: {
	                                    token: _this.state.token,
	                                    idname: _this.state.idname,
	                                    quiz_id: _this.state.quiz_id,
	                                    offset: _this.state.offset_send
	                                  }
	                                });
	                              } else {
	                                _this.toggleAlert();
	                              }
	                              _context2.next = 10;
	                              break;
	
	                            case 10:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this2);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }()
	                  // console.log('fail');
	                  );
	
	                case 19:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this._startQuizquestion = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(item, offset_va, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context7.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                      while (1) {
	                        switch (_context6.prev = _context6.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context6.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context6.next = 5;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                                  while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context4.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context4.next = 6;
	                                        return _SoaPSubscription4.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                                      case 6:
	                                        isInArray_var = _context4.sent;
	
	                                        if (isInArray_var) {
	                                          _this.context.router.push({
	                                            pathname: '/soa/probability/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                                            state: {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              quiz_id: _this.state.quiz_id,
	                                              offset: offset_va
	                                            }
	                                          });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context4.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context4.stop();
	                                    }
	                                  }
	                                }, _callee4, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref6.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 9:
	                            _context6.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected == '')) {
	                              _context6.next = 15;
	                              break;
	                            }
	
	                            _this.toggleAlert();
	                            _context6.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context6.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context5.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context5.next = 6;
	                                        return _SoaPSubscription2.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                                      case 6:
	                                        isInArray_var = _context5.sent;
	
	                                        if (isInArray_var) {
	                                          _this.context.router.push({
	                                            pathname: '/soa/probability/beginquiz/' + _this.state.quiz_id + '/' + offset_va,
	                                            state: {
	                                              token: _this.state.token,
	                                              idname: _this.state.idname,
	                                              quiz_id: _this.state.quiz_id,
	                                              offset: offset_va
	                                            }
	                                          });
	                                        } else {
	                                          _this.toggleAlert();
	                                        }
	                                        _context5.next = 10;
	                                        break;
	
	                                      case 10:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context6.stop();
	                        }
	                      }
	                    }, _callee6, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x4, _x5, _x6) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    var messageTitle_cfa = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_soa_p,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      status_send: _this.props.params.status_send ? _this.props.params.status_send : '',
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      user_time_value: '',
	      include_timer: '',
	      questions_count: '',
	      allrightanswercount: '',
	      offset_send: 0,
	      selectedmenu: 'soa_p'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_P_BeforeStart, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to Create Quiz page
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to Subscription page
	    ------------------------------------------------------
	    */
	
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to begin Quiz page
	    ------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to begin Quiz page
	    ------------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scroll(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token'],
	        quiz_id: this.state.quiz_id
	      };
	      //Api to fetch Quiz by quiz id
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getQuize', data).then(function (resp) {
	        if (resp.success) {
	          var retun_all_question = JSON.stringify(resp.singlequiz);
	          var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
	
	          var question_id = [];
	          //console.log(all_questions);
	          for (var i = 0; i < resp.questions_count; i++) {
	            question_id.push(all_questions[i]);
	          }
	          var minutes = resp.timer_value / 60;
	          _this3.setState({
	            all_question_id: question_id,
	            question_length: question_id.length,
	            timer_value: minutes,
	            include_timer: resp.include_timer,
	            user_time_value: resp.user_time_value,
	            questions_count: resp.questions_count
	          });
	        } else {
	          //console.log(resp.success + "------------failure");
	        }
	        return resp;
	      });
	      /*
	      -------------------------------------------------------
	      Api to fetch all right answered on particular quiz id
	      ------------------------------------------------------
	      */
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getrightAnswer', data).then(function (resp_count) {
	        if (resp_count.success) {
	          _this3.setState({
	            allrightanswercount: resp_count.allrightanswercount.count
	          });
	        } else {
	          //console.log(resp_count.success + "------------failure");
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var all_question_id = this.state.all_question_id;
	      var question_id_display = '';
	
	      if (all_question_id.length) {
	        question_id_display = all_question_id.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement('td', { id: 'questionNameId_' + index }),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(QuestionChecked, {
	                question_id: items,
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                quiz_id: _this4.state.quiz_id,
	                answered_state: index
	              })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'javascript: void(0)',
	                  onClick: _this4._startQuizquestion.bind(_this4, items, index)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      }
	      var user_time = '';
	      var min,
	          sec = '';
	      var status_data = '';
	      if (this.state.status_send === 'abondon') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      if (this.state.status_send === 'completed') {
	        if (this.state.user_time_value < 60) {
	          user_time = this.state.user_time_value + 'sec';
	        } else {
	          min = parseInt(this.state.user_time_value / 60);
	          sec = this.state.user_time_value % 60;
	          user_time = min + 'min ' + sec + 'sec ';
	        }
	        status_data = _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(
	            'div',
	            { className: 'score_wrapper card-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'margin_right_20' },
	                  _language2.default.LC().SCORE
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'score_box' },
	                  this.state.allrightanswercount,
	                  '/',
	                  this.state.questions_count
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'margin_right_20' },
	                  ' ',
	                  _language2.default.LC().TOTAL_TIME,
	                  ':'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  user_time
	                )
	              )
	            )
	          )
	        );
	      }
	
	      var button_status = '';
	      if (this.state.status_send === 'abondon') {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          ' ',
	          _language2.default.LC().CONTINUE
	        );
	      } else if (this.state.status_send === 'completed') {
	        button_status = '';
	      } else {
	        button_status = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary pointer_class', onClick: this._startQuizpage.bind(this) },
	          ' ',
	          _language2.default.LC().BEGIN
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            ' ',
	            _language2.default.LC().QUIZ_ID,
	            ': ',
	            this.state.quiz_id
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this._createQuizpage.bind(this)
	            },
	            _language2.default.LC().CREATE_NEW_QUIZ
	          )
	        ),
	        status_data,
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().SUMMARY,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-actions float-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_right_10' },
	                    _language2.default.LC().LENGTH
	                  ),
	                  ' ',
	                  this.state.question_length,
	                  ' ',
	                  _language2.default.LC().QUESTIONS,
	                  ', ',
	                  this.state.timer_value,
	                  ' ',
	                  _language2.default.LC().MINUTE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_40' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().BEFORE_STARTING,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'example_box_wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'margin_bottom_20' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().EXAMPLE
	                    )
	                  ),
	                  _react2.default.createElement('hr', { className: 'margin_bottom_30' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-9' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().NO_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_notanswered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().CORRECT_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_answered_status', className: 'margin_right_60' })
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'list-inline-item' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'text_light margin_right_20' },
	                            _language2.default.LC().WRONG_ANSWER
	                          ),
	                          _react2.default.createElement('span', { id: 'quiz_wrong_answered_status', className: 'margin_right_60' })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-3 text-right' },
	                      button_status
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header' },
	                _language2.default.LC().YOUR_ANSWERS
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_max_height abandoned_quizzes_cards_scroll' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().QUESTIONS
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().YOURS_ANSWER
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      question_id_display
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.SOA_P
	        })
	      );
	    }
	  }]);
	
	  return SOA_P_BeforeStart;
	}(_react.Component);
	/*This is  child component for checked Question is answered or not*/
	
	
	SOA_P_BeforeStart.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	function QuestionChecked(props) {
	  var data = {
	    token: props.token,
	    idname: props.idname,
	    quiz_id: props.quiz_id,
	    question_id: props.question_id
	  };
	  //Api to check quiz answered of particular question
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/checkAnswered', data).then(function (resp) {
	    document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
	    if (resp.success) {
	      // console.log(resp.question_recived);
	      if (resp.question_recived.answer === 1) {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_answered_status';
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().CORRECT_ANSWER;
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).id = 'quiz_wrong_answered_status';
	        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
	        document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().WRONG_ANSWER;
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).id = 'quiz_notanswered_status';
	      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
	      document.getElementById('answer_flag' + props.answered_state).innerHTML = '' + _language2.default.LC().NO_ANSWER;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('span', { className: 'margin_right_20', id: 'user_question_status' + props.answered_state }),
	    _react2.default.createElement('span', { id: 'answer_flag' + props.answered_state })
	  );
	}
	
	exports.default = SOA_P_BeforeStart;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStarRatings = __webpack_require__(35);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _SoaPSubscription3 = __webpack_require__(105);
	
	var _SoaPSubscription4 = _interopRequireDefault(_SoaPSubscription3);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRatingComponent from 'react-star-rating-component';
	
	// import { withRouter } from 'react-router';
	// import { Router, browserHistory } from 'react-router';
	// import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
	// import Dropzone from 'react-dropzone';
	// import request from 'superagent';
	// import GD from '../../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	
	var SOA_P_Beginchapters = function (_Component) {
	  _inherits(SOA_P_Beginchapters, _Component);
	
	  function SOA_P_Beginchapters(props) {
	    _classCallCheck(this, SOA_P_Beginchapters);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Beginchapters.__proto__ || Object.getPrototypeOf(SOA_P_Beginchapters)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      reportLoading: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      choice_d: 'answer_box',
	      choice_e: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: 'icon-control-pause pause_btn',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      question_length: '',
	      timer_stop: true,
	      timer_tag: 'Start',
	      display_loader: '',
	      selectedmenu: 'soa_p',
	      subscriptionstatus: 'paid',
	      chapter_name: '',
	      isEditable: false,
	      all_questions: '',
	      category: 'Actuarial - P(Probability)',
	      tags: ['probability', 'acturial', 'exam', 'question'],
	      title: '',
	      description: '',
	      forumComment: '',
	      isFlashCardHidden: true,
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }],
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: '',
	      attemptedQuestions: {},
	      selectedChoice: '',
	      showAnswer: false,
	      stopTimer: false,
	      setAnswer: false
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    _this.timer = null;
	    return _this;
	  }
	
	  _createClass(SOA_P_Beginchapters, [{
	    key: 'saveForumComment',
	    value: function saveForumComment(e) {
	      this.setState({ forumComment: e.target.value });
	    }
	  }, {
	    key: '_tick',
	    value: function _tick() {
	      var timer_stop = this.state.timer_stop;
	
	      if (!timer_stop) {
	        this.setState(function (prevState) {
	          return {
	            count: prevState.count + 1
	          };
	        });
	      }
	    }
	
	    //Funcion to save new report question
	
	
	    //Function to Edit Flash card
	
	
	    //Function to give star rattings
	
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var result, storage_session, user_data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                window.scrollTo(0, 0);
	
	                // Clear any existing timer first
	                if (this.timer) {
	                  clearInterval(this.timer);
	                  this.timer = null;
	                }
	
	                // Initialize timer state
	                this.setState({
	                  count: 0,
	                  timer_stop: true,
	                  timer_tag: 'Start',
	                  timerstopbtn: 'pause_btn icon-control-play'
	                });
	
	                // api to get ip address
	                _context.next = 5;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 5:
	                result = _context.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	
	                user_data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this2._runCode('free');
	                      _this2.setState({ subscriptionstatus: 'free' });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this2.state.selectedmenu;
	                          var isInArray_var = false;
	                          isInArray_var = _SoaPSubscription4.default.checkSoaPSubscription(selectedmen, exam_data);
	                          if (isInArray_var) {
	                            _this2._runCode('paid');
	                            _this2.setState({ subscriptionstatus: 'paid' });
	                          } else {
	                            _this2._runCode('free');
	                            _this2.setState({ subscriptionstatus: 'free' });
	                          }
	                        }
	                      });
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      _this2._runCode('free');
	                      _this2.setState({ subscriptionstatus: 'free' });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this2.state.token,
	                        idname: _this2.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this2.state.selectedmenu;
	                          var isInArray_var = false;
	                          isInArray_var = _SoaPSubscription2.default.checkSoaPSubscription(selectedmen, exam_data);
	                          if (isInArray_var) {
	                            _this2._runCode('paid');
	                            _this2.setState({ subscriptionstatus: 'paid' });
	                          } else {
	                            _this2._runCode('free');
	                            _this2.setState({ subscriptionstatus: 'free' });
	                          }
	                        }
	                      });
	                    }
	                  }
	                });
	
	                // Start timer when component mounts
	                this.timer = setInterval(this._tick, 1000);
	                this.setState({
	                  timer_stop: false,
	                  timer_tag: 'Stop',
	                  timerstopbtn: 'pause_btn icon-control-pause'
	                });
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: '_runCode',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(subscriptionStatus) {
	        var _this3 = this;
	
	        var storageSession, _props$params, readingid, notesid, id, offset, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                storageSession = JSON.parse(localStorage.getItem('localstorageval'));
	                _props$params = this.props.params, readingid = _props$params.readingid, notesid = _props$params.notesid, id = _props$params.id;
	                offset = this.state.offset;
	                data = {
	                  idname: storageSession['idname'],
	                  token: storageSession['token'],
	                  reading_id: readingid,
	                  chapter_id: notesid,
	                  offset: offset,
	                  subscriptionstatus: subscriptionStatus
	                };
	                _context2.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestions_allcr', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ all_questions_state: resp.questions });
	                    var quesRes = null;
	                    var offsetRes = '';
	                    for (var i = 0; i < resp.questions.length; i++) {
	                      if (resp.questions[i].id == id) {
	                        quesRes = resp.questions[i];
	                        offsetRes = i;
	                      }
	                      if (i === resp.questions.length - 1) {
	                        _this3.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    if (!quesRes && resp.questions.length > 0) {
	                      quesRes = resp.questions[0];
	                      offsetRes = 0;
	                    }
	                    if (!quesRes) {
	                      quesRes = {};
	                    }
	                    _this3.setState({ questions: quesRes });
	                    _this3.setState({ offset: offsetRes });
	                    _this3.setState({ question_length: resp.questions.length });
	                    if (offsetRes === 0) {
	                      _this3.setState({ previ_block: 'card hide_block' });
	                    }
	                    if (offsetRes === parseInt(resp.questions.length) - 1) {
	                      _this3.setState({ next_block: 'card hide_block' });
	                    }
	                    var selected = '';
	                    var showAnswer = false;
	                    var selectedChoice = quesRes['soa_p_question_stats.selected_choice'] || '';
	                    var rightAnswer = quesRes['soa_p_question_stats.right_answer'] || '';
	                    var answerStatus = quesRes['soa_p_question_stats.id'] || '';
	                    var timeDone = quesRes['soa_p_question_stats.time_done'] || 0;
	                    var correctChoiceKey = 'right_choice';
	                    var correct = quesRes[correctChoiceKey];
	                    if (selectedChoice) {
	                      selected = selectedChoice;
	                      showAnswer = true;
	                    } else if (answerStatus) {
	                      if (rightAnswer === 1) {
	                        selected = correct;
	                        showAnswer = true;
	                      } else if (!rightAnswer) {
	                        var choices = Object.keys(quesRes).filter(function (key) {
	                          return key.startsWith('choice') && key !== correct;
	                        });
	                        selected = choices.length > 0 ? choices[0] : '';
	                        showAnswer = true;
	                      }
	                    }
	                    var isCorrect = selected === correct;
	                    if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_P)) {
	                      clearInterval(_this3.timer);
	                      _this3.setState(Object.assign({
	                        timer_stop: true,
	                        timer_tag: 'Start',
	                        timerstopbtn: 'pause_btn icon-control-play',
	                        count: timeDone,
	                        selectedChoice: selected,
	                        clicked: true,
	                        showAnswer: showAnswer,
	                        stopTimer: true,
	                        setAnswer: true
	                      }, _this3.getChoices(selected, isCorrect, correct), {
	                        result_block: 'card show_block',
	                        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	                        result: isCorrect ? 'CORRECT' : 'INCORRECT'
	                      }));
	                    } else {
	                      clearInterval(_this3.timer);
	                      _this3.setState(Object.assign({
	                        timer_stop: false,
	                        timer_tag: 'Stop',
	                        timerstopbtn: 'pause_btn icon-control-pause',
	                        count: 0,
	                        selectedChoice: '',
	                        clicked: false,
	                        showAnswer: false,
	                        stopTimer: false,
	                        setAnswer: false,
	                        result_block: 'card hide_block'
	                      }, _this3.getChoices('', false, ''), {
	                        text_color: 'card-header',
	                        result: ''
	                      }));
	                      _this3.timer = setInterval(_this3._tick.bind(_this3), 1000);
	                    }
	
	                    _this3.setState({ records: '' });
	                    // Only fetch rating if quesRes is valid and has an id
	                    if (quesRes && quesRes.id) {
	                      var ratingParams = {
	                        token: storageSession['token'],
	                        question_id: quesRes.id,
	                        idname: _this3.state.idname
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getRatting', ratingParams).then(function (response) {
	                        if (response.success && response.ratting.length > 0) {
	                          _this3.setState({
	                            rating: response.ratting[0].ratting,
	                            ratting_text: '' + _language2.default.LC().RATED,
	                            rated: true
	                          });
	                        } else {
	                          _this3.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	                        }
	                      });
	                    }
	                    // --- Add this block to check saved state on refresh ---
	                    if (quesRes && quesRes.id) {
	                      var favParams = {
	                        token: _this3.state.token,
	                        question_id: quesRes.id,
	                        idname: _this3.state.idname
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFavQuestions', favParams).then(function (response) {
	                        if (response.success) {
	                          _this3.setState({
	                            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                            bookmarkColor: 'rgb(54, 141, 84)',
	                            save_text: '' + _language2.default.LC().Question_Saved,
	                            isFlashCardHidden: false
	                          });
	                        } else {
	                          _this3.setState({
	                            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                            bookmarkColor: '',
	                            save_text: '' + _language2.default.LC().SAVE_QUESTION,
	                            isFlashCardHidden: true
	                          });
	                        }
	                      });
	                    }
	                    // --- End block ---
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                    _this3.setState({ records: '' + _language2.default.LC().Result_not_found });
	                  }
	                  clearInterval(_this3.timer);
	                  _this3.timer = setInterval(_this3._tick.bind(_this3), 1000);
	                  return resp;
	                });
	
	              case 6:
	                _context2.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getChapterbyID', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ chapter_name: resp.chapters[0].chapter_name });
	                  }
	                });
	
	              case 8:
	                this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	
	              case 9:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function _runCode(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return _runCode;
	    }()
	
	    /*on url change run this function*/
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id !== this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*on url change run this function*/
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val, subscription) {
	      var _this4 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val,
	        subscriptionstatus: this.state.subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestions_allcr', data).then(function (resp) {
	        if (resp.success) {
	          _this4.setState({ ValidToken: true });
	          _this4.setState({ choice_a: 'answer_box' });
	          _this4.setState({ choice_b: 'answer_box' });
	          _this4.setState({ choice_c: 'answer_box' });
	          _this4.setState({ choice_d: 'answer_box' });
	          _this4.setState({ choice_e: 'answer_box' });
	          var ques_res = null;
	          for (var i = 0; i < resp.questions.length; i++) {
	            if (resp.questions[i].id == _this4.props.params.id) {
	              ques_res = resp.questions[i];
	            }
	          }
	          if (!ques_res && resp.questions.length > 0) {
	            ques_res = resp.questions[0];
	          }
	          if (!ques_res) {
	            ques_res = {};
	          }
	          _this4.setState({ questions: ques_res });
	          _this4.setState({ display_loader: 'hide_block' });
	
	          // Get answer state for navigation (match didMount logic exactly)
	          var selected = '';
	          var showAnswer = false;
	          var selectedChoice = ques_res['soa_p_question_stats.selected_choice'] || '';
	          var rightAnswer = ques_res['soa_p_question_stats.right_answer'] || '';
	          var answerStatus = ques_res['soa_p_question_stats.id'] || '';
	          var timeDone = ques_res['soa_p_question_stats.time_done'] || 0;
	          var correctChoiceKey = 'right_choice';
	          var correct = ques_res[correctChoiceKey];
	          if (selectedChoice) {
	            selected = selectedChoice;
	            showAnswer = true;
	          } else if (answerStatus) {
	            if (rightAnswer === 1) {
	              selected = correct;
	              showAnswer = true;
	            } else if (!rightAnswer) {
	              var choices = Object.keys(ques_res).filter(function (key) {
	                return key.startsWith('choice') && key !== correct;
	              });
	              selected = choices.length > 0 ? choices[0] : '';
	              showAnswer = true;
	            }
	          }
	          var isCorrect = selected === correct;
	          if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_P)) {
	            clearInterval(_this4.timer);
	            _this4.setState(Object.assign({
	              timer_stop: true,
	              timer_tag: 'Start',
	              timerstopbtn: 'pause_btn icon-control-play',
	              count: timeDone,
	              selectedChoice: selected,
	              clicked: true,
	              showAnswer: showAnswer,
	              stopTimer: true,
	              setAnswer: true
	            }, _this4.getChoices(selected, isCorrect, correct), {
	              result_block: 'card show_block',
	              text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	              result: isCorrect ? 'CORRECT' : 'INCORRECT'
	            }));
	          } else {
	            clearInterval(_this4.timer);
	            _this4.setState(Object.assign({
	              timer_stop: false,
	              timer_tag: 'Stop',
	              timerstopbtn: 'pause_btn icon-control-pause',
	              count: 0,
	              selectedChoice: '',
	              clicked: false,
	              showAnswer: false,
	              stopTimer: false,
	              setAnswer: false,
	              result_block: 'card hide_block'
	            }, _this4.getChoices('', false, ''), {
	              text_color: 'card-header',
	              result: ''
	            }));
	            _this4.timer = setInterval(_this4._tick.bind(_this4), 1000);
	          }
	
	          // Check for saved questions and flash cards
	          if (ques_res.id) {
	            var params = {
	              token: _this4.state.token,
	              question_id: ques_res.id,
	              idname: _this4.state.idname
	            };
	
	            // Check for saved questions
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFavQuestions', params).then(function (response) {
	              if (response.success) {
	                _this4.setState({
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  save_text: '' + _language2.default.LC().Question_Saved,
	                  isFlashCardHidden: false
	                });
	              } else {
	                _this4.setState({
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  bookmarkColor: '',
	                  save_text: '' + _language2.default.LC().SAVE_QUESTION,
	                  isFlashCardHidden: true
	                });
	              }
	            });
	
	            // Always fetch flashcards for the current question on mount
	            _this4._fetchFlashCards(ques_res.id);
	          }
	
	          _this4.setState({ records: '' });
	        } else {
	          _this4.setState({ ValidToken: false });
	          _this4.setState({ records: '' + _language2.default.LC().Result_not_found });
	        }
	        clearInterval(_this4.timer);
	        _this4.timer = setInterval(_this4._tick.bind(_this4), 1000);
	        return resp;
	      });
	      this.setState({ timer_stop: false });
	      this.setState({ timer_tag: '' + _language2.default.LC().STOP });
	      this.setState({ count: 0 });
	      clearInterval(this.timer);
	      this.timer = setInterval(this._tick.bind(this), 1000);
	
	      // Reset rating state
	      this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	      // Fetch latest rating for the current question
	      // Only fetch rating if ques_res is valid and has an id
	      if (this.state.questions && this.state.questions.id) {
	        var ratingParams = {
	          token: this.state.token,
	          question_id: this.state.questions.id,
	          idname: this.state.idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getRatting', ratingParams).then(function (response) {
	          if (response.success && response.ratting.length > 0) {
	            _this4.setState({
	              rating: response.ratting[0].ratting,
	              ratting_text: '' + _language2.default.LC().RATED,
	              rated: true
	            });
	          } else {
	            _this4.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: 'getChoices',
	    value: function getChoices(selected, isCorrect, correct) {
	      var choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d', 'choice_e'];
	      var state = {};
	      choices.forEach(function (choice) {
	        if (selected === choice) {
	          state[choice] = isCorrect ? 'answer_box success' : 'answer_box failure';
	        } else if (correct === choice && selected) {
	          state[choice] = 'answer_box success';
	        } else {
	          state[choice] = 'answer_box';
	        }
	      });
	      return state;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	
	      var data = '';
	      var forumData = '';
	      var choice_a = 'choice_a';
	      var choice_b = 'choice_b';
	      var choice_c = 'choice_c';
	      var choice_d = 'choice_d';
	      var choice_e = 'choice_e';
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      if (count_temp_var < 60) {
	        display_time = count_temp_var + 'sec';
	      } else {
	        var temp_min = Math.trunc(count_temp_var / 60);
	        var temp_sec = Math.trunc(count_temp_var % 60);
	        display_time = temp_min + 'min ' + temp_sec + 'sec';
	      }
	      var retun_all_question = JSON.stringify(this.state.questions);
	      var all_questions = JSON.parse(retun_all_question);
	      if (all_questions != '') {
	        forumData = '<div class="col-sm-12 no-cursor" >\n            <div class="margin_bottom_40">\n                <div >\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="row">\n                                <div class="col-sm-12 cursor-text">\n                                    <div contentEditable=\'false\' class="margin_bottom_40 view_questionhtml bg_blue"> ' + all_questions.question + ' </div>\n                                </div>\n                                <div class="col-sm-12" id="choice_a" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().A + '\n                                        </div>\n                                        <p class="ans_box_text"> \n                                        <span contentEditable=\'false\'> ' + all_questions.choice_a + ' </span></p>\n                                    </div>\n                                </div>\n                                <div class="col-sm-12" id="choice_b">\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().B + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>  ' + all_questions.choice_b + ' </span></p>\n                                    </div>\n                                </div>\n                                <div class="col-sm-12" id="choice_c" >\n                                    <div class="answer_box_forum">\n                                        <div class="answer_count">\n                                        ' + _language2.default.LC().C + '\n                                        </div>\n                                        <p class="ans_box_text"><span contentEditable=\'false\'>\n                                        ' + all_questions.choice_c + '\n                                        </span></p>\n                                    </div>\n                                </div>\n                                <div class="col-sm-12" id="choice_d" >\n                                <div class="answer_box_forum">\n                                    <div class="answer_count">\n                                    ' + _language2.default.LC().D + '\n                                    </div>\n                                    <p class="ans_box_text"><span contentEditable=\'false\'>\n                                    ' + all_questions.choice_d + '\n                                    </span></p>\n                                </div>\n                            </div>\n                            <div class="col-sm-12 margin_bottom_30" id="choice_e" >\n                            <div class="answer_box_forum">\n                                <div class="answer_count">\n                                ' + _language2.default.LC().E + '\n                                </div>\n                                <p class="ans_box_text"><span contentEditable=\'false\'>\n                                ' + all_questions.choice_e + '\n                                </span></p>\n                            </div>\n                            </div>\n                                <div class="col-sm-12 cursor-text"">\n                                <p contentEditable=\'false\' class=\'view_questionhtml\'> ' + all_questions.answer + '</p>\n                                </div>\n                                <div class="col-sm-12 margin_bottom_30">\n\n                                <div class="userQuestionDiv">\n                                <span class="questionColor cursor-text"> *User Question: </span>\n                                <div class="forum-data-comment cursor-text">\n                                  <h4> ' + this.state.forumComment + ' \n                                  </h4>\n                                </div>\n                                </div>\n\n                              </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>';
	
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card margin_bottom_40' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                className: 'margin_right_20',
	                width: '30',
	                alt: ''
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, 'span', '', { contentEditable: 'false' }),
	              ' (',
	              _language2.default.LC().Q,
	              ' ',
	              all_questions.id,
	              ')',
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this.getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this.getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        _ViewQuestion2.default,
	                        Object.assign({}, all_questions, this.props, {
	                          setAnswer: this.getAnswer,
	                          showAnswer: this.state.clicked,
	                          correctChoice: '' + all_questions.right_choice,
	                          selectedChoice: this.state.selectedChoice,
	                          onValidate: function onValidate() {
	                            return _this5.getResult(all_questions);
	                          }
	                        }),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { md: 12, className: 'mt-2' },
	                          _react2.default.createElement(
	                            _reactstrap.Row,
	                            { className: 'align-items-center' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'd-flex align-items-center' },
	                              _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                                isQue: true,
	                                _getResult: this.getResult,
	                                clicked: this.state.clicked,
	                                _saveQuestion: this.saveQuestion,
	                                _displayReportForm: this._displayReportForm,
	                                all_questions: all_questions,
	                                save_text: this.state.save_text,
	                                bookmarkCSS: this.state.bookmarkCSS,
	                                bookmarkColor: this.state.bookmarkColor,
	                                disabled: !this.state.selectedChoice || this.state.clicked
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'star_rating_wrap' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: ' margin_bottom_0 margin_right_10' },
	                                  this.state.ratting_text
	                                ),
	                                _react2.default.createElement(_reactStarRatings2.default, {
	                                  rating: this.state.rating,
	                                  starRatedColor: 'rgb(255, 180, 0)',
	                                  starEmptyColor: 'rgb(51, 51, 51)',
	                                  starDimension: '20px',
	                                  starHoverColor: 'rgb(255, 180, 0)',
	                                  starSpacing: '2px',
	                                  changeRating: this.onStarClick.bind(this, all_questions),
	                                  numberOfStars: 5,
	                                  name: 'rate1'
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timer_outer' },
	                    _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'timer_box' },
	                      display_time
	                    )
	                  ),
	                  _react2.default.createElement('button', {
	                    type: 'button',
	                    className: this.state.timerstopbtn,
	                    onClick: this._timer_funct
	                  }),
	                  this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	                    'a',
	                    {
	                      onClick: this._getSubscribe,
	                      className: 'box_question_color text-center cursor_pointer'
	                    },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS,
	                      ' '
	                    )
	                  ) : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.result_block + ' font-lusitana font-16px' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.text_color },
	              this.state.result
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              (0, _function.renderHTMLContent)(all_questions.answer, 'p', 'view_questionhtml', {
	                contentEditable: 'false'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.report_block },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().REPORT
	            ),
	            !this.state.successAlert ? _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().COMMENT
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 margin_bottom_10' },
	                  _react2.default.createElement('textarea', {
	                    id: 'comment',
	                    name: 'comment',
	                    rows: '6',
	                    className: 'form-control',
	                    placeholder: 'Content..'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class report-btn',
	                      disabled: reportLoading,
	                      onClick: this._reportQuestion.bind(this, all_questions)
	                    },
	                    ' ',
	                    reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-danger active pointer_class margin_left_10',
	                      onClick: this._hideReportForm.bind(this, all_questions)
	                    },
	                    ' ',
	                    _language2.default.LC().CANCEL
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12 report-Success-card' },
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-control-label', htmlFor: 'textarea-input' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-primary active pointer_class  min-vw-120',
	                      onClick: this.onClose
	                    },
	                    ' ',
	                    _language2.default.LC().CLOSE
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else {
	        /*data = <div className="col-sm-12 col-md-12">
	            <div className="no_data_bar card">No Records Found</div></div>;*/
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUESTION_BANK
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this.getQuestions
	                },
	                _language2.default.LC().CHANGE_QUESTIONS
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getReadings
	                },
	                _language2.default.LC().CHANGE_READING
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          ),
	          _react2.default.createElement(_FlashCard2.default, {
	            item: questions,
	            type: 'question',
	            isFlashCardHidden: this.state.isFlashCardHidden,
	            ref: this.setChildRef,
	            exam: 'soa_p',
	            onToggleFlash: this._getToggleFlash,
	            flashForm: this.state.flash_form,
	            flashData: this.state.flash_data
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_Beginchapters;
	}(_react.Component);
	
	SOA_P_Beginchapters.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this7 = this;
	
	  this._getReadings = function () {
	    _this7.context.router.push({
	      pathname: '/soa/probability/readings/' + _this7.props.params.notesid
	      // state: {
	      //   token: this.state.token,
	      //   idname: this.state.idname,
	      //   chapter: this.props.location.state.chapter,
	      // },
	    });
	  };
	
	  this.getQuestions = function () {
	    _this7.context.router.push({
	      pathname: '/soa/probability/viewquestions/' + _this7.props.params.readingid + '/' + _this7.props.params.notesid + '/' + _this7.state.questions.name + '/' + _this7.props.params.notesid + '/' + _this7.state.subscriptionstatus
	    });
	  };
	
	  this._getToggleComment = function (item, e) {
	    (0, _jquery2.default)(_this7.refs['comment_toggle_div']).slideToggle(1000);
	  };
	
	  this._getToggleFlash = function (item, e) {
	    // Toggle flash card visibility
	    var isCurrentlyHidden = _this7.state.isFlashCardHidden;
	    _this7.setState({
	      isFlashCardHidden: !isCurrentlyHidden,
	      flash_form: !isCurrentlyHidden ? 'col-sm-12 col-md-12 display_block' : 'col-sm-12 col-md-12 hide_block'
	    }, function () {
	      // If showing flash cards, fetch them
	      if (!_this7.state.isFlashCardHidden) {
	        _this7._fetchFlashCards(item.id);
	      }
	    });
	  };
	
	  this._fetchFlashCards = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(questionId) {
	      var params, response, flash_cards;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              params = {
	                token: _this7.state.token,
	                idname: _this7.state.idname,
	                question_id: questionId
	              };
	              _context3.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFlashCards', params);
	
	            case 4:
	              response = _context3.sent;
	
	
	              if (response.success) {
	                _this7.setState({ ValidToken: true });
	                if (response.flash_cards.length > 0) {
	                  _this7.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	                  flash_cards = response.flash_cards.map(function (items, index) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: index },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'icon_list' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this7._editFlash.bind(_this7, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'pointer_class', onClick: _this7._deleteFlash.bind(_this7, items) },
	                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _this7.state.flash_class },
	                          _react2.default.createElement('h4', null),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            items.flash_card
	                          )
	                        )
	                      )
	                    );
	                  });
	
	                  _this7.setState({ flash_data: flash_cards });
	                } else {
	                  _this7.setState({
	                    flash_form: 'col-sm-12 col-md-12 display_block',
	                    flash_data: _react2.default.createElement(
	                      'p',
	                      null,
	                      _language2.default.LC().NO_FLASHCARD_FOUND
	                    )
	                  });
	                }
	              } else {
	                _this7.setState({
	                  ValidToken: false,
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  ),
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	              }
	              _context3.next = 11;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3['catch'](0);
	
	              _this7.setState({
	                ValidToken: false,
	                flash_data: _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                ),
	                flash_form: 'col-sm-12 col-md-12 display_block'
	              });
	
	            case 11:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this7, [[0, 8]]);
	    }));
	
	    return function (_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  this._saveFlashCard = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(item, e) {
	      var flash_card, data, resp;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              if (!(document.getElementById('flash_card').value === '')) {
	                _context4.next = 2;
	                break;
	              }
	
	              return _context4.abrupt('return');
	
	            case 2:
	              _context4.prev = 2;
	              flash_card = document.getElementById('flash_card').value;
	              data = {
	                token: _this7.state.token,
	                idname: _this7.state.idname,
	                question_id: item.id,
	                flash_card: flash_card
	              };
	              _context4.next = 7;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/saveFlashCard', data);
	
	            case 7:
	              resp = _context4.sent;
	
	              if (!resp.success) {
	                _context4.next = 15;
	                break;
	              }
	
	              _this7.setState({ ValidToken: true });
	              document.getElementById('flash_card').value = '';
	              _context4.next = 13;
	              return _this7._fetchFlashCards(item.id);
	
	            case 13:
	              _context4.next = 16;
	              break;
	
	            case 15:
	              _this7.setState({ ValidToken: false });
	
	            case 16:
	              _context4.next = 21;
	              break;
	
	            case 18:
	              _context4.prev = 18;
	              _context4.t0 = _context4['catch'](2);
	
	              _this7.setState({ ValidToken: false });
	
	            case 21:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this7, [[2, 18]]);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  this._deleteFlash = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(item, e) {
	      var data, resp;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.prev = 0;
	              data = {
	                token: _this7.state.token,
	                idname: _this7.state.idname,
	                flash_card: item
	              };
	              _context5.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteFlashCard', data);
	
	            case 4:
	              resp = _context5.sent;
	
	
	              if (resp.success) {
	                _this7.setState({
	                  ValidToken: true,
	                  flash_form: 'col-sm-12 col-md-12 display_block',
	                  isEditable: false,
	                  flash_data: _react2.default.createElement(
	                    'p',
	                    null,
	                    _language2.default.LC().NO_FLASHCARD_FOUND
	                  )
	                });
	                document.getElementById('flash_card').value = '';
	              } else {
	                _this7.setState({ ValidToken: false });
	              }
	              _context5.next = 11;
	              break;
	
	            case 8:
	              _context5.prev = 8;
	              _context5.t0 = _context5['catch'](0);
	
	              _this7.setState({ ValidToken: false });
	
	            case 11:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this7, [[0, 8]]);
	    }));
	
	    return function (_x5, _x6) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  this.getPrevious = function () {
	    var _state2 = _this7.state,
	        offset = _state2.offset,
	        all_questions_state = _state2.all_questions_state,
	        question_length = _state2.question_length,
	        token = _state2.token,
	        idname = _state2.idname,
	        attemptedQuestions = _state2.attemptedQuestions;
	
	    if (offset <= 0) return;
	    _this7.setState({ display_loader: 'show_block' });
	    var prevIndex = offset - 1;
	    var currentQuestion = all_questions_state[prevIndex];
	    if (!currentQuestion) {
	      _this7.setState({ display_loader: 'hide_block' });
	      return;
	    }
	    var prevQuestionId = currentQuestion.id;
	    var params = _this7.props.params;
	
	    _this7.context.router.push({
	      pathname: '/soa/probability/beginchapter/' + params.notesid + '/' + params.readingid + '/' + prevQuestionId + '/' + prevIndex,
	      state: {
	        token: token,
	        idname: idname,
	        reading: params.readingid,
	        chapter: params.notesid,
	        offset: prevIndex
	      }
	    });
	    if (_this7.timer) {
	      clearInterval(_this7.timer);
	      _this7.timer = null;
	    }
	    var selected = '';
	    var showAnswer = false;
	    var selectedChoice = currentQuestion['soa_p_question_stats.selected_choice'] || '';
	    var rightAnswer = currentQuestion['soa_p_question_stats.right_answer'] || '';
	    var answerStatus = currentQuestion['soa_p_question_stats.id'] || '';
	    var timeDone = currentQuestion['soa_p_question_stats.time_done'] || 0;
	    var correctChoiceKey = 'right_choice';
	    var correct = currentQuestion[correctChoiceKey];
	    if (selectedChoice) {
	      selected = selectedChoice;
	      showAnswer = true;
	    } else if (answerStatus) {
	      if (rightAnswer === 1) {
	        selected = correct;
	        showAnswer = true;
	      } else if (!rightAnswer) {
	        var choices = Object.keys(currentQuestion).filter(function (key) {
	          return key.startsWith('choice') && key !== correct;
	        });
	        selected = choices.length > 0 ? choices[0] : '';
	        showAnswer = true;
	      }
	    }
	    var isCorrect = selected === correct;
	    if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_P)) {
	      clearInterval(_this7.timer);
	      _this7.setState(Object.assign({
	        timer_stop: true,
	        timer_tag: 'Start',
	        timerstopbtn: 'pause_btn icon-control-play',
	        count: timeDone,
	        selectedChoice: selected,
	        clicked: true,
	        showAnswer: showAnswer,
	        stopTimer: true,
	        setAnswer: true
	      }, _this7.getChoices(selected, isCorrect, correct), {
	        result_block: 'card show_block',
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	        result: isCorrect ? 'CORRECT' : 'INCORRECT'
	      }));
	    } else {
	      clearInterval(_this7.timer);
	      _this7.setState(Object.assign({
	        timer_stop: false,
	        timer_tag: 'Stop',
	        timerstopbtn: 'pause_btn icon-control-pause',
	        count: 0,
	        selectedChoice: '',
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false,
	        setAnswer: false,
	        result_block: 'card hide_block'
	      }, _this7.getChoices('', false, ''), {
	        text_color: 'card-header',
	        result: ''
	      }));
	      _this7.timer = setInterval(_this7._tick.bind(_this7), 1000);
	    }
	    _this7.setState({
	      offset: prevIndex,
	      questions: currentQuestion,
	      validated: false,
	      result_block: selected ? 'card show_block' : 'card hide_block',
	      text_color: selected ? isCorrect ? 'card-header text_success' : 'card-header text_failure' : 'card-header',
	      result: selected ? isCorrect ? 'CORRECT' : 'INCORRECT' : '',
	      report_block: 'card hide_block',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      rated: false,
	      rating: 0,
	      ratting_text: 'Rate this Question',
	      previ_block: prevIndex === 0 ? 'hide_block' : '',
	      next_block: '',
	      display_loader: 'hide_block',
	      isFlashCardHidden: true,
	      flash_data: [],
	      flash_form: 'col-sm-12 col-md-12 display_block'
	    }, function () {
	      _this7.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	      var ratingParams = {
	        token: token,
	        question_id: _this7.state.questions.id,
	        idname: idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getRatting', ratingParams).then(function (response) {
	        if (response.success && response.ratting.length > 0) {
	          _this7.setState({
	            rating: response.ratting[0].ratting,
	            ratting_text: '' + _language2.default.LC().RATED,
	            rated: true
	          });
	        } else {
	          _this7.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	        }
	      });
	    });
	    _this7._fetchFlashCards(currentQuestion.id);
	  };
	
	  this.getNext = function () {
	    var _state3 = _this7.state,
	        offset = _state3.offset,
	        all_questions_state = _state3.all_questions_state,
	        question_length = _state3.question_length,
	        token = _state3.token,
	        idname = _state3.idname,
	        attemptedQuestions = _state3.attemptedQuestions;
	
	    if (offset >= question_length - 1) return;
	    _this7.setState({ display_loader: 'show_block' });
	    var nextIndex = offset + 1;
	    var currentQuestion = all_questions_state[nextIndex];
	    if (!currentQuestion) {
	      _this7.setState({ display_loader: 'hide_block' });
	      return;
	    }
	    var nextQuestionId = currentQuestion.id;
	    var params = _this7.props.params;
	
	    _this7.context.router.push({
	      pathname: '/soa/probability/beginchapter/' + params.notesid + '/' + params.readingid + '/' + nextQuestionId + '/' + nextIndex,
	      state: {
	        token: token,
	        idname: idname,
	        reading: params.readingid,
	        chapter: params.notesid,
	        offset: nextIndex
	      }
	    });
	    if (_this7.timer) {
	      clearInterval(_this7.timer);
	      _this7.timer = null;
	    }
	    var selected = '';
	    var showAnswer = false;
	    var selectedChoice = currentQuestion['soa_p_question_stats.selected_choice'] || '';
	    var rightAnswer = currentQuestion['soa_p_question_stats.right_answer'] || '';
	    var answerStatus = currentQuestion['soa_p_question_stats.id'] || '';
	    var timeDone = currentQuestion['soa_p_question_stats.time_done'] || 0;
	    var correctChoiceKey = 'right_choice';
	    var correct = currentQuestion[correctChoiceKey];
	    if (selectedChoice) {
	      selected = selectedChoice;
	      showAnswer = true;
	    } else if (answerStatus) {
	      if (rightAnswer === 1) {
	        selected = correct;
	        showAnswer = true;
	      } else if (!rightAnswer) {
	        var choices = Object.keys(currentQuestion).filter(function (key) {
	          return key.startsWith('choice') && key !== correct;
	        });
	        selected = choices.length > 0 ? choices[0] : '';
	        showAnswer = true;
	      }
	    }
	    var isCorrect = selected === correct;
	    if (selected && (0, _function.isRevisionModeActive)(_constant.EXAM_NAMES.SOA_P)) {
	      clearInterval(_this7.timer);
	      _this7.setState(Object.assign({
	        timer_stop: true,
	        timer_tag: 'Start',
	        timerstopbtn: 'pause_btn icon-control-play',
	        count: timeDone,
	        selectedChoice: selected,
	        clicked: true,
	        showAnswer: showAnswer,
	        stopTimer: true,
	        setAnswer: true
	      }, _this7.getChoices(selected, isCorrect, correct), {
	        result_block: 'card show_block',
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
	        result: isCorrect ? 'CORRECT' : 'INCORRECT'
	      }));
	    } else {
	      clearInterval(_this7.timer);
	      _this7.setState(Object.assign({
	        timer_stop: false,
	        timer_tag: 'Stop',
	        timerstopbtn: 'pause_btn icon-control-pause',
	        count: 0,
	        selectedChoice: '',
	        clicked: false,
	        showAnswer: false,
	        stopTimer: false,
	        setAnswer: false,
	        result_block: 'card hide_block'
	      }, _this7.getChoices('', false, ''), {
	        text_color: 'card-header',
	        result: ''
	      }));
	      _this7.timer = setInterval(_this7._tick.bind(_this7), 1000);
	    }
	    _this7.setState({
	      offset: nextIndex,
	      questions: currentQuestion,
	      validated: false,
	      result_block: selected ? 'card show_block' : 'card hide_block',
	      text_color: selected ? isCorrect ? 'card-header text_success' : 'card-header text_failure' : 'card-header',
	      result: selected ? isCorrect ? 'CORRECT' : 'INCORRECT' : '',
	      report_block: 'card hide_block',
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      rated: false,
	      rating: 0,
	      ratting_text: 'Rate this Question',
	      previ_block: '',
	      next_block: nextIndex === parseInt(question_length) - 1 ? 'hide_block' : '',
	      display_loader: 'hide_block',
	      isFlashCardHidden: true,
	      flash_data: [],
	      flash_form: 'col-sm-12 col-md-12 display_block'
	    }, function () {
	      _this7.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	      var ratingParams = {
	        token: token,
	        question_id: _this7.state.questions.id,
	        idname: idname
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getRatting', ratingParams).then(function (response) {
	        if (response.success && response.ratting.length > 0) {
	          _this7.setState({
	            rating: response.ratting[0].ratting,
	            ratting_text: '' + _language2.default.LC().RATED,
	            rated: true
	          });
	        } else {
	          _this7.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	        }
	      });
	    });
	    _this7._fetchFlashCards(currentQuestion.id);
	  };
	
	  this.getAnswer = function (choice, e) {
	    var _state4 = _this7.state,
	        questions = _state4.questions,
	        user_city = _state4.user_city,
	        user_country = _state4.user_country,
	        user_state = _state4.user_state,
	        user_continent = _state4.user_continent,
	        user_ip = _state4.user_ip,
	        token = _state4.token,
	        idname = _state4.idname,
	        attemptedQuestions = _state4.attemptedQuestions,
	        props = _state4.props;
	
	    var currentQuestionId = questions.id;
	    var selectedChoice = choice[0];
	    _this7.setState(Object.assign({
	      selectedChoice: selectedChoice,
	      setAnswer: true,
	      clicked: false,
	      showAnswer: false,
	      stopTimer: false
	    }, _this7.getChoices(selectedChoice, false, '')), function () {
	      var currentAttempts = attemptedQuestions || {};
	      var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	        selectedChoice: _this7.state.selectedChoice,
	        isAnswered: false,
	        setAnswer: true
	      }));
	      _this7.setState({ attemptedQuestions: updatedAttempts });
	    });
	    var data = {
	      token: token,
	      idname: idname,
	      id: props.params.id,
	      city: user_city,
	      country: user_country,
	      state: user_state,
	      continent: user_continent,
	      ip: user_ip
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/trackUserRecord', data).then(function (resp) {
	      if (resp.success) {
	        _this7.setState({ ValidToken: true });
	      }
	    });
	  };
	
	  this._displayReportForm = function (item, e) {
	    _this7.setState({ report_block: 'card show_block' });
	  };
	
	  this._hideReportForm = function (item, e) {
	    _this7.setState({ report_block: 'card hide_block' });
	  };
	
	  this.getResult = function (item, e) {
	    var _state5 = _this7.state,
	        selectedChoice = _state5.selectedChoice,
	        timer = _state5.timer,
	        count = _state5.count,
	        attemptedQuestions = _state5.attemptedQuestions,
	        ValidToken = _state5.ValidToken,
	        validated = _state5.validated,
	        token = _state5.token,
	        idname = _state5.idname;
	
	    if (selectedChoice) {
	      if (timer) {
	        clearInterval(timer);
	        _this7.timer = null;
	      }
	      var currentQuestionId = item.id;
	      var correctChoiceKey = 'right_choice';
	      var isCorrect = selectedChoice === '' + item[correctChoiceKey];
	      _this7.setState({
	        timer_stop: true,
	        timer_tag: 'Start',
	        timerstopbtn: 'pause_btn icon-control-play',
	        setAnswer: true,
	        clicked: true,
	        showAnswer: true,
	        stopTimer: true,
	        result_block: 'card show_block',
	        result: isCorrect ? 'CORRECT' : 'INCORRECT',
	        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
	      }, function () {
	        var currentAttempts = attemptedQuestions || {};
	        var updatedAttempts = Object.assign({}, currentAttempts, _defineProperty({}, currentQuestionId, {
	          selectedChoice: selectedChoice,
	          isAnswered: true,
	          isCorrect: isCorrect,
	          setAnswer: true,
	          timeSpent: count
	        }));
	        _this7.setState({ attemptedQuestions: updatedAttempts });
	        if (isCorrect) {
	          _this7.setState(Object.assign({}, _this7.getChoices(selectedChoice, isCorrect, item[correctChoiceKey])));
	        } else {
	          _this7.setState(Object.assign({}, _this7.getChoices(selectedChoice, isCorrect, item.right_choice)));
	        }
	      });
	      if (!validated) {
	        var data = {
	          token: token,
	          idname: idname,
	          question_id: item.id,
	          right_answer: isCorrect ? 1 : 0,
	          time_done: count,
	          selected_choice: selectedChoice
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/saveStats', data).then(function (resp) {
	          if (resp.success) {
	            _this7.setState({ ValidToken: true, validated: true });
	          } else {
	            _this7.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    } else {
	      _this7.setState({
	        result_block: 'card hide_block'
	      });
	    }
	  };
	
	  this.saveQuestion = function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(item, e) {
	      var _state6, token, idname, bookmarkCSS, isFlashCardHidden, flash_form, flash_data, data, resp, _resp;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _state6 = _this7.state, token = _state6.token, idname = _state6.idname, bookmarkCSS = _state6.bookmarkCSS, isFlashCardHidden = _state6.isFlashCardHidden, flash_form = _state6.flash_form, flash_data = _state6.flash_data;
	              data = {
	                token: token,
	                idname: idname,
	                question_id: item.id
	              };
	              _context6.prev = 2;
	
	              if (!(bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark')) {
	                _context6.next = 10;
	                break;
	              }
	
	              _context6.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/unsaveQuestion', data);
	
	            case 6:
	              resp = _context6.sent;
	
	              if (resp.success) {
	                if (_this7.childRef) {
	                  _this7.childRef.deleteFlash();
	                }
	                _this7.setState({
	                  ValidToken: true,
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	                  bookmarkColor: '',
	                  save_text: '' + _language2.default.LC().SAVE_QUESTION,
	                  isFlashCardHidden: true,
	                  flash_form: 'col-sm-12 col-md-12 hide_block'
	                });
	              } else {
	                _this7.setState({ ValidToken: false });
	              }
	              _context6.next = 14;
	              break;
	
	            case 10:
	              _context6.next = 12;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/saveQuestion', data);
	
	            case 12:
	              _resp = _context6.sent;
	
	              if (_resp.success) {
	                _this7.setState({
	                  ValidToken: true,
	                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	                  isFlashCardHidden: false,
	                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                  bookmarkColor: 'rgb(54, 141, 84)',
	                  save_text: '' + _language2.default.LC().Question_Saved,
	                  flash_form: 'col-sm-12 col-md-12 display_block'
	                });
	              } else {
	                _this7.setState({ ValidToken: false });
	              }
	
	            case 14:
	              _context6.next = 19;
	              break;
	
	            case 16:
	              _context6.prev = 16;
	              _context6.t0 = _context6['catch'](2);
	
	              _this7.setState({ ValidToken: false });
	
	            case 19:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this7, [[2, 16]]);
	    }));
	
	    return function (_x7, _x8) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  this._reportQuestion = function (item, e) {
	    var comment = document.getElementById('comment').value;
	    if (comment.length < 2) {
	      return;
	    }
	    // const result = getDeviceDetails();
	    var data = {
	      token: _this7.state.token,
	      idname: _this7.state.idname,
	      question_id: item.id,
	      comment: comment,
	      city: _this7.state.user_city,
	      country: _this7.state.user_country,
	      state: _this7.state.user_state,
	      continent: _this7.state.user_continent,
	      ip: _this7.state.user_ip
	    };
	    _this7.setState({
	      reportLoading: true
	    });
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/reportQuestion', data).then(function (resp) {
	      if (resp.success) {
	        _this7.setState({
	          ValidToken: true,
	          successAlert: true,
	          reportLoading: false
	        });
	        document.getElementById('comment').value = '';
	      } else {
	        _this7.setState({ ValidToken: false });
	      }
	      return resp;
	    });
	  };
	
	  this.onClose = function (e) {
	    _this7.setState({
	      report_block: 'card hide_block',
	      successAlert: false
	    });
	  };
	
	  this._editFlash = function (item, e) {
	    _this7.setState({
	      flash_form: 'col-sm-12 col-md-12 display_block',
	      isEditable: true
	    });
	    document.getElementById('flash_card').value = item.flash_card;
	  };
	
	  this.onStarClick = function (item, nextValue, prevValue, name) {
	    var _state7 = _this7.state,
	        token = _state7.token,
	        idname = _state7.idname;
	
	    _this7.setState({ rating: nextValue, ratting_text: '' + _language2.default.LC().RATED, rated: true });
	    var params = {
	      token: token,
	      idname: idname,
	      question_id: item.id,
	      ratting: nextValue
	    };
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/saveRatting', params).then(function (response) {
	      if (response.success) {
	        var getParams = {
	          token: token,
	          question_id: item.id,
	          idname: idname
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getRatting', getParams).then(function (resp) {
	          if (resp.success && resp.ratting.length > 0) {
	            _this7.setState({
	              rating: resp.ratting[0].ratting,
	              ratting_text: '' + _language2.default.LC().RATED,
	              rated: true
	            });
	          } else {
	            _this7.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	          }
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/UpdateSoaPRatting', params).then(function () {
	          var getParams = {
	            token: token,
	            question_id: item.id,
	            idname: idname
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getRatting', getParams).then(function (resp) {
	            if (resp.success && resp.ratting.length > 0) {
	              _this7.setState({
	                rating: resp.ratting[0].ratting,
	                ratting_text: '' + _language2.default.LC().RATED,
	                rated: true
	              });
	            } else {
	              _this7.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
	            }
	          });
	        });
	      }
	    });
	  };
	
	  this._getSubscribe = function () {
	    _this7.context.router.push({
	      pathname: '/subscribe/',
	      state: { token: _this7.state.token, idname: _this7.state.idname }
	    });
	  };
	
	  this._timer_funct = function () {
	    // Prevent timer from starting if already answered
	    if (_this7.state.clicked || _this7.state.selectedChoice) {
	      // Optionally, show a message or just do nothing
	      return;
	    }
	    var newTimerStopState = !_this7.state.timer_stop;
	    _this7.setState({
	      timer_stop: newTimerStopState,
	      timerstopbtn: newTimerStopState ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	    });
	    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
	    if (newTimerStopState) {
	      if (_this7.timer) {
	        clearInterval(_this7.timer);
	      }
	    } else {
	      _this7.timer = setInterval(_this7._tick.bind(_this7), 1000);
	    }
	  };
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_P_Beginchapters;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _function = __webpack_require__(10);
	
	var _ViewQuestion = __webpack_require__(36);
	
	var _ViewQuestion2 = _interopRequireDefault(_ViewQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var SOA_P_Beginquiz = function (_Component) {
	  _inherits(SOA_P_Beginquiz, _Component);
	
	  function SOA_P_Beginquiz(props) {
	    _classCallCheck(this, SOA_P_Beginquiz);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Beginquiz.__proto__ || Object.getPrototypeOf(SOA_P_Beginquiz)).call(this, props));
	
	    _this.fetchQuizData = function () {
	      var _this$state = _this.state,
	          idname = _this$state.idname,
	          token = _this$state.token,
	          quiz_id = _this$state.quiz_id,
	          offset = _this$state.offset;
	
	      var requestData = { idname: idname, token: token, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getQuize', requestData).then(function (resp) {
	        if (resp.success) {
	          var allQuestions = JSON.parse(JSON.parse(JSON.stringify(resp.singlequiz))).all_questions;
	          var questionIds = [];
	          for (var i = 0; i < resp.questions_count; i++) {
	            questionIds.push(allQuestions[i]);
	          }
	          var timerValue = Number(resp.timer_value) || 0;
	          var hasUserTimeValue = resp.user_time_value !== undefined && resp.user_time_value !== null;
	          var userTimeValue = hasUserTimeValue ? Number(resp.user_time_value) : timerValue;
	          var initialTimerValue = userTimeValue > 0 ? userTimeValue : timerValue;
	          var firstQuestionId = questionIds[offset];
	          _this.setState({
	            user_time_value: userTimeValue,
	            count: initialTimerValue,
	            count_temp: initialTimerValue,
	            all_question_id: questionIds,
	            question_length: questionIds.length,
	            timer_value: timerValue,
	            include_timer: resp.include_timer,
	            first_question_id: firstQuestionId
	          }, function () {
	            if (questionIds.length - 1 === offset) {
	              _this.setState({ next_block: 'card hide_block' });
	            }
	            if (_this.isTimerFeatureEnabled() && !_this.state.timer_stop && !_this.state.validated && !_this.state.selectedChoice) {
	              if (_this.timer) clearInterval(_this.timer);
	              _this.timer = setInterval(_this.tick.bind(_this), 1000);
	            }
	            _this.fetchQuestionDetails(firstQuestionId);
	          });
	        }
	      });
	    };
	
	    _this.fetchQuestionDetails = function (questionId) {
	      var _this$state2 = _this.state,
	          token = _this$state2.token,
	          idname = _this$state2.idname,
	          quiz_id = _this$state2.quiz_id,
	          offset = _this$state2.offset;
	
	      var requestData = { token: token, idname: idname, question_id: questionId, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestionsbyid', requestData).then(function (resp) {
	        if (resp.success) {
	          var questionData = resp.questionsbyid;
	          _this.setState({
	            display_question: questionData,
	            correctChoice: questionData.right_choice || '',
	            display_loader: 'hide_block'
	          });
	          var checkData = { token: token, idname: idname, quiz_id: quiz_id, question_id: questionId };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/checkAnswered', checkData).then(function (respInner) {
	            var questionResponse = respInner.question_recived || {};
	            var selected = '';
	            var showAnswer = false;
	            if (questionResponse.selected_choice) {
	              selected = questionResponse.selected_choice;
	              showAnswer = true;
	            } else if (questionResponse.id) {
	              if (questionResponse.answer === 1) {
	                selected = questionData.right_choice;
	                showAnswer = true;
	              } else if (!questionResponse.answer) {
	                var choices = Object.keys(questionData).filter(function (key) {
	                  return key.startsWith('choice') && key !== questionData.right_choice;
	                });
	                selected = choices.length > 0 ? choices[0] : '';
	                showAnswer = true;
	              }
	            }
	            _this.setState({
	              already_answered_status: respInner.message,
	              ValidToken: true,
	              selectedChoice: selected,
	              clicked: showAnswer,
	              validated: showAnswer,
	              result_block: showAnswer ? 'card show_block' : 'card hide_block',
	              text_color: selected === questionData.right_choice ? 'card-header text_success' : 'card-header text_failure',
	              result: selected === questionData.right_choice ? '' + _language2.default.LC().CORRECT : '' + _language2.default.LC().INCORRECT,
	              timer_stop: showAnswer || !!selected,
	              timerstopbtn: showAnswer || !!selected ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	            });
	            if (showAnswer || !!selected) {
	              if (_this.timer) clearInterval(_this.timer);
	            } else if (_this.isTimerFeatureEnabled() && !_this.state.timer_stop) {
	              if (_this.timer) clearInterval(_this.timer);
	              _this.timer = setInterval(_this.tick.bind(_this), 1000);
	            }
	          });
	          _this.fetchSavedQuestionStatus(questionId);
	          _this.fetchFlashCards(questionId);
	        }
	      });
	    };
	
	    _this.fetchSavedQuestionStatus = function (questionId) {
	      var _this$state3 = _this.state,
	          token = _this$state3.token,
	          idname = _this$state3.idname;
	
	      var params = { token: token, question_id: questionId, idname: idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFavQuestions', params).then(function (response) {
	        if (response.success) {
	          _this.setState({
	            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	            bookmarkColor: 'rgb(54, 141, 84)',
	            save_text: '' + _language2.default.LC().Question_Saved
	          });
	        }
	      });
	    };
	
	    _this.fetchFlashCards = function (questionId) {
	      var _this$state4 = _this.state,
	          token = _this$state4.token,
	          idname = _this$state4.idname,
	          quiz_id = _this$state4.quiz_id,
	          flash_class = _this$state4.flash_class;
	
	      var params = { token: token, idname: idname, question_id: questionId, quiz_id: quiz_id };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFlashCards', params).then(function (response) {
	        var flashCardsContent = '';
	        if (response.success) {
	          _this.setState({ ValidToken: true });
	          if (response.flash_cards.length > 0) {
	            _this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
	            flashCardsContent = response.flash_cards.map(function (item) {
	              return _react2.default.createElement(
	                'li',
	                { key: item.id },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'icon_list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._editFlash.bind(_this, item) },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, item) },
	                        _react2.default.createElement('i', { className: 'fa fa-close' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: flash_class },
	                    _react2.default.createElement('h4', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      item.flash_card
	                    )
	                  )
	                )
	              );
	            });
	          } else {
	            _this.setState({ flash_form: 'col-md-12 display_block' });
	            flashCardsContent = _react2.default.createElement(
	              'p',
	              null,
	              _language2.default.LC().NO_FLASHCARD_FOUND
	            );
	          }
	          _this.setState({ flash_data: flashCardsContent });
	        } else {
	          flashCardsContent = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({
	            ValidToken: false,
	            flash_data: flashCardsContent,
	            flash_form: 'col-md-12 display_block'
	          });
	        }
	      });
	    };
	
	    _this._navigateQuestion = function (newOffset) {
	      var _this$state5 = _this.state,
	          token = _this$state5.token,
	          idname = _this$state5.idname,
	          quiz_id = _this$state5.quiz_id,
	          count = _this$state5.count,
	          question_length = _this$state5.question_length,
	          all_question_id = _this$state5.all_question_id;
	
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        clicked: false,
	        selectedChoice: null,
	        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        bookmarkColor: '',
	        save_text: '' + _language2.default.LC().SAVE_QUESTION,
	        report_block: 'card hide_block',
	        timer_stop: false,
	        timerstopbtn: 'pause_btn icon-control-pause'
	      });
	      document.getElementById('comment').value = '';
	      var timerData = { token: token, idname: idname, quiz_id: quiz_id, user_time_value: count };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/insertTimer', timerData);
	      _this.context.router.push({
	        pathname: '/soa/probability/beginquiz/' + quiz_id + '/' + newOffset
	      });
	      if (newOffset > 0) {
	        _this.setState({ previ_block: '' });
	      }
	      if (question_length - 1 === newOffset) {
	        _this.setState({ next_block: 'card hide_block' });
	      } else {
	        _this.setState({ next_block: '' });
	      }
	      _this.setState({ offset: newOffset });
	      _this.fetchQuestionDetails(all_question_id[newOffset]);
	      if (_this.isTimerFeatureEnabled()) {
	        clearInterval(_this.timer);
	        if (!_this.state.timer_stop) {
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        }
	      }
	    };
	
	    _this.getNext = function () {
	      _this._navigateQuestion(_this.state.offset + 1);
	    };
	
	    _this.getPrevious = function () {
	      _this._navigateQuestion(_this.state.offset - 1);
	    };
	
	    _this.handleAnswerSelect = function (choice) {
	      if (!_this.state.validated) {
	        _this.setState({
	          selectedChoice: choice[0],
	          clicked: true,
	          result_block: 'card hide_block',
	          timer_stop: true,
	          timerstopbtn: 'pause_btn icon-control-play'
	        });
	        if (_this.timer) {
	          clearInterval(_this.timer);
	        }
	      }
	    };
	
	    _this.getResult = function (questionItem, e) {
	      var _this$state6 = _this.state,
	          clicked = _this$state6.clicked,
	          validated = _this$state6.validated,
	          token = _this$state6.token,
	          idname = _this$state6.idname,
	          quiz_id = _this$state6.quiz_id,
	          all_question_id = _this$state6.all_question_id,
	          offset = _this$state6.offset,
	          selectedChoice = _this$state6.selectedChoice;
	
	      if (clicked && !validated) {
	        clearInterval(_this.timer);
	        var isRightAnswer = 0;
	        if (questionItem.right_choice === selectedChoice) {
	          isRightAnswer = 1;
	          _this.setState({
	            result: '' + _language2.default.LC().CORRECT,
	            text_color: 'card-header text_success',
	            result_block: 'card show_block',
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        } else {
	          isRightAnswer = 0;
	          _this.setState({
	            text_color: 'card-header text_failure',
	            result: '' + _language2.default.LC().INCORRECT,
	            result_block: 'card show_block',
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	        }
	        var answerData = {
	          token: token,
	          idname: idname,
	          quiz_id: quiz_id,
	          question_id: all_question_id[offset],
	          answer: isRightAnswer,
	          selected_choice: selectedChoice
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/answerQuiz', answerData).then(function (resp) {
	          if (resp.success) {
	            var statsData = {
	              token: token,
	              idname: idname,
	              question_id: all_question_id[offset],
	              right_answer: isRightAnswer,
	              time_done: 0
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/saveStats', statsData).then(function (resp) {
	              if (resp.success) {
	                _this.setState({ ValidToken: true, validated: true });
	              }
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	        });
	      }
	    };
	
	    _this.saveQuestion = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/unsaveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              save_text: '' + _language2.default.LC().SAVE_QUESTION,
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: ''
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/saveQuestion', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              save_text: '' + _language2.default.LC().Question_Saved,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)'
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true, successAlert: true });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({ flash_form: 'col-sm-12 display_block' });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-sm-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this.timerHandler = function () {
	      if (!_this.isTimerFeatureEnabled()) return;
	      if (_this.state.validated) return;
	      if (_this.state.count <= 0 && !!_this.state.count_end_message) return;
	
	      var newTimerStopState = !_this.state.timer_stop;
	      localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
	      _this.setState({
	        timer_stop: newTimerStopState,
	        timerstopbtn: newTimerStopState ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	      });
	
	      if (newTimerStopState) {
	        clearInterval(_this.timer);
	      } else {
	        if (_this.state.count > 0 && !_this.state.selectedChoice) {
	          clearInterval(_this.timer);
	          _this.timer = setInterval(_this.tick.bind(_this), 1000);
	        } else {
	          _this.setState({
	            timer_stop: true,
	            timerstopbtn: 'pause_btn icon-control-play'
	          });
	          localStorage.setItem('timer_stop', JSON.stringify(true));
	          if (_this.timer) clearInterval(_this.timer);
	        }
	      }
	    };
	
	    _this.isTimerFeatureEnabled = function () {
	      var _this$state7 = _this.state,
	          include_timer = _this$state7.include_timer,
	          timer_value = _this$state7.timer_value;
	
	      return !!include_timer || timer_value && parseInt(timer_value, 10) > 0;
	    };
	
	    _this._getSummary = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/beforeStart/' + _this.state.quiz_id + '/' + 'abondon',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          quiz_id: _this.state.quiz_id,
	          status_send: 'abondon'
	        }
	      });
	    };
	
	    var initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
	    _this.state = {
	      successAlert: false,
	      token: '',
	      idname: '',
	      quiz_id: _this.props.params.quiz_id,
	      offset: _this.props.params.offset ? parseInt(_this.props.params.offset) : 0,
	      all_question_id: '',
	      question_length: '',
	      timer_value: '',
	      include_timer: '',
	      user_time_value: '',
	      first_question_id: '',
	      display_question: '',
	      save_text: '' + _language2.default.LC().SAVE_QUESTION,
	      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	      bookmarkColor: '',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      timerstopbtn: initialTimerStop ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause',
	      ValidToken: false,
	      selectedChoice: null,
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      savedQuestion: false,
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      count_end_message: '',
	      timer_stop: initialTimerStop,
	      timer_tag: '' + _language2.default.LC().STOP,
	      timer_display: 'card-block',
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      comment_update: 'hide_block',
	      comment_save: 'btn btn-primary active pointer_class',
	      comment_update_id: '',
	      next_block: '',
	      previ_block: '',
	      already_answered_status: '',
	      display_loader: 'show_block',
	      tooltips: [{
	        placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }, {
	        placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	        text_align: 'right'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(SOA_P_Beginquiz, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'tick',
	    value: function tick() {
	      var _state = this.state,
	          count = _state.count,
	          token = _state.token,
	          idname = _state.idname,
	          quiz_id = _state.quiz_id;
	
	      if (count > 0) {
	        var newCount = count - 1;
	        var timerData = { token: token, idname: idname, quiz_id: quiz_id, user_time_value: newCount };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/insertTimer', timerData);
	        this.setState({
	          count: newCount,
	          timer_display: 'card-block'
	        });
	      } else {
	        this.setState({
	          timer_display: 'card hide_block',
	          count_end_message: "Time's Up"
	        });
	        clearInterval(this.timer);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      if (this.state.offset === 0) {
	        this.setState({ previ_block: 'card hide_block' });
	      }
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        }, function () {
	          _this2.fetchQuizData();
	          if (_this2.timer) {
	            clearInterval(_this2.timer);
	          }
	          var initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
	          _this2.setState({
	            timer_stop: initialTimerStop,
	            timerstopbtn: initialTimerStop ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause'
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var questions = this.state.display_question;
	
	      var data = '';
	
	      var count_temp_var = this.state.count;
	      var display_time = '';
	      var isTimeUp = count_temp_var <= 0;
	
	      if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
	        if (count_temp_var < 60) {
	          display_time = count_temp_var + ' sec';
	        } else {
	          var minutes = Math.floor(count_temp_var / 60);
	          var seconds = count_temp_var % 60;
	          display_time = minutes + ' min ' + seconds + ' sec';
	        }
	      }
	
	      var isValidateDisabled = this.state.validated || !this.state.selectedChoice;
	      var isTimerButtonDisabled = !this.isTimerFeatureEnabled() || this.state.count <= 0 || this.state.validated || this.state.selectedChoice;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                _language2.default.LC().QUIZ_ID,
	                ' : ',
	                this.state.quiz_id
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 margin_bottom_20 text-sm-right' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary pointer_class', onClick: this._getSummary },
	                ' ',
	                _language2.default.LC().BACK_TO_SUMMARY,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_40 font-16px' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/question_icon_blue.svg',
	                    className: 'margin_right_20',
	                    width: '30',
	                    alt: ''
	                  }),
	                  _language2.default.LC().Q,
	                  ' ',
	                  parseInt(this.state.offset) + 1,
	                  ' ',
	                  (0, _function.renderHTMLContent)(questions.name, 'span', '', { contentEditable: 'false' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'float-right text-right' },
	                    parseInt(this.props.params.offset) === 0 ? null : _react2.default.createElement('i', {
	                      className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                      onClick: this.getPrevious
	                    }),
	                    _react2.default.createElement('i', {
	                      className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                      onClick: this.getNext
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-9' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          (0, _function.renderHTMLContent)(questions.question, 'div', 'margin_bottom_40 view_questionhtml bg_blue', { contentEditable: 'false' })
	                        ),
	                        _react2.default.createElement(_ViewQuestion2.default, {
	                          question: questions.question,
	                          choice_a: questions.choice_a,
	                          choice_b: questions.choice_b,
	                          choice_c: questions.choice_c,
	                          choice_d: questions.choice_d,
	                          choice_e: questions.choice_e,
	                          selectedChoice: this.state.selectedChoice,
	                          onAnswerSelect: this.handleAnswerSelect,
	                          isAnswered: this.state.validated,
	                          correctChoice: this.state.correctChoice,
	                          setAnswer: this.handleAnswerSelect,
	                          showAnswer: this.state.validated
	                        }),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { md: 12, className: 'mt-2' },
	                          _react2.default.createElement(
	                            _reactstrap.Row,
	                            { className: 'align-items-center' },
	                            _react2.default.createElement(_ValidateSaveReportIcon2.default, {
	                              isQue: true,
	                              _getResult: this.getResult,
	                              clicked: isValidateDisabled,
	                              _saveQuestion: this.saveQuestion,
	                              _displayReportForm: this._displayReportForm,
	                              all_questions: questions,
	                              save_text: this.state.save_text,
	                              bookmarkCSS: this.state.bookmarkCSS,
	                              bookmarkColor: this.state.bookmarkColor,
	                              showResult: this.state.validated || !this.state.selectedChoice
	                            })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'timer_outer' },
	                        _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'timer_box' },
	                          display_time
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'quiz_timer_btn ' + this.state.timer_display },
	                        _react2.default.createElement('button', {
	                          type: 'button',
	                          className: this.state.timerstopbtn,
	                          onClick: this.timerHandler,
	                          disabled: isTimerButtonDisabled
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'text-danger' },
	                        (0, _function.renderHTMLContent)(this.state.count_end_message, 'div', '', {
	                          contentEditable: 'false'
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.result_block + ' font-lusitana font-16px' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.text_color },
	                  this.state.result
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  (0, _function.renderHTMLContent)(questions.answer, 'div', '', { contentEditable: 'false' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class',
	                          onClick: this._reportQuestion.bind(this, questions)
	                        },
	                        _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_Beginquiz;
	}(_react.Component);
	
	SOA_P_Beginquiz.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this3 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this3.toggle = _this3.toggle.bind(_this3);
	    _this3.state = {
	      tooltipOpen: false
	    };
	    return _this3;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_P_Beginquiz;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(58);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactDatepicker = __webpack_require__(59);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(79);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _function = __webpack_require__(10);
	
	var _EmailResubscribe = __webpack_require__(64);
	
	var _EmailResubscribe2 = _interopRequireDefault(_EmailResubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iterator = '';
	/* eslint-disable*/
	
	var SOA_P_Dashboard = function (_Component) {
	  _inherits(SOA_P_Dashboard, _Component);
	
	  function SOA_P_Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Dashboard.__proto__ || Object.getPrototypeOf(SOA_P_Dashboard)).call(this, props));
	
	    _this.getVideosSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context2.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getFavVideosbyuserid', data).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savedVideos: resp.soa_p_videos });
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }());
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.getVideoReports = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	              console.log('I am heree');
	              _context4.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getReportsVideobyuserid', data).then(function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportedVideos: resp.video });
	                            console.log('resp.video', resp.video);
	                          } else {
	                            console.log(resp.success + '------------failure');
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                }));
	
	                return function (_x2) {
	                  return _ref4.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	    _this.getQuestionReports = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	
	              console.log('I am heree');
	
	              _context6.next = 6;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getReportsQuestionsbyuserid', data).then(function () {
	                var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp) {
	                  return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportquestion: resp.questions, reportLoader: false });
	                          } else {
	                            //console.log(resp.success + "------------failure");
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this2);
	                }));
	
	                return function (_x3) {
	                  return _ref6.apply(this, arguments);
	                };
	              }());
	
	            case 6:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	    _this.getQuestionFlashCards = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context7.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ flashreport: resp.flash_report, flashLoader: false });
	                } else {
	                  //console.log(resp.success + "------------failure");
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this2);
	    }));
	    _this.getQuestionSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context8.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	                if (resp.success) {
	                  _this.setState({ savedquestion: resp.questions, savedLoader: false });
	                } else {
	                  //console.log(resp.success + "------------failure");
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this2);
	    }));
	    _this.getNotesReports = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context10.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getReportsNotesbyuserid', data).then(function () {
	                var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(resp) {
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ reportnotes: resp.notes });
	                          } else {
	                            //console.log(resp.success + "------------failure");
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                }));
	
	                return function (_x4) {
	                  return _ref10.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this2);
	    }));
	    _this.getNotesFlashCards = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context12.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFlashcardsnotesbyuserid', data).then(function () {
	                var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(resp) {
	                  return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ notesFlashReport: resp.flash_report });
	                          } else {
	                            //console.log(resp.success + "------------failure");
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, _this2);
	                }));
	
	                return function (_x5) {
	                  return _ref12.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this2);
	    }));
	    _this.getNotesSaved = _asyncToGenerator(_regenerator2.default.mark(function _callee14() {
	      var storage_session, data;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	              _this.setState({
	                idname: storage_session['idname'],
	                token: storage_session['token']
	              });
	              data = {
	                token: storage_session['token'],
	                idname: storage_session['idname'],
	                startDate: _this.state.send_startDate,
	                endDate: _this.state.send_startDate_second
	              };
	              _context14.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFavNotesbyuserID', data).then(function () {
	                var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(resp) {
	                  return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                      switch (_context13.prev = _context13.next) {
	                        case 0:
	                          if (resp.success) {
	                            _this.setState({ savednotes: resp.soa_p_fav_notes });
	                          } else {
	                            //console.log(resp.success + "------------failure");
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context13.stop();
	                      }
	                    }
	                  }, _callee13, _this2);
	                }));
	
	                return function (_x6) {
	                  return _ref14.apply(this, arguments);
	                };
	              }());
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this2);
	    }));
	
	    _this.OpenEditVideoReport = function (item) {
	      _this.setState({
	        reportEditStatus: !_this.state.reportEditStatus,
	        reportEditId: item.id,
	        videoReport: item.comment,
	        type: 'videoReport'
	      });
	    };
	
	    _this.handleVideoReportSubmit = function () {
	      var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(event) {
	        var _this$state, reportEditId, idname, token, videoReport, data;
	
	        return _regenerator2.default.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.videoReport === '' && _this.state.videoReport.length < 1)) {
	                  _context16.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context16.abrupt('return');
	
	              case 4:
	                _this$state = _this.state, reportEditId = _this$state.reportEditId, idname = _this$state.idname, token = _this$state.token, videoReport = _this$state.videoReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  videoReport: videoReport
	                };
	                _context16.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/UpdateReportsVideobyuserid', data).then(function () {
	                  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(resp) {
	                    return _regenerator2.default.wrap(function _callee15$(_context15) {
	                      while (1) {
	                        switch (_context15.prev = _context15.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context15.next = 6;
	                              break;
	                            }
	
	                            _this.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this.state.reportEditStatus,
	                              reportEditId: '',
	                              videoReport: ''
	                            });
	                            _context15.next = 4;
	                            return _this.getVideoReports();
	
	                          case 4:
	                            _context15.next = 7;
	                            break;
	
	                          case 6:
	                            _this.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context15.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context15.stop();
	                        }
	                      }
	                    }, _callee15, _this2);
	                  }));
	
	                  return function (_x8) {
	                    return _ref16.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref15.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteFlashCard = function () {
	      var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(type, id) {
	        var _this$state2, id_name, token, payload;
	
	        return _regenerator2.default.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                _this$state2 = _this.state, id_name = _this$state2.idname, token = _this$state2.token;
	                payload = {
	                  id_name: id_name,
	                  token: token,
	                  type: type,
	                  question_type: '',
	                  exam: 'soa_p',
	                  level: '',
	                  item_id: id
	                };
	                _context17.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/question_bank_2024/deleteFlashCard', payload);
	
	              case 4:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this2);
	      }));
	
	      return function (_x9, _x10) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    _this.onContactSubmit = function () {
	      var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(event) {
	        var _this$state3, idname, token, contactComment, contactSubject, data;
	
	        return _regenerator2.default.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(_this.state.contactSubject === '' && _this.state.contactSubject.length < 1)) {
	                  _context19.next = 4;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  SubjectErrorMessage: "Subject can't be empty",
	                  isLoading: false
	                });
	                return _context19.abrupt('return');
	
	              case 4:
	                if (!(_this.state.contactComment === '' && _this.state.contactComment.length < 1)) {
	                  _context19.next = 7;
	                  break;
	                }
	
	                _this.setState({
	                  displaytext: 'show_block',
	                  CommentErrorMessage: "Comment can't be empty",
	                  isLoading: false
	                });
	                return _context19.abrupt('return');
	
	              case 7:
	                _this.setState({
	                  isLoading: true
	                });
	                _this$state3 = _this.state, idname = _this$state3.idname, token = _this$state3.token, contactComment = _this$state3.contactComment, contactSubject = _this$state3.contactSubject;
	                data = {
	                  idname: idname,
	                  token: token,
	                  contactComment: contactComment,
	                  contactSubject: contactSubject
	                };
	                _context19.next = 12;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/contact_us/sendReportHelpRequest', data).then(function () {
	                  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(resp) {
	                    return _regenerator2.default.wrap(function _callee18$(_context18) {
	                      while (1) {
	                        switch (_context18.prev = _context18.next) {
	                          case 0:
	                            if (resp.success) {
	                              _this.setState({
	                                ValidToken: true,
	                                validated: true,
	                                isLoading: false,
	                                successAlert: true
	                              });
	                            } else {
	                              _this.setState({ ValidToken: false });
	                            }
	                            return _context18.abrupt('return', resp);
	
	                          case 2:
	                          case 'end':
	                            return _context18.stop();
	                        }
	                      }
	                    }, _callee18, _this2);
	                  }));
	
	                  return function (_x12) {
	                    return _ref19.apply(this, arguments);
	                  };
	                }());
	
	              case 12:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this2);
	      }));
	
	      return function (_x11) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    _this.onClose = function (e) {
	      _this.setState({
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        contactStatus: false,
	        successAlert: false,
	        reportAnswerStatus: !_this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: ''
	      });
	    };
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._deleteSavequestino = function (items) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._deleteReportsquestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsquestion');
	    };
	
	    _this._deleteSavedNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Savednotes');
	    };
	
	    _this._deleteReportsNotes = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsnotes');
	    };
	
	    _this._getall = function () {
	      if (_this.state.show_outer === 'hide_block') {
	        _this.setState({ show_outer: 'show_block' });
	        _this.setState({ more_detail_button: 'Hide Details' });
	      }
	      if (_this.state.show_outer === 'show_block') {
	        _this.setState({ show_outer: 'hide_block' });
	        _this.setState({ more_detail_button: 'I Want More Details' });
	      }
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/soa/probability/beginchapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.reading_id + '/' + item.question_id + '/' + resp.questionsbyid.chapter_id,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              reading: resp.questionsbyid.reading_id,
	              chapter: resp.questionsbyid.chapter_id
	            }
	          });
	        } else {
	          //console.log("Not Found");
	        }
	      });
	    };
	
	    _this._beginNotes = function () {
	      var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(reading, e) {
	        var reading_id, chapter_id, data;
	        return _regenerator2.default.wrap(function _callee20$(_context20) {
	          while (1) {
	            switch (_context20.prev = _context20.next) {
	              case 0:
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                _context20.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    chapter_id = resp.notes[0].chapter_id;
	                    reading_id = resp.notes[0].reading_id;
	
	                    _this.context.router.push({
	                      pathname: '/soa/probability/beginnotes/' + chapter_id + '/' + reading_id + '/' + reading.question_id + '/' + 0,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        reading: reading_id,
	                        chapter: chapter_id,
	                        offset: 0
	                      }
	                    });
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context20.stop();
	            }
	          }
	        }, _callee20, _this2);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref20.apply(this, arguments);
	      };
	    }();
	
	    _this._beginVideos = function () {
	      var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(reading, e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee21$(_context21) {
	          while (1) {
	            switch (_context21.prev = _context21.next) {
	              case 0:
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.video_id
	                };
	                _context21.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getVideoByID', data).then(function (resp) {
	                  if (resp.success) {
	                    var index = resp.allVideo.findIndex(function (item) {
	                      return item.id === resp.video[0].id;
	                    });
	                    var _resp$video$ = resp.video[0],
	                        id = _resp$video$.id,
	                        chapter_id = _resp$video$.chapter_id;
	
	                    _this.context.router.push({
	                      pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', id).replace(':showFreePremium', _this.state.showFreePremium ? 0 : 1).replace(':chapterId', chapter_id).replace(':index', index)
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context21.stop();
	            }
	          }
	        }, _callee21, _this2);
	      }));
	
	      return function (_x15, _x16) {
	        return _ref21.apply(this, arguments);
	      };
	    }();
	
	    _this.flashcardTabToggle = function (tab) {
	      if (_this.state.activeTabFlashcards !== tab) {
	        _this.setState({
	          activeTabFlashcards: tab
	        });
	      }
	    };
	
	    _this.savedTabToggle = function (tab) {
	      if (_this.state.activeTabSaved !== tab) {
	        _this.setState({
	          activeTabSaved: tab
	        });
	      }
	    };
	
	    _this.reportsTabToggle = function (tab) {
	      if (_this.state.activeTabReports !== tab) {
	        _this.setState({
	          activeTabReports: tab
	        });
	      }
	    };
	
	    _this._deleteReportsVideo = function (items) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Reportsvideos');
	    };
	
	    _this._deleteSavedVideo = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedvideos');
	    };
	
	    _this.state = {
	      alert_status: false,
	      reportAnswerStatus: false,
	      reportEditStatus: false,
	      reportEditId: '',
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      items_val: '',
	      item_status: '',
	      dropdownOpen: false,
	      ValidToken: false,
	      token: '',
	      idname: '',
	      notesFlashReport: [],
	      flashreport: [], //All Flash question Store
	      savedquestion: [],
	      savednotes: [],
	      progress_bar_zero: [],
	      progress_bar: [],
	      progress_bar_slider: [],
	      main_bargraph_data: '',
	      bar_chapter: '',
	      bar_main_user: [],
	      bar_main_class: [],
	      reportquestion: [],
	      reportnotes: [],
	      startDate: '',
	      startDate_second: '',
	      send_startDate: '',
	      send_startDate_second: '',
	
	      contactID: '',
	      contactType: '',
	      contactIndex: '',
	      contactSubject: '',
	      contactComment: '',
	      contactStatus: false,
	      successAlert: false,
	
	      more_detail_button: '' + _language2.default.LC().I_WANT_MORE_DETAILS,
	      show_outer: 'hide_block',
	      chapters: '',
	      subreadings_status: false,
	      display_main_loader: 'show_block',
	      display_loader: 'hide_block',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
	      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
	      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
	      ErrorMessage: '',
	      SubjectErrorMessage: '',
	      CommentErrorMessage: '',
	      type: '',
	      activeTabFlashcards: '1',
	      activeTabSaved: '1',
	      activeTabReports: '1',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SEPARATE_YOUR_RESULT,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().YOU_CAN_SEE,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().THAT_SPECIFIC_NOTES,
	        text_align: 'left'
	      }],
	      qpLoader: true,
	      npLoader: true,
	      savedLoader: true,
	      flashLoader: true,
	      reportLoader: true,
	      savedVideos: [],
	      reportedVideos: []
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	
	    _this.toggleCloseReport = _this.toggleCloseReport.bind(_this);
	    _this.toggleAlertReport = _this.toggleAlertReport.bind(_this);
	
	    _this.CloseEditQuesReport = _this.CloseEditQuesReport.bind(_this);
	    _this.OpenEditQuesReport = _this.OpenEditQuesReport.bind(_this);
	
	    _this.CloseEditNotesReport = _this.CloseEditNotesReport.bind(_this);
	    _this.OpenEditNotesReport = _this.OpenEditNotesReport.bind(_this);
	    _this.onContactChange = _this.onContactChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_P_Dashboard, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee22$(_context22) {
	          while (1) {
	            switch (_context22.prev = _context22.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  startDate: this.state.send_startDate,
	                  endDate: this.state.send_startDate_second
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/authtoken', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/mainProgressbar', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ display_loader: 'hide_block' });
	                    var dataString = JSON.stringify(resp.chapters);
	                    var dataReason = JSON.parse(dataString);
	                    var final_array_main = [];
	                    for (iterator = 0; iterator < dataReason.length; iterator++) {
	                      var right_answered = dataReason[iterator].answered_count;
	                      /* var total_question=dataReason[i].question_stat_count;*/
	                      var total_question = dataReason[iterator].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	
	                    _this3.setState({ bar_main_user: final_array_main });
	                  } else {
	                    _this3.setState({ display_loader: 'hide_block' });
	                    // console.log(resp.success+'------------failure');
	                  }
	                });
	                this.setState({ display_main_loader: 'show_block' });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/mainProgressclassbar', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ display_main_loader: 'hide_block' });
	                    var dataString = JSON.stringify(resp.chaptersclass);
	                    var dataReason = JSON.parse(dataString);
	
	                    var final_array_main = [];
	
	                    for (iterator = 0; iterator < dataReason.length; iterator++) {
	                      var right_answered = dataReason[iterator].answered_count;
	                      var total_question = dataReason[iterator].attempted_count;
	                      var user_graph_val = (right_answered / total_question * 100).toFixed(1);
	
	                      if (user_graph_val === 'NaN') {
	                        final_array_main.push('0.0');
	                      } else {
	                        final_array_main.push(user_graph_val);
	                      }
	                    }
	                    _this3.setState({ bar_main_class: final_array_main });
	                  } else {
	                    _this3.setState({ display_loader: 'hide_block' });
	                    // console.log(resp.success+'------------failure');
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getQuestionProgByUser', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      progress_bar_zero: resp.progressbarzero_data,
	                      qpLoader: false
	                    });
	                  } else {
	                    //console.log(resp.success + "------------failure");
	                  }
	                });
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getNotesChapter', data).then(function (resp) {
	                  if (resp.success) {
	                    //this.setState({progress_bar:resp.chapters});
	                    _this3.setState({ bar_chapter: resp.chapters });
	                  } else {
	                    //console.log(resp.success + "------------failure");
	                  }
	                });
	                _context22.next = 13;
	                return this.getQuestionFlashCards();
	
	              case 13:
	                _context22.next = 15;
	                return this.getNotesFlashCards();
	
	              case 15:
	                _context22.next = 17;
	                return this.getQuestionSaved();
	
	              case 17:
	                _context22.next = 19;
	                return this.getNotesSaved();
	
	              case 19:
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getnotesprogByuser', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ progress_bar: resp.progressbar_data, npLoader: false });
	                  } else {
	                    //console.log(resp.success + "------------failure");
	                  }
	                });
	
	                _context22.next = 22;
	                return this.getQuestionReports();
	
	              case 22:
	                _context22.next = 24;
	                return this.getNotesReports();
	
	              case 24:
	                _context22.next = 26;
	                return this.getVideoReports();
	
	              case 26:
	                _context22.next = 28;
	                return this.getVideosSaved();
	
	              case 28:
	              case 'end':
	                return _context22.stop();
	            }
	          }
	        }, _callee22, this);
	      }));
	
	      function componentDidMount() {
	        return _ref22.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	     * get saved all video
	     */
	
	
	    // function for get  video report
	
	
	    /*
	    ---------------------------------------
	      Function to get  question report
	    ---------------------------------------
	    */
	
	
	    /*
	    ---------------------------------------
	      Function to get  question flash card
	    ---------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to get  question saved
	    -------------------------------------
	    */
	
	
	    /*
	    -----------------------------------
	        Function to get  notes report
	    -----------------------------------
	    */
	
	
	    /*
	    ----------------------------------------
	        Function to get  notes flash card
	    --------------------------------------
	    */
	
	
	    /*
	    ---------------------------------
	      Function to get  notes Saved 
	    ---------------------------------
	    */
	
	  }, {
	    key: 'OpenEditQuesReport',
	    value: function OpenEditQuesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        quesReport: item.comment,
	        type: 'quesReport'
	      });
	    }
	  }, {
	    key: 'OpenEditNotesReport',
	    value: function OpenEditNotesReport(item, e) {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: item.id,
	        notesReport: item.comment,
	        type: 'notesReport'
	      });
	    }
	  }, {
	    key: 'CloseEditQuesReport',
	    value: function CloseEditQuesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        quesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'CloseEditNotesReport',
	    value: function CloseEditNotesReport() {
	      this.setState({
	        reportEditStatus: !this.state.reportEditStatus,
	        reportEditId: '',
	        notesReport: '',
	        type: '',
	        ErrorMessage: ''
	      });
	    }
	  }, {
	    key: 'toggleAlertReport',
	    value: function toggleAlertReport(item, data, e) {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: item.id,
	        type: data
	      });
	    }
	  }, {
	    key: 'toggleCloseReport',
	    value: function toggleCloseReport() {
	      this.setState({
	        reportAnswerStatus: !this.state.reportAnswerStatus,
	        reportAnswerId: '',
	        type: '',
	        contactID: '',
	        contactType: '',
	        contactIndex: '',
	        contactSubject: '',
	        contactComment: '',
	        SubjectErrorMessage: '',
	        CommentErrorMessage: '',
	        contactStatus: false
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleDone',
	    value: function () {
	      var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee31() {
	        var _this4 = this;
	
	        var _state, idname, token, item_status, items_val, question_id, item_id, video_id, data;
	
	        return _regenerator2.default.wrap(function _callee31$(_context31) {
	          while (1) {
	            switch (_context31.prev = _context31.next) {
	              case 0:
	                _state = this.state, idname = _state.idname, token = _state.token, item_status = _state.item_status, items_val = _state.items_val;
	                question_id = items_val.question_id, item_id = items_val.item_id, video_id = items_val.video_id;
	
	                if (!(this.state.item_status === 'flashcard')) {
	                  _context31.next = 6;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context31.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteFlashCard', data).then(function () {
	                  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(resp) {
	                    return _regenerator2.default.wrap(function _callee23$(_context23) {
	                      while (1) {
	                        switch (_context23.prev = _context23.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context23.next = 5;
	                              break;
	                            }
	
	                            _context23.next = 3;
	                            return _this4.getQuestionFlashCards();
	
	                          case 3:
	                            _context23.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context23.stop();
	                        }
	                      }
	                    }, _callee23, _this4);
	                  }));
	
	                  return function (_x17) {
	                    return _ref24.apply(this, arguments);
	                  };
	                }()
	                //console.log("error");
	                );
	
	              case 6:
	                if (!(this.state.item_status === 'Notesflashcard')) {
	                  _context31.next = 10;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  flash_card: this.state.items_val
	                };
	                _context31.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/deleteDashboardFlashCard', data).then(function () {
	                  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(resp) {
	                    return _regenerator2.default.wrap(function _callee24$(_context24) {
	                      while (1) {
	                        switch (_context24.prev = _context24.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context24.next = 5;
	                              break;
	                            }
	
	                            _context24.next = 3;
	                            return _this4.getNotesFlashCards();
	
	                          case 3:
	                            _context24.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context24.stop();
	                        }
	                      }
	                    }, _callee24, _this4);
	                  }));
	
	                  return function (_x18) {
	                    return _ref25.apply(this, arguments);
	                  };
	                }()
	                //console.log("error");
	                );
	
	              case 10:
	                if (!(item_status === 'savedquestion')) {
	                  _context31.next = 15;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val
	                };
	
	                this.deleteFlashCard('question', question_id ? question_id : item_id);
	                _context31.next = 15;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteSavequestion', data).then(function () {
	                  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(resp) {
	                    return _regenerator2.default.wrap(function _callee25$(_context25) {
	                      while (1) {
	                        switch (_context25.prev = _context25.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context25.next = 5;
	                              break;
	                            }
	
	                            _context25.next = 3;
	                            return _this4.getQuestionSaved();
	
	                          case 3:
	                            _context25.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context25.stop();
	                        }
	                      }
	                    }, _callee25, _this4);
	                  }));
	
	                  return function (_x19) {
	                    return _ref26.apply(this, arguments);
	                  };
	                }()
	                //console.log("error");
	                );
	
	              case 15:
	                if (!(item_status === 'Savednotes')) {
	                  _context31.next = 20;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val
	                };
	
	                this.deleteFlashCard('notes', question_id ? question_id : item_id);
	                _context31.next = 20;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/deleteSaveNotes', data).then(function () {
	                  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(resp) {
	                    return _regenerator2.default.wrap(function _callee26$(_context26) {
	                      while (1) {
	                        switch (_context26.prev = _context26.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context26.next = 5;
	                              break;
	                            }
	
	                            _context26.next = 3;
	                            return _this4.getNotesSaved();
	
	                          case 3:
	                            _context26.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context26.stop();
	                        }
	                      }
	                    }, _callee26, _this4);
	                  }));
	
	                  return function (_x20) {
	                    return _ref27.apply(this, arguments);
	                  };
	                }()
	                //console.log("error");
	                );
	
	              case 20:
	                if (!(this.state.item_status == 'Reportsquestion')) {
	                  _context31.next = 24;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context31.next = 24;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteDashboardQuestionReports', data).then(function () {
	                  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(resp) {
	                    return _regenerator2.default.wrap(function _callee27$(_context27) {
	                      while (1) {
	                        switch (_context27.prev = _context27.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context27.next = 5;
	                              break;
	                            }
	
	                            _context27.next = 3;
	                            return _this4.getQuestionReports();
	
	                          case 3:
	                            _context27.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context27.stop();
	                        }
	                      }
	                    }, _callee27, _this4);
	                  }));
	
	                  return function (_x21) {
	                    return _ref28.apply(this, arguments);
	                  };
	                }()
	                //console.log("error");
	                );
	
	              case 24:
	                if (!(this.state.item_status == 'Reportsnotes')) {
	                  _context31.next = 28;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context31.next = 28;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/deleteDashboardNotesReports', data).then(function () {
	                  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(resp) {
	                    return _regenerator2.default.wrap(function _callee28$(_context28) {
	                      while (1) {
	                        switch (_context28.prev = _context28.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context28.next = 5;
	                              break;
	                            }
	
	                            _context28.next = 3;
	                            return _this4.getNotesReports();
	
	                          case 3:
	                            _context28.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context28.stop();
	                        }
	                      }
	                    }, _callee28, _this4);
	                  }));
	
	                  return function (_x22) {
	                    return _ref29.apply(this, arguments);
	                  };
	                }()
	                //console.log("error");
	                );
	
	              case 28:
	                if (!(item_status == 'savedvideos')) {
	                  _context31.next = 33;
	                  break;
	                }
	
	                data = {
	                  token: token,
	                  idname: idname,
	                  save_question: items_val
	                };
	
	                this.deleteFlashCard('video', video_id ? video_id : item_id);
	                _context31.next = 33;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/deleteSaveVideo', data).then(function () {
	                  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(resp) {
	                    return _regenerator2.default.wrap(function _callee29$(_context29) {
	                      while (1) {
	                        switch (_context29.prev = _context29.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context29.next = 5;
	                              break;
	                            }
	
	                            _context29.next = 3;
	                            return _this4.getVideosSaved();
	
	                          case 3:
	                            _context29.next = 5;
	                            break;
	
	                          case 5:
	                          case 'end':
	                            return _context29.stop();
	                        }
	                      }
	                    }, _callee29, _this4);
	                  }));
	
	                  return function (_x23) {
	                    return _ref30.apply(this, arguments);
	                  };
	                }()
	                // console.log("error");
	                );
	
	              case 33:
	                if (!(this.state.item_status == 'Reportsvideos')) {
	                  _context31.next = 37;
	                  break;
	                }
	
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  reports: this.state.items_val
	                };
	                _context31.next = 37;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/deleteDashboardVideoReports', data).then(function () {
	                  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(resp) {
	                    return _regenerator2.default.wrap(function _callee30$(_context30) {
	                      while (1) {
	                        switch (_context30.prev = _context30.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context30.next = 5;
	                              break;
	                            }
	
	                            _context30.next = 3;
	                            return _this4.getVideoReports();
	
	                          case 3:
	                            _context30.next = 6;
	                            break;
	
	                          case 5:
	                            console.log('error');
	
	                          case 6:
	                          case 'end':
	                            return _context30.stop();
	                        }
	                      }
	                    }, _callee30, _this4);
	                  }));
	
	                  return function (_x24) {
	                    return _ref31.apply(this, arguments);
	                  };
	                }());
	
	              case 37:
	
	                this.setState({
	                  alert_status: false
	                });
	
	              case 38:
	              case 'end':
	                return _context31.stop();
	            }
	          }
	        }, _callee31, this);
	      }));
	
	      function toggleDone() {
	        return _ref23.apply(this, arguments);
	      }
	
	      return toggleDone;
	    }()
	  }, {
	    key: 'onContactChange',
	    value: function onContactChange(data, index, type) {
	      //console.log("dfaay", data);
	      if (!this.state.contactStatus) {
	        this.setState({
	          contactID: data.id,
	          contactType: type,
	          contactIndex: index,
	          contactStatus: true
	        });
	      } else {
	        this.setState({
	          contactID: '',
	          contactType: '',
	          contactIndex: '',
	          contactSubject: '',
	          contactComment: '',
	          SubjectErrorMessage: '',
	          CommentErrorMessage: '',
	          contactStatus: false
	        });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(date) {
	      this.setState({
	        startDate: date,
	        startDate_second: '',
	        send_startDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	        subreadings_status: false
	      });
	    }
	  }, {
	    key: 'handleChange_second',
	    value: function handleChange_second(date) {
	      if (this.state.startDate !== '') {
	        // document.getElementById('outer_readings_id').innerHTML = '';
	        this.setState({
	          startDate_second: date,
	          send_startDate_second: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          subreadings_status: true,
	          display_main_loader: 'show_block'
	        }, function afterdateChange() {
	          var _this5 = this;
	
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            startDate: this.state.send_startDate,
	            endDate: this.state.send_startDate_second
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/mainProgressbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chapters);
	              var dataReason = JSON.parse(dataString);
	
	              var final_array_main = [];
	
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                /* var total_question=dataReason[i].question_stat_count;*/
	                var total_question = dataReason[iterator].attempted_count;
	
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	
	                ////console.log(final_array_main+'----fdg-------');
	              }
	
	              _this5.setState({
	                bar_main_user: final_array_main,
	                display_main_loader: 'hide_block'
	              });
	              // console.log('***********'+this.state.bar_main_user+'++++++++++++');
	            } else {
	              _this5.setState({
	                display_main_loader: 'hide_block'
	              });
	              //console.log(resp.success + "------------failure");
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/mainProgressclassbar', data).then(function (resp) {
	            if (resp.success) {
	              var dataString = JSON.stringify(resp.chaptersclass);
	              var dataReason = JSON.parse(dataString);
	              var final_array_main = [];
	              for (iterator = 0; iterator < dataReason.length; iterator++) {
	                var right_answered = dataReason[iterator].answered_count;
	                var total_question = dataReason[iterator].attempted_count;
	                var user_graph_val = Math.round(right_answered / total_question * 100).toFixed(1);
	
	                if (user_graph_val === 'NaN') {
	                  final_array_main.push('0.0');
	                } else {
	                  final_array_main.push(user_graph_val);
	                }
	              }
	              _this5.setState({ bar_main_class: final_array_main });
	              //console.log('***********'+this.state.bar_main_class+'++++++++++++');
	            } else {
	                //console.log(resp.success + "------------failure");
	              }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getProgressChapter', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({ progress_bar_zero: resp.chapters });
	            } else {
	              //console.log(resp.success + "------------failure");
	            }
	          });
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getQuestionProgByUser', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({
	                progress_bar_zero: resp.progressbarzero_data,
	                qpLoader: false
	              });
	            } else {
	              //console.log(resp.success + "------------failure");
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getNotesChapter', data).then(function (resp) {
	            if (resp.success) {
	              //this.setState({progress_bar:resp.chapters});
	              _this5.setState({ bar_chapter: resp.chapters });
	            } else {
	              //console.log(resp.success + "------------failure");
	            }
	          });
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/getnotesprogByuser', data).then(function (resp) {
	            if (resp.success) {
	              _this5.setState({
	                progress_bar: resp.progressbar_data,
	                npLoader: false
	              });
	            } else {
	              //console.log(resp.success + "------------failure");
	            }
	          });
	        });
	      }
	    }
	
	    /*
	    --------------------------------------------------
	      Function to redirect page on specifc questions 
	    --------------------------------------------------
	    */
	
	  }, {
	    key: 'questionProgressBarFun',
	    value: function questionProgressBarFun() {
	      return this.state.progress_bar_zero.map(function (item, index) {
	        var progressnotes_zero = Math.round(item.counttotquestion / item.question_stat_count * 100);
	        if (progressnotes_zero < 1) {
	          progressnotes_zero = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'Q.',
	                item.chapter_id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes_zero,
	                      style: { width: progressnotes_zero + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'notesProgressBarFun',
	    value: function notesProgressBarFun() {
	      return this.state.progress_bar.map(function (item, index) {
	        var progresstotalques = item.chapterallqurestion;
	        var progressnotes = Math.round(item.fav / progresstotalques * 100);
	        if (progressnotes < 1) {
	          progressnotes = 1;
	        }
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'question_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'question_count' },
	                'N.',
	                item.chapter_id
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_bar' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.chapter_name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar_wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactstrap.Progress, {
	                      className: 'progress-xs',
	                      color: 'info',
	                      value: progressnotes,
	                      style: { width: progressnotes + '%' }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'handleQuestionReportSubmit',
	
	
	    /*
	    ---------------------------------
	      question form submit function
	    ----------------------------------
	    */
	    value: function () {
	      var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(event) {
	        var _this6 = this;
	
	        var _state2, reportEditId, idname, token, quesReport, data;
	
	        return _regenerator2.default.wrap(function _callee33$(_context33) {
	          while (1) {
	            switch (_context33.prev = _context33.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.quesReport === '' && this.state.quesReport.length < 1)) {
	                  _context33.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context33.abrupt('return');
	
	              case 4:
	                _state2 = this.state, reportEditId = _state2.reportEditId, idname = _state2.idname, token = _state2.token, quesReport = _state2.quesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  quesReport: quesReport
	                };
	                _context33.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/UpdateReportsQuestionsbyuserid', data).then(function () {
	                  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(resp) {
	                    return _regenerator2.default.wrap(function _callee32$(_context32) {
	                      while (1) {
	                        switch (_context32.prev = _context32.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context32.next = 6;
	                              break;
	                            }
	
	                            _this6.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this6.state.reportEditStatus,
	                              reportEditId: '',
	                              quesReport: ''
	                            });
	                            _context32.next = 4;
	                            return _this6.getQuestionReports();
	
	                          case 4:
	                            _context32.next = 7;
	                            break;
	
	                          case 6:
	                            _this6.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context32.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context32.stop();
	                        }
	                      }
	                    }, _callee32, _this6);
	                  }));
	
	                  return function (_x26) {
	                    return _ref33.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context33.stop();
	            }
	          }
	        }, _callee33, this);
	      }));
	
	      function handleQuestionReportSubmit(_x25) {
	        return _ref32.apply(this, arguments);
	      }
	
	      return handleQuestionReportSubmit;
	    }()
	
	    /*
	    ---------------------------------
	      notes form submit function
	    ----------------------------------
	    */
	
	  }, {
	    key: 'handleNotesReportSubmit',
	    value: function () {
	      var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(event) {
	        var _this7 = this;
	
	        var _state3, reportEditId, idname, token, notesReport, data;
	
	        return _regenerator2.default.wrap(function _callee35$(_context35) {
	          while (1) {
	            switch (_context35.prev = _context35.next) {
	              case 0:
	                event.preventDefault();
	
	                if (!(this.state.notesReport === '' && this.state.notesReport.length < 1)) {
	                  _context35.next = 4;
	                  break;
	                }
	
	                this.setState({
	                  displaytext: 'show_block',
	                  ErrorMessage: "Report can't be empty"
	                });
	                return _context35.abrupt('return');
	
	              case 4:
	                _state3 = this.state, reportEditId = _state3.reportEditId, idname = _state3.idname, token = _state3.token, notesReport = _state3.notesReport;
	                data = {
	                  id: reportEditId,
	                  idname: idname,
	                  token: token,
	                  notesReport: notesReport
	                };
	                _context35.next = 8;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/UpdateReportsNotesbyuserid', data).then(function () {
	                  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(resp) {
	                    return _regenerator2.default.wrap(function _callee34$(_context34) {
	                      while (1) {
	                        switch (_context34.prev = _context34.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context34.next = 6;
	                              break;
	                            }
	
	                            _this7.setState({
	                              ValidToken: true,
	                              validated: true,
	                              reportEditStatus: !_this7.state.reportEditStatus,
	                              reportEditId: '',
	                              notesReport: ''
	                            });
	                            _context34.next = 4;
	                            return _this7.getNotesReports();
	
	                          case 4:
	                            _context34.next = 7;
	                            break;
	
	                          case 6:
	                            _this7.setState({ ValidToken: false });
	
	                          case 7:
	                            return _context34.abrupt('return', resp);
	
	                          case 8:
	                          case 'end':
	                            return _context34.stop();
	                        }
	                      }
	                    }, _callee34, _this7);
	                  }));
	
	                  return function (_x28) {
	                    return _ref35.apply(this, arguments);
	                  };
	                }());
	
	              case 8:
	              case 'end':
	                return _context35.stop();
	            }
	          }
	        }, _callee35, this);
	      }));
	
	      function handleNotesReportSubmit(_x27) {
	        return _ref34.apply(this, arguments);
	      }
	
	      return handleNotesReportSubmit;
	    }()
	
	    /*
	    -------------------------------------------------------
	      function for state change of edit report form fileds
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: 'InputChange',
	    value: function InputChange(e) {
	      var _setState;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'ErrorMessage', ''), _setState));
	    }
	
	    /*
	    -------------------------------------------------------
	      function for state change of edit report form fileds
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: 'SubjectInputChange',
	    value: function SubjectInputChange(e) {
	      var _setState2;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'SubjectErrorMessage', ''), _setState2));
	    }
	
	    /*
	    -------------------------------------------------------
	      function for state change of edit report form fileds
	    -------------------------------------------------------
	    */
	
	  }, {
	    key: 'CommentInputChange',
	    value: function CommentInputChange(e) {
	      var _setState3;
	
	      var target = e.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, value), _defineProperty(_setState3, 'CommentErrorMessage', ''), _setState3));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          activeTabFlashcards = _state4.activeTabFlashcards,
	          activeTabSaved = _state4.activeTabSaved,
	          activeTabReports = _state4.activeTabReports,
	          qpLoader = _state4.qpLoader,
	          npLoader = _state4.npLoader,
	          savedLoader = _state4.savedLoader,
	          flashLoader = _state4.flashLoader,
	          reportLoader = _state4.reportLoader,
	          savedVideos = _state4.savedVideos,
	          reportedVideos = _state4.reportedVideos;
	
	      var flashreport_val = this.state.flashreport;
	      var notes_flashreport_val = this.state.notesFlashReport;
	      var savedquestion_val = this.state.savedquestion;
	      var savednotes_val = this.state.savednotes;
	
	      var reportquestion_val = this.state.reportquestion;
	      var reportnotes_val = this.state.reportnotes;
	
	      // let progress_bar_zero_val = this.state.progress_bar_zero;
	      // let progress_barnotes_val = this.state.progress_bar;
	      var flashcard_data = '';
	      var notes_flashcard_data = '';
	      var savedquestion_data = '';
	      var savednotes_data = '';
	
	      var question_reportsData = ''; // for question reports
	      var notes_reportsData = '';
	      var reportedVideosDataDisplay = '';
	      var savedVideoDataDisplay = '';
	      // let progress_bar_data = "";
	      // let token_Val = this.state.token;
	      // let idname_Val = this.state.idname;
	      /*first main graph*/
	      var main_bar_val = this.state.bar_chapter;
	      var main_bar_percentage = this.state.bar_main_user;
	
	      var main_bar_user_percentage = this.state.bar_main_class;
	      var main_bar_data = [];
	      var i = 0;
	
	      Object.keys(main_bar_val).map(function (key) {
	        var dataString = JSON.stringify(main_bar_val[key]);
	        var dataReason = JSON.parse(dataString);
	        main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
	        var chapter_id = dataReason.chapter_id;
	
	        i++;
	      });
	
	      var bar_data = {
	        labels: main_bar_data,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(31, 140, 235)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(31, 140, 235)',
	          data: main_bar_percentage
	        }, {
	          label: 'AnalystPrep Users Average',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: main_bar_user_percentage
	        }]
	      };
	
	      /*other graph*/
	      var chapters = this.state.chapters;
	      var reading_data = '';
	
	      if (this.state.chapters.length && !this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header', key: item.id, value: item.id },
	              _react2.default.createElement(
	                'a',
	                { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                item.chapter_name
	              )
	            ),
	            _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	          );
	        });
	      }
	      if (this.state.chapters.length && this.state.subreadings_status) {
	        reading_data = chapters.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card ', key: item.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'pointer_class', id: item.chapter_name, value: item.id },
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement('div', { className: 'card-block', key: item.chapter_name, id: 'bar_sub_item' + index })
	            )
	          );
	        });
	      }
	
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              ' ',
	              items.flash_card
	            )
	          );
	        });
	      } else if (flashLoader) {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.notesFlashReport.length) {
	        notes_flashcard_data = notes_flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginNotes.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteNotesFlashcard.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().Saved_Note,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.flash_card, "span")
	            )
	          );
	        });
	      } else {
	        notes_flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this8._deleteSavequestino(items);
	                    },
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)((items.topic_name || '').replace(/LOS \d*/i, ''), "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else if (savedLoader) {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_QUESTIONS,
	          ' '
	        );
	      }
	
	      if (this.state.savednotes.length) {
	        savednotes_data = savednotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savednotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                items.question_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginNotes.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteSavedNotes.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)((items.topic_name || '').replace(/LOS \d*/i, ''), "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else {
	        savednotes_data = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_NOTES,
	          ' '
	        );
	      }
	
	      // ===================== Saved Videos Start =========================== //
	
	      if (savedVideos.length > 0) {
	        savedVideoDataDisplay = savedVideos.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this8._beginVideos(items);
	                    },
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this8._deleteSavedVideo(items);
	                    },
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              items.topic_name && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TOPIC,
	                  ': '
	                ),
	                (0, _function.renderHTMLContent)((items.topic_name || '').replace(/LOS \d*/i, ''), "span")
	              ),
	              items.flash_card && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' Note: '
	                ),
	                (0, _function.renderHTMLContent)(items.flash_card, "span")
	              )
	            )
	          );
	        });
	      } else {
	        savedVideoDataDisplay = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_SAVED_VIDEO,
	          ' '
	        );
	      }
	      // ===================== Saved Videos End ============================= //
	      if (this.state.reportquestion.length) {
	        question_reportsData = reportquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsque_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().QUESTION_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditQuesReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.OpenEditQuesReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditQuesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleQuestionReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment-' + index,
	                            name: 'quesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.quesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditQuesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginChapter.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement('i', {
	                  onClick: _this8.toggleAlertReport.bind(_this8, items, 'quesReport'),
	                  className: _this8.state.viewREPORTCSS,
	                  style: { color: '#1f8ceb' }
	                })
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'quesReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'Q. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'quesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'quesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsquestino.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else if (reportLoader) {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'card-block-loader' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      } else {
	        question_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      if (this.state.reportnotes.length) {
	        notes_reportsData = reportnotes_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsnotes_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().Notes_ID,
	                  ': '
	                ),
	                ' ',
	                items.question_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : _this8.OpenEditNotesReport.bind(_this8, items),
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'notesReport',
	                  toggle: _this8.OpenEditNotesReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditNotesReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: _this8.handleNotesReportSubmit.bind(_this8) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment-' + index + '_' + items.id,
	                            name: 'notesReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.notesReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditNotesReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginNotes.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8.toggleAlertReport.bind(_this8, items, 'notesReport'),
	                    className: _this8.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'notesReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'N. ',
	                  items.question_id,
	                  ' ',
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'notesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'notesReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'notesReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: { paddingLeft: '0.5rem', paddingTop: '0.5rem' },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'notesReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._deleteReportsNotes.bind(_this8, items),
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        notes_reportsData = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	
	      // ===================== Report Section Start =================== //
	      if (reportedVideos.length) {
	        reportedVideosDataDisplay = reportedVideos.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'reportsvideos_' + items.id, key: index, className: 'flash_card_box' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().TICKET_ID,
	                  ': '
	                ),
	                ' ',
	                items.id
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'float-right status-' + (items.status === 'resolved' ? 'resolved' : 'pending')
	                },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'text-capitalize' },
	                  items.status === 'resolved' ? 'resolved' : 'pending'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  ' ',
	                  _language2.default.LC().VIDEO_ID,
	                  ': '
	                ),
	                ' ',
	                items.video_id
	              ),
	              !items.isSend && !items.answer && items.status !== 'resolved' ? _react2.default.createElement(
	                'span',
	                {
	                  className: 'up tooltip-hover-questions float-right',
	                  style: { padding: '10px' },
	                  onClick: items.isSend ? null : function () {
	                    return _this8.OpenEditVideoReport(items);
	                  },
	                  disabled: items.isSend
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().EDIT_REPORT,
	                  ' '
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  { className: _this8.state.EditCSS, 'aria-hidden': 'true', style: { color: '#1f8ceb' } },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportEditStatus && _this8.state.reportEditId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.OpenEditVideoReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    _reactstrap.Button,
	                    { className: 'close', color: 'secondary', onClick: _this8.CloseEditVideoReport },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'form',
	                      { onSubmit: function onSubmit(event) {
	                          return _this8.handleVideoReportSubmit(event);
	                        } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 margin_bottom_10' },
	                          _react2.default.createElement('textarea', {
	                            id: 'comment',
	                            name: 'videoReport',
	                            rows: '6',
	                            className: 'form-control',
	                            placeholder: 'Content..',
	                            onChange: _this8.InputChange.bind(_this8),
	                            value: _this8.state.videoReport
	                          }),
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            _this8.state.ErrorMessage
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 d-flex' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                            ' ',
	                            _language2.default.LC().UPDATE
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'btn btn-danger active pointer_class margin_left_10',
	                              onClick: _this8.CloseEditVideoReport
	                            },
	                            ' ',
	                            _language2.default.LC().CANCEL
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8._beginVideos.bind(_this8, items),
	                    className: _this8.state.viewCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ),
	              items.isSend && items.answer && items.answer.length > 0 ? _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().VIEW_REPORTS_ANSWER,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: _this8.toggleAlertReport.bind(_this8, items, 'videoReport'),
	                    className: _this8.state.viewREPORTCSS,
	                    style: { color: '#1f8ceb' }
	                  },
	                  ' '
	                )
	              ) : null,
	              _react2.default.createElement(
	                _reactstrap.Modal,
	                {
	                  isOpen: _this8.state.reportAnswerStatus && _this8.state.reportAnswerId === items.id && _this8.state.type === 'videoReport',
	                  toggle: _this8.toggleAlertReport,
	                  className: 'modal-primary ' + _this8.props.className
	                },
	                _react2.default.createElement(
	                  _reactstrap.ModalHeader,
	                  null,
	                  'V. ',
	                  items.video_id,
	                  (0, _function.renderHTMLContent)(items.topic_name, "span"),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'contact-us-btn float-right' },
	                    _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      _language2.default.LC().GO_TO_ANSWER,
	                      ' '
	                    ) : _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'btn btn-primary',
	                        onClick: _this8.onContactChange.bind(_this8, items, index, 'videoReport')
	                      },
	                      ' ',
	                      _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	                      ' ',
	                      _language2.default.LC().I_need_further_help,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Button,
	                      {
	                        className: 'close',
	                        style: {
	                          paddingLeft: '0.5rem',
	                          paddingTop: '0.5rem'
	                        },
	                        color: 'secondary',
	                        onClick: _this8.toggleCloseReport
	                      },
	                      '\xD7'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.ModalBody,
	                  null,
	                  _this8.state.contactStatus && _this8.state.contactType === 'videoReport' && _this8.state.contactID === items.id && _this8.state.contactIndex === index ? !_this8.state.successAlert ? _react2.default.createElement(
	                    'form',
	                    { onSubmit: _this8.onContactSubmit.bind(_this8) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().SUBJECT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactSubject',
	                          name: 'contactSubject',
	                          rows: '2',
	                          className: 'form-control',
	                          placeholder: 'Subject..',
	                          onChange: _this8.SubjectInputChange.bind(_this8),
	                          value: _this8.state.contactSubject
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.SubjectErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 margin_bottom_10' },
	                        _react2.default.createElement(
	                          'h6',
	                          { className: 'mb-1 d-flex' },
	                          ' ',
	                          _language2.default.LC().COMMENT,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: _this8.state.displaytext + ' text-danger' },
	                            '*'
	                          )
	                        ),
	                        _react2.default.createElement('textarea', {
	                          id: 'contactComment',
	                          name: 'contactComment',
	                          rows: '6',
	                          className: 'form-control',
	                          placeholder: 'Comment..',
	                          onChange: _this8.CommentInputChange.bind(_this8),
	                          value: _this8.state.contactComment
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: _this8.state.displaytext + ' text-danger' },
	                          _this8.state.CommentErrorMessage
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 d-flex align-items-center justify-content-center mt-1' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-primary active pointer_class' },
	                          ' ',
	                          _this8.state.isLoading ? 'Please wait ...' : _language2.default.LC().SEND_REQUEST
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'card-block' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 report-Success-card' },
	                        _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-control-label', htmlFor: 'textarea-input' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' ',
	                            _language2.default.LC().REQUEST_SEND_SUCCESS_MESSAGE
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-primary active pointer_class  min-vw-120',
	                            onClick: _this8.onClose
	                          },
	                          ' ',
	                          _language2.default.LC().CLOSE
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'margin_bottom_20' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _function.renderSanitizedHTML)(items.answer)
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'up tooltip-hover-questions float-right', style: { padding: '10px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  ' ',
	                  _language2.default.LC().DELETE,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'i',
	                  {
	                    onClick: function onClick() {
	                      return _this8._deleteReportsVideo(items);
	                    },
	                    className: _this8.state.deleteCSS,
	                    style: { color: '#f51a00' }
	                  },
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-1' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().TOPIC,
	                ': '
	              ),
	              (0, _function.renderHTMLContent)(items.topic_name, "span")
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                ' ',
	                _language2.default.LC().REPORT,
	                ': '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _function.renderSanitizedHTML)(items.comment)
	              )
	            )
	          );
	        });
	      } else {
	        reportedVideosDataDisplay = _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          ' ',
	          _language2.default.LC().NO_REPORTS,
	          ' '
	        );
	      }
	      // ===================== Report Section End =================== //
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_EmailResubscribe2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 margin_bottom_20' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dashboard-top-head-section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head' },
	                  _language2.default.LC().DASHBOARD
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card margin_bottom_20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-right align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        _language2.default.LC().FROM
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          selected: this.state.startDate,
	                          onChange: this.handleChange,
	                          placeholderText: 'Select date',
	                          width: '100%'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-1 text-md-center align-self-center' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'margin_bottom_0' },
	                        ' ',
	                        _language2.default.LC().TO,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-5 align-self-center' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'ico_box' },
	                          _react2.default.createElement('img', {
	                            src: _App_data2.default.frontend_url + '/img/dashboard/calendar.svg',
	                            alt: '',
	                            width: '14'
	                          })
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          placeholderText: 'Select date',
	                          width: '100%',
	                          selected: this.state.startDate_second,
	                          minDate: this.state.startDate,
	                          onChange: this.handleChange_second.bind(this)
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().PERFORMANCE,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main_loader ' + this.state.display_main_loader },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'loader-mid' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'card-block-loader' },
	                        _react2.default.createElement(_loader2.default, null)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-wrapper performance-chart-wrapper' },
	                    _react2.default.createElement(_reactChartjs.Bar, {
	                      data: bar_data,
	                      options: Object.assign({
	                        maintainAspectRatio: false
	                      }, _constant.Y_AXIS_SCALES, {
	                        tooltips: {
	                          callbacks: {
	                            label: function label(tooltipItem, data) {
	                              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
	                            }
	                          }
	                        }
	                      })
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: this.state.show_outer, id: 'outer_readings_id' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_bottom_30' },
	                ' ',
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_SAVED_ITEM_WITH_FLASH_CARD
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('1');
	                        },
	                        className: activeTabSaved === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('2');
	                        },
	                        className: activeTabSaved === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.savedTabToggle('3');
	                        },
	                        className: activeTabSaved === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' Videos '
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabSaved === '1' ? savedquestion_data : this.state.activeTabSaved === '2' ? savednotes_data : this.state.activeTabSaved === '3' ? savedVideoDataDisplay : null
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'section_head padding_bottom_30' },
	                  _language2.default.LC().MY_REPORTS
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'd-flex header-card-dashboard tab-header-wrap' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dashboard-card-header-tab' },
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('1');
	                        },
	                        className: activeTabReports === '1' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().QUESTIONS
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('2');
	                        },
	                        className: activeTabReports === '2' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        _language2.default.LC().Notes,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      {
	                        onClick: function onClick() {
	                          _this8.reportsTabToggle('3');
	                        },
	                        className: activeTabReports === '3' ? 'active' : ''
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        ' Videos '
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card tab-body-wrap' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-block dashboard-cards-scroll my-1' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'chart-wrapper' },
	                      this.state.activeTabReports === '1' ? question_reportsData : this.state.activeTabReports === '2' ? notes_reportsData : this.state.activeTabReports === '3' ? reportedVideosDataDisplay : null
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().QUESTION_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    qpLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.questionProgressBarFun()
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().NOTES_PROGRESS,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table table-hover mb-0 compress_table' },
	                    npLoader ? _react2.default.createElement(
	                      'div',
	                      { className: 'card-block-loader' },
	                      _react2.default.createElement(_loader2.default, null)
	                    ) : _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.notesProgressBarFun()
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.toggleAlert,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'close', color: 'secondary', onClick: this.toggleClose },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.toggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_Dashboard;
	}(_react.Component);
	
	SOA_P_Dashboard.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	var bar_data_sub = [];
	var reading_text = '';
	function Barget(props) {
	  if (props.subreadings_status && props.endDate !== '') {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: props.startDate,
	      endDate: props.endDate
	    };
	  } else {
	    var data = {
	      idname: props.idname,
	      chapter_id: props.chapter_id,
	      token: props.token,
	      startDate: '',
	      endDate: ''
	    };
	  }
	
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/subProgressbar', data).then(function (resp) {
	    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_dashboard/subProgressbarofclass', data).then(function (resp_class) {
	      /*class variable */
	      var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
	      var dataReason_class = JSON.parse(dataString_class);
	      var final_array_main_class = [];
	
	      for (iterator = 0; iterator < dataReason_class.length; iterator++) {
	        var right_answered_class = dataReason_class[iterator].right_answer;
	        var total_question_class = dataReason_class[iterator].total_questions;
	        var user_graph_val_class = (right_answered_class / total_question_class * 100).toFixed(2);
	        final_array_main_class.push(user_graph_val_class);
	      }
	      // console.log('abc------------------'+final_array_main_class+'-------ssss--------');
	      /*user variable*/
	      var dataString = JSON.stringify(resp.readingwisebar_ret);
	      var dataReason = JSON.parse(dataString);
	      var final_array_main = [];
	      var reading_text = [];
	
	      for (iterator = 0; iterator < dataReason.length; iterator++) {
	        var right_answered = dataReason[iterator].right_answer;
	        var total_question = dataReason[iterator].total_questions;
	        var user_graph_val = (right_answered / total_question * 100).toFixed(2);
	
	        final_array_main.push(user_graph_val);
	        reading_text.push(dataReason[iterator].reading.substring(0, 14));
	      }
	
	      bar_data_sub[props.answered_state] = {
	        labels: reading_text,
	        datasets: [{
	          label: 'You',
	          backgroundColor: 'rgb(114,195,250)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(114,195,250)',
	          data: final_array_main
	        }, {
	          label: 'Class',
	          backgroundColor: 'rgb(42,63,84)',
	          borderWidth: 1,
	          hoverBackgroundColor: 'rgb(42,63,84)',
	          data: final_array_main_class
	        }]
	      };
	    });
	  });
	  return _react2.default.createElement(_reactChartjs.Bar, { data: bar_data_sub[props.answered_state], options: { maintainAspectRatio: false } });
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this9 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this9.toggle = _this9.toggle.bind(_this9);
	    _this9.state = {
	      tooltipOpen: false
	    };
	    return _this9;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_P_Dashboard;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Soa_p_flashquestion = function (_Component) {
	  _inherits(Soa_p_flashquestion, _Component);
	
	  function Soa_p_flashquestion(props) {
	    _classCallCheck(this, Soa_p_flashquestion);
	
	    var _this = _possibleConstructorReturn(this, (Soa_p_flashquestion.__proto__ || Object.getPrototypeOf(Soa_p_flashquestion)).call(this, props));
	
	    _this._deleteFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('flashcard');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/soa/probability/beginchapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.reading_id + '/' + item.question_id,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              reading: resp.questionsbyid.reading_id,
	              chapter: resp.questionsbyid.chapter_id
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      flashreport: [], //All Flash question Store
	      token: '',
	      idname: '',
	      ValidToken: false,
	      no_result_display: '',
	      username: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(Soa_p_flashquestion, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFlashcardsbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this2.setState({ flashreport: resp.flash_report });
	          if (!resp.flash_report.length) {
	            _this2.setState({
	              no_result_display: '' + _language2.default.LC().NO_SAVED_FLASHCARDS
	            });
	          }
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	
	    //Function to toggle alert box
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	
	    //Function to delete flash card
	
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	
	    //Function to close toggle and set items status blank
	
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	
	    //On Click ok button from alert perform deletion of cfa flash card
	
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this3 = this;
	
	      if (this.state.item_status === 'flashcard') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          flash_card: this.state.items_val
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteFlashCard', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('flash_' + _this3.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	
	    //On click delete button ,set item value and open toggle alert
	
	
	    //Function to redirect, page to Dashboard page
	
	
	    //Function to redirect page to particular question id
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var flashreport_val = this.state.flashreport;
	      var flashcard_data = '';
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'flash_' + items.id, key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row  align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ':',
	                    ' ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().Saved_Note,
	                      ': '
	                    ),
	                    ' ',
	                    items.flash_card
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._beginChapter.bind(_this4, items),
	                        className: _this4.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._deleteFlashcard.bind(_this4, items),
	                        className: _this4.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_FLASHCARDS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                ' ',
	                _language2.default.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW,
	                ':',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          flashcard_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: this.toggleDone },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Soa_p_flashquestion;
	}(_react.Component);
	
	Soa_p_flashquestion.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Soa_p_flashquestion;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Soa_p_flashquestionnotes = function (_Component) {
	  _inherits(Soa_p_flashquestionnotes, _Component);
	
	  function Soa_p_flashquestionnotes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Soa_p_flashquestionnotes);
	
	    var _this = _possibleConstructorReturn(this, (Soa_p_flashquestionnotes.__proto__ || Object.getPrototypeOf(Soa_p_flashquestionnotes)).call(this, props));
	
	    _this._deleteNotesFlashcard = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('Notesflashcard');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(reading, e) {
	        var reading_id, chapter_id, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                reading_id = '';
	                chapter_id = '';
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  id: reading.question_id
	                };
	                _context.next = 5;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotesByID', data).then(function (resp) {
	                  if (resp.success) {
	                    chapter_id = resp.notes[0].chapter_id;
	                    reading_id = resp.notes[0].reading_id;
	
	                    _this.context.router.push({
	                      pathname: '/soa/probability/beginnotes/' + chapter_id + '/' + reading_id + '/' + reading.question_id,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        reading: reading_id,
	                        chapter: chapter_id,
	                        offset: 0
	                      }
	                    });
	                  }
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      flashreport: [], //All Flash question Store
	      token: '',
	      idname: '',
	      ValidToken: false,
	      no_result_display: '',
	      username: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  //it is use to redirect page
	
	
	  _createClass(Soa_p_flashquestionnotes, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFlashcardsnotesbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ flashreport: resp.flash_report });
	          if (!resp.flash_report.length) {
	            _this3.setState({
	              no_result_display: '' + _language2.default.LC().NO_SAVED_FLASHCARDS
	            });
	          }
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	
	    //Function to toggle alert box
	
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	
	    //Function to delete flash card
	
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	
	    //Function to close toggle and set items status blank
	
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	
	    //On Click ok button from alert perform deletion of cfa flash card
	
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this4 = this;
	
	      if (this.state.item_status === 'Notesflashcard') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          flash_card: this.state.items_val
	        };
	
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/deleteDashboardFlashCard', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('notesFlash_' + _this4.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	
	    //On click delete button ,set item value and open toggle alert
	
	
	    //Function to redirect, page to Dashboard page
	
	
	    //Function to redirect page on specifc questions
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var flashreport_val = this.state.flashreport;
	      var flashcard_data = '';
	      if (this.state.flashreport.length) {
	        flashcard_data = flashreport_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'notesFlash_' + items.id, key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row  align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ':',
	                    ' ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().Saved_Note,
	                      ': '
	                    ),
	                    ' ',
	                    items.flash_card
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this5._beginNotes.bind(_this5, items),
	                        className: _this5.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this5._deleteNotesFlashcard.bind(_this5, items),
	                        className: _this5.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        flashcard_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_FLASHCARDS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_FLASHCARDS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                ' ',
	                _language2.default.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW,
	                ':',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          flashcard_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { className: 'btn btn-primary', onClick: this.toggleDone },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Soa_p_flashquestionnotes;
	}(_react.Component);
	
	Soa_p_flashquestionnotes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Soa_p_flashquestionnotes;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _SoaPSubscription3 = __webpack_require__(105);
	
	var _SoaPSubscription4 = _interopRequireDefault(_SoaPSubscription3);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Axios from 'axios';
	// import { saveAs } from 'file-saver';
	
	
	/* eslint-disable*/
	
	var SOA_P_Notes = function (_Component) {
	  _inherits(SOA_P_Notes, _Component);
	
	  function SOA_P_Notes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_Notes);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Notes.__proto__ || Object.getPrototypeOf(SOA_P_Notes)).call(this, props));
	
	    _this._getReadings = function (chapter, e) {
	      // console.log(chapter);
	      if (chapter.chapter_no === 1) {
	        _this.context.router.push({
	          pathname: '/soa/probability/notesreadings/' + chapter.chapter_no,
	          state: {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            chapter: chapter.chapter_no
	          }
	        });
	      } else {
	        var final_exam = [];
	        var data = { token: _this.state.token, idname: _this.state.idname };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	          // console.log("resp", resp);
	
	          if (resp.profileInfo.role === 'partner') {
	            if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	              _this.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	              var dataset = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                  var exam_data, selectedmen, isInArray_var;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!resp_exam.success) {
	                            _context.next = 10;
	                            break;
	                          }
	
	                          exam_data = resp_exam.examData;
	                          selectedmen = _this.state.selectedmenu;
	                          isInArray_var = false;
	                          _context.next = 6;
	                          return _SoaPSubscription4.default.checkSoaPNotesSubscription(selectedmen, exam_data);
	
	                        case 6:
	                          isInArray_var = _context.sent;
	
	                          if (isInArray_var) {
	                            _this.context.router.push({
	                              pathname: '/soa/probability/notesreadings/' + chapter.chapter_no,
	                              state: {
	                                token: _this.state.token,
	                                idname: _this.state.idname,
	                                chapter: chapter.chapter_no
	                              }
	                            });
	                          } else {
	                            _this.toggleAlert();
	                          }
	                          _context.next = 10;
	                          break;
	
	                        case 10:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                  return _ref.apply(this, arguments);
	                };
	              }()
	              // console.log('fail');
	              );
	            }
	          } else {
	            if (resp.profileInfo.exam_selected === '') {
	              _this.toggleAlert();
	            } else {
	              var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	              var dataset = {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                examid: data_arr
	              };
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                // console.log(resp_exam);
	                if (resp_exam.success) {
	                  var exam_data = resp_exam.examData;
	                  var selectedmen = _this.state.selectedmenu;
	                  var isInArray_var = false;
	                  // console.log(exam_data);
	                  // console.log(selectedmen);
	                  isInArray_var = _SoaPSubscription2.default.checkSoaPNotesSubscription(selectedmen, exam_data);
	                  // console.log(isInArray_var);
	                  if (isInArray_var) {
	                    _this.context.router.push({
	                      pathname: '/soa/probability/notesreadings/' + chapter.chapter_no,
	                      state: {
	                        token: _this.state.token,
	                        idname: _this.state.idname,
	                        chapter: chapter.chapter_no
	                      }
	                    });
	                  } else {
	                    _this.toggleAlert();
	                  }
	                } else {
	                  // console.log('fail');
	                }
	              });
	            }
	          }
	        });
	      }
	    };
	
	    _this.goToNotes = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: '/soa/probability/beginnotes/' + lastRecord.soa_p_note.chapter_id + '/' + lastRecord.soa_p_note.reading_id + '/' + lastRecord.soa_p_note.id + '/' + 0,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    reading: lastRecord.soa_p_note.reading_id,
	                    chapter: lastRecord.soa_p_note.chapter_id,
	                    offset: 0
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: _App_data2.default.messageTitle_cfa,
	      MessageContent: _alertMessage2.default.messageContent_soa_p,
	      chapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      showFreePremium: '',
	      selectedmenu: 'soa_p',
	      pdfLoading: true,
	      lastRecord: '',
	      lastAttempt: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(SOA_P_Notes, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var storage_session, data, final_exam;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                if (localStorage.getItem('selectedmenu') === 'frm') {
	                  this.context.router.push({
	                    pathname: '/frm/questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getChapters', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, chapters: resp.chapters });
	                    var data = { token: _this3.state.token, idname: _this3.state.idname };
	                    _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getlastReadNotes', data).then(function (response) {
	                      if (response.success) {
	                        _this3.setState({
	                          lastRecord: response.data,
	                          lastAttempt: true
	                        });
	                      }
	                    });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	                final_exam = [];
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                this.dispose = (0, _mobx.autorun)(function () {
	                  var resp = _userStore2.default;
	                  if (resp == null || resp.profileInfo == null) {
	                    return;
	                  }
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this3.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee3$(_context3) {
	                            while (1) {
	                              switch (_context3.prev = _context3.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context3.next = 10;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this3.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context3.next = 6;
	                                  return _SoaPSubscription4.default.checkSoaPNotesSubscription(selectedmen, exam_data);
	
	                                case 6:
	                                  isInArray_var = _context3.sent;
	
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                  _context3.next = 11;
	                                  break;
	
	                                case 10:
	                                  console.log('fail');
	
	                                case 11:
	                                case 'end':
	                                  return _context3.stop();
	                              }
	                            }
	                          }, _callee3, _this3);
	                        }));
	
	                        return function (_x2) {
	                          return _ref4.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      _this3.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      // console.log("dsarafaygdu", data_arr);
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        // console.log(resp_exam);
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this3.state.selectedmenu;
	                          var isInArray_var = false;
	                          // console.log(exam_data);
	                          // console.log(selectedmen);
	                          isInArray_var = _SoaPSubscription2.default.checkSoaPNotesSubscription(selectedmen, exam_data);
	                          // console.log(isInArray_var);
	                          if (isInArray_var) {
	                            _this3.setState({ showFreePremium: false });
	                          } else {
	                            _this3.setState({ showFreePremium: true });
	                          }
	                        } else {
	                          console.log('fail');
	                        }
	                      });
	                    }
	                  }
	                });
	
	              case 9:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters = this.state.chapters;
	      var data = '';
	      var lastAttempt = this.state.lastAttempt;
	
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-6 col-xl-4 question_box free-premium-section', key: item.id },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'question_bank_wrap pointer_class',
	                key: item.id,
	                onClick: _this4._getReadings.bind(_this4, item)
	              },
	              _this4.state.showFreePremium ? item.id === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'tag-tile free' },
	                ' ',
	                _language2.default.LC().FREE,
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'tag-tile premium' },
	                ' ',
	                _language2.default.LC().PREMIUM,
	                ' '
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'margin_bottom_30' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/notes/notes_icon1.svg',
	                  className: '',
	                  width: '40',
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'question_title', key: item.id, value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  item.chapter_no,
	                  ' ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { key: item.chapter_name },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon2.svg',
	                      className: '',
	                      width: '24',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    item.Countreading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_READINGS
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: _App_data2.default.frontend_url + '/img/notes/notes_icon3.svg',
	                      className: '',
	                      width: '20',
	                      alt: ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.Countquestion
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tootip_box' },
	                    _language2.default.LC().TOTAL_NOTES
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().NOTES
	          ),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToNotes,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_READ_NOTE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.SOA_P
	        })
	      );
	    }
	  }]);
	
	  return SOA_P_Notes;
	}(_react.Component);
	
	SOA_P_Notes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_P_Notes;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var SOA_P_Viewques = function (_Component) {
	  _inherits(SOA_P_Viewques, _Component);
	
	  function SOA_P_Viewques(props) {
	    _classCallCheck(this, SOA_P_Viewques);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Viewques.__proto__ || Object.getPrototypeOf(SOA_P_Viewques)).call(this, props));
	
	    _this._getReadings = function () {
	      // console.log('working')
	      _this.context.router.push({
	        pathname: '/soa/probability/notesreadings/' + _this.props.params.chapter_no
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.props.location.state.reading.chapter_no,
	        // },
	      });
	    };
	
	    _this._beginNotes = function (item, e) {
	      // console.log(item)
	      _this.context.router.push({
	        pathname: '/soa/probability/beginnotes/' + item.chapter_id + '/' + item.reading_id + '/' + item.id,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: item.reading_id,
	          chapter: item.chapter_id
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      showFreePremium: true,
	      subscription_details: '',
	      chapters: [],
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'soa_p'
	    };
	    return _this;
	  }
	
	  _createClass(SOA_P_Viewques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                window.scrollTo(0, 0);
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	                // console.log(data);
	
	                _context2.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotes', data).then(function (resp) {
	                  // console.log(resp);
	                  // console.log(resp.questions);
	                  if (resp.success) {
	                    _this2.setState({ ValidToken: true });
	                    _this2.setState({ questions: resp.questions });
	                  } else {
	                    _this2.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 6:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	                _context2.next = 9;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp) {
	                    var exam_selected, subscription_details;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            exam_selected = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : resp.profileInfo.exam_selected;
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	                            _this2.setState({ subscription_details: subscription_details });
	
	                          case 3:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // console.log('working')
	      var questions = this.state.questions;
	      var data = '';
	      if (this.state.questions.length) {
	        data = questions.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4', key: index },
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: _this3._beginNotes.bind(_this3, item),
	                className: 'border_box'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                    className: 'margin_right_20',
	                    alt: '',
	                    width: '21'
	                  }),
	                  item.name,
	                  '(',
	                  _language2.default.LC().N,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box cfa_notes_view' },
	                item.discription ? (0, _function.renderHTMLContent)(item.discription.substr(0, 550) + '...', "div", "view_question_height view_questionhtml margin_bottom_40", { contentEditable: "false" }) : null,
	                _react2.default.createElement(UserInfo, {
	                  itemid: item.id,
	                  chapter_id: _this3.props.params.chapter_no,
	                  reading_id: _this3.props.params.id,
	                  idname: _this3.state.idname,
	                  token: _this3.state.token,
	                  answered_state: index
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.props.params.reading
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_Viewques;
	}(_react.Component);
	
	SOA_P_Viewques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function UserInfo(props) {
	  // console.log('working')
	  var data = {
	    itemid: props.itemid,
	    chapter_id: props.chapter_id,
	    reading_id: props.reading_id,
	    idname: props.idname,
	    token: props.token
	  };
	  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotesByuser', data).then(function (resp) {
	    // console.log('working')
	    if (resp.success) {
	      if (resp.success === 'success') {
	        document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Read';
	        document.getElementById('user_question_status' + props.answered_state).id = 'answered_status';
	      } else {
	        document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Not Read';
	        document.getElementById('user_question_status' + props.answered_state).id = 'notanswered_status';
	      }
	    } else {
	      document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { id: 'user_question_status' + props.answered_state })
	  );
	}
	
	exports.default = SOA_P_Viewques;
	
	// function UserInfo(props) {
	//     var data = { 'itemid': props.itemid, 'chapter_id': props.chapter_id, 'reading_id': props.reading_id, idname: props.idname, 'token': props.token };
	
	//     FD.callAPI(App_data.backend_api + '/cfa_notes/getNotesByuser', data).then(resp => {
	//         if (resp.success) {
	//             if (resp.success == "success") {
	
	//                 document.getElementById('user_question_status' + props.answered_state).innerHTML = "Read";
	//                 document.getElementById('user_question_status' + props.answered_state).id = "answered_status";
	//             }
	//             else {
	//                 document.getElementById('user_question_status' + props.answered_state).innerHTML = "Unread";
	//                 document.getElementById('user_question_status' + props.answered_state).id = "notanswered_status";
	
	//             }
	//         }
	//         else {
	//             document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
	//         }
	
	//     })
	
	//     return (<div><div id={'user_question_status' + props.answered_state} ></div></div>
	//     );
	// }

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _jquery = __webpack_require__(22);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _ValidateSaveReportIcon = __webpack_require__(18);
	
	var _ValidateSaveReportIcon2 = _interopRequireDefault(_ValidateSaveReportIcon);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from '../../../RestAPI/getData';
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_P_BeingNotes = function (_Component) {
	  _inherits(SOA_P_BeingNotes, _Component);
	
	  function SOA_P_BeingNotes(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, SOA_P_BeingNotes);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_BeingNotes.__proto__ || Object.getPrototypeOf(SOA_P_BeingNotes)).call(this, props));
	
	    _this.getSavedNotes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                params = {
	                  token: _this.state.token,
	                  question_id: data,
	                  idname: _this.state.idname
	                };
	                _context.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFavNotes', params).then(function (response) {
	                  if (response.success) {
	                    _this.setState({
	                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	                      saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	                      bookmarkColor: 'rgb(54, 141, 84)',
	                      isFlashCardHidden: false
	                    });
	                  } else {
	                    _this.setState({ isFlashCardHidden: true });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/notesreadings/' + _this.props.params.notesid,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: _this.props.params.notesid
	        }
	      });
	    };
	
	    _this._getNext = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	
	      document.getElementById('comment').value = '';
	      var i = _this.state.offset + 1;
	
	      _this.setState({ offset: i, questions: _this.state.all_questions_state[i] });
	
	      // alert((parseInt(this.state.question_length)-1)+'--------'+i);
	      if (parseInt(_this.state.question_length) - 1 == i) {
	        _this.setState({ next_block: 'card hide_block' });
	      }
	
	      if (i != 0) {
	        _this.setState({ previ_block: '' });
	      }
	
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: '/soa/probability/beginnotes/' + _this.props.params.notesid + '/' + _this.props.params.readingid + '/' + next_question_id + '/' + i,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._getPrevious = function () {
	      _this.setState({
	        display_loader: 'show_block',
	        validated: false,
	        save_question: 'btn btn-primary pointer_class margin_right_10',
	        save_text: '' + _language2.default.LC().MARK_AS_READ,
	        report_block: 'card hide_block',
	        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	        saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	      });
	      if (document.getElementById('comment')) {
	        document.getElementById('comment').value = '';
	      }
	      var i = _this.state.offset - 1;
	      _this.setState({ offset: i });
	      //alert(i);
	      // alert(this.state.offset+'-----'+(parseInt(this.state.question_length)-1));
	      if (i < parseInt(_this.state.question_length) - 1) {
	        _this.setState({ next_block: '' });
	      }
	      if (i == 0) {
	        _this.setState({ previ_block: 'card hide_block' });
	      }
	
	      _this.setState({ questions: _this.state.all_questions_state[i] });
	      var next_question_id = _this.state.all_questions_state[i].id;
	      _this.context.router.push({
	        pathname: '/soa/probability/beginnotes/' + _this.props.params.notesid + '/' + _this.props.params.readingid + '/' + next_question_id + '/' + i,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: _this.props.params.readingid,
	          chapter: _this.props.params.notesid,
	          offset: i
	        }
	      });
	    };
	
	    _this._displayReportForm = function (item, e) {
	      _this.setState({ report_block: 'card show_block' });
	    };
	
	    _this._hideReportForm = function (item, e) {
	      document.getElementById('comment').value = '';
	      _this.setState({ report_block: 'card hide_block' });
	    };
	
	    _this._reportQuestion = function (item, e) {
	      var comment = document.getElementById('comment').value;
	      if (comment.length < 2) {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        comment: comment,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _this.setState({
	        reportLoading: true
	      });
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/reportQuestion', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            successAlert: true,
	            reportLoading: false
	          });
	          document.getElementById('comment').value = '';
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this.onClose = function (e) {
	      _this.setState({
	        report_block: 'card hide_block',
	        successAlert: false
	      });
	    };
	
	    _this._getToggleComment = function (item, e) {
	      (0, _jquery2.default)(_this.refs['comment_toggle_div']).slideToggle(1000);
	    };
	
	    _this._getToggleFlash = function (item, e) {
	      (0, _jquery2.default)(_this.refs['flash_toggle_div']).slideToggle(1000);
	    };
	
	    _this._saveNotesstats = function (item, e) {
	      if (_this.state.save_question == 'btn btn-success pointer_class margin_right_10') {
	        return;
	      }
	      // const result = getDeviceDetails();
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        notes_id: item.id,
	        city: _this.state.user_city,
	        country: _this.state.user_country,
	        state: _this.state.user_state,
	        continent: _this.state.user_continent,
	        ip: _this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            save_question: 'btn btn-success pointer_class margin_right_10',
	            save_text: '' + _language2.default.LC().MARKED_AS_READ,
	            markColor: 'green'
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    };
	
	    _this._saveFlashCard = function (item, e) {
	      if (document.getElementById('flash_card').value == '') {
	        return;
	      }
	      var flash_card = document.getElementById('flash_card').value;
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id,
	        flash_card: flash_card
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/saveFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({ ValidToken: true });
	          document.getElementById('flash_card').value = '';
	          var params = {
	            token: _this.state.token,
	            idname: _this.state.idname,
	            question_id: item.id
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFlashCards', params).then(function (response) {
	            if (response.success) {
	              _this.setState({ ValidToken: true });
	              if (response.flash_cards.length > 0) {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                });
	                var flash_cards = response.flash_cards.map(function (items, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'icon_list' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._editFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'pointer_class', onClick: _this._deleteFlash.bind(_this, items) },
	                            _react2.default.createElement('i', { className: 'fa fa-close' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _this.state.flash_class },
	                        _react2.default.createElement('h4', null),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          items.flash_card
	                        )
	                      )
	                    )
	                  );
	                });
	              } else {
	                _this.setState({
	                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                });
	                var flash_cards = _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().NO_FLASHCARD_FOUND
	                );
	              }
	              _this.setState({ flash_data: flash_cards });
	            } else {
	              var flash_cards = _react2.default.createElement(
	                'p',
	                null,
	                _language2.default.LC().NO_FLASHCARD_FOUND
	              );
	              _this.setState({
	                ValidToken: false,
	                flash_data: flash_cards,
	                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	              });
	            }
	            return response;
	          });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._editFlash = function (item, e) {
	      _this.setState({
	        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	      });
	      document.getElementById('flash_card').value = item.flash_card;
	    };
	
	    _this._deleteFlash = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        flash_card: item
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/deleteFlashCard', data).then(function (resp) {
	        if (resp.success) {
	          _this.setState({
	            ValidToken: true,
	            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	          });
	          document.getElementById('flash_card').value = '';
	          var flash_cards = _react2.default.createElement(
	            'p',
	            null,
	            _language2.default.LC().NO_FLASHCARD_FOUND
	          );
	          _this.setState({ flash_data: flash_cards });
	        } else {
	          _this.setState({ ValidToken: false });
	        }
	      });
	    };
	
	    _this._saveFavNotes = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.id
	      };
	      if (_this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
	        // return;
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/unsaveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            if (_this.childRef) {
	              _this.childRef.deleteFlash();
	            }
	            _this.setState({
	              ValidToken: true,
	              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
	              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
	              bookmarkColor: '',
	              saveNotes_text: '' + _language2.default.LC().SAVE_NOTES,
	              isFlashCardHidden: true
	            });
	          } else {
	            _this.setState({ ValidToken: false });
	          }
	          return resp;
	        });
	      } else {
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/saveFavNotesByUserID', data).then(function (resp) {
	          if (resp.success) {
	            _this.setState({
	              ValidToken: true,
	              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
	              bookmarkColor: 'rgb(54, 141, 84)',
	              saveNotes_text: '' + _language2.default.LC().Notes_Saved,
	              isFlashCardHidden: false
	            });
	          } else {
	            _this.setState({ ValidToken: false, isFlashCardHidden: true });
	          }
	          return resp;
	        });
	      }
	    };
	
	    _this.state = (_this$state = {
	      successAlert: false,
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      questions: [],
	      all_questions_state: [],
	      token: '',
	      idname: '',
	      chapter_id: _this.props.params.notesid,
	      reading_id: _this.props.params.readingid,
	      ValidToken: false,
	      reportLoading: false,
	      offset: 0,
	      limit: 1,
	      choice_a: 'answer_box',
	      choice_b: 'answer_box',
	      choice_c: 'answer_box',
	      result_block: 'card hide_block',
	      report_block: 'card hide_block',
	      clicked: false,
	      choice: '',
	      result: '',
	      text_color: 'card-header',
	      records: '',
	      save_question: 'btn btn-primary pointer_class margin_right_10',
	      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
	
	      bookmarkCSS: 'fa fa-bookmark-o',
	      flagCSS: 'fa fa-flag-o mark-action-btn',
	      save_text: '' + _language2.default.LC().MARK_AS_READ,
	      savedQuestion: false,
	
	      comment: 'card-block',
	      flashcard: 'card-block',
	      comment_data: '',
	      flash_data: [],
	      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
	      comment_arrow: '',
	      flash_card_arrow: '',
	      flash_class: 'edit_right_padding',
	      count: 0,
	      rating: 0,
	      rated: false,
	      ratting_text: '' + _language2.default.LC().RATE_THIS_QUESTION,
	      validated: false,
	      saveNotes_text: '' + _language2.default.LC().SAVE_NOTES
	    }, _defineProperty(_this$state, 'bookmarkCSS', 'fa fa-bookmark-o mark-action-btn-bookmark'), _defineProperty(_this$state, 'bookmarkColor', ''), _defineProperty(_this$state, 'comment_update', 'hide_block'), _defineProperty(_this$state, 'comment_save', 'btn btn-primary active pointer_class'), _defineProperty(_this$state, 'comment_update_id', ''), _defineProperty(_this$state, 'next_block', ''), _defineProperty(_this$state, 'previ_block', ''), _defineProperty(_this$state, 'display_loader', ''), _defineProperty(_this$state, 'isFlashCardHidden', true), _defineProperty(_this$state, 'tooltips', [{
	      placement: '' + _language2.default.LC().COMMENT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().REPORT_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }, {
	      placement: '' + _language2.default.LC().FLASHCARD_TOOLTIP_MESSAGE,
	      text_align: 'right'
	    }]), _defineProperty(_this$state, 'user_city', ''), _defineProperty(_this$state, 'user_country', ''), _defineProperty(_this$state, 'user_ip', ''), _defineProperty(_this$state, 'user_state', ''), _defineProperty(_this$state, 'user_continent', ''), _this$state);
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	
	    // this.toggleAlert= this.toggleAlert.bind(this);
	    return _this;
	  }
	  /*
	  ------------------------------
	    it is use to redirect page
	  ------------------------------
	  */
	
	
	  _createClass(SOA_P_BeingNotes, [{
	    key: 'componentDidMount',
	
	
	    //On Page Load ,init this method
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                window.scroll(0, 0);
	                // api to get ip address
	                _context3.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context3.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                if (!this.props.params.id) {
	                  this.setState({ previ_block: 'card hide_block' });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.readingid,
	                  chapter_id: this.props.params.notesid,
	                  offset: this.state.offset,
	                  limit: this.state.limit
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotes_allcr', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    var ques_res, offset_res, i, params;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 19;
	                              break;
	                            }
	
	                            _this3.setState({
	                              ValidToken: true,
	                              all_questions_state: resp.questions
	                            });
	                            ques_res = [];
	                            offset_res = '';
	
	                            for (i = 0; i < resp.questions.length; i++) {
	                              if (resp.questions[i].id == _this3.props.params.id) {
	                                ques_res = resp.questions[i];
	                                offset_res = i;
	                              }
	                              if (i === resp.questions.length - 1) {
	                                _this3.setState({ display_loader: 'hide_block' });
	                              }
	                            }
	                            _this3.setState({
	                              questions: ques_res,
	                              offset: offset_res,
	                              question_length: resp.questions.length
	                            });
	
	                            if (offset_res == 0) {
	                              _this3.setState({ previ_block: 'card hide_block' });
	                            }
	                            //alert(offset_res+'--'+(parseInt(resp.questions.length)-1));
	                            if (offset_res == parseInt(resp.questions.length) - 1) {
	                              _this3.setState({ next_block: 'card hide_block' });
	                            }
	                            params = {
	                              token: _this3.state.token,
	                              question_id: ques_res.id,
	                              idname: _this3.state.idname
	                            };
	                            _context2.next = 11;
	                            return _this3.getSavedNotes(ques_res.id);
	
	                          case 11:
	                            _context2.next = 13;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getsavestatesNotes', params).then(function (response) {
	                              if (response.success) {
	                                _this3.setState({
	                                  save_question: 'btn btn-success pointer_class margin_right_10',
	                                  save_text: '' + _language2.default.LC().MARKED_AS_READ,
	                                  markColor: 'green'
	                                });
	                              } else {
	                                // console.log("enter else");
	                                setTimeout(_this3.notes_MARKED_AS_READ.bind(_this3, params), 120000);
	                              }
	                            });
	
	                          case 13:
	                            params = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              question_id: ques_res.id
	                            };
	                            _context2.next = 16;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFlashCards', params).then(function (response) {
	                              var flash_cards = '';
	                              if (response.success) {
	                                _this3.setState({ ValidToken: true });
	                                if (response.flash_cards.length > 0) {
	                                  _this3.setState({
	                                    flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                                  });
	                                  flash_cards = response.flash_cards.map(function (items, index) {
	                                    return _react2.default.createElement(
	                                      'li',
	                                      { key: index },
	                                      _react2.default.createElement(
	                                        'div',
	                                        { className: '' },
	                                        _react2.default.createElement(
	                                          'ul',
	                                          { className: 'icon_list' },
	                                          _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                              'a',
	                                              { className: 'pointer_class', onClick: _this3._editFlash.bind(_this3, items) },
	                                              _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                              'a',
	                                              {
	                                                className: 'pointer_class',
	                                                onClick: _this3._deleteFlash.bind(_this3, items)
	                                              },
	                                              _react2.default.createElement('i', { className: 'fa fa-close' })
	                                            )
	                                          )
	                                        ),
	                                        _react2.default.createElement(
	                                          'div',
	                                          { className: _this3.state.flash_class },
	                                          _react2.default.createElement('h4', null),
	                                          _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            items.flash_card
	                                          )
	                                        )
	                                      )
	                                    );
	                                  });
	                                } else {
	                                  _this3.setState({
	                                    flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                  });
	                                  flash_cards = _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _language2.default.LC().NO_FLASHCARD_FOUND
	                                  );
	                                }
	                                _this3.setState({ flash_data: flash_cards });
	                              } else {
	                                flash_cards = _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  _language2.default.LC().NO_FLASHCARD_FOUND
	                                );
	                                _this3.setState({
	                                  ValidToken: false,
	                                  flash_data: flash_cards,
	                                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                                });
	                              }
	                              return response;
	                            });
	
	                          case 16:
	                            _this3.setState({ records: '' });
	                            _context2.next = 20;
	                            break;
	
	                          case 19:
	                            _this3.setState({ ValidToken: false, records: 'Result not found.' });
	
	                          case 20:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this3);
	                  }));
	
	                  return function (_x2) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /*
	    ----------------------------------------------
	      Function to redirect page to readings page
	    ----------------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to fetch Next question
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to fetch Previous question
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to show Report box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to hide Report box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Funcion to save new report question
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Comment box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------
	      Function to toggle Flash box
	    ------------------------------------
	    */
	
	
	    /*
	    ------------------------------------------------------
	      Function to save notes and display Marked on button
	    -------------------------------------------------------
	      */
	
	  }, {
	    key: 'notes_MARKED_AS_READ',
	    value: function notes_MARKED_AS_READ(params) {
	      var _this4 = this;
	
	      // const result = getDeviceDetails();
	      var data = {
	        token: params.token,
	        idname: params.idname,
	        notes_id: params.question_id,
	        city: this.state.user_city,
	        country: this.state.user_country,
	        state: this.state.user_state,
	        continent: this.state.user_continent,
	        ip: this.state.user_ip
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/saveNotesstats', data).then(function (resp) {
	        if (resp.success) {
	          _this4.setState({
	            ValidToken: true,
	            save_question: 'btn btn-success pointer_class margin_right_10',
	            save_text: '' + _language2.default.LC().MARKED_AS_READ,
	            markColor: 'green'
	          });
	        } else {
	          _this4.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	    }
	
	    /*
	    -----------------------------------------------------------------
	      Function to Save flash Card And display new stored flash card
	    -----------------------------------------------------------------
	      */
	
	
	    /*
	    --------------------------------
	      Function to Edit Flash card
	    --------------------------------
	      */
	
	
	    /*
	    --------------------------------
	      Function to delete Flash card
	    --------------------------------
	      */
	
	  }, {
	    key: 'componentWillReceiveProps',
	
	
	    /*on url change run this function*/
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.id != this.props.params.id) {
	        this._changeContent(nextProps.params.id, nextProps.params.notesid, nextProps.params.readingid, this.state.token, this.state.idname, nextProps.params.offset);
	        this.setState({ display_loader: 'show_block' });
	      }
	    }
	
	    /*
	    ----------------------------------
	      on url change run this function
	    ----------------------------------
	      */
	
	  }, {
	    key: '_changeContent',
	    value: function _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
	      var _this5 = this;
	
	      var data = {
	        token: token_id,
	        idname: idname,
	        reading_id: readingid,
	        chapter_id: chapter_id,
	        offset: offset_val
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotes_allcr', data).then(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	          var ques_res, i, params;
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context4.next = 15;
	                    break;
	                  }
	
	                  _this5.setState({ ValidToken: true });
	                  ques_res = [];
	
	                  for (i = 0; i < resp.questions.length; i++) {
	                    if (resp.questions[i].id == _this5.props.params.id) {
	                      ques_res = resp.questions[i];
	                    }
	                  }
	                  _this5.setState({ questions: ques_res, display_loader: 'hide_block' });
	                  params = {
	                    token: _this5.state.token,
	                    question_id: ques_res.id,
	                    idname: _this5.state.idname
	                  };
	                  _context4.next = 8;
	                  return _this5.getSavedNotes(ques_res.id);
	
	                case 8:
	                  _context4.next = 10;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getsavestatesNotes', params).then(function (response) {
	                    if (response.success) {
	                      _this5.setState({
	                        save_question: 'btn btn-success pointer_class margin_right_10',
	                        save_text: '' + _language2.default.LC().MARKED_AS_READ,
	                        markColor: 'green'
	                      });
	                    }
	                  });
	
	                case 10:
	                  _context4.next = 12;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getFlashCards', params).then(function (response) {
	                    var flash_cards = '';
	                    if (response.success) {
	                      _this5.setState({ ValidToken: true });
	                      if (response.flash_cards.length > 0) {
	                        _this5.setState({
	                          flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block'
	                        });
	                        flash_cards = response.flash_cards.map(function (items, index) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                              'div',
	                              { className: '' },
	                              _react2.default.createElement(
	                                'ul',
	                                { className: 'icon_list' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  _react2.default.createElement(
	                                    'a',
	                                    { className: 'pointer_class', onClick: _this5._editFlash.bind(_this5, items) },
	                                    _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  _react2.default.createElement(
	                                    'a',
	                                    {
	                                      className: 'pointer_class',
	                                      onClick: _this5._deleteFlash.bind(_this5, items)
	                                    },
	                                    _react2.default.createElement('i', { className: 'fa fa-close' })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: _this5.state.flash_class },
	                                _react2.default.createElement('h4', null),
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  items.flash_card
	                                )
	                              )
	                            )
	                          );
	                        });
	                      } else {
	                        _this5.setState({
	                          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                        });
	                        flash_cards = _react2.default.createElement(
	                          'p',
	                          null,
	                          _language2.default.LC().NO_FLASHCARD_FOUND
	                        );
	                      }
	                      _this5.setState({ flash_data: flash_cards });
	                    } else {
	                      flash_cards = _react2.default.createElement(
	                        'p',
	                        null,
	                        _language2.default.LC().NO_FLASHCARD_FOUND
	                      );
	                      _this5.setState({
	                        ValidToken: false,
	                        flash_data: flash_cards,
	                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block'
	                      });
	                    }
	                    return response;
	                  });
	
	                case 12:
	                  _this5.setState({ records: '' });
	                  _context4.next = 16;
	                  break;
	
	                case 15:
	                  _this5.setState({
	                    ValidToken: false,
	                    records: '' + _language2.default.LC().Result_not_found
	                  });
	
	                case 16:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this5);
	        }));
	
	        return function (_x3) {
	          return _ref4.apply(this, arguments);
	        };
	      }());
	    }
	
	    /*
	    ---------------------------------------------------------------------
	      Function to Display Saved Question on button and save in database
	    ---------------------------------------------------------------------
	      */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = '';
	      var _state = this.state,
	          reportLoading = _state.reportLoading,
	          questions = _state.questions,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	      var retun_all_question = JSON.stringify(questions);
	      var all_questions = JSON.parse(retun_all_question);
	      // console.log(all_questions)
	      if (all_questions != '') {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 note-section special_notes_view' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card note-section-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header title-font-size sticky-header' },
	              _react2.default.createElement('img', {
	                src: _App_data2.default.frontend_url + '/img/notes/notes_icon4.svg',
	                className: 'margin_right_20',
	                alt: '',
	                width: '21'
	              }),
	              (0, _function.renderHTMLContent)(all_questions.name, "span", "notes-head-color", { contentEditable: "false" }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'notes-head-color' },
	                '(',
	                _language2.default.LC().N,
	                ' ',
	                all_questions.id,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'float-right text-right sticky-navigate' },
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block,
	                  onClick: this._getPrevious
	                }),
	                _react2.default.createElement('i', {
	                  className: 'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block,
	                  onClick: this._getNext
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'note-text-wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_20' },
	                    (0, _function.renderHTMLContent)(all_questions.discription, "div", "note_text_wrap", { contentEditable: "false" })
	                  ),
	                  _react2.default.createElement(_ValidateSaveReportIcon2.default
	                  // _getResult={this._getResult}
	                  , { isQue: false,
	                    saveNotes_text: this.state.saveNotes_text,
	                    markColor: this.state.markColor,
	                    _saveQuestion: this._saveFavNotes,
	                    _saveNotesstats: this._saveNotesstats,
	                    _displayReportForm: this._displayReportForm,
	                    all_questions: all_questions,
	                    save_text: this.state.save_text,
	                    bookmarkCSS: this.state.bookmarkCSS,
	                    bookmarkColor: this.state.bookmarkColor
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.report_block },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().REPORT
	                ),
	                !this.state.successAlert ? _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _language2.default.LC().COMMENT
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10' },
	                      _react2.default.createElement('textarea', {
	                        id: 'comment',
	                        name: 'comment',
	                        rows: '6',
	                        className: 'form-control',
	                        placeholder: 'Content..'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-12 col-sm-12 col-md-12' },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class report-btn',
	                          disabled: reportLoading,
	                          onClick: this._reportQuestion.bind(this, all_questions)
	                        },
	                        reportLoading ? _language2.default.LC().PLEASE_WAIT : _language2.default.LC().REPORT
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-danger active pointer_class margin_left_10',
	                          onClick: this._hideReportForm.bind(this, all_questions)
	                        },
	                        _language2.default.LC().CANCEL
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 report-Success-card' },
	                      _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-control-label', htmlFor: 'textarea-input' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          ' ',
	                          _language2.default.LC().REPORT_SEND_SUCCESS_MESSAGE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          className: 'btn btn-primary active pointer_class  min-vw-120',
	                          onClick: this.onClose
	                        },
	                        ' ',
	                        _language2.default.LC().CLOSE
	                      )
	                    )
	                  )
	                ),
	                ' '
	              )
	            ),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: questions,
	              type: 'notes',
	              isFlashCardHidden: isFlashCardHidden,
	              ref: this.setChildRef,
	              exam: 'soa_p'
	            })
	          ),
	          _react2.default.createElement('div', { className: 'row' })
	        );
	      } else {
	        /* data = <div className="col-sm-12 col-md-12">
	               <div className="no_data_bar card">No Records Found</div>
	          </div>;*/
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row note-section notes_inner_title_wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head title-font-size' },
	              _language2.default.LC().NOTES
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              _language2.default.LC().CHANGE_READING
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            data
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_BeingNotes;
	}(_react.Component);
	
	SOA_P_BeingNotes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          width: '18',
	          alt: '',
	          style: { marginLeft: '4px' }
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_P_BeingNotes;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _SoaPSubscription = __webpack_require__(105);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _SoaPSubscription3 = __webpack_require__(87);
	
	var _SoaPSubscription4 = _interopRequireDefault(_SoaPSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _constant = __webpack_require__(9);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_P_Cfanotesreadings = function (_Component) {
	  _inherits(SOA_P_Cfanotesreadings, _Component);
	
	  function SOA_P_Cfanotesreadings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_Cfanotesreadings);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Cfanotesreadings.__proto__ || Object.getPrototypeOf(SOA_P_Cfanotesreadings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/soa/probability/notes',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: '/soa/probability/notesviewques',
	              state: {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reading: reading,
	                chapter: _this.state.chapterid
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: reading.chapter_no,
	        offset: 0,
	        limit: 1
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getNotes', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this.context.router.push({
	              pathname: '/soa/probability/beginnotes/' + reading.chapter_no + '/' + reading.id + '/' + resp.questions[0].id + '/' + 0
	              // state: {
	              //   token: this.state.token,
	              //   idname: this.state.idname,
	              //   reading: reading,
	              //   chapter: this.props.location.state.chapter,
	              //   offset: 0,
	              // },
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.getpdf = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(_this.state.pdfLoading === false)) {
	                  _context4.next = 3;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context4.abrupt('return');
	
	              case 3:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context4.next = 6;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context3.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context3.next = 5;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context3.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context.next = 6;
	                                        return _SoaPSubscription2.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context.sent;
	
	                                        if (!isInArray_var) {
	                                          _context.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.PDFToggleAlert();
	
	                                      case 15:
	                                        _context.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this2);
	                              }));
	
	                              return function (_x3) {
	                                return _ref3.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 9:
	                            _context3.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context3.next = 15;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context3.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context3.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _SoaPSubscription4.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (!isInArray_var) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true
	                                            });
	                                            _this.PDFDownloadAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.PDFToggleAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      PDF_Alert_status: false,
	      PDFDownloadAlertStatus: false,
	
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: '' + _language2.default.LC().NOTE_NOT_FOUND,
	
	      PDFMessageTitle: _App_data2.default.messageTitle_cfa,
	      PDFMessageContent: _alertMessage2.default.messageContent_soa_p,
	
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.chapter,
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      chapterName: '',
	      showFreePremium: '',
	      selectedmenu: 'soa_p',
	      pdfLoading: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      type: 'notes',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.PDFToggleAlert = _this.PDFToggleAlert.bind(_this);
	    _this.PDFDownloadAlertModel = _this.PDFDownloadAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_P_Cfanotesreadings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'PDFToggleAlert',
	    value: function PDFToggleAlert() {
	      this.setState({
	        PDF_Alert_status: !this.state.PDF_Alert_status
	      });
	    }
	  }, {
	    key: 'PDFDownloadAlertModel',
	    value: function PDFDownloadAlertModel() {
	      this.setState({
	        PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus
	      });
	    }
	
	    /*
	    ------------------------------
	      it is use to redirect page
	    ------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to cfanotes page
	    ------------------------------------------------------
	    */
	
	
	    /*
	    -------------------------------------------------------
	      Function to redirect page to to notesviewquestion  page
	    ------------------------------------------------------
	    */
	
	
	    /*
	    -----------------------------------------------------
	      Function to redirect page to to specifc  questions
	    -----------------------------------------------------
	    */
	
	  }, {
	    key: 'componentDidMount',
	
	
	    //On Page Load,init this method
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        var result, storage_session, data;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context7.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context7.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  chapter: this.state.chapterid
	                };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	
	                _userStore2.default.getUserProfile(true).then(function (resp) {
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this3.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee5$(_context5) {
	                            while (1) {
	                              switch (_context5.prev = _context5.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context5.next = 10;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this3.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context5.next = 6;
	                                  return _SoaPSubscription2.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this3.state.type);
	
	                                case 6:
	                                  isInArray_var = _context5.sent;
	
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                  _context5.next = 10;
	                                  break;
	
	                                case 10:
	                                case 'end':
	                                  return _context5.stop();
	                              }
	                            }
	                          }, _callee5, _this3);
	                        }));
	
	                        return function (_x5) {
	                          return _ref6.apply(this, arguments);
	                        };
	                      }()
	                      // console.log("fail");
	                      );
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      _this3.setState({ showFreePremium: true });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee6$(_context6) {
	                            while (1) {
	                              switch (_context6.prev = _context6.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context6.next = 10;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this3.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context6.next = 6;
	                                  return _SoaPSubscription4.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this3.state.type);
	
	                                case 6:
	                                  isInArray_var = _context6.sent;
	
	                                  if (isInArray_var) {
	                                    _this3.setState({ showFreePremium: false });
	                                  } else {
	                                    _this3.setState({ showFreePremium: true });
	                                  }
	                                  _context6.next = 10;
	                                  break;
	
	                                case 10:
	                                case 'end':
	                                  return _context6.stop();
	                              }
	                            }
	                          }, _callee6, _this3);
	                        }));
	
	                        return function (_x6) {
	                          return _ref7.apply(this, arguments);
	                        };
	                      }()
	                      // console.log("fail");
	                      );
	                    }
	                  }
	                });
	                data = {
	                  token: this.state.token,
	                  idname: this.state.idname,
	                  chapter: this.state.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_notes/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({
	                      ValidToken: true,
	                      readings: resp.readings,
	                      chapterName: resp.chaptername.chapter_name
	                    });
	                    if (!resp.readings.length) {
	                      _this3.setState({ no_result_display: '<h6>No Saved Questions</h6>' });
	                    }
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 11:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              index + 1,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this4._beginChapter.bind(_this4, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_NOTES_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.chapterName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 text-md-right margin_bottom_20  notes-download-reading-page' },
	            _react2.default.createElement(
	              'span',
	              { onClick: this.getpdf.bind(this), className: 'status-download-btn margin_right_10' },
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-primary  pointer_class pull-right' },
	                this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                this.state.showFreePremium ? _react2.default.createElement(
	                  'div',
	                  { className: 'premium-download' },
	                  _language2.default.LC().PREMIUM
	                ) : null,
	                this.state.pdfLoading ? _language2.default.LC().Download_Notes : '  please wait...'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getChapters
	              },
	              _language2.default.LC().CHANGE_TOPIC
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card height_70vh' },
	              _react2.default.createElement('div', { className: 'card-header' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'table_responsive_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table-responsive' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'table_white_bg table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'border_top_0' },
	                        _react2.default.createElement(
	                          'th',
	                          { width: '90' },
	                          '#'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          _language2.default.LC().READING
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { width: '130' },
	                          _language2.default.LC().ACTION
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      data
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            this.state.MessageContent
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.PDFToggleAlert.bind(this),
	          alert_status: this.state.PDF_Alert_status,
	          MessageContent: this.state.PDFMessageContent,
	          exam: _constant.examNameAccordingToDB.SOA_P
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: 'Study Notes',
	          pdfAlertModel: this.PDFDownloadAlertModel.bind(this),
	          pdfAlert: this.state.PDFDownloadAlertStatus,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return SOA_P_Cfanotesreadings;
	}(_react.Component);
	
	SOA_P_Cfanotesreadings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_P_Cfanotesreadings;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _messages = __webpack_require__(14);
	
	var _constant = __webpack_require__(9);
	
	var _QuestionModeSetting = __webpack_require__(63);
	
	var _QuestionModeSetting2 = _interopRequireDefault(_QuestionModeSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SOA_P_QuestionBank = function (_Component) {
	  _inherits(SOA_P_QuestionBank, _Component);
	
	  function SOA_P_QuestionBank(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_QuestionBank);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_QuestionBank.__proto__ || Object.getPrototypeOf(SOA_P_QuestionBank)).call(this, props));
	
	    _this._getReadings = function (chapter, e) {
	      _this.context.router.push({
	        pathname: '/soa/probability/readings/' + chapter.chapter_no + '/' + chapter.chapter_name,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          chapter: chapter.chapter_no,
	          chapterName: chapter.chapter_name
	        }
	      });
	    };
	
	    _this.goToQuestion = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, lastRecord, lastAttempt;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                _this.context.router.push({
	                  pathname: '/soa/probability/beginchapter/' + lastRecord.soa_p_question.chapter_id + '/' + lastRecord.soa_p_question.reading_id + '/' + lastRecord.soa_p_question.id + '/' + lastRecord.soa_p_question.chapter_id + '/' + 0,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    reading: lastRecord.soa_p_question.reading_id,
	                    chapter: lastRecord.soa_p_question.chapter_id,
	                    offset: 0
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      chapters: [],
	      freeChapterCount: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      lastRecord: '',
	      lastAttempt: false
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    //this._getReadings = this._getReadings.bind(this);
	    return _this;
	  }
	
	  _createClass(SOA_P_QuestionBank, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({ alert_status: !this.state.alert_status });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      if (localStorage.getItem('selectedmenu') === 'frm') {
	        this.context.router.push({
	          pathname: '/frm/questionbank/',
	          state: {
	            token: storage_session['token'],
	            idname: storage_session['idname']
	          }
	        });
	      }
	
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getChapters', data).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  if (!resp.success) {
	                    _context2.next = 6;
	                    break;
	                  }
	
	                  _this3.setState({
	                    ValidToken: true,
	                    chapters: resp.chapters,
	                    freeChapterCount: resp.freeChapterCount
	                  });
	                  _context2.next = 4;
	                  return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getlastAnsweredQuestion', data).then(function (response) {
	                    if (response.success) {
	                      _this3.setState({
	                        lastRecord: response.data,
	                        lastAttempt: true
	                      });
	                    }
	                  });
	
	                case 4:
	                  _context2.next = 7;
	                  break;
	
	                case 6:
	                  _this3.setState({ ValidToken: false });
	
	                case 7:
	                  return _context2.abrupt('return', resp);
	
	                case 8:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var chapters = this.state.chapters;
	      var countFree = this.state.freeChapterCount;
	      var lastAttempt = this.state.lastAttempt;
	
	      var data = '';
	      var percent_data = ['23-30%', //General Probability
	      '44-50%', // Univariate Random Variables
	      '23-30%'];
	      if (this.state.chapters.length && this.state.freeChapterCount.length) {
	        data = chapters.map(function (item, index) {
	          return countFree.map(function (itemFree, indexFree) {
	            return item.chapter_no === itemFree.id ? _react2.default.createElement(
	              'div',
	              {
	                className: 'col-md-6 col-lg-6 col-xl-4 free-premium-section question_box',
	                key: index
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'question_bank_wrap pointer_class',
	                  key: item.id,
	                  onClick: _this4._getReadings.bind(_this4, item)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'margin_bottom_30' },
	                  _react2.default.createElement('img', {
	                    src: _App_data2.default.frontend_url + '/img/question_bank/icon2.svg',
	                    className: '',
	                    width: '54',
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'question_title', key: item.id, value: item.id },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'pointer_class',
	                      id: item.chapter_name,
	                      value: item.chapter_no,
	                      onClick: _this4._getReadings.bind(_this4, item)
	                    },
	                    item.chapter_no,
	                    '. ',
	                    item.chapter_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { key: item.chapter_name },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_reading_icon.svg',
	                        className: '',
	                        width: '25',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      percent_data[index]
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/free_question_icon.svg',
	                        className: '',
	                        width: '26',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      itemFree.count
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().FREE_QUESTIONS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', {
	                        src: _App_data2.default.frontend_url + '/img/question_bank/premium_question_icon.svg',
	                        className: '',
	                        width: '23',
	                        alt: ''
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      item.Countquestion
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      _language2.default.LC().PREMIUM_QUESTIONS
	                    )
	                  )
	                )
	              )
	            ) : null;
	          });
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section_head' },
	            _language2.default.LC().SOA_PROBABILITY_QUESTION_BANK
	          ),
	          _react2.default.createElement(_QuestionModeSetting2.default, { examNameKey: _constant.EXAM_NAMES.SOA_P }),
	          lastAttempt && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary pointer_class',
	              onClick: this.goToQuestion,
	              disabled: !lastAttempt
	            },
	            _messages.messages.GO_TO_MY_LAST_QUESTION_ANSWERED
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 seperator-block-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    data
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_QuestionBank;
	}(_react.Component);
	
	SOA_P_QuestionBank.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = SOA_P_QuestionBank;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _toast = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	var SOA_P_Quizzes = function (_Component) {
	  _inherits(SOA_P_Quizzes, _Component);
	
	  function SOA_P_Quizzes(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_Quizzes);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Quizzes.__proto__ || Object.getPrototypeOf(SOA_P_Quizzes)).call(this, props));
	
	    _this.abandonedQuizzes = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getallQuiz', data).then(function (resp) {
	                  if (resp.success) {
	                    var getallabondQuiz = [];
	                    var completed_quiz = [];
	                    var dataString = JSON.stringify(resp.getallQuiz);
	                    var dataReason = JSON.parse(dataString);
	                    if (!dataReason.length) {
	                      _this.setState({ display_loader: 'hide_block' });
	                    }
	                    for (var i = 0; i < dataReason.length; i++) {
	                      if (dataReason[i].count_tot === dataReason[i].number_questions) {
	                        completed_quiz.push(dataReason[i]);
	                      } else {
	                        getallabondQuiz.push(dataReason[i]);
	                      }
	                      if (i === dataReason.length - 1) {
	                        _this.setState({ display_loader: 'hide_block' });
	                      }
	                    }
	                    _this.setState({
	                      getallabondQuiz: getallabondQuiz,
	                      getallcompleteQuiz: completed_quiz
	                    });
	                  } else {
	                    // console.log('Some Thing Went Wrong');
	                  }
	                  return resp;
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this._all_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	      var all_Checked = document.getElementById('all_Checked');
	      if (all_Checked.checked) {
	        _this.setState({ all_checked_state: true }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = '';
	          }
	        });
	      } else {
	        _this.setState({ all_checked_state: false }, function all_checked_state() {
	          var i = 0;
	          for (i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = 'FALSE';
	          }
	        });
	      }
	    };
	
	    _this._single_Checked = function () {
	      var checkboxes = document.getElementsByName('approve[]');
	
	      // console.log(this.state.all_checked_state);
	      var i = 0;
	      var single_clicked_value = [];
	      for (i = 0; i < checkboxes.length; i++) {
	        if (checkboxes[i].checked) {
	          //console.log(i+'----------'+checkboxes[i].value);
	          single_clicked_value.push(checkboxes[i].value);
	        }
	      }
	
	      _this.setState({
	        all_checked_state: false,
	        single_clicked_val: single_clicked_value
	      });
	    };
	
	    _this.deleteQuizzes = function (items, e) {
	      //console.log("deleteQuizzes", items);
	      if (!_this.state.alert_status) {
	        _this.setState({
	          deleteItemId: items.id,
	          alert_status: true
	        });
	      } else {
	        _this.setState({
	          deleteItemId: '',
	          alert_status: false
	        });
	      }
	    };
	
	    _this.deleteToggleDone = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                //console.log("calllinggg!!!!");
	                data = {
	                  token: _this.state.token,
	                  idname: _this.state.idname,
	                  deleteItemId: _this.state.deleteItemId
	                };
	                _context3.next = 3;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/deleteAbandonedQuizzes', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!resp.success) {
	                              _context2.next = 4;
	                              break;
	                            }
	
	                            _context2.next = 3;
	                            return _this.abandonedQuizzes(data);
	
	                          case 3:
	                            _this.setState({
	                              deleteItemId: '',
	                              alert_status: false
	                            });
	
	                          case 4:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      token: '',
	      idname: '',
	      chapters: '',
	      all_checked_state: true,
	      radio_checked_question: 0,
	      radio_checked_priority: 'none',
	      single_clicked_val: '',
	      getallabondQuiz: '',
	      getallcompleteQuiz: '',
	      quiz_length_state: '',
	      display_loader: 'show_block',
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRM,
	      deleteItemId: '',
	      tooltips: [{
	        placement: '' + _language2.default.LC().SELECT_HERE_NUMBER,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().ALL_INCOMPLETE_QUIZ,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().SEE_THE_DETAILS,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().Priority_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().unanswered_selected,
	        text_align: 'left'
	      }, {
	        placement: '' + _language2.default.LC().wronganswered_selected,
	        text_align: 'left'
	      }]
	    };
	    // this.toggle = this.toggle.bind(this);
	    return _this;
	  }
	
	  _createClass(SOA_P_Quizzes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getChapters', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ ValidToken: true, chapters: resp.chapters });
	        } else {
	          _this3.setState({ ValidToken: false });
	        }
	        return resp;
	      });
	
	      this.abandonedQuizzes(data);
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getallQuiz_length', data).then(function (resp_quiz_length) {
	        // console.log(resp_quiz_length.quiz_length);
	        if (resp_quiz_length.success) {
	          _this3.setState({ quiz_length_state: resp_quiz_length.quiz_length });
	        } else {
	          // console.log('Some Thing Went Wrong');
	        }
	      });
	    }
	  }, {
	    key: '_createQuiz',
	
	
	    /*_changeIncludetimer(){
	      if(this.state.include_timer)
	      {
	        this.setState({ include_timer:!this.state.include_timer });
	      }
	      else{
	        this.setState({ include_timer:!this.state.include_timer });
	      }    	
	    }*/
	
	    /*_changeSaveresult(){
	      if(this.state.save_results)
	      {
	        this.setState({ save_results:!this.state.save_results });
	      }
	      else{
	        this.setState({ save_results:!this.state.save_results });
	      }    
	    }*/
	
	    value: function _createQuiz() {
	      var _this4 = this;
	
	      this.setState({ display_loader: 'show_block' });
	      var question_length_val = document.querySelector('input[name="number_questions"]:checked').value;
	      var timer_value,
	          chapterAll = '';
	      timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;
	      if (this.state.all_checked_state) {
	        // console.log('if	 working')
	        var dataString = JSON.stringify(this.state.chapters);
	        var dataReason = JSON.parse(dataString);
	        var chapterall_id = [];
	        for (var i = 0; i < dataReason.length; i++) {
	          chapterall_id.push(dataReason[i].chapter_no);
	        }
	
	        chapterAll = chapterall_id;
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          chapterAll: chapterAll,
	          questionquize: question_length_val,
	          priority: this.state.radio_checked_priority
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getQuizequestion', data).then(function (resp) {
	          // console.log('getQuizequestion')
	          // console.log(resp)
	          if (resp.success) {
	            var retun_all_chapter = JSON.stringify(resp.chapters);
	            var chapterParse = JSON.parse(retun_all_chapter);
	            var question_id = [];
	            var myJson = { question_count: '', all_questions: {} };
	            for (var i = 0; i < chapterParse.length; i++) {
	              var objName = 'q' + i;
	              var objValue = chapterParse[i].id;
	              myJson.all_questions[i] = objValue;
	              question_id.push(chapterParse[i].id);
	            }
	            myJson.question_count = question_id.length;
	            var questions = JSON.stringify(myJson);
	            var data = {
	              token: _this4.state.token,
	              idname: _this4.state.idname,
	              number_questions: myJson.question_count,
	              questions: questions,
	              timer_value: timer_value
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/createQuiz', data).then(function (resp) {
	              // console.log('createQuiz')
	              // console.log(resp)
	              if (resp.success) {
	                _this4.setState({ display_loader: 'hide_block' });
	                _this4.context.router.push({
	                  pathname: '/soa/probability/beforeStart/' + resp.last_id,
	                  state: {
	                    token: _this4.state.token,
	                    idname: _this4.state.idname,
	                    quiz_id: resp.last_id,
	                    status_send: ''
	                  }
	                });
	              } else {
	                //console.log(resp.success);
	              }
	            });
	          } else {
	            _this4.setState({ display_loader: 'hide_block' });
	            (0, _toast.showFailure)(resp.message);
	          }
	          return resp;
	        });
	      } else {
	        // console.log('else working')
	        var checkboxes = document.getElementsByName('approve[]');
	        var i = 0;
	        var single_clicked_value = [];
	        if (this.state.single_clicked_val === '') {
	          for (i = 0; i < checkboxes.length; i++) {
	            if (checkboxes[i].checked) {
	              // console.log(i+'----------'+checkboxes[i].value);
	              single_clicked_value.push(checkboxes[i].value);
	            }
	          }
	
	          chapterAll = single_clicked_value;
	          // console.log(chapterAll)
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          // console.log(data)
	
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getQuizequestion', data).then(function (resp) {
	            // console.log('getQuizequestion1')
	            // console.log(resp)
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/createQuiz', data_insert).then(function (resp) {
	                // console.log('createQuiz')
	                // console.log(resp)
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: '/soa/probability/beforeStart/' + resp.last_id,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id
	                    }
	                  });
	                } else {
	                  // console.log(resp.success);
	                }
	              });
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        } else {
	          chapterAll = this.state.single_clicked_val;
	          var data = {
	            token: this.state.token,
	            idname: this.state.idname,
	            chapterAll: chapterAll,
	            questionquize: question_length_val,
	            priority: this.state.radio_checked_priority
	          };
	          _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/getQuizequestion', data).then(function (resp) {
	            // console.log('getQuizequestion')
	            // console.log(resp)
	            if (resp.success) {
	              var retun_all_chapter = JSON.stringify(resp.chapters);
	              var chapterParse = JSON.parse(retun_all_chapter);
	              var question_id = [];
	              var myJson = { question_count: '', all_questions: {} };
	              for (var i = 0; i < chapterParse.length; i++) {
	                var objName = 'q' + i;
	                var objValue = chapterParse[i].id;
	                myJson.all_questions[i] = objValue;
	                question_id.push(chapterParse[i].id);
	              }
	              myJson.question_count = question_id.length;
	              var questions = JSON.stringify(myJson);
	              var data_insert = {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                number_questions: myJson.question_count,
	                questions: questions,
	                timer_value: timer_value
	              };
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_quizzes/createQuiz', data_insert).then(function (resp) {
	                // console.log('createQuiz')
	                // console.log(resp)
	                if (resp.success) {
	                  _this4.context.router.push({
	                    pathname: '/soa/probability/beforeStart/' + resp.last_id,
	                    state: {
	                      token: _this4.state.token,
	                      idname: _this4.state.idname,
	                      quiz_id: resp.last_id
	                    }
	                  });
	                } else {
	                  //console.log(resp.success);
	                }
	              });
	            } else {
	              _this4.setState({ display_loader: 'hide_block' });
	              (0, _toast.showFailure)(resp.message);
	            }
	            return resp;
	          });
	        }
	      }
	    }
	  }, {
	    key: '_checkAbondon',
	    value: function _checkAbondon(items, e) {
	      this.context.router.push({
	        pathname: '/soa/probability/beforeStart/' + items.id + '/' + 'abondon',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'abondon'
	        }
	      });
	    }
	  }, {
	    key: '_checkCompleted',
	    value: function _checkCompleted(items, e) {
	      this.context.router.push({
	        pathname: '/soa/probability/beforeStart/' + items.id + '/' + 'completed',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          quiz_id: items.id,
	          status_send: 'completed'
	        }
	      });
	    }
	  }, {
	    key: '_length_Checked',
	    value: function _length_Checked(items, index_value, e) {
	      this.setState({ radio_checked_question: index_value });
	    }
	  }, {
	    key: '_priority_selected',
	    value: function _priority_selected(e) {
	      // console.log(e.target.value)
	      this.setState({ radio_checked_priority: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var chapters_all = this.state.chapters;
	      var chapter_data = '';
	
	      if (this.state.chapters.length) {
	        chapter_data = chapters_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-md-6', key: index },
	            _react2.default.createElement(
	              'label',
	              { className: 'check_container' },
	              items.chapter_name,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                name: 'approve[]',
	                value: items.chapter_no,
	                onClick: _this5._single_Checked.bind(_this5)
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          );
	        });
	      }
	
	      var abandoned_all = this.state.getallabondQuiz;
	      var abandoned_data = '';
	
	      if (this.state.getallabondQuiz.length) {
	        abandoned_data = abandoned_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_red' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Id: ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ' : ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'cursor_pointer',
	                  onClick: _this5._checkAbondon.bind(_this5, items)
	                },
	                _language2.default.LC().RECOVER
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: '' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'delete-quizzes',
	                  onClick: function onClick() {
	                    return _this5.deleteQuizzes(items);
	                  }
	                },
	                ' ',
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                ' Delete',
	                ' '
	              )
	            )
	          );
	        });
	      } else {
	        abandoned_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var getallcompleteQuiz_all = this.state.getallcompleteQuiz;
	      var getallcompleteQuiz_data = '';
	
	      if (this.state.getallcompleteQuiz.length) {
	        getallcompleteQuiz_data = getallcompleteQuiz_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index, className: 'quize-row' },
	            _react2.default.createElement(
	              'td',
	              { className: 'text_green' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                _language2.default.LC().ID,
	                ': ',
	                items.id
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().QUESTIONS,
	              ': ',
	              items.number_questions
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _language2.default.LC().DATE,
	              ': ',
	              _react2.default.createElement(Dateform, { created_d: items.createdAt })
	            ),
	            _react2.default.createElement(
	              'td',
	              { className: 'text_blue' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'cursor_pointer',
	                  onClick: _this5._checkCompleted.bind(_this5, items)
	                },
	                _language2.default.LC().VIEW
	              )
	            )
	          );
	        });
	      } else {
	        getallcompleteQuiz_data = _react2.default.createElement(
	          'tr',
	          { contentEditable: 'false' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: 4, className: 'text-center' },
	            'No Data Found'
	          )
	        );
	      }
	
	      var quiz_length_state_all = this.state.quiz_length_state;
	      var quiz_length_state_data = '';
	      if (this.state.quiz_length_state.length) {
	        quiz_length_state_data = quiz_length_state_all.map(function (items, index) {
	          return _react2.default.createElement(
	            'label',
	            { className: 'radio_container', key: index },
	            items.quiz_length,
	            ' ',
	            _language2.default.LC().QUESTIONS,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              id: 'number_questions_id',
	              name: 'number_questions',
	              value: items.quiz_length,
	              checked: _this5.state.radio_checked_question === index,
	              onClick: _this5._length_Checked.bind(_this5, items, index)
	            }),
	            _react2.default.createElement('span', { className: 'checkmark' })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              _language2.default.LC().SOA_P_QUIZZES
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this._createQuiz.bind(this)
	              },
	              ' ',
	              _language2.default.LC().CREATE_QUIZ,
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-7' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().CONTENT,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions float-right' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'check_container margin_bottom_0' },
	                      ' ',
	                      _language2.default.LC().ALL_CHAPTERS,
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'all_Checked',
	                        name: 'all_checked',
	                        value: 'select',
	                        onClick: this._all_Checked.bind(this),
	                        checked: this.state.all_checked_state
	                      }),
	                      _react2.default.createElement('span', { className: 'checkmark' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block padding_15' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    chapter_data
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().ABANDONED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '1',
	                      id: '1',
	                      content: this.state.tooltips[1].placement,
	                      place_tip: this.state.tooltips[1].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper abandoned_quizzes_cards_scroll' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        abandoned_data
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().Priorities_By,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '3',
	                      id: '3',
	                      content: this.state.tooltips[3].placement,
	                      place_tip: this.state.tooltips[3].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().NONE,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'none',
	                      name: 'none',
	                      value: 'none',
	                      checked: this.state.radio_checked_priority === 'none',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    _language2.default.LC().UNANSWERED,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unanswered',
	                      name: 'mark_unanswered',
	                      value: 'unanswered',
	                      checked: this.state.radio_checked_priority === 'unanswered',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '4',
	                      id: '4',
	                      content: this.state.tooltips[4].placement,
	                      place_tip: this.state.tooltips[4].text_align
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'radio_container' },
	                    ' ',
	                    _language2.default.LC().Wrong_answers,
	                    _react2.default.createElement('input', {
	                      type: 'radio',
	                      id: 'mark_unattempted',
	                      name: 'mark_unattempted',
	                      value: 'wrongquestion',
	                      checked: this.state.radio_checked_priority === 'wrongquestion',
	                      onClick: this._priority_selected.bind(this)
	                    }),
	                    _react2.default.createElement('span', { className: 'checkmark' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right tooltip_quiz' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '5',
	                      id: '5',
	                      content: this.state.tooltips[5].placement,
	                      place_tip: this.state.tooltips[5].text_align
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().LENGTH,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '0',
	                      id: '0',
	                      content: this.state.tooltips[0].placement,
	                      place_tip: this.state.tooltips[0].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-block' },
	                  quiz_length_state_data
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-header' },
	                  _language2.default.LC().COMPLETED_QUIZZES,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-actions card_action_tooltip float-right' },
	                    _react2.default.createElement(TooltipItem, {
	                      key: '2',
	                      id: '2',
	                      content: this.state.tooltips[2].placement,
	                      place_tip: this.state.tooltips[2].text_align
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table' },
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        getallcompleteQuiz_data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Modal,
	            {
	              isOpen: this.state.alert_status,
	              toggle: this.deleteQuizzes,
	              className: 'modal-primary ' + this.props.className
	            },
	            _react2.default.createElement(
	              _reactstrap.ModalHeader,
	              null,
	              _language2.default.LC().ALERT,
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'close',
	                  color: 'secondary',
	                  onClick: this.deleteQuizzes
	                },
	                '\xD7'
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.ModalBody,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'margin_bottom_20' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    this.state.MessageContent
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: this.deleteToggleDone
	                  },
	                  _language2.default.LC().OK
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loader_box ' + this.state.display_loader },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_Quizzes;
	}(_react.Component);
	
	SOA_P_Quizzes.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function Dateform(props) {
	  var myDate = (0, _moment2.default)(props.created_d).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    'span',
	    null,
	    myDate
	  );
	}
	
	var TooltipItem = function (_React$Component) {
	  _inherits(TooltipItem, _React$Component);
	
	  function TooltipItem(props) {
	    _classCallCheck(this, TooltipItem);
	
	    var _this6 = _possibleConstructorReturn(this, (TooltipItem.__proto__ || Object.getPrototypeOf(TooltipItem)).call(this, props));
	
	    _this6.toggle = _this6.toggle.bind(_this6);
	    _this6.state = {
	      tooltipOpen: false
	    };
	    return _this6;
	  }
	
	  _createClass(TooltipItem, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        tooltipOpen: !this.state.tooltipOpen
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('img', {
	          src: _App_data2.default.frontend_url + '/img/dashboard/info_icon.svg',
	          id: 'Tooltip-' + this.props.id,
	          alt: '',
	          className: '',
	          width: '18'
	        }),
	        _react2.default.createElement(
	          _reactstrap.Tooltip,
	          {
	            placement: this.props.place_tip,
	            isOpen: this.state.tooltipOpen,
	            target: 'Tooltip-' + this.props.id,
	            toggle: this.toggle
	          },
	          _react2.default.createElement(
	            'p',
	            { className: 'tooltip_text' },
	            this.props.content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TooltipItem;
	}(_react2.default.Component);
	
	exports.default = SOA_P_Quizzes;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _SoaPSubscription3 = __webpack_require__(105);
	
	var _SoaPSubscription4 = _interopRequireDefault(_SoaPSubscription3);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _PDFModel = __webpack_require__(30);
	
	var _PDFModel2 = _interopRequireDefault(_PDFModel);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getIpAddress = __webpack_require__(17);
	
	var _constant = __webpack_require__(9);
	
	var _mobx = __webpack_require__(37);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import GD from "../../../RestAPI/getData";
	
	// import { getDeviceDetails } from "../../../../common/deviceDetails";
	
	
	/* eslint-disable*/
	var SOA_P_Readings = function (_Component) {
	  _inherits(SOA_P_Readings, _Component);
	
	  function SOA_P_Readings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_Readings);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Readings.__proto__ || Object.getPrototypeOf(SOA_P_Readings)).call(this, props));
	
	    _this._getChapters = function (e) {
	      _this.context.router.push({
	        pathname: '/soa/probability/questionbank',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._getQuestions = function (reading, e) {
	      var user_data = { token: _this.state.token, idname: _this.state.idname };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', user_data).then(function (resp) {
	        if (resp.profileInfo.role === 'partner') {
	          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(resp_exam) {
	                var exam_data, selectedmen, isInArray_var;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!resp_exam.success) {
	                          _context.next = 10;
	                          break;
	                        }
	
	                        exam_data = resp_exam.examData;
	                        selectedmen = _this.state.selectedmenu;
	                        isInArray_var = false;
	                        _context.next = 6;
	                        return _SoaPSubscription4.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                      case 6:
	                        isInArray_var = _context.sent;
	
	                        if (isInArray_var) {
	                          _this._runCode('paid', reading);
	                          _this.setState({ subscriptionstatus: 'paid' });
	                        } else {
	                          _this._runCode('free', reading);
	                          _this.setState({ subscriptionstatus: 'free' });
	                        }
	                        _context.next = 11;
	                        break;
	
	                      case 10:
	                        console.log('fail');
	
	                      case 11:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }());
	          }
	        } else {
	          if (resp.profileInfo.exam_selected === '') {
	            _this._runCode('free', reading);
	            _this.setState({ subscriptionstatus: 'free' });
	          } else {
	            var subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	            _this.setState({
	              subscription_details: subscription_details
	            });
	            var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	            var dataset = {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              examid: data_arr
	            };
	            _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	              if (resp_exam.success) {
	                var exam_data = resp_exam.examData;
	                var selectedmen = _this.state.selectedmenu;
	                var isInArray_var = false;
	                isInArray_var = _SoaPSubscription2.default.checkSoaPSubscription(selectedmen, exam_data);
	                if (isInArray_var) {
	                  _this._runCode('paid', reading);
	                  _this.setState({ subscriptionstatus: 'paid' });
	                } else {
	                  _this._runCode('free', reading);
	                  _this.setState({ subscriptionstatus: 'free' });
	                }
	              } else {
	                console.log('fail');
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this._beginChapter = function (reading, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        reading_id: reading.id,
	        chapter_id: _this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: _this.state.subscriptionstatus
	      };
	      // console.log(data);
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            // console.log(resp.questions);
	            _this.context.router.push({
	              pathname: '/soa/probability/beginchapter/' + _this.state.chapterid + '/' + reading.id + '/' + resp.questions[0].id + '/' + 0,
	              state: {
	                token: _this.state.token,
	                idname: _this.state.idname,
	                reading: reading,
	                chapter: _this.props.params.chapter,
	                offset: 0
	              }
	            });
	          } else {
	            _this.toggleAlert();
	          }
	        }
	      });
	    };
	
	    _this.getpdf = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                console.log('getpdf');
	
	                if (!(_this.state.pdfLoading == false)) {
	                  _context5.next = 4;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context5.abrupt('return');
	
	              case 4:
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context5.next = 7;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context5.abrupt('return');
	
	              case 7:
	                data = { token: _this.state.token, idname: _this.state.idname };
	                _context5.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 5;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context4.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _SoaPSubscription4.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (!isInArray_var) {
	                                          _context2.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context2.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context2.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.PDFToggleAlert();
	
	                                      case 15:
	                                        _context2.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this2);
	                              }));
	
	                              return function (_x4) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 9:
	                            _context4.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context4.next = 15;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context4.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context3.next = 6;
	                                        return _SoaPSubscription2.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context3.sent;
	
	                                        if (!isInArray_var) {
	                                          _context3.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoading: false
	                                        });
	                                        // const result = getDeviceDetails();
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context3.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/Q-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoading: true,
	                                              PDFDownloadType: 'Question'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context3.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.PDFToggleAlert();
	
	                                      case 15:
	                                        _context3.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this2);
	                              }));
	
	                              return function (_x5) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this2);
	                  }));
	
	                  return function (_x3) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 10:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getpdfAnswer = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(e) {
	        var data;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                console.log('getpdfAnswer');
	
	                if (!(_this.state.pdfLoadingAnswer == false)) {
	                  _context9.next = 4;
	                  break;
	                }
	
	                alert('Download is in progress....');
	                return _context9.abrupt('return');
	
	              case 4:
	                if (!(_this.state.pdfLoading == false)) {
	                  _context9.next = 7;
	                  break;
	                }
	
	                alert('Please wait one process is in queue.');
	                return _context9.abrupt('return');
	
	              case 7:
	                data = { token: _this.state.token, idname: _this.state.idname };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee8$(_context8) {
	                      while (1) {
	                        switch (_context8.prev = _context8.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context8.next = 11;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context8.next = 5;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context8.next = 9;
	                            break;
	
	                          case 5:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 9;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context6.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context6.next = 6;
	                                        return _SoaPSubscription4.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context6.sent;
	
	                                        if (!isInArray_var) {
	                                          _context6.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context6.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context6.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.PDFToggleAlert();
	
	                                      case 15:
	                                        _context6.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this2);
	                              }));
	
	                              return function (_x8) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 9:
	                            _context8.next = 19;
	                            break;
	
	                          case 11:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context8.next = 15;
	                              break;
	                            }
	
	                            _this.PDFToggleAlert();
	                            _context8.next = 19;
	                            break;
	
	                          case 15:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this.state.token,
	                              idname: _this.state.idname,
	                              examid: data_arr
	                            };
	                            _context8.next = 19;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var, dataset;
	                                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                                  while (1) {
	                                    switch (_context7.prev = _context7.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context7.next = 17;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context7.next = 6;
	                                        return _SoaPSubscription2.default.checkSoaP_PDFSubscription(selectedmen, exam_data, _this.state.type);
	
	                                      case 6:
	                                        isInArray_var = _context7.sent;
	
	                                        if (!isInArray_var) {
	                                          _context7.next = 14;
	                                          break;
	                                        }
	
	                                        _this.setState({
	                                          pdfLoadingAnswer: false
	                                        });
	                                        // const result = getDeviceDetails();
	
	                                        dataset = {
	                                          token: _this.state.token,
	                                          idname: _this.state.idname,
	                                          chapterId: _this.state.chapterid,
	                                          city: _this.state.user_city,
	                                          country: _this.state.user_country,
	                                          state: _this.state.user_state,
	                                          continent: _this.state.user_continent,
	                                          ip: _this.state.user_ip
	                                        };
	                                        _context7.next = 12;
	                                        return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/QA-PdfDownloadViaEmail', dataset).then(function (response) {
	                                          if (response.success) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          } else if (!response.pdf) {
	                                            _this.setState({
	                                              pdfLoadingAnswer: true,
	                                              PDFDownloadType: 'Question/Answer'
	                                            });
	                                            _this.pdfAlertModel();
	                                          }
	                                        });
	
	                                      case 12:
	                                        _context7.next = 15;
	                                        break;
	
	                                      case 14:
	                                        _this.PDFToggleAlert();
	
	                                      case 15:
	                                        _context7.next = 17;
	                                        break;
	
	                                      case 17:
	                                      case 'end':
	                                        return _context7.stop();
	                                    }
	                                  }
	                                }, _callee7, _this2);
	                              }));
	
	                              return function (_x9) {
	                                return _ref9.apply(this, arguments);
	                              };
	                            }()
	                            // console.log('fail');
	                            );
	
	                          case 19:
	                          case 'end':
	                            return _context8.stop();
	                        }
	                      }
	                    }, _callee8, _this2);
	                  }));
	
	                  return function (_x7) {
	                    return _ref7.apply(this, arguments);
	                  };
	                }());
	
	              case 9:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this2);
	      }));
	
	      return function (_x6) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      alert_status: false,
	      PDF_Alert_status: false,
	      PDFDownloadAlertStatus: false,
	
	      MessageTitle: '' + _language2.default.LC().MESSAGE,
	      MessageContent: '' + _language2.default.LC().QUESTION_NOT_FOUND,
	      PDFMessageTitle: _App_data2.default.messageTitle_cfa,
	      PDFMessageContent: _alertMessage2.default.messageContent_soa_p,
	      readings: [],
	      token: '',
	      idname: '',
	      chapterid: _this.props.params.chapter,
	      chapterName: '',
	      ValidToken: false,
	      chapter_id: '',
	      no_result_display: '',
	      subscriptionstatus: '',
	      showFreePremium: '',
	      selectedmenu: 'soa_p',
	      PDFDownloadType: 'Question',
	      pdfLoading: true,
	      pdfLoadingAnswer: true,
	      PDFContentMessage: _language2.default.LC().PDFContentMessage,
	      type: 'question',
	      user_city: '',
	      user_country: '',
	      user_ip: '',
	      user_state: '',
	      user_continent: ''
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.PDFToggleAlert = _this.PDFToggleAlert.bind(_this);
	
	    _this.pdfAlertModel = _this.pdfAlertModel.bind(_this);
	    return _this;
	  }
	
	  _createClass(SOA_P_Readings, [{
	    key: 'toggleAlert',
	    value: function toggleAlert() {
	      this.setState({
	        alert_status: !this.state.alert_status
	      });
	    }
	  }, {
	    key: 'PDFToggleAlert',
	    value: function PDFToggleAlert() {
	      this.setState({
	        PDF_Alert_status: !this.state.PDF_Alert_status
	      });
	    }
	  }, {
	    key: 'pdfAlertModel',
	    value: function pdfAlertModel() {
	      this.setState({
	        PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus
	      });
	    }
	    //On Page Load,init this method
	
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	        var _this3 = this;
	
	        var result, storage_session, data, final_exam;
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                window.scrollTo(0, 0);
	                // api to get ip address
	                _context11.next = 3;
	                return (0, _getIpAddress.getIpAddress)();
	
	              case 3:
	                result = _context11.sent;
	
	                if (result) {
	                  this.setState({
	                    user_city: result.city,
	                    user_country: result.country,
	                    user_ip: result.query,
	                    user_state: result.region,
	                    user_continent: result.continent
	                  });
	                }
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                if (localStorage.getItem('selectedmenu') === 'frm') {
	                  this.context.router.push({
	                    pathname: '/soa/probability/questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                // var data = {
	                //   token: storage_session['token'],
	                //   idname: storage_session['idname'],
	                // };
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
	                //   console.log("SSSSSSS:::::::")
	                // // this.dispose = autorun(async () => {
	                // //   const resp = userStore;
	                // //   if(resp == null || resp.profileInfo == null){
	                // //     return null;
	                // //   }
	                //   if (resp.profileInfo.role === 'partner') {
	                //     if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                //       this.setState({ showFreePremium: true });
	                //     } else {
	                //       var data_arr = resp.profileInfo.exam_selected
	                //         ? JSON.parse(resp.profileInfo.exam_selected)
	                //         : null;
	                //       var dataset = {
	                //         token: this.state.token,
	                //         idname: this.state.idname,
	                //         examid: data_arr,
	                //       };
	                //       FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
	                //         async resp_exam => {
	                //           if (resp_exam.success) {
	                //             var exam_data = resp_exam.examData;
	                //             var selectedmen = this.state.selectedmenu;
	                //             var isInArray_var = false;
	                //             isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
	                //               selectedmen,
	                //               exam_data,
	                //               this.state.type,
	                //             );
	                //             if (isInArray_var) {
	                //               this.setState({ showFreePremium: false });
	                //             } else {
	                //               this.setState({ showFreePremium: true });
	                //             }
	                //           } else {
	                //             console.log('fail');
	                //           }
	                //         },
	                //       );
	                //     }
	                //   } else {
	                //     if (resp.profileInfo.exam_selected === '') {
	                //       this.setState({ showFreePremium: true });
	                //     } else {
	                //       var data_arr = resp.profileInfo.exam_selected
	                //         ? JSON.parse(resp.profileInfo.exam_selected)
	                //         : null;
	                //       // console.log("dsarafaygdu", data_arr);
	                //
	                //       var dataset = {
	                //         token: this.state.token,
	                //         idname: this.state.idname,
	                //         examid: data_arr,
	                //       };
	                //       FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
	                //         resp_exam => {
	                //           if (resp_exam.success) {
	                //             var exam_data = resp_exam.examData;
	                //             var selectedmen = this.state.selectedmenu;
	                //             var isInArray_var = false;
	                //             isInArray_var = SoaP_SubscriptionCheck.checkSoaP_PDFSubscription(
	                //               selectedmen,
	                //               exam_data,
	                //               this.state.type,
	                //             );
	                //             if (isInArray_var) {
	                //               this.setState({ showFreePremium: false });
	                //             } else {
	                //               this.setState({ showFreePremium: true });
	                //             }
	                //           } else {
	                //             console.log('fail');
	                //           }
	                //         },
	                //       );
	                //     }
	                //   }
	                // });
	                //
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname'],
	                  chapter: this.state.chapterid
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getReadings', data).then(function (resp) {
	                  if (resp.success) {
	                    // console.log(resp);
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ readings: resp.readings });
	                    _this3.setState({ chapterName: resp.chaptername.chapter_name });
	                    if (!resp.readings.length) {
	                      _this3.setState({ no_result_display: 'No Saved Questions' });
	                    }
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                final_exam = [];
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	
	                this.dispose = (0, _mobx.autorun)(function () {
	                  var resp = _userStore2.default;
	                  if (resp == null || resp.profileInfo == null) {
	                    return;
	                  }
	                  // console.log("resp getProfile info", resp);
	                  if (resp.profileInfo.role === 'partner') {
	                    if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
	                      _this3.setState({
	                        showFreePremium: true,
	                        subscriptionstatus: 'free'
	                      });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(resp_exam) {
	                          var exam_data, selectedmen, isInArray_var;
	                          return _regenerator2.default.wrap(function _callee10$(_context10) {
	                            while (1) {
	                              switch (_context10.prev = _context10.next) {
	                                case 0:
	                                  if (!resp_exam.success) {
	                                    _context10.next = 10;
	                                    break;
	                                  }
	
	                                  exam_data = resp_exam.examData;
	                                  selectedmen = _this3.state.selectedmenu;
	                                  isInArray_var = false;
	                                  _context10.next = 6;
	                                  return _SoaPSubscription4.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                                case 6:
	                                  isInArray_var = _context10.sent;
	
	                                  if (isInArray_var) {
	                                    _this3.setState({ subscriptionstatus: 'paid' });
	                                  } else {
	                                    _this3.setState({ subscriptionstatus: 'free' });
	                                  }
	                                  _context10.next = 11;
	                                  break;
	
	                                case 10:
	                                  console.log('fail');
	
	                                case 11:
	                                case 'end':
	                                  return _context10.stop();
	                              }
	                            }
	                          }, _callee10, _this3);
	                        }));
	
	                        return function (_x10) {
	                          return _ref11.apply(this, arguments);
	                        };
	                      }());
	                    }
	                  } else {
	                    if (resp.profileInfo.exam_selected === '') {
	                      _this3.setState({
	                        showFreePremium: true,
	                        subscriptionstatus: 'free'
	                      });
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this3.state.token,
	                        idname: _this3.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        // console.log(resp_exam);
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this3.state.selectedmenu;
	                          var isInArray_var = false;
	                          isInArray_var = _SoaPSubscription2.default.checkSoaPSubscription(selectedmen, exam_data);
	                          // console.log(isInArray_var);
	                          if (isInArray_var) {
	                            _this3.setState({ subscriptionstatus: 'paid' });
	                          } else {
	                            _this3.setState({ subscriptionstatus: 'free' });
	                          }
	                        } else {
	                          console.log('fail');
	                        }
	                      });
	                    }
	                  }
	                });
	
	              case 14:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function componentDidMount() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    //it is use to redirect page
	
	
	    //Function to redirect page to question bank page
	
	
	    //Function to redirect page to viewquestions page
	
	  }, {
	    key: '_runCode',
	    value: function _runCode(subscriptionstatus, reading) {
	      var _this4 = this;
	
	      var data = {
	        token: this.state.token,
	        idname: this.state.idname,
	        reading_id: reading.id,
	        chapter_id: this.state.chapterid,
	        offset: 0,
	        limit: 1,
	        subscriptionstatus: subscriptionstatus
	      };
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestions', data).then(function (resp) {
	        if (resp.success) {
	          if (resp.questions.length) {
	            _this4.context.router.push({
	              pathname: '/soa/probability/viewquestions/' + reading.id + '/' + reading.chapter_no + '/' + reading.reading + '/' + _this4.state.chapterid + '/' + _this4.state.subscriptionstatus,
	              state: {
	                token: _this4.state.token,
	                idname: _this4.state.idname,
	                reading: reading,
	                chapter: _this4.state.chapterid,
	                subscriptionstatus: _this4.state.subscriptionstatus
	              }
	            });
	          } else {
	            _this4.toggleAlert();
	          }
	        }
	      });
	    }
	
	    //Function to redirect page on specifc questions
	
	    /*
	    ------------------------------
	    PDF DOWNLOAD  Question Via Email
	    -------------------------------
	    */
	
	
	    /*
	    ------------------------------
	    PDF DOWNLOAD  Question/Answer
	    -------------------------------
	    */
	
	  }, {
	    key: 'goPremium',
	    value: function goPremium() {
	      this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: this.state.token,
	          idname: this.state.idname,
	          selectedMenu: this.state.selectedmenu
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var readings = this.state.readings;
	      var data = '';
	
	      if (this.state.readings.length) {
	        data = readings.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              item.order_no,
	              '.'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.reading
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap margin_right_20' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/eye_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '23',
	                  onClick: _this5._getQuestions.bind(_this5, item),
	                  id: item.id,
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().VIEW_LIST
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip_wrap' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/open_book_icon.svg',
	                  className: 'pointer_class',
	                  alt: '',
	                  width: '21',
	                  id: item.id,
	                  onClick: _this5._beginChapter.bind(_this5, item),
	                  title: ''
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tootip_box' },
	                  _language2.default.LC().BEGIN_CHAPTER
	                )
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 margin_bottom_20' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'section_head' },
	                this.state.chapterName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 text-md-right margin_bottom_20 question-download-reading-page' },
	              _react2.default.createElement(
	                'span',
	                {
	                  onClick: this.getpdf.bind(this),
	                  className: 'status-download-btn margin_right_10'
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoading ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoading ? _language2.default.LC().Download_Question : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  onClick: this.getpdfAnswer.bind(this),
	                  className: 'status-download-btn margin_right_10'
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn btn-primary  pointer_class pull-right' },
	                  this.state.pdfLoadingAnswer ? _react2.default.createElement('i', { className: 'fa fa-download', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' }),
	                  this.state.showFreePremium ? _react2.default.createElement(
	                    'div',
	                    { className: 'premium-download' },
	                    _language2.default.LC().PREMIUM
	                  ) : null,
	                  this.state.pdfLoadingAnswer ? _language2.default.LC().Download_Question_Answer : '  please wait...'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getChapters
	                },
	                ' ',
	                _language2.default.LC().CHANGE_TOPIC,
	                ' '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card height_70vh' },
	                _react2.default.createElement('div', { className: 'card-header' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'table_responsive_wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'table-responsive reading-table-wrap' },
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table_white_bg table ' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          { className: 'border_top_0' },
	                          _react2.default.createElement(
	                            'th',
	                            { width: '90' },
	                            '#'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            _language2.default.LC().READING
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            { width: '130' },
	                            _language2.default.LC().ACTION
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        data
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            { toggle: this.toggleAlert },
	            this.state.MessageTitle
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            { className: 'd-flex justify-content-between align-items-center' },
	            this.state.MessageContent,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { color: 'primary', onClick: this.toggleAlert },
	              ' ',
	              _language2.default.LC().OK,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.PDFToggleAlert.bind(this),
	          alert_status: this.state.PDF_Alert_status,
	          MessageContent: this.state.PDFMessageContent,
	          exam: _constant.examNameAccordingToDB.SOA_P
	        }),
	        _react2.default.createElement(_PDFModel2.default, {
	          type: this.state.PDFDownloadType,
	          pdfAlertModel: this.pdfAlertModel.bind(this),
	          pdfAlert: this.state.PDFDownloadAlertStatus,
	          PDFContentMessage: this.state.PDFContentMessage
	        })
	      );
	    }
	  }]);
	
	  return SOA_P_Readings;
	}(_react.Component);
	
	SOA_P_Readings.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_P_Readings;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var Soa_p_savedquestion = function (_Component) {
	  _inherits(Soa_p_savedquestion, _Component);
	
	  function Soa_p_savedquestion(props) {
	    _classCallCheck(this, Soa_p_savedquestion);
	
	    var _this = _possibleConstructorReturn(this, (Soa_p_savedquestion.__proto__ || Object.getPrototypeOf(Soa_p_savedquestion)).call(this, props));
	
	    _this._deleteSavequestino = function (items, e) {
	      _this.setState({ items_val: items });
	      _this.toggleAlert('savedquestion');
	    };
	
	    _this._getDashboard = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/dashboard/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      var data = {
	        token: _this.state.token,
	        idname: _this.state.idname,
	        question_id: item.question_id
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestionsbyid', data).then(function (resp) {
	        if (resp.success) {
	          _this.context.router.push({
	            pathname: '/soa/probability/beginchapter/' + resp.questionsbyid.chapter_id + '/' + resp.questionsbyid.reading_id + '/' + item.question_id,
	            state: {
	              token: _this.state.token,
	              idname: _this.state.idname,
	              reading: resp.questionsbyid.reading_id,
	              chapter: resp.questionsbyid.chapter_id
	            }
	          });
	        } else {
	          console.log('Not Found');
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageContent: '' + _language2.default.LC().ARE_YOU_SURE_TO_DELETE_THIS,
	      MessageTitle: '' + _language2.default.LC().CONFIRMATION_BOX,
	      items_val: '',
	      item_status: '',
	      questions: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      savedquestion: [],
	      no_restult_display: '',
	      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
	      viewCSS: 'fa fa-eye mark-action-btn-dashboard'
	    };
	    _this.toggleAlert = _this.toggleAlert.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.toggleClose = _this.toggleClose.bind(_this);
	    _this.toggleDone = _this.toggleDone.bind(_this);
	    return _this;
	  }
	
	  _createClass(Soa_p_savedquestion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      if (storage_session) {
	        this.setState({
	          idname: storage_session['idname'],
	          token: storage_session['token']
	        });
	      }
	      this.props.location.state ? this.setState({ username: this.props.location.state.username }) : null;
	      var data = {
	        idname: storage_session['idname'],
	        token: storage_session['token']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getFavQuestionsbyuserid', data).then(function (resp) {
	        if (resp.success) {
	          _this2.setState({ savedquestion: resp.questions });
	          if (!resp.questions.length) {
	            _this2.setState({
	              no_restult_display: '' + _language2.default.LC().NO_SAVED_QUESTIONS
	            });
	          }
	        } else {
	          console.log(resp.success + '------------failure');
	        }
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        dropdownOpen: !this.state.dropdownOpen
	      });
	    }
	  }, {
	    key: 'toggleAlert',
	    value: function toggleAlert(card) {
	      // console.log(card)
	      this.setState({
	        alert_status: !this.state.alert_status,
	        item_status: card
	      });
	    }
	  }, {
	    key: 'toggleClose',
	    value: function toggleClose() {
	      this.setState({
	        alert_status: !this.state.alert_status,
	        items_val: '',
	        item_status: ''
	      });
	    }
	  }, {
	    key: 'toggleDone',
	    value: function toggleDone() {
	      var _this3 = this;
	
	      if (this.state.item_status === 'savedquestion') {
	        var data = {
	          token: this.state.token,
	          idname: this.state.idname,
	          save_question: this.state.items_val
	        };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/deleteSavequestion', data).then(function (resp) {
	          if (resp.success) {
	            document.getElementById('savedque_' + _this3.state.items_val.id).remove();
	          } else {
	            console.log('error');
	          }
	        });
	      }
	      this.setState({
	        alert_status: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var savedquestion_val = this.state.savedquestion;
	      var savedquestion_data = '';
	      if (this.state.savedquestion.length) {
	        savedquestion_data = savedquestion_val.map(function (items, index) {
	          return _react2.default.createElement(
	            'div',
	            { id: 'savedque_' + items.id, key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'flash_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row  align-items-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-8' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      ' ',
	                      _language2.default.LC().QUESTION_ID
	                    ),
	                    ':',
	                    ' ',
	                    items.question_id
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'margin_left_15 text_light margin_bottom_0' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      _language2.default.LC().TOPIC,
	                      ': '
	                    ),
	                    ' ',
	                    items.topic_name
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-4 text-right xl-text-left' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().VIEW,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._beginChapter.bind(_this4, items),
	                        className: _this4.state.viewCSS,
	                        style: { color: '#1f8ceb' }
	                      },
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'up tooltip-hover-questions',
	                      style: { padding: '10px' }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tootip_box' },
	                      ' ',
	                      _language2.default.LC().DELETE,
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'i',
	                      {
	                        onClick: _this4._deleteSavequestino.bind(_this4, items),
	                        className: _this4.state.deleteCSS,
	                        style: { color: '#f51a00' }
	                      },
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          );
	        });
	      } else {
	        savedquestion_data = _react2.default.createElement(
	          'div',
	          { className: 'horizontal_mid card-block text-center text_light' },
	          _language2.default.LC().NO_SAVED_QUESTIONS
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().MY_SAVED_QUESTIONS,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text_light margin_left_15' },
	                _language2.default.LC().PICK_THE_QUESTION_YOU_WANT_TO_REVIEW,
	                ' :',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class',
	                  onClick: this._getDashboard.bind(this)
	                },
	                _language2.default.LC().DASHBOARD
	              ),
	              '\xA0\xA0',
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class margin_left_15',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                _language2.default.LC().PROFILE
	              )
	            )
	          ),
	          savedquestion_data
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.alert_status,
	            toggle: this.toggleAlert,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            _language2.default.LC().ALERT,
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', onClick: this.toggleClose },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.MessageContent
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-primary',
	                  color: 'primary',
	                  onClick: this.toggleDone
	                },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Soa_p_savedquestion;
	}(_react.Component);
	
	Soa_p_savedquestion.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = Soa_p_savedquestion;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CircularTooltip(_ref) {
	  var tooltipContent = _ref.tooltipContent,
	      children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'up tooltip-hover-questions padding-10px ' + className },
	    _react2.default.createElement(
	      'div',
	      { className: 'tootip_box' },
	      ' ',
	      tooltipContent,
	      ' '
	    ),
	    children
	  );
	}
	
	exports.default = CircularTooltip;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoFooter = __webpack_require__(888);
	
	var _VideoFooter2 = _interopRequireDefault(_VideoFooter);
	
	var _VideoReport = __webpack_require__(889);
	
	var _VideoReport2 = _interopRequireDefault(_VideoReport);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _constant = __webpack_require__(9);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoDisplayUI(_ref) {
	  var videoList = _ref.videoList,
	      showFreePremium = _ref.showFreePremium,
	      videoId = _ref.videoId,
	      isFlashCardHidden = _ref.isFlashCardHidden,
	      setChildRef = _ref.setChildRef,
	      title = _ref.title,
	      urlId = _ref.urlId,
	      urlIdQq = _ref.urlIdQq,
	      pdfFile = _ref.pdfFile,
	      chapterName = _ref.chapterName,
	      getVideoUrl = _ref.getVideoUrl,
	      goToPreviousVideo = _ref.goToPreviousVideo,
	      goToNextVideo = _ref.goToNextVideo,
	      moveToNotes = _ref.moveToNotes,
	      moveToPracticeQuestion = _ref.moveToPracticeQuestion,
	      saveVideo = _ref.saveVideo,
	      onReportVideo = _ref.onReportVideo,
	      onViewPDF = _ref.onViewPDF,
	      reportLoading = _ref.reportLoading,
	      successAlert = _ref.successAlert,
	      toggleReportSection = _ref.toggleReportSection,
	      isReportSectionOpen = _ref.isReportSectionOpen,
	      setContent = _ref.setContent,
	      isVideoSaved = _ref.isVideoSaved,
	      reportContent = _ref.reportContent,
	      showPremiumModel = _ref.showPremiumModel,
	      checkSubscription = _ref.checkSubscription,
	      toggleAlert = _ref.toggleAlert,
	      goPremium = _ref.goPremium,
	      moveToVideoLessons = _ref.moveToVideoLessons;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'd-flex justify-content-between' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        ' ',
	        chapterName
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'btn btn-primary pointer_class height-fit-content',
	          onClick: moveToVideoLessons
	        },
	        'Back to Videos'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'video_outer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex justify-content-between' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'float-right text-right' },
	              _react2.default.createElement('i', { className: 'fa fa-angle-left ques_arrow pointer_class', onClick: goToNextVideo }),
	              _react2.default.createElement('i', {
	                className: 'fa fa-angle-right ques_arrow pointer_class',
	                onClick: goToPreviousVideo
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'videos-main-wraper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row videos-main-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-9 col-md-9 video-show-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'iframe-wraper' },
	              urlIdQq ? _react2.default.createElement('iframe', {
	                className: 'embed-responsive-item',
	                allowFullScreen: true,
	                width: '100%',
	                height: '100%',
	                position: 'absolute',
	                top: '10',
	                left: '0',
	                src: (0, _constant.flowPlayerVideoDisplayUrl)(urlIdQq),
	                sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                title: '0',
	                byline: '0',
	                portrait: '0',
	                frameborder: '10'
	              }) : _react2.default.createElement('iframe', {
	                width: '100%',
	                allowFullScreen: '1',
	                height: '100%',
	                src: 'https://www.youtube.com/embed/' + urlId + '?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 ',
	                sandbox: 'allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation',
	                frameBorder: '0'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-3 col-md-3 video-tag-heading' },
	            _react2.default.createElement(
	              'div',
	              { className: 'link_list_wrap' },
	              videoList.map(function (item, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: item.id },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'full-width', key: item.id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'videotitle', key: item.id, value: item.id },
	                      showFreePremium === 'true' || showFreePremium === true ? item.free === 1 ? _react2.default.createElement(
	                        'div',
	                        { className: 'video-type-free' },
	                        'Free'
	                      ) : _react2.default.createElement(
	                        'div',
	                        { className: 'video-type-primum' },
	                        'Premium'
	                      ) : _react2.default.createElement('div', null),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          name: 'videourl',
	                          id: item.id,
	                          className: item.id === videoId ? 'active' : '',
	                          onClick: function onClick() {
	                            return getVideoUrl(index);
	                          },
	                          value: item.url
	                        },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'text-overflow' },
	                          item.title
	                        )
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_VideoFooter2.default, {
	      rowClassName: 'my-3',
	      moveToNotes: moveToNotes,
	      moveToPracticeQuestion: moveToPracticeQuestion,
	      saveVideo: saveVideo,
	      onViewPDF: onViewPDF,
	      isVideoSaved: isVideoSaved,
	      videoId: videoId,
	      pdfFile: pdfFile,
	      toggleReportSection: toggleReportSection,
	      showFreePremium: showFreePremium,
	      checkSubscription: checkSubscription
	    }),
	    _react2.default.createElement('br', null),
	    ' ',
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(_FlashCard2.default, {
	      item: { id: videoId },
	      type: 'video',
	      isFlashCardHidden: isFlashCardHidden,
	      ref: setChildRef,
	      exam: 'soa_p'
	    }),
	    isReportSectionOpen ? _react2.default.createElement(_VideoReport2.default, {
	      videoId: videoId,
	      reportLoading: reportLoading,
	      successAlert: successAlert,
	      toggleReportSection: toggleReportSection,
	      setContent: setContent,
	      reportContent: reportContent,
	      onReportVideo: onReportVideo
	    }) : null,
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Modal2.default, {
	        goPremium: goPremium,
	        toggleAlert: toggleAlert,
	        alert_status: showPremiumModel,
	        MessageContent: _alertMessage2.default.messageContent_soa_p,
	        exam: _constant.examNameAccordingToDB.SOA_P
	      })
	    )
	  );
	}
	
	exports.default = VideoDisplayUI;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _CircularTooltip = __webpack_require__(886);
	
	var _CircularTooltip2 = _interopRequireDefault(_CircularTooltip);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoFooter(_ref) {
	  var _ref$rowClassName = _ref.rowClassName,
	      rowClassName = _ref$rowClassName === undefined ? '' : _ref$rowClassName,
	      _ref$showFreePremium = _ref.showFreePremium,
	      showFreePremium = _ref$showFreePremium === undefined ? true : _ref$showFreePremium,
	      moveToNotes = _ref.moveToNotes,
	      moveToPracticeQuestion = _ref.moveToPracticeQuestion,
	      saveVideo = _ref.saveVideo,
	      toggleReportSection = _ref.toggleReportSection,
	      onViewPDF = _ref.onViewPDF,
	      videoId = _ref.videoId,
	      isVideoSaved = _ref.isVideoSaved,
	      pdfFile = _ref.pdfFile,
	      checkSubscription = _ref.checkSubscription;
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    { className: rowClassName },
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { xs: '12', md: '6', className: 'd-flex' },
	      _react2.default.createElement(
	        _CircularTooltip2.default,
	        { tooltipContent: 'Go to Notes', className: 'pl-0' },
	        _react2.default.createElement('i', {
	          onClick: function onClick() {
	            return checkSubscription(moveToNotes);
	          },
	          className: 'fa fa-book mark-action-btn',
	          style: { color: '#1f8ceb' }
	        })
	      ),
	      _react2.default.createElement(
	        _CircularTooltip2.default,
	        { tooltipContent: 'Go to Question Bank' },
	        _react2.default.createElement('i', {
	          onClick: moveToPracticeQuestion,
	          className: 'fa fa-question-circle-o mark-action-btn',
	          style: { color: '#1d364b' }
	        })
	      ),
	      _react2.default.createElement(
	        _CircularTooltip2.default,
	        { tooltipContent: 'Save this item on your dashboard for further review.' },
	        _react2.default.createElement('i', {
	          onClick: function onClick() {
	            return saveVideo(videoId);
	          },
	          className: isVideoSaved ? 'fa fa-bookmark mark-action-btn-bookmark' : 'fa fa-bookmark-o mark-action-btn-bookmark',
	          style: { color: isVideoSaved ? 'rgb(54, 141, 84)' : '#1d364b' }
	        })
	      ),
	      _react2.default.createElement(
	        _CircularTooltip2.default,
	        { tooltipContent: "Report this video to AnalystPrep's team for review." },
	        _react2.default.createElement(
	          'span',
	          { className: 'mark-action-btn' },
	          _react2.default.createElement('img', {
	            src: _App_data2.default.frontend_url + '/img/report4.png',
	            alt: 'report',
	            onClick: toggleReportSection,
	            className: '',
	            style: { color: '#ef2100' }
	          })
	        )
	      )
	    ),
	    pdfFile ? _react2.default.createElement(
	      _reactstrap.Col,
	      { xs: '12', md: '6', className: 'padding-10px' },
	      _react2.default.createElement(
	        'div',
	        { className: 'status-download-btn' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn-primary  pointer_class pull-right',
	            onClick: function onClick() {
	              return checkSubscription(onViewPDF);
	            }
	          },
	          _react2.default.createElement('i', { className: 'fa fa-download  ', 'aria-hidden': 'true' }),
	          showFreePremium ? _react2.default.createElement(
	            'div',
	            { className: 'premium-download' },
	            'Premium'
	          ) : null,
	          'View PDF'
	        )
	      )
	    ) : null
	  );
	}
	
	exports.default = VideoFooter;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoReport(_ref) {
	  var videoId = _ref.videoId,
	      setContent = _ref.setContent,
	      successAlert = _ref.successAlert,
	      reportLoading = _ref.reportLoading,
	      reportContent = _ref.reportContent,
	      onReportVideo = _ref.onReportVideo,
	      toggleReportSection = _ref.toggleReportSection;
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Col,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header' },
	          'Report'
	        ),
	        !successAlert ? _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            'label',
	            { className: 'form-control-label', htmlFor: 'textarea-input' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Comment'
	            )
	          ),
	          _react2.default.createElement('textarea', {
	            id: 'comment',
	            name: 'comment',
	            rows: '6',
	            className: 'form-control',
	            placeholder: 'Content..',
	            onBlur: setContent,
	            value: reportContent
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'mt-1' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary active pointer_class report-btn',
	                disabled: reportLoading,
	                onClick: function onClick() {
	                  return onReportVideo(videoId);
	                }
	              },
	              reportLoading ? 'Please Wait' : 'Report'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-danger active pointer_class margin_left_10',
	                onClick: toggleReportSection
	              },
	              'Cancel'
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'report-Success-card card-block' },
	          _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/success-ic.svg', alt: '' }),
	          _react2.default.createElement(
	            'label',
	            { className: 'form-control-label', htmlFor: 'textarea-input' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              ' Your report has been submitted successfully.'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-primary active pointer_class  min-vw-120',
	              onClick: toggleReportSection
	            },
	            'Close'
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = VideoReport;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoDisplay = undefined;
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(10);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _VideoDisplayUI = __webpack_require__(887);
	
	var _VideoDisplayUI2 = _interopRequireDefault(_VideoDisplayUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoDisplay = exports.VideoDisplay = function (_Component) {
	  _inherits(VideoDisplay, _Component);
	
	  function VideoDisplay(props) {
	    _classCallCheck(this, VideoDisplay);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (VideoDisplay.__proto__ || Object.getPrototypeOf(VideoDisplay)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _props$params = props.params,
	        _props$params$chapter = _props$params.chapterId,
	        chapterId = _props$params$chapter === undefined ? 1 : _props$params$chapter,
	        id = _props$params.id,
	        _props$params$index = _props$params.index,
	        index = _props$params$index === undefined ? 0 : _props$params$index;
	
	    _this.state = {
	      index: index,
	      chapterId: chapterId,
	      showFreePremium: true,
	      videoId: id,
	      videoList: [],
	      fistVideoData: {},
	      showLoader: true,
	      title: 'Title',
	      urlId: 'URL ID',
	      urlIdQq: '',
	      chapterName: 'Chapter Name',
	      pdfFile: null,
	      errorMessage: '',
	      isReportSectionOpen: false,
	      reportContent: '',
	      isVideoSaved: false,
	      showPremiumModel: false,
	      showPremiumLoader: true,
	      isFlashCardHidden: true
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(VideoDisplay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var chapterId = this.state.chapterId;
	
	      var data = (0, _function.getRequestAPIData)({ chapter_id: chapterId });
	      this.getChapterWiseVideoList(data);
	      this.getChapterData(data);
	      this.getProfileInfo(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          videoList = _state.videoList,
	          showFreePremium = _state.showFreePremium,
	          videoId = _state.videoId,
	          title = _state.title,
	          urlId = _state.urlId,
	          urlIdQq = _state.urlIdQq,
	          pdfFile = _state.pdfFile,
	          showLoader = _state.showLoader,
	          chapterName = _state.chapterName,
	          errorMessage = _state.errorMessage,
	          successAlert = _state.successAlert,
	          isReportSectionOpen = _state.isReportSectionOpen,
	          isVideoSaved = _state.isVideoSaved,
	          showPremiumModel = _state.showPremiumModel,
	          showPremiumLoader = _state.showPremiumLoader,
	          isFlashCardHidden = _state.isFlashCardHidden;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn coming_soon_wrap' },
	        showPremiumLoader || showLoader ? _react2.default.createElement(_loader2.default, null) : errorMessage ? _react2.default.createElement(
	          'h4',
	          null,
	          errorMessage
	        ) : videoList.length ? _react2.default.createElement(_VideoDisplayUI2.default, {
	          videoList: videoList,
	          showFreePremium: showFreePremium,
	          videoId: videoId,
	          isFlashCardHidden: isFlashCardHidden,
	          setChildRef: this.setChildRef,
	          title: title,
	          urlId: urlId,
	          urlIdQq: urlIdQq,
	          pdfFile: pdfFile,
	          chapterName: chapterName,
	          getVideoUrl: this.getVideoUrl,
	          goToPreviousVideo: this.goToPreviousVideo,
	          goToNextVideo: this.goToNextVideo,
	          moveToNotes: this.moveToNotes,
	          moveToPracticeQuestion: this.moveToPracticeQuestion,
	          saveVideo: this.saveVideo,
	          reportVideo: this.reportVideo,
	          onViewPDF: this.onViewPDF,
	          isVideoSaved: isVideoSaved,
	          successAlert: successAlert,
	          showPremiumModel: showPremiumModel,
	          checkSubscription: this.checkSubscription,
	          toggleReportSection: function toggleReportSection() {
	            return _this2.setState({ isReportSectionOpen: !isReportSectionOpen });
	          },
	          isReportSectionOpen: isReportSectionOpen,
	          setContent: function setContent(event) {
	            _this2.setState({ reportContent: event.target.value });
	          },
	          onReportVideo: this.onReportVideo,
	          toggleAlert: this.toggleAlert,
	          goPremium: this.goPremium,
	          moveToVideoLessons: function moveToVideoLessons() {
	            return _this2.context.router.push({ pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_LESSONS });
	          }
	        }) : _react2.default.createElement(
	          'h4',
	          null,
	          'No Data Found'
	        )
	      );
	    }
	  }]);
	
	  return VideoDisplay;
	}(_react.Component);
	
	VideoDisplay.contextTypes = { router: _react2.default.PropTypes.object };
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getProfileInfo = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	      var response, exam_selected, dataObject, _data;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data);
	
	            case 3:
	              response = _context.sent;
	
	              if (response.success === true || response.success === 'true') {
	                exam_selected = response.profileInfo.exam_selected;
	                // if (exam_selected === '') {
	                //   return this.toggleAlert();
	                // } else {
	
	                dataObject = exam_selected ? JSON.parse(exam_selected) : null;
	                _data = (0, _function.getRequestAPIData)({ examid: dataObject });
	
	                _this3.getExamsByUser(_data);
	                // }
	              }
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              _this3.setState({
	                showLoader: false,
	                errorMessage: _context.t0.message
	              });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3, [[0, 7]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  this.getExamsByUser = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	      var response, examData, isContentAccessible;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', data);
	
	            case 2:
	              response = _context2.sent;
	
	              if (response.success) {
	                examData = response.examData;
	                isContentAccessible = false;
	
	                isContentAccessible = _SoaPSubscription2.default.checkSoaPVideosSubscription('soa_p', examData);
	                if (isContentAccessible) {
	                  _this3.setState({ showFreePremium: false });
	                }
	                _this3.setState({ showPremiumLoader: false });
	              }
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this3);
	    }));
	
	    return function (_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  this.getChapterWiseVideoList = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	      var response, fistVideoData, videoList, index;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getSoaPVideosChapterwise', data);
	
	            case 3:
	              response = _context3.sent;
	
	              if (response.success === true || response.success === 'true') {
	                fistVideoData = response.soapvchapterfirst, videoList = response.soapvchapter;
	
	                _this3.setState({
	                  videoList: videoList,
	                  fistVideoData: fistVideoData
	                });
	                index = _this3.state.index;
	
	                _this3.setVideoState(videoList[index], index);
	              } else {
	                _this3.setState({ errorMessage: response.message });
	              }
	              _this3.setState({ showLoader: false });
	              _context3.next = 11;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3['catch'](0);
	
	              _this3.setState({
	                showLoader: false,
	                errorMessage: _context3.t0.message
	              });
	
	            case 11:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this3, [[0, 8]]);
	    }));
	
	    return function (_x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  this.getChapterData = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	      var response, chapterId, chapterDetails;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	              _context4.next = 3;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getSoaPVideos', data);
	
	            case 3:
	              response = _context4.sent;
	              chapterId = _this3.state.chapterId;
	
	              if (response.success === true || response.success === 'true') {
	                chapterDetails = response.soapvideo.find(function (element) {
	                  return parseInt(element.chapter_no, 10) === parseInt(chapterId, 10);
	                });
	
	                if (chapterDetails) _this3.setState({ chapterName: chapterDetails.chapter_name });
	              } else {
	                _this3.setState({ errorMessage: response.message });
	              }
	              _context4.next = 11;
	              break;
	
	            case 8:
	              _context4.prev = 8;
	              _context4.t0 = _context4['catch'](0);
	
	              _this3.setState({
	                showLoader: false,
	                errorMessage: _context4.t0.message
	              });
	
	            case 11:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this3, [[0, 8]]);
	    }));
	
	    return function (_x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  this.getSavedVideo = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(videoId) {
	      var data, response;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.prev = 0;
	              data = (0, _function.getRequestAPIData)({ question_id: videoId });
	              _context5.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getFavVideo', data);
	
	            case 4:
	              response = _context5.sent;
	
	              if (response.success) {
	                _this3.setState({ isVideoSaved: true, isFlashCardHidden: false });
	              } else {
	                _this3.setState({ isFlashCardHidden: true });
	              }
	              _context5.next = 11;
	              break;
	
	            case 8:
	              _context5.prev = 8;
	              _context5.t0 = _context5['catch'](0);
	
	              _this3.setState({ errorMessage: _context5.t0.message });
	
	            case 11:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this3, [[0, 8]]);
	    }));
	
	    return function (_x5) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  this.setVideoState = function (item, index) {
	    _this3.setState({
	      videoId: item.id,
	      title: item.title,
	      urlId: item.url_id,
	      urlIdQq: item.url_id_qq,
	      pdfFile: item.pdf_file,
	      index: index,
	      successAlert: false,
	      isVideoSaved: false,
	      isReportSectionOpen: false
	    });
	    _this3.getSavedVideo(item.id);
	  };
	
	  this.redirectToURL = function (item, index) {
	    var _state2 = _this3.state,
	        chapterId = _state2.chapterId,
	        showFreePremium = _state2.showFreePremium;
	
	    _this3.context.router.push({
	      pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', item.id).replace(':showFreePremium', showFreePremium).replace(':index', index).replace(':chapterId', chapterId)
	    });
	  };
	
	  this.goToNextVideo = function () {
	    var index = _this3.state.index;
	
	    _this3.redirectToVideo(parseInt(index, 10) - 1);
	  };
	
	  this.goToPreviousVideo = function () {
	    var index = _this3.state.index;
	
	    _this3.redirectToVideo(parseInt(index, 10) + 1);
	  };
	
	  this.getVideoUrl = function (index) {
	    _this3.redirectToVideo(index);
	  };
	
	  this.moveToNotes = function () {
	    var chapterId = _this3.state.chapterId;
	
	    _this3.context.router.push({
	      pathname: _AppRoutes2.default.SOA_PROBABILITY_NOTES_READING.replace('(/:chapter)', '/' + chapterId)
	    });
	  };
	
	  this.moveToPracticeQuestion = function () {
	    var _state3 = _this3.state,
	        chapterId = _state3.chapterId,
	        chapterName = _state3.chapterName;
	
	    _this3.context.router.push({
	      pathname: _AppRoutes2.default.SOA_PROBABILITY_READING.replace('(/:chapter)', '/' + chapterId).replace('(/:chapterName)', '/' + chapterName)
	    });
	  };
	
	  this.saveVideo = function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(videoId) {
	      var data, response, _response;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              data = (0, _function.getRequestAPIData)({ video_id: videoId });
	
	              if (!_this3.state.isVideoSaved) {
	                _context6.next = 9;
	                break;
	              }
	
	              _context6.next = 4;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/unsaveFavVideoByUserID', data);
	
	            case 4:
	              response = _context6.sent;
	
	
	              if (response.success) {
	                if (_this3.childRef) {
	                  _this3.childRef.deleteFlash();
	                }
	                _this3.setState({ isVideoSaved: false, isFlashCardHidden: true });
	              }
	              return _context6.abrupt('return', response);
	
	            case 9:
	              _context6.next = 11;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/saveFavVideoByUserID', data);
	
	            case 11:
	              _response = _context6.sent;
	
	              if (_response.success) {
	                _this3.setState({
	                  isVideoSaved: true,
	                  isFlashCardHidden: false
	                });
	              } else {
	                _this3.setState({ isFlashCardHidden: true });
	              }
	              return _context6.abrupt('return', _response);
	
	            case 14:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this3);
	    }));
	
	    return function (_x6) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  this.onReportVideo = function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(videoId) {
	      var _state4, index, reportContent, data, response;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _this3.setState({ reportLoading: true });
	              _state4 = _this3.state, index = _state4.index, reportContent = _state4.reportContent;
	              data = (0, _function.getRequestAPIData)({
	                videoIndex: index,
	                video_id: videoId,
	                comment: reportContent
	              });
	              _context7.next = 5;
	              return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/videoReportQuestion', data);
	
	            case 5:
	              response = _context7.sent;
	
	              if (response.success) {
	                _this3.setState({
	                  successAlert: true,
	                  reportLoading: false
	                });
	              }
	
	            case 7:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this3);
	    }));
	
	    return function (_x7) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  this.onViewPDF = function () {
	    var pdfFile = _this3.state.pdfFile;
	
	    var myWindow = window.open(pdfFile);
	    myWindow.focus();
	  };
	
	  this.toggleAlert = function () {
	    _this3.setState({ showPremiumModel: !_this3.state.showPremiumModel });
	  };
	
	  this.checkSubscription = function (func, condition) {
	    var showFreePremium = _this3.state.showFreePremium;
	
	    if (condition !== 1 && (showFreePremium === true || showFreePremium === 'true')) {
	      _this3.toggleAlert();
	      return;
	    }
	    return func();
	  };
	
	  this.redirectToVideo = function (index) {
	    var videoList = _this3.state.videoList;
	
	    var videoData = videoList[index];
	    _this3.checkSubscription(function () {
	      _this3.setVideoState(videoData, index);
	      _this3.redirectToURL(videoData, index);
	    }, videoData.free);
	  };
	
	  this.goPremium = function () {
	    _this3.context.router.push({ pathname: '/Subscribe/' });
	  };
	};
	
	exports.default = VideoDisplay;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reactSlick = __webpack_require__(34);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(1014);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _constant = __webpack_require__(9);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {autorun} from "mobx";
	
	
	/* eslint-disable*/
	
	var SOA_P_VideoLessons = function (_Component) {
	  _inherits(SOA_P_VideoLessons, _Component);
	
	  function SOA_P_VideoLessons(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_VideoLessons);
	
	    window.scrollTo(0, 0);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_VideoLessons.__proto__ || Object.getPrototypeOf(SOA_P_VideoLessons)).call(this, props));
	
	    _this.toggleAlert = function () {
	      _this.setState({
	        alert_status: !_this.state.alert_status
	      });
	    };
	
	    _this.goPremium = function () {
	      _this.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: _this.state.selectedmenu
	        }
	      });
	    };
	
	    _this._getReadings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(chapter, e) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY,
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: chapter,
	                    showFreePremium: _this.state.showFreePremium,
	                    type: 'notintro'
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.iframe = {
	      padding: 10
	    };
	    _this.goToVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$state, lastRecord, lastAttempt, videoIndex, soa_p_video;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$state = _this.state, lastRecord = _this$state.lastRecord, lastAttempt = _this$state.lastAttempt;
	
	              if (lastAttempt) {
	                videoIndex = lastRecord.videoIndex, soa_p_video = lastRecord.soa_p_video;
	
	                _this.context.router.push({
	                  pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', id).replace(':showFreePremium', _this.state.showFreePremium).replace(':index', index).replace(':chapterId', chapterId),
	                  state: {
	                    token: _this.state.token,
	                    idname: _this.state.idname,
	                    chapter: lastRecord.soa_p_video,
	                    index: lastRecord.videoIndex,
	                    showFreePremium: _this.state.showFreePremium
	                  }
	                });
	              }
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    var messageTitle_soa_p = '<i class="icon-info icons font-2xl d-block "></i>';
	    _this.state = {
	      alert_status: false,
	      MessageTitle: messageTitle_soa_p,
	      MessageContent: _alertMessage2.default.messageContent_soa_p,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      Allchapters: [],
	      itemData: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      showFreePremium: '',
	      selectedmenu: 'soa_p',
	      exams: [],
	      lastRecord: '',
	      lastAttempt: false
	    };
	    return _this;
	  }
	
	  _createClass(SOA_P_VideoLessons, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidUpdate() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var storage_session, data, dataExam, data_data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                });
	                if (localStorage.getItem('selectedmenu') == 'frm') {
	                  this.context.router.push({
	                    pathname: '/frm/questionbank/',
	                    state: {
	                      token: storage_session['token'],
	                      idname: storage_session['idname']
	                    }
	                  });
	                }
	
	                data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                //!!! Some sheet with dispose. It seems like early dispose autorun caused some concurrent state change caused trouble in this component!!! Need refactor all
	                // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
	
	                _context5.next = 6;
	                return _userStore2.default.getUserProfile(true).then(function () {
	                  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context4.next = 4;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context4.next = 8;
	                            break;
	
	                          case 4:
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              token: _this3.state.token,
	                              idname: _this3.state.idname,
	                              examid: data_arr
	                            };
	                            _context4.next = 8;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                              if (resp_exam.success) {
	                                var exam_data = resp_exam.examData;
	                                var selectedmen = _this3.state.selectedmenu;
	                                var isInArray_var = false;
	                                isInArray_var = _SoaPSubscription2.default.checkSoaPVideosSubscription(selectedmen, exam_data);
	                                // console.log('I am here in package', isInArray_var);
	                                if (isInArray_var) {
	                                  _this3.setState({ showFreePremium: false });
	                                } else {
	                                  _this3.setState({ showFreePremium: true });
	                                }
	                              } else {
	                                // console.log('fail');
	                              }
	                            });
	
	                          case 8:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this3);
	                  }));
	
	                  return function (_x3) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	
	              case 6:
	                dataExam = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExams', dataExam).then(function (resp) {
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true, exams: resp.exams[0] });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context5.next = 11;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getSoaPVideos', data_data).then(function (resp) {
	                  if (resp.success) {
	                    console.log(resp);
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ chapters: resp.soapvideo });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  // return resp;
	                });
	
	              case 11:
	                data_data = {
	                  token: storage_session['token'],
	                  idname: storage_session['idname']
	                };
	                _context5.next = 14;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getLastViewedVideo', data_data).then(function (response) {
	                  console.log('hvedf', response);
	                  if (response.success) {
	                    _this3.setState({
	                      lastRecord: response.data,
	                      lastAttempt: true
	                    });
	                  }
	                });
	
	              case 14:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dispose) this.dispose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var domainApp = localStorage.getItem('domainApp');
	      //console.log(language.LC())
	      //console.log(this.state.showFreePremium);
	      var lastAttempt = this.state.lastAttempt;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      var chapters = this.state.chapters;
	      var exam = this.state.exams;
	      // console.log(this.state.chapters);
	      var data = '';
	      if (this.state.chapters.length) {
	        data = chapters.map(function (item, index) {
	          return item.Countvideos > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12', key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-header card_header_bg', value: item.id },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'pointer_class',
	                    id: item.chapter_name,
	                    value: item.id,
	                    onClick: _this4._getReadings.bind(_this4, item)
	                  },
	                  _language2.default.LC().CHAPTER,
	                  ' ',
	                  item.chapter_no,
	                  ' - ',
	                  item.chapter_name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-block list_icon_outer', key: item.chapter_name },
	                item.Countvideos > 0 ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _language2.default.LC().TOTAL_VIDEOS,
	                  ': ',
	                  item.Countvideos
	                ) : _react2.default.createElement('p', null),
	                _react2.default.createElement(
	                  'div',
	                  { key: index, className: 'col-xs-12 col-sm-12 col-md-12' },
	                  _react2.default.createElement(ChatperwiseReadingData, {
	                    key: item.id,
	                    item: item,
	                    showFreePremium: _this4.state.showFreePremium
	                  })
	                )
	              )
	            )
	          ) : null;
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'video_lesson_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'margin_bottom_20 d-flex justify-content-between last_question_read' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              ' ',
	              _language2.default.LC().VIDEO_LESSONS,
	              ' '
	            ),
	            lastAttempt ? _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: this.goToVideo.bind(this),
	                disabled: !lastAttempt
	              },
	              ' ',
	              _language2.default.LC().GO_TO_MY_LAST_VIDEO_VIEWED,
	              ' '
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-12 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bank_wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  data
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Modal2.default, {
	            goPremium: this.goPremium.bind(this),
	            toggleAlert: this.toggleAlert.bind(this),
	            alert_status: this.state.alert_status,
	            MessageContent: this.state.MessageContent,
	            exam: _constant.examNameAccordingToDB.SOA_P
	          })
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_VideoLessons;
	}(_react.Component);
	
	SOA_P_VideoLessons.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	
	
	function SampleNextArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: Object.assign({}, style, { display: 'block' }), onClick: onClick },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/right-arrow.svg', alt: '' })
	  );
	}
	
	function SamplePrevArrow(props) {
	  var className = props.className,
	      style = props.style,
	      onClick = props.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: Object.assign({}, style, {
	        display: 'block',
	        fontSize: '60px',
	        right: '80px',
	        zIndex: '15',
	        height: '20px',
	        width: '40px',
	        opacity: '1'
	      }),
	      onClick: onClick
	    },
	    _react2.default.createElement('img', { onClick: onClick, src: '../../assets/img/left-arrow.svg', alt: '' })
	  );
	}
	
	var ChatperwiseReadingData = function (_Component2) {
	  _inherits(ChatperwiseReadingData, _Component2);
	
	  function ChatperwiseReadingData(props) {
	    var _this6 = this,
	        _this5$state2;
	
	    _classCallCheck(this, ChatperwiseReadingData);
	
	    var _this5 = _possibleConstructorReturn(this, (ChatperwiseReadingData.__proto__ || Object.getPrototypeOf(ChatperwiseReadingData)).call(this, props));
	
	    _this5.toggleAlert = function () {
	      _this5.setState({
	        alert_status: !_this5.state.alert_status
	      });
	    };
	
	    _this5.goPremium = function () {
	      _this5.context.router.push({
	        pathname: '/Subscribe/',
	        state: {
	          token: _this5.state.token,
	          idname: _this5.state.idname,
	          selectedMenu: _this5.state.selectedmenu
	        }
	      });
	    };
	
	    _this5._getReadings = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(chapter, index) {
	        var _id, _chapterId, data;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (chapter.free === 1) {
	                  _id = chapter.id, _chapterId = chapter.chapter_id;
	
	                  _this5.context.router.push({
	                    pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', _id).replace(':showFreePremium', _this5.state.showFreePremium).replace(':index', index).replace(':chapterId', _chapterId)
	                  });
	                } else {
	                  data = {
	                    token: _this5.state.token,
	                    idname: _this5.state.idname
	                  };
	
	                  _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                    if (resp.profileInfo.exam_selected === '') {
	                      return _this5.toggleAlert();
	                    } else {
	                      var data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                      var dataset = {
	                        token: _this5.state.token,
	                        idname: _this5.state.idname,
	                        examid: data_arr
	                      };
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                        // console.log(resp_exam);
	                        if (resp_exam.success) {
	                          var exam_data = resp_exam.examData;
	                          var selectedmen = _this5.state.selectedmenu;
	                          var isInArray_var = false;
	                          console.log('I am here in package', isInArray_var);
	
	                          isInArray_var = _SoaPSubscription2.default.checkSoaPVideosSubscription(selectedmen, exam_data);
	
	                          if (isInArray_var) {
	                            var _id2 = chapter.id,
	                                _chapterId2 = chapter.chapter_id;
	
	                            _this5.context.router.push({
	                              pathname: _AppRoutes2.default.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', _id2).replace(':showFreePremium', _this5.state.showFreePremium).replace(':index', index).replace(':chapterId', _chapterId2)
	                            });
	                          } else {
	                            return _this5.toggleAlert();
	                          }
	                        }
	                      });
	                    }
	                  });
	                }
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this6);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this5.savelastVideo = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(chapter, index) {
	        var _this5$state, token, idname, data_data;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _this5$state = _this5.state, token = _this5$state.token, idname = _this5$state.idname;
	                data_data = {
	                  token: token,
	                  idname: idname,
	                  video_id: chapter.id,
	                  videoIndex: index
	                };
	                _context7.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/saveLastViewedVideo', data_data).then(function (response) {
	                  if (response.success) {
	                    _this5.setState({
	                      ValidToken: true
	                    });
	                  }
	                });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this6);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this5.iframe = {
	      padding: 10
	    };
	
	    _this5.videoSection = function () {
	      var domainApp = localStorage.getItem('domainApp');
	      var data = '';
	      // console.log("this.state.allchapters.length", this.state.allchapters.length);
	
	      if (_this5.state.allchapters.length > 0) {
	        var count = 0;
	        data = _this5.state.allchapters.map(function (item, index) {
	          // let videoUrl = item.url.split("/");
	          // let srcUrl_final = (videoUrl[4].split("?"))[0];
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _this5.state.showFreePremium ? item.free === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'video-type-free' },
	              _language2.default.LC().FREE
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'video-type-primum' },
	              _language2.default.LC().PREMIUM
	            ) : _react2.default.createElement('div', null),
	            item.url_id_qq ? _react2.default.createElement('img', {
	              alt: '',
	              width: '100%',
	              src: item.posterImage ? item.posterImage : (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1'),
	              onError: function onError(_ref8) {
	                var currentTarget = _ref8.currentTarget;
	
	                if (!count++) {
	                  // Added condition because of infinite loop, this will once only
	                  currentTarget.onerror = null; // prevents looping
	                  currentTarget.src = (0, _constant.flowPlayerVideoLessonUrl)(item.url_id_qq + '-1_2');
	                }
	              },
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row'
	            }) : _react2.default.createElement('img', {
	              width: '100%',
	              src: 'https://img.youtube.com/vi/' + item.url_id + '/mqdefault.jpg',
	              value: index,
	              onClick: _this5._getReadings.bind(_this5, item, index),
	              className: 'pointer_class slider_row'
	            }),
	            _react2.default.createElement(
	              'strong',
	              { style: { padding: '10px' } },
	              ' ',
	              item.title
	            )
	          );
	        });
	      } else {
	        return null;
	      }
	      return data;
	    };
	
	    var messageTitle_soa_p = '<i class="icon-info icons font-2xl d-block "></i>';
	
	    _this5.state = (_this5$state2 = {
	      allchapters: [],
	      offset: 0,
	      limit: 10,
	      alert_status: false,
	      MessageTitle: messageTitle_soa_p,
	      MessageContent: _alertMessage2.default.messageContent_soa_p,
	      chapters: [],
	      allChapters: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: ''
	    }, _defineProperty(_this5$state2, 'offset', 0), _defineProperty(_this5$state2, 'limit', 10), _defineProperty(_this5$state2, 'Allchapters', []), _defineProperty(_this5$state2, 'itemData', []), _defineProperty(_this5$state2, 'videoUrl', ''), _defineProperty(_this5$state2, 'srcUrl', ''), _defineProperty(_this5$state2, 'srcUrl_final', ''), _defineProperty(_this5$state2, 'selectedmenu', 'soa_p'), _defineProperty(_this5$state2, 'showFreePremium', true), _this5$state2);
	    return _this5;
	  }
	
	  _createClass(ChatperwiseReadingData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var _this7 = this;
	
	        var storage_session, dataCW;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                // console.log(this.props.showFreePremium);
	                // console.log(this.props);
	                this.setState({ showFreePremium: this.props.showFreePremium });
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                this.setState({ idname: storage_session['idname'] });
	                this.setState({ token: storage_session['token'] });
	                dataCW = {
	                  token: storage_session['token'],
	                  chapter_id: this.props.item.chapter_no
	                };
	                _context8.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_videos/getSoaPVideosChapterwise', dataCW).then(function (resp) {
	                  if (resp.success) {
	                    // console.log("getSoaPVideosChapterwise", resp);
	                    _this7.setState({ allchapters: resp.soapvchapter });
	                  } else {
	                    _this7.setState({ allchapters: [] });
	                    _this7.setState({ ValidToken: false });
	                  }
	                });
	
	              case 7:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this);
	      }));
	
	      function componentDidMount() {
	        return _ref9.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      //console.log(this.state.showFreePremium);
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            dots: true
	          }
	        }, {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2,
	            dots: false
	          }
	        }, {
	          breakpoint: 480,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false
	          }
	        }],
	        nextArrow: _react2.default.createElement(SampleNextArrow, null),
	        prevArrow: _react2.default.createElement(SamplePrevArrow, null)
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          this.videoSection()
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.goPremium.bind(this),
	          toggleAlert: this.toggleAlert.bind(this),
	          alert_status: this.state.alert_status,
	          MessageContent: this.state.MessageContent,
	          exam: _constant.examNameAccordingToDB.SOA_P
	        })
	      );
	    }
	  }]);
	
	  return ChatperwiseReadingData;
	}(_react.Component);
	
	ChatperwiseReadingData.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_P_VideoLessons;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _SoaPSubscription = __webpack_require__(87);
	
	var _SoaPSubscription2 = _interopRequireDefault(_SoaPSubscription);
	
	var _SoaPSubscription3 = __webpack_require__(105);
	
	var _SoaPSubscription4 = _interopRequireDefault(_SoaPSubscription3);
	
	var _alertMessage = __webpack_require__(11);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var _exams = __webpack_require__(180);
	
	var _UserAnsweredNotAnsweredStatus = __webpack_require__(137);
	
	var _UserAnsweredNotAnsweredStatus2 = _interopRequireDefault(_UserAnsweredNotAnsweredStatus);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var SOA_P_Viewques = function (_Component) {
	  _inherits(SOA_P_Viewques, _Component);
	
	  function SOA_P_Viewques(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SOA_P_Viewques);
	
	    var _this = _possibleConstructorReturn(this, (SOA_P_Viewques.__proto__ || Object.getPrototypeOf(SOA_P_Viewques)).call(this, props));
	
	    _this.setContentMessage = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var result, _result$data, html_content, header;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _exams.fetchFreeUseSubscriptionMessage)({
	                exam: 'soa_p',
	                section: 'question'
	              });
	
	            case 2:
	              result = _context.sent;
	
	              if (result.success) {
	                _result$data = result.data, html_content = _result$data.html_content, header = _result$data.header;
	
	                _this.setState({
	                  subscriptionMessage: html_content,
	                  contentHeader: header
	                });
	              }
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this._getReadings = function () {
	      _this.context.router.push({
	        pathname: '/soa/probability/readings/' + _this.props.params.chapter_no
	        // state: {
	        //   token: this.state.token,
	        //   idname: this.state.idname,
	        //   chapter: this.props.location.state.reading.chapter_no,
	        // },
	      });
	    };
	
	    _this._beginChapter = function (item, e) {
	      // console.log(item)
	      _this.context.router.push({
	        pathname: '/soa/probability/beginchapter/' + item.chapter_id + '/' + item.reading_id + '/' + item.id,
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          reading: item.reading_id,
	          chapter: item.chapter_id
	        }
	      });
	    };
	
	    _this._getSubscribe = function () {
	      _this.context.router.push({
	        pathname: '/subscribe/',
	        state: { token: _this.state.token, idname: _this.state.idname }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      subscriptionMessage: _alertMessage2.default.messageContent_soa_p,
	      contentHeader: _language2.default.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS,
	      questions: [],
	      token: '',
	      idname: '',
	      readingName: _this.props.params.reading,
	      subscriptionstatus: _this.props.params.subscriptionstatus,
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 1000,
	      answered: [],
	      answered_state: [],
	      showFreePremium: true,
	      chapters: [],
	      subscription_details: '',
	      subscription_details_for_isActive: '',
	      chapter_video_redirect: '',
	      selectedmenu: 'soa_p'
	    };
	    return _this;
	  }
	
	  _createClass(SOA_P_Viewques, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var storage_session, data;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	
	                if (storage_session) {
	                  this.setState({
	                    idname: storage_session['idname'],
	                    token: storage_session['token']
	                  });
	                }
	                window.scrollTo(0, 0);
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token']
	                };
	
	                this.setContentMessage();
	                _context5.next = 7;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(resp) {
	                    var subscription_details, data_arr, dataset;
	                    return _regenerator2.default.wrap(function _callee4$(_context4) {
	                      while (1) {
	                        switch (_context4.prev = _context4.next) {
	                          case 0:
	                            if (!(resp.profileInfo.role === 'partner')) {
	                              _context4.next = 13;
	                              break;
	                            }
	
	                            if (!(resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '')) {
	                              _context4.next = 5;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context4.next = 11;
	                            break;
	
	                          case 5:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context4.next = 11;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                  while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context2.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context2.next = 6;
	                                        return _SoaPSubscription4.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                                      case 6:
	                                        isInArray_var = _context2.sent;
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context2.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context2.stop();
	                                    }
	                                  }
	                                }, _callee2, _this3);
	                              }));
	
	                              return function (_x2) {
	                                return _ref4.apply(this, arguments);
	                              };
	                            }());
	
	                          case 11:
	                            _context4.next = 23;
	                            break;
	
	                          case 13:
	                            if (!(resp.profileInfo.exam_selected === '')) {
	                              _context4.next = 17;
	                              break;
	                            }
	
	                            _this3.setState({
	                              showFreePremium: true
	                            });
	                            _context4.next = 23;
	                            break;
	
	                          case 17:
	                            subscription_details = resp.profileInfo.subscription_details ? JSON.parse(resp.profileInfo.subscription_details) : resp.profileInfo.subscription_details;
	
	
	                            _this3.setState({
	                              subscription_details: subscription_details
	                            });
	                            data_arr = resp.profileInfo.exam_selected ? JSON.parse(resp.profileInfo.exam_selected) : null;
	                            dataset = {
	                              idname: storage_session['idname'],
	                              token: storage_session['token'],
	                              examid: data_arr
	                            };
	                            _context4.next = 23;
	                            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function () {
	                              var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(resp_exam) {
	                                var exam_data, selectedmen, isInArray_var;
	                                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                  while (1) {
	                                    switch (_context3.prev = _context3.next) {
	                                      case 0:
	                                        if (!resp_exam.success) {
	                                          _context3.next = 10;
	                                          break;
	                                        }
	
	                                        exam_data = resp_exam.examData;
	                                        selectedmen = _this3.state.selectedmenu;
	                                        isInArray_var = false;
	                                        _context3.next = 6;
	                                        return _SoaPSubscription2.default.checkSoaPSubscription(selectedmen, exam_data);
	
	                                      case 6:
	                                        isInArray_var = _context3.sent;
	
	                                        if (isInArray_var) {
	                                          _this3.setState({ showFreePremium: false });
	                                        } else {
	                                          _this3.setState({ showFreePremium: true });
	                                        }
	                                        _context3.next = 11;
	                                        break;
	
	                                      case 10:
	                                        console.log('fail');
	
	                                      case 11:
	                                      case 'end':
	                                        return _context3.stop();
	                                    }
	                                  }
	                                }, _callee3, _this3);
	                              }));
	
	                              return function (_x3) {
	                                return _ref5.apply(this, arguments);
	                              };
	                            }());
	
	                          case 23:
	                          case 'end':
	                            return _context4.stop();
	                        }
	                      }
	                    }, _callee4, _this3);
	                  }));
	
	                  return function (_x) {
	                    return _ref3.apply(this, arguments);
	                  };
	                }());
	
	              case 7:
	                data = {
	                  idname: storage_session['idname'],
	                  token: storage_session['token'],
	                  reading_id: this.props.params.id,
	                  chapter_id: this.props.params.chapter_no,
	                  offset: this.state.offset,
	                  limit: this.state.limit,
	                  subscriptionstatus: this.state.subscriptionstatus
	                };
	                _context5.next = 10;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/soa_p_question_bank/getQuestions', data).then(function (resp) {
	                  // console.log(resp)
	                  if (resp.success) {
	                    _this3.setState({ ValidToken: true });
	                    _this3.setState({ questions: resp.questions });
	                  } else {
	                    _this3.setState({ ValidToken: false });
	                  }
	                  return resp;
	                });
	
	              case 10:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var questions = this.state.questions;
	      var data = '';
	      if (this.state.questions.length) {
	        data = questions.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { onClick: _this4._beginChapter.bind(_this4, item), className: 'border_box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title d-flex' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'ml-1' },
	                  item.name,
	                  ' (',
	                  _language2.default.LC().Q,
	                  ' ',
	                  item.id,
	                  ')'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box' },
	                _react2.default.createElement(
	                  'div',
	                  { contentEditable: 'false', className: 'view_question_height view_questionhtml' },
	                  (0, _function.renderHTMLContent)(item.question.substring(0, item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 450) + '...')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _this4.state.answered_state[index]
	                ),
	                _react2.default.createElement(_UserAnsweredNotAnsweredStatus2.default, {
	                  itemid: item.id,
	                  chapter_id: _this4.props.params.chapter_no,
	                  reading_id: _this4.props.params.id,
	                  idname: _this4.state.idname,
	                  token: _this4.state.token,
	                  answered_state: index,
	                  examRoute: 'soa_p_question_bank'
	                })
	              )
	            )
	          );
	        });
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'loader_box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sk-circle' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 margin_bottom_20' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section_head' },
	              this.state.readingName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 text-md-right margin_bottom_20' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary pointer_class',
	                onClick: this._getReadings
	              },
	              ' ',
	              _language2.default.LC().CHANGE_READING,
	              ' '
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data,
	          this.state.subscriptionstatus === 'free' ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'border_box', onClick: this._getSubscribe },
	              _react2.default.createElement(
	                'div',
	                { className: 'border_box_title' },
	                _react2.default.createElement('img', {
	                  src: _App_data2.default.frontend_url + '/img/question_bank/question_icon-blu.svg',
	                  className: 'margin_bottom_20',
	                  width: '30',
	                  alt: ''
	                }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  ' ',
	                  this.state.contentHeader,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_box_free' },
	                (0, _function.renderHTMLContent)(this.state.subscriptionMessage, "div", "view_question_height view_questionhtml modal-info-view-for-plan", { contentEditable: "false" })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'subscibe__btn text-center' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary pointer_class',
	                    onClick: this._getSubscribe
	                  },
	                  _language2.default.LC().SUBSCRIBE
	                )
	              )
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return SOA_P_Viewques;
	}(_react.Component);
	
	SOA_P_Viewques.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SOA_P_Viewques;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var fileTypes = ['jpg', 'jpeg', 'png', 'what', 'ever', 'you', 'want'];
	
	var SetPassword = function (_Component) {
	  _inherits(SetPassword, _Component);
	
	  function SetPassword(props) {
	    _classCallCheck(this, SetPassword);
	
	    var _this = _possibleConstructorReturn(this, (SetPassword.__proto__ || Object.getPrototypeOf(SetPassword)).call(this, props));
	
	    _this._getProfile = function () {
	      _this.context.router.push({
	        pathname: '/profile/',
	        state: {
	          token: _this.state.token,
	          idname: _this.state.idname,
	          selectedMenu: 'frm'
	        }
	      });
	    };
	
	    _this.state = {
	      alert_status: false,
	      MessageTitle: '' + _language2.default.LC().ALERT,
	      MessageContent: '' + _language2.default.LC().ERROR,
	      token: '',
	      idname: '',
	      oldPass: '',
	      newPass: '',
	      repeatPass: '',
	      social: false,
	      ValidToken: false,
	      message: '',
	      message_display_box: 'hide_block'
	    };
	    _this.newPassChanged = _this.newPassChanged.bind(_this);
	    _this.repeatPassChanged = _this.repeatPassChanged.bind(_this);
	    return _this;
	  }
	
	  _createClass(SetPassword, [{
	    key: 'newPassChanged',
	    value: function newPassChanged(e) {
	      this.setState({
	        newPass: e.target.value
	      });
	    }
	  }, {
	    key: 'repeatPassChanged',
	    value: function repeatPassChanged(e) {
	      this.setState({
	        repeatPass: e.target.value
	      });
	    }
	  }, {
	    key: 'updatePassword',
	    value: function updatePassword() {
	      var _this2 = this;
	
	      if (this.state.newPass == '') {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({ message: '' + _language2.default.LC().New_Password_Is_Required });
	        return;
	      }
	      if (this.state.repeatPass == '') {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({
	          message: '' + _language2.default.LC().Confirm_Password_is_Required
	        });
	        return;
	      }
	      if (this.state.newPass != this.state.repeatPass) {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({
	          message: '' + _language2.default.LC().Password_And_Confirm_Password_Is_Required
	        });
	        return;
	      }
	
	      if (this.state.newPass.length < 6) {
	        this.setState({ message_display_box: 'show_block' });
	        this.setState({
	          message: '' + _language2.default.LC().Please_enter_atleast_6_characters_in_the_field
	        });
	        return;
	      } else {
	        this.setState({ message_display_box: 'hide_block' });
	        var data = { idname: this.state.idname, newpassword: this.state.newPass };
	        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/setPassword', data).then(function (resp) {
	          if (resp.success) {
	            _this2.setState({ message_display_box: 'show_block' });
	            _this2.setState({ message: resp.message });
	            _this2.setState({ oldPass: '', newPass: '', repeatPass: '' });
	          } else {
	            _this2.setState({ message_display_box: 'show_block' });
	            _this2.setState({ message: resp.message });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	        if (resp.success) {
	          _this3.setState({ ValidToken: true });
	          if (resp.profileInfo.password === null) {
	            // console.log(resp)
	          }
	        } else {
	          _reactRouter.browserHistory.push('/login');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      /*alert(localStorage.getItem('selectedmenu'));*/
	      var validRender = _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-header' },
	              _language2.default.LC().SET_PASSWORD,
	              _react2.default.createElement(
	                'div',
	                { className: 'card-actions float-md-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'text_light cursor_pointer', onClick: _function._getProfile.bind(this) },
	                  _language2.default.LC().GO_TO_PROFILE,
	                  ' \xA0\xA0\xA0',
	                  ' ',
	                  _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/arrow_right.png', className: '', alt: '' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-block' },
	              _react2.default.createElement(
	                'div',
	                { className: 'padding_top_60 padding_bottom_60' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form_wrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12 ' + this.state.message_display_box },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'error_text' },
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              this.state.message
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form_field' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              ' ',
	                              _language2.default.LC().NEW_PASSWORD,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/profile/lock_icon.svg',
	                                  className: '',
	                                  width: '15',
	                                  alt: ''
	                                })
	                              ),
	                              _react2.default.createElement('input', {
	                                type: 'password',
	                                id: 'input1-group1',
	                                name: 'input1-group1',
	                                className: 'form-control',
	                                placeholder: 'New password',
	                                value: this.state.newPass,
	                                disabled: this.state.social,
	                                onChange: this.newPassChanged
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form_field' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              ' ',
	                              _language2.default.LC().CONFIRM_OLD_PASSWORD,
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement('img', {
	                                  src: _App_data2.default.frontend_url + '/img/profile/lock_icon.svg',
	                                  className: '',
	                                  width: '15',
	                                  alt: ''
	                                })
	                              ),
	                              _react2.default.createElement('input', {
	                                type: 'password',
	                                id: 'input1-group1',
	                                name: 'input1-group1',
	                                className: 'form-control',
	                                placeholder: 'Confirm password',
	                                value: this.state.repeatPass,
	                                disabled: this.state.social,
	                                onChange: this.repeatPassChanged
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement('div', { className: 'border_line' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-sm-12' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: 'btn btn-primary btn_full_width',
	                              onClick: this.updatePassword.bind(this)
	                            },
	                            ' ',
	                            _language2.default.LC().UPDATE_PASSWORD,
	                            ' '
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	      if (this.state.ValidToken) return validRender;else return _react2.default.createElement('p', null);
	    }
	  }]);
	
	  return SetPassword;
	}(_react.Component);
	
	SetPassword.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SetPassword;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _toast = __webpack_require__(15);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _constant = __webpack_require__(9);
	
	var _analytics = __webpack_require__(117);
	
	__webpack_require__(122);
	
	var _subscriptionBadge = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
	// import language from '../../../assets/languages/language';
	// import { EXAM_MAPPING, ROLES } from '../../../common/constant';
	
	// import { renderHTMLContent } from '../../../common/function';
	// import { retrieveSpecialPrice } from '../../../common/function';
	
	// import CheckboxComponent from './Checkbox';
	// import BuyPackages from './BuyPackages';
	
	
	/* eslint-disable */
	
	// Three rows overflowed the header; two is the agreed ceiling (2026-09-01).
	var MAX_HEADER_ENTITLEMENTS = 2;
	
	var SelectPackage = function (_Component) {
	  _inherits(SelectPackage, _Component);
	
	  function SelectPackage(props) {
	    _classCallCheck(this, SelectPackage);
	
	    var _this = _possibleConstructorReturn(this, (SelectPackage.__proto__ || Object.getPrototypeOf(SelectPackage)).call(this, props));
	
	    _this.SPECIAL_INCLUDED_PLANS = {
	      13: { // GMAT Prep
	        45: [43, 44] // Learn + Practice includes Learn + Practice
	      },
	      14: { // Executive Assessment
	        53: [51, 52] // Learn + Practice includes Learn + Practice
	      }
	    };
	
	
	    _this.state = {
	      isLoading: true,
	      errorMessage: "",
	      exam: null,
	      owned: null,
	      packages: [],
	      selectedAddonsByPlanId: {},
	      headerPurchase: null,
	      headerEntitlements: [],
	      // Design 2b — page-level billing switch. 'year' | 'monthly'.
	      billingTerm: "year"
	    };
	
	    _this.loadCoursePackages = _this.loadCoursePackages.bind(_this);
	    _this.goBackToCourses = _this.goBackToCourses.bind(_this);
	    _this.onToggleAddon = _this.onToggleAddon.bind(_this);
	    _this.getSelectedAddonsTotal = _this.getSelectedAddonsTotal.bind(_this);
	    _this.handleAddToCart = _this.handleAddToCart.bind(_this);
	    _this.renderHeader = _this.renderHeader.bind(_this);
	    _this.renderAddons = _this.renderAddons.bind(_this);
	    _this.renderPlanCard = _this.renderPlanCard.bind(_this);
	    _this.setBillingTerm = _this.setBillingTerm.bind(_this);
	    _this.getIntervalLabel = _this.getIntervalLabel.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectPackage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadCoursePackages();
	    }
	  }, {
	    key: 'loadCoursePackages',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _ref2, examId, examName;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ isLoading: true, errorMessage: "" });
	                _ref2 = this.props.params || {}, examId = _ref2.exam_id, examName = _ref2.exam_name;
	
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getExamPackagesByUserId", {
	                  examId: examId,
	                  examName: examName
	                }).then(function (resp) {
	                  if (resp && resp.success) {
	                    // #216 — hide CFA Unlimited+ (pkg 78) from the purchase flow while the
	                    // launch is deferred. Filter is gated by a feature flag so backend /
	                    // ownership checks for existing test purchases stay intact.
	                    var allPackages = Array.isArray(resp.packages) ? resp.packages : [];
	                    var visiblePackages = _constant.SHOW_CFA_UNLIMITED_PLUS ? allPackages : allPackages.filter(function (p) {
	                      if (!p) return false;
	                      if (String(p.package_val).toLowerCase() === 'plus') return false;
	                      if (Number(p.planId) === _constant.CFA_UNLIMITED_PLUS_PACKAGE_ID) return false;
	                      return true;
	                    });
	
	                    _this2.setState({
	                      isLoading: false,
	                      errorMessage: "",
	                      exam: resp.exam,
	                      owned: resp.owned,
	                      packages: visiblePackages,
	                      selectedAddonsByPlanId: {},
	                      headerPurchase: resp.headerPurchase,
	                      headerEntitlements: resp.headerEntitlements || []
	                    });
	                  } else {
	                    var msg = resp && resp.message ? resp.message : "Failed to load packages";
	                    _this2.setState({
	                      isLoading: false,
	                      errorMessage: msg,
	                      exam: null,
	                      owned: null,
	                      packages: [],
	                      selectedAddonsByPlanId: {},
	                      headerPurchase: null
	                    });
	                    (0, _toast.showInformation)(msg);
	                  }
	                  return resp;
	                }).catch(function () {
	                  _this2.setState({
	                    isLoading: false,
	                    errorMessage: "Error loading packages",
	                    exam: null,
	                    owned: null,
	                    packages: [],
	                    selectedAddonsByPlanId: {},
	                    headerPurchase: null
	                  });
	                  (0, _toast.showFailure)("Error loading packages");
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadCoursePackages() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadCoursePackages;
	    }()
	  }, {
	    key: 'goBackToCourses',
	    value: function goBackToCourses() {
	      this.props.router.push('/subscribe');
	    }
	  }, {
	    key: 'getPlanIdWithAnySelectedAddons',
	    value: function getPlanIdWithAnySelectedAddons(selectedMap) {
	      var map = selectedMap || {};
	      var planIds = Object.keys(map);
	
	      for (var i = 0; i < planIds.length; i++) {
	        var pid = planIds[i];
	        var addonsMap = map[pid] || {};
	        var addonIds = Object.keys(addonsMap);
	
	        for (var j = 0; j < addonIds.length; j++) {
	          var aid = addonIds[j];
	          if (addonsMap[aid]) return pid;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'onToggleAddon',
	    value: function onToggleAddon(planId, addonId) {
	      var _this3 = this;
	
	      this.setState(function (prevState) {
	        var selectedMap = prevState.selectedAddonsByPlanId || {};
	
	        var activePlanId = _this3.getPlanIdWithAnySelectedAddons(selectedMap);
	
	        if (activePlanId && String(activePlanId) !== String(planId)) {
	          (0, _toast.showInformation)("You can select add-ons for only one package at a time.");
	          return null;
	        }
	
	        var prevPlanMap = selectedMap[planId] || {};
	        var nextPlanMap = Object.assign({}, prevPlanMap);
	        nextPlanMap[addonId] = !nextPlanMap[addonId];
	
	        var next = Object.assign({}, selectedMap, _defineProperty({}, planId, nextPlanMap));
	        return { selectedAddonsByPlanId: next };
	      });
	    }
	  }, {
	    key: 'getOwnedAddonsTotal',
	    value: function getOwnedAddonsTotal(plan) {
	      if (!plan) return 0;
	      var addons = plan.addons || [];
	      var total = 0;
	
	      for (var i = 0; i < addons.length; i++) {
	        var a = addons[i];
	        if (!a) continue;
	        if (a.owned) total += Number(a.price || 0);
	      }
	      return total;
	    }
	  }, {
	    key: 'getSelectedAddonsTotal',
	    value: function getSelectedAddonsTotal(plan) {
	      if (!plan) return 0;
	
	      var selectedMap = this.state.selectedAddonsByPlanId || {};
	      var planMap = selectedMap[plan.planId] || {};
	      var addons = plan.addons || [];
	      var total = 0;
	
	      for (var i = 0; i < addons.length; i++) {
	        var a = addons[i];
	        if (!a || a.owned || a.inherited) continue;
	        if (planMap[a.id]) total += Number(a.price || 0);
	      }
	      return total;
	    }
	
	    // ── Design 2b — page-level billing switch ────────────────────────────
	    // A plan is "recurring" when exam_plans.payment_interval is set.
	
	  }, {
	    key: 'isRecurringPlan',
	    value: function isRecurringPlan(plan) {
	      return !!(plan && plan.payment_interval);
	    }
	
	    // Only study tiers can have a monthly twin. unlimited / plus are lifetime
	    // one-time purchases and never respond to the switch. Mock packages are
	    // excluded even though they share package_val with a study tier (CFA L1
	    // pkg 65 is `expensive` + category 'mock') — otherwise the switch would
	    // swap the mock card out for the monthly Learn + Practice plan.
	
	  }, {
	    key: 'isSwitchablePlan',
	    value: function isSwitchablePlan(plan) {
	      if (!plan || this.isMockPlan(plan.package_category)) return false;
	      return plan.package_val === "simple" || plan.package_val === "expensive";
	    }
	
	    // Count year/monthly variants per tier. Twins are matched on package_val,
	    // unambiguous for CFA L1 today (one 'simple', one 'expensive') — see spec 11.1.
	
	  }, {
	    key: 'getTermVariantCounts',
	    value: function getTermVariantCounts(packages) {
	      var tiers = {};
	      for (var i = 0; i < (packages || []).length; i++) {
	        var p = packages[i];
	        if (!this.isSwitchablePlan(p)) continue;
	        var t = tiers[p.package_val] || { year: 0, monthly: 0 };
	        if (this.isRecurringPlan(p)) t.monthly += 1;else t.year += 1;
	        tiers[p.package_val] = t;
	      }
	      return tiers;
	    }
	
	    // The switch only renders when a tier genuinely offers BOTH terms.
	    // Exams with a monthly-only plan (GMAT Focus, pkg 57) must keep rendering
	    // it, and would show an empty grid under a naive year-default filter.
	
	  }, {
	    key: 'hasBillingChoice',
	    value: function hasBillingChoice(packages) {
	      var tiers = this.getTermVariantCounts(packages);
	      var keys = Object.keys(tiers);
	      for (var i = 0; i < keys.length; i++) {
	        if (tiers[keys[i]].year > 0 && tiers[keys[i]].monthly > 0) return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'filterPackagesByTerm',
	    value: function filterPackagesByTerm(packages, term) {
	      var _this4 = this;
	
	      // Monthly view shows monthly packages ONLY — no one-time tiers alongside
	      // them (requirement 2026-08-25).
	      if (term === "monthly") {
	        return (packages || []).filter(function (p) {
	          return _this4.isRecurringPlan(p);
	        });
	      }
	
	      // Yearly view: every one-time plan, plus any recurring plan whose tier has
	      // no one-time twin. That last case keeps monthly-only exams working —
	      // GMAT Focus (pkg 57) has no yearly variant and would otherwise render an
	      // empty grid, since 'year' is the default term and it gets no switch.
	      var tiers = this.getTermVariantCounts(packages);
	      return (packages || []).filter(function (p) {
	        if (!_this4.isRecurringPlan(p)) return true;
	        if (!_this4.isSwitchablePlan(p)) return false;
	        var t = tiers[p.package_val] || { year: 0, monthly: 0 };
	        return t.year === 0;
	      });
	    }
	  }, {
	    key: 'setBillingTerm',
	    value: function setBillingTerm(term) {
	      if (term === this.state.billingTerm) return;
	      this.setState({ billingTerm: term });
	    }
	  }, {
	    key: 'isMockPlan',
	    value: function isMockPlan(packageCategory) {
	      return !!(packageCategory === "mock");
	    }
	  }, {
	    key: 'getTierScore',
	    value: function getTierScore(plan) {
	      if (!plan) return 0;
	
	      var isPlus = plan.package_val === "plus";
	      var isUnlimited = plan.package_val === "unlimited";
	      var isExpensive = plan.package_val === "expensive";
	      var isSimple = plan.package_val === "simple";
	
	      if (isPlus) return 400;
	      if (isUnlimited) return 300;
	      if (isExpensive) return 200;
	      if (isSimple) return 100;
	      return 50;
	    }
	  }, {
	    key: 'getPlanRank',
	    value: function getPlanRank(plan) {
	      var tier = this.getTierScore(plan);
	      var price = Number(plan.price || 0);
	      var id = Number(plan.planId || 0);
	      return tier * 1000000 + price * 1000 + id;
	    }
	
	    // `ignoreRecurring` — a monthly subscription must never make a 12-month
	    // package look "Included in Purchased Package". Monthly ranks BELOW yearly
	    // regardless of tier: a subscriber has to be able to switch to the yearly
	    // plan, and buying it supersedes the subscription (spec §9).
	
	  }, {
	    key: 'getMaxOwnedRank',
	    value: function getMaxOwnedRank(packages, onlyMock, ignoreRecurring) {
	      var maxRank = -1;
	
	      for (var i = 0; i < packages.length; i++) {
	        var p = packages[i];
	        if (!p || !p.isOwned) continue;
	
	        var isMock = this.isMockPlan(p.package_category);
	        if (onlyMock && !isMock) continue;
	        if (!onlyMock && isMock) continue;
	        if (ignoreRecurring && this.isRecurringPlan(p)) continue;
	
	        var r = this.getPlanRank(p);
	        if (r > maxRank) maxRank = r;
	      }
	
	      return maxRank;
	    }
	  }, {
	    key: 'getPrimaryOwnedPlan',
	    value: function getPrimaryOwnedPlan(packages) {
	      var bestNonMock = null;
	      var bestNonMockRank = -1;
	
	      var bestMock = null;
	      var bestMockRank = -1;
	
	      for (var i = 0; i < packages.length; i++) {
	        var p = packages[i];
	        if (!p || !p.isOwned) continue;
	
	        var r = this.getPlanRank(p);
	        if (this.isMockPlan(p.package_category)) {
	          if (r > bestMockRank) {
	            bestMockRank = r;
	            bestMock = p;
	          }
	        } else {
	          if (r > bestNonMockRank) {
	            bestNonMockRank = r;
	            bestNonMock = p;
	          }
	        }
	      }
	
	      return bestNonMock || bestMock || null;
	    }
	  }, {
	    key: 'hasOwnedNonMockUnlimited',
	    value: function hasOwnedNonMockUnlimited(packages) {
	      for (var i = 0; i < packages.length; i++) {
	        var p = packages[i];
	        if (!p || !p.isOwned) continue;
	        if (this.isMockPlan(p.package_category)) continue;
	        if (p.package_val === "unlimited" || p.package_val === "plus") return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'isIncludedInPurchasedPackage',
	    value: function isIncludedInPurchasedPackage(plan, packages) {
	      if (!plan) return false;
	
	      var isMock = this.isMockPlan(plan.package_category);
	      var examId = Number(plan.exam_id);
	
	      if (!isMock && this.isSpecialExamWithExplicitRules(examId)) {
	        for (var i = 0; i < packages.length; i++) {
	          var ownedPlan = packages[i];
	          if (!ownedPlan || !ownedPlan.isOwned) continue;
	
	          if (this.isMockPlan(ownedPlan.package_category)) continue;
	          if (Number(ownedPlan.exam_id) !== examId) continue;
	          // A subscription never blocks a one-time purchase.
	          if (!this.isRecurringPlan(plan) && this.isRecurringPlan(ownedPlan)) continue;
	
	          if (this.isExplicitlyIncludedByOwnedPlan(plan, ownedPlan)) {
	            return true;
	          }
	        }
	
	        // Reverse: if target is composite (e.g. L+P) and ALL its components are owned
	        if (this.isCompositeIncludedByComponents(plan, packages)) {
	          return true;
	        }
	
	        return false;
	      }
	
	      var rank = this.getPlanRank(plan);
	
	      if (isMock && this.hasOwnedNonMockUnlimited(packages)) return true;
	
	      // When judging a ONE-TIME plan, owned monthly plans do not count — see
	      // getMaxOwnedRank. When judging a monthly plan they do, so a lower monthly
	      // tier is still correctly shown as included in a higher one.
	      var ignoreRecurring = !this.isRecurringPlan(plan);
	      var maxOwnedRankSameGroup = this.getMaxOwnedRank(packages, isMock, ignoreRecurring);
	      if (maxOwnedRankSameGroup <= 0) return false;
	
	      return rank < maxOwnedRankSameGroup;
	    }
	  }, {
	    key: 'shouldShowUpgrade',
	    value: function shouldShowUpgrade(plan) {
	      if (!plan || plan.isOwned) return false;
	      if (this.isMockPlan(plan.package_category)) return false;
	      // No upgrade path into a monthly plan (requirement 2026-08-25). Design 2h
	      // states the same rule in the cart: upgrades are 12-month billing only.
	      if (this.isRecurringPlan(plan)) return false;
	      return !!plan.upgradeAvailable;
	    }
	  }, {
	    key: 'isBestValue',
	    value: function isBestValue(plan) {
	      if (!plan || plan.isOwned || this.isMockPlan(plan.package_category)) return false;
	      return plan.package_val === "unlimited" || plan.package_val === "plus";
	    }
	  }, {
	    key: 'isSpecialExamWithExplicitRules',
	    value: function isSpecialExamWithExplicitRules(examId) {
	      return !!this.SPECIAL_INCLUDED_PLANS[Number(examId)];
	    }
	  }, {
	    key: 'getExplicitlyIncludedPlanIds',
	    value: function getExplicitlyIncludedPlanIds(ownedPlan) {
	      if (!ownedPlan) return [];
	
	      var examId = Number(ownedPlan.exam_id);
	      var ownedPlanId = Number(ownedPlan.planId);
	
	      var examRules = this.SPECIAL_INCLUDED_PLANS[examId];
	      if (!examRules) return [];
	
	      return examRules[ownedPlanId] || [];
	    }
	  }, {
	    key: 'isExplicitlyIncludedByOwnedPlan',
	    value: function isExplicitlyIncludedByOwnedPlan(targetPlan, ownedPlan) {
	      if (!targetPlan || !ownedPlan) return false;
	
	      var targetPlanId = Number(targetPlan.planId);
	      var includedPlanIds = this.getExplicitlyIncludedPlanIds(ownedPlan);
	
	      return includedPlanIds.includes(targetPlanId);
	    }
	
	    // Reverse check: if target is a composite plan (e.g. L+P expensive)
	    // and ALL its component plans (e.g. Learn simple + Practice simple) are owned
	
	  }, {
	    key: 'isCompositeIncludedByComponents',
	    value: function isCompositeIncludedByComponents(targetPlan, packages) {
	      if (!targetPlan) return false;
	      var examId = Number(targetPlan.exam_id);
	      var targetPlanId = Number(targetPlan.planId);
	
	      var examRules = this.SPECIAL_INCLUDED_PLANS[examId];
	      if (!examRules) return false;
	
	      var componentIds = examRules[targetPlanId];
	      if (!componentIds || componentIds.length === 0) return false;
	
	      for (var i = 0; i < componentIds.length; i++) {
	        var cid = componentIds[i];
	        var found = false;
	        for (var j = 0; j < packages.length; j++) {
	          if (packages[j] && packages[j].isOwned && Number(packages[j].planId) === cid) {
	            found = true;
	            break;
	          }
	        }
	        if (!found) return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'fireAddToCartTracking',
	    value: function fireAddToCartTracking(plan, displayPrice) {
	      try {
	        var exam = this.state.exam;
	
	        var profile = _userStore2.default && _userStore2.default.profileInfo || {};
	        var value = Number(displayPrice) || Number(plan && plan.price) || 0;
	        (0, _analytics.trackAddToCart)({
	          exam: exam && exam.uiTitle || '',
	          packageType: plan && plan.package_type || '',
	          value: value,
	          userName: profile.username || '',
	          userEmail: profile.email || '',
	          source: _userStore2.default && _userStore2.default.landingSource || 'organic',
	          affiliateName: _userStore2.default && _userStore2.default.landingSourceName || null
	        });
	      } catch (e) {
	        // eslint-disable-next-line no-console
	        console.warn('SelectPackage trackAddToCart failed:', e && e.message);
	      }
	    }
	  }, {
	    key: 'handleAddToCart',
	    value: function handleAddToCart(plan, isOwned, proposeUpgrade, displayPrice) {
	      var _this5 = this;
	
	      if (!plan) return;
	
	      var examId = Number(plan.exam_id);
	      var planId = Number(plan.planId);
	
	      var selectedMap = this.state.selectedAddonsByPlanId || {};
	      var planMap = selectedMap[planId] || {};
	      var addons = plan.addons || [];
	
	      var addonIds = [];
	
	      for (var i = 0; i < addons.length; i++) {
	        var a = addons[i];
	        if (!a || a.owned) continue;
	        // Auto-include inherited addons (price will be 0 on backend)
	        if (a.inherited || planMap[a.id]) addonIds.push(a.id);
	      }
	
	      var type = isOwned ? "unlessUnlimited" : "main";
	      var payload = {
	        examId: examId,
	        planId: planId,
	        addonIds: addonIds
	      };
	
	      if (proposeUpgrade && plan.upgradeAvailable) {
	        type = plan.upgradeType || "upgrade_standard";
	        payload.upgradeFromPlanId = plan.upgradeFromPlanId;
	        payload.displayPrice = displayPrice;
	      }
	
	      payload.type = type;
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/addToUserCart", payload).then(function (resp) {
	        if (resp && resp.success) {
	          // Conversion tracking — fire GTM/GA4/FB AddToCart events for this
	          // package selection. Lost when this component replaced the legacy
	          // Subscribe/SelectPackage.js. See common/analytics.js.
	          _this5.fireAddToCartTracking(plan, displayPrice);
	
	          _this5.props.router.push("/cart");
	        } else {
	          var msg = resp && resp.message ? resp.message : "Failed to add to cart";
	          (0, _toast.showInformation)(msg);
	        }
	      }).catch(function () {
	        (0, _toast.showFailure)("Failed to add to cart");
	      });
	    }
	
	    // One block per active entitlement. A user can hold several at once — a
	    // mock package alongside a monthly subscription — and naming only the
	    // "primary" one hid the rest (decided 2026-09-01: show every one, no cap).
	
	  }, {
	    key: 'renderEntitlement',
	    value: function renderEntitlement(item, index) {
	      var sub = item.subscription || null;
	      var badge = (0, _subscriptionBadge.getSubscriptionBadge)(sub);
	      var dateLabel = (0, _subscriptionBadge.getSubscriptionDateLabel)(sub);
	      // The subscription's own expiry is authoritative when present; the
	      // derived expirationDate can lag.
	      var expiry = sub && sub.expiryDate ? (0, _CommonUtils.formatPrettyDate)(sub.expiryDate) : item.expirationDate ? (0, _CommonUtils.formatPrettyDate)(item.expirationDate) : null;
	      var purchased = item.purchaseDate ? (0, _CommonUtils.formatPrettyDate)(item.purchaseDate) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sp_purchased_container', key: item.planId || index },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'sp_purchased_header sb_card_meta_row' + (sub ? ' sp_badge_tone_' + badge.tone : '')
	          },
	          _react2.default.createElement('span', { className: 'sb_card_meta_icon sp_icon_purchased' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            badge.label
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sp_purchased_title' },
	          item.package_type || 'Purchased'
	        ),
	        purchased && _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	          _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_calendar' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            (sub ? 'Subscribed: ' : 'Purchased: ') + purchased
	          )
	        ),
	        expiry && !item.hasLifetimeAccess && _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	          _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_clock' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            dateLabel + expiry
	          )
	        ),
	        (item.hasLifetimeAccess || item.hasUnlimitedTutor) && _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row sb_card_meta_row_green' },
	          item.hasLifetimeAccess && _react2.default.createElement(
	            'div',
	            { className: 'sb_card_meta_row' },
	            _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_infinity' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Lifetime'
	            )
	          ),
	          item.hasUnlimitedTutor && _react2.default.createElement(
	            'div',
	            { className: 'sb_card_meta_row' },
	            _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_chat' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Unlimited Tutor'
	            )
	          )
	        )
	      );
	    }
	
	    // What the header should actually list. Two rules, both from real cases:
	    //  1. A package already covered by a bigger one is noise — owning "Mock
	    //     Unlimited (All 3 Levels)" makes "Mock (Learn + Practice)" redundant,
	    //     and the plan card itself says "Included in Purchased Package".
	    //     Reuses the card's own coverage rule so the two cannot disagree.
	    //  2. Cap at MAX_HEADER_ENTITLEMENTS — three rows was already too much.
	
	  }, {
	    key: 'visibleHeaderEntitlements',
	    value: function visibleHeaderEntitlements() {
	      var _state = this.state,
	          packages = _state.packages,
	          headerEntitlements = _state.headerEntitlements;
	
	      var list = headerEntitlements || [];
	      if (list.length < 2) return list;
	
	      var planById = {};
	      for (var i = 0; i < (packages || []).length; i++) {
	        var p = packages[i];
	        if (p) planById[String(p.planId)] = p;
	      }
	
	      var kept = [];
	      for (var _i = 0; _i < list.length; _i++) {
	        var plan = planById[String(list[_i].planId)];
	        if (plan && this.isIncludedInPurchasedPackage(plan, packages || [])) continue;
	        kept.push(list[_i]);
	      }
	
	      return (kept.length ? kept : list).slice(0, MAX_HEADER_ENTITLEMENTS);
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          exam = _state2.exam,
	          packages = _state2.packages,
	          headerPurchase = _state2.headerPurchase;
	
	      var headerEntitlements = this.visibleHeaderEntitlements();
	
	      var primaryOwned = this.getPrimaryOwnedPlan(packages || []);
	
	      var purchasedPretty = headerPurchase && headerPurchase.purchaseDate ? (0, _CommonUtils.formatPrettyDate)(headerPurchase.purchaseDate) : null;
	
	      var expiresPretty = headerPurchase && headerPurchase.expirationDate ? (0, _CommonUtils.formatPrettyDate)(headerPurchase.expirationDate) : null;
	
	      var hasLifetimeAccess = headerPurchase && headerPurchase.hasLifetimeAccess;
	
	      var hasUnlimitedTutor = headerPurchase && headerPurchase.hasUnlimitedTutor;
	
	      // The header described every owned plan as "Purchased … Expires: X".
	      // Neither word is right for a subscription: it is subscribed, not
	      // purchased, and the date is a RENEWAL while it is live and an
	      // ACCESS-UNTIL once it is cancelled. Same vocabulary as the plan cards
	      // and the course tiles — see common/subscriptionBadge.js.
	      var primarySub = primaryOwned && primaryOwned.subscription || null;
	      var headerBadge = (0, _subscriptionBadge.getSubscriptionBadge)(primarySub);
	      var headerDateLabel = (0, _subscriptionBadge.getSubscriptionDateLabel)(primarySub);
	      // The subscription's own expiry is authoritative when present; the
	      // header's expirationDate is derived and can lag.
	      var headerExpiry = primarySub && primarySub.expiryDate ? (0, _CommonUtils.formatPrettyDate)(primarySub.expiryDate) : expiresPretty;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sp_container_header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sp_header_row' },
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'sp_back_btn',
	              onClick: this.goBackToCourses,
	              'aria-label': 'Back',
	              title: 'Back'
	            },
	            _react2.default.createElement('span', { className: 'sp_back_icon' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'sp_container_title' },
	              'STUDY PACKAGE'
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'sp_container_subtitle' },
	              exam.uiTitle
	            )
	          )
	        ),
	        headerEntitlements && headerEntitlements.length > 0 ? _react2.default.createElement(
	          'div',
	          { className: 'sp_purchased_block' },
	          headerEntitlements.map(function (item, i) {
	            return _this6.renderEntitlement(item, i);
	          })
	        ) : headerPurchase && _react2.default.createElement(
	          'div',
	          { className: 'sp_purchased_block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sp_purchased_container' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'sp_purchased_header sb_card_meta_row' + (primarySub ? ' sp_badge_tone_' + headerBadge.tone : '')
	              },
	              _react2.default.createElement('span', { className: 'sb_card_meta_icon sp_icon_purchased' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                headerBadge.label
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sp_purchased_title' },
	              function () {
	                var title = primaryOwned ? primaryOwned.package_type || "Purchased" : "Purchased";
	                var eid = Number(exam && exam.id);
	                if (eid === 13 || eid === 14) {
	                  var ownedNonMock = (packages || []).filter(function (p) {
	                    return p && p.isOwned && p.package_category !== 'mock';
	                  });
	                  if (ownedNonMock.length > 1) {
	                    title = ownedNonMock.map(function (p) {
	                      return p.package_type;
	                    }).filter(Boolean).join(' + ');
	                  }
	                }
	                return title;
	              }()
	            ),
	            purchasedPretty && _react2.default.createElement(
	              'div',
	              { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	              _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_calendar' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (primarySub ? 'Subscribed: ' : 'Purchased: ') + purchasedPretty
	              )
	            ),
	            headerExpiry && _react2.default.createElement(
	              'div',
	              { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	              _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_clock' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                headerDateLabel + headerExpiry
	              )
	            ),
	            (hasLifetimeAccess || hasUnlimitedTutor) && _react2.default.createElement(
	              'div',
	              { className: 'sb_card_meta_row sb_card_meta_row_green' },
	              hasLifetimeAccess && _react2.default.createElement(
	                'div',
	                { className: 'sb_card_meta_row' },
	                _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_infinity' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Lifetime'
	                )
	              ),
	              hasUnlimitedTutor && _react2.default.createElement(
	                'div',
	                { className: 'sb_card_meta_row' },
	                _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_chat' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Unlimited Tutor'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPackageDesc',
	    value: function renderPackageDesc(plan) {
	      var html = plan && plan.package_desc ? String(plan.package_desc) : "";
	      return _react2.default.createElement('div', { className: 'sp_plan_features', dangerouslySetInnerHTML: { __html: html } });
	    }
	  }, {
	    key: 'renderAddons',
	    value: function renderAddons(plan) {
	      var _this7 = this;
	
	      if (!plan || !!(plan && plan.package_val === "unlimited")) return null;
	      // Monthly packages carry no add-ons (requirement 2026-08-25). A subscription
	      // bills current_price_id only, so an add-on priced here would never be charged.
	      if (this.isRecurringPlan(plan)) return null;
	
	      var _plan$addons = plan.addons,
	          addons = _plan$addons === undefined ? [] : _plan$addons,
	          planId = plan.planId;
	
	
	      if (!addons.length) return null;
	
	      var selectedMap = this.state.selectedAddonsByPlanId || {};
	      var planMap = selectedMap[planId] || {};
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sp_plan_addons_block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sp_plan_addons_title' },
	          'Optional Add-ons'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sp_plan_addons_box' },
	          addons.map(function (addon) {
	            if (!addon) return null;
	
	            var aid = addon.id;
	            var isOwned = !!addon.owned;
	            var isInherited = !!addon.inherited;
	            var isLocked = isOwned || isInherited;
	
	            var checked = !isLocked && !!planMap[aid];
	
	            return _react2.default.createElement(
	              'div',
	              {
	                key: aid,
	                className: "sb_enhance_panel_item" + (checked || isLocked ? " sb_enhance_panel_item_active" : "") + (isLocked ? " sb_enhance_panel_item_owned" : ""),
	                onClick: function onClick() {
	                  if (isLocked) return;
	                  _this7.onToggleAddon(planId, aid);
	                }
	              },
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                'aria-label': addon.title,
	                checked: isLocked ? true : checked,
	                disabled: isLocked,
	                onChange: function onChange() {
	                  if (isLocked) return;
	                  _this7.onToggleAddon(planId, aid);
	                },
	                onClick: function onClick(e) {
	                  return e.stopPropagation();
	                }
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sb_panel_item_name' },
	                addon.title
	              ),
	              isLocked ? _react2.default.createElement(
	                'span',
	                { className: "sb_addon_status_badge" + (isLocked ? " sb_addon_badge_is_owned" : "") },
	                isOwned ? "Purchased" : "Included"
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'sb_price_addon_block' },
	                addon.tooltip_description ? _react2.default.createElement(
	                  'span',
	                  { className: 'sb_addon_tooltip_wrap' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'sb_addon_tooltip_icon' },
	                    'i'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'sb_addon_tooltip_popup' },
	                    String(addon.tooltip_description).replace(/<[^>]*>/g, "")
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sb_panel_item_price' },
	                  "+ " + (0, _CommonUtils.formatMoney)(addon.price)
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'getIntervalLabel',
	    value: function getIntervalLabel(payment_interval) {
	      if (!payment_interval) return "";
	
	      var labels = {
	        day: "daily",
	        week: "weekly",
	        month: "monthly",
	        year: "yearly"
	      };
	
	      return labels[payment_interval.toLowerCase()] || "";
	    }
	  }, {
	    key: 'renderPlanCard',
	    value: function renderPlanCard(plan) {
	      var _this8 = this;
	
	      if (!plan) return null;
	
	      var _state$packages = this.state.packages,
	          packages = _state$packages === undefined ? [] : _state$packages;
	      var _plan$isOwned = plan.isOwned,
	          isOwned = _plan$isOwned === undefined ? false : _plan$isOwned,
	          _plan$price = plan.price,
	          price = _plan$price === undefined ? 0 : _plan$price,
	          _plan$originalPrice = plan.originalPrice,
	          originalPrice = _plan$originalPrice === undefined ? null : _plan$originalPrice,
	          _plan$planId = plan.planId,
	          planId = _plan$planId === undefined ? 0 : _plan$planId,
	          package_type = plan.package_type,
	          payment_interval = plan.payment_interval;
	
	
	      var hasPartnerPrice = originalPrice !== null && originalPrice !== price;
	
	      var isDisabled = this.isIncludedInPurchasedPackage(plan, packages);
	      var proposeUpgrade = this.shouldShowUpgrade(plan);
	      var isUpgradeUnlimited = proposeUpgrade && plan.upgradeType === 'upgrade_unlimited';
	      var isUpgradePlus = proposeUpgrade && plan.upgradeType === 'upgrade_plus';
	      var isPlus = plan.package_val === 'plus';
	      var best = !proposeUpgrade && this.isBestValue(plan);
	
	      var selectedAddonsTotal = this.getSelectedAddonsTotal(plan);
	      var hasSelected = selectedAddonsTotal > 0;
	
	      var upgradeCredit = proposeUpgrade ? Number(plan.upgradeCredit) || 0 : 0;
	      var upgradePrice = proposeUpgrade ? Math.max(0, price + selectedAddonsTotal - upgradeCredit) : 0;
	      var displayPrice = void 0;
	      if (proposeUpgrade) {
	        displayPrice = upgradePrice;
	      } else if (isOwned) {
	        displayPrice = price;
	      } else {
	        displayPrice = price + selectedAddonsTotal;
	      }
	
	      var canBuy = !isDisabled && (proposeUpgrade || !isOwned || hasSelected);
	      var isPurchasedCard = isOwned && !isDisabled;
	
	      var cardClass = "sp_plan_card";
	      if (isDisabled) cardClass += " sp_plan_card_lower";else if (isOwned) cardClass += " sp_plan_card_owned";else if (isUpgradePlus) cardClass += " sp_plan_card_best sp_plan_card_plus";else if (isUpgradeUnlimited) cardClass += " sp_plan_card_best";else if (proposeUpgrade) cardClass += " sp_plan_card_upgrade";else if (isPlus) cardClass += " sp_plan_card_best sp_plan_card_plus";else if (best) cardClass += " sp_plan_card_best";
	
	      // A recurring plan whose subscription was cancelled or has lapsed is
	      // purchasable again (see ownership rules in /getExamPackagesByUserId).
	      // Without this the card silently reverts to a plain buy card and the user
	      // has no idea their subscription ended, expired.
	      // Subscription state drives the badge whether or not the plan is still
	      // owned. A `cancelling` plan IS owned, so gating on !isOwned rendered a
	      // blue "Purchased" here while /subscribe said "Cancelled" for the same plan.
	      // An `expired` plan is no longer owned (it is buyable again) but still gets
	      // a badge so the user can see why.
	      var subState = plan.subscription || null;
	      var subBadge = subState ? (0, _subscriptionBadge.getSubscriptionBadge)(subState) : null;
	      var showSubBadge = !!subBadge && (isPurchasedCard || subState.status === 'expired');
	
	      var badge = null;
	      if (!isDisabled) {
	        if (showSubBadge) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: "sp_plan_badge sb_card_meta_row sp_badge_tone_" + subBadge.tone },
	            _react2.default.createElement(
	              'span',
	              null,
	              subBadge.label
	            )
	          );
	        } else if (isPurchasedCard) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_badge sb_card_meta_row sp_badge_purchased' },
	            _react2.default.createElement('span', { className: 'sb_card_meta_icon sp_icon_badge_purchased' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Purchased'
	            )
	          );
	        } else if (isUpgradePlus) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_badge sb_card_meta_row sp_badge_launch_special' },
	            _react2.default.createElement('span', { className: 'sb_card_meta_icon sp_icon_badge_upgrade' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Upgrade'
	            )
	          );
	        } else if (isUpgradeUnlimited) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_badge sb_card_meta_row sp_badge_best' },
	            _react2.default.createElement('span', { className: 'sb_card_meta_icon sp_icon_badge_upgrade' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Upgrade'
	            )
	          );
	        } else if (proposeUpgrade) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_badge sb_card_meta_row sp_badge_upgrade' },
	            _react2.default.createElement('span', { className: 'sb_card_meta_icon sp_icon_badge_upgrade' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Upgrade'
	            )
	          );
	        } else if (isPlus) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_badge sp_badge_launch_special' },
	            'Launch Special'
	          );
	        } else if (best) {
	          badge = _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_badge sp_badge_best' },
	            'Best Value'
	          );
	        }
	      }
	
	      var combinedPrice = hasSelected ? (0, _CommonUtils.formatMoney)(price) + " + " + (0, _CommonUtils.formatMoney)(selectedAddonsTotal) + " add-ons" : null;
	
	      var buttonInner = null;
	
	      if (isDisabled) {
	        buttonInner = _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row' },
	          'Included in Purchased Package'
	        );
	      } else if (isPurchasedCard && !hasSelected) {
	        // } else if (isOwned && isPrimaryOwned && !hasSelected || isOwned && isMock && !hasSelected) {
	        buttonInner = _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row' },
	          _react2.default.createElement('span', { className: 'sp_icon_button_purchased' }),
	          'Purchased'
	        );
	      } else if (proposeUpgrade) {
	        buttonInner = _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row' },
	          _react2.default.createElement('span', { className: 'sp_btn_primary_icon' }),
	          'Upgrade for ',
	          (0, _CommonUtils.formatMoney)(upgradePrice)
	        );
	      } else if (isOwned && hasSelected) {
	        buttonInner = _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row' },
	          _react2.default.createElement('span', { className: 'sp_btn_primary_icon' }),
	          'Add Extras to Cart ($',
	          selectedAddonsTotal,
	          ')'
	        );
	      } else {
	        buttonInner = _react2.default.createElement(
	          'div',
	          { className: 'sb_card_meta_row' },
	          _react2.default.createElement('span', { className: 'sp_btn_primary_icon' }),
	          'Add To Cart'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: planId, className: cardClass },
	        badge,
	        _react2.default.createElement(
	          'div',
	          { className: 'sp_plan_card_body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_descript' },
	            package_type
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_price' },
	            hasPartnerPrice && _react2.default.createElement(
	              'span',
	              { className: 'sp_plan_price_original' },
	              (0, _CommonUtils.formatMoney)(originalPrice)
	            ),
	            proposeUpgrade && !hasPartnerPrice && upgradeCredit > 0 && _react2.default.createElement(
	              'span',
	              { className: 'sp_plan_price_original' },
	              (0, _CommonUtils.formatMoney)(price)
	            ),
	            (0, _CommonUtils.formatMoney)(displayPrice),
	            payment_interval ? _react2.default.createElement(
	              'span',
	              { className: 'sp_plan_price_interval' },
	              ' /  ',
	              payment_interval
	            ) : null
	          ),
	          hasPartnerPrice ? _react2.default.createElement(
	            'span',
	            { className: 'sp_plan_price_billed' },
	            'Partner price'
	          ) : "",
	          payment_interval ? _react2.default.createElement(
	            'span',
	            { className: 'sp_plan_price_billed' },
	            'Billed ',
	            this.getIntervalLabel(payment_interval),
	            ' \xB7 cancel anytime'
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'sp_combined_price' },
	            proposeUpgrade && hasSelected ? (0, _CommonUtils.formatMoney)(price) + " + " + (0, _CommonUtils.formatMoney)(selectedAddonsTotal) + " add-ons − " + (0, _CommonUtils.formatMoney)(upgradeCredit) + " credit" : !isOwned && combinedPrice
	          ),
	          this.renderPackageDesc(plan),
	          _react2.default.createElement(
	            'div',
	            { className: 'sp_plan_add_card' },
	            isDisabled ? null : this.renderAddons(plan),
	            _react2.default.createElement(
	              'button',
	              {
	                disabled: !canBuy,
	                className: "sp_btn_primary " + (hasSelected ? "sp_addons_has_selected" : isPlus ? "sp_badge_launch_special" : ""),
	                onClick: function onClick() {
	                  if (!canBuy) return;
	                  _this8.handleAddToCart(plan, isOwned, proposeUpgrade, displayPrice);
	                }
	              },
	              buttonInner
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'isCfaLevelOnePage',
	    value: function isCfaLevelOnePage() {
	      var exam = this.state.exam;
	
	      return !!(exam && Number(exam.id) === 1);
	    }
	  }, {
	    key: 'renderBillingSwitch',
	    value: function renderBillingSwitch() {
	      var _this9 = this;
	
	      var _state3 = this.state,
	          packages = _state3.packages,
	          billingTerm = _state3.billingTerm;
	
	      if (!this.hasBillingChoice(packages)) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sp_billing_switch_wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sp_billing_switch', role: 'group', 'aria-label': 'Billing period' },
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: "sp_billing_switch_option" + (billingTerm === "year" ? " is_active" : ""),
	              'aria-pressed': billingTerm === "year",
	              onClick: function onClick() {
	                return _this9.setBillingTerm("year");
	              }
	            },
	            'Annual Payment'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: "sp_billing_switch_option" + (billingTerm === "monthly" ? " is_active" : ""),
	              'aria-pressed': billingTerm === "monthly",
	              onClick: function onClick() {
	                return _this9.setBillingTerm("monthly");
	              }
	            },
	            'Subscription'
	          )
	        ),
	        billingTerm === "monthly" ? _react2.default.createElement(
	          'div',
	          { className: 'sp_billing_switch_note' },
	          'Subscriptions apply to per-level study packages only.'
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var _state4 = this.state,
	          isLoading = _state4.isLoading,
	          errorMessage = _state4.errorMessage,
	          packages = _state4.packages,
	          billingTerm = _state4.billingTerm;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      }
	
	      // Keep the wider CFA Level I page layout on every CFA L1 visit regardless of
	      // the Plus-visibility feature flag. The grid itself adjusts column count by
	      // card count (see `.sp_plans_grid_cfa1` media rules), so 3 cards no longer
	      // leave dead right-column space and aren't centered in an oversized gutter.
	      var isCfa1 = this.isCfaLevelOnePage();
	      var isCfa1WithPlus = isCfa1 && _constant.SHOW_CFA_UNLIMITED_PLUS;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        errorMessage ? _react2.default.createElement(
	          'div',
	          { className: 'sb_error_message' },
	          errorMessage
	        ) : _react2.default.createElement(
	          'div',
	          { className: "sb_page_container " + (isCfa1 ? "special_cfa1_width" : "") },
	          this.renderHeader(),
	          this.renderBillingSwitch(),
	          _react2.default.createElement(
	            'div',
	            { className: "sp_plans_grid " + (isCfa1WithPlus ? "sp_plans_grid_cfa1" : "") },
	            this.filterPackagesByTerm(packages, billingTerm).map(function (p) {
	              return _this10.renderPlanCard(p);
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectPackage;
	}(_react.Component);
	
	/* class SelectPackage extends Component { // old flow
	  constructor(props) {
	    super(props);
	    this.state = {
	      alert_status: false,
	      MessageTitle: language.LC().ALERT,
	      MessageContent: language.LC().ERROR,
	      exams: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      answered: [],
	      plan_data: '',
	      pack_class: 'hide_block',
	      exam_name: '',
	      exam_class: 'row',
	      extras_1: false,
	      extras_2: false,
	      checkedStatus: false,
	      disable: false,
	      isLoading: true,
	      China_price: 6.55,
	      canadian_price: 5.22,
	      usd_canadian_price: 1.26,
	      userRole: '',
	      partnerId: null,
	      package_data: null,
	    };
	
	    this.toggleAlert = this.toggleAlert.bind(this);
	  }
	
	  static contextTypes = {
	    router: React.PropTypes.object,
	  };
	
	  toggleAlert() {
	    this.setState((prevState) => ({ alert_status: !prevState.alert_status }));
	  }
	
	  getExams = () => {
	    this.context.router.push({ pathname: '/subscribe' });
	  };
	
	  async getPackages() {
	    const { token, idname, userRole, partnerId } = this.state;
	    const exam_id = parseInt(this.props.params.exam_id);
	    const data = { token, idname, exam_id };
	
	    try {
	      const packagesData = await FD.callAPI(
	        `${App_data.backend_api}/checkout_v1/getPackages`,
	        data,
	      );
	
	      if (!packagesData.success) {
	        this.setState({
	          ValidToken: false,
	          package_data: <div>{language.LC().NO_PACKAGE_FOUND}</div>,
	        });
	        return;
	      }
	
	      const examPlansDetails =
	        userRole === ROLES.PARTNER && partnerId
	          ? await retrieveSpecialPrice(partnerId, packagesData.exam_plans)
	          : packagesData.exam_plans;
	
	      const packageDetails = examPlansDetails.length ? (
	        examPlansDetails.map((item, index) => {
	          if (item.role === ROLES.EMPLOYEE && userRole !== ROLES.EMPLOYEE) return null;
	
	          const planExtras =
	            item.extras &&
	            item.extras.map((extra, index) => (
	              <label className='check_container' key={index} id={`extras_${item.id}_${extra.id}`}>
	                <CheckboxComponent
	                  checkedStatus={this.state.checkedStatus}
	                  id={`${item.id}_${extra.id}`}
	                  extrasPrice={extra.price}
	                  index={item.id}
	                />
	                <span className='checkmark' />
	                {renderHTMLContent(extra.tooltip_description, 'span', 'extras_desc')}
	                <span className='white_space_extras_price'>{`- $${extra.price}`}</span>
	              </label>
	            ));
	
	          const planDescription = renderHTMLContent(item.package_desc, 'div', 'plan_desc');
	          const { exam_name } = this.props.params;
	          const hideExtras =
	            item.package_category === 'mock' || exam_name === 'gmat_focus' || exam_name === 'ea';
	          const isUnlimited = item.package_val === 'unlimited';
	
	          return (
	            <div className='col-lg-4' key={index}>
	              <div className='plan_wrapper' id={`plan_wrapper_${item.id}`}>
	                <div className='plan_header'>
	                  {item.package_type}
	                  <img
	                    src={`${App_data.frontend_url}/img/subscription/greenTick.svg`}
	                    alt=''
	                    width='20'
	                    id={`purchasedBadge${item.id}`}
	                  />
	                </div>
	                <div className={`plan_price ${item.payment_interval ? 'font-4xl' : ''}`}>
	                  $
	                  <span id={`price_${item.id}`}>
	                    {item.payment_interval ? `${item.price}/${item.payment_interval}` : item.price}
	                  </span>
	                </div>
	                <div className='plan_text'>
	                  {planDescription}
	                  {!isUnlimited && !hideExtras && (
	                    <div className='plan_extras' style={{ position: 'relative' }}>
	                      <h4 className='extras_header'>{language.LC().EXTRAS}</h4>
	                      <div className='extras-cover'>{planExtras}</div>
	                    </div>
	                  )}
	                </div>
	                <BuyPackages
	                  idname={idname}
	                  token={token}
	                  itemval={item}
	                  exam_name={this.state.exam_name}
	                  {...this.props}
	                />
	              </div>
	            </div>
	          );
	        })
	      ) : (
	        <div>{language.LC().NO_PACKAGE_FOUND}</div>
	      );
	
	      this.setState({
	        ValidToken: true,
	        pack_class: 'row',
	        exam_name: this.props.params.exam_name,
	        exam_class: 'hide_block',
	        resp: packagesData,
	        isLoading: false,
	        package_data: packageDetails,
	      });
	    } catch (error) {
	      this.setState({ isLoading: false });
	    }
	  }
	
	  componentDidMount() {
	    const session = JSON.parse(localStorage.getItem('localstorageval')) || {};
	    const { idname, token } = session;
	    const data = { idname, token };
	
	    // FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then((resp) => {
	    userStore.getUserProfile().then((resp) => {
	      this.setState(
	        {
	          userRole: resp.role,
	          partnerId: resp.partnerID || null,
	          idname,
	          token,
	        },
	        this.getPackages,
	      );
	    });
	  }
	
	  render() {
	    const {
	      isLoading,
	      pack_class: packageClass,
	      package_data,
	      alert_status,
	      MessageTitle,
	      MessageContent,
	      exam_name,
	    } = this.state;
	
	    return (
	      <div className='animated fadeIn'>
	        {isLoading ? (
	          <Loader />
	        ) : packageClass === 'row' ? (
	          <div className={packageClass}>
	            <div className='col-lg-12 text-center subscription-card-cover subscription-plan-wrap'>
	              <div className='subscription-card'>
	                <Button
	                  type='button'
	                  className='btn btn-primary pointer_class mob_back padding-0'
	                  onClick={this.getExams}
	                >
	                  <i className='fa fa-arrow-left' aria-hidden='true' />
	                </Button>
	                <div className='subscription-heading-wrap'>
	                  <div className='subscription-img'>
	                    <img
	                      src={`${App_data.frontend_url}/img/subscription/subscription_icon2.svg`}
	                      alt='subscription icon'
	                      width='30'
	                    />
	                  </div>
	                  <h4>{EXAM_MAPPING[exam_name] || exam_name}</h4>
	                </div>
	              </div>
	            </div>
	
	            <div className='col-lg-12 text-center align-self-center'>
	              <div
	                className={`row subscription_wrap row-gap-3 ${package_data && package_data.length > 1 ? '' : 'package-alignment'}`}
	              >
	                {package_data}
	              </div>
	            </div>
	
	            <Modal
	              isOpen={alert_status}
	              toggle={this.toggleAlert}
	              className={`modal-danger ${this.props.className}`}
	            >
	              <ModalHeader toggle={this.toggleAlert}>{MessageTitle}</ModalHeader>
	              <ModalBody>
	                <strong>{MessageContent}</strong>
	              </ModalBody>
	              <ModalFooter>
	                <Button color='secondary' onClick={this.toggleAlert}>
	                  {language.LC().OK}
	                </Button>
	              </ModalFooter>
	            </Modal>
	          </div>
	        ) : null}
	      </div>
	    );
	  }
	} */
	
	exports.default = SelectPackage;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	__webpack_require__(122);
	
	var _toast = __webpack_require__(15);
	
	var _CommonUtils = __webpack_require__(41);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _analytics = __webpack_require__(117);
	
	var _subscriptionBadge = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	
	// Two rows is the ceiling (2026-09-01) — three overflowed the card.
	var MAX_TILE_ENTITLEMENTS = 2;
	
	var entitlementTier = function entitlementTier(item) {
	  var v = String(item && item.package_val || '').toLowerCase();
	  if (v === 'plus') return 4;
	  if (v === 'unlimited') return 3;
	  if (v === 'expensive') return 2;
	  if (v === 'simple') return 1;
	  return 0;
	};
	
	// Mirrors SelectPackage.isIncludedInPurchasedPackage's generic branch:
	// getPlanRank = tier * 1e6 + price * 1e3 + id, compared within the mock /
	// non-mock group. Owning "Mock Unlimited (All 3 Levels)" therefore hides
	// "Mock (Learn + Practice)" here exactly as the plan card marks it
	// "Included in Purchased Package".
	var entitlementRank = function entitlementRank(item) {
	  return entitlementTier(item) * 1000000 + Number(item && item.price || 0) * 1000 + Number(item && item.planId || 0);
	};
	
	var isMockEntitlement = function isMockEntitlement(item) {
	  return !!(item && item.package_category === 'mock');
	};
	
	var filterVisibleEntitlements = function filterVisibleEntitlements(entitlements) {
	  var list = Array.isArray(entitlements) ? entitlements : [];
	  if (list.length < 2) return list;
	
	  // A non-mock unlimited package covers every mock package for the course.
	  var hasNonMockUnlimited = false;
	  for (var i = 0; i < list.length; i++) {
	    if (!isMockEntitlement(list[i]) && entitlementTier(list[i]) >= 3) {
	      hasNonMockUnlimited = true;
	    }
	  }
	
	  var maxMockRank = -1;
	  var maxOtherRank = -1;
	  for (var _i = 0; _i < list.length; _i++) {
	    var r = entitlementRank(list[_i]);
	    if (isMockEntitlement(list[_i])) {
	      if (r > maxMockRank) maxMockRank = r;
	    } else if (r > maxOtherRank) maxOtherRank = r;
	  }
	
	  var kept = [];
	  for (var _i2 = 0; _i2 < list.length; _i2++) {
	    var item = list[_i2];
	    var isMock = isMockEntitlement(item);
	    if (isMock && hasNonMockUnlimited) continue;
	    var groupMax = isMock ? maxMockRank : maxOtherRank;
	    if (entitlementRank(item) < groupMax) continue;
	    kept.push(item);
	  }
	
	  // Never blank the card: if the rules removed everything, fall back to the
	  // unfiltered list.
	  return (kept.length ? kept : list).slice(0, MAX_TILE_ENTITLEMENTS);
	};
	
	var Subscribe = function (_Component) {
	  _inherits(Subscribe, _Component);
	
	  function Subscribe(props) {
	    _classCallCheck(this, Subscribe);
	
	    var _this = _possibleConstructorReturn(this, (Subscribe.__proto__ || Object.getPrototypeOf(Subscribe)).call(this, props));
	
	    _this.onDocClick = function (e) {
	      if (!_this.state.expandedCourseKey) return;
	
	      var panel = e.target.closest && e.target.closest(".sb_enhance_panel");
	      var button = e.target.closest && e.target.closest(".sb_card_button_enhance");
	      if (panel || button) return;
	
	      _this.setState({ expandedCourseKey: null });
	    };
	
	    _this.state = {
	      isLoading: true,
	      courseCategories: [],
	      expandedCourseKey: null,
	      selectedAddonsByCourse: {},
	      errorMessage: "",
	      activeExtrasCourseKey: null,
	      isAddingToCart: false
	    };
	
	    _this.onToggleExpand = _this.onToggleExpand.bind(_this);
	    _this.onToggleAddon = _this.onToggleAddon.bind(_this);
	    _this.onAddExtrasToCart = _this.onAddExtrasToCart.bind(_this);
	    _this.onSelectCourse = _this.onSelectCourse.bind(_this);
	    return _this;
	  }
	
	  _createClass(Subscribe, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("mousedown", this.onDocClick, false);
	      this.loadCourses();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("mousedown", this.onDocClick, false);
	    }
	  }, {
	    key: 'loadCourses',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ isLoading: true, errorMessage: "" });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getAllExamPackagesByUserId").then(function (resp) {
	                  if (resp && resp.success) {
	                    _this2.setState({
	                      isLoading: false,
	                      courseCategories: resp.coursesByGroup,
	                      errorMessage: ""
	                    });
	                  } else {
	                    var msg = resp && resp.message ? resp.message : "Failed to load courses";
	                    _this2.setState({
	                      isLoading: false,
	                      courseCategories: [],
	                      errorMessage: msg
	                    });
	                    (0, _toast.showInformation)(msg);
	                  }
	                  return resp;
	                }).catch(function (err) {
	                  console.log(err);
	                  _this2.setState({
	                    isLoading: false,
	                    courseCategories: [],
	                    errorMessage: "Error loading courses"
	                  });
	                  (0, _toast.showFailure)("Error loading courses");
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadCourses() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadCourses;
	    }()
	  }, {
	    key: 'priceLabel',
	    value: function priceLabel(priceRange) {
	      var pr = priceRange || { min: 0, max: 0 };
	      var min = Number(pr.min || 0);
	      var max = Number(pr.max || 0);
	      if (min === max) return (0, _CommonUtils.formatMoney)(min);
	      return (0, _CommonUtils.formatMoney)(min) + " - " + (0, _CommonUtils.formatMoney)(max);
	    }
	  }, {
	    key: 'onSelectCourse',
	    value: function onSelectCourse(uiKey, primaryExamId) {
	      if (!uiKey || !primaryExamId) return;
	      this.props.router.push('/subscribe/selectPackage/' + uiKey + '/' + primaryExamId);
	    }
	  }, {
	    key: 'onToggleExpand',
	    value: function onToggleExpand(uiKey) {
	      var current = this.state.expandedCourseKey;
	      this.setState({
	        expandedCourseKey: current === uiKey ? null : uiKey
	      });
	    }
	  }, {
	    key: 'onToggleAddon',
	    value: function onToggleAddon(uiKey, addonId) {
	      var selectedMap = this.state.selectedAddonsByCourse || {};
	      var activeKey = this.state.activeExtrasCourseKey;
	
	      if (activeKey && activeKey !== uiKey) {
	        selectedMap = {};
	        activeKey = uiKey;
	      } else if (!activeKey) {
	        activeKey = uiKey;
	      }
	
	      var curCourseMap = selectedMap[uiKey] || {};
	      var nextCourseMap = Object.assign({}, curCourseMap);
	
	      if (nextCourseMap[addonId]) {
	        delete nextCourseMap[addonId];
	      } else {
	        nextCourseMap[addonId] = true;
	      }
	
	      var hasAny = Object.keys(nextCourseMap).length > 0;
	
	      var nextSelectedMap = Object.assign({}, selectedMap);
	      if (hasAny) nextSelectedMap[uiKey] = nextCourseMap;else delete nextSelectedMap[uiKey];
	
	      this.setState({
	        selectedAddonsByCourse: nextSelectedMap,
	        activeExtrasCourseKey: hasAny ? activeKey : null
	      });
	    }
	
	    /**
	     * Walk courseCategories to find the course by uiKey.
	     */
	
	  }, {
	    key: 'findCourseByUiKey',
	    value: function findCourseByUiKey(uiKey) {
	      var cats = this.state.courseCategories || [];
	      for (var i = 0; i < cats.length; i++) {
	        var items = cats[i] && cats[i].dataItems || [];
	        for (var j = 0; j < items.length; j++) {
	          if (items[j] && items[j].uiKey === uiKey) return items[j];
	        }
	      }
	      return null;
	    }
	
	    /**
	     * Fire conversion tracking after addons are successfully added to cart.
	     * Sums the prices of the selected addons for the analytics value.
	     */
	
	  }, {
	    key: 'fireAddonsAddToCartTracking',
	    value: function fireAddonsAddToCartTracking(uiKey, addonIds, purchasedCourse) {
	      try {
	        var course = this.findCourseByUiKey(uiKey);
	        var addons = course && course.addons && (course.addons.remaining || course.addons.available) || [];
	        var idSet = new Set(addonIds.map(Number));
	
	        var value = 0;
	        for (var i = 0; i < addons.length; i++) {
	          var a = addons[i];
	          if (a && idSet.has(Number(a.id))) {
	            value += Number(a.price) || 0;
	          }
	        }
	
	        var profile = _userStore2.default && _userStore2.default.profileInfo || {};
	        (0, _analytics.trackAddToCart)({
	          exam: course && course.uiTitle || '',
	          packageType: purchasedCourse && purchasedCourse.package_type || (course && course.uiTitle ? course.uiTitle + ' — Add-ons' : 'Add-ons'),
	          value: value,
	          userName: profile.username || '',
	          userEmail: profile.email || '',
	          source: _userStore2.default && _userStore2.default.landingSource || 'organic',
	          affiliateName: _userStore2.default && _userStore2.default.landingSourceName || null
	        });
	      } catch (e) {
	        // eslint-disable-next-line no-console
	        console.warn('Subscribe addons trackAddToCart failed:', e && e.message);
	      }
	    }
	  }, {
	    key: 'onAddExtrasToCart',
	    value: function onAddExtrasToCart(purchasedCourse) {
	      var _this3 = this;
	
	      if (!purchasedCourse) return;
	
	      var examId = Number(purchasedCourse.exam_id || 0);
	      var planId = Number(purchasedCourse.package_id || 0);
	
	      if (!(examId > 0) || !(planId > 0)) {
	        (0, _toast.showInformation)("Missing examId or planId for this course.");
	        return;
	      }
	
	      var selectedMap = this.state.selectedAddonsByCourse || {};
	      var activeKey = this.state.activeExtrasCourseKey;
	
	      if (!activeKey || !selectedMap[activeKey]) {
	        (0, _toast.showInformation)("Please select add-ons first.");
	        return;
	      }
	
	      var courseMap = selectedMap[activeKey] || {};
	      var addonIds = Object.keys(courseMap).map(function (k) {
	        return Number(k);
	      }).filter(function (n) {
	        return Number.isFinite(n) && n > 0;
	      });
	
	      if (!addonIds.length) {
	        (0, _toast.showInformation)("Please select add-ons first.");
	        return;
	      }
	
	      if (this.state.isAddingToCart) return;
	
	      this.setState({ isAddingToCart: true });
	
	      _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/addToUserCart", {
	        examId: examId,
	        planId: planId,
	        addonIds: addonIds,
	        type: "unlessUnlimited"
	      }).then(function (resp) {
	        if (resp && resp.success) {
	          // Conversion tracking — fire GTM/GA4/FB AddToCart events for the
	          // addons being added. Mirrors the legacy SelectExtras.js behaviour.
	          _this3.fireAddonsAddToCartTracking(activeKey, addonIds, purchasedCourse);
	
	          _this3.setState({
	            selectedAddonsByCourse: {},
	            activeExtrasCourseKey: null,
	            isAddingToCart: false
	          });
	
	          _this3.props.router.push("/cart");
	        } else {
	          var msg = resp && resp.message ? resp.message : "Failed to add add-ons to cart";
	          (0, _toast.showInformation)(msg);
	          _this3.setState({ isAddingToCart: false });
	        }
	        return resp;
	      }).catch(function () {
	        (0, _toast.showFailure)("Failed to add add-ons to cart");
	        _this3.setState({ isAddingToCart: false });
	      });
	    }
	  }, {
	    key: 'renderCourseCard',
	    value: function renderCourseCard(course, key) {
	      var _this4 = this;
	
	      if (!course) return null;
	
	      var _course$status = course.status,
	          status = _course$status === undefined ? "none" : _course$status,
	          _course$uiKey = course.uiKey,
	          uiKey = _course$uiKey === undefined ? "" : _course$uiKey,
	          _course$primaryExamId = course.primaryExamId,
	          primaryExamId = _course$primaryExamId === undefined ? null : _course$primaryExamId,
	          _course$addons = course.addons,
	          addons = _course$addons === undefined ? {} : _course$addons,
	          _course$purchasedCour = course.purchasedCourse,
	          purchasedCourse = _course$purchasedCour === undefined ? null : _course$purchasedCour,
	          _course$hasLifetimeAc = course.hasLifetimeAccess,
	          hasLifetimeAccess = _course$hasLifetimeAc === undefined ? false : _course$hasLifetimeAc,
	          _course$hasUnlimitedT = course.hasUnlimitedTutor,
	          hasUnlimitedTutor = _course$hasUnlimitedT === undefined ? false : _course$hasUnlimitedT,
	          _course$purchaseDate = course.purchaseDate,
	          purchaseDate = _course$purchaseDate === undefined ? null : _course$purchaseDate,
	          _course$expirationDat = course.expirationDate,
	          expirationDate = _course$expirationDat === undefined ? null : _course$expirationDat,
	          _course$includedBy = course.includedBy,
	          includedBy = _course$includedBy === undefined ? null : _course$includedBy,
	          _course$uiTitle = course.uiTitle,
	          uiTitle = _course$uiTitle === undefined ? "" : _course$uiTitle,
	          _course$priceRange = course.priceRange,
	          priceRange = _course$priceRange === undefined ? null : _course$priceRange,
	          _course$subscription = course.subscription,
	          subscription = _course$subscription === undefined ? null : _course$subscription,
	          _course$entitlements = course.entitlements,
	          entitlements = _course$entitlements === undefined ? [] : _course$entitlements;
	
	
	      var isPurchased = status === "purchased" && !!purchasedCourse;
	      var isIncluded = status === "included";
	      var isOwnedLike = isPurchased || isIncluded;
	
	      var abbr = key === "soa" ? "AE" : String(key || "").toUpperCase();
	      var expanded = this.state.expandedCourseKey === uiKey;
	
	      var remaining = addons && addons.remaining || [];
	      var selectedMap = (this.state.selectedAddonsByCourse || {})[uiKey] || {};
	      var selectedIds = Object.keys(selectedMap);
	
	      var canEnhance = isPurchased && remaining.length > 0;
	
	      if (isOwnedLike) {
	        var badgeText = "Purchased";
	        var planName = "—";
	
	        if (isPurchased) {
	          planName = purchasedCourse && purchasedCourse.package_type || "—";
	          // Shared vocabulary — see src/common/subscriptionBadge.js
	          badgeText = (0, _subscriptionBadge.getSubscriptionBadge)(subscription).label;
	        }
	
	        if (isIncluded) {
	          badgeText = "Included";
	          var srcType = includedBy && includedBy.package_type || "Unlimited package";
	          // planName = `${srcType} Bundle`;
	          planName = srcType;
	        }
	
	        var purchasedPretty = isPurchased ? (0, _CommonUtils.formatPrettyDate)(purchaseDate) : null;
	        var expiresPretty = isPurchased ? (0, _CommonUtils.formatPrettyDate)(expirationDate) : null;
	
	        // A course can carry several live entitlements at once — a mock package
	        // alongside a monthly subscription. The flat fields above describe only
	        // the primary one, so the rest were invisible. A single entitlement keeps
	        // the original markup exactly, so nothing moves for the common case.
	        var tileEntitlements = filterVisibleEntitlements(entitlements);
	        var showEntitlementList = isPurchased && tileEntitlements.length > 1;
	
	        return _react2.default.createElement(
	          'div',
	          {
	            className: "sb_page_container_card" + (isIncluded ? " sb_card_included" : ""),
	            key: uiKey
	            // onClick={() => this.onSelectCourse(uiKey, primaryExamId)}
	            , onClick: function onClick() {
	              return !isIncluded ? _this4.onSelectCourse(uiKey, primaryExamId) : null;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'sb_container_card_header' },
	            _react2.default.createElement(
	              'div',
	              { className: "sb_card_header_icon" + (isIncluded ? " sb_card_header_icon_included" : "") },
	              _react2.default.createElement(
	                'span',
	                { className: 'sb_header_icon_text' },
	                abbr
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_card_header_info' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sb_header_info_row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sb_header_info_title' },
	                  uiTitle
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: "sb_header_info_badge_purchased" + (isIncluded ? " sb_header_info_badge_included" : "") + (isPurchased ? " sb_badge_tone_" + (0, _subscriptionBadge.getSubscriptionBadge)(subscription).tone : "")
	                  },
	                  badgeText
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'sb_header_info_subtitle' },
	                planName
	              )
	            )
	          ),
	          showEntitlementList && _react2.default.createElement(
	            'div',
	            { className: 'sb_container_card_meta' },
	            tileEntitlements.map(function (item, idx) {
	              var itemSub = item.subscription || null;
	              var itemBadge = (0, _subscriptionBadge.getSubscriptionBadge)(itemSub);
	              var itemExpiry = itemSub && itemSub.expiryDate ? (0, _CommonUtils.formatPrettyDate)(itemSub.expiryDate) : item.expirationDate ? (0, _CommonUtils.formatPrettyDate)(item.expirationDate) : null;
	              var itemPurchased = item.purchaseDate ? (0, _CommonUtils.formatPrettyDate)(item.purchaseDate) : null;
	
	              return _react2.default.createElement(
	                'div',
	                { className: 'sb_card_entitlement', key: item.planId || idx },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sb_card_meta_row' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: "sb_header_info_badge_purchased sb_badge_tone_" + itemBadge.tone
	                    },
	                    itemBadge.label
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'sb_card_entitlement_name' },
	                    item.package_type || "—"
	                  )
	                ),
	                (item.hasLifetimeAccess || item.hasUnlimitedTutor) && _react2.default.createElement(
	                  'div',
	                  { className: 'sb_card_meta_row sb_card_meta_row_green' },
	                  item.hasLifetimeAccess && _react2.default.createElement(
	                    'div',
	                    { className: 'sb_card_meta_row' },
	                    _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_infinity' }),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Lifetime'
	                    )
	                  ),
	                  item.hasUnlimitedTutor && _react2.default.createElement(
	                    'div',
	                    { className: 'sb_card_meta_row' },
	                    _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_chat' }),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Unlimited Tutor'
	                    )
	                  )
	                ),
	                itemExpiry && !item.hasLifetimeAccess && _react2.default.createElement(
	                  'div',
	                  { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	                  _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_clock' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _subscriptionBadge.getSubscriptionDateLabel)(itemSub) + itemExpiry
	                  )
	                ),
	                itemPurchased && _react2.default.createElement(
	                  'div',
	                  { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	                  _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_calendar' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    (itemSub ? "Subscribed: " : "Purchased: ") + itemPurchased
	                  )
	                )
	              );
	            })
	          ),
	          isPurchased && !showEntitlementList && _react2.default.createElement(
	            'div',
	            { className: 'sb_container_card_meta' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_card_meta_row sb_card_meta_row_green' },
	              hasLifetimeAccess && _react2.default.createElement(
	                'div',
	                { className: 'sb_card_meta_row' },
	                _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_infinity' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Lifetime'
	                )
	              ),
	              hasUnlimitedTutor && _react2.default.createElement(
	                'div',
	                { className: 'sb_card_meta_row' },
	                _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_chat' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Unlimited Tutor'
	                )
	              )
	            ),
	            expiresPretty && _react2.default.createElement(
	              'div',
	              { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	              _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_clock' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _subscriptionBadge.getSubscriptionDateLabel)(subscription) + expiresPretty
	              )
	            ),
	            purchasedPretty && _react2.default.createElement(
	              'div',
	              { className: 'sb_card_meta_row sb_card_meta_row_grey' },
	              _react2.default.createElement('span', { className: 'sb_card_meta_icon sb_card_meta_icon_calendar' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                (subscription ? "Subscribed: " : "Purchased: ") + purchasedPretty
	              )
	            )
	          ),
	          canEnhance && _react2.default.createElement(
	            'div',
	            { className: 'sb_container_card_enhance', onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'sb_card_button_enhance',
	                onClick: function onClick() {
	                  return _this4.onToggleExpand(uiKey);
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'sb_enhance_plus' },
	                '+'
	              ),
	              ' Enhance Your Package'
	            ),
	            expanded && _react2.default.createElement(
	              'div',
	              { className: 'sb_enhance_panel' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sb_enhance_panel_title' },
	                'Enhance Your Package'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'sb_enhance_panel_list' },
	                remaining.map(function (addon) {
	                  var aid = String(addon.id);
	                  var checked = !!selectedMap[aid];
	
	                  return _react2.default.createElement(
	                    'div',
	                    {
	                      key: aid,
	                      className: "sb_enhance_panel_item" + (checked ? " sb_enhance_panel_item_active" : ""),
	                      onClick: function onClick() {
	                        return _this4.onToggleAddon(uiKey, aid);
	                      }
	                    },
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      checked: checked,
	                      onChange: function onChange() {
	                        return _this4.onToggleAddon(uiKey, aid);
	                      },
	                      onClick: function onClick(e) {
	                        return e.stopPropagation();
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sb_panel_item_name' },
	                      addon.title
	                    ),
	                    addon.tooltip_description && _react2.default.createElement(
	                      'span',
	                      { className: 'sb_addon_tooltip_wrap' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'sb_addon_tooltip_icon', 'aria-label': 'Info' },
	                        'i'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'sb_addon_tooltip_popup' },
	                        String(addon.tooltip_description).replace(/<[^>]*>/g, "")
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'sb_panel_item_price' },
	                      (0, _CommonUtils.formatMoney)(addon.price)
	                    )
	                  );
	                })
	              ),
	              selectedIds.length > 0 && _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'sb_enhance_panel_add_button',
	                  onClick: function onClick() {
	                    return _this4.onAddExtrasToCart(purchasedCourse);
	                  }
	                },
	                'Add ',
	                selectedIds.length,
	                ' Extra',
	                selectedIds.length > 1 ? "s" : "",
	                ' to Cart'
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          key: uiKey,
	          className: 'sb_page_container_card sb_card_not_purchased',
	          onClick: function onClick() {
	            return _this4.onSelectCourse(uiKey, primaryExamId);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'sb_container_card_header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sb_card_header_icon sb_icon_not_purchased' },
	            _react2.default.createElement(
	              'span',
	              { className: 'sb_header_icon_text sb_icon_text_not_purchased' },
	              abbr
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sb_card_header_info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_header_info_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sb_header_info_title' },
	                uiTitle
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_header_info_subtitle' },
	              this.priceLabel(priceRange)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCategory',
	    value: function renderCategory(category) {
	      var _this5 = this;
	
	      var items = category.dataItems || [];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'sb_container_category', key: category.key },
	        _react2.default.createElement(
	          'div',
	          { className: 'sb_category_header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sb_category_header_title' },
	            category.title,
	            " ",
	            _react2.default.createElement(
	              'span',
	              { className: 'sb_category_header_count' },
	              '(',
	              items.length,
	              ' ',
	              items.length === 1 ? "exam" : "exams",
	              ')'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'sb_page_container_grid' },
	          items.map(function (course) {
	            return _this5.renderCourseCard(course, category.key);
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          courseCategories = _state.courseCategories,
	          errorMessage = _state.errorMessage;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sb_page_container' },
	          errorMessage ? _react2.default.createElement(
	            'div',
	            { className: 'sb_error_message' },
	            errorMessage
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_container_header' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'sb_container_title' },
	                'Pick Your Exam Plan'
	              )
	            ),
	            courseCategories.map(function (c) {
	              return _this6.renderCategory(c);
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Subscribe;
	}(_react.Component);
	
	// import language from '../../assets/languages/language';
	// import GD from '../RestAPI/getData';
	// import {autorun} from "mobx";
	// import userStore from "../../store/userStore";
	
	/* class Subscribe extends Component { // old flow
	  constructor(props) {
	    super(props);
	    this.state = {
	      alert_status: false,
	      MessageTitle: `${language.LC().ALERT}`,
	      MessageContent: `${language.LC().ERROR}`,
	      exams: [],
	      token: '',
	      idname: '',
	      ValidToken: false,
	      chapter_id: '',
	      offset: 0,
	      limit: 10,
	      answered: [],
	      plan_data: '',
	      pack_class: 'hide_block',
	      exam_name: '',
	      exam_class: 'row',
	      extras_1: false,
	      extras_2: false,
	      checkedStatus: false,
	      disable: false,
	      selectedMenu: '',
	      // China_price: "",
	      China_price: 6.55,
	      canadian_price: 5.22,
	      usd_canadian_price: 1.26,
	      userRole: '',
	    };
	    this.toggleAlert = this.toggleAlert.bind(this);
	  }
	
	  static contextTypes = {
	    router: React.PropTypes.object,
	  };
	
	  toggleAlert() {
	    this.setState({
	      alert_status: !this.state.alert_status,
	    });
	  }
	
	  _getPackages = (item, e) => {
	    this.context.router.push({
	      pathname: `/subscribe/selectPackage/${item.exam_name}/${item.id}`,
	      state: {
	        exam: {
	          exam_id: item.id,
	          name: item.name,
	        },
	        China_price: this.state.China_price,
	      },
	    });
	  };
	  getChinaPrice = () => {
	    GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then(resp => {
	      // console.log("resunfnvd", resp);
	      // console.log("resunfnvd", resp.rates.CNY);
	      this.setState({
	        China_price: resp.rates.CNY,
	      });
	    });
	  };
	  componentDidMount() {
	    // this.getChinaPrice();
	    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	    var selectedMenu = localStorage.getItem('selectedmenu');
	
	    this.setState({
	      idname: storage_session['idname'],
	      token: storage_session['token'],
	      selectedMenu: selectedMenu,
	    });
	
	    var data = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	    };
	    FD.callAPI(App_data.backend_api + '/checkout_v1/getExams', data).then(resp => {
	      // console.log("resp", resp);
	
	      if (resp.success) {
	        this.setState({ ValidToken: true });
	        this.setState({ exams: resp.exams });
	        this.setState({ exam_name: resp.name });
	      } else {
	        this.setState({ ValidToken: false });
	      }
	      return resp;
	    });
	    var user_data = {
	      token: storage_session['token'],
	      idname: storage_session['idname'],
	    };
	    this.dispose = autorun(() => {
	      const profileInfo = userStore.profileInfo;
	      if(profileInfo == null) return;
	      const { role } = profileInfo || {};
	      this.setState({
	        userRole: role,
	      });
	    });
	    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
	    //   if (resp) {
	    //     const { profileInfo } = resp || {};
	    //     const { role } = profileInfo || {};
	    //     this.setState({
	    //       userRole: role,
	    //     });
	    //   }
	    // });
	  }
	
	  componentWillUnmount() {
	    if(this.dispose) this.dispose();
	  }
	
	  renderExamData = (exams, ids) => {
	    return exams.map((item, index) => {
	      if (ids.includes(item.id)) {
	        return (
	          <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={index}>
	            <div
	              className='question_bank_wrap pointer_class'
	              onClick={this._getPackages.bind(this, item)}
	            >
	              <div className='margin_bottom_30'>
	                <img
	                  src={App_data.frontend_url + '/img/subscription/subscription_icon4.svg'}
	                  alt=''
	                  width='50'
	                />
	              </div>
	              <div className='question_title'>
	                <a>{item.name}</a>
	              </div>
	              <div className='read_more'> {language.LC().BUY_NOW} </div>
	            </div>
	          </div>
	        );
	      } else {
	        return null;
	      }
	    });
	  };
	
	  render() {
	    var domainApp = localStorage.getItem('domainApp');
	    let exams = this.state.exams;
	    let data = '';
	    let exam_data = '';
	    let soa_exam_data = '';
	    let gmat_exam_data = '';
	    let ea_exam_data = '';
	    if (this.state.exams.length) {
	      data = this.renderExamData(exams, [1, 5, 6, 17], language.LC().CFA);
	      exam_data = this.renderExamData(exams, [2, 3, 4], language.LC().FRM);
	      soa_exam_data = this.renderExamData(exams, [7, 8, 9, 10], language.LC().SOA);
	      gmat_exam_data = this.renderExamData(exams, [13, 19], 'GMAT Exam');
	      ea_exam_data = this.renderExamData(exams, [14], 'Executive Assessment Exam');
	    } else {
	      data = (
	        <div className='loader_box'>
	          <div className='sk-circle'>
	            <div className='sk-circle1 sk-child' />
	            <div className='sk-circle2 sk-child' />
	            <div className='sk-circle3 sk-child' />
	            <div className='sk-circle4 sk-child' />
	            <div className='sk-circle5 sk-child' />
	            <div className='sk-circle6 sk-child' />
	            <div className='sk-circle7 sk-child' />
	            <div className='sk-circle8 sk-child' />
	            <div className='sk-circle9 sk-child' />
	            <div className='sk-circle10 sk-child' />
	            <div className='sk-circle11 sk-child' />
	            <div className='sk-circle12 sk-child' />
	            <div className='sk-circle13 sk-child' />
	          </div>
	        </div>
	      );
	    }
	
	    return (
	      <div className='animated fadeIn'>
	        <div className={this.state.exam_class}>
	          <div className='col-12 margin_bottom_20'>
	            <h1 className='section_head'>{language.LC().PICK_YOUR_EXAM}</h1>
	          </div>
	          <div className='col-12 seperator-block-wrap'>
	            <div className='card'>
	              <div className='card-block'>
	                {this.state.selectedMenu === 'soa_p' || this.state.selectedMenu === 'soa_fm' ? (
	                  <div>
	                    {renderExamBlock(language.LC().SOA, soa_exam_data)}
	                    {renderExamBlock(language.LC().CFA, data)}
	                    {renderExamBlock(language.LC().FRM, exam_data)}
	                    {renderExamBlock('GMAT Exam', gmat_exam_data)}
	                    {renderExamBlock('Executive Assessment Exam', ea_exam_data)}
	                  </div>
	                ) : this.state.selectedMenu === 'frm' ? (
	                  <div>
	                    {renderExamBlock(language.LC().FRM, exam_data)}
	                    {renderExamBlock(language.LC().CFA, data)}
	                    {renderExamBlock(language.LC().SOA, soa_exam_data)}
	                    {renderExamBlock('GMAT Exam', gmat_exam_data)}
	                    {renderExamBlock('Executive Assessment Exam', ea_exam_data)}
	                  </div>
	                ) : (
	                  <div>
	                    {renderExamBlock(language.LC().CFA, data)}
	                    {renderExamBlock(language.LC().FRM, exam_data)}
	                    {renderExamBlock(language.LC().SOA, soa_exam_data)}
	                    {renderExamBlock('GMAT Exam', gmat_exam_data)}
	                    {renderExamBlock('Executive Assessment Exam', ea_exam_data)}
	                  </div>
	                )}
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    );
	  }
	} */
	
	// Function to render exam block
	// const renderExamBlock = (title, examData) => (
	//   <div>
	//     <div className='text-center'>
	//       <div className='subscription-heading-wrap'>
	//         <div className='subscription-img'>
	//           <img
	//             src={App_data.frontend_url + '/img/subscription/subscription_icon2.svg'}
	//             alt=''
	//             width='30'
	//           />
	//         </div>
	//         <h4>{title}</h4>
	//       </div>
	//     </div>
	//     <br />
	//     <div className='row plans-wrap'>{examData}</div>
	//   </div>
	// );
	
	exports.default = Subscribe;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var RecurringPlanDetail = function (_Component) {
	  _inherits(RecurringPlanDetail, _Component);
	
	  function RecurringPlanDetail(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, RecurringPlanDetail);
	
	    var _this = _possibleConstructorReturn(this, (RecurringPlanDetail.__proto__ || Object.getPrototypeOf(RecurringPlanDetail)).call(this, props));
	
	    _this.cancelSubscriptionToggle = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(packageId, subscriptionId, subscriptionScheduleId) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (packageId) {
	                  _this.setState({
	                    isCancelSubscription: !_this.state.isCancelSubscription
	                  });
	                  _this.packageId = packageId;
	                  _this.subscriptionId = subscriptionId;
	                  _this.subscriptionScheduleId = subscriptionScheduleId;
	                } else {
	                  _this.setState({ isCancelSubscription: !_this.state.isCancelSubscription });
	                }
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.getPackages = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var result;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/get-recurring-plan-details', data);
	
	              case 2:
	                result = _context2.sent;
	
	
	                // The route now returns a resolved `subscriptions` array (exam_name,
	                // package_type and payment_interval joined from the catalogue) instead of
	                // the raw users row for the client to parse.
	                if (result && result.success && Array.isArray(result.subscriptions)) {
	                  _this.setState({
	                    subscriptionList: result.subscriptions,
	                    currentDate: result.currentDate
	                  });
	                }
	                _this.setState({
	                  isLoading: false
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.cancelSubscription = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state, token, idname, package_id;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state = _this.state, token = _this$state.token, idname = _this$state.idname;
	              package_id = _this.packageId;
	
	              // Only package_id is sent now — the backend resolves the Stripe id from
	              // the caller's own subscription_details. Previously it cancelled whatever
	              // subscriptionId the client supplied.
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/cancelSubscription', {
	                token: token,
	                idname: idname,
	                package_id: package_id
	              }).then(function (resp) {
	                if (resp.success) {
	                  var _this$state2 = _this.state,
	                      _token = _this$state2.token,
	                      _idname = _this$state2.idname;
	
	                  var data = {
	                    token: _token,
	                    idname: _idname
	                  };
	                  _this.setState({
	                    isCancelSubscription: false,
	                    packageId: '',
	                    subscriptionId: ''
	                  }, function () {
	                    (0, _toast.showSuccess)(resp.accessUntil ? 'Cancelled. You keep access until ' + (0, _moment2.default)(resp.accessUntil).format('ll') : 'Your subscription has been cancelled');
	                    _this.getPackages({ token: _token, idname: _idname });
	                  });
	                } else {
	                  _this.setState({
	                    isCancelSubscription: false,
	                    packageId: '',
	                    subscriptionId: ''
	                  }, function () {
	                    (0, _toast.showFailure)(resp && resp.message || 'Something went wrong');
	                  });
	                }
	              });
	
	            case 3:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.state = {
	      token: '',
	      idname: '',
	      subscriptionList: [],
	      isLoading: true,
	      isCancelSubscription: false,
	      currentDate: new Date()
	    };
	    _this.packageId = '';
	    _this.subscriptionId = '';
	    _this.subscriptionScheduleId = '';
	    return _this;
	  }
	
	  _createClass(RecurringPlanDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scroll(0, 0);
	      this.props.params ? this.setState({ username: this.props.params.username }) : null;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      this.getPackages(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          _state$subscriptionLi = _state.subscriptionList,
	          subscriptionList = _state$subscriptionLi === undefined ? [] : _state$subscriptionLi,
	          currentDate = _state.currentDate;
	
	      var subscriptionDetails = _react2.default.createElement(
	        'td',
	        { className: 'text-center pt-3', colSpan: '7', contentEditable: 'false' },
	        _react2.default.createElement(
	          'b',
	          null,
	          'No Subscription Plan Available.'
	        )
	      );
	
	      var count = 1;
	      if (subscriptionList.length) {
	        // No `monthly_payment` gate here any more: /get-recurring-plan-details
	        // returns recurring subscriptions ONLY, so re-filtering on a field the
	        // route no longer sends rendered an empty table.
	        subscriptionDetails = subscriptionList.map(function (tableValues, index) {
	          return _react2.default.createElement(
	            'tbody',
	            { key: index },
	            _react2.default.createElement(
	              'tr',
	              { key: index },
	              _react2.default.createElement(
	                'td',
	                null,
	                count++
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'exam-name' },
	                tableValues.exam_name || tableValues.package_type || '-'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                tableValues.package_type
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  tableValues.amount === null || tableValues.amount === undefined ? '\u2014' : '$' + tableValues.amount,
	                  tableValues.amount !== null && tableValues.amount !== undefined && tableValues.payment_interval ? '/' + tableValues.payment_interval : ''
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                tableValues.expiryDate ? (0, _moment2.default)(tableValues.expiryDate).format('ll') : '—'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                tableValues.status === 'expired' ? _react2.default.createElement(
	                  'div',
	                  { className: 'text-danger' },
	                  _language2.default.LC().EXPIRED
	                ) : tableValues.status === 'cancelling' ? _react2.default.createElement(
	                  'div',
	                  { className: 'text-warning' },
	                  'Cancelled'
	                ) : tableValues.status === 'past_due' ? _react2.default.createElement(
	                  'div',
	                  { className: 'text-danger' },
	                  'Payment failed'
	                ) : 'Active'
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'text-center' },
	                tableValues.subscriptionId || tableValues.subscriptionScheduleId ? _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn custom-btn-danger pointer_class',
	                    onClick: function onClick() {
	                      return (
	                        // this.cancelSubscription(tableValues.packageId, tableValues.subscriptionId)
	                        _this3.cancelSubscriptionToggle(tableValues.package_id, tableValues.subscriptionId, tableValues.subscriptionScheduleId)
	                      );
	                    },
	                    disabled: tableValues.cancelledSubscription
	                  },
	                  tableValues.cancelledSubscription ? 'Cancelled' : 'Cancel Subscription'
	                ) : '-'
	              )
	            )
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header subscription-header d-flex align-items-center justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().RECURRING_SUBSCRIPTION_DETAIL
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class mb-0',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                ' ',
	                _language2.default.LC().GO_TO_PROFILE,
	                ' '
	              )
	            )
	          ),
	          this.state.isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            { id: 'table_responsive_wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-responsive order_his_tb' },
	              _react2.default.createElement(
	                'table',
	                { className: 'cart_table table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().ID
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().EXAM_NAME
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().PACKAGE
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().AMOUNT
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Renewal / Access Until'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().STATUS
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { className: 'text-center' },
	                      _language2.default.LC().ACTION
	                    )
	                  )
	                ),
	                subscriptionDetails
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.isCancelSubscription,
	            toggle: this.cancelSubscriptionToggle,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'Cancel subscription',
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', color: 'secondary', onClick: this.cancelSubscriptionToggle },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center cancel_sub' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Are you sure you want to cancel your subscription?'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                'You will keep access until the end of the period you have already paid for.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-center flex-small-wrap', style: { gap: '10px' } },
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-primary',
	                    color: 'primary',
	                    onClick: function onClick() {
	                      return _this3.cancelSubscriptionToggle();
	                    }
	                  },
	                  'Keep subscription'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  {
	                    className: 'btn btn-sm btn-danger',
	                    color: 'danger',
	                    onClick: this.cancelSubscription
	                  },
	                  'Yes, cancel'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RecurringPlanDetail;
	}(_react.Component);
	
	RecurringPlanDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = RecurringPlanDetail;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _language = __webpack_require__(4);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _function = __webpack_require__(10);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _constant = __webpack_require__(9);
	
	var _subscriptionBadge = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable*/
	var SubscriptionDetail = function (_Component) {
	  _inherits(SubscriptionDetail, _Component);
	
	  function SubscriptionDetail(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SubscriptionDetail);
	
	    var _this = _possibleConstructorReturn(this, (SubscriptionDetail.__proto__ || Object.getPrototypeOf(SubscriptionDetail)).call(this, props));
	
	    _this.cancelSubscriptionToggle = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(packageId, subscriptionId, subscriptionScheduleId) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (packageId) {
	                  _this.setState({
	                    isCancelSubscription: !_this.state.isCancelSubscription,
	                    packageId: packageId,
	                    subscriptionId: subscriptionId,
	                    subscriptionScheduleId: subscriptionScheduleId
	                  });
	                } else {
	                  _this.setState({ isCancelSubscription: !_this.state.isCancelSubscription });
	                }
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onCancelSubscription = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.state.packageId, _this.state.subscriptionId;
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.getPackages = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                console.log('this API will be call again', data);
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getProfileInfo', data).then(function (resp) {
	                  if (resp.success) {
	                    _this.setState({ ValidToken: true, profileInfo: resp.profileInfo });
	                    if (resp.profileInfo.exam_selected !== '') {
	                      _fetchData2.default.callAPI(_App_data2.default.backend_api + '/user/getPackages', data).then(function (resp_package) {
	                        if (resp_package.success) {
	                          _this.setState({
	                            examPlan: resp_package.exam_plans
	                          });
	                        }
	                        var data_arr = JSON.parse(resp.profileInfo.exam_selected);
	                        var dataset = Object.assign({}, data, {
	                          examid: data_arr
	                        });
	                        _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(function (resp_exam) {
	                          if (resp_exam.success) {
	                            var exam_data = resp_exam.examData;
	                            _this.setState({
	                              examData: exam_data,
	                              examDetails: resp_exam.examdetails
	                            });
	
	                            // `examPlan` is filtered by users.exam_package, which the
	                            // admin cancel mutates: dropping a plan there removes it from
	                            // the catalogue list while `cancel_at_period_end` keeps the
	                            // entitlement alive to the end of the paid period. Union in
	                            // `entitlementPlans` (every plan the user actually holds) so
	                            // a cancelled-but-still-active subscription keeps its row.
	                            var planList = (resp_exam.examPlan || []).slice();
	                            var seenPlanIds = {};
	                            for (var pi = 0; pi < planList.length; pi++) {
	                              seenPlanIds[String(planList[pi].id)] = true;
	                            }
	                            var extraPlans = resp_exam.entitlementPlans || [];
	                            for (var ei = 0; ei < extraPlans.length; ei++) {
	                              if (!seenPlanIds[String(extraPlans[ei].id)]) {
	                                seenPlanIds[String(extraPlans[ei].id)] = true;
	                                planList.push(extraPlans[ei]);
	                              }
	                            }
	
	                            resp_exam.examData.map(function (examData) {
	                              examData.levels.map(function (levelsItem) {
	                                planList.map(function (examPlanItem) {
	                                  // Match on package_id when the level carries one.
	                                  // Matching on package_val alone paired a monthly entry
	                                  // with its 12-month twin (79/1 both 'simple', 80/2 both
	                                  // 'expensive'), so the yearly plan row rendered the
	                                  // monthly's expiry — and the findElementIndex guard
	                                  // below meant the correct entry could never fix it.
	                                  // package_val remains the fallback for legacy entries
	                                  // written before package_id was emitted.
	                                  var levelPackageId = levelsItem.package_id === undefined || levelsItem.package_id === null ? null : Number(levelsItem.package_id);
	                                  var matchesPlan = levelPackageId !== null ? levelPackageId === Number(examPlanItem.id) : levelsItem.package_val === examPlanItem.package_val;
	
	                                  if (matchesPlan && examPlanItem.exam_id === examData.exam_id) {
	                                    resp_exam.examdetails.map(function (examName) {
	                                      if (examData.exam_id === examName.id) {
	                                        var findElementIndex = _this.state.new_table_array.findIndex(function (element) {
	                                          return element.packageId == examPlanItem.id;
	                                        });
	                                        if (findElementIndex === -1) {
	                                          _this.setState(function (prevState) {
	                                            return {
	                                              new_table_array: [].concat(_toConsumableArray(prevState.new_table_array), [{
	                                                packageId: examPlanItem.id,
	                                                payment_interval: examPlanItem.payment_interval,
	                                                subscriptionId: levelsItem.subscriptionId,
	                                                subscriptionScheduleId: levelsItem.subscriptionScheduleId,
	                                                cancelledSubscription: levelsItem.cancelledSubscription,
	                                                exam_name: examName.name,
	                                                package_type: examPlanItem.package_type,
	                                                expiryDate: levelsItem.expiryDate,
	                                                status: levelsItem.isActive,
	                                                subscriptionState: levelsItem.subscription_state
	                                              }])
	                                            };
	                                          });
	                                        } else {
	                                          var newData = _this.state.new_table_array;
	
	                                          newData[findElementIndex] = Object.assign({}, newData[findElementIndex], {
	                                            cancelledSubscription: levelsItem.cancelledSubscription
	                                          });
	                                          console.log('newData', newData);
	                                          _this.setState(function (prevState) {
	                                            return {
	                                              new_table_array: newData
	                                            };
	                                          });
	                                        }
	                                      }
	                                    });
	                                  }
	                                });
	                              });
	                            });
	                            _this.setState({
	                              isLoading: false
	                            });
	                          }
	                        });
	                      });
	                    } else {
	                      _this.setState({
	                        no_result_display: '<td colspan="6" className="" align="center">No Subscription Found</td>',
	                        isLoading: false
	                      });
	                    }
	                  } else {
	                    _this.setState({ ValidToken: false });
	                  }
	                });
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.cancelSubscription = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$state, token, idname, package_id, subscriptionId, subscriptionScheduleId, subscriptionObject;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this$state = _this.state, token = _this$state.token, idname = _this$state.idname, package_id = _this$state.packageId, subscriptionId = _this$state.subscriptionId, subscriptionScheduleId = _this$state.subscriptionScheduleId;
	              subscriptionObject = {
	                subscriptionId: subscriptionId
	              };
	
	
	              console.log('subscriptionScheduleId', subscriptionScheduleId);
	              if (subscriptionScheduleId && !subscriptionId) {
	                subscriptionObject = {
	                  subscriptionScheduleId: subscriptionScheduleId
	                };
	              }
	
	              _fetchData2.default.callAPI(_App_data2.default.backend_api + '/checkout_v1/cancelSubscription', Object.assign({
	                token: token,
	                idname: idname
	              }, subscriptionObject, {
	                package_id: package_id
	              })).then(function (resp) {
	                if (resp.success) {
	                  var _this$state2 = _this.state,
	                      _token = _this$state2.token,
	                      _idname = _this$state2.idname;
	
	                  var data = {
	                    token: _token,
	                    idname: _idname
	                  };
	                  _this.setState({
	                    isCancelSubscription: false,
	                    packageId: '',
	                    subscriptionId: ''
	                  }, function () {
	                    (0, _toast.showSuccess)('Your subscription has been cancelled');
	                    _this.getPackages({ token: _token, idname: _idname });
	                  });
	                } else {
	                  _this.setState({
	                    isCancelSubscription: false,
	                    packageId: '',
	                    subscriptionId: ''
	                  }, function () {
	                    (0, _toast.showFailure)('Something went wrong');
	                  });
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.state = {
	      token: '',
	      idname: '',
	      ValidToken: false,
	      examData: '',
	      examPlan: '',
	      examDetails: '',
	      new_table_array: [],
	
	      no_result_display: '',
	      profileInfo: '',
	      isLoading: true,
	      isCancelSubscription: false
	    };
	    return _this;
	  }
	
	  _createClass(SubscriptionDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scroll(0, 0);
	      this.props.params ? this.setState({ username: this.props.params.username }) : null;
	      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
	      this.setState({ idname: storage_session['idname'] });
	      this.setState({ token: storage_session['token'] });
	      var data = {
	        token: storage_session['token'],
	        idname: storage_session['idname']
	      };
	      this.getPackages(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var subscription_data = this.state.examData;
	      var showPurchasedPkgDetails = [];
	      var profileInfo = this.state.profileInfo;
	
	      var unlimitedData = '';
	      var tableObject = {
	        exam_name: '',
	        package_type: '',
	        expiryDate: '',
	        status: ''
	      };
	      // this.state.examData.map((examData) => {
	      //   examData.level.map((levelsItem) => {
	      //     this.state.examPlan.map((examPlanItem) => {
	      //       if (
	      //         levelsItem.package_val === examPlanItem.package_val &&
	      //         examPlanItem.exam_id === examData.exam_id
	      //       ) {
	      //         this.state.examDetails.map((examName) => {
	      //           if (examData.exam_id === examName.id) {
	      //             // tableObject.expiryDate = levelsItem.expiryDate;
	      //             // tableObject.status = levelsItem.isActive;
	      //             // tableObject.package_type = examPlanItem.package_type;
	      //             new_table_array.push({
	      //               exam_name:examName.name ,
	      //               package_type: examPlanItem.package_type,
	      //               expiryDate: levelsItem.expiryDate,
	      //               status: levelsItem.isActive,
	      //             });
	      //           }
	      //         });
	      //       }
	      //     });
	      //   });
	      // });
	      if (profileInfo.cfaUnlimitedActiveExam === 'cfa' && profileInfo.cfaUnlimitedPackage === 'true') {
	        // #216 — distinguish CFA Unlimited+ (pkg 78) from CFA Unlimited (pkg 15)
	        // by inspecting exam_package. Both owners share the cfaUnlimitedPackage
	        // fast-path flag, so it alone cannot identify the purchased tier.
	        //
	        // Feature flag: while `SHOW_CFA_UNLIMITED_PLUS` is false the Plus branding
	        // is suppressed even for users who own pkg 78 — they see the plain
	        // "CFA Unlimited" label instead. Entitlement is unaffected.
	        var ownedPlanIds = [];
	        try {
	          ownedPlanIds = JSON.parse(profileInfo.exam_package || '[]') || [];
	        } catch (e) {
	          ownedPlanIds = [];
	        }
	        var ownsPlusPlanId = Array.isArray(ownedPlanIds) && ownedPlanIds.map(Number).indexOf(78) !== -1;
	        var hasPlusPackage = _constant.SHOW_CFA_UNLIMITED_PLUS && ownsPlusPlanId;
	        var unlimitedPackageName = hasPlusPackage ? 'CFA Unlimited+ Package (All 3 Levels)' : 'CFA Unlimited Package (All 3 Levels)';
	
	        unlimitedData = _react2.default.createElement(
	          'tr',
	          { key: '45' },
	          _react2.default.createElement(
	            'td',
	            null,
	            ' 0'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'exam-name' },
	            ' CFA Level I'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            unlimitedPackageName
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            ' Lifetime valid'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Active'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'text-center' },
	            ' - '
	          )
	        );
	      }
	      // var unique = array.filter((v, i, a) =>{ return a.indexOf(v) === i});
	      // console.log('agni parikshaaa==2222======>', unique);
	
	      // console.log(subscription_data,"<================subscription_data","\n",this.state.examPlan,"<===============this.state.examPlan")
	      // if (subscription_data.length) {
	      //   let count = 1;
	      //   showPurchasedPkgDetails = subscription_data.map((item, index) => {
	      //     return (
	      //       <tbody key={index}>
	      //         {item.levels.length
	      //           ? this.state.examPlan.map((data, index) =>
	      //                item.exam_id === data.exam_id
	      //                 ? item.levels.map((levelItem, levelIndex) => {
	      //                   console.log("item.exam_id === data.exam_id",levelItem.package_id === data.id)
	      //                     return levelItem.package_id == data.id ? (
	      //                       <tr key={levelIndex}>
	      //                         <td>{count++}</td>
	      //                         {item.exam_id === data.exam.id ? (
	      //                           <td className='exam-name'>{data.exam.name}</td>
	      //                         ) : null}
	      //                         {item.exam_id === data.exam.id &&
	      //                         levelItem.package_val === data.package_val ? (
	      //                           <td>{data.package_type}</td>
	      //                         ) : null}
	      //                         <td>
	      //                           {console.log(
	      //                             'data',
	      //                             data,
	      //                             'levelItem',
	      //                             levelItem
	      //                           )}
	      //                           {levelItem.expiryDate
	      //                             ? moment(levelItem.expiryDate).format('ll')
	      //                             : 'Lifetime valid'}
	      //                         </td>
	      //                         <td>
	      //                           {levelItem.isActive ? (
	      //                             'Active'
	      //                           ) : (
	      //                             <div className='text-danger'>
	      //                               {language.LC().EXPIRED}
	      //                             </div>
	      //                           )}
	      //                         </td>
	      //                         <td className='text-center'>
	      //                           {data &&
	      //                           data.payment_interval &&
	      //                           data.payment_interval.includes('month') ? (
	      //                             <button
	      //                               type='button'
	      //                               className='btn custom-btn-danger pointer_class'
	      //                               onClick={() =>
	      //                                 this.cancelSubscription(
	      //                                   levelItem.package_id,
	      //                                   levelItem.subscriptionId
	      //                                 )
	      //                               }
	      //                               disabled={levelItem.cancelledSubscription}
	      //                             >
	      //                               Cancel Subscription
	      //                             </button>
	      //                           ) : (
	      //                             '-'
	      //                           )}
	      //                         </td>
	      //                       </tr>
	      //                     ) : null;
	      //                   })
	      //                 : null
	      //             )
	      //           : null}
	      //       </tbody>
	      //     );
	      //   });
	      // }
	
	      var count = 1;
	      // #216 — When the hardcoded "CFA Unlimited / Unlimited+" row renders above
	      // (driven by cfaUnlimitedPackage='true'), skip pkg 15 and pkg 78 entries
	      // in the per-package table to avoid the row duplicating.
	      var CFA_ALL_LEVELS_PLAN_IDS = [15, 78];
	      var displayRows = unlimitedData ? this.state.new_table_array.filter(function (row) {
	        return CFA_ALL_LEVELS_PLAN_IDS.indexOf(Number(row.packageId)) === -1;
	      }) : this.state.new_table_array;
	
	      if (displayRows.length) {
	        showPurchasedPkgDetails = displayRows.map(function (tableValues, index) {
	          return _react2.default.createElement(
	            'tbody',
	            { key: index },
	            _react2.default.createElement(
	              'tr',
	              { key: index },
	              _react2.default.createElement(
	                'td',
	                null,
	                count++
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'exam-name' },
	                tableValues.exam_name
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                tableValues.package_type
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                tableValues.expiryDate ? (0, _subscriptionBadge.getSubscriptionDateLabel)(tableValues.subscriptionState ? { status: tableValues.subscriptionState } : null) + (0, _moment2.default)(tableValues.expiryDate).format('ll') : 'Lifetime valid'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                tableValues.subscriptionState ? _react2.default.createElement(
	                  'div',
	                  {
	                    className: _subscriptionBadge.SUBSCRIPTION_BADGE[tableValues.subscriptionState] && _subscriptionBadge.SUBSCRIPTION_BADGE[tableValues.subscriptionState].tone === 'danger' ? 'text-danger' : ''
	                  },
	                  _subscriptionBadge.SUBSCRIPTION_BADGE[tableValues.subscriptionState] ? _subscriptionBadge.SUBSCRIPTION_BADGE[tableValues.subscriptionState].label : ''
	                ) : tableValues.status ? 'Active' : _react2.default.createElement(
	                  'div',
	                  { className: 'text-danger' },
	                  _language2.default.LC().EXPIRED
	                )
	              )
	            )
	          );
	        });
	      }
	
	      if (profileInfo.cfaUnlimitedActiveExam === '' && profileInfo.subscription_details === '' && profileInfo.exam_package === '') {
	        showPurchasedPkgDetails = _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: '5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _language2.default.LC().NO_SUBSCRIPTION_DETAIL
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card height_70vh' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-header subscription-header d-flex align-items-center justify-content-between' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mb-1 d-inline-block' },
	              _language2.default.LC().SUBSCRIPTION_DETAIL
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-actions float-md-right' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-primary pointer_class mb-0',
	                  onClick: _function._getProfile.bind(this, this.state.username)
	                },
	                ' ',
	                _language2.default.LC().GO_TO_PROFILE,
	                ' '
	              )
	            )
	          ),
	          this.state.isLoading ? _react2.default.createElement(_loader2.default, null) : _react2.default.createElement(
	            'div',
	            { id: 'table_responsive_wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-responsive order_his_tb' },
	              _react2.default.createElement(
	                'table',
	                { className: 'cart_table table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().ID
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().EXAM_NAME
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().PACKAGE
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().EXPIRY_DATE
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      _language2.default.LC().STATUS
	                    )
	                  )
	                ),
	                unlimitedData ? unlimitedData : null,
	                console.log('no RESULT', this.state.no_result_display),
	                showPurchasedPkgDetails.length ? showPurchasedPkgDetails :
	                // #216 — if the hardcoded unlimited/plus row is already
	                // shown, don't also render the "no subscription" fallback.
	                unlimitedData ? null : (0, _function.renderHTMLContent)(this.state.no_result_display, "td", "text-center pt-3", { colSpan: 6, contentEditable: "false" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Modal,
	          {
	            isOpen: this.state.isCancelSubscription,
	            toggle: this.cancelSubscriptionToggle,
	            className: 'modal-primary ' + this.props.className
	          },
	          _react2.default.createElement(
	            _reactstrap.ModalHeader,
	            null,
	            'Cancel subscription',
	            _react2.default.createElement(
	              _reactstrap.Button,
	              { className: 'close', color: 'secondary', onClick: this.cancelSubscriptionToggle },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.ModalBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'margin_bottom_20' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Are you sure you want to cancel your subscription'
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Button,
	                {
	                  className: 'btn btn-sm btn-primary',
	                  color: 'primary',
	                  onClick: this.cancelSubscription
	                },
	                _language2.default.LC().OK
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SubscriptionDetail;
	}(_react.Component);
	
	SubscriptionDetail.contextTypes = {
	  router: _react2.default.PropTypes.object
	};
	exports.default = SubscriptionDetail;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGtmModule = __webpack_require__(89);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	__webpack_require__(122);
	
	var _constant = __webpack_require__(9);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _toast = __webpack_require__(15);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	/* eslint-disable*/
	
	var Thankyou = function (_Component) {
	  _inherits(Thankyou, _Component);
	
	  function Thankyou(props) {
	    _classCallCheck(this, Thankyou);
	
	    var _this = _possibleConstructorReturn(this, (Thankyou.__proto__ || Object.getPrototypeOf(Thankyou)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      errorMessage: "",
	      orderId: props.params && props.params.order_id || null,
	      orderData: null,
	      amount: 0,
	      paymentType: "",
	      createdAt: null
	    };
	
	    _this.loadUserOrder = _this.loadUserOrder.bind(_this);
	    _this.goToCourses = _this.goToCourses.bind(_this);
	
	    // Idempotency guard so React strict-mode double-mount, page navigation
	    // back, etc. cannot fire conversion tags twice for the same order_id.
	    _this._conversionFired = false;
	    return _this;
	  }
	
	  _createClass(Thankyou, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.state.orderId) {
	        this.setState({ isLoading: false, errorMessage: "Missing order id" });
	        return;
	      }
	      this.loadUserOrder();
	    }
	  }, {
	    key: 'loadUserOrder',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ isLoading: true, errorMessage: "" });
	
	                _fetchData2.default.callAPI(_App_data2.default.backend_api + "/checkout_v1/getOrdersbyid", { order_id: this.state.orderId }).then(function (resp) {
	                  if (resp && resp.success) {
	                    var parsed = null;
	                    try {
	                      parsed = typeof resp.orders_val === "string" ? JSON.parse(resp.orders_val) : resp.orders_val;
	                    } catch (e) {
	                      parsed = null;
	                    }
	
	                    _this2.setState({
	                      isLoading: false,
	                      errorMessage: "",
	                      orderData: parsed,
	                      amount: Number(resp.amount) || 0,
	                      paymentType: resp.payment_type || "",
	                      createdAt: resp.createdAt || null
	                    });
	
	                    // Fire conversion tags for marketing/analytics platforms.
	                    // Was lost when this component was rewritten alongside /createOrder
	                    // (#174 conversion-tracking regression). Must run for every
	                    // successful purchase that lands on /thankyou/:order_id.
	                    _this2.fireConversionTags({
	                      order: parsed,
	                      amount: Number(resp.amount) || 0,
	                      paymentType: resp.payment_type || "",
	                      stripeChargeId: resp.stripe_chargeID || null,
	                      stripeCustomerId: resp.stripe_customerID || null,
	                      payerId: resp.payer_id || null,
	                      paymentId: resp.payment_id || null,
	                      landingSource: resp.landingSource || 'organic',
	                      landingSourceName: resp.landingSourceName || null
	                    });
	                  } else {
	                    var msg = resp && resp.message ? resp.message : "Failed to load your order";
	                    _this2.setState({ isLoading: false, errorMessage: msg });
	                    (0, _toast.showInformation)(msg);
	                  }
	                  return resp;
	                }).catch(function (err) {
	                  _this2.setState({ isLoading: false, errorMessage: "Error loading your order" });
	                  (0, _toast.showFailure)("Error loading your order");
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadUserOrder() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadUserOrder;
	    }()
	
	    /**
	     * Fire all post-purchase conversion tags. Idempotent: safe to call multiple
	     * times for the same component instance — only the first call actually fires.
	     *
	     * Tags fired:
	     *   - GTM `purchaseCompleted` (custom dataLayer event for the GTM workspace)
	     *   - GTM `purchase` (GA4 standard ecommerce event)
	     *   - Bing UET (window.uet_report_conversion, defined in public/index.html)
	     *   - Tapfiliate `conversion` (Stripe transaction id, with PayPal fallback)
	     */
	
	  }, {
	    key: 'fireConversionTags',
	    value: function fireConversionTags(_ref2) {
	      var order = _ref2.order,
	          amount = _ref2.amount,
	          paymentType = _ref2.paymentType,
	          stripeChargeId = _ref2.stripeChargeId,
	          stripeCustomerId = _ref2.stripeCustomerId,
	          payerId = _ref2.payerId,
	          paymentId = _ref2.paymentId,
	          landingSource = _ref2.landingSource,
	          landingSourceName = _ref2.landingSourceName;
	
	      if (this._conversionFired) return;
	      if (!order || !Array.isArray(order.all_order_details)) return;
	      if (!amount || amount <= 0) return;
	      this._conversionFired = true;
	
	      try {
	        var cart = order.all_order_details.map(function (item) {
	          var extras = Array.isArray(item.extras) ? item.extras : [];
	          var extrasTotal = extras.reduce(function (s, e) {
	            return s + (Number(e.price) || 0);
	          }, 0);
	          return {
	            exam: item.exam_name || '',
	            packageType: item.package_type || '',
	            price: (Number(item.price) || 0) + extrasTotal
	          };
	        });
	
	        var transactionId = order.order_id != null ? String(order.order_id) : '';
	
	        var commonData = {
	          transaction_id: transactionId,
	          value: amount,
	          currency: _constant.Currency,
	          userName: order.username || '',
	          userEmail: order.idname || '',
	          source: landingSource
	        };
	
	        var paymentOption = paymentType === 'stripe' ? 'card' : paymentType || '';
	
	        // GTM custom event (existing GTM tags listen to `purchaseCompleted`)
	        _reactGtmModule2.default.initialize({
	          gtmId: _constant.GTM_ID,
	          dataLayer: Object.assign({
	            event: _constant.GTMPurchaseCompleted,
	            eventOptions: {
	              orderID: commonData.transaction_id,
	              paymentOption: paymentOption,
	              cart: cart,
	              cartTotal: amount
	            }
	          }, commonData, {
	            price: amount,
	            affiliateName: landingSourceName
	          })
	        });
	
	        // GA4 standard ecommerce purchase event
	        _reactGtmModule2.default.initialize({
	          gtmId: _constant.GTM_ID,
	          dataLayer: Object.assign({
	            event: _constant.GA4Purchase,
	            eventOptions: {
	              orderID: commonData.transaction_id,
	              paymentOption: paymentOption,
	              cart: cart,
	              cartTotal: amount
	            }
	          }, commonData, {
	            revenue_value: amount,
	            affiliation: landingSourceName,
	            items: cart
	          })
	        });
	
	        // Bing UET conversion (helper defined in public/index.html)
	        if (typeof window !== 'undefined' && typeof window.uet_report_conversion === 'function') {
	          window.uet_report_conversion(amount);
	        }
	
	        // Tapfiliate conversion (Stripe primary, PayPal fallback). Re-creates
	        // the integration handle defensively in case the page entered Thankyou
	        // without coming from the public landing pages where it was created.
	        if (typeof window !== 'undefined' && typeof window.tap === 'function') {
	          if (paymentType === 'stripe' && stripeChargeId) {
	            try {
	              window.tap('create', '14886-4db9dd', { integration: 'stripe' });
	            } catch (e) {}
	            window.tap('conversion', stripeChargeId, amount, {
	              customer_id: stripeCustomerId || undefined
	            });
	          } else if (paymentType === 'paypal' && paymentId) {
	            try {
	              window.tap('create', '14886-4db9dd', { integration: 'paypal' });
	            } catch (e) {}
	            window.tap('conversion', paymentId, amount, {
	              customer_id: payerId || undefined
	            });
	          }
	        }
	
	        // Facebook Pixel — purchase event with currency + value
	        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
	          window.fbq('track', 'Purchase', {
	            currency: _constant.Currency,
	            value: amount
	          });
	        }
	      } catch (e) {
	        // Never let an analytics failure break the user-visible Thank You page.
	        // eslint-disable-next-line no-console
	        console.warn('Thankyou conversion tags failed:', e && e.message);
	      }
	    }
	  }, {
	    key: 'goToCourses',
	    value: function goToCourses() {
	      this.props.router.push("/dashboard");
	    }
	  }, {
	    key: 'isUpgradeItem',
	    value: function isUpgradeItem(item) {
	      return item && item.type && String(item.type).startsWith("upgrade_");
	    }
	  }, {
	    key: 'getOrderTotals',
	    value: function getOrderTotals(items) {
	      var subtotal = 0;
	      var discountTotal = 0;
	      var firstPct = 0;
	
	      for (var i = 0; i < items.length; i++) {
	        var it = items[i];
	        var extras = Array.isArray(it.extras) ? it.extras : [];
	        var addonsTotal = extras.reduce(function (s, e) {
	          return s + (Number(e.price) || 0);
	        }, 0);
	        var basePrice = Number(it.price) || 0;
	        var planPriceOnly = Math.max(0, basePrice - addonsTotal);
	        var pct = Number(it.percent_discount) || 0;
	        var discountAmt = pct > 0 ? planPriceOnly * pct / 100 : 0;
	
	        subtotal += basePrice;
	        discountTotal += discountAmt;
	        if (pct > 0 && firstPct === 0) firstPct = pct;
	      }
	
	      return { subtotal: subtotal, discountTotal: discountTotal, firstPct: firstPct };
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item, idx) {
	      var isUpgrade = this.isUpgradeItem(item);
	      var isUpgradeUnlimited = isUpgrade && item.type === "upgrade_unlimited";
	      var examName = item.exam_name || "";
	      var pkgType = item.package_type || "";
	      var extras = Array.isArray(item.extras) ? item.extras : [];
	      var addonsTotal = extras.reduce(function (s, e) {
	        return s + (Number(e.price) || 0);
	      }, 0);
	
	      // item.price is basePrice (plan + addons); back out the plan-only price
	      var basePrice = Number(item.price) || 0;
	      var planPriceOnly = Math.max(0, basePrice - addonsTotal);
	      var pctDiscount = Number(item.percent_discount) || 0;
	      // Discount only applies to plan price (#243), not to add-ons
	      var discountAmount = pctDiscount > 0 ? planPriceOnly * pctDiscount / 100 : 0;
	      // const finalPrice = Math.max(0, planPriceOnly - discountAmount);
	
	      var abbr = examName ? examName.substring(0, 3).toUpperCase() : "";
	      var upgradeBadgeClass = "ty_item_badge " + (isUpgradeUnlimited ? "ty_item_badge_green" : "ty_item_badge_blue");
	
	      return _react2.default.createElement(
	        'div',
	        { key: idx, className: 'ty_item_block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ty_item_row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ty_item_left' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ty_item_icon' },
	              _react2.default.createElement(
	                'span',
	                { className: 'ty_item_icon_text' },
	                abbr
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ty_item_text' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ty_item_title_box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'ty_item_title' },
	                  isUpgrade ? examName + " – Upgrade to " + pkgType : examName
	                ),
	                !isUpgrade && pkgType ? _react2.default.createElement(
	                  'p',
	                  { className: 'ty_item_subtitle' },
	                  '(',
	                  pkgType,
	                  ')'
	                ) : null,
	                isUpgrade ? _react2.default.createElement(
	                  'span',
	                  { className: upgradeBadgeClass },
	                  'UPGRADE'
	                ) : null
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ty_item_right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ty_item_price' },
	              (0, _CommonUtils.formatMoney)(planPriceOnly),
	              item.payment_interval ? _react2.default.createElement(
	                'span',
	                { className: 'ct_item_price_interval' },
	                '/',
	                item.payment_interval,
	                ' '
	              ) : ""
	            )
	          )
	        ),
	        discountAmount > 0 ? _react2.default.createElement(
	          'div',
	          { className: 'ty_discount_row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'ty_discount_label' },
	            'Coupon applied (-',
	            pctDiscount,
	            '%)'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'ty_discount_value' },
	            '-',
	            (0, _CommonUtils.formatMoney)(discountAmount)
	          )
	        ) : null,
	        extras.length > 0 ? _react2.default.createElement(
	          'div',
	          { className: 'ty_addons_box' },
	          extras.map(function (ex, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'ty_addon_row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ty_addon_name' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ty_addon_tree' },
	                  '\u2514'
	                ),
	                ex.title,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ty_addon_badge' },
	                  'ADD-ON'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ty_addon_price' },
	                Number(ex.price) > 0 ? (0, _CommonUtils.formatMoney)(Number(ex.price)) : _react2.default.createElement(
	                  'span',
	                  { className: 'ty_addon_included' },
	                  'Included'
	                )
	              )
	            );
	          })
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          errorMessage = _state.errorMessage,
	          orderData = _state.orderData,
	          amount = _state.amount,
	          paymentType = _state.paymentType,
	          createdAt = _state.createdAt,
	          orderId = _state.orderId;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(_loader2.default, null)
	        );
	      }
	
	      if (errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'animated fadeIn' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sb_page_container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sb_error_message' },
	              errorMessage
	            )
	          )
	        );
	      }
	
	      var items = orderData && Array.isArray(orderData.all_order_details) ? orderData.all_order_details : [];
	
	      var username = orderData && orderData.username || "";
	      var email = orderData && orderData.idname || "";
	      var orderNumber = orderData && orderData.order_id || orderId || "";
	      var dateText = createdAt ? (0, _CommonUtils.formatPrettyDate)(createdAt) : "";
	      var paymentLabel = paymentType === "stripe" ? "Credit / Debit Card" : paymentType || "—";
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sb_page_container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ty_title_block' },
	            _react2.default.createElement(
	              'svg',
	              { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round', className: 'ty_check_icon' },
	              _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	              _react2.default.createElement('path', { d: 'm9 12 2 2 4-4' })
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'ty_title' },
	              'Your order was successful!'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ty_order_number_title' },
	              'Order number: ',
	              orderNumber
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'ty_subtitle' },
	              'Your order information, along with a detailed receipt, have been emailed to you.'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'ct_btn_checkout',
	                onClick: this.goToCourses
	              },
	              'Access My Learning'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'ty_block_divider' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ty_layout' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'ty_card_title' },
	                'Order Summary'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ty_card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ty_items_list' },
	                  items.length > 0 ? items.map(function (it, i) {
	                    return _this3.renderItem(it, i);
	                  }) : _react2.default.createElement(
	                    'p',
	                    { className: 'ty_muted' },
	                    'No items.'
	                  )
	                ),
	                function () {
	                  var _getOrderTotals = _this3.getOrderTotals(items),
	                      subtotal = _getOrderTotals.subtotal,
	                      discountTotal = _getOrderTotals.discountTotal,
	                      firstPct = _getOrderTotals.firstPct;
	
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'ty_totals_box' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'ty_subtotal_row' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        'Subtotal:'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _CommonUtils.formatMoney)(subtotal)
	                      )
	                    ),
	                    discountTotal > 0 ? _react2.default.createElement(
	                      'div',
	                      { className: 'ty_discount_total_row' },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        'Discount: ',
	                        firstPct > 0 ? '(-' + firstPct + '%)' : ""
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        '-',
	                        (0, _CommonUtils.formatMoney)(discountTotal)
	                      )
	                    ) : null
	                  );
	                }(),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ty_total_row' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Total'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_total_amount' },
	                    (0, _CommonUtils.formatMoney)(amount)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ty_col_right' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'ty_card_title' },
	                'Order Details'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ty_card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ty_details_row' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_label' },
	                    'Order #'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_value' },
	                    orderNumber
	                  )
	                ),
	                dateText ? _react2.default.createElement(
	                  'div',
	                  { className: 'ty_details_row' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_label' },
	                    'Date'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_value' },
	                    dateText
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ty_details_row' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_label' },
	                    'Name'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_value' },
	                    username
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ty_details_row' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_label' },
	                    'Email'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_value' },
	                    email
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ty_details_row' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_label' },
	                    'Payment'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'ty_details_value' },
	                    paymentLabel
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Thankyou;
	}(_react.Component);
	
	/* class Thankyou extends Component {
	  constructor(props) {
	    super(props);
	    this.state = {
	      alert_status: false,
	      MessageTitle: `${language.LC().ALERT}`,
	      MessageContent: `${language.LC().ERROR}`,
	      succ_img: 'http://localhost:3000/img/green_checked.png',
	      order_id: this.props.params.order_id,
	      token: '',
	      idname: '',
	      ValidToken: false,
	      orders_discription: [],
	      totalAmount: '',
	      order_price: [],
	      uts_orderid: this.props.params.order_id,
	      payment_type: '',
	      stripe_customerID: '',
	      stripe_chargeID: '',
	      payer_id: '',
	      payment_id: '',
	      landingSource: 'organic',
	      landingSourceName: null,
	      exam: null,
	      isLoading: true,
	    };
	  }
	
	  componentDidMount() {
	    const session = JSON.parse(localStorage.getItem('localstorageval'));
	    if (session) {
	      this.setState({
	        idname: session.idname,
	        token: session.token,
	      });
	    }
	
	    const data = {
	      idname: session.idname,
	      token: session.token,
	      order_id: this.state.order_id,
	    };
	
	    FD.callAPI(`${App_data.backend_api}/checkout_v1/getOrdersbyid`, data).then(async (resp) => {
	      if (resp.success) {
	        const app1 = JSON.stringify(resp.orders_val);
	        const app2 = JSON.parse(JSON.parse(app1));
	        this.setState({
	          ValidToken: true,
	          orders_discription: app2,
	          totalAmount: resp.amount,
	          order_price: app2.all_order_details,
	          payment_type: resp.payment_type,
	          stripe_customerID: resp.stripe_customerID,
	          stripe_chargeID: resp.stripe_chargeID,
	          payer_id: resp.payer_id,
	          payment_id: resp.payment_id,
	          landingSource: resp.landingSource,
	          landingSourceName: resp.landingSourceName,
	          exam: resp.exam,
	          isLoading: false,
	        });
	
	        const gtmData = {
	          orders_discription: app2,
	          totalAmount: resp.amount,
	          order_price: app2.all_order_details,
	          payment_type: resp.payment_type,
	          landingSource: resp.landingSource,
	          landingSourceName: resp.landingSourceName,
	        };
	
	        if (window.uet_report_conversion) {
	          window.uet_report_conversion(resp.amount);
	        }
	
	        await this.triggerGTM(gtmData);
	      } else {
	        this.setState({ ValidToken: false });
	      }
	    });
	  }
	
	  triggerGTM = (data) => {
	    const array = data.order_price.map((item) => {
	      let extraPrice = item.price;
	      if (item.extras && item.extras.length) {
	        extraPrice += item.extras.reduce((sum, e) => sum + e.price, 0);
	      }
	      return {
	        exam: item.exam_name,
	        packageType: item.package_type,
	        price: extraPrice,
	      };
	    });
	
	    const commonData = {
	      transaction_id: JSON.stringify(data.orders_discription.order_id),
	      value: data.totalAmount,
	      currency: Currency,
	      userName: data.orders_discription.username,
	      userEmail: data.orders_discription.idname,
	      source: data.landingSource,
	    };
	
	    TagManager.initialize({
	      gtmId: GTM_ID,
	      dataLayer: {
	        event: GTMPurchaseCompleted,
	        eventOptions: {
	          orderID: commonData.transaction_id,
	          paymentOption: data.payment_type === 'stripe' ? 'card' : data.payment_type,
	          cart: array,
	          cartTotal: data.totalAmount,
	        },
	        ...commonData,
	        price: data.totalAmount,
	        affiliateName: data.landingSourceName,
	      },
	    });
	
	    TagManager.initialize({
	      gtmId: GTM_ID,
	      dataLayer: {
	        event: GA4Purchase,
	        eventOptions: {
	          orderID: commonData.transaction_id,
	          paymentOption:
	            data.orders_discription.payment_type === 'stripe'
	              ? 'card'
	              : data.orders_discription.payment_type,
	          cart: array,
	          cartTotal: data.totalAmount,
	        },
	        ...commonData,
	        revenue_value: data.totalAmount,
	        affiliation: data.landingSourceName,
	        items: array,
	      },
	    });
	  };
	
	  render() {
	    const payment_details = this.state.orders_discription;
	    let payment_details_val = '';
	    const plan_details = this.state.order_price;
	
	    let data1 = '';
	    payment_details_val = (
	      <table className='table cart_table'>
	        <tbody>
	          <tr>
	            <td>
	              <strong>{language.LC().ORDER_ID} :</strong>
	            </td>
	            <td>{payment_details.order_id}</td>
	          </tr>
	          <tr>
	            <td>
	              <strong>{language.LC().NAME} :</strong>
	            </td>
	            <td>{payment_details.username}</td>
	          </tr>
	          <tr>
	            <td>
	              <strong>{language.LC().PAYMENT_METHOD} :</strong>
	            </td>
	            <td>{payment_details.payment_type}</td>
	          </tr>
	          <tr>
	            <td>
	              <strong>{language.LC().EMAIL} :</strong>
	            </td>
	            <td>{payment_details.idname}</td>
	          </tr>
	        </tbody>
	      </table>
	    );
	
	    if (plan_details.length) {
	      data1 = Object.keys(plan_details).map((item, index) => (
	        <tbody key={index}>
	          <tr className='package-heading'>
	            <td width='60%'>
	              {`${plan_details[index].exam_name} (${plan_details[index].package_type}) `}
	            </td>
	            <td width='20%'>
	              {plan_details[index].type !== 'unlessUnlimited'
	                ? `$${plan_details[index].price}`
	                : null}
	            </td>
	            <td width='20%'>
	              {plan_details[index].type !== 'unlessUnlimited'
	                ? `$${
	                    // eslint-disable-next-line eqeqeq
	                    plan_details[index].percent_discount == 0
	                      ? plan_details[index].percent_discount
	                      : Math.ceil(
	                          plan_details[index].price * plan_details[index].percent_discount,
	                        ) / 100
	                  }`
	                : null}
	            </td>
	          </tr>
	          {plan_details[index].extras.map((extras, key) => {
	            return (
	              <tr key={key} className='extras-table'>
	                <td width='60%'>{`- ${extras.title}`}</td>
	                <td width='20%'>${extras.price}</td>
	                <td width='20%' />
	              </tr>
	            );
	          })}
	        </tbody>
	      ));
	    }
	    const total = this.state.totalAmount;
	    let tot_price = 0;
	    if (plan_details.length) {
	      Object.keys(plan_details).map((item, index) => {
	        if (plan_details[index].percent_discount === '') {
	          // eslint-disable-next-line no-multi-assign
	          tot_price += tot_price += Math.round(plan_details[index].price);
	        } else {
	          tot_price += Math.round(
	            plan_details[index].price -
	              Number((plan_details[index].price * plan_details[index].percent_discount) / 100),
	          );
	        }
	      });
	
	      // eslint-disable-next-line no-var
	      var order_fetch = payment_details.order_id;
	    }
	    const tagManagerArgs = {
	      gtmId: GTM_ID,
	      events: {
	        sendUserInfo: GTMUserInfo,
	      },
	      dataLayer: {
	        page: 'checkout',
	        value: total,
	        currency: 'USD',
	      },
	    };
	    TagManager.initialize(tagManagerArgs);
	
	    const { payment_type, stripe_chargeID, stripe_customerID, totalAmount, payer_id, payment_id } =
	      this.state;
	    let tapFiliateCount = 0;
	    {
	      payment_type === 'stripe' ? (
	        <script src='https://script.tapfiliate.com/tapfiliate.js' type='text/javascript' async>
	          {tapFiliateCount++}
	          <script type='text/javascript'>
	            {function (t, a, p) {
	              (t.TapfiliateObject = a),
	                (t[a] =
	                  t[a] ||
	                  function () {
	                    (t[a].q = t[a].q || []).push(arguments);
	                  });
	            }}
	            )({(window, 'tap')});
	            {
	              (window.tap('create', '14886-4db9dd', {
	                integration: 'stripe',
	              }),
	              window.tap('conversion', stripe_chargeID, totalAmount, {
	                customer_id: stripe_customerID,
	              }))
	            }
	          </script>
	        </script>
	      ) : null;
	    }
	
	    {
	      payment_type === 'paypal' ? (
	        <script src='https://script.tapfiliate.com/tapfiliate.js' type='text/javascript' async>
	          <script type='text/javascript'>
	            {(function (t, a, p) {
	              t.TapfiliateObject = a;
	              t[a] =
	                t[a] ||
	                function () {
	                  (t[a].q = t[a].q || []).push(arguments);
	                };
	            })(window, 'tap')}
	            ;{window.tap('create', '14886-4db9dd', { integration: 'paypal' })};
	            {window.tap('conversion', payment_id, totalAmount, {
	              customer_id: payer_id,
	            })}
	          </script>
	        </script>
	      ) : null;
	    }
	
	    const { isLoading } = this.state;
	    return (
	      <div className='animated fadeIn'>
	        <Helmet
	          script={[
	            {
	              src: 'https://www.dwin1.com/19038.js',
	              type: 'text/javascript',
	              defer: 'defer',
	            },
	          ]}
	        />
	        <img
	          src={`https://www.shareasale.com/sale.cfm?tracking=${order_fetch}&amount=${tot_price}&merchantID=118265&transtype=sale&currency=USD`}
	          width='1'
	          height='1'
	        />
	        <div className='row'>
	          <div className='col-xs-12 col-sm-12 col-md-12'>
	            <div className='white_box margin_bottom_20'>
	              <div className='row'>
	                <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
	                  <h4> {language.LC().THANK_YOU_FOR_YOUR_ORDER}</h4>
	                </div>
	              </div>
	
	              {isLoading ? (
	                <Loader />
	              ) : (
	                <div className='row'>
	                  <div className='col-xs-12 col-sm-6 col-md-7 margin_bottom_10'>
	                    <div className='table-responsive thankyou_tb'>
	                      <table className='table cart_table '>
	                        <thead>
	                          <tr>
	                            <th>{language.LC().PACKAGE}</th>
	                            <th>{language.LC().PRICE}</th>
	                            <th>{language.LC().DISCOUNT}</th>
	                          </tr>
	                        </thead>
	                        {data1}
	                        <tfoot>
	                          <tr>
	                            <td>
	                              <strong>{language.LC().TOTAL}</strong>
	                            </td>
	
	                            <td>${total}</td>
	
	                            <td />
	                          </tr>
	                        </tfoot>
	                      </table>
	                    </div>
	                  </div>
	                  <div className='col-xs-12 col-sm-6 col-md-5 margin_bottom_10'>
	                    <div className='table-responsive thankyou_tb'>{payment_details_val}</div>
	                  </div>
	                </div>
	              )}
	            </div>
	          </div>
	        </div>
	      </div>
	    );
	  }
	} */
	
	exports.default = Thankyou;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messages = __webpack_require__(14);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _reactstrap = __webpack_require__(6);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _reactRouter = __webpack_require__(29);
	
	var _examRedirectRoute = __webpack_require__(103);
	
	var _error_ = __webpack_require__(1038);
	
	var _error_2 = _interopRequireDefault(_error_);
	
	var _CommonUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var WordPressThankYou = function (_Component) {
	  _inherits(WordPressThankYou, _Component);
	
	  function WordPressThankYou(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, WordPressThankYou);
	
	    var _this = _possibleConstructorReturn(this, (WordPressThankYou.__proto__ || Object.getPrototypeOf(WordPressThankYou)).call(this, props));
	
	    _this.getOrders = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(orderId) {
	        var payload, orderDetails, _orderDetails$data, _orderDetails$data$da, data, success, orderSubscriptionDetails, paymentMode, userEmail, _orderId, amount, _orderDetails, userName, parsedOrderData, items, orderInformation;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	
	                _this.setState({ isLoading: true });
	                payload = { orderId: orderId };
	                _context.next = 5;
	                return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/partner/user/order', payload);
	
	              case 5:
	                orderDetails = _context.sent;
	                _orderDetails$data = orderDetails.data, _orderDetails$data$da = _orderDetails$data.data, data = _orderDetails$data$da === undefined ? {} : _orderDetails$data$da, success = _orderDetails$data.success;
	
	                if (success) {
	                  orderSubscriptionDetails = data.orderSubscriptionDetails, paymentMode = data.paymentMode, userEmail = data.userEmail, _orderId = data.orderId, amount = data.amount;
	                  _orderDetails = null;
	                  userName = null;
	
	
	                  if (orderSubscriptionDetails) {
	                    parsedOrderData = JSON.parse(orderSubscriptionDetails);
	
	                    userName = parsedOrderData.username;
	                    if (parsedOrderData.all_order_details) _orderDetails = parsedOrderData.all_order_details;
	                  }
	
	                  items = (_orderDetails || []).map(function (item) {
	                    var extras = Array.isArray(item.extras) ? item.extras : [];
	                    var addonsTotal = extras.reduce(function (sum, e) {
	                      return sum + (Number(e.price) || 0);
	                    }, 0);
	                    var basePrice = Number(item.price) || 0;
	                    // item.price includes add-ons; back out the plan-only figure, exactly
	                    // as the LMS thank-you page does.
	                    var planPriceOnly = Math.max(0, basePrice - addonsTotal);
	                    var pct = Number(item.percent_discount) || 0;
	
	                    return {
	                      // The exam name is the human label. This used to show
	                      // `package_val` — the tier key — so the page literally read
	                      // "simple (Practice Subscription)".
	                      examName: item.exam_name || '',
	                      packageType: item.package_type || '',
	                      basePrice: basePrice,
	                      planPriceOnly: planPriceOnly,
	                      extras: extras,
	                      percentDiscount: pct,
	                      // Discount applies to the plan only, never to add-ons.
	                      discountAmount: pct > 0 ? planPriceOnly * pct / 100 : 0,
	                      // Absence of payment_interval is what marks a one-time package.
	                      // `monthly_payment` / `subscriptionId` were written incorrectly
	                      // until 2026-10-05 and are still wrong on historical orders.
	                      paymentInterval: item.payment_interval || ''
	                    };
	                  });
	                  orderInformation = {
	                    paymentMode: paymentMode,
	                    orderId: _orderId,
	                    userName: userName,
	                    userEmail: userEmail,
	                    createdAt: data.createdAt || null,
	                    items: items,
	                    paidTotal: amount != null ? Number(amount) : null
	                  };
	
	                  _this.setState(Object.assign({
	                    orderDetails: orderInformation,
	                    isLoading: false
	                  }, !userEmail && { error: true }));
	                }
	                _context.next = 13;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](0);
	
	                _this.setState({ orderDetails: {}, isLoading: false, error: true });
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[0, 10]]);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToApp = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(email) {
	        var loginDetails, _loginDetails$user, success, partnerDomain;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	
	                _this.setState({ isDisabled: true });
	                _context2.next = 4;
	                return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/partner/user/getOrganizationDomain', {
	                  email: email
	                });
	
	              case 4:
	                loginDetails = _context2.sent;
	                _loginDetails$user = loginDetails.user, success = _loginDetails$user.success, partnerDomain = _loginDetails$user.partnerDomain;
	
	                if (success && partnerDomain) {
	                  window.location.href = ("https://app.analystprep.dev").replace('app.', partnerDomain + '.');
	                }
	
	              case 7:
	                _context2.prev = 7;
	
	                _this.setState({ isDisabled: false });
	                return _context2.finish(7);
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[0,, 7, 10]]);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      orderDetails: {
	        paymentMode: '',
	        userName: '',
	        userEmail: '',
	        orderId: '',
	        createdAt: null,
	        // Every purchased line, not just the first — a multi-package order used
	        // to render a single row.
	        items: [],
	        // The amount actually charged. Authoritative: order_data carries the
	        // catalogue price on orders placed before 2026-10-05.
	        paidTotal: null
	      },
	      isLoading: false,
	      isDisabled: false,
	      error: false
	    };
	    return _this;
	  }
	
	  _createClass(WordPressThankYou, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var orderId;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                orderId = this.props.params.orderId;
	
	                this.getOrders(orderId);
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          orderDetails = _state.orderDetails,
	          isLoading = _state.isLoading,
	          error = _state.error,
	          isDisabled = _state.isDisabled;
	      var _orderDetails$payment = orderDetails.paymentMode,
	          paymentMode = _orderDetails$payment === undefined ? '' : _orderDetails$payment,
	          _orderDetails$userNam = orderDetails.userName,
	          userName = _orderDetails$userNam === undefined ? '' : _orderDetails$userNam,
	          _orderDetails$userEma = orderDetails.userEmail,
	          userEmail = _orderDetails$userEma === undefined ? '' : _orderDetails$userEma,
	          _orderDetails$orderId = orderDetails.orderId,
	          orderId = _orderDetails$orderId === undefined ? '' : _orderDetails$orderId,
	          _orderDetails$created = orderDetails.createdAt,
	          createdAt = _orderDetails$created === undefined ? null : _orderDetails$created,
	          _orderDetails$items = orderDetails.items,
	          items = _orderDetails$items === undefined ? [] : _orderDetails$items,
	          _orderDetails$paidTot = orderDetails.paidTotal,
	          paidTotal = _orderDetails$paidTot === undefined ? null : _orderDetails$paidTot;
	
	
	      var subtotal = items.reduce(function (sum, item) {
	        return sum + item.basePrice;
	      }, 0);
	      var discountTotal = items.reduce(function (sum, item) {
	        return sum + item.discountAmount;
	      }, 0);
	      var firstPct = (items.find(function (item) {
	        return item.percentDiscount > 0;
	      }) || {}).percentDiscount || 0;
	      var hasDiscount = discountTotal > 0;
	      // The charge is the truth; the computed subtotal is only a fallback.
	      var total = paidTotal != null ? paidTotal : subtotal - discountTotal;
	      var paymentLabel = paymentMode === 'stripe' ? 'Credit / Debit Card' : paymentMode || '—';
	      var dateText = createdAt ? (0, _CommonUtils.formatPrettyDate)(createdAt) : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'justify-content-center' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper' },
	            _react2.default.createElement('img', { src: _App_data2.default.frontend_url + '/img/logo1.png', alt: 'Analystprep logo', width: '200' })
	          ),
	          _react2.default.createElement(
	            _LoaderWrapper2.default,
	            { isLoading: isLoading },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              !error ? _react2.default.createElement(
	                _reactstrap.Card,
	                { className: 'col-xs-12 col-sm-12 col-md-12 card-group p-2 mb-0' },
	                _react2.default.createElement(
	                  _reactstrap.CardHeader,
	                  { className: 'card-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'pb-2' },
	                    _react2.default.createElement(
	                      'h1',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        _messages.messages.THANK_YOU_FOR_YOUR_ORDER
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'small',
	                    null,
	                    _messages.messages.PURCHASE_CONFIRMATION
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { className: 'col-xs-12 col-sm-6 col-md-7 margin_bottom_10' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-responsive thankyou_tb' },
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table cart_table ' },
	                        _react2.default.createElement(
	                          'thead',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'th',
	                              null,
	                              _messages.messages.PACKAGE
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              null,
	                              _messages.messages.PRICE
	                            ),
	                            hasDiscount ? _react2.default.createElement(
	                              'th',
	                              null,
	                              _messages.messages.DISCOUNT
	                            ) : _react2.default.createElement('th', null)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          items.map(function (item, index) {
	                            return _react2.default.createElement(
	                              'tr',
	                              { className: 'package-heading', key: index },
	                              _react2.default.createElement(
	                                'td',
	                                { width: '60%' },
	                                item.examName,
	                                item.packageType ? ' (' + item.packageType + ')' : '',
	                                item.extras.map(function (extra, extraIndex) {
	                                  return _react2.default.createElement(
	                                    'div',
	                                    { className: 'text_light', key: extraIndex },
	                                    '+ ',
	                                    extra.title || 'Add-on',
	                                    ' ',
	                                    (0, _CommonUtils.formatMoney)(extra.price)
	                                  );
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { width: '20%' },
	                                (0, _CommonUtils.formatMoney)(item.planPriceOnly),
	                                item.paymentInterval ? ' / ' + item.paymentInterval : ''
	                              ),
	                              hasDiscount ? _react2.default.createElement(
	                                'td',
	                                { width: '20%' },
	                                item.percentDiscount > 0 ? '-' + item.percentDiscount + '% (-' + (0, _CommonUtils.formatMoney)(item.discountAmount) + ')' : ''
	                              ) : _react2.default.createElement('td', { width: '20%' })
	                            );
	                          })
	                        ),
	                        _react2.default.createElement(
	                          'tfoot',
	                          null,
	                          hasDiscount ? _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _messages.messages.DISCOUNT,
	                              firstPct > 0 ? ' (-' + firstPct + '%)' : ''
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              '-',
	                              (0, _CommonUtils.formatMoney)(discountTotal)
	                            ),
	                            _react2.default.createElement('td', null)
	                          ) : null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                _messages.messages.TOTAL
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                (0, _CommonUtils.formatMoney)(total)
	                              )
	                            ),
	                            _react2.default.createElement('td', null)
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { className: 'col-xs-12 col-sm-6 col-md-5 margin_bottom_10' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'table-responsive thankyou_tb' },
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table cart_table' },
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          [{ label: _messages.messages.ORDER_ID, value: orderId }, { label: _messages.messages.NAME, value: userName }, { label: _messages.messages.PAYMENT_METHOD, value: paymentLabel }, { label: _messages.messages.EMAIL, value: userEmail }].concat(_toConsumableArray(dateText ? [{ label: 'Date', value: dateText }] : [])).map(function (_ref4) {
	                            var label = _ref4.label,
	                                value = _ref4.value;
	                            return _react2.default.createElement(
	                              'tr',
	                              { key: label },
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                  'strong',
	                                  null,
	                                  label,
	                                  ': '
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                value
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { className: 'col-xs-12 col-sm-12 col-md-12 margin_bottom_10 m-0 d-flex justify-content-center' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn btn-primary pointer_class',
	                        disabled: isDisabled,
	                        onClick: function onClick() {
	                          return _this3.redirectToApp(userEmail);
	                        }
	                      },
	                      isDisabled && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	                      _messages.messages.START_STUDY
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                _reactstrap.Row,
	                { className: 'justify-content-center' },
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'col-sm-6 text-center' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'font-weight-bold  ' },
	                    _messages.messages.ORDER_NOT_FOUND
	                  ),
	                  _react2.default.createElement('img', { src: _error_2.default, className: 'h-100 w-50' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WordPressThankYou;
	}(_react.Component);
	
	exports.default = WordPressThankYou;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var retrieveVideos = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/all-videos', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function retrieveVideos(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var retrieveLastViewedVideo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/last-video-viewed', Object.assign({}, data));
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function retrieveLastViewedVideo() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	module.exports = {
	  retrieveVideos: retrieveVideos,
	  retrieveLastViewedVideo: retrieveLastViewedVideo
	};

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getDataService = __webpack_require__(24);
	
	var _getDataService2 = _interopRequireDefault(_getDataService);
	
	var _fetchData = __webpack_require__(5);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _App_data = __webpack_require__(3);
	
	var _App_data2 = _interopRequireDefault(_App_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* 
	   I am using the 'question' key in the API functions. 
	   Please disregard it,
	   as these API calls originate from the Question Bank common component, 
	   which necessitates its usage
	*/
	
	var retrieveVideos = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/all-videos', data);
	
	          case 2:
	            return _context.abrupt('return', _context.sent);
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function retrieveVideos(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	var saveLastViewedVideo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/last-video-viewed', data);
	
	          case 2:
	            return _context2.abrupt('return', _context2.sent);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function saveLastViewedVideo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	var fetchSavedQuestion = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(data) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return _getDataService2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/save', Object.assign({
	              videoId: data.video_id
	            }, data));
	
	          case 2:
	            return _context3.abrupt('return', _context3.sent);
	
	          case 3:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function fetchSavedQuestion(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	var saveQuestion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(data) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/save', Object.assign({
	              videoId: data.video_id
	            }, data));
	
	          case 2:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 3:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function saveQuestion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	var deleteSavedQuestion = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(data) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/unsave', Object.assign({
	              videoId: data.video_id
	            }, data));
	
	          case 2:
	            return _context5.abrupt('return', _context5.sent);
	
	          case 3:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function deleteSavedQuestion(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	var mutateReportVideo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(data) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _fetchData2.default.callAPI(_App_data2.default.backend_api + '/exams/cfa/videos/report', data);
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function mutateReportVideo(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	module.exports = {
	  retrieveVideos: retrieveVideos,
	  fetchSavedQuestion: fetchSavedQuestion,
	  saveQuestion: saveQuestion,
	  deleteSavedQuestion: deleteSavedQuestion,
	  mutateReportVideo: mutateReportVideo,
	  saveLastViewedVideo: saveLastViewedVideo
	};

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _ReportCard = __webpack_require__(92);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	var _VideoPlayList = __webpack_require__(174);
	
	var _VideoPlayList2 = _interopRequireDefault(_VideoPlayList);
	
	var _VideoValidateReportsIcons = __webpack_require__(175);
	
	var _VideoValidateReportsIcons2 = _interopRequireDefault(_VideoValidateReportsIcons);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _FlashCard = __webpack_require__(19);
	
	var _FlashCard2 = _interopRequireDefault(_FlashCard);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa2NextRoutes = __webpack_require__(177);
	
	var _ApiService = __webpack_require__(901);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _function = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var videoTableKey = 'cfa1_2025_videos';
	
	var VideoPlayList = function (_Component) {
	  _inherits(VideoPlayList, _Component);
	
	  function VideoPlayList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, VideoPlayList);
	
	    var _this = _possibleConstructorReturn(this, (VideoPlayList.__proto__ || Object.getPrototypeOf(VideoPlayList)).call(this, props));
	
	    _this.getChapterWiseVideos = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(payload) {
	        var _ref2, success, associatedVideosTable, data, titleName, associatedSubscriptionKey, selectedExamSubscriptionDetails, examName, videosData, id, currentIndex, subscriptionDetail, isUserPremium, router;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _ApiService2.default['retrieveVideos'](payload);
	
	              case 2:
	                _ref2 = _context.sent;
	                success = _ref2.success;
	                associatedVideosTable = _ref2.associatedVideosTable;
	                data = _ref2.data;
	                titleName = _ref2.titleName;
	                associatedSubscriptionKey = _ref2.associatedSubscriptionKey;
	                selectedExamSubscriptionDetails = _ref2.selectedExamSubscriptionDetails;
	                examName = _ref2.examName;
	
	                if (!success) {
	                  _context.next = 30;
	                  break;
	                }
	
	                videoTableKey = associatedVideosTable;
	                videosData = data[0][videoTableKey];
	                id = payload.id;
	                currentIndex = videosData.findIndex(function (item) {
	                  return item.id === parseInt(id, 10);
	                });
	
	                currentIndex = currentIndex === -1 ? 0 : currentIndex;
	
	                //* HERE ADDED A CHECK IF USER WANT TO ACCESS PREMIUM VIDEO WITHOUT SUBSCRIPTION */
	                subscriptionDetail = selectedExamSubscriptionDetails[associatedSubscriptionKey];
	                isUserPremium = subscriptionDetail && (subscriptionDetail.videoStatus || subscriptionDetail.package_val === _constant.SUBSCRIPTION_TYPES.EXPENSIVE);
	
	                if (!(isUserPremium || videosData[currentIndex].free)) {
	                  _context.next = 25;
	                  break;
	                }
	
	                _this.setState({
	                  isLoading: false,
	                  examNameKey: examName,
	                  currentIndex: currentIndex > -1 ? currentIndex : 0,
	                  videoData: data.length && data[0][videoTableKey],
	                  title: data.length && (titleName || data[0]['chapter_name']),
	                  isUserPremium: isUserPremium
	                });
	                // CFA2 dated trees: opening a video URL directly (e.g. from the chapter list) must also count
	                // as "last viewed" — previously only in-playlist clicks saved it, so "Go to my last viewed
	                // video" pointed at a stale video. Scoped to /cfa2/2026|2027 so CFA3's shared /videos is unchanged.
	
	                if (!((0, _cfa2NextRoutes.isNextPath)() && videosData[currentIndex])) {
	                  _context.next = 23;
	                  break;
	                }
	
	                _context.next = 23;
	                return _ApiService2.default['saveLastViewedVideo']({
	                  videoId: videosData[currentIndex].id,
	                  videoIndex: currentIndex
	                });
	
	              case 23:
	                _context.next = 28;
	                break;
	
	              case 25:
	                router = _this.context.router;
	
	                router.push({ pathname: (0, _cfa2NextRoutes.nextAwareRoute)(_AppRoutes2.default.VIDEOS) });
	                (0, _toast.showInformation)(_messages.messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO);
	
	              case 28:
	                _context.next = 31;
	                break;
	
	              case 30:
	                _this.setState({ isLoading: false });
	
	              case 31:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.navigateToVideo = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(index) {
	        var state, isUserPremium, videoData, router;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                state = _this.state;
	                isUserPremium = state.isUserPremium, videoData = state.videoData;
	
	                if (!(isUserPremium || videoData[index].free)) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                _this.setState({ currentIndex: index });
	                router = _this.context.router;
	
	                router.push({
	                  pathname: (0, _cfa2NextRoutes.nextAwareRoute)(_AppRoutes2.default.VIDEOS_LIST).replace(':id', videoData[index].id).replace(':chapterId', videoData[index]['chapter_id']),
	                  query: Object.assign({}, videoData[index].mock_id && { mockId: videoData[index].mock_id }, videoData[index].case_id && { caseId: videoData[index].case_id }, videoData[index].pathway_id && { pathwayId: videoData[index].pathway_id })
	                });
	                _context2.next = 8;
	                return _ApiService2.default['saveLastViewedVideo']({
	                  videoId: videoData[index].id,
	                  videoIndex: index
	                });
	
	              case 8:
	                _context2.next = 11;
	                break;
	
	              case 10:
	                _this.setState({ isPremiumPopupVisible: true });
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.redirectToSubscription = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.handleShowPremiumModal = function () {
	      _this.setState({ isPremiumPopupVisible: !_this.state.isPremiumPopupVisible });
	    };
	
	    _this.onSaveItemChange = function (status) {
	      _this.setState({ isFlashCardVisible: status });
	    };
	
	    _this.toggleReportSection = function () {
	      return _this.setState(function (prevState) {
	        return { isReportSectionVisible: !prevState.isReportSectionVisible };
	      });
	    };
	
	    _this.onHandleHideReportSection = function () {
	      _this.setState({ isReportSectionVisible: false });
	    };
	
	    _this.state = {
	      videoData: [],
	      currentIndex: 0,
	      title: '',
	      isLoading: true,
	      isFlashCardVisible: true,
	      isReportSectionVisible: false,
	      isPremiumPopupVisible: false,
	      isUserPremium: false,
	      examNameKey: ''
	    };
	    _this.childRef = null;
	    _this.setChildRef = function (element) {
	      _this.childRef = element;
	    };
	    return _this;
	  }
	
	  _createClass(VideoPlayList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _props$params, chapterId, id, _props$location$query, mockId, caseId, pathwayId;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.setState({ isLoading: true });
	                _props$params = this.props.params, chapterId = _props$params.chapterId, id = _props$params.id;
	                _props$location$query = this.props.location.query, mockId = _props$location$query.mockId, caseId = _props$location$query.caseId, pathwayId = _props$location$query.pathwayId;
	                _context3.next = 5;
	                return this.getChapterWiseVideos({ chapterId: chapterId, id: id, mockId: mockId, caseId: caseId, pathwayId: pathwayId });
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var router = this.context.router,
	          props = this.props,
	          _state = this.state,
	          videoData = _state.videoData,
	          isLoading = _state.isLoading,
	          currentIndex = _state.currentIndex,
	          isUserPremium = _state.isUserPremium,
	          isPremiumPopupVisible = _state.isPremiumPopupVisible,
	          isFlashCardVisible = _state.isFlashCardVisible,
	          isReportSectionVisible = _state.isReportSectionVisible,
	          title = _state.title,
	          examNameKey = _state.examNameKey;
	      var _props$location$query2 = props.location.query,
	          mockId = _props$location$query2.mockId,
	          caseId = _props$location$query2.caseId,
	          pathwayId = _props$location$query2.pathwayId;
	
	      var isRedirectIconVisible = !mockId && !caseId && !pathwayId;
	
	      var _ref5 = _constant.REDIRECTION_ROUTES[examNameKey] || {},
	          _ref5$notes = _ref5.notes,
	          notes = _ref5$notes === undefined ? '' : _ref5$notes,
	          _ref5$question = _ref5.question,
	          question = _ref5$question === undefined ? '' : _ref5$question;
	
	      var currentVideoData = videoData[currentIndex] || {};
	      var titleName = caseId ? (0, _function.removeSuffix)(title, '– volume') : title;
	
	      var getRedirectRoute = function getRedirectRoute(type, videoData, title) {
	        return type && (0, _function.generateDynamicRoute)(type, videoData, title) || '';
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          _LoaderWrapper2.default,
	          { isLoading: isLoading },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ComponentHeader2.default,
	              { title: titleName },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary pointer_class',
	                  onClick: function onClick() {
	                    return router.push({ pathname: (0, _cfa2NextRoutes.nextAwareRoute)(_AppRoutes2.default.VIDEOS) });
	                  }
	                },
	                _messages.messages.BACK_TO_VIDEOS
	              )
	            ),
	            _react2.default.createElement(_VideoPlayList2.default, {
	              videoTitle: videoData[currentIndex] ? videoData[currentIndex]['title'] : '',
	              currentIndex: currentIndex,
	              videosData: videoData,
	              youtubeID: videoData[currentIndex] ? videoData[currentIndex]['url_id'] : '',
	              navigateToVideoByID: this.navigateToVideo,
	              toggleAlert: this.handleShowPremiumModal,
	              isUserSubscribed: isUserPremium
	            }),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_VideoValidateReportsIcons2.default, {
	              isMoveToNotesIcon: isRedirectIconVisible,
	              isMoveToQuestionIcon: isRedirectIconVisible,
	              toggleAlert: this.handleShowPremiumModal,
	              setChildRef: this.childRef,
	              currentVideo: videoData[currentIndex] && videoData[currentIndex],
	              apiServiceProvider: _ApiService2.default,
	              onSaveItemChange: this.onSaveItemChange,
	              toggleReportSection: this.toggleReportSection,
	              isUserSubscribed: isUserPremium,
	              savePayLoad: { videoId: videoData[currentIndex] && videoData[currentIndex].id },
	              favItemId: videoData[currentIndex] && videoData[currentIndex].id,
	              notesRedirectRoute: getRedirectRoute(notes, currentVideoData, title),
	              questionRedirectRoute: getRedirectRoute(question, currentVideoData, title)
	            }),
	            _react2.default.createElement(_FlashCard2.default, {
	              item: { id: videoData[currentIndex] ? videoData[currentIndex].id : '' },
	              type: 'video',
	              isFlashCardHidden: isFlashCardVisible,
	              ref: this.setChildRef
	            }),
	            isReportSectionVisible && _react2.default.createElement(_ReportCard2.default, {
	              section: 'video',
	              hideReportSection: this.onHandleHideReportSection,
	              apiServiceProvider: _ApiService2.default,
	              itemId: videoData[currentIndex] ? videoData[currentIndex].id : '',
	              keyId: 'videoId'
	            })
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.redirectToSubscription,
	          toggleAlert: this.handleShowPremiumModal,
	          alert_status: isPremiumPopupVisible,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP
	        })
	      );
	    }
	  }]);
	
	  return VideoPlayList;
	}(_react.Component);
	
	VideoPlayList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = VideoPlayList;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(6);
	
	var _LoaderWrapper = __webpack_require__(25);
	
	var _LoaderWrapper2 = _interopRequireDefault(_LoaderWrapper);
	
	var _videoCard = __webpack_require__(176);
	
	var _videoCard2 = _interopRequireDefault(_videoCard);
	
	var _ComponentHeader = __webpack_require__(23);
	
	var _ComponentHeader2 = _interopRequireDefault(_ComponentHeader);
	
	var _constant = __webpack_require__(9);
	
	var _messages = __webpack_require__(14);
	
	var _toast = __webpack_require__(15);
	
	var _Modal = __webpack_require__(13);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AppRoutes = __webpack_require__(8);
	
	var _AppRoutes2 = _interopRequireDefault(_AppRoutes);
	
	var _cfa2NextRoutes = __webpack_require__(177);
	
	var _ApiService = __webpack_require__(900);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var index = function (_Component) {
	  _inherits(index, _Component);
	
	  function index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, index);
	
	    var _this = _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).call(this, props));
	
	    _this.retrieveVideos = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var result, subscriptionDetail;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _ApiService2.default['retrieveVideos']();
	
	            case 2:
	              result = _context.sent;
	
	              if (result.success) {
	                subscriptionDetail = result.selectedExamSubscriptionDetails[result.associatedSubscriptionKey];
	
	                _this.setState({
	                  videoTableNameKey: result.associatedVideosTable,
	                  isLoading: false,
	                  videoData: result.data,
	                  isUserSubscriptionStatus: subscriptionDetail && (subscriptionDetail.videoStatus || subscriptionDetail.package_val === _constant.SUBSCRIPTION_TYPES.EXPENSIVE)
	                });
	              } else {
	                _this.setState({ isLoading: false });
	              }
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.redirectToSubscription = function () {
	      var router = _this.context.router;
	
	      router.push({ pathname: '/Subscribe' });
	    };
	
	    _this.onHandleToggleAlert = function () {
	      _this.setState({ isPremiumPopupOpen: !_this.state.isPremiumPopupOpen });
	    };
	
	    _this.playlistChapterId = function (video) {
	      if (!video) return null;
	      if (video.mock_id || video.case_id || video.pathway_id) return video.chapter_id;
	      return video.chapter_id_2025 !== undefined && video.chapter_id_2025 !== null ? video.chapter_id_2025 : video.chapter_id;
	    };
	
	    _this.redirectToPlaylist = function (items) {
	      var router = _this.context.router;
	      var id = items.id;
	
	      router.push({
	        pathname: (0, _cfa2NextRoutes.nextAwareRoute)(_AppRoutes2.default.VIDEOS_LIST).replace(':chapterId', _this.playlistChapterId(items)).replace(':id', id),
	        query: Object.assign({}, items.mock_id && { mockId: items.mock_id }, items.case_id && { caseId: items.case_id }, items.pathway_id && { pathwayId: items.pathway_id })
	      });
	    };
	
	    _this.redirectToLastViewedVideo = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var result, router, data, associatedVideosTable;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.setState({ isLastVideoViewButtonDisabled: true });
	              _context2.next = 3;
	              return _ApiService2.default['retrieveLastViewedVideo']();
	
	            case 3:
	              result = _context2.sent;
	
	              if (result.success) {
	                router = _this.context.router;
	                data = result.data, associatedVideosTable = result.associatedVideosTable;
	
	                router.push({
	                  pathname: (0, _cfa2NextRoutes.nextAwareRoute)(_AppRoutes2.default.VIDEOS_LIST).replace(':chapterId', _this.playlistChapterId(data[associatedVideosTable])).replace(':id', data.contentID),
	                  query: Object.assign({}, data[associatedVideosTable].mock_id && {
	                    mockId: data[associatedVideosTable].mock_id
	                  }, data[associatedVideosTable].case_id && {
	                    caseId: data[associatedVideosTable].case_id
	                  }, data[associatedVideosTable].pathway_id && {
	                    pathwayId: data[associatedVideosTable].pathway_id
	                  })
	                });
	              } else {
	                _this.setState({ isLastVideoViewButtonDisabled: false });
	                (0, _toast.showInformation)(_messages.messages.VIDEO_NOT_AVAILABLE);
	              }
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.state = {
	      videoData: [],
	      isLoading: true,
	      isPremiumPopupOpen: false,
	      isLastVideoViewButtonDisabled: false,
	      isUserSubscriptionStatus: false
	    };
	    return _this;
	  }
	
	  _createClass(index, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this.setState({ isLoading: true });
	                _context3.next = 3;
	                return this.retrieveVideos();
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    // Chapter id for the playlist URL. CFA2 videos belong to their chapter through
	    // chapter_id_2025 (chapter_id is the legacy 2022/2023 classification: NULL on admin-created
	    // videos, stale on some cloned ones). Other exams' video tables only have chapter_id.
	    // Mock/case/pathway videos are opened by their query ids, so they keep chapter_id.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var state = this.state;
	      var isLoading = state.isLoading,
	          isPremiumPopupOpen = state.isPremiumPopupOpen,
	          isUserSubscriptionStatus = state.isUserSubscriptionStatus,
	          isLastVideoViewButtonDisabled = state.isLastVideoViewButtonDisabled,
	          videoData = state.videoData,
	          videoTableNameKey = state.videoTableNameKey;
	
	      var caseIndex = 1,
	          mockIndex = 1,
	          pathwayIndex = 1,
	          normalIndex = 1;
	      return _react2.default.createElement(
	        'div',
	        { className: 'animated fadeIn' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _ComponentHeader2.default,
	            { title: _messages.messages.VIDEOS, className: 'mb-3' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary pointer_class',
	                onClick: function onClick() {
	                  return _this3.redirectToLastViewedVideo();
	                },
	                disabled: isLastVideoViewButtonDisabled
	              },
	              isLastVideoViewButtonDisabled && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin mr-1' }),
	              _messages.messages.GO_TO_MY_LAST_VIEWED_VIDEO
	            )
	          ),
	          _react2.default.createElement(
	            _LoaderWrapper2.default,
	            { isLoading: isLoading },
	            _react2.default.createElement(
	              _reactstrap.Row,
	              { className: 'video_lesson_wrap' },
	              videoData.length > 0 && videoData.map(function (item) {
	                var index = item.case_id ? caseIndex++ : item.mock_id ? mockIndex++ : item.pathway_id ? pathwayIndex++ : normalIndex++;
	                return _react2.default.createElement(_videoCard2.default, {
	                  index: index++,
	                  currentItem: item,
	                  chapterIdKey: 'id',
	                  chapterNameKey: 'chapter_name',
	                  videoTableNameKey: videoTableNameKey,
	                  isUserSubscribed: isUserSubscriptionStatus,
	                  premiumModalToggle: _this3.onHandleToggleAlert,
	                  redirectToPlaylist: _this3.redirectToPlaylist
	                });
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_Modal2.default, {
	          goPremium: this.redirectToSubscription,
	          toggleAlert: this.onHandleToggleAlert,
	          alert_status: isPremiumPopupOpen,
	          MessageContent: _messages.messages.CFA1_2025_PREMIUM_POPUP
	        })
	      );
	    }
	  }]);
	
	  return index;
	}(_react.Component);
	
	index.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = index;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(2);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebinarRESTService = __webpack_require__(139);
	
	var _WebinarRESTService2 = _interopRequireDefault(_WebinarRESTService);
	
	var _WebinarsListItem = __webpack_require__(544);
	
	var _WebinarsListItem2 = _interopRequireDefault(_WebinarsListItem);
	
	var _pagination = __webpack_require__(274);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _loader = __webpack_require__(12);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	__webpack_require__(998);
	
	var _userStore = __webpack_require__(16);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _WebSocketService = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var REGION_LABELS = {
	    'NA': 'North America',
	    'EU': 'Europe',
	    'APAC': 'Asia Pacific',
	    'LATAM': 'Latin America',
	    'MEA': 'Middle East & Africa',
	    'UK': 'United Kingdom'
	};
	
	function getRegionLabel(region) {
	    return REGION_LABELS[region] || region;
	}
	
	var WebinarsList = function (_Component) {
	    _inherits(WebinarsList, _Component);
	
	    function WebinarsList(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, WebinarsList);
	
	        var _this = _possibleConstructorReturn(this, (WebinarsList.__proto__ || Object.getPrototypeOf(WebinarsList)).call(this, props, context));
	
	        _this.listWebinars = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	            var dto, data;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this.setState({ isLoading: true });
	                            _context.prev = 1;
	                            dto = {
	                                page: page,
	                                perPage: _this.state.perPage,
	                                tags: _this.state.selectedTags,
	                                type: _this.state.sessionType,
	                                region: _this.state.selectedRegion
	                            };
	                            _context.next = 5;
	                            return new _WebinarRESTService2.default().setAuthHeader(_this.state.userData.token).getWebinarsList(dto);
	
	                        case 5:
	                            data = _context.sent;
	
	                            if (data != null) {
	                                _this.setState({
	                                    items: data.items || [],
	                                    totalCount: data.count || 0,
	                                    currentPage: page
	                                });
	                            }
	                            _context.next = 12;
	                            break;
	
	                        case 9:
	                            _context.prev = 9;
	                            _context.t0 = _context["catch"](1);
	
	                            console.log("ListWebinarsERROR:: ", _context.t0);
	
	                        case 12:
	                            _context.prev = 12;
	
	                            setTimeout(function () {
	                                return _this.setState({ isLoading: false });
	                            }, 500);
	                            return _context.finish(12);
	
	                        case 15:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[1, 9, 12, 15]]);
	        }));
	
	        _this.listFilters = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(filters) {
	                var data;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.prev = 0;
	                                _context2.next = 3;
	                                return new _WebinarRESTService2.default().setAuthHeader(_this.state.userData.token).getFIlters();
	
	                            case 3:
	                                data = _context2.sent;
	
	                                if (data != null) {
	                                    _this.setState({
	                                        filters: data,
	                                        upcomingCount: data.upcomingCount || 0,
	                                        pastCount: data.pastCount || 0
	                                    });
	                                }
	                                _context2.next = 10;
	                                break;
	
	                            case 7:
	                                _context2.prev = 7;
	                                _context2.t0 = _context2["catch"](0);
	
	                                console.log("Error in listFilters:: ", _context2.t0);
	
	                            case 10:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this2, [[0, 7]]);
	            }));
	
	            return function (_x2) {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        _this.updateWebinarItem = function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(webinarId) {
	                var data;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.prev = 0;
	                                _context3.next = 3;
	                                return new _WebinarRESTService2.default().setAuthHeader(_this.state.userData.token).getWebinarItem(webinarId);
	
	                            case 3:
	                                data = _context3.sent;
	
	                                if (data != null) {
	                                    _this.setState(function (prevState) {
	                                        return {
	                                            items: prevState.items.map(function (item) {
	                                                return item.id === webinarId ? data : item;
	                                            })
	                                        };
	                                    });
	                                }
	                                _context3.next = 10;
	                                break;
	
	                            case 7:
	                                _context3.prev = 7;
	                                _context3.t0 = _context3["catch"](0);
	
	                                console.log("updateWebinarItem::error", _context3.t0);
	
	                            case 10:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, _this2, [[0, 7]]);
	            }));
	
	            return function (_x3) {
	                return _ref3.apply(this, arguments);
	            };
	        }();
	
	        _this.handleTagClick = function (tag) {
	            _this.setState(function (prevState) {
	                var selected = prevState.selectedTags.includes(tag) ? prevState.selectedTags.filter(function (t) {
	                    return t !== tag;
	                }) : [].concat(_toConsumableArray(prevState.selectedTags), [tag]);
	                return { selectedTags: selected };
	            }, function () {
	                return _this.listWebinars(1);
	            });
	        };
	
	        _this.handleSessionTypeChange = function (type) {
	            if (type === _this.state.sessionType) return;
	            _this.setState({ sessionType: type, selectedTags: [], selectedRegion: null }, function () {
	                return _this.listWebinars(1);
	            });
	        };
	
	        _this.handleAllClick = function () {
	            _this.setState({ selectedTags: [] }, function () {
	                return _this.listWebinars(1);
	            });
	        };
	
	        _this.handleRegionClick = function (region) {
	            var newRegion = _this.state.selectedRegion === region ? null : region;
	            _this.setState({ selectedRegion: newRegion }, function () {
	                return _this.listWebinars(1);
	            });
	        };
	
	        _this.handleRegionAllClick = function () {
	            _this.setState({ selectedRegion: null }, function () {
	                return _this.listWebinars(1);
	            });
	        };
	
	        _this.onPageChanged = function (paginationData) {
	            var currentPage = paginationData.currentPage;
	
	            if (currentPage === _this.state.currentPage) return;
	            _this.context.router.push({ pathname: '/webinars', query: { page: currentPage } });
	            _this.listWebinars(currentPage);
	        };
	
	        _this.state = {
	            items: [],
	            userData: {
	                profile: null,
	                token: null
	            },
	            currentPage: 1,
	            perPage: 9,
	            totalCount: 0,
	            filters: {
	                tags: [],
	                regions: []
	            },
	            selectedTags: [],
	            selectedRegion: null,
	            sessionType: 'upcoming',
	            upcomingCount: 0,
	            pastCount: 0,
	            isLoading: true
	        };
	        return _this;
	    }
	
	    _createClass(WebinarsList, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                var _this3 = this;
	
	                var profile, token, page, socket;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return _userStore2.default.fetchProfile();
	
	                            case 2:
	                                profile = _context4.sent;
	                                token = _userStore2.default.token;
	
	                                this.setState({ userData: { profile: profile, token: token } });
	                                page = parseInt(this.props.location && this.props.location.query && this.props.location.query.page, 10) || 1;
	                                _context4.next = 8;
	                                return this.listWebinars(page);
	
	                            case 8:
	                                _context4.next = 10;
	                                return this.listFilters();
	
	                            case 10:
	                                socket = (0, _WebSocketService.getSocket)();
	
	                                socket.on('webinar_data_update', function (data) {
	                                    if (data) {
	                                        var webinarId = data.id;
	                                        _this3.setState(function (prevState) {
	                                            return {
	                                                items: prevState.items.map(function (item) {
	                                                    return item.id === webinarId ? data : item;
	                                                })
	                                            };
	                                        });
	                                    }
	                                });
	
	                            case 12:
	                            case "end":
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function componentDidMount() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                items = _state.items,
	                totalCount = _state.totalCount,
	                currentPage = _state.currentPage,
	                perPage = _state.perPage,
	                filters = _state.filters,
	                selectedTags = _state.selectedTags,
	                selectedRegion = _state.selectedRegion,
	                sessionType = _state.sessionType,
	                upcomingCount = _state.upcomingCount,
	                pastCount = _state.pastCount,
	                isLoading = _state.isLoading;
	
	            var tags = filters && filters.tags ? filters.tags : [];
	            var regions = filters && filters.regions ? filters.regions : [];
	
	            if (isLoading) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "animated fadeIn" },
	                    _react2.default.createElement(_loader2.default, null)
	                );
	            }
	            return _react2.default.createElement(
	                "div",
	                { className: "webinars-wrapper" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "webinars-container" },
	                    tags.length > 0 && _react2.default.createElement(
	                        "div",
	                        { className: "webinar-filters" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "webinar-filters__label" },
	                            "Filter:"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: 'webinar-filter-tag' + (selectedTags.length === 0 ? ' webinar-filter-tag--active' : ''),
	                                onClick: this.handleAllClick,
	                                type: "button"
	                            },
	                            "All"
	                        ),
	                        tags.map(function (tag, idx) {
	                            return _react2.default.createElement(
	                                "button",
	                                {
	                                    className: 'webinar-filter-tag' + (selectedTags.includes(tag) ? ' webinar-filter-tag--active' : ''),
	                                    onClick: function onClick() {
	                                        return _this4.handleTagClick(tag);
	                                    },
	                                    type: "button",
	                                    key: 'ftag_' + idx
	                                },
	                                tag
	                            );
	                        })
	                    ),
	                    regions.length > 0 && _react2.default.createElement(
	                        "div",
	                        { className: "webinar-filters" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "webinar-filters__label" },
	                            "Location:"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: 'webinar-filter-tag' + (selectedRegion == null ? ' webinar-filter-tag--active' : ''),
	                                onClick: this.handleRegionAllClick,
	                                type: "button"
	                            },
	                            "All"
	                        ),
	                        regions.map(function (region, idx) {
	                            return _react2.default.createElement(
	                                "button",
	                                {
	                                    className: 'webinar-filter-tag' + (selectedRegion === region ? ' webinar-filter-tag--active' : ''),
	                                    onClick: function onClick() {
	                                        return _this4.handleRegionClick(region);
	                                    },
	                                    type: "button",
	                                    key: 'fregion_' + idx
	                                },
	                                getRegionLabel(region)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "webinar-list-container" },
	                        items.slice().sort(function (a, b) {
	                            var aLive = a && a.sessionState === 'live' ? 0 : 1;
	                            var bLive = b && b.sessionState === 'live' ? 0 : 1;
	                            return aLive - bLive;
	                        }).map(function (item, idx) {
	                            return _react2.default.createElement(_WebinarsListItem2.default, {
	                                item: item,
	                                userData: _this4.state.userData,
	                                onWebinarUpdate: _this4.updateWebinarItem,
	                                key: "wbi_" + idx
	                            });
	                        })
	                    ),
	                    totalCount > perPage && _react2.default.createElement(
	                        "div",
	                        { className: "webinar-pagination" },
	                        _react2.default.createElement(_pagination2.default, {
	                            totalRecords: totalCount,
	                            currentPage: currentPage,
	                            pageLimit: perPage,
	                            pageNeighbours: 1,
	                            onPageChanged: this.onPageChanged
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WebinarsList;
	}(_react.Component);
	
	WebinarsList.contextTypes = { router: _react2.default.PropTypes.object };
	exports.default = WebinarsList;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(906);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 906 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 907 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ },
/* 908 */
/***/ function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(chars){
	  "use strict";
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = chars.indexOf(base64[i]);
	      encoded2 = chars.indexOf(base64[i+1]);
	      encoded3 = chars.indexOf(base64[i+2]);
	      encoded4 = chars.indexOf(base64[i+3]);
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");


/***/ },
/* 909 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 910 */
/***/ function(module, exports) {

	/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
	  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
	  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
	  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
	  false;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  return ary.map(function(chunk) {
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      return buf;
	    }
	
	    return chunk;
	  });
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary).forEach(function(part) {
	    bb.append(part);
	  });
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  return new Blob(mapArrayBufferViews(ary), options || {});
	};
	
	if (typeof Blob !== 'undefined') {
	  BlobBuilderConstructor.prototype = Blob.prototype;
	  BlobConstructor.prototype = Blob.prototype;
	}
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(190);
	var Transform = __webpack_require__(191);
	var inherits = __webpack_require__(47);
	var modes = __webpack_require__(192);
	var StreamCipher = __webpack_require__(281);
	var ebtk = __webpack_require__(275);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(279),
	  CBC: __webpack_require__(276),
	  CFB: __webpack_require__(277),
	  OFB: __webpack_require__(280),
	  CTR: __webpack_require__(278)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(190);
	var Transform = __webpack_require__(191);
	var inherits = __webpack_require__(47);
	var modes = __webpack_require__(192);
	var ebtk = __webpack_require__(275);
	var StreamCipher = __webpack_require__(281);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(279),
	  CBC: __webpack_require__(276),
	  CFB: __webpack_require__(277),
	  OFB: __webpack_require__(280),
	  CTR: __webpack_require__(278)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(912)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(911)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(192);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 914 */
490,
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(936)();
	
	__webpack_require__(934)(Chart);
	__webpack_require__(950)(Chart);
	__webpack_require__(930)(Chart);
	__webpack_require__(939)(Chart);
	__webpack_require__(933)(Chart);
	__webpack_require__(929)(Chart);
	__webpack_require__(931)(Chart);
	__webpack_require__(932)(Chart);
	__webpack_require__(937)(Chart);
	__webpack_require__(941)(Chart);
	__webpack_require__(942)(Chart);
	__webpack_require__(940)(Chart);
	__webpack_require__(943)(Chart);
	__webpack_require__(938)(Chart);
	__webpack_require__(935)(Chart);
	__webpack_require__(944)(Chart);
	
	__webpack_require__(945)(Chart);
	__webpack_require__(946)(Chart);
	__webpack_require__(947)(Chart);
	__webpack_require__(948)(Chart);
	
	__webpack_require__(953)(Chart);
	__webpack_require__(951)(Chart);
	__webpack_require__(952)(Chart);
	__webpack_require__(954)(Chart);
	__webpack_require__(955)(Chart);
	__webpack_require__(956)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(923)(Chart);
	__webpack_require__(924)(Chart);
	__webpack_require__(925)(Chart);
	__webpack_require__(926)(Chart);
	__webpack_require__(927)(Chart);
	__webpack_require__(928)(Chart);
	
	__webpack_require__(916)(Chart);
	__webpack_require__(917)(Chart);
	__webpack_require__(918)(Chart);
	__webpack_require__(919)(Chart);
	__webpack_require__(920)(Chart);
	__webpack_require__(921)(Chart);
	__webpack_require__(922)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ },
/* 916 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 917 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 918 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 919 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 920 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 921 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 922 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // scatter should not use a category axis
					position: 'bottom',
					id: 'x-axis-1' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-1'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 923 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				meta.stack = dataset.stack;
				// Use this to indicate that this is a bar dataset.
				meta.bar = true;
			},
	
			// Correctly calculate the bar width accounting for stacks and the fact that not all bars are visible
			getStackCount: function() {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var stacks = [];
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var dsMeta = me.chart.getDatasetMeta(datasetIndex);
					if (dsMeta.bar && me.chart.isDatasetVisible(datasetIndex) &&
						(yScale.options.stacked === false ||
						(yScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(yScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}, me);
	
				return stacks.length;
			},
	
			update: function(reset) {
				var me = this;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					me.updateElement(rectangle, index, reset);
				}, me);
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = yScale.getBasePixel();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
	
				rectangle._xScale = xScale;
				rectangle._yScale = yScale;
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				var ruler = me.getRuler(index); // The index argument for compatible
				rectangle._model = {
					x: me.calculateBarX(index, me.index, ruler),
					y: reset ? scaleBase : me.calculateBarY(index, me.index),
	
					// Tooltip
					label: me.chart.data.labels[index],
					datasetLabel: dataset.label,
	
					// Appearance
					horizontal: false,
					base: reset ? scaleBase : me.calculateBarBase(me.index, index),
					width: me.calculateBarWidth(ruler),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
				};
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var base = yScale.getBaseValue();
				var original = base;
	
				if ((yScale.options.stacked === true) ||
					(yScale.options.stacked === undefined && meta.stack !== undefined)) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i) &&
							meta.stack === currentDsMeta.stack) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, original) : Math.max(currentVal, original);
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				return yScale.getBasePixel();
			},
	
			getRuler: function() {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var stackCount = me.getStackCount();
	
				var tickWidth = xScale.width / xScale.ticks.length;
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / stackCount;
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					stackCount: stackCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function(ruler) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				if (xScale.options.barThickness) {
					return xScale.options.barThickness;
				}
				return ruler.barWidth;
			},
	
			// Get stack index from the given dataset index accounting for stacks and the fact that not all bars are visible
			getStackIndex: function(datasetIndex) {
				var me = this;
				var meta = me.chart.getDatasetMeta(datasetIndex);
				var yScale = me.getScaleForId(meta.yAxisID);
				var dsMeta, j;
				var stacks = [meta.stack];
	
				for (j = 0; j < datasetIndex; ++j) {
					dsMeta = this.chart.getDatasetMeta(j);
					if (dsMeta.bar && this.chart.isDatasetVisible(j) &&
						(yScale.options.stacked === false ||
						(yScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(yScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}
	
				return stacks.length - 1;
			},
	
			calculateBarX: function(index, datasetIndex, ruler) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var stackIndex = me.getStackIndex(datasetIndex);
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				leftTick -= me.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * stackIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * stackIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (yScale.options.stacked ||
					(yScale.options.stacked === undefined && meta.stack !== undefined)) {
					var base = yScale.getBaseValue();
					var sumPos = base,
						sumNeg = base;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && me.chart.isDatasetVisible(i) &&
							meta.stack === dsMeta.stack) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					}
					return yScale.getPixelForValue(sumPos + value);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				var metaData = me.getMeta().data;
				var dataset = me.getDataset();
				var i, len;
	
				Chart.canvasHelpers.clipArea(me.chart.chart.ctx, me.chart.chartArea);
				for (i = 0, len = metaData.length; i < len; ++i) {
					var d = dataset.data[i];
					if (d !== null && d !== undefined && !isNaN(d)) {
						metaData[i].transition(easingDecimal).draw();
					}
				}
				Chart.canvasHelpers.unclipArea(me.chart.chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
	
			// Correctly calculate the bar width accounting for stacks and the fact that not all bars are visible
			getStackCount: function() {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
	
				var stacks = [];
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var dsMeta = me.chart.getDatasetMeta(datasetIndex);
					if (dsMeta.bar && me.chart.isDatasetVisible(datasetIndex) &&
						(xScale.options.stacked === false ||
						(xScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(xScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}, me);
	
				return stacks.length;
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = xScale.getBasePixel();
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
	
				rectangle._xScale = xScale;
				rectangle._yScale = yScale;
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				var ruler = me.getRuler(index); // The index argument for compatible
				rectangle._model = {
					x: reset ? scaleBase : me.calculateBarX(index, me.index),
					y: me.calculateBarY(index, me.index, ruler),
	
					// Tooltip
					label: me.chart.data.labels[index],
					datasetLabel: dataset.label,
	
					// Appearance
					horizontal: true,
					base: reset ? scaleBase : me.calculateBarBase(me.index, index),
					height: me.calculateBarHeight(ruler),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
				};
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var base = xScale.getBaseValue();
				var originalBase = base;
	
				if (xScale.options.stacked ||
					(xScale.options.stacked === undefined && meta.stack !== undefined)) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.xAxisID === xScale.id && chart.isDatasetVisible(i) &&
							meta.stack === currentDsMeta.stack) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, originalBase) : Math.max(currentVal, originalBase);
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				return xScale.getBasePixel();
			},
	
			getRuler: function() {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var stackCount = me.getStackCount();
	
				var tickHeight = yScale.height / yScale.ticks.length;
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / stackCount;
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					stackCount: stackCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing
				};
			},
	
			calculateBarHeight: function(ruler) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				if (yScale.options.barThickness) {
					return yScale.options.barThickness;
				}
				return ruler.barHeight;
			},
	
			// Get stack index from the given dataset index accounting for stacks and the fact that not all bars are visible
			getStackIndex: function(datasetIndex) {
				var me = this;
				var meta = me.chart.getDatasetMeta(datasetIndex);
				var xScale = me.getScaleForId(meta.xAxisID);
				var dsMeta, j;
				var stacks = [meta.stack];
	
				for (j = 0; j < datasetIndex; ++j) {
					dsMeta = this.chart.getDatasetMeta(j);
					if (dsMeta.bar && this.chart.isDatasetVisible(j) &&
						(xScale.options.stacked === false ||
						(xScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(xScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}
	
				return stacks.length - 1;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (xScale.options.stacked ||
					(xScale.options.stacked === undefined && meta.stack !== undefined)) {
					var base = xScale.getBaseValue();
					var sumPos = base,
						sumNeg = base;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && me.chart.isDatasetVisible(i) &&
							meta.stack === dsMeta.stack) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					}
					return xScale.getPixelForValue(sumPos + value);
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function(index, datasetIndex, ruler) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var stackIndex = me.getStackIndex(datasetIndex);
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				topTick -= me.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * stackIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * stackIndex);
			}
		});
	};


/***/ },
/* 924 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ },
/* 925 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						var dataLabel = data.labels[tooltipItem.index];
						var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
						if (helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
	
						return dataLabel;
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ },
/* 926 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePixel()
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth)) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function(ease) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data || [];
				var easingDecimal = ease || 1;
				var i, ilen;
	
				// Transition Point Locations
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].transition(easingDecimal);
				}
	
				Chart.canvasHelpers.clipArea(me.chart.chart.ctx, me.chart.chartArea);
				// Transition and Draw the line
				if (lineEnabled(me.getDataset(), me.chart.options)) {
					meta.dataset.transition(easingDecimal).draw();
				}
				Chart.canvasHelpers.unclipArea(me.chart.chart.ctx);
	
				// Draw the points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].draw(me.chart.chartArea);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ },
/* 927 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				lineArc: true, // so that lines are circular
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ },
/* 928 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			aspectRatio: 1,
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePosition()
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.radius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ },
/* 929 */
/***/ function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @function Chart.animationService.addAnimation
			 * @param chartInstance {ChartController} the chart to animate
			 * @param animationObject {IAnimation} the animation that we will animate
			 * @param duration {Number} length of animation in ms
			 * @param lazy {Boolean} if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
				var me = this;
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < me.animations.length; ++index) {
					if (me.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						me.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				me.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (me.animations.length === 1) {
					me.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
				var me = this;
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				var i = 0;
				while (i < me.animations.length) {
					if (me.animations[i].animationObject.currentStep === null) {
						me.animations[i].animationObject.currentStep = 0;
					}
	
					me.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (me.animations[i].animationObject.currentStep > me.animations[i].animationObject.numSteps) {
						me.animations[i].animationObject.currentStep = me.animations[i].animationObject.numSteps;
					}
	
					me.animations[i].animationObject.render(me.animations[i].chartInstance, me.animations[i].animationObject);
					if (me.animations[i].animationObject.onAnimationProgress && me.animations[i].animationObject.onAnimationProgress.call) {
						me.animations[i].animationObject.onAnimationProgress.call(me.animations[i].chartInstance, me.animations[i]);
					}
	
					if (me.animations[i].animationObject.currentStep === me.animations[i].animationObject.numSteps) {
						if (me.animations[i].animationObject.onAnimationComplete && me.animations[i].animationObject.onAnimationComplete.call) {
							me.animations[i].animationObject.onAnimationComplete.call(me.animations[i].chartInstance, me.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						me.animations[i].chartInstance.animating = false;
	
						me.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / me.frameDuration;
	
				me.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			}
		};
	};


/***/ },
/* 930 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				Chart.helpers.drawRoundedRectangle(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	
		helpers.clipArea = function(ctx, clipArea) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(clipArea.left, clipArea.top, clipArea.right - clipArea.left, clipArea.bottom - clipArea.top);
			ctx.clip();
		};
	
		helpers.unclipArea = function(ctx) {
			ctx.restore();
		};
	
	};


/***/ },
/* 931 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var plugins = Chart.plugins;
		var platform = Chart.platform;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				Chart.defaults.global,
				Chart.defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart.Controller} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		/**
		 * @class Chart.Controller
		 * The main controller of a chart.
		 */
		Chart.Controller = function(item, config, instance) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			instance.ctx = context;
			instance.canvas = canvas;
			instance.config = config;
			instance.width = width;
			instance.height = height;
			instance.aspectRatio = height? width / height : null;
	
			me.id = helpers.uid();
			me.chart = instance;
			me.config = config;
			me.options = config.options;
			me._bufferedRender = false;
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return me;
			}
	
			me.initialize();
			me.update();
	
			return me;
		};
	
		helpers.extend(Chart.Controller.prototype, /** @lends Chart.Controller.prototype */ {
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me.chart);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var chart = me.chart;
				var options = me.options;
				var canvas = chart.canvas;
				var aspectRatio = (options.maintainAspectRatio && chart.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
				var newWidth = Math.floor(helpers.getMaximumWidth(canvas));
				var newHeight = Math.floor(aspectRatio? newWidth / aspectRatio : helpers.getMaximumHeight(canvas));
	
				if (chart.width === newWidth && chart.height === newHeight) {
					return;
				}
	
				canvas.width = chart.width = newWidth;
				canvas.height = chart.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(chart);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear'};
						})
					);
				}
	
				if (options.scale) {
					items.push({options: options.scale, dtype: 'radialLinear', isDefault: true});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.chart.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						lazy: lazy,
						duration: animationDuration
					};
				} else {
					me.render(animationDuration, lazy);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.getDatasetMeta(i).controller.update();
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			render: function(duration, lazy) {
				var me = this;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function() {
					plugins.notify(me, 'afterRender');
					var callback = animationOptions && animationOptions.onComplete;
					if (callback && callback.call) {
						callback.call(me);
					}
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || animationOptions.duration) / 16.66; // 60 fps
					animation.easing = animationOptions.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = animationOptions.onProgress;
					animation.onAnimationComplete = onComplete;
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
					onComplete();
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (easingValue === undefined || easingValue === null) {
					easingValue = 1;
				}
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
	
				// Finally draw the tooltip
				me.tooltip.transition(easingValue).draw();
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						me.getDatasetMeta(datasetIndex).controller.draw(easingValue);
					}
				}, me, true);
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Chart.Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Chart.Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Chart.Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Chart.Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Chart.Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.chart.canvas;
				var meta, i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					meta = me.getDatasetMeta(i);
					if (meta.controller) {
						meta.controller.destroy();
						meta.controller = null;
					}
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.clear(me.chart);
					platform.releaseContext(me.chart.ctx);
					me.chart.canvas = null;
					me.chart.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me.chart,
					_chartInstance: me,
					_data: me.data,
					_options: me.options.tooltips
				}, me);
				me.tooltip.initialize();
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Responsiveness is currently based on the use of an iframe, however this method causes
				// performance issues and could be troublesome when used with ad blockers. So make sure
				// that the user is still able to create a chart without iframe when responsive is false.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest.duration, bufferedRequest.lazy);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					// Need to call with native event here to not break backwards compatibility
					hoverOptions.onHover.call(me, e.native, me.active);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	};


/***/ },
/* 932 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				var i, len;
				var metaData = this.getMeta().data;
				for (i = 0, len = metaData.length; i < len; ++i) {
					metaData[i].transition(easingDecimal).draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i=0; i<count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length-1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ },
/* 933 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = helpers.clone(me._view);
				return me;
			},
	
			transition: function(ease) {
				var me = this;
	
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
	
				// No animation -> No Transition
				if (ease === 1) {
					me._view = me._model;
					me._start = null;
					return me;
				}
	
				if (!me._start) {
					me.pivot();
				}
	
				helpers.each(me._model, function(value, key) {
	
					if (key[0] === '_') {
						// Only non-underscored properties
					// Init if doesn't exist
					} else if (!me._view.hasOwnProperty(key)) {
						if (typeof value === 'number' && !isNaN(me._view[key])) {
							me._view[key] = value * ease;
						} else {
							me._view[key] = value;
						}
					// No unnecessary computations
					} else if (value === me._view[key]) {
						// It's the same! Woohoo!
					// Color transitions if possible
					} else if (typeof value === 'string') {
						try {
							var color = helpers.color(me._model[key]).mix(helpers.color(me._start[key]), ease);
							me._view[key] = color.rgbString();
						} catch (err) {
							me._view[key] = value;
						}
					// Number transitions
					} else if (typeof value === 'number') {
						var startVal = me._start[key] !== undefined && isNaN(me._start[key]) === false ? me._start[key] : 0;
						me._view[key] = ((me._model[key] - startVal) * ease) + startVal;
					// Everything else
					} else {
						me._view[key] = value;
					}
				}, me);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	
	};


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(958);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					var baseHasProperty = base.hasOwnProperty(key);
					var baseVal = baseHasProperty ? base[key] : {};
	
					if (key === 'scales') {
						// Scale config merging is complex. Add our own function here for that
						base[key] = helpers.scaleMerge(baseVal, value);
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(baseVal, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (baseHasProperty
							&& typeof baseVal === 'object'
							&& !helpers.isArray(baseVal)
							&& baseVal !== null
							&& typeof value === 'object'
							&& !helpers.isArray(value)) {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(baseVal, value);
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.error('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ },
/* 935 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		/**
		 * Helper function to get relative position for an event
		 * @param {Event|IEvent} event - The event to get the position for
		 * @param {Chart} chart - The chart
		 * @returns {Point} the event position
		 */
		function getRelativePosition(e, chart) {
			if (e.native) {
				return {
					x: e.x,
					y: e.y
				};
			}
	
			return helpers.getRelativePosition(e, chart);
		}
	
		/**
		 * Helper function to traverse all of the visible elements in the chart
		 * @param chart {chart} the chart
		 * @param handler {Function} the callback to execute for each visible item
		 */
		function parseVisibleItems(chart, handler) {
			var datasets = chart.data.datasets;
			var meta, i, j, ilen, jlen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!chart.isDatasetVisible(i)) {
					continue;
				}
	
				meta = chart.getDatasetMeta(i);
				for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
					var element = meta.data[j];
					if (!element._view.skip) {
						handler(element);
					}
				}
			}
		}
	
		/**
		 * Helper function to get the items that intersect the event position
		 * @param items {ChartElement[]} elements to filter
		 * @param position {Point} the point to be nearest to
		 * @return {ChartElement[]} the nearest items
		 */
		function getIntersectItems(chart, position) {
			var elements = [];
	
			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
				}
			});
	
			return elements;
		}
	
		/**
		 * Helper function to get the items nearest to the event position considering all visible items in teh chart
		 * @param chart {Chart} the chart to look at elements from
		 * @param position {Point} the point to be nearest to
		 * @param intersect {Boolean} if true, only consider items that intersect the position
		 * @param distanceMetric {Function} Optional function to provide the distance between
		 * @return {ChartElement[]} the nearest items
		 */
		function getNearestItems(chart, position, intersect, distanceMetric) {
			var minDistance = Number.POSITIVE_INFINITY;
			var nearestItems = [];
	
			if (!distanceMetric) {
				distanceMetric = helpers.distanceBetweenPoints;
			}
	
			parseVisibleItems(chart, function(element) {
				if (intersect && !element.inRange(position.x, position.y)) {
					return;
				}
	
				var center = element.getCenterPoint();
				var distance = distanceMetric(position, center);
	
				if (distance < minDistance) {
					nearestItems = [element];
					minDistance = distance;
				} else if (distance === minDistance) {
					// Can have multiple items at the same distance in which case we sort by size
					nearestItems.push(element);
				}
			});
	
			return nearestItems;
		}
	
		function indexMode(chart, e, options) {
			var position = getRelativePosition(e, chart.chart);
			var distanceMetric = function(pt1, pt2) {
				return Math.abs(pt1.x - pt2.x);
			};
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
			var elements = [];
	
			if (!items.length) {
				return [];
			}
	
			chart.data.datasets.forEach(function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex),
						element = meta.data[items[0]._index];
	
					// don't count items that are skipped (null data)
					if (element && !element._view.skip) {
						elements.push(element);
					}
				}
			});
	
			return elements;
		}
	
		/**
		 * @interface IInteractionOptions
		 */
		/**
		 * If true, only consider items that intersect the point
		 * @name IInterfaceOptions#boolean
		 * @type Boolean
		 */
	
		/**
		 * Contains interaction related functions
		 * @namespace Chart.Interaction
		 */
		Chart.Interaction = {
			// Helper function for different modes
			modes: {
				single: function(chart, e) {
					var position = getRelativePosition(e, chart.chart);
					var elements = [];
	
					parseVisibleItems(chart, function(element) {
						if (element.inRange(position.x, position.y)) {
							elements.push(element);
							return elements;
						}
					});
	
					return elements.slice(0, 1);
				},
	
				/**
				 * @function Chart.Interaction.modes.label
				 * @deprecated since version 2.4.0
				 */
				label: indexMode,
	
				/**
				 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
				 * @function Chart.Interaction.modes.index
				 * @since v2.4.0
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				index: indexMode,
	
				/**
				 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect is false, we find the nearest item and return the items in that dataset
				 * @function Chart.Interaction.modes.dataset
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				dataset: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false);
	
					if (items.length > 0) {
						items = chart.getDatasetMeta(items[0]._datasetIndex).data;
					}
	
					return items;
				},
	
				/**
				 * @function Chart.Interaction.modes.x-axis
				 * @deprecated since version 2.4.0. Use index mode and intersect == true
				 */
				'x-axis': function(chart, e) {
					return indexMode(chart, e, true);
				},
	
				/**
				 * Point mode returns all elements that hit test based on the event position
				 * of the event
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				point: function(chart, e) {
					var position = getRelativePosition(e, chart.chart);
					return getIntersectItems(chart, position);
				},
	
				/**
				 * nearest mode returns the element closest to the point
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				nearest: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var nearestItems = getNearestItems(chart, position, options.intersect);
	
					// We have multiple items at the same distance from the event. Now sort by smallest
					if (nearestItems.length > 1) {
						nearestItems.sort(function(a, b) {
							var sizeA = a.getArea();
							var sizeB = b.getArea();
							var ret = sizeA - sizeB;
	
							if (ret === 0) {
								// if equal sort by dataset index
								ret = a._datasetIndex - b._datasetIndex;
							}
	
							return ret;
						});
					}
	
					// Return only 1 item
					return nearestItems.slice(0, 1);
				},
	
				/**
				 * x mode returns the elements that hit-test at the current x coordinate
				 * @function Chart.Interaction.modes.x
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				x: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inXRange(position.x)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				},
	
				/**
				 * y mode returns the elements that hit-test at the current y coordinate
				 * @function Chart.Interaction.modes.y
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				y: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inYRange(position.y)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				}
			}
		};
	};


/***/ },
/* 936 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.controller = new Chart.Controller(item, config, this);
			return this.controller;
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'nearest',
					intersect: true,
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ },
/* 937 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var layoutOptions = chartInstance.options.layout;
				var padding = layoutOptions ? layoutOptions.padding : null;
	
				var leftPadding = 0;
				var rightPadding = 0;
				var topPadding = 0;
				var bottomPadding = 0;
	
				if (!isNaN(padding)) {
					// options.layout.padding is a number. assign to all
					leftPadding = padding;
					rightPadding = padding;
					topPadding = padding;
					bottomPadding = padding;
				} else {
					leftPadding = padding.left || 0;
					rightPadding = padding.right || 0;
					topPadding = padding.top || 0;
					bottomPadding = padding.bottom || 0;
				}
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'left';
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'right';
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'top';
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'bottom';
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'chartArea';
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ },
/* 938 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels;
				var legendItems = labelOpts.generateLabels.call(me, me.chart);
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize),
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x,
					y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chartInstance, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chartInstance.chart.ctx,
				options: legendOpts,
				chart: chartInstance
			});
			chartInstance.legend = legend;
			Chart.layoutService.addBox(chartInstance, legend);
		}
	
		// Register the legend plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var legendOpts = chartInstance.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chartInstance, legendOpts);
				}
			},
			beforeUpdate: function(chartInstance) {
				var legendOpts = chartInstance.options.legend;
	
				if (legendOpts) {
					legendOpts = helpers.configMerge(Chart.defaults.global.legend, legendOpts);
	
					if (chartInstance.legend) {
						chartInstance.legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chartInstance, legendOpts);
					}
				} else {
					Chart.layoutService.removeBox(chartInstance, chartInstance.legend);
					delete chartInstance.legend;
				}
			},
			afterEvent: function(chartInstance, e) {
				var legend = chartInstance.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		});
	};


/***/ },
/* 939 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.plugins = {};
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i=0; i<ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var defaults = Chart.defaults.global.plugins;
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = helpers.inherits({});
	};


/***/ },
/* 940 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 0,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: Chart.Ticks.formatters.values
			}
		};
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var getValueOrDefault = helpers.getValueOrDefault;
			var globalDefaults = Chart.defaults.global;
			var size = getValueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = getValueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = getValueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		Chart.Scale = Chart.Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, me.ticks, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation;
					var sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var scaleLabelFontSize = parseFontOptions(scaleLabelOpts).size * 1.5;
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += scaleLabelFontSize;
					} else {
						minSize.width += scaleLabelFontSize;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFont.size * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickFont.font;
	
						var firstTick = me.ticks[0];
						var firstLabelWidth = computeTextSize(me.ctx, firstTick, tickFont.font);
	
						var lastTick = me.ticks[me.ticks.length - 1];
						var lastLabelWidth = computeTextSize(me.ctx, lastTick, tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom'? (cosRotation * firstLabelWidth) + 3: (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom'? (cosRotation * lineSpace) + 3: (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						// Account for padding
	
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							largestTextWidth += me.options.ticks.padding;
						}
						minSize.width += largestTextWidth;
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof(rawValue) === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
				var borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				var borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					// Only calculate the skip ratio with the half width of longestRotateLabel if we got an actual rotation
					// See #2584
					if (isRotated) {
						longestRotatedLabel /= 2;
					}
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated? 'top':'middle';
							textAlign = !isRotated? 'center': 'right';
							labelY = me.top + tl;
						} else {
							// top
							textBaseline = !isRotated? 'bottom':'middle';
							textAlign = !isRotated? 'center': 'left';
							labelY = me.bottom - tl;
						}
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var tickPadding = optionTicks.padding;
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickFont.font;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFont.size / 2) : me.top + (scaleLabelFont.size / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFont.size / 2) : me.right - (scaleLabelFont.size / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ },
/* 941 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};


/***/ },
/* 942 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
		 * Namespace to hold static tick generation functions
		 * @namespace Chart.Ticks
		 */
		Chart.Ticks = {
			/**
			 * Namespace to hold generators for different types of ticks
			 * @namespace Chart.Ticks.generators
			 */
			generators: {
				/**
				 * Interface for the options provided to the numeric tick generator
				 * @interface INumericTickGenerationOptions
				 */
				/**
				 * The maximum number of ticks to display
				 * @name INumericTickGenerationOptions#maxTicks
				 * @type Number
				 */
				/**
				 * The distance between each tick.
				 * @name INumericTickGenerationOptions#stepSize
				 * @type Number
				 * @optional
				 */
				/**
				 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
				 * @name INumericTickGenerationOptions#min
				 * @type Number
				 * @optional
				 */
				/**
				 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
				 * @name INumericTickGenerationOptions#max
				 * @type Number
				 * @optional
				 */
	
				/**
				 * Generate a set of linear ticks
				 * @method Chart.Ticks.generators.linear
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				linear: function(generationOptions, dataRange) {
					var ticks = [];
					// To get a "nice" value for the tick spacing, we will use the appropriately named
					// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
					// for details.
	
					var spacing;
					if (generationOptions.stepSize && generationOptions.stepSize > 0) {
						spacing = generationOptions.stepSize;
					} else {
						var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
						spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
					}
					var niceMin = Math.floor(dataRange.min / spacing) * spacing;
					var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
					// If min, max and stepSize is set and they make an evenly spaced scale use it.
					if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
						// If very close to our whole number, use it.
						if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
							niceMin = generationOptions.min;
							niceMax = generationOptions.max;
						}
					}
	
					var numSpaces = (niceMax - niceMin) / spacing;
					// If very close to our rounded value, use it.
					if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
						numSpaces = Math.round(numSpaces);
					} else {
						numSpaces = Math.ceil(numSpaces);
					}
	
					// Put the values into the ticks array
					ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
					for (var j = 1; j < numSpaces; ++j) {
						ticks.push(niceMin + (j * spacing));
					}
					ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
					return ticks;
				},
	
				/**
				 * Generate a set of logarithmic ticks
				 * @method Chart.Ticks.generators.logarithmic
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				logarithmic: function(generationOptions, dataRange) {
					var ticks = [];
					var getValueOrDefault = helpers.getValueOrDefault;
	
					// Figure out what the max number of ticks we can support it is based on the size of
					// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
					// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
					// the graph
					var tickVal = getValueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
					var endExp = Math.floor(helpers.log10(dataRange.max));
					var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(dataRange.minNotZero));
						significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
						ticks.push(tickVal);
						tickVal = significand * Math.pow(10, exp);
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp));
					}
	
					do {
						ticks.push(tickVal);
	
						++significand;
						if (significand === 10) {
							significand = 1;
							++exp;
						}
	
						tickVal = significand * Math.pow(10, exp);
					} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
					var lastTick = getValueOrDefault(generationOptions.max, tickVal);
					ticks.push(lastTick);
	
					return ticks;
				}
			},
	
			/**
			 * Namespace to hold formatters for different types of ticks
			 * @namespace Chart.Ticks.formatters
			 */
			formatters: {
				/**
				 * Formatter for value labels
				 * @method Chart.Ticks.formatters.values
				 * @param value the value to display
				 * @return {String|Array} the label to display
				 */
				values: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				},
	
				/**
				 * Formatter for linear numeric ticks
				 * @method Chart.Ticks.formatters.linear
				 * @param tickValue {Number} the value to be formatted
				 * @param index {Number} the position of the tickValue parameter in the ticks array
				 * @param ticks {Array<Number>} the list of ticks being converted
				 * @return {String} string representation of the tickValue parameter
				 */
				linear: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				},
	
				logarithmic: function(tickValue, index, ticks) {
					var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
					if (tickValue === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
						return tickValue.toExponential();
					}
					return '';
				}
			}
		};
	};


/***/ },
/* 943 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right,
						maxWidth;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0, maxWidth);
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chartInstance, titleOpts) {
			var title = new Chart.Title({
				ctx: chartInstance.chart.ctx,
				options: titleOpts,
				chart: chartInstance
			});
			chartInstance.titleBlock = title;
			Chart.layoutService.addBox(chartInstance, title);
		}
	
		// Register the title plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var titleOpts = chartInstance.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chartInstance, titleOpts);
				}
			},
			beforeUpdate: function(chartInstance) {
				var titleOpts = chartInstance.options.title;
	
				if (titleOpts) {
					titleOpts = helpers.configMerge(Chart.defaults.global.title, titleOpts);
	
					if (chartInstance.titleBlock) {
						chartInstance.titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chartInstance, titleOpts);
					}
				} else {
					Chart.layoutService.removeBox(chartInstance, chartInstance.titleBlock);
					delete chartInstance.titleBlock;
				}
			}
		});
	};


/***/ },
/* 944 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				labelColor: function(tooltipItem, chartInstance) {
					var meta = chartInstance.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = Chart.defaults.global;
			var getValueOrDefault = helpers.getValueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize,
				bodyFontSize = model.bodyFontSize,
				footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chartInstance.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize,
				caretPadding = vm.caretPadding,
				cornerRadius = vm.cornerRadius,
				xAlign = alignment.xAlign,
				yAlign = alignment.yAlign,
				paddingAndSize = caretSize + caretPadding,
				radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
				var chartInstance = me._chartInstance;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position](active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, chartInstance));
					});
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = helpers.getValueOrDefault(tooltipPosition.padding, 2);
					model.labelColors = labelColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size, opacity) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					// Left or right side
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
					}
	
					y2 = ptY + (height / 2);
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				} else {
					if (xAlign === 'left') {
						x1 = ptX + cornerRadius;
						x2 = x1 + caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x1 = ptX + width - cornerRadius;
						x2 = x1 - caretSize;
						x3 = x2 - caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
	
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
					}
				}
	
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var textColor = mergeOpacity(vm.bodyFontColor, opacity);
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
				ctx.fill();
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.enabled) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chartInstance.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
	
				var nearestElement;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len;
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ },
/* 945 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var halfAngle = (vm.startAngle + vm.endAngle) / 2;
				var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
				return {
					x: vm.x + Math.cos(halfAngle) * halfRadius,
					y: vm.y + Math.sin(halfAngle) * halfRadius
				};
			},
			getArea: function() {
				var vm = this._view;
				return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ },
/* 946 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var spanGaps = vm.spanGaps;
				var fillPoint = vm.scaleZero;
				var loop = me._loop;
	
				// Handle different fill modes for cartesian lines
				if (!loop) {
					if (vm.fill === 'top') {
						fillPoint = vm.scaleTop;
					} else if (vm.fill === 'bottom') {
						fillPoint = vm.scaleBottom;
					}
				}
	
				var ctx = me._chart.ctx;
				ctx.save();
	
				// Helper function to draw a line to a point
				function lineToPoint(previousPoint, point) {
					var pointVM = point._view;
					if (point._view.steppedLine === true) {
						ctx.lineTo(pointVM.x, previousPoint._view.y);
						ctx.lineTo(pointVM.x, pointVM.y);
					} else if (point._view.tension === 0) {
						ctx.lineTo(pointVM.x, pointVM.y);
					} else {
						ctx.bezierCurveTo(
							previousPoint._view.controlPointNextX,
							previousPoint._view.controlPointNextY,
							pointVM.controlPointPreviousX,
							pointVM.controlPointPreviousY,
							pointVM.x,
							pointVM.y
						);
					}
				}
	
				var points = me._children.slice(); // clone array
				var lastDrawnIndex = -1;
	
				// If we are looping, adding the first point again
				if (loop && points.length) {
					points.push(points[0]);
				}
	
				var index, current, previous, currentVM;
	
				// Fill Line
				if (points.length && vm.fill) {
					ctx.beginPath();
	
					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (loop) {
								ctx.moveTo(fillPoint.x, fillPoint.y);
							} else {
								ctx.moveTo(currentVM.x, fillPoint);
							}
	
							if (!currentVM.skip) {
								lastDrawnIndex = index;
								ctx.lineTo(currentVM.x, currentVM.y);
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
							if (currentVM.skip) {
								// Only do this if this is the first point that is skipped
								if (!spanGaps && lastDrawnIndex === (index - 1)) {
									if (loop) {
										ctx.lineTo(fillPoint.x, fillPoint.y);
									} else {
										ctx.lineTo(previous._view.x, fillPoint);
									}
								}
							} else {
								if (lastDrawnIndex !== (index - 1)) {
									// There was a gap and this is the first point after the gap. If we've never drawn a point, this is a special case.
									// If the first data point is NaN, then there is no real gap to skip
									if (spanGaps && lastDrawnIndex !== -1) {
										// We are spanning the gap, so simple draw a line to this point
										lineToPoint(previous, current);
									} else if (loop) {
										ctx.lineTo(currentVM.x, currentVM.y);
									} else {
										ctx.lineTo(currentVM.x, fillPoint);
										ctx.lineTo(currentVM.x, currentVM.y);
									}
								} else {
									// Line to next point
									lineToPoint(previous, current);
								}
								lastDrawnIndex = index;
							}
						}
					}
	
					if (!loop && lastDrawnIndex !== -1) {
						ctx.lineTo(points[lastDrawnIndex]._view.x, fillPoint);
					}
	
					ctx.fillStyle = vm.backgroundColor || globalDefaults.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Stroke Line Options
				var globalOptionLineElements = globalDefaults.elements.line;
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								lineToPoint(previous, current);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ },
/* 947 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		function xRange(mouseX) {
			var vm = this._view;
			return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		function yRange(mouseY) {
			var vm = this._view;
			return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
	
			inLabelRange: xRange,
			inXRange: xRange,
			inYRange: yRange,
	
			getCenterPoint: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			},
			getArea: function() {
				return Math.PI * Math.pow(this._view.radius, 2);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function(chartArea) {
				var vm = this._view;
				var model = this._model;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
				var color = Chart.helpers.color;
				var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
				var ratio = 0;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				// Cliping for Points.
				// going out from inner charArea?
				if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right*errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom*errMargin < model.y))) {
					// Point fade out
					if (model.x < chartArea.left) {
						ratio = (x - model.x) / (chartArea.left - model.x);
					} else if (chartArea.right*errMargin < model.x) {
						ratio = (model.x - x) / (model.x - chartArea.right);
					} else if (model.y < chartArea.top) {
						ratio = (y - model.y) / (chartArea.top - model.y);
					} else if (chartArea.bottom*errMargin < model.y) {
						ratio = (model.y - y) / (model.y - chartArea.bottom);
					}
					ratio = Math.round(ratio*100) / 100;
					ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
					ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
				}
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ },
/* 948 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		function isVertical(bar) {
			return bar._view.width !== undefined;
		}
	
		/**
		 * Helper function to get the bounds of the bar regardless of the orientation
		 * @private
		 * @param bar {Chart.Element.Rectangle} the bar
		 * @return {Bounds} bounds of the bar
		 */
		function getBarBounds(bar) {
			var vm = bar._view;
			var x1, x2, y1, y2;
	
			if (isVertical(bar)) {
				// vertical
				var halfWidth = vm.width / 2;
				x1 = vm.x - halfWidth;
				x2 = vm.x + halfWidth;
				y1 = Math.min(vm.y, vm.base);
				y2 = Math.max(vm.y, vm.base);
			} else {
				// horizontal bar
				var halfHeight = vm.height / 2;
				x1 = Math.min(vm.x, vm.base);
				x2 = Math.max(vm.x, vm.base);
				y1 = vm.y - halfHeight;
				y2 = vm.y + halfHeight;
			}
	
			return {
				left: x1,
				top: y1,
				right: x2,
				bottom: y2
			};
		}
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var left, right, top, bottom, signX, signY, borderSkipped;
				var borderWidth = vm.borderWidth;
	
				if (!vm.horizontal) {
					// bar
					left = vm.x - vm.width / 2;
					right = vm.x + vm.width / 2;
					top = vm.y;
					bottom = vm.base;
					signX = 1;
					signY = bottom > top? 1: -1;
					borderSkipped = vm.borderSkipped || 'bottom';
				} else {
					// horizontal bar
					left = vm.base;
					right = vm.x;
					top = vm.y - vm.height / 2;
					bottom = vm.y + vm.height / 2;
					signX = right > left? 1: -1;
					signY = 1;
					borderSkipped = vm.borderSkipped || 'left';
				}
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (borderWidth) {
					// borderWidth shold be less than bar width and bar height.
					var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
					borderWidth = borderWidth > barSize? barSize: borderWidth;
					var halfStroke = borderWidth / 2;
					// Adjust borderWidth when bar top position is near vm.base(zero).
					var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
					var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
					var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
					var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
					// not become a vertical line?
					if (borderLeft !== borderRight) {
						top = borderTop;
						bottom = borderBottom;
					}
					// not become a horizontal line?
					if (borderTop !== borderBottom) {
						left = borderLeft;
						right = borderRight;
					}
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[left, bottom],
					[left, top],
					[right, top],
					[right, bottom]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				var corner = cornerAt(0);
				ctx.moveTo(corner[0], corner[1]);
	
				for (var i = 1; i < 4; i++) {
					corner = cornerAt(i);
					ctx.lineTo(corner[0], corner[1]);
				}
	
				ctx.fill();
				if (borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var inRange = false;
	
				if (this._view) {
					var bounds = getBarBounds(this);
					inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inLabelRange: function(mouseX, mouseY) {
				var me = this;
				if (!me._view) {
					return false;
				}
	
				var inRange = false;
				var bounds = getBarBounds(me);
	
				if (isVertical(me)) {
					inRange = mouseX >= bounds.left && mouseX <= bounds.right;
				} else {
					inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inXRange: function(mouseX) {
				var bounds = getBarBounds(this);
				return mouseX >= bounds.left && mouseX <= bounds.right;
			},
			inYRange: function(mouseY) {
				var bounds = getBarBounds(this);
				return mouseY >= bounds.top && mouseY <= bounds.bottom;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var x, y;
				if (isVertical(this)) {
					x = vm.x;
					y = (vm.y + vm.base) / 2;
				} else {
					x = (vm.x + vm.base) / 2;
					y = vm.y;
				}
	
				return {x: x, y: y};
			},
			getArea: function() {
				var vm = this._view;
				return vm.width * Math.abs(vm.y - vm.base);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ },
/* 949 */
/***/ function(module, exports) {

	'use strict';
	
	// Chart.Platform implementation for targeting a web browser
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		// DOM event types -> Chart.js event types.
		// Note: only events with different types are mapped.
		// https://developer.mozilla.org/en-US/docs/Web/Events
		var eventTypeMap = {
			// Touch events
			touchstart: 'mousedown',
			touchmove: 'mousemove',
			touchend: 'mouseup',
	
			// Pointer events
			pointerenter: 'mouseenter',
			pointerdown: 'mousedown',
			pointermove: 'mousemove',
			pointerup: 'mouseup',
			pointerleave: 'mouseout',
			pointerout: 'mouseout'
		};
	
		/**
		 * The "used" size is the final value of a dimension property after all calculations have
		 * been performed. This method uses the computed style of `element` but returns undefined
		 * if the computed style is not expressed in pixels. That can happen in some cases where
		 * `element` has a size relative to its parent and this last one is not yet displayed,
		 * for example because of `display: none` on a parent node.
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
		 * @returns {Number} Size in pixels or undefined if unknown.
		 */
		function readUsedSize(element, property) {
			var value = helpers.getStyle(element, property);
			var matches = value && value.match(/(\d+)px/);
			return matches? Number(matches[1]) : undefined;
		}
	
		/**
		 * Initializes the canvas style and render size without modifying the canvas display size,
		 * since responsiveness is handled by the controller.resize() method. The config is used
		 * to determine the aspect ratio to apply in case no explicit height has been specified.
		 */
		function initCanvas(canvas, config) {
			var style = canvas.style;
	
			// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
			// returns null or '' if no explicit value has been set to the canvas attribute.
			var renderHeight = canvas.getAttribute('height');
			var renderWidth = canvas.getAttribute('width');
	
			// Chart.js modifies some canvas values that we want to restore on destroy
			canvas._chartjs = {
				initial: {
					height: renderHeight,
					width: renderWidth,
					style: {
						display: style.display,
						height: style.height,
						width: style.width
					}
				}
			};
	
			// Force canvas to display as block to avoid extra space caused by inline
			// elements, which would interfere with the responsive resize process.
			// https://github.com/chartjs/Chart.js/issues/2538
			style.display = style.display || 'block';
	
			if (renderWidth === null || renderWidth === '') {
				var displayWidth = readUsedSize(canvas, 'width');
				if (displayWidth !== undefined) {
					canvas.width = displayWidth;
				}
			}
	
			if (renderHeight === null || renderHeight === '') {
				if (canvas.style.height === '') {
					// If no explicit render height and style height, let's apply the aspect ratio,
					// which one can be specified by the user but also by charts as default option
					// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
					canvas.height = canvas.width / (config.options.aspectRatio || 2);
				} else {
					var displayHeight = readUsedSize(canvas, 'height');
					if (displayWidth !== undefined) {
						canvas.height = displayHeight;
					}
				}
			}
	
			return canvas;
		}
	
		function createEvent(type, chart, x, y, native) {
			return {
				type: type,
				chart: chart,
				native: native || null,
				x: x !== undefined? x : null,
				y: y !== undefined? y : null,
			};
		}
	
		function fromNativeEvent(event, chart) {
			var type = eventTypeMap[event.type] || event.type;
			var pos = helpers.getRelativePosition(event, chart);
			return createEvent(type, chart, pos.x, pos.y, event);
		}
	
		function createResizer(handler) {
			var iframe = document.createElement('iframe');
			iframe.className = 'chartjs-hidden-iframe';
			iframe.style.cssText =
				'display:block;'+
				'overflow:hidden;'+
				'border:0;'+
				'margin:0;'+
				'top:0;'+
				'left:0;'+
				'bottom:0;'+
				'right:0;'+
				'height:100%;'+
				'width:100%;'+
				'position:absolute;'+
				'pointer-events:none;'+
				'z-index:-1;';
	
			// Prevent the iframe to gain focus on tab.
			// https://github.com/chartjs/Chart.js/issues/3090
			iframe.tabIndex = -1;
	
			// If the iframe is re-attached to the DOM, the resize listener is removed because the
			// content is reloaded, so make sure to install the handler after the iframe is loaded.
			// https://github.com/chartjs/Chart.js/issues/3521
			helpers.addEvent(iframe, 'load', function() {
				helpers.addEvent(iframe.contentWindow || iframe, 'resize', handler);
	
				// The iframe size might have changed while loading, which can also
				// happen if the size has been changed while detached from the DOM.
				handler();
			});
	
			return iframe;
		}
	
		function addResizeListener(node, listener, chart) {
			var stub = node._chartjs = {
				ticking: false
			};
	
			// Throttle the callback notification until the next animation frame.
			var notify = function() {
				if (!stub.ticking) {
					stub.ticking = true;
					helpers.requestAnimFrame.call(window, function() {
						if (stub.resizer) {
							stub.ticking = false;
							return listener(createEvent('resize', chart));
						}
					});
				}
			};
	
			// Let's keep track of this added iframe and thus avoid DOM query when removing it.
			stub.resizer = createResizer(notify);
	
			node.insertBefore(stub.resizer, node.firstChild);
		}
	
		function removeResizeListener(node) {
			if (!node || !node._chartjs) {
				return;
			}
	
			var resizer = node._chartjs.resizer;
			if (resizer) {
				resizer.parentNode.removeChild(resizer);
				node._chartjs.resizer = null;
			}
	
			delete node._chartjs;
		}
	
		return {
			acquireContext: function(item, config) {
				if (typeof item === 'string') {
					item = document.getElementById(item);
				} else if (item.length) {
					// Support for array based queries (such as jQuery)
					item = item[0];
				}
	
				if (item && item.canvas) {
					// Support for any object associated to a canvas (including a context2d)
					item = item.canvas;
				}
	
				if (item instanceof HTMLCanvasElement) {
					// To prevent canvas fingerprinting, some add-ons undefine the getContext
					// method, for example: https://github.com/kkapsner/CanvasBlocker
					// https://github.com/chartjs/Chart.js/issues/2807
					var context = item.getContext && item.getContext('2d');
					if (context instanceof CanvasRenderingContext2D) {
						initCanvas(item, config);
						return context;
					}
				}
	
				return null;
			},
	
			releaseContext: function(context) {
				var canvas = context.canvas;
				if (!canvas._chartjs) {
					return;
				}
	
				var initial = canvas._chartjs.initial;
				['height', 'width'].forEach(function(prop) {
					var value = initial[prop];
					if (value === undefined || value === null) {
						canvas.removeAttribute(prop);
					} else {
						canvas.setAttribute(prop, value);
					}
				});
	
				helpers.each(initial.style || {}, function(value, key) {
					canvas.style[key] = value;
				});
	
				// The canvas render size might have been changed (and thus the state stack discarded),
				// we can't use save() and restore() to restore the initial state. So make sure that at
				// least the canvas context is reset to the default state by setting the canvas width.
				// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
				canvas.width = canvas.width;
	
				delete canvas._chartjs;
			},
	
			addEventListener: function(chart, type, listener) {
				var canvas = chart.chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					addResizeListener(canvas.parentNode, listener, chart.chart);
					return;
				}
	
				var stub = listener._chartjs || (listener._chartjs = {});
				var proxies = stub.proxies || (stub.proxies = {});
				var proxy = proxies[chart.id + '_' + type] = function(event) {
					listener(fromNativeEvent(event, chart.chart));
				};
	
				helpers.addEvent(canvas, type, proxy);
			},
	
			removeEventListener: function(chart, type, listener) {
				var canvas = chart.chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					removeResizeListener(canvas.parentNode, listener);
					return;
				}
	
				var stub = listener._chartjs || {};
				var proxies = stub.proxies || {};
				var proxy = proxies[chart.id + '_' + type];
				if (!proxy) {
					return;
				}
	
				helpers.removeEvent(canvas, type, proxy);
			}
		};
	};


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// By default, select the browser (DOM) platform.
	// @TODO Make possible to select another platform at build time.
	var implementation = __webpack_require__(949);
	
	module.exports = function(Chart) {
		/**
		 * @namespace Chart.platform
		 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
		 * @since 2.4.0
		 */
		Chart.platform = {
			/**
			 * Called at chart construction time, returns a context2d instance implementing
			 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
			 * @param {*} item - The native item from which to acquire context (platform specific)
			 * @param {Object} options - The chart options
			 * @returns {CanvasRenderingContext2D} context2d instance
			 */
			acquireContext: function() {},
	
			/**
			 * Called at chart destruction time, releases any resources associated to the context
			 * previously returned by the acquireContext() method.
			 * @param {CanvasRenderingContext2D} context - The context2d instance
			 * @returns {Boolean} true if the method succeeded, else false
			 */
			releaseContext: function() {},
	
			/**
			 * Registers the specified listener on the given chart.
			 * @param {Chart} chart - Chart from which to listen for event
			 * @param {String} type - The ({@link IEvent}) type to listen for
			 * @param {Function} listener - Receives a notification (an object that implements
			 * the {@link IEvent} interface) when an event of the specified type occurs.
			 */
			addEventListener: function() {},
	
			/**
			 * Removes the specified listener previously registered with addEventListener.
			 * @param {Chart} chart -Chart from which to remove the listener
			 * @param {String} type - The ({@link IEvent}) type to remove
			 * @param {Function} listener - The listener function to remove from the event target.
			 */
			removeEventListener: function() {}
		};
	
		/**
		 * @interface IPlatform
		 * Allows abstracting platform dependencies away from the chart
		 * @borrows Chart.platform.acquireContext as acquireContext
		 * @borrows Chart.platform.releaseContext as releaseContext
		 * @borrows Chart.platform.addEventListener as addEventListener
		 * @borrows Chart.platform.removeEventListener as removeEventListener
		 */
	
		/**
		 * @interface IEvent
		 * @prop {String} type - The event type name, possible values are:
		 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
		 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
		 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
		 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
		 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
		 */
	
		Chart.helpers.extend(Chart.platform, implementation(Chart));
	};


/***/ },
/* 951 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
			// Implement this so that
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (value !== undefined && isNaN(index)) {
					var labels = me.getLabels();
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ },
/* 952 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Chart.Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ },
/* 953 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Chart.Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ },
/* 954 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Chart.Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Chart.Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ },
/* 955 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Chart.Ticks.formatters.linear
			},
	
			pointLabels: {
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			return !scale.options.lineArc ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.getValueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.getValueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.getValueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				l: scale.width,
				r: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i;
			var textSize;
			var pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y+= spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var getValueOrDefault = helpers.getValueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;
	
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.lineArc) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.lineArc) {
					fit(this);
				} else {
					fitWithPointLabels(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea,
					maxTop = topMovement + me.drawingArea,
					maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (!opts.lineArc) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(7);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (typeof this.labelMoments[datasetIndex] !== 'undefined') {
					return this.labelMoments[datasetIndex][index];
				}
	
				return null;
			},
			getLabelDiff: function(datasetIndex, index) {
				var me = this;
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (me.labelDiffs === undefined) {
					me.buildLabelDiffs();
				}
	
				if (typeof me.labelDiffs[datasetIndex] !== 'undefined') {
					return me.labelDiffs[datasetIndex][index];
				}
	
				return null;
			},
			getMomentStartOf: function(tick) {
				var me = this;
				if (me.options.time.unit === 'week' && me.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(me.options.time.isoWeekday);
				}
				return tick.clone().startOf(me.tickUnit);
			},
			determineDataLimits: function() {
				var me = this;
				me.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, me);
	
					me.firstTick = moment.min.call(me, scaleLabelMoments);
					me.lastTick = moment.max.call(me, scaleLabelMoments);
				} else {
					me.firstTick = null;
					me.lastTick = null;
				}
	
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = me.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									me.firstTick = me.firstTick !== null ? moment.min(me.firstTick, labelMoment) : labelMoment;
									me.lastTick = me.lastTick !== null ? moment.max(me.lastTick, labelMoment) : labelMoment;
								}
							}
						}, me);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					me.labelMoments.push(momentsForDataset);
				}, me);
	
				// Set these after we've done all the data
				if (me.options.time.min) {
					me.firstTick = me.parseTime(me.options.time.min);
				}
	
				if (me.options.time.max) {
					me.lastTick = me.parseTime(me.options.time.max);
				}
	
				// We will modify these, so clone for later
				me.firstTick = (me.firstTick || moment()).clone();
				me.lastTick = (me.lastTick || moment()).clone();
			},
			buildLabelDiffs: function() {
				var me = this;
				me.labelDiffs = [];
				var scaleLabelDiffs = [];
				// Parse common labels once
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelDiffs.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
						}
					}, me);
				}
	
				helpers.each(me.chart.data.datasets, function(dataset) {
					var diffsForDataset = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								diffsForDataset.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
							}
						}, me);
					} else {
						// We have no labels. Use common ones
						diffsForDataset = scaleLabelDiffs;
					}
	
					me.labelDiffs.push(diffsForDataset);
				}, me);
			},
			buildTicks: function() {
				var me = this;
	
				me.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(me.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(me.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				me.ctx.font = tickLabelFont;
	
				me.ticks = [];
				me.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				me.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (me.options.time.unit) {
					me.tickUnit = me.options.time.unit || 'day';
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = me.isHorizontal() ? me.width : me.height;
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = me.tickFormatFunction(me.firstTick, 0, []);
					var tickLabelWidth = me.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(me.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(me.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					me.tickUnit = me.options.time.minUnit;
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						me.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(me.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the predefined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(me.scaleSizeInUnits / labelCapacity)) {
									me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(me.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, Math.ceil(me.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							me.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = me.firstTick.diff(me.getMomentStartOf(me.firstTick), me.tickUnit, true);
							var trailingUnitBuffer = me.getMomentStartOf(me.lastTick.clone().add(1, me.tickUnit)).diff(me.lastTick, me.tickUnit, true);
							me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							me.displayFormat = me.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!me.options.time.min) {
					me.firstTick = me.getMomentStartOf(me.firstTick);
					roundedStart = me.firstTick;
				} else {
					roundedStart = me.getMomentStartOf(me.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!me.options.time.max) {
					var roundedEnd = me.getMomentStartOf(me.lastTick);
					var delta = roundedEnd.diff(me.lastTick, me.tickUnit, true);
					if (delta < 0) {
						// Do not use end of because we need me to be in the next time unit
						me.lastTick = me.getMomentStartOf(me.lastTick.add(1, me.tickUnit));
					} else if (delta >= 0) {
						me.lastTick = roundedEnd;
					}
	
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
				}
	
				// Tick displayFormat override
				if (me.options.time.displayFormat) {
					me.displayFormat = me.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				me.ticks.push(me.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = me.unitScale; i <= me.scaleSizeInUnits; i += me.unitScale) {
					var newTick = roundedStart.clone().add(i, me.tickUnit);
	
					// Are we greater than the max time
					if (me.options.time.max && newTick.diff(me.lastTick, me.tickUnit, true) >= 0) {
						break;
					}
	
					me.ticks.push(newTick);
				}
	
				// Always show the right tick
				var diff = me.ticks[me.ticks.length - 1].diff(me.lastTick, me.tickUnit);
				if (diff !== 0 || me.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (me.options.time.max) {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.ticks[0], me.tickUnit, true);
					} else {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				me.ctx.restore();
	
				// Invalidate label diffs cache
				me.labelDiffs = undefined;
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
				var value = me.chart.data.datasets[datasetIndex].data[index];
	
				if (value !== null && typeof value === 'object') {
					label = me.getRightValue(value);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = me.parseTime(label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.tickMoments = me.ticks;
				me.ticks = me.ticks.map(me.tickFormatFunction, me);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me.getLabelDiff(datasetIndex, index);
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = me.parseTime(me.getRightValue(value));
					}
					if (value && value.isValid && value.isValid()) {
						offset = value.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				if (offset !== null) {
					var decimal = offset !== 0 ? offset / me.scaleSizeInUnits : offset;
	
					if (me.isHorizontal()) {
						var valueOffset = (me.width * decimal);
						return me.left + Math.round(valueOffset);
					}
	
					var heightOffset = (me.height * decimal);
					return me.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickMoments[index], null, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width : me.height;
				var offset = (pixel - (me.isHorizontal() ? me.left : me.top)) / innerDimension;
				offset *= me.scaleSizeInUnits;
				return me.firstTick.clone().add(moment.duration(offset, me.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				var me = this;
				if (typeof me.options.time.parser === 'string') {
					return moment(label, me.options.time.parser);
				}
				if (typeof me.options.time.parser === 'function') {
					return me.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof me.options.time.format !== 'string' && me.options.time.format.call) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale');
					return me.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, me.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(961);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/i,
	       hex =  /^#([a-fA-F0-9]{6})$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(960);
	var string = __webpack_require__(957);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ },
/* 959 */
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(959);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },
/* 961 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(286)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(967)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(286)
	
	exports.createHmac = __webpack_require__(962)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(966)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(913)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(963);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1062)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(1257)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(33).Buffer))

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(166);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(969));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 969 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 970 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(166);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(287));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(166);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(287));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(974);
	var entities = __webpack_require__(995);
	
	/*
	  Boolean Attributes
	*/
	var booleanAttributes = {
	  __proto__: null,
	  allowfullscreen: true,
	  async: true,
	  autofocus: true,
	  autoplay: true,
	  checked: true,
	  controls: true,
	  default: true,
	  defer: true,
	  disabled: true,
	  hidden: true,
	  ismap: true,
	  loop: true,
	  multiple: true,
	  muted: true,
	  open: true,
	  readonly: true,
	  required: true,
	  reversed: true,
	  scoped: true,
	  seamless: true,
	  selected: true,
	  typemustmatch: true
	};
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '',
	      value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (!value && booleanAttributes[key]) {
	      output += key;
	    } else {
	      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true,
	};
	
	
	var render = module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for(var i = 0; i < dom.length; i++){
	    var elem = dom[i];
	
	    if (elem.type === 'root')
	      output += render(elem.children, opts);
	    else if (ElementType.isTag(elem))
	      output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment)
	      output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA)
	      output += renderCdata(elem);
	    else
	      output += renderText(elem, opts);
	  }
	
	  return output;
	};
	
	function renderTag(elem, opts) {
	  // Handle SVG
	  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};
	
	  var tag = '<' + elem.name,
	      attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (
	    opts.xmlMode
	    && (!elem.children || elem.children.length === 0)
	  ) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 974 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(289);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 976 */
/***/ function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(121);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ },
/* 978 */
/***/ function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(121).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, rootElems){
		var result = [];
		var stack = rootElems.slice();
		while(stack.length){
			var elem = stack.shift();
			if(!isTag(elem)) continue;
			if (elem.children && elem.children.length > 0) {
				stack.unshift.apply(stack, elem.children);
			}
			if(test(elem)) result.push(elem);
		}
		return result;
	}


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(121),
	    getOuterHTML = __webpack_require__(973),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
		if(elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ },
/* 981 */
/***/ function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(983);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(107);


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(291);
	var Emitter = __webpack_require__(196);
	var debug = __webpack_require__(147)('engine.io-client:socket');
	var index = __webpack_require__(308);
	var parser = __webpack_require__(107);
	var parseuri = __webpack_require__(437);
	var parseqs = __webpack_require__(152);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (typeof location !== 'undefined' && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (typeof location !== 'undefined' ? location.hostname : 'localhost');
	  this.port = opts.port || (typeof location !== 'undefined' && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.withCredentials = false !== opts.withCredentials;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.transportOptions = opts.transportOptions || {};
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // detect ReactNative environment
	  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');
	
	  // other options for Node.js or ReactNative client
	  if (typeof self === 'undefined' || this.isReactNative) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(194);
	Socket.transports = __webpack_require__(291);
	Socket.parser = __webpack_require__(107);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // per-transport options
	  var options = this.transportOptions[name] || {};
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    query: query,
	    socket: this,
	    agent: options.agent || this.agent,
	    hostname: options.hostname || this.hostname,
	    port: options.port || this.port,
	    secure: options.secure || this.secure,
	    path: options.path || this.path,
	    forceJSONP: options.forceJSONP || this.forceJSONP,
	    jsonp: options.jsonp || this.jsonp,
	    forceBase64: options.forceBase64 || this.forceBase64,
	    enablesXDR: options.enablesXDR || this.enablesXDR,
	    withCredentials: options.withCredentials || this.withCredentials,
	    timestampRequests: options.timestampRequests || this.timestampRequests,
	    timestampParam: options.timestampParam || this.timestampParam,
	    policyPort: options.policyPort || this.policyPort,
	    pfx: options.pfx || this.pfx,
	    key: options.key || this.key,
	    passphrase: options.passphrase || this.passphrase,
	    cert: options.cert || this.cert,
	    ca: options.ca || this.ca,
	    ciphers: options.ciphers || this.ciphers,
	    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
	    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
	    extraHeaders: options.extraHeaders || this.extraHeaders,
	    forceNode: options.forceNode || this.forceNode,
	    localAddress: options.localAddress || this.localAddress,
	    requestTimeout: options.requestTimeout || this.requestTimeout,
	    protocols: options.protocols || void (0),
	    isReactNative: this.isReactNative
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(JSON.parse(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(292);
	var inherit = __webpack_require__(146);
	var globalThis = __webpack_require__(193);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    callbacks = globalThis.___eio = (globalThis.___eio || []);
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (typeof addEventListener === 'function') {
	    addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	/* global attachEvent */
	
	/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(195);
	var Polling = __webpack_require__(292);
	var Emitter = __webpack_require__(196);
	var inherit = __webpack_require__(146);
	var debug = __webpack_require__(147)('engine.io-client:polling-xhr');
	var globalThis = __webpack_require__(193);
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	  this.extraHeaders = opts.extraHeaders;
	
	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	  opts.withCredentials = this.withCredentials;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = this.withCredentials;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 2) {
	          try {
	            var contentType = xhr.getResponseHeader('Content-Type');
	            if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	              xhr.responseType = 'arraybuffer';
	            }
	          } catch (e) {}
	        }
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (typeof document !== 'undefined') {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (typeof document !== 'undefined') {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type');
	    } catch (e) {}
	    if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      data = this.xhr.responseText;
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (typeof document !== 'undefined') {
	  if (typeof attachEvent === 'function') {
	    attachEvent('onunload', unloadHandler);
	  } else if (typeof addEventListener === 'function') {
	    var terminationEvent = 'onpagehide' in globalThis ? 'pagehide' : 'unload';
	    addEventListener(terminationEvent, unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(194);
	var parser = __webpack_require__(107);
	var parseqs = __webpack_require__(152);
	var inherit = __webpack_require__(146);
	var yeast = __webpack_require__(498);
	var debug = __webpack_require__(147)('engine.io-client:websocket');
	
	var BrowserWebSocket, NodeWebSocket;
	
	if (typeof WebSocket !== 'undefined') {
	  BrowserWebSocket = WebSocket;
	} else if (typeof self !== 'undefined') {
	  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
	}
	
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(1258);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocketImpl = BrowserWebSocket || NodeWebSocket;
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  this.protocols = opts.protocols;
	  if (!this.usingBrowserWebSocket) {
	    WebSocketImpl = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = this.protocols;
	
	  var opts = {};
	
	  if (!this.isReactNative) {
	    opts.agent = this.agent;
	    opts.perMessageDeflate = this.perMessageDeflate;
	
	    // SSL options for Node.js client
	    opts.pfx = this.pfx;
	    opts.key = this.key;
	    opts.passphrase = this.passphrase;
	    opts.cert = this.cert;
	    opts.ca = this.ca;
	    opts.ciphers = this.ciphers;
	    opts.rejectUnauthorized = this.rejectUnauthorized;
	  }
	
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws =
	      this.usingBrowserWebSocket && !this.isReactNative
	        ? protocols
	          ? new WebSocketImpl(uri, protocols)
	          : new WebSocketImpl(uri)
	        : new WebSocketImpl(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 987 */
[1263, 988],
/* 988 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 989 */
/***/ function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ },
/* 990 */
/***/ function(module, exports) {

	/*! https://mths.be/utf8js v2.1.2 by @mathias */
	
	var stringFromCharCode = String.fromCharCode;
	
	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}
	
	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}
	
	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/
	
	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}
	
	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}
	
	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;
	
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}
	
	/*--------------------------------------------------------------------------*/
	
	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}
	
		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;
	
		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}
	
		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}
	
	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;
	
		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}
	
		if (byteIndex == byteCount) {
			return false;
		}
	
		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;
	
		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}
	
		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}
	
		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}
	
		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}
	
		throw Error('Invalid UTF-8 detected');
	}
	
	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;
	
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}
	
	module.exports = {
		version: '2.1.2',
		encode: utf8encode,
		decode: utf8decode
	};


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(993);
	var each = __webpack_require__(293).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(991);
	var Util = __webpack_require__(293);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 993 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(992);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	var encode = __webpack_require__(997),
	    decode = __webpack_require__(996);
	
	exports.decode = function(data, level) {
	    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
	};
	
	exports.decodeStrict = function(data, level) {
	    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
	};
	
	exports.encode = function(data, level) {
	    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
	};
	
	exports.encodeXML = encode.XML;
	
	exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;
	
	exports.decodeXML = exports.decodeXMLStrict = decode.XML;
	
	exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;
	
	exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;
	
	exports.escape = encode.escape;


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	var entityMap = __webpack_require__(200),
	    legacyMap = __webpack_require__(309),
	    xmlMap = __webpack_require__(201),
	    decodeCodePoint = __webpack_require__(294);
	
	var decodeXMLStrict = getStrictDecoder(xmlMap),
	    decodeHTMLStrict = getStrictDecoder(entityMap);
	
	function getStrictDecoder(map) {
	    var keys = Object.keys(map).join("|"),
	        replace = getReplacer(map);
	
	    keys += "|#[xX][\\da-fA-F]+|#\\d+";
	
	    var re = new RegExp("&(?:" + keys + ");", "g");
	
	    return function(str) {
	        return String(str).replace(re, replace);
	    };
	}
	
	var decodeHTML = (function() {
	    var legacy = Object.keys(legacyMap).sort(sorter);
	
	    var keys = Object.keys(entityMap).sort(sorter);
	
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        } else {
	            keys[i] += ";";
	        }
	    }
	
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	        replace = getReplacer(entityMap);
	
	    function replacer(str) {
	        if (str.substr(-1) !== ";") str += ";";
	        return replace(str);
	    }
	
	    //TODO consider creating a merged map
	    return function(str) {
	        return String(str).replace(re, replacer);
	    };
	})();
	
	function sorter(a, b) {
	    return a < b ? 1 : -1;
	}
	
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
	                return decodeCodePoint(parseInt(str.substr(3), 16));
	            }
	            return decodeCodePoint(parseInt(str.substr(2), 10));
	        }
	        return map[str.slice(1, -1)];
	    };
	}
	
	module.exports = {
	    XML: decodeXMLStrict,
	    HTML: decodeHTML,
	    HTMLStrict: decodeHTMLStrict
	};


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	var inverseXML = getInverseObj(__webpack_require__(201)),
	    xmlReplacer = getInverseReplacer(inverseXML);
	
	exports.XML = getInverse(inverseXML, xmlReplacer);
	
	var inverseHTML = getInverseObj(__webpack_require__(200)),
	    htmlReplacer = getInverseReplacer(inverseHTML);
	
	exports.HTML = getInverse(inverseHTML, htmlReplacer);
	
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function(inverse, name) {
	            inverse[obj[name]] = "&" + name + ";";
	            return inverse;
	        }, {});
	}
	
	function getInverseReplacer(inverse) {
	    var single = [],
	        multiple = [];
	
	    Object.keys(inverse).forEach(function(k) {
	        if (k.length === 1) {
	            single.push("\\" + k);
	        } else {
	            multiple.push(k);
	        }
	    });
	
	    //TODO add ranges
	    multiple.unshift("[" + single.join("") + "]");
	
	    return new RegExp(multiple.join("|"), "g");
	}
	
	var re_nonASCII = /[^\0-\x7F]/g,
	    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	
	function singleCharReplacer(c) {
	    return (
	        "&#x" +
	        c
	            .charCodeAt(0)
	            .toString(16)
	            .toUpperCase() +
	        ";"
	    );
	}
	
	function astralReplacer(c) {
	    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	    var high = c.charCodeAt(0);
	    var low = c.charCodeAt(1);
	    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
	    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	
	function getInverse(inverse, re) {
	    function func(name) {
	        return inverse[name];
	    }
	
	    return function(data) {
	        return data
	            .replace(re, func)
	            .replace(re_astralSymbols, astralReplacer)
	            .replace(re_nonASCII, singleCharReplacer);
	    };
	}
	
	var re_xmlChars = getInverseReplacer(inverseXML);
	
	function escapeXML(data) {
	    return data
	        .replace(re_xmlChars, singleCharReplacer)
	        .replace(re_astralSymbols, astralReplacer)
	        .replace(re_nonASCII, singleCharReplacer);
	}
	
	exports.escape = escapeXML;


/***/ },
/* 998 */
79,
/* 999 */
79,
/* 1000 */
79,
/* 1001 */
79,
/* 1002 */
79,
/* 1003 */
79,
/* 1004 */
79,
/* 1005 */
79,
/* 1006 */
79,
/* 1007 */
79,
/* 1008 */
79,
/* 1009 */
79,
/* 1010 */
79,
/* 1011 */
79,
/* 1012 */
79,
/* 1013 */
79,
/* 1014 */
79,
/* 1015 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1015);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1025);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createArrayFromMixed = __webpack_require__(1018);
	var getMarkupWrap = __webpack_require__(1020);
	var invariant = __webpack_require__(20);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1021 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1022 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1022);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1024 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1024);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1026 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cbt-icon.f9b64851.svg";

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dashboard-icon.328e58c7.svg";

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/essay-question-icon.64f00ba4.svg";

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notes-icon.bd84f9d6.svg";

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/premium.951f1b4f.svg";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/question-bank-icon.e3743758.svg";

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/quiz-icon.aece401f.svg";

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/subscription.ddbd8aaa.svg";

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tutor-icon.5393da42.svg";

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/video-icon.a08cc672.svg";

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/webinars.d7242e00.svg";

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/error_404.b9e40ade.svg";

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notes_icon2.391597a1.svg";

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notes_icon3.e250c16a.svg";

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/free_question_icon.91c25836.svg";

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/premium_question_icon.4bf240ff.svg";

/***/ },
/* 1043 */
490,
/* 1044 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(108).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(288);
	var DomUtils = __webpack_require__(290);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(47)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(108).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(307);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(47)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(108).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ },
/* 1049 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1050 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 1051 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2019a",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQob.c ME01.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 gj9y0|32e5",
			"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
			"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
			"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|LMT CST CDT CWT CPT EST|66.s 60 50 50 50 50|01212345|-32B5R.w UFdR.w 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|LMT AST ADT AWT APT|3M.s 40 30 30 30|0121341|-3tokb.w 1nsqb.w 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 2en0|90e5",
			"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
			"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|LMT MST PST|7K.4 70 80|0121|-3togd.U 1jInd.U 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT|9h.E 90 80 80 80 70 80 70|01212134151676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|012323232323232323232323232323232323232323232323232323232323232323232323232343232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121212121565652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
			"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|LMT EST EDT EWT EPT|5R.4 50 40 40 40|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B66.U UFd6.U 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
			"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.K 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.6 fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
			"America/Rainy_River|LMT CST CDT CWT CPT|6i.g 60 50 50 50|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B5F.I UFdF.I 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|LMT SMT -05 -04 -03|4G.K 4G.K 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.e MJc0 fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
			"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|LMT CST EST EWT EPT EDT|5V 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-32B63 Avc3 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT|90.c 90 80 80 80 70 80 70|01212134151676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|-00 AEST AEDT +11|0 -a0 -b0 -b0|01210121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-2OPc0 Fb40 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|LMT CET CEST|-H -10 -20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32BcH Q4oH Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|0121212121212121212121212121|-2M0U5.H 1zWo5.H Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00",
			"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azch.Q 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azck.n 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taOu Hbu xUu 94nu 1qsu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1nX0 11B0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|LMT IMT EET EEST +04 +03|-1T.Q -1U.U -20 -30 -40 -30|0123232323232323232323232323232323232323232323232323232345454545453232323232323232323232323232323232323232323232323232323232323235|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|0123232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6K.K -6T.p -70 -7k -7u -90 -80|01234546|-2M0SK.K aILP.l 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Singapore|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so1u|56e5",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
			"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlA5.Q xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry0d.8 xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|LMT AEST AEDT|-9z.s -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109z.s Pk1z.s 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PknP.s xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U RxXU.U xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlzE.Q xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PknI.o xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00",
			"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00",
			"Europe/Dublin|LMT DMT IST GMT BST IST|p p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHbz 1ra20.l Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Etc/GMT-0|GMT|0|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Etc/GMT-10|+10|-a0|0|",
			"Etc/GMT-11|+11|-b0|0|",
			"Etc/GMT-12|+12|-c0|0|",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Etc/GMT-7|+07|-70|0|",
			"Etc/GMT-8|+08|-80|0|",
			"Etc/GMT-9|+09|-90|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+2|-02|20|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|LMT AMT NST +0120 +0020 CEST CET|-j.w -j.w -1j.w -1k -k -20 -10|0121212121212121212121212121212121212121212123434345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-5sHcj.w 3i200 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1M0 SNMh.u 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cWpg.k 12hbg.k 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|LMT CMT CET CEST|-O.k -O.k -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLAO.k 9Io0 SryO.k Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|LMT CET CEST CET CEST MSK MSD EEST EET +03|-1m -10 -20 -20 -30 -30 -40 -30 -20 -30|01212121212121343565656565656565657878787878787878787878787878787878787878787898|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|LMT PMT WET WEST WEMT CET CEST|-t.w -9.l 0 -10 -20 -10 -20|012323232323232323232323232323232323232323232323232343434343456565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3bQot.w ME0k.b cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQo8.l ME00 cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4bsoN.U 160LN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|LMT SET CET CEST|-1c.c -10.e -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3FyNc.c P80b.W DPb0.e TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Uzhgorod|LMT CET CEST MSK MSD EET EEST|-1t.c -10 -20 -30 -40 -20 -30|0121212134343434343434343431565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3cWpt.c 20vCt.c 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
			"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|LMT +0220 EET MSK CEST CET MSD EEST|-2k.E -2k -20 -30 -20 -10 -40 -30|012345453636363636363636363637272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8Ok.E 1LUM0.E eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Christmas|LMT +07|-72.Q -70|01|-32oT2.Q|21e2",
			"Indian/Cocos|LMT +0630|-6r.E -6u|01|-2OqSr.E|596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|LMT LMT +10 +09|dQ.Q -a7.8 -a0 -90|0123232|-54ma7.8 2glc0 xso7.8 axB0 RVX0 axd0|49e3",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|LMT -12 -11 +13|bo.k c0 b0 -d0|0123|-2M0Az.E 3bIMz.E B7X0|1",
			"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0|88e4",
			"Pacific/Funafuti|LMT +12|-bU.Q -c0|01|-2M0XU.Q|45e2",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
			"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Majuro|LMT +11 +09 +10 +12|-bo.M -b0 -90 -a0 -c0|01213214|-2M0Xo.M xsoo.M axC0 HBy0 akp0 6RB0 12um0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|LMT -1120 -1130 -11|bj.E bk bu b0|0123|-2M0AE.k 21IM0.k 17y0a|12e2",
			"Pacific/Norfolk|LMT +1112 +1130 +1230 +11|-bb.Q -bc -bu -cu -b0|012324|-2M0Xb.Q 21ILX.Q W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
			"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
			"Pacific/Pohnpei|LMT LMT +11 +09 +10|dr.8 -aw.Q -b0 -90 -a0|01232432|-54maw.Q 2glc0 xsnw.Q axC0 HBy0 akp0 axd0|34e3",
			"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
			"Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-2M0Bk.U 39zzO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
			"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.k -ck -d0 -e0|01232323232|-2M10j.k 1BnXX.k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"Pacific/Wake|LMT +12|-b6.s -c0|01|-2M0X6.s|16e3",
			"Pacific/Wallis|LMT +12|-cf.k -c0|01|-2M10f.k|94",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Singapore|Singapore",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pohnpei|Pacific/Ponape"
		]
	};

/***/ },
/* 1052 */
/***/ function(module, exports) {

	module.exports = {
		"1": "1",
		"2": "2",
		"CHAPTER": "Chapter",
		"TOTAL_VIDEOS": "Total Videos",
		"VIDEO_LESSONS": "Video Lessons",
		"KEEP_FREE_VERSION": "Keep Free Version!",
		"GO_PREMIUM": "Go Premium!",
		"Q": "Q.",
		"N": "N.",
		"CHANGE_READING": "Change Reading",
		"CHANGE_QUESTIONS": "Change Question",
		"CHANGE_NOTES": "Change Notes",
		"OPEN_CALCULATOR": "Open Calculator",
		"CHANGE_CHAPTER": "Change Chapter",
		"SUBSCRIBE_FOR_3000_PRACTICE_QUESTIONS": "Subscribe for 3,000 practice questions",
		"SUBSCRIBE_FOR_4000_PRACTICE_QUESTIONS": "Subscribe for 2,000 Practice Questions",
		"SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS": "Subscribe for 1,500 practice questions",
		"SUBSCRIBE": "Subscribe",
		"GO_TO_VIDEOS": "Go To Videos",
		"ORDER_ID": "Order ID",
		"NAME": "Name",
		"EMAIL": "Email",
		"PAYMENT_METHOD": "Payment Method",
		"THANK_YOU_FOR_YOUR_ORDER": "Thank You for your Order!",
		"PRICE": "Price",
		"DISCOUNT": "Discount",
		"EXPIRED": "Expired",
		"LIFETIME_VALID": "Lifetime valid",
		"ACTIVE": "Active",
		"SUBSCRIPTION_DETAIL": "Package Details",
		"MONTHLY_SUBSCRIPTION_DETAIL": "Subscription Details",
		"GO_TO_PROFILE": "Go to profile",
		"ID": "Id",
		"EXAM_NAME": "Exam Name",
		"PACKAGE": "Package",
		"EXPIRY_DATE": "Expiry Date",
		"STATUS": "Status",
		"READ_MORE": "Read More",
		"PICK_YOUR_EXAM": "Pick Your Exam Plan",
		"GO_BACK_TO_EXAMS": "Go Back To Exams",
		"OK": "OK",
		"VIEW_LIST": "View List",
		"Percentile_20": "20th Percentile",
		"Percentile_80": "80th Percentile",
		"BEGIN_CHAPTER": "Begin Chapter",
		"CHANGE_TOPIC": "Change Topic",
		"CHANGE_QUESTION": "Change Question",
		"READING": "Reading",
		"ACTION": "Action",
		"QUESTIONS": "Questions",
		"DATE": "Date",
		"RECOVER": "Recover",
		"VIEW": "View",
		"CREATE_QUIZ": "Create Quiz",
		"CONTENT": "Content",
		"ALL_CHAPTERS": "All Chapters",
		"ABANDONED_QUIZZES": "Abandoned Quizzes",
		"LENGTH": "Length",
		"COMPLETED_QUIZZES": "Completed Quizzes",
		"TOTAL_READINGS": "Total Readings",
		"FREE_QUESTIONS": "Free Questions",
		"PREMIUM_QUESTIONS": "Premium Questions",
		"CFA_LEVEL_I_QUESTION_BANK": "Question Bank",
		"CHANGE_PASSWORD": "Change Password",
		"MY_SAVED_QUESTIONS": "My Saved Questions",
		"MY_SAVED_NOTES": "My Saved Notes",
		"MY_SAVED_VIDEOS": "My Saved Videos",
		"MY_SAVED": "My Saved Items/Flashcards",
		"MY_SAVED_ITEM_WITH_FLASH_CARD": "My Saved Items/Flashcards",
		"MY_FLASHCARDS": "My Flashcards",
		"MY_REPORTS": "My Reports",
		"ORDER_HISTORY": "Order History",
		"PROFILE_INFO": "Profile Info",
		"EXAM_LOCATION": "Exam Location",
		"AGE": "Age",
		"OCCUPATION": "Occupation",
		"EDUCATION": "Education",
		"UPDATE_PROFILE": "Update Profile",
		"ORDERS": "Orders",
		"ORDERS_History": "Order History",
		"PAYMENT_TYPE": "Payment type",
		"PAYMENT_STATUS": "Payment Status",
		"ORDER_DATE": "Order Date",
		"YOUR_ORDER": "Your Order",
		"Order_Details": "Order Details",
		"GO_TO_HISTORY": "Go to history",
		"TOTAL": "Total",
		"TOTAL_NOTES": "Total Notes",
		"NOTES": "Notes",
		"READY_FOR_PRINT": "Ready For Print",
		"CFA_LEVEL_I_QUIZZES": "Quizzes",
		"CFA_LEVEL_I_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"NO_SAVED_QUESTIONS_FOR_LEVEL_I": "No Saved Questions For Level I",
		"QUESTION_ID": "Question ID",
		"TOPIC": "Topic",
		"NO_SAVED_QUESTIONS_FOR_LEVEL_II": "No Saved Questions For Level II",
		"NO_SAVED_NOTES_FOR_LEVEL_I": "No Saved Notes For Level I",
		"NO_SAVED_NOTES_FOR_LEVEL_II": "No Saved Notes For Level II",
		"NO_SAVED_VIDEO_FOR_LEVEL_I": "No Saved Video For Level I",
		"NO_SAVED_VIDEO_FOR_LEVEL_II": "No Saved Video For Level II",
		"PICK_THE_QUESTION_YOU_WANT_TO_REVIEW": "Pick the question you want to review",
		"PICK_THE_NOTES_YOU_WANT_TO_REVIEW": "Pick the notes you want to review",
		"PICK_THE_VIDEO_YOU_WANT_TO_REVIEW": "Pick the video you want to review",
		"LEVEL_I": "LEVEL I",
		"LEVEL_II": "LEVEL II",
		"ALERT": "Alert",
		"READINGS": "Readings",
		"QUESTION_BANK": "Question Bank",
		"FRM_LEVEL_I_TOPICS": "FRM Part I - Topics",
		"FRM_LEVEL_II_TOPICS": "FRM Part II - Topics",
		"FRM_LEVEL_I_QUIZZES": "FRM Part I Quizzes",
		"FRM_LEVEL_II_QUIZZES": "FRM Part II Quizzes",
		"SOA_P_QUIZZES": "Quizzes",
		"SOA_FM_QUIZZES": "Quizzes",
		"SOA_IFM_QUIZZES": "Quizzes",
		"CODE_OF_ETHICS_AND_STANDARDS_OF_PROFESSIONAL_CONDUCT": "Code of Ethics and Standards of Professional Conduct",
		"READ_CHAPTER": "Read Chapter",
		"CANCEL": "Cancel",
		"COMMENT": "Comment",
		"UPDATE_COMMENT": "Update Comment",
		"YOU_CAN_USE_THE_COMMENT_SECTION_TO_ASK_A_QUESTION_OR_TO_SHOW_HOW_YOU_SOLVED_THE_PROBLEM_Dont_hesitate_to_share_your_thoughts_it_could_help_other_candidates": "You can use the comment section to ask a question or to show how you solved the problem. Don't hesitate to share your thoughts, it could help other candidates!",
		"FLASHCARD": "Flashcard",
		"CREATE": "Create",
		"FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study": "Flashcards only show up to you. This is a simple way to take notes while you study!",
		"FRM_NOTES": "Notes",
		"FRM_PART_I_CHAPTERS": "FRM Part I",
		"FRM_PART_II_CHAPTERS": "FRM Part II",
		"TOTAL_QUESTIONS": "Total Questions",
		"PRINT": "Print",
		"FRM_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"NO_SAVED_FLASHCARDS_FOR_LEVEL_I": " No Saved Flashcards For Level I",
		"NO_FLASHCARDS_FOR_LEVEL_II": "No Flashcards For Level II",
		"PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW": "Pick the flashcard you want to review",
		"DELETE": "Delete",
		"NO_FLASHCARDS": "No Flashcards",
		"NO_SAVED_QUESTIONS": "No Saved Questions",
		"NO_SAVED_NOTES": "No Saved Notes",
		"NO_SAVED_VIDEO": "No Saved Video",
		"NO_REPORTS": "No Reports",
		"MY_FRM_EXAM_I_DASHBOARD": "FRM Part I Dashboard",
		"FROM": "From",
		"TO": "To",
		"QUESTION_PROGRESS": "Questions Progress",
		"LABELS": "labels",
		"DATASETS": "datasets",
		"A": "A",
		"B": "B",
		"C": "C",
		"D": "D",
		"E": "E",
		"VALIDATE": "Validate",
		"FLAG_QUESTION": "Flag Question",
		"THE_CORRECT_ANSWER_IS": "The correct answer is ",
		"QUIZ_ID": "Quiz ID",
		"BACK_TO_SUMMARY": "Back to Summary",
		"CFA_LEVEL_I_PREMIUM_PACKAGE": "CFA Level I - Premium Package",
		"TOTAL_TIME:": "Total Time:",
		"CREATE_NEW_QUIZ": "Create New Quiz",
		"SUMMARY": "Summary",
		"MINUTE": "Minute",
		"BEFORE_STARTING": "Before Starting",
		"ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER": "1. Once a question is validated, it is impossible to change your answer.",
		"YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS": "2. You can always come back to this page to view the questions left unanswered or to navigate through the questions.",
		"IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS": "3. If you requested a timer, we strongly discourage you to stop it during the quiz as time management is a key factor for success.",
		"YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER": "4. You can always use the flashcard or the save question tools to take some notes for later.",
		"WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS": "5. We encourage you to leave your methodology in the comments section to help other users.",
		"YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION": "6. You can leave the quiz and come back later. It will always stay available in the abandoned quizzes section.",
		"EXAMPLE": "Example",
		"NO_ANSWER": "No Answer",
		"CORRECT_ANSWER": "Correct Answer",
		"WRONG_ANSWER": "Wrong Answer",
		"ACTIONS": "Actions",
		"MY_FRM_EXAM_II_DASHBOARD": "FRM Part II Dashboard",
		"NOTES_PROGRESS": "Notes Progress",
		"GO_BACK_TO_PROFILE": "Go Back to Profile",
		"OLD_PASSWORD": "Old Password",
		"NEW_PASSWORD": "New Password",
		"CONFIRM_NEW_PASSWORD": "Confirm New Password",
		"UPDATE_PASSWORD": "Update Password",
		"YOUR_CART": "Your Cart",
		"PLEASE_VERIFY_THE_EXAM_AND_LEVEL_FOR_YOUR_PURCHASE": "Please verify the exam and level before you proceed to pay.",
		"PRICE($)": "Price($)",
		"PAYABLE_TODAY": "Payable today",
		"$": "$",
		"HAVE_A_PROMOTIONAL_CODE": "Have a Promotional Code",
		"APPLY": "Apply",
		"ADD_SUBSCRIPTION": "Add Subscription",
		"PROCEED_TO_PAY": "Proceed to pay",
		"PICK_YOUR_PAYMENT": "Select your Payment Method",
		"PAYMENT_WITH_ALIPAY": "Payment With AliPay",
		"PAY_WITH_ALIPAY": "Pay With Alipay",
		"PAY_WITH_CARD": "Pay with Debit or Credit Card",
		"FLASH_CARD": "Flash Card",
		"ADDONS": "Addons",
		"BUY": "BUY",
		"NO_PACKAGE_FOUND": "No Package Found",
		"ALL_EXAMS": "All Exams",
		"YOURS_ANSWER": "Your Answers",
		"SCORE": "Summary",
		"GRAPH": "Detailed Score",
		"TOTAL_TIME": "Total Time",
		"CONTINUE": "Continue",
		"BEGIN": "Begin",
		"QUIZ_ID:": "Quiz ID:",
		"CASES": "Cases",
		"BEGIN_CASES": "Begin Cases",
		"CASE_STUDIES": "Case Studies",
		"CASE_NAME": "Case Name",
		"THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY": "This case is available for Premium members only",
		"CASE_STUDY": "Case Study",
		"CHANGE_CASES": "Change Cases",
		"CFA_LEVEL_I_MY_DASHBOARD": "Dashboard",
		"CFA_LEVEL_I_2022_DASHBOARD": "CFA Level I Dashboard",
		"CFA_LEVEL_I_2023_DASHBOARD": "CFA Level I Dashboard",
		"CFA_LEVEL_II_2023_DASHBOARD": "CFA Level II Dashboard",
		"CFA_LEVEL_II_2022_DASHBOARD": "CFA Level II Dashboard",
		"CFA_LEVEL_II_MY_DASHBOARD": "Dashboard",
		"PERFORMANCE": "Performance",
		"PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW:": "Pick the flashcard you want to review:",
		"DASHBOARD": "Dashboard",
		"CFA_LEVEL_II_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"CFA_LEVEL_II_QUESTION_BANK": "Question Bank",
		"CFA_LEVEL_II_QUIZZES": "Quizzes",
		"CFA_LEVEL_III_MY_DASHBOARD": "CFA Level III Dashboard",
		"CFA_LEVEL_III_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"CFA_LEVEL_III_QUESTION_BANK": "Question Bank",
		"CFA_LEVEL_III_QUIZZES": "Quizzes",
		"FREE": "Free",
		"UPGRADE_ACCOUNT": "Upgrade Account",
		"PREMIUM": "Premium",
		"NO_RECORDS_FOUND": "No Records Found",
		"BACK_TO_VIDEOS": "Back to Videos",
		"FLAG_VIDEO": "Flag Video",
		"GO_TO_NOTES": "Go to Notes",
		"GO_TO_PRACTICE_QUESTIONS": "Go To Practice Questions",
		"QUESTION": "Question",
		"QUIZZES": "Quizzes",
		"BEGIN_NOTES_CHAPTER": "Begin Notes Chapter",
		"CHAPTER_READINGS": " Chapter  Readings",
		"DASHBOARD_GO_TO_PROFILE": "Dashboard Go to Profile",
		"FREE_CASES": "Free cases",
		"PREMIUM_CASES": "Premium cases",
		"NO_SAVED_FLASHCARDS": "No Saved Flashcard",
		"YOUR_CART_IS_EMPTY": "Your cart is empty",
		"PAY_WITH": "Pay With",
		"GRAPHSCORE": "Score",
		"GRAPHSCOREBOX": "Score box",
		"SCOREBOX": "Score Box",
		"CFACHAPTERWISERESULT": "Your Performance by Topic Area",
		"OVERALLRESULT": "Your Performance on the Exam",
		"YOURSCORE": "Your Score",
		"FRMBookWiseScore": "Your Performance by Topic Area",
		"QUESTIONS_3000": "3,000+ Questions",
		"FULL_LENGTH_PRINTABLE_MOCK_EXAMS_8": "8 Full-Length Printable Mock Exams",
		"UNLIMITED_CUSTOMIZABLE_QUIZZES": "Unlimited Customizable Quizzes",
		"COMPREHENSIVE_STUDY_NOTES": "Comprehensive Study Notes",
		"A_FORMULA_SHEET": "A Formula Sheet",
		"PRIORITY_EMAIL_SUPPORT": "Priority Email Support",
		"AND_YOU_KEEP_YOUR_MEMBERSHIP_UNTIL_YOU_PASS": "...and you keep your membership until you pass!",
		"FORGOT_PASSWORD": "Forgot password?",
		"SIGN_IN": "Sign In",
		"SIGN_UP": "Sign Up",
		"SELECT_EXAM": "Select Exam",
		"CFA_1": "Level I of the CFA® Exam",
		"CFA_1_2021": "Level I of CFA® Exam",
		"CFA_1_2022": "Level I of CFA® Exam",
		"CFA_1_2023": "Level I of the CFA® Exam 2023",
		"CFA_1_2024": "Level I of the CFA® Exam 2024",
		"CFA2_2025_QUIZ_ERROR": "Not enough questions to populate the quiz",
		"CFA_2": "Level II of the CFA® Exam",
		"CFA_2_2023": "Level II of the CFA® Exam 2023",
		"CFA_2_2025": "Level II of the CFA® Exam 2025",
		"CFA_2_2023_2024": "Level II of the CFA® Exam 2023/2024",
		"CFA_3": "Level III of the CFA® Exam",
		"CFA_3_2024": "Level III of the CFA® Exam 2024",
		"FRM_PART_1": "FRM Part I",
		"FRM_PART_2": "FRM Part II",
		"RESET_PASSWORD": "Reset Password",
		"RESEND_MAIL": "Resend Mail",
		"PASSWORD_RESET_SUCCESSFULLY": "Password has been reset successfully",
		"LOGIN": "Login",
		"ENTER_YOUR_EMAIL_ADDRESS": "Enter your email address and we'll send you a recovery link",
		"SUBMIT": "Submit",
		"CHECK_YOUR_EMAIL": "Check your email",
		"RESTE_PASSWORD_LINK": "Reset password link has been sent to your email address",
		"RESEND_EMAIL": "Resend Email",
		"WELCOME_TO_ANALYSTPREP": "Welcome to AnalystPrep",
		"EXTRAS": "extras",
		"ALREADY_SUBSCRIBED": "Already Subscribed",
		"QUIZ": "Quiz",
		"NO_COMMENTS_FOUND": "No Comments Found",
		"PASSWORD": "Password",
		"USERNAME_OR_EMAIL": "Username or Email",
		"CONFIRM_PASSWORD": "Confirm Password",
		"USERNAME": "Username",
		"QUESTION_SETS_150": "150 Question Sets",
		"QUESTION_SETS_120": "120 Question Sets",
		"FULL_LENGTH_PRINTABLE_MOCK_EXAMS": "Full-Length Printable Mock Exams",
		"PAY_WITH_ALIPAY_NORMAL": "Pay With AliPay",
		"PAY_WITH_ALIPAY_CAPITAL": "PAY WITH ALIPAY",
		"PAY_WITH_PAYPAL_NORMAL": "Pay with PayPal",
		"PAY_WITH_PAYPAL_CAPITAL": "PAY WITH PAYPAL",
		"BY": "By",
		"NO_FLASHCARD_FOUND": "No Flash Card Found",
		"SELECT_HERE_NUMBER": "You can select here the number of questions for the quiz.",
		"ALL_INCOMPLETE_QUIZ": "You can see here the list of all incomplete quizes and also you can start the quiz from the point where you left by clicking on Recover link.",
		"SEE_THE_DETAILS": "You can see here the list of all completed quizes and see the details of the answered questions by clicking on View link.",
		"SEPARATE_YOUR_RESULT": "Analyze your results by topic and compare them to a user base of over 50,000 candidates.",
		"YOU_CAN_SEE": " A full progress bar means you have completed all available questions in that specific topic.",
		"Priority_selected": "You can priorities quiz on the basis of below options.",
		"I_WANT_MORE_DETAILS": "I Want More Details",
		"CONFIRM": "Confirm",
		"ARE_YOU_SURE_TO_DELETE_THIS": "Are you sure you want to delete this?",
		"RATE_THIS_QUESTION": "Rate this Question",
		"THAT_SPECIFIC_NOTES": "A full progress bar means you have completed all available study notes in that specific topic.",
		"ERROR": "Error",
		"CONFIRMATION_BOX": "Confirmation Box",
		"MARK_AS_READ": "Mark as Read",
		"SAVE_QUESTION": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
		"SAVE_NOTES": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
		"SAVE_VIDEO": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
		"MESSAGE": "Message",
		"READING_NOT_FOUND": "Reading Not Found",
		"MAY_ENTER_COUPON": "You may enter coupon code, partner code.",
		"MOCK_EXAMS": "Mock Exams",
		"VIDEOS": "Videos",
		"FRM_EXAM_I_DASHBOARD": "FRM Part I Dashboard",
		"FRM_EXAM_II_DASHBOARD": "FRM Part II Dashboard",
		"FRM_EXAM_I_QUIZZES": "FRM Part I Quizzes",
		"FRM_EXAM_II_QUIZZES": "FRM Part II Quizzes",
		"FRM_EXAM_I_VIDEOS": "Videos",
		"NEW_MAIL_ARRIVED": "new mail arrived",
		"CFA_LEVEL_I": "CFA Level I",
		"CFA_LEVEL_I_2021": "CFA Level I 2021",
		"CFA_LEVEL_I_2022": "CFA Level I 2022",
		"CFA_LEVEL_I_2023": "CFA Level I 2023",
		"CFA_LEVEL_I_2024": "CFA Level I 2024",
		"CFA_LEVEL_I_2024_DASHBOARD": "CFA Level I Dashboard",
		"CFA_LEVEL_II": "CFA Level II",
		"CFA_LEVEL_II_2023": "CFA Level II 2023",
		"CFA_LEVEL_II_2021": "CFA Level II 2021",
		"CFA_LEVEL_II_2022": "CFA Level II",
		"CFA_LEVEL_III": "CFA Level III",
		"FRM_EXAMS": "FRM Exams",
		"PROFILE": "Profile",
		"WELCOME": "Welcome",
		"CART": "Cart",
		"SUCCESS": "Success",
		"UPDATE_FAILED": "Update Failed",
		"PROFILE_SUCCESSFULLY_UPDATED": "Profile successfully updated!",
		"QUESTION_NOT_FOUND": "Questions not found",
		"NOTE_NOT_FOUND": "Notes not found",
		"LOGOUT": "Logout",
		"PAY": "Pay",
		"CASE": "Case",
		"STOP": "Stop",
		"Image_size_must_be_greater_than_200_less_than_400": "Image size must be greater than 200x200 in pixel or less than 400x400 inpixel",
		"Image_size_must_not_exceed_200_KB": "Image size must not exceed 200 KB",
		"Password_is_Required": "Password is Required",
		"Password_at_least_6_characters_long": "Password at least 6 characters long",
		"Confirm_Password_is_Required": "Confirm Password is Required",
		"Password_didnt_match": "Password didn't match",
		"Session_has_been_Expired": "Session has been Expired",
		"Email_Id_Not_Exist": " We do not recognize this email address in our system. Please contact support@analystprep.com for help.",
		"Email_Id_Invalid": "Email Id Invalid",
		"Email_is_Required": "Email is Required",
		"User_Name_is_Required": "User Name is Required",
		"Please_enter_atleast_6_characters_in_the_field": "New password must be atleast 6 characters long",
		"Exam_Field_is_Required": "Exam Field is Required",
		"No_Order_History": "No Order History",
		"PAID": "Paid",
		"Result_not_found": "Result not found.",
		"Hide_details": "Hide Details",
		"INCORRECT": "INCORRECT",
		"CORRECT": "CORRECT",
		"Question_Saved": "Question Saved",
		"Notes_Saved": "Notes Saved",
		"Video_Saved": "Video Saved",
		"New_Password_Is_Required": "New Password Is Required",
		"Password_And_Confirm_Password_Is_Required": "New Password and Confirm Password must be same",
		"Notes_not_found": "Notes not found",
		"MARKED_AS_READ": "Marked as Read",
		"RATED": "Rated",
		"VIEW_QUESTION": "View Question",
		"EDIT_REPORT": "Edit report",
		"VIEW_REPORTS_ANSWER": "View Feedback",
		"NO_SUBSCRIPTION_DETAIL": "No Subscription Details",
		"SOA_PROBILITY_DASHBOARD": "Dashboard",
		"List_of_All_Questions_For": "Detailed Stats For",
		"Filter_By": "Filter by",
		"Please_select_Chapter_ID": "Please select Chapter ID",
		"Please_Enter_Number_Only": "Please Enter Number Only",
		"Chapter_ID": "Chapter ID",
		"Reading_ID": "Reading ID",
		"Question_ID": "Question ID",
		"VIDEO_ID": "Video ID",
		"SELECT": "Select",
		"ANSWERED": "Answered",
		"Non_ANSWERED": "Not Answered",
		"No_of_attempts": "No. of Attempts",
		"AVERAGE_SCORE": "Average Score",
		"Passing_Score": "Passing Score",
		"PASSED": "Passed",
		"FAILED": "Failed",
		"Chapter_No": "Chapter No.",
		"READING_No": "Reading No.",
		"Reading_Name": "Reading Name",
		"PASS": "Pass",
		"YES": "Yes",
		"NO": "No",
		"Extensive_Study_Notes": "Extensive Study Notes",
		"Practice_Questions_3000": "3,000+ Practice Questions",
		"Practice_Questions_4000": "4,000+ Practice Questions",
		"Practice_Questions_1250": "1,250 Practice Questions",
		"Practice_Questions_1500_Actuarial": "1,500+ Practice Questions",
		"Mock_Exams_2": "2 Full-Length Mock Exams",
		"FullLength_Mock_Exams_4": "4 Full-Length Mock Exams",
		"FullLength_Mock_Exams_3": "5 Full-Length Mock Exams",
		"Unlimited_Customizable_Quizzes": "Unlimited Customizable Quizzes",
		"Amazing_Chat_Email_Support": "Tutors Answering your Questions via Live Chat",
		"INFORMATION": "Information",
		"Why_should_I_upgrade_my_account": "Why should I Upgrade my Account?",
		"Hours_of_Video_Lessons_40": "40+ Hours of Video Lessons",
		"Hours_of_Video_Lessons_60": "60+ Hours of Video Lessons",
		"Practice_Questions_1500": "500+ Practice Questions",
		"FullLength_Mock_Exams_2": "Essay Questions",
		"DOWNLOAD_PDF": "Download PDF",
		"REPORT": "Report",
		"MARK_THIS_QUESTION_AS_COMPLETED": "Mark as :",
		"COMPLETED": "Completed",
		"NOT_COMPLETED": "Not completed",
		"MARK_THIS_VIGNETTE_QUESTION_AS_COMPLETED": "Mark this Vignette Question as Completed",
		"Mark_this_Question_as_Completed": "Mark this vignette question as completed",
		"Essay_Style_Questions": "Essay Questions",
		"CFA_LEVEL_III_Essay_Style_Questions": "Essay Style Questions",
		"Detailed_Stats": "Detailed Stats",
		"Priorities_By": "Filter Questions",
		"UNANSWERED": "Non-attempted questions",
		"NONE": "No filter",
		"CHANGE_STATUS": "Change Status",
		"Wrong_answers": "Wrong answers",
		"DataDetail": "Data shown is solely based on mock exams attempts where 80% of the questions have been answered in a minimum of 20 minutes.",
		"unanswered_selected": "Prioritize questions you have never attempted followed by questions you answered incorrectly.",
		"wronganswered_selected": "Prioritize questions you answered incorrectly followed by questions you have never attempted.",
		"LANGUAGE": "Language",
		"ENGLISH": "English",
		"CHINESE": "Chinese",
		"Download_PDF": "Download PDF",
		"UPDATE": "Update",
		"CONFIRM_OLD_PASSWORD": "Confirm Old Password",
		"Chapter_Name": "Chapter Name",
		"CHAPTERS": "Chapters",
		"CFA_LEVEL_III_PRINTABLE_ESSAY_QUESTIONS": "Printable Essay Questions",
		"SET_PASSWORD": "Set Password",
		"FORUM": "Forum",
		"DISCUSSIONS": "Discussions",
		"REPLIES": "Replies",
		"GO_TO_APP": "Switch to Study App",
		"GO_TO_FORUM": "Switch to Forum",
		"SAVED_QUESTION": "Question Saved",
		"Executive_Assessment": "Executive Assessment (EA)",
		"SOA_PROBABILITY_QUESTION_BANK": "Question Bank",
		"PROBABILITY": "Probability",
		"SOA_PROBABILITY": "Actuarial Exam P (Probability)",
		"SOA_FINANCIAL": "Actuarial Exam FM (Financial Mathematics)",
		"SOA_INVESTMENT": "Actuarial Exam IFM (Investment and Financial Markets)",
		"ACTUARIAL_PROBABILITY_P": "P (Probability)",
		"ACTUARIAL_FM_QUESTION_BANK": "Question Bank",
		"ACTUARIAL_IFM_QUESTION_BANK": "Question Bank",
		"ACTUARIAL_FM": "FM (Financial Mathematics)",
		"ACTUARIAL_IFM": "IFM (Investment and Financial Markets)",
		"FRM_Part1and2": "FRM Part I & Part II",
		"REPORT_THIS_QUESTION": "Report this question to AnalystPrep's team for review.",
		"GO_TO_QUESTION_BANK": "Go to Question Bank",
		"Notes_ID": "Note ID",
		"Saved_Note": "Saved Note",
		"Question_Bank": "Question Bank",
		"Notes": "Notes",
		"CFA": "CFA Exams",
		"FRM": "FRM Exams",
		"SOA": "Actuarial Exams",
		"TAGS_INFO": "Please click on enter, tab, space, comma to add a tag.",
		"All_prices_are_in_US_dollars_All_sales_are_final": "All prices are in US dollars. All sales are final.",
		"All_sales_are_final": "All sales are final.",
		"COMING_SOON": "Coming Soon",
		"Download_Notes": "Download Notes",
		"Download_Question": "Download Q",
		"Download_Question_Answer": "Download Q/A",
		"COMMENT_TOOLTIP_MESSAGE": "You can use the Comments section to ask a question or to show how you solved the question. Don't hesitate to share your thoughts, as it could help other candidates. Comments will show up on AnalystPrep's forum page.",
		"REPORT_TOOLTIP_MESSAGE": "Report this question to AnalystPrep's team for review.",
		"FLASHCARD_TOOLTIP_MESSAGE": "Flashcards will be visible in the dashboard tab. These are a great way to take notes while studying.",
		"BUY_NOW": "Buy Now",
		"Item_Sets_200": "200 Item Sets",
		"Item_Sets_100": "100 Item Sets",
		"CLOSE": "Close",
		"REPORT_SEND_SUCCESS_MESSAGE": "Your report has been submitted successfully.",
		"I_need_further_help": "I need further help",
		"SUBJECT": "Subject",
		"SEND_REQUEST": "Send Request",
		"GO_TO_ANSWER": "Back",
		"REQUEST_SEND_SUCCESS_MESSAGE": "Your request has been submitted successfully.",
		"GO_TO_MY_LAST_QUESTION_ANSWERED": "Go to my Last Question Answered",
		"GO_TO_MY_LAST_NOTES_READ": "Go to my Last Notes Read",
		"GO_TO_MY_LAST_VIDEO_VIEWED": "Go to my Last Viewed Video",
		"PLEASE_WAIT": "Please Wait",
		"SEND_NOTIFICATIONS_VIA_EMAIL": "Send notifications via email",
		"GOTOLOGIN": "Return to Login.",
		"SIGNUP_Approval_HEADING": "Your account must be verified by an administrator.",
		"SIGNUP_Approval_BODY_1": "You have created your account successfully, but you can not log in yet.",
		"SIGNUP_Approval_BODY_2": "Your registration request has been submitted to the moderators for approval. You will be notified by email when your registration is approved.",
		"FOOTER_MESSAGE": "CFA Institute does not endorse, promote or warrant the accuracy or quality of AnalystPrep. CFA® and Chartered Financial Analyst® are registered trademarks owned by CFA Institute.",
		"PDFContentMessage": "You successfully initiated your export. You'll receive an email notification when your export is ready to download.",
		"PDFDOWNLOAD": "PDF Download",
		"START_STUDY": "Start Studying",
		"TICKET_ID": "Ticket ID",
		"DELETE_FROM_CART": "Delete from Cart",
		"APPSUMO_CODE": "AppSumo Code",
		"Code_is_Required": "AppSumo code is required.",
		"EXISTING_USER_APP_SUMO": "Existing User? Sign In",
		"NEW_USER_APP_SUMO": "New User? Sign Up",
		"ACCOUNT_DELETE": "Delete Account",
		"ARE_YOU_SURE_TO_DELETE_THIS_ACCOUNT": "Are you sure you want to delete your account?",
		"ACCOUNT_DELETE_ALERT": "Delete my account",
		"DeleteAccountMiddleMessage": "<strong>Please Note: </strong> This will <span style='color: #f86c6b;font-weight: bold;' >permanently</span> delete your account including all your data and your activity on the forum.",
		"ACCOUNT_DELETED_SUCCESSFULLY": "Your Account has been successfully deleted.",
		"Download_Q_Cases": "Download QC",
		"Download_QA_Cases": "Download QA/C",
		"FRM_LEVEL_II_LESSONS": "FRM Part II - Video Lessons",
		"FRM_LEVEL_I_LESSONS": "FRM Part I - Video Lessons",
		"CBT_MOCK_EXAM": "CBT Mock Exams",
		"MOCKEXAM": "Mock Exam",
		"INSTRUCTIONS": "Instructions",
		"START": "Start",
		"No_Mock_Exams": "No Mock Exams",
		"SCRORE": "Score",
		"CBT_MOCK_INSTRUCTIONS": "At the test center before beginning the exam you must agree to terms in the Candidate Agreement and Standard VII(A) of the CFA Institute Standards of Professional Conduct.  If you do not accept the terms, you will not be permitted to test and must exit the exam. Your enrollment and/or registration fees are non-refundable and non-transferrable.<br/><br/>By checking the box <strong>I accept these terms</strong/> and clicking <strong>Continue</strong> you affirm that you accept the terms of this agreement and want to proceed into the exam. If you do not accept the terms of this agreement, you must click the <strong>Exit</strong> button and the exam will terminate.",
		"TEST": "Test",
		"Finish_Test": "Finish Test",
		"FRM1_MOCK_LIST": "FRM Part I Computer-Based Testing Mock Exams",
		"FRM2_MOCK_LIST": "FRM Part II Computer-Based Testing Mock Exams",
		"Test_Deleted": "Test Deleted Successfully",
		"BACK": "Back",
		"TOTAL_SCORE": "Total Score",
		"TEST_COMPLETED_IN": "Test Completed In",
		"NEXT": "Next",
		"NO_QUESTION_FOUND": "No Question Found",
		"NO_QUESTION_FOR_THIS_EXAM": "No Questions found for this mock exam",
		"NO_QUESTION_FOR_GRADING": "No Questions found for grading",
		"NO_SCORE_FOUND": "No Score found",
		"MOCK_LIST": "Computer-Based Testing Mock Exams",
		"PRINT_Q_MOCK": "Questions",
		"PRINT_QA_MOCK": "Questions & Answers",
		"TIME_LEFT": "Time Left",
		"FLAG_THIS_QUESTION": "Flag to review later",
		"UNFLAG_THIS_QUESTION": "Unflag question",
		"SECTION_REVIEW": "Section Review",
		"FILTER_BY": "Filter by",
		"CLEAR": "Clear",
		"DELETE_TEST": "Delete Test",
		"VIEW_TEST": "View Test",
		"NO_MOCK_EXAM_FOUND": "No Test Found",
		"INTROTITLE": "Tutorial Introduction",
		"INTROPARA": "<p>The following screens provide a tutorial of the exam software. This will help you become familiar with the software features and is not intended to be a mock exam. This same tutorial will be available to you on exam day. Before attempting any exam questions, take a few minutes to review the tutorial.</p><p>After completing and reviewing the sample exam questions, click the 'Finish Section' button in the top-right corner of the screen.</p><p>Once clicked, a pop-up window will appear confirming that you want to finish the section. Click 'Yes' to submit your answers or 'No' to return to the test.</p><p>Please note that once you finish the section you may not return to the sample exam questions. Any questions that are unanswered or incorrect will not count against your final score.</p>",
		"NEXTTOCONTINUE": "To begin the tutorial, click 'Next' to continue",
		"WELCOMETITLE": "Welcome to the Tutorial",
		"WELCOMEPARA": "<p>This tutorial provides a series of screens that orient you to the computer testing environment. You will be instructed on how to use the mouse and the different parts of the screen.</p><p> Notice the timer at the top of the screen. A similar display will appear during the actual exam. To the left of the screen is a numbered list that shows you where you are in the series of examination questions (or in this case, screens of the tutorial). Other screen features are described later in the tutorial.</p>",
		"NEXTBUTTONCONTINUE": "Click the 'Next' button to continue.",
		"USEMOUSETITLE": "Using the Mouse",
		"USEMOUSEPARA": "<p>The mouse pointer moves when you move the mouse around on a surface. Although it can assume different shapes, the arrow shown above is most common. To point with the mouse, move the pointer until it rests on the desired object. To click on an object, point to it and then quickly press and release the left mouse button.</p>",
		"NAVIGATTITLE": "Navigating Through the Exam",
		"NAVIGATPARA": "<p>Click the <b>'Next'</b> button displayed at the bottom of the screen to move to the next screen or question. Click the <b>'Back'</b> button to move to the previous screen or question.</p><p> In addition to the navigation buttons, you can use the numbered buttons displayed on the left side of the screen. Depending on the number of questions in the section, you may need to click on the down arrow to navigate to additional questions.</p>",
		"NAVIGATBUTTONINFO": "<p>The numbered buttons change appearance to indicate different question states: Current, Attempted, Unattempted, and Flagged.</p><ul><li>The current question will be indicated by an arrow-shaped numbered button.</li><li>For all attempted questions, the numbered button will appear darker in color.</li><li>For all unattempted questions, the numbered button will remain the original color.</li><li>Flagged questions will show a flag icon on the numbered button.</li></ul>",
		"TIMEREMAINTITLE": "Time Remaining",
		"TIMEREMAINPARAONE": "<p>The amount of time remaining is displayed at the right of the screen.</p>",
		"TIMEREMAINPARATWO": "<p>Each section of this examination is allocated a specific amount of time, including the Tutorial and Survey. There is also an overall amount of time provided for your full exam appointment. Clicking on the clock will switch between the amount of time remaining in the current section of the exam and the amount of overall time remaining for the full exam appointment.</p><p>The most important time display for you as a test taker is the 'Section Time Remaining.'</p><p>Note that, where applicable, an alert box will appear below the exam clock to signal when 30 minutes, 15 minutes, and 5 minutes remain in the current section.</p>",
		"FLAGTITLE": "Flagging Questions",
		"FLAGPARA": "<p>You can flag a question as a reminder to go back and check your answer or attempt it later. To flag a question, click the <b>'Flag'</b> button displayed at the bottom of the exam screen.</p><p>Any questions that are flagged for review will show a flag icon on the numbered button, as shown below.</p>",
		"FLAGBUTTON": "<p>Click the <b>'Flag'</b> button again to remove the flag.</p>",
		"ANSWERMULTTITLE": "Answering Multiple-Choice Questions",
		"ANSWERMULTPARA": "<p>This examination uses multiple-choice questions. This type of question has one correct answer.</p><p>To complete each multiple-choice question, click on the option that you believe to be the single best answer. Once selected, the option will appear darker in color. To change your response, click on a different option. If you would like to unselect a chosen option, click on it a second time.</p><p><b>Practice answering the multiple-choice question below. Once you have finished practicing, click the 'Next' button to continue.</b></p>",
		"QUESMULTTITLE": "Tallinn is the capital of which country?",
		"ESTONIA": "Estonia",
		"UKRAINE": "Ukraine",
		"BELGIUM": "Belgium",
		"REVIEWTITLE": "Section Review",
		"REVIEWPARA": "<p>During the examination, you can review the status of all questions in a current exam section using the grid icon located in the bottom left corner of the exam screen:</p>",
		"REVIEWPARACLOSE": "<p>To navigate directly to a question, click the corresponding numbered icon. You may also filter your view by unattempted, attempted, and flagged questions. The Section Review can be closed using the <b>'X'</b> icon.</p>",
		"ENDINGEXAMTITLE": "Ending Exam Sections",
		"ENDINGEXAMPARA": "<p>After completing and reviewing all of the questions within a section, you can navigate to the next section by clicking the <b>'Finish Section'</b> button in the top-right corner of the screen. Once clicked, a pop-up window will appear confirming you want to finish the section. Select 'Yes, I would like to finish this section' to submit your answers for that  section and progress to the next section.</p><p>The final section of the test is a short survey. Once you have completed the survey, you can end your session by clicking the <b>'Finish Test'</b> button in the top-right corner of the screen and confirming you would like to finish the test.</p><p>Please note that once you leave a section, you may not return. Any questions that are unanswered or incorrect will not count against your final score.</p>",
		"TUTORIALCONCLUSIONTITLE": "Tutorial Conclusion",
		"TUTORIALCONCLUSIONPARA": "<p>This concludes the tutorial. You can review the tutorial by clicking on the <b>'Back'</b> button to back up one screen at a time, or by using the numbered buttons displayed on the left side of the screen. You may view the tutorial at any point during the examination by clicking on the question mark icon. This icon can be found in the bottom left of the screen once you have begun testing.</p><p>Good luck with the examination.</p>",
		"CLICKSTARTTEST": "Click the 'Start the Test' button to exit the tutorial and begin the examination.",
		"NOT_ATTEMPTED": "Not Attempted",
		"START_TEST": "Start the Test",
		"Incorrect": "Incorrect",
		"Correct": "Correct",
		"TOPIC_WISE_SCORE": "Topic Wise Score",
		"You_Scored": "You Scored",
		"SHOW_MYSCORE": "Show my score by topic",
		"SHOW_GRAPH": "Show my graph",
		"ARE_YOU_SURE_FINISH": "Are you sure you would like to finish the test?",
		"FLAG_POPUP_TEXT": "Some of the questions in this test have been flagged. Are you sure  you would like to finish?",
		"I_ACCEPT_THE_TERMS": "I accept these terms.",
		"NOT_ATTEMPTED_POPUP": "You have not attempted all of the questions on this test.",
		"CHANGE_MOCK": "Change Mock",
		"CBT_MOCK_INSTRUCTIONS_FRM": "At the test center before beginning the exam you must agree to terms in the Candidate Agreement. If you do not accept the terms, you will not be permitted to test and must exit the exam. Your enrollment and/or registration fees are non-refundable and non-transferrable.<br/><br/>By checking the box <strong>I accept these terms</strong/> and clicking <strong>Continue</strong> you affirm that you accept the terms of this agreement and want to proceed into the exam. If you do not accept the terms of this agreement, you must click the <strong>Exit</strong> button and the exam will terminate.",
		"BOOK": "Book",
		"Hours_of_Video_Lessons_30": "30+ Hours of Video Lessons for each Part",
		"Practice_Questions_2000": "2,000 Practice Questions for each Part",
		"SHOW_MYSCORE_Book": "Show my score by book",
		"BOOK_WISE_SCORE": "Book Wise Score",
		"Essential_Summaries": "Essential Summaries",
		"Formula_Sheet": "Formula Sheet",
		"Ratio_Sheet": "Ratio Sheet",
		"Additional_Resources": "Additional Resources",
		"Save_and_Take_Break": "Save and Take a Break",
		"RESUME": "Resume",
		"Section_Introduction": "Section Introduction",
		"Study_Notes": "Study Notes",
		"Click_me_to_highlight": "Click to highlight",
		"Click_me_to_unhighlight": "Click to unhighlight",
		"Strike_Through": "Strikethrough",
		"Correct_Choice": "Mark as correct answer",
		"Incomplete": "Incomplete",
		"HIGHLIGHTINGTEXT": "Highlighting Text",
		"HIGHLIGHTINGPARA": "<p>During the examination, you will be able to highlight question text that you feel is important to refer back to as you progress through the exam. The highlight will remain present as you navigate through the exam, unless you select to remove it.</p><p>To highlight text, click and drag the mouse cursor over the desired text. Click the <b>'Highlight'</b> button, as shown in the image below, that appears after releasing the mouse button. To remove the highlight, click on any area of the highlighted text.</p>",
		"PLEASENOTE": "<p>Please note the highlight feature cannot be applied to text within the answer options.</p>",
		"STRIKINGOUTOPTIONS": "Striking Out Options",
		"STRIKINGOUTOPTIONSPARA": "<p>During the examination, a Strikeout feature is available to help you visually eliminate possible options from consideration. A struck out option will remain present as you progress through the exam, unless you select to remove it.</p><p>Right-click on an option to strike it out. Right-click again to remove the strikeout. Left-click on a struck out option to select it as your response. You may strike out as many or as few items as you like.</p><p><b>Practice using the Strikeout feature below. Once you have finished practicing, click the 'Next' button to continue.</b></p><p>What bird has the largest wingspan of any existing species?</p>",
		"PAUSEEXAM": "Pause Exam",
		"PAUSEEXAMPARA": "<p>While attempting exam you can also pause it for a while to go for a tea break. <b>Once you resume exam the time will be stopped</b>.</p>",
		"Privacy_Policy": "Privacy Policy",
		"PRACTICE_EXAMS": "Practice Exams",
		"PRINT_CASES_QA_MOCK": "Questions & Answers",
		"PRINT_CASES_Q_MOCK": "Questions",
		"Hours_of_Video_Lessons_35": "35+ Hours of Video Lessons",
		"Quant_Questions": "Quant Questions",
		"Verbal_Questions": "Verbal Questions",
		"Integrated_Reasoning_Questions": "Integrated Reasoning Questions",
		"Advanced_Analytics_Dashboard": "Advanced Analytics Dashboard",
		"AskATutor_Questions": "Ask-A-Tutor Questions",
		"SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS": "Subscribe for 1,000 practice questions",
		"VERBAL_PROBLEM": "Verbal Problems",
		"INTEGRATED_REASONING_QUESTIONS": "Integrated Reasoning Questions",
		"PERFORMANCE_BY_AREA": "Performance by Area",
		"QUANT_PROBLEM": "Quantitative Problems",
		"Change_Questions": "Change Question",
		"ESG": "ESG",
		"NAVIGATBUTTONINFOONFINISH": "<p>The numbered buttons change appearance to indicate different answer states: Wrong Answer, Correct Answer, Unanswered and Marks in between 0 and max grade.</p><ul><li>The current answer will be indicated by an arrow-shaped numbered button.</li><li>For all correct answered question, the numbered button will appear in green color.</li><li>For all incorrect answered question, the numbered button will appear in red color.</li><li>For in between 0 to max grading answered question, the numbered button will appear in yellow color.</li><li>For all unattempted questions, the numbered button will remain the original color.</li><li>Flagged questions will show a flag icon on the numbered button.</li></ul>",
		"AMOUNT": "Amount",
		"RENEWAL_DATE": "Renewal Date",
		"RECURRING_SUBSCRIPTION_DETAIL": "Recurring Subscription Details"
	};

/***/ },
/* 1053 */
/***/ function(module, exports) {

	module.exports = {
		"1": "1",
		"2": "2",
		"CHAPTER": "Chapter",
		"TOTAL_VIDEOS": "Total Videos",
		"VIDEO_LESSONS": "Video Lessons",
		"KEEP_FREE_VERSION": "Keep Free Version!",
		"GO_PREMIUM": "Go Premium!",
		"Q": "Q.",
		"N": "N.",
		"CHANGE_READING": "Change Reading",
		"CHANGE_QUESTIONS": "Change Question",
		"CHANGE_NOTES": "Change Notes",
		"OPEN_CALCULATOR": "Open Calculator",
		"CHANGE_CHAPTER": "Change Chapter",
		"SUBSCRIBE_FOR_3000_PRACTICE_QUESTIONS": "Subscribe for 3,000 practice questions",
		"SUBSCRIBE_FOR_4000_PRACTICE_QUESTIONS": "Subscribe for 2,000 Practice Questions",
		"SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS": "Subscribe for 1,500 practice questions",
		"SUBSCRIBE": "Subscribe",
		"GO_TO_VIDEOS": "Go To Videos",
		"ORDER_ID": "Order ID",
		"NAME": "Name",
		"EMAIL": "Email",
		"PAYMENT_METHOD": "Payment Method",
		"THANK_YOU_FOR_YOUR_ORDER": "Thank You for your Order!",
		"PRICE": "Price",
		"DISCOUNT": "Discount",
		"EXPIRED": "Expired",
		"LIFETIME_VALID": "Lifetime valid",
		"ACTIVE": "Active",
		"SUBSCRIPTION_DETAIL": "Package Details",
		"MONTHLY_SUBSCRIPTION_DETAIL": "Subscription Details",
		"GO_TO_PROFILE": "Go to profile",
		"ID": "Id",
		"EXAM_NAME": "Exam Name",
		"PACKAGE": "Package",
		"EXPIRY_DATE": "Expiry Date",
		"STATUS": "Status",
		"READ_MORE": "Read More",
		"PICK_YOUR_EXAM": "Pick Your Exam Plan",
		"GO_BACK_TO_EXAMS": "Go Back To Exams",
		"OK": "OK",
		"VIEW_LIST": "View List",
		"Percentile_20": "20th Percentile",
		"Percentile_80": "80th Percentile",
		"BEGIN_CHAPTER": "Begin Chapter",
		"CHANGE_TOPIC": "Change Topic",
		"CHANGE_QUESTION": "Change Question",
		"READING": "Reading",
		"ACTION": "Action",
		"QUESTIONS": "Questions",
		"DATE": "Date",
		"RECOVER": "Recover",
		"VIEW": "View",
		"CREATE_QUIZ": "Create Quiz",
		"CONTENT": "Content",
		"ALL_CHAPTERS": "All Chapters",
		"ABANDONED_QUIZZES": "Abandoned Quizzes",
		"LENGTH": "Length",
		"COMPLETED_QUIZZES": "Completed Quizzes",
		"TOTAL_READINGS": "Total Readings",
		"FREE_QUESTIONS": "Free Questions",
		"PREMIUM_QUESTIONS": "Premium Questions",
		"CFA_LEVEL_I_QUESTION_BANK": "Question Bank",
		"CHANGE_PASSWORD": "Change Password",
		"MY_SAVED_QUESTIONS": "My Saved Questions",
		"MY_SAVED_NOTES": "My Saved Notes",
		"MY_SAVED_VIDEOS": "My Saved Videos",
		"MY_SAVED": "My Saved Items/Flashcards",
		"MY_SAVED_ITEM_WITH_FLASH_CARD": "My Saved Items/Flashcards",
		"MY_FLASHCARDS": "My Flashcards",
		"MY_REPORTS": "My Reports",
		"ORDER_HISTORY": "Order History",
		"PROFILE_INFO": "Profile Details",
		"EXAM_LOCATION": "Exam Location",
		"AGE": "Age",
		"OCCUPATION": "Occupation",
		"EDUCATION": "Education",
		"UPDATE_PROFILE": "Update Profile",
		"ORDERS": "Orders",
		"ORDERS_History": "Order History",
		"PAYMENT_TYPE": "Payment type",
		"PAYMENT_STATUS": "Payment Status",
		"ORDER_DATE": "Order Date",
		"YOUR_ORDER": "Your Order",
		"Order_Details": "Order Details",
		"GO_TO_HISTORY": "Go to history",
		"TOTAL": "Total",
		"TOTAL_NOTES": "Total Notes",
		"NOTES": "Notes",
		"READY_FOR_PRINT": "Ready For Print",
		"CFA_LEVEL_I_QUIZZES": "Quizzes",
		"CFA_LEVEL_I_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"NO_SAVED_QUESTIONS_FOR_LEVEL_I": "No Saved Questions For Level I",
		"QUESTION_ID": "Question ID",
		"TOPIC": "Topic",
		"NO_SAVED_QUESTIONS_FOR_LEVEL_II": "No Saved Questions For Level II",
		"NO_SAVED_NOTES_FOR_LEVEL_I": "No Saved Notes For Level I",
		"NO_SAVED_NOTES_FOR_LEVEL_II": "No Saved Notes For Level II",
		"NO_SAVED_VIDEO_FOR_LEVEL_I": "No Saved Video For Level I",
		"NO_SAVED_VIDEO_FOR_LEVEL_II": "No Saved Video For Level II",
		"PICK_THE_QUESTION_YOU_WANT_TO_REVIEW": "Pick the question you want to review",
		"PICK_THE_NOTES_YOU_WANT_TO_REVIEW": "Pick the notes you want to review",
		"PICK_THE_VIDEO_YOU_WANT_TO_REVIEW": "Pick the video you want to review",
		"LEVEL_I": "LEVEL I",
		"LEVEL_II": "LEVEL II",
		"ALERT": "Alert",
		"READINGS": "Readings",
		"QUESTION_BANK": "Question Bank",
		"FRM_LEVEL_I_TOPICS": "FRM Part I - Topics",
		"FRM_LEVEL_II_TOPICS": "FRM Part II - Topics",
		"FRM_LEVEL_I_QUIZZES": "FRM Part I Quizzes",
		"FRM_LEVEL_II_QUIZZES": "FRM Part II Quizzes",
		"SOA_P_QUIZZES": "Quizzes",
		"SOA_FM_QUIZZES": "Quizzes",
		"SOA_IFM_QUIZZES": "Quizzes",
		"CODE_OF_ETHICS_AND_STANDARDS_OF_PROFESSIONAL_CONDUCT": "Code of Ethics and Standards of Professional Conduct",
		"READ_CHAPTER": "Read Chapter",
		"CANCEL": "Cancel",
		"COMMENT": "Comment",
		"UPDATE_COMMENT": "Update Comment",
		"YOU_CAN_USE_THE_COMMENT_SECTION_TO_ASK_A_QUESTION_OR_TO_SHOW_HOW_YOU_SOLVED_THE_PROBLEM_Dont_hesitate_to_share_your_thoughts_it_could_help_other_candidates": "You can use the comment section to ask a question or to show how you solved the problem. Don't hesitate to share your thoughts, it could help other candidates!",
		"FLASHCARD": "Flashcard",
		"CREATE": "Create",
		"FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study": "Flashcards only show up to you. This is a simple way to take notes while you study!",
		"FRM_NOTES": "Notes",
		"FRM_PART_I_CHAPTERS": "FRM Part I",
		"FRM_PART_II_CHAPTERS": "FRM Part II",
		"TOTAL_QUESTIONS": "Total Questions",
		"PRINT": "Print",
		"FRM_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"NO_SAVED_FLASHCARDS_FOR_LEVEL_I": " No Saved Flashcards For Level I",
		"NO_FLASHCARDS_FOR_LEVEL_II": "No Flashcards For Level II",
		"PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW": "Pick the flashcard you want to review",
		"DELETE": "Delete",
		"NO_FLASHCARDS": "No Flashcards",
		"NO_SAVED_QUESTIONS": "No Saved Questions",
		"NO_SAVED_NOTES": "No Saved Notes",
		"NO_SAVED_VIDEO": "No Saved Video",
		"NO_REPORTS": "No Reports",
		"MY_FRM_EXAM_I_DASHBOARD": "FRM Part I Dashboard",
		"FROM": "From",
		"TO": "To",
		"QUESTION_PROGRESS": "Questions Progress",
		"LABELS": "labels",
		"DATASETS": "datasets",
		"A": "A",
		"B": "B",
		"C": "C",
		"D": "D",
		"E": "E",
		"VALIDATE": "Validate",
		"FLAG_QUESTION": "Flag Question",
		"THE_CORRECT_ANSWER_IS": "The correct answer is ",
		"QUIZ_ID": "Quiz ID",
		"BACK_TO_SUMMARY": "Back to Summary",
		"CFA_LEVEL_I_PREMIUM_PACKAGE": "CFA Level I - Premium Package",
		"TOTAL_TIME:": "Total Time:",
		"CREATE_NEW_QUIZ": "Create New Quiz",
		"SUMMARY": "Summary",
		"MINUTE": "Minute",
		"BEFORE_STARTING": "Before Starting",
		"ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER": "1. Once a question is validated, it is impossible to change your answer.",
		"YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS": "2. You can always come back to this page to view the questions left unanswered or to navigate through the questions.",
		"IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS": "3. If you requested a timer, we strongly discourage you to stop it during the quiz as time management is a key factor for success.",
		"YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER": "4. You can always use the flashcard or the save question tools to take some notes for later.",
		"WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS": "5. We encourage you to leave your methodology in the comments section to help other users.",
		"YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION": "6. You can leave the quiz and come back later. It will always stay available in the abandoned quizzes section.",
		"EXAMPLE": "Example",
		"NO_ANSWER": "No Answer",
		"CORRECT_ANSWER": "Correct Answer",
		"WRONG_ANSWER": "Wrong Answer",
		"ACTIONS": "Actions",
		"MY_FRM_EXAM_II_DASHBOARD": "FRM Part II Dashboard",
		"NOTES_PROGRESS": "Notes Progress",
		"GO_BACK_TO_PROFILE": "Go Back to Profile",
		"OLD_PASSWORD": "Old Password",
		"NEW_PASSWORD": "New Password",
		"CONFIRM_NEW_PASSWORD": "Confirm New Password",
		"UPDATE_PASSWORD": "Update Password",
		"YOUR_CART": "Your Cart",
		"PLEASE_VERIFY_THE_EXAM_AND_LEVEL_FOR_YOUR_PURCHASE": "Please verify the exam and level before you proceed to pay.",
		"PRICE($)": "Price($)",
		"PAYABLE_TODAY": "Payable today",
		"$": "$",
		"HAVE_A_PROMOTIONAL_CODE": "Have a Promotional Code",
		"APPLY": "Apply",
		"ADD_SUBSCRIPTION": "Add Subscription",
		"PROCEED_TO_PAY": "Proceed to pay",
		"PICK_YOUR_PAYMENT": "Select your Payment Method",
		"PAYMENT_WITH_ALIPAY": "Payment With AliPay",
		"PAY_WITH_ALIPAY": "Pay With Alipay",
		"PAY_WITH_CARD": "Pay with Debit or Credit Card",
		"FLASH_CARD": "Flash Card",
		"ADDONS": "Addons",
		"BUY": "BUY",
		"NO_PACKAGE_FOUND": "No Package Found",
		"ALL_EXAMS": "All Exams",
		"YOURS_ANSWER": "Your Answers",
		"SCORE": "Summary",
		"GRAPH": "Detailed Score",
		"TOTAL_TIME": "Total Time",
		"CONTINUE": "Continue",
		"BEGIN": "Begin",
		"QUIZ_ID:": "Quiz ID:",
		"CASES": "Cases",
		"BEGIN_CASES": "Begin Cases",
		"CASE_STUDIES": "Case Studies",
		"CASE_NAME": "Case Name",
		"THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY": "This case is available for Premium members only",
		"CASE_STUDY": "Case Study",
		"CHANGE_CASES": "Change Cases",
		"CFA_LEVEL_I_MY_DASHBOARD": "Dashboard",
		"CFA_LEVEL_I_2022_DASHBOARD": "CFA Level I Dashboard",
		"CFA_LEVEL_I_2023_DASHBOARD": "CFA Level I Dashboard",
		"CFA_LEVEL_I_2024_DASHBOARD": "CFA Level I Dashboard",
		"CFA_LEVEL_II_2023_DASHBOARD": "CFA Level II Dashboard",
		"CFA_LEVEL_II_2022_DASHBOARD": "CFA Level II Dashboard",
		"CFA_LEVEL_II_MY_DASHBOARD": "Dashboard",
		"PERFORMANCE": "Performance",
		"PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW:": "Pick the flashcard you want to review:",
		"DASHBOARD": "Dashboard",
		"CFA_LEVEL_II_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"CFA_LEVEL_II_QUESTION_BANK": "Question Bank",
		"CFA_LEVEL_II_QUIZZES": "Quizzes",
		"CFA_LEVEL_III_MY_DASHBOARD": "CFA Level III Dashboard",
		"CFA_LEVEL_III_PRINTABLE_MOCK_EXAMS": "Printable Mock Exams",
		"CFA_LEVEL_III_QUESTION_BANK": "Question Bank",
		"CFA_LEVEL_III_QUIZZES": "Quizzes",
		"FREE": "Free",
		"UPGRADE_ACCOUNT": "Upgrade Account",
		"PREMIUM": "Premium",
		"NO_RECORDS_FOUND": "No Records Found",
		"BACK_TO_VIDEOS": "Back to Videos",
		"FLAG_VIDEO": "Flag Video",
		"GO_TO_NOTES": "Go to Notes",
		"GO_TO_PRACTICE_QUESTIONS": "Go To Practice Questions",
		"QUESTION": "Question",
		"QUIZZES": "Quizzes",
		"BEGIN_NOTES_CHAPTER": "Begin Notes Chapter",
		"CHAPTER_READINGS": " Chapter  Readings",
		"DASHBOARD_GO_TO_PROFILE": "Dashboard Go to Profile",
		"FREE_CASES": "Free cases",
		"PREMIUM_CASES": "Premium cases",
		"NO_SAVED_FLASHCARDS": "No Saved Flashcard",
		"YOUR_CART_IS_EMPTY": "Your cart is empty",
		"PAY_WITH": "Pay With",
		"GRAPHSCORE": "Score",
		"GRAPHSCOREBOX": "Score box",
		"SCOREBOX": "Score Box",
		"CFACHAPTERWISERESULT": "Your Performance by Topic Area",
		"OVERALLRESULT": "Your Performance on the Exam",
		"YOURSCORE": "Your Score",
		"FRMBookWiseScore": "Your Performance by Topic Area",
		"QUESTIONS_3000": "3,000+ Questions",
		"FULL_LENGTH_PRINTABLE_MOCK_EXAMS_8": "8 Full-Length Printable Mock Exams",
		"UNLIMITED_CUSTOMIZABLE_QUIZZES": "Unlimited Customizable Quizzes",
		"COMPREHENSIVE_STUDY_NOTES": "Comprehensive Study Notes",
		"A_FORMULA_SHEET": "A Formula Sheet",
		"PRIORITY_EMAIL_SUPPORT": "Priority Email Support",
		"AND_YOU_KEEP_YOUR_MEMBERSHIP_UNTIL_YOU_PASS": "...and you keep your membership until you pass!",
		"FORGOT_PASSWORD": "Forgot password?",
		"SIGN_IN": "Sign In",
		"SIGN_UP": "Sign Up",
		"SELECT_EXAM": "Select Exam",
		"CFA_1": "Level I of the CFA® Exam",
		"CFA_1_2021": "Level I of CFA® Exam",
		"CFA_1_2022": "Level I of CFA® Exam",
		"CFA_1_2023": "Level I of the CFA® Exam 2023",
		"CFA_1_2024": "Level I of the CFA® Exam 2024",
		"CFA2_2025_QUIZ_ERROR": "Not enough questions to populate the quiz",
		"CFA_2": "Level II of the CFA® Exam",
		"CFA_2_2022": "Level II of the CFA® Exam",
		"CFA_2_2025": "Level II of the CFA® Exam 2025",
		"CFA_2_2023": "Level II of the CFA® Exam 2023",
		"CFA_2_2023_2024": "Level II of the CFA® Exam 2023/2024",
		"CFA_3": "Level III of the CFA® Exam",
		"CFA_3_2024": "Level III of the CFA® Exam 2024",
		"FRM_PART_1": "FRM Part I",
		"FRM_PART_2": "FRM Part II",
		"RESET_PASSWORD": "Reset Password",
		"RESEND_MAIL": "Resend Mail",
		"PASSWORD_RESET_SUCCESSFULLY": "Password has been reset successfully",
		"LOGIN": "Login",
		"ENTER_YOUR_EMAIL_ADDRESS": "Enter your email address and we'll send you a recovery link",
		"SUBMIT": "Submit",
		"CHECK_YOUR_EMAIL": "Check your email",
		"RESTE_PASSWORD_LINK": "Reset password link has been sent to your email address",
		"RESEND_EMAIL": "Resend Email",
		"WELCOME_TO_ANALYSTPREP": "Welcome to AnalystPrep",
		"EXTRAS": "extras",
		"ALREADY_SUBSCRIBED": "Already Subscribed",
		"QUIZ": "Quiz",
		"NO_COMMENTS_FOUND": "No Comments Found",
		"PASSWORD": "Password",
		"USERNAME_OR_EMAIL": "Username or Email",
		"CONFIRM_PASSWORD": "Confirm Password",
		"USERNAME": "Username",
		"QUESTION_SETS_150": "150 Question Sets",
		"QUESTION_SETS_120": "120 Question Sets",
		"FULL_LENGTH_PRINTABLE_MOCK_EXAMS": "Full-Length Printable Mock Exams",
		"PAY_WITH_ALIPAY_NORMAL": "Pay With AliPay",
		"PAY_WITH_ALIPAY_CAPITAL": "PAY WITH ALIPAY",
		"PAY_WITH_PAYPAL_NORMAL": "Pay with PayPal",
		"PAY_WITH_PAYPAL_CAPITAL": "PAY WITH PAYPAL",
		"BY": "By",
		"NO_FLASHCARD_FOUND": "No Flash Card Found",
		"SELECT_HERE_NUMBER": "You can select here the number of questions for the quiz.",
		"ALL_INCOMPLETE_QUIZ": "You can see here the list of all incomplete quizes and also you can start the quiz from the point where you left by clicking on Recover link.",
		"SEE_THE_DETAILS": "You can see here the list of all completed quizes and see the details of the answered questions by clicking on View link.",
		"SEPARATE_YOUR_RESULT": "Analyze your results by topic and compare them to a user base of over 50,000 candidates.",
		"YOU_CAN_SEE": "A full progress bar means you have completed all available questions in that specific topic.",
		"Priority_selected": "You can priorities quiz on the basis of below options.",
		"I_WANT_MORE_DETAILS": "I Want More Details",
		"CONFIRM": "Confirm",
		"ARE_YOU_SURE_TO_DELETE_THIS": "Are you sure you want to delete this?",
		"RATE_THIS_QUESTION": "Rate this Question",
		"THAT_SPECIFIC_NOTES": "A full progress bar means you have completed all available study notes in that specific topic.",
		"ERROR": "Error",
		"CONFIRMATION_BOX": "Confirmation Box",
		"MARK_AS_READ": "Mark as Read",
		"SAVE_QUESTION": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
		"SAVE_NOTES": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
		"SAVE_VIDEO": "Save this item on your dashboard for further review. You will also be able to create a flashcard.",
		"MESSAGE": "Message",
		"READING_NOT_FOUND": "Reading Not Found",
		"MAY_ENTER_COUPON": "You may enter coupon code, partner code.",
		"MOCK_EXAMS": "Mock Exams",
		"VIDEOS": "Videos",
		"FRM_EXAM_I_DASHBOARD": "FRM Part I Dashboard",
		"FRM_EXAM_II_DASHBOARD": "FRM Part II Dashboard",
		"FRM_EXAM_I_QUIZZES": "FRM Part I Quizzes",
		"FRM_EXAM_II_QUIZZES": "FRM Part II Quizzes",
		"FRM_EXAM_I_VIDEOS": "Videos",
		"NEW_MAIL_ARRIVED": "new mail arrived",
		"CFA_LEVEL_I": "CFA Level I",
		"CFA_LEVEL_I_2021": "CFA Level I 2021",
		"CFA_LEVEL_I_2022": "CFA Level I 2022",
		"CFA_LEVEL_I_2023": "CFA Level I 2023",
		"CFA_LEVEL_I_2024": "CFA Level I 2024",
		"CFA_LEVEL_II": "CFA Level II",
		"CFA_LEVEL_II_2023": "CFA Level II 2023",
		"CFA_LEVEL_II_2021": "CFA Level II 2021",
		"CFA_LEVEL_II_2022": "CFA Level II",
		"CFA_LEVEL_III": "CFA Level III",
		"FRM_EXAMS": "FRM Exams",
		"PROFILE": "Profile",
		"WELCOME": "Welcome",
		"CART": "Cart",
		"SUCCESS": "Success",
		"UPDATE_FAILED": "Update Failed",
		"PROFILE_SUCCESSFULLY_UPDATED": "Profile successfully updated!",
		"QUESTION_NOT_FOUND": "Questions not found",
		"NOTE_NOT_FOUND": "Notes not found",
		"LOGOUT": "Logout",
		"PAY": "Pay",
		"CASE": "Case",
		"STOP": "Stop",
		"Image_size_must_be_greater_than_200_less_than_400": "Image size must be greater than 200x200 in pixel or less than 400x400 inpixel",
		"Image_size_must_not_exceed_200_KB": "Image size must not exceed 200 KB",
		"Password_is_Required": "Password is Required",
		"Password_at_least_6_characters_long": "Password at least 6 characters long",
		"Confirm_Password_is_Required": "Confirm Password is Required",
		"Password_didnt_match": "Password didn't match",
		"Session_has_been_Expired": "Session has been Expired",
		"Email_Id_Not_Exist": " We do not recognize this email address in our system. Please contact support@analystprep.com for help.",
		"Email_Id_Invalid": "Email Id Invalid",
		"Email_is_Required": "Email is Required",
		"User_Name_is_Required": "User Name is Required",
		"Please_enter_atleast_6_characters_in_the_field": "New password must be atleast 6 characters long",
		"Exam_Field_is_Required": "Exam Field is Required",
		"No_Order_History": "No Order History",
		"PAID": "Paid",
		"Result_not_found": "Result not found.",
		"Hide_details": "Hide Details",
		"INCORRECT": "INCORRECT",
		"CORRECT": "CORRECT",
		"Question_Saved": "Question Saved",
		"Notes_Saved": "Notes Saved",
		"Video_Saved": "Video Saved",
		"New_Password_Is_Required": "New Password Is Required",
		"Password_And_Confirm_Password_Is_Required": "New Password and Confirm Password must be same",
		"Notes_not_found": "Notes not found",
		"MARKED_AS_READ": "Marked as Read",
		"RATED": "Rated",
		"VIEW_QUESTION": "View Question",
		"EDIT_REPORT": "Edit report",
		"VIEW_REPORTS_ANSWER": "View Feedback",
		"NO_SUBSCRIPTION_DETAIL": "No Subscription Details",
		"SOA_PROBILITY_DASHBOARD": "Dashboard",
		"List_of_All_Questions_For": "Detailed Stats For",
		"Filter_By": "Filter by",
		"Please_select_Chapter_ID": "Please select Chapter ID",
		"Please_Enter_Number_Only": "Please Enter Number Only",
		"Chapter_ID": "Chapter ID",
		"Reading_ID": "Reading ID",
		"Question_ID": "Question ID",
		"VIDEO_ID": "Video ID",
		"SELECT": "Select",
		"ANSWERED": "Answered",
		"Non_ANSWERED": "Not Answered",
		"No_of_attempts": "No. of Attempts",
		"AVERAGE_SCORE": "Average Score",
		"Passing_Score": "Passing Score",
		"PASSED": "Passed",
		"FAILED": "Failed",
		"Chapter_No": "Chapter No.",
		"READING_No": "Reading No.",
		"Reading_Name": "Reading Name",
		"PASS": "Pass",
		"YES": "Yes",
		"NO": "No",
		"Extensive_Study_Notes": "Extensive Study Notes",
		"Practice_Questions_3000": "3,000+ Practice Questions",
		"Practice_Questions_4000": "4,000+ Practice Questions",
		"Practice_Questions_1250": "1,250 Practice Questions",
		"Practice_Questions_1500_Actuarial": "1,500+ Practice Questions",
		"Mock_Exams_2": "2 Full-Length Mock Exams",
		"FullLength_Mock_Exams_4": "4 Full-Length Mock Exams",
		"FullLength_Mock_Exams_3": "5 Full-Length Mock Exams",
		"Unlimited_Customizable_Quizzes": "Unlimited Customizable Quizzes",
		"Amazing_Chat_Email_Support": "Tutors Answering your Questions via Live Chat",
		"INFORMATION": "Information",
		"Why_should_I_upgrade_my_account": "Why should I Upgrade my Account?",
		"Hours_of_Video_Lessons_40": "40+ Hours of Video Lessons",
		"Hours_of_Video_Lessons_60": "60+ Hours of Video Lessons",
		"Practice_Questions_1500": "500+ Practice Questions",
		"FullLength_Mock_Exams_2": "Essay Questions",
		"DOWNLOAD_PDF": "Download PDF",
		"REPORT": "Report",
		"MARK_THIS_QUESTION_AS_COMPLETED": "Mark as :",
		"COMPLETED": "Completed",
		"NOT_COMPLETED": "Not completed",
		"MARK_THIS_VIGNETTE_QUESTION_AS_COMPLETED": "Mark this Vignette Question as Completed",
		"Mark_this_Question_as_Completed": "Mark this vignette question as completed",
		"Essay_Style_Questions": "Essay Questions",
		"CFA_LEVEL_III_Essay_Style_Questions": "Essay Style Questions",
		"Detailed_Stats": "Detailed Stats",
		"Priorities_By": "Filter Questions",
		"UNANSWERED": "Non-attempted questions",
		"NONE": "No filter",
		"FILTER_QUIZZES": "Filter Quizzes",
		"NON_ATTEMPTED_CASES": "Non-attempted cases",
		"CHANGE_STATUS": "Change Status",
		"Wrong_answers": "Wrong answers",
		"DataDetail": "Data shown is solely based on mock exams attempts where 80% of the questions have been answered in a minimum of 20 minutes.",
		"unanswered_selected": "Prioritize questions you have never attempted followed by questions you answered incorrectly.",
		"UNANSWERED_QUIZ_SELECTED": "Prioritize quiz you have never attempted followed by quiz you answered incorrectly.",
		"wronganswered_selected": "Prioritize questions you answered incorrectly followed by questions you have never attempted.",
		"LANGUAGE": "Language",
		"ENGLISH": "English",
		"CHINESE": "Chinese",
		"Download_PDF": "Download PDF",
		"UPDATE": "Update",
		"CONFIRM_OLD_PASSWORD": "Confirm Old Password",
		"Chapter_Name": "Chapter Name",
		"CHAPTERS": "Chapters",
		"CFA_LEVEL_III_PRINTABLE_ESSAY_QUESTIONS": "Printable Essay Questions",
		"SET_PASSWORD": "Set Password",
		"FORUM": "Forum",
		"DISCUSSIONS": "Discussions",
		"REPLIES": "Replies",
		"GO_TO_APP": "Switch to Study App",
		"GO_TO_FORUM": "Switch to Forum",
		"SAVED_QUESTION": "Question Saved",
		"Executive_Assessment": "Executive Assessment (EA)",
		"SOA_PROBABILITY_QUESTION_BANK": "Question Bank",
		"PROBABILITY": "Probability",
		"SOA_PROBABILITY": "Actuarial Exam P (Probability)",
		"SOA_FINANCIAL": "Actuarial Exam FM (Financial Mathematics)",
		"SOA_INVESTMENT": "Actuarial Exam IFM (Investment and Financial Markets)",
		"ACTUARIAL_PROBABILITY_P": "P (Probability)",
		"ACTUARIAL_FM_QUESTION_BANK": "Question Bank",
		"ACTUARIAL_IFM_QUESTION_BANK": "Question Bank",
		"ACTUARIAL_FM": "FM (Financial Mathematics)",
		"ACTUARIAL_IFM": "IFM (Investment and Financial Markets)",
		"FRM_Part1and2": "FRM Part I & Part II",
		"REPORT_THIS_QUESTION": "Report this question to AnalystPrep's team for review.",
		"GO_TO_QUESTION_BANK": "Go to Question Bank",
		"Notes_ID": "Note ID",
		"Saved_Note": "Saved Note",
		"Question_Bank": "Question Bank",
		"Notes": "Notes",
		"CFA": "CFA Exams",
		"FRM": "FRM Exams",
		"SOA": "Actuarial Exams",
		"TAGS_INFO": "Please click on enter, tab, space, comma to add a tag.",
		"All_prices_are_in_US_dollars_All_sales_are_final": "All prices are in US dollars. All sales are final.",
		"All_sales_are_final": "All sales are final.",
		"COMING_SOON": "Coming Soon",
		"Download_Notes": "Download Notes",
		"Download_Question": "Download Q",
		"Download_Question_Answer": "Download Q/A",
		"COMMENT_TOOLTIP_MESSAGE": "You can use the Comments section to ask a question or to show how you solved the question. Don't hesitate to share your thoughts, as it could help other candidates. Comments will show up on AnalystPrep's forum page.",
		"REPORT_TOOLTIP_MESSAGE": "Report this question to AnalystPrep's team for review.",
		"REPORT_VIDEO_TOOLTIP_MESSAGE": "Report this video to AnalystPrep's team for review.",
		"FLASHCARD_TOOLTIP_MESSAGE": "Flashcards will be visible in the dashboard tab. These are a great way to take notes while studying.",
		"BUY_NOW": "Buy Now",
		"Item_Sets_200": "200 Item Sets",
		"Item_Sets_100": "100 Item Sets",
		"CLOSE": "Close",
		"REPORT_SEND_SUCCESS_MESSAGE": "Your report has been submitted successfully.",
		"I_need_further_help": "I need further help",
		"SUBJECT": "Subject",
		"SEND_REQUEST": "Send Request",
		"GO_TO_ANSWER": "Back",
		"REQUEST_SEND_SUCCESS_MESSAGE": "Your request has been submitted successfully.",
		"GO_TO_MY_LAST_QUESTION_ANSWERED": "Go to my Last Question Answered",
		"GO_TO_MY_LAST_NOTES_READ": "Go to my Last Notes Read",
		"GO_TO_MY_LAST_VIDEO_VIEWED": "Go to my Last Viewed Video",
		"PLEASE_WAIT": "Please Wait",
		"SEND_NOTIFICATIONS_VIA_EMAIL": "Send notifications via email",
		"GOTOLOGIN": "Return to Login.",
		"SIGNUP_Approval_HEADING": "Your account must be verified by an administrator.",
		"SIGNUP_Approval_BODY_1": "You have created your account successfully, but you can not log in yet.",
		"SIGNUP_Approval_BODY_2": "Your registration request has been submitted to the moderators for approval. You will be notified by email when your registration is approved.",
		"FOOTER_MESSAGE": "CFA Institute does not endorse, promote or warrant the accuracy or quality of AnalystPrep. CFA® and Chartered Financial Analyst® are registered trademarks owned by CFA Institute.",
		"PDFContentMessage": "You successfully initiated your export. You'll receive an email notification when your export is ready to download.",
		"PDFDOWNLOAD": "PDF Download",
		"START_STUDY": "Start Studying",
		"TICKET_ID": "Ticket ID",
		"DELETE_FROM_CART": "Delete from Cart",
		"APPSUMO_CODE": "AppSumo Code",
		"Code_is_Required": "AppSumo code is required.",
		"EXISTING_USER_APP_SUMO": "Existing User? Sign In",
		"NEW_USER_APP_SUMO": "New User? Sign Up",
		"ACCOUNT_DELETE": "Delete Account",
		"ARE_YOU_SURE_TO_DELETE_THIS_ACCOUNT": "Are you sure you want to delete your account?",
		"ACCOUNT_DELETE_ALERT": "Delete my account",
		"DeleteAccountMiddleMessage": "<strong>Please Note: </strong> This will <span style='color: #f86c6b;font-weight: bold;' >permanently</span> delete your account including all your data and your activity on the forum.",
		"ACCOUNT_DELETED_SUCCESSFULLY": "Your Account has been successfully deleted.",
		"Download_Q_Cases": "Download QC",
		"Download_QA_Cases": "Download QA/C",
		"FRM_LEVEL_II_LESSONS": "FRM Part II - Video Lessons",
		"FRM_LEVEL_I_LESSONS": "FRM Part I - Video Lessons",
		"CBT_MOCK_EXAM": "CBT Mock Exams",
		"MOCKEXAM": "Mock Exam",
		"INSTRUCTIONS": "Instructions",
		"START": "Start",
		"No_Mock_Exams": "No Mock Exams",
		"SCRORE": "Score",
		"CBT_MOCK_INSTRUCTIONS": "At the test center before beginning the exam you must agree to terms in the Candidate Agreement and Standard VII(A) of the CFA Institute Standards of Professional Conduct.  If you do not accept the terms, you will not be permitted to test and must exit the exam. Your enrollment and/or registration fees are non-refundable and non-transferrable.<br/><br/>By checking the box <strong>I accept these terms</strong/> and clicking <strong>Continue</strong> you affirm that you accept the terms of this agreement and want to proceed into the exam. If you do not accept the terms of this agreement, you must click the <strong>Exit</strong> button and the exam will terminate.",
		"TEST": "Test",
		"Finish_Test": "Finish Test",
		"FRM1_MOCK_LIST": "FRM Part I Computer-Based Testing Mock Exams",
		"FRM2_MOCK_LIST": "FRM Part II Computer-Based Testing Mock Exams",
		"Test_Deleted": "Test Deleted Successfully",
		"BACK": "Back",
		"TOTAL_SCORE": "Total Score",
		"TEST_COMPLETED_IN": "Test Completed In",
		"NEXT": "Next",
		"NO_QUESTION_FOUND": "No Question Found",
		"NO_QUESTION_FOR_THIS_EXAM": "No Questions found for this mock exam",
		"NO_QUESTION_FOR_GRADING": "No Questions found for grading",
		"NO_SCORE_FOUND": "No Score found",
		"MOCK_LIST": "Computer-Based Testing Mock Exams",
		"PRINT_Q_MOCK": "Questions",
		"PRINT_QA_MOCK": "Questions & Answers",
		"TIME_LEFT": "Time Left",
		"FLAG_THIS_QUESTION": "Flag to review later",
		"UNFLAG_THIS_QUESTION": "Unflag question",
		"SECTION_REVIEW": "Section Review",
		"FILTER_BY": "Filter by",
		"CLEAR": "Clear",
		"DELETE_TEST": "Delete Test",
		"VIEW_TEST": "View Test",
		"NO_MOCK_EXAM_FOUND": "No Test Found",
		"INTROTITLE": "Tutorial Introduction",
		"INTROPARA": "<p>The following screens provide a tutorial of the exam software. This will help you become familiar with the software features and is not intended to be a mock exam. This same tutorial will be available to you on exam day. Before attempting any exam questions, take a few minutes to review the tutorial.</p><p>After completing and reviewing the sample exam questions, click the 'Finish Section' button in the top-right corner of the screen.</p><p>Once clicked, a pop-up window will appear confirming that you want to finish the section. Click 'Yes' to submit your answers or 'No' to return to the test.</p><p>Please note that once you finish the section you may not return to the sample exam questions. Any questions that are unanswered or incorrect will not count against your final score.</p>",
		"NEXTTOCONTINUE": "To begin the tutorial, click 'Next' to continue",
		"WELCOMETITLE": "Welcome to the Tutorial",
		"WELCOMEPARA": "<p>This tutorial provides a series of screens that orient you to the computer testing environment. You will be instructed on how to use the mouse and the different parts of the screen.</p><p> Notice the timer at the top of the screen. A similar display will appear during the actual exam. To the left of the screen is a numbered list that shows you where you are in the series of examination questions (or in this case, screens of the tutorial). Other screen features are described later in the tutorial.</p>",
		"NEXTBUTTONCONTINUE": "Click the 'Next' button to continue.",
		"USEMOUSETITLE": "Using the Mouse",
		"USEMOUSEPARA": "<p>The mouse pointer moves when you move the mouse around on a surface. Although it can assume different shapes, the arrow shown above is most common. To point with the mouse, move the pointer until it rests on the desired object. To click on an object, point to it and then quickly press and release the left mouse button.</p>",
		"NAVIGATTITLE": "Navigating Through the Exam",
		"NAVIGATPARA": "<p>Click the <b>'Next'</b> button displayed at the bottom of the screen to move to the next screen or question. Click the <b>'Back'</b> button to move to the previous screen or question.</p><p> In addition to the navigation buttons, you can use the numbered buttons displayed on the left side of the screen. Depending on the number of questions in the section, you may need to click on the down arrow to navigate to additional questions.</p>",
		"NAVIGATBUTTONINFO": "<p>The numbered buttons change appearance to indicate different question states: Current, Attempted, Unattempted, and Flagged.</p><ul><li>The current question will be indicated by an arrow-shaped numbered button.</li><li>For all attempted questions, the numbered button will appear darker in color.</li><li>For all unattempted questions, the numbered button will remain the original color.</li><li>Flagged questions will show a flag icon on the numbered button.</li></ul>",
		"TIMEREMAINTITLE": "Time Remaining",
		"TIMEREMAINPARAONE": "<p>The amount of time remaining is displayed at the right of the screen.</p>",
		"TIMEREMAINPARATWO": "<p>Each section of this examination is allocated a specific amount of time, including the Tutorial and Survey. There is also an overall amount of time provided for your full exam appointment. Clicking on the clock will switch between the amount of time remaining in the current section of the exam and the amount of overall time remaining for the full exam appointment.</p><p>The most important time display for you as a test taker is the 'Section Time Remaining.'</p><p>Note that, where applicable, an alert box will appear below the exam clock to signal when 30 minutes, 15 minutes, and 5 minutes remain in the current section.</p>",
		"FLAGTITLE": "Flagging Questions",
		"FLAGPARA": "<p>You can flag a question as a reminder to go back and check your answer or attempt it later. To flag a question, click the <b>'Flag'</b> button displayed at the bottom of the exam screen.</p><p>Any questions that are flagged for review will show a flag icon on the numbered button, as shown below.</p>",
		"FLAGBUTTON": "<p>Click the <b>'Flag'</b> button again to remove the flag.</p>",
		"ANSWERMULTTITLE": "Answering Multiple-Choice Questions",
		"ANSWERMULTPARA": "<p>This examination uses multiple-choice questions. This type of question has one correct answer.</p><p>To complete each multiple-choice question, click on the option that you believe to be the single best answer. Once selected, the option will appear darker in color. To change your response, click on a different option. If you would like to unselect a chosen option, click on it a second time.</p><p><b>Practice answering the multiple-choice question below. Once you have finished practicing, click the 'Next' button to continue.</b></p>",
		"QUESMULTTITLE": "Tallinn is the capital of which country?",
		"ESTONIA": "Estonia",
		"UKRAINE": "Ukraine",
		"BELGIUM": "Belgium",
		"REVIEWTITLE": "Section Review",
		"REVIEWPARA": "<p>During the examination, you can review the status of all questions in a current exam section using the grid icon located in the bottom left corner of the exam screen:</p>",
		"REVIEWPARACLOSE": "<p>To navigate directly to a question, click the corresponding numbered icon. You may also filter your view by unattempted, attempted, and flagged questions. The Section Review can be closed using the <b>'X'</b> icon.</p>",
		"ENDINGEXAMTITLE": "Ending Exam Sections",
		"ENDINGEXAMPARA": "<p>After completing and reviewing all of the questions within a section, you can navigate to the next section by clicking the <b>'Finish Section'</b> button in the top-right corner of the screen. Once clicked, a pop-up window will appear confirming you want to finish the section. Select 'Yes, I would like to finish this section' to submit your answers for that  section and progress to the next section.</p><p>The final section of the test is a short survey. Once you have completed the survey, you can end your session by clicking the <b>'Finish Test'</b> button in the top-right corner of the screen and confirming you would like to finish the test.</p><p>Please note that once you leave a section, you may not return. Any questions that are unanswered or incorrect will not count against your final score.</p>",
		"TUTORIALCONCLUSIONTITLE": "Tutorial Conclusion",
		"TUTORIALCONCLUSIONPARA": "<p>This concludes the tutorial. You can review the tutorial by clicking on the <b>'Back'</b> button to back up one screen at a time, or by using the numbered buttons displayed on the left side of the screen. You may view the tutorial at any point during the examination by clicking on the question mark icon. This icon can be found in the bottom left of the screen once you have begun testing.</p><p>Good luck with the examination.</p>",
		"CLICKSTARTTEST": "Click the 'Start the Test' button to exit the tutorial and begin the examination.",
		"NOT_ATTEMPTED": "Not Attempted",
		"START_TEST": "Start the Test",
		"Incorrect": "Incorrect",
		"Correct": "Correct",
		"TOPIC_WISE_SCORE": "Topic Wise Score",
		"You_Scored": "You Scored",
		"SHOW_MYSCORE": "Show my score by topic",
		"SHOW_GRAPH": "Show my graph",
		"ARE_YOU_SURE_FINISH": "Are you sure you would like to finish the test?",
		"FLAG_POPUP_TEXT": "Some of the questions in this test have been flagged. Are you sure  you would like to finish?",
		"I_ACCEPT_THE_TERMS": "I accept these terms.",
		"NOT_ATTEMPTED_POPUP": "You have not attempted all of the questions on this test.",
		"CHANGE_MOCK": "Change Mock",
		"CBT_MOCK_INSTRUCTIONS_FRM": "At the test center before beginning the exam you must agree to terms in the Candidate Agreement. If you do not accept the terms, you will not be permitted to test and must exit the exam. Your enrollment and/or registration fees are non-refundable and non-transferrable.<br/><br/>By checking the box <strong>I accept these terms</strong/> and clicking <strong>Continue</strong> you affirm that you accept the terms of this agreement and want to proceed into the exam. If you do not accept the terms of this agreement, you must click the <strong>Exit</strong> button and the exam will terminate.",
		"BOOK": "Book",
		"Hours_of_Video_Lessons_30": "30+ Hours of Video Lessons for each Part",
		"Practice_Questions_2000": "2,000 Practice Questions for each Part",
		"SHOW_MYSCORE_Book": "Show my score by book",
		"BOOK_WISE_SCORE": "Book Wise Score",
		"Essential_Summaries": "Essential Summaries",
		"Formula_Sheet": "Formula Sheet",
		"Ratio_Sheet": "Ratio Sheet",
		"Additional_Resources": "Additional Resources",
		"Save_and_Take_Break": "Save and Take a Break",
		"RESUME": "Resume",
		"Section_Introduction": "Section Introduction",
		"Study_Notes": "Study Notes",
		"Click_me_to_highlight": "Click to highlight",
		"Click_me_to_unhighlight": "Click to unhighlight",
		"Strike_Through": "Strikethrough",
		"Correct_Choice": "Mark as correct answer",
		"Incomplete": "Incomplete",
		"HIGHLIGHTINGTEXT": "Highlighting Text",
		"HIGHLIGHTINGPARA": "<p>During the examination, you will be able to highlight question text that you feel is important to refer back to as you progress through the exam. The highlight will remain present as you navigate through the exam, unless you select to remove it.</p><p>To highlight text, click and drag the mouse cursor over the desired text. Click the <b>'Highlight'</b> button, as shown in the image below, that appears after releasing the mouse button. To remove the highlight, click on any area of the highlighted text.</p>",
		"PLEASENOTE": "<p>Please note the highlight feature cannot be applied to text within the answer options.</p>",
		"STRIKINGOUTOPTIONS": "Striking Out Options",
		"STRIKINGOUTOPTIONSPARA": "<p>During the examination, a Strikeout feature is available to help you visually eliminate possible options from consideration. A struck out option will remain present as you progress through the exam, unless you select to remove it.</p><p>Right-click on an option to strike it out. Right-click again to remove the strikeout. Left-click on a struck out option to select it as your response. You may strike out as many or as few items as you like.</p><p><b>Practice using the Strikeout feature below. Once you have finished practicing, click the 'Next' button to continue.</b></p><p>What bird has the largest wingspan of any existing species?</p>",
		"PAUSEEXAM": "Pause Exam",
		"PAUSEEXAMPARA": "<p>While attempting exam you can also pause it for a while to go for a tea break. <b>Once you resume exam the time will be stopped</b>.</p>",
		"Privacy_Policy": "Privacy Policy",
		"PRACTICE_EXAMS": "Practice Exams",
		"PRINT_CASES_QA_MOCK": "Questions & Answers",
		"PRINT_CASES_Q_MOCK": "Questions",
		"Hours_of_Video_Lessons_35": "35+ Hours of Video Lessons",
		"Quant_Questions": "Quant Questions",
		"Verbal_Questions": "Verbal Questions",
		"Integrated_Reasoning_Questions": "Integrated Reasoning Questions",
		"Advanced_Analytics_Dashboard": "Advanced Analytics Dashboard",
		"AskATutor_Questions": "Ask-A-Tutor Questions",
		"SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS": "Subscribe for 1,000 practice questions",
		"VERBAL_PROBLEM": "Verbal Problems",
		"INTEGRATED_REASONING_QUESTIONS": "Integrated Reasoning Questions",
		"PERFORMANCE_BY_AREA": "Performance by Area",
		"QUANT_PROBLEM": "Quantitative Problems",
		"Change_Questions": "Change Question",
		"ESG": "ESG",
		"NAVIGATBUTTONINFOONFINISH": "<p>The numbered buttons change appearance to indicate different answer states: Wrong Answer, Correct Answer, Unanswered and Marks in between 0 and max grade.</p><ul><li>The current answer will be indicated by an arrow-shaped numbered button.</li><li>For all correct answered question, the numbered button will appear in green color.</li><li>For all incorrect answered question, the numbered button will appear in red color.</li><li>For in between 0 to max grading answered question, the numbered button will appear in yellow color.</li><li>For all unattempted questions, the numbered button will remain the original color.</li><li>Flagged questions will show a flag icon on the numbered button.</li></ul>",
		"VIEW_PDF": "View PDF",
		"AMOUNT": "Amount",
		"RENEWAL_DATE": "Renewal Date",
		"RECURRING_SUBSCRIPTION_DETAIL": "Recurring Subscription Details"
	};

/***/ },
/* 1054 */
/***/ function(module, exports) {

	module.exports = {
		"version": "1.0.1x0055"
	};

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1244);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 1056 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(497)(module)))

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	var EMPTY_OBJECT = {};
	Object.freeze(EMPTY_OBJECT);
	var mockGlobal = {};
	function getGlobal() {
	    if (typeof window !== "undefined") {
	        return window;
	    }
	    if (typeof global !== "undefined") {
	        return global;
	    }
	    if (typeof self !== "undefined") {
	        return self;
	    }
	    return mockGlobal;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail(message) {
	    invariant(false, message);
	    throw "X"; // unreachable
	}
	function invariant(check, message) {
	    if (!check)
	        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg, thing) {
	    if (thing) {
	        return deprecated("'" + msg + "', use '" + thing + "' instead.");
	    }
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function convertToMap(dataStructure) {
	    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
	        return dataStructure;
	    }
	    else if (Array.isArray(dataStructure)) {
	        return new Map(dataStructure);
	    }
	    else if (isPlainObject(dataStructure)) {
	        var map = new Map();
	        for (var key in dataStructure) {
	            map.set(key, dataStructure[key]);
	        }
	        return map;
	    }
	    else {
	        return fail("Cannot convert to map from '" + dataStructure + "'");
	    }
	}
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    if ( !isPropertyConfigurable(object, prop))
	        fail("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
	        return true;
	    return false;
	}
	function isES6Set(thing) {
	    return thing instanceof Set;
	}
	// use Array.from in Mobx 5
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    // es-disable-next-line
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	// Use "for of" in V5
	function forOf(iter, callback) {
	    var next = iter.next();
	    while (!next.done) {
	        callback(next.value);
	        next = iter.next();
	    }
	}
	
	function iteratorSymbol() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	function makeIterable(iterator) {
	    iterator[iteratorSymbol()] = getSelf;
	    return iterator;
	}
	function toStringTagSymbol() {
	    return (typeof Symbol === "function" && Symbol.toStringTag) || "@@toStringTag";
	}
	function getSelf() {
	    return this;
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var Atom = /** @class */ (function () {
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function Atom(name) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        this.name = name;
	        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	        this.isBeingObserved = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	    }
	    Atom.prototype.onBecomeUnobserved = function () {
	        // noop
	    };
	    Atom.prototype.onBecomeObserved = function () {
	        /* noop */
	    };
	    /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     * Returns true if there is currently a reactive context.
	     */
	    Atom.prototype.reportObserved = function () {
	        return reportObserved(this);
	    };
	    /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	    Atom.prototype.reportChanged = function () {
	        startBatch();
	        propagateChanged(this);
	        endBatch();
	    };
	    Atom.prototype.toString = function () {
	        return this.name;
	    };
	    return Atom;
	}());
	var isAtom = createInstanceofPredicate("Atom", Atom);
	function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	    var atom = new Atom(name);
	    onBecomeObserved(atom, onBecomeObservedHandler);
	    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
	    return atom;
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function shallowComparer(a, b) {
	    return deepEqual(a, b, 1);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer,
	    shallow: shallowComparer
	};
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	var enumerableDescriptorCache = {};
	var nonEnumerableDescriptorCache = {};
	function createPropertyInitializerDescriptor(prop, enumerable) {
	    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
	    return (cache[prop] ||
	        (cache[prop] = {
	            configurable: true,
	            enumerable: enumerable,
	            get: function () {
	                initializeInstance(this);
	                return this[prop];
	            },
	            set: function (value) {
	                initializeInstance(this);
	                this[prop] = value;
	            }
	        }));
	}
	function initializeInstance(target) {
	    if (target.__mobxDidRunLazyInitializers === true)
	        return;
	    var decorators = target.__mobxDecorators;
	    if (decorators) {
	        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
	        for (var key in decorators) {
	            var d = decorators[key];
	            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
	        }
	    }
	}
	function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
	    return function decoratorFactory() {
	        var decoratorArguments;
	        var decorator = function decorate(target, prop, descriptor, applyImmediately
	        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
	        // as the instance to apply the decorator to equals the target
	        ) {
	            if (applyImmediately === true) {
	                propertyCreator(target, prop, descriptor, target, decoratorArguments);
	                return null;
	            }
	            if ( !quacksLikeADecorator(arguments))
	                fail("This function is a decorator, but it wasn't invoked like a decorator");
	            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
	                var inheritedDecorators = target.__mobxDecorators;
	                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
	            }
	            target.__mobxDecorators[prop] = {
	                prop: prop,
	                propertyCreator: propertyCreator,
	                descriptor: descriptor,
	                decoratorTarget: target,
	                decoratorArguments: decoratorArguments
	            };
	            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
	        };
	        if (quacksLikeADecorator(arguments)) {
	            // @decorator
	            decoratorArguments = EMPTY_ARRAY;
	            return decorator.apply(null, arguments);
	        }
	        else {
	            // @decorator(args)
	            decoratorArguments = Array.prototype.slice.call(arguments);
	            return decorator;
	        }
	    };
	}
	function quacksLikeADecorator(args) {
	    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
	        (args.length === 4 && args[3] === true));
	}
	
	function deepEnhancer(v, _, name) {
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, { name: name });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name });
	    if (isES6Map(v))
	        return observable.map(v, { name: name });
	    if (isES6Set(v))
	        return observable.set(v, { name: name });
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.array(v, { name: name, deep: false });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name, deep: false });
	    if (isES6Map(v))
	        return observable.map(v, { name: name, deep: false });
	    if (isES6Set(v))
	        return observable.set(v, { name: name, deep: false });
	    return fail(
	        "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if ( isObservable(v))
	        throw "observable.struct should not be used with observable values";
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    invariant(enhancer);
	    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
	        {
	            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
	        }
	        var initialValue = descriptor
	            ? descriptor.initializer
	                ? descriptor.initializer.call(target)
	                : descriptor.value
	            : undefined;
	        defineObservableProperty(target, propertyName, initialValue, enhancer);
	    });
	    var res = 
	    // Extra process checks, as this happens during module initialization
	    typeof process !== "undefined" && ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}) && "development" !== "production"
	        ? function observableDecorator() {
	            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
	            // and simply return the created prop decorator
	            if (arguments.length < 2)
	                return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
	            return decorator.apply(null, arguments);
	        }
	        : decorator;
	    res.enhancer = enhancer;
	    return res;
	}
	
	// Predefined bags of create observable options, to avoid allocating temporarily option objects
	// in the majority of cases
	var defaultCreateObservableOptions = {
	    deep: true,
	    name: undefined,
	    defaultDecorator: undefined
	};
	var shallowCreateObservableOptions = {
	    deep: false,
	    name: undefined,
	    defaultDecorator: undefined
	};
	Object.freeze(defaultCreateObservableOptions);
	Object.freeze(shallowCreateObservableOptions);
	function assertValidOption(key) {
	    if (!/^(deep|name|equals|defaultDecorator)$/.test(key))
	        fail("invalid option for (extend)observable: " + key);
	}
	function asCreateObservableOptions(thing) {
	    if (thing === null || thing === undefined)
	        return defaultCreateObservableOptions;
	    if (typeof thing === "string")
	        return { name: thing, deep: true };
	    {
	        if (typeof thing !== "object")
	            return fail("expected options object");
	        Object.keys(thing).forEach(assertValidOption);
	    }
	    return thing;
	}
	function getEnhancerFromOptions(options) {
	    return options.defaultDecorator
	        ? options.defaultDecorator.enhancer
	        : options.deep === false
	            ? referenceEnhancer
	            : deepEnhancer;
	}
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v, arg2, arg3) {
	    // @observable someProp;
	    if (typeof arguments[1] === "string") {
	        return deepDecorator.apply(null, arguments);
	    }
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = isPlainObject(v)
	        ? observable.object(v, arg2, arg3)
	        : Array.isArray(v)
	            ? observable.array(v, arg2)
	            : isES6Map(v)
	                ? observable.map(v, arg2)
	                : isES6Set(v)
	                    ? observable.set(v, arg2)
	                    : v;
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    fail(
	        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
	}
	var observableFactories = {
	    box: function (value, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        var o = asCreateObservableOptions(options);
	        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
	        return observable.box(value, { name: name, deep: false });
	    },
	    array: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        var o = asCreateObservableOptions(options);
	        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
	        return observable.array(initialValues, { name: name, deep: false });
	    },
	    map: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        var o = asCreateObservableOptions(options);
	        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
	        return observable.map(initialValues, { name: name, deep: false });
	    },
	    set: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("set");
	        var o = asCreateObservableOptions(options);
	        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    object: function (props, decorators, options) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("object");
	        var o = asCreateObservableOptions(options);
	        return extendObservable({}, props, decorators, o);
	    },
	    shallowObject: function (props, name) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("shallowObject");
	        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
	        return observable.object(props, {}, { name: name, deep: false });
	    },
	    ref: refDecorator,
	    shallow: shallowDecorator,
	    deep: deepDecorator,
	    struct: refStructDecorator
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	function incorrectlyUsedAsDecorator(methodName) {
	    fail(
	    // "development" !== "production" &&
	    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
	    {
	        invariant(descriptor && descriptor.get, "Trying to declare a computed value for unspecified getter '" + propertyName + "'");
	    }
	    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
	    // Optimization: faster on decorator target or instance? Assuming target
	    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
	    // Forcing instance now, fixes hot reloadig issues on React Native:
	    var options = decoratorArgs[0] || {};
	    defineComputedProperty(instance, propertyName, __assign({ get: get, set: set }, options));
	});
	var computedStructDecorator = computedDecorator({ equals: comparer.structural });
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        // @computed
	        return computedDecorator.apply(null, arguments);
	    }
	    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
	        // @computed({ options })
	        return computedDecorator.apply(null, arguments);
	    }
	    // computed(expr, options?)
	    {
	        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
	        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
	    }
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.get = arg1;
	    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
	    opts.name = opts.name || arg1.name || ""; /* for generated name */
	    return new ComputedValue(opts);
	};
	computed.struct = computedStructDecorator;
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            // state propagation can occur outside of action/reactive context #2195
	            var prevAllowStateReads = allowStateReadsStart(true);
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    if (globalState.disableErrorBoundaries) {
	                        obj.get();
	                    }
	                    else {
	                        try {
	                            obj.get();
	                        }
	                        catch (e) {
	                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                            untrackedEnd(prevUntracked);
	                            allowStateReadsEnd(prevAllowStateReads);
	                            return true;
	                        }
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    // invariantShouldCompute(derivation)
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        allowStateReadsEnd(prevAllowStateReads);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            allowStateReadsEnd(prevAllowStateReads);
	            return false;
	        }
	    }
	}
	// function invariantShouldCompute(derivation: IDerivation) {
	//     const newDepState = (derivation as any).dependenciesState
	//     if (
	//         "development" === "production" &&
	//         (newDepState === IDerivationState.POSSIBLY_STALE ||
	//             newDepState === IDerivationState.NOT_TRACKING)
	//     )
	//         fail("Illegal dependency state")
	// }
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers)
	        fail(
	            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict"))
	        fail(
	            (globalState.enforceActions
	                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
	                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
	                atom.name);
	}
	function checkIfStateReadsAreAllowed(observable) {
	    if (
	        !globalState.allowStateReads &&
	        globalState.observableRequiresReaction) {
	        console.warn("[mobx] Observable " + observable.name + " being read outside a reactive context");
	    }
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    var prevAllowStateReads = allowStateReadsStart(true);
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    if (globalState.disableErrorBoundaries === true) {
	        result = f.call(context);
	    }
	    else {
	        try {
	            result = f.call(context);
	        }
	        catch (e) {
	            result = new CaughtException(e);
	        }
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    if (derivation.observing.length === 0) {
	        warnAboutDerivationWithoutDependencies(derivation);
	    }
	    allowStateReadsEnd(prevAllowStateReads);
	    return result;
	}
	function warnAboutDerivationWithoutDependencies(derivation) {
	    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
	        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
	    }
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	function allowStateReadsStart(allowStateReads) {
	    var prev = globalState.allowStateReads;
	    globalState.allowStateReads = allowStateReads;
	    return prev;
	}
	function allowStateReadsEnd(prev) {
	    globalState.allowStateReads = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	// we don't use globalState for these in order to avoid possible issues with multiple
	// mobx versions
	var currentActionId = 0;
	var nextActionId = 1;
	var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () { }, "name");
	var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
	function createAction(actionName, fn) {
	    {
	        invariant(typeof fn === "function", "`action` can only be invoked on functions");
	        if (typeof actionName !== "string" || !actionName)
	            fail("actions should have valid names, got: '" + actionName + "'");
	    }
	    var res = function () {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    {
	        if (isFunctionNameConfigurable) {
	            Object.defineProperty(res, "name", { value: actionName });
	        }
	    }
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = _startAction(actionName, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    catch (err) {
	        runInfo.error = err;
	        throw err;
	    }
	    finally {
	        _endAction(runInfo);
	    }
	}
	function _startAction(actionName, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    var prevAllowStateReads = allowStateReadsStart(true);
	    var runInfo = {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        prevAllowStateReads: prevAllowStateReads,
	        notifySpy: notifySpy,
	        startTime: startTime,
	        actionId: nextActionId++,
	        parentActionId: currentActionId
	    };
	    currentActionId = runInfo.actionId;
	    return runInfo;
	}
	function _endAction(runInfo) {
	    if (currentActionId !== runInfo.actionId) {
	        fail("invalid action stack. did you forget to finish an action?");
	    }
	    currentActionId = runInfo.parentActionId;
	    if (runInfo.error !== undefined) {
	        globalState.suppressReactionErrors = true;
	    }
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    allowStateReadsEnd(runInfo.prevAllowStateReads);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy) {
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	    }
	    globalState.suppressReactionErrors = false;
	}
	function allowStateChanges(allowStateChanges, func) {
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	function allowStateChangesInsideComputed(func) {
	    var prev = globalState.computationDepth;
	    globalState.computationDepth = 0;
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        globalState.computationDepth = prev;
	    }
	    return res;
	}
	
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy, equals) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        if (equals === void 0) { equals = comparer.default; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.name = name;
	        _this.equals = equals;
	        _this.hasUnreportedChange = false;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== globalState.UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    name: this.name,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return globalState.UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(Atom));
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce a new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(options) {
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isBeingObserved = false;
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        invariant(options.get, "missing option for computed: get");
	        this.derivation = options.get;
	        this.name = options.name || "ComputedValue@" + getNextId();
	        if (options.set)
	            this.setter = createAction(this.name + "-setter", options.set);
	        this.equals =
	            options.equals ||
	                (options.compareStructural || options.struct
	                    ? comparer.structural
	                    : comparer.default);
	        this.scope = options.context;
	        this.requiresReaction = !!options.requiresReaction;
	        this.keepAlive = !!options.keepAlive;
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () { };
	    ComputedValue.prototype.onBecomeObserved = function () { };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        if (this.isComputing)
	            fail("Cycle detected in computation " + this.name + ": " + this.derivation);
	        if (globalState.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
	            if (shouldCompute(this)) {
	                this.warnAboutUntrackedRead();
	                startBatch(); // See perf test 'computed memoization'
	                this.value = this.computeValue(false);
	                endBatch();
	            }
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, 
	                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                name: this.name
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = this.computeValue(true);
	        var changed = wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue);
	        if (changed) {
	            this.value = newValue;
	        }
	        return changed;
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            if (globalState.disableErrorBoundaries === true) {
	                res = this.derivation.call(this.scope);
	            }
	            else {
	                try {
	                    res = this.derivation.call(this.scope);
	                }
	                catch (e) {
	                    res = new CaughtException(e);
	                }
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.suspend = function () {
	        if (!this.keepAlive) {
	            clearObserving(this);
	            this.value = undefined; // don't hold on to computed value!
	        }
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.warnAboutUntrackedRead = function () {
	        if (this.requiresReaction === true) {
	            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
	        }
	        if (this.isTracing !== TraceMode.NONE) {
	            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
	        }
	        if (globalState.computedRequiresReaction) {
	            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
	        }
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ComputedValue;
	}());
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = [
	    "mobxGuid",
	    "spyListeners",
	    "enforceActions",
	    "computedRequiresReaction",
	    "reactionRequiresObservable",
	    "observableRequiresReaction",
	    "allowStateReads",
	    "disableErrorBoundaries",
	    "runId",
	    "UNCHANGED"
	];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         *
	         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
	         * internal state storage of MobX, and can be the same across many different package versions
	         */
	        this.version = 5;
	        /**
	         * globally unique token to signal unchanged
	         */
	        this.UNCHANGED = {};
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * Is it allowed to read observables at this point?
	         * Used to hold the state needed for `observableRequiresReaction`
	         */
	        this.allowStateReads = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.enforceActions = false;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	        /**
	         * Warn if computed values are accessed outside a reactive context
	         */
	        this.computedRequiresReaction = false;
	        /**
	         * (Experimental)
	         * Warn if you try to create to derivation / reactive context without accessing any observable.
	         */
	        this.reactionRequiresObservable = false;
	        /**
	         * (Experimental)
	         * Warn if observables are accessed outside a reactive context
	         */
	        this.observableRequiresReaction = false;
	        /**
	         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
	         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
	         */
	        this.computedConfigurable = false;
	        /*
	         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
	         * the stack when an exception occurs while debugging.
	         */
	        this.disableErrorBoundaries = false;
	        /*
	         * If true, we are already handling an exception in an action. Any errors in reactions should be supressed, as
	         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
	         */
	        this.suppressReactionErrors = false;
	    }
	    return MobXGlobals;
	}());
	var canMergeGlobalState = true;
	var isolateCalled = false;
	var globalState = (function () {
	    var global = getGlobal();
	    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
	        canMergeGlobalState = false;
	    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
	        canMergeGlobalState = false;
	    if (!canMergeGlobalState) {
	        setTimeout(function () {
	            if (!isolateCalled) {
	                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
	            }
	        }, 1);
	        return new MobXGlobals();
	    }
	    else if (global.__mobxGlobals) {
	        global.__mobxInstanceCount += 1;
	        if (!global.__mobxGlobals.UNCHANGED)
	            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
	        return global.__mobxGlobals;
	    }
	    else {
	        global.__mobxInstanceCount = 1;
	        return (global.__mobxGlobals = new MobXGlobals());
	    }
	})();
	function isolateGlobalState() {
	    if (globalState.pendingReactions.length ||
	        globalState.inBatch ||
	        globalState.isRunningReactions)
	        fail("isolateGlobalState should be called before MobX is running any reactions");
	    isolateCalled = true;
	    if (canMergeGlobalState) {
	        if (--getGlobal().__mobxInstanceCount === 0)
	            getGlobal().__mobxGlobals = undefined;
	        globalState = new MobXGlobals();
	    }
	}
	function getGlobalState() {
	    return globalState;
	}
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.enforceActions;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	// function invariantObservers(observable: IObservable) {
	//     const list = observable.observers
	//     const map = observable.observersIndexes
	//     const l = list.length
	//     for (let i = 0; i < l; i++) {
	//         const id = list[i].__mapid
	//         if (i) {
	//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
	//         } else {
	//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
	//         }
	//     }
	//     invariant(
	//         list.length === 0 || Object.keys(map).length === list.length - 1,
	//         "INTERNAL ERROR there is no junk in map"
	//     )
	// }
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (observable.isPendingUnobservation === false) {
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                if (observable.isBeingObserved) {
	                    // if this observable had reactive observers, trigger the hooks
	                    observable.isBeingObserved = false;
	                    observable.onBecomeUnobserved();
	                }
	                if (observable instanceof ComputedValue) {
	                    // computed values are automatically teared down when the last observer leaves
	                    // this process happens recursively, this computed might be the last observable of another, etc..
	                    observable.suspend();
	                }
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    checkIfStateReadsAreAllowed(observable);
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	            if (!observable.isBeingObserved) {
	                observable.isBeingObserved = true;
	                observable.onBecomeObserved();
	            }
	        }
	        return true;
	    }
	    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
	        queueForUnobservation(observable);
	    }
	    return false;
	}
	// function invariantLOS(observable: IObservable, msg: string) {
	//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
	//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
	//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
	//     throw new Error(
	//         "lowestObserverState is wrong for " +
	//             msg +
	//             " because " +
	//             min +
	//             " < " +
	//             observable.lowestObserverState
	//     )
	// }
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        if (requiresObservable === void 0) { requiresObservable = false; }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.errorHandler = errorHandler;
	        this.requiresObservable = requiresObservable;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                try {
	                    this.onInvalidate();
	                    if (this._isTrackPending && isSpyEnabled()) {
	                        // onInvalidate didn't trigger track right away..
	                        spyReport({
	                            name: this.name,
	                            type: "scheduled-reaction"
	                        });
	                    }
	                }
	                catch (e) {
	                    this.reportExceptionInDerivation(e);
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                name: this.name,
	                type: "reaction"
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        if (globalState.disableErrorBoundaries)
	            throw error;
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
	        if (globalState.suppressReactionErrors) {
	            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
	        }
	        else {
	            console.error(message, error);
	            /** If debugging brought you here, please, read the above message :-). Tnx! */
	        }
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                name: this.name,
	                message: message,
	                error: "" + error
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = __assign(__assign({}, event), { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(__assign(__assign({}, change), { spyReportEnd: true }));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
	    });
	}
	
	function dontReassignFields() {
	    fail( "@action fields are not reassignable");
	}
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor) {
	            if ( descriptor.get !== undefined) {
	                return fail("@action cannot be used with getters");
	            }
	            // babel / typescript
	            // @action method() { }
	            if (descriptor.value) {
	                // typescript
	                return {
	                    value: createAction(name, descriptor.value),
	                    enumerable: false,
	                    configurable: true,
	                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
	                };
	            }
	            // babel only: @action method = () => {}
	            var initializer_1 = descriptor.initializer;
	            return {
	                enumerable: false,
	                configurable: true,
	                writable: true,
	                initializer: function () {
	                    // N.B: we can't immediately invoke initializer; this would be wrong
	                    return createAction(name, initializer_1.call(this));
	                }
	            };
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function actionFieldDecorator(name) {
	    // Simple property that writes on first invocation to the current instance
	    return function (target, prop, descriptor) {
	        Object.defineProperty(target, prop, {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return undefined;
	            },
	            set: function (value) {
	                addHiddenProp(this, prop, action(name, value));
	            }
	        });
	    };
	}
	function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
	    if (applyToInstance === true) {
	        defineBoundAction(target, propertyName, descriptor.value);
	        return null;
	    }
	    if (descriptor) {
	        // if (descriptor.value)
	        // Typescript / Babel: @action.bound method() { }
	        // also: babel @action.bound method = () => {}
	        return {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
	                return this[propertyName];
	            },
	            set: dontReassignFields
	        };
	    }
	    // field decorator Typescript @action.bound method = () => {}
	    return {
	        enumerable: false,
	        configurable: true,
	        set: function (v) {
	            defineBoundAction(this, propertyName, v);
	        },
	        get: function () {
	            return undefined;
	        }
	    };
	}
	
	var action = function action(arg1, arg2, arg3, arg4) {
	    // action(fn() {})
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    // action("name", fn() {})
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    // @action("name") fn() {}
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    // @action fn() {}
	    if (arg4 === true) {
	        // apply to instance immediately
	        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
	    }
	    else {
	        return namedActionDecorator(arg2).apply(null, arguments);
	    }
	};
	action.bound = boundActionDecorator;
	function runInAction(arg1, arg2) {
	    // TODO: deprecate?
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    {
	        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
	        if (typeof actionName !== "string" || !actionName)
	            fail("actions should have valid names, got: '" + actionName + "'");
	    }
	    return executeAction(actionName, fn, this, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
	}
	
	/**
	 * Creates a named reactive view and keeps it alive, so that the view is always
	 * updated if one of the dependencies changes, even when the view is not further used by something else.
	 * @param view The reactive view
	 * @returns disposer function, which can be used to stop the view from being updated in the future.
	 */
	function autorun(view, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    {
	        invariant(typeof view === "function", "Autorun expects a function as first argument");
	        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
	    }
	    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
	    var runSync = !opts.scheduler && !opts.delay;
	    var reaction;
	    if (runSync) {
	        // normal autorun
	        reaction = new Reaction(name, function () {
	            this.track(reactionRunner);
	        }, opts.onError, opts.requiresObservable);
	    }
	    else {
	        var scheduler_1 = createSchedulerFromOptions(opts);
	        // debounced autorun
	        var isScheduled_1 = false;
	        reaction = new Reaction(name, function () {
	            if (!isScheduled_1) {
	                isScheduled_1 = true;
	                scheduler_1(function () {
	                    isScheduled_1 = false;
	                    if (!reaction.isDisposed)
	                        reaction.track(reactionRunner);
	                });
	            }
	        }, opts.onError, opts.requiresObservable);
	    }
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	var run = function (f) { return f(); };
	function createSchedulerFromOptions(opts) {
	    return opts.scheduler
	        ? opts.scheduler
	        : opts.delay
	            ? function (f) { return setTimeout(f, opts.delay); }
	            : run;
	}
	function reaction(expression, effect, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    if (typeof opts === "boolean") {
	        opts = { fireImmediately: opts };
	        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
	    }
	    {
	        invariant(typeof expression === "function", "First argument to reaction should be a function");
	        invariant(typeof opts === "object", "Third argument of reactions should be an object");
	    }
	    var name = opts.name || "Reaction@" + getNextId();
	    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
	    var runSync = !opts.scheduler && !opts.delay;
	    var scheduler = createSchedulerFromOptions(opts);
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.compareStructural
	        ? comparer.structural
	        : opts.equals || comparer.default;
	    var r = new Reaction(name, function () {
	        if (firstTime || runSync) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            scheduler(reactionRunner);
	        }
	    }, opts.onError, opts.requiresObservable);
	    function reactionRunner() {
	        isScheduled = false; // Q: move into reaction runner?
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effectAction(value, r);
	        if (!firstTime && changed === true)
	            effectAction(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function wrapErrorHandler(errorHandler, baseFn) {
	    return function () {
	        try {
	            return baseFn.apply(this, arguments);
	        }
	        catch (e) {
	            errorHandler.call(this, e);
	        }
	    };
	}
	
	function onBecomeObserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeObserved", thing, arg2, arg3);
	}
	function onBecomeUnobserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
	}
	function interceptHook(hook, thing, arg2, arg3) {
	    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
	    var cb = typeof arg3 === "function" ? arg3 : arg2;
	    var orig = atom[hook];
	    if (typeof orig !== "function")
	        return fail( "Not an atom that can be (un)observed");
	    atom[hook] = function () {
	        orig.call(this);
	        cb.call(this);
	    };
	    return function () {
	        atom[hook] = orig;
	    };
	}
	
	function configure(options) {
	    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
	    if (options.isolateGlobalState === true) {
	        isolateGlobalState();
	    }
	    if (enforceActions !== undefined) {
	        if (typeof enforceActions === "boolean" || enforceActions === "strict")
	            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
	        var ea = void 0;
	        switch (enforceActions) {
	            case true:
	            case "observed":
	                ea = true;
	                break;
	            case false:
	            case "never":
	                ea = false;
	                break;
	            case "strict":
	            case "always":
	                ea = "strict";
	                break;
	            default:
	                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
	        }
	        globalState.enforceActions = ea;
	        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
	    }
	    if (computedRequiresReaction !== undefined) {
	        globalState.computedRequiresReaction = !!computedRequiresReaction;
	    }
	    if (reactionRequiresObservable !== undefined) {
	        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
	    }
	    if (observableRequiresReaction !== undefined) {
	        globalState.observableRequiresReaction = !!observableRequiresReaction;
	        globalState.allowStateReads = !globalState.observableRequiresReaction;
	    }
	    if (computedConfigurable !== undefined) {
	        globalState.computedConfigurable = !!computedConfigurable;
	    }
	    if (disableErrorBoundaries !== undefined) {
	        if (disableErrorBoundaries === true)
	            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
	        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
	    }
	    if (typeof arrayBuffer === "number") {
	        reserveArrayBuffer(arrayBuffer);
	    }
	    if (reactionScheduler) {
	        setReactionScheduler(reactionScheduler);
	    }
	}
	
	function decorate(thing, decorators) {
	    if ( !isPlainObject(decorators))
	        fail("Decorators should be a key value map");
	    var target = typeof thing === "function" ? thing.prototype : thing;
	    var _loop_1 = function (prop) {
	        var propertyDecorators = decorators[prop];
	        if (!Array.isArray(propertyDecorators)) {
	            propertyDecorators = [propertyDecorators];
	        }
	        // prettier-ignore
	        if ( !propertyDecorators.every(function (decorator) { return typeof decorator === "function"; }))
	            fail("Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
	        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
	        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
	        if (newDescriptor)
	            Object.defineProperty(target, prop, newDescriptor);
	    };
	    for (var prop in decorators) {
	        _loop_1(prop);
	    }
	    return thing;
	}
	
	function extendShallowObservable(target, properties, decorators) {
	    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
	    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
	}
	function extendObservable(target, properties, decorators, options) {
	    {
	        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
	        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
	        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
	        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
	        if (decorators)
	            for (var key in decorators)
	                if (!(key in properties))
	                    fail("Trying to declare a decorator for unspecified property '" + key + "'");
	    }
	    options = asCreateObservableOptions(options);
	    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
	    initializeInstance(target);
	    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
	    startBatch();
	    try {
	        var keys = Object.getOwnPropertyNames(properties);
	        for (var i = 0, l = keys.length; i < l; i++) {
	            var key = keys[i];
	            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	            if (true) {
	                if (isComputed(descriptor.value))
	                    fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
	            }
	            var decorator = decorators && key in decorators
	                ? decorators[key]
	                : descriptor.get
	                    ? computedDecorator
	                    : defaultDecorator;
	            if ("development" !== "production" && typeof decorator !== "function")
	                return fail("Not a valid decorator for '" + key + "', got: " + decorator);
	            var resultDescriptor = decorator(target, key, descriptor, true);
	            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
	            )
	                Object.defineProperty(target, key, resultDescriptor);
	        }
	    }
	    finally {
	        endBatch();
	    }
	    return target;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	var generatorId = 0;
	function FlowCancellationError() {
	    this.message = "FLOW_CANCELLED";
	}
	FlowCancellationError.prototype = Object.create(Error.prototype);
	function isFlowCancellationError(error) {
	    return error instanceof FlowCancellationError;
	}
	function flow(generator) {
	    if (arguments.length !== 1)
	        fail( "Flow expects one 1 argument and cannot be used as decorator");
	    var name = generator.name || "<unnamed flow>";
	    // Implementation based on https://github.com/tj/co/blob/master/index.js
	    return function () {
	        var ctx = this;
	        var args = arguments;
	        var runId = ++generatorId;
	        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
	        var rejector;
	        var pendingPromise = undefined;
	        var res = new Promise(function (resolve, reject) {
	            var stepId = 0;
	            rejector = reject;
	            function onFulfilled(res) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function onRejected(err) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret && typeof ret.then === "function") {
	                    // an async iterator
	                    ret.then(next, reject);
	                    return;
	                }
	                if (ret.done)
	                    return resolve(ret.value);
	                pendingPromise = Promise.resolve(ret.value);
	                return pendingPromise.then(onFulfilled, onRejected);
	            }
	            onFulfilled(undefined); // kick off the process
	        });
	        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
	            try {
	                if (pendingPromise)
	                    cancelPromise(pendingPromise);
	                // Finally block can return (or yield) stuff..
	                var res_1 = gen.return(undefined);
	                // eat anything that promise would do, it's cancelled!
	                var yieldedPromise = Promise.resolve(res_1.value);
	                yieldedPromise.then(noop, noop);
	                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
	                // reject our original promise
	                rejector(new FlowCancellationError());
	            }
	            catch (e) {
	                rejector(e); // there could be a throwing finally block
	            }
	        });
	        return res;
	    };
	}
	function cancelPromise(promise) {
	    if (typeof promise.cancel === "function")
	        promise.cancel();
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail(
	                "InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail(
	            "Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail( "An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	function _isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	function isComputed(value) {
	    if (arguments.length > 1)
	        return fail(
	            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isComputed(value);
	}
	function isComputedProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail(
	            "isComputed expected a property name as second argument");
	    return _isComputed(value, propName);
	}
	
	function _isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (
	            (isObservableMap(value) || isObservableArray(value)))
	            return fail("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
	        if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value.$mobx ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	function isObservable(value) {
	    if (arguments.length !== 1)
	        fail(
	            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isObservable(value);
	}
	function isObservableProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail( "expected a property name as second argument");
	    return _isObservable(value, propName);
	}
	
	function keys(obj) {
	    if (isObservableObject(obj)) {
	        return obj.$mobx.getKeys();
	    }
	    if (isObservableMap(obj)) {
	        return iteratorToArray(obj.keys());
	    }
	    if (isObservableSet(obj)) {
	        return iteratorToArray(obj.keys());
	    }
	    if (isObservableArray(obj)) {
	        return obj.map(function (_, index) { return index; });
	    }
	    return fail(
	        "'keys()' can only be used on observable objects, arrays, sets and maps");
	}
	function values(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) { return obj[key]; });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) { return obj.get(key); });
	    }
	    if (isObservableSet(obj)) {
	        return iteratorToArray(obj.values());
	    }
	    if (isObservableArray(obj)) {
	        return obj.slice();
	    }
	    return fail(
	        "'values()' can only be used on observable objects, arrays, sets and maps");
	}
	function entries(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) { return [key, obj[key]]; });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
	    }
	    if (isObservableSet(obj)) {
	        return iteratorToArray(obj.entries());
	    }
	    if (isObservableArray(obj)) {
	        return obj.map(function (key, index) { return [index, key]; });
	    }
	    return fail(
	        "'entries()' can only be used on observable objects, arrays and maps");
	}
	function set(obj, key, value) {
	    if (arguments.length === 2 && !isObservableSet(obj)) {
	        startBatch();
	        var values_1 = key;
	        try {
	            for (var key_1 in values_1)
	                set(obj, key_1, values_1[key_1]);
	        }
	        finally {
	            endBatch();
	        }
	        return;
	    }
	    if (isObservableObject(obj)) {
	        var adm = obj.$mobx;
	        var existingObservable = adm.values[key];
	        if (existingObservable) {
	            adm.write(obj, key, value);
	        }
	        else {
	            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
	        }
	    }
	    else if (isObservableMap(obj)) {
	        obj.set(key, value);
	    }
	    else if (isObservableSet(obj)) {
	        obj.add(key);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        startBatch();
	        if (key >= obj.length)
	            obj.length = key + 1;
	        obj[key] = value;
	        endBatch();
	    }
	    else {
	        return fail(
	            "'set()' can only be used on observable objects, arrays and maps");
	    }
	}
	function remove(obj, key) {
	    if (isObservableObject(obj)) {
	        obj.$mobx.remove(key);
	    }
	    else if (isObservableMap(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableSet(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        obj.splice(key, 1);
	    }
	    else {
	        return fail(
	            "'remove()' can only be used on observable objects, arrays and maps");
	    }
	}
	function has(obj, key) {
	    if (isObservableObject(obj)) {
	        // return keys(obj).indexOf(key) >= 0
	        var adm = getAdministration(obj);
	        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
	        return !!adm.values[key];
	    }
	    else if (isObservableMap(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableSet(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableArray(obj)) {
	        return key >= 0 && key < obj.length;
	    }
	    else {
	        return fail(
	            "'has()' can only be used on observable objects, arrays and maps");
	    }
	}
	function get(obj, key) {
	    if (!has(obj, key))
	        return undefined;
	    if (isObservableObject(obj)) {
	        return obj[key];
	    }
	    else if (isObservableMap(obj)) {
	        return obj.get(key);
	    }
	    else if (isObservableArray(obj)) {
	        return obj[key];
	    }
	    else {
	        return fail(
	            "'get()' can only be used on observable objects, arrays and maps");
	    }
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	var defaultOptions = {
	    detectCycles: true,
	    exportMapsAsObjects: true,
	    recurseEverything: false
	};
	function cache(map, key, value, options) {
	    if (options.detectCycles)
	        map.set(key, value);
	    return value;
	}
	function toJSHelper(source, options, __alreadySeen) {
	    if (!options.recurseEverything && !isObservable(source))
	        return source;
	    if (typeof source !== "object")
	        return source;
	    // Directly return null if source is null
	    if (source === null)
	        return null;
	    // Directly return the Date object itself if contained in the observable
	    if (source instanceof Date)
	        return source;
	    if (isObservableValue(source))
	        return toJSHelper(source.get(), options, __alreadySeen);
	    // make sure we track the keys of the object
	    if (isObservable(source))
	        keys(source);
	    var detectCycles = options.detectCycles === true;
	    if (detectCycles && source !== null && __alreadySeen.has(source)) {
	        return __alreadySeen.get(source);
	    }
	    if (isObservableArray(source) || Array.isArray(source)) {
	        var res_1 = cache(__alreadySeen, source, [], options);
	        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
	        res_1.length = toAdd.length;
	        for (var i = 0, l = toAdd.length; i < l; i++)
	            res_1[i] = toAdd[i];
	        return res_1;
	    }
	    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
	        if (options.exportMapsAsObjects === false) {
	            var res_2 = cache(__alreadySeen, source, new Set(), options);
	            source.forEach(function (value) {
	                res_2.add(toJSHelper(value, options, __alreadySeen));
	            });
	            return res_2;
	        }
	        else {
	            var res_3 = cache(__alreadySeen, source, [], options);
	            source.forEach(function (value) {
	                res_3.push(toJSHelper(value, options, __alreadySeen));
	            });
	            return res_3;
	        }
	    }
	    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
	        if (options.exportMapsAsObjects === false) {
	            var res_4 = cache(__alreadySeen, source, new Map(), options);
	            source.forEach(function (value, key) {
	                res_4.set(key, toJSHelper(value, options, __alreadySeen));
	            });
	            return res_4;
	        }
	        else {
	            var res_5 = cache(__alreadySeen, source, {}, options);
	            source.forEach(function (value, key) {
	                res_5[key] = toJSHelper(value, options, __alreadySeen);
	            });
	            return res_5;
	        }
	    }
	    // Fallback to the situation that source is an ObservableObject or a plain object
	    var res = cache(__alreadySeen, source, {}, options);
	    for (var key in source) {
	        res[key] = toJSHelper(source[key], options, __alreadySeen);
	    }
	    return res;
	}
	function toJS(source, options) {
	    // backward compatibility
	    if (typeof options === "boolean")
	        options = { detectCycles: options };
	    if (!options)
	        options = defaultOptions;
	    options.detectCycles =
	        options.detectCycles === undefined
	            ? options.recurseEverything === true
	            : options.detectCycles === true;
	    var __alreadySeen;
	    if (options.detectCycles)
	        __alreadySeen = new Map();
	    return toJSHelper(source, options, __alreadySeen);
	}
	
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail(
	            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	function when(predicate, arg1, arg2) {
	    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
	        return whenPromise(predicate, arg1);
	    return _when(predicate, arg1, arg2 || {});
	}
	function _when(predicate, effect, opts) {
	    var timeoutHandle;
	    if (typeof opts.timeout === "number") {
	        timeoutHandle = setTimeout(function () {
	            if (!disposer.$mobx.isDisposed) {
	                disposer();
	                var error = new Error("WHEN_TIMEOUT");
	                if (opts.onError)
	                    opts.onError(error);
	                else
	                    throw error;
	            }
	        }, opts.timeout);
	    }
	    opts.name = opts.name || "When@" + getNextId();
	    var effectAction = createAction(opts.name + "-effect", effect);
	    var disposer = autorun(function (r) {
	        if (predicate()) {
	            r.dispose();
	            if (timeoutHandle)
	                clearTimeout(timeoutHandle);
	            effectAction();
	        }
	    }, opts);
	    return disposer;
	}
	function whenPromise(predicate, opts) {
	    if ( opts && opts.onError)
	        return fail("the options 'onError' and 'promise' cannot be combined");
	    var cancel;
	    var res = new Promise(function (resolve, reject) {
	        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), { onError: reject }));
	        cancel = function () {
	            disposer();
	            reject("WHEN_CANCELLED");
	        };
	    });
	    res.cancel = cancel;
	    return res;
	}
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */ (function () {
	    function StubArray() {
	    }
	    return StubArray;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.atom = new Atom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined && values.length > 0)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = EMPTY_ARRAY;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems =
	            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        var _a;
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray = /** @class */ (function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            var prev = allowStateChangesStart(true);
	            _this.spliceWithArray(0, 0, initialValues);
	            allowStateChangesEnd(prev);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = __spread(oldItems.slice(0, toIndex), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray));
	declareIterator(ObservableArray.prototype, function () {
	    this.$mobx.atom.reportObserved();
	    var self = this;
	    var nextIndex = 0;
	    return makeIterable({
	        next: function () {
	            return nextIndex < self.length
	                ? { value: self[nextIndex++], done: false }
	                : { done: true, value: undefined };
	        }
	    });
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	addHiddenProp(ObservableArray.prototype, toStringTagSymbol(), "Array");
	["indexOf", "join", "lastIndexOf", "slice", "toString", "toLocaleString"].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	[
	    "every",
	    "filter",
	    //"find", // implemented individually (IE support)
	    //"findIndex", // implemented individually (IE support)
	    //"flatMap", // not supported
	    "forEach",
	    "map",
	    "some"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function (callback, thisArg) {
	        var _this = this;
	        var adm = this.$mobx;
	        adm.atom.reportObserved();
	        var dehancedValues = adm.dehanceValues(adm.values);
	        return dehancedValues[funcName](function (element, index) {
	            return callback.call(thisArg, element, index, _this);
	        }, thisArg);
	    });
	});
	["reduce", "reduceRight"].forEach(function (funcName) {
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        var _this = this;
	        var adm = this.$mobx;
	        adm.atom.reportObserved();
	        // #2432 - reduce behavior depends on arguments.length
	        var callback = arguments[0];
	        arguments[0] = function (accumulator, currentValue, index) {
	            currentValue = adm.dehanceValue(currentValue);
	            return callback(accumulator, currentValue, index, _this);
	        };
	        return adm.values[funcName].apply(adm.values, arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._keysAtom = createAtom(this.name + ".keys()");
	        if (typeof Map !== "function") {
	            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
	        }
	        this._data = new Map();
	        this._hasMap = new Map();
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return this._data.has(key);
	    };
	    ObservableMap.prototype.has = function (key) {
	        var _this = this;
	        if (!globalState.trackingDerivation)
	            return this._has(key);
	        var entry = this._hasMap.get(key);
	        if (!entry) {
	            // todo: replace with atom (breaking change)
	            var newEntry = (entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false));
	            this._hasMap.set(key, newEntry);
	            onBecomeUnobserved(newEntry, function () { return _this._hasMap.delete(key); });
	        }
	        return entry.get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this._keysAtom);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data.get(key).value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            transaction(function () {
	                _this._keysAtom.reportChanged();
	                _this._updateHasMapEntry(key, false);
	                var observable = _this._data.get(key);
	                observable.setNewValue(undefined);
	                _this._data.delete(key);
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        var entry = this._hasMap.get(key);
	        if (entry) {
	            entry.setNewValue(value);
	        }
	    };
	    ObservableMap.prototype._updateValue = function (key, newValue) {
	        var observable = this._data.get(key);
	        newValue = observable.prepareNewValue(newValue);
	        if (newValue !== globalState.UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (key, newValue) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this._keysAtom);
	        transaction(function () {
	            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
	            _this._data.set(key, observable);
	            newValue = observable.value; // value might have been changed
	            _this._updateHasMapEntry(key, true);
	            _this._keysAtom.reportChanged();
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: key,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        if (this.has(key))
	            return this.dehanceValue(this._data.get(key).get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        this._keysAtom.reportObserved();
	        return this._data.keys();
	    };
	    ObservableMap.prototype.values = function () {
	        var self = this;
	        var keys = this.keys();
	        return makeIterable({
	            next: function () {
	                var _a = keys.next(), done = _a.done, value = _a.value;
	                return {
	                    done: done,
	                    value: done ? undefined : self.get(value)
	                };
	            }
	        });
	    };
	    ObservableMap.prototype.entries = function () {
	        var self = this;
	        var keys = this.keys();
	        return makeIterable({
	            next: function () {
	                var _a = keys.next(), done = _a.done, value = _a.value;
	                return {
	                    done: done,
	                    value: done ? undefined : [value, self.get(value)]
	                };
	            }
	        });
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this._keysAtom.reportObserved();
	        this._data.forEach(function (_, key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            var prev = allowStateChangesStart(true);
	            try {
	                if (isPlainObject(other))
	                    Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	                else if (Array.isArray(other))
	                    other.forEach(function (_a) {
	                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
	                        return _this.set(key, value);
	                    });
	                else if (isES6Map(other)) {
	                    if (other.constructor !== Map)
	                        fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
	                    else
	                        other.forEach(function (value, key) { return _this.set(key, value); });
	                }
	                else if (other !== null && other !== undefined)
	                    fail("Cannot initialize map from " + other);
	            }
	            finally {
	                allowStateChangesEnd(prev);
	            }
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                // Note we are concurrently reading/deleting the same keys
	                // forEach handles this properly
	                _this._data.forEach(function (_, key) { return _this.delete(key); });
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        // Implementation requirements:
	        // - respect ordering of replacement map
	        // - allow interceptors to run and potentially prevent individual operations
	        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
	        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
	        // - note that result map may differ from replacement map due to the interceptors
	        transaction(function () {
	            // Convert to map so we can do quick key lookups
	            var replacementMap = convertToMap(values);
	            var orderedData = new Map();
	            // Used for optimization
	            var keysReportChangedCalled = false;
	            // Delete keys that don't exist in replacement map
	            // if the key deletion is prevented by interceptor
	            // add entry at the beginning of the result map
	            forOf(_this._data.keys(), function (key) {
	                // Concurrently iterating/deleting keys
	                // iterator should handle this correctly
	                if (!replacementMap.has(key)) {
	                    var deleted = _this.delete(key);
	                    // Was the key removed?
	                    if (deleted) {
	                        // _keysAtom.reportChanged() was already called
	                        keysReportChangedCalled = true;
	                    }
	                    else {
	                        // Delete prevented by interceptor
	                        var value = _this._data.get(key);
	                        orderedData.set(key, value);
	                    }
	                }
	            });
	            // Merge entries
	            forOf(replacementMap.entries(), function (_a) {
	                var _b = __read(_a, 2), key = _b[0], value = _b[1];
	                // We will want to know whether a new key is added
	                var keyExisted = _this._data.has(key);
	                // Add or update value
	                _this.set(key, value);
	                // The addition could have been prevent by interceptor
	                if (_this._data.has(key)) {
	                    // The update could have been prevented by interceptor
	                    // and also we want to preserve existing values
	                    // so use value from _data map (instead of replacement map)
	                    var value_1 = _this._data.get(key);
	                    orderedData.set(key, value_1);
	                    // Was a new key added?
	                    if (!keyExisted) {
	                        // _keysAtom.reportChanged() was already called
	                        keysReportChangedCalled = true;
	                    }
	                }
	            });
	            // Check for possible key order change
	            if (!keysReportChangedCalled) {
	                if (_this._data.size !== orderedData.size) {
	                    // If size differs, keys are definitely modified
	                    _this._keysAtom.reportChanged();
	                }
	                else {
	                    var iter1 = _this._data.keys();
	                    var iter2 = orderedData.keys();
	                    var next1 = iter1.next();
	                    var next2 = iter2.next();
	                    while (!next1.done) {
	                        if (next1.value !== next2.value) {
	                            _this._keysAtom.reportChanged();
	                            break;
	                        }
	                        next1 = iter1.next();
	                        next2 = iter2.next();
	                    }
	                }
	            }
	            // Use correctly ordered map
	            _this._data = orderedData;
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            this._keysAtom.reportObserved();
	            return this._data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a plain object that represents this map.
	     * Note that all the keys being stringified.
	     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
	     */
	    ObservableMap.prototype.toPOJO = function () {
	        var _this = this;
	        var res = {};
	        this.forEach(function (_, key) {
	            return (res[typeof key === "symbol" ? key : stringifyKey(key)] = _this.get(key));
	        });
	        return res;
	    };
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        return new Map(this);
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toPOJO();
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            iteratorToArray(this.keys())
	                .map(function (key) { return stringifyKey(key) + ": " + ("" + _this.get(key)); })
	                .join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        
	            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	function stringifyKey(key) {
	    if (key && key.toString)
	        return key.toString();
	    else
	        return new String(key).toString();
	}
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	addHiddenFinalProp(ObservableMap.prototype, toStringTagSymbol(), "Map");
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	var ObservableSetMarker = {};
	var ObservableSet = /** @class */ (function () {
	    function ObservableSet(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableSet@" + getNextId(); }
	        this.name = name;
	        this.$mobx = ObservableSetMarker;
	        this._data = new Set();
	        this._atom = createAtom(this.name);
	        if (typeof Set !== "function") {
	            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
	        }
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
	        if (initialData) {
	            this.replace(initialData);
	        }
	    }
	    ObservableSet.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableSet.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this._data.forEach(function (value) {
	                    _this.delete(value);
	                });
	            });
	        });
	    };
	    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
	        var _this = this;
	        this._atom.reportObserved();
	        this._data.forEach(function (value) {
	            callbackFn.call(thisArg, value, value, _this);
	        });
	    };
	    Object.defineProperty(ObservableSet.prototype, "size", {
	        get: function () {
	            this._atom.reportObserved();
	            return this._data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObservableSet.prototype.add = function (value) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this._atom);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "add",
	                object: this,
	                newValue: value
	            });
	            if (!change)
	                return this;
	            // TODO: ideally, value = change.value would be done here, so that values can be
	            // changed by interceptor. Same applies for other Set and Map api's.
	        }
	        if (!this.has(value)) {
	            transaction(function () {
	                _this._data.add(_this.enhancer(value, undefined));
	                _this._atom.reportChanged();
	            });
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "add",
	                    object: this,
	                    newValue: value
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(change);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	        }
	        return this;
	    };
	    ObservableSet.prototype.delete = function (value) {
	        var _this = this;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                oldValue: value
	            });
	            if (!change)
	                return false;
	        }
	        if (this.has(value)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: value
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(__assign(__assign({}, change), { name: this.name }));
	            transaction(function () {
	                _this._atom.reportChanged();
	                _this._data.delete(value);
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableSet.prototype.has = function (value) {
	        this._atom.reportObserved();
	        return this._data.has(this.dehanceValue(value));
	    };
	    ObservableSet.prototype.entries = function () {
	        var nextIndex = 0;
	        var keys = iteratorToArray(this.keys());
	        var values = iteratorToArray(this.values());
	        return makeIterable({
	            next: function () {
	                var index = nextIndex;
	                nextIndex += 1;
	                return index < values.length
	                    ? { value: [keys[index], values[index]], done: false }
	                    : { done: true };
	            }
	        });
	    };
	    ObservableSet.prototype.keys = function () {
	        return this.values();
	    };
	    ObservableSet.prototype.values = function () {
	        this._atom.reportObserved();
	        var self = this;
	        var nextIndex = 0;
	        var observableValues;
	        if (this._data.values !== undefined) {
	            observableValues = iteratorToArray(this._data.values());
	        }
	        else {
	            // There is no values function in IE11
	            observableValues = [];
	            this._data.forEach(function (e) { return observableValues.push(e); });
	        }
	        return makeIterable({
	            next: function () {
	                return nextIndex < observableValues.length
	                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
	                    : { done: true };
	            }
	        });
	    };
	    ObservableSet.prototype.replace = function (other) {
	        var _this = this;
	        if (isObservableSet(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            var prev = allowStateChangesStart(true);
	            try {
	                if (Array.isArray(other)) {
	                    _this.clear();
	                    other.forEach(function (value) { return _this.add(value); });
	                }
	                else if (isES6Set(other)) {
	                    _this.clear();
	                    other.forEach(function (value) { return _this.add(value); });
	                }
	                else if (other !== null && other !== undefined) {
	                    fail("Cannot initialize set from " + other);
	                }
	            }
	            finally {
	                allowStateChangesEnd(prev);
	            }
	        });
	        return this;
	    };
	    ObservableSet.prototype.observe = function (listener, fireImmediately) {
	        // TODO 'fireImmediately' can be true?
	        
	            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
	        return registerListener(this, listener);
	    };
	    ObservableSet.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableSet.prototype.toJS = function () {
	        return new Set(this);
	    };
	    ObservableSet.prototype.toString = function () {
	        return this.name + "[ " + iteratorToArray(this.keys()).join(", ") + " ]";
	    };
	    return ObservableSet;
	}());
	declareIterator(ObservableSet.prototype, function () {
	    return this.values();
	});
	addHiddenFinalProp(ObservableSet.prototype, toStringTagSymbol(), "Set");
	var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, name, defaultEnhancer) {
	        this.target = target;
	        this.name = name;
	        this.defaultEnhancer = defaultEnhancer;
	        this.values = {};
	    }
	    ObservableObjectAdministration.prototype.read = function (owner, key) {
	        return this.values[key].get();
	    };
	    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
	        var instance = this.target;
	        var observable = this.values[key];
	        if (observable instanceof ComputedValue) {
	            observable.set(newValue);
	            return;
	        }
	        // intercept
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "update",
	                object: instance,
	                name: key,
	                newValue: newValue
	            });
	            if (!change)
	                return;
	            newValue = change.newValue;
	        }
	        newValue = observable.prepareNewValue(newValue);
	        // notify spy & observers
	        if (newValue !== globalState.UNCHANGED) {
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: instance,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableObjectAdministration.prototype.remove = function (key) {
	        if (!this.values[key])
	            return;
	        var target = this.target;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: target,
	                name: key,
	                type: "remove"
	            });
	            if (!change)
	                return;
	        }
	        try {
	            startBatch();
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var oldValue = this.values[key].get();
	            if (this.keys)
	                this.keys.remove(key);
	            delete this.values[key];
	            delete this.target[key];
	            var change = notify || notifySpy
	                ? {
	                    type: "remove",
	                    object: target,
	                    oldValue: oldValue,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	        finally {
	            endBatch();
	        }
	    };
	    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
	        /**
	         * This happens if a property is accessed through the prototype chain, but the property was
	         * declared directly as own property on the prototype.
	         *
	         * E.g.:
	         * class A {
	         * }
	         * extendObservable(A.prototype, { x: 1 })
	         *
	         * classB extens A {
	         * }
	         * console.log(new B().x)
	         *
	         * It is unclear whether the property should be considered 'static' or inherited.
	         * Either use `console.log(A.x)`
	         * or: decorate(A, { x: observable })
	         *
	         * When using decorate, the property will always be redeclared as own property on the actual instance
	         */
	        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        
	            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableObjectAdministration.prototype.getKeys = function () {
	        var _this = this;
	        if (this.keys === undefined) {
	            this.keys = (new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true));
	        }
	        return this.keys.slice();
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name, defaultEnhancer) {
	    if (name === void 0) { name = ""; }
	    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
	    var adm = target.$mobx;
	    if (adm)
	        return adm;
	    
	        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservableProperty(target, propName, newValue, enhancer) {
	    var adm = asObservableObject(target);
	    assertPropertyConfigurable(target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
	    if (adm.keys)
	        adm.keys.push(propName);
	    notifyPropertyAddition(adm, target, propName, newValue);
	}
	function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
	propName, options) {
	    var adm = asObservableObject(target);
	    options.name = adm.name + "." + propName;
	    options.context = target;
	    adm.values[propName] = new ComputedValue(options);
	    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = Object.create(null);
	var computedPropertyConfigs = Object.create(null);
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.read(this, propName);
	            },
	            set: function (v) {
	                this.$mobx.write(this, propName, v);
	            }
	        }));
	}
	function getAdministrationForComputedPropOwner(owner) {
	    var adm = owner.$mobx;
	    if (!adm) {
	        // because computed props are declared on proty,
	        // the current instance might not have been initialized yet
	        initializeInstance(owner);
	        return owner.$mobx;
	    }
	    return adm;
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: globalState.computedConfigurable,
	            enumerable: false,
	            get: function () {
	                return getAdministrationForComputedPropOwner(this).read(this, propName);
	            },
	            set: function (v) {
	                getAdministrationForComputedPropOwner(this).write(this, propName, v);
	            }
	        }));
	}
	function notifyPropertyAddition(adm, object, key, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: key,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart(__assign(__assign({}, change), { name: adm.name, key: key }));
	    if (notify)
	        notifyListeners(adm, change);
	    if (notifySpy)
	        spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            if (property !== undefined)
	                fail(
	                    "It is not possible to get index atoms from arrays");
	            return thing.$mobx.atom;
	        }
	        if (isObservableSet(thing)) {
	            return thing.$mobx;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return anyThing._keysAtom;
	            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
	            if (!observable)
	                fail(
	                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail( "please specify a property");
	            var observable = thing.$mobx.values[property];
	            if (!observable)
	                fail(
	                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail( "Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    if (!thing)
	        fail("Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing) || isObservableSet(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    initializeInstance(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    fail( "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b, depth) {
	    if (depth === void 0) { depth = -1; }
	    return eq(a, b, depth);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, depth, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (
	            // eslint-disable-next-line
	            typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    if (depth === 0) {
	        return false;
	    }
	    else if (depth < 0) {
	        depth = -1;
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], depth - 1, aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys = Object.keys(a);
	        var key = void 0;
	        length = keys.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys[length];
	            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.peek();
	    if (isES6Map(a) || isObservableMap(a))
	        return iteratorToArray(a.entries());
	    if (isES6Set(a) || isObservableSet(a))
	        return iteratorToArray(a.entries());
	    return a;
	}
	function has$1(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2019
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	try {
	    // define process.env if needed
	    // if this is not a production build in the first place
	    // (in which case the expression below would be substituted with 'production')
	    // tslint:disable-next-line
	    "development";
	}
	catch (e) {
	    var g = getGlobal();
	    if (typeof process === "undefined")
	        g.process = {};
	    g.process.env = {};
	}
	(function () {
	    function testCodeMinification() { }
	    if (testCodeMinification.name !== "testCodeMinification" &&
	        "development" !== "production" &&
	        typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}).IGNORE_MOBX_MINIFY_WARNING !== "true") {
	        // trick so it doesn't get replaced
	        var varName = ["process", "env", "NODE_ENV"].join(".");
	        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
	    }
	})();
	// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
	var $mobx = "$mobx";
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    // See: https://github.com/andykog/mobx-devtools/
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
	        spy: spy,
	        extras: {
	            getDebugName: getDebugName
	        },
	        $mobx: $mobx
	    });
	}
	// TODO: remove in some future build
	if (
	    typeof module !== "undefined" &&
	    typeof module.exports !== "undefined") {
	    var warnedAboutDefaultExport_1 = false;
	    Object.defineProperty(module.exports, "default", {
	        enumerable: false,
	        get: function () {
	            if (!warnedAboutDefaultExport_1) {
	                warnedAboutDefaultExport_1 = true;
	                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
	            }
	            return undefined;
	        }
	    });
	    [
	        "extras",
	        "Atom",
	        "BaseAtom",
	        "asFlat",
	        "asMap",
	        "asReference",
	        "asStructure",
	        "autorunAsync",
	        "createTranformer",
	        "expr",
	        "isModifierDescriptor",
	        "isStrictModeEnabled",
	        "map",
	        "useStrict",
	        "whyRun"
	    ].forEach(function (prop) {
	        Object.defineProperty(module.exports, prop, {
	            enumerable: false,
	            get: function () {
	                fail("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
	            },
	            set: function () { }
	        });
	    });
	}
	
	exports.$mobx = $mobx;
	exports.FlowCancellationError = FlowCancellationError;
	exports.ObservableMap = ObservableMap;
	exports.ObservableSet = ObservableSet;
	exports.Reaction = Reaction;
	exports._allowStateChanges = allowStateChanges;
	exports._allowStateChangesInsideComputed = allowStateChangesInsideComputed;
	exports._allowStateReadsEnd = allowStateReadsEnd;
	exports._allowStateReadsStart = allowStateReadsStart;
	exports._endAction = _endAction;
	exports._getAdministration = getAdministration;
	exports._getGlobalState = getGlobalState;
	exports._interceptReads = interceptReads;
	exports._isComputingDerivation = isComputingDerivation;
	exports._resetGlobalState = resetGlobalState;
	exports._startAction = _startAction;
	exports.action = action;
	exports.autorun = autorun;
	exports.comparer = comparer;
	exports.computed = computed;
	exports.configure = configure;
	exports.createAtom = createAtom;
	exports.decorate = decorate;
	exports.entries = entries;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.flow = flow;
	exports.get = get;
	exports.getAtom = getAtom;
	exports.getDebugName = getDebugName;
	exports.getDependencyTree = getDependencyTree;
	exports.getObserverTree = getObserverTree;
	exports.has = has;
	exports.intercept = intercept;
	exports.isAction = isAction;
	exports.isArrayLike = isArrayLike;
	exports.isBoxedObservable = isObservableValue;
	exports.isComputed = isComputed;
	exports.isComputedProp = isComputedProp;
	exports.isFlowCancellationError = isFlowCancellationError;
	exports.isObservable = isObservable;
	exports.isObservableArray = isObservableArray;
	exports.isObservableMap = isObservableMap;
	exports.isObservableObject = isObservableObject;
	exports.isObservableProp = isObservableProp;
	exports.isObservableSet = isObservableSet;
	exports.keys = keys;
	exports.observable = observable;
	exports.observe = observe;
	exports.onBecomeObserved = onBecomeObserved;
	exports.onBecomeUnobserved = onBecomeUnobserved;
	exports.onReactionError = onReactionError;
	exports.reaction = reaction;
	exports.remove = remove;
	exports.runInAction = runInAction;
	exports.set = set;
	exports.spy = spy;
	exports.toJS = toJS;
	exports.trace = trace;
	exports.transaction = transaction;
	exports.untracked = untracked;
	exports.values = values;
	exports.when = when;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=[];Object.freeze(e);var t={};Object.freeze(t);var n={};function r(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:n}function o(){return++Ne.mobxGuid}function i(e){throw a(!1,e),"X"}function a(e,t){if(!e)throw new Error("[mobx] "+(t||"An invariant failed, however the error is obfuscated because this is an production build."))}function s(e){var t=!1;return function(){if(!t)return t=!0,e.apply(this,arguments)}}var u=function(){};function c(e){return null!==e&&"object"==typeof e}function l(e){if(null===e||"object"!=typeof e)return!1;var t=Object.getPrototypeOf(e);return t===Object.prototype||null===t}function p(e,t,n){Object.defineProperty(e,t,{enumerable:!1,writable:!0,configurable:!0,value:n})}function f(e,t,n){Object.defineProperty(e,t,{enumerable:!1,writable:!1,configurable:!0,value:n})}function h(e,t){var n="isMobX"+e;return t.prototype[n]=!0,function(e){return c(e)&&!0===e[n]}}function v(e){return void 0!==r().Map&&e instanceof r().Map}function d(e){return e instanceof Set}function y(e){for(var t=[];;){var n=e.next();if(n.done)break;t.push(n.value)}return t}function b(){return"function"==typeof Symbol&&Symbol.toPrimitive||"@@toPrimitive"}function m(e){return null===e?null:"object"==typeof e?""+e:e}function g(e,t){for(var n=e.next();!n.done;)t(n.value),n=e.next()}function x(){return"function"==typeof Symbol&&Symbol.iterator||"@@iterator"}function _(e,t){f(e,x(),t)}function O(e){return e[x()]=S,e}function w(){return"function"==typeof Symbol&&Symbol.toStringTag||"@@toStringTag"}function S(){return this}var A=function(){function e(e){void 0===e&&(e="Atom@"+o()),this.name=e,this.isPendingUnobservation=!1,this.isBeingObserved=!1,this.observers=[],this.observersIndexes={},this.diffValue=0,this.lastAccessedBy=0,this.lowestObserverState=exports.IDerivationState.NOT_TRACKING}return e.prototype.onBecomeUnobserved=function(){},e.prototype.onBecomeObserved=function(){},e.prototype.reportObserved=function(){return Ue(this)},e.prototype.reportChanged=function(){$e(),function(e){if(e.lowestObserverState===exports.IDerivationState.STALE)return;e.lowestObserverState=exports.IDerivationState.STALE;var t=e.observers,n=t.length;for(;n--;){var r=t[n];r.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(r.isTracing!==ne.NONE&&Ge(r,e),r.onBecomeStale()),r.dependenciesState=exports.IDerivationState.STALE}}(this),Me()},e.prototype.toString=function(){return this.name},e}(),E=h("Atom",A);function D(e,t,n){void 0===t&&(t=u),void 0===n&&(n=u);var r=new A(e);return ct(r,t),lt(r,n),r}function j(e,t){return e===t}var k={identity:j,structural:function(e,t){return gn(e,t)},default:function(e,t){return function(e,t){return"number"==typeof e&&"number"==typeof t&&isNaN(e)&&isNaN(t)}(e,t)||j(e,t)},shallow:function(e,t){return gn(e,t,1)}},R=function(e,t){return(R=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)};
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */function I(e,t){function n(){this.constructor=e}R(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var C=function(){return(C=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function T(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,i=n.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(r=i.next()).done;)a.push(r.value)}catch(e){o={error:e}}finally{try{r&&!r.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function V(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(T(arguments[t]));return e}var N={},P={};function L(e,t){var n=t?N:P;return n[e]||(n[e]={configurable:!0,enumerable:t,get:function(){return B(this),this[e]},set:function(t){B(this),this[e]=t}})}function B(e){if(!0!==e.__mobxDidRunLazyInitializers){var t=e.__mobxDecorators;if(t)for(var n in p(e,"__mobxDidRunLazyInitializers",!0),t){var r=t[n];r.propertyCreator(e,r.prop,r.descriptor,r.decoratorTarget,r.decoratorArguments)}}}function $(t,n){return function(){var r,o=function(e,o,i,a){if(!0===a)return n(e,o,i,e,r),null;if(!Object.prototype.hasOwnProperty.call(e,"__mobxDecorators")){var s=e.__mobxDecorators;p(e,"__mobxDecorators",C({},s))}return e.__mobxDecorators[o]={prop:o,propertyCreator:n,descriptor:i,decoratorTarget:e,decoratorArguments:r},L(o,t)};return M(arguments)?(r=e,o.apply(null,arguments)):(r=Array.prototype.slice.call(arguments),o)}}function M(e){return(2===e.length||3===e.length)&&"string"==typeof e[1]||4===e.length&&!0===e[3]}function U(e,t,n){return Ot(e)?e:Array.isArray(e)?Z.array(e,{name:n}):l(e)?Z.object(e,void 0,{name:n}):v(e)?Z.map(e,{name:n}):d(e)?Z.set(e,{name:n}):e}function G(e){return e}function q(e){a(e);var t=$(!0,(function(t,n,r,o,i){cn(t,n,r?r.initializer?r.initializer.call(t):r.value:void 0,e)})),n=("undefined"!=typeof process&&({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}),t);return n.enhancer=e,n}var H={deep:!0,name:void 0,defaultDecorator:void 0},z={deep:!1,name:void 0,defaultDecorator:void 0};function K(e){return null==e?H:"string"==typeof e?{name:e,deep:!0}:e}function W(e){return e.defaultDecorator?e.defaultDecorator.enhancer:!1===e.deep?G:U}Object.freeze(H),Object.freeze(z);var J=q(U),X=q((function(e,t,n){return null==e?e:vn(e)||Qt(e)||nn(e)||an(e)?e:Array.isArray(e)?Z.array(e,{name:n,deep:!1}):l(e)?Z.object(e,void 0,{name:n,deep:!1}):v(e)?Z.map(e,{name:n,deep:!1}):d(e)?Z.set(e,{name:n,deep:!1}):i(!1)})),Y=q(G),F=q((function(e,t,n){return gn(e,t)?t:e}));var Q={box:function(e,t){arguments.length>2&&ee("box");var n=K(t);return new De(e,W(n),n.name,!0,n.equals)},shallowBox:function(e,t){return arguments.length>2&&ee("shallowBox"),Z.box(e,{name:t,deep:!1})},array:function(e,t){arguments.length>2&&ee("array");var n=K(t);return new Kt(e,W(n),n.name)},shallowArray:function(e,t){return arguments.length>2&&ee("shallowArray"),Z.array(e,{name:t,deep:!1})},map:function(e,t){arguments.length>2&&ee("map");var n=K(t);return new en(e,W(n),n.name)},shallowMap:function(e,t){return arguments.length>2&&ee("shallowMap"),Z.map(e,{name:t,deep:!1})},set:function(e,t){arguments.length>2&&ee("set");var n=K(t);return new on(e,W(n),n.name)},object:function(e,t,n){"string"==typeof arguments[1]&&ee("object");var r=K(n);return ft({},e,t,r)},shallowObject:function(e,t){return"string"==typeof arguments[1]&&ee("shallowObject"),Z.object(e,{},{name:t,deep:!1})},ref:Y,shallow:X,deep:J,struct:F},Z=function(e,t,n){if("string"==typeof arguments[1])return J.apply(null,arguments);if(Ot(e))return e;var r=l(e)?Z.object(e,t,n):Array.isArray(e)?Z.array(e,t):v(e)?Z.map(e,t):d(e)?Z.set(e,t):e;if(r!==e)return r;i(!1)};function ee(e){i("Expected one or two arguments to observable."+e+". Did you accidentally try to use observable."+e+" as decorator?")}Object.keys(Q).forEach((function(e){return Z[e]=Q[e]}));var te,ne,re=$(!1,(function(e,t,n,r,o){var i=n.get,a=n.set,s=o[0]||{};!function(e,t,n){var r=un(e);n.name=r.name+"."+t,n.context=e,r.values[t]=new ke(n),Object.defineProperty(e,t,function(e){return pn[e]||(pn[e]={configurable:Ne.computedConfigurable,enumerable:!1,get:function(){return fn(this).read(this,e)},set:function(t){fn(this).write(this,e,t)}})}(t))}(e,t,C({get:i,set:a},s))})),oe=re({equals:k.structural}),ie=function(e,t,n){if("string"==typeof t)return re.apply(null,arguments);if(null!==e&&"object"==typeof e&&1===arguments.length)return re.apply(null,arguments);var r="object"==typeof t?t:{};return r.get=e,r.set="function"==typeof t?t:r.set,r.name=r.name||e.name||"",new ke(r)};ie.struct=oe,(te=exports.IDerivationState||(exports.IDerivationState={}))[te.NOT_TRACKING=-1]="NOT_TRACKING",te[te.UP_TO_DATE=0]="UP_TO_DATE",te[te.POSSIBLY_STALE=1]="POSSIBLY_STALE",te[te.STALE=2]="STALE",function(e){e[e.NONE=0]="NONE",e[e.LOG=1]="LOG",e[e.BREAK=2]="BREAK"}(ne||(ne={}));var ae=function(e){this.cause=e};function se(e){return e instanceof ae}function ue(e){switch(e.dependenciesState){case exports.IDerivationState.UP_TO_DATE:return!1;case exports.IDerivationState.NOT_TRACKING:case exports.IDerivationState.STALE:return!0;case exports.IDerivationState.POSSIBLY_STALE:for(var t=de(!0),n=he(),r=e.observing,o=r.length,i=0;i<o;i++){var a=r[i];if(Re(a)){if(Ne.disableErrorBoundaries)a.get();else try{a.get()}catch(e){return ve(n),ye(t),!0}if(e.dependenciesState===exports.IDerivationState.STALE)return ve(n),ye(t),!0}}return be(e),ve(n),ye(t),!1}}function ce(e){var t=e.observers.length>0;Ne.computationDepth>0&&t&&i(!1),Ne.allowStateChanges||!t&&"strict"!==Ne.enforceActions||i(!1)}function le(e,t,n){var r=de(!0);be(e),e.newObserving=new Array(e.observing.length+100),e.unboundDepsCount=0,e.runId=++Ne.runId;var o,i=Ne.trackingDerivation;if(Ne.trackingDerivation=e,!0===Ne.disableErrorBoundaries)o=t.call(n);else try{o=t.call(n)}catch(e){o=new ae(e)}return Ne.trackingDerivation=i,function(e){for(var t=e.observing,n=e.observing=e.newObserving,r=exports.IDerivationState.UP_TO_DATE,o=0,i=e.unboundDepsCount,a=0;a<i;a++){0===(s=n[a]).diffValue&&(s.diffValue=1,o!==a&&(n[o]=s),o++),s.dependenciesState>r&&(r=s.dependenciesState)}n.length=o,e.newObserving=null,i=t.length;for(;i--;){0===(s=t[i]).diffValue&&Le(s,e),s.diffValue=0}for(;o--;){var s;1===(s=n[o]).diffValue&&(s.diffValue=0,Pe(s,e))}r!==exports.IDerivationState.UP_TO_DATE&&(e.dependenciesState=r,e.onBecomeStale())}(e),e.observing.length,ye(r),o}function pe(e){var t=e.observing;e.observing=[];for(var n=t.length;n--;)Le(t[n],e);e.dependenciesState=exports.IDerivationState.NOT_TRACKING}function fe(e){var t=he(),n=e();return ve(t),n}function he(){var e=Ne.trackingDerivation;return Ne.trackingDerivation=null,e}function ve(e){Ne.trackingDerivation=e}function de(e){var t=Ne.allowStateReads;return Ne.allowStateReads=e,t}function ye(e){Ne.allowStateReads=e}function be(e){if(e.dependenciesState!==exports.IDerivationState.UP_TO_DATE){e.dependenciesState=exports.IDerivationState.UP_TO_DATE;for(var t=e.observing,n=t.length;n--;)t[n].lowestObserverState=exports.IDerivationState.UP_TO_DATE}}var me=0,ge=1,xe=Object.getOwnPropertyDescriptor((function(){}),"name");xe&&xe.configurable;function _e(e,t){var n=function(){return Oe(e,t,this,arguments)};return n.isMobxAction=!0,n}function Oe(e,t,n,r){var o=we(e,n,r);try{return t.apply(n,r)}catch(e){throw o.error=e,e}finally{Se(o)}}function we(e,t,n){var r=Xe()&&!!e,o=0;if(r){o=Date.now();var i=n&&n.length||0,a=new Array(i);if(i>0)for(var s=0;s<i;s++)a[s]=n[s];Fe({type:"action",name:e,object:t,arguments:a})}var u=he();$e();var c={prevDerivation:u,prevAllowStateChanges:Ae(!0),prevAllowStateReads:de(!0),notifySpy:r,startTime:o,actionId:ge++,parentActionId:me};return me=c.actionId,c}function Se(e){me!==e.actionId&&i("invalid action stack. did you forget to finish an action?"),me=e.parentActionId,void 0!==e.error&&(Ne.suppressReactionErrors=!0),Ee(e.prevAllowStateChanges),ye(e.prevAllowStateReads),Me(),ve(e.prevDerivation),e.notifySpy&&Ze({time:Date.now()-e.startTime}),Ne.suppressReactionErrors=!1}function Ae(e){var t=Ne.allowStateChanges;return Ne.allowStateChanges=e,t}function Ee(e){Ne.allowStateChanges=e}var De=function(e){function t(t,n,r,i,a){void 0===r&&(r="ObservableValue@"+o()),void 0===i&&(i=!0),void 0===a&&(a=k.default);var s=e.call(this,r)||this;return s.enhancer=n,s.name=r,s.equals=a,s.hasUnreportedChange=!1,s.value=n(t,void 0,r),i&&Xe()&&Ye({type:"create",name:s.name,newValue:""+s.value}),s}return I(t,e),t.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},t.prototype.set=function(e){var t=this.value;if((e=this.prepareNewValue(e))!==Ne.UNCHANGED){var n=Xe();n&&Fe({type:"update",name:this.name,newValue:e,oldValue:t}),this.setNewValue(e),n&&Ze()}},t.prototype.prepareNewValue=function(e){if(ce(this),Ct(this)){var t=Vt(this,{object:this,type:"update",newValue:e});if(!t)return Ne.UNCHANGED;e=t.newValue}return e=this.enhancer(e,this.value,this.name),this.equals(this.value,e)?Ne.UNCHANGED:e},t.prototype.setNewValue=function(e){var t=this.value;this.value=e,this.reportChanged(),Nt(this)&&Lt(this,{type:"update",object:this,newValue:e,oldValue:t})},t.prototype.get=function(){return this.reportObserved(),this.dehanceValue(this.value)},t.prototype.intercept=function(e){return Tt(this,e)},t.prototype.observe=function(e,t){return t&&e({object:this,type:"update",newValue:this.value,oldValue:void 0}),Pt(this,e)},t.prototype.toJSON=function(){return this.get()},t.prototype.toString=function(){return this.name+"["+this.value+"]"},t.prototype.valueOf=function(){return m(this.get())},t}(A);De.prototype[b()]=De.prototype.valueOf;var je=h("ObservableValue",De),ke=function(){function e(e){this.dependenciesState=exports.IDerivationState.NOT_TRACKING,this.observing=[],this.newObserving=null,this.isBeingObserved=!1,this.isPendingUnobservation=!1,this.observers=[],this.observersIndexes={},this.diffValue=0,this.runId=0,this.lastAccessedBy=0,this.lowestObserverState=exports.IDerivationState.UP_TO_DATE,this.unboundDepsCount=0,this.__mapid="#"+o(),this.value=new ae(null),this.isComputing=!1,this.isRunningSetter=!1,this.isTracing=ne.NONE,a(e.get,"missing option for computed: get"),this.derivation=e.get,this.name=e.name||"ComputedValue@"+o(),e.set&&(this.setter=_e(this.name+"-setter",e.set)),this.equals=e.equals||(e.compareStructural||e.struct?k.structural:k.default),this.scope=e.context,this.requiresReaction=!!e.requiresReaction,this.keepAlive=!!e.keepAlive}return e.prototype.onBecomeStale=function(){!function(e){if(e.lowestObserverState!==exports.IDerivationState.UP_TO_DATE)return;e.lowestObserverState=exports.IDerivationState.POSSIBLY_STALE;var t=e.observers,n=t.length;for(;n--;){var r=t[n];r.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(r.dependenciesState=exports.IDerivationState.POSSIBLY_STALE,r.isTracing!==ne.NONE&&Ge(r,e),r.onBecomeStale())}}(this)},e.prototype.onBecomeUnobserved=function(){},e.prototype.onBecomeObserved=function(){},e.prototype.get=function(){this.isComputing&&i("Cycle detected in computation "+this.name+": "+this.derivation),0!==Ne.inBatch||0!==this.observers.length||this.keepAlive?(Ue(this),ue(this)&&this.trackAndCompute()&&function(e){if(e.lowestObserverState===exports.IDerivationState.STALE)return;e.lowestObserverState=exports.IDerivationState.STALE;var t=e.observers,n=t.length;for(;n--;){var r=t[n];r.dependenciesState===exports.IDerivationState.POSSIBLY_STALE?r.dependenciesState=exports.IDerivationState.STALE:r.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(e.lowestObserverState=exports.IDerivationState.UP_TO_DATE)}}(this)):ue(this)&&(this.warnAboutUntrackedRead(),$e(),this.value=this.computeValue(!1),Me());var e=this.value;if(se(e))throw e.cause;return e},e.prototype.peek=function(){var e=this.computeValue(!1);if(se(e))throw e.cause;return e},e.prototype.set=function(e){if(this.setter){a(!this.isRunningSetter,"The setter of computed value '"+this.name+"' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?"),this.isRunningSetter=!0;try{this.setter.call(this.scope,e)}finally{this.isRunningSetter=!1}}else a(!1,!1)},e.prototype.trackAndCompute=function(){Xe()&&Ye({object:this.scope,type:"compute",name:this.name});var e=this.value,t=this.dependenciesState===exports.IDerivationState.NOT_TRACKING,n=this.computeValue(!0),r=t||se(e)||se(n)||!this.equals(e,n);return r&&(this.value=n),r},e.prototype.computeValue=function(e){var t;if(this.isComputing=!0,Ne.computationDepth++,e)t=le(this,this.derivation,this.scope);else if(!0===Ne.disableErrorBoundaries)t=this.derivation.call(this.scope);else try{t=this.derivation.call(this.scope)}catch(e){t=new ae(e)}return Ne.computationDepth--,this.isComputing=!1,t},e.prototype.suspend=function(){this.keepAlive||(pe(this),this.value=void 0)},e.prototype.observe=function(e,t){var n=this,r=!0,o=void 0;return at((function(){var i=n.get();if(!r||t){var a=he();e({type:"update",object:n,newValue:i,oldValue:o}),ve(a)}r=!1,o=i}))},e.prototype.warnAboutUntrackedRead=function(){},e.prototype.toJSON=function(){return this.get()},e.prototype.toString=function(){return this.name+"["+this.derivation.toString()+"]"},e.prototype.valueOf=function(){return m(this.get())},e}();ke.prototype[b()]=ke.prototype.valueOf;var Re=h("ComputedValue",ke),Ie=["mobxGuid","spyListeners","enforceActions","computedRequiresReaction","reactionRequiresObservable","observableRequiresReaction","allowStateReads","disableErrorBoundaries","runId","UNCHANGED"],Ce=function(){this.version=5,this.UNCHANGED={},this.trackingDerivation=null,this.computationDepth=0,this.runId=0,this.mobxGuid=0,this.inBatch=0,this.pendingUnobservations=[],this.pendingReactions=[],this.isRunningReactions=!1,this.allowStateChanges=!0,this.allowStateReads=!0,this.enforceActions=!1,this.spyListeners=[],this.globalReactionErrorHandlers=[],this.computedRequiresReaction=!1,this.reactionRequiresObservable=!1,this.observableRequiresReaction=!1,this.computedConfigurable=!1,this.disableErrorBoundaries=!1,this.suppressReactionErrors=!1},Te=!0,Ve=!1,Ne=function(){var e=r();return e.__mobxInstanceCount>0&&!e.__mobxGlobals&&(Te=!1),e.__mobxGlobals&&e.__mobxGlobals.version!==(new Ce).version&&(Te=!1),Te?e.__mobxGlobals?(e.__mobxInstanceCount+=1,e.__mobxGlobals.UNCHANGED||(e.__mobxGlobals.UNCHANGED={}),e.__mobxGlobals):(e.__mobxInstanceCount=1,e.__mobxGlobals=new Ce):(setTimeout((function(){Ve||i("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`")}),1),new Ce)}();function Pe(e,t){var n=e.observers.length;n&&(e.observersIndexes[t.__mapid]=n),e.observers[n]=t,e.lowestObserverState>t.dependenciesState&&(e.lowestObserverState=t.dependenciesState)}function Le(e,t){if(1===e.observers.length)e.observers.length=0,Be(e);else{var n=e.observers,r=e.observersIndexes,o=n.pop();if(o!==t){var i=r[t.__mapid]||0;i?r[o.__mapid]=i:delete r[o.__mapid],n[i]=o}delete r[t.__mapid]}}function Be(e){!1===e.isPendingUnobservation&&(e.isPendingUnobservation=!0,Ne.pendingUnobservations.push(e))}function $e(){Ne.inBatch++}function Me(){if(0==--Ne.inBatch){ze();for(var e=Ne.pendingUnobservations,t=0;t<e.length;t++){var n=e[t];n.isPendingUnobservation=!1,0===n.observers.length&&(n.isBeingObserved&&(n.isBeingObserved=!1,n.onBecomeUnobserved()),n instanceof ke&&n.suspend())}Ne.pendingUnobservations=[]}}function Ue(e){var t=Ne.trackingDerivation;return null!==t?(t.runId!==e.lastAccessedBy&&(e.lastAccessedBy=t.runId,t.newObserving[t.unboundDepsCount++]=e,e.isBeingObserved||(e.isBeingObserved=!0,e.onBecomeObserved())),!0):(0===e.observers.length&&Ne.inBatch>0&&Be(e),!1)}function Ge(e,t){if(console.log("[mobx.trace] '"+e.name+"' is invalidated due to a change in: '"+t.name+"'"),e.isTracing===ne.BREAK){var n=[];!function e(t,n,r){if(n.length>=1e3)return void n.push("(and many more)");n.push(""+new Array(r).join("\t")+t.name),t.dependencies&&t.dependencies.forEach((function(t){return e(t,n,r+1)}))}(ht(e),n,1),new Function("debugger;\n/*\nTracing '"+e.name+"'\n\nYou are entering this break point because derivation '"+e.name+"' is being traced and '"+t.name+"' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n"+(e instanceof ke?e.derivation.toString().replace(/[*]\//g,"/"):"")+"\n\nThe dependencies for this derivation are:\n\n"+n.join("\n")+"\n*/\n    ")()}}var qe=function(){function e(e,t,n,r){void 0===e&&(e="Reaction@"+o()),void 0===r&&(r=!1),this.name=e,this.onInvalidate=t,this.errorHandler=n,this.requiresObservable=r,this.observing=[],this.newObserving=[],this.dependenciesState=exports.IDerivationState.NOT_TRACKING,this.diffValue=0,this.runId=0,this.unboundDepsCount=0,this.__mapid="#"+o(),this.isDisposed=!1,this._isScheduled=!1,this._isTrackPending=!1,this._isRunning=!1,this.isTracing=ne.NONE}return e.prototype.onBecomeStale=function(){this.schedule()},e.prototype.schedule=function(){this._isScheduled||(this._isScheduled=!0,Ne.pendingReactions.push(this),ze())},e.prototype.isScheduled=function(){return this._isScheduled},e.prototype.runReaction=function(){if(!this.isDisposed){if($e(),this._isScheduled=!1,ue(this)){this._isTrackPending=!0;try{this.onInvalidate(),this._isTrackPending&&Xe()&&Ye({name:this.name,type:"scheduled-reaction"})}catch(e){this.reportExceptionInDerivation(e)}}Me()}},e.prototype.track=function(e){$e();var t,n=Xe();n&&(t=Date.now(),Fe({name:this.name,type:"reaction"})),this._isRunning=!0;var r=le(this,e,void 0);this._isRunning=!1,this._isTrackPending=!1,this.isDisposed&&pe(this),se(r)&&this.reportExceptionInDerivation(r.cause),n&&Ze({time:Date.now()-t}),Me()},e.prototype.reportExceptionInDerivation=function(e){var t=this;if(this.errorHandler)this.errorHandler(e,this);else{if(Ne.disableErrorBoundaries)throw e;var n="[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '"+this+"'";Ne.suppressReactionErrors?console.warn("[mobx] (error in reaction '"+this.name+"' suppressed, fix error of causing action below)"):console.error(n,e),Xe()&&Ye({type:"error",name:this.name,message:n,error:""+e}),Ne.globalReactionErrorHandlers.forEach((function(n){return n(e,t)}))}},e.prototype.dispose=function(){this.isDisposed||(this.isDisposed=!0,this._isRunning||($e(),pe(this),Me()))},e.prototype.getDisposer=function(){var e=this.dispose.bind(this);return e.$mobx=this,e},e.prototype.toString=function(){return"Reaction["+this.name+"]"},e.prototype.trace=function(e){void 0===e&&(e=!1),Dt(this,e)},e}();var He=function(e){return e()};function ze(){Ne.inBatch>0||Ne.isRunningReactions||He(Ke)}function Ke(){Ne.isRunningReactions=!0;for(var e=Ne.pendingReactions,t=0;e.length>0;){100==++t&&(console.error("Reaction doesn't converge to a stable state after 100 iterations. Probably there is a cycle in the reactive function: "+e[0]),e.splice(0));for(var n=e.splice(0),r=0,o=n.length;r<o;r++)n[r].runReaction()}Ne.isRunningReactions=!1}var We=h("Reaction",qe);function Je(e){var t=He;He=function(n){return e((function(){return t(n)}))}}function Xe(){return!!Ne.spyListeners.length}function Ye(e){if(Ne.spyListeners.length)for(var t=Ne.spyListeners,n=0,r=t.length;n<r;n++)t[n](e)}function Fe(e){Ye(C(C({},e),{spyReportStart:!0}))}var Qe={spyReportEnd:!0};function Ze(e){Ye(e?C(C({},e),{spyReportEnd:!0}):Qe)}function et(e){return Ne.spyListeners.push(e),s((function(){Ne.spyListeners=Ne.spyListeners.filter((function(t){return t!==e}))}))}function tt(){i(!1)}function nt(e){return function(t,n,r){if(r){if(r.value)return{value:_e(e,r.value),enumerable:!1,configurable:!0,writable:!0};var o=r.initializer;return{enumerable:!1,configurable:!0,writable:!0,initializer:function(){return _e(e,o.call(this))}}}return rt(e).apply(this,arguments)}}function rt(e){return function(t,n,r){Object.defineProperty(t,n,{configurable:!0,enumerable:!1,get:function(){},set:function(t){p(this,n,ot(e,t))}})}}var ot=function(e,t,n,r){return 1===arguments.length&&"function"==typeof e?_e(e.name||"<unnamed action>",e):2===arguments.length&&"function"==typeof t?_e(e,t):1===arguments.length&&"string"==typeof e?nt(e):!0!==r?nt(t).apply(null,arguments):void(e[t]=_e(e.name||t,n.value))};function it(e,t,n){p(e,t,_e(t,n.bind(e)))}function at(e,n){void 0===n&&(n=t);var r,i=n&&n.name||e.name||"Autorun@"+o();if(!n.scheduler&&!n.delay)r=new qe(i,(function(){this.track(u)}),n.onError,n.requiresObservable);else{var a=ut(n),s=!1;r=new qe(i,(function(){s||(s=!0,a((function(){s=!1,r.isDisposed||r.track(u)})))}),n.onError,n.requiresObservable)}function u(){e(r)}return r.schedule(),r.getDisposer()}ot.bound=function(e,t,n,r){return!0===r?(it(e,t,n.value),null):n?{configurable:!0,enumerable:!1,get:function(){return it(this,t,n.value||n.initializer.call(this)),this[t]},set:tt}:{enumerable:!1,configurable:!0,set:function(e){it(this,t,e)},get:function(){}}};var st=function(e){return e()};function ut(e){return e.scheduler?e.scheduler:e.delay?function(t){return setTimeout(t,e.delay)}:st}function ct(e,t,n){return pt("onBecomeObserved",e,t,n)}function lt(e,t,n){return pt("onBecomeUnobserved",e,t,n)}function pt(e,t,n,r){var o="function"==typeof r?dn(t,n):dn(t),a="function"==typeof r?r:n,s=o[e];return"function"!=typeof s?i(!1):(o[e]=function(){s.call(this),a.call(this)},function(){o[e]=s})}function ft(e,t,n,r){var o=(r=K(r)).defaultDecorator||(!1===r.deep?Y:J);B(e),un(e,r.name,o.enhancer),$e();try{for(var i=Object.getOwnPropertyNames(t),a=0,s=i.length;a<s;a++){var u=i[a],c=Object.getOwnPropertyDescriptor(t,u);0;var l=n&&u in n?n[u]:c.get?re:o;0;var p=l(e,u,c,!0);p&&Object.defineProperty(e,u,p)}}finally{Me()}return e}function ht(e,t){return vt(dn(e,t))}function vt(e){var t,n,r={name:e.name};return e.observing&&e.observing.length>0&&(r.dependencies=(t=e.observing,n=[],t.forEach((function(e){-1===n.indexOf(e)&&n.push(e)})),n).map(vt)),r}function dt(e){var t={name:e.name};return function(e){return e.observers&&e.observers.length>0}(e)&&(t.observers=function(e){return e.observers}(e).map(dt)),t}var yt=0;function bt(){this.message="FLOW_CANCELLED"}function mt(e){"function"==typeof e.cancel&&e.cancel()}function gt(e,t){if(null==e)return!1;if(void 0!==t){if(!1===vn(e))return!1;if(!e.$mobx.values[t])return!1;var n=dn(e,t);return Re(n)}return Re(e)}function xt(e){return arguments.length>1?i(!1):gt(e)}function _t(e,t){if(null==e)return!1;if(void 0!==t){if(vn(e)){var n=e.$mobx;return n.values&&!!n.values[t]}return!1}return vn(e)||!!e.$mobx||E(e)||We(e)||Re(e)}function Ot(e){return 1!==arguments.length&&i(!1),_t(e)}function wt(e){return vn(e)?e.$mobx.getKeys():nn(e)?y(e.keys()):an(e)?y(e.keys()):Qt(e)?e.map((function(e,t){return t})):i(!1)}function St(e,t){if(vn(e)){var n=yn(e);return n.getKeys(),!!n.values[t]}return nn(e)?e.has(t):an(e)?e.has(t):Qt(e)?t>=0&&t<e.length:i(!1)}bt.prototype=Object.create(Error.prototype);var At={detectCycles:!0,exportMapsAsObjects:!0,recurseEverything:!1};function Et(e,t,n,r){return r.detectCycles&&e.set(t,n),n}function Dt(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n=!1;"boolean"==typeof e[e.length-1]&&(n=e.pop());var r=jt(e);if(!r)return i(!1);r.isTracing===ne.NONE&&console.log("[mobx.trace] '"+r.name+"' tracing enabled"),r.isTracing=n?ne.BREAK:ne.LOG}function jt(e){switch(e.length){case 0:return Ne.trackingDerivation;case 1:return dn(e[0]);case 2:return dn(e[0],e[1])}}function kt(e,t){void 0===t&&(t=void 0),$e();try{return e.apply(t)}finally{Me()}}function Rt(e,t,n){var r;"number"==typeof n.timeout&&(r=setTimeout((function(){if(!a.$mobx.isDisposed){a();var e=new Error("WHEN_TIMEOUT");if(!n.onError)throw e;n.onError(e)}}),n.timeout)),n.name=n.name||"When@"+o();var i=_e(n.name+"-effect",t),a=at((function(t){e()&&(t.dispose(),r&&clearTimeout(r),i())}),n);return a}function It(e,t){var n,r=new Promise((function(r,o){var i=Rt(e,r,C(C({},t),{onError:o}));n=function(){i(),o("WHEN_CANCELLED")}}));return r.cancel=n,r}function Ct(e){return void 0!==e.interceptors&&e.interceptors.length>0}function Tt(e,t){var n=e.interceptors||(e.interceptors=[]);return n.push(t),s((function(){var e=n.indexOf(t);-1!==e&&n.splice(e,1)}))}function Vt(e,t){var n=he();try{var r=e.interceptors;if(r)for(var o=0,i=r.length;o<i&&(a(!(t=r[o](t))||t.type,"Intercept handlers should return nothing or a change object"),t);o++);return t}finally{ve(n)}}function Nt(e){return void 0!==e.changeListeners&&e.changeListeners.length>0}function Pt(e,t){var n=e.changeListeners||(e.changeListeners=[]);return n.push(t),s((function(){var e=n.indexOf(t);-1!==e&&n.splice(e,1)}))}function Lt(e,t){var n=he(),r=e.changeListeners;if(r){for(var o=0,i=(r=r.slice()).length;o<i;o++)r[o](t);ve(n)}}var Bt,$t,Mt,Ut,Gt=(Bt=!1,$t={},Object.defineProperty($t,"0",{set:function(){Bt=!0}}),Object.create($t)[0]=1,!1===Bt),qt=0,Ht=function(){};Mt=Ht,Ut=Array.prototype,void 0!==Object.setPrototypeOf?Object.setPrototypeOf(Mt.prototype,Ut):void 0!==Mt.prototype.__proto__?Mt.prototype.__proto__=Ut:Mt.prototype=Ut,Object.isFrozen(Array)&&["constructor","push","shift","concat","pop","unshift","replace","find","findIndex","splice","reverse","sort"].forEach((function(e){Object.defineProperty(Ht.prototype,e,{configurable:!0,writable:!0,value:Array.prototype[e]})}));var zt=function(){function t(e,t,n,r){this.array=n,this.owned=r,this.values=[],this.lastKnownLength=0,this.atom=new A(e||"ObservableArray@"+o()),this.enhancer=function(n,r){return t(n,r,e+"[..]")}}return t.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},t.prototype.dehanceValues=function(e){return void 0!==this.dehancer&&e.length>0?e.map(this.dehancer):e},t.prototype.intercept=function(e){return Tt(this,e)},t.prototype.observe=function(e,t){return void 0===t&&(t=!1),t&&e({object:this.array,type:"splice",index:0,added:this.values.slice(),addedCount:this.values.length,removed:[],removedCount:0}),Pt(this,e)},t.prototype.getArrayLength=function(){return this.atom.reportObserved(),this.values.length},t.prototype.setArrayLength=function(e){if("number"!=typeof e||e<0)throw new Error("[mobx.array] Out of range: "+e);var t=this.values.length;if(e!==t)if(e>t){for(var n=new Array(e-t),r=0;r<e-t;r++)n[r]=void 0;this.spliceWithArray(t,0,n)}else this.spliceWithArray(e,t-e)},t.prototype.updateArrayLength=function(e,t){if(e!==this.lastKnownLength)throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");this.lastKnownLength+=t,t>0&&e+t+1>qt&&Yt(e+t+1)},t.prototype.spliceWithArray=function(t,n,r){var o=this;ce(this.atom);var i=this.values.length;if(void 0===t?t=0:t>i?t=i:t<0&&(t=Math.max(0,i+t)),n=1===arguments.length?i-t:null==n?0:Math.max(0,Math.min(n,i-t)),void 0===r&&(r=e),Ct(this)){var a=Vt(this,{object:this.array,type:"splice",index:t,removedCount:n,added:r});if(!a)return e;n=a.removedCount,r=a.added}var s=(r=0===r.length?r:r.map((function(e){return o.enhancer(e,void 0)}))).length-n;this.updateArrayLength(i,s);var u=this.spliceItemsIntoValues(t,n,r);return 0===n&&0===r.length||this.notifyArraySplice(t,r,u),this.dehanceValues(u)},t.prototype.spliceItemsIntoValues=function(e,t,n){var r;if(n.length<1e4)return(r=this.values).splice.apply(r,V([e,t],n));var o=this.values.slice(e,e+t);return this.values=this.values.slice(0,e).concat(n,this.values.slice(e+t)),o},t.prototype.notifyArrayChildUpdate=function(e,t,n){var r=!this.owned&&Xe(),o=Nt(this),i=o||r?{object:this.array,type:"update",index:e,newValue:t,oldValue:n}:null;r&&Fe(C(C({},i),{name:this.atom.name})),this.atom.reportChanged(),o&&Lt(this,i),r&&Ze()},t.prototype.notifyArraySplice=function(e,t,n){var r=!this.owned&&Xe(),o=Nt(this),i=o||r?{object:this.array,type:"splice",index:e,removed:n,added:t,removedCount:n.length,addedCount:t.length}:null;r&&Fe(C(C({},i),{name:this.atom.name})),this.atom.reportChanged(),o&&Lt(this,i),r&&Ze()},t}(),Kt=function(e){function t(t,n,r,i){void 0===r&&(r="ObservableArray@"+o()),void 0===i&&(i=!1);var a=e.call(this)||this,s=new zt(r,n,a,i);if(f(a,"$mobx",s),t&&t.length){var u=Ae(!0);a.spliceWithArray(0,0,t),Ee(u)}return Gt&&Object.defineProperty(s.array,"0",Wt),a}return I(t,e),t.prototype.intercept=function(e){return this.$mobx.intercept(e)},t.prototype.observe=function(e,t){return void 0===t&&(t=!1),this.$mobx.observe(e,t)},t.prototype.clear=function(){return this.splice(0)},t.prototype.concat=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];return this.$mobx.atom.reportObserved(),Array.prototype.concat.apply(this.peek(),e.map((function(e){return Qt(e)?e.peek():e})))},t.prototype.replace=function(e){return this.$mobx.spliceWithArray(0,this.$mobx.values.length,e)},t.prototype.toJS=function(){return this.slice()},t.prototype.toJSON=function(){return this.toJS()},t.prototype.peek=function(){return this.$mobx.atom.reportObserved(),this.$mobx.dehanceValues(this.$mobx.values)},t.prototype.find=function(e,t,n){void 0===n&&(n=0);var r=this.findIndex.apply(this,arguments);return-1===r?void 0:this.get(r)},t.prototype.findIndex=function(e,t,n){void 0===n&&(n=0);for(var r=this.peek(),o=r.length,i=n;i<o;i++)if(e.call(t,r[i],i,this))return i;return-1},t.prototype.splice=function(e,t){for(var n=[],r=2;r<arguments.length;r++)n[r-2]=arguments[r];switch(arguments.length){case 0:return[];case 1:return this.$mobx.spliceWithArray(e);case 2:return this.$mobx.spliceWithArray(e,t)}return this.$mobx.spliceWithArray(e,t,n)},t.prototype.spliceWithArray=function(e,t,n){return this.$mobx.spliceWithArray(e,t,n)},t.prototype.push=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n=this.$mobx;return n.spliceWithArray(n.values.length,0,e),n.values.length},t.prototype.pop=function(){return this.splice(Math.max(this.$mobx.values.length-1,0),1)[0]},t.prototype.shift=function(){return this.splice(0,1)[0]},t.prototype.unshift=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n=this.$mobx;return n.spliceWithArray(0,0,e),n.values.length},t.prototype.reverse=function(){var e=this.slice();return e.reverse.apply(e,arguments)},t.prototype.sort=function(e){var t=this.slice();return t.sort.apply(t,arguments)},t.prototype.remove=function(e){var t=this.$mobx.dehanceValues(this.$mobx.values).indexOf(e);return t>-1&&(this.splice(t,1),!0)},t.prototype.move=function(e,t){function n(e){if(e<0)throw new Error("[mobx.array] Index out of bounds: "+e+" is negative");var t=this.$mobx.values.length;if(e>=t)throw new Error("[mobx.array] Index out of bounds: "+e+" is not smaller than "+t)}if(n.call(this,e),n.call(this,t),e!==t){var r,o=this.$mobx.values;r=e<t?V(o.slice(0,e),o.slice(e+1,t+1),[o[e]],o.slice(t+1)):V(o.slice(0,t),[o[e]],o.slice(t,e),o.slice(e+1)),this.replace(r)}},t.prototype.get=function(e){var t=this.$mobx;if(t){if(e<t.values.length)return t.atom.reportObserved(),t.dehanceValue(t.values[e]);console.warn("[mobx.array] Attempt to read an array index ("+e+") that is out of bounds ("+t.values.length+"). Please check length first. Out of bound indices will not be tracked by MobX")}},t.prototype.set=function(e,t){var n=this.$mobx,r=n.values;if(e<r.length){ce(n.atom);var o=r[e];if(Ct(n)){var i=Vt(n,{type:"update",object:this,index:e,newValue:t});if(!i)return;t=i.newValue}(t=n.enhancer(t,o))!==o&&(r[e]=t,n.notifyArrayChildUpdate(e,t,o))}else{if(e!==r.length)throw new Error("[mobx.array] Index out of bounds, "+e+" is larger than "+r.length);n.spliceWithArray(e,0,[t])}},t}(Ht);_(Kt.prototype,(function(){this.$mobx.atom.reportObserved();var e=this,t=0;return O({next:function(){return t<e.length?{value:e[t++],done:!1}:{done:!0,value:void 0}}})})),Object.defineProperty(Kt.prototype,"length",{enumerable:!1,configurable:!0,get:function(){return this.$mobx.getArrayLength()},set:function(e){this.$mobx.setArrayLength(e)}}),p(Kt.prototype,w(),"Array"),["indexOf","join","lastIndexOf","slice","toString","toLocaleString"].forEach((function(e){var t=Array.prototype[e];a("function"==typeof t,"Base function not defined on Array prototype: '"+e+"'"),p(Kt.prototype,e,(function(){return t.apply(this.peek(),arguments)}))})),["every","filter","forEach","map","some"].forEach((function(e){a("function"==typeof Array.prototype[e],"Base function not defined on Array prototype: '"+e+"'"),p(Kt.prototype,e,(function(t,n){var r=this,o=this.$mobx;return o.atom.reportObserved(),o.dehanceValues(o.values)[e]((function(e,o){return t.call(n,e,o,r)}),n)}))})),["reduce","reduceRight"].forEach((function(e){p(Kt.prototype,e,(function(){var t=this,n=this.$mobx;n.atom.reportObserved();var r=arguments[0];return arguments[0]=function(e,o,i){return o=n.dehanceValue(o),r(e,o,i,t)},n.values[e].apply(n.values,arguments)}))})),function(e,t){for(var n=0;n<t.length;n++)p(e,t[n],e[t[n]])}(Kt.prototype,["constructor","intercept","observe","clear","concat","get","replace","toJS","toJSON","peek","find","findIndex","splice","spliceWithArray","push","pop","set","shift","unshift","reverse","sort","remove","move","toString","toLocaleString"]);var Wt=Jt(0);function Jt(e){return{enumerable:!1,configurable:!1,get:function(){return this.get(e)},set:function(t){this.set(e,t)}}}function Xt(e){Object.defineProperty(Kt.prototype,""+e,Jt(e))}function Yt(e){for(var t=qt;t<e;t++)Xt(t);qt=e}Yt(1e3);var Ft=h("ObservableArrayAdministration",zt);function Qt(e){return c(e)&&Ft(e.$mobx)}var Zt={},en=function(){function e(e,t,n){if(void 0===t&&(t=U),void 0===n&&(n="ObservableMap@"+o()),this.enhancer=t,this.name=n,this.$mobx=Zt,this._keysAtom=D(this.name+".keys()"),"function"!=typeof Map)throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");this._data=new Map,this._hasMap=new Map,this.merge(e)}return e.prototype._has=function(e){return this._data.has(e)},e.prototype.has=function(e){var t=this;if(!Ne.trackingDerivation)return this._has(e);var n=this._hasMap.get(e);if(!n){var r=n=new De(this._has(e),G,this.name+"."+tn(e)+"?",!1);this._hasMap.set(e,r),lt(r,(function(){return t._hasMap.delete(e)}))}return n.get()},e.prototype.set=function(e,t){var n=this._has(e);if(Ct(this)){var r=Vt(this,{type:n?"update":"add",object:this,newValue:t,name:e});if(!r)return this;t=r.newValue}return n?this._updateValue(e,t):this._addValue(e,t),this},e.prototype.delete=function(e){var t=this;if((ce(this._keysAtom),Ct(this))&&!(o=Vt(this,{type:"delete",object:this,name:e})))return!1;if(this._has(e)){var n=Xe(),r=Nt(this),o=r||n?{type:"delete",object:this,oldValue:this._data.get(e).value,name:e}:null;return n&&Fe(C(C({},o),{name:this.name,key:e})),kt((function(){t._keysAtom.reportChanged(),t._updateHasMapEntry(e,!1),t._data.get(e).setNewValue(void 0),t._data.delete(e)})),r&&Lt(this,o),n&&Ze(),!0}return!1},e.prototype._updateHasMapEntry=function(e,t){var n=this._hasMap.get(e);n&&n.setNewValue(t)},e.prototype._updateValue=function(e,t){var n=this._data.get(e);if((t=n.prepareNewValue(t))!==Ne.UNCHANGED){var r=Xe(),o=Nt(this),i=o||r?{type:"update",object:this,oldValue:n.value,name:e,newValue:t}:null;r&&Fe(C(C({},i),{name:this.name,key:e})),n.setNewValue(t),o&&Lt(this,i),r&&Ze()}},e.prototype._addValue=function(e,t){var n=this;ce(this._keysAtom),kt((function(){var r=new De(t,n.enhancer,n.name+"."+tn(e),!1);n._data.set(e,r),t=r.value,n._updateHasMapEntry(e,!0),n._keysAtom.reportChanged()}));var r=Xe(),o=Nt(this),i=o||r?{type:"add",object:this,name:e,newValue:t}:null;r&&Fe(C(C({},i),{name:this.name,key:e})),o&&Lt(this,i),r&&Ze()},e.prototype.get=function(e){return this.has(e)?this.dehanceValue(this._data.get(e).get()):this.dehanceValue(void 0)},e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.keys=function(){return this._keysAtom.reportObserved(),this._data.keys()},e.prototype.values=function(){var e=this,t=this.keys();return O({next:function(){var n=t.next(),r=n.done,o=n.value;return{done:r,value:r?void 0:e.get(o)}}})},e.prototype.entries=function(){var e=this,t=this.keys();return O({next:function(){var n=t.next(),r=n.done,o=n.value;return{done:r,value:r?void 0:[o,e.get(o)]}}})},e.prototype.forEach=function(e,t){var n=this;this._keysAtom.reportObserved(),this._data.forEach((function(r,o){return e.call(t,n.get(o),o,n)}))},e.prototype.merge=function(e){var t=this;return nn(e)&&(e=e.toJS()),kt((function(){var n=Ae(!0);try{l(e)?Object.keys(e).forEach((function(n){return t.set(n,e[n])})):Array.isArray(e)?e.forEach((function(e){var n=T(e,2),r=n[0],o=n[1];return t.set(r,o)})):v(e)?e.constructor!==Map?i("Cannot initialize from classes that inherit from Map: "+e.constructor.name):e.forEach((function(e,n){return t.set(n,e)})):null!=e&&i("Cannot initialize map from "+e)}finally{Ee(n)}})),this},e.prototype.clear=function(){var e=this;kt((function(){fe((function(){e._data.forEach((function(t,n){return e.delete(n)}))}))}))},e.prototype.replace=function(e){var t=this;return kt((function(){var n=function(e){if(v(e)||nn(e))return e;if(Array.isArray(e))return new Map(e);if(l(e)){var t=new Map;for(var n in e)t.set(n,e[n]);return t}return i("Cannot convert to map from '"+e+"'")}(e),r=new Map,o=!1;if(g(t._data.keys(),(function(e){if(!n.has(e))if(t.delete(e))o=!0;else{var i=t._data.get(e);r.set(e,i)}})),g(n.entries(),(function(e){var n=T(e,2),i=n[0],a=n[1],s=t._data.has(i);if(t.set(i,a),t._data.has(i)){var u=t._data.get(i);r.set(i,u),s||(o=!0)}})),!o)if(t._data.size!==r.size)t._keysAtom.reportChanged();else for(var a=t._data.keys(),s=r.keys(),u=a.next(),c=s.next();!u.done;){if(u.value!==c.value){t._keysAtom.reportChanged();break}u=a.next(),c=s.next()}t._data=r})),this},Object.defineProperty(e.prototype,"size",{get:function(){return this._keysAtom.reportObserved(),this._data.size},enumerable:!0,configurable:!0}),e.prototype.toPOJO=function(){var e=this,t={};return this.forEach((function(n,r){return t["symbol"==typeof r?r:tn(r)]=e.get(r)})),t},e.prototype.toJS=function(){return new Map(this)},e.prototype.toJSON=function(){return this.toPOJO()},e.prototype.toString=function(){var e=this;return this.name+"[{ "+y(this.keys()).map((function(t){return tn(t)+": "+e.get(t)})).join(", ")+" }]"},e.prototype.observe=function(e,t){return Pt(this,e)},e.prototype.intercept=function(e){return Tt(this,e)},e}();function tn(e){return e&&e.toString?e.toString():new String(e).toString()}_(en.prototype,(function(){return this.entries()})),f(en.prototype,w(),"Map");var nn=h("ObservableMap",en),rn={},on=function(){function e(e,t,n){if(void 0===t&&(t=U),void 0===n&&(n="ObservableSet@"+o()),this.name=n,this.$mobx=rn,this._data=new Set,this._atom=D(this.name),"function"!=typeof Set)throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");this.enhancer=function(e,r){return t(e,r,n)},e&&this.replace(e)}return e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.clear=function(){var e=this;kt((function(){fe((function(){e._data.forEach((function(t){e.delete(t)}))}))}))},e.prototype.forEach=function(e,t){var n=this;this._atom.reportObserved(),this._data.forEach((function(r){e.call(t,r,r,n)}))},Object.defineProperty(e.prototype,"size",{get:function(){return this._atom.reportObserved(),this._data.size},enumerable:!0,configurable:!0}),e.prototype.add=function(e){var t=this;if((ce(this._atom),Ct(this))&&!(o=Vt(this,{type:"add",object:this,newValue:e})))return this;if(!this.has(e)){kt((function(){t._data.add(t.enhancer(e,void 0)),t._atom.reportChanged()}));var n=Xe(),r=Nt(this),o=r||n?{type:"add",object:this,newValue:e}:null;0,r&&Lt(this,o)}return this},e.prototype.delete=function(e){var t=this;if(Ct(this)&&!(o=Vt(this,{type:"delete",object:this,oldValue:e})))return!1;if(this.has(e)){var n=Xe(),r=Nt(this),o=r||n?{type:"delete",object:this,oldValue:e}:null;return kt((function(){t._atom.reportChanged(),t._data.delete(e)})),r&&Lt(this,o),!0}return!1},e.prototype.has=function(e){return this._atom.reportObserved(),this._data.has(this.dehanceValue(e))},e.prototype.entries=function(){var e=0,t=y(this.keys()),n=y(this.values());return O({next:function(){var r=e;return e+=1,r<n.length?{value:[t[r],n[r]],done:!1}:{done:!0}}})},e.prototype.keys=function(){return this.values()},e.prototype.values=function(){this._atom.reportObserved();var e,t=this,n=0;return void 0!==this._data.values?e=y(this._data.values()):(e=[],this._data.forEach((function(t){return e.push(t)}))),O({next:function(){return n<e.length?{value:t.dehanceValue(e[n++]),done:!1}:{done:!0}}})},e.prototype.replace=function(e){var t=this;return an(e)&&(e=e.toJS()),kt((function(){var n=Ae(!0);try{Array.isArray(e)?(t.clear(),e.forEach((function(e){return t.add(e)}))):d(e)?(t.clear(),e.forEach((function(e){return t.add(e)}))):null!=e&&i("Cannot initialize set from "+e)}finally{Ee(n)}})),this},e.prototype.observe=function(e,t){return Pt(this,e)},e.prototype.intercept=function(e){return Tt(this,e)},e.prototype.toJS=function(){return new Set(this)},e.prototype.toString=function(){return this.name+"[ "+y(this.keys()).join(", ")+" ]"},e}();_(on.prototype,(function(){return this.values()})),f(on.prototype,w(),"Set");var an=h("ObservableSet",on),sn=function(){function e(e,t,n){this.target=e,this.name=t,this.defaultEnhancer=n,this.values={}}return e.prototype.read=function(e,t){if(this.target===e||(this.illegalAccess(e,t),this.values[t]))return this.values[t].get()},e.prototype.write=function(e,t,n){var r=this.target;r!==e&&this.illegalAccess(e,t);var o=this.values[t];if(o instanceof ke)o.set(n);else{if(Ct(this)){if(!(s=Vt(this,{type:"update",object:r,name:t,newValue:n})))return;n=s.newValue}if((n=o.prepareNewValue(n))!==Ne.UNCHANGED){var i=Nt(this),a=Xe(),s=i||a?{type:"update",object:r,oldValue:o.value,name:t,newValue:n}:null;a&&Fe(C(C({},s),{name:this.name,key:t})),o.setNewValue(n),i&&Lt(this,s),a&&Ze()}}},e.prototype.remove=function(e){if(this.values[e]){var t=this.target;if(Ct(this))if(!(i=Vt(this,{object:t,name:e,type:"remove"})))return;try{$e();var n=Nt(this),r=Xe(),o=this.values[e].get();this.keys&&this.keys.remove(e),delete this.values[e],delete this.target[e];var i=n||r?{type:"remove",object:t,oldValue:o,name:e}:null;r&&Fe(C(C({},i),{name:this.name,key:e})),n&&Lt(this,i),r&&Ze()}finally{Me()}}},e.prototype.illegalAccess=function(e,t){console.warn("Property '"+t+"' of '"+e+"' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner")},e.prototype.observe=function(e,t){return Pt(this,e)},e.prototype.intercept=function(e){return Tt(this,e)},e.prototype.getKeys=function(){var e=this;return void 0===this.keys&&(this.keys=new Kt(Object.keys(this.values).filter((function(t){return e.values[t]instanceof De})),G,"keys("+this.name+")",!0)),this.keys.slice()},e}();function un(e,t,n){void 0===t&&(t=""),void 0===n&&(n=U);var r=e.$mobx;return r||(l(e)||(t=(e.constructor.name||"ObservableObject")+"@"+o()),t||(t="ObservableObject@"+o()),f(e,"$mobx",r=new sn(e,t,n)),r)}function cn(e,t,n,r){var o=un(e);if(Ct(o)){var i=Vt(o,{object:e,name:t,type:"add",newValue:n});if(!i)return;n=i.newValue}n=(o.values[t]=new De(n,r,o.name+"."+t,!1)).value,Object.defineProperty(e,t,function(e){return ln[e]||(ln[e]={configurable:!0,enumerable:!0,get:function(){return this.$mobx.read(this,e)},set:function(t){this.$mobx.write(this,e,t)}})}(t)),o.keys&&o.keys.push(t),function(e,t,n,r){var o=Nt(e),i=Xe(),a=o||i?{type:"add",object:t,name:n,newValue:r}:null;i&&Fe(C(C({},a),{name:e.name,key:n}));o&&Lt(e,a);i&&Ze()}(o,e,t,n)}var ln=Object.create(null),pn=Object.create(null);function fn(e){var t=e.$mobx;return t||(B(e),e.$mobx)}var hn=h("ObservableObjectAdministration",sn);function vn(e){return!!c(e)&&(B(e),hn(e.$mobx))}function dn(e,t){if("object"==typeof e&&null!==e){if(Qt(e))return void 0!==t&&i(!1),e.$mobx.atom;if(an(e))return e.$mobx;if(nn(e)){var n=e;return void 0===t?n._keysAtom:((r=n._data.get(t)||n._hasMap.get(t))||i(!1),r)}var r;if(B(e),t&&!e.$mobx&&e[t],vn(e))return t?((r=e.$mobx.values[t])||i(!1),r):i(!1);if(E(e)||Re(e)||We(e))return e}else if("function"==typeof e&&We(e.$mobx))return e.$mobx;return i(!1)}function yn(e,t){return e||i("Expecting some object"),void 0!==t?yn(dn(e,t)):E(e)||Re(e)||We(e)?e:nn(e)||an(e)?e:(B(e),e.$mobx?e.$mobx:void i(!1))}function bn(e,t){return(void 0!==t?dn(e,t):vn(e)||nn(e)||an(e)?yn(e):dn(e)).name}var mn=Object.prototype.toString;function gn(e,t,n){return void 0===n&&(n=-1),function e(t,n,r,o,i){if(t===n)return 0!==t||1/t==1/n;if(null==t||null==n)return!1;if(t!=t)return n!=n;var a=typeof t;if("function"!==a&&"object"!==a&&"object"!=typeof n)return!1;t=xn(t),n=xn(n);var s=mn.call(t);if(s!==mn.call(n))return!1;switch(s){case"[object RegExp]":case"[object String]":return""+t==""+n;case"[object Number]":return+t!=+t?+n!=+n:0==+t?1/+t==1/n:+t==+n;case"[object Date]":case"[object Boolean]":return+t==+n;case"[object Symbol]":return"undefined"!=typeof Symbol&&Symbol.valueOf.call(t)===Symbol.valueOf.call(n)}var u="[object Array]"===s;if(!u){if("object"!=typeof t||"object"!=typeof n)return!1;var c=t.constructor,l=n.constructor;if(c!==l&&!("function"==typeof c&&c instanceof c&&"function"==typeof l&&l instanceof l)&&"constructor"in t&&"constructor"in n)return!1}if(0===r)return!1;r<0&&(r=-1);i=i||[];var p=(o=o||[]).length;for(;p--;)if(o[p]===t)return i[p]===n;if(o.push(t),i.push(n),u){if((p=t.length)!==n.length)return!1;for(;p--;)if(!e(t[p],n[p],r-1,o,i))return!1}else{var f=Object.keys(t),h=void 0;if(p=f.length,Object.keys(n).length!==p)return!1;for(;p--;)if(h=f[p],!_n(n,h)||!e(t[h],n[h],r-1,o,i))return!1}return o.pop(),i.pop(),!0}(e,t,n)}function xn(e){return Qt(e)?e.peek():v(e)||nn(e)?y(e.entries()):d(e)||an(e)?y(e.entries()):e}function _n(e,t){return Object.prototype.hasOwnProperty.call(e,t)}"object"==typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__&&__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({spy:et,extras:{getDebugName:bn},$mobx:"$mobx"}),exports.$mobx="$mobx",exports.FlowCancellationError=bt,exports.ObservableMap=en,exports.ObservableSet=on,exports.Reaction=qe,exports._allowStateChanges=function(e,t){var n,r=Ae(e);try{n=t()}finally{Ee(r)}return n},exports._allowStateChangesInsideComputed=function(e){var t,n=Ne.computationDepth;Ne.computationDepth=0;try{t=e()}finally{Ne.computationDepth=n}return t},exports._allowStateReadsEnd=ye,exports._allowStateReadsStart=de,exports._endAction=Se,exports._getAdministration=yn,exports._getGlobalState=function(){return Ne},exports._interceptReads=function(e,t,n){var r;if(nn(e)||Qt(e)||je(e))r=yn(e);else{if(!vn(e))return i(!1);if("string"!=typeof t)return i(!1);r=yn(e,t)}return void 0!==r.dehancer?i(!1):(r.dehancer="function"==typeof t?t:n,function(){r.dehancer=void 0})},exports._isComputingDerivation=function(){return null!==Ne.trackingDerivation},exports._resetGlobalState=function(){var e=new Ce;for(var t in e)-1===Ie.indexOf(t)&&(Ne[t]=e[t]);Ne.allowStateChanges=!Ne.enforceActions},exports._startAction=we,exports.action=ot,exports.autorun=at,exports.comparer=k,exports.computed=ie,exports.configure=function(e){var t=e.enforceActions,n=e.computedRequiresReaction,o=e.computedConfigurable,a=e.disableErrorBoundaries,s=e.arrayBuffer,u=e.reactionScheduler,c=e.reactionRequiresObservable,l=e.observableRequiresReaction;if(!0===e.isolateGlobalState&&((Ne.pendingReactions.length||Ne.inBatch||Ne.isRunningReactions)&&i("isolateGlobalState should be called before MobX is running any reactions"),Ve=!0,Te&&(0==--r().__mobxInstanceCount&&(r().__mobxGlobals=void 0),Ne=new Ce)),void 0!==t){var p=void 0;switch(t){case!0:case"observed":p=!0;break;case!1:case"never":p=!1;break;case"strict":case"always":p="strict";break;default:i("Invalid value for 'enforceActions': '"+t+"', expected 'never', 'always' or 'observed'")}Ne.enforceActions=p,Ne.allowStateChanges=!0!==p&&"strict"!==p}void 0!==n&&(Ne.computedRequiresReaction=!!n),void 0!==c&&(Ne.reactionRequiresObservable=!!c),void 0!==l&&(Ne.observableRequiresReaction=!!l,Ne.allowStateReads=!Ne.observableRequiresReaction),void 0!==o&&(Ne.computedConfigurable=!!o),void 0!==a&&(!0===a&&console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on."),Ne.disableErrorBoundaries=!!a),"number"==typeof s&&Yt(s),u&&Je(u)},exports.createAtom=D,exports.decorate=function(e,t){var n="function"==typeof e?e.prototype:e,r=function(e){var r=t[e];Array.isArray(r)||(r=[r]);var o=Object.getOwnPropertyDescriptor(n,e),i=r.reduce((function(t,r){return r(n,e,t)}),o);i&&Object.defineProperty(n,e,i)};for(var o in t)r(o);return e},exports.entries=function(e){return vn(e)?wt(e).map((function(t){return[t,e[t]]})):nn(e)?wt(e).map((function(t){return[t,e.get(t)]})):an(e)?y(e.entries()):Qt(e)?e.map((function(e,t){return[t,e]})):i(!1)},exports.extendObservable=ft,exports.extendShallowObservable=function(e,t,n){return ft(e,t,n,z)},exports.flow=function(e){1!==arguments.length&&i("Flow expects one 1 argument and cannot be used as decorator");var t=e.name||"<unnamed flow>";return function(){var n,r=this,o=arguments,i=++yt,a=ot(t+" - runid: "+i+" - init",e).apply(r,o),s=void 0,c=new Promise((function(e,r){var o=0;function u(e){var n;s=void 0;try{n=ot(t+" - runid: "+i+" - yield "+o++,a.next).call(a,e)}catch(e){return r(e)}l(n)}function c(e){var n;s=void 0;try{n=ot(t+" - runid: "+i+" - yield "+o++,a.throw).call(a,e)}catch(e){return r(e)}l(n)}function l(t){if(!t||"function"!=typeof t.then)return t.done?e(t.value):(s=Promise.resolve(t.value)).then(u,c);t.then(l,r)}n=r,u(void 0)}));return c.cancel=ot(t+" - runid: "+i+" - cancel",(function(){try{s&&mt(s);var e=a.return(void 0),t=Promise.resolve(e.value);t.then(u,u),mt(t),n(new bt)}catch(e){n(e)}})),c}},exports.get=function(e,t){if(St(e,t))return vn(e)?e[t]:nn(e)?e.get(t):Qt(e)?e[t]:i(!1)},exports.getAtom=dn,exports.getDebugName=bn,exports.getDependencyTree=ht,exports.getObserverTree=function(e,t){return dt(dn(e,t))},exports.has=St,exports.intercept=function(e,t,n){return"function"==typeof n?function(e,t,n){return yn(e,t).intercept(n)}(e,t,n):function(e,t){return yn(e).intercept(t)}(e,t)},exports.isAction=function(e){return"function"==typeof e&&!0===e.isMobxAction},exports.isArrayLike=function(e){return Array.isArray(e)||Qt(e)},exports.isBoxedObservable=je,exports.isComputed=xt,exports.isComputedProp=function(e,t){return"string"!=typeof t?i(!1):gt(e,t)},exports.isFlowCancellationError=function(e){return e instanceof bt},exports.isObservable=Ot,exports.isObservableArray=Qt,exports.isObservableMap=nn,exports.isObservableObject=vn,exports.isObservableProp=function(e,t){return"string"!=typeof t?i(!1):_t(e,t)},exports.isObservableSet=an,exports.keys=wt,exports.observable=Z,exports.observe=function(e,t,n,r){return"function"==typeof n?function(e,t,n,r){return yn(e,t).observe(n,r)}(e,t,n,r):function(e,t,n){return yn(e).observe(t,n)}(e,t,n)},exports.onBecomeObserved=ct,exports.onBecomeUnobserved=lt,exports.onReactionError=function(e){return Ne.globalReactionErrorHandlers.push(e),function(){var t=Ne.globalReactionErrorHandlers.indexOf(e);t>=0&&Ne.globalReactionErrorHandlers.splice(t,1)}},exports.reaction=function(e,n,r){void 0===r&&(r=t),"boolean"==typeof r&&(r={fireImmediately:r});var i,a,s,u=r.name||"Reaction@"+o(),c=ot(u,r.onError?(i=r.onError,a=n,function(){try{return a.apply(this,arguments)}catch(e){i.call(this,e)}}):n),l=!r.scheduler&&!r.delay,p=ut(r),f=!0,h=!1,v=r.compareStructural?k.structural:r.equals||k.default,d=new qe(u,(function(){f||l?y():h||(h=!0,p(y))}),r.onError,r.requiresObservable);function y(){if(h=!1,!d.isDisposed){var t=!1;d.track((function(){var n=e(d);t=f||!v(s,n),s=n})),f&&r.fireImmediately&&c(s,d),f||!0!==t||c(s,d),f&&(f=!1)}}return d.schedule(),d.getDisposer()},exports.remove=function(e,t){if(vn(e))e.$mobx.remove(t);else if(nn(e))e.delete(t);else if(an(e))e.delete(t);else{if(!Qt(e))return i(!1);"number"!=typeof t&&(t=parseInt(t,10)),a(t>=0,"Not a valid index: '"+t+"'"),e.splice(t,1)}},exports.runInAction=function(e,t){return Oe("string"==typeof e?e:e.name||"<unnamed action>","function"==typeof e?e:t,this,void 0)},exports.set=function e(t,n,r){if(2!==arguments.length||an(t))if(vn(t)){var o=t.$mobx,s=o.values[n];s?o.write(t,n,r):cn(t,n,r,o.defaultEnhancer)}else if(nn(t))t.set(n,r);else if(an(t))t.add(n);else{if(!Qt(t))return i(!1);"number"!=typeof n&&(n=parseInt(n,10)),a(n>=0,"Not a valid index: '"+n+"'"),$e(),n>=t.length&&(t.length=n+1),t[n]=r,Me()}else{$e();var u=n;try{for(var c in u)e(t,c,u[c])}finally{Me()}}},exports.spy=et,exports.toJS=function(e,t){var n;return"boolean"==typeof t&&(t={detectCycles:t}),t||(t=At),t.detectCycles=void 0===t.detectCycles?!0===t.recurseEverything:!0===t.detectCycles,t.detectCycles&&(n=new Map),function e(t,n,r){if(!n.recurseEverything&&!Ot(t))return t;if("object"!=typeof t)return t;if(null===t)return null;if(t instanceof Date)return t;if(je(t))return e(t.get(),n,r);if(Ot(t)&&wt(t),!0===n.detectCycles&&null!==t&&r.has(t))return r.get(t);if(Qt(t)||Array.isArray(t)){var o=Et(r,t,[],n),i=t.map((function(t){return e(t,n,r)}));o.length=i.length;for(var a=0,s=i.length;a<s;a++)o[a]=i[a];return o}if(an(t)||Object.getPrototypeOf(t)===Set.prototype){if(!1===n.exportMapsAsObjects){var u=Et(r,t,new Set,n);return t.forEach((function(t){u.add(e(t,n,r))})),u}var c=Et(r,t,[],n);return t.forEach((function(t){c.push(e(t,n,r))})),c}if(nn(t)||Object.getPrototypeOf(t)===Map.prototype){if(!1===n.exportMapsAsObjects){var l=Et(r,t,new Map,n);return t.forEach((function(t,o){l.set(o,e(t,n,r))})),l}var p=Et(r,t,{},n);return t.forEach((function(t,o){p[o]=e(t,n,r)})),p}var f=Et(r,t,{},n);for(var h in t)f[h]=e(t[h],n,r);return f}(e,t,n)},exports.trace=Dt,exports.transaction=kt,exports.untracked=fe,exports.values=function(e){return vn(e)?wt(e).map((function(t){return e[t]})):nn(e)?wt(e).map((function(t){return e.get(t)})):an(e)?y(e.values()):Qt(e)?e.slice():i(!1)},exports.when=function(e,t,n){return 1===arguments.length||t&&"object"==typeof t?It(e,t):Rt(e,t,n||{})};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.25
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(7)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.25",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
			
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
		
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 310,
		"./af.js": 310,
		"./ar": 317,
		"./ar-dz": 311,
		"./ar-dz.js": 311,
		"./ar-kw": 312,
		"./ar-kw.js": 312,
		"./ar-ly": 313,
		"./ar-ly.js": 313,
		"./ar-ma": 314,
		"./ar-ma.js": 314,
		"./ar-sa": 315,
		"./ar-sa.js": 315,
		"./ar-tn": 316,
		"./ar-tn.js": 316,
		"./ar.js": 317,
		"./az": 318,
		"./az.js": 318,
		"./be": 319,
		"./be.js": 319,
		"./bg": 320,
		"./bg.js": 320,
		"./bm": 321,
		"./bm.js": 321,
		"./bn": 322,
		"./bn.js": 322,
		"./bo": 323,
		"./bo.js": 323,
		"./br": 324,
		"./br.js": 324,
		"./bs": 325,
		"./bs.js": 325,
		"./ca": 326,
		"./ca.js": 326,
		"./cs": 327,
		"./cs.js": 327,
		"./cv": 328,
		"./cv.js": 328,
		"./cy": 329,
		"./cy.js": 329,
		"./da": 330,
		"./da.js": 330,
		"./de": 333,
		"./de-at": 331,
		"./de-at.js": 331,
		"./de-ch": 332,
		"./de-ch.js": 332,
		"./de.js": 333,
		"./dv": 334,
		"./dv.js": 334,
		"./el": 335,
		"./el.js": 335,
		"./en-SG": 336,
		"./en-SG.js": 336,
		"./en-au": 337,
		"./en-au.js": 337,
		"./en-ca": 338,
		"./en-ca.js": 338,
		"./en-gb": 339,
		"./en-gb.js": 339,
		"./en-ie": 340,
		"./en-ie.js": 340,
		"./en-il": 341,
		"./en-il.js": 341,
		"./en-nz": 342,
		"./en-nz.js": 342,
		"./eo": 343,
		"./eo.js": 343,
		"./es": 346,
		"./es-do": 344,
		"./es-do.js": 344,
		"./es-us": 345,
		"./es-us.js": 345,
		"./es.js": 346,
		"./et": 347,
		"./et.js": 347,
		"./eu": 348,
		"./eu.js": 348,
		"./fa": 349,
		"./fa.js": 349,
		"./fi": 350,
		"./fi.js": 350,
		"./fo": 351,
		"./fo.js": 351,
		"./fr": 354,
		"./fr-ca": 352,
		"./fr-ca.js": 352,
		"./fr-ch": 353,
		"./fr-ch.js": 353,
		"./fr.js": 354,
		"./fy": 355,
		"./fy.js": 355,
		"./ga": 356,
		"./ga.js": 356,
		"./gd": 357,
		"./gd.js": 357,
		"./gl": 358,
		"./gl.js": 358,
		"./gom-latn": 359,
		"./gom-latn.js": 359,
		"./gu": 360,
		"./gu.js": 360,
		"./he": 361,
		"./he.js": 361,
		"./hi": 362,
		"./hi.js": 362,
		"./hr": 363,
		"./hr.js": 363,
		"./hu": 364,
		"./hu.js": 364,
		"./hy-am": 365,
		"./hy-am.js": 365,
		"./id": 366,
		"./id.js": 366,
		"./is": 367,
		"./is.js": 367,
		"./it": 369,
		"./it-ch": 368,
		"./it-ch.js": 368,
		"./it.js": 369,
		"./ja": 370,
		"./ja.js": 370,
		"./jv": 371,
		"./jv.js": 371,
		"./ka": 372,
		"./ka.js": 372,
		"./kk": 373,
		"./kk.js": 373,
		"./km": 374,
		"./km.js": 374,
		"./kn": 375,
		"./kn.js": 375,
		"./ko": 376,
		"./ko.js": 376,
		"./ku": 377,
		"./ku.js": 377,
		"./ky": 378,
		"./ky.js": 378,
		"./lb": 379,
		"./lb.js": 379,
		"./lo": 380,
		"./lo.js": 380,
		"./lt": 381,
		"./lt.js": 381,
		"./lv": 382,
		"./lv.js": 382,
		"./me": 383,
		"./me.js": 383,
		"./mi": 384,
		"./mi.js": 384,
		"./mk": 385,
		"./mk.js": 385,
		"./ml": 386,
		"./ml.js": 386,
		"./mn": 387,
		"./mn.js": 387,
		"./mr": 388,
		"./mr.js": 388,
		"./ms": 390,
		"./ms-my": 389,
		"./ms-my.js": 389,
		"./ms.js": 390,
		"./mt": 391,
		"./mt.js": 391,
		"./my": 392,
		"./my.js": 392,
		"./nb": 393,
		"./nb.js": 393,
		"./ne": 394,
		"./ne.js": 394,
		"./nl": 396,
		"./nl-be": 395,
		"./nl-be.js": 395,
		"./nl.js": 396,
		"./nn": 397,
		"./nn.js": 397,
		"./pa-in": 398,
		"./pa-in.js": 398,
		"./pl": 399,
		"./pl.js": 399,
		"./pt": 401,
		"./pt-br": 400,
		"./pt-br.js": 400,
		"./pt.js": 401,
		"./ro": 402,
		"./ro.js": 402,
		"./ru": 403,
		"./ru.js": 403,
		"./sd": 404,
		"./sd.js": 404,
		"./se": 405,
		"./se.js": 405,
		"./si": 406,
		"./si.js": 406,
		"./sk": 407,
		"./sk.js": 407,
		"./sl": 408,
		"./sl.js": 408,
		"./sq": 409,
		"./sq.js": 409,
		"./sr": 411,
		"./sr-cyrl": 410,
		"./sr-cyrl.js": 410,
		"./sr.js": 411,
		"./ss": 412,
		"./ss.js": 412,
		"./sv": 413,
		"./sv.js": 413,
		"./sw": 414,
		"./sw.js": 414,
		"./ta": 415,
		"./ta.js": 415,
		"./te": 416,
		"./te.js": 416,
		"./tet": 417,
		"./tet.js": 417,
		"./tg": 418,
		"./tg.js": 418,
		"./th": 419,
		"./th.js": 419,
		"./tl-ph": 420,
		"./tl-ph.js": 420,
		"./tlh": 421,
		"./tlh.js": 421,
		"./tr": 422,
		"./tr.js": 422,
		"./tzl": 423,
		"./tzl.js": 423,
		"./tzm": 425,
		"./tzm-latn": 424,
		"./tzm-latn.js": 424,
		"./tzm.js": 425,
		"./ug-cn": 426,
		"./ug-cn.js": 426,
		"./uk": 427,
		"./uk.js": 427,
		"./ur": 428,
		"./ur.js": 428,
		"./uz": 430,
		"./uz-latn": 429,
		"./uz-latn.js": 429,
		"./uz.js": 430,
		"./vi": 431,
		"./vi.js": 431,
		"./x-pseudo": 432,
		"./x-pseudo.js": 432,
		"./yo": 433,
		"./yo.js": 433,
		"./zh-cn": 434,
		"./zh-cn.js": 434,
		"./zh-hk": 435,
		"./zh-hk.js": 435,
		"./zh-tw": 436,
		"./zh-tw.js": 436
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1061;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(439);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(28);
	
	var ReactPropTypesSecret = __webpack_require__(439);
	var checkPropTypes = __webpack_require__(1063);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1067);


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(1069);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1068);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(968);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(970);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(972);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(971);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(88);
	
	var _PropTypes = __webpack_require__(440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 1069 */
[1264, 1070],
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1072);


/***/ },
/* 1072 */
[1264, 1073],
/* 1073 */
1070,
/* 1074 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(42);
	
	var focusNode = __webpack_require__(299);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(125);
	var ExecutionEnvironment = __webpack_require__(51);
	var FallbackCompositionState = __webpack_require__(1082);
	var SyntheticCompositionEvent = __webpack_require__(1119);
	var SyntheticInputEvent = __webpack_require__(1122);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(441);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactInstrumentation = __webpack_require__(60);
	
	var camelizeStyleName = __webpack_require__(1016);
	var dangerousStyleValue = __webpack_require__(1128);
	var hyphenateStyleName = __webpack_require__(1023);
	var memoizeStringOnly = __webpack_require__(1026);
	var warning = __webpack_require__(27);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(124);
	var EventPropagators = __webpack_require__(125);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactUpdates = __webpack_require__(70);
	var SyntheticEvent = __webpack_require__(81);
	
	var inputValueTracking = __webpack_require__(457);
	var getEventTarget = __webpack_require__(215);
	var isEventSupported = __webpack_require__(216);
	var isTextInputElement = __webpack_require__(459);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var DOMLazyTree = __webpack_require__(109);
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createNodesFromMarkup = __webpack_require__(1019);
	var emptyFunction = __webpack_require__(57);
	var invariant = __webpack_require__(20);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1080 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(125);
	var ReactDOMComponentTree = __webpack_require__(42);
	var SyntheticMouseEvent = __webpack_require__(155);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var PooledClass = __webpack_require__(99);
	
	var getTextContentAccessor = __webpack_require__(456);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(110);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(111);
	
	var instantiateReactComponent = __webpack_require__(458);
	var KeyEscapeUtils = __webpack_require__(207);
	var shouldUpdateReactComponent = __webpack_require__(217);
	var traverseAllChildren = __webpack_require__(461);
	var warning = __webpack_require__(27);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(481);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(203);
	var ReactDOMIDOperations = __webpack_require__(1092);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var React = __webpack_require__(115);
	var ReactComponentEnvironment = __webpack_require__(209);
	var ReactCurrentOwner = __webpack_require__(82);
	var ReactErrorUtils = __webpack_require__(210);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(60);
	var ReactNodeTypes = __webpack_require__(451);
	var ReactReconciler = __webpack_require__(111);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(150);
	var invariant = __webpack_require__(20);
	var shallowEqual = __webpack_require__(197);
	var shouldUpdateReactComponent = __webpack_require__(217);
	var warning = __webpack_require__(27);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactDefaultInjection = __webpack_require__(1100);
	var ReactMount = __webpack_require__(450);
	var ReactReconciler = __webpack_require__(111);
	var ReactUpdates = __webpack_require__(70);
	var ReactVersion = __webpack_require__(1113);
	
	var findDOMNode = __webpack_require__(1129);
	var getHostComponentFromComposite = __webpack_require__(455);
	var renderSubtreeIntoContainer = __webpack_require__(1136);
	var warning = __webpack_require__(27);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var AutoFocusUtils = __webpack_require__(1075);
	var CSSPropertyOperations = __webpack_require__(1077);
	var DOMLazyTree = __webpack_require__(109);
	var DOMNamespaces = __webpack_require__(204);
	var DOMProperty = __webpack_require__(110);
	var DOMPropertyOperations = __webpack_require__(443);
	var EventPluginHub = __webpack_require__(124);
	var EventPluginRegistry = __webpack_require__(205);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactDOMComponentFlags = __webpack_require__(444);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactDOMInput = __webpack_require__(1093);
	var ReactDOMOption = __webpack_require__(1094);
	var ReactDOMSelect = __webpack_require__(445);
	var ReactDOMTextarea = __webpack_require__(1097);
	var ReactInstrumentation = __webpack_require__(60);
	var ReactMultiChild = __webpack_require__(1106);
	var ReactServerRenderingTransaction = __webpack_require__(1111);
	
	var emptyFunction = __webpack_require__(57);
	var escapeTextContentForBrowser = __webpack_require__(157);
	var invariant = __webpack_require__(20);
	var isEventSupported = __webpack_require__(216);
	var shallowEqual = __webpack_require__(197);
	var inputValueTracking = __webpack_require__(457);
	var validateDOMNesting = __webpack_require__(218);
	var warning = __webpack_require__(27);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(218);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var DOMLazyTree = __webpack_require__(109);
	var ReactDOMComponentTree = __webpack_require__(42);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1091 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(203);
	var ReactDOMComponentTree = __webpack_require__(42);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var DOMPropertyOperations = __webpack_require__(443);
	var LinkedValueUtils = __webpack_require__(208);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactUpdates = __webpack_require__(70);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var React = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactDOMSelect = __webpack_require__(445);
	
	var warning = __webpack_require__(27);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var getNodeForCharacterOffset = __webpack_require__(1133);
	var getTextContentAccessor = __webpack_require__(456);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var DOMChildrenOperations = __webpack_require__(203);
	var DOMLazyTree = __webpack_require__(109);
	var ReactDOMComponentTree = __webpack_require__(42);
	
	var escapeTextContentForBrowser = __webpack_require__(157);
	var invariant = __webpack_require__(20);
	var validateDOMNesting = __webpack_require__(218);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(28);
	
	var LinkedValueUtils = __webpack_require__(208);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactUpdates = __webpack_require__(70);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactUpdates = __webpack_require__(70);
	var Transaction = __webpack_require__(156);
	
	var emptyFunction = __webpack_require__(57);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1074);
	var BeforeInputEventPlugin = __webpack_require__(1076);
	var ChangeEventPlugin = __webpack_require__(1078);
	var DefaultEventPluginOrder = __webpack_require__(1080);
	var EnterLeaveEventPlugin = __webpack_require__(1081);
	var HTMLDOMPropertyConfig = __webpack_require__(1083);
	var ReactComponentBrowserEnvironment = __webpack_require__(1085);
	var ReactDOMComponent = __webpack_require__(1088);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactDOMEmptyComponent = __webpack_require__(1090);
	var ReactDOMTreeTraversal = __webpack_require__(1098);
	var ReactDOMTextComponent = __webpack_require__(1096);
	var ReactDefaultBatchingStrategy = __webpack_require__(1099);
	var ReactEventListener = __webpack_require__(1103);
	var ReactInjection = __webpack_require__(1104);
	var ReactReconcileTransaction = __webpack_require__(1109);
	var SVGDOMPropertyConfig = __webpack_require__(1114);
	var SelectEventPlugin = __webpack_require__(1115);
	var SimpleEventPlugin = __webpack_require__(1116);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1101 */
482,
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(124);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var EventListener = __webpack_require__(298);
	var ExecutionEnvironment = __webpack_require__(51);
	var PooledClass = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactUpdates = __webpack_require__(70);
	
	var getEventTarget = __webpack_require__(215);
	var getUnboundedScrollPosition = __webpack_require__(1021);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(110);
	var EventPluginHub = __webpack_require__(124);
	var EventPluginUtils = __webpack_require__(206);
	var ReactComponentEnvironment = __webpack_require__(209);
	var ReactEmptyComponent = __webpack_require__(446);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactHostComponent = __webpack_require__(448);
	var ReactUpdates = __webpack_require__(70);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1127);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactComponentEnvironment = __webpack_require__(209);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(60);
	
	var ReactCurrentOwner = __webpack_require__(82);
	var ReactReconciler = __webpack_require__(111);
	var ReactChildReconciler = __webpack_require__(1084);
	
	var emptyFunction = __webpack_require__(57);
	var flattenChildren = __webpack_require__(1130);
	var invariant = __webpack_require__(20);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1108 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var CallbackQueue = __webpack_require__(442);
	var PooledClass = __webpack_require__(99);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactInputSelection = __webpack_require__(449);
	var ReactInstrumentation = __webpack_require__(60);
	var Transaction = __webpack_require__(156);
	var ReactUpdateQueue = __webpack_require__(211);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1107);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var PooledClass = __webpack_require__(99);
	var Transaction = __webpack_require__(156);
	var ReactInstrumentation = __webpack_require__(60);
	var ReactServerUpdateQueue = __webpack_require__(1112);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(211);
	
	var warning = __webpack_require__(27);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1113 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 1114 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(125);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactInputSelection = __webpack_require__(449);
	var SyntheticEvent = __webpack_require__(81);
	
	var getActiveElement = __webpack_require__(300);
	var isTextInputElement = __webpack_require__(459);
	var shallowEqual = __webpack_require__(197);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var EventListener = __webpack_require__(298);
	var EventPropagators = __webpack_require__(125);
	var ReactDOMComponentTree = __webpack_require__(42);
	var SyntheticAnimationEvent = __webpack_require__(1117);
	var SyntheticClipboardEvent = __webpack_require__(1118);
	var SyntheticEvent = __webpack_require__(81);
	var SyntheticFocusEvent = __webpack_require__(1121);
	var SyntheticKeyboardEvent = __webpack_require__(1123);
	var SyntheticMouseEvent = __webpack_require__(155);
	var SyntheticDragEvent = __webpack_require__(1120);
	var SyntheticTouchEvent = __webpack_require__(1124);
	var SyntheticTransitionEvent = __webpack_require__(1125);
	var SyntheticUIEvent = __webpack_require__(127);
	var SyntheticWheelEvent = __webpack_require__(1126);
	
	var emptyFunction = __webpack_require__(57);
	var getEventCharCode = __webpack_require__(213);
	var invariant = __webpack_require__(20);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(81);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(81);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(81);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(155);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(127);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(81);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(127);
	
	var getEventCharCode = __webpack_require__(213);
	var getEventKey = __webpack_require__(1131);
	var getEventModifierState = __webpack_require__(214);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(127);
	
	var getEventModifierState = __webpack_require__(214);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(81);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(155);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1127 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(441);
	var warning = __webpack_require__(27);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(42);
	var ReactInstanceMap = __webpack_require__(126);
	
	var getHostComponentFromComposite = __webpack_require__(455);
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(27);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(207);
	var traverseAllChildren = __webpack_require__(461);
	var warning = __webpack_require__(27);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(481);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(213);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1132 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1133 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(157);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(450);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(21));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		function fileAccepted(file, accept) {
		  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		  // that MIME type will always be accepted
		  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
		}
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(evt) {
		      // allow the entire document to be a drag target
		      evt.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children, isDragActive, isDragReject) {
		      if (typeof children === 'function') {
		        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.setRefs = _this.setRefs.bind(_this);
		    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      draggedFiles: [],
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(evt) {
		      if (this.node.contains(evt.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      evt.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(evt) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(evt) {
		      evt.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(evt.target) === -1) {
		        this.dragTargets.push(evt.target);
		      }
		
		      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(evt) {
		      // eslint-disable-line class-methods-use-this
		      evt.preventDefault();
		      evt.stopPropagation();
		      try {
		        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, evt);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(evt) {
		      var _this2 = this;
		
		      evt.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== evt.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      // Clear dragging files state
		      this.setState({ draggedFiles: [] });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(evt) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview,
		          accept = _props.accept;
		
		      var fileList = (0, _getDataTransferItems2.default)(evt);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      evt.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (!multiple) {
		        // if not in multi mode add any extra accepted files to rejected.
		        // This will allow end users to easily ignore a multi file drop in "single" mode.
		        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
		      }
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, evt);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, evt);
		      }
		
		      // Clear files value
		      this.draggedFiles = null;
		
		      // Reset drag state
		      this.setState({
		        draggedFiles: [],
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(evt) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        evt.stopPropagation();
		
		        if (onClick) {
		          onClick.call(this, evt);
		        }
		
		        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
		        // this is so react can handle state changes in the onClick prop above above
		        // see: https://github.com/okonet/react-dropzone/issues/450
		        setTimeout(this.open.bind(this), 0);
		      }
		    }
		  }, {
		    key: 'onInputElementClick',
		    value: function onInputElementClick(evt) {
		      evt.stopPropagation();
		      if (this.props.inputProps && this.props.inputProps.onClick) {
		        this.props.inputProps.onClick();
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'setRefs',
		    value: function setRefs(ref) {
		      this.fileInputEl = ref;
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this4 = this;
		
		      return files.every(function (file) {
		        return fileAccepted(file, _this4.props.accept);
		      });
		    }
		
		    /**
		     * Open system file upload dialog.
		     *
		     * @public
		     */
		
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var draggedFiles = this.state.draggedFiles;
		
		      var filesCount = draggedFiles.length;
		      var isMultipleAllowed = multiple || filesCount <= 1;
		      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
		      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          borderColor: '#6c6',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          borderColor: '#c66',
		          backgroundColor: '#eee'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: this.setRefs,
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children, isDragActive, isDragReject),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.propTypes = {
		  /**
		   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
		   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
		   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
		   * Windows. In some cases there might not be a mime type set at all.
		   * See: https://github.com/okonet/react-dropzone/issues/276
		   */
		  accept: _propTypes2.default.string,
		
		  /**
		   * Contents of the dropzone
		   */
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		
		  /**
		   * Disallow clicking on the dropzone container to open file dialog
		   */
		  disableClick: _propTypes2.default.bool,
		
		  /**
		   * Enable/disable preview generation
		   */
		  disablePreview: _propTypes2.default.bool,
		
		  /**
		   * If false, allow dropped items to take over the current browser window
		   */
		  preventDropOnDocument: _propTypes2.default.bool,
		
		  /**
		   * Pass additional attributes to the `<input type="file"/>` tag
		   */
		  inputProps: _propTypes2.default.object,
		
		  /**
		   * Allow dropping multiple files
		   */
		  multiple: _propTypes2.default.bool,
		
		  /**
		   * `name` attribute for the input tag
		   */
		  name: _propTypes2.default.string,
		
		  /**
		   * Maximum file size
		   */
		  maxSize: _propTypes2.default.number,
		
		  /**
		   * Minimum file size
		   */
		  minSize: _propTypes2.default.number,
		
		  /**
		   * className
		   */
		  className: _propTypes2.default.string,
		
		  /**
		   * className for accepted state
		   */
		  activeClassName: _propTypes2.default.string,
		
		  /**
		   * className for rejected state
		   */
		  rejectClassName: _propTypes2.default.string,
		
		  /**
		   * CSS styles to apply
		   */
		  style: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be accepted
		   */
		  activeStyle: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be rejected
		   */
		  rejectStyle: _propTypes2.default.object,
		
		  /**
		   * onClick callback
		   * @param {Event} event
		   */
		  onClick: _propTypes2.default.func,
		
		  /**
		   * onDrop callback
		   */
		  onDrop: _propTypes2.default.func,
		
		  /**
		   * onDropAccepted callback
		   */
		  onDropAccepted: _propTypes2.default.func,
		
		  /**
		   * onDropRejected callback
		   */
		  onDropRejected: _propTypes2.default.func,
		
		  /**
		   * onDragStart callback
		   */
		  onDragStart: _propTypes2.default.func,
		
		  /**
		   * onDragEnter callback
		   */
		  onDragEnter: _propTypes2.default.func,
		
		  /**
		   * onDragOver callback
		   */
		  onDragOver: _propTypes2.default.func,
		
		  /**
		   * onDragLeave callback
		   */
		  onDragLeave: _propTypes2.default.func,
		
		  /**
		   * Provide a callback on clicking the cancel button of the file dialog
		   */
		  onFileDialogCancel: _propTypes2.default.func
		};
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(21));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports.default = exports.testModeAPI = exports.OutboundLink = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI.default.ga.apply(_testModeAPI.default, arguments);
	  if (typeof window === 'undefined') return false;
	  if (!window.ga) return (0, _warn.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn.default)('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (typeof window === 'undefined') {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA.default)(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn.default)('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'arguments\');');
	      (0, _log.default)("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log.default)('called ga(\'set\', fieldsObject);');
	    (0, _log.default)("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log.default)('called ga(\'send\', fieldObject);');
	    (0, _log.default)("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log.default)("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim.default)(rawPath);
	
	  if (path === '') {
	    (0, _warn.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log.default)("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash.default)((0, _trim.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log.default)("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn.default)('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim.default)(rawName);
	
	      if (name === '') {
	        (0, _warn.default)('`name` cannot be an empty string in .require()');
	        return;
	      } // Optional Fields
	
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log.default)("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log.default)("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	            (0, _log.default)("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	            (0, _log.default)("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn.default)('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink.default.origTrackLink = _OutboundLink.default.trackLink;
	_OutboundLink.default.trackLink = outboundLink;
	var OutboundLink = _OutboundLink.default;
	exports.OutboundLink = OutboundLink;
	var testModeAPI = _testModeAPI.default;
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink,
	  testModeAPI: _testModeAPI.default
	};
	exports.default = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail.default)(s)) {
	    (0, _warn.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return /[^@]+@[^@]+/.test(s);
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push(args.concat());
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports.default = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(11));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(12));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      return _react.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports.default = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn.default)('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes.default.string.isRequired,
	  target: _propTypes.default.string,
	  to: _propTypes.default.string,
	  onClick: _propTypes.default.func
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null
	});
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _warn = __webpack_require__(1141);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://developers.google.com/tag-manager/quickstart
	
	var Snippets = {
	  tags: function tags(_ref) {
	    var id = _ref.id,
	        events = _ref.events,
	        dataLayer = _ref.dataLayer,
	        dataLayerName = _ref.dataLayerName,
	        preview = _ref.preview,
	        auth = _ref.auth;
	
	    var gtm_auth = '&gtm_auth=' + auth;
	    var gtm_preview = '&gtm_preview=' + preview;
	
	    if (!id) (0, _warn2.default)('GTM Id is required');
	
	    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
	
	    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
	
	    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
	
	    return {
	      iframe: iframe,
	      script: script,
	      dataLayerVar: dataLayerVar
	    };
	  },
	  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
	    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
	  }
	};
	
	module.exports = Snippets;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Snippets = __webpack_require__(1139);
	
	var _Snippets2 = _interopRequireDefault(_Snippets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagManager = {
	  dataScript: function dataScript(dataLayer) {
	    var script = document.createElement('script');
	    script.innerHTML = dataLayer;
	    return script;
	  },
	  gtm: function gtm(args) {
	    var snippets = _Snippets2.default.tags(args);
	
	    var noScript = function noScript() {
	      var noscript = document.createElement('noscript');
	      noscript.innerHTML = snippets.iframe;
	      return noscript;
	    };
	
	    var script = function script() {
	      var script = document.createElement('script');
	      script.innerHTML = snippets.script;
	      return script;
	    };
	
	    var dataScript = this.dataScript(snippets.dataLayerVar);
	
	    return {
	      noScript: noScript,
	      script: script,
	      dataScript: dataScript
	    };
	  },
	  initialize: function initialize(_ref) {
	    var gtmId = _ref.gtmId,
	        _ref$events = _ref.events,
	        events = _ref$events === undefined ? {} : _ref$events,
	        dataLayer = _ref.dataLayer,
	        _ref$dataLayerName = _ref.dataLayerName,
	        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
	        _ref$auth = _ref.auth,
	        auth = _ref$auth === undefined ? '' : _ref$auth,
	        _ref$preview = _ref.preview,
	        preview = _ref$preview === undefined ? '' : _ref$preview;
	
	    var gtm = this.gtm({
	      id: gtmId,
	      events: events,
	      dataLayer: dataLayer || undefined,
	      dataLayerName: dataLayerName,
	      auth: auth,
	      preview: preview
	    });
	    if (dataLayer) document.head.appendChild(gtm.dataScript);
	    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
	    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
	  },
	  dataLayer: function dataLayer(_ref2) {
	    var _dataLayer = _ref2.dataLayer,
	        _ref2$dataLayerName = _ref2.dataLayerName,
	        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
	
	    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
	    var dataScript = this.dataScript(snippets);
	    document.head.appendChild(dataScript);
	  }
	};
	
	module.exports = TagManager;

/***/ },
/* 1141 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var warn = function warn(s) {
	  console.warn('[react-gtm]', s);
	};
	
	exports.default = warn;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(108);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(219);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ },
/* 1143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ },
/* 1144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ },
/* 1145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(464);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(219);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(464);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(1145);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(465);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ },
/* 1148 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ },
/* 1149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(108);
	
	var _TextElementType = __webpack_require__(1148);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(1147);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(1146);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(1149);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(219);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(463);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(108);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(1142);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(1143);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(1144);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(465);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ },
/* 1153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ },
/* 1154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IntercomAPI = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1157);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var IntercomAPI = exports.IntercomAPI = function IntercomAPI() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (canUseDOM && window.Intercom) {
	    window.Intercom.apply(null, args);
	  } else {
	    console.warn('Intercom not initialized yet');
	  }
	};
	
	var Intercom = function (_Component) {
	  _inherits(Intercom, _Component);
	
	  function Intercom(props) {
	    _classCallCheck(this, Intercom);
	
	    var _this = _possibleConstructorReturn(this, (Intercom.__proto__ || Object.getPrototypeOf(Intercom)).call(this, props));
	
	    var appID = props.appID,
	        otherProps = _objectWithoutProperties(props, ['appID']);
	
	    if (!appID || !canUseDOM) {
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (!window.Intercom) {
	      (function (w, d, id, s, x) {
	        function i() {
	          i.c(arguments);
	        }
	        i.q = [];
	        i.c = function (args) {
	          i.q.push(args);
	        };
	        w.Intercom = i;
	        s = d.createElement('script');
	        s.async = 1;
	        s.src = 'https://widget.intercom.io/widget/' + id;
	        d.head.appendChild(s);
	      })(window, document, appID);
	    }
	
	    window.intercomSettings = _extends({}, otherProps, { app_id: appID });
	
	    if (window.Intercom) {
	      window.Intercom('boot', otherProps);
	    }
	    return _this;
	  }
	
	  _createClass(Intercom, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var appID = nextProps.appID,
	          otherProps = _objectWithoutProperties(nextProps, ['appID']);
	
	      if (!canUseDOM) return;
	
	      window.intercomSettings = _extends({}, otherProps, { app_id: appID });
	
	      if (window.Intercom) {
	        if (this.loggedIn(this.props) && !this.loggedIn(nextProps)) {
	          // Shutdown and boot each time the user logs out to clear conversations
	          window.Intercom('shutdown');
	          window.Intercom('boot', otherProps);
	        } else {
	          window.Intercom('update', otherProps);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!canUseDOM || !window.Intercom) return false;
	
	      window.Intercom('shutdown');
	
	      delete window.Intercom;
	      delete window.intercomSettings;
	    }
	  }, {
	    key: 'loggedIn',
	    value: function loggedIn(props) {
	      return props.email || props.user_id;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return false;
	    }
	  }]);
	
	  return Intercom;
	}(_react.Component);
	
	Intercom.propTypes = {
	  appID: _propTypes2.default.string.isRequired
	};
	Intercom.displayName = 'Intercom';
	exports.default = Intercom;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(57);
	var invariant = __webpack_require__(20);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1156)();
	}


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(88);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.props.disableOnClickOutside) return;
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(466);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _routerWarning = __webpack_require__(113);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(468);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _routerWarning = __webpack_require__(113);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(90);
	
	var _InternalPropTypes = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(90);
	
	var _InternalPropTypes = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(21);
	
	var _createTransitionManager2 = __webpack_require__(472);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(128);
	
	var _RouterContext = __webpack_require__(223);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(90);
	
	var _RouterUtils = __webpack_require__(469);
	
	var _routerWarning = __webpack_require__(113);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(220);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(223);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(113);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1178);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(471);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(112);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(220);
	
	var _PromiseUtils = __webpack_require__(467);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(112);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1179);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(471);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(112);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(159);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(470);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(472);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(90);
	
	var _RouterUtils = __webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(220);
	
	var _PromiseUtils = __webpack_require__(467);
	
	var _PatternUtils = __webpack_require__(112);
	
	var _routerWarning = __webpack_require__(113);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(68);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1182);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(221);
	
	var _PropTypes = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1175 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(224);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(114);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _DOMStateStorage = __webpack_require__(474);
	
	var _PathUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(224);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(114);
	
	var _PathUtils = __webpack_require__(91);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(225);
	
	var _BrowserProtocol = __webpack_require__(224);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1177);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _createHistory = __webpack_require__(226);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(225);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _HashProtocol = __webpack_require__(1176);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(226);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(114);
	
	var _PathUtils = __webpack_require__(91);
	
	var _createHistory = __webpack_require__(226);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1183);
	var objectAssign = __webpack_require__(28);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1182 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1183 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1186).enable();
	  window.Promise = __webpack_require__(1185);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1187);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(28);


/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(477);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(477);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1187 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	(function(root) {
	
	  // administrative
	  var registeredComponents = [];
	  var handlers = [];
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
	
	  /**
	   * Check whether some DOM node is our Component's node.
	   */
	  var isNodeFound = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (current.correspondingElement) {
	      return current.correspondingElement.classList.contains(ignoreClass);
	    }
	    return current.classList.contains(ignoreClass);
	  };
	
	  /**
	   * Try to find our node in a hierarchy of nodes, returning the document
	   * node as highest noode if our node is not found in the path up.
	   */
	  var findHighest = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	
	    // If source=local then this event came from 'somewhere'
	    // inside and should be ignored. We could handle this with
	    // a layered approach, too, but that requires going back to
	    // thinking in terms of Dom node nesting, running counter
	    // to React's 'you shouldn't care about the DOM' philosophy.
	    while(current.parentNode) {
	      if (isNodeFound(current, componentNode, ignoreClass)) {
	        return true;
	      }
	      current = current.parentNode;
	    }
	    return current;
	  };
	
	  /**
	   * Check if the browser scrollbar was clicked
	   */
	  var clickedScrollbar = function(evt) {
	    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	  };
	
	  /**
	   * Generate the event handler that checks whether a clicked DOM node
	   * is inside of, or lives outside of, our Component's node tree.
	   */
	  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	    return function(evt) {
	      if (preventDefault) {
	        evt.preventDefault();
	      }
	      if (stopPropagation) {
	        evt.stopPropagation();
	      }
	      var current = evt.target;
	      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
	        return;
	      }
	      eventHandler(evt);
	    };
	  };
	
	  /**
	   * This function generates the HOC function that you'll use
	   * in order to impart onOutsideClick listening to an
	   * arbitrary component. It gets called at the end of the
	   * bootstrapping code to yield an instance of the
	   * onClickOutsideHOC function defined inside setupHOC().
	   */
	  function setupHOC(root, React, ReactDOM, createReactClass) {
	
	    // The actual Component-wrapping HOC:
	    return function onClickOutsideHOC(Component, config) {
	      var wrapComponentWithOnClickOutsideHandling = createReactClass({
	        statics: {
	          /**
	           * Access the wrapped Component's class.
	           */
	          getClass: function() {
	            if (Component.getClass) {
	              return Component.getClass();
	            }
	            return Component;
	          }
	        },
	
	        /**
	         * Access the wrapped Component's instance.
	         */
	        getInstance: function() {
	          return Component.prototype.isReactComponent ? this.refs.instance : this;
	        },
	
	        // this is given meaning in componentDidMount
	        __outsideClickHandler: function() {},
	
	        getDefaultProps: function() {
	          return {
	            excludeScrollbar: config && config.excludeScrollbar
	          };
	        },
	
	        /**
	         * Add click listeners to the current document,
	         * linked to this component's state.
	         */
	        componentDidMount: function() {
	          // If we are in an environment without a DOM such
	          // as shallow rendering or snapshots then we exit
	          // early to prevent any unhandled errors being thrown.
	          if (typeof document === 'undefined' || !document.createElement){
	            return;
	          }
	
	          var instance = this.getInstance();
	          var clickOutsideHandler;
	
	          if(config && typeof config.handleClickOutside === 'function') {
	            clickOutsideHandler = config.handleClickOutside(instance);
	            if(typeof clickOutsideHandler !== 'function') {
	              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
	            }
	          } else if(typeof instance.handleClickOutside === 'function') {
	            if (React.Component.prototype.isPrototypeOf(instance)) {
	              clickOutsideHandler = instance.handleClickOutside.bind(instance);
	            } else {
	              clickOutsideHandler = instance.handleClickOutside;
	            }
	          } else if(typeof instance.props.handleClickOutside === 'function') {
	            clickOutsideHandler = instance.props.handleClickOutside;
	          } else {
	            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
	          }
	
	          var componentNode = ReactDOM.findDOMNode(instance);
	          if (componentNode === null) {
	            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
	            console.warn([
	              'This is typically caused by having a component that starts life with a render function that',
	              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
	              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
	              'decision of whether or not to show your component is handled by the parent, in their render()',
	              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
	              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
	              'the parent is always responsible for deciding whether or not to render any of its children.',
	              'It is not the child\'s responsibility to decide whether a render instruction from above should',
	              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
	              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
	              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
	              'for that decision.'
	            ].join(' '));
	          }
	
	          var fn = this.__outsideClickHandler = generateOutsideCheck(
	            componentNode,
	            instance,
	            clickOutsideHandler,
	            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
	            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
	            this.props.preventDefault || false,
	            this.props.stopPropagation || false
	          );
	
	          var pos = registeredComponents.length;
	          registeredComponents.push(this);
	          handlers[pos] = fn;
	
	          // If there is a truthy disableOnClickOutside property for this
	          // component, don't immediately start listening for outside events.
	          if (!this.props.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          }
	        },
	
	        /**
	        * Track for disableOnClickOutside props changes and enable/disable click outside
	        */
	        componentWillReceiveProps: function(nextProps) {
	          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	            this.disableOnClickOutside();
	          }
	        },
	
	        /**
	         * Remove the document's event listeners
	         */
	        componentWillUnmount: function() {
	          this.disableOnClickOutside();
	          this.__outsideClickHandler = false;
	          var pos = registeredComponents.indexOf(this);
	          if( pos>-1) {
	            // clean up so we don't leak memory
	            if (handlers[pos]) { handlers.splice(pos, 1); }
	            registeredComponents.splice(pos, 1);
	          }
	        },
	
	        /**
	         * Can be called to explicitly enable event listening
	         * for clicks and touches outside of this element.
	         */
	        enableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.addEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Can be called to explicitly disable event listening
	         * for clicks and touches outside of this element.
	         */
	        disableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.removeEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Pass-through render
	         */
	        render: function() {
	          var passedProps = this.props;
	          var props = {};
	          Object.keys(this.props).forEach(function(key) {
	            if (key !== 'excludeScrollbar') {
	              props[key] = passedProps[key];
	            }
	          });
	          if (Component.prototype.isReactComponent) {
	            props.ref = 'instance';
	          }
	          props.disableOnClickOutside = this.disableOnClickOutside;
	          props.enableOnClickOutside = this.enableOnClickOutside;
	          return React.createElement(Component, props);
	        }
	      });
	
	      // Add display name for React devtools
	      (function bindWrappedComponentName(c, wrapper) {
	        var componentName = c.displayName || c.name || 'Component';
	        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
	      }(Component, wrapComponentWithOnClickOutsideHandling));
	
	      return wrapComponentWithOnClickOutsideHandling;
	    };
	  }
	
	  /**
	   * This function sets up the library in ways that
	   * work with the various modulde loading solutions
	   * used in JavaScript land today.
	   */
	  function setupBinding(root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(88),__webpack_require__(68)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
	        if (!createReactClass) createReactClass = React.createClass;
	        return factory(root, React, ReactDom, createReactClass);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      // Node. Note that this does not work with strict
	      // CommonJS, but only CommonJS-like environments
	      // that support module.exports
	      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
	    } else {
	      // Browser globals (root is window)
	      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
	      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
	    }
	  }
	
	  // Make it all happen
	  setupBinding(root, setupHOC);
	
	}(this));


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(106);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(106);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ },
/* 1192 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(88);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(1192);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(1056);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(106);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(161);
	
	var _track = __webpack_require__(1195);
	
	var _dots = __webpack_require__(1191);
	
	var _arrows = __webpack_require__(1189);
	
	var _resizeObserverPolyfill = __webpack_require__(1218);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	      // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(1193);
	
	var _json2mq = __webpack_require__(1055);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(1190);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(994);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(106);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(478);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _star = __webpack_require__(1197);
	
	var _star2 = _interopRequireDefault(_star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarRatings = function (_React$Component) {
	  _inherits(StarRatings, _React$Component);
	
	  function StarRatings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StarRatings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StarRatings.__proto__ || Object.getPrototypeOf(StarRatings)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      highestStarHovered: -Infinity
	    }, _this.fillId = 'starGrad' + Math.random().toFixed(15).slice(2), _this.hoverOverStar = function (starRating) {
	      return function () {
	        _this.setState({
	          highestStarHovered: starRating
	        });
	      };
	    }, _this.unHoverOverStar = function () {
	      _this.setState({
	        highestStarHovered: -Infinity
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StarRatings, [{
	    key: 'stopColorStyle',
	    value: function stopColorStyle(color) {
	      var stopColorStyle = {
	        stopColor: color,
	        stopOpacity: '1'
	      };
	      return this.props.ignoreInlineStyles ? {} : stopColorStyle;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          starRatedColor = _props.starRatedColor,
	          starEmptyColor = _props.starEmptyColor;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'star-ratings',
	          title: this.titleText,
	          style: this.starRatingsStyle
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: 'star-grad',
	            style: this.starGradientStyle
	          },
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement(
	              'linearGradient',
	              { id: this.fillId, x1: '0%', y1: '0%', x2: '100%', y2: '0%' },
	              _react2.default.createElement('stop', { offset: '0%', className: 'stop-color-first', style: this.stopColorStyle(starRatedColor) }),
	              _react2.default.createElement('stop', { offset: this.offsetValue, className: 'stop-color-first', style: this.stopColorStyle(starRatedColor) }),
	              _react2.default.createElement('stop', { offset: this.offsetValue, className: 'stop-color-final', style: this.stopColorStyle(starEmptyColor) }),
	              _react2.default.createElement('stop', { offset: '100%', className: 'stop-color-final', style: this.stopColorStyle(starEmptyColor) })
	            )
	          )
	        ),
	        this.renderStars
	      );
	    }
	  }, {
	    key: 'starRatingsStyle',
	    get: function get() {
	      var starRatingsStyle = {
	        position: 'relative',
	        boxSizing: 'border-box',
	        display: 'inline-block'
	      };
	      return this.props.ignoreInlineStyles ? {} : starRatingsStyle;
	    }
	  }, {
	    key: 'starGradientStyle',
	    get: function get() {
	      var starGradientStyle = {
	        position: 'absolute',
	        zIndex: '0',
	        width: '0',
	        height: '0',
	        visibility: 'hidden'
	      };
	      return this.props.ignoreInlineStyles ? {} : starGradientStyle;
	    }
	  }, {
	    key: 'titleText',
	    get: function get() {
	      var _props2 = this.props,
	          typeOfWidget = _props2.typeOfWidget,
	          selectedRating = _props2.rating;
	
	      var hoveredRating = this.state.highestStarHovered;
	      var currentRating = hoveredRating > 0 ? hoveredRating : selectedRating;
	      // fix it at 2 decimal places and remove trailing 0s
	      var formattedRating = parseFloat(currentRating.toFixed(2)).toString();
	      if (Number.isInteger(currentRating)) {
	        formattedRating = String(currentRating);
	      }
	      var starText = typeOfWidget + 's';
	      if (formattedRating === '1') {
	        starText = typeOfWidget;
	      }
	      return formattedRating + ' ' + starText;
	    }
	  }, {
	    key: 'offsetValue',
	    get: function get() {
	      var rating = this.props.rating;
	      var ratingIsInteger = Number.isInteger(rating);
	      var offsetValue = '0%';
	      if (!ratingIsInteger) {
	        var firstTwoDecimals = rating.toFixed(2).split('.')[1].slice(0, 2);
	        offsetValue = firstTwoDecimals + '%';
	      }
	      return offsetValue;
	    }
	  }, {
	    key: 'renderStars',
	    get: function get() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          changeRating = _props3.changeRating,
	          selectedRating = _props3.rating,
	          numberOfStars = _props3.numberOfStars,
	          starDimension = _props3.starDimension,
	          starSpacing = _props3.starSpacing,
	          starRatedColor = _props3.starRatedColor,
	          starEmptyColor = _props3.starEmptyColor,
	          starHoverColor = _props3.starHoverColor,
	          gradientPathName = _props3.gradientPathName,
	          ignoreInlineStyles = _props3.ignoreInlineStyles,
	          svgIconPath = _props3.svgIconPath,
	          svgIconViewBox = _props3.svgIconViewBox,
	          name = _props3.name;
	      var highestStarHovered = this.state.highestStarHovered;
	
	
	      var numberOfStarsArray = Array.apply(null, Array(numberOfStars));
	
	      return numberOfStarsArray.map(function (_, index) {
	        var starRating = index + 1;
	        var isStarred = starRating <= selectedRating;
	
	        // hovered only matters when changeRating is true
	        var hoverMode = highestStarHovered > 0;
	        var isHovered = starRating <= highestStarHovered;
	        var isCurrentHoveredStar = starRating === highestStarHovered;
	
	        // only matters when changeRating is false
	        // given star 5 and rating 4.2:  5 > 4.2 && 4 < 4.2;
	        var isPartiallyFullStar = starRating > selectedRating && starRating - 1 < selectedRating;
	
	        var isFirstStar = starRating === 1;
	        var isLastStar = starRating === numberOfStars;
	
	        return _react2.default.createElement(_star2.default, {
	          key: starRating,
	          fillId: _this2.fillId,
	          changeRating: changeRating ? function () {
	            return changeRating(starRating, name);
	          } : null,
	          hoverOverStar: changeRating ? _this2.hoverOverStar(starRating) : null,
	          unHoverOverStar: changeRating ? _this2.unHoverOverStar : null,
	          isStarred: isStarred,
	          isPartiallyFullStar: isPartiallyFullStar,
	          isHovered: isHovered,
	          hoverMode: hoverMode,
	          isCurrentHoveredStar: isCurrentHoveredStar,
	          isFirstStar: isFirstStar,
	          isLastStar: isLastStar,
	          starDimension: starDimension,
	          starSpacing: starSpacing,
	          starHoverColor: starHoverColor,
	          starRatedColor: starRatedColor,
	          starEmptyColor: starEmptyColor,
	          gradientPathName: gradientPathName,
	          ignoreInlineStyles: ignoreInlineStyles,
	          svgIconPath: svgIconPath,
	          svgIconViewBox: svgIconViewBox
	        });
	      });
	    }
	  }]);
	
	  return StarRatings;
	}(_react2.default.Component);
	
	StarRatings.propTypes = {
	  rating: _propTypes2.default.number.isRequired,
	  numberOfStars: _propTypes2.default.number.isRequired,
	  changeRating: _propTypes2.default.func,
	  starHoverColor: _propTypes2.default.string.isRequired,
	  starRatedColor: _propTypes2.default.string.isRequired,
	  starEmptyColor: _propTypes2.default.string.isRequired,
	  starDimension: _propTypes2.default.string.isRequired,
	  starSpacing: _propTypes2.default.string.isRequired,
	  gradientPathName: _propTypes2.default.string.isRequired,
	  ignoreInlineStyles: _propTypes2.default.bool.isRequired,
	  svgIconPath: _propTypes2.default.string.isRequired,
	  svgIconViewBox: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string
	};
	
	StarRatings.defaultProps = {
	  rating: 0,
	  typeOfWidget: 'Star',
	  numberOfStars: 5,
	  changeRating: null,
	  starHoverColor: 'rgb(230, 67, 47)',
	  starRatedColor: 'rgb(109, 122, 130)',
	  starEmptyColor: 'rgb(203, 211, 227)',
	  starDimension: '50px',
	  starSpacing: '7px',
	  gradientPathName: '',
	  ignoreInlineStyles: false,
	  svgIconPath: 'm25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z',
	  svgIconViewBox: '0 0 51 48'
	};
	
	exports.default = StarRatings;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(478);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(106);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Star = function (_React$Component) {
	  _inherits(Star, _React$Component);
	
	  function Star() {
	    _classCallCheck(this, Star);
	
	    return _possibleConstructorReturn(this, (Star.__proto__ || Object.getPrototypeOf(Star)).apply(this, arguments));
	  }
	
	  _createClass(Star, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          changeRating = _props.changeRating,
	          hoverOverStar = _props.hoverOverStar,
	          unHoverOverStar = _props.unHoverOverStar,
	          svgIconViewBox = _props.svgIconViewBox,
	          svgIconPath = _props.svgIconPath;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'star-container',
	          style: this.starContainerStyle,
	          onMouseEnter: hoverOverStar,
	          onMouseLeave: unHoverOverStar,
	          onClick: changeRating
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            viewBox: svgIconViewBox,
	            className: this.starClasses,
	            style: this.starSvgStyle
	          },
	          _react2.default.createElement('path', {
	            className: 'star',
	            style: this.pathStyle,
	            d: svgIconPath
	          })
	        )
	      );
	    }
	  }, {
	    key: 'starContainerStyle',
	    get: function get() {
	      var _props2 = this.props,
	          changeRating = _props2.changeRating,
	          starSpacing = _props2.starSpacing,
	          isFirstStar = _props2.isFirstStar,
	          isLastStar = _props2.isLastStar,
	          ignoreInlineStyles = _props2.ignoreInlineStyles;
	
	
	      var starContainerStyle = {
	        position: 'relative',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        paddingLeft: isFirstStar ? undefined : starSpacing,
	        paddingRight: isLastStar ? undefined : starSpacing,
	        cursor: changeRating ? 'pointer' : undefined
	      };
	      return ignoreInlineStyles ? {} : starContainerStyle;
	    }
	  }, {
	    key: 'starSvgStyle',
	    get: function get() {
	      var _props3 = this.props,
	          ignoreInlineStyles = _props3.ignoreInlineStyles,
	          isCurrentHoveredStar = _props3.isCurrentHoveredStar,
	          starDimension = _props3.starDimension;
	
	      var starSvgStyle = {
	        width: starDimension,
	        height: starDimension,
	        transition: 'transform .2s ease-in-out',
	        transform: isCurrentHoveredStar ? 'scale(1.1)' : undefined
	      };
	
	      return ignoreInlineStyles ? {} : starSvgStyle;
	    }
	  }, {
	    key: 'pathStyle',
	    get: function get() {
	      var _props4 = this.props,
	          isStarred = _props4.isStarred,
	          isPartiallyFullStar = _props4.isPartiallyFullStar,
	          isHovered = _props4.isHovered,
	          hoverMode = _props4.hoverMode,
	          starEmptyColor = _props4.starEmptyColor,
	          starRatedColor = _props4.starRatedColor,
	          starHoverColor = _props4.starHoverColor,
	          gradientPathName = _props4.gradientPathName,
	          fillId = _props4.fillId,
	          ignoreInlineStyles = _props4.ignoreInlineStyles;
	
	
	      var fill = void 0;
	      if (hoverMode) {
	        if (isHovered) fill = starHoverColor;else fill = starEmptyColor;
	      } else {
	        if (isPartiallyFullStar) fill = 'url(\'' + gradientPathName + '#' + fillId + '\')';else if (isStarred) fill = starRatedColor;else fill = starEmptyColor;
	      }
	
	      var pathStyle = {
	        fill: fill,
	        transition: 'fill .2s ease-in-out'
	      };
	
	      return ignoreInlineStyles ? {} : pathStyle;
	    }
	  }, {
	    key: 'starClasses',
	    get: function get() {
	      var _props5 = this.props,
	          isSelected = _props5.isSelected,
	          isPartiallyFullStar = _props5.isPartiallyFullStar,
	          isHovered = _props5.isHovered,
	          isCurrentHoveredStar = _props5.isCurrentHoveredStar,
	          ignoreInlineStyles = _props5.ignoreInlineStyles;
	
	
	      var starClasses = (0, _classnames2.default)({
	        'widget-svg': true,
	        'widget-selected': isSelected,
	        'multi-widget-selected': isPartiallyFullStar,
	        'hovered': isHovered,
	        'current-hovered': isCurrentHoveredStar
	      });
	
	      return ignoreInlineStyles ? {} : starClasses;
	    }
	  }]);
	
	  return Star;
	}(_react2.default.Component);
	
	Star.propTypes = {
	  fillId: _propTypes2.default.string.isRequired,
	  changeRating: _propTypes2.default.func,
	  hoverOverStar: _propTypes2.default.func,
	  unHoverOverStar: _propTypes2.default.func,
	  isStarred: _propTypes2.default.bool.isRequired,
	  isPartiallyFullStar: _propTypes2.default.bool.isRequired,
	  isHovered: _propTypes2.default.bool.isRequired,
	  hoverMode: _propTypes2.default.bool.isRequired,
	  isCurrentHoveredStar: _propTypes2.default.bool.isRequired,
	  isFirstStar: _propTypes2.default.bool.isRequired,
	  isLastStar: _propTypes2.default.bool.isRequired,
	  starDimension: _propTypes2.default.string.isRequired,
	  starSpacing: _propTypes2.default.string.isRequired,
	  starHoverColor: _propTypes2.default.string.isRequired,
	  starRatedColor: _propTypes2.default.string.isRequired,
	  starEmptyColor: _propTypes2.default.string.isRequired,
	  gradientPathName: _propTypes2.default.string.isRequired,
	  ignoreInlineStyles: _propTypes2.default.bool.isRequired,
	  svgIconPath: _propTypes2.default.string.isRequired,
	  svgIconViewBox: _propTypes2.default.string.isRequired
	};
	
	exports.default = Star;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.9.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(28),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
	60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
	function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
	function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
	G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
	h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
	b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(163);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEqual = __webpack_require__(1202);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _Elements = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['id', 'className', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var capitalized = function capitalized(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      _this._element = null;
	
	      var options = _extractOptions(_this.props);
	      // We keep track of the extracted options on this._options to avoid re-rendering.
	      // (We would unnecessarily re-render if we were tracking them with state.)
	      _this._options = options;
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.context.addElementsLoadListener(function (elements) {
	        if (!_this2._ref) {
	          return;
	        }
	
	        var element = elements.create(type, _this2._options);
	        _this2._element = element;
	
	        _this2._setupEventListeners(element);
	
	        element.mount(_this2._ref);
	
	        // Register Element for automatic token / source / paymentMethod creation
	        if (hocOptions.impliedTokenType || hocOptions.impliedSourceType || hocOptions.impliedPaymentMethodType) {
	          _this2.context.registerElement(element, hocOptions.impliedTokenType, hocOptions.impliedSourceType, hocOptions.impliedPaymentMethodType);
	        }
	      });
	    };
	
	    _class.prototype.componentDidUpdate = function componentDidUpdate() {
	      var options = _extractOptions(this.props);
	      if (Object.keys(options).length !== 0 && !(0, _isEqual2.default)(options, this._options)) {
	        this._options = options;
	        if (this._element) {
	          this._element.update(options);
	        }
	      }
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._element) {
	        var element = this._element;
	        element.destroy();
	        this.context.unregisterElement(element);
	      }
	    };
	
	    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
	      var _this3 = this;
	
	      element.on('ready', function () {
	        _this3.props.onReady(_this3._element);
	      });
	
	      element.on('change', function (change) {
	        _this3.props.onChange(change);
	      });
	
	      element.on('blur', function () {
	        var _props;
	
	        return (_props = _this3.props).onBlur.apply(_props, arguments);
	      });
	      element.on('focus', function () {
	        var _props2;
	
	        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
	      });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement('div', {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.handleRef
	      });
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    id: undefined,
	    className: undefined,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = _Elements.elementContextTypes, _class.displayName = capitalized(type) + 'Element', _temp;
	};
	
	exports.default = Element;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(163);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(1203);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['id', 'className', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    // We keep track of the extracted options on this._options to avoid re-rendering.
	    // (We would unnecessarily re-render if we were tracking them with state.)
	    _this._options = options;
	    return _this;
	  }
	
	  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.addElementsLoadListener(function (elements) {
	      _this2._element = elements.create('paymentRequestButton', _extends({
	        paymentRequest: _this2.props.paymentRequest
	      }, _this2._options));
	      _this2._element.on('ready', function () {
	        _this2.props.onReady(_this2._element);
	      });
	      _this2._element.on('focus', function () {
	        var _props;
	
	        return (_props = _this2.props).onFocus.apply(_props, arguments);
	      });
	      _this2._element.on('click', function () {
	        var _props2;
	
	        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
	      });
	      _this2._element.on('blur', function () {
	        var _props3;
	
	        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
	      });
	      _this2._element.mount(_this2._ref);
	    });
	  };
	
	  PaymentRequestButtonElement.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.paymentRequest !== prevProps.paymentRequest) {
	      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	    }
	    var options = _extractOptions(this.props);
	    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	      this._options = options;
	      this._element.update(options);
	    }
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._element.destroy();
	  };
	
	  PaymentRequestButtonElement.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      id: this.props.id,
	      className: this.props.className,
	      ref: this.handleRef
	    });
	  };
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  id: undefined,
	  className: undefined,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
	exports.default = PaymentRequestButtonElement;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Elements = __webpack_require__(162);
	
	var _Provider = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.getRegisteredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.parseElementOrData = function (elementOrOptions) {
	        return elementOrOptions && (typeof elementOrOptions === 'undefined' ? 'undefined' : _typeof(elementOrOptions)) === 'object' && elementOrOptions._frame && _typeof(elementOrOptions._frame) === 'object' && elementOrOptions._frame.id && typeof elementOrOptions._frame.id === 'string' && typeof elementOrOptions._componentName === 'string' ? { type: 'element', element: elementOrOptions } : { type: 'data', data: elementOrOptions };
	      };
	
	      _this.findElement = function (filterBy, specifiedType) {
	        var allElements = _this.context.getRegisteredElements();
	        var filteredElements = allElements.filter(function (e) {
	          return e[filterBy];
	        });
	        var matchingElements = specifiedType === 'auto' ? filteredElements : filteredElements.filter(function (e) {
	          return e[filterBy] === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.requireElement = function (filterBy, specifiedType) {
	        var element = _this.findElement(filterBy, specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.wrappedCreateToken = function (stripe) {
	        return function () {
	          var tokenTypeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	          if (tokenTypeOrOptions && (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) === 'object') {
	            // First argument is options; infer the Element and tokenize
	            var opts = tokenTypeOrOptions;
	
	            var tokenType = opts.type,
	                rest = _objectWithoutProperties(opts, ['type']);
	
	            var specifiedType = typeof tokenType === 'string' ? tokenType : 'auto';
	            // Since only options were passed in, a corresponding Element must exist
	            // for the tokenization to succeed -- thus we call requireElement.
	            var element = _this.requireElement('impliedTokenType', specifiedType);
	            return stripe.createToken(element, rest);
	          } else if (typeof tokenTypeOrOptions === 'string') {
	            // First argument is token type; tokenize with token type and options
	            var _tokenType = tokenTypeOrOptions;
	            return stripe.createToken(_tokenType, options);
	          } else {
	            // If a bad value was passed in for options, throw an error.
	            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreateSource = function (stripe) {
	        return function () {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            if (typeof options.type !== 'string') {
	              throw new Error('Invalid Source type passed to createSource. Expected string, got ' + _typeof(options.type) + '.');
	            }
	
	            var element = _this.findElement('impliedSourceType', options.type);
	            if (element) {
	              // If an Element exists for the source type, use that to create the
	              // corresponding source.
	              //
	              // NOTE: this prevents users from independently creating sources of
	              // type `foo` if an Element that can create `foo` sources exists in
	              // the current <Elements /> context.
	              return stripe.createSource(element, options);
	            } else {
	              // If no Element exists for the source type, directly create a source.
	              return stripe.createSource(options);
	            }
	          } else {
	            // If a bad value was passed in for options, throw an error.
	            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreatePaymentMethod = function (stripe) {
	        return function (paymentMethodType, elementOrData, maybeData) {
	          if (paymentMethodType && (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) === 'object') {
	            return stripe.createPaymentMethod(paymentMethodType);
	          }
	
	          if (!paymentMethodType || typeof paymentMethodType !== 'string') {
	            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. Expected a string, got ' + (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) + '.');
	          }
	
	          var elementOrDataResult = _this.parseElementOrData(elementOrData);
	
	          // Second argument is Element; use passed in Element
	          if (elementOrDataResult.type === 'element') {
	            var _element = elementOrDataResult.element;
	
	            if (maybeData) {
	              return stripe.createPaymentMethod(paymentMethodType, _element, maybeData);
	            } else {
	              return stripe.createPaymentMethod(paymentMethodType, _element);
	            }
	          }
	
	          // Second argument is data or undefined; infer the Element
	          var data = elementOrDataResult.data;
	
	          var element = _this.findElement('impliedPaymentMethodType', paymentMethodType);
	
	          if (element) {
	            return data ? stripe.createPaymentMethod(paymentMethodType, element, data) : stripe.createPaymentMethod(paymentMethodType, element);
	          }
	
	          if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	            return stripe.createPaymentMethod(paymentMethodType, data);
	          } else if (!data) {
	            throw new Error('Could not find an Element that can be used to create a PaymentMethod of type: ' + paymentMethodType + '.');
	          } else {
	            // If a bad value was passed in for data, throw an error.
	            throw new Error('Invalid data passed to createPaymentMethod. Expected an object, got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedHandleCardX = function (stripe, method) {
	        return function (clientSecret, elementOrData, maybeData) {
	          if (!clientSecret || typeof clientSecret !== 'string') {
	            // If a bad value was passed in for clientSecret, throw an error.
	            throw new Error('Invalid PaymentIntent client secret passed to handleCardPayment. Expected string, got ' + (typeof clientSecret === 'undefined' ? 'undefined' : _typeof(clientSecret)) + '.');
	          }
	
	          var elementOrDataResult = _this.parseElementOrData(elementOrData);
	
	          // Second argument is Element; handle with element
	          if (elementOrDataResult.type === 'element') {
	            var _element2 = elementOrDataResult.element;
	
	            if (maybeData) {
	              return stripe[method](clientSecret, _element2, maybeData);
	            } else {
	              return stripe[method](clientSecret, _element2);
	            }
	          }
	
	          // Second argument is data or undefined; see if we can find a mounted Element
	          // that can create card PaymentMethods
	          var data = elementOrDataResult.data;
	
	          var element = _this.findElement('impliedPaymentMethodType', 'card');
	
	          if (element) {
	            // If an Element exists that can create card PaymentMethods use it. Otherwise
	            // assume that we must be calling with data only.
	            //
	            // NOTE: this prevents users from using handleCard* with an existing
	            // Source or PaymentMethod if an Element that can create card PaymentMethods
	            // exists in the current <Elements /> context.
	            if (data) {
	              return stripe[method](clientSecret, element, data);
	            } else {
	              return stripe[method](clientSecret, element);
	            }
	          } else if (data) {
	            // if no element exists call handleCard* directly (with data)
	            return stripe[method](clientSecret, data);
	          } else {
	            // if no element exists call handleCard* directly (with only the clientSecret)
	            return stripe[method](clientSecret);
	          }
	        };
	      };
	
	      if (_this.context.tag === 'sync') {
	        _this.state = {
	          stripe: _this.stripeProps(_this.context.stripe)
	        };
	      } else {
	        _this.state = {
	          stripe: null
	        };
	      }
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (this.context.tag === 'async') {
	        this.context.addStripeLoadListener(function (stripe) {
	          _this2.setState({
	            stripe: _this2.stripeProps(stripe)
	          });
	        });
	      } else {
	        // when 'sync', it's already set in the constructor.
	      }
	    };
	
	    _class.prototype.getWrappedInstance = function getWrappedInstance() {
	      if (!withRef) {
	        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	      }
	      return this.wrappedInstance;
	    };
	
	    _class.prototype.stripeProps = function stripeProps(stripe) {
	      return _extends({}, stripe, {
	        // These are the only functions that take elements.
	        createToken: this.wrappedCreateToken(stripe),
	        createSource: this.wrappedCreateSource(stripe),
	        createPaymentMethod: this.wrappedCreatePaymentMethod(stripe),
	        handleCardPayment: this.wrappedHandleCardX(stripe, 'handleCardPayment'),
	        handleCardSetup: this.wrappedHandleCardX(stripe, 'handleCardSetup')
	      });
	    };
	
	    // Finds an Element by the specified type, if one exists.
	    // Throws if multiple Elements match.
	
	
	    // Require that exactly one Element is found for the specified type.
	    // Throws if no Element is found.
	
	
	    // Wraps createToken in order to infer the Element that is being tokenized.
	
	
	    // Wraps createSource in order to infer the Element that is being used for
	    // source creation.
	
	
	    // Wraps createPaymentMethod in order to infer the Element that is being
	    // used for PaymentMethod creation.
	
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	        stripe: this.state.stripe,
	        elements: this.context.elements,
	        ref: withRef ? function (c) {
	          _this3.wrappedInstance = c;
	        } : null
	      }));
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ },
/* 1202 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var PLAIN_OBJECT_STR = '[object Object]';
	
	var isEqual = function isEqual(left, right) {
	  if ((typeof left === 'undefined' ? 'undefined' : _typeof(left)) !== 'object' || (typeof right === 'undefined' ? 'undefined' : _typeof(right)) !== 'object') {
	    return left === right;
	  }
	
	  if (left === null || right === null) return left === right;
	
	  var leftArray = Array.isArray(left);
	  var rightArray = Array.isArray(right);
	
	  if (leftArray !== rightArray) return false;
	
	  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
	  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
	
	  if (leftPlainObject !== rightPlainObject) return false;
	
	  if (!leftPlainObject && !leftArray) return false;
	
	  var leftKeys = Object.keys(left);
	  var rightKeys = Object.keys(right);
	
	  if (leftKeys.length !== rightKeys.length) return false;
	
	  var keySet = {};
	  for (var i = 0; i < leftKeys.length; i += 1) {
	    keySet[leftKeys[i]] = true;
	  }
	  for (var _i = 0; _i < rightKeys.length; _i += 1) {
	    keySet[rightKeys[_i]] = true;
	  }
	  var allKeys = Object.keys(keySet);
	  if (allKeys.length !== leftKeys.length) {
	    return false;
	  }
	
	  var l = left;
	  var r = right;
	  var pred = function pred(key) {
	    return isEqual(l[key], r[key]);
	  };
	
	  return allKeys.every(pred);
	};
	
	exports.default = isEqual;

/***/ },
/* 1203 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1205);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1205 */
439,
/* 1206 */
207,
/* 1207 */
[1265, 129],
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1207);
	var ReactElement = __webpack_require__(116);
	
	var emptyFunction = __webpack_require__(57);
	var traverseAllChildren = __webpack_require__(1217);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(116);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(116),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(438);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1211 */
1113,
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(480),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(116),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(483);
	var factory = __webpack_require__(285);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1213 */
1132,
/* 1214 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(129);
	
	var ReactElement = __webpack_require__(116);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(129);
	
	var ReactCurrentOwner = __webpack_require__(82);
	var REACT_ELEMENT_TYPE = __webpack_require__(482);
	
	var getIteratorFn = __webpack_require__(1213);
	var invariant = __webpack_require__(20);
	var KeyEscapeUtils = __webpack_require__(1206);
	var warning = __webpack_require__(27);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _createForOfIteratorHelper(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray2(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return{s:F,n:function n(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};},e:function e(_e){throw _e;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return{s:function s(){it=o[Symbol.iterator]();},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e2){didErr=true;err=_e2;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray2(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray2(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray2(o,minLen);}function _arrayLikeToArray2(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}(function(f){if(( false?"undefined":_typeof(exports))==="object"&&typeof module!=="undefined"){module.exports=f();}else if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{var g;if(typeof window!=="undefined"){g=window;}else if(typeof global!=="undefined"){g=global;}else if(typeof self!=="undefined"){g=self;}else{g=this;}g.sanitizeHtml=f();}})(function(){var define,module,exports;return function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a;}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r);},p,p.exports,r,e,n,t);}return n[i].exports;}for(var u="function"==typeof require&&require,i=0;i<t.length;i++){o(t[i]);}return o;}return r;}()({1:[function(require,module,exports){'use strict';exports.byteLength=byteLength;exports.toByteArray=toByteArray;exports.fromByteArray=fromByteArray;var lookup=[];var revLookup=[];var Arr=typeof Uint8Array!=='undefined'?Uint8Array:Array;var code='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';for(var i=0,len=code.length;i<len;++i){lookup[i]=code[i];revLookup[code.charCodeAt(i)]=i;}// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)]=62;revLookup['_'.charCodeAt(0)]=63;function getLens(b64){var len=b64.length;if(len%4>0){throw new Error('Invalid string. Length must be a multiple of 4');}// Trim off extra bytes after placeholder bytes are found
	// See: https://github.com/beatgammit/base64-js/issues/42
	var validLen=b64.indexOf('=');if(validLen===-1)validLen=len;var placeHoldersLen=validLen===len?0:4-validLen%4;return[validLen,placeHoldersLen];}// base64 is 4/3 + up to two characters of the original data
	function byteLength(b64){var lens=getLens(b64);var validLen=lens[0];var placeHoldersLen=lens[1];return(validLen+placeHoldersLen)*3/4-placeHoldersLen;}function _byteLength(b64,validLen,placeHoldersLen){return(validLen+placeHoldersLen)*3/4-placeHoldersLen;}function toByteArray(b64){var tmp;var lens=getLens(b64);var validLen=lens[0];var placeHoldersLen=lens[1];var arr=new Arr(_byteLength(b64,validLen,placeHoldersLen));var curByte=0;// if there are placeholders, only get up to the last complete 4 chars
	var len=placeHoldersLen>0?validLen-4:validLen;var i;for(i=0;i<len;i+=4){tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)];arr[curByte++]=tmp>>16&0xFF;arr[curByte++]=tmp>>8&0xFF;arr[curByte++]=tmp&0xFF;}if(placeHoldersLen===2){tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4;arr[curByte++]=tmp&0xFF;}if(placeHoldersLen===1){tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2;arr[curByte++]=tmp>>8&0xFF;arr[curByte++]=tmp&0xFF;}return arr;}function tripletToBase64(num){return lookup[num>>18&0x3F]+lookup[num>>12&0x3F]+lookup[num>>6&0x3F]+lookup[num&0x3F];}function encodeChunk(uint8,start,end){var tmp;var output=[];for(var i=start;i<end;i+=3){tmp=(uint8[i]<<16&0xFF0000)+(uint8[i+1]<<8&0xFF00)+(uint8[i+2]&0xFF);output.push(tripletToBase64(tmp));}return output.join('');}function fromByteArray(uint8){var tmp;var len=uint8.length;var extraBytes=len%3;// if we have 1 byte left, pad 2 bytes
	var parts=[];var maxChunkLength=16383;// must be multiple of 3
	// go through the array every three bytes, we'll deal with trailing stuff later
	for(var i=0,len2=len-extraBytes;i<len2;i+=maxChunkLength){parts.push(encodeChunk(uint8,i,i+maxChunkLength>len2?len2:i+maxChunkLength));}// pad the end with zeros, but make sure to not forget the extra bytes
	if(extraBytes===1){tmp=uint8[len-1];parts.push(lookup[tmp>>2]+lookup[tmp<<4&0x3F]+'==');}else if(extraBytes===2){tmp=(uint8[len-2]<<8)+uint8[len-1];parts.push(lookup[tmp>>10]+lookup[tmp>>4&0x3F]+lookup[tmp<<2&0x3F]+'=');}return parts.join('');}},{}],2:[function(require,module,exports){},{}],3:[function(require,module,exports){(function(Buffer){/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */ /* eslint-disable no-proto */'use strict';var base64=require('base64-js');var ieee754=require('ieee754');exports.Buffer=Buffer;exports.SlowBuffer=SlowBuffer;exports.INSPECT_MAX_BYTES=50;var K_MAX_LENGTH=0x7fffffff;exports.kMaxLength=K_MAX_LENGTH;/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=='undefined'&&typeof console.error==='function'){console.error('This browser lacks typed array (Uint8Array) support which is required by '+'`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');}function typedArraySupport(){// Can typed array instances can be augmented?
	try{var arr=new Uint8Array(1);arr.__proto__={__proto__:Uint8Array.prototype,foo:function foo(){return 42;}};return arr.foo()===42;}catch(e){return false;}}Object.defineProperty(Buffer.prototype,'parent',{enumerable:true,get:function get(){if(!Buffer.isBuffer(this))return undefined;return this.buffer;}});Object.defineProperty(Buffer.prototype,'offset',{enumerable:true,get:function get(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset;}});function createBuffer(length){if(length>K_MAX_LENGTH){throw new RangeError('The value "'+length+'" is invalid for option "size"');}// Return an augmented `Uint8Array` instance
	var buf=new Uint8Array(length);buf.__proto__=Buffer.prototype;return buf;}/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */function Buffer(arg,encodingOrOffset,length){// Common case.
	if(typeof arg==='number'){if(typeof encodingOrOffset==='string'){throw new TypeError('The "string" argument must be of type string. Received type number');}return allocUnsafe(arg);}return from(arg,encodingOrOffset,length);}// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	if(typeof Symbol!=='undefined'&&Symbol.species!=null&&Buffer[Symbol.species]===Buffer){Object.defineProperty(Buffer,Symbol.species,{value:null,configurable:true,enumerable:false,writable:false});}Buffer.poolSize=8192;// not used by this implementation
	function from(value,encodingOrOffset,length){if(typeof value==='string'){return fromString(value,encodingOrOffset);}if(ArrayBuffer.isView(value)){return fromArrayLike(value);}if(value==null){throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, '+'or Array-like Object. Received type '+_typeof(value));}if(isInstance(value,ArrayBuffer)||value&&isInstance(value.buffer,ArrayBuffer)){return fromArrayBuffer(value,encodingOrOffset,length);}if(typeof value==='number'){throw new TypeError('The "value" argument must not be of type number. Received type number');}var valueOf=value.valueOf&&value.valueOf();if(valueOf!=null&&valueOf!==value){return Buffer.from(valueOf,encodingOrOffset,length);}var b=fromObject(value);if(b)return b;if(typeof Symbol!=='undefined'&&Symbol.toPrimitive!=null&&typeof value[Symbol.toPrimitive]==='function'){return Buffer.from(value[Symbol.toPrimitive]('string'),encodingOrOffset,length);}throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, '+'or Array-like Object. Received type '+_typeof(value));}/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/Buffer.from=function(value,encodingOrOffset,length){return from(value,encodingOrOffset,length);};// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Buffer.prototype.__proto__=Uint8Array.prototype;Buffer.__proto__=Uint8Array;function assertSize(size){if(typeof size!=='number'){throw new TypeError('"size" argument must be of type number');}else if(size<0){throw new RangeError('The value "'+size+'" is invalid for option "size"');}}function alloc(size,fill,encoding){assertSize(size);if(size<=0){return createBuffer(size);}if(fill!==undefined){// Only pay attention to encoding if it's a string. This
	// prevents accidentally sending in a number that would
	// be interpretted as a start offset.
	return typeof encoding==='string'?createBuffer(size).fill(fill,encoding):createBuffer(size).fill(fill);}return createBuffer(size);}/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/Buffer.alloc=function(size,fill,encoding){return alloc(size,fill,encoding);};function allocUnsafe(size){assertSize(size);return createBuffer(size<0?0:checked(size)|0);}/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */Buffer.allocUnsafe=function(size){return allocUnsafe(size);};/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */Buffer.allocUnsafeSlow=function(size){return allocUnsafe(size);};function fromString(string,encoding){if(typeof encoding!=='string'||encoding===''){encoding='utf8';}if(!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}var length=byteLength(string,encoding)|0;var buf=createBuffer(length);var actual=buf.write(string,encoding);if(actual!==length){// Writing a hex string, for example, that contains invalid characters will
	// cause everything after the first invalid character to be ignored. (e.g.
	// 'abxxcd' will be treated as 'ab')
	buf=buf.slice(0,actual);}return buf;}function fromArrayLike(array){var length=array.length<0?0:checked(array.length)|0;var buf=createBuffer(length);for(var i=0;i<length;i+=1){buf[i]=array[i]&255;}return buf;}function fromArrayBuffer(array,byteOffset,length){if(byteOffset<0||array.byteLength<byteOffset){throw new RangeError('"offset" is outside of buffer bounds');}if(array.byteLength<byteOffset+(length||0)){throw new RangeError('"length" is outside of buffer bounds');}var buf;if(byteOffset===undefined&&length===undefined){buf=new Uint8Array(array);}else if(length===undefined){buf=new Uint8Array(array,byteOffset);}else{buf=new Uint8Array(array,byteOffset,length);}// Return an augmented `Uint8Array` instance
	buf.__proto__=Buffer.prototype;return buf;}function fromObject(obj){if(Buffer.isBuffer(obj)){var len=checked(obj.length)|0;var buf=createBuffer(len);if(buf.length===0){return buf;}obj.copy(buf,0,0,len);return buf;}if(obj.length!==undefined){if(typeof obj.length!=='number'||numberIsNaN(obj.length)){return createBuffer(0);}return fromArrayLike(obj);}if(obj.type==='Buffer'&&Array.isArray(obj.data)){return fromArrayLike(obj.data);}}function checked(length){// Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	// length is NaN (which is otherwise coerced to zero.)
	if(length>=K_MAX_LENGTH){throw new RangeError('Attempt to allocate Buffer larger than maximum '+'size: 0x'+K_MAX_LENGTH.toString(16)+' bytes');}return length|0;}function SlowBuffer(length){if(+length!=length){// eslint-disable-line eqeqeq
	length=0;}return Buffer.alloc(+length);}Buffer.isBuffer=function isBuffer(b){return b!=null&&b._isBuffer===true&&b!==Buffer.prototype;// so Buffer.isBuffer(Buffer.prototype) will be false
	};Buffer.compare=function compare(a,b){if(isInstance(a,Uint8Array))a=Buffer.from(a,a.offset,a.byteLength);if(isInstance(b,Uint8Array))b=Buffer.from(b,b.offset,b.byteLength);if(!Buffer.isBuffer(a)||!Buffer.isBuffer(b)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');}if(a===b)return 0;var x=a.length;var y=b.length;for(var i=0,len=Math.min(x,y);i<len;++i){if(a[i]!==b[i]){x=a[i];y=b[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};Buffer.isEncoding=function isEncoding(encoding){switch(String(encoding).toLowerCase()){case'hex':case'utf8':case'utf-8':case'ascii':case'latin1':case'binary':case'base64':case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return true;default:return false;}};Buffer.concat=function concat(list,length){if(!Array.isArray(list)){throw new TypeError('"list" argument must be an Array of Buffers');}if(list.length===0){return Buffer.alloc(0);}var i;if(length===undefined){length=0;for(i=0;i<list.length;++i){length+=list[i].length;}}var buffer=Buffer.allocUnsafe(length);var pos=0;for(i=0;i<list.length;++i){var buf=list[i];if(isInstance(buf,Uint8Array)){buf=Buffer.from(buf);}if(!Buffer.isBuffer(buf)){throw new TypeError('"list" argument must be an Array of Buffers');}buf.copy(buffer,pos);pos+=buf.length;}return buffer;};function byteLength(string,encoding){if(Buffer.isBuffer(string)){return string.length;}if(ArrayBuffer.isView(string)||isInstance(string,ArrayBuffer)){return string.byteLength;}if(typeof string!=='string'){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+'Received type '+_typeof(string));}var len=string.length;var mustMatch=arguments.length>2&&arguments[2]===true;if(!mustMatch&&len===0)return 0;// Use a for loop to avoid recursion
	var loweredCase=false;for(;;){switch(encoding){case'ascii':case'latin1':case'binary':return len;case'utf8':case'utf-8':return utf8ToBytes(string).length;case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return len*2;case'hex':return len>>>1;case'base64':return base64ToBytes(string).length;default:if(loweredCase){return mustMatch?-1:utf8ToBytes(string).length;// assume utf8
	}encoding=(''+encoding).toLowerCase();loweredCase=true;}}}Buffer.byteLength=byteLength;function slowToString(encoding,start,end){var loweredCase=false;// No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	// property of a typed array.
	// This behaves neither like String nor Uint8Array in that we set start/end
	// to their upper/lower bounds if the value passed is out of range.
	// undefined is handled specially as per ECMA-262 6th Edition,
	// Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	if(start===undefined||start<0){start=0;}// Return early if start > this.length. Done here to prevent potential uint32
	// coercion fail below.
	if(start>this.length){return'';}if(end===undefined||end>this.length){end=this.length;}if(end<=0){return'';}// Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	end>>>=0;start>>>=0;if(end<=start){return'';}if(!encoding)encoding='utf8';while(true){switch(encoding){case'hex':return hexSlice(this,start,end);case'utf8':case'utf-8':return utf8Slice(this,start,end);case'ascii':return asciiSlice(this,start,end);case'latin1':case'binary':return latin1Slice(this,start,end);case'base64':return base64Slice(this,start,end);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return utf16leSlice(this,start,end);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(encoding+'').toLowerCase();loweredCase=true;}}}// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer=true;function swap(b,n,m){var i=b[n];b[n]=b[m];b[m]=i;}Buffer.prototype.swap16=function swap16(){var len=this.length;if(len%2!==0){throw new RangeError('Buffer size must be a multiple of 16-bits');}for(var i=0;i<len;i+=2){swap(this,i,i+1);}return this;};Buffer.prototype.swap32=function swap32(){var len=this.length;if(len%4!==0){throw new RangeError('Buffer size must be a multiple of 32-bits');}for(var i=0;i<len;i+=4){swap(this,i,i+3);swap(this,i+1,i+2);}return this;};Buffer.prototype.swap64=function swap64(){var len=this.length;if(len%8!==0){throw new RangeError('Buffer size must be a multiple of 64-bits');}for(var i=0;i<len;i+=8){swap(this,i,i+7);swap(this,i+1,i+6);swap(this,i+2,i+5);swap(this,i+3,i+4);}return this;};Buffer.prototype.toString=function toString(){var length=this.length;if(length===0)return'';if(arguments.length===0)return utf8Slice(this,0,length);return slowToString.apply(this,arguments);};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(b){if(!Buffer.isBuffer(b))throw new TypeError('Argument must be a Buffer');if(this===b)return true;return Buffer.compare(this,b)===0;};Buffer.prototype.inspect=function inspect(){var str='';var max=exports.INSPECT_MAX_BYTES;str=this.toString('hex',0,max).replace(/(.{2})/g,'$1 ').trim();if(this.length>max)str+=' ... ';return'<Buffer '+str+'>';};Buffer.prototype.compare=function compare(target,start,end,thisStart,thisEnd){if(isInstance(target,Uint8Array)){target=Buffer.from(target,target.offset,target.byteLength);}if(!Buffer.isBuffer(target)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+'Received type '+_typeof(target));}if(start===undefined){start=0;}if(end===undefined){end=target?target.length:0;}if(thisStart===undefined){thisStart=0;}if(thisEnd===undefined){thisEnd=this.length;}if(start<0||end>target.length||thisStart<0||thisEnd>this.length){throw new RangeError('out of range index');}if(thisStart>=thisEnd&&start>=end){return 0;}if(thisStart>=thisEnd){return-1;}if(start>=end){return 1;}start>>>=0;end>>>=0;thisStart>>>=0;thisEnd>>>=0;if(this===target)return 0;var x=thisEnd-thisStart;var y=end-start;var len=Math.min(x,y);var thisCopy=this.slice(thisStart,thisEnd);var targetCopy=target.slice(start,end);for(var i=0;i<len;++i){if(thisCopy[i]!==targetCopy[i]){x=thisCopy[i];y=targetCopy[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer,val,byteOffset,encoding,dir){// Empty buffer means no match
	if(buffer.length===0)return-1;// Normalize byteOffset
	if(typeof byteOffset==='string'){encoding=byteOffset;byteOffset=0;}else if(byteOffset>0x7fffffff){byteOffset=0x7fffffff;}else if(byteOffset<-0x80000000){byteOffset=-0x80000000;}byteOffset=+byteOffset;// Coerce to Number.
	if(numberIsNaN(byteOffset)){// byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	byteOffset=dir?0:buffer.length-1;}// Normalize byteOffset: negative offsets start from the end of the buffer
	if(byteOffset<0)byteOffset=buffer.length+byteOffset;if(byteOffset>=buffer.length){if(dir)return-1;else byteOffset=buffer.length-1;}else if(byteOffset<0){if(dir)byteOffset=0;else return-1;}// Normalize val
	if(typeof val==='string'){val=Buffer.from(val,encoding);}// Finally, search either indexOf (if dir is true) or lastIndexOf
	if(Buffer.isBuffer(val)){// Special case: looking for empty string/buffer always fails
	if(val.length===0){return-1;}return arrayIndexOf(buffer,val,byteOffset,encoding,dir);}else if(typeof val==='number'){val=val&0xFF;// Search for a byte value [0-255]
	if(typeof Uint8Array.prototype.indexOf==='function'){if(dir){return Uint8Array.prototype.indexOf.call(buffer,val,byteOffset);}else{return Uint8Array.prototype.lastIndexOf.call(buffer,val,byteOffset);}}return arrayIndexOf(buffer,[val],byteOffset,encoding,dir);}throw new TypeError('val must be string, number or Buffer');}function arrayIndexOf(arr,val,byteOffset,encoding,dir){var indexSize=1;var arrLength=arr.length;var valLength=val.length;if(encoding!==undefined){encoding=String(encoding).toLowerCase();if(encoding==='ucs2'||encoding==='ucs-2'||encoding==='utf16le'||encoding==='utf-16le'){if(arr.length<2||val.length<2){return-1;}indexSize=2;arrLength/=2;valLength/=2;byteOffset/=2;}}function read(buf,i){if(indexSize===1){return buf[i];}else{return buf.readUInt16BE(i*indexSize);}}var i;if(dir){var foundIndex=-1;for(i=byteOffset;i<arrLength;i++){if(read(arr,i)===read(val,foundIndex===-1?0:i-foundIndex)){if(foundIndex===-1)foundIndex=i;if(i-foundIndex+1===valLength)return foundIndex*indexSize;}else{if(foundIndex!==-1)i-=i-foundIndex;foundIndex=-1;}}}else{if(byteOffset+valLength>arrLength)byteOffset=arrLength-valLength;for(i=byteOffset;i>=0;i--){var found=true;for(var j=0;j<valLength;j++){if(read(arr,i+j)!==read(val,j)){found=false;break;}}if(found)return i;}}return-1;}Buffer.prototype.includes=function includes(val,byteOffset,encoding){return this.indexOf(val,byteOffset,encoding)!==-1;};Buffer.prototype.indexOf=function indexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,true);};Buffer.prototype.lastIndexOf=function lastIndexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,false);};function hexWrite(buf,string,offset,length){offset=Number(offset)||0;var remaining=buf.length-offset;if(!length){length=remaining;}else{length=Number(length);if(length>remaining){length=remaining;}}var strLen=string.length;if(length>strLen/2){length=strLen/2;}for(var i=0;i<length;++i){var parsed=parseInt(string.substr(i*2,2),16);if(numberIsNaN(parsed))return i;buf[offset+i]=parsed;}return i;}function utf8Write(buf,string,offset,length){return blitBuffer(utf8ToBytes(string,buf.length-offset),buf,offset,length);}function asciiWrite(buf,string,offset,length){return blitBuffer(asciiToBytes(string),buf,offset,length);}function latin1Write(buf,string,offset,length){return asciiWrite(buf,string,offset,length);}function base64Write(buf,string,offset,length){return blitBuffer(base64ToBytes(string),buf,offset,length);}function ucs2Write(buf,string,offset,length){return blitBuffer(utf16leToBytes(string,buf.length-offset),buf,offset,length);}Buffer.prototype.write=function write(string,offset,length,encoding){// Buffer#write(string)
	if(offset===undefined){encoding='utf8';length=this.length;offset=0;// Buffer#write(string, encoding)
	}else if(length===undefined&&typeof offset==='string'){encoding=offset;length=this.length;offset=0;// Buffer#write(string, offset[, length][, encoding])
	}else if(isFinite(offset)){offset=offset>>>0;if(isFinite(length)){length=length>>>0;if(encoding===undefined)encoding='utf8';}else{encoding=length;length=undefined;}}else{throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');}var remaining=this.length-offset;if(length===undefined||length>remaining)length=remaining;if(string.length>0&&(length<0||offset<0)||offset>this.length){throw new RangeError('Attempt to write outside buffer bounds');}if(!encoding)encoding='utf8';var loweredCase=false;for(;;){switch(encoding){case'hex':return hexWrite(this,string,offset,length);case'utf8':case'utf-8':return utf8Write(this,string,offset,length);case'ascii':return asciiWrite(this,string,offset,length);case'latin1':case'binary':return latin1Write(this,string,offset,length);case'base64':// Warning: maxLength not taken into account in base64Write
	return base64Write(this,string,offset,length);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return ucs2Write(this,string,offset,length);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(''+encoding).toLowerCase();loweredCase=true;}}};Buffer.prototype.toJSON=function toJSON(){return{type:'Buffer',data:Array.prototype.slice.call(this._arr||this,0)};};function base64Slice(buf,start,end){if(start===0&&end===buf.length){return base64.fromByteArray(buf);}else{return base64.fromByteArray(buf.slice(start,end));}}function utf8Slice(buf,start,end){end=Math.min(buf.length,end);var res=[];var i=start;while(i<end){var firstByte=buf[i];var codePoint=null;var bytesPerSequence=firstByte>0xEF?4:firstByte>0xDF?3:firstByte>0xBF?2:1;if(i+bytesPerSequence<=end){var secondByte,thirdByte,fourthByte,tempCodePoint;switch(bytesPerSequence){case 1:if(firstByte<0x80){codePoint=firstByte;}break;case 2:secondByte=buf[i+1];if((secondByte&0xC0)===0x80){tempCodePoint=(firstByte&0x1F)<<0x6|secondByte&0x3F;if(tempCodePoint>0x7F){codePoint=tempCodePoint;}}break;case 3:secondByte=buf[i+1];thirdByte=buf[i+2];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0xC|(secondByte&0x3F)<<0x6|thirdByte&0x3F;if(tempCodePoint>0x7FF&&(tempCodePoint<0xD800||tempCodePoint>0xDFFF)){codePoint=tempCodePoint;}}break;case 4:secondByte=buf[i+1];thirdByte=buf[i+2];fourthByte=buf[i+3];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80&&(fourthByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0x12|(secondByte&0x3F)<<0xC|(thirdByte&0x3F)<<0x6|fourthByte&0x3F;if(tempCodePoint>0xFFFF&&tempCodePoint<0x110000){codePoint=tempCodePoint;}}}}if(codePoint===null){// we did not generate a valid codePoint so insert a
	// replacement char (U+FFFD) and advance only 1 byte
	codePoint=0xFFFD;bytesPerSequence=1;}else if(codePoint>0xFFFF){// encode to utf16 (surrogate pair dance)
	codePoint-=0x10000;res.push(codePoint>>>10&0x3FF|0xD800);codePoint=0xDC00|codePoint&0x3FF;}res.push(codePoint);i+=bytesPerSequence;}return decodeCodePointsArray(res);}// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH=0x1000;function decodeCodePointsArray(codePoints){var len=codePoints.length;if(len<=MAX_ARGUMENTS_LENGTH){return String.fromCharCode.apply(String,codePoints);// avoid extra slice()
	}// Decode in chunks to avoid "call stack size exceeded".
	var res='';var i=0;while(i<len){res+=String.fromCharCode.apply(String,codePoints.slice(i,i+=MAX_ARGUMENTS_LENGTH));}return res;}function asciiSlice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]&0x7F);}return ret;}function latin1Slice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]);}return ret;}function hexSlice(buf,start,end){var len=buf.length;if(!start||start<0)start=0;if(!end||end<0||end>len)end=len;var out='';for(var i=start;i<end;++i){out+=toHex(buf[i]);}return out;}function utf16leSlice(buf,start,end){var bytes=buf.slice(start,end);var res='';for(var i=0;i<bytes.length;i+=2){res+=String.fromCharCode(bytes[i]+bytes[i+1]*256);}return res;}Buffer.prototype.slice=function slice(start,end){var len=this.length;start=~~start;end=end===undefined?len:~~end;if(start<0){start+=len;if(start<0)start=0;}else if(start>len){start=len;}if(end<0){end+=len;if(end<0)end=0;}else if(end>len){end=len;}if(end<start)end=start;var newBuf=this.subarray(start,end);// Return an augmented `Uint8Array` instance
	newBuf.__proto__=Buffer.prototype;return newBuf;};/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */function checkOffset(offset,ext,length){if(offset%1!==0||offset<0)throw new RangeError('offset is not uint');if(offset+ext>length)throw new RangeError('Trying to access beyond buffer length');}Buffer.prototype.readUIntLE=function readUIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}return val;};Buffer.prototype.readUIntBE=function readUIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){checkOffset(offset,byteLength,this.length);}var val=this[offset+--byteLength];var mul=1;while(byteLength>0&&(mul*=0x100)){val+=this[offset+--byteLength]*mul;}return val;};Buffer.prototype.readUInt8=function readUInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);return this[offset];};Buffer.prototype.readUInt16LE=function readUInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]|this[offset+1]<<8;};Buffer.prototype.readUInt16BE=function readUInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]<<8|this[offset+1];};Buffer.prototype.readUInt32LE=function readUInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return(this[offset]|this[offset+1]<<8|this[offset+2]<<16)+this[offset+3]*0x1000000;};Buffer.prototype.readUInt32BE=function readUInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]*0x1000000+(this[offset+1]<<16|this[offset+2]<<8|this[offset+3]);};Buffer.prototype.readIntLE=function readIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readIntBE=function readIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var i=byteLength;var mul=1;var val=this[offset+--i];while(i>0&&(mul*=0x100)){val+=this[offset+--i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readInt8=function readInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);if(!(this[offset]&0x80))return this[offset];return(0xff-this[offset]+1)*-1;};Buffer.prototype.readInt16LE=function readInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset]|this[offset+1]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt16BE=function readInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset+1]|this[offset]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt32LE=function readInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]|this[offset+1]<<8|this[offset+2]<<16|this[offset+3]<<24;};Buffer.prototype.readInt32BE=function readInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]<<24|this[offset+1]<<16|this[offset+2]<<8|this[offset+3];};Buffer.prototype.readFloatLE=function readFloatLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,true,23,4);};Buffer.prototype.readFloatBE=function readFloatBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,false,23,4);};Buffer.prototype.readDoubleLE=function readDoubleLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,true,52,8);};Buffer.prototype.readDoubleBE=function readDoubleBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,false,52,8);};function checkInt(buf,value,offset,ext,max,min){if(!Buffer.isBuffer(buf))throw new TypeError('"buffer" argument must be a Buffer instance');if(value>max||value<min)throw new RangeError('"value" argument is out of bounds');if(offset+ext>buf.length)throw new RangeError('Index out of range');}Buffer.prototype.writeUIntLE=function writeUIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var mul=1;var i=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUIntBE=function writeUIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var i=byteLength-1;var mul=1;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUInt8=function writeUInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0xff,0);this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeUInt16LE=function writeUInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeUInt16BE=function writeUInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeUInt32LE=function writeUInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset+3]=value>>>24;this[offset+2]=value>>>16;this[offset+1]=value>>>8;this[offset]=value&0xff;return offset+4;};Buffer.prototype.writeUInt32BE=function writeUInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};Buffer.prototype.writeIntLE=function writeIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=0;var mul=1;var sub=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i-1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeIntBE=function writeIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=byteLength-1;var mul=1;var sub=0;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i+1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeInt8=function writeInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0x7f,-0x80);if(value<0)value=0xff+value+1;this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeInt16LE=function writeInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeInt16BE=function writeInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeInt32LE=function writeInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);this[offset]=value&0xff;this[offset+1]=value>>>8;this[offset+2]=value>>>16;this[offset+3]=value>>>24;return offset+4;};Buffer.prototype.writeInt32BE=function writeInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);if(value<0)value=0xffffffff+value+1;this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};function checkIEEE754(buf,value,offset,ext,max,min){if(offset+ext>buf.length)throw new RangeError('Index out of range');if(offset<0)throw new RangeError('Index out of range');}function writeFloat(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,4,3.4028234663852886e+38,-3.4028234663852886e+38);}ieee754.write(buf,value,offset,littleEndian,23,4);return offset+4;}Buffer.prototype.writeFloatLE=function writeFloatLE(value,offset,noAssert){return writeFloat(this,value,offset,true,noAssert);};Buffer.prototype.writeFloatBE=function writeFloatBE(value,offset,noAssert){return writeFloat(this,value,offset,false,noAssert);};function writeDouble(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,8,1.7976931348623157E+308,-1.7976931348623157E+308);}ieee754.write(buf,value,offset,littleEndian,52,8);return offset+8;}Buffer.prototype.writeDoubleLE=function writeDoubleLE(value,offset,noAssert){return writeDouble(this,value,offset,true,noAssert);};Buffer.prototype.writeDoubleBE=function writeDoubleBE(value,offset,noAssert){return writeDouble(this,value,offset,false,noAssert);};// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy=function copy(target,targetStart,start,end){if(!Buffer.isBuffer(target))throw new TypeError('argument should be a Buffer');if(!start)start=0;if(!end&&end!==0)end=this.length;if(targetStart>=target.length)targetStart=target.length;if(!targetStart)targetStart=0;if(end>0&&end<start)end=start;// Copy 0 bytes; we're done
	if(end===start)return 0;if(target.length===0||this.length===0)return 0;// Fatal error conditions
	if(targetStart<0){throw new RangeError('targetStart out of bounds');}if(start<0||start>=this.length)throw new RangeError('Index out of range');if(end<0)throw new RangeError('sourceEnd out of bounds');// Are we oob?
	if(end>this.length)end=this.length;if(target.length-targetStart<end-start){end=target.length-targetStart+start;}var len=end-start;if(this===target&&typeof Uint8Array.prototype.copyWithin==='function'){// Use built-in when available, missing from IE11
	this.copyWithin(targetStart,start,end);}else if(this===target&&start<targetStart&&targetStart<end){// descending copy from end
	for(var i=len-1;i>=0;--i){target[i+targetStart]=this[i+start];}}else{Uint8Array.prototype.set.call(target,this.subarray(start,end),targetStart);}return len;};// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill=function fill(val,start,end,encoding){// Handle string cases:
	if(typeof val==='string'){if(typeof start==='string'){encoding=start;start=0;end=this.length;}else if(typeof end==='string'){encoding=end;end=this.length;}if(encoding!==undefined&&typeof encoding!=='string'){throw new TypeError('encoding must be a string');}if(typeof encoding==='string'&&!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}if(val.length===1){var code=val.charCodeAt(0);if(encoding==='utf8'&&code<128||encoding==='latin1'){// Fast path: If `val` fits into a single byte, use that numeric value.
	val=code;}}}else if(typeof val==='number'){val=val&255;}// Invalid ranges are not set to a default, so can range check early.
	if(start<0||this.length<start||this.length<end){throw new RangeError('Out of range index');}if(end<=start){return this;}start=start>>>0;end=end===undefined?this.length:end>>>0;if(!val)val=0;var i;if(typeof val==='number'){for(i=start;i<end;++i){this[i]=val;}}else{var bytes=Buffer.isBuffer(val)?val:Buffer.from(val,encoding);var len=bytes.length;if(len===0){throw new TypeError('The value "'+val+'" is invalid for argument "value"');}for(i=0;i<end-start;++i){this[i+start]=bytes[i%len];}}return this;};// HELPER FUNCTIONS
	// ================
	var INVALID_BASE64_RE=/[^+/0-9A-Za-z-_]/g;function base64clean(str){// Node takes equal signs as end of the Base64 encoding
	str=str.split('=')[0];// Node strips out invalid characters like \n and \t from the string, base64-js does not
	str=str.trim().replace(INVALID_BASE64_RE,'');// Node converts strings with length < 2 to ''
	if(str.length<2)return'';// Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	while(str.length%4!==0){str=str+'=';}return str;}function toHex(n){if(n<16)return'0'+n.toString(16);return n.toString(16);}function utf8ToBytes(string,units){units=units||Infinity;var codePoint;var length=string.length;var leadSurrogate=null;var bytes=[];for(var i=0;i<length;++i){codePoint=string.charCodeAt(i);// is surrogate component
	if(codePoint>0xD7FF&&codePoint<0xE000){// last char was a lead
	if(!leadSurrogate){// no lead yet
	if(codePoint>0xDBFF){// unexpected trail
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}else if(i+1===length){// unpaired lead
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}// valid lead
	leadSurrogate=codePoint;continue;}// 2 leads in a row
	if(codePoint<0xDC00){if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);leadSurrogate=codePoint;continue;}// valid surrogate pair
	codePoint=(leadSurrogate-0xD800<<10|codePoint-0xDC00)+0x10000;}else if(leadSurrogate){// valid bmp char, but last char was a lead
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);}leadSurrogate=null;// encode utf8
	if(codePoint<0x80){if((units-=1)<0)break;bytes.push(codePoint);}else if(codePoint<0x800){if((units-=2)<0)break;bytes.push(codePoint>>0x6|0xC0,codePoint&0x3F|0x80);}else if(codePoint<0x10000){if((units-=3)<0)break;bytes.push(codePoint>>0xC|0xE0,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else if(codePoint<0x110000){if((units-=4)<0)break;bytes.push(codePoint>>0x12|0xF0,codePoint>>0xC&0x3F|0x80,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else{throw new Error('Invalid code point');}}return bytes;}function asciiToBytes(str){var byteArray=[];for(var i=0;i<str.length;++i){// Node's code seems to be doing this and not & 0x7F..
	byteArray.push(str.charCodeAt(i)&0xFF);}return byteArray;}function utf16leToBytes(str,units){var c,hi,lo;var byteArray=[];for(var i=0;i<str.length;++i){if((units-=2)<0)break;c=str.charCodeAt(i);hi=c>>8;lo=c%256;byteArray.push(lo);byteArray.push(hi);}return byteArray;}function base64ToBytes(str){return base64.toByteArray(base64clean(str));}function blitBuffer(src,dst,offset,length){for(var i=0;i<length;++i){if(i+offset>=dst.length||i>=src.length)break;dst[i+offset]=src[i];}return i;}// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance(obj,type){return obj instanceof type||obj!=null&&obj.constructor!=null&&obj.constructor.name!=null&&obj.constructor.name===type.name;}function numberIsNaN(obj){// For IE11 support
	return obj!==obj;// eslint-disable-line no-self-compare
	}}).call(this,require("buffer").Buffer);},{"base64-js":1,"buffer":3,"ieee754":32}],4:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.attributeNames=exports.elementNames=void 0;exports.elementNames=new Map([["altglyph","altGlyph"],["altglyphdef","altGlyphDef"],["altglyphitem","altGlyphItem"],["animatecolor","animateColor"],["animatemotion","animateMotion"],["animatetransform","animateTransform"],["clippath","clipPath"],["feblend","feBlend"],["fecolormatrix","feColorMatrix"],["fecomponenttransfer","feComponentTransfer"],["fecomposite","feComposite"],["feconvolvematrix","feConvolveMatrix"],["fediffuselighting","feDiffuseLighting"],["fedisplacementmap","feDisplacementMap"],["fedistantlight","feDistantLight"],["fedropshadow","feDropShadow"],["feflood","feFlood"],["fefunca","feFuncA"],["fefuncb","feFuncB"],["fefuncg","feFuncG"],["fefuncr","feFuncR"],["fegaussianblur","feGaussianBlur"],["feimage","feImage"],["femerge","feMerge"],["femergenode","feMergeNode"],["femorphology","feMorphology"],["feoffset","feOffset"],["fepointlight","fePointLight"],["fespecularlighting","feSpecularLighting"],["fespotlight","feSpotLight"],["fetile","feTile"],["feturbulence","feTurbulence"],["foreignobject","foreignObject"],["glyphref","glyphRef"],["lineargradient","linearGradient"],["radialgradient","radialGradient"],["textpath","textPath"]]);exports.attributeNames=new Map([["definitionurl","definitionURL"],["attributename","attributeName"],["attributetype","attributeType"],["basefrequency","baseFrequency"],["baseprofile","baseProfile"],["calcmode","calcMode"],["clippathunits","clipPathUnits"],["diffuseconstant","diffuseConstant"],["edgemode","edgeMode"],["filterunits","filterUnits"],["glyphref","glyphRef"],["gradienttransform","gradientTransform"],["gradientunits","gradientUnits"],["kernelmatrix","kernelMatrix"],["kernelunitlength","kernelUnitLength"],["keypoints","keyPoints"],["keysplines","keySplines"],["keytimes","keyTimes"],["lengthadjust","lengthAdjust"],["limitingconeangle","limitingConeAngle"],["markerheight","markerHeight"],["markerunits","markerUnits"],["markerwidth","markerWidth"],["maskcontentunits","maskContentUnits"],["maskunits","maskUnits"],["numoctaves","numOctaves"],["pathlength","pathLength"],["patterncontentunits","patternContentUnits"],["patterntransform","patternTransform"],["patternunits","patternUnits"],["pointsatx","pointsAtX"],["pointsaty","pointsAtY"],["pointsatz","pointsAtZ"],["preservealpha","preserveAlpha"],["preserveaspectratio","preserveAspectRatio"],["primitiveunits","primitiveUnits"],["refx","refX"],["refy","refY"],["repeatcount","repeatCount"],["repeatdur","repeatDur"],["requiredextensions","requiredExtensions"],["requiredfeatures","requiredFeatures"],["specularconstant","specularConstant"],["specularexponent","specularExponent"],["spreadmethod","spreadMethod"],["startoffset","startOffset"],["stddeviation","stdDeviation"],["stitchtiles","stitchTiles"],["surfacescale","surfaceScale"],["systemlanguage","systemLanguage"],["tablevalues","tableValues"],["targetx","targetX"],["targety","targetY"],["textlength","textLength"],["viewbox","viewBox"],["viewtarget","viewTarget"],["xchannelselector","xChannelSelector"],["ychannelselector","yChannelSelector"],["zoomandpan","zoomAndPan"]]);},{}],5:[function(require,module,exports){"use strict";var __assign=this&&this.__assign||function(){__assign=Object.assign||function(t){for(var s,i=1,n=arguments.length;i<n;i++){s=arguments[i];for(var p in s){if(Object.prototype.hasOwnProperty.call(s,p))t[p]=s[p];}}return t;};return __assign.apply(this,arguments);};var __createBinding=this&&this.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;Object.defineProperty(o,k2,{enumerable:true,get:function get(){return m[k];}});}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __setModuleDefault=this&&this.__setModuleDefault||(Object.create?function(o,v){Object.defineProperty(o,"default",{enumerable:true,value:v});}:function(o,v){o["default"]=v;});var __importStar=this&&this.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod){if(k!=="default"&&Object.prototype.hasOwnProperty.call(mod,k))__createBinding(result,mod,k);}__setModuleDefault(result,mod);return result;};Object.defineProperty(exports,"__esModule",{value:true});/*
	 * Module dependencies
	 */var ElementType=__importStar(require("domelementtype"));var entities_1=require("entities");/*
	 * Mixed-case SVG and MathML tags & attributes
	 * recognized by the HTML parser, see
	 * https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	 */var foreignNames_1=require("./foreignNames");var unencodedElements=new Set(["style","script","xmp","iframe","noembed","noframes","plaintext","noscript"]);/**
	 * Format attributes
	 */function formatAttributes(attributes,opts){if(!attributes)return;return Object.keys(attributes).map(function(key){var _a,_b;var value=(_a=attributes[key])!==null&&_a!==void 0?_a:"";if(opts.xmlMode==="foreign"){/* Fix up mixed-case attribute names */key=(_b=foreignNames_1.attributeNames.get(key))!==null&&_b!==void 0?_b:key;}if(!opts.emptyAttrs&&!opts.xmlMode&&value===""){return key;}return key+"=\""+(opts.decodeEntities?entities_1.encodeXML(value):value.replace(/"/g,"&quot;"))+"\"";}).join(" ");}/**
	 * Self-enclosing tags
	 */var singleTag=new Set(["area","base","basefont","br","col","command","embed","frame","hr","img","input","isindex","keygen","link","meta","param","source","track","wbr"]);/**
	 * Renders a DOM node or an array of DOM nodes to a string.
	 *
	 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
	 *
	 * @param node Node to be rendered.
	 * @param options Changes serialization behavior
	 */function render(node,options){if(options===void 0){options={};}// TODO: This is a bit hacky.
	var nodes=Array.isArray(node)||node.cheerio?node:[node];var output="";for(var i=0;i<nodes.length;i++){output+=renderNode(nodes[i],options);}return output;}exports["default"]=render;function renderNode(node,options){switch(node.type){case"root":return render(node.children,options);case ElementType.Directive:return renderDirective(node);case ElementType.Comment:return renderComment(node);case ElementType.CDATA:return renderCdata(node);default:return ElementType.isTag(node)?renderTag(node,options):renderText(node,options);}}var foreignModeIntegrationPoints=new Set(["mi","mo","mn","ms","mtext","annotation-xml","foreignObject","desc","title"]);var foreignElements=new Set(["svg","math"]);function renderTag(elem,opts){var _a;// Handle SVG / MathML in HTML
	if(opts.xmlMode==="foreign"){/* Fix up mixed-case element names */elem.name=(_a=foreignNames_1.elementNames.get(elem.name))!==null&&_a!==void 0?_a:elem.name;/* Exit foreign mode at integration points */if(elem.parent&&foreignModeIntegrationPoints.has(elem.parent.name)){opts=__assign(__assign({},opts),{xmlMode:false});}}if(!opts.xmlMode&&foreignElements.has(elem.name)){opts=__assign(__assign({},opts),{xmlMode:"foreign"});}var tag="<"+elem.name;var attribs=formatAttributes(elem.attribs,opts);if(attribs){tag+=" "+attribs;}if(elem.children.length===0&&(opts.xmlMode?// In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
	opts.selfClosingTags!==false:// User explicitly asked for self-closing tags, even in HTML mode
	opts.selfClosingTags&&singleTag.has(elem.name))){if(!opts.xmlMode)tag+=" ";tag+="/>";}else{tag+=">";if(elem.children.length>0){tag+=render(elem.children,opts);}if(opts.xmlMode||!singleTag.has(elem.name)){tag+="</"+elem.name+">";}}return tag;}function renderDirective(elem){return"<"+elem.data+">";}function renderText(elem,opts){var data=elem.data||"";// If entities weren't decoded, no need to encode them back
	if(opts.decodeEntities&&!(elem.parent&&unencodedElements.has(elem.parent.name))){data=entities_1.encodeXML(data);}return data;}function renderCdata(elem){return"<![CDATA["+elem.children[0].data+"]]>";}function renderComment(elem){return"<!--"+elem.data+"-->";}},{"./foreignNames":4,"domelementtype":6,"entities":20}],6:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.Doctype=exports.CDATA=exports.Tag=exports.Style=exports.Script=exports.Comment=exports.Directive=exports.Text=exports.isTag=void 0;/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */function isTag(elem){return elem.type==="tag"/* Tag */||elem.type==="script"/* Script */||elem.type==="style"/* Style */;}exports.isTag=isTag;// Exports for backwards compatibility
	/** Type for Text */exports.Text="text"/* Text */;/** Type for <? ... ?> */exports.Directive="directive"/* Directive */;/** Type for <!-- ... --> */exports.Comment="comment"/* Comment */;/** Type for <script> tags */exports.Script="script"/* Script */;/** Type for <style> tags */exports.Style="style"/* Style */;/** Type for Any tag */exports.Tag="tag"/* Tag */;/** Type for <![CDATA[ ... ]]> */exports.CDATA="cdata"/* CDATA */;/** Type for <!doctype ...> */exports.Doctype="doctype"/* Doctype */;},{}],7:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});var node_1=require("./node");exports.Node=node_1.Node;exports.Element=node_1.Element;exports.DataNode=node_1.DataNode;exports.NodeWithChildren=node_1.NodeWithChildren;var reWhitespace=/\s+/g;// Default options
	var defaultOpts={normalizeWhitespace:false,withStartIndices:false,withEndIndices:false};var DomHandler=/** @class */function(){/**
	     * Initiate a new DomHandler.
	     *
	     * @param callback Called once parsing has completed.
	     * @param options Settings for the handler.
	     * @param elementCB Callback whenever a tag is closed.
	     */function DomHandler(callback,options,elementCB){/** The constructed DOM */this.dom=[];/** Indicated whether parsing has been completed. */this._done=false;/** Stack of open tags. */this._tagStack=[];/** A data node that is still being written to. */this._lastNode=null;/** Reference to the parser instance. Used for location information. */this._parser=null;// Make it possible to skip arguments, for backwards-compatibility
	if(typeof options==="function"){elementCB=options;options=defaultOpts;}if(_typeof(callback)==="object"){options=callback;callback=undefined;}this._callback=callback||null;this._options=options||defaultOpts;this._elementCB=elementCB||null;}DomHandler.prototype.onparserinit=function(parser){this._parser=parser;};// Resets the handler back to starting state
	DomHandler.prototype.onreset=function(){this.dom=[];this._done=false;this._tagStack=[];this._lastNode=null;this._parser=this._parser||null;};// Signals the handler that parsing is done
	DomHandler.prototype.onend=function(){if(this._done)return;this._done=true;this._parser=null;this.handleCallback(null);};DomHandler.prototype.onerror=function(error){this.handleCallback(error);};DomHandler.prototype.onclosetag=function(){this._lastNode=null;// If(this._tagStack.pop().name !== name) this.handleCallback(Error("Tagname didn't match!"));
	var elem=this._tagStack.pop();if(!elem||!this._parser){return;}if(this._options.withEndIndices){elem.endIndex=this._parser.endIndex;}if(this._elementCB)this._elementCB(elem);};DomHandler.prototype.onopentag=function(name,attribs){var element=new node_1.Element(name,attribs);this.addNode(element);this._tagStack.push(element);};DomHandler.prototype.ontext=function(data){var normalize=this._options.normalizeWhitespace;var _lastNode=this._lastNode;if(_lastNode&&_lastNode.type==="text"/* Text */){if(normalize){_lastNode.data=(_lastNode.data+data).replace(reWhitespace," ");}else{_lastNode.data+=data;}}else{if(normalize){data=data.replace(reWhitespace," ");}var node=new node_1.DataNode("text"/* Text */,data);this.addNode(node);this._lastNode=node;}};DomHandler.prototype.oncomment=function(data){if(this._lastNode&&this._lastNode.type==="comment"/* Comment */){this._lastNode.data+=data;return;}var node=new node_1.DataNode("comment"/* Comment */,data);this.addNode(node);this._lastNode=node;};DomHandler.prototype.oncommentend=function(){this._lastNode=null;};DomHandler.prototype.oncdatastart=function(){var text=new node_1.DataNode("text"/* Text */,"");var node=new node_1.NodeWithChildren("cdata"/* CDATA */,[text]);this.addNode(node);text.parent=node;this._lastNode=text;};DomHandler.prototype.oncdataend=function(){this._lastNode=null;};DomHandler.prototype.onprocessinginstruction=function(name,data){var node=new node_1.ProcessingInstruction(name,data);this.addNode(node);};DomHandler.prototype.handleCallback=function(error){if(typeof this._callback==="function"){this._callback(error,this.dom);}else if(error){throw error;}};DomHandler.prototype.addNode=function(node){var parent=this._tagStack[this._tagStack.length-1];var siblings=parent?parent.children:this.dom;var previousSibling=siblings[siblings.length-1];if(this._parser){if(this._options.withStartIndices){node.startIndex=this._parser.startIndex;}if(this._options.withEndIndices){node.endIndex=this._parser.endIndex;}}siblings.push(node);if(previousSibling){node.prev=previousSibling;previousSibling.next=node;}if(parent){node.parent=parent;}this._lastNode=null;};DomHandler.prototype.addDataNode=function(node){this.addNode(node);this._lastNode=node;};return DomHandler;}();exports.DomHandler=DomHandler;exports["default"]=DomHandler;},{"./node":8}],8:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics=function extendStatics(d,b){_extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics(d,b);};return function(d,b){_extendStatics(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();Object.defineProperty(exports,"__esModule",{value:true});var nodeTypes=new Map([["tag"/* Tag */,1],["script"/* Script */,1],["style"/* Style */,1],["directive"/* Directive */,1],["text"/* Text */,3],["cdata"/* CDATA */,4],["comment"/* Comment */,8]]);// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var Node=/** @class */function(){/**
	     *
	     * @param type The type of the node.
	     */function Node(type){this.type=type;/** Parent of the node */this.parent=null;/** Previous sibling */this.prev=null;/** Next sibling */this.next=null;/** The start index of the node. Requires `withStartIndices` on the handler to be `true. */this.startIndex=null;/** The end index of the node. Requires `withEndIndices` on the handler to be `true. */this.endIndex=null;}Object.defineProperty(Node.prototype,"nodeType",{// Read-only aliases
	get:function get(){return nodeTypes.get(this.type)||1;},enumerable:true,configurable:true});Object.defineProperty(Node.prototype,"parentNode",{// Read-write aliases for properties
	get:function get(){return this.parent||null;},set:function set(parent){this.parent=parent;},enumerable:true,configurable:true});Object.defineProperty(Node.prototype,"previousSibling",{get:function get(){return this.prev||null;},set:function set(prev){this.prev=prev;},enumerable:true,configurable:true});Object.defineProperty(Node.prototype,"nextSibling",{get:function get(){return this.next||null;},set:function set(next){this.next=next;},enumerable:true,configurable:true});return Node;}();exports.Node=Node;var DataNode=/** @class */function(_super){__extends(DataNode,_super);/**
	     *
	     * @param type The type of the node
	     * @param data The content of the data node
	     */function DataNode(type,data){var _this=_super.call(this,type)||this;_this.data=data;return _this;}Object.defineProperty(DataNode.prototype,"nodeValue",{get:function get(){return this.data;},set:function set(data){this.data=data;},enumerable:true,configurable:true});return DataNode;}(Node);exports.DataNode=DataNode;var ProcessingInstruction=/** @class */function(_super){__extends(ProcessingInstruction,_super);function ProcessingInstruction(name,data){var _this=_super.call(this,"directive"/* Directive */,data)||this;_this.name=name;return _this;}return ProcessingInstruction;}(DataNode);exports.ProcessingInstruction=ProcessingInstruction;var NodeWithChildren=/** @class */function(_super){__extends(NodeWithChildren,_super);/**
	     *
	     * @param type Type of the node.
	     * @param children Children of the node. Only certain node types can have children.
	     */function NodeWithChildren(type,children){var _this=_super.call(this,type)||this;_this.children=children;return _this;}Object.defineProperty(NodeWithChildren.prototype,"firstChild",{// Aliases
	get:function get(){return this.children[0]||null;},enumerable:true,configurable:true});Object.defineProperty(NodeWithChildren.prototype,"lastChild",{get:function get(){return this.children[this.children.length-1]||null;},enumerable:true,configurable:true});Object.defineProperty(NodeWithChildren.prototype,"childNodes",{get:function get(){return this.children;},set:function set(children){this.children=children;},enumerable:true,configurable:true});return NodeWithChildren;}(Node);exports.NodeWithChildren=NodeWithChildren;var Element=/** @class */function(_super){__extends(Element,_super);/**
	     *
	     * @param name Name of the tag, eg. `div`, `span`
	     * @param attribs Object mapping attribute names to attribute values
	     */function Element(name,attribs){var _this=_super.call(this,name==="script"?"script"/* Script */:name==="style"?"style"/* Style */:"tag"/* Tag */,[])||this;_this.name=name;_this.attribs=attribs;_this.attribs=attribs;return _this;}Object.defineProperty(Element.prototype,"tagName",{// DOM Level 1 aliases
	get:function get(){return this.name;},set:function set(name){this.name=name;},enumerable:true,configurable:true});return Element;}(NodeWithChildren);exports.Element=Element;},{}],9:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.uniqueSort=exports.compareDocumentPosition=exports.removeSubsets=void 0;var tagtypes_1=require("./tagtypes");/**
	 * Given an array of nodes, remove any member that is contained by another.
	 *
	 * @param nodes Nodes to filter.
	 */function removeSubsets(nodes){var idx=nodes.length;/*
	     * Check if each node (or one of its ancestors) is already contained in the
	     * array.
	     */while(--idx>=0){var node=nodes[idx];/*
	         * Remove the node if it is not unique.
	         * We are going through the array from the end, so we only
	         * have to check nodes that preceed the node under consideration in the array.
	         */if(idx>0&&nodes.lastIndexOf(node,idx-1)>=0){nodes.splice(idx,1);continue;}for(var ancestor=node.parent;ancestor;ancestor=ancestor.parent){if(nodes.includes(ancestor)){nodes.splice(idx,1);break;}}}return nodes;}exports.removeSubsets=removeSubsets;/**
	 * Compare the position of one node against another node in any other document.
	 * The return value is a bitmask with the following values:
	 *
	 * document order:
	 * > There is an ordering, document order, defined on all the nodes in the
	 * > document corresponding to the order in which the first character of the
	 * > XML representation of each node occurs in the XML representation of the
	 * > document after expansion of general entities. Thus, the document element
	 * > node will be the first node. Element nodes occur before their children.
	 * > Thus, document order orders element nodes in order of the occurrence of
	 * > their start-tag in the XML (after expansion of entities). The attribute
	 * > nodes of an element occur after the element and before its children. The
	 * > relative order of attribute nodes is implementation-dependent./
	 *
	 * Source:
	 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	 * @param nodaA The first node to use in the comparison
	 * @param nodeB The second node to use in the comparison
	 *
	 * @return A bitmask describing the input nodes' relative position.
	 *
	 *        See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	 *        a description of these values.
	 */function compareDocumentPosition(nodeA,nodeB){var aParents=[];var bParents=[];if(nodeA===nodeB){return 0;}var current=tagtypes_1.hasChildren(nodeA)?nodeA:nodeA.parent;while(current){aParents.unshift(current);current=current.parent;}current=tagtypes_1.hasChildren(nodeB)?nodeB:nodeB.parent;while(current){bParents.unshift(current);current=current.parent;}var maxIdx=Math.min(aParents.length,bParents.length);var idx=0;while(idx<maxIdx&&aParents[idx]===bParents[idx]){idx++;}if(idx===0){return 1/* DISCONNECTED */;}var sharedParent=aParents[idx-1];var siblings=sharedParent.children;var aSibling=aParents[idx];var bSibling=bParents[idx];if(siblings.indexOf(aSibling)>siblings.indexOf(bSibling)){if(sharedParent===nodeB){return 4/* FOLLOWING */|16/* CONTAINED_BY */;}return 4/* FOLLOWING */;}if(sharedParent===nodeA){return 2/* PRECEDING */|8/* CONTAINS */;}return 2/* PRECEDING */;}exports.compareDocumentPosition=compareDocumentPosition;/**
	 * Sort an array of nodes based on their relative position in the document and
	 * remove any duplicate nodes. If the array contains nodes that do not belong
	 * to the same document, sort order is unspecified.
	 *
	 * @param nodes Array of DOM nodes
	 * @returns collection of unique nodes, sorted in document order
	 */function uniqueSort(nodes){nodes=nodes.filter(function(node,i,arr){return!arr.includes(node,i+1);});nodes.sort(function(a,b){var relative=compareDocumentPosition(a,b);if(relative&2/* PRECEDING */){return-1;}else if(relative&4/* FOLLOWING */){return 1;}return 0;});return nodes;}exports.uniqueSort=uniqueSort;},{"./tagtypes":15}],10:[function(require,module,exports){"use strict";var __createBinding=this&&this.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;Object.defineProperty(o,k2,{enumerable:true,get:function get(){return m[k];}});}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __exportStar=this&&this.__exportStar||function(m,exports){for(var p in m){if(p!=="default"&&!Object.prototype.hasOwnProperty.call(exports,p))__createBinding(exports,m,p);}};Object.defineProperty(exports,"__esModule",{value:true});__exportStar(require("./stringify"),exports);__exportStar(require("./traversal"),exports);__exportStar(require("./manipulation"),exports);__exportStar(require("./querying"),exports);__exportStar(require("./legacy"),exports);__exportStar(require("./helpers"),exports);__exportStar(require("./tagtypes"),exports);},{"./helpers":9,"./legacy":11,"./manipulation":12,"./querying":13,"./stringify":14,"./tagtypes":15,"./traversal":16}],11:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.getElementsByTagType=exports.getElementsByTagName=exports.getElementById=exports.getElements=exports.testElement=void 0;var querying_1=require("./querying");var tagtypes_1=require("./tagtypes");function isTextNode(node){return node.type==="text"/* Text */;}var Checks={tag_name:function tag_name(name){if(typeof name==="function"){return function(elem){return tagtypes_1.isTag(elem)&&name(elem.name);};}else if(name==="*"){return tagtypes_1.isTag;}return function(elem){return tagtypes_1.isTag(elem)&&elem.name===name;};},tag_type:function tag_type(type){if(typeof type==="function"){return function(elem){return type(elem.type);};}return function(elem){return elem.type===type;};},tag_contains:function tag_contains(data){if(typeof data==="function"){return function(elem){return isTextNode(elem)&&data(elem.data);};}return function(elem){return isTextNode(elem)&&elem.data===data;};}};function getAttribCheck(attrib,value){if(typeof value==="function"){return function(elem){return tagtypes_1.isTag(elem)&&value(elem.attribs[attrib]);};}return function(elem){return tagtypes_1.isTag(elem)&&elem.attribs[attrib]===value;};}function combineFuncs(a,b){return function(elem){return a(elem)||b(elem);};}function compileTest(options){var funcs=Object.keys(options).map(function(key){var value=options[key];return key in Checks?Checks[key](value):getAttribCheck(key,value);});return funcs.length===0?null:funcs.reduce(combineFuncs);}function testElement(options,element){var test=compileTest(options);return test?test(element):true;}exports.testElement=testElement;function getElements(options,element,recurse,limit){if(limit===void 0){limit=Infinity;}var test=compileTest(options);return test?querying_1.filter(test,element,recurse,limit):[];}exports.getElements=getElements;function getElementById(id,element,recurse){if(recurse===void 0){recurse=true;}if(!Array.isArray(element))element=[element];return querying_1.findOne(getAttribCheck("id",id),element,recurse);}exports.getElementById=getElementById;function getElementsByTagName(name,element,recurse,limit){if(limit===void 0){limit=Infinity;}return querying_1.filter(Checks.tag_name(name),element,recurse,limit);}exports.getElementsByTagName=getElementsByTagName;function getElementsByTagType(type,element,recurse,limit){if(recurse===void 0){recurse=true;}if(limit===void 0){limit=Infinity;}return querying_1.filter(Checks.tag_type(type),element,recurse,limit);}exports.getElementsByTagType=getElementsByTagType;},{"./querying":13,"./tagtypes":15}],12:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.prepend=exports.append=exports.appendChild=exports.replaceElement=exports.removeElement=void 0;/**
	 * Remove an element from the dom
	 *
	 * @param elem The element to be removed
	 */function removeElement(elem){if(elem.prev)elem.prev.next=elem.next;if(elem.next)elem.next.prev=elem.prev;if(elem.parent){var childs=elem.parent.children;childs.splice(childs.lastIndexOf(elem),1);}}exports.removeElement=removeElement;/**
	 * Replace an element in the dom
	 *
	 * @param elem The element to be replaced
	 * @param replacement The element to be added
	 */function replaceElement(elem,replacement){var prev=replacement.prev=elem.prev;if(prev){prev.next=replacement;}var next=replacement.next=elem.next;if(next){next.prev=replacement;}var parent=replacement.parent=elem.parent;if(parent){var childs=parent.children;childs[childs.lastIndexOf(elem)]=replacement;}}exports.replaceElement=replaceElement;/**
	 * Append a child to an element
	 *
	 * @param elem The element to append to
	 * @param child The element to be added as a child
	 */function appendChild(elem,child){removeElement(child);child.parent=elem;if(elem.children.push(child)!==1){var sibling=elem.children[elem.children.length-2];sibling.next=child;child.prev=sibling;child.next=null;}}exports.appendChild=appendChild;/**
	 * Append an element after another
	 *
	 * @param elem The element to append to
	 * @param next The element be added
	 */function append(elem,next){removeElement(next);var parent=elem.parent;var currNext=elem.next;next.next=currNext;next.prev=elem;elem.next=next;next.parent=parent;if(currNext){currNext.prev=next;if(parent){var childs=parent.children;childs.splice(childs.lastIndexOf(currNext),0,next);}}else if(parent){parent.children.push(next);}}exports.append=append;/**
	 * Prepend an element before another
	 *
	 * @param elem The element to append to
	 * @param prev The element be added
	 */function prepend(elem,prev){var parent=elem.parent;if(parent){var childs=parent.children;childs.splice(childs.lastIndexOf(elem),0,prev);}if(elem.prev){elem.prev.next=prev;}prev.parent=parent;prev.prev=elem.prev;prev.next=elem;elem.prev=prev;}exports.prepend=prepend;},{}],13:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.findAll=exports.existsOne=exports.findOne=exports.findOneChild=exports.find=exports.filter=void 0;var tagtypes_1=require("./tagtypes");/**
	 * Search a node and its children for nodes passing a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param element Element to search. Will be included in the result set if it matches.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 */function filter(test,node,recurse,limit){if(recurse===void 0){recurse=true;}if(limit===void 0){limit=Infinity;}if(!Array.isArray(node))node=[node];return find(test,node,recurse,limit);}exports.filter=filter;/**
	 * Like `filter`, but only works on an array of nodes.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 */function find(test,nodes,recurse,limit){var result=[];for(var _i=0,nodes_1=nodes;_i<nodes_1.length;_i++){var elem=nodes_1[_i];if(test(elem)){result.push(elem);if(--limit<=0)break;}if(recurse&&tagtypes_1.hasChildren(elem)&&elem.children.length>0){var children=find(test,elem.children,recurse,limit);result.push.apply(result,children);limit-=children.length;if(limit<=0)break;}}return result;}exports.find=find;/**
	 * Finds the first element inside of an array that matches a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */function findOneChild(test,nodes){return nodes.find(test);}exports.findOneChild=findOneChild;/**
	 * Finds one element in a tree that passes a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 */function findOne(test,nodes,recurse){if(recurse===void 0){recurse=true;}var elem=null;for(var i=0;i<nodes.length&&!elem;i++){var checked=nodes[i];if(!tagtypes_1.isTag(checked)){continue;}else if(test(checked)){elem=checked;}else if(recurse&&checked.children.length>0){elem=findOne(test,checked.children);}}return elem;}exports.findOne=findOne;/**
	 * Returns whether a tree of nodes contains at least one node passing a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */function existsOne(test,nodes){return nodes.some(function(checked){return tagtypes_1.isTag(checked)&&(test(checked)||checked.children.length>0&&existsOne(test,checked.children));});}exports.existsOne=existsOne;/**
	 * Search and array of nodes and its children for nodes passing a test function.
	 *
	 * Same as `find`, only with less options, leading to reduced complexity.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */function findAll(test,nodes){var _a;var result=[];var stack=nodes.filter(tagtypes_1.isTag);var elem;while(elem=stack.shift()){var children=(_a=elem.children)===null||_a===void 0?void 0:_a.filter(tagtypes_1.isTag);if(children&&children.length>0){stack.unshift.apply(stack,children);}if(test(elem))result.push(elem);}return result;}exports.findAll=findAll;},{"./tagtypes":15}],14:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});exports.getText=exports.getInnerHTML=exports.getOuterHTML=void 0;var tagtypes_1=require("./tagtypes");var dom_serializer_1=__importDefault(require("dom-serializer"));function getOuterHTML(node,options){return dom_serializer_1["default"](node,options);}exports.getOuterHTML=getOuterHTML;function getInnerHTML(node,options){return tagtypes_1.hasChildren(node)?node.children.map(function(node){return getOuterHTML(node,options);}).join(""):"";}exports.getInnerHTML=getInnerHTML;function getText(node){if(Array.isArray(node))return node.map(getText).join("");if(tagtypes_1.isTag(node))return node.name==="br"?"\n":getText(node.children);if(tagtypes_1.isCDATA(node))return getText(node.children);if(tagtypes_1.isText(node))return node.data;return"";}exports.getText=getText;},{"./tagtypes":15,"dom-serializer":5}],15:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.hasChildren=exports.isComment=exports.isText=exports.isCDATA=exports.isTag=void 0;var domelementtype_1=require("domelementtype");function isTag(node){return domelementtype_1.isTag(node);}exports.isTag=isTag;function isCDATA(node){return node.type==="cdata"/* CDATA */;}exports.isCDATA=isCDATA;function isText(node){return node.type==="text"/* Text */;}exports.isText=isText;function isComment(node){return node.type==="comment"/* Comment */;}exports.isComment=isComment;function hasChildren(node){return Object.prototype.hasOwnProperty.call(node,"children");}exports.hasChildren=hasChildren;},{"domelementtype":6}],16:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.nextElementSibling=exports.getName=exports.hasAttrib=exports.getAttributeValue=exports.getSiblings=exports.getParent=exports.getChildren=void 0;function getChildren(elem){return elem.children||null;}exports.getChildren=getChildren;function getParent(elem){return elem.parent||null;}exports.getParent=getParent;function getSiblings(elem){var parent=getParent(elem);return parent?getChildren(parent):[elem];}exports.getSiblings=getSiblings;function getAttributeValue(elem,name){var _a;return(_a=elem.attribs)===null||_a===void 0?void 0:_a[name];}exports.getAttributeValue=getAttributeValue;function hasAttrib(elem,name){return!!elem.attribs&&Object.prototype.hasOwnProperty.call(elem.attribs,name)&&elem.attribs[name]!=null;}exports.hasAttrib=hasAttrib;/**
	 * Returns the name property of an element
	 *
	 * @param elem The element to get the name for
	 */function getName(elem){return elem.name;}exports.getName=getName;function nextElementSibling(elem){var node=elem.next;while(node!==null&&node.type!=="tag"){node=node.next;}return node;}exports.nextElementSibling=nextElementSibling;},{}],17:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});exports.decodeHTML=exports.decodeHTMLStrict=exports.decodeXML=void 0;var entities_json_1=__importDefault(require("./maps/entities.json"));var legacy_json_1=__importDefault(require("./maps/legacy.json"));var xml_json_1=__importDefault(require("./maps/xml.json"));var decode_codepoint_1=__importDefault(require("./decode_codepoint"));exports.decodeXML=getStrictDecoder(xml_json_1["default"]);exports.decodeHTMLStrict=getStrictDecoder(entities_json_1["default"]);function getStrictDecoder(map){var keys=Object.keys(map).join("|");var replace=getReplacer(map);keys+="|#[xX][\\da-fA-F]+|#\\d+";var re=new RegExp("&(?:"+keys+");","g");return function(str){return String(str).replace(re,replace);};}var sorter=function sorter(a,b){return a<b?1:-1;};exports.decodeHTML=function(){var legacy=Object.keys(legacy_json_1["default"]).sort(sorter);var keys=Object.keys(entities_json_1["default"]).sort(sorter);for(var i=0,j=0;i<keys.length;i++){if(legacy[j]===keys[i]){keys[i]+=";?";j++;}else{keys[i]+=";";}}var re=new RegExp("&(?:"+keys.join("|")+"|#[xX][\\da-fA-F]+;?|#\\d+;?)","g");var replace=getReplacer(entities_json_1["default"]);function replacer(str){if(str.substr(-1)!==";")str+=";";return replace(str);}//TODO consider creating a merged map
	return function(str){return String(str).replace(re,replacer);};}();function getReplacer(map){return function replace(str){if(str.charAt(1)==="#"){var secondChar=str.charAt(2);if(secondChar==="X"||secondChar==="x"){return decode_codepoint_1["default"](parseInt(str.substr(3),16));}return decode_codepoint_1["default"](parseInt(str.substr(2),10));}return map[str.slice(1,-1)];};}},{"./decode_codepoint":18,"./maps/entities.json":22,"./maps/legacy.json":23,"./maps/xml.json":24}],18:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var decode_json_1=__importDefault(require("./maps/decode.json"));// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint){if(codePoint>=0xd800&&codePoint<=0xdfff||codePoint>0x10ffff){return"\uFFFD";}if(codePoint in decode_json_1["default"]){codePoint=decode_json_1["default"][codePoint];}var output="";if(codePoint>0xffff){codePoint-=0x10000;output+=String.fromCharCode(codePoint>>>10&0x3ff|0xd800);codePoint=0xdc00|codePoint&0x3ff;}output+=String.fromCharCode(codePoint);return output;}exports["default"]=decodeCodePoint;},{"./maps/decode.json":21}],19:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});exports.escape=exports.encodeHTML=exports.encodeXML=void 0;var xml_json_1=__importDefault(require("./maps/xml.json"));var inverseXML=getInverseObj(xml_json_1["default"]);var xmlReplacer=getInverseReplacer(inverseXML);exports.encodeXML=getInverse(inverseXML,xmlReplacer);var entities_json_1=__importDefault(require("./maps/entities.json"));var inverseHTML=getInverseObj(entities_json_1["default"]);var htmlReplacer=getInverseReplacer(inverseHTML);exports.encodeHTML=getInverse(inverseHTML,htmlReplacer);function getInverseObj(obj){return Object.keys(obj).sort().reduce(function(inverse,name){inverse[obj[name]]="&"+name+";";return inverse;},{});}function getInverseReplacer(inverse){var single=[];var multiple=[];for(var _i=0,_a=Object.keys(inverse);_i<_a.length;_i++){var k=_a[_i];if(k.length===1){// Add value to single array
	single.push("\\"+k);}else{// Add value to multiple array
	multiple.push(k);}}// Add ranges to single characters.
	single.sort();for(var start=0;start<single.length-1;start++){// Find the end of a run of characters
	var end=start;while(end<single.length-1&&single[end].charCodeAt(1)+1===single[end+1].charCodeAt(1)){end+=1;}var count=1+end-start;// We want to replace at least three characters
	if(count<3)continue;single.splice(start,count,single[start]+"-"+single[end]);}multiple.unshift("["+single.join("")+"]");return new RegExp(multiple.join("|"),"g");}var reNonASCII=/(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;function singleCharReplacer(c){// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return"&#x"+c.codePointAt(0).toString(16).toUpperCase()+";";}function getInverse(inverse,re){return function(data){return data.replace(re,function(name){return inverse[name];}).replace(reNonASCII,singleCharReplacer);};}var reXmlChars=getInverseReplacer(inverseXML);function escape(data){return data.replace(reXmlChars,singleCharReplacer).replace(reNonASCII,singleCharReplacer);}exports.escape=escape;},{"./maps/entities.json":22,"./maps/xml.json":24}],20:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.encode=exports.decodeStrict=exports.decode=void 0;var decode_1=require("./decode");var encode_1=require("./encode");/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 */function decode(data,level){return(!level||level<=0?decode_1.decodeXML:decode_1.decodeHTML)(data);}exports.decode=decode;/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 */function decodeStrict(data,level){return(!level||level<=0?decode_1.decodeXML:decode_1.decodeHTMLStrict)(data);}exports.decodeStrict=decodeStrict;/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
	 */function encode(data,level){return(!level||level<=0?encode_1.encodeXML:encode_1.encodeHTML)(data);}exports.encode=encode;var encode_2=require("./encode");Object.defineProperty(exports,"encodeXML",{enumerable:true,get:function get(){return encode_2.encodeXML;}});Object.defineProperty(exports,"encodeHTML",{enumerable:true,get:function get(){return encode_2.encodeHTML;}});Object.defineProperty(exports,"escape",{enumerable:true,get:function get(){return encode_2.escape;}});// Legacy aliases
	Object.defineProperty(exports,"encodeHTML4",{enumerable:true,get:function get(){return encode_2.encodeHTML;}});Object.defineProperty(exports,"encodeHTML5",{enumerable:true,get:function get(){return encode_2.encodeHTML;}});var decode_2=require("./decode");Object.defineProperty(exports,"decodeXML",{enumerable:true,get:function get(){return decode_2.decodeXML;}});Object.defineProperty(exports,"decodeHTML",{enumerable:true,get:function get(){return decode_2.decodeHTML;}});Object.defineProperty(exports,"decodeHTMLStrict",{enumerable:true,get:function get(){return decode_2.decodeHTMLStrict;}});// Legacy aliases
	Object.defineProperty(exports,"decodeHTML4",{enumerable:true,get:function get(){return decode_2.decodeHTML;}});Object.defineProperty(exports,"decodeHTML5",{enumerable:true,get:function get(){return decode_2.decodeHTML;}});Object.defineProperty(exports,"decodeHTML4Strict",{enumerable:true,get:function get(){return decode_2.decodeHTMLStrict;}});Object.defineProperty(exports,"decodeHTML5Strict",{enumerable:true,get:function get(){return decode_2.decodeHTMLStrict;}});Object.defineProperty(exports,"decodeXMLStrict",{enumerable:true,get:function get(){return decode_2.decodeXML;}});},{"./decode":17,"./encode":19}],21:[function(require,module,exports){module.exports={"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376};},{}],22:[function(require,module,exports){module.exports={"Aacute":"\xC1","aacute":"\xE1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xC2","acirc":"\xE2","acute":"\xB4","Acy":"\u0410","acy":"\u0430","AElig":"\xC6","aelig":"\xE6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xC0","agrave":"\xE0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xC5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xC5","aring":"\xE5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xC3","atilde":"\xE3","Auml":"\xC4","auml":"\xE4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xA6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xC7","ccedil":"\xE7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xB8","Cedilla":"\xB8","cemptyv":"\u29B2","cent":"\xA2","centerdot":"\xB7","CenterDot":"\xB7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xAE","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xA9","COPY":"\xA9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xA4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xB0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xB4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xA8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xF7","divide":"\xF7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xA8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xA8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xC9","eacute":"\xE9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xCA","ecirc":"\xEA","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xC8","egrave":"\xE8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xD0","eth":"\xF0","Euml":"\xCB","euml":"\xEB","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xBD","frac13":"\u2153","frac14":"\xBC","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xBE","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xBD","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xCD","iacute":"\xED","ic":"\u2063","Icirc":"\xCE","icirc":"\xEE","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xA1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xCC","igrave":"\xEC","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xBF","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xCF","iuml":"\xEF","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xAB","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xAF","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xB5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xB7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xA0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xA0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xAC","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xD1","ntilde":"\xF1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xD3","oacute":"\xF3","oast":"\u229B","Ocirc":"\xD4","ocirc":"\xF4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xD2","ograve":"\xF2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xAA","ordm":"\xBA","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xD8","oslash":"\xF8","osol":"\u2298","Otilde":"\xD5","otilde":"\xF5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xD6","ouml":"\xF6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xB6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xB1","plusmn":"\xB1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xB1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xA3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\"","QUOT":"\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xBB","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xAE","REG":"\xAE","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xA7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xAD","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xAF","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xB9","sup2":"\xB2","sup3":"\xB3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xDF","Tab":"\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xDE","thorn":"\xFE","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xD7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xDA","uacute":"\xFA","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xDB","ucirc":"\xFB","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xD9","ugrave":"\xF9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xA8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xDC","uuml":"\xFC","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xDD","yacute":"\xFD","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xA5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xFF","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"};},{}],23:[function(require,module,exports){module.exports={"Aacute":"\xC1","aacute":"\xE1","Acirc":"\xC2","acirc":"\xE2","acute":"\xB4","AElig":"\xC6","aelig":"\xE6","Agrave":"\xC0","agrave":"\xE0","amp":"&","AMP":"&","Aring":"\xC5","aring":"\xE5","Atilde":"\xC3","atilde":"\xE3","Auml":"\xC4","auml":"\xE4","brvbar":"\xA6","Ccedil":"\xC7","ccedil":"\xE7","cedil":"\xB8","cent":"\xA2","copy":"\xA9","COPY":"\xA9","curren":"\xA4","deg":"\xB0","divide":"\xF7","Eacute":"\xC9","eacute":"\xE9","Ecirc":"\xCA","ecirc":"\xEA","Egrave":"\xC8","egrave":"\xE8","ETH":"\xD0","eth":"\xF0","Euml":"\xCB","euml":"\xEB","frac12":"\xBD","frac14":"\xBC","frac34":"\xBE","gt":">","GT":">","Iacute":"\xCD","iacute":"\xED","Icirc":"\xCE","icirc":"\xEE","iexcl":"\xA1","Igrave":"\xCC","igrave":"\xEC","iquest":"\xBF","Iuml":"\xCF","iuml":"\xEF","laquo":"\xAB","lt":"<","LT":"<","macr":"\xAF","micro":"\xB5","middot":"\xB7","nbsp":"\xA0","not":"\xAC","Ntilde":"\xD1","ntilde":"\xF1","Oacute":"\xD3","oacute":"\xF3","Ocirc":"\xD4","ocirc":"\xF4","Ograve":"\xD2","ograve":"\xF2","ordf":"\xAA","ordm":"\xBA","Oslash":"\xD8","oslash":"\xF8","Otilde":"\xD5","otilde":"\xF5","Ouml":"\xD6","ouml":"\xF6","para":"\xB6","plusmn":"\xB1","pound":"\xA3","quot":"\"","QUOT":"\"","raquo":"\xBB","reg":"\xAE","REG":"\xAE","sect":"\xA7","shy":"\xAD","sup1":"\xB9","sup2":"\xB2","sup3":"\xB3","szlig":"\xDF","THORN":"\xDE","thorn":"\xFE","times":"\xD7","Uacute":"\xDA","uacute":"\xFA","Ucirc":"\xDB","ucirc":"\xFB","Ugrave":"\xD9","ugrave":"\xF9","uml":"\xA8","Uuml":"\xDC","uuml":"\xFC","Yacute":"\xDD","yacute":"\xFD","yen":"\xA5","yuml":"\xFF"};},{}],24:[function(require,module,exports){module.exports={"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""};},{}],25:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	var objectCreate=Object.create||objectCreatePolyfill;var objectKeys=Object.keys||objectKeysPolyfill;var bind=Function.prototype.bind||functionBindPolyfill;function EventEmitter(){if(!this._events||!Object.prototype.hasOwnProperty.call(this,'_events')){this._events=objectCreate(null);this._eventsCount=0;}this._maxListeners=this._maxListeners||undefined;}module.exports=EventEmitter;// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._maxListeners=undefined;// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners=10;var hasDefineProperty;try{var o={};if(Object.defineProperty)Object.defineProperty(o,'x',{value:0});hasDefineProperty=o.x===0;}catch(err){hasDefineProperty=false;}if(hasDefineProperty){Object.defineProperty(EventEmitter,'defaultMaxListeners',{enumerable:true,get:function get(){return defaultMaxListeners;},set:function set(arg){// check whether the input is a positive number (whose value is zero or
	// greater and not a NaN).
	if(typeof arg!=='number'||arg<0||arg!==arg)throw new TypeError('"defaultMaxListeners" must be a positive number');defaultMaxListeners=arg;}});}else{EventEmitter.defaultMaxListeners=defaultMaxListeners;}// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners=function setMaxListeners(n){if(typeof n!=='number'||n<0||isNaN(n))throw new TypeError('"n" argument must be a positive number');this._maxListeners=n;return this;};function $getMaxListeners(that){if(that._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return that._maxListeners;}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return $getMaxListeners(this);};// These standalone emit* functions are used to optimize calling of event
	// handlers for fast cases because emit() itself often has a variable number of
	// arguments and can be deoptimized because of that. These functions always have
	// the same number of arguments and thus do not get deoptimized, so the code
	// inside them can execute faster.
	function emitNone(handler,isFn,self){if(isFn)handler.call(self);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self);}}}function emitOne(handler,isFn,self,arg1){if(isFn)handler.call(self,arg1);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self,arg1);}}}function emitTwo(handler,isFn,self,arg1,arg2){if(isFn)handler.call(self,arg1,arg2);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self,arg1,arg2);}}}function emitThree(handler,isFn,self,arg1,arg2,arg3){if(isFn)handler.call(self,arg1,arg2,arg3);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self,arg1,arg2,arg3);}}}function emitMany(handler,isFn,self,args){if(isFn)handler.apply(self,args);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].apply(self,args);}}}EventEmitter.prototype.emit=function emit(type){var er,handler,len,args,i,events;var doError=type==='error';events=this._events;if(events)doError=doError&&events.error==null;else if(!doError)return false;// If there is no 'error' event listener then throw.
	if(doError){if(arguments.length>1)er=arguments[1];if(er instanceof Error){throw er;// Unhandled 'error' event
	}else{// At least give some kind of context to the user
	var err=new Error('Unhandled "error" event. ('+er+')');err.context=er;throw err;}return false;}handler=events[type];if(!handler)return false;var isFn=typeof handler==='function';len=arguments.length;switch(len){// fast cases
	case 1:emitNone(handler,isFn,this);break;case 2:emitOne(handler,isFn,this,arguments[1]);break;case 3:emitTwo(handler,isFn,this,arguments[1],arguments[2]);break;case 4:emitThree(handler,isFn,this,arguments[1],arguments[2],arguments[3]);break;// slower
	default:args=new Array(len-1);for(i=1;i<len;i++){args[i-1]=arguments[i];}emitMany(handler,isFn,this,args);}return true;};function _addListener(target,type,listener,prepend){var m;var events;var existing;if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');events=target._events;if(!events){events=target._events=objectCreate(null);target._eventsCount=0;}else{// To avoid recursion in the case that type === "newListener"! Before
	// adding it to the listeners, first emit "newListener".
	if(events.newListener){target.emit('newListener',type,listener.listener?listener.listener:listener);// Re-assign `events` because a newListener handler could have caused the
	// this._events to be assigned to a new object
	events=target._events;}existing=events[type];}if(!existing){// Optimize the case of one listener. Don't need the extra array object.
	existing=events[type]=listener;++target._eventsCount;}else{if(typeof existing==='function'){// Adding the second element, need to change to array.
	existing=events[type]=prepend?[listener,existing]:[existing,listener];}else{// If we've already got an array, just append.
	if(prepend){existing.unshift(listener);}else{existing.push(listener);}}// Check for listener leak
	if(!existing.warned){m=$getMaxListeners(target);if(m&&m>0&&existing.length>m){existing.warned=true;var w=new Error('Possible EventEmitter memory leak detected. '+existing.length+' "'+String(type)+'" listeners '+'added. Use emitter.setMaxListeners() to '+'increase limit.');w.name='MaxListenersExceededWarning';w.emitter=target;w.type=type;w.count=existing.length;if((typeof console==="undefined"?"undefined":_typeof(console))==='object'&&console.warn){console.warn('%s: %s',w.name,w.message);}}}}return target;}EventEmitter.prototype.addListener=function addListener(type,listener){return _addListener(this,type,listener,false);};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(type,listener){return _addListener(this,type,listener,true);};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;switch(arguments.length){case 0:return this.listener.call(this.target);case 1:return this.listener.call(this.target,arguments[0]);case 2:return this.listener.call(this.target,arguments[0],arguments[1]);case 3:return this.listener.call(this.target,arguments[0],arguments[1],arguments[2]);default:var args=new Array(arguments.length);for(var i=0;i<args.length;++i){args[i]=arguments[i];}this.listener.apply(this.target,args);}}}function _onceWrap(target,type,listener){var state={fired:false,wrapFn:undefined,target:target,type:type,listener:listener};var wrapped=bind.call(onceWrapper,state);wrapped.listener=listener;state.wrapFn=wrapped;return wrapped;}EventEmitter.prototype.once=function once(type,listener){if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');this.on(type,_onceWrap(this,type,listener));return this;};EventEmitter.prototype.prependOnceListener=function prependOnceListener(type,listener){if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');this.prependListener(type,_onceWrap(this,type,listener));return this;};// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener=function removeListener(type,listener){var list,events,position,i,originalListener;if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');events=this._events;if(!events)return this;list=events[type];if(!list)return this;if(list===listener||list.listener===listener){if(--this._eventsCount===0)this._events=objectCreate(null);else{delete events[type];if(events.removeListener)this.emit('removeListener',type,list.listener||listener);}}else if(typeof list!=='function'){position=-1;for(i=list.length-1;i>=0;i--){if(list[i]===listener||list[i].listener===listener){originalListener=list[i].listener;position=i;break;}}if(position<0)return this;if(position===0)list.shift();else spliceOne(list,position);if(list.length===1)events[type]=list[0];if(events.removeListener)this.emit('removeListener',type,originalListener||listener);}return this;};EventEmitter.prototype.removeAllListeners=function removeAllListeners(type){var listeners,events,i;events=this._events;if(!events)return this;// not listening for removeListener, no need to emit
	if(!events.removeListener){if(arguments.length===0){this._events=objectCreate(null);this._eventsCount=0;}else if(events[type]){if(--this._eventsCount===0)this._events=objectCreate(null);else delete events[type];}return this;}// emit removeListener for all listeners on all events
	if(arguments.length===0){var keys=objectKeys(events);var key;for(i=0;i<keys.length;++i){key=keys[i];if(key==='removeListener')continue;this.removeAllListeners(key);}this.removeAllListeners('removeListener');this._events=objectCreate(null);this._eventsCount=0;return this;}listeners=events[type];if(typeof listeners==='function'){this.removeListener(type,listeners);}else if(listeners){// LIFO order
	for(i=listeners.length-1;i>=0;i--){this.removeListener(type,listeners[i]);}}return this;};function _listeners(target,type,unwrap){var events=target._events;if(!events)return[];var evlistener=events[type];if(!evlistener)return[];if(typeof evlistener==='function')return unwrap?[evlistener.listener||evlistener]:[evlistener];return unwrap?unwrapListeners(evlistener):arrayClone(evlistener,evlistener.length);}EventEmitter.prototype.listeners=function listeners(type){return _listeners(this,type,true);};EventEmitter.prototype.rawListeners=function rawListeners(type){return _listeners(this,type,false);};EventEmitter.listenerCount=function(emitter,type){if(typeof emitter.listenerCount==='function'){return emitter.listenerCount(type);}else{return listenerCount.call(emitter,type);}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(type){var events=this._events;if(events){var evlistener=events[type];if(typeof evlistener==='function'){return 1;}else if(evlistener){return evlistener.length;}}return 0;}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?Reflect.ownKeys(this._events):[];};// About 1.5x faster than the two-arg version of Array#splice().
	function spliceOne(list,index){for(var i=index,k=i+1,n=list.length;k<n;i+=1,k+=1){list[i]=list[k];}list.pop();}function arrayClone(arr,n){var copy=new Array(n);for(var i=0;i<n;++i){copy[i]=arr[i];}return copy;}function unwrapListeners(arr){var ret=new Array(arr.length);for(var i=0;i<ret.length;++i){ret[i]=arr[i].listener||arr[i];}return ret;}function objectCreatePolyfill(proto){var F=function F(){};F.prototype=proto;return new F();}function objectKeysPolyfill(obj){var keys=[];for(var k in obj){if(Object.prototype.hasOwnProperty.call(obj,k)){keys.push(k);}}return k;}function functionBindPolyfill(context){var fn=this;return function(){return fn.apply(context,arguments);};}},{}],26:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics2=function extendStatics(d,b){_extendStatics2=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics2(d,b);};return function(d,b){_extendStatics2(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var MultiplexHandler_1=__importDefault(require("./MultiplexHandler"));var CollectingHandler=/** @class */function(_super){__extends(CollectingHandler,_super);function CollectingHandler(cbs){if(cbs===void 0){cbs={};}var _this=_super.call(this,function(name){var _a;var args=[];for(var _i=1;_i<arguments.length;_i++){args[_i-1]=arguments[_i];}_this.events.push([name].concat(args));// @ts-ignore
	if(_this._cbs[name])(_a=_this._cbs)[name].apply(_a,args);})||this;_this._cbs=cbs;_this.events=[];return _this;}CollectingHandler.prototype.onreset=function(){this.events=[];if(this._cbs.onreset)this._cbs.onreset();};CollectingHandler.prototype.restart=function(){var _a;if(this._cbs.onreset)this._cbs.onreset();for(var i=0;i<this.events.length;i++){var _b=this.events[i],name_1=_b[0],args=_b.slice(1);if(!this._cbs[name_1]){continue;}// @ts-ignore
	(_a=this._cbs)[name_1].apply(_a,args);}};return CollectingHandler;}(MultiplexHandler_1["default"]);exports.CollectingHandler=CollectingHandler;},{"./MultiplexHandler":28}],27:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics3=function extendStatics(d,b){_extendStatics3=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics3(d,b);};return function(d,b){_extendStatics3(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};var __importStar=this&&this.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod){if(Object.hasOwnProperty.call(mod,k))result[k]=mod[k];}result["default"]=mod;return result;};Object.defineProperty(exports,"__esModule",{value:true});var domhandler_1=__importDefault(require("domhandler"));var DomUtils=__importStar(require("domutils"));var Parser_1=require("./Parser");//TODO: Consume data as it is coming in
	var FeedHandler=/** @class */function(_super){__extends(FeedHandler,_super);/**
	     *
	     * @param callback
	     * @param options
	     */function FeedHandler(callback,options){var _this=this;if(_typeof(callback)==="object"&&callback!==null){callback=undefined;options=callback;}_this=_super.call(this,callback,options)||this;return _this;}FeedHandler.prototype.onend=function(){var feed={};var feedRoot=getOneElement(isValidFeed,this.dom);if(feedRoot){if(feedRoot.name==="feed"){var childs=feedRoot.children;feed.type="atom";addConditionally(feed,"id","id",childs);addConditionally(feed,"title","title",childs);var href=getAttribute("href",getOneElement("link",childs));if(href){feed.link=href;}addConditionally(feed,"description","subtitle",childs);var updated=fetch("updated",childs);if(updated){feed.updated=new Date(updated);}addConditionally(feed,"author","email",childs,true);feed.items=getElements("entry",childs).map(function(item){var entry={};var children=item.children;addConditionally(entry,"id","id",children);addConditionally(entry,"title","title",children);var href=getAttribute("href",getOneElement("link",children));if(href){entry.link=href;}var description=fetch("summary",children)||fetch("content",children);if(description){entry.description=description;}var pubDate=fetch("updated",children);if(pubDate){entry.pubDate=new Date(pubDate);}return entry;});}else{var childs=getOneElement("channel",feedRoot.children).children;feed.type=feedRoot.name.substr(0,3);feed.id="";addConditionally(feed,"title","title",childs);addConditionally(feed,"link","link",childs);addConditionally(feed,"description","description",childs);var updated=fetch("lastBuildDate",childs);if(updated){feed.updated=new Date(updated);}addConditionally(feed,"author","managingEditor",childs,true);feed.items=getElements("item",feedRoot.children).map(function(item){var entry={};var children=item.children;addConditionally(entry,"id","guid",children);addConditionally(entry,"title","title",children);addConditionally(entry,"link","link",children);addConditionally(entry,"description","description",children);var pubDate=fetch("pubDate",children);if(pubDate)entry.pubDate=new Date(pubDate);return entry;});}}this.feed=feed;this.handleCallback(feedRoot?null:Error("couldn't find root of feed"));};return FeedHandler;}(domhandler_1["default"]);exports.FeedHandler=FeedHandler;function getElements(what,where){return DomUtils.getElementsByTagName(what,where,true);}function getOneElement(what,where){return DomUtils.getElementsByTagName(what,where,true,1)[0];}function fetch(what,where,recurse){if(recurse===void 0){recurse=false;}return DomUtils.getText(DomUtils.getElementsByTagName(what,where,recurse,1)).trim();}function getAttribute(name,elem){if(!elem){return null;}var attribs=elem.attribs;return attribs[name];}function addConditionally(obj,prop,what,where,recurse){if(recurse===void 0){recurse=false;}var tmp=fetch(what,where,recurse);// @ts-ignore
	if(tmp)obj[prop]=tmp;}function isValidFeed(value){return value==="rss"||value==="feed"||value==="rdf:RDF";}var defaultOptions={xmlMode:true};/**
	 * Parse a feed.
	 *
	 * @param feed The feed that should be parsed, as a string.
	 * @param options Optionally, options for parsing. When using this option, you probably want to set `xmlMode` to `true`.
	 */function parseFeed(feed,options){if(options===void 0){options=defaultOptions;}var handler=new FeedHandler(options);new Parser_1.Parser(handler,options).end(feed);return handler.feed;}exports.parseFeed=parseFeed;},{"./Parser":29,"domhandler":7,"domutils":10}],28:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});/**
	 * Calls a specific handler function for all events that are encountered.
	 *
	 * @param func — The function to multiplex all events to.
	 */var MultiplexHandler=/** @class */function(){function MultiplexHandler(func){this._func=func;}/* Format: eventname: number of arguments */MultiplexHandler.prototype.onattribute=function(name,value){this._func("onattribute",name,value);};MultiplexHandler.prototype.oncdatastart=function(){this._func("oncdatastart");};MultiplexHandler.prototype.oncdataend=function(){this._func("oncdataend");};MultiplexHandler.prototype.ontext=function(text){this._func("ontext",text);};MultiplexHandler.prototype.onprocessinginstruction=function(name,value){this._func("onprocessinginstruction",name,value);};MultiplexHandler.prototype.oncomment=function(comment){this._func("oncomment",comment);};MultiplexHandler.prototype.oncommentend=function(){this._func("oncommentend");};MultiplexHandler.prototype.onclosetag=function(name){this._func("onclosetag",name);};MultiplexHandler.prototype.onopentag=function(name,attribs){this._func("onopentag",name,attribs);};MultiplexHandler.prototype.onopentagname=function(name){this._func("onopentagname",name);};MultiplexHandler.prototype.onerror=function(error){this._func("onerror",error);};MultiplexHandler.prototype.onend=function(){this._func("onend");};MultiplexHandler.prototype.onparserinit=function(parser){this._func("onparserinit",parser);};MultiplexHandler.prototype.onreset=function(){this._func("onreset");};return MultiplexHandler;}();exports["default"]=MultiplexHandler;},{}],29:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics4=function extendStatics(d,b){_extendStatics4=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics4(d,b);};return function(d,b){_extendStatics4(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var Tokenizer_1=__importDefault(require("./Tokenizer"));var events_1=require("events");var formTags=new Set(["input","option","optgroup","select","button","datalist","textarea"]);var pTag=new Set(["p"]);var openImpliesClose={tr:new Set(["tr","th","td"]),th:new Set(["th"]),td:new Set(["thead","th","td"]),body:new Set(["head","link","script"]),li:new Set(["li"]),p:pTag,h1:pTag,h2:pTag,h3:pTag,h4:pTag,h5:pTag,h6:pTag,select:formTags,input:formTags,output:formTags,button:formTags,datalist:formTags,textarea:formTags,option:new Set(["option"]),optgroup:new Set(["optgroup","option"]),dd:new Set(["dt","dd"]),dt:new Set(["dt","dd"]),address:pTag,article:pTag,aside:pTag,blockquote:pTag,details:pTag,div:pTag,dl:pTag,fieldset:pTag,figcaption:pTag,figure:pTag,footer:pTag,form:pTag,header:pTag,hr:pTag,main:pTag,nav:pTag,ol:pTag,pre:pTag,section:pTag,table:pTag,ul:pTag,rt:new Set(["rt","rp"]),rp:new Set(["rt","rp"]),tbody:new Set(["thead","tbody"]),tfoot:new Set(["thead","tbody"])};var voidElements=new Set(["area","base","basefont","br","col","command","embed","frame","hr","img","input","isindex","keygen","link","meta","param","source","track","wbr"]);var foreignContextElements=new Set(["math","svg"]);var htmlIntegrationElements=new Set(["mi","mo","mn","ms","mtext","annotation-xml","foreignObject","desc","title"]);var reNameEnd=/\s|\//;var Parser=/** @class */function(_super){__extends(Parser,_super);function Parser(cbs,options){var _this=_super.call(this)||this;_this._tagname="";_this._attribname="";_this._attribvalue="";_this._attribs=null;_this._stack=[];_this._foreignContext=[];_this.startIndex=0;_this.endIndex=null;// Aliases for backwards compatibility
	_this.parseChunk=Parser.prototype.write;_this.done=Parser.prototype.end;_this._options=options||{};_this._cbs=cbs||{};_this._tagname="";_this._attribname="";_this._attribvalue="";_this._attribs=null;_this._stack=[];_this._foreignContext=[];_this.startIndex=0;_this.endIndex=null;_this._lowerCaseTagNames="lowerCaseTags"in _this._options?!!_this._options.lowerCaseTags:!_this._options.xmlMode;_this._lowerCaseAttributeNames="lowerCaseAttributeNames"in _this._options?!!_this._options.lowerCaseAttributeNames:!_this._options.xmlMode;_this._tokenizer=new(_this._options.Tokenizer||Tokenizer_1["default"])(_this._options,_this);if(_this._cbs.onparserinit)_this._cbs.onparserinit(_this);return _this;}Parser.prototype._updatePosition=function(initialOffset){if(this.endIndex===null){if(this._tokenizer._sectionStart<=initialOffset){this.startIndex=0;}else{this.startIndex=this._tokenizer._sectionStart-initialOffset;}}else this.startIndex=this.endIndex+1;this.endIndex=this._tokenizer.getAbsoluteIndex();};//Tokenizer event handlers
	Parser.prototype.ontext=function(data){this._updatePosition(1);// @ts-ignore
	this.endIndex--;if(this._cbs.ontext)this._cbs.ontext(data);};Parser.prototype.onopentagname=function(name){if(this._lowerCaseTagNames){name=name.toLowerCase();}this._tagname=name;if(!this._options.xmlMode&&Object.prototype.hasOwnProperty.call(openImpliesClose,name)){for(var el=void 0;// @ts-ignore
	openImpliesClose[name].has(el=this._stack[this._stack.length-1]);this.onclosetag(el)){;}}if(this._options.xmlMode||!voidElements.has(name)){this._stack.push(name);if(foreignContextElements.has(name)){this._foreignContext.push(true);}else if(htmlIntegrationElements.has(name)){this._foreignContext.push(false);}}if(this._cbs.onopentagname)this._cbs.onopentagname(name);if(this._cbs.onopentag)this._attribs={};};Parser.prototype.onopentagend=function(){this._updatePosition(1);if(this._attribs){if(this._cbs.onopentag){this._cbs.onopentag(this._tagname,this._attribs);}this._attribs=null;}if(!this._options.xmlMode&&this._cbs.onclosetag&&voidElements.has(this._tagname)){this._cbs.onclosetag(this._tagname);}this._tagname="";};Parser.prototype.onclosetag=function(name){this._updatePosition(1);if(this._lowerCaseTagNames){name=name.toLowerCase();}if(foreignContextElements.has(name)||htmlIntegrationElements.has(name)){this._foreignContext.pop();}if(this._stack.length&&(this._options.xmlMode||!voidElements.has(name))){var pos=this._stack.lastIndexOf(name);if(pos!==-1){if(this._cbs.onclosetag){pos=this._stack.length-pos;// @ts-ignore
	while(pos--){this._cbs.onclosetag(this._stack.pop());}}else this._stack.length=pos;}else if(name==="p"&&!this._options.xmlMode){this.onopentagname(name);this._closeCurrentTag();}}else if(!this._options.xmlMode&&(name==="br"||name==="p")){this.onopentagname(name);this._closeCurrentTag();}};Parser.prototype.onselfclosingtag=function(){if(this._options.xmlMode||this._options.recognizeSelfClosing||this._foreignContext[this._foreignContext.length-1]){this._closeCurrentTag();}else{this.onopentagend();}};Parser.prototype._closeCurrentTag=function(){var name=this._tagname;this.onopentagend();//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length-1]===name){if(this._cbs.onclosetag){this._cbs.onclosetag(name);}this._stack.pop();}};Parser.prototype.onattribname=function(name){if(this._lowerCaseAttributeNames){name=name.toLowerCase();}this._attribname=name;};Parser.prototype.onattribdata=function(value){this._attribvalue+=value;};Parser.prototype.onattribend=function(){if(this._cbs.onattribute)this._cbs.onattribute(this._attribname,this._attribvalue);if(this._attribs&&!Object.prototype.hasOwnProperty.call(this._attribs,this._attribname)){this._attribs[this._attribname]=this._attribvalue;}this._attribname="";this._attribvalue="";};Parser.prototype._getInstructionName=function(value){var idx=value.search(reNameEnd);var name=idx<0?value:value.substr(0,idx);if(this._lowerCaseTagNames){name=name.toLowerCase();}return name;};Parser.prototype.ondeclaration=function(value){if(this._cbs.onprocessinginstruction){var name_1=this._getInstructionName(value);this._cbs.onprocessinginstruction("!"+name_1,"!"+value);}};Parser.prototype.onprocessinginstruction=function(value){if(this._cbs.onprocessinginstruction){var name_2=this._getInstructionName(value);this._cbs.onprocessinginstruction("?"+name_2,"?"+value);}};Parser.prototype.oncomment=function(value){this._updatePosition(4);if(this._cbs.oncomment)this._cbs.oncomment(value);if(this._cbs.oncommentend)this._cbs.oncommentend();};Parser.prototype.oncdata=function(value){this._updatePosition(1);if(this._options.xmlMode||this._options.recognizeCDATA){if(this._cbs.oncdatastart)this._cbs.oncdatastart();if(this._cbs.ontext)this._cbs.ontext(value);if(this._cbs.oncdataend)this._cbs.oncdataend();}else{this.oncomment("[CDATA["+value+"]]");}};Parser.prototype.onerror=function(err){if(this._cbs.onerror)this._cbs.onerror(err);};Parser.prototype.onend=function(){if(this._cbs.onclosetag){for(var i=this._stack.length;i>0;this._cbs.onclosetag(this._stack[--i])){;}}if(this._cbs.onend)this._cbs.onend();};//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset=function(){if(this._cbs.onreset)this._cbs.onreset();this._tokenizer.reset();this._tagname="";this._attribname="";this._attribs=null;this._stack=[];if(this._cbs.onparserinit)this._cbs.onparserinit(this);};//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete=function(data){this.reset();this.end(data);};Parser.prototype.write=function(chunk){this._tokenizer.write(chunk);};Parser.prototype.end=function(chunk){this._tokenizer.end(chunk);};Parser.prototype.pause=function(){this._tokenizer.pause();};Parser.prototype.resume=function(){this._tokenizer.resume();};return Parser;}(events_1.EventEmitter);exports.Parser=Parser;},{"./Tokenizer":30,"events":25}],30:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var decode_codepoint_1=__importDefault(require("entities/lib/decode_codepoint"));var entities_json_1=__importDefault(require("entities/lib/maps/entities.json"));var legacy_json_1=__importDefault(require("entities/lib/maps/legacy.json"));var xml_json_1=__importDefault(require("entities/lib/maps/xml.json"));function whitespace(c){return c===" "||c==="\n"||c==="\t"||c==="\f"||c==="\r";}function ifElseState(upper,SUCCESS,FAILURE){var lower=upper.toLowerCase();if(upper===lower){return function(t,c){if(c===lower){t._state=SUCCESS;}else{t._state=FAILURE;t._index--;}};}else{return function(t,c){if(c===lower||c===upper){t._state=SUCCESS;}else{t._state=FAILURE;t._index--;}};}}function consumeSpecialNameChar(upper,NEXT_STATE){var lower=upper.toLowerCase();return function(t,c){if(c===lower||c===upper){t._state=NEXT_STATE;}else{t._state=3/* InTagName */;t._index--;//consume the token again
	}};}var stateBeforeCdata1=ifElseState("C",23/* BeforeCdata2 */,16/* InDeclaration */);var stateBeforeCdata2=ifElseState("D",24/* BeforeCdata3 */,16/* InDeclaration */);var stateBeforeCdata3=ifElseState("A",25/* BeforeCdata4 */,16/* InDeclaration */);var stateBeforeCdata4=ifElseState("T",26/* BeforeCdata5 */,16/* InDeclaration */);var stateBeforeCdata5=ifElseState("A",27/* BeforeCdata6 */,16/* InDeclaration */);var stateBeforeScript1=consumeSpecialNameChar("R",34/* BeforeScript2 */);var stateBeforeScript2=consumeSpecialNameChar("I",35/* BeforeScript3 */);var stateBeforeScript3=consumeSpecialNameChar("P",36/* BeforeScript4 */);var stateBeforeScript4=consumeSpecialNameChar("T",37/* BeforeScript5 */);var stateAfterScript1=ifElseState("R",39/* AfterScript2 */,1/* Text */);var stateAfterScript2=ifElseState("I",40/* AfterScript3 */,1/* Text */);var stateAfterScript3=ifElseState("P",41/* AfterScript4 */,1/* Text */);var stateAfterScript4=ifElseState("T",42/* AfterScript5 */,1/* Text */);var stateBeforeStyle1=consumeSpecialNameChar("Y",44/* BeforeStyle2 */);var stateBeforeStyle2=consumeSpecialNameChar("L",45/* BeforeStyle3 */);var stateBeforeStyle3=consumeSpecialNameChar("E",46/* BeforeStyle4 */);var stateAfterStyle1=ifElseState("Y",48/* AfterStyle2 */,1/* Text */);var stateAfterStyle2=ifElseState("L",49/* AfterStyle3 */,1/* Text */);var stateAfterStyle3=ifElseState("E",50/* AfterStyle4 */,1/* Text */);var stateBeforeEntity=ifElseState("#",52/* BeforeNumericEntity */,53/* InNamedEntity */);var stateBeforeNumericEntity=ifElseState("X",55/* InHexEntity */,54/* InNumericEntity */);var Tokenizer=/** @class */function(){function Tokenizer(options,cbs){/** The current state the tokenizer is in. */this._state=1/* Text */;/** The read buffer. */this._buffer="";/** The beginning of the section that is currently being read. */this._sectionStart=0;/** The index within the buffer that we are currently looking at. */this._index=0;/**
	         * Data that has already been processed will be removed from the buffer occasionally.
	         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
	         */this._bufferOffset=0;/** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */this._baseState=1/* Text */;/** For special parsing behavior inside of script and style tags. */this._special=1/* None */;/** Indicates whether the tokenizer has been paused. */this._running=true;/** Indicates whether the tokenizer has finished running / `.end` has been called. */this._ended=false;this._cbs=cbs;this._xmlMode=!!(options&&options.xmlMode);this._decodeEntities=!!(options&&options.decodeEntities);}Tokenizer.prototype.reset=function(){this._state=1/* Text */;this._buffer="";this._sectionStart=0;this._index=0;this._bufferOffset=0;this._baseState=1/* Text */;this._special=1/* None */;this._running=true;this._ended=false;};Tokenizer.prototype._stateText=function(c){if(c==="<"){if(this._index>this._sectionStart){this._cbs.ontext(this._getSection());}this._state=2/* BeforeTagName */;this._sectionStart=this._index;}else if(this._decodeEntities&&this._special===1/* None */&&c==="&"){if(this._index>this._sectionStart){this._cbs.ontext(this._getSection());}this._baseState=1/* Text */;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateBeforeTagName=function(c){if(c==="/"){this._state=5/* BeforeClosingTagName */;}else if(c==="<"){this._cbs.ontext(this._getSection());this._sectionStart=this._index;}else if(c===">"||this._special!==1/* None */||whitespace(c)){this._state=1/* Text */;}else if(c==="!"){this._state=15/* BeforeDeclaration */;this._sectionStart=this._index+1;}else if(c==="?"){this._state=17/* InProcessingInstruction */;this._sectionStart=this._index+1;}else{this._state=!this._xmlMode&&(c==="s"||c==="S")?31/* BeforeSpecial */:3/* InTagName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInTagName=function(c){if(c==="/"||c===">"||whitespace(c)){this._emitToken("onopentagname");this._state=8/* BeforeAttributeName */;this._index--;}};Tokenizer.prototype._stateBeforeClosingTagName=function(c){if(whitespace(c)){// ignore
	}else if(c===">"){this._state=1/* Text */;}else if(this._special!==1/* None */){if(c==="s"||c==="S"){this._state=32/* BeforeSpecialEnd */;}else{this._state=1/* Text */;this._index--;}}else{this._state=6/* InClosingTagName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInClosingTagName=function(c){if(c===">"||whitespace(c)){this._emitToken("onclosetag");this._state=7/* AfterClosingTagName */;this._index--;}};Tokenizer.prototype._stateAfterClosingTagName=function(c){//skip everything until ">"
	if(c===">"){this._state=1/* Text */;this._sectionStart=this._index+1;}};Tokenizer.prototype._stateBeforeAttributeName=function(c){if(c===">"){this._cbs.onopentagend();this._state=1/* Text */;this._sectionStart=this._index+1;}else if(c==="/"){this._state=4/* InSelfClosingTag */;}else if(!whitespace(c)){this._state=9/* InAttributeName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInSelfClosingTag=function(c){if(c===">"){this._cbs.onselfclosingtag();this._state=1/* Text */;this._sectionStart=this._index+1;}else if(!whitespace(c)){this._state=8/* BeforeAttributeName */;this._index--;}};Tokenizer.prototype._stateInAttributeName=function(c){if(c==="="||c==="/"||c===">"||whitespace(c)){this._cbs.onattribname(this._getSection());this._sectionStart=-1;this._state=10/* AfterAttributeName */;this._index--;}};Tokenizer.prototype._stateAfterAttributeName=function(c){if(c==="="){this._state=11/* BeforeAttributeValue */;}else if(c==="/"||c===">"){this._cbs.onattribend();this._state=8/* BeforeAttributeName */;this._index--;}else if(!whitespace(c)){this._cbs.onattribend();this._state=9/* InAttributeName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateBeforeAttributeValue=function(c){if(c==='"'){this._state=12/* InAttributeValueDq */;this._sectionStart=this._index+1;}else if(c==="'"){this._state=13/* InAttributeValueSq */;this._sectionStart=this._index+1;}else if(!whitespace(c)){this._state=14/* InAttributeValueNq */;this._sectionStart=this._index;this._index--;//reconsume token
	}};Tokenizer.prototype._stateInAttributeValueDoubleQuotes=function(c){if(c==='"'){this._emitToken("onattribdata");this._cbs.onattribend();this._state=8/* BeforeAttributeName */;}else if(this._decodeEntities&&c==="&"){this._emitToken("onattribdata");this._baseState=this._state;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInAttributeValueSingleQuotes=function(c){if(c==="'"){this._emitToken("onattribdata");this._cbs.onattribend();this._state=8/* BeforeAttributeName */;}else if(this._decodeEntities&&c==="&"){this._emitToken("onattribdata");this._baseState=this._state;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInAttributeValueNoQuotes=function(c){if(whitespace(c)||c===">"){this._emitToken("onattribdata");this._cbs.onattribend();this._state=8/* BeforeAttributeName */;this._index--;}else if(this._decodeEntities&&c==="&"){this._emitToken("onattribdata");this._baseState=this._state;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateBeforeDeclaration=function(c){this._state=c==="["?22/* BeforeCdata1 */:c==="-"?18/* BeforeComment */:16/* InDeclaration */;};Tokenizer.prototype._stateInDeclaration=function(c){if(c===">"){this._cbs.ondeclaration(this._getSection());this._state=1/* Text */;this._sectionStart=this._index+1;}};Tokenizer.prototype._stateInProcessingInstruction=function(c){if(c===">"){this._cbs.onprocessinginstruction(this._getSection());this._state=1/* Text */;this._sectionStart=this._index+1;}};Tokenizer.prototype._stateBeforeComment=function(c){if(c==="-"){this._state=19/* InComment */;this._sectionStart=this._index+1;}else{this._state=16/* InDeclaration */;}};Tokenizer.prototype._stateInComment=function(c){if(c==="-")this._state=20/* AfterComment1 */;};Tokenizer.prototype._stateAfterComment1=function(c){if(c==="-"){this._state=21/* AfterComment2 */;}else{this._state=19/* InComment */;}};Tokenizer.prototype._stateAfterComment2=function(c){if(c===">"){//remove 2 trailing chars
	this._cbs.oncomment(this._buffer.substring(this._sectionStart,this._index-2));this._state=1/* Text */;this._sectionStart=this._index+1;}else if(c!=="-"){this._state=19/* InComment */;}// else: stay in AFTER_COMMENT_2 (`--->`)
	};Tokenizer.prototype._stateBeforeCdata6=function(c){if(c==="["){this._state=28/* InCdata */;this._sectionStart=this._index+1;}else{this._state=16/* InDeclaration */;this._index--;}};Tokenizer.prototype._stateInCdata=function(c){if(c==="]")this._state=29/* AfterCdata1 */;};Tokenizer.prototype._stateAfterCdata1=function(c){if(c==="]")this._state=30/* AfterCdata2 */;else this._state=28/* InCdata */;};Tokenizer.prototype._stateAfterCdata2=function(c){if(c===">"){//remove 2 trailing chars
	this._cbs.oncdata(this._buffer.substring(this._sectionStart,this._index-2));this._state=1/* Text */;this._sectionStart=this._index+1;}else if(c!=="]"){this._state=28/* InCdata */;}//else: stay in AFTER_CDATA_2 (`]]]>`)
	};Tokenizer.prototype._stateBeforeSpecial=function(c){if(c==="c"||c==="C"){this._state=33/* BeforeScript1 */;}else if(c==="t"||c==="T"){this._state=43/* BeforeStyle1 */;}else{this._state=3/* InTagName */;this._index--;//consume the token again
	}};Tokenizer.prototype._stateBeforeSpecialEnd=function(c){if(this._special===2/* Script */&&(c==="c"||c==="C")){this._state=38/* AfterScript1 */;}else if(this._special===3/* Style */&&(c==="t"||c==="T")){this._state=47/* AfterStyle1 */;}else this._state=1/* Text */;};Tokenizer.prototype._stateBeforeScript5=function(c){if(c==="/"||c===">"||whitespace(c)){this._special=2/* Script */;}this._state=3/* InTagName */;this._index--;//consume the token again
	};Tokenizer.prototype._stateAfterScript5=function(c){if(c===">"||whitespace(c)){this._special=1/* None */;this._state=6/* InClosingTagName */;this._sectionStart=this._index-6;this._index--;//reconsume the token
	}else this._state=1/* Text */;};Tokenizer.prototype._stateBeforeStyle4=function(c){if(c==="/"||c===">"||whitespace(c)){this._special=3/* Style */;}this._state=3/* InTagName */;this._index--;//consume the token again
	};Tokenizer.prototype._stateAfterStyle4=function(c){if(c===">"||whitespace(c)){this._special=1/* None */;this._state=6/* InClosingTagName */;this._sectionStart=this._index-5;this._index--;//reconsume the token
	}else this._state=1/* Text */;};//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict=function(){//offset = 1
	if(this._sectionStart+1<this._index){var entity=this._buffer.substring(this._sectionStart+1,this._index),map=this._xmlMode?xml_json_1["default"]:entities_json_1["default"];if(Object.prototype.hasOwnProperty.call(map,entity)){// @ts-ignore
	this._emitPartial(map[entity]);this._sectionStart=this._index+1;}}};//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity=function(){var start=this._sectionStart+1;var limit=this._index-start;if(limit>6)limit=6;// The max length of legacy entities is 6
	while(limit>=2){// The min length of legacy entities is 2
	var entity=this._buffer.substr(start,limit);if(Object.prototype.hasOwnProperty.call(legacy_json_1["default"],entity)){// @ts-ignore
	this._emitPartial(legacy_json_1["default"][entity]);this._sectionStart+=limit+1;return;}else{limit--;}}};Tokenizer.prototype._stateInNamedEntity=function(c){if(c===";"){this._parseNamedEntityStrict();if(this._sectionStart+1<this._index&&!this._xmlMode){this._parseLegacyEntity();}this._state=this._baseState;}else if((c<"a"||c>"z")&&(c<"A"||c>"Z")&&(c<"0"||c>"9")){if(this._xmlMode||this._sectionStart+1===this._index){// ignore
	}else if(this._baseState!==1/* Text */){if(c!=="="){this._parseNamedEntityStrict();}}else{this._parseLegacyEntity();}this._state=this._baseState;this._index--;}};Tokenizer.prototype._decodeNumericEntity=function(offset,base){var sectionStart=this._sectionStart+offset;if(sectionStart!==this._index){//parse entity
	var entity=this._buffer.substring(sectionStart,this._index);var parsed=parseInt(entity,base);this._emitPartial(decode_codepoint_1["default"](parsed));this._sectionStart=this._index;}else{this._sectionStart--;}this._state=this._baseState;};Tokenizer.prototype._stateInNumericEntity=function(c){if(c===";"){this._decodeNumericEntity(2,10);this._sectionStart++;}else if(c<"0"||c>"9"){if(!this._xmlMode){this._decodeNumericEntity(2,10);}else{this._state=this._baseState;}this._index--;}};Tokenizer.prototype._stateInHexEntity=function(c){if(c===";"){this._decodeNumericEntity(3,16);this._sectionStart++;}else if((c<"a"||c>"f")&&(c<"A"||c>"F")&&(c<"0"||c>"9")){if(!this._xmlMode){this._decodeNumericEntity(3,16);}else{this._state=this._baseState;}this._index--;}};Tokenizer.prototype._cleanup=function(){if(this._sectionStart<0){this._buffer="";this._bufferOffset+=this._index;this._index=0;}else if(this._running){if(this._state===1/* Text */){if(this._sectionStart!==this._index){this._cbs.ontext(this._buffer.substr(this._sectionStart));}this._buffer="";this._bufferOffset+=this._index;this._index=0;}else if(this._sectionStart===this._index){//the section just started
	this._buffer="";this._bufferOffset+=this._index;this._index=0;}else{//remove everything unnecessary
	this._buffer=this._buffer.substr(this._sectionStart);this._index-=this._sectionStart;this._bufferOffset+=this._sectionStart;}this._sectionStart=0;}};//TODO make events conditional
	Tokenizer.prototype.write=function(chunk){if(this._ended)this._cbs.onerror(Error(".write() after done!"));this._buffer+=chunk;this._parse();};// Iterates through the buffer, calling the function corresponding to the current state.
	// States that are more likely to be hit are higher up, as a performance improvement.
	Tokenizer.prototype._parse=function(){while(this._index<this._buffer.length&&this._running){var c=this._buffer.charAt(this._index);if(this._state===1/* Text */){this._stateText(c);}else if(this._state===12/* InAttributeValueDq */){this._stateInAttributeValueDoubleQuotes(c);}else if(this._state===9/* InAttributeName */){this._stateInAttributeName(c);}else if(this._state===19/* InComment */){this._stateInComment(c);}else if(this._state===8/* BeforeAttributeName */){this._stateBeforeAttributeName(c);}else if(this._state===3/* InTagName */){this._stateInTagName(c);}else if(this._state===6/* InClosingTagName */){this._stateInClosingTagName(c);}else if(this._state===2/* BeforeTagName */){this._stateBeforeTagName(c);}else if(this._state===10/* AfterAttributeName */){this._stateAfterAttributeName(c);}else if(this._state===13/* InAttributeValueSq */){this._stateInAttributeValueSingleQuotes(c);}else if(this._state===11/* BeforeAttributeValue */){this._stateBeforeAttributeValue(c);}else if(this._state===5/* BeforeClosingTagName */){this._stateBeforeClosingTagName(c);}else if(this._state===7/* AfterClosingTagName */){this._stateAfterClosingTagName(c);}else if(this._state===31/* BeforeSpecial */){this._stateBeforeSpecial(c);}else if(this._state===20/* AfterComment1 */){this._stateAfterComment1(c);}else if(this._state===14/* InAttributeValueNq */){this._stateInAttributeValueNoQuotes(c);}else if(this._state===4/* InSelfClosingTag */){this._stateInSelfClosingTag(c);}else if(this._state===16/* InDeclaration */){this._stateInDeclaration(c);}else if(this._state===15/* BeforeDeclaration */){this._stateBeforeDeclaration(c);}else if(this._state===21/* AfterComment2 */){this._stateAfterComment2(c);}else if(this._state===18/* BeforeComment */){this._stateBeforeComment(c);}else if(this._state===32/* BeforeSpecialEnd */){this._stateBeforeSpecialEnd(c);}else if(this._state===38/* AfterScript1 */){stateAfterScript1(this,c);}else if(this._state===39/* AfterScript2 */){stateAfterScript2(this,c);}else if(this._state===40/* AfterScript3 */){stateAfterScript3(this,c);}else if(this._state===33/* BeforeScript1 */){stateBeforeScript1(this,c);}else if(this._state===34/* BeforeScript2 */){stateBeforeScript2(this,c);}else if(this._state===35/* BeforeScript3 */){stateBeforeScript3(this,c);}else if(this._state===36/* BeforeScript4 */){stateBeforeScript4(this,c);}else if(this._state===37/* BeforeScript5 */){this._stateBeforeScript5(c);}else if(this._state===41/* AfterScript4 */){stateAfterScript4(this,c);}else if(this._state===42/* AfterScript5 */){this._stateAfterScript5(c);}else if(this._state===43/* BeforeStyle1 */){stateBeforeStyle1(this,c);}else if(this._state===28/* InCdata */){this._stateInCdata(c);}else if(this._state===44/* BeforeStyle2 */){stateBeforeStyle2(this,c);}else if(this._state===45/* BeforeStyle3 */){stateBeforeStyle3(this,c);}else if(this._state===46/* BeforeStyle4 */){this._stateBeforeStyle4(c);}else if(this._state===47/* AfterStyle1 */){stateAfterStyle1(this,c);}else if(this._state===48/* AfterStyle2 */){stateAfterStyle2(this,c);}else if(this._state===49/* AfterStyle3 */){stateAfterStyle3(this,c);}else if(this._state===50/* AfterStyle4 */){this._stateAfterStyle4(c);}else if(this._state===17/* InProcessingInstruction */){this._stateInProcessingInstruction(c);}else if(this._state===53/* InNamedEntity */){this._stateInNamedEntity(c);}else if(this._state===22/* BeforeCdata1 */){stateBeforeCdata1(this,c);}else if(this._state===51/* BeforeEntity */){stateBeforeEntity(this,c);}else if(this._state===23/* BeforeCdata2 */){stateBeforeCdata2(this,c);}else if(this._state===24/* BeforeCdata3 */){stateBeforeCdata3(this,c);}else if(this._state===29/* AfterCdata1 */){this._stateAfterCdata1(c);}else if(this._state===30/* AfterCdata2 */){this._stateAfterCdata2(c);}else if(this._state===25/* BeforeCdata4 */){stateBeforeCdata4(this,c);}else if(this._state===26/* BeforeCdata5 */){stateBeforeCdata5(this,c);}else if(this._state===27/* BeforeCdata6 */){this._stateBeforeCdata6(c);}else if(this._state===55/* InHexEntity */){this._stateInHexEntity(c);}else if(this._state===54/* InNumericEntity */){this._stateInNumericEntity(c);}else if(this._state===52/* BeforeNumericEntity */){stateBeforeNumericEntity(this,c);}else{this._cbs.onerror(Error("unknown _state"),this._state);}this._index++;}this._cleanup();};Tokenizer.prototype.pause=function(){this._running=false;};Tokenizer.prototype.resume=function(){this._running=true;if(this._index<this._buffer.length){this._parse();}if(this._ended){this._finish();}};Tokenizer.prototype.end=function(chunk){if(this._ended)this._cbs.onerror(Error(".end() after done!"));if(chunk)this.write(chunk);this._ended=true;if(this._running)this._finish();};Tokenizer.prototype._finish=function(){//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart<this._index){this._handleTrailingData();}this._cbs.onend();};Tokenizer.prototype._handleTrailingData=function(){var data=this._buffer.substr(this._sectionStart);if(this._state===28/* InCdata */||this._state===29/* AfterCdata1 */||this._state===30/* AfterCdata2 */){this._cbs.oncdata(data);}else if(this._state===19/* InComment */||this._state===20/* AfterComment1 */||this._state===21/* AfterComment2 */){this._cbs.oncomment(data);}else if(this._state===53/* InNamedEntity */&&!this._xmlMode){this._parseLegacyEntity();if(this._sectionStart<this._index){this._state=this._baseState;this._handleTrailingData();}}else if(this._state===54/* InNumericEntity */&&!this._xmlMode){this._decodeNumericEntity(2,10);if(this._sectionStart<this._index){this._state=this._baseState;this._handleTrailingData();}}else if(this._state===55/* InHexEntity */&&!this._xmlMode){this._decodeNumericEntity(3,16);if(this._sectionStart<this._index){this._state=this._baseState;this._handleTrailingData();}}else if(this._state!==3/* InTagName */&&this._state!==8/* BeforeAttributeName */&&this._state!==11/* BeforeAttributeValue */&&this._state!==10/* AfterAttributeName */&&this._state!==9/* InAttributeName */&&this._state!==13/* InAttributeValueSq */&&this._state!==12/* InAttributeValueDq */&&this._state!==14/* InAttributeValueNq */&&this._state!==6/* InClosingTagName */){this._cbs.ontext(data);}//else, ignore remaining data
	//TODO add a way to remove current tag
	};Tokenizer.prototype.getAbsoluteIndex=function(){return this._bufferOffset+this._index;};Tokenizer.prototype._getSection=function(){return this._buffer.substring(this._sectionStart,this._index);};Tokenizer.prototype._emitToken=function(name){this._cbs[name](this._getSection());this._sectionStart=-1;};Tokenizer.prototype._emitPartial=function(value){if(this._baseState!==1/* Text */){this._cbs.onattribdata(value);//TODO implement the new event
	}else{this._cbs.ontext(value);}};return Tokenizer;}();exports["default"]=Tokenizer;},{"entities/lib/decode_codepoint":18,"entities/lib/maps/entities.json":22,"entities/lib/maps/legacy.json":23,"entities/lib/maps/xml.json":24}],31:[function(require,module,exports){"use strict";function __export(m){for(var p in m){if(!exports.hasOwnProperty(p))exports[p]=m[p];}}var __importStar=this&&this.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod){if(Object.hasOwnProperty.call(mod,k))result[k]=mod[k];}result["default"]=mod;return result;};Object.defineProperty(exports,"__esModule",{value:true});var Parser_1=require("./Parser");exports.Parser=Parser_1.Parser;var domhandler_1=require("domhandler");exports.DomHandler=domhandler_1.DomHandler;exports.DefaultHandler=domhandler_1.DomHandler;// Helper methods
	/**
	 * Parses data, returns the resulting DOM.
	 *
	 * @param data The data that should be parsed.
	 * @param options Optional options for the parser and DOM builder.
	 */function parseDOM(data,options){var handler=new domhandler_1.DomHandler(void 0,options);new Parser_1.Parser(handler,options).end(data);return handler.dom;}exports.parseDOM=parseDOM;/**
	 * Creates a parser instance, with an attached DOM handler.
	 *
	 * @param cb A callback that will be called once parsing has been completed.
	 * @param options Optional options for the parser and DOM builder.
	 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
	 */function createDomStream(cb,options,elementCb){var handler=new domhandler_1.DomHandler(cb,options,elementCb);return new Parser_1.Parser(handler,options);}exports.createDomStream=createDomStream;var Tokenizer_1=require("./Tokenizer");exports.Tokenizer=Tokenizer_1["default"];var ElementType=__importStar(require("domelementtype"));exports.ElementType=ElementType;/**
	 * List of all events that the parser emits.
	 *
	 * Format: eventname: number of arguments.
	 */exports.EVENTS={attribute:2,cdatastart:0,cdataend:0,text:1,processinginstruction:2,comment:1,commentend:0,closetag:1,opentag:2,opentagname:1,error:1,end:0};/*
	    All of the following exports exist for backwards-compatibility.
	    They should probably be removed eventually.
	*/__export(require("./FeedHandler"));__export(require("./WritableStream"));__export(require("./CollectingHandler"));var DomUtils=__importStar(require("domutils"));exports.DomUtils=DomUtils;var FeedHandler_1=require("./FeedHandler");exports.RssHandler=FeedHandler_1.FeedHandler;},{"./CollectingHandler":26,"./FeedHandler":27,"./Parser":29,"./Tokenizer":30,"./WritableStream":2,"domelementtype":6,"domhandler":7,"domutils":10}],32:[function(require,module,exports){exports.read=function(buffer,offset,isLE,mLen,nBytes){var e,m;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var nBits=-7;var i=isLE?nBytes-1:0;var d=isLE?-1:1;var s=buffer[offset+i];i+=d;e=s&(1<<-nBits)-1;s>>=-nBits;nBits+=eLen;for(;nBits>0;e=e*256+buffer[offset+i],i+=d,nBits-=8){}m=e&(1<<-nBits)-1;e>>=-nBits;nBits+=mLen;for(;nBits>0;m=m*256+buffer[offset+i],i+=d,nBits-=8){}if(e===0){e=1-eBias;}else if(e===eMax){return m?NaN:(s?-1:1)*Infinity;}else{m=m+Math.pow(2,mLen);e=e-eBias;}return(s?-1:1)*m*Math.pow(2,e-mLen);};exports.write=function(buffer,value,offset,isLE,mLen,nBytes){var e,m,c;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var rt=mLen===23?Math.pow(2,-24)-Math.pow(2,-77):0;var i=isLE?0:nBytes-1;var d=isLE?1:-1;var s=value<0||value===0&&1/value<0?1:0;value=Math.abs(value);if(isNaN(value)||value===Infinity){m=isNaN(value)?1:0;e=eMax;}else{e=Math.floor(Math.log(value)/Math.LN2);if(value*(c=Math.pow(2,-e))<1){e--;c*=2;}if(e+eBias>=1){value+=rt/c;}else{value+=rt*Math.pow(2,1-eBias);}if(value*c>=2){e++;c/=2;}if(e+eBias>=eMax){m=0;e=eMax;}else if(e+eBias>=1){m=(value*c-1)*Math.pow(2,mLen);e=e+eBias;}else{m=value*Math.pow(2,eBias-1)*Math.pow(2,mLen);e=0;}}for(;mLen>=8;buffer[offset+i]=m&0xff,i+=d,m/=256,mLen-=8){}e=e<<mLen|m;eLen+=mLen;for(;eLen>0;buffer[offset+i]=e&0xff,i+=d,e/=256,eLen-=8){}buffer[offset+i-d]|=s*128;};},{}],33:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var DataView=getNative(root,'DataView');module.exports=DataView;},{"./_getNative":93,"./_root":130}],34:[function(require,module,exports){var hashClear=require('./_hashClear'),hashDelete=require('./_hashDelete'),hashGet=require('./_hashGet'),hashHas=require('./_hashHas'),hashSet=require('./_hashSet');/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;module.exports=Hash;},{"./_hashClear":100,"./_hashDelete":101,"./_hashGet":102,"./_hashHas":103,"./_hashSet":104}],35:[function(require,module,exports){var listCacheClear=require('./_listCacheClear'),listCacheDelete=require('./_listCacheDelete'),listCacheGet=require('./_listCacheGet'),listCacheHas=require('./_listCacheHas'),listCacheSet=require('./_listCacheSet');/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;module.exports=ListCache;},{"./_listCacheClear":113,"./_listCacheDelete":114,"./_listCacheGet":115,"./_listCacheHas":116,"./_listCacheSet":117}],36:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var Map=getNative(root,'Map');module.exports=Map;},{"./_getNative":93,"./_root":130}],37:[function(require,module,exports){var mapCacheClear=require('./_mapCacheClear'),mapCacheDelete=require('./_mapCacheDelete'),mapCacheGet=require('./_mapCacheGet'),mapCacheHas=require('./_mapCacheHas'),mapCacheSet=require('./_mapCacheSet');/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;module.exports=MapCache;},{"./_mapCacheClear":118,"./_mapCacheDelete":119,"./_mapCacheGet":120,"./_mapCacheHas":121,"./_mapCacheSet":122}],38:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var Promise=getNative(root,'Promise');module.exports=Promise;},{"./_getNative":93,"./_root":130}],39:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var Set=getNative(root,'Set');module.exports=Set;},{"./_getNative":93,"./_root":130}],40:[function(require,module,exports){var ListCache=require('./_ListCache'),stackClear=require('./_stackClear'),stackDelete=require('./_stackDelete'),stackGet=require('./_stackGet'),stackHas=require('./_stackHas'),stackSet=require('./_stackSet');/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;module.exports=Stack;},{"./_ListCache":35,"./_stackClear":134,"./_stackDelete":135,"./_stackGet":136,"./_stackHas":137,"./_stackSet":138}],41:[function(require,module,exports){var root=require('./_root');/** Built-in value references. */var _Symbol=root.Symbol;module.exports=_Symbol;},{"./_root":130}],42:[function(require,module,exports){var root=require('./_root');/** Built-in value references. */var Uint8Array=root.Uint8Array;module.exports=Uint8Array;},{"./_root":130}],43:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var WeakMap=getNative(root,'WeakMap');module.exports=WeakMap;},{"./_getNative":93,"./_root":130}],44:[function(require,module,exports){/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}module.exports=apply;},{}],45:[function(require,module,exports){/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}module.exports=arrayEach;},{}],46:[function(require,module,exports){/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}module.exports=arrayFilter;},{}],47:[function(require,module,exports){var baseTimes=require('./_baseTimes'),isArguments=require('./isArguments'),isArray=require('./isArray'),isBuffer=require('./isBuffer'),isIndex=require('./_isIndex'),isTypedArray=require('./isTypedArray');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}module.exports=arrayLikeKeys;},{"./_baseTimes":72,"./_isIndex":108,"./isArguments":145,"./isArray":146,"./isBuffer":149,"./isTypedArray":159}],48:[function(require,module,exports){/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}module.exports=arrayMap;},{}],49:[function(require,module,exports){/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}module.exports=arrayPush;},{}],50:[function(require,module,exports){var baseAssignValue=require('./_baseAssignValue'),eq=require('./eq');/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}module.exports=assignMergeValue;},{"./_baseAssignValue":55,"./eq":142}],51:[function(require,module,exports){var baseAssignValue=require('./_baseAssignValue'),eq=require('./eq');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}module.exports=assignValue;},{"./_baseAssignValue":55,"./eq":142}],52:[function(require,module,exports){var eq=require('./eq');/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}module.exports=assocIndexOf;},{"./eq":142}],53:[function(require,module,exports){var copyObject=require('./_copyObject'),keys=require('./keys');/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}module.exports=baseAssign;},{"./_copyObject":82,"./keys":160}],54:[function(require,module,exports){var copyObject=require('./_copyObject'),keysIn=require('./keysIn');/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}module.exports=baseAssignIn;},{"./_copyObject":82,"./keysIn":161}],55:[function(require,module,exports){var defineProperty=require('./_defineProperty');/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}module.exports=baseAssignValue;},{"./_defineProperty":88}],56:[function(require,module,exports){var Stack=require('./_Stack'),arrayEach=require('./_arrayEach'),assignValue=require('./_assignValue'),baseAssign=require('./_baseAssign'),baseAssignIn=require('./_baseAssignIn'),cloneBuffer=require('./_cloneBuffer'),copyArray=require('./_copyArray'),copySymbols=require('./_copySymbols'),copySymbolsIn=require('./_copySymbolsIn'),getAllKeys=require('./_getAllKeys'),getAllKeysIn=require('./_getAllKeysIn'),getTag=require('./_getTag'),initCloneArray=require('./_initCloneArray'),initCloneByTag=require('./_initCloneByTag'),initCloneObject=require('./_initCloneObject'),isArray=require('./isArray'),isBuffer=require('./isBuffer'),isMap=require('./isMap'),isObject=require('./isObject'),isSet=require('./isSet'),keys=require('./keys'),keysIn=require('./keysIn');/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',boolTag='[object Boolean]',dateTag='[object Date]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',objectTag='[object Object]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',weakMapTag='[object WeakMap]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}module.exports=baseClone;},{"./_Stack":40,"./_arrayEach":45,"./_assignValue":51,"./_baseAssign":53,"./_baseAssignIn":54,"./_cloneBuffer":76,"./_copyArray":81,"./_copySymbols":83,"./_copySymbolsIn":84,"./_getAllKeys":90,"./_getAllKeysIn":91,"./_getTag":98,"./_initCloneArray":105,"./_initCloneByTag":106,"./_initCloneObject":107,"./isArray":146,"./isBuffer":149,"./isMap":152,"./isObject":153,"./isSet":156,"./keys":160,"./keysIn":161}],57:[function(require,module,exports){var isObject=require('./isObject');/** Built-in value references. */var objectCreate=Object.create;/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();module.exports=baseCreate;},{"./isObject":153}],58:[function(require,module,exports){var createBaseFor=require('./_createBaseFor');/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */var baseFor=createBaseFor();module.exports=baseFor;},{"./_createBaseFor":87}],59:[function(require,module,exports){var arrayPush=require('./_arrayPush'),isArray=require('./isArray');/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}module.exports=baseGetAllKeys;},{"./_arrayPush":49,"./isArray":146}],60:[function(require,module,exports){var _Symbol2=require('./_Symbol'),getRawTag=require('./_getRawTag'),objectToString=require('./_objectToString');/** `Object#toString` result references. */var nullTag='[object Null]',undefinedTag='[object Undefined]';/** Built-in value references. */var symToStringTag=_Symbol2?_Symbol2.toStringTag:undefined;/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}module.exports=baseGetTag;},{"./_Symbol":41,"./_getRawTag":95,"./_objectToString":127}],61:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var argsTag='[object Arguments]';/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}module.exports=baseIsArguments;},{"./_baseGetTag":60,"./isObjectLike":154}],62:[function(require,module,exports){var getTag=require('./_getTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var mapTag='[object Map]';/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}module.exports=baseIsMap;},{"./_getTag":98,"./isObjectLike":154}],63:[function(require,module,exports){var isFunction=require('./isFunction'),isMasked=require('./_isMasked'),isObject=require('./isObject'),toSource=require('./_toSource');/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used for built-in method references. */var funcProto=Function.prototype,objectProto=Object.prototype;/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}module.exports=baseIsNative;},{"./_isMasked":111,"./_toSource":139,"./isFunction":150,"./isObject":153}],64:[function(require,module,exports){var getTag=require('./_getTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var setTag='[object Set]';/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}module.exports=baseIsSet;},{"./_getTag":98,"./isObjectLike":154}],65:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isLength=require('./isLength'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',boolTag='[object Boolean]',dateTag='[object Date]',errorTag='[object Error]',funcTag='[object Function]',mapTag='[object Map]',numberTag='[object Number]',objectTag='[object Object]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',weakMapTag='[object WeakMap]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}module.exports=baseIsTypedArray;},{"./_baseGetTag":60,"./isLength":151,"./isObjectLike":154}],66:[function(require,module,exports){var isPrototype=require('./_isPrototype'),nativeKeys=require('./_nativeKeys');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}module.exports=baseKeys;},{"./_isPrototype":112,"./_nativeKeys":124}],67:[function(require,module,exports){var isObject=require('./isObject'),isPrototype=require('./_isPrototype'),nativeKeysIn=require('./_nativeKeysIn');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}module.exports=baseKeysIn;},{"./_isPrototype":112,"./_nativeKeysIn":125,"./isObject":153}],68:[function(require,module,exports){var Stack=require('./_Stack'),assignMergeValue=require('./_assignMergeValue'),baseFor=require('./_baseFor'),baseMergeDeep=require('./_baseMergeDeep'),isObject=require('./isObject'),keysIn=require('./keysIn'),safeGet=require('./_safeGet');/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}module.exports=baseMerge;},{"./_Stack":40,"./_assignMergeValue":50,"./_baseFor":58,"./_baseMergeDeep":69,"./_safeGet":131,"./isObject":153,"./keysIn":161}],69:[function(require,module,exports){var assignMergeValue=require('./_assignMergeValue'),cloneBuffer=require('./_cloneBuffer'),cloneTypedArray=require('./_cloneTypedArray'),copyArray=require('./_copyArray'),initCloneObject=require('./_initCloneObject'),isArguments=require('./isArguments'),isArray=require('./isArray'),isArrayLikeObject=require('./isArrayLikeObject'),isBuffer=require('./isBuffer'),isFunction=require('./isFunction'),isObject=require('./isObject'),isPlainObject=require('./isPlainObject'),isTypedArray=require('./isTypedArray'),safeGet=require('./_safeGet'),toPlainObject=require('./toPlainObject');/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}module.exports=baseMergeDeep;},{"./_assignMergeValue":50,"./_cloneBuffer":76,"./_cloneTypedArray":80,"./_copyArray":81,"./_initCloneObject":107,"./_safeGet":131,"./isArguments":145,"./isArray":146,"./isArrayLikeObject":148,"./isBuffer":149,"./isFunction":150,"./isObject":153,"./isPlainObject":155,"./isTypedArray":159,"./toPlainObject":165}],70:[function(require,module,exports){var identity=require('./identity'),overRest=require('./_overRest'),setToString=require('./_setToString');/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}module.exports=baseRest;},{"./_overRest":129,"./_setToString":132,"./identity":144}],71:[function(require,module,exports){var constant=require('./constant'),defineProperty=require('./_defineProperty'),identity=require('./identity');/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};module.exports=baseSetToString;},{"./_defineProperty":88,"./constant":141,"./identity":144}],72:[function(require,module,exports){/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}module.exports=baseTimes;},{}],73:[function(require,module,exports){var _Symbol3=require('./_Symbol'),arrayMap=require('./_arrayMap'),isArray=require('./isArray'),isSymbol=require('./isSymbol');/** Used as references for various `Number` constants. */var INFINITY=1/0;/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol3?_Symbol3.prototype:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}module.exports=baseToString;},{"./_Symbol":41,"./_arrayMap":48,"./isArray":146,"./isSymbol":158}],74:[function(require,module,exports){/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */function baseUnary(func){return function(value){return func(value);};}module.exports=baseUnary;},{}],75:[function(require,module,exports){var Uint8Array=require('./_Uint8Array');/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}module.exports=cloneArrayBuffer;},{"./_Uint8Array":42}],76:[function(require,module,exports){var root=require('./_root');/** Detect free variable `exports`. */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&_typeof(module)=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Built-in value references. */var Buffer=moduleExports?root.Buffer:undefined,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined;/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}module.exports=cloneBuffer;},{"./_root":130}],77:[function(require,module,exports){var cloneArrayBuffer=require('./_cloneArrayBuffer');/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}module.exports=cloneDataView;},{"./_cloneArrayBuffer":75}],78:[function(require,module,exports){/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}module.exports=cloneRegExp;},{}],79:[function(require,module,exports){var _Symbol4=require('./_Symbol');/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol4?_Symbol4.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined;/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}module.exports=cloneSymbol;},{"./_Symbol":41}],80:[function(require,module,exports){var cloneArrayBuffer=require('./_cloneArrayBuffer');/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}module.exports=cloneTypedArray;},{"./_cloneArrayBuffer":75}],81:[function(require,module,exports){/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}module.exports=copyArray;},{}],82:[function(require,module,exports){var assignValue=require('./_assignValue'),baseAssignValue=require('./_baseAssignValue');/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}module.exports=copyObject;},{"./_assignValue":51,"./_baseAssignValue":55}],83:[function(require,module,exports){var copyObject=require('./_copyObject'),getSymbols=require('./_getSymbols');/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}module.exports=copySymbols;},{"./_copyObject":82,"./_getSymbols":96}],84:[function(require,module,exports){var copyObject=require('./_copyObject'),getSymbolsIn=require('./_getSymbolsIn');/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}module.exports=copySymbolsIn;},{"./_copyObject":82,"./_getSymbolsIn":97}],85:[function(require,module,exports){var root=require('./_root');/** Used to detect overreaching core-js shims. */var coreJsData=root['__core-js_shared__'];module.exports=coreJsData;},{"./_root":130}],86:[function(require,module,exports){var baseRest=require('./_baseRest'),isIterateeCall=require('./_isIterateeCall');/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}module.exports=createAssigner;},{"./_baseRest":70,"./_isIterateeCall":109}],87:[function(require,module,exports){/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}module.exports=createBaseFor;},{}],88:[function(require,module,exports){var getNative=require('./_getNative');var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();module.exports=defineProperty;},{"./_getNative":93}],89:[function(require,module,exports){(function(global){/** Detect free variable `global` from Node.js. */var freeGlobal=_typeof(global)=='object'&&global&&global.Object===Object&&global;module.exports=freeGlobal;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],90:[function(require,module,exports){var baseGetAllKeys=require('./_baseGetAllKeys'),getSymbols=require('./_getSymbols'),keys=require('./keys');/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}module.exports=getAllKeys;},{"./_baseGetAllKeys":59,"./_getSymbols":96,"./keys":160}],91:[function(require,module,exports){var baseGetAllKeys=require('./_baseGetAllKeys'),getSymbolsIn=require('./_getSymbolsIn'),keysIn=require('./keysIn');/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}module.exports=getAllKeysIn;},{"./_baseGetAllKeys":59,"./_getSymbolsIn":97,"./keysIn":161}],92:[function(require,module,exports){var isKeyable=require('./_isKeyable');/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}module.exports=getMapData;},{"./_isKeyable":110}],93:[function(require,module,exports){var baseIsNative=require('./_baseIsNative'),getValue=require('./_getValue');/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}module.exports=getNative;},{"./_baseIsNative":63,"./_getValue":99}],94:[function(require,module,exports){var overArg=require('./_overArg');/** Built-in value references. */var getPrototype=overArg(Object.getPrototypeOf,Object);module.exports=getPrototype;},{"./_overArg":128}],95:[function(require,module,exports){var _Symbol5=require('./_Symbol');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */var nativeObjectToString=objectProto.toString;/** Built-in value references. */var symToStringTag=_Symbol5?_Symbol5.toStringTag:undefined;/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}module.exports=getRawTag;},{"./_Symbol":41}],96:[function(require,module,exports){var arrayFilter=require('./_arrayFilter'),stubArray=require('./stubArray');/** Used for built-in method references. */var objectProto=Object.prototype;/** Built-in value references. */var propertyIsEnumerable=objectProto.propertyIsEnumerable;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeGetSymbols=Object.getOwnPropertySymbols;/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};module.exports=getSymbols;},{"./_arrayFilter":46,"./stubArray":163}],97:[function(require,module,exports){var arrayPush=require('./_arrayPush'),getPrototype=require('./_getPrototype'),getSymbols=require('./_getSymbols'),stubArray=require('./stubArray');/* Built-in method references for those with the same name as other `lodash` methods. */var nativeGetSymbols=Object.getOwnPropertySymbols;/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};module.exports=getSymbolsIn;},{"./_arrayPush":49,"./_getPrototype":94,"./_getSymbols":96,"./stubArray":163}],98:[function(require,module,exports){var DataView=require('./_DataView'),Map=require('./_Map'),Promise=require('./_Promise'),Set=require('./_Set'),WeakMap=require('./_WeakMap'),baseGetTag=require('./_baseGetTag'),toSource=require('./_toSource');/** `Object#toString` result references. */var mapTag='[object Map]',objectTag='[object Object]',promiseTag='[object Promise]',setTag='[object Set]',weakMapTag='[object WeakMap]';var dataViewTag='[object DataView]';/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}module.exports=getTag;},{"./_DataView":33,"./_Map":36,"./_Promise":38,"./_Set":39,"./_WeakMap":43,"./_baseGetTag":60,"./_toSource":139}],99:[function(require,module,exports){/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */function getValue(object,key){return object==null?undefined:object[key];}module.exports=getValue;},{}],100:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}module.exports=hashClear;},{"./_nativeCreate":123}],101:[function(require,module,exports){/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}module.exports=hashDelete;},{}],102:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}module.exports=hashGet;},{"./_nativeCreate":123}],103:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}module.exports=hashHas;},{"./_nativeCreate":123}],104:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}module.exports=hashSet;},{"./_nativeCreate":123}],105:[function(require,module,exports){/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}module.exports=initCloneArray;},{}],106:[function(require,module,exports){var cloneArrayBuffer=require('./_cloneArrayBuffer'),cloneDataView=require('./_cloneDataView'),cloneRegExp=require('./_cloneRegExp'),cloneSymbol=require('./_cloneSymbol'),cloneTypedArray=require('./_cloneTypedArray');/** `Object#toString` result references. */var boolTag='[object Boolean]',dateTag='[object Date]',mapTag='[object Map]',numberTag='[object Number]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}module.exports=initCloneByTag;},{"./_cloneArrayBuffer":75,"./_cloneDataView":77,"./_cloneRegExp":78,"./_cloneSymbol":79,"./_cloneTypedArray":80}],107:[function(require,module,exports){var baseCreate=require('./_baseCreate'),getPrototype=require('./_getPrototype'),isPrototype=require('./_isPrototype');/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}module.exports=initCloneObject;},{"./_baseCreate":57,"./_getPrototype":94,"./_isPrototype":112}],108:[function(require,module,exports){/** Used as references for various `Number` constants. */var MAX_SAFE_INTEGER=9007199254740991;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */function isIndex(value,length){var type=_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}module.exports=isIndex;},{}],109:[function(require,module,exports){var eq=require('./eq'),isArrayLike=require('./isArrayLike'),isIndex=require('./_isIndex'),isObject=require('./isObject');/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}module.exports=isIterateeCall;},{"./_isIndex":108,"./eq":142,"./isArrayLike":147,"./isObject":153}],110:[function(require,module,exports){/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */function isKeyable(value){var type=_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}module.exports=isKeyable;},{}],111:[function(require,module,exports){var coreJsData=require('./_coreJsData');/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}module.exports=isMasked;},{"./_coreJsData":85}],112:[function(require,module,exports){/** Used for built-in method references. */var objectProto=Object.prototype;/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}module.exports=isPrototype;},{}],113:[function(require,module,exports){/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */function listCacheClear(){this.__data__=[];this.size=0;}module.exports=listCacheClear;},{}],114:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/** Used for built-in method references. */var arrayProto=Array.prototype;/** Built-in value references. */var splice=arrayProto.splice;/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}module.exports=listCacheDelete;},{"./_assocIndexOf":52}],115:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}module.exports=listCacheGet;},{"./_assocIndexOf":52}],116:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}module.exports=listCacheHas;},{"./_assocIndexOf":52}],117:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}module.exports=listCacheSet;},{"./_assocIndexOf":52}],118:[function(require,module,exports){var Hash=require('./_Hash'),ListCache=require('./_ListCache'),Map=require('./_Map');/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}module.exports=mapCacheClear;},{"./_Hash":34,"./_ListCache":35,"./_Map":36}],119:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}module.exports=mapCacheDelete;},{"./_getMapData":92}],120:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function mapCacheGet(key){return getMapData(this,key).get(key);}module.exports=mapCacheGet;},{"./_getMapData":92}],121:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function mapCacheHas(key){return getMapData(this,key).has(key);}module.exports=mapCacheHas;},{"./_getMapData":92}],122:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}module.exports=mapCacheSet;},{"./_getMapData":92}],123:[function(require,module,exports){var getNative=require('./_getNative');/* Built-in method references that are verified to be native. */var nativeCreate=getNative(Object,'create');module.exports=nativeCreate;},{"./_getNative":93}],124:[function(require,module,exports){var overArg=require('./_overArg');/* Built-in method references for those with the same name as other `lodash` methods. */var nativeKeys=overArg(Object.keys,Object);module.exports=nativeKeys;},{"./_overArg":128}],125:[function(require,module,exports){/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}module.exports=nativeKeysIn;},{}],126:[function(require,module,exports){var freeGlobal=require('./_freeGlobal');/** Detect free variable `exports`. */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&_typeof(module)=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
	var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
	return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();module.exports=nodeUtil;},{"./_freeGlobal":89}],127:[function(require,module,exports){/** Used for built-in method references. */var objectProto=Object.prototype;/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */var nativeObjectToString=objectProto.toString;/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */function objectToString(value){return nativeObjectToString.call(value);}module.exports=objectToString;},{}],128:[function(require,module,exports){/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */function overArg(func,transform){return function(arg){return func(transform(arg));};}module.exports=overArg;},{}],129:[function(require,module,exports){var apply=require('./_apply');/* Built-in method references for those with the same name as other `lodash` methods. */var nativeMax=Math.max;/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}module.exports=overRest;},{"./_apply":44}],130:[function(require,module,exports){var freeGlobal=require('./_freeGlobal');/** Detect free variable `self`. */var freeSelf=(typeof self==="undefined"?"undefined":_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();module.exports=root;},{"./_freeGlobal":89}],131:[function(require,module,exports){/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}module.exports=safeGet;},{}],132:[function(require,module,exports){var baseSetToString=require('./_baseSetToString'),shortOut=require('./_shortOut');/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */var setToString=shortOut(baseSetToString);module.exports=setToString;},{"./_baseSetToString":71,"./_shortOut":133}],133:[function(require,module,exports){/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeNow=Date.now;/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}module.exports=shortOut;},{}],134:[function(require,module,exports){var ListCache=require('./_ListCache');/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */function stackClear(){this.__data__=new ListCache();this.size=0;}module.exports=stackClear;},{"./_ListCache":35}],135:[function(require,module,exports){/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}module.exports=stackDelete;},{}],136:[function(require,module,exports){/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function stackGet(key){return this.__data__.get(key);}module.exports=stackGet;},{}],137:[function(require,module,exports){/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function stackHas(key){return this.__data__.has(key);}module.exports=stackHas;},{}],138:[function(require,module,exports){var ListCache=require('./_ListCache'),Map=require('./_Map'),MapCache=require('./_MapCache');/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}module.exports=stackSet;},{"./_ListCache":35,"./_Map":36,"./_MapCache":37}],139:[function(require,module,exports){/** Used for built-in method references. */var funcProto=Function.prototype;/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}module.exports=toSource;},{}],140:[function(require,module,exports){var baseClone=require('./_baseClone');/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_SYMBOLS_FLAG=4;/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}module.exports=cloneDeep;},{"./_baseClone":56}],141:[function(require,module,exports){/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */function constant(value){return function(){return value;};}module.exports=constant;},{}],142:[function(require,module,exports){/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */function eq(value,other){return value===other||value!==value&&other!==other;}module.exports=eq;},{}],143:[function(require,module,exports){var toString=require('./toString');/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}module.exports=escapeRegExp;},{"./toString":166}],144:[function(require,module,exports){/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */function identity(value){return value;}module.exports=identity;},{}],145:[function(require,module,exports){var baseIsArguments=require('./_baseIsArguments'),isObjectLike=require('./isObjectLike');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Built-in value references. */var propertyIsEnumerable=objectProto.propertyIsEnumerable;/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};module.exports=isArguments;},{"./_baseIsArguments":61,"./isObjectLike":154}],146:[function(require,module,exports){/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */var isArray=Array.isArray;module.exports=isArray;},{}],147:[function(require,module,exports){var isFunction=require('./isFunction'),isLength=require('./isLength');/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}module.exports=isArrayLike;},{"./isFunction":150,"./isLength":151}],148:[function(require,module,exports){var isArrayLike=require('./isArrayLike'),isObjectLike=require('./isObjectLike');/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}module.exports=isArrayLikeObject;},{"./isArrayLike":147,"./isObjectLike":154}],149:[function(require,module,exports){var root=require('./_root'),stubFalse=require('./stubFalse');/** Detect free variable `exports`. */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&_typeof(module)=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Built-in value references. */var Buffer=moduleExports?root.Buffer:undefined;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeIsBuffer=Buffer?Buffer.isBuffer:undefined;/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */var isBuffer=nativeIsBuffer||stubFalse;module.exports=isBuffer;},{"./_root":130,"./stubFalse":164}],150:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isObject=require('./isObject');/** `Object#toString` result references. */var asyncTag='[object AsyncFunction]',funcTag='[object Function]',genTag='[object GeneratorFunction]',proxyTag='[object Proxy]';/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}module.exports=isFunction;},{"./_baseGetTag":60,"./isObject":153}],151:[function(require,module,exports){/** Used as references for various `Number` constants. */var MAX_SAFE_INTEGER=9007199254740991;/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}module.exports=isLength;},{}],152:[function(require,module,exports){var baseIsMap=require('./_baseIsMap'),baseUnary=require('./_baseUnary'),nodeUtil=require('./_nodeUtil');/* Node.js helper references. */var nodeIsMap=nodeUtil&&nodeUtil.isMap;/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;module.exports=isMap;},{"./_baseIsMap":62,"./_baseUnary":74,"./_nodeUtil":126}],153:[function(require,module,exports){/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */function isObject(value){var type=_typeof(value);return value!=null&&(type=='object'||type=='function');}module.exports=isObject;},{}],154:[function(require,module,exports){/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */function isObjectLike(value){return value!=null&&_typeof(value)=='object';}module.exports=isObjectLike;},{}],155:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),getPrototype=require('./_getPrototype'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var objectTag='[object Object]';/** Used for built-in method references. */var funcProto=Function.prototype,objectProto=Object.prototype;/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}module.exports=isPlainObject;},{"./_baseGetTag":60,"./_getPrototype":94,"./isObjectLike":154}],156:[function(require,module,exports){var baseIsSet=require('./_baseIsSet'),baseUnary=require('./_baseUnary'),nodeUtil=require('./_nodeUtil');/* Node.js helper references. */var nodeIsSet=nodeUtil&&nodeUtil.isSet;/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;module.exports=isSet;},{"./_baseIsSet":64,"./_baseUnary":74,"./_nodeUtil":126}],157:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isArray=require('./isArray'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var stringTag='[object String]';/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}module.exports=isString;},{"./_baseGetTag":60,"./isArray":146,"./isObjectLike":154}],158:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var symbolTag='[object Symbol]';/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */function isSymbol(value){return _typeof(value)=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}module.exports=isSymbol;},{"./_baseGetTag":60,"./isObjectLike":154}],159:[function(require,module,exports){var baseIsTypedArray=require('./_baseIsTypedArray'),baseUnary=require('./_baseUnary'),nodeUtil=require('./_nodeUtil');/* Node.js helper references. */var nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;module.exports=isTypedArray;},{"./_baseIsTypedArray":65,"./_baseUnary":74,"./_nodeUtil":126}],160:[function(require,module,exports){var arrayLikeKeys=require('./_arrayLikeKeys'),baseKeys=require('./_baseKeys'),isArrayLike=require('./isArrayLike');/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}module.exports=keys;},{"./_arrayLikeKeys":47,"./_baseKeys":66,"./isArrayLike":147}],161:[function(require,module,exports){var arrayLikeKeys=require('./_arrayLikeKeys'),baseKeysIn=require('./_baseKeysIn'),isArrayLike=require('./isArrayLike');/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}module.exports=keysIn;},{"./_arrayLikeKeys":47,"./_baseKeysIn":67,"./isArrayLike":147}],162:[function(require,module,exports){var baseMerge=require('./_baseMerge'),createAssigner=require('./_createAssigner');/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});module.exports=mergeWith;},{"./_baseMerge":68,"./_createAssigner":86}],163:[function(require,module,exports){/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */function stubArray(){return[];}module.exports=stubArray;},{}],164:[function(require,module,exports){/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */function stubFalse(){return false;}module.exports=stubFalse;},{}],165:[function(require,module,exports){var copyObject=require('./_copyObject'),keysIn=require('./keysIn');/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */function toPlainObject(value){return copyObject(value,keysIn(value));}module.exports=toPlainObject;},{"./_copyObject":82,"./keysIn":161}],166:[function(require,module,exports){var baseToString=require('./_baseToString');/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */function toString(value){return value==null?'':baseToString(value);}module.exports=toString;},{"./_baseToString":73}],167:[function(require,module,exports){/**
	 * Srcset Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * JS Parser for the string value that appears in markup <img srcset="here">
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 */(function(root,factory){if(typeof define==='function'&&define.amd){// AMD. Register as an anonymous module.
	define([],factory);}else if(_typeof(module)==='object'&&module.exports){// Node. Does not work with strict CommonJS, but
	// only CommonJS-like environments that support module.exports,
	// like Node.
	module.exports=factory();}else{// Browser globals (root is window)
	root.parseSrcset=factory();}})(this,function(){// 1. Let input be the value passed to this algorithm.
	return function(input){// UTILITY FUNCTIONS
	// Manual is faster than RegEx
	// http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
	// http://jsperf.com/whitespace-character/5
	function isSpace(c){return c===" "||// space
	c==="\t"||// horizontal tab
	c==="\n"||// new line
	c==="\f"||// form feed
	c==="\r";// carriage return
	}function collectCharacters(regEx){var chars,match=regEx.exec(input.substring(pos));if(match){chars=match[0];pos+=chars.length;return chars;}}var inputLength=input.length,// (Don't use \s, to avoid matching non-breaking space)
	regexLeadingSpaces=/^[ \t\n\r\u000c]+/,regexLeadingCommasOrSpaces=/^[, \t\n\r\u000c]+/,regexLeadingNotSpaces=/^[^ \t\n\r\u000c]+/,regexTrailingCommas=/[,]+$/,regexNonNegativeInteger=/^\d+$/,// ( Positive or negative or unsigned integers or decimals, without or without exponents.
	// Must include at least one digit.
	// According to spec tests any decimal point must be followed by a digit.
	// No leading plus sign is allowed.)
	// https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	regexFloatingPoint=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,url,descriptors,currentDescriptor,state,c,// 2. Let position be a pointer into input, initially pointing at the start
	//    of the string.
	pos=0,// 3. Let candidates be an initially empty source set.
	candidates=[];// 4. Splitting loop: Collect a sequence of characters that are space
	//    characters or U+002C COMMA characters. If any U+002C COMMA characters
	//    were collected, that is a parse error.
	while(true){collectCharacters(regexLeadingCommasOrSpaces);// 5. If position is past the end of input, return candidates and abort these steps.
	if(pos>=inputLength){return candidates;// (we're done, this is the sole return path)
	}// 6. Collect a sequence of characters that are not space characters,
	//    and let that be url.
	url=collectCharacters(regexLeadingNotSpaces);// 7. Let descriptors be a new empty list.
	descriptors=[];// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
	//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
	//         more than one character, that is a parse error.
	if(url.slice(-1)===","){url=url.replace(regexTrailingCommas,"");// (Jump ahead to step 9 to skip tokenization and just push the candidate).
	parseDescriptors();//	Otherwise, follow these substeps:
	}else{tokenize();}// (close else of step 8)
	// 16. Return to the step labeled splitting loop.
	}// (Close of big while loop.)
	/**
			 * Tokenizes descriptor properties prior to parsing
			 * Returns undefined.
			 */function tokenize(){// 8.1. Descriptor tokeniser: Skip whitespace
	collectCharacters(regexLeadingSpaces);// 8.2. Let current descriptor be the empty string.
	currentDescriptor="";// 8.3. Let state be in descriptor.
	state="in descriptor";while(true){// 8.4. Let c be the character at position.
	c=input.charAt(pos);//  Do the following depending on the value of state.
	//  For the purpose of this step, "EOF" is a special character representing
	//  that position is past the end of input.
	// In descriptor
	if(state==="in descriptor"){// Do the following, depending on the value of c:
	// Space character
	// If current descriptor is not empty, append current descriptor to
	// descriptors and let current descriptor be the empty string.
	// Set state to after descriptor.
	if(isSpace(c)){if(currentDescriptor){descriptors.push(currentDescriptor);currentDescriptor="";state="after descriptor";}// U+002C COMMA (,)
	// Advance position to the next character in input. If current descriptor
	// is not empty, append current descriptor to descriptors. Jump to the step
	// labeled descriptor parser.
	}else if(c===","){pos+=1;if(currentDescriptor){descriptors.push(currentDescriptor);}parseDescriptors();return;// U+0028 LEFT PARENTHESIS (()
	// Append c to current descriptor. Set state to in parens.
	}else if(c==="("){currentDescriptor=currentDescriptor+c;state="in parens";// EOF
	// If current descriptor is not empty, append current descriptor to
	// descriptors. Jump to the step labeled descriptor parser.
	}else if(c===""){if(currentDescriptor){descriptors.push(currentDescriptor);}parseDescriptors();return;// Anything else
	// Append c to current descriptor.
	}else{currentDescriptor=currentDescriptor+c;}// (end "in descriptor"
	// In parens
	}else if(state==="in parens"){// U+0029 RIGHT PARENTHESIS ())
	// Append c to current descriptor. Set state to in descriptor.
	if(c===")"){currentDescriptor=currentDescriptor+c;state="in descriptor";// EOF
	// Append current descriptor to descriptors. Jump to the step labeled
	// descriptor parser.
	}else if(c===""){descriptors.push(currentDescriptor);parseDescriptors();return;// Anything else
	// Append c to current descriptor.
	}else{currentDescriptor=currentDescriptor+c;}// After descriptor
	}else if(state==="after descriptor"){// Do the following, depending on the value of c:
	// Space character: Stay in this state.
	if(isSpace(c)){// EOF: Jump to the step labeled descriptor parser.
	}else if(c===""){parseDescriptors();return;// Anything else
	// Set state to in descriptor. Set position to the previous character in input.
	}else{state="in descriptor";pos-=1;}}// Advance position to the next character in input.
	pos+=1;// Repeat this step.
	}// (close while true loop)
	}/**
			 * Adds descriptor properties to a candidate, pushes to the candidates array
			 * @return undefined
			 */ // Declared outside of the while loop so that it's only created once.
	function parseDescriptors(){// 9. Descriptor parser: Let error be no.
	var pError=false,// 10. Let width be absent.
	// 11. Let density be absent.
	// 12. Let future-compat-h be absent. (We're implementing it now as h)
	w,d,h,i,candidate={},desc,lastChar,value,intVal,floatVal;// 13. For each descriptor in descriptors, run the appropriate set of steps
	// from the following list:
	for(i=0;i<descriptors.length;i++){desc=descriptors[i];lastChar=desc[desc.length-1];value=desc.substring(0,desc.length-1);intVal=parseInt(value,10);floatVal=parseFloat(value);// If the descriptor consists of a valid non-negative integer followed by
	// a U+0077 LATIN SMALL LETTER W character
	if(regexNonNegativeInteger.test(value)&&lastChar==="w"){// If width and density are not both absent, then let error be yes.
	if(w||d){pError=true;}// Apply the rules for parsing non-negative integers to the descriptor.
	// If the result is zero, let error be yes.
	// Otherwise, let width be the result.
	if(intVal===0){pError=true;}else{w=intVal;}// If the descriptor consists of a valid floating-point number followed by
	// a U+0078 LATIN SMALL LETTER X character
	}else if(regexFloatingPoint.test(value)&&lastChar==="x"){// If width, density and future-compat-h are not all absent, then let error
	// be yes.
	if(w||d||h){pError=true;}// Apply the rules for parsing floating-point number values to the descriptor.
	// If the result is less than zero, let error be yes. Otherwise, let density
	// be the result.
	if(floatVal<0){pError=true;}else{d=floatVal;}// If the descriptor consists of a valid non-negative integer followed by
	// a U+0068 LATIN SMALL LETTER H character
	}else if(regexNonNegativeInteger.test(value)&&lastChar==="h"){// If height and density are not both absent, then let error be yes.
	if(h||d){pError=true;}// Apply the rules for parsing non-negative integers to the descriptor.
	// If the result is zero, let error be yes. Otherwise, let future-compat-h
	// be the result.
	if(intVal===0){pError=true;}else{h=intVal;}// Anything else, Let error be yes.
	}else{pError=true;}}// (close step 13 for loop)
	// 15. If error is still no, then append a new image source to candidates whose
	// URL is url, associated with a width width if not absent and a pixel
	// density density if not absent. Otherwise, there is a parse error.
	if(!pError){candidate.url=url;if(w){candidate.w=w;}if(d){candidate.d=d;}if(h){candidate.h=h;}candidates.push(candidate);}else if(console&&console.log){console.log("Invalid srcset descriptor found in '"+input+"' at '"+desc+"'.");}}// (close parseDescriptors fn)
	};});},{}],168:[function(require,module,exports){(function(process){// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
	// backported and transplited with Babel, with backwards-compat fixes
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts,allowAboveRoot){// if the path tries to go above the root, `up` ends up > 0
	var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==='.'){parts.splice(i,1);}else if(last==='..'){parts.splice(i,1);up++;}else if(up){parts.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
	if(allowAboveRoot){for(;up--;up){parts.unshift('..');}}return parts;}// path.resolve([from ...], to)
	// posix version
	exports.resolve=function(){var resolvedPath='',resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:process.cwd();// Skip empty and invalid entries
	if(typeof path!=='string'){throw new TypeError('Arguments to path.resolve must be strings');}else if(!path){continue;}resolvedPath=path+'/'+resolvedPath;resolvedAbsolute=path.charAt(0)==='/';}// At this point the path should be resolved to a full absolute path, but
	// handle relative paths to be safe (might happen when process.cwd() fails)
	// Normalize the path
	resolvedPath=normalizeArray(filter(resolvedPath.split('/'),function(p){return!!p;}),!resolvedAbsolute).join('/');return(resolvedAbsolute?'/':'')+resolvedPath||'.';};// path.normalize(path)
	// posix version
	exports.normalize=function(path){var isAbsolute=exports.isAbsolute(path),trailingSlash=substr(path,-1)==='/';// Normalize the path
	path=normalizeArray(filter(path.split('/'),function(p){return!!p;}),!isAbsolute).join('/');if(!path&&!isAbsolute){path='.';}if(path&&trailingSlash){path+='/';}return(isAbsolute?'/':'')+path;};// posix version
	exports.isAbsolute=function(path){return path.charAt(0)==='/';};// posix version
	exports.join=function(){var paths=Array.prototype.slice.call(arguments,0);return exports.normalize(filter(paths,function(p,index){if(typeof p!=='string'){throw new TypeError('Arguments to path.join must be strings');}return p;}).join('/'));};// path.relative(from, to)
	// posix version
	exports.relative=function(from,to){from=exports.resolve(from).substr(1);to=exports.resolve(to).substr(1);function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!=='')break;}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!=='')break;}if(start>end)return[];return arr.slice(start,end-start+1);}var fromParts=trim(from.split('/'));var toParts=trim(to.split('/'));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break;}}var outputParts=[];for(var i=samePartsLength;i<fromParts.length;i++){outputParts.push('..');}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join('/');};exports.sep='/';exports.delimiter=':';exports.dirname=function(path){if(typeof path!=='string')path=path+'';if(path.length===0)return'.';var code=path.charCodeAt(0);var hasRoot=code===47/*/*/;var end=-1;var matchedSlash=true;for(var i=path.length-1;i>=1;--i){code=path.charCodeAt(i);if(code===47/*/*/){if(!matchedSlash){end=i;break;}}else{// We saw the first non-path separator
	matchedSlash=false;}}if(end===-1)return hasRoot?'/':'.';if(hasRoot&&end===1){// return '//';
	// Backwards-compat fix:
	return'/';}return path.slice(0,end);};function basename(path){if(typeof path!=='string')path=path+'';var start=0;var end=-1;var matchedSlash=true;var i;for(i=path.length-1;i>=0;--i){if(path.charCodeAt(i)===47/*/*/){// If we reached a path separator that was not part of a set of path
	// separators at the end of the string, stop now
	if(!matchedSlash){start=i+1;break;}}else if(end===-1){// We saw the first non-path separator, mark this as the end of our
	// path component
	matchedSlash=false;end=i+1;}}if(end===-1)return'';return path.slice(start,end);}// Uses a mixed approach for backwards-compatibility, as ext behavior changed
	// in new Node.js versions, so only basename() above is backported here
	exports.basename=function(path,ext){var f=basename(path);if(ext&&f.substr(-1*ext.length)===ext){f=f.substr(0,f.length-ext.length);}return f;};exports.extname=function(path){if(typeof path!=='string')path=path+'';var startDot=-1;var startPart=0;var end=-1;var matchedSlash=true;// Track the state of characters (if any) we see before our first dot and
	// after any path separator we find
	var preDotState=0;for(var i=path.length-1;i>=0;--i){var code=path.charCodeAt(i);if(code===47/*/*/){// If we reached a path separator that was not part of a set of path
	// separators at the end of the string, stop now
	if(!matchedSlash){startPart=i+1;break;}continue;}if(end===-1){// We saw the first non-path separator, mark this as the end of our
	// extension
	matchedSlash=false;end=i+1;}if(code===46/*.*/){// If this is our first dot, mark it as the start of our extension
	if(startDot===-1)startDot=i;else if(preDotState!==1)preDotState=1;}else if(startDot!==-1){// We saw a non-dot and non-path separator before our dot, so we should
	// have a good chance at having a non-empty extension
	preDotState=-1;}}if(startDot===-1||end===-1||// We saw a non-dot character immediately before the dot
	preDotState===0||// The (right-most) trimmed path component is exactly '..'
	preDotState===1&&startDot===end-1&&startDot===startPart+1){return'';}return path.slice(startDot,end);};function filter(xs,f){if(xs.filter)return xs.filter(f);var res=[];for(var i=0;i<xs.length;i++){if(f(xs[i],i,xs))res.push(xs[i]);}return res;}// String.prototype.substr - negative index don't work in IE8
	var substr='ab'.substr(-1)==='b'?function(str,start,len){return str.substr(start,len);}:function(str,start,len){if(start<0)start=str.length+start;return str.substr(start,len);};}).call(this,require('_process'));},{"_process":193}],169:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _container=_interopRequireDefault(require("./container"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents an at-rule.
	 *
	 * If it’s followed in the CSS by a {} block, this node will have
	 * a nodes property representing its children.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('@charset "UTF-8"; @media print {}')
	 *
	 * const charset = root.first
	 * charset.type  //=> 'atrule'
	 * charset.nodes //=> undefined
	 *
	 * const media = root.last
	 * media.nodes   //=> []
	 */var AtRule=/*#__PURE__*/function(_Container){_inheritsLoose(AtRule,_Container);function AtRule(defaults){var _this;_this=_Container.call(this,defaults)||this;_this.type='atrule';return _this;}var _proto=AtRule.prototype;_proto.append=function append(){var _Container$prototype$;if(!this.nodes)this.nodes=[];for(var _len=arguments.length,children=new Array(_len),_key=0;_key<_len;_key++){children[_key]=arguments[_key];}return(_Container$prototype$=_Container.prototype.append).call.apply(_Container$prototype$,[this].concat(children));};_proto.prepend=function prepend(){var _Container$prototype$2;if(!this.nodes)this.nodes=[];for(var _len2=arguments.length,children=new Array(_len2),_key2=0;_key2<_len2;_key2++){children[_key2]=arguments[_key2];}return(_Container$prototype$2=_Container.prototype.prepend).call.apply(_Container$prototype$2,[this].concat(children));}/**
	   * @memberof AtRule#
	   * @member {string} name The at-rule’s name immediately follows the `@`.
	   *
	   * @example
	   * const root  = postcss.parse('@media print {}')
	   * media.name //=> 'media'
	   * const media = root.first
	   */ /**
	   * @memberof AtRule#
	   * @member {string} params The at-rule’s parameters, the values
	   *                         that follow the at-rule’s name but precede
	   *                         any {} block.
	   *
	   * @example
	   * const root  = postcss.parse('@media print, screen {}')
	   * const media = root.first
	   * media.params //=> 'print, screen'
	   */ /**
	   * @memberof AtRule#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                        node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node. It also stores `*`
	   *   and `_` symbols before the declaration (IE hack).
	   * * `after`: the space symbols after the last child of the node
	   *   to the end of the node.
	   * * `between`: the symbols between the property and value
	   *   for declarations, selector and `{` for rules, or last parameter
	   *   and `{` for at-rules.
	   * * `semicolon`: contains true if the last child has
	   *   an (optional) semicolon.
	   * * `afterName`: the space between the at-rule name and its parameters.
	   *
	   * PostCSS cleans at-rule parameters from comments and extra spaces,
	   * but it stores origin content in raws properties.
	   * As such, if you don’t change a declaration’s value,
	   * PostCSS will use the raw value with comments.
	   *
	   * @example
	   * const root = postcss.parse('  @media\nprint {\n}')
	   * root.first.first.raws //=> { before: '  ',
	   *                       //     between: ' ',
	   *                       //     afterName: '\n',
	   *                       //     after: '\n' }
	   */;return AtRule;}(_container["default"]);var _default=AtRule;exports["default"]=_default;module.exports=exports["default"];},{"./container":171}],170:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _node=_interopRequireDefault(require("./node"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a comment between declarations or statements (rule and at-rules).
	 *
	 * Comments inside selectors, at-rule parameters, or declaration values
	 * will be stored in the `raws` properties explained above.
	 *
	 * @extends Node
	 */var Comment=/*#__PURE__*/function(_Node){_inheritsLoose(Comment,_Node);function Comment(defaults){var _this;_this=_Node.call(this,defaults)||this;_this.type='comment';return _this;}/**
	   * @memberof Comment#
	   * @member {string} text The comment’s text.
	   */ /**
	   * @memberof Comment#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node.
	   * * `left`: the space symbols between `/*` and the comment’s text.
	   * * `right`: the space symbols between the comment’s text.
	   */return Comment;}(_node["default"]);var _default=Comment;exports["default"]=_default;module.exports=exports["default"];},{"./node":178}],171:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _declaration=_interopRequireDefault(require("./declaration"));var _comment=_interopRequireDefault(require("./comment"));var _node=_interopRequireDefault(require("./node"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}function cleanSource(nodes){return nodes.map(function(i){if(i.nodes)i.nodes=cleanSource(i.nodes);delete i.source;return i;});}/**
	 * The {@link Root}, {@link AtRule}, and {@link Rule} container nodes
	 * inherit some common methods to help work with their children.
	 *
	 * Note that all containers can store any content. If you write a rule inside
	 * a rule, PostCSS will parse it.
	 *
	 * @extends Node
	 * @abstract
	 */var Container=/*#__PURE__*/function(_Node){_inheritsLoose(Container,_Node);function Container(){return _Node.apply(this,arguments)||this;}var _proto=Container.prototype;_proto.push=function push(child){child.parent=this;this.nodes.push(child);return this;}/**
	   * Iterates through the container’s immediate children,
	   * calling `callback` for each child.
	   *
	   * Returning `false` in the callback will break iteration.
	   *
	   * This method only iterates through the container’s immediate children.
	   * If you need to recursively iterate through all the container’s descendant
	   * nodes, use {@link Container#walk}.
	   *
	   * Unlike the for `{}`-cycle or `Array#forEach` this iterator is safe
	   * if you are mutating the array of child nodes during iteration.
	   * PostCSS will adjust the current index to match the mutations.
	   *
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black; z-index: 1 }')
	   * const rule = root.first
	   *
	   * for (const decl of rule.nodes) {
	   *   decl.cloneBefore({ prop: '-webkit-' + decl.prop })
	   *   // Cycle will be infinite, because cloneBefore moves the current node
	   *   // to the next index
	   * }
	   *
	   * rule.each(decl => {
	   *   decl.cloneBefore({ prop: '-webkit-' + decl.prop })
	   *   // Will be executed only for color and z-index
	   * })
	   */;_proto.each=function each(callback){if(!this.lastEach)this.lastEach=0;if(!this.indexes)this.indexes={};this.lastEach+=1;var id=this.lastEach;this.indexes[id]=0;if(!this.nodes)return undefined;var index,result;while(this.indexes[id]<this.nodes.length){index=this.indexes[id];result=callback(this.nodes[index],index);if(result===false)break;this.indexes[id]+=1;}delete this.indexes[id];return result;}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each node.
	   *
	   * Like container.each(), this method is safe to use
	   * if you are mutating arrays during iteration.
	   *
	   * If you only need to iterate through the container’s immediate children,
	   * use {@link Container#each}.
	   *
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walk(node => {
	   *   // Traverses all descendant nodes.
	   * })
	   */;_proto.walk=function walk(callback){return this.each(function(child,i){var result;try{result=callback(child,i);}catch(e){e.postcssNode=child;if(e.stack&&child.source&&/\n\s{4}at /.test(e.stack)){var s=child.source;e.stack=e.stack.replace(/\n\s{4}at /,"$&"+s.input.from+":"+s.start.line+":"+s.start.column+"$&");}throw e;}if(result!==false&&child.walk){result=child.walk(callback);}return result;});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each declaration node.
	   *
	   * If you pass a filter, iteration will only happen over declarations
	   * with matching properties.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {string|RegExp} [prop]   String or regular expression
	   *                                 to filter declarations by property name.
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walkDecls(decl => {
	   *   checkPropertySupport(decl.prop)
	   * })
	   *
	   * root.walkDecls('border-radius', decl => {
	   *   decl.remove()
	   * })
	   *
	   * root.walkDecls(/^background/, decl => {
	   *   decl.value = takeFirstColorFromGradient(decl.value)
	   * })
	   */;_proto.walkDecls=function walkDecls(prop,callback){if(!callback){callback=prop;return this.walk(function(child,i){if(child.type==='decl'){return callback(child,i);}});}if(prop instanceof RegExp){return this.walk(function(child,i){if(child.type==='decl'&&prop.test(child.prop)){return callback(child,i);}});}return this.walk(function(child,i){if(child.type==='decl'&&child.prop===prop){return callback(child,i);}});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each rule node.
	   *
	   * If you pass a filter, iteration will only happen over rules
	   * with matching selectors.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {string|RegExp} [selector] String or regular expression
	   *                                   to filter rules by selector.
	   * @param {childIterator} callback   Iterator receives each node and index.
	   *
	   * @return {false|undefined} returns `false` if iteration was broke.
	   *
	   * @example
	   * const selectors = []
	   * root.walkRules(rule => {
	   *   selectors.push(rule.selector)
	   * })
	   * console.log(`Your CSS uses ${ selectors.length } selectors`)
	   */;_proto.walkRules=function walkRules(selector,callback){if(!callback){callback=selector;return this.walk(function(child,i){if(child.type==='rule'){return callback(child,i);}});}if(selector instanceof RegExp){return this.walk(function(child,i){if(child.type==='rule'&&selector.test(child.selector)){return callback(child,i);}});}return this.walk(function(child,i){if(child.type==='rule'&&child.selector===selector){return callback(child,i);}});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each at-rule node.
	   *
	   * If you pass a filter, iteration will only happen over at-rules
	   * that have matching names.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {string|RegExp} [name]   String or regular expression
	   *                                 to filter at-rules by name.
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walkAtRules(rule => {
	   *   if (isOld(rule.name)) rule.remove()
	   * })
	   *
	   * let first = false
	   * root.walkAtRules('charset', rule => {
	   *   if (!first) {
	   *     first = true
	   *   } else {
	   *     rule.remove()
	   *   }
	   * })
	   */;_proto.walkAtRules=function walkAtRules(name,callback){if(!callback){callback=name;return this.walk(function(child,i){if(child.type==='atrule'){return callback(child,i);}});}if(name instanceof RegExp){return this.walk(function(child,i){if(child.type==='atrule'&&name.test(child.name)){return callback(child,i);}});}return this.walk(function(child,i){if(child.type==='atrule'&&child.name===name){return callback(child,i);}});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each comment node.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walkComments(comment => {
	   *   comment.remove()
	   * })
	   */;_proto.walkComments=function walkComments(callback){return this.walk(function(child,i){if(child.type==='comment'){return callback(child,i);}});}/**
	   * Inserts new nodes to the end of the container.
	   *
	   * @param {...(Node|object|string|Node[])} children New nodes.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * const decl1 = postcss.decl({ prop: 'color', value: 'black' })
	   * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' })
	   * rule.append(decl1, decl2)
	   *
	   * root.append({ name: 'charset', params: '"UTF-8"' })  // at-rule
	   * root.append({ selector: 'a' })                       // rule
	   * rule.append({ prop: 'color', value: 'black' })       // declaration
	   * rule.append({ text: 'Comment' })                     // comment
	   *
	   * root.append('a {}')
	   * root.first.append('color: black; z-index: 1')
	   */;_proto.append=function append(){for(var _len=arguments.length,children=new Array(_len),_key=0;_key<_len;_key++){children[_key]=arguments[_key];}for(var _i=0,_children=children;_i<_children.length;_i++){var child=_children[_i];var nodes=this.normalize(child,this.last);for(var _iterator=_createForOfIteratorHelperLoose(nodes),_step;!(_step=_iterator()).done;){var node=_step.value;this.nodes.push(node);}}return this;}/**
	   * Inserts new nodes to the start of the container.
	   *
	   * @param {...(Node|object|string|Node[])} children New nodes.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * const decl1 = postcss.decl({ prop: 'color', value: 'black' })
	   * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' })
	   * rule.prepend(decl1, decl2)
	   *
	   * root.append({ name: 'charset', params: '"UTF-8"' })  // at-rule
	   * root.append({ selector: 'a' })                       // rule
	   * rule.append({ prop: 'color', value: 'black' })       // declaration
	   * rule.append({ text: 'Comment' })                     // comment
	   *
	   * root.append('a {}')
	   * root.first.append('color: black; z-index: 1')
	   */;_proto.prepend=function prepend(){for(var _len2=arguments.length,children=new Array(_len2),_key2=0;_key2<_len2;_key2++){children[_key2]=arguments[_key2];}children=children.reverse();for(var _iterator2=_createForOfIteratorHelperLoose(children),_step2;!(_step2=_iterator2()).done;){var child=_step2.value;var nodes=this.normalize(child,this.first,'prepend').reverse();for(var _iterator3=_createForOfIteratorHelperLoose(nodes),_step3;!(_step3=_iterator3()).done;){var node=_step3.value;this.nodes.unshift(node);}for(var id in this.indexes){this.indexes[id]=this.indexes[id]+nodes.length;}}return this;};_proto.cleanRaws=function cleanRaws(keepBetween){_Node.prototype.cleanRaws.call(this,keepBetween);if(this.nodes){for(var _iterator4=_createForOfIteratorHelperLoose(this.nodes),_step4;!(_step4=_iterator4()).done;){var node=_step4.value;node.cleanRaws(keepBetween);}}}/**
	   * Insert new node before old node within the container.
	   *
	   * @param {Node|number} exist             Child or child’s index.
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * rule.insertBefore(decl, decl.clone({ prop: '-webkit-' + decl.prop }))
	   */;_proto.insertBefore=function insertBefore(exist,add){exist=this.index(exist);var type=exist===0?'prepend':false;var nodes=this.normalize(add,this.nodes[exist],type).reverse();for(var _iterator5=_createForOfIteratorHelperLoose(nodes),_step5;!(_step5=_iterator5()).done;){var node=_step5.value;this.nodes.splice(exist,0,node);}var index;for(var id in this.indexes){index=this.indexes[id];if(exist<=index){this.indexes[id]=index+nodes.length;}}return this;}/**
	   * Insert new node after old node within the container.
	   *
	   * @param {Node|number} exist             Child or child’s index.
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   */;_proto.insertAfter=function insertAfter(exist,add){exist=this.index(exist);var nodes=this.normalize(add,this.nodes[exist]).reverse();for(var _iterator6=_createForOfIteratorHelperLoose(nodes),_step6;!(_step6=_iterator6()).done;){var node=_step6.value;this.nodes.splice(exist+1,0,node);}var index;for(var id in this.indexes){index=this.indexes[id];if(exist<index){this.indexes[id]=index+nodes.length;}}return this;}/**
	   * Removes node from the container and cleans the parent properties
	   * from the node and its children.
	   *
	   * @param {Node|number} child Child or child’s index.
	   *
	   * @return {Node} This node for methods chain
	   *
	   * @example
	   * rule.nodes.length  //=> 5
	   * rule.removeChild(decl)
	   * rule.nodes.length  //=> 4
	   * decl.parent        //=> undefined
	   */;_proto.removeChild=function removeChild(child){child=this.index(child);this.nodes[child].parent=undefined;this.nodes.splice(child,1);var index;for(var id in this.indexes){index=this.indexes[id];if(index>=child){this.indexes[id]=index-1;}}return this;}/**
	   * Removes all children from the container
	   * and cleans their parent properties.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * rule.removeAll()
	   * rule.nodes.length //=> 0
	   */;_proto.removeAll=function removeAll(){for(var _iterator7=_createForOfIteratorHelperLoose(this.nodes),_step7;!(_step7=_iterator7()).done;){var node=_step7.value;node.parent=undefined;}this.nodes=[];return this;}/**
	   * Passes all declaration values within the container that match pattern
	   * through callback, replacing those values with the returned result
	   * of callback.
	   *
	   * This method is useful if you are using a custom unit or function
	   * and need to iterate through all values.
	   *
	   * @param {string|RegExp} pattern      Replace pattern.
	   * @param {object} opts                Options to speed up the search.
	   * @param {string|string[]} opts.props An array of property names.
	   * @param {string} opts.fast           String that’s used to narrow down
	   *                                     values and speed up the regexp search.
	   * @param {function|string} callback   String to replace pattern or callback
	   *                                     that returns a new value. The callback
	   *                                     will receive the same arguments
	   *                                     as those passed to a function parameter
	   *                                     of `String#replace`.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * root.replaceValues(/\d+rem/, { fast: 'rem' }, string => {
	   *   return 15 * parseInt(string) + 'px'
	   * })
	   */;_proto.replaceValues=function replaceValues(pattern,opts,callback){if(!callback){callback=opts;opts={};}this.walkDecls(function(decl){if(opts.props&&opts.props.indexOf(decl.prop)===-1)return;if(opts.fast&&decl.value.indexOf(opts.fast)===-1)return;decl.value=decl.value.replace(pattern,callback);});return this;}/**
	   * Returns `true` if callback returns `true`
	   * for all of the container’s children.
	   *
	   * @param {childCondition} condition Iterator returns true or false.
	   *
	   * @return {boolean} Is every child pass condition.
	   *
	   * @example
	   * const noPrefixes = rule.every(i => i.prop[0] !== '-')
	   */;_proto.every=function every(condition){return this.nodes.every(condition);}/**
	   * Returns `true` if callback returns `true` for (at least) one
	   * of the container’s children.
	   *
	   * @param {childCondition} condition Iterator returns true or false.
	   *
	   * @return {boolean} Is some child pass condition.
	   *
	   * @example
	   * const hasPrefix = rule.some(i => i.prop[0] === '-')
	   */;_proto.some=function some(condition){return this.nodes.some(condition);}/**
	   * Returns a `child`’s index within the {@link Container#nodes} array.
	   *
	   * @param {Node} child Child of the current container.
	   *
	   * @return {number} Child index.
	   *
	   * @example
	   * rule.index( rule.nodes[2] ) //=> 2
	   */;_proto.index=function index(child){if(typeof child==='number'){return child;}return this.nodes.indexOf(child);}/**
	   * The container’s first child.
	   *
	   * @type {Node}
	   *
	   * @example
	   * rule.first === rules.nodes[0]
	   */;_proto.normalize=function normalize(nodes,sample){var _this=this;if(typeof nodes==='string'){var parse=require('./parse');nodes=cleanSource(parse(nodes).nodes);}else if(Array.isArray(nodes)){nodes=nodes.slice(0);for(var _iterator8=_createForOfIteratorHelperLoose(nodes),_step8;!(_step8=_iterator8()).done;){var i=_step8.value;if(i.parent)i.parent.removeChild(i,'ignore');}}else if(nodes.type==='root'){nodes=nodes.nodes.slice(0);for(var _iterator9=_createForOfIteratorHelperLoose(nodes),_step9;!(_step9=_iterator9()).done;){var _i2=_step9.value;if(_i2.parent)_i2.parent.removeChild(_i2,'ignore');}}else if(nodes.type){nodes=[nodes];}else if(nodes.prop){if(typeof nodes.value==='undefined'){throw new Error('Value field is missed in node creation');}else if(typeof nodes.value!=='string'){nodes.value=String(nodes.value);}nodes=[new _declaration["default"](nodes)];}else if(nodes.selector){var Rule=require('./rule');nodes=[new Rule(nodes)];}else if(nodes.name){var AtRule=require('./at-rule');nodes=[new AtRule(nodes)];}else if(nodes.text){nodes=[new _comment["default"](nodes)];}else{throw new Error('Unknown node type in node creation');}var processed=nodes.map(function(i){if(i.parent)i.parent.removeChild(i);if(typeof i.raws.before==='undefined'){if(sample&&typeof sample.raws.before!=='undefined'){i.raws.before=sample.raws.before.replace(/[^\s]/g,'');}}i.parent=_this;return i;});return processed;}/**
	   * @memberof Container#
	   * @member {Node[]} nodes An array containing the container’s children.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black }')
	   * root.nodes.length           //=> 1
	   * root.nodes[0].selector      //=> 'a'
	   * root.nodes[0].nodes[0].prop //=> 'color'
	   */;_createClass(Container,[{key:"first",get:function get(){if(!this.nodes)return undefined;return this.nodes[0];}/**
	     * The container’s last child.
	     *
	     * @type {Node}
	     *
	     * @example
	     * rule.last === rule.nodes[rule.nodes.length - 1]
	     */},{key:"last",get:function get(){if(!this.nodes)return undefined;return this.nodes[this.nodes.length-1];}}]);return Container;}(_node["default"]);var _default=Container;/**
	 * @callback childCondition
	 * @param {Node} node    Container child.
	 * @param {number} index Child index.
	 * @param {Node[]} nodes All container children.
	 * @return {boolean}
	 */ /**
	 * @callback childIterator
	 * @param {Node} node    Container child.
	 * @param {number} index Child index.
	 * @return {false|undefined} Returning `false` will break iteration.
	 */exports["default"]=_default;module.exports=exports["default"];},{"./at-rule":169,"./comment":170,"./declaration":173,"./node":178,"./parse":179,"./rule":186}],172:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _supportsColor=_interopRequireDefault(require("supports-color"));var _chalk=_interopRequireDefault(require("chalk"));var _terminalHighlight=_interopRequireDefault(require("./terminal-highlight"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}function _wrapNativeSuper(Class){var _cache=typeof Map==="function"?new Map():undefined;_wrapNativeSuper=function _wrapNativeSuper(Class){if(Class===null||!_isNativeFunction(Class))return Class;if(typeof Class!=="function"){throw new TypeError("Super expression must either be null or a function");}if(typeof _cache!=="undefined"){if(_cache.has(Class))return _cache.get(Class);_cache.set(Class,Wrapper);}function Wrapper(){return _construct(Class,arguments,_getPrototypeOf(this).constructor);}Wrapper.prototype=Object.create(Class.prototype,{constructor:{value:Wrapper,enumerable:false,writable:true,configurable:true}});return _setPrototypeOf(Wrapper,Class);};return _wrapNativeSuper(Class);}function _construct(Parent,args,Class){if(_isNativeReflectConstruct()){_construct=Reflect.construct;}else{_construct=function _construct(Parent,args,Class){var a=[null];a.push.apply(a,args);var Constructor=Function.bind.apply(Parent,a);var instance=new Constructor();if(Class)_setPrototypeOf(instance,Class.prototype);return instance;};}return _construct.apply(null,arguments);}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Date.prototype.toString.call(Reflect.construct(Date,[],function(){}));return true;}catch(e){return false;}}function _isNativeFunction(fn){return Function.toString.call(fn).indexOf("[native code]")!==-1;}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/**
	 * The CSS parser throws this error for broken CSS.
	 *
	 * Custom parsers can throw this error for broken custom syntax using
	 * the {@link Node#error} method.
	 *
	 * PostCSS will use the input source map to detect the original error location.
	 * If you wrote a Sass file, compiled it to CSS and then parsed it with PostCSS,
	 * PostCSS will show the original position in the Sass file.
	 *
	 * If you need the position in the PostCSS input
	 * (e.g., to debug the previous compiler), use `error.input.file`.
	 *
	 * @example
	 * // Catching and checking syntax error
	 * try {
	 *   postcss.parse('a{')
	 * } catch (error) {
	 *   if (error.name === 'CssSyntaxError') {
	 *     error //=> CssSyntaxError
	 *   }
	 * }
	 *
	 * @example
	 * // Raising error from plugin
	 * throw node.error('Unknown variable', { plugin: 'postcss-vars' })
	 */var CssSyntaxError=/*#__PURE__*/function(_Error){_inheritsLoose(CssSyntaxError,_Error);/**
	   * @param {string} message  Error message.
	   * @param {number} [line]   Source line of the error.
	   * @param {number} [column] Source column of the error.
	   * @param {string} [source] Source code of the broken file.
	   * @param {string} [file]   Absolute path to the broken file.
	   * @param {string} [plugin] PostCSS plugin name, if error came from plugin.
	   */function CssSyntaxError(message,line,column,source,file,plugin){var _this;_this=_Error.call(this,message)||this;/**
	     * Always equal to `'CssSyntaxError'`. You should always check error type
	     * by `error.name === 'CssSyntaxError'`
	     * instead of `error instanceof CssSyntaxError`,
	     * because npm could have several PostCSS versions.
	     *
	     * @type {string}
	     *
	     * @example
	     * if (error.name === 'CssSyntaxError') {
	     *   error //=> CssSyntaxError
	     * }
	     */_this.name='CssSyntaxError';/**
	     * Error message.
	     *
	     * @type {string}
	     *
	     * @example
	     * error.message //=> 'Unclosed block'
	     */_this.reason=message;if(file){/**
	       * Absolute path to the broken file.
	       *
	       * @type {string}
	       *
	       * @example
	       * error.file       //=> 'a.sass'
	       * error.input.file //=> 'a.css'
	       */_this.file=file;}if(source){/**
	       * Source code of the broken file.
	       *
	       * @type {string}
	       *
	       * @example
	       * error.source       //=> 'a { b {} }'
	       * error.input.column //=> 'a b { }'
	       */_this.source=source;}if(plugin){/**
	       * Plugin name, if error came from plugin.
	       *
	       * @type {string}
	       *
	       * @example
	       * error.plugin //=> 'postcss-vars'
	       */_this.plugin=plugin;}if(typeof line!=='undefined'&&typeof column!=='undefined'){/**
	       * Source line of the error.
	       *
	       * @type {number}
	       *
	       * @example
	       * error.line       //=> 2
	       * error.input.line //=> 4
	       */_this.line=line;/**
	       * Source column of the error.
	       *
	       * @type {number}
	       *
	       * @example
	       * error.column       //=> 1
	       * error.input.column //=> 4
	       */_this.column=column;}_this.setMessage();if(Error.captureStackTrace){Error.captureStackTrace(_assertThisInitialized(_this),CssSyntaxError);}return _this;}var _proto=CssSyntaxError.prototype;_proto.setMessage=function setMessage(){/**
	     * Full error text in the GNU error format
	     * with plugin, file, line and column.
	     *
	     * @type {string}
	     *
	     * @example
	     * error.message //=> 'a.css:1:1: Unclosed block'
	     */this.message=this.plugin?this.plugin+': ':'';this.message+=this.file?this.file:'<css input>';if(typeof this.line!=='undefined'){this.message+=':'+this.line+':'+this.column;}this.message+=': '+this.reason;}/**
	   * Returns a few lines of CSS source that caused the error.
	   *
	   * If the CSS has an input source map without `sourceContent`,
	   * this method will return an empty string.
	   *
	   * @param {boolean} [color] Whether arrow will be colored red by terminal
	   *                          color codes. By default, PostCSS will detect
	   *                          color support by `process.stdout.isTTY`
	   *                          and `process.env.NODE_DISABLE_COLORS`.
	   *
	   * @example
	   * error.showSourceCode() //=> "  4 | }
	   *                        //      5 | a {
	   *                        //    > 6 |   bad
	   *                        //        |   ^
	   *                        //      7 | }
	   *                        //      8 | b {"
	   *
	   * @return {string} Few lines of CSS source that caused the error.
	   */;_proto.showSourceCode=function showSourceCode(color){var _this2=this;if(!this.source)return'';var css=this.source;if(_terminalHighlight["default"]){if(typeof color==='undefined')color=_supportsColor["default"].stdout;if(color)css=(0,_terminalHighlight["default"])(css);}var lines=css.split(/\r?\n/);var start=Math.max(this.line-3,0);var end=Math.min(this.line+2,lines.length);var maxWidth=String(end).length;function mark(text){if(color&&_chalk["default"].red){return _chalk["default"].red.bold(text);}return text;}function aside(text){if(color&&_chalk["default"].gray){return _chalk["default"].gray(text);}return text;}return lines.slice(start,end).map(function(line,index){var number=start+1+index;var gutter=' '+(' '+number).slice(-maxWidth)+' | ';if(number===_this2.line){var spacing=aside(gutter.replace(/\d/g,' '))+line.slice(0,_this2.column-1).replace(/[^\t]/g,' ');return mark('>')+aside(gutter)+line+'\n '+spacing+mark('^');}return' '+aside(gutter)+line;}).join('\n');}/**
	   * Returns error position, message and source code of the broken part.
	   *
	   * @example
	   * error.toString() //=> "CssSyntaxError: app.css:1:1: Unclosed block
	   *                  //    > 1 | a {
	   *                  //        | ^"
	   *
	   * @return {string} Error position, message and source code.
	   */;_proto.toString=function toString(){var code=this.showSourceCode();if(code){code='\n\n'+code+'\n';}return this.name+': '+this.message+code;}/**
	   * @memberof CssSyntaxError#
	   * @member {Input} input Input object with PostCSS internal information
	   *                       about input file. If input has source map
	   *                       from previous tool, PostCSS will use origin
	   *                       (for example, Sass) source. You can use this
	   *                       object to get PostCSS input source.
	   *
	   * @example
	   * error.input.file //=> 'a.css'
	   * error.file       //=> 'a.sass'
	   */;return CssSyntaxError;}(/*#__PURE__*/_wrapNativeSuper(Error));var _default=CssSyntaxError;exports["default"]=_default;module.exports=exports["default"];},{"./terminal-highlight":2,"chalk":2,"supports-color":2}],173:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _node=_interopRequireDefault(require("./node"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a CSS declaration.
	 *
	 * @extends Node
	 *
	 * @example
	 * const root = postcss.parse('a { color: black }')
	 * const decl = root.first.first
	 * decl.type       //=> 'decl'
	 * decl.toString() //=> ' color: black'
	 */var Declaration=/*#__PURE__*/function(_Node){_inheritsLoose(Declaration,_Node);function Declaration(defaults){var _this;_this=_Node.call(this,defaults)||this;_this.type='decl';return _this;}/**
	   * @memberof Declaration#
	   * @member {string} prop The declaration’s property name.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black }')
	   * const decl = root.first.first
	   * decl.prop //=> 'color'
	   */ /**
	   * @memberof Declaration#
	   * @member {string} value The declaration’s value.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black }')
	   * const decl = root.first.first
	   * decl.value //=> 'black'
	   */ /**
	   * @memberof Declaration#
	   * @member {boolean} important `true` if the declaration
	   *                             has an !important annotation.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black !important; color: red }')
	   * root.first.first.important //=> true
	   * root.first.last.important  //=> undefined
	   */ /**
	   * @memberof Declaration#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node. It also stores `*`
	   *   and `_` symbols before the declaration (IE hack).
	   * * `between`: the symbols between the property and value
	   *   for declarations.
	   * * `important`: the content of the important statement,
	   *   if it is not just `!important`.
	   *
	   * PostCSS cleans declaration from comments and extra spaces,
	   * but it stores origin content in raws properties.
	   * As such, if you don’t change a declaration’s value,
	   * PostCSS will use the raw value with comments.
	   *
	   * @example
	   * const root = postcss.parse('a {\n  color:black\n}')
	   * root.first.first.raws //=> { before: '\n  ', between: ':' }
	   */return Declaration;}(_node["default"]);var _default=Declaration;exports["default"]=_default;module.exports=exports["default"];},{"./node":178}],174:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _path=_interopRequireDefault(require("path"));var _cssSyntaxError=_interopRequireDefault(require("./css-syntax-error"));var _previousMap=_interopRequireDefault(require("./previous-map"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}var sequence=0;/**
	 * Represents the source CSS.
	 *
	 * @example
	 * const root  = postcss.parse(css, { from: file })
	 * const input = root.source.input
	 */var Input=/*#__PURE__*/function(){/**
	   * @param {string} css    Input CSS source.
	   * @param {object} [opts] {@link Processor#process} options.
	   */function Input(css,opts){if(opts===void 0){opts={};}if(css===null||typeof css==='undefined'||_typeof(css)==='object'&&!css.toString){throw new Error("PostCSS received "+css+" instead of CSS string");}/**
	     * Input CSS source
	     *
	     * @type {string}
	     *
	     * @example
	     * const input = postcss.parse('a{}', { from: file }).input
	     * input.css //=> "a{}"
	     */this.css=css.toString();if(this.css[0]==="\uFEFF"||this.css[0]==="\uFFFE"){this.hasBOM=true;this.css=this.css.slice(1);}else{this.hasBOM=false;}if(opts.from){if(/^\w+:\/\//.test(opts.from)||_path["default"].isAbsolute(opts.from)){/**
	         * The absolute path to the CSS source file defined
	         * with the `from` option.
	         *
	         * @type {string}
	         *
	         * @example
	         * const root = postcss.parse(css, { from: 'a.css' })
	         * root.source.input.file //=> '/home/ai/a.css'
	         */this.file=opts.from;}else{this.file=_path["default"].resolve(opts.from);}}var map=new _previousMap["default"](this.css,opts);if(map.text){/**
	       * The input source map passed from a compilation step before PostCSS
	       * (for example, from Sass compiler).
	       *
	       * @type {PreviousMap}
	       *
	       * @example
	       * root.source.input.map.consumer().sources //=> ['a.sass']
	       */this.map=map;var file=map.consumer().file;if(!this.file&&file)this.file=this.mapResolve(file);}if(!this.file){sequence+=1;/**
	       * The unique ID of the CSS source. It will be created if `from` option
	       * is not provided (because PostCSS does not know the file path).
	       *
	       * @type {string}
	       *
	       * @example
	       * const root = postcss.parse(css)
	       * root.source.input.file //=> undefined
	       * root.source.input.id   //=> "<input css 1>"
	       */this.id='<input css '+sequence+'>';}if(this.map)this.map.file=this.from;}var _proto=Input.prototype;_proto.error=function error(message,line,column,opts){if(opts===void 0){opts={};}var result;var origin=this.origin(line,column);if(origin){result=new _cssSyntaxError["default"](message,origin.line,origin.column,origin.source,origin.file,opts.plugin);}else{result=new _cssSyntaxError["default"](message,line,column,this.css,this.file,opts.plugin);}result.input={line:line,column:column,source:this.css};if(this.file)result.input.file=this.file;return result;}/**
	   * Reads the input source map and returns a symbol position
	   * in the input source (e.g., in a Sass file that was compiled
	   * to CSS before being passed to PostCSS).
	   *
	   * @param {number} line   Line in input CSS.
	   * @param {number} column Column in input CSS.
	   *
	   * @return {filePosition} Position in input source.
	   *
	   * @example
	   * root.source.input.origin(1, 1) //=> { file: 'a.css', line: 3, column: 1 }
	   */;_proto.origin=function origin(line,column){if(!this.map)return false;var consumer=this.map.consumer();var from=consumer.originalPositionFor({line:line,column:column});if(!from.source)return false;var result={file:this.mapResolve(from.source),line:from.line,column:from.column};var source=consumer.sourceContentFor(from.source);if(source)result.source=source;return result;};_proto.mapResolve=function mapResolve(file){if(/^\w+:\/\//.test(file)){return file;}return _path["default"].resolve(this.map.consumer().sourceRoot||'.',file);}/**
	   * The CSS source identifier. Contains {@link Input#file} if the user
	   * set the `from` option, or {@link Input#id} if they did not.
	   *
	   * @type {string}
	   *
	   * @example
	   * const root = postcss.parse(css, { from: 'a.css' })
	   * root.source.input.from //=> "/home/ai/a.css"
	   *
	   * const root = postcss.parse(css)
	   * root.source.input.from //=> "<input css 1>"
	   */;_createClass(Input,[{key:"from",get:function get(){return this.file||this.id;}}]);return Input;}();var _default=Input;/**
	 * @typedef  {object} filePosition
	 * @property {string} file   Path to file.
	 * @property {number} line   Source line in file.
	 * @property {number} column Source column in file.
	 */exports["default"]=_default;module.exports=exports["default"];},{"./css-syntax-error":172,"./previous-map":182,"path":168}],175:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _mapGenerator=_interopRequireDefault(require("./map-generator"));var _stringify2=_interopRequireDefault(require("./stringify"));var _warnOnce=_interopRequireDefault(require("./warn-once"));var _result=_interopRequireDefault(require("./result"));var _parse=_interopRequireDefault(require("./parse"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function isPromise(obj){return _typeof(obj)==='object'&&typeof obj.then==='function';}/**
	 * A Promise proxy for the result of PostCSS transformations.
	 *
	 * A `LazyResult` instance is returned by {@link Processor#process}.
	 *
	 * @example
	 * const lazy = postcss([autoprefixer]).process(css)
	 */var LazyResult=/*#__PURE__*/function(){function LazyResult(processor,css,opts){this.stringified=false;this.processed=false;var root;if(_typeof(css)==='object'&&css!==null&&css.type==='root'){root=css;}else if(css instanceof LazyResult||css instanceof _result["default"]){root=css.root;if(css.map){if(typeof opts.map==='undefined')opts.map={};if(!opts.map.inline)opts.map.inline=false;opts.map.prev=css.map;}}else{var parser=_parse["default"];if(opts.syntax)parser=opts.syntax.parse;if(opts.parser)parser=opts.parser;if(parser.parse)parser=parser.parse;try{root=parser(css,opts);}catch(error){this.error=error;}}this.result=new _result["default"](processor,root,opts);}/**
	   * Returns a {@link Processor} instance, which will be used
	   * for CSS transformations.
	   *
	   * @type {Processor}
	   */var _proto=LazyResult.prototype;/**
	   * Processes input CSS through synchronous plugins
	   * and calls {@link Result#warnings()}.
	   *
	   * @return {Warning[]} Warnings from plugins.
	   */_proto.warnings=function warnings(){return this.sync().warnings();}/**
	   * Alias for the {@link LazyResult#css} property.
	   *
	   * @example
	   * lazy + '' === lazy.css
	   *
	   * @return {string} Output CSS.
	   */;_proto.toString=function toString(){return this.css;}/**
	   * Processes input CSS through synchronous and asynchronous plugins
	   * and calls `onFulfilled` with a Result instance. If a plugin throws
	   * an error, the `onRejected` callback will be executed.
	   *
	   * It implements standard Promise API.
	   *
	   * @param {onFulfilled} onFulfilled Callback will be executed
	   *                                  when all plugins will finish work.
	   * @param {onRejected}  onRejected  Callback will be executed on any error.
	   *
	   * @return {Promise} Promise API to make queue.
	   *
	   * @example
	   * postcss([autoprefixer]).process(css, { from: cssPath }).then(result => {
	   *   console.log(result.css)
	   * })
	   */;_proto.then=function then(onFulfilled,onRejected){if(process.env.NODE_ENV!=='production'){if(!('from'in this.opts)){(0,_warnOnce["default"])('Without `from` option PostCSS could generate wrong source map '+'and will not find Browserslist config. Set it to CSS file path '+'or to `undefined` to prevent this warning.');}}return this.async().then(onFulfilled,onRejected);}/**
	   * Processes input CSS through synchronous and asynchronous plugins
	   * and calls onRejected for each error thrown in any plugin.
	   *
	   * It implements standard Promise API.
	   *
	   * @param {onRejected} onRejected Callback will be executed on any error.
	   *
	   * @return {Promise} Promise API to make queue.
	   *
	   * @example
	   * postcss([autoprefixer]).process(css).then(result => {
	   *   console.log(result.css)
	   * }).catch(error => {
	   *   console.error(error)
	   * })
	   */;_proto["catch"]=function _catch(onRejected){return this.async()["catch"](onRejected);}/**
	   * Processes input CSS through synchronous and asynchronous plugins
	   * and calls onFinally on any error or when all plugins will finish work.
	   *
	   * It implements standard Promise API.
	   *
	   * @param {onFinally} onFinally Callback will be executed on any error or
	   *                              when all plugins will finish work.
	   *
	   * @return {Promise} Promise API to make queue.
	   *
	   * @example
	   * postcss([autoprefixer]).process(css).finally(() => {
	   *   console.log('processing ended')
	   * })
	   */;_proto["finally"]=function _finally(onFinally){return this.async().then(onFinally,onFinally);};_proto.handleError=function handleError(error,plugin){try{this.error=error;if(error.name==='CssSyntaxError'&&!error.plugin){error.plugin=plugin.postcssPlugin;error.setMessage();}else if(plugin.postcssVersion){if(process.env.NODE_ENV!=='production'){var pluginName=plugin.postcssPlugin;var pluginVer=plugin.postcssVersion;var runtimeVer=this.result.processor.version;var a=pluginVer.split('.');var b=runtimeVer.split('.');if(a[0]!==b[0]||parseInt(a[1])>parseInt(b[1])){console.error('Unknown error from PostCSS plugin. Your current PostCSS '+'version is '+runtimeVer+', but '+pluginName+' uses '+pluginVer+'. Perhaps this is the source of the error below.');}}}}catch(err){if(console&&console.error)console.error(err);}};_proto.asyncTick=function asyncTick(resolve,reject){var _this=this;if(this.plugin>=this.processor.plugins.length){this.processed=true;return resolve();}try{var plugin=this.processor.plugins[this.plugin];var promise=this.run(plugin);this.plugin+=1;if(isPromise(promise)){promise.then(function(){_this.asyncTick(resolve,reject);})["catch"](function(error){_this.handleError(error,plugin);_this.processed=true;reject(error);});}else{this.asyncTick(resolve,reject);}}catch(error){this.processed=true;reject(error);}};_proto.async=function async(){var _this2=this;if(this.processed){return new Promise(function(resolve,reject){if(_this2.error){reject(_this2.error);}else{resolve(_this2.stringify());}});}if(this.processing){return this.processing;}this.processing=new Promise(function(resolve,reject){if(_this2.error)return reject(_this2.error);_this2.plugin=0;_this2.asyncTick(resolve,reject);}).then(function(){_this2.processed=true;return _this2.stringify();});return this.processing;};_proto.sync=function sync(){if(this.processed)return this.result;this.processed=true;if(this.processing){throw new Error('Use process(css).then(cb) to work with async plugins');}if(this.error)throw this.error;for(var _iterator=_createForOfIteratorHelperLoose(this.result.processor.plugins),_step;!(_step=_iterator()).done;){var plugin=_step.value;var promise=this.run(plugin);if(isPromise(promise)){throw new Error('Use process(css).then(cb) to work with async plugins');}}return this.result;};_proto.run=function run(plugin){this.result.lastPlugin=plugin;try{return plugin(this.result.root,this.result);}catch(error){this.handleError(error,plugin);throw error;}};_proto.stringify=function stringify(){if(this.stringified)return this.result;this.stringified=true;this.sync();var opts=this.result.opts;var str=_stringify2["default"];if(opts.syntax)str=opts.syntax.stringify;if(opts.stringifier)str=opts.stringifier;if(str.stringify)str=str.stringify;var map=new _mapGenerator["default"](str,this.result.root,this.result.opts);var data=map.generate();this.result.css=data[0];this.result.map=data[1];return this.result;};_createClass(LazyResult,[{key:"processor",get:function get(){return this.result.processor;}/**
	     * Options from the {@link Processor#process} call.
	     *
	     * @type {processOptions}
	     */},{key:"opts",get:function get(){return this.result.opts;}/**
	     * Processes input CSS through synchronous plugins, converts `Root`
	     * to a CSS string and returns {@link Result#css}.
	     *
	     * This property will only work with synchronous plugins.
	     * If the processor contains any asynchronous plugins
	     * it will throw an error. This is why this method is only
	     * for debug purpose, you should always use {@link LazyResult#then}.
	     *
	     * @type {string}
	     * @see Result#css
	     */},{key:"css",get:function get(){return this.stringify().css;}/**
	     * An alias for the `css` property. Use it with syntaxes
	     * that generate non-CSS output.
	     *
	     * This property will only work with synchronous plugins.
	     * If the processor contains any asynchronous plugins
	     * it will throw an error. This is why this method is only
	     * for debug purpose, you should always use {@link LazyResult#then}.
	     *
	     * @type {string}
	     * @see Result#content
	     */},{key:"content",get:function get(){return this.stringify().content;}/**
	     * Processes input CSS through synchronous plugins
	     * and returns {@link Result#map}.
	     *
	     * This property will only work with synchronous plugins.
	     * If the processor contains any asynchronous plugins
	     * it will throw an error. This is why this method is only
	     * for debug purpose, you should always use {@link LazyResult#then}.
	     *
	     * @type {SourceMapGenerator}
	     * @see Result#map
	     */},{key:"map",get:function get(){return this.stringify().map;}/**
	     * Processes input CSS through synchronous plugins
	     * and returns {@link Result#root}.
	     *
	     * This property will only work with synchronous plugins. If the processor
	     * contains any asynchronous plugins it will throw an error.
	     *
	     * This is why this method is only for debug purpose,
	     * you should always use {@link LazyResult#then}.
	     *
	     * @type {Root}
	     * @see Result#root
	     */},{key:"root",get:function get(){return this.sync().root;}/**
	     * Processes input CSS through synchronous plugins
	     * and returns {@link Result#messages}.
	     *
	     * This property will only work with synchronous plugins. If the processor
	     * contains any asynchronous plugins it will throw an error.
	     *
	     * This is why this method is only for debug purpose,
	     * you should always use {@link LazyResult#then}.
	     *
	     * @type {Message[]}
	     * @see Result#messages
	     */},{key:"messages",get:function get(){return this.sync().messages;}}]);return LazyResult;}();var _default=LazyResult;/**
	 * @callback onFulfilled
	 * @param {Result} result
	 */ /**
	 * @callback onRejected
	 * @param {Error} error
	 */exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./map-generator":177,"./parse":179,"./result":184,"./stringify":188,"./warn-once":191,"_process":193}],176:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;/**
	 * Contains helpers for safely splitting lists of CSS values,
	 * preserving parentheses and quotes.
	 *
	 * @example
	 * const list = postcss.list
	 *
	 * @namespace list
	 */var list={split:function split(string,separators,last){var array=[];var current='';var split=false;var func=0;var quote=false;var escape=false;for(var i=0;i<string.length;i++){var letter=string[i];if(quote){if(escape){escape=false;}else if(letter==='\\'){escape=true;}else if(letter===quote){quote=false;}}else if(letter==='"'||letter==='\''){quote=letter;}else if(letter==='('){func+=1;}else if(letter===')'){if(func>0)func-=1;}else if(func===0){if(separators.indexOf(letter)!==-1)split=true;}if(split){if(current!=='')array.push(current.trim());current='';split=false;}else{current+=letter;}}if(last||current!=='')array.push(current.trim());return array;},/**
	   * Safely splits space-separated values (such as those for `background`,
	   * `border-radius`, and other shorthand properties).
	   *
	   * @param {string} string Space-separated values.
	   *
	   * @return {string[]} Split values.
	   *
	   * @example
	   * postcss.list.space('1px calc(10% + 1px)') //=> ['1px', 'calc(10% + 1px)']
	   */space:function space(string){var spaces=[' ','\n','\t'];return list.split(string,spaces);},/**
	   * Safely splits comma-separated values (such as those for `transition-*`
	   * and `background` properties).
	   *
	   * @param {string} string Comma-separated values.
	   *
	   * @return {string[]} Split values.
	   *
	   * @example
	   * postcss.list.comma('black, linear-gradient(white, black)')
	   * //=> ['black', 'linear-gradient(white, black)']
	   */comma:function comma(string){return list.split(string,[','],true);}};var _default=list;exports["default"]=_default;module.exports=exports["default"];},{}],177:[function(require,module,exports){(function(Buffer){"use strict";exports.__esModule=true;exports["default"]=void 0;var _sourceMap=_interopRequireDefault(require("source-map"));var _path=_interopRequireDefault(require("path"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}var MapGenerator=/*#__PURE__*/function(){function MapGenerator(stringify,root,opts){this.stringify=stringify;this.mapOpts=opts.map||{};this.root=root;this.opts=opts;}var _proto=MapGenerator.prototype;_proto.isMap=function isMap(){if(typeof this.opts.map!=='undefined'){return!!this.opts.map;}return this.previous().length>0;};_proto.previous=function previous(){var _this=this;if(!this.previousMaps){this.previousMaps=[];this.root.walk(function(node){if(node.source&&node.source.input.map){var map=node.source.input.map;if(_this.previousMaps.indexOf(map)===-1){_this.previousMaps.push(map);}}});}return this.previousMaps;};_proto.isInline=function isInline(){if(typeof this.mapOpts.inline!=='undefined'){return this.mapOpts.inline;}var annotation=this.mapOpts.annotation;if(typeof annotation!=='undefined'&&annotation!==true){return false;}if(this.previous().length){return this.previous().some(function(i){return i.inline;});}return true;};_proto.isSourcesContent=function isSourcesContent(){if(typeof this.mapOpts.sourcesContent!=='undefined'){return this.mapOpts.sourcesContent;}if(this.previous().length){return this.previous().some(function(i){return i.withContent();});}return true;};_proto.clearAnnotation=function clearAnnotation(){if(this.mapOpts.annotation===false)return;var node;for(var i=this.root.nodes.length-1;i>=0;i--){node=this.root.nodes[i];if(node.type!=='comment')continue;if(node.text.indexOf('# sourceMappingURL=')===0){this.root.removeChild(i);}}};_proto.setSourcesContent=function setSourcesContent(){var _this2=this;var already={};this.root.walk(function(node){if(node.source){var from=node.source.input.from;if(from&&!already[from]){already[from]=true;var relative=_this2.relative(from);_this2.map.setSourceContent(relative,node.source.input.css);}}});};_proto.applyPrevMaps=function applyPrevMaps(){for(var _iterator=_createForOfIteratorHelperLoose(this.previous()),_step;!(_step=_iterator()).done;){var prev=_step.value;var from=this.relative(prev.file);var root=prev.root||_path["default"].dirname(prev.file);var map=void 0;if(this.mapOpts.sourcesContent===false){map=new _sourceMap["default"].SourceMapConsumer(prev.text);if(map.sourcesContent){map.sourcesContent=map.sourcesContent.map(function(){return null;});}}else{map=prev.consumer();}this.map.applySourceMap(map,from,this.relative(root));}};_proto.isAnnotation=function isAnnotation(){if(this.isInline()){return true;}if(typeof this.mapOpts.annotation!=='undefined'){return this.mapOpts.annotation;}if(this.previous().length){return this.previous().some(function(i){return i.annotation;});}return true;};_proto.toBase64=function toBase64(str){if(Buffer){return Buffer.from(str).toString('base64');}return window.btoa(unescape(encodeURIComponent(str)));};_proto.addAnnotation=function addAnnotation(){var content;if(this.isInline()){content='data:application/json;base64,'+this.toBase64(this.map.toString());}else if(typeof this.mapOpts.annotation==='string'){content=this.mapOpts.annotation;}else{content=this.outputFile()+'.map';}var eol='\n';if(this.css.indexOf('\r\n')!==-1)eol='\r\n';this.css+=eol+'/*# sourceMappingURL='+content+' */';};_proto.outputFile=function outputFile(){if(this.opts.to){return this.relative(this.opts.to);}if(this.opts.from){return this.relative(this.opts.from);}return'to.css';};_proto.generateMap=function generateMap(){this.generateString();if(this.isSourcesContent())this.setSourcesContent();if(this.previous().length>0)this.applyPrevMaps();if(this.isAnnotation())this.addAnnotation();if(this.isInline()){return[this.css];}return[this.css,this.map];};_proto.relative=function relative(file){if(file.indexOf('<')===0)return file;if(/^\w+:\/\//.test(file))return file;var from=this.opts.to?_path["default"].dirname(this.opts.to):'.';if(typeof this.mapOpts.annotation==='string'){from=_path["default"].dirname(_path["default"].resolve(from,this.mapOpts.annotation));}file=_path["default"].relative(from,file);if(_path["default"].sep==='\\'){return file.replace(/\\/g,'/');}return file;};_proto.sourcePath=function sourcePath(node){if(this.mapOpts.from){return this.mapOpts.from;}return this.relative(node.source.input.from);};_proto.generateString=function generateString(){var _this3=this;this.css='';this.map=new _sourceMap["default"].SourceMapGenerator({file:this.outputFile()});var line=1;var column=1;var lines,last;this.stringify(this.root,function(str,node,type){_this3.css+=str;if(node&&type!=='end'){if(node.source&&node.source.start){_this3.map.addMapping({source:_this3.sourcePath(node),generated:{line:line,column:column-1},original:{line:node.source.start.line,column:node.source.start.column-1}});}else{_this3.map.addMapping({source:'<no source>',original:{line:1,column:0},generated:{line:line,column:column-1}});}}lines=str.match(/\n/g);if(lines){line+=lines.length;last=str.lastIndexOf('\n');column=str.length-last;}else{column+=str.length;}if(node&&type!=='start'){var p=node.parent||{raws:{}};if(node.type!=='decl'||node!==p.last||p.raws.semicolon){if(node.source&&node.source.end){_this3.map.addMapping({source:_this3.sourcePath(node),generated:{line:line,column:column-2},original:{line:node.source.end.line,column:node.source.end.column-1}});}else{_this3.map.addMapping({source:'<no source>',original:{line:1,column:0},generated:{line:line,column:column-1}});}}}});};_proto.generate=function generate(){this.clearAnnotation();if(this.isMap()){return this.generateMap();}var result='';this.stringify(this.root,function(i){result+=i;});return[result];};return MapGenerator;}();var _default=MapGenerator;exports["default"]=_default;module.exports=exports["default"];}).call(this,require("buffer").Buffer);},{"buffer":3,"path":168,"source-map":208}],178:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _cssSyntaxError=_interopRequireDefault(require("./css-syntax-error"));var _stringifier=_interopRequireDefault(require("./stringifier"));var _stringify=_interopRequireDefault(require("./stringify"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function cloneNode(obj,parent){var cloned=new obj.constructor();for(var i in obj){if(!obj.hasOwnProperty(i))continue;var value=obj[i];var type=_typeof(value);if(i==='parent'&&type==='object'){if(parent)cloned[i]=parent;}else if(i==='source'){cloned[i]=value;}else if(value instanceof Array){cloned[i]=value.map(function(j){return cloneNode(j,cloned);});}else{if(type==='object'&&value!==null)value=cloneNode(value);cloned[i]=value;}}return cloned;}/**
	 * All node classes inherit the following common methods.
	 *
	 * @abstract
	 */var Node=/*#__PURE__*/function(){/**
	   * @param {object} [defaults] Value for node properties.
	   */function Node(defaults){if(defaults===void 0){defaults={};}this.raws={};if(process.env.NODE_ENV!=='production'){if(_typeof(defaults)!=='object'&&typeof defaults!=='undefined'){throw new Error('PostCSS nodes constructor accepts object, not '+JSON.stringify(defaults));}}for(var name in defaults){this[name]=defaults[name];}}/**
	   * Returns a `CssSyntaxError` instance containing the original position
	   * of the node in the source, showing line and column numbers and also
	   * a small excerpt to facilitate debugging.
	   *
	   * If present, an input source map will be used to get the original position
	   * of the source, even from a previous compilation step
	   * (e.g., from Sass compilation).
	   *
	   * This method produces very useful error messages.
	   *
	   * @param {string} message     Error description.
	   * @param {object} [opts]      Options.
	   * @param {string} opts.plugin Plugin name that created this error.
	   *                             PostCSS will set it automatically.
	   * @param {string} opts.word   A word inside a node’s string that should
	   *                             be highlighted as the source of the error.
	   * @param {number} opts.index  An index inside a node’s string that should
	   *                             be highlighted as the source of the error.
	   *
	   * @return {CssSyntaxError} Error object to throw it.
	   *
	   * @example
	   * if (!variables[name]) {
	   *   throw decl.error('Unknown variable ' + name, { word: name })
	   *   // CssSyntaxError: postcss-vars:a.sass:4:3: Unknown variable $black
	   *   //   color: $black
	   *   // a
	   *   //          ^
	   *   //   background: white
	   * }
	   */var _proto=Node.prototype;_proto.error=function error(message,opts){if(opts===void 0){opts={};}if(this.source){var pos=this.positionBy(opts);return this.source.input.error(message,pos.line,pos.column,opts);}return new _cssSyntaxError["default"](message);}/**
	   * This method is provided as a convenience wrapper for {@link Result#warn}.
	   *
	   * @param {Result} result      The {@link Result} instance
	   *                             that will receive the warning.
	   * @param {string} text        Warning message.
	   * @param {object} [opts]      Options
	   * @param {string} opts.plugin Plugin name that created this warning.
	   *                             PostCSS will set it automatically.
	   * @param {string} opts.word   A word inside a node’s string that should
	   *                             be highlighted as the source of the warning.
	   * @param {number} opts.index  An index inside a node’s string that should
	   *                             be highlighted as the source of the warning.
	   *
	   * @return {Warning} Created warning object.
	   *
	   * @example
	   * const plugin = postcss.plugin('postcss-deprecated', () => {
	   *   return (root, result) => {
	   *     root.walkDecls('bad', decl => {
	   *       decl.warn(result, 'Deprecated property bad')
	   *     })
	   *   }
	   * })
	   */;_proto.warn=function warn(result,text,opts){var data={node:this};for(var i in opts){data[i]=opts[i];}return result.warn(text,data);}/**
	   * Removes the node from its parent and cleans the parent properties
	   * from the node and its children.
	   *
	   * @example
	   * if (decl.prop.match(/^-webkit-/)) {
	   *   decl.remove()
	   * }
	   *
	   * @return {Node} Node to make calls chain.
	   */;_proto.remove=function remove(){if(this.parent){this.parent.removeChild(this);}this.parent=undefined;return this;}/**
	   * Returns a CSS string representing the node.
	   *
	   * @param {stringifier|syntax} [stringifier] A syntax to use
	   *                                           in string generation.
	   *
	   * @return {string} CSS string of this node.
	   *
	   * @example
	   * postcss.rule({ selector: 'a' }).toString() //=> "a {}"
	   */;_proto.toString=function toString(stringifier){if(stringifier===void 0){stringifier=_stringify["default"];}if(stringifier.stringify)stringifier=stringifier.stringify;var result='';stringifier(this,function(i){result+=i;});return result;}/**
	   * Returns an exact clone of the node.
	   *
	   * The resulting cloned node and its (cloned) children will retain
	   * code style properties.
	   *
	   * @param {object} [overrides] New properties to override in the clone.
	   *
	   * @example
	   * decl.raws.before    //=> "\n  "
	   * const cloned = decl.clone({ prop: '-moz-' + decl.prop })
	   * cloned.raws.before  //=> "\n  "
	   * cloned.toString()   //=> -moz-transform: scale(0)
	   *
	   * @return {Node} Clone of the node.
	   */;_proto.clone=function clone(overrides){if(overrides===void 0){overrides={};}var cloned=cloneNode(this);for(var name in overrides){cloned[name]=overrides[name];}return cloned;}/**
	   * Shortcut to clone the node and insert the resulting cloned node
	   * before the current node.
	   *
	   * @param {object} [overrides] Mew properties to override in the clone.
	   *
	   * @example
	   * decl.cloneBefore({ prop: '-moz-' + decl.prop })
	   *
	   * @return {Node} New node
	   */;_proto.cloneBefore=function cloneBefore(overrides){if(overrides===void 0){overrides={};}var cloned=this.clone(overrides);this.parent.insertBefore(this,cloned);return cloned;}/**
	   * Shortcut to clone the node and insert the resulting cloned node
	   * after the current node.
	   *
	   * @param {object} [overrides] New properties to override in the clone.
	   *
	   * @return {Node} New node.
	   */;_proto.cloneAfter=function cloneAfter(overrides){if(overrides===void 0){overrides={};}var cloned=this.clone(overrides);this.parent.insertAfter(this,cloned);return cloned;}/**
	   * Inserts node(s) before the current node and removes the current node.
	   *
	   * @param {...Node} nodes Mode(s) to replace current one.
	   *
	   * @example
	   * if (atrule.name === 'mixin') {
	   *   atrule.replaceWith(mixinRules[atrule.params])
	   * }
	   *
	   * @return {Node} Current node to methods chain.
	   */;_proto.replaceWith=function replaceWith(){if(this.parent){for(var _len=arguments.length,nodes=new Array(_len),_key=0;_key<_len;_key++){nodes[_key]=arguments[_key];}for(var _i=0,_nodes=nodes;_i<_nodes.length;_i++){var node=_nodes[_i];this.parent.insertBefore(this,node);}this.remove();}return this;}/**
	   * Returns the next child of the node’s parent.
	   * Returns `undefined` if the current node is the last child.
	   *
	   * @return {Node|undefined} Next node.
	   *
	   * @example
	   * if (comment.text === 'delete next') {
	   *   const next = comment.next()
	   *   if (next) {
	   *     next.remove()
	   *   }
	   * }
	   */;_proto.next=function next(){if(!this.parent)return undefined;var index=this.parent.index(this);return this.parent.nodes[index+1];}/**
	   * Returns the previous child of the node’s parent.
	   * Returns `undefined` if the current node is the first child.
	   *
	   * @return {Node|undefined} Previous node.
	   *
	   * @example
	   * const annotation = decl.prev()
	   * if (annotation.type === 'comment') {
	   *   readAnnotation(annotation.text)
	   * }
	   */;_proto.prev=function prev(){if(!this.parent)return undefined;var index=this.parent.index(this);return this.parent.nodes[index-1];}/**
	   * Insert new node before current node to current node’s parent.
	   *
	   * Just alias for `node.parent.insertBefore(node, add)`.
	   *
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * decl.before('content: ""')
	   */;_proto.before=function before(add){this.parent.insertBefore(this,add);return this;}/**
	   * Insert new node after current node to current node’s parent.
	   *
	   * Just alias for `node.parent.insertAfter(node, add)`.
	   *
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * decl.after('color: black')
	   */;_proto.after=function after(add){this.parent.insertAfter(this,add);return this;};_proto.toJSON=function toJSON(){var fixed={};for(var name in this){if(!this.hasOwnProperty(name))continue;if(name==='parent')continue;var value=this[name];if(value instanceof Array){fixed[name]=value.map(function(i){if(_typeof(i)==='object'&&i.toJSON){return i.toJSON();}else{return i;}});}else if(_typeof(value)==='object'&&value.toJSON){fixed[name]=value.toJSON();}else{fixed[name]=value;}}return fixed;}/**
	   * Returns a {@link Node#raws} value. If the node is missing
	   * the code style property (because the node was manually built or cloned),
	   * PostCSS will try to autodetect the code style property by looking
	   * at other nodes in the tree.
	   *
	   * @param {string} prop          Name of code style property.
	   * @param {string} [defaultType] Name of default value, it can be missed
	   *                               if the value is the same as prop.
	   *
	   * @example
	   * const root = postcss.parse('a { background: white }')
	   * root.nodes[0].append({ prop: 'color', value: 'black' })
	   * root.nodes[0].nodes[1].raws.before   //=> undefined
	   * root.nodes[0].nodes[1].raw('before') //=> ' '
	   *
	   * @return {string} Code style value.
	   */;_proto.raw=function raw(prop,defaultType){var str=new _stringifier["default"]();return str.raw(this,prop,defaultType);}/**
	   * Finds the Root instance of the node’s tree.
	   *
	   * @example
	   * root.nodes[0].nodes[0].root() === root
	   *
	   * @return {Root} Root parent.
	   */;_proto.root=function root(){var result=this;while(result.parent){result=result.parent;}return result;}/**
	   * Clear the code style properties for the node and its children.
	   *
	   * @param {boolean} [keepBetween] Keep the raws.between symbols.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * node.raws.before  //=> ' '
	   * node.cleanRaws()
	   * node.raws.before  //=> undefined
	   */;_proto.cleanRaws=function cleanRaws(keepBetween){delete this.raws.before;delete this.raws.after;if(!keepBetween)delete this.raws.between;};_proto.positionInside=function positionInside(index){var string=this.toString();var column=this.source.start.column;var line=this.source.start.line;for(var i=0;i<index;i++){if(string[i]==='\n'){column=1;line+=1;}else{column+=1;}}return{line:line,column:column};};_proto.positionBy=function positionBy(opts){var pos=this.source.start;if(opts.index){pos=this.positionInside(opts.index);}else if(opts.word){var index=this.toString().indexOf(opts.word);if(index!==-1)pos=this.positionInside(index);}return pos;}/**
	   * @memberof Node#
	   * @member {string} type String representing the node’s type.
	   *                       Possible values are `root`, `atrule`, `rule`,
	   *                       `decl`, or `comment`.
	   *
	   * @example
	   * postcss.decl({ prop: 'color', value: 'black' }).type //=> 'decl'
	   */ /**
	   * @memberof Node#
	   * @member {Container} parent The node’s parent node.
	   *
	   * @example
	   * root.nodes[0].parent === root
	   */ /**
	   * @memberof Node#
	   * @member {source} source The input source of the node.
	   *
	   * The property is used in source map generation.
	   *
	   * If you create a node manually (e.g., with `postcss.decl()`),
	   * that node will not have a `source` property and will be absent
	   * from the source map. For this reason, the plugin developer should
	   * consider cloning nodes to create new ones (in which case the new node’s
	   * source will reference the original, cloned node) or setting
	   * the `source` property manually.
	   *
	   * ```js
	   * // Bad
	   * const prefixed = postcss.decl({
	   *   prop: '-moz-' + decl.prop,
	   *   value: decl.value
	   * })
	   *
	   * // Good
	   * const prefixed = decl.clone({ prop: '-moz-' + decl.prop })
	   * ```
	   *
	   * ```js
	   * if (atrule.name === 'add-link') {
	   *   const rule = postcss.rule({ selector: 'a', source: atrule.source })
	   *   atrule.parent.insertBefore(atrule, rule)
	   * }
	   * ```
	   *
	   * @example
	   * decl.source.input.from //=> '/home/ai/a.sass'
	   * decl.source.start      //=> { line: 10, column: 2 }
	   * decl.source.end        //=> { line: 10, column: 12 }
	   */ /**
	   * @memberof Node#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node. It also stores `*`
	   *   and `_` symbols before the declaration (IE hack).
	   * * `after`: the space symbols after the last child of the node
	   *   to the end of the node.
	   * * `between`: the symbols between the property and value
	   *   for declarations, selector and `{` for rules, or last parameter
	   *   and `{` for at-rules.
	   * * `semicolon`: contains true if the last child has
	   *   an (optional) semicolon.
	   * * `afterName`: the space between the at-rule name and its parameters.
	   * * `left`: the space symbols between `/*` and the comment’s text.
	   * * `right`: the space symbols between the comment’s text
	   *   and <code>*&#47;</code>.
	   * * `important`: the content of the important statement,
	   *   if it is not just `!important`.
	   *
	   * PostCSS cleans selectors, declaration values and at-rule parameters
	   * from comments and extra spaces, but it stores origin content in raws
	   * properties. As such, if you don’t change a declaration’s value,
	   * PostCSS will use the raw value with comments.
	   *
	   * @example
	   * const root = postcss.parse('a {\n  color:black\n}')
	   * root.first.first.raws //=> { before: '\n  ', between: ':' }
	   */;return Node;}();var _default=Node;/**
	 * @typedef {object} position
	 * @property {number} line   Source line in file.
	 * @property {number} column Source column in file.
	 */ /**
	 * @typedef {object} source
	 * @property {Input} input    {@link Input} with input file
	 * @property {position} start The starting position of the node’s source.
	 * @property {position} end   The ending position of the node’s source.
	 */exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./css-syntax-error":172,"./stringifier":187,"./stringify":188,"_process":193}],179:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _parser=_interopRequireDefault(require("./parser"));var _input=_interopRequireDefault(require("./input"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function parse(css,opts){var input=new _input["default"](css,opts);var parser=new _parser["default"](input);try{parser.parse();}catch(e){if(process.env.NODE_ENV!=='production'){if(e.name==='CssSyntaxError'&&opts&&opts.from){if(/\.scss$/i.test(opts.from)){e.message+='\nYou tried to parse SCSS with '+'the standard CSS parser; '+'try again with the postcss-scss parser';}else if(/\.sass/i.test(opts.from)){e.message+='\nYou tried to parse Sass with '+'the standard CSS parser; '+'try again with the postcss-sass parser';}else if(/\.less$/i.test(opts.from)){e.message+='\nYou tried to parse Less with '+'the standard CSS parser; '+'try again with the postcss-less parser';}}}throw e;}return parser.root;}var _default=parse;exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./input":174,"./parser":180,"_process":193}],180:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _declaration=_interopRequireDefault(require("./declaration"));var _tokenize=_interopRequireDefault(require("./tokenize"));var _comment=_interopRequireDefault(require("./comment"));var _atRule=_interopRequireDefault(require("./at-rule"));var _root=_interopRequireDefault(require("./root"));var _rule=_interopRequireDefault(require("./rule"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}var Parser=/*#__PURE__*/function(){function Parser(input){this.input=input;this.root=new _root["default"]();this.current=this.root;this.spaces='';this.semicolon=false;this.createTokenizer();this.root.source={input:input,start:{line:1,column:1}};}var _proto=Parser.prototype;_proto.createTokenizer=function createTokenizer(){this.tokenizer=(0,_tokenize["default"])(this.input);};_proto.parse=function parse(){var token;while(!this.tokenizer.endOfFile()){token=this.tokenizer.nextToken();switch(token[0]){case'space':this.spaces+=token[1];break;case';':this.freeSemicolon(token);break;case'}':this.end(token);break;case'comment':this.comment(token);break;case'at-word':this.atrule(token);break;case'{':this.emptyRule(token);break;default:this.other(token);break;}}this.endFile();};_proto.comment=function comment(token){var node=new _comment["default"]();this.init(node,token[2],token[3]);node.source.end={line:token[4],column:token[5]};var text=token[1].slice(2,-2);if(/^\s*$/.test(text)){node.text='';node.raws.left=text;node.raws.right='';}else{var match=text.match(/^(\s*)([^]*[^\s])(\s*)$/);node.text=match[2];node.raws.left=match[1];node.raws.right=match[3];}};_proto.emptyRule=function emptyRule(token){var node=new _rule["default"]();this.init(node,token[2],token[3]);node.selector='';node.raws.between='';this.current=node;};_proto.other=function other(start){var end=false;var type=null;var colon=false;var bracket=null;var brackets=[];var tokens=[];var token=start;while(token){type=token[0];tokens.push(token);if(type==='('||type==='['){if(!bracket)bracket=token;brackets.push(type==='('?')':']');}else if(brackets.length===0){if(type===';'){if(colon){this.decl(tokens);return;}else{break;}}else if(type==='{'){this.rule(tokens);return;}else if(type==='}'){this.tokenizer.back(tokens.pop());end=true;break;}else if(type===':'){colon=true;}}else if(type===brackets[brackets.length-1]){brackets.pop();if(brackets.length===0)bracket=null;}token=this.tokenizer.nextToken();}if(this.tokenizer.endOfFile())end=true;if(brackets.length>0)this.unclosedBracket(bracket);if(end&&colon){while(tokens.length){token=tokens[tokens.length-1][0];if(token!=='space'&&token!=='comment')break;this.tokenizer.back(tokens.pop());}this.decl(tokens);}else{this.unknownWord(tokens);}};_proto.rule=function rule(tokens){tokens.pop();var node=new _rule["default"]();this.init(node,tokens[0][2],tokens[0][3]);node.raws.between=this.spacesAndCommentsFromEnd(tokens);this.raw(node,'selector',tokens);this.current=node;};_proto.decl=function decl(tokens){var node=new _declaration["default"]();this.init(node);var last=tokens[tokens.length-1];if(last[0]===';'){this.semicolon=true;tokens.pop();}if(last[4]){node.source.end={line:last[4],column:last[5]};}else{node.source.end={line:last[2],column:last[3]};}while(tokens[0][0]!=='word'){if(tokens.length===1)this.unknownWord(tokens);node.raws.before+=tokens.shift()[1];}node.source.start={line:tokens[0][2],column:tokens[0][3]};node.prop='';while(tokens.length){var type=tokens[0][0];if(type===':'||type==='space'||type==='comment'){break;}node.prop+=tokens.shift()[1];}node.raws.between='';var token;while(tokens.length){token=tokens.shift();if(token[0]===':'){node.raws.between+=token[1];break;}else{if(token[0]==='word'&&/\w/.test(token[1])){this.unknownWord([token]);}node.raws.between+=token[1];}}if(node.prop[0]==='_'||node.prop[0]==='*'){node.raws.before+=node.prop[0];node.prop=node.prop.slice(1);}node.raws.between+=this.spacesAndCommentsFromStart(tokens);this.precheckMissedSemicolon(tokens);for(var i=tokens.length-1;i>0;i--){token=tokens[i];if(token[1].toLowerCase()==='!important'){node.important=true;var string=this.stringFrom(tokens,i);string=this.spacesFromEnd(tokens)+string;if(string!==' !important')node.raws.important=string;break;}else if(token[1].toLowerCase()==='important'){var cache=tokens.slice(0);var str='';for(var j=i;j>0;j--){var _type=cache[j][0];if(str.trim().indexOf('!')===0&&_type!=='space'){break;}str=cache.pop()[1]+str;}if(str.trim().indexOf('!')===0){node.important=true;node.raws.important=str;tokens=cache;}}if(token[0]!=='space'&&token[0]!=='comment'){break;}}this.raw(node,'value',tokens);if(node.value.indexOf(':')!==-1)this.checkMissedSemicolon(tokens);};_proto.atrule=function atrule(token){var node=new _atRule["default"]();node.name=token[1].slice(1);if(node.name===''){this.unnamedAtrule(node,token);}this.init(node,token[2],token[3]);var prev;var shift;var last=false;var open=false;var params=[];while(!this.tokenizer.endOfFile()){token=this.tokenizer.nextToken();if(token[0]===';'){node.source.end={line:token[2],column:token[3]};this.semicolon=true;break;}else if(token[0]==='{'){open=true;break;}else if(token[0]==='}'){if(params.length>0){shift=params.length-1;prev=params[shift];while(prev&&prev[0]==='space'){prev=params[--shift];}if(prev){node.source.end={line:prev[4],column:prev[5]};}}this.end(token);break;}else{params.push(token);}if(this.tokenizer.endOfFile()){last=true;break;}}node.raws.between=this.spacesAndCommentsFromEnd(params);if(params.length){node.raws.afterName=this.spacesAndCommentsFromStart(params);this.raw(node,'params',params);if(last){token=params[params.length-1];node.source.end={line:token[4],column:token[5]};this.spaces=node.raws.between;node.raws.between='';}}else{node.raws.afterName='';node.params='';}if(open){node.nodes=[];this.current=node;}};_proto.end=function end(token){if(this.current.nodes&&this.current.nodes.length){this.current.raws.semicolon=this.semicolon;}this.semicolon=false;this.current.raws.after=(this.current.raws.after||'')+this.spaces;this.spaces='';if(this.current.parent){this.current.source.end={line:token[2],column:token[3]};this.current=this.current.parent;}else{this.unexpectedClose(token);}};_proto.endFile=function endFile(){if(this.current.parent)this.unclosedBlock();if(this.current.nodes&&this.current.nodes.length){this.current.raws.semicolon=this.semicolon;}this.current.raws.after=(this.current.raws.after||'')+this.spaces;};_proto.freeSemicolon=function freeSemicolon(token){this.spaces+=token[1];if(this.current.nodes){var prev=this.current.nodes[this.current.nodes.length-1];if(prev&&prev.type==='rule'&&!prev.raws.ownSemicolon){prev.raws.ownSemicolon=this.spaces;this.spaces='';}}}// Helpers
	;_proto.init=function init(node,line,column){this.current.push(node);node.source={start:{line:line,column:column},input:this.input};node.raws.before=this.spaces;this.spaces='';if(node.type!=='comment')this.semicolon=false;};_proto.raw=function raw(node,prop,tokens){var token,type;var length=tokens.length;var value='';var clean=true;var next,prev;var pattern=/^([.|#])?([\w])+/i;for(var i=0;i<length;i+=1){token=tokens[i];type=token[0];if(type==='comment'&&node.type==='rule'){prev=tokens[i-1];next=tokens[i+1];if(prev[0]!=='space'&&next[0]!=='space'&&pattern.test(prev[1])&&pattern.test(next[1])){value+=token[1];}else{clean=false;}continue;}if(type==='comment'||type==='space'&&i===length-1){clean=false;}else{value+=token[1];}}if(!clean){var raw=tokens.reduce(function(all,i){return all+i[1];},'');node.raws[prop]={value:value,raw:raw};}node[prop]=value;};_proto.spacesAndCommentsFromEnd=function spacesAndCommentsFromEnd(tokens){var lastTokenType;var spaces='';while(tokens.length){lastTokenType=tokens[tokens.length-1][0];if(lastTokenType!=='space'&&lastTokenType!=='comment')break;spaces=tokens.pop()[1]+spaces;}return spaces;};_proto.spacesAndCommentsFromStart=function spacesAndCommentsFromStart(tokens){var next;var spaces='';while(tokens.length){next=tokens[0][0];if(next!=='space'&&next!=='comment')break;spaces+=tokens.shift()[1];}return spaces;};_proto.spacesFromEnd=function spacesFromEnd(tokens){var lastTokenType;var spaces='';while(tokens.length){lastTokenType=tokens[tokens.length-1][0];if(lastTokenType!=='space')break;spaces=tokens.pop()[1]+spaces;}return spaces;};_proto.stringFrom=function stringFrom(tokens,from){var result='';for(var i=from;i<tokens.length;i++){result+=tokens[i][1];}tokens.splice(from,tokens.length-from);return result;};_proto.colon=function colon(tokens){var brackets=0;var token,type,prev;for(var i=0;i<tokens.length;i++){token=tokens[i];type=token[0];if(type==='('){brackets+=1;}if(type===')'){brackets-=1;}if(brackets===0&&type===':'){if(!prev){this.doubleColon(token);}else if(prev[0]==='word'&&prev[1]==='progid'){continue;}else{return i;}}prev=token;}return false;}// Errors
	;_proto.unclosedBracket=function unclosedBracket(bracket){throw this.input.error('Unclosed bracket',bracket[2],bracket[3]);};_proto.unknownWord=function unknownWord(tokens){throw this.input.error('Unknown word',tokens[0][2],tokens[0][3]);};_proto.unexpectedClose=function unexpectedClose(token){throw this.input.error('Unexpected }',token[2],token[3]);};_proto.unclosedBlock=function unclosedBlock(){var pos=this.current.source.start;throw this.input.error('Unclosed block',pos.line,pos.column);};_proto.doubleColon=function doubleColon(token){throw this.input.error('Double colon',token[2],token[3]);};_proto.unnamedAtrule=function unnamedAtrule(node,token){throw this.input.error('At-rule without name',token[2],token[3]);};_proto.precheckMissedSemicolon=function precheckMissedSemicolon()/* tokens */{// Hook for Safe Parser
	};_proto.checkMissedSemicolon=function checkMissedSemicolon(tokens){var colon=this.colon(tokens);if(colon===false)return;var founded=0;var token;for(var j=colon-1;j>=0;j--){token=tokens[j];if(token[0]!=='space'){founded+=1;if(founded===2)break;}}throw this.input.error('Missed semicolon',token[2],token[3]);};return Parser;}();exports["default"]=Parser;module.exports=exports["default"];},{"./at-rule":169,"./comment":170,"./declaration":173,"./root":185,"./rule":186,"./tokenize":189}],181:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _declaration=_interopRequireDefault(require("./declaration"));var _processor=_interopRequireDefault(require("./processor"));var _stringify=_interopRequireDefault(require("./stringify"));var _comment=_interopRequireDefault(require("./comment"));var _atRule=_interopRequireDefault(require("./at-rule"));var _vendor=_interopRequireDefault(require("./vendor"));var _parse=_interopRequireDefault(require("./parse"));var _list=_interopRequireDefault(require("./list"));var _rule=_interopRequireDefault(require("./rule"));var _root=_interopRequireDefault(require("./root"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}/**
	 * Create a new {@link Processor} instance that will apply `plugins`
	 * as CSS processors.
	 *
	 * @param {Array.<Plugin|pluginFunction>|Processor} plugins PostCSS plugins.
	 *        See {@link Processor#use} for plugin format.
	 *
	 * @return {Processor} Processor to process multiple CSS.
	 *
	 * @example
	 * import postcss from 'postcss'
	 *
	 * postcss(plugins).process(css, { from, to }).then(result => {
	 *   console.log(result.css)
	 * })
	 *
	 * @namespace postcss
	 */function postcss(){for(var _len=arguments.length,plugins=new Array(_len),_key=0;_key<_len;_key++){plugins[_key]=arguments[_key];}if(plugins.length===1&&Array.isArray(plugins[0])){plugins=plugins[0];}return new _processor["default"](plugins);}/**
	 * Creates a PostCSS plugin with a standard API.
	 *
	 * The newly-wrapped function will provide both the name and PostCSS
	 * version of the plugin.
	 *
	 * ```js
	 * const processor = postcss([replace])
	 * processor.plugins[0].postcssPlugin  //=> 'postcss-replace'
	 * processor.plugins[0].postcssVersion //=> '6.0.0'
	 * ```
	 *
	 * The plugin function receives 2 arguments: {@link Root}
	 * and {@link Result} instance. The function should mutate the provided
	 * `Root` node. Alternatively, you can create a new `Root` node
	 * and override the `result.root` property.
	 *
	 * ```js
	 * const cleaner = postcss.plugin('postcss-cleaner', () => {
	 *   return (root, result) => {
	 *     result.root = postcss.root()
	 *   }
	 * })
	 * ```
	 *
	 * As a convenience, plugins also expose a `process` method so that you can use
	 * them as standalone tools.
	 *
	 * ```js
	 * cleaner.process(css, processOpts, pluginOpts)
	 * // This is equivalent to:
	 * postcss([ cleaner(pluginOpts) ]).process(css, processOpts)
	 * ```
	 *
	 * Asynchronous plugins should return a `Promise` instance.
	 *
	 * ```js
	 * postcss.plugin('postcss-import', () => {
	 *   return (root, result) => {
	 *     return new Promise( (resolve, reject) => {
	 *       fs.readFile('base.css', (base) => {
	 *         root.prepend(base)
	 *         resolve()
	 *       })
	 *     })
	 *   }
	 * })
	 * ```
	 *
	 * Add warnings using the {@link Node#warn} method.
	 * Send data to other plugins using the {@link Result#messages} array.
	 *
	 * ```js
	 * postcss.plugin('postcss-caniuse-test', () => {
	 *   return (root, result) => {
	 *     root.walkDecls(decl => {
	 *       if (!caniuse.support(decl.prop)) {
	 *         decl.warn(result, 'Some browsers do not support ' + decl.prop)
	 *       }
	 *     })
	 *   }
	 * })
	 * ```
	 *
	 * @param {string} name          PostCSS plugin name. Same as in `name`
	 *                               property in `package.json`. It will be saved
	 *                               in `plugin.postcssPlugin` property.
	 * @param {function} initializer Will receive plugin options
	 *                               and should return {@link pluginFunction}
	 *
	 * @return {Plugin} PostCSS plugin.
	 */postcss.plugin=function plugin(name,initializer){function creator(){var transformer=initializer.apply(void 0,arguments);transformer.postcssPlugin=name;transformer.postcssVersion=new _processor["default"]().version;return transformer;}var cache;Object.defineProperty(creator,'postcss',{get:function get(){if(!cache)cache=creator();return cache;}});creator.process=function(css,processOpts,pluginOpts){return postcss([creator(pluginOpts)]).process(css,processOpts);};return creator;};/**
	 * Default function to convert a node tree into a CSS string.
	 *
	 * @param {Node} node       Start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder Function to concatenate CSS from node’s parts
	 *                          or generate string and source map.
	 *
	 * @return {void}
	 *
	 * @function
	 */postcss.stringify=_stringify["default"];/**
	 * Parses source css and returns a new {@link Root} node,
	 * which contains the source CSS nodes.
	 *
	 * @param {string|toString} css   String with input CSS or any object
	 *                                with toString() method, like a Buffer
	 * @param {processOptions} [opts] Options with only `from` and `map` keys.
	 *
	 * @return {Root} PostCSS AST.
	 *
	 * @example
	 * // Simple CSS concatenation with source map support
	 * const root1 = postcss.parse(css1, { from: file1 })
	 * const root2 = postcss.parse(css2, { from: file2 })
	 * root1.append(root2).toResult().css
	 *
	 * @function
	 */postcss.parse=_parse["default"];/**
	 * Contains the {@link vendor} module.
	 *
	 * @type {vendor}
	 *
	 * @example
	 * postcss.vendor.unprefixed('-moz-tab') //=> ['tab']
	 */postcss.vendor=_vendor["default"];/**
	 * Contains the {@link list} module.
	 *
	 * @member {list}
	 *
	 * @example
	 * postcss.list.space('5px calc(10% + 5px)') //=> ['5px', 'calc(10% + 5px)']
	 */postcss.list=_list["default"];/**
	 * Creates a new {@link Comment} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Comment} New comment node
	 *
	 * @example
	 * postcss.comment({ text: 'test' })
	 */postcss.comment=function(defaults){return new _comment["default"](defaults);};/**
	 * Creates a new {@link AtRule} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {AtRule} new at-rule node
	 *
	 * @example
	 * postcss.atRule({ name: 'charset' }).toString() //=> "@charset"
	 */postcss.atRule=function(defaults){return new _atRule["default"](defaults);};/**
	 * Creates a new {@link Declaration} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Declaration} new declaration node
	 *
	 * @example
	 * postcss.decl({ prop: 'color', value: 'red' }).toString() //=> "color: red"
	 */postcss.decl=function(defaults){return new _declaration["default"](defaults);};/**
	 * Creates a new {@link Rule} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Rule} new rule node
	 *
	 * @example
	 * postcss.rule({ selector: 'a' }).toString() //=> "a {\n}"
	 */postcss.rule=function(defaults){return new _rule["default"](defaults);};/**
	 * Creates a new {@link Root} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Root} new root node.
	 *
	 * @example
	 * postcss.root({ after: '\n' }).toString() //=> "\n"
	 */postcss.root=function(defaults){return new _root["default"](defaults);};var _default=postcss;exports["default"]=_default;module.exports=exports["default"];},{"./at-rule":169,"./comment":170,"./declaration":173,"./list":176,"./parse":179,"./processor":183,"./root":185,"./rule":186,"./stringify":188,"./vendor":190}],182:[function(require,module,exports){(function(Buffer){"use strict";exports.__esModule=true;exports["default"]=void 0;var _sourceMap=_interopRequireDefault(require("source-map"));var _path=_interopRequireDefault(require("path"));var _fs=_interopRequireDefault(require("fs"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function fromBase64(str){if(Buffer){return Buffer.from(str,'base64').toString();}else{return window.atob(str);}}/**
	 * Source map information from input CSS.
	 * For example, source map after Sass compiler.
	 *
	 * This class will automatically find source map in input CSS or in file system
	 * near input file (according `from` option).
	 *
	 * @example
	 * const root = postcss.parse(css, { from: 'a.sass.css' })
	 * root.input.map //=> PreviousMap
	 */var PreviousMap=/*#__PURE__*/function(){/**
	   * @param {string}         css    Input CSS source.
	   * @param {processOptions} [opts] {@link Processor#process} options.
	   */function PreviousMap(css,opts){this.loadAnnotation(css);/**
	     * Was source map inlined by data-uri to input CSS.
	     *
	     * @type {boolean}
	     */this.inline=this.startWith(this.annotation,'data:');var prev=opts.map?opts.map.prev:undefined;var text=this.loadMap(opts.from,prev);if(text)this.text=text;}/**
	   * Create a instance of `SourceMapGenerator` class
	   * from the `source-map` library to work with source map information.
	   *
	   * It is lazy method, so it will create object only on first call
	   * and then it will use cache.
	   *
	   * @return {SourceMapGenerator} Object with source map information.
	   */var _proto=PreviousMap.prototype;_proto.consumer=function consumer(){if(!this.consumerCache){this.consumerCache=new _sourceMap["default"].SourceMapConsumer(this.text);}return this.consumerCache;}/**
	   * Does source map contains `sourcesContent` with input source text.
	   *
	   * @return {boolean} Is `sourcesContent` present.
	   */;_proto.withContent=function withContent(){return!!(this.consumer().sourcesContent&&this.consumer().sourcesContent.length>0);};_proto.startWith=function startWith(string,start){if(!string)return false;return string.substr(0,start.length)===start;};_proto.getAnnotationURL=function getAnnotationURL(sourceMapString){return sourceMapString.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//)[1].trim();};_proto.loadAnnotation=function loadAnnotation(css){var annotations=css.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//mg);if(annotations&&annotations.length>0){// Locate the last sourceMappingURL to avoid picking up
	// sourceMappingURLs from comments, strings, etc.
	var lastAnnotation=annotations[annotations.length-1];if(lastAnnotation){this.annotation=this.getAnnotationURL(lastAnnotation);}}};_proto.decodeInline=function decodeInline(text){var baseCharsetUri=/^data:application\/json;charset=utf-?8;base64,/;var baseUri=/^data:application\/json;base64,/;var uri='data:application/json,';if(this.startWith(text,uri)){return decodeURIComponent(text.substr(uri.length));}if(baseCharsetUri.test(text)||baseUri.test(text)){return fromBase64(text.substr(RegExp.lastMatch.length));}var encoding=text.match(/data:application\/json;([^,]+),/)[1];throw new Error('Unsupported source map encoding '+encoding);};_proto.loadMap=function loadMap(file,prev){if(prev===false)return false;if(prev){if(typeof prev==='string'){return prev;}else if(typeof prev==='function'){var prevPath=prev(file);if(prevPath&&_fs["default"].existsSync&&_fs["default"].existsSync(prevPath)){return _fs["default"].readFileSync(prevPath,'utf-8').toString().trim();}else{throw new Error('Unable to load previous source map: '+prevPath.toString());}}else if(prev instanceof _sourceMap["default"].SourceMapConsumer){return _sourceMap["default"].SourceMapGenerator.fromSourceMap(prev).toString();}else if(prev instanceof _sourceMap["default"].SourceMapGenerator){return prev.toString();}else if(this.isMap(prev)){return JSON.stringify(prev);}else{throw new Error('Unsupported previous source map format: '+prev.toString());}}else if(this.inline){return this.decodeInline(this.annotation);}else if(this.annotation){var map=this.annotation;if(file)map=_path["default"].join(_path["default"].dirname(file),map);this.root=_path["default"].dirname(map);if(_fs["default"].existsSync&&_fs["default"].existsSync(map)){return _fs["default"].readFileSync(map,'utf-8').toString().trim();}else{return false;}}};_proto.isMap=function isMap(map){if(_typeof(map)!=='object')return false;return typeof map.mappings==='string'||typeof map._mappings==='string';};return PreviousMap;}();var _default=PreviousMap;exports["default"]=_default;module.exports=exports["default"];}).call(this,require("buffer").Buffer);},{"buffer":3,"fs":2,"path":168,"source-map":208}],183:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _lazyResult=_interopRequireDefault(require("./lazy-result"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}/**
	 * Contains plugins to process CSS. Create one `Processor` instance,
	 * initialize its plugins, and then use that instance on numerous CSS files.
	 *
	 * @example
	 * const processor = postcss([autoprefixer, precss])
	 * processor.process(css1).then(result => console.log(result.css))
	 * processor.process(css2).then(result => console.log(result.css))
	 */var Processor=/*#__PURE__*/function(){/**
	   * @param {Array.<Plugin|pluginFunction>|Processor} plugins PostCSS plugins.
	   *        See {@link Processor#use} for plugin format.
	   */function Processor(plugins){if(plugins===void 0){plugins=[];}/**
	     * Current PostCSS version.
	     *
	     * @type {string}
	     *
	     * @example
	     * if (result.processor.version.split('.')[0] !== '6') {
	     *   throw new Error('This plugin works only with PostCSS 6')
	     * }
	     */this.version='7.0.34';/**
	     * Plugins added to this processor.
	     *
	     * @type {pluginFunction[]}
	     *
	     * @example
	     * const processor = postcss([autoprefixer, precss])
	     * processor.plugins.length //=> 2
	     */this.plugins=this.normalize(plugins);}/**
	   * Adds a plugin to be used as a CSS processor.
	   *
	   * PostCSS plugin can be in 4 formats:
	   * * A plugin created by {@link postcss.plugin} method.
	   * * A function. PostCSS will pass the function a @{link Root}
	   *   as the first argument and current {@link Result} instance
	   *   as the second.
	   * * An object with a `postcss` method. PostCSS will use that method
	   *   as described in #2.
	   * * Another {@link Processor} instance. PostCSS will copy plugins
	   *   from that instance into this one.
	   *
	   * Plugins can also be added by passing them as arguments when creating
	   * a `postcss` instance (see [`postcss(plugins)`]).
	   *
	   * Asynchronous plugins should return a `Promise` instance.
	   *
	   * @param {Plugin|pluginFunction|Processor} plugin PostCSS plugin
	   *                                                 or {@link Processor}
	   *                                                 with plugins.
	   *
	   * @example
	   * const processor = postcss()
	   *   .use(autoprefixer)
	   *   .use(precss)
	   *
	   * @return {Processes} Current processor to make methods chain.
	   */var _proto=Processor.prototype;_proto.use=function use(plugin){this.plugins=this.plugins.concat(this.normalize([plugin]));return this;}/**
	   * Parses source CSS and returns a {@link LazyResult} Promise proxy.
	   * Because some plugins can be asynchronous it doesn’t make
	   * any transformations. Transformations will be applied
	   * in the {@link LazyResult} methods.
	   *
	   * @param {string|toString|Result} css String with input CSS or any object
	   *                                     with a `toString()` method,
	   *                                     like a Buffer. Optionally, send
	   *                                     a {@link Result} instance
	   *                                     and the processor will take
	   *                                     the {@link Root} from it.
	   * @param {processOptions} [opts]      Options.
	   *
	   * @return {LazyResult} Promise proxy.
	   *
	   * @example
	   * processor.process(css, { from: 'a.css', to: 'a.out.css' })
	   *   .then(result => {
	   *      console.log(result.css)
	   *   })
	   */;_proto.process=function(_process){function process(_x){return _process.apply(this,arguments);}process.toString=function(){return _process.toString();};return process;}(function(css,opts){if(opts===void 0){opts={};}if(this.plugins.length===0&&opts.parser===opts.stringifier){if(process.env.NODE_ENV!=='production'){if(typeof console!=='undefined'&&console.warn){console.warn('You did not set any plugins, parser, or stringifier. '+'Right now, PostCSS does nothing. Pick plugins for your case '+'on https://www.postcss.parts/ and use them in postcss.config.js.');}}}return new _lazyResult["default"](this,css,opts);});_proto.normalize=function normalize(plugins){var normalized=[];for(var _iterator=_createForOfIteratorHelperLoose(plugins),_step;!(_step=_iterator()).done;){var i=_step.value;if(i.postcss===true){var plugin=i();throw new Error('PostCSS plugin '+plugin.postcssPlugin+' requires PostCSS 8. Update PostCSS or downgrade this plugin.');}if(i.postcss)i=i.postcss;if(_typeof(i)==='object'&&Array.isArray(i.plugins)){normalized=normalized.concat(i.plugins);}else if(typeof i==='function'){normalized.push(i);}else if(_typeof(i)==='object'&&(i.parse||i.stringify)){if(process.env.NODE_ENV!=='production'){throw new Error('PostCSS syntaxes cannot be used as plugins. Instead, please use '+'one of the syntax/parser/stringifier options as outlined '+'in your PostCSS runner documentation.');}}else if(_typeof(i)==='object'&&i.postcssPlugin){throw new Error('PostCSS plugin '+i.postcssPlugin+' requires PostCSS 8. Update PostCSS or downgrade this plugin.');}else{throw new Error(i+' is not a PostCSS plugin');}}return normalized;};return Processor;}();var _default=Processor;/**
	 * @callback builder
	 * @param {string} part          Part of generated CSS connected to this node.
	 * @param {Node}   node          AST node.
	 * @param {"start"|"end"} [type] Node’s part type.
	 */ /**
	 * @callback parser
	 *
	 * @param {string|toString} css   String with input CSS or any object
	 *                                with toString() method, like a Buffer.
	 * @param {processOptions} [opts] Options with only `from` and `map` keys.
	 *
	 * @return {Root} PostCSS AST
	 */ /**
	 * @callback stringifier
	 *
	 * @param {Node} node       Start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder Function to concatenate CSS from node’s parts
	 *                          or generate string and source map.
	 *
	 * @return {void}
	 */ /**
	 * @typedef {object} syntax
	 * @property {parser} parse          Function to generate AST by string.
	 * @property {stringifier} stringify Function to generate string by AST.
	 */ /**
	 * @typedef {object} toString
	 * @property {function} toString
	 */ /**
	 * @callback pluginFunction
	 * @param {Root} root     Parsed input CSS.
	 * @param {Result} result Result to set warnings or check other plugins.
	 */ /**
	 * @typedef {object} Plugin
	 * @property {function} postcss PostCSS plugin function.
	 */ /**
	 * @typedef {object} processOptions
	 * @property {string} from             The path of the CSS source file.
	 *                                     You should always set `from`,
	 *                                     because it is used in source map
	 *                                     generation and syntax error messages.
	 * @property {string} to               The path where you’ll put the output
	 *                                     CSS file. You should always set `to`
	 *                                     to generate correct source maps.
	 * @property {parser} parser           Function to generate AST by string.
	 * @property {stringifier} stringifier Class to generate string by AST.
	 * @property {syntax} syntax           Object with `parse` and `stringify`.
	 * @property {object} map              Source map options.
	 * @property {boolean} map.inline                    Does source map should
	 *                                                   be embedded in the output
	 *                                                   CSS as a base64-encoded
	 *                                                   comment.
	 * @property {string|object|false|function} map.prev Source map content
	 *                                                   from a previous
	 *                                                   processing step
	 *                                                   (for example, Sass).
	 *                                                   PostCSS will try to find
	 *                                                   previous map automatically,
	 *                                                   so you could disable it by
	 *                                                   `false` value.
	 * @property {boolean} map.sourcesContent            Does PostCSS should set
	 *                                                   the origin content to map.
	 * @property {string|false} map.annotation           Does PostCSS should set
	 *                                                   annotation comment to map.
	 * @property {string} map.from                       Override `from` in map’s
	 *                                                   sources`.
	 */exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./lazy-result":175,"_process":193}],184:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _warning=_interopRequireDefault(require("./warning"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
	 * Provides the result of the PostCSS transformations.
	 *
	 * A Result instance is returned by {@link LazyResult#then}
	 * or {@link Root#toResult} methods.
	 *
	 * @example
	 * postcss([autoprefixer]).process(css).then(result => {
	 *  console.log(result.css)
	 * })
	 *
	 * @example
	 * const result2 = postcss.parse(css).toResult()
	 */var Result=/*#__PURE__*/function(){/**
	   * @param {Processor} processor Processor used for this transformation.
	   * @param {Root}      root      Root node after all transformations.
	   * @param {processOptions} opts Options from the {@link Processor#process}
	   *                              or {@link Root#toResult}.
	   */function Result(processor,root,opts){/**
	     * The Processor instance used for this transformation.
	     *
	     * @type {Processor}
	     *
	     * @example
	     * for (const plugin of result.processor.plugins) {
	     *   if (plugin.postcssPlugin === 'postcss-bad') {
	     *     throw 'postcss-good is incompatible with postcss-bad'
	     *   }
	     * })
	     */this.processor=processor;/**
	     * Contains messages from plugins (e.g., warnings or custom messages).
	     * Each message should have type and plugin properties.
	     *
	     * @type {Message[]}
	     *
	     * @example
	     * postcss.plugin('postcss-min-browser', () => {
	     *   return (root, result) => {
	     *     const browsers = detectMinBrowsersByCanIUse(root)
	     *     result.messages.push({
	     *       type: 'min-browser',
	     *       plugin: 'postcss-min-browser',
	     *       browsers
	     *     })
	     *   }
	     * })
	     */this.messages=[];/**
	     * Root node after all transformations.
	     *
	     * @type {Root}
	     *
	     * @example
	     * root.toResult().root === root
	     */this.root=root;/**
	     * Options from the {@link Processor#process} or {@link Root#toResult} call
	     * that produced this Result instance.
	     *
	     * @type {processOptions}
	     *
	     * @example
	     * root.toResult(opts).opts === opts
	     */this.opts=opts;/**
	     * A CSS string representing of {@link Result#root}.
	     *
	     * @type {string}
	     *
	     * @example
	     * postcss.parse('a{}').toResult().css //=> "a{}"
	     */this.css=undefined;/**
	     * An instance of `SourceMapGenerator` class from the `source-map` library,
	     * representing changes to the {@link Result#root} instance.
	     *
	     * @type {SourceMapGenerator}
	     *
	     * @example
	     * result.map.toJSON() //=> { version: 3, file: 'a.css', … }
	     *
	     * @example
	     * if (result.map) {
	     *   fs.writeFileSync(result.opts.to + '.map', result.map.toString())
	     * }
	     */this.map=undefined;}/**
	   * Returns for @{link Result#css} content.
	   *
	   * @example
	   * result + '' === result.css
	   *
	   * @return {string} String representing of {@link Result#root}.
	   */var _proto=Result.prototype;_proto.toString=function toString(){return this.css;}/**
	   * Creates an instance of {@link Warning} and adds it
	   * to {@link Result#messages}.
	   *
	   * @param {string} text        Warning message.
	   * @param {Object} [opts]      Warning options.
	   * @param {Node}   opts.node   CSS node that caused the warning.
	   * @param {string} opts.word   Word in CSS source that caused the warning.
	   * @param {number} opts.index  Index in CSS node string that caused
	   *                             the warning.
	   * @param {string} opts.plugin Name of the plugin that created
	   *                             this warning. {@link Result#warn} fills
	   *                             this property automatically.
	   *
	   * @return {Warning} Created warning.
	   */;_proto.warn=function warn(text,opts){if(opts===void 0){opts={};}if(!opts.plugin){if(this.lastPlugin&&this.lastPlugin.postcssPlugin){opts.plugin=this.lastPlugin.postcssPlugin;}}var warning=new _warning["default"](text,opts);this.messages.push(warning);return warning;}/**
	     * Returns warnings from plugins. Filters {@link Warning} instances
	     * from {@link Result#messages}.
	     *
	     * @example
	     * result.warnings().forEach(warn => {
	     *   console.warn(warn.toString())
	     * })
	     *
	     * @return {Warning[]} Warnings from plugins.
	     */;_proto.warnings=function warnings(){return this.messages.filter(function(i){return i.type==='warning';});}/**
	   * An alias for the {@link Result#css} property.
	   * Use it with syntaxes that generate non-CSS output.
	   *
	   * @type {string}
	   *
	   * @example
	   * result.css === result.content
	   */;_createClass(Result,[{key:"content",get:function get(){return this.css;}}]);return Result;}();var _default=Result;/**
	 * @typedef  {object} Message
	 * @property {string} type   Message type.
	 * @property {string} plugin Source PostCSS plugin name.
	 */exports["default"]=_default;module.exports=exports["default"];},{"./warning":192}],185:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _container=_interopRequireDefault(require("./container"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a CSS file and contains all its parsed nodes.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{color:black} b{z-index:2}')
	 * root.type         //=> 'root'
	 * root.nodes.length //=> 2
	 */var Root=/*#__PURE__*/function(_Container){_inheritsLoose(Root,_Container);function Root(defaults){var _this;_this=_Container.call(this,defaults)||this;_this.type='root';if(!_this.nodes)_this.nodes=[];return _this;}var _proto=Root.prototype;_proto.removeChild=function removeChild(child,ignore){var index=this.index(child);if(!ignore&&index===0&&this.nodes.length>1){this.nodes[1].raws.before=this.nodes[index].raws.before;}return _Container.prototype.removeChild.call(this,child);};_proto.normalize=function normalize(child,sample,type){var nodes=_Container.prototype.normalize.call(this,child);if(sample){if(type==='prepend'){if(this.nodes.length>1){sample.raws.before=this.nodes[1].raws.before;}else{delete sample.raws.before;}}else if(this.first!==sample){for(var _iterator=_createForOfIteratorHelperLoose(nodes),_step;!(_step=_iterator()).done;){var node=_step.value;node.raws.before=sample.raws.before;}}}return nodes;}/**
	   * Returns a {@link Result} instance representing the root’s CSS.
	   *
	   * @param {processOptions} [opts] Options with only `to` and `map` keys.
	   *
	   * @return {Result} Result with current root’s CSS.
	   *
	   * @example
	   * const root1 = postcss.parse(css1, { from: 'a.css' })
	   * const root2 = postcss.parse(css2, { from: 'b.css' })
	   * root1.append(root2)
	   * const result = root1.toResult({ to: 'all.css', map: true })
	   */;_proto.toResult=function toResult(opts){if(opts===void 0){opts={};}var LazyResult=require('./lazy-result');var Processor=require('./processor');var lazy=new LazyResult(new Processor(),this,opts);return lazy.stringify();}/**
	   * @memberof Root#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `after`: the space symbols after the last child to the end of file.
	   * * `semicolon`: is the last child has an (optional) semicolon.
	   *
	   * @example
	   * postcss.parse('a {}\n').raws //=> { after: '\n' }
	   * postcss.parse('a {}').raws   //=> { after: '' }
	   */;return Root;}(_container["default"]);var _default=Root;exports["default"]=_default;module.exports=exports["default"];},{"./container":171,"./lazy-result":175,"./processor":183}],186:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _container=_interopRequireDefault(require("./container"));var _list=_interopRequireDefault(require("./list"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a CSS rule: a selector followed by a declaration block.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{}')
	 * const rule = root.first
	 * rule.type       //=> 'rule'
	 * rule.toString() //=> 'a{}'
	 */var Rule=/*#__PURE__*/function(_Container){_inheritsLoose(Rule,_Container);function Rule(defaults){var _this;_this=_Container.call(this,defaults)||this;_this.type='rule';if(!_this.nodes)_this.nodes=[];return _this;}/**
	   * An array containing the rule’s individual selectors.
	   * Groups of selectors are split at commas.
	   *
	   * @type {string[]}
	   *
	   * @example
	   * const root = postcss.parse('a, b { }')
	   * const rule = root.first
	   *
	   * rule.selector  //=> 'a, b'
	   * rule.selectors //=> ['a', 'b']
	   *
	   * rule.selectors = ['a', 'strong']
	   * rule.selector //=> 'a, strong'
	   */_createClass(Rule,[{key:"selectors",get:function get(){return _list["default"].comma(this.selector);},set:function set(values){var match=this.selector?this.selector.match(/,\s*/):null;var sep=match?match[0]:','+this.raw('between','beforeOpen');this.selector=values.join(sep);}/**
	     * @memberof Rule#
	     * @member {string} selector The rule’s full selector represented
	     *                           as a string.
	     *
	     * @example
	     * const root = postcss.parse('a, b { }')
	     * const rule = root.first
	     * rule.selector //=> 'a, b'
	     */ /**
	     * @memberof Rule#
	     * @member {object} raws Information to generate byte-to-byte equal
	     *                       node string as it was in the origin input.
	     *
	     * Every parser saves its own properties,
	     * but the default CSS parser uses:
	     *
	     * * `before`: the space symbols before the node. It also stores `*`
	     *   and `_` symbols before the declaration (IE hack).
	     * * `after`: the space symbols after the last child of the node
	     *   to the end of the node.
	     * * `between`: the symbols between the property and value
	     *   for declarations, selector and `{` for rules, or last parameter
	     *   and `{` for at-rules.
	     * * `semicolon`: contains `true` if the last child has
	     *   an (optional) semicolon.
	     * * `ownSemicolon`: contains `true` if there is semicolon after rule.
	     *
	     * PostCSS cleans selectors from comments and extra spaces,
	     * but it stores origin content in raws properties.
	     * As such, if you don’t change a declaration’s value,
	     * PostCSS will use the raw value with comments.
	     *
	     * @example
	     * const root = postcss.parse('a {\n  color:black\n}')
	     * root.first.first.raws //=> { before: '', between: ' ', after: '\n' }
	     */}]);return Rule;}(_container["default"]);var _default=Rule;exports["default"]=_default;module.exports=exports["default"];},{"./container":171,"./list":176}],187:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var DEFAULT_RAW={colon:': ',indent:'    ',beforeDecl:'\n',beforeRule:'\n',beforeOpen:' ',beforeClose:'\n',beforeComment:'\n',after:'\n',emptyBody:'',commentLeft:' ',commentRight:' ',semicolon:false};function capitalize(str){return str[0].toUpperCase()+str.slice(1);}var Stringifier=/*#__PURE__*/function(){function Stringifier(builder){this.builder=builder;}var _proto=Stringifier.prototype;_proto.stringify=function stringify(node,semicolon){this[node.type](node,semicolon);};_proto.root=function root(node){this.body(node);if(node.raws.after)this.builder(node.raws.after);};_proto.comment=function comment(node){var left=this.raw(node,'left','commentLeft');var right=this.raw(node,'right','commentRight');this.builder('/*'+left+node.text+right+'*/',node);};_proto.decl=function decl(node,semicolon){var between=this.raw(node,'between','colon');var string=node.prop+between+this.rawValue(node,'value');if(node.important){string+=node.raws.important||' !important';}if(semicolon)string+=';';this.builder(string,node);};_proto.rule=function rule(node){this.block(node,this.rawValue(node,'selector'));if(node.raws.ownSemicolon){this.builder(node.raws.ownSemicolon,node,'end');}};_proto.atrule=function atrule(node,semicolon){var name='@'+node.name;var params=node.params?this.rawValue(node,'params'):'';if(typeof node.raws.afterName!=='undefined'){name+=node.raws.afterName;}else if(params){name+=' ';}if(node.nodes){this.block(node,name+params);}else{var end=(node.raws.between||'')+(semicolon?';':'');this.builder(name+params+end,node);}};_proto.body=function body(node){var last=node.nodes.length-1;while(last>0){if(node.nodes[last].type!=='comment')break;last-=1;}var semicolon=this.raw(node,'semicolon');for(var i=0;i<node.nodes.length;i++){var child=node.nodes[i];var before=this.raw(child,'before');if(before)this.builder(before);this.stringify(child,last!==i||semicolon);}};_proto.block=function block(node,start){var between=this.raw(node,'between','beforeOpen');this.builder(start+between+'{',node,'start');var after;if(node.nodes&&node.nodes.length){this.body(node);after=this.raw(node,'after');}else{after=this.raw(node,'after','emptyBody');}if(after)this.builder(after);this.builder('}',node,'end');};_proto.raw=function raw(node,own,detect){var value;if(!detect)detect=own;// Already had
	if(own){value=node.raws[own];if(typeof value!=='undefined')return value;}var parent=node.parent;// Hack for first rule in CSS
	if(detect==='before'){if(!parent||parent.type==='root'&&parent.first===node){return'';}}// Floating child without parent
	if(!parent)return DEFAULT_RAW[detect];// Detect style by other nodes
	var root=node.root();if(!root.rawCache)root.rawCache={};if(typeof root.rawCache[detect]!=='undefined'){return root.rawCache[detect];}if(detect==='before'||detect==='after'){return this.beforeAfter(node,detect);}else{var method='raw'+capitalize(detect);if(this[method]){value=this[method](root,node);}else{root.walk(function(i){value=i.raws[own];if(typeof value!=='undefined')return false;});}}if(typeof value==='undefined')value=DEFAULT_RAW[detect];root.rawCache[detect]=value;return value;};_proto.rawSemicolon=function rawSemicolon(root){var value;root.walk(function(i){if(i.nodes&&i.nodes.length&&i.last.type==='decl'){value=i.raws.semicolon;if(typeof value!=='undefined')return false;}});return value;};_proto.rawEmptyBody=function rawEmptyBody(root){var value;root.walk(function(i){if(i.nodes&&i.nodes.length===0){value=i.raws.after;if(typeof value!=='undefined')return false;}});return value;};_proto.rawIndent=function rawIndent(root){if(root.raws.indent)return root.raws.indent;var value;root.walk(function(i){var p=i.parent;if(p&&p!==root&&p.parent&&p.parent===root){if(typeof i.raws.before!=='undefined'){var parts=i.raws.before.split('\n');value=parts[parts.length-1];value=value.replace(/[^\s]/g,'');return false;}}});return value;};_proto.rawBeforeComment=function rawBeforeComment(root,node){var value;root.walkComments(function(i){if(typeof i.raws.before!=='undefined'){value=i.raws.before;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}});if(typeof value==='undefined'){value=this.raw(node,null,'beforeDecl');}else if(value){value=value.replace(/[^\s]/g,'');}return value;};_proto.rawBeforeDecl=function rawBeforeDecl(root,node){var value;root.walkDecls(function(i){if(typeof i.raws.before!=='undefined'){value=i.raws.before;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}});if(typeof value==='undefined'){value=this.raw(node,null,'beforeRule');}else if(value){value=value.replace(/[^\s]/g,'');}return value;};_proto.rawBeforeRule=function rawBeforeRule(root){var value;root.walk(function(i){if(i.nodes&&(i.parent!==root||root.first!==i)){if(typeof i.raws.before!=='undefined'){value=i.raws.before;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}}});if(value)value=value.replace(/[^\s]/g,'');return value;};_proto.rawBeforeClose=function rawBeforeClose(root){var value;root.walk(function(i){if(i.nodes&&i.nodes.length>0){if(typeof i.raws.after!=='undefined'){value=i.raws.after;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}}});if(value)value=value.replace(/[^\s]/g,'');return value;};_proto.rawBeforeOpen=function rawBeforeOpen(root){var value;root.walk(function(i){if(i.type!=='decl'){value=i.raws.between;if(typeof value!=='undefined')return false;}});return value;};_proto.rawColon=function rawColon(root){var value;root.walkDecls(function(i){if(typeof i.raws.between!=='undefined'){value=i.raws.between.replace(/[^\s:]/g,'');return false;}});return value;};_proto.beforeAfter=function beforeAfter(node,detect){var value;if(node.type==='decl'){value=this.raw(node,null,'beforeDecl');}else if(node.type==='comment'){value=this.raw(node,null,'beforeComment');}else if(detect==='before'){value=this.raw(node,null,'beforeRule');}else{value=this.raw(node,null,'beforeClose');}var buf=node.parent;var depth=0;while(buf&&buf.type!=='root'){depth+=1;buf=buf.parent;}if(value.indexOf('\n')!==-1){var indent=this.raw(node,null,'indent');if(indent.length){for(var step=0;step<depth;step++){value+=indent;}}}return value;};_proto.rawValue=function rawValue(node,prop){var value=node[prop];var raw=node.raws[prop];if(raw&&raw.value===value){return raw.raw;}return value;};return Stringifier;}();var _default=Stringifier;exports["default"]=_default;module.exports=exports["default"];},{}],188:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _stringifier=_interopRequireDefault(require("./stringifier"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function stringify(node,builder){var str=new _stringifier["default"](builder);str.stringify(node);}var _default=stringify;exports["default"]=_default;module.exports=exports["default"];},{"./stringifier":187}],189:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=tokenizer;var SINGLE_QUOTE='\''.charCodeAt(0);var DOUBLE_QUOTE='"'.charCodeAt(0);var BACKSLASH='\\'.charCodeAt(0);var SLASH='/'.charCodeAt(0);var NEWLINE='\n'.charCodeAt(0);var SPACE=' '.charCodeAt(0);var FEED='\f'.charCodeAt(0);var TAB='\t'.charCodeAt(0);var CR='\r'.charCodeAt(0);var OPEN_SQUARE='['.charCodeAt(0);var CLOSE_SQUARE=']'.charCodeAt(0);var OPEN_PARENTHESES='('.charCodeAt(0);var CLOSE_PARENTHESES=')'.charCodeAt(0);var OPEN_CURLY='{'.charCodeAt(0);var CLOSE_CURLY='}'.charCodeAt(0);var SEMICOLON=';'.charCodeAt(0);var ASTERISK='*'.charCodeAt(0);var COLON=':'.charCodeAt(0);var AT='@'.charCodeAt(0);var RE_AT_END=/[ \n\t\r\f{}()'"\\;/[\]#]/g;var RE_WORD_END=/[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g;var RE_BAD_BRACKET=/.[\\/("'\n]/;var RE_HEX_ESCAPE=/[a-f0-9]/i;function tokenizer(input,options){if(options===void 0){options={};}var css=input.css.valueOf();var ignore=options.ignoreErrors;var code,next,quote,lines,last,content,escape;var nextLine,nextOffset,escaped,escapePos,prev,n,currentToken;var length=css.length;var offset=-1;var line=1;var pos=0;var buffer=[];var returned=[];function position(){return pos;}function unclosed(what){throw input.error('Unclosed '+what,line,pos-offset);}function endOfFile(){return returned.length===0&&pos>=length;}function nextToken(opts){if(returned.length)return returned.pop();if(pos>=length)return;var ignoreUnclosed=opts?opts.ignoreUnclosed:false;code=css.charCodeAt(pos);if(code===NEWLINE||code===FEED||code===CR&&css.charCodeAt(pos+1)!==NEWLINE){offset=pos;line+=1;}switch(code){case NEWLINE:case SPACE:case TAB:case CR:case FEED:next=pos;do{next+=1;code=css.charCodeAt(next);if(code===NEWLINE){offset=next;line+=1;}}while(code===SPACE||code===NEWLINE||code===TAB||code===CR||code===FEED);currentToken=['space',css.slice(pos,next)];pos=next-1;break;case OPEN_SQUARE:case CLOSE_SQUARE:case OPEN_CURLY:case CLOSE_CURLY:case COLON:case SEMICOLON:case CLOSE_PARENTHESES:var controlChar=String.fromCharCode(code);currentToken=[controlChar,controlChar,line,pos-offset];break;case OPEN_PARENTHESES:prev=buffer.length?buffer.pop()[1]:'';n=css.charCodeAt(pos+1);if(prev==='url'&&n!==SINGLE_QUOTE&&n!==DOUBLE_QUOTE&&n!==SPACE&&n!==NEWLINE&&n!==TAB&&n!==FEED&&n!==CR){next=pos;do{escaped=false;next=css.indexOf(')',next+1);if(next===-1){if(ignore||ignoreUnclosed){next=pos;break;}else{unclosed('bracket');}}escapePos=next;while(css.charCodeAt(escapePos-1)===BACKSLASH){escapePos-=1;escaped=!escaped;}}while(escaped);currentToken=['brackets',css.slice(pos,next+1),line,pos-offset,line,next-offset];pos=next;}else{next=css.indexOf(')',pos+1);content=css.slice(pos,next+1);if(next===-1||RE_BAD_BRACKET.test(content)){currentToken=['(','(',line,pos-offset];}else{currentToken=['brackets',content,line,pos-offset,line,next-offset];pos=next;}}break;case SINGLE_QUOTE:case DOUBLE_QUOTE:quote=code===SINGLE_QUOTE?'\'':'"';next=pos;do{escaped=false;next=css.indexOf(quote,next+1);if(next===-1){if(ignore||ignoreUnclosed){next=pos+1;break;}else{unclosed('string');}}escapePos=next;while(css.charCodeAt(escapePos-1)===BACKSLASH){escapePos-=1;escaped=!escaped;}}while(escaped);content=css.slice(pos,next+1);lines=content.split('\n');last=lines.length-1;if(last>0){nextLine=line+last;nextOffset=next-lines[last].length;}else{nextLine=line;nextOffset=offset;}currentToken=['string',css.slice(pos,next+1),line,pos-offset,nextLine,next-nextOffset];offset=nextOffset;line=nextLine;pos=next;break;case AT:RE_AT_END.lastIndex=pos+1;RE_AT_END.test(css);if(RE_AT_END.lastIndex===0){next=css.length-1;}else{next=RE_AT_END.lastIndex-2;}currentToken=['at-word',css.slice(pos,next+1),line,pos-offset,line,next-offset];pos=next;break;case BACKSLASH:next=pos;escape=true;while(css.charCodeAt(next+1)===BACKSLASH){next+=1;escape=!escape;}code=css.charCodeAt(next+1);if(escape&&code!==SLASH&&code!==SPACE&&code!==NEWLINE&&code!==TAB&&code!==CR&&code!==FEED){next+=1;if(RE_HEX_ESCAPE.test(css.charAt(next))){while(RE_HEX_ESCAPE.test(css.charAt(next+1))){next+=1;}if(css.charCodeAt(next+1)===SPACE){next+=1;}}}currentToken=['word',css.slice(pos,next+1),line,pos-offset,line,next-offset];pos=next;break;default:if(code===SLASH&&css.charCodeAt(pos+1)===ASTERISK){next=css.indexOf('*/',pos+2)+1;if(next===0){if(ignore||ignoreUnclosed){next=css.length;}else{unclosed('comment');}}content=css.slice(pos,next+1);lines=content.split('\n');last=lines.length-1;if(last>0){nextLine=line+last;nextOffset=next-lines[last].length;}else{nextLine=line;nextOffset=offset;}currentToken=['comment',content,line,pos-offset,nextLine,next-nextOffset];offset=nextOffset;line=nextLine;pos=next;}else{RE_WORD_END.lastIndex=pos+1;RE_WORD_END.test(css);if(RE_WORD_END.lastIndex===0){next=css.length-1;}else{next=RE_WORD_END.lastIndex-2;}currentToken=['word',css.slice(pos,next+1),line,pos-offset,line,next-offset];buffer.push(currentToken);pos=next;}break;}pos++;return currentToken;}function back(token){returned.push(token);}return{back:back,nextToken:nextToken,endOfFile:endOfFile,position:position};}module.exports=exports["default"];},{}],190:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;/**
	 * Contains helpers for working with vendor prefixes.
	 *
	 * @example
	 * const vendor = postcss.vendor
	 *
	 * @namespace vendor
	 */var vendor={/**
	   * Returns the vendor prefix extracted from an input string.
	   *
	   * @param {string} prop String with or without vendor prefix.
	   *
	   * @return {string} vendor prefix or empty string
	   *
	   * @example
	   * postcss.vendor.prefix('-moz-tab-size') //=> '-moz-'
	   * postcss.vendor.prefix('tab-size')      //=> ''
	   */prefix:function prefix(prop){var match=prop.match(/^(-\w+-)/);if(match){return match[0];}return'';},/**
	     * Returns the input string stripped of its vendor prefix.
	     *
	     * @param {string} prop String with or without vendor prefix.
	     *
	     * @return {string} String name without vendor prefixes.
	     *
	     * @example
	     * postcss.vendor.unprefixed('-moz-tab-size') //=> 'tab-size'
	     */unprefixed:function unprefixed(prop){return prop.replace(/^-\w+-/,'');}};var _default=vendor;exports["default"]=_default;module.exports=exports["default"];},{}],191:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=warnOnce;var printed={};function warnOnce(message){if(printed[message])return;printed[message]=true;if(typeof console!=='undefined'&&console.warn){console.warn(message);}}module.exports=exports["default"];},{}],192:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;/**
	 * Represents a plugin’s warning. It can be created using {@link Node#warn}.
	 *
	 * @example
	 * if (decl.important) {
	 *   decl.warn(result, 'Avoid !important', { word: '!important' })
	 * }
	 */var Warning=/*#__PURE__*/function(){/**
	   * @param {string} text        Warning message.
	   * @param {Object} [opts]      Warning options.
	   * @param {Node}   opts.node   CSS node that caused the warning.
	   * @param {string} opts.word   Word in CSS source that caused the warning.
	   * @param {number} opts.index  Index in CSS node string that caused
	   *                             the warning.
	   * @param {string} opts.plugin Name of the plugin that created
	   *                             this warning. {@link Result#warn} fills
	   *                             this property automatically.
	   */function Warning(text,opts){if(opts===void 0){opts={};}/**
	     * Type to filter warnings from {@link Result#messages}.
	     * Always equal to `"warning"`.
	     *
	     * @type {string}
	     *
	     * @example
	     * const nonWarning = result.messages.filter(i => i.type !== 'warning')
	     */this.type='warning';/**
	     * The warning message.
	     *
	     * @type {string}
	     *
	     * @example
	     * warning.text //=> 'Try to avoid !important'
	     */this.text=text;if(opts.node&&opts.node.source){var pos=opts.node.positionBy(opts);/**
	       * Line in the input file with this warning’s source.
	       * @type {number}
	       *
	       * @example
	       * warning.line //=> 5
	       */this.line=pos.line;/**
	       * Column in the input file with this warning’s source.
	       *
	       * @type {number}
	       *
	       * @example
	       * warning.column //=> 6
	       */this.column=pos.column;}for(var opt in opts){this[opt]=opts[opt];}}/**
	   * Returns a warning position and message.
	   *
	   * @example
	   * warning.toString() //=> 'postcss-lint:a.css:10:14: Avoid !important'
	   *
	   * @return {string} Warning position and message.
	   */var _proto=Warning.prototype;_proto.toString=function toString(){if(this.node){return this.node.error(this.text,{plugin:this.plugin,index:this.index,word:this.word}).message;}if(this.plugin){return this.plugin+': '+this.text;}return this.text;}/**
	   * @memberof Warning#
	   * @member {string} plugin The name of the plugin that created
	   *                         it will fill this property automatically.
	   *                         this warning. When you call {@link Node#warn}
	   *
	   * @example
	   * warning.plugin //=> 'postcss-important'
	   */ /**
	   * @memberof Warning#
	   * @member {Node} node Contains the CSS node that caused the warning.
	   *
	   * @example
	   * warning.node.toString() //=> 'color: white !important'
	   */;return Warning;}();var _default=Warning;exports["default"]=_default;module.exports=exports["default"];},{}],193:[function(require,module,exports){// shim for using process in browser
	var process=module.exports={};// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error('setTimeout has not been defined');}function defaultClearTimeout(){throw new Error('clearTimeout has not been defined');}(function(){try{if(typeof setTimeout==='function'){cachedSetTimeout=setTimeout;}else{cachedSetTimeout=defaultSetTimout;}}catch(e){cachedSetTimeout=defaultSetTimout;}try{if(typeof clearTimeout==='function'){cachedClearTimeout=clearTimeout;}else{cachedClearTimeout=defaultClearTimeout;}}catch(e){cachedClearTimeout=defaultClearTimeout;}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){//normal enviroments in sane situations
	return setTimeout(fun,0);}// if setTimeout wasn't available but was latter defined
	if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
	return cachedSetTimeout(fun,0);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	return cachedSetTimeout.call(null,fun,0);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	return cachedSetTimeout.call(this,fun,0);}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){//normal enviroments in sane situations
	return clearTimeout(marker);}// if clearTimeout wasn't available but was latter defined
	if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
	return cachedClearTimeout(marker);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	return cachedClearTimeout.call(null,marker);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	// Some versions of I.E. have different rules for clearTimeout vs setTimeout
	return cachedClearTimeout.call(this,marker);}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return;}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else{queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;runClearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue);}};// v8 likes predictible objects
	function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
	process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return[];};process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return'/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};},{}],194:[function(require,module,exports){(function(global){/*! https://mths.be/punycode v1.4.1 by @mathias */;(function(root){/** Detect free variables */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;var freeModule=_typeof(module)=='object'&&module&&!module.nodeType&&module;var freeGlobal=_typeof(global)=='object'&&global;if(freeGlobal.global===freeGlobal||freeGlobal.window===freeGlobal||freeGlobal.self===freeGlobal){root=freeGlobal;}/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */var punycode,/** Highest positive signed 32-bit float value */maxInt=2147483647,// aka. 0x7FFFFFFF or 2^31-1
	/** Bootstring parameters */base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128,// 0x80
	delimiter='-',// '\x2D'
	/** Regular expressions */regexPunycode=/^xn--/,regexNonASCII=/[^\x20-\x7E]/,// unprintable ASCII chars + non-ASCII chars
	regexSeparators=/[\x2E\u3002\uFF0E\uFF61]/g,// RFC 3490 separators
	/** Error messages */errors={'overflow':'Overflow: input needs wider integers to process','not-basic':'Illegal input >= 0x80 (not a basic code point)','invalid-input':'Invalid input'},/** Convenience shortcuts */baseMinusTMin=base-tMin,floor=Math.floor,stringFromCharCode=String.fromCharCode,/** Temporary variable */key;/*--------------------------------------------------------------------------*/ /**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */function error(type){throw new RangeError(errors[type]);}/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */function map(array,fn){var length=array.length;var result=[];while(length--){result[length]=fn(array[length]);}return result;}/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */function mapDomain(string,fn){var parts=string.split('@');var result='';if(parts.length>1){// In email addresses, only the domain name should be punycoded. Leave
	// the local part (i.e. everything up to `@`) intact.
	result=parts[0]+'@';string=parts[1];}// Avoid `split(regex)` for IE8 compatibility. See #17.
	string=string.replace(regexSeparators,'\x2E');var labels=string.split('.');var encoded=map(labels,fn).join('.');return result+encoded;}/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */function ucs2decode(string){var output=[],counter=0,length=string.length,value,extra;while(counter<length){value=string.charCodeAt(counter++);if(value>=0xD800&&value<=0xDBFF&&counter<length){// high surrogate, and there is a next character
	extra=string.charCodeAt(counter++);if((extra&0xFC00)==0xDC00){// low surrogate
	output.push(((value&0x3FF)<<10)+(extra&0x3FF)+0x10000);}else{// unmatched surrogate; only append this code unit, in case the next
	// code unit is the high surrogate of a surrogate pair
	output.push(value);counter--;}}else{output.push(value);}}return output;}/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */function ucs2encode(array){return map(array,function(value){var output='';if(value>0xFFFF){value-=0x10000;output+=stringFromCharCode(value>>>10&0x3FF|0xD800);value=0xDC00|value&0x3FF;}output+=stringFromCharCode(value);return output;}).join('');}/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */function basicToDigit(codePoint){if(codePoint-48<10){return codePoint-22;}if(codePoint-65<26){return codePoint-65;}if(codePoint-97<26){return codePoint-97;}return base;}/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */function digitToBasic(digit,flag){//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit+22+75*(digit<26)-((flag!=0)<<5);}/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */function adapt(delta,numPoints,firstTime){var k=0;delta=firstTime?floor(delta/damp):delta>>1;delta+=floor(delta/numPoints);for(;/* no initialization */delta>baseMinusTMin*tMax>>1;k+=base){delta=floor(delta/baseMinusTMin);}return floor(k+(baseMinusTMin+1)*delta/(delta+skew));}/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */function decode(input){// Don't use UCS-2
	var output=[],inputLength=input.length,out,i=0,n=initialN,bias=initialBias,basic,j,index,oldi,w,k,digit,t,/** Cached calculation results */baseMinusT;// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.
	basic=input.lastIndexOf(delimiter);if(basic<0){basic=0;}for(j=0;j<basic;++j){// if it's not a basic code point
	if(input.charCodeAt(j)>=0x80){error('not-basic');}output.push(input.charCodeAt(j));}// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.
	for(index=basic>0?basic+1:0;index<inputLength;)/* no final expression */{// `index` is the index of the next character to be consumed.
	// Decode a generalized variable-length integer into `delta`,
	// which gets added to `i`. The overflow checking is easier
	// if we increase `i` as we go, then subtract off its starting
	// value at the end to obtain `delta`.
	for(oldi=i,w=1,k=base;;/* no condition */k+=base){if(index>=inputLength){error('invalid-input');}digit=basicToDigit(input.charCodeAt(index++));if(digit>=base||digit>floor((maxInt-i)/w)){error('overflow');}i+=digit*w;t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(digit<t){break;}baseMinusT=base-t;if(w>floor(maxInt/baseMinusT)){error('overflow');}w*=baseMinusT;}out=output.length+1;bias=adapt(i-oldi,out,oldi==0);// `i` was supposed to wrap around from `out` to `0`,
	// incrementing `n` each time, so we'll fix that now:
	if(floor(i/out)>maxInt-n){error('overflow');}n+=floor(i/out);i%=out;// Insert `n` at position `i` of the output
	output.splice(i++,0,n);}return ucs2encode(output);}/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */function encode(input){var n,delta,handledCPCount,basicLength,bias,j,m,q,k,t,currentValue,output=[],/** `inputLength` will hold the number of code points in `input`. */inputLength,/** Cached calculation results */handledCPCountPlusOne,baseMinusT,qMinusT;// Convert the input in UCS-2 to Unicode
	input=ucs2decode(input);// Cache the length
	inputLength=input.length;// Initialize the state
	n=initialN;delta=0;bias=initialBias;// Handle the basic code points
	for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<0x80){output.push(stringFromCharCode(currentValue));}}handledCPCount=basicLength=output.length;// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.
	// Finish the basic string - if it is not empty - with a delimiter
	if(basicLength){output.push(delimiter);}// Main encoding loop:
	while(handledCPCount<inputLength){// All non-basic code points < n have been handled already. Find the next
	// larger one:
	for(m=maxInt,j=0;j<inputLength;++j){currentValue=input[j];if(currentValue>=n&&currentValue<m){m=currentValue;}}// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	// but guard against overflow
	handledCPCountPlusOne=handledCPCount+1;if(m-n>floor((maxInt-delta)/handledCPCountPlusOne)){error('overflow');}delta+=(m-n)*handledCPCountPlusOne;n=m;for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<n&&++delta>maxInt){error('overflow');}if(currentValue==n){// Represent delta as a generalized variable-length integer
	for(q=delta,k=base;;/* no condition */k+=base){t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(q<t){break;}qMinusT=q-t;baseMinusT=base-t;output.push(stringFromCharCode(digitToBasic(t+qMinusT%baseMinusT,0)));q=floor(qMinusT/baseMinusT);}output.push(stringFromCharCode(digitToBasic(q,0)));bias=adapt(delta,handledCPCountPlusOne,handledCPCount==basicLength);delta=0;++handledCPCount;}}++delta;++n;}return output.join('');}/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */function toUnicode(input){return mapDomain(input,function(string){return regexPunycode.test(string)?decode(string.slice(4).toLowerCase()):string;});}/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */function toASCII(input){return mapDomain(input,function(string){return regexNonASCII.test(string)?'xn--'+encode(string):string;});}/*--------------------------------------------------------------------------*/ /** Define the public API */punycode={/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */'version':'1.4.1',/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */'ucs2':{'decode':ucs2decode,'encode':ucs2encode},'decode':decode,'encode':encode,'toASCII':toASCII,'toUnicode':toUnicode};/** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if(typeof define=='function'&&_typeof(define.amd)=='object'&&define.amd){define('punycode',function(){return punycode;});}else if(freeExports&&freeModule){if(module.exports==freeExports){// in Node.js, io.js, or RingoJS v0.8.0+
	freeModule.exports=punycode;}else{// in Narwhal or RingoJS v0.7.0-
	for(key in punycode){punycode.hasOwnProperty(key)&&(freeExports[key]=punycode[key]);}}}else{// in Rhino or a web browser
	root.punycode=punycode;}})(this);}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],195:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);}module.exports=function(qs,sep,eq,options){sep=sep||'&';eq=eq||'=';var obj={};if(typeof qs!=='string'||qs.length===0){return obj;}var regexp=/\+/g;qs=qs.split(sep);var maxKeys=1000;if(options&&typeof options.maxKeys==='number'){maxKeys=options.maxKeys;}var len=qs.length;// maxKeys <= 0 means that we should not limit keys count
	if(maxKeys>0&&len>maxKeys){len=maxKeys;}for(var i=0;i<len;++i){var x=qs[i].replace(regexp,'%20'),idx=x.indexOf(eq),kstr,vstr,k,v;if(idx>=0){kstr=x.substr(0,idx);vstr=x.substr(idx+1);}else{kstr=x;vstr='';}k=decodeURIComponent(kstr);v=decodeURIComponent(vstr);if(!hasOwnProperty(obj,k)){obj[k]=v;}else if(isArray(obj[k])){obj[k].push(v);}else{obj[k]=[obj[k],v];}}return obj;};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};},{}],196:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';var stringifyPrimitive=function stringifyPrimitive(v){switch(_typeof(v)){case'string':return v;case'boolean':return v?'true':'false';case'number':return isFinite(v)?v:'';default:return'';}};module.exports=function(obj,sep,eq,name){sep=sep||'&';eq=eq||'=';if(obj===null){obj=undefined;}if(_typeof(obj)==='object'){return map(objectKeys(obj),function(k){var ks=encodeURIComponent(stringifyPrimitive(k))+eq;if(isArray(obj[k])){return map(obj[k],function(v){return ks+encodeURIComponent(stringifyPrimitive(v));}).join(sep);}else{return ks+encodeURIComponent(stringifyPrimitive(obj[k]));}}).join(sep);}if(!name)return'';return encodeURIComponent(stringifyPrimitive(name))+eq+encodeURIComponent(stringifyPrimitive(obj));};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};function map(xs,f){if(xs.map)return xs.map(f);var res=[];for(var i=0;i<xs.length;i++){res.push(f(xs[i],i));}return res;}var objectKeys=Object.keys||function(obj){var res=[];for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))res.push(key);}return res;};},{}],197:[function(require,module,exports){'use strict';exports.decode=exports.parse=require('./decode');exports.encode=exports.stringify=require('./encode');},{"./decode":195,"./encode":196}],198:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var util=require('./util');var has=Object.prototype.hasOwnProperty;var hasNativeMap=typeof Map!=="undefined";/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */function ArraySet(){this._array=[];this._set=hasNativeMap?new Map():Object.create(null);}/**
	 * Static method for creating ArraySet instances from an existing array.
	 */ArraySet.fromArray=function ArraySet_fromArray(aArray,aAllowDuplicates){var set=new ArraySet();for(var i=0,len=aArray.length;i<len;i++){set.add(aArray[i],aAllowDuplicates);}return set;};/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */ArraySet.prototype.size=function ArraySet_size(){return hasNativeMap?this._set.size:Object.getOwnPropertyNames(this._set).length;};/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */ArraySet.prototype.add=function ArraySet_add(aStr,aAllowDuplicates){var sStr=hasNativeMap?aStr:util.toSetString(aStr);var isDuplicate=hasNativeMap?this.has(aStr):has.call(this._set,sStr);var idx=this._array.length;if(!isDuplicate||aAllowDuplicates){this._array.push(aStr);}if(!isDuplicate){if(hasNativeMap){this._set.set(aStr,idx);}else{this._set[sStr]=idx;}}};/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */ArraySet.prototype.has=function ArraySet_has(aStr){if(hasNativeMap){return this._set.has(aStr);}else{var sStr=util.toSetString(aStr);return has.call(this._set,sStr);}};/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */ArraySet.prototype.indexOf=function ArraySet_indexOf(aStr){if(hasNativeMap){var idx=this._set.get(aStr);if(idx>=0){return idx;}}else{var sStr=util.toSetString(aStr);if(has.call(this._set,sStr)){return this._set[sStr];}}throw new Error('"'+aStr+'" is not in the set.');};/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */ArraySet.prototype.at=function ArraySet_at(aIdx){if(aIdx>=0&&aIdx<this._array.length){return this._array[aIdx];}throw new Error('No element indexed by '+aIdx);};/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */ArraySet.prototype.toArray=function ArraySet_toArray(){return this._array.slice();};exports.ArraySet=ArraySet;},{"./util":207}],199:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */var base64=require('./base64');// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	var VLQ_BASE_SHIFT=5;// binary: 100000
	var VLQ_BASE=1<<VLQ_BASE_SHIFT;// binary: 011111
	var VLQ_BASE_MASK=VLQ_BASE-1;// binary: 100000
	var VLQ_CONTINUATION_BIT=VLQ_BASE;/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */function toVLQSigned(aValue){return aValue<0?(-aValue<<1)+1:(aValue<<1)+0;}/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */function fromVLQSigned(aValue){var isNegative=(aValue&1)===1;var shifted=aValue>>1;return isNegative?-shifted:shifted;}/**
	 * Returns the base 64 VLQ encoded value.
	 */exports.encode=function base64VLQ_encode(aValue){var encoded="";var digit;var vlq=toVLQSigned(aValue);do{digit=vlq&VLQ_BASE_MASK;vlq>>>=VLQ_BASE_SHIFT;if(vlq>0){// There are still more digits in this value, so we must make sure the
	// continuation bit is marked.
	digit|=VLQ_CONTINUATION_BIT;}encoded+=base64.encode(digit);}while(vlq>0);return encoded;};/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */exports.decode=function base64VLQ_decode(aStr,aIndex,aOutParam){var strLen=aStr.length;var result=0;var shift=0;var continuation,digit;do{if(aIndex>=strLen){throw new Error("Expected more digits in base 64 VLQ value.");}digit=base64.decode(aStr.charCodeAt(aIndex++));if(digit===-1){throw new Error("Invalid base64 digit: "+aStr.charAt(aIndex-1));}continuation=!!(digit&VLQ_CONTINUATION_BIT);digit&=VLQ_BASE_MASK;result=result+(digit<<shift);shift+=VLQ_BASE_SHIFT;}while(continuation);aOutParam.value=fromVLQSigned(result);aOutParam.rest=aIndex;};},{"./base64":200}],200:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var intToCharMap='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */exports.encode=function(number){if(0<=number&&number<intToCharMap.length){return intToCharMap[number];}throw new TypeError("Must be between 0 and 63: "+number);};/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */exports.decode=function(charCode){var bigA=65;// 'A'
	var bigZ=90;// 'Z'
	var littleA=97;// 'a'
	var littleZ=122;// 'z'
	var zero=48;// '0'
	var nine=57;// '9'
	var plus=43;// '+'
	var slash=47;// '/'
	var littleOffset=26;var numberOffset=52;// 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	if(bigA<=charCode&&charCode<=bigZ){return charCode-bigA;}// 26 - 51: abcdefghijklmnopqrstuvwxyz
	if(littleA<=charCode&&charCode<=littleZ){return charCode-littleA+littleOffset;}// 52 - 61: 0123456789
	if(zero<=charCode&&charCode<=nine){return charCode-zero+numberOffset;}// 62: +
	if(charCode==plus){return 62;}// 63: /
	if(charCode==slash){return 63;}// Invalid base64 digit.
	return-1;};},{}],201:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */exports.GREATEST_LOWER_BOUND=1;exports.LEAST_UPPER_BOUND=2;/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */function recursiveSearch(aLow,aHigh,aNeedle,aHaystack,aCompare,aBias){// This function terminates when one of the following is true:
	//
	//   1. We find the exact element we are looking for.
	//
	//   2. We did not find the exact element, but we can return the index of
	//      the next-closest element.
	//
	//   3. We did not find the exact element, and there is no next-closest
	//      element than the one we are searching for, so we return -1.
	var mid=Math.floor((aHigh-aLow)/2)+aLow;var cmp=aCompare(aNeedle,aHaystack[mid],true);if(cmp===0){// Found the element we are looking for.
	return mid;}else if(cmp>0){// Our needle is greater than aHaystack[mid].
	if(aHigh-mid>1){// The element is in the upper half.
	return recursiveSearch(mid,aHigh,aNeedle,aHaystack,aCompare,aBias);}// The exact needle element was not found in this haystack. Determine if
	// we are in termination case (3) or (2) and return the appropriate thing.
	if(aBias==exports.LEAST_UPPER_BOUND){return aHigh<aHaystack.length?aHigh:-1;}else{return mid;}}else{// Our needle is less than aHaystack[mid].
	if(mid-aLow>1){// The element is in the lower half.
	return recursiveSearch(aLow,mid,aNeedle,aHaystack,aCompare,aBias);}// we are in termination case (3) or (2) and return the appropriate thing.
	if(aBias==exports.LEAST_UPPER_BOUND){return mid;}else{return aLow<0?-1:aLow;}}}/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */exports.search=function search(aNeedle,aHaystack,aCompare,aBias){if(aHaystack.length===0){return-1;}var index=recursiveSearch(-1,aHaystack.length,aNeedle,aHaystack,aCompare,aBias||exports.GREATEST_LOWER_BOUND);if(index<0){return-1;}// We have found either the exact element, or the next-closest element than
	// the one we are searching for. However, there may be more than one such
	// element. Make sure we always return the smallest of these.
	while(index-1>=0){if(aCompare(aHaystack[index],aHaystack[index-1],true)!==0){break;}--index;}return index;};},{}],202:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var util=require('./util');/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */function generatedPositionAfter(mappingA,mappingB){// Optimized for most common case
	var lineA=mappingA.generatedLine;var lineB=mappingB.generatedLine;var columnA=mappingA.generatedColumn;var columnB=mappingB.generatedColumn;return lineB>lineA||lineB==lineA&&columnB>=columnA||util.compareByGeneratedPositionsInflated(mappingA,mappingB)<=0;}/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */function MappingList(){this._array=[];this._sorted=true;// Serves as infimum
	this._last={generatedLine:-1,generatedColumn:0};}/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */MappingList.prototype.unsortedForEach=function MappingList_forEach(aCallback,aThisArg){this._array.forEach(aCallback,aThisArg);};/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */MappingList.prototype.add=function MappingList_add(aMapping){if(generatedPositionAfter(this._last,aMapping)){this._last=aMapping;this._array.push(aMapping);}else{this._sorted=false;this._array.push(aMapping);}};/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */MappingList.prototype.toArray=function MappingList_toArray(){if(!this._sorted){this._array.sort(util.compareByGeneratedPositionsInflated);this._sorted=true;}return this._array;};exports.MappingList=MappingList;},{"./util":207}],203:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */ // It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */function swap(ary,x,y){var temp=ary[x];ary[x]=ary[y];ary[y]=temp;}/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */function randomIntInRange(low,high){return Math.round(low+Math.random()*(high-low));}/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */function doQuickSort(ary,comparator,p,r){// If our lower bound is less than our upper bound, we (1) partition the
	// array into two pieces and (2) recurse on each half. If it is not, this is
	// the empty array and our base case.
	if(p<r){// (1) Partitioning.
	//
	// The partitioning chooses a pivot between `p` and `r` and moves all
	// elements that are less than or equal to the pivot to the before it, and
	// all the elements that are greater than it after it. The effect is that
	// once partition is done, the pivot is in the exact place it will be when
	// the array is put in sorted order, and it will not need to be moved
	// again. This runs in O(n) time.
	// Always choose a random pivot so that an input array which is reverse
	// sorted does not cause O(n^2) running time.
	var pivotIndex=randomIntInRange(p,r);var i=p-1;swap(ary,pivotIndex,r);var pivot=ary[r];// Immediately after `j` is incremented in this loop, the following hold
	// true:
	//
	//   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	//
	//   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	for(var j=p;j<r;j++){if(comparator(ary[j],pivot)<=0){i+=1;swap(ary,i,j);}}swap(ary,i+1,j);var q=i+1;// (2) Recurse on each half.
	doQuickSort(ary,comparator,p,q-1);doQuickSort(ary,comparator,q+1,r);}}/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */exports.quickSort=function(ary,comparator){doQuickSort(ary,comparator,0,ary.length-1);};},{}],204:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var util=require('./util');var binarySearch=require('./binary-search');var ArraySet=require('./array-set').ArraySet;var base64VLQ=require('./base64-vlq');var quickSort=require('./quick-sort').quickSort;function SourceMapConsumer(aSourceMap,aSourceMapURL){var sourceMap=aSourceMap;if(typeof aSourceMap==='string'){sourceMap=util.parseSourceMapInput(aSourceMap);}return sourceMap.sections!=null?new IndexedSourceMapConsumer(sourceMap,aSourceMapURL):new BasicSourceMapConsumer(sourceMap,aSourceMapURL);}SourceMapConsumer.fromSourceMap=function(aSourceMap,aSourceMapURL){return BasicSourceMapConsumer.fromSourceMap(aSourceMap,aSourceMapURL);};/**
	 * The version of the source mapping spec that we are consuming.
	 */SourceMapConsumer.prototype._version=3;// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	SourceMapConsumer.prototype.__generatedMappings=null;Object.defineProperty(SourceMapConsumer.prototype,'_generatedMappings',{configurable:true,enumerable:true,get:function get(){if(!this.__generatedMappings){this._parseMappings(this._mappings,this.sourceRoot);}return this.__generatedMappings;}});SourceMapConsumer.prototype.__originalMappings=null;Object.defineProperty(SourceMapConsumer.prototype,'_originalMappings',{configurable:true,enumerable:true,get:function get(){if(!this.__originalMappings){this._parseMappings(this._mappings,this.sourceRoot);}return this.__originalMappings;}});SourceMapConsumer.prototype._charIsMappingSeparator=function SourceMapConsumer_charIsMappingSeparator(aStr,index){var c=aStr.charAt(index);return c===";"||c===",";};/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */SourceMapConsumer.prototype._parseMappings=function SourceMapConsumer_parseMappings(aStr,aSourceRoot){throw new Error("Subclasses must implement _parseMappings");};SourceMapConsumer.GENERATED_ORDER=1;SourceMapConsumer.ORIGINAL_ORDER=2;SourceMapConsumer.GREATEST_LOWER_BOUND=1;SourceMapConsumer.LEAST_UPPER_BOUND=2;/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */SourceMapConsumer.prototype.eachMapping=function SourceMapConsumer_eachMapping(aCallback,aContext,aOrder){var context=aContext||null;var order=aOrder||SourceMapConsumer.GENERATED_ORDER;var mappings;switch(order){case SourceMapConsumer.GENERATED_ORDER:mappings=this._generatedMappings;break;case SourceMapConsumer.ORIGINAL_ORDER:mappings=this._originalMappings;break;default:throw new Error("Unknown order of iteration.");}var sourceRoot=this.sourceRoot;mappings.map(function(mapping){var source=mapping.source===null?null:this._sources.at(mapping.source);source=util.computeSourceURL(sourceRoot,source,this._sourceMapURL);return{source:source,generatedLine:mapping.generatedLine,generatedColumn:mapping.generatedColumn,originalLine:mapping.originalLine,originalColumn:mapping.originalColumn,name:mapping.name===null?null:this._names.at(mapping.name)};},this).forEach(aCallback,context);};/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.  The line number is 1-based.
	 *   - column: Optional. the column number in the original source.
	 *    The column number is 0-based.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.  The
	 *    line number is 1-based.
	 *   - column: The column number in the generated source, or null.
	 *    The column number is 0-based.
	 */SourceMapConsumer.prototype.allGeneratedPositionsFor=function SourceMapConsumer_allGeneratedPositionsFor(aArgs){var line=util.getArg(aArgs,'line');// When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	// returns the index of the closest mapping less than the needle. By
	// setting needle.originalColumn to 0, we thus find the last mapping for
	// the given line, provided such a mapping exists.
	var needle={source:util.getArg(aArgs,'source'),originalLine:line,originalColumn:util.getArg(aArgs,'column',0)};needle.source=this._findSourceIndex(needle.source);if(needle.source<0){return[];}var mappings=[];var index=this._findMapping(needle,this._originalMappings,"originalLine","originalColumn",util.compareByOriginalPositions,binarySearch.LEAST_UPPER_BOUND);if(index>=0){var mapping=this._originalMappings[index];if(aArgs.column===undefined){var originalLine=mapping.originalLine;// Iterate until either we run out of mappings, or we run into
	// a mapping for a different line than the one we found. Since
	// mappings are sorted, this is guaranteed to find all mappings for
	// the line we found.
	while(mapping&&mapping.originalLine===originalLine){mappings.push({line:util.getArg(mapping,'generatedLine',null),column:util.getArg(mapping,'generatedColumn',null),lastColumn:util.getArg(mapping,'lastGeneratedColumn',null)});mapping=this._originalMappings[++index];}}else{var originalColumn=mapping.originalColumn;// Iterate until either we run out of mappings, or we run into
	// a mapping for a different line than the one we were searching for.
	// Since mappings are sorted, this is guaranteed to find all mappings for
	// the line we are searching for.
	while(mapping&&mapping.originalLine===line&&mapping.originalColumn==originalColumn){mappings.push({line:util.getArg(mapping,'generatedLine',null),column:util.getArg(mapping,'generatedColumn',null),lastColumn:util.getArg(mapping,'lastGeneratedColumn',null)});mapping=this._originalMappings[++index];}}}return mappings;};exports.SourceMapConsumer=SourceMapConsumer;/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The first parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * The second parameter, if given, is a string whose value is the URL
	 * at which the source map was found.  This URL is used to compute the
	 * sources array.
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */function BasicSourceMapConsumer(aSourceMap,aSourceMapURL){var sourceMap=aSourceMap;if(typeof aSourceMap==='string'){sourceMap=util.parseSourceMapInput(aSourceMap);}var version=util.getArg(sourceMap,'version');var sources=util.getArg(sourceMap,'sources');// Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	// requires the array) to play nice here.
	var names=util.getArg(sourceMap,'names',[]);var sourceRoot=util.getArg(sourceMap,'sourceRoot',null);var sourcesContent=util.getArg(sourceMap,'sourcesContent',null);var mappings=util.getArg(sourceMap,'mappings');var file=util.getArg(sourceMap,'file',null);// Once again, Sass deviates from the spec and supplies the version as a
	// string rather than a number, so we use loose equality checking here.
	if(version!=this._version){throw new Error('Unsupported version: '+version);}if(sourceRoot){sourceRoot=util.normalize(sourceRoot);}sources=sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
	// "foo.js".  Normalize these first so that future comparisons will succeed.
	// See bugzil.la/1090768.
	.map(util.normalize)// Always ensure that absolute sources are internally stored relative to
	// the source root, if the source root is absolute. Not doing this would
	// be particularly problematic when the source root is a prefix of the
	// source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	.map(function(source){return sourceRoot&&util.isAbsolute(sourceRoot)&&util.isAbsolute(source)?util.relative(sourceRoot,source):source;});// Pass `true` below to allow duplicate names and sources. While source maps
	// are intended to be compressed and deduplicated, the TypeScript compiler
	// sometimes generates source maps with duplicates in them. See Github issue
	// #72 and bugzil.la/889492.
	this._names=ArraySet.fromArray(names.map(String),true);this._sources=ArraySet.fromArray(sources,true);this._absoluteSources=this._sources.toArray().map(function(s){return util.computeSourceURL(sourceRoot,s,aSourceMapURL);});this.sourceRoot=sourceRoot;this.sourcesContent=sourcesContent;this._mappings=mappings;this._sourceMapURL=aSourceMapURL;this.file=file;}BasicSourceMapConsumer.prototype=Object.create(SourceMapConsumer.prototype);BasicSourceMapConsumer.prototype.consumer=SourceMapConsumer;/**
	 * Utility function to find the index of a source.  Returns -1 if not
	 * found.
	 */BasicSourceMapConsumer.prototype._findSourceIndex=function(aSource){var relativeSource=aSource;if(this.sourceRoot!=null){relativeSource=util.relative(this.sourceRoot,relativeSource);}if(this._sources.has(relativeSource)){return this._sources.indexOf(relativeSource);}// Maybe aSource is an absolute URL as returned by |sources|.  In
	// this case we can't simply undo the transform.
	var i;for(i=0;i<this._absoluteSources.length;++i){if(this._absoluteSources[i]==aSource){return i;}}return-1;};/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @param String aSourceMapURL
	 *        The URL at which the source map can be found (optional)
	 * @returns BasicSourceMapConsumer
	 */BasicSourceMapConsumer.fromSourceMap=function SourceMapConsumer_fromSourceMap(aSourceMap,aSourceMapURL){var smc=Object.create(BasicSourceMapConsumer.prototype);var names=smc._names=ArraySet.fromArray(aSourceMap._names.toArray(),true);var sources=smc._sources=ArraySet.fromArray(aSourceMap._sources.toArray(),true);smc.sourceRoot=aSourceMap._sourceRoot;smc.sourcesContent=aSourceMap._generateSourcesContent(smc._sources.toArray(),smc.sourceRoot);smc.file=aSourceMap._file;smc._sourceMapURL=aSourceMapURL;smc._absoluteSources=smc._sources.toArray().map(function(s){return util.computeSourceURL(smc.sourceRoot,s,aSourceMapURL);});// Because we are modifying the entries (by converting string sources and
	// names to indices into the sources and names ArraySets), we have to make
	// a copy of the entry or else bad things happen. Shared mutable state
	// strikes again! See github issue #191.
	var generatedMappings=aSourceMap._mappings.toArray().slice();var destGeneratedMappings=smc.__generatedMappings=[];var destOriginalMappings=smc.__originalMappings=[];for(var i=0,length=generatedMappings.length;i<length;i++){var srcMapping=generatedMappings[i];var destMapping=new Mapping();destMapping.generatedLine=srcMapping.generatedLine;destMapping.generatedColumn=srcMapping.generatedColumn;if(srcMapping.source){destMapping.source=sources.indexOf(srcMapping.source);destMapping.originalLine=srcMapping.originalLine;destMapping.originalColumn=srcMapping.originalColumn;if(srcMapping.name){destMapping.name=names.indexOf(srcMapping.name);}destOriginalMappings.push(destMapping);}destGeneratedMappings.push(destMapping);}quickSort(smc.__originalMappings,util.compareByOriginalPositions);return smc;};/**
	 * The version of the source mapping spec that we are consuming.
	 */BasicSourceMapConsumer.prototype._version=3;/**
	 * The list of original sources.
	 */Object.defineProperty(BasicSourceMapConsumer.prototype,'sources',{get:function get(){return this._absoluteSources.slice();}});/**
	 * Provide the JIT with a nice shape / hidden class.
	 */function Mapping(){this.generatedLine=0;this.generatedColumn=0;this.source=null;this.originalLine=null;this.originalColumn=null;this.name=null;}/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */BasicSourceMapConsumer.prototype._parseMappings=function SourceMapConsumer_parseMappings(aStr,aSourceRoot){var generatedLine=1;var previousGeneratedColumn=0;var previousOriginalLine=0;var previousOriginalColumn=0;var previousSource=0;var previousName=0;var length=aStr.length;var index=0;var cachedSegments={};var temp={};var originalMappings=[];var generatedMappings=[];var mapping,str,segment,end,value;while(index<length){if(aStr.charAt(index)===';'){generatedLine++;index++;previousGeneratedColumn=0;}else if(aStr.charAt(index)===','){index++;}else{mapping=new Mapping();mapping.generatedLine=generatedLine;// Because each offset is encoded relative to the previous one,
	// many segments often have the same encoding. We can exploit this
	// fact by caching the parsed variable length fields of each segment,
	// allowing us to avoid a second parse if we encounter the same
	// segment again.
	for(end=index;end<length;end++){if(this._charIsMappingSeparator(aStr,end)){break;}}str=aStr.slice(index,end);segment=cachedSegments[str];if(segment){index+=str.length;}else{segment=[];while(index<end){base64VLQ.decode(aStr,index,temp);value=temp.value;index=temp.rest;segment.push(value);}if(segment.length===2){throw new Error('Found a source, but no line and column');}if(segment.length===3){throw new Error('Found a source and line, but no column');}cachedSegments[str]=segment;}// Generated column.
	mapping.generatedColumn=previousGeneratedColumn+segment[0];previousGeneratedColumn=mapping.generatedColumn;if(segment.length>1){// Original source.
	mapping.source=previousSource+segment[1];previousSource+=segment[1];// Original line.
	mapping.originalLine=previousOriginalLine+segment[2];previousOriginalLine=mapping.originalLine;// Lines are stored 0-based
	mapping.originalLine+=1;// Original column.
	mapping.originalColumn=previousOriginalColumn+segment[3];previousOriginalColumn=mapping.originalColumn;if(segment.length>4){// Original name.
	mapping.name=previousName+segment[4];previousName+=segment[4];}}generatedMappings.push(mapping);if(typeof mapping.originalLine==='number'){originalMappings.push(mapping);}}}quickSort(generatedMappings,util.compareByGeneratedPositionsDeflated);this.__generatedMappings=generatedMappings;quickSort(originalMappings,util.compareByOriginalPositions);this.__originalMappings=originalMappings;};/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */BasicSourceMapConsumer.prototype._findMapping=function SourceMapConsumer_findMapping(aNeedle,aMappings,aLineName,aColumnName,aComparator,aBias){// To return the position we are searching for, we must first find the
	// mapping for the given position and then return the opposite position it
	// points to. Because the mappings are sorted, we can use binary search to
	// find the best mapping.
	if(aNeedle[aLineName]<=0){throw new TypeError('Line must be greater than or equal to 1, got '+aNeedle[aLineName]);}if(aNeedle[aColumnName]<0){throw new TypeError('Column must be greater than or equal to 0, got '+aNeedle[aColumnName]);}return binarySearch.search(aNeedle,aMappings,aComparator,aBias);};/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */BasicSourceMapConsumer.prototype.computeColumnSpans=function SourceMapConsumer_computeColumnSpans(){for(var index=0;index<this._generatedMappings.length;++index){var mapping=this._generatedMappings[index];// Mappings do not contain a field for the last generated columnt. We
	// can come up with an optimistic estimate, however, by assuming that
	// mappings are contiguous (i.e. given two consecutive mappings, the
	// first mapping ends where the second one starts).
	if(index+1<this._generatedMappings.length){var nextMapping=this._generatedMappings[index+1];if(mapping.generatedLine===nextMapping.generatedLine){mapping.lastGeneratedColumn=nextMapping.generatedColumn-1;continue;}}// The last mapping for each line spans the entire line.
	mapping.lastGeneratedColumn=Infinity;}};/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the generated source.  The column
	 *     number is 0-based.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.  The
	 *     line number is 1-based.
	 *   - column: The column number in the original source, or null.  The
	 *     column number is 0-based.
	 *   - name: The original identifier, or null.
	 */BasicSourceMapConsumer.prototype.originalPositionFor=function SourceMapConsumer_originalPositionFor(aArgs){var needle={generatedLine:util.getArg(aArgs,'line'),generatedColumn:util.getArg(aArgs,'column')};var index=this._findMapping(needle,this._generatedMappings,"generatedLine","generatedColumn",util.compareByGeneratedPositionsDeflated,util.getArg(aArgs,'bias',SourceMapConsumer.GREATEST_LOWER_BOUND));if(index>=0){var mapping=this._generatedMappings[index];if(mapping.generatedLine===needle.generatedLine){var source=util.getArg(mapping,'source',null);if(source!==null){source=this._sources.at(source);source=util.computeSourceURL(this.sourceRoot,source,this._sourceMapURL);}var name=util.getArg(mapping,'name',null);if(name!==null){name=this._names.at(name);}return{source:source,line:util.getArg(mapping,'originalLine',null),column:util.getArg(mapping,'originalColumn',null),name:name};}}return{source:null,line:null,column:null,name:null};};/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */BasicSourceMapConsumer.prototype.hasContentsOfAllSources=function BasicSourceMapConsumer_hasContentsOfAllSources(){if(!this.sourcesContent){return false;}return this.sourcesContent.length>=this._sources.size()&&!this.sourcesContent.some(function(sc){return sc==null;});};/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */BasicSourceMapConsumer.prototype.sourceContentFor=function SourceMapConsumer_sourceContentFor(aSource,nullOnMissing){if(!this.sourcesContent){return null;}var index=this._findSourceIndex(aSource);if(index>=0){return this.sourcesContent[index];}var relativeSource=aSource;if(this.sourceRoot!=null){relativeSource=util.relative(this.sourceRoot,relativeSource);}var url;if(this.sourceRoot!=null&&(url=util.urlParse(this.sourceRoot))){// XXX: file:// URIs and absolute paths lead to unexpected behavior for
	// many users. We can help them out when they expect file:// URIs to
	// behave like it would if they were running a local HTTP server. See
	// https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	var fileUriAbsPath=relativeSource.replace(/^file:\/\//,"");if(url.scheme=="file"&&this._sources.has(fileUriAbsPath)){return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];}if((!url.path||url.path=="/")&&this._sources.has("/"+relativeSource)){return this.sourcesContent[this._sources.indexOf("/"+relativeSource)];}}// This function is used recursively from
	// IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	// don't want to throw if we can't find the source - we just want to
	// return null, so we provide a flag to exit gracefully.
	if(nullOnMissing){return null;}else{throw new Error('"'+relativeSource+'" is not in the SourceMap.');}};/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the original source.  The column
	 *     number is 0-based.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.  The
	 *     line number is 1-based.
	 *   - column: The column number in the generated source, or null.
	 *     The column number is 0-based.
	 */BasicSourceMapConsumer.prototype.generatedPositionFor=function SourceMapConsumer_generatedPositionFor(aArgs){var source=util.getArg(aArgs,'source');source=this._findSourceIndex(source);if(source<0){return{line:null,column:null,lastColumn:null};}var needle={source:source,originalLine:util.getArg(aArgs,'line'),originalColumn:util.getArg(aArgs,'column')};var index=this._findMapping(needle,this._originalMappings,"originalLine","originalColumn",util.compareByOriginalPositions,util.getArg(aArgs,'bias',SourceMapConsumer.GREATEST_LOWER_BOUND));if(index>=0){var mapping=this._originalMappings[index];if(mapping.source===needle.source){return{line:util.getArg(mapping,'generatedLine',null),column:util.getArg(mapping,'generatedColumn',null),lastColumn:util.getArg(mapping,'lastGeneratedColumn',null)};}}return{line:null,column:null,lastColumn:null};};exports.BasicSourceMapConsumer=BasicSourceMapConsumer;/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The first parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * The second parameter, if given, is a string whose value is the URL
	 * at which the source map was found.  This URL is used to compute the
	 * sources array.
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */function IndexedSourceMapConsumer(aSourceMap,aSourceMapURL){var sourceMap=aSourceMap;if(typeof aSourceMap==='string'){sourceMap=util.parseSourceMapInput(aSourceMap);}var version=util.getArg(sourceMap,'version');var sections=util.getArg(sourceMap,'sections');if(version!=this._version){throw new Error('Unsupported version: '+version);}this._sources=new ArraySet();this._names=new ArraySet();var lastOffset={line:-1,column:0};this._sections=sections.map(function(s){if(s.url){// The url field will require support for asynchronicity.
	// See https://github.com/mozilla/source-map/issues/16
	throw new Error('Support for url field in sections not implemented.');}var offset=util.getArg(s,'offset');var offsetLine=util.getArg(offset,'line');var offsetColumn=util.getArg(offset,'column');if(offsetLine<lastOffset.line||offsetLine===lastOffset.line&&offsetColumn<lastOffset.column){throw new Error('Section offsets must be ordered and non-overlapping.');}lastOffset=offset;return{generatedOffset:{// The offset fields are 0-based, but we use 1-based indices when
	// encoding/decoding from VLQ.
	generatedLine:offsetLine+1,generatedColumn:offsetColumn+1},consumer:new SourceMapConsumer(util.getArg(s,'map'),aSourceMapURL)};});}IndexedSourceMapConsumer.prototype=Object.create(SourceMapConsumer.prototype);IndexedSourceMapConsumer.prototype.constructor=SourceMapConsumer;/**
	 * The version of the source mapping spec that we are consuming.
	 */IndexedSourceMapConsumer.prototype._version=3;/**
	 * The list of original sources.
	 */Object.defineProperty(IndexedSourceMapConsumer.prototype,'sources',{get:function get(){var sources=[];for(var i=0;i<this._sections.length;i++){for(var j=0;j<this._sections[i].consumer.sources.length;j++){sources.push(this._sections[i].consumer.sources[j]);}}return sources;}});/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the generated source.  The column
	 *     number is 0-based.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.  The
	 *     line number is 1-based.
	 *   - column: The column number in the original source, or null.  The
	 *     column number is 0-based.
	 *   - name: The original identifier, or null.
	 */IndexedSourceMapConsumer.prototype.originalPositionFor=function IndexedSourceMapConsumer_originalPositionFor(aArgs){var needle={generatedLine:util.getArg(aArgs,'line'),generatedColumn:util.getArg(aArgs,'column')};// Find the section containing the generated position we're trying to map
	// to an original position.
	var sectionIndex=binarySearch.search(needle,this._sections,function(needle,section){var cmp=needle.generatedLine-section.generatedOffset.generatedLine;if(cmp){return cmp;}return needle.generatedColumn-section.generatedOffset.generatedColumn;});var section=this._sections[sectionIndex];if(!section){return{source:null,line:null,column:null,name:null};}return section.consumer.originalPositionFor({line:needle.generatedLine-(section.generatedOffset.generatedLine-1),column:needle.generatedColumn-(section.generatedOffset.generatedLine===needle.generatedLine?section.generatedOffset.generatedColumn-1:0),bias:aArgs.bias});};/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */IndexedSourceMapConsumer.prototype.hasContentsOfAllSources=function IndexedSourceMapConsumer_hasContentsOfAllSources(){return this._sections.every(function(s){return s.consumer.hasContentsOfAllSources();});};/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */IndexedSourceMapConsumer.prototype.sourceContentFor=function IndexedSourceMapConsumer_sourceContentFor(aSource,nullOnMissing){for(var i=0;i<this._sections.length;i++){var section=this._sections[i];var content=section.consumer.sourceContentFor(aSource,true);if(content){return content;}}if(nullOnMissing){return null;}else{throw new Error('"'+aSource+'" is not in the SourceMap.');}};/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the original source.  The column
	 *     number is 0-based.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.  The
	 *     line number is 1-based. 
	 *   - column: The column number in the generated source, or null.
	 *     The column number is 0-based.
	 */IndexedSourceMapConsumer.prototype.generatedPositionFor=function IndexedSourceMapConsumer_generatedPositionFor(aArgs){for(var i=0;i<this._sections.length;i++){var section=this._sections[i];// Only consider this section if the requested source is in the list of
	// sources of the consumer.
	if(section.consumer._findSourceIndex(util.getArg(aArgs,'source'))===-1){continue;}var generatedPosition=section.consumer.generatedPositionFor(aArgs);if(generatedPosition){var ret={line:generatedPosition.line+(section.generatedOffset.generatedLine-1),column:generatedPosition.column+(section.generatedOffset.generatedLine===generatedPosition.line?section.generatedOffset.generatedColumn-1:0)};return ret;}}return{line:null,column:null};};/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */IndexedSourceMapConsumer.prototype._parseMappings=function IndexedSourceMapConsumer_parseMappings(aStr,aSourceRoot){this.__generatedMappings=[];this.__originalMappings=[];for(var i=0;i<this._sections.length;i++){var section=this._sections[i];var sectionMappings=section.consumer._generatedMappings;for(var j=0;j<sectionMappings.length;j++){var mapping=sectionMappings[j];var source=section.consumer._sources.at(mapping.source);source=util.computeSourceURL(section.consumer.sourceRoot,source,this._sourceMapURL);this._sources.add(source);source=this._sources.indexOf(source);var name=null;if(mapping.name){name=section.consumer._names.at(mapping.name);this._names.add(name);name=this._names.indexOf(name);}// The mappings coming from the consumer for the section have
	// generated positions relative to the start of the section, so we
	// need to offset them to be relative to the start of the concatenated
	// generated file.
	var adjustedMapping={source:source,generatedLine:mapping.generatedLine+(section.generatedOffset.generatedLine-1),generatedColumn:mapping.generatedColumn+(section.generatedOffset.generatedLine===mapping.generatedLine?section.generatedOffset.generatedColumn-1:0),originalLine:mapping.originalLine,originalColumn:mapping.originalColumn,name:name};this.__generatedMappings.push(adjustedMapping);if(typeof adjustedMapping.originalLine==='number'){this.__originalMappings.push(adjustedMapping);}}}quickSort(this.__generatedMappings,util.compareByGeneratedPositionsDeflated);quickSort(this.__originalMappings,util.compareByOriginalPositions);};exports.IndexedSourceMapConsumer=IndexedSourceMapConsumer;},{"./array-set":198,"./base64-vlq":199,"./binary-search":201,"./quick-sort":203,"./util":207}],205:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var base64VLQ=require('./base64-vlq');var util=require('./util');var ArraySet=require('./array-set').ArraySet;var MappingList=require('./mapping-list').MappingList;/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */function SourceMapGenerator(aArgs){if(!aArgs){aArgs={};}this._file=util.getArg(aArgs,'file',null);this._sourceRoot=util.getArg(aArgs,'sourceRoot',null);this._skipValidation=util.getArg(aArgs,'skipValidation',false);this._sources=new ArraySet();this._names=new ArraySet();this._mappings=new MappingList();this._sourcesContents=null;}SourceMapGenerator.prototype._version=3;/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */SourceMapGenerator.fromSourceMap=function SourceMapGenerator_fromSourceMap(aSourceMapConsumer){var sourceRoot=aSourceMapConsumer.sourceRoot;var generator=new SourceMapGenerator({file:aSourceMapConsumer.file,sourceRoot:sourceRoot});aSourceMapConsumer.eachMapping(function(mapping){var newMapping={generated:{line:mapping.generatedLine,column:mapping.generatedColumn}};if(mapping.source!=null){newMapping.source=mapping.source;if(sourceRoot!=null){newMapping.source=util.relative(sourceRoot,newMapping.source);}newMapping.original={line:mapping.originalLine,column:mapping.originalColumn};if(mapping.name!=null){newMapping.name=mapping.name;}}generator.addMapping(newMapping);});aSourceMapConsumer.sources.forEach(function(sourceFile){var sourceRelative=sourceFile;if(sourceRoot!==null){sourceRelative=util.relative(sourceRoot,sourceFile);}if(!generator._sources.has(sourceRelative)){generator._sources.add(sourceRelative);}var content=aSourceMapConsumer.sourceContentFor(sourceFile);if(content!=null){generator.setSourceContent(sourceFile,content);}});return generator;};/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */SourceMapGenerator.prototype.addMapping=function SourceMapGenerator_addMapping(aArgs){var generated=util.getArg(aArgs,'generated');var original=util.getArg(aArgs,'original',null);var source=util.getArg(aArgs,'source',null);var name=util.getArg(aArgs,'name',null);if(!this._skipValidation){this._validateMapping(generated,original,source,name);}if(source!=null){source=String(source);if(!this._sources.has(source)){this._sources.add(source);}}if(name!=null){name=String(name);if(!this._names.has(name)){this._names.add(name);}}this._mappings.add({generatedLine:generated.line,generatedColumn:generated.column,originalLine:original!=null&&original.line,originalColumn:original!=null&&original.column,source:source,name:name});};/**
	 * Set the source content for a source file.
	 */SourceMapGenerator.prototype.setSourceContent=function SourceMapGenerator_setSourceContent(aSourceFile,aSourceContent){var source=aSourceFile;if(this._sourceRoot!=null){source=util.relative(this._sourceRoot,source);}if(aSourceContent!=null){// Add the source content to the _sourcesContents map.
	// Create a new _sourcesContents map if the property is null.
	if(!this._sourcesContents){this._sourcesContents=Object.create(null);}this._sourcesContents[util.toSetString(source)]=aSourceContent;}else if(this._sourcesContents){// Remove the source file from the _sourcesContents map.
	// If the _sourcesContents map is empty, set the property to null.
	delete this._sourcesContents[util.toSetString(source)];if(Object.keys(this._sourcesContents).length===0){this._sourcesContents=null;}}};/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */SourceMapGenerator.prototype.applySourceMap=function SourceMapGenerator_applySourceMap(aSourceMapConsumer,aSourceFile,aSourceMapPath){var sourceFile=aSourceFile;// If aSourceFile is omitted, we will use the file property of the SourceMap
	if(aSourceFile==null){if(aSourceMapConsumer.file==null){throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, '+'or the source map\'s "file" property. Both were omitted.');}sourceFile=aSourceMapConsumer.file;}var sourceRoot=this._sourceRoot;// Make "sourceFile" relative if an absolute Url is passed.
	if(sourceRoot!=null){sourceFile=util.relative(sourceRoot,sourceFile);}// Applying the SourceMap can add and remove items from the sources and
	// the names array.
	var newSources=new ArraySet();var newNames=new ArraySet();// Find mappings for the "sourceFile"
	this._mappings.unsortedForEach(function(mapping){if(mapping.source===sourceFile&&mapping.originalLine!=null){// Check if it can be mapped by the source map, then update the mapping.
	var original=aSourceMapConsumer.originalPositionFor({line:mapping.originalLine,column:mapping.originalColumn});if(original.source!=null){// Copy mapping
	mapping.source=original.source;if(aSourceMapPath!=null){mapping.source=util.join(aSourceMapPath,mapping.source);}if(sourceRoot!=null){mapping.source=util.relative(sourceRoot,mapping.source);}mapping.originalLine=original.line;mapping.originalColumn=original.column;if(original.name!=null){mapping.name=original.name;}}}var source=mapping.source;if(source!=null&&!newSources.has(source)){newSources.add(source);}var name=mapping.name;if(name!=null&&!newNames.has(name)){newNames.add(name);}},this);this._sources=newSources;this._names=newNames;// Copy sourcesContents of applied map.
	aSourceMapConsumer.sources.forEach(function(sourceFile){var content=aSourceMapConsumer.sourceContentFor(sourceFile);if(content!=null){if(aSourceMapPath!=null){sourceFile=util.join(aSourceMapPath,sourceFile);}if(sourceRoot!=null){sourceFile=util.relative(sourceRoot,sourceFile);}this.setSourceContent(sourceFile,content);}},this);};/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */SourceMapGenerator.prototype._validateMapping=function SourceMapGenerator_validateMapping(aGenerated,aOriginal,aSource,aName){// When aOriginal is truthy but has empty values for .line and .column,
	// it is most likely a programmer error. In this case we throw a very
	// specific error message to try to guide them the right way.
	// For example: https://github.com/Polymer/polymer-bundler/pull/519
	if(aOriginal&&typeof aOriginal.line!=='number'&&typeof aOriginal.column!=='number'){throw new Error('original.line and original.column are not numbers -- you probably meant to omit '+'the original mapping entirely and only map the generated position. If so, pass '+'null for the original mapping instead of an object with empty or null values.');}if(aGenerated&&'line'in aGenerated&&'column'in aGenerated&&aGenerated.line>0&&aGenerated.column>=0&&!aOriginal&&!aSource&&!aName){// Case 1.
	return;}else if(aGenerated&&'line'in aGenerated&&'column'in aGenerated&&aOriginal&&'line'in aOriginal&&'column'in aOriginal&&aGenerated.line>0&&aGenerated.column>=0&&aOriginal.line>0&&aOriginal.column>=0&&aSource){// Cases 2 and 3.
	return;}else{throw new Error('Invalid mapping: '+JSON.stringify({generated:aGenerated,source:aSource,original:aOriginal,name:aName}));}};/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */SourceMapGenerator.prototype._serializeMappings=function SourceMapGenerator_serializeMappings(){var previousGeneratedColumn=0;var previousGeneratedLine=1;var previousOriginalColumn=0;var previousOriginalLine=0;var previousName=0;var previousSource=0;var result='';var next;var mapping;var nameIdx;var sourceIdx;var mappings=this._mappings.toArray();for(var i=0,len=mappings.length;i<len;i++){mapping=mappings[i];next='';if(mapping.generatedLine!==previousGeneratedLine){previousGeneratedColumn=0;while(mapping.generatedLine!==previousGeneratedLine){next+=';';previousGeneratedLine++;}}else{if(i>0){if(!util.compareByGeneratedPositionsInflated(mapping,mappings[i-1])){continue;}next+=',';}}next+=base64VLQ.encode(mapping.generatedColumn-previousGeneratedColumn);previousGeneratedColumn=mapping.generatedColumn;if(mapping.source!=null){sourceIdx=this._sources.indexOf(mapping.source);next+=base64VLQ.encode(sourceIdx-previousSource);previousSource=sourceIdx;// lines are stored 0-based in SourceMap spec version 3
	next+=base64VLQ.encode(mapping.originalLine-1-previousOriginalLine);previousOriginalLine=mapping.originalLine-1;next+=base64VLQ.encode(mapping.originalColumn-previousOriginalColumn);previousOriginalColumn=mapping.originalColumn;if(mapping.name!=null){nameIdx=this._names.indexOf(mapping.name);next+=base64VLQ.encode(nameIdx-previousName);previousName=nameIdx;}}result+=next;}return result;};SourceMapGenerator.prototype._generateSourcesContent=function SourceMapGenerator_generateSourcesContent(aSources,aSourceRoot){return aSources.map(function(source){if(!this._sourcesContents){return null;}if(aSourceRoot!=null){source=util.relative(aSourceRoot,source);}var key=util.toSetString(source);return Object.prototype.hasOwnProperty.call(this._sourcesContents,key)?this._sourcesContents[key]:null;},this);};/**
	 * Externalize the source map.
	 */SourceMapGenerator.prototype.toJSON=function SourceMapGenerator_toJSON(){var map={version:this._version,sources:this._sources.toArray(),names:this._names.toArray(),mappings:this._serializeMappings()};if(this._file!=null){map.file=this._file;}if(this._sourceRoot!=null){map.sourceRoot=this._sourceRoot;}if(this._sourcesContents){map.sourcesContent=this._generateSourcesContent(map.sources,map.sourceRoot);}return map;};/**
	 * Render the source map being generated to a string.
	 */SourceMapGenerator.prototype.toString=function SourceMapGenerator_toString(){return JSON.stringify(this.toJSON());};exports.SourceMapGenerator=SourceMapGenerator;},{"./array-set":198,"./base64-vlq":199,"./mapping-list":202,"./util":207}],206:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var SourceMapGenerator=require('./source-map-generator').SourceMapGenerator;var util=require('./util');// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE=/(\r?\n)/;// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE=10;// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode="$$$isSourceNode$$$";/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */function SourceNode(aLine,aColumn,aSource,aChunks,aName){this.children=[];this.sourceContents={};this.line=aLine==null?null:aLine;this.column=aColumn==null?null:aColumn;this.source=aSource==null?null:aSource;this.name=aName==null?null:aName;this[isSourceNode]=true;if(aChunks!=null)this.add(aChunks);}/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */SourceNode.fromStringWithSourceMap=function SourceNode_fromStringWithSourceMap(aGeneratedCode,aSourceMapConsumer,aRelativePath){// The SourceNode we want to fill with the generated code
	// and the SourceMap
	var node=new SourceNode();// All even indices of this array are one line of the generated code,
	// while all odd indices are the newlines between two adjacent lines
	// (since `REGEX_NEWLINE` captures its match).
	// Processed fragments are accessed by calling `shiftNextLine`.
	var remainingLines=aGeneratedCode.split(REGEX_NEWLINE);var remainingLinesIndex=0;var shiftNextLine=function shiftNextLine(){var lineContents=getNextLine();// The last line of a file might not have a newline.
	var newLine=getNextLine()||"";return lineContents+newLine;function getNextLine(){return remainingLinesIndex<remainingLines.length?remainingLines[remainingLinesIndex++]:undefined;}};// We need to remember the position of "remainingLines"
	var lastGeneratedLine=1,lastGeneratedColumn=0;// The generate SourceNodes we need a code range.
	// To extract it current and last mapping is used.
	// Here we store the last mapping.
	var lastMapping=null;aSourceMapConsumer.eachMapping(function(mapping){if(lastMapping!==null){// We add the code from "lastMapping" to "mapping":
	// First check if there is a new line in between.
	if(lastGeneratedLine<mapping.generatedLine){// Associate first line with "lastMapping"
	addMappingWithCode(lastMapping,shiftNextLine());lastGeneratedLine++;lastGeneratedColumn=0;// The remaining code is added without mapping
	}else{// There is no new line in between.
	// Associate the code between "lastGeneratedColumn" and
	// "mapping.generatedColumn" with "lastMapping"
	var nextLine=remainingLines[remainingLinesIndex]||'';var code=nextLine.substr(0,mapping.generatedColumn-lastGeneratedColumn);remainingLines[remainingLinesIndex]=nextLine.substr(mapping.generatedColumn-lastGeneratedColumn);lastGeneratedColumn=mapping.generatedColumn;addMappingWithCode(lastMapping,code);// No more remaining code, continue
	lastMapping=mapping;return;}}// We add the generated code until the first mapping
	// to the SourceNode without any mapping.
	// Each line is added as separate string.
	while(lastGeneratedLine<mapping.generatedLine){node.add(shiftNextLine());lastGeneratedLine++;}if(lastGeneratedColumn<mapping.generatedColumn){var nextLine=remainingLines[remainingLinesIndex]||'';node.add(nextLine.substr(0,mapping.generatedColumn));remainingLines[remainingLinesIndex]=nextLine.substr(mapping.generatedColumn);lastGeneratedColumn=mapping.generatedColumn;}lastMapping=mapping;},this);// We have processed all mappings.
	if(remainingLinesIndex<remainingLines.length){if(lastMapping){// Associate the remaining code in the current line with "lastMapping"
	addMappingWithCode(lastMapping,shiftNextLine());}// and add the remaining lines without any mapping
	node.add(remainingLines.splice(remainingLinesIndex).join(""));}// Copy sourcesContent into SourceNode
	aSourceMapConsumer.sources.forEach(function(sourceFile){var content=aSourceMapConsumer.sourceContentFor(sourceFile);if(content!=null){if(aRelativePath!=null){sourceFile=util.join(aRelativePath,sourceFile);}node.setSourceContent(sourceFile,content);}});return node;function addMappingWithCode(mapping,code){if(mapping===null||mapping.source===undefined){node.add(code);}else{var source=aRelativePath?util.join(aRelativePath,mapping.source):mapping.source;node.add(new SourceNode(mapping.originalLine,mapping.originalColumn,source,code,mapping.name));}}};/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */SourceNode.prototype.add=function SourceNode_add(aChunk){if(Array.isArray(aChunk)){aChunk.forEach(function(chunk){this.add(chunk);},this);}else if(aChunk[isSourceNode]||typeof aChunk==="string"){if(aChunk){this.children.push(aChunk);}}else{throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+aChunk);}return this;};/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */SourceNode.prototype.prepend=function SourceNode_prepend(aChunk){if(Array.isArray(aChunk)){for(var i=aChunk.length-1;i>=0;i--){this.prepend(aChunk[i]);}}else if(aChunk[isSourceNode]||typeof aChunk==="string"){this.children.unshift(aChunk);}else{throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+aChunk);}return this;};/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */SourceNode.prototype.walk=function SourceNode_walk(aFn){var chunk;for(var i=0,len=this.children.length;i<len;i++){chunk=this.children[i];if(chunk[isSourceNode]){chunk.walk(aFn);}else{if(chunk!==''){aFn(chunk,{source:this.source,line:this.line,column:this.column,name:this.name});}}}};/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */SourceNode.prototype.join=function SourceNode_join(aSep){var newChildren;var i;var len=this.children.length;if(len>0){newChildren=[];for(i=0;i<len-1;i++){newChildren.push(this.children[i]);newChildren.push(aSep);}newChildren.push(this.children[i]);this.children=newChildren;}return this;};/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */SourceNode.prototype.replaceRight=function SourceNode_replaceRight(aPattern,aReplacement){var lastChild=this.children[this.children.length-1];if(lastChild[isSourceNode]){lastChild.replaceRight(aPattern,aReplacement);}else if(typeof lastChild==='string'){this.children[this.children.length-1]=lastChild.replace(aPattern,aReplacement);}else{this.children.push(''.replace(aPattern,aReplacement));}return this;};/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */SourceNode.prototype.setSourceContent=function SourceNode_setSourceContent(aSourceFile,aSourceContent){this.sourceContents[util.toSetString(aSourceFile)]=aSourceContent;};/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */SourceNode.prototype.walkSourceContents=function SourceNode_walkSourceContents(aFn){for(var i=0,len=this.children.length;i<len;i++){if(this.children[i][isSourceNode]){this.children[i].walkSourceContents(aFn);}}var sources=Object.keys(this.sourceContents);for(var i=0,len=sources.length;i<len;i++){aFn(util.fromSetString(sources[i]),this.sourceContents[sources[i]]);}};/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */SourceNode.prototype.toString=function SourceNode_toString(){var str="";this.walk(function(chunk){str+=chunk;});return str;};/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */SourceNode.prototype.toStringWithSourceMap=function SourceNode_toStringWithSourceMap(aArgs){var generated={code:"",line:1,column:0};var map=new SourceMapGenerator(aArgs);var sourceMappingActive=false;var lastOriginalSource=null;var lastOriginalLine=null;var lastOriginalColumn=null;var lastOriginalName=null;this.walk(function(chunk,original){generated.code+=chunk;if(original.source!==null&&original.line!==null&&original.column!==null){if(lastOriginalSource!==original.source||lastOriginalLine!==original.line||lastOriginalColumn!==original.column||lastOriginalName!==original.name){map.addMapping({source:original.source,original:{line:original.line,column:original.column},generated:{line:generated.line,column:generated.column},name:original.name});}lastOriginalSource=original.source;lastOriginalLine=original.line;lastOriginalColumn=original.column;lastOriginalName=original.name;sourceMappingActive=true;}else if(sourceMappingActive){map.addMapping({generated:{line:generated.line,column:generated.column}});lastOriginalSource=null;sourceMappingActive=false;}for(var idx=0,length=chunk.length;idx<length;idx++){if(chunk.charCodeAt(idx)===NEWLINE_CODE){generated.line++;generated.column=0;// Mappings end at eol
	if(idx+1===length){lastOriginalSource=null;sourceMappingActive=false;}else if(sourceMappingActive){map.addMapping({source:original.source,original:{line:original.line,column:original.column},generated:{line:generated.line,column:generated.column},name:original.name});}}else{generated.column++;}}});this.walkSourceContents(function(sourceFile,sourceContent){map.setSourceContent(sourceFile,sourceContent);});return{code:generated.code,map:map};};exports.SourceNode=SourceNode;},{"./source-map-generator":205,"./util":207}],207:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */ /**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */function getArg(aArgs,aName,aDefaultValue){if(aName in aArgs){return aArgs[aName];}else if(arguments.length===3){return aDefaultValue;}else{throw new Error('"'+aName+'" is a required argument.');}}exports.getArg=getArg;var urlRegexp=/^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;var dataUrlRegexp=/^data:.+\,.+$/;function urlParse(aUrl){var match=aUrl.match(urlRegexp);if(!match){return null;}return{scheme:match[1],auth:match[2],host:match[3],port:match[4],path:match[5]};}exports.urlParse=urlParse;function urlGenerate(aParsedUrl){var url='';if(aParsedUrl.scheme){url+=aParsedUrl.scheme+':';}url+='//';if(aParsedUrl.auth){url+=aParsedUrl.auth+'@';}if(aParsedUrl.host){url+=aParsedUrl.host;}if(aParsedUrl.port){url+=":"+aParsedUrl.port;}if(aParsedUrl.path){url+=aParsedUrl.path;}return url;}exports.urlGenerate=urlGenerate;/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */function normalize(aPath){var path=aPath;var url=urlParse(aPath);if(url){if(!url.path){return aPath;}path=url.path;}var isAbsolute=exports.isAbsolute(path);var parts=path.split(/\/+/);for(var part,up=0,i=parts.length-1;i>=0;i--){part=parts[i];if(part==='.'){parts.splice(i,1);}else if(part==='..'){up++;}else if(up>0){if(part===''){// The first part is blank if the path is absolute. Trying to go
	// above the root is a no-op. Therefore we can remove all '..' parts
	// directly after the root.
	parts.splice(i+1,up);up=0;}else{parts.splice(i,2);up--;}}}path=parts.join('/');if(path===''){path=isAbsolute?'/':'.';}if(url){url.path=path;return urlGenerate(url);}return path;}exports.normalize=normalize;/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */function join(aRoot,aPath){if(aRoot===""){aRoot=".";}if(aPath===""){aPath=".";}var aPathUrl=urlParse(aPath);var aRootUrl=urlParse(aRoot);if(aRootUrl){aRoot=aRootUrl.path||'/';}// `join(foo, '//www.example.org')`
	if(aPathUrl&&!aPathUrl.scheme){if(aRootUrl){aPathUrl.scheme=aRootUrl.scheme;}return urlGenerate(aPathUrl);}if(aPathUrl||aPath.match(dataUrlRegexp)){return aPath;}// `join('http://', 'www.example.com')`
	if(aRootUrl&&!aRootUrl.host&&!aRootUrl.path){aRootUrl.host=aPath;return urlGenerate(aRootUrl);}var joined=aPath.charAt(0)==='/'?aPath:normalize(aRoot.replace(/\/+$/,'')+'/'+aPath);if(aRootUrl){aRootUrl.path=joined;return urlGenerate(aRootUrl);}return joined;}exports.join=join;exports.isAbsolute=function(aPath){return aPath.charAt(0)==='/'||urlRegexp.test(aPath);};/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */function relative(aRoot,aPath){if(aRoot===""){aRoot=".";}aRoot=aRoot.replace(/\/$/,'');// It is possible for the path to be above the root. In this case, simply
	// checking whether the root is a prefix of the path won't work. Instead, we
	// need to remove components from the root one by one, until either we find
	// a prefix that fits, or we run out of components to remove.
	var level=0;while(aPath.indexOf(aRoot+'/')!==0){var index=aRoot.lastIndexOf("/");if(index<0){return aPath;}// If the only part of the root that is left is the scheme (i.e. http://,
	// file:///, etc.), one or more slashes (/), or simply nothing at all, we
	// have exhausted all components, so the path is not relative to the root.
	aRoot=aRoot.slice(0,index);if(aRoot.match(/^([^\/]+:\/)?\/*$/)){return aPath;}++level;}// Make sure we add a "../" for each component we removed from the root.
	return Array(level+1).join("../")+aPath.substr(aRoot.length+1);}exports.relative=relative;var supportsNullProto=function(){var obj=Object.create(null);return!('__proto__'in obj);}();function identity(s){return s;}/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */function toSetString(aStr){if(isProtoString(aStr)){return'$'+aStr;}return aStr;}exports.toSetString=supportsNullProto?identity:toSetString;function fromSetString(aStr){if(isProtoString(aStr)){return aStr.slice(1);}return aStr;}exports.fromSetString=supportsNullProto?identity:fromSetString;function isProtoString(s){if(!s){return false;}var length=s.length;if(length<9/* "__proto__".length */){return false;}if(s.charCodeAt(length-1)!==95/* '_' */||s.charCodeAt(length-2)!==95/* '_' */||s.charCodeAt(length-3)!==111/* 'o' */||s.charCodeAt(length-4)!==116/* 't' */||s.charCodeAt(length-5)!==111/* 'o' */||s.charCodeAt(length-6)!==114/* 'r' */||s.charCodeAt(length-7)!==112/* 'p' */||s.charCodeAt(length-8)!==95/* '_' */||s.charCodeAt(length-9)!==95/* '_' */){return false;}for(var i=length-10;i>=0;i--){if(s.charCodeAt(i)!==36/* '$' */){return false;}}return true;}/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */function compareByOriginalPositions(mappingA,mappingB,onlyCompareOriginal){var cmp=strcmp(mappingA.source,mappingB.source);if(cmp!==0){return cmp;}cmp=mappingA.originalLine-mappingB.originalLine;if(cmp!==0){return cmp;}cmp=mappingA.originalColumn-mappingB.originalColumn;if(cmp!==0||onlyCompareOriginal){return cmp;}cmp=mappingA.generatedColumn-mappingB.generatedColumn;if(cmp!==0){return cmp;}cmp=mappingA.generatedLine-mappingB.generatedLine;if(cmp!==0){return cmp;}return strcmp(mappingA.name,mappingB.name);}exports.compareByOriginalPositions=compareByOriginalPositions;/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */function compareByGeneratedPositionsDeflated(mappingA,mappingB,onlyCompareGenerated){var cmp=mappingA.generatedLine-mappingB.generatedLine;if(cmp!==0){return cmp;}cmp=mappingA.generatedColumn-mappingB.generatedColumn;if(cmp!==0||onlyCompareGenerated){return cmp;}cmp=strcmp(mappingA.source,mappingB.source);if(cmp!==0){return cmp;}cmp=mappingA.originalLine-mappingB.originalLine;if(cmp!==0){return cmp;}cmp=mappingA.originalColumn-mappingB.originalColumn;if(cmp!==0){return cmp;}return strcmp(mappingA.name,mappingB.name);}exports.compareByGeneratedPositionsDeflated=compareByGeneratedPositionsDeflated;function strcmp(aStr1,aStr2){if(aStr1===aStr2){return 0;}if(aStr1===null){return 1;// aStr2 !== null
	}if(aStr2===null){return-1;// aStr1 !== null
	}if(aStr1>aStr2){return 1;}return-1;}/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */function compareByGeneratedPositionsInflated(mappingA,mappingB){var cmp=mappingA.generatedLine-mappingB.generatedLine;if(cmp!==0){return cmp;}cmp=mappingA.generatedColumn-mappingB.generatedColumn;if(cmp!==0){return cmp;}cmp=strcmp(mappingA.source,mappingB.source);if(cmp!==0){return cmp;}cmp=mappingA.originalLine-mappingB.originalLine;if(cmp!==0){return cmp;}cmp=mappingA.originalColumn-mappingB.originalColumn;if(cmp!==0){return cmp;}return strcmp(mappingA.name,mappingB.name);}exports.compareByGeneratedPositionsInflated=compareByGeneratedPositionsInflated;/**
	 * Strip any JSON XSSI avoidance prefix from the string (as documented
	 * in the source maps specification), and then parse the string as
	 * JSON.
	 */function parseSourceMapInput(str){return JSON.parse(str.replace(/^\)]}'[^\n]*\n/,''));}exports.parseSourceMapInput=parseSourceMapInput;/**
	 * Compute the URL of a source given the the source root, the source's
	 * URL, and the source map's URL.
	 */function computeSourceURL(sourceRoot,sourceURL,sourceMapURL){sourceURL=sourceURL||'';if(sourceRoot){// This follows what Chrome does.
	if(sourceRoot[sourceRoot.length-1]!=='/'&&sourceURL[0]!=='/'){sourceRoot+='/';}// The spec says:
	//   Line 4: An optional source root, useful for relocating source
	//   files on a server or removing repeated values in the
	//   “sources” entry.  This value is prepended to the individual
	//   entries in the “source” field.
	sourceURL=sourceRoot+sourceURL;}// Historically, SourceMapConsumer did not take the sourceMapURL as
	// a parameter.  This mode is still somewhat supported, which is why
	// this code block is conditional.  However, it's preferable to pass
	// the source map URL to SourceMapConsumer, so that this function
	// can implement the source URL resolution algorithm as outlined in
	// the spec.  This block is basically the equivalent of:
	//    new URL(sourceURL, sourceMapURL).toString()
	// ... except it avoids using URL, which wasn't available in the
	// older releases of node still supported by this library.
	//
	// The spec says:
	//   If the sources are not absolute URLs after prepending of the
	//   “sourceRoot”, the sources are resolved relative to the
	//   SourceMap (like resolving script src in a html document).
	if(sourceMapURL){var parsed=urlParse(sourceMapURL);if(!parsed){throw new Error("sourceMapURL could not be parsed");}if(parsed.path){// Strip the last path component, but keep the "/".
	var index=parsed.path.lastIndexOf('/');if(index>=0){parsed.path=parsed.path.substring(0,index+1);}}sourceURL=join(urlGenerate(parsed),sourceURL);}return normalize(sourceURL);}exports.computeSourceURL=computeSourceURL;},{}],208:[function(require,module,exports){/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */exports.SourceMapGenerator=require('./lib/source-map-generator').SourceMapGenerator;exports.SourceMapConsumer=require('./lib/source-map-consumer').SourceMapConsumer;exports.SourceNode=require('./lib/source-node').SourceNode;},{"./lib/source-map-consumer":204,"./lib/source-map-generator":205,"./lib/source-node":206}],209:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';var punycode=require('punycode');var util=require('./util');exports.parse=urlParse;exports.resolve=urlResolve;exports.resolveObject=urlResolveObject;exports.format=urlFormat;exports.Url=Url;function Url(){this.protocol=null;this.slashes=null;this.auth=null;this.host=null;this.port=null;this.hostname=null;this.hash=null;this.search=null;this.query=null;this.pathname=null;this.path=null;this.href=null;}// Reference: RFC 3986, RFC 1808, RFC 2396
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern=/^([a-z0-9.+-]+:)/i,portPattern=/:[0-9]*$/,// Special case for a simple path URL
	simplePathPattern=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,// RFC 2396: characters reserved for delimiting URLs.
	// We actually just auto-escape these.
	delims=['<','>','"','`',' ','\r','\n','\t'],// RFC 2396: characters not allowed for various reasons.
	unwise=['{','}','|','\\','^','`'].concat(delims),// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	autoEscape=['\''].concat(unwise),// Characters that are never ever allowed in a hostname.
	// Note that any invalid chars are also handled, but these
	// are the ones that are *expected* to be seen, so we fast-path
	// them.
	nonHostChars=['%','/','?',';','#'].concat(autoEscape),hostEndingChars=['/','?','#'],hostnameMaxLen=255,hostnamePartPattern=/^[+a-z0-9A-Z_-]{0,63}$/,hostnamePartStart=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,// protocols that can allow "unsafe" and "unwise" chars.
	unsafeProtocol={'javascript':true,'javascript:':true},// protocols that never have a hostname.
	hostlessProtocol={'javascript':true,'javascript:':true},// protocols that always contain a // bit.
	slashedProtocol={'http':true,'https':true,'ftp':true,'gopher':true,'file':true,'http:':true,'https:':true,'ftp:':true,'gopher:':true,'file:':true},querystring=require('querystring');function urlParse(url,parseQueryString,slashesDenoteHost){if(url&&util.isObject(url)&&url instanceof Url)return url;var u=new Url();u.parse(url,parseQueryString,slashesDenoteHost);return u;}Url.prototype.parse=function(url,parseQueryString,slashesDenoteHost){if(!util.isString(url)){throw new TypeError("Parameter 'url' must be a string, not "+_typeof(url));}// Copy chrome, IE, opera backslash-handling behavior.
	// Back slashes before the query string get converted to forward slashes
	// See: https://code.google.com/p/chromium/issues/detail?id=25916
	var queryIndex=url.indexOf('?'),splitter=queryIndex!==-1&&queryIndex<url.indexOf('#')?'?':'#',uSplit=url.split(splitter),slashRegex=/\\/g;uSplit[0]=uSplit[0].replace(slashRegex,'/');url=uSplit.join(splitter);var rest=url;// trim before proceeding.
	// This is to support parse stuff like "  http://foo.com  \n"
	rest=rest.trim();if(!slashesDenoteHost&&url.split('#').length===1){// Try fast path regexp
	var simplePath=simplePathPattern.exec(rest);if(simplePath){this.path=rest;this.href=rest;this.pathname=simplePath[1];if(simplePath[2]){this.search=simplePath[2];if(parseQueryString){this.query=querystring.parse(this.search.substr(1));}else{this.query=this.search.substr(1);}}else if(parseQueryString){this.search='';this.query={};}return this;}}var proto=protocolPattern.exec(rest);if(proto){proto=proto[0];var lowerProto=proto.toLowerCase();this.protocol=lowerProto;rest=rest.substr(proto.length);}// figure out if it's got a host
	// user@server is *always* interpreted as a hostname, and url
	// resolution will treat //foo/bar as host=foo,path=bar because that's
	// how the browser resolves relative URLs.
	if(slashesDenoteHost||proto||rest.match(/^\/\/[^@\/]+@[^@\/]+/)){var slashes=rest.substr(0,2)==='//';if(slashes&&!(proto&&hostlessProtocol[proto])){rest=rest.substr(2);this.slashes=true;}}if(!hostlessProtocol[proto]&&(slashes||proto&&!slashedProtocol[proto])){// there's a hostname.
	// the first instance of /, ?, ;, or # ends the host.
	//
	// If there is an @ in the hostname, then non-host chars *are* allowed
	// to the left of the last @ sign, unless some host-ending character
	// comes *before* the @-sign.
	// URLs are obnoxious.
	//
	// ex:
	// http://a@b@c/ => user:a@b host:c
	// http://a@b?@c => user:a host:c path:/?@c
	// v0.12 TODO(isaacs): This is not quite how Chrome does things.
	// Review our test case against browsers more comprehensively.
	// find the first instance of any hostEndingChars
	var hostEnd=-1;for(var i=0;i<hostEndingChars.length;i++){var hec=rest.indexOf(hostEndingChars[i]);if(hec!==-1&&(hostEnd===-1||hec<hostEnd))hostEnd=hec;}// at this point, either we have an explicit point where the
	// auth portion cannot go past, or the last @ char is the decider.
	var auth,atSign;if(hostEnd===-1){// atSign can be anywhere.
	atSign=rest.lastIndexOf('@');}else{// atSign must be in auth portion.
	// http://a@b/c@d => host:b auth:a path:/c@d
	atSign=rest.lastIndexOf('@',hostEnd);}// Now we have a portion which is definitely the auth.
	// Pull that off.
	if(atSign!==-1){auth=rest.slice(0,atSign);rest=rest.slice(atSign+1);this.auth=decodeURIComponent(auth);}// the host is the remaining to the left of the first non-host char
	hostEnd=-1;for(var i=0;i<nonHostChars.length;i++){var hec=rest.indexOf(nonHostChars[i]);if(hec!==-1&&(hostEnd===-1||hec<hostEnd))hostEnd=hec;}// if we still have not hit it, then the entire thing is a host.
	if(hostEnd===-1)hostEnd=rest.length;this.host=rest.slice(0,hostEnd);rest=rest.slice(hostEnd);// pull out port.
	this.parseHost();// we've indicated that there is a hostname,
	// so even if it's empty, it has to be present.
	this.hostname=this.hostname||'';// if hostname begins with [ and ends with ]
	// assume that it's an IPv6 address.
	var ipv6Hostname=this.hostname[0]==='['&&this.hostname[this.hostname.length-1]===']';// validate a little.
	if(!ipv6Hostname){var hostparts=this.hostname.split(/\./);for(var i=0,l=hostparts.length;i<l;i++){var part=hostparts[i];if(!part)continue;if(!part.match(hostnamePartPattern)){var newpart='';for(var j=0,k=part.length;j<k;j++){if(part.charCodeAt(j)>127){// we replace non-ASCII char with a temporary placeholder
	// we need this to make sure size of hostname is not
	// broken by replacing non-ASCII by nothing
	newpart+='x';}else{newpart+=part[j];}}// we test again with ASCII char only
	if(!newpart.match(hostnamePartPattern)){var validParts=hostparts.slice(0,i);var notHost=hostparts.slice(i+1);var bit=part.match(hostnamePartStart);if(bit){validParts.push(bit[1]);notHost.unshift(bit[2]);}if(notHost.length){rest='/'+notHost.join('.')+rest;}this.hostname=validParts.join('.');break;}}}}if(this.hostname.length>hostnameMaxLen){this.hostname='';}else{// hostnames are always lower case.
	this.hostname=this.hostname.toLowerCase();}if(!ipv6Hostname){// IDNA Support: Returns a punycoded representation of "domain".
	// It only converts parts of the domain name that
	// have non-ASCII characters, i.e. it doesn't matter if
	// you call it with a domain that already is ASCII-only.
	this.hostname=punycode.toASCII(this.hostname);}var p=this.port?':'+this.port:'';var h=this.hostname||'';this.host=h+p;this.href+=this.host;// strip [ and ] from the hostname
	// the host field still retains them, though
	if(ipv6Hostname){this.hostname=this.hostname.substr(1,this.hostname.length-2);if(rest[0]!=='/'){rest='/'+rest;}}}// now rest is set to the post-host stuff.
	// chop off any delim chars.
	if(!unsafeProtocol[lowerProto]){// First, make 100% sure that any "autoEscape" chars get
	// escaped, even if encodeURIComponent doesn't think they
	// need to be.
	for(var i=0,l=autoEscape.length;i<l;i++){var ae=autoEscape[i];if(rest.indexOf(ae)===-1)continue;var esc=encodeURIComponent(ae);if(esc===ae){esc=escape(ae);}rest=rest.split(ae).join(esc);}}// chop off from the tail first.
	var hash=rest.indexOf('#');if(hash!==-1){// got a fragment string.
	this.hash=rest.substr(hash);rest=rest.slice(0,hash);}var qm=rest.indexOf('?');if(qm!==-1){this.search=rest.substr(qm);this.query=rest.substr(qm+1);if(parseQueryString){this.query=querystring.parse(this.query);}rest=rest.slice(0,qm);}else if(parseQueryString){// no query string, but parseQueryString still requested
	this.search='';this.query={};}if(rest)this.pathname=rest;if(slashedProtocol[lowerProto]&&this.hostname&&!this.pathname){this.pathname='/';}//to support http.request
	if(this.pathname||this.search){var p=this.pathname||'';var s=this.search||'';this.path=p+s;}// finally, reconstruct the href based on what has been validated.
	this.href=this.format();return this;};// format a parsed object into a url string
	function urlFormat(obj){// ensure it's an object, and not a string url.
	// If it's an obj, this is a no-op.
	// this way, you can call url_format() on strings
	// to clean up potentially wonky urls.
	if(util.isString(obj))obj=urlParse(obj);if(!(obj instanceof Url))return Url.prototype.format.call(obj);return obj.format();}Url.prototype.format=function(){var auth=this.auth||'';if(auth){auth=encodeURIComponent(auth);auth=auth.replace(/%3A/i,':');auth+='@';}var protocol=this.protocol||'',pathname=this.pathname||'',hash=this.hash||'',host=false,query='';if(this.host){host=auth+this.host;}else if(this.hostname){host=auth+(this.hostname.indexOf(':')===-1?this.hostname:'['+this.hostname+']');if(this.port){host+=':'+this.port;}}if(this.query&&util.isObject(this.query)&&Object.keys(this.query).length){query=querystring.stringify(this.query);}var search=this.search||query&&'?'+query||'';if(protocol&&protocol.substr(-1)!==':')protocol+=':';// only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	// unless they had them to begin with.
	if(this.slashes||(!protocol||slashedProtocol[protocol])&&host!==false){host='//'+(host||'');if(pathname&&pathname.charAt(0)!=='/')pathname='/'+pathname;}else if(!host){host='';}if(hash&&hash.charAt(0)!=='#')hash='#'+hash;if(search&&search.charAt(0)!=='?')search='?'+search;pathname=pathname.replace(/[?#]/g,function(match){return encodeURIComponent(match);});search=search.replace('#','%23');return protocol+host+pathname+search+hash;};function urlResolve(source,relative){return urlParse(source,false,true).resolve(relative);}Url.prototype.resolve=function(relative){return this.resolveObject(urlParse(relative,false,true)).format();};function urlResolveObject(source,relative){if(!source)return relative;return urlParse(source,false,true).resolveObject(relative);}Url.prototype.resolveObject=function(relative){if(util.isString(relative)){var rel=new Url();rel.parse(relative,false,true);relative=rel;}var result=new Url();var tkeys=Object.keys(this);for(var tk=0;tk<tkeys.length;tk++){var tkey=tkeys[tk];result[tkey]=this[tkey];}// hash is always overridden, no matter what.
	// even href="" will remove it.
	result.hash=relative.hash;// if the relative url is empty, then there's nothing left to do here.
	if(relative.href===''){result.href=result.format();return result;}// hrefs like //foo/bar always cut to the protocol.
	if(relative.slashes&&!relative.protocol){// take everything except the protocol from relative
	var rkeys=Object.keys(relative);for(var rk=0;rk<rkeys.length;rk++){var rkey=rkeys[rk];if(rkey!=='protocol')result[rkey]=relative[rkey];}//urlParse appends trailing / to urls like http://www.example.com
	if(slashedProtocol[result.protocol]&&result.hostname&&!result.pathname){result.path=result.pathname='/';}result.href=result.format();return result;}if(relative.protocol&&relative.protocol!==result.protocol){// if it's a known url protocol, then changing
	// the protocol does weird things
	// first, if it's not file:, then we MUST have a host,
	// and if there was a path
	// to begin with, then we MUST have a path.
	// if it is file:, then the host is dropped,
	// because that's known to be hostless.
	// anything else is assumed to be absolute.
	if(!slashedProtocol[relative.protocol]){var keys=Object.keys(relative);for(var v=0;v<keys.length;v++){var k=keys[v];result[k]=relative[k];}result.href=result.format();return result;}result.protocol=relative.protocol;if(!relative.host&&!hostlessProtocol[relative.protocol]){var relPath=(relative.pathname||'').split('/');while(relPath.length&&!(relative.host=relPath.shift())){;}if(!relative.host)relative.host='';if(!relative.hostname)relative.hostname='';if(relPath[0]!=='')relPath.unshift('');if(relPath.length<2)relPath.unshift('');result.pathname=relPath.join('/');}else{result.pathname=relative.pathname;}result.search=relative.search;result.query=relative.query;result.host=relative.host||'';result.auth=relative.auth;result.hostname=relative.hostname||relative.host;result.port=relative.port;// to support http.request
	if(result.pathname||result.search){var p=result.pathname||'';var s=result.search||'';result.path=p+s;}result.slashes=result.slashes||relative.slashes;result.href=result.format();return result;}var isSourceAbs=result.pathname&&result.pathname.charAt(0)==='/',isRelAbs=relative.host||relative.pathname&&relative.pathname.charAt(0)==='/',mustEndAbs=isRelAbs||isSourceAbs||result.host&&relative.pathname,removeAllDots=mustEndAbs,srcPath=result.pathname&&result.pathname.split('/')||[],relPath=relative.pathname&&relative.pathname.split('/')||[],psychotic=result.protocol&&!slashedProtocol[result.protocol];// if the url is a non-slashed url, then relative
	// links like ../.. should be able
	// to crawl up to the hostname, as well.  This is strange.
	// result.protocol has already been set by now.
	// Later on, put the first path part into the host field.
	if(psychotic){result.hostname='';result.port=null;if(result.host){if(srcPath[0]==='')srcPath[0]=result.host;else srcPath.unshift(result.host);}result.host='';if(relative.protocol){relative.hostname=null;relative.port=null;if(relative.host){if(relPath[0]==='')relPath[0]=relative.host;else relPath.unshift(relative.host);}relative.host=null;}mustEndAbs=mustEndAbs&&(relPath[0]===''||srcPath[0]==='');}if(isRelAbs){// it's absolute.
	result.host=relative.host||relative.host===''?relative.host:result.host;result.hostname=relative.hostname||relative.hostname===''?relative.hostname:result.hostname;result.search=relative.search;result.query=relative.query;srcPath=relPath;// fall through to the dot-handling below.
	}else if(relPath.length){// it's relative
	// throw away the existing file, and take the new path instead.
	if(!srcPath)srcPath=[];srcPath.pop();srcPath=srcPath.concat(relPath);result.search=relative.search;result.query=relative.query;}else if(!util.isNullOrUndefined(relative.search)){// just pull out the search.
	// like href='?foo'.
	// Put this after the other two cases because it simplifies the booleans
	if(psychotic){result.hostname=result.host=srcPath.shift();//occationaly the auth can get stuck only in host
	//this especially happens in cases like
	//url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	var authInHost=result.host&&result.host.indexOf('@')>0?result.host.split('@'):false;if(authInHost){result.auth=authInHost.shift();result.host=result.hostname=authInHost.shift();}}result.search=relative.search;result.query=relative.query;//to support http.request
	if(!util.isNull(result.pathname)||!util.isNull(result.search)){result.path=(result.pathname?result.pathname:'')+(result.search?result.search:'');}result.href=result.format();return result;}if(!srcPath.length){// no path at all.  easy.
	// we've already handled the other stuff above.
	result.pathname=null;//to support http.request
	if(result.search){result.path='/'+result.search;}else{result.path=null;}result.href=result.format();return result;}// if a url ENDs in . or .., then it must get a trailing slash.
	// however, if it ends in anything else non-slashy,
	// then it must NOT get a trailing slash.
	var last=srcPath.slice(-1)[0];var hasTrailingSlash=(result.host||relative.host||srcPath.length>1)&&(last==='.'||last==='..')||last==='';// strip single dots, resolve double dots to parent dir
	// if the path tries to go above the root, `up` ends up > 0
	var up=0;for(var i=srcPath.length;i>=0;i--){last=srcPath[i];if(last==='.'){srcPath.splice(i,1);}else if(last==='..'){srcPath.splice(i,1);up++;}else if(up){srcPath.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
	if(!mustEndAbs&&!removeAllDots){for(;up--;up){srcPath.unshift('..');}}if(mustEndAbs&&srcPath[0]!==''&&(!srcPath[0]||srcPath[0].charAt(0)!=='/')){srcPath.unshift('');}if(hasTrailingSlash&&srcPath.join('/').substr(-1)!=='/'){srcPath.push('');}var isAbsolute=srcPath[0]===''||srcPath[0]&&srcPath[0].charAt(0)==='/';// put the host back
	if(psychotic){result.hostname=result.host=isAbsolute?'':srcPath.length?srcPath.shift():'';//occationaly the auth can get stuck only in host
	//this especially happens in cases like
	//url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	var authInHost=result.host&&result.host.indexOf('@')>0?result.host.split('@'):false;if(authInHost){result.auth=authInHost.shift();result.host=result.hostname=authInHost.shift();}}mustEndAbs=mustEndAbs||result.host&&srcPath.length;if(mustEndAbs&&!isAbsolute){srcPath.unshift('');}if(!srcPath.length){result.pathname=null;result.path=null;}else{result.pathname=srcPath.join('/');}//to support request.http
	if(!util.isNull(result.pathname)||!util.isNull(result.search)){result.path=(result.pathname?result.pathname:'')+(result.search?result.search:'');}result.auth=relative.auth||result.auth;result.slashes=result.slashes||relative.slashes;result.href=result.format();return result;};Url.prototype.parseHost=function(){var host=this.host;var port=portPattern.exec(host);if(port){port=port[0];if(port!==':'){this.port=port.substr(1);}host=host.substr(0,host.length-port.length);}if(host)this.hostname=host;};},{"./util":210,"punycode":194,"querystring":197}],210:[function(require,module,exports){'use strict';module.exports={isString:function isString(arg){return typeof arg==='string';},isObject:function isObject(arg){return _typeof(arg)==='object'&&arg!==null;},isNull:function isNull(arg){return arg===null;},isNullOrUndefined:function isNullOrUndefined(arg){return arg==null;}};},{}],211:[function(require,module,exports){/* eslint-disable no-useless-escape */var htmlparser=require('htmlparser2');var quoteRegexp=require('lodash/escapeRegExp');var cloneDeep=require('lodash/cloneDeep');var mergeWith=require('lodash/mergeWith');var isString=require('lodash/isString');var isPlainObject=require('lodash/isPlainObject');var parseSrcset=require('parse-srcset');var postcss=require('postcss');var url=require('url');// Tags that can conceivably represent stand-alone media.
	var mediaTags=['img','audio','video','picture','svg','object','map','iframe','embed'];// Tags that are inherently vulnerable to being used in XSS attacks.
	var vulnerableTags=['script','style'];function each(obj,cb){if(obj){Object.keys(obj).forEach(function(key){cb(obj[key],key);});}}// Avoid false positives with .__proto__, .hasOwnProperty, etc.
	function has(obj,key){return{}.hasOwnProperty.call(obj,key);}// Returns those elements of `a` for which `cb(a)` returns truthy
	function filter(a,cb){var n=[];each(a,function(v){if(cb(v)){n.push(v);}});return n;}function isEmptyObject(obj){for(var key in obj){if(has(obj,key)){return false;}}return true;}function stringifySrcset(parsedSrcset){return parsedSrcset.map(function(part){if(!part.url){throw new Error('URL missing');}return part.url+(part.w?" ".concat(part.w,"w"):'')+(part.h?" ".concat(part.h,"h"):'')+(part.d?" ".concat(part.d,"x"):'');}).join(', ');}module.exports=sanitizeHtml;// A valid attribute name.
	// We use a tolerant definition based on the set of strings defined by
	// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
	// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
	// The characters accepted are ones which can be appended to the attribute
	// name buffer without triggering a parse error:
	//   * unexpected-equals-sign-before-attribute-name
	//   * unexpected-null-character
	//   * unexpected-character-in-attribute-name
	// We exclude the empty string because it's impossible to get to the after
	// attribute name state with an empty attribute name buffer.
	var VALID_HTML_ATTRIBUTE_NAME=/^[^\0\t\n\f\r /<=>]+$/;// Ignore the _recursing flag; it's there for recursive
	// invocation as a guard against this exploit:
	// https://github.com/fb55/htmlparser2/issues/105
	function sanitizeHtml(html,options,_recursing){var result='';// Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
	var tempResult='';function Frame(tag,attribs){var that=this;this.tag=tag;this.attribs=attribs||{};this.tagPosition=result.length;this.text='';// Node inner text
	this.mediaChildren=[];this.updateParentNodeText=function(){if(stack.length){var parentFrame=stack[stack.length-1];parentFrame.text+=that.text;}};this.updateParentNodeMediaChildren=function(){if(stack.length&&mediaTags.indexOf(this.tag)>-1){var parentFrame=stack[stack.length-1];parentFrame.mediaChildren.push(this.tag);}};}if(!options){options=sanitizeHtml.defaults;options.parser=htmlParserDefaults;}else{options=Object.assign({},sanitizeHtml.defaults,options);if(options.parser){options.parser=Object.assign({},htmlParserDefaults,options.parser);}else{options.parser=htmlParserDefaults;}}// vulnerableTags
	vulnerableTags.forEach(function(tag){if(options.allowedTags&&options.allowedTags.indexOf(tag)>-1&&!options.allowVulnerableTags){// eslint-disable-next-line no-console
	console.warn("\n\n\u26A0\uFE0F Your `allowedTags` option includes, `".concat(tag,"`, which is inherently\nvulnerable to XSS attacks. Please remove it from `allowedTags`.\nOr, to disable this warning, add the `allowVulnerableTags` option\nand ensure you are accounting for this risk.\n\n"));}});// Tags that contain something other than HTML, or where discarding
	// the text when the tag is disallowed makes sense for other reasons.
	// If we are not allowing these tags, we should drop their content too.
	// For other tags you would drop the tag but keep its content.
	var nonTextTagsArray=options.nonTextTags||['script','style','textarea','option'];var allowedAttributesMap;var allowedAttributesGlobMap;if(options.allowedAttributes){allowedAttributesMap={};allowedAttributesGlobMap={};each(options.allowedAttributes,function(attributes,tag){allowedAttributesMap[tag]=[];var globRegex=[];attributes.forEach(function(obj){if(isString(obj)&&obj.indexOf('*')>=0){globRegex.push(quoteRegexp(obj).replace(/\\\*/g,'.*'));}else{allowedAttributesMap[tag].push(obj);}});allowedAttributesGlobMap[tag]=new RegExp('^('+globRegex.join('|')+')$');});}var allowedClassesMap={};each(options.allowedClasses,function(classes,tag){// Implicitly allows the class attribute
	if(allowedAttributesMap){if(!has(allowedAttributesMap,tag)){allowedAttributesMap[tag]=[];}allowedAttributesMap[tag].push('class');}allowedClassesMap[tag]=classes;});var transformTagsMap={};var transformTagsAll;each(options.transformTags,function(transform,tag){var transFun;if(typeof transform==='function'){transFun=transform;}else if(typeof transform==='string'){transFun=sanitizeHtml.simpleTransform(transform);}if(tag==='*'){transformTagsAll=transFun;}else{transformTagsMap[tag]=transFun;}});var depth;var stack;var skipMap;var transformMap;var skipText;var skipTextDepth;var addedText=false;initializeState();var parser=new htmlparser.Parser({onopentag:function onopentag(name,attribs){// If `enforceHtmlBoundary` is `true` and this has found the opening
	// `html` tag, reset the state.
	if(options.enforceHtmlBoundary&&name==='html'){initializeState();}if(skipText){skipTextDepth++;return;}var frame=new Frame(name,attribs);stack.push(frame);var skip=false;var hasText=!!frame.text;var transformedTag;if(has(transformTagsMap,name)){transformedTag=transformTagsMap[name](name,attribs);frame.attribs=attribs=transformedTag.attribs;if(transformedTag.text!==undefined){frame.innerText=transformedTag.text;}if(name!==transformedTag.tagName){frame.name=name=transformedTag.tagName;transformMap[depth]=transformedTag.tagName;}}if(transformTagsAll){transformedTag=transformTagsAll(name,attribs);frame.attribs=attribs=transformedTag.attribs;if(name!==transformedTag.tagName){frame.name=name=transformedTag.tagName;transformMap[depth]=transformedTag.tagName;}}if(options.allowedTags&&options.allowedTags.indexOf(name)===-1||options.disallowedTagsMode==='recursiveEscape'&&!isEmptyObject(skipMap)){skip=true;skipMap[depth]=true;if(options.disallowedTagsMode==='discard'){if(nonTextTagsArray.indexOf(name)!==-1){skipText=true;skipTextDepth=1;}}skipMap[depth]=true;}depth++;if(skip){if(options.disallowedTagsMode==='discard'){// We want the contents but not this tag
	return;}tempResult=result;result='';}result+='<'+name;if(!allowedAttributesMap||has(allowedAttributesMap,name)||allowedAttributesMap['*']){each(attribs,function(value,a){if(!VALID_HTML_ATTRIBUTE_NAME.test(a)){// This prevents part of an attribute name in the output from being
	// interpreted as the end of an attribute, or end of a tag.
	delete frame.attribs[a];return;}var parsed;// check allowedAttributesMap for the element and attribute and modify the value
	// as necessary if there are specific values defined.
	var passedAllowedAttributesMapCheck=false;if(!allowedAttributesMap||has(allowedAttributesMap,name)&&allowedAttributesMap[name].indexOf(a)!==-1||allowedAttributesMap['*']&&allowedAttributesMap['*'].indexOf(a)!==-1||has(allowedAttributesGlobMap,name)&&allowedAttributesGlobMap[name].test(a)||allowedAttributesGlobMap['*']&&allowedAttributesGlobMap['*'].test(a)){passedAllowedAttributesMapCheck=true;}else if(allowedAttributesMap&&allowedAttributesMap[name]){var _iterator10=_createForOfIteratorHelper(allowedAttributesMap[name]),_step10;try{for(_iterator10.s();!(_step10=_iterator10.n()).done;){var o=_step10.value;if(isPlainObject(o)&&o.name&&o.name===a){passedAllowedAttributesMapCheck=true;var newValue='';if(o.multiple===true){// verify the values that are allowed
	var splitStrArray=value.split(' ');var _iterator11=_createForOfIteratorHelper(splitStrArray),_step11;try{for(_iterator11.s();!(_step11=_iterator11.n()).done;){var s=_step11.value;if(o.values.indexOf(s)!==-1){if(newValue===''){newValue=s;}else{newValue+=' '+s;}}}}catch(err){_iterator11.e(err);}finally{_iterator11.f();}}else if(o.values.indexOf(value)>=0){// verified an allowed value matches the entire attribute value
	newValue=value;}value=newValue;}}}catch(err){_iterator10.e(err);}finally{_iterator10.f();}}if(passedAllowedAttributesMapCheck){if(options.allowedSchemesAppliedToAttributes.indexOf(a)!==-1){if(naughtyHref(name,value)){delete frame.attribs[a];return;}}if(name==='iframe'&&a==='src'){var allowed=true;try{// naughtyHref is in charge of whether protocol relative URLs
	// are cool. We should just accept them.
	// eslint-disable-next-line node/no-deprecated-api
	parsed=url.parse(value,false,true);var isRelativeUrl=parsed&&parsed.host===null&&parsed.protocol===null;if(isRelativeUrl){// default value of allowIframeRelativeUrls is true
	// unless allowedIframeHostnames or allowedIframeDomains specified
	allowed=has(options,'allowIframeRelativeUrls')?options.allowIframeRelativeUrls:!options.allowedIframeHostnames&&!options.allowedIframeDomains;}else if(options.allowedIframeHostnames||options.allowedIframeDomains){var allowedHostname=(options.allowedIframeHostnames||[]).find(function(hostname){return hostname===parsed.hostname;});var allowedDomain=(options.allowedIframeDomains||[]).find(function(domain){return parsed.hostname===domain||parsed.hostname.endsWith(".".concat(domain));});allowed=allowedHostname||allowedDomain;}}catch(e){// Unparseable iframe src
	allowed=false;}if(!allowed){delete frame.attribs[a];return;}}if(a==='srcset'){try{parsed=parseSrcset(value);each(parsed,function(value){if(naughtyHref('srcset',value.url)){value.evil=true;}});parsed=filter(parsed,function(v){return!v.evil;});if(!parsed.length){delete frame.attribs[a];return;}else{value=stringifySrcset(filter(parsed,function(v){return!v.evil;}));frame.attribs[a]=value;}}catch(e){// Unparseable srcset
	delete frame.attribs[a];return;}}if(a==='class'){value=filterClasses(value,allowedClassesMap[name]);if(!value.length){delete frame.attribs[a];return;}}if(a==='style'){try{var abstractSyntaxTree=postcss.parse(name+' {'+value+'}');var filteredAST=filterCss(abstractSyntaxTree,options.allowedStyles);value=stringifyStyleAttributes(filteredAST);if(value.length===0){delete frame.attribs[a];return;}}catch(e){delete frame.attribs[a];return;}}result+=' '+a;if(value&&value.length){result+='="'+escapeHtml(value,true)+'"';}}else{delete frame.attribs[a];}});}if(options.selfClosing.indexOf(name)!==-1){result+=' />';}else{result+='>';if(frame.innerText&&!hasText&&!options.textFilter){result+=frame.innerText;addedText=true;}}if(skip){result=tempResult+escapeHtml(result);tempResult='';}},ontext:function ontext(text){if(skipText){return;}var lastFrame=stack[stack.length-1];var tag;if(lastFrame){tag=lastFrame.tag;// If inner text was set by transform function then let's use it
	text=lastFrame.innerText!==undefined?lastFrame.innerText:text;}if(options.disallowedTagsMode==='discard'&&(tag==='script'||tag==='style')){// htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
	// script tags is, by definition, game over for XSS protection, so if that's
	// your concern, don't allow them. The same is essentially true for style tags
	// which have their own collection of XSS vectors.
	result+=text;}else{var escaped=escapeHtml(text,false);if(options.textFilter&&!addedText){result+=options.textFilter(escaped,tag);}else if(!addedText){result+=escaped;}}if(stack.length){var frame=stack[stack.length-1];frame.text+=text;}},onclosetag:function onclosetag(name){if(skipText){skipTextDepth--;if(!skipTextDepth){skipText=false;}else{return;}}var frame=stack.pop();if(!frame){// Do not crash on bad markup
	return;}skipText=options.enforceHtmlBoundary?name==='html':false;depth--;var skip=skipMap[depth];if(skip){delete skipMap[depth];if(options.disallowedTagsMode==='discard'){frame.updateParentNodeText();return;}tempResult=result;result='';}if(transformMap[depth]){name=transformMap[depth];delete transformMap[depth];}if(options.exclusiveFilter&&options.exclusiveFilter(frame)){result=result.substr(0,frame.tagPosition);return;}frame.updateParentNodeMediaChildren();frame.updateParentNodeText();if(options.selfClosing.indexOf(name)!==-1){// Already output />
	if(skip){result=tempResult;tempResult='';}return;}result+='</'+name+'>';if(skip){result=tempResult+escapeHtml(result);tempResult='';}}},options.parser);parser.write(html);parser.end();return result;function initializeState(){result='';depth=0;stack=[];skipMap={};transformMap={};skipText=false;skipTextDepth=0;}function escapeHtml(s,quote){if(typeof s!=='string'){s=s+'';}if(options.parser.decodeEntities){s=s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/\>/g,'&gt;');if(quote){s=s.replace(/\"/g,'&quot;');}}// TODO: this is inadequate because it will pass `&0;`. This approach
	// will not work, each & must be considered with regard to whether it
	// is followed by a 100% syntactically valid entity or not, and escaped
	// if it is not. If this bothers you, don't set parser.decodeEntities
	// to false. (The default is true.)
	s=s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g,'&amp;')// Match ampersands not part of existing HTML entity
	.replace(/</g,'&lt;').replace(/\>/g,'&gt;');if(quote){s=s.replace(/\"/g,'&quot;');}return s;}function naughtyHref(name,href){// Browsers ignore character codes of 32 (space) and below in a surprising
	// number of situations. Start reading here:
	// https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
	// eslint-disable-next-line no-control-regex
	href=href.replace(/[\x00-\x20]+/g,'');// Clobber any comments in URLs, which the browser might
	// interpret inside an XML data island, allowing
	// a javascript: URL to be snuck through
	href=href.replace(/<\!\-\-.*?\-\-\>/g,'');// Case insensitive so we don't get faked out by JAVASCRIPT #1
	var matches=href.match(/^([a-zA-Z]+)\:/);if(!matches){// Protocol-relative URL starting with any combination of '/' and '\'
	if(href.match(/^[\/\\]{2}/)){return!options.allowProtocolRelative;}// No scheme
	return false;}var scheme=matches[1].toLowerCase();if(has(options.allowedSchemesByTag,name)){return options.allowedSchemesByTag[name].indexOf(scheme)===-1;}return!options.allowedSchemes||options.allowedSchemes.indexOf(scheme)===-1;}/**
	   * Filters user input css properties by whitelisted regex attributes.
	   *
	   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
	   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
	   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
	   * @return {object}                    - Abstract Syntax Tree with filtered style attributes.
	   */function filterCss(abstractSyntaxTree,allowedStyles){if(!allowedStyles){return abstractSyntaxTree;}var filteredAST=cloneDeep(abstractSyntaxTree);var astRules=abstractSyntaxTree.nodes[0];var selectedRule;// Merge global and tag-specific styles into new AST.
	if(allowedStyles[astRules.selector]&&allowedStyles['*']){selectedRule=mergeWith(cloneDeep(allowedStyles[astRules.selector]),allowedStyles['*'],function(objValue,srcValue){if(Array.isArray(objValue)){return objValue.concat(srcValue);}});}else{selectedRule=allowedStyles[astRules.selector]||allowedStyles['*'];}if(selectedRule){filteredAST.nodes[0].nodes=astRules.nodes.reduce(filterDeclarations(selectedRule),[]);}return filteredAST;}/**
	   * Extracts the style attribues from an AbstractSyntaxTree and formats those
	   * values in the inline style attribute format.
	   *
	   * @param  {AbstractSyntaxTree} filteredAST
	   * @return {string}             - Example: "color:yellow;text-align:center;font-family:helvetica;"
	   */function stringifyStyleAttributes(filteredAST){return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes,attributeObject){extractedAttributes.push(attributeObject.prop+':'+attributeObject.value);return extractedAttributes;},[]).join(';');}/**
	    * Filters the existing attributes for the given property. Discards any attributes
	    * which don't match the whitelist.
	    *
	    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
	    * @param  {array} allowedDeclarationsList   - List of declarations which pass whitelisting.
	    * @param  {object} attributeObject          - Object representing the current css property.
	    * @property {string} attributeObject.type   - Typically 'declaration'.
	    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
	    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
	    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
	    */function filterDeclarations(selectedRule){return function(allowedDeclarationsList,attributeObject){// If this property is whitelisted...
	if(has(selectedRule,attributeObject.prop)){var matchesRegex=selectedRule[attributeObject.prop].some(function(regularExpression){return regularExpression.test(attributeObject.value);});if(matchesRegex){allowedDeclarationsList.push(attributeObject);}}return allowedDeclarationsList;};}function filterClasses(classes,allowed){if(!allowed){// The class attribute is allowed without filtering on this tag
	return classes;}classes=classes.split(/\s+/);return classes.filter(function(clss){return allowed.indexOf(clss)!==-1;}).join(' ');}}// Defaults are accessible to you so that you can use them as a starting point
	// programmatically if you wish
	var htmlParserDefaults={decodeEntities:true};sanitizeHtml.defaults={allowedTags:['h3','h4','h5','h6','blockquote','p','a','ul','ol','nl','li','b','i','strong','em','strike','abbr','code','hr','br','div','table','thead','caption','tbody','tr','th','td','pre','iframe'],disallowedTagsMode:'discard',allowedAttributes:{a:['href','name','target'],// We don't currently allow img itself by default, but this
	// would make sense if we did. You could add srcset here,
	// and if you do the URL is checked for safety
	img:['src']},// Lots of these won't come up by default because we don't allow them
	selfClosing:['img','br','hr','area','base','basefont','input','link','meta'],// URL schemes we permit
	allowedSchemes:['http','https','ftp','mailto'],allowedSchemesByTag:{},allowedSchemesAppliedToAttributes:['href','src','cite'],allowProtocolRelative:true,enforceHtmlBoundary:false};sanitizeHtml.simpleTransform=function(newTagName,newAttribs,merge){merge=merge===undefined?true:merge;newAttribs=newAttribs||{};return function(tagName,attribs){var attrib;if(merge){for(attrib in newAttribs){attribs[attrib]=newAttribs[attrib];}}else{attribs=newAttribs;}return{tagName:newTagName,attribs:attribs};};};},{"htmlparser2":31,"lodash/cloneDeep":140,"lodash/escapeRegExp":143,"lodash/isPlainObject":155,"lodash/isString":157,"lodash/mergeWith":162,"parse-srcset":167,"postcss":181,"url":209}]},{},[211])(211);});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 1222 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(33).Buffer
	var Hash   = __webpack_require__(1222)(Buffer)
	
	exports.sha1 = __webpack_require__(1224)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1225)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1226)(Buffer, Hash)


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(232).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(232).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(232).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(1228);
	var parser = __webpack_require__(229);
	var Manager = __webpack_require__(485);
	var debug = __webpack_require__(164)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  }
	  return io.socket(parsed.path, opts);
	}
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(485);
	exports.Socket = __webpack_require__(487);


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(437);
	var debug = __webpack_require__(164)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || (typeof location !== 'undefined' && location);
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}


/***/ },
/* 1229 */
[1263, 1230],
/* 1230 */
988,
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(490);
	var isBuf = __webpack_require__(489);
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
	var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet) {
	  var buffers = [];
	  var packetData = packet.data;
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData, buffers);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	function _deconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (isBuf(data)) {
	    var placeholder = { _placeholder: true, num: buffers.length };
	    buffers.push(data);
	    return placeholder;
	  } else if (isArray(data)) {
	    var newData = new Array(data.length);
	    for (var i = 0; i < data.length; i++) {
	      newData[i] = _deconstructPacket(data[i], buffers);
	    }
	    return newData;
	  } else if (typeof data === 'object' && !(data instanceof Date)) {
	    var newData = {};
	    for (var key in data) {
	      newData[key] = _deconstructPacket(data[key], buffers);
	    }
	    return newData;
	  }
	  return data;
	}
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  packet.data = _reconstructPacket(packet.data, buffers);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	function _reconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (data && data._placeholder === true) {
	    var isIndexValid =
	      typeof data.num === "number" &&
	      data.num >= 0 &&
	      data.num < buffers.length;
	    if (isIndexValid) {
	      return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	    } else {
	      throw new Error("illegal attachments");
	    }
	  } else if (isArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      data[i] = _reconstructPacket(data[i], buffers);
	    }
	  } else if (typeof data === 'object') {
	    for (var key in data) {
	      data[key] = _reconstructPacket(data[key], buffers);
	    }
	  }
	
	  return data;
	}
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((withNativeBlob && obj instanceof Blob) ||
	        (withNativeFile && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};


/***/ },
/* 1232 */
196,
/* 1233 */
[1262, 1234],
/* 1234 */
[1263, 1235],
/* 1235 */
988,
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(148).EventEmitter;
	var inherits = __webpack_require__(47);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(231);
	Stream.Writable = __webpack_require__(1243);
	Stream.Duplex = __webpack_require__(1238);
	Stream.Transform = __webpack_require__(1242);
	Stream.PassThrough = __webpack_require__(1241);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 1237 */
490,
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(101);


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(492);
	
	/*<replacement>*/
	var util = __webpack_require__(120);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(130).Buffer;
	var util = __webpack_require__(1261);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(231).PassThrough


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(231).Transform


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(230);


/***/ },
/* 1244 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 1245 */
495,
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	* sweetalert2 v10.13.1
	* Released under the MIT License.
	*/
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.Sweetalert2 = factory());
	}(this, function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _isNativeReflectConstruct() {
	    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	    if (Reflect.construct.sham) return false;
	    if (typeof Proxy === "function") return true;
	
	    try {
	      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	
	  function _construct(Parent, args, Class) {
	    if (_isNativeReflectConstruct()) {
	      _construct = Reflect.construct;
	    } else {
	      _construct = function _construct(Parent, args, Class) {
	        var a = [null];
	        a.push.apply(a, args);
	        var Constructor = Function.bind.apply(Parent, a);
	        var instance = new Constructor();
	        if (Class) _setPrototypeOf(instance, Class.prototype);
	        return instance;
	      };
	    }
	
	    return _construct.apply(null, arguments);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _createSuper(Derived) {
	    var hasNativeReflectConstruct = _isNativeReflectConstruct();
	
	    return function _createSuperInternal() {
	      var Super = _getPrototypeOf(Derived),
	          result;
	
	      if (hasNativeReflectConstruct) {
	        var NewTarget = _getPrototypeOf(this).constructor;
	
	        result = Reflect.construct(Super, arguments, NewTarget);
	      } else {
	        result = Super.apply(this, arguments);
	      }
	
	      return _possibleConstructorReturn(this, result);
	    };
	  }
	
	  function _superPropBase(object, property) {
	    while (!Object.prototype.hasOwnProperty.call(object, property)) {
	      object = _getPrototypeOf(object);
	      if (object === null) break;
	    }
	
	    return object;
	  }
	
	  function _get(target, property, receiver) {
	    if (typeof Reflect !== "undefined" && Reflect.get) {
	      _get = Reflect.get;
	    } else {
	      _get = function _get(target, property, receiver) {
	        var base = _superPropBase(target, property);
	
	        if (!base) return;
	        var desc = Object.getOwnPropertyDescriptor(base, property);
	
	        if (desc.get) {
	          return desc.get.call(receiver);
	        }
	
	        return desc.value;
	      };
	    }
	
	    return _get(target, property, receiver || target);
	  }
	
	  var consolePrefix = 'SweetAlert2:';
	  /**
	   * Filter the unique values into a new array
	   * @param arr
	   */
	
	  var uniqueArray = function uniqueArray(arr) {
	    var result = [];
	
	    for (var i = 0; i < arr.length; i++) {
	      if (result.indexOf(arr[i]) === -1) {
	        result.push(arr[i]);
	      }
	    }
	
	    return result;
	  };
	  /**
	   * Capitalize the first letter of a string
	   * @param str
	   */
	
	  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  };
	  /**
	   * Returns the array of object values (Object.values isn't supported in IE11)
	   * @param obj
	   */
	
	  var objectValues = function objectValues(obj) {
	    return Object.keys(obj).map(function (key) {
	      return obj[key];
	    });
	  };
	  /**
	   * Convert NodeList to Array
	   * @param nodeList
	   */
	
	  var toArray = function toArray(nodeList) {
	    return Array.prototype.slice.call(nodeList);
	  };
	  /**
	   * Standardise console warnings
	   * @param message
	   */
	
	  var warn = function warn(message) {
	    console.warn("".concat(consolePrefix, " ").concat(_typeof(message) === 'object' ? message.join(' ') : message));
	  };
	  /**
	   * Standardise console errors
	   * @param message
	   */
	
	  var error = function error(message) {
	    console.error("".concat(consolePrefix, " ").concat(message));
	  };
	  /**
	   * Private global state for `warnOnce`
	   * @type {Array}
	   * @private
	   */
	
	  var previousWarnOnceMessages = [];
	  /**
	   * Show a console warning, but only if it hasn't already been shown
	   * @param message
	   */
	
	  var warnOnce = function warnOnce(message) {
	    if (!(previousWarnOnceMessages.indexOf(message) !== -1)) {
	      previousWarnOnceMessages.push(message);
	      warn(message);
	    }
	  };
	  /**
	   * Show a one-time console warning about deprecated params/methods
	   */
	
	  var warnAboutDeprecation = function warnAboutDeprecation(deprecatedParam, useInstead) {
	    warnOnce("\"".concat(deprecatedParam, "\" is deprecated and will be removed in the next major release. Please use \"").concat(useInstead, "\" instead."));
	  };
	  /**
	   * If `arg` is a function, call it (with no arguments or context) and return the result.
	   * Otherwise, just pass the value through
	   * @param arg
	   */
	
	  var callIfFunction = function callIfFunction(arg) {
	    return typeof arg === 'function' ? arg() : arg;
	  };
	  var hasToPromiseFn = function hasToPromiseFn(arg) {
	    return arg && typeof arg.toPromise === 'function';
	  };
	  var asPromise = function asPromise(arg) {
	    return hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
	  };
	  var isPromise = function isPromise(arg) {
	    return arg && Promise.resolve(arg) === arg;
	  };
	
	  var DismissReason = Object.freeze({
	    cancel: 'cancel',
	    backdrop: 'backdrop',
	    close: 'close',
	    esc: 'esc',
	    timer: 'timer'
	  });
	
	  var isJqueryElement = function isJqueryElement(elem) {
	    return _typeof(elem) === 'object' && elem.jquery;
	  };
	
	  var isElement = function isElement(elem) {
	    return elem instanceof Element || isJqueryElement(elem);
	  };
	
	  var argsToParams = function argsToParams(args) {
	    var params = {};
	
	    if (_typeof(args[0]) === 'object' && !isElement(args[0])) {
	      _extends(params, args[0]);
	    } else {
	      ['title', 'html', 'icon'].forEach(function (name, index) {
	        var arg = args[index];
	
	        if (typeof arg === 'string' || isElement(arg)) {
	          params[name] = arg;
	        } else if (arg !== undefined) {
	          error("Unexpected type of ".concat(name, "! Expected \"string\" or \"Element\", got ").concat(_typeof(arg)));
	        }
	      });
	    }
	
	    return params;
	  };
	
	  var swalPrefix = 'swal2-';
	  var prefix = function prefix(items) {
	    var result = {};
	
	    for (var i in items) {
	      result[items[i]] = swalPrefix + items[i];
	    }
	
	    return result;
	  };
	  var swalClasses = prefix(['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'toast-column', 'show', 'hide', 'close', 'title', 'header', 'content', 'html-container', 'actions', 'confirm', 'deny', 'cancel', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'input-label', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loader', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error']);
	  var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);
	
	  var getContainer = function getContainer() {
	    return document.body.querySelector(".".concat(swalClasses.container));
	  };
	  var elementBySelector = function elementBySelector(selectorString) {
	    var container = getContainer();
	    return container ? container.querySelector(selectorString) : null;
	  };
	
	  var elementByClass = function elementByClass(className) {
	    return elementBySelector(".".concat(className));
	  };
	
	  var getPopup = function getPopup() {
	    return elementByClass(swalClasses.popup);
	  };
	  var getIcons = function getIcons() {
	    var popup = getPopup();
	    return toArray(popup.querySelectorAll(".".concat(swalClasses.icon)));
	  };
	  var getIcon = function getIcon() {
	    var visibleIcon = getIcons().filter(function (icon) {
	      return isVisible(icon);
	    });
	    return visibleIcon.length ? visibleIcon[0] : null;
	  };
	  var getTitle = function getTitle() {
	    return elementByClass(swalClasses.title);
	  };
	  var getContent = function getContent() {
	    return elementByClass(swalClasses.content);
	  };
	  var getHtmlContainer = function getHtmlContainer() {
	    return elementByClass(swalClasses['html-container']);
	  };
	  var getImage = function getImage() {
	    return elementByClass(swalClasses.image);
	  };
	  var getProgressSteps = function getProgressSteps() {
	    return elementByClass(swalClasses['progress-steps']);
	  };
	  var getValidationMessage = function getValidationMessage() {
	    return elementByClass(swalClasses['validation-message']);
	  };
	  var getConfirmButton = function getConfirmButton() {
	    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.confirm));
	  };
	  var getDenyButton = function getDenyButton() {
	    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.deny));
	  };
	  var getInputLabel = function getInputLabel() {
	    return elementByClass(swalClasses['input-label']);
	  };
	  var getLoader = function getLoader() {
	    return elementBySelector(".".concat(swalClasses.loader));
	  };
	  var getCancelButton = function getCancelButton() {
	    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.cancel));
	  };
	  var getActions = function getActions() {
	    return elementByClass(swalClasses.actions);
	  };
	  var getHeader = function getHeader() {
	    return elementByClass(swalClasses.header);
	  };
	  var getFooter = function getFooter() {
	    return elementByClass(swalClasses.footer);
	  };
	  var getTimerProgressBar = function getTimerProgressBar() {
	    return elementByClass(swalClasses['timer-progress-bar']);
	  };
	  var getCloseButton = function getCloseButton() {
	    return elementByClass(swalClasses.close);
	  }; // https://github.com/jkup/focusable/blob/master/index.js
	
	  var focusable = "\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex=\"0\"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n";
	  var getFocusableElements = function getFocusableElements() {
	    var focusableElementsWithTabindex = toArray(getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')) // sort according to tabindex
	    .sort(function (a, b) {
	      a = parseInt(a.getAttribute('tabindex'));
	      b = parseInt(b.getAttribute('tabindex'));
	
	      if (a > b) {
	        return 1;
	      } else if (a < b) {
	        return -1;
	      }
	
	      return 0;
	    });
	    var otherFocusableElements = toArray(getPopup().querySelectorAll(focusable)).filter(function (el) {
	      return el.getAttribute('tabindex') !== '-1';
	    });
	    return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements)).filter(function (el) {
	      return isVisible(el);
	    });
	  };
	  var isModal = function isModal() {
	    return !isToast() && !document.body.classList.contains(swalClasses['no-backdrop']);
	  };
	  var isToast = function isToast() {
	    return document.body.classList.contains(swalClasses['toast-shown']);
	  };
	  var isLoading = function isLoading() {
	    return getPopup().hasAttribute('data-loading');
	  };
	
	  var states = {
	    previousBodyPadding: null
	  };
	  var setInnerHtml = function setInnerHtml(elem, html) {
	    // #1926
	    elem.textContent = '';
	
	    if (html) {
	      var parser = new DOMParser();
	      var parsed = parser.parseFromString(html, "text/html");
	      toArray(parsed.querySelector('head').childNodes).forEach(function (child) {
	        elem.appendChild(child);
	      });
	      toArray(parsed.querySelector('body').childNodes).forEach(function (child) {
	        elem.appendChild(child);
	      });
	    }
	  };
	  var hasClass = function hasClass(elem, className) {
	    if (!className) {
	      return false;
	    }
	
	    var classList = className.split(/\s+/);
	
	    for (var i = 0; i < classList.length; i++) {
	      if (!elem.classList.contains(classList[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  var removeCustomClasses = function removeCustomClasses(elem, params) {
	    toArray(elem.classList).forEach(function (className) {
	      if (!(objectValues(swalClasses).indexOf(className) !== -1) && !(objectValues(iconTypes).indexOf(className) !== -1) && !(objectValues(params.showClass).indexOf(className) !== -1)) {
	        elem.classList.remove(className);
	      }
	    });
	  };
	
	  var applyCustomClass = function applyCustomClass(elem, params, className) {
	    removeCustomClasses(elem, params);
	
	    if (params.customClass && params.customClass[className]) {
	      if (typeof params.customClass[className] !== 'string' && !params.customClass[className].forEach) {
	        return warn("Invalid type of customClass.".concat(className, "! Expected string or iterable object, got \"").concat(_typeof(params.customClass[className]), "\""));
	      }
	
	      addClass(elem, params.customClass[className]);
	    }
	  };
	  function getInput(content, inputType) {
	    if (!inputType) {
	      return null;
	    }
	
	    switch (inputType) {
	      case 'select':
	      case 'textarea':
	      case 'file':
	        return getChildByClass(content, swalClasses[inputType]);
	
	      case 'checkbox':
	        return content.querySelector(".".concat(swalClasses.checkbox, " input"));
	
	      case 'radio':
	        return content.querySelector(".".concat(swalClasses.radio, " input:checked")) || content.querySelector(".".concat(swalClasses.radio, " input:first-child"));
	
	      case 'range':
	        return content.querySelector(".".concat(swalClasses.range, " input"));
	
	      default:
	        return getChildByClass(content, swalClasses.input);
	    }
	  }
	  var focusInput = function focusInput(input) {
	    input.focus(); // place cursor at end of text in text input
	
	    if (input.type !== 'file') {
	      // http://stackoverflow.com/a/2345915
	      var val = input.value;
	      input.value = '';
	      input.value = val;
	    }
	  };
	  var toggleClass = function toggleClass(target, classList, condition) {
	    if (!target || !classList) {
	      return;
	    }
	
	    if (typeof classList === 'string') {
	      classList = classList.split(/\s+/).filter(Boolean);
	    }
	
	    classList.forEach(function (className) {
	      if (target.forEach) {
	        target.forEach(function (elem) {
	          condition ? elem.classList.add(className) : elem.classList.remove(className);
	        });
	      } else {
	        condition ? target.classList.add(className) : target.classList.remove(className);
	      }
	    });
	  };
	  var addClass = function addClass(target, classList) {
	    toggleClass(target, classList, true);
	  };
	  var removeClass = function removeClass(target, classList) {
	    toggleClass(target, classList, false);
	  };
	  var getChildByClass = function getChildByClass(elem, className) {
	    for (var i = 0; i < elem.childNodes.length; i++) {
	      if (hasClass(elem.childNodes[i], className)) {
	        return elem.childNodes[i];
	      }
	    }
	  };
	  var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
	    if (value === "".concat(parseInt(value))) {
	      value = parseInt(value);
	    }
	
	    if (value || parseInt(value) === 0) {
	      elem.style[property] = typeof value === 'number' ? "".concat(value, "px") : value;
	    } else {
	      elem.style.removeProperty(property);
	    }
	  };
	  var show = function show(elem) {
	    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
	    elem.style.display = display;
	  };
	  var hide = function hide(elem) {
	    elem.style.display = 'none';
	  };
	  var setStyle = function setStyle(parent, selector, property, value) {
	    var el = parent.querySelector(selector);
	
	    if (el) {
	      el.style[property] = value;
	    }
	  };
	  var toggle = function toggle(elem, condition, display) {
	    condition ? show(elem, display) : hide(elem);
	  }; // borrowed from jquery $(elem).is(':visible') implementation
	
	  var isVisible = function isVisible(elem) {
	    return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
	  };
	  var allButtonsAreHidden = function allButtonsAreHidden() {
	    return !isVisible(getConfirmButton()) && !isVisible(getDenyButton()) && !isVisible(getCancelButton());
	  };
	  var isScrollable = function isScrollable(elem) {
	    return !!(elem.scrollHeight > elem.clientHeight);
	  }; // borrowed from https://stackoverflow.com/a/46352119
	
	  var hasCssAnimation = function hasCssAnimation(elem) {
	    var style = window.getComputedStyle(elem);
	    var animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
	    var transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
	    return animDuration > 0 || transDuration > 0;
	  };
	  var contains = function contains(haystack, needle) {
	    if (typeof haystack.contains === 'function') {
	      return haystack.contains(needle);
	    }
	  };
	  var animateTimerProgressBar = function animateTimerProgressBar(timer) {
	    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var timerProgressBar = getTimerProgressBar();
	
	    if (isVisible(timerProgressBar)) {
	      if (reset) {
	        timerProgressBar.style.transition = 'none';
	        timerProgressBar.style.width = '100%';
	      }
	
	      setTimeout(function () {
	        timerProgressBar.style.transition = "width ".concat(timer / 1000, "s linear");
	        timerProgressBar.style.width = '0%';
	      }, 10);
	    }
	  };
	  var stopTimerProgressBar = function stopTimerProgressBar() {
	    var timerProgressBar = getTimerProgressBar();
	    var timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
	    timerProgressBar.style.removeProperty('transition');
	    timerProgressBar.style.width = '100%';
	    var timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
	    var timerProgressBarPercent = parseInt(timerProgressBarWidth / timerProgressBarFullWidth * 100);
	    timerProgressBar.style.removeProperty('transition');
	    timerProgressBar.style.width = "".concat(timerProgressBarPercent, "%");
	  };
	
	  // Detect Node env
	  var isNodeEnv = function isNodeEnv() {
	    return typeof window === 'undefined' || typeof document === 'undefined';
	  };
	
	  var sweetHTML = "\n <div aria-labelledby=\"".concat(swalClasses.title, "\" aria-describedby=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses.popup, "\" tabindex=\"-1\">\n   <div class=\"").concat(swalClasses.header, "\">\n     <ul class=\"").concat(swalClasses['progress-steps'], "\"></ul>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.error, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.question, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.warning, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.info, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.success, "\"></div>\n     <img class=\"").concat(swalClasses.image, "\" />\n     <h2 class=\"").concat(swalClasses.title, "\" id=\"").concat(swalClasses.title, "\"></h2>\n     <button type=\"button\" class=\"").concat(swalClasses.close, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.content, "\">\n     <div id=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses['html-container'], "\"></div>\n     <input class=\"").concat(swalClasses.input, "\" />\n     <input type=\"file\" class=\"").concat(swalClasses.file, "\" />\n     <div class=\"").concat(swalClasses.range, "\">\n       <input type=\"range\" />\n       <output></output>\n     </div>\n     <select class=\"").concat(swalClasses.select, "\"></select>\n     <div class=\"").concat(swalClasses.radio, "\"></div>\n     <label for=\"").concat(swalClasses.checkbox, "\" class=\"").concat(swalClasses.checkbox, "\">\n       <input type=\"checkbox\" />\n       <span class=\"").concat(swalClasses.label, "\"></span>\n     </label>\n     <textarea class=\"").concat(swalClasses.textarea, "\"></textarea>\n     <div class=\"").concat(swalClasses['validation-message'], "\" id=\"").concat(swalClasses['validation-message'], "\"></div>\n   </div>\n   <div class=\"").concat(swalClasses.actions, "\">\n     <div class=\"").concat(swalClasses.loader, "\"></div>\n     <button type=\"button\" class=\"").concat(swalClasses.confirm, "\"></button>\n     <button type=\"button\" class=\"").concat(swalClasses.deny, "\"></button>\n     <button type=\"button\" class=\"").concat(swalClasses.cancel, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.footer, "\"></div>\n   <div class=\"").concat(swalClasses['timer-progress-bar-container'], "\">\n     <div class=\"").concat(swalClasses['timer-progress-bar'], "\"></div>\n   </div>\n </div>\n").replace(/(^|\n)\s*/g, '');
	
	  var resetOldContainer = function resetOldContainer() {
	    var oldContainer = getContainer();
	
	    if (!oldContainer) {
	      return false;
	    }
	
	    oldContainer.parentNode.removeChild(oldContainer);
	    removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
	    return true;
	  };
	
	  var oldInputVal; // IE11 workaround, see #1109 for details
	
	  var resetValidationMessage = function resetValidationMessage(e) {
	    if (Swal.isVisible() && oldInputVal !== e.target.value) {
	      Swal.resetValidationMessage();
	    }
	
	    oldInputVal = e.target.value;
	  };
	
	  var addInputChangeListeners = function addInputChangeListeners() {
	    var content = getContent();
	    var input = getChildByClass(content, swalClasses.input);
	    var file = getChildByClass(content, swalClasses.file);
	    var range = content.querySelector(".".concat(swalClasses.range, " input"));
	    var rangeOutput = content.querySelector(".".concat(swalClasses.range, " output"));
	    var select = getChildByClass(content, swalClasses.select);
	    var checkbox = content.querySelector(".".concat(swalClasses.checkbox, " input"));
	    var textarea = getChildByClass(content, swalClasses.textarea);
	    input.oninput = resetValidationMessage;
	    file.onchange = resetValidationMessage;
	    select.onchange = resetValidationMessage;
	    checkbox.onchange = resetValidationMessage;
	    textarea.oninput = resetValidationMessage;
	
	    range.oninput = function (e) {
	      resetValidationMessage(e);
	      rangeOutput.value = range.value;
	    };
	
	    range.onchange = function (e) {
	      resetValidationMessage(e);
	      range.nextSibling.value = range.value;
	    };
	  };
	
	  var getTarget = function getTarget(target) {
	    return typeof target === 'string' ? document.querySelector(target) : target;
	  };
	
	  var setupAccessibility = function setupAccessibility(params) {
	    var popup = getPopup();
	    popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
	    popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
	
	    if (!params.toast) {
	      popup.setAttribute('aria-modal', 'true');
	    }
	  };
	
	  var setupRTL = function setupRTL(targetElement) {
	    if (window.getComputedStyle(targetElement).direction === 'rtl') {
	      addClass(getContainer(), swalClasses.rtl);
	    }
	  };
	  /*
	   * Add modal + backdrop to DOM
	   */
	
	
	  var init = function init(params) {
	    // Clean up the old popup container if it exists
	    var oldContainerExisted = resetOldContainer();
	    /* istanbul ignore if */
	
	    if (isNodeEnv()) {
	      error('SweetAlert2 requires document to initialize');
	      return;
	    }
	
	    var container = document.createElement('div');
	    container.className = swalClasses.container;
	
	    if (oldContainerExisted) {
	      addClass(container, swalClasses['no-transition']);
	    }
	
	    setInnerHtml(container, sweetHTML);
	    var targetElement = getTarget(params.target);
	    targetElement.appendChild(container);
	    setupAccessibility(params);
	    setupRTL(targetElement);
	    addInputChangeListeners();
	  };
	
	  var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
	    // DOM element
	    if (param instanceof HTMLElement) {
	      target.appendChild(param); // Object
	    } else if (_typeof(param) === 'object') {
	      handleObject(param, target); // Plain string
	    } else if (param) {
	      setInnerHtml(target, param);
	    }
	  };
	
	  var handleObject = function handleObject(param, target) {
	    // JQuery element(s)
	    if (param.jquery) {
	      handleJqueryElem(target, param); // For other objects use their string representation
	    } else {
	      setInnerHtml(target, param.toString());
	    }
	  };
	
	  var handleJqueryElem = function handleJqueryElem(target, elem) {
	    target.textContent = '';
	
	    if (0 in elem) {
	      for (var i = 0; (i in elem); i++) {
	        target.appendChild(elem[i].cloneNode(true));
	      }
	    } else {
	      target.appendChild(elem.cloneNode(true));
	    }
	  };
	
	  var animationEndEvent = function () {
	    // Prevent run in Node env
	
	    /* istanbul ignore if */
	    if (isNodeEnv()) {
	      return false;
	    }
	
	    var testEl = document.createElement('div');
	    var transEndEventNames = {
	      WebkitAnimation: 'webkitAnimationEnd',
	      OAnimation: 'oAnimationEnd oanimationend',
	      animation: 'animationend'
	    };
	
	    for (var i in transEndEventNames) {
	      if (Object.prototype.hasOwnProperty.call(transEndEventNames, i) && typeof testEl.style[i] !== 'undefined') {
	        return transEndEventNames[i];
	      }
	    }
	
	    return false;
	  }();
	
	  // https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
	
	  var measureScrollbar = function measureScrollbar() {
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = swalClasses['scrollbar-measure'];
	    document.body.appendChild(scrollDiv);
	    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	    document.body.removeChild(scrollDiv);
	    return scrollbarWidth;
	  };
	
	  var renderActions = function renderActions(instance, params) {
	    var actions = getActions();
	    var loader = getLoader();
	    var confirmButton = getConfirmButton();
	    var denyButton = getDenyButton();
	    var cancelButton = getCancelButton(); // Actions (buttons) wrapper
	
	    if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) {
	      hide(actions);
	    } // Custom class
	
	
	    applyCustomClass(actions, params, 'actions'); // Render buttons
	
	    renderButton(confirmButton, 'confirm', params);
	    renderButton(denyButton, 'deny', params);
	    renderButton(cancelButton, 'cancel', params);
	    handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
	
	    if (params.reverseButtons) {
	      actions.insertBefore(cancelButton, loader);
	      actions.insertBefore(denyButton, loader);
	      actions.insertBefore(confirmButton, loader);
	    } // Loader
	
	
	    setInnerHtml(loader, params.loaderHtml);
	    applyCustomClass(loader, params, 'loader');
	  };
	
	  function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
	    if (!params.buttonsStyling) {
	      return removeClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
	    }
	
	    addClass([confirmButton, denyButton, cancelButton], swalClasses.styled); // Buttons background colors
	
	    if (params.confirmButtonColor) {
	      confirmButton.style.backgroundColor = params.confirmButtonColor;
	    }
	
	    if (params.denyButtonColor) {
	      denyButton.style.backgroundColor = params.denyButtonColor;
	    }
	
	    if (params.cancelButtonColor) {
	      cancelButton.style.backgroundColor = params.cancelButtonColor;
	    }
	  }
	
	  function renderButton(button, buttonType, params) {
	    toggle(button, params["show".concat(capitalizeFirstLetter(buttonType), "Button")], 'inline-block');
	    setInnerHtml(button, params["".concat(buttonType, "ButtonText")]); // Set caption text
	
	    button.setAttribute('aria-label', params["".concat(buttonType, "ButtonAriaLabel")]); // ARIA label
	    // Add buttons custom classes
	
	    button.className = swalClasses[buttonType];
	    applyCustomClass(button, params, "".concat(buttonType, "Button"));
	    addClass(button, params["".concat(buttonType, "ButtonClass")]);
	  }
	
	  function handleBackdropParam(container, backdrop) {
	    if (typeof backdrop === 'string') {
	      container.style.background = backdrop;
	    } else if (!backdrop) {
	      addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
	    }
	  }
	
	  function handlePositionParam(container, position) {
	    if (position in swalClasses) {
	      addClass(container, swalClasses[position]);
	    } else {
	      warn('The "position" parameter is not valid, defaulting to "center"');
	      addClass(container, swalClasses.center);
	    }
	  }
	
	  function handleGrowParam(container, grow) {
	    if (grow && typeof grow === 'string') {
	      var growClass = "grow-".concat(grow);
	
	      if (growClass in swalClasses) {
	        addClass(container, swalClasses[growClass]);
	      }
	    }
	  }
	
	  var renderContainer = function renderContainer(instance, params) {
	    var container = getContainer();
	
	    if (!container) {
	      return;
	    }
	
	    handleBackdropParam(container, params.backdrop);
	
	    if (!params.backdrop && params.allowOutsideClick) {
	      warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
	    }
	
	    handlePositionParam(container, params.position);
	    handleGrowParam(container, params.grow); // Custom class
	
	    applyCustomClass(container, params, 'container'); // Set queue step attribute for getQueueStep() method
	
	    var queueStep = document.body.getAttribute('data-swal2-queue-step');
	
	    if (queueStep) {
	      container.setAttribute('data-queue-step', queueStep);
	      document.body.removeAttribute('data-swal2-queue-step');
	    }
	  };
	
	  /**
	   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
	   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
	   * This is the approach that Babel will probably take to implement private methods/fields
	   *   https://github.com/tc39/proposal-private-methods
	   *   https://github.com/babel/babel/pull/7555
	   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
	   *   then we can use that language feature.
	   */
	  var privateProps = {
	    promise: new WeakMap(),
	    innerParams: new WeakMap(),
	    domCache: new WeakMap()
	  };
	
	  var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
	  var renderInput = function renderInput(instance, params) {
	    var content = getContent();
	    var innerParams = privateProps.innerParams.get(instance);
	    var rerender = !innerParams || params.input !== innerParams.input;
	    inputTypes.forEach(function (inputType) {
	      var inputClass = swalClasses[inputType];
	      var inputContainer = getChildByClass(content, inputClass); // set attributes
	
	      setAttributes(inputType, params.inputAttributes); // set class
	
	      inputContainer.className = inputClass;
	
	      if (rerender) {
	        hide(inputContainer);
	      }
	    });
	
	    if (params.input) {
	      if (rerender) {
	        showInput(params);
	      } // set custom class
	
	
	      setCustomClass(params);
	    }
	  };
	
	  var showInput = function showInput(params) {
	    if (!renderInputType[params.input]) {
	      return error("Unexpected type of input! Expected \"text\", \"email\", \"password\", \"number\", \"tel\", \"select\", \"radio\", \"checkbox\", \"textarea\", \"file\" or \"url\", got \"".concat(params.input, "\""));
	    }
	
	    var inputContainer = getInputContainer(params.input);
	    var input = renderInputType[params.input](inputContainer, params);
	    show(input); // input autofocus
	
	    setTimeout(function () {
	      focusInput(input);
	    });
	  };
	
	  var removeAttributes = function removeAttributes(input) {
	    for (var i = 0; i < input.attributes.length; i++) {
	      var attrName = input.attributes[i].name;
	
	      if (!(['type', 'value', 'style'].indexOf(attrName) !== -1)) {
	        input.removeAttribute(attrName);
	      }
	    }
	  };
	
	  var setAttributes = function setAttributes(inputType, inputAttributes) {
	    var input = getInput(getContent(), inputType);
	
	    if (!input) {
	      return;
	    }
	
	    removeAttributes(input);
	
	    for (var attr in inputAttributes) {
	      // Do not set a placeholder for <input type="range">
	      // it'll crash Edge, #1298
	      if (inputType === 'range' && attr === 'placeholder') {
	        continue;
	      }
	
	      input.setAttribute(attr, inputAttributes[attr]);
	    }
	  };
	
	  var setCustomClass = function setCustomClass(params) {
	    var inputContainer = getInputContainer(params.input);
	
	    if (params.customClass) {
	      addClass(inputContainer, params.customClass.input);
	    }
	  };
	
	  var setInputPlaceholder = function setInputPlaceholder(input, params) {
	    if (!input.placeholder || params.inputPlaceholder) {
	      input.placeholder = params.inputPlaceholder;
	    }
	  };
	
	  var setInputLabel = function setInputLabel(input, prependTo, params) {
	    if (params.inputLabel) {
	      input.id = swalClasses.input;
	      var label = document.createElement('label');
	      var labelClass = swalClasses['input-label'];
	      label.setAttribute('for', input.id);
	      label.className = labelClass;
	      addClass(label, params.customClass.inputLabel);
	      label.innerText = params.inputLabel;
	      prependTo.insertAdjacentElement('beforebegin', label);
	    }
	  };
	
	  var getInputContainer = function getInputContainer(inputType) {
	    var inputClass = swalClasses[inputType] ? swalClasses[inputType] : swalClasses.input;
	    return getChildByClass(getContent(), inputClass);
	  };
	
	  var renderInputType = {};
	
	  renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = function (input, params) {
	    if (typeof params.inputValue === 'string' || typeof params.inputValue === 'number') {
	      input.value = params.inputValue;
	    } else if (!isPromise(params.inputValue)) {
	      warn("Unexpected type of inputValue! Expected \"string\", \"number\" or \"Promise\", got \"".concat(_typeof(params.inputValue), "\""));
	    }
	
	    setInputLabel(input, input, params);
	    setInputPlaceholder(input, params);
	    input.type = params.input;
	    return input;
	  };
	
	  renderInputType.file = function (input, params) {
	    setInputLabel(input, input, params);
	    setInputPlaceholder(input, params);
	    return input;
	  };
	
	  renderInputType.range = function (range, params) {
	    var rangeInput = range.querySelector('input');
	    var rangeOutput = range.querySelector('output');
	    rangeInput.value = params.inputValue;
	    rangeInput.type = params.input;
	    rangeOutput.value = params.inputValue;
	    setInputLabel(rangeInput, range, params);
	    return range;
	  };
	
	  renderInputType.select = function (select, params) {
	    select.textContent = '';
	
	    if (params.inputPlaceholder) {
	      var placeholder = document.createElement('option');
	      setInnerHtml(placeholder, params.inputPlaceholder);
	      placeholder.value = '';
	      placeholder.disabled = true;
	      placeholder.selected = true;
	      select.appendChild(placeholder);
	    }
	
	    setInputLabel(select, select, params);
	    return select;
	  };
	
	  renderInputType.radio = function (radio) {
	    radio.textContent = '';
	    return radio;
	  };
	
	  renderInputType.checkbox = function (checkboxContainer, params) {
	    var checkbox = getInput(getContent(), 'checkbox');
	    checkbox.value = 1;
	    checkbox.id = swalClasses.checkbox;
	    checkbox.checked = Boolean(params.inputValue);
	    var label = checkboxContainer.querySelector('span');
	    setInnerHtml(label, params.inputPlaceholder);
	    return checkboxContainer;
	  };
	
	  renderInputType.textarea = function (textarea, params) {
	    textarea.value = params.inputValue;
	    setInputPlaceholder(textarea, params);
	    setInputLabel(textarea, textarea, params);
	
	    var getPadding = function getPadding(el) {
	      return parseInt(window.getComputedStyle(el).paddingLeft) + parseInt(window.getComputedStyle(el).paddingRight);
	    };
	
	    if ('MutationObserver' in window) {
	      // #1699
	      var initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
	
	      var outputsize = function outputsize() {
	        var contentWidth = textarea.offsetWidth + getPadding(getPopup()) + getPadding(getContent());
	
	        if (contentWidth > initialPopupWidth) {
	          getPopup().style.width = "".concat(contentWidth, "px");
	        } else {
	          getPopup().style.width = null;
	        }
	      };
	
	      new MutationObserver(outputsize).observe(textarea, {
	        attributes: true,
	        attributeFilter: ['style']
	      });
	    }
	
	    return textarea;
	  };
	
	  var renderContent = function renderContent(instance, params) {
	    var content = getContent().querySelector("#".concat(swalClasses.content)); // Content as HTML
	
	    if (params.html) {
	      parseHtmlToContainer(params.html, content);
	      show(content, 'block'); // Content as plain text
	    } else if (params.text) {
	      content.textContent = params.text;
	      show(content, 'block'); // No content
	    } else {
	      hide(content);
	    }
	
	    renderInput(instance, params); // Custom class
	
	    applyCustomClass(getContent(), params, 'content');
	  };
	
	  var renderFooter = function renderFooter(instance, params) {
	    var footer = getFooter();
	    toggle(footer, params.footer);
	
	    if (params.footer) {
	      parseHtmlToContainer(params.footer, footer);
	    } // Custom class
	
	
	    applyCustomClass(footer, params, 'footer');
	  };
	
	  var renderCloseButton = function renderCloseButton(instance, params) {
	    var closeButton = getCloseButton();
	    setInnerHtml(closeButton, params.closeButtonHtml); // Custom class
	
	    applyCustomClass(closeButton, params, 'closeButton');
	    toggle(closeButton, params.showCloseButton);
	    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
	  };
	
	  var renderIcon = function renderIcon(instance, params) {
	    var innerParams = privateProps.innerParams.get(instance); // if the given icon already rendered, apply the styling without re-rendering the icon
	
	    if (innerParams && params.icon === innerParams.icon && getIcon()) {
	      applyStyles(getIcon(), params);
	      return;
	    }
	
	    hideAllIcons();
	
	    if (!params.icon) {
	      return;
	    }
	
	    if (Object.keys(iconTypes).indexOf(params.icon) !== -1) {
	      var icon = elementBySelector(".".concat(swalClasses.icon, ".").concat(iconTypes[params.icon]));
	      show(icon); // Custom or default content
	
	      setContent(icon, params);
	      applyStyles(icon, params); // Animate icon
	
	      addClass(icon, params.showClass.icon);
	    } else {
	      error("Unknown icon! Expected \"success\", \"error\", \"warning\", \"info\" or \"question\", got \"".concat(params.icon, "\""));
	    }
	  };
	
	  var hideAllIcons = function hideAllIcons() {
	    var icons = getIcons();
	
	    for (var i = 0; i < icons.length; i++) {
	      hide(icons[i]);
	    }
	  };
	
	  var applyStyles = function applyStyles(icon, params) {
	    // Icon color
	    setColor(icon, params); // Success icon background color
	
	    adjustSuccessIconBackgoundColor(); // Custom class
	
	    applyCustomClass(icon, params, 'icon');
	  }; // Adjust success icon background color to match the popup background color
	
	
	  var adjustSuccessIconBackgoundColor = function adjustSuccessIconBackgoundColor() {
	    var popup = getPopup();
	    var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
	    var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
	
	    for (var i = 0; i < successIconParts.length; i++) {
	      successIconParts[i].style.backgroundColor = popupBackgroundColor;
	    }
	  };
	
	  var setContent = function setContent(icon, params) {
	    icon.textContent = '';
	
	    if (params.iconHtml) {
	      setInnerHtml(icon, iconContent(params.iconHtml));
	    } else if (params.icon === 'success') {
	      setInnerHtml(icon, "\n      <div class=\"swal2-success-circular-line-left\"></div>\n      <span class=\"swal2-success-line-tip\"></span> <span class=\"swal2-success-line-long\"></span>\n      <div class=\"swal2-success-ring\"></div> <div class=\"swal2-success-fix\"></div>\n      <div class=\"swal2-success-circular-line-right\"></div>\n    ");
	    } else if (params.icon === 'error') {
	      setInnerHtml(icon, "\n      <span class=\"swal2-x-mark\">\n        <span class=\"swal2-x-mark-line-left\"></span>\n        <span class=\"swal2-x-mark-line-right\"></span>\n      </span>\n    ");
	    } else {
	      var defaultIconHtml = {
	        question: '?',
	        warning: '!',
	        info: 'i'
	      };
	      setInnerHtml(icon, iconContent(defaultIconHtml[params.icon]));
	    }
	  };
	
	  var setColor = function setColor(icon, params) {
	    if (!params.iconColor) {
	      return;
	    }
	
	    icon.style.color = params.iconColor;
	    icon.style.borderColor = params.iconColor;
	
	    for (var _i = 0, _arr = ['.swal2-success-line-tip', '.swal2-success-line-long', '.swal2-x-mark-line-left', '.swal2-x-mark-line-right']; _i < _arr.length; _i++) {
	      var sel = _arr[_i];
	      setStyle(icon, sel, 'backgroundColor', params.iconColor);
	    }
	
	    setStyle(icon, '.swal2-success-ring', 'borderColor', params.iconColor);
	  };
	
	  var iconContent = function iconContent(content) {
	    return "<div class=\"".concat(swalClasses['icon-content'], "\">").concat(content, "</div>");
	  };
	
	  var renderImage = function renderImage(instance, params) {
	    var image = getImage();
	
	    if (!params.imageUrl) {
	      return hide(image);
	    }
	
	    show(image, ''); // Src, alt
	
	    image.setAttribute('src', params.imageUrl);
	    image.setAttribute('alt', params.imageAlt); // Width, height
	
	    applyNumericalStyle(image, 'width', params.imageWidth);
	    applyNumericalStyle(image, 'height', params.imageHeight); // Class
	
	    image.className = swalClasses.image;
	    applyCustomClass(image, params, 'image');
	  };
	
	  var currentSteps = [];
	  /*
	   * Global function for chaining sweetAlert popups
	   */
	
	  var queue = function queue(steps) {
	    var Swal = this;
	    currentSteps = steps;
	
	    var resetAndResolve = function resetAndResolve(resolve, value) {
	      currentSteps = [];
	      resolve(value);
	    };
	
	    var queueResult = [];
	    return new Promise(function (resolve) {
	      (function step(i, callback) {
	        if (i < currentSteps.length) {
	          document.body.setAttribute('data-swal2-queue-step', i);
	          Swal.fire(currentSteps[i]).then(function (result) {
	            if (typeof result.value !== 'undefined') {
	              queueResult.push(result.value);
	              step(i + 1, callback);
	            } else {
	              resetAndResolve(resolve, {
	                dismiss: result.dismiss
	              });
	            }
	          });
	        } else {
	          resetAndResolve(resolve, {
	            value: queueResult
	          });
	        }
	      })(0);
	    });
	  };
	  /*
	   * Global function for getting the index of current popup in queue
	   */
	
	  var getQueueStep = function getQueueStep() {
	    return getContainer() && getContainer().getAttribute('data-queue-step');
	  };
	  /*
	   * Global function for inserting a popup to the queue
	   */
	
	  var insertQueueStep = function insertQueueStep(step, index) {
	    if (index && index < currentSteps.length) {
	      return currentSteps.splice(index, 0, step);
	    }
	
	    return currentSteps.push(step);
	  };
	  /*
	   * Global function for deleting a popup from the queue
	   */
	
	  var deleteQueueStep = function deleteQueueStep(index) {
	    if (typeof currentSteps[index] !== 'undefined') {
	      currentSteps.splice(index, 1);
	    }
	  };
	
	  var createStepElement = function createStepElement(step) {
	    var stepEl = document.createElement('li');
	    addClass(stepEl, swalClasses['progress-step']);
	    setInnerHtml(stepEl, step);
	    return stepEl;
	  };
	
	  var createLineElement = function createLineElement(params) {
	    var lineEl = document.createElement('li');
	    addClass(lineEl, swalClasses['progress-step-line']);
	
	    if (params.progressStepsDistance) {
	      lineEl.style.width = params.progressStepsDistance;
	    }
	
	    return lineEl;
	  };
	
	  var renderProgressSteps = function renderProgressSteps(instance, params) {
	    var progressStepsContainer = getProgressSteps();
	
	    if (!params.progressSteps || params.progressSteps.length === 0) {
	      return hide(progressStepsContainer);
	    }
	
	    show(progressStepsContainer);
	    progressStepsContainer.textContent = '';
	    var currentProgressStep = parseInt(params.currentProgressStep === undefined ? getQueueStep() : params.currentProgressStep);
	
	    if (currentProgressStep >= params.progressSteps.length) {
	      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
	    }
	
	    params.progressSteps.forEach(function (step, index) {
	      var stepEl = createStepElement(step);
	      progressStepsContainer.appendChild(stepEl);
	
	      if (index === currentProgressStep) {
	        addClass(stepEl, swalClasses['active-progress-step']);
	      }
	
	      if (index !== params.progressSteps.length - 1) {
	        var lineEl = createLineElement(params);
	        progressStepsContainer.appendChild(lineEl);
	      }
	    });
	  };
	
	  var renderTitle = function renderTitle(instance, params) {
	    var title = getTitle();
	    toggle(title, params.title || params.titleText);
	
	    if (params.title) {
	      parseHtmlToContainer(params.title, title);
	    }
	
	    if (params.titleText) {
	      title.innerText = params.titleText;
	    } // Custom class
	
	
	    applyCustomClass(title, params, 'title');
	  };
	
	  var renderHeader = function renderHeader(instance, params) {
	    var header = getHeader(); // Custom class
	
	    applyCustomClass(header, params, 'header'); // Progress steps
	
	    renderProgressSteps(instance, params); // Icon
	
	    renderIcon(instance, params); // Image
	
	    renderImage(instance, params); // Title
	
	    renderTitle(instance, params); // Close button
	
	    renderCloseButton(instance, params);
	  };
	
	  var renderPopup = function renderPopup(instance, params) {
	    var popup = getPopup(); // Width
	
	    applyNumericalStyle(popup, 'width', params.width); // Padding
	
	    applyNumericalStyle(popup, 'padding', params.padding); // Background
	
	    if (params.background) {
	      popup.style.background = params.background;
	    } // Classes
	
	
	    addClasses(popup, params);
	  };
	
	  var addClasses = function addClasses(popup, params) {
	    // Default Class + showClass when updating Swal.update({})
	    popup.className = "".concat(swalClasses.popup, " ").concat(isVisible(popup) ? params.showClass.popup : '');
	
	    if (params.toast) {
	      addClass([document.documentElement, document.body], swalClasses['toast-shown']);
	      addClass(popup, swalClasses.toast);
	    } else {
	      addClass(popup, swalClasses.modal);
	    } // Custom class
	
	
	    applyCustomClass(popup, params, 'popup');
	
	    if (typeof params.customClass === 'string') {
	      addClass(popup, params.customClass);
	    } // Icon class (#1842)
	
	
	    if (params.icon) {
	      addClass(popup, swalClasses["icon-".concat(params.icon)]);
	    }
	  };
	
	  var render = function render(instance, params) {
	    renderPopup(instance, params);
	    renderContainer(instance, params);
	    renderHeader(instance, params);
	    renderContent(instance, params);
	    renderActions(instance, params);
	    renderFooter(instance, params);
	
	    if (typeof params.didRender === 'function') {
	      params.didRender(getPopup());
	    } else if (typeof params.onRender === 'function') {
	      params.onRender(getPopup()); // @deprecated
	    }
	  };
	
	  /*
	   * Global function to determine if SweetAlert2 popup is shown
	   */
	
	  var isVisible$1 = function isVisible$$1() {
	    return isVisible(getPopup());
	  };
	  /*
	   * Global function to click 'Confirm' button
	   */
	
	  var clickConfirm = function clickConfirm() {
	    return getConfirmButton() && getConfirmButton().click();
	  };
	  /*
	   * Global function to click 'Deny' button
	   */
	
	  var clickDeny = function clickDeny() {
	    return getDenyButton() && getDenyButton().click();
	  };
	  /*
	   * Global function to click 'Cancel' button
	   */
	
	  var clickCancel = function clickCancel() {
	    return getCancelButton() && getCancelButton().click();
	  };
	
	  function fire() {
	    var Swal = this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _construct(Swal, args);
	  }
	
	  /**
	   * Returns an extended version of `Swal` containing `params` as defaults.
	   * Useful for reusing Swal configuration.
	   *
	   * For example:
	   *
	   * Before:
	   * const textPromptOptions = { input: 'text', showCancelButton: true }
	   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
	   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
	   *
	   * After:
	   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
	   * const {value: firstName} = await TextPrompt('What is your first name?')
	   * const {value: lastName} = await TextPrompt('What is your last name?')
	   *
	   * @param mixinParams
	   */
	  function mixin(mixinParams) {
	    var MixinSwal = /*#__PURE__*/function (_this) {
	      _inherits(MixinSwal, _this);
	
	      var _super = _createSuper(MixinSwal);
	
	      function MixinSwal() {
	        _classCallCheck(this, MixinSwal);
	
	        return _super.apply(this, arguments);
	      }
	
	      _createClass(MixinSwal, [{
	        key: "_main",
	        value: function _main(params, prevMixinParams) {
	          return _get(_getPrototypeOf(MixinSwal.prototype), "_main", this).call(this, params, _extends({}, prevMixinParams, mixinParams));
	        }
	      }]);
	
	      return MixinSwal;
	    }(this);
	
	    return MixinSwal;
	  }
	
	  /**
	   * Shows loader (spinner), this is useful with AJAX requests.
	   * By default the loader be shown instead of the "Confirm" button.
	   */
	
	  var showLoading = function showLoading(buttonToReplace) {
	    var popup = getPopup();
	
	    if (!popup) {
	      Swal.fire();
	    }
	
	    popup = getPopup();
	    var actions = getActions();
	    var loader = getLoader();
	
	    if (!buttonToReplace && isVisible(getConfirmButton())) {
	      buttonToReplace = getConfirmButton();
	    }
	
	    show(actions);
	
	    if (buttonToReplace) {
	      hide(buttonToReplace);
	      loader.setAttribute('data-button-to-replace', buttonToReplace.className);
	    }
	
	    loader.parentNode.insertBefore(loader, buttonToReplace);
	    addClass([popup, actions], swalClasses.loading);
	    show(loader);
	    popup.setAttribute('data-loading', true);
	    popup.setAttribute('aria-busy', true);
	    popup.focus();
	  };
	
	  var RESTORE_FOCUS_TIMEOUT = 100;
	
	  var globalState = {};
	
	  var focusPreviousActiveElement = function focusPreviousActiveElement() {
	    if (globalState.previousActiveElement && globalState.previousActiveElement.focus) {
	      globalState.previousActiveElement.focus();
	      globalState.previousActiveElement = null;
	    } else if (document.body) {
	      document.body.focus();
	    }
	  }; // Restore previous active (focused) element
	
	
	  var restoreActiveElement = function restoreActiveElement() {
	    return new Promise(function (resolve) {
	      var x = window.scrollX;
	      var y = window.scrollY;
	      globalState.restoreFocusTimeout = setTimeout(function () {
	        focusPreviousActiveElement();
	        resolve();
	      }, RESTORE_FOCUS_TIMEOUT); // issues/900
	
	      /* istanbul ignore if */
	
	      if (typeof x !== 'undefined' && typeof y !== 'undefined') {
	        // IE doesn't have scrollX/scrollY support
	        window.scrollTo(x, y);
	      }
	    });
	  };
	
	  /**
	   * If `timer` parameter is set, returns number of milliseconds of timer remained.
	   * Otherwise, returns undefined.
	   */
	
	  var getTimerLeft = function getTimerLeft() {
	    return globalState.timeout && globalState.timeout.getTimerLeft();
	  };
	  /**
	   * Stop timer. Returns number of milliseconds of timer remained.
	   * If `timer` parameter isn't set, returns undefined.
	   */
	
	  var stopTimer = function stopTimer() {
	    if (globalState.timeout) {
	      stopTimerProgressBar();
	      return globalState.timeout.stop();
	    }
	  };
	  /**
	   * Resume timer. Returns number of milliseconds of timer remained.
	   * If `timer` parameter isn't set, returns undefined.
	   */
	
	  var resumeTimer = function resumeTimer() {
	    if (globalState.timeout) {
	      var remaining = globalState.timeout.start();
	      animateTimerProgressBar(remaining);
	      return remaining;
	    }
	  };
	  /**
	   * Resume timer. Returns number of milliseconds of timer remained.
	   * If `timer` parameter isn't set, returns undefined.
	   */
	
	  var toggleTimer = function toggleTimer() {
	    var timer = globalState.timeout;
	    return timer && (timer.running ? stopTimer() : resumeTimer());
	  };
	  /**
	   * Increase timer. Returns number of milliseconds of an updated timer.
	   * If `timer` parameter isn't set, returns undefined.
	   */
	
	  var increaseTimer = function increaseTimer(n) {
	    if (globalState.timeout) {
	      var remaining = globalState.timeout.increase(n);
	      animateTimerProgressBar(remaining, true);
	      return remaining;
	    }
	  };
	  /**
	   * Check if timer is running. Returns true if timer is running
	   * or false if timer is paused or stopped.
	   * If `timer` parameter isn't set, returns undefined
	   */
	
	  var isTimerRunning = function isTimerRunning() {
	    return globalState.timeout && globalState.timeout.isRunning();
	  };
	
	  var bodyClickListenerAdded = false;
	  var clickHandlers = {};
	  function bindClickHandler() {
	    var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
	    clickHandlers[attr] = this;
	
	    if (!bodyClickListenerAdded) {
	      document.body.addEventListener('click', bodyClickListener);
	      bodyClickListenerAdded = true;
	    }
	  }
	
	  var bodyClickListener = function bodyClickListener(event) {
	    // 1. using .parentNode instead of event.path because of better support by old browsers https://stackoverflow.com/a/39245638
	    // 2. using .parentNode instead of .parentElement because of IE11 + SVG https://stackoverflow.com/a/36270354
	    for (var el = event.target; el && el !== document; el = el.parentNode) {
	      for (var attr in clickHandlers) {
	        var template = el.getAttribute(attr);
	
	        if (template) {
	          clickHandlers[attr].fire({
	            template: template
	          });
	          return;
	        }
	      }
	    }
	  };
	
	  var defaultParams = {
	    title: '',
	    titleText: '',
	    text: '',
	    html: '',
	    footer: '',
	    icon: undefined,
	    iconColor: undefined,
	    iconHtml: undefined,
	    template: undefined,
	    toast: false,
	    animation: true,
	    showClass: {
	      popup: 'swal2-show',
	      backdrop: 'swal2-backdrop-show',
	      icon: 'swal2-icon-show'
	    },
	    hideClass: {
	      popup: 'swal2-hide',
	      backdrop: 'swal2-backdrop-hide',
	      icon: 'swal2-icon-hide'
	    },
	    customClass: {},
	    target: 'body',
	    backdrop: true,
	    heightAuto: true,
	    allowOutsideClick: true,
	    allowEscapeKey: true,
	    allowEnterKey: true,
	    stopKeydownPropagation: true,
	    keydownListenerCapture: false,
	    showConfirmButton: true,
	    showDenyButton: false,
	    showCancelButton: false,
	    preConfirm: undefined,
	    preDeny: undefined,
	    confirmButtonText: 'OK',
	    confirmButtonAriaLabel: '',
	    confirmButtonColor: undefined,
	    denyButtonText: 'No',
	    denyButtonAriaLabel: '',
	    denyButtonColor: undefined,
	    cancelButtonText: 'Cancel',
	    cancelButtonAriaLabel: '',
	    cancelButtonColor: undefined,
	    buttonsStyling: true,
	    reverseButtons: false,
	    focusConfirm: true,
	    focusDeny: false,
	    focusCancel: false,
	    showCloseButton: false,
	    closeButtonHtml: '&times;',
	    closeButtonAriaLabel: 'Close this dialog',
	    loaderHtml: '',
	    showLoaderOnConfirm: false,
	    imageUrl: undefined,
	    imageWidth: undefined,
	    imageHeight: undefined,
	    imageAlt: '',
	    timer: undefined,
	    timerProgressBar: false,
	    width: undefined,
	    padding: undefined,
	    background: undefined,
	    input: undefined,
	    inputPlaceholder: '',
	    inputLabel: '',
	    inputValue: '',
	    inputOptions: {},
	    inputAutoTrim: true,
	    inputAttributes: {},
	    inputValidator: undefined,
	    returnInputValueOnDeny: false,
	    validationMessage: undefined,
	    grow: false,
	    position: 'center',
	    progressSteps: [],
	    currentProgressStep: undefined,
	    progressStepsDistance: undefined,
	    onBeforeOpen: undefined,
	    onOpen: undefined,
	    willOpen: undefined,
	    didOpen: undefined,
	    onRender: undefined,
	    didRender: undefined,
	    onClose: undefined,
	    onAfterClose: undefined,
	    willClose: undefined,
	    didClose: undefined,
	    onDestroy: undefined,
	    didDestroy: undefined,
	    scrollbarPadding: true
	  };
	  var updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'background', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'denyButtonAriaLabel', 'denyButtonColor', 'denyButtonText', 'didClose', 'didDestroy', 'footer', 'hideClass', 'html', 'icon', 'iconColor', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'onAfterClose', 'onClose', 'onDestroy', 'progressSteps', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'showDenyButton', 'text', 'title', 'titleText', 'willClose'];
	  var deprecatedParams = {
	    animation: 'showClass" and "hideClass',
	    onBeforeOpen: 'willOpen',
	    onOpen: 'didOpen',
	    onRender: 'didRender',
	    onClose: 'willClose',
	    onAfterClose: 'didClose',
	    onDestroy: 'didDestroy'
	  };
	  var toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusDeny', 'focusCancel', 'heightAuto', 'keydownListenerCapture'];
	  /**
	   * Is valid parameter
	   * @param {String} paramName
	   */
	
	  var isValidParameter = function isValidParameter(paramName) {
	    return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
	  };
	  /**
	   * Is valid parameter for Swal.update() method
	   * @param {String} paramName
	   */
	
	  var isUpdatableParameter = function isUpdatableParameter(paramName) {
	    return updatableParams.indexOf(paramName) !== -1;
	  };
	  /**
	   * Is deprecated parameter
	   * @param {String} paramName
	   */
	
	  var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
	    return deprecatedParams[paramName];
	  };
	
	  var checkIfParamIsValid = function checkIfParamIsValid(param) {
	    if (!isValidParameter(param)) {
	      warn("Unknown parameter \"".concat(param, "\""));
	    }
	  };
	
	  var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
	    if (toastIncompatibleParams.indexOf(param) !== -1) {
	      warn("The parameter \"".concat(param, "\" is incompatible with toasts"));
	    }
	  };
	
	  var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
	    if (isDeprecatedParameter(param)) {
	      warnAboutDeprecation(param, isDeprecatedParameter(param));
	    }
	  };
	  /**
	   * Show relevant warnings for given params
	   *
	   * @param params
	   */
	
	
	  var showWarningsForParams = function showWarningsForParams(params) {
	    for (var param in params) {
	      checkIfParamIsValid(param);
	
	      if (params.toast) {
	        checkIfToastParamIsValid(param);
	      }
	
	      checkIfParamIsDeprecated(param);
	    }
	  };
	
	
	
	  var staticMethods = /*#__PURE__*/Object.freeze({
	    isValidParameter: isValidParameter,
	    isUpdatableParameter: isUpdatableParameter,
	    isDeprecatedParameter: isDeprecatedParameter,
	    argsToParams: argsToParams,
	    isVisible: isVisible$1,
	    clickConfirm: clickConfirm,
	    clickDeny: clickDeny,
	    clickCancel: clickCancel,
	    getContainer: getContainer,
	    getPopup: getPopup,
	    getTitle: getTitle,
	    getContent: getContent,
	    getHtmlContainer: getHtmlContainer,
	    getImage: getImage,
	    getIcon: getIcon,
	    getIcons: getIcons,
	    getInputLabel: getInputLabel,
	    getCloseButton: getCloseButton,
	    getActions: getActions,
	    getConfirmButton: getConfirmButton,
	    getDenyButton: getDenyButton,
	    getCancelButton: getCancelButton,
	    getLoader: getLoader,
	    getHeader: getHeader,
	    getFooter: getFooter,
	    getTimerProgressBar: getTimerProgressBar,
	    getFocusableElements: getFocusableElements,
	    getValidationMessage: getValidationMessage,
	    isLoading: isLoading,
	    fire: fire,
	    mixin: mixin,
	    queue: queue,
	    getQueueStep: getQueueStep,
	    insertQueueStep: insertQueueStep,
	    deleteQueueStep: deleteQueueStep,
	    showLoading: showLoading,
	    enableLoading: showLoading,
	    getTimerLeft: getTimerLeft,
	    stopTimer: stopTimer,
	    resumeTimer: resumeTimer,
	    toggleTimer: toggleTimer,
	    increaseTimer: increaseTimer,
	    isTimerRunning: isTimerRunning,
	    bindClickHandler: bindClickHandler
	  });
	
	  /**
	   * Hides loader and shows back the button which was hidden by .showLoading()
	   */
	
	  function hideLoading() {
	    // do nothing if popup is closed
	    var innerParams = privateProps.innerParams.get(this);
	
	    if (!innerParams) {
	      return;
	    }
	
	    var domCache = privateProps.domCache.get(this);
	    hide(domCache.loader);
	    var buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
	
	    if (buttonToReplace.length) {
	      show(buttonToReplace[0], 'inline-block');
	    } else if (allButtonsAreHidden()) {
	      hide(domCache.actions);
	    }
	
	    removeClass([domCache.popup, domCache.actions], swalClasses.loading);
	    domCache.popup.removeAttribute('aria-busy');
	    domCache.popup.removeAttribute('data-loading');
	    domCache.confirmButton.disabled = false;
	    domCache.denyButton.disabled = false;
	    domCache.cancelButton.disabled = false;
	  }
	
	  function getInput$1(instance) {
	    var innerParams = privateProps.innerParams.get(instance || this);
	    var domCache = privateProps.domCache.get(instance || this);
	
	    if (!domCache) {
	      return null;
	    }
	
	    return getInput(domCache.content, innerParams.input);
	  }
	
	  var fixScrollbar = function fixScrollbar() {
	    // for queues, do not do this more than once
	    if (states.previousBodyPadding !== null) {
	      return;
	    } // if the body has overflow
	
	
	    if (document.body.scrollHeight > window.innerHeight) {
	      // add padding so the content doesn't shift after removal of scrollbar
	      states.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
	      document.body.style.paddingRight = "".concat(states.previousBodyPadding + measureScrollbar(), "px");
	    }
	  };
	  var undoScrollbar = function undoScrollbar() {
	    if (states.previousBodyPadding !== null) {
	      document.body.style.paddingRight = "".concat(states.previousBodyPadding, "px");
	      states.previousBodyPadding = null;
	    }
	  };
	
	  /* istanbul ignore file */
	
	  var iOSfix = function iOSfix() {
	    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
	
	    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
	      var offset = document.body.scrollTop;
	      document.body.style.top = "".concat(offset * -1, "px");
	      addClass(document.body, swalClasses.iosfix);
	      lockBodyScroll();
	      addBottomPaddingForTallPopups(); // #1948
	    }
	  };
	
	  var addBottomPaddingForTallPopups = function addBottomPaddingForTallPopups() {
	    var safari = !navigator.userAgent.match(/(CriOS|FxiOS|EdgiOS|YaBrowser|UCBrowser)/i);
	
	    if (safari) {
	      var bottomPanelHeight = 44;
	
	      if (getPopup().scrollHeight > window.innerHeight - bottomPanelHeight) {
	        getContainer().style.paddingBottom = "".concat(bottomPanelHeight, "px");
	      }
	    }
	  };
	
	  var lockBodyScroll = function lockBodyScroll() {
	    // #1246
	    var container = getContainer();
	    var preventTouchMove;
	
	    container.ontouchstart = function (e) {
	      preventTouchMove = shouldPreventTouchMove(e);
	    };
	
	    container.ontouchmove = function (e) {
	      if (preventTouchMove) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    };
	  };
	
	  var shouldPreventTouchMove = function shouldPreventTouchMove(event) {
	    var target = event.target;
	    var container = getContainer();
	
	    if (isStylys(event) || isZoom(event)) {
	      return false;
	    }
	
	    if (target === container) {
	      return true;
	    }
	
	    if (!isScrollable(container) && target.tagName !== 'INPUT' && // #1603
	    !(isScrollable(getContent()) && // #1944
	    getContent().contains(target))) {
	      return true;
	    }
	
	    return false;
	  };
	
	  var isStylys = function isStylys(event) {
	    // #1786
	    return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
	  };
	
	  var isZoom = function isZoom(event) {
	    // #1891
	    return event.touches && event.touches.length > 1;
	  };
	
	  var undoIOSfix = function undoIOSfix() {
	    if (hasClass(document.body, swalClasses.iosfix)) {
	      var offset = parseInt(document.body.style.top, 10);
	      removeClass(document.body, swalClasses.iosfix);
	      document.body.style.top = '';
	      document.body.scrollTop = offset * -1;
	    }
	  };
	
	  /* istanbul ignore file */
	
	  var isIE11 = function isIE11() {
	    return !!window.MSInputMethodContext && !!document.documentMode;
	  }; // Fix IE11 centering sweetalert2/issues/933
	
	
	  var fixVerticalPositionIE = function fixVerticalPositionIE() {
	    var container = getContainer();
	    var popup = getPopup();
	    container.style.removeProperty('align-items');
	
	    if (popup.offsetTop < 0) {
	      container.style.alignItems = 'flex-start';
	    }
	  };
	
	  var IEfix = function IEfix() {
	    if (typeof window !== 'undefined' && isIE11()) {
	      fixVerticalPositionIE();
	      window.addEventListener('resize', fixVerticalPositionIE);
	    }
	  };
	  var undoIEfix = function undoIEfix() {
	    if (typeof window !== 'undefined' && isIE11()) {
	      window.removeEventListener('resize', fixVerticalPositionIE);
	    }
	  };
	
	  // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
	  // elements not within the active modal dialog will not be surfaced if a user opens a screen
	  // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
	
	  var setAriaHidden = function setAriaHidden() {
	    var bodyChildren = toArray(document.body.children);
	    bodyChildren.forEach(function (el) {
	      if (el === getContainer() || contains(el, getContainer())) {
	        return;
	      }
	
	      if (el.hasAttribute('aria-hidden')) {
	        el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden'));
	      }
	
	      el.setAttribute('aria-hidden', 'true');
	    });
	  };
	  var unsetAriaHidden = function unsetAriaHidden() {
	    var bodyChildren = toArray(document.body.children);
	    bodyChildren.forEach(function (el) {
	      if (el.hasAttribute('data-previous-aria-hidden')) {
	        el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden'));
	        el.removeAttribute('data-previous-aria-hidden');
	      } else {
	        el.removeAttribute('aria-hidden');
	      }
	    });
	  };
	
	  /**
	   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
	   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
	   * This is the approach that Babel will probably take to implement private methods/fields
	   *   https://github.com/tc39/proposal-private-methods
	   *   https://github.com/babel/babel/pull/7555
	   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
	   *   then we can use that language feature.
	   */
	  var privateMethods = {
	    swalPromiseResolve: new WeakMap()
	  };
	
	  /*
	   * Instance method to close sweetAlert
	   */
	
	  function removePopupAndResetState(instance, container, isToast$$1, didClose) {
	    if (isToast$$1) {
	      triggerDidCloseAndDispose(instance, didClose);
	    } else {
	      restoreActiveElement().then(function () {
	        return triggerDidCloseAndDispose(instance, didClose);
	      });
	      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
	        capture: globalState.keydownListenerCapture
	      });
	      globalState.keydownHandlerAdded = false;
	    }
	
	    if (container.parentNode && !document.body.getAttribute('data-swal2-queue-step')) {
	      container.parentNode.removeChild(container);
	    }
	
	    if (isModal()) {
	      undoScrollbar();
	      undoIOSfix();
	      undoIEfix();
	      unsetAriaHidden();
	    }
	
	    removeBodyClasses();
	  }
	
	  function removeBodyClasses() {
	    removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['toast-column']]);
	  }
	
	  function close(resolveValue) {
	    var popup = getPopup();
	
	    if (!popup) {
	      return;
	    }
	
	    resolveValue = prepareResolveValue(resolveValue);
	    var innerParams = privateProps.innerParams.get(this);
	
	    if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
	      return;
	    }
	
	    var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
	    removeClass(popup, innerParams.showClass.popup);
	    addClass(popup, innerParams.hideClass.popup);
	    var backdrop = getContainer();
	    removeClass(backdrop, innerParams.showClass.backdrop);
	    addClass(backdrop, innerParams.hideClass.backdrop);
	    handlePopupAnimation(this, popup, innerParams); // Resolve Swal promise
	
	    swalPromiseResolve(resolveValue);
	  }
	
	  var prepareResolveValue = function prepareResolveValue(resolveValue) {
	    // When user calls Swal.close()
	    if (typeof resolveValue === 'undefined') {
	      return {
	        isConfirmed: false,
	        isDenied: false,
	        isDismissed: true
	      };
	    }
	
	    return _extends({
	      isConfirmed: false,
	      isDenied: false,
	      isDismissed: false
	    }, resolveValue);
	  };
	
	  var handlePopupAnimation = function handlePopupAnimation(instance, popup, innerParams) {
	    var container = getContainer(); // If animation is supported, animate
	
	    var animationIsSupported = animationEndEvent && hasCssAnimation(popup);
	    var onClose = innerParams.onClose,
	        onAfterClose = innerParams.onAfterClose,
	        willClose = innerParams.willClose,
	        didClose = innerParams.didClose;
	    runDidClose(popup, willClose, onClose);
	
	    if (animationIsSupported) {
	      animatePopup(instance, popup, container, didClose || onAfterClose);
	    } else {
	      // Otherwise, remove immediately
	      removePopupAndResetState(instance, container, isToast(), didClose || onAfterClose);
	    }
	  };
	
	  var runDidClose = function runDidClose(popup, willClose, onClose) {
	    if (willClose !== null && typeof willClose === 'function') {
	      willClose(popup);
	    } else if (onClose !== null && typeof onClose === 'function') {
	      onClose(popup); // @deprecated
	    }
	  };
	
	  var animatePopup = function animatePopup(instance, popup, container, didClose) {
	    globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, isToast(), didClose);
	    popup.addEventListener(animationEndEvent, function (e) {
	      if (e.target === popup) {
	        globalState.swalCloseEventFinishedCallback();
	        delete globalState.swalCloseEventFinishedCallback;
	      }
	    });
	  };
	
	  var triggerDidCloseAndDispose = function triggerDidCloseAndDispose(instance, didClose) {
	    setTimeout(function () {
	      if (typeof didClose === 'function') {
	        didClose();
	      }
	
	      instance._destroy();
	    });
	  };
	
	  function setButtonsDisabled(instance, buttons, disabled) {
	    var domCache = privateProps.domCache.get(instance);
	    buttons.forEach(function (button) {
	      domCache[button].disabled = disabled;
	    });
	  }
	
	  function setInputDisabled(input, disabled) {
	    if (!input) {
	      return false;
	    }
	
	    if (input.type === 'radio') {
	      var radiosContainer = input.parentNode.parentNode;
	      var radios = radiosContainer.querySelectorAll('input');
	
	      for (var i = 0; i < radios.length; i++) {
	        radios[i].disabled = disabled;
	      }
	    } else {
	      input.disabled = disabled;
	    }
	  }
	
	  function enableButtons() {
	    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], false);
	  }
	  function disableButtons() {
	    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], true);
	  }
	  function enableInput() {
	    return setInputDisabled(this.getInput(), false);
	  }
	  function disableInput() {
	    return setInputDisabled(this.getInput(), true);
	  }
	
	  function showValidationMessage(error) {
	    var domCache = privateProps.domCache.get(this);
	    var params = privateProps.innerParams.get(this);
	    setInnerHtml(domCache.validationMessage, error);
	    domCache.validationMessage.className = swalClasses['validation-message'];
	
	    if (params.customClass && params.customClass.validationMessage) {
	      addClass(domCache.validationMessage, params.customClass.validationMessage);
	    }
	
	    show(domCache.validationMessage);
	    var input = this.getInput();
	
	    if (input) {
	      input.setAttribute('aria-invalid', true);
	      input.setAttribute('aria-describedBy', swalClasses['validation-message']);
	      focusInput(input);
	      addClass(input, swalClasses.inputerror);
	    }
	  } // Hide block with validation message
	
	  function resetValidationMessage$1() {
	    var domCache = privateProps.domCache.get(this);
	
	    if (domCache.validationMessage) {
	      hide(domCache.validationMessage);
	    }
	
	    var input = this.getInput();
	
	    if (input) {
	      input.removeAttribute('aria-invalid');
	      input.removeAttribute('aria-describedBy');
	      removeClass(input, swalClasses.inputerror);
	    }
	  }
	
	  function getProgressSteps$1() {
	    var domCache = privateProps.domCache.get(this);
	    return domCache.progressSteps;
	  }
	
	  var Timer = /*#__PURE__*/function () {
	    function Timer(callback, delay) {
	      _classCallCheck(this, Timer);
	
	      this.callback = callback;
	      this.remaining = delay;
	      this.running = false;
	      this.start();
	    }
	
	    _createClass(Timer, [{
	      key: "start",
	      value: function start() {
	        if (!this.running) {
	          this.running = true;
	          this.started = new Date();
	          this.id = setTimeout(this.callback, this.remaining);
	        }
	
	        return this.remaining;
	      }
	    }, {
	      key: "stop",
	      value: function stop() {
	        if (this.running) {
	          this.running = false;
	          clearTimeout(this.id);
	          this.remaining -= new Date() - this.started;
	        }
	
	        return this.remaining;
	      }
	    }, {
	      key: "increase",
	      value: function increase(n) {
	        var running = this.running;
	
	        if (running) {
	          this.stop();
	        }
	
	        this.remaining += n;
	
	        if (running) {
	          this.start();
	        }
	
	        return this.remaining;
	      }
	    }, {
	      key: "getTimerLeft",
	      value: function getTimerLeft() {
	        if (this.running) {
	          this.stop();
	          this.start();
	        }
	
	        return this.remaining;
	      }
	    }, {
	      key: "isRunning",
	      value: function isRunning() {
	        return this.running;
	      }
	    }]);
	
	    return Timer;
	  }();
	
	  var defaultInputValidators = {
	    email: function email(string, validationMessage) {
	      return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
	    },
	    url: function url(string, validationMessage) {
	      // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
	      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
	    }
	  };
	
	  function setDefaultInputValidators(params) {
	    // Use default `inputValidator` for supported input types if not provided
	    if (!params.inputValidator) {
	      Object.keys(defaultInputValidators).forEach(function (key) {
	        if (params.input === key) {
	          params.inputValidator = defaultInputValidators[key];
	        }
	      });
	    }
	  }
	
	  function validateCustomTargetElement(params) {
	    // Determine if the custom target element is valid
	    if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
	      warn('Target parameter is not valid, defaulting to "body"');
	      params.target = 'body';
	    }
	  }
	  /**
	   * Set type, text and actions on popup
	   *
	   * @param params
	   * @returns {boolean}
	   */
	
	
	  function setParameters(params) {
	    setDefaultInputValidators(params); // showLoaderOnConfirm && preConfirm
	
	    if (params.showLoaderOnConfirm && !params.preConfirm) {
	      warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
	    } // params.animation will be actually used in renderPopup.js
	    // but in case when params.animation is a function, we need to call that function
	    // before popup (re)initialization, so it'll be possible to check Swal.isVisible()
	    // inside the params.animation function
	
	
	    params.animation = callIfFunction(params.animation);
	    validateCustomTargetElement(params); // Replace newlines with <br> in title
	
	    if (typeof params.title === 'string') {
	      params.title = params.title.split('\n').join('<br />');
	    }
	
	    init(params);
	  }
	
	  var swalStringParams = ['swal-title', 'swal-html', 'swal-footer'];
	  var getTemplateParams = function getTemplateParams(params) {
	    var template = typeof params.template === 'string' ? document.querySelector(params.template) : params.template;
	
	    if (!template) {
	      return {};
	    }
	
	    var templateContent = template.content || template; // IE11
	
	    showWarningsForElements(templateContent);
	
	    var result = _extends(getSwalParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
	
	    return result;
	  };
	
	  var getSwalParams = function getSwalParams(templateContent) {
	    var result = {};
	    toArray(templateContent.querySelectorAll('swal-param')).forEach(function (param) {
	      showWarningsForAttributes(param, ['name', 'value']);
	      var paramName = param.getAttribute('name');
	      var value = param.getAttribute('value');
	
	      if (typeof defaultParams[paramName] === 'boolean' && value === 'false') {
	        value = false;
	      }
	
	      if (_typeof(defaultParams[paramName]) === 'object') {
	        value = JSON.parse(value);
	      }
	
	      result[paramName] = value;
	    });
	    return result;
	  };
	
	  var getSwalButtons = function getSwalButtons(templateContent) {
	    var result = {};
	    toArray(templateContent.querySelectorAll('swal-button')).forEach(function (button) {
	      showWarningsForAttributes(button, ['type', 'color', 'aria-label']);
	      var type = button.getAttribute('type');
	      result["".concat(type, "ButtonText")] = button.innerHTML;
	      result["show".concat(capitalizeFirstLetter(type), "Button")] = true;
	
	      if (button.hasAttribute('color')) {
	        result["".concat(type, "ButtonColor")] = button.getAttribute('color');
	      }
	
	      if (button.hasAttribute('aria-label')) {
	        result["".concat(type, "ButtonAriaLabel")] = button.getAttribute('aria-label');
	      }
	    });
	    return result;
	  };
	
	  var getSwalImage = function getSwalImage(templateContent) {
	    var result = {};
	    var image = templateContent.querySelector('swal-image');
	
	    if (image) {
	      showWarningsForAttributes(image, ['src', 'width', 'height', 'alt']);
	
	      if (image.hasAttribute('src')) {
	        result.imageUrl = image.getAttribute('src');
	      }
	
	      if (image.hasAttribute('width')) {
	        result.imageWidth = image.getAttribute('width');
	      }
	
	      if (image.hasAttribute('height')) {
	        result.imageHeight = image.getAttribute('height');
	      }
	
	      if (image.hasAttribute('alt')) {
	        result.imageAlt = image.getAttribute('alt');
	      }
	    }
	
	    return result;
	  };
	
	  var getSwalIcon = function getSwalIcon(templateContent) {
	    var result = {};
	    var icon = templateContent.querySelector('swal-icon');
	
	    if (icon) {
	      showWarningsForAttributes(icon, ['type', 'color']);
	
	      if (icon.hasAttribute('type')) {
	        result.icon = icon.getAttribute('type');
	      }
	
	      if (icon.hasAttribute('color')) {
	        result.iconColor = icon.getAttribute('color');
	      }
	
	      result.iconHtml = icon.innerHTML;
	    }
	
	    return result;
	  };
	
	  var getSwalInput = function getSwalInput(templateContent) {
	    var result = {};
	    var input = templateContent.querySelector('swal-input');
	
	    if (input) {
	      showWarningsForAttributes(input, ['type', 'label', 'placeholder', 'value']);
	      result.input = input.getAttribute('type') || 'text';
	
	      if (input.hasAttribute('label')) {
	        result.inputLabel = input.getAttribute('label');
	      }
	
	      if (input.hasAttribute('placeholder')) {
	        result.inputPlaceholder = input.getAttribute('placeholder');
	      }
	
	      if (input.hasAttribute('value')) {
	        result.inputValue = input.getAttribute('value');
	      }
	    }
	
	    var inputOptions = templateContent.querySelectorAll('swal-input-option');
	
	    if (inputOptions.length) {
	      result.inputOptions = {};
	      toArray(inputOptions).forEach(function (option) {
	        showWarningsForAttributes(option, ['value']);
	        var optionValue = option.getAttribute('value');
	        var optionName = option.innerHTML;
	        result.inputOptions[optionValue] = optionName;
	      });
	    }
	
	    return result;
	  };
	
	  var getSwalStringParams = function getSwalStringParams(templateContent, paramNames) {
	    var result = {};
	
	    for (var i in paramNames) {
	      var paramName = paramNames[i];
	      var tag = templateContent.querySelector(paramName);
	
	      if (tag) {
	        showWarningsForAttributes(tag, []);
	        result[paramName.replace(/^swal-/, '')] = tag.innerHTML;
	      }
	    }
	
	    return result;
	  };
	
	  var showWarningsForElements = function showWarningsForElements(template) {
	    var allowedElements = swalStringParams.concat(['swal-param', 'swal-button', 'swal-image', 'swal-icon', 'swal-input', 'swal-input-option']);
	    toArray(template.children).forEach(function (el) {
	      var tagName = el.tagName.toLowerCase();
	
	      if (allowedElements.indexOf(tagName) === -1) {
	        warn("Unrecognized element <".concat(tagName, ">"));
	      }
	    });
	  };
	
	  var showWarningsForAttributes = function showWarningsForAttributes(el, allowedAttributes) {
	    toArray(el.attributes).forEach(function (attribute) {
	      if (allowedAttributes.indexOf(attribute.name) === -1) {
	        warn(["Unrecognized attribute \"".concat(attribute.name, "\" on <").concat(el.tagName.toLowerCase(), ">."), "".concat(allowedAttributes.length ? "Allowed attributes are: ".concat(allowedAttributes.join(', ')) : 'To set the value, use HTML within the element.')]);
	      }
	    });
	  };
	
	  var SHOW_CLASS_TIMEOUT = 10;
	  /**
	   * Open popup, add necessary classes and styles, fix scrollbar
	   *
	   * @param params
	   */
	
	  var openPopup = function openPopup(params) {
	    var container = getContainer();
	    var popup = getPopup();
	
	    if (typeof params.willOpen === 'function') {
	      params.willOpen(popup);
	    } else if (typeof params.onBeforeOpen === 'function') {
	      params.onBeforeOpen(popup); // @deprecated
	    }
	
	    var bodyStyles = window.getComputedStyle(document.body);
	    var initialBodyOverflow = bodyStyles.overflowY;
	    addClasses$1(container, popup, params); // scrolling is 'hidden' until animation is done, after that 'auto'
	
	    setTimeout(function () {
	      setScrollingVisibility(container, popup);
	    }, SHOW_CLASS_TIMEOUT);
	
	    if (isModal()) {
	      fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
	      setAriaHidden();
	    }
	
	    if (!isToast() && !globalState.previousActiveElement) {
	      globalState.previousActiveElement = document.activeElement;
	    }
	
	    runDidOpen(popup, params);
	    removeClass(container, swalClasses['no-transition']);
	  };
	
	  var runDidOpen = function runDidOpen(popup, params) {
	    if (typeof params.didOpen === 'function') {
	      setTimeout(function () {
	        return params.didOpen(popup);
	      });
	    } else if (typeof params.onOpen === 'function') {
	      setTimeout(function () {
	        return params.onOpen(popup);
	      }); // @deprecated
	    }
	  };
	
	  var swalOpenAnimationFinished = function swalOpenAnimationFinished(event) {
	    var popup = getPopup();
	
	    if (event.target !== popup) {
	      return;
	    }
	
	    var container = getContainer();
	    popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
	    container.style.overflowY = 'auto';
	  };
	
	  var setScrollingVisibility = function setScrollingVisibility(container, popup) {
	    if (animationEndEvent && hasCssAnimation(popup)) {
	      container.style.overflowY = 'hidden';
	      popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
	    } else {
	      container.style.overflowY = 'auto';
	    }
	  };
	
	  var fixScrollContainer = function fixScrollContainer(container, scrollbarPadding, initialBodyOverflow) {
	    iOSfix();
	    IEfix();
	
	    if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
	      fixScrollbar();
	    } // sweetalert2/issues/1247
	
	
	    setTimeout(function () {
	      container.scrollTop = 0;
	    });
	  };
	
	  var addClasses$1 = function addClasses(container, popup, params) {
	    addClass(container, params.showClass.backdrop); // the workaround with setting/unsetting opacity is needed for #2019 and 2059
	
	    popup.style.setProperty('opacity', '0', 'important');
	    show(popup);
	    setTimeout(function () {
	      // Animate popup right after showing it
	      addClass(popup, params.showClass.popup); // and remove the opacity workaround
	
	      popup.style.removeProperty('opacity');
	    }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
	
	    addClass([document.documentElement, document.body], swalClasses.shown);
	
	    if (params.heightAuto && params.backdrop && !params.toast) {
	      addClass([document.documentElement, document.body], swalClasses['height-auto']);
	    }
	  };
	
	  var handleInputOptionsAndValue = function handleInputOptionsAndValue(instance, params) {
	    if (params.input === 'select' || params.input === 'radio') {
	      handleInputOptions(instance, params);
	    } else if (['text', 'email', 'number', 'tel', 'textarea'].indexOf(params.input) !== -1 && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
	      handleInputValue(instance, params);
	    }
	  };
	  var getInputValue = function getInputValue(instance, innerParams) {
	    var input = instance.getInput();
	
	    if (!input) {
	      return null;
	    }
	
	    switch (innerParams.input) {
	      case 'checkbox':
	        return getCheckboxValue(input);
	
	      case 'radio':
	        return getRadioValue(input);
	
	      case 'file':
	        return getFileValue(input);
	
	      default:
	        return innerParams.inputAutoTrim ? input.value.trim() : input.value;
	    }
	  };
	
	  var getCheckboxValue = function getCheckboxValue(input) {
	    return input.checked ? 1 : 0;
	  };
	
	  var getRadioValue = function getRadioValue(input) {
	    return input.checked ? input.value : null;
	  };
	
	  var getFileValue = function getFileValue(input) {
	    return input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
	  };
	
	  var handleInputOptions = function handleInputOptions(instance, params) {
	    var content = getContent();
	
	    var processInputOptions = function processInputOptions(inputOptions) {
	      return populateInputOptions[params.input](content, formatInputOptions(inputOptions), params);
	    };
	
	    if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
	      showLoading();
	      asPromise(params.inputOptions).then(function (inputOptions) {
	        instance.hideLoading();
	        processInputOptions(inputOptions);
	      });
	    } else if (_typeof(params.inputOptions) === 'object') {
	      processInputOptions(params.inputOptions);
	    } else {
	      error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(_typeof(params.inputOptions)));
	    }
	  };
	
	  var handleInputValue = function handleInputValue(instance, params) {
	    var input = instance.getInput();
	    hide(input);
	    asPromise(params.inputValue).then(function (inputValue) {
	      input.value = params.input === 'number' ? parseFloat(inputValue) || 0 : "".concat(inputValue);
	      show(input);
	      input.focus();
	      instance.hideLoading();
	    })["catch"](function (err) {
	      error("Error in inputValue promise: ".concat(err));
	      input.value = '';
	      show(input);
	      input.focus();
	      instance.hideLoading();
	    });
	  };
	
	  var populateInputOptions = {
	    select: function select(content, inputOptions, params) {
	      var select = getChildByClass(content, swalClasses.select);
	
	      var renderOption = function renderOption(parent, optionLabel, optionValue) {
	        var option = document.createElement('option');
	        option.value = optionValue;
	        setInnerHtml(option, optionLabel);
	        option.selected = isSelected(optionValue, params.inputValue);
	        parent.appendChild(option);
	      };
	
	      inputOptions.forEach(function (inputOption) {
	        var optionValue = inputOption[0];
	        var optionLabel = inputOption[1]; // <optgroup> spec:
	        // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
	        // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
	        // check whether this is a <optgroup>
	
	        if (Array.isArray(optionLabel)) {
	          // if it is an array, then it is an <optgroup>
	          var optgroup = document.createElement('optgroup');
	          optgroup.label = optionValue;
	          optgroup.disabled = false; // not configurable for now
	
	          select.appendChild(optgroup);
	          optionLabel.forEach(function (o) {
	            return renderOption(optgroup, o[1], o[0]);
	          });
	        } else {
	          // case of <option>
	          renderOption(select, optionLabel, optionValue);
	        }
	      });
	      select.focus();
	    },
	    radio: function radio(content, inputOptions, params) {
	      var radio = getChildByClass(content, swalClasses.radio);
	      inputOptions.forEach(function (inputOption) {
	        var radioValue = inputOption[0];
	        var radioLabel = inputOption[1];
	        var radioInput = document.createElement('input');
	        var radioLabelElement = document.createElement('label');
	        radioInput.type = 'radio';
	        radioInput.name = swalClasses.radio;
	        radioInput.value = radioValue;
	
	        if (isSelected(radioValue, params.inputValue)) {
	          radioInput.checked = true;
	        }
	
	        var label = document.createElement('span');
	        setInnerHtml(label, radioLabel);
	        label.className = swalClasses.label;
	        radioLabelElement.appendChild(radioInput);
	        radioLabelElement.appendChild(label);
	        radio.appendChild(radioLabelElement);
	      });
	      var radios = radio.querySelectorAll('input');
	
	      if (radios.length) {
	        radios[0].focus();
	      }
	    }
	  };
	  /**
	   * Converts `inputOptions` into an array of `[value, label]`s
	   * @param inputOptions
	   */
	
	  var formatInputOptions = function formatInputOptions(inputOptions) {
	    var result = [];
	
	    if (typeof Map !== 'undefined' && inputOptions instanceof Map) {
	      inputOptions.forEach(function (value, key) {
	        var valueFormatted = value;
	
	        if (_typeof(valueFormatted) === 'object') {
	          // case of <optgroup>
	          valueFormatted = formatInputOptions(valueFormatted);
	        }
	
	        result.push([key, valueFormatted]);
	      });
	    } else {
	      Object.keys(inputOptions).forEach(function (key) {
	        var valueFormatted = inputOptions[key];
	
	        if (_typeof(valueFormatted) === 'object') {
	          // case of <optgroup>
	          valueFormatted = formatInputOptions(valueFormatted);
	        }
	
	        result.push([key, valueFormatted]);
	      });
	    }
	
	    return result;
	  };
	
	  var isSelected = function isSelected(optionValue, inputValue) {
	    return inputValue && inputValue.toString() === optionValue.toString();
	  };
	
	  var handleConfirmButtonClick = function handleConfirmButtonClick(instance, innerParams) {
	    instance.disableButtons();
	
	    if (innerParams.input) {
	      handleConfirmOrDenyWithInput(instance, innerParams, 'confirm');
	    } else {
	      confirm(instance, innerParams, true);
	    }
	  };
	  var handleDenyButtonClick = function handleDenyButtonClick(instance, innerParams) {
	    instance.disableButtons();
	
	    if (innerParams.returnInputValueOnDeny) {
	      handleConfirmOrDenyWithInput(instance, innerParams, 'deny');
	    } else {
	      deny(instance, innerParams, false);
	    }
	  };
	  var handleCancelButtonClick = function handleCancelButtonClick(instance, dismissWith) {
	    instance.disableButtons();
	    dismissWith(DismissReason.cancel);
	  };
	
	  var handleConfirmOrDenyWithInput = function handleConfirmOrDenyWithInput(instance, innerParams, type
	  /* type is either 'confirm' or 'deny' */
	  ) {
	    var inputValue = getInputValue(instance, innerParams);
	
	    if (innerParams.inputValidator) {
	      handleInputValidator(instance, innerParams, inputValue);
	    } else if (!instance.getInput().checkValidity()) {
	      instance.enableButtons();
	      instance.showValidationMessage(innerParams.validationMessage);
	    } else if (type === 'deny') {
	      deny(instance, innerParams, inputValue);
	    } else {
	      confirm(instance, innerParams, inputValue);
	    }
	  };
	
	  var handleInputValidator = function handleInputValidator(instance, innerParams, inputValue) {
	    instance.disableInput();
	    var validationPromise = Promise.resolve().then(function () {
	      return asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage));
	    });
	    validationPromise.then(function (validationMessage) {
	      instance.enableButtons();
	      instance.enableInput();
	
	      if (validationMessage) {
	        instance.showValidationMessage(validationMessage);
	      } else {
	        confirm(instance, innerParams, inputValue);
	      }
	    });
	  };
	
	  var deny = function deny(instance, innerParams, value) {
	    if (innerParams.preDeny) {
	      var preDenyPromise = Promise.resolve().then(function () {
	        return asPromise(innerParams.preDeny(value, innerParams.validationMessage));
	      });
	      preDenyPromise.then(function (preDenyValue) {
	        if (preDenyValue === false) {
	          instance.hideLoading();
	        } else {
	          instance.closePopup({
	            isDenied: true,
	            value: typeof preDenyValue === 'undefined' ? value : preDenyValue
	          });
	        }
	      });
	    } else {
	      instance.closePopup({
	        isDenied: true,
	        value: value
	      });
	    }
	  };
	
	  var succeedWith = function succeedWith(instance, value) {
	    instance.closePopup({
	      isConfirmed: true,
	      value: value
	    });
	  };
	
	  var confirm = function confirm(instance, innerParams, value) {
	    if (innerParams.showLoaderOnConfirm) {
	      showLoading(); // TODO: make showLoading an *instance* method
	    }
	
	    if (innerParams.preConfirm) {
	      instance.resetValidationMessage();
	      var preConfirmPromise = Promise.resolve().then(function () {
	        return asPromise(innerParams.preConfirm(value, innerParams.validationMessage));
	      });
	      preConfirmPromise.then(function (preConfirmValue) {
	        if (isVisible(getValidationMessage()) || preConfirmValue === false) {
	          instance.hideLoading();
	        } else {
	          succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
	        }
	      });
	    } else {
	      succeedWith(instance, value);
	    }
	  };
	
	  var addKeydownHandler = function addKeydownHandler(instance, globalState, innerParams, dismissWith) {
	    if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
	      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
	        capture: globalState.keydownListenerCapture
	      });
	      globalState.keydownHandlerAdded = false;
	    }
	
	    if (!innerParams.toast) {
	      globalState.keydownHandler = function (e) {
	        return keydownHandler(instance, e, dismissWith);
	      };
	
	      globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
	      globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
	      globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
	        capture: globalState.keydownListenerCapture
	      });
	      globalState.keydownHandlerAdded = true;
	    }
	  }; // Focus handling
	
	  var setFocus = function setFocus(innerParams, index, increment) {
	    var focusableElements = getFocusableElements(); // search for visible elements and select the next possible match
	
	    if (focusableElements.length) {
	      index = index + increment; // rollover to first item
	
	      if (index === focusableElements.length) {
	        index = 0; // go to last item
	      } else if (index === -1) {
	        index = focusableElements.length - 1;
	      }
	
	      return focusableElements[index].focus();
	    } // no visible focusable elements, focus the popup
	
	
	    getPopup().focus();
	  };
	  var arrowKeysNextButton = ['ArrowRight', 'ArrowDown', 'Right', 'Down' // IE11
	  ];
	  var arrowKeysPreviousButton = ['ArrowLeft', 'ArrowUp', 'Left', 'Up' // IE11
	  ];
	  var escKeys = ['Escape', 'Esc' // IE11
	  ];
	
	  var keydownHandler = function keydownHandler(instance, e, dismissWith) {
	    var innerParams = privateProps.innerParams.get(instance);
	
	    if (innerParams.stopKeydownPropagation) {
	      e.stopPropagation();
	    } // ENTER
	
	
	    if (e.key === 'Enter') {
	      handleEnter(instance, e, innerParams); // TAB
	    } else if (e.key === 'Tab') {
	      handleTab(e, innerParams); // ARROWS - switch focus between buttons
	    } else if ([].concat(arrowKeysNextButton, arrowKeysPreviousButton).indexOf(e.key) !== -1) {
	      handleArrows(e.key); // ESC
	    } else if (escKeys.indexOf(e.key) !== -1) {
	      handleEsc(e, innerParams, dismissWith);
	    }
	  };
	
	  var handleEnter = function handleEnter(instance, e, innerParams) {
	    // #720 #721
	    if (e.isComposing) {
	      return;
	    }
	
	    if (e.target && instance.getInput() && e.target.outerHTML === instance.getInput().outerHTML) {
	      if (['textarea', 'file'].indexOf(innerParams.input) !== -1) {
	        return; // do not submit
	      }
	
	      clickConfirm();
	      e.preventDefault();
	    }
	  };
	
	  var handleTab = function handleTab(e, innerParams) {
	    var targetElement = e.target;
	    var focusableElements = getFocusableElements();
	    var btnIndex = -1;
	
	    for (var i = 0; i < focusableElements.length; i++) {
	      if (targetElement === focusableElements[i]) {
	        btnIndex = i;
	        break;
	      }
	    }
	
	    if (!e.shiftKey) {
	      // Cycle to the next button
	      setFocus(innerParams, btnIndex, 1);
	    } else {
	      // Cycle to the prev button
	      setFocus(innerParams, btnIndex, -1);
	    }
	
	    e.stopPropagation();
	    e.preventDefault();
	  };
	
	  var handleArrows = function handleArrows(key) {
	    var confirmButton = getConfirmButton();
	    var denyButton = getDenyButton();
	    var cancelButton = getCancelButton();
	
	    if (!([confirmButton, denyButton, cancelButton].indexOf(document.activeElement) !== -1)) {
	      return;
	    }
	
	    var sibling = arrowKeysNextButton.indexOf(key) !== -1 ? 'nextElementSibling' : 'previousElementSibling';
	    var buttonToFocus = document.activeElement[sibling];
	
	    if (buttonToFocus) {
	      buttonToFocus.focus();
	    }
	  };
	
	  var handleEsc = function handleEsc(e, innerParams, dismissWith) {
	    if (callIfFunction(innerParams.allowEscapeKey)) {
	      e.preventDefault();
	      dismissWith(DismissReason.esc);
	    }
	  };
	
	  var handlePopupClick = function handlePopupClick(instance, domCache, dismissWith) {
	    var innerParams = privateProps.innerParams.get(instance);
	
	    if (innerParams.toast) {
	      handleToastClick(instance, domCache, dismissWith);
	    } else {
	      // Ignore click events that had mousedown on the popup but mouseup on the container
	      // This can happen when the user drags a slider
	      handleModalMousedown(domCache); // Ignore click events that had mousedown on the container but mouseup on the popup
	
	      handleContainerMousedown(domCache);
	      handleModalClick(instance, domCache, dismissWith);
	    }
	  };
	
	  var handleToastClick = function handleToastClick(instance, domCache, dismissWith) {
	    // Closing toast by internal click
	    domCache.popup.onclick = function () {
	      var innerParams = privateProps.innerParams.get(instance);
	
	      if (innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton || innerParams.timer || innerParams.input) {
	        return;
	      }
	
	      dismissWith(DismissReason.close);
	    };
	  };
	
	  var ignoreOutsideClick = false;
	
	  var handleModalMousedown = function handleModalMousedown(domCache) {
	    domCache.popup.onmousedown = function () {
	      domCache.container.onmouseup = function (e) {
	        domCache.container.onmouseup = undefined; // We only check if the mouseup target is the container because usually it doesn't
	        // have any other direct children aside of the popup
	
	        if (e.target === domCache.container) {
	          ignoreOutsideClick = true;
	        }
	      };
	    };
	  };
	
	  var handleContainerMousedown = function handleContainerMousedown(domCache) {
	    domCache.container.onmousedown = function () {
	      domCache.popup.onmouseup = function (e) {
	        domCache.popup.onmouseup = undefined; // We also need to check if the mouseup target is a child of the popup
	
	        if (e.target === domCache.popup || domCache.popup.contains(e.target)) {
	          ignoreOutsideClick = true;
	        }
	      };
	    };
	  };
	
	  var handleModalClick = function handleModalClick(instance, domCache, dismissWith) {
	    domCache.container.onclick = function (e) {
	      var innerParams = privateProps.innerParams.get(instance);
	
	      if (ignoreOutsideClick) {
	        ignoreOutsideClick = false;
	        return;
	      }
	
	      if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
	        dismissWith(DismissReason.backdrop);
	      }
	    };
	  };
	
	  function _main(userParams) {
	    var mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    showWarningsForParams(_extends({}, mixinParams, userParams));
	
	    if (globalState.currentInstance) {
	      globalState.currentInstance._destroy();
	    }
	
	    globalState.currentInstance = this;
	    var innerParams = prepareParams(userParams, mixinParams);
	    setParameters(innerParams);
	    Object.freeze(innerParams); // clear the previous timer
	
	    if (globalState.timeout) {
	      globalState.timeout.stop();
	      delete globalState.timeout;
	    } // clear the restore focus timeout
	
	
	    clearTimeout(globalState.restoreFocusTimeout);
	    var domCache = populateDomCache(this);
	    render(this, innerParams);
	    privateProps.innerParams.set(this, innerParams);
	    return swalPromise(this, domCache, innerParams);
	  }
	
	  var prepareParams = function prepareParams(userParams, mixinParams) {
	    var templateParams = getTemplateParams(userParams);
	
	    var showClass = _extends({}, defaultParams.showClass, mixinParams.showClass, templateParams.showClass, userParams.showClass);
	
	    var hideClass = _extends({}, defaultParams.hideClass, mixinParams.hideClass, templateParams.hideClass, userParams.hideClass);
	
	    var params = _extends({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
	
	
	    params.showClass = showClass;
	    params.hideClass = hideClass; // @deprecated
	
	    if (userParams.animation === false) {
	      params.showClass = {
	        popup: 'swal2-noanimation',
	        backdrop: 'swal2-noanimation'
	      };
	      params.hideClass = {};
	    }
	
	    return params;
	  };
	
	  var swalPromise = function swalPromise(instance, domCache, innerParams) {
	    return new Promise(function (resolve) {
	      // functions to handle all closings/dismissals
	      var dismissWith = function dismissWith(dismiss) {
	        instance.closePopup({
	          isDismissed: true,
	          dismiss: dismiss
	        });
	      };
	
	      privateMethods.swalPromiseResolve.set(instance, resolve);
	
	      domCache.confirmButton.onclick = function () {
	        return handleConfirmButtonClick(instance, innerParams);
	      };
	
	      domCache.denyButton.onclick = function () {
	        return handleDenyButtonClick(instance, innerParams);
	      };
	
	      domCache.cancelButton.onclick = function () {
	        return handleCancelButtonClick(instance, dismissWith);
	      };
	
	      domCache.closeButton.onclick = function () {
	        return dismissWith(DismissReason.close);
	      };
	
	      handlePopupClick(instance, domCache, dismissWith);
	      addKeydownHandler(instance, globalState, innerParams, dismissWith);
	
	      if (innerParams.toast && (innerParams.input || innerParams.footer || innerParams.showCloseButton)) {
	        addClass(document.body, swalClasses['toast-column']);
	      } else {
	        removeClass(document.body, swalClasses['toast-column']);
	      }
	
	      handleInputOptionsAndValue(instance, innerParams);
	      openPopup(innerParams);
	      setupTimer(globalState, innerParams, dismissWith);
	      initFocus(domCache, innerParams); // Scroll container to top on open (#1247, #1946)
	
	      setTimeout(function () {
	        domCache.container.scrollTop = 0;
	      });
	    });
	  };
	
	  var populateDomCache = function populateDomCache(instance) {
	    var domCache = {
	      popup: getPopup(),
	      container: getContainer(),
	      content: getContent(),
	      actions: getActions(),
	      confirmButton: getConfirmButton(),
	      denyButton: getDenyButton(),
	      cancelButton: getCancelButton(),
	      loader: getLoader(),
	      closeButton: getCloseButton(),
	      validationMessage: getValidationMessage(),
	      progressSteps: getProgressSteps()
	    };
	    privateProps.domCache.set(instance, domCache);
	    return domCache;
	  };
	
	  var setupTimer = function setupTimer(globalState$$1, innerParams, dismissWith) {
	    var timerProgressBar = getTimerProgressBar();
	    hide(timerProgressBar);
	
	    if (innerParams.timer) {
	      globalState$$1.timeout = new Timer(function () {
	        dismissWith('timer');
	        delete globalState$$1.timeout;
	      }, innerParams.timer);
	
	      if (innerParams.timerProgressBar) {
	        show(timerProgressBar);
	        setTimeout(function () {
	          if (globalState$$1.timeout && globalState$$1.timeout.running) {
	            // timer can be already stopped or unset at this point
	            animateTimerProgressBar(innerParams.timer);
	          }
	        });
	      }
	    }
	  };
	
	  var initFocus = function initFocus(domCache, innerParams) {
	    if (innerParams.toast) {
	      return;
	    }
	
	    if (!callIfFunction(innerParams.allowEnterKey)) {
	      return blurActiveElement();
	    }
	
	    if (!focusButton(domCache, innerParams)) {
	      setFocus(innerParams, -1, 1);
	    }
	  };
	
	  var focusButton = function focusButton(domCache, innerParams) {
	    if (innerParams.focusDeny && isVisible(domCache.denyButton)) {
	      domCache.denyButton.focus();
	      return true;
	    }
	
	    if (innerParams.focusCancel && isVisible(domCache.cancelButton)) {
	      domCache.cancelButton.focus();
	      return true;
	    }
	
	    if (innerParams.focusConfirm && isVisible(domCache.confirmButton)) {
	      domCache.confirmButton.focus();
	      return true;
	    }
	
	    return false;
	  };
	
	  var blurActiveElement = function blurActiveElement() {
	    if (document.activeElement && typeof document.activeElement.blur === 'function') {
	      document.activeElement.blur();
	    }
	  };
	
	  /**
	   * Updates popup parameters.
	   */
	
	  function update(params) {
	    var popup = getPopup();
	    var innerParams = privateProps.innerParams.get(this);
	
	    if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
	      return warn("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
	    }
	
	    var validUpdatableParams = {}; // assign valid params from `params` to `defaults`
	
	    Object.keys(params).forEach(function (param) {
	      if (Swal.isUpdatableParameter(param)) {
	        validUpdatableParams[param] = params[param];
	      } else {
	        warn("Invalid parameter to update: \"".concat(param, "\". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js\n\nIf you think this parameter should be updatable, request it here: https://github.com/sweetalert2/sweetalert2/issues/new?template=02_feature_request.md"));
	      }
	    });
	
	    var updatedParams = _extends({}, innerParams, validUpdatableParams);
	
	    render(this, updatedParams);
	    privateProps.innerParams.set(this, updatedParams);
	    Object.defineProperties(this, {
	      params: {
	        value: _extends({}, this.params, params),
	        writable: false,
	        enumerable: true
	      }
	    });
	  }
	
	  function _destroy() {
	    var domCache = privateProps.domCache.get(this);
	    var innerParams = privateProps.innerParams.get(this);
	
	    if (!innerParams) {
	      return; // This instance has already been destroyed
	    } // Check if there is another Swal closing
	
	
	    if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
	      globalState.swalCloseEventFinishedCallback();
	      delete globalState.swalCloseEventFinishedCallback;
	    } // Check if there is a swal disposal defer timer
	
	
	    if (globalState.deferDisposalTimer) {
	      clearTimeout(globalState.deferDisposalTimer);
	      delete globalState.deferDisposalTimer;
	    }
	
	    runDidDestroy(innerParams);
	    disposeSwal(this);
	  }
	
	  var runDidDestroy = function runDidDestroy(innerParams) {
	    if (typeof innerParams.didDestroy === 'function') {
	      innerParams.didDestroy();
	    } else if (typeof innerParams.onDestroy === 'function') {
	      innerParams.onDestroy(); // @deprecated
	    }
	  };
	
	  var disposeSwal = function disposeSwal(instance) {
	    // Unset this.params so GC will dispose it (#1569)
	    delete instance.params; // Unset globalState props so GC will dispose globalState (#1569)
	
	    delete globalState.keydownHandler;
	    delete globalState.keydownTarget; // Unset WeakMaps so GC will be able to dispose them (#1569)
	
	    unsetWeakMaps(privateProps);
	    unsetWeakMaps(privateMethods);
	  };
	
	  var unsetWeakMaps = function unsetWeakMaps(obj) {
	    for (var i in obj) {
	      obj[i] = new WeakMap();
	    }
	  };
	
	
	
	  var instanceMethods = /*#__PURE__*/Object.freeze({
	    hideLoading: hideLoading,
	    disableLoading: hideLoading,
	    getInput: getInput$1,
	    close: close,
	    closePopup: close,
	    closeModal: close,
	    closeToast: close,
	    enableButtons: enableButtons,
	    disableButtons: disableButtons,
	    enableInput: enableInput,
	    disableInput: disableInput,
	    showValidationMessage: showValidationMessage,
	    resetValidationMessage: resetValidationMessage$1,
	    getProgressSteps: getProgressSteps$1,
	    _main: _main,
	    update: update,
	    _destroy: _destroy
	  });
	
	  var currentInstance;
	
	  var SweetAlert = /*#__PURE__*/function () {
	    function SweetAlert() {
	      _classCallCheck(this, SweetAlert);
	
	      // Prevent run in Node env
	      if (typeof window === 'undefined') {
	        return;
	      } // Check for the existence of Promise
	
	
	      if (typeof Promise === 'undefined') {
	        error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
	      }
	
	      currentInstance = this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var outerParams = Object.freeze(this.constructor.argsToParams(args));
	      Object.defineProperties(this, {
	        params: {
	          value: outerParams,
	          writable: false,
	          enumerable: true,
	          configurable: true
	        }
	      });
	
	      var promise = this._main(this.params);
	
	      privateProps.promise.set(this, promise);
	    } // `catch` cannot be the name of a module export, so we define our thenable methods here instead
	
	
	    _createClass(SweetAlert, [{
	      key: "then",
	      value: function then(onFulfilled) {
	        var promise = privateProps.promise.get(this);
	        return promise.then(onFulfilled);
	      }
	    }, {
	      key: "finally",
	      value: function _finally(onFinally) {
	        var promise = privateProps.promise.get(this);
	        return promise["finally"](onFinally);
	      }
	    }]);
	
	    return SweetAlert;
	  }(); // Assign instance methods from src/instanceMethods/*.js to prototype
	
	
	  _extends(SweetAlert.prototype, instanceMethods); // Assign static methods from src/staticMethods/*.js to constructor
	
	
	  _extends(SweetAlert, staticMethods); // Proxy to instance methods to constructor, for now, for backwards compatibility
	
	
	  Object.keys(instanceMethods).forEach(function (key) {
	    SweetAlert[key] = function () {
	      if (currentInstance) {
	        var _currentInstance;
	
	        return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
	      }
	    };
	  });
	  SweetAlert.DismissReason = DismissReason;
	  SweetAlert.version = '10.13.1';
	
	  var Swal = SweetAlert;
	  Swal["default"] = Swal;
	
	  return Swal;
	
	}));
	if (typeof this !== 'undefined' && this.Sweetalert2){  this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2}
	
	"undefined"!=typeof document&&function(e,t){var n=e.createElement("style");if(e.getElementsByTagName("head")[0].appendChild(n),n.styleSheet)n.styleSheet.disabled||(n.styleSheet.cssText=t);else try{n.innerHTML=t}catch(e){n.innerText=t}}(document,".swal2-popup.swal2-toast{flex-direction:row;align-items:center;width:auto;padding:.625em;overflow-y:hidden;background:#fff;box-shadow:0 0 .625em #d9d9d9}.swal2-popup.swal2-toast .swal2-header{flex-direction:row;padding:0}.swal2-popup.swal2-toast .swal2-title{flex-grow:1;justify-content:flex-start;margin:0 .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:static;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{justify-content:flex-start;padding:0;font-size:1em}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:700}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{font-size:.25em}}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{flex-basis:auto!important;width:auto;height:auto;margin:0 .3125em;padding:0}.swal2-popup.swal2-toast .swal2-styled{margin:.125em .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(100,150,200,.5)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.8em;left:-.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-toast-animate-success-line-tip .75s;animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-toast-animate-success-line-long .75s;animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:swal2-toast-show .5s;animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:swal2-toast-hide .1s forwards;animation:swal2-toast-hide .1s forwards}.swal2-container{display:flex;position:fixed;z-index:1060;top:0;right:0;bottom:0;left:0;flex-direction:row;align-items:center;justify-content:center;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}.swal2-container.swal2-backdrop-show,.swal2-container.swal2-noanimation{background:rgba(0,0,0,.4)}.swal2-container.swal2-backdrop-hide{background:0 0!important}.swal2-container.swal2-top{align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{align-items:flex-start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{align-items:flex-start;justify-content:flex-end}.swal2-container.swal2-center{align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{align-items:center;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{align-items:center;justify-content:flex-end}.swal2-container.swal2-bottom{align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{align-items:flex-end;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{align-items:flex-end;justify-content:flex-end}.swal2-container.swal2-bottom-end>:first-child,.swal2-container.swal2-bottom-left>:first-child,.swal2-container.swal2-bottom-right>:first-child,.swal2-container.swal2-bottom-start>:first-child,.swal2-container.swal2-bottom>:first-child{margin-top:auto}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:flex!important;flex:1;align-self:stretch;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-grow-column{flex:1;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-no-transition{transition:none!important}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-container .swal2-modal{margin:0!important}}.swal2-popup{display:none;position:relative;box-sizing:border-box;flex-direction:column;justify-content:center;width:32em;max-width:100%;padding:1.25em;border:none;border-radius:5px;background:#fff;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-header{display:flex;flex-direction:column;align-items:center;padding:0 1.8em}.swal2-title{position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:100%;margin:1.25em auto 0;padding:0 1.6em}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-loader{display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 transparent #2778c4 transparent}.swal2-styled{margin:.3125em;padding:.625em 1.1em;box-shadow:none;font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#2778c4;color:#fff;font-size:1.0625em}.swal2-styled.swal2-deny{border:0;border-radius:.25em;background:initial;background-color:#d14529;color:#fff;font-size:1.0625em}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#757575;color:#fff;font-size:1.0625em}.swal2-styled:focus{outline:0;box-shadow:0 0 0 3px rgba(100,150,200,.5)}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;height:.25em;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.swal2-timer-progress-bar{width:100%;height:.25em;background:rgba(0,0,0,.2)}.swal2-image{max-width:100%;margin:1.25em auto}.swal2-close{position:absolute;z-index:2;top:0;right:0;align-items:center;justify-content:center;width:1.2em;height:1.2em;padding:0;overflow:hidden;transition:color .1s ease-out;border:none;border-radius:5px;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer}.swal2-close:hover{transform:none;background:0 0;color:#f27474}.swal2-close:focus{outline:0;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}.swal2-close::-moz-focus-inner{border:0}.swal2-content{z-index:1;justify-content:center;margin:0;padding:0 1.6em;color:#545454;font-size:1.125em;font-weight:400;line-height:normal;text-align:center;word-wrap:break-word}.swal2-checkbox,.swal2-file,.swal2-input,.swal2-radio,.swal2-select,.swal2-textarea{margin:1em auto}.swal2-file,.swal2-input,.swal2-textarea{box-sizing:border-box;width:100%;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);color:inherit;font-size:1.125em}.swal2-file.swal2-inputerror,.swal2-input.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-file:focus,.swal2-input:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 0 3px rgba(100,150,200,.5)}.swal2-file::-moz-placeholder,.swal2-input::-moz-placeholder,.swal2-textarea::-moz-placeholder{color:#ccc}.swal2-file:-ms-input-placeholder,.swal2-input:-ms-input-placeholder,.swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-file::placeholder,.swal2-input::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em auto;background:#fff}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-input[type=number]{max-width:10em}.swal2-file{background:inherit;font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:inherit;font-size:1.125em}.swal2-checkbox,.swal2-radio{align-items:center;justify-content:center;background:#fff;color:inherit}.swal2-checkbox label,.swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-checkbox input,.swal2-radio input{margin:0 .4em}.swal2-input-label{display:flex;justify-content:center;margin:1em auto}.swal2-validation-message{display:none;align-items:center;justify-content:center;margin:0 -2.7em;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}.swal2-icon{position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;border:.25em solid transparent;border-radius:50%;font-family:inherit;line-height:5em;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474;color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}.swal2-icon.swal2-error.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-success{border-color:#a5dc86;color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-.25em;left:-.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:0 0 1.25em;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-webkit-keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@-webkit-keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@-webkit-keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@-webkit-keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-container{top:auto;right:auto;bottom:auto;left:auto;max-width:calc(100% - .625em * 2);background-color:transparent!important}body.swal2-no-backdrop .swal2-container>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-container.swal2-top{top:0;left:50%;transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-top-left,body.swal2-no-backdrop .swal2-container.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-top-end,body.swal2-no-backdrop .swal2-container.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-container.swal2-center{top:50%;left:50%;transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-left,body.swal2-no-backdrop .swal2-container.swal2-center-start{top:50%;left:0;transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-end,body.swal2-no-backdrop .swal2-container.swal2-center-right{top:50%;right:0;transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom{bottom:0;left:50%;transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom-left,body.swal2-no-backdrop .swal2-container.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-bottom-end,body.swal2-no-backdrop .swal2-container.swal2-bottom-right{right:0;bottom:0}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}body.swal2-toast-shown .swal2-container{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}body.swal2-toast-column .swal2-toast{flex-direction:column;align-items:stretch}body.swal2-toast-column .swal2-toast .swal2-actions{flex:1;align-self:stretch;height:2.2em;margin-top:.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{justify-content:center}body.swal2-toast-column .swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size:1em}");

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1221);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1248 */
/***/ function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(284);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(28);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _utils = __webpack_require__(1250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cookies = function () {
	  function Cookies(cookies, hooks) {
	    _classCallCheck(this, Cookies);
	
	    this.changeListeners = [];
	
	    this.cookies = parseCookies(cookies);
	    this.hooks = hooks;
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  _createClass(Cookies, [{
	    key: '_updateBrowserValues',
	    value: function _updateBrowserValues() {
	      if (!this.HAS_DOCUMENT_COOKIE) {
	        return;
	      }
	
	      this.cookies = _cookie2.default.parse(document.cookie);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._updateBrowserValues();
	      return readCookie(this.cookies[name], options);
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this._updateBrowserValues();
	      var result = {};
	
	      for (var name in this.cookies) {
	        result[name] = readCookie(this.cookies[name], options);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(name, value, options) {
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        value = JSON.stringify(value);
	      }
	
	      if (this.hooks && this.hooks.onSet) {
	        this.hooks.onSet(name, value, options);
	      }
	
	      this.cookies[name] = value;
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, value, options);
	      }
	
	      this._emitChange({ name: name, value: value, options: options });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(name, options) {
	      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
	        expires: new Date(1970, 1, 1, 0, 0, 1),
	        maxAge: 0
	      });
	
	      if (this.hooks && this.hooks.onRemove) {
	        this.hooks.onRemove(name, finalOptions);
	      }
	
	      delete this.cookies[name];
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
	      }
	
	      this._emitChange({ name: name, value: undefined, options: options });
	    }
	  }, {
	    key: '_emitChange',
	    value: function _emitChange(params) {
	      for (var i = 0; i < this.changeListeners.length; ++i) {
	        this.changeListeners[i](params);
	      }
	    }
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(callback) {
	      this.changeListeners.push(callback);
	    }
	  }, {
	    key: 'removeChangeListener',
	    value: function removeChangeListener(callback) {
	      var idx = this.changeListeners.indexOf(callback);
	      if (idx >= 0) {
	        this.changeListeners.splice(idx, 1);
	      }
	    }
	  }]);
	
	  return Cookies;
	}();
	
	exports.default = Cookies;
	
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return _cookie2.default.parse(cookies);
	  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      // At least we tried
	    }
	  }
	
	  return value;
	}
	module.exports = exports['default'];

/***/ },
/* 1250 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	// Can we get/set cookies on document.cookie?
	
	function hasDocumentCookie() {
	  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	//backwards compatibility
	var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notFound3.5917750c.jpg";

/***/ },
/* 1252 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1253 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(1256)
	} else {
	  module.exports = require('./windows-iana.cjs.development.js')
	}


/***/ },
/* 1256 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=[{name:"adalv",description:"Andorra",alias:["Europe/Andorra"]},{name:"aedxb",description:"Dubai, United Arab Emirates",alias:["Asia/Dubai"]},{name:"afkbl",description:"Kabul, Afghanistan",alias:["Asia/Kabul"]},{name:"aganu",description:"Antigua",alias:["America/Antigua"]},{name:"aiaxa",description:"Anguilla",alias:["America/Anguilla"]},{name:"altia",description:"Tirane, Albania",alias:["Europe/Tirane"]},{name:"amevn",description:"Yerevan, Armenia",alias:["Asia/Yerevan"]},{name:"ancur",description:"Curaçao",alias:["America/Curacao"]},{name:"aolad",description:"Luanda, Angola",alias:["Africa/Luanda"]},{name:"aqcas",description:"Casey Station, Bailey Peninsula",alias:["Antarctica/Casey"]},{name:"aqdav",description:"Davis Station, Vestfold Hills",alias:["Antarctica/Davis"]},{name:"aqddu",description:"Dumont d'Urville Station, Terre Adélie",alias:["Antarctica/DumontDUrville"]},{name:"aqmaw",description:"Mawson Station, Holme Bay",alias:["Antarctica/Mawson"]},{name:"aqmcm",description:"McMurdo Station, Ross Island",alias:["Antarctica/McMurdo"]},{name:"aqplm",description:"Palmer Station, Anvers Island",alias:["Antarctica/Palmer"]},{name:"aqrot",description:"Rothera Station, Adelaide Island",alias:["Antarctica/Rothera"]},{name:"aqsyw",description:"Syowa Station, East Ongul Island",alias:["Antarctica/Syowa"]},{name:"aqtrl",description:"Troll Station, Queen Maud Land",alias:["Antarctica/Troll"]},{name:"aqvos",description:"Vostok Station, Lake Vostok",alias:["Antarctica/Vostok"]},{name:"arbue",description:"Buenos Aires, Argentina",alias:["America/Buenos_Aires","America/Argentina/Buenos_Aires"]},{name:"arcor",description:"Córdoba, Argentina",alias:["America/Cordoba","America/Argentina/Cordoba","America/Rosario"]},{name:"arctc",description:"Catamarca, Argentina",alias:["America/Catamarca","America/Argentina/Catamarca","America/Argentina/ComodRivadavia"]},{name:"arirj",description:"La Rioja, Argentina",alias:["America/Argentina/La_Rioja"]},{name:"arjuj",description:"Jujuy, Argentina",alias:["America/Jujuy","America/Argentina/Jujuy"]},{name:"arluq",description:"San Luis, Argentina",alias:["America/Argentina/San_Luis"]},{name:"armdz",description:"Mendoza, Argentina",alias:["America/Mendoza","America/Argentina/Mendoza"]},{name:"arrgl",description:"Río Gallegos, Argentina",alias:["America/Argentina/Rio_Gallegos"]},{name:"arsla",description:"Salta, Argentina",alias:["America/Argentina/Salta"]},{name:"artuc",description:"Tucumán, Argentina",alias:["America/Argentina/Tucuman"]},{name:"aruaq",description:"San Juan, Argentina",alias:["America/Argentina/San_Juan"]},{name:"arush",description:"Ushuaia, Argentina",alias:["America/Argentina/Ushuaia"]},{name:"asppg",description:"Pago Pago, American Samoa",alias:["Pacific/Pago_Pago","Pacific/Samoa","US/Samoa"]},{name:"atvie",description:"Vienna, Austria",alias:["Europe/Vienna"]},{name:"auadl",description:"Adelaide, Australia",alias:["Australia/Adelaide","Australia/South"]},{name:"aubhq",description:"Broken Hill, Australia",alias:["Australia/Broken_Hill","Australia/Yancowinna"]},{name:"aubne",description:"Brisbane, Australia",alias:["Australia/Brisbane","Australia/Queensland"]},{name:"audrw",description:"Darwin, Australia",alias:["Australia/Darwin","Australia/North"]},{name:"aueuc",description:"Eucla, Australia",alias:["Australia/Eucla"]},{name:"auhba",description:"Hobart, Australia",alias:["Australia/Hobart","Australia/Tasmania"]},{name:"aukns",description:"Currie, Australia",alias:["Australia/Currie"]},{name:"auldc",description:"Lindeman Island, Australia",alias:["Australia/Lindeman"]},{name:"auldh",description:"Lord Howe Island, Australia",alias:["Australia/Lord_Howe","Australia/LHI"]},{name:"aumel",description:"Melbourne, Australia",alias:["Australia/Melbourne","Australia/Victoria"]},{name:"aumqi",description:"Macquarie Island Station, Macquarie Island",alias:["Antarctica/Macquarie"]},{name:"auper",description:"Perth, Australia",alias:["Australia/Perth","Australia/West"]},{name:"ausyd",description:"Sydney, Australia",alias:["Australia/Sydney","Australia/ACT","Australia/Canberra","Australia/NSW"]},{name:"awaua",description:"Aruba",alias:["America/Aruba"]},{name:"azbak",description:"Baku, Azerbaijan",alias:["Asia/Baku"]},{name:"basjj",description:"Sarajevo, Bosnia and Herzegovina",alias:["Europe/Sarajevo"]},{name:"bbbgi",description:"Barbados",alias:["America/Barbados"]},{name:"bddac",description:"Dhaka, Bangladesh",alias:["Asia/Dhaka","Asia/Dacca"]},{name:"bebru",description:"Brussels, Belgium",alias:["Europe/Brussels"]},{name:"bfoua",description:"Ouagadougou, Burkina Faso",alias:["Africa/Ouagadougou"]},{name:"bgsof",description:"Sofia, Bulgaria",alias:["Europe/Sofia"]},{name:"bhbah",description:"Bahrain",alias:["Asia/Bahrain"]},{name:"bibjm",description:"Bujumbura, Burundi",alias:["Africa/Bujumbura"]},{name:"bjptn",description:"Porto-Novo, Benin",alias:["Africa/Porto-Novo"]},{name:"bmbda",description:"Bermuda",alias:["Atlantic/Bermuda"]},{name:"bnbwn",description:"Brunei",alias:["Asia/Brunei"]},{name:"bolpb",description:"La Paz, Bolivia",alias:["America/La_Paz"]},{name:"bqkra",description:"Bonaire, Sint Estatius and Saba",alias:["America/Kralendijk"]},{name:"braux",description:"Araguaína, Brazil",alias:["America/Araguaina"]},{name:"brbel",description:"Belém, Brazil",alias:["America/Belem"]},{name:"brbvb",description:"Boa Vista, Brazil",alias:["America/Boa_Vista"]},{name:"brcgb",description:"Cuiabá, Brazil",alias:["America/Cuiaba"]},{name:"brcgr",description:"Campo Grande, Brazil",alias:["America/Campo_Grande"]},{name:"brern",description:"Eirunepé, Brazil",alias:["America/Eirunepe"]},{name:"brfen",description:"Fernando de Noronha, Brazil",alias:["America/Noronha","Brazil/DeNoronha"]},{name:"brfor",description:"Fortaleza, Brazil",alias:["America/Fortaleza"]},{name:"brmao",description:"Manaus, Brazil",alias:["America/Manaus","Brazil/West"]},{name:"brmcz",description:"Maceió, Brazil",alias:["America/Maceio"]},{name:"brpvh",description:"Porto Velho, Brazil",alias:["America/Porto_Velho"]},{name:"brrbr",description:"Rio Branco, Brazil",alias:["America/Rio_Branco","America/Porto_Acre","Brazil/Acre"]},{name:"brrec",description:"Recife, Brazil",alias:["America/Recife"]},{name:"brsao",description:"São Paulo, Brazil",alias:["America/Sao_Paulo","Brazil/East"]},{name:"brssa",description:"Bahia, Brazil",alias:["America/Bahia"]},{name:"brstm",description:"Santarém, Brazil",alias:["America/Santarem"]},{name:"bsnas",description:"Nassau, Bahamas",alias:["America/Nassau"]},{name:"btthi",description:"Thimphu, Bhutan",alias:["Asia/Thimphu","Asia/Thimbu"]},{name:"bwgbe",description:"Gaborone, Botswana",alias:["Africa/Gaborone"]},{name:"bymsq",description:"Minsk, Belarus",alias:["Europe/Minsk"]},{name:"bzbze",description:"Belize",alias:["America/Belize"]},{name:"cacfq",description:"Creston, Canada",alias:["America/Creston"]},{name:"caedm",description:"Edmonton, Canada",alias:["America/Edmonton","Canada/Mountain"]},{name:"caffs",description:"Rainy River, Canada",alias:["America/Rainy_River"]},{name:"cafne",description:"Fort Nelson, Canada",alias:["America/Fort_Nelson"]},{name:"caglb",description:"Glace Bay, Canada",alias:["America/Glace_Bay"]},{name:"cagoo",description:"Goose Bay, Canada",alias:["America/Goose_Bay"]},{name:"cahal",description:"Halifax, Canada",alias:["America/Halifax","Canada/Atlantic"]},{name:"caiql",description:"Iqaluit, Canada",alias:["America/Iqaluit"]},{name:"camon",description:"Moncton, Canada",alias:["America/Moncton"]},{name:"capnt",description:"Pangnirtung, Canada",alias:["America/Pangnirtung"]},{name:"careb",description:"Resolute, Canada",alias:["America/Resolute"]},{name:"careg",description:"Regina, Canada",alias:["America/Regina","Canada/East-Saskatchewan","Canada/Saskatchewan"]},{name:"casjf",description:"St. John's, Canada",alias:["America/St_Johns","Canada/Newfoundland"]},{name:"canpg",description:"Nipigon, Canada",alias:["America/Nipigon"]},{name:"cathu",description:"Thunder Bay, Canada",alias:["America/Thunder_Bay"]},{name:"cator",description:"Toronto, Canada",alias:["America/Toronto","Canada/Eastern"]},{name:"cavan",description:"Vancouver, Canada",alias:["America/Vancouver","Canada/Pacific"]},{name:"cawnp",description:"Winnipeg, Canada",alias:["America/Winnipeg","Canada/Central"]},{name:"caybx",description:"Blanc-Sablon, Canada",alias:["America/Blanc-Sablon"]},{name:"caycb",description:"Cambridge Bay, Canada",alias:["America/Cambridge_Bay"]},{name:"cayda",description:"Dawson, Canada",alias:["America/Dawson"]},{name:"caydq",description:"Dawson Creek, Canada",alias:["America/Dawson_Creek"]},{name:"cayek",description:"Rankin Inlet, Canada",alias:["America/Rankin_Inlet"]},{name:"cayev",description:"Inuvik, Canada",alias:["America/Inuvik"]},{name:"cayxy",description:"Whitehorse, Canada",alias:["America/Whitehorse","Canada/Yukon"]},{name:"cayyn",description:"Swift Current, Canada",alias:["America/Swift_Current"]},{name:"cayzf",description:"Yellowknife, Canada",alias:["America/Yellowknife"]},{name:"cayzs",description:"Atikokan, Canada",alias:["America/Coral_Harbour","America/Atikokan"]},{name:"cccck",description:"Cocos (Keeling) Islands",alias:["Indian/Cocos"]},{name:"cdfbm",description:"Lubumbashi, Democratic Republic of the Congo",alias:["Africa/Lubumbashi"]},{name:"cdfih",description:"Kinshasa, Democratic Republic of the Congo",alias:["Africa/Kinshasa"]},{name:"cfbgf",description:"Bangui, Central African Republic",alias:["Africa/Bangui"]},{name:"cgbzv",description:"Brazzaville, Republic of the Congo",alias:["Africa/Brazzaville"]},{name:"chzrh",description:"Zurich, Switzerland",alias:["Europe/Zurich"]},{name:"ciabj",description:"Abidjan, Côte d'Ivoire",alias:["Africa/Abidjan"]},{name:"ckrar",description:"Rarotonga, Cook Islands",alias:["Pacific/Rarotonga"]},{name:"clipc",description:"Easter Island, Chile",alias:["Pacific/Easter","Chile/EasterIsland"]},{name:"clpuq",description:"Punta Arenas, Chile",alias:["America/Punta_Arenas"]},{name:"clscl",description:"Santiago, Chile",alias:["America/Santiago","Chile/Continental"]},{name:"cmdla",description:"Douala, Cameroon",alias:["Africa/Douala"]},{name:"cnsha",description:"Shanghai, China",alias:["Asia/Shanghai","Asia/Chongqing","Asia/Chungking","Asia/Harbin","PRC"]},{name:"cnurc",description:"Ürümqi, China",alias:["Asia/Urumqi","Asia/Kashgar"]},{name:"cobog",description:"Bogotá, Colombia",alias:["America/Bogota"]},{name:"crsjo",description:"Costa Rica",alias:["America/Costa_Rica"]},{name:"cst6cdt",description:"POSIX style time zone for US Central Time",alias:["CST6CDT"]},{name:"cuhav",description:"Havana, Cuba",alias:["America/Havana","Cuba"]},{name:"cvrai",description:"Cape Verde",alias:["Atlantic/Cape_Verde"]},{name:"cxxch",description:"Christmas Island",alias:["Indian/Christmas"]},{name:"cyfmg",description:"Famagusta, Cyprus",alias:["Asia/Famagusta"]},{name:"cynic",description:"Nicosia, Cyprus",alias:["Asia/Nicosia","Europe/Nicosia"]},{name:"czprg",description:"Prague, Czech Republic",alias:["Europe/Prague"]},{name:"deber",description:"Berlin, Germany",alias:["Europe/Berlin"]},{name:"debsngn",description:"Busingen, Germany",alias:["Europe/Busingen"]},{name:"djjib",description:"Djibouti",alias:["Africa/Djibouti"]},{name:"dkcph",description:"Copenhagen, Denmark",alias:["Europe/Copenhagen"]},{name:"dmdom",description:"Dominica",alias:["America/Dominica"]},{name:"dosdq",description:"Santo Domingo, Dominican Republic",alias:["America/Santo_Domingo"]},{name:"dzalg",description:"Algiers, Algeria",alias:["Africa/Algiers"]},{name:"ecgps",description:"Galápagos Islands, Ecuador",alias:["Pacific/Galapagos"]},{name:"ecgye",description:"Guayaquil, Ecuador",alias:["America/Guayaquil"]},{name:"eetll",description:"Tallinn, Estonia",alias:["Europe/Tallinn"]},{name:"egcai",description:"Cairo, Egypt",alias:["Africa/Cairo","Egypt"]},{name:"eheai",description:"El Aaiún, Western Sahara",alias:["Africa/El_Aaiun"]},{name:"erasm",description:"Asmara, Eritrea",alias:["Africa/Asmera","Africa/Asmara"]},{name:"esceu",description:"Ceuta, Spain",alias:["Africa/Ceuta"]},{name:"eslpa",description:"Canary Islands, Spain",alias:["Atlantic/Canary"]},{name:"esmad",description:"Madrid, Spain",alias:["Europe/Madrid"]},{name:"est5edt",description:"POSIX style time zone for US Eastern Time",alias:["EST5EDT"]},{name:"etadd",description:"Addis Ababa, Ethiopia",alias:["Africa/Addis_Ababa"]},{name:"fihel",description:"Helsinki, Finland",alias:["Europe/Helsinki"]},{name:"fimhq",description:"Mariehamn, Åland, Finland",alias:["Europe/Mariehamn"]},{name:"fjsuv",description:"Fiji",alias:["Pacific/Fiji"]},{name:"fkpsy",description:"Stanley, Falkland Islands",alias:["Atlantic/Stanley"]},{name:"fmksa",description:"Kosrae, Micronesia",alias:["Pacific/Kosrae"]},{name:"fmpni",description:"Pohnpei, Micronesia",alias:["Pacific/Ponape","Pacific/Pohnpei"]},{name:"fmtkk",description:"Chuuk, Micronesia",alias:["Pacific/Truk","Pacific/Chuuk","Pacific/Yap"]},{name:"fotho",description:"Faroe Islands",alias:["Atlantic/Faeroe","Atlantic/Faroe"]},{name:"frpar",description:"Paris, France",alias:["Europe/Paris"]},{name:"galbv",description:"Libreville, Gabon",alias:["Africa/Libreville"]},{name:"gazastrp",description:"Gaza Strip, Palestinian Territories",alias:["Asia/Gaza"]},{name:"gblon",description:"London, United Kingdom",alias:["Europe/London","Europe/Belfast","GB","GB-Eire"]},{name:"gdgnd",description:"Grenada",alias:["America/Grenada"]},{name:"getbs",description:"Tbilisi, Georgia",alias:["Asia/Tbilisi"]},{name:"gfcay",description:"Cayenne, French Guiana",alias:["America/Cayenne"]},{name:"gggci",description:"Guernsey",alias:["Europe/Guernsey"]},{name:"ghacc",description:"Accra, Ghana",alias:["Africa/Accra"]},{name:"gigib",description:"Gibraltar",alias:["Europe/Gibraltar"]},{name:"gldkshvn",description:"Danmarkshavn, Greenland",alias:["America/Danmarkshavn"]},{name:"glgoh",description:"Nuuk (Godthåb), Greenland",alias:["America/Godthab","America/Nuuk"]},{name:"globy",description:"Ittoqqortoormiit (Scoresbysund), Greenland",alias:["America/Scoresbysund"]},{name:"glthu",description:"Qaanaaq (Thule), Greenland",alias:["America/Thule"]},{name:"gmbjl",description:"Banjul, Gambia",alias:["Africa/Banjul"]},{name:"gmt",description:"Greenwich Mean Time",alias:["Etc/GMT","Etc/GMT+0","Etc/GMT-0","Etc/GMT0","Etc/Greenwich","GMT","GMT+0","GMT-0","GMT0","Greenwich"]},{name:"gncky",description:"Conakry, Guinea",alias:["Africa/Conakry"]},{name:"gpbbr",description:"Guadeloupe",alias:["America/Guadeloupe"]},{name:"gpmsb",description:"Marigot, Saint Martin",alias:["America/Marigot"]},{name:"gpsbh",description:"Saint Barthélemy",alias:["America/St_Barthelemy"]},{name:"gqssg",description:"Malabo, Equatorial Guinea",alias:["Africa/Malabo"]},{name:"grath",description:"Athens, Greece",alias:["Europe/Athens"]},{name:"gsgrv",description:"South Georgia and the South Sandwich Islands",alias:["Atlantic/South_Georgia"]},{name:"gtgua",description:"Guatemala",alias:["America/Guatemala"]},{name:"gugum",description:"Guam",alias:["Pacific/Guam"]},{name:"gwoxb",description:"Bissau, Guinea-Bissau",alias:["Africa/Bissau"]},{name:"gygeo",description:"Guyana",alias:["America/Guyana"]},{name:"hebron",description:"West Bank, Palestinian Territories",alias:["Asia/Hebron"]},{name:"hkhkg",description:"Hong Kong SAR China",alias:["Asia/Hong_Kong","Hongkong"]},{name:"hntgu",description:"Tegucigalpa, Honduras",alias:["America/Tegucigalpa"]},{name:"hrzag",description:"Zagreb, Croatia",alias:["Europe/Zagreb"]},{name:"htpap",description:"Port-au-Prince, Haiti",alias:["America/Port-au-Prince"]},{name:"hubud",description:"Budapest, Hungary",alias:["Europe/Budapest"]},{name:"iddjj",description:"Jayapura, Indonesia",alias:["Asia/Jayapura"]},{name:"idjkt",description:"Jakarta, Indonesia",alias:["Asia/Jakarta"]},{name:"idmak",description:"Makassar, Indonesia",alias:["Asia/Makassar","Asia/Ujung_Pandang"]},{name:"idpnk",description:"Pontianak, Indonesia",alias:["Asia/Pontianak"]},{name:"iedub",description:"Dublin, Ireland",alias:["Europe/Dublin","Eire"]},{name:"imdgs",description:"Isle of Man",alias:["Europe/Isle_of_Man"]},{name:"inccu",description:"Kolkata, India",alias:["Asia/Calcutta","Asia/Kolkata"]},{name:"iodga",description:"Chagos Archipelago",alias:["Indian/Chagos"]},{name:"iqbgw",description:"Baghdad, Iraq",alias:["Asia/Baghdad"]},{name:"irthr",description:"Tehran, Iran",alias:["Asia/Tehran","Iran"]},{name:"isrey",description:"Reykjavik, Iceland",alias:["Atlantic/Reykjavik","Iceland"]},{name:"itrom",description:"Rome, Italy",alias:["Europe/Rome"]},{name:"jeruslm",description:"Jerusalem",alias:["Asia/Jerusalem","Asia/Tel_Aviv","Israel"]},{name:"jesth",description:"Jersey",alias:["Europe/Jersey"]},{name:"jmkin",description:"Jamaica",alias:["America/Jamaica","Jamaica"]},{name:"joamm",description:"Amman, Jordan",alias:["Asia/Amman"]},{name:"jptyo",description:"Tokyo, Japan",alias:["Asia/Tokyo","Japan"]},{name:"kenbo",description:"Nairobi, Kenya",alias:["Africa/Nairobi"]},{name:"kgfru",description:"Bishkek, Kyrgyzstan",alias:["Asia/Bishkek"]},{name:"khpnh",description:"Phnom Penh, Cambodia",alias:["Asia/Phnom_Penh"]},{name:"kicxi",description:"Kiritimati, Kiribati",alias:["Pacific/Kiritimati"]},{name:"kipho",description:"Enderbury Island, Kiribati",alias:["Pacific/Enderbury"]},{name:"kitrw",description:"Tarawa, Kiribati",alias:["Pacific/Tarawa"]},{name:"kmyva",description:"Comoros",alias:["Indian/Comoro"]},{name:"knbas",description:"Saint Kitts",alias:["America/St_Kitts"]},{name:"kpfnj",description:"Pyongyang, North Korea",alias:["Asia/Pyongyang"]},{name:"krsel",description:"Seoul, South Korea",alias:["Asia/Seoul","ROK"]},{name:"kwkwi",description:"Kuwait",alias:["Asia/Kuwait"]},{name:"kygec",description:"Cayman Islands",alias:["America/Cayman"]},{name:"kzaau",description:"Aqtau, Kazakhstan",alias:["Asia/Aqtau"]},{name:"kzakx",description:"Aqtobe, Kazakhstan",alias:["Asia/Aqtobe"]},{name:"kzala",description:"Almaty, Kazakhstan",alias:["Asia/Almaty"]},{name:"kzguw",description:"Atyrau (Guryev), Kazakhstan",alias:["Asia/Atyrau"]},{name:"kzksn",description:"Qostanay (Kostanay), Kazakhstan",alias:["Asia/Qostanay"]},{name:"kzkzo",description:"Kyzylorda, Kazakhstan",alias:["Asia/Qyzylorda"]},{name:"kzura",description:"Oral, Kazakhstan",alias:["Asia/Oral"]},{name:"lavte",description:"Vientiane, Laos",alias:["Asia/Vientiane"]},{name:"lbbey",description:"Beirut, Lebanon",alias:["Asia/Beirut"]},{name:"lccas",description:"Saint Lucia",alias:["America/St_Lucia"]},{name:"livdz",description:"Vaduz, Liechtenstein",alias:["Europe/Vaduz"]},{name:"lkcmb",description:"Colombo, Sri Lanka",alias:["Asia/Colombo"]},{name:"lrmlw",description:"Monrovia, Liberia",alias:["Africa/Monrovia"]},{name:"lsmsu",description:"Maseru, Lesotho",alias:["Africa/Maseru"]},{name:"ltvno",description:"Vilnius, Lithuania",alias:["Europe/Vilnius"]},{name:"lulux",description:"Luxembourg",alias:["Europe/Luxembourg"]},{name:"lvrix",description:"Riga, Latvia",alias:["Europe/Riga"]},{name:"lytip",description:"Tripoli, Libya",alias:["Africa/Tripoli","Libya"]},{name:"macas",description:"Casablanca, Morocco",alias:["Africa/Casablanca"]},{name:"mcmon",description:"Monaco",alias:["Europe/Monaco"]},{name:"mdkiv",description:"Chişinău, Moldova",alias:["Europe/Chisinau","Europe/Tiraspol"]},{name:"metgd",description:"Podgorica, Montenegro",alias:["Europe/Podgorica"]},{name:"mgtnr",description:"Antananarivo, Madagascar",alias:["Indian/Antananarivo"]},{name:"mhkwa",description:"Kwajalein, Marshall Islands",alias:["Pacific/Kwajalein","Kwajalein"]},{name:"mhmaj",description:"Majuro, Marshall Islands",alias:["Pacific/Majuro"]},{name:"mkskp",description:"Skopje, Macedonia",alias:["Europe/Skopje"]},{name:"mlbko",description:"Bamako, Mali",alias:["Africa/Bamako","Africa/Timbuktu"]},{name:"mmrgn",description:"Yangon (Rangoon), Burma",alias:["Asia/Rangoon","Asia/Yangon"]},{name:"mncoq",description:"Choibalsan, Mongolia",alias:["Asia/Choibalsan"]},{name:"mnhvd",description:"Khovd (Hovd), Mongolia",alias:["Asia/Hovd"]},{name:"mnuln",description:"Ulaanbaatar (Ulan Bator), Mongolia",alias:["Asia/Ulaanbaatar","Asia/Ulan_Bator"]},{name:"momfm",description:"Macau SAR China",alias:["Asia/Macau","Asia/Macao"]},{name:"mpspn",description:"Saipan, Northern Mariana Islands",alias:["Pacific/Saipan"]},{name:"mqfdf",description:"Martinique",alias:["America/Martinique"]},{name:"mrnkc",description:"Nouakchott, Mauritania",alias:["Africa/Nouakchott"]},{name:"msmni",description:"Montserrat",alias:["America/Montserrat"]},{name:"mst7mdt",description:"POSIX style time zone for US Mountain Time",alias:["MST7MDT"]},{name:"mtmla",description:"Malta",alias:["Europe/Malta"]},{name:"muplu",description:"Mauritius",alias:["Indian/Mauritius"]},{name:"mvmle",description:"Maldives",alias:["Indian/Maldives"]},{name:"mwblz",description:"Blantyre, Malawi",alias:["Africa/Blantyre"]},{name:"mxchi",description:"Chihuahua, Mexico",alias:["America/Chihuahua"]},{name:"mxcun",description:"Cancún, Mexico",alias:["America/Cancun"]},{name:"mxhmo",description:"Hermosillo, Mexico",alias:["America/Hermosillo"]},{name:"mxmam",description:"Matamoros, Mexico",alias:["America/Matamoros"]},{name:"mxmex",description:"Mexico City, Mexico",alias:["America/Mexico_City","Mexico/General"]},{name:"mxmid",description:"Mérida, Mexico",alias:["America/Merida"]},{name:"mxmty",description:"Monterrey, Mexico",alias:["America/Monterrey"]},{name:"mxmzt",description:"Mazatlán, Mexico",alias:["America/Mazatlan","Mexico/BajaSur"]},{name:"mxoji",description:"Ojinaga, Mexico",alias:["America/Ojinaga"]},{name:"mxpvr",description:"Bahía de Banderas, Mexico",alias:["America/Bahia_Banderas"]},{name:"mxstis",description:"Santa Isabel (Baja California), Mexico",alias:["America/Santa_Isabel"]},{name:"mxtij",description:"Tijuana, Mexico",alias:["America/Tijuana","America/Ensenada","Mexico/BajaNorte"]},{name:"mykch",description:"Kuching, Malaysia",alias:["Asia/Kuching"]},{name:"mykul",description:"Kuala Lumpur, Malaysia",alias:["Asia/Kuala_Lumpur"]},{name:"mzmpm",description:"Maputo, Mozambique",alias:["Africa/Maputo"]},{name:"nawdh",description:"Windhoek, Namibia",alias:["Africa/Windhoek"]},{name:"ncnou",description:"Noumea, New Caledonia",alias:["Pacific/Noumea"]},{name:"nenim",description:"Niamey, Niger",alias:["Africa/Niamey"]},{name:"nfnlk",description:"Norfolk Island",alias:["Pacific/Norfolk"]},{name:"nglos",description:"Lagos, Nigeria",alias:["Africa/Lagos"]},{name:"nimga",description:"Managua, Nicaragua",alias:["America/Managua"]},{name:"nlams",description:"Amsterdam, Netherlands",alias:["Europe/Amsterdam"]},{name:"noosl",description:"Oslo, Norway",alias:["Europe/Oslo"]},{name:"npktm",description:"Kathmandu, Nepal",alias:["Asia/Katmandu","Asia/Kathmandu"]},{name:"nrinu",description:"Nauru",alias:["Pacific/Nauru"]},{name:"nuiue",description:"Niue",alias:["Pacific/Niue"]},{name:"nzakl",description:"Auckland, New Zealand",alias:["Pacific/Auckland","Antarctica/South_Pole","NZ"]},{name:"nzcht",description:"Chatham Islands, New Zealand",alias:["Pacific/Chatham","NZ-CHAT"]},{name:"ommct",description:"Muscat, Oman",alias:["Asia/Muscat"]},{name:"papty",description:"Panama",alias:["America/Panama"]},{name:"pelim",description:"Lima, Peru",alias:["America/Lima"]},{name:"pfgmr",description:"Gambiera Islands, French Polynesia",alias:["Pacific/Gambier"]},{name:"pfnhv",description:"Marquesas Islands, French Polynesia",alias:["Pacific/Marquesas"]},{name:"pfppt",description:"Tahiti, French Polynesia",alias:["Pacific/Tahiti"]},{name:"pgpom",description:"Port Moresby, Papua New Guinea",alias:["Pacific/Port_Moresby"]},{name:"pgraw",description:"Bougainville, Papua New Guinea",alias:["Pacific/Bougainville"]},{name:"phmnl",description:"Manila, Philippines",alias:["Asia/Manila"]},{name:"pkkhi",description:"Karachi, Pakistan",alias:["Asia/Karachi"]},{name:"plwaw",description:"Warsaw, Poland",alias:["Europe/Warsaw","Poland"]},{name:"pmmqc",description:"Saint Pierre and Miquelon",alias:["America/Miquelon"]},{name:"pnpcn",description:"Pitcairn Islands",alias:["Pacific/Pitcairn"]},{name:"prsju",description:"Puerto Rico",alias:["America/Puerto_Rico"]},{name:"pst8pdt",description:"POSIX style time zone for US Pacific Time",alias:["PST8PDT"]},{name:"ptfnc",description:"Madeira, Portugal",alias:["Atlantic/Madeira"]},{name:"ptlis",description:"Lisbon, Portugal",alias:["Europe/Lisbon","Portugal"]},{name:"ptpdl",description:"Azores, Portugal",alias:["Atlantic/Azores"]},{name:"pwror",description:"Palau",alias:["Pacific/Palau"]},{name:"pyasu",description:"Asunción, Paraguay",alias:["America/Asuncion"]},{name:"qadoh",description:"Qatar",alias:["Asia/Qatar"]},{name:"rereu",description:"Réunion",alias:["Indian/Reunion"]},{name:"robuh",description:"Bucharest, Romania",alias:["Europe/Bucharest"]},{name:"rsbeg",description:"Belgrade, Serbia",alias:["Europe/Belgrade"]},{name:"ruasf",description:"Astrakhan, Russia",alias:["Europe/Astrakhan"]},{name:"rubax",description:"Barnaul, Russia",alias:["Asia/Barnaul"]},{name:"ruchita",description:"Chita Zabaykalsky, Russia",alias:["Asia/Chita"]},{name:"rudyr",description:"Anadyr, Russia",alias:["Asia/Anadyr"]},{name:"rugdx",description:"Magadan, Russia",alias:["Asia/Magadan"]},{name:"ruikt",description:"Irkutsk, Russia",alias:["Asia/Irkutsk"]},{name:"rukgd",description:"Kaliningrad, Russia",alias:["Europe/Kaliningrad"]},{name:"rukhndg",description:"Khandyga Tomponsky, Russia",alias:["Asia/Khandyga"]},{name:"rukra",description:"Krasnoyarsk, Russia",alias:["Asia/Krasnoyarsk"]},{name:"rukuf",description:"Samara, Russia",alias:["Europe/Samara"]},{name:"rukvx",description:"Kirov, Russia",alias:["Europe/Kirov"]},{name:"rumow",description:"Moscow, Russia",alias:["Europe/Moscow","W-SU"]},{name:"runoz",description:"Novokuznetsk, Russia",alias:["Asia/Novokuznetsk"]},{name:"ruoms",description:"Omsk, Russia",alias:["Asia/Omsk"]},{name:"ruovb",description:"Novosibirsk, Russia",alias:["Asia/Novosibirsk"]},{name:"rupkc",description:"Kamchatka Peninsula, Russia",alias:["Asia/Kamchatka"]},{name:"rurtw",description:"Saratov, Russia",alias:["Europe/Saratov"]},{name:"rusred",description:"Srednekolymsk, Russia",alias:["Asia/Srednekolymsk"]},{name:"rutof",description:"Tomsk, Russia",alias:["Asia/Tomsk"]},{name:"ruuly",description:"Ulyanovsk, Russia",alias:["Europe/Ulyanovsk"]},{name:"ruunera",description:"Ust-Nera Oymyakonsky, Russia",alias:["Asia/Ust-Nera"]},{name:"ruuus",description:"Sakhalin, Russia",alias:["Asia/Sakhalin"]},{name:"ruvog",description:"Volgograd, Russia",alias:["Europe/Volgograd"]},{name:"ruvvo",description:"Vladivostok, Russia",alias:["Asia/Vladivostok"]},{name:"ruyek",description:"Yekaterinburg, Russia",alias:["Asia/Yekaterinburg"]},{name:"ruyks",description:"Yakutsk, Russia",alias:["Asia/Yakutsk"]},{name:"rwkgl",description:"Kigali, Rwanda",alias:["Africa/Kigali"]},{name:"saruh",description:"Riyadh, Saudi Arabia",alias:["Asia/Riyadh"]},{name:"sbhir",description:"Guadalcanal, Solomon Islands",alias:["Pacific/Guadalcanal"]},{name:"scmaw",description:"Mahé, Seychelles",alias:["Indian/Mahe"]},{name:"sdkrt",description:"Khartoum, Sudan",alias:["Africa/Khartoum"]},{name:"sesto",description:"Stockholm, Sweden",alias:["Europe/Stockholm"]},{name:"sgsin",description:"Singapore",alias:["Asia/Singapore","Singapore"]},{name:"shshn",description:"Saint Helena",alias:["Atlantic/St_Helena"]},{name:"silju",description:"Ljubljana, Slovenia",alias:["Europe/Ljubljana"]},{name:"sjlyr",description:"Longyearbyen, Svalbard",alias:["Arctic/Longyearbyen","Atlantic/Jan_Mayen"]},{name:"skbts",description:"Bratislava, Slovakia",alias:["Europe/Bratislava"]},{name:"slfna",description:"Freetown, Sierra Leone",alias:["Africa/Freetown"]},{name:"smsai",description:"San Marino",alias:["Europe/San_Marino"]},{name:"sndkr",description:"Dakar, Senegal",alias:["Africa/Dakar"]},{name:"somgq",description:"Mogadishu, Somalia",alias:["Africa/Mogadishu"]},{name:"srpbm",description:"Paramaribo, Suriname",alias:["America/Paramaribo"]},{name:"ssjub",description:"Juba, South Sudan",alias:["Africa/Juba"]},{name:"sttms",description:"São Tomé, São Tomé and Príncipe",alias:["Africa/Sao_Tome"]},{name:"svsal",description:"El Salvador",alias:["America/El_Salvador"]},{name:"sxphi",description:"Sint Maarten",alias:["America/Lower_Princes"]},{name:"sydam",description:"Damascus, Syria",alias:["Asia/Damascus"]},{name:"szqmn",description:"Mbabane, Swaziland",alias:["Africa/Mbabane"]},{name:"tcgdt",description:"Grand Turk, Turks and Caicos Islands",alias:["America/Grand_Turk"]},{name:"tdndj",description:"N'Djamena, Chad",alias:["Africa/Ndjamena"]},{name:"tfpfr",description:"Kerguelen Islands, French Southern Territories",alias:["Indian/Kerguelen"]},{name:"tglfw",description:"Lomé, Togo",alias:["Africa/Lome"]},{name:"thbkk",description:"Bangkok, Thailand",alias:["Asia/Bangkok"]},{name:"tjdyu",description:"Dushanbe, Tajikistan",alias:["Asia/Dushanbe"]},{name:"tkfko",description:"Fakaofo, Tokelau",alias:["Pacific/Fakaofo"]},{name:"tldil",description:"Dili, East Timor",alias:["Asia/Dili"]},{name:"tmasb",description:"Ashgabat, Turkmenistan",alias:["Asia/Ashgabat","Asia/Ashkhabad"]},{name:"tntun",description:"Tunis, Tunisia",alias:["Africa/Tunis"]},{name:"totbu",description:"Tongatapu, Tonga",alias:["Pacific/Tongatapu"]},{name:"trist",description:"Istanbul, Turkey",alias:["Europe/Istanbul","Asia/Istanbul","Turkey"]},{name:"ttpos",description:"Port of Spain, Trinidad and Tobago",alias:["America/Port_of_Spain"]},{name:"tvfun",description:"Funafuti, Tuvalu",alias:["Pacific/Funafuti"]},{name:"twtpe",description:"Taipei, Taiwan",alias:["Asia/Taipei","ROC"]},{name:"tzdar",description:"Dar es Salaam, Tanzania",alias:["Africa/Dar_es_Salaam"]},{name:"uaiev",description:"Kiev, Ukraine",alias:["Europe/Kiev"]},{name:"uaozh",description:"Zaporizhia (Zaporozhye), Ukraine",alias:["Europe/Zaporozhye"]},{name:"uasip",description:"Simferopol, Ukraine",alias:["Europe/Simferopol"]},{name:"uauzh",description:"Uzhhorod (Uzhgorod), Ukraine",alias:["Europe/Uzhgorod"]},{name:"ugkla",description:"Kampala, Uganda",alias:["Africa/Kampala"]},{name:"umawk",description:"Wake Island, U.S. Minor Outlying Islands",alias:["Pacific/Wake"]},{name:"umjon",description:"Johnston Atoll, U.S. Minor Outlying Islands",alias:["Pacific/Johnston"]},{name:"ummdy",description:"Midway Islands, U.S. Minor Outlying Islands",alias:["Pacific/Midway"]},{name:"unk",description:"Unknown time zone",alias:["Etc/Unknown"]},{name:"usadk",description:"Adak (Alaska), United States",alias:["America/Adak","America/Atka","US/Aleutian"]},{name:"usaeg",description:"Marengo (Indiana), United States",alias:["America/Indiana/Marengo"]},{name:"usanc",description:"Anchorage, United States",alias:["America/Anchorage","US/Alaska"]},{name:"usboi",description:"Boise (Idaho), United States",alias:["America/Boise"]},{name:"uschi",description:"Chicago, United States",alias:["America/Chicago","US/Central"]},{name:"usden",description:"Denver, United States",alias:["America/Denver","America/Shiprock","Navajo","US/Mountain"]},{name:"usdet",description:"Detroit, United States",alias:["America/Detroit","US/Michigan"]},{name:"ushnl",description:"Honolulu, United States",alias:["Pacific/Honolulu","US/Hawaii"]},{name:"usind",description:"Indianapolis, United States",alias:["America/Indianapolis","America/Fort_Wayne","America/Indiana/Indianapolis","US/East-Indiana"]},{name:"usinvev",description:"Vevay (Indiana), United States",alias:["America/Indiana/Vevay"]},{name:"usjnu",description:"Juneau (Alaska), United States",alias:["America/Juneau"]},{name:"usknx",description:"Knox (Indiana), United States",alias:["America/Indiana/Knox","America/Knox_IN","US/Indiana-Starke"]},{name:"uslax",description:"Los Angeles, United States",alias:["America/Los_Angeles","US/Pacific","US/Pacific-New"]},{name:"uslui",description:"Louisville (Kentucky), United States",alias:["America/Louisville","America/Kentucky/Louisville"]},{name:"usmnm",description:"Menominee (Michigan), United States",alias:["America/Menominee"]},{name:"usmtm",description:"Metlakatla (Alaska), United States",alias:["America/Metlakatla"]},{name:"usmoc",description:"Monticello (Kentucky), United States",alias:["America/Kentucky/Monticello"]},{name:"usndcnt",description:"Center (North Dakota), United States",alias:["America/North_Dakota/Center"]},{name:"usndnsl",description:"New Salem (North Dakota), United States",alias:["America/North_Dakota/New_Salem"]},{name:"usnyc",description:"New York, United States",alias:["America/New_York","US/Eastern"]},{name:"usoea",description:"Vincennes (Indiana), United States",alias:["America/Indiana/Vincennes"]},{name:"usome",description:"Nome (Alaska), United States",alias:["America/Nome"]},{name:"usphx",description:"Phoenix, United States",alias:["America/Phoenix","US/Arizona"]},{name:"ussit",description:"Sitka (Alaska), United States",alias:["America/Sitka"]},{name:"ustel",description:"Tell City (Indiana), United States",alias:["America/Indiana/Tell_City"]},{name:"uswlz",description:"Winamac (Indiana), United States",alias:["America/Indiana/Winamac"]},{name:"uswsq",description:"Petersburg (Indiana), United States",alias:["America/Indiana/Petersburg"]},{name:"usxul",description:"Beulah (North Dakota), United States",alias:["America/North_Dakota/Beulah"]},{name:"usyak",description:"Yakutat (Alaska), United States",alias:["America/Yakutat"]},{name:"utc",description:"UTC (Coordinated Universal Time)",alias:["Etc/UTC","Etc/UCT","Etc/Universal","Etc/Zulu","UCT","UTC","Universal","Zulu"]},{name:"utce01",description:"1 hour ahead of UTC",alias:["Etc/GMT-1"]},{name:"utce02",description:"2 hours ahead of UTC",alias:["Etc/GMT-2"]},{name:"utce03",description:"3 hours ahead of UTC",alias:["Etc/GMT-3"]},{name:"utce04",description:"4 hours ahead of UTC",alias:["Etc/GMT-4"]},{name:"utce05",description:"5 hours ahead of UTC",alias:["Etc/GMT-5"]},{name:"utce06",description:"6 hours ahead of UTC",alias:["Etc/GMT-6"]},{name:"utce07",description:"7 hours ahead of UTC",alias:["Etc/GMT-7"]},{name:"utce08",description:"8 hours ahead of UTC",alias:["Etc/GMT-8"]},{name:"utce09",description:"9 hours ahead of UTC",alias:["Etc/GMT-9"]},{name:"utce10",description:"10 hours ahead of UTC",alias:["Etc/GMT-10"]},{name:"utce11",description:"11 hours ahead of UTC",alias:["Etc/GMT-11"]},{name:"utce12",description:"12 hours ahead of UTC",alias:["Etc/GMT-12"]},{name:"utce13",description:"13 hours ahead of UTC",alias:["Etc/GMT-13"]},{name:"utce14",description:"14 hours ahead of UTC",alias:["Etc/GMT-14"]},{name:"utcw01",description:"1 hour behind UTC",alias:["Etc/GMT+1"]},{name:"utcw02",description:"2 hours behind UTC",alias:["Etc/GMT+2"]},{name:"utcw03",description:"3 hours behind UTC",alias:["Etc/GMT+3"]},{name:"utcw04",description:"4 hours behind UTC",alias:["Etc/GMT+4"]},{name:"utcw05",description:"5 hours behind UTC",alias:["Etc/GMT+5","EST"]},{name:"utcw06",description:"6 hours behind UTC",alias:["Etc/GMT+6"]},{name:"utcw07",description:"7 hours behind UTC",alias:["Etc/GMT+7","MST"]},{name:"utcw08",description:"8 hours behind UTC",alias:["Etc/GMT+8"]},{name:"utcw09",description:"9 hours behind UTC",alias:["Etc/GMT+9"]},{name:"utcw10",description:"10 hours behind UTC",alias:["Etc/GMT+10","HST"]},{name:"utcw11",description:"11 hours behind UTC",alias:["Etc/GMT+11"]},{name:"utcw12",description:"12 hours behind UTC",alias:["Etc/GMT+12"]},{name:"uymvd",description:"Montevideo, Uruguay",alias:["America/Montevideo"]},{name:"uzskd",description:"Samarkand, Uzbekistan",alias:["Asia/Samarkand"]},{name:"uztas",description:"Tashkent, Uzbekistan",alias:["Asia/Tashkent"]},{name:"vavat",description:"Vatican City",alias:["Europe/Vatican"]},{name:"vcsvd",description:"Saint Vincent, Saint Vincent and the Grenadines",alias:["America/St_Vincent"]},{name:"veccs",description:"Caracas, Venezuela",alias:["America/Caracas"]},{name:"vgtov",description:"Tortola, British Virgin Islands",alias:["America/Tortola"]},{name:"vistt",description:"Saint Thomas, U.S. Virgin Islands",alias:["America/St_Thomas","America/Virgin"]},{name:"vnsgn",description:"Ho Chi Minh City, Vietnam",alias:["Asia/Saigon","Asia/Ho_Chi_Minh"]},{name:"vuvli",description:"Efate, Vanuatu",alias:["Pacific/Efate"]},{name:"wfmau",description:"Wallis Islands, Wallis and Futuna",alias:["Pacific/Wallis"]},{name:"wsapw",description:"Apia, Samoa",alias:["Pacific/Apia"]},{name:"yeade",description:"Aden, Yemen",alias:["Asia/Aden"]},{name:"ytmam",description:"Mayotte",alias:["Indian/Mayotte"]},{name:"zajnb",description:"Johannesburg, South Africa",alias:["Africa/Johannesburg"]},{name:"zmlun",description:"Lusaka, Zambia",alias:["Africa/Lusaka"]},{name:"zwhre",description:"Harare, Zimbabwe",alias:["Africa/Harare"]}],i=[{windowsName:"Dateline Standard Time",territory:"001",iana:["Etc/GMT+12"]},{windowsName:"Dateline Standard Time",territory:"ZZ",iana:["Etc/GMT+12"]},{windowsName:"UTC-11",territory:"001",iana:["Etc/GMT+11"]},{windowsName:"UTC-11",territory:"AS",iana:["Pacific/Pago_Pago"]},{windowsName:"UTC-11",territory:"NU",iana:["Pacific/Niue"]},{windowsName:"UTC-11",territory:"UM",iana:["Pacific/Midway"]},{windowsName:"UTC-11",territory:"ZZ",iana:["Etc/GMT+11"]},{windowsName:"Aleutian Standard Time",territory:"001",iana:["America/Adak"]},{windowsName:"Aleutian Standard Time",territory:"US",iana:["America/Adak"]},{windowsName:"Hawaiian Standard Time",territory:"001",iana:["Pacific/Honolulu"]},{windowsName:"Hawaiian Standard Time",territory:"CK",iana:["Pacific/Rarotonga"]},{windowsName:"Hawaiian Standard Time",territory:"PF",iana:["Pacific/Tahiti"]},{windowsName:"Hawaiian Standard Time",territory:"UM",iana:["Pacific/Johnston"]},{windowsName:"Hawaiian Standard Time",territory:"US",iana:["Pacific/Honolulu"]},{windowsName:"Hawaiian Standard Time",territory:"ZZ",iana:["Etc/GMT+10"]},{windowsName:"Marquesas Standard Time",territory:"001",iana:["Pacific/Marquesas"]},{windowsName:"Marquesas Standard Time",territory:"PF",iana:["Pacific/Marquesas"]},{windowsName:"Alaskan Standard Time",territory:"001",iana:["America/Anchorage"]},{windowsName:"Alaskan Standard Time",territory:"US",iana:["America/Anchorage","America/Juneau","America/Metlakatla","America/Nome","America/Sitka","America/Yakutat"]},{windowsName:"UTC-09",territory:"001",iana:["Etc/GMT+9"]},{windowsName:"UTC-09",territory:"PF",iana:["Pacific/Gambier"]},{windowsName:"UTC-09",territory:"ZZ",iana:["Etc/GMT+9"]},{windowsName:"Pacific Standard Time (Mexico)",territory:"001",iana:["America/Tijuana"]},{windowsName:"Pacific Standard Time (Mexico)",territory:"MX",iana:["America/Tijuana","America/Santa_Isabel"]},{windowsName:"UTC-08",territory:"001",iana:["Etc/GMT+8"]},{windowsName:"UTC-08",territory:"PN",iana:["Pacific/Pitcairn"]},{windowsName:"UTC-08",territory:"ZZ",iana:["Etc/GMT+8"]},{windowsName:"Pacific Standard Time",territory:"001",iana:["America/Los_Angeles"]},{windowsName:"Pacific Standard Time",territory:"CA",iana:["America/Vancouver"]},{windowsName:"Pacific Standard Time",territory:"US",iana:["America/Los_Angeles"]},{windowsName:"Pacific Standard Time",territory:"ZZ",iana:["PST8PDT"]},{windowsName:"US Mountain Standard Time",territory:"001",iana:["America/Phoenix"]},{windowsName:"US Mountain Standard Time",territory:"CA",iana:["America/Creston","America/Dawson_Creek","America/Fort_Nelson"]},{windowsName:"US Mountain Standard Time",territory:"MX",iana:["America/Hermosillo"]},{windowsName:"US Mountain Standard Time",territory:"US",iana:["America/Phoenix"]},{windowsName:"US Mountain Standard Time",territory:"ZZ",iana:["Etc/GMT+7"]},{windowsName:"Mountain Standard Time (Mexico)",territory:"001",iana:["America/Chihuahua"]},{windowsName:"Mountain Standard Time (Mexico)",territory:"MX",iana:["America/Chihuahua","America/Mazatlan"]},{windowsName:"Mountain Standard Time",territory:"001",iana:["America/Denver"]},{windowsName:"Mountain Standard Time",territory:"CA",iana:["America/Edmonton","America/Cambridge_Bay","America/Inuvik","America/Yellowknife"]},{windowsName:"Mountain Standard Time",territory:"MX",iana:["America/Ojinaga"]},{windowsName:"Mountain Standard Time",territory:"US",iana:["America/Denver","America/Boise"]},{windowsName:"Mountain Standard Time",territory:"ZZ",iana:["MST7MDT"]},{windowsName:"Yukon Standard Time",territory:"001",iana:["America/Whitehorse"]},{windowsName:"Yukon Standard Time",territory:"CA",iana:["America/Whitehorse","America/Dawson"]},{windowsName:"Central America Standard Time",territory:"001",iana:["America/Guatemala"]},{windowsName:"Central America Standard Time",territory:"BZ",iana:["America/Belize"]},{windowsName:"Central America Standard Time",territory:"CR",iana:["America/Costa_Rica"]},{windowsName:"Central America Standard Time",territory:"EC",iana:["Pacific/Galapagos"]},{windowsName:"Central America Standard Time",territory:"GT",iana:["America/Guatemala"]},{windowsName:"Central America Standard Time",territory:"HN",iana:["America/Tegucigalpa"]},{windowsName:"Central America Standard Time",territory:"NI",iana:["America/Managua"]},{windowsName:"Central America Standard Time",territory:"SV",iana:["America/El_Salvador"]},{windowsName:"Central America Standard Time",territory:"ZZ",iana:["Etc/GMT+6"]},{windowsName:"Central Standard Time",territory:"001",iana:["America/Chicago"]},{windowsName:"Central Standard Time",territory:"CA",iana:["America/Winnipeg","America/Rainy_River","America/Rankin_Inlet","America/Resolute"]},{windowsName:"Central Standard Time",territory:"MX",iana:["America/Matamoros"]},{windowsName:"Central Standard Time",territory:"US",iana:["America/Chicago","America/Indiana/Knox","America/Indiana/Tell_City","America/Menominee","America/North_Dakota/Beulah","America/North_Dakota/Center","America/North_Dakota/New_Salem"]},{windowsName:"Central Standard Time",territory:"ZZ",iana:["CST6CDT"]},{windowsName:"Easter Island Standard Time",territory:"001",iana:["Pacific/Easter"]},{windowsName:"Easter Island Standard Time",territory:"CL",iana:["Pacific/Easter"]},{windowsName:"Central Standard Time (Mexico)",territory:"001",iana:["America/Mexico_City"]},{windowsName:"Central Standard Time (Mexico)",territory:"MX",iana:["America/Mexico_City","America/Bahia_Banderas","America/Merida","America/Monterrey"]},{windowsName:"Canada Central Standard Time",territory:"001",iana:["America/Regina"]},{windowsName:"Canada Central Standard Time",territory:"CA",iana:["America/Regina","America/Swift_Current"]},{windowsName:"SA Pacific Standard Time",territory:"001",iana:["America/Bogota"]},{windowsName:"SA Pacific Standard Time",territory:"BR",iana:["America/Rio_Branco","America/Eirunepe"]},{windowsName:"SA Pacific Standard Time",territory:"CA",iana:["America/Coral_Harbour"]},{windowsName:"SA Pacific Standard Time",territory:"CO",iana:["America/Bogota"]},{windowsName:"SA Pacific Standard Time",territory:"EC",iana:["America/Guayaquil"]},{windowsName:"SA Pacific Standard Time",territory:"JM",iana:["America/Jamaica"]},{windowsName:"SA Pacific Standard Time",territory:"KY",iana:["America/Cayman"]},{windowsName:"SA Pacific Standard Time",territory:"PA",iana:["America/Panama"]},{windowsName:"SA Pacific Standard Time",territory:"PE",iana:["America/Lima"]},{windowsName:"SA Pacific Standard Time",territory:"ZZ",iana:["Etc/GMT+5"]},{windowsName:"Eastern Standard Time (Mexico)",territory:"001",iana:["America/Cancun"]},{windowsName:"Eastern Standard Time (Mexico)",territory:"MX",iana:["America/Cancun"]},{windowsName:"Eastern Standard Time",territory:"001",iana:["America/New_York"]},{windowsName:"Eastern Standard Time",territory:"BS",iana:["America/Nassau"]},{windowsName:"Eastern Standard Time",territory:"CA",iana:["America/Toronto","America/Iqaluit","America/Montreal","America/Nipigon","America/Pangnirtung","America/Thunder_Bay"]},{windowsName:"Eastern Standard Time",territory:"US",iana:["America/New_York","America/Detroit","America/Indiana/Petersburg","America/Indiana/Vincennes","America/Indiana/Winamac","America/Kentucky/Monticello","America/Louisville"]},{windowsName:"Eastern Standard Time",territory:"ZZ",iana:["EST5EDT"]},{windowsName:"Haiti Standard Time",territory:"001",iana:["America/Port-au-Prince"]},{windowsName:"Haiti Standard Time",territory:"HT",iana:["America/Port-au-Prince"]},{windowsName:"Cuba Standard Time",territory:"001",iana:["America/Havana"]},{windowsName:"Cuba Standard Time",territory:"CU",iana:["America/Havana"]},{windowsName:"US Eastern Standard Time",territory:"001",iana:["America/Indianapolis"]},{windowsName:"US Eastern Standard Time",territory:"US",iana:["America/Indianapolis","America/Indiana/Marengo","America/Indiana/Vevay"]},{windowsName:"Turks And Caicos Standard Time",territory:"001",iana:["America/Grand_Turk"]},{windowsName:"Turks And Caicos Standard Time",territory:"TC",iana:["America/Grand_Turk"]},{windowsName:"Paraguay Standard Time",territory:"001",iana:["America/Asuncion"]},{windowsName:"Paraguay Standard Time",territory:"PY",iana:["America/Asuncion"]},{windowsName:"Atlantic Standard Time",territory:"001",iana:["America/Halifax"]},{windowsName:"Atlantic Standard Time",territory:"BM",iana:["Atlantic/Bermuda"]},{windowsName:"Atlantic Standard Time",territory:"CA",iana:["America/Halifax","America/Glace_Bay","America/Goose_Bay","America/Moncton"]},{windowsName:"Atlantic Standard Time",territory:"GL",iana:["America/Thule"]},{windowsName:"Venezuela Standard Time",territory:"001",iana:["America/Caracas"]},{windowsName:"Venezuela Standard Time",territory:"VE",iana:["America/Caracas"]},{windowsName:"Central Brazilian Standard Time",territory:"001",iana:["America/Cuiaba"]},{windowsName:"Central Brazilian Standard Time",territory:"BR",iana:["America/Cuiaba","America/Campo_Grande"]},{windowsName:"SA Western Standard Time",territory:"001",iana:["America/La_Paz"]},{windowsName:"SA Western Standard Time",territory:"AG",iana:["America/Antigua"]},{windowsName:"SA Western Standard Time",territory:"AI",iana:["America/Anguilla"]},{windowsName:"SA Western Standard Time",territory:"AW",iana:["America/Aruba"]},{windowsName:"SA Western Standard Time",territory:"BB",iana:["America/Barbados"]},{windowsName:"SA Western Standard Time",territory:"BL",iana:["America/St_Barthelemy"]},{windowsName:"SA Western Standard Time",territory:"BO",iana:["America/La_Paz"]},{windowsName:"SA Western Standard Time",territory:"BQ",iana:["America/Kralendijk"]},{windowsName:"SA Western Standard Time",territory:"BR",iana:["America/Manaus","America/Boa_Vista","America/Porto_Velho"]},{windowsName:"SA Western Standard Time",territory:"CA",iana:["America/Blanc-Sablon"]},{windowsName:"SA Western Standard Time",territory:"CW",iana:["America/Curacao"]},{windowsName:"SA Western Standard Time",territory:"DM",iana:["America/Dominica"]},{windowsName:"SA Western Standard Time",territory:"DO",iana:["America/Santo_Domingo"]},{windowsName:"SA Western Standard Time",territory:"GD",iana:["America/Grenada"]},{windowsName:"SA Western Standard Time",territory:"GP",iana:["America/Guadeloupe"]},{windowsName:"SA Western Standard Time",territory:"GY",iana:["America/Guyana"]},{windowsName:"SA Western Standard Time",territory:"KN",iana:["America/St_Kitts"]},{windowsName:"SA Western Standard Time",territory:"LC",iana:["America/St_Lucia"]},{windowsName:"SA Western Standard Time",territory:"MF",iana:["America/Marigot"]},{windowsName:"SA Western Standard Time",territory:"MQ",iana:["America/Martinique"]},{windowsName:"SA Western Standard Time",territory:"MS",iana:["America/Montserrat"]},{windowsName:"SA Western Standard Time",territory:"PR",iana:["America/Puerto_Rico"]},{windowsName:"SA Western Standard Time",territory:"SX",iana:["America/Lower_Princes"]},{windowsName:"SA Western Standard Time",territory:"TT",iana:["America/Port_of_Spain"]},{windowsName:"SA Western Standard Time",territory:"VC",iana:["America/St_Vincent"]},{windowsName:"SA Western Standard Time",territory:"VG",iana:["America/Tortola"]},{windowsName:"SA Western Standard Time",territory:"VI",iana:["America/St_Thomas"]},{windowsName:"SA Western Standard Time",territory:"ZZ",iana:["Etc/GMT+4"]},{windowsName:"Pacific SA Standard Time",territory:"001",iana:["America/Santiago"]},{windowsName:"Pacific SA Standard Time",territory:"CL",iana:["America/Santiago"]},{windowsName:"Newfoundland Standard Time",territory:"001",iana:["America/St_Johns"]},{windowsName:"Newfoundland Standard Time",territory:"CA",iana:["America/St_Johns"]},{windowsName:"Tocantins Standard Time",territory:"001",iana:["America/Araguaina"]},{windowsName:"Tocantins Standard Time",territory:"BR",iana:["America/Araguaina"]},{windowsName:"E. South America Standard Time",territory:"001",iana:["America/Sao_Paulo"]},{windowsName:"E. South America Standard Time",territory:"BR",iana:["America/Sao_Paulo"]},{windowsName:"SA Eastern Standard Time",territory:"001",iana:["America/Cayenne"]},{windowsName:"SA Eastern Standard Time",territory:"AQ",iana:["Antarctica/Rothera","Antarctica/Palmer"]},{windowsName:"SA Eastern Standard Time",territory:"BR",iana:["America/Fortaleza","America/Belem","America/Maceio","America/Recife","America/Santarem"]},{windowsName:"SA Eastern Standard Time",territory:"FK",iana:["Atlantic/Stanley"]},{windowsName:"SA Eastern Standard Time",territory:"GF",iana:["America/Cayenne"]},{windowsName:"SA Eastern Standard Time",territory:"SR",iana:["America/Paramaribo"]},{windowsName:"SA Eastern Standard Time",territory:"ZZ",iana:["Etc/GMT+3"]},{windowsName:"Argentina Standard Time",territory:"001",iana:["America/Buenos_Aires"]},{windowsName:"Argentina Standard Time",territory:"AR",iana:["America/Buenos_Aires","America/Argentina/La_Rioja","America/Argentina/Rio_Gallegos","America/Argentina/Salta","America/Argentina/San_Juan","America/Argentina/San_Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Catamarca","America/Cordoba","America/Jujuy","America/Mendoza"]},{windowsName:"Greenland Standard Time",territory:"001",iana:["America/Godthab"]},{windowsName:"Greenland Standard Time",territory:"GL",iana:["America/Godthab"]},{windowsName:"Montevideo Standard Time",territory:"001",iana:["America/Montevideo"]},{windowsName:"Montevideo Standard Time",territory:"UY",iana:["America/Montevideo"]},{windowsName:"Magallanes Standard Time",territory:"001",iana:["America/Punta_Arenas"]},{windowsName:"Magallanes Standard Time",territory:"CL",iana:["America/Punta_Arenas"]},{windowsName:"Saint Pierre Standard Time",territory:"001",iana:["America/Miquelon"]},{windowsName:"Saint Pierre Standard Time",territory:"PM",iana:["America/Miquelon"]},{windowsName:"Bahia Standard Time",territory:"001",iana:["America/Bahia"]},{windowsName:"Bahia Standard Time",territory:"BR",iana:["America/Bahia"]},{windowsName:"UTC-02",territory:"001",iana:["Etc/GMT+2"]},{windowsName:"UTC-02",territory:"BR",iana:["America/Noronha"]},{windowsName:"UTC-02",territory:"GS",iana:["Atlantic/South_Georgia"]},{windowsName:"UTC-02",territory:"ZZ",iana:["Etc/GMT+2"]},{windowsName:"Azores Standard Time",territory:"001",iana:["Atlantic/Azores"]},{windowsName:"Azores Standard Time",territory:"GL",iana:["America/Scoresbysund"]},{windowsName:"Azores Standard Time",territory:"PT",iana:["Atlantic/Azores"]},{windowsName:"Cape Verde Standard Time",territory:"001",iana:["Atlantic/Cape_Verde"]},{windowsName:"Cape Verde Standard Time",territory:"CV",iana:["Atlantic/Cape_Verde"]},{windowsName:"Cape Verde Standard Time",territory:"ZZ",iana:["Etc/GMT+1"]},{windowsName:"UTC",territory:"001",iana:["Etc/UTC"]},{windowsName:"UTC",territory:"ZZ",iana:["Etc/UTC","Etc/GMT"]},{windowsName:"GMT Standard Time",territory:"001",iana:["Europe/London"]},{windowsName:"GMT Standard Time",territory:"ES",iana:["Atlantic/Canary"]},{windowsName:"GMT Standard Time",territory:"FO",iana:["Atlantic/Faeroe"]},{windowsName:"GMT Standard Time",territory:"GB",iana:["Europe/London"]},{windowsName:"GMT Standard Time",territory:"GG",iana:["Europe/Guernsey"]},{windowsName:"GMT Standard Time",territory:"IE",iana:["Europe/Dublin"]},{windowsName:"GMT Standard Time",territory:"IM",iana:["Europe/Isle_of_Man"]},{windowsName:"GMT Standard Time",territory:"JE",iana:["Europe/Jersey"]},{windowsName:"GMT Standard Time",territory:"PT",iana:["Europe/Lisbon","Atlantic/Madeira"]},{windowsName:"Greenwich Standard Time",territory:"001",iana:["Atlantic/Reykjavik"]},{windowsName:"Greenwich Standard Time",territory:"BF",iana:["Africa/Ouagadougou"]},{windowsName:"Greenwich Standard Time",territory:"CI",iana:["Africa/Abidjan"]},{windowsName:"Greenwich Standard Time",territory:"GH",iana:["Africa/Accra"]},{windowsName:"Greenwich Standard Time",territory:"GL",iana:["America/Danmarkshavn"]},{windowsName:"Greenwich Standard Time",territory:"GM",iana:["Africa/Banjul"]},{windowsName:"Greenwich Standard Time",territory:"GN",iana:["Africa/Conakry"]},{windowsName:"Greenwich Standard Time",territory:"GW",iana:["Africa/Bissau"]},{windowsName:"Greenwich Standard Time",territory:"IS",iana:["Atlantic/Reykjavik"]},{windowsName:"Greenwich Standard Time",territory:"LR",iana:["Africa/Monrovia"]},{windowsName:"Greenwich Standard Time",territory:"ML",iana:["Africa/Bamako"]},{windowsName:"Greenwich Standard Time",territory:"MR",iana:["Africa/Nouakchott"]},{windowsName:"Greenwich Standard Time",territory:"SH",iana:["Atlantic/St_Helena"]},{windowsName:"Greenwich Standard Time",territory:"SL",iana:["Africa/Freetown"]},{windowsName:"Greenwich Standard Time",territory:"SN",iana:["Africa/Dakar"]},{windowsName:"Greenwich Standard Time",territory:"TG",iana:["Africa/Lome"]},{windowsName:"Sao Tome Standard Time",territory:"001",iana:["Africa/Sao_Tome"]},{windowsName:"Sao Tome Standard Time",territory:"ST",iana:["Africa/Sao_Tome"]},{windowsName:"Morocco Standard Time",territory:"001",iana:["Africa/Casablanca"]},{windowsName:"Morocco Standard Time",territory:"EH",iana:["Africa/El_Aaiun"]},{windowsName:"Morocco Standard Time",territory:"MA",iana:["Africa/Casablanca"]},{windowsName:"W. Europe Standard Time",territory:"001",iana:["Europe/Berlin"]},{windowsName:"W. Europe Standard Time",territory:"AD",iana:["Europe/Andorra"]},{windowsName:"W. Europe Standard Time",territory:"AT",iana:["Europe/Vienna"]},{windowsName:"W. Europe Standard Time",territory:"CH",iana:["Europe/Zurich"]},{windowsName:"W. Europe Standard Time",territory:"DE",iana:["Europe/Berlin","Europe/Busingen"]},{windowsName:"W. Europe Standard Time",territory:"GI",iana:["Europe/Gibraltar"]},{windowsName:"W. Europe Standard Time",territory:"IT",iana:["Europe/Rome"]},{windowsName:"W. Europe Standard Time",territory:"LI",iana:["Europe/Vaduz"]},{windowsName:"W. Europe Standard Time",territory:"LU",iana:["Europe/Luxembourg"]},{windowsName:"W. Europe Standard Time",territory:"MC",iana:["Europe/Monaco"]},{windowsName:"W. Europe Standard Time",territory:"MT",iana:["Europe/Malta"]},{windowsName:"W. Europe Standard Time",territory:"NL",iana:["Europe/Amsterdam"]},{windowsName:"W. Europe Standard Time",territory:"NO",iana:["Europe/Oslo"]},{windowsName:"W. Europe Standard Time",territory:"SE",iana:["Europe/Stockholm"]},{windowsName:"W. Europe Standard Time",territory:"SJ",iana:["Arctic/Longyearbyen"]},{windowsName:"W. Europe Standard Time",territory:"SM",iana:["Europe/San_Marino"]},{windowsName:"W. Europe Standard Time",territory:"VA",iana:["Europe/Vatican"]},{windowsName:"Central Europe Standard Time",territory:"001",iana:["Europe/Budapest"]},{windowsName:"Central Europe Standard Time",territory:"AL",iana:["Europe/Tirane"]},{windowsName:"Central Europe Standard Time",territory:"CZ",iana:["Europe/Prague"]},{windowsName:"Central Europe Standard Time",territory:"HU",iana:["Europe/Budapest"]},{windowsName:"Central Europe Standard Time",territory:"ME",iana:["Europe/Podgorica"]},{windowsName:"Central Europe Standard Time",territory:"RS",iana:["Europe/Belgrade"]},{windowsName:"Central Europe Standard Time",territory:"SI",iana:["Europe/Ljubljana"]},{windowsName:"Central Europe Standard Time",territory:"SK",iana:["Europe/Bratislava"]},{windowsName:"Romance Standard Time",territory:"001",iana:["Europe/Paris"]},{windowsName:"Romance Standard Time",territory:"BE",iana:["Europe/Brussels"]},{windowsName:"Romance Standard Time",territory:"DK",iana:["Europe/Copenhagen"]},{windowsName:"Romance Standard Time",territory:"ES",iana:["Europe/Madrid","Africa/Ceuta"]},{windowsName:"Romance Standard Time",territory:"FR",iana:["Europe/Paris"]},{windowsName:"Central European Standard Time",territory:"001",iana:["Europe/Warsaw"]},{windowsName:"Central European Standard Time",territory:"BA",iana:["Europe/Sarajevo"]},{windowsName:"Central European Standard Time",territory:"HR",iana:["Europe/Zagreb"]},{windowsName:"Central European Standard Time",territory:"MK",iana:["Europe/Skopje"]},{windowsName:"Central European Standard Time",territory:"PL",iana:["Europe/Warsaw"]},{windowsName:"W. Central Africa Standard Time",territory:"001",iana:["Africa/Lagos"]},{windowsName:"W. Central Africa Standard Time",territory:"AO",iana:["Africa/Luanda"]},{windowsName:"W. Central Africa Standard Time",territory:"BJ",iana:["Africa/Porto-Novo"]},{windowsName:"W. Central Africa Standard Time",territory:"CD",iana:["Africa/Kinshasa"]},{windowsName:"W. Central Africa Standard Time",territory:"CF",iana:["Africa/Bangui"]},{windowsName:"W. Central Africa Standard Time",territory:"CG",iana:["Africa/Brazzaville"]},{windowsName:"W. Central Africa Standard Time",territory:"CM",iana:["Africa/Douala"]},{windowsName:"W. Central Africa Standard Time",territory:"DZ",iana:["Africa/Algiers"]},{windowsName:"W. Central Africa Standard Time",territory:"GA",iana:["Africa/Libreville"]},{windowsName:"W. Central Africa Standard Time",territory:"GQ",iana:["Africa/Malabo"]},{windowsName:"W. Central Africa Standard Time",territory:"NE",iana:["Africa/Niamey"]},{windowsName:"W. Central Africa Standard Time",territory:"NG",iana:["Africa/Lagos"]},{windowsName:"W. Central Africa Standard Time",territory:"TD",iana:["Africa/Ndjamena"]},{windowsName:"W. Central Africa Standard Time",territory:"TN",iana:["Africa/Tunis"]},{windowsName:"W. Central Africa Standard Time",territory:"ZZ",iana:["Etc/GMT-1"]},{windowsName:"Jordan Standard Time",territory:"001",iana:["Asia/Amman"]},{windowsName:"Jordan Standard Time",territory:"JO",iana:["Asia/Amman"]},{windowsName:"GTB Standard Time",territory:"001",iana:["Europe/Bucharest"]},{windowsName:"GTB Standard Time",territory:"CY",iana:["Asia/Nicosia","Asia/Famagusta"]},{windowsName:"GTB Standard Time",territory:"GR",iana:["Europe/Athens"]},{windowsName:"GTB Standard Time",territory:"RO",iana:["Europe/Bucharest"]},{windowsName:"Middle East Standard Time",territory:"001",iana:["Asia/Beirut"]},{windowsName:"Middle East Standard Time",territory:"LB",iana:["Asia/Beirut"]},{windowsName:"Egypt Standard Time",territory:"001",iana:["Africa/Cairo"]},{windowsName:"Egypt Standard Time",territory:"EG",iana:["Africa/Cairo"]},{windowsName:"E. Europe Standard Time",territory:"001",iana:["Europe/Chisinau"]},{windowsName:"E. Europe Standard Time",territory:"MD",iana:["Europe/Chisinau"]},{windowsName:"Syria Standard Time",territory:"001",iana:["Asia/Damascus"]},{windowsName:"Syria Standard Time",territory:"SY",iana:["Asia/Damascus"]},{windowsName:"West Bank Standard Time",territory:"001",iana:["Asia/Hebron"]},{windowsName:"West Bank Standard Time",territory:"PS",iana:["Asia/Hebron","Asia/Gaza"]},{windowsName:"South Africa Standard Time",territory:"001",iana:["Africa/Johannesburg"]},{windowsName:"South Africa Standard Time",territory:"BI",iana:["Africa/Bujumbura"]},{windowsName:"South Africa Standard Time",territory:"BW",iana:["Africa/Gaborone"]},{windowsName:"South Africa Standard Time",territory:"CD",iana:["Africa/Lubumbashi"]},{windowsName:"South Africa Standard Time",territory:"LS",iana:["Africa/Maseru"]},{windowsName:"South Africa Standard Time",territory:"MW",iana:["Africa/Blantyre"]},{windowsName:"South Africa Standard Time",territory:"MZ",iana:["Africa/Maputo"]},{windowsName:"South Africa Standard Time",territory:"RW",iana:["Africa/Kigali"]},{windowsName:"South Africa Standard Time",territory:"SZ",iana:["Africa/Mbabane"]},{windowsName:"South Africa Standard Time",territory:"ZA",iana:["Africa/Johannesburg"]},{windowsName:"South Africa Standard Time",territory:"ZM",iana:["Africa/Lusaka"]},{windowsName:"South Africa Standard Time",territory:"ZW",iana:["Africa/Harare"]},{windowsName:"South Africa Standard Time",territory:"ZZ",iana:["Etc/GMT-2"]},{windowsName:"FLE Standard Time",territory:"001",iana:["Europe/Kiev"]},{windowsName:"FLE Standard Time",territory:"AX",iana:["Europe/Mariehamn"]},{windowsName:"FLE Standard Time",territory:"BG",iana:["Europe/Sofia"]},{windowsName:"FLE Standard Time",territory:"EE",iana:["Europe/Tallinn"]},{windowsName:"FLE Standard Time",territory:"FI",iana:["Europe/Helsinki"]},{windowsName:"FLE Standard Time",territory:"LT",iana:["Europe/Vilnius"]},{windowsName:"FLE Standard Time",territory:"LV",iana:["Europe/Riga"]},{windowsName:"FLE Standard Time",territory:"UA",iana:["Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye"]},{windowsName:"Israel Standard Time",territory:"001",iana:["Asia/Jerusalem"]},{windowsName:"Israel Standard Time",territory:"IL",iana:["Asia/Jerusalem"]},{windowsName:"South Sudan Standard Time",territory:"001",iana:["Africa/Juba"]},{windowsName:"South Sudan Standard Time",territory:"SS",iana:["Africa/Juba"]},{windowsName:"Kaliningrad Standard Time",territory:"001",iana:["Europe/Kaliningrad"]},{windowsName:"Kaliningrad Standard Time",territory:"RU",iana:["Europe/Kaliningrad"]},{windowsName:"Sudan Standard Time",territory:"001",iana:["Africa/Khartoum"]},{windowsName:"Sudan Standard Time",territory:"SD",iana:["Africa/Khartoum"]},{windowsName:"Libya Standard Time",territory:"001",iana:["Africa/Tripoli"]},{windowsName:"Libya Standard Time",territory:"LY",iana:["Africa/Tripoli"]},{windowsName:"Namibia Standard Time",territory:"001",iana:["Africa/Windhoek"]},{windowsName:"Namibia Standard Time",territory:"NA",iana:["Africa/Windhoek"]},{windowsName:"Arabic Standard Time",territory:"001",iana:["Asia/Baghdad"]},{windowsName:"Arabic Standard Time",territory:"IQ",iana:["Asia/Baghdad"]},{windowsName:"Turkey Standard Time",territory:"001",iana:["Europe/Istanbul"]},{windowsName:"Turkey Standard Time",territory:"TR",iana:["Europe/Istanbul"]},{windowsName:"Arab Standard Time",territory:"001",iana:["Asia/Riyadh"]},{windowsName:"Arab Standard Time",territory:"BH",iana:["Asia/Bahrain"]},{windowsName:"Arab Standard Time",territory:"KW",iana:["Asia/Kuwait"]},{windowsName:"Arab Standard Time",territory:"QA",iana:["Asia/Qatar"]},{windowsName:"Arab Standard Time",territory:"SA",iana:["Asia/Riyadh"]},{windowsName:"Arab Standard Time",territory:"YE",iana:["Asia/Aden"]},{windowsName:"Belarus Standard Time",territory:"001",iana:["Europe/Minsk"]},{windowsName:"Belarus Standard Time",territory:"BY",iana:["Europe/Minsk"]},{windowsName:"Russian Standard Time",territory:"001",iana:["Europe/Moscow"]},{windowsName:"Russian Standard Time",territory:"RU",iana:["Europe/Moscow","Europe/Kirov"]},{windowsName:"Russian Standard Time",territory:"UA",iana:["Europe/Simferopol"]},{windowsName:"E. Africa Standard Time",territory:"001",iana:["Africa/Nairobi"]},{windowsName:"E. Africa Standard Time",territory:"AQ",iana:["Antarctica/Syowa"]},{windowsName:"E. Africa Standard Time",territory:"DJ",iana:["Africa/Djibouti"]},{windowsName:"E. Africa Standard Time",territory:"ER",iana:["Africa/Asmera"]},{windowsName:"E. Africa Standard Time",territory:"ET",iana:["Africa/Addis_Ababa"]},{windowsName:"E. Africa Standard Time",territory:"KE",iana:["Africa/Nairobi"]},{windowsName:"E. Africa Standard Time",territory:"KM",iana:["Indian/Comoro"]},{windowsName:"E. Africa Standard Time",territory:"MG",iana:["Indian/Antananarivo"]},{windowsName:"E. Africa Standard Time",territory:"SO",iana:["Africa/Mogadishu"]},{windowsName:"E. Africa Standard Time",territory:"TZ",iana:["Africa/Dar_es_Salaam"]},{windowsName:"E. Africa Standard Time",territory:"UG",iana:["Africa/Kampala"]},{windowsName:"E. Africa Standard Time",territory:"YT",iana:["Indian/Mayotte"]},{windowsName:"E. Africa Standard Time",territory:"ZZ",iana:["Etc/GMT-3"]},{windowsName:"Iran Standard Time",territory:"001",iana:["Asia/Tehran"]},{windowsName:"Iran Standard Time",territory:"IR",iana:["Asia/Tehran"]},{windowsName:"Arabian Standard Time",territory:"001",iana:["Asia/Dubai"]},{windowsName:"Arabian Standard Time",territory:"AE",iana:["Asia/Dubai"]},{windowsName:"Arabian Standard Time",territory:"OM",iana:["Asia/Muscat"]},{windowsName:"Arabian Standard Time",territory:"ZZ",iana:["Etc/GMT-4"]},{windowsName:"Astrakhan Standard Time",territory:"001",iana:["Europe/Astrakhan"]},{windowsName:"Astrakhan Standard Time",territory:"RU",iana:["Europe/Astrakhan","Europe/Ulyanovsk"]},{windowsName:"Azerbaijan Standard Time",territory:"001",iana:["Asia/Baku"]},{windowsName:"Azerbaijan Standard Time",territory:"AZ",iana:["Asia/Baku"]},{windowsName:"Russia Time Zone 3",territory:"001",iana:["Europe/Samara"]},{windowsName:"Russia Time Zone 3",territory:"RU",iana:["Europe/Samara"]},{windowsName:"Mauritius Standard Time",territory:"001",iana:["Indian/Mauritius"]},{windowsName:"Mauritius Standard Time",territory:"MU",iana:["Indian/Mauritius"]},{windowsName:"Mauritius Standard Time",territory:"RE",iana:["Indian/Reunion"]},{windowsName:"Mauritius Standard Time",territory:"SC",iana:["Indian/Mahe"]},{windowsName:"Saratov Standard Time",territory:"001",iana:["Europe/Saratov"]},{windowsName:"Saratov Standard Time",territory:"RU",iana:["Europe/Saratov"]},{windowsName:"Georgian Standard Time",territory:"001",iana:["Asia/Tbilisi"]},{windowsName:"Georgian Standard Time",territory:"GE",iana:["Asia/Tbilisi"]},{windowsName:"Volgograd Standard Time",territory:"001",iana:["Europe/Volgograd"]},{windowsName:"Volgograd Standard Time",territory:"RU",iana:["Europe/Volgograd"]},{windowsName:"Caucasus Standard Time",territory:"001",iana:["Asia/Yerevan"]},{windowsName:"Caucasus Standard Time",territory:"AM",iana:["Asia/Yerevan"]},{windowsName:"Afghanistan Standard Time",territory:"001",iana:["Asia/Kabul"]},{windowsName:"Afghanistan Standard Time",territory:"AF",iana:["Asia/Kabul"]},{windowsName:"West Asia Standard Time",territory:"001",iana:["Asia/Tashkent"]},{windowsName:"West Asia Standard Time",territory:"AQ",iana:["Antarctica/Mawson"]},{windowsName:"West Asia Standard Time",territory:"KZ",iana:["Asia/Oral","Asia/Aqtau","Asia/Aqtobe","Asia/Atyrau"]},{windowsName:"West Asia Standard Time",territory:"MV",iana:["Indian/Maldives"]},{windowsName:"West Asia Standard Time",territory:"TF",iana:["Indian/Kerguelen"]},{windowsName:"West Asia Standard Time",territory:"TJ",iana:["Asia/Dushanbe"]},{windowsName:"West Asia Standard Time",territory:"TM",iana:["Asia/Ashgabat"]},{windowsName:"West Asia Standard Time",territory:"UZ",iana:["Asia/Tashkent","Asia/Samarkand"]},{windowsName:"West Asia Standard Time",territory:"ZZ",iana:["Etc/GMT-5"]},{windowsName:"Ekaterinburg Standard Time",territory:"001",iana:["Asia/Yekaterinburg"]},{windowsName:"Ekaterinburg Standard Time",territory:"RU",iana:["Asia/Yekaterinburg"]},{windowsName:"Pakistan Standard Time",territory:"001",iana:["Asia/Karachi"]},{windowsName:"Pakistan Standard Time",territory:"PK",iana:["Asia/Karachi"]},{windowsName:"Qyzylorda Standard Time",territory:"001",iana:["Asia/Qyzylorda"]},{windowsName:"Qyzylorda Standard Time",territory:"KZ",iana:["Asia/Qyzylorda"]},{windowsName:"India Standard Time",territory:"001",iana:["Asia/Calcutta"]},{windowsName:"India Standard Time",territory:"IN",iana:["Asia/Calcutta"]},{windowsName:"Sri Lanka Standard Time",territory:"001",iana:["Asia/Colombo"]},{windowsName:"Sri Lanka Standard Time",territory:"LK",iana:["Asia/Colombo"]},{windowsName:"Nepal Standard Time",territory:"001",iana:["Asia/Katmandu"]},{windowsName:"Nepal Standard Time",territory:"NP",iana:["Asia/Katmandu"]},{windowsName:"Central Asia Standard Time",territory:"001",iana:["Asia/Almaty"]},{windowsName:"Central Asia Standard Time",territory:"AQ",iana:["Antarctica/Vostok"]},{windowsName:"Central Asia Standard Time",territory:"CN",iana:["Asia/Urumqi"]},{windowsName:"Central Asia Standard Time",territory:"IO",iana:["Indian/Chagos"]},{windowsName:"Central Asia Standard Time",territory:"KG",iana:["Asia/Bishkek"]},{windowsName:"Central Asia Standard Time",territory:"KZ",iana:["Asia/Almaty","Asia/Qostanay"]},{windowsName:"Central Asia Standard Time",territory:"ZZ",iana:["Etc/GMT-6"]},{windowsName:"Bangladesh Standard Time",territory:"001",iana:["Asia/Dhaka"]},{windowsName:"Bangladesh Standard Time",territory:"BD",iana:["Asia/Dhaka"]},{windowsName:"Bangladesh Standard Time",territory:"BT",iana:["Asia/Thimphu"]},{windowsName:"Omsk Standard Time",territory:"001",iana:["Asia/Omsk"]},{windowsName:"Omsk Standard Time",territory:"RU",iana:["Asia/Omsk"]},{windowsName:"Myanmar Standard Time",territory:"001",iana:["Asia/Rangoon"]},{windowsName:"Myanmar Standard Time",territory:"CC",iana:["Indian/Cocos"]},{windowsName:"Myanmar Standard Time",territory:"MM",iana:["Asia/Rangoon"]},{windowsName:"SE Asia Standard Time",territory:"001",iana:["Asia/Bangkok"]},{windowsName:"SE Asia Standard Time",territory:"AQ",iana:["Antarctica/Davis"]},{windowsName:"SE Asia Standard Time",territory:"CX",iana:["Indian/Christmas"]},{windowsName:"SE Asia Standard Time",territory:"ID",iana:["Asia/Jakarta","Asia/Pontianak"]},{windowsName:"SE Asia Standard Time",territory:"KH",iana:["Asia/Phnom_Penh"]},{windowsName:"SE Asia Standard Time",territory:"LA",iana:["Asia/Vientiane"]},{windowsName:"SE Asia Standard Time",territory:"TH",iana:["Asia/Bangkok"]},{windowsName:"SE Asia Standard Time",territory:"VN",iana:["Asia/Saigon"]},{windowsName:"SE Asia Standard Time",territory:"ZZ",iana:["Etc/GMT-7"]},{windowsName:"Altai Standard Time",territory:"001",iana:["Asia/Barnaul"]},{windowsName:"Altai Standard Time",territory:"RU",iana:["Asia/Barnaul"]},{windowsName:"W. Mongolia Standard Time",territory:"001",iana:["Asia/Hovd"]},{windowsName:"W. Mongolia Standard Time",territory:"MN",iana:["Asia/Hovd"]},{windowsName:"North Asia Standard Time",territory:"001",iana:["Asia/Krasnoyarsk"]},{windowsName:"North Asia Standard Time",territory:"RU",iana:["Asia/Krasnoyarsk","Asia/Novokuznetsk"]},{windowsName:"N. Central Asia Standard Time",territory:"001",iana:["Asia/Novosibirsk"]},{windowsName:"N. Central Asia Standard Time",territory:"RU",iana:["Asia/Novosibirsk"]},{windowsName:"Tomsk Standard Time",territory:"001",iana:["Asia/Tomsk"]},{windowsName:"Tomsk Standard Time",territory:"RU",iana:["Asia/Tomsk"]},{windowsName:"China Standard Time",territory:"001",iana:["Asia/Shanghai"]},{windowsName:"China Standard Time",territory:"CN",iana:["Asia/Shanghai"]},{windowsName:"China Standard Time",territory:"HK",iana:["Asia/Hong_Kong"]},{windowsName:"China Standard Time",territory:"MO",iana:["Asia/Macau"]},{windowsName:"North Asia East Standard Time",territory:"001",iana:["Asia/Irkutsk"]},{windowsName:"North Asia East Standard Time",territory:"RU",iana:["Asia/Irkutsk"]},{windowsName:"Singapore Standard Time",territory:"001",iana:["Asia/Singapore"]},{windowsName:"Singapore Standard Time",territory:"BN",iana:["Asia/Brunei"]},{windowsName:"Singapore Standard Time",territory:"ID",iana:["Asia/Makassar"]},{windowsName:"Singapore Standard Time",territory:"MY",iana:["Asia/Kuala_Lumpur","Asia/Kuching"]},{windowsName:"Singapore Standard Time",territory:"PH",iana:["Asia/Manila"]},{windowsName:"Singapore Standard Time",territory:"SG",iana:["Asia/Singapore"]},{windowsName:"Singapore Standard Time",territory:"ZZ",iana:["Etc/GMT-8"]},{windowsName:"W. Australia Standard Time",territory:"001",iana:["Australia/Perth"]},{windowsName:"W. Australia Standard Time",territory:"AU",iana:["Australia/Perth"]},{windowsName:"Taipei Standard Time",territory:"001",iana:["Asia/Taipei"]},{windowsName:"Taipei Standard Time",territory:"TW",iana:["Asia/Taipei"]},{windowsName:"Ulaanbaatar Standard Time",territory:"001",iana:["Asia/Ulaanbaatar"]},{windowsName:"Ulaanbaatar Standard Time",territory:"MN",iana:["Asia/Ulaanbaatar","Asia/Choibalsan"]},{windowsName:"Aus Central W. Standard Time",territory:"001",iana:["Australia/Eucla"]},{windowsName:"Aus Central W. Standard Time",territory:"AU",iana:["Australia/Eucla"]},{windowsName:"Transbaikal Standard Time",territory:"001",iana:["Asia/Chita"]},{windowsName:"Transbaikal Standard Time",territory:"RU",iana:["Asia/Chita"]},{windowsName:"Tokyo Standard Time",territory:"001",iana:["Asia/Tokyo"]},{windowsName:"Tokyo Standard Time",territory:"ID",iana:["Asia/Jayapura"]},{windowsName:"Tokyo Standard Time",territory:"JP",iana:["Asia/Tokyo"]},{windowsName:"Tokyo Standard Time",territory:"PW",iana:["Pacific/Palau"]},{windowsName:"Tokyo Standard Time",territory:"TL",iana:["Asia/Dili"]},{windowsName:"Tokyo Standard Time",territory:"ZZ",iana:["Etc/GMT-9"]},{windowsName:"North Korea Standard Time",territory:"001",iana:["Asia/Pyongyang"]},{windowsName:"North Korea Standard Time",territory:"KP",iana:["Asia/Pyongyang"]},{windowsName:"Korea Standard Time",territory:"001",iana:["Asia/Seoul"]},{windowsName:"Korea Standard Time",territory:"KR",iana:["Asia/Seoul"]},{windowsName:"Yakutsk Standard Time",territory:"001",iana:["Asia/Yakutsk"]},{windowsName:"Yakutsk Standard Time",territory:"RU",iana:["Asia/Yakutsk","Asia/Khandyga"]},{windowsName:"Cen. Australia Standard Time",territory:"001",iana:["Australia/Adelaide"]},{windowsName:"Cen. Australia Standard Time",territory:"AU",iana:["Australia/Adelaide","Australia/Broken_Hill"]},{windowsName:"AUS Central Standard Time",territory:"001",iana:["Australia/Darwin"]},{windowsName:"AUS Central Standard Time",territory:"AU",iana:["Australia/Darwin"]},{windowsName:"E. Australia Standard Time",territory:"001",iana:["Australia/Brisbane"]},{windowsName:"E. Australia Standard Time",territory:"AU",iana:["Australia/Brisbane","Australia/Lindeman"]},{windowsName:"AUS Eastern Standard Time",territory:"001",iana:["Australia/Sydney"]},{windowsName:"AUS Eastern Standard Time",territory:"AU",iana:["Australia/Sydney","Australia/Melbourne"]},{windowsName:"West Pacific Standard Time",territory:"001",iana:["Pacific/Port_Moresby"]},{windowsName:"West Pacific Standard Time",territory:"AQ",iana:["Antarctica/DumontDUrville"]},{windowsName:"West Pacific Standard Time",territory:"FM",iana:["Pacific/Truk"]},{windowsName:"West Pacific Standard Time",territory:"GU",iana:["Pacific/Guam"]},{windowsName:"West Pacific Standard Time",territory:"MP",iana:["Pacific/Saipan"]},{windowsName:"West Pacific Standard Time",territory:"PG",iana:["Pacific/Port_Moresby"]},{windowsName:"West Pacific Standard Time",territory:"ZZ",iana:["Etc/GMT-10"]},{windowsName:"Tasmania Standard Time",territory:"001",iana:["Australia/Hobart"]},{windowsName:"Tasmania Standard Time",territory:"AU",iana:["Australia/Hobart","Australia/Currie","Antarctica/Macquarie"]},{windowsName:"Vladivostok Standard Time",territory:"001",iana:["Asia/Vladivostok"]},{windowsName:"Vladivostok Standard Time",territory:"RU",iana:["Asia/Vladivostok","Asia/Ust-Nera"]},{windowsName:"Lord Howe Standard Time",territory:"001",iana:["Australia/Lord_Howe"]},{windowsName:"Lord Howe Standard Time",territory:"AU",iana:["Australia/Lord_Howe"]},{windowsName:"Bougainville Standard Time",territory:"001",iana:["Pacific/Bougainville"]},{windowsName:"Bougainville Standard Time",territory:"PG",iana:["Pacific/Bougainville"]},{windowsName:"Russia Time Zone 10",territory:"001",iana:["Asia/Srednekolymsk"]},{windowsName:"Russia Time Zone 10",territory:"RU",iana:["Asia/Srednekolymsk"]},{windowsName:"Magadan Standard Time",territory:"001",iana:["Asia/Magadan"]},{windowsName:"Magadan Standard Time",territory:"RU",iana:["Asia/Magadan"]},{windowsName:"Norfolk Standard Time",territory:"001",iana:["Pacific/Norfolk"]},{windowsName:"Norfolk Standard Time",territory:"NF",iana:["Pacific/Norfolk"]},{windowsName:"Sakhalin Standard Time",territory:"001",iana:["Asia/Sakhalin"]},{windowsName:"Sakhalin Standard Time",territory:"RU",iana:["Asia/Sakhalin"]},{windowsName:"Central Pacific Standard Time",territory:"001",iana:["Pacific/Guadalcanal"]},{windowsName:"Central Pacific Standard Time",territory:"AQ",iana:["Antarctica/Casey"]},{windowsName:"Central Pacific Standard Time",territory:"FM",iana:["Pacific/Ponape","Pacific/Kosrae"]},{windowsName:"Central Pacific Standard Time",territory:"NC",iana:["Pacific/Noumea"]},{windowsName:"Central Pacific Standard Time",territory:"SB",iana:["Pacific/Guadalcanal"]},{windowsName:"Central Pacific Standard Time",territory:"VU",iana:["Pacific/Efate"]},{windowsName:"Central Pacific Standard Time",territory:"ZZ",iana:["Etc/GMT-11"]},{windowsName:"Russia Time Zone 11",territory:"001",iana:["Asia/Kamchatka"]},{windowsName:"Russia Time Zone 11",territory:"RU",iana:["Asia/Kamchatka","Asia/Anadyr"]},{windowsName:"New Zealand Standard Time",territory:"001",iana:["Pacific/Auckland"]},{windowsName:"New Zealand Standard Time",territory:"AQ",iana:["Antarctica/McMurdo"]},{windowsName:"New Zealand Standard Time",territory:"NZ",iana:["Pacific/Auckland"]},{windowsName:"UTC+12",territory:"001",iana:["Etc/GMT-12"]},{windowsName:"UTC+12",territory:"KI",iana:["Pacific/Tarawa"]},{windowsName:"UTC+12",territory:"MH",iana:["Pacific/Majuro","Pacific/Kwajalein"]},{windowsName:"UTC+12",territory:"NR",iana:["Pacific/Nauru"]},{windowsName:"UTC+12",territory:"TV",iana:["Pacific/Funafuti"]},{windowsName:"UTC+12",territory:"UM",iana:["Pacific/Wake"]},{windowsName:"UTC+12",territory:"WF",iana:["Pacific/Wallis"]},{windowsName:"UTC+12",territory:"ZZ",iana:["Etc/GMT-12"]},{windowsName:"Fiji Standard Time",territory:"001",iana:["Pacific/Fiji"]},{windowsName:"Fiji Standard Time",territory:"FJ",iana:["Pacific/Fiji"]},{windowsName:"Chatham Islands Standard Time",territory:"001",iana:["Pacific/Chatham"]},{windowsName:"Chatham Islands Standard Time",territory:"NZ",iana:["Pacific/Chatham"]},{windowsName:"UTC+13",territory:"001",iana:["Etc/GMT-13"]},{windowsName:"UTC+13",territory:"KI",iana:["Pacific/Enderbury"]},{windowsName:"UTC+13",territory:"TK",iana:["Pacific/Fakaofo"]},{windowsName:"UTC+13",territory:"ZZ",iana:["Etc/GMT-13"]},{windowsName:"Tonga Standard Time",territory:"001",iana:["Pacific/Tongatapu"]},{windowsName:"Tonga Standard Time",territory:"TO",iana:["Pacific/Tongatapu"]},{windowsName:"Samoa Standard Time",territory:"001",iana:["Pacific/Apia"]},{windowsName:"Samoa Standard Time",territory:"WS",iana:["Pacific/Apia"]},{windowsName:"Line Islands Standard Time",territory:"001",iana:["Pacific/Kiritimati"]},{windowsName:"Line Islands Standard Time",territory:"KI",iana:["Pacific/Kiritimati"]},{windowsName:"Line Islands Standard Time",territory:"ZZ",iana:["Etc/GMT-14"]}];function r(i){var r=new Set;return a.filter((function(a){return a.alias.includes(i)})).map((function(a){return a.alias})).flat().forEach((function(a){r.add(a)})),Array.from(r)}exports.IANA_ALIAS_MAP=a,exports.WINDOWS_TO_IANA_MAP=i,exports.findIana=function(a,e){var n=new Set;return i.filter((function(i){return void 0===e?i.windowsName===a:i.windowsName===a&&i.territory===e})).map((function(a){return a.iana})).flat().map(r).flat().forEach((function(a){n.add(a)})),Array.from(n)},exports.findIanaAliases=r,exports.findWindows=function(a){var e=r(a),n=new Set;return i.filter((function(a){return a.iana.find((function(a){return e.includes(a)}))})).forEach((function(a){n.add(a.windowsName)})),Array.from(n)};
	//# sourceMappingURL=windows-iana.cjs.production.min.js.map


/***/ },
/* 1257 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1258 */
1257,
/* 1259 */
1257,
/* 1260 */
1257,
/* 1261 */
1257,
/* 1262 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
	  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
	  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
	  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
	  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
	  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
	  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
	  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
	  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
	  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
	  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // Internet Explorer and Edge do not support colors.
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_URL":"https://app.analystprep.dev","REACT_APP_BASEURL":"https://api.app.analystprep.dev/avatars/","REACT_APP_API_ENDPOINT":"https://api.app.analystprep.dev/api","REACT_APP_FRONTEND_ENDPOINT":"https://app.analystprep.dev","REACT_APP_S3_BASE_URL":"https://s3.amazonaws.com/app.analystprep.dev","REACT_APP_STRIPEKEY":"pk_test_GPG6XQjma3eXn5T4F7CFJFAs","REACT_APP_TUTOR_URL":"https://ai-tutor.analystprep.dev"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Active `debug` instances.
	 */
	exports.instances = [];
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  var prevTime;
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	  debug.destroy = destroy;
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  exports.instances.push(debug);
	
	  return debug;
	}
	
	function destroy () {
	  var index = exports.instances.indexOf(this);
	  if (index !== -1) {
	    exports.instances.splice(index, 1);
	    return true;
	  } else {
	    return false;
	  }
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var i;
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	
	  for (i = 0; i < exports.instances.length; i++) {
	    var instance = exports.instances[i];
	    instance.enabled = exports.enabled(instance.namespace);
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  if (name[name.length - 1] === '*') {
	    return true;
	  }
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(282);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.bbd29cc6.js